/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		53: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"babe0f14","1":"d671ecfb","2":"8ed5bb41","3":"29ab082b","4":"5a0947cc","5":"64d0fc6a","6":"5e6fd52e","7":"b49643a7","8":"b4b06ace","9":"35b24f0c","10":"b25b4485","11":"04bd97c3","12":"e3ed6d33","13":"8f5f8994","14":"8e24be34","15":"2722f733","16":"36f67160","17":"c8dbb2e3","18":"c9521a36","19":"b849d3ac","20":"eb5f3de4","21":"602b3fce","22":"ca4382e2","23":"3c8a2ae0","24":"4ad5da7e","25":"cdb5a82a","26":"0b7880f0","27":"31b5fe5c","28":"3bedfe05","29":"b2c286a0","30":"aa1442fc","31":"2f2a31bd","32":"9b0a3408","33":"638304c0","34":"3c917aa3","35":"a93bb428","36":"17c14c57","37":"7567c91d","38":"2c1ab295","39":"63352c92","40":"bba29e72","41":"70e7df08","42":"4c6155a3","43":"cbf5e2da","44":"918d4a6b","45":"4e43adde","46":"9f36b271","47":"4f7910e4","48":"12ac2332","49":"2d42bcfe","50":"074a8b7a","51":"16a6843b","52":"476246e2"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 296);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = isDisposable;
/* harmony export (immutable) */ __webpack_exports__["d"] = dispose;
/* harmony export (immutable) */ __webpack_exports__["c"] = combinedDisposable;
/* harmony export (immutable) */ __webpack_exports__["f"] = toDisposable;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Disposable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImmortalReference; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function isDisposable(thing) {
    return typeof thing.dispose === 'function'
        && thing.dispose.length === 0;
}
function dispose(first) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    if (Array.isArray(first)) {
        first.forEach(function (d) { return d && d.dispose(); });
        return [];
    }
    else if (rest.length === 0) {
        if (first) {
            first.dispose();
            return first;
        }
        return undefined;
    }
    else {
        dispose(first);
        dispose(rest);
        return [];
    }
}
function combinedDisposable(disposables) {
    return { dispose: function () { return dispose(disposables); } };
}
function toDisposable(fn) {
    return { dispose: function () { fn(); } };
}
var Disposable = /** @class */ (function () {
    function Disposable() {
        this._toDispose = [];
    }
    Object.defineProperty(Disposable.prototype, "toDispose", {
        get: function () { return this._toDispose; },
        enumerable: true,
        configurable: true
    });
    Disposable.prototype.dispose = function () {
        this._toDispose = dispose(this._toDispose);
    };
    Disposable.prototype._register = function (t) {
        this._toDispose.push(t);
        return t;
    };
    Disposable.None = Object.freeze({ dispose: function () { } });
    return Disposable;
}());

var ImmortalReference = /** @class */ (function () {
    function ImmortalReference(object) {
        this.object = object;
    }
    ImmortalReference.prototype.dispose = function () { };
    return ImmortalReference;
}());



/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Range; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


/**
 * A range in the editor. (startLineNumber,startColumn) is <= (endLineNumber,endColumn)
 */
var Range = /** @class */ (function () {
    function Range(startLineNumber, startColumn, endLineNumber, endColumn) {
        if ((startLineNumber > endLineNumber) || (startLineNumber === endLineNumber && startColumn > endColumn)) {
            this.startLineNumber = endLineNumber;
            this.startColumn = endColumn;
            this.endLineNumber = startLineNumber;
            this.endColumn = startColumn;
        }
        else {
            this.startLineNumber = startLineNumber;
            this.startColumn = startColumn;
            this.endLineNumber = endLineNumber;
            this.endColumn = endColumn;
        }
    }
    /**
     * Test if this range is empty.
     */
    Range.prototype.isEmpty = function () {
        return Range.isEmpty(this);
    };
    /**
     * Test if `range` is empty.
     */
    Range.isEmpty = function (range) {
        return (range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn);
    };
    /**
     * Test if position is in this range. If the position is at the edges, will return true.
     */
    Range.prototype.containsPosition = function (position) {
        return Range.containsPosition(this, position);
    };
    /**
     * Test if `position` is in `range`. If the position is at the edges, will return true.
     */
    Range.containsPosition = function (range, position) {
        if (position.lineNumber < range.startLineNumber || position.lineNumber > range.endLineNumber) {
            return false;
        }
        if (position.lineNumber === range.startLineNumber && position.column < range.startColumn) {
            return false;
        }
        if (position.lineNumber === range.endLineNumber && position.column > range.endColumn) {
            return false;
        }
        return true;
    };
    /**
     * Test if range is in this range. If the range is equal to this range, will return true.
     */
    Range.prototype.containsRange = function (range) {
        return Range.containsRange(this, range);
    };
    /**
     * Test if `otherRange` is in `range`. If the ranges are equal, will return true.
     */
    Range.containsRange = function (range, otherRange) {
        if (otherRange.startLineNumber < range.startLineNumber || otherRange.endLineNumber < range.startLineNumber) {
            return false;
        }
        if (otherRange.startLineNumber > range.endLineNumber || otherRange.endLineNumber > range.endLineNumber) {
            return false;
        }
        if (otherRange.startLineNumber === range.startLineNumber && otherRange.startColumn < range.startColumn) {
            return false;
        }
        if (otherRange.endLineNumber === range.endLineNumber && otherRange.endColumn > range.endColumn) {
            return false;
        }
        return true;
    };
    /**
     * A reunion of the two ranges.
     * The smallest position will be used as the start point, and the largest one as the end point.
     */
    Range.prototype.plusRange = function (range) {
        return Range.plusRange(this, range);
    };
    /**
     * A reunion of the two ranges.
     * The smallest position will be used as the start point, and the largest one as the end point.
     */
    Range.plusRange = function (a, b) {
        var startLineNumber;
        var startColumn;
        var endLineNumber;
        var endColumn;
        if (b.startLineNumber < a.startLineNumber) {
            startLineNumber = b.startLineNumber;
            startColumn = b.startColumn;
        }
        else if (b.startLineNumber === a.startLineNumber) {
            startLineNumber = b.startLineNumber;
            startColumn = Math.min(b.startColumn, a.startColumn);
        }
        else {
            startLineNumber = a.startLineNumber;
            startColumn = a.startColumn;
        }
        if (b.endLineNumber > a.endLineNumber) {
            endLineNumber = b.endLineNumber;
            endColumn = b.endColumn;
        }
        else if (b.endLineNumber === a.endLineNumber) {
            endLineNumber = b.endLineNumber;
            endColumn = Math.max(b.endColumn, a.endColumn);
        }
        else {
            endLineNumber = a.endLineNumber;
            endColumn = a.endColumn;
        }
        return new Range(startLineNumber, startColumn, endLineNumber, endColumn);
    };
    /**
     * A intersection of the two ranges.
     */
    Range.prototype.intersectRanges = function (range) {
        return Range.intersectRanges(this, range);
    };
    /**
     * A intersection of the two ranges.
     */
    Range.intersectRanges = function (a, b) {
        var resultStartLineNumber = a.startLineNumber;
        var resultStartColumn = a.startColumn;
        var resultEndLineNumber = a.endLineNumber;
        var resultEndColumn = a.endColumn;
        var otherStartLineNumber = b.startLineNumber;
        var otherStartColumn = b.startColumn;
        var otherEndLineNumber = b.endLineNumber;
        var otherEndColumn = b.endColumn;
        if (resultStartLineNumber < otherStartLineNumber) {
            resultStartLineNumber = otherStartLineNumber;
            resultStartColumn = otherStartColumn;
        }
        else if (resultStartLineNumber === otherStartLineNumber) {
            resultStartColumn = Math.max(resultStartColumn, otherStartColumn);
        }
        if (resultEndLineNumber > otherEndLineNumber) {
            resultEndLineNumber = otherEndLineNumber;
            resultEndColumn = otherEndColumn;
        }
        else if (resultEndLineNumber === otherEndLineNumber) {
            resultEndColumn = Math.min(resultEndColumn, otherEndColumn);
        }
        // Check if selection is now empty
        if (resultStartLineNumber > resultEndLineNumber) {
            return null;
        }
        if (resultStartLineNumber === resultEndLineNumber && resultStartColumn > resultEndColumn) {
            return null;
        }
        return new Range(resultStartLineNumber, resultStartColumn, resultEndLineNumber, resultEndColumn);
    };
    /**
     * Test if this range equals other.
     */
    Range.prototype.equalsRange = function (other) {
        return Range.equalsRange(this, other);
    };
    /**
     * Test if range `a` equals `b`.
     */
    Range.equalsRange = function (a, b) {
        return (!!a &&
            !!b &&
            a.startLineNumber === b.startLineNumber &&
            a.startColumn === b.startColumn &&
            a.endLineNumber === b.endLineNumber &&
            a.endColumn === b.endColumn);
    };
    /**
     * Return the end position (which will be after or equal to the start position)
     */
    Range.prototype.getEndPosition = function () {
        return new __WEBPACK_IMPORTED_MODULE_0__position_js__["a" /* Position */](this.endLineNumber, this.endColumn);
    };
    /**
     * Return the start position (which will be before or equal to the end position)
     */
    Range.prototype.getStartPosition = function () {
        return new __WEBPACK_IMPORTED_MODULE_0__position_js__["a" /* Position */](this.startLineNumber, this.startColumn);
    };
    /**
     * Transform to a user presentable string representation.
     */
    Range.prototype.toString = function () {
        return '[' + this.startLineNumber + ',' + this.startColumn + ' -> ' + this.endLineNumber + ',' + this.endColumn + ']';
    };
    /**
     * Create a new range using this range's start position, and using endLineNumber and endColumn as the end position.
     */
    Range.prototype.setEndPosition = function (endLineNumber, endColumn) {
        return new Range(this.startLineNumber, this.startColumn, endLineNumber, endColumn);
    };
    /**
     * Create a new range using this range's end position, and using startLineNumber and startColumn as the start position.
     */
    Range.prototype.setStartPosition = function (startLineNumber, startColumn) {
        return new Range(startLineNumber, startColumn, this.endLineNumber, this.endColumn);
    };
    /**
     * Create a new empty range using this range's start position.
     */
    Range.prototype.collapseToStart = function () {
        return Range.collapseToStart(this);
    };
    /**
     * Create a new empty range using this range's start position.
     */
    Range.collapseToStart = function (range) {
        return new Range(range.startLineNumber, range.startColumn, range.startLineNumber, range.startColumn);
    };
    // ---
    Range.fromPositions = function (start, end) {
        if (end === void 0) { end = start; }
        return new Range(start.lineNumber, start.column, end.lineNumber, end.column);
    };
    /**
     * Create a `Range` from an `IRange`.
     */
    Range.lift = function (range) {
        if (!range) {
            return null;
        }
        return new Range(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
    };
    /**
     * Test if `obj` is an `IRange`.
     */
    Range.isIRange = function (obj) {
        return (obj
            && (typeof obj.startLineNumber === 'number')
            && (typeof obj.startColumn === 'number')
            && (typeof obj.endLineNumber === 'number')
            && (typeof obj.endColumn === 'number'));
    };
    /**
     * Test if the two ranges are touching in any way.
     */
    Range.areIntersectingOrTouching = function (a, b) {
        // Check if `a` is before `b`
        if (a.endLineNumber < b.startLineNumber || (a.endLineNumber === b.startLineNumber && a.endColumn < b.startColumn)) {
            return false;
        }
        // Check if `b` is before `a`
        if (b.endLineNumber < a.startLineNumber || (b.endLineNumber === a.startLineNumber && b.endColumn < a.startColumn)) {
            return false;
        }
        // These ranges must intersect
        return true;
    };
    /**
     * Test if the two ranges are intersecting. If the ranges are touching it returns true.
     */
    Range.areIntersecting = function (a, b) {
        // Check if `a` is before `b`
        if (a.endLineNumber < b.startLineNumber || (a.endLineNumber === b.startLineNumber && a.endColumn <= b.startColumn)) {
            return false;
        }
        // Check if `b` is before `a`
        if (b.endLineNumber < a.startLineNumber || (b.endLineNumber === a.startLineNumber && b.endColumn <= a.startColumn)) {
            return false;
        }
        // These ranges must intersect
        return true;
    };
    /**
     * A function that compares ranges, useful for sorting ranges
     * It will first compare ranges on the startPosition and then on the endPosition
     */
    Range.compareRangesUsingStarts = function (a, b) {
        var aStartLineNumber = a.startLineNumber | 0;
        var bStartLineNumber = b.startLineNumber | 0;
        if (aStartLineNumber === bStartLineNumber) {
            var aStartColumn = a.startColumn | 0;
            var bStartColumn = b.startColumn | 0;
            if (aStartColumn === bStartColumn) {
                var aEndLineNumber = a.endLineNumber | 0;
                var bEndLineNumber = b.endLineNumber | 0;
                if (aEndLineNumber === bEndLineNumber) {
                    var aEndColumn = a.endColumn | 0;
                    var bEndColumn = b.endColumn | 0;
                    return aEndColumn - bEndColumn;
                }
                return aEndLineNumber - bEndLineNumber;
            }
            return aStartColumn - bStartColumn;
        }
        return aStartLineNumber - bStartLineNumber;
    };
    /**
     * A function that compares ranges, useful for sorting ranges
     * It will first compare ranges on the endPosition and then on the startPosition
     */
    Range.compareRangesUsingEnds = function (a, b) {
        if (a.endLineNumber === b.endLineNumber) {
            if (a.endColumn === b.endColumn) {
                if (a.startLineNumber === b.startLineNumber) {
                    return a.startColumn - b.startColumn;
                }
                return a.startLineNumber - b.startLineNumber;
            }
            return a.endColumn - b.endColumn;
        }
        return a.endLineNumber - b.endLineNumber;
    };
    /**
     * Test if the range spans multiple lines.
     */
    Range.spansMultipleLines = function (range) {
        return range.endLineNumber > range.startLineNumber;
    };
    return Range;
}());



/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = localize;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
function _format(message, args) {
    var result;
    if (args.length === 0) {
        result = message;
    }
    else {
        result = message.replace(/\{(\d+)\}/g, function (match, rest) {
            var index = rest[0];
            return typeof args[index] !== 'undefined' ? args[index] : match;
        });
    }
    return result;
}
function localize(data, message) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return _format(message, args);
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony export (immutable) */ __webpack_exports__["isFalsyOrWhitespace"] = isFalsyOrWhitespace;
/* harmony export (immutable) */ __webpack_exports__["pad"] = pad;
/* harmony export (immutable) */ __webpack_exports__["format"] = format;
/* harmony export (immutable) */ __webpack_exports__["escape"] = escape;
/* harmony export (immutable) */ __webpack_exports__["escapeRegExpCharacters"] = escapeRegExpCharacters;
/* harmony export (immutable) */ __webpack_exports__["trim"] = trim;
/* harmony export (immutable) */ __webpack_exports__["ltrim"] = ltrim;
/* harmony export (immutable) */ __webpack_exports__["rtrim"] = rtrim;
/* harmony export (immutable) */ __webpack_exports__["convertSimple2RegExpPattern"] = convertSimple2RegExpPattern;
/* harmony export (immutable) */ __webpack_exports__["startsWith"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["endsWith"] = endsWith;
/* harmony export (immutable) */ __webpack_exports__["createRegExp"] = createRegExp;
/* harmony export (immutable) */ __webpack_exports__["regExpLeadsToEndlessLoop"] = regExpLeadsToEndlessLoop;
/* harmony export (immutable) */ __webpack_exports__["firstNonWhitespaceIndex"] = firstNonWhitespaceIndex;
/* harmony export (immutable) */ __webpack_exports__["getLeadingWhitespace"] = getLeadingWhitespace;
/* harmony export (immutable) */ __webpack_exports__["lastNonWhitespaceIndex"] = lastNonWhitespaceIndex;
/* harmony export (immutable) */ __webpack_exports__["compare"] = compare;
/* harmony export (immutable) */ __webpack_exports__["compareIgnoreCase"] = compareIgnoreCase;
/* harmony export (immutable) */ __webpack_exports__["isLowerAsciiLetter"] = isLowerAsciiLetter;
/* harmony export (immutable) */ __webpack_exports__["isUpperAsciiLetter"] = isUpperAsciiLetter;
/* harmony export (immutable) */ __webpack_exports__["equalsIgnoreCase"] = equalsIgnoreCase;
/* harmony export (immutable) */ __webpack_exports__["startsWithIgnoreCase"] = startsWithIgnoreCase;
/* harmony export (immutable) */ __webpack_exports__["commonPrefixLength"] = commonPrefixLength;
/* harmony export (immutable) */ __webpack_exports__["commonSuffixLength"] = commonSuffixLength;
/* harmony export (immutable) */ __webpack_exports__["isHighSurrogate"] = isHighSurrogate;
/* harmony export (immutable) */ __webpack_exports__["isLowSurrogate"] = isLowSurrogate;
/* harmony export (immutable) */ __webpack_exports__["containsRTL"] = containsRTL;
/* harmony export (immutable) */ __webpack_exports__["containsEmoji"] = containsEmoji;
/* harmony export (immutable) */ __webpack_exports__["isBasicASCII"] = isBasicASCII;
/* harmony export (immutable) */ __webpack_exports__["containsFullWidthCharacter"] = containsFullWidthCharacter;
/* harmony export (immutable) */ __webpack_exports__["isFullWidthCharacter"] = isFullWidthCharacter;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UTF8_BOM_CHARACTER", function() { return UTF8_BOM_CHARACTER; });
/* harmony export (immutable) */ __webpack_exports__["startsWithUTF8BOM"] = startsWithUTF8BOM;
/* harmony export (immutable) */ __webpack_exports__["safeBtoa"] = safeBtoa;
/* harmony export (immutable) */ __webpack_exports__["repeat"] = repeat;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * The empty string.
 */
var empty = '';
function isFalsyOrWhitespace(str) {
    if (!str || typeof str !== 'string') {
        return true;
    }
    return str.trim().length === 0;
}
/**
 * @returns the provided number with the given number of preceding zeros.
 */
function pad(n, l, char) {
    if (char === void 0) { char = '0'; }
    var str = '' + n;
    var r = [str];
    for (var i = str.length; i < l; i++) {
        r.push(char);
    }
    return r.reverse().join('');
}
var _formatRegexp = /{(\d+)}/g;
/**
 * Helper to produce a string with a variable number of arguments. Insert variable segments
 * into the string using the {n} notation where N is the index of the argument following the string.
 * @param value string to which formatting is applied
 * @param args replacements for {n}-entries
 */
function format(value) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (args.length === 0) {
        return value;
    }
    return value.replace(_formatRegexp, function (match, group) {
        var idx = parseInt(group, 10);
        return isNaN(idx) || idx < 0 || idx >= args.length ?
            match :
            args[idx];
    });
}
/**
 * Converts HTML characters inside the string to use entities instead. Makes the string safe from
 * being used e.g. in HTMLElement.innerHTML.
 */
function escape(html) {
    return html.replace(/[<|>|&]/g, function (match) {
        switch (match) {
            case '<': return '&lt;';
            case '>': return '&gt;';
            case '&': return '&amp;';
            default: return match;
        }
    });
}
/**
 * Escapes regular expression characters in a given string
 */
function escapeRegExpCharacters(value) {
    return value.replace(/[\-\\\{\}\*\+\?\|\^\$\.\[\]\(\)\#]/g, '\\$&');
}
/**
 * Removes all occurrences of needle from the beginning and end of haystack.
 * @param haystack string to trim
 * @param needle the thing to trim (default is a blank)
 */
function trim(haystack, needle) {
    if (needle === void 0) { needle = ' '; }
    var trimmed = ltrim(haystack, needle);
    return rtrim(trimmed, needle);
}
/**
 * Removes all occurrences of needle from the beginning of haystack.
 * @param haystack string to trim
 * @param needle the thing to trim
 */
function ltrim(haystack, needle) {
    if (!haystack || !needle) {
        return haystack;
    }
    var needleLen = needle.length;
    if (needleLen === 0 || haystack.length === 0) {
        return haystack;
    }
    var offset = 0, idx = -1;
    while ((idx = haystack.indexOf(needle, offset)) === offset) {
        offset = offset + needleLen;
    }
    return haystack.substring(offset);
}
/**
 * Removes all occurrences of needle from the end of haystack.
 * @param haystack string to trim
 * @param needle the thing to trim
 */
function rtrim(haystack, needle) {
    if (!haystack || !needle) {
        return haystack;
    }
    var needleLen = needle.length, haystackLen = haystack.length;
    if (needleLen === 0 || haystackLen === 0) {
        return haystack;
    }
    var offset = haystackLen, idx = -1;
    while (true) {
        idx = haystack.lastIndexOf(needle, offset - 1);
        if (idx === -1 || idx + needleLen !== offset) {
            break;
        }
        if (idx === 0) {
            return '';
        }
        offset = idx;
    }
    return haystack.substring(0, offset);
}
function convertSimple2RegExpPattern(pattern) {
    return pattern.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, '\\$&').replace(/[\*]/g, '.*');
}
/**
 * Determines if haystack starts with needle.
 */
function startsWith(haystack, needle) {
    if (haystack.length < needle.length) {
        return false;
    }
    if (haystack === needle) {
        return true;
    }
    for (var i = 0; i < needle.length; i++) {
        if (haystack[i] !== needle[i]) {
            return false;
        }
    }
    return true;
}
/**
 * Determines if haystack ends with needle.
 */
function endsWith(haystack, needle) {
    var diff = haystack.length - needle.length;
    if (diff > 0) {
        return haystack.indexOf(needle, diff) === diff;
    }
    else if (diff === 0) {
        return haystack === needle;
    }
    else {
        return false;
    }
}
function createRegExp(searchString, isRegex, options) {
    if (options === void 0) { options = {}; }
    if (!searchString) {
        throw new Error('Cannot create regex from empty string');
    }
    if (!isRegex) {
        searchString = escapeRegExpCharacters(searchString);
    }
    if (options.wholeWord) {
        if (!/\B/.test(searchString.charAt(0))) {
            searchString = '\\b' + searchString;
        }
        if (!/\B/.test(searchString.charAt(searchString.length - 1))) {
            searchString = searchString + '\\b';
        }
    }
    var modifiers = '';
    if (options.global) {
        modifiers += 'g';
    }
    if (!options.matchCase) {
        modifiers += 'i';
    }
    if (options.multiline) {
        modifiers += 'm';
    }
    return new RegExp(searchString, modifiers);
}
function regExpLeadsToEndlessLoop(regexp) {
    // Exit early if it's one of these special cases which are meant to match
    // against an empty string
    if (regexp.source === '^' || regexp.source === '^$' || regexp.source === '$' || regexp.source === '^\\s*$') {
        return false;
    }
    // We check against an empty string. If the regular expression doesn't advance
    // (e.g. ends in an endless loop) it will match an empty string.
    var match = regexp.exec('');
    return (match && regexp.lastIndex === 0);
}
/**
 * Returns first index of the string that is not whitespace.
 * If string is empty or contains only whitespaces, returns -1
 */
function firstNonWhitespaceIndex(str) {
    for (var i = 0, len = str.length; i < len; i++) {
        var chCode = str.charCodeAt(i);
        if (chCode !== 32 /* Space */ && chCode !== 9 /* Tab */) {
            return i;
        }
    }
    return -1;
}
/**
 * Returns the leading whitespace of the string.
 * If the string contains only whitespaces, returns entire string
 */
function getLeadingWhitespace(str, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = str.length; }
    for (var i = start; i < end; i++) {
        var chCode = str.charCodeAt(i);
        if (chCode !== 32 /* Space */ && chCode !== 9 /* Tab */) {
            return str.substring(start, i);
        }
    }
    return str.substring(start, end);
}
/**
 * Returns last index of the string that is not whitespace.
 * If string is empty or contains only whitespaces, returns -1
 */
function lastNonWhitespaceIndex(str, startIndex) {
    if (startIndex === void 0) { startIndex = str.length - 1; }
    for (var i = startIndex; i >= 0; i--) {
        var chCode = str.charCodeAt(i);
        if (chCode !== 32 /* Space */ && chCode !== 9 /* Tab */) {
            return i;
        }
    }
    return -1;
}
function compare(a, b) {
    if (a < b) {
        return -1;
    }
    else if (a > b) {
        return 1;
    }
    else {
        return 0;
    }
}
function compareIgnoreCase(a, b) {
    var len = Math.min(a.length, b.length);
    for (var i = 0; i < len; i++) {
        var codeA = a.charCodeAt(i);
        var codeB = b.charCodeAt(i);
        if (codeA === codeB) {
            // equal
            continue;
        }
        if (isUpperAsciiLetter(codeA)) {
            codeA += 32;
        }
        if (isUpperAsciiLetter(codeB)) {
            codeB += 32;
        }
        var diff = codeA - codeB;
        if (diff === 0) {
            // equal -> ignoreCase
            continue;
        }
        else if (isLowerAsciiLetter(codeA) && isLowerAsciiLetter(codeB)) {
            //
            return diff;
        }
        else {
            return compare(a.toLowerCase(), b.toLowerCase());
        }
    }
    if (a.length < b.length) {
        return -1;
    }
    else if (a.length > b.length) {
        return 1;
    }
    else {
        return 0;
    }
}
function isLowerAsciiLetter(code) {
    return code >= 97 /* a */ && code <= 122 /* z */;
}
function isUpperAsciiLetter(code) {
    return code >= 65 /* A */ && code <= 90 /* Z */;
}
function isAsciiLetter(code) {
    return isLowerAsciiLetter(code) || isUpperAsciiLetter(code);
}
function equalsIgnoreCase(a, b) {
    var len1 = a ? a.length : 0;
    var len2 = b ? b.length : 0;
    if (len1 !== len2) {
        return false;
    }
    return doEqualsIgnoreCase(a, b);
}
function doEqualsIgnoreCase(a, b, stopAt) {
    if (stopAt === void 0) { stopAt = a.length; }
    if (typeof a !== 'string' || typeof b !== 'string') {
        return false;
    }
    for (var i = 0; i < stopAt; i++) {
        var codeA = a.charCodeAt(i);
        var codeB = b.charCodeAt(i);
        if (codeA === codeB) {
            continue;
        }
        // a-z A-Z
        if (isAsciiLetter(codeA) && isAsciiLetter(codeB)) {
            var diff = Math.abs(codeA - codeB);
            if (diff !== 0 && diff !== 32) {
                return false;
            }
        }
        // Any other charcode
        else {
            if (String.fromCharCode(codeA).toLowerCase() !== String.fromCharCode(codeB).toLowerCase()) {
                return false;
            }
        }
    }
    return true;
}
function startsWithIgnoreCase(str, candidate) {
    var candidateLength = candidate.length;
    if (candidate.length > str.length) {
        return false;
    }
    return doEqualsIgnoreCase(str, candidate, candidateLength);
}
/**
 * @returns the length of the common prefix of the two strings.
 */
function commonPrefixLength(a, b) {
    var i, len = Math.min(a.length, b.length);
    for (i = 0; i < len; i++) {
        if (a.charCodeAt(i) !== b.charCodeAt(i)) {
            return i;
        }
    }
    return len;
}
/**
 * @returns the length of the common suffix of the two strings.
 */
function commonSuffixLength(a, b) {
    var i, len = Math.min(a.length, b.length);
    var aLastIndex = a.length - 1;
    var bLastIndex = b.length - 1;
    for (i = 0; i < len; i++) {
        if (a.charCodeAt(aLastIndex - i) !== b.charCodeAt(bLastIndex - i)) {
            return i;
        }
    }
    return len;
}
// --- unicode
// http://en.wikipedia.org/wiki/Surrogate_pair
// Returns the code point starting at a specified index in a string
// Code points U+0000 to U+D7FF and U+E000 to U+FFFF are represented on a single character
// Code points U+10000 to U+10FFFF are represented on two consecutive characters
//export function getUnicodePoint(str:string, index:number, len:number):number {
//	let chrCode = str.charCodeAt(index);
//	if (0xD800 <= chrCode && chrCode <= 0xDBFF && index + 1 < len) {
//		let nextChrCode = str.charCodeAt(index + 1);
//		if (0xDC00 <= nextChrCode && nextChrCode <= 0xDFFF) {
//			return (chrCode - 0xD800) << 10 + (nextChrCode - 0xDC00) + 0x10000;
//		}
//	}
//	return chrCode;
//}
function isHighSurrogate(charCode) {
    return (0xD800 <= charCode && charCode <= 0xDBFF);
}
function isLowSurrogate(charCode) {
    return (0xDC00 <= charCode && charCode <= 0xDFFF);
}
/**
 * Generated using https://github.com/alexandrudima/unicode-utils/blob/master/generate-rtl-test.js
 */
var CONTAINS_RTL = /(?:[\u05BE\u05C0\u05C3\u05C6\u05D0-\u05F4\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u0710\u0712-\u072F\u074D-\u07A5\u07B1-\u07EA\u07F4\u07F5\u07FA-\u0815\u081A\u0824\u0828\u0830-\u0858\u085E-\u08BD\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFD3D\uFD50-\uFDFC\uFE70-\uFEFC]|\uD802[\uDC00-\uDD1B\uDD20-\uDE00\uDE10-\uDE33\uDE40-\uDEE4\uDEEB-\uDF35\uDF40-\uDFFF]|\uD803[\uDC00-\uDCFF]|\uD83A[\uDC00-\uDCCF\uDD00-\uDD43\uDD50-\uDFFF]|\uD83B[\uDC00-\uDEBB])/;
/**
 * Returns true if `str` contains any Unicode character that is classified as "R" or "AL".
 */
function containsRTL(str) {
    return CONTAINS_RTL.test(str);
}
/**
 * Generated using https://github.com/alexandrudima/unicode-utils/blob/master/generate-emoji-test.js
 */
var CONTAINS_EMOJI = /(?:[\u231A\u231B\u23F0\u23F3\u2600-\u27BF\u2B50\u2B55]|\uD83C[\uDDE6-\uDDFF\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEF8]|\uD83E[\uDD00-\uDDE6])/;
function containsEmoji(str) {
    return CONTAINS_EMOJI.test(str);
}
var IS_BASIC_ASCII = /^[\t\n\r\x20-\x7E]*$/;
/**
 * Returns true if `str` contains only basic ASCII characters in the range 32 - 126 (including 32 and 126) or \n, \r, \t
 */
function isBasicASCII(str) {
    return IS_BASIC_ASCII.test(str);
}
function containsFullWidthCharacter(str) {
    for (var i = 0, len = str.length; i < len; i++) {
        if (isFullWidthCharacter(str.charCodeAt(i))) {
            return true;
        }
    }
    return false;
}
function isFullWidthCharacter(charCode) {
    // Do a cheap trick to better support wrapping of wide characters, treat them as 2 columns
    // http://jrgraphix.net/research/unicode_blocks.php
    //          2E80 — 2EFF   CJK Radicals Supplement
    //          2F00 — 2FDF   Kangxi Radicals
    //          2FF0 — 2FFF   Ideographic Description Characters
    //          3000 — 303F   CJK Symbols and Punctuation
    //          3040 — 309F   Hiragana
    //          30A0 — 30FF   Katakana
    //          3100 — 312F   Bopomofo
    //          3130 — 318F   Hangul Compatibility Jamo
    //          3190 — 319F   Kanbun
    //          31A0 — 31BF   Bopomofo Extended
    //          31F0 — 31FF   Katakana Phonetic Extensions
    //          3200 — 32FF   Enclosed CJK Letters and Months
    //          3300 — 33FF   CJK Compatibility
    //          3400 — 4DBF   CJK Unified Ideographs Extension A
    //          4DC0 — 4DFF   Yijing Hexagram Symbols
    //          4E00 — 9FFF   CJK Unified Ideographs
    //          A000 — A48F   Yi Syllables
    //          A490 — A4CF   Yi Radicals
    //          AC00 — D7AF   Hangul Syllables
    // [IGNORE] D800 — DB7F   High Surrogates
    // [IGNORE] DB80 — DBFF   High Private Use Surrogates
    // [IGNORE] DC00 — DFFF   Low Surrogates
    // [IGNORE] E000 — F8FF   Private Use Area
    //          F900 — FAFF   CJK Compatibility Ideographs
    // [IGNORE] FB00 — FB4F   Alphabetic Presentation Forms
    // [IGNORE] FB50 — FDFF   Arabic Presentation Forms-A
    // [IGNORE] FE00 — FE0F   Variation Selectors
    // [IGNORE] FE20 — FE2F   Combining Half Marks
    // [IGNORE] FE30 — FE4F   CJK Compatibility Forms
    // [IGNORE] FE50 — FE6F   Small Form Variants
    // [IGNORE] FE70 — FEFF   Arabic Presentation Forms-B
    //          FF00 — FFEF   Halfwidth and Fullwidth Forms
    //               [https://en.wikipedia.org/wiki/Halfwidth_and_fullwidth_forms]
    //               of which FF01 - FF5E fullwidth ASCII of 21 to 7E
    // [IGNORE]    and FF65 - FFDC halfwidth of Katakana and Hangul
    // [IGNORE] FFF0 — FFFF   Specials
    charCode = +charCode; // @perf
    return ((charCode >= 0x2E80 && charCode <= 0xD7AF)
        || (charCode >= 0xF900 && charCode <= 0xFAFF)
        || (charCode >= 0xFF01 && charCode <= 0xFF5E));
}
// -- UTF-8 BOM
var UTF8_BOM_CHARACTER = String.fromCharCode(65279 /* UTF8_BOM */);
function startsWithUTF8BOM(str) {
    return (str && str.length > 0 && str.charCodeAt(0) === 65279 /* UTF8_BOM */);
}
function safeBtoa(str) {
    return btoa(encodeURIComponent(str)); // we use encodeURIComponent because btoa fails for non Latin 1 values
}
function repeat(s, count) {
    var result = '';
    for (var i = 0; i < count; i++) {
        result += s;
    }
    return result;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = clearNode;
/* harmony export (immutable) */ __webpack_exports__["D"] = isInDOM;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return toggleClass; });
/* harmony export (immutable) */ __webpack_exports__["g"] = addDisposableListener;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addStandardDisposableListener; });
/* harmony export (immutable) */ __webpack_exports__["h"] = addDisposableNonBubblingMouseOutListener;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return runAtThisOrScheduleAtNextAnimationFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return scheduleAtNextAnimationFrame; });
/* harmony export (immutable) */ __webpack_exports__["i"] = addDisposableThrottledListener;
/* harmony export (immutable) */ __webpack_exports__["r"] = getComputedStyle;
/* harmony export (immutable) */ __webpack_exports__["q"] = getClientArea;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Dimension; });
/* harmony export (immutable) */ __webpack_exports__["w"] = getTopLeftOffset;
/* harmony export (immutable) */ __webpack_exports__["u"] = getDomNodePagePosition;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StandardWindow; });
/* harmony export (immutable) */ __webpack_exports__["y"] = getTotalWidth;
/* harmony export (immutable) */ __webpack_exports__["t"] = getContentWidth;
/* harmony export (immutable) */ __webpack_exports__["s"] = getContentHeight;
/* harmony export (immutable) */ __webpack_exports__["x"] = getTotalHeight;
/* harmony export (immutable) */ __webpack_exports__["B"] = isAncestor;
/* harmony export (immutable) */ __webpack_exports__["p"] = findParentWithClass;
/* harmony export (immutable) */ __webpack_exports__["o"] = createStyleSheet;
/* harmony export (immutable) */ __webpack_exports__["n"] = createCSSRule;
/* harmony export (immutable) */ __webpack_exports__["F"] = removeCSSRulesContainingSelector;
/* harmony export (immutable) */ __webpack_exports__["C"] = isHTMLElement;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EventHelper; });
/* harmony export (immutable) */ __webpack_exports__["K"] = saveParentsScrollTop;
/* harmony export (immutable) */ __webpack_exports__["I"] = restoreParentsScrollTop;
/* harmony export (immutable) */ __webpack_exports__["O"] = trackFocus;
/* harmony export (immutable) */ __webpack_exports__["k"] = append;
/* harmony export (immutable) */ __webpack_exports__["E"] = prepend;
/* harmony export (immutable) */ __webpack_exports__["a"] = $;
/* harmony export (immutable) */ __webpack_exports__["M"] = show;
/* harmony export (immutable) */ __webpack_exports__["A"] = hide;
/* harmony export (immutable) */ __webpack_exports__["H"] = removeTabIndexAndUpdateFocus;
/* harmony export (immutable) */ __webpack_exports__["v"] = getElementsByTagName;
/* harmony export (immutable) */ __webpack_exports__["m"] = computeScreenAwareSize;
/* harmony export (immutable) */ __webpack_exports__["P"] = windowOpenNoOpener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_js__ = __webpack_require__(78);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









function clearNode(node) {
    while (node.firstChild) {
        node.removeChild(node.firstChild);
    }
}
function isInDOM(node) {
    while (node) {
        if (node === document.body) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}
var _manualClassList = new /** @class */ (function () {
    function class_1() {
    }
    class_1.prototype._findClassName = function (node, className) {
        var classes = node.className;
        if (!classes) {
            this._lastStart = -1;
            return;
        }
        className = className.trim();
        var classesLen = classes.length, classLen = className.length;
        if (classLen === 0) {
            this._lastStart = -1;
            return;
        }
        if (classesLen < classLen) {
            this._lastStart = -1;
            return;
        }
        if (classes === className) {
            this._lastStart = 0;
            this._lastEnd = classesLen;
            return;
        }
        var idx = -1, idxEnd;
        while ((idx = classes.indexOf(className, idx + 1)) >= 0) {
            idxEnd = idx + classLen;
            // a class that is followed by another class
            if ((idx === 0 || classes.charCodeAt(idx - 1) === 32 /* Space */) && classes.charCodeAt(idxEnd) === 32 /* Space */) {
                this._lastStart = idx;
                this._lastEnd = idxEnd + 1;
                return;
            }
            // last class
            if (idx > 0 && classes.charCodeAt(idx - 1) === 32 /* Space */ && idxEnd === classesLen) {
                this._lastStart = idx - 1;
                this._lastEnd = idxEnd;
                return;
            }
            // equal - duplicate of cmp above
            if (idx === 0 && idxEnd === classesLen) {
                this._lastStart = 0;
                this._lastEnd = idxEnd;
                return;
            }
        }
        this._lastStart = -1;
    };
    class_1.prototype.hasClass = function (node, className) {
        this._findClassName(node, className);
        return this._lastStart !== -1;
    };
    class_1.prototype.addClasses = function (node) {
        var _this = this;
        var classNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classNames[_i - 1] = arguments[_i];
        }
        classNames.forEach(function (nameValue) { return nameValue.split(' ').forEach(function (name) { return _this.addClass(node, name); }); });
    };
    class_1.prototype.addClass = function (node, className) {
        if (!node.className) { // doesn't have it for sure
            node.className = className;
        }
        else {
            this._findClassName(node, className); // see if it's already there
            if (this._lastStart === -1) {
                node.className = node.className + ' ' + className;
            }
        }
    };
    class_1.prototype.removeClass = function (node, className) {
        this._findClassName(node, className);
        if (this._lastStart === -1) {
            return; // Prevent styles invalidation if not necessary
        }
        else {
            node.className = node.className.substring(0, this._lastStart) + node.className.substring(this._lastEnd);
        }
    };
    class_1.prototype.removeClasses = function (node) {
        var _this = this;
        var classNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classNames[_i - 1] = arguments[_i];
        }
        classNames.forEach(function (nameValue) { return nameValue.split(' ').forEach(function (name) { return _this.removeClass(node, name); }); });
    };
    class_1.prototype.toggleClass = function (node, className, shouldHaveIt) {
        this._findClassName(node, className);
        if (this._lastStart !== -1 && (shouldHaveIt === void 0 || !shouldHaveIt)) {
            this.removeClass(node, className);
        }
        if (this._lastStart === -1 && (shouldHaveIt === void 0 || shouldHaveIt)) {
            this.addClass(node, className);
        }
    };
    return class_1;
}());
var _nativeClassList = new /** @class */ (function () {
    function class_2() {
    }
    class_2.prototype.hasClass = function (node, className) {
        return className && node.classList && node.classList.contains(className);
    };
    class_2.prototype.addClasses = function (node) {
        var _this = this;
        var classNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classNames[_i - 1] = arguments[_i];
        }
        classNames.forEach(function (nameValue) { return nameValue.split(' ').forEach(function (name) { return _this.addClass(node, name); }); });
    };
    class_2.prototype.addClass = function (node, className) {
        if (className && node.classList) {
            node.classList.add(className);
        }
    };
    class_2.prototype.removeClass = function (node, className) {
        if (className && node.classList) {
            node.classList.remove(className);
        }
    };
    class_2.prototype.removeClasses = function (node) {
        var _this = this;
        var classNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classNames[_i - 1] = arguments[_i];
        }
        classNames.forEach(function (nameValue) { return nameValue.split(' ').forEach(function (name) { return _this.removeClass(node, name); }); });
    };
    class_2.prototype.toggleClass = function (node, className, shouldHaveIt) {
        if (node.classList) {
            node.classList.toggle(className, shouldHaveIt);
        }
    };
    return class_2;
}());
// In IE11 there is only partial support for `classList` which makes us keep our
// custom implementation. Otherwise use the native implementation, see: http://caniuse.com/#search=classlist
var _classList = __WEBPACK_IMPORTED_MODULE_4__browser_js__["k" /* isIE */] ? _manualClassList : _nativeClassList;
var hasClass = _classList.hasClass.bind(_classList);
var addClass = _classList.addClass.bind(_classList);
var removeClass = _classList.removeClass.bind(_classList);
var toggleClass = _classList.toggleClass.bind(_classList);
var DomListener = /** @class */ (function () {
    function DomListener(node, type, handler, useCapture) {
        this._node = node;
        this._type = type;
        this._handler = handler;
        this._useCapture = (useCapture || false);
        this._node.addEventListener(this._type, this._handler, this._useCapture);
    }
    DomListener.prototype.dispose = function () {
        if (!this._handler) {
            // Already disposed
            return;
        }
        this._node.removeEventListener(this._type, this._handler, this._useCapture);
        // Prevent leakers from holding on to the dom or handler func
        this._node = null;
        this._handler = null;
    };
    return DomListener;
}());
function addDisposableListener(node, type, handler, useCapture) {
    return new DomListener(node, type, handler, useCapture);
}
function _wrapAsStandardMouseEvent(handler) {
    return function (e) {
        return handler(new __WEBPACK_IMPORTED_MODULE_6__mouseEvent_js__["b" /* StandardMouseEvent */](e));
    };
}
function _wrapAsStandardKeyboardEvent(handler) {
    return function (e) {
        return handler(new __WEBPACK_IMPORTED_MODULE_5__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e));
    };
}
var addStandardDisposableListener = function addStandardDisposableListener(node, type, handler, useCapture) {
    var wrapHandler = handler;
    if (type === 'click' || type === 'mousedown') {
        wrapHandler = _wrapAsStandardMouseEvent(handler);
    }
    else if (type === 'keydown' || type === 'keypress' || type === 'keyup') {
        wrapHandler = _wrapAsStandardKeyboardEvent(handler);
    }
    return addDisposableListener(node, type, wrapHandler, useCapture);
};
function addDisposableNonBubblingMouseOutListener(node, handler) {
    return addDisposableListener(node, 'mouseout', function (e) {
        // Mouse out bubbles, so this is an attempt to ignore faux mouse outs coming from children elements
        var toElement = (e.relatedTarget || e.toElement);
        while (toElement && toElement !== node) {
            toElement = toElement.parentNode;
        }
        if (toElement === node) {
            return;
        }
        handler(e);
    });
}
var _animationFrame = null;
function doRequestAnimationFrame(callback) {
    if (!_animationFrame) {
        var emulatedRequestAnimationFrame = function (callback) {
            return setTimeout(function () { return callback(new Date().getTime()); }, 0);
        };
        _animationFrame = (self.requestAnimationFrame
            || self.msRequestAnimationFrame
            || self.webkitRequestAnimationFrame
            || self.mozRequestAnimationFrame
            || self.oRequestAnimationFrame
            || emulatedRequestAnimationFrame);
    }
    return _animationFrame.call(self, callback);
}
/**
 * Schedule a callback to be run at the next animation frame.
 * This allows multiple parties to register callbacks that should run at the next animation frame.
 * If currently in an animation frame, `runner` will be executed immediately.
 * @return token that can be used to cancel the scheduled runner (only if `runner` was not executed immediately).
 */
var runAtThisOrScheduleAtNextAnimationFrame;
/**
 * Schedule a callback to be run at the next animation frame.
 * This allows multiple parties to register callbacks that should run at the next animation frame.
 * If currently in an animation frame, `runner` will be executed at the next animation frame.
 * @return token that can be used to cancel the scheduled runner.
 */
var scheduleAtNextAnimationFrame;
var AnimationFrameQueueItem = /** @class */ (function () {
    function AnimationFrameQueueItem(runner, priority) {
        this._runner = runner;
        this.priority = priority;
        this._canceled = false;
    }
    AnimationFrameQueueItem.prototype.dispose = function () {
        this._canceled = true;
    };
    AnimationFrameQueueItem.prototype.execute = function () {
        if (this._canceled) {
            return;
        }
        try {
            this._runner();
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_2__common_errors_js__["e" /* onUnexpectedError */])(e);
        }
    };
    // Sort by priority (largest to lowest)
    AnimationFrameQueueItem.sort = function (a, b) {
        return b.priority - a.priority;
    };
    return AnimationFrameQueueItem;
}());
(function () {
    /**
     * The runners scheduled at the next animation frame
     */
    var NEXT_QUEUE = [];
    /**
     * The runners scheduled at the current animation frame
     */
    var CURRENT_QUEUE = null;
    /**
     * A flag to keep track if the native requestAnimationFrame was already called
     */
    var animFrameRequested = false;
    /**
     * A flag to indicate if currently handling a native requestAnimationFrame callback
     */
    var inAnimationFrameRunner = false;
    var animationFrameRunner = function () {
        animFrameRequested = false;
        CURRENT_QUEUE = NEXT_QUEUE;
        NEXT_QUEUE = [];
        inAnimationFrameRunner = true;
        while (CURRENT_QUEUE.length > 0) {
            CURRENT_QUEUE.sort(AnimationFrameQueueItem.sort);
            var top_1 = CURRENT_QUEUE.shift();
            top_1.execute();
        }
        inAnimationFrameRunner = false;
    };
    scheduleAtNextAnimationFrame = function (runner, priority) {
        if (priority === void 0) { priority = 0; }
        var item = new AnimationFrameQueueItem(runner, priority);
        NEXT_QUEUE.push(item);
        if (!animFrameRequested) {
            animFrameRequested = true;
            doRequestAnimationFrame(animationFrameRunner);
        }
        return item;
    };
    runAtThisOrScheduleAtNextAnimationFrame = function (runner, priority) {
        if (inAnimationFrameRunner) {
            var item = new AnimationFrameQueueItem(runner, priority);
            CURRENT_QUEUE.push(item);
            return item;
        }
        else {
            return scheduleAtNextAnimationFrame(runner, priority);
        }
    };
})();
var MINIMUM_TIME_MS = 16;
var DEFAULT_EVENT_MERGER = function (lastEvent, currentEvent) {
    return currentEvent;
};
var TimeoutThrottledDomListener = /** @class */ (function (_super) {
    __extends(TimeoutThrottledDomListener, _super);
    function TimeoutThrottledDomListener(node, type, handler, eventMerger, minimumTimeMs) {
        if (eventMerger === void 0) { eventMerger = DEFAULT_EVENT_MERGER; }
        if (minimumTimeMs === void 0) { minimumTimeMs = MINIMUM_TIME_MS; }
        var _this = _super.call(this) || this;
        var lastEvent = null;
        var lastHandlerTime = 0;
        var timeout = _this._register(new __WEBPACK_IMPORTED_MODULE_1__common_async_js__["f" /* TimeoutTimer */]());
        var invokeHandler = function () {
            lastHandlerTime = (new Date()).getTime();
            handler(lastEvent);
            lastEvent = null;
        };
        _this._register(addDisposableListener(node, type, function (e) {
            lastEvent = eventMerger(lastEvent, e);
            var elapsedTime = (new Date()).getTime() - lastHandlerTime;
            if (elapsedTime >= minimumTimeMs) {
                timeout.cancel();
                invokeHandler();
            }
            else {
                timeout.setIfNotSet(invokeHandler, minimumTimeMs - elapsedTime);
            }
        }));
        return _this;
    }
    return TimeoutThrottledDomListener;
}(__WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["a" /* Disposable */]));
function addDisposableThrottledListener(node, type, handler, eventMerger, minimumTimeMs) {
    return new TimeoutThrottledDomListener(node, type, handler, eventMerger, minimumTimeMs);
}
function getComputedStyle(el) {
    return document.defaultView.getComputedStyle(el, null);
}
// Adapted from WinJS
// Converts a CSS positioning string for the specified element to pixels.
var convertToPixels = (function () {
    return function (element, value) {
        return parseFloat(value) || 0;
    };
})();
function getDimension(element, cssPropertyName, jsPropertyName) {
    var computedStyle = getComputedStyle(element);
    var value = '0';
    if (computedStyle) {
        if (computedStyle.getPropertyValue) {
            value = computedStyle.getPropertyValue(cssPropertyName);
        }
        else {
            // IE8
            value = computedStyle.getAttribute(jsPropertyName);
        }
    }
    return convertToPixels(element, value);
}
function getClientArea(element) {
    // Try with DOM clientWidth / clientHeight
    if (element !== document.body) {
        return new Dimension(element.clientWidth, element.clientHeight);
    }
    // Try innerWidth / innerHeight
    if (window.innerWidth && window.innerHeight) {
        return new Dimension(window.innerWidth, window.innerHeight);
    }
    // Try with document.body.clientWidth / document.body.clientHeigh
    if (document.body && document.body.clientWidth && document.body.clientWidth) {
        return new Dimension(document.body.clientWidth, document.body.clientHeight);
    }
    // Try with document.documentElement.clientWidth / document.documentElement.clientHeight
    if (document.documentElement && document.documentElement.clientWidth && document.documentElement.clientHeight) {
        return new Dimension(document.documentElement.clientWidth, document.documentElement.clientHeight);
    }
    throw new Error('Unable to figure out browser width and height');
}
var sizeUtils = {
    getBorderLeftWidth: function (element) {
        return getDimension(element, 'border-left-width', 'borderLeftWidth');
    },
    getBorderRightWidth: function (element) {
        return getDimension(element, 'border-right-width', 'borderRightWidth');
    },
    getBorderTopWidth: function (element) {
        return getDimension(element, 'border-top-width', 'borderTopWidth');
    },
    getBorderBottomWidth: function (element) {
        return getDimension(element, 'border-bottom-width', 'borderBottomWidth');
    },
    getPaddingLeft: function (element) {
        return getDimension(element, 'padding-left', 'paddingLeft');
    },
    getPaddingRight: function (element) {
        return getDimension(element, 'padding-right', 'paddingRight');
    },
    getPaddingTop: function (element) {
        return getDimension(element, 'padding-top', 'paddingTop');
    },
    getPaddingBottom: function (element) {
        return getDimension(element, 'padding-bottom', 'paddingBottom');
    },
    getMarginLeft: function (element) {
        return getDimension(element, 'margin-left', 'marginLeft');
    },
    getMarginTop: function (element) {
        return getDimension(element, 'margin-top', 'marginTop');
    },
    getMarginRight: function (element) {
        return getDimension(element, 'margin-right', 'marginRight');
    },
    getMarginBottom: function (element) {
        return getDimension(element, 'margin-bottom', 'marginBottom');
    },
    __commaSentinel: false
};
// ----------------------------------------------------------------------------------------
// Position & Dimension
var Dimension = /** @class */ (function () {
    function Dimension(width, height) {
        this.width = width;
        this.height = height;
    }
    return Dimension;
}());

function getTopLeftOffset(element) {
    // Adapted from WinJS.Utilities.getPosition
    // and added borders to the mix
    var offsetParent = element.offsetParent, top = element.offsetTop, left = element.offsetLeft;
    while ((element = element.parentNode) !== null && element !== document.body && element !== document.documentElement) {
        top -= element.scrollTop;
        var c = getComputedStyle(element);
        if (c) {
            left -= c.direction !== 'rtl' ? element.scrollLeft : -element.scrollLeft;
        }
        if (element === offsetParent) {
            left += sizeUtils.getBorderLeftWidth(element);
            top += sizeUtils.getBorderTopWidth(element);
            top += element.offsetTop;
            left += element.offsetLeft;
            offsetParent = element.offsetParent;
        }
    }
    return {
        left: left,
        top: top
    };
}
/**
 * Returns the position of a dom node relative to the entire page.
 */
function getDomNodePagePosition(domNode) {
    var bb = domNode.getBoundingClientRect();
    return {
        left: bb.left + StandardWindow.scrollX,
        top: bb.top + StandardWindow.scrollY,
        width: bb.width,
        height: bb.height
    };
}
var StandardWindow = new /** @class */ (function () {
    function class_3() {
    }
    Object.defineProperty(class_3.prototype, "scrollX", {
        get: function () {
            if (typeof window.scrollX === 'number') {
                // modern browsers
                return window.scrollX;
            }
            else {
                return document.body.scrollLeft + document.documentElement.scrollLeft;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_3.prototype, "scrollY", {
        get: function () {
            if (typeof window.scrollY === 'number') {
                // modern browsers
                return window.scrollY;
            }
            else {
                return document.body.scrollTop + document.documentElement.scrollTop;
            }
        },
        enumerable: true,
        configurable: true
    });
    return class_3;
}());
// Adapted from WinJS
// Gets the width of the element, including margins.
function getTotalWidth(element) {
    var margin = sizeUtils.getMarginLeft(element) + sizeUtils.getMarginRight(element);
    return element.offsetWidth + margin;
}
function getContentWidth(element) {
    var border = sizeUtils.getBorderLeftWidth(element) + sizeUtils.getBorderRightWidth(element);
    var padding = sizeUtils.getPaddingLeft(element) + sizeUtils.getPaddingRight(element);
    return element.offsetWidth - border - padding;
}
// Adapted from WinJS
// Gets the height of the content of the specified element. The content height does not include borders or padding.
function getContentHeight(element) {
    var border = sizeUtils.getBorderTopWidth(element) + sizeUtils.getBorderBottomWidth(element);
    var padding = sizeUtils.getPaddingTop(element) + sizeUtils.getPaddingBottom(element);
    return element.offsetHeight - border - padding;
}
// Adapted from WinJS
// Gets the height of the element, including its margins.
function getTotalHeight(element) {
    var margin = sizeUtils.getMarginTop(element) + sizeUtils.getMarginBottom(element);
    return element.offsetHeight + margin;
}
// ----------------------------------------------------------------------------------------
function isAncestor(testChild, testAncestor) {
    while (testChild) {
        if (testChild === testAncestor) {
            return true;
        }
        testChild = testChild.parentNode;
    }
    return false;
}
function findParentWithClass(node, clazz, stopAtClazzOrNode) {
    while (node) {
        if (hasClass(node, clazz)) {
            return node;
        }
        if (stopAtClazzOrNode) {
            if (typeof stopAtClazzOrNode === 'string') {
                if (hasClass(node, stopAtClazzOrNode)) {
                    return null;
                }
            }
            else {
                if (node === stopAtClazzOrNode) {
                    return null;
                }
            }
        }
        node = node.parentNode;
    }
    return null;
}
function createStyleSheet(container) {
    if (container === void 0) { container = document.getElementsByTagName('head')[0]; }
    var style = document.createElement('style');
    style.type = 'text/css';
    style.media = 'screen';
    container.appendChild(style);
    return style;
}
var _sharedStyleSheet = null;
function getSharedStyleSheet() {
    if (!_sharedStyleSheet) {
        _sharedStyleSheet = createStyleSheet();
    }
    return _sharedStyleSheet;
}
function getDynamicStyleSheetRules(style) {
    if (style && style.sheet && style.sheet.rules) {
        // Chrome, IE
        return style.sheet.rules;
    }
    if (style && style.sheet && style.sheet.cssRules) {
        // FF
        return style.sheet.cssRules;
    }
    return [];
}
function createCSSRule(selector, cssText, style) {
    if (style === void 0) { style = getSharedStyleSheet(); }
    if (!style || !cssText) {
        return;
    }
    style.sheet.insertRule(selector + '{' + cssText + '}', 0);
}
function removeCSSRulesContainingSelector(ruleName, style) {
    if (style === void 0) { style = getSharedStyleSheet(); }
    if (!style) {
        return;
    }
    var rules = getDynamicStyleSheetRules(style);
    var toDelete = [];
    for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        if (rule.selectorText.indexOf(ruleName) !== -1) {
            toDelete.push(i);
        }
    }
    for (var i = toDelete.length - 1; i >= 0; i--) {
        style.sheet.deleteRule(toDelete[i]);
    }
}
function isHTMLElement(o) {
    if (typeof HTMLElement === 'object') {
        return o instanceof HTMLElement;
    }
    return o && typeof o === 'object' && o.nodeType === 1 && typeof o.nodeName === 'string';
}
var EventType = {
    // Mouse
    CLICK: 'click',
    AUXCLICK: 'auxclick',
    DBLCLICK: 'dblclick',
    MOUSE_UP: 'mouseup',
    MOUSE_DOWN: 'mousedown',
    MOUSE_OVER: 'mouseover',
    MOUSE_MOVE: 'mousemove',
    MOUSE_OUT: 'mouseout',
    MOUSE_ENTER: 'mouseenter',
    MOUSE_LEAVE: 'mouseleave',
    CONTEXT_MENU: 'contextmenu',
    WHEEL: 'wheel',
    // Keyboard
    KEY_DOWN: 'keydown',
    KEY_PRESS: 'keypress',
    KEY_UP: 'keyup',
    // HTML Document
    LOAD: 'load',
    UNLOAD: 'unload',
    ABORT: 'abort',
    ERROR: 'error',
    RESIZE: 'resize',
    SCROLL: 'scroll',
    // Form
    SELECT: 'select',
    CHANGE: 'change',
    SUBMIT: 'submit',
    RESET: 'reset',
    FOCUS: 'focus',
    FOCUS_IN: 'focusin',
    FOCUS_OUT: 'focusout',
    BLUR: 'blur',
    INPUT: 'input',
    // Local Storage
    STORAGE: 'storage',
    // Drag
    DRAG_START: 'dragstart',
    DRAG: 'drag',
    DRAG_ENTER: 'dragenter',
    DRAG_LEAVE: 'dragleave',
    DRAG_OVER: 'dragover',
    DROP: 'drop',
    DRAG_END: 'dragend',
    // Animation
    ANIMATION_START: __WEBPACK_IMPORTED_MODULE_4__browser_js__["n" /* isWebKit */] ? 'webkitAnimationStart' : 'animationstart',
    ANIMATION_END: __WEBPACK_IMPORTED_MODULE_4__browser_js__["n" /* isWebKit */] ? 'webkitAnimationEnd' : 'animationend',
    ANIMATION_ITERATION: __WEBPACK_IMPORTED_MODULE_4__browser_js__["n" /* isWebKit */] ? 'webkitAnimationIteration' : 'animationiteration'
};
var EventHelper = {
    stop: function (e, cancelBubble) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        else {
            // IE8
            e.returnValue = false;
        }
        if (cancelBubble) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            else {
                // IE8
                e.cancelBubble = true;
            }
        }
    }
};
function saveParentsScrollTop(node) {
    var r = [];
    for (var i = 0; node && node.nodeType === node.ELEMENT_NODE; i++) {
        r[i] = node.scrollTop;
        node = node.parentNode;
    }
    return r;
}
function restoreParentsScrollTop(node, state) {
    for (var i = 0; node && node.nodeType === node.ELEMENT_NODE; i++) {
        if (node.scrollTop !== state[i]) {
            node.scrollTop = state[i];
        }
        node = node.parentNode;
    }
}
var FocusTracker = /** @class */ (function () {
    function FocusTracker(element) {
        var _this = this;
        this._onDidFocus = new __WEBPACK_IMPORTED_MODULE_7__common_event_js__["a" /* Emitter */]();
        this.onDidFocus = this._onDidFocus.event;
        this._onDidBlur = new __WEBPACK_IMPORTED_MODULE_7__common_event_js__["a" /* Emitter */]();
        this.onDidBlur = this._onDidBlur.event;
        this.disposables = [];
        var hasFocus = false;
        var loosingFocus = false;
        var onFocus = function () {
            loosingFocus = false;
            if (!hasFocus) {
                hasFocus = true;
                _this._onDidFocus.fire();
            }
        };
        var onBlur = function () {
            if (hasFocus) {
                loosingFocus = true;
                window.setTimeout(function () {
                    if (loosingFocus) {
                        loosingFocus = false;
                        hasFocus = false;
                        _this._onDidBlur.fire();
                    }
                }, 0);
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_8__event_js__["a" /* domEvent */])(element, EventType.FOCUS, true)(onFocus, null, this.disposables);
        Object(__WEBPACK_IMPORTED_MODULE_8__event_js__["a" /* domEvent */])(element, EventType.BLUR, true)(onBlur, null, this.disposables);
    }
    FocusTracker.prototype.dispose = function () {
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */])(this.disposables);
        this._onDidFocus.dispose();
        this._onDidBlur.dispose();
    };
    return FocusTracker;
}());
function trackFocus(element) {
    return new FocusTracker(element);
}
function append(parent) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    children.forEach(function (child) { return parent.appendChild(child); });
    return children[children.length - 1];
}
function prepend(parent, child) {
    parent.insertBefore(child, parent.firstChild);
    return child;
}
var SELECTOR_REGEX = /([\w\-]+)?(#([\w\-]+))?((.([\w\-]+))*)/;
// Similar to builder, but much more lightweight
function $(description, attrs) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var match = SELECTOR_REGEX.exec(description);
    if (!match) {
        throw new Error('Bad use of emmet');
    }
    var result = document.createElement(match[1] || 'div');
    if (match[3]) {
        result.id = match[3];
    }
    if (match[4]) {
        result.className = match[4].replace(/\./g, ' ').trim();
    }
    Object.keys(attrs || {}).forEach(function (name) {
        if (/^on\w+$/.test(name)) {
            result[name] = attrs[name];
        }
        else if (name === 'selected') {
            var value = attrs[name];
            if (value) {
                result.setAttribute(name, 'true');
            }
        }
        else {
            result.setAttribute(name, attrs[name]);
        }
    });
    children
        .filter(function (child) { return !!child; })
        .forEach(function (child) {
        if (child instanceof Node) {
            result.appendChild(child);
        }
        else {
            result.appendChild(document.createTextNode(child));
        }
    });
    return result;
}
function show() {
    var elements = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        elements[_i] = arguments[_i];
    }
    for (var _a = 0, elements_1 = elements; _a < elements_1.length; _a++) {
        var element = elements_1[_a];
        element.style.display = '';
        element.removeAttribute('aria-hidden');
    }
}
function hide() {
    var elements = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        elements[_i] = arguments[_i];
    }
    for (var _a = 0, elements_2 = elements; _a < elements_2.length; _a++) {
        var element = elements_2[_a];
        element.style.display = 'none';
        element.setAttribute('aria-hidden', 'true');
    }
}
function findParentWithAttribute(node, attribute) {
    while (node) {
        if (node instanceof HTMLElement && node.hasAttribute(attribute)) {
            return node;
        }
        node = node.parentNode;
    }
    return null;
}
function removeTabIndexAndUpdateFocus(node) {
    if (!node || !node.hasAttribute('tabIndex')) {
        return;
    }
    // If we are the currently focused element and tabIndex is removed,
    // standard DOM behavior is to move focus to the <body> element. We
    // typically never want that, rather put focus to the closest element
    // in the hierarchy of the parent DOM nodes.
    if (document.activeElement === node) {
        var parentFocusable = findParentWithAttribute(node.parentElement, 'tabIndex');
        if (parentFocusable) {
            parentFocusable.focus();
        }
    }
    node.removeAttribute('tabindex');
}
function getElementsByTagName(tag) {
    return Array.prototype.slice.call(document.getElementsByTagName(tag), 0);
}
/**
 * Find a value usable for a dom node size such that the likelihood that it would be
 * displayed with constant screen pixels size is as high as possible.
 *
 * e.g. We would desire for the cursors to be 2px (CSS px) wide. Under a devicePixelRatio
 * of 1.25, the cursor will be 2.5 screen pixels wide. Depending on how the dom node aligns/"snaps"
 * with the screen pixels, it will sometimes be rendered with 2 screen pixels, and sometimes with 3 screen pixels.
 */
function computeScreenAwareSize(cssPx) {
    var screenPx = window.devicePixelRatio * cssPx;
    return Math.max(1, Math.floor(screenPx)) / window.devicePixelRatio;
}
/**
 * See https://github.com/Microsoft/monaco-editor/issues/601
 * To protect against malicious code in the linked site, particularly phishing attempts,
 * the window.opener should be set to null to prevent the linked site from having access
 * to change the location of the current page.
 * See https://mathiasbynens.github.io/rel-noopener/
 */
function windowOpenNoOpener(url) {
    if (__WEBPACK_IMPORTED_MODULE_0__common_platform_js__["e" /* isNative */] || __WEBPACK_IMPORTED_MODULE_4__browser_js__["i" /* isEdgeWebView */]) {
        // In VSCode, window.open() always returns null...
        // The same is true for a WebView (see https://github.com/Microsoft/monaco-editor/issues/628)
        window.open(url);
    }
    else {
        var newTab = window.open();
        if (newTab) {
            newTab.opener = null;
            newTab.location.href = url;
        }
    }
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Emitter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EventMultiplexer; });
/* harmony export (immutable) */ __webpack_exports__["k"] = once;
/* harmony export (immutable) */ __webpack_exports__["f"] = anyEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = debounceEvent;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EventBufferer; });
/* harmony export (immutable) */ __webpack_exports__["j"] = mapEvent;
/* harmony export (immutable) */ __webpack_exports__["i"] = filterEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = chain;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Relay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkedList_js__ = __webpack_require__(246);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var Event;
(function (Event) {
    var _disposable = { dispose: function () { } };
    Event.None = function () { return _disposable; };
})(Event || (Event = {}));
/**
 * The Emitter can be used to expose an Event to the public
 * to fire it from the insides.
 * Sample:
    class Document {

        private _onDidChange = new Emitter<(value:string)=>any>();

        public onDidChange = this._onDidChange.event;

        // getter-style
        // get onDidChange(): Event<(value:string)=>any> {
        // 	return this._onDidChange.event;
        // }

        private _doIt() {
            //...
            this._onDidChange.fire(value);
        }
    }
 */
var Emitter = /** @class */ (function () {
    function Emitter(_options) {
        this._options = _options;
    }
    Object.defineProperty(Emitter.prototype, "event", {
        /**
         * For the public to allow to subscribe
         * to events from this Emitter
         */
        get: function () {
            var _this = this;
            if (!this._event) {
                this._event = function (listener, thisArgs, disposables) {
                    if (!_this._listeners) {
                        _this._listeners = new __WEBPACK_IMPORTED_MODULE_3__linkedList_js__["a" /* LinkedList */]();
                    }
                    var firstListener = _this._listeners.isEmpty();
                    if (firstListener && _this._options && _this._options.onFirstListenerAdd) {
                        _this._options.onFirstListenerAdd(_this);
                    }
                    var remove = _this._listeners.push(!thisArgs ? listener : [listener, thisArgs]);
                    if (firstListener && _this._options && _this._options.onFirstListenerDidAdd) {
                        _this._options.onFirstListenerDidAdd(_this);
                    }
                    if (_this._options && _this._options.onListenerDidAdd) {
                        _this._options.onListenerDidAdd(_this, listener, thisArgs);
                    }
                    var result;
                    result = {
                        dispose: function () {
                            result.dispose = Emitter._noop;
                            if (!_this._disposed) {
                                remove();
                                if (_this._options && _this._options.onLastListenerRemove && _this._listeners.isEmpty()) {
                                    _this._options.onLastListenerRemove(_this);
                                }
                            }
                        }
                    };
                    if (Array.isArray(disposables)) {
                        disposables.push(result);
                    }
                    return result;
                };
            }
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * To be kept private to fire an event to
     * subscribers
     */
    Emitter.prototype.fire = function (event) {
        if (this._listeners) {
            // put all [listener,event]-pairs into delivery queue
            // then emit all event. an inner/nested event might be
            // the driver of this
            if (!this._deliveryQueue) {
                this._deliveryQueue = [];
            }
            for (var iter = this._listeners.iterator(), e = iter.next(); !e.done; e = iter.next()) {
                this._deliveryQueue.push([e.value, event]);
            }
            while (this._deliveryQueue.length > 0) {
                var _a = this._deliveryQueue.shift(), listener = _a[0], event_1 = _a[1];
                try {
                    if (typeof listener === 'function') {
                        listener.call(undefined, event_1);
                    }
                    else {
                        listener[0].call(listener[1], event_1);
                    }
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__errors_js__["e" /* onUnexpectedError */])(e);
                }
            }
        }
    };
    Emitter.prototype.dispose = function () {
        if (this._listeners) {
            this._listeners = undefined;
        }
        if (this._deliveryQueue) {
            this._deliveryQueue.length = 0;
        }
        this._disposed = true;
    };
    Emitter._noop = function () { };
    return Emitter;
}());

var EventMultiplexer = /** @class */ (function () {
    function EventMultiplexer() {
        var _this = this;
        this.hasListeners = false;
        this.events = [];
        this.emitter = new Emitter({
            onFirstListenerAdd: function () { return _this.onFirstListenerAdd(); },
            onLastListenerRemove: function () { return _this.onLastListenerRemove(); }
        });
    }
    Object.defineProperty(EventMultiplexer.prototype, "event", {
        get: function () {
            return this.emitter.event;
        },
        enumerable: true,
        configurable: true
    });
    EventMultiplexer.prototype.add = function (event) {
        var _this = this;
        var e = { event: event, listener: null };
        this.events.push(e);
        if (this.hasListeners) {
            this.hook(e);
        }
        var dispose = function () {
            if (_this.hasListeners) {
                _this.unhook(e);
            }
            var idx = _this.events.indexOf(e);
            _this.events.splice(idx, 1);
        };
        return Object(__WEBPACK_IMPORTED_MODULE_2__lifecycle_js__["f" /* toDisposable */])(Object(__WEBPACK_IMPORTED_MODULE_1__functional_js__["a" /* once */])(dispose));
    };
    EventMultiplexer.prototype.onFirstListenerAdd = function () {
        var _this = this;
        this.hasListeners = true;
        this.events.forEach(function (e) { return _this.hook(e); });
    };
    EventMultiplexer.prototype.onLastListenerRemove = function () {
        var _this = this;
        this.hasListeners = false;
        this.events.forEach(function (e) { return _this.unhook(e); });
    };
    EventMultiplexer.prototype.hook = function (e) {
        var _this = this;
        e.listener = e.event(function (r) { return _this.emitter.fire(r); });
    };
    EventMultiplexer.prototype.unhook = function (e) {
        e.listener.dispose();
        e.listener = null;
    };
    EventMultiplexer.prototype.dispose = function () {
        this.emitter.dispose();
    };
    return EventMultiplexer;
}());

function once(event) {
    return function (listener, thisArgs, disposables) {
        if (thisArgs === void 0) { thisArgs = null; }
        var result = event(function (e) {
            result.dispose();
            return listener.call(thisArgs, e);
        }, null, disposables);
        return result;
    };
}
function anyEvent() {
    var events = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        events[_i] = arguments[_i];
    }
    return function (listener, thisArgs, disposables) {
        if (thisArgs === void 0) { thisArgs = null; }
        return Object(__WEBPACK_IMPORTED_MODULE_2__lifecycle_js__["c" /* combinedDisposable */])(events.map(function (event) { return event(function (e) { return listener.call(thisArgs, e); }, null, disposables); }));
    };
}
function debounceEvent(event, merger, delay, leading) {
    if (delay === void 0) { delay = 100; }
    if (leading === void 0) { leading = false; }
    var subscription;
    var output = undefined;
    var handle = undefined;
    var numDebouncedCalls = 0;
    var emitter = new Emitter({
        onFirstListenerAdd: function () {
            subscription = event(function (cur) {
                numDebouncedCalls++;
                output = merger(output, cur);
                if (leading && !handle) {
                    emitter.fire(output);
                }
                clearTimeout(handle);
                handle = setTimeout(function () {
                    var _output = output;
                    output = undefined;
                    handle = undefined;
                    if (!leading || numDebouncedCalls > 1) {
                        emitter.fire(_output);
                    }
                    numDebouncedCalls = 0;
                }, delay);
            });
        },
        onLastListenerRemove: function () {
            subscription.dispose();
        }
    });
    return emitter.event;
}
/**
 * The EventDelayer is useful in situations in which you want
 * to delay firing your events during some code.
 * You can wrap that code and be sure that the event will not
 * be fired during that wrap.
 *
 * ```
 * const emitter: Emitter;
 * const delayer = new EventDelayer();
 * const delayedEvent = delayer.wrapEvent(emitter.event);
 *
 * delayedEvent(console.log);
 *
 * delayer.bufferEvents(() => {
 *   emitter.fire(); // event will not be fired yet
 * });
 *
 * // event will only be fired at this point
 * ```
 */
var EventBufferer = /** @class */ (function () {
    function EventBufferer() {
        this.buffers = [];
    }
    EventBufferer.prototype.wrapEvent = function (event) {
        var _this = this;
        return function (listener, thisArgs, disposables) {
            return event(function (i) {
                var buffer = _this.buffers[_this.buffers.length - 1];
                if (buffer) {
                    buffer.push(function () { return listener.call(thisArgs, i); });
                }
                else {
                    listener.call(thisArgs, i);
                }
            }, void 0, disposables);
        };
    };
    EventBufferer.prototype.bufferEvents = function (fn) {
        var buffer = [];
        this.buffers.push(buffer);
        fn();
        this.buffers.pop();
        buffer.forEach(function (flush) { return flush(); });
    };
    return EventBufferer;
}());

function mapEvent(event, map) {
    return function (listener, thisArgs, disposables) {
        if (thisArgs === void 0) { thisArgs = null; }
        return event(function (i) { return listener.call(thisArgs, map(i)); }, null, disposables);
    };
}
function filterEvent(event, filter) {
    return function (listener, thisArgs, disposables) {
        if (thisArgs === void 0) { thisArgs = null; }
        return event(function (e) { return filter(e) && listener.call(thisArgs, e); }, null, disposables);
    };
}
var ChainableEvent = /** @class */ (function () {
    function ChainableEvent(_event) {
        this._event = _event;
    }
    Object.defineProperty(ChainableEvent.prototype, "event", {
        get: function () { return this._event; },
        enumerable: true,
        configurable: true
    });
    ChainableEvent.prototype.map = function (fn) {
        return new ChainableEvent(mapEvent(this._event, fn));
    };
    ChainableEvent.prototype.filter = function (fn) {
        return new ChainableEvent(filterEvent(this._event, fn));
    };
    ChainableEvent.prototype.on = function (listener, thisArgs, disposables) {
        return this._event(listener, thisArgs, disposables);
    };
    return ChainableEvent;
}());
function chain(event) {
    return new ChainableEvent(event);
}
var Relay = /** @class */ (function () {
    function Relay() {
        this.emitter = new Emitter();
        this.event = this.emitter.event;
        this.disposable = __WEBPACK_IMPORTED_MODULE_2__lifecycle_js__["a" /* Disposable */].None;
    }
    Object.defineProperty(Relay.prototype, "input", {
        set: function (event) {
            this.disposable.dispose();
            this.disposable = event(this.emitter.fire, this.emitter);
        },
        enumerable: true,
        configurable: true
    });
    Relay.prototype.dispose = function () {
        this.disposable.dispose();
        this.emitter.dispose();
    };
    return Relay;
}());



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorHandler */
/* unused harmony export errorHandler */
/* harmony export (immutable) */ __webpack_exports__["e"] = onUnexpectedError;
/* harmony export (immutable) */ __webpack_exports__["f"] = onUnexpectedExternalError;
/* harmony export (immutable) */ __webpack_exports__["g"] = transformErrorForSerialization;
/* harmony export (immutable) */ __webpack_exports__["d"] = isPromiseCanceledError;
/* harmony export (immutable) */ __webpack_exports__["a"] = canceled;
/* harmony export (immutable) */ __webpack_exports__["b"] = illegalArgument;
/* harmony export (immutable) */ __webpack_exports__["c"] = illegalState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__winjs_base_js__ = __webpack_require__(8);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// ------ BEGIN Hook up error listeners to winjs promises
var outstandingPromiseErrors = {};
function promiseErrorHandler(e) {
    //
    // e.detail looks like: { exception, error, promise, handler, id, parent }
    //
    var details = e.detail;
    var id = details.id;
    // If the error has a parent promise then this is not the origination of the
    //  error so we check if it has a handler, and if so we mark that the error
    //  was handled by removing it from outstandingPromiseErrors
    //
    if (details.parent) {
        if (details.handler && outstandingPromiseErrors) {
            delete outstandingPromiseErrors[id];
        }
        return;
    }
    // Indicate that this error was originated and needs to be handled
    outstandingPromiseErrors[id] = details;
    // The first time the queue fills up this iteration, schedule a timeout to
    // check if any errors are still unhandled.
    if (Object.keys(outstandingPromiseErrors).length === 1) {
        setTimeout(function () {
            var errors = outstandingPromiseErrors;
            outstandingPromiseErrors = {};
            Object.keys(errors).forEach(function (errorId) {
                var error = errors[errorId];
                if (error.exception) {
                    onUnexpectedError(error.exception);
                }
                else if (error.error) {
                    onUnexpectedError(error.error);
                }
                console.log('WARNING: Promise with no error callback:' + error.id);
                console.log(error);
                if (error.exception) {
                    console.log(error.exception.stack);
                }
            });
        }, 0);
    }
}
__WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["b" /* TPromise */].addEventListener('error', promiseErrorHandler);
// Avoid circular dependency on EventEmitter by implementing a subset of the interface.
var ErrorHandler = /** @class */ (function () {
    function ErrorHandler() {
        this.listeners = [];
        this.unexpectedErrorHandler = function (e) {
            setTimeout(function () {
                if (e.stack) {
                    throw new Error(e.message + '\n\n' + e.stack);
                }
                throw e;
            }, 0);
        };
    }
    ErrorHandler.prototype.emit = function (e) {
        this.listeners.forEach(function (listener) {
            listener(e);
        });
    };
    ErrorHandler.prototype.onUnexpectedError = function (e) {
        this.unexpectedErrorHandler(e);
        this.emit(e);
    };
    // For external errors, we don't want the listeners to be called
    ErrorHandler.prototype.onUnexpectedExternalError = function (e) {
        this.unexpectedErrorHandler(e);
    };
    return ErrorHandler;
}());

var errorHandler = new ErrorHandler();
function onUnexpectedError(e) {
    // ignore errors from cancelled promises
    if (!isPromiseCanceledError(e)) {
        errorHandler.onUnexpectedError(e);
    }
    return undefined;
}
function onUnexpectedExternalError(e) {
    // ignore errors from cancelled promises
    if (!isPromiseCanceledError(e)) {
        errorHandler.onUnexpectedExternalError(e);
    }
    return undefined;
}
function transformErrorForSerialization(error) {
    if (error instanceof Error) {
        var name_1 = error.name, message = error.message;
        var stack = error.stacktrace || error.stack;
        return {
            $isError: true,
            name: name_1,
            message: message,
            stack: stack
        };
    }
    // return as is
    return error;
}
var canceledName = 'Canceled';
/**
 * Checks if the given error is a promise in canceled state
 */
function isPromiseCanceledError(error) {
    return error instanceof Error && error.name === canceledName && error.message === canceledName;
}
/**
 * Returns an error that signals cancellation.
 */
function canceled() {
    var error = new Error(canceledName);
    error.name = error.message;
    return error;
}
function illegalArgument(name) {
    if (name) {
        return new Error("Illegal argument: " + name);
    }
    else {
        return new Error('Illegal argument');
    }
}
function illegalState(name) {
    if (name) {
        return new Error("Illegal state: " + name);
    }
    else {
        return new Error('Illegal state');
    }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Command; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditorCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditorAction; });
/* harmony export (immutable) */ __webpack_exports__["j"] = registerLanguageCommand;
/* harmony export (immutable) */ __webpack_exports__["e"] = registerDefaultLanguageCommand;
/* harmony export (immutable) */ __webpack_exports__["g"] = registerEditorCommand;
/* harmony export (immutable) */ __webpack_exports__["f"] = registerEditorAction;
/* harmony export (immutable) */ __webpack_exports__["i"] = registerInstantiatedEditorAction;
/* harmony export (immutable) */ __webpack_exports__["h"] = registerEditorContribution;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EditorExtensionsRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_telemetry_common_telemetry_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_codeEditorService_js__ = __webpack_require__(29);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};











var Command = /** @class */ (function () {
    function Command(opts) {
        this.id = opts.id;
        this.precondition = opts.precondition;
        this._kbOpts = opts.kbOpts;
        this._menubarOpts = opts.menubarOpts;
        this._description = opts.description;
    }
    Command.prototype.register = function () {
        var _this = this;
        if (this._menubarOpts) {
            __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["d" /* MenuRegistry */].appendMenuItem(this._menubarOpts.menuId, {
                group: this._menubarOpts.group,
                command: {
                    id: this.id,
                    title: this._menubarOpts.title,
                },
                when: this._menubarOpts.when,
                order: this._menubarOpts.order
            });
        }
        if (this._kbOpts) {
            var kbWhen = this._kbOpts.kbExpr;
            if (this.precondition) {
                if (kbWhen) {
                    kbWhen = __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(kbWhen, this.precondition);
                }
                else {
                    kbWhen = this.precondition;
                }
            }
            __WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
                id: this.id,
                handler: function (accessor, args) { return _this.runCommand(accessor, args); },
                weight: this._kbOpts.weight,
                when: kbWhen,
                primary: this._kbOpts.primary,
                secondary: this._kbOpts.secondary,
                win: this._kbOpts.win,
                linux: this._kbOpts.linux,
                mac: this._kbOpts.mac,
                description: this._description
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand({
                id: this.id,
                handler: function (accessor, args) { return _this.runCommand(accessor, args); },
                description: this._description
            });
        }
    };
    return Command;
}());

var EditorCommand = /** @class */ (function (_super) {
    __extends(EditorCommand, _super);
    function EditorCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a command class that is bound to a certain editor contribution.
     */
    EditorCommand.bindToContribution = function (controllerGetter) {
        return /** @class */ (function (_super) {
            __extends(EditorControllerCommandImpl, _super);
            function EditorControllerCommandImpl(opts) {
                var _this = _super.call(this, opts) || this;
                _this._callback = opts.handler;
                return _this;
            }
            EditorControllerCommandImpl.prototype.runEditorCommand = function (accessor, editor, args) {
                var controller = controllerGetter(editor);
                if (controller) {
                    this._callback(controllerGetter(editor));
                }
            };
            return EditorControllerCommandImpl;
        }(EditorCommand));
    };
    EditorCommand.prototype.runCommand = function (accessor, args) {
        var _this = this;
        var codeEditorService = accessor.get(__WEBPACK_IMPORTED_MODULE_10__services_codeEditorService_js__["a" /* ICodeEditorService */]);
        // Find the editor with text focus or active
        var editor = codeEditorService.getFocusedCodeEditor() || codeEditorService.getActiveCodeEditor();
        if (!editor) {
            // well, at least we tried...
            return;
        }
        return editor.invokeWithinContext(function (editorAccessor) {
            var kbService = editorAccessor.get(__WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]);
            if (!kbService.contextMatchesRules(_this.precondition)) {
                // precondition does not hold
                return;
            }
            return _this.runEditorCommand(editorAccessor, editor, args);
        });
    };
    return EditorCommand;
}(Command));

var EditorAction = /** @class */ (function (_super) {
    __extends(EditorAction, _super);
    function EditorAction(opts) {
        var _this = _super.call(this, opts) || this;
        _this.label = opts.label;
        _this.alias = opts.alias;
        _this.menuOpts = opts.menuOpts;
        return _this;
    }
    EditorAction.prototype.register = function () {
        if (this.menuOpts) {
            __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["d" /* MenuRegistry */].appendMenuItem(__WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["b" /* MenuId */].EditorContext, {
                command: {
                    id: this.id,
                    title: this.label
                },
                when: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(this.precondition, this.menuOpts.when),
                group: this.menuOpts.group,
                order: this.menuOpts.order
            });
        }
        _super.prototype.register.call(this);
    };
    EditorAction.prototype.runEditorCommand = function (accessor, editor, args) {
        this.reportTelemetry(accessor, editor);
        return this.run(accessor, editor, args || {});
    };
    EditorAction.prototype.reportTelemetry = function (accessor, editor) {
        /* __GDPR__
            "editorActionInvoked" : {
                "name" : { "classification": "SystemMetaData", "purpose": "FeatureInsight" },
                "id": { "classification": "SystemMetaData", "purpose": "FeatureInsight" },
                "${include}": [
                    "${EditorTelemetryData}"
                ]
            }
        */
        accessor.get(__WEBPACK_IMPORTED_MODULE_5__platform_telemetry_common_telemetry_js__["a" /* ITelemetryService */]).publicLog('editorActionInvoked', __assign({ name: this.label, id: this.id }, editor.getTelemetryData()));
    };
    return EditorAction;
}(EditorCommand));

//#endregion EditorAction
// --- Registration of commands and actions
function registerLanguageCommand(id, handler) {
    __WEBPACK_IMPORTED_MODULE_2__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand(id, function (accessor, args) { return handler(accessor, args || {}); });
}
function registerDefaultLanguageCommand(id, handler) {
    registerLanguageCommand(id, function (accessor, args) {
        var resource = args.resource, position = args.position;
        if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */])) {
            throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('resource');
        }
        if (!__WEBPACK_IMPORTED_MODULE_6__common_core_position_js__["a" /* Position */].isIPosition(position)) {
            throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('position');
        }
        var model = accessor.get(__WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
        if (!model) {
            throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('Can not find open model for ' + resource);
        }
        var editorPosition = __WEBPACK_IMPORTED_MODULE_6__common_core_position_js__["a" /* Position */].lift(position);
        return handler(model, editorPosition, args);
    });
}
function registerEditorCommand(editorCommand) {
    EditorContributionRegistry.INSTANCE.registerEditorCommand(editorCommand);
    return editorCommand;
}
function registerEditorAction(ctor) {
    EditorContributionRegistry.INSTANCE.registerEditorAction(new ctor());
}
function registerInstantiatedEditorAction(editorAction) {
    EditorContributionRegistry.INSTANCE.registerEditorAction(editorAction);
}
function registerEditorContribution(ctor) {
    EditorContributionRegistry.INSTANCE.registerEditorContribution(ctor);
}
var EditorExtensionsRegistry;
(function (EditorExtensionsRegistry) {
    function getEditorCommand(commandId) {
        return EditorContributionRegistry.INSTANCE.getEditorCommand(commandId);
    }
    EditorExtensionsRegistry.getEditorCommand = getEditorCommand;
    function getEditorActions() {
        return EditorContributionRegistry.INSTANCE.getEditorActions();
    }
    EditorExtensionsRegistry.getEditorActions = getEditorActions;
    function getEditorContributions() {
        return EditorContributionRegistry.INSTANCE.getEditorContributions();
    }
    EditorExtensionsRegistry.getEditorContributions = getEditorContributions;
})(EditorExtensionsRegistry || (EditorExtensionsRegistry = {}));
// Editor extension points
var Extensions = {
    EditorCommonContributions: 'editor.contributions'
};
var EditorContributionRegistry = /** @class */ (function () {
    function EditorContributionRegistry() {
        this.editorContributions = [];
        this.editorActions = [];
        this.editorCommands = Object.create(null);
    }
    EditorContributionRegistry.prototype.registerEditorContribution = function (ctor) {
        this.editorContributions.push(ctor);
    };
    EditorContributionRegistry.prototype.registerEditorAction = function (action) {
        action.register();
        this.editorActions.push(action);
    };
    EditorContributionRegistry.prototype.getEditorContributions = function () {
        return this.editorContributions.slice(0);
    };
    EditorContributionRegistry.prototype.getEditorActions = function () {
        return this.editorActions.slice(0);
    };
    EditorContributionRegistry.prototype.registerEditorCommand = function (editorCommand) {
        editorCommand.register();
        this.editorCommands[editorCommand.id] = editorCommand;
    };
    EditorContributionRegistry.prototype.getEditorCommand = function (commandId) {
        return (this.editorCommands[commandId] || null);
    };
    EditorContributionRegistry.INSTANCE = new EditorContributionRegistry();
    return EditorContributionRegistry;
}());
__WEBPACK_IMPORTED_MODULE_4__platform_registry_common_platform_js__["a" /* Registry */].add(Extensions.EditorCommonContributions, EditorContributionRegistry.INSTANCE);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Promise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TPromise; });
/* unused harmony export PPromise */
/**
 * Extracted from https://github.com/winjs/winjs
 * Version: 4.4.0(ec3258a9f3a36805a187848984e3bb938044178d)
 * Copyright (c) Microsoft Corporation.
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
var __winjs_exports;

(function() {

var _modules = Object.create(null);//{};
_modules["WinJS/Core/_WinJS"] = {};

var _winjs = function(moduleId, deps, factory) {
    var exports = {};
    var exportsPassedIn = false;

    var depsValues = deps.map(function(dep) {
        if (dep === 'exports') {
            exportsPassedIn = true;
            return exports;
        }
        return _modules[dep];
    });

    var result = factory.apply({}, depsValues);

    _modules[moduleId] = exportsPassedIn ? exports : result;
};


_winjs("WinJS/Core/_Global", [], function () {
    "use strict";

    // Appease jshint
    /* global window, self, global */

    var globalObject =
        typeof window !== 'undefined' ? window :
        typeof self !== 'undefined' ? self :
        typeof global !== 'undefined' ? global :
        {};
    return globalObject;
});

_winjs("WinJS/Core/_BaseCoreUtils", ["WinJS/Core/_Global"], function baseCoreUtilsInit(_Global) {
    "use strict";

    var hasWinRT = !!_Global.Windows;

    function markSupportedForProcessing(func) {
        /// <signature helpKeyword="WinJS.Utilities.markSupportedForProcessing">
        /// <summary locid="WinJS.Utilities.markSupportedForProcessing">
        /// Marks a function as being compatible with declarative processing, such as WinJS.UI.processAll
        /// or WinJS.Binding.processAll.
        /// </summary>
        /// <param name="func" type="Function" locid="WinJS.Utilities.markSupportedForProcessing_p:func">
        /// The function to be marked as compatible with declarative processing.
        /// </param>
        /// <returns type="Function" locid="WinJS.Utilities.markSupportedForProcessing_returnValue">
        /// The input function.
        /// </returns>
        /// </signature>
        func.supportedForProcessing = true;
        return func;
    }

    var actualSetImmediate = null;

    return {
        hasWinRT: hasWinRT,
        markSupportedForProcessing: markSupportedForProcessing,
        _setImmediate: function (callback) {
            // BEGIN monaco change
            if (actualSetImmediate === null) {
                if (_Global.setImmediate) {
                    actualSetImmediate = _Global.setImmediate.bind(_Global);
                } else if (typeof process !== 'undefined' && typeof process.nextTick === 'function') {
                    actualSetImmediate = process.nextTick.bind(process);
                } else {
                    actualSetImmediate = _Global.setTimeout.bind(_Global);
                }
            }
            actualSetImmediate(callback);
            // END monaco change
        }
    };
});
_winjs("WinJS/Core/_WriteProfilerMark", ["WinJS/Core/_Global"], function profilerInit(_Global) {
    "use strict";

    return _Global.msWriteProfilerMark || function () { };
});
_winjs("WinJS/Core/_Base", ["WinJS/Core/_WinJS","WinJS/Core/_Global","WinJS/Core/_BaseCoreUtils","WinJS/Core/_WriteProfilerMark"], function baseInit(_WinJS, _Global, _BaseCoreUtils, _WriteProfilerMark) {
    "use strict";

    function initializeProperties(target, members, prefix) {
        var keys = Object.keys(members);
        var isArray = Array.isArray(target);
        var properties;
        var i, len;
        for (i = 0, len = keys.length; i < len; i++) {
            var key = keys[i];
            var enumerable = key.charCodeAt(0) !== /*_*/95;
            var member = members[key];
            if (member && typeof member === 'object') {
                if (member.value !== undefined || typeof member.get === 'function' || typeof member.set === 'function') {
                    if (member.enumerable === undefined) {
                        member.enumerable = enumerable;
                    }
                    if (prefix && member.setName && typeof member.setName === 'function') {
                        member.setName(prefix + "." + key);
                    }
                    properties = properties || {};
                    properties[key] = member;
                    continue;
                }
            }
            if (!enumerable) {
                properties = properties || {};
                properties[key] = { value: member, enumerable: enumerable, configurable: true, writable: true };
                continue;
            }
            if (isArray) {
                target.forEach(function (target) {
                    target[key] = member;
                });
            } else {
                target[key] = member;
            }
        }
        if (properties) {
            if (isArray) {
                target.forEach(function (target) {
                    Object.defineProperties(target, properties);
                });
            } else {
                Object.defineProperties(target, properties);
            }
        }
    }

    (function () {

        var _rootNamespace = _WinJS;
        if (!_rootNamespace.Namespace) {
            _rootNamespace.Namespace = Object.create(Object.prototype);
        }

        function createNamespace(parentNamespace, name) {
            var currentNamespace = parentNamespace || {};
            if (name) {
                var namespaceFragments = name.split(".");
                if (currentNamespace === _Global && namespaceFragments[0] === "WinJS") {
                    currentNamespace = _WinJS;
                    namespaceFragments.splice(0, 1);
                }
                for (var i = 0, len = namespaceFragments.length; i < len; i++) {
                    var namespaceName = namespaceFragments[i];
                    if (!currentNamespace[namespaceName]) {
                        Object.defineProperty(currentNamespace, namespaceName,
                            { value: {}, writable: false, enumerable: true, configurable: true }
                        );
                    }
                    currentNamespace = currentNamespace[namespaceName];
                }
            }
            return currentNamespace;
        }

        function defineWithParent(parentNamespace, name, members) {
            /// <signature helpKeyword="WinJS.Namespace.defineWithParent">
            /// <summary locid="WinJS.Namespace.defineWithParent">
            /// Defines a new namespace with the specified name under the specified parent namespace.
            /// </summary>
            /// <param name="parentNamespace" type="Object" locid="WinJS.Namespace.defineWithParent_p:parentNamespace">
            /// The parent namespace.
            /// </param>
            /// <param name="name" type="String" locid="WinJS.Namespace.defineWithParent_p:name">
            /// The name of the new namespace.
            /// </param>
            /// <param name="members" type="Object" locid="WinJS.Namespace.defineWithParent_p:members">
            /// The members of the new namespace.
            /// </param>
            /// <returns type="Object" locid="WinJS.Namespace.defineWithParent_returnValue">
            /// The newly-defined namespace.
            /// </returns>
            /// </signature>
            var currentNamespace = createNamespace(parentNamespace, name);

            if (members) {
                initializeProperties(currentNamespace, members, name || "<ANONYMOUS>");
            }

            return currentNamespace;
        }

        function define(name, members) {
            /// <signature helpKeyword="WinJS.Namespace.define">
            /// <summary locid="WinJS.Namespace.define">
            /// Defines a new namespace with the specified name.
            /// </summary>
            /// <param name="name" type="String" locid="WinJS.Namespace.define_p:name">
            /// The name of the namespace. This could be a dot-separated name for nested namespaces.
            /// </param>
            /// <param name="members" type="Object" locid="WinJS.Namespace.define_p:members">
            /// The members of the new namespace.
            /// </param>
            /// <returns type="Object" locid="WinJS.Namespace.define_returnValue">
            /// The newly-defined namespace.
            /// </returns>
            /// </signature>
            return defineWithParent(_Global, name, members);
        }

        var LazyStates = {
            uninitialized: 1,
            working: 2,
            initialized: 3,
        };

        function lazy(f) {
            var name;
            var state = LazyStates.uninitialized;
            var result;
            return {
                setName: function (value) {
                    name = value;
                },
                get: function () {
                    switch (state) {
                        case LazyStates.initialized:
                            return result;

                        case LazyStates.uninitialized:
                            state = LazyStates.working;
                            try {
                                _WriteProfilerMark("WinJS.Namespace._lazy:" + name + ",StartTM");
                                result = f();
                            } finally {
                                _WriteProfilerMark("WinJS.Namespace._lazy:" + name + ",StopTM");
                                state = LazyStates.uninitialized;
                            }
                            f = null;
                            state = LazyStates.initialized;
                            return result;

                        case LazyStates.working:
                            throw "Illegal: reentrancy on initialization";

                        default:
                            throw "Illegal";
                    }
                },
                set: function (value) {
                    switch (state) {
                        case LazyStates.working:
                            throw "Illegal: reentrancy on initialization";

                        default:
                            state = LazyStates.initialized;
                            result = value;
                            break;
                    }
                },
                enumerable: true,
                configurable: true,
            };
        }

        // helper for defining AMD module members
        function moduleDefine(exports, name, members) {
            var target = [exports];
            var publicNS = null;
            if (name) {
                publicNS = createNamespace(_Global, name);
                target.push(publicNS);
            }
            initializeProperties(target, members, name || "<ANONYMOUS>");
            return publicNS;
        }

        // Establish members of the "WinJS.Namespace" namespace
        Object.defineProperties(_rootNamespace.Namespace, {

            defineWithParent: { value: defineWithParent, writable: true, enumerable: true, configurable: true },

            define: { value: define, writable: true, enumerable: true, configurable: true },

            _lazy: { value: lazy, writable: true, enumerable: true, configurable: true },

            _moduleDefine: { value: moduleDefine, writable: true, enumerable: true, configurable: true }

        });

    })();

    (function () {

        function define(constructor, instanceMembers, staticMembers) {
            /// <signature helpKeyword="WinJS.Class.define">
            /// <summary locid="WinJS.Class.define">
            /// Defines a class using the given constructor and the specified instance members.
            /// </summary>
            /// <param name="constructor" type="Function" locid="WinJS.Class.define_p:constructor">
            /// A constructor function that is used to instantiate this class.
            /// </param>
            /// <param name="instanceMembers" type="Object" locid="WinJS.Class.define_p:instanceMembers">
            /// The set of instance fields, properties, and methods made available on the class.
            /// </param>
            /// <param name="staticMembers" type="Object" locid="WinJS.Class.define_p:staticMembers">
            /// The set of static fields, properties, and methods made available on the class.
            /// </param>
            /// <returns type="Function" locid="WinJS.Class.define_returnValue">
            /// The newly-defined class.
            /// </returns>
            /// </signature>
            constructor = constructor || function () { };
            _BaseCoreUtils.markSupportedForProcessing(constructor);
            if (instanceMembers) {
                initializeProperties(constructor.prototype, instanceMembers);
            }
            if (staticMembers) {
                initializeProperties(constructor, staticMembers);
            }
            return constructor;
        }

        function derive(baseClass, constructor, instanceMembers, staticMembers) {
            /// <signature helpKeyword="WinJS.Class.derive">
            /// <summary locid="WinJS.Class.derive">
            /// Creates a sub-class based on the supplied baseClass parameter, using prototypal inheritance.
            /// </summary>
            /// <param name="baseClass" type="Function" locid="WinJS.Class.derive_p:baseClass">
            /// The class to inherit from.
            /// </param>
            /// <param name="constructor" type="Function" locid="WinJS.Class.derive_p:constructor">
            /// A constructor function that is used to instantiate this class.
            /// </param>
            /// <param name="instanceMembers" type="Object" locid="WinJS.Class.derive_p:instanceMembers">
            /// The set of instance fields, properties, and methods to be made available on the class.
            /// </param>
            /// <param name="staticMembers" type="Object" locid="WinJS.Class.derive_p:staticMembers">
            /// The set of static fields, properties, and methods to be made available on the class.
            /// </param>
            /// <returns type="Function" locid="WinJS.Class.derive_returnValue">
            /// The newly-defined class.
            /// </returns>
            /// </signature>
            if (baseClass) {
                constructor = constructor || function () { };
                var basePrototype = baseClass.prototype;
                constructor.prototype = Object.create(basePrototype);
                _BaseCoreUtils.markSupportedForProcessing(constructor);
                Object.defineProperty(constructor.prototype, "constructor", { value: constructor, writable: true, configurable: true, enumerable: true });
                if (instanceMembers) {
                    initializeProperties(constructor.prototype, instanceMembers);
                }
                if (staticMembers) {
                    initializeProperties(constructor, staticMembers);
                }
                return constructor;
            } else {
                return define(constructor, instanceMembers, staticMembers);
            }
        }

        function mix(constructor) {
            /// <signature helpKeyword="WinJS.Class.mix">
            /// <summary locid="WinJS.Class.mix">
            /// Defines a class using the given constructor and the union of the set of instance members
            /// specified by all the mixin objects. The mixin parameter list is of variable length.
            /// </summary>
            /// <param name="constructor" locid="WinJS.Class.mix_p:constructor">
            /// A constructor function that is used to instantiate this class.
            /// </param>
            /// <returns type="Function" locid="WinJS.Class.mix_returnValue">
            /// The newly-defined class.
            /// </returns>
            /// </signature>
            constructor = constructor || function () { };
            var i, len;
            for (i = 1, len = arguments.length; i < len; i++) {
                initializeProperties(constructor.prototype, arguments[i]);
            }
            return constructor;
        }

        // Establish members of "WinJS.Class" namespace
        _WinJS.Namespace.define("WinJS.Class", {
            define: define,
            derive: derive,
            mix: mix
        });

    })();

    return {
        Namespace: _WinJS.Namespace,
        Class: _WinJS.Class
    };

});
_winjs("WinJS/Core/_ErrorFromName", ["WinJS/Core/_Base"], function errorsInit(_Base) {
    "use strict";

    var ErrorFromName = _Base.Class.derive(Error, function (name, message) {
        /// <signature helpKeyword="WinJS.ErrorFromName">
        /// <summary locid="WinJS.ErrorFromName">
        /// Creates an Error object with the specified name and message properties.
        /// </summary>
        /// <param name="name" type="String" locid="WinJS.ErrorFromName_p:name">The name of this error. The name is meant to be consumed programmatically and should not be localized.</param>
        /// <param name="message" type="String" optional="true" locid="WinJS.ErrorFromName_p:message">The message for this error. The message is meant to be consumed by humans and should be localized.</param>
        /// <returns type="Error" locid="WinJS.ErrorFromName_returnValue">Error instance with .name and .message properties populated</returns>
        /// </signature>
        this.name = name;
        this.message = message || name;
    }, {
        /* empty */
    }, {
        supportedForProcessing: false,
    });

    _Base.Namespace.define("WinJS", {
        // ErrorFromName establishes a simple pattern for returning error codes.
        //
        ErrorFromName: ErrorFromName
    });

    return ErrorFromName;

});


_winjs("WinJS/Core/_Events", ["exports","WinJS/Core/_Base"], function eventsInit(exports, _Base) {
    "use strict";


    function createEventProperty(name) {
        var eventPropStateName = "_on" + name + "state";

        return {
            get: function () {
                var state = this[eventPropStateName];
                return state && state.userHandler;
            },
            set: function (handler) {
                var state = this[eventPropStateName];
                if (handler) {
                    if (!state) {
                        state = { wrapper: function (evt) { return state.userHandler(evt); }, userHandler: handler };
                        Object.defineProperty(this, eventPropStateName, { value: state, enumerable: false, writable:true, configurable: true });
                        this.addEventListener(name, state.wrapper, false);
                    }
                    state.userHandler = handler;
                } else if (state) {
                    this.removeEventListener(name, state.wrapper, false);
                    this[eventPropStateName] = null;
                }
            },
            enumerable: true
        };
    }

    function createEventProperties() {
        /// <signature helpKeyword="WinJS.Utilities.createEventProperties">
        /// <summary locid="WinJS.Utilities.createEventProperties">
        /// Creates an object that has one property for each name passed to the function.
        /// </summary>
        /// <param name="events" locid="WinJS.Utilities.createEventProperties_p:events">
        /// A variable list of property names.
        /// </param>
        /// <returns type="Object" locid="WinJS.Utilities.createEventProperties_returnValue">
        /// The object with the specified properties. The names of the properties are prefixed with 'on'.
        /// </returns>
        /// </signature>
        var props = {};
        for (var i = 0, len = arguments.length; i < len; i++) {
            var name = arguments[i];
            props["on" + name] = createEventProperty(name);
        }
        return props;
    }

    var EventMixinEvent = _Base.Class.define(
        function EventMixinEvent_ctor(type, detail, target) {
            this.detail = detail;
            this.target = target;
            this.timeStamp = Date.now();
            this.type = type;
        },
        {
            bubbles: { value: false, writable: false },
            cancelable: { value: false, writable: false },
            currentTarget: {
                get: function () { return this.target; }
            },
            defaultPrevented: {
                get: function () { return this._preventDefaultCalled; }
            },
            trusted: { value: false, writable: false },
            eventPhase: { value: 0, writable: false },
            target: null,
            timeStamp: null,
            type: null,

            preventDefault: function () {
                this._preventDefaultCalled = true;
            },
            stopImmediatePropagation: function () {
                this._stopImmediatePropagationCalled = true;
            },
            stopPropagation: function () {
            }
        }, {
            supportedForProcessing: false,
        }
    );

    var eventMixin = {
        _listeners: null,

        addEventListener: function (type, listener, useCapture) {
            /// <signature helpKeyword="WinJS.Utilities.eventMixin.addEventListener">
            /// <summary locid="WinJS.Utilities.eventMixin.addEventListener">
            /// Adds an event listener to the control.
            /// </summary>
            /// <param name="type" locid="WinJS.Utilities.eventMixin.addEventListener_p:type">
            /// The type (name) of the event.
            /// </param>
            /// <param name="listener" locid="WinJS.Utilities.eventMixin.addEventListener_p:listener">
            /// The listener to invoke when the event is raised.
            /// </param>
            /// <param name="useCapture" locid="WinJS.Utilities.eventMixin.addEventListener_p:useCapture">
            /// if true initiates capture, otherwise false.
            /// </param>
            /// </signature>
            useCapture = useCapture || false;
            this._listeners = this._listeners || {};
            var eventListeners = (this._listeners[type] = this._listeners[type] || []);
            for (var i = 0, len = eventListeners.length; i < len; i++) {
                var l = eventListeners[i];
                if (l.useCapture === useCapture && l.listener === listener) {
                    return;
                }
            }
            eventListeners.push({ listener: listener, useCapture: useCapture });
        },
        dispatchEvent: function (type, details) {
            /// <signature helpKeyword="WinJS.Utilities.eventMixin.dispatchEvent">
            /// <summary locid="WinJS.Utilities.eventMixin.dispatchEvent">
            /// Raises an event of the specified type and with the specified additional properties.
            /// </summary>
            /// <param name="type" locid="WinJS.Utilities.eventMixin.dispatchEvent_p:type">
            /// The type (name) of the event.
            /// </param>
            /// <param name="details" locid="WinJS.Utilities.eventMixin.dispatchEvent_p:details">
            /// The set of additional properties to be attached to the event object when the event is raised.
            /// </param>
            /// <returns type="Boolean" locid="WinJS.Utilities.eventMixin.dispatchEvent_returnValue">
            /// true if preventDefault was called on the event.
            /// </returns>
            /// </signature>
            var listeners = this._listeners && this._listeners[type];
            if (listeners) {
                var eventValue = new EventMixinEvent(type, details, this);
                // Need to copy the array to protect against people unregistering while we are dispatching
                listeners = listeners.slice(0, listeners.length);
                for (var i = 0, len = listeners.length; i < len && !eventValue._stopImmediatePropagationCalled; i++) {
                    listeners[i].listener(eventValue);
                }
                return eventValue.defaultPrevented || false;
            }
            return false;
        },
        removeEventListener: function (type, listener, useCapture) {
            /// <signature helpKeyword="WinJS.Utilities.eventMixin.removeEventListener">
            /// <summary locid="WinJS.Utilities.eventMixin.removeEventListener">
            /// Removes an event listener from the control.
            /// </summary>
            /// <param name="type" locid="WinJS.Utilities.eventMixin.removeEventListener_p:type">
            /// The type (name) of the event.
            /// </param>
            /// <param name="listener" locid="WinJS.Utilities.eventMixin.removeEventListener_p:listener">
            /// The listener to remove.
            /// </param>
            /// <param name="useCapture" locid="WinJS.Utilities.eventMixin.removeEventListener_p:useCapture">
            /// Specifies whether to initiate capture.
            /// </param>
            /// </signature>
            useCapture = useCapture || false;
            var listeners = this._listeners && this._listeners[type];
            if (listeners) {
                for (var i = 0, len = listeners.length; i < len; i++) {
                    var l = listeners[i];
                    if (l.listener === listener && l.useCapture === useCapture) {
                        listeners.splice(i, 1);
                        if (listeners.length === 0) {
                            delete this._listeners[type];
                        }
                        // Only want to remove one element for each call to removeEventListener
                        break;
                    }
                }
            }
        }
    };

    _Base.Namespace._moduleDefine(exports, "WinJS.Utilities", {
        _createEventProperty: createEventProperty,
        createEventProperties: createEventProperties,
        eventMixin: eventMixin
    });

});


_winjs("WinJS/Core/_Trace", ["WinJS/Core/_Global"], function traceInit(_Global) {
    "use strict";

    function nop(v) {
        return v;
    }

    return {
        _traceAsyncOperationStarting: (_Global.Debug && _Global.Debug.msTraceAsyncOperationStarting && _Global.Debug.msTraceAsyncOperationStarting.bind(_Global.Debug)) || nop,
        _traceAsyncOperationCompleted: (_Global.Debug && _Global.Debug.msTraceAsyncOperationCompleted && _Global.Debug.msTraceAsyncOperationCompleted.bind(_Global.Debug)) || nop,
        _traceAsyncCallbackStarting: (_Global.Debug && _Global.Debug.msTraceAsyncCallbackStarting && _Global.Debug.msTraceAsyncCallbackStarting.bind(_Global.Debug)) || nop,
        _traceAsyncCallbackCompleted: (_Global.Debug && _Global.Debug.msTraceAsyncCallbackCompleted && _Global.Debug.msTraceAsyncCallbackCompleted.bind(_Global.Debug)) || nop
    };
});
_winjs("WinJS/Promise/_StateMachine", ["WinJS/Core/_Global","WinJS/Core/_BaseCoreUtils","WinJS/Core/_Base","WinJS/Core/_ErrorFromName","WinJS/Core/_Events","WinJS/Core/_Trace"], function promiseStateMachineInit(_Global, _BaseCoreUtils, _Base, _ErrorFromName, _Events, _Trace) {
    "use strict";

    _Global.Debug && (_Global.Debug.setNonUserCodeExceptions = true);

    var ListenerType = _Base.Class.mix(_Base.Class.define(null, { /*empty*/ }, { supportedForProcessing: false }), _Events.eventMixin);
    var promiseEventListeners = new ListenerType();
    // make sure there is a listeners collection so that we can do a more trivial check below
    promiseEventListeners._listeners = {};
    var errorET = "error";
    var canceledName = "Canceled";
    var tagWithStack = false;
    var tag = {
        promise: 0x01,
        thenPromise: 0x02,
        errorPromise: 0x04,
        exceptionPromise: 0x08,
        completePromise: 0x10,
    };
    tag.all = tag.promise | tag.thenPromise | tag.errorPromise | tag.exceptionPromise | tag.completePromise;

    //
    // Global error counter, for each error which enters the system we increment this once and then
    // the error number travels with the error as it traverses the tree of potential handlers.
    //
    // When someone has registered to be told about errors (WinJS.Promise.callonerror) promises
    // which are in error will get tagged with a ._errorId field. This tagged field is the
    // contract by which nested promises with errors will be identified as chaining for the
    // purposes of the callonerror semantics. If a nested promise in error is encountered without
    // a ._errorId it will be assumed to be foreign and treated as an interop boundary and
    // a new error id will be minted.
    //
    var error_number = 1;

    //
    // The state machine has a interesting hiccup in it with regards to notification, in order
    // to flatten out notification and avoid recursion for synchronous completion we have an
    // explicit set of *_notify states which are responsible for notifying their entire tree
    // of children. They can do this because they know that immediate children are always
    // ThenPromise instances and we can therefore reach into their state to access the
    // _listeners collection.
    //
    // So, what happens is that a Promise will be fulfilled through the _completed or _error
    // messages at which point it will enter a *_notify state and be responsible for to move
    // its children into an (as appropriate) success or error state and also notify that child's
    // listeners of the state transition, until leaf notes are reached.
    //

    var state_created,              // -> working
        state_working,              // -> error | error_notify | success | success_notify | canceled | waiting
        state_waiting,              // -> error | error_notify | success | success_notify | waiting_canceled
        state_waiting_canceled,     // -> error | error_notify | success | success_notify | canceling
        state_canceled,             // -> error | error_notify | success | success_notify | canceling
        state_canceling,            // -> error_notify
        state_success_notify,       // -> success
        state_success,              // -> .
        state_error_notify,         // -> error
        state_error;                // -> .

    // Noop function, used in the various states to indicate that they don't support a given
    // message. Named with the somewhat cute name '_' because it reads really well in the states.

    function _() { }

    // Initial state
    //
    state_created = {
        name: "created",
        enter: function (promise) {
            promise._setState(state_working);
        },
        cancel: _,
        done: _,
        then: _,
        _completed: _,
        _error: _,
        _notify: _,
        _progress: _,
        _setCompleteValue: _,
        _setErrorValue: _
    };

    // Ready state, waiting for a message (completed/error/progress), able to be canceled
    //
    state_working = {
        name: "working",
        enter: _,
        cancel: function (promise) {
            promise._setState(state_canceled);
        },
        done: done,
        then: then,
        _completed: completed,
        _error: error,
        _notify: _,
        _progress: progress,
        _setCompleteValue: setCompleteValue,
        _setErrorValue: setErrorValue
    };

    // Waiting state, if a promise is completed with a value which is itself a promise
    // (has a then() method) it signs up to be informed when that child promise is
    // fulfilled at which point it will be fulfilled with that value.
    //
    state_waiting = {
        name: "waiting",
        enter: function (promise) {
            var waitedUpon = promise._value;
            // We can special case our own intermediate promises which are not in a
            //  terminal state by just pushing this promise as a listener without
            //  having to create new indirection functions
            if (waitedUpon instanceof ThenPromise &&
                waitedUpon._state !== state_error &&
                waitedUpon._state !== state_success) {
                pushListener(waitedUpon, { promise: promise });
            } else {
                var error = function (value) {
                    if (waitedUpon._errorId) {
                        promise._chainedError(value, waitedUpon);
                    } else {
                        // Because this is an interop boundary we want to indicate that this
                        //  error has been handled by the promise infrastructure before we
                        //  begin a new handling chain.
                        //
                        callonerror(promise, value, detailsForHandledError, waitedUpon, error);
                        promise._error(value);
                    }
                };
                error.handlesOnError = true;
                waitedUpon.then(
                    promise._completed.bind(promise),
                    error,
                    promise._progress.bind(promise)
                );
            }
        },
        cancel: function (promise) {
            promise._setState(state_waiting_canceled);
        },
        done: done,
        then: then,
        _completed: completed,
        _error: error,
        _notify: _,
        _progress: progress,
        _setCompleteValue: setCompleteValue,
        _setErrorValue: setErrorValue
    };

    // Waiting canceled state, when a promise has been in a waiting state and receives a
    // request to cancel its pending work it will forward that request to the child promise
    // and then waits to be informed of the result. This promise moves itself into the
    // canceling state but understands that the child promise may instead push it to a
    // different state.
    //
    state_waiting_canceled = {
        name: "waiting_canceled",
        enter: function (promise) {
            // Initiate a transition to canceling. Triggering a cancel on the promise
            // that we are waiting upon may result in a different state transition
            // before the state machine pump runs again.
            promise._setState(state_canceling);
            var waitedUpon = promise._value;
            if (waitedUpon.cancel) {
                waitedUpon.cancel();
            }
        },
        cancel: _,
        done: done,
        then: then,
        _completed: completed,
        _error: error,
        _notify: _,
        _progress: progress,
        _setCompleteValue: setCompleteValue,
        _setErrorValue: setErrorValue
    };

    // Canceled state, moves to the canceling state and then tells the promise to do
    // whatever it might need to do on cancelation.
    //
    state_canceled = {
        name: "canceled",
        enter: function (promise) {
            // Initiate a transition to canceling. The _cancelAction may change the state
            // before the state machine pump runs again.
            promise._setState(state_canceling);
            promise._cancelAction();
        },
        cancel: _,
        done: done,
        then: then,
        _completed: completed,
        _error: error,
        _notify: _,
        _progress: progress,
        _setCompleteValue: setCompleteValue,
        _setErrorValue: setErrorValue
    };

    // Canceling state, commits to the promise moving to an error state with an error
    // object whose 'name' and 'message' properties contain the string "Canceled"
    //
    state_canceling = {
        name: "canceling",
        enter: function (promise) {
            var error = new Error(canceledName);
            error.name = error.message;
            promise._value = error;
            promise._setState(state_error_notify);
        },
        cancel: _,
        done: _,
        then: _,
        _completed: _,
        _error: _,
        _notify: _,
        _progress: _,
        _setCompleteValue: _,
        _setErrorValue: _
    };

    // Success notify state, moves a promise to the success state and notifies all children
    //
    state_success_notify = {
        name: "complete_notify",
        enter: function (promise) {
            promise.done = CompletePromise.prototype.done;
            promise.then = CompletePromise.prototype.then;
            if (promise._listeners) {
                var queue = [promise];
                var p;
                while (queue.length) {
                    p = queue.shift();
                    p._state._notify(p, queue);
                }
            }
            promise._setState(state_success);
        },
        cancel: _,
        done: null, /*error to get here */
        then: null, /*error to get here */
        _completed: _,
        _error: _,
        _notify: notifySuccess,
        _progress: _,
        _setCompleteValue: _,
        _setErrorValue: _
    };

    // Success state, moves a promise to the success state and does NOT notify any children.
    // Some upstream promise is owning the notification pass.
    //
    state_success = {
        name: "success",
        enter: function (promise) {
            promise.done = CompletePromise.prototype.done;
            promise.then = CompletePromise.prototype.then;
            promise._cleanupAction();
        },
        cancel: _,
        done: null, /*error to get here */
        then: null, /*error to get here */
        _completed: _,
        _error: _,
        _notify: notifySuccess,
        _progress: _,
        _setCompleteValue: _,
        _setErrorValue: _
    };

    // Error notify state, moves a promise to the error state and notifies all children
    //
    state_error_notify = {
        name: "error_notify",
        enter: function (promise) {
            promise.done = ErrorPromise.prototype.done;
            promise.then = ErrorPromise.prototype.then;
            if (promise._listeners) {
                var queue = [promise];
                var p;
                while (queue.length) {
                    p = queue.shift();
                    p._state._notify(p, queue);
                }
            }
            promise._setState(state_error);
        },
        cancel: _,
        done: null, /*error to get here*/
        then: null, /*error to get here*/
        _completed: _,
        _error: _,
        _notify: notifyError,
        _progress: _,
        _setCompleteValue: _,
        _setErrorValue: _
    };

    // Error state, moves a promise to the error state and does NOT notify any children.
    // Some upstream promise is owning the notification pass.
    //
    state_error = {
        name: "error",
        enter: function (promise) {
            promise.done = ErrorPromise.prototype.done;
            promise.then = ErrorPromise.prototype.then;
            promise._cleanupAction();
        },
        cancel: _,
        done: null, /*error to get here*/
        then: null, /*error to get here*/
        _completed: _,
        _error: _,
        _notify: notifyError,
        _progress: _,
        _setCompleteValue: _,
        _setErrorValue: _
    };

    //
    // The statemachine implementation follows a very particular pattern, the states are specified
    // as static stateless bags of functions which are then indirected through the state machine
    // instance (a Promise). As such all of the functions on each state have the promise instance
    // passed to them explicitly as a parameter and the Promise instance members do a little
    // dance where they indirect through the state and insert themselves in the argument list.
    //
    // We could instead call directly through the promise states however then every caller
    // would have to remember to do things like pumping the state machine to catch state transitions.
    //

    var PromiseStateMachine = _Base.Class.define(null, {
        _listeners: null,
        _nextState: null,
        _state: null,
        _value: null,

        cancel: function () {
            /// <signature helpKeyword="WinJS.PromiseStateMachine.cancel">
            /// <summary locid="WinJS.PromiseStateMachine.cancel">
            /// Attempts to cancel the fulfillment of a promised value. If the promise hasn't
            /// already been fulfilled and cancellation is supported, the promise enters
            /// the error state with a value of Error("Canceled").
            /// </summary>
            /// </signature>
            this._state.cancel(this);
            this._run();
        },
        done: function Promise_done(onComplete, onError, onProgress) {
            /// <signature helpKeyword="WinJS.PromiseStateMachine.done">
            /// <summary locid="WinJS.PromiseStateMachine.done">
            /// Allows you to specify the work to be done on the fulfillment of the promised value,
            /// the error handling to be performed if the promise fails to fulfill
            /// a value, and the handling of progress notifications along the way.
            ///
            /// After the handlers have finished executing, this function throws any error that would have been returned
            /// from then() as a promise in the error state.
            /// </summary>
            /// <param name='onComplete' type='Function' locid="WinJS.PromiseStateMachine.done_p:onComplete">
            /// The function to be called if the promise is fulfilled successfully with a value.
            /// The fulfilled value is passed as the single argument. If the value is null,
            /// the fulfilled value is returned. The value returned
            /// from the function becomes the fulfilled value of the promise returned by
            /// then(). If an exception is thrown while executing the function, the promise returned
            /// by then() moves into the error state.
            /// </param>
            /// <param name='onError' type='Function' optional='true' locid="WinJS.PromiseStateMachine.done_p:onError">
            /// The function to be called if the promise is fulfilled with an error. The error
            /// is passed as the single argument. If it is null, the error is forwarded.
            /// The value returned from the function is the fulfilled value of the promise returned by then().
            /// </param>
            /// <param name='onProgress' type='Function' optional='true' locid="WinJS.PromiseStateMachine.done_p:onProgress">
            /// the function to be called if the promise reports progress. Data about the progress
            /// is passed as the single argument. Promises are not required to support
            /// progress.
            /// </param>
            /// </signature>
            this._state.done(this, onComplete, onError, onProgress);
        },
        then: function Promise_then(onComplete, onError, onProgress) {
            /// <signature helpKeyword="WinJS.PromiseStateMachine.then">
            /// <summary locid="WinJS.PromiseStateMachine.then">
            /// Allows you to specify the work to be done on the fulfillment of the promised value,
            /// the error handling to be performed if the promise fails to fulfill
            /// a value, and the handling of progress notifications along the way.
            /// </summary>
            /// <param name='onComplete' type='Function' locid="WinJS.PromiseStateMachine.then_p:onComplete">
            /// The function to be called if the promise is fulfilled successfully with a value.
            /// The value is passed as the single argument. If the value is null, the value is returned.
            /// The value returned from the function becomes the fulfilled value of the promise returned by
            /// then(). If an exception is thrown while this function is being executed, the promise returned
            /// by then() moves into the error state.
            /// </param>
            /// <param name='onError' type='Function' optional='true' locid="WinJS.PromiseStateMachine.then_p:onError">
            /// The function to be called if the promise is fulfilled with an error. The error
            /// is passed as the single argument. If it is null, the error is forwarded.
            /// The value returned from the function becomes the fulfilled value of the promise returned by then().
            /// </param>
            /// <param name='onProgress' type='Function' optional='true' locid="WinJS.PromiseStateMachine.then_p:onProgress">
            /// The function to be called if the promise reports progress. Data about the progress
            /// is passed as the single argument. Promises are not required to support
            /// progress.
            /// </param>
            /// <returns type="WinJS.Promise" locid="WinJS.PromiseStateMachine.then_returnValue">
            /// The promise whose value is the result of executing the complete or
            /// error function.
            /// </returns>
            /// </signature>
            // BEGIN monaco change
            if (this.then !== Promise_then) {
                this.then(onComplete, onError, onProgress);
                return;
            }
            // END monaco change
            return this._state.then(this, onComplete, onError, onProgress);
        },

        _chainedError: function (value, context) {
            var result = this._state._error(this, value, detailsForChainedError, context);
            this._run();
            return result;
        },
        _completed: function (value) {
            var result = this._state._completed(this, value);
            this._run();
            return result;
        },
        _error: function (value) {
            var result = this._state._error(this, value, detailsForError);
            this._run();
            return result;
        },
        _progress: function (value) {
            this._state._progress(this, value);
        },
        _setState: function (state) {
            this._nextState = state;
        },
        _setCompleteValue: function (value) {
            this._state._setCompleteValue(this, value);
            this._run();
        },
        _setChainedErrorValue: function (value, context) {
            var result = this._state._setErrorValue(this, value, detailsForChainedError, context);
            this._run();
            return result;
        },
        _setExceptionValue: function (value) {
            var result = this._state._setErrorValue(this, value, detailsForException);
            this._run();
            return result;
        },
        _run: function () {
            while (this._nextState) {
                this._state = this._nextState;
                this._nextState = null;
                this._state.enter(this);
            }
        }
    }, {
        supportedForProcessing: false
    });

    //
    // Implementations of shared state machine code.
    //

    function completed(promise, value) {
        var targetState;
        if (value && typeof value === "object" && typeof value.then === "function") {
            targetState = state_waiting;
        } else {
            targetState = state_success_notify;
        }
        promise._value = value;
        promise._setState(targetState);
    }
    function createErrorDetails(exception, error, promise, id, parent, handler) {
        return {
            exception: exception,
            error: error,
            promise: promise,
            handler: handler,
            id: id,
            parent: parent
        };
    }
    function detailsForHandledError(promise, errorValue, context, handler) {
        var exception = context._isException;
        var errorId = context._errorId;
        return createErrorDetails(
            exception ? errorValue : null,
            exception ? null : errorValue,
            promise,
            errorId,
            context,
            handler
        );
    }
    function detailsForChainedError(promise, errorValue, context) {
        var exception = context._isException;
        var errorId = context._errorId;
        setErrorInfo(promise, errorId, exception);
        return createErrorDetails(
            exception ? errorValue : null,
            exception ? null : errorValue,
            promise,
            errorId,
            context
        );
    }
    function detailsForError(promise, errorValue) {
        var errorId = ++error_number;
        setErrorInfo(promise, errorId);
        return createErrorDetails(
            null,
            errorValue,
            promise,
            errorId
        );
    }
    function detailsForException(promise, exceptionValue) {
        var errorId = ++error_number;
        setErrorInfo(promise, errorId, true);
        return createErrorDetails(
            exceptionValue,
            null,
            promise,
            errorId
        );
    }
    function done(promise, onComplete, onError, onProgress) {
        var asyncOpID = _Trace._traceAsyncOperationStarting("WinJS.Promise.done");
        pushListener(promise, { c: onComplete, e: onError, p: onProgress, asyncOpID: asyncOpID });
    }
    function error(promise, value, onerrorDetails, context) {
        promise._value = value;
        callonerror(promise, value, onerrorDetails, context);
        promise._setState(state_error_notify);
    }
    function notifySuccess(promise, queue) {
        var value = promise._value;
        var listeners = promise._listeners;
        if (!listeners) {
            return;
        }
        promise._listeners = null;
        var i, len;
        for (i = 0, len = Array.isArray(listeners) ? listeners.length : 1; i < len; i++) {
            var listener = len === 1 ? listeners : listeners[i];
            var onComplete = listener.c;
            var target = listener.promise;

            _Trace._traceAsyncOperationCompleted(listener.asyncOpID, _Global.Debug && _Global.Debug.MS_ASYNC_OP_STATUS_SUCCESS);

            if (target) {
                _Trace._traceAsyncCallbackStarting(listener.asyncOpID);
                try {
                    target._setCompleteValue(onComplete ? onComplete(value) : value);
                } catch (ex) {
                    target._setExceptionValue(ex);
                } finally {
                    _Trace._traceAsyncCallbackCompleted();
                }
                if (target._state !== state_waiting && target._listeners) {
                    queue.push(target);
                }
            } else {
                CompletePromise.prototype.done.call(promise, onComplete);
            }
        }
    }
    function notifyError(promise, queue) {
        var value = promise._value;
        var listeners = promise._listeners;
        if (!listeners) {
            return;
        }
        promise._listeners = null;
        var i, len;
        for (i = 0, len = Array.isArray(listeners) ? listeners.length : 1; i < len; i++) {
            var listener = len === 1 ? listeners : listeners[i];
            var onError = listener.e;
            var target = listener.promise;

            var errorID = _Global.Debug && (value && value.name === canceledName ? _Global.Debug.MS_ASYNC_OP_STATUS_CANCELED : _Global.Debug.MS_ASYNC_OP_STATUS_ERROR);
            _Trace._traceAsyncOperationCompleted(listener.asyncOpID, errorID);

            if (target) {
                var asyncCallbackStarted = false;
                try {
                    if (onError) {
                        _Trace._traceAsyncCallbackStarting(listener.asyncOpID);
                        asyncCallbackStarted = true;
                        if (!onError.handlesOnError) {
                            callonerror(target, value, detailsForHandledError, promise, onError);
                        }
                        target._setCompleteValue(onError(value));
                    } else {
                        target._setChainedErrorValue(value, promise);
                    }
                } catch (ex) {
                    target._setExceptionValue(ex);
                } finally {
                    if (asyncCallbackStarted) {
                        _Trace._traceAsyncCallbackCompleted();
                    }
                }
                if (target._state !== state_waiting && target._listeners) {
                    queue.push(target);
                }
            } else {
                ErrorPromise.prototype.done.call(promise, null, onError);
            }
        }
    }
    function callonerror(promise, value, onerrorDetailsGenerator, context, handler) {
        if (promiseEventListeners._listeners[errorET]) {
            if (value instanceof Error && value.message === canceledName) {
                return;
            }
            promiseEventListeners.dispatchEvent(errorET, onerrorDetailsGenerator(promise, value, context, handler));
        }
    }
    function progress(promise, value) {
        var listeners = promise._listeners;
        if (listeners) {
            var i, len;
            for (i = 0, len = Array.isArray(listeners) ? listeners.length : 1; i < len; i++) {
                var listener = len === 1 ? listeners : listeners[i];
                var onProgress = listener.p;
                if (onProgress) {
                    try { onProgress(value); } catch (ex) { }
                }
                if (!(listener.c || listener.e) && listener.promise) {
                    listener.promise._progress(value);
                }
            }
        }
    }
    function pushListener(promise, listener) {
        var listeners = promise._listeners;
        if (listeners) {
            // We may have either a single listener (which will never be wrapped in an array)
            // or 2+ listeners (which will be wrapped). Since we are now adding one more listener
            // we may have to wrap the single listener before adding the second.
            listeners = Array.isArray(listeners) ? listeners : [listeners];
            listeners.push(listener);
        } else {
            listeners = listener;
        }
        promise._listeners = listeners;
    }
    // The difference beween setCompleteValue()/setErrorValue() and complete()/error() is that setXXXValue() moves
    // a promise directly to the success/error state without starting another notification pass (because one
    // is already ongoing).
    function setErrorInfo(promise, errorId, isException) {
        promise._isException = isException || false;
        promise._errorId = errorId;
    }
    function setErrorValue(promise, value, onerrorDetails, context) {
        promise._value = value;
        callonerror(promise, value, onerrorDetails, context);
        promise._setState(state_error);
    }
    function setCompleteValue(promise, value) {
        var targetState;
        if (value && typeof value === "object" && typeof value.then === "function") {
            targetState = state_waiting;
        } else {
            targetState = state_success;
        }
        promise._value = value;
        promise._setState(targetState);
    }
    function then(promise, onComplete, onError, onProgress) {
        var result = new ThenPromise(promise);
        var asyncOpID = _Trace._traceAsyncOperationStarting("WinJS.Promise.then");
        pushListener(promise, { promise: result, c: onComplete, e: onError, p: onProgress, asyncOpID: asyncOpID });
        return result;
    }

    //
    // Internal implementation detail promise, ThenPromise is created when a promise needs
    // to be returned from a then() method.
    //
    var ThenPromise = _Base.Class.derive(PromiseStateMachine,
        function (creator) {

            if (tagWithStack && (tagWithStack === true || (tagWithStack & tag.thenPromise))) {
                this._stack = Promise._getStack();
            }

            this._creator = creator;
            this._setState(state_created);
            this._run();
        }, {
            _creator: null,

            _cancelAction: function () { if (this._creator) { this._creator.cancel(); } },
            _cleanupAction: function () { this._creator = null; }
        }, {
            supportedForProcessing: false
        }
    );

    //
    // Slim promise implementations for already completed promises, these are created
    // under the hood on synchronous completion paths as well as by WinJS.Promise.wrap
    // and WinJS.Promise.wrapError.
    //

    var ErrorPromise = _Base.Class.define(
        function ErrorPromise_ctor(value) {

            if (tagWithStack && (tagWithStack === true || (tagWithStack & tag.errorPromise))) {
                this._stack = Promise._getStack();
            }

            this._value = value;
            callonerror(this, value, detailsForError);
        }, {
            cancel: function () {
                /// <signature helpKeyword="WinJS.PromiseStateMachine.cancel">
                /// <summary locid="WinJS.PromiseStateMachine.cancel">
                /// Attempts to cancel the fulfillment of a promised value. If the promise hasn't
                /// already been fulfilled and cancellation is supported, the promise enters
                /// the error state with a value of Error("Canceled").
                /// </summary>
                /// </signature>
            },
            done: function ErrorPromise_done(unused, onError) {
                /// <signature helpKeyword="WinJS.PromiseStateMachine.done">
                /// <summary locid="WinJS.PromiseStateMachine.done">
                /// Allows you to specify the work to be done on the fulfillment of the promised value,
                /// the error handling to be performed if the promise fails to fulfill
                /// a value, and the handling of progress notifications along the way.
                ///
                /// After the handlers have finished executing, this function throws any error that would have been returned
                /// from then() as a promise in the error state.
                /// </summary>
                /// <param name='onComplete' type='Function' locid="WinJS.PromiseStateMachine.done_p:onComplete">
                /// The function to be called if the promise is fulfilled successfully with a value.
                /// The fulfilled value is passed as the single argument. If the value is null,
                /// the fulfilled value is returned. The value returned
                /// from the function becomes the fulfilled value of the promise returned by
                /// then(). If an exception is thrown while executing the function, the promise returned
                /// by then() moves into the error state.
                /// </param>
                /// <param name='onError' type='Function' optional='true' locid="WinJS.PromiseStateMachine.done_p:onError">
                /// The function to be called if the promise is fulfilled with an error. The error
                /// is passed as the single argument. If it is null, the error is forwarded.
                /// The value returned from the function is the fulfilled value of the promise returned by then().
                /// </param>
                /// <param name='onProgress' type='Function' optional='true' locid="WinJS.PromiseStateMachine.done_p:onProgress">
                /// the function to be called if the promise reports progress. Data about the progress
                /// is passed as the single argument. Promises are not required to support
                /// progress.
                /// </param>
                /// </signature>
                var value = this._value;
                if (onError) {
                    try {
                        if (!onError.handlesOnError) {
                            callonerror(null, value, detailsForHandledError, this, onError);
                        }
                        var result = onError(value);
                        if (result && typeof result === "object" && typeof result.done === "function") {
                            // If a promise is returned we need to wait on it.
                            result.done();
                        }
                        return;
                    } catch (ex) {
                        value = ex;
                    }
                }
                if (value instanceof Error && value.message === canceledName) {
                    // suppress cancel
                    return;
                }
                // force the exception to be thrown asyncronously to avoid any try/catch blocks
                //
                Promise._doneHandler(value);
            },
            then: function ErrorPromise_then(unused, onError) {
                /// <signature helpKeyword="WinJS.PromiseStateMachine.then">
                /// <summary locid="WinJS.PromiseStateMachine.then">
                /// Allows you to specify the work to be done on the fulfillment of the promised value,
                /// the error handling to be performed if the promise fails to fulfill
                /// a value, and the handling of progress notifications along the way.
                /// </summary>
                /// <param name='onComplete' type='Function' locid="WinJS.PromiseStateMachine.then_p:onComplete">
                /// The function to be called if the promise is fulfilled successfully with a value.
                /// The value is passed as the single argument. If the value is null, the value is returned.
                /// The value returned from the function becomes the fulfilled value of the promise returned by
                /// then(). If an exception is thrown while this function is being executed, the promise returned
                /// by then() moves into the error state.
                /// </param>
                /// <param name='onError' type='Function' optional='true' locid="WinJS.PromiseStateMachine.then_p:onError">
                /// The function to be called if the promise is fulfilled with an error. The error
                /// is passed as the single argument. If it is null, the error is forwarded.
                /// The value returned from the function becomes the fulfilled value of the promise returned by then().
                /// </param>
                /// <param name='onProgress' type='Function' optional='true' locid="WinJS.PromiseStateMachine.then_p:onProgress">
                /// The function to be called if the promise reports progress. Data about the progress
                /// is passed as the single argument. Promises are not required to support
                /// progress.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.PromiseStateMachine.then_returnValue">
                /// The promise whose value is the result of executing the complete or
                /// error function.
                /// </returns>
                /// </signature>

                // If the promise is already in a error state and no error handler is provided
                // we optimize by simply returning the promise instead of creating a new one.
                //
                if (!onError) { return this; }
                var result;
                var value = this._value;
                try {
                    if (!onError.handlesOnError) {
                        callonerror(null, value, detailsForHandledError, this, onError);
                    }
                    result = new CompletePromise(onError(value));
                } catch (ex) {
                    // If the value throw from the error handler is the same as the value
                    // provided to the error handler then there is no need for a new promise.
                    //
                    if (ex === value) {
                        result = this;
                    } else {
                        result = new ExceptionPromise(ex);
                    }
                }
                return result;
            }
        }, {
            supportedForProcessing: false
        }
    );

    var ExceptionPromise = _Base.Class.derive(ErrorPromise,
        function ExceptionPromise_ctor(value) {

            if (tagWithStack && (tagWithStack === true || (tagWithStack & tag.exceptionPromise))) {
                this._stack = Promise._getStack();
            }

            this._value = value;
            callonerror(this, value, detailsForException);
        }, {
            /* empty */
        }, {
            supportedForProcessing: false
        }
    );

    var CompletePromise = _Base.Class.define(
        function CompletePromise_ctor(value) {

            if (tagWithStack && (tagWithStack === true || (tagWithStack & tag.completePromise))) {
                this._stack = Promise._getStack();
            }

            if (value && typeof value === "object" && typeof value.then === "function") {
                var result = new ThenPromise(null);
                result._setCompleteValue(value);
                return result;
            }
            this._value = value;
        }, {
            cancel: function () {
                /// <signature helpKeyword="WinJS.PromiseStateMachine.cancel">
                /// <summary locid="WinJS.PromiseStateMachine.cancel">
                /// Attempts to cancel the fulfillment of a promised value. If the promise hasn't
                /// already been fulfilled and cancellation is supported, the promise enters
                /// the error state with a value of Error("Canceled").
                /// </summary>
                /// </signature>
            },
            done: function CompletePromise_done(onComplete) {
                /// <signature helpKeyword="WinJS.PromiseStateMachine.done">
                /// <summary locid="WinJS.PromiseStateMachine.done">
                /// Allows you to specify the work to be done on the fulfillment of the promised value,
                /// the error handling to be performed if the promise fails to fulfill
                /// a value, and the handling of progress notifications along the way.
                ///
                /// After the handlers have finished executing, this function throws any error that would have been returned
                /// from then() as a promise in the error state.
                /// </summary>
                /// <param name='onComplete' type='Function' locid="WinJS.PromiseStateMachine.done_p:onComplete">
                /// The function to be called if the promise is fulfilled successfully with a value.
                /// The fulfilled value is passed as the single argument. If the value is null,
                /// the fulfilled value is returned. The value returned
                /// from the function becomes the fulfilled value of the promise returned by
                /// then(). If an exception is thrown while executing the function, the promise returned
                /// by then() moves into the error state.
                /// </param>
                /// <param name='onError' type='Function' optional='true' locid="WinJS.PromiseStateMachine.done_p:onError">
                /// The function to be called if the promise is fulfilled with an error. The error
                /// is passed as the single argument. If it is null, the error is forwarded.
                /// The value returned from the function is the fulfilled value of the promise returned by then().
                /// </param>
                /// <param name='onProgress' type='Function' optional='true' locid="WinJS.PromiseStateMachine.done_p:onProgress">
                /// the function to be called if the promise reports progress. Data about the progress
                /// is passed as the single argument. Promises are not required to support
                /// progress.
                /// </param>
                /// </signature>
                if (!onComplete) { return; }
                try {
                    var result = onComplete(this._value);
                    if (result && typeof result === "object" && typeof result.done === "function") {
                        result.done();
                    }
                } catch (ex) {
                    // force the exception to be thrown asynchronously to avoid any try/catch blocks
                    Promise._doneHandler(ex);
                }
            },
            then: function CompletePromise_then(onComplete) {
                /// <signature helpKeyword="WinJS.PromiseStateMachine.then">
                /// <summary locid="WinJS.PromiseStateMachine.then">
                /// Allows you to specify the work to be done on the fulfillment of the promised value,
                /// the error handling to be performed if the promise fails to fulfill
                /// a value, and the handling of progress notifications along the way.
                /// </summary>
                /// <param name='onComplete' type='Function' locid="WinJS.PromiseStateMachine.then_p:onComplete">
                /// The function to be called if the promise is fulfilled successfully with a value.
                /// The value is passed as the single argument. If the value is null, the value is returned.
                /// The value returned from the function becomes the fulfilled value of the promise returned by
                /// then(). If an exception is thrown while this function is being executed, the promise returned
                /// by then() moves into the error state.
                /// </param>
                /// <param name='onError' type='Function' optional='true' locid="WinJS.PromiseStateMachine.then_p:onError">
                /// The function to be called if the promise is fulfilled with an error. The error
                /// is passed as the single argument. If it is null, the error is forwarded.
                /// The value returned from the function becomes the fulfilled value of the promise returned by then().
                /// </param>
                /// <param name='onProgress' type='Function' optional='true' locid="WinJS.PromiseStateMachine.then_p:onProgress">
                /// The function to be called if the promise reports progress. Data about the progress
                /// is passed as the single argument. Promises are not required to support
                /// progress.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.PromiseStateMachine.then_returnValue">
                /// The promise whose value is the result of executing the complete or
                /// error function.
                /// </returns>
                /// </signature>
                try {
                    // If the value returned from the completion handler is the same as the value
                    // provided to the completion handler then there is no need for a new promise.
                    //
                    var newValue = onComplete ? onComplete(this._value) : this._value;
                    return newValue === this._value ? this : new CompletePromise(newValue);
                } catch (ex) {
                    return new ExceptionPromise(ex);
                }
            }
        }, {
            supportedForProcessing: false
        }
    );

    //
    // Promise is the user-creatable WinJS.Promise object.
    //

    function timeout(timeoutMS) {
        var id;
        return new Promise(
            function (c) {
                if (timeoutMS) {
                    id = _Global.setTimeout(c, timeoutMS);
                } else {
                    _BaseCoreUtils._setImmediate(c);
                }
            },
            function () {
                if (id) {
                    _Global.clearTimeout(id);
                }
            }
        );
    }

    function timeoutWithPromise(timeout, promise) {
        var cancelPromise = function () { promise.cancel(); };
        var cancelTimeout = function () { timeout.cancel(); };
        timeout.then(cancelPromise);
        promise.then(cancelTimeout, cancelTimeout);
        return promise;
    }

    var staticCanceledPromise;

    var Promise = _Base.Class.derive(PromiseStateMachine,
        function Promise_ctor(init, oncancel) {
            /// <signature helpKeyword="WinJS.Promise">
            /// <summary locid="WinJS.Promise">
            /// A promise provides a mechanism to schedule work to be done on a value that
            /// has not yet been computed. It is a convenient abstraction for managing
            /// interactions with asynchronous APIs.
            /// </summary>
            /// <param name="init" type="Function" locid="WinJS.Promise_p:init">
            /// The function that is called during construction of the  promise. The function
            /// is given three arguments (complete, error, progress). Inside this function
            /// you should add event listeners for the notifications supported by this value.
            /// </param>
            /// <param name="oncancel" optional="true" locid="WinJS.Promise_p:oncancel">
            /// The function to call if a consumer of this promise wants
            /// to cancel its undone work. Promises are not required to
            /// support cancellation.
            /// </param>
            /// </signature>

            if (tagWithStack && (tagWithStack === true || (tagWithStack & tag.promise))) {
                this._stack = Promise._getStack();
            }

            this._oncancel = oncancel;
            this._setState(state_created);
            this._run();

            try {
                var complete = this._completed.bind(this);
                var error = this._error.bind(this);
                var progress = this._progress.bind(this);
                init(complete, error, progress);
            } catch (ex) {
                this._setExceptionValue(ex);
            }
        }, {
            _oncancel: null,

            _cancelAction: function () {
                // BEGIN monaco change
                try {
                    if (this._oncancel) {
                        this._oncancel();
                    } else {
                        throw new Error('Promise did not implement oncancel');
                    }
                } catch (ex) {
                    // Access fields to get them created
                    var msg = ex.message;
                    var stack = ex.stack;
                    promiseEventListeners.dispatchEvent('error', ex);
                }
                // END monaco change
            },
            _cleanupAction: function () { this._oncancel = null; }
        }, {

            addEventListener: function Promise_addEventListener(eventType, listener, capture) {
                /// <signature helpKeyword="WinJS.Promise.addEventListener">
                /// <summary locid="WinJS.Promise.addEventListener">
                /// Adds an event listener to the control.
                /// </summary>
                /// <param name="eventType" locid="WinJS.Promise.addEventListener_p:eventType">
                /// The type (name) of the event.
                /// </param>
                /// <param name="listener" locid="WinJS.Promise.addEventListener_p:listener">
                /// The listener to invoke when the event is raised.
                /// </param>
                /// <param name="capture" locid="WinJS.Promise.addEventListener_p:capture">
                /// Specifies whether or not to initiate capture.
                /// </param>
                /// </signature>
                promiseEventListeners.addEventListener(eventType, listener, capture);
            },
            any: function Promise_any(values) {
                /// <signature helpKeyword="WinJS.Promise.any">
                /// <summary locid="WinJS.Promise.any">
                /// Returns a promise that is fulfilled when one of the input promises
                /// has been fulfilled.
                /// </summary>
                /// <param name="values" type="Array" locid="WinJS.Promise.any_p:values">
                /// An array that contains promise objects or objects whose property
                /// values include promise objects.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.any_returnValue">
                /// A promise that on fulfillment yields the value of the input (complete or error).
                /// </returns>
                /// </signature>
                return new Promise(
                    function (complete, error) {
                        var keys = Object.keys(values);
                        if (keys.length === 0) {
                            complete();
                        }
                        var canceled = 0;
                        keys.forEach(function (key) {
                            Promise.as(values[key]).then(
                                function () { complete({ key: key, value: values[key] }); },
                                function (e) {
                                    if (e instanceof Error && e.name === canceledName) {
                                        if ((++canceled) === keys.length) {
                                            complete(Promise.cancel);
                                        }
                                        return;
                                    }
                                    error({ key: key, value: values[key] });
                                }
                            );
                        });
                    },
                    function () {
                        var keys = Object.keys(values);
                        keys.forEach(function (key) {
                            var promise = Promise.as(values[key]);
                            if (typeof promise.cancel === "function") {
                                promise.cancel();
                            }
                        });
                    }
                );
            },
            as: function Promise_as(value) {
                /// <signature helpKeyword="WinJS.Promise.as">
                /// <summary locid="WinJS.Promise.as">
                /// Returns a promise. If the object is already a promise it is returned;
                /// otherwise the object is wrapped in a promise.
                /// </summary>
                /// <param name="value" locid="WinJS.Promise.as_p:value">
                /// The value to be treated as a promise.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.as_returnValue">
                /// A promise.
                /// </returns>
                /// </signature>
                if (value && typeof value === "object" && typeof value.then === "function") {
                    return value;
                }
                return new CompletePromise(value);
            },
            /// <field type="WinJS.Promise" helpKeyword="WinJS.Promise.cancel" locid="WinJS.Promise.cancel">
            /// Canceled promise value, can be returned from a promise completion handler
            /// to indicate cancelation of the promise chain.
            /// </field>
            cancel: {
                get: function () {
                    return (staticCanceledPromise = staticCanceledPromise || new ErrorPromise(new _ErrorFromName(canceledName)));
                }
            },
            dispatchEvent: function Promise_dispatchEvent(eventType, details) {
                /// <signature helpKeyword="WinJS.Promise.dispatchEvent">
                /// <summary locid="WinJS.Promise.dispatchEvent">
                /// Raises an event of the specified type and properties.
                /// </summary>
                /// <param name="eventType" locid="WinJS.Promise.dispatchEvent_p:eventType">
                /// The type (name) of the event.
                /// </param>
                /// <param name="details" locid="WinJS.Promise.dispatchEvent_p:details">
                /// The set of additional properties to be attached to the event object.
                /// </param>
                /// <returns type="Boolean" locid="WinJS.Promise.dispatchEvent_returnValue">
                /// Specifies whether preventDefault was called on the event.
                /// </returns>
                /// </signature>
                return promiseEventListeners.dispatchEvent(eventType, details);
            },
            is: function Promise_is(value) {
                /// <signature helpKeyword="WinJS.Promise.is">
                /// <summary locid="WinJS.Promise.is">
                /// Determines whether a value fulfills the promise contract.
                /// </summary>
                /// <param name="value" locid="WinJS.Promise.is_p:value">
                /// A value that may be a promise.
                /// </param>
                /// <returns type="Boolean" locid="WinJS.Promise.is_returnValue">
                /// true if the specified value is a promise, otherwise false.
                /// </returns>
                /// </signature>
                return value && typeof value === "object" && typeof value.then === "function";
            },
            join: function Promise_join(values) {
                /// <signature helpKeyword="WinJS.Promise.join">
                /// <summary locid="WinJS.Promise.join">
                /// Creates a promise that is fulfilled when all the values are fulfilled.
                /// </summary>
                /// <param name="values" type="Object" locid="WinJS.Promise.join_p:values">
                /// An object whose fields contain values, some of which may be promises.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.join_returnValue">
                /// A promise whose value is an object with the same field names as those of the object in the values parameter, where
                /// each field value is the fulfilled value of a promise.
                /// </returns>
                /// </signature>
                return new Promise(
                    function (complete, error, progress) {
                        var keys = Object.keys(values);
                        var errors = Array.isArray(values) ? [] : {};
                        var results = Array.isArray(values) ? [] : {};
                        var undefineds = 0;
                        var pending = keys.length;
                        var argDone = function (key) {
                            if ((--pending) === 0) {
                                var errorCount = Object.keys(errors).length;
                                if (errorCount === 0) {
                                    complete(results);
                                } else {
                                    var canceledCount = 0;
                                    keys.forEach(function (key) {
                                        var e = errors[key];
                                        if (e instanceof Error && e.name === canceledName) {
                                            canceledCount++;
                                        }
                                    });
                                    if (canceledCount === errorCount) {
                                        complete(Promise.cancel);
                                    } else {
                                        error(errors);
                                    }
                                }
                            } else {
                                progress({ Key: key, Done: true });
                            }
                        };
                        keys.forEach(function (key) {
                            var value = values[key];
                            if (value === undefined) {
                                undefineds++;
                            } else {
                                Promise.then(value,
                                    function (value) { results[key] = value; argDone(key); },
                                    function (value) { errors[key] = value; argDone(key); }
                                );
                            }
                        });
                        pending -= undefineds;
                        if (pending === 0) {
                            complete(results);
                            return;
                        }
                    },
                    function () {
                        Object.keys(values).forEach(function (key) {
                            var promise = Promise.as(values[key]);
                            if (typeof promise.cancel === "function") {
                                promise.cancel();
                            }
                        });
                    }
                );
            },
            removeEventListener: function Promise_removeEventListener(eventType, listener, capture) {
                /// <signature helpKeyword="WinJS.Promise.removeEventListener">
                /// <summary locid="WinJS.Promise.removeEventListener">
                /// Removes an event listener from the control.
                /// </summary>
                /// <param name='eventType' locid="WinJS.Promise.removeEventListener_eventType">
                /// The type (name) of the event.
                /// </param>
                /// <param name='listener' locid="WinJS.Promise.removeEventListener_listener">
                /// The listener to remove.
                /// </param>
                /// <param name='capture' locid="WinJS.Promise.removeEventListener_capture">
                /// Specifies whether or not to initiate capture.
                /// </param>
                /// </signature>
                promiseEventListeners.removeEventListener(eventType, listener, capture);
            },
            supportedForProcessing: false,
            then: function Promise_then(value, onComplete, onError, onProgress) {
                /// <signature helpKeyword="WinJS.Promise.then">
                /// <summary locid="WinJS.Promise.then">
                /// A static version of the promise instance method then().
                /// </summary>
                /// <param name="value" locid="WinJS.Promise.then_p:value">
                /// the value to be treated as a promise.
                /// </param>
                /// <param name="onComplete" type="Function" locid="WinJS.Promise.then_p:complete">
                /// The function to be called if the promise is fulfilled with a value.
                /// If it is null, the promise simply
                /// returns the value. The value is passed as the single argument.
                /// </param>
                /// <param name="onError" type="Function" optional="true" locid="WinJS.Promise.then_p:error">
                /// The function to be called if the promise is fulfilled with an error. The error
                /// is passed as the single argument.
                /// </param>
                /// <param name="onProgress" type="Function" optional="true" locid="WinJS.Promise.then_p:progress">
                /// The function to be called if the promise reports progress. Data about the progress
                /// is passed as the single argument. Promises are not required to support
                /// progress.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.then_returnValue">
                /// A promise whose value is the result of executing the provided complete function.
                /// </returns>
                /// </signature>
                return Promise.as(value).then(onComplete, onError, onProgress);
            },
            thenEach: function Promise_thenEach(values, onComplete, onError, onProgress) {
                /// <signature helpKeyword="WinJS.Promise.thenEach">
                /// <summary locid="WinJS.Promise.thenEach">
                /// Performs an operation on all the input promises and returns a promise
                /// that has the shape of the input and contains the result of the operation
                /// that has been performed on each input.
                /// </summary>
                /// <param name="values" locid="WinJS.Promise.thenEach_p:values">
                /// A set of values (which could be either an array or an object) of which some or all are promises.
                /// </param>
                /// <param name="onComplete" type="Function" locid="WinJS.Promise.thenEach_p:complete">
                /// The function to be called if the promise is fulfilled with a value.
                /// If the value is null, the promise returns the value.
                /// The value is passed as the single argument.
                /// </param>
                /// <param name="onError" type="Function" optional="true" locid="WinJS.Promise.thenEach_p:error">
                /// The function to be called if the promise is fulfilled with an error. The error
                /// is passed as the single argument.
                /// </param>
                /// <param name="onProgress" type="Function" optional="true" locid="WinJS.Promise.thenEach_p:progress">
                /// The function to be called if the promise reports progress. Data about the progress
                /// is passed as the single argument. Promises are not required to support
                /// progress.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.thenEach_returnValue">
                /// A promise that is the result of calling Promise.join on the values parameter.
                /// </returns>
                /// </signature>
                var result = Array.isArray(values) ? [] : {};
                Object.keys(values).forEach(function (key) {
                    result[key] = Promise.as(values[key]).then(onComplete, onError, onProgress);
                });
                return Promise.join(result);
            },
            timeout: function Promise_timeout(time, promise) {
                /// <signature helpKeyword="WinJS.Promise.timeout">
                /// <summary locid="WinJS.Promise.timeout">
                /// Creates a promise that is fulfilled after a timeout.
                /// </summary>
                /// <param name="timeout" type="Number" optional="true" locid="WinJS.Promise.timeout_p:timeout">
                /// The timeout period in milliseconds. If this value is zero or not specified
                /// setImmediate is called, otherwise setTimeout is called.
                /// </param>
                /// <param name="promise" type="Promise" optional="true" locid="WinJS.Promise.timeout_p:promise">
                /// A promise that will be canceled if it doesn't complete before the
                /// timeout has expired.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.timeout_returnValue">
                /// A promise that is completed asynchronously after the specified timeout.
                /// </returns>
                /// </signature>
                var to = timeout(time);
                return promise ? timeoutWithPromise(to, promise) : to;
            },
            wrap: function Promise_wrap(value) {
                /// <signature helpKeyword="WinJS.Promise.wrap">
                /// <summary locid="WinJS.Promise.wrap">
                /// Wraps a non-promise value in a promise. You can use this function if you need
                /// to pass a value to a function that requires a promise.
                /// </summary>
                /// <param name="value" locid="WinJS.Promise.wrap_p:value">
                /// Some non-promise value to be wrapped in a promise.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.wrap_returnValue">
                /// A promise that is successfully fulfilled with the specified value
                /// </returns>
                /// </signature>
                return new CompletePromise(value);
            },
            wrapError: function Promise_wrapError(error) {
                /// <signature helpKeyword="WinJS.Promise.wrapError">
                /// <summary locid="WinJS.Promise.wrapError">
                /// Wraps a non-promise error value in a promise. You can use this function if you need
                /// to pass an error to a function that requires a promise.
                /// </summary>
                /// <param name="error" locid="WinJS.Promise.wrapError_p:error">
                /// A non-promise error value to be wrapped in a promise.
                /// </param>
                /// <returns type="WinJS.Promise" locid="WinJS.Promise.wrapError_returnValue">
                /// A promise that is in an error state with the specified value.
                /// </returns>
                /// </signature>
                return new ErrorPromise(error);
            },

            _veryExpensiveTagWithStack: {
                get: function () { return tagWithStack; },
                set: function (value) { tagWithStack = value; }
            },
            _veryExpensiveTagWithStack_tag: tag,
            _getStack: function () {
                if (_Global.Debug && _Global.Debug.debuggerEnabled) {
                    try { throw new Error(); } catch (e) { return e.stack; }
                }
            },

            _cancelBlocker: function Promise__cancelBlocker(input, oncancel) {
                //
                // Returns a promise which on cancelation will still result in downstream cancelation while
                //  protecting the promise 'input' from being  canceled which has the effect of allowing
                //  'input' to be shared amoung various consumers.
                //
                if (!Promise.is(input)) {
                    return Promise.wrap(input);
                }
                var complete;
                var error;
                var output = new Promise(
                    function (c, e) {
                        complete = c;
                        error = e;
                    },
                    function () {
                        complete = null;
                        error = null;
                        oncancel && oncancel();
                    }
                );
                input.then(
                    function (v) { complete && complete(v); },
                    function (e) { error && error(e); }
                );
                return output;
            },

        }
    );
    Object.defineProperties(Promise, _Events.createEventProperties(errorET));

    Promise._doneHandler = function (value) {
        _BaseCoreUtils._setImmediate(function Promise_done_rethrow() {
            throw value;
        });
    };

    return {
        PromiseStateMachine: PromiseStateMachine,
        Promise: Promise,
        state_created: state_created
    };
});

_winjs("WinJS/Promise", ["WinJS/Core/_Base","WinJS/Promise/_StateMachine"], function promiseInit( _Base, _StateMachine) {
    "use strict";

    _Base.Namespace.define("WinJS", {
        Promise: _StateMachine.Promise
    });

    return _StateMachine.Promise;
});

__winjs_exports = _modules["WinJS/Core/_WinJS"];
__winjs_exports.TPromise = __winjs_exports.Promise;
__winjs_exports.PPromise = __winjs_exports.Promise;

// ESM-comment-begin
// if (typeof exports === 'undefined' && typeof define === 'function' && define.amd) {
//     define([], __winjs_exports);
// } else {
//     module.exports = __winjs_exports;
// }
// ESM-comment-end

})();

// ESM-uncomment-begin
var Promise = __winjs_exports.Promise;
var TPromise = __winjs_exports.TPromise;
var PPromise = __winjs_exports.PPromise;
// ESM-uncomment-end

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(112), __webpack_require__(245)))

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Position; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * A position in the editor.
 */
var Position = /** @class */ (function () {
    function Position(lineNumber, column) {
        this.lineNumber = lineNumber;
        this.column = column;
    }
    /**
     * Test if this position equals other position
     */
    Position.prototype.equals = function (other) {
        return Position.equals(this, other);
    };
    /**
     * Test if position `a` equals position `b`
     */
    Position.equals = function (a, b) {
        if (!a && !b) {
            return true;
        }
        return (!!a &&
            !!b &&
            a.lineNumber === b.lineNumber &&
            a.column === b.column);
    };
    /**
     * Test if this position is before other position.
     * If the two positions are equal, the result will be false.
     */
    Position.prototype.isBefore = function (other) {
        return Position.isBefore(this, other);
    };
    /**
     * Test if position `a` is before position `b`.
     * If the two positions are equal, the result will be false.
     */
    Position.isBefore = function (a, b) {
        if (a.lineNumber < b.lineNumber) {
            return true;
        }
        if (b.lineNumber < a.lineNumber) {
            return false;
        }
        return a.column < b.column;
    };
    /**
     * Test if this position is before other position.
     * If the two positions are equal, the result will be true.
     */
    Position.prototype.isBeforeOrEqual = function (other) {
        return Position.isBeforeOrEqual(this, other);
    };
    /**
     * Test if position `a` is before position `b`.
     * If the two positions are equal, the result will be true.
     */
    Position.isBeforeOrEqual = function (a, b) {
        if (a.lineNumber < b.lineNumber) {
            return true;
        }
        if (b.lineNumber < a.lineNumber) {
            return false;
        }
        return a.column <= b.column;
    };
    /**
     * A function that compares positions, useful for sorting
     */
    Position.compare = function (a, b) {
        var aLineNumber = a.lineNumber | 0;
        var bLineNumber = b.lineNumber | 0;
        if (aLineNumber === bLineNumber) {
            var aColumn = a.column | 0;
            var bColumn = b.column | 0;
            return aColumn - bColumn;
        }
        return aLineNumber - bLineNumber;
    };
    /**
     * Clone this position.
     */
    Position.prototype.clone = function () {
        return new Position(this.lineNumber, this.column);
    };
    /**
     * Convert to a human-readable representation.
     */
    Position.prototype.toString = function () {
        return '(' + this.lineNumber + ',' + this.column + ')';
    };
    // ---
    /**
     * Create a `Position` from an `IPosition`.
     */
    Position.lift = function (pos) {
        return new Position(pos.lineNumber, pos.column);
    };
    /**
     * Test if `obj` is an `IPosition`.
     */
    Position.isIPosition = function (obj) {
        return (obj
            && (typeof obj.lineNumber === 'number')
            && (typeof obj.column === 'number'));
    };
    return Position;
}());



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isThenable */
/* harmony export (immutable) */ __webpack_exports__["n"] = toThenable;
/* harmony export (immutable) */ __webpack_exports__["i"] = createCancelablePromise;
/* harmony export (immutable) */ __webpack_exports__["h"] = asWinJsPromise;
/* harmony export (immutable) */ __webpack_exports__["o"] = wireCancellationToken;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Throttler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Delayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ShallowCancelThenPromise; });
/* harmony export (immutable) */ __webpack_exports__["m"] = timeout;
/* harmony export (immutable) */ __webpack_exports__["g"] = always;
/* harmony export (immutable) */ __webpack_exports__["k"] = first2;
/* harmony export (immutable) */ __webpack_exports__["j"] = first;
/* harmony export (immutable) */ __webpack_exports__["l"] = setDisposableTimeout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TimeoutTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntervalTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RunOnceScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cancellation_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




function isThenable(obj) {
    return obj && typeof obj.then === 'function';
}
function toThenable(arg) {
    if (isThenable(arg)) {
        return arg;
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */].as(arg);
    }
}
function createCancelablePromise(callback) {
    var source = new __WEBPACK_IMPORTED_MODULE_2__cancellation_js__["b" /* CancellationTokenSource */]();
    var thenable = callback(source.token);
    var promise = new Promise(function (resolve, reject) {
        source.token.onCancellationRequested(function () {
            reject(__WEBPACK_IMPORTED_MODULE_0__errors_js__["a" /* canceled */]());
        });
        Promise.resolve(thenable).then(function (value) {
            source.dispose();
            resolve(value);
        }, function (err) {
            source.dispose();
            reject(err);
        });
    });
    return new /** @class */ (function () {
        function class_1() {
        }
        class_1.prototype.cancel = function () {
            source.cancel();
        };
        class_1.prototype.then = function (resolve, reject) {
            return promise.then(resolve, reject);
        };
        class_1.prototype.catch = function (reject) {
            return this.then(undefined, reject);
        };
        return class_1;
    }());
}
function asWinJsPromise(callback) {
    var source = new __WEBPACK_IMPORTED_MODULE_2__cancellation_js__["b" /* CancellationTokenSource */]();
    return new __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */](function (resolve, reject, progress) {
        var item = callback(source.token);
        if (item instanceof __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */]) {
            item.then(function (result) {
                source.dispose();
                resolve(result);
            }, function (err) {
                source.dispose();
                reject(err);
            }, progress);
        }
        else if (isThenable(item)) {
            item.then(function (result) {
                source.dispose();
                resolve(result);
            }, function (err) {
                source.dispose();
                reject(err);
            });
        }
        else {
            source.dispose();
            resolve(item);
        }
    }, function () {
        source.cancel();
    });
}
/**
 * Hook a cancellation token to a WinJS Promise
 */
function wireCancellationToken(token, promise, resolveAsUndefinedWhenCancelled) {
    var subscription = token.onCancellationRequested(function () { return promise.cancel(); });
    if (resolveAsUndefinedWhenCancelled) {
        promise = promise.then(undefined, function (err) {
            if (!__WEBPACK_IMPORTED_MODULE_0__errors_js__["d" /* isPromiseCanceledError */](err)) {
                return __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */].wrapError(err);
            }
            return undefined;
        });
    }
    return always(promise, function () { return subscription.dispose(); });
}
/**
 * A helper to prevent accumulation of sequential async tasks.
 *
 * Imagine a mail man with the sole task of delivering letters. As soon as
 * a letter submitted for delivery, he drives to the destination, delivers it
 * and returns to his base. Imagine that during the trip, N more letters were submitted.
 * When the mail man returns, he picks those N letters and delivers them all in a
 * single trip. Even though N+1 submissions occurred, only 2 deliveries were made.
 *
 * The throttler implements this via the queue() method, by providing it a task
 * factory. Following the example:
 *
 * 		const throttler = new Throttler();
 * 		const letters = [];
 *
 * 		function deliver() {
 * 			const lettersToDeliver = letters;
 * 			letters = [];
 * 			return makeTheTrip(lettersToDeliver);
 * 		}
 *
 * 		function onLetterReceived(l) {
 * 			letters.push(l);
 * 			throttler.queue(deliver);
 * 		}
 */
var Throttler = /** @class */ (function () {
    function Throttler() {
        this.activePromise = null;
        this.queuedPromise = null;
        this.queuedPromiseFactory = null;
    }
    Throttler.prototype.queue = function (promiseFactory) {
        var _this = this;
        if (this.activePromise) {
            this.queuedPromiseFactory = promiseFactory;
            if (!this.queuedPromise) {
                var onComplete_1 = function () {
                    _this.queuedPromise = null;
                    var result = _this.queue(_this.queuedPromiseFactory);
                    _this.queuedPromiseFactory = null;
                    return result;
                };
                this.queuedPromise = new __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */](function (c, e, p) {
                    _this.activePromise.then(onComplete_1, onComplete_1, p).done(c);
                }, function () {
                    _this.activePromise.cancel();
                });
            }
            return new __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */](function (c, e, p) {
                _this.queuedPromise.then(c, e, p);
            }, function () {
                // no-op
            });
        }
        this.activePromise = promiseFactory();
        return new __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */](function (c, e, p) {
            _this.activePromise.done(function (result) {
                _this.activePromise = null;
                c(result);
            }, function (err) {
                _this.activePromise = null;
                e(err);
            }, p);
        }, function () {
            _this.activePromise.cancel();
        });
    };
    return Throttler;
}());

/**
 * A helper to delay execution of a task that is being requested often.
 *
 * Following the throttler, now imagine the mail man wants to optimize the number of
 * trips proactively. The trip itself can be long, so he decides not to make the trip
 * as soon as a letter is submitted. Instead he waits a while, in case more
 * letters are submitted. After said waiting period, if no letters were submitted, he
 * decides to make the trip. Imagine that N more letters were submitted after the first
 * one, all within a short period of time between each other. Even though N+1
 * submissions occurred, only 1 delivery was made.
 *
 * The delayer offers this behavior via the trigger() method, into which both the task
 * to be executed and the waiting period (delay) must be passed in as arguments. Following
 * the example:
 *
 * 		const delayer = new Delayer(WAITING_PERIOD);
 * 		const letters = [];
 *
 * 		function letterReceived(l) {
 * 			letters.push(l);
 * 			delayer.trigger(() => { return makeTheTrip(); });
 * 		}
 */
var Delayer = /** @class */ (function () {
    function Delayer(defaultDelay) {
        this.defaultDelay = defaultDelay;
        this.timeout = null;
        this.completionPromise = null;
        this.onSuccess = null;
        this.task = null;
    }
    Delayer.prototype.trigger = function (task, delay) {
        var _this = this;
        if (delay === void 0) { delay = this.defaultDelay; }
        this.task = task;
        this.cancelTimeout();
        if (!this.completionPromise) {
            this.completionPromise = new __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */](function (c) {
                _this.onSuccess = c;
            }, function () {
                // no-op
            }).then(function () {
                _this.completionPromise = null;
                _this.onSuccess = null;
                var task = _this.task;
                _this.task = null;
                return task();
            });
        }
        this.timeout = setTimeout(function () {
            _this.timeout = null;
            _this.onSuccess(null);
        }, delay);
        return this.completionPromise;
    };
    Delayer.prototype.cancel = function () {
        this.cancelTimeout();
        if (this.completionPromise) {
            this.completionPromise.cancel();
            this.completionPromise = null;
        }
    };
    Delayer.prototype.cancelTimeout = function () {
        if (this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };
    return Delayer;
}());

var ShallowCancelThenPromise = /** @class */ (function (_super) {
    __extends(ShallowCancelThenPromise, _super);
    function ShallowCancelThenPromise(outer) {
        var _this = this;
        var completeCallback, errorCallback, progressCallback;
        _this = _super.call(this, function (c, e, p) {
            completeCallback = c;
            errorCallback = e;
            progressCallback = p;
        }, function () {
            // cancel this promise but not the
            // outer promise
            errorCallback(__WEBPACK_IMPORTED_MODULE_0__errors_js__["a" /* canceled */]());
        }) || this;
        outer.then(completeCallback, errorCallback, progressCallback);
        return _this;
    }
    return ShallowCancelThenPromise;
}(__WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */]));

/**
 * Replacement for `WinJS.TPromise.timeout`.
 */
function timeout(n) {
    return createCancelablePromise(function (token) {
        return new Promise(function (resolve, reject) {
            var handle = setTimeout(resolve, n);
            token.onCancellationRequested(function (_) {
                clearTimeout(handle);
                reject(__WEBPACK_IMPORTED_MODULE_0__errors_js__["a" /* canceled */]());
            });
        });
    });
}
function isWinJSPromise(candidate) {
    return __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */].is(candidate) && typeof candidate.done === 'function';
}
function always(winjsPromiseOrThenable, f) {
    if (isWinJSPromise(winjsPromiseOrThenable)) {
        return new __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */](function (c, e, p) {
            winjsPromiseOrThenable.done(function (result) {
                try {
                    f(result);
                }
                catch (e1) {
                    __WEBPACK_IMPORTED_MODULE_0__errors_js__["e" /* onUnexpectedError */](e1);
                }
                c(result);
            }, function (err) {
                try {
                    f(err);
                }
                catch (e1) {
                    __WEBPACK_IMPORTED_MODULE_0__errors_js__["e" /* onUnexpectedError */](e1);
                }
                e(err);
            }, function (progress) {
                p(progress);
            });
        }, function () {
            winjsPromiseOrThenable.cancel();
        });
    }
    else {
        // simple
        winjsPromiseOrThenable.then(function (_) { return f(); }, function (_) { return f(); });
        return winjsPromiseOrThenable;
    }
}
function first2(promiseFactories, shouldStop, defaultValue) {
    if (shouldStop === void 0) { shouldStop = function (t) { return !!t; }; }
    if (defaultValue === void 0) { defaultValue = null; }
    var index = 0;
    var len = promiseFactories.length;
    var loop = function () {
        if (index >= len) {
            return Promise.resolve(defaultValue);
        }
        var factory = promiseFactories[index++];
        var promise = factory();
        return promise.then(function (result) {
            if (shouldStop(result)) {
                return Promise.resolve(result);
            }
            return loop();
        });
    };
    return loop();
}
function first(promiseFactories, shouldStop, defaultValue) {
    if (shouldStop === void 0) { shouldStop = function (t) { return !!t; }; }
    if (defaultValue === void 0) { defaultValue = null; }
    var index = 0;
    var len = promiseFactories.length;
    var loop = function () {
        if (index >= len) {
            return __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */].as(defaultValue);
        }
        var factory = promiseFactories[index++];
        var promise = factory();
        return promise.then(function (result) {
            if (shouldStop(result)) {
                return __WEBPACK_IMPORTED_MODULE_1__winjs_base_js__["b" /* TPromise */].as(result);
            }
            return loop();
        });
    };
    return loop();
}
function setDisposableTimeout(handler, timeout) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var handle = setTimeout.apply(void 0, [handler, timeout].concat(args));
    return { dispose: function () { clearTimeout(handle); } };
}
var TimeoutTimer = /** @class */ (function (_super) {
    __extends(TimeoutTimer, _super);
    function TimeoutTimer() {
        var _this = _super.call(this) || this;
        _this._token = -1;
        return _this;
    }
    TimeoutTimer.prototype.dispose = function () {
        this.cancel();
        _super.prototype.dispose.call(this);
    };
    TimeoutTimer.prototype.cancel = function () {
        if (this._token !== -1) {
            clearTimeout(this._token);
            this._token = -1;
        }
    };
    TimeoutTimer.prototype.cancelAndSet = function (runner, timeout) {
        var _this = this;
        this.cancel();
        this._token = setTimeout(function () {
            _this._token = -1;
            runner();
        }, timeout);
    };
    TimeoutTimer.prototype.setIfNotSet = function (runner, timeout) {
        var _this = this;
        if (this._token !== -1) {
            // timer is already set
            return;
        }
        this._token = setTimeout(function () {
            _this._token = -1;
            runner();
        }, timeout);
    };
    return TimeoutTimer;
}(__WEBPACK_IMPORTED_MODULE_3__lifecycle_js__["a" /* Disposable */]));

var IntervalTimer = /** @class */ (function (_super) {
    __extends(IntervalTimer, _super);
    function IntervalTimer() {
        var _this = _super.call(this) || this;
        _this._token = -1;
        return _this;
    }
    IntervalTimer.prototype.dispose = function () {
        this.cancel();
        _super.prototype.dispose.call(this);
    };
    IntervalTimer.prototype.cancel = function () {
        if (this._token !== -1) {
            clearInterval(this._token);
            this._token = -1;
        }
    };
    IntervalTimer.prototype.cancelAndSet = function (runner, interval) {
        this.cancel();
        this._token = setInterval(function () {
            runner();
        }, interval);
    };
    return IntervalTimer;
}(__WEBPACK_IMPORTED_MODULE_3__lifecycle_js__["a" /* Disposable */]));

var RunOnceScheduler = /** @class */ (function () {
    function RunOnceScheduler(runner, timeout) {
        this.timeoutToken = -1;
        this.runner = runner;
        this.timeout = timeout;
        this.timeoutHandler = this.onTimeout.bind(this);
    }
    /**
     * Dispose RunOnceScheduler
     */
    RunOnceScheduler.prototype.dispose = function () {
        this.cancel();
        this.runner = null;
    };
    /**
     * Cancel current scheduled runner (if any).
     */
    RunOnceScheduler.prototype.cancel = function () {
        if (this.isScheduled()) {
            clearTimeout(this.timeoutToken);
            this.timeoutToken = -1;
        }
    };
    /**
     * Cancel previous runner (if any) & schedule a new runner.
     */
    RunOnceScheduler.prototype.schedule = function (delay) {
        if (delay === void 0) { delay = this.timeout; }
        this.cancel();
        this.timeoutToken = setTimeout(this.timeoutHandler, delay);
    };
    /**
     * Returns true if scheduled.
     */
    RunOnceScheduler.prototype.isScheduled = function () {
        return this.timeoutToken !== -1;
    };
    RunOnceScheduler.prototype.onTimeout = function () {
        this.timeoutToken = -1;
        if (this.runner) {
            this.doRun();
        }
    };
    RunOnceScheduler.prototype.doRun = function () {
        this.runner();
    };
    return RunOnceScheduler;
}());



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadLanguage */
/* harmony export (immutable) */ __webpack_exports__["a"] = registerLanguage;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
var languageDefinitions = {};
function _loadLanguage(languageId) {
    var loader = languageDefinitions[languageId].loader;
    return loader().then(function (mod) {
        _monaco.languages.setMonarchTokensProvider(languageId, mod.language);
        _monaco.languages.setLanguageConfiguration(languageId, mod.conf);
    });
}
var languagePromises = {};
function loadLanguage(languageId) {
    if (!languagePromises[languageId]) {
        languagePromises[languageId] = _loadLanguage(languageId);
    }
    return languagePromises[languageId];
}
function registerLanguage(def) {
    var languageId = def.id;
    languageDefinitions[languageId] = def;
    _monaco.languages.register(def);
    _monaco.languages.onLanguage(languageId, function () {
        loadLanguage(languageId);
    });
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _util; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IInstantiationService; });
/* harmony export (immutable) */ __webpack_exports__["c"] = createDecorator;
/* harmony export (immutable) */ __webpack_exports__["d"] = optional;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// ------ internal util
var _util;
(function (_util) {
    _util.serviceIds = new Map();
    _util.DI_TARGET = '$di$target';
    _util.DI_DEPENDENCIES = '$di$dependencies';
    function getServiceDependencies(ctor) {
        return ctor[_util.DI_DEPENDENCIES] || [];
    }
    _util.getServiceDependencies = getServiceDependencies;
})(_util || (_util = {}));
var IInstantiationService = createDecorator('instantiationService');
function storeServiceDependency(id, target, index, optional) {
    if (target[_util.DI_TARGET] === target) {
        target[_util.DI_DEPENDENCIES].push({ id: id, index: index, optional: optional });
    }
    else {
        target[_util.DI_DEPENDENCIES] = [{ id: id, index: index, optional: optional }];
        target[_util.DI_TARGET] = target;
    }
}
/**
 * A *only* valid way to create a {{ServiceIdentifier}}.
 */
function createDecorator(serviceId) {
    if (_util.serviceIds.has(serviceId)) {
        return _util.serviceIds.get(serviceId);
    }
    var id = function (target, key, index) {
        if (arguments.length !== 3) {
            throw new Error('@IServiceName-decorator can only be used to decorate a parameter');
        }
        storeServiceDependency(id, target, index, false);
    };
    id.toString = function () { return serviceId; };
    _util.serviceIds.set(serviceId, id);
    return id;
}
/**
 * Mark a service dependency as optional.
 */
function optional(serviceIdentifier) {
    return function (target, key, index) {
        if (arguments.length !== 3) {
            throw new Error('@optional-decorator can only be used to decorate a parameter');
        }
        storeServiceDependency(serviceIdentifier, target, index, true);
    };
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IThemeService; });
/* harmony export (immutable) */ __webpack_exports__["f"] = themeColorFromId;
/* unused harmony export DARK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIGH_CONTRAST; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getThemeTypeSelector;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Extensions; });
/* harmony export (immutable) */ __webpack_exports__["e"] = registerThemingParticipant;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var IThemeService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('themeService');
function themeColorFromId(id) {
    return { id: id };
}
// base themes
var DARK = 'dark';
var HIGH_CONTRAST = 'hc';
function getThemeTypeSelector(type) {
    switch (type) {
        case DARK: return 'vs-dark';
        case HIGH_CONTRAST: return 'hc-black';
        default: return 'vs';
    }
}
// static theming participant
var Extensions = {
    ThemingContribution: 'base.contributions.theming'
};
var ThemingRegistry = /** @class */ (function () {
    function ThemingRegistry() {
        this.themingParticipants = [];
        this.themingParticipants = [];
        this.onThemingParticipantAddedEmitter = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
    }
    ThemingRegistry.prototype.onThemeChange = function (participant) {
        var _this = this;
        this.themingParticipants.push(participant);
        this.onThemingParticipantAddedEmitter.fire(participant);
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            var idx = _this.themingParticipants.indexOf(participant);
            _this.themingParticipants.splice(idx, 1);
        });
    };
    ThemingRegistry.prototype.getThemingParticipants = function () {
        return this.themingParticipants;
    };
    return ThemingRegistry;
}());
var themingRegistry = new ThemingRegistry();
__WEBPACK_IMPORTED_MODULE_2__registry_common_platform_js__["a" /* Registry */].add(Extensions.ThemingContribution, themingRegistry);
function registerThemingParticipant(participant) {
    return themingRegistry.onThemeChange(participant);
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* unused harmony export LANGUAGE_DEFAULT */
/* unused harmony export Platform */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isWindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMacintosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLinux; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isWeb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return globals; });
/* harmony export (immutable) */ __webpack_exports__["h"] = setImmediate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OS; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var _isWindows = false;
var _isMacintosh = false;
var _isLinux = false;
var _isNative = false;
var _isWeb = false;
var _locale = undefined;
var _language = undefined;
var _translationsConfigFile = undefined;
var LANGUAGE_DEFAULT = 'en';
// OS detection
if (typeof process === 'object' && typeof process.nextTick === 'function' && typeof process.platform === 'string') {
    _isWindows = (process.platform === 'win32');
    _isMacintosh = (process.platform === 'darwin');
    _isLinux = (process.platform === 'linux');
    _locale = LANGUAGE_DEFAULT;
    _language = LANGUAGE_DEFAULT;
    var rawNlsConfig = Object({"NODE_ENV":"production","PUBLIC_URL":""})['VSCODE_NLS_CONFIG'];
    if (rawNlsConfig) {
        try {
            var nlsConfig = JSON.parse(rawNlsConfig);
            var resolved = nlsConfig.availableLanguages['*'];
            _locale = nlsConfig.locale;
            // VSCode's default language is 'en'
            _language = resolved ? resolved : LANGUAGE_DEFAULT;
            _translationsConfigFile = nlsConfig._translationsConfigFile;
        }
        catch (e) {
        }
    }
    _isNative = true;
}
else if (typeof navigator === 'object') {
    var userAgent = navigator.userAgent;
    _isWindows = userAgent.indexOf('Windows') >= 0;
    _isMacintosh = userAgent.indexOf('Macintosh') >= 0;
    _isLinux = userAgent.indexOf('Linux') >= 0;
    _isWeb = true;
    _locale = navigator.language;
    _language = _locale;
}
var Platform;
(function (Platform) {
    Platform[Platform["Web"] = 0] = "Web";
    Platform[Platform["Mac"] = 1] = "Mac";
    Platform[Platform["Linux"] = 2] = "Linux";
    Platform[Platform["Windows"] = 3] = "Windows";
})(Platform || (Platform = {}));
var _platform = Platform.Web;
if (_isNative) {
    if (_isMacintosh) {
        _platform = Platform.Mac;
    }
    else if (_isWindows) {
        _platform = Platform.Windows;
    }
    else if (_isLinux) {
        _platform = Platform.Linux;
    }
}
var isWindows = _isWindows;
var isMacintosh = _isMacintosh;
var isLinux = _isLinux;
var isNative = _isNative;
var isWeb = _isWeb;
var _globals = (typeof self === 'object' ? self : typeof global === 'object' ? global : {});
var globals = _globals;
var _setImmediate = null;
function setImmediate(callback) {
    if (_setImmediate === null) {
        if (globals.setImmediate) {
            _setImmediate = globals.setImmediate.bind(globals);
        }
        else if (typeof process !== 'undefined' && typeof process.nextTick === 'function') {
            _setImmediate = process.nextTick.bind(process);
        }
        else {
            _setImmediate = globals.setTimeout.bind(globals);
        }
    }
    return _setImmediate(callback);
}
var OS = (_isMacintosh ? 2 /* Macintosh */ : (_isWindows ? 1 /* Windows */ : 3 /* Linux */));

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(245), __webpack_require__(112)))

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LanguageIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TokenMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SuggestTriggerKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CodeActionTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DocumentHighlightKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SymbolKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return symbolKindToCssClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FoldingRangeKind; });
/* harmony export (immutable) */ __webpack_exports__["A"] = isResourceTextEdit;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ReferenceProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RenameProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SuggestRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SignatureHelpProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return HoverProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DocumentSymbolProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DocumentHighlightProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DefinitionProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ImplementationProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TypeDefinitionProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CodeLensProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeActionProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DocumentFormattingEditProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DocumentRangeFormattingEditProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return OnTypeFormattingEditProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LinkProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ColorProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FoldingRangeProviderRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TokenizationRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modes_tokenizationRegistry_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_types_js__ = __webpack_require__(31);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




/**
 * @internal
 */
var LanguageIdentifier = /** @class */ (function () {
    function LanguageIdentifier(language, id) {
        this.language = language;
        this.id = id;
    }
    return LanguageIdentifier;
}());

/**
 * @internal
 */
var TokenMetadata = /** @class */ (function () {
    function TokenMetadata() {
    }
    TokenMetadata.getLanguageId = function (metadata) {
        return (metadata & 255 /* LANGUAGEID_MASK */) >>> 0 /* LANGUAGEID_OFFSET */;
    };
    TokenMetadata.getTokenType = function (metadata) {
        return (metadata & 1792 /* TOKEN_TYPE_MASK */) >>> 8 /* TOKEN_TYPE_OFFSET */;
    };
    TokenMetadata.getFontStyle = function (metadata) {
        return (metadata & 14336 /* FONT_STYLE_MASK */) >>> 11 /* FONT_STYLE_OFFSET */;
    };
    TokenMetadata.getForeground = function (metadata) {
        return (metadata & 8372224 /* FOREGROUND_MASK */) >>> 14 /* FOREGROUND_OFFSET */;
    };
    TokenMetadata.getBackground = function (metadata) {
        return (metadata & 4286578688 /* BACKGROUND_MASK */) >>> 23 /* BACKGROUND_OFFSET */;
    };
    TokenMetadata.getClassNameFromMetadata = function (metadata) {
        var foreground = this.getForeground(metadata);
        var className = 'mtk' + foreground;
        var fontStyle = this.getFontStyle(metadata);
        if (fontStyle & 1 /* Italic */) {
            className += ' mtki';
        }
        if (fontStyle & 2 /* Bold */) {
            className += ' mtkb';
        }
        if (fontStyle & 4 /* Underline */) {
            className += ' mtku';
        }
        return className;
    };
    TokenMetadata.getInlineStyleFromMetadata = function (metadata, colorMap) {
        var foreground = this.getForeground(metadata);
        var fontStyle = this.getFontStyle(metadata);
        var result = "color: " + colorMap[foreground] + ";";
        if (fontStyle & 1 /* Italic */) {
            result += 'font-style: italic;';
        }
        if (fontStyle & 2 /* Bold */) {
            result += 'font-weight: bold;';
        }
        if (fontStyle & 4 /* Underline */) {
            result += 'text-decoration: underline;';
        }
        return result;
    };
    return TokenMetadata;
}());

/**
 * How a suggest provider was triggered.
 */
var SuggestTriggerKind;
(function (SuggestTriggerKind) {
    SuggestTriggerKind[SuggestTriggerKind["Invoke"] = 0] = "Invoke";
    SuggestTriggerKind[SuggestTriggerKind["TriggerCharacter"] = 1] = "TriggerCharacter";
    SuggestTriggerKind[SuggestTriggerKind["TriggerForIncompleteCompletions"] = 2] = "TriggerForIncompleteCompletions";
})(SuggestTriggerKind || (SuggestTriggerKind = {}));
/**
 * @internal
 */
var CodeActionTrigger;
(function (CodeActionTrigger) {
    CodeActionTrigger[CodeActionTrigger["Automatic"] = 1] = "Automatic";
    CodeActionTrigger[CodeActionTrigger["Manual"] = 2] = "Manual";
})(CodeActionTrigger || (CodeActionTrigger = {}));
/**
 * A document highlight kind.
 */
var DocumentHighlightKind;
(function (DocumentHighlightKind) {
    /**
     * A textual occurrence.
     */
    DocumentHighlightKind[DocumentHighlightKind["Text"] = 0] = "Text";
    /**
     * Read-access of a symbol, like reading a variable.
     */
    DocumentHighlightKind[DocumentHighlightKind["Read"] = 1] = "Read";
    /**
     * Write-access of a symbol, like writing to a variable.
     */
    DocumentHighlightKind[DocumentHighlightKind["Write"] = 2] = "Write";
})(DocumentHighlightKind || (DocumentHighlightKind = {}));
/**
 * A symbol kind.
 */
var SymbolKind;
(function (SymbolKind) {
    SymbolKind[SymbolKind["File"] = 0] = "File";
    SymbolKind[SymbolKind["Module"] = 1] = "Module";
    SymbolKind[SymbolKind["Namespace"] = 2] = "Namespace";
    SymbolKind[SymbolKind["Package"] = 3] = "Package";
    SymbolKind[SymbolKind["Class"] = 4] = "Class";
    SymbolKind[SymbolKind["Method"] = 5] = "Method";
    SymbolKind[SymbolKind["Property"] = 6] = "Property";
    SymbolKind[SymbolKind["Field"] = 7] = "Field";
    SymbolKind[SymbolKind["Constructor"] = 8] = "Constructor";
    SymbolKind[SymbolKind["Enum"] = 9] = "Enum";
    SymbolKind[SymbolKind["Interface"] = 10] = "Interface";
    SymbolKind[SymbolKind["Function"] = 11] = "Function";
    SymbolKind[SymbolKind["Variable"] = 12] = "Variable";
    SymbolKind[SymbolKind["Constant"] = 13] = "Constant";
    SymbolKind[SymbolKind["String"] = 14] = "String";
    SymbolKind[SymbolKind["Number"] = 15] = "Number";
    SymbolKind[SymbolKind["Boolean"] = 16] = "Boolean";
    SymbolKind[SymbolKind["Array"] = 17] = "Array";
    SymbolKind[SymbolKind["Object"] = 18] = "Object";
    SymbolKind[SymbolKind["Key"] = 19] = "Key";
    SymbolKind[SymbolKind["Null"] = 20] = "Null";
    SymbolKind[SymbolKind["EnumMember"] = 21] = "EnumMember";
    SymbolKind[SymbolKind["Struct"] = 22] = "Struct";
    SymbolKind[SymbolKind["Event"] = 23] = "Event";
    SymbolKind[SymbolKind["Operator"] = 24] = "Operator";
    SymbolKind[SymbolKind["TypeParameter"] = 25] = "TypeParameter";
})(SymbolKind || (SymbolKind = {}));
/**
 * @internal
 */
var symbolKindToCssClass = (function () {
    var _fromMapping = Object.create(null);
    _fromMapping[SymbolKind.File] = 'file';
    _fromMapping[SymbolKind.Module] = 'module';
    _fromMapping[SymbolKind.Namespace] = 'namespace';
    _fromMapping[SymbolKind.Package] = 'package';
    _fromMapping[SymbolKind.Class] = 'class';
    _fromMapping[SymbolKind.Method] = 'method';
    _fromMapping[SymbolKind.Property] = 'property';
    _fromMapping[SymbolKind.Field] = 'field';
    _fromMapping[SymbolKind.Constructor] = 'constructor';
    _fromMapping[SymbolKind.Enum] = 'enum';
    _fromMapping[SymbolKind.Interface] = 'interface';
    _fromMapping[SymbolKind.Function] = 'function';
    _fromMapping[SymbolKind.Variable] = 'variable';
    _fromMapping[SymbolKind.Constant] = 'constant';
    _fromMapping[SymbolKind.String] = 'string';
    _fromMapping[SymbolKind.Number] = 'number';
    _fromMapping[SymbolKind.Boolean] = 'boolean';
    _fromMapping[SymbolKind.Array] = 'array';
    _fromMapping[SymbolKind.Object] = 'object';
    _fromMapping[SymbolKind.Key] = 'key';
    _fromMapping[SymbolKind.Null] = 'null';
    _fromMapping[SymbolKind.EnumMember] = 'enum-member';
    _fromMapping[SymbolKind.Struct] = 'struct';
    _fromMapping[SymbolKind.Event] = 'event';
    _fromMapping[SymbolKind.Operator] = 'operator';
    _fromMapping[SymbolKind.TypeParameter] = 'type-parameter';
    return function toCssClassName(kind) {
        return "symbol-icon " + (_fromMapping[kind] || 'property');
    };
})();
var FoldingRangeKind = /** @class */ (function () {
    /**
     * Creates a new [FoldingRangeKind](#FoldingRangeKind).
     *
     * @param value of the kind.
     */
    function FoldingRangeKind(value) {
        this.value = value;
    }
    /**
     * Kind for folding range representing a comment. The value of the kind is 'comment'.
     */
    FoldingRangeKind.Comment = new FoldingRangeKind('comment');
    /**
     * Kind for folding range representing a import. The value of the kind is 'imports'.
     */
    FoldingRangeKind.Imports = new FoldingRangeKind('imports');
    /**
     * Kind for folding range representing regions (for example marked by `#region`, `#endregion`).
     * The value of the kind is 'region'.
     */
    FoldingRangeKind.Region = new FoldingRangeKind('region');
    return FoldingRangeKind;
}());

/**
 * @internal
 */
function isResourceTextEdit(thing) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["g" /* isObject */])(thing) && thing.resource && Array.isArray(thing.edits);
}
// --- feature registries ------
/**
 * @internal
 */
var ReferenceProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var RenameProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var SuggestRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var SignatureHelpProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var HoverProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var DocumentSymbolProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var DocumentHighlightProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var DefinitionProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var ImplementationProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var TypeDefinitionProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var CodeLensProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var CodeActionProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var DocumentFormattingEditProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var DocumentRangeFormattingEditProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var OnTypeFormattingEditProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var LinkProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var ColorProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var FoldingRangeProviderRegistry = new __WEBPACK_IMPORTED_MODULE_0__modes_languageFeatureRegistry_js__["a" /* default */]();
/**
 * @internal
 */
var TokenizationRegistry = new __WEBPACK_IMPORTED_MODULE_1__modes_tokenizationRegistry_js__["a" /* TokenizationRegistryImpl */]();


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContextKeyExprType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContextKeyExpr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContextKeyDefinedExpr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContextKeyEqualsExpr; });
/* unused harmony export ContextKeyNotEqualsExpr */
/* unused harmony export ContextKeyNotExpr */
/* unused harmony export ContextKeyRegexExpr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextKeyAndExpr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RawContextKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IContextKeyService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CONTEXT_COMMAND_ID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ContextKeyExprType;
(function (ContextKeyExprType) {
    ContextKeyExprType[ContextKeyExprType["Defined"] = 1] = "Defined";
    ContextKeyExprType[ContextKeyExprType["Not"] = 2] = "Not";
    ContextKeyExprType[ContextKeyExprType["Equals"] = 3] = "Equals";
    ContextKeyExprType[ContextKeyExprType["NotEquals"] = 4] = "NotEquals";
    ContextKeyExprType[ContextKeyExprType["And"] = 5] = "And";
    ContextKeyExprType[ContextKeyExprType["Regex"] = 6] = "Regex";
})(ContextKeyExprType || (ContextKeyExprType = {}));
var ContextKeyExpr = /** @class */ (function () {
    function ContextKeyExpr() {
    }
    ContextKeyExpr.has = function (key) {
        return new ContextKeyDefinedExpr(key);
    };
    ContextKeyExpr.equals = function (key, value) {
        return new ContextKeyEqualsExpr(key, value);
    };
    ContextKeyExpr.regex = function (key, value) {
        return new ContextKeyRegexExpr(key, value);
    };
    ContextKeyExpr.not = function (key) {
        return new ContextKeyNotExpr(key);
    };
    ContextKeyExpr.and = function () {
        var expr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            expr[_i] = arguments[_i];
        }
        return new ContextKeyAndExpr(expr);
    };
    ContextKeyExpr.deserialize = function (serialized) {
        var _this = this;
        if (!serialized) {
            return null;
        }
        var pieces = serialized.split('&&');
        var result = new ContextKeyAndExpr(pieces.map(function (p) { return _this._deserializeOne(p); }));
        return result.normalize();
    };
    ContextKeyExpr._deserializeOne = function (serializedOne) {
        serializedOne = serializedOne.trim();
        if (serializedOne.indexOf('!=') >= 0) {
            var pieces = serializedOne.split('!=');
            return new ContextKeyNotEqualsExpr(pieces[0].trim(), this._deserializeValue(pieces[1]));
        }
        if (serializedOne.indexOf('==') >= 0) {
            var pieces = serializedOne.split('==');
            return new ContextKeyEqualsExpr(pieces[0].trim(), this._deserializeValue(pieces[1]));
        }
        if (serializedOne.indexOf('=~') >= 0) {
            var pieces = serializedOne.split('=~');
            return new ContextKeyRegexExpr(pieces[0].trim(), this._deserializeRegexValue(pieces[1]));
        }
        if (/^\!\s*/.test(serializedOne)) {
            return new ContextKeyNotExpr(serializedOne.substr(1).trim());
        }
        return new ContextKeyDefinedExpr(serializedOne);
    };
    ContextKeyExpr._deserializeValue = function (serializedValue) {
        serializedValue = serializedValue.trim();
        if (serializedValue === 'true') {
            return true;
        }
        if (serializedValue === 'false') {
            return false;
        }
        var m = /^'([^']*)'$/.exec(serializedValue);
        if (m) {
            return m[1].trim();
        }
        return serializedValue;
    };
    ContextKeyExpr._deserializeRegexValue = function (serializedValue) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isFalsyOrWhitespace"])(serializedValue)) {
            console.warn('missing regexp-value for =~-expression');
            return null;
        }
        var start = serializedValue.indexOf('/');
        var end = serializedValue.lastIndexOf('/');
        if (start === end || start < 0 /* || to < 0 */) {
            console.warn("bad regexp-value '" + serializedValue + "', missing /-enclosure");
            return null;
        }
        var value = serializedValue.slice(start + 1, end);
        var caseIgnoreFlag = serializedValue[end + 1] === 'i' ? 'i' : '';
        try {
            return new RegExp(value, caseIgnoreFlag);
        }
        catch (e) {
            console.warn("bad regexp-value '" + serializedValue + "', parse error: " + e);
            return null;
        }
    };
    return ContextKeyExpr;
}());

function cmp(a, b) {
    var aType = a.getType();
    var bType = b.getType();
    if (aType !== bType) {
        return aType - bType;
    }
    switch (aType) {
        case ContextKeyExprType.Defined:
            return a.cmp(b);
        case ContextKeyExprType.Not:
            return a.cmp(b);
        case ContextKeyExprType.Equals:
            return a.cmp(b);
        case ContextKeyExprType.NotEquals:
            return a.cmp(b);
        case ContextKeyExprType.Regex:
            return a.cmp(b);
        default:
            throw new Error('Unknown ContextKeyExpr!');
    }
}
var ContextKeyDefinedExpr = /** @class */ (function () {
    function ContextKeyDefinedExpr(key) {
        this.key = key;
    }
    ContextKeyDefinedExpr.prototype.getType = function () {
        return ContextKeyExprType.Defined;
    };
    ContextKeyDefinedExpr.prototype.cmp = function (other) {
        if (this.key < other.key) {
            return -1;
        }
        if (this.key > other.key) {
            return 1;
        }
        return 0;
    };
    ContextKeyDefinedExpr.prototype.equals = function (other) {
        if (other instanceof ContextKeyDefinedExpr) {
            return (this.key === other.key);
        }
        return false;
    };
    ContextKeyDefinedExpr.prototype.evaluate = function (context) {
        return (!!context.getValue(this.key));
    };
    ContextKeyDefinedExpr.prototype.normalize = function () {
        return this;
    };
    ContextKeyDefinedExpr.prototype.keys = function () {
        return [this.key];
    };
    return ContextKeyDefinedExpr;
}());

var ContextKeyEqualsExpr = /** @class */ (function () {
    function ContextKeyEqualsExpr(key, value) {
        this.key = key;
        this.value = value;
    }
    ContextKeyEqualsExpr.prototype.getType = function () {
        return ContextKeyExprType.Equals;
    };
    ContextKeyEqualsExpr.prototype.cmp = function (other) {
        if (this.key < other.key) {
            return -1;
        }
        if (this.key > other.key) {
            return 1;
        }
        if (this.value < other.value) {
            return -1;
        }
        if (this.value > other.value) {
            return 1;
        }
        return 0;
    };
    ContextKeyEqualsExpr.prototype.equals = function (other) {
        if (other instanceof ContextKeyEqualsExpr) {
            return (this.key === other.key && this.value === other.value);
        }
        return false;
    };
    ContextKeyEqualsExpr.prototype.evaluate = function (context) {
        /* tslint:disable:triple-equals */
        // Intentional ==
        return (context.getValue(this.key) == this.value);
        /* tslint:enable:triple-equals */
    };
    ContextKeyEqualsExpr.prototype.normalize = function () {
        if (typeof this.value === 'boolean') {
            if (this.value) {
                return new ContextKeyDefinedExpr(this.key);
            }
            return new ContextKeyNotExpr(this.key);
        }
        return this;
    };
    ContextKeyEqualsExpr.prototype.keys = function () {
        return [this.key];
    };
    return ContextKeyEqualsExpr;
}());

var ContextKeyNotEqualsExpr = /** @class */ (function () {
    function ContextKeyNotEqualsExpr(key, value) {
        this.key = key;
        this.value = value;
    }
    ContextKeyNotEqualsExpr.prototype.getType = function () {
        return ContextKeyExprType.NotEquals;
    };
    ContextKeyNotEqualsExpr.prototype.cmp = function (other) {
        if (this.key < other.key) {
            return -1;
        }
        if (this.key > other.key) {
            return 1;
        }
        if (this.value < other.value) {
            return -1;
        }
        if (this.value > other.value) {
            return 1;
        }
        return 0;
    };
    ContextKeyNotEqualsExpr.prototype.equals = function (other) {
        if (other instanceof ContextKeyNotEqualsExpr) {
            return (this.key === other.key && this.value === other.value);
        }
        return false;
    };
    ContextKeyNotEqualsExpr.prototype.evaluate = function (context) {
        /* tslint:disable:triple-equals */
        // Intentional !=
        return (context.getValue(this.key) != this.value);
        /* tslint:enable:triple-equals */
    };
    ContextKeyNotEqualsExpr.prototype.normalize = function () {
        if (typeof this.value === 'boolean') {
            if (this.value) {
                return new ContextKeyNotExpr(this.key);
            }
            return new ContextKeyDefinedExpr(this.key);
        }
        return this;
    };
    ContextKeyNotEqualsExpr.prototype.keys = function () {
        return [this.key];
    };
    return ContextKeyNotEqualsExpr;
}());

var ContextKeyNotExpr = /** @class */ (function () {
    function ContextKeyNotExpr(key) {
        this.key = key;
    }
    ContextKeyNotExpr.prototype.getType = function () {
        return ContextKeyExprType.Not;
    };
    ContextKeyNotExpr.prototype.cmp = function (other) {
        if (this.key < other.key) {
            return -1;
        }
        if (this.key > other.key) {
            return 1;
        }
        return 0;
    };
    ContextKeyNotExpr.prototype.equals = function (other) {
        if (other instanceof ContextKeyNotExpr) {
            return (this.key === other.key);
        }
        return false;
    };
    ContextKeyNotExpr.prototype.evaluate = function (context) {
        return (!context.getValue(this.key));
    };
    ContextKeyNotExpr.prototype.normalize = function () {
        return this;
    };
    ContextKeyNotExpr.prototype.keys = function () {
        return [this.key];
    };
    return ContextKeyNotExpr;
}());

var ContextKeyRegexExpr = /** @class */ (function () {
    function ContextKeyRegexExpr(key, regexp) {
        this.key = key;
        this.regexp = regexp;
        //
    }
    ContextKeyRegexExpr.prototype.getType = function () {
        return ContextKeyExprType.Regex;
    };
    ContextKeyRegexExpr.prototype.cmp = function (other) {
        if (this.key < other.key) {
            return -1;
        }
        if (this.key > other.key) {
            return 1;
        }
        var source = this.regexp ? this.regexp.source : undefined;
        if (source < other.regexp.source) {
            return -1;
        }
        if (source > other.regexp.source) {
            return 1;
        }
        return 0;
    };
    ContextKeyRegexExpr.prototype.equals = function (other) {
        if (other instanceof ContextKeyRegexExpr) {
            var source = this.regexp ? this.regexp.source : undefined;
            return (this.key === other.key && source === other.regexp.source);
        }
        return false;
    };
    ContextKeyRegexExpr.prototype.evaluate = function (context) {
        return this.regexp ? this.regexp.test(context.getValue(this.key)) : false;
    };
    ContextKeyRegexExpr.prototype.normalize = function () {
        return this;
    };
    ContextKeyRegexExpr.prototype.keys = function () {
        return [this.key];
    };
    return ContextKeyRegexExpr;
}());

var ContextKeyAndExpr = /** @class */ (function () {
    function ContextKeyAndExpr(expr) {
        this.expr = ContextKeyAndExpr._normalizeArr(expr);
    }
    ContextKeyAndExpr.prototype.getType = function () {
        return ContextKeyExprType.And;
    };
    ContextKeyAndExpr.prototype.equals = function (other) {
        if (other instanceof ContextKeyAndExpr) {
            if (this.expr.length !== other.expr.length) {
                return false;
            }
            for (var i = 0, len = this.expr.length; i < len; i++) {
                if (!this.expr[i].equals(other.expr[i])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };
    ContextKeyAndExpr.prototype.evaluate = function (context) {
        for (var i = 0, len = this.expr.length; i < len; i++) {
            if (!this.expr[i].evaluate(context)) {
                return false;
            }
        }
        return true;
    };
    ContextKeyAndExpr._normalizeArr = function (arr) {
        var expr = [];
        if (arr) {
            for (var i = 0, len = arr.length; i < len; i++) {
                var e = arr[i];
                if (!e) {
                    continue;
                }
                e = e.normalize();
                if (!e) {
                    continue;
                }
                if (e instanceof ContextKeyAndExpr) {
                    expr = expr.concat(e.expr);
                    continue;
                }
                expr.push(e);
            }
            expr.sort(cmp);
        }
        return expr;
    };
    ContextKeyAndExpr.prototype.normalize = function () {
        if (this.expr.length === 0) {
            return null;
        }
        if (this.expr.length === 1) {
            return this.expr[0];
        }
        return this;
    };
    ContextKeyAndExpr.prototype.keys = function () {
        var result = [];
        for (var _i = 0, _a = this.expr; _i < _a.length; _i++) {
            var expr = _a[_i];
            result.push.apply(result, expr.keys());
        }
        return result;
    };
    return ContextKeyAndExpr;
}());

var RawContextKey = /** @class */ (function (_super) {
    __extends(RawContextKey, _super);
    function RawContextKey(key, defaultValue) {
        var _this = _super.call(this, key) || this;
        _this._defaultValue = defaultValue;
        return _this;
    }
    RawContextKey.prototype.bindTo = function (target) {
        return target.createKey(this.key, this._defaultValue);
    };
    RawContextKey.prototype.toNegated = function () {
        return ContextKeyExpr.not(this.key);
    };
    return RawContextKey;
}(ContextKeyDefinedExpr));

var IContextKeyService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('contextKeyService');
var SET_CONTEXT_COMMAND_ID = 'setContext';


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorContextKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var EditorContextKeys;
(function (EditorContextKeys) {
    /**
     * A context key that is set when the editor's text has focus (cursor is blinking).
     */
    EditorContextKeys.editorTextFocus = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorTextFocus', false);
    /**
     * A context key that is set when the editor's text or an editor's widget has focus.
     */
    EditorContextKeys.focus = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorFocus', false);
    /**
     * A context key that is set when any editor input has focus (regular editor, repl input...).
     */
    EditorContextKeys.textInputFocus = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('textInputFocus', false);
    EditorContextKeys.readOnly = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorReadonly', false);
    EditorContextKeys.writable = EditorContextKeys.readOnly.toNegated();
    EditorContextKeys.hasNonEmptySelection = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasSelection', false);
    EditorContextKeys.hasOnlyEmptySelection = EditorContextKeys.hasNonEmptySelection.toNegated();
    EditorContextKeys.hasMultipleSelections = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasMultipleSelections', false);
    EditorContextKeys.hasSingleSelection = EditorContextKeys.hasMultipleSelections.toNegated();
    EditorContextKeys.tabMovesFocus = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorTabMovesFocus', false);
    EditorContextKeys.tabDoesNotMoveFocus = EditorContextKeys.tabMovesFocus.toNegated();
    EditorContextKeys.isInEmbeddedEditor = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('isInEmbeddedEditor', undefined);
    EditorContextKeys.canUndo = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('canUndo', false);
    EditorContextKeys.canRedo = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('canRedo', false);
    // -- mode context keys
    EditorContextKeys.languageId = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorLangId', undefined);
    EditorContextKeys.hasCompletionItemProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasCompletionItemProvider', undefined);
    EditorContextKeys.hasCodeActionsProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasCodeActionsProvider', undefined);
    EditorContextKeys.hasCodeLensProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasCodeLensProvider', undefined);
    EditorContextKeys.hasDefinitionProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasDefinitionProvider', undefined);
    EditorContextKeys.hasImplementationProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasImplementationProvider', undefined);
    EditorContextKeys.hasTypeDefinitionProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasTypeDefinitionProvider', undefined);
    EditorContextKeys.hasHoverProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasHoverProvider', undefined);
    EditorContextKeys.hasDocumentHighlightProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasDocumentHighlightProvider', undefined);
    EditorContextKeys.hasDocumentSymbolProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasDocumentSymbolProvider', undefined);
    EditorContextKeys.hasReferenceProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasReferenceProvider', undefined);
    EditorContextKeys.hasRenameProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasRenameProvider', undefined);
    EditorContextKeys.hasDocumentFormattingProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasDocumentFormattingProvider', undefined);
    EditorContextKeys.hasDocumentSelectionFormattingProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasDocumentSelectionFormattingProvider', undefined);
    EditorContextKeys.hasSignatureHelpProvider = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('editorHasSignatureHelpProvider', undefined);
})(EditorContextKeys || (EditorContextKeys = {}));


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SelectionDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Selection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * The direction of a selection.
 */
var SelectionDirection;
(function (SelectionDirection) {
    /**
     * The selection starts above where it ends.
     */
    SelectionDirection[SelectionDirection["LTR"] = 0] = "LTR";
    /**
     * The selection starts below where it ends.
     */
    SelectionDirection[SelectionDirection["RTL"] = 1] = "RTL";
})(SelectionDirection || (SelectionDirection = {}));
/**
 * A selection in the editor.
 * The selection is a range that has an orientation.
 */
var Selection = /** @class */ (function (_super) {
    __extends(Selection, _super);
    function Selection(selectionStartLineNumber, selectionStartColumn, positionLineNumber, positionColumn) {
        var _this = _super.call(this, selectionStartLineNumber, selectionStartColumn, positionLineNumber, positionColumn) || this;
        _this.selectionStartLineNumber = selectionStartLineNumber;
        _this.selectionStartColumn = selectionStartColumn;
        _this.positionLineNumber = positionLineNumber;
        _this.positionColumn = positionColumn;
        return _this;
    }
    /**
     * Clone this selection.
     */
    Selection.prototype.clone = function () {
        return new Selection(this.selectionStartLineNumber, this.selectionStartColumn, this.positionLineNumber, this.positionColumn);
    };
    /**
     * Transform to a human-readable representation.
     */
    Selection.prototype.toString = function () {
        return '[' + this.selectionStartLineNumber + ',' + this.selectionStartColumn + ' -> ' + this.positionLineNumber + ',' + this.positionColumn + ']';
    };
    /**
     * Test if equals other selection.
     */
    Selection.prototype.equalsSelection = function (other) {
        return (Selection.selectionsEqual(this, other));
    };
    /**
     * Test if the two selections are equal.
     */
    Selection.selectionsEqual = function (a, b) {
        return (a.selectionStartLineNumber === b.selectionStartLineNumber &&
            a.selectionStartColumn === b.selectionStartColumn &&
            a.positionLineNumber === b.positionLineNumber &&
            a.positionColumn === b.positionColumn);
    };
    /**
     * Get directions (LTR or RTL).
     */
    Selection.prototype.getDirection = function () {
        if (this.selectionStartLineNumber === this.startLineNumber && this.selectionStartColumn === this.startColumn) {
            return SelectionDirection.LTR;
        }
        return SelectionDirection.RTL;
    };
    /**
     * Create a new selection with a different `positionLineNumber` and `positionColumn`.
     */
    Selection.prototype.setEndPosition = function (endLineNumber, endColumn) {
        if (this.getDirection() === SelectionDirection.LTR) {
            return new Selection(this.startLineNumber, this.startColumn, endLineNumber, endColumn);
        }
        return new Selection(endLineNumber, endColumn, this.startLineNumber, this.startColumn);
    };
    /**
     * Get the position at `positionLineNumber` and `positionColumn`.
     */
    Selection.prototype.getPosition = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__position_js__["a" /* Position */](this.positionLineNumber, this.positionColumn);
    };
    /**
     * Create a new selection with a different `selectionStartLineNumber` and `selectionStartColumn`.
     */
    Selection.prototype.setStartPosition = function (startLineNumber, startColumn) {
        if (this.getDirection() === SelectionDirection.LTR) {
            return new Selection(startLineNumber, startColumn, this.endLineNumber, this.endColumn);
        }
        return new Selection(this.endLineNumber, this.endColumn, startLineNumber, startColumn);
    };
    // ----
    /**
     * Create a `Selection` from one or two positions
     */
    Selection.fromPositions = function (start, end) {
        if (end === void 0) { end = start; }
        return new Selection(start.lineNumber, start.column, end.lineNumber, end.column);
    };
    /**
     * Create a `Selection` from an `ISelection`.
     */
    Selection.liftSelection = function (sel) {
        return new Selection(sel.selectionStartLineNumber, sel.selectionStartColumn, sel.positionLineNumber, sel.positionColumn);
    };
    /**
     * `a` equals `b`.
     */
    Selection.selectionsArrEqual = function (a, b) {
        if (a && !b || !a && b) {
            return false;
        }
        if (!a && !b) {
            return true;
        }
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0, len = a.length; i < len; i++) {
            if (!this.selectionsEqual(a[i], b[i])) {
                return false;
            }
        }
        return true;
    };
    /**
     * Test if `obj` is an `ISelection`.
     */
    Selection.isISelection = function (obj) {
        return (obj
            && (typeof obj.selectionStartLineNumber === 'number')
            && (typeof obj.selectionStartColumn === 'number')
            && (typeof obj.positionLineNumber === 'number')
            && (typeof obj.positionColumn === 'number'));
    };
    /**
     * Create with a direction.
     */
    Selection.createWithDirection = function (startLineNumber, startColumn, endLineNumber, endColumn, direction) {
        if (direction === SelectionDirection.LTR) {
            return new Selection(startLineNumber, startColumn, endLineNumber, endColumn);
        }
        return new Selection(endLineNumber, endColumn, startLineNumber, startColumn);
    };
    return Selection;
}(__WEBPACK_IMPORTED_MODULE_0__range_js__["a" /* Range */]));



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Extensions; });
/* harmony export (immutable) */ __webpack_exports__["_10"] = registerColor;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return foreground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return errorForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return focusBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return contrastBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activeContrastBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return textLinkForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return textCodeBlockBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return widgetShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return inputBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return inputForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return inputBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return inputActiveOptionBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return inputValidationInfoBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return inputValidationInfoBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return inputValidationWarningBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return inputValidationWarningBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return inputValidationErrorBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return inputValidationErrorBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return listFocusBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return listFocusForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return listActiveSelectionBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return listActiveSelectionForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return listInactiveSelectionBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return listInactiveSelectionForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return listInactiveFocusBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return listHoverBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return listHoverForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return listDropBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return listHighlightForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return pickerGroupForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return pickerGroupBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return badgeBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return badgeForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return scrollbarShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return scrollbarSliderBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return scrollbarSliderHoverBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return scrollbarSliderActiveBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return progressBarBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return editorBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return editorForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return editorWidgetBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return editorWidgetBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return editorWidgetResizeBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return editorSelectionBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return editorSelectionForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return editorInactiveSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return editorSelectionHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return editorSelectionHighlightBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return editorFindMatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return editorFindMatchHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return editorFindRangeHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return editorFindMatchBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return editorFindMatchHighlightBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return editorFindRangeHighlightBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return editorHoverHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return editorHoverBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return editorHoverBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return editorActiveLinkForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultInsertColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultRemoveColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return diffInserted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return diffRemoved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return diffInsertedOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return diffRemovedOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return diffBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return overviewRulerFindMatchForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return overviewRulerSelectionHighlightForeground; });
/* unused harmony export transparent */
/* harmony export (immutable) */ __webpack_exports__["_4"] = oneOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nls_js__ = __webpack_require__(2);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




// color registry
var Extensions = {
    ColorContribution: 'base.contributions.colors'
};
var ColorRegistry = /** @class */ (function () {
    function ColorRegistry() {
        this.colorSchema = { type: 'object', description: __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('schema.colors', "Colors used in the workbench."), properties: {}, additionalProperties: false };
        this.colorReferenceSchema = { type: 'string', enum: [], enumDescriptions: [] };
        this.colorsById = {};
    }
    ColorRegistry.prototype.registerColor = function (id, defaults, description, needsTransparency, deprecationMessage) {
        if (needsTransparency === void 0) { needsTransparency = false; }
        var colorContribution = { id: id, description: description, defaults: defaults, needsTransparency: needsTransparency, deprecationMessage: deprecationMessage };
        this.colorsById[id] = colorContribution;
        var propertySchema = { type: 'string', description: description, format: 'color-hex', default: '#ff0000' };
        if (deprecationMessage) {
            propertySchema.deprecationMessage = deprecationMessage;
        }
        this.colorSchema.properties[id] = propertySchema;
        this.colorReferenceSchema.enum.push(id);
        this.colorReferenceSchema.enumDescriptions.push(description);
        return id;
    };
    ColorRegistry.prototype.resolveDefaultColor = function (id, theme) {
        var colorDesc = this.colorsById[id];
        if (colorDesc && colorDesc.defaults) {
            var colorValue = colorDesc.defaults[theme.type];
            return resolveColorValue(colorValue, theme);
        }
        return null;
    };
    ColorRegistry.prototype.toString = function () {
        var _this = this;
        var sorter = function (a, b) {
            var cat1 = a.indexOf('.') === -1 ? 0 : 1;
            var cat2 = b.indexOf('.') === -1 ? 0 : 1;
            if (cat1 !== cat2) {
                return cat1 - cat2;
            }
            return a.localeCompare(b);
        };
        return Object.keys(this.colorsById).sort(sorter).map(function (k) { return "- `" + k + "`: " + _this.colorsById[k].description; }).join('\n');
    };
    return ColorRegistry;
}());
var colorRegistry = new ColorRegistry();
__WEBPACK_IMPORTED_MODULE_0__registry_common_platform_js__["a" /* Registry */].add(Extensions.ColorContribution, colorRegistry);
function registerColor(id, defaults, description, needsTransparency, deprecationMessage) {
    return colorRegistry.registerColor(id, defaults, description, needsTransparency, deprecationMessage);
}
// ----- base colors
var foreground = registerColor('foreground', { dark: '#CCCCCC', light: '#616161', hc: '#FFFFFF' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('foreground', "Overall foreground color. This color is only used if not overridden by a component."));
var errorForeground = registerColor('errorForeground', { dark: '#F48771', light: '#A1260D', hc: '#F48771' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('errorForeground', "Overall foreground color for error messages. This color is only used if not overridden by a component."));
var focusBorder = registerColor('focusBorder', { dark: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#0E639C').transparent(0.6), light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#007ACC').transparent(0.4), hc: '#F38518' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('focusBorder', "Overall border color for focused elements. This color is only used if not overridden by a component."));
var contrastBorder = registerColor('contrastBorder', { light: null, dark: null, hc: '#6FC3DF' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('contrastBorder', "An extra border around elements to separate them from others for greater contrast."));
var activeContrastBorder = registerColor('contrastActiveBorder', { light: null, dark: null, hc: focusBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('activeContrastBorder', "An extra border around active elements to separate them from others for greater contrast."));
var textLinkForeground = registerColor('textLink.foreground', { light: '#006AB1', dark: '#3794FF', hc: '#3794FF' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('textLinkForeground', "Foreground color for links in text."));
var textCodeBlockBackground = registerColor('textCodeBlock.background', { light: '#dcdcdc66', dark: '#0a0a0a66', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('textCodeBlockBackground', "Background color for code blocks in text."));
// ----- widgets
var widgetShadow = registerColor('widget.shadow', { dark: '#000000', light: '#A8A8A8', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('widgetShadow', 'Shadow color of widgets such as find/replace inside the editor.'));
var inputBackground = registerColor('input.background', { dark: '#3C3C3C', light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white, hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputBoxBackground', "Input box background."));
var inputForeground = registerColor('input.foreground', { dark: foreground, light: foreground, hc: foreground }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputBoxForeground', "Input box foreground."));
var inputBorder = registerColor('input.border', { dark: null, light: null, hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputBoxBorder', "Input box border."));
var inputActiveOptionBorder = registerColor('inputOption.activeBorder', { dark: '#007ACC', light: '#007ACC', hc: activeContrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputBoxActiveOptionBorder', "Border color of activated options in input fields."));
var inputValidationInfoBackground = registerColor('inputValidation.infoBackground', { dark: '#063B49', light: '#D6ECF2', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputValidationInfoBackground', "Input validation background color for information severity."));
var inputValidationInfoBorder = registerColor('inputValidation.infoBorder', { dark: '#007acc', light: '#007acc', hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputValidationInfoBorder', "Input validation border color for information severity."));
var inputValidationWarningBackground = registerColor('inputValidation.warningBackground', { dark: '#352A05', light: '#F6F5D2', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputValidationWarningBackground', "Input validation background color for warning severity."));
var inputValidationWarningBorder = registerColor('inputValidation.warningBorder', { dark: '#B89500', light: '#B89500', hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputValidationWarningBorder', "Input validation border color for warning severity."));
var inputValidationErrorBackground = registerColor('inputValidation.errorBackground', { dark: '#5A1D1D', light: '#F2DEDE', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputValidationErrorBackground', "Input validation background color for error severity."));
var inputValidationErrorBorder = registerColor('inputValidation.errorBorder', { dark: '#BE1100', light: '#BE1100', hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('inputValidationErrorBorder', "Input validation border color for error severity."));
var listFocusBackground = registerColor('list.focusBackground', { dark: '#062F4A', light: '#DFF0FF', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listFocusBackground', "List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listFocusForeground = registerColor('list.focusForeground', { dark: null, light: null, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listFocusForeground', "List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listActiveSelectionBackground = registerColor('list.activeSelectionBackground', { dark: '#094771', light: '#2477CE', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listActiveSelectionBackground', "List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listActiveSelectionForeground = registerColor('list.activeSelectionForeground', { dark: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white, light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listActiveSelectionForeground', "List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveSelectionBackground = registerColor('list.inactiveSelectionBackground', { dark: '#37373D', light: '#dddfea', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listInactiveSelectionBackground', "List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveSelectionForeground = registerColor('list.inactiveSelectionForeground', { dark: null, light: null, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listInactiveSelectionForeground', "List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveFocusBackground = registerColor('list.inactiveFocusBackground', { dark: '#313135', light: '#d8dae6', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listInactiveFocusBackground', "List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listHoverBackground = registerColor('list.hoverBackground', { dark: '#2A2D2E', light: '#F0F0F0', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listHoverBackground', "List/Tree background when hovering over items using the mouse."));
var listHoverForeground = registerColor('list.hoverForeground', { dark: null, light: null, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listHoverForeground', "List/Tree foreground when hovering over items using the mouse."));
var listDropBackground = registerColor('list.dropBackground', { dark: listFocusBackground, light: listFocusBackground, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('listDropBackground', "List/Tree drag and drop background when moving items around using the mouse."));
var listHighlightForeground = registerColor('list.highlightForeground', { dark: '#0097fb', light: '#007acc', hc: focusBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('highlight', 'List/Tree foreground color of the match highlights when searching inside the list/tree.'));
var pickerGroupForeground = registerColor('pickerGroup.foreground', { dark: '#3794FF', light: '#006AB1', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('pickerGroupForeground', "Quick picker color for grouping labels."));
var pickerGroupBorder = registerColor('pickerGroup.border', { dark: '#3F3F46', light: '#CCCEDB', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('pickerGroupBorder', "Quick picker color for grouping borders."));
var badgeBackground = registerColor('badge.background', { dark: '#4D4D4D', light: '#C4C4C4', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('badgeBackground', "Badge background color. Badges are small information labels, e.g. for search results count."));
var badgeForeground = registerColor('badge.foreground', { dark: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white, light: '#333', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('badgeForeground', "Badge foreground color. Badges are small information labels, e.g. for search results count."));
var scrollbarShadow = registerColor('scrollbar.shadow', { dark: '#000000', light: '#DDDDDD', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('scrollbarShadow', "Scrollbar shadow to indicate that the view is scrolled."));
var scrollbarSliderBackground = registerColor('scrollbarSlider.background', { dark: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#797979').transparent(0.4), light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#646464').transparent(0.4), hc: transparent(contrastBorder, 0.6) }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('scrollbarSliderBackground', "Scrollbar slider background color."));
var scrollbarSliderHoverBackground = registerColor('scrollbarSlider.hoverBackground', { dark: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#646464').transparent(0.7), light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#646464').transparent(0.7), hc: transparent(contrastBorder, 0.8) }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('scrollbarSliderHoverBackground', "Scrollbar slider background color when hovering."));
var scrollbarSliderActiveBackground = registerColor('scrollbarSlider.activeBackground', { dark: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#BFBFBF').transparent(0.4), light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#000000').transparent(0.6), hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('scrollbarSliderActiveBackground', "Scrollbar slider background color when clicked on."));
var progressBarBackground = registerColor('progressBar.background', { dark: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#0E70C0'), light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex('#0E70C0'), hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('progressBarBackground', "Background color of the progress bar that can show for long running operations."));
/**
 * Editor background color.
 * Because of bug https://monacotools.visualstudio.com/DefaultCollection/Monaco/_workitems/edit/13254
 * we are *not* using the color white (or #ffffff, rgba(255,255,255)) but something very close to white.
 */
var editorBackground = registerColor('editor.background', { light: '#fffffe', dark: '#1E1E1E', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorBackground', "Editor background color."));
/**
 * Editor foreground color.
 */
var editorForeground = registerColor('editor.foreground', { light: '#333333', dark: '#BBBBBB', hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorForeground', "Editor default foreground color."));
/**
 * Editor widgets
 */
var editorWidgetBackground = registerColor('editorWidget.background', { dark: '#2D2D30', light: '#EFEFF2', hc: '#0C141F' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorWidgetBackground', 'Background color of editor widgets, such as find/replace.'));
var editorWidgetBorder = registerColor('editorWidget.border', { dark: '#454545', light: '#C8C8C8', hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorWidgetBorder', 'Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget.'));
var editorWidgetResizeBorder = registerColor('editorWidget.resizeBorder', { light: null, dark: null, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorWidgetResizeBorder', "Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget."));
/**
 * Editor selection colors.
 */
var editorSelectionBackground = registerColor('editor.selectionBackground', { light: '#ADD6FF', dark: '#264F78', hc: '#f3f518' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorSelectionBackground', "Color of the editor selection."));
var editorSelectionForeground = registerColor('editor.selectionForeground', { light: null, dark: null, hc: '#000000' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorSelectionForeground', "Color of the selected text for high contrast."));
var editorInactiveSelection = registerColor('editor.inactiveSelectionBackground', { light: transparent(editorSelectionBackground, 0.5), dark: transparent(editorSelectionBackground, 0.5), hc: transparent(editorSelectionBackground, 0.5) }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorInactiveSelection', "Color of the selection in an inactive editor. The color must not be opaque to not hide underlying decorations."), true);
var editorSelectionHighlight = registerColor('editor.selectionHighlightBackground', { light: lessProminent(editorSelectionBackground, editorBackground, 0.3, 0.6), dark: lessProminent(editorSelectionBackground, editorBackground, 0.3, 0.6), hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorSelectionHighlight', 'Color for regions with the same content as the selection. The color must not be opaque to not hide underlying decorations.'), true);
var editorSelectionHighlightBorder = registerColor('editor.selectionHighlightBorder', { light: null, dark: null, hc: activeContrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorSelectionHighlightBorder', "Border color for regions with the same content as the selection."));
/**
 * Editor find match colors.
 */
var editorFindMatch = registerColor('editor.findMatchBackground', { light: '#A8AC94', dark: '#515C6A', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorFindMatch', "Color of the current search match."));
var editorFindMatchHighlight = registerColor('editor.findMatchHighlightBackground', { light: '#EA5C0055', dark: '#EA5C0055', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('findMatchHighlight', "Color of the other search matches. The color must not be opaque to not hide underlying decorations."), true);
var editorFindRangeHighlight = registerColor('editor.findRangeHighlightBackground', { dark: '#3a3d4166', light: '#b4b4b44d', hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('findRangeHighlight', "Color of the range limiting the search. The color must not be opaque to not hide underlying decorations."), true);
var editorFindMatchBorder = registerColor('editor.findMatchBorder', { light: null, dark: null, hc: activeContrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('editorFindMatchBorder', "Border color of the current search match."));
var editorFindMatchHighlightBorder = registerColor('editor.findMatchHighlightBorder', { light: null, dark: null, hc: activeContrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('findMatchHighlightBorder', "Border color of the other search matches."));
var editorFindRangeHighlightBorder = registerColor('editor.findRangeHighlightBorder', { dark: null, light: null, hc: transparent(activeContrastBorder, 0.4) }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('findRangeHighlightBorder', "Border color of the range limiting the search. The color must not be opaque to not hide underlying decorations."), true);
/**
 * Editor hover
 */
var editorHoverHighlight = registerColor('editor.hoverHighlightBackground', { light: '#ADD6FF26', dark: '#264f7840', hc: '#ADD6FF26' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('hoverHighlight', 'Highlight below the word for which a hover is shown. The color must not be opaque to not hide underlying decorations.'), true);
var editorHoverBackground = registerColor('editorHoverWidget.background', { light: editorWidgetBackground, dark: editorWidgetBackground, hc: editorWidgetBackground }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('hoverBackground', 'Background color of the editor hover.'));
var editorHoverBorder = registerColor('editorHoverWidget.border', { light: editorWidgetBorder, dark: editorWidgetBorder, hc: editorWidgetBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('hoverBorder', 'Border color of the editor hover.'));
/**
 * Editor link colors
 */
var editorActiveLinkForeground = registerColor('editorLink.activeForeground', { dark: '#4E94CE', light: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].blue, hc: __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].cyan }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('activeLinkForeground', 'Color of active links.'));
/**
 * Diff Editor Colors
 */
var defaultInsertColor = new __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["c" /* RGBA */](155, 185, 85, 0.2));
var defaultRemoveColor = new __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["c" /* RGBA */](255, 0, 0, 0.2));
var diffInserted = registerColor('diffEditor.insertedTextBackground', { dark: defaultInsertColor, light: defaultInsertColor, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('diffEditorInserted', 'Background color for text that got inserted. The color must not be opaque to not hide underlying decorations.'), true);
var diffRemoved = registerColor('diffEditor.removedTextBackground', { dark: defaultRemoveColor, light: defaultRemoveColor, hc: null }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('diffEditorRemoved', 'Background color for text that got removed. The color must not be opaque to not hide underlying decorations.'), true);
var diffInsertedOutline = registerColor('diffEditor.insertedTextBorder', { dark: null, light: null, hc: '#33ff2eff' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('diffEditorInsertedOutline', 'Outline color for the text that got inserted.'));
var diffRemovedOutline = registerColor('diffEditor.removedTextBorder', { dark: null, light: null, hc: '#FF008F' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('diffEditorRemovedOutline', 'Outline color for text that got removed.'));
var diffBorder = registerColor('diffEditor.border', { dark: null, light: null, hc: contrastBorder }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('diffEditorBorder', 'Border color between the two text editors.'));
var findMatchColorDefault = new __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["c" /* RGBA */](246, 185, 77, 0.7));
var overviewRulerFindMatchForeground = registerColor('editorOverviewRuler.findMatchForeground', { dark: findMatchColorDefault, light: findMatchColorDefault, hc: findMatchColorDefault }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('overviewRulerFindMatchForeground', 'Overview ruler marker color for find matches. The color must not be opaque to not hide underlying decorations.'), true);
var overviewRulerSelectionHighlightForeground = registerColor('editorOverviewRuler.selectionHighlightForeground', { dark: '#A0A0A0CC', light: '#A0A0A0CC', hc: '#A0A0A0CC' }, __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('overviewRulerSelectionHighlightForeground', 'Overview ruler marker color for selection highlights. The color must not be opaque to not hide underlying decorations.'), true);
function transparent(colorValue, factor) {
    return function (theme) {
        var color = resolveColorValue(colorValue, theme);
        if (color) {
            return color.transparent(factor);
        }
        return null;
    };
}
function oneOf() {
    var colorValues = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        colorValues[_i] = arguments[_i];
    }
    return function (theme) {
        for (var _i = 0, colorValues_1 = colorValues; _i < colorValues_1.length; _i++) {
            var colorValue = colorValues_1[_i];
            var color = resolveColorValue(colorValue, theme);
            if (color) {
                return color;
            }
        }
        return null;
    };
}
function lessProminent(colorValue, backgroundColorValue, factor, transparency) {
    return function (theme) {
        var from = resolveColorValue(colorValue, theme);
        if (from) {
            var backgroundColor = resolveColorValue(backgroundColorValue, theme);
            if (backgroundColor) {
                if (from.isDarkerThan(backgroundColor)) {
                    return __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].getLighterColor(from, backgroundColor, factor).transparent(transparency);
                }
                return __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].getDarkerColor(from, backgroundColor, factor).transparent(transparency);
            }
            return from.transparent(factor * transparency);
        }
        return null;
    };
}
// ----- implementation
/**
 * @param colorValue Resolve a color value in the context of a theme
 */
function resolveColorValue(colorValue, theme) {
    if (colorValue === null) {
        return null;
    }
    else if (typeof colorValue === 'string') {
        if (colorValue[0] === '#') {
            return __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */].fromHex(colorValue);
        }
        return theme.getColor(colorValue);
    }
    else if (colorValue instanceof __WEBPACK_IMPORTED_MODULE_1__base_common_color_js__["a" /* Color */]) {
        return colorValue;
    }
    else if (typeof colorValue === 'function') {
        return colorValue(theme);
    }
    return null;
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentWidgetPositionPreference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OverlayWidgetPositionPreference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MouseTargetType; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isCodeEditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_editorCommon_js__ = __webpack_require__(59);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


/**
 * A positioning preference for rendering content widgets.
 */
var ContentWidgetPositionPreference;
(function (ContentWidgetPositionPreference) {
    /**
     * Place the content widget exactly at a position
     */
    ContentWidgetPositionPreference[ContentWidgetPositionPreference["EXACT"] = 0] = "EXACT";
    /**
     * Place the content widget above a position
     */
    ContentWidgetPositionPreference[ContentWidgetPositionPreference["ABOVE"] = 1] = "ABOVE";
    /**
     * Place the content widget below a position
     */
    ContentWidgetPositionPreference[ContentWidgetPositionPreference["BELOW"] = 2] = "BELOW";
})(ContentWidgetPositionPreference || (ContentWidgetPositionPreference = {}));
/**
 * A positioning preference for rendering overlay widgets.
 */
var OverlayWidgetPositionPreference;
(function (OverlayWidgetPositionPreference) {
    /**
     * Position the overlay widget in the top right corner
     */
    OverlayWidgetPositionPreference[OverlayWidgetPositionPreference["TOP_RIGHT_CORNER"] = 0] = "TOP_RIGHT_CORNER";
    /**
     * Position the overlay widget in the bottom right corner
     */
    OverlayWidgetPositionPreference[OverlayWidgetPositionPreference["BOTTOM_RIGHT_CORNER"] = 1] = "BOTTOM_RIGHT_CORNER";
    /**
     * Position the overlay widget in the top center
     */
    OverlayWidgetPositionPreference[OverlayWidgetPositionPreference["TOP_CENTER"] = 2] = "TOP_CENTER";
})(OverlayWidgetPositionPreference || (OverlayWidgetPositionPreference = {}));
/**
 * Type of hit element with the mouse in the editor.
 */
var MouseTargetType;
(function (MouseTargetType) {
    /**
     * Mouse is on top of an unknown element.
     */
    MouseTargetType[MouseTargetType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Mouse is on top of the textarea used for input.
     */
    MouseTargetType[MouseTargetType["TEXTAREA"] = 1] = "TEXTAREA";
    /**
     * Mouse is on top of the glyph margin
     */
    MouseTargetType[MouseTargetType["GUTTER_GLYPH_MARGIN"] = 2] = "GUTTER_GLYPH_MARGIN";
    /**
     * Mouse is on top of the line numbers
     */
    MouseTargetType[MouseTargetType["GUTTER_LINE_NUMBERS"] = 3] = "GUTTER_LINE_NUMBERS";
    /**
     * Mouse is on top of the line decorations
     */
    MouseTargetType[MouseTargetType["GUTTER_LINE_DECORATIONS"] = 4] = "GUTTER_LINE_DECORATIONS";
    /**
     * Mouse is on top of the whitespace left in the gutter by a view zone.
     */
    MouseTargetType[MouseTargetType["GUTTER_VIEW_ZONE"] = 5] = "GUTTER_VIEW_ZONE";
    /**
     * Mouse is on top of text in the content.
     */
    MouseTargetType[MouseTargetType["CONTENT_TEXT"] = 6] = "CONTENT_TEXT";
    /**
     * Mouse is on top of empty space in the content (e.g. after line text or below last line)
     */
    MouseTargetType[MouseTargetType["CONTENT_EMPTY"] = 7] = "CONTENT_EMPTY";
    /**
     * Mouse is on top of a view zone in the content.
     */
    MouseTargetType[MouseTargetType["CONTENT_VIEW_ZONE"] = 8] = "CONTENT_VIEW_ZONE";
    /**
     * Mouse is on top of a content widget.
     */
    MouseTargetType[MouseTargetType["CONTENT_WIDGET"] = 9] = "CONTENT_WIDGET";
    /**
     * Mouse is on top of the decorations overview ruler.
     */
    MouseTargetType[MouseTargetType["OVERVIEW_RULER"] = 10] = "OVERVIEW_RULER";
    /**
     * Mouse is on top of a scrollbar.
     */
    MouseTargetType[MouseTargetType["SCROLLBAR"] = 11] = "SCROLLBAR";
    /**
     * Mouse is on top of an overlay widget.
     */
    MouseTargetType[MouseTargetType["OVERLAY_WIDGET"] = 12] = "OVERLAY_WIDGET";
    /**
     * Mouse is outside of the editor.
     */
    MouseTargetType[MouseTargetType["OUTSIDE_EDITOR"] = 13] = "OUTSIDE_EDITOR";
})(MouseTargetType || (MouseTargetType = {}));
/**
 *@internal
 */
function isCodeEditor(thing) {
    if (thing && typeof thing.getEditorType === 'function') {
        return thing.getEditorType() === __WEBPACK_IMPORTED_MODULE_0__common_editorCommon_js__["a" /* EditorType */].ICodeEditor;
    }
    else {
        return false;
    }
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OverviewRulerLane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EndOfLinePreference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultEndOfLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EndOfLineSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TextModelResolvedOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FindMatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TrackedRangeStickiness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplyEditsResult; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Vertical Lane in the overview ruler of the editor.
 */
var OverviewRulerLane;
(function (OverviewRulerLane) {
    OverviewRulerLane[OverviewRulerLane["Left"] = 1] = "Left";
    OverviewRulerLane[OverviewRulerLane["Center"] = 2] = "Center";
    OverviewRulerLane[OverviewRulerLane["Right"] = 4] = "Right";
    OverviewRulerLane[OverviewRulerLane["Full"] = 7] = "Full";
})(OverviewRulerLane || (OverviewRulerLane = {}));
/**
 * End of line character preference.
 */
var EndOfLinePreference;
(function (EndOfLinePreference) {
    /**
     * Use the end of line character identified in the text buffer.
     */
    EndOfLinePreference[EndOfLinePreference["TextDefined"] = 0] = "TextDefined";
    /**
     * Use line feed (\n) as the end of line character.
     */
    EndOfLinePreference[EndOfLinePreference["LF"] = 1] = "LF";
    /**
     * Use carriage return and line feed (\r\n) as the end of line character.
     */
    EndOfLinePreference[EndOfLinePreference["CRLF"] = 2] = "CRLF";
})(EndOfLinePreference || (EndOfLinePreference = {}));
/**
 * The default end of line to use when instantiating models.
 */
var DefaultEndOfLine;
(function (DefaultEndOfLine) {
    /**
     * Use line feed (\n) as the end of line character.
     */
    DefaultEndOfLine[DefaultEndOfLine["LF"] = 1] = "LF";
    /**
     * Use carriage return and line feed (\r\n) as the end of line character.
     */
    DefaultEndOfLine[DefaultEndOfLine["CRLF"] = 2] = "CRLF";
})(DefaultEndOfLine || (DefaultEndOfLine = {}));
/**
 * End of line character preference.
 */
var EndOfLineSequence;
(function (EndOfLineSequence) {
    /**
     * Use line feed (\n) as the end of line character.
     */
    EndOfLineSequence[EndOfLineSequence["LF"] = 0] = "LF";
    /**
     * Use carriage return and line feed (\r\n) as the end of line character.
     */
    EndOfLineSequence[EndOfLineSequence["CRLF"] = 1] = "CRLF";
})(EndOfLineSequence || (EndOfLineSequence = {}));
var TextModelResolvedOptions = /** @class */ (function () {
    /**
     * @internal
     */
    function TextModelResolvedOptions(src) {
        this.tabSize = src.tabSize | 0;
        this.insertSpaces = Boolean(src.insertSpaces);
        this.defaultEOL = src.defaultEOL | 0;
        this.trimAutoWhitespace = Boolean(src.trimAutoWhitespace);
    }
    /**
     * @internal
     */
    TextModelResolvedOptions.prototype.equals = function (other) {
        return (this.tabSize === other.tabSize
            && this.insertSpaces === other.insertSpaces
            && this.defaultEOL === other.defaultEOL
            && this.trimAutoWhitespace === other.trimAutoWhitespace);
    };
    /**
     * @internal
     */
    TextModelResolvedOptions.prototype.createChangeEvent = function (newOpts) {
        return {
            tabSize: this.tabSize !== newOpts.tabSize,
            insertSpaces: this.insertSpaces !== newOpts.insertSpaces,
            trimAutoWhitespace: this.trimAutoWhitespace !== newOpts.trimAutoWhitespace,
        };
    };
    return TextModelResolvedOptions;
}());

var FindMatch = /** @class */ (function () {
    /**
     * @internal
     */
    function FindMatch(range, matches) {
        this.range = range;
        this.matches = matches;
    }
    return FindMatch;
}());

/**
 * Describes the behavior of decorations when typing/editing near their edges.
 * Note: Please do not edit the values, as they very carefully match `DecorationRangeBehavior`
 */
var TrackedRangeStickiness;
(function (TrackedRangeStickiness) {
    TrackedRangeStickiness[TrackedRangeStickiness["AlwaysGrowsWhenTypingAtEdges"] = 0] = "AlwaysGrowsWhenTypingAtEdges";
    TrackedRangeStickiness[TrackedRangeStickiness["NeverGrowsWhenTypingAtEdges"] = 1] = "NeverGrowsWhenTypingAtEdges";
    TrackedRangeStickiness[TrackedRangeStickiness["GrowsOnlyWhenTypingBefore"] = 2] = "GrowsOnlyWhenTypingBefore";
    TrackedRangeStickiness[TrackedRangeStickiness["GrowsOnlyWhenTypingAfter"] = 3] = "GrowsOnlyWhenTypingAfter";
})(TrackedRangeStickiness || (TrackedRangeStickiness = {}));
/**
 * @internal
 */
var ApplyEditsResult = /** @class */ (function () {
    function ApplyEditsResult(reverseEdits, changes, trimAutoWhitespaceLineNumbers) {
        this.reverseEdits = reverseEdits;
        this.changes = changes;
        this.trimAutoWhitespaceLineNumbers = trimAutoWhitespaceLineNumbers;
    }
    return ApplyEditsResult;
}());



/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["n"] = tail;
/* harmony export (immutable) */ __webpack_exports__["e"] = equals;
/* harmony export (immutable) */ __webpack_exports__["b"] = binarySearch;
/* harmony export (immutable) */ __webpack_exports__["f"] = findFirstInSorted;
/* harmony export (immutable) */ __webpack_exports__["l"] = mergeSort;
/* harmony export (immutable) */ __webpack_exports__["j"] = groupBy;
/* harmony export (immutable) */ __webpack_exports__["c"] = coalesce;
/* harmony export (immutable) */ __webpack_exports__["k"] = isFalsyOrEmpty;
/* harmony export (immutable) */ __webpack_exports__["d"] = distinct;
/* harmony export (immutable) */ __webpack_exports__["h"] = firstIndex;
/* harmony export (immutable) */ __webpack_exports__["g"] = first;
/* harmony export (immutable) */ __webpack_exports__["i"] = flatten;
/* harmony export (immutable) */ __webpack_exports__["m"] = range;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayInsert;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Returns the last element of an array.
 * @param array The array.
 * @param n Which element from the end (default is zero).
 */
function tail(array, n) {
    if (n === void 0) { n = 0; }
    return array[array.length - (1 + n)];
}
function equals(one, other, itemEquals) {
    if (itemEquals === void 0) { itemEquals = function (a, b) { return a === b; }; }
    if (one.length !== other.length) {
        return false;
    }
    for (var i = 0, len = one.length; i < len; i++) {
        if (!itemEquals(one[i], other[i])) {
            return false;
        }
    }
    return true;
}
function binarySearch(array, key, comparator) {
    var low = 0, high = array.length - 1;
    while (low <= high) {
        var mid = ((low + high) / 2) | 0;
        var comp = comparator(array[mid], key);
        if (comp < 0) {
            low = mid + 1;
        }
        else if (comp > 0) {
            high = mid - 1;
        }
        else {
            return mid;
        }
    }
    return -(low + 1);
}
/**
 * Takes a sorted array and a function p. The array is sorted in such a way that all elements where p(x) is false
 * are located before all elements where p(x) is true.
 * @returns the least x for which p(x) is true or array.length if no element fullfills the given function.
 */
function findFirstInSorted(array, p) {
    var low = 0, high = array.length;
    if (high === 0) {
        return 0; // no children
    }
    while (low < high) {
        var mid = Math.floor((low + high) / 2);
        if (p(array[mid])) {
            high = mid;
        }
        else {
            low = mid + 1;
        }
    }
    return low;
}
/**
 * Like `Array#sort` but always stable. Usually runs a little slower `than Array#sort`
 * so only use this when actually needing stable sort.
 */
function mergeSort(data, compare) {
    _sort(data, compare, 0, data.length - 1, []);
    return data;
}
function _merge(a, compare, lo, mid, hi, aux) {
    var leftIdx = lo, rightIdx = mid + 1;
    for (var i = lo; i <= hi; i++) {
        aux[i] = a[i];
    }
    for (var i = lo; i <= hi; i++) {
        if (leftIdx > mid) {
            // left side consumed
            a[i] = aux[rightIdx++];
        }
        else if (rightIdx > hi) {
            // right side consumed
            a[i] = aux[leftIdx++];
        }
        else if (compare(aux[rightIdx], aux[leftIdx]) < 0) {
            // right element is less -> comes first
            a[i] = aux[rightIdx++];
        }
        else {
            // left element comes first (less or equal)
            a[i] = aux[leftIdx++];
        }
    }
}
function _sort(a, compare, lo, hi, aux) {
    if (hi <= lo) {
        return;
    }
    var mid = lo + ((hi - lo) / 2) | 0;
    _sort(a, compare, lo, mid, aux);
    _sort(a, compare, mid + 1, hi, aux);
    if (compare(a[mid], a[mid + 1]) <= 0) {
        // left and right are sorted and if the last-left element is less
        // or equals than the first-right element there is nothing else
        // to do
        return;
    }
    _merge(a, compare, lo, mid, hi, aux);
}
function groupBy(data, compare) {
    var result = [];
    var currentGroup;
    for (var _i = 0, _a = mergeSort(data.slice(0), compare); _i < _a.length; _i++) {
        var element = _a[_i];
        if (!currentGroup || compare(currentGroup[0], element) !== 0) {
            currentGroup = [element];
            result.push(currentGroup);
        }
        else {
            currentGroup.push(element);
        }
    }
    return result;
}
function coalesce(array, inplace) {
    if (!array) {
        if (!inplace) {
            return array;
        }
    }
    if (!inplace) {
        return array.filter(function (e) { return !!e; });
    }
    else {
        var to = 0;
        for (var i = 0; i < array.length; i++) {
            if (!!array[i]) {
                array[to] = array[i];
                to += 1;
            }
        }
        array.length = to;
    }
}
/**
 * @returns {{false}} if the provided object is an array
 * 	and not empty.
 */
function isFalsyOrEmpty(obj) {
    return !Array.isArray(obj) || obj.length === 0;
}
/**
 * Removes duplicates from the given array. The optional keyFn allows to specify
 * how elements are checked for equalness by returning a unique string for each.
 */
function distinct(array, keyFn) {
    if (!keyFn) {
        return array.filter(function (element, position) {
            return array.indexOf(element) === position;
        });
    }
    var seen = Object.create(null);
    return array.filter(function (elem) {
        var key = keyFn(elem);
        if (seen[key]) {
            return false;
        }
        seen[key] = true;
        return true;
    });
}
function firstIndex(array, fn) {
    for (var i = 0; i < array.length; i++) {
        var element = array[i];
        if (fn(element)) {
            return i;
        }
    }
    return -1;
}
function first(array, fn, notFoundValue) {
    if (notFoundValue === void 0) { notFoundValue = null; }
    var index = firstIndex(array, fn);
    return index < 0 ? notFoundValue : array[index];
}
function flatten(arr) {
    return [].concat.apply([], arr);
}
function range(arg, to) {
    var from = typeof to === 'number' ? arg : 0;
    if (typeof to === 'number') {
        from = arg;
    }
    else {
        from = 0;
        to = arg;
    }
    var result = [];
    if (from <= to) {
        for (var i = from; i < to; i++) {
            result.push(i);
        }
    }
    else {
        for (var i = from; i > to; i--) {
            result.push(i);
        }
    }
    return result;
}
/**
 * Insert `insertArr` inside `target` at `insertIndex`.
 * Please don't touch unless you understand https://jsperf.com/inserting-an-array-within-an-array
 */
function arrayInsert(target, insertIndex, insertArr) {
    var before = target.slice(0, insertIndex);
    var after = target.slice(insertIndex);
    return before.concat(insertArr, after);
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FastDomNode; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createFastDomNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var FastDomNode = /** @class */ (function () {
    function FastDomNode(domNode) {
        this.domNode = domNode;
        this._maxWidth = -1;
        this._width = -1;
        this._height = -1;
        this._top = -1;
        this._left = -1;
        this._bottom = -1;
        this._right = -1;
        this._fontFamily = '';
        this._fontWeight = '';
        this._fontSize = -1;
        this._lineHeight = -1;
        this._letterSpacing = -100;
        this._className = '';
        this._display = '';
        this._position = '';
        this._visibility = '';
        this._layerHint = false;
    }
    FastDomNode.prototype.setMaxWidth = function (maxWidth) {
        if (this._maxWidth === maxWidth) {
            return;
        }
        this._maxWidth = maxWidth;
        this.domNode.style.maxWidth = this._maxWidth + 'px';
    };
    FastDomNode.prototype.setWidth = function (width) {
        if (this._width === width) {
            return;
        }
        this._width = width;
        this.domNode.style.width = this._width + 'px';
    };
    FastDomNode.prototype.setHeight = function (height) {
        if (this._height === height) {
            return;
        }
        this._height = height;
        this.domNode.style.height = this._height + 'px';
    };
    FastDomNode.prototype.setTop = function (top) {
        if (this._top === top) {
            return;
        }
        this._top = top;
        this.domNode.style.top = this._top + 'px';
    };
    FastDomNode.prototype.unsetTop = function () {
        if (this._top === -1) {
            return;
        }
        this._top = -1;
        this.domNode.style.top = '';
    };
    FastDomNode.prototype.setLeft = function (left) {
        if (this._left === left) {
            return;
        }
        this._left = left;
        this.domNode.style.left = this._left + 'px';
    };
    FastDomNode.prototype.setBottom = function (bottom) {
        if (this._bottom === bottom) {
            return;
        }
        this._bottom = bottom;
        this.domNode.style.bottom = this._bottom + 'px';
    };
    FastDomNode.prototype.setRight = function (right) {
        if (this._right === right) {
            return;
        }
        this._right = right;
        this.domNode.style.right = this._right + 'px';
    };
    FastDomNode.prototype.setFontFamily = function (fontFamily) {
        if (this._fontFamily === fontFamily) {
            return;
        }
        this._fontFamily = fontFamily;
        this.domNode.style.fontFamily = this._fontFamily;
    };
    FastDomNode.prototype.setFontWeight = function (fontWeight) {
        if (this._fontWeight === fontWeight) {
            return;
        }
        this._fontWeight = fontWeight;
        this.domNode.style.fontWeight = this._fontWeight;
    };
    FastDomNode.prototype.setFontSize = function (fontSize) {
        if (this._fontSize === fontSize) {
            return;
        }
        this._fontSize = fontSize;
        this.domNode.style.fontSize = this._fontSize + 'px';
    };
    FastDomNode.prototype.setLineHeight = function (lineHeight) {
        if (this._lineHeight === lineHeight) {
            return;
        }
        this._lineHeight = lineHeight;
        this.domNode.style.lineHeight = this._lineHeight + 'px';
    };
    FastDomNode.prototype.setLetterSpacing = function (letterSpacing) {
        if (this._letterSpacing === letterSpacing) {
            return;
        }
        this._letterSpacing = letterSpacing;
        this.domNode.style.letterSpacing = this._letterSpacing + 'px';
    };
    FastDomNode.prototype.setClassName = function (className) {
        if (this._className === className) {
            return;
        }
        this._className = className;
        this.domNode.className = this._className;
    };
    FastDomNode.prototype.toggleClassName = function (className, shouldHaveIt) {
        __WEBPACK_IMPORTED_MODULE_0__dom_js__["N" /* toggleClass */](this.domNode, className, shouldHaveIt);
        this._className = this.domNode.className;
    };
    FastDomNode.prototype.setDisplay = function (display) {
        if (this._display === display) {
            return;
        }
        this._display = display;
        this.domNode.style.display = this._display;
    };
    FastDomNode.prototype.setPosition = function (position) {
        if (this._position === position) {
            return;
        }
        this._position = position;
        this.domNode.style.position = this._position;
    };
    FastDomNode.prototype.setVisibility = function (visibility) {
        if (this._visibility === visibility) {
            return;
        }
        this._visibility = visibility;
        this.domNode.style.visibility = this._visibility;
    };
    FastDomNode.prototype.setLayerHinting = function (layerHint) {
        if (this._layerHint === layerHint) {
            return;
        }
        this._layerHint = layerHint;
        this.domNode.style.willChange = this._layerHint ? 'transform' : 'auto';
    };
    FastDomNode.prototype.setAttribute = function (name, value) {
        this.domNode.setAttribute(name, value);
    };
    FastDomNode.prototype.removeAttribute = function (name) {
        this.domNode.removeAttribute(name);
    };
    FastDomNode.prototype.appendChild = function (child) {
        this.domNode.appendChild(child.domNode);
    };
    FastDomNode.prototype.removeChild = function (child) {
        this.domNode.removeChild(child.domNode);
    };
    return FastDomNode;
}());

function createFastDomNode(domNode) {
    return new FastDomNode(domNode);
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RGBA; });
/* unused harmony export HSLA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HSVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
function roundFloat(number, decimalPoints) {
    var decimal = Math.pow(10, decimalPoints);
    return Math.round(number * decimal) / decimal;
}
var RGBA = /** @class */ (function () {
    function RGBA(r, g, b, a) {
        if (a === void 0) { a = 1; }
        this.r = Math.min(255, Math.max(0, r)) | 0;
        this.g = Math.min(255, Math.max(0, g)) | 0;
        this.b = Math.min(255, Math.max(0, b)) | 0;
        this.a = roundFloat(Math.max(Math.min(1, a), 0), 3);
    }
    RGBA.equals = function (a, b) {
        return a.r === b.r && a.g === b.g && a.b === b.b && a.a === b.a;
    };
    return RGBA;
}());

var HSLA = /** @class */ (function () {
    function HSLA(h, s, l, a) {
        this.h = Math.max(Math.min(360, h), 0) | 0;
        this.s = roundFloat(Math.max(Math.min(1, s), 0), 3);
        this.l = roundFloat(Math.max(Math.min(1, l), 0), 3);
        this.a = roundFloat(Math.max(Math.min(1, a), 0), 3);
    }
    HSLA.equals = function (a, b) {
        return a.h === b.h && a.s === b.s && a.l === b.l && a.a === b.a;
    };
    /**
     * Converts an RGB color value to HSL. Conversion formula
     * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
     * Assumes r, g, and b are contained in the set [0, 255] and
     * returns h in the set [0, 360], s, and l in the set [0, 1].
     */
    HSLA.fromRGBA = function (rgba) {
        var r = rgba.r / 255;
        var g = rgba.g / 255;
        var b = rgba.b / 255;
        var a = rgba.a;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var h = 0;
        var s = 0;
        var l = (min + max) / 2;
        var chroma = max - min;
        if (chroma > 0) {
            s = Math.min((l <= 0.5 ? chroma / (2 * l) : chroma / (2 - (2 * l))), 1);
            switch (max) {
                case r:
                    h = (g - b) / chroma + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / chroma + 2;
                    break;
                case b:
                    h = (r - g) / chroma + 4;
                    break;
            }
            h *= 60;
            h = Math.round(h);
        }
        return new HSLA(h, s, l, a);
    };
    HSLA._hue2rgb = function (p, q, t) {
        if (t < 0) {
            t += 1;
        }
        if (t > 1) {
            t -= 1;
        }
        if (t < 1 / 6) {
            return p + (q - p) * 6 * t;
        }
        if (t < 1 / 2) {
            return q;
        }
        if (t < 2 / 3) {
            return p + (q - p) * (2 / 3 - t) * 6;
        }
        return p;
    };
    /**
     * Converts an HSL color value to RGB. Conversion formula
     * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
     * Assumes h in the set [0, 360] s, and l are contained in the set [0, 1] and
     * returns r, g, and b in the set [0, 255].
     */
    HSLA.toRGBA = function (hsla) {
        var h = hsla.h / 360;
        var s = hsla.s, l = hsla.l, a = hsla.a;
        var r, g, b;
        if (s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = HSLA._hue2rgb(p, q, h + 1 / 3);
            g = HSLA._hue2rgb(p, q, h);
            b = HSLA._hue2rgb(p, q, h - 1 / 3);
        }
        return new RGBA(Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), a);
    };
    return HSLA;
}());

var HSVA = /** @class */ (function () {
    function HSVA(h, s, v, a) {
        this.h = Math.max(Math.min(360, h), 0) | 0;
        this.s = roundFloat(Math.max(Math.min(1, s), 0), 3);
        this.v = roundFloat(Math.max(Math.min(1, v), 0), 3);
        this.a = roundFloat(Math.max(Math.min(1, a), 0), 3);
    }
    HSVA.equals = function (a, b) {
        return a.h === b.h && a.s === b.s && a.v === b.v && a.a === b.a;
    };
    // from http://www.rapidtables.com/convert/color/rgb-to-hsv.htm
    HSVA.fromRGBA = function (rgba) {
        var r = rgba.r / 255;
        var g = rgba.g / 255;
        var b = rgba.b / 255;
        var cmax = Math.max(r, g, b);
        var cmin = Math.min(r, g, b);
        var delta = cmax - cmin;
        var s = cmax === 0 ? 0 : (delta / cmax);
        var m;
        if (delta === 0) {
            m = 0;
        }
        else if (cmax === r) {
            m = ((((g - b) / delta) % 6) + 6) % 6;
        }
        else if (cmax === g) {
            m = ((b - r) / delta) + 2;
        }
        else {
            m = ((r - g) / delta) + 4;
        }
        return new HSVA(Math.round(m * 60), s, cmax, rgba.a);
    };
    // from http://www.rapidtables.com/convert/color/hsv-to-rgb.htm
    HSVA.toRGBA = function (hsva) {
        var h = hsva.h, s = hsva.s, v = hsva.v, a = hsva.a;
        var c = v * s;
        var x = c * (1 - Math.abs((h / 60) % 2 - 1));
        var m = v - c;
        var _a = [0, 0, 0], r = _a[0], g = _a[1], b = _a[2];
        if (h < 60) {
            r = c;
            g = x;
        }
        else if (h < 120) {
            r = x;
            g = c;
        }
        else if (h < 180) {
            g = c;
            b = x;
        }
        else if (h < 240) {
            g = x;
            b = c;
        }
        else if (h < 300) {
            r = x;
            b = c;
        }
        else if (h < 360) {
            r = c;
            b = x;
        }
        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);
        return new RGBA(r, g, b, a);
    };
    return HSVA;
}());

var Color = /** @class */ (function () {
    function Color(arg) {
        if (!arg) {
            throw new Error('Color needs a value');
        }
        else if (arg instanceof RGBA) {
            this.rgba = arg;
        }
        else if (arg instanceof HSLA) {
            this._hsla = arg;
            this.rgba = HSLA.toRGBA(arg);
        }
        else if (arg instanceof HSVA) {
            this._hsva = arg;
            this.rgba = HSVA.toRGBA(arg);
        }
        else {
            throw new Error('Invalid color ctor argument');
        }
    }
    Color.fromHex = function (hex) {
        return Color.Format.CSS.parseHex(hex) || Color.red;
    };
    Object.defineProperty(Color.prototype, "hsla", {
        get: function () {
            if (this._hsla) {
                return this._hsla;
            }
            else {
                return HSLA.fromRGBA(this.rgba);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "hsva", {
        get: function () {
            if (this._hsva) {
                return this._hsva;
            }
            return HSVA.fromRGBA(this.rgba);
        },
        enumerable: true,
        configurable: true
    });
    Color.prototype.equals = function (other) {
        return !!other && RGBA.equals(this.rgba, other.rgba) && HSLA.equals(this.hsla, other.hsla) && HSVA.equals(this.hsva, other.hsva);
    };
    /**
     * http://www.w3.org/TR/WCAG20/#relativeluminancedef
     * Returns the number in the set [0, 1]. O => Darkest Black. 1 => Lightest white.
     */
    Color.prototype.getRelativeLuminance = function () {
        var R = Color._relativeLuminanceForComponent(this.rgba.r);
        var G = Color._relativeLuminanceForComponent(this.rgba.g);
        var B = Color._relativeLuminanceForComponent(this.rgba.b);
        var luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B;
        return roundFloat(luminance, 4);
    };
    Color._relativeLuminanceForComponent = function (color) {
        var c = color / 255;
        return (c <= 0.03928) ? c / 12.92 : Math.pow(((c + 0.055) / 1.055), 2.4);
    };
    /**
     *	http://24ways.org/2010/calculating-color-contrast
     *  Return 'true' if lighter color otherwise 'false'
     */
    Color.prototype.isLighter = function () {
        var yiq = (this.rgba.r * 299 + this.rgba.g * 587 + this.rgba.b * 114) / 1000;
        return yiq >= 128;
    };
    Color.prototype.isLighterThan = function (another) {
        var lum1 = this.getRelativeLuminance();
        var lum2 = another.getRelativeLuminance();
        return lum1 > lum2;
    };
    Color.prototype.isDarkerThan = function (another) {
        var lum1 = this.getRelativeLuminance();
        var lum2 = another.getRelativeLuminance();
        return lum1 < lum2;
    };
    Color.prototype.lighten = function (factor) {
        return new Color(new HSLA(this.hsla.h, this.hsla.s, this.hsla.l + this.hsla.l * factor, this.hsla.a));
    };
    Color.prototype.darken = function (factor) {
        return new Color(new HSLA(this.hsla.h, this.hsla.s, this.hsla.l - this.hsla.l * factor, this.hsla.a));
    };
    Color.prototype.transparent = function (factor) {
        var _a = this.rgba, r = _a.r, g = _a.g, b = _a.b, a = _a.a;
        return new Color(new RGBA(r, g, b, a * factor));
    };
    Color.prototype.isTransparent = function () {
        return this.rgba.a === 0;
    };
    Color.prototype.isOpaque = function () {
        return this.rgba.a === 1;
    };
    Color.prototype.opposite = function () {
        return new Color(new RGBA(255 - this.rgba.r, 255 - this.rgba.g, 255 - this.rgba.b, this.rgba.a));
    };
    Color.prototype.toString = function () {
        return Color.Format.CSS.format(this);
    };
    Color.getLighterColor = function (of, relative, factor) {
        if (of.isLighterThan(relative)) {
            return of;
        }
        factor = factor ? factor : 0.5;
        var lum1 = of.getRelativeLuminance();
        var lum2 = relative.getRelativeLuminance();
        factor = factor * (lum2 - lum1) / lum2;
        return of.lighten(factor);
    };
    Color.getDarkerColor = function (of, relative, factor) {
        if (of.isDarkerThan(relative)) {
            return of;
        }
        factor = factor ? factor : 0.5;
        var lum1 = of.getRelativeLuminance();
        var lum2 = relative.getRelativeLuminance();
        factor = factor * (lum1 - lum2) / lum1;
        return of.darken(factor);
    };
    Color.white = new Color(new RGBA(255, 255, 255, 1));
    Color.black = new Color(new RGBA(0, 0, 0, 1));
    Color.red = new Color(new RGBA(255, 0, 0, 1));
    Color.blue = new Color(new RGBA(0, 0, 255, 1));
    Color.cyan = new Color(new RGBA(0, 255, 255, 1));
    Color.lightgrey = new Color(new RGBA(211, 211, 211, 1));
    Color.transparent = new Color(new RGBA(0, 0, 0, 0));
    return Color;
}());

(function (Color) {
    var Format;
    (function (Format) {
        var CSS;
        (function (CSS) {
            function formatRGB(color) {
                if (color.rgba.a === 1) {
                    return "rgb(" + color.rgba.r + ", " + color.rgba.g + ", " + color.rgba.b + ")";
                }
                return Color.Format.CSS.formatRGBA(color);
            }
            CSS.formatRGB = formatRGB;
            function formatRGBA(color) {
                return "rgba(" + color.rgba.r + ", " + color.rgba.g + ", " + color.rgba.b + ", " + +(color.rgba.a).toFixed(2) + ")";
            }
            CSS.formatRGBA = formatRGBA;
            function formatHSL(color) {
                if (color.hsla.a === 1) {
                    return "hsl(" + color.hsla.h + ", " + (color.hsla.s * 100).toFixed(2) + "%, " + (color.hsla.l * 100).toFixed(2) + "%)";
                }
                return Color.Format.CSS.formatHSLA(color);
            }
            CSS.formatHSL = formatHSL;
            function formatHSLA(color) {
                return "hsla(" + color.hsla.h + ", " + (color.hsla.s * 100).toFixed(2) + "%, " + (color.hsla.l * 100).toFixed(2) + "%, " + color.hsla.a.toFixed(2) + ")";
            }
            CSS.formatHSLA = formatHSLA;
            function _toTwoDigitHex(n) {
                var r = n.toString(16);
                return r.length !== 2 ? '0' + r : r;
            }
            /**
             * Formats the color as #RRGGBB
             */
            function formatHex(color) {
                return "#" + _toTwoDigitHex(color.rgba.r) + _toTwoDigitHex(color.rgba.g) + _toTwoDigitHex(color.rgba.b);
            }
            CSS.formatHex = formatHex;
            /**
             * Formats the color as #RRGGBBAA
             * If 'compact' is set, colors without transparancy will be printed as #RRGGBB
             */
            function formatHexA(color, compact) {
                if (compact === void 0) { compact = false; }
                if (compact && color.rgba.a === 1) {
                    return Color.Format.CSS.formatHex(color);
                }
                return "#" + _toTwoDigitHex(color.rgba.r) + _toTwoDigitHex(color.rgba.g) + _toTwoDigitHex(color.rgba.b) + _toTwoDigitHex(Math.round(color.rgba.a * 255));
            }
            CSS.formatHexA = formatHexA;
            /**
             * The default format will use HEX if opaque and RGBA otherwise.
             */
            function format(color) {
                if (!color) {
                    return null;
                }
                if (color.isOpaque()) {
                    return Color.Format.CSS.formatHex(color);
                }
                return Color.Format.CSS.formatRGBA(color);
            }
            CSS.format = format;
            /**
             * Converts an Hex color value to a Color.
             * returns r, g, and b are contained in the set [0, 255]
             * @param hex string (#RGB, #RGBA, #RRGGBB or #RRGGBBAA).
             */
            function parseHex(hex) {
                if (!hex) {
                    // Invalid color
                    return null;
                }
                var length = hex.length;
                if (length === 0) {
                    // Invalid color
                    return null;
                }
                if (hex.charCodeAt(0) !== 35 /* Hash */) {
                    // Does not begin with a #
                    return null;
                }
                if (length === 7) {
                    // #RRGGBB format
                    var r = 16 * _parseHexDigit(hex.charCodeAt(1)) + _parseHexDigit(hex.charCodeAt(2));
                    var g = 16 * _parseHexDigit(hex.charCodeAt(3)) + _parseHexDigit(hex.charCodeAt(4));
                    var b = 16 * _parseHexDigit(hex.charCodeAt(5)) + _parseHexDigit(hex.charCodeAt(6));
                    return new Color(new RGBA(r, g, b, 1));
                }
                if (length === 9) {
                    // #RRGGBBAA format
                    var r = 16 * _parseHexDigit(hex.charCodeAt(1)) + _parseHexDigit(hex.charCodeAt(2));
                    var g = 16 * _parseHexDigit(hex.charCodeAt(3)) + _parseHexDigit(hex.charCodeAt(4));
                    var b = 16 * _parseHexDigit(hex.charCodeAt(5)) + _parseHexDigit(hex.charCodeAt(6));
                    var a = 16 * _parseHexDigit(hex.charCodeAt(7)) + _parseHexDigit(hex.charCodeAt(8));
                    return new Color(new RGBA(r, g, b, a / 255));
                }
                if (length === 4) {
                    // #RGB format
                    var r = _parseHexDigit(hex.charCodeAt(1));
                    var g = _parseHexDigit(hex.charCodeAt(2));
                    var b = _parseHexDigit(hex.charCodeAt(3));
                    return new Color(new RGBA(16 * r + r, 16 * g + g, 16 * b + b));
                }
                if (length === 5) {
                    // #RGBA format
                    var r = _parseHexDigit(hex.charCodeAt(1));
                    var g = _parseHexDigit(hex.charCodeAt(2));
                    var b = _parseHexDigit(hex.charCodeAt(3));
                    var a = _parseHexDigit(hex.charCodeAt(4));
                    return new Color(new RGBA(16 * r + r, 16 * g + g, 16 * b + b, (16 * a + a) / 255));
                }
                // Invalid color
                return null;
            }
            CSS.parseHex = parseHex;
            function _parseHexDigit(charCode) {
                switch (charCode) {
                    case 48 /* Digit0 */: return 0;
                    case 49 /* Digit1 */: return 1;
                    case 50 /* Digit2 */: return 2;
                    case 51 /* Digit3 */: return 3;
                    case 52 /* Digit4 */: return 4;
                    case 53 /* Digit5 */: return 5;
                    case 54 /* Digit6 */: return 6;
                    case 55 /* Digit7 */: return 7;
                    case 56 /* Digit8 */: return 8;
                    case 57 /* Digit9 */: return 9;
                    case 97 /* a */: return 10;
                    case 65 /* A */: return 10;
                    case 98 /* b */: return 11;
                    case 66 /* B */: return 11;
                    case 99 /* c */: return 12;
                    case 67 /* C */: return 12;
                    case 100 /* d */: return 13;
                    case 68 /* D */: return 13;
                    case 101 /* e */: return 14;
                    case 69 /* E */: return 14;
                    case 102 /* f */: return 15;
                    case 70 /* F */: return 15;
                }
                return 0;
            }
        })(CSS = Format.CSS || (Format.CSS = {}));
    })(Format = Color.Format || (Color.Format = {}));
})(Color || (Color = {}));


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getZoomLevel;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTimeSinceLastZoomLevelChanged;
/* harmony export (immutable) */ __webpack_exports__["p"] = onDidChangeZoomLevel;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPixelRatio;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAccessibilitySupport;
/* harmony export (immutable) */ __webpack_exports__["o"] = onDidChangeAccessibilitySupport;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEdge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isEdgeOrIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isFirefox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isWebKit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isChrome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSafari; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isIPad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isEdgeWebView; });
/* harmony export (immutable) */ __webpack_exports__["e"] = hasClipboardSupport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var WindowManager = /** @class */ (function () {
    function WindowManager() {
        // --- Zoom Level
        this._zoomLevel = 0;
        this._lastZoomLevelChangeTime = 0;
        this._onDidChangeZoomLevel = new __WEBPACK_IMPORTED_MODULE_0__common_event_js__["a" /* Emitter */]();
        this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
        // --- Accessibility
        this._accessibilitySupport = 0 /* Unknown */;
        this._onDidChangeAccessibilitySupport = new __WEBPACK_IMPORTED_MODULE_0__common_event_js__["a" /* Emitter */]();
        this.onDidChangeAccessibilitySupport = this._onDidChangeAccessibilitySupport.event;
    }
    WindowManager.prototype.getZoomLevel = function () {
        return this._zoomLevel;
    };
    WindowManager.prototype.getTimeSinceLastZoomLevelChanged = function () {
        return Date.now() - this._lastZoomLevelChangeTime;
    };
    // --- Pixel Ratio
    WindowManager.prototype.getPixelRatio = function () {
        var ctx = document.createElement('canvas').getContext('2d');
        var dpr = window.devicePixelRatio || 1;
        var bsr = ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio || 1;
        return dpr / bsr;
    };
    WindowManager.prototype.getAccessibilitySupport = function () {
        return this._accessibilitySupport;
    };
    WindowManager.INSTANCE = new WindowManager();
    return WindowManager;
}());
function getZoomLevel() {
    return WindowManager.INSTANCE.getZoomLevel();
}
/** Returns the time (in ms) since the zoom level was changed */
function getTimeSinceLastZoomLevelChanged() {
    return WindowManager.INSTANCE.getTimeSinceLastZoomLevelChanged();
}
function onDidChangeZoomLevel(callback) {
    return WindowManager.INSTANCE.onDidChangeZoomLevel(callback);
}
function getPixelRatio() {
    return WindowManager.INSTANCE.getPixelRatio();
}
function getAccessibilitySupport() {
    return WindowManager.INSTANCE.getAccessibilitySupport();
}
function onDidChangeAccessibilitySupport(callback) {
    return WindowManager.INSTANCE.onDidChangeAccessibilitySupport(callback);
}
var userAgent = navigator.userAgent;
var isIE = (userAgent.indexOf('Trident') >= 0);
var isEdge = (userAgent.indexOf('Edge/') >= 0);
var isEdgeOrIE = isIE || isEdge;
var isFirefox = (userAgent.indexOf('Firefox') >= 0);
var isWebKit = (userAgent.indexOf('AppleWebKit') >= 0);
var isChrome = (userAgent.indexOf('Chrome') >= 0);
var isSafari = (userAgent.indexOf('Chrome') === -1) && (userAgent.indexOf('Safari') >= 0);
var isIPad = (userAgent.indexOf('iPad') >= 0);
var isEdgeWebView = isEdge && (userAgent.indexOf('WebView/') >= 0);
function hasClipboardSupport() {
    if (isIE) {
        return false;
    }
    if (isEdge) {
        var index = userAgent.indexOf('Edge/');
        var version = parseInt(userAgent.substring(index + 5, userAgent.indexOf('.', index)), 10);
        if (!version || (version >= 12 && version <= 16)) {
            return false;
        }
    }
    return true;
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deepClone;
/* harmony export (immutable) */ __webpack_exports__["d"] = deepFreeze;
/* harmony export (immutable) */ __webpack_exports__["g"] = mixin;
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
/* harmony export (immutable) */ __webpack_exports__["e"] = equals;
/* unused harmony export arrayToHash */
/* harmony export (immutable) */ __webpack_exports__["b"] = createKeywordMatcher;
/* harmony export (immutable) */ __webpack_exports__["f"] = getOrDefault;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(31);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


function deepClone(obj) {
    if (!obj || typeof obj !== 'object') {
        return obj;
    }
    if (obj instanceof RegExp) {
        // See https://github.com/Microsoft/TypeScript/issues/10990
        return obj;
    }
    var result = Array.isArray(obj) ? [] : {};
    Object.keys(obj).forEach(function (key) {
        if (obj[key] && typeof obj[key] === 'object') {
            result[key] = deepClone(obj[key]);
        }
        else {
            result[key] = obj[key];
        }
    });
    return result;
}
function deepFreeze(obj) {
    if (!obj || typeof obj !== 'object') {
        return obj;
    }
    var stack = [obj];
    while (stack.length > 0) {
        var obj_1 = stack.shift();
        Object.freeze(obj_1);
        for (var key in obj_1) {
            if (_hasOwnProperty.call(obj_1, key)) {
                var prop = obj_1[key];
                if (typeof prop === 'object' && !Object.isFrozen(prop)) {
                    stack.push(prop);
                }
            }
        }
    }
    return obj;
}
var _hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Copies all properties of source into destination. The optional parameter "overwrite" allows to control
 * if existing properties on the destination should be overwritten or not. Defaults to true (overwrite).
 */
function mixin(destination, source, overwrite) {
    if (overwrite === void 0) { overwrite = true; }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__types_js__["g" /* isObject */])(destination)) {
        return source;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__types_js__["g" /* isObject */])(source)) {
        Object.keys(source).forEach(function (key) {
            if (key in destination) {
                if (overwrite) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__types_js__["g" /* isObject */])(destination[key]) && Object(__WEBPACK_IMPORTED_MODULE_0__types_js__["g" /* isObject */])(source[key])) {
                        mixin(destination[key], source[key], overwrite);
                    }
                    else {
                        destination[key] = source[key];
                    }
                }
            }
            else {
                destination[key] = source[key];
            }
        });
    }
    return destination;
}
function assign(destination) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) { return Object.keys(source).forEach(function (key) { return destination[key] = source[key]; }); });
    return destination;
}
function equals(one, other) {
    if (one === other) {
        return true;
    }
    if (one === null || one === undefined || other === null || other === undefined) {
        return false;
    }
    if (typeof one !== typeof other) {
        return false;
    }
    if (typeof one !== 'object') {
        return false;
    }
    if ((Array.isArray(one)) !== (Array.isArray(other))) {
        return false;
    }
    var i;
    var key;
    if (Array.isArray(one)) {
        if (one.length !== other.length) {
            return false;
        }
        for (i = 0; i < one.length; i++) {
            if (!equals(one[i], other[i])) {
                return false;
            }
        }
    }
    else {
        var oneKeys = [];
        for (key in one) {
            oneKeys.push(key);
        }
        oneKeys.sort();
        var otherKeys = [];
        for (key in other) {
            otherKeys.push(key);
        }
        otherKeys.sort();
        if (!equals(oneKeys, otherKeys)) {
            return false;
        }
        for (i = 0; i < oneKeys.length; i++) {
            if (!equals(one[oneKeys[i]], other[oneKeys[i]])) {
                return false;
            }
        }
    }
    return true;
}
function arrayToHash(array) {
    var result = {};
    for (var i = 0; i < array.length; ++i) {
        result[array[i]] = true;
    }
    return result;
}
/**
 * Given an array of strings, returns a function which, given a string
 * returns true or false whether the string is in that array.
 */
function createKeywordMatcher(arr, caseInsensitive) {
    if (caseInsensitive === void 0) { caseInsensitive = false; }
    if (caseInsensitive) {
        arr = arr.map(function (x) { return x.toLowerCase(); });
    }
    var hash = arrayToHash(arr);
    if (caseInsensitive) {
        return function (word) {
            return hash[word.toLowerCase()] !== undefined && hash.hasOwnProperty(word.toLowerCase());
        };
    }
    else {
        return function (word) {
            return hash[word] !== undefined && hash.hasOwnProperty(word);
        };
    }
}
function getOrDefault(obj, fn, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var result = fn(obj);
    return typeof result === 'undefined' ? defaultValue : result;
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createTextBufferFactory */
/* unused harmony export createTextBuffer */
/* unused harmony export LONG_LINE_BOUNDARY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextModel; });
/* unused harmony export ModelDecorationOverviewRulerOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModelDecorationOptions; });
/* unused harmony export DidChangeDecorationsEmitter */
/* unused harmony export DidChangeContentEmitter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editStack_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__intervalTree_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_stopwatch_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modes_nullMode_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modes_supports_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modes_supports_richEditBrackets_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordHelper_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__textModelTokens_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__indentationGuesser_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config_editorOptions_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pieceTreeTextBuffer_pieceTreeTextBufferBuilder_js__ = __webpack_require__(330);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
























function createTextBufferBuilder() {
    return new __WEBPACK_IMPORTED_MODULE_23__pieceTreeTextBuffer_pieceTreeTextBufferBuilder_js__["a" /* PieceTreeTextBufferBuilder */]();
}
function createTextBufferFactory(text) {
    var builder = createTextBufferBuilder();
    builder.acceptChunk(text);
    return builder.finish();
}
function createTextBuffer(value, defaultEOL) {
    var factory = (typeof value === 'string' ? createTextBufferFactory(value) : value);
    return factory.create(defaultEOL);
}
var MODEL_ID = 0;
/**
 * Produces 'a'-'z', followed by 'A'-'Z'... followed by 'a'-'z', etc.
 */
function singleLetter(result) {
    var LETTERS_CNT = (90 /* Z */ - 65 /* A */ + 1);
    result = result % (2 * LETTERS_CNT);
    if (result < LETTERS_CNT) {
        return String.fromCharCode(97 /* a */ + result);
    }
    return String.fromCharCode(65 /* A */ + result - LETTERS_CNT);
}
var LIMIT_FIND_COUNT = 999;
var LONG_LINE_BOUNDARY = 10000;
var TextModel = /** @class */ (function (_super) {
    __extends(TextModel, _super);
    //#endregion
    function TextModel(source, creationOptions, languageIdentifier, associatedResource) {
        if (associatedResource === void 0) { associatedResource = null; }
        var _this = _super.call(this) || this;
        //#region Events
        _this._onWillDispose = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.onWillDispose = _this._onWillDispose.event;
        _this._onDidChangeDecorations = _this._register(new DidChangeDecorationsEmitter());
        _this.onDidChangeDecorations = _this._onDidChangeDecorations.event;
        _this._onDidChangeLanguage = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeLanguage = _this._onDidChangeLanguage.event;
        _this._onDidChangeLanguageConfiguration = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeLanguageConfiguration = _this._onDidChangeLanguageConfiguration.event;
        _this._onDidChangeTokens = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeTokens = _this._onDidChangeTokens.event;
        _this._onDidChangeOptions = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeOptions = _this._onDidChangeOptions.event;
        _this._eventEmitter = _this._register(new DidChangeContentEmitter());
        // Generate a new unique model id
        MODEL_ID++;
        _this.id = '$model' + MODEL_ID;
        _this.isForSimpleWidget = creationOptions.isForSimpleWidget;
        if (typeof associatedResource === 'undefined' || associatedResource === null) {
            _this._associatedResource = __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__["a" /* default */].parse('inmemory://model/' + MODEL_ID);
        }
        else {
            _this._associatedResource = associatedResource;
        }
        _this._attachedEditorCount = 0;
        _this._buffer = createTextBuffer(source, creationOptions.defaultEOL);
        _this._options = TextModel.resolveOptions(_this._buffer, creationOptions);
        var bufferLineCount = _this._buffer.getLineCount();
        var bufferTextLength = _this._buffer.getValueLengthInRange(new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](1, 1, bufferLineCount, _this._buffer.getLineLength(bufferLineCount) + 1), __WEBPACK_IMPORTED_MODULE_2__model_js__["c" /* EndOfLinePreference */].TextDefined);
        // !!! Make a decision in the ctor and permanently respect this decision !!!
        // If a model is too large at construction time, it will never get tokenized,
        // under no circumstances.
        if (creationOptions.largeFileOptimizations) {
            _this._isTooLargeForTokenization = ((bufferTextLength > TextModel.LARGE_FILE_SIZE_THRESHOLD)
                || (bufferLineCount > TextModel.LARGE_FILE_LINE_COUNT_THRESHOLD));
        }
        else {
            _this._isTooLargeForTokenization = false;
        }
        _this._isTooLargeForSyncing = (bufferTextLength > TextModel.MODEL_SYNC_LIMIT);
        _this._setVersionId(1);
        _this._isDisposed = false;
        _this._isDisposing = false;
        _this._languageIdentifier = languageIdentifier || __WEBPACK_IMPORTED_MODULE_13__modes_nullMode_js__["a" /* NULL_LANGUAGE_IDENTIFIER */];
        _this._tokenizationListener = __WEBPACK_IMPORTED_MODULE_3__modes_js__["y" /* TokenizationRegistry */].onDidChange(function (e) {
            if (e.changedLanguages.indexOf(_this._languageIdentifier.language) === -1) {
                return;
            }
            _this._resetTokenizationState();
            _this.emitModelTokensChangedEvent({
                ranges: [{
                        fromLineNumber: 1,
                        toLineNumber: _this.getLineCount()
                    }]
            });
            if (_this._shouldAutoTokenize()) {
                _this._warmUpTokens();
            }
        });
        _this._revalidateTokensTimeout = -1;
        _this._languageRegistryListener = __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].onDidChange(function (e) {
            if (e.languageIdentifier.id === _this._languageIdentifier.id) {
                _this._onDidChangeLanguageConfiguration.fire({});
            }
        });
        _this._resetTokenizationState();
        _this._instanceId = singleLetter(MODEL_ID);
        _this._lastDecorationId = 0;
        _this._decorations = Object.create(null);
        _this._decorationsTree = new DecorationsTrees();
        _this._commandManager = new __WEBPACK_IMPORTED_MODULE_4__editStack_js__["a" /* EditStack */](_this);
        _this._isUndoing = false;
        _this._isRedoing = false;
        _this._trimAutoWhitespaceLines = null;
        return _this;
    }
    TextModel.createFromString = function (text, options, languageIdentifier, uri) {
        if (options === void 0) { options = TextModel.DEFAULT_CREATION_OPTIONS; }
        if (languageIdentifier === void 0) { languageIdentifier = null; }
        if (uri === void 0) { uri = null; }
        return new TextModel(text, options, languageIdentifier, uri);
    };
    TextModel.resolveOptions = function (textBuffer, options) {
        if (options.detectIndentation) {
            var guessedIndentation = Object(__WEBPACK_IMPORTED_MODULE_20__indentationGuesser_js__["a" /* guessIndentation */])(textBuffer, options.tabSize, options.insertSpaces);
            return new __WEBPACK_IMPORTED_MODULE_2__model_js__["g" /* TextModelResolvedOptions */]({
                tabSize: guessedIndentation.tabSize,
                insertSpaces: guessedIndentation.insertSpaces,
                trimAutoWhitespace: options.trimAutoWhitespace,
                defaultEOL: options.defaultEOL
            });
        }
        return new __WEBPACK_IMPORTED_MODULE_2__model_js__["g" /* TextModelResolvedOptions */]({
            tabSize: options.tabSize,
            insertSpaces: options.insertSpaces,
            trimAutoWhitespace: options.trimAutoWhitespace,
            defaultEOL: options.defaultEOL
        });
    };
    TextModel.prototype.onDidChangeRawContentFast = function (listener) {
        return this._eventEmitter.fastEvent(function (e) { return listener(e.rawContentChangedEvent); });
    };
    TextModel.prototype.onDidChangeRawContent = function (listener) {
        return this._eventEmitter.slowEvent(function (e) { return listener(e.rawContentChangedEvent); });
    };
    TextModel.prototype.onDidChangeContent = function (listener) {
        return this._eventEmitter.slowEvent(function (e) { return listener(e.contentChangedEvent); });
    };
    TextModel.prototype.dispose = function () {
        this._isDisposing = true;
        this._onWillDispose.fire();
        this._commandManager = null;
        this._decorations = null;
        this._decorationsTree = null;
        this._tokenizationListener.dispose();
        this._languageRegistryListener.dispose();
        this._clearTimers();
        this._tokens = null;
        this._isDisposed = true;
        // Null out members, such that any use of a disposed model will throw exceptions sooner rather than later
        this._buffer = null;
        _super.prototype.dispose.call(this);
        this._isDisposing = false;
    };
    TextModel.prototype._assertNotDisposed = function () {
        if (this._isDisposed) {
            throw new Error('Model is disposed!');
        }
    };
    TextModel.prototype._emitContentChangedEvent = function (rawChange, change) {
        if (this._isDisposing) {
            // Do not confuse listeners by emitting any event after disposing
            return;
        }
        this._eventEmitter.fire(new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["a" /* InternalModelContentChangeEvent */](rawChange, change));
    };
    TextModel.prototype.setValue = function (value) {
        this._assertNotDisposed();
        if (value === null) {
            // There's nothing to do
            return;
        }
        var textBuffer = createTextBuffer(value, this._options.defaultEOL);
        this.setValueFromTextBuffer(textBuffer);
    };
    TextModel.prototype._createContentChanged2 = function (range, rangeOffset, rangeLength, text, isUndoing, isRedoing, isFlush) {
        return {
            changes: [{
                    range: range,
                    rangeOffset: rangeOffset,
                    rangeLength: rangeLength,
                    text: text,
                }],
            eol: this._buffer.getEOL(),
            versionId: this.getVersionId(),
            isUndoing: isUndoing,
            isRedoing: isRedoing,
            isFlush: isFlush
        };
    };
    TextModel.prototype.setValueFromTextBuffer = function (textBuffer) {
        this._assertNotDisposed();
        if (textBuffer === null) {
            // There's nothing to do
            return;
        }
        var oldFullModelRange = this.getFullModelRange();
        var oldModelValueLength = this.getValueLengthInRange(oldFullModelRange);
        var endLineNumber = this.getLineCount();
        var endColumn = this.getLineMaxColumn(endLineNumber);
        this._buffer = textBuffer;
        this._increaseVersionId();
        // Cancel tokenization, clear all tokens and begin tokenizing
        this._resetTokenizationState();
        // Destroy all my decorations
        this._decorations = Object.create(null);
        this._decorationsTree = new DecorationsTrees();
        // Destroy my edit history and settings
        this._commandManager = new __WEBPACK_IMPORTED_MODULE_4__editStack_js__["a" /* EditStack */](this);
        this._trimAutoWhitespaceLines = null;
        this._emitContentChangedEvent(new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["b" /* ModelRawContentChangedEvent */]([
            new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["d" /* ModelRawFlush */]()
        ], this._versionId, false, false), this._createContentChanged2(new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](1, 1, endLineNumber, endColumn), 0, oldModelValueLength, this.getValue(), false, false, true));
    };
    TextModel.prototype.setEOL = function (eol) {
        this._assertNotDisposed();
        var newEOL = (eol === __WEBPACK_IMPORTED_MODULE_2__model_js__["d" /* EndOfLineSequence */].CRLF ? '\r\n' : '\n');
        if (this._buffer.getEOL() === newEOL) {
            // Nothing to do
            return;
        }
        var oldFullModelRange = this.getFullModelRange();
        var oldModelValueLength = this.getValueLengthInRange(oldFullModelRange);
        var endLineNumber = this.getLineCount();
        var endColumn = this.getLineMaxColumn(endLineNumber);
        this._onBeforeEOLChange();
        this._buffer.setEOL(newEOL);
        this._increaseVersionId();
        this._onAfterEOLChange();
        this._emitContentChangedEvent(new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["b" /* ModelRawContentChangedEvent */]([
            new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["c" /* ModelRawEOLChanged */]()
        ], this._versionId, false, false), this._createContentChanged2(new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](1, 1, endLineNumber, endColumn), 0, oldModelValueLength, this.getValue(), false, false, false));
    };
    TextModel.prototype._onBeforeEOLChange = function () {
        // Ensure all decorations get their `range` set.
        var versionId = this.getVersionId();
        var allDecorations = this._decorationsTree.search(0, false, false, versionId);
        this._ensureNodesHaveRanges(allDecorations);
    };
    TextModel.prototype._onAfterEOLChange = function () {
        // Transform back `range` to offsets
        var versionId = this.getVersionId();
        var allDecorations = this._decorationsTree.collectNodesPostOrder();
        for (var i = 0, len = allDecorations.length; i < len; i++) {
            var node = allDecorations[i];
            var delta = node.cachedAbsoluteStart - node.start;
            var startOffset = this._buffer.getOffsetAt(node.range.startLineNumber, node.range.startColumn);
            var endOffset = this._buffer.getOffsetAt(node.range.endLineNumber, node.range.endColumn);
            node.cachedAbsoluteStart = startOffset;
            node.cachedAbsoluteEnd = endOffset;
            node.cachedVersionId = versionId;
            node.start = startOffset - delta;
            node.end = endOffset - delta;
            Object(__WEBPACK_IMPORTED_MODULE_10__intervalTree_js__["d" /* recomputeMaxEnd */])(node);
        }
    };
    TextModel.prototype._resetTokenizationState = function () {
        this._clearTimers();
        var tokenizationSupport = (this._isTooLargeForTokenization
            ? null
            : __WEBPACK_IMPORTED_MODULE_3__modes_js__["y" /* TokenizationRegistry */].get(this._languageIdentifier.language));
        this._tokens = new __WEBPACK_IMPORTED_MODULE_19__textModelTokens_js__["a" /* ModelLinesTokens */](this._languageIdentifier, tokenizationSupport);
        this._beginBackgroundTokenization();
    };
    TextModel.prototype._clearTimers = function () {
        if (this._revalidateTokensTimeout !== -1) {
            clearTimeout(this._revalidateTokensTimeout);
            this._revalidateTokensTimeout = -1;
        }
    };
    TextModel.prototype.onBeforeAttached = function () {
        this._attachedEditorCount++;
        // Warm up tokens for the editor
        this._warmUpTokens();
    };
    TextModel.prototype.onBeforeDetached = function () {
        this._attachedEditorCount--;
    };
    TextModel.prototype._shouldAutoTokenize = function () {
        return this.isAttachedToEditor();
    };
    TextModel.prototype.isAttachedToEditor = function () {
        return this._attachedEditorCount > 0;
    };
    TextModel.prototype.getAttachedEditorCount = function () {
        return this._attachedEditorCount;
    };
    TextModel.prototype.isTooLargeForSyncing = function () {
        return this._isTooLargeForSyncing;
    };
    TextModel.prototype.isTooLargeForTokenization = function () {
        return this._isTooLargeForTokenization;
    };
    TextModel.prototype.isDisposed = function () {
        return this._isDisposed;
    };
    TextModel.prototype.isDominatedByLongLines = function () {
        this._assertNotDisposed();
        if (this.isTooLargeForTokenization()) {
            // Cannot word wrap huge files anyways, so it doesn't really matter
            return false;
        }
        var smallLineCharCount = 0;
        var longLineCharCount = 0;
        var lineCount = this._buffer.getLineCount();
        for (var lineNumber = 1; lineNumber <= lineCount; lineNumber++) {
            var lineLength = this._buffer.getLineLength(lineNumber);
            if (lineLength >= LONG_LINE_BOUNDARY) {
                longLineCharCount += lineLength;
            }
            else {
                smallLineCharCount += lineLength;
            }
        }
        return (longLineCharCount > smallLineCharCount);
    };
    Object.defineProperty(TextModel.prototype, "uri", {
        get: function () {
            return this._associatedResource;
        },
        enumerable: true,
        configurable: true
    });
    //#region Options
    TextModel.prototype.getOptions = function () {
        this._assertNotDisposed();
        return this._options;
    };
    TextModel.prototype.updateOptions = function (_newOpts) {
        this._assertNotDisposed();
        var tabSize = (typeof _newOpts.tabSize !== 'undefined') ? _newOpts.tabSize : this._options.tabSize;
        var insertSpaces = (typeof _newOpts.insertSpaces !== 'undefined') ? _newOpts.insertSpaces : this._options.insertSpaces;
        var trimAutoWhitespace = (typeof _newOpts.trimAutoWhitespace !== 'undefined') ? _newOpts.trimAutoWhitespace : this._options.trimAutoWhitespace;
        var newOpts = new __WEBPACK_IMPORTED_MODULE_2__model_js__["g" /* TextModelResolvedOptions */]({
            tabSize: tabSize,
            insertSpaces: insertSpaces,
            defaultEOL: this._options.defaultEOL,
            trimAutoWhitespace: trimAutoWhitespace
        });
        if (this._options.equals(newOpts)) {
            return;
        }
        var e = this._options.createChangeEvent(newOpts);
        this._options = newOpts;
        this._onDidChangeOptions.fire(e);
    };
    TextModel.prototype.detectIndentation = function (defaultInsertSpaces, defaultTabSize) {
        this._assertNotDisposed();
        var guessedIndentation = Object(__WEBPACK_IMPORTED_MODULE_20__indentationGuesser_js__["a" /* guessIndentation */])(this._buffer, defaultTabSize, defaultInsertSpaces);
        this.updateOptions({
            insertSpaces: guessedIndentation.insertSpaces,
            tabSize: guessedIndentation.tabSize
        });
    };
    TextModel._normalizeIndentationFromWhitespace = function (str, tabSize, insertSpaces) {
        var spacesCnt = 0;
        for (var i = 0; i < str.length; i++) {
            if (str.charAt(i) === '\t') {
                spacesCnt += tabSize;
            }
            else {
                spacesCnt++;
            }
        }
        var result = '';
        if (!insertSpaces) {
            var tabsCnt = Math.floor(spacesCnt / tabSize);
            spacesCnt = spacesCnt % tabSize;
            for (var i = 0; i < tabsCnt; i++) {
                result += '\t';
            }
        }
        for (var i = 0; i < spacesCnt; i++) {
            result += ' ';
        }
        return result;
    };
    TextModel.normalizeIndentation = function (str, tabSize, insertSpaces) {
        var firstNonWhitespaceIndex = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["firstNonWhitespaceIndex"](str);
        if (firstNonWhitespaceIndex === -1) {
            firstNonWhitespaceIndex = str.length;
        }
        return TextModel._normalizeIndentationFromWhitespace(str.substring(0, firstNonWhitespaceIndex), tabSize, insertSpaces) + str.substring(firstNonWhitespaceIndex);
    };
    TextModel.prototype.normalizeIndentation = function (str) {
        this._assertNotDisposed();
        return TextModel.normalizeIndentation(str, this._options.tabSize, this._options.insertSpaces);
    };
    TextModel.prototype.getOneIndent = function () {
        this._assertNotDisposed();
        var tabSize = this._options.tabSize;
        var insertSpaces = this._options.insertSpaces;
        if (insertSpaces) {
            var result = '';
            for (var i = 0; i < tabSize; i++) {
                result += ' ';
            }
            return result;
        }
        else {
            return '\t';
        }
    };
    //#endregion
    //#region Reading
    TextModel.prototype.getVersionId = function () {
        this._assertNotDisposed();
        return this._versionId;
    };
    TextModel.prototype.mightContainRTL = function () {
        return this._buffer.mightContainRTL();
    };
    TextModel.prototype.mightContainNonBasicASCII = function () {
        return this._buffer.mightContainNonBasicASCII();
    };
    TextModel.prototype.getAlternativeVersionId = function () {
        this._assertNotDisposed();
        return this._alternativeVersionId;
    };
    TextModel.prototype.getOffsetAt = function (rawPosition) {
        this._assertNotDisposed();
        var position = this._validatePosition(rawPosition.lineNumber, rawPosition.column, false);
        return this._buffer.getOffsetAt(position.lineNumber, position.column);
    };
    TextModel.prototype.getPositionAt = function (rawOffset) {
        this._assertNotDisposed();
        var offset = (Math.min(this._buffer.getLength(), Math.max(0, rawOffset)));
        return this._buffer.getPositionAt(offset);
    };
    TextModel.prototype._increaseVersionId = function () {
        this._setVersionId(this._versionId + 1);
    };
    TextModel.prototype._setVersionId = function (newVersionId) {
        this._versionId = newVersionId;
        this._alternativeVersionId = this._versionId;
    };
    TextModel.prototype._overwriteAlternativeVersionId = function (newAlternativeVersionId) {
        this._alternativeVersionId = newAlternativeVersionId;
    };
    TextModel.prototype.getValue = function (eol, preserveBOM) {
        if (preserveBOM === void 0) { preserveBOM = false; }
        this._assertNotDisposed();
        var fullModelRange = this.getFullModelRange();
        var fullModelValue = this.getValueInRange(fullModelRange, eol);
        if (preserveBOM) {
            return this._buffer.getBOM() + fullModelValue;
        }
        return fullModelValue;
    };
    TextModel.prototype.getValueLength = function (eol, preserveBOM) {
        if (preserveBOM === void 0) { preserveBOM = false; }
        this._assertNotDisposed();
        var fullModelRange = this.getFullModelRange();
        var fullModelValue = this.getValueLengthInRange(fullModelRange, eol);
        if (preserveBOM) {
            return this._buffer.getBOM().length + fullModelValue;
        }
        return fullModelValue;
    };
    TextModel.prototype.getValueInRange = function (rawRange, eol) {
        if (eol === void 0) { eol = __WEBPACK_IMPORTED_MODULE_2__model_js__["c" /* EndOfLinePreference */].TextDefined; }
        this._assertNotDisposed();
        return this._buffer.getValueInRange(this.validateRange(rawRange), eol);
    };
    TextModel.prototype.getValueLengthInRange = function (rawRange, eol) {
        if (eol === void 0) { eol = __WEBPACK_IMPORTED_MODULE_2__model_js__["c" /* EndOfLinePreference */].TextDefined; }
        this._assertNotDisposed();
        return this._buffer.getValueLengthInRange(this.validateRange(rawRange), eol);
    };
    TextModel.prototype.getLineCount = function () {
        this._assertNotDisposed();
        return this._buffer.getLineCount();
    };
    TextModel.prototype.getLineContent = function (lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            throw new Error('Illegal value for lineNumber');
        }
        return this._buffer.getLineContent(lineNumber);
    };
    TextModel.prototype.getLineLength = function (lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            throw new Error('Illegal value for lineNumber');
        }
        return this._buffer.getLineLength(lineNumber);
    };
    TextModel.prototype.getLinesContent = function () {
        this._assertNotDisposed();
        return this._buffer.getLinesContent();
    };
    TextModel.prototype.getEOL = function () {
        this._assertNotDisposed();
        return this._buffer.getEOL();
    };
    TextModel.prototype.getLineMinColumn = function (lineNumber) {
        this._assertNotDisposed();
        return 1;
    };
    TextModel.prototype.getLineMaxColumn = function (lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            throw new Error('Illegal value for lineNumber');
        }
        return this._buffer.getLineLength(lineNumber) + 1;
    };
    TextModel.prototype.getLineFirstNonWhitespaceColumn = function (lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            throw new Error('Illegal value for lineNumber');
        }
        return this._buffer.getLineFirstNonWhitespaceColumn(lineNumber);
    };
    TextModel.prototype.getLineLastNonWhitespaceColumn = function (lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            throw new Error('Illegal value for lineNumber');
        }
        return this._buffer.getLineLastNonWhitespaceColumn(lineNumber);
    };
    /**
     * Validates `range` is within buffer bounds, but allows it to sit in between surrogate pairs, etc.
     * Will try to not allocate if possible.
     */
    TextModel.prototype._validateRangeRelaxedNoAllocations = function (range) {
        var linesCount = this._buffer.getLineCount();
        var initialStartLineNumber = range.startLineNumber;
        var initialStartColumn = range.startColumn;
        var startLineNumber;
        var startColumn;
        if (initialStartLineNumber < 1) {
            startLineNumber = 1;
            startColumn = 1;
        }
        else if (initialStartLineNumber > linesCount) {
            startLineNumber = linesCount;
            startColumn = this.getLineMaxColumn(startLineNumber);
        }
        else {
            startLineNumber = initialStartLineNumber | 0;
            if (initialStartColumn <= 1) {
                startColumn = 1;
            }
            else {
                var maxColumn = this.getLineMaxColumn(startLineNumber);
                if (initialStartColumn >= maxColumn) {
                    startColumn = maxColumn;
                }
                else {
                    startColumn = initialStartColumn | 0;
                }
            }
        }
        var initialEndLineNumber = range.endLineNumber;
        var initialEndColumn = range.endColumn;
        var endLineNumber;
        var endColumn;
        if (initialEndLineNumber < 1) {
            endLineNumber = 1;
            endColumn = 1;
        }
        else if (initialEndLineNumber > linesCount) {
            endLineNumber = linesCount;
            endColumn = this.getLineMaxColumn(endLineNumber);
        }
        else {
            endLineNumber = initialEndLineNumber | 0;
            if (initialEndColumn <= 1) {
                endColumn = 1;
            }
            else {
                var maxColumn = this.getLineMaxColumn(endLineNumber);
                if (initialEndColumn >= maxColumn) {
                    endColumn = maxColumn;
                }
                else {
                    endColumn = initialEndColumn | 0;
                }
            }
        }
        if (initialStartLineNumber === startLineNumber
            && initialStartColumn === startColumn
            && initialEndLineNumber === endLineNumber
            && initialEndColumn === endColumn
            && range instanceof __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */]
            && !(range instanceof __WEBPACK_IMPORTED_MODULE_6__core_selection_js__["a" /* Selection */])) {
            return range;
        }
        return new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn);
    };
    /**
     * @param strict Do NOT allow a position inside a high-low surrogate pair
     */
    TextModel.prototype._isValidPosition = function (lineNumber, column, strict) {
        if (isNaN(lineNumber)) {
            return false;
        }
        if (lineNumber < 1) {
            return false;
        }
        var lineCount = this._buffer.getLineCount();
        if (lineNumber > lineCount) {
            return false;
        }
        if (isNaN(column)) {
            return false;
        }
        if (column < 1) {
            return false;
        }
        var maxColumn = this.getLineMaxColumn(lineNumber);
        if (column > maxColumn) {
            return false;
        }
        if (strict) {
            if (column > 1) {
                var charCodeBefore = this._buffer.getLineCharCode(lineNumber, column - 2);
                if (__WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["isHighSurrogate"](charCodeBefore)) {
                    return false;
                }
            }
        }
        return true;
    };
    /**
     * @param strict Do NOT allow a position inside a high-low surrogate pair
     */
    TextModel.prototype._validatePosition = function (_lineNumber, _column, strict) {
        var lineNumber = Math.floor((typeof _lineNumber === 'number' && !isNaN(_lineNumber)) ? _lineNumber : 1);
        var column = Math.floor((typeof _column === 'number' && !isNaN(_column)) ? _column : 1);
        var lineCount = this._buffer.getLineCount();
        if (lineNumber < 1) {
            return new __WEBPACK_IMPORTED_MODULE_16__core_position_js__["a" /* Position */](1, 1);
        }
        if (lineNumber > lineCount) {
            return new __WEBPACK_IMPORTED_MODULE_16__core_position_js__["a" /* Position */](lineCount, this.getLineMaxColumn(lineCount));
        }
        if (column <= 1) {
            return new __WEBPACK_IMPORTED_MODULE_16__core_position_js__["a" /* Position */](lineNumber, 1);
        }
        var maxColumn = this.getLineMaxColumn(lineNumber);
        if (column >= maxColumn) {
            return new __WEBPACK_IMPORTED_MODULE_16__core_position_js__["a" /* Position */](lineNumber, maxColumn);
        }
        if (strict) {
            // If the position would end up in the middle of a high-low surrogate pair,
            // we move it to before the pair
            // !!At this point, column > 1
            var charCodeBefore = this._buffer.getLineCharCode(lineNumber, column - 2);
            if (__WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["isHighSurrogate"](charCodeBefore)) {
                return new __WEBPACK_IMPORTED_MODULE_16__core_position_js__["a" /* Position */](lineNumber, column - 1);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_16__core_position_js__["a" /* Position */](lineNumber, column);
    };
    TextModel.prototype.validatePosition = function (position) {
        this._assertNotDisposed();
        // Avoid object allocation and cover most likely case
        if (position instanceof __WEBPACK_IMPORTED_MODULE_16__core_position_js__["a" /* Position */]) {
            if (this._isValidPosition(position.lineNumber, position.column, true)) {
                return position;
            }
        }
        return this._validatePosition(position.lineNumber, position.column, true);
    };
    /**
     * @param strict Do NOT allow a range to have its boundaries inside a high-low surrogate pair
     */
    TextModel.prototype._isValidRange = function (range, strict) {
        var startLineNumber = range.startLineNumber;
        var startColumn = range.startColumn;
        var endLineNumber = range.endLineNumber;
        var endColumn = range.endColumn;
        if (!this._isValidPosition(startLineNumber, startColumn, false)) {
            return false;
        }
        if (!this._isValidPosition(endLineNumber, endColumn, false)) {
            return false;
        }
        if (strict) {
            var charCodeBeforeStart = (startColumn > 1 ? this._buffer.getLineCharCode(startLineNumber, startColumn - 2) : 0);
            var charCodeBeforeEnd = (endColumn > 1 && endColumn <= this._buffer.getLineLength(endLineNumber) ? this._buffer.getLineCharCode(endLineNumber, endColumn - 2) : 0);
            var startInsideSurrogatePair = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["isHighSurrogate"](charCodeBeforeStart);
            var endInsideSurrogatePair = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["isHighSurrogate"](charCodeBeforeEnd);
            if (!startInsideSurrogatePair && !endInsideSurrogatePair) {
                return true;
            }
            return false;
        }
        return true;
    };
    TextModel.prototype.validateRange = function (_range) {
        this._assertNotDisposed();
        // Avoid object allocation and cover most likely case
        if ((_range instanceof __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */]) && !(_range instanceof __WEBPACK_IMPORTED_MODULE_6__core_selection_js__["a" /* Selection */])) {
            if (this._isValidRange(_range, true)) {
                return _range;
            }
        }
        var start = this._validatePosition(_range.startLineNumber, _range.startColumn, false);
        var end = this._validatePosition(_range.endLineNumber, _range.endColumn, false);
        var startLineNumber = start.lineNumber;
        var startColumn = start.column;
        var endLineNumber = end.lineNumber;
        var endColumn = end.column;
        var charCodeBeforeStart = (startColumn > 1 ? this._buffer.getLineCharCode(startLineNumber, startColumn - 2) : 0);
        var charCodeBeforeEnd = (endColumn > 1 && endColumn <= this._buffer.getLineLength(endLineNumber) ? this._buffer.getLineCharCode(endLineNumber, endColumn - 2) : 0);
        var startInsideSurrogatePair = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["isHighSurrogate"](charCodeBeforeStart);
        var endInsideSurrogatePair = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["isHighSurrogate"](charCodeBeforeEnd);
        if (!startInsideSurrogatePair && !endInsideSurrogatePair) {
            return new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn);
        }
        if (startLineNumber === endLineNumber && startColumn === endColumn) {
            // do not expand a collapsed range, simply move it to a valid location
            return new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](startLineNumber, startColumn - 1, endLineNumber, endColumn - 1);
        }
        if (startInsideSurrogatePair && endInsideSurrogatePair) {
            // expand range at both ends
            return new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](startLineNumber, startColumn - 1, endLineNumber, endColumn + 1);
        }
        if (startInsideSurrogatePair) {
            // only expand range at the start
            return new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](startLineNumber, startColumn - 1, endLineNumber, endColumn);
        }
        // only expand range at the end
        return new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn + 1);
    };
    TextModel.prototype.modifyPosition = function (rawPosition, offset) {
        this._assertNotDisposed();
        var candidate = this.getOffsetAt(rawPosition) + offset;
        return this.getPositionAt(Math.min(this._buffer.getLength(), Math.max(0, candidate)));
    };
    TextModel.prototype.getFullModelRange = function () {
        this._assertNotDisposed();
        var lineCount = this.getLineCount();
        return new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](1, 1, lineCount, this.getLineMaxColumn(lineCount));
    };
    TextModel.prototype.findMatchesLineByLine = function (searchRange, searchData, captureMatches, limitResultCount) {
        return this._buffer.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
    };
    TextModel.prototype.findMatches = function (searchString, rawSearchScope, isRegex, matchCase, wordSeparators, captureMatches, limitResultCount) {
        if (limitResultCount === void 0) { limitResultCount = LIMIT_FIND_COUNT; }
        this._assertNotDisposed();
        var searchRange;
        if (__WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */].isIRange(rawSearchScope)) {
            searchRange = this.validateRange(rawSearchScope);
        }
        else {
            searchRange = this.getFullModelRange();
        }
        if (!isRegex && searchString.indexOf('\n') < 0) {
            // not regex, not multi line
            var searchParams = new __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["a" /* SearchParams */](searchString, isRegex, matchCase, wordSeparators);
            var searchData = searchParams.parseSearchRequest();
            if (!searchData) {
                return [];
            }
            return this.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
        }
        return __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["c" /* TextModelSearch */].findMatches(this, new __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["a" /* SearchParams */](searchString, isRegex, matchCase, wordSeparators), searchRange, captureMatches, limitResultCount);
    };
    TextModel.prototype.findNextMatch = function (searchString, rawSearchStart, isRegex, matchCase, wordSeparators, captureMatches) {
        this._assertNotDisposed();
        var searchStart = this.validatePosition(rawSearchStart);
        if (!isRegex && searchString.indexOf('\n') < 0) {
            var searchParams = new __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["a" /* SearchParams */](searchString, isRegex, matchCase, wordSeparators);
            var searchData = searchParams.parseSearchRequest();
            var lineCount = this.getLineCount();
            var searchRange = new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](searchStart.lineNumber, searchStart.column, lineCount, this.getLineMaxColumn(lineCount));
            var ret = this.findMatchesLineByLine(searchRange, searchData, captureMatches, 1);
            __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["c" /* TextModelSearch */].findNextMatch(this, new __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["a" /* SearchParams */](searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
            if (ret.length > 0) {
                return ret[0];
            }
            searchRange = new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](1, 1, searchStart.lineNumber, this.getLineMaxColumn(searchStart.lineNumber));
            ret = this.findMatchesLineByLine(searchRange, searchData, captureMatches, 1);
            if (ret.length > 0) {
                return ret[0];
            }
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["c" /* TextModelSearch */].findNextMatch(this, new __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["a" /* SearchParams */](searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
    };
    TextModel.prototype.findPreviousMatch = function (searchString, rawSearchStart, isRegex, matchCase, wordSeparators, captureMatches) {
        this._assertNotDisposed();
        var searchStart = this.validatePosition(rawSearchStart);
        return __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["c" /* TextModelSearch */].findPreviousMatch(this, new __WEBPACK_IMPORTED_MODULE_22__textModelSearch_js__["a" /* SearchParams */](searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
    };
    //#endregion
    //#region Editing
    TextModel.prototype.pushStackElement = function () {
        this._commandManager.pushStackElement();
    };
    TextModel.prototype.pushEOL = function (eol) {
        var currentEOL = (this.getEOL() === '\n' ? __WEBPACK_IMPORTED_MODULE_2__model_js__["d" /* EndOfLineSequence */].LF : __WEBPACK_IMPORTED_MODULE_2__model_js__["d" /* EndOfLineSequence */].CRLF);
        if (currentEOL === eol) {
            return;
        }
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            this._commandManager.pushEOL(eol);
        }
        finally {
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    };
    TextModel.prototype.pushEditOperations = function (beforeCursorState, editOperations, cursorStateComputer) {
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            return this._pushEditOperations(beforeCursorState, editOperations, cursorStateComputer);
        }
        finally {
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    };
    TextModel.prototype._pushEditOperations = function (beforeCursorState, editOperations, cursorStateComputer) {
        var _this = this;
        if (this._options.trimAutoWhitespace && this._trimAutoWhitespaceLines) {
            // Go through each saved line number and insert a trim whitespace edit
            // if it is safe to do so (no conflicts with other edits).
            var incomingEdits = editOperations.map(function (op) {
                return {
                    range: _this.validateRange(op.range),
                    text: op.text
                };
            });
            // Sometimes, auto-formatters change ranges automatically which can cause undesired auto whitespace trimming near the cursor
            // We'll use the following heuristic: if the edits occur near the cursor, then it's ok to trim auto whitespace
            var editsAreNearCursors = true;
            for (var i = 0, len = beforeCursorState.length; i < len; i++) {
                var sel = beforeCursorState[i];
                var foundEditNearSel = false;
                for (var j = 0, lenJ = incomingEdits.length; j < lenJ; j++) {
                    var editRange = incomingEdits[j].range;
                    var selIsAbove = editRange.startLineNumber > sel.endLineNumber;
                    var selIsBelow = sel.startLineNumber > editRange.endLineNumber;
                    if (!selIsAbove && !selIsBelow) {
                        foundEditNearSel = true;
                        break;
                    }
                }
                if (!foundEditNearSel) {
                    editsAreNearCursors = false;
                    break;
                }
            }
            if (editsAreNearCursors) {
                for (var i = 0, len = this._trimAutoWhitespaceLines.length; i < len; i++) {
                    var trimLineNumber = this._trimAutoWhitespaceLines[i];
                    var maxLineColumn = this.getLineMaxColumn(trimLineNumber);
                    var allowTrimLine = true;
                    for (var j = 0, lenJ = incomingEdits.length; j < lenJ; j++) {
                        var editRange = incomingEdits[j].range;
                        var editText = incomingEdits[j].text;
                        if (trimLineNumber < editRange.startLineNumber || trimLineNumber > editRange.endLineNumber) {
                            // `trimLine` is completely outside this edit
                            continue;
                        }
                        // At this point:
                        //   editRange.startLineNumber <= trimLine <= editRange.endLineNumber
                        if (trimLineNumber === editRange.startLineNumber && editRange.startColumn === maxLineColumn
                            && editRange.isEmpty() && editText && editText.length > 0 && editText.charAt(0) === '\n') {
                            // This edit inserts a new line (and maybe other text) after `trimLine`
                            continue;
                        }
                        if (trimLineNumber === editRange.startLineNumber && editRange.startColumn === 1
                            && editRange.isEmpty() && editText && editText.length > 0 && editText.charAt(editText.length - 1) === '\n') {
                            // This edit inserts a new line (and maybe other text) before `trimLine`
                            continue;
                        }
                        // Looks like we can't trim this line as it would interfere with an incoming edit
                        allowTrimLine = false;
                        break;
                    }
                    if (allowTrimLine) {
                        editOperations.push({
                            range: new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](trimLineNumber, 1, trimLineNumber, maxLineColumn),
                            text: null
                        });
                    }
                }
            }
            this._trimAutoWhitespaceLines = null;
        }
        return this._commandManager.pushEditOperation(beforeCursorState, editOperations, cursorStateComputer);
    };
    TextModel.prototype.applyEdits = function (rawOperations) {
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            return this._applyEdits(rawOperations);
        }
        finally {
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    };
    TextModel._eolCount = function (text) {
        var eolCount = 0;
        var firstLineLength = 0;
        for (var i = 0, len = text.length; i < len; i++) {
            var chr = text.charCodeAt(i);
            if (chr === 13 /* CarriageReturn */) {
                if (eolCount === 0) {
                    firstLineLength = i;
                }
                eolCount++;
                if (i + 1 < len && text.charCodeAt(i + 1) === 10 /* LineFeed */) {
                    // \r\n... case
                    i++; // skip \n
                }
                else {
                    // \r... case
                }
            }
            else if (chr === 10 /* LineFeed */) {
                if (eolCount === 0) {
                    firstLineLength = i;
                }
                eolCount++;
            }
        }
        if (eolCount === 0) {
            firstLineLength = text.length;
        }
        return [eolCount, firstLineLength];
    };
    TextModel.prototype._applyEdits = function (rawOperations) {
        for (var i = 0, len = rawOperations.length; i < len; i++) {
            rawOperations[i].range = this.validateRange(rawOperations[i].range);
        }
        var oldLineCount = this._buffer.getLineCount();
        var result = this._buffer.applyEdits(rawOperations, this._options.trimAutoWhitespace);
        var newLineCount = this._buffer.getLineCount();
        var contentChanges = result.changes;
        this._trimAutoWhitespaceLines = result.trimAutoWhitespaceLineNumbers;
        if (contentChanges.length !== 0) {
            var rawContentChanges = [];
            var lineCount = oldLineCount;
            for (var i = 0, len = contentChanges.length; i < len; i++) {
                var change = contentChanges[i];
                var _a = TextModel._eolCount(change.text), eolCount = _a[0], firstLineLength = _a[1];
                this._tokens.applyEdits(change.range, eolCount, firstLineLength);
                this._onDidChangeDecorations.fire();
                this._decorationsTree.acceptReplace(change.rangeOffset, change.rangeLength, change.text.length, change.forceMoveMarkers);
                var startLineNumber = change.range.startLineNumber;
                var endLineNumber = change.range.endLineNumber;
                var deletingLinesCnt = endLineNumber - startLineNumber;
                var insertingLinesCnt = eolCount;
                var editingLinesCnt = Math.min(deletingLinesCnt, insertingLinesCnt);
                var changeLineCountDelta = (insertingLinesCnt - deletingLinesCnt);
                for (var j = editingLinesCnt; j >= 0; j--) {
                    var editLineNumber = startLineNumber + j;
                    var currentEditLineNumber = newLineCount - lineCount - changeLineCountDelta + editLineNumber;
                    rawContentChanges.push(new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["e" /* ModelRawLineChanged */](editLineNumber, this.getLineContent(currentEditLineNumber)));
                }
                if (editingLinesCnt < deletingLinesCnt) {
                    // Must delete some lines
                    var spliceStartLineNumber = startLineNumber + editingLinesCnt;
                    rawContentChanges.push(new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["f" /* ModelRawLinesDeleted */](spliceStartLineNumber + 1, endLineNumber));
                }
                if (editingLinesCnt < insertingLinesCnt) {
                    // Must insert some lines
                    var spliceLineNumber = startLineNumber + editingLinesCnt;
                    var cnt = insertingLinesCnt - editingLinesCnt;
                    var fromLineNumber = newLineCount - lineCount - cnt + spliceLineNumber + 1;
                    var newLines = [];
                    for (var i_1 = 0; i_1 < cnt; i_1++) {
                        var lineNumber = fromLineNumber + i_1;
                        newLines[lineNumber - fromLineNumber] = this.getLineContent(lineNumber);
                    }
                    rawContentChanges.push(new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["g" /* ModelRawLinesInserted */](spliceLineNumber + 1, startLineNumber + insertingLinesCnt, newLines));
                }
                lineCount += changeLineCountDelta;
            }
            this._increaseVersionId();
            this._emitContentChangedEvent(new __WEBPACK_IMPORTED_MODULE_7__textModelEvents_js__["b" /* ModelRawContentChangedEvent */](rawContentChanges, this.getVersionId(), this._isUndoing, this._isRedoing), {
                changes: contentChanges,
                eol: this._buffer.getEOL(),
                versionId: this.getVersionId(),
                isUndoing: this._isUndoing,
                isRedoing: this._isRedoing,
                isFlush: false
            });
        }
        if (this._tokens.hasLinesToTokenize(this._buffer)) {
            this._beginBackgroundTokenization();
        }
        return result.reverseEdits;
    };
    TextModel.prototype._undo = function () {
        this._isUndoing = true;
        var r = this._commandManager.undo();
        this._isUndoing = false;
        if (!r) {
            return null;
        }
        this._overwriteAlternativeVersionId(r.recordedVersionId);
        return r.selections;
    };
    TextModel.prototype.undo = function () {
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            return this._undo();
        }
        finally {
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    };
    TextModel.prototype.canUndo = function () {
        return this._commandManager.canUndo();
    };
    TextModel.prototype._redo = function () {
        this._isRedoing = true;
        var r = this._commandManager.redo();
        this._isRedoing = false;
        if (!r) {
            return null;
        }
        this._overwriteAlternativeVersionId(r.recordedVersionId);
        return r.selections;
    };
    TextModel.prototype.redo = function () {
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            return this._redo();
        }
        finally {
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    };
    TextModel.prototype.canRedo = function () {
        return this._commandManager.canRedo();
    };
    //#endregion
    //#region Decorations
    TextModel.prototype.changeDecorations = function (callback, ownerId) {
        if (ownerId === void 0) { ownerId = 0; }
        this._assertNotDisposed();
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            return this._changeDecorations(ownerId, callback);
        }
        finally {
            this._onDidChangeDecorations.endDeferredEmit();
        }
    };
    TextModel.prototype._changeDecorations = function (ownerId, callback) {
        var _this = this;
        var changeAccessor = {
            addDecoration: function (range, options) {
                _this._onDidChangeDecorations.fire();
                return _this._deltaDecorationsImpl(ownerId, [], [{ range: range, options: options }])[0];
            },
            changeDecoration: function (id, newRange) {
                _this._onDidChangeDecorations.fire();
                _this._changeDecorationImpl(id, newRange);
            },
            changeDecorationOptions: function (id, options) {
                _this._onDidChangeDecorations.fire();
                _this._changeDecorationOptionsImpl(id, _normalizeOptions(options));
            },
            removeDecoration: function (id) {
                _this._onDidChangeDecorations.fire();
                _this._deltaDecorationsImpl(ownerId, [id], []);
            },
            deltaDecorations: function (oldDecorations, newDecorations) {
                if (oldDecorations.length === 0 && newDecorations.length === 0) {
                    // nothing to do
                    return [];
                }
                _this._onDidChangeDecorations.fire();
                return _this._deltaDecorationsImpl(ownerId, oldDecorations, newDecorations);
            }
        };
        var result = null;
        try {
            result = callback(changeAccessor);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_8__base_common_errors_js__["e" /* onUnexpectedError */])(e);
        }
        // Invalidate change accessor
        changeAccessor.addDecoration = null;
        changeAccessor.changeDecoration = null;
        changeAccessor.removeDecoration = null;
        changeAccessor.deltaDecorations = null;
        return result;
    };
    TextModel.prototype.deltaDecorations = function (oldDecorations, newDecorations, ownerId) {
        if (ownerId === void 0) { ownerId = 0; }
        this._assertNotDisposed();
        if (!oldDecorations) {
            oldDecorations = [];
        }
        if (oldDecorations.length === 0 && newDecorations.length === 0) {
            // nothing to do
            return [];
        }
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._onDidChangeDecorations.fire();
            return this._deltaDecorationsImpl(ownerId, oldDecorations, newDecorations);
        }
        finally {
            this._onDidChangeDecorations.endDeferredEmit();
        }
    };
    TextModel.prototype._getTrackedRange = function (id) {
        return this.getDecorationRange(id);
    };
    TextModel.prototype._setTrackedRange = function (id, newRange, newStickiness) {
        var node = (id ? this._decorations[id] : null);
        if (!node) {
            if (!newRange) {
                // node doesn't exist, the request is to delete => nothing to do
                return null;
            }
            // node doesn't exist, the request is to set => add the tracked range
            return this._deltaDecorationsImpl(0, [], [{ range: newRange, options: TRACKED_RANGE_OPTIONS[newStickiness] }])[0];
        }
        if (!newRange) {
            // node exists, the request is to delete => delete node
            this._decorationsTree.delete(node);
            delete this._decorations[node.id];
            return null;
        }
        // node exists, the request is to set => change the tracked range and its options
        var range = this._validateRangeRelaxedNoAllocations(newRange);
        var startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
        var endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
        this._decorationsTree.delete(node);
        node.reset(this.getVersionId(), startOffset, endOffset, range);
        node.setOptions(TRACKED_RANGE_OPTIONS[newStickiness]);
        this._decorationsTree.insert(node);
        return node.id;
    };
    TextModel.prototype.removeAllDecorationsWithOwnerId = function (ownerId) {
        if (this._isDisposed) {
            return;
        }
        var nodes = this._decorationsTree.collectNodesFromOwner(ownerId);
        for (var i = 0, len = nodes.length; i < len; i++) {
            var node = nodes[i];
            this._decorationsTree.delete(node);
            delete this._decorations[node.id];
        }
    };
    TextModel.prototype.getDecorationOptions = function (decorationId) {
        var node = this._decorations[decorationId];
        if (!node) {
            return null;
        }
        return node.options;
    };
    TextModel.prototype.getDecorationRange = function (decorationId) {
        var node = this._decorations[decorationId];
        if (!node) {
            return null;
        }
        var versionId = this.getVersionId();
        if (node.cachedVersionId !== versionId) {
            this._decorationsTree.resolveNode(node, versionId);
        }
        if (node.range === null) {
            node.range = this._getRangeAt(node.cachedAbsoluteStart, node.cachedAbsoluteEnd);
        }
        return node.range;
    };
    TextModel.prototype.getLineDecorations = function (lineNumber, ownerId, filterOutValidation) {
        if (ownerId === void 0) { ownerId = 0; }
        if (filterOutValidation === void 0) { filterOutValidation = false; }
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            return [];
        }
        return this.getLinesDecorations(lineNumber, lineNumber, ownerId, filterOutValidation);
    };
    TextModel.prototype.getLinesDecorations = function (_startLineNumber, _endLineNumber, ownerId, filterOutValidation) {
        if (ownerId === void 0) { ownerId = 0; }
        if (filterOutValidation === void 0) { filterOutValidation = false; }
        var lineCount = this.getLineCount();
        var startLineNumber = Math.min(lineCount, Math.max(1, _startLineNumber));
        var endLineNumber = Math.min(lineCount, Math.max(1, _endLineNumber));
        var endColumn = this.getLineMaxColumn(endLineNumber);
        return this._getDecorationsInRange(new __WEBPACK_IMPORTED_MODULE_5__core_range_js__["a" /* Range */](startLineNumber, 1, endLineNumber, endColumn), ownerId, filterOutValidation);
    };
    TextModel.prototype.getDecorationsInRange = function (range, ownerId, filterOutValidation) {
        if (ownerId === void 0) { ownerId = 0; }
        if (filterOutValidation === void 0) { filterOutValidation = false; }
        var validatedRange = this.validateRange(range);
        return this._getDecorationsInRange(validatedRange, ownerId, filterOutValidation);
    };
    TextModel.prototype.getOverviewRulerDecorations = function (ownerId, filterOutValidation) {
        if (ownerId === void 0) { ownerId = 0; }
        if (filterOutValidation === void 0) { filterOutValidation = false; }
        var versionId = this.getVersionId();
        var result = this._decorationsTree.search(ownerId, filterOutValidation, true, versionId);
        return this._ensureNodesHaveRanges(result);
    };
    TextModel.prototype.getAllDecorations = function (ownerId, filterOutValidation) {
        if (ownerId === void 0) { ownerId = 0; }
        if (filterOutValidation === void 0) { filterOutValidation = false; }
        var versionId = this.getVersionId();
        var result = this._decorationsTree.search(ownerId, filterOutValidation, false, versionId);
        return this._ensureNodesHaveRanges(result);
    };
    TextModel.prototype._getDecorationsInRange = function (filterRange, filterOwnerId, filterOutValidation) {
        var startOffset = this._buffer.getOffsetAt(filterRange.startLineNumber, filterRange.startColumn);
        var endOffset = this._buffer.getOffsetAt(filterRange.endLineNumber, filterRange.endColumn);
        var versionId = this.getVersionId();
        var result = this._decorationsTree.intervalSearch(startOffset, endOffset, filterOwnerId, filterOutValidation, versionId);
        return this._ensureNodesHaveRanges(result);
    };
    TextModel.prototype._ensureNodesHaveRanges = function (nodes) {
        for (var i = 0, len = nodes.length; i < len; i++) {
            var node = nodes[i];
            if (node.range === null) {
                node.range = this._getRangeAt(node.cachedAbsoluteStart, node.cachedAbsoluteEnd);
            }
        }
        return nodes;
    };
    TextModel.prototype._getRangeAt = function (start, end) {
        return this._buffer.getRangeAt(start, end - start);
    };
    TextModel.prototype._changeDecorationImpl = function (decorationId, _range) {
        var node = this._decorations[decorationId];
        if (!node) {
            return;
        }
        var range = this._validateRangeRelaxedNoAllocations(_range);
        var startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
        var endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
        this._decorationsTree.delete(node);
        node.reset(this.getVersionId(), startOffset, endOffset, range);
        this._decorationsTree.insert(node);
    };
    TextModel.prototype._changeDecorationOptionsImpl = function (decorationId, options) {
        var node = this._decorations[decorationId];
        if (!node) {
            return;
        }
        var nodeWasInOverviewRuler = (node.options.overviewRuler.color ? true : false);
        var nodeIsInOverviewRuler = (options.overviewRuler.color ? true : false);
        if (nodeWasInOverviewRuler !== nodeIsInOverviewRuler) {
            // Delete + Insert due to an overview ruler status change
            this._decorationsTree.delete(node);
            node.setOptions(options);
            this._decorationsTree.insert(node);
        }
        else {
            node.setOptions(options);
        }
    };
    TextModel.prototype._deltaDecorationsImpl = function (ownerId, oldDecorationsIds, newDecorations) {
        var versionId = this.getVersionId();
        var oldDecorationsLen = oldDecorationsIds.length;
        var oldDecorationIndex = 0;
        var newDecorationsLen = newDecorations.length;
        var newDecorationIndex = 0;
        var result = new Array(newDecorationsLen);
        while (oldDecorationIndex < oldDecorationsLen || newDecorationIndex < newDecorationsLen) {
            var node = null;
            if (oldDecorationIndex < oldDecorationsLen) {
                // (1) get ourselves an old node
                do {
                    node = this._decorations[oldDecorationsIds[oldDecorationIndex++]];
                } while (!node && oldDecorationIndex < oldDecorationsLen);
                // (2) remove the node from the tree (if it exists)
                if (node) {
                    this._decorationsTree.delete(node);
                }
            }
            if (newDecorationIndex < newDecorationsLen) {
                // (3) create a new node if necessary
                if (!node) {
                    var internalDecorationId = (++this._lastDecorationId);
                    var decorationId = this._instanceId + ";" + internalDecorationId;
                    node = new __WEBPACK_IMPORTED_MODULE_10__intervalTree_js__["a" /* IntervalNode */](decorationId, 0, 0);
                    this._decorations[decorationId] = node;
                }
                // (4) initialize node
                var newDecoration = newDecorations[newDecorationIndex];
                var range = this._validateRangeRelaxedNoAllocations(newDecoration.range);
                var options = _normalizeOptions(newDecoration.options);
                var startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
                var endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
                node.ownerId = ownerId;
                node.reset(versionId, startOffset, endOffset, range);
                node.setOptions(options);
                this._decorationsTree.insert(node);
                result[newDecorationIndex] = node.id;
                newDecorationIndex++;
            }
            else {
                if (node) {
                    delete this._decorations[node.id];
                }
            }
        }
        return result;
    };
    //#endregion
    //#region Tokenization
    TextModel.prototype.tokenizeViewport = function (startLineNumber, endLineNumber) {
        if (!this._tokens.tokenizationSupport) {
            return;
        }
        // we tokenize `this._tokens.inValidLineStartIndex` lines in around 20ms so it's a good baseline.
        var contextBefore = Math.floor(this._tokens.inValidLineStartIndex * 0.3);
        startLineNumber = Math.max(1, startLineNumber - contextBefore);
        if (startLineNumber <= this._tokens.inValidLineStartIndex) {
            this.forceTokenization(endLineNumber);
            return;
        }
        var eventBuilder = new __WEBPACK_IMPORTED_MODULE_19__textModelTokens_js__["b" /* ModelTokensChangedEventBuilder */]();
        var nonWhitespaceColumn = this.getLineFirstNonWhitespaceColumn(startLineNumber);
        var fakeLines = [];
        var i = startLineNumber - 1;
        var initialState = null;
        if (nonWhitespaceColumn > 0) {
            while (nonWhitespaceColumn > 0 && i >= 1) {
                var newNonWhitespaceIndex = this.getLineFirstNonWhitespaceColumn(i);
                if (newNonWhitespaceIndex === 0) {
                    i--;
                    continue;
                }
                if (newNonWhitespaceIndex < nonWhitespaceColumn) {
                    initialState = this._tokens._getState(i - 1);
                    if (initialState) {
                        break;
                    }
                    fakeLines.push(this.getLineContent(i));
                    nonWhitespaceColumn = newNonWhitespaceIndex;
                }
                i--;
            }
        }
        if (!initialState) {
            initialState = this._tokens.tokenizationSupport.getInitialState();
        }
        var state = initialState.clone();
        for (var i_2 = fakeLines.length - 1; i_2 >= 0; i_2--) {
            var r = this._tokens._tokenizeText(this._buffer, fakeLines[i_2], state);
            if (r) {
                state = r.endState.clone();
            }
            else {
                state = initialState.clone();
            }
        }
        var contextAfter = Math.floor(this._tokens.inValidLineStartIndex * 0.4);
        endLineNumber = Math.min(this.getLineCount(), endLineNumber + contextAfter);
        for (var i_3 = startLineNumber; i_3 <= endLineNumber; i_3++) {
            var text = this.getLineContent(i_3);
            var r = this._tokens._tokenizeText(this._buffer, text, state);
            if (r) {
                this._tokens._setTokens(this._tokens.languageIdentifier.id, i_3 - 1, text.length, r.tokens);
                /*
                 * we think it's valid and give it a state but we don't update `_invalidLineStartIndex` then the top-to-bottom tokenization
                 * goes through the viewport, it can skip them if they already have correct tokens and state, and the lines after the viewport
                 * can still be tokenized.
                 */
                this._tokens._setIsInvalid(i_3 - 1, false);
                this._tokens._setState(i_3 - 1, state);
                state = r.endState.clone();
                eventBuilder.registerChangedTokens(i_3);
            }
            else {
                state = initialState.clone();
            }
        }
        var e = eventBuilder.build();
        if (e) {
            this._onDidChangeTokens.fire(e);
        }
    };
    TextModel.prototype.forceTokenization = function (lineNumber) {
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            throw new Error('Illegal value for lineNumber');
        }
        var eventBuilder = new __WEBPACK_IMPORTED_MODULE_19__textModelTokens_js__["b" /* ModelTokensChangedEventBuilder */]();
        this._tokens._updateTokensUntilLine(this._buffer, eventBuilder, lineNumber);
        var e = eventBuilder.build();
        if (e) {
            this._onDidChangeTokens.fire(e);
        }
    };
    TextModel.prototype.isCheapToTokenize = function (lineNumber) {
        return this._tokens.isCheapToTokenize(lineNumber);
    };
    TextModel.prototype.tokenizeIfCheap = function (lineNumber) {
        if (this.isCheapToTokenize(lineNumber)) {
            this.forceTokenization(lineNumber);
        }
    };
    TextModel.prototype.getLineTokens = function (lineNumber) {
        if (lineNumber < 1 || lineNumber > this.getLineCount()) {
            throw new Error('Illegal value for lineNumber');
        }
        return this._getLineTokens(lineNumber);
    };
    TextModel.prototype._getLineTokens = function (lineNumber) {
        var lineText = this._buffer.getLineContent(lineNumber);
        return this._tokens.getTokens(this._languageIdentifier.id, lineNumber - 1, lineText);
    };
    TextModel.prototype.getLanguageIdentifier = function () {
        return this._languageIdentifier;
    };
    TextModel.prototype.getModeId = function () {
        return this._languageIdentifier.language;
    };
    TextModel.prototype.setMode = function (languageIdentifier) {
        if (this._languageIdentifier.id === languageIdentifier.id) {
            // There's nothing to do
            return;
        }
        var e = {
            oldLanguage: this._languageIdentifier.language,
            newLanguage: languageIdentifier.language
        };
        this._languageIdentifier = languageIdentifier;
        // Cancel tokenization, clear all tokens and begin tokenizing
        this._resetTokenizationState();
        this.emitModelTokensChangedEvent({
            ranges: [{
                    fromLineNumber: 1,
                    toLineNumber: this.getLineCount()
                }]
        });
        this._onDidChangeLanguage.fire(e);
        this._onDidChangeLanguageConfiguration.fire({});
    };
    TextModel.prototype.getLanguageIdAtPosition = function (_lineNumber, _column) {
        if (!this._tokens.tokenizationSupport) {
            return this._languageIdentifier.id;
        }
        var _a = this.validatePosition({ lineNumber: _lineNumber, column: _column }), lineNumber = _a.lineNumber, column = _a.column;
        var lineTokens = this._getLineTokens(lineNumber);
        return lineTokens.getLanguageId(lineTokens.findTokenIndexAtOffset(column - 1));
    };
    TextModel.prototype._beginBackgroundTokenization = function () {
        var _this = this;
        if (this._shouldAutoTokenize() && this._revalidateTokensTimeout === -1) {
            this._revalidateTokensTimeout = setTimeout(function () {
                _this._revalidateTokensTimeout = -1;
                _this._revalidateTokensNow();
            }, 0);
        }
    };
    TextModel.prototype._warmUpTokens = function () {
        // Warm up first 100 lines (if it takes less than 50ms)
        var maxLineNumber = Math.min(100, this.getLineCount());
        this._revalidateTokensNow(maxLineNumber);
        if (this._tokens.hasLinesToTokenize(this._buffer)) {
            this._beginBackgroundTokenization();
        }
    };
    TextModel.prototype._revalidateTokensNow = function (toLineNumber) {
        if (toLineNumber === void 0) { toLineNumber = this._buffer.getLineCount(); }
        var MAX_ALLOWED_TIME = 20;
        var eventBuilder = new __WEBPACK_IMPORTED_MODULE_19__textModelTokens_js__["b" /* ModelTokensChangedEventBuilder */]();
        var sw = __WEBPACK_IMPORTED_MODULE_12__base_common_stopwatch_js__["a" /* StopWatch */].create(false);
        while (this._tokens.hasLinesToTokenize(this._buffer)) {
            if (sw.elapsed() > MAX_ALLOWED_TIME) {
                // Stop if MAX_ALLOWED_TIME is reached
                break;
            }
            var tokenizedLineNumber = this._tokens._tokenizeOneLine(this._buffer, eventBuilder);
            if (tokenizedLineNumber >= toLineNumber) {
                break;
            }
        }
        if (this._tokens.hasLinesToTokenize(this._buffer)) {
            this._beginBackgroundTokenization();
        }
        var e = eventBuilder.build();
        if (e) {
            this._onDidChangeTokens.fire(e);
        }
    };
    TextModel.prototype.emitModelTokensChangedEvent = function (e) {
        if (!this._isDisposing) {
            this._onDidChangeTokens.fire(e);
        }
    };
    // Having tokens allows implementing additional helper methods
    TextModel.prototype.getWordAtPosition = function (_position) {
        this._assertNotDisposed();
        var position = this.validatePosition(_position);
        var lineContent = this.getLineContent(position.lineNumber);
        var lineTokens = this._getLineTokens(position.lineNumber);
        var tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
        // (1). First try checking right biased word
        var _a = TextModel._findLanguageBoundaries(lineTokens, tokenIndex), rbStartOffset = _a[0], rbEndOffset = _a[1];
        var rightBiasedWord = Object(__WEBPACK_IMPORTED_MODULE_18__wordHelper_js__["d" /* getWordAtText */])(position.column, __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getWordDefinition(lineTokens.getLanguageId(tokenIndex)), lineContent.substring(rbStartOffset, rbEndOffset), rbStartOffset);
        if (rightBiasedWord) {
            return rightBiasedWord;
        }
        // (2). Else, if we were at a language boundary, check the left biased word
        if (tokenIndex > 0 && rbStartOffset === position.column - 1) {
            // edge case, where `position` sits between two tokens belonging to two different languages
            var _b = TextModel._findLanguageBoundaries(lineTokens, tokenIndex - 1), lbStartOffset = _b[0], lbEndOffset = _b[1];
            var leftBiasedWord = Object(__WEBPACK_IMPORTED_MODULE_18__wordHelper_js__["d" /* getWordAtText */])(position.column, __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getWordDefinition(lineTokens.getLanguageId(tokenIndex - 1)), lineContent.substring(lbStartOffset, lbEndOffset), lbStartOffset);
            if (leftBiasedWord) {
                return leftBiasedWord;
            }
        }
        return null;
    };
    TextModel._findLanguageBoundaries = function (lineTokens, tokenIndex) {
        var languageId = lineTokens.getLanguageId(tokenIndex);
        // go left until a different language is hit
        var startOffset;
        for (var i = tokenIndex; i >= 0 && lineTokens.getLanguageId(i) === languageId; i--) {
            startOffset = lineTokens.getStartOffset(i);
        }
        // go right until a different language is hit
        var endOffset;
        for (var i = tokenIndex, tokenCount = lineTokens.getCount(); i < tokenCount && lineTokens.getLanguageId(i) === languageId; i++) {
            endOffset = lineTokens.getEndOffset(i);
        }
        return [startOffset, endOffset];
    };
    TextModel.prototype.getWordUntilPosition = function (position) {
        var wordAtPosition = this.getWordAtPosition(position);
        if (!wordAtPosition) {
            return {
                word: '',
                startColumn: position.column,
                endColumn: position.column
            };
        }
        return {
            word: wordAtPosition.word.substr(0, position.column - wordAtPosition.startColumn),
            startColumn: wordAtPosition.startColumn,
            endColumn: position.column
        };
    };
    TextModel.prototype.findMatchingBracketUp = function (_bracket, _position) {
        var bracket = _bracket.toLowerCase();
        var position = this.validatePosition(_position);
        var lineTokens = this._getLineTokens(position.lineNumber);
        var languageId = lineTokens.getLanguageId(lineTokens.findTokenIndexAtOffset(position.column - 1));
        var bracketsSupport = __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getBracketsSupport(languageId);
        if (!bracketsSupport) {
            return null;
        }
        var data = bracketsSupport.textIsBracket[bracket];
        if (!data) {
            return null;
        }
        return this._findMatchingBracketUp(data, position);
    };
    TextModel.prototype.matchBracket = function (position) {
        return this._matchBracket(this.validatePosition(position));
    };
    TextModel.prototype._matchBracket = function (position) {
        var lineNumber = position.lineNumber;
        var lineTokens = this._getLineTokens(lineNumber);
        var lineText = this._buffer.getLineContent(lineNumber);
        var tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
        if (tokenIndex < 0) {
            return null;
        }
        var currentModeBrackets = __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getBracketsSupport(lineTokens.getLanguageId(tokenIndex));
        // check that the token is not to be ignored
        if (currentModeBrackets && !Object(__WEBPACK_IMPORTED_MODULE_14__modes_supports_js__["b" /* ignoreBracketsInToken */])(lineTokens.getStandardTokenType(tokenIndex))) {
            // limit search to not go before `maxBracketLength`
            var searchStartOffset = Math.max(lineTokens.getStartOffset(tokenIndex), position.column - 1 - currentModeBrackets.maxBracketLength);
            // limit search to not go after `maxBracketLength`
            var searchEndOffset = Math.min(lineTokens.getEndOffset(tokenIndex), position.column - 1 + currentModeBrackets.maxBracketLength);
            // it might be the case that [currentTokenStart -> currentTokenEnd] contains multiple brackets
            // `bestResult` will contain the most right-side result
            var bestResult = null;
            while (true) {
                var foundBracket = __WEBPACK_IMPORTED_MODULE_15__modes_supports_richEditBrackets_js__["a" /* BracketsUtils */].findNextBracketInToken(currentModeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (!foundBracket) {
                    // there are no more brackets in this text
                    break;
                }
                // check that we didn't hit a bracket too far away from position
                if (foundBracket.startColumn <= position.column && position.column <= foundBracket.endColumn) {
                    var foundBracketText = lineText.substring(foundBracket.startColumn - 1, foundBracket.endColumn - 1);
                    foundBracketText = foundBracketText.toLowerCase();
                    var r = this._matchFoundBracket(foundBracket, currentModeBrackets.textIsBracket[foundBracketText], currentModeBrackets.textIsOpenBracket[foundBracketText]);
                    // check that we can actually match this bracket
                    if (r) {
                        bestResult = r;
                    }
                }
                searchStartOffset = foundBracket.endColumn - 1;
            }
            if (bestResult) {
                return bestResult;
            }
        }
        // If position is in between two tokens, try also looking in the previous token
        if (tokenIndex > 0 && lineTokens.getStartOffset(tokenIndex) === position.column - 1) {
            var searchEndOffset = lineTokens.getStartOffset(tokenIndex);
            tokenIndex--;
            var prevModeBrackets = __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getBracketsSupport(lineTokens.getLanguageId(tokenIndex));
            // check that previous token is not to be ignored
            if (prevModeBrackets && !Object(__WEBPACK_IMPORTED_MODULE_14__modes_supports_js__["b" /* ignoreBracketsInToken */])(lineTokens.getStandardTokenType(tokenIndex))) {
                // limit search in case previous token is very large, there's no need to go beyond `maxBracketLength`
                var searchStartOffset = Math.max(lineTokens.getStartOffset(tokenIndex), position.column - 1 - prevModeBrackets.maxBracketLength);
                var foundBracket = __WEBPACK_IMPORTED_MODULE_15__modes_supports_richEditBrackets_js__["a" /* BracketsUtils */].findPrevBracketInToken(prevModeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                // check that we didn't hit a bracket too far away from position
                if (foundBracket && foundBracket.startColumn <= position.column && position.column <= foundBracket.endColumn) {
                    var foundBracketText = lineText.substring(foundBracket.startColumn - 1, foundBracket.endColumn - 1);
                    foundBracketText = foundBracketText.toLowerCase();
                    var r = this._matchFoundBracket(foundBracket, prevModeBrackets.textIsBracket[foundBracketText], prevModeBrackets.textIsOpenBracket[foundBracketText]);
                    // check that we can actually match this bracket
                    if (r) {
                        return r;
                    }
                }
            }
        }
        return null;
    };
    TextModel.prototype._matchFoundBracket = function (foundBracket, data, isOpen) {
        if (!data) {
            return null;
        }
        if (isOpen) {
            var matched = this._findMatchingBracketDown(data, foundBracket.getEndPosition());
            if (matched) {
                return [foundBracket, matched];
            }
        }
        else {
            var matched = this._findMatchingBracketUp(data, foundBracket.getStartPosition());
            if (matched) {
                return [foundBracket, matched];
            }
        }
        return null;
    };
    TextModel.prototype._findMatchingBracketUp = function (bracket, position) {
        // console.log('_findMatchingBracketUp: ', 'bracket: ', JSON.stringify(bracket), 'startPosition: ', String(position));
        var languageId = bracket.languageIdentifier.id;
        var reversedBracketRegex = bracket.reversedRegex;
        var count = -1;
        for (var lineNumber = position.lineNumber; lineNumber >= 1; lineNumber--) {
            var lineTokens = this._getLineTokens(lineNumber);
            var tokenCount = lineTokens.getCount();
            var lineText = this._buffer.getLineContent(lineNumber);
            var tokenIndex = tokenCount - 1;
            var searchStopOffset = -1;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStopOffset = position.column - 1;
            }
            for (; tokenIndex >= 0; tokenIndex--) {
                var tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                var tokenType = lineTokens.getStandardTokenType(tokenIndex);
                var tokenStartOffset = lineTokens.getStartOffset(tokenIndex);
                var tokenEndOffset = lineTokens.getEndOffset(tokenIndex);
                if (searchStopOffset === -1) {
                    searchStopOffset = tokenEndOffset;
                }
                if (tokenLanguageId === languageId && !Object(__WEBPACK_IMPORTED_MODULE_14__modes_supports_js__["b" /* ignoreBracketsInToken */])(tokenType)) {
                    while (true) {
                        var r = __WEBPACK_IMPORTED_MODULE_15__modes_supports_richEditBrackets_js__["a" /* BracketsUtils */].findPrevBracketInToken(reversedBracketRegex, lineNumber, lineText, tokenStartOffset, searchStopOffset);
                        if (!r) {
                            break;
                        }
                        var hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1);
                        hitText = hitText.toLowerCase();
                        if (hitText === bracket.open) {
                            count++;
                        }
                        else if (hitText === bracket.close) {
                            count--;
                        }
                        if (count === 0) {
                            return r;
                        }
                        searchStopOffset = r.startColumn - 1;
                    }
                }
                searchStopOffset = -1;
            }
        }
        return null;
    };
    TextModel.prototype._findMatchingBracketDown = function (bracket, position) {
        // console.log('_findMatchingBracketDown: ', 'bracket: ', JSON.stringify(bracket), 'startPosition: ', String(position));
        var languageId = bracket.languageIdentifier.id;
        var bracketRegex = bracket.forwardRegex;
        var count = 1;
        for (var lineNumber = position.lineNumber, lineCount = this.getLineCount(); lineNumber <= lineCount; lineNumber++) {
            var lineTokens = this._getLineTokens(lineNumber);
            var tokenCount = lineTokens.getCount();
            var lineText = this._buffer.getLineContent(lineNumber);
            var tokenIndex = 0;
            var searchStartOffset = 0;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStartOffset = position.column - 1;
            }
            for (; tokenIndex < tokenCount; tokenIndex++) {
                var tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                var tokenType = lineTokens.getStandardTokenType(tokenIndex);
                var tokenStartOffset = lineTokens.getStartOffset(tokenIndex);
                var tokenEndOffset = lineTokens.getEndOffset(tokenIndex);
                if (searchStartOffset === 0) {
                    searchStartOffset = tokenStartOffset;
                }
                if (tokenLanguageId === languageId && !Object(__WEBPACK_IMPORTED_MODULE_14__modes_supports_js__["b" /* ignoreBracketsInToken */])(tokenType)) {
                    while (true) {
                        var r = __WEBPACK_IMPORTED_MODULE_15__modes_supports_richEditBrackets_js__["a" /* BracketsUtils */].findNextBracketInToken(bracketRegex, lineNumber, lineText, searchStartOffset, tokenEndOffset);
                        if (!r) {
                            break;
                        }
                        var hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1);
                        hitText = hitText.toLowerCase();
                        if (hitText === bracket.open) {
                            count++;
                        }
                        else if (hitText === bracket.close) {
                            count--;
                        }
                        if (count === 0) {
                            return r;
                        }
                        searchStartOffset = r.endColumn - 1;
                    }
                }
                searchStartOffset = 0;
            }
        }
        return null;
    };
    TextModel.prototype.findNextBracket = function (_position) {
        var position = this.validatePosition(_position);
        var languageId = -1;
        var modeBrackets = null;
        for (var lineNumber = position.lineNumber, lineCount = this.getLineCount(); lineNumber <= lineCount; lineNumber++) {
            var lineTokens = this._getLineTokens(lineNumber);
            var tokenCount = lineTokens.getCount();
            var lineText = this._buffer.getLineContent(lineNumber);
            var tokenIndex = 0;
            var searchStartOffset = 0;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStartOffset = position.column - 1;
            }
            for (; tokenIndex < tokenCount; tokenIndex++) {
                var tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                var tokenType = lineTokens.getStandardTokenType(tokenIndex);
                var tokenStartOffset = lineTokens.getStartOffset(tokenIndex);
                var tokenEndOffset = lineTokens.getEndOffset(tokenIndex);
                if (searchStartOffset === 0) {
                    searchStartOffset = tokenStartOffset;
                }
                if (languageId !== tokenLanguageId) {
                    languageId = tokenLanguageId;
                    modeBrackets = __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getBracketsSupport(languageId);
                }
                if (modeBrackets && !Object(__WEBPACK_IMPORTED_MODULE_14__modes_supports_js__["b" /* ignoreBracketsInToken */])(tokenType)) {
                    var r = __WEBPACK_IMPORTED_MODULE_15__modes_supports_richEditBrackets_js__["a" /* BracketsUtils */].findNextBracketInToken(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, tokenEndOffset);
                    if (r) {
                        return this._toFoundBracket(modeBrackets, r);
                    }
                }
                searchStartOffset = 0;
            }
        }
        return null;
    };
    TextModel.prototype._toFoundBracket = function (modeBrackets, r) {
        if (!r) {
            return null;
        }
        var text = this.getValueInRange(r);
        text = text.toLowerCase();
        var data = modeBrackets.textIsBracket[text];
        if (!data) {
            return null;
        }
        return {
            range: r,
            open: data.open,
            close: data.close,
            isOpen: modeBrackets.textIsOpenBracket[text]
        };
    };
    /**
     * Returns:
     *  - -1 => the line consists of whitespace
     *  - otherwise => the indent level is returned value
     */
    TextModel.computeIndentLevel = function (line, tabSize) {
        var indent = 0;
        var i = 0;
        var len = line.length;
        while (i < len) {
            var chCode = line.charCodeAt(i);
            if (chCode === 32 /* Space */) {
                indent++;
            }
            else if (chCode === 9 /* Tab */) {
                indent = indent - indent % tabSize + tabSize;
            }
            else {
                break;
            }
            i++;
        }
        if (i === len) {
            return -1; // line only consists of whitespace
        }
        return indent;
    };
    TextModel.prototype._computeIndentLevel = function (lineIndex) {
        return TextModel.computeIndentLevel(this._buffer.getLineContent(lineIndex + 1), this._options.tabSize);
    };
    TextModel.prototype.getActiveIndentGuide = function (lineNumber, minLineNumber, maxLineNumber) {
        var _this = this;
        this._assertNotDisposed();
        var lineCount = this.getLineCount();
        if (lineNumber < 1 || lineNumber > lineCount) {
            throw new Error('Illegal value for lineNumber');
        }
        var foldingRules = __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getFoldingRules(this._languageIdentifier.id);
        var offSide = foldingRules && foldingRules.offSide;
        var up_aboveContentLineIndex = -2; /* -2 is a marker for not having computed it */
        var up_aboveContentLineIndent = -1;
        var up_belowContentLineIndex = -2; /* -2 is a marker for not having computed it */
        var up_belowContentLineIndent = -1;
        var up_resolveIndents = function (lineNumber) {
            if (up_aboveContentLineIndex !== -1 && (up_aboveContentLineIndex === -2 || up_aboveContentLineIndex > lineNumber - 1)) {
                up_aboveContentLineIndex = -1;
                up_aboveContentLineIndent = -1;
                // must find previous line with content
                for (var lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--) {
                    var indent_1 = _this._computeIndentLevel(lineIndex);
                    if (indent_1 >= 0) {
                        up_aboveContentLineIndex = lineIndex;
                        up_aboveContentLineIndent = indent_1;
                        break;
                    }
                }
            }
            if (up_belowContentLineIndex === -2) {
                up_belowContentLineIndex = -1;
                up_belowContentLineIndent = -1;
                // must find next line with content
                for (var lineIndex = lineNumber; lineIndex < lineCount; lineIndex++) {
                    var indent_2 = _this._computeIndentLevel(lineIndex);
                    if (indent_2 >= 0) {
                        up_belowContentLineIndex = lineIndex;
                        up_belowContentLineIndent = indent_2;
                        break;
                    }
                }
            }
        };
        var down_aboveContentLineIndex = -2; /* -2 is a marker for not having computed it */
        var down_aboveContentLineIndent = -1;
        var down_belowContentLineIndex = -2; /* -2 is a marker for not having computed it */
        var down_belowContentLineIndent = -1;
        var down_resolveIndents = function (lineNumber) {
            if (down_aboveContentLineIndex === -2) {
                down_aboveContentLineIndex = -1;
                down_aboveContentLineIndent = -1;
                // must find previous line with content
                for (var lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--) {
                    var indent_3 = _this._computeIndentLevel(lineIndex);
                    if (indent_3 >= 0) {
                        down_aboveContentLineIndex = lineIndex;
                        down_aboveContentLineIndent = indent_3;
                        break;
                    }
                }
            }
            if (down_belowContentLineIndex !== -1 && (down_belowContentLineIndex === -2 || down_belowContentLineIndex < lineNumber - 1)) {
                down_belowContentLineIndex = -1;
                down_belowContentLineIndent = -1;
                // must find next line with content
                for (var lineIndex = lineNumber; lineIndex < lineCount; lineIndex++) {
                    var indent_4 = _this._computeIndentLevel(lineIndex);
                    if (indent_4 >= 0) {
                        down_belowContentLineIndex = lineIndex;
                        down_belowContentLineIndent = indent_4;
                        break;
                    }
                }
            }
        };
        var startLineNumber = 0;
        var goUp = true;
        var endLineNumber = 0;
        var goDown = true;
        var indent = 0;
        for (var distance = 0; goUp || goDown; distance++) {
            var upLineNumber = lineNumber - distance;
            var downLineNumber = lineNumber + distance;
            if (distance !== 0 && (upLineNumber < 1 || upLineNumber < minLineNumber)) {
                goUp = false;
            }
            if (distance !== 0 && (downLineNumber > lineCount || downLineNumber > maxLineNumber)) {
                goDown = false;
            }
            if (distance > 50000) {
                // stop processing
                goUp = false;
                goDown = false;
            }
            if (goUp) {
                // compute indent level going up
                var upLineIndentLevel = void 0;
                var currentIndent = this._computeIndentLevel(upLineNumber - 1);
                if (currentIndent >= 0) {
                    // This line has content (besides whitespace)
                    // Use the line's indent
                    up_belowContentLineIndex = upLineNumber - 1;
                    up_belowContentLineIndent = currentIndent;
                    upLineIndentLevel = Math.ceil(currentIndent / this._options.tabSize);
                }
                else {
                    up_resolveIndents(upLineNumber);
                    upLineIndentLevel = this._getIndentLevelForWhitespaceLine(offSide, up_aboveContentLineIndent, up_belowContentLineIndent);
                }
                if (distance === 0) {
                    // This is the initial line number
                    startLineNumber = upLineNumber;
                    endLineNumber = downLineNumber;
                    indent = upLineIndentLevel;
                    if (indent === 0) {
                        // No need to continue
                        return { startLineNumber: startLineNumber, endLineNumber: endLineNumber, indent: indent };
                    }
                    continue;
                }
                if (upLineIndentLevel >= indent) {
                    startLineNumber = upLineNumber;
                }
                else {
                    goUp = false;
                }
            }
            if (goDown) {
                // compute indent level going down
                var downLineIndentLevel = void 0;
                var currentIndent = this._computeIndentLevel(downLineNumber - 1);
                if (currentIndent >= 0) {
                    // This line has content (besides whitespace)
                    // Use the line's indent
                    down_aboveContentLineIndex = downLineNumber - 1;
                    down_aboveContentLineIndent = currentIndent;
                    downLineIndentLevel = Math.ceil(currentIndent / this._options.tabSize);
                }
                else {
                    down_resolveIndents(downLineNumber);
                    downLineIndentLevel = this._getIndentLevelForWhitespaceLine(offSide, down_aboveContentLineIndent, down_belowContentLineIndent);
                }
                if (downLineIndentLevel >= indent) {
                    endLineNumber = downLineNumber;
                }
                else {
                    goDown = false;
                }
            }
        }
        return { startLineNumber: startLineNumber, endLineNumber: endLineNumber, indent: indent };
    };
    TextModel.prototype.getLinesIndentGuides = function (startLineNumber, endLineNumber) {
        this._assertNotDisposed();
        var lineCount = this.getLineCount();
        if (startLineNumber < 1 || startLineNumber > lineCount) {
            throw new Error('Illegal value for startLineNumber');
        }
        if (endLineNumber < 1 || endLineNumber > lineCount) {
            throw new Error('Illegal value for endLineNumber');
        }
        var foldingRules = __WEBPACK_IMPORTED_MODULE_17__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getFoldingRules(this._languageIdentifier.id);
        var offSide = foldingRules && foldingRules.offSide;
        var result = new Array(endLineNumber - startLineNumber + 1);
        var aboveContentLineIndex = -2; /* -2 is a marker for not having computed it */
        var aboveContentLineIndent = -1;
        var belowContentLineIndex = -2; /* -2 is a marker for not having computed it */
        var belowContentLineIndent = -1;
        for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
            var resultIndex = lineNumber - startLineNumber;
            var currentIndent = this._computeIndentLevel(lineNumber - 1);
            if (currentIndent >= 0) {
                // This line has content (besides whitespace)
                // Use the line's indent
                aboveContentLineIndex = lineNumber - 1;
                aboveContentLineIndent = currentIndent;
                result[resultIndex] = Math.ceil(currentIndent / this._options.tabSize);
                continue;
            }
            if (aboveContentLineIndex === -2) {
                aboveContentLineIndex = -1;
                aboveContentLineIndent = -1;
                // must find previous line with content
                for (var lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--) {
                    var indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        aboveContentLineIndex = lineIndex;
                        aboveContentLineIndent = indent;
                        break;
                    }
                }
            }
            if (belowContentLineIndex !== -1 && (belowContentLineIndex === -2 || belowContentLineIndex < lineNumber - 1)) {
                belowContentLineIndex = -1;
                belowContentLineIndent = -1;
                // must find next line with content
                for (var lineIndex = lineNumber; lineIndex < lineCount; lineIndex++) {
                    var indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        belowContentLineIndex = lineIndex;
                        belowContentLineIndent = indent;
                        break;
                    }
                }
            }
            result[resultIndex] = this._getIndentLevelForWhitespaceLine(offSide, aboveContentLineIndent, belowContentLineIndent);
        }
        return result;
    };
    TextModel.prototype._getIndentLevelForWhitespaceLine = function (offSide, aboveContentLineIndent, belowContentLineIndent) {
        if (aboveContentLineIndent === -1 || belowContentLineIndent === -1) {
            // At the top or bottom of the file
            return 0;
        }
        else if (aboveContentLineIndent < belowContentLineIndent) {
            // we are inside the region above
            return (1 + Math.floor(aboveContentLineIndent / this._options.tabSize));
        }
        else if (aboveContentLineIndent === belowContentLineIndent) {
            // we are in between two regions
            return Math.ceil(belowContentLineIndent / this._options.tabSize);
        }
        else {
            if (offSide) {
                // same level as region below
                return Math.ceil(belowContentLineIndent / this._options.tabSize);
            }
            else {
                // we are inside the region that ends below
                return (1 + Math.floor(belowContentLineIndent / this._options.tabSize));
            }
        }
    };
    TextModel.MODEL_SYNC_LIMIT = 50 * 1024 * 1024; // 50 MB
    TextModel.LARGE_FILE_SIZE_THRESHOLD = 20 * 1024 * 1024; // 20 MB;
    TextModel.LARGE_FILE_LINE_COUNT_THRESHOLD = 300 * 1000; // 300K lines
    TextModel.DEFAULT_CREATION_OPTIONS = {
        isForSimpleWidget: false,
        tabSize: __WEBPACK_IMPORTED_MODULE_21__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].tabSize,
        insertSpaces: __WEBPACK_IMPORTED_MODULE_21__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].insertSpaces,
        detectIndentation: false,
        defaultEOL: __WEBPACK_IMPORTED_MODULE_2__model_js__["b" /* DefaultEndOfLine */].LF,
        trimAutoWhitespace: __WEBPACK_IMPORTED_MODULE_21__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].trimAutoWhitespace,
        largeFileOptimizations: __WEBPACK_IMPORTED_MODULE_21__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].largeFileOptimizations,
    };
    return TextModel;
}(__WEBPACK_IMPORTED_MODULE_11__base_common_lifecycle_js__["a" /* Disposable */]));

//#region Decorations
var DecorationsTrees = /** @class */ (function () {
    function DecorationsTrees() {
        this._decorationsTree0 = new __WEBPACK_IMPORTED_MODULE_10__intervalTree_js__["b" /* IntervalTree */]();
        this._decorationsTree1 = new __WEBPACK_IMPORTED_MODULE_10__intervalTree_js__["b" /* IntervalTree */]();
    }
    DecorationsTrees.prototype.intervalSearch = function (start, end, filterOwnerId, filterOutValidation, cachedVersionId) {
        var r0 = this._decorationsTree0.intervalSearch(start, end, filterOwnerId, filterOutValidation, cachedVersionId);
        var r1 = this._decorationsTree1.intervalSearch(start, end, filterOwnerId, filterOutValidation, cachedVersionId);
        return r0.concat(r1);
    };
    DecorationsTrees.prototype.search = function (filterOwnerId, filterOutValidation, overviewRulerOnly, cachedVersionId) {
        if (overviewRulerOnly) {
            return this._decorationsTree1.search(filterOwnerId, filterOutValidation, cachedVersionId);
        }
        else {
            var r0 = this._decorationsTree0.search(filterOwnerId, filterOutValidation, cachedVersionId);
            var r1 = this._decorationsTree1.search(filterOwnerId, filterOutValidation, cachedVersionId);
            return r0.concat(r1);
        }
    };
    DecorationsTrees.prototype.collectNodesFromOwner = function (ownerId) {
        var r0 = this._decorationsTree0.collectNodesFromOwner(ownerId);
        var r1 = this._decorationsTree1.collectNodesFromOwner(ownerId);
        return r0.concat(r1);
    };
    DecorationsTrees.prototype.collectNodesPostOrder = function () {
        var r0 = this._decorationsTree0.collectNodesPostOrder();
        var r1 = this._decorationsTree1.collectNodesPostOrder();
        return r0.concat(r1);
    };
    DecorationsTrees.prototype.insert = function (node) {
        if (Object(__WEBPACK_IMPORTED_MODULE_10__intervalTree_js__["c" /* getNodeIsInOverviewRuler */])(node)) {
            this._decorationsTree1.insert(node);
        }
        else {
            this._decorationsTree0.insert(node);
        }
    };
    DecorationsTrees.prototype.delete = function (node) {
        if (Object(__WEBPACK_IMPORTED_MODULE_10__intervalTree_js__["c" /* getNodeIsInOverviewRuler */])(node)) {
            this._decorationsTree1.delete(node);
        }
        else {
            this._decorationsTree0.delete(node);
        }
    };
    DecorationsTrees.prototype.resolveNode = function (node, cachedVersionId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_10__intervalTree_js__["c" /* getNodeIsInOverviewRuler */])(node)) {
            this._decorationsTree1.resolveNode(node, cachedVersionId);
        }
        else {
            this._decorationsTree0.resolveNode(node, cachedVersionId);
        }
    };
    DecorationsTrees.prototype.acceptReplace = function (offset, length, textLength, forceMoveMarkers) {
        this._decorationsTree0.acceptReplace(offset, length, textLength, forceMoveMarkers);
        this._decorationsTree1.acceptReplace(offset, length, textLength, forceMoveMarkers);
    };
    return DecorationsTrees;
}());
function cleanClassName(className) {
    return className.replace(/[^a-z0-9\-_]/gi, ' ');
}
var ModelDecorationOverviewRulerOptions = /** @class */ (function () {
    function ModelDecorationOverviewRulerOptions(options) {
        this.color = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.darkColor = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.hcColor = __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.position = __WEBPACK_IMPORTED_MODULE_2__model_js__["f" /* OverviewRulerLane */].Center;
        this._resolvedColor = null;
        if (options && options.color) {
            this.color = options.color;
        }
        if (options && options.darkColor) {
            this.darkColor = options.darkColor;
            this.hcColor = options.darkColor;
        }
        if (options && options.hcColor) {
            this.hcColor = options.hcColor;
        }
        if (options && options.hasOwnProperty('position')) {
            this.position = options.position;
        }
    }
    return ModelDecorationOverviewRulerOptions;
}());

var ModelDecorationOptions = /** @class */ (function () {
    function ModelDecorationOptions(options) {
        this.stickiness = options.stickiness || __WEBPACK_IMPORTED_MODULE_2__model_js__["h" /* TrackedRangeStickiness */].AlwaysGrowsWhenTypingAtEdges;
        this.zIndex = options.zIndex || 0;
        this.className = options.className ? cleanClassName(options.className) : __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.hoverMessage = options.hoverMessage || [];
        this.glyphMarginHoverMessage = options.glyphMarginHoverMessage || [];
        this.isWholeLine = options.isWholeLine || false;
        this.showIfCollapsed = options.showIfCollapsed || false;
        this.overviewRuler = new ModelDecorationOverviewRulerOptions(options.overviewRuler);
        this.glyphMarginClassName = options.glyphMarginClassName ? cleanClassName(options.glyphMarginClassName) : __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.linesDecorationsClassName = options.linesDecorationsClassName ? cleanClassName(options.linesDecorationsClassName) : __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.marginClassName = options.marginClassName ? cleanClassName(options.marginClassName) : __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.inlineClassName = options.inlineClassName ? cleanClassName(options.inlineClassName) : __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.inlineClassNameAffectsLetterSpacing = options.inlineClassNameAffectsLetterSpacing || false;
        this.beforeContentClassName = options.beforeContentClassName ? cleanClassName(options.beforeContentClassName) : __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
        this.afterContentClassName = options.afterContentClassName ? cleanClassName(options.afterContentClassName) : __WEBPACK_IMPORTED_MODULE_9__base_common_strings_js__["empty"];
    }
    ModelDecorationOptions.register = function (options) {
        return new ModelDecorationOptions(options);
    };
    ModelDecorationOptions.createDynamic = function (options) {
        return new ModelDecorationOptions(options);
    };
    return ModelDecorationOptions;
}());

ModelDecorationOptions.EMPTY = ModelDecorationOptions.register({});
/**
 * The order carefully matches the values of the enum.
 */
var TRACKED_RANGE_OPTIONS = [
    ModelDecorationOptions.register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__model_js__["h" /* TrackedRangeStickiness */].AlwaysGrowsWhenTypingAtEdges }),
    ModelDecorationOptions.register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges }),
    ModelDecorationOptions.register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__model_js__["h" /* TrackedRangeStickiness */].GrowsOnlyWhenTypingBefore }),
    ModelDecorationOptions.register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__model_js__["h" /* TrackedRangeStickiness */].GrowsOnlyWhenTypingAfter }),
];
function _normalizeOptions(options) {
    if (options instanceof ModelDecorationOptions) {
        return options;
    }
    return ModelDecorationOptions.createDynamic(options);
}
var DidChangeDecorationsEmitter = /** @class */ (function (_super) {
    __extends(DidChangeDecorationsEmitter, _super);
    function DidChangeDecorationsEmitter() {
        var _this = _super.call(this) || this;
        _this._actual = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.event = _this._actual.event;
        _this._deferredCnt = 0;
        _this._shouldFire = false;
        return _this;
    }
    DidChangeDecorationsEmitter.prototype.beginDeferredEmit = function () {
        this._deferredCnt++;
    };
    DidChangeDecorationsEmitter.prototype.endDeferredEmit = function () {
        this._deferredCnt--;
        if (this._deferredCnt === 0) {
            if (this._shouldFire) {
                this._shouldFire = false;
                this._actual.fire({});
            }
        }
    };
    DidChangeDecorationsEmitter.prototype.fire = function () {
        this._shouldFire = true;
    };
    return DidChangeDecorationsEmitter;
}(__WEBPACK_IMPORTED_MODULE_11__base_common_lifecycle_js__["a" /* Disposable */]));

//#endregion
var DidChangeContentEmitter = /** @class */ (function (_super) {
    __extends(DidChangeContentEmitter, _super);
    function DidChangeContentEmitter() {
        var _this = _super.call(this) || this;
        /**
         * Both `fastEvent` and `slowEvent` work the same way and contain the same events, but first we invoke `fastEvent` and then `slowEvent`.
         */
        _this._fastEmitter = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.fastEvent = _this._fastEmitter.event;
        _this._slowEmitter = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.slowEvent = _this._slowEmitter.event;
        _this._deferredCnt = 0;
        _this._deferredEvent = null;
        return _this;
    }
    DidChangeContentEmitter.prototype.beginDeferredEmit = function () {
        this._deferredCnt++;
    };
    DidChangeContentEmitter.prototype.endDeferredEmit = function () {
        this._deferredCnt--;
        if (this._deferredCnt === 0) {
            if (this._deferredEvent !== null) {
                var e = this._deferredEvent;
                this._deferredEvent = null;
                this._fastEmitter.fire(e);
                this._slowEmitter.fire(e);
            }
        }
    };
    DidChangeContentEmitter.prototype.fire = function (e) {
        if (this._deferredCnt > 0) {
            if (this._deferredEvent) {
                this._deferredEvent = this._deferredEvent.merge(e);
            }
            else {
                this._deferredEvent = e;
            }
            return;
        }
        this._fastEmitter.fire(e);
        this._slowEmitter.fire(e);
    };
    return DidChangeContentEmitter;
}(__WEBPACK_IMPORTED_MODULE_11__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_js__ = __webpack_require__(14);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;

var _schemePattern = /^\w[\w\d+.-]*$/;
var _singleSlashStart = /^\//;
var _doubleSlashStart = /^\/\//;
function _validateUri(ret) {
    // scheme, https://tools.ietf.org/html/rfc3986#section-3.1
    // ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
    if (ret.scheme && !_schemePattern.test(ret.scheme)) {
        throw new Error('[UriError]: Scheme contains illegal characters.');
    }
    // path, http://tools.ietf.org/html/rfc3986#section-3.3
    // If a URI contains an authority component, then the path component
    // must either be empty or begin with a slash ("/") character.  If a URI
    // does not contain an authority component, then the path cannot begin
    // with two slash characters ("//").
    if (ret.path) {
        if (ret.authority) {
            if (!_singleSlashStart.test(ret.path)) {
                throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
            }
        }
        else {
            if (_doubleSlashStart.test(ret.path)) {
                throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
            }
        }
    }
}
// implements a bit of https://tools.ietf.org/html/rfc3986#section-5
function _referenceResolution(scheme, path) {
    // the slash-character is our 'default base' as we don't
    // support constructing URIs relative to other URIs. This
    // also means that we alter and potentially break paths.
    // see https://tools.ietf.org/html/rfc3986#section-5.1.4
    switch (scheme) {
        case 'https':
        case 'http':
        case 'file':
            if (!path) {
                path = _slash;
            }
            else if (path[0] !== _slash) {
                path = _slash + path;
            }
            break;
    }
    return path;
}
var _empty = '';
var _slash = '/';
var _regexp = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
/**
 * Uniform Resource Identifier (URI) http://tools.ietf.org/html/rfc3986.
 * This class is a simple parser which creates the basic component paths
 * (http://tools.ietf.org/html/rfc3986#section-3) with minimal validation
 * and encoding.
 *
 *       foo://example.com:8042/over/there?name=ferret#nose
 *       \_/   \______________/\_________/ \_________/ \__/
 *        |           |            |            |        |
 *     scheme     authority       path        query   fragment
 *        |   _____________________|__
 *       / \ /                        \
 *       urn:example:animal:ferret:nose
 *
 *
 */
var URI = /** @class */ (function () {
    /**
     * @internal
     */
    function URI(schemeOrData, authority, path, query, fragment) {
        if (typeof schemeOrData === 'object') {
            this.scheme = schemeOrData.scheme || _empty;
            this.authority = schemeOrData.authority || _empty;
            this.path = schemeOrData.path || _empty;
            this.query = schemeOrData.query || _empty;
            this.fragment = schemeOrData.fragment || _empty;
            // no validation because it's this URI
            // that creates uri components.
            // _validateUri(this);
        }
        else {
            this.scheme = schemeOrData || _empty;
            this.authority = authority || _empty;
            this.path = _referenceResolution(this.scheme, path || _empty);
            this.query = query || _empty;
            this.fragment = fragment || _empty;
            _validateUri(this);
        }
    }
    URI.isUri = function (thing) {
        if (thing instanceof URI) {
            return true;
        }
        if (!thing) {
            return false;
        }
        return typeof thing.authority === 'string'
            && typeof thing.fragment === 'string'
            && typeof thing.path === 'string'
            && typeof thing.query === 'string'
            && typeof thing.scheme === 'string';
    };
    Object.defineProperty(URI.prototype, "fsPath", {
        // ---- filesystem path -----------------------
        /**
         * Returns a string representing the corresponding file system path of this URI.
         * Will handle UNC paths and normalize windows drive letters to lower-case. Also
         * uses the platform specific path separator. Will *not* validate the path for
         * invalid characters and semantics. Will *not* look at the scheme of this URI.
         */
        get: function () {
            return _makeFsPath(this);
        },
        enumerable: true,
        configurable: true
    });
    // ---- modify to new -------------------------
    URI.prototype.with = function (change) {
        if (!change) {
            return this;
        }
        var scheme = change.scheme, authority = change.authority, path = change.path, query = change.query, fragment = change.fragment;
        if (scheme === void 0) {
            scheme = this.scheme;
        }
        else if (scheme === null) {
            scheme = _empty;
        }
        if (authority === void 0) {
            authority = this.authority;
        }
        else if (authority === null) {
            authority = _empty;
        }
        if (path === void 0) {
            path = this.path;
        }
        else if (path === null) {
            path = _empty;
        }
        if (query === void 0) {
            query = this.query;
        }
        else if (query === null) {
            query = _empty;
        }
        if (fragment === void 0) {
            fragment = this.fragment;
        }
        else if (fragment === null) {
            fragment = _empty;
        }
        if (scheme === this.scheme
            && authority === this.authority
            && path === this.path
            && query === this.query
            && fragment === this.fragment) {
            return this;
        }
        return new _URI(scheme, authority, path, query, fragment);
    };
    // ---- parse & validate ------------------------
    URI.parse = function (value) {
        var match = _regexp.exec(value);
        if (!match) {
            return new _URI(_empty, _empty, _empty, _empty, _empty);
        }
        return new _URI(match[2] || _empty, decodeURIComponent(match[4] || _empty), decodeURIComponent(match[5] || _empty), decodeURIComponent(match[7] || _empty), decodeURIComponent(match[9] || _empty));
    };
    URI.file = function (path) {
        var authority = _empty;
        // normalize to fwd-slashes on windows,
        // on other systems bwd-slashes are valid
        // filename character, eg /f\oo/ba\r.txt
        if (__WEBPACK_IMPORTED_MODULE_0__platform_js__["g" /* isWindows */]) {
            path = path.replace(/\\/g, _slash);
        }
        // check for authority as used in UNC shares
        // or use the path as given
        if (path[0] === _slash && path[1] === _slash) {
            var idx = path.indexOf(_slash, 2);
            if (idx === -1) {
                authority = path.substring(2);
                path = _slash;
            }
            else {
                authority = path.substring(2, idx);
                path = path.substring(idx) || _slash;
            }
        }
        return new _URI('file', authority, path, _empty, _empty);
    };
    URI.from = function (components) {
        return new _URI(components.scheme, components.authority, components.path, components.query, components.fragment);
    };
    // ---- printing/externalize ---------------------------
    /**
     *
     * @param skipEncoding Do not encode the result, default is `false`
     */
    URI.prototype.toString = function (skipEncoding) {
        if (skipEncoding === void 0) { skipEncoding = false; }
        return _asFormatted(this, skipEncoding);
    };
    URI.prototype.toJSON = function () {
        return this;
    };
    URI.revive = function (data) {
        if (!data) {
            return data;
        }
        else if (data instanceof URI) {
            return data;
        }
        else {
            var result = new _URI(data);
            result._fsPath = data.fsPath;
            result._formatted = data.external;
            return result;
        }
    };
    return URI;
}());
/* harmony default export */ __webpack_exports__["a"] = (URI);
// tslint:disable-next-line:class-name
var _URI = /** @class */ (function (_super) {
    __extends(_URI, _super);
    function _URI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._formatted = null;
        _this._fsPath = null;
        return _this;
    }
    Object.defineProperty(_URI.prototype, "fsPath", {
        get: function () {
            if (!this._fsPath) {
                this._fsPath = _makeFsPath(this);
            }
            return this._fsPath;
        },
        enumerable: true,
        configurable: true
    });
    _URI.prototype.toString = function (skipEncoding) {
        if (skipEncoding === void 0) { skipEncoding = false; }
        if (!skipEncoding) {
            if (!this._formatted) {
                this._formatted = _asFormatted(this, false);
            }
            return this._formatted;
        }
        else {
            // we don't cache that
            return _asFormatted(this, true);
        }
    };
    _URI.prototype.toJSON = function () {
        var res = {
            $mid: 1
        };
        // cached state
        if (this._fsPath) {
            res.fsPath = this._fsPath;
        }
        if (this._formatted) {
            res.external = this._formatted;
        }
        // uri components
        if (this.path) {
            res.path = this.path;
        }
        if (this.scheme) {
            res.scheme = this.scheme;
        }
        if (this.authority) {
            res.authority = this.authority;
        }
        if (this.query) {
            res.query = this.query;
        }
        if (this.fragment) {
            res.fragment = this.fragment;
        }
        return res;
    };
    return _URI;
}(URI));
// reserved characters: https://tools.ietf.org/html/rfc3986#section-2.2
var encodeTable = (_a = {},
    _a[58 /* Colon */] = '%3A',
    _a[47 /* Slash */] = '%2F',
    _a[63 /* QuestionMark */] = '%3F',
    _a[35 /* Hash */] = '%23',
    _a[91 /* OpenSquareBracket */] = '%5B',
    _a[93 /* CloseSquareBracket */] = '%5D',
    _a[64 /* AtSign */] = '%40',
    _a[33 /* ExclamationMark */] = '%21',
    _a[36 /* DollarSign */] = '%24',
    _a[38 /* Ampersand */] = '%26',
    _a[39 /* SingleQuote */] = '%27',
    _a[40 /* OpenParen */] = '%28',
    _a[41 /* CloseParen */] = '%29',
    _a[42 /* Asterisk */] = '%2A',
    _a[43 /* Plus */] = '%2B',
    _a[44 /* Comma */] = '%2C',
    _a[59 /* Semicolon */] = '%3B',
    _a[61 /* Equals */] = '%3D',
    _a[32 /* Space */] = '%20',
    _a);
function encodeURIComponentFast(uriComponent, allowSlash) {
    var res = undefined;
    var nativeEncodePos = -1;
    for (var pos = 0; pos < uriComponent.length; pos++) {
        var code = uriComponent.charCodeAt(pos);
        // unreserved characters: https://tools.ietf.org/html/rfc3986#section-2.3
        if ((code >= 97 /* a */ && code <= 122 /* z */)
            || (code >= 65 /* A */ && code <= 90 /* Z */)
            || (code >= 48 /* Digit0 */ && code <= 57 /* Digit9 */)
            || code === 45 /* Dash */
            || code === 46 /* Period */
            || code === 95 /* Underline */
            || code === 126 /* Tilde */
            || (allowSlash && code === 47 /* Slash */)) {
            // check if we are delaying native encode
            if (nativeEncodePos !== -1) {
                res += encodeURIComponent(uriComponent.substring(nativeEncodePos, pos));
                nativeEncodePos = -1;
            }
            // check if we write into a new string (by default we try to return the param)
            if (res !== undefined) {
                res += uriComponent.charAt(pos);
            }
        }
        else {
            // encoding needed, we need to allocate a new string
            if (res === undefined) {
                res = uriComponent.substr(0, pos);
            }
            // check with default table first
            var escaped = encodeTable[code];
            if (escaped !== undefined) {
                // check if we are delaying native encode
                if (nativeEncodePos !== -1) {
                    res += encodeURIComponent(uriComponent.substring(nativeEncodePos, pos));
                    nativeEncodePos = -1;
                }
                // append escaped variant to result
                res += escaped;
            }
            else if (nativeEncodePos === -1) {
                // use native encode only when needed
                nativeEncodePos = pos;
            }
        }
    }
    if (nativeEncodePos !== -1) {
        res += encodeURIComponent(uriComponent.substring(nativeEncodePos));
    }
    return res !== undefined ? res : uriComponent;
}
function encodeURIComponentMinimal(path) {
    var res = undefined;
    for (var pos = 0; pos < path.length; pos++) {
        var code = path.charCodeAt(pos);
        if (code === 35 /* Hash */ || code === 63 /* QuestionMark */) {
            if (res === undefined) {
                res = path.substr(0, pos);
            }
            res += encodeTable[code];
        }
        else {
            if (res !== undefined) {
                res += path[pos];
            }
        }
    }
    return res !== undefined ? res : path;
}
/**
 * Compute `fsPath` for the given uri
 * @param uri
 */
function _makeFsPath(uri) {
    var value;
    if (uri.authority && uri.path.length > 1 && uri.scheme === 'file') {
        // unc path: file://shares/c$/far/boo
        value = "//" + uri.authority + uri.path;
    }
    else if (uri.path.charCodeAt(0) === 47 /* Slash */
        && (uri.path.charCodeAt(1) >= 65 /* A */ && uri.path.charCodeAt(1) <= 90 /* Z */ || uri.path.charCodeAt(1) >= 97 /* a */ && uri.path.charCodeAt(1) <= 122 /* z */)
        && uri.path.charCodeAt(2) === 58 /* Colon */) {
        // windows drive letter: file:///c:/far/boo
        value = uri.path[1].toLowerCase() + uri.path.substr(2);
    }
    else {
        // other path
        value = uri.path;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__platform_js__["g" /* isWindows */]) {
        value = value.replace(/\//g, '\\');
    }
    return value;
}
/**
 * Create the external version of a uri
 */
function _asFormatted(uri, skipEncoding) {
    var encoder = !skipEncoding
        ? encodeURIComponentFast
        : encodeURIComponentMinimal;
    var res = '';
    var scheme = uri.scheme, authority = uri.authority, path = uri.path, query = uri.query, fragment = uri.fragment;
    if (scheme) {
        res += scheme;
        res += ':';
    }
    if (authority || scheme === 'file') {
        res += _slash;
        res += _slash;
    }
    if (authority) {
        var idx = authority.indexOf('@');
        if (idx !== -1) {
            // <user>@<auth>
            var userinfo = authority.substr(0, idx);
            authority = authority.substr(idx + 1);
            idx = userinfo.indexOf(':');
            if (idx === -1) {
                res += encoder(userinfo, false);
            }
            else {
                // <user>:<pass>@<auth>
                res += encoder(userinfo.substr(0, idx), false);
                res += ':';
                res += encoder(userinfo.substr(idx + 1), false);
            }
            res += '@';
        }
        authority = authority.toLowerCase();
        idx = authority.indexOf(':');
        if (idx === -1) {
            res += encoder(authority, false);
        }
        else {
            // <auth>:<port>
            res += encoder(authority.substr(0, idx), false);
            res += authority.substr(idx);
        }
    }
    if (path) {
        // lower-case windows drive letters in /C:/fff or C:/fff
        if (path.length >= 3 && path.charCodeAt(0) === 47 /* Slash */ && path.charCodeAt(2) === 58 /* Colon */) {
            var code = path.charCodeAt(1);
            if (code >= 65 /* A */ && code <= 90 /* Z */) {
                path = "/" + String.fromCharCode(code + 32) + ":" + path.substr(3); // "/c:".length === 3
            }
        }
        else if (path.length >= 2 && path.charCodeAt(1) === 58 /* Colon */) {
            var code = path.charCodeAt(0);
            if (code >= 65 /* A */ && code <= 90 /* Z */) {
                path = String.fromCharCode(code + 32) + ":" + path.substr(2); // "/c:".length === 3
            }
        }
        // encode the rest of the path
        res += encoder(path, true);
    }
    if (query) {
        res += '?';
        res += encoder(query, false);
    }
    if (fragment) {
        res += '#';
        res += !skipEncoding ? encodeURIComponentFast(fragment, false) : fragment;
    }
    return res;
}


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICodeEditorService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ICodeEditorService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])('codeEditorService');


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ICommandService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandsRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_linkedList_js__ = __webpack_require__(246);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var ICommandService = Object(__WEBPACK_IMPORTED_MODULE_2__instantiation_common_instantiation_js__["c" /* createDecorator */])('commandService');
var CommandsRegistry = new /** @class */ (function () {
    function class_1() {
        this._commands = new Map();
    }
    class_1.prototype.registerCommand = function (idOrCommand, handler) {
        var _this = this;
        if (!idOrCommand) {
            throw new Error("invalid command");
        }
        if (typeof idOrCommand === 'string') {
            if (!handler) {
                throw new Error("invalid command");
            }
            return this.registerCommand({ id: idOrCommand, handler: handler });
        }
        // add argument validation if rich command metadata is provided
        if (idOrCommand.description) {
            var constraints_1 = [];
            for (var _i = 0, _a = idOrCommand.description.args; _i < _a.length; _i++) {
                var arg = _a[_i];
                constraints_1.push(arg.constraint);
            }
            var actualHandler_1 = idOrCommand.handler;
            idOrCommand.handler = function (accessor) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                Object(__WEBPACK_IMPORTED_MODULE_1__base_common_types_js__["k" /* validateConstraints */])(args, constraints_1);
                return actualHandler_1.apply(void 0, [accessor].concat(args));
            };
        }
        // find a place to store the command
        var id = idOrCommand.id;
        var commands = this._commands.get(id);
        if (!commands) {
            commands = new __WEBPACK_IMPORTED_MODULE_3__base_common_linkedList_js__["a" /* LinkedList */]();
            this._commands.set(id, commands);
        }
        var removeFn = commands.unshift(idOrCommand);
        return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            removeFn();
            if (_this._commands.get(id).isEmpty()) {
                _this._commands.delete(id);
            }
        });
    };
    class_1.prototype.registerCommandAlias = function (oldId, newId) {
        return CommandsRegistry.registerCommand(oldId, function (accessor) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var _a;
            (_a = accessor.get(ICommandService)).executeCommand.apply(_a, [newId].concat(args));
        });
    };
    class_1.prototype.getCommand = function (id) {
        var list = this._commands.get(id);
        if (!list || list.isEmpty()) {
            return undefined;
        }
        return list.iterator().next().value;
    };
    class_1.prototype.getCommands = function () {
        var _this = this;
        var result = Object.create(null);
        this._commands.forEach(function (value, key) {
            result[key] = _this.getCommand(key);
        });
        return result;
    };
    return class_1;
}());


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["h"] = isString;
/* harmony export (immutable) */ __webpack_exports__["g"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["i"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["j"] = isUndefinedOrNull;
/* harmony export (immutable) */ __webpack_exports__["d"] = isEmptyObject;
/* harmony export (immutable) */ __webpack_exports__["e"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["k"] = validateConstraints;
/* unused harmony export validateConstraint */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var _typeof = {
    number: 'number',
    string: 'string',
    undefined: 'undefined',
    object: 'object',
    function: 'function'
};
/**
 * @returns whether the provided parameter is a JavaScript Array or not.
 */
function isArray(array) {
    if (Array.isArray) {
        return Array.isArray(array);
    }
    if (array && typeof (array.length) === _typeof.number && array.constructor === Array) {
        return true;
    }
    return false;
}
/**
 * @returns whether the provided parameter is a JavaScript String or not.
 */
function isString(str) {
    if (typeof (str) === _typeof.string || str instanceof String) {
        return true;
    }
    return false;
}
/**
 *
 * @returns whether the provided parameter is of type `object` but **not**
 *	`null`, an `array`, a `regexp`, nor a `date`.
 */
function isObject(obj) {
    // The method can't do a type cast since there are type (like strings) which
    // are subclasses of any put not positvely matched by the function. Hence type
    // narrowing results in wrong results.
    return typeof obj === _typeof.object
        && obj !== null
        && !Array.isArray(obj)
        && !(obj instanceof RegExp)
        && !(obj instanceof Date);
}
/**
 * In **contrast** to just checking `typeof` this will return `false` for `NaN`.
 * @returns whether the provided parameter is a JavaScript Number or not.
 */
function isNumber(obj) {
    if ((typeof (obj) === _typeof.number || obj instanceof Number) && !isNaN(obj)) {
        return true;
    }
    return false;
}
/**
 * @returns whether the provided parameter is a JavaScript Boolean or not.
 */
function isBoolean(obj) {
    return obj === true || obj === false;
}
/**
 * @returns whether the provided parameter is undefined.
 */
function isUndefined(obj) {
    return typeof (obj) === _typeof.undefined;
}
/**
 * @returns whether the provided parameter is undefined or null.
 */
function isUndefinedOrNull(obj) {
    return isUndefined(obj) || obj === null;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * @returns whether the provided parameter is an empty JavaScript Object or not.
 */
function isEmptyObject(obj) {
    if (!isObject(obj)) {
        return false;
    }
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
/**
 * @returns whether the provided parameter is a JavaScript Function or not.
 */
function isFunction(obj) {
    return typeof obj === _typeof.function;
}
function validateConstraints(args, constraints) {
    var len = Math.min(args.length, constraints.length);
    for (var i = 0; i < len; i++) {
        validateConstraint(args[i], constraints[i]);
    }
}
function validateConstraint(arg, constraint) {
    if (isString(constraint)) {
        if (typeof arg !== constraint) {
            throw new Error("argument does not match constraint: typeof " + constraint);
        }
    }
    else if (isFunction(constraint)) {
        if (arg instanceof constraint) {
            return;
        }
        if (!isUndefinedOrNull(arg) && arg.constructor === constraint) {
            return;
        }
        if (constraint.length === 1 && constraint.call(undefined, arg) === true) {
            return;
        }
        throw new Error("argument does not match one of these constraints: arg instanceof constraint, arg.constructor === constraint, nor constraint(arg) === true");
    }
}
/**
 * Creates a new object of the provided class and will call the constructor with
 * any additional argument supplied.
 */
function create(ctor) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var obj = Object.create(ctor.prototype);
    ctor.apply(obj, args);
    return obj;
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return editorLineHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return editorLineHighlightBorder; });
/* unused harmony export editorRangeHighlight */
/* unused harmony export editorRangeHighlightBorder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return editorCursorForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return editorCursorBackground; });
/* unused harmony export editorWhitespaces */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return editorIndentGuides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editorActiveIndentGuides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return editorLineNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editorActiveLineNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return editorRuler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return editorCodeLensForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editorBracketMatchBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return editorBracketMatchBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return editorOverviewRulerBorder; });
/* unused harmony export editorGutter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return editorErrorForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return editorErrorBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return editorWarningForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return editorWarningBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return editorInfoForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return editorInfoBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return editorHintForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return editorHintBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return editorUnnecessaryCodeBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return editorUnnecessaryCodeOpacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return overviewRulerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return overviewRulerWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return overviewRulerInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__ = __webpack_require__(24);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




/**
 * Definition of the editor colors
 */
var editorLineHighlight = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.lineHighlightBackground', { dark: null, light: null, hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineHighlight', 'Background color for the highlight of line at the cursor position.'));
var editorLineHighlightBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.lineHighlightBorder', { dark: '#282828', light: '#eeeeee', hc: '#f38518' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineHighlightBorderBox', 'Background color for the border around the line at the cursor position.'));
var editorRangeHighlight = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.rangeHighlightBackground', { dark: '#ffffff0b', light: '#fdff0033', hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('rangeHighlight', 'Background color of highlighted ranges, like by quick open and find features. The color must not be opaque to not hide underlying decorations.'), true);
var editorRangeHighlightBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.rangeHighlightBorder', { dark: null, light: null, hc: __WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["b" /* activeContrastBorder */] }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('rangeHighlightBorder', 'Background color of the border around highlighted ranges.'), true);
var editorCursorForeground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorCursor.foreground', { dark: '#AEAFAD', light: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].black, hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('caret', 'Color of the editor cursor.'));
var editorCursorBackground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorCursor.background', null, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorCursorBackground', 'The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor.'));
var editorWhitespaces = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorWhitespace.foreground', { dark: '#e3e4e229', light: '#33333333', hc: '#e3e4e229' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorWhitespaces', 'Color of whitespace characters in the editor.'));
var editorIndentGuides = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorIndentGuide.background', { dark: editorWhitespaces, light: editorWhitespaces, hc: editorWhitespaces }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorIndentGuides', 'Color of the editor indentation guides.'));
var editorActiveIndentGuides = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorIndentGuide.activeBackground', { dark: editorWhitespaces, light: editorWhitespaces, hc: editorWhitespaces }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorActiveIndentGuide', 'Color of the active editor indentation guides.'));
var editorLineNumbers = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorLineNumber.foreground', { dark: '#858585', light: '#237893', hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorLineNumbers', 'Color of editor line numbers.'));
var deprecatedEditorActiveLineNumber = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorActiveLineNumber.foreground', { dark: '#c6c6c6', light: '#0B216F', hc: __WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["b" /* activeContrastBorder */] }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorActiveLineNumber', 'Color of editor active line number'), false, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('deprecatedEditorActiveLineNumber', 'Id is deprecated. Use \'editorLineNumber.activeForeground\' instead.'));
var editorActiveLineNumber = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorLineNumber.activeForeground', { dark: deprecatedEditorActiveLineNumber, light: deprecatedEditorActiveLineNumber, hc: deprecatedEditorActiveLineNumber }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorActiveLineNumber', 'Color of editor active line number'));
var editorRuler = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorRuler.foreground', { dark: '#5A5A5A', light: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].lightgrey, hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorRuler', 'Color of the editor rulers.'));
var editorCodeLensForeground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorCodeLens.foreground', { dark: '#999999', light: '#999999', hc: '#999999' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorCodeLensForeground', 'Foreground color of editor code lenses'));
var editorBracketMatchBackground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorBracketMatch.background', { dark: '#0064001a', light: '#0064001a', hc: '#0064001a' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorBracketMatchBackground', 'Background color behind matching brackets'));
var editorBracketMatchBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorBracketMatch.border', { dark: '#888', light: '#B9B9B9', hc: '#fff' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorBracketMatchBorder', 'Color for matching brackets boxes'));
var editorOverviewRulerBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorOverviewRuler.border', { dark: '#7f7f7f4d', light: '#7f7f7f4d', hc: '#7f7f7f4d' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorOverviewRulerBorder', 'Color of the overview ruler border.'));
var editorGutter = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorGutter.background', { dark: __WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["n" /* editorBackground */], light: __WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["n" /* editorBackground */], hc: __WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["n" /* editorBackground */] }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorGutter', 'Background color of the editor gutter. The gutter contains the glyph margins and the line numbers.'));
var editorErrorForeground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorError.foreground', { dark: '#ea4646', light: '#d60a0a', hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('errorForeground', 'Foreground color of error squigglies in the editor.'));
var editorErrorBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorError.border', { dark: null, light: null, hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#E47777').transparent(0.8) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('errorBorder', 'Border color of error squigglies in the editor.'));
var editorWarningForeground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorWarning.foreground', { dark: '#4d9e4d', light: '#117711', hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('warningForeground', 'Foreground color of warning squigglies in the editor.'));
var editorWarningBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorWarning.border', { dark: null, light: null, hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#71B771').transparent(0.8) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('warningBorder', 'Border color of warning squigglies in the editor.'));
var editorInfoForeground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorInfo.foreground', { dark: '#008000', light: '#008000', hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('infoForeground', 'Foreground color of info squigglies in the editor.'));
var editorInfoBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorInfo.border', { dark: null, light: null, hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#71B771').transparent(0.8) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('infoBorder', 'Border color of info squigglies in the editor.'));
var editorHintForeground = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorHint.foreground', { dark: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#eeeeee').transparent(0.7), light: '#6c6c6c', hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hintForeground', 'Foreground color of hint squigglies in the editor.'));
var editorHintBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorHint.border', { dark: null, light: null, hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#eeeeee').transparent(0.8) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hintBorder', 'Border color of hint squigglies in the editor.'));
var editorUnnecessaryCodeBorder = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorUnnecessaryCode.border', { dark: null, light: null, hc: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#fff').transparent(0.8) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('unnecessaryCodeBorder', 'Border of unnecessary code in the editor.'));
var editorUnnecessaryCodeOpacity = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorUnnecessaryCode.opacity', { dark: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#000a'), light: __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */].fromHex('#0007'), hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('unnecessaryCodeOpacity', 'Opacity of unnecessary code in the editor.'));
var overviewRulerError = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorOverviewRuler.errorForeground', { dark: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](255, 18, 18, 0.7)), light: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](255, 18, 18, 0.7)), hc: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](255, 50, 50, 1)) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overviewRuleError', 'Overview ruler marker color for errors.'));
var overviewRulerWarning = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorOverviewRuler.warningForeground', { dark: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](18, 136, 18, 0.7)), light: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](18, 136, 18, 0.7)), hc: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](50, 255, 50, 1)) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overviewRuleWarning', 'Overview ruler marker color for warnings.'));
var overviewRulerInfo = Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorOverviewRuler.infoForeground', { dark: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](18, 18, 136, 0.7)), light: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](18, 18, 136, 0.7)), hc: new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_3__base_common_color_js__["c" /* RGBA */](50, 50, 255, 1)) }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overviewRuleInfo', 'Overview ruler marker color for infos.'));
// contains all color rules that used to defined in editor/browser/widget/editor.css
Object(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var background = theme.getColor(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["n" /* editorBackground */]);
    if (background) {
        collector.addRule(".monaco-editor, .monaco-editor-background, .monaco-editor .inputarea.ime-input { background-color: " + background + "; }");
    }
    var foreground = theme.getColor(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_colorRegistry_js__["u" /* editorForeground */]);
    if (foreground) {
        collector.addRule(".monaco-editor, .monaco-editor .inputarea.ime-input { color: " + foreground + "; }");
    }
    var gutter = theme.getColor(editorGutter);
    if (gutter) {
        collector.addRule(".monaco-editor .margin { background-color: " + gutter + "; }");
    }
    var rangeHighlight = theme.getColor(editorRangeHighlight);
    if (rangeHighlight) {
        collector.addRule(".monaco-editor .rangeHighlight { background-color: " + rangeHighlight + "; }");
    }
    var rangeHighlightBorder = theme.getColor(editorRangeHighlightBorder);
    if (rangeHighlightBorder) {
        collector.addRule(".monaco-editor .rangeHighlight { border: 1px " + (theme.type === 'hc' ? 'dotted' : 'solid') + " " + rangeHighlightBorder + "; }");
    }
    var invisibles = theme.getColor(editorWhitespaces);
    if (invisibles) {
        collector.addRule(".vs-whitespace { color: " + invisibles + " !important; }");
    }
});


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ViewPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartFingerprints; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_viewModel_viewEventHandler_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__ = __webpack_require__(23);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ViewPart = /** @class */ (function (_super) {
    __extends(ViewPart, _super);
    function ViewPart(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._context.addEventHandler(_this);
        return _this;
    }
    ViewPart.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        _super.prototype.dispose.call(this);
    };
    return ViewPart;
}(__WEBPACK_IMPORTED_MODULE_0__common_viewModel_viewEventHandler_js__["a" /* ViewEventHandler */]));

var PartFingerprints = /** @class */ (function () {
    function PartFingerprints() {
    }
    PartFingerprints.write = function (target, partId) {
        if (target instanceof __WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["a" /* FastDomNode */]) {
            target.setAttribute('data-mprt', String(partId));
        }
        else {
            target.setAttribute('data-mprt', String(partId));
        }
    };
    PartFingerprints.read = function (target) {
        var r = target.getAttribute('data-mprt');
        if (r === null) {
            return 0 /* None */;
        }
        return parseInt(r, 10);
    };
    PartFingerprints.collect = function (child, stopAt) {
        var result = [], resultLen = 0;
        while (child && child !== document.body) {
            if (child === stopAt) {
                break;
            }
            if (child.nodeType === child.ELEMENT_NODE) {
                result[resultLen++] = this.read(child);
            }
            child = child.parentElement;
        }
        var r = new Uint8Array(resultLen);
        for (var i = 0; i < resultLen; i++) {
            r[i] = result[resultLen - i - 1];
        }
        return r;
    };
    return PartFingerprints;
}());



/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Severity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INotificationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NoOpNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var Severity = __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__["a" /* default */];
var INotificationService = Object(__WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__["c" /* createDecorator */])('notificationService');
var NoOpNotification = /** @class */ (function () {
    function NoOpNotification() {
    }
    return NoOpNotification;
}());



/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancellationToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CancellationTokenSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var shortcutEvent = Object.freeze(function (callback, context) {
    var handle = setTimeout(callback.bind(context), 0);
    return { dispose: function () { clearTimeout(handle); } };
});
var CancellationToken;
(function (CancellationToken) {
    CancellationToken.None = Object.freeze({
        isCancellationRequested: false,
        onCancellationRequested: __WEBPACK_IMPORTED_MODULE_0__event_js__["b" /* Event */].None
    });
    CancellationToken.Cancelled = Object.freeze({
        isCancellationRequested: true,
        onCancellationRequested: shortcutEvent
    });
})(CancellationToken || (CancellationToken = {}));
var MutableToken = /** @class */ (function () {
    function MutableToken() {
        this._isCancelled = false;
    }
    MutableToken.prototype.cancel = function () {
        if (!this._isCancelled) {
            this._isCancelled = true;
            if (this._emitter) {
                this._emitter.fire(undefined);
                this.dispose();
            }
        }
    };
    Object.defineProperty(MutableToken.prototype, "isCancellationRequested", {
        get: function () {
            return this._isCancelled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MutableToken.prototype, "onCancellationRequested", {
        get: function () {
            if (this._isCancelled) {
                return shortcutEvent;
            }
            if (!this._emitter) {
                this._emitter = new __WEBPACK_IMPORTED_MODULE_0__event_js__["a" /* Emitter */]();
            }
            return this._emitter.event;
        },
        enumerable: true,
        configurable: true
    });
    MutableToken.prototype.dispose = function () {
        if (this._emitter) {
            this._emitter.dispose();
            this._emitter = undefined;
        }
    };
    return MutableToken;
}());
var CancellationTokenSource = /** @class */ (function () {
    function CancellationTokenSource() {
    }
    Object.defineProperty(CancellationTokenSource.prototype, "token", {
        get: function () {
            if (!this._token) {
                // be lazy and create the token only when
                // actually needed
                this._token = new MutableToken();
            }
            return this._token;
        },
        enumerable: true,
        configurable: true
    });
    CancellationTokenSource.prototype.cancel = function () {
        if (!this._token) {
            // save an object by returning the default
            // cancelled token when cancellation happens
            // before someone asks for the token
            this._token = CancellationToken.Cancelled;
        }
        else if (this._token instanceof MutableToken) {
            // actually cancel
            this._token.cancel();
        }
    };
    CancellationTokenSource.prototype.dispose = function () {
        if (!this._token) {
            // ensure to initialize with an empty token if we had none
            this._token = CancellationToken.None;
        }
        else if (this._token instanceof MutableToken) {
            // actually dispose
            this._token.dispose();
        }
    };
    return CancellationTokenSource;
}());



/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KeyCodeUtils; });
/* harmony export (immutable) */ __webpack_exports__["a"] = KeyChord;
/* harmony export (immutable) */ __webpack_exports__["f"] = createKeybinding;
/* unused harmony export createSimpleKeybinding */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SimpleKeybinding; });
/* unused harmony export ChordKeybinding */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ResolvedKeybindingPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResolvedKeybinding; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var KeyCodeStrMap = /** @class */ (function () {
    function KeyCodeStrMap() {
        this._keyCodeToStr = [];
        this._strToKeyCode = Object.create(null);
    }
    KeyCodeStrMap.prototype.define = function (keyCode, str) {
        this._keyCodeToStr[keyCode] = str;
        this._strToKeyCode[str.toLowerCase()] = keyCode;
    };
    KeyCodeStrMap.prototype.keyCodeToStr = function (keyCode) {
        return this._keyCodeToStr[keyCode];
    };
    KeyCodeStrMap.prototype.strToKeyCode = function (str) {
        return this._strToKeyCode[str.toLowerCase()] || 0 /* Unknown */;
    };
    return KeyCodeStrMap;
}());
var uiMap = new KeyCodeStrMap();
var userSettingsUSMap = new KeyCodeStrMap();
var userSettingsGeneralMap = new KeyCodeStrMap();
(function () {
    function define(keyCode, uiLabel, usUserSettingsLabel, generalUserSettingsLabel) {
        if (usUserSettingsLabel === void 0) { usUserSettingsLabel = uiLabel; }
        if (generalUserSettingsLabel === void 0) { generalUserSettingsLabel = usUserSettingsLabel; }
        uiMap.define(keyCode, uiLabel);
        userSettingsUSMap.define(keyCode, usUserSettingsLabel);
        userSettingsGeneralMap.define(keyCode, generalUserSettingsLabel);
    }
    define(0 /* Unknown */, 'unknown');
    define(1 /* Backspace */, 'Backspace');
    define(2 /* Tab */, 'Tab');
    define(3 /* Enter */, 'Enter');
    define(4 /* Shift */, 'Shift');
    define(5 /* Ctrl */, 'Ctrl');
    define(6 /* Alt */, 'Alt');
    define(7 /* PauseBreak */, 'PauseBreak');
    define(8 /* CapsLock */, 'CapsLock');
    define(9 /* Escape */, 'Escape');
    define(10 /* Space */, 'Space');
    define(11 /* PageUp */, 'PageUp');
    define(12 /* PageDown */, 'PageDown');
    define(13 /* End */, 'End');
    define(14 /* Home */, 'Home');
    define(15 /* LeftArrow */, 'LeftArrow', 'Left');
    define(16 /* UpArrow */, 'UpArrow', 'Up');
    define(17 /* RightArrow */, 'RightArrow', 'Right');
    define(18 /* DownArrow */, 'DownArrow', 'Down');
    define(19 /* Insert */, 'Insert');
    define(20 /* Delete */, 'Delete');
    define(21 /* KEY_0 */, '0');
    define(22 /* KEY_1 */, '1');
    define(23 /* KEY_2 */, '2');
    define(24 /* KEY_3 */, '3');
    define(25 /* KEY_4 */, '4');
    define(26 /* KEY_5 */, '5');
    define(27 /* KEY_6 */, '6');
    define(28 /* KEY_7 */, '7');
    define(29 /* KEY_8 */, '8');
    define(30 /* KEY_9 */, '9');
    define(31 /* KEY_A */, 'A');
    define(32 /* KEY_B */, 'B');
    define(33 /* KEY_C */, 'C');
    define(34 /* KEY_D */, 'D');
    define(35 /* KEY_E */, 'E');
    define(36 /* KEY_F */, 'F');
    define(37 /* KEY_G */, 'G');
    define(38 /* KEY_H */, 'H');
    define(39 /* KEY_I */, 'I');
    define(40 /* KEY_J */, 'J');
    define(41 /* KEY_K */, 'K');
    define(42 /* KEY_L */, 'L');
    define(43 /* KEY_M */, 'M');
    define(44 /* KEY_N */, 'N');
    define(45 /* KEY_O */, 'O');
    define(46 /* KEY_P */, 'P');
    define(47 /* KEY_Q */, 'Q');
    define(48 /* KEY_R */, 'R');
    define(49 /* KEY_S */, 'S');
    define(50 /* KEY_T */, 'T');
    define(51 /* KEY_U */, 'U');
    define(52 /* KEY_V */, 'V');
    define(53 /* KEY_W */, 'W');
    define(54 /* KEY_X */, 'X');
    define(55 /* KEY_Y */, 'Y');
    define(56 /* KEY_Z */, 'Z');
    define(57 /* Meta */, 'Meta');
    define(58 /* ContextMenu */, 'ContextMenu');
    define(59 /* F1 */, 'F1');
    define(60 /* F2 */, 'F2');
    define(61 /* F3 */, 'F3');
    define(62 /* F4 */, 'F4');
    define(63 /* F5 */, 'F5');
    define(64 /* F6 */, 'F6');
    define(65 /* F7 */, 'F7');
    define(66 /* F8 */, 'F8');
    define(67 /* F9 */, 'F9');
    define(68 /* F10 */, 'F10');
    define(69 /* F11 */, 'F11');
    define(70 /* F12 */, 'F12');
    define(71 /* F13 */, 'F13');
    define(72 /* F14 */, 'F14');
    define(73 /* F15 */, 'F15');
    define(74 /* F16 */, 'F16');
    define(75 /* F17 */, 'F17');
    define(76 /* F18 */, 'F18');
    define(77 /* F19 */, 'F19');
    define(78 /* NumLock */, 'NumLock');
    define(79 /* ScrollLock */, 'ScrollLock');
    define(80 /* US_SEMICOLON */, ';', ';', 'OEM_1');
    define(81 /* US_EQUAL */, '=', '=', 'OEM_PLUS');
    define(82 /* US_COMMA */, ',', ',', 'OEM_COMMA');
    define(83 /* US_MINUS */, '-', '-', 'OEM_MINUS');
    define(84 /* US_DOT */, '.', '.', 'OEM_PERIOD');
    define(85 /* US_SLASH */, '/', '/', 'OEM_2');
    define(86 /* US_BACKTICK */, '`', '`', 'OEM_3');
    define(110 /* ABNT_C1 */, 'ABNT_C1');
    define(111 /* ABNT_C2 */, 'ABNT_C2');
    define(87 /* US_OPEN_SQUARE_BRACKET */, '[', '[', 'OEM_4');
    define(88 /* US_BACKSLASH */, '\\', '\\', 'OEM_5');
    define(89 /* US_CLOSE_SQUARE_BRACKET */, ']', ']', 'OEM_6');
    define(90 /* US_QUOTE */, '\'', '\'', 'OEM_7');
    define(91 /* OEM_8 */, 'OEM_8');
    define(92 /* OEM_102 */, 'OEM_102');
    define(93 /* NUMPAD_0 */, 'NumPad0');
    define(94 /* NUMPAD_1 */, 'NumPad1');
    define(95 /* NUMPAD_2 */, 'NumPad2');
    define(96 /* NUMPAD_3 */, 'NumPad3');
    define(97 /* NUMPAD_4 */, 'NumPad4');
    define(98 /* NUMPAD_5 */, 'NumPad5');
    define(99 /* NUMPAD_6 */, 'NumPad6');
    define(100 /* NUMPAD_7 */, 'NumPad7');
    define(101 /* NUMPAD_8 */, 'NumPad8');
    define(102 /* NUMPAD_9 */, 'NumPad9');
    define(103 /* NUMPAD_MULTIPLY */, 'NumPad_Multiply');
    define(104 /* NUMPAD_ADD */, 'NumPad_Add');
    define(105 /* NUMPAD_SEPARATOR */, 'NumPad_Separator');
    define(106 /* NUMPAD_SUBTRACT */, 'NumPad_Subtract');
    define(107 /* NUMPAD_DECIMAL */, 'NumPad_Decimal');
    define(108 /* NUMPAD_DIVIDE */, 'NumPad_Divide');
})();
var KeyCodeUtils;
(function (KeyCodeUtils) {
    function toString(keyCode) {
        return uiMap.keyCodeToStr(keyCode);
    }
    KeyCodeUtils.toString = toString;
    function fromString(key) {
        return uiMap.strToKeyCode(key);
    }
    KeyCodeUtils.fromString = fromString;
    function toUserSettingsUS(keyCode) {
        return userSettingsUSMap.keyCodeToStr(keyCode);
    }
    KeyCodeUtils.toUserSettingsUS = toUserSettingsUS;
    function toUserSettingsGeneral(keyCode) {
        return userSettingsGeneralMap.keyCodeToStr(keyCode);
    }
    KeyCodeUtils.toUserSettingsGeneral = toUserSettingsGeneral;
    function fromUserSettings(key) {
        return userSettingsUSMap.strToKeyCode(key) || userSettingsGeneralMap.strToKeyCode(key);
    }
    KeyCodeUtils.fromUserSettings = fromUserSettings;
})(KeyCodeUtils || (KeyCodeUtils = {}));
function KeyChord(firstPart, secondPart) {
    var chordPart = ((secondPart & 0x0000ffff) << 16) >>> 0;
    return (firstPart | chordPart) >>> 0;
}
function createKeybinding(keybinding, OS) {
    if (keybinding === 0) {
        return null;
    }
    var firstPart = (keybinding & 0x0000ffff) >>> 0;
    var chordPart = (keybinding & 0xffff0000) >>> 16;
    if (chordPart !== 0) {
        return new ChordKeybinding(createSimpleKeybinding(firstPart, OS), createSimpleKeybinding(chordPart, OS));
    }
    return createSimpleKeybinding(firstPart, OS);
}
function createSimpleKeybinding(keybinding, OS) {
    var ctrlCmd = (keybinding & 2048 /* CtrlCmd */ ? true : false);
    var winCtrl = (keybinding & 256 /* WinCtrl */ ? true : false);
    var ctrlKey = (OS === 2 /* Macintosh */ ? winCtrl : ctrlCmd);
    var shiftKey = (keybinding & 1024 /* Shift */ ? true : false);
    var altKey = (keybinding & 512 /* Alt */ ? true : false);
    var metaKey = (OS === 2 /* Macintosh */ ? ctrlCmd : winCtrl);
    var keyCode = (keybinding & 255 /* KeyCode */);
    return new SimpleKeybinding(ctrlKey, shiftKey, altKey, metaKey, keyCode);
}
var SimpleKeybinding = /** @class */ (function () {
    function SimpleKeybinding(ctrlKey, shiftKey, altKey, metaKey, keyCode) {
        this.type = 1 /* Simple */;
        this.ctrlKey = ctrlKey;
        this.shiftKey = shiftKey;
        this.altKey = altKey;
        this.metaKey = metaKey;
        this.keyCode = keyCode;
    }
    SimpleKeybinding.prototype.equals = function (other) {
        if (other.type !== 1 /* Simple */) {
            return false;
        }
        return (this.ctrlKey === other.ctrlKey
            && this.shiftKey === other.shiftKey
            && this.altKey === other.altKey
            && this.metaKey === other.metaKey
            && this.keyCode === other.keyCode);
    };
    SimpleKeybinding.prototype.isModifierKey = function () {
        return (this.keyCode === 0 /* Unknown */
            || this.keyCode === 5 /* Ctrl */
            || this.keyCode === 57 /* Meta */
            || this.keyCode === 6 /* Alt */
            || this.keyCode === 4 /* Shift */);
    };
    /**
     * Does this keybinding refer to the key code of a modifier and it also has the modifier flag?
     */
    SimpleKeybinding.prototype.isDuplicateModifierCase = function () {
        return ((this.ctrlKey && this.keyCode === 5 /* Ctrl */)
            || (this.shiftKey && this.keyCode === 4 /* Shift */)
            || (this.altKey && this.keyCode === 6 /* Alt */)
            || (this.metaKey && this.keyCode === 57 /* Meta */));
    };
    return SimpleKeybinding;
}());

var ChordKeybinding = /** @class */ (function () {
    function ChordKeybinding(firstPart, chordPart) {
        this.type = 2 /* Chord */;
        this.firstPart = firstPart;
        this.chordPart = chordPart;
    }
    return ChordKeybinding;
}());

var ResolvedKeybindingPart = /** @class */ (function () {
    function ResolvedKeybindingPart(ctrlKey, shiftKey, altKey, metaKey, kbLabel, kbAriaLabel) {
        this.ctrlKey = ctrlKey;
        this.shiftKey = shiftKey;
        this.altKey = altKey;
        this.metaKey = metaKey;
        this.keyLabel = kbLabel;
        this.keyAriaLabel = kbAriaLabel;
    }
    return ResolvedKeybindingPart;
}());

/**
 * A resolved keybinding. Can be a simple keybinding or a chord keybinding.
 */
var ResolvedKeybinding = /** @class */ (function () {
    function ResolvedKeybinding() {
    }
    return ResolvedKeybinding;
}());



/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StandardMouseEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragMouseEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StandardMouseWheelEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iframe_js__ = __webpack_require__(247);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var StandardMouseEvent = /** @class */ (function () {
    function StandardMouseEvent(e) {
        this.timestamp = Date.now();
        this.browserEvent = e;
        this.leftButton = e.button === 0;
        this.middleButton = e.button === 1;
        this.rightButton = e.button === 2;
        this.target = e.target;
        this.detail = e.detail || 1;
        if (e.type === 'dblclick') {
            this.detail = 2;
        }
        this.ctrlKey = e.ctrlKey;
        this.shiftKey = e.shiftKey;
        this.altKey = e.altKey;
        this.metaKey = e.metaKey;
        if (typeof e.pageX === 'number') {
            this.posx = e.pageX;
            this.posy = e.pageY;
        }
        else {
            // Probably hit by MSGestureEvent
            this.posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            this.posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        // Find the position of the iframe this code is executing in relative to the iframe where the event was captured.
        var iframeOffsets = __WEBPACK_IMPORTED_MODULE_2__iframe_js__["a" /* IframeUtils */].getPositionOfChildWindowRelativeToAncestorWindow(self, e.view);
        this.posx -= iframeOffsets.left;
        this.posy -= iframeOffsets.top;
    }
    StandardMouseEvent.prototype.preventDefault = function () {
        if (this.browserEvent.preventDefault) {
            this.browserEvent.preventDefault();
        }
    };
    StandardMouseEvent.prototype.stopPropagation = function () {
        if (this.browserEvent.stopPropagation) {
            this.browserEvent.stopPropagation();
        }
    };
    return StandardMouseEvent;
}());

var DragMouseEvent = /** @class */ (function (_super) {
    __extends(DragMouseEvent, _super);
    function DragMouseEvent(e) {
        var _this = _super.call(this, e) || this;
        _this.dataTransfer = e.dataTransfer;
        return _this;
    }
    return DragMouseEvent;
}(StandardMouseEvent));

var StandardMouseWheelEvent = /** @class */ (function () {
    function StandardMouseWheelEvent(e, deltaX, deltaY) {
        if (deltaX === void 0) { deltaX = 0; }
        if (deltaY === void 0) { deltaY = 0; }
        this.browserEvent = e || null;
        this.target = e ? (e.target || e.targetNode || e.srcElement) : null;
        this.deltaY = deltaY;
        this.deltaX = deltaX;
        if (e) {
            var e1 = e;
            var e2 = e;
            // vertical delta scroll
            if (typeof e1.wheelDeltaY !== 'undefined') {
                this.deltaY = e1.wheelDeltaY / 120;
            }
            else if (typeof e2.VERTICAL_AXIS !== 'undefined' && e2.axis === e2.VERTICAL_AXIS) {
                this.deltaY = -e2.detail / 3;
            }
            // horizontal delta scroll
            if (typeof e1.wheelDeltaX !== 'undefined') {
                if (__WEBPACK_IMPORTED_MODULE_1__browser_js__["m" /* isSafari */] && __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["g" /* isWindows */]) {
                    this.deltaX = -(e1.wheelDeltaX / 120);
                }
                else {
                    this.deltaX = e1.wheelDeltaX / 120;
                }
            }
            else if (typeof e2.HORIZONTAL_AXIS !== 'undefined' && e2.axis === e2.HORIZONTAL_AXIS) {
                this.deltaX = -e.detail / 3;
            }
            // Assume a vertical scroll if nothing else worked
            if (this.deltaY === 0 && this.deltaX === 0 && e.wheelDelta) {
                this.deltaY = e.wheelDelta / 120;
            }
        }
    }
    StandardMouseWheelEvent.prototype.preventDefault = function () {
        if (this.browserEvent) {
            if (this.browserEvent.preventDefault) {
                this.browserEvent.preventDefault();
            }
        }
    };
    StandardMouseWheelEvent.prototype.stopPropagation = function () {
        if (this.browserEvent) {
            if (this.browserEvent.stopPropagation) {
                this.browserEvent.stopPropagation();
            }
        }
    };
    return StandardMouseWheelEvent;
}());



/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RichEditSupport */
/* unused harmony export LanguageConfigurationChangeEvent */
/* unused harmony export LanguageConfigurationRegistryImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguageConfigurationRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__supports_characterPair_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__supports_electricCharacter_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__supports_onEnter_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__supports_indentRules_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__supports_richEditBrackets_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_wordHelper_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__supports_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__ = __webpack_require__(58);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/














var RichEditSupport = /** @class */ (function () {
    function RichEditSupport(languageIdentifier, previous, rawConf) {
        this._languageIdentifier = languageIdentifier;
        this._brackets = null;
        this._electricCharacter = null;
        var prev = null;
        if (previous) {
            prev = previous._conf;
        }
        this._conf = RichEditSupport._mergeConf(prev, rawConf);
        this.onEnter = RichEditSupport._handleOnEnter(this._conf);
        this.comments = RichEditSupport._handleComments(this._conf);
        this.characterPair = new __WEBPACK_IMPORTED_MODULE_0__supports_characterPair_js__["a" /* CharacterPairSupport */](this._conf);
        this.wordDefinition = this._conf.wordPattern || __WEBPACK_IMPORTED_MODULE_9__model_wordHelper_js__["a" /* DEFAULT_WORD_REGEXP */];
        this.indentationRules = this._conf.indentationRules;
        if (this._conf.indentationRules) {
            this.indentRulesSupport = new __WEBPACK_IMPORTED_MODULE_3__supports_indentRules_js__["a" /* IndentRulesSupport */](this._conf.indentationRules);
        }
        this.foldingRules = this._conf.folding || {};
    }
    Object.defineProperty(RichEditSupport.prototype, "brackets", {
        get: function () {
            if (!this._brackets && this._conf.brackets) {
                this._brackets = new __WEBPACK_IMPORTED_MODULE_4__supports_richEditBrackets_js__["b" /* RichEditBrackets */](this._languageIdentifier, this._conf.brackets);
            }
            return this._brackets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RichEditSupport.prototype, "electricCharacter", {
        get: function () {
            if (!this._electricCharacter) {
                var autoClosingPairs = [];
                if (this._conf.autoClosingPairs) {
                    autoClosingPairs = this._conf.autoClosingPairs;
                }
                else if (this._conf.brackets) {
                    autoClosingPairs = this._conf.brackets.map(function (b) {
                        return { open: b[0], close: b[1] };
                    });
                }
                this._electricCharacter = new __WEBPACK_IMPORTED_MODULE_1__supports_electricCharacter_js__["a" /* BracketElectricCharacterSupport */](this.brackets, autoClosingPairs, this._conf.__electricCharacterSupport);
            }
            return this._electricCharacter;
        },
        enumerable: true,
        configurable: true
    });
    RichEditSupport._mergeConf = function (prev, current) {
        return {
            comments: (prev ? current.comments || prev.comments : current.comments),
            brackets: (prev ? current.brackets || prev.brackets : current.brackets),
            wordPattern: (prev ? current.wordPattern || prev.wordPattern : current.wordPattern),
            indentationRules: (prev ? current.indentationRules || prev.indentationRules : current.indentationRules),
            onEnterRules: (prev ? current.onEnterRules || prev.onEnterRules : current.onEnterRules),
            autoClosingPairs: (prev ? current.autoClosingPairs || prev.autoClosingPairs : current.autoClosingPairs),
            surroundingPairs: (prev ? current.surroundingPairs || prev.surroundingPairs : current.surroundingPairs),
            folding: (prev ? current.folding || prev.folding : current.folding),
            __electricCharacterSupport: (prev ? current.__electricCharacterSupport || prev.__electricCharacterSupport : current.__electricCharacterSupport),
        };
    };
    RichEditSupport._handleOnEnter = function (conf) {
        // on enter
        var onEnter = {};
        var empty = true;
        if (conf.brackets) {
            empty = false;
            onEnter.brackets = conf.brackets;
        }
        if (conf.indentationRules) {
            empty = false;
        }
        if (conf.onEnterRules) {
            empty = false;
            onEnter.regExpRules = conf.onEnterRules;
        }
        if (!empty) {
            return new __WEBPACK_IMPORTED_MODULE_2__supports_onEnter_js__["a" /* OnEnterSupport */](onEnter);
        }
        return null;
    };
    RichEditSupport._handleComments = function (conf) {
        var commentRule = conf.comments;
        if (!commentRule) {
            return null;
        }
        // comment configuration
        var comments = {};
        if (commentRule.lineComment) {
            comments.lineCommentToken = commentRule.lineComment;
        }
        if (commentRule.blockComment) {
            var _a = commentRule.blockComment, blockStart = _a[0], blockEnd = _a[1];
            comments.blockCommentStartToken = blockStart;
            comments.blockCommentEndToken = blockEnd;
        }
        return comments;
    };
    return RichEditSupport;
}());

var LanguageConfigurationChangeEvent = /** @class */ (function () {
    function LanguageConfigurationChangeEvent() {
    }
    return LanguageConfigurationChangeEvent;
}());

var LanguageConfigurationRegistryImpl = /** @class */ (function () {
    function LanguageConfigurationRegistryImpl() {
        this._onDidChange = new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]();
        this.onDidChange = this._onDidChange.event;
        this._entries = [];
    }
    LanguageConfigurationRegistryImpl.prototype.register = function (languageIdentifier, configuration) {
        var _this = this;
        var previous = this._getRichEditSupport(languageIdentifier.id);
        var current = new RichEditSupport(languageIdentifier, previous, configuration);
        this._entries[languageIdentifier.id] = current;
        this._onDidChange.fire({ languageIdentifier: languageIdentifier });
        return Object(__WEBPACK_IMPORTED_MODULE_8__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            if (_this._entries[languageIdentifier.id] === current) {
                _this._entries[languageIdentifier.id] = previous;
                _this._onDidChange.fire({ languageIdentifier: languageIdentifier });
            }
        });
    };
    LanguageConfigurationRegistryImpl.prototype._getRichEditSupport = function (languageId) {
        return this._entries[languageId] || null;
    };
    // begin electricCharacter
    LanguageConfigurationRegistryImpl.prototype._getElectricCharacterSupport = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return null;
        }
        return value.electricCharacter || null;
    };
    LanguageConfigurationRegistryImpl.prototype.getElectricCharacters = function (languageId) {
        var electricCharacterSupport = this._getElectricCharacterSupport(languageId);
        if (!electricCharacterSupport) {
            return [];
        }
        return electricCharacterSupport.getElectricCharacters();
    };
    /**
     * Should return opening bracket type to match indentation with
     */
    LanguageConfigurationRegistryImpl.prototype.onElectricCharacter = function (character, context, column) {
        var scopedLineTokens = Object(__WEBPACK_IMPORTED_MODULE_10__supports_js__["a" /* createScopedLineTokens */])(context, column - 1);
        var electricCharacterSupport = this._getElectricCharacterSupport(scopedLineTokens.languageId);
        if (!electricCharacterSupport) {
            return null;
        }
        return electricCharacterSupport.onElectricCharacter(character, scopedLineTokens, column - scopedLineTokens.firstCharOffset);
    };
    // end electricCharacter
    LanguageConfigurationRegistryImpl.prototype.getComments = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return null;
        }
        return value.comments || null;
    };
    // begin characterPair
    LanguageConfigurationRegistryImpl.prototype._getCharacterPairSupport = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return null;
        }
        return value.characterPair || null;
    };
    LanguageConfigurationRegistryImpl.prototype.getAutoClosingPairs = function (languageId) {
        var characterPairSupport = this._getCharacterPairSupport(languageId);
        if (!characterPairSupport) {
            return [];
        }
        return characterPairSupport.getAutoClosingPairs();
    };
    LanguageConfigurationRegistryImpl.prototype.getSurroundingPairs = function (languageId) {
        var characterPairSupport = this._getCharacterPairSupport(languageId);
        if (!characterPairSupport) {
            return [];
        }
        return characterPairSupport.getSurroundingPairs();
    };
    LanguageConfigurationRegistryImpl.prototype.shouldAutoClosePair = function (character, context, column) {
        var scopedLineTokens = Object(__WEBPACK_IMPORTED_MODULE_10__supports_js__["a" /* createScopedLineTokens */])(context, column - 1);
        var characterPairSupport = this._getCharacterPairSupport(scopedLineTokens.languageId);
        if (!characterPairSupport) {
            return false;
        }
        return characterPairSupport.shouldAutoClosePair(character, scopedLineTokens, column - scopedLineTokens.firstCharOffset);
    };
    // end characterPair
    LanguageConfigurationRegistryImpl.prototype.getWordDefinition = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__model_wordHelper_js__["c" /* ensureValidWordDefinition */])(null);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_9__model_wordHelper_js__["c" /* ensureValidWordDefinition */])(value.wordDefinition || null);
    };
    LanguageConfigurationRegistryImpl.prototype.getFoldingRules = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return {};
        }
        return value.foldingRules;
    };
    // begin Indent Rules
    LanguageConfigurationRegistryImpl.prototype.getIndentRulesSupport = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return null;
        }
        return value.indentRulesSupport || null;
    };
    /**
     * Get nearest preceiding line which doesn't match unIndentPattern or contains all whitespace.
     * Result:
     * -1: run into the boundary of embedded languages
     * 0: every line above are invalid
     * else: nearest preceding line of the same language
     */
    LanguageConfigurationRegistryImpl.prototype.getPrecedingValidLine = function (model, lineNumber, indentRulesSupport) {
        var languageID = model.getLanguageIdAtPosition(lineNumber, 0);
        if (lineNumber > 1) {
            var lastLineNumber = lineNumber - 1;
            var resultLineNumber = -1;
            for (lastLineNumber = lineNumber - 1; lastLineNumber >= 1; lastLineNumber--) {
                if (model.getLanguageIdAtPosition(lastLineNumber, 0) !== languageID) {
                    return resultLineNumber;
                }
                var text = model.getLineContent(lastLineNumber);
                if (indentRulesSupport.shouldIgnore(text) || /^\s+$/.test(text) || text === '') {
                    resultLineNumber = lastLineNumber;
                    continue;
                }
                return lastLineNumber;
            }
        }
        return -1;
    };
    /**
     * Get inherited indentation from above lines.
     * 1. Find the nearest preceding line which doesn't match unIndentedLinePattern.
     * 2. If this line matches indentNextLinePattern or increaseIndentPattern, it means that the indent level of `lineNumber` should be 1 greater than this line.
     * 3. If this line doesn't match any indent rules
     *   a. check whether the line above it matches indentNextLinePattern
     *   b. If not, the indent level of this line is the result
     *   c. If so, it means the indent of this line is *temporary*, go upward utill we find a line whose indent is not temporary (the same workflow a -> b -> c).
     * 4. Otherwise, we fail to get an inherited indent from aboves. Return null and we should not touch the indent of `lineNumber`
     *
     * This function only return the inherited indent based on above lines, it doesn't check whether current line should decrease or not.
     */
    LanguageConfigurationRegistryImpl.prototype.getInheritIndentForLine = function (model, lineNumber, honorIntentialIndent) {
        if (honorIntentialIndent === void 0) { honorIntentialIndent = true; }
        var indentRulesSupport = this.getIndentRulesSupport(model.getLanguageIdentifier().id);
        if (!indentRulesSupport) {
            return null;
        }
        if (lineNumber <= 1) {
            return {
                indentation: '',
                action: null
            };
        }
        var precedingUnIgnoredLine = this.getPrecedingValidLine(model, lineNumber, indentRulesSupport);
        if (precedingUnIgnoredLine < 0) {
            return null;
        }
        else if (precedingUnIgnoredLine < 1) {
            return {
                indentation: '',
                action: null
            };
        }
        var precedingUnIgnoredLineContent = model.getLineContent(precedingUnIgnoredLine);
        if (indentRulesSupport.shouldIncrease(precedingUnIgnoredLineContent) || indentRulesSupport.shouldIndentNextLine(precedingUnIgnoredLineContent)) {
            return {
                indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](precedingUnIgnoredLineContent),
                action: __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent,
                line: precedingUnIgnoredLine
            };
        }
        else if (indentRulesSupport.shouldDecrease(precedingUnIgnoredLineContent)) {
            return {
                indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](precedingUnIgnoredLineContent),
                action: null,
                line: precedingUnIgnoredLine
            };
        }
        else {
            // precedingUnIgnoredLine can not be ignored.
            // it doesn't increase indent of following lines
            // it doesn't increase just next line
            // so current line is not affect by precedingUnIgnoredLine
            // and then we should get a correct inheritted indentation from above lines
            if (precedingUnIgnoredLine === 1) {
                return {
                    indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(precedingUnIgnoredLine)),
                    action: null,
                    line: precedingUnIgnoredLine
                };
            }
            var previousLine = precedingUnIgnoredLine - 1;
            var previousLineIndentMetadata = indentRulesSupport.getIndentMetadata(model.getLineContent(previousLine));
            if (!(previousLineIndentMetadata & (1 /* INCREASE_MASK */ | 2 /* DECREASE_MASK */)) &&
                (previousLineIndentMetadata & 4 /* INDENT_NEXTLINE_MASK */)) {
                var stopLine = 0;
                for (var i = previousLine - 1; i > 0; i--) {
                    if (indentRulesSupport.shouldIndentNextLine(model.getLineContent(i))) {
                        continue;
                    }
                    stopLine = i;
                    break;
                }
                return {
                    indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(stopLine + 1)),
                    action: null,
                    line: stopLine + 1
                };
            }
            if (honorIntentialIndent) {
                return {
                    indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(precedingUnIgnoredLine)),
                    action: null,
                    line: precedingUnIgnoredLine
                };
            }
            else {
                // search from precedingUnIgnoredLine until we find one whose indent is not temporary
                for (var i = precedingUnIgnoredLine; i > 0; i--) {
                    var lineContent = model.getLineContent(i);
                    if (indentRulesSupport.shouldIncrease(lineContent)) {
                        return {
                            indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](lineContent),
                            action: __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent,
                            line: i
                        };
                    }
                    else if (indentRulesSupport.shouldIndentNextLine(lineContent)) {
                        var stopLine = 0;
                        for (var j = i - 1; j > 0; j--) {
                            if (indentRulesSupport.shouldIndentNextLine(model.getLineContent(i))) {
                                continue;
                            }
                            stopLine = j;
                            break;
                        }
                        return {
                            indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(stopLine + 1)),
                            action: null,
                            line: stopLine + 1
                        };
                    }
                    else if (indentRulesSupport.shouldDecrease(lineContent)) {
                        return {
                            indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](lineContent),
                            action: null,
                            line: i
                        };
                    }
                }
                return {
                    indentation: __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(1)),
                    action: null,
                    line: 1
                };
            }
        }
    };
    LanguageConfigurationRegistryImpl.prototype.getGoodIndentForLine = function (virtualModel, languageId, lineNumber, indentConverter) {
        var indentRulesSupport = this.getIndentRulesSupport(languageId);
        if (!indentRulesSupport) {
            return null;
        }
        var indent = this.getInheritIndentForLine(virtualModel, lineNumber);
        var lineContent = virtualModel.getLineContent(lineNumber);
        if (indent) {
            var inheritLine = indent.line;
            if (inheritLine !== undefined) {
                var onEnterSupport = this._getOnEnterSupport(languageId);
                var enterResult = null;
                try {
                    enterResult = onEnterSupport.onEnter('', virtualModel.getLineContent(inheritLine), '');
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["e" /* onUnexpectedError */])(e);
                }
                if (enterResult) {
                    var indentation = __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](virtualModel.getLineContent(inheritLine));
                    if (enterResult.removeText) {
                        indentation = indentation.substring(0, indentation.length - enterResult.removeText);
                    }
                    if ((enterResult.indentAction === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent) ||
                        (enterResult.indentAction === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].IndentOutdent)) {
                        indentation = indentConverter.shiftIndent(indentation);
                    }
                    else if (enterResult.indentAction === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Outdent) {
                        indentation = indentConverter.unshiftIndent(indentation);
                    }
                    if (indentRulesSupport.shouldDecrease(lineContent)) {
                        indentation = indentConverter.unshiftIndent(indentation);
                    }
                    if (enterResult.appendText) {
                        indentation += enterResult.appendText;
                    }
                    return __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](indentation);
                }
            }
            if (indentRulesSupport.shouldDecrease(lineContent)) {
                if (indent.action === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent) {
                    return indent.indentation;
                }
                else {
                    return indentConverter.unshiftIndent(indent.indentation);
                }
            }
            else {
                if (indent.action === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent) {
                    return indentConverter.shiftIndent(indent.indentation);
                }
                else {
                    return indent.indentation;
                }
            }
        }
        return null;
    };
    LanguageConfigurationRegistryImpl.prototype.getIndentForEnter = function (model, range, indentConverter, autoIndent) {
        model.forceTokenization(range.startLineNumber);
        var lineTokens = model.getLineTokens(range.startLineNumber);
        var beforeEnterText;
        var afterEnterText;
        var scopedLineTokens = Object(__WEBPACK_IMPORTED_MODULE_10__supports_js__["a" /* createScopedLineTokens */])(lineTokens, range.startColumn - 1);
        var scopedLineText = scopedLineTokens.getLineContent();
        var embeddedLanguage = false;
        if (scopedLineTokens.firstCharOffset > 0 && lineTokens.getLanguageId(0) !== scopedLineTokens.languageId) {
            // we are in the embeded language content
            embeddedLanguage = true; // if embeddedLanguage is true, then we don't touch the indentation of current line
            beforeEnterText = scopedLineText.substr(0, range.startColumn - 1 - scopedLineTokens.firstCharOffset);
        }
        else {
            beforeEnterText = lineTokens.getLineContent().substring(0, range.startColumn - 1);
        }
        if (range.isEmpty()) {
            afterEnterText = scopedLineText.substr(range.startColumn - 1 - scopedLineTokens.firstCharOffset);
        }
        else {
            var endScopedLineTokens = this.getScopedLineTokens(model, range.endLineNumber, range.endColumn);
            afterEnterText = endScopedLineTokens.getLineContent().substr(range.endColumn - 1 - scopedLineTokens.firstCharOffset);
        }
        var indentRulesSupport = this.getIndentRulesSupport(scopedLineTokens.languageId);
        if (!indentRulesSupport) {
            return null;
        }
        var beforeEnterResult = beforeEnterText;
        var beforeEnterIndent = __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](beforeEnterText);
        if (!autoIndent && !embeddedLanguage) {
            var beforeEnterIndentAction = this.getInheritIndentForLine(model, range.startLineNumber);
            if (indentRulesSupport.shouldDecrease(beforeEnterText)) {
                if (beforeEnterIndentAction) {
                    beforeEnterIndent = beforeEnterIndentAction.indentation;
                    if (beforeEnterIndentAction.action !== __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent) {
                        beforeEnterIndent = indentConverter.unshiftIndent(beforeEnterIndent);
                    }
                }
            }
            beforeEnterResult = beforeEnterIndent + __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["ltrim"](__WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["ltrim"](beforeEnterText, ' '), '\t');
        }
        var virtualModel = {
            getLineTokens: function (lineNumber) {
                return model.getLineTokens(lineNumber);
            },
            getLanguageIdentifier: function () {
                return model.getLanguageIdentifier();
            },
            getLanguageIdAtPosition: function (lineNumber, column) {
                return model.getLanguageIdAtPosition(lineNumber, column);
            },
            getLineContent: function (lineNumber) {
                if (lineNumber === range.startLineNumber) {
                    return beforeEnterResult;
                }
                else {
                    return model.getLineContent(lineNumber);
                }
            }
        };
        var currentLineIndent = __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](lineTokens.getLineContent());
        var afterEnterAction = this.getInheritIndentForLine(virtualModel, range.startLineNumber + 1);
        if (!afterEnterAction) {
            var beforeEnter = embeddedLanguage ? currentLineIndent : beforeEnterIndent;
            return {
                beforeEnter: beforeEnter,
                afterEnter: beforeEnter
            };
        }
        var afterEnterIndent = embeddedLanguage ? currentLineIndent : afterEnterAction.indentation;
        if (afterEnterAction.action === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent) {
            afterEnterIndent = indentConverter.shiftIndent(afterEnterIndent);
        }
        if (indentRulesSupport.shouldDecrease(afterEnterText)) {
            afterEnterIndent = indentConverter.unshiftIndent(afterEnterIndent);
        }
        return {
            beforeEnter: embeddedLanguage ? currentLineIndent : beforeEnterIndent,
            afterEnter: afterEnterIndent
        };
    };
    /**
     * We should always allow intentional indentation. It means, if users change the indentation of `lineNumber` and the content of
     * this line doesn't match decreaseIndentPattern, we should not adjust the indentation.
     */
    LanguageConfigurationRegistryImpl.prototype.getIndentActionForType = function (model, range, ch, indentConverter) {
        var scopedLineTokens = this.getScopedLineTokens(model, range.startLineNumber, range.startColumn);
        var indentRulesSupport = this.getIndentRulesSupport(scopedLineTokens.languageId);
        if (!indentRulesSupport) {
            return null;
        }
        var scopedLineText = scopedLineTokens.getLineContent();
        var beforeTypeText = scopedLineText.substr(0, range.startColumn - 1 - scopedLineTokens.firstCharOffset);
        var afterTypeText;
        // selection support
        if (range.isEmpty()) {
            afterTypeText = scopedLineText.substr(range.startColumn - 1 - scopedLineTokens.firstCharOffset);
        }
        else {
            var endScopedLineTokens = this.getScopedLineTokens(model, range.endLineNumber, range.endColumn);
            afterTypeText = endScopedLineTokens.getLineContent().substr(range.endColumn - 1 - scopedLineTokens.firstCharOffset);
        }
        // If previous content already matches decreaseIndentPattern, it means indentation of this line should already be adjusted
        // Users might change the indentation by purpose and we should honor that instead of readjusting.
        if (!indentRulesSupport.shouldDecrease(beforeTypeText + afterTypeText) && indentRulesSupport.shouldDecrease(beforeTypeText + ch + afterTypeText)) {
            // after typing `ch`, the content matches decreaseIndentPattern, we should adjust the indent to a good manner.
            // 1. Get inherited indent action
            var r = this.getInheritIndentForLine(model, range.startLineNumber, false);
            if (!r) {
                return null;
            }
            var indentation = r.indentation;
            if (r.action !== __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent) {
                indentation = indentConverter.unshiftIndent(indentation);
            }
            return indentation;
        }
        return null;
    };
    LanguageConfigurationRegistryImpl.prototype.getIndentMetadata = function (model, lineNumber) {
        var indentRulesSupport = this.getIndentRulesSupport(model.getLanguageIdentifier().id);
        if (!indentRulesSupport) {
            return null;
        }
        if (lineNumber < 1 || lineNumber > model.getLineCount()) {
            return null;
        }
        return indentRulesSupport.getIndentMetadata(model.getLineContent(lineNumber));
    };
    // end Indent Rules
    // begin onEnter
    LanguageConfigurationRegistryImpl.prototype._getOnEnterSupport = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return null;
        }
        return value.onEnter || null;
    };
    LanguageConfigurationRegistryImpl.prototype.getRawEnterActionAtPosition = function (model, lineNumber, column) {
        var r = this.getEnterAction(model, new __WEBPACK_IMPORTED_MODULE_11__core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column));
        return r ? r.enterAction : null;
    };
    LanguageConfigurationRegistryImpl.prototype.getEnterAction = function (model, range) {
        var indentation = this.getIndentationAtPosition(model, range.startLineNumber, range.startColumn);
        var scopedLineTokens = this.getScopedLineTokens(model, range.startLineNumber, range.startColumn);
        var onEnterSupport = this._getOnEnterSupport(scopedLineTokens.languageId);
        if (!onEnterSupport) {
            return null;
        }
        var scopedLineText = scopedLineTokens.getLineContent();
        var beforeEnterText = scopedLineText.substr(0, range.startColumn - 1 - scopedLineTokens.firstCharOffset);
        var afterEnterText;
        // selection support
        if (range.isEmpty()) {
            afterEnterText = scopedLineText.substr(range.startColumn - 1 - scopedLineTokens.firstCharOffset);
        }
        else {
            var endScopedLineTokens = this.getScopedLineTokens(model, range.endLineNumber, range.endColumn);
            afterEnterText = endScopedLineTokens.getLineContent().substr(range.endColumn - 1 - scopedLineTokens.firstCharOffset);
        }
        var lineNumber = range.startLineNumber;
        var oneLineAboveText = '';
        if (lineNumber > 1 && scopedLineTokens.firstCharOffset === 0) {
            // This is not the first line and the entire line belongs to this mode
            var oneLineAboveScopedLineTokens = this.getScopedLineTokens(model, lineNumber - 1);
            if (oneLineAboveScopedLineTokens.languageId === scopedLineTokens.languageId) {
                // The line above ends with text belonging to the same mode
                oneLineAboveText = oneLineAboveScopedLineTokens.getLineContent();
            }
        }
        var enterResult = null;
        try {
            enterResult = onEnterSupport.onEnter(oneLineAboveText, beforeEnterText, afterEnterText);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["e" /* onUnexpectedError */])(e);
        }
        if (!enterResult) {
            return null;
        }
        else {
            // Here we add `\t` to appendText first because enterAction is leveraging appendText and removeText to change indentation.
            if (!enterResult.appendText) {
                if ((enterResult.indentAction === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].Indent) ||
                    (enterResult.indentAction === __WEBPACK_IMPORTED_MODULE_12__languageConfiguration_js__["a" /* IndentAction */].IndentOutdent)) {
                    enterResult.appendText = '\t';
                }
                else {
                    enterResult.appendText = '';
                }
            }
        }
        if (enterResult.removeText) {
            indentation = indentation.substring(0, indentation.length - enterResult.removeText);
        }
        return {
            enterAction: enterResult,
            indentation: indentation,
        };
    };
    LanguageConfigurationRegistryImpl.prototype.getIndentationAtPosition = function (model, lineNumber, column) {
        var lineText = model.getLineContent(lineNumber);
        var indentation = __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["getLeadingWhitespace"](lineText);
        if (indentation.length > column - 1) {
            indentation = indentation.substring(0, column - 1);
        }
        return indentation;
    };
    LanguageConfigurationRegistryImpl.prototype.getScopedLineTokens = function (model, lineNumber, columnNumber) {
        model.forceTokenization(lineNumber);
        var lineTokens = model.getLineTokens(lineNumber);
        var column = isNaN(columnNumber) ? model.getLineMaxColumn(lineNumber) - 1 : columnNumber - 1;
        var scopedLineTokens = Object(__WEBPACK_IMPORTED_MODULE_10__supports_js__["a" /* createScopedLineTokens */])(lineTokens, column);
        return scopedLineTokens;
    };
    // end onEnter
    LanguageConfigurationRegistryImpl.prototype.getBracketsSupport = function (languageId) {
        var value = this._getRichEditSupport(languageId);
        if (!value) {
            return null;
        }
        return value.brackets || null;
    };
    return LanguageConfigurationRegistryImpl;
}());

var LanguageConfigurationRegistry = new LanguageConfigurationRegistryImpl();


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CursorConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SingleCursorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CursorContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CursorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EditOperationResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CursorColumns; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__ = __webpack_require__(6);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var CursorConfiguration = /** @class */ (function () {
    function CursorConfiguration(languageIdentifier, oneIndent, modelOptions, configuration) {
        this._languageIdentifier = languageIdentifier;
        var c = configuration.editor;
        this.readOnly = c.readOnly;
        this.tabSize = modelOptions.tabSize;
        this.insertSpaces = modelOptions.insertSpaces;
        this.oneIndent = oneIndent;
        this.pageSize = Math.max(1, Math.floor(c.layoutInfo.height / c.fontInfo.lineHeight) - 2);
        this.lineHeight = c.lineHeight;
        this.useTabStops = c.useTabStops;
        this.wordSeparators = c.wordSeparators;
        this.emptySelectionClipboard = c.emptySelectionClipboard;
        this.multiCursorMergeOverlapping = c.multiCursorMergeOverlapping;
        this.autoClosingBrackets = c.autoClosingBrackets;
        this.autoIndent = c.autoIndent;
        this.autoClosingPairsOpen = {};
        this.autoClosingPairsClose = {};
        this.surroundingPairs = {};
        this._electricChars = null;
        var autoClosingPairs = CursorConfiguration._getAutoClosingPairs(languageIdentifier);
        if (autoClosingPairs) {
            for (var i = 0; i < autoClosingPairs.length; i++) {
                this.autoClosingPairsOpen[autoClosingPairs[i].open] = autoClosingPairs[i].close;
                this.autoClosingPairsClose[autoClosingPairs[i].close] = autoClosingPairs[i].open;
            }
        }
        var surroundingPairs = CursorConfiguration._getSurroundingPairs(languageIdentifier);
        if (surroundingPairs) {
            for (var i = 0; i < surroundingPairs.length; i++) {
                this.surroundingPairs[surroundingPairs[i].open] = surroundingPairs[i].close;
            }
        }
    }
    CursorConfiguration.shouldRecreate = function (e) {
        return (e.layoutInfo
            || e.wordSeparators
            || e.emptySelectionClipboard
            || e.multiCursorMergeOverlapping
            || e.autoClosingBrackets
            || e.useTabStops
            || e.lineHeight
            || e.readOnly);
    };
    Object.defineProperty(CursorConfiguration.prototype, "electricChars", {
        get: function () {
            if (!this._electricChars) {
                this._electricChars = {};
                var electricChars = CursorConfiguration._getElectricCharacters(this._languageIdentifier);
                if (electricChars) {
                    for (var i = 0; i < electricChars.length; i++) {
                        this._electricChars[electricChars[i]] = true;
                    }
                }
            }
            return this._electricChars;
        },
        enumerable: true,
        configurable: true
    });
    CursorConfiguration.prototype.normalizeIndentation = function (str) {
        return __WEBPACK_IMPORTED_MODULE_2__model_textModel_js__["b" /* TextModel */].normalizeIndentation(str, this.tabSize, this.insertSpaces);
    };
    CursorConfiguration._getElectricCharacters = function (languageIdentifier) {
        try {
            return __WEBPACK_IMPORTED_MODULE_5__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getElectricCharacters(languageIdentifier.id);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            return null;
        }
    };
    CursorConfiguration._getAutoClosingPairs = function (languageIdentifier) {
        try {
            return __WEBPACK_IMPORTED_MODULE_5__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getAutoClosingPairs(languageIdentifier.id);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            return null;
        }
    };
    CursorConfiguration._getSurroundingPairs = function (languageIdentifier) {
        try {
            return __WEBPACK_IMPORTED_MODULE_5__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getSurroundingPairs(languageIdentifier.id);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            return null;
        }
    };
    return CursorConfiguration;
}());

/**
 * Represents the cursor state on either the model or on the view model.
 */
var SingleCursorState = /** @class */ (function () {
    function SingleCursorState(selectionStart, selectionStartLeftoverVisibleColumns, position, leftoverVisibleColumns) {
        this.selectionStart = selectionStart;
        this.selectionStartLeftoverVisibleColumns = selectionStartLeftoverVisibleColumns;
        this.position = position;
        this.leftoverVisibleColumns = leftoverVisibleColumns;
        this.selection = SingleCursorState._computeSelection(this.selectionStart, this.position);
    }
    SingleCursorState.prototype.equals = function (other) {
        return (this.selectionStartLeftoverVisibleColumns === other.selectionStartLeftoverVisibleColumns
            && this.leftoverVisibleColumns === other.leftoverVisibleColumns
            && this.position.equals(other.position)
            && this.selectionStart.equalsRange(other.selectionStart));
    };
    SingleCursorState.prototype.hasSelection = function () {
        return (!this.selection.isEmpty() || !this.selectionStart.isEmpty());
    };
    SingleCursorState.prototype.move = function (inSelectionMode, lineNumber, column, leftoverVisibleColumns) {
        if (inSelectionMode) {
            // move just position
            return new SingleCursorState(this.selectionStart, this.selectionStartLeftoverVisibleColumns, new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineNumber, column), leftoverVisibleColumns);
        }
        else {
            // move everything
            return new SingleCursorState(new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column), leftoverVisibleColumns, new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineNumber, column), leftoverVisibleColumns);
        }
    };
    SingleCursorState._computeSelection = function (selectionStart, position) {
        var startLineNumber, startColumn, endLineNumber, endColumn;
        if (selectionStart.isEmpty()) {
            startLineNumber = selectionStart.startLineNumber;
            startColumn = selectionStart.startColumn;
            endLineNumber = position.lineNumber;
            endColumn = position.column;
        }
        else {
            if (position.isBeforeOrEqual(selectionStart.getStartPosition())) {
                startLineNumber = selectionStart.endLineNumber;
                startColumn = selectionStart.endColumn;
                endLineNumber = position.lineNumber;
                endColumn = position.column;
            }
            else {
                startLineNumber = selectionStart.startLineNumber;
                startColumn = selectionStart.startColumn;
                endLineNumber = position.lineNumber;
                endColumn = position.column;
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["a" /* Selection */](startLineNumber, startColumn, endLineNumber, endColumn);
    };
    return SingleCursorState;
}());

var CursorContext = /** @class */ (function () {
    function CursorContext(configuration, model, viewModel) {
        this.model = model;
        this.viewModel = viewModel;
        this.config = new CursorConfiguration(this.model.getLanguageIdentifier(), this.model.getOneIndent(), this.model.getOptions(), configuration);
    }
    CursorContext.prototype.validateViewPosition = function (viewPosition, modelPosition) {
        return this.viewModel.coordinatesConverter.validateViewPosition(viewPosition, modelPosition);
    };
    CursorContext.prototype.validateViewRange = function (viewRange, expectedModelRange) {
        return this.viewModel.coordinatesConverter.validateViewRange(viewRange, expectedModelRange);
    };
    CursorContext.prototype.convertViewRangeToModelRange = function (viewRange) {
        return this.viewModel.coordinatesConverter.convertViewRangeToModelRange(viewRange);
    };
    CursorContext.prototype.convertViewPositionToModelPosition = function (lineNumber, column) {
        return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineNumber, column));
    };
    CursorContext.prototype.convertModelPositionToViewPosition = function (modelPosition) {
        return this.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
    };
    CursorContext.prototype.convertModelRangeToViewRange = function (modelRange) {
        return this.viewModel.coordinatesConverter.convertModelRangeToViewRange(modelRange);
    };
    CursorContext.prototype.getCurrentScrollTop = function () {
        return this.viewModel.viewLayout.getCurrentScrollTop();
    };
    CursorContext.prototype.getCompletelyVisibleViewRange = function () {
        return this.viewModel.getCompletelyVisibleViewRange();
    };
    CursorContext.prototype.getCompletelyVisibleModelRange = function () {
        var viewRange = this.viewModel.getCompletelyVisibleViewRange();
        return this.viewModel.coordinatesConverter.convertViewRangeToModelRange(viewRange);
    };
    CursorContext.prototype.getCompletelyVisibleViewRangeAtScrollTop = function (scrollTop) {
        return this.viewModel.getCompletelyVisibleViewRangeAtScrollTop(scrollTop);
    };
    CursorContext.prototype.getVerticalOffsetForViewLine = function (viewLineNumber) {
        return this.viewModel.viewLayout.getVerticalOffsetForLineNumber(viewLineNumber);
    };
    return CursorContext;
}());

var CursorState = /** @class */ (function () {
    function CursorState(modelState, viewState) {
        this.modelState = modelState;
        this.viewState = viewState;
    }
    CursorState.fromModelState = function (modelState) {
        return new CursorState(modelState, null);
    };
    CursorState.fromViewState = function (viewState) {
        return new CursorState(null, viewState);
    };
    CursorState.fromModelSelection = function (modelSelection) {
        var selectionStartLineNumber = modelSelection.selectionStartLineNumber;
        var selectionStartColumn = modelSelection.selectionStartColumn;
        var positionLineNumber = modelSelection.positionLineNumber;
        var positionColumn = modelSelection.positionColumn;
        var modelState = new SingleCursorState(new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](selectionStartLineNumber, selectionStartColumn, selectionStartLineNumber, selectionStartColumn), 0, new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](positionLineNumber, positionColumn), 0);
        return CursorState.fromModelState(modelState);
    };
    CursorState.fromModelSelections = function (modelSelections) {
        var states = [];
        for (var i = 0, len = modelSelections.length; i < len; i++) {
            states[i] = this.fromModelSelection(modelSelections[i]);
        }
        return states;
    };
    CursorState.prototype.equals = function (other) {
        return (this.viewState.equals(other.viewState) && this.modelState.equals(other.modelState));
    };
    return CursorState;
}());

var EditOperationResult = /** @class */ (function () {
    function EditOperationResult(type, commands, opts) {
        this.type = type;
        this.commands = commands;
        this.shouldPushStackElementBefore = opts.shouldPushStackElementBefore;
        this.shouldPushStackElementAfter = opts.shouldPushStackElementAfter;
    }
    return EditOperationResult;
}());

/**
 * Common operations that work and make sense both on the model and on the view model.
 */
var CursorColumns = /** @class */ (function () {
    function CursorColumns() {
    }
    CursorColumns.isLowSurrogate = function (model, lineNumber, charOffset) {
        var lineContent = model.getLineContent(lineNumber);
        if (charOffset < 0 || charOffset >= lineContent.length) {
            return false;
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isLowSurrogate"](lineContent.charCodeAt(charOffset));
    };
    CursorColumns.isHighSurrogate = function (model, lineNumber, charOffset) {
        var lineContent = model.getLineContent(lineNumber);
        if (charOffset < 0 || charOffset >= lineContent.length) {
            return false;
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isHighSurrogate"](lineContent.charCodeAt(charOffset));
    };
    CursorColumns.isInsideSurrogatePair = function (model, lineNumber, column) {
        return this.isHighSurrogate(model, lineNumber, column - 2);
    };
    CursorColumns.visibleColumnFromColumn = function (lineContent, column, tabSize) {
        var endOffset = lineContent.length;
        if (endOffset > column - 1) {
            endOffset = column - 1;
        }
        var result = 0;
        for (var i = 0; i < endOffset; i++) {
            var charCode = lineContent.charCodeAt(i);
            if (charCode === 9 /* Tab */) {
                result = this.nextTabStop(result, tabSize);
            }
            else if (__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isFullWidthCharacter"](charCode)) {
                result = result + 2;
            }
            else {
                result = result + 1;
            }
        }
        return result;
    };
    CursorColumns.visibleColumnFromColumn2 = function (config, model, position) {
        return this.visibleColumnFromColumn(model.getLineContent(position.lineNumber), position.column, config.tabSize);
    };
    CursorColumns.columnFromVisibleColumn = function (lineContent, visibleColumn, tabSize) {
        if (visibleColumn <= 0) {
            return 1;
        }
        var lineLength = lineContent.length;
        var beforeVisibleColumn = 0;
        for (var i = 0; i < lineLength; i++) {
            var charCode = lineContent.charCodeAt(i);
            var afterVisibleColumn = void 0;
            if (charCode === 9 /* Tab */) {
                afterVisibleColumn = this.nextTabStop(beforeVisibleColumn, tabSize);
            }
            else if (__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isFullWidthCharacter"](charCode)) {
                afterVisibleColumn = beforeVisibleColumn + 2;
            }
            else {
                afterVisibleColumn = beforeVisibleColumn + 1;
            }
            if (afterVisibleColumn >= visibleColumn) {
                var prevDelta = visibleColumn - beforeVisibleColumn;
                var afterDelta = afterVisibleColumn - visibleColumn;
                if (afterDelta < prevDelta) {
                    return i + 2;
                }
                else {
                    return i + 1;
                }
            }
            beforeVisibleColumn = afterVisibleColumn;
        }
        // walked the entire string
        return lineLength + 1;
    };
    CursorColumns.columnFromVisibleColumn2 = function (config, model, lineNumber, visibleColumn) {
        var result = this.columnFromVisibleColumn(model.getLineContent(lineNumber), visibleColumn, config.tabSize);
        var minColumn = model.getLineMinColumn(lineNumber);
        if (result < minColumn) {
            return minColumn;
        }
        var maxColumn = model.getLineMaxColumn(lineNumber);
        if (result > maxColumn) {
            return maxColumn;
        }
        return result;
    };
    /**
     * ATTENTION: This works with 0-based columns (as oposed to the regular 1-based columns)
     */
    CursorColumns.nextTabStop = function (visibleColumn, tabSize) {
        return visibleColumn + tabSize - visibleColumn % tabSize;
    };
    /**
     * ATTENTION: This works with 0-based columns (as oposed to the regular 1-based columns)
     */
    CursorColumns.prevTabStop = function (column, tabSize) {
        return column - 1 - (column - 1) % tabSize;
    };
    return CursorColumns;
}());



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Registry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_assert_js__ = __webpack_require__(79);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var RegistryImpl = /** @class */ (function () {
    function RegistryImpl() {
        this.data = {};
    }
    RegistryImpl.prototype.add = function (id, data) {
        __WEBPACK_IMPORTED_MODULE_1__base_common_assert_js__["a" /* ok */](__WEBPACK_IMPORTED_MODULE_0__base_common_types_js__["h" /* isString */](id));
        __WEBPACK_IMPORTED_MODULE_1__base_common_assert_js__["a" /* ok */](__WEBPACK_IMPORTED_MODULE_0__base_common_types_js__["g" /* isObject */](data));
        __WEBPACK_IMPORTED_MODULE_1__base_common_assert_js__["a" /* ok */](!this.data.hasOwnProperty(id), 'There is already an extension with this id');
        this.data[id] = data;
    };
    RegistryImpl.prototype.as = function (id) {
        return this.data[id] || null;
    };
    return RegistryImpl;
}());
var Registry = new RegistryImpl();


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isIMenuItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMenuService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MenuRegistry; });
/* unused harmony export ExecuteCommandAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SubmenuItemAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MenuItemAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_actions_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_common_commands_js__ = __webpack_require__(30);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};




function isIMenuItem(item) {
    return item.command !== undefined;
}
var MenuId = /** @class */ (function () {
    function MenuId() {
        this.id = String(MenuId.ID++);
    }
    MenuId.ID = 1;
    MenuId.EditorContext = new MenuId();
    MenuId.CommandPalette = new MenuId();
    MenuId.MenubarEditMenu = new MenuId();
    MenuId.MenubarSelectionMenu = new MenuId();
    return MenuId;
}());

var IMenuService = Object(__WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__["c" /* createDecorator */])('menuService');
var MenuRegistry = new /** @class */ (function () {
    function class_1() {
        this._commands = Object.create(null);
        this._menuItems = Object.create(null);
    }
    class_1.prototype.addCommand = function (command) {
        var old = this._commands[command.id];
        this._commands[command.id] = command;
        return old !== void 0;
    };
    class_1.prototype.getCommand = function (id) {
        return this._commands[id];
    };
    class_1.prototype.appendMenuItem = function (_a, item) {
        var id = _a.id;
        var array = this._menuItems[id];
        if (!array) {
            this._menuItems[id] = array = [item];
        }
        else {
            array.push(item);
        }
        return {
            dispose: function () {
                var idx = array.indexOf(item);
                if (idx >= 0) {
                    array.splice(idx, 1);
                }
            }
        };
    };
    class_1.prototype.getMenuItems = function (_a) {
        var id = _a.id;
        var result = this._menuItems[id] || [];
        if (id === MenuId.CommandPalette.id) {
            // CommandPalette is special because it shows
            // all commands by default
            this._appendImplicitItems(result);
        }
        return result;
    };
    class_1.prototype._appendImplicitItems = function (result) {
        var set = new Set();
        var temp = result.filter(function (item) { return isIMenuItem(item); });
        for (var _i = 0, temp_1 = temp; _i < temp_1.length; _i++) {
            var _a = temp_1[_i], command = _a.command, alt = _a.alt;
            set.add(command.id);
            if (alt) {
                set.add(alt.id);
            }
        }
        for (var id in this._commands) {
            if (!set.has(id)) {
                result.push({ command: this._commands[id] });
            }
        }
    };
    return class_1;
}());
var ExecuteCommandAction = /** @class */ (function (_super) {
    __extends(ExecuteCommandAction, _super);
    function ExecuteCommandAction(id, label, _commandService) {
        var _this = _super.call(this, id, label) || this;
        _this._commandService = _commandService;
        return _this;
    }
    ExecuteCommandAction.prototype.run = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a;
        return (_a = this._commandService).executeCommand.apply(_a, [this.id].concat(args));
    };
    ExecuteCommandAction = __decorate([
        __param(2, __WEBPACK_IMPORTED_MODULE_3__commands_common_commands_js__["b" /* ICommandService */])
    ], ExecuteCommandAction);
    return ExecuteCommandAction;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_actions_js__["a" /* Action */]));

var SubmenuItemAction = /** @class */ (function (_super) {
    __extends(SubmenuItemAction, _super);
    function SubmenuItemAction(item) {
        var _this = this;
        typeof item.title === 'string' ? _this = _super.call(this, '', item.title, 'submenu') || this : _this = _super.call(this, '', item.title.value, 'submenu') || this;
        _this.item = item;
        return _this;
    }
    return SubmenuItemAction;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_actions_js__["a" /* Action */]));

var MenuItemAction = /** @class */ (function (_super) {
    __extends(MenuItemAction, _super);
    function MenuItemAction(item, alt, options, contextKeyService, commandService) {
        var _this = this;
        typeof item.title === 'string' ? _this = _super.call(this, item.id, item.title, commandService) || this : _this = _super.call(this, item.id, item.title.value, commandService) || this;
        _this._cssClass = undefined;
        _this._enabled = !item.precondition || contextKeyService.contextMatchesRules(item.precondition);
        _this._options = options || {};
        _this.item = item;
        _this.alt = alt ? new MenuItemAction(alt, undefined, _this._options, contextKeyService, commandService) : undefined;
        return _this;
    }
    MenuItemAction.prototype.run = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var runArgs = [];
        if (this._options.arg) {
            runArgs = runArgs.concat([this._options.arg]);
        }
        if (this._options.shouldForwardArgs) {
            runArgs = runArgs.concat(args);
        }
        return _super.prototype.run.apply(this, runArgs);
    };
    MenuItemAction = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_3__commands_common_commands_js__["b" /* ICommandService */])
    ], MenuItemAction);
    return MenuItemAction;
}(ExecuteCommandAction));



/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScrollbarVisibility; });
/* unused harmony export ScrollState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scrollable; });
/* unused harmony export SmoothScrollingUpdate */
/* unused harmony export SmoothScrollingOperation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ScrollbarVisibility;
(function (ScrollbarVisibility) {
    ScrollbarVisibility[ScrollbarVisibility["Auto"] = 1] = "Auto";
    ScrollbarVisibility[ScrollbarVisibility["Hidden"] = 2] = "Hidden";
    ScrollbarVisibility[ScrollbarVisibility["Visible"] = 3] = "Visible";
})(ScrollbarVisibility || (ScrollbarVisibility = {}));
var ScrollState = /** @class */ (function () {
    function ScrollState(width, scrollWidth, scrollLeft, height, scrollHeight, scrollTop) {
        width = width | 0;
        scrollWidth = scrollWidth | 0;
        scrollLeft = scrollLeft | 0;
        height = height | 0;
        scrollHeight = scrollHeight | 0;
        scrollTop = scrollTop | 0;
        if (width < 0) {
            width = 0;
        }
        if (scrollLeft + width > scrollWidth) {
            scrollLeft = scrollWidth - width;
        }
        if (scrollLeft < 0) {
            scrollLeft = 0;
        }
        if (height < 0) {
            height = 0;
        }
        if (scrollTop + height > scrollHeight) {
            scrollTop = scrollHeight - height;
        }
        if (scrollTop < 0) {
            scrollTop = 0;
        }
        this.width = width;
        this.scrollWidth = scrollWidth;
        this.scrollLeft = scrollLeft;
        this.height = height;
        this.scrollHeight = scrollHeight;
        this.scrollTop = scrollTop;
    }
    ScrollState.prototype.equals = function (other) {
        return (this.width === other.width
            && this.scrollWidth === other.scrollWidth
            && this.scrollLeft === other.scrollLeft
            && this.height === other.height
            && this.scrollHeight === other.scrollHeight
            && this.scrollTop === other.scrollTop);
    };
    ScrollState.prototype.withScrollDimensions = function (update) {
        return new ScrollState((typeof update.width !== 'undefined' ? update.width : this.width), (typeof update.scrollWidth !== 'undefined' ? update.scrollWidth : this.scrollWidth), this.scrollLeft, (typeof update.height !== 'undefined' ? update.height : this.height), (typeof update.scrollHeight !== 'undefined' ? update.scrollHeight : this.scrollHeight), this.scrollTop);
    };
    ScrollState.prototype.withScrollPosition = function (update) {
        return new ScrollState(this.width, this.scrollWidth, (typeof update.scrollLeft !== 'undefined' ? update.scrollLeft : this.scrollLeft), this.height, this.scrollHeight, (typeof update.scrollTop !== 'undefined' ? update.scrollTop : this.scrollTop));
    };
    ScrollState.prototype.createScrollEvent = function (previous) {
        var widthChanged = (this.width !== previous.width);
        var scrollWidthChanged = (this.scrollWidth !== previous.scrollWidth);
        var scrollLeftChanged = (this.scrollLeft !== previous.scrollLeft);
        var heightChanged = (this.height !== previous.height);
        var scrollHeightChanged = (this.scrollHeight !== previous.scrollHeight);
        var scrollTopChanged = (this.scrollTop !== previous.scrollTop);
        return {
            width: this.width,
            scrollWidth: this.scrollWidth,
            scrollLeft: this.scrollLeft,
            height: this.height,
            scrollHeight: this.scrollHeight,
            scrollTop: this.scrollTop,
            widthChanged: widthChanged,
            scrollWidthChanged: scrollWidthChanged,
            scrollLeftChanged: scrollLeftChanged,
            heightChanged: heightChanged,
            scrollHeightChanged: scrollHeightChanged,
            scrollTopChanged: scrollTopChanged,
        };
    };
    return ScrollState;
}());

var Scrollable = /** @class */ (function (_super) {
    __extends(Scrollable, _super);
    function Scrollable(smoothScrollDuration, scheduleAtNextAnimationFrame) {
        var _this = _super.call(this) || this;
        _this._onScroll = _this._register(new __WEBPACK_IMPORTED_MODULE_1__event_js__["a" /* Emitter */]());
        _this.onScroll = _this._onScroll.event;
        _this._smoothScrollDuration = smoothScrollDuration;
        _this._scheduleAtNextAnimationFrame = scheduleAtNextAnimationFrame;
        _this._state = new ScrollState(0, 0, 0, 0, 0, 0);
        _this._smoothScrolling = null;
        return _this;
    }
    Scrollable.prototype.dispose = function () {
        if (this._smoothScrolling) {
            this._smoothScrolling.dispose();
            this._smoothScrolling = null;
        }
        _super.prototype.dispose.call(this);
    };
    Scrollable.prototype.setSmoothScrollDuration = function (smoothScrollDuration) {
        this._smoothScrollDuration = smoothScrollDuration;
    };
    Scrollable.prototype.validateScrollPosition = function (scrollPosition) {
        return this._state.withScrollPosition(scrollPosition);
    };
    Scrollable.prototype.getScrollDimensions = function () {
        return this._state;
    };
    Scrollable.prototype.setScrollDimensions = function (dimensions) {
        var newState = this._state.withScrollDimensions(dimensions);
        this._setState(newState);
        // Validate outstanding animated scroll position target
        if (this._smoothScrolling) {
            this._smoothScrolling.acceptScrollDimensions(this._state);
        }
    };
    /**
     * Returns the final scroll position that the instance will have once the smooth scroll animation concludes.
     * If no scroll animation is occurring, it will return the current scroll position instead.
     */
    Scrollable.prototype.getFutureScrollPosition = function () {
        if (this._smoothScrolling) {
            return this._smoothScrolling.to;
        }
        return this._state;
    };
    /**
     * Returns the current scroll position.
     * Note: This result might be an intermediate scroll position, as there might be an ongoing smooth scroll animation.
     */
    Scrollable.prototype.getCurrentScrollPosition = function () {
        return this._state;
    };
    Scrollable.prototype.setScrollPositionNow = function (update) {
        // no smooth scrolling requested
        var newState = this._state.withScrollPosition(update);
        // Terminate any outstanding smooth scrolling
        if (this._smoothScrolling) {
            this._smoothScrolling.dispose();
            this._smoothScrolling = null;
        }
        this._setState(newState);
    };
    Scrollable.prototype.setScrollPositionSmooth = function (update) {
        var _this = this;
        if (this._smoothScrollDuration === 0) {
            // Smooth scrolling not supported.
            return this.setScrollPositionNow(update);
        }
        if (this._smoothScrolling) {
            // Combine our pending scrollLeft/scrollTop with incoming scrollLeft/scrollTop
            update = {
                scrollLeft: (typeof update.scrollLeft === 'undefined' ? this._smoothScrolling.to.scrollLeft : update.scrollLeft),
                scrollTop: (typeof update.scrollTop === 'undefined' ? this._smoothScrolling.to.scrollTop : update.scrollTop)
            };
            // Validate `update`
            var validTarget = this._state.withScrollPosition(update);
            if (this._smoothScrolling.to.scrollLeft === validTarget.scrollLeft && this._smoothScrolling.to.scrollTop === validTarget.scrollTop) {
                // No need to interrupt or extend the current animation since we're going to the same place
                return;
            }
            var newSmoothScrolling = this._smoothScrolling.combine(this._state, validTarget, this._smoothScrollDuration);
            this._smoothScrolling.dispose();
            this._smoothScrolling = newSmoothScrolling;
        }
        else {
            // Validate `update`
            var validTarget = this._state.withScrollPosition(update);
            this._smoothScrolling = SmoothScrollingOperation.start(this._state, validTarget, this._smoothScrollDuration);
        }
        // Begin smooth scrolling animation
        this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(function () {
            if (!_this._smoothScrolling) {
                return;
            }
            _this._smoothScrolling.animationFrameDisposable = null;
            _this._performSmoothScrolling();
        });
    };
    Scrollable.prototype._performSmoothScrolling = function () {
        var _this = this;
        var update = this._smoothScrolling.tick();
        var newState = this._state.withScrollPosition(update);
        this._setState(newState);
        if (update.isDone) {
            this._smoothScrolling.dispose();
            this._smoothScrolling = null;
            return;
        }
        // Continue smooth scrolling animation
        this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(function () {
            if (!_this._smoothScrolling) {
                return;
            }
            _this._smoothScrolling.animationFrameDisposable = null;
            _this._performSmoothScrolling();
        });
    };
    Scrollable.prototype._setState = function (newState) {
        var oldState = this._state;
        if (oldState.equals(newState)) {
            // no change
            return;
        }
        this._state = newState;
        this._onScroll.fire(this._state.createScrollEvent(oldState));
    };
    return Scrollable;
}(__WEBPACK_IMPORTED_MODULE_0__lifecycle_js__["a" /* Disposable */]));

var SmoothScrollingUpdate = /** @class */ (function () {
    function SmoothScrollingUpdate(scrollLeft, scrollTop, isDone) {
        this.scrollLeft = scrollLeft;
        this.scrollTop = scrollTop;
        this.isDone = isDone;
    }
    return SmoothScrollingUpdate;
}());

function createEaseOutCubic(from, to) {
    var delta = to - from;
    return function (completion) {
        return from + delta * easeOutCubic(completion);
    };
}
function createComposed(a, b, cut) {
    return function (completion) {
        if (completion < cut) {
            return a(completion / cut);
        }
        return b((completion - cut) / (1 - cut));
    };
}
var SmoothScrollingOperation = /** @class */ (function () {
    function SmoothScrollingOperation(from, to, startTime, duration) {
        this.from = from;
        this.to = to;
        this.duration = duration;
        this._startTime = startTime;
        this.animationFrameDisposable = null;
        this._initAnimations();
    }
    SmoothScrollingOperation.prototype._initAnimations = function () {
        this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width);
        this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
    };
    SmoothScrollingOperation.prototype._initAnimation = function (from, to, viewportSize) {
        var delta = Math.abs(from - to);
        if (delta > 2.5 * viewportSize) {
            var stop1 = void 0, stop2 = void 0;
            if (from < to) {
                // scroll to 75% of the viewportSize
                stop1 = from + 0.75 * viewportSize;
                stop2 = to - 0.75 * viewportSize;
            }
            else {
                stop1 = from - 0.75 * viewportSize;
                stop2 = to + 0.75 * viewportSize;
            }
            return createComposed(createEaseOutCubic(from, stop1), createEaseOutCubic(stop2, to), 0.33);
        }
        return createEaseOutCubic(from, to);
    };
    SmoothScrollingOperation.prototype.dispose = function () {
        if (this.animationFrameDisposable !== null) {
            this.animationFrameDisposable.dispose();
            this.animationFrameDisposable = null;
        }
    };
    SmoothScrollingOperation.prototype.acceptScrollDimensions = function (state) {
        this.to = state.withScrollPosition(this.to);
        this._initAnimations();
    };
    SmoothScrollingOperation.prototype.tick = function () {
        return this._tick(Date.now());
    };
    SmoothScrollingOperation.prototype._tick = function (now) {
        var completion = (now - this._startTime) / this.duration;
        if (completion < 1) {
            var newScrollLeft = this.scrollLeft(completion);
            var newScrollTop = this.scrollTop(completion);
            return new SmoothScrollingUpdate(newScrollLeft, newScrollTop, false);
        }
        return new SmoothScrollingUpdate(this.to.scrollLeft, this.to.scrollTop, true);
    };
    SmoothScrollingOperation.prototype.combine = function (from, to, duration) {
        return SmoothScrollingOperation.start(from, to, duration);
    };
    SmoothScrollingOperation.start = function (from, to, duration) {
        // +10 / -10 : pretend the animation already started for a quicker response to a scroll request
        duration = duration + 10;
        var startTime = Date.now() - 10;
        return new SmoothScrollingOperation(from, to, startTime, duration);
    };
    return SmoothScrollingOperation;
}());

function easeInCubic(t) {
    return Math.pow(t, 3);
}
function easeOutCubic(t) {
    return 1 - easeInCubic(1 - t);
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Widget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Widget = /** @class */ (function (_super) {
    __extends(Widget, _super);
    function Widget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Widget.prototype.onclick = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].CLICK, function (e) { return listener(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["b" /* StandardMouseEvent */](e)); }));
    };
    Widget.prototype.onmousedown = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].MOUSE_DOWN, function (e) { return listener(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["b" /* StandardMouseEvent */](e)); }));
    };
    Widget.prototype.onmouseover = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].MOUSE_OVER, function (e) { return listener(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["b" /* StandardMouseEvent */](e)); }));
    };
    Widget.prototype.onnonbubblingmouseout = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["h" /* addDisposableNonBubblingMouseOutListener */](domNode, function (e) { return listener(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["b" /* StandardMouseEvent */](e)); }));
    };
    Widget.prototype.onkeydown = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].KEY_DOWN, function (e) { return listener(new __WEBPACK_IMPORTED_MODULE_2__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e)); }));
    };
    Widget.prototype.onkeyup = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].KEY_UP, function (e) { return listener(new __WEBPACK_IMPORTED_MODULE_2__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e)); }));
    };
    Widget.prototype.oninput = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].INPUT, listener));
    };
    Widget.prototype.onblur = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].BLUR, listener));
    };
    Widget.prototype.onfocus = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].FOCUS, listener));
    };
    Widget.prototype.onchange = function (domNode, listener) {
        this._register(__WEBPACK_IMPORTED_MODULE_3__dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].CHANGE, listener));
    };
    return Widget;
}(__WEBPACK_IMPORTED_MODULE_0__common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IModelService; });
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldSynchronizeModel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IModelService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])('modelService');
function shouldSynchronizeModel(model) {
    return (!model.isTooLargeForSyncing() && !model.isForSimpleWidget);
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RenderMinimap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WrappingIndent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TextEditorCursorBlinkingStyle; });
/* harmony export (immutable) */ __webpack_exports__["k"] = blinkingStyleToString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TextEditorCursorStyle; });
/* harmony export (immutable) */ __webpack_exports__["l"] = cursorStyleToString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return InternalEditorOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EditorOptionsValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return InternalEditorOptionsFactory; });
/* unused harmony export EditorLayoutProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDITOR_FONT_DEFAULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EDITOR_MODEL_DEFAULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDITOR_DEFAULTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_wordHelper_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_objects_js__ = __webpack_require__(26);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var RenderMinimap;
(function (RenderMinimap) {
    RenderMinimap[RenderMinimap["None"] = 0] = "None";
    RenderMinimap[RenderMinimap["Small"] = 1] = "Small";
    RenderMinimap[RenderMinimap["Large"] = 2] = "Large";
    RenderMinimap[RenderMinimap["SmallBlocks"] = 3] = "SmallBlocks";
    RenderMinimap[RenderMinimap["LargeBlocks"] = 4] = "LargeBlocks";
})(RenderMinimap || (RenderMinimap = {}));
/**
 * Describes how to indent wrapped lines.
 */
var WrappingIndent;
(function (WrappingIndent) {
    /**
     * No indentation => wrapped lines begin at column 1.
     */
    WrappingIndent[WrappingIndent["None"] = 0] = "None";
    /**
     * Same => wrapped lines get the same indentation as the parent.
     */
    WrappingIndent[WrappingIndent["Same"] = 1] = "Same";
    /**
     * Indent => wrapped lines get +1 indentation toward the parent.
     */
    WrappingIndent[WrappingIndent["Indent"] = 2] = "Indent";
    /**
     * DeepIndent => wrapped lines get +2 indentation toward the parent.
     */
    WrappingIndent[WrappingIndent["DeepIndent"] = 3] = "DeepIndent";
})(WrappingIndent || (WrappingIndent = {}));
/**
 * The kind of animation in which the editor's cursor should be rendered.
 */
var TextEditorCursorBlinkingStyle;
(function (TextEditorCursorBlinkingStyle) {
    /**
     * Hidden
     */
    TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Hidden"] = 0] = "Hidden";
    /**
     * Blinking
     */
    TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Blink"] = 1] = "Blink";
    /**
     * Blinking with smooth fading
     */
    TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Smooth"] = 2] = "Smooth";
    /**
     * Blinking with prolonged filled state and smooth fading
     */
    TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Phase"] = 3] = "Phase";
    /**
     * Expand collapse animation on the y axis
     */
    TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Expand"] = 4] = "Expand";
    /**
     * No-Blinking
     */
    TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Solid"] = 5] = "Solid";
})(TextEditorCursorBlinkingStyle || (TextEditorCursorBlinkingStyle = {}));
/**
 * @internal
 */
function blinkingStyleToString(blinkingStyle) {
    if (blinkingStyle === TextEditorCursorBlinkingStyle.Blink) {
        return 'blink';
    }
    else if (blinkingStyle === TextEditorCursorBlinkingStyle.Expand) {
        return 'expand';
    }
    else if (blinkingStyle === TextEditorCursorBlinkingStyle.Phase) {
        return 'phase';
    }
    else if (blinkingStyle === TextEditorCursorBlinkingStyle.Smooth) {
        return 'smooth';
    }
    else if (blinkingStyle === TextEditorCursorBlinkingStyle.Solid) {
        return 'solid';
    }
    else {
        throw new Error('blinkingStyleToString: Unknown blinkingStyle');
    }
}
/**
 * The style in which the editor's cursor should be rendered.
 */
var TextEditorCursorStyle;
(function (TextEditorCursorStyle) {
    /**
     * As a vertical line (sitting between two characters).
     */
    TextEditorCursorStyle[TextEditorCursorStyle["Line"] = 1] = "Line";
    /**
     * As a block (sitting on top of a character).
     */
    TextEditorCursorStyle[TextEditorCursorStyle["Block"] = 2] = "Block";
    /**
     * As a horizontal line (sitting under a character).
     */
    TextEditorCursorStyle[TextEditorCursorStyle["Underline"] = 3] = "Underline";
    /**
     * As a thin vertical line (sitting between two characters).
     */
    TextEditorCursorStyle[TextEditorCursorStyle["LineThin"] = 4] = "LineThin";
    /**
     * As an outlined block (sitting on top of a character).
     */
    TextEditorCursorStyle[TextEditorCursorStyle["BlockOutline"] = 5] = "BlockOutline";
    /**
     * As a thin horizontal line (sitting under a character).
     */
    TextEditorCursorStyle[TextEditorCursorStyle["UnderlineThin"] = 6] = "UnderlineThin";
})(TextEditorCursorStyle || (TextEditorCursorStyle = {}));
/**
 * @internal
 */
function cursorStyleToString(cursorStyle) {
    if (cursorStyle === TextEditorCursorStyle.Line) {
        return 'line';
    }
    else if (cursorStyle === TextEditorCursorStyle.Block) {
        return 'block';
    }
    else if (cursorStyle === TextEditorCursorStyle.Underline) {
        return 'underline';
    }
    else if (cursorStyle === TextEditorCursorStyle.LineThin) {
        return 'line-thin';
    }
    else if (cursorStyle === TextEditorCursorStyle.BlockOutline) {
        return 'block-outline';
    }
    else if (cursorStyle === TextEditorCursorStyle.UnderlineThin) {
        return 'underline-thin';
    }
    else {
        throw new Error('cursorStyleToString: Unknown cursorStyle');
    }
}
function _cursorStyleFromString(cursorStyle, defaultValue) {
    if (typeof cursorStyle !== 'string') {
        return defaultValue;
    }
    if (cursorStyle === 'line') {
        return TextEditorCursorStyle.Line;
    }
    else if (cursorStyle === 'block') {
        return TextEditorCursorStyle.Block;
    }
    else if (cursorStyle === 'underline') {
        return TextEditorCursorStyle.Underline;
    }
    else if (cursorStyle === 'line-thin') {
        return TextEditorCursorStyle.LineThin;
    }
    else if (cursorStyle === 'block-outline') {
        return TextEditorCursorStyle.BlockOutline;
    }
    else if (cursorStyle === 'underline-thin') {
        return TextEditorCursorStyle.UnderlineThin;
    }
    return TextEditorCursorStyle.Line;
}
/**
 * Internal configuration options (transformed or computed) for the editor.
 */
var InternalEditorOptions = /** @class */ (function () {
    /**
     * @internal
     */
    function InternalEditorOptions(source) {
        this.canUseLayerHinting = source.canUseLayerHinting;
        this.pixelRatio = source.pixelRatio;
        this.editorClassName = source.editorClassName;
        this.lineHeight = source.lineHeight | 0;
        this.readOnly = source.readOnly;
        this.accessibilitySupport = source.accessibilitySupport;
        this.multiCursorModifier = source.multiCursorModifier;
        this.multiCursorMergeOverlapping = source.multiCursorMergeOverlapping;
        this.wordSeparators = source.wordSeparators;
        this.autoClosingBrackets = source.autoClosingBrackets;
        this.autoIndent = source.autoIndent;
        this.useTabStops = source.useTabStops;
        this.tabFocusMode = source.tabFocusMode;
        this.dragAndDrop = source.dragAndDrop;
        this.emptySelectionClipboard = source.emptySelectionClipboard;
        this.layoutInfo = source.layoutInfo;
        this.fontInfo = source.fontInfo;
        this.viewInfo = source.viewInfo;
        this.wrappingInfo = source.wrappingInfo;
        this.contribInfo = source.contribInfo;
        this.showUnused = source.showUnused;
    }
    /**
     * @internal
     */
    InternalEditorOptions.prototype.equals = function (other) {
        return (this.canUseLayerHinting === other.canUseLayerHinting
            && this.pixelRatio === other.pixelRatio
            && this.editorClassName === other.editorClassName
            && this.lineHeight === other.lineHeight
            && this.readOnly === other.readOnly
            && this.accessibilitySupport === other.accessibilitySupport
            && this.multiCursorModifier === other.multiCursorModifier
            && this.multiCursorMergeOverlapping === other.multiCursorMergeOverlapping
            && this.wordSeparators === other.wordSeparators
            && this.autoClosingBrackets === other.autoClosingBrackets
            && this.autoIndent === other.autoIndent
            && this.useTabStops === other.useTabStops
            && this.tabFocusMode === other.tabFocusMode
            && this.dragAndDrop === other.dragAndDrop
            && this.showUnused === other.showUnused
            && this.emptySelectionClipboard === other.emptySelectionClipboard
            && InternalEditorOptions._equalsLayoutInfo(this.layoutInfo, other.layoutInfo)
            && this.fontInfo.equals(other.fontInfo)
            && InternalEditorOptions._equalsViewOptions(this.viewInfo, other.viewInfo)
            && InternalEditorOptions._equalsWrappingInfo(this.wrappingInfo, other.wrappingInfo)
            && InternalEditorOptions._equalsContribOptions(this.contribInfo, other.contribInfo));
    };
    /**
     * @internal
     */
    InternalEditorOptions.prototype.createChangeEvent = function (newOpts) {
        return {
            canUseLayerHinting: (this.canUseLayerHinting !== newOpts.canUseLayerHinting),
            pixelRatio: (this.pixelRatio !== newOpts.pixelRatio),
            editorClassName: (this.editorClassName !== newOpts.editorClassName),
            lineHeight: (this.lineHeight !== newOpts.lineHeight),
            readOnly: (this.readOnly !== newOpts.readOnly),
            accessibilitySupport: (this.accessibilitySupport !== newOpts.accessibilitySupport),
            multiCursorModifier: (this.multiCursorModifier !== newOpts.multiCursorModifier),
            multiCursorMergeOverlapping: (this.multiCursorMergeOverlapping !== newOpts.multiCursorMergeOverlapping),
            wordSeparators: (this.wordSeparators !== newOpts.wordSeparators),
            autoClosingBrackets: (this.autoClosingBrackets !== newOpts.autoClosingBrackets),
            autoIndent: (this.autoIndent !== newOpts.autoIndent),
            useTabStops: (this.useTabStops !== newOpts.useTabStops),
            tabFocusMode: (this.tabFocusMode !== newOpts.tabFocusMode),
            dragAndDrop: (this.dragAndDrop !== newOpts.dragAndDrop),
            emptySelectionClipboard: (this.emptySelectionClipboard !== newOpts.emptySelectionClipboard),
            layoutInfo: (!InternalEditorOptions._equalsLayoutInfo(this.layoutInfo, newOpts.layoutInfo)),
            fontInfo: (!this.fontInfo.equals(newOpts.fontInfo)),
            viewInfo: (!InternalEditorOptions._equalsViewOptions(this.viewInfo, newOpts.viewInfo)),
            wrappingInfo: (!InternalEditorOptions._equalsWrappingInfo(this.wrappingInfo, newOpts.wrappingInfo)),
            contribInfo: (!InternalEditorOptions._equalsContribOptions(this.contribInfo, newOpts.contribInfo))
        };
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsLayoutInfo = function (a, b) {
        return (a.width === b.width
            && a.height === b.height
            && a.glyphMarginLeft === b.glyphMarginLeft
            && a.glyphMarginWidth === b.glyphMarginWidth
            && a.glyphMarginHeight === b.glyphMarginHeight
            && a.lineNumbersLeft === b.lineNumbersLeft
            && a.lineNumbersWidth === b.lineNumbersWidth
            && a.lineNumbersHeight === b.lineNumbersHeight
            && a.decorationsLeft === b.decorationsLeft
            && a.decorationsWidth === b.decorationsWidth
            && a.decorationsHeight === b.decorationsHeight
            && a.contentLeft === b.contentLeft
            && a.contentWidth === b.contentWidth
            && a.contentHeight === b.contentHeight
            && a.renderMinimap === b.renderMinimap
            && a.minimapLeft === b.minimapLeft
            && a.minimapWidth === b.minimapWidth
            && a.viewportColumn === b.viewportColumn
            && a.verticalScrollbarWidth === b.verticalScrollbarWidth
            && a.horizontalScrollbarHeight === b.horizontalScrollbarHeight
            && this._equalsOverviewRuler(a.overviewRuler, b.overviewRuler));
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsOverviewRuler = function (a, b) {
        return (a.width === b.width
            && a.height === b.height
            && a.top === b.top
            && a.right === b.right);
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsViewOptions = function (a, b) {
        return (a.extraEditorClassName === b.extraEditorClassName
            && a.disableMonospaceOptimizations === b.disableMonospaceOptimizations
            && __WEBPACK_IMPORTED_MODULE_4__base_common_arrays_js__["e" /* equals */](a.rulers, b.rulers)
            && a.ariaLabel === b.ariaLabel
            && a.renderLineNumbers === b.renderLineNumbers
            && a.renderCustomLineNumbers === b.renderCustomLineNumbers
            && a.selectOnLineNumbers === b.selectOnLineNumbers
            && a.glyphMargin === b.glyphMargin
            && a.revealHorizontalRightPadding === b.revealHorizontalRightPadding
            && a.roundedSelection === b.roundedSelection
            && a.overviewRulerLanes === b.overviewRulerLanes
            && a.overviewRulerBorder === b.overviewRulerBorder
            && a.cursorBlinking === b.cursorBlinking
            && a.mouseWheelZoom === b.mouseWheelZoom
            && a.cursorStyle === b.cursorStyle
            && a.cursorWidth === b.cursorWidth
            && a.hideCursorInOverviewRuler === b.hideCursorInOverviewRuler
            && a.scrollBeyondLastLine === b.scrollBeyondLastLine
            && a.scrollBeyondLastColumn === b.scrollBeyondLastColumn
            && a.smoothScrolling === b.smoothScrolling
            && a.stopRenderingLineAfter === b.stopRenderingLineAfter
            && a.renderWhitespace === b.renderWhitespace
            && a.renderControlCharacters === b.renderControlCharacters
            && a.fontLigatures === b.fontLigatures
            && a.renderIndentGuides === b.renderIndentGuides
            && a.highlightActiveIndentGuide === b.highlightActiveIndentGuide
            && a.renderLineHighlight === b.renderLineHighlight
            && this._equalsScrollbarOptions(a.scrollbar, b.scrollbar)
            && this._equalsMinimapOptions(a.minimap, b.minimap)
            && a.fixedOverflowWidgets === b.fixedOverflowWidgets);
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsScrollbarOptions = function (a, b) {
        return (a.arrowSize === b.arrowSize
            && a.vertical === b.vertical
            && a.horizontal === b.horizontal
            && a.useShadows === b.useShadows
            && a.verticalHasArrows === b.verticalHasArrows
            && a.horizontalHasArrows === b.horizontalHasArrows
            && a.handleMouseWheel === b.handleMouseWheel
            && a.horizontalScrollbarSize === b.horizontalScrollbarSize
            && a.horizontalSliderSize === b.horizontalSliderSize
            && a.verticalScrollbarSize === b.verticalScrollbarSize
            && a.verticalSliderSize === b.verticalSliderSize
            && a.mouseWheelScrollSensitivity === b.mouseWheelScrollSensitivity);
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsMinimapOptions = function (a, b) {
        return (a.enabled === b.enabled
            && a.side === b.side
            && a.showSlider === b.showSlider
            && a.renderCharacters === b.renderCharacters
            && a.maxColumn === b.maxColumn);
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalFindOptions = function (a, b) {
        return (a.seedSearchStringFromSelection === b.seedSearchStringFromSelection
            && a.autoFindInSelection === b.autoFindInSelection
            && a.globalFindClipboard === b.globalFindClipboard);
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsHoverOptions = function (a, b) {
        return (a.enabled === b.enabled
            && a.delay === b.delay
            && a.sticky === b.sticky);
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsSuggestOptions = function (a, b) {
        if (a === b) {
            return true;
        }
        else if (!a || !b) {
            return false;
        }
        else {
            return a.filterGraceful === b.filterGraceful
                && a.snippets === b.snippets
                && a.snippetsPreventQuickSuggestions === b.snippetsPreventQuickSuggestions;
        }
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsWrappingInfo = function (a, b) {
        return (a.inDiffEditor === b.inDiffEditor
            && a.isDominatedByLongLines === b.isDominatedByLongLines
            && a.isWordWrapMinified === b.isWordWrapMinified
            && a.isViewportWrapping === b.isViewportWrapping
            && a.wrappingColumn === b.wrappingColumn
            && a.wrappingIndent === b.wrappingIndent
            && a.wordWrapBreakBeforeCharacters === b.wordWrapBreakBeforeCharacters
            && a.wordWrapBreakAfterCharacters === b.wordWrapBreakAfterCharacters
            && a.wordWrapBreakObtrusiveCharacters === b.wordWrapBreakObtrusiveCharacters);
    };
    /**
     * @internal
     */
    InternalEditorOptions._equalsContribOptions = function (a, b) {
        return (a.selectionClipboard === b.selectionClipboard
            && this._equalsHoverOptions(a.hover, b.hover)
            && a.links === b.links
            && a.contextmenu === b.contextmenu
            && InternalEditorOptions._equalsQuickSuggestions(a.quickSuggestions, b.quickSuggestions)
            && a.quickSuggestionsDelay === b.quickSuggestionsDelay
            && a.parameterHints === b.parameterHints
            && a.iconsInSuggestions === b.iconsInSuggestions
            && a.formatOnType === b.formatOnType
            && a.formatOnPaste === b.formatOnPaste
            && a.suggestOnTriggerCharacters === b.suggestOnTriggerCharacters
            && a.acceptSuggestionOnEnter === b.acceptSuggestionOnEnter
            && a.acceptSuggestionOnCommitCharacter === b.acceptSuggestionOnCommitCharacter
            && a.wordBasedSuggestions === b.wordBasedSuggestions
            && a.suggestSelection === b.suggestSelection
            && a.suggestFontSize === b.suggestFontSize
            && a.suggestLineHeight === b.suggestLineHeight
            && this._equalsSuggestOptions(a.suggest, b.suggest)
            && a.selectionHighlight === b.selectionHighlight
            && a.occurrencesHighlight === b.occurrencesHighlight
            && a.codeLens === b.codeLens
            && a.folding === b.folding
            && a.foldingStrategy === b.foldingStrategy
            && a.showFoldingControls === b.showFoldingControls
            && a.matchBrackets === b.matchBrackets
            && this._equalFindOptions(a.find, b.find)
            && a.colorDecorators === b.colorDecorators
            && __WEBPACK_IMPORTED_MODULE_5__base_common_objects_js__["e" /* equals */](a.codeActionsOnSave, b.codeActionsOnSave)
            && a.codeActionsOnSaveTimeout === b.codeActionsOnSaveTimeout
            && a.lightbulbEnabled === b.lightbulbEnabled);
    };
    InternalEditorOptions._equalsQuickSuggestions = function (a, b) {
        if (typeof a === 'boolean') {
            if (typeof b !== 'boolean') {
                return false;
            }
            return a === b;
        }
        if (typeof b === 'boolean') {
            return false;
        }
        return (a.comments === b.comments
            && a.other === b.other
            && a.strings === b.strings);
    };
    return InternalEditorOptions;
}());

function _boolean(value, defaultValue) {
    if (typeof value === 'undefined') {
        return defaultValue;
    }
    if (value === 'false') {
        // treat the string 'false' as false
        return false;
    }
    return Boolean(value);
}
function _booleanMap(value, defaultValue) {
    if (!value) {
        return defaultValue;
    }
    var out = Object.create(null);
    for (var _i = 0, _a = Object.keys(value); _i < _a.length; _i++) {
        var k = _a[_i];
        var v = value[k];
        if (typeof v === 'boolean') {
            out[k] = v;
        }
    }
    return out;
}
function _string(value, defaultValue) {
    if (typeof value !== 'string') {
        return defaultValue;
    }
    return value;
}
function _stringSet(value, defaultValue, allowedValues) {
    if (typeof value !== 'string') {
        return defaultValue;
    }
    if (allowedValues.indexOf(value) === -1) {
        return defaultValue;
    }
    return value;
}
function _clampedInt(value, defaultValue, minimum, maximum) {
    var r;
    if (typeof value === 'undefined') {
        r = defaultValue;
    }
    else {
        r = parseInt(value, 10);
        if (isNaN(r)) {
            r = defaultValue;
        }
    }
    r = Math.max(minimum, r);
    r = Math.min(maximum, r);
    return r | 0;
}
function _float(value, defaultValue) {
    var r = parseFloat(value);
    if (isNaN(r)) {
        r = defaultValue;
    }
    return r;
}
function _wrappingIndentFromString(wrappingIndent, defaultValue) {
    if (typeof wrappingIndent !== 'string') {
        return defaultValue;
    }
    if (wrappingIndent === 'same') {
        return WrappingIndent.Same;
    }
    else if (wrappingIndent === 'indent') {
        return WrappingIndent.Indent;
    }
    else if (wrappingIndent === 'deepIndent') {
        return WrappingIndent.DeepIndent;
    }
    else {
        return WrappingIndent.None;
    }
}
function _cursorBlinkingStyleFromString(cursorBlinkingStyle, defaultValue) {
    if (typeof cursorBlinkingStyle !== 'string') {
        return defaultValue;
    }
    switch (cursorBlinkingStyle) {
        case 'blink':
            return TextEditorCursorBlinkingStyle.Blink;
        case 'smooth':
            return TextEditorCursorBlinkingStyle.Smooth;
        case 'phase':
            return TextEditorCursorBlinkingStyle.Phase;
        case 'expand':
            return TextEditorCursorBlinkingStyle.Expand;
        case 'visible': // maintain compatibility
        case 'solid':
            return TextEditorCursorBlinkingStyle.Solid;
    }
    return TextEditorCursorBlinkingStyle.Blink;
}
function _scrollbarVisibilityFromString(visibility, defaultValue) {
    if (typeof visibility !== 'string') {
        return defaultValue;
    }
    switch (visibility) {
        case 'hidden':
            return __WEBPACK_IMPORTED_MODULE_2__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden;
        case 'visible':
            return __WEBPACK_IMPORTED_MODULE_2__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Visible;
        default:
            return __WEBPACK_IMPORTED_MODULE_2__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Auto;
    }
}
/**
 * @internal
 */
var EditorOptionsValidator = /** @class */ (function () {
    function EditorOptionsValidator() {
    }
    /**
     * Validate raw editor options.
     * i.e. since they can be defined by the user, they might be invalid.
     */
    EditorOptionsValidator.validate = function (opts, defaults) {
        var wordWrap = opts.wordWrap;
        {
            // Compatibility with old true or false values
            if (wordWrap === true) {
                wordWrap = 'on';
            }
            else if (wordWrap === false) {
                wordWrap = 'off';
            }
            wordWrap = _stringSet(wordWrap, defaults.wordWrap, ['off', 'on', 'wordWrapColumn', 'bounded']);
        }
        var viewInfo = this._sanitizeViewInfo(opts, defaults.viewInfo);
        var contribInfo = this._sanitizeContribInfo(opts, defaults.contribInfo);
        var configuredMulticursorModifier;
        if (typeof opts.multiCursorModifier === 'string') {
            if (opts.multiCursorModifier === 'ctrlCmd') {
                configuredMulticursorModifier = __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["d" /* isMacintosh */] ? 'metaKey' : 'ctrlKey';
            }
            else {
                configuredMulticursorModifier = 'altKey';
            }
        }
        var multiCursorModifier = _stringSet(configuredMulticursorModifier, defaults.multiCursorModifier, ['altKey', 'metaKey', 'ctrlKey']);
        return {
            inDiffEditor: _boolean(opts.inDiffEditor, defaults.inDiffEditor),
            wordSeparators: _string(opts.wordSeparators, defaults.wordSeparators),
            lineNumbersMinChars: _clampedInt(opts.lineNumbersMinChars, defaults.lineNumbersMinChars, 1, 10),
            lineDecorationsWidth: (typeof opts.lineDecorationsWidth === 'undefined' ? defaults.lineDecorationsWidth : opts.lineDecorationsWidth),
            readOnly: _boolean(opts.readOnly, defaults.readOnly),
            mouseStyle: _stringSet(opts.mouseStyle, defaults.mouseStyle, ['text', 'default', 'copy']),
            disableLayerHinting: _boolean(opts.disableLayerHinting, defaults.disableLayerHinting),
            automaticLayout: _boolean(opts.automaticLayout, defaults.automaticLayout),
            wordWrap: wordWrap,
            wordWrapColumn: _clampedInt(opts.wordWrapColumn, defaults.wordWrapColumn, 1, 1073741824 /* MAX_SAFE_SMALL_INTEGER */),
            wordWrapMinified: _boolean(opts.wordWrapMinified, defaults.wordWrapMinified),
            wrappingIndent: _wrappingIndentFromString(opts.wrappingIndent, defaults.wrappingIndent),
            wordWrapBreakBeforeCharacters: _string(opts.wordWrapBreakBeforeCharacters, defaults.wordWrapBreakBeforeCharacters),
            wordWrapBreakAfterCharacters: _string(opts.wordWrapBreakAfterCharacters, defaults.wordWrapBreakAfterCharacters),
            wordWrapBreakObtrusiveCharacters: _string(opts.wordWrapBreakObtrusiveCharacters, defaults.wordWrapBreakObtrusiveCharacters),
            autoClosingBrackets: _boolean(opts.autoClosingBrackets, defaults.autoClosingBrackets),
            autoIndent: _boolean(opts.autoIndent, defaults.autoIndent),
            dragAndDrop: _boolean(opts.dragAndDrop, defaults.dragAndDrop),
            emptySelectionClipboard: _boolean(opts.emptySelectionClipboard, defaults.emptySelectionClipboard),
            useTabStops: _boolean(opts.useTabStops, defaults.useTabStops),
            multiCursorModifier: multiCursorModifier,
            multiCursorMergeOverlapping: _boolean(opts.multiCursorMergeOverlapping, defaults.multiCursorMergeOverlapping),
            accessibilitySupport: _stringSet(opts.accessibilitySupport, defaults.accessibilitySupport, ['auto', 'on', 'off']),
            showUnused: _boolean(opts.showUnused, defaults.showUnused),
            viewInfo: viewInfo,
            contribInfo: contribInfo,
        };
    };
    EditorOptionsValidator._sanitizeScrollbarOpts = function (opts, defaults, mouseWheelScrollSensitivity) {
        if (typeof opts !== 'object') {
            return defaults;
        }
        var horizontalScrollbarSize = _clampedInt(opts.horizontalScrollbarSize, defaults.horizontalScrollbarSize, 0, 1000);
        var verticalScrollbarSize = _clampedInt(opts.verticalScrollbarSize, defaults.verticalScrollbarSize, 0, 1000);
        return {
            vertical: _scrollbarVisibilityFromString(opts.vertical, defaults.vertical),
            horizontal: _scrollbarVisibilityFromString(opts.horizontal, defaults.horizontal),
            arrowSize: _clampedInt(opts.arrowSize, defaults.arrowSize, 0, 1000),
            useShadows: _boolean(opts.useShadows, defaults.useShadows),
            verticalHasArrows: _boolean(opts.verticalHasArrows, defaults.verticalHasArrows),
            horizontalHasArrows: _boolean(opts.horizontalHasArrows, defaults.horizontalHasArrows),
            horizontalScrollbarSize: horizontalScrollbarSize,
            horizontalSliderSize: _clampedInt(opts.horizontalSliderSize, horizontalScrollbarSize, 0, 1000),
            verticalScrollbarSize: verticalScrollbarSize,
            verticalSliderSize: _clampedInt(opts.verticalSliderSize, verticalScrollbarSize, 0, 1000),
            handleMouseWheel: _boolean(opts.handleMouseWheel, defaults.handleMouseWheel),
            mouseWheelScrollSensitivity: mouseWheelScrollSensitivity
        };
    };
    EditorOptionsValidator._sanitizeMinimapOpts = function (opts, defaults) {
        if (typeof opts !== 'object') {
            return defaults;
        }
        return {
            enabled: _boolean(opts.enabled, defaults.enabled),
            side: _stringSet(opts.side, defaults.side, ['right', 'left']),
            showSlider: _stringSet(opts.showSlider, defaults.showSlider, ['always', 'mouseover']),
            renderCharacters: _boolean(opts.renderCharacters, defaults.renderCharacters),
            maxColumn: _clampedInt(opts.maxColumn, defaults.maxColumn, 1, 10000),
        };
    };
    EditorOptionsValidator._santizeFindOpts = function (opts, defaults) {
        if (typeof opts !== 'object') {
            return defaults;
        }
        return {
            seedSearchStringFromSelection: _boolean(opts.seedSearchStringFromSelection, defaults.seedSearchStringFromSelection),
            autoFindInSelection: _boolean(opts.autoFindInSelection, defaults.autoFindInSelection),
            globalFindClipboard: _boolean(opts.globalFindClipboard, defaults.globalFindClipboard)
        };
    };
    EditorOptionsValidator._santizeHoverOpts = function (_opts, defaults) {
        var opts;
        if (typeof _opts === 'boolean') {
            opts = {
                enabled: _opts
            };
        }
        else if (typeof _opts === 'object') {
            opts = _opts;
        }
        else {
            return defaults;
        }
        return {
            enabled: _boolean(opts.enabled, defaults.enabled),
            delay: _clampedInt(opts.delay, defaults.delay, 0, 10000),
            sticky: _boolean(opts.sticky, defaults.sticky)
        };
    };
    EditorOptionsValidator._sanitizeSuggestOpts = function (opts, defaults) {
        var suggestOpts = opts.suggest || {};
        return {
            filterGraceful: _boolean(suggestOpts.filterGraceful, defaults.filterGraceful),
            snippets: _stringSet(opts.snippetSuggestions, defaults.snippets, ['top', 'bottom', 'inline', 'none']),
            snippetsPreventQuickSuggestions: _boolean(suggestOpts.snippetsPreventQuickSuggestions, defaults.filterGraceful),
        };
    };
    EditorOptionsValidator._sanitizeViewInfo = function (opts, defaults) {
        var rulers = [];
        if (Array.isArray(opts.rulers)) {
            for (var i = 0, len = opts.rulers.length; i < len; i++) {
                rulers.push(_clampedInt(opts.rulers[i], 0, 0, 10000));
            }
            rulers.sort();
        }
        var renderLineNumbers = defaults.renderLineNumbers;
        var renderCustomLineNumbers = defaults.renderCustomLineNumbers;
        if (typeof opts.lineNumbers !== 'undefined') {
            var lineNumbers = opts.lineNumbers;
            // Compatibility with old true or false values
            if (lineNumbers === true) {
                lineNumbers = 'on';
            }
            else if (lineNumbers === false) {
                lineNumbers = 'off';
            }
            if (typeof lineNumbers === 'function') {
                renderLineNumbers = 4 /* Custom */;
                renderCustomLineNumbers = lineNumbers;
            }
            else if (lineNumbers === 'interval') {
                renderLineNumbers = 3 /* Interval */;
            }
            else if (lineNumbers === 'relative') {
                renderLineNumbers = 2 /* Relative */;
            }
            else if (lineNumbers === 'on') {
                renderLineNumbers = 1 /* On */;
            }
            else {
                renderLineNumbers = 0 /* Off */;
            }
        }
        var fontLigatures = _boolean(opts.fontLigatures, defaults.fontLigatures);
        var disableMonospaceOptimizations = _boolean(opts.disableMonospaceOptimizations, defaults.disableMonospaceOptimizations) || fontLigatures;
        var renderWhitespace = opts.renderWhitespace;
        {
            // Compatibility with old true or false values
            if (renderWhitespace === true) {
                renderWhitespace = 'boundary';
            }
            else if (renderWhitespace === false) {
                renderWhitespace = 'none';
            }
            renderWhitespace = _stringSet(opts.renderWhitespace, defaults.renderWhitespace, ['none', 'boundary', 'all']);
        }
        var renderLineHighlight = opts.renderLineHighlight;
        {
            // Compatibility with old true or false values
            if (renderLineHighlight === true) {
                renderLineHighlight = 'line';
            }
            else if (renderLineHighlight === false) {
                renderLineHighlight = 'none';
            }
            renderLineHighlight = _stringSet(opts.renderLineHighlight, defaults.renderLineHighlight, ['none', 'gutter', 'line', 'all']);
        }
        var mouseWheelScrollSensitivity = _float(opts.mouseWheelScrollSensitivity, defaults.scrollbar.mouseWheelScrollSensitivity);
        if (mouseWheelScrollSensitivity === 0) {
            // Disallow 0, as it would prevent/block scrolling
            mouseWheelScrollSensitivity = 1;
        }
        var scrollbar = this._sanitizeScrollbarOpts(opts.scrollbar, defaults.scrollbar, mouseWheelScrollSensitivity);
        var minimap = this._sanitizeMinimapOpts(opts.minimap, defaults.minimap);
        return {
            extraEditorClassName: _string(opts.extraEditorClassName, defaults.extraEditorClassName),
            disableMonospaceOptimizations: disableMonospaceOptimizations,
            rulers: rulers,
            ariaLabel: _string(opts.ariaLabel, defaults.ariaLabel),
            renderLineNumbers: renderLineNumbers,
            renderCustomLineNumbers: renderCustomLineNumbers,
            selectOnLineNumbers: _boolean(opts.selectOnLineNumbers, defaults.selectOnLineNumbers),
            glyphMargin: _boolean(opts.glyphMargin, defaults.glyphMargin),
            revealHorizontalRightPadding: _clampedInt(opts.revealHorizontalRightPadding, defaults.revealHorizontalRightPadding, 0, 1000),
            roundedSelection: _boolean(opts.roundedSelection, defaults.roundedSelection),
            overviewRulerLanes: _clampedInt(opts.overviewRulerLanes, defaults.overviewRulerLanes, 0, 3),
            overviewRulerBorder: _boolean(opts.overviewRulerBorder, defaults.overviewRulerBorder),
            cursorBlinking: _cursorBlinkingStyleFromString(opts.cursorBlinking, defaults.cursorBlinking),
            mouseWheelZoom: _boolean(opts.mouseWheelZoom, defaults.mouseWheelZoom),
            cursorStyle: _cursorStyleFromString(opts.cursorStyle, defaults.cursorStyle),
            cursorWidth: _clampedInt(opts.cursorWidth, defaults.cursorWidth, 0, Number.MAX_VALUE),
            hideCursorInOverviewRuler: _boolean(opts.hideCursorInOverviewRuler, defaults.hideCursorInOverviewRuler),
            scrollBeyondLastLine: _boolean(opts.scrollBeyondLastLine, defaults.scrollBeyondLastLine),
            scrollBeyondLastColumn: _clampedInt(opts.scrollBeyondLastColumn, defaults.scrollBeyondLastColumn, 0, 1073741824 /* MAX_SAFE_SMALL_INTEGER */),
            smoothScrolling: _boolean(opts.smoothScrolling, defaults.smoothScrolling),
            stopRenderingLineAfter: _clampedInt(opts.stopRenderingLineAfter, defaults.stopRenderingLineAfter, -1, 1073741824 /* MAX_SAFE_SMALL_INTEGER */),
            renderWhitespace: renderWhitespace,
            renderControlCharacters: _boolean(opts.renderControlCharacters, defaults.renderControlCharacters),
            fontLigatures: fontLigatures,
            renderIndentGuides: _boolean(opts.renderIndentGuides, defaults.renderIndentGuides),
            highlightActiveIndentGuide: _boolean(opts.highlightActiveIndentGuide, defaults.highlightActiveIndentGuide),
            renderLineHighlight: renderLineHighlight,
            scrollbar: scrollbar,
            minimap: minimap,
            fixedOverflowWidgets: _boolean(opts.fixedOverflowWidgets, defaults.fixedOverflowWidgets),
        };
    };
    EditorOptionsValidator._sanitizeContribInfo = function (opts, defaults) {
        var quickSuggestions;
        if (typeof opts.quickSuggestions === 'object') {
            quickSuggestions = __assign({ other: true }, opts.quickSuggestions);
        }
        else {
            quickSuggestions = _boolean(opts.quickSuggestions, defaults.quickSuggestions);
        }
        // Compatibility support for acceptSuggestionOnEnter
        if (typeof opts.acceptSuggestionOnEnter === 'boolean') {
            opts.acceptSuggestionOnEnter = opts.acceptSuggestionOnEnter ? 'on' : 'off';
        }
        var find = this._santizeFindOpts(opts.find, defaults.find);
        return {
            selectionClipboard: _boolean(opts.selectionClipboard, defaults.selectionClipboard),
            hover: this._santizeHoverOpts(opts.hover, defaults.hover),
            links: _boolean(opts.links, defaults.links),
            contextmenu: _boolean(opts.contextmenu, defaults.contextmenu),
            quickSuggestions: quickSuggestions,
            quickSuggestionsDelay: _clampedInt(opts.quickSuggestionsDelay, defaults.quickSuggestionsDelay, -1073741824 /* MIN_SAFE_SMALL_INTEGER */, 1073741824 /* MAX_SAFE_SMALL_INTEGER */),
            parameterHints: _boolean(opts.parameterHints, defaults.parameterHints),
            iconsInSuggestions: _boolean(opts.iconsInSuggestions, defaults.iconsInSuggestions),
            formatOnType: _boolean(opts.formatOnType, defaults.formatOnType),
            formatOnPaste: _boolean(opts.formatOnPaste, defaults.formatOnPaste),
            suggestOnTriggerCharacters: _boolean(opts.suggestOnTriggerCharacters, defaults.suggestOnTriggerCharacters),
            acceptSuggestionOnEnter: _stringSet(opts.acceptSuggestionOnEnter, defaults.acceptSuggestionOnEnter, ['on', 'smart', 'off']),
            acceptSuggestionOnCommitCharacter: _boolean(opts.acceptSuggestionOnCommitCharacter, defaults.acceptSuggestionOnCommitCharacter),
            wordBasedSuggestions: _boolean(opts.wordBasedSuggestions, defaults.wordBasedSuggestions),
            suggestSelection: _stringSet(opts.suggestSelection, defaults.suggestSelection, ['first', 'recentlyUsed', 'recentlyUsedByPrefix']),
            suggestFontSize: _clampedInt(opts.suggestFontSize, defaults.suggestFontSize, 0, 1000),
            suggestLineHeight: _clampedInt(opts.suggestLineHeight, defaults.suggestLineHeight, 0, 1000),
            suggest: this._sanitizeSuggestOpts(opts, defaults.suggest),
            selectionHighlight: _boolean(opts.selectionHighlight, defaults.selectionHighlight),
            occurrencesHighlight: _boolean(opts.occurrencesHighlight, defaults.occurrencesHighlight),
            codeLens: _boolean(opts.codeLens, defaults.codeLens),
            folding: _boolean(opts.folding, defaults.folding),
            foldingStrategy: _stringSet(opts.foldingStrategy, defaults.foldingStrategy, ['auto', 'indentation']),
            showFoldingControls: _stringSet(opts.showFoldingControls, defaults.showFoldingControls, ['always', 'mouseover']),
            matchBrackets: _boolean(opts.matchBrackets, defaults.matchBrackets),
            find: find,
            colorDecorators: _boolean(opts.colorDecorators, defaults.colorDecorators),
            lightbulbEnabled: _boolean(opts.lightbulb ? opts.lightbulb.enabled : false, defaults.lightbulbEnabled),
            codeActionsOnSave: _booleanMap(opts.codeActionsOnSave, {}),
            codeActionsOnSaveTimeout: _clampedInt(opts.codeActionsOnSaveTimeout, defaults.codeActionsOnSaveTimeout, 1, 10000)
        };
    };
    return EditorOptionsValidator;
}());

/**
 * @internal
 */
var InternalEditorOptionsFactory = /** @class */ (function () {
    function InternalEditorOptionsFactory() {
    }
    InternalEditorOptionsFactory._tweakValidatedOptions = function (opts, accessibilitySupport) {
        var accessibilityIsOn = (accessibilitySupport === 2 /* Enabled */);
        var accessibilityIsOff = (accessibilitySupport === 1 /* Disabled */);
        return {
            inDiffEditor: opts.inDiffEditor,
            wordSeparators: opts.wordSeparators,
            lineNumbersMinChars: opts.lineNumbersMinChars,
            lineDecorationsWidth: opts.lineDecorationsWidth,
            readOnly: opts.readOnly,
            mouseStyle: opts.mouseStyle,
            disableLayerHinting: opts.disableLayerHinting,
            automaticLayout: opts.automaticLayout,
            wordWrap: opts.wordWrap,
            wordWrapColumn: opts.wordWrapColumn,
            wordWrapMinified: opts.wordWrapMinified,
            wrappingIndent: opts.wrappingIndent,
            wordWrapBreakBeforeCharacters: opts.wordWrapBreakBeforeCharacters,
            wordWrapBreakAfterCharacters: opts.wordWrapBreakAfterCharacters,
            wordWrapBreakObtrusiveCharacters: opts.wordWrapBreakObtrusiveCharacters,
            autoClosingBrackets: opts.autoClosingBrackets,
            autoIndent: opts.autoIndent,
            dragAndDrop: opts.dragAndDrop,
            emptySelectionClipboard: opts.emptySelectionClipboard,
            useTabStops: opts.useTabStops,
            multiCursorModifier: opts.multiCursorModifier,
            multiCursorMergeOverlapping: opts.multiCursorMergeOverlapping,
            accessibilitySupport: opts.accessibilitySupport,
            showUnused: opts.showUnused,
            viewInfo: {
                extraEditorClassName: opts.viewInfo.extraEditorClassName,
                disableMonospaceOptimizations: opts.viewInfo.disableMonospaceOptimizations,
                rulers: opts.viewInfo.rulers,
                ariaLabel: (accessibilityIsOff ? __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('accessibilityOffAriaLabel', "The editor is not accessible at this time. Press Alt+F1 for options.") : opts.viewInfo.ariaLabel),
                renderLineNumbers: opts.viewInfo.renderLineNumbers,
                renderCustomLineNumbers: opts.viewInfo.renderCustomLineNumbers,
                selectOnLineNumbers: opts.viewInfo.selectOnLineNumbers,
                glyphMargin: opts.viewInfo.glyphMargin,
                revealHorizontalRightPadding: opts.viewInfo.revealHorizontalRightPadding,
                roundedSelection: (accessibilityIsOn ? false : opts.viewInfo.roundedSelection),
                overviewRulerLanes: opts.viewInfo.overviewRulerLanes,
                overviewRulerBorder: opts.viewInfo.overviewRulerBorder,
                cursorBlinking: opts.viewInfo.cursorBlinking,
                mouseWheelZoom: opts.viewInfo.mouseWheelZoom,
                cursorStyle: opts.viewInfo.cursorStyle,
                cursorWidth: opts.viewInfo.cursorWidth,
                hideCursorInOverviewRuler: opts.viewInfo.hideCursorInOverviewRuler,
                scrollBeyondLastLine: opts.viewInfo.scrollBeyondLastLine,
                scrollBeyondLastColumn: opts.viewInfo.scrollBeyondLastColumn,
                smoothScrolling: opts.viewInfo.smoothScrolling,
                stopRenderingLineAfter: opts.viewInfo.stopRenderingLineAfter,
                renderWhitespace: (accessibilityIsOn ? 'none' : opts.viewInfo.renderWhitespace),
                renderControlCharacters: (accessibilityIsOn ? false : opts.viewInfo.renderControlCharacters),
                fontLigatures: (accessibilityIsOn ? false : opts.viewInfo.fontLigatures),
                renderIndentGuides: (accessibilityIsOn ? false : opts.viewInfo.renderIndentGuides),
                highlightActiveIndentGuide: opts.viewInfo.highlightActiveIndentGuide,
                renderLineHighlight: opts.viewInfo.renderLineHighlight,
                scrollbar: opts.viewInfo.scrollbar,
                minimap: {
                    enabled: (accessibilityIsOn ? false : opts.viewInfo.minimap.enabled),
                    side: opts.viewInfo.minimap.side,
                    renderCharacters: opts.viewInfo.minimap.renderCharacters,
                    showSlider: opts.viewInfo.minimap.showSlider,
                    maxColumn: opts.viewInfo.minimap.maxColumn
                },
                fixedOverflowWidgets: opts.viewInfo.fixedOverflowWidgets
            },
            contribInfo: {
                selectionClipboard: opts.contribInfo.selectionClipboard,
                hover: opts.contribInfo.hover,
                links: (accessibilityIsOn ? false : opts.contribInfo.links),
                contextmenu: opts.contribInfo.contextmenu,
                quickSuggestions: opts.contribInfo.quickSuggestions,
                quickSuggestionsDelay: opts.contribInfo.quickSuggestionsDelay,
                parameterHints: opts.contribInfo.parameterHints,
                iconsInSuggestions: opts.contribInfo.iconsInSuggestions,
                formatOnType: opts.contribInfo.formatOnType,
                formatOnPaste: opts.contribInfo.formatOnPaste,
                suggestOnTriggerCharacters: opts.contribInfo.suggestOnTriggerCharacters,
                acceptSuggestionOnEnter: opts.contribInfo.acceptSuggestionOnEnter,
                acceptSuggestionOnCommitCharacter: opts.contribInfo.acceptSuggestionOnCommitCharacter,
                wordBasedSuggestions: opts.contribInfo.wordBasedSuggestions,
                suggestSelection: opts.contribInfo.suggestSelection,
                suggestFontSize: opts.contribInfo.suggestFontSize,
                suggestLineHeight: opts.contribInfo.suggestLineHeight,
                suggest: opts.contribInfo.suggest,
                selectionHighlight: (accessibilityIsOn ? false : opts.contribInfo.selectionHighlight),
                occurrencesHighlight: (accessibilityIsOn ? false : opts.contribInfo.occurrencesHighlight),
                codeLens: (accessibilityIsOn ? false : opts.contribInfo.codeLens),
                folding: (accessibilityIsOn ? false : opts.contribInfo.folding),
                foldingStrategy: opts.contribInfo.foldingStrategy,
                showFoldingControls: opts.contribInfo.showFoldingControls,
                matchBrackets: (accessibilityIsOn ? false : opts.contribInfo.matchBrackets),
                find: opts.contribInfo.find,
                colorDecorators: opts.contribInfo.colorDecorators,
                lightbulbEnabled: opts.contribInfo.lightbulbEnabled,
                codeActionsOnSave: opts.contribInfo.codeActionsOnSave,
                codeActionsOnSaveTimeout: opts.contribInfo.codeActionsOnSaveTimeout
            }
        };
    };
    InternalEditorOptionsFactory.createInternalEditorOptions = function (env, _opts) {
        var accessibilitySupport;
        if (_opts.accessibilitySupport === 'auto') {
            // The editor reads the `accessibilitySupport` from the environment
            accessibilitySupport = env.accessibilitySupport;
        }
        else if (_opts.accessibilitySupport === 'on') {
            accessibilitySupport = 2 /* Enabled */;
        }
        else {
            accessibilitySupport = 1 /* Disabled */;
        }
        // Disable some non critical features to get as best performance as possible
        // See https://github.com/Microsoft/vscode/issues/26730
        var opts = this._tweakValidatedOptions(_opts, accessibilitySupport);
        var lineDecorationsWidth;
        if (typeof opts.lineDecorationsWidth === 'string' && /^\d+(\.\d+)?ch$/.test(opts.lineDecorationsWidth)) {
            var multiple = parseFloat(opts.lineDecorationsWidth.substr(0, opts.lineDecorationsWidth.length - 2));
            lineDecorationsWidth = multiple * env.fontInfo.typicalHalfwidthCharacterWidth;
        }
        else {
            lineDecorationsWidth = _clampedInt(opts.lineDecorationsWidth, 0, 0, 1000);
        }
        if (opts.contribInfo.folding) {
            lineDecorationsWidth += 16;
        }
        var layoutInfo = EditorLayoutProvider.compute({
            outerWidth: env.outerWidth,
            outerHeight: env.outerHeight,
            showGlyphMargin: opts.viewInfo.glyphMargin,
            lineHeight: env.fontInfo.lineHeight,
            showLineNumbers: (opts.viewInfo.renderLineNumbers !== 0 /* Off */),
            lineNumbersMinChars: opts.lineNumbersMinChars,
            lineNumbersDigitCount: env.lineNumbersDigitCount,
            lineDecorationsWidth: lineDecorationsWidth,
            typicalHalfwidthCharacterWidth: env.fontInfo.typicalHalfwidthCharacterWidth,
            maxDigitWidth: env.fontInfo.maxDigitWidth,
            verticalScrollbarWidth: opts.viewInfo.scrollbar.verticalScrollbarSize,
            horizontalScrollbarHeight: opts.viewInfo.scrollbar.horizontalScrollbarSize,
            scrollbarArrowSize: opts.viewInfo.scrollbar.arrowSize,
            verticalScrollbarHasArrows: opts.viewInfo.scrollbar.verticalHasArrows,
            minimap: opts.viewInfo.minimap.enabled,
            minimapSide: opts.viewInfo.minimap.side,
            minimapRenderCharacters: opts.viewInfo.minimap.renderCharacters,
            minimapMaxColumn: opts.viewInfo.minimap.maxColumn,
            pixelRatio: env.pixelRatio
        });
        var bareWrappingInfo = null;
        {
            var wordWrap = opts.wordWrap;
            var wordWrapColumn = opts.wordWrapColumn;
            var wordWrapMinified = opts.wordWrapMinified;
            if (accessibilitySupport === 2 /* Enabled */) {
                // See https://github.com/Microsoft/vscode/issues/27766
                // Never enable wrapping when a screen reader is attached
                // because arrow down etc. will not move the cursor in the way
                // a screen reader expects.
                bareWrappingInfo = {
                    isWordWrapMinified: false,
                    isViewportWrapping: false,
                    wrappingColumn: -1
                };
            }
            else if (wordWrapMinified && env.isDominatedByLongLines) {
                // Force viewport width wrapping if model is dominated by long lines
                bareWrappingInfo = {
                    isWordWrapMinified: true,
                    isViewportWrapping: true,
                    wrappingColumn: Math.max(1, layoutInfo.viewportColumn)
                };
            }
            else if (wordWrap === 'on') {
                bareWrappingInfo = {
                    isWordWrapMinified: false,
                    isViewportWrapping: true,
                    wrappingColumn: Math.max(1, layoutInfo.viewportColumn)
                };
            }
            else if (wordWrap === 'bounded') {
                bareWrappingInfo = {
                    isWordWrapMinified: false,
                    isViewportWrapping: true,
                    wrappingColumn: Math.min(Math.max(1, layoutInfo.viewportColumn), wordWrapColumn)
                };
            }
            else if (wordWrap === 'wordWrapColumn') {
                bareWrappingInfo = {
                    isWordWrapMinified: false,
                    isViewportWrapping: false,
                    wrappingColumn: wordWrapColumn
                };
            }
            else {
                bareWrappingInfo = {
                    isWordWrapMinified: false,
                    isViewportWrapping: false,
                    wrappingColumn: -1
                };
            }
        }
        var wrappingInfo = {
            inDiffEditor: opts.inDiffEditor,
            isDominatedByLongLines: env.isDominatedByLongLines,
            isWordWrapMinified: bareWrappingInfo.isWordWrapMinified,
            isViewportWrapping: bareWrappingInfo.isViewportWrapping,
            wrappingColumn: bareWrappingInfo.wrappingColumn,
            wrappingIndent: opts.wrappingIndent,
            wordWrapBreakBeforeCharacters: opts.wordWrapBreakBeforeCharacters,
            wordWrapBreakAfterCharacters: opts.wordWrapBreakAfterCharacters,
            wordWrapBreakObtrusiveCharacters: opts.wordWrapBreakObtrusiveCharacters,
        };
        var className = 'monaco-editor';
        if (opts.viewInfo.extraEditorClassName) {
            className += ' ' + opts.viewInfo.extraEditorClassName;
        }
        if (env.extraEditorClassName) {
            className += ' ' + env.extraEditorClassName;
        }
        if (opts.viewInfo.fontLigatures) {
            className += ' enable-ligatures';
        }
        if (opts.mouseStyle === 'default') {
            className += ' mouse-default';
        }
        else if (opts.mouseStyle === 'copy') {
            className += ' mouse-copy';
        }
        return new InternalEditorOptions({
            canUseLayerHinting: opts.disableLayerHinting ? false : true,
            pixelRatio: env.pixelRatio,
            editorClassName: className,
            lineHeight: env.fontInfo.lineHeight,
            readOnly: opts.readOnly,
            accessibilitySupport: accessibilitySupport,
            multiCursorModifier: opts.multiCursorModifier,
            multiCursorMergeOverlapping: opts.multiCursorMergeOverlapping,
            wordSeparators: opts.wordSeparators,
            autoClosingBrackets: opts.autoClosingBrackets,
            autoIndent: opts.autoIndent,
            useTabStops: opts.useTabStops,
            tabFocusMode: opts.readOnly ? true : env.tabFocusMode,
            dragAndDrop: opts.dragAndDrop,
            emptySelectionClipboard: opts.emptySelectionClipboard && env.emptySelectionClipboard,
            layoutInfo: layoutInfo,
            fontInfo: env.fontInfo,
            viewInfo: opts.viewInfo,
            wrappingInfo: wrappingInfo,
            contribInfo: opts.contribInfo,
            showUnused: opts.showUnused,
        });
    };
    return InternalEditorOptionsFactory;
}());

/**
 * @internal
 */
var EditorLayoutProvider = /** @class */ (function () {
    function EditorLayoutProvider() {
    }
    EditorLayoutProvider.compute = function (_opts) {
        var outerWidth = _opts.outerWidth | 0;
        var outerHeight = _opts.outerHeight | 0;
        var showGlyphMargin = _opts.showGlyphMargin;
        var lineHeight = _opts.lineHeight | 0;
        var showLineNumbers = _opts.showLineNumbers;
        var lineNumbersMinChars = _opts.lineNumbersMinChars | 0;
        var lineNumbersDigitCount = _opts.lineNumbersDigitCount | 0;
        var lineDecorationsWidth = _opts.lineDecorationsWidth | 0;
        var typicalHalfwidthCharacterWidth = _opts.typicalHalfwidthCharacterWidth;
        var maxDigitWidth = _opts.maxDigitWidth;
        var verticalScrollbarWidth = _opts.verticalScrollbarWidth | 0;
        var verticalScrollbarHasArrows = _opts.verticalScrollbarHasArrows;
        var scrollbarArrowSize = _opts.scrollbarArrowSize | 0;
        var horizontalScrollbarHeight = _opts.horizontalScrollbarHeight | 0;
        var minimap = _opts.minimap;
        var minimapSide = _opts.minimapSide;
        var minimapRenderCharacters = _opts.minimapRenderCharacters;
        var minimapMaxColumn = _opts.minimapMaxColumn | 0;
        var pixelRatio = _opts.pixelRatio;
        var lineNumbersWidth = 0;
        if (showLineNumbers) {
            var digitCount = Math.max(lineNumbersDigitCount, lineNumbersMinChars);
            lineNumbersWidth = Math.round(digitCount * maxDigitWidth);
        }
        var glyphMarginWidth = 0;
        if (showGlyphMargin) {
            glyphMarginWidth = lineHeight;
        }
        var glyphMarginLeft = 0;
        var lineNumbersLeft = glyphMarginLeft + glyphMarginWidth;
        var decorationsLeft = lineNumbersLeft + lineNumbersWidth;
        var contentLeft = decorationsLeft + lineDecorationsWidth;
        var remainingWidth = outerWidth - glyphMarginWidth - lineNumbersWidth - lineDecorationsWidth;
        var renderMinimap;
        var minimapLeft;
        var minimapWidth;
        var contentWidth;
        if (!minimap) {
            minimapLeft = 0;
            minimapWidth = 0;
            renderMinimap = RenderMinimap.None;
            contentWidth = remainingWidth;
        }
        else {
            var minimapCharWidth = void 0;
            if (pixelRatio >= 2) {
                renderMinimap = minimapRenderCharacters ? RenderMinimap.Large : RenderMinimap.LargeBlocks;
                minimapCharWidth = 2 / pixelRatio;
            }
            else {
                renderMinimap = minimapRenderCharacters ? RenderMinimap.Small : RenderMinimap.SmallBlocks;
                minimapCharWidth = 1 / pixelRatio;
            }
            // Given:
            // (leaving 2px for the cursor to have space after the last character)
            // viewportColumn = (contentWidth - verticalScrollbarWidth - 2) / typicalHalfwidthCharacterWidth
            // minimapWidth = viewportColumn * minimapCharWidth
            // contentWidth = remainingWidth - minimapWidth
            // What are good values for contentWidth and minimapWidth ?
            // minimapWidth = ((contentWidth - verticalScrollbarWidth - 2) / typicalHalfwidthCharacterWidth) * minimapCharWidth
            // typicalHalfwidthCharacterWidth * minimapWidth = (contentWidth - verticalScrollbarWidth - 2) * minimapCharWidth
            // typicalHalfwidthCharacterWidth * minimapWidth = (remainingWidth - minimapWidth - verticalScrollbarWidth - 2) * minimapCharWidth
            // (typicalHalfwidthCharacterWidth + minimapCharWidth) * minimapWidth = (remainingWidth - verticalScrollbarWidth - 2) * minimapCharWidth
            // minimapWidth = ((remainingWidth - verticalScrollbarWidth - 2) * minimapCharWidth) / (typicalHalfwidthCharacterWidth + minimapCharWidth)
            minimapWidth = Math.max(0, Math.floor(((remainingWidth - verticalScrollbarWidth - 2) * minimapCharWidth) / (typicalHalfwidthCharacterWidth + minimapCharWidth)));
            var minimapColumns = minimapWidth / minimapCharWidth;
            if (minimapColumns > minimapMaxColumn) {
                minimapWidth = Math.floor(minimapMaxColumn * minimapCharWidth);
            }
            contentWidth = remainingWidth - minimapWidth;
            if (minimapSide === 'left') {
                minimapLeft = 0;
                glyphMarginLeft += minimapWidth;
                lineNumbersLeft += minimapWidth;
                decorationsLeft += minimapWidth;
                contentLeft += minimapWidth;
            }
            else {
                minimapLeft = outerWidth - minimapWidth - verticalScrollbarWidth;
            }
        }
        // (leaving 2px for the cursor to have space after the last character)
        var viewportColumn = Math.max(1, Math.floor((contentWidth - verticalScrollbarWidth - 2) / typicalHalfwidthCharacterWidth));
        var verticalArrowSize = (verticalScrollbarHasArrows ? scrollbarArrowSize : 0);
        return {
            width: outerWidth,
            height: outerHeight,
            glyphMarginLeft: glyphMarginLeft,
            glyphMarginWidth: glyphMarginWidth,
            glyphMarginHeight: outerHeight,
            lineNumbersLeft: lineNumbersLeft,
            lineNumbersWidth: lineNumbersWidth,
            lineNumbersHeight: outerHeight,
            decorationsLeft: decorationsLeft,
            decorationsWidth: lineDecorationsWidth,
            decorationsHeight: outerHeight,
            contentLeft: contentLeft,
            contentWidth: contentWidth,
            contentHeight: outerHeight,
            renderMinimap: renderMinimap,
            minimapLeft: minimapLeft,
            minimapWidth: minimapWidth,
            viewportColumn: viewportColumn,
            verticalScrollbarWidth: verticalScrollbarWidth,
            horizontalScrollbarHeight: horizontalScrollbarHeight,
            overviewRuler: {
                top: verticalArrowSize,
                width: verticalScrollbarWidth,
                height: (outerHeight - 2 * verticalArrowSize),
                right: 0
            }
        };
    };
    return EditorLayoutProvider;
}());

var DEFAULT_WINDOWS_FONT_FAMILY = 'Consolas, \'Courier New\', monospace';
var DEFAULT_MAC_FONT_FAMILY = 'Menlo, Monaco, \'Courier New\', monospace';
var DEFAULT_LINUX_FONT_FAMILY = '\'Droid Sans Mono\', \'monospace\', monospace, \'Droid Sans Fallback\'';
/**
 * @internal
 */
var EDITOR_FONT_DEFAULTS = {
    fontFamily: (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["d" /* isMacintosh */] ? DEFAULT_MAC_FONT_FAMILY : (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["c" /* isLinux */] ? DEFAULT_LINUX_FONT_FAMILY : DEFAULT_WINDOWS_FONT_FAMILY)),
    fontWeight: 'normal',
    fontSize: (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["d" /* isMacintosh */] ? 12 : 14),
    lineHeight: 0,
    letterSpacing: 0,
};
/**
 * @internal
 */
var EDITOR_MODEL_DEFAULTS = {
    tabSize: 4,
    insertSpaces: true,
    detectIndentation: true,
    trimAutoWhitespace: true,
    largeFileOptimizations: true
};
/**
 * @internal
 */
var EDITOR_DEFAULTS = {
    inDiffEditor: false,
    wordSeparators: __WEBPACK_IMPORTED_MODULE_3__model_wordHelper_js__["b" /* USUAL_WORD_SEPARATORS */],
    lineNumbersMinChars: 5,
    lineDecorationsWidth: 10,
    readOnly: false,
    mouseStyle: 'text',
    disableLayerHinting: false,
    automaticLayout: false,
    wordWrap: 'off',
    wordWrapColumn: 80,
    wordWrapMinified: true,
    wrappingIndent: WrappingIndent.Same,
    wordWrapBreakBeforeCharacters: '([{‘“〈《「『【〔（［｛｢£¥＄￡￥+＋',
    wordWrapBreakAfterCharacters: ' \t})]?|&,;¢°′″‰℃、。｡､￠，．：；？！％・･ゝゞヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻ｧｨｩｪｫｬｭｮｯｰ”〉》」』】〕）］｝｣',
    wordWrapBreakObtrusiveCharacters: '.',
    autoClosingBrackets: true,
    autoIndent: true,
    dragAndDrop: true,
    emptySelectionClipboard: true,
    useTabStops: true,
    multiCursorModifier: 'altKey',
    multiCursorMergeOverlapping: true,
    accessibilitySupport: 'auto',
    showUnused: true,
    viewInfo: {
        extraEditorClassName: '',
        disableMonospaceOptimizations: false,
        rulers: [],
        ariaLabel: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorViewAccessibleLabel', "Editor content"),
        renderLineNumbers: 1 /* On */,
        renderCustomLineNumbers: null,
        selectOnLineNumbers: true,
        glyphMargin: true,
        revealHorizontalRightPadding: 30,
        roundedSelection: true,
        overviewRulerLanes: 2,
        overviewRulerBorder: true,
        cursorBlinking: TextEditorCursorBlinkingStyle.Blink,
        mouseWheelZoom: false,
        cursorStyle: TextEditorCursorStyle.Line,
        cursorWidth: 0,
        hideCursorInOverviewRuler: false,
        scrollBeyondLastLine: true,
        scrollBeyondLastColumn: 5,
        smoothScrolling: false,
        stopRenderingLineAfter: 10000,
        renderWhitespace: 'none',
        renderControlCharacters: false,
        fontLigatures: false,
        renderIndentGuides: true,
        highlightActiveIndentGuide: true,
        renderLineHighlight: 'line',
        scrollbar: {
            vertical: __WEBPACK_IMPORTED_MODULE_2__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Auto,
            horizontal: __WEBPACK_IMPORTED_MODULE_2__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Auto,
            arrowSize: 11,
            useShadows: true,
            verticalHasArrows: false,
            horizontalHasArrows: false,
            horizontalScrollbarSize: 10,
            horizontalSliderSize: 10,
            verticalScrollbarSize: 14,
            verticalSliderSize: 14,
            handleMouseWheel: true,
            mouseWheelScrollSensitivity: 1,
        },
        minimap: {
            enabled: true,
            side: 'right',
            showSlider: 'mouseover',
            renderCharacters: true,
            maxColumn: 120
        },
        fixedOverflowWidgets: false,
    },
    contribInfo: {
        selectionClipboard: true,
        hover: {
            enabled: true,
            delay: 300,
            sticky: true
        },
        links: true,
        contextmenu: true,
        quickSuggestions: { other: true, comments: false, strings: false },
        quickSuggestionsDelay: 10,
        parameterHints: true,
        iconsInSuggestions: true,
        formatOnType: false,
        formatOnPaste: false,
        suggestOnTriggerCharacters: true,
        acceptSuggestionOnEnter: 'on',
        acceptSuggestionOnCommitCharacter: true,
        wordBasedSuggestions: true,
        suggestSelection: 'recentlyUsed',
        suggestFontSize: 0,
        suggestLineHeight: 0,
        suggest: {
            filterGraceful: true,
            snippets: 'inline',
            snippetsPreventQuickSuggestions: true
        },
        selectionHighlight: true,
        occurrencesHighlight: true,
        codeLens: true,
        folding: true,
        foldingStrategy: 'auto',
        showFoldingControls: 'mouseover',
        matchBrackets: true,
        find: {
            seedSearchStringFromSelection: true,
            autoFindInSelection: false,
            globalFindClipboard: false
        },
        colorDecorators: true,
        lightbulbEnabled: true,
        codeActionsOnSave: {},
        codeActionsOnSaveTimeout: 750
    },
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KeybindingSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IKeybindingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var KeybindingSource;
(function (KeybindingSource) {
    KeybindingSource[KeybindingSource["Default"] = 1] = "Default";
    KeybindingSource[KeybindingSource["User"] = 2] = "User";
})(KeybindingSource || (KeybindingSource = {}));
var IKeybindingService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('keybindingService');


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setARIAContainer;
/* harmony export (immutable) */ __webpack_exports__["a"] = alert;
/* harmony export (immutable) */ __webpack_exports__["c"] = status;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aria_css__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aria_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__aria_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var ariaContainer;
var alertContainer;
var statusContainer;
function setARIAContainer(parent) {
    ariaContainer = document.createElement('div');
    ariaContainer.className = 'monaco-aria-container';
    alertContainer = document.createElement('div');
    alertContainer.className = 'monaco-alert';
    alertContainer.setAttribute('role', 'alert');
    alertContainer.setAttribute('aria-atomic', 'true');
    ariaContainer.appendChild(alertContainer);
    statusContainer = document.createElement('div');
    statusContainer.className = 'monaco-status';
    statusContainer.setAttribute('role', 'status');
    statusContainer.setAttribute('aria-atomic', 'true');
    ariaContainer.appendChild(statusContainer);
    parent.appendChild(ariaContainer);
}
/**
 * Given the provided message, will make sure that it is read as alert to screen readers.
 */
function alert(msg) {
    insertMessage(alertContainer, msg);
}
/**
 * Given the provided message, will make sure that it is read as status to screen readers.
 */
function status(msg) {
    if (__WEBPACK_IMPORTED_MODULE_2__common_platform_js__["d" /* isMacintosh */]) {
        alert(msg); // VoiceOver does not seem to support status role
    }
    else {
        insertMessage(statusContainer, msg);
    }
}
var repeatedTimes = 0;
var prevText = undefined;
function insertMessage(target, msg) {
    if (!ariaContainer) {
        // console.warn('ARIA support needs a container. Call setARIAContainer() first.');
        return;
    }
    if (prevText === msg) {
        repeatedTimes++;
    }
    else {
        prevText = msg;
        repeatedTimes = 0;
    }
    switch (repeatedTimes) {
        case 0: break;
        case 1:
            msg = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('repeated', "{0} (occurred again)", msg);
            break;
        default:
            msg = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('repeatedNtimes', "{0} (occurred {1} times)", msg, repeatedTimes);
            break;
    }
    __WEBPACK_IMPORTED_MODULE_3__dom_js__["l" /* clearNode */](target);
    target.textContent = msg;
    // See https://www.paciellogroup.com/blog/2012/06/html5-accessibility-chops-aria-rolealert-browser-support/
    target.style.visibility = 'hidden';
    target.style.visibility = 'visible';
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return nativeSep; });
/* harmony export (immutable) */ __webpack_exports__["b"] = dirname;
/* harmony export (immutable) */ __webpack_exports__["a"] = basename;
/* harmony export (immutable) */ __webpack_exports__["c"] = extname;
/* harmony export (immutable) */ __webpack_exports__["h"] = normalize;
/* unused harmony export getRoot */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return join; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isEqualOrParent;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAbsolute;
/* unused harmony export isAbsolute_win32 */
/* unused harmony export isAbsolute_posix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



/**
 * The forward slash path separator.
 */
var sep = '/';
/**
 * The native path separator depending on the OS.
 */
var nativeSep = __WEBPACK_IMPORTED_MODULE_0__platform_js__["g" /* isWindows */] ? '\\' : '/';
/**
 * @returns the directory name of a path.
 */
function dirname(path) {
    var idx = ~path.lastIndexOf('/') || ~path.lastIndexOf('\\');
    if (idx === 0) {
        return '.';
    }
    else if (~idx === 0) {
        return path[0];
    }
    else if (~idx === path.length - 1) {
        return dirname(path.substring(0, path.length - 1));
    }
    else {
        var res = path.substring(0, ~idx);
        if (__WEBPACK_IMPORTED_MODULE_0__platform_js__["g" /* isWindows */] && res[res.length - 1] === ':') {
            res += nativeSep; // make sure drive letters end with backslash
        }
        return res;
    }
}
/**
 * @returns the base name of a path.
 */
function basename(path) {
    var idx = ~path.lastIndexOf('/') || ~path.lastIndexOf('\\');
    if (idx === 0) {
        return path;
    }
    else if (~idx === path.length - 1) {
        return basename(path.substring(0, path.length - 1));
    }
    else {
        return path.substr(~idx + 1);
    }
}
/**
 * @returns `.far` from `boo.far` or the empty string.
 */
function extname(path) {
    path = basename(path);
    var idx = ~path.lastIndexOf('.');
    return idx ? path.substring(~idx) : '';
}
var _posixBadPath = /(\/\.\.?\/)|(\/\.\.?)$|^(\.\.?\/)|(\/\/+)|(\\)/;
var _winBadPath = /(\\\.\.?\\)|(\\\.\.?)$|^(\.\.?\\)|(\\\\+)|(\/)/;
function _isNormal(path, win) {
    return win
        ? !_winBadPath.test(path)
        : !_posixBadPath.test(path);
}
function normalize(path, toOSPath) {
    if (path === null || path === void 0) {
        return path;
    }
    var len = path.length;
    if (len === 0) {
        return '.';
    }
    var wantsBackslash = __WEBPACK_IMPORTED_MODULE_0__platform_js__["g" /* isWindows */] && toOSPath;
    if (_isNormal(path, wantsBackslash)) {
        return path;
    }
    var sep = wantsBackslash ? '\\' : '/';
    var root = getRoot(path, sep);
    // skip the root-portion of the path
    var start = root.length;
    var skip = false;
    var res = '';
    for (var end = root.length; end <= len; end++) {
        // either at the end or at a path-separator character
        if (end === len || path.charCodeAt(end) === 47 /* Slash */ || path.charCodeAt(end) === 92 /* Backslash */) {
            if (streql(path, start, end, '..')) {
                // skip current and remove parent (if there is already something)
                var prev_start = res.lastIndexOf(sep);
                var prev_part = res.slice(prev_start + 1);
                if ((root || prev_part.length > 0) && prev_part !== '..') {
                    res = prev_start === -1 ? '' : res.slice(0, prev_start);
                    skip = true;
                }
            }
            else if (streql(path, start, end, '.') && (root || res || end < len - 1)) {
                // skip current (if there is already something or if there is more to come)
                skip = true;
            }
            if (!skip) {
                var part = path.slice(start, end);
                if (res !== '' && res[res.length - 1] !== sep) {
                    res += sep;
                }
                res += part;
            }
            start = end + 1;
            skip = false;
        }
    }
    return root + res;
}
function streql(value, start, end, other) {
    return start + other.length === end && value.indexOf(other, start) === start;
}
/**
 * Computes the _root_ this path, like `getRoot('c:\files') === c:\`,
 * `getRoot('files:///files/path') === files:///`,
 * or `getRoot('\\server\shares\path') === \\server\shares\`
 */
function getRoot(path, sep) {
    if (sep === void 0) { sep = '/'; }
    if (!path) {
        return '';
    }
    var len = path.length;
    var code = path.charCodeAt(0);
    if (code === 47 /* Slash */ || code === 92 /* Backslash */) {
        code = path.charCodeAt(1);
        if (code === 47 /* Slash */ || code === 92 /* Backslash */) {
            // UNC candidate \\localhost\shares\ddd
            //               ^^^^^^^^^^^^^^^^^^^
            code = path.charCodeAt(2);
            if (code !== 47 /* Slash */ && code !== 92 /* Backslash */) {
                var pos_1 = 3;
                var start = pos_1;
                for (; pos_1 < len; pos_1++) {
                    code = path.charCodeAt(pos_1);
                    if (code === 47 /* Slash */ || code === 92 /* Backslash */) {
                        break;
                    }
                }
                code = path.charCodeAt(pos_1 + 1);
                if (start !== pos_1 && code !== 47 /* Slash */ && code !== 92 /* Backslash */) {
                    pos_1 += 1;
                    for (; pos_1 < len; pos_1++) {
                        code = path.charCodeAt(pos_1);
                        if (code === 47 /* Slash */ || code === 92 /* Backslash */) {
                            return path.slice(0, pos_1 + 1) // consume this separator
                                .replace(/[\\/]/g, sep);
                        }
                    }
                }
            }
        }
        // /user/far
        // ^
        return sep;
    }
    else if ((code >= 65 /* A */ && code <= 90 /* Z */) || (code >= 97 /* a */ && code <= 122 /* z */)) {
        // check for windows drive letter c:\ or c:
        if (path.charCodeAt(1) === 58 /* Colon */) {
            code = path.charCodeAt(2);
            if (code === 47 /* Slash */ || code === 92 /* Backslash */) {
                // C:\fff
                // ^^^
                return path.slice(0, 2) + sep;
            }
            else {
                // C:
                // ^^
                return path.slice(0, 2);
            }
        }
    }
    // check for URI
    // scheme://authority/path
    // ^^^^^^^^^^^^^^^^^^^
    var pos = path.indexOf('://');
    if (pos !== -1) {
        pos += 3; // 3 -> "://".length
        for (; pos < len; pos++) {
            code = path.charCodeAt(pos);
            if (code === 47 /* Slash */ || code === 92 /* Backslash */) {
                return path.slice(0, pos + 1); // consume this separator
            }
        }
    }
    return '';
}
var join = function () {
    // Not using a function with var-args because of how TS compiles
    // them to JS - it would result in 2*n runtime cost instead
    // of 1*n, where n is parts.length.
    var value = '';
    for (var i = 0; i < arguments.length; i++) {
        var part = arguments[i];
        if (i > 0) {
            // add the separater between two parts unless
            // there already is one
            var last = value.charCodeAt(value.length - 1);
            if (last !== 47 /* Slash */ && last !== 92 /* Backslash */) {
                var next = part.charCodeAt(0);
                if (next !== 47 /* Slash */ && next !== 92 /* Backslash */) {
                    value += sep;
                }
            }
        }
        value += part;
    }
    return normalize(value);
};
function isEqualOrParent(path, candidate, ignoreCase, separator) {
    if (separator === void 0) { separator = nativeSep; }
    if (path === candidate) {
        return true;
    }
    if (!path || !candidate) {
        return false;
    }
    if (candidate.length > path.length) {
        return false;
    }
    if (ignoreCase) {
        var beginsWith = Object(__WEBPACK_IMPORTED_MODULE_1__strings_js__["startsWithIgnoreCase"])(path, candidate);
        if (!beginsWith) {
            return false;
        }
        if (candidate.length === path.length) {
            return true; // same path, different casing
        }
        var sepOffset = candidate.length;
        if (candidate.charAt(candidate.length - 1) === separator) {
            sepOffset--; // adjust the expected sep offset in case our candidate already ends in separator character
        }
        return path.charAt(sepOffset) === separator;
    }
    if (candidate.charAt(candidate.length - 1) !== separator) {
        candidate += separator;
    }
    return path.indexOf(candidate) === 0;
}
/**
 * Adapted from Node's path.isAbsolute functions
 */
function isAbsolute(path) {
    return __WEBPACK_IMPORTED_MODULE_0__platform_js__["g" /* isWindows */] ?
        isAbsolute_win32(path) :
        isAbsolute_posix(path);
}
function isAbsolute_win32(path) {
    if (!path) {
        return false;
    }
    var char0 = path.charCodeAt(0);
    if (char0 === 47 /* Slash */ || char0 === 92 /* Backslash */) {
        return true;
    }
    else if ((char0 >= 65 /* A */ && char0 <= 90 /* Z */) || (char0 >= 97 /* a */ && char0 <= 122 /* z */)) {
        if (path.length > 2 && path.charCodeAt(1) === 58 /* Colon */) {
            var char2 = path.charCodeAt(2);
            if (char2 === 47 /* Slash */ || char2 === 92 /* Backslash */) {
                return true;
            }
        }
    }
    return false;
}
function isAbsolute_posix(path) {
    return path && path.charCodeAt(0) === 47 /* Slash */;
}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IConfigurationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigurationTarget; });
/* harmony export (immutable) */ __webpack_exports__["i"] = toValuesTree;
/* harmony export (immutable) */ __webpack_exports__["c"] = addToValueTree;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeFromValueTree;
/* harmony export (immutable) */ __webpack_exports__["e"] = getConfigurationValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = getConfigurationKeys;
/* harmony export (immutable) */ __webpack_exports__["f"] = getDefaultValues;
/* harmony export (immutable) */ __webpack_exports__["g"] = overrideIdentifierFromKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configurationRegistry_js__ = __webpack_require__(81);



var IConfigurationService = Object(__WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__["c" /* createDecorator */])('configurationService');
var ConfigurationTarget;
(function (ConfigurationTarget) {
    ConfigurationTarget[ConfigurationTarget["USER"] = 1] = "USER";
    ConfigurationTarget[ConfigurationTarget["WORKSPACE"] = 2] = "WORKSPACE";
    ConfigurationTarget[ConfigurationTarget["WORKSPACE_FOLDER"] = 3] = "WORKSPACE_FOLDER";
    ConfigurationTarget[ConfigurationTarget["DEFAULT"] = 4] = "DEFAULT";
    ConfigurationTarget[ConfigurationTarget["MEMORY"] = 5] = "MEMORY";
})(ConfigurationTarget || (ConfigurationTarget = {}));
function toValuesTree(properties, conflictReporter) {
    var root = Object.create(null);
    for (var key in properties) {
        addToValueTree(root, key, properties[key], conflictReporter);
    }
    return root;
}
function addToValueTree(settingsTreeRoot, key, value, conflictReporter) {
    var segments = key.split('.');
    var last = segments.pop();
    var curr = settingsTreeRoot;
    for (var i = 0; i < segments.length; i++) {
        var s = segments[i];
        var obj = curr[s];
        switch (typeof obj) {
            case 'undefined':
                obj = curr[s] = Object.create(null);
                break;
            case 'object':
                break;
            default:
                conflictReporter("Ignoring " + key + " as " + segments.slice(0, i + 1).join('.') + " is " + JSON.stringify(obj));
                return;
        }
        curr = obj;
    }
    if (typeof curr === 'object') {
        curr[last] = value; // workaround https://github.com/Microsoft/vscode/issues/13606
    }
    else {
        conflictReporter("Ignoring " + key + " as " + segments.join('.') + " is " + JSON.stringify(curr));
    }
}
function removeFromValueTree(valueTree, key) {
    var segments = key.split('.');
    doRemoveFromValueTree(valueTree, segments);
}
function doRemoveFromValueTree(valueTree, segments) {
    var first = segments.shift();
    if (segments.length === 0) {
        // Reached last segment
        delete valueTree[first];
        return;
    }
    if (Object.keys(valueTree).indexOf(first) !== -1) {
        var value = valueTree[first];
        if (typeof value === 'object' && !Array.isArray(value)) {
            doRemoveFromValueTree(value, segments);
            if (Object.keys(value).length === 0) {
                delete valueTree[first];
            }
        }
    }
}
/**
 * A helper function to get the configuration value with a specific settings path (e.g. config.some.setting)
 */
function getConfigurationValue(config, settingPath, defaultValue) {
    function accessSetting(config, path) {
        var current = config;
        for (var i = 0; i < path.length; i++) {
            if (typeof current !== 'object' || current === null) {
                return undefined;
            }
            current = current[path[i]];
        }
        return current;
    }
    var path = settingPath.split('.');
    var result = accessSetting(config, path);
    return typeof result === 'undefined' ? defaultValue : result;
}
function getConfigurationKeys() {
    var properties = __WEBPACK_IMPORTED_MODULE_0__registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_2__configurationRegistry_js__["b" /* Extensions */].Configuration).getConfigurationProperties();
    return Object.keys(properties);
}
function getDefaultValues() {
    var valueTreeRoot = Object.create(null);
    var properties = __WEBPACK_IMPORTED_MODULE_0__registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_2__configurationRegistry_js__["b" /* Extensions */].Configuration).getConfigurationProperties();
    for (var key in properties) {
        var value = properties[key].default;
        addToValueTree(valueTreeRoot, key, value, function (message) { return console.error("Conflict in default settings: " + message); });
    }
    return valueTreeRoot;
}
function overrideIdentifierFromKey(key) {
    return key.substring(1, key.length - 1);
}


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditOperation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var EditOperation = /** @class */ (function () {
    function EditOperation() {
    }
    EditOperation.insert = function (position, text) {
        return {
            range: new __WEBPACK_IMPORTED_MODULE_0__range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column),
            text: text,
            forceMoveMarkers: true
        };
    };
    EditOperation.delete = function (range) {
        return {
            range: range,
            text: null
        };
    };
    EditOperation.replace = function (range, text) {
        return {
            range: range,
            text: text
        };
    };
    EditOperation.replaceMove = function (range, text) {
        return {
            range: range,
            text: text,
            forceMoveMarkers: true
        };
    };
    return EditOperation;
}());



/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandardKeyboardEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_js__ = __webpack_require__(25);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var KEY_CODE_MAP = new Array(230);
var INVERSE_KEY_CODE_MAP = new Array(112 /* MAX_VALUE */);
(function () {
    for (var i = 0; i < INVERSE_KEY_CODE_MAP.length; i++) {
        INVERSE_KEY_CODE_MAP[i] = -1;
    }
    function define(code, keyCode) {
        KEY_CODE_MAP[code] = keyCode;
        INVERSE_KEY_CODE_MAP[keyCode] = code;
    }
    define(3, 7 /* PauseBreak */); // VK_CANCEL 0x03 Control-break processing
    define(8, 1 /* Backspace */);
    define(9, 2 /* Tab */);
    define(13, 3 /* Enter */);
    define(16, 4 /* Shift */);
    define(17, 5 /* Ctrl */);
    define(18, 6 /* Alt */);
    define(19, 7 /* PauseBreak */);
    define(20, 8 /* CapsLock */);
    define(27, 9 /* Escape */);
    define(32, 10 /* Space */);
    define(33, 11 /* PageUp */);
    define(34, 12 /* PageDown */);
    define(35, 13 /* End */);
    define(36, 14 /* Home */);
    define(37, 15 /* LeftArrow */);
    define(38, 16 /* UpArrow */);
    define(39, 17 /* RightArrow */);
    define(40, 18 /* DownArrow */);
    define(45, 19 /* Insert */);
    define(46, 20 /* Delete */);
    define(48, 21 /* KEY_0 */);
    define(49, 22 /* KEY_1 */);
    define(50, 23 /* KEY_2 */);
    define(51, 24 /* KEY_3 */);
    define(52, 25 /* KEY_4 */);
    define(53, 26 /* KEY_5 */);
    define(54, 27 /* KEY_6 */);
    define(55, 28 /* KEY_7 */);
    define(56, 29 /* KEY_8 */);
    define(57, 30 /* KEY_9 */);
    define(65, 31 /* KEY_A */);
    define(66, 32 /* KEY_B */);
    define(67, 33 /* KEY_C */);
    define(68, 34 /* KEY_D */);
    define(69, 35 /* KEY_E */);
    define(70, 36 /* KEY_F */);
    define(71, 37 /* KEY_G */);
    define(72, 38 /* KEY_H */);
    define(73, 39 /* KEY_I */);
    define(74, 40 /* KEY_J */);
    define(75, 41 /* KEY_K */);
    define(76, 42 /* KEY_L */);
    define(77, 43 /* KEY_M */);
    define(78, 44 /* KEY_N */);
    define(79, 45 /* KEY_O */);
    define(80, 46 /* KEY_P */);
    define(81, 47 /* KEY_Q */);
    define(82, 48 /* KEY_R */);
    define(83, 49 /* KEY_S */);
    define(84, 50 /* KEY_T */);
    define(85, 51 /* KEY_U */);
    define(86, 52 /* KEY_V */);
    define(87, 53 /* KEY_W */);
    define(88, 54 /* KEY_X */);
    define(89, 55 /* KEY_Y */);
    define(90, 56 /* KEY_Z */);
    define(93, 58 /* ContextMenu */);
    define(96, 93 /* NUMPAD_0 */);
    define(97, 94 /* NUMPAD_1 */);
    define(98, 95 /* NUMPAD_2 */);
    define(99, 96 /* NUMPAD_3 */);
    define(100, 97 /* NUMPAD_4 */);
    define(101, 98 /* NUMPAD_5 */);
    define(102, 99 /* NUMPAD_6 */);
    define(103, 100 /* NUMPAD_7 */);
    define(104, 101 /* NUMPAD_8 */);
    define(105, 102 /* NUMPAD_9 */);
    define(106, 103 /* NUMPAD_MULTIPLY */);
    define(107, 104 /* NUMPAD_ADD */);
    define(108, 105 /* NUMPAD_SEPARATOR */);
    define(109, 106 /* NUMPAD_SUBTRACT */);
    define(110, 107 /* NUMPAD_DECIMAL */);
    define(111, 108 /* NUMPAD_DIVIDE */);
    define(112, 59 /* F1 */);
    define(113, 60 /* F2 */);
    define(114, 61 /* F3 */);
    define(115, 62 /* F4 */);
    define(116, 63 /* F5 */);
    define(117, 64 /* F6 */);
    define(118, 65 /* F7 */);
    define(119, 66 /* F8 */);
    define(120, 67 /* F9 */);
    define(121, 68 /* F10 */);
    define(122, 69 /* F11 */);
    define(123, 70 /* F12 */);
    define(124, 71 /* F13 */);
    define(125, 72 /* F14 */);
    define(126, 73 /* F15 */);
    define(127, 74 /* F16 */);
    define(128, 75 /* F17 */);
    define(129, 76 /* F18 */);
    define(130, 77 /* F19 */);
    define(144, 78 /* NumLock */);
    define(145, 79 /* ScrollLock */);
    define(186, 80 /* US_SEMICOLON */);
    define(187, 81 /* US_EQUAL */);
    define(188, 82 /* US_COMMA */);
    define(189, 83 /* US_MINUS */);
    define(190, 84 /* US_DOT */);
    define(191, 85 /* US_SLASH */);
    define(192, 86 /* US_BACKTICK */);
    define(193, 110 /* ABNT_C1 */);
    define(194, 111 /* ABNT_C2 */);
    define(219, 87 /* US_OPEN_SQUARE_BRACKET */);
    define(220, 88 /* US_BACKSLASH */);
    define(221, 89 /* US_CLOSE_SQUARE_BRACKET */);
    define(222, 90 /* US_QUOTE */);
    define(223, 91 /* OEM_8 */);
    define(226, 92 /* OEM_102 */);
    /**
     * https://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
     * If an Input Method Editor is processing key input and the event is keydown, return 229.
     */
    define(229, 109 /* KEY_IN_COMPOSITION */);
    if (__WEBPACK_IMPORTED_MODULE_2__browser_js__["k" /* isIE */]) {
        define(91, 57 /* Meta */);
    }
    else if (__WEBPACK_IMPORTED_MODULE_2__browser_js__["j" /* isFirefox */]) {
        define(59, 80 /* US_SEMICOLON */);
        define(107, 81 /* US_EQUAL */);
        define(109, 83 /* US_MINUS */);
        if (__WEBPACK_IMPORTED_MODULE_1__common_platform_js__["d" /* isMacintosh */]) {
            define(224, 57 /* Meta */);
        }
    }
    else if (__WEBPACK_IMPORTED_MODULE_2__browser_js__["n" /* isWebKit */]) {
        define(91, 57 /* Meta */);
        if (__WEBPACK_IMPORTED_MODULE_1__common_platform_js__["d" /* isMacintosh */]) {
            // the two meta keys in the Mac have different key codes (91 and 93)
            define(93, 57 /* Meta */);
        }
        else {
            define(92, 57 /* Meta */);
        }
    }
})();
function extractKeyCode(e) {
    if (e.charCode) {
        // "keypress" events mostly
        var char = String.fromCharCode(e.charCode).toUpperCase();
        return __WEBPACK_IMPORTED_MODULE_0__common_keyCodes_js__["b" /* KeyCodeUtils */].fromString(char);
    }
    return KEY_CODE_MAP[e.keyCode] || 0 /* Unknown */;
}
var ctrlKeyMod = (__WEBPACK_IMPORTED_MODULE_1__common_platform_js__["d" /* isMacintosh */] ? 256 /* WinCtrl */ : 2048 /* CtrlCmd */);
var altKeyMod = 512 /* Alt */;
var shiftKeyMod = 1024 /* Shift */;
var metaKeyMod = (__WEBPACK_IMPORTED_MODULE_1__common_platform_js__["d" /* isMacintosh */] ? 2048 /* CtrlCmd */ : 256 /* WinCtrl */);
var StandardKeyboardEvent = /** @class */ (function () {
    function StandardKeyboardEvent(source) {
        var e = source;
        this.browserEvent = e;
        this.target = e.target;
        this.ctrlKey = e.ctrlKey;
        this.shiftKey = e.shiftKey;
        this.altKey = e.altKey;
        this.metaKey = e.metaKey;
        this.keyCode = extractKeyCode(e);
        this.code = e.code;
        // console.info(e.type + ": keyCode: " + e.keyCode + ", which: " + e.which + ", charCode: " + e.charCode + ", detail: " + e.detail + " ====> " + this.keyCode + ' -- ' + KeyCode[this.keyCode]);
        this.ctrlKey = this.ctrlKey || this.keyCode === 5 /* Ctrl */;
        this.altKey = this.altKey || this.keyCode === 6 /* Alt */;
        this.shiftKey = this.shiftKey || this.keyCode === 4 /* Shift */;
        this.metaKey = this.metaKey || this.keyCode === 57 /* Meta */;
        this._asKeybinding = this._computeKeybinding();
        this._asRuntimeKeybinding = this._computeRuntimeKeybinding();
        // console.log(`code: ${e.code}, keyCode: ${e.keyCode}, key: ${e.key}`);
    }
    StandardKeyboardEvent.prototype.preventDefault = function () {
        if (this.browserEvent && this.browserEvent.preventDefault) {
            this.browserEvent.preventDefault();
        }
    };
    StandardKeyboardEvent.prototype.stopPropagation = function () {
        if (this.browserEvent && this.browserEvent.stopPropagation) {
            this.browserEvent.stopPropagation();
        }
    };
    StandardKeyboardEvent.prototype.toKeybinding = function () {
        return this._asRuntimeKeybinding;
    };
    StandardKeyboardEvent.prototype.equals = function (other) {
        return this._asKeybinding === other;
    };
    StandardKeyboardEvent.prototype._computeKeybinding = function () {
        var key = 0 /* Unknown */;
        if (this.keyCode !== 5 /* Ctrl */ && this.keyCode !== 4 /* Shift */ && this.keyCode !== 6 /* Alt */ && this.keyCode !== 57 /* Meta */) {
            key = this.keyCode;
        }
        var result = 0;
        if (this.ctrlKey) {
            result |= ctrlKeyMod;
        }
        if (this.altKey) {
            result |= altKeyMod;
        }
        if (this.shiftKey) {
            result |= shiftKeyMod;
        }
        if (this.metaKey) {
            result |= metaKeyMod;
        }
        result |= key;
        return result;
    };
    StandardKeyboardEvent.prototype._computeRuntimeKeybinding = function () {
        var key = 0 /* Unknown */;
        if (this.keyCode !== 5 /* Ctrl */ && this.keyCode !== 4 /* Shift */ && this.keyCode !== 6 /* Alt */ && this.keyCode !== 57 /* Meta */) {
            key = this.keyCode;
        }
        return new __WEBPACK_IMPORTED_MODULE_0__common_keyCodes_js__["e" /* SimpleKeybinding */](this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, key);
    };
    return StandardKeyboardEvent;
}());



/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Builder */
/* unused harmony export MultiBuilder */
/* unused harmony export withElement */
/* unused harmony export setPropertyOnElement */
/* unused harmony export getPropertyFromElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builder_css__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__builder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_assert_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






// --- Implementation starts here
var MS_DATA_KEY = '_msDataKey';
var LISTENER_BINDING_ID = '__$listeners';
var VISIBILITY_BINDING_ID = '__$visibility';
function data(element) {
    if (!element[MS_DATA_KEY]) {
        element[MS_DATA_KEY] = {};
    }
    return element[MS_DATA_KEY];
}
function hasData(element) {
    return !!element[MS_DATA_KEY];
}
/**
 *  Wraps around the provided element to manipulate it and add more child elements.
 */
var Builder = /** @class */ (function () {
    function Builder(element, offdom) {
        this.offdom = offdom;
        this.container = element;
        this.currentElement = element;
        this.createdElements = [];
        this.toDispose = {};
        this.captureToDispose = {};
    }
    /**
     *  Clones the builder providing the same properties as this one.
     */
    Builder.prototype.clone = function () {
        var builder = new Builder(this.container, this.offdom);
        builder.currentElement = this.currentElement;
        builder.createdElements = this.createdElements;
        builder.captureToDispose = this.captureToDispose;
        builder.toDispose = this.toDispose;
        return builder;
    };
    Builder.prototype.build = function (container, index) {
        __WEBPACK_IMPORTED_MODULE_4__common_assert_js__["a" /* ok */](this.offdom, 'This builder was not created off-dom, so build() can not be called.');
        // Use builders own container if present
        if (!container) {
            container = this.container;
        }
        // Handle case of passed in Builder
        else if (container instanceof Builder) {
            container = container.getHTMLElement();
        }
        __WEBPACK_IMPORTED_MODULE_4__common_assert_js__["a" /* ok */](container, 'Builder can only be build() with a container provided.');
        __WEBPACK_IMPORTED_MODULE_4__common_assert_js__["a" /* ok */](__WEBPACK_IMPORTED_MODULE_5__dom_js__["C" /* isHTMLElement */](container), 'The container must either be a HTMLElement or a Builder.');
        var htmlContainer = container;
        // Append
        var i, len;
        var childNodes = htmlContainer.childNodes;
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["f" /* isNumber */](index) && index < childNodes.length) {
            for (i = 0, len = this.createdElements.length; i < len; i++) {
                htmlContainer.insertBefore(this.createdElements[i], childNodes[index++]);
            }
        }
        else {
            for (i = 0, len = this.createdElements.length; i < len; i++) {
                htmlContainer.appendChild(this.createdElements[i]);
            }
        }
        return this;
    };
    Builder.prototype.appendTo = function (container, index) {
        // Use builders own container if present
        if (!container) {
            container = this.container;
        }
        // Handle case of passed in Builder
        else if (container instanceof Builder) {
            container = container.getHTMLElement();
        }
        __WEBPACK_IMPORTED_MODULE_4__common_assert_js__["a" /* ok */](container, 'Builder can only be build() with a container provided.');
        __WEBPACK_IMPORTED_MODULE_4__common_assert_js__["a" /* ok */](__WEBPACK_IMPORTED_MODULE_5__dom_js__["C" /* isHTMLElement */](container), 'The container must either be a HTMLElement or a Builder.');
        var htmlContainer = container;
        // Remove node from parent, if needed
        if (this.currentElement.parentNode) {
            this.currentElement.parentNode.removeChild(this.currentElement);
        }
        var childNodes = htmlContainer.childNodes;
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["f" /* isNumber */](index) && index < childNodes.length) {
            htmlContainer.insertBefore(this.currentElement, childNodes[index]);
        }
        else {
            htmlContainer.appendChild(this.currentElement);
        }
        return this;
    };
    /**
     *  Returns the HTML Element the builder is currently active on.
     */
    Builder.prototype.getHTMLElement = function () {
        return this.currentElement;
    };
    // HTML Elements
    /**
     *  Creates a new element of this kind as child of the current element or parent.
     *  Accepts an object literal as first parameter that can be used to describe the
     *  attributes of the element.
     *  Accepts a function as second parameter that can be used to create child elements
     *  of the element. The function will be called with a new builder created with the
     *  provided element.
     */
    Builder.prototype.div = function (attributes, fn) {
        return this.doElement('div', attributes, fn);
    };
    /**
     *  Creates a new element of given tag name as child of the current element or parent.
     *  Accepts an object literal as first parameter that can be used to describe the
     *  attributes of the element.
     *  Accepts a function as second parameter that can be used to create child elements
     *  of the element. The function will be called with a new builder created with the
     *  provided element.
     */
    Builder.prototype.element = function (name, attributes, fn) {
        return this.doElement(name, attributes, fn);
    };
    Builder.prototype.doElement = function (name, attributesOrFn, fn) {
        // Create Element
        var element = document.createElement(name);
        this.currentElement = element;
        // Off-DOM: Remember in array of created elements
        if (this.offdom) {
            this.createdElements.push(element);
        }
        // Object (apply properties as attributes to HTML element)
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["g" /* isObject */](attributesOrFn)) {
            this.attr(attributesOrFn);
        }
        // Support second argument being function
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["e" /* isFunction */](attributesOrFn)) {
            fn = attributesOrFn;
        }
        // Apply Functions (Elements created in Functions will be added as child to current element)
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["e" /* isFunction */](fn)) {
            var builder = new Builder(element);
            fn.call(builder, builder); // Set both 'this' and the first parameter to the new builder
        }
        // Add to parent
        if (!this.offdom) {
            this.container.appendChild(element);
        }
        return this;
    };
    /**
     *  Calls blur() on the current HTML element;
     */
    Builder.prototype.domBlur = function () {
        this.currentElement.blur();
        return this;
    };
    Builder.prototype.on = function (arg1, fn, listenerToDisposeContainer, useCapture) {
        var _this = this;
        // Event Type Array
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](arg1)) {
            arg1.forEach(function (type) {
                _this.on(type, fn, listenerToDisposeContainer, useCapture);
            });
        }
        // Single Event Type
        else {
            var type = arg1;
            // Add Listener
            var unbind_1 = __WEBPACK_IMPORTED_MODULE_5__dom_js__["g" /* addDisposableListener */](this.currentElement, type, function (e) {
                fn(e, _this, unbind_1); // Pass in Builder as Second Argument
            }, useCapture || false);
            // Remember for off() use
            if (useCapture) {
                if (!this.captureToDispose[type]) {
                    this.captureToDispose[type] = [];
                }
                this.captureToDispose[type].push(unbind_1);
            }
            else {
                if (!this.toDispose[type]) {
                    this.toDispose[type] = [];
                }
                this.toDispose[type].push(unbind_1);
            }
            // Bind to Element
            var listenerBinding = this.getProperty(LISTENER_BINDING_ID, []);
            listenerBinding.push(unbind_1);
            this.setProperty(LISTENER_BINDING_ID, listenerBinding);
            // Add to Array if passed in
            if (listenerToDisposeContainer && __WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](listenerToDisposeContainer)) {
                listenerToDisposeContainer.push(unbind_1);
            }
        }
        return this;
    };
    Builder.prototype.off = function (arg1, useCapture) {
        var _this = this;
        // Event Type Array
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](arg1)) {
            arg1.forEach(function (type) {
                _this.off(type);
            });
        }
        // Single Event Type
        else {
            var type = arg1;
            if (useCapture) {
                if (this.captureToDispose[type]) {
                    this.captureToDispose[type] = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.captureToDispose[type]);
                }
            }
            else {
                if (this.toDispose[type]) {
                    this.toDispose[type] = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.toDispose[type]);
                }
            }
        }
        return this;
    };
    Builder.prototype.attr = function (firstP, secondP) {
        // Apply Object Literal to Attributes of Element
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["g" /* isObject */](firstP)) {
            for (var prop in firstP) {
                if (firstP.hasOwnProperty(prop)) {
                    var value = firstP[prop];
                    this.doSetAttr(prop, value);
                }
            }
            return this;
        }
        // Get Attribute Value
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["h" /* isString */](firstP) && !__WEBPACK_IMPORTED_MODULE_1__common_types_js__["h" /* isString */](secondP)) {
            return this.currentElement.getAttribute(firstP);
        }
        // Set Attribute Value
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["h" /* isString */](firstP)) {
            if (!__WEBPACK_IMPORTED_MODULE_1__common_types_js__["h" /* isString */](secondP)) {
                secondP = String(secondP);
            }
            this.doSetAttr(firstP, secondP);
        }
        return this;
    };
    Builder.prototype.doSetAttr = function (prop, value) {
        if (prop === 'class') {
            prop = 'addClass'; // Workaround for the issue that a function name can not be 'class' in ES
        }
        if (this[prop]) {
            if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](value)) {
                this[prop].apply(this, value);
            }
            else {
                this[prop].call(this, value);
            }
        }
        else {
            this.currentElement.setAttribute(prop, value);
        }
    };
    Builder.prototype.style = function (firstP, secondP) {
        // Apply Object Literal to Styles of Element
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["g" /* isObject */](firstP)) {
            for (var prop in firstP) {
                if (firstP.hasOwnProperty(prop)) {
                    var value = firstP[prop];
                    this.doSetStyle(prop, value);
                }
            }
            return this;
        }
        var hasFirstP = __WEBPACK_IMPORTED_MODULE_1__common_types_js__["h" /* isString */](firstP);
        // Get Style Value
        if (hasFirstP && __WEBPACK_IMPORTED_MODULE_1__common_types_js__["i" /* isUndefined */](secondP)) {
            return this.currentElement.style[this.cssKeyToJavaScriptProperty(firstP)];
        }
        // Set Style Value
        else if (hasFirstP) {
            this.doSetStyle(firstP, secondP);
        }
        return this;
    };
    Builder.prototype.doSetStyle = function (key, value) {
        if (key.indexOf('-') >= 0) {
            var segments = key.split('-');
            key = segments[0];
            for (var i = 1; i < segments.length; i++) {
                var segment = segments[i];
                key = key + segment.charAt(0).toUpperCase() + segment.substr(1);
            }
        }
        this.currentElement.style[this.cssKeyToJavaScriptProperty(key)] = value;
    };
    Builder.prototype.cssKeyToJavaScriptProperty = function (key) {
        // Automagically convert dashes as they are not allowed when programmatically
        // setting a CSS style property
        if (key.indexOf('-') >= 0) {
            var segments = key.split('-');
            key = segments[0];
            for (var i = 1; i < segments.length; i++) {
                var segment = segments[i];
                key = key + segment.charAt(0).toUpperCase() + segment.substr(1);
            }
        }
        // Float is special too
        else if (key === 'float') {
            key = 'cssFloat';
        }
        return key;
    };
    /**
     *  Adds the variable list of arguments as class names to the current HTML element of the builder.
     */
    Builder.prototype.addClass = function () {
        var _this = this;
        var classes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classes[_i] = arguments[_i];
        }
        classes.forEach(function (nameValue) {
            var names = nameValue.split(' ');
            names.forEach(function (name) {
                __WEBPACK_IMPORTED_MODULE_5__dom_js__["f" /* addClass */](_this.currentElement, name);
            });
        });
        return this;
    };
    /**
     *  Sets the class name of the current HTML element of the builder to the provided className.
     *  If shouldAddClass is provided - for true class is added, for false class is removed.
     */
    Builder.prototype.setClass = function (className, shouldAddClass) {
        if (shouldAddClass === void 0) { shouldAddClass = null; }
        if (shouldAddClass === null) {
            this.currentElement.className = className;
        }
        else if (shouldAddClass) {
            this.addClass(className);
        }
        else {
            this.removeClass(className);
        }
        return this;
    };
    /**
     *  Returns whether the current HTML element of the builder has the provided class assigned.
     */
    Builder.prototype.hasClass = function (className) {
        return __WEBPACK_IMPORTED_MODULE_5__dom_js__["z" /* hasClass */](this.currentElement, className);
    };
    /**
     *  Removes the variable list of arguments as class names from the current HTML element of the builder.
     */
    Builder.prototype.removeClass = function () {
        var _this = this;
        var classes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classes[_i] = arguments[_i];
        }
        classes.forEach(function (nameValue) {
            var names = nameValue.split(' ');
            names.forEach(function (name) {
                __WEBPACK_IMPORTED_MODULE_5__dom_js__["G" /* removeClass */](_this.currentElement, name);
            });
        });
        return this;
    };
    /**
     *  Shows the current element of the builder.
     */
    Builder.prototype.show = function () {
        if (this.hasClass('monaco-builder-hidden')) {
            this.removeClass('monaco-builder-hidden');
        }
        this.attr('aria-hidden', 'false');
        // Cancel any pending showDelayed() invocation
        this.cancelVisibilityTimeout();
        return this;
    };
    /**
     *  Hides the current element of the builder.
     */
    Builder.prototype.hide = function () {
        if (!this.hasClass('monaco-builder-hidden')) {
            this.addClass('monaco-builder-hidden');
        }
        this.attr('aria-hidden', 'true');
        // Cancel any pending showDelayed() invocation
        this.cancelVisibilityTimeout();
        return this;
    };
    Builder.prototype.cancelVisibilityTimeout = function () {
        var visibilityDisposable = this.getProperty(VISIBILITY_BINDING_ID);
        if (visibilityDisposable) {
            visibilityDisposable.dispose();
            this.removeProperty(VISIBILITY_BINDING_ID);
        }
    };
    /**
     *  Sets the innerHTML attribute.
     */
    Builder.prototype.innerHtml = function (html, append) {
        if (append) {
            this.currentElement.innerHTML += html;
        }
        else {
            this.currentElement.innerHTML = html;
        }
        return this;
    };
    /**
     *  Sets the textContent property of the element.
     *  All HTML special characters will be escaped.
     */
    Builder.prototype.text = function (text, append) {
        if (append) {
            // children is child Elements versus childNodes includes textNodes
            if (this.currentElement.children.length === 0) {
                this.currentElement.textContent += text;
            }
            else {
                // if there are elements inside this node, append the string as a new text node
                // to avoid wiping out the innerHTML and replacing it with only text content
                this.currentElement.appendChild(document.createTextNode(text));
            }
        }
        else {
            this.currentElement.textContent = text;
        }
        return this;
    };
    /**
     *  Sets the innerHTML attribute in escaped form.
     */
    Builder.prototype.safeInnerHtml = function (html, append) {
        return this.innerHtml(__WEBPACK_IMPORTED_MODULE_3__common_strings_js__["escape"](html), append);
    };
    /**
     *  Allows to store arbritary data into the current element.
     */
    Builder.prototype.setProperty = function (key, value) {
        setPropertyOnElement(this.currentElement, key, value);
        return this;
    };
    /**
     *  Allows to get arbritary data from the current element.
     */
    Builder.prototype.getProperty = function (key, fallback) {
        return getPropertyFromElement(this.currentElement, key, fallback);
    };
    /**
     *  Removes a property from the current element that is stored under the given key.
     */
    Builder.prototype.removeProperty = function (key) {
        if (hasData(this.currentElement)) {
            delete data(this.currentElement)[key];
        }
        return this;
    };
    /**
     * Recurse through all descendant nodes and remove their data binding.
     */
    Builder.prototype.unbindDescendants = function (current) {
        if (current && current.children) {
            for (var i = 0, length_1 = current.children.length; i < length_1; i++) {
                var element = current.children.item(i);
                // Unbind
                if (hasData(element)) {
                    // Listeners
                    var listeners = data(element)[LISTENER_BINDING_ID];
                    if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](listeners)) {
                        while (listeners.length) {
                            listeners.pop().dispose();
                        }
                    }
                    // Delete Data Slot
                    delete element[MS_DATA_KEY];
                }
                // Recurse
                this.unbindDescendants(element);
            }
        }
    };
    /**
     *  Removes all HTML elements from the current element of the builder. Will also clean up any
     *  event listners registered and also clear any data binding and properties stored
     *  to any child element.
     */
    Builder.prototype.empty = function () {
        this.unbindDescendants(this.currentElement);
        this.clearChildren();
        if (this.offdom) {
            this.createdElements = [];
        }
        return this;
    };
    /**
     *  Removes all HTML elements from the current element of the builder.
     */
    Builder.prototype.clearChildren = function () {
        // Remove Elements
        if (this.currentElement) {
            __WEBPACK_IMPORTED_MODULE_5__dom_js__["l" /* clearNode */](this.currentElement);
        }
        return this;
    };
    /**
     *  Removes the current HTML element and all its children from its parent and unbinds
     *  all listeners and properties set to the data slots.
     */
    Builder.prototype.destroy = function () {
        if (this.currentElement) {
            // Remove from parent
            if (this.currentElement.parentNode) {
                this.currentElement.parentNode.removeChild(this.currentElement);
            }
            // Empty to clear listeners and bindings from children
            this.empty();
            // Unbind
            if (hasData(this.currentElement)) {
                // Listeners
                var listeners = data(this.currentElement)[LISTENER_BINDING_ID];
                if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](listeners)) {
                    while (listeners.length) {
                        listeners.pop().dispose();
                    }
                }
                // Delete Data Slot
                delete this.currentElement[MS_DATA_KEY];
            }
        }
        var type;
        for (type in this.toDispose) {
            if (this.toDispose.hasOwnProperty(type) && __WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](this.toDispose[type])) {
                this.toDispose[type] = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.toDispose[type]);
            }
        }
        for (type in this.captureToDispose) {
            if (this.captureToDispose.hasOwnProperty(type) && __WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](this.captureToDispose[type])) {
                this.captureToDispose[type] = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.captureToDispose[type]);
            }
        }
        // Nullify fields
        this.currentElement = null;
        this.container = null;
        this.offdom = null;
        this.createdElements = null;
        this.captureToDispose = null;
        this.toDispose = null;
    };
    /**
     *  Removes the current HTML element and all its children from its parent and unbinds
     *  all listeners and properties set to the data slots.
     */
    Builder.prototype.dispose = function () {
        this.destroy();
    };
    /**
     *  Gets the size (in pixels) of an element, including the margin.
     */
    Builder.prototype.getTotalSize = function () {
        var totalWidth = __WEBPACK_IMPORTED_MODULE_5__dom_js__["y" /* getTotalWidth */](this.currentElement);
        var totalHeight = __WEBPACK_IMPORTED_MODULE_5__dom_js__["x" /* getTotalHeight */](this.currentElement);
        return new __WEBPACK_IMPORTED_MODULE_5__dom_js__["b" /* Dimension */](totalWidth, totalHeight);
    };
    /**
     *  Another variant of getting the inner dimensions of an element.
     */
    Builder.prototype.getClientArea = function () {
        return __WEBPACK_IMPORTED_MODULE_5__dom_js__["q" /* getClientArea */](this.currentElement);
    };
    return Builder;
}());

/**
 *  The multi builder provides the same methods as the builder, but allows to call
 *  them on an array of builders.
 */
var MultiBuilder = /** @class */ (function (_super) {
    __extends(MultiBuilder, _super);
    function MultiBuilder(builders) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4__common_assert_js__["a" /* ok */](__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](builders) || builders instanceof MultiBuilder, 'Expected Array or MultiBuilder as parameter');
        _this = _super.call(this) || this;
        _this.length = 0;
        _this.builders = [];
        // Add Builders to Array
        if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](builders)) {
            for (var i = 0; i < builders.length; i++) {
                if (builders[i] instanceof HTMLElement) {
                    _this.push(withElement(builders[i]));
                }
                else {
                    _this.push(builders[i]);
                }
            }
        }
        else {
            for (var i = 0; i < builders.length; i++) {
                _this.push(builders.item(i));
            }
        }
        // Mixin Builder functions to operate on all builders
        var $outer = _this;
        var propertyFn = function (prop) {
            $outer[prop] = function () {
                var args = Array.prototype.slice.call(arguments);
                var returnValues;
                var mergeBuilders = false;
                for (var i = 0; i < $outer.length; i++) {
                    var res = $outer.item(i)[prop].apply($outer.item(i), args);
                    // Merge MultiBuilders into one
                    if (res instanceof MultiBuilder) {
                        if (!returnValues) {
                            returnValues = [];
                        }
                        mergeBuilders = true;
                        for (var j = 0; j < res.length; j++) {
                            returnValues.push(res.item(j));
                        }
                    }
                    // Any other Return Type (e.g. boolean, integer)
                    else if (!__WEBPACK_IMPORTED_MODULE_1__common_types_js__["i" /* isUndefined */](res) && !(res instanceof Builder)) {
                        if (!returnValues) {
                            returnValues = [];
                        }
                        returnValues.push(res);
                    }
                }
                if (returnValues && mergeBuilders) {
                    return new MultiBuilder(returnValues);
                }
                return returnValues || $outer;
            };
        };
        for (var prop in Builder.prototype) {
            if (prop !== 'clone' && prop !== 'and') { // Skip methods that are explicitly defined in MultiBuilder
                if (Builder.prototype.hasOwnProperty(prop) && __WEBPACK_IMPORTED_MODULE_1__common_types_js__["e" /* isFunction */](Builder.prototype[prop])) {
                    propertyFn(prop);
                }
            }
        }
        return _this;
    }
    MultiBuilder.prototype.item = function (i) {
        return this.builders[i];
    };
    MultiBuilder.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        for (var i = 0; i < items.length; i++) {
            this.builders.push(items[i]);
        }
        this.length = this.builders.length;
    };
    MultiBuilder.prototype.clone = function () {
        return new MultiBuilder(this);
    };
    return MultiBuilder;
}(Builder));

function withBuilder(builder, offdom) {
    if (builder instanceof MultiBuilder) {
        return new MultiBuilder(builder);
    }
    return new Builder(builder.getHTMLElement(), offdom);
}
function withElement(element, offdom) {
    return new Builder(element, offdom);
}
function offDOM() {
    return new Builder(null, true);
}
// Binding functions
/**
 *  Allows to store arbritary data into element.
 */
function setPropertyOnElement(element, key, value) {
    data(element)[key] = value;
}
/**
 *  Allows to get arbritary data from element.
 */
function getPropertyFromElement(element, key, fallback) {
    if (hasData(element)) {
        var value = data(element)[key];
        if (!__WEBPACK_IMPORTED_MODULE_1__common_types_js__["i" /* isUndefined */](value)) {
            return value;
        }
    }
    return fallback;
}
var SELECTOR_REGEX = /([\w\-]+)?(#([\w\-]+))?((.([\w\-]+))*)/;
var $ = function (arg) {
    // Off-DOM use
    if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["i" /* isUndefined */](arg)) {
        return offDOM();
    }
    // Falsified values cause error otherwise
    if (!arg) {
        throw new Error('Bad use of $');
    }
    // Wrap the given element
    if (__WEBPACK_IMPORTED_MODULE_5__dom_js__["C" /* isHTMLElement */](arg) || arg === window) {
        return withElement(arg);
    }
    // Wrap the given builders
    if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["b" /* isArray */](arg)) {
        return new MultiBuilder(arg);
    }
    // Wrap the given builder
    if (arg instanceof Builder) {
        return withBuilder(arg);
    }
    if (__WEBPACK_IMPORTED_MODULE_1__common_types_js__["h" /* isString */](arg)) {
        // Use the argument as HTML code
        if (arg[0] === '<') {
            var element = void 0;
            var container = document.createElement('div');
            container.innerHTML = __WEBPACK_IMPORTED_MODULE_3__common_strings_js__["format"].apply(__WEBPACK_IMPORTED_MODULE_3__common_strings_js__, arguments);
            if (container.children.length === 0) {
                throw new Error('Bad use of $');
            }
            if (container.children.length === 1) {
                element = container.firstChild;
                container.removeChild(element);
                return withElement(element);
            }
            var builders = [];
            while (container.firstChild) {
                element = container.firstChild;
                container.removeChild(element);
                builders.push(withElement(element));
            }
            return new MultiBuilder(builders);
        }
        // Use the argument as a selector constructor
        else if (arguments.length === 1) {
            var match = SELECTOR_REGEX.exec(arg);
            if (!match) {
                throw new Error('Bad use of $');
            }
            var tag = match[1] || 'div';
            var id = match[3] || undefined;
            var classes = (match[4] || '').replace(/\./g, ' ');
            var props = {};
            if (id) {
                props['id'] = id;
            }
            if (classes) {
                props['class'] = classes;
            }
            return offDOM().element(tag, props);
        }
        // Use the arguments as the arguments to Builder#element(...)
        else {
            var result = offDOM();
            result.element.apply(result, arguments);
            return result;
        }
    }
    else {
        throw new Error('Bad use of $');
    }
};


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CursorChangeReason; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Describes the reason the cursor has changed its position.
 */
var CursorChangeReason;
(function (CursorChangeReason) {
    /**
     * Unknown or not set.
     */
    CursorChangeReason[CursorChangeReason["NotSet"] = 0] = "NotSet";
    /**
     * A `model.setValue()` was called.
     */
    CursorChangeReason[CursorChangeReason["ContentFlush"] = 1] = "ContentFlush";
    /**
     * The `model` has been changed outside of this cursor and the cursor recovers its position from associated markers.
     */
    CursorChangeReason[CursorChangeReason["RecoverFromMarkers"] = 2] = "RecoverFromMarkers";
    /**
     * There was an explicit user gesture.
     */
    CursorChangeReason[CursorChangeReason["Explicit"] = 3] = "Explicit";
    /**
     * There was a Paste.
     */
    CursorChangeReason[CursorChangeReason["Paste"] = 4] = "Paste";
    /**
     * There was an Undo.
     */
    CursorChangeReason[CursorChangeReason["Undo"] = 5] = "Undo";
    /**
     * There was a Redo.
     */
    CursorChangeReason[CursorChangeReason["Redo"] = 6] = "Redo";
})(CursorChangeReason || (CursorChangeReason = {}));


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MouseWheelClassifier */
/* unused harmony export AbstractScrollableElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScrollableElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SmoothScrollableElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DomScrollableElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_scrollbars_css__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_scrollbars_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__media_scrollbars_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__horizontalScrollbar_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__verticalScrollbar_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var HIDE_TIMEOUT = 500;
var SCROLL_WHEEL_SENSITIVITY = 50;
var SCROLL_WHEEL_SMOOTH_SCROLL_ENABLED = true;
var MouseWheelClassifierItem = /** @class */ (function () {
    function MouseWheelClassifierItem(timestamp, deltaX, deltaY) {
        this.timestamp = timestamp;
        this.deltaX = deltaX;
        this.deltaY = deltaY;
        this.score = 0;
    }
    return MouseWheelClassifierItem;
}());
var MouseWheelClassifier = /** @class */ (function () {
    function MouseWheelClassifier() {
        this._capacity = 5;
        this._memory = [];
        this._front = -1;
        this._rear = -1;
    }
    MouseWheelClassifier.prototype.isPhysicalMouseWheel = function () {
        if (this._front === -1 && this._rear === -1) {
            // no elements
            return false;
        }
        // 0.5 * last + 0.25 * before last + 0.125 * before before last + ...
        var remainingInfluence = 1;
        var score = 0;
        var iteration = 1;
        var index = this._rear;
        do {
            var influence = (index === this._front ? remainingInfluence : Math.pow(2, -iteration));
            remainingInfluence -= influence;
            score += this._memory[index].score * influence;
            if (index === this._front) {
                break;
            }
            index = (this._capacity + index - 1) % this._capacity;
            iteration++;
        } while (true);
        return (score <= 0.5);
    };
    MouseWheelClassifier.prototype.accept = function (timestamp, deltaX, deltaY) {
        var item = new MouseWheelClassifierItem(timestamp, deltaX, deltaY);
        item.score = this._computeScore(item);
        if (this._front === -1 && this._rear === -1) {
            this._memory[0] = item;
            this._front = 0;
            this._rear = 0;
        }
        else {
            this._rear = (this._rear + 1) % this._capacity;
            if (this._rear === this._front) {
                // Drop oldest
                this._front = (this._front + 1) % this._capacity;
            }
            this._memory[this._rear] = item;
        }
    };
    /**
     * A score between 0 and 1 for `item`.
     *  - a score towards 0 indicates that the source appears to be a physical mouse wheel
     *  - a score towards 1 indicates that the source appears to be a touchpad or magic mouse, etc.
     */
    MouseWheelClassifier.prototype._computeScore = function (item) {
        if (Math.abs(item.deltaX) > 0 && Math.abs(item.deltaY) > 0) {
            // both axes exercised => definitely not a physical mouse wheel
            return 1;
        }
        var score = 0.5;
        var prev = (this._front === -1 && this._rear === -1 ? null : this._memory[this._rear]);
        if (prev) {
            // const deltaT = item.timestamp - prev.timestamp;
            // if (deltaT < 1000 / 30) {
            // 	// sooner than X times per second => indicator that this is not a physical mouse wheel
            // 	score += 0.25;
            // }
            // if (item.deltaX === prev.deltaX && item.deltaY === prev.deltaY) {
            // 	// equal amplitude => indicator that this is a physical mouse wheel
            // 	score -= 0.25;
            // }
        }
        if (Math.abs(item.deltaX - Math.round(item.deltaX)) > 0 || Math.abs(item.deltaY - Math.round(item.deltaY)) > 0) {
            // non-integer deltas => indicator that this is not a physical mouse wheel
            score += 0.25;
        }
        return Math.min(Math.max(score, 0), 1);
    };
    MouseWheelClassifier.INSTANCE = new MouseWheelClassifier();
    return MouseWheelClassifier;
}());

var AbstractScrollableElement = /** @class */ (function (_super) {
    __extends(AbstractScrollableElement, _super);
    function AbstractScrollableElement(element, options, scrollable) {
        var _this = _super.call(this) || this;
        _this._onScroll = _this._register(new __WEBPACK_IMPORTED_MODULE_11__common_event_js__["a" /* Emitter */]());
        _this.onScroll = _this._onScroll.event;
        element.style.overflow = 'hidden';
        _this._options = resolveOptions(options);
        _this._scrollable = scrollable;
        _this._register(_this._scrollable.onScroll(function (e) {
            _this._onDidScroll(e);
            _this._onScroll.fire(e);
        }));
        var scrollbarHost = {
            onMouseWheel: function (mouseWheelEvent) { return _this._onMouseWheel(mouseWheelEvent); },
            onDragStart: function () { return _this._onDragStart(); },
            onDragEnd: function () { return _this._onDragEnd(); },
        };
        _this._verticalScrollbar = _this._register(new __WEBPACK_IMPORTED_MODULE_5__verticalScrollbar_js__["a" /* VerticalScrollbar */](_this._scrollable, _this._options, scrollbarHost));
        _this._horizontalScrollbar = _this._register(new __WEBPACK_IMPORTED_MODULE_4__horizontalScrollbar_js__["a" /* HorizontalScrollbar */](_this._scrollable, _this._options, scrollbarHost));
        _this._domNode = document.createElement('div');
        _this._domNode.className = 'monaco-scrollable-element ' + _this._options.className;
        _this._domNode.setAttribute('role', 'presentation');
        _this._domNode.style.position = 'relative';
        _this._domNode.style.overflow = 'hidden';
        _this._domNode.appendChild(element);
        _this._domNode.appendChild(_this._horizontalScrollbar.domNode.domNode);
        _this._domNode.appendChild(_this._verticalScrollbar.domNode.domNode);
        if (_this._options.useShadows) {
            _this._leftShadowDomNode = Object(__WEBPACK_IMPORTED_MODULE_10__fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
            _this._leftShadowDomNode.setClassName('shadow');
            _this._domNode.appendChild(_this._leftShadowDomNode.domNode);
            _this._topShadowDomNode = Object(__WEBPACK_IMPORTED_MODULE_10__fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
            _this._topShadowDomNode.setClassName('shadow');
            _this._domNode.appendChild(_this._topShadowDomNode.domNode);
            _this._topLeftShadowDomNode = Object(__WEBPACK_IMPORTED_MODULE_10__fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
            _this._topLeftShadowDomNode.setClassName('shadow top-left-corner');
            _this._domNode.appendChild(_this._topLeftShadowDomNode.domNode);
        }
        _this._listenOnDomNode = _this._options.listenOnDomNode || _this._domNode;
        _this._mouseWheelToDispose = [];
        _this._setListeningToMouseWheel(_this._options.handleMouseWheel);
        _this.onmouseover(_this._listenOnDomNode, function (e) { return _this._onMouseOver(e); });
        _this.onnonbubblingmouseout(_this._listenOnDomNode, function (e) { return _this._onMouseOut(e); });
        _this._hideTimeout = _this._register(new __WEBPACK_IMPORTED_MODULE_9__common_async_js__["f" /* TimeoutTimer */]());
        _this._isDragging = false;
        _this._mouseIsOver = false;
        _this._shouldRender = true;
        _this._revealOnScroll = true;
        return _this;
    }
    AbstractScrollableElement.prototype.dispose = function () {
        this._mouseWheelToDispose = Object(__WEBPACK_IMPORTED_MODULE_6__common_lifecycle_js__["d" /* dispose */])(this._mouseWheelToDispose);
        _super.prototype.dispose.call(this);
    };
    /**
     * Get the generated 'scrollable' dom node
     */
    AbstractScrollableElement.prototype.getDomNode = function () {
        return this._domNode;
    };
    AbstractScrollableElement.prototype.getOverviewRulerLayoutInfo = function () {
        return {
            parent: this._domNode,
            insertBefore: this._verticalScrollbar.domNode.domNode,
        };
    };
    /**
     * Delegate a mouse down event to the vertical scrollbar.
     * This is to help with clicking somewhere else and having the scrollbar react.
     */
    AbstractScrollableElement.prototype.delegateVerticalScrollbarMouseDown = function (browserEvent) {
        this._verticalScrollbar.delegateMouseDown(browserEvent);
    };
    AbstractScrollableElement.prototype.getScrollDimensions = function () {
        return this._scrollable.getScrollDimensions();
    };
    AbstractScrollableElement.prototype.setScrollDimensions = function (dimensions) {
        this._scrollable.setScrollDimensions(dimensions);
    };
    /**
     * Update the class name of the scrollable element.
     */
    AbstractScrollableElement.prototype.updateClassName = function (newClassName) {
        this._options.className = newClassName;
        // Defaults are different on Macs
        if (__WEBPACK_IMPORTED_MODULE_2__common_platform_js__["d" /* isMacintosh */]) {
            this._options.className += ' mac';
        }
        this._domNode.className = 'monaco-scrollable-element ' + this._options.className;
    };
    /**
     * Update configuration options for the scrollbar.
     * Really this is Editor.IEditorScrollbarOptions, but base shouldn't
     * depend on Editor.
     */
    AbstractScrollableElement.prototype.updateOptions = function (newOptions) {
        var massagedOptions = resolveOptions(newOptions);
        this._options.handleMouseWheel = massagedOptions.handleMouseWheel;
        this._options.mouseWheelScrollSensitivity = massagedOptions.mouseWheelScrollSensitivity;
        this._setListeningToMouseWheel(this._options.handleMouseWheel);
        if (!this._options.lazyRender) {
            this._render();
        }
    };
    // -------------------- mouse wheel scrolling --------------------
    AbstractScrollableElement.prototype._setListeningToMouseWheel = function (shouldListen) {
        var _this = this;
        var isListening = (this._mouseWheelToDispose.length > 0);
        if (isListening === shouldListen) {
            // No change
            return;
        }
        // Stop listening (if necessary)
        this._mouseWheelToDispose = Object(__WEBPACK_IMPORTED_MODULE_6__common_lifecycle_js__["d" /* dispose */])(this._mouseWheelToDispose);
        // Start listening (if necessary)
        if (shouldListen) {
            var onMouseWheel = function (browserEvent) {
                var e = new __WEBPACK_IMPORTED_MODULE_3__mouseEvent_js__["c" /* StandardMouseWheelEvent */](browserEvent);
                _this._onMouseWheel(e);
            };
            this._mouseWheelToDispose.push(__WEBPACK_IMPORTED_MODULE_1__dom_js__["g" /* addDisposableListener */](this._listenOnDomNode, 'mousewheel', onMouseWheel));
            this._mouseWheelToDispose.push(__WEBPACK_IMPORTED_MODULE_1__dom_js__["g" /* addDisposableListener */](this._listenOnDomNode, 'DOMMouseScroll', onMouseWheel));
        }
    };
    AbstractScrollableElement.prototype._onMouseWheel = function (e) {
        var _a;
        var classifier = MouseWheelClassifier.INSTANCE;
        if (SCROLL_WHEEL_SMOOTH_SCROLL_ENABLED) {
            classifier.accept(Date.now(), e.deltaX, e.deltaY);
        }
        // console.log(`${Date.now()}, ${e.deltaY}, ${e.deltaX}`);
        if (e.deltaY || e.deltaX) {
            var deltaY = e.deltaY * this._options.mouseWheelScrollSensitivity;
            var deltaX = e.deltaX * this._options.mouseWheelScrollSensitivity;
            if (this._options.flipAxes) {
                _a = [deltaX, deltaY], deltaY = _a[0], deltaX = _a[1];
            }
            // Convert vertical scrolling to horizontal if shift is held, this
            // is handled at a higher level on Mac
            var shiftConvert = !__WEBPACK_IMPORTED_MODULE_2__common_platform_js__["d" /* isMacintosh */] && e.browserEvent && e.browserEvent.shiftKey;
            if ((this._options.scrollYToX || shiftConvert) && !deltaX) {
                deltaX = deltaY;
                deltaY = 0;
            }
            var futureScrollPosition = this._scrollable.getFutureScrollPosition();
            var desiredScrollPosition = {};
            if (deltaY) {
                var desiredScrollTop = futureScrollPosition.scrollTop - SCROLL_WHEEL_SENSITIVITY * deltaY;
                this._verticalScrollbar.writeScrollPosition(desiredScrollPosition, desiredScrollTop);
            }
            if (deltaX) {
                var desiredScrollLeft = futureScrollPosition.scrollLeft - SCROLL_WHEEL_SENSITIVITY * deltaX;
                this._horizontalScrollbar.writeScrollPosition(desiredScrollPosition, desiredScrollLeft);
            }
            // Check that we are scrolling towards a location which is valid
            desiredScrollPosition = this._scrollable.validateScrollPosition(desiredScrollPosition);
            if (futureScrollPosition.scrollLeft !== desiredScrollPosition.scrollLeft || futureScrollPosition.scrollTop !== desiredScrollPosition.scrollTop) {
                var canPerformSmoothScroll = (SCROLL_WHEEL_SMOOTH_SCROLL_ENABLED
                    && this._options.mouseWheelSmoothScroll
                    && classifier.isPhysicalMouseWheel());
                if (canPerformSmoothScroll) {
                    this._scrollable.setScrollPositionSmooth(desiredScrollPosition);
                }
                else {
                    this._scrollable.setScrollPositionNow(desiredScrollPosition);
                }
                this._shouldRender = true;
            }
        }
        if (this._options.alwaysConsumeMouseWheel || this._shouldRender) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    AbstractScrollableElement.prototype._onDidScroll = function (e) {
        this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender;
        this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender;
        if (this._options.useShadows) {
            this._shouldRender = true;
        }
        if (this._revealOnScroll) {
            this._reveal();
        }
        if (!this._options.lazyRender) {
            this._render();
        }
    };
    /**
     * Render / mutate the DOM now.
     * Should be used together with the ctor option `lazyRender`.
     */
    AbstractScrollableElement.prototype.renderNow = function () {
        if (!this._options.lazyRender) {
            throw new Error('Please use `lazyRender` together with `renderNow`!');
        }
        this._render();
    };
    AbstractScrollableElement.prototype._render = function () {
        if (!this._shouldRender) {
            return;
        }
        this._shouldRender = false;
        this._horizontalScrollbar.render();
        this._verticalScrollbar.render();
        if (this._options.useShadows) {
            var scrollState = this._scrollable.getCurrentScrollPosition();
            var enableTop = scrollState.scrollTop > 0;
            var enableLeft = scrollState.scrollLeft > 0;
            this._leftShadowDomNode.setClassName('shadow' + (enableLeft ? ' left' : ''));
            this._topShadowDomNode.setClassName('shadow' + (enableTop ? ' top' : ''));
            this._topLeftShadowDomNode.setClassName('shadow top-left-corner' + (enableTop ? ' top' : '') + (enableLeft ? ' left' : ''));
        }
    };
    // -------------------- fade in / fade out --------------------
    AbstractScrollableElement.prototype._onDragStart = function () {
        this._isDragging = true;
        this._reveal();
    };
    AbstractScrollableElement.prototype._onDragEnd = function () {
        this._isDragging = false;
        this._hide();
    };
    AbstractScrollableElement.prototype._onMouseOut = function (e) {
        this._mouseIsOver = false;
        this._hide();
    };
    AbstractScrollableElement.prototype._onMouseOver = function (e) {
        this._mouseIsOver = true;
        this._reveal();
    };
    AbstractScrollableElement.prototype._reveal = function () {
        this._verticalScrollbar.beginReveal();
        this._horizontalScrollbar.beginReveal();
        this._scheduleHide();
    };
    AbstractScrollableElement.prototype._hide = function () {
        if (!this._mouseIsOver && !this._isDragging) {
            this._verticalScrollbar.beginHide();
            this._horizontalScrollbar.beginHide();
        }
    };
    AbstractScrollableElement.prototype._scheduleHide = function () {
        var _this = this;
        if (!this._mouseIsOver && !this._isDragging) {
            this._hideTimeout.cancelAndSet(function () { return _this._hide(); }, HIDE_TIMEOUT);
        }
    };
    return AbstractScrollableElement;
}(__WEBPACK_IMPORTED_MODULE_8__widget_js__["a" /* Widget */]));

var ScrollableElement = /** @class */ (function (_super) {
    __extends(ScrollableElement, _super);
    function ScrollableElement(element, options) {
        var _this = this;
        options = options || {};
        options.mouseWheelSmoothScroll = false;
        var scrollable = new __WEBPACK_IMPORTED_MODULE_7__common_scrollable_js__["a" /* Scrollable */](0, function (callback) { return __WEBPACK_IMPORTED_MODULE_1__dom_js__["L" /* scheduleAtNextAnimationFrame */](callback); });
        _this = _super.call(this, element, options, scrollable) || this;
        _this._register(scrollable);
        return _this;
    }
    ScrollableElement.prototype.setScrollPosition = function (update) {
        this._scrollable.setScrollPositionNow(update);
    };
    ScrollableElement.prototype.getScrollPosition = function () {
        return this._scrollable.getCurrentScrollPosition();
    };
    return ScrollableElement;
}(AbstractScrollableElement));

var SmoothScrollableElement = /** @class */ (function (_super) {
    __extends(SmoothScrollableElement, _super);
    function SmoothScrollableElement(element, options, scrollable) {
        return _super.call(this, element, options, scrollable) || this;
    }
    return SmoothScrollableElement;
}(AbstractScrollableElement));

var DomScrollableElement = /** @class */ (function (_super) {
    __extends(DomScrollableElement, _super);
    function DomScrollableElement(element, options) {
        var _this = _super.call(this, element, options) || this;
        _this._element = element;
        _this.onScroll(function (e) {
            if (e.scrollTopChanged) {
                _this._element.scrollTop = e.scrollTop;
            }
            if (e.scrollLeftChanged) {
                _this._element.scrollLeft = e.scrollLeft;
            }
        });
        _this.scanDomNode();
        return _this;
    }
    DomScrollableElement.prototype.scanDomNode = function () {
        // widh, scrollLeft, scrollWidth, height, scrollTop, scrollHeight
        this.setScrollDimensions({
            width: this._element.clientWidth,
            scrollWidth: this._element.scrollWidth,
            height: this._element.clientHeight,
            scrollHeight: this._element.scrollHeight
        });
        this.setScrollPosition({
            scrollLeft: this._element.scrollLeft,
            scrollTop: this._element.scrollTop,
        });
    };
    return DomScrollableElement;
}(ScrollableElement));

function resolveOptions(opts) {
    var result = {
        lazyRender: (typeof opts.lazyRender !== 'undefined' ? opts.lazyRender : false),
        className: (typeof opts.className !== 'undefined' ? opts.className : ''),
        useShadows: (typeof opts.useShadows !== 'undefined' ? opts.useShadows : true),
        handleMouseWheel: (typeof opts.handleMouseWheel !== 'undefined' ? opts.handleMouseWheel : true),
        flipAxes: (typeof opts.flipAxes !== 'undefined' ? opts.flipAxes : false),
        alwaysConsumeMouseWheel: (typeof opts.alwaysConsumeMouseWheel !== 'undefined' ? opts.alwaysConsumeMouseWheel : false),
        scrollYToX: (typeof opts.scrollYToX !== 'undefined' ? opts.scrollYToX : false),
        mouseWheelScrollSensitivity: (typeof opts.mouseWheelScrollSensitivity !== 'undefined' ? opts.mouseWheelScrollSensitivity : 1),
        mouseWheelSmoothScroll: (typeof opts.mouseWheelSmoothScroll !== 'undefined' ? opts.mouseWheelSmoothScroll : true),
        arrowSize: (typeof opts.arrowSize !== 'undefined' ? opts.arrowSize : 11),
        listenOnDomNode: (typeof opts.listenOnDomNode !== 'undefined' ? opts.listenOnDomNode : null),
        horizontal: (typeof opts.horizontal !== 'undefined' ? opts.horizontal : __WEBPACK_IMPORTED_MODULE_7__common_scrollable_js__["b" /* ScrollbarVisibility */].Auto),
        horizontalScrollbarSize: (typeof opts.horizontalScrollbarSize !== 'undefined' ? opts.horizontalScrollbarSize : 10),
        horizontalSliderSize: (typeof opts.horizontalSliderSize !== 'undefined' ? opts.horizontalSliderSize : 0),
        horizontalHasArrows: (typeof opts.horizontalHasArrows !== 'undefined' ? opts.horizontalHasArrows : false),
        vertical: (typeof opts.vertical !== 'undefined' ? opts.vertical : __WEBPACK_IMPORTED_MODULE_7__common_scrollable_js__["b" /* ScrollbarVisibility */].Auto),
        verticalScrollbarSize: (typeof opts.verticalScrollbarSize !== 'undefined' ? opts.verticalScrollbarSize : 10),
        verticalHasArrows: (typeof opts.verticalHasArrows !== 'undefined' ? opts.verticalHasArrows : false),
        verticalSliderSize: (typeof opts.verticalSliderSize !== 'undefined' ? opts.verticalSliderSize : 0)
    };
    result.horizontalSliderSize = (typeof opts.horizontalSliderSize !== 'undefined' ? opts.horizontalSliderSize : result.horizontalScrollbarSize);
    result.verticalSliderSize = (typeof opts.verticalSliderSize !== 'undefined' ? opts.verticalSliderSize : result.verticalScrollbarSize);
    // Defaults are different on Macs
    if (__WEBPACK_IMPORTED_MODULE_2__common_platform_js__["d" /* isMacintosh */]) {
        result.className += ' mac';
    }
    return result;
}


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionRunner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var Action = /** @class */ (function () {
    function Action(id, label, cssClass, enabled, actionCallback) {
        if (label === void 0) { label = ''; }
        if (cssClass === void 0) { cssClass = ''; }
        if (enabled === void 0) { enabled = true; }
        this._onDidChange = new __WEBPACK_IMPORTED_MODULE_1__event_js__["a" /* Emitter */]();
        this._id = id;
        this._label = label;
        this._cssClass = cssClass;
        this._enabled = enabled;
        this._actionCallback = actionCallback;
    }
    Action.prototype.dispose = function () {
        this._onDidChange.dispose();
    };
    Object.defineProperty(Action.prototype, "onDidChange", {
        get: function () {
            return this._onDidChange.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (value) {
            this._setLabel(value);
        },
        enumerable: true,
        configurable: true
    });
    Action.prototype._setLabel = function (value) {
        if (this._label !== value) {
            this._label = value;
            this._onDidChange.fire({ label: value });
        }
    };
    Object.defineProperty(Action.prototype, "tooltip", {
        get: function () {
            return this._tooltip;
        },
        set: function (value) {
            this._setTooltip(value);
        },
        enumerable: true,
        configurable: true
    });
    Action.prototype._setTooltip = function (value) {
        if (this._tooltip !== value) {
            this._tooltip = value;
            this._onDidChange.fire({ tooltip: value });
        }
    };
    Object.defineProperty(Action.prototype, "class", {
        get: function () {
            return this._cssClass;
        },
        set: function (value) {
            this._setClass(value);
        },
        enumerable: true,
        configurable: true
    });
    Action.prototype._setClass = function (value) {
        if (this._cssClass !== value) {
            this._cssClass = value;
            this._onDidChange.fire({ class: value });
        }
    };
    Object.defineProperty(Action.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._setEnabled(value);
        },
        enumerable: true,
        configurable: true
    });
    Action.prototype._setEnabled = function (value) {
        if (this._enabled !== value) {
            this._enabled = value;
            this._onDidChange.fire({ enabled: value });
        }
    };
    Object.defineProperty(Action.prototype, "checked", {
        get: function () {
            return this._checked;
        },
        set: function (value) {
            this._setChecked(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "radio", {
        get: function () {
            return this._radio;
        },
        set: function (value) {
            this._setRadio(value);
        },
        enumerable: true,
        configurable: true
    });
    Action.prototype._setChecked = function (value) {
        if (this._checked !== value) {
            this._checked = value;
            this._onDidChange.fire({ checked: value });
        }
    };
    Action.prototype._setRadio = function (value) {
        if (this._radio !== value) {
            this._radio = value;
            this._onDidChange.fire({ radio: value });
        }
    };
    Object.defineProperty(Action.prototype, "order", {
        get: function () {
            return this._order;
        },
        set: function (value) {
            this._order = value;
        },
        enumerable: true,
        configurable: true
    });
    Action.prototype.run = function (event, data) {
        if (this._actionCallback !== void 0) {
            return this._actionCallback(event);
        }
        return __WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["b" /* TPromise */].as(true);
    };
    return Action;
}());

var ActionRunner = /** @class */ (function () {
    function ActionRunner() {
        this._onDidBeforeRun = new __WEBPACK_IMPORTED_MODULE_1__event_js__["a" /* Emitter */]();
        this._onDidRun = new __WEBPACK_IMPORTED_MODULE_1__event_js__["a" /* Emitter */]();
    }
    Object.defineProperty(ActionRunner.prototype, "onDidRun", {
        get: function () {
            return this._onDidRun.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionRunner.prototype, "onDidBeforeRun", {
        get: function () {
            return this._onDidBeforeRun.event;
        },
        enumerable: true,
        configurable: true
    });
    ActionRunner.prototype.run = function (action, context) {
        var _this = this;
        if (!action.enabled) {
            return __WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["b" /* TPromise */].as(null);
        }
        this._onDidBeforeRun.fire({ action: action });
        return this.runAction(action, context).then(function (result) {
            _this._onDidRun.fire({ action: action, result: result });
        }, function (error) {
            _this._onDidRun.fire({ action: action, error: error });
        });
    };
    ActionRunner.prototype.runAction = function (action, context) {
        var res = context ? action.run(context) : action.run();
        if (__WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["b" /* TPromise */].is(res)) {
            return res;
        }
        return __WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["b" /* TPromise */].wrap(res);
    };
    ActionRunner.prototype.dispose = function () {
        this._onDidBeforeRun.dispose();
        this._onDidRun.dispose();
    };
    return ActionRunner;
}());



/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IOpenerService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NullOpenerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var IOpenerService = Object(__WEBPACK_IMPORTED_MODULE_1__instantiation_common_instantiation_js__["c" /* createDecorator */])('openerService');
var NullOpenerService = Object.freeze({
    _serviceBrand: undefined,
    open: function () { return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(undefined); }
});


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NULL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NULL_MODE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NULL_LANGUAGE_IDENTIFIER; });
/* harmony export (immutable) */ __webpack_exports__["d"] = nullTokenize;
/* harmony export (immutable) */ __webpack_exports__["e"] = nullTokenize2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_token_js__ = __webpack_require__(94);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var NullStateImpl = /** @class */ (function () {
    function NullStateImpl() {
    }
    NullStateImpl.prototype.clone = function () {
        return this;
    };
    NullStateImpl.prototype.equals = function (other) {
        return (this === other);
    };
    return NullStateImpl;
}());
var NULL_STATE = new NullStateImpl();
var NULL_MODE_ID = 'vs.editor.nullMode';
var NULL_LANGUAGE_IDENTIFIER = new __WEBPACK_IMPORTED_MODULE_0__modes_js__["o" /* LanguageIdentifier */](NULL_MODE_ID, 0 /* Null */);
function nullTokenize(modeId, buffer, state, deltaOffset) {
    return new __WEBPACK_IMPORTED_MODULE_1__core_token_js__["b" /* TokenizationResult */]([new __WEBPACK_IMPORTED_MODULE_1__core_token_js__["a" /* Token */](deltaOffset, '', modeId)], state);
}
function nullTokenize2(languageId, buffer, state, deltaOffset) {
    var tokens = new Uint32Array(2);
    tokens[0] = deltaOffset;
    tokens[1] = ((languageId << 0 /* LANGUAGEID_OFFSET */)
        | (0 /* Other */ << 8 /* TOKEN_TYPE_OFFSET */)
        | (0 /* None */ << 11 /* FONT_STYLE_OFFSET */)
        | (1 /* DefaultForeground */ << 14 /* FOREGROUND_OFFSET */)
        | (2 /* DefaultBackground */ << 23 /* BACKGROUND_OFFSET */)) >>> 0;
    return new __WEBPACK_IMPORTED_MODULE_1__core_token_js__["c" /* TokenizationResult2 */](tokens, state);
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndentAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StandardAutoClosingPairConditional; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Describes what to do with the indentation when pressing Enter.
 */
var IndentAction;
(function (IndentAction) {
    /**
     * Insert new line and copy the previous line's indentation.
     */
    IndentAction[IndentAction["None"] = 0] = "None";
    /**
     * Insert new line and indent once (relative to the previous line's indentation).
     */
    IndentAction[IndentAction["Indent"] = 1] = "Indent";
    /**
     * Insert two new lines:
     *  - the first one indented which will hold the cursor
     *  - the second one at the same indentation level
     */
    IndentAction[IndentAction["IndentOutdent"] = 2] = "IndentOutdent";
    /**
     * Insert new line and outdent once (relative to the previous line's indentation).
     */
    IndentAction[IndentAction["Outdent"] = 3] = "Outdent";
})(IndentAction || (IndentAction = {}));
/**
 * @internal
 */
var StandardAutoClosingPairConditional = /** @class */ (function () {
    function StandardAutoClosingPairConditional(source) {
        this.open = source.open;
        this.close = source.close;
        // initially allowed in all tokens
        this._standardTokenMask = 0;
        if (Array.isArray(source.notIn)) {
            for (var i = 0, len = source.notIn.length; i < len; i++) {
                var notIn = source.notIn[i];
                switch (notIn) {
                    case 'string':
                        this._standardTokenMask |= 2 /* String */;
                        break;
                    case 'comment':
                        this._standardTokenMask |= 1 /* Comment */;
                        break;
                    case 'regex':
                        this._standardTokenMask |= 4 /* RegEx */;
                        break;
                }
            }
        }
    }
    StandardAutoClosingPairConditional.prototype.isOK = function (standardToken) {
        return (this._standardTokenMask & standardToken) === 0;
    };
    return StandardAutoClosingPairConditional;
}());



/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isThemeColor;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Handler; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * @internal
 */
function isThemeColor(o) {
    return o && typeof o.id === 'string';
}
/**
 * The type of the `IEditor`.
 */
var EditorType = {
    ICodeEditor: 'vs.editor.ICodeEditor',
    IDiffEditor: 'vs.editor.IDiffEditor'
};
/**
 * Built-in commands.
 * @internal
 */
var Handler = {
    ExecuteCommand: 'executeCommand',
    ExecuteCommands: 'executeCommands',
    Type: 'type',
    ReplacePreviousChar: 'replacePreviousChar',
    CompositionStart: 'compositionStart',
    CompositionEnd: 'compositionEnd',
    Paste: 'paste',
    Cut: 'cut',
    Undo: 'undo',
    Redo: 'redo',
};


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Schemas; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var Schemas;
(function (Schemas) {
    /**
     * A schema that is used for models that exist in memory
     * only and that have no correspondence on a server or such.
     */
    Schemas.inMemory = 'inmemory';
    /**
     * A schema that is used for setting files
     */
    Schemas.vscode = 'vscode';
    /**
     * A schema that is used for internal private files
     */
    Schemas.internal = 'private';
    /**
     * A walk-through document.
     */
    Schemas.walkThrough = 'walkThrough';
    /**
     * An embedded code snippet.
     */
    Schemas.walkThroughSnippet = 'walkThroughSnippet';
    Schemas.http = 'http';
    Schemas.https = 'https';
    Schemas.file = 'file';
    Schemas.mailto = 'mailto';
    Schemas.untitled = 'untitled';
    Schemas.data = 'data';
})(Schemas || (Schemas = {}));


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Configuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_config_commonEditorConfig_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_config_fontInfo_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elementSizeObserver_js__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__charWidthReader_js__ = __webpack_require__(387);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var CSSBasedConfigurationCache = /** @class */ (function () {
    function CSSBasedConfigurationCache() {
        this._keys = Object.create(null);
        this._values = Object.create(null);
    }
    CSSBasedConfigurationCache.prototype.has = function (item) {
        var itemId = item.getId();
        return !!this._values[itemId];
    };
    CSSBasedConfigurationCache.prototype.get = function (item) {
        var itemId = item.getId();
        return this._values[itemId];
    };
    CSSBasedConfigurationCache.prototype.put = function (item, value) {
        var itemId = item.getId();
        this._keys[itemId] = item;
        this._values[itemId] = value;
    };
    CSSBasedConfigurationCache.prototype.remove = function (item) {
        var itemId = item.getId();
        delete this._keys[itemId];
        delete this._values[itemId];
    };
    CSSBasedConfigurationCache.prototype.getValues = function () {
        var _this = this;
        return Object.keys(this._keys).map(function (id) { return _this._values[id]; });
    };
    return CSSBasedConfigurationCache;
}());
var CSSBasedConfiguration = /** @class */ (function (_super) {
    __extends(CSSBasedConfiguration, _super);
    function CSSBasedConfiguration() {
        var _this = _super.call(this) || this;
        _this._onDidChange = _this._register(new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChange = _this._onDidChange.event;
        _this._cache = new CSSBasedConfigurationCache();
        _this._evictUntrustedReadingsTimeout = -1;
        return _this;
    }
    CSSBasedConfiguration.prototype.dispose = function () {
        if (this._evictUntrustedReadingsTimeout !== -1) {
            clearTimeout(this._evictUntrustedReadingsTimeout);
            this._evictUntrustedReadingsTimeout = -1;
        }
        _super.prototype.dispose.call(this);
    };
    CSSBasedConfiguration.prototype._writeToCache = function (item, value) {
        var _this = this;
        this._cache.put(item, value);
        if (!value.isTrusted && this._evictUntrustedReadingsTimeout === -1) {
            // Try reading again after some time
            this._evictUntrustedReadingsTimeout = setTimeout(function () {
                _this._evictUntrustedReadingsTimeout = -1;
                _this._evictUntrustedReadings();
            }, 5000);
        }
    };
    CSSBasedConfiguration.prototype._evictUntrustedReadings = function () {
        var values = this._cache.getValues();
        var somethingRemoved = false;
        for (var i = 0, len = values.length; i < len; i++) {
            var item = values[i];
            if (!item.isTrusted) {
                somethingRemoved = true;
                this._cache.remove(item);
            }
        }
        if (somethingRemoved) {
            this._onDidChange.fire();
        }
    };
    CSSBasedConfiguration.prototype.readConfiguration = function (bareFontInfo) {
        if (!this._cache.has(bareFontInfo)) {
            var readConfig = CSSBasedConfiguration._actualReadConfiguration(bareFontInfo);
            if (readConfig.typicalHalfwidthCharacterWidth <= 2 || readConfig.typicalFullwidthCharacterWidth <= 2 || readConfig.spaceWidth <= 2 || readConfig.maxDigitWidth <= 2) {
                // Hey, it's Bug 14341 ... we couldn't read
                readConfig = new __WEBPACK_IMPORTED_MODULE_5__common_config_fontInfo_js__["b" /* FontInfo */]({
                    zoomLevel: __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["d" /* getZoomLevel */](),
                    fontFamily: readConfig.fontFamily,
                    fontWeight: readConfig.fontWeight,
                    fontSize: readConfig.fontSize,
                    lineHeight: readConfig.lineHeight,
                    letterSpacing: readConfig.letterSpacing,
                    isMonospace: readConfig.isMonospace,
                    typicalHalfwidthCharacterWidth: Math.max(readConfig.typicalHalfwidthCharacterWidth, 5),
                    typicalFullwidthCharacterWidth: Math.max(readConfig.typicalFullwidthCharacterWidth, 5),
                    spaceWidth: Math.max(readConfig.spaceWidth, 5),
                    maxDigitWidth: Math.max(readConfig.maxDigitWidth, 5),
                }, false);
            }
            this._writeToCache(bareFontInfo, readConfig);
        }
        return this._cache.get(bareFontInfo);
    };
    CSSBasedConfiguration.createRequest = function (chr, type, all, monospace) {
        var result = new __WEBPACK_IMPORTED_MODULE_7__charWidthReader_js__["a" /* CharWidthRequest */](chr, type);
        all.push(result);
        if (monospace) {
            monospace.push(result);
        }
        return result;
    };
    CSSBasedConfiguration._actualReadConfiguration = function (bareFontInfo) {
        var all = [];
        var monospace = [];
        var typicalHalfwidthCharacter = this.createRequest('n', 0 /* Regular */, all, monospace);
        var typicalFullwidthCharacter = this.createRequest('\uff4d', 0 /* Regular */, all, null);
        var space = this.createRequest(' ', 0 /* Regular */, all, monospace);
        var digit0 = this.createRequest('0', 0 /* Regular */, all, monospace);
        var digit1 = this.createRequest('1', 0 /* Regular */, all, monospace);
        var digit2 = this.createRequest('2', 0 /* Regular */, all, monospace);
        var digit3 = this.createRequest('3', 0 /* Regular */, all, monospace);
        var digit4 = this.createRequest('4', 0 /* Regular */, all, monospace);
        var digit5 = this.createRequest('5', 0 /* Regular */, all, monospace);
        var digit6 = this.createRequest('6', 0 /* Regular */, all, monospace);
        var digit7 = this.createRequest('7', 0 /* Regular */, all, monospace);
        var digit8 = this.createRequest('8', 0 /* Regular */, all, monospace);
        var digit9 = this.createRequest('9', 0 /* Regular */, all, monospace);
        // monospace test: used for whitespace rendering
        this.createRequest('→', 0 /* Regular */, all, monospace);
        this.createRequest('·', 0 /* Regular */, all, monospace);
        // monospace test: some characters
        this.createRequest('|', 0 /* Regular */, all, monospace);
        this.createRequest('/', 0 /* Regular */, all, monospace);
        this.createRequest('-', 0 /* Regular */, all, monospace);
        this.createRequest('_', 0 /* Regular */, all, monospace);
        this.createRequest('i', 0 /* Regular */, all, monospace);
        this.createRequest('l', 0 /* Regular */, all, monospace);
        this.createRequest('m', 0 /* Regular */, all, monospace);
        // monospace italic test
        this.createRequest('|', 1 /* Italic */, all, monospace);
        this.createRequest('_', 1 /* Italic */, all, monospace);
        this.createRequest('i', 1 /* Italic */, all, monospace);
        this.createRequest('l', 1 /* Italic */, all, monospace);
        this.createRequest('m', 1 /* Italic */, all, monospace);
        this.createRequest('n', 1 /* Italic */, all, monospace);
        // monospace bold test
        this.createRequest('|', 2 /* Bold */, all, monospace);
        this.createRequest('_', 2 /* Bold */, all, monospace);
        this.createRequest('i', 2 /* Bold */, all, monospace);
        this.createRequest('l', 2 /* Bold */, all, monospace);
        this.createRequest('m', 2 /* Bold */, all, monospace);
        this.createRequest('n', 2 /* Bold */, all, monospace);
        Object(__WEBPACK_IMPORTED_MODULE_7__charWidthReader_js__["b" /* readCharWidths */])(bareFontInfo, all);
        var maxDigitWidth = Math.max(digit0.width, digit1.width, digit2.width, digit3.width, digit4.width, digit5.width, digit6.width, digit7.width, digit8.width, digit9.width);
        var isMonospace = true;
        var referenceWidth = monospace[0].width;
        for (var i = 1, len = monospace.length; i < len; i++) {
            var diff = referenceWidth - monospace[i].width;
            if (diff < -0.001 || diff > 0.001) {
                isMonospace = false;
                break;
            }
        }
        // let's trust the zoom level only 2s after it was changed.
        var canTrustBrowserZoomLevel = (__WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["c" /* getTimeSinceLastZoomLevelChanged */]() > 2000);
        return new __WEBPACK_IMPORTED_MODULE_5__common_config_fontInfo_js__["b" /* FontInfo */]({
            zoomLevel: __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["d" /* getZoomLevel */](),
            fontFamily: bareFontInfo.fontFamily,
            fontWeight: bareFontInfo.fontWeight,
            fontSize: bareFontInfo.fontSize,
            lineHeight: bareFontInfo.lineHeight,
            letterSpacing: bareFontInfo.letterSpacing,
            isMonospace: isMonospace,
            typicalHalfwidthCharacterWidth: typicalHalfwidthCharacter.width,
            typicalFullwidthCharacterWidth: typicalFullwidthCharacter.width,
            spaceWidth: space.width,
            maxDigitWidth: maxDigitWidth
        }, canTrustBrowserZoomLevel);
    };
    CSSBasedConfiguration.INSTANCE = new CSSBasedConfiguration();
    return CSSBasedConfiguration;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));
var Configuration = /** @class */ (function (_super) {
    __extends(Configuration, _super);
    function Configuration(options, referenceDomElement) {
        if (referenceDomElement === void 0) { referenceDomElement = null; }
        var _this = _super.call(this, options) || this;
        _this._elementSizeObserver = _this._register(new __WEBPACK_IMPORTED_MODULE_6__elementSizeObserver_js__["a" /* ElementSizeObserver */](referenceDomElement, function () { return _this._onReferenceDomElementSizeChanged(); }));
        _this._register(CSSBasedConfiguration.INSTANCE.onDidChange(function () { return _this._onCSSBasedConfigurationChanged(); }));
        if (_this._validatedOptions.automaticLayout) {
            _this._elementSizeObserver.startObserving();
        }
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["p" /* onDidChangeZoomLevel */](function (_) { return _this._recomputeOptions(); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["o" /* onDidChangeAccessibilitySupport */](function () { return _this._recomputeOptions(); }));
        _this._recomputeOptions();
        return _this;
    }
    Configuration._massageFontFamily = function (fontFamily) {
        if (/[,"']/.test(fontFamily)) {
            // Looks like the font family might be already escaped
            return fontFamily;
        }
        if (/[+ ]/.test(fontFamily)) {
            // Wrap a font family using + or <space> with quotes
            return "\"" + fontFamily + "\"";
        }
        return fontFamily;
    };
    Configuration.applyFontInfoSlow = function (domNode, fontInfo) {
        domNode.style.fontFamily = Configuration._massageFontFamily(fontInfo.fontFamily);
        domNode.style.fontWeight = fontInfo.fontWeight;
        domNode.style.fontSize = fontInfo.fontSize + 'px';
        domNode.style.lineHeight = fontInfo.lineHeight + 'px';
        domNode.style.letterSpacing = fontInfo.letterSpacing + 'px';
    };
    Configuration.applyFontInfo = function (domNode, fontInfo) {
        domNode.setFontFamily(Configuration._massageFontFamily(fontInfo.fontFamily));
        domNode.setFontWeight(fontInfo.fontWeight);
        domNode.setFontSize(fontInfo.fontSize);
        domNode.setLineHeight(fontInfo.lineHeight);
        domNode.setLetterSpacing(fontInfo.letterSpacing);
    };
    Configuration.prototype._onReferenceDomElementSizeChanged = function () {
        this._recomputeOptions();
    };
    Configuration.prototype._onCSSBasedConfigurationChanged = function () {
        this._recomputeOptions();
    };
    Configuration.prototype.observeReferenceElement = function (dimension) {
        this._elementSizeObserver.observe(dimension);
    };
    Configuration.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    Configuration.prototype._getExtraEditorClassName = function () {
        var extra = '';
        if (__WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["k" /* isIE */]) {
            extra += 'ie ';
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["j" /* isFirefox */]) {
            extra += 'ff ';
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["g" /* isEdge */]) {
            extra += 'edge ';
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["m" /* isSafari */]) {
            extra += 'safari ';
        }
        if (__WEBPACK_IMPORTED_MODULE_2__base_common_platform_js__["d" /* isMacintosh */]) {
            extra += 'mac ';
        }
        return extra;
    };
    Configuration.prototype._getEnvConfiguration = function () {
        return {
            extraEditorClassName: this._getExtraEditorClassName(),
            outerWidth: this._elementSizeObserver.getWidth(),
            outerHeight: this._elementSizeObserver.getHeight(),
            emptySelectionClipboard: __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["n" /* isWebKit */] || __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["j" /* isFirefox */],
            pixelRatio: __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["b" /* getPixelRatio */](),
            zoomLevel: __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["d" /* getZoomLevel */](),
            accessibilitySupport: __WEBPACK_IMPORTED_MODULE_3__base_browser_browser_js__["a" /* getAccessibilitySupport */]()
        };
    };
    Configuration.prototype.readConfiguration = function (bareFontInfo) {
        return CSSBasedConfiguration.INSTANCE.readConfiguration(bareFontInfo);
    };
    return Configuration;
}(__WEBPACK_IMPORTED_MODULE_4__common_config_commonEditorConfig_js__["a" /* CommonEditorConfiguration */]));



/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Viewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MinimapLinesRenderingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ViewLineData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ViewLineRenderingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineDecoration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ViewModelDecoration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var Viewport = /** @class */ (function () {
    function Viewport(top, left, width, height) {
        this.top = top | 0;
        this.left = left | 0;
        this.width = width | 0;
        this.height = height | 0;
    }
    return Viewport;
}());

var MinimapLinesRenderingData = /** @class */ (function () {
    function MinimapLinesRenderingData(tabSize, data) {
        this.tabSize = tabSize;
        this.data = data;
    }
    return MinimapLinesRenderingData;
}());

var ViewLineData = /** @class */ (function () {
    function ViewLineData(content, continuesWithWrappedLine, minColumn, maxColumn, tokens) {
        this.content = content;
        this.continuesWithWrappedLine = continuesWithWrappedLine;
        this.minColumn = minColumn;
        this.maxColumn = maxColumn;
        this.tokens = tokens;
    }
    return ViewLineData;
}());

var ViewLineRenderingData = /** @class */ (function () {
    function ViewLineRenderingData(minColumn, maxColumn, content, continuesWithWrappedLine, mightContainRTL, mightContainNonBasicASCII, tokens, inlineDecorations, tabSize) {
        this.minColumn = minColumn;
        this.maxColumn = maxColumn;
        this.content = content;
        this.continuesWithWrappedLine = continuesWithWrappedLine;
        this.isBasicASCII = ViewLineRenderingData.isBasicASCII(content, mightContainNonBasicASCII);
        this.containsRTL = ViewLineRenderingData.containsRTL(content, this.isBasicASCII, mightContainRTL);
        this.tokens = tokens;
        this.inlineDecorations = inlineDecorations;
        this.tabSize = tabSize;
    }
    ViewLineRenderingData.isBasicASCII = function (lineContent, mightContainNonBasicASCII) {
        if (mightContainNonBasicASCII) {
            return __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["isBasicASCII"](lineContent);
        }
        return true;
    };
    ViewLineRenderingData.containsRTL = function (lineContent, isBasicASCII, mightContainRTL) {
        if (!isBasicASCII && mightContainRTL) {
            return __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["containsRTL"](lineContent);
        }
        return false;
    };
    return ViewLineRenderingData;
}());

var InlineDecoration = /** @class */ (function () {
    function InlineDecoration(range, inlineClassName, type) {
        this.range = range;
        this.inlineClassName = inlineClassName;
        this.type = type;
    }
    return InlineDecoration;
}());

var ViewModelDecoration = /** @class */ (function () {
    function ViewModelDecoration(range, options) {
        this.range = range;
        this.options = options;
    }
    return ViewModelDecoration;
}());



/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicViewOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_viewModel_viewEventHandler_js__ = __webpack_require__(85);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DynamicViewOverlay = /** @class */ (function (_super) {
    __extends(DynamicViewOverlay, _super);
    function DynamicViewOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DynamicViewOverlay;
}(__WEBPACK_IMPORTED_MODULE_0__common_viewModel_viewEventHandler_js__["a" /* ViewEventHandler */]));



/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IModeService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IModeService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])('modeService');


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkdownString; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isEmptyMarkdownString;
/* unused harmony export isMarkdownString */
/* harmony export (immutable) */ __webpack_exports__["c"] = markedStringsEquals;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeMarkdownEscapes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrays_js__ = __webpack_require__(22);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var MarkdownString = /** @class */ (function () {
    function MarkdownString(value) {
        if (value === void 0) { value = ''; }
        this.value = value;
    }
    MarkdownString.prototype.appendText = function (value) {
        // escape markdown syntax tokens: http://daringfireball.net/projects/markdown/syntax#backslash
        this.value += value.replace(/[\\`*_{}[\]()#+\-.!]/g, '\\$&');
        return this;
    };
    MarkdownString.prototype.appendMarkdown = function (value) {
        this.value += value;
        return this;
    };
    MarkdownString.prototype.appendCodeblock = function (langId, code) {
        this.value += '\n```';
        this.value += langId;
        this.value += '\n';
        this.value += code;
        this.value += '\n```\n';
        return this;
    };
    return MarkdownString;
}());

function isEmptyMarkdownString(oneOrMany) {
    if (isMarkdownString(oneOrMany)) {
        return !oneOrMany.value;
    }
    else if (Array.isArray(oneOrMany)) {
        return oneOrMany.every(isEmptyMarkdownString);
    }
    else {
        return true;
    }
}
function isMarkdownString(thing) {
    if (thing instanceof MarkdownString) {
        return true;
    }
    else if (thing && typeof thing === 'object') {
        return typeof thing.value === 'string'
            && (typeof thing.isTrusted === 'boolean' || thing.isTrusted === void 0);
    }
    return false;
}
function markedStringsEquals(a, b) {
    if (!a && !b) {
        return true;
    }
    else if (!a || !b) {
        return false;
    }
    else if (Array.isArray(a) && Array.isArray(b)) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__arrays_js__["e" /* equals */])(a, b, markdownStringEqual);
    }
    else if (isMarkdownString(a) && isMarkdownString(b)) {
        return markdownStringEqual(a, b);
    }
    else {
        return false;
    }
}
function markdownStringEqual(a, b) {
    if (a === b) {
        return true;
    }
    else if (!a || !b) {
        return false;
    }
    else {
        return a.value === b.value && a.isTrusted === b.isTrusted;
    }
}
function removeMarkdownEscapes(text) {
    if (!text) {
        return text;
    }
    return text.replace(/\\([\\`*_{}[\]()#+\-.!])/g, '$1');
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = values;
/* unused harmony export StringIterator */
/* unused harmony export PathIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TernarySearchTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResourceMap; });
/* unused harmony export Touch */
/* unused harmony export LinkedMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LRUCache; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
function values(forEachable) {
    var result = [];
    forEachable.forEach(function (value) { return result.push(value); });
    return result;
}
var StringIterator = /** @class */ (function () {
    function StringIterator() {
        this._value = '';
        this._pos = 0;
    }
    StringIterator.prototype.reset = function (key) {
        this._value = key;
        this._pos = 0;
        return this;
    };
    StringIterator.prototype.next = function () {
        this._pos += 1;
        return this;
    };
    StringIterator.prototype.hasNext = function () {
        return this._pos < this._value.length - 1;
    };
    StringIterator.prototype.cmp = function (a) {
        var aCode = a.charCodeAt(0);
        var thisCode = this._value.charCodeAt(this._pos);
        return aCode - thisCode;
    };
    StringIterator.prototype.value = function () {
        return this._value[this._pos];
    };
    return StringIterator;
}());

var PathIterator = /** @class */ (function () {
    function PathIterator() {
    }
    PathIterator.prototype.reset = function (key) {
        this._value = key.replace(/\\$|\/$/, '');
        this._from = 0;
        this._to = 0;
        return this.next();
    };
    PathIterator.prototype.hasNext = function () {
        return this._to < this._value.length;
    };
    PathIterator.prototype.next = function () {
        // this._data = key.split(/[\\/]/).filter(s => !!s);
        this._from = this._to;
        var justSeps = true;
        for (; this._to < this._value.length; this._to++) {
            var ch = this._value.charCodeAt(this._to);
            if (ch === 47 /* Slash */ || ch === 92 /* Backslash */) {
                if (justSeps) {
                    this._from++;
                }
                else {
                    break;
                }
            }
            else {
                justSeps = false;
            }
        }
        return this;
    };
    PathIterator.prototype.cmp = function (a) {
        var aPos = 0;
        var aLen = a.length;
        var thisPos = this._from;
        while (aPos < aLen && thisPos < this._to) {
            var cmp = a.charCodeAt(aPos) - this._value.charCodeAt(thisPos);
            if (cmp !== 0) {
                return cmp;
            }
            aPos += 1;
            thisPos += 1;
        }
        if (aLen === this._to - this._from) {
            return 0;
        }
        else if (aPos < aLen) {
            return -1;
        }
        else {
            return 1;
        }
    };
    PathIterator.prototype.value = function () {
        return this._value.substring(this._from, this._to);
    };
    return PathIterator;
}());

var TernarySearchTreeNode = /** @class */ (function () {
    function TernarySearchTreeNode() {
    }
    return TernarySearchTreeNode;
}());
var TernarySearchTree = /** @class */ (function () {
    function TernarySearchTree(segments) {
        this._iter = segments;
    }
    TernarySearchTree.forPaths = function () {
        return new TernarySearchTree(new PathIterator());
    };
    TernarySearchTree.forStrings = function () {
        return new TernarySearchTree(new StringIterator());
    };
    TernarySearchTree.prototype.clear = function () {
        this._root = undefined;
    };
    TernarySearchTree.prototype.set = function (key, element) {
        var iter = this._iter.reset(key);
        var node;
        if (!this._root) {
            this._root = new TernarySearchTreeNode();
            this._root.segment = iter.value();
        }
        node = this._root;
        while (true) {
            var val = iter.cmp(node.segment);
            if (val > 0) {
                // left
                if (!node.left) {
                    node.left = new TernarySearchTreeNode();
                    node.left.segment = iter.value();
                }
                node = node.left;
            }
            else if (val < 0) {
                // right
                if (!node.right) {
                    node.right = new TernarySearchTreeNode();
                    node.right.segment = iter.value();
                }
                node = node.right;
            }
            else if (iter.hasNext()) {
                // mid
                iter.next();
                if (!node.mid) {
                    node.mid = new TernarySearchTreeNode();
                    node.mid.segment = iter.value();
                }
                node = node.mid;
            }
            else {
                break;
            }
        }
        var oldElement = node.value;
        node.value = element;
        node.key = key;
        return oldElement;
    };
    TernarySearchTree.prototype.get = function (key) {
        var iter = this._iter.reset(key);
        var node = this._root;
        while (node) {
            var val = iter.cmp(node.segment);
            if (val > 0) {
                // left
                node = node.left;
            }
            else if (val < 0) {
                // right
                node = node.right;
            }
            else if (iter.hasNext()) {
                // mid
                iter.next();
                node = node.mid;
            }
            else {
                break;
            }
        }
        return node ? node.value : undefined;
    };
    TernarySearchTree.prototype.findSubstr = function (key) {
        var iter = this._iter.reset(key);
        var node = this._root;
        var candidate;
        while (node) {
            var val = iter.cmp(node.segment);
            if (val > 0) {
                // left
                node = node.left;
            }
            else if (val < 0) {
                // right
                node = node.right;
            }
            else if (iter.hasNext()) {
                // mid
                iter.next();
                candidate = node.value || candidate;
                node = node.mid;
            }
            else {
                break;
            }
        }
        return node && node.value || candidate;
    };
    TernarySearchTree.prototype.forEach = function (callback) {
        this._forEach(this._root, callback);
    };
    TernarySearchTree.prototype._forEach = function (node, callback) {
        if (node) {
            // left
            this._forEach(node.left, callback);
            // node
            if (node.value) {
                // callback(node.value, this._iter.join(parts));
                callback(node.value, node.key);
            }
            // mid
            this._forEach(node.mid, callback);
            // right
            this._forEach(node.right, callback);
        }
    };
    return TernarySearchTree;
}());

var ResourceMap = /** @class */ (function () {
    function ResourceMap() {
        this.map = new Map();
        this.ignoreCase = false; // in the future this should be an uri-comparator
    }
    ResourceMap.prototype.set = function (resource, value) {
        this.map.set(this.toKey(resource), value);
    };
    ResourceMap.prototype.get = function (resource) {
        return this.map.get(this.toKey(resource));
    };
    ResourceMap.prototype.toKey = function (resource) {
        var key = resource.toString();
        if (this.ignoreCase) {
            key = key.toLowerCase();
        }
        return key;
    };
    return ResourceMap;
}());

var Touch;
(function (Touch) {
    Touch[Touch["None"] = 0] = "None";
    Touch[Touch["AsOld"] = 1] = "AsOld";
    Touch[Touch["AsNew"] = 2] = "AsNew";
})(Touch || (Touch = {}));
var LinkedMap = /** @class */ (function () {
    function LinkedMap() {
        this._map = new Map();
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
    }
    LinkedMap.prototype.clear = function () {
        this._map.clear();
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
    };
    Object.defineProperty(LinkedMap.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    LinkedMap.prototype.get = function (key, touch) {
        if (touch === void 0) { touch = Touch.None; }
        var item = this._map.get(key);
        if (!item) {
            return undefined;
        }
        if (touch !== Touch.None) {
            this.touch(item, touch);
        }
        return item.value;
    };
    LinkedMap.prototype.set = function (key, value, touch) {
        if (touch === void 0) { touch = Touch.None; }
        var item = this._map.get(key);
        if (item) {
            item.value = value;
            if (touch !== Touch.None) {
                this.touch(item, touch);
            }
        }
        else {
            item = { key: key, value: value, next: undefined, previous: undefined };
            switch (touch) {
                case Touch.None:
                    this.addItemLast(item);
                    break;
                case Touch.AsOld:
                    this.addItemFirst(item);
                    break;
                case Touch.AsNew:
                    this.addItemLast(item);
                    break;
                default:
                    this.addItemLast(item);
                    break;
            }
            this._map.set(key, item);
            this._size++;
        }
    };
    LinkedMap.prototype.forEach = function (callbackfn, thisArg) {
        var current = this._head;
        while (current) {
            if (thisArg) {
                callbackfn.bind(thisArg)(current.value, current.key, this);
            }
            else {
                callbackfn(current.value, current.key, this);
            }
            current = current.next;
        }
    };
    /* VS Code / Monaco editor runs on es5 which has no Symbol.iterator
    public keys(): IterableIterator<K> {
        let current = this._head;
        let iterator: IterableIterator<K> = {
            [Symbol.iterator]() {
                return iterator;
            },
            next():IteratorResult<K> {
                if (current) {
                    let result = { value: current.key, done: false };
                    current = current.next;
                    return result;
                } else {
                    return { value: undefined, done: true };
                }
            }
        };
        return iterator;
    }

    public values(): IterableIterator<V> {
        let current = this._head;
        let iterator: IterableIterator<V> = {
            [Symbol.iterator]() {
                return iterator;
            },
            next():IteratorResult<V> {
                if (current) {
                    let result = { value: current.value, done: false };
                    current = current.next;
                    return result;
                } else {
                    return { value: undefined, done: true };
                }
            }
        };
        return iterator;
    }
    */
    LinkedMap.prototype.trimOld = function (newSize) {
        if (newSize >= this.size) {
            return;
        }
        if (newSize === 0) {
            this.clear();
            return;
        }
        var current = this._head;
        var currentSize = this.size;
        while (current && currentSize > newSize) {
            this._map.delete(current.key);
            current = current.next;
            currentSize--;
        }
        this._head = current;
        this._size = currentSize;
        current.previous = void 0;
    };
    LinkedMap.prototype.addItemFirst = function (item) {
        // First time Insert
        if (!this._head && !this._tail) {
            this._tail = item;
        }
        else if (!this._head) {
            throw new Error('Invalid list');
        }
        else {
            item.next = this._head;
            this._head.previous = item;
        }
        this._head = item;
    };
    LinkedMap.prototype.addItemLast = function (item) {
        // First time Insert
        if (!this._head && !this._tail) {
            this._head = item;
        }
        else if (!this._tail) {
            throw new Error('Invalid list');
        }
        else {
            item.previous = this._tail;
            this._tail.next = item;
        }
        this._tail = item;
    };
    LinkedMap.prototype.touch = function (item, touch) {
        if (!this._head || !this._tail) {
            throw new Error('Invalid list');
        }
        if ((touch !== Touch.AsOld && touch !== Touch.AsNew)) {
            return;
        }
        if (touch === Touch.AsOld) {
            if (item === this._head) {
                return;
            }
            var next = item.next;
            var previous = item.previous;
            // Unlink the item
            if (item === this._tail) {
                // previous must be defined since item was not head but is tail
                // So there are more than on item in the map
                previous.next = void 0;
                this._tail = previous;
            }
            else {
                // Both next and previous are not undefined since item was neither head nor tail.
                next.previous = previous;
                previous.next = next;
            }
            // Insert the node at head
            item.previous = void 0;
            item.next = this._head;
            this._head.previous = item;
            this._head = item;
        }
        else if (touch === Touch.AsNew) {
            if (item === this._tail) {
                return;
            }
            var next = item.next;
            var previous = item.previous;
            // Unlink the item.
            if (item === this._head) {
                // next must be defined since item was not tail but is head
                // So there are more than on item in the map
                next.previous = void 0;
                this._head = next;
            }
            else {
                // Both next and previous are not undefined since item was neither head nor tail.
                next.previous = previous;
                previous.next = next;
            }
            item.next = void 0;
            item.previous = this._tail;
            this._tail.next = item;
            this._tail = item;
        }
    };
    LinkedMap.prototype.toJSON = function () {
        var data = [];
        this.forEach(function (value, key) {
            data.push([key, value]);
        });
        return data;
    };
    return LinkedMap;
}());

var LRUCache = /** @class */ (function (_super) {
    __extends(LRUCache, _super);
    function LRUCache(limit, ratio) {
        if (ratio === void 0) { ratio = 1; }
        var _this = _super.call(this) || this;
        _this._limit = limit;
        _this._ratio = Math.min(Math.max(0, ratio), 1);
        return _this;
    }
    LRUCache.prototype.get = function (key) {
        return _super.prototype.get.call(this, key, Touch.AsNew);
    };
    LRUCache.prototype.set = function (key, value) {
        _super.prototype.set.call(this, key, value, Touch.AsNew);
        this.checkTrim();
    };
    LRUCache.prototype.checkTrim = function () {
        if (this.size > this._limit) {
            this.trimOld(Math.round(this._limit * this._ratio));
        }
    };
    return LRUCache;
}(LinkedMap));



/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IContextViewService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IContextMenuService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IContextViewService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('contextViewService');
var IContextMenuService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('contextMenuService');


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MarkerTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MarkerSeverity; });
/* unused harmony export IMarkerData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMarkerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_severity_js__ = __webpack_require__(127);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var MarkerTag;
(function (MarkerTag) {
    MarkerTag[MarkerTag["Unnecessary"] = 1] = "Unnecessary";
})(MarkerTag || (MarkerTag = {}));
var MarkerSeverity;
(function (MarkerSeverity) {
    MarkerSeverity[MarkerSeverity["Hint"] = 1] = "Hint";
    MarkerSeverity[MarkerSeverity["Info"] = 2] = "Info";
    MarkerSeverity[MarkerSeverity["Warning"] = 4] = "Warning";
    MarkerSeverity[MarkerSeverity["Error"] = 8] = "Error";
})(MarkerSeverity || (MarkerSeverity = {}));
(function (MarkerSeverity) {
    function compare(a, b) {
        return b - a;
    }
    MarkerSeverity.compare = compare;
    var _displayStrings = Object.create(null);
    _displayStrings[MarkerSeverity.Error] = Object(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */])('sev.error', "Error");
    _displayStrings[MarkerSeverity.Warning] = Object(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */])('sev.warning', "Warning");
    _displayStrings[MarkerSeverity.Info] = Object(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */])('sev.info', "Info");
    function toString(a) {
        return _displayStrings[a] || '';
    }
    MarkerSeverity.toString = toString;
    function fromSeverity(severity) {
        switch (severity) {
            case __WEBPACK_IMPORTED_MODULE_2__base_common_severity_js__["a" /* default */].Error: return MarkerSeverity.Error;
            case __WEBPACK_IMPORTED_MODULE_2__base_common_severity_js__["a" /* default */].Warning: return MarkerSeverity.Warning;
            case __WEBPACK_IMPORTED_MODULE_2__base_common_severity_js__["a" /* default */].Info: return MarkerSeverity.Info;
            case __WEBPACK_IMPORTED_MODULE_2__base_common_severity_js__["a" /* default */].Ignore: return MarkerSeverity.Hint;
        }
    }
    MarkerSeverity.fromSeverity = fromSeverity;
})(MarkerSeverity || (MarkerSeverity = {}));
var IMarkerData;
(function (IMarkerData) {
    var emptyString = '';
    function makeKey(markerData) {
        var result = [emptyString];
        if (markerData.source) {
            result.push(markerData.source.replace('¦', '\¦'));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.code) {
            result.push(markerData.code.replace('¦', '\¦'));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.severity !== void 0 && markerData.severity !== null) {
            result.push(MarkerSeverity.toString(markerData.severity));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.message) {
            result.push(markerData.message.replace('¦', '\¦'));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.startLineNumber !== void 0 && markerData.startLineNumber !== null) {
            result.push(markerData.startLineNumber.toString());
        }
        else {
            result.push(emptyString);
        }
        if (markerData.startColumn !== void 0 && markerData.startColumn !== null) {
            result.push(markerData.startColumn.toString());
        }
        else {
            result.push(emptyString);
        }
        if (markerData.endLineNumber !== void 0 && markerData.endLineNumber !== null) {
            result.push(markerData.endLineNumber.toString());
        }
        else {
            result.push(emptyString);
        }
        if (markerData.endColumn !== void 0 && markerData.endColumn !== null) {
            result.push(markerData.endColumn.toString());
        }
        else {
            result.push(emptyString);
        }
        result.push(emptyString);
        return result.join('¦');
    }
    IMarkerData.makeKey = makeKey;
})(IMarkerData || (IMarkerData = {}));
var IMarkerService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('markerService');


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = standardMouseMoveMerger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalMouseMoveMonitor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iframe_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mouseEvent_js__ = __webpack_require__(37);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




function standardMouseMoveMerger(lastEvent, currentEvent) {
    var ev = new __WEBPACK_IMPORTED_MODULE_3__mouseEvent_js__["b" /* StandardMouseEvent */](currentEvent);
    ev.preventDefault();
    return {
        leftButton: ev.leftButton,
        posx: ev.posx,
        posy: ev.posy
    };
}
var GlobalMouseMoveMonitor = /** @class */ (function (_super) {
    __extends(GlobalMouseMoveMonitor, _super);
    function GlobalMouseMoveMonitor() {
        var _this = _super.call(this) || this;
        _this.hooks = [];
        _this.mouseMoveEventMerger = null;
        _this.mouseMoveCallback = null;
        _this.onStopCallback = null;
        return _this;
    }
    GlobalMouseMoveMonitor.prototype.dispose = function () {
        this.stopMonitoring(false);
        _super.prototype.dispose.call(this);
    };
    GlobalMouseMoveMonitor.prototype.stopMonitoring = function (invokeStopCallback) {
        if (!this.isMonitoring()) {
            // Not monitoring
            return;
        }
        // Unhook
        this.hooks = Object(__WEBPACK_IMPORTED_MODULE_0__common_lifecycle_js__["d" /* dispose */])(this.hooks);
        this.mouseMoveEventMerger = null;
        this.mouseMoveCallback = null;
        var onStopCallback = this.onStopCallback;
        this.onStopCallback = null;
        if (invokeStopCallback) {
            onStopCallback();
        }
    };
    GlobalMouseMoveMonitor.prototype.isMonitoring = function () {
        return this.hooks.length > 0;
    };
    GlobalMouseMoveMonitor.prototype.startMonitoring = function (mouseMoveEventMerger, mouseMoveCallback, onStopCallback) {
        var _this = this;
        if (this.isMonitoring()) {
            // I am already hooked
            return;
        }
        this.mouseMoveEventMerger = mouseMoveEventMerger;
        this.mouseMoveCallback = mouseMoveCallback;
        this.onStopCallback = onStopCallback;
        var windowChain = __WEBPACK_IMPORTED_MODULE_2__iframe_js__["a" /* IframeUtils */].getSameOriginWindowChain();
        for (var i = 0; i < windowChain.length; i++) {
            this.hooks.push(__WEBPACK_IMPORTED_MODULE_1__dom_js__["i" /* addDisposableThrottledListener */](windowChain[i].window.document, 'mousemove', function (data) { return _this.mouseMoveCallback(data); }, function (lastEvent, currentEvent) { return _this.mouseMoveEventMerger(lastEvent, currentEvent); }));
            this.hooks.push(__WEBPACK_IMPORTED_MODULE_1__dom_js__["g" /* addDisposableListener */](windowChain[i].window.document, 'mouseup', function (e) { return _this.stopMonitoring(true); }));
        }
        if (__WEBPACK_IMPORTED_MODULE_2__iframe_js__["a" /* IframeUtils */].hasDifferentOriginAncestor()) {
            var lastSameOriginAncestor = windowChain[windowChain.length - 1];
            // We might miss a mouse up if it happens outside the iframe
            // This one is for Chrome
            this.hooks.push(__WEBPACK_IMPORTED_MODULE_1__dom_js__["g" /* addDisposableListener */](lastSameOriginAncestor.window.document, 'mouseout', function (browserEvent) {
                var e = new __WEBPACK_IMPORTED_MODULE_3__mouseEvent_js__["b" /* StandardMouseEvent */](browserEvent);
                if (e.target.tagName.toLowerCase() === 'html') {
                    _this.stopMonitoring(true);
                }
            }));
            // This one is for FF
            this.hooks.push(__WEBPACK_IMPORTED_MODULE_1__dom_js__["g" /* addDisposableListener */](lastSameOriginAncestor.window.document, 'mouseover', function (browserEvent) {
                var e = new __WEBPACK_IMPORTED_MODULE_3__mouseEvent_js__["b" /* StandardMouseEvent */](browserEvent);
                if (e.target.tagName.toLowerCase() === 'html') {
                    _this.stopMonitoring(true);
                }
            }));
            // This one is for IE
            this.hooks.push(__WEBPACK_IMPORTED_MODULE_1__dom_js__["g" /* addDisposableListener */](lastSameOriginAncestor.window.document.body, 'mouseleave', function (browserEvent) {
                _this.stopMonitoring(true);
            }));
        }
    };
    return GlobalMouseMoveMonitor;
}(__WEBPACK_IMPORTED_MODULE_0__common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StableEditorScrollState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var EditorState = /** @class */ (function () {
    function EditorState(editor, flags) {
        this.flags = flags;
        if ((this.flags & 1 /* Value */) !== 0) {
            var model = editor.getModel();
            this.modelVersionId = model ? __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"]('{0}#{1}', model.uri.toString(), model.getVersionId()) : null;
        }
        if ((this.flags & 4 /* Position */) !== 0) {
            this.position = editor.getPosition();
        }
        if ((this.flags & 2 /* Selection */) !== 0) {
            this.selection = editor.getSelection();
        }
        if ((this.flags & 8 /* Scroll */) !== 0) {
            this.scrollLeft = editor.getScrollLeft();
            this.scrollTop = editor.getScrollTop();
        }
    }
    EditorState.prototype._equals = function (other) {
        if (!(other instanceof EditorState)) {
            return false;
        }
        var state = other;
        if (this.modelVersionId !== state.modelVersionId) {
            return false;
        }
        if (this.scrollLeft !== state.scrollLeft || this.scrollTop !== state.scrollTop) {
            return false;
        }
        if (!this.position && state.position || this.position && !state.position || this.position && state.position && !this.position.equals(state.position)) {
            return false;
        }
        if (!this.selection && state.selection || this.selection && !state.selection || this.selection && state.selection && !this.selection.equalsRange(state.selection)) {
            return false;
        }
        return true;
    };
    EditorState.prototype.validate = function (editor) {
        return this._equals(new EditorState(editor, this.flags));
    };
    return EditorState;
}());

var StableEditorScrollState = /** @class */ (function () {
    function StableEditorScrollState(_visiblePosition, _visiblePositionScrollDelta) {
        this._visiblePosition = _visiblePosition;
        this._visiblePositionScrollDelta = _visiblePositionScrollDelta;
    }
    StableEditorScrollState.capture = function (editor) {
        var visiblePosition = null;
        var visiblePositionScrollDelta = 0;
        if (editor.getScrollTop() !== 0) {
            var visibleRanges = editor.getVisibleRanges();
            if (visibleRanges.length > 0) {
                visiblePosition = visibleRanges[0].getStartPosition();
                var visiblePositionScrollTop = editor.getTopForPosition(visiblePosition.lineNumber, visiblePosition.column);
                visiblePositionScrollDelta = editor.getScrollTop() - visiblePositionScrollTop;
            }
        }
        return new StableEditorScrollState(visiblePosition, visiblePositionScrollDelta);
    };
    StableEditorScrollState.prototype.restore = function (editor) {
        if (this._visiblePosition) {
            var visiblePositionScrollTop = editor.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
            editor.setScrollTop(visiblePositionScrollTop + this._visiblePositionScrollDelta);
        }
    };
    return StableEditorScrollState;
}());



/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BaseActionItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Separator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ActionsOrientation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionbar_css__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__actionbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_actions_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__touch_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var BaseActionItem = /** @class */ (function () {
    function BaseActionItem(context, action, options) {
        var _this = this;
        this.options = options;
        this._callOnDispose = [];
        this._context = context || this;
        this._action = action;
        if (action instanceof __WEBPACK_IMPORTED_MODULE_5__common_actions_js__["a" /* Action */]) {
            this._callOnDispose.push(action.onDidChange(function (event) {
                if (!_this.builder) {
                    // we have not been rendered yet, so there
                    // is no point in updating the UI
                    return;
                }
                _this._handleActionChangeEvent(event);
            }));
        }
    }
    BaseActionItem.prototype._handleActionChangeEvent = function (event) {
        if (event.enabled !== void 0) {
            this._updateEnabled();
        }
        if (event.checked !== void 0) {
            this._updateChecked();
        }
        if (event.class !== void 0) {
            this._updateClass();
        }
        if (event.label !== void 0) {
            this._updateLabel();
            this._updateTooltip();
        }
        if (event.tooltip !== void 0) {
            this._updateTooltip();
        }
    };
    Object.defineProperty(BaseActionItem.prototype, "actionRunner", {
        get: function () {
            return this._actionRunner;
        },
        set: function (actionRunner) {
            this._actionRunner = actionRunner;
        },
        enumerable: true,
        configurable: true
    });
    BaseActionItem.prototype.getAction = function () {
        return this._action;
    };
    BaseActionItem.prototype.isEnabled = function () {
        return this._action.enabled;
    };
    BaseActionItem.prototype.setActionContext = function (newContext) {
        this._context = newContext;
    };
    BaseActionItem.prototype.render = function (container) {
        var _this = this;
        this.builder = Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(container);
        __WEBPACK_IMPORTED_MODULE_8__touch_js__["b" /* Gesture */].addTarget(container);
        var enableDragging = this.options && this.options.draggable;
        if (enableDragging) {
            container.draggable = true;
        }
        this.builder.on(__WEBPACK_IMPORTED_MODULE_8__touch_js__["a" /* EventType */].Tap, function (e) { return _this.onClick(e); });
        this.builder.on(__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].MOUSE_DOWN, function (e) {
            if (!enableDragging) {
                __WEBPACK_IMPORTED_MODULE_6__dom_js__["c" /* EventHelper */].stop(e, true); // do not run when dragging is on because that would disable it
            }
            var mouseEvent = e;
            if (_this._action.enabled && mouseEvent.button === 0) {
                _this.builder.addClass('active');
            }
        });
        this.builder.on(__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].CLICK, function (e) {
            __WEBPACK_IMPORTED_MODULE_6__dom_js__["c" /* EventHelper */].stop(e, true);
            // See https://developer.mozilla.org/en-US/Add-ons/WebExtensions/Interact_with_the_clipboard
            // > Writing to the clipboard
            // > You can use the "cut" and "copy" commands without any special
            // permission if you are using them in a short-lived event handler
            // for a user action (for example, a click handler).
            // => to get the Copy and Paste context menu actions working on Firefox,
            // there should be no timeout here
            if (_this.options && _this.options.isMenu) {
                _this.onClick(e);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__common_platform_js__["h" /* setImmediate */](function () { return _this.onClick(e); });
            }
        });
        this.builder.on([__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].MOUSE_UP, __WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].MOUSE_OUT], function (e) {
            __WEBPACK_IMPORTED_MODULE_6__dom_js__["c" /* EventHelper */].stop(e);
            _this.builder.removeClass('active');
        });
    };
    BaseActionItem.prototype.onClick = function (event) {
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["c" /* EventHelper */].stop(event, true);
        var context;
        if (__WEBPACK_IMPORTED_MODULE_7__common_types_js__["j" /* isUndefinedOrNull */](this._context) || !__WEBPACK_IMPORTED_MODULE_7__common_types_js__["g" /* isObject */](this._context)) {
            context = event;
        }
        else {
            context = this._context;
            context.event = event;
        }
        this._actionRunner.run(this._action, context);
    };
    BaseActionItem.prototype._updateEnabled = function () {
        // implement in subclass
    };
    BaseActionItem.prototype._updateLabel = function () {
        // implement in subclass
    };
    BaseActionItem.prototype._updateTooltip = function () {
        // implement in subclass
    };
    BaseActionItem.prototype._updateClass = function () {
        // implement in subclass
    };
    BaseActionItem.prototype._updateChecked = function () {
        // implement in subclass
    };
    BaseActionItem.prototype.dispose = function () {
        if (this.builder) {
            this.builder.destroy();
            this.builder = null;
        }
        this._callOnDispose = __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */](this._callOnDispose);
    };
    return BaseActionItem;
}());

var Separator = /** @class */ (function (_super) {
    __extends(Separator, _super);
    function Separator(label, order) {
        var _this = _super.call(this, Separator.ID, label, label ? 'separator text' : 'separator') || this;
        _this.checked = false;
        _this.radio = false;
        _this.enabled = false;
        _this.order = order;
        return _this;
    }
    Separator.ID = 'vs.actions.separator';
    return Separator;
}(__WEBPACK_IMPORTED_MODULE_5__common_actions_js__["a" /* Action */]));

var ActionItem = /** @class */ (function (_super) {
    __extends(ActionItem, _super);
    function ActionItem(context, action, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, context, action, options) || this;
        _this.options = options;
        _this.options.icon = options.icon !== undefined ? options.icon : false;
        _this.options.label = options.label !== undefined ? options.label : true;
        _this.cssClass = '';
        return _this;
    }
    ActionItem.prototype.render = function (container) {
        _super.prototype.render.call(this, container);
        this.$e = Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])('a.action-label').appendTo(this.builder);
        if (this._action.id === Separator.ID) {
            // A separator is a presentation item
            this.$e.attr({ role: 'presentation' });
        }
        else {
            if (this.options.isMenu) {
                this.$e.attr({ role: 'menuitem' });
            }
            else {
                this.$e.attr({ role: 'button' });
            }
        }
        if (this.options.label && this.options.keybinding) {
            Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])('span.keybinding').text(this.options.keybinding).appendTo(this.builder);
        }
        this._updateClass();
        this._updateLabel();
        this._updateTooltip();
        this._updateEnabled();
        this._updateChecked();
    };
    ActionItem.prototype._updateLabel = function () {
        if (this.options.label) {
            this.$e.text(this.getAction().label);
        }
    };
    ActionItem.prototype._updateTooltip = function () {
        var title = null;
        if (this.getAction().tooltip) {
            title = this.getAction().tooltip;
        }
        else if (!this.options.label && this.getAction().label && this.options.icon) {
            title = this.getAction().label;
            if (this.options.keybinding) {
                title = __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]({ key: 'titleLabel', comment: ['action title', 'action keybinding'] }, "{0} ({1})", title, this.options.keybinding);
            }
        }
        if (title) {
            this.$e.attr({ title: title });
        }
    };
    ActionItem.prototype._updateClass = function () {
        if (this.cssClass) {
            this.$e.removeClass(this.cssClass);
        }
        if (this.options.icon) {
            this.cssClass = this.getAction().class;
            this.$e.addClass('icon');
            if (this.cssClass) {
                this.$e.addClass(this.cssClass);
            }
            this._updateEnabled();
        }
        else {
            this.$e.removeClass('icon');
        }
    };
    ActionItem.prototype._updateEnabled = function () {
        if (this.getAction().enabled) {
            this.builder.removeClass('disabled');
            this.$e.removeClass('disabled');
            this.$e.attr({ tabindex: 0 });
        }
        else {
            this.builder.addClass('disabled');
            this.$e.addClass('disabled');
            __WEBPACK_IMPORTED_MODULE_6__dom_js__["H" /* removeTabIndexAndUpdateFocus */](this.$e.getHTMLElement());
        }
    };
    ActionItem.prototype._updateChecked = function () {
        if (this.getAction().checked) {
            this.$e.addClass('checked');
        }
        else {
            this.$e.removeClass('checked');
        }
    };
    return ActionItem;
}(BaseActionItem));

var ActionsOrientation;
(function (ActionsOrientation) {
    ActionsOrientation[ActionsOrientation["HORIZONTAL"] = 0] = "HORIZONTAL";
    ActionsOrientation[ActionsOrientation["HORIZONTAL_REVERSE"] = 1] = "HORIZONTAL_REVERSE";
    ActionsOrientation[ActionsOrientation["VERTICAL"] = 2] = "VERTICAL";
    ActionsOrientation[ActionsOrientation["VERTICAL_REVERSE"] = 3] = "VERTICAL_REVERSE";
})(ActionsOrientation || (ActionsOrientation = {}));
var defaultOptions = {
    orientation: ActionsOrientation.HORIZONTAL,
    context: null
};
var ActionBar = /** @class */ (function () {
    function ActionBar(container, options) {
        if (options === void 0) { options = defaultOptions; }
        var _this = this;
        this._onDidBlur = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this._onDidCancel = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this._onDidRun = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this._onDidBeforeRun = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this.options = options;
        this._context = options.context;
        this.toDispose = [];
        this._actionRunner = this.options.actionRunner;
        if (!this._actionRunner) {
            this._actionRunner = new __WEBPACK_IMPORTED_MODULE_5__common_actions_js__["b" /* ActionRunner */]();
            this.toDispose.push(this._actionRunner);
        }
        this.toDispose.push(this._actionRunner.onDidRun(function (e) { return _this._onDidRun.fire(e); }));
        this.toDispose.push(this._actionRunner.onDidBeforeRun(function (e) { return _this._onDidBeforeRun.fire(e); }));
        this.items = [];
        this.focusedItem = undefined;
        this.domNode = document.createElement('div');
        this.domNode.className = 'monaco-action-bar';
        if (options.animated !== false) {
            __WEBPACK_IMPORTED_MODULE_6__dom_js__["f" /* addClass */](this.domNode, 'animated');
        }
        var previousKey;
        var nextKey;
        switch (this.options.orientation) {
            case ActionsOrientation.HORIZONTAL:
                previousKey = 15 /* LeftArrow */;
                nextKey = 17 /* RightArrow */;
                break;
            case ActionsOrientation.HORIZONTAL_REVERSE:
                previousKey = 17 /* RightArrow */;
                nextKey = 15 /* LeftArrow */;
                this.domNode.className += ' reverse';
                break;
            case ActionsOrientation.VERTICAL:
                previousKey = 16 /* UpArrow */;
                nextKey = 18 /* DownArrow */;
                this.domNode.className += ' vertical';
                break;
            case ActionsOrientation.VERTICAL_REVERSE:
                previousKey = 18 /* DownArrow */;
                nextKey = 16 /* UpArrow */;
                this.domNode.className += ' vertical reverse';
                break;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(this.domNode).on(__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
            var event = new __WEBPACK_IMPORTED_MODULE_9__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
            var eventHandled = true;
            if (event.equals(previousKey)) {
                _this.focusPrevious();
            }
            else if (event.equals(nextKey)) {
                _this.focusNext();
            }
            else if (event.equals(9 /* Escape */)) {
                _this.cancel();
            }
            else if (event.equals(3 /* Enter */) || event.equals(10 /* Space */)) {
                // Nothing, just staying out of the else branch
            }
            else {
                eventHandled = false;
            }
            if (eventHandled) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
        Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(this.domNode).on(__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].KEY_UP, function (e) {
            var event = new __WEBPACK_IMPORTED_MODULE_9__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
            // Run action on Enter/Space
            if (event.equals(3 /* Enter */) || event.equals(10 /* Space */)) {
                _this.doTrigger(event);
                event.preventDefault();
                event.stopPropagation();
            }
            // Recompute focused item
            else if (event.equals(2 /* Tab */) || event.equals(1024 /* Shift */ | 2 /* Tab */)) {
                _this.updateFocusedItem();
            }
        });
        this.focusTracker = __WEBPACK_IMPORTED_MODULE_6__dom_js__["O" /* trackFocus */](this.domNode);
        this.toDispose.push(this.focusTracker.onDidBlur(function () {
            if (document.activeElement === _this.domNode || !__WEBPACK_IMPORTED_MODULE_6__dom_js__["B" /* isAncestor */](document.activeElement, _this.domNode)) {
                _this._onDidBlur.fire();
                _this.focusedItem = undefined;
            }
        }));
        this.toDispose.push(this.focusTracker.onDidFocus(function () { return _this.updateFocusedItem(); }));
        this.actionsList = document.createElement('ul');
        this.actionsList.className = 'actions-container';
        if (this.options.isMenu) {
            this.actionsList.setAttribute('role', 'menu');
        }
        else {
            this.actionsList.setAttribute('role', 'toolbar');
        }
        if (this.options.ariaLabel) {
            this.actionsList.setAttribute('aria-label', this.options.ariaLabel);
        }
        if (this.options.isMenu) {
            this.domNode.tabIndex = 0;
            Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(this.domNode).on(__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].MOUSE_OUT, function (e) {
                var relatedTarget = e.relatedTarget;
                if (!__WEBPACK_IMPORTED_MODULE_6__dom_js__["B" /* isAncestor */](relatedTarget, _this.domNode)) {
                    _this.focusedItem = undefined;
                    _this.updateFocus();
                    e.stopPropagation();
                }
            });
            Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(this.actionsList).on(__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].MOUSE_OVER, function (e) {
                var target = e.target;
                if (!target || !__WEBPACK_IMPORTED_MODULE_6__dom_js__["B" /* isAncestor */](target, _this.actionsList) || target === _this.actionsList) {
                    return;
                }
                while (target.parentElement !== _this.actionsList) {
                    target = target.parentElement;
                }
                if (__WEBPACK_IMPORTED_MODULE_6__dom_js__["z" /* hasClass */](target, 'action-item')) {
                    var lastFocusedItem = _this.focusedItem;
                    _this.setFocusedItem(target);
                    if (lastFocusedItem !== _this.focusedItem) {
                        _this.updateFocus();
                    }
                }
            });
        }
        this.domNode.appendChild(this.actionsList);
        container.appendChild(this.domNode);
    }
    Object.defineProperty(ActionBar.prototype, "onDidBlur", {
        get: function () {
            return this._onDidBlur.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionBar.prototype, "onDidCancel", {
        get: function () {
            return this._onDidCancel.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionBar.prototype, "onDidRun", {
        get: function () {
            return this._onDidRun.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionBar.prototype, "onDidBeforeRun", {
        get: function () {
            return this._onDidBeforeRun.event;
        },
        enumerable: true,
        configurable: true
    });
    ActionBar.prototype.setFocusedItem = function (element) {
        for (var i = 0; i < this.actionsList.children.length; i++) {
            var elem = this.actionsList.children[i];
            if (element === elem) {
                this.focusedItem = i;
                break;
            }
        }
    };
    ActionBar.prototype.updateFocusedItem = function () {
        for (var i = 0; i < this.actionsList.children.length; i++) {
            var elem = this.actionsList.children[i];
            if (__WEBPACK_IMPORTED_MODULE_6__dom_js__["B" /* isAncestor */](document.activeElement, elem)) {
                this.focusedItem = i;
                break;
            }
        }
    };
    Object.defineProperty(ActionBar.prototype, "context", {
        get: function () {
            return this._context;
        },
        set: function (context) {
            this._context = context;
            this.items.forEach(function (i) { return i.setActionContext(context); });
        },
        enumerable: true,
        configurable: true
    });
    ActionBar.prototype.getContainer = function () {
        return this.domNode;
    };
    ActionBar.prototype.push = function (arg, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var actions = !Array.isArray(arg) ? [arg] : arg;
        var index = __WEBPACK_IMPORTED_MODULE_7__common_types_js__["f" /* isNumber */](options.index) ? options.index : null;
        actions.forEach(function (action) {
            var actionItemElement = document.createElement('li');
            actionItemElement.className = 'action-item';
            actionItemElement.setAttribute('role', 'presentation');
            // Prevent native context menu on actions
            Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(actionItemElement).on(__WEBPACK_IMPORTED_MODULE_6__dom_js__["d" /* EventType */].CONTEXT_MENU, function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
            var item = null;
            if (_this.options.actionItemProvider) {
                item = _this.options.actionItemProvider(action);
            }
            if (!item) {
                item = new ActionItem(_this.context, action, options);
            }
            item.actionRunner = _this._actionRunner;
            item.setActionContext(_this.context);
            item.render(actionItemElement);
            if (index === null || index < 0 || index >= _this.actionsList.children.length) {
                _this.actionsList.appendChild(actionItemElement);
                _this.items.push(item);
            }
            else {
                _this.actionsList.insertBefore(actionItemElement, _this.actionsList.children[index]);
                _this.items.splice(index, 0, item);
                index++;
            }
        });
    };
    ActionBar.prototype.clear = function () {
        this.items = __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */](this.items);
        Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(this.actionsList).empty();
    };
    ActionBar.prototype.isEmpty = function () {
        return this.items.length === 0;
    };
    ActionBar.prototype.focus = function (selectFirst) {
        if (selectFirst && typeof this.focusedItem === 'undefined') {
            // Focus the first enabled item
            this.focusedItem = this.items.length - 1;
            this.focusNext();
        }
        else {
            this.updateFocus();
        }
    };
    ActionBar.prototype.focusNext = function () {
        if (typeof this.focusedItem === 'undefined') {
            this.focusedItem = this.items.length - 1;
        }
        var startIndex = this.focusedItem;
        var item;
        do {
            this.focusedItem = (this.focusedItem + 1) % this.items.length;
            item = this.items[this.focusedItem];
        } while (this.focusedItem !== startIndex && !item.isEnabled());
        if (this.focusedItem === startIndex && !item.isEnabled()) {
            this.focusedItem = undefined;
        }
        this.updateFocus();
    };
    ActionBar.prototype.focusPrevious = function () {
        if (typeof this.focusedItem === 'undefined') {
            this.focusedItem = 0;
        }
        var startIndex = this.focusedItem;
        var item;
        do {
            this.focusedItem = this.focusedItem - 1;
            if (this.focusedItem < 0) {
                this.focusedItem = this.items.length - 1;
            }
            item = this.items[this.focusedItem];
        } while (this.focusedItem !== startIndex && !item.isEnabled());
        if (this.focusedItem === startIndex && !item.isEnabled()) {
            this.focusedItem = undefined;
        }
        this.updateFocus(true);
    };
    ActionBar.prototype.updateFocus = function (fromRight) {
        if (typeof this.focusedItem === 'undefined') {
            this.domNode.focus();
        }
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            var actionItem = item;
            if (i === this.focusedItem) {
                if (__WEBPACK_IMPORTED_MODULE_7__common_types_js__["e" /* isFunction */](actionItem.isEnabled)) {
                    if (actionItem.isEnabled() && __WEBPACK_IMPORTED_MODULE_7__common_types_js__["e" /* isFunction */](actionItem.focus)) {
                        actionItem.focus(fromRight);
                    }
                    else {
                        this.domNode.focus();
                    }
                }
            }
            else {
                if (__WEBPACK_IMPORTED_MODULE_7__common_types_js__["e" /* isFunction */](actionItem.blur)) {
                    actionItem.blur();
                }
            }
        }
    };
    ActionBar.prototype.doTrigger = function (event) {
        if (typeof this.focusedItem === 'undefined') {
            return; //nothing to focus
        }
        // trigger action
        var actionItem = this.items[this.focusedItem];
        if (actionItem instanceof BaseActionItem) {
            var context = (actionItem._context === null || actionItem._context === undefined) ? event : actionItem._context;
            this.run(actionItem._action, context).done();
        }
    };
    ActionBar.prototype.cancel = function () {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur(); // remove focus from focused action
        }
        this._onDidCancel.fire();
    };
    ActionBar.prototype.run = function (action, context) {
        return this._actionRunner.run(action, context);
    };
    ActionBar.prototype.dispose = function () {
        if (this.items !== null) {
            __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */](this.items);
        }
        this.items = null;
        if (this.focusTracker) {
            this.focusTracker.dispose();
            this.focusTracker = null;
        }
        this.toDispose = __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */](this.toDispose);
        Object(__WEBPACK_IMPORTED_MODULE_4__builder_js__["a" /* $ */])(this.getContainer()).destroy();
    };
    return ActionBar;
}());



/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Gesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_decorators_js__ = __webpack_require__(132);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EventType;
(function (EventType) {
    EventType.Tap = '-monaco-gesturetap';
    EventType.Change = '-monaco-gesturechange';
    EventType.Start = '-monaco-gesturestart';
    EventType.End = '-monaco-gesturesend';
    EventType.Contextmenu = '-monaco-gesturecontextmenu';
})(EventType || (EventType = {}));
var Gesture = /** @class */ (function () {
    function Gesture() {
        var _this = this;
        this.toDispose = [];
        this.activeTouches = {};
        this.handle = null;
        this.targets = [];
        this.toDispose.push(__WEBPACK_IMPORTED_MODULE_2__dom_js__["g" /* addDisposableListener */](document, 'touchstart', function (e) { return _this.onTouchStart(e); }));
        this.toDispose.push(__WEBPACK_IMPORTED_MODULE_2__dom_js__["g" /* addDisposableListener */](document, 'touchend', function (e) { return _this.onTouchEnd(e); }));
        this.toDispose.push(__WEBPACK_IMPORTED_MODULE_2__dom_js__["g" /* addDisposableListener */](document, 'touchmove', function (e) { return _this.onTouchMove(e); }));
    }
    Gesture.addTarget = function (element) {
        if (!Gesture.isTouchDevice()) {
            return;
        }
        if (!Gesture.INSTANCE) {
            Gesture.INSTANCE = new Gesture();
        }
        Gesture.INSTANCE.targets.push(element);
    };
    Gesture.isTouchDevice = function () {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0;
    };
    Gesture.prototype.dispose = function () {
        if (this.handle) {
            this.handle.dispose();
            Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(this.toDispose);
            this.handle = null;
        }
    };
    Gesture.prototype.onTouchStart = function (e) {
        var timestamp = Date.now(); // use Date.now() because on FF e.timeStamp is not epoch based.
        if (this.handle) {
            this.handle.dispose();
            this.handle = null;
        }
        for (var i = 0, len = e.targetTouches.length; i < len; i++) {
            var touch = e.targetTouches.item(i);
            this.activeTouches[touch.identifier] = {
                id: touch.identifier,
                initialTarget: touch.target,
                initialTimeStamp: timestamp,
                initialPageX: touch.pageX,
                initialPageY: touch.pageY,
                rollingTimestamps: [timestamp],
                rollingPageX: [touch.pageX],
                rollingPageY: [touch.pageY]
            };
            var evt = this.newGestureEvent(EventType.Start, touch.target);
            evt.pageX = touch.pageX;
            evt.pageY = touch.pageY;
            this.dispatchEvent(evt);
        }
        if (this.dispatched) {
            e.preventDefault();
            e.stopPropagation();
            this.dispatched = false;
        }
    };
    Gesture.prototype.onTouchEnd = function (e) {
        var timestamp = Date.now(); // use Date.now() because on FF e.timeStamp is not epoch based.
        var activeTouchCount = Object.keys(this.activeTouches).length;
        var _loop_1 = function (i, len) {
            var touch = e.changedTouches.item(i);
            if (!this_1.activeTouches.hasOwnProperty(String(touch.identifier))) {
                console.warn('move of an UNKNOWN touch', touch);
                return "continue";
            }
            var data = this_1.activeTouches[touch.identifier], holdTime = Date.now() - data.initialTimeStamp;
            if (holdTime < Gesture.HOLD_DELAY
                && Math.abs(data.initialPageX - __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageX)) < 30
                && Math.abs(data.initialPageY - __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageY)) < 30) {
                var evt = this_1.newGestureEvent(EventType.Tap, data.initialTarget);
                evt.pageX = __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageX);
                evt.pageY = __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageY);
                this_1.dispatchEvent(evt);
            }
            else if (holdTime >= Gesture.HOLD_DELAY
                && Math.abs(data.initialPageX - __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageX)) < 30
                && Math.abs(data.initialPageY - __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageY)) < 30) {
                var evt = this_1.newGestureEvent(EventType.Contextmenu, data.initialTarget);
                evt.pageX = __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageX);
                evt.pageY = __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageY);
                this_1.dispatchEvent(evt);
            }
            else if (activeTouchCount === 1) {
                var finalX = __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageX);
                var finalY = __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageY);
                var deltaT = __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingTimestamps) - data.rollingTimestamps[0];
                var deltaX = finalX - data.rollingPageX[0];
                var deltaY = finalY - data.rollingPageY[0];
                // We need to get all the dispatch targets on the start of the inertia event
                var dispatchTo = this_1.targets.filter(function (t) { return data.initialTarget instanceof Node && t.contains(data.initialTarget); });
                this_1.inertia(dispatchTo, timestamp, // time now
                Math.abs(deltaX) / deltaT, // speed
                deltaX > 0 ? 1 : -1, // x direction
                finalX, // x now
                Math.abs(deltaY) / deltaT, // y speed
                deltaY > 0 ? 1 : -1, // y direction
                finalY // y now
                );
            }
            this_1.dispatchEvent(this_1.newGestureEvent(EventType.End, data.initialTarget));
            // forget about this touch
            delete this_1.activeTouches[touch.identifier];
        };
        var this_1 = this;
        for (var i = 0, len = e.changedTouches.length; i < len; i++) {
            _loop_1(i, len);
        }
        if (this.dispatched) {
            e.preventDefault();
            e.stopPropagation();
            this.dispatched = false;
        }
    };
    Gesture.prototype.newGestureEvent = function (type, intialTarget) {
        var event = document.createEvent('CustomEvent');
        event.initEvent(type, false, true);
        event.initialTarget = intialTarget;
        return event;
    };
    Gesture.prototype.dispatchEvent = function (event) {
        var _this = this;
        this.targets.forEach(function (target) {
            if (event.initialTarget instanceof Node && target.contains(event.initialTarget)) {
                target.dispatchEvent(event);
                _this.dispatched = true;
            }
        });
    };
    Gesture.prototype.inertia = function (dispatchTo, t1, vX, dirX, x, vY, dirY, y) {
        var _this = this;
        this.handle = __WEBPACK_IMPORTED_MODULE_2__dom_js__["L" /* scheduleAtNextAnimationFrame */](function () {
            var now = Date.now();
            // velocity: old speed + accel_over_time
            var deltaT = now - t1, delta_pos_x = 0, delta_pos_y = 0, stopped = true;
            vX += Gesture.SCROLL_FRICTION * deltaT;
            vY += Gesture.SCROLL_FRICTION * deltaT;
            if (vX > 0) {
                stopped = false;
                delta_pos_x = dirX * vX * deltaT;
            }
            if (vY > 0) {
                stopped = false;
                delta_pos_y = dirY * vY * deltaT;
            }
            // dispatch translation event
            var evt = _this.newGestureEvent(EventType.Change);
            evt.translationX = delta_pos_x;
            evt.translationY = delta_pos_y;
            dispatchTo.forEach(function (d) { return d.dispatchEvent(evt); });
            if (!stopped) {
                _this.inertia(dispatchTo, now, vX, dirX, x + delta_pos_x, vY, dirY, y + delta_pos_y);
            }
        });
    };
    Gesture.prototype.onTouchMove = function (e) {
        var timestamp = Date.now(); // use Date.now() because on FF e.timeStamp is not epoch based.
        for (var i = 0, len = e.changedTouches.length; i < len; i++) {
            var touch = e.changedTouches.item(i);
            if (!this.activeTouches.hasOwnProperty(String(touch.identifier))) {
                console.warn('end of an UNKNOWN touch', touch);
                continue;
            }
            var data = this.activeTouches[touch.identifier];
            var evt = this.newGestureEvent(EventType.Change, data.initialTarget);
            evt.translationX = touch.pageX - __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageX);
            evt.translationY = touch.pageY - __WEBPACK_IMPORTED_MODULE_0__common_arrays_js__["n" /* tail */](data.rollingPageY);
            evt.pageX = touch.pageX;
            evt.pageY = touch.pageY;
            this.dispatchEvent(evt);
            // only keep a few data points, to average the final speed
            if (data.rollingPageX.length > 3) {
                data.rollingPageX.shift();
                data.rollingPageY.shift();
                data.rollingTimestamps.shift();
            }
            data.rollingPageX.push(touch.pageX);
            data.rollingPageY.push(touch.pageY);
            data.rollingTimestamps.push(timestamp);
        }
        if (this.dispatched) {
            e.preventDefault();
            e.stopPropagation();
            this.dispatched = false;
        }
    };
    Gesture.SCROLL_FRICTION = -0.005;
    Gesture.HOLD_DELAY = 700;
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3__common_decorators_js__["a" /* memoize */]
    ], Gesture, "isTouchDevice", null);
    return Gesture;
}());



/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplaceCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ReplaceCommandWithoutChangingPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ReplaceCommandWithOffsetCursorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReplaceCommandThatPreservesSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_selection_js__ = __webpack_require__(18);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ReplaceCommand = /** @class */ (function () {
    function ReplaceCommand(range, text, insertsAutoWhitespace) {
        if (insertsAutoWhitespace === void 0) { insertsAutoWhitespace = false; }
        this._range = range;
        this._text = text;
        this.insertsAutoWhitespace = insertsAutoWhitespace;
    }
    ReplaceCommand.prototype.getEditOperations = function (model, builder) {
        builder.addTrackedEditOperation(this._range, this._text);
    };
    ReplaceCommand.prototype.computeCursorState = function (model, helper) {
        var inverseEditOperations = helper.getInverseEditOperations();
        var srcRange = inverseEditOperations[0].range;
        return new __WEBPACK_IMPORTED_MODULE_0__core_selection_js__["a" /* Selection */](srcRange.endLineNumber, srcRange.endColumn, srcRange.endLineNumber, srcRange.endColumn);
    };
    return ReplaceCommand;
}());

var ReplaceCommandWithoutChangingPosition = /** @class */ (function () {
    function ReplaceCommandWithoutChangingPosition(range, text, insertsAutoWhitespace) {
        if (insertsAutoWhitespace === void 0) { insertsAutoWhitespace = false; }
        this._range = range;
        this._text = text;
        this.insertsAutoWhitespace = insertsAutoWhitespace;
    }
    ReplaceCommandWithoutChangingPosition.prototype.getEditOperations = function (model, builder) {
        builder.addTrackedEditOperation(this._range, this._text);
    };
    ReplaceCommandWithoutChangingPosition.prototype.computeCursorState = function (model, helper) {
        var inverseEditOperations = helper.getInverseEditOperations();
        var srcRange = inverseEditOperations[0].range;
        return new __WEBPACK_IMPORTED_MODULE_0__core_selection_js__["a" /* Selection */](srcRange.startLineNumber, srcRange.startColumn, srcRange.startLineNumber, srcRange.startColumn);
    };
    return ReplaceCommandWithoutChangingPosition;
}());

var ReplaceCommandWithOffsetCursorState = /** @class */ (function () {
    function ReplaceCommandWithOffsetCursorState(range, text, lineNumberDeltaOffset, columnDeltaOffset, insertsAutoWhitespace) {
        if (insertsAutoWhitespace === void 0) { insertsAutoWhitespace = false; }
        this._range = range;
        this._text = text;
        this._columnDeltaOffset = columnDeltaOffset;
        this._lineNumberDeltaOffset = lineNumberDeltaOffset;
        this.insertsAutoWhitespace = insertsAutoWhitespace;
    }
    ReplaceCommandWithOffsetCursorState.prototype.getEditOperations = function (model, builder) {
        builder.addTrackedEditOperation(this._range, this._text);
    };
    ReplaceCommandWithOffsetCursorState.prototype.computeCursorState = function (model, helper) {
        var inverseEditOperations = helper.getInverseEditOperations();
        var srcRange = inverseEditOperations[0].range;
        return new __WEBPACK_IMPORTED_MODULE_0__core_selection_js__["a" /* Selection */](srcRange.endLineNumber + this._lineNumberDeltaOffset, srcRange.endColumn + this._columnDeltaOffset, srcRange.endLineNumber + this._lineNumberDeltaOffset, srcRange.endColumn + this._columnDeltaOffset);
    };
    return ReplaceCommandWithOffsetCursorState;
}());

var ReplaceCommandThatPreservesSelection = /** @class */ (function () {
    function ReplaceCommandThatPreservesSelection(editRange, text, initialSelection) {
        this._range = editRange;
        this._text = text;
        this._initialSelection = initialSelection;
    }
    ReplaceCommandThatPreservesSelection.prototype.getEditOperations = function (model, builder) {
        builder.addEditOperation(this._range, this._text);
        this._selectionId = builder.trackSelection(this._initialSelection);
    };
    ReplaceCommandThatPreservesSelection.prototype.computeCursorState = function (model, helper) {
        return helper.getTrackedSelection(this._selectionId);
    };
    return ReplaceCommandThatPreservesSelection;
}());



/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IStorageService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StorageScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NullStorageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ID = 'storageService';
var IStorageService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])(ID);
var StorageScope;
(function (StorageScope) {
    /**
     * The stored data will be scoped to all workspaces of this domain.
     */
    StorageScope[StorageScope["GLOBAL"] = 0] = "GLOBAL";
    /**
     * The stored data will be scoped to the current workspace.
     */
    StorageScope[StorageScope["WORKSPACE"] = 1] = "WORKSPACE";
})(StorageScope || (StorageScope = {}));
var NullStorageService = {
    _serviceBrand: undefined,
    store: function () { return undefined; },
    remove: function () { return undefined; },
    get: function (a, b, defaultValue) { return defaultValue; },
    getInteger: function (a, b, defaultValue) { return defaultValue; },
    getBoolean: function (a, b, defaultValue) { return defaultValue; }
};


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ID_EDITOR_WORKER_SERVICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IEditorWorkerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ID_EDITOR_WORKER_SERVICE = 'editorWorkerService';
var IEditorWorkerService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])(ID_EDITOR_WORKER_SERVICE);


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewConfigurationChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ViewCursorStateChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ViewDecorationsChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ViewFlushedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ViewFocusChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ViewLineMappingChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ViewLinesChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ViewLinesDeletedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ViewLinesInsertedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ViewRevealRangeRequestEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ViewScrollChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ViewTokensChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ViewThemeChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ViewTokensColorsChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ViewZonesChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ViewLanguageConfigurationEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ViewEventEmitter; });
/* unused harmony export ViewEventsCollector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ViewConfigurationChangedEvent = /** @class */ (function () {
    function ViewConfigurationChangedEvent(source) {
        this.type = 1 /* ViewConfigurationChanged */;
        this.canUseLayerHinting = source.canUseLayerHinting;
        this.pixelRatio = source.pixelRatio;
        this.editorClassName = source.editorClassName;
        this.lineHeight = source.lineHeight;
        this.readOnly = source.readOnly;
        this.accessibilitySupport = source.accessibilitySupport;
        this.emptySelectionClipboard = source.emptySelectionClipboard;
        this.layoutInfo = source.layoutInfo;
        this.fontInfo = source.fontInfo;
        this.viewInfo = source.viewInfo;
        this.wrappingInfo = source.wrappingInfo;
    }
    return ViewConfigurationChangedEvent;
}());

var ViewCursorStateChangedEvent = /** @class */ (function () {
    function ViewCursorStateChangedEvent(selections) {
        this.type = 2 /* ViewCursorStateChanged */;
        this.selections = selections;
    }
    return ViewCursorStateChangedEvent;
}());

var ViewDecorationsChangedEvent = /** @class */ (function () {
    function ViewDecorationsChangedEvent() {
        this.type = 3 /* ViewDecorationsChanged */;
        // Nothing to do
    }
    return ViewDecorationsChangedEvent;
}());

var ViewFlushedEvent = /** @class */ (function () {
    function ViewFlushedEvent() {
        this.type = 4 /* ViewFlushed */;
        // Nothing to do
    }
    return ViewFlushedEvent;
}());

var ViewFocusChangedEvent = /** @class */ (function () {
    function ViewFocusChangedEvent(isFocused) {
        this.type = 5 /* ViewFocusChanged */;
        this.isFocused = isFocused;
    }
    return ViewFocusChangedEvent;
}());

var ViewLineMappingChangedEvent = /** @class */ (function () {
    function ViewLineMappingChangedEvent() {
        this.type = 6 /* ViewLineMappingChanged */;
        // Nothing to do
    }
    return ViewLineMappingChangedEvent;
}());

var ViewLinesChangedEvent = /** @class */ (function () {
    function ViewLinesChangedEvent(fromLineNumber, toLineNumber) {
        this.type = 7 /* ViewLinesChanged */;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
    }
    return ViewLinesChangedEvent;
}());

var ViewLinesDeletedEvent = /** @class */ (function () {
    function ViewLinesDeletedEvent(fromLineNumber, toLineNumber) {
        this.type = 8 /* ViewLinesDeleted */;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
    }
    return ViewLinesDeletedEvent;
}());

var ViewLinesInsertedEvent = /** @class */ (function () {
    function ViewLinesInsertedEvent(fromLineNumber, toLineNumber) {
        this.type = 9 /* ViewLinesInserted */;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
    }
    return ViewLinesInsertedEvent;
}());

var ViewRevealRangeRequestEvent = /** @class */ (function () {
    function ViewRevealRangeRequestEvent(range, verticalType, revealHorizontal, scrollType) {
        this.type = 10 /* ViewRevealRangeRequest */;
        this.range = range;
        this.verticalType = verticalType;
        this.revealHorizontal = revealHorizontal;
        this.scrollType = scrollType;
    }
    return ViewRevealRangeRequestEvent;
}());

var ViewScrollChangedEvent = /** @class */ (function () {
    function ViewScrollChangedEvent(source) {
        this.type = 11 /* ViewScrollChanged */;
        this.scrollWidth = source.scrollWidth;
        this.scrollLeft = source.scrollLeft;
        this.scrollHeight = source.scrollHeight;
        this.scrollTop = source.scrollTop;
        this.scrollWidthChanged = source.scrollWidthChanged;
        this.scrollLeftChanged = source.scrollLeftChanged;
        this.scrollHeightChanged = source.scrollHeightChanged;
        this.scrollTopChanged = source.scrollTopChanged;
    }
    return ViewScrollChangedEvent;
}());

var ViewTokensChangedEvent = /** @class */ (function () {
    function ViewTokensChangedEvent(ranges) {
        this.type = 12 /* ViewTokensChanged */;
        this.ranges = ranges;
    }
    return ViewTokensChangedEvent;
}());

var ViewThemeChangedEvent = /** @class */ (function () {
    function ViewThemeChangedEvent() {
        this.type = 15 /* ViewThemeChanged */;
    }
    return ViewThemeChangedEvent;
}());

var ViewTokensColorsChangedEvent = /** @class */ (function () {
    function ViewTokensColorsChangedEvent() {
        this.type = 13 /* ViewTokensColorsChanged */;
        // Nothing to do
    }
    return ViewTokensColorsChangedEvent;
}());

var ViewZonesChangedEvent = /** @class */ (function () {
    function ViewZonesChangedEvent() {
        this.type = 14 /* ViewZonesChanged */;
        // Nothing to do
    }
    return ViewZonesChangedEvent;
}());

var ViewLanguageConfigurationEvent = /** @class */ (function () {
    function ViewLanguageConfigurationEvent() {
        this.type = 16 /* ViewLanguageConfigurationChanged */;
    }
    return ViewLanguageConfigurationEvent;
}());

var ViewEventEmitter = /** @class */ (function (_super) {
    __extends(ViewEventEmitter, _super);
    function ViewEventEmitter() {
        var _this = _super.call(this) || this;
        _this._listeners = [];
        _this._collector = null;
        _this._collectorCnt = 0;
        return _this;
    }
    ViewEventEmitter.prototype.dispose = function () {
        this._listeners = [];
        _super.prototype.dispose.call(this);
    };
    ViewEventEmitter.prototype._beginEmit = function () {
        this._collectorCnt++;
        if (this._collectorCnt === 1) {
            this._collector = new ViewEventsCollector();
        }
        return this._collector;
    };
    ViewEventEmitter.prototype._endEmit = function () {
        this._collectorCnt--;
        if (this._collectorCnt === 0) {
            var events = this._collector.finalize();
            this._collector = null;
            if (events.length > 0) {
                this._emit(events);
            }
        }
    };
    ViewEventEmitter.prototype._emit = function (events) {
        var listeners = this._listeners.slice(0);
        for (var i = 0, len = listeners.length; i < len; i++) {
            safeInvokeListener(listeners[i], events);
        }
    };
    ViewEventEmitter.prototype.addEventListener = function (listener) {
        var _this = this;
        this._listeners.push(listener);
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            var listeners = _this._listeners;
            for (var i = 0, len = listeners.length; i < len; i++) {
                if (listeners[i] === listener) {
                    listeners.splice(i, 1);
                    break;
                }
            }
        });
    };
    return ViewEventEmitter;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));

var ViewEventsCollector = /** @class */ (function () {
    function ViewEventsCollector() {
        this._eventsLen = 0;
        this._events = [];
        this._eventsLen = 0;
    }
    ViewEventsCollector.prototype.emit = function (event) {
        this._events[this._eventsLen++] = event;
    };
    ViewEventsCollector.prototype.finalize = function () {
        var result = this._events;
        this._events = null;
        return result;
    };
    return ViewEventsCollector;
}());

function safeInvokeListener(listener, events) {
    try {
        listener(events);
    }
    catch (e) {
        __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */](e);
    }
}


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        getWorkerUrl: function (moduleId, label) {
          const pathPrefix = (typeof window.__webpack_public_path__ === 'string' ? window.__webpack_public_path__ : "/");
          return (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
        }
      };
    })({
  "editorWorkerService": "editor.worker.js",
  "css": "css.worker.js",
  "html": "html.worker.js",
  "json": "json.worker.js",
  "typescript": "typescript.worker.js",
  "javascript": "typescript.worker.js",
  "less": "css.worker.js",
  "scss": "css.worker.js"
});
__webpack_require__(115);
__webpack_require__(120);
__webpack_require__(122);
__webpack_require__(123);
__webpack_require__(124);
__webpack_require__(129);
__webpack_require__(100);
__webpack_require__(130);
__webpack_require__(131);
__webpack_require__(84);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(101);
__webpack_require__(140);
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(103);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(166);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(89);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(91);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(111);
__webpack_require__(187);
module.exports = __webpack_require__(513);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(188);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return domEvent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = stop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var domEvent = function (element, type, useCapture) {
    var fn = function (e) { return emitter.fire(e); };
    var emitter = new __WEBPACK_IMPORTED_MODULE_0__common_event_js__["a" /* Emitter */]({
        onFirstListenerAdd: function () {
            element.addEventListener(type, fn, useCapture);
        },
        onLastListenerRemove: function () {
            element.removeEventListener(type, fn, useCapture);
        }
    });
    return emitter.event;
};
function stop(event) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common_event_js__["j" /* mapEvent */])(event, function (e) {
        e.preventDefault();
        e.stopPropagation();
        return e;
    });
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ok;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Throws an error with the provided message if the provided value does not evaluate to a true Javascript value.
 */
function ok(value, message) {
    if (!value || value === null) {
        throw new Error(message ? 'Assertion failed (' + message + ')' : 'Assertion Failed');
    }
}


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ITelemetryService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ITelemetryService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('telemetryService');


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Extensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigurationScope; });
/* unused harmony export allSettings */
/* unused harmony export applicationSettings */
/* unused harmony export windowSettings */
/* unused harmony export resourceSettings */
/* unused harmony export editorConfigurationSchemaId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OVERRIDE_PROPERTY_PATTERN; });
/* unused harmony export validateProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsonschemas_common_jsonContributionRegistry_js__ = __webpack_require__(314);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/







var Extensions = {
    Configuration: 'base.contributions.configuration'
};
var ConfigurationScope;
(function (ConfigurationScope) {
    ConfigurationScope[ConfigurationScope["APPLICATION"] = 1] = "APPLICATION";
    ConfigurationScope[ConfigurationScope["WINDOW"] = 2] = "WINDOW";
    ConfigurationScope[ConfigurationScope["RESOURCE"] = 3] = "RESOURCE";
})(ConfigurationScope || (ConfigurationScope = {}));
var allSettings = { properties: {}, patternProperties: {} };
var applicationSettings = { properties: {}, patternProperties: {} };
var windowSettings = { properties: {}, patternProperties: {} };
var resourceSettings = { properties: {}, patternProperties: {} };
var editorConfigurationSchemaId = 'vscode://schemas/settings/editor';
var contributionRegistry = __WEBPACK_IMPORTED_MODULE_2__registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_5__jsonschemas_common_jsonContributionRegistry_js__["a" /* Extensions */].JSONContribution);
var ConfigurationRegistry = /** @class */ (function () {
    function ConfigurationRegistry() {
        this.overrideIdentifiers = [];
        this._onDidSchemaChange = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this._onDidRegisterConfiguration = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.configurationContributors = [];
        this.editorConfigurationSchema = { properties: {}, patternProperties: {}, additionalProperties: false, errorMessage: 'Unknown editor configuration setting' };
        this.configurationProperties = {};
        this.excludedConfigurationProperties = {};
        this.computeOverridePropertyPattern();
        contributionRegistry.registerSchema(editorConfigurationSchemaId, this.editorConfigurationSchema);
    }
    ConfigurationRegistry.prototype.registerConfiguration = function (configuration, validate) {
        if (validate === void 0) { validate = true; }
        this.registerConfigurations([configuration], [], validate);
    };
    ConfigurationRegistry.prototype.registerConfigurations = function (configurations, defaultConfigurations, validate) {
        var _this = this;
        if (validate === void 0) { validate = true; }
        var configurationNode = this.toConfiguration(defaultConfigurations);
        if (configurationNode) {
            configurations.push(configurationNode);
        }
        var properties = [];
        configurations.forEach(function (configuration) {
            properties.push.apply(properties, _this.validateAndRegisterProperties(configuration, validate)); // fills in defaults
            _this.configurationContributors.push(configuration);
            _this.registerJSONConfiguration(configuration);
            _this.updateSchemaForOverrideSettingsConfiguration(configuration);
        });
        this._onDidRegisterConfiguration.fire(properties);
    };
    ConfigurationRegistry.prototype.registerOverrideIdentifiers = function (overrideIdentifiers) {
        var _a;
        (_a = this.overrideIdentifiers).push.apply(_a, overrideIdentifiers);
        this.updateOverridePropertyPatternKey();
    };
    ConfigurationRegistry.prototype.toConfiguration = function (defaultConfigurations) {
        var configurationNode = {
            id: 'defaultOverrides',
            title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('defaultConfigurations.title', "Default Configuration Overrides"),
            properties: {}
        };
        for (var _i = 0, defaultConfigurations_1 = defaultConfigurations; _i < defaultConfigurations_1.length; _i++) {
            var defaultConfiguration = defaultConfigurations_1[_i];
            for (var key in defaultConfiguration.defaults) {
                var defaultValue = defaultConfiguration.defaults[key];
                if (OVERRIDE_PROPERTY_PATTERN.test(key) && typeof defaultValue === 'object') {
                    configurationNode.properties[key] = {
                        type: 'object',
                        default: defaultValue,
                        description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overrideSettings.description', "Configure editor settings to be overridden for {0} language.", key),
                        $ref: editorConfigurationSchemaId
                    };
                }
            }
        }
        return Object.keys(configurationNode.properties).length ? configurationNode : null;
    };
    ConfigurationRegistry.prototype.validateAndRegisterProperties = function (configuration, validate, scope, overridable) {
        if (validate === void 0) { validate = true; }
        if (scope === void 0) { scope = ConfigurationScope.WINDOW; }
        if (overridable === void 0) { overridable = false; }
        scope = __WEBPACK_IMPORTED_MODULE_3__base_common_types_js__["j" /* isUndefinedOrNull */](configuration.scope) ? scope : configuration.scope;
        overridable = configuration.overridable || overridable;
        var propertyKeys = [];
        var properties = configuration.properties;
        if (properties) {
            for (var key in properties) {
                var message = void 0;
                if (validate && (message = validateProperty(key))) {
                    console.warn(message);
                    delete properties[key];
                    continue;
                }
                // fill in default values
                var property = properties[key];
                var defaultValue = property.default;
                if (__WEBPACK_IMPORTED_MODULE_3__base_common_types_js__["i" /* isUndefined */](defaultValue)) {
                    property.default = getDefaultValue(property.type);
                }
                // Inherit overridable property from parent
                if (overridable) {
                    property.overridable = true;
                }
                if (OVERRIDE_PROPERTY_PATTERN.test(key)) {
                    property.scope = void 0; // No scope for overridable properties `[${identifier}]`
                }
                else {
                    property.scope = __WEBPACK_IMPORTED_MODULE_3__base_common_types_js__["j" /* isUndefinedOrNull */](property.scope) ? scope : property.scope;
                }
                // Add to properties maps
                // Property is included by default if 'included' is unspecified
                if (properties[key].hasOwnProperty('included') && !properties[key].included) {
                    this.excludedConfigurationProperties[key] = properties[key];
                    delete properties[key];
                    continue;
                }
                else {
                    this.configurationProperties[key] = properties[key];
                }
                propertyKeys.push(key);
            }
        }
        var subNodes = configuration.allOf;
        if (subNodes) {
            for (var _i = 0, subNodes_1 = subNodes; _i < subNodes_1.length; _i++) {
                var node = subNodes_1[_i];
                propertyKeys.push.apply(propertyKeys, this.validateAndRegisterProperties(node, validate, scope, overridable));
            }
        }
        return propertyKeys;
    };
    ConfigurationRegistry.prototype.getConfigurationProperties = function () {
        return this.configurationProperties;
    };
    ConfigurationRegistry.prototype.registerJSONConfiguration = function (configuration) {
        function register(configuration) {
            var properties = configuration.properties;
            if (properties) {
                for (var key in properties) {
                    allSettings.properties[key] = properties[key];
                    switch (properties[key].scope) {
                        case ConfigurationScope.APPLICATION:
                            applicationSettings.properties[key] = properties[key];
                            break;
                        case ConfigurationScope.WINDOW:
                            windowSettings.properties[key] = properties[key];
                            break;
                        case ConfigurationScope.RESOURCE:
                            resourceSettings.properties[key] = properties[key];
                            break;
                    }
                }
            }
            var subNodes = configuration.allOf;
            if (subNodes) {
                subNodes.forEach(register);
            }
        }
        register(configuration);
        this._onDidSchemaChange.fire();
    };
    ConfigurationRegistry.prototype.updateSchemaForOverrideSettingsConfiguration = function (configuration) {
        if (configuration.id !== SETTINGS_OVERRRIDE_NODE_ID) {
            this.update(configuration);
            contributionRegistry.registerSchema(editorConfigurationSchemaId, this.editorConfigurationSchema);
        }
    };
    ConfigurationRegistry.prototype.updateOverridePropertyPatternKey = function () {
        var patternProperties = allSettings.patternProperties[this.overridePropertyPattern];
        if (!patternProperties) {
            patternProperties = {
                type: 'object',
                description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overrideSettings.defaultDescription', "Configure editor settings to be overridden for a language."),
                errorMessage: 'Unknown Identifier. Use language identifiers',
                $ref: editorConfigurationSchemaId
            };
        }
        delete allSettings.patternProperties[this.overridePropertyPattern];
        delete applicationSettings.patternProperties[this.overridePropertyPattern];
        delete windowSettings.patternProperties[this.overridePropertyPattern];
        delete resourceSettings.patternProperties[this.overridePropertyPattern];
        this.computeOverridePropertyPattern();
        allSettings.patternProperties[this.overridePropertyPattern] = patternProperties;
        applicationSettings.patternProperties[this.overridePropertyPattern] = patternProperties;
        windowSettings.patternProperties[this.overridePropertyPattern] = patternProperties;
        resourceSettings.patternProperties[this.overridePropertyPattern] = patternProperties;
        this._onDidSchemaChange.fire();
    };
    ConfigurationRegistry.prototype.update = function (configuration) {
        var _this = this;
        var properties = configuration.properties;
        if (properties) {
            for (var key in properties) {
                if (properties[key].overridable) {
                    this.editorConfigurationSchema.properties[key] = this.getConfigurationProperties()[key];
                }
            }
        }
        var subNodes = configuration.allOf;
        if (subNodes) {
            subNodes.forEach(function (subNode) { return _this.update(subNode); });
        }
    };
    ConfigurationRegistry.prototype.computeOverridePropertyPattern = function () {
        this.overridePropertyPattern = this.overrideIdentifiers.length ? OVERRIDE_PATTERN_WITH_SUBSTITUTION.replace('${0}', this.overrideIdentifiers.map(function (identifier) { return __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["createRegExp"](identifier, false).source; }).join('|')) : OVERRIDE_PROPERTY;
    };
    return ConfigurationRegistry;
}());
var SETTINGS_OVERRRIDE_NODE_ID = 'override';
var OVERRIDE_PROPERTY = '\\[.*\\]$';
var OVERRIDE_PATTERN_WITH_SUBSTITUTION = '\\[(${0})\\]$';
var OVERRIDE_PROPERTY_PATTERN = new RegExp(OVERRIDE_PROPERTY);
function getDefaultValue(type) {
    var t = Array.isArray(type) ? type[0] : type;
    switch (t) {
        case 'boolean':
            return false;
        case 'integer':
        case 'number':
            return 0;
        case 'string':
            return '';
        case 'array':
            return [];
        case 'object':
            return {};
        default:
            return null;
    }
}
var configurationRegistry = new ConfigurationRegistry();
__WEBPACK_IMPORTED_MODULE_2__registry_common_platform_js__["a" /* Registry */].add(Extensions.Configuration, configurationRegistry);
function validateProperty(property) {
    if (OVERRIDE_PROPERTY_PATTERN.test(property)) {
        return __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('config.property.languageDefault', "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", property);
    }
    if (configurationRegistry.getConfigurationProperties()[property] !== void 0) {
        return __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('config.property.duplicate', "Cannot register '{0}'. This property is already registered.", property);
    }
    return null;
}


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WordCharacterClassifier */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMapForWordSeparators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_characterClassifier_js__ = __webpack_require__(83);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var WordCharacterClassifier = /** @class */ (function (_super) {
    __extends(WordCharacterClassifier, _super);
    function WordCharacterClassifier(wordSeparators) {
        var _this = _super.call(this, 0 /* Regular */) || this;
        for (var i = 0, len = wordSeparators.length; i < len; i++) {
            _this.set(wordSeparators.charCodeAt(i), 2 /* WordSeparator */);
        }
        _this.set(32 /* Space */, 1 /* Whitespace */);
        _this.set(9 /* Tab */, 1 /* Whitespace */);
        return _this;
    }
    return WordCharacterClassifier;
}(__WEBPACK_IMPORTED_MODULE_0__core_characterClassifier_js__["a" /* CharacterClassifier */]));

function once(computeFn) {
    var cache = {}; // TODO@Alex unbounded cache
    return function (input) {
        if (!cache.hasOwnProperty(input)) {
            cache[input] = computeFn(input);
        }
        return cache[input];
    };
}
var getMapForWordSeparators = once(function (input) { return new WordCharacterClassifier(input); });


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharacterClassifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CharacterSet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uint_js__ = __webpack_require__(98);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


/**
 * A fast character classifier that uses a compact array for ASCII values.
 */
var CharacterClassifier = /** @class */ (function () {
    function CharacterClassifier(_defaultValue) {
        var defaultValue = Object(__WEBPACK_IMPORTED_MODULE_0__uint_js__["d" /* toUint8 */])(_defaultValue);
        this._defaultValue = defaultValue;
        this._asciiMap = CharacterClassifier._createAsciiMap(defaultValue);
        this._map = new Map();
    }
    CharacterClassifier._createAsciiMap = function (defaultValue) {
        var asciiMap = new Uint8Array(256);
        for (var i = 0; i < 256; i++) {
            asciiMap[i] = defaultValue;
        }
        return asciiMap;
    };
    CharacterClassifier.prototype.set = function (charCode, _value) {
        var value = Object(__WEBPACK_IMPORTED_MODULE_0__uint_js__["d" /* toUint8 */])(_value);
        if (charCode >= 0 && charCode < 256) {
            this._asciiMap[charCode] = value;
        }
        else {
            this._map.set(charCode, value);
        }
    };
    CharacterClassifier.prototype.get = function (charCode) {
        if (charCode >= 0 && charCode < 256) {
            return this._asciiMap[charCode];
        }
        else {
            return (this._map.get(charCode) || this._defaultValue);
        }
    };
    return CharacterClassifier;
}());

var CharacterSet = /** @class */ (function () {
    function CharacterSet() {
        this._actual = new CharacterClassifier(0 /* False */);
    }
    CharacterSet.prototype.add = function (charCode) {
        this._actual.set(charCode, 1 /* True */);
    };
    CharacterSet.prototype.has = function (charCode) {
        return (this._actual.get(charCode) === 1 /* True */);
    };
    return CharacterSet;
}());



/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEditorCommand", function() { return CoreEditorCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditorScroll_", function() { return EditorScroll_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RevealLine_", function() { return RevealLine_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreNavigationCommands", function() { return CoreNavigationCommands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEditingCommands", function() { return CoreEditingCommands; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_editorCommon_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_controller_cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorColumnSelection_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_controller_cursorTypeOperations_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_controller_cursorDeleteOperations_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_actions_common_actions_js__ = __webpack_require__(41);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var H = __WEBPACK_IMPORTED_MODULE_3__common_editorCommon_js__["b" /* Handler */];






var CORE_WEIGHT = 0 /* EditorCore */;
var CoreEditorCommand = /** @class */ (function (_super) {
    __extends(CoreEditorCommand, _super);
    function CoreEditorCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreEditorCommand.prototype.runEditorCommand = function (accessor, editor, args) {
        var cursors = editor._getCursors();
        if (!cursors) {
            // the editor has no view => has no cursors
            return;
        }
        this.runCoreEditorCommand(cursors, args || {});
    };
    return CoreEditorCommand;
}(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["c" /* EditorCommand */]));

var EditorScroll_;
(function (EditorScroll_) {
    var isEditorScrollArgs = function (arg) {
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["g" /* isObject */](arg)) {
            return false;
        }
        var scrollArg = arg;
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["h" /* isString */](scrollArg.to)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["i" /* isUndefined */](scrollArg.by) && !__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["h" /* isString */](scrollArg.by)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["i" /* isUndefined */](scrollArg.value) && !__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["f" /* isNumber */](scrollArg.value)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["i" /* isUndefined */](scrollArg.revealCursor) && !__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["c" /* isBoolean */](scrollArg.revealCursor)) {
            return false;
        }
        return true;
    };
    EditorScroll_.description = {
        description: 'Scroll editor in the given direction',
        args: [
            {
                name: 'Editor scroll argument object',
                description: "Property-value pairs that can be passed through this argument:\n\t\t\t\t\t* 'to': A mandatory direction value.\n\t\t\t\t\t\t```\n\t\t\t\t\t\t'up', 'down'\n\t\t\t\t\t\t```\n\t\t\t\t\t* 'by': Unit to move. Default is computed based on 'to' value.\n\t\t\t\t\t\t```\n\t\t\t\t\t\t'line', 'wrappedLine', 'page', 'halfPage'\n\t\t\t\t\t\t```\n\t\t\t\t\t* 'value': Number of units to move. Default is '1'.\n\t\t\t\t\t* 'revealCursor': If 'true' reveals the cursor if it is outside view port.\n\t\t\t\t",
                constraint: isEditorScrollArgs
            }
        ]
    };
    /**
     * Directions in the view for editor scroll command.
     */
    EditorScroll_.RawDirection = {
        Up: 'up',
        Down: 'down',
    };
    /**
     * Units for editor scroll 'by' argument
     */
    EditorScroll_.RawUnit = {
        Line: 'line',
        WrappedLine: 'wrappedLine',
        Page: 'page',
        HalfPage: 'halfPage'
    };
    function parse(args) {
        var direction;
        switch (args.to) {
            case EditorScroll_.RawDirection.Up:
                direction = 1 /* Up */;
                break;
            case EditorScroll_.RawDirection.Down:
                direction = 2 /* Down */;
                break;
            default:
                // Illegal arguments
                return null;
        }
        var unit;
        switch (args.by) {
            case EditorScroll_.RawUnit.Line:
                unit = 1 /* Line */;
                break;
            case EditorScroll_.RawUnit.WrappedLine:
                unit = 2 /* WrappedLine */;
                break;
            case EditorScroll_.RawUnit.Page:
                unit = 3 /* Page */;
                break;
            case EditorScroll_.RawUnit.HalfPage:
                unit = 4 /* HalfPage */;
                break;
            default:
                unit = 2 /* WrappedLine */;
        }
        var value = Math.floor(args.value || 1);
        var revealCursor = !!args.revealCursor;
        return {
            direction: direction,
            unit: unit,
            value: value,
            revealCursor: revealCursor,
            select: (!!args.select)
        };
    }
    EditorScroll_.parse = parse;
})(EditorScroll_ || (EditorScroll_ = {}));
var RevealLine_;
(function (RevealLine_) {
    var isRevealLineArgs = function (arg) {
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["g" /* isObject */](arg)) {
            return false;
        }
        var reveaLineArg = arg;
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["f" /* isNumber */](reveaLineArg.lineNumber)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["i" /* isUndefined */](reveaLineArg.at) && !__WEBPACK_IMPORTED_MODULE_12__base_common_types_js__["h" /* isString */](reveaLineArg.at)) {
            return false;
        }
        return true;
    };
    RevealLine_.description = {
        description: 'Reveal the given line at the given logical position',
        args: [
            {
                name: 'Reveal line argument object',
                description: "Property-value pairs that can be passed through this argument:\n\t\t\t\t\t* 'lineNumber': A mandatory line number value.\n\t\t\t\t\t* 'at': Logical position at which line has to be revealed .\n\t\t\t\t\t\t```\n\t\t\t\t\t\t'top', 'center', 'bottom'\n\t\t\t\t\t\t```\n\t\t\t\t",
                constraint: isRevealLineArgs
            }
        ]
    };
    /**
     * Values for reveal line 'at' argument
     */
    RevealLine_.RawAtArgument = {
        Top: 'top',
        Center: 'center',
        Bottom: 'bottom'
    };
})(RevealLine_ || (RevealLine_ = {}));
var CoreNavigationCommands;
(function (CoreNavigationCommands) {
    var BaseMoveToCommand = /** @class */ (function (_super) {
        __extends(BaseMoveToCommand, _super);
        function BaseMoveToCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        BaseMoveToCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].moveTo(cursors.context, cursors.getPrimaryCursor(), this._inSelectionMode, args.position, args.viewPosition)
            ]);
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return BaseMoveToCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.MoveTo = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new BaseMoveToCommand({
        id: '_moveTo',
        inSelectionMode: false,
        precondition: null
    }));
    CoreNavigationCommands.MoveToSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new BaseMoveToCommand({
        id: '_moveToSelect',
        inSelectionMode: true,
        precondition: null
    }));
    var ColumnSelectCommand = /** @class */ (function (_super) {
        __extends(ColumnSelectCommand, _super);
        function ColumnSelectCommand() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ColumnSelectCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            var result = this._getColumnSelectResult(cursors.context, cursors.getPrimaryCursor(), cursors.getColumnSelectData(), args);
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, result.viewStates.map(function (viewState) { return __WEBPACK_IMPORTED_MODULE_4__common_controller_cursorCommon_js__["d" /* CursorState */].fromViewState(viewState); }));
            cursors.setColumnSelectData({
                toViewLineNumber: result.toLineNumber,
                toViewVisualColumn: result.toVisualColumn
            });
            cursors.reveal(true, (result.reversed ? 1 /* TopMost */ : 2 /* BottomMost */), 0 /* Smooth */);
        };
        return ColumnSelectCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.ColumnSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super.call(this, {
                id: 'columnSelect',
                precondition: null
            }) || this;
        }
        class_1.prototype._getColumnSelectResult = function (context, primary, prevColumnSelectData, args) {
            // validate `args`
            var validatedPosition = context.model.validatePosition(args.position);
            var validatedViewPosition;
            if (args.viewPosition) {
                validatedViewPosition = context.validateViewPosition(new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](args.viewPosition.lineNumber, args.viewPosition.column), validatedPosition);
            }
            else {
                validatedViewPosition = context.convertModelPositionToViewPosition(validatedPosition);
            }
            return __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorColumnSelection_js__["a" /* ColumnSelection */].columnSelect(context.config, context.viewModel, primary.viewState.selection, validatedViewPosition.lineNumber, args.mouseColumn - 1);
        };
        return class_1;
    }(ColumnSelectCommand)));
    CoreNavigationCommands.CursorColumnSelectLeft = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_2, _super);
        function class_2() {
            return _super.call(this, {
                id: 'cursorColumnSelectLeft',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 512 /* Alt */ | 15 /* LeftArrow */,
                    linux: { primary: 0 }
                }
            }) || this;
        }
        class_2.prototype._getColumnSelectResult = function (context, primary, prevColumnSelectData, args) {
            return __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorColumnSelection_js__["a" /* ColumnSelection */].columnSelectLeft(context.config, context.viewModel, primary.viewState, prevColumnSelectData.toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
        };
        return class_2;
    }(ColumnSelectCommand)));
    CoreNavigationCommands.CursorColumnSelectRight = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_3, _super);
        function class_3() {
            return _super.call(this, {
                id: 'cursorColumnSelectRight',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 512 /* Alt */ | 17 /* RightArrow */,
                    linux: { primary: 0 }
                }
            }) || this;
        }
        class_3.prototype._getColumnSelectResult = function (context, primary, prevColumnSelectData, args) {
            return __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorColumnSelection_js__["a" /* ColumnSelection */].columnSelectRight(context.config, context.viewModel, primary.viewState, prevColumnSelectData.toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
        };
        return class_3;
    }(ColumnSelectCommand)));
    var ColumnSelectUpCommand = /** @class */ (function (_super) {
        __extends(ColumnSelectUpCommand, _super);
        function ColumnSelectUpCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._isPaged = opts.isPaged;
            return _this;
        }
        ColumnSelectUpCommand.prototype._getColumnSelectResult = function (context, primary, prevColumnSelectData, args) {
            return __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorColumnSelection_js__["a" /* ColumnSelection */].columnSelectUp(context.config, context.viewModel, primary.viewState, this._isPaged, prevColumnSelectData.toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
        };
        return ColumnSelectUpCommand;
    }(ColumnSelectCommand));
    CoreNavigationCommands.CursorColumnSelectUp = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new ColumnSelectUpCommand({
        isPaged: false,
        id: 'cursorColumnSelectUp',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 512 /* Alt */ | 16 /* UpArrow */,
            linux: { primary: 0 }
        }
    }));
    CoreNavigationCommands.CursorColumnSelectPageUp = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new ColumnSelectUpCommand({
        isPaged: true,
        id: 'cursorColumnSelectPageUp',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 512 /* Alt */ | 11 /* PageUp */,
            linux: { primary: 0 }
        }
    }));
    var ColumnSelectDownCommand = /** @class */ (function (_super) {
        __extends(ColumnSelectDownCommand, _super);
        function ColumnSelectDownCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._isPaged = opts.isPaged;
            return _this;
        }
        ColumnSelectDownCommand.prototype._getColumnSelectResult = function (context, primary, prevColumnSelectData, args) {
            return __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorColumnSelection_js__["a" /* ColumnSelection */].columnSelectDown(context.config, context.viewModel, primary.viewState, this._isPaged, prevColumnSelectData.toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
        };
        return ColumnSelectDownCommand;
    }(ColumnSelectCommand));
    CoreNavigationCommands.CursorColumnSelectDown = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new ColumnSelectDownCommand({
        isPaged: false,
        id: 'cursorColumnSelectDown',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 512 /* Alt */ | 18 /* DownArrow */,
            linux: { primary: 0 }
        }
    }));
    CoreNavigationCommands.CursorColumnSelectPageDown = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new ColumnSelectDownCommand({
        isPaged: true,
        id: 'cursorColumnSelectPageDown',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 512 /* Alt */ | 12 /* PageDown */,
            linux: { primary: 0 }
        }
    }));
    var CursorMoveImpl = /** @class */ (function (_super) {
        __extends(CursorMoveImpl, _super);
        function CursorMoveImpl() {
            return _super.call(this, {
                id: 'cursorMove',
                precondition: null,
                description: __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["a" /* CursorMove */].description
            }) || this;
        }
        CursorMoveImpl.prototype.runCoreEditorCommand = function (cursors, args) {
            var parsed = __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["a" /* CursorMove */].parse(args);
            if (!parsed) {
                // illegal arguments
                return;
            }
            this._runCursorMove(cursors, args.source, parsed);
        };
        CursorMoveImpl.prototype._runCursorMove = function (cursors, source, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].move(cursors.context, cursors.getAll(), args));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return CursorMoveImpl;
    }(CoreEditorCommand));
    CoreNavigationCommands.CursorMoveImpl = CursorMoveImpl;
    CoreNavigationCommands.CursorMove = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveImpl());
    var CursorMoveBasedCommand = /** @class */ (function (_super) {
        __extends(CursorMoveBasedCommand, _super);
        function CursorMoveBasedCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._staticArgs = opts.args;
            return _this;
        }
        CursorMoveBasedCommand.prototype.runCoreEditorCommand = function (cursors, dynamicArgs) {
            var args = this._staticArgs;
            if (this._staticArgs.value === -1 /* PAGE_SIZE_MARKER */) {
                // -1 is a marker for page size
                args = {
                    direction: this._staticArgs.direction,
                    unit: this._staticArgs.unit,
                    select: this._staticArgs.select,
                    value: cursors.context.config.pageSize
                };
            }
            CoreNavigationCommands.CursorMove._runCursorMove(cursors, dynamicArgs.source, args);
        };
        return CursorMoveBasedCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.CursorLeft = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 0 /* Left */,
            unit: 0 /* None */,
            select: false,
            value: 1
        },
        id: 'cursorLeft',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 15 /* LeftArrow */,
            mac: { primary: 15 /* LeftArrow */, secondary: [256 /* WinCtrl */ | 32 /* KEY_B */] }
        }
    }));
    CoreNavigationCommands.CursorLeftSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 0 /* Left */,
            unit: 0 /* None */,
            select: true,
            value: 1
        },
        id: 'cursorLeftSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 15 /* LeftArrow */
        }
    }));
    CoreNavigationCommands.CursorRight = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 1 /* Right */,
            unit: 0 /* None */,
            select: false,
            value: 1
        },
        id: 'cursorRight',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 17 /* RightArrow */,
            mac: { primary: 17 /* RightArrow */, secondary: [256 /* WinCtrl */ | 36 /* KEY_F */] }
        }
    }));
    CoreNavigationCommands.CursorRightSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 1 /* Right */,
            unit: 0 /* None */,
            select: true,
            value: 1
        },
        id: 'cursorRightSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 17 /* RightArrow */
        }
    }));
    CoreNavigationCommands.CursorUp = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* Up */,
            unit: 2 /* WrappedLine */,
            select: false,
            value: 1
        },
        id: 'cursorUp',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 16 /* UpArrow */,
            mac: { primary: 16 /* UpArrow */, secondary: [256 /* WinCtrl */ | 46 /* KEY_P */] }
        }
    }));
    CoreNavigationCommands.CursorUpSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* Up */,
            unit: 2 /* WrappedLine */,
            select: true,
            value: 1
        },
        id: 'cursorUpSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 16 /* UpArrow */,
            secondary: [2048 /* CtrlCmd */ | 1024 /* Shift */ | 16 /* UpArrow */],
            mac: { primary: 1024 /* Shift */ | 16 /* UpArrow */ },
            linux: { primary: 1024 /* Shift */ | 16 /* UpArrow */ }
        }
    }));
    CoreNavigationCommands.CursorPageUp = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* Up */,
            unit: 2 /* WrappedLine */,
            select: false,
            value: -1 /* PAGE_SIZE_MARKER */
        },
        id: 'cursorPageUp',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 11 /* PageUp */
        }
    }));
    CoreNavigationCommands.CursorPageUpSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* Up */,
            unit: 2 /* WrappedLine */,
            select: true,
            value: -1 /* PAGE_SIZE_MARKER */
        },
        id: 'cursorPageUpSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 11 /* PageUp */
        }
    }));
    CoreNavigationCommands.CursorDown = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* Down */,
            unit: 2 /* WrappedLine */,
            select: false,
            value: 1
        },
        id: 'cursorDown',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 18 /* DownArrow */,
            mac: { primary: 18 /* DownArrow */, secondary: [256 /* WinCtrl */ | 44 /* KEY_N */] }
        }
    }));
    CoreNavigationCommands.CursorDownSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* Down */,
            unit: 2 /* WrappedLine */,
            select: true,
            value: 1
        },
        id: 'cursorDownSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 18 /* DownArrow */,
            secondary: [2048 /* CtrlCmd */ | 1024 /* Shift */ | 18 /* DownArrow */],
            mac: { primary: 1024 /* Shift */ | 18 /* DownArrow */ },
            linux: { primary: 1024 /* Shift */ | 18 /* DownArrow */ }
        }
    }));
    CoreNavigationCommands.CursorPageDown = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* Down */,
            unit: 2 /* WrappedLine */,
            select: false,
            value: -1 /* PAGE_SIZE_MARKER */
        },
        id: 'cursorPageDown',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 12 /* PageDown */
        }
    }));
    CoreNavigationCommands.CursorPageDownSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* Down */,
            unit: 2 /* WrappedLine */,
            select: true,
            value: -1 /* PAGE_SIZE_MARKER */
        },
        id: 'cursorPageDownSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 12 /* PageDown */
        }
    }));
    CoreNavigationCommands.CreateCursor = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_4, _super);
        function class_4() {
            return _super.call(this, {
                id: 'createCursor',
                precondition: null
            }) || this;
        }
        class_4.prototype.runCoreEditorCommand = function (cursors, args) {
            var context = cursors.context;
            var newState;
            if (args.wholeLine) {
                newState = __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].line(context, cursors.getPrimaryCursor(), false, args.position, args.viewPosition);
            }
            else {
                newState = __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].moveTo(context, cursors.getPrimaryCursor(), false, args.position, args.viewPosition);
            }
            var states = cursors.getAll();
            // Check if we should remove a cursor (sort of like a toggle)
            if (states.length > 1) {
                var newModelPosition = (newState.modelState ? newState.modelState.position : null);
                var newViewPosition = (newState.viewState ? newState.viewState.position : null);
                for (var i = 0, len = states.length; i < len; i++) {
                    var state = states[i];
                    if (newModelPosition && !state.modelState.selection.containsPosition(newModelPosition)) {
                        continue;
                    }
                    if (newViewPosition && !state.viewState.selection.containsPosition(newViewPosition)) {
                        continue;
                    }
                    // => Remove the cursor
                    states.splice(i, 1);
                    cursors.context.model.pushStackElement();
                    cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, states);
                    return;
                }
            }
            // => Add the new cursor
            states.push(newState);
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, states);
        };
        return class_4;
    }(CoreEditorCommand)));
    CoreNavigationCommands.LastCursorMoveToSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_5, _super);
        function class_5() {
            return _super.call(this, {
                id: '_lastCursorMoveToSelect',
                precondition: null
            }) || this;
        }
        class_5.prototype.runCoreEditorCommand = function (cursors, args) {
            var context = cursors.context;
            var lastAddedCursorIndex = cursors.getLastAddedCursorIndex();
            var newStates = cursors.getAll().slice(0);
            newStates[lastAddedCursorIndex] = __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].moveTo(context, newStates[lastAddedCursorIndex], true, args.position, args.viewPosition);
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, newStates);
        };
        return class_5;
    }(CoreEditorCommand)));
    var HomeCommand = /** @class */ (function (_super) {
        __extends(HomeCommand, _super);
        function HomeCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        HomeCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].moveToBeginningOfLine(cursors.context, cursors.getAll(), this._inSelectionMode));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return HomeCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.CursorHome = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new HomeCommand({
        inSelectionMode: false,
        id: 'cursorHome',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 14 /* Home */,
            mac: { primary: 14 /* Home */, secondary: [2048 /* CtrlCmd */ | 15 /* LeftArrow */] }
        }
    }));
    CoreNavigationCommands.CursorHomeSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new HomeCommand({
        inSelectionMode: true,
        id: 'cursorHomeSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 14 /* Home */,
            mac: { primary: 1024 /* Shift */ | 14 /* Home */, secondary: [2048 /* CtrlCmd */ | 1024 /* Shift */ | 15 /* LeftArrow */] }
        }
    }));
    CoreNavigationCommands.CursorLineStart = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_6, _super);
        function class_6() {
            return _super.call(this, {
                id: 'cursorLineStart',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 0,
                    mac: { primary: 256 /* WinCtrl */ | 31 /* KEY_A */ }
                }
            }) || this;
        }
        class_6.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, this._exec(cursors.context, cursors.getAll()));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        class_6.prototype._exec = function (context, cursors) {
            var result = [];
            for (var i = 0, len = cursors.length; i < len; i++) {
                var cursor = cursors[i];
                var lineNumber = cursor.modelState.position.lineNumber;
                result[i] = __WEBPACK_IMPORTED_MODULE_4__common_controller_cursorCommon_js__["d" /* CursorState */].fromModelState(cursor.modelState.move(false, lineNumber, 1, 0));
            }
            return result;
        };
        return class_6;
    }(CoreEditorCommand)));
    var EndCommand = /** @class */ (function (_super) {
        __extends(EndCommand, _super);
        function EndCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        EndCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].moveToEndOfLine(cursors.context, cursors.getAll(), this._inSelectionMode));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return EndCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.CursorEnd = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new EndCommand({
        inSelectionMode: false,
        id: 'cursorEnd',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 13 /* End */,
            mac: { primary: 13 /* End */, secondary: [2048 /* CtrlCmd */ | 17 /* RightArrow */] }
        }
    }));
    CoreNavigationCommands.CursorEndSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new EndCommand({
        inSelectionMode: true,
        id: 'cursorEndSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 1024 /* Shift */ | 13 /* End */,
            mac: { primary: 1024 /* Shift */ | 13 /* End */, secondary: [2048 /* CtrlCmd */ | 1024 /* Shift */ | 17 /* RightArrow */] }
        }
    }));
    CoreNavigationCommands.CursorLineEnd = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_7, _super);
        function class_7() {
            return _super.call(this, {
                id: 'cursorLineEnd',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 0,
                    mac: { primary: 256 /* WinCtrl */ | 35 /* KEY_E */ }
                }
            }) || this;
        }
        class_7.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, this._exec(cursors.context, cursors.getAll()));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        class_7.prototype._exec = function (context, cursors) {
            var result = [];
            for (var i = 0, len = cursors.length; i < len; i++) {
                var cursor = cursors[i];
                var lineNumber = cursor.modelState.position.lineNumber;
                var maxColumn = context.model.getLineMaxColumn(lineNumber);
                result[i] = __WEBPACK_IMPORTED_MODULE_4__common_controller_cursorCommon_js__["d" /* CursorState */].fromModelState(cursor.modelState.move(false, lineNumber, maxColumn, 0));
            }
            return result;
        };
        return class_7;
    }(CoreEditorCommand)));
    var TopCommand = /** @class */ (function (_super) {
        __extends(TopCommand, _super);
        function TopCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        TopCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].moveToBeginningOfBuffer(cursors.context, cursors.getAll(), this._inSelectionMode));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return TopCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.CursorTop = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new TopCommand({
        inSelectionMode: false,
        id: 'cursorTop',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 14 /* Home */,
            mac: { primary: 2048 /* CtrlCmd */ | 16 /* UpArrow */ }
        }
    }));
    CoreNavigationCommands.CursorTopSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new TopCommand({
        inSelectionMode: true,
        id: 'cursorTopSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 14 /* Home */,
            mac: { primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 16 /* UpArrow */ }
        }
    }));
    var BottomCommand = /** @class */ (function (_super) {
        __extends(BottomCommand, _super);
        function BottomCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        BottomCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].moveToEndOfBuffer(cursors.context, cursors.getAll(), this._inSelectionMode));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return BottomCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.CursorBottom = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new BottomCommand({
        inSelectionMode: false,
        id: 'cursorBottom',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 13 /* End */,
            mac: { primary: 2048 /* CtrlCmd */ | 18 /* DownArrow */ }
        }
    }));
    CoreNavigationCommands.CursorBottomSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new BottomCommand({
        inSelectionMode: true,
        id: 'cursorBottomSelect',
        precondition: null,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 13 /* End */,
            mac: { primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 18 /* DownArrow */ }
        }
    }));
    var EditorScrollImpl = /** @class */ (function (_super) {
        __extends(EditorScrollImpl, _super);
        function EditorScrollImpl() {
            return _super.call(this, {
                id: 'editorScroll',
                precondition: null,
                description: EditorScroll_.description
            }) || this;
        }
        EditorScrollImpl.prototype.runCoreEditorCommand = function (cursors, args) {
            var parsed = EditorScroll_.parse(args);
            if (!parsed) {
                // illegal arguments
                return;
            }
            this._runEditorScroll(cursors, args.source, parsed);
        };
        EditorScrollImpl.prototype._runEditorScroll = function (cursors, source, args) {
            var desiredScrollTop = this._computeDesiredScrollTop(cursors.context, args);
            if (args.revealCursor) {
                // must ensure cursor is in new visible range
                var desiredVisibleViewRange = cursors.context.getCompletelyVisibleViewRangeAtScrollTop(desiredScrollTop);
                cursors.setStates(source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                    __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].findPositionInViewportIfOutside(cursors.context, cursors.getPrimaryCursor(), desiredVisibleViewRange, args.select)
                ]);
            }
            cursors.scrollTo(desiredScrollTop);
        };
        EditorScrollImpl.prototype._computeDesiredScrollTop = function (context, args) {
            if (args.unit === 1 /* Line */) {
                // scrolling by model lines
                var visibleModelRange = context.getCompletelyVisibleModelRange();
                var desiredTopModelLineNumber = void 0;
                if (args.direction === 1 /* Up */) {
                    // must go x model lines up
                    desiredTopModelLineNumber = Math.max(1, visibleModelRange.startLineNumber - args.value);
                }
                else {
                    // must go x model lines down
                    desiredTopModelLineNumber = Math.min(context.model.getLineCount(), visibleModelRange.startLineNumber + args.value);
                }
                var desiredTopViewPosition = context.convertModelPositionToViewPosition(new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](desiredTopModelLineNumber, 1));
                return context.getVerticalOffsetForViewLine(desiredTopViewPosition.lineNumber);
            }
            var noOfLines;
            if (args.unit === 3 /* Page */) {
                noOfLines = context.config.pageSize * args.value;
            }
            else if (args.unit === 4 /* HalfPage */) {
                noOfLines = Math.round(context.config.pageSize / 2) * args.value;
            }
            else {
                noOfLines = args.value;
            }
            var deltaLines = (args.direction === 1 /* Up */ ? -1 : 1) * noOfLines;
            return context.getCurrentScrollTop() + deltaLines * context.config.lineHeight;
        };
        return EditorScrollImpl;
    }(CoreEditorCommand));
    CoreNavigationCommands.EditorScrollImpl = EditorScrollImpl;
    CoreNavigationCommands.EditorScroll = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new EditorScrollImpl());
    CoreNavigationCommands.ScrollLineUp = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_8, _super);
        function class_8() {
            return _super.call(this, {
                id: 'scrollLineUp',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 2048 /* CtrlCmd */ | 16 /* UpArrow */,
                    mac: { primary: 256 /* WinCtrl */ | 11 /* PageUp */ }
                }
            }) || this;
        }
        class_8.prototype.runCoreEditorCommand = function (cursors, args) {
            CoreNavigationCommands.EditorScroll._runEditorScroll(cursors, args.source, {
                direction: 1 /* Up */,
                unit: 2 /* WrappedLine */,
                value: 1,
                revealCursor: false,
                select: false
            });
        };
        return class_8;
    }(CoreEditorCommand)));
    CoreNavigationCommands.ScrollPageUp = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_9, _super);
        function class_9() {
            return _super.call(this, {
                id: 'scrollPageUp',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 2048 /* CtrlCmd */ | 11 /* PageUp */,
                    win: { primary: 512 /* Alt */ | 11 /* PageUp */ },
                    linux: { primary: 512 /* Alt */ | 11 /* PageUp */ }
                }
            }) || this;
        }
        class_9.prototype.runCoreEditorCommand = function (cursors, args) {
            CoreNavigationCommands.EditorScroll._runEditorScroll(cursors, args.source, {
                direction: 1 /* Up */,
                unit: 3 /* Page */,
                value: 1,
                revealCursor: false,
                select: false
            });
        };
        return class_9;
    }(CoreEditorCommand)));
    CoreNavigationCommands.ScrollLineDown = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_10, _super);
        function class_10() {
            return _super.call(this, {
                id: 'scrollLineDown',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 2048 /* CtrlCmd */ | 18 /* DownArrow */,
                    mac: { primary: 256 /* WinCtrl */ | 12 /* PageDown */ }
                }
            }) || this;
        }
        class_10.prototype.runCoreEditorCommand = function (cursors, args) {
            CoreNavigationCommands.EditorScroll._runEditorScroll(cursors, args.source, {
                direction: 2 /* Down */,
                unit: 2 /* WrappedLine */,
                value: 1,
                revealCursor: false,
                select: false
            });
        };
        return class_10;
    }(CoreEditorCommand)));
    CoreNavigationCommands.ScrollPageDown = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_11, _super);
        function class_11() {
            return _super.call(this, {
                id: 'scrollPageDown',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 2048 /* CtrlCmd */ | 12 /* PageDown */,
                    win: { primary: 512 /* Alt */ | 12 /* PageDown */ },
                    linux: { primary: 512 /* Alt */ | 12 /* PageDown */ }
                }
            }) || this;
        }
        class_11.prototype.runCoreEditorCommand = function (cursors, args) {
            CoreNavigationCommands.EditorScroll._runEditorScroll(cursors, args.source, {
                direction: 2 /* Down */,
                unit: 3 /* Page */,
                value: 1,
                revealCursor: false,
                select: false
            });
        };
        return class_11;
    }(CoreEditorCommand)));
    var WordCommand = /** @class */ (function (_super) {
        __extends(WordCommand, _super);
        function WordCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        WordCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].word(cursors.context, cursors.getPrimaryCursor(), this._inSelectionMode, args.position)
            ]);
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return WordCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.WordSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new WordCommand({
        inSelectionMode: false,
        id: '_wordSelect',
        precondition: null
    }));
    CoreNavigationCommands.WordSelectDrag = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new WordCommand({
        inSelectionMode: true,
        id: '_wordSelectDrag',
        precondition: null
    }));
    CoreNavigationCommands.LastCursorWordSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_12, _super);
        function class_12() {
            return _super.call(this, {
                id: 'lastCursorWordSelect',
                precondition: null
            }) || this;
        }
        class_12.prototype.runCoreEditorCommand = function (cursors, args) {
            var context = cursors.context;
            var lastAddedCursorIndex = cursors.getLastAddedCursorIndex();
            var newStates = cursors.getAll().slice(0);
            var lastAddedState = newStates[lastAddedCursorIndex];
            newStates[lastAddedCursorIndex] = __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].word(context, lastAddedState, lastAddedState.modelState.hasSelection(), args.position);
            context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, newStates);
        };
        return class_12;
    }(CoreEditorCommand)));
    var LineCommand = /** @class */ (function (_super) {
        __extends(LineCommand, _super);
        function LineCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        LineCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].line(cursors.context, cursors.getPrimaryCursor(), this._inSelectionMode, args.position, args.viewPosition)
            ]);
            cursors.reveal(false, 0 /* Primary */, 0 /* Smooth */);
        };
        return LineCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.LineSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new LineCommand({
        inSelectionMode: false,
        id: '_lineSelect',
        precondition: null
    }));
    CoreNavigationCommands.LineSelectDrag = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new LineCommand({
        inSelectionMode: true,
        id: '_lineSelectDrag',
        precondition: null
    }));
    var LastCursorLineCommand = /** @class */ (function (_super) {
        __extends(LastCursorLineCommand, _super);
        function LastCursorLineCommand(opts) {
            var _this = _super.call(this, opts) || this;
            _this._inSelectionMode = opts.inSelectionMode;
            return _this;
        }
        LastCursorLineCommand.prototype.runCoreEditorCommand = function (cursors, args) {
            var lastAddedCursorIndex = cursors.getLastAddedCursorIndex();
            var newStates = cursors.getAll().slice(0);
            newStates[lastAddedCursorIndex] = __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].line(cursors.context, newStates[lastAddedCursorIndex], this._inSelectionMode, args.position, args.viewPosition);
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, newStates);
        };
        return LastCursorLineCommand;
    }(CoreEditorCommand));
    CoreNavigationCommands.LastCursorLineSelect = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new LastCursorLineCommand({
        inSelectionMode: false,
        id: 'lastCursorLineSelect',
        precondition: null
    }));
    CoreNavigationCommands.LastCursorLineSelectDrag = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new LastCursorLineCommand({
        inSelectionMode: true,
        id: 'lastCursorLineSelectDrag',
        precondition: null
    }));
    CoreNavigationCommands.ExpandLineSelection = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_13, _super);
        function class_13() {
            return _super.call(this, {
                id: 'expandLineSelection',
                precondition: null,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 2048 /* CtrlCmd */ | 39 /* KEY_I */
                }
            }) || this;
        }
        class_13.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].expandLineSelection(cursors.context, cursors.getAll()));
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return class_13;
    }(CoreEditorCommand)));
    CoreNavigationCommands.CancelSelection = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_14, _super);
        function class_14() {
            return _super.call(this, {
                id: 'cancelSelection',
                precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasNonEmptySelection,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 9 /* Escape */,
                    secondary: [1024 /* Shift */ | 9 /* Escape */]
                }
            }) || this;
        }
        class_14.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].cancelSelection(cursors.context, cursors.getPrimaryCursor())
            ]);
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return class_14;
    }(CoreEditorCommand)));
    CoreNavigationCommands.RemoveSecondaryCursors = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_15, _super);
        function class_15() {
            return _super.call(this, {
                id: 'removeSecondaryCursors',
                precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasMultipleSelections,
                kbOpts: {
                    weight: CORE_WEIGHT + 1,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 9 /* Escape */,
                    secondary: [1024 /* Shift */ | 9 /* Escape */]
                }
            }) || this;
        }
        class_15.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                cursors.getPrimaryCursor()
            ]);
            cursors.reveal(true, 0 /* Primary */, 0 /* Smooth */);
        };
        return class_15;
    }(CoreEditorCommand)));
    CoreNavigationCommands.RevealLine = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_16, _super);
        function class_16() {
            return _super.call(this, {
                id: 'revealLine',
                precondition: null,
                description: RevealLine_.description
            }) || this;
        }
        class_16.prototype.runCoreEditorCommand = function (cursors, args) {
            var revealLineArg = args;
            var lineNumber = revealLineArg.lineNumber + 1;
            if (lineNumber < 1) {
                lineNumber = 1;
            }
            var lineCount = cursors.context.model.getLineCount();
            if (lineNumber > lineCount) {
                lineNumber = lineCount;
            }
            var range = new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, cursors.context.model.getLineMaxColumn(lineNumber));
            var revealAt = 0 /* Simple */;
            if (revealLineArg.at) {
                switch (revealLineArg.at) {
                    case RevealLine_.RawAtArgument.Top:
                        revealAt = 3 /* Top */;
                        break;
                    case RevealLine_.RawAtArgument.Center:
                        revealAt = 1 /* Center */;
                        break;
                    case RevealLine_.RawAtArgument.Bottom:
                        revealAt = 4 /* Bottom */;
                        break;
                    default:
                        break;
                }
            }
            var viewRange = cursors.context.convertModelRangeToViewRange(range);
            cursors.revealRange(false, viewRange, revealAt, 0 /* Smooth */);
        };
        return class_16;
    }(CoreEditorCommand)));
    CoreNavigationCommands.SelectAll = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_17, _super);
        function class_17() {
            return _super.call(this, {
                id: 'selectAll',
                precondition: null
            }) || this;
        }
        class_17.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].selectAll(cursors.context, cursors.getPrimaryCursor())
            ]);
        };
        return class_17;
    }(CoreEditorCommand)));
    CoreNavigationCommands.SetSelection = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_18, _super);
        function class_18() {
            return _super.call(this, {
                id: 'setSelection',
                precondition: null
            }) || this;
        }
        class_18.prototype.runCoreEditorCommand = function (cursors, args) {
            cursors.context.model.pushStackElement();
            cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, [
                __WEBPACK_IMPORTED_MODULE_4__common_controller_cursorCommon_js__["d" /* CursorState */].fromModelSelection(args.selection)
            ]);
        };
        return class_18;
    }(CoreEditorCommand)));
})(CoreNavigationCommands || (CoreNavigationCommands = {}));
var CoreEditingCommands;
(function (CoreEditingCommands) {
    CoreEditingCommands.LineBreakInsert = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_19, _super);
        function class_19() {
            return _super.call(this, {
                id: 'lineBreakInsert',
                precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: null,
                    mac: { primary: 256 /* WinCtrl */ | 45 /* KEY_O */ }
                }
            }) || this;
        }
        class_19.prototype.runEditorCommand = function (accessor, editor, args) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, __WEBPACK_IMPORTED_MODULE_13__common_controller_cursorTypeOperations_js__["a" /* TypeOperations */].lineBreakInsert(editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()));
        };
        return class_19;
    }(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["c" /* EditorCommand */])));
    CoreEditingCommands.Outdent = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_20, _super);
        function class_20() {
            return _super.call(this, {
                id: 'outdent',
                precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus, __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].tabDoesNotMoveFocus),
                    primary: 1024 /* Shift */ | 2 /* Tab */
                }
            }) || this;
        }
        class_20.prototype.runEditorCommand = function (accessor, editor, args) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, __WEBPACK_IMPORTED_MODULE_13__common_controller_cursorTypeOperations_js__["a" /* TypeOperations */].outdent(editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()));
            editor.pushUndoStop();
        };
        return class_20;
    }(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["c" /* EditorCommand */])));
    CoreEditingCommands.Tab = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_21, _super);
        function class_21() {
            return _super.call(this, {
                id: 'tab',
                precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus, __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].tabDoesNotMoveFocus),
                    primary: 2 /* Tab */
                }
            }) || this;
        }
        class_21.prototype.runEditorCommand = function (accessor, editor, args) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, __WEBPACK_IMPORTED_MODULE_13__common_controller_cursorTypeOperations_js__["a" /* TypeOperations */].tab(editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()));
            editor.pushUndoStop();
        };
        return class_21;
    }(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["c" /* EditorCommand */])));
    CoreEditingCommands.DeleteLeft = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_22, _super);
        function class_22() {
            return _super.call(this, {
                id: 'deleteLeft',
                precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 1 /* Backspace */,
                    secondary: [1024 /* Shift */ | 1 /* Backspace */],
                    mac: { primary: 1 /* Backspace */, secondary: [1024 /* Shift */ | 1 /* Backspace */, 256 /* WinCtrl */ | 38 /* KEY_H */, 256 /* WinCtrl */ | 1 /* Backspace */] }
                }
            }) || this;
        }
        class_22.prototype.runEditorCommand = function (accessor, editor, args) {
            var cursors = editor._getCursors();
            var _a = __WEBPACK_IMPORTED_MODULE_14__common_controller_cursorDeleteOperations_js__["a" /* DeleteOperations */].deleteLeft(cursors.getPrevEditOperationType(), editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()), shouldPushStackElementBefore = _a[0], commands = _a[1];
            if (shouldPushStackElementBefore) {
                editor.pushUndoStop();
            }
            editor.executeCommands(this.id, commands);
            cursors.setPrevEditOperationType(2 /* DeletingLeft */);
        };
        return class_22;
    }(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["c" /* EditorCommand */])));
    CoreEditingCommands.DeleteRight = Object(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["g" /* registerEditorCommand */])(new /** @class */ (function (_super) {
        __extends(class_23, _super);
        function class_23() {
            return _super.call(this, {
                id: 'deleteRight',
                precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                    primary: 20 /* Delete */,
                    mac: { primary: 20 /* Delete */, secondary: [256 /* WinCtrl */ | 34 /* KEY_D */, 256 /* WinCtrl */ | 20 /* Delete */] }
                }
            }) || this;
        }
        class_23.prototype.runEditorCommand = function (accessor, editor, args) {
            var cursors = editor._getCursors();
            var _a = __WEBPACK_IMPORTED_MODULE_14__common_controller_cursorDeleteOperations_js__["a" /* DeleteOperations */].deleteRight(cursors.getPrevEditOperationType(), editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()), shouldPushStackElementBefore = _a[0], commands = _a[1];
            if (shouldPushStackElementBefore) {
                editor.pushUndoStop();
            }
            editor.executeCommands(this.id, commands);
            cursors.setPrevEditOperationType(3 /* DeletingRight */);
        };
        return class_23;
    }(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["c" /* EditorCommand */])));
})(CoreEditingCommands || (CoreEditingCommands = {}));
function findFocusedEditor(accessor) {
    return accessor.get(__WEBPACK_IMPORTED_MODULE_10__services_codeEditorService_js__["a" /* ICodeEditorService */]).getFocusedCodeEditor();
}
function registerCommand(command) {
    command.register();
}
/**
 * A command that will:
 *  1. invoke a command on the focused editor.
 *  2. otherwise, invoke a browser built-in command on the `activeElement`.
 *  3. otherwise, invoke a command on the workbench active editor.
 */
var EditorOrNativeTextInputCommand = /** @class */ (function (_super) {
    __extends(EditorOrNativeTextInputCommand, _super);
    function EditorOrNativeTextInputCommand(opts) {
        var _this = _super.call(this, opts) || this;
        _this._editorHandler = opts.editorHandler;
        _this._inputHandler = opts.inputHandler;
        return _this;
    }
    EditorOrNativeTextInputCommand.prototype.runCommand = function (accessor, args) {
        var focusedEditor = findFocusedEditor(accessor);
        // Only if editor text focus (i.e. not if editor has widget focus).
        if (focusedEditor && focusedEditor.hasTextFocus()) {
            return this._runEditorHandler(focusedEditor, args);
        }
        // Ignore this action when user is focused on an element that allows for entering text
        var activeElement = document.activeElement;
        if (activeElement && ['input', 'textarea'].indexOf(activeElement.tagName.toLowerCase()) >= 0) {
            document.execCommand(this._inputHandler);
            return;
        }
        // Redirecting to active editor
        var activeEditor = accessor.get(__WEBPACK_IMPORTED_MODULE_10__services_codeEditorService_js__["a" /* ICodeEditorService */]).getActiveCodeEditor();
        if (activeEditor) {
            activeEditor.focus();
            return this._runEditorHandler(activeEditor, args);
        }
    };
    EditorOrNativeTextInputCommand.prototype._runEditorHandler = function (editor, args) {
        var HANDLER = this._editorHandler;
        if (typeof HANDLER === 'string') {
            editor.trigger('keyboard', HANDLER, args);
        }
        else {
            args = args || {};
            args.source = 'keyboard';
            HANDLER.runEditorCommand(null, editor, args);
        }
    };
    return EditorOrNativeTextInputCommand;
}(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["a" /* Command */]));
/**
 * A command that will invoke a command on the focused editor.
 */
var EditorHandlerCommand = /** @class */ (function (_super) {
    __extends(EditorHandlerCommand, _super);
    function EditorHandlerCommand(id, handlerId) {
        var _this = _super.call(this, {
            id: id,
            precondition: null
        }) || this;
        _this._handlerId = handlerId;
        return _this;
    }
    EditorHandlerCommand.prototype.runCommand = function (accessor, args) {
        var editor = findFocusedEditor(accessor);
        if (!editor) {
            return;
        }
        editor.trigger('keyboard', this._handlerId, args);
    };
    return EditorHandlerCommand;
}(__WEBPACK_IMPORTED_MODULE_7__editorExtensions_js__["a" /* Command */]));
registerCommand(new EditorOrNativeTextInputCommand({
    editorHandler: CoreNavigationCommands.SelectAll,
    inputHandler: 'selectAll',
    id: 'editor.action.selectAll',
    precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
    kbOpts: {
        weight: CORE_WEIGHT,
        kbExpr: null,
        primary: 2048 /* CtrlCmd */ | 31 /* KEY_A */
    },
    menubarOpts: {
        menuId: __WEBPACK_IMPORTED_MODULE_15__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
        group: '1_basic',
        title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miSelectAll', comment: ['&& denotes a mnemonic'] }, "&&Select All"),
        order: 1
    }
}));
registerCommand(new EditorOrNativeTextInputCommand({
    editorHandler: H.Undo,
    inputHandler: 'undo',
    id: H.Undo,
    precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
    kbOpts: {
        weight: CORE_WEIGHT,
        kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 2048 /* CtrlCmd */ | 56 /* KEY_Z */
    },
    menubarOpts: {
        menuId: __WEBPACK_IMPORTED_MODULE_15__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
        group: '1_do',
        title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miUndo', comment: ['&& denotes a mnemonic'] }, "&&Undo"),
        order: 1
    }
}));
registerCommand(new EditorHandlerCommand('default:' + H.Undo, H.Undo));
registerCommand(new EditorOrNativeTextInputCommand({
    editorHandler: H.Redo,
    inputHandler: 'redo',
    id: H.Redo,
    precondition: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
    kbOpts: {
        weight: CORE_WEIGHT,
        kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 2048 /* CtrlCmd */ | 55 /* KEY_Y */,
        secondary: [2048 /* CtrlCmd */ | 1024 /* Shift */ | 56 /* KEY_Z */],
        mac: { primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 56 /* KEY_Z */ }
    },
    menubarOpts: {
        menuId: __WEBPACK_IMPORTED_MODULE_15__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
        group: '1_do',
        title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miRedo', comment: ['&& denotes a mnemonic'] }, "&&Redo"),
        order: 2
    }
}));
registerCommand(new EditorHandlerCommand('default:' + H.Redo, H.Redo));
function registerOverwritableCommand(handlerId) {
    registerCommand(new EditorHandlerCommand('default:' + handlerId, handlerId));
    registerCommand(new EditorHandlerCommand(handlerId, handlerId));
}
registerOverwritableCommand(H.Type);
registerOverwritableCommand(H.ReplacePreviousChar);
registerOverwritableCommand(H.CompositionStart);
registerOverwritableCommand(H.CompositionEnd);
registerOverwritableCommand(H.Paste);
registerOverwritableCommand(H.Cut);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewEventHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ViewEventHandler = /** @class */ (function (_super) {
    __extends(ViewEventHandler, _super);
    function ViewEventHandler() {
        var _this = _super.call(this) || this;
        _this._shouldRender = true;
        return _this;
    }
    ViewEventHandler.prototype.shouldRender = function () {
        return this._shouldRender;
    };
    ViewEventHandler.prototype.forceShouldRender = function () {
        this._shouldRender = true;
    };
    ViewEventHandler.prototype.setShouldRender = function () {
        this._shouldRender = true;
    };
    ViewEventHandler.prototype.onDidRender = function () {
        this._shouldRender = false;
    };
    // --- begin event handlers
    ViewEventHandler.prototype.onConfigurationChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onCursorStateChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onDecorationsChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onFlushed = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onFocusChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onLanguageConfigurationChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onLineMappingChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onLinesChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onLinesDeleted = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onLinesInserted = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onRevealRangeRequest = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onScrollChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onTokensChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onTokensColorsChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onZonesChanged = function (e) {
        return false;
    };
    ViewEventHandler.prototype.onThemeChanged = function (e) {
        return false;
    };
    // --- end event handlers
    ViewEventHandler.prototype.handleEvents = function (events) {
        var shouldRender = false;
        for (var i = 0, len = events.length; i < len; i++) {
            var e = events[i];
            switch (e.type) {
                case 1 /* ViewConfigurationChanged */:
                    if (this.onConfigurationChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 2 /* ViewCursorStateChanged */:
                    if (this.onCursorStateChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 3 /* ViewDecorationsChanged */:
                    if (this.onDecorationsChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 4 /* ViewFlushed */:
                    if (this.onFlushed(e)) {
                        shouldRender = true;
                    }
                    break;
                case 5 /* ViewFocusChanged */:
                    if (this.onFocusChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 16 /* ViewLanguageConfigurationChanged */:
                    if (this.onLanguageConfigurationChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 6 /* ViewLineMappingChanged */:
                    if (this.onLineMappingChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 7 /* ViewLinesChanged */:
                    if (this.onLinesChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 8 /* ViewLinesDeleted */:
                    if (this.onLinesDeleted(e)) {
                        shouldRender = true;
                    }
                    break;
                case 9 /* ViewLinesInserted */:
                    if (this.onLinesInserted(e)) {
                        shouldRender = true;
                    }
                    break;
                case 10 /* ViewRevealRangeRequest */:
                    if (this.onRevealRangeRequest(e)) {
                        shouldRender = true;
                    }
                    break;
                case 11 /* ViewScrollChanged */:
                    if (this.onScrollChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 12 /* ViewTokensChanged */:
                    if (this.onTokensChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 13 /* ViewTokensColorsChanged */:
                    if (this.onTokensColorsChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 14 /* ViewZonesChanged */:
                    if (this.onZonesChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                case 15 /* ViewThemeChanged */:
                    if (this.onThemeChanged(e)) {
                        shouldRender = true;
                    }
                    break;
                default:
                    console.info('View received unknown event: ');
                    console.info(e);
            }
        }
        if (shouldRender) {
            this._shouldRender = true;
        }
    };
    return ViewEventHandler;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RestrictedRenderingContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RenderingContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LineVisibleRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HorizontalRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RestrictedRenderingContext = /** @class */ (function () {
    function RestrictedRenderingContext(viewLayout, viewportData) {
        this._viewLayout = viewLayout;
        this.viewportData = viewportData;
        this.scrollWidth = this._viewLayout.getScrollWidth();
        this.scrollHeight = this._viewLayout.getScrollHeight();
        this.visibleRange = this.viewportData.visibleRange;
        this.bigNumbersDelta = this.viewportData.bigNumbersDelta;
        var vInfo = this._viewLayout.getCurrentViewport();
        this.scrollTop = vInfo.top;
        this.scrollLeft = vInfo.left;
        this.viewportWidth = vInfo.width;
        this.viewportHeight = vInfo.height;
    }
    RestrictedRenderingContext.prototype.getScrolledTopFromAbsoluteTop = function (absoluteTop) {
        return absoluteTop - this.scrollTop;
    };
    RestrictedRenderingContext.prototype.getVerticalOffsetForLineNumber = function (lineNumber) {
        return this._viewLayout.getVerticalOffsetForLineNumber(lineNumber);
    };
    RestrictedRenderingContext.prototype.getDecorationsInViewport = function () {
        return this.viewportData.getDecorationsInViewport();
    };
    return RestrictedRenderingContext;
}());

var RenderingContext = /** @class */ (function (_super) {
    __extends(RenderingContext, _super);
    function RenderingContext(viewLayout, viewportData, viewLines) {
        var _this = _super.call(this, viewLayout, viewportData) || this;
        _this._viewLines = viewLines;
        return _this;
    }
    RenderingContext.prototype.linesVisibleRangesForRange = function (range, includeNewLines) {
        return this._viewLines.linesVisibleRangesForRange(range, includeNewLines);
    };
    RenderingContext.prototype.visibleRangeForPosition = function (position) {
        var visibleRanges = this._viewLines.visibleRangesForRange2(new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column));
        if (!visibleRanges) {
            return null;
        }
        return visibleRanges[0];
    };
    return RenderingContext;
}(RestrictedRenderingContext));

var LineVisibleRanges = /** @class */ (function () {
    function LineVisibleRanges(lineNumber, ranges) {
        this.lineNumber = lineNumber;
        this.ranges = ranges;
    }
    return LineVisibleRanges;
}());

var HorizontalRange = /** @class */ (function () {
    function HorizontalRange(left, width) {
        this.left = Math.round(left);
        this.width = Math.round(width);
    }
    HorizontalRange.prototype.toString = function () {
        return "[" + this.left + "," + this.width + "]";
    };
    return HorizontalRange;
}());



/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickBehavior; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OpenMode; });
/* unused harmony export KeybindingDispatcher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DefaultController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DefaultDragAndDrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DefaultFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultAccessibilityProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DefaultTreestyler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_keyCodes_js__ = __webpack_require__(36);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var ClickBehavior;
(function (ClickBehavior) {
    /**
     * Handle the click when the mouse button is pressed but not released yet.
     */
    ClickBehavior[ClickBehavior["ON_MOUSE_DOWN"] = 0] = "ON_MOUSE_DOWN";
    /**
     * Handle the click when the mouse button is released.
     */
    ClickBehavior[ClickBehavior["ON_MOUSE_UP"] = 1] = "ON_MOUSE_UP";
})(ClickBehavior || (ClickBehavior = {}));
var OpenMode;
(function (OpenMode) {
    OpenMode[OpenMode["SINGLE_CLICK"] = 0] = "SINGLE_CLICK";
    OpenMode[OpenMode["DOUBLE_CLICK"] = 1] = "DOUBLE_CLICK";
})(OpenMode || (OpenMode = {}));
var KeybindingDispatcher = /** @class */ (function () {
    function KeybindingDispatcher() {
        this._arr = [];
    }
    KeybindingDispatcher.prototype.set = function (keybinding, callback) {
        this._arr.push({
            keybinding: Object(__WEBPACK_IMPORTED_MODULE_3__common_keyCodes_js__["f" /* createKeybinding */])(keybinding, __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["a" /* OS */]),
            callback: callback
        });
    };
    KeybindingDispatcher.prototype.dispatch = function (keybinding) {
        // Loop from the last to the first to handle overwrites
        for (var i = this._arr.length - 1; i >= 0; i--) {
            var item = this._arr[i];
            if (keybinding.equals(item.keybinding)) {
                return item.callback;
            }
        }
        return null;
    };
    return KeybindingDispatcher;
}());

var DefaultController = /** @class */ (function () {
    function DefaultController(options) {
        if (options === void 0) { options = { clickBehavior: ClickBehavior.ON_MOUSE_DOWN, keyboardSupport: true, openMode: OpenMode.SINGLE_CLICK }; }
        var _this = this;
        this.options = options;
        this.downKeyBindingDispatcher = new KeybindingDispatcher();
        this.upKeyBindingDispatcher = new KeybindingDispatcher();
        if (typeof options.keyboardSupport !== 'boolean' || options.keyboardSupport) {
            this.downKeyBindingDispatcher.set(16 /* UpArrow */, function (t, e) { return _this.onUp(t, e); });
            this.downKeyBindingDispatcher.set(18 /* DownArrow */, function (t, e) { return _this.onDown(t, e); });
            this.downKeyBindingDispatcher.set(15 /* LeftArrow */, function (t, e) { return _this.onLeft(t, e); });
            this.downKeyBindingDispatcher.set(17 /* RightArrow */, function (t, e) { return _this.onRight(t, e); });
            if (__WEBPACK_IMPORTED_MODULE_0__common_platform_js__["d" /* isMacintosh */]) {
                this.downKeyBindingDispatcher.set(2048 /* CtrlCmd */ | 16 /* UpArrow */, function (t, e) { return _this.onLeft(t, e); });
                this.downKeyBindingDispatcher.set(256 /* WinCtrl */ | 44 /* KEY_N */, function (t, e) { return _this.onDown(t, e); });
                this.downKeyBindingDispatcher.set(256 /* WinCtrl */ | 46 /* KEY_P */, function (t, e) { return _this.onUp(t, e); });
            }
            this.downKeyBindingDispatcher.set(11 /* PageUp */, function (t, e) { return _this.onPageUp(t, e); });
            this.downKeyBindingDispatcher.set(12 /* PageDown */, function (t, e) { return _this.onPageDown(t, e); });
            this.downKeyBindingDispatcher.set(14 /* Home */, function (t, e) { return _this.onHome(t, e); });
            this.downKeyBindingDispatcher.set(13 /* End */, function (t, e) { return _this.onEnd(t, e); });
            this.downKeyBindingDispatcher.set(10 /* Space */, function (t, e) { return _this.onSpace(t, e); });
            this.downKeyBindingDispatcher.set(9 /* Escape */, function (t, e) { return _this.onEscape(t, e); });
            this.upKeyBindingDispatcher.set(3 /* Enter */, this.onEnter.bind(this));
            this.upKeyBindingDispatcher.set(2048 /* CtrlCmd */ | 3 /* Enter */, this.onEnter.bind(this));
        }
    }
    DefaultController.prototype.onMouseDown = function (tree, element, event, origin) {
        if (origin === void 0) { origin = 'mouse'; }
        if (this.options.clickBehavior === ClickBehavior.ON_MOUSE_DOWN && (event.leftButton || event.middleButton)) {
            if (event.target) {
                if (event.target.tagName && event.target.tagName.toLowerCase() === 'input') {
                    return false; // Ignore event if target is a form input field (avoids browser specific issues)
                }
                if (__WEBPACK_IMPORTED_MODULE_2__browser_dom_js__["p" /* findParentWithClass */](event.target, 'scrollbar', 'monaco-tree')) {
                    return false;
                }
                if (__WEBPACK_IMPORTED_MODULE_2__browser_dom_js__["p" /* findParentWithClass */](event.target, 'monaco-action-bar', 'row')) { // TODO@Joao not very nice way of checking for the action bar (implicit knowledge)
                    return false; // Ignore event if target is over an action bar of the row
                }
            }
            // Propagate to onLeftClick now
            return this.onLeftClick(tree, element, event, origin);
        }
        return false;
    };
    DefaultController.prototype.onClick = function (tree, element, event) {
        var isMac = __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["d" /* isMacintosh */];
        // A Ctrl click on the Mac is a context menu event
        if (isMac && event.ctrlKey) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
        if (event.target && event.target.tagName && event.target.tagName.toLowerCase() === 'input') {
            return false; // Ignore event if target is a form input field (avoids browser specific issues)
        }
        if (this.options.clickBehavior === ClickBehavior.ON_MOUSE_DOWN && (event.leftButton || event.middleButton)) {
            return false; // Already handled by onMouseDown
        }
        return this.onLeftClick(tree, element, event);
    };
    DefaultController.prototype.onLeftClick = function (tree, element, eventish, origin) {
        if (origin === void 0) { origin = 'mouse'; }
        var event = eventish;
        var payload = { origin: origin, originalEvent: eventish, didClickOnTwistie: this.isClickOnTwistie(event) };
        if (tree.getInput() === element) {
            tree.clearFocus(payload);
            tree.clearSelection(payload);
        }
        else {
            var isSingleMouseDown = eventish && event.browserEvent && event.browserEvent.type === 'mousedown' && event.browserEvent.detail === 1;
            if (!isSingleMouseDown) {
                eventish.preventDefault(); // we cannot preventDefault onMouseDown with single click because this would break DND otherwise
            }
            eventish.stopPropagation();
            tree.domFocus();
            tree.setSelection([element], payload);
            tree.setFocus(element, payload);
            if (this.shouldToggleExpansion(element, event, origin)) {
                if (tree.isExpanded(element)) {
                    tree.collapse(element).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
                }
                else {
                    tree.expand(element).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
                }
            }
        }
        return true;
    };
    DefaultController.prototype.shouldToggleExpansion = function (element, event, origin) {
        var isDoubleClick = (origin === 'mouse' && event.detail === 2);
        return this.openOnSingleClick || isDoubleClick || this.isClickOnTwistie(event);
    };
    DefaultController.prototype.setOpenMode = function (openMode) {
        this.options.openMode = openMode;
    };
    Object.defineProperty(DefaultController.prototype, "openOnSingleClick", {
        get: function () {
            return this.options.openMode === OpenMode.SINGLE_CLICK;
        },
        enumerable: true,
        configurable: true
    });
    DefaultController.prototype.isClickOnTwistie = function (event) {
        var element = event.target;
        if (!__WEBPACK_IMPORTED_MODULE_2__browser_dom_js__["z" /* hasClass */](element, 'content')) {
            return false;
        }
        var twistieStyle = window.getComputedStyle(element, ':before');
        if (twistieStyle.backgroundImage === 'none' || twistieStyle.display === 'none') {
            return false;
        }
        var twistieWidth = parseInt(twistieStyle.width) + parseInt(twistieStyle.paddingRight);
        return event.browserEvent.offsetX <= twistieWidth;
    };
    DefaultController.prototype.onContextMenu = function (tree, element, event) {
        if (event.target && event.target.tagName && event.target.tagName.toLowerCase() === 'input') {
            return false; // allow context menu on input fields
        }
        // Prevent native context menu from showing up
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return false;
    };
    DefaultController.prototype.onTap = function (tree, element, event) {
        var target = event.initialTarget;
        if (target && target.tagName && target.tagName.toLowerCase() === 'input') {
            return false; // Ignore event if target is a form input field (avoids browser specific issues)
        }
        return this.onLeftClick(tree, element, event, 'touch');
    };
    DefaultController.prototype.onKeyDown = function (tree, event) {
        return this.onKey(this.downKeyBindingDispatcher, tree, event);
    };
    DefaultController.prototype.onKeyUp = function (tree, event) {
        return this.onKey(this.upKeyBindingDispatcher, tree, event);
    };
    DefaultController.prototype.onKey = function (bindings, tree, event) {
        var handler = bindings.dispatch(event.toKeybinding());
        if (handler) {
            if (handler(tree, event)) {
                event.preventDefault();
                event.stopPropagation();
                return true;
            }
        }
        return false;
    };
    DefaultController.prototype.onUp = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            tree.focusPrevious(1, payload);
            tree.reveal(tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onPageUp = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            tree.focusPreviousPage(payload);
            tree.reveal(tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onDown = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            tree.focusNext(1, payload);
            tree.reveal(tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onPageDown = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            tree.focusNextPage(payload);
            tree.reveal(tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onHome = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            tree.focusFirst(payload);
            tree.reveal(tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onEnd = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            tree.focusLast(payload);
            tree.reveal(tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onLeft = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            var focus_1 = tree.getFocus();
            tree.collapse(focus_1).then(function (didCollapse) {
                if (focus_1 && !didCollapse) {
                    tree.focusParent(payload);
                    return tree.reveal(tree.getFocus());
                }
                return undefined;
            }).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onRight = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
        }
        else {
            var focus_2 = tree.getFocus();
            tree.expand(focus_2).then(function (didExpand) {
                if (focus_2 && !didExpand) {
                    tree.focusFirstChild(payload);
                    return tree.reveal(tree.getFocus());
                }
                return undefined;
            }).done(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    DefaultController.prototype.onEnter = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            return false;
        }
        var focus = tree.getFocus();
        if (focus) {
            tree.setSelection([focus], payload);
        }
        return true;
    };
    DefaultController.prototype.onSpace = function (tree, event) {
        if (tree.getHighlight()) {
            return false;
        }
        var focus = tree.getFocus();
        if (focus) {
            tree.toggleExpansion(focus);
        }
        return true;
    };
    DefaultController.prototype.onEscape = function (tree, event) {
        var payload = { origin: 'keyboard', originalEvent: event };
        if (tree.getHighlight()) {
            tree.clearHighlight(payload);
            return true;
        }
        if (tree.getSelection().length) {
            tree.clearSelection(payload);
            return true;
        }
        if (tree.getFocus()) {
            tree.clearFocus(payload);
            return true;
        }
        return false;
    };
    return DefaultController;
}());

var DefaultDragAndDrop = /** @class */ (function () {
    function DefaultDragAndDrop() {
    }
    DefaultDragAndDrop.prototype.getDragURI = function (tree, element) {
        return null;
    };
    DefaultDragAndDrop.prototype.onDragStart = function (tree, data, originalEvent) {
        return;
    };
    DefaultDragAndDrop.prototype.onDragOver = function (tree, data, targetElement, originalEvent) {
        return null;
    };
    DefaultDragAndDrop.prototype.drop = function (tree, data, targetElement, originalEvent) {
        return;
    };
    return DefaultDragAndDrop;
}());

var DefaultFilter = /** @class */ (function () {
    function DefaultFilter() {
    }
    DefaultFilter.prototype.isVisible = function (tree, element) {
        return true;
    };
    return DefaultFilter;
}());

var DefaultAccessibilityProvider = /** @class */ (function () {
    function DefaultAccessibilityProvider() {
    }
    DefaultAccessibilityProvider.prototype.getAriaLabel = function (tree, element) {
        return null;
    };
    return DefaultAccessibilityProvider;
}());

var DefaultTreestyler = /** @class */ (function () {
    function DefaultTreestyler(styleElement, selectorSuffix) {
        this.styleElement = styleElement;
        this.selectorSuffix = selectorSuffix;
    }
    DefaultTreestyler.prototype.style = function (styles) {
        var suffix = this.selectorSuffix ? "." + this.selectorSuffix : '';
        var content = [];
        if (styles.listFocusBackground) {
            content.push(".monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.focused:not(.highlighted) { background-color: " + styles.listFocusBackground + "; }");
        }
        if (styles.listFocusForeground) {
            content.push(".monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.focused:not(.highlighted) { color: " + styles.listFocusForeground + "; }");
        }
        if (styles.listActiveSelectionBackground) {
            content.push(".monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted) { background-color: " + styles.listActiveSelectionBackground + "; }");
        }
        if (styles.listActiveSelectionForeground) {
            content.push(".monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted) { color: " + styles.listActiveSelectionForeground + "; }");
        }
        if (styles.listFocusAndSelectionBackground) {
            content.push("\n\t\t\t\t.monaco-tree-drag-image,\n\t\t\t\t.monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.focused.selected:not(.highlighted) { background-color: " + styles.listFocusAndSelectionBackground + "; }\n\t\t\t");
        }
        if (styles.listFocusAndSelectionForeground) {
            content.push("\n\t\t\t\t.monaco-tree-drag-image,\n\t\t\t\t.monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.focused.selected:not(.highlighted) { color: " + styles.listFocusAndSelectionForeground + "; }\n\t\t\t");
        }
        if (styles.listInactiveSelectionBackground) {
            content.push(".monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted) { background-color: " + styles.listInactiveSelectionBackground + "; }");
        }
        if (styles.listInactiveSelectionForeground) {
            content.push(".monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted) { color: " + styles.listInactiveSelectionForeground + "; }");
        }
        if (styles.listHoverBackground) {
            content.push(".monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row:hover:not(.highlighted):not(.selected):not(.focused) { background-color: " + styles.listHoverBackground + "; }");
        }
        if (styles.listHoverForeground) {
            content.push(".monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row:hover:not(.highlighted):not(.selected):not(.focused) { color: " + styles.listHoverForeground + "; }");
        }
        if (styles.listDropBackground) {
            content.push("\n\t\t\t\t.monaco-tree" + suffix + " .monaco-tree-wrapper.drop-target,\n\t\t\t\t.monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row.drop-target { background-color: " + styles.listDropBackground + " !important; color: inherit !important; }\n\t\t\t");
        }
        if (styles.listFocusOutline) {
            content.push("\n\t\t\t\t.monaco-tree-drag-image\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{ border: 1px solid " + styles.listFocusOutline + "; background: #000; }\n\t\t\t\t.monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row \t\t\t\t\t\t\t\t\t\t\t\t\t\t{ border: 1px solid transparent; }\n\t\t\t\t.monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.focused:not(.highlighted) \t\t\t\t\t\t{ border: 1px dotted " + styles.listFocusOutline + "; }\n\t\t\t\t.monaco-tree" + suffix + ".focused .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted) \t\t\t\t\t\t{ border: 1px solid " + styles.listFocusOutline + "; }\n\t\t\t\t.monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted)  \t\t\t\t\t\t\t{ border: 1px solid " + styles.listFocusOutline + "; }\n\t\t\t\t.monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row:hover:not(.highlighted):not(.selected):not(.focused)  \t{ border: 1px dashed " + styles.listFocusOutline + "; }\n\t\t\t\t.monaco-tree" + suffix + " .monaco-tree-wrapper.drop-target,\n\t\t\t\t.monaco-tree" + suffix + " .monaco-tree-rows > .monaco-tree-row.drop-target\t\t\t\t\t\t\t\t\t\t\t\t{ border: 1px dashed " + styles.listFocusOutline + "; }\n\t\t\t");
        }
        var newStyles = content.join('\n');
        if (newStyles !== this.styleElement.innerHTML) {
            this.styleElement.innerHTML = newStyles;
        }
    };
    return DefaultTreestyler;
}());



/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IStandaloneThemeService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IStandaloneThemeService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])('themeService');


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SnippetController2", function() { return SnippetController2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snippetSession_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__suggest_suggest_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_log_common_log_js__ = __webpack_require__(182);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};









var SnippetController2 = /** @class */ (function () {
    function SnippetController2(_editor, _logService, contextKeyService) {
        this._editor = _editor;
        this._logService = _logService;
        this._snippetListener = [];
        this._inSnippet = SnippetController2.InSnippetMode.bindTo(contextKeyService);
        this._hasNextTabstop = SnippetController2.HasNextTabstop.bindTo(contextKeyService);
        this._hasPrevTabstop = SnippetController2.HasPrevTabstop.bindTo(contextKeyService);
    }
    SnippetController2.get = function (editor) {
        return editor.getContribution('snippetController2');
    };
    SnippetController2.prototype.dispose = function () {
        this._inSnippet.reset();
        this._hasPrevTabstop.reset();
        this._hasNextTabstop.reset();
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._session);
    };
    SnippetController2.prototype.getId = function () {
        return 'snippetController2';
    };
    SnippetController2.prototype.insert = function (template, overwriteBefore, overwriteAfter, undoStopBefore, undoStopAfter) {
        if (overwriteBefore === void 0) { overwriteBefore = 0; }
        if (overwriteAfter === void 0) { overwriteAfter = 0; }
        if (undoStopBefore === void 0) { undoStopBefore = true; }
        if (undoStopAfter === void 0) { undoStopAfter = true; }
        // this is here to find out more about the yet-not-understood
        // error that sometimes happens when we fail to inserted a nested
        // snippet
        try {
            this._doInsert(template, overwriteBefore, overwriteAfter, undoStopBefore, undoStopAfter);
        }
        catch (e) {
            this.cancel();
            this._logService.error(e);
            this._logService.error('snippet_error');
            this._logService.error('insert_template=', template);
            this._logService.error('existing_template=', this._session ? this._session._logInfo() : '<no_session>');
        }
    };
    SnippetController2.prototype._doInsert = function (template, overwriteBefore, overwriteAfter, undoStopBefore, undoStopAfter) {
        var _this = this;
        if (overwriteBefore === void 0) { overwriteBefore = 0; }
        if (overwriteAfter === void 0) { overwriteAfter = 0; }
        if (undoStopBefore === void 0) { undoStopBefore = true; }
        if (undoStopAfter === void 0) { undoStopAfter = true; }
        // don't listen while inserting the snippet
        // as that is the inflight state causing cancelation
        this._snippetListener = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._snippetListener);
        if (undoStopBefore) {
            this._editor.getModel().pushStackElement();
        }
        if (!this._session) {
            this._modelVersionId = this._editor.getModel().getAlternativeVersionId();
            this._session = new __WEBPACK_IMPORTED_MODULE_3__snippetSession_js__["a" /* SnippetSession */](this._editor, template, overwriteBefore, overwriteAfter);
            this._session.insert();
        }
        else {
            this._session.merge(template, overwriteBefore, overwriteAfter);
        }
        if (undoStopAfter) {
            this._editor.getModel().pushStackElement();
        }
        this._updateState();
        this._snippetListener = [
            this._editor.onDidChangeModelContent(function (e) { return e.isFlush && _this.cancel(); }),
            this._editor.onDidChangeModel(function () { return _this.cancel(); }),
            this._editor.onDidChangeCursorSelection(function () { return _this._updateState(); })
        ];
    };
    SnippetController2.prototype._updateState = function () {
        if (!this._session) {
            // canceled in the meanwhile
            return;
        }
        if (this._modelVersionId === this._editor.getModel().getAlternativeVersionId()) {
            // undo until the 'before' state happened
            // and makes use cancel snippet mode
            return this.cancel();
        }
        if (!this._session.hasPlaceholder) {
            // don't listen for selection changes and don't
            // update context keys when the snippet is plain text
            return this.cancel();
        }
        if (this._session.isAtLastPlaceholder || !this._session.isSelectionWithinPlaceholders()) {
            return this.cancel();
        }
        this._inSnippet.set(true);
        this._hasPrevTabstop.set(!this._session.isAtFirstPlaceholder);
        this._hasNextTabstop.set(!this._session.isAtLastPlaceholder);
        this._handleChoice();
    };
    SnippetController2.prototype._handleChoice = function () {
        var choice = this._session.choice;
        if (!choice) {
            this._currentChoice = undefined;
            return;
        }
        if (this._currentChoice !== choice) {
            this._currentChoice = choice;
            this._editor.setSelections(this._editor.getSelections()
                .map(function (s) { return __WEBPACK_IMPORTED_MODULE_6__common_core_selection_js__["a" /* Selection */].fromPositions(s.getStartPosition()); }));
            var first_1 = choice.options[0];
            Object(__WEBPACK_IMPORTED_MODULE_5__suggest_suggest_js__["e" /* showSimpleSuggestions */])(this._editor, choice.options.map(function (option, i) {
                // let before = choice.options.slice(0, i);
                // let after = choice.options.slice(i);
                return {
                    type: 'value',
                    label: option.value,
                    insertText: option.value,
                    // insertText: `\${1|${after.concat(before).join(',')}|}$0`,
                    // snippetType: 'textmate',
                    sortText: Object(__WEBPACK_IMPORTED_MODULE_7__base_common_strings_js__["repeat"])('a', i),
                    overwriteAfter: first_1.value.length
                };
            }));
        }
    };
    SnippetController2.prototype.finish = function () {
        while (this._inSnippet.get()) {
            this.next();
        }
    };
    SnippetController2.prototype.cancel = function () {
        this._inSnippet.reset();
        this._hasPrevTabstop.reset();
        this._hasNextTabstop.reset();
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._snippetListener);
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._session);
        this._session = undefined;
        this._modelVersionId = -1;
    };
    SnippetController2.prototype.prev = function () {
        this._session.prev();
        this._updateState();
    };
    SnippetController2.prototype.next = function () {
        this._session.next();
        this._updateState();
    };
    SnippetController2.prototype.isInSnippet = function () {
        return this._inSnippet.get();
    };
    SnippetController2.InSnippetMode = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('inSnippetMode', false);
    SnippetController2.HasNextTabstop = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('hasNextTabstop', false);
    SnippetController2.HasPrevTabstop = new __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('hasPrevTabstop', false);
    SnippetController2 = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_8__platform_log_common_log_js__["a" /* ILogService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], SnippetController2);
    return SnippetController2;
}());

Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["h" /* registerEditorContribution */])(SnippetController2);
var CommandCtor = __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(SnippetController2.get);
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CommandCtor({
    id: 'jumpToNextSnippetPlaceholder',
    precondition: __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(SnippetController2.InSnippetMode, SnippetController2.HasNextTabstop),
    handler: function (ctrl) { return ctrl.next(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 30,
        kbExpr: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
        primary: 2 /* Tab */
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CommandCtor({
    id: 'jumpToPrevSnippetPlaceholder',
    precondition: __WEBPACK_IMPORTED_MODULE_0__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(SnippetController2.InSnippetMode, SnippetController2.HasPrevTabstop),
    handler: function (ctrl) { return ctrl.prev(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 30,
        kbExpr: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
        primary: 1024 /* Shift */ | 2 /* Tab */
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CommandCtor({
    id: 'leaveSnippet',
    precondition: SnippetController2.InSnippetMode,
    handler: function (ctrl) { return ctrl.cancel(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 30,
        kbExpr: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
        primary: 9 /* Escape */,
        secondary: [1024 /* Shift */ | 9 /* Escape */]
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CommandCtor({
    id: 'acceptSnippet',
    precondition: SnippetController2.InSnippetMode,
    handler: function (ctrl) { return ctrl.finish(); },
}));


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeybindingsRegistry; });
/* unused harmony export Extensions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registry_common_platform_js__ = __webpack_require__(40);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var KeybindingsRegistryImpl = /** @class */ (function () {
    function KeybindingsRegistryImpl() {
        this._keybindings = [];
        this._keybindingsSorted = true;
    }
    /**
     * Take current platform into account and reduce to primary & secondary.
     */
    KeybindingsRegistryImpl.bindToCurrentPlatform = function (kb) {
        if (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["a" /* OS */] === 1 /* Windows */) {
            if (kb && kb.win) {
                return kb.win;
            }
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["a" /* OS */] === 2 /* Macintosh */) {
            if (kb && kb.mac) {
                return kb.mac;
            }
        }
        else {
            if (kb && kb.linux) {
                return kb.linux;
            }
        }
        return kb;
    };
    KeybindingsRegistryImpl.prototype.registerKeybindingRule = function (rule, source) {
        if (source === void 0) { source = 0 /* Core */; }
        var actualKb = KeybindingsRegistryImpl.bindToCurrentPlatform(rule);
        if (actualKb && actualKb.primary) {
            this._registerDefaultKeybinding(Object(__WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__["f" /* createKeybinding */])(actualKb.primary, __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["a" /* OS */]), rule.id, rule.weight, 0, rule.when, source);
        }
        if (actualKb && Array.isArray(actualKb.secondary)) {
            for (var i = 0, len = actualKb.secondary.length; i < len; i++) {
                var k = actualKb.secondary[i];
                this._registerDefaultKeybinding(Object(__WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__["f" /* createKeybinding */])(k, __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["a" /* OS */]), rule.id, rule.weight, -i - 1, rule.when, source);
            }
        }
    };
    KeybindingsRegistryImpl.prototype.registerCommandAndKeybindingRule = function (desc, source) {
        if (source === void 0) { source = 0 /* Core */; }
        this.registerKeybindingRule(desc, source);
        __WEBPACK_IMPORTED_MODULE_2__commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand(desc);
    };
    KeybindingsRegistryImpl._mightProduceChar = function (keyCode) {
        if (keyCode >= 21 /* KEY_0 */ && keyCode <= 30 /* KEY_9 */) {
            return true;
        }
        if (keyCode >= 31 /* KEY_A */ && keyCode <= 56 /* KEY_Z */) {
            return true;
        }
        return (keyCode === 80 /* US_SEMICOLON */
            || keyCode === 81 /* US_EQUAL */
            || keyCode === 82 /* US_COMMA */
            || keyCode === 83 /* US_MINUS */
            || keyCode === 84 /* US_DOT */
            || keyCode === 85 /* US_SLASH */
            || keyCode === 86 /* US_BACKTICK */
            || keyCode === 110 /* ABNT_C1 */
            || keyCode === 111 /* ABNT_C2 */
            || keyCode === 87 /* US_OPEN_SQUARE_BRACKET */
            || keyCode === 88 /* US_BACKSLASH */
            || keyCode === 89 /* US_CLOSE_SQUARE_BRACKET */
            || keyCode === 90 /* US_QUOTE */
            || keyCode === 91 /* OEM_8 */
            || keyCode === 92 /* OEM_102 */);
    };
    KeybindingsRegistryImpl.prototype._assertNoCtrlAlt = function (keybinding, commandId) {
        if (keybinding.ctrlKey && keybinding.altKey && !keybinding.metaKey) {
            if (KeybindingsRegistryImpl._mightProduceChar(keybinding.keyCode)) {
                console.warn('Ctrl+Alt+ keybindings should not be used by default under Windows. Offender: ', keybinding, ' for ', commandId);
            }
        }
    };
    KeybindingsRegistryImpl.prototype._registerDefaultKeybinding = function (keybinding, commandId, weight1, weight2, when, source) {
        if (source === 0 /* Core */ && __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["a" /* OS */] === 1 /* Windows */) {
            if (keybinding.type === 2 /* Chord */) {
                this._assertNoCtrlAlt(keybinding.firstPart, commandId);
            }
            else {
                this._assertNoCtrlAlt(keybinding, commandId);
            }
        }
        this._keybindings.push({
            keybinding: keybinding,
            command: commandId,
            commandArgs: undefined,
            when: when,
            weight1: weight1,
            weight2: weight2
        });
        this._keybindingsSorted = false;
    };
    KeybindingsRegistryImpl.prototype.getDefaultKeybindings = function () {
        if (!this._keybindingsSorted) {
            this._keybindings.sort(sorter);
            this._keybindingsSorted = true;
        }
        return this._keybindings.slice(0);
    };
    return KeybindingsRegistryImpl;
}());
var KeybindingsRegistry = new KeybindingsRegistryImpl();
// Define extension point ids
var Extensions = {
    EditorModes: 'platform.keybindingsRegistry'
};
__WEBPACK_IMPORTED_MODULE_3__registry_common_platform_js__["a" /* Registry */].add(Extensions.EditorModes, KeybindingsRegistry);
function sorter(a, b) {
    if (a.weight1 !== b.weight1) {
        return a.weight1 - b.weight1;
    }
    if (a.command < b.command) {
        return -1;
    }
    if (a.command > b.command) {
        return 1;
    }
    return a.weight2 - b.weight2;
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleTabFocusModeAction", function() { return ToggleTabFocusModeAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_config_commonEditorConfig_js__ = __webpack_require__(118);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ToggleTabFocusModeAction = /** @class */ (function (_super) {
    __extends(ToggleTabFocusModeAction, _super);
    function ToggleTabFocusModeAction() {
        return _super.call(this, {
            id: ToggleTabFocusModeAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'toggle.tabMovesFocus', comment: ['Turn on/off use of tab key for moving focus around VS Code'] }, "Toggle Tab Key Moves Focus"),
            alias: 'Toggle Tab Key Moves Focus',
            precondition: null,
            kbOpts: {
                kbExpr: null,
                primary: 2048 /* CtrlCmd */ | 43 /* KEY_M */,
                mac: { primary: 256 /* WinCtrl */ | 1024 /* Shift */ | 43 /* KEY_M */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    ToggleTabFocusModeAction.prototype.run = function (accessor, editor) {
        var oldValue = __WEBPACK_IMPORTED_MODULE_2__common_config_commonEditorConfig_js__["b" /* TabFocus */].getTabFocusMode();
        __WEBPACK_IMPORTED_MODULE_2__common_config_commonEditorConfig_js__["b" /* TabFocus */].setTabFocusMode(!oldValue);
    };
    ToggleTabFocusModeAction.ID = 'editor.action.toggleTabFocusMode';
    return ToggleTabFocusModeAction;
}(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["f" /* registerEditorAction */])(ToggleTabFocusModeAction);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorZoom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var EditorZoom = new /** @class */ (function () {
    function class_1() {
        this._zoomLevel = 0;
        this._onDidChangeZoomLevel = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
    }
    class_1.prototype.getZoomLevel = function () {
        return this._zoomLevel;
    };
    class_1.prototype.setZoomLevel = function (zoomLevel) {
        zoomLevel = Math.min(Math.max(-5, zoomLevel), 20);
        if (this._zoomLevel === zoomLevel) {
            return;
        }
        this._zoomLevel = zoomLevel;
        this._onDidChangeZoomLevel.fire(this._zoomLevel);
    };
    return class_1;
}());


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USUAL_WORD_SEPARATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_WORD_REGEXP; });
/* harmony export (immutable) */ __webpack_exports__["c"] = ensureValidWordDefinition;
/* harmony export (immutable) */ __webpack_exports__["d"] = getWordAtText;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var USUAL_WORD_SEPARATORS = '`~!@#$%^&*()-=+[{]}\\|;:\'",.<>/?';
/**
 * Create a word definition regular expression based on default word separators.
 * Optionally provide allowed separators that should be included in words.
 *
 * The default would look like this:
 * /(-?\d*\.\d\w*)|([^\`\~\!\@\#\$\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g
 */
function createWordRegExp(allowInWords) {
    if (allowInWords === void 0) { allowInWords = ''; }
    var source = '(-?\\d*\\.\\d\\w*)|([^';
    for (var i = 0; i < USUAL_WORD_SEPARATORS.length; i++) {
        if (allowInWords.indexOf(USUAL_WORD_SEPARATORS[i]) >= 0) {
            continue;
        }
        source += '\\' + USUAL_WORD_SEPARATORS[i];
    }
    source += '\\s]+)';
    return new RegExp(source, 'g');
}
// catches numbers (including floating numbers) in the first group, and alphanum in the second
var DEFAULT_WORD_REGEXP = createWordRegExp();
function ensureValidWordDefinition(wordDefinition) {
    var result = DEFAULT_WORD_REGEXP;
    if (wordDefinition && (wordDefinition instanceof RegExp)) {
        if (!wordDefinition.global) {
            var flags = 'g';
            if (wordDefinition.ignoreCase) {
                flags += 'i';
            }
            if (wordDefinition.multiline) {
                flags += 'm';
            }
            result = new RegExp(wordDefinition.source, flags);
        }
        else {
            result = wordDefinition;
        }
    }
    result.lastIndex = 0;
    return result;
}
function getWordAtPosFast(column, wordDefinition, text, textOffset) {
    // find whitespace enclosed text around column and match from there
    var pos = column - 1 - textOffset;
    var start = text.lastIndexOf(' ', pos - 1) + 1;
    var end = text.indexOf(' ', pos);
    if (end === -1) {
        end = text.length;
    }
    wordDefinition.lastIndex = start;
    var match;
    while (match = wordDefinition.exec(text)) {
        if (match.index <= pos && wordDefinition.lastIndex >= pos) {
            return {
                word: match[0],
                startColumn: textOffset + 1 + match.index,
                endColumn: textOffset + 1 + wordDefinition.lastIndex
            };
        }
    }
    return null;
}
function getWordAtPosSlow(column, wordDefinition, text, textOffset) {
    // matches all words starting at the beginning
    // of the input until it finds a match that encloses
    // the desired column. slow but correct
    var pos = column - 1 - textOffset;
    wordDefinition.lastIndex = 0;
    var match;
    while (match = wordDefinition.exec(text)) {
        if (match.index > pos) {
            // |nW -> matched only after the pos
            return null;
        }
        else if (wordDefinition.lastIndex >= pos) {
            // W|W -> match encloses pos
            return {
                word: match[0],
                startColumn: textOffset + 1 + match.index,
                endColumn: textOffset + 1 + wordDefinition.lastIndex
            };
        }
    }
    return null;
}
function getWordAtText(column, wordDefinition, text, textOffset) {
    // if `words` can contain whitespace character we have to use the slow variant
    // otherwise we use the fast variant of finding a word
    wordDefinition.lastIndex = 0;
    var match = wordDefinition.exec(text);
    if (!match) {
        return null;
    }
    // todo@joh the `match` could already be the (first) word
    var ret = match[0].indexOf(' ') >= 0
        // did match a word which contains a space character -> use slow word find
        ? getWordAtPosSlow(column, wordDefinition, text, textOffset)
        // sane word definition -> use fast word find
        : getWordAtPosFast(column, wordDefinition, text, textOffset);
    // both (getWordAtPosFast and getWordAtPosSlow) leave the wordDefinition-RegExp
    // in an undefined state and to not confuse other users of the wordDefinition
    // we reset the lastIndex
    wordDefinition.lastIndex = 0;
    return ret;
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Token; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TokenizationResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TokenizationResult2; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var Token = /** @class */ (function () {
    function Token(offset, type, language) {
        this.offset = offset | 0; // @perf
        this.type = type;
        this.language = language;
    }
    Token.prototype.toString = function () {
        return '(' + this.offset + ', ' + this.type + ')';
    };
    return Token;
}());

var TokenizationResult = /** @class */ (function () {
    function TokenizationResult(tokens, endState) {
        this.tokens = tokens;
        this.endState = endState;
    }
    return TokenizationResult;
}());

var TokenizationResult2 = /** @class */ (function () {
    function TokenizationResult2(tokens, endState) {
        this.tokens = tokens;
        this.endState = endState;
    }
    return TokenizationResult2;
}());



/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createScopedLineTokens;
/* unused harmony export ScopedLineTokens */
/* harmony export (immutable) */ __webpack_exports__["b"] = ignoreBracketsInToken;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function createScopedLineTokens(context, offset) {
    var tokenCount = context.getCount();
    var tokenIndex = context.findTokenIndexAtOffset(offset);
    var desiredLanguageId = context.getLanguageId(tokenIndex);
    var lastTokenIndex = tokenIndex;
    while (lastTokenIndex + 1 < tokenCount && context.getLanguageId(lastTokenIndex + 1) === desiredLanguageId) {
        lastTokenIndex++;
    }
    var firstTokenIndex = tokenIndex;
    while (firstTokenIndex > 0 && context.getLanguageId(firstTokenIndex - 1) === desiredLanguageId) {
        firstTokenIndex--;
    }
    return new ScopedLineTokens(context, desiredLanguageId, firstTokenIndex, lastTokenIndex + 1, context.getStartOffset(firstTokenIndex), context.getEndOffset(lastTokenIndex));
}
var ScopedLineTokens = /** @class */ (function () {
    function ScopedLineTokens(actual, languageId, firstTokenIndex, lastTokenIndex, firstCharOffset, lastCharOffset) {
        this._actual = actual;
        this.languageId = languageId;
        this._firstTokenIndex = firstTokenIndex;
        this._lastTokenIndex = lastTokenIndex;
        this.firstCharOffset = firstCharOffset;
        this._lastCharOffset = lastCharOffset;
    }
    ScopedLineTokens.prototype.getLineContent = function () {
        var actualLineContent = this._actual.getLineContent();
        return actualLineContent.substring(this.firstCharOffset, this._lastCharOffset);
    };
    ScopedLineTokens.prototype.getTokenCount = function () {
        return this._lastTokenIndex - this._firstTokenIndex;
    };
    ScopedLineTokens.prototype.findTokenIndexAtOffset = function (offset) {
        return this._actual.findTokenIndexAtOffset(offset + this.firstCharOffset) - this._firstTokenIndex;
    };
    ScopedLineTokens.prototype.getStandardTokenType = function (tokenIndex) {
        return this._actual.getStandardTokenType(tokenIndex + this._firstTokenIndex);
    };
    return ScopedLineTokens;
}());

function ignoreBracketsInToken(standardTokenType) {
    return (standardTokenType & 7 /* value */) !== 0;
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RichEditBracket */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RichEditBrackets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BracketsUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var RichEditBracket = /** @class */ (function () {
    function RichEditBracket(languageIdentifier, open, close, forwardRegex, reversedRegex) {
        this.languageIdentifier = languageIdentifier;
        this.open = open;
        this.close = close;
        this.forwardRegex = forwardRegex;
        this.reversedRegex = reversedRegex;
    }
    return RichEditBracket;
}());

var RichEditBrackets = /** @class */ (function () {
    function RichEditBrackets(languageIdentifier, brackets) {
        var _this = this;
        this.brackets = brackets.map(function (b) {
            return new RichEditBracket(languageIdentifier, b[0], b[1], getRegexForBracketPair({ open: b[0], close: b[1] }), getReversedRegexForBracketPair({ open: b[0], close: b[1] }));
        });
        this.forwardRegex = getRegexForBrackets(this.brackets);
        this.reversedRegex = getReversedRegexForBrackets(this.brackets);
        this.textIsBracket = {};
        this.textIsOpenBracket = {};
        var maxBracketLength = 0;
        this.brackets.forEach(function (b) {
            _this.textIsBracket[b.open.toLowerCase()] = b;
            _this.textIsBracket[b.close.toLowerCase()] = b;
            _this.textIsOpenBracket[b.open.toLowerCase()] = true;
            _this.textIsOpenBracket[b.close.toLowerCase()] = false;
            maxBracketLength = Math.max(maxBracketLength, b.open.length);
            maxBracketLength = Math.max(maxBracketLength, b.close.length);
        });
        this.maxBracketLength = maxBracketLength;
    }
    return RichEditBrackets;
}());

function once(keyFn, computeFn) {
    var cache = {};
    return function (input) {
        var key = keyFn(input);
        if (!cache.hasOwnProperty(key)) {
            cache[key] = computeFn(input);
        }
        return cache[key];
    };
}
var getRegexForBracketPair = once(function (input) { return input.open + ";" + input.close; }, function (input) {
    return createBracketOrRegExp([input.open, input.close]);
});
var getReversedRegexForBracketPair = once(function (input) { return input.open + ";" + input.close; }, function (input) {
    return createBracketOrRegExp([toReversedString(input.open), toReversedString(input.close)]);
});
var getRegexForBrackets = once(function (input) { return input.map(function (b) { return b.open + ";" + b.close; }).join(';'); }, function (input) {
    var pieces = [];
    input.forEach(function (b) {
        pieces.push(b.open);
        pieces.push(b.close);
    });
    return createBracketOrRegExp(pieces);
});
var getReversedRegexForBrackets = once(function (input) { return input.map(function (b) { return b.open + ";" + b.close; }).join(';'); }, function (input) {
    var pieces = [];
    input.forEach(function (b) {
        pieces.push(toReversedString(b.open));
        pieces.push(toReversedString(b.close));
    });
    return createBracketOrRegExp(pieces);
});
function prepareBracketForRegExp(str) {
    // This bracket pair uses letters like e.g. "begin" - "end"
    var insertWordBoundaries = (/^[\w]+$/.test(str));
    str = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["escapeRegExpCharacters"](str);
    return (insertWordBoundaries ? "\\b" + str + "\\b" : str);
}
function createBracketOrRegExp(pieces) {
    var regexStr = "(" + pieces.map(prepareBracketForRegExp).join(')|(') + ")";
    return __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["createRegExp"](regexStr, true);
}
var toReversedString = (function () {
    function reverse(str) {
        var reversedStr = '';
        for (var i = str.length - 1; i >= 0; i--) {
            reversedStr += str.charAt(i);
        }
        return reversedStr;
    }
    var lastInput = null;
    var lastOutput = null;
    return function toReversedString(str) {
        if (lastInput !== str) {
            lastInput = str;
            lastOutput = reverse(lastInput);
        }
        return lastOutput;
    };
})();
var BracketsUtils = /** @class */ (function () {
    function BracketsUtils() {
    }
    BracketsUtils._findPrevBracketInText = function (reversedBracketRegex, lineNumber, reversedText, offset) {
        var m = reversedText.match(reversedBracketRegex);
        if (!m) {
            return null;
        }
        var matchOffset = reversedText.length - m.index;
        var matchLength = m[0].length;
        var absoluteMatchOffset = offset + matchOffset;
        return new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](lineNumber, absoluteMatchOffset - matchLength + 1, lineNumber, absoluteMatchOffset + 1);
    };
    BracketsUtils.findPrevBracketInToken = function (reversedBracketRegex, lineNumber, lineText, currentTokenStart, currentTokenEnd) {
        // Because JS does not support backwards regex search, we search forwards in a reversed string with a reversed regex ;)
        var reversedLineText = toReversedString(lineText);
        var reversedTokenText = reversedLineText.substring(lineText.length - currentTokenEnd, lineText.length - currentTokenStart);
        return this._findPrevBracketInText(reversedBracketRegex, lineNumber, reversedTokenText, currentTokenStart);
    };
    BracketsUtils.findNextBracketInText = function (bracketRegex, lineNumber, text, offset) {
        var m = text.match(bracketRegex);
        if (!m) {
            return null;
        }
        var matchOffset = m.index;
        var matchLength = m[0].length;
        if (matchLength === 0) {
            return null;
        }
        var absoluteMatchOffset = offset + matchOffset;
        return new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](lineNumber, absoluteMatchOffset + 1, lineNumber, absoluteMatchOffset + 1 + matchLength);
    };
    BracketsUtils.findNextBracketInToken = function (bracketRegex, lineNumber, lineText, currentTokenStart, currentTokenEnd) {
        var currentTokenText = lineText.substring(currentTokenStart, currentTokenEnd);
        return this.findNextBracketInText(bracketRegex, lineNumber, currentTokenText, currentTokenStart);
    };
    return BracketsUtils;
}());



/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineTokens; });
/* unused harmony export SlicedLineTokens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modes_js__ = __webpack_require__(15);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var LineTokens = /** @class */ (function () {
    function LineTokens(tokens, text) {
        this._tokens = tokens;
        this._tokensCount = (this._tokens.length >>> 1);
        this._text = text;
    }
    LineTokens.prototype.equals = function (other) {
        if (other instanceof LineTokens) {
            return this.slicedEquals(other, 0, this._tokensCount);
        }
        return false;
    };
    LineTokens.prototype.slicedEquals = function (other, sliceFromTokenIndex, sliceTokenCount) {
        if (this._text !== other._text) {
            return false;
        }
        if (this._tokensCount !== other._tokensCount) {
            return false;
        }
        var from = (sliceFromTokenIndex << 1);
        var to = from + (sliceTokenCount << 1);
        for (var i = from; i < to; i++) {
            if (this._tokens[i] !== other._tokens[i]) {
                return false;
            }
        }
        return true;
    };
    LineTokens.prototype.getLineContent = function () {
        return this._text;
    };
    LineTokens.prototype.getCount = function () {
        return this._tokensCount;
    };
    LineTokens.prototype.getStartOffset = function (tokenIndex) {
        if (tokenIndex > 0) {
            return this._tokens[(tokenIndex - 1) << 1];
        }
        return 0;
    };
    LineTokens.prototype.getLanguageId = function (tokenIndex) {
        var metadata = this._tokens[(tokenIndex << 1) + 1];
        return __WEBPACK_IMPORTED_MODULE_0__modes_js__["x" /* TokenMetadata */].getLanguageId(metadata);
    };
    LineTokens.prototype.getStandardTokenType = function (tokenIndex) {
        var metadata = this._tokens[(tokenIndex << 1) + 1];
        return __WEBPACK_IMPORTED_MODULE_0__modes_js__["x" /* TokenMetadata */].getTokenType(metadata);
    };
    LineTokens.prototype.getForeground = function (tokenIndex) {
        var metadata = this._tokens[(tokenIndex << 1) + 1];
        return __WEBPACK_IMPORTED_MODULE_0__modes_js__["x" /* TokenMetadata */].getForeground(metadata);
    };
    LineTokens.prototype.getClassName = function (tokenIndex) {
        var metadata = this._tokens[(tokenIndex << 1) + 1];
        return __WEBPACK_IMPORTED_MODULE_0__modes_js__["x" /* TokenMetadata */].getClassNameFromMetadata(metadata);
    };
    LineTokens.prototype.getInlineStyle = function (tokenIndex, colorMap) {
        var metadata = this._tokens[(tokenIndex << 1) + 1];
        return __WEBPACK_IMPORTED_MODULE_0__modes_js__["x" /* TokenMetadata */].getInlineStyleFromMetadata(metadata, colorMap);
    };
    LineTokens.prototype.getEndOffset = function (tokenIndex) {
        return this._tokens[tokenIndex << 1];
    };
    /**
     * Find the token containing offset `offset`.
     * @param offset The search offset
     * @return The index of the token containing the offset.
     */
    LineTokens.prototype.findTokenIndexAtOffset = function (offset) {
        return LineTokens.findIndexInTokensArray(this._tokens, offset);
    };
    LineTokens.prototype.inflate = function () {
        return this;
    };
    LineTokens.prototype.sliceAndInflate = function (startOffset, endOffset, deltaOffset) {
        return new SlicedLineTokens(this, startOffset, endOffset, deltaOffset);
    };
    LineTokens.convertToEndOffset = function (tokens, lineTextLength) {
        var tokenCount = (tokens.length >>> 1);
        var lastTokenIndex = tokenCount - 1;
        for (var tokenIndex = 0; tokenIndex < lastTokenIndex; tokenIndex++) {
            tokens[tokenIndex << 1] = tokens[(tokenIndex + 1) << 1];
        }
        tokens[lastTokenIndex << 1] = lineTextLength;
    };
    LineTokens.findIndexInTokensArray = function (tokens, desiredIndex) {
        if (tokens.length <= 2) {
            return 0;
        }
        var low = 0;
        var high = (tokens.length >>> 1) - 1;
        while (low < high) {
            var mid = low + Math.floor((high - low) / 2);
            var endOffset = tokens[(mid << 1)];
            if (endOffset === desiredIndex) {
                return mid + 1;
            }
            else if (endOffset < desiredIndex) {
                low = mid + 1;
            }
            else if (endOffset > desiredIndex) {
                high = mid;
            }
        }
        return low;
    };
    return LineTokens;
}());

var SlicedLineTokens = /** @class */ (function () {
    function SlicedLineTokens(source, startOffset, endOffset, deltaOffset) {
        this._source = source;
        this._startOffset = startOffset;
        this._endOffset = endOffset;
        this._deltaOffset = deltaOffset;
        this._firstTokenIndex = source.findTokenIndexAtOffset(startOffset);
        this._tokensCount = 0;
        for (var i = this._firstTokenIndex, len = source.getCount(); i < len; i++) {
            var tokenStartOffset = source.getStartOffset(i);
            if (tokenStartOffset >= endOffset) {
                break;
            }
            this._tokensCount++;
        }
    }
    SlicedLineTokens.prototype.equals = function (other) {
        if (other instanceof SlicedLineTokens) {
            return (this._startOffset === other._startOffset
                && this._endOffset === other._endOffset
                && this._deltaOffset === other._deltaOffset
                && this._source.slicedEquals(other._source, this._firstTokenIndex, this._tokensCount));
        }
        return false;
    };
    SlicedLineTokens.prototype.getCount = function () {
        return this._tokensCount;
    };
    SlicedLineTokens.prototype.getForeground = function (tokenIndex) {
        return this._source.getForeground(this._firstTokenIndex + tokenIndex);
    };
    SlicedLineTokens.prototype.getEndOffset = function (tokenIndex) {
        var tokenEndOffset = this._source.getEndOffset(this._firstTokenIndex + tokenIndex);
        return Math.min(this._endOffset, tokenEndOffset) - this._startOffset + this._deltaOffset;
    };
    SlicedLineTokens.prototype.getClassName = function (tokenIndex) {
        return this._source.getClassName(this._firstTokenIndex + tokenIndex);
    };
    SlicedLineTokens.prototype.getInlineStyle = function (tokenIndex, colorMap) {
        return this._source.getInlineStyle(this._firstTokenIndex + tokenIndex, colorMap);
    };
    SlicedLineTokens.prototype.findTokenIndexAtOffset = function (offset) {
        return this._source.findTokenIndexAtOffset(offset + this._startOffset - this._deltaOffset) - this._firstTokenIndex;
    };
    return SlicedLineTokens;
}());



/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Uint8Matrix; });
/* harmony export (immutable) */ __webpack_exports__["d"] = toUint8;
/* harmony export (immutable) */ __webpack_exports__["b"] = toUint32;
/* harmony export (immutable) */ __webpack_exports__["c"] = toUint32Array;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var Uint8Matrix = /** @class */ (function () {
    function Uint8Matrix(rows, cols, defaultValue) {
        var data = new Uint8Array(rows * cols);
        for (var i = 0, len = rows * cols; i < len; i++) {
            data[i] = defaultValue;
        }
        this._data = data;
        this.rows = rows;
        this.cols = cols;
    }
    Uint8Matrix.prototype.get = function (row, col) {
        return this._data[row * this.cols + col];
    };
    Uint8Matrix.prototype.set = function (row, col, value) {
        this._data[row * this.cols + col] = value;
    };
    return Uint8Matrix;
}());

function toUint8(v) {
    if (v < 0) {
        return 0;
    }
    if (v > 255 /* MAX_UINT_8 */) {
        return 255 /* MAX_UINT_8 */;
    }
    return v | 0;
}
function toUint32(v) {
    if (v < 0) {
        return 0;
    }
    if (v > 4294967295 /* MAX_UINT_32 */) {
        return 4294967295 /* MAX_UINT_32 */;
    }
    return v | 0;
}
function toUint32Array(arr) {
    var len = arr.length;
    var r = new Uint32Array(len);
    for (var i = 0; i < len; i++) {
        r[i] = toUint32(arr[i]);
    }
    return r;
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IProgressService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IProgressService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('progressService');


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorDetector", function() { return ColorDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_hash_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__color_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_configuration_common_configuration_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_errors_js__ = __webpack_require__(6);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};












var MAX_DECORATORS = 500;
var ColorDetector = /** @class */ (function () {
    function ColorDetector(_editor, _codeEditorService, _configurationService) {
        var _this = this;
        this._editor = _editor;
        this._codeEditorService = _codeEditorService;
        this._configurationService = _configurationService;
        this._globalToDispose = [];
        this._localToDispose = [];
        this._decorationsIds = [];
        this._colorDatas = new Map();
        this._colorDecoratorIds = [];
        this._decorationsTypes = {};
        this._globalToDispose.push(_editor.onDidChangeModel(function (e) {
            _this._isEnabled = _this.isEnabled();
            _this.onModelChanged();
        }));
        this._globalToDispose.push(_editor.onDidChangeModelLanguage(function (e) { return _this.onModelChanged(); }));
        this._globalToDispose.push(__WEBPACK_IMPORTED_MODULE_5__common_modes_js__["d" /* ColorProviderRegistry */].onDidChange(function (e) { return _this.onModelChanged(); }));
        this._globalToDispose.push(_editor.onDidChangeConfiguration(function (e) {
            var prevIsEnabled = _this._isEnabled;
            _this._isEnabled = _this.isEnabled();
            if (prevIsEnabled !== _this._isEnabled) {
                if (_this._isEnabled) {
                    _this.onModelChanged();
                }
                else {
                    _this.removeAllDecorations();
                }
            }
        }));
        this._timeoutTimer = null;
        this._computePromise = null;
        this._isEnabled = this.isEnabled();
        this.onModelChanged();
    }
    ColorDetector.prototype.isEnabled = function () {
        var model = this._editor.getModel();
        if (!model) {
            return false;
        }
        var languageId = model.getLanguageIdentifier();
        // handle deprecated settings. [languageId].colorDecorators.enable
        var deprecatedConfig = this._configurationService.getValue(languageId.language);
        if (deprecatedConfig) {
            var colorDecorators = deprecatedConfig['colorDecorators']; // deprecatedConfig.valueOf('.colorDecorators.enable');
            if (colorDecorators && colorDecorators['enable'] !== undefined && !colorDecorators['enable']) {
                return colorDecorators['enable'];
            }
        }
        return this._editor.getConfiguration().contribInfo.colorDecorators;
    };
    ColorDetector.prototype.getId = function () {
        return ColorDetector.ID;
    };
    ColorDetector.get = function (editor) {
        return editor.getContribution(this.ID);
    };
    ColorDetector.prototype.dispose = function () {
        this.stop();
        this.removeAllDecorations();
        this._globalToDispose = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._globalToDispose);
    };
    ColorDetector.prototype.onModelChanged = function () {
        var _this = this;
        this.stop();
        if (!this._isEnabled) {
            return;
        }
        var model = this._editor.getModel();
        // if (!model) {
        // 	return;
        // }
        if (!__WEBPACK_IMPORTED_MODULE_5__common_modes_js__["d" /* ColorProviderRegistry */].has(model)) {
            return;
        }
        this._localToDispose.push(this._editor.onDidChangeModelContent(function (e) {
            if (!_this._timeoutTimer) {
                _this._timeoutTimer = new __WEBPACK_IMPORTED_MODULE_10__base_common_async_js__["f" /* TimeoutTimer */]();
                _this._timeoutTimer.cancelAndSet(function () {
                    _this._timeoutTimer = null;
                    _this.beginCompute();
                }, ColorDetector.RECOMPUTE_TIME);
            }
        }));
        this.beginCompute();
    };
    ColorDetector.prototype.beginCompute = function () {
        var _this = this;
        this._computePromise = Object(__WEBPACK_IMPORTED_MODULE_10__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return Object(__WEBPACK_IMPORTED_MODULE_7__color_js__["b" /* getColors */])(_this._editor.getModel(), token); });
        this._computePromise.then(function (colorInfos) {
            _this.updateDecorations(colorInfos);
            _this.updateColorDecorators(colorInfos);
            _this._computePromise = null;
        }, __WEBPACK_IMPORTED_MODULE_11__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    ColorDetector.prototype.stop = function () {
        if (this._timeoutTimer) {
            this._timeoutTimer.cancel();
            this._timeoutTimer = null;
        }
        if (this._computePromise) {
            this._computePromise.cancel();
            this._computePromise = null;
        }
        this._localToDispose = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._localToDispose);
    };
    ColorDetector.prototype.updateDecorations = function (colorDatas) {
        var _this = this;
        var decorations = colorDatas.map(function (c) { return ({
            range: {
                startLineNumber: c.colorInfo.range.startLineNumber,
                startColumn: c.colorInfo.range.startColumn,
                endLineNumber: c.colorInfo.range.endLineNumber,
                endColumn: c.colorInfo.range.endColumn
            },
            options: __WEBPACK_IMPORTED_MODULE_9__common_model_textModel_js__["a" /* ModelDecorationOptions */].EMPTY
        }); });
        this._decorationsIds = this._editor.deltaDecorations(this._decorationsIds, decorations);
        this._colorDatas = new Map();
        this._decorationsIds.forEach(function (id, i) { return _this._colorDatas.set(id, colorDatas[i]); });
    };
    ColorDetector.prototype.updateColorDecorators = function (colorData) {
        var decorations = [];
        var newDecorationsTypes = {};
        for (var i = 0; i < colorData.length && decorations.length < MAX_DECORATORS; i++) {
            var _a = colorData[i].colorInfo.color, red = _a.red, green = _a.green, blue = _a.blue, alpha = _a.alpha;
            var rgba = new __WEBPACK_IMPORTED_MODULE_0__base_common_color_js__["c" /* RGBA */](Math.round(red * 255), Math.round(green * 255), Math.round(blue * 255), alpha);
            var subKey = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_hash_js__["a" /* hash */])(rgba).toString(16);
            var color = "rgba(" + rgba.r + ", " + rgba.g + ", " + rgba.b + ", " + rgba.a + ")";
            var key = 'colorBox-' + subKey;
            if (!this._decorationsTypes[key] && !newDecorationsTypes[key]) {
                this._codeEditorService.registerDecorationType(key, {
                    before: {
                        contentText: ' ',
                        border: 'solid 0.1em #000',
                        margin: '0.1em 0.2em 0 0.2em',
                        width: '0.8em',
                        height: '0.8em',
                        backgroundColor: color
                    },
                    dark: {
                        before: {
                            border: 'solid 0.1em #eee'
                        }
                    }
                });
            }
            newDecorationsTypes[key] = true;
            decorations.push({
                range: {
                    startLineNumber: colorData[i].colorInfo.range.startLineNumber,
                    startColumn: colorData[i].colorInfo.range.startColumn,
                    endLineNumber: colorData[i].colorInfo.range.endLineNumber,
                    endColumn: colorData[i].colorInfo.range.endColumn
                },
                options: this._codeEditorService.resolveDecorationOptions(key, true)
            });
        }
        for (var subType in this._decorationsTypes) {
            if (!newDecorationsTypes[subType]) {
                this._codeEditorService.removeDecorationType(subType);
            }
        }
        this._colorDecoratorIds = this._editor.deltaDecorations(this._colorDecoratorIds, decorations);
    };
    ColorDetector.prototype.removeAllDecorations = function () {
        this._decorationsIds = this._editor.deltaDecorations(this._decorationsIds, []);
        this._colorDecoratorIds = this._editor.deltaDecorations(this._colorDecoratorIds, []);
        for (var subType in this._decorationsTypes) {
            this._codeEditorService.removeDecorationType(subType);
        }
    };
    ColorDetector.prototype.getColorData = function (position) {
        var _this = this;
        var decorations = this._editor.getModel()
            .getDecorationsInRange(__WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].fromPositions(position, position))
            .filter(function (d) { return _this._colorDatas.has(d.id); });
        if (decorations.length === 0) {
            return null;
        }
        return this._colorDatas.get(decorations[0].id);
    };
    ColorDetector.ID = 'editor.contrib.colorDetector';
    ColorDetector.RECOMPUTE_TIME = 1000; // ms
    ColorDetector = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_6__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_8__platform_configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], ColorDetector);
    return ColorDetector;
}());

Object(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["h" /* registerEditorContribution */])(ColorDetector);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getSelectionSearchString"] = getSelectionSearchString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommonFindController", function() { return CommonFindController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FindController", function() { return FindController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StartFindAction", function() { return StartFindAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StartFindWithSelectionAction", function() { return StartFindWithSelectionAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatchFindAction", function() { return MatchFindAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NextMatchFindAction", function() { return NextMatchFindAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousMatchFindAction", function() { return PreviousMatchFindAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectionMatchFindAction", function() { return SelectionMatchFindAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NextSelectionMatchFindAction", function() { return NextSelectionMatchFindAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousSelectionMatchFindAction", function() { return PreviousSelectionMatchFindAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StartFindReplaceAction", function() { return StartFindReplaceAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__findModel_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findState_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_clipboard_common_clipboardService_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_contextview_browser_contextView_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__findWidget_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__findOptionsWidget_js__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__platform_actions_common_actions_js__ = __webpack_require__(41);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


















function getSelectionSearchString(editor) {
    var selection = editor.getSelection();
    // if selection spans multiple lines, default search string to empty
    if (selection.startLineNumber === selection.endLineNumber) {
        if (selection.isEmpty()) {
            var wordAtPosition = editor.getModel().getWordAtPosition(selection.getStartPosition());
            if (wordAtPosition) {
                return wordAtPosition.word;
            }
        }
        else {
            return editor.getModel().getValueInRange(selection);
        }
    }
    return null;
}
var CommonFindController = /** @class */ (function (_super) {
    __extends(CommonFindController, _super);
    function CommonFindController(editor, contextKeyService, storageService, clipboardService) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        _this._findWidgetVisible = __WEBPACK_IMPORTED_MODULE_5__findModel_js__["b" /* CONTEXT_FIND_WIDGET_VISIBLE */].bindTo(contextKeyService);
        _this._storageService = storageService;
        _this._clipboardService = clipboardService;
        _this._updateHistoryDelayer = new __WEBPACK_IMPORTED_MODULE_7__base_common_async_js__["a" /* Delayer */](500);
        _this._state = _this._register(new __WEBPACK_IMPORTED_MODULE_6__findState_js__["a" /* FindReplaceState */]());
        _this.loadQueryState();
        _this._register(_this._state.onFindReplaceStateChange(function (e) { return _this._onStateChanged(e); }));
        _this._model = null;
        _this._register(_this._editor.onDidChangeModel(function () {
            var shouldRestartFind = (_this._editor.getModel() && _this._state.isRevealed);
            _this.disposeModel();
            _this._state.change({
                searchScope: null,
                matchCase: _this._storageService.getBoolean('editor.matchCase', __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE, false),
                wholeWord: _this._storageService.getBoolean('editor.wholeWord', __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE, false),
                isRegex: _this._storageService.getBoolean('editor.isRegex', __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE, false)
            }, false);
            if (shouldRestartFind) {
                _this._start({
                    forceRevealReplace: false,
                    seedSearchStringFromSelection: false && _this._editor.getConfiguration().contribInfo.find.seedSearchStringFromSelection,
                    seedSearchStringFromGlobalClipboard: false,
                    shouldFocus: 0 /* NoFocusChange */,
                    shouldAnimate: false,
                });
            }
        }));
        return _this;
    }
    CommonFindController.get = function (editor) {
        return editor.getContribution(CommonFindController.ID);
    };
    CommonFindController.prototype.dispose = function () {
        this.disposeModel();
        _super.prototype.dispose.call(this);
    };
    CommonFindController.prototype.disposeModel = function () {
        if (this._model) {
            this._model.dispose();
            this._model = null;
        }
    };
    CommonFindController.prototype.getId = function () {
        return CommonFindController.ID;
    };
    CommonFindController.prototype._onStateChanged = function (e) {
        this.saveQueryState(e);
        if (e.isRevealed) {
            if (this._state.isRevealed) {
                this._findWidgetVisible.set(true);
            }
            else {
                this._findWidgetVisible.reset();
                this.disposeModel();
            }
        }
        if (e.searchString) {
            this.setGlobalBufferTerm(this._state.searchString);
        }
    };
    CommonFindController.prototype.saveQueryState = function (e) {
        if (e.isRegex) {
            this._storageService.store('editor.isRegex', this._state.actualIsRegex, __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE);
        }
        if (e.wholeWord) {
            this._storageService.store('editor.wholeWord', this._state.actualWholeWord, __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE);
        }
        if (e.matchCase) {
            this._storageService.store('editor.matchCase', this._state.actualMatchCase, __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE);
        }
    };
    CommonFindController.prototype.loadQueryState = function () {
        this._state.change({
            matchCase: this._storageService.getBoolean('editor.matchCase', __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE, this._state.matchCase),
            wholeWord: this._storageService.getBoolean('editor.wholeWord', __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE, this._state.wholeWord),
            isRegex: this._storageService.getBoolean('editor.isRegex', __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE, this._state.isRegex)
        }, false);
    };
    CommonFindController.prototype.getState = function () {
        return this._state;
    };
    CommonFindController.prototype.closeFindWidget = function () {
        this._state.change({
            isRevealed: false,
            searchScope: null
        }, false);
        this._editor.focus();
    };
    CommonFindController.prototype.toggleCaseSensitive = function () {
        this._state.change({ matchCase: !this._state.matchCase }, false);
    };
    CommonFindController.prototype.toggleWholeWords = function () {
        this._state.change({ wholeWord: !this._state.wholeWord }, false);
    };
    CommonFindController.prototype.toggleRegex = function () {
        this._state.change({ isRegex: !this._state.isRegex }, false);
    };
    CommonFindController.prototype.toggleSearchScope = function () {
        if (this._state.searchScope) {
            this._state.change({ searchScope: null }, true);
        }
        else {
            var selection = this._editor.getSelection();
            if (selection.endColumn === 1 && selection.endLineNumber > selection.startLineNumber) {
                selection = selection.setEndPosition(selection.endLineNumber - 1, 1);
            }
            if (!selection.isEmpty()) {
                this._state.change({ searchScope: selection }, true);
            }
        }
    };
    CommonFindController.prototype.setSearchString = function (searchString) {
        if (this._state.isRegex) {
            searchString = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["escapeRegExpCharacters"](searchString);
        }
        this._state.change({ searchString: searchString }, false);
    };
    CommonFindController.prototype.highlightFindOptions = function () {
        // overwritten in subclass
    };
    CommonFindController.prototype._start = function (opts) {
        this.disposeModel();
        if (!this._editor.getModel()) {
            // cannot do anything with an editor that doesn't have a model...
            return;
        }
        var stateChanges = {
            isRevealed: true
        };
        if (opts.seedSearchStringFromSelection) {
            var selectionSearchString = getSelectionSearchString(this._editor);
            if (selectionSearchString) {
                if (this._state.isRegex) {
                    stateChanges.searchString = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["escapeRegExpCharacters"](selectionSearchString);
                }
                else {
                    stateChanges.searchString = selectionSearchString;
                }
            }
        }
        if (!stateChanges.searchString && opts.seedSearchStringFromGlobalClipboard) {
            var selectionSearchString = this.getGlobalBufferTerm();
            if (selectionSearchString) {
                stateChanges.searchString = selectionSearchString;
            }
        }
        // Overwrite isReplaceRevealed
        if (opts.forceRevealReplace) {
            stateChanges.isReplaceRevealed = true;
        }
        else if (!this._findWidgetVisible.get()) {
            stateChanges.isReplaceRevealed = false;
        }
        this._state.change(stateChanges, false);
        if (!this._model) {
            this._model = new __WEBPACK_IMPORTED_MODULE_5__findModel_js__["e" /* FindModelBoundToEditorModel */](this._editor, this._state);
        }
    };
    CommonFindController.prototype.start = function (opts) {
        this._start(opts);
    };
    CommonFindController.prototype.moveToNextMatch = function () {
        if (this._model) {
            this._model.moveToNextMatch();
            return true;
        }
        return false;
    };
    CommonFindController.prototype.moveToPrevMatch = function () {
        if (this._model) {
            this._model.moveToPrevMatch();
            return true;
        }
        return false;
    };
    CommonFindController.prototype.replace = function () {
        if (this._model) {
            this._model.replace();
            return true;
        }
        return false;
    };
    CommonFindController.prototype.replaceAll = function () {
        if (this._model) {
            this._model.replaceAll();
            return true;
        }
        return false;
    };
    CommonFindController.prototype.selectAllMatches = function () {
        if (this._model) {
            this._model.selectAllMatches();
            this._editor.focus();
            return true;
        }
        return false;
    };
    CommonFindController.prototype.getGlobalBufferTerm = function () {
        if (this._editor.getConfiguration().contribInfo.find.globalFindClipboard
            && this._clipboardService
            && !this._editor.getModel().isTooLargeForSyncing()) {
            return this._clipboardService.readFindText();
        }
        return '';
    };
    CommonFindController.prototype.setGlobalBufferTerm = function (text) {
        if (this._editor.getConfiguration().contribInfo.find.globalFindClipboard
            && this._clipboardService
            && !this._editor.getModel().isTooLargeForSyncing()) {
            this._clipboardService.writeFindText(text);
        }
    };
    CommonFindController.ID = 'editor.contrib.findController';
    CommonFindController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["a" /* IStorageService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_10__platform_clipboard_common_clipboardService_js__["a" /* IClipboardService */])
    ], CommonFindController);
    return CommonFindController;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));

var FindController = /** @class */ (function (_super) {
    __extends(FindController, _super);
    function FindController(editor, _contextViewService, _contextKeyService, _keybindingService, _themeService, storageService, clipboardService) {
        var _this = _super.call(this, editor, _contextKeyService, storageService, clipboardService) || this;
        _this._contextViewService = _contextViewService;
        _this._contextKeyService = _contextKeyService;
        _this._keybindingService = _keybindingService;
        _this._themeService = _themeService;
        return _this;
    }
    FindController.prototype._start = function (opts) {
        if (!this._widget) {
            this._createFindWidget();
        }
        _super.prototype._start.call(this, opts);
        if (opts.shouldFocus === 2 /* FocusReplaceInput */) {
            this._widget.focusReplaceInput();
        }
        else if (opts.shouldFocus === 1 /* FocusFindInput */) {
            this._widget.focusFindInput();
        }
    };
    FindController.prototype.highlightFindOptions = function () {
        if (!this._widget) {
            this._createFindWidget();
        }
        if (this._state.isRevealed) {
            this._widget.highlightFindOptions();
        }
        else {
            this._findOptionsWidget.highlightFindOptions();
        }
    };
    FindController.prototype._createFindWidget = function () {
        this._widget = this._register(new __WEBPACK_IMPORTED_MODULE_13__findWidget_js__["a" /* FindWidget */](this._editor, this, this._state, this._contextViewService, this._keybindingService, this._contextKeyService, this._themeService));
        this._findOptionsWidget = this._register(new __WEBPACK_IMPORTED_MODULE_14__findOptionsWidget_js__["a" /* FindOptionsWidget */](this._editor, this._state, this._keybindingService, this._themeService));
    };
    FindController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_11__platform_contextview_browser_contextView_js__["b" /* IContextViewService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_12__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_15__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_9__platform_storage_common_storage_js__["a" /* IStorageService */]),
        __param(6, Object(__WEBPACK_IMPORTED_MODULE_16__platform_instantiation_common_instantiation_js__["d" /* optional */])(__WEBPACK_IMPORTED_MODULE_10__platform_clipboard_common_clipboardService_js__["a" /* IClipboardService */]))
    ], FindController);
    return FindController;
}(CommonFindController));

var StartFindAction = /** @class */ (function (_super) {
    __extends(StartFindAction, _super);
    function StartFindAction() {
        return _super.call(this, {
            id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].StartFindAction,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('startFindAction', "Find"),
            alias: 'Find',
            precondition: null,
            kbOpts: {
                kbExpr: null,
                primary: 2048 /* CtrlCmd */ | 36 /* KEY_F */,
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_17__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
                group: '3_find',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miFind', comment: ['&& denotes a mnemonic'] }, "&&Find"),
                order: 1
            }
        }) || this;
    }
    StartFindAction.prototype.run = function (accessor, editor) {
        var controller = CommonFindController.get(editor);
        if (controller) {
            controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: editor.getConfiguration().contribInfo.find.seedSearchStringFromSelection,
                seedSearchStringFromGlobalClipboard: editor.getConfiguration().contribInfo.find.globalFindClipboard,
                shouldFocus: 1 /* FocusFindInput */,
                shouldAnimate: true
            });
        }
    };
    return StartFindAction;
}(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["b" /* EditorAction */]));

var StartFindWithSelectionAction = /** @class */ (function (_super) {
    __extends(StartFindWithSelectionAction, _super);
    function StartFindWithSelectionAction() {
        return _super.call(this, {
            id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].StartFindWithSelection,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('startFindWithSelectionAction', "Find With Selection"),
            alias: 'Find With Selection',
            precondition: null,
            kbOpts: {
                kbExpr: null,
                primary: null,
                mac: {
                    primary: 2048 /* CtrlCmd */ | 35 /* KEY_E */,
                },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    StartFindWithSelectionAction.prototype.run = function (accessor, editor) {
        var controller = CommonFindController.get(editor);
        if (controller) {
            controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: true,
                seedSearchStringFromGlobalClipboard: false,
                shouldFocus: 1 /* FocusFindInput */,
                shouldAnimate: true
            });
            controller.setGlobalBufferTerm(controller.getState().searchString);
        }
    };
    return StartFindWithSelectionAction;
}(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["b" /* EditorAction */]));

var MatchFindAction = /** @class */ (function (_super) {
    __extends(MatchFindAction, _super);
    function MatchFindAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatchFindAction.prototype.run = function (accessor, editor) {
        var controller = CommonFindController.get(editor);
        if (controller && !this._run(controller)) {
            controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: (controller.getState().searchString.length === 0) && editor.getConfiguration().contribInfo.find.seedSearchStringFromSelection,
                seedSearchStringFromGlobalClipboard: true,
                shouldFocus: 0 /* NoFocusChange */,
                shouldAnimate: true
            });
            this._run(controller);
        }
    };
    return MatchFindAction;
}(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["b" /* EditorAction */]));

var NextMatchFindAction = /** @class */ (function (_super) {
    __extends(NextMatchFindAction, _super);
    function NextMatchFindAction() {
        return _super.call(this, {
            id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].NextMatchFindAction,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('findNextMatchAction', "Find Next"),
            alias: 'Find Next',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 61 /* F3 */,
                mac: { primary: 2048 /* CtrlCmd */ | 37 /* KEY_G */, secondary: [61 /* F3 */] },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    NextMatchFindAction.prototype._run = function (controller) {
        return controller.moveToNextMatch();
    };
    return NextMatchFindAction;
}(MatchFindAction));

var PreviousMatchFindAction = /** @class */ (function (_super) {
    __extends(PreviousMatchFindAction, _super);
    function PreviousMatchFindAction() {
        return _super.call(this, {
            id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].PreviousMatchFindAction,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('findPreviousMatchAction', "Find Previous"),
            alias: 'Find Previous',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 1024 /* Shift */ | 61 /* F3 */,
                mac: { primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 37 /* KEY_G */, secondary: [1024 /* Shift */ | 61 /* F3 */] },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    PreviousMatchFindAction.prototype._run = function (controller) {
        return controller.moveToPrevMatch();
    };
    return PreviousMatchFindAction;
}(MatchFindAction));

var SelectionMatchFindAction = /** @class */ (function (_super) {
    __extends(SelectionMatchFindAction, _super);
    function SelectionMatchFindAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectionMatchFindAction.prototype.run = function (accessor, editor) {
        var controller = CommonFindController.get(editor);
        if (!controller) {
            return;
        }
        var selectionSearchString = getSelectionSearchString(editor);
        if (selectionSearchString) {
            controller.setSearchString(selectionSearchString);
        }
        if (!this._run(controller)) {
            controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: editor.getConfiguration().contribInfo.find.seedSearchStringFromSelection,
                seedSearchStringFromGlobalClipboard: false,
                shouldFocus: 0 /* NoFocusChange */,
                shouldAnimate: true
            });
            this._run(controller);
        }
    };
    return SelectionMatchFindAction;
}(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["b" /* EditorAction */]));

var NextSelectionMatchFindAction = /** @class */ (function (_super) {
    __extends(NextSelectionMatchFindAction, _super);
    function NextSelectionMatchFindAction() {
        return _super.call(this, {
            id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].NextSelectionMatchFindAction,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('nextSelectionMatchFindAction', "Find Next Selection"),
            alias: 'Find Next Selection',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 2048 /* CtrlCmd */ | 61 /* F3 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    NextSelectionMatchFindAction.prototype._run = function (controller) {
        return controller.moveToNextMatch();
    };
    return NextSelectionMatchFindAction;
}(SelectionMatchFindAction));

var PreviousSelectionMatchFindAction = /** @class */ (function (_super) {
    __extends(PreviousSelectionMatchFindAction, _super);
    function PreviousSelectionMatchFindAction() {
        return _super.call(this, {
            id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].PreviousSelectionMatchFindAction,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('previousSelectionMatchFindAction', "Find Previous Selection"),
            alias: 'Find Previous Selection',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 61 /* F3 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    PreviousSelectionMatchFindAction.prototype._run = function (controller) {
        return controller.moveToPrevMatch();
    };
    return PreviousSelectionMatchFindAction;
}(SelectionMatchFindAction));

var StartFindReplaceAction = /** @class */ (function (_super) {
    __extends(StartFindReplaceAction, _super);
    function StartFindReplaceAction() {
        return _super.call(this, {
            id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].StartFindReplaceAction,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('startReplace', "Replace"),
            alias: 'Replace',
            precondition: null,
            kbOpts: {
                kbExpr: null,
                primary: 2048 /* CtrlCmd */ | 38 /* KEY_H */,
                mac: { primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 36 /* KEY_F */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_17__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
                group: '3_find',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miReplace', comment: ['&& denotes a mnemonic'] }, "&&Replace"),
                order: 2
            }
        }) || this;
    }
    StartFindReplaceAction.prototype.run = function (accessor, editor) {
        if (editor.getConfiguration().readOnly) {
            return;
        }
        var controller = CommonFindController.get(editor);
        var currentSelection = editor.getSelection();
        // we only seed search string from selection when the current selection is single line and not empty.
        var seedSearchStringFromSelection = !currentSelection.isEmpty() &&
            currentSelection.startLineNumber === currentSelection.endLineNumber && editor.getConfiguration().contribInfo.find.seedSearchStringFromSelection;
        var oldSearchString = controller.getState().searchString;
        // if the existing search string in find widget is empty and we don't seed search string from selection, it means the Find Input
        // is still empty, so we should focus the Find Input instead of Replace Input.
        var shouldFocus = (!!oldSearchString || seedSearchStringFromSelection) ?
            2 /* FocusReplaceInput */ : 1 /* FocusFindInput */;
        if (controller) {
            controller.start({
                forceRevealReplace: true,
                seedSearchStringFromSelection: seedSearchStringFromSelection,
                seedSearchStringFromGlobalClipboard: editor.getConfiguration().contribInfo.find.seedSearchStringFromSelection,
                shouldFocus: shouldFocus,
                shouldAnimate: true
            });
        }
    };
    return StartFindReplaceAction;
}(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["h" /* registerEditorContribution */])(FindController);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(StartFindAction);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(StartFindWithSelectionAction);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(NextMatchFindAction);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(PreviousMatchFindAction);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(NextSelectionMatchFindAction);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(PreviousSelectionMatchFindAction);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(StartFindReplaceAction);
var FindCommand = __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(CommonFindController.get);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].CloseFindWidgetCommand,
    precondition: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["b" /* CONTEXT_FIND_WIDGET_VISIBLE */],
    handler: function (x) { return x.closeFindWidget(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 9 /* Escape */,
        secondary: [1024 /* Shift */ | 9 /* Escape */]
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].ToggleCaseSensitiveCommand,
    precondition: null,
    handler: function (x) { return x.toggleCaseSensitive(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["g" /* ToggleCaseSensitiveKeybinding */].primary,
        mac: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["g" /* ToggleCaseSensitiveKeybinding */].mac,
        win: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["g" /* ToggleCaseSensitiveKeybinding */].win,
        linux: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["g" /* ToggleCaseSensitiveKeybinding */].linux
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].ToggleWholeWordCommand,
    precondition: null,
    handler: function (x) { return x.toggleWholeWords(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["j" /* ToggleWholeWordKeybinding */].primary,
        mac: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["j" /* ToggleWholeWordKeybinding */].mac,
        win: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["j" /* ToggleWholeWordKeybinding */].win,
        linux: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["j" /* ToggleWholeWordKeybinding */].linux
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].ToggleRegexCommand,
    precondition: null,
    handler: function (x) { return x.toggleRegex(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["h" /* ToggleRegexKeybinding */].primary,
        mac: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["h" /* ToggleRegexKeybinding */].mac,
        win: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["h" /* ToggleRegexKeybinding */].win,
        linux: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["h" /* ToggleRegexKeybinding */].linux
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].ToggleSearchScopeCommand,
    precondition: null,
    handler: function (x) { return x.toggleSearchScope(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["i" /* ToggleSearchScopeKeybinding */].primary,
        mac: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["i" /* ToggleSearchScopeKeybinding */].mac,
        win: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["i" /* ToggleSearchScopeKeybinding */].win,
        linux: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["i" /* ToggleSearchScopeKeybinding */].linux
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].ReplaceOneAction,
    precondition: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["b" /* CONTEXT_FIND_WIDGET_VISIBLE */],
    handler: function (x) { return x.replace(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 22 /* KEY_1 */
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].ReplaceAllAction,
    precondition: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["b" /* CONTEXT_FIND_WIDGET_VISIBLE */],
    handler: function (x) { return x.replaceAll(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 3 /* Enter */
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new FindCommand({
    id: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["d" /* FIND_IDS */].SelectAllMatchesAction,
    precondition: __WEBPACK_IMPORTED_MODULE_5__findModel_js__["b" /* CONTEXT_FIND_WIDGET_VISIBLE */],
    handler: function (x) { return x.selectAllMatches(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 5,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 512 /* Alt */ | 3 /* Enter */
    }
}));


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Orientation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SashState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Sash; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sash_css__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sash_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sash_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__touch_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_js__ = __webpack_require__(78);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/











var DEBUG = false;
var Orientation;
(function (Orientation) {
    Orientation[Orientation["VERTICAL"] = 0] = "VERTICAL";
    Orientation[Orientation["HORIZONTAL"] = 1] = "HORIZONTAL";
})(Orientation || (Orientation = {}));
var SashState;
(function (SashState) {
    SashState[SashState["Disabled"] = 0] = "Disabled";
    SashState[SashState["Minimum"] = 1] = "Minimum";
    SashState[SashState["Maximum"] = 2] = "Maximum";
    SashState[SashState["Enabled"] = 3] = "Enabled";
})(SashState || (SashState = {}));
var Sash = /** @class */ (function () {
    function Sash(container, layoutProvider, options) {
        if (options === void 0) { options = {}; }
        this.disposables = [];
        this._state = SashState.Enabled;
        this._onDidEnablementChange = new __WEBPACK_IMPORTED_MODULE_7__common_event_js__["a" /* Emitter */]();
        this.onDidEnablementChange = this._onDidEnablementChange.event;
        this._onDidStart = new __WEBPACK_IMPORTED_MODULE_7__common_event_js__["a" /* Emitter */]();
        this.onDidStart = this._onDidStart.event;
        this._onDidChange = new __WEBPACK_IMPORTED_MODULE_7__common_event_js__["a" /* Emitter */]();
        this.onDidChange = this._onDidChange.event;
        this._onDidReset = new __WEBPACK_IMPORTED_MODULE_7__common_event_js__["a" /* Emitter */]();
        this.onDidReset = this._onDidReset.event;
        this._onDidEnd = new __WEBPACK_IMPORTED_MODULE_7__common_event_js__["a" /* Emitter */]();
        this.onDidEnd = this._onDidEnd.event;
        this.linkedSash = undefined;
        this.orthogonalStartSashDisposables = [];
        this.orthogonalEndSashDisposables = [];
        this.el = Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["k" /* append */])(container, Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["a" /* $ */])('.monaco-sash'));
        if (__WEBPACK_IMPORTED_MODULE_3__common_platform_js__["d" /* isMacintosh */]) {
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["f" /* addClass */])(this.el, 'mac');
        }
        Object(__WEBPACK_IMPORTED_MODULE_9__event_js__["a" /* domEvent */])(this.el, 'mousedown')(this.onMouseDown, this, this.disposables);
        Object(__WEBPACK_IMPORTED_MODULE_9__event_js__["a" /* domEvent */])(this.el, 'dblclick')(this.onMouseDoubleClick, this, this.disposables);
        __WEBPACK_IMPORTED_MODULE_5__touch_js__["b" /* Gesture */].addTarget(this.el);
        Object(__WEBPACK_IMPORTED_MODULE_9__event_js__["a" /* domEvent */])(this.el, __WEBPACK_IMPORTED_MODULE_5__touch_js__["a" /* EventType */].Start)(this.onTouchStart, this, this.disposables);
        if (__WEBPACK_IMPORTED_MODULE_2__browser_js__["l" /* isIPad */]) {
            // see also http://ux.stackexchange.com/questions/39023/what-is-the-optimum-button-size-of-touch-screen-applications
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["f" /* addClass */])(this.el, 'touch');
        }
        this.setOrientation(options.orientation || Orientation.VERTICAL);
        this.hidden = false;
        this.layoutProvider = layoutProvider;
        this.orthogonalStartSash = options.orthogonalStartSash;
        this.orthogonalEndSash = options.orthogonalEndSash;
        Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["N" /* toggleClass */])(this.el, 'debug', DEBUG);
    }
    Object.defineProperty(Sash.prototype, "state", {
        get: function () { return this._state; },
        set: function (state) {
            if (this._state === state) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["N" /* toggleClass */])(this.el, 'disabled', state === SashState.Disabled);
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["N" /* toggleClass */])(this.el, 'minimum', state === SashState.Minimum);
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["N" /* toggleClass */])(this.el, 'maximum', state === SashState.Maximum);
            this._state = state;
            this._onDidEnablementChange.fire(state);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sash.prototype, "orthogonalStartSash", {
        get: function () { return this._orthogonalStartSash; },
        set: function (sash) {
            this.orthogonalStartSashDisposables = Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(this.orthogonalStartSashDisposables);
            if (sash) {
                sash.onDidEnablementChange(this.onOrthogonalStartSashEnablementChange, this, this.orthogonalStartSashDisposables);
                this.onOrthogonalStartSashEnablementChange(sash.state);
            }
            else {
                this.onOrthogonalStartSashEnablementChange(SashState.Disabled);
            }
            this._orthogonalStartSash = sash;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sash.prototype, "orthogonalEndSash", {
        get: function () { return this._orthogonalEndSash; },
        set: function (sash) {
            this.orthogonalEndSashDisposables = Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(this.orthogonalEndSashDisposables);
            if (sash) {
                sash.onDidEnablementChange(this.onOrthogonalEndSashEnablementChange, this, this.orthogonalEndSashDisposables);
                this.onOrthogonalEndSashEnablementChange(sash.state);
            }
            else {
                this.onOrthogonalEndSashEnablementChange(SashState.Disabled);
            }
            this._orthogonalEndSash = sash;
        },
        enumerable: true,
        configurable: true
    });
    Sash.prototype.setOrientation = function (orientation) {
        this.orientation = orientation;
        if (this.orientation === Orientation.HORIZONTAL) {
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["f" /* addClass */])(this.el, 'horizontal');
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["G" /* removeClass */])(this.el, 'vertical');
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["G" /* removeClass */])(this.el, 'horizontal');
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["f" /* addClass */])(this.el, 'vertical');
        }
        if (this.layoutProvider) {
            this.layout();
        }
    };
    Sash.prototype.onMouseDown = function (e) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_8__dom_js__["c" /* EventHelper */].stop(e, false);
        var isMultisashResize = false;
        if (this.linkedSash && !e.__linkedSashEvent) {
            e.__linkedSashEvent = true;
            this.linkedSash.onMouseDown(e);
        }
        if (!e.__orthogonalSashEvent) {
            var orthogonalSash = void 0;
            if (this.orientation === Orientation.VERTICAL) {
                if (e.offsetY <= 4) {
                    orthogonalSash = this.orthogonalStartSash;
                }
                else if (e.offsetY >= this.el.clientHeight - 4) {
                    orthogonalSash = this.orthogonalEndSash;
                }
            }
            else {
                if (e.offsetX <= 4) {
                    orthogonalSash = this.orthogonalStartSash;
                }
                else if (e.offsetX >= this.el.clientWidth - 4) {
                    orthogonalSash = this.orthogonalEndSash;
                }
            }
            if (orthogonalSash) {
                isMultisashResize = true;
                e.__orthogonalSashEvent = true;
                orthogonalSash.onMouseDown(e);
            }
        }
        if (!this.state) {
            return;
        }
        var iframes = Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["v" /* getElementsByTagName */])('iframe');
        for (var _i = 0, iframes_1 = iframes; _i < iframes_1.length; _i++) {
            var iframe = iframes_1[_i];
            iframe.style.pointerEvents = 'none'; // disable mouse events on iframes as long as we drag the sash
        }
        var mouseDownEvent = new __WEBPACK_IMPORTED_MODULE_6__mouseEvent_js__["b" /* StandardMouseEvent */](e);
        var startX = mouseDownEvent.posx;
        var startY = mouseDownEvent.posy;
        var altKey = mouseDownEvent.altKey;
        var startEvent = { startX: startX, currentX: startX, startY: startY, currentY: startY, altKey: altKey };
        Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["f" /* addClass */])(this.el, 'active');
        this._onDidStart.fire(startEvent);
        // fix https://github.com/Microsoft/vscode/issues/21675
        var style = Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["o" /* createStyleSheet */])(this.el);
        var updateStyle = function () {
            var cursor = '';
            if (isMultisashResize) {
                cursor = 'all-scroll';
            }
            else if (_this.orientation === Orientation.HORIZONTAL) {
                if (_this.state === SashState.Minimum) {
                    cursor = 's-resize';
                }
                else if (_this.state === SashState.Maximum) {
                    cursor = 'n-resize';
                }
                else {
                    cursor = __WEBPACK_IMPORTED_MODULE_3__common_platform_js__["d" /* isMacintosh */] ? 'row-resize' : 'ns-resize';
                }
            }
            else {
                if (_this.state === SashState.Minimum) {
                    cursor = 'e-resize';
                }
                else if (_this.state === SashState.Maximum) {
                    cursor = 'w-resize';
                }
                else {
                    cursor = __WEBPACK_IMPORTED_MODULE_3__common_platform_js__["d" /* isMacintosh */] ? 'col-resize' : 'ew-resize';
                }
            }
            style.innerHTML = "* { cursor: " + cursor + " !important; }";
        };
        var disposables = [];
        updateStyle();
        if (!isMultisashResize) {
            this.onDidEnablementChange(updateStyle, null, disposables);
        }
        var onMouseMove = function (e) {
            __WEBPACK_IMPORTED_MODULE_8__dom_js__["c" /* EventHelper */].stop(e, false);
            var mouseMoveEvent = new __WEBPACK_IMPORTED_MODULE_6__mouseEvent_js__["b" /* StandardMouseEvent */](e);
            var event = { startX: startX, currentX: mouseMoveEvent.posx, startY: startY, currentY: mouseMoveEvent.posy, altKey: altKey };
            _this._onDidChange.fire(event);
        };
        var onMouseUp = function (e) {
            __WEBPACK_IMPORTED_MODULE_8__dom_js__["c" /* EventHelper */].stop(e, false);
            _this.el.removeChild(style);
            Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["G" /* removeClass */])(_this.el, 'active');
            _this._onDidEnd.fire();
            Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(disposables);
            var iframes = Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["v" /* getElementsByTagName */])('iframe');
            for (var _i = 0, iframes_2 = iframes; _i < iframes_2.length; _i++) {
                var iframe = iframes_2[_i];
                iframe.style.pointerEvents = 'auto';
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_9__event_js__["a" /* domEvent */])(window, 'mousemove')(onMouseMove, null, disposables);
        Object(__WEBPACK_IMPORTED_MODULE_9__event_js__["a" /* domEvent */])(window, 'mouseup')(onMouseUp, null, disposables);
    };
    Sash.prototype.onMouseDoubleClick = function (event) {
        this._onDidReset.fire();
    };
    Sash.prototype.onTouchStart = function (event) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_8__dom_js__["c" /* EventHelper */].stop(event);
        var listeners = [];
        var startX = event.pageX;
        var startY = event.pageY;
        var altKey = event.altKey;
        this._onDidStart.fire({
            startX: startX,
            currentX: startX,
            startY: startY,
            currentY: startY,
            altKey: altKey
        });
        listeners.push(Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["g" /* addDisposableListener */])(this.el, __WEBPACK_IMPORTED_MODULE_5__touch_js__["a" /* EventType */].Change, function (event) {
            if (__WEBPACK_IMPORTED_MODULE_4__common_types_js__["f" /* isNumber */](event.pageX) && __WEBPACK_IMPORTED_MODULE_4__common_types_js__["f" /* isNumber */](event.pageY)) {
                _this._onDidChange.fire({
                    startX: startX,
                    currentX: event.pageX,
                    startY: startY,
                    currentY: event.pageY,
                    altKey: altKey
                });
            }
        }));
        listeners.push(Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["g" /* addDisposableListener */])(this.el, __WEBPACK_IMPORTED_MODULE_5__touch_js__["a" /* EventType */].End, function (event) {
            _this._onDidEnd.fire();
            Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(listeners);
        }));
    };
    Sash.prototype.layout = function () {
        var size = __WEBPACK_IMPORTED_MODULE_2__browser_js__["l" /* isIPad */] ? 20 : 4;
        if (this.orientation === Orientation.VERTICAL) {
            var verticalProvider = this.layoutProvider;
            this.el.style.left = verticalProvider.getVerticalSashLeft(this) - (size / 2) + 'px';
            if (verticalProvider.getVerticalSashTop) {
                this.el.style.top = verticalProvider.getVerticalSashTop(this) + 'px';
            }
            if (verticalProvider.getVerticalSashHeight) {
                this.el.style.height = verticalProvider.getVerticalSashHeight(this) + 'px';
            }
        }
        else {
            var horizontalProvider = this.layoutProvider;
            this.el.style.top = horizontalProvider.getHorizontalSashTop(this) - (size / 2) + 'px';
            if (horizontalProvider.getHorizontalSashLeft) {
                this.el.style.left = horizontalProvider.getHorizontalSashLeft(this) + 'px';
            }
            if (horizontalProvider.getHorizontalSashWidth) {
                this.el.style.width = horizontalProvider.getHorizontalSashWidth(this) + 'px';
            }
        }
    };
    Sash.prototype.hide = function () {
        this.hidden = true;
        this.el.style.display = 'none';
        this.el.setAttribute('aria-hidden', 'true');
    };
    Sash.prototype.onOrthogonalStartSashEnablementChange = function (state) {
        Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["N" /* toggleClass */])(this.el, 'orthogonal-start', state !== SashState.Disabled);
    };
    Sash.prototype.onOrthogonalEndSashEnablementChange = function (state) {
        Object(__WEBPACK_IMPORTED_MODULE_8__dom_js__["N" /* toggleClass */])(this.el, 'orthogonal-end', state !== SashState.Disabled);
    };
    Sash.prototype.dispose = function () {
        this.orthogonalStartSashDisposables = Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(this.orthogonalStartSashDisposables);
        this.orthogonalEndSashDisposables = Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(this.orthogonalEndSashDisposables);
        if (this.el && this.el.parentElement) {
            this.el.parentElement.removeChild(this.el);
        }
        this.el = null;
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    return Sash;
}());



/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefinitionActionConfig", function() { return DefinitionActionConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefinitionAction", function() { return DefinitionAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GoToDefinitionAction", function() { return GoToDefinitionAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OpenDefinitionToSideAction", function() { return OpenDefinitionToSideAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PeekDefinitionAction", function() { return PeekDefinitionAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImplementationAction", function() { return ImplementationAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GoToImplementationAction", function() { return GoToImplementationAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PeekImplementationAction", function() { return PeekImplementationAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TypeDefinitionAction", function() { return TypeDefinitionAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GoToTypeDefinitionAction", function() { return GoToTypeDefinitionAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PeekTypeDefinitionAction", function() { return PeekTypeDefinitionAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__goToDefinition_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__referenceSearch_referencesController_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__referenceSearch_referencesModel_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__referenceSearch_peekViewWidget_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__message_messageController_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_progress_common_progress_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__base_common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

















var DefinitionActionConfig = /** @class */ (function () {
    function DefinitionActionConfig(openToSide, openInPeek, filterCurrent, showMessage) {
        if (openToSide === void 0) { openToSide = false; }
        if (openInPeek === void 0) { openInPeek = false; }
        if (filterCurrent === void 0) { filterCurrent = true; }
        if (showMessage === void 0) { showMessage = true; }
        this.openToSide = openToSide;
        this.openInPeek = openInPeek;
        this.filterCurrent = filterCurrent;
        this.showMessage = showMessage;
        //
    }
    return DefinitionActionConfig;
}());

var DefinitionAction = /** @class */ (function (_super) {
    __extends(DefinitionAction, _super);
    function DefinitionAction(configuration, opts) {
        var _this = _super.call(this, opts) || this;
        _this._configuration = configuration;
        return _this;
    }
    DefinitionAction.prototype.run = function (accessor, editor) {
        var _this = this;
        var notificationService = accessor.get(__WEBPACK_IMPORTED_MODULE_15__platform_notification_common_notification_js__["a" /* INotificationService */]);
        var editorService = accessor.get(__WEBPACK_IMPORTED_MODULE_4__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]);
        var progressService = accessor.get(__WEBPACK_IMPORTED_MODULE_14__platform_progress_common_progress_js__["a" /* IProgressService */]);
        var model = editor.getModel();
        var pos = editor.getPosition();
        var definitionPromise = this._getDeclarationsAtPosition(model, pos).then(function (references) {
            if (model.isDisposed() || editor.getModel() !== model) {
                // new model, no more model
                return;
            }
            // * remove falsy references
            // * find reference at the current pos
            var idxOfCurrent = -1;
            var result = [];
            for (var i = 0; i < references.length; i++) {
                var reference = references[i];
                if (!reference || !reference.range) {
                    continue;
                }
                var uri = reference.uri, range = reference.range;
                var newLen = result.push({
                    uri: uri,
                    range: range
                });
                if (_this._configuration.filterCurrent
                    && uri.toString() === model.uri.toString()
                    && __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].containsPosition(range, pos)
                    && idxOfCurrent === -1) {
                    idxOfCurrent = newLen - 1;
                }
            }
            if (result.length === 0) {
                // no result -> show message
                if (_this._configuration.showMessage) {
                    var info = model.getWordAtPosition(pos);
                    __WEBPACK_IMPORTED_MODULE_12__message_messageController_js__["a" /* MessageController */].get(editor).showMessage(_this._getNoResultFoundMessage(info), pos);
                }
            }
            else if (result.length === 1 && idxOfCurrent !== -1) {
                // only the position at which we are -> adjust selection
                var current = result[0];
                _this._openReference(editor, editorService, current, false);
            }
            else {
                // handle multile results
                _this._onResult(editorService, editor, new __WEBPACK_IMPORTED_MODULE_9__referenceSearch_referencesModel_js__["c" /* ReferencesModel */](result));
            }
        }, function (err) {
            // report an error
            notificationService.error(err);
        });
        progressService.showWhile(definitionPromise, 250);
        return definitionPromise;
    };
    DefinitionAction.prototype._getDeclarationsAtPosition = function (model, position) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__goToDefinition_js__["a" /* getDefinitionsAtPosition */])(model, position);
    };
    DefinitionAction.prototype._getNoResultFoundMessage = function (info) {
        return info && info.word
            ? __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('noResultWord', "No definition found for '{0}'", info.word)
            : __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('generic.noResults', "No definition found");
    };
    DefinitionAction.prototype._getMetaTitle = function (model) {
        return model.references.length > 1 && __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('meta.title', " – {0} definitions", model.references.length);
    };
    DefinitionAction.prototype._onResult = function (editorService, editor, model) {
        var _this = this;
        var msg = model.getAriaMessage();
        Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_ui_aria_aria_js__["a" /* alert */])(msg);
        if (this._configuration.openInPeek) {
            this._openInPeek(editorService, editor, model);
        }
        else {
            var next = model.nearestReference(editor.getModel().uri, editor.getPosition());
            this._openReference(editor, editorService, next, this._configuration.openToSide).then(function (editor) {
                if (editor && model.references.length > 1) {
                    _this._openInPeek(editorService, editor, model);
                }
                else {
                    model.dispose();
                }
            });
        }
    };
    DefinitionAction.prototype._openReference = function (editor, editorService, reference, sideBySide) {
        var uri = reference.uri, range = reference.range;
        return editorService.openCodeEditor({
            resource: uri,
            options: {
                selection: __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].collapseToStart(range),
                revealIfOpened: true,
                revealInCenterIfOutsideViewport: true
            }
        }, editor, sideBySide);
    };
    DefinitionAction.prototype._openInPeek = function (editorService, target, model) {
        var _this = this;
        var controller = __WEBPACK_IMPORTED_MODULE_8__referenceSearch_referencesController_js__["a" /* ReferencesController */].get(target);
        if (controller) {
            controller.toggleWidget(target.getSelection(), Object(__WEBPACK_IMPORTED_MODULE_16__base_common_async_js__["i" /* createCancelablePromise */])(function (_) { return Promise.resolve(model); }), {
                getMetaTitle: function (model) {
                    return _this._getMetaTitle(model);
                },
                onGoto: function (reference) {
                    controller.closeWidget();
                    return _this._openReference(target, editorService, reference, false);
                }
            });
        }
        else {
            model.dispose();
        }
    };
    return DefinitionAction;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));

var goToDeclarationKb = __WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["f" /* isWeb */]
    ? 2048 /* CtrlCmd */ | 70 /* F12 */
    : 70 /* F12 */;
var GoToDefinitionAction = /** @class */ (function (_super) {
    __extends(GoToDefinitionAction, _super);
    function GoToDefinitionAction() {
        return _super.call(this, new DefinitionActionConfig(), {
            id: GoToDefinitionAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('actions.goToDecl.label', "Go to Definition"),
            alias: 'Go to Definition',
            precondition: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDefinitionProvider, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: goToDeclarationKb,
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: 'navigation',
                order: 1.1
            }
        }) || this;
    }
    GoToDefinitionAction.ID = 'editor.action.goToDeclaration';
    return GoToDefinitionAction;
}(DefinitionAction));

var OpenDefinitionToSideAction = /** @class */ (function (_super) {
    __extends(OpenDefinitionToSideAction, _super);
    function OpenDefinitionToSideAction() {
        return _super.call(this, new DefinitionActionConfig(true), {
            id: OpenDefinitionToSideAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('actions.goToDeclToSide.label', "Open Definition to the Side"),
            alias: 'Open Definition to the Side',
            precondition: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDefinitionProvider, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, goToDeclarationKb),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    OpenDefinitionToSideAction.ID = 'editor.action.openDeclarationToTheSide';
    return OpenDefinitionToSideAction;
}(DefinitionAction));

var PeekDefinitionAction = /** @class */ (function (_super) {
    __extends(PeekDefinitionAction, _super);
    function PeekDefinitionAction() {
        return _super.call(this, new DefinitionActionConfig(void 0, true, false), {
            id: 'editor.action.previewDeclaration',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('actions.previewDecl.label', "Peek Definition"),
            alias: 'Peek Definition',
            precondition: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDefinitionProvider, __WEBPACK_IMPORTED_MODULE_10__referenceSearch_peekViewWidget_js__["a" /* PeekContext */].notInPeekEditor, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 512 /* Alt */ | 70 /* F12 */,
                linux: { primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 68 /* F10 */ },
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: 'navigation',
                order: 1.2
            }
        }) || this;
    }
    return PeekDefinitionAction;
}(DefinitionAction));

var ImplementationAction = /** @class */ (function (_super) {
    __extends(ImplementationAction, _super);
    function ImplementationAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImplementationAction.prototype._getDeclarationsAtPosition = function (model, position) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__goToDefinition_js__["b" /* getImplementationsAtPosition */])(model, position);
    };
    ImplementationAction.prototype._getNoResultFoundMessage = function (info) {
        return info && info.word
            ? __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('goToImplementation.noResultWord', "No implementation found for '{0}'", info.word)
            : __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('goToImplementation.generic.noResults', "No implementation found");
    };
    ImplementationAction.prototype._getMetaTitle = function (model) {
        return model.references.length > 1 && __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('meta.implementations.title', " – {0} implementations", model.references.length);
    };
    return ImplementationAction;
}(DefinitionAction));

var GoToImplementationAction = /** @class */ (function (_super) {
    __extends(GoToImplementationAction, _super);
    function GoToImplementationAction() {
        return _super.call(this, new DefinitionActionConfig(), {
            id: GoToImplementationAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('actions.goToImplementation.label', "Go to Implementation"),
            alias: 'Go to Implementation',
            precondition: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasImplementationProvider, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 70 /* F12 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    GoToImplementationAction.ID = 'editor.action.goToImplementation';
    return GoToImplementationAction;
}(ImplementationAction));

var PeekImplementationAction = /** @class */ (function (_super) {
    __extends(PeekImplementationAction, _super);
    function PeekImplementationAction() {
        return _super.call(this, new DefinitionActionConfig(false, true, false), {
            id: PeekImplementationAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('actions.peekImplementation.label', "Peek Implementation"),
            alias: 'Peek Implementation',
            precondition: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasImplementationProvider, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 70 /* F12 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    PeekImplementationAction.ID = 'editor.action.peekImplementation';
    return PeekImplementationAction;
}(ImplementationAction));

var TypeDefinitionAction = /** @class */ (function (_super) {
    __extends(TypeDefinitionAction, _super);
    function TypeDefinitionAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TypeDefinitionAction.prototype._getDeclarationsAtPosition = function (model, position) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__goToDefinition_js__["c" /* getTypeDefinitionsAtPosition */])(model, position);
    };
    TypeDefinitionAction.prototype._getNoResultFoundMessage = function (info) {
        return info && info.word
            ? __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('goToTypeDefinition.noResultWord', "No type definition found for '{0}'", info.word)
            : __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('goToTypeDefinition.generic.noResults', "No type definition found");
    };
    TypeDefinitionAction.prototype._getMetaTitle = function (model) {
        return model.references.length > 1 && __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('meta.typeDefinitions.title', " – {0} type definitions", model.references.length);
    };
    return TypeDefinitionAction;
}(DefinitionAction));

var GoToTypeDefinitionAction = /** @class */ (function (_super) {
    __extends(GoToTypeDefinitionAction, _super);
    function GoToTypeDefinitionAction() {
        return _super.call(this, new DefinitionActionConfig(), {
            id: GoToTypeDefinitionAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('actions.goToTypeDefinition.label', "Go to Type Definition"),
            alias: 'Go to Type Definition',
            precondition: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasTypeDefinitionProvider, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 0,
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: 'navigation',
                order: 1.4
            }
        }) || this;
    }
    GoToTypeDefinitionAction.ID = 'editor.action.goToTypeDefinition';
    return GoToTypeDefinitionAction;
}(TypeDefinitionAction));

var PeekTypeDefinitionAction = /** @class */ (function (_super) {
    __extends(PeekTypeDefinitionAction, _super);
    function PeekTypeDefinitionAction() {
        return _super.call(this, new DefinitionActionConfig(false, true, false), {
            id: PeekTypeDefinitionAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('actions.peekTypeDefinition.label', "Peek Type Definition"),
            alias: 'Peek Type Definition',
            precondition: __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasTypeDefinitionProvider, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 0,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    PeekTypeDefinitionAction.ID = 'editor.action.peekTypeDefinition';
    return PeekTypeDefinitionAction;
}(TypeDefinitionAction));

Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(GoToDefinitionAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(OpenDefinitionToSideAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(PeekDefinitionAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(GoToImplementationAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(PeekImplementationAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(GoToTypeDefinitionAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(PeekTypeDefinitionAction);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeEditorWidget; });
/* unused harmony export BooleanEventEmitter */
/* unused harmony export EditorModeContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_editor_css__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_editor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__media_editor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_tokens_css__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_tokens_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__media_tokens_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_instantiation_common_serviceCollection_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_configuration_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_controller_cursor_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_controller_cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModelImpl_js__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__base_common_network_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__view_viewImpl_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_editorAction_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};































var EDITOR_ID = 0;
var SHOW_UNUSED_ENABLED_CLASS = 'showUnused';
var CodeEditorWidget = /** @class */ (function (_super) {
    __extends(CodeEditorWidget, _super);
    function CodeEditorWidget(domElement, options, codeEditorWidgetOptions, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService) {
        var _this = _super.call(this) || this;
        //#region Eventing
        _this._onDidDispose = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidDispose = _this._onDidDispose.event;
        _this._onDidChangeModelContent = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeModelContent = _this._onDidChangeModelContent.event;
        _this._onDidChangeModelLanguage = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeModelLanguage = _this._onDidChangeModelLanguage.event;
        _this._onDidChangeModelLanguageConfiguration = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeModelLanguageConfiguration = _this._onDidChangeModelLanguageConfiguration.event;
        _this._onDidChangeModelOptions = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeModelOptions = _this._onDidChangeModelOptions.event;
        _this._onDidChangeModelDecorations = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeModelDecorations = _this._onDidChangeModelDecorations.event;
        _this._onDidChangeConfiguration = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeConfiguration = _this._onDidChangeConfiguration.event;
        _this._onDidChangeModel = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeModel = _this._onDidChangeModel.event;
        _this._onDidChangeCursorPosition = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeCursorPosition = _this._onDidChangeCursorPosition.event;
        _this._onDidChangeCursorSelection = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeCursorSelection = _this._onDidChangeCursorSelection.event;
        _this._onDidAttemptReadOnlyEdit = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidAttemptReadOnlyEdit = _this._onDidAttemptReadOnlyEdit.event;
        _this._onDidLayoutChange = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidLayoutChange = _this._onDidLayoutChange.event;
        _this._editorTextFocus = _this._register(new BooleanEventEmitter());
        _this.onDidFocusEditorText = _this._editorTextFocus.onDidChangeToTrue;
        _this.onDidBlurEditorText = _this._editorTextFocus.onDidChangeToFalse;
        _this._editorWidgetFocus = _this._register(new BooleanEventEmitter());
        _this.onDidFocusEditorWidget = _this._editorWidgetFocus.onDidChangeToTrue;
        _this.onDidBlurEditorWidget = _this._editorWidgetFocus.onDidChangeToFalse;
        _this._onWillType = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onWillType = _this._onWillType.event;
        _this._onDidType = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidType = _this._onDidType.event;
        _this._onDidPaste = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidPaste = _this._onDidPaste.event;
        _this._onMouseUp = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onMouseUp = _this._onMouseUp.event;
        _this._onMouseDown = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onMouseDown = _this._onMouseDown.event;
        _this._onMouseDrag = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onMouseDrag = _this._onMouseDrag.event;
        _this._onMouseDrop = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onMouseDrop = _this._onMouseDrop.event;
        _this._onContextMenu = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onContextMenu = _this._onContextMenu.event;
        _this._onMouseMove = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onMouseMove = _this._onMouseMove.event;
        _this._onMouseLeave = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onMouseLeave = _this._onMouseLeave.event;
        _this._onKeyUp = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onKeyUp = _this._onKeyUp.event;
        _this._onKeyDown = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onKeyDown = _this._onKeyDown.event;
        _this._onDidScrollChange = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidScrollChange = _this._onDidScrollChange.event;
        _this._onDidChangeViewZones = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeViewZones = _this._onDidChangeViewZones.event;
        _this.domElement = domElement;
        _this.id = (++EDITOR_ID);
        _this._decorationTypeKeysToIds = {};
        _this._decorationTypeSubtypes = {};
        _this.isSimpleWidget = codeEditorWidgetOptions.isSimpleWidget || false;
        _this._telemetryData = codeEditorWidgetOptions.telemetryData || null;
        options = options || {};
        _this._configuration = _this._register(_this._createConfiguration(options));
        _this._register(_this._configuration.onDidChange(function (e) {
            _this._onDidChangeConfiguration.fire(e);
            if (e.layoutInfo) {
                _this._onDidLayoutChange.fire(_this._configuration.editor.layoutInfo);
            }
            if (_this._configuration.editor.showUnused) {
                _this.domElement.classList.add(SHOW_UNUSED_ENABLED_CLASS);
            }
            else {
                _this.domElement.classList.remove(SHOW_UNUSED_ENABLED_CLASS);
            }
        }));
        _this._contextKeyService = _this._register(contextKeyService.createScoped(_this.domElement));
        _this._notificationService = notificationService;
        _this._codeEditorService = codeEditorService;
        _this._commandService = commandService;
        _this._themeService = themeService;
        _this._register(new EditorContextKeysManager(_this, _this._contextKeyService));
        _this._register(new EditorModeContext(_this, _this._contextKeyService));
        _this._instantiationService = instantiationService.createChild(new __WEBPACK_IMPORTED_MODULE_9__platform_instantiation_common_serviceCollection_js__["a" /* ServiceCollection */]([__WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */], _this._contextKeyService]));
        _this._attachModel(null);
        _this._contributions = {};
        _this._actions = {};
        _this._focusTracker = new CodeEditorWidgetFocusTracker(domElement);
        _this._focusTracker.onChange(function () {
            _this._editorWidgetFocus.setValue(_this._focusTracker.hasFocus());
        });
        _this.contentWidgets = {};
        _this.overlayWidgets = {};
        var contributions = codeEditorWidgetOptions.contributions;
        if (!Array.isArray(contributions)) {
            contributions = __WEBPACK_IMPORTED_MODULE_28__editorExtensions_js__["d" /* EditorExtensionsRegistry */].getEditorContributions();
        }
        for (var i = 0, len = contributions.length; i < len; i++) {
            var ctor = contributions[i];
            try {
                var contribution = _this._instantiationService.createInstance(ctor, _this);
                _this._contributions[contribution.getId()] = contribution;
            }
            catch (err) {
                Object(__WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__["e" /* onUnexpectedError */])(err);
            }
        }
        __WEBPACK_IMPORTED_MODULE_28__editorExtensions_js__["d" /* EditorExtensionsRegistry */].getEditorActions().forEach(function (action) {
            var internalAction = new __WEBPACK_IMPORTED_MODULE_29__common_editorAction_js__["a" /* InternalEditorAction */](action.id, action.label, action.alias, action.precondition, function () {
                return _this._instantiationService.invokeFunction(function (accessor) {
                    return action.runEditorCommand(accessor, _this, null);
                });
            }, _this._contextKeyService);
            _this._actions[internalAction.id] = internalAction;
        });
        _this._codeEditorService.addCodeEditor(_this);
        return _this;
    }
    CodeEditorWidget.prototype._createConfiguration = function (options) {
        return new __WEBPACK_IMPORTED_MODULE_11__config_configuration_js__["a" /* Configuration */](options, this.domElement);
    };
    CodeEditorWidget.prototype.getId = function () {
        return this.getEditorType() + ':' + this.id;
    };
    CodeEditorWidget.prototype.getEditorType = function () {
        return __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["a" /* EditorType */].ICodeEditor;
    };
    CodeEditorWidget.prototype.dispose = function () {
        this._codeEditorService.removeCodeEditor(this);
        this.contentWidgets = {};
        this.overlayWidgets = {};
        this._focusTracker.dispose();
        var keys = Object.keys(this._contributions);
        for (var i = 0, len = keys.length; i < len; i++) {
            var contributionId = keys[i];
            this._contributions[contributionId].dispose();
        }
        this._contributions = {};
        // editor actions don't need to be disposed
        this._actions = {};
        this._removeDecorationTypes();
        this._postDetachModelCleanup(this._detachModel());
        this._onDidDispose.fire();
        _super.prototype.dispose.call(this);
    };
    CodeEditorWidget.prototype.invokeWithinContext = function (fn) {
        return this._instantiationService.invokeFunction(fn);
    };
    CodeEditorWidget.prototype.updateOptions = function (newOptions) {
        this._configuration.updateOptions(newOptions);
    };
    CodeEditorWidget.prototype.getConfiguration = function () {
        return this._configuration.editor;
    };
    CodeEditorWidget.prototype.getRawConfiguration = function () {
        return this._configuration.getRawOptions();
    };
    CodeEditorWidget.prototype.getValue = function (options) {
        if (options === void 0) { options = null; }
        if (this.model) {
            var preserveBOM = (options && options.preserveBOM) ? true : false;
            var eolPreference = __WEBPACK_IMPORTED_MODULE_22__common_model_js__["c" /* EndOfLinePreference */].TextDefined;
            if (options && options.lineEnding && options.lineEnding === '\n') {
                eolPreference = __WEBPACK_IMPORTED_MODULE_22__common_model_js__["c" /* EndOfLinePreference */].LF;
            }
            else if (options && options.lineEnding && options.lineEnding === '\r\n') {
                eolPreference = __WEBPACK_IMPORTED_MODULE_22__common_model_js__["c" /* EndOfLinePreference */].CRLF;
            }
            return this.model.getValue(eolPreference, preserveBOM);
        }
        return '';
    };
    CodeEditorWidget.prototype.setValue = function (newValue) {
        if (this.model) {
            this.model.setValue(newValue);
        }
    };
    CodeEditorWidget.prototype.getModel = function () {
        return this.model;
    };
    CodeEditorWidget.prototype.setModel = function (model) {
        if (model === void 0) { model = null; }
        if (this.model === model) {
            // Current model is the new model
            return;
        }
        var detachedModel = this._detachModel();
        this._attachModel(model);
        var e = {
            oldModelUrl: detachedModel ? detachedModel.uri : null,
            newModelUrl: model ? model.uri : null
        };
        this._removeDecorationTypes();
        this._onDidChangeModel.fire(e);
        this._postDetachModelCleanup(detachedModel);
    };
    CodeEditorWidget.prototype._removeDecorationTypes = function () {
        this._decorationTypeKeysToIds = {};
        if (this._decorationTypeSubtypes) {
            for (var decorationType in this._decorationTypeSubtypes) {
                var subTypes = this._decorationTypeSubtypes[decorationType];
                for (var subType in subTypes) {
                    this._removeDecorationType(decorationType + '-' + subType);
                }
            }
            this._decorationTypeSubtypes = {};
        }
    };
    CodeEditorWidget.prototype.getVisibleRanges = function () {
        if (!this.hasView) {
            return [];
        }
        return this.viewModel.getVisibleRanges();
    };
    CodeEditorWidget.prototype.getWhitespaces = function () {
        if (!this.hasView) {
            return [];
        }
        return this.viewModel.viewLayout.getWhitespaces();
    };
    CodeEditorWidget.prototype._getVerticalOffsetForPosition = function (modelLineNumber, modelColumn) {
        var modelPosition = this.model.validatePosition({
            lineNumber: modelLineNumber,
            column: modelColumn
        });
        var viewPosition = this.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
        return this.viewModel.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
    };
    CodeEditorWidget.prototype.getTopForLineNumber = function (lineNumber) {
        if (!this.hasView) {
            return -1;
        }
        return this._getVerticalOffsetForPosition(lineNumber, 1);
    };
    CodeEditorWidget.prototype.getTopForPosition = function (lineNumber, column) {
        if (!this.hasView) {
            return -1;
        }
        return this._getVerticalOffsetForPosition(lineNumber, column);
    };
    CodeEditorWidget.prototype.setHiddenAreas = function (ranges) {
        if (this.viewModel) {
            this.viewModel.setHiddenAreas(ranges.map(function (r) { return __WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */].lift(r); }));
        }
    };
    CodeEditorWidget.prototype.getVisibleColumnFromPosition = function (rawPosition) {
        if (!this.model) {
            return rawPosition.column;
        }
        var position = this.model.validatePosition(rawPosition);
        var tabSize = this.model.getOptions().tabSize;
        return __WEBPACK_IMPORTED_MODULE_13__common_controller_cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(this.model.getLineContent(position.lineNumber), position.column, tabSize) + 1;
    };
    CodeEditorWidget.prototype.getPosition = function () {
        if (!this.cursor) {
            return null;
        }
        return this.cursor.getPosition().clone();
    };
    CodeEditorWidget.prototype.setPosition = function (position) {
        if (!this.cursor) {
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_14__common_core_position_js__["a" /* Position */].isIPosition(position)) {
            throw new Error('Invalid arguments');
        }
        this.cursor.setSelections('api', [{
                selectionStartLineNumber: position.lineNumber,
                selectionStartColumn: position.column,
                positionLineNumber: position.lineNumber,
                positionColumn: position.column
            }]);
    };
    CodeEditorWidget.prototype._sendRevealRange = function (modelRange, verticalType, revealHorizontal, scrollType) {
        if (!this.model || !this.cursor) {
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */].isIRange(modelRange)) {
            throw new Error('Invalid arguments');
        }
        var validatedModelRange = this.model.validateRange(modelRange);
        var viewRange = this.viewModel.coordinatesConverter.convertModelRangeToViewRange(validatedModelRange);
        this.cursor.emitCursorRevealRange(viewRange, verticalType, revealHorizontal, scrollType);
    };
    CodeEditorWidget.prototype.revealLine = function (lineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealLine(lineNumber, 0 /* Simple */, scrollType);
    };
    CodeEditorWidget.prototype.revealLineInCenter = function (lineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealLine(lineNumber, 1 /* Center */, scrollType);
    };
    CodeEditorWidget.prototype.revealLineInCenterIfOutsideViewport = function (lineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealLine(lineNumber, 2 /* CenterIfOutsideViewport */, scrollType);
    };
    CodeEditorWidget.prototype._revealLine = function (lineNumber, revealType, scrollType) {
        if (typeof lineNumber !== 'number') {
            throw new Error('Invalid arguments');
        }
        this._sendRevealRange(new __WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, 1), revealType, false, scrollType);
    };
    CodeEditorWidget.prototype.revealPosition = function (position, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealPosition(position, 0 /* Simple */, true, scrollType);
    };
    CodeEditorWidget.prototype.revealPositionInCenter = function (position, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealPosition(position, 1 /* Center */, true, scrollType);
    };
    CodeEditorWidget.prototype.revealPositionInCenterIfOutsideViewport = function (position, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealPosition(position, 2 /* CenterIfOutsideViewport */, true, scrollType);
    };
    CodeEditorWidget.prototype._revealPosition = function (position, verticalType, revealHorizontal, scrollType) {
        if (!__WEBPACK_IMPORTED_MODULE_14__common_core_position_js__["a" /* Position */].isIPosition(position)) {
            throw new Error('Invalid arguments');
        }
        this._sendRevealRange(new __WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column), verticalType, revealHorizontal, scrollType);
    };
    CodeEditorWidget.prototype.getSelection = function () {
        if (!this.cursor) {
            return null;
        }
        return this.cursor.getSelection().clone();
    };
    CodeEditorWidget.prototype.getSelections = function () {
        if (!this.cursor) {
            return null;
        }
        var selections = this.cursor.getSelections();
        var result = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            result[i] = selections[i].clone();
        }
        return result;
    };
    CodeEditorWidget.prototype.setSelection = function (something) {
        var isSelection = __WEBPACK_IMPORTED_MODULE_16__common_core_selection_js__["a" /* Selection */].isISelection(something);
        var isRange = __WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */].isIRange(something);
        if (!isSelection && !isRange) {
            throw new Error('Invalid arguments');
        }
        if (isSelection) {
            this._setSelectionImpl(something);
        }
        else if (isRange) {
            // act as if it was an IRange
            var selection = {
                selectionStartLineNumber: something.startLineNumber,
                selectionStartColumn: something.startColumn,
                positionLineNumber: something.endLineNumber,
                positionColumn: something.endColumn
            };
            this._setSelectionImpl(selection);
        }
    };
    CodeEditorWidget.prototype._setSelectionImpl = function (sel) {
        if (!this.cursor) {
            return;
        }
        var selection = new __WEBPACK_IMPORTED_MODULE_16__common_core_selection_js__["a" /* Selection */](sel.selectionStartLineNumber, sel.selectionStartColumn, sel.positionLineNumber, sel.positionColumn);
        this.cursor.setSelections('api', [selection]);
    };
    CodeEditorWidget.prototype.revealLines = function (startLineNumber, endLineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealLines(startLineNumber, endLineNumber, 0 /* Simple */, scrollType);
    };
    CodeEditorWidget.prototype.revealLinesInCenter = function (startLineNumber, endLineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealLines(startLineNumber, endLineNumber, 1 /* Center */, scrollType);
    };
    CodeEditorWidget.prototype.revealLinesInCenterIfOutsideViewport = function (startLineNumber, endLineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealLines(startLineNumber, endLineNumber, 2 /* CenterIfOutsideViewport */, scrollType);
    };
    CodeEditorWidget.prototype._revealLines = function (startLineNumber, endLineNumber, verticalType, scrollType) {
        if (typeof startLineNumber !== 'number' || typeof endLineNumber !== 'number') {
            throw new Error('Invalid arguments');
        }
        this._sendRevealRange(new __WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */](startLineNumber, 1, endLineNumber, 1), verticalType, false, scrollType);
    };
    CodeEditorWidget.prototype.revealRange = function (range, scrollType, revealVerticalInCenter, revealHorizontal) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        if (revealVerticalInCenter === void 0) { revealVerticalInCenter = false; }
        if (revealHorizontal === void 0) { revealHorizontal = true; }
        this._revealRange(range, revealVerticalInCenter ? 1 /* Center */ : 0 /* Simple */, revealHorizontal, scrollType);
    };
    CodeEditorWidget.prototype.revealRangeInCenter = function (range, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealRange(range, 1 /* Center */, true, scrollType);
    };
    CodeEditorWidget.prototype.revealRangeInCenterIfOutsideViewport = function (range, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealRange(range, 2 /* CenterIfOutsideViewport */, true, scrollType);
    };
    CodeEditorWidget.prototype.revealRangeAtTop = function (range, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._revealRange(range, 3 /* Top */, true, scrollType);
    };
    CodeEditorWidget.prototype._revealRange = function (range, verticalType, revealHorizontal, scrollType) {
        if (!__WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */].isIRange(range)) {
            throw new Error('Invalid arguments');
        }
        this._sendRevealRange(__WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */].lift(range), verticalType, revealHorizontal, scrollType);
    };
    CodeEditorWidget.prototype.setSelections = function (ranges) {
        if (!this.cursor) {
            return;
        }
        if (!ranges || ranges.length === 0) {
            throw new Error('Invalid arguments');
        }
        for (var i = 0, len = ranges.length; i < len; i++) {
            if (!__WEBPACK_IMPORTED_MODULE_16__common_core_selection_js__["a" /* Selection */].isISelection(ranges[i])) {
                throw new Error('Invalid arguments');
            }
        }
        this.cursor.setSelections('api', ranges);
    };
    CodeEditorWidget.prototype.getScrollWidth = function () {
        if (!this.hasView) {
            return -1;
        }
        return this.viewModel.viewLayout.getScrollWidth();
    };
    CodeEditorWidget.prototype.getScrollLeft = function () {
        if (!this.hasView) {
            return -1;
        }
        return this.viewModel.viewLayout.getCurrentScrollLeft();
    };
    CodeEditorWidget.prototype.getScrollHeight = function () {
        if (!this.hasView) {
            return -1;
        }
        return this.viewModel.viewLayout.getScrollHeight();
    };
    CodeEditorWidget.prototype.getScrollTop = function () {
        if (!this.hasView) {
            return -1;
        }
        return this.viewModel.viewLayout.getCurrentScrollTop();
    };
    CodeEditorWidget.prototype.setScrollLeft = function (newScrollLeft) {
        if (!this.hasView) {
            return;
        }
        if (typeof newScrollLeft !== 'number') {
            throw new Error('Invalid arguments');
        }
        this.viewModel.viewLayout.setScrollPositionNow({
            scrollLeft: newScrollLeft
        });
    };
    CodeEditorWidget.prototype.setScrollTop = function (newScrollTop) {
        if (!this.hasView) {
            return;
        }
        if (typeof newScrollTop !== 'number') {
            throw new Error('Invalid arguments');
        }
        this.viewModel.viewLayout.setScrollPositionNow({
            scrollTop: newScrollTop
        });
    };
    CodeEditorWidget.prototype.setScrollPosition = function (position) {
        if (!this.hasView) {
            return;
        }
        this.viewModel.viewLayout.setScrollPositionNow(position);
    };
    CodeEditorWidget.prototype.saveViewState = function () {
        if (!this.cursor || !this.hasView) {
            return null;
        }
        var contributionsState = {};
        var keys = Object.keys(this._contributions);
        for (var i = 0, len = keys.length; i < len; i++) {
            var id = keys[i];
            var contribution = this._contributions[id];
            if (typeof contribution.saveViewState === 'function') {
                contributionsState[id] = contribution.saveViewState();
            }
        }
        var cursorState = this.cursor.saveState();
        var viewState = this.viewModel.saveState();
        return {
            cursorState: cursorState,
            viewState: viewState,
            contributionsState: contributionsState
        };
    };
    CodeEditorWidget.prototype.restoreViewState = function (s) {
        if (!this.cursor || !this.hasView) {
            return;
        }
        if (s && s.cursorState && s.viewState) {
            var codeEditorState = s;
            var cursorState = codeEditorState.cursorState;
            if (Array.isArray(cursorState)) {
                this.cursor.restoreState(cursorState);
            }
            else {
                // Backwards compatibility
                this.cursor.restoreState([cursorState]);
            }
            var contributionsState = s.contributionsState || {};
            var keys = Object.keys(this._contributions);
            for (var i = 0, len = keys.length; i < len; i++) {
                var id = keys[i];
                var contribution = this._contributions[id];
                if (typeof contribution.restoreViewState === 'function') {
                    contribution.restoreViewState(contributionsState[id]);
                }
            }
            var reducedState = this.viewModel.reduceRestoreState(s.viewState);
            var linesViewportData = this.viewModel.viewLayout.getLinesViewportDataAtScrollTop(reducedState.scrollTop);
            var startPosition = this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_14__common_core_position_js__["a" /* Position */](linesViewportData.startLineNumber, 1));
            var endPosition = this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_14__common_core_position_js__["a" /* Position */](linesViewportData.endLineNumber, 1));
            this.model.tokenizeViewport(startPosition.lineNumber, endPosition.lineNumber);
            this._view.restoreState(reducedState);
        }
    };
    CodeEditorWidget.prototype.getContribution = function (id) {
        return (this._contributions[id] || null);
    };
    CodeEditorWidget.prototype.getActions = function () {
        var result = [];
        var keys = Object.keys(this._actions);
        for (var i = 0, len = keys.length; i < len; i++) {
            var id = keys[i];
            result.push(this._actions[id]);
        }
        return result;
    };
    CodeEditorWidget.prototype.getSupportedActions = function () {
        var result = this.getActions();
        result = result.filter(function (action) { return action.isSupported(); });
        return result;
    };
    CodeEditorWidget.prototype.getAction = function (id) {
        return this._actions[id] || null;
    };
    CodeEditorWidget.prototype.trigger = function (source, handlerId, payload) {
        payload = payload || {};
        // Special case for typing
        if (handlerId === __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Type) {
            if (!this.cursor || typeof payload.text !== 'string' || payload.text.length === 0) {
                // nothing to do
                return;
            }
            if (source === 'keyboard') {
                this._onWillType.fire(payload.text);
            }
            this.cursor.trigger(source, handlerId, payload);
            if (source === 'keyboard') {
                this._onDidType.fire(payload.text);
            }
            return;
        }
        // Special case for pasting
        if (handlerId === __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Paste) {
            if (!this.cursor || typeof payload.text !== 'string' || payload.text.length === 0) {
                // nothing to do
                return;
            }
            var startPosition = this.cursor.getSelection().getStartPosition();
            this.cursor.trigger(source, handlerId, payload);
            var endPosition = this.cursor.getSelection().getStartPosition();
            if (source === 'keyboard') {
                this._onDidPaste.fire(new __WEBPACK_IMPORTED_MODULE_15__common_core_range_js__["a" /* Range */](startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column));
            }
            return;
        }
        var action = this.getAction(handlerId);
        if (action) {
            __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].as(action.run()).then(null, __WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__["e" /* onUnexpectedError */]);
            return;
        }
        if (!this.cursor) {
            return;
        }
        if (this._triggerEditorCommand(source, handlerId, payload)) {
            return;
        }
        this.cursor.trigger(source, handlerId, payload);
    };
    CodeEditorWidget.prototype._triggerEditorCommand = function (source, handlerId, payload) {
        var command = __WEBPACK_IMPORTED_MODULE_28__editorExtensions_js__["d" /* EditorExtensionsRegistry */].getEditorCommand(handlerId);
        if (command) {
            payload = payload || {};
            payload.source = source;
            __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].as(command.runEditorCommand(null, this, payload)).done(null, __WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__["e" /* onUnexpectedError */]);
            return true;
        }
        return false;
    };
    CodeEditorWidget.prototype._getCursors = function () {
        return this.cursor;
    };
    CodeEditorWidget.prototype._getCursorConfiguration = function () {
        return this.cursor.context.config;
    };
    CodeEditorWidget.prototype.pushUndoStop = function () {
        if (!this.model) {
            return false;
        }
        if (this._configuration.editor.readOnly) {
            // read only editor => sorry!
            return false;
        }
        this.model.pushStackElement();
        return true;
    };
    CodeEditorWidget.prototype.executeEdits = function (source, edits, endCursorState) {
        if (!this.cursor) {
            // no view, no cursor
            return false;
        }
        if (this._configuration.editor.readOnly) {
            // read only editor => sorry!
            return false;
        }
        this.model.pushEditOperations(this.cursor.getSelections(), edits, function () {
            return endCursorState ? endCursorState : null;
        });
        if (endCursorState) {
            this.cursor.setSelections(source, endCursorState);
        }
        return true;
    };
    CodeEditorWidget.prototype.executeCommand = function (source, command) {
        if (!this.cursor) {
            return;
        }
        this.cursor.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].ExecuteCommand, command);
    };
    CodeEditorWidget.prototype.executeCommands = function (source, commands) {
        if (!this.cursor) {
            return;
        }
        this.cursor.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].ExecuteCommands, commands);
    };
    CodeEditorWidget.prototype.changeDecorations = function (callback) {
        if (!this.model) {
            //			console.warn('Cannot change decorations on editor that is not attached to a model');
            // callback will not be called
            return null;
        }
        return this.model.changeDecorations(callback, this.id);
    };
    CodeEditorWidget.prototype.getLineDecorations = function (lineNumber) {
        if (!this.model) {
            return null;
        }
        return this.model.getLineDecorations(lineNumber, this.id, this._configuration.editor.readOnly);
    };
    CodeEditorWidget.prototype.deltaDecorations = function (oldDecorations, newDecorations) {
        if (!this.model) {
            return [];
        }
        if (oldDecorations.length === 0 && newDecorations.length === 0) {
            return oldDecorations;
        }
        return this.model.deltaDecorations(oldDecorations, newDecorations, this.id);
    };
    CodeEditorWidget.prototype.removeDecorations = function (decorationTypeKey) {
        // remove decorations for type and sub type
        var oldDecorationsIds = this._decorationTypeKeysToIds[decorationTypeKey];
        if (oldDecorationsIds) {
            this.deltaDecorations(oldDecorationsIds, []);
        }
        if (this._decorationTypeKeysToIds.hasOwnProperty(decorationTypeKey)) {
            delete this._decorationTypeKeysToIds[decorationTypeKey];
        }
        if (this._decorationTypeSubtypes.hasOwnProperty(decorationTypeKey)) {
            delete this._decorationTypeSubtypes[decorationTypeKey];
        }
    };
    CodeEditorWidget.prototype.getLayoutInfo = function () {
        return this._configuration.editor.layoutInfo;
    };
    CodeEditorWidget.prototype.createOverviewRuler = function (cssClassName) {
        return this._view.createOverviewRuler(cssClassName);
    };
    CodeEditorWidget.prototype.getDomNode = function () {
        if (!this.hasView) {
            return null;
        }
        return this._view.domNode.domNode;
    };
    CodeEditorWidget.prototype.delegateVerticalScrollbarMouseDown = function (browserEvent) {
        if (!this.hasView) {
            return;
        }
        this._view.delegateVerticalScrollbarMouseDown(browserEvent);
    };
    CodeEditorWidget.prototype.layout = function (dimension) {
        this._configuration.observeReferenceElement(dimension);
        this.render();
    };
    CodeEditorWidget.prototype.focus = function () {
        if (!this.hasView) {
            return;
        }
        this._view.focus();
    };
    CodeEditorWidget.prototype.hasTextFocus = function () {
        return this.hasView && this._view.isFocused();
    };
    CodeEditorWidget.prototype.hasWidgetFocus = function () {
        return this._focusTracker && this._focusTracker.hasFocus();
    };
    CodeEditorWidget.prototype.addContentWidget = function (widget) {
        var widgetData = {
            widget: widget,
            position: widget.getPosition()
        };
        if (this.contentWidgets.hasOwnProperty(widget.getId())) {
            console.warn('Overwriting a content widget with the same id.');
        }
        this.contentWidgets[widget.getId()] = widgetData;
        if (this.hasView) {
            this._view.addContentWidget(widgetData);
        }
    };
    CodeEditorWidget.prototype.layoutContentWidget = function (widget) {
        var widgetId = widget.getId();
        if (this.contentWidgets.hasOwnProperty(widgetId)) {
            var widgetData = this.contentWidgets[widgetId];
            widgetData.position = widget.getPosition();
            if (this.hasView) {
                this._view.layoutContentWidget(widgetData);
            }
        }
    };
    CodeEditorWidget.prototype.removeContentWidget = function (widget) {
        var widgetId = widget.getId();
        if (this.contentWidgets.hasOwnProperty(widgetId)) {
            var widgetData = this.contentWidgets[widgetId];
            delete this.contentWidgets[widgetId];
            if (this.hasView) {
                this._view.removeContentWidget(widgetData);
            }
        }
    };
    CodeEditorWidget.prototype.addOverlayWidget = function (widget) {
        var widgetData = {
            widget: widget,
            position: widget.getPosition()
        };
        if (this.overlayWidgets.hasOwnProperty(widget.getId())) {
            console.warn('Overwriting an overlay widget with the same id.');
        }
        this.overlayWidgets[widget.getId()] = widgetData;
        if (this.hasView) {
            this._view.addOverlayWidget(widgetData);
        }
    };
    CodeEditorWidget.prototype.layoutOverlayWidget = function (widget) {
        var widgetId = widget.getId();
        if (this.overlayWidgets.hasOwnProperty(widgetId)) {
            var widgetData = this.overlayWidgets[widgetId];
            widgetData.position = widget.getPosition();
            if (this.hasView) {
                this._view.layoutOverlayWidget(widgetData);
            }
        }
    };
    CodeEditorWidget.prototype.removeOverlayWidget = function (widget) {
        var widgetId = widget.getId();
        if (this.overlayWidgets.hasOwnProperty(widgetId)) {
            var widgetData = this.overlayWidgets[widgetId];
            delete this.overlayWidgets[widgetId];
            if (this.hasView) {
                this._view.removeOverlayWidget(widgetData);
            }
        }
    };
    CodeEditorWidget.prototype.changeViewZones = function (callback) {
        if (!this.hasView) {
            return;
        }
        var hasChanges = this._view.change(callback);
        if (hasChanges) {
            this._onDidChangeViewZones.fire();
        }
    };
    CodeEditorWidget.prototype.getTargetAtClientPoint = function (clientX, clientY) {
        if (!this.hasView) {
            return null;
        }
        return this._view.getTargetAtClientPoint(clientX, clientY);
    };
    CodeEditorWidget.prototype.getScrolledVisiblePosition = function (rawPosition) {
        if (!this.hasView) {
            return null;
        }
        var position = this.model.validatePosition(rawPosition);
        var layoutInfo = this._configuration.editor.layoutInfo;
        var top = this._getVerticalOffsetForPosition(position.lineNumber, position.column) - this.getScrollTop();
        var left = this._view.getOffsetForColumn(position.lineNumber, position.column) + layoutInfo.glyphMarginWidth + layoutInfo.lineNumbersWidth + layoutInfo.decorationsWidth - this.getScrollLeft();
        return {
            top: top,
            left: left,
            height: this._configuration.editor.lineHeight
        };
    };
    CodeEditorWidget.prototype.getOffsetForColumn = function (lineNumber, column) {
        if (!this.hasView) {
            return -1;
        }
        return this._view.getOffsetForColumn(lineNumber, column);
    };
    CodeEditorWidget.prototype.render = function () {
        if (!this.hasView) {
            return;
        }
        this._view.render(true, false);
    };
    CodeEditorWidget.prototype.applyFontInfo = function (target) {
        __WEBPACK_IMPORTED_MODULE_11__config_configuration_js__["a" /* Configuration */].applyFontInfoSlow(target, this._configuration.editor.fontInfo);
    };
    CodeEditorWidget.prototype._attachModel = function (model) {
        var _this = this;
        this._view = null;
        this.model = model ? model : null;
        this.listenersToRemove = [];
        this.viewModel = null;
        this.cursor = null;
        if (this.model) {
            this.domElement.setAttribute('data-mode-id', this.model.getLanguageIdentifier().language);
            this._configuration.setIsDominatedByLongLines(this.model.isDominatedByLongLines());
            this._configuration.setMaxLineNumber(this.model.getLineCount());
            this.model.onBeforeAttached();
            this.viewModel = new __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModelImpl_js__["a" /* ViewModel */](this.id, this._configuration, this.model, function (callback) { return __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["L" /* scheduleAtNextAnimationFrame */](callback); });
            this.listenersToRemove.push(this.model.onDidChangeDecorations(function (e) { return _this._onDidChangeModelDecorations.fire(e); }));
            this.listenersToRemove.push(this.model.onDidChangeLanguage(function (e) {
                if (!_this.model) {
                    return;
                }
                _this.domElement.setAttribute('data-mode-id', _this.model.getLanguageIdentifier().language);
                _this._onDidChangeModelLanguage.fire(e);
            }));
            this.listenersToRemove.push(this.model.onDidChangeLanguageConfiguration(function (e) { return _this._onDidChangeModelLanguageConfiguration.fire(e); }));
            this.listenersToRemove.push(this.model.onDidChangeContent(function (e) { return _this._onDidChangeModelContent.fire(e); }));
            this.listenersToRemove.push(this.model.onDidChangeOptions(function (e) { return _this._onDidChangeModelOptions.fire(e); }));
            // Someone might destroy the model from under the editor, so prevent any exceptions by setting a null model
            this.listenersToRemove.push(this.model.onWillDispose(function () { return _this.setModel(null); }));
            this.cursor = new __WEBPACK_IMPORTED_MODULE_12__common_controller_cursor_js__["a" /* Cursor */](this._configuration, this.model, this.viewModel);
            this._createView();
            this.listenersToRemove.push(this.cursor.onDidReachMaxCursorCount(function () {
                _this._notificationService.warn(__WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('cursors.maximum', "The number of cursors has been limited to {0}.", __WEBPACK_IMPORTED_MODULE_12__common_controller_cursor_js__["a" /* Cursor */].MAX_CURSOR_COUNT));
            }));
            this.listenersToRemove.push(this.cursor.onDidAttemptReadOnlyEdit(function () {
                _this._onDidAttemptReadOnlyEdit.fire(void 0);
            }));
            this.listenersToRemove.push(this.cursor.onDidChange(function (e) {
                var positions = [];
                for (var i = 0, len = e.selections.length; i < len; i++) {
                    positions[i] = e.selections[i].getPosition();
                }
                var e1 = {
                    position: positions[0],
                    secondaryPositions: positions.slice(1),
                    reason: e.reason,
                    source: e.source
                };
                _this._onDidChangeCursorPosition.fire(e1);
                var e2 = {
                    selection: e.selections[0],
                    secondarySelections: e.selections.slice(1),
                    source: e.source,
                    reason: e.reason
                };
                _this._onDidChangeCursorSelection.fire(e2);
            }));
        }
        else {
            this.hasView = false;
        }
        if (this._view) {
            this.domElement.appendChild(this._view.domNode.domNode);
            var keys = Object.keys(this.contentWidgets);
            for (var i = 0, len = keys.length; i < len; i++) {
                var widgetId = keys[i];
                this._view.addContentWidget(this.contentWidgets[widgetId]);
            }
            keys = Object.keys(this.overlayWidgets);
            for (var i = 0, len = keys.length; i < len; i++) {
                var widgetId = keys[i];
                this._view.addOverlayWidget(this.overlayWidgets[widgetId]);
            }
            this._view.render(false, true);
            this.hasView = true;
            this._view.domNode.domNode.setAttribute('data-uri', model.uri.toString());
        }
    };
    CodeEditorWidget.prototype._createView = function () {
        var _this = this;
        var commandDelegate;
        if (this.isSimpleWidget) {
            commandDelegate = {
                paste: function (source, text, pasteOnNewLine, multicursorText) {
                    _this.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Paste, { text: text, pasteOnNewLine: pasteOnNewLine, multicursorText: multicursorText });
                },
                type: function (source, text) {
                    _this.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Type, { text: text });
                },
                replacePreviousChar: function (source, text, replaceCharCnt) {
                    _this.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].ReplacePreviousChar, { text: text, replaceCharCnt: replaceCharCnt });
                },
                compositionStart: function (source) {
                    _this.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].CompositionStart, undefined);
                },
                compositionEnd: function (source) {
                    _this.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].CompositionEnd, undefined);
                },
                cut: function (source) {
                    _this.trigger(source, __WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Cut, undefined);
                }
            };
        }
        else {
            commandDelegate = {
                paste: function (source, text, pasteOnNewLine, multicursorText) {
                    _this._commandService.executeCommand(__WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Paste, {
                        text: text,
                        pasteOnNewLine: pasteOnNewLine,
                        multicursorText: multicursorText
                    });
                },
                type: function (source, text) {
                    _this._commandService.executeCommand(__WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Type, {
                        text: text
                    });
                },
                replacePreviousChar: function (source, text, replaceCharCnt) {
                    _this._commandService.executeCommand(__WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].ReplacePreviousChar, {
                        text: text,
                        replaceCharCnt: replaceCharCnt
                    });
                },
                compositionStart: function (source) {
                    _this._commandService.executeCommand(__WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].CompositionStart, {});
                },
                compositionEnd: function (source) {
                    _this._commandService.executeCommand(__WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].CompositionEnd, {});
                },
                cut: function (source) {
                    _this._commandService.executeCommand(__WEBPACK_IMPORTED_MODULE_17__common_editorCommon_js__["b" /* Handler */].Cut, {});
                }
            };
        }
        this._view = new __WEBPACK_IMPORTED_MODULE_27__view_viewImpl_js__["a" /* View */](commandDelegate, this._configuration, this._themeService, this.viewModel, this.cursor, function (editorCommand, args) {
            if (!_this.cursor) {
                return;
            }
            editorCommand.runCoreEditorCommand(_this.cursor, args);
        });
        var viewEventBus = this._view.getInternalEventBus();
        viewEventBus.onDidGainFocus = function () {
            _this._editorTextFocus.setValue(true);
            // In IE, the focus is not synchronous, so we give it a little help
            _this._editorWidgetFocus.setValue(true);
        };
        viewEventBus.onDidScroll = function (e) { return _this._onDidScrollChange.fire(e); };
        viewEventBus.onDidLoseFocus = function () { return _this._editorTextFocus.setValue(false); };
        viewEventBus.onContextMenu = function (e) { return _this._onContextMenu.fire(e); };
        viewEventBus.onMouseDown = function (e) { return _this._onMouseDown.fire(e); };
        viewEventBus.onMouseUp = function (e) { return _this._onMouseUp.fire(e); };
        viewEventBus.onMouseDrag = function (e) { return _this._onMouseDrag.fire(e); };
        viewEventBus.onMouseDrop = function (e) { return _this._onMouseDrop.fire(e); };
        viewEventBus.onKeyUp = function (e) { return _this._onKeyUp.fire(e); };
        viewEventBus.onMouseMove = function (e) { return _this._onMouseMove.fire(e); };
        viewEventBus.onMouseLeave = function (e) { return _this._onMouseLeave.fire(e); };
        viewEventBus.onKeyDown = function (e) { return _this._onKeyDown.fire(e); };
    };
    CodeEditorWidget.prototype._postDetachModelCleanup = function (detachedModel) {
        if (detachedModel) {
            detachedModel.removeAllDecorationsWithOwnerId(this.id);
        }
    };
    CodeEditorWidget.prototype._detachModel = function () {
        var removeDomNode = null;
        if (this._view) {
            this._view.dispose();
            removeDomNode = this._view.domNode.domNode;
            this._view = null;
        }
        if (this.model) {
            this.model.onBeforeDetached();
        }
        this.hasView = false;
        this.listenersToRemove = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.listenersToRemove);
        if (this.cursor) {
            this.cursor.dispose();
            this.cursor = null;
        }
        if (this.viewModel) {
            this.viewModel.dispose();
            this.viewModel = null;
        }
        var result = this.model;
        this.model = null;
        this.domElement.removeAttribute('data-mode-id');
        if (removeDomNode) {
            this.domElement.removeChild(removeDomNode);
        }
        return result;
    };
    CodeEditorWidget.prototype._removeDecorationType = function (key) {
        this._codeEditorService.removeDecorationType(key);
    };
    /* __GDPR__FRAGMENT__
        "EditorTelemetryData" : {}
    */
    CodeEditorWidget.prototype.getTelemetryData = function () {
        return this._telemetryData;
    };
    CodeEditorWidget = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_24__services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_25__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_26__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(8, __WEBPACK_IMPORTED_MODULE_23__platform_notification_common_notification_js__["a" /* INotificationService */])
    ], CodeEditorWidget);
    return CodeEditorWidget;
}(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["a" /* Disposable */]));

var BooleanEventEmitter = /** @class */ (function (_super) {
    __extends(BooleanEventEmitter, _super);
    function BooleanEventEmitter() {
        var _this = _super.call(this) || this;
        _this._onDidChangeToTrue = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeToTrue = _this._onDidChangeToTrue.event;
        _this._onDidChangeToFalse = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChangeToFalse = _this._onDidChangeToFalse.event;
        _this._value = 0 /* NotSet */;
        return _this;
    }
    BooleanEventEmitter.prototype.setValue = function (_value) {
        var value = (_value ? 2 /* True */ : 1 /* False */);
        if (this._value === value) {
            return;
        }
        this._value = value;
        if (this._value === 2 /* True */) {
            this._onDidChangeToTrue.fire();
        }
        else if (this._value === 1 /* False */) {
            this._onDidChangeToFalse.fire();
        }
    };
    return BooleanEventEmitter;
}(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["a" /* Disposable */]));

var EditorContextKeysManager = /** @class */ (function (_super) {
    __extends(EditorContextKeysManager, _super);
    function EditorContextKeysManager(editor, contextKeyService) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        contextKeyService.createKey('editorId', editor.getId());
        _this._editorFocus = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus.bindTo(contextKeyService);
        _this._textInputFocus = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus.bindTo(contextKeyService);
        _this._editorTextFocus = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus.bindTo(contextKeyService);
        _this._editorTabMovesFocus = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].tabMovesFocus.bindTo(contextKeyService);
        _this._editorReadonly = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].readOnly.bindTo(contextKeyService);
        _this._hasMultipleSelections = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasMultipleSelections.bindTo(contextKeyService);
        _this._hasNonEmptySelection = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasNonEmptySelection.bindTo(contextKeyService);
        _this._canUndo = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].canUndo.bindTo(contextKeyService);
        _this._canRedo = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].canRedo.bindTo(contextKeyService);
        _this._register(_this._editor.onDidChangeConfiguration(function () { return _this._updateFromConfig(); }));
        _this._register(_this._editor.onDidChangeCursorSelection(function () { return _this._updateFromSelection(); }));
        _this._register(_this._editor.onDidFocusEditorWidget(function () { return _this._updateFromFocus(); }));
        _this._register(_this._editor.onDidBlurEditorWidget(function () { return _this._updateFromFocus(); }));
        _this._register(_this._editor.onDidFocusEditorText(function () { return _this._updateFromFocus(); }));
        _this._register(_this._editor.onDidBlurEditorText(function () { return _this._updateFromFocus(); }));
        _this._register(_this._editor.onDidChangeModel(function () { return _this._updateFromModel(); }));
        _this._register(_this._editor.onDidChangeConfiguration(function () { return _this._updateFromModel(); }));
        _this._updateFromConfig();
        _this._updateFromSelection();
        _this._updateFromFocus();
        _this._updateFromModel();
        return _this;
    }
    EditorContextKeysManager.prototype._updateFromConfig = function () {
        var config = this._editor.getConfiguration();
        this._editorTabMovesFocus.set(config.tabFocusMode);
        this._editorReadonly.set(config.readOnly);
    };
    EditorContextKeysManager.prototype._updateFromSelection = function () {
        var selections = this._editor.getSelections();
        if (!selections) {
            this._hasMultipleSelections.reset();
            this._hasNonEmptySelection.reset();
        }
        else {
            this._hasMultipleSelections.set(selections.length > 1);
            this._hasNonEmptySelection.set(selections.some(function (s) { return !s.isEmpty(); }));
        }
    };
    EditorContextKeysManager.prototype._updateFromFocus = function () {
        this._editorFocus.set(this._editor.hasWidgetFocus() && !this._editor.isSimpleWidget);
        this._editorTextFocus.set(this._editor.hasTextFocus() && !this._editor.isSimpleWidget);
        this._textInputFocus.set(this._editor.hasTextFocus());
    };
    EditorContextKeysManager.prototype._updateFromModel = function () {
        var model = this._editor.getModel();
        this._canUndo.set(model && model.canUndo());
        this._canRedo.set(model && model.canRedo());
    };
    return EditorContextKeysManager;
}(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["a" /* Disposable */]));
var EditorModeContext = /** @class */ (function (_super) {
    __extends(EditorModeContext, _super);
    function EditorModeContext(editor, contextKeyService) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        _this._langId = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].languageId.bindTo(contextKeyService);
        _this._hasCompletionItemProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCompletionItemProvider.bindTo(contextKeyService);
        _this._hasCodeActionsProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCodeActionsProvider.bindTo(contextKeyService);
        _this._hasCodeLensProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCodeLensProvider.bindTo(contextKeyService);
        _this._hasDefinitionProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDefinitionProvider.bindTo(contextKeyService);
        _this._hasImplementationProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasImplementationProvider.bindTo(contextKeyService);
        _this._hasTypeDefinitionProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasTypeDefinitionProvider.bindTo(contextKeyService);
        _this._hasHoverProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasHoverProvider.bindTo(contextKeyService);
        _this._hasDocumentHighlightProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDocumentHighlightProvider.bindTo(contextKeyService);
        _this._hasDocumentSymbolProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDocumentSymbolProvider.bindTo(contextKeyService);
        _this._hasReferenceProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasReferenceProvider.bindTo(contextKeyService);
        _this._hasRenameProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasRenameProvider.bindTo(contextKeyService);
        _this._hasDocumentFormattingProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDocumentFormattingProvider.bindTo(contextKeyService);
        _this._hasDocumentSelectionFormattingProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDocumentSelectionFormattingProvider.bindTo(contextKeyService);
        _this._hasSignatureHelpProvider = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasSignatureHelpProvider.bindTo(contextKeyService);
        _this._isInWalkThrough = __WEBPACK_IMPORTED_MODULE_19__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.bindTo(contextKeyService);
        var update = function () { return _this._update(); };
        // update when model/mode changes
        _this._register(editor.onDidChangeModel(update));
        _this._register(editor.onDidChangeModelLanguage(update));
        // update when registries change
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["u" /* SuggestRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["a" /* CodeActionProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["c" /* CodeLensProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["e" /* DefinitionProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["n" /* ImplementationProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["z" /* TypeDefinitionProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["m" /* HoverProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["h" /* DocumentHighlightProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["j" /* DocumentSymbolProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["r" /* ReferenceProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["s" /* RenameProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["f" /* DocumentFormattingEditProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["i" /* DocumentRangeFormattingEditProviderRegistry */].onDidChange(update));
        _this._register(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["t" /* SignatureHelpProviderRegistry */].onDidChange(update));
        update();
        return _this;
    }
    EditorModeContext.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    EditorModeContext.prototype.reset = function () {
        this._langId.reset();
        this._hasCompletionItemProvider.reset();
        this._hasCodeActionsProvider.reset();
        this._hasCodeLensProvider.reset();
        this._hasDefinitionProvider.reset();
        this._hasImplementationProvider.reset();
        this._hasTypeDefinitionProvider.reset();
        this._hasHoverProvider.reset();
        this._hasDocumentHighlightProvider.reset();
        this._hasDocumentSymbolProvider.reset();
        this._hasReferenceProvider.reset();
        this._hasRenameProvider.reset();
        this._hasDocumentFormattingProvider.reset();
        this._hasDocumentSelectionFormattingProvider.reset();
        this._hasSignatureHelpProvider.reset();
        this._isInWalkThrough.reset();
    };
    EditorModeContext.prototype._update = function () {
        var model = this._editor.getModel();
        if (!model) {
            this.reset();
            return;
        }
        this._langId.set(model.getLanguageIdentifier().language);
        this._hasCompletionItemProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["u" /* SuggestRegistry */].has(model));
        this._hasCodeActionsProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["a" /* CodeActionProviderRegistry */].has(model));
        this._hasCodeLensProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["c" /* CodeLensProviderRegistry */].has(model));
        this._hasDefinitionProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["e" /* DefinitionProviderRegistry */].has(model));
        this._hasImplementationProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["n" /* ImplementationProviderRegistry */].has(model));
        this._hasTypeDefinitionProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["z" /* TypeDefinitionProviderRegistry */].has(model));
        this._hasHoverProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["m" /* HoverProviderRegistry */].has(model));
        this._hasDocumentHighlightProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["h" /* DocumentHighlightProviderRegistry */].has(model));
        this._hasDocumentSymbolProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["j" /* DocumentSymbolProviderRegistry */].has(model));
        this._hasReferenceProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["r" /* ReferenceProviderRegistry */].has(model));
        this._hasRenameProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["s" /* RenameProviderRegistry */].has(model));
        this._hasSignatureHelpProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["t" /* SignatureHelpProviderRegistry */].has(model));
        this._hasDocumentFormattingProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["f" /* DocumentFormattingEditProviderRegistry */].has(model) || __WEBPACK_IMPORTED_MODULE_20__common_modes_js__["i" /* DocumentRangeFormattingEditProviderRegistry */].has(model));
        this._hasDocumentSelectionFormattingProvider.set(__WEBPACK_IMPORTED_MODULE_20__common_modes_js__["i" /* DocumentRangeFormattingEditProviderRegistry */].has(model));
        this._isInWalkThrough.set(model.uri.scheme === __WEBPACK_IMPORTED_MODULE_21__base_common_network_js__["a" /* Schemas */].walkThroughSnippet);
    };
    return EditorModeContext;
}(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["a" /* Disposable */]));

var CodeEditorWidgetFocusTracker = /** @class */ (function (_super) {
    __extends(CodeEditorWidgetFocusTracker, _super);
    function CodeEditorWidgetFocusTracker(domElement) {
        var _this = _super.call(this) || this;
        _this._onChange = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]());
        _this.onChange = _this._onChange.event;
        _this._hasFocus = false;
        _this._domFocusTracker = _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["O" /* trackFocus */](domElement));
        _this._register(_this._domFocusTracker.onDidFocus(function () {
            _this._hasFocus = true;
            _this._onChange.fire(void 0);
        }));
        _this._register(_this._domFocusTracker.onDidBlur(function () {
            _this._hasFocus = false;
            _this._onChange.fire(void 0);
        }));
        return _this;
    }
    CodeEditorWidgetFocusTracker.prototype.hasFocus = function () {
        return this._hasFocus;
    };
    return CodeEditorWidgetFocusTracker;
}(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["a" /* Disposable */]));
var squigglyStart = encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' enable-background='new 0 0 6 3' height='3' width='6'><g fill='");
var squigglyEnd = encodeURIComponent("'><polygon points='5.5,0 2.5,3 1.1,3 4.1,0'/><polygon points='4,0 6,2 6,0.6 5.4,0'/><polygon points='0,2 1,3 2.4,3 0,0.6'/></g></svg>");
function getSquigglySVGData(color) {
    return squigglyStart + encodeURIComponent(color.toString()) + squigglyEnd;
}
var dotdotdotStart = encodeURIComponent("<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"3\" width=\"12\"><g fill=\"");
var dotdotdotEnd = encodeURIComponent("\"><circle cx=\"1\" cy=\"1\" r=\"1\"/><circle cx=\"5\" cy=\"1\" r=\"1\"/><circle cx=\"9\" cy=\"1\" r=\"1\"/></g></svg>");
function getDotDotDotSVGData(color) {
    return dotdotdotStart + encodeURIComponent(color.toString()) + dotdotdotEnd;
}
Object(__WEBPACK_IMPORTED_MODULE_26__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var errorBorderColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["h" /* editorErrorBorder */]);
    if (errorBorderColor) {
        collector.addRule(".monaco-editor ." + "squiggly-error" /* EditorErrorDecoration */ + " { border-bottom: 4px double " + errorBorderColor + "; }");
    }
    var errorForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["i" /* editorErrorForeground */]);
    if (errorForeground) {
        collector.addRule(".monaco-editor ." + "squiggly-error" /* EditorErrorDecoration */ + " { background: url(\"data:image/svg+xml," + getSquigglySVGData(errorForeground) + "\") repeat-x bottom left; }");
    }
    var warningBorderColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["v" /* editorWarningBorder */]);
    if (warningBorderColor) {
        collector.addRule(".monaco-editor ." + "squiggly-warning" /* EditorWarningDecoration */ + " { border-bottom: 4px double " + warningBorderColor + "; }");
    }
    var warningForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["w" /* editorWarningForeground */]);
    if (warningForeground) {
        collector.addRule(".monaco-editor ." + "squiggly-warning" /* EditorWarningDecoration */ + " { background: url(\"data:image/svg+xml," + getSquigglySVGData(warningForeground) + "\") repeat-x bottom left; }");
    }
    var infoBorderColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["m" /* editorInfoBorder */]);
    if (infoBorderColor) {
        collector.addRule(".monaco-editor ." + "squiggly-info" /* EditorInfoDecoration */ + " { border-bottom: 4px double " + infoBorderColor + "; }");
    }
    var infoForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["n" /* editorInfoForeground */]);
    if (infoForeground) {
        collector.addRule(".monaco-editor ." + "squiggly-info" /* EditorInfoDecoration */ + " { background: url(\"data:image/svg+xml," + getSquigglySVGData(infoForeground) + "\") repeat-x bottom left; }");
    }
    var hintBorderColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["j" /* editorHintBorder */]);
    if (hintBorderColor) {
        collector.addRule(".monaco-editor ." + "squiggly-hint" /* EditorHintDecoration */ + " { border-bottom: 2px dotted " + hintBorderColor + "; }");
    }
    var hintForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["k" /* editorHintForeground */]);
    if (hintForeground) {
        collector.addRule(".monaco-editor ." + "squiggly-hint" /* EditorHintDecoration */ + " { background: url(\"data:image/svg+xml," + getDotDotDotSVGData(hintForeground) + "\") no-repeat bottom left; }");
    }
    var unnecessaryForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["u" /* editorUnnecessaryCodeOpacity */]);
    if (unnecessaryForeground) {
        collector.addRule("." + SHOW_UNUSED_ENABLED_CLASS + " .monaco-editor ." + "squiggly-inline-unnecessary" /* EditorUnnecessaryInlineDecoration */ + " { opacity: " + unnecessaryForeground.rgba.a + "; will-change: opacity; }"); // TODO@Ben: 'will-change: opacity' is a workaround for https://github.com/Microsoft/vscode/issues/52196
    }
    var unnecessaryBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_30__common_view_editorColorRegistry_js__["t" /* editorUnnecessaryCodeBorder */]);
    if (unnecessaryBorder) {
        collector.addRule("." + SHOW_UNUSED_ENABLED_CLASS + " .monaco-editor ." + "squiggly-unnecessary" /* EditorUnnecessaryDecoration */ + " { border-bottom: 2px dashed " + unnecessaryBorder + "; }");
    }
});


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceCollection; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var ServiceCollection = /** @class */ (function () {
    function ServiceCollection() {
        var entries = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            entries[_i] = arguments[_i];
        }
        this._entries = new Map();
        for (var _a = 0, entries_1 = entries; _a < entries_1.length; _a++) {
            var _b = entries_1[_a], id = _b[0], service = _b[1];
            this.set(id, service);
        }
    }
    ServiceCollection.prototype.set = function (id, instanceOrDescriptor) {
        var result = this._entries.get(id);
        this._entries.set(id, instanceOrDescriptor);
        return result;
    };
    ServiceCollection.prototype.forEach = function (callback) {
        this._entries.forEach(function (value, key) { return callback(key, value); });
    };
    ServiceCollection.prototype.has = function (id) {
        return this._entries.has(id);
    };
    ServiceCollection.prototype.get = function (id) {
        return this._entries.get(id);
    };
    return ServiceCollection;
}());



/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderLineInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharacterMapping; });
/* unused harmony export RenderLineOutput */
/* harmony export (immutable) */ __webpack_exports__["c"] = renderViewLine;
/* unused harmony export RenderLineOutput2 */
/* harmony export (immutable) */ __webpack_exports__["d"] = renderViewLine2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lineDecorations_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_stringBuilder_js__ = __webpack_require__(152);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var LinePart = /** @class */ (function () {
    function LinePart(endIndex, type) {
        this.endIndex = endIndex;
        this.type = type;
    }
    return LinePart;
}());
var RenderLineInput = /** @class */ (function () {
    function RenderLineInput(useMonospaceOptimizations, lineContent, continuesWithWrappedLine, isBasicASCII, containsRTL, fauxIndentLength, lineTokens, lineDecorations, tabSize, spaceWidth, stopRenderingLineAfter, renderWhitespace, renderControlCharacters, fontLigatures) {
        this.useMonospaceOptimizations = useMonospaceOptimizations;
        this.lineContent = lineContent;
        this.continuesWithWrappedLine = continuesWithWrappedLine;
        this.isBasicASCII = isBasicASCII;
        this.containsRTL = containsRTL;
        this.fauxIndentLength = fauxIndentLength;
        this.lineTokens = lineTokens;
        this.lineDecorations = lineDecorations;
        this.tabSize = tabSize;
        this.spaceWidth = spaceWidth;
        this.stopRenderingLineAfter = stopRenderingLineAfter;
        this.renderWhitespace = (renderWhitespace === 'all'
            ? 2 /* All */
            : renderWhitespace === 'boundary'
                ? 1 /* Boundary */
                : 0 /* None */);
        this.renderControlCharacters = renderControlCharacters;
        this.fontLigatures = fontLigatures;
    }
    RenderLineInput.prototype.equals = function (other) {
        return (this.useMonospaceOptimizations === other.useMonospaceOptimizations
            && this.lineContent === other.lineContent
            && this.continuesWithWrappedLine === other.continuesWithWrappedLine
            && this.isBasicASCII === other.isBasicASCII
            && this.containsRTL === other.containsRTL
            && this.fauxIndentLength === other.fauxIndentLength
            && this.tabSize === other.tabSize
            && this.spaceWidth === other.spaceWidth
            && this.stopRenderingLineAfter === other.stopRenderingLineAfter
            && this.renderWhitespace === other.renderWhitespace
            && this.renderControlCharacters === other.renderControlCharacters
            && this.fontLigatures === other.fontLigatures
            && __WEBPACK_IMPORTED_MODULE_0__lineDecorations_js__["a" /* LineDecoration */].equalsArr(this.lineDecorations, other.lineDecorations)
            && this.lineTokens.equals(other.lineTokens));
    };
    return RenderLineInput;
}());

/**
 * Provides a both direction mapping between a line's character and its rendered position.
 */
var CharacterMapping = /** @class */ (function () {
    function CharacterMapping(length, partCount) {
        this.length = length;
        this._data = new Uint32Array(this.length);
        this._absoluteOffsets = new Uint32Array(this.length);
    }
    CharacterMapping.getPartIndex = function (partData) {
        return (partData & 4294901760 /* PART_INDEX_MASK */) >>> 16 /* PART_INDEX_OFFSET */;
    };
    CharacterMapping.getCharIndex = function (partData) {
        return (partData & 65535 /* CHAR_INDEX_MASK */) >>> 0 /* CHAR_INDEX_OFFSET */;
    };
    CharacterMapping.prototype.setPartData = function (charOffset, partIndex, charIndex, partAbsoluteOffset) {
        var partData = ((partIndex << 16 /* PART_INDEX_OFFSET */)
            | (charIndex << 0 /* CHAR_INDEX_OFFSET */)) >>> 0;
        this._data[charOffset] = partData;
        this._absoluteOffsets[charOffset] = partAbsoluteOffset + charIndex;
    };
    CharacterMapping.prototype.getAbsoluteOffsets = function () {
        return this._absoluteOffsets;
    };
    CharacterMapping.prototype.charOffsetToPartData = function (charOffset) {
        if (this.length === 0) {
            return 0;
        }
        if (charOffset < 0) {
            return this._data[0];
        }
        if (charOffset >= this.length) {
            return this._data[this.length - 1];
        }
        return this._data[charOffset];
    };
    CharacterMapping.prototype.partDataToCharOffset = function (partIndex, partLength, charIndex) {
        if (this.length === 0) {
            return 0;
        }
        var searchEntry = ((partIndex << 16 /* PART_INDEX_OFFSET */)
            | (charIndex << 0 /* CHAR_INDEX_OFFSET */)) >>> 0;
        var min = 0;
        var max = this.length - 1;
        while (min + 1 < max) {
            var mid = ((min + max) >>> 1);
            var midEntry = this._data[mid];
            if (midEntry === searchEntry) {
                return mid;
            }
            else if (midEntry > searchEntry) {
                max = mid;
            }
            else {
                min = mid;
            }
        }
        if (min === max) {
            return min;
        }
        var minEntry = this._data[min];
        var maxEntry = this._data[max];
        if (minEntry === searchEntry) {
            return min;
        }
        if (maxEntry === searchEntry) {
            return max;
        }
        var minPartIndex = CharacterMapping.getPartIndex(minEntry);
        var minCharIndex = CharacterMapping.getCharIndex(minEntry);
        var maxPartIndex = CharacterMapping.getPartIndex(maxEntry);
        var maxCharIndex;
        if (minPartIndex !== maxPartIndex) {
            // sitting between parts
            maxCharIndex = partLength;
        }
        else {
            maxCharIndex = CharacterMapping.getCharIndex(maxEntry);
        }
        var minEntryDistance = charIndex - minCharIndex;
        var maxEntryDistance = maxCharIndex - charIndex;
        if (minEntryDistance <= maxEntryDistance) {
            return min;
        }
        return max;
    };
    return CharacterMapping;
}());

var RenderLineOutput = /** @class */ (function () {
    function RenderLineOutput(characterMapping, containsRTL, containsForeignElements) {
        this.characterMapping = characterMapping;
        this.containsRTL = containsRTL;
        this.containsForeignElements = containsForeignElements;
    }
    return RenderLineOutput;
}());

function renderViewLine(input, sb) {
    if (input.lineContent.length === 0) {
        var containsForeignElements = 0 /* None */;
        // This is basically for IE's hit test to work
        var content = '<span><span>\u00a0</span></span>';
        if (input.lineDecorations.length > 0) {
            // This line is empty, but it contains inline decorations
            var classNames = [];
            for (var i = 0, len = input.lineDecorations.length; i < len; i++) {
                var lineDecoration = input.lineDecorations[i];
                if (lineDecoration.type === 1 /* Before */) {
                    classNames.push(input.lineDecorations[i].className);
                    containsForeignElements |= 1 /* Before */;
                }
                if (lineDecoration.type === 2 /* After */) {
                    classNames.push(input.lineDecorations[i].className);
                    containsForeignElements |= 2 /* After */;
                }
            }
            if (containsForeignElements !== 0 /* None */) {
                content = "<span><span class=\"" + classNames.join(' ') + "\"></span></span>";
            }
        }
        sb.appendASCIIString(content);
        return new RenderLineOutput(new CharacterMapping(0, 0), false, containsForeignElements);
    }
    return _renderLine(resolveRenderLineInput(input), sb);
}
var RenderLineOutput2 = /** @class */ (function () {
    function RenderLineOutput2(characterMapping, html, containsRTL, containsForeignElements) {
        this.characterMapping = characterMapping;
        this.html = html;
        this.containsRTL = containsRTL;
        this.containsForeignElements = containsForeignElements;
    }
    return RenderLineOutput2;
}());

function renderViewLine2(input) {
    var sb = Object(__WEBPACK_IMPORTED_MODULE_2__core_stringBuilder_js__["a" /* createStringBuilder */])(10000);
    var out = renderViewLine(input, sb);
    return new RenderLineOutput2(out.characterMapping, sb.build(), out.containsRTL, out.containsForeignElements);
}
var ResolvedRenderLineInput = /** @class */ (function () {
    function ResolvedRenderLineInput(fontIsMonospace, lineContent, len, isOverflowing, parts, containsForeignElements, tabSize, containsRTL, spaceWidth, renderWhitespace, renderControlCharacters) {
        this.fontIsMonospace = fontIsMonospace;
        this.lineContent = lineContent;
        this.len = len;
        this.isOverflowing = isOverflowing;
        this.parts = parts;
        this.containsForeignElements = containsForeignElements;
        this.tabSize = tabSize;
        this.containsRTL = containsRTL;
        this.spaceWidth = spaceWidth;
        this.renderWhitespace = renderWhitespace;
        this.renderControlCharacters = renderControlCharacters;
        //
    }
    return ResolvedRenderLineInput;
}());
function resolveRenderLineInput(input) {
    var useMonospaceOptimizations = input.useMonospaceOptimizations;
    var lineContent = input.lineContent;
    var isOverflowing;
    var len;
    if (input.stopRenderingLineAfter !== -1 && input.stopRenderingLineAfter < lineContent.length) {
        isOverflowing = true;
        len = input.stopRenderingLineAfter;
    }
    else {
        isOverflowing = false;
        len = lineContent.length;
    }
    var tokens = transformAndRemoveOverflowing(input.lineTokens, input.fauxIndentLength, len);
    if (input.renderWhitespace === 2 /* All */ || input.renderWhitespace === 1 /* Boundary */) {
        tokens = _applyRenderWhitespace(lineContent, len, input.continuesWithWrappedLine, tokens, input.fauxIndentLength, input.tabSize, useMonospaceOptimizations, input.renderWhitespace === 1 /* Boundary */);
    }
    var containsForeignElements = 0 /* None */;
    if (input.lineDecorations.length > 0) {
        for (var i = 0, len_1 = input.lineDecorations.length; i < len_1; i++) {
            var lineDecoration = input.lineDecorations[i];
            if (lineDecoration.type === 3 /* RegularAffectingLetterSpacing */) {
                // Pretend there are foreign elements... although not 100% accurate.
                containsForeignElements |= 1 /* Before */;
            }
            else if (lineDecoration.type === 1 /* Before */) {
                containsForeignElements |= 1 /* Before */;
            }
            else if (lineDecoration.type === 2 /* After */) {
                containsForeignElements |= 2 /* After */;
            }
        }
        tokens = _applyInlineDecorations(lineContent, len, tokens, input.lineDecorations);
    }
    if (input.isBasicASCII && !input.fontLigatures) {
        tokens = splitLargeTokens(lineContent, tokens);
    }
    return new ResolvedRenderLineInput(useMonospaceOptimizations, lineContent, len, isOverflowing, tokens, containsForeignElements, input.tabSize, input.containsRTL, input.spaceWidth, input.renderWhitespace, input.renderControlCharacters);
}
/**
 * In the rendering phase, characters are always looped until token.endIndex.
 * Ensure that all tokens end before `len` and the last one ends precisely at `len`.
 */
function transformAndRemoveOverflowing(tokens, fauxIndentLength, len) {
    var result = [], resultLen = 0;
    // The faux indent part of the line should have no token type
    if (fauxIndentLength > 0) {
        result[resultLen++] = new LinePart(fauxIndentLength, '');
    }
    for (var tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++) {
        var endIndex = tokens.getEndOffset(tokenIndex);
        if (endIndex <= fauxIndentLength) {
            // The faux indent part of the line should have no token type
            continue;
        }
        var type = tokens.getClassName(tokenIndex);
        if (endIndex >= len) {
            result[resultLen++] = new LinePart(len, type);
            break;
        }
        result[resultLen++] = new LinePart(endIndex, type);
    }
    return result;
}
/**
 * See https://github.com/Microsoft/vscode/issues/6885.
 * It appears that having very large spans causes very slow reading of character positions.
 * So here we try to avoid that.
 */
function splitLargeTokens(lineContent, tokens) {
    var lastTokenEndIndex = 0;
    var result = [], resultLen = 0;
    for (var i = 0, len = tokens.length; i < len; i++) {
        var token = tokens[i];
        var tokenEndIndex = token.endIndex;
        var diff = (tokenEndIndex - lastTokenEndIndex);
        if (diff > 50 /* LongToken */) {
            var tokenType = token.type;
            var piecesCount = Math.ceil(diff / 50 /* LongToken */);
            for (var j = 1; j < piecesCount; j++) {
                var pieceEndIndex = lastTokenEndIndex + (j * 50 /* LongToken */);
                result[resultLen++] = new LinePart(pieceEndIndex, tokenType);
            }
            result[resultLen++] = new LinePart(tokenEndIndex, tokenType);
        }
        else {
            result[resultLen++] = token;
        }
        lastTokenEndIndex = tokenEndIndex;
    }
    return result;
}
/**
 * Whitespace is rendered by "replacing" tokens with a special-purpose `vs-whitespace` type that is later recognized in the rendering phase.
 * Moreover, a token is created for every visual indent because on some fonts the glyphs used for rendering whitespace (&rarr; or &middot;) do not have the same width as &nbsp;.
 * The rendering phase will generate `style="width:..."` for these tokens.
 */
function _applyRenderWhitespace(lineContent, len, continuesWithWrappedLine, tokens, fauxIndentLength, tabSize, useMonospaceOptimizations, onlyBoundary) {
    var result = [], resultLen = 0;
    var tokenIndex = 0;
    var tokenType = tokens[tokenIndex].type;
    var tokenEndIndex = tokens[tokenIndex].endIndex;
    var firstNonWhitespaceIndex = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["firstNonWhitespaceIndex"](lineContent);
    var lastNonWhitespaceIndex;
    if (firstNonWhitespaceIndex === -1) {
        // The entire line is whitespace
        firstNonWhitespaceIndex = len;
        lastNonWhitespaceIndex = len;
    }
    else {
        lastNonWhitespaceIndex = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["lastNonWhitespaceIndex"](lineContent);
    }
    var tmpIndent = 0;
    for (var charIndex = 0; charIndex < fauxIndentLength; charIndex++) {
        var chCode = lineContent.charCodeAt(charIndex);
        if (chCode === 9 /* Tab */) {
            tmpIndent = tabSize;
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isFullWidthCharacter"](chCode)) {
            tmpIndent += 2;
        }
        else {
            tmpIndent++;
        }
    }
    tmpIndent = tmpIndent % tabSize;
    var wasInWhitespace = false;
    for (var charIndex = fauxIndentLength; charIndex < len; charIndex++) {
        var chCode = lineContent.charCodeAt(charIndex);
        var isInWhitespace = void 0;
        if (charIndex < firstNonWhitespaceIndex || charIndex > lastNonWhitespaceIndex) {
            // in leading or trailing whitespace
            isInWhitespace = true;
        }
        else if (chCode === 9 /* Tab */) {
            // a tab character is rendered both in all and boundary cases
            isInWhitespace = true;
        }
        else if (chCode === 32 /* Space */) {
            // hit a space character
            if (onlyBoundary) {
                // rendering only boundary whitespace
                if (wasInWhitespace) {
                    isInWhitespace = true;
                }
                else {
                    var nextChCode = (charIndex + 1 < len ? lineContent.charCodeAt(charIndex + 1) : 0 /* Null */);
                    isInWhitespace = (nextChCode === 32 /* Space */ || nextChCode === 9 /* Tab */);
                }
            }
            else {
                isInWhitespace = true;
            }
        }
        else {
            isInWhitespace = false;
        }
        if (wasInWhitespace) {
            // was in whitespace token
            if (!isInWhitespace || (!useMonospaceOptimizations && tmpIndent >= tabSize)) {
                // leaving whitespace token or entering a new indent
                result[resultLen++] = new LinePart(charIndex, 'vs-whitespace');
                tmpIndent = tmpIndent % tabSize;
            }
        }
        else {
            // was in regular token
            if (charIndex === tokenEndIndex || (isInWhitespace && charIndex > fauxIndentLength)) {
                result[resultLen++] = new LinePart(charIndex, tokenType);
                tmpIndent = tmpIndent % tabSize;
            }
        }
        if (chCode === 9 /* Tab */) {
            tmpIndent = tabSize;
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isFullWidthCharacter"](chCode)) {
            tmpIndent += 2;
        }
        else {
            tmpIndent++;
        }
        wasInWhitespace = isInWhitespace;
        if (charIndex === tokenEndIndex) {
            tokenIndex++;
            tokenType = tokens[tokenIndex].type;
            tokenEndIndex = tokens[tokenIndex].endIndex;
        }
    }
    var generateWhitespace = false;
    if (wasInWhitespace) {
        // was in whitespace token
        if (continuesWithWrappedLine && onlyBoundary) {
            var lastCharCode = (len > 0 ? lineContent.charCodeAt(len - 1) : 0 /* Null */);
            var prevCharCode = (len > 1 ? lineContent.charCodeAt(len - 2) : 0 /* Null */);
            var isSingleTrailingSpace = (lastCharCode === 32 /* Space */ && (prevCharCode !== 32 /* Space */ && prevCharCode !== 9 /* Tab */));
            if (!isSingleTrailingSpace) {
                generateWhitespace = true;
            }
        }
        else {
            generateWhitespace = true;
        }
    }
    result[resultLen++] = new LinePart(len, generateWhitespace ? 'vs-whitespace' : tokenType);
    return result;
}
/**
 * Inline decorations are "merged" on top of tokens.
 * Special care must be taken when multiple inline decorations are at play and they overlap.
 */
function _applyInlineDecorations(lineContent, len, tokens, _lineDecorations) {
    _lineDecorations.sort(__WEBPACK_IMPORTED_MODULE_0__lineDecorations_js__["a" /* LineDecoration */].compare);
    var lineDecorations = __WEBPACK_IMPORTED_MODULE_0__lineDecorations_js__["b" /* LineDecorationsNormalizer */].normalize(lineContent, _lineDecorations);
    var lineDecorationsLen = lineDecorations.length;
    var lineDecorationIndex = 0;
    var result = [], resultLen = 0, lastResultEndIndex = 0;
    for (var tokenIndex = 0, len_2 = tokens.length; tokenIndex < len_2; tokenIndex++) {
        var token = tokens[tokenIndex];
        var tokenEndIndex = token.endIndex;
        var tokenType = token.type;
        while (lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset < tokenEndIndex) {
            var lineDecoration = lineDecorations[lineDecorationIndex];
            if (lineDecoration.startOffset > lastResultEndIndex) {
                lastResultEndIndex = lineDecoration.startOffset;
                result[resultLen++] = new LinePart(lastResultEndIndex, tokenType);
            }
            if (lineDecoration.endOffset + 1 <= tokenEndIndex) {
                // This line decoration ends before this token ends
                lastResultEndIndex = lineDecoration.endOffset + 1;
                result[resultLen++] = new LinePart(lastResultEndIndex, tokenType + ' ' + lineDecoration.className);
                lineDecorationIndex++;
            }
            else {
                // This line decoration continues on to the next token
                lastResultEndIndex = tokenEndIndex;
                result[resultLen++] = new LinePart(lastResultEndIndex, tokenType + ' ' + lineDecoration.className);
                break;
            }
        }
        if (tokenEndIndex > lastResultEndIndex) {
            lastResultEndIndex = tokenEndIndex;
            result[resultLen++] = new LinePart(lastResultEndIndex, tokenType);
        }
    }
    var lastTokenEndIndex = tokens[tokens.length - 1].endIndex;
    if (lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset === lastTokenEndIndex) {
        var classNames = [];
        while (lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset === lastTokenEndIndex) {
            classNames.push(lineDecorations[lineDecorationIndex].className);
            lineDecorationIndex++;
        }
        result[resultLen++] = new LinePart(lastResultEndIndex, classNames.join(' '));
    }
    return result;
}
/**
 * This function is on purpose not split up into multiple functions to allow runtime type inference (i.e. performance reasons).
 * Notice how all the needed data is fully resolved and passed in (i.e. no other calls).
 */
function _renderLine(input, sb) {
    var fontIsMonospace = input.fontIsMonospace;
    var containsForeignElements = input.containsForeignElements;
    var lineContent = input.lineContent;
    var len = input.len;
    var isOverflowing = input.isOverflowing;
    var parts = input.parts;
    var tabSize = input.tabSize;
    var containsRTL = input.containsRTL;
    var spaceWidth = input.spaceWidth;
    var renderWhitespace = input.renderWhitespace;
    var renderControlCharacters = input.renderControlCharacters;
    var characterMapping = new CharacterMapping(len + 1, parts.length);
    var charIndex = 0;
    var tabsCharDelta = 0;
    var charOffsetInPart = 0;
    var prevPartContentCnt = 0;
    var partAbsoluteOffset = 0;
    sb.appendASCIIString('<span>');
    for (var partIndex = 0, tokensLen = parts.length; partIndex < tokensLen; partIndex++) {
        partAbsoluteOffset += prevPartContentCnt;
        var part = parts[partIndex];
        var partEndIndex = part.endIndex;
        var partType = part.type;
        var partRendersWhitespace = (renderWhitespace !== 0 /* None */ && (partType.indexOf('vs-whitespace') >= 0));
        charOffsetInPart = 0;
        sb.appendASCIIString('<span class="');
        sb.appendASCIIString(partType);
        sb.appendASCII(34 /* DoubleQuote */);
        if (partRendersWhitespace) {
            var partContentCnt = 0;
            {
                var _charIndex = charIndex;
                var _tabsCharDelta = tabsCharDelta;
                for (; _charIndex < partEndIndex; _charIndex++) {
                    var charCode = lineContent.charCodeAt(_charIndex);
                    if (charCode === 9 /* Tab */) {
                        var insertSpacesCount = tabSize - (_charIndex + _tabsCharDelta) % tabSize;
                        _tabsCharDelta += insertSpacesCount - 1;
                        partContentCnt += insertSpacesCount;
                    }
                    else {
                        // must be CharCode.Space
                        partContentCnt++;
                    }
                }
            }
            if (!fontIsMonospace) {
                var partIsOnlyWhitespace = (partType === 'vs-whitespace');
                if (partIsOnlyWhitespace || !containsForeignElements) {
                    sb.appendASCIIString(' style="width:');
                    sb.appendASCIIString(String(spaceWidth * partContentCnt));
                    sb.appendASCIIString('px"');
                }
            }
            sb.appendASCII(62 /* GreaterThan */);
            for (; charIndex < partEndIndex; charIndex++) {
                characterMapping.setPartData(charIndex, partIndex, charOffsetInPart, partAbsoluteOffset);
                var charCode = lineContent.charCodeAt(charIndex);
                if (charCode === 9 /* Tab */) {
                    var insertSpacesCount = tabSize - (charIndex + tabsCharDelta) % tabSize;
                    tabsCharDelta += insertSpacesCount - 1;
                    charOffsetInPart += insertSpacesCount - 1;
                    if (insertSpacesCount > 0) {
                        if (insertSpacesCount > 1) {
                            sb.write1(0x2192); // RIGHTWARDS ARROW
                        }
                        else {
                            sb.write1(0xffeb); // HALFWIDTH RIGHTWARDS ARROW
                        }
                        insertSpacesCount--;
                    }
                    while (insertSpacesCount > 0) {
                        sb.write1(0xA0); // &nbsp;
                        insertSpacesCount--;
                    }
                }
                else {
                    // must be CharCode.Space
                    sb.write1(0xb7); // &middot;
                }
                charOffsetInPart++;
            }
            prevPartContentCnt = partContentCnt;
        }
        else {
            var partContentCnt = 0;
            if (containsRTL) {
                sb.appendASCIIString(' dir="ltr"');
            }
            sb.appendASCII(62 /* GreaterThan */);
            for (; charIndex < partEndIndex; charIndex++) {
                characterMapping.setPartData(charIndex, partIndex, charOffsetInPart, partAbsoluteOffset);
                var charCode = lineContent.charCodeAt(charIndex);
                switch (charCode) {
                    case 9 /* Tab */:
                        var insertSpacesCount = tabSize - (charIndex + tabsCharDelta) % tabSize;
                        tabsCharDelta += insertSpacesCount - 1;
                        charOffsetInPart += insertSpacesCount - 1;
                        while (insertSpacesCount > 0) {
                            sb.write1(0xA0); // &nbsp;
                            partContentCnt++;
                            insertSpacesCount--;
                        }
                        break;
                    case 32 /* Space */:
                        sb.write1(0xA0); // &nbsp;
                        partContentCnt++;
                        break;
                    case 60 /* LessThan */:
                        sb.appendASCIIString('&lt;');
                        partContentCnt++;
                        break;
                    case 62 /* GreaterThan */:
                        sb.appendASCIIString('&gt;');
                        partContentCnt++;
                        break;
                    case 38 /* Ampersand */:
                        sb.appendASCIIString('&amp;');
                        partContentCnt++;
                        break;
                    case 0 /* Null */:
                        sb.appendASCIIString('&#00;');
                        partContentCnt++;
                        break;
                    case 65279 /* UTF8_BOM */:
                    case 8232 /* LINE_SEPARATOR_2028 */:
                        sb.write1(0xfffd);
                        partContentCnt++;
                        break;
                    default:
                        if (__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isFullWidthCharacter"](charCode)) {
                            tabsCharDelta++;
                        }
                        if (renderControlCharacters && charCode < 32) {
                            sb.write1(9216 + charCode);
                            partContentCnt++;
                        }
                        else {
                            sb.write1(charCode);
                            partContentCnt++;
                        }
                }
                charOffsetInPart++;
            }
            prevPartContentCnt = partContentCnt;
        }
        sb.appendASCIIString('</span>');
    }
    // When getting client rects for the last character, we will position the
    // text range at the end of the span, insteaf of at the beginning of next span
    characterMapping.setPartData(len, parts.length - 1, charOffsetInPart, partAbsoluteOffset);
    if (isOverflowing) {
        sb.appendASCIIString('<span>&hellip;</span>');
    }
    sb.appendASCIIString('</span>');
    return new RenderLineOutput(characterMapping, containsRTL, containsForeignElements);
}


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = computeStyles;
/* unused harmony export attachStyler */
/* harmony export (immutable) */ __webpack_exports__["a"] = attachBadgeStyler;
/* harmony export (immutable) */ __webpack_exports__["c"] = attachQuickOpenStyler;
/* harmony export (immutable) */ __webpack_exports__["b"] = attachListStyler;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultListStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_objects_js__ = __webpack_require__(26);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



function computeStyles(theme, styleMap) {
    var styles = Object.create(null);
    for (var key in styleMap) {
        var value = styleMap[key];
        if (typeof value === 'string') {
            styles[key] = theme.getColor(value);
        }
        else if (typeof value === 'function') {
            styles[key] = value(theme);
        }
    }
    return styles;
}
function attachStyler(themeService, styleMap, widgetOrCallback) {
    function applyStyles(theme) {
        var styles = computeStyles(themeService.getTheme(), styleMap);
        if (typeof widgetOrCallback === 'function') {
            widgetOrCallback(styles);
        }
        else {
            widgetOrCallback.style(styles);
        }
    }
    applyStyles(themeService.getTheme());
    return themeService.onThemeChange(applyStyles);
}
function attachBadgeStyler(widget, themeService, style) {
    return attachStyler(themeService, {
        badgeBackground: (style && style.badgeBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["c" /* badgeBackground */],
        badgeForeground: (style && style.badgeForeground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["d" /* badgeForeground */],
        badgeBorder: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["e" /* contrastBorder */]
    }, widget);
}
function attachQuickOpenStyler(widget, themeService, style) {
    return attachStyler(themeService, {
        foreground: (style && style.foreground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["I" /* foreground */],
        background: (style && style.background) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["n" /* editorBackground */],
        borderColor: style && style.borderColor || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["e" /* contrastBorder */],
        widgetShadow: style && style.widgetShadow || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_17" /* widgetShadow */],
        progressBarBackground: style && style.progressBarBackground || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_9" /* progressBarBackground */],
        pickerGroupForeground: style && style.pickerGroupForeground || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_8" /* pickerGroupForeground */],
        pickerGroupBorder: style && style.pickerGroupBorder || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_7" /* pickerGroupBorder */],
        inputBackground: (style && style.inputBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["K" /* inputBackground */],
        inputForeground: (style && style.inputForeground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["M" /* inputForeground */],
        inputBorder: (style && style.inputBorder) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["L" /* inputBorder */],
        inputValidationInfoBorder: (style && style.inputValidationInfoBorder) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["Q" /* inputValidationInfoBorder */],
        inputValidationInfoBackground: (style && style.inputValidationInfoBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["P" /* inputValidationInfoBackground */],
        inputValidationWarningBorder: (style && style.inputValidationWarningBorder) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["S" /* inputValidationWarningBorder */],
        inputValidationWarningBackground: (style && style.inputValidationWarningBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["R" /* inputValidationWarningBackground */],
        inputValidationErrorBorder: (style && style.inputValidationErrorBorder) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["O" /* inputValidationErrorBorder */],
        inputValidationErrorBackground: (style && style.inputValidationErrorBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["N" /* inputValidationErrorBackground */],
        listFocusBackground: (style && style.listFocusBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["W" /* listFocusBackground */],
        listFocusForeground: (style && style.listFocusForeground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["X" /* listFocusForeground */],
        listActiveSelectionBackground: (style && style.listActiveSelectionBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["T" /* listActiveSelectionBackground */],
        listActiveSelectionForeground: (style && style.listActiveSelectionForeground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["U" /* listActiveSelectionForeground */],
        listFocusAndSelectionBackground: style && style.listFocusAndSelectionBackground || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["T" /* listActiveSelectionBackground */],
        listFocusAndSelectionForeground: (style && style.listFocusAndSelectionForeground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["U" /* listActiveSelectionForeground */],
        listInactiveSelectionBackground: (style && style.listInactiveSelectionBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_2" /* listInactiveSelectionBackground */],
        listInactiveSelectionForeground: (style && style.listInactiveSelectionForeground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_3" /* listInactiveSelectionForeground */],
        listInactiveFocusBackground: (style && style.listInactiveFocusBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_1" /* listInactiveFocusBackground */],
        listHoverBackground: (style && style.listHoverBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["Z" /* listHoverBackground */],
        listHoverForeground: (style && style.listHoverForeground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_0" /* listHoverForeground */],
        listDropBackground: (style && style.listDropBackground) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["V" /* listDropBackground */],
        listFocusOutline: (style && style.listFocusOutline) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["b" /* activeContrastBorder */],
        listSelectionOutline: (style && style.listSelectionOutline) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["b" /* activeContrastBorder */],
        listHoverOutline: (style && style.listHoverOutline) || __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["b" /* activeContrastBorder */]
    }, widget);
}
function attachListStyler(widget, themeService, overrides) {
    return attachStyler(themeService, Object(__WEBPACK_IMPORTED_MODULE_1__base_common_objects_js__["g" /* mixin */])(overrides || Object.create(null), defaultListStyles, false), widget);
}
var defaultListStyles = {
    listFocusBackground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["W" /* listFocusBackground */],
    listFocusForeground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["X" /* listFocusForeground */],
    listActiveSelectionBackground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["T" /* listActiveSelectionBackground */],
    listActiveSelectionForeground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["U" /* listActiveSelectionForeground */],
    listFocusAndSelectionBackground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["T" /* listActiveSelectionBackground */],
    listFocusAndSelectionForeground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["U" /* listActiveSelectionForeground */],
    listInactiveSelectionBackground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_2" /* listInactiveSelectionBackground */],
    listInactiveSelectionForeground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_3" /* listInactiveSelectionForeground */],
    listInactiveFocusBackground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_1" /* listInactiveFocusBackground */],
    listHoverBackground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["Z" /* listHoverBackground */],
    listHoverForeground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["_0" /* listHoverForeground */],
    listDropBackground: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["V" /* listDropBackground */],
    listFocusOutline: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["b" /* activeContrastBorder */],
    listSelectionOutline: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["b" /* activeContrastBorder */],
    listHoverOutline: __WEBPACK_IMPORTED_MODULE_0__colorRegistry_js__["b" /* activeContrastBorder */]
};


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mode; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var Mode;
(function (Mode) {
    Mode[Mode["PREVIEW"] = 0] = "PREVIEW";
    Mode[Mode["OPEN"] = 1] = "OPEN";
    Mode[Mode["OPEN_IN_BACKGROUND"] = 2] = "OPEN_IN_BACKGROUND";
})(Mode || (Mode = {}));


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export or */
/* unused harmony export matchesPrefix */
/* unused harmony export matchesContiguousSubString */
/* unused harmony export matchesSubString */
/* unused harmony export isUpper */
/* unused harmony export matchesCamelCase */
/* unused harmony export fuzzyContiguousFilter */
/* harmony export (immutable) */ __webpack_exports__["e"] = matchesFuzzy;
/* harmony export (immutable) */ __webpack_exports__["a"] = anyScore;
/* harmony export (immutable) */ __webpack_exports__["b"] = createMatches;
/* harmony export (immutable) */ __webpack_exports__["c"] = fuzzyScore;
/* harmony export (immutable) */ __webpack_exports__["d"] = fuzzyScoreGracefulAggressive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(66);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



// Combined filters
/**
 * @returns A filter which combines the provided set
 * of filters with an or. The *first* filters that
 * matches defined the return value of the returned
 * filter.
 */
function or() {
    var filter = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        filter[_i] = arguments[_i];
    }
    return function (word, wordToMatchAgainst) {
        for (var i = 0, len = filter.length; i < len; i++) {
            var match = filter[i](word, wordToMatchAgainst);
            if (match) {
                return match;
            }
        }
        return null;
    };
}
var matchesPrefix = _matchesPrefix.bind(undefined, true);
function _matchesPrefix(ignoreCase, word, wordToMatchAgainst) {
    if (!wordToMatchAgainst || wordToMatchAgainst.length < word.length) {
        return null;
    }
    var matches;
    if (ignoreCase) {
        matches = __WEBPACK_IMPORTED_MODULE_0__strings_js__["startsWithIgnoreCase"](wordToMatchAgainst, word);
    }
    else {
        matches = wordToMatchAgainst.indexOf(word) === 0;
    }
    if (!matches) {
        return null;
    }
    return word.length > 0 ? [{ start: 0, end: word.length }] : [];
}
// Contiguous Substring
function matchesContiguousSubString(word, wordToMatchAgainst) {
    var index = wordToMatchAgainst.toLowerCase().indexOf(word.toLowerCase());
    if (index === -1) {
        return null;
    }
    return [{ start: index, end: index + word.length }];
}
// Substring
function matchesSubString(word, wordToMatchAgainst) {
    return _matchesSubString(word.toLowerCase(), wordToMatchAgainst.toLowerCase(), 0, 0);
}
function _matchesSubString(word, wordToMatchAgainst, i, j) {
    if (i === word.length) {
        return [];
    }
    else if (j === wordToMatchAgainst.length) {
        return null;
    }
    else {
        if (word[i] === wordToMatchAgainst[j]) {
            var result = null;
            if (result = _matchesSubString(word, wordToMatchAgainst, i + 1, j + 1)) {
                return join({ start: j, end: j + 1 }, result);
            }
            return null;
        }
        return _matchesSubString(word, wordToMatchAgainst, i, j + 1);
    }
}
// CamelCase
function isLower(code) {
    return 97 /* a */ <= code && code <= 122 /* z */;
}
function isUpper(code) {
    return 65 /* A */ <= code && code <= 90 /* Z */;
}
function isNumber(code) {
    return 48 /* Digit0 */ <= code && code <= 57 /* Digit9 */;
}
function isWhitespace(code) {
    return (code === 32 /* Space */
        || code === 9 /* Tab */
        || code === 10 /* LineFeed */
        || code === 13 /* CarriageReturn */);
}
function isAlphanumeric(code) {
    return isLower(code) || isUpper(code) || isNumber(code);
}
function join(head, tail) {
    if (tail.length === 0) {
        tail = [head];
    }
    else if (head.end === tail[0].start) {
        tail[0].start = head.start;
    }
    else {
        tail.unshift(head);
    }
    return tail;
}
function nextAnchor(camelCaseWord, start) {
    for (var i = start; i < camelCaseWord.length; i++) {
        var c = camelCaseWord.charCodeAt(i);
        if (isUpper(c) || isNumber(c) || (i > 0 && !isAlphanumeric(camelCaseWord.charCodeAt(i - 1)))) {
            return i;
        }
    }
    return camelCaseWord.length;
}
function _matchesCamelCase(word, camelCaseWord, i, j) {
    if (i === word.length) {
        return [];
    }
    else if (j === camelCaseWord.length) {
        return null;
    }
    else if (word[i] !== camelCaseWord[j].toLowerCase()) {
        return null;
    }
    else {
        var result = null;
        var nextUpperIndex = j + 1;
        result = _matchesCamelCase(word, camelCaseWord, i + 1, j + 1);
        while (!result && (nextUpperIndex = nextAnchor(camelCaseWord, nextUpperIndex)) < camelCaseWord.length) {
            result = _matchesCamelCase(word, camelCaseWord, i + 1, nextUpperIndex);
            nextUpperIndex++;
        }
        return result === null ? null : join({ start: j, end: j + 1 }, result);
    }
}
// Heuristic to avoid computing camel case matcher for words that don't
// look like camelCaseWords.
function analyzeCamelCaseWord(word) {
    var upper = 0, lower = 0, alpha = 0, numeric = 0, code = 0;
    for (var i = 0; i < word.length; i++) {
        code = word.charCodeAt(i);
        if (isUpper(code)) {
            upper++;
        }
        if (isLower(code)) {
            lower++;
        }
        if (isAlphanumeric(code)) {
            alpha++;
        }
        if (isNumber(code)) {
            numeric++;
        }
    }
    var upperPercent = upper / word.length;
    var lowerPercent = lower / word.length;
    var alphaPercent = alpha / word.length;
    var numericPercent = numeric / word.length;
    return { upperPercent: upperPercent, lowerPercent: lowerPercent, alphaPercent: alphaPercent, numericPercent: numericPercent };
}
function isUpperCaseWord(analysis) {
    var upperPercent = analysis.upperPercent, lowerPercent = analysis.lowerPercent;
    return lowerPercent === 0 && upperPercent > 0.6;
}
function isCamelCaseWord(analysis) {
    var upperPercent = analysis.upperPercent, lowerPercent = analysis.lowerPercent, alphaPercent = analysis.alphaPercent, numericPercent = analysis.numericPercent;
    return lowerPercent > 0.2 && upperPercent < 0.8 && alphaPercent > 0.6 && numericPercent < 0.2;
}
// Heuristic to avoid computing camel case matcher for words that don't
// look like camel case patterns.
function isCamelCasePattern(word) {
    var upper = 0, lower = 0, code = 0, whitespace = 0;
    for (var i = 0; i < word.length; i++) {
        code = word.charCodeAt(i);
        if (isUpper(code)) {
            upper++;
        }
        if (isLower(code)) {
            lower++;
        }
        if (isWhitespace(code)) {
            whitespace++;
        }
    }
    if ((upper === 0 || lower === 0) && whitespace === 0) {
        return word.length <= 30;
    }
    else {
        return upper <= 5;
    }
}
function matchesCamelCase(word, camelCaseWord) {
    if (!camelCaseWord) {
        return null;
    }
    camelCaseWord = camelCaseWord.trim();
    if (camelCaseWord.length === 0) {
        return null;
    }
    if (!isCamelCasePattern(word)) {
        return null;
    }
    if (camelCaseWord.length > 60) {
        return null;
    }
    var analysis = analyzeCamelCaseWord(camelCaseWord);
    if (!isCamelCaseWord(analysis)) {
        if (!isUpperCaseWord(analysis)) {
            return null;
        }
        camelCaseWord = camelCaseWord.toLowerCase();
    }
    var result = null;
    var i = 0;
    word = word.toLowerCase();
    while (i < camelCaseWord.length && (result = _matchesCamelCase(word, camelCaseWord, 0, i)) === null) {
        i = nextAnchor(camelCaseWord, i + 1);
    }
    return result;
}
// Fuzzy
var fuzzyContiguousFilter = or(matchesPrefix, matchesCamelCase, matchesContiguousSubString);
var fuzzySeparateFilter = or(matchesPrefix, matchesCamelCase, matchesSubString);
var fuzzyRegExpCache = new __WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* LRUCache */](10000); // bounded to 10000 elements
function matchesFuzzy(word, wordToMatchAgainst, enableSeparateSubstringMatching) {
    if (enableSeparateSubstringMatching === void 0) { enableSeparateSubstringMatching = false; }
    if (typeof word !== 'string' || typeof wordToMatchAgainst !== 'string') {
        return null; // return early for invalid input
    }
    // Form RegExp for wildcard matches
    var regexp = fuzzyRegExpCache.get(word);
    if (!regexp) {
        regexp = new RegExp(__WEBPACK_IMPORTED_MODULE_0__strings_js__["convertSimple2RegExpPattern"](word), 'i');
        fuzzyRegExpCache.set(word, regexp);
    }
    // RegExp Filter
    var match = regexp.exec(wordToMatchAgainst);
    if (match) {
        return [{ start: match.index, end: match.index + match[0].length }];
    }
    // Default Filter
    return enableSeparateSubstringMatching ? fuzzySeparateFilter(word, wordToMatchAgainst) : fuzzyContiguousFilter(word, wordToMatchAgainst);
}
function anyScore(pattern, word, patternMaxWhitespaceIgnore) {
    pattern = pattern.toLowerCase();
    word = word.toLowerCase();
    var matches = [];
    var idx = 0;
    for (var pos = 0; pos < pattern.length; ++pos) {
        var thisIdx = word.indexOf(pattern.charAt(pos), idx);
        if (thisIdx >= 0) {
            matches.push(thisIdx);
            idx = thisIdx + 1;
        }
    }
    return [matches.length, matches];
}
//#region --- fuzzyScore ---
function createMatches(position) {
    var ret = [];
    if (!position) {
        return ret;
    }
    var last;
    for (var _i = 0, position_1 = position; _i < position_1.length; _i++) {
        var pos = position_1[_i];
        if (last && last.end === pos) {
            last.end += 1;
        }
        else {
            last = { start: pos, end: pos + 1 };
            ret.push(last);
        }
    }
    return ret;
}
function initTable() {
    var table = [];
    var row = [0];
    for (var i = 1; i <= 100; i++) {
        row.push(-i);
    }
    for (var i = 0; i <= 100; i++) {
        var thisRow = row.slice(0);
        thisRow[0] = -i;
        table.push(thisRow);
    }
    return table;
}
var _table = initTable();
var _scores = initTable();
var _arrows = initTable();
var _debug = false;
function printTable(table, pattern, patternLen, word, wordLen) {
    function pad(s, n, pad) {
        if (pad === void 0) { pad = ' '; }
        while (s.length < n) {
            s = pad + s;
        }
        return s;
    }
    var ret = " |   |" + word.split('').map(function (c) { return pad(c, 3); }).join('|') + "\n";
    for (var i = 0; i <= patternLen; i++) {
        if (i === 0) {
            ret += ' |';
        }
        else {
            ret += pattern[i - 1] + "|";
        }
        ret += table[i].slice(0, wordLen + 1).map(function (n) { return pad(n.toString(), 3); }).join('|') + '\n';
    }
    return ret;
}
function isSeparatorAtPos(value, index) {
    if (index < 0 || index >= value.length) {
        return false;
    }
    var code = value.charCodeAt(index);
    switch (code) {
        case 95 /* Underline */:
        case 45 /* Dash */:
        case 46 /* Period */:
        case 32 /* Space */:
        case 47 /* Slash */:
        case 92 /* Backslash */:
        case 39 /* SingleQuote */:
        case 34 /* DoubleQuote */:
        case 58 /* Colon */:
            return true;
        default:
            return false;
    }
}
function isWhitespaceAtPos(value, index) {
    if (index < 0 || index >= value.length) {
        return false;
    }
    var code = value.charCodeAt(index);
    switch (code) {
        case 32 /* Space */:
        case 9 /* Tab */:
            return true;
        default:
            return false;
    }
}
function fuzzyScore(pattern, word, patternMaxWhitespaceIgnore, firstMatchCanBeWeak) {
    var patternLen = pattern.length > 100 ? 100 : pattern.length;
    var wordLen = word.length > 100 ? 100 : word.length;
    // Check for leading whitespace in the pattern and
    // start matching just after that position. This is
    // like `pattern = pattern.rtrim()` but doesn't create
    // a new string
    var patternStartPos = 0;
    if (patternMaxWhitespaceIgnore === undefined) {
        patternMaxWhitespaceIgnore = patternLen;
    }
    while (patternStartPos < patternMaxWhitespaceIgnore) {
        if (isWhitespaceAtPos(pattern, patternStartPos)) {
            patternStartPos += 1;
        }
        else {
            break;
        }
    }
    if (patternStartPos === patternLen) {
        return [-100, []];
    }
    if (patternLen > wordLen) {
        return undefined;
    }
    var lowPattern = pattern.toLowerCase();
    var lowWord = word.toLowerCase();
    var patternPos = patternStartPos;
    var wordPos = 0;
    // Run a simple check if the characters of pattern occur
    // (in order) at all in word. If that isn't the case we
    // stop because no match will be possible
    while (patternPos < patternLen && wordPos < wordLen) {
        if (lowPattern[patternPos] === lowWord[wordPos]) {
            patternPos += 1;
        }
        wordPos += 1;
    }
    if (patternPos !== patternLen) {
        return undefined;
    }
    // There will be a mach, fill in tables
    for (patternPos = patternStartPos + 1; patternPos <= patternLen; patternPos++) {
        for (wordPos = 1; wordPos <= wordLen; wordPos++) {
            var score = -1;
            var lowWordChar = lowWord[wordPos - 1];
            if (lowPattern[patternPos - 1] === lowWordChar) {
                if (wordPos === (patternPos - patternStartPos)) {
                    // common prefix: `foobar <-> foobaz`
                    if (pattern[patternPos - 1] === word[wordPos - 1]) {
                        score = 7;
                    }
                    else {
                        score = 5;
                    }
                }
                else if (lowWordChar !== word[wordPos - 1] && (wordPos === 1 || lowWord[wordPos - 2] === word[wordPos - 2])) {
                    // hitting upper-case: `foo <-> forOthers`
                    if (pattern[patternPos - 1] === word[wordPos - 1]) {
                        score = 7;
                    }
                    else {
                        score = 5;
                    }
                }
                else if (isSeparatorAtPos(lowWord, wordPos - 2) || isWhitespaceAtPos(lowWord, wordPos - 2)) {
                    // post separator: `foo <-> bar_foo`
                    score = 5;
                }
                else {
                    score = 1;
                }
            }
            _scores[patternPos][wordPos] = score;
            var diag = _table[patternPos - 1][wordPos - 1] + (score > 1 ? 1 : score);
            var top_1 = _table[patternPos - 1][wordPos] + -1;
            var left = _table[patternPos][wordPos - 1] + -1;
            if (left >= top_1) {
                // left or diag
                if (left > diag) {
                    _table[patternPos][wordPos] = left;
                    _arrows[patternPos][wordPos] = 4 /* Left */;
                }
                else if (left === diag) {
                    _table[patternPos][wordPos] = left;
                    _arrows[patternPos][wordPos] = 4 /* Left */ | 2 /* Diag */;
                }
                else {
                    _table[patternPos][wordPos] = diag;
                    _arrows[patternPos][wordPos] = 2 /* Diag */;
                }
            }
            else {
                // top or diag
                if (top_1 > diag) {
                    _table[patternPos][wordPos] = top_1;
                    _arrows[patternPos][wordPos] = 1 /* Top */;
                }
                else if (top_1 === diag) {
                    _table[patternPos][wordPos] = top_1;
                    _arrows[patternPos][wordPos] = 1 /* Top */ | 2 /* Diag */;
                }
                else {
                    _table[patternPos][wordPos] = diag;
                    _arrows[patternPos][wordPos] = 2 /* Diag */;
                }
            }
        }
    }
    if (_debug) {
        console.log(printTable(_table, pattern, patternLen, word, wordLen));
        console.log(printTable(_arrows, pattern, patternLen, word, wordLen));
        console.log(printTable(_scores, pattern, patternLen, word, wordLen));
    }
    // _bucket is an array of [PrefixArray] we use to keep
    // track of scores and matches. After calling `_findAllMatches`
    // the best match (if available) is the first item in the array
    _matchesCount = 0;
    _topScore = -100;
    _patternStartPos = patternStartPos;
    _firstMatchCanBeWeak = firstMatchCanBeWeak;
    _findAllMatches(patternLen, wordLen, patternLen === wordLen ? 1 : 0, new LazyArray(), false);
    if (_matchesCount === 0) {
        return undefined;
    }
    return [_topScore, _topMatch.toArray()];
}
var _matchesCount = 0;
var _topMatch;
var _topScore = 0;
var _patternStartPos = 0;
var _firstMatchCanBeWeak = false;
function _findAllMatches(patternPos, wordPos, total, matches, lastMatched) {
    if (_matchesCount >= 10 || total < -25) {
        // stop when having already 10 results, or
        // when a potential alignment as already 5 gaps
        return;
    }
    var simpleMatchCount = 0;
    while (patternPos > _patternStartPos && wordPos > 0) {
        var score = _scores[patternPos][wordPos];
        var arrow = _arrows[patternPos][wordPos];
        if (arrow === 4 /* Left */) {
            // left
            wordPos -= 1;
            if (lastMatched) {
                total -= 5; // new gap penalty
            }
            else if (!matches.isEmpty()) {
                total -= 1; // gap penalty after first match
            }
            lastMatched = false;
            simpleMatchCount = 0;
        }
        else if (arrow & 2 /* Diag */) {
            if (arrow & 4 /* Left */) {
                // left
                _findAllMatches(patternPos, wordPos - 1, !matches.isEmpty() ? total - 1 : total, // gap penalty after first match
                matches.slice(), lastMatched);
            }
            // diag
            total += score;
            patternPos -= 1;
            wordPos -= 1;
            matches.unshift(wordPos);
            lastMatched = true;
            // count simple matches and boost a row of
            // simple matches when they yield in a
            // strong match.
            if (score === 1) {
                simpleMatchCount += 1;
                if (patternPos === _patternStartPos && !_firstMatchCanBeWeak) {
                    // when the first match is a weak
                    // match we discard it
                    return undefined;
                }
            }
            else {
                // boost
                total += 1 + (simpleMatchCount * (score - 1));
                simpleMatchCount = 0;
            }
        }
        else {
            return undefined;
        }
    }
    total -= wordPos >= 3 ? 9 : wordPos * 3; // late start penalty
    // dynamically keep track of the current top score
    // and insert the current best score at head, the rest at tail
    _matchesCount += 1;
    if (total > _topScore) {
        _topScore = total;
        _topMatch = matches;
    }
}
var LazyArray = /** @class */ (function () {
    function LazyArray() {
    }
    LazyArray.prototype.isEmpty = function () {
        return !this._data && (!this._parent || this._parent.isEmpty());
    };
    LazyArray.prototype.unshift = function (n) {
        if (!this._data) {
            this._data = [n];
        }
        else {
            this._data.unshift(n);
        }
    };
    LazyArray.prototype.slice = function () {
        var ret = new LazyArray();
        ret._parent = this;
        ret._parentLen = this._data ? this._data.length : 0;
        return ret;
    };
    LazyArray.prototype.toArray = function () {
        if (!this._data) {
            return this._parent.toArray();
        }
        var bucket = [];
        var element = this;
        while (element) {
            if (element._parent && element._parent._data) {
                bucket.push(element._parent._data.slice(element._parent._data.length - element._parentLen));
            }
            element = element._parent;
        }
        return Array.prototype.concat.apply(this._data, bucket);
    };
    return LazyArray;
}());
//#endregion
//#region --- graceful ---
function fuzzyScoreGracefulAggressive(pattern, word, patternMaxWhitespaceIgnore) {
    return fuzzyScoreWithPermutations(pattern, word, true, patternMaxWhitespaceIgnore);
}
function fuzzyScoreWithPermutations(pattern, word, aggressive, patternMaxWhitespaceIgnore) {
    var top = fuzzyScore(pattern, word, patternMaxWhitespaceIgnore);
    if (top && !aggressive) {
        // when using the original pattern yield a result we`
        // return it unless we are aggressive and try to find
        // a better alignment, e.g. `cno` -> `^co^ns^ole` or `^c^o^nsole`.
        return top;
    }
    if (pattern.length >= 3) {
        // When the pattern is long enough then try a few (max 7)
        // permutations of the pattern to find a better match. The
        // permutations only swap neighbouring characters, e.g
        // `cnoso` becomes `conso`, `cnsoo`, `cnoos`.
        var tries = Math.min(7, pattern.length - 1);
        for (var patternPos = 1; patternPos < tries; patternPos++) {
            var newPattern = nextTypoPermutation(pattern, patternPos);
            if (newPattern) {
                var candidate = fuzzyScore(newPattern, word, patternMaxWhitespaceIgnore);
                if (candidate) {
                    candidate[0] -= 3; // permutation penalty
                    if (!top || candidate[0] > top[0]) {
                        top = candidate;
                    }
                }
            }
        }
    }
    return top;
}
function nextTypoPermutation(pattern, patternPos) {
    if (patternPos + 1 >= pattern.length) {
        return undefined;
    }
    var swap1 = pattern[patternPos];
    var swap2 = pattern[patternPos + 1];
    if (swap1 === swap2) {
        return undefined;
    }
    return pattern.slice(0, patternPos)
        + swap2
        + swap1
        + pattern.slice(patternPos + 2);
}


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Context; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getSnippetSuggestSupport;
/* harmony export (immutable) */ __webpack_exports__["d"] = provideSuggestionItems;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSuggestionComparator;
/* harmony export (immutable) */ __webpack_exports__["e"] = showSimpleSuggestions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/









var Context = {
    Visible: new __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('suggestWidgetVisible', false),
    MultipleSuggestions: new __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('suggestWidgetMultipleSuggestions', false),
    MakesTextEdit: new __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('suggestionMakesTextEdit', true),
    AcceptOnKey: new __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('suggestionSupportsAcceptOnKey', true),
    AcceptSuggestionsOnEnter: new __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('acceptSuggestionOnEnter', true)
};
var _snippetSuggestSupport;
function getSnippetSuggestSupport() {
    return _snippetSuggestSupport;
}
function provideSuggestionItems(model, position, snippetConfig, onlyFrom, context, token) {
    if (snippetConfig === void 0) { snippetConfig = 'bottom'; }
    if (token === void 0) { token = __WEBPACK_IMPORTED_MODULE_8__base_common_cancellation_js__["a" /* CancellationToken */].None; }
    var allSuggestions = [];
    var acceptSuggestion = createSuggesionFilter(snippetConfig);
    position = position.clone();
    // get provider groups, always add snippet suggestion provider
    var supports = __WEBPACK_IMPORTED_MODULE_6__common_modes_js__["u" /* SuggestRegistry */].orderedGroups(model);
    // add snippets provider unless turned off
    if (snippetConfig !== 'none' && _snippetSuggestSupport) {
        supports.unshift([_snippetSuggestSupport]);
    }
    var suggestConext = context || { triggerKind: __WEBPACK_IMPORTED_MODULE_6__common_modes_js__["v" /* SuggestTriggerKind */].Invoke };
    // add suggestions from contributed providers - providers are ordered in groups of
    // equal score and once a group produces a result the process stops
    var hasResult = false;
    var factory = supports.map(function (supports) { return function () {
        // for each support in the group ask for suggestions
        return Promise.all(supports.map(function (support) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(onlyFrom) && onlyFrom.indexOf(support) < 0) {
                return undefined;
            }
            return Promise.resolve(support.provideCompletionItems(model, position, suggestConext, token)).then(function (container) {
                var len = allSuggestions.length;
                if (container && !Object(__WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(container.suggestions)) {
                    for (var _i = 0, _a = container.suggestions; _i < _a.length; _i++) {
                        var suggestion = _a[_i];
                        if (acceptSuggestion(suggestion)) {
                            fixOverwriteBeforeAfter(suggestion, container);
                            allSuggestions.push({
                                position: position,
                                container: container,
                                suggestion: suggestion,
                                support: support,
                                resolve: createSuggestionResolver(support, suggestion, model, position)
                            });
                        }
                    }
                }
                if (len !== allSuggestions.length && support !== _snippetSuggestSupport) {
                    hasResult = true;
                }
            }, __WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
        }));
    }; });
    var result = Object(__WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["k" /* first2 */])(factory, function () { return hasResult; }).then(function () { return allSuggestions.sort(getSuggestionComparator(snippetConfig)); });
    // result.then(items => {
    // 	console.log(model.getWordUntilPosition(position), items.map(item => `${item.suggestion.label}, type=${item.suggestion.type}, incomplete?${item.container.incomplete}, overwriteBefore=${item.suggestion.overwriteBefore}`));
    // 	return items;
    // }, err => {
    // 	console.warn(model.getWordUntilPosition(position), err);
    // });
    return result;
}
function fixOverwriteBeforeAfter(suggestion, container) {
    if (typeof suggestion.overwriteBefore !== 'number') {
        suggestion.overwriteBefore = 0;
    }
    if (typeof suggestion.overwriteAfter !== 'number' || suggestion.overwriteAfter < 0) {
        suggestion.overwriteAfter = 0;
    }
}
function createSuggestionResolver(provider, suggestion, model, position) {
    return function (token) {
        if (typeof provider.resolveCompletionItem === 'function') {
            return Promise.resolve(provider.resolveCompletionItem(model, position, suggestion, token)).then(function (value) { Object(__WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["a" /* assign */])(suggestion, value); });
        }
        else {
            return Promise.resolve(void 0);
        }
    };
}
function createSuggesionFilter(snippetConfig) {
    if (snippetConfig === 'none') {
        return function (suggestion) { return suggestion.type !== 'snippet'; };
    }
    else {
        return function () { return true; };
    }
}
function defaultComparator(a, b) {
    var ret = 0;
    // check with 'sortText'
    if (typeof a.suggestion.sortText === 'string' && typeof b.suggestion.sortText === 'string') {
        ret = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["compareIgnoreCase"])(a.suggestion.sortText, b.suggestion.sortText);
    }
    // check with 'label'
    if (ret === 0) {
        ret = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["compareIgnoreCase"])(a.suggestion.label, b.suggestion.label);
    }
    // check with 'type' and lower snippets
    if (ret === 0 && a.suggestion.type !== b.suggestion.type) {
        if (a.suggestion.type === 'snippet') {
            ret = 1;
        }
        else if (b.suggestion.type === 'snippet') {
            ret = -1;
        }
    }
    return ret;
}
function snippetUpComparator(a, b) {
    if (a.suggestion.type !== b.suggestion.type) {
        if (a.suggestion.type === 'snippet') {
            return -1;
        }
        else if (b.suggestion.type === 'snippet') {
            return 1;
        }
    }
    return defaultComparator(a, b);
}
function snippetDownComparator(a, b) {
    if (a.suggestion.type !== b.suggestion.type) {
        if (a.suggestion.type === 'snippet') {
            return 1;
        }
        else if (b.suggestion.type === 'snippet') {
            return -1;
        }
    }
    return defaultComparator(a, b);
}
function getSuggestionComparator(snippetConfig) {
    if (snippetConfig === 'top') {
        return snippetUpComparator;
    }
    else if (snippetConfig === 'bottom') {
        return snippetDownComparator;
    }
    else {
        return defaultComparator;
    }
}
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeCompletionItemProvider', function (model, position, args) {
    var result = {
        incomplete: false,
        suggestions: []
    };
    var resolving = [];
    var maxItemsToResolve = args['maxItemsToResolve'] || 0;
    return provideSuggestionItems(model, position).then(function (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (resolving.length < maxItemsToResolve) {
                resolving.push(item.resolve(__WEBPACK_IMPORTED_MODULE_8__base_common_cancellation_js__["a" /* CancellationToken */].None));
            }
            result.incomplete = result.incomplete || item.container.incomplete;
            result.suggestions.push(item.suggestion);
        }
    }).then(function () {
        return Promise.all(resolving);
    }).then(function () {
        return result;
    });
});
var _provider = new /** @class */ (function () {
    function class_1() {
        this.onlyOnceSuggestions = [];
    }
    class_1.prototype.provideCompletionItems = function () {
        var suggestions = this.onlyOnceSuggestions.slice(0);
        var result = { suggestions: suggestions };
        this.onlyOnceSuggestions.length = 0;
        return result;
    };
    return class_1;
}());
__WEBPACK_IMPORTED_MODULE_6__common_modes_js__["u" /* SuggestRegistry */].register('*', _provider);
function showSimpleSuggestions(editor, suggestions) {
    setTimeout(function () {
        var _a;
        (_a = _provider.onlyOnceSuggestions).push.apply(_a, suggestions);
        editor.getContribution('editor.contrib.suggestController').triggerSuggest([_provider]);
    }, 0);
}


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoveWordCommand", function() { return MoveWordCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WordLeftCommand", function() { return WordLeftCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WordRightCommand", function() { return WordRightCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordStartLeft", function() { return CursorWordStartLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordEndLeft", function() { return CursorWordEndLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordLeft", function() { return CursorWordLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordStartLeftSelect", function() { return CursorWordStartLeftSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordEndLeftSelect", function() { return CursorWordEndLeftSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordLeftSelect", function() { return CursorWordLeftSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordStartRight", function() { return CursorWordStartRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordEndRight", function() { return CursorWordEndRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordRight", function() { return CursorWordRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordStartRightSelect", function() { return CursorWordStartRightSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordEndRightSelect", function() { return CursorWordEndRightSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordRightSelect", function() { return CursorWordRightSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordCommand", function() { return DeleteWordCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordLeftCommand", function() { return DeleteWordLeftCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordRightCommand", function() { return DeleteWordRightCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordStartLeft", function() { return DeleteWordStartLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordEndLeft", function() { return DeleteWordEndLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordLeft", function() { return DeleteWordLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordStartRight", function() { return DeleteWordStartRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordEndRight", function() { return DeleteWordEndRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordRight", function() { return DeleteWordRight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorWordOperations_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_controller_wordCharacterClassifier_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__ = __webpack_require__(53);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var MoveWordCommand = /** @class */ (function (_super) {
    __extends(MoveWordCommand, _super);
    function MoveWordCommand(opts) {
        var _this = _super.call(this, opts) || this;
        _this._inSelectionMode = opts.inSelectionMode;
        _this._wordNavigationType = opts.wordNavigationType;
        return _this;
    }
    MoveWordCommand.prototype.runEditorCommand = function (accessor, editor, args) {
        var _this = this;
        var config = editor.getConfiguration();
        var wordSeparators = Object(__WEBPACK_IMPORTED_MODULE_7__common_controller_wordCharacterClassifier_js__["a" /* getMapForWordSeparators */])(config.wordSeparators);
        var model = editor.getModel();
        var selections = editor.getSelections();
        var result = selections.map(function (sel) {
            var inPosition = new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](sel.positionLineNumber, sel.positionColumn);
            var outPosition = _this._move(wordSeparators, model, inPosition, _this._wordNavigationType);
            return _this._moveTo(sel, outPosition, _this._inSelectionMode);
        });
        editor._getCursors().setStates('moveWordCommand', __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].NotSet, result.map(function (r) { return __WEBPACK_IMPORTED_MODULE_8__common_controller_cursorCommon_js__["d" /* CursorState */].fromModelSelection(r); }));
        if (result.length === 1) {
            var pos = new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](result[0].positionLineNumber, result[0].positionColumn);
            editor.revealPosition(pos, 0 /* Smooth */);
        }
    };
    MoveWordCommand.prototype._moveTo = function (from, to, inSelectionMode) {
        if (inSelectionMode) {
            // move just position
            return new __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__["a" /* Selection */](from.selectionStartLineNumber, from.selectionStartColumn, to.lineNumber, to.column);
        }
        else {
            // move everything
            return new __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__["a" /* Selection */](to.lineNumber, to.column, to.lineNumber, to.column);
        }
    };
    return MoveWordCommand;
}(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["c" /* EditorCommand */]));

var WordLeftCommand = /** @class */ (function (_super) {
    __extends(WordLeftCommand, _super);
    function WordLeftCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WordLeftCommand.prototype._move = function (wordSeparators, model, position, wordNavigationType) {
        return __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorWordOperations_js__["a" /* WordOperations */].moveWordLeft(wordSeparators, model, position, wordNavigationType);
    };
    return WordLeftCommand;
}(MoveWordCommand));

var WordRightCommand = /** @class */ (function (_super) {
    __extends(WordRightCommand, _super);
    function WordRightCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WordRightCommand.prototype._move = function (wordSeparators, model, position, wordNavigationType) {
        return __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorWordOperations_js__["a" /* WordOperations */].moveWordRight(wordSeparators, model, position, wordNavigationType);
    };
    return WordRightCommand;
}(MoveWordCommand));

var CursorWordStartLeft = /** @class */ (function (_super) {
    __extends(CursorWordStartLeft, _super);
    function CursorWordStartLeft() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordStartLeft',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 15 /* LeftArrow */,
                mac: { primary: 512 /* Alt */ | 15 /* LeftArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordStartLeft;
}(WordLeftCommand));

var CursorWordEndLeft = /** @class */ (function (_super) {
    __extends(CursorWordEndLeft, _super);
    function CursorWordEndLeft() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordEndLeft',
            precondition: null
        }) || this;
    }
    return CursorWordEndLeft;
}(WordLeftCommand));

var CursorWordLeft = /** @class */ (function (_super) {
    __extends(CursorWordLeft, _super);
    function CursorWordLeft() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordLeft',
            precondition: null
        }) || this;
    }
    return CursorWordLeft;
}(WordLeftCommand));

var CursorWordStartLeftSelect = /** @class */ (function (_super) {
    __extends(CursorWordStartLeftSelect, _super);
    function CursorWordStartLeftSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordStartLeftSelect',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 15 /* LeftArrow */,
                mac: { primary: 512 /* Alt */ | 1024 /* Shift */ | 15 /* LeftArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordStartLeftSelect;
}(WordLeftCommand));

var CursorWordEndLeftSelect = /** @class */ (function (_super) {
    __extends(CursorWordEndLeftSelect, _super);
    function CursorWordEndLeftSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordEndLeftSelect',
            precondition: null
        }) || this;
    }
    return CursorWordEndLeftSelect;
}(WordLeftCommand));

var CursorWordLeftSelect = /** @class */ (function (_super) {
    __extends(CursorWordLeftSelect, _super);
    function CursorWordLeftSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordLeftSelect',
            precondition: null
        }) || this;
    }
    return CursorWordLeftSelect;
}(WordLeftCommand));

var CursorWordStartRight = /** @class */ (function (_super) {
    __extends(CursorWordStartRight, _super);
    function CursorWordStartRight() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordStartRight',
            precondition: null
        }) || this;
    }
    return CursorWordStartRight;
}(WordRightCommand));

var CursorWordEndRight = /** @class */ (function (_super) {
    __extends(CursorWordEndRight, _super);
    function CursorWordEndRight() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordEndRight',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 17 /* RightArrow */,
                mac: { primary: 512 /* Alt */ | 17 /* RightArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordEndRight;
}(WordRightCommand));

var CursorWordRight = /** @class */ (function (_super) {
    __extends(CursorWordRight, _super);
    function CursorWordRight() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordRight',
            precondition: null
        }) || this;
    }
    return CursorWordRight;
}(WordRightCommand));

var CursorWordStartRightSelect = /** @class */ (function (_super) {
    __extends(CursorWordStartRightSelect, _super);
    function CursorWordStartRightSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordStartRightSelect',
            precondition: null
        }) || this;
    }
    return CursorWordStartRightSelect;
}(WordRightCommand));

var CursorWordEndRightSelect = /** @class */ (function (_super) {
    __extends(CursorWordEndRightSelect, _super);
    function CursorWordEndRightSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordEndRightSelect',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 17 /* RightArrow */,
                mac: { primary: 512 /* Alt */ | 1024 /* Shift */ | 17 /* RightArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordEndRightSelect;
}(WordRightCommand));

var CursorWordRightSelect = /** @class */ (function (_super) {
    __extends(CursorWordRightSelect, _super);
    function CursorWordRightSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordRightSelect',
            precondition: null
        }) || this;
    }
    return CursorWordRightSelect;
}(WordRightCommand));

var DeleteWordCommand = /** @class */ (function (_super) {
    __extends(DeleteWordCommand, _super);
    function DeleteWordCommand(opts) {
        var _this = _super.call(this, opts) || this;
        _this._whitespaceHeuristics = opts.whitespaceHeuristics;
        _this._wordNavigationType = opts.wordNavigationType;
        return _this;
    }
    DeleteWordCommand.prototype.runEditorCommand = function (accessor, editor, args) {
        var _this = this;
        var config = editor.getConfiguration();
        var wordSeparators = Object(__WEBPACK_IMPORTED_MODULE_7__common_controller_wordCharacterClassifier_js__["a" /* getMapForWordSeparators */])(config.wordSeparators);
        var model = editor.getModel();
        var selections = editor.getSelections();
        var commands = selections.map(function (sel) {
            var deleteRange = _this._delete(wordSeparators, model, sel, _this._whitespaceHeuristics, _this._wordNavigationType);
            return new __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__["a" /* ReplaceCommand */](deleteRange, '');
        });
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return DeleteWordCommand;
}(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["c" /* EditorCommand */]));

var DeleteWordLeftCommand = /** @class */ (function (_super) {
    __extends(DeleteWordLeftCommand, _super);
    function DeleteWordLeftCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeleteWordLeftCommand.prototype._delete = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        var r = __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorWordOperations_js__["a" /* WordOperations */].deleteWordLeft(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);
        if (r) {
            return r;
        }
        return new __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */](1, 1, 1, 1);
    };
    return DeleteWordLeftCommand;
}(DeleteWordCommand));

var DeleteWordRightCommand = /** @class */ (function (_super) {
    __extends(DeleteWordRightCommand, _super);
    function DeleteWordRightCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeleteWordRightCommand.prototype._delete = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        var r = __WEBPACK_IMPORTED_MODULE_5__common_controller_cursorWordOperations_js__["a" /* WordOperations */].deleteWordRight(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);
        if (r) {
            return r;
        }
        var lineCount = model.getLineCount();
        var maxColumn = model.getLineMaxColumn(lineCount);
        return new __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */](lineCount, maxColumn, lineCount, maxColumn);
    };
    return DeleteWordRightCommand;
}(DeleteWordCommand));

var DeleteWordStartLeft = /** @class */ (function (_super) {
    __extends(DeleteWordStartLeft, _super);
    function DeleteWordStartLeft() {
        return _super.call(this, {
            whitespaceHeuristics: false,
            wordNavigationType: 0 /* WordStart */,
            id: 'deleteWordStartLeft',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return DeleteWordStartLeft;
}(DeleteWordLeftCommand));

var DeleteWordEndLeft = /** @class */ (function (_super) {
    __extends(DeleteWordEndLeft, _super);
    function DeleteWordEndLeft() {
        return _super.call(this, {
            whitespaceHeuristics: false,
            wordNavigationType: 1 /* WordEnd */,
            id: 'deleteWordEndLeft',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return DeleteWordEndLeft;
}(DeleteWordLeftCommand));

var DeleteWordLeft = /** @class */ (function (_super) {
    __extends(DeleteWordLeft, _super);
    function DeleteWordLeft() {
        return _super.call(this, {
            whitespaceHeuristics: true,
            wordNavigationType: 0 /* WordStart */,
            id: 'deleteWordLeft',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 1 /* Backspace */,
                mac: { primary: 512 /* Alt */ | 1 /* Backspace */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return DeleteWordLeft;
}(DeleteWordLeftCommand));

var DeleteWordStartRight = /** @class */ (function (_super) {
    __extends(DeleteWordStartRight, _super);
    function DeleteWordStartRight() {
        return _super.call(this, {
            whitespaceHeuristics: false,
            wordNavigationType: 0 /* WordStart */,
            id: 'deleteWordStartRight',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return DeleteWordStartRight;
}(DeleteWordRightCommand));

var DeleteWordEndRight = /** @class */ (function (_super) {
    __extends(DeleteWordEndRight, _super);
    function DeleteWordEndRight() {
        return _super.call(this, {
            whitespaceHeuristics: false,
            wordNavigationType: 1 /* WordEnd */,
            id: 'deleteWordEndRight',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return DeleteWordEndRight;
}(DeleteWordRightCommand));

var DeleteWordRight = /** @class */ (function (_super) {
    __extends(DeleteWordRight, _super);
    function DeleteWordRight() {
        return _super.call(this, {
            whitespaceHeuristics: true,
            wordNavigationType: 1 /* WordEnd */,
            id: 'deleteWordRight',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 20 /* Delete */,
                mac: { primary: 512 /* Alt */ | 20 /* Delete */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return DeleteWordRight;
}(DeleteWordRightCommand));

Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordStartLeft());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordEndLeft());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordLeft());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordStartLeftSelect());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordEndLeftSelect());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordLeftSelect());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordStartRight());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordEndRight());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordRight());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordStartRightSelect());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordEndRightSelect());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordRightSelect());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordStartLeft());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordEndLeft());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordLeft());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordStartRight());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordEndRight());
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordRight());


/***/ }),
/* 112 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(303);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessibilityHelp_css__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessibilityHelp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__accessibilityHelp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_browser_htmlContentRenderer_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_browser_ui_widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contrib_toggleTabFocusMode_toggleTabFocusMode_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__platform_opener_common_opener_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__base_browser_browser_js__ = __webpack_require__(25);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





















var CONTEXT_ACCESSIBILITY_WIDGET_VISIBLE = new __WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('accessibilityHelpWidgetVisible', false);
var AccessibilityHelpController = /** @class */ (function (_super) {
    __extends(AccessibilityHelpController, _super);
    function AccessibilityHelpController(editor, instantiationService) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        _this._widget = _this._register(instantiationService.createInstance(AccessibilityHelpWidget, _this._editor));
        return _this;
    }
    AccessibilityHelpController.get = function (editor) {
        return editor.getContribution(AccessibilityHelpController.ID);
    };
    AccessibilityHelpController.prototype.getId = function () {
        return AccessibilityHelpController.ID;
    };
    AccessibilityHelpController.prototype.show = function () {
        this._widget.show();
    };
    AccessibilityHelpController.prototype.hide = function () {
        this._widget.hide();
    };
    AccessibilityHelpController.ID = 'editor.contrib.accessibilityHelpController';
    AccessibilityHelpController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */])
    ], AccessibilityHelpController);
    return AccessibilityHelpController;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));
var nlsNoSelection = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("noSelection", "No selection");
var nlsSingleSelectionRange = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("singleSelectionRange", "Line {0}, Column {1} ({2} selected)");
var nlsSingleSelection = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("singleSelection", "Line {0}, Column {1}");
var nlsMultiSelectionRange = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("multiSelectionRange", "{0} selections ({1} characters selected)");
var nlsMultiSelection = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("multiSelection", "{0} selections");
function getSelectionLabel(selections, charactersSelected) {
    if (!selections || selections.length === 0) {
        return nlsNoSelection;
    }
    if (selections.length === 1) {
        if (charactersSelected) {
            return __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"](nlsSingleSelectionRange, selections[0].positionLineNumber, selections[0].positionColumn, charactersSelected);
        }
        return __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"](nlsSingleSelection, selections[0].positionLineNumber, selections[0].positionColumn);
    }
    if (charactersSelected) {
        return __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"](nlsMultiSelectionRange, selections.length, charactersSelected);
    }
    if (selections.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"](nlsMultiSelection, selections.length);
    }
    return null;
}
var AccessibilityHelpWidget = /** @class */ (function (_super) {
    __extends(AccessibilityHelpWidget, _super);
    function AccessibilityHelpWidget(editor, _contextKeyService, _keybindingService, _openerService) {
        var _this = _super.call(this) || this;
        _this._contextKeyService = _contextKeyService;
        _this._keybindingService = _keybindingService;
        _this._openerService = _openerService;
        _this._editor = editor;
        _this._isVisibleKey = CONTEXT_ACCESSIBILITY_WIDGET_VISIBLE.bindTo(_this._contextKeyService);
        _this._domNode = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._domNode.setClassName('accessibilityHelpWidget');
        _this._domNode.setDisplay('none');
        _this._domNode.setAttribute('role', 'dialog');
        _this._domNode.setAttribute('aria-hidden', 'true');
        _this._contentDomNode = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._contentDomNode.setAttribute('role', 'document');
        _this._domNode.appendChild(_this._contentDomNode);
        _this._isVisible = false;
        _this._register(_this._editor.onDidLayoutChange(function () {
            if (_this._isVisible) {
                _this._layout();
            }
        }));
        // Intentionally not configurable!
        _this._register(__WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this._contentDomNode.domNode, 'keydown', function (e) {
            if (!_this._isVisible) {
                return;
            }
            if (e.equals(2048 /* CtrlCmd */ | 35 /* KEY_E */)) {
                Object(__WEBPACK_IMPORTED_MODULE_17__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("emergencyConfOn", "Now changing the setting `accessibilitySupport` to 'on'."));
                _this._editor.updateOptions({
                    accessibilitySupport: 'on'
                });
                __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["l" /* clearNode */](_this._contentDomNode.domNode);
                _this._buildContent();
                _this._contentDomNode.domNode.focus();
                e.preventDefault();
                e.stopPropagation();
            }
            if (e.equals(2048 /* CtrlCmd */ | 38 /* KEY_H */)) {
                Object(__WEBPACK_IMPORTED_MODULE_17__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("openingDocs", "Now opening the Editor Accessibility documentation page."));
                var url = _this._editor.getRawConfiguration().accessibilityHelpUrl;
                if (typeof url === 'undefined') {
                    url = 'https://go.microsoft.com/fwlink/?linkid=852450';
                }
                _this._openerService.open(__WEBPACK_IMPORTED_MODULE_19__base_common_uri_js__["a" /* default */].parse(url));
                e.preventDefault();
                e.stopPropagation();
            }
        }));
        _this.onblur(_this._contentDomNode.domNode, function () {
            _this.hide();
        });
        _this._editor.addOverlayWidget(_this);
        return _this;
    }
    AccessibilityHelpWidget.prototype.dispose = function () {
        this._editor.removeOverlayWidget(this);
        _super.prototype.dispose.call(this);
    };
    AccessibilityHelpWidget.prototype.getId = function () {
        return AccessibilityHelpWidget.ID;
    };
    AccessibilityHelpWidget.prototype.getDomNode = function () {
        return this._domNode.domNode;
    };
    AccessibilityHelpWidget.prototype.getPosition = function () {
        return {
            preference: null
        };
    };
    AccessibilityHelpWidget.prototype.show = function () {
        if (this._isVisible) {
            return;
        }
        this._isVisible = true;
        this._isVisibleKey.set(true);
        this._layout();
        this._domNode.setDisplay('block');
        this._domNode.setAttribute('aria-hidden', 'false');
        this._contentDomNode.domNode.tabIndex = 0;
        this._buildContent();
        this._contentDomNode.domNode.focus();
    };
    AccessibilityHelpWidget.prototype._descriptionForCommand = function (commandId, msg, noKbMsg) {
        var kb = this._keybindingService.lookupKeybinding(commandId);
        if (kb) {
            return __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"](msg, kb.getAriaLabel());
        }
        return __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"](noKbMsg, commandId);
    };
    AccessibilityHelpWidget.prototype._buildContent = function () {
        var opts = this._editor.getConfiguration();
        var selections = this._editor.getSelections();
        var charactersSelected = 0;
        if (selections) {
            var model_1 = this._editor.getModel();
            if (model_1) {
                selections.forEach(function (selection) {
                    charactersSelected += model_1.getValueLengthInRange(selection);
                });
            }
        }
        var text = getSelectionLabel(selections, charactersSelected);
        if (opts.wrappingInfo.inDiffEditor) {
            if (opts.readOnly) {
                text += __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("readonlyDiffEditor", " in a read-only pane of a diff editor.");
            }
            else {
                text += __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("editableDiffEditor", " in a pane of a diff editor.");
            }
        }
        else {
            if (opts.readOnly) {
                text += __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("readonlyEditor", " in a read-only code editor");
            }
            else {
                text += __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("editableEditor", " in a code editor");
            }
        }
        switch (opts.accessibilitySupport) {
            case 0 /* Unknown */:
                var turnOnMessage = (__WEBPACK_IMPORTED_MODULE_16__base_common_platform_js__["d" /* isMacintosh */]
                    ? __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("changeConfigToOnMac", "To configure the editor to be optimized for usage with a Screen Reader press Command+E now.")
                    : __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("changeConfigToOnWinLinux", "To configure the editor to be optimized for usage with a Screen Reader press Control+E now."));
                text += '\n\n - ' + turnOnMessage;
                break;
            case 2 /* Enabled */:
                text += '\n\n - ' + __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("auto_on", "The editor is configured to be optimized for usage with a Screen Reader.");
                break;
            case 1 /* Disabled */:
                text += '\n\n - ' + __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("auto_off", "The editor is configured to never be optimized for usage with a Screen Reader, which is not the case at this time.");
                text += ' ' + turnOnMessage;
                break;
        }
        var NLS_TAB_FOCUS_MODE_ON = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("tabFocusModeOnMsg", "Pressing Tab in the current editor will move focus to the next focusable element. Toggle this behavior by pressing {0}.");
        var NLS_TAB_FOCUS_MODE_ON_NO_KB = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("tabFocusModeOnMsgNoKb", "Pressing Tab in the current editor will move focus to the next focusable element. The command {0} is currently not triggerable by a keybinding.");
        var NLS_TAB_FOCUS_MODE_OFF = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("tabFocusModeOffMsg", "Pressing Tab in the current editor will insert the tab character. Toggle this behavior by pressing {0}.");
        var NLS_TAB_FOCUS_MODE_OFF_NO_KB = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("tabFocusModeOffMsgNoKb", "Pressing Tab in the current editor will insert the tab character. The command {0} is currently not triggerable by a keybinding.");
        if (opts.tabFocusMode) {
            text += '\n\n - ' + this._descriptionForCommand(__WEBPACK_IMPORTED_MODULE_13__contrib_toggleTabFocusMode_toggleTabFocusMode_js__["ToggleTabFocusModeAction"].ID, NLS_TAB_FOCUS_MODE_ON, NLS_TAB_FOCUS_MODE_ON_NO_KB);
        }
        else {
            text += '\n\n - ' + this._descriptionForCommand(__WEBPACK_IMPORTED_MODULE_13__contrib_toggleTabFocusMode_toggleTabFocusMode_js__["ToggleTabFocusModeAction"].ID, NLS_TAB_FOCUS_MODE_OFF, NLS_TAB_FOCUS_MODE_OFF_NO_KB);
        }
        var openDocMessage = (__WEBPACK_IMPORTED_MODULE_16__base_common_platform_js__["d" /* isMacintosh */]
            ? __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("openDocMac", "Press Command+H now to open a browser window with more information related to editor accessibility.")
            : __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("openDocWinLinux", "Press Control+H now to open a browser window with more information related to editor accessibility."));
        text += '\n\n - ' + openDocMessage;
        text += '\n\n' + __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("outroMsg", "You can dismiss this tooltip and return to the editor by pressing Escape or Shift+Escape.");
        this._contentDomNode.domNode.appendChild(Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_htmlContentRenderer_js__["a" /* renderFormattedText */])(text));
        // Per https://www.w3.org/TR/wai-aria/roles#document, Authors SHOULD provide a title or label for documents
        this._contentDomNode.domNode.setAttribute('aria-label', text);
    };
    AccessibilityHelpWidget.prototype.hide = function () {
        if (!this._isVisible) {
            return;
        }
        this._isVisible = false;
        this._isVisibleKey.reset();
        this._domNode.setDisplay('none');
        this._domNode.setAttribute('aria-hidden', 'true');
        this._contentDomNode.domNode.tabIndex = -1;
        __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["l" /* clearNode */](this._contentDomNode.domNode);
        this._editor.focus();
    };
    AccessibilityHelpWidget.prototype._layout = function () {
        var editorLayout = this._editor.getLayoutInfo();
        var w = Math.max(5, Math.min(AccessibilityHelpWidget.WIDTH, editorLayout.width - 40));
        var h = Math.max(5, Math.min(AccessibilityHelpWidget.HEIGHT, editorLayout.height - 40));
        this._domNode.setWidth(w);
        this._domNode.setHeight(h);
        var top = Math.round((editorLayout.height - h) / 2);
        this._domNode.setTop(top);
        var left = Math.round((editorLayout.width - w) / 2);
        this._domNode.setLeft(left);
    };
    AccessibilityHelpWidget.ID = 'editor.contrib.accessibilityHelpWidget';
    AccessibilityHelpWidget.WIDTH = 500;
    AccessibilityHelpWidget.HEIGHT = 300;
    AccessibilityHelpWidget = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_9__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_18__platform_opener_common_opener_js__["a" /* IOpenerService */])
    ], AccessibilityHelpWidget);
    return AccessibilityHelpWidget;
}(__WEBPACK_IMPORTED_MODULE_7__base_browser_ui_widget_js__["a" /* Widget */]));
var ShowAccessibilityHelpAction = /** @class */ (function (_super) {
    __extends(ShowAccessibilityHelpAction, _super);
    function ShowAccessibilityHelpAction() {
        return _super.call(this, {
            id: 'editor.action.showAccessibilityHelp',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("ShowAccessibilityHelpAction", "Show Accessibility Help"),
            alias: 'Show Accessibility Help',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_11__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: (__WEBPACK_IMPORTED_MODULE_20__base_browser_browser_js__["k" /* isIE */] ? 2048 /* CtrlCmd */ | 59 /* F1 */ : 512 /* Alt */ | 59 /* F1 */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    ShowAccessibilityHelpAction.prototype.run = function (accessor, editor) {
        var controller = AccessibilityHelpController.get(editor);
        if (controller) {
            controller.show();
        }
    };
    return ShowAccessibilityHelpAction;
}(__WEBPACK_IMPORTED_MODULE_12__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_12__browser_editorExtensions_js__["h" /* registerEditorContribution */])(AccessibilityHelpController);
Object(__WEBPACK_IMPORTED_MODULE_12__browser_editorExtensions_js__["f" /* registerEditorAction */])(ShowAccessibilityHelpAction);
var AccessibilityHelpCommand = __WEBPACK_IMPORTED_MODULE_12__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(AccessibilityHelpController.get);
Object(__WEBPACK_IMPORTED_MODULE_12__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new AccessibilityHelpCommand({
    id: 'closeAccessibilityHelp',
    precondition: CONTEXT_ACCESSIBILITY_WIDGET_VISIBLE,
    handler: function (x) { return x.hide(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 100,
        kbExpr: __WEBPACK_IMPORTED_MODULE_11__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 9 /* Escape */,
        secondary: [1024 /* Shift */ | 9 /* Escape */]
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_14__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var widgetBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_15__platform_theme_common_colorRegistry_js__["D" /* editorWidgetBackground */]);
    if (widgetBackground) {
        collector.addRule(".monaco-editor .accessibilityHelpWidget { background-color: " + widgetBackground + "; }");
    }
    var widgetShadowColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_15__platform_theme_common_colorRegistry_js__["_17" /* widgetShadow */]);
    if (widgetShadowColor) {
        collector.addRule(".monaco-editor .accessibilityHelpWidget { box-shadow: 0 2px 8px " + widgetShadowColor + "; }");
    }
    var hcBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_15__platform_theme_common_colorRegistry_js__["e" /* contrastBorder */]);
    if (hcBorder) {
        collector.addRule(".monaco-editor .accessibilityHelpWidget { border: 2px solid " + hcBorder + "; }");
    }
});


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = renderText;
/* harmony export (immutable) */ __webpack_exports__["a"] = renderFormattedText;
/* harmony export (immutable) */ __webpack_exports__["b"] = renderMarkdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_idGenerator_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_htmlContent_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_marked_marked_js__ = __webpack_require__(313);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






function createElement(options) {
    var tagName = options.inline ? 'span' : 'div';
    var element = document.createElement(tagName);
    if (options.className) {
        element.className = options.className;
    }
    return element;
}
function renderText(text, options) {
    if (options === void 0) { options = {}; }
    var element = createElement(options);
    element.textContent = text;
    return element;
}
function renderFormattedText(formattedText, options) {
    if (options === void 0) { options = {}; }
    var element = createElement(options);
    _renderFormattedText(element, parseFormattedText(formattedText), options.actionHandler);
    return element;
}
/**
 * Create html nodes for the given content element.
 */
function renderMarkdown(markdown, options) {
    if (options === void 0) { options = {}; }
    var element = createElement(options);
    // signal to code-block render that the
    // element has been created
    var signalInnerHTML;
    var withInnerHTML = new Promise(function (c) { return signalInnerHTML = c; });
    var renderer = new __WEBPACK_IMPORTED_MODULE_4__common_marked_marked_js__["a" /* marked */].Renderer();
    renderer.image = function (href, title, text) {
        var dimensions = [];
        if (href) {
            var splitted = href.split('|').map(function (s) { return s.trim(); });
            href = splitted[0];
            var parameters = splitted[1];
            if (parameters) {
                var heightFromParams = /height=(\d+)/.exec(parameters);
                var widthFromParams = /width=(\d+)/.exec(parameters);
                var height = (heightFromParams && heightFromParams[1]);
                var width = (widthFromParams && widthFromParams[1]);
                var widthIsFinite = isFinite(parseInt(width));
                var heightIsFinite = isFinite(parseInt(height));
                if (widthIsFinite) {
                    dimensions.push("width=\"" + width + "\"");
                }
                if (heightIsFinite) {
                    dimensions.push("height=\"" + height + "\"");
                }
            }
        }
        var attributes = [];
        if (href) {
            attributes.push("src=\"" + href + "\"");
        }
        if (text) {
            attributes.push("alt=\"" + text + "\"");
        }
        if (title) {
            attributes.push("title=\"" + title + "\"");
        }
        if (dimensions.length) {
            attributes = attributes.concat(dimensions);
        }
        return '<img ' + attributes.join(' ') + '>';
    };
    renderer.link = function (href, title, text) {
        // Remove markdown escapes. Workaround for https://github.com/chjj/marked/issues/829
        if (href === text) { // raw link case
            text = Object(__WEBPACK_IMPORTED_MODULE_3__common_htmlContent_js__["d" /* removeMarkdownEscapes */])(text);
        }
        title = Object(__WEBPACK_IMPORTED_MODULE_3__common_htmlContent_js__["d" /* removeMarkdownEscapes */])(title);
        href = Object(__WEBPACK_IMPORTED_MODULE_3__common_htmlContent_js__["d" /* removeMarkdownEscapes */])(href);
        if (!href
            || href.match(/^data:|javascript:/i)
            || (href.match(/^command:/i) && !markdown.isTrusted)) {
            // drop the link
            return text;
        }
        else {
            return "<a href=\"#\" data-href=\"" + href + "\" title=\"" + (title || href) + "\">" + text + "</a>";
        }
    };
    renderer.paragraph = function (text) {
        return "<p>" + text + "</p>";
    };
    if (options.codeBlockRenderer) {
        renderer.code = function (code, lang) {
            var value = options.codeBlockRenderer(lang, code);
            // when code-block rendering is async we return sync
            // but update the node with the real result later.
            var id = __WEBPACK_IMPORTED_MODULE_1__common_idGenerator_js__["b" /* defaultGenerator */].nextId();
            var promise = Promise.all([value, withInnerHTML]).then(function (values) {
                var strValue = values[0];
                var span = element.querySelector("div[data-code=\"" + id + "\"]");
                if (span) {
                    span.innerHTML = strValue;
                }
            }).catch(function (err) {
                // ignore
            });
            if (options.codeBlockRenderCallback) {
                promise.then(options.codeBlockRenderCallback);
            }
            return "<div class=\"code\" data-code=\"" + id + "\">" + Object(__WEBPACK_IMPORTED_MODULE_2__common_strings_js__["escape"])(code) + "</div>";
        };
    }
    if (options.actionHandler) {
        options.actionHandler.disposeables.push(__WEBPACK_IMPORTED_MODULE_0__dom_js__["j" /* addStandardDisposableListener */](element, 'click', function (event) {
            var target = event.target;
            if (target.tagName !== 'A') {
                target = target.parentElement;
                if (!target || target.tagName !== 'A') {
                    return;
                }
            }
            var href = target.dataset['href'];
            if (href) {
                options.actionHandler.callback(href, event);
            }
        }));
    }
    var markedOptions = {
        sanitize: true,
        renderer: renderer
    };
    element.innerHTML = Object(__WEBPACK_IMPORTED_MODULE_4__common_marked_marked_js__["a" /* marked */])(markdown.value, markedOptions);
    signalInnerHTML();
    return element;
}
// --- formatted string parsing
var StringStream = /** @class */ (function () {
    function StringStream(source) {
        this.source = source;
        this.index = 0;
    }
    StringStream.prototype.eos = function () {
        return this.index >= this.source.length;
    };
    StringStream.prototype.next = function () {
        var next = this.peek();
        this.advance();
        return next;
    };
    StringStream.prototype.peek = function () {
        return this.source[this.index];
    };
    StringStream.prototype.advance = function () {
        this.index++;
    };
    return StringStream;
}());
function _renderFormattedText(element, treeNode, actionHandler) {
    var child;
    if (treeNode.type === 2 /* Text */) {
        child = document.createTextNode(treeNode.content);
    }
    else if (treeNode.type === 3 /* Bold */) {
        child = document.createElement('b');
    }
    else if (treeNode.type === 4 /* Italics */) {
        child = document.createElement('i');
    }
    else if (treeNode.type === 5 /* Action */ && actionHandler) {
        var a = document.createElement('a');
        a.href = '#';
        actionHandler.disposeables.push(__WEBPACK_IMPORTED_MODULE_0__dom_js__["j" /* addStandardDisposableListener */](a, 'click', function (event) {
            actionHandler.callback(String(treeNode.index), event);
        }));
        child = a;
    }
    else if (treeNode.type === 7 /* NewLine */) {
        child = document.createElement('br');
    }
    else if (treeNode.type === 1 /* Root */) {
        child = element;
    }
    if (element !== child) {
        element.appendChild(child);
    }
    if (Array.isArray(treeNode.children)) {
        treeNode.children.forEach(function (nodeChild) {
            _renderFormattedText(child, nodeChild, actionHandler);
        });
    }
}
function parseFormattedText(content) {
    var root = {
        type: 1 /* Root */,
        children: []
    };
    var actionItemIndex = 0;
    var current = root;
    var stack = [];
    var stream = new StringStream(content);
    while (!stream.eos()) {
        var next = stream.next();
        var isEscapedFormatType = (next === '\\' && formatTagType(stream.peek()) !== 0 /* Invalid */);
        if (isEscapedFormatType) {
            next = stream.next(); // unread the backslash if it escapes a format tag type
        }
        if (!isEscapedFormatType && isFormatTag(next) && next === stream.peek()) {
            stream.advance();
            if (current.type === 2 /* Text */) {
                current = stack.pop();
            }
            var type = formatTagType(next);
            if (current.type === type || (current.type === 5 /* Action */ && type === 6 /* ActionClose */)) {
                current = stack.pop();
            }
            else {
                var newCurrent = {
                    type: type,
                    children: []
                };
                if (type === 5 /* Action */) {
                    newCurrent.index = actionItemIndex;
                    actionItemIndex++;
                }
                current.children.push(newCurrent);
                stack.push(current);
                current = newCurrent;
            }
        }
        else if (next === '\n') {
            if (current.type === 2 /* Text */) {
                current = stack.pop();
            }
            current.children.push({
                type: 7 /* NewLine */
            });
        }
        else {
            if (current.type !== 2 /* Text */) {
                var textCurrent = {
                    type: 2 /* Text */,
                    content: next
                };
                current.children.push(textCurrent);
                stack.push(current);
                current = textCurrent;
            }
            else {
                current.content += next;
            }
        }
    }
    if (current.type === 2 /* Text */) {
        current = stack.pop();
    }
    if (stack.length) {
        // incorrectly formatted string literal
    }
    return root;
}
function isFormatTag(char) {
    return formatTagType(char) !== 0 /* Invalid */;
}
function formatTagType(char) {
    switch (char) {
        case '*':
            return 3 /* Bold */;
        case '_':
            return 4 /* Italics */;
        case '[':
            return 5 /* Action */;
        case ']':
            return 6 /* ActionClose */;
        default:
            return 0 /* Invalid */;
    }
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultGenerator; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var IdGenerator = /** @class */ (function () {
    function IdGenerator(prefix) {
        this._prefix = prefix;
        this._lastId = 0;
    }
    IdGenerator.prototype.nextId = function () {
        return this._prefix + (++this._lastId);
    };
    return IdGenerator;
}());

var defaultGenerator = new IdGenerator('id#');


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonEditorConfiguration; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isEditorConfigurationKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = isDiffEditorConfigurationKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_configuration_common_configurationRegistry_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fontInfo_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editorZoom_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__ = __webpack_require__(45);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var EDITOR_DEFAULTS = __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["a" /* EDITOR_DEFAULTS */];
var EDITOR_FONT_DEFAULTS = __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["b" /* EDITOR_FONT_DEFAULTS */];
var EDITOR_MODEL_DEFAULTS = __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */];
var TabFocus = new /** @class */ (function () {
    function class_1() {
        this._tabFocus = false;
        this._onDidChangeTabFocus = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.onDidChangeTabFocus = this._onDidChangeTabFocus.event;
    }
    class_1.prototype.getTabFocusMode = function () {
        return this._tabFocus;
    };
    class_1.prototype.setTabFocusMode = function (tabFocusMode) {
        if (this._tabFocus === tabFocusMode) {
            return;
        }
        this._tabFocus = tabFocusMode;
        this._onDidChangeTabFocus.fire(this._tabFocus);
    };
    return class_1;
}());
var hasOwnProperty = Object.hasOwnProperty;
var CommonEditorConfiguration = /** @class */ (function (_super) {
    __extends(CommonEditorConfiguration, _super);
    function CommonEditorConfiguration(options) {
        var _this = _super.call(this) || this;
        _this._onDidChange = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChange = _this._onDidChange.event;
        // Do a "deep clone of sorts" on the incoming options
        _this._rawOptions = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["g" /* mixin */]({}, options || {});
        _this._rawOptions.scrollbar = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["g" /* mixin */]({}, _this._rawOptions.scrollbar || {});
        _this._rawOptions.minimap = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["g" /* mixin */]({}, _this._rawOptions.minimap || {});
        _this._rawOptions.find = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["g" /* mixin */]({}, _this._rawOptions.find || {});
        _this._rawOptions.hover = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["g" /* mixin */]({}, _this._rawOptions.hover || {});
        _this._validatedOptions = __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["d" /* EditorOptionsValidator */].validate(_this._rawOptions, EDITOR_DEFAULTS);
        _this.editor = null;
        _this._isDominatedByLongLines = false;
        _this._lineNumbersDigitCount = 1;
        _this._register(__WEBPACK_IMPORTED_MODULE_8__editorZoom_js__["a" /* EditorZoom */].onDidChangeZoomLevel(function (_) { return _this._recomputeOptions(); }));
        _this._register(TabFocus.onDidChangeTabFocus(function (_) { return _this._recomputeOptions(); }));
        return _this;
    }
    CommonEditorConfiguration.prototype.observeReferenceElement = function (dimension) {
    };
    CommonEditorConfiguration.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    CommonEditorConfiguration.prototype._recomputeOptions = function () {
        var oldOptions = this.editor;
        var newOptions = this._computeInternalOptions();
        if (oldOptions && oldOptions.equals(newOptions)) {
            return;
        }
        this.editor = newOptions;
        if (oldOptions) {
            this._onDidChange.fire(oldOptions.createChangeEvent(newOptions));
        }
    };
    CommonEditorConfiguration.prototype.getRawOptions = function () {
        return this._rawOptions;
    };
    CommonEditorConfiguration.prototype._computeInternalOptions = function () {
        var opts = this._validatedOptions;
        var partialEnv = this._getEnvConfiguration();
        var bareFontInfo = __WEBPACK_IMPORTED_MODULE_7__fontInfo_js__["a" /* BareFontInfo */].createFromRawSettings(this._rawOptions, partialEnv.zoomLevel);
        var env = {
            outerWidth: partialEnv.outerWidth,
            outerHeight: partialEnv.outerHeight,
            fontInfo: this.readConfiguration(bareFontInfo),
            extraEditorClassName: partialEnv.extraEditorClassName,
            isDominatedByLongLines: this._isDominatedByLongLines,
            lineNumbersDigitCount: this._lineNumbersDigitCount,
            emptySelectionClipboard: partialEnv.emptySelectionClipboard,
            pixelRatio: partialEnv.pixelRatio,
            tabFocusMode: TabFocus.getTabFocusMode(),
            accessibilitySupport: partialEnv.accessibilitySupport
        };
        return __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["f" /* InternalEditorOptionsFactory */].createInternalEditorOptions(env, opts);
    };
    CommonEditorConfiguration._primitiveArrayEquals = function (a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) {
                return false;
            }
        }
        return true;
    };
    CommonEditorConfiguration._subsetEquals = function (base, subset) {
        for (var key in subset) {
            if (hasOwnProperty.call(subset, key)) {
                var subsetValue = subset[key];
                var baseValue = base[key];
                if (baseValue === subsetValue) {
                    continue;
                }
                if (Array.isArray(baseValue) && Array.isArray(subsetValue)) {
                    if (!this._primitiveArrayEquals(baseValue, subsetValue)) {
                        return false;
                    }
                    continue;
                }
                if (typeof baseValue === 'object' && typeof subsetValue === 'object') {
                    if (!this._subsetEquals(baseValue, subsetValue)) {
                        return false;
                    }
                    continue;
                }
                return false;
            }
        }
        return true;
    };
    CommonEditorConfiguration.prototype.updateOptions = function (newOptions) {
        if (typeof newOptions === 'undefined') {
            return;
        }
        if (CommonEditorConfiguration._subsetEquals(this._rawOptions, newOptions)) {
            return;
        }
        this._rawOptions = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["g" /* mixin */](this._rawOptions, newOptions || {});
        this._validatedOptions = __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["d" /* EditorOptionsValidator */].validate(this._rawOptions, EDITOR_DEFAULTS);
        this._recomputeOptions();
    };
    CommonEditorConfiguration.prototype.setIsDominatedByLongLines = function (isDominatedByLongLines) {
        this._isDominatedByLongLines = isDominatedByLongLines;
        this._recomputeOptions();
    };
    CommonEditorConfiguration.prototype.setMaxLineNumber = function (maxLineNumber) {
        var digitCount = CommonEditorConfiguration._digitCount(maxLineNumber);
        if (this._lineNumbersDigitCount === digitCount) {
            return;
        }
        this._lineNumbersDigitCount = digitCount;
        this._recomputeOptions();
    };
    CommonEditorConfiguration._digitCount = function (n) {
        var r = 0;
        while (n) {
            n = Math.floor(n / 10);
            r++;
        }
        return r ? r : 1;
    };
    return CommonEditorConfiguration;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));

var configurationRegistry = __WEBPACK_IMPORTED_MODULE_6__platform_registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_5__platform_configuration_common_configurationRegistry_js__["b" /* Extensions */].Configuration);
var editorConfiguration = {
    'id': 'editor',
    'order': 5,
    'type': 'object',
    'title': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editorConfigurationTitle', "Editor"),
    'overridable': true,
    'scope': __WEBPACK_IMPORTED_MODULE_5__platform_configuration_common_configurationRegistry_js__["a" /* ConfigurationScope */].RESOURCE,
    'properties': {
        'editor.fontFamily': {
            'type': 'string',
            'default': EDITOR_FONT_DEFAULTS.fontFamily,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('fontFamily', "Controls the font family.")
        },
        'editor.fontWeight': {
            'type': 'string',
            'enum': ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'],
            'default': EDITOR_FONT_DEFAULTS.fontWeight,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('fontWeight', "Controls the font weight.")
        },
        'editor.fontSize': {
            'type': 'number',
            'default': EDITOR_FONT_DEFAULTS.fontSize,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('fontSize', "Controls the font size in pixels.")
        },
        'editor.lineHeight': {
            'type': 'number',
            'default': EDITOR_FONT_DEFAULTS.lineHeight,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineHeight', "Controls the line height. Use 0 to compute the line height from the font size.")
        },
        'editor.letterSpacing': {
            'type': 'number',
            'default': EDITOR_FONT_DEFAULTS.letterSpacing,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('letterSpacing', "Controls the letter spacing in pixels.")
        },
        'editor.lineNumbers': {
            'type': 'string',
            'enum': ['off', 'on', 'relative', 'interval'],
            'enumDescriptions': [
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineNumbers.off', "Line numbers are not rendered."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineNumbers.on', "Line numbers are rendered as absolute number."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineNumbers.relative', "Line numbers are rendered as distance in lines to cursor position."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineNumbers.interval', "Line numbers are rendered every 10 lines.")
            ],
            'default': 'on',
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lineNumbers', "Controls the display of line numbers.")
        },
        'editor.rulers': {
            'type': 'array',
            'items': {
                'type': 'number'
            },
            'default': EDITOR_DEFAULTS.viewInfo.rulers,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('rulers', "Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.")
        },
        'editor.wordSeparators': {
            'type': 'string',
            'default': EDITOR_DEFAULTS.wordSeparators,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordSeparators', "Characters that will be used as word separators when doing word related navigations or operations.")
        },
        'editor.tabSize': {
            'type': 'number',
            'default': EDITOR_MODEL_DEFAULTS.tabSize,
            'minimum': 1,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('tabSize', "The number of spaces a tab is equal to. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on."),
            'errorMessage': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('tabSize.errorMessage', "Expected 'number'. Note that the value \"auto\" has been replaced by the `editor.detectIndentation` setting.")
        },
        'editor.insertSpaces': {
            'type': 'boolean',
            'default': EDITOR_MODEL_DEFAULTS.insertSpaces,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('insertSpaces', "Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on."),
            'errorMessage': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('insertSpaces.errorMessage', "Expected 'boolean'. Note that the value \"auto\" has been replaced by the `editor.detectIndentation` setting.")
        },
        'editor.detectIndentation': {
            'type': 'boolean',
            'default': EDITOR_MODEL_DEFAULTS.detectIndentation,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('detectIndentation', "Controls whether `#editor.tabSize#` and `#editor.insertSpaces#` will be automatically detected when a file is opened based on the file contents.")
        },
        'editor.roundedSelection': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.roundedSelection,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('roundedSelection', "Controls whether selections should have rounded corners.")
        },
        'editor.scrollBeyondLastLine': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.scrollBeyondLastLine,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('scrollBeyondLastLine', "Controls whether the editor will scroll beyond the last line.")
        },
        'editor.scrollBeyondLastColumn': {
            'type': 'number',
            'default': EDITOR_DEFAULTS.viewInfo.scrollBeyondLastColumn,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('scrollBeyondLastColumn', "Controls the number of extra characters beyond which the editor will scroll horizontally.")
        },
        'editor.smoothScrolling': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.smoothScrolling,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('smoothScrolling', "Controls whether the editor will scroll using an animation.")
        },
        'editor.minimap.enabled': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.minimap.enabled,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('minimap.enabled', "Controls whether the minimap is shown.")
        },
        'editor.minimap.side': {
            'type': 'string',
            'enum': ['left', 'right'],
            'default': EDITOR_DEFAULTS.viewInfo.minimap.side,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('minimap.side', "Controls the side where to render the minimap.")
        },
        'editor.minimap.showSlider': {
            'type': 'string',
            'enum': ['always', 'mouseover'],
            'default': EDITOR_DEFAULTS.viewInfo.minimap.showSlider,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('minimap.showSlider', "Controls whether the minimap slider is automatically hidden.")
        },
        'editor.minimap.renderCharacters': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.minimap.renderCharacters,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('minimap.renderCharacters', "Render the actual characters on a line as opposed to color blocks.")
        },
        'editor.minimap.maxColumn': {
            'type': 'number',
            'default': EDITOR_DEFAULTS.viewInfo.minimap.maxColumn,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('minimap.maxColumn', "Limit the width of the minimap to render at most a certain number of columns.")
        },
        'editor.hover.enabled': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.hover.enabled,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hover.enabled', "Controls whether the hover is shown.")
        },
        'editor.hover.delay': {
            'type': 'number',
            'default': EDITOR_DEFAULTS.contribInfo.hover.delay,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hover.delay', "Time delay in milliseconds after which to the hover is shown.")
        },
        'editor.hover.sticky': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.hover.sticky,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hover.sticky', "Controls whether the hover should remain visible when mouse is moved over it.")
        },
        'editor.find.seedSearchStringFromSelection': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.find.seedSearchStringFromSelection,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('find.seedSearchStringFromSelection', "Controls whether the search string in the Find Widget is seeded from the editor selection.")
        },
        'editor.find.autoFindInSelection': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.find.autoFindInSelection,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('find.autoFindInSelection', "Controls whether the find operation is carried on selected text or the entire file in the editor.")
        },
        'editor.find.globalFindClipboard': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.find.globalFindClipboard,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('find.globalFindClipboard', "Controls whether the Find Widget should read or modify the shared find clipboard on macOS."),
            'included': __WEBPACK_IMPORTED_MODULE_4__base_common_platform_js__["d" /* isMacintosh */]
        },
        'editor.wordWrap': {
            'type': 'string',
            'enum': ['off', 'on', 'wordWrapColumn', 'bounded'],
            'enumDescriptions': [
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordWrap.off', "Lines will never wrap."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordWrap.on', "Lines will wrap at the viewport width."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({
                    key: 'wordWrap.wordWrapColumn',
                    comment: [
                        '- `editor.wordWrapColumn` refers to a different setting and should not be localized.'
                    ]
                }, "Lines will wrap at `#editor.wordWrapColumn#`."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({
                    key: 'wordWrap.bounded',
                    comment: [
                        '- viewport means the edge of the visible window size.',
                        '- `editor.wordWrapColumn` refers to a different setting and should not be localized.'
                    ]
                }, "Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`."),
            ],
            'default': EDITOR_DEFAULTS.wordWrap,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({
                key: 'wordWrap',
                comment: [
                    '- \'off\', \'on\', \'wordWrapColumn\' and \'bounded\' refer to values the setting can take and should not be localized.',
                    '- `editor.wordWrapColumn` refers to a different setting and should not be localized.'
                ]
            }, "Controls how lines should wrap.")
        },
        'editor.wordWrapColumn': {
            'type': 'integer',
            'default': EDITOR_DEFAULTS.wordWrapColumn,
            'minimum': 1,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({
                key: 'wordWrapColumn',
                comment: [
                    '- `editor.wordWrap` refers to a different setting and should not be localized.',
                    '- \'wordWrapColumn\' and \'bounded\' refer to values the different setting can take and should not be localized.'
                ]
            }, "Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.")
        },
        'editor.wrappingIndent': {
            'type': 'string',
            'enum': ['none', 'same', 'indent', 'deepIndent'],
            enumDescriptions: [
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wrappingIndent.none', "No indentation. Wrapped lines begin at column 1."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wrappingIndent.same', "Wrapped lines get the same indentation as the parent."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wrappingIndent.indent', "Wrapped lines get +1 indentation toward the parent."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wrappingIndent.deepIndent', "Wrapped lines get +2 indentation toward the parent."),
            ],
            'default': 'same',
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wrappingIndent', "Controls the indentation of wrapped lines."),
        },
        'editor.mouseWheelScrollSensitivity': {
            'type': 'number',
            'default': EDITOR_DEFAULTS.viewInfo.scrollbar.mouseWheelScrollSensitivity,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('mouseWheelScrollSensitivity', "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.")
        },
        'editor.multiCursorModifier': {
            'type': 'string',
            'enum': ['ctrlCmd', 'alt'],
            'enumDescriptions': [
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('multiCursorModifier.ctrlCmd', "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('multiCursorModifier.alt', "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
            ],
            'default': 'alt',
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({
                key: 'multiCursorModifier',
                comment: [
                    '- `ctrlCmd` refers to a value the setting can take and should not be localized.',
                    '- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized.'
                ]
            }, "The modifier to be used to add multiple cursors with the mouse. The Go To Definition and Open Link mouse gestures will adapt such that they do not conflict with the multicursor modifier. [Read more](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).")
        },
        'editor.multiCursorMergeOverlapping': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.multiCursorMergeOverlapping,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('multiCursorMergeOverlapping', "Merge multiple cursors when they are overlapping.")
        },
        'editor.quickSuggestions': {
            'anyOf': [
                {
                    type: 'boolean',
                },
                {
                    type: 'object',
                    properties: {
                        strings: {
                            type: 'boolean',
                            default: false,
                            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickSuggestions.strings', "Enable quick suggestions inside strings.")
                        },
                        comments: {
                            type: 'boolean',
                            default: false,
                            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickSuggestions.comments', "Enable quick suggestions inside comments.")
                        },
                        other: {
                            type: 'boolean',
                            default: true,
                            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickSuggestions.other', "Enable quick suggestions outside of strings and comments.")
                        },
                    }
                }
            ],
            'default': EDITOR_DEFAULTS.contribInfo.quickSuggestions,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickSuggestions', "Controls whether suggestions should automatically show up while typing.")
        },
        'editor.quickSuggestionsDelay': {
            'type': 'integer',
            'default': EDITOR_DEFAULTS.contribInfo.quickSuggestionsDelay,
            'minimum': 0,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickSuggestionsDelay', "Controls the delay in milliseconds after which quick suggestions will show up.")
        },
        'editor.parameterHints': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.parameterHints,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('parameterHints', "Enables a pop-up that shows parameter documentation and type information as you type.")
        },
        'editor.autoClosingBrackets': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.autoClosingBrackets,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('autoClosingBrackets', "Controls whether the editor should automatically close brackets after the user adds an opening bracket.")
        },
        'editor.formatOnType': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.formatOnType,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('formatOnType', "Controls whether the editor should automatically format the line after typing.")
        },
        'editor.formatOnPaste': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.formatOnPaste,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('formatOnPaste', "Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.")
        },
        'editor.autoIndent': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.autoIndent,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('autoIndent', "Controls whether the editor should automatically adjust the indentation when users type, paste or move lines. Extensions with indentation rules of the language must be available.")
        },
        'editor.suggestOnTriggerCharacters': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.suggestOnTriggerCharacters,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggestOnTriggerCharacters', "Controls whether suggestions should automatically show up when typing trigger characters.")
        },
        'editor.acceptSuggestionOnEnter': {
            'type': 'string',
            'enum': ['on', 'smart', 'off'],
            'default': EDITOR_DEFAULTS.contribInfo.acceptSuggestionOnEnter,
            'enumDescriptions': [
                '',
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('acceptSuggestionOnEnterSmart', "Only accept a suggestion with `Enter` when it makes a textual change."),
                ''
            ],
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('acceptSuggestionOnEnter', "Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.")
        },
        'editor.acceptSuggestionOnCommitCharacter': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.acceptSuggestionOnCommitCharacter,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('acceptSuggestionOnCommitCharacter', "Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.")
        },
        'editor.snippetSuggestions': {
            'type': 'string',
            'enum': ['top', 'bottom', 'inline', 'none'],
            'enumDescriptions': [
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('snippetSuggestions.top', "Show snippet suggestions on top of other suggestions."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('snippetSuggestions.bottom', "Show snippet suggestions below other suggestions."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('snippetSuggestions.inline', "Show snippets suggestions with other suggestions."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('snippetSuggestions.none', "Do not show snippet suggestions."),
            ],
            'default': EDITOR_DEFAULTS.contribInfo.suggest.snippets,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('snippetSuggestions', "Controls whether snippets are shown with other suggestions and how they are sorted.")
        },
        'editor.emptySelectionClipboard': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.emptySelectionClipboard,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('emptySelectionClipboard', "Controls whether copying without a selection copies the current line.")
        },
        'editor.wordBasedSuggestions': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.wordBasedSuggestions,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordBasedSuggestions', "Controls whether completions should be computed based on words in the document.")
        },
        'editor.suggestSelection': {
            'type': 'string',
            'enum': ['first', 'recentlyUsed', 'recentlyUsedByPrefix'],
            'enumDescriptions': [
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggestSelection.first', "Always select the first suggestion."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggestSelection.recentlyUsed', "Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggestSelection.recentlyUsedByPrefix', "Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`."),
            ],
            'default': 'recentlyUsed',
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggestSelection', "Controls how suggestions are pre-selected when showing the suggest list.")
        },
        'editor.suggestFontSize': {
            'type': 'integer',
            'default': 0,
            'minimum': 0,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggestFontSize', "Font size for the suggest widget.")
        },
        'editor.suggestLineHeight': {
            'type': 'integer',
            'default': 0,
            'minimum': 0,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggestLineHeight', "Line height for the suggest widget.")
        },
        'editor.suggest.filterGraceful': {
            type: 'boolean',
            default: true,
            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggest.filterGraceful', "Controls whether filtering and sorting suggestions accounts for small typos.")
        },
        'editor.suggest.snippetsPreventQuickSuggestions': {
            type: 'boolean',
            default: true,
            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggest.snippetsPreventQuickSuggestions', "Control whether an active snippet prevents quick suggestions.")
        },
        'editor.selectionHighlight': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.selectionHighlight,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('selectionHighlight', "Controls whether the editor should highlight matches similar to the selection")
        },
        'editor.occurrencesHighlight': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.occurrencesHighlight,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('occurrencesHighlight', "Controls whether the editor should highlight semantic symbol occurrences.")
        },
        'editor.overviewRulerLanes': {
            'type': 'integer',
            'default': 3,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overviewRulerLanes', "Controls the number of decorations that can show up at the same position in the overview ruler.")
        },
        'editor.overviewRulerBorder': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.overviewRulerBorder,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overviewRulerBorder', "Controls whether a border should be drawn around the overview ruler.")
        },
        'editor.cursorBlinking': {
            'type': 'string',
            'enum': ['blink', 'smooth', 'phase', 'expand', 'solid'],
            'default': __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["k" /* blinkingStyleToString */](EDITOR_DEFAULTS.viewInfo.cursorBlinking),
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('cursorBlinking', "Control the cursor animation style.")
        },
        'editor.mouseWheelZoom': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.mouseWheelZoom,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('mouseWheelZoom', "Zoom the font of the editor when using mouse wheel and holding `Ctrl`.")
        },
        'editor.cursorStyle': {
            'type': 'string',
            'enum': ['block', 'block-outline', 'line', 'line-thin', 'underline', 'underline-thin'],
            'default': __WEBPACK_IMPORTED_MODULE_9__editorOptions_js__["l" /* cursorStyleToString */](EDITOR_DEFAULTS.viewInfo.cursorStyle),
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('cursorStyle', "Controls the cursor style.")
        },
        'editor.cursorWidth': {
            'type': 'integer',
            'default': EDITOR_DEFAULTS.viewInfo.cursorWidth,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('cursorWidth', "Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.")
        },
        'editor.fontLigatures': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.fontLigatures,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('fontLigatures', "Enables/Disables font ligatures.")
        },
        'editor.hideCursorInOverviewRuler': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.hideCursorInOverviewRuler,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hideCursorInOverviewRuler', "Controls whether the cursor should be hidden in the overview ruler.")
        },
        'editor.renderWhitespace': {
            'type': 'string',
            'enum': ['none', 'boundary', 'all'],
            'enumDescriptions': [
                '',
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('renderWhiteSpace.boundary', "Render whitespace characters except for single spaces between words."),
                ''
            ],
            default: EDITOR_DEFAULTS.viewInfo.renderWhitespace,
            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('renderWhitespace', "Controls how the editor should render whitespace characters.")
        },
        'editor.renderControlCharacters': {
            'type': 'boolean',
            default: EDITOR_DEFAULTS.viewInfo.renderControlCharacters,
            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('renderControlCharacters', "Controls whether the editor should render control characters.")
        },
        'editor.renderIndentGuides': {
            'type': 'boolean',
            default: EDITOR_DEFAULTS.viewInfo.renderIndentGuides,
            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('renderIndentGuides', "Controls whether the editor should render indent guides.")
        },
        'editor.highlightActiveIndentGuide': {
            'type': 'boolean',
            default: EDITOR_DEFAULTS.viewInfo.highlightActiveIndentGuide,
            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('highlightActiveIndentGuide', "Controls whether the editor should highlight the active indent guide.")
        },
        'editor.renderLineHighlight': {
            'type': 'string',
            'enum': ['none', 'gutter', 'line', 'all'],
            'enumDescriptions': [
                '',
                '',
                '',
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('renderLineHighlight.all', "Highlights both the gutter and the current line."),
            ],
            default: EDITOR_DEFAULTS.viewInfo.renderLineHighlight,
            description: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('renderLineHighlight', "Controls how the editor should render the current line highlight.")
        },
        'editor.codeLens': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.codeLens,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('codeLens', "Controls whether the editor shows CodeLens")
        },
        'editor.folding': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.folding,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('folding', "Controls whether the editor has code folding enabled")
        },
        'editor.foldingStrategy': {
            'type': 'string',
            'enum': ['auto', 'indentation'],
            'default': EDITOR_DEFAULTS.contribInfo.foldingStrategy,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('foldingStrategy', "Controls the strategy for computing folding ranges. `auto` uses a language specific folding strategy, if available. `indentation` uses the indentation based folding strategy.")
        },
        'editor.showFoldingControls': {
            'type': 'string',
            'enum': ['always', 'mouseover'],
            'default': EDITOR_DEFAULTS.contribInfo.showFoldingControls,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('showFoldingControls', "Controls whether the fold controls on the gutter are automatically hidden.")
        },
        'editor.matchBrackets': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.matchBrackets,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('matchBrackets', "Highlight matching brackets when one of them is selected.")
        },
        'editor.glyphMargin': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.viewInfo.glyphMargin,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('glyphMargin', "Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.")
        },
        'editor.useTabStops': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.useTabStops,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('useTabStops', "Inserting and deleting whitespace follows tab stops.")
        },
        'editor.trimAutoWhitespace': {
            'type': 'boolean',
            'default': EDITOR_MODEL_DEFAULTS.trimAutoWhitespace,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('trimAutoWhitespace', "Remove trailing auto inserted whitespace.")
        },
        'editor.stablePeek': {
            'type': 'boolean',
            'default': false,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('stablePeek', "Keep peek editors open even when double clicking their content or when hitting `Escape`.")
        },
        'editor.dragAndDrop': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.dragAndDrop,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('dragAndDrop', "Controls whether the editor should allow moving selections via drag and drop.")
        },
        'editor.accessibilitySupport': {
            'type': 'string',
            'enum': ['auto', 'on', 'off'],
            'enumDescriptions': [
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('accessibilitySupport.auto', "The editor will use platform APIs to detect when a Screen Reader is attached."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('accessibilitySupport.on', "The editor will be permanently optimized for usage with a Screen Reader."),
                __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('accessibilitySupport.off', "The editor will never be optimized for usage with a Screen Reader."),
            ],
            'default': EDITOR_DEFAULTS.accessibilitySupport,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('accessibilitySupport', "Controls whether the editor should run in a mode where it is optimized for screen readers.")
        },
        'editor.showUnused': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.showUnused,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('showUnused', "Controls fading out of unused code.")
        },
        'editor.links': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.links,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('links', "Controls whether the editor should detect links and make them clickable.")
        },
        'editor.colorDecorators': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.colorDecorators,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('colorDecorators', "Controls whether the editor should render the inline color decorators and color picker.")
        },
        'editor.lightbulb.enabled': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.lightbulbEnabled,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('codeActions', "Enables the code action lightbulb in the editor.")
        },
        'editor.codeActionsOnSave': {
            'type': 'object',
            'properties': {
                'source.organizeImports': {
                    'type': 'boolean',
                    'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('codeActionsOnSave.organizeImports', "Controls whether organize imports action should be run on file save.")
                }
            },
            'additionalProperties': {
                'type': 'boolean'
            },
            'default': EDITOR_DEFAULTS.contribInfo.codeActionsOnSave,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('codeActionsOnSave', "Code action kinds to be run on save.")
        },
        'editor.codeActionsOnSaveTimeout': {
            'type': 'number',
            'default': EDITOR_DEFAULTS.contribInfo.codeActionsOnSaveTimeout,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('codeActionsOnSaveTimeout', "Timeout in milliseconds after which the code actions that are run on save are cancelled.")
        },
        'editor.selectionClipboard': {
            'type': 'boolean',
            'default': EDITOR_DEFAULTS.contribInfo.selectionClipboard,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('selectionClipboard', "Controls whether the Linux primary clipboard should be supported."),
            'included': __WEBPACK_IMPORTED_MODULE_4__base_common_platform_js__["c" /* isLinux */]
        },
        'diffEditor.renderSideBySide': {
            'type': 'boolean',
            'default': true,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('sideBySide', "Controls whether the diff editor shows the diff side by side or inline.")
        },
        'diffEditor.ignoreTrimWhitespace': {
            'type': 'boolean',
            'default': true,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('ignoreTrimWhitespace', "Controls whether the diff editor shows changes in leading or trailing whitespace as diffs.")
        },
        'editor.largeFileOptimizations': {
            'type': 'boolean',
            'default': EDITOR_MODEL_DEFAULTS.largeFileOptimizations,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('largeFileOptimizations', "Special handling for large files to disable certain memory intensive features.")
        },
        'diffEditor.renderIndicators': {
            'type': 'boolean',
            'default': true,
            'description': __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('renderIndicators', "Controls whether the diff editor shows +/- indicators for added/removed changes.")
        }
    }
};
var cachedEditorConfigurationKeys = null;
function getEditorConfigurationKeys() {
    if (cachedEditorConfigurationKeys === null) {
        cachedEditorConfigurationKeys = Object.create(null);
        Object.keys(editorConfiguration.properties).forEach(function (prop) {
            cachedEditorConfigurationKeys[prop] = true;
        });
    }
    return cachedEditorConfigurationKeys;
}
function isEditorConfigurationKey(key) {
    var editorConfigurationKeys = getEditorConfigurationKeys();
    return (editorConfigurationKeys["editor." + key] || false);
}
function isDiffEditorConfigurationKey(key) {
    var editorConfigurationKeys = getEditorConfigurationKeys();
    return (editorConfigurationKeys["diffEditor." + key] || false);
}
configurationRegistry.registerConfiguration(editorConfiguration);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BareFontInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FontInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editorZoom_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorOptions_js__ = __webpack_require__(45);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * Determined from empirical observations.
 * @internal
 */
var GOLDEN_LINE_HEIGHT_RATIO = __WEBPACK_IMPORTED_MODULE_0__base_common_platform_js__["d" /* isMacintosh */] ? 1.5 : 1.35;
/**
 * Font settings maximum and minimum limits
 */
var MINIMUM_FONT_SIZE = 8;
var MAXIMUM_FONT_SIZE = 100;
var MINIMUM_LINE_HEIGHT = 8;
var MAXIMUM_LINE_HEIGHT = 150;
var MINIMUM_LETTER_SPACING = -5;
var MAXIMUM_LETTER_SPACING = 20;
function safeParseFloat(n, defaultValue) {
    if (typeof n === 'number') {
        return n;
    }
    var r = parseFloat(n);
    if (isNaN(r)) {
        return defaultValue;
    }
    return r;
}
function safeParseInt(n, defaultValue) {
    if (typeof n === 'number') {
        return Math.round(n);
    }
    var r = parseInt(n);
    if (isNaN(r)) {
        return defaultValue;
    }
    return r;
}
function clamp(n, min, max) {
    if (n < min) {
        return min;
    }
    if (n > max) {
        return max;
    }
    return n;
}
function _string(value, defaultValue) {
    if (typeof value !== 'string') {
        return defaultValue;
    }
    return value;
}
var BareFontInfo = /** @class */ (function () {
    /**
     * @internal
     */
    function BareFontInfo(opts) {
        this.zoomLevel = opts.zoomLevel;
        this.fontFamily = String(opts.fontFamily);
        this.fontWeight = String(opts.fontWeight);
        this.fontSize = opts.fontSize;
        this.lineHeight = opts.lineHeight | 0;
        this.letterSpacing = opts.letterSpacing;
    }
    /**
     * @internal
     */
    BareFontInfo.createFromRawSettings = function (opts, zoomLevel) {
        var fontFamily = _string(opts.fontFamily, __WEBPACK_IMPORTED_MODULE_2__editorOptions_js__["b" /* EDITOR_FONT_DEFAULTS */].fontFamily);
        var fontWeight = _string(opts.fontWeight, __WEBPACK_IMPORTED_MODULE_2__editorOptions_js__["b" /* EDITOR_FONT_DEFAULTS */].fontWeight);
        var fontSize = safeParseFloat(opts.fontSize, __WEBPACK_IMPORTED_MODULE_2__editorOptions_js__["b" /* EDITOR_FONT_DEFAULTS */].fontSize);
        fontSize = clamp(fontSize, 0, MAXIMUM_FONT_SIZE);
        if (fontSize === 0) {
            fontSize = __WEBPACK_IMPORTED_MODULE_2__editorOptions_js__["b" /* EDITOR_FONT_DEFAULTS */].fontSize;
        }
        else if (fontSize < MINIMUM_FONT_SIZE) {
            fontSize = MINIMUM_FONT_SIZE;
        }
        var lineHeight = safeParseInt(opts.lineHeight, 0);
        lineHeight = clamp(lineHeight, 0, MAXIMUM_LINE_HEIGHT);
        if (lineHeight === 0) {
            lineHeight = Math.round(GOLDEN_LINE_HEIGHT_RATIO * fontSize);
        }
        else if (lineHeight < MINIMUM_LINE_HEIGHT) {
            lineHeight = MINIMUM_LINE_HEIGHT;
        }
        var letterSpacing = safeParseFloat(opts.letterSpacing, 0);
        letterSpacing = clamp(letterSpacing, MINIMUM_LETTER_SPACING, MAXIMUM_LETTER_SPACING);
        var editorZoomLevelMultiplier = 1 + (__WEBPACK_IMPORTED_MODULE_1__editorZoom_js__["a" /* EditorZoom */].getZoomLevel() * 0.1);
        fontSize *= editorZoomLevelMultiplier;
        lineHeight *= editorZoomLevelMultiplier;
        return new BareFontInfo({
            zoomLevel: zoomLevel,
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: fontSize,
            lineHeight: lineHeight,
            letterSpacing: letterSpacing
        });
    };
    /**
     * @internal
     */
    BareFontInfo.prototype.getId = function () {
        return this.zoomLevel + '-' + this.fontFamily + '-' + this.fontWeight + '-' + this.fontSize + '-' + this.lineHeight + '-' + this.letterSpacing;
    };
    return BareFontInfo;
}());

var FontInfo = /** @class */ (function (_super) {
    __extends(FontInfo, _super);
    /**
     * @internal
     */
    function FontInfo(opts, isTrusted) {
        var _this = _super.call(this, opts) || this;
        _this.isTrusted = isTrusted;
        _this.isMonospace = opts.isMonospace;
        _this.typicalHalfwidthCharacterWidth = opts.typicalHalfwidthCharacterWidth;
        _this.typicalFullwidthCharacterWidth = opts.typicalFullwidthCharacterWidth;
        _this.spaceWidth = opts.spaceWidth;
        _this.maxDigitWidth = opts.maxDigitWidth;
        return _this;
    }
    /**
     * @internal
     */
    FontInfo.prototype.equals = function (other) {
        return (this.fontFamily === other.fontFamily
            && this.fontWeight === other.fontWeight
            && this.fontSize === other.fontSize
            && this.lineHeight === other.lineHeight
            && this.letterSpacing === other.letterSpacing
            && this.typicalHalfwidthCharacterWidth === other.typicalHalfwidthCharacterWidth
            && this.typicalFullwidthCharacterWidth === other.typicalFullwidthCharacterWidth
            && this.spaceWidth === other.spaceWidth
            && this.maxDigitWidth === other.maxDigitWidth);
    };
    return FontInfo;
}(BareFontInfo));



/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BracketMatchingController", function() { return BracketMatchingController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bracketMatching_css__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bracketMatching_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bracketMatching_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var overviewRulerBracketMatchForeground = Object(__WEBPACK_IMPORTED_MODULE_11__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorOverviewRuler.bracketMatchForeground', { dark: '#A0A0A0', light: '#A0A0A0', hc: '#A0A0A0' }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('overviewRulerBracketMatchForeground', 'Overview ruler marker color for matching brackets.'));
var JumpToBracketAction = /** @class */ (function (_super) {
    __extends(JumpToBracketAction, _super);
    function JumpToBracketAction() {
        return _super.call(this, {
            id: 'editor.action.jumpToBracket',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('smartSelect.jumpBracket', "Go to Bracket"),
            alias: 'Go to Bracket',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 88 /* US_BACKSLASH */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    JumpToBracketAction.prototype.run = function (accessor, editor) {
        var controller = BracketMatchingController.get(editor);
        if (!controller) {
            return;
        }
        controller.jumpToBracket();
    };
    return JumpToBracketAction;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));
var SelectToBracketAction = /** @class */ (function (_super) {
    __extends(SelectToBracketAction, _super);
    function SelectToBracketAction() {
        return _super.call(this, {
            id: 'editor.action.selectToBracket',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('smartSelect.selectToBracket', "Select to Bracket"),
            alias: 'Select to Bracket',
            precondition: null
        }) || this;
    }
    SelectToBracketAction.prototype.run = function (accessor, editor) {
        var controller = BracketMatchingController.get(editor);
        if (!controller) {
            return;
        }
        controller.selectToBracket();
    };
    return SelectToBracketAction;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));
var BracketsData = /** @class */ (function () {
    function BracketsData(position, brackets) {
        this.position = position;
        this.brackets = brackets;
    }
    return BracketsData;
}());
var BracketMatchingController = /** @class */ (function (_super) {
    __extends(BracketMatchingController, _super);
    function BracketMatchingController(editor) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        _this._lastBracketsData = [];
        _this._lastVersionId = 0;
        _this._decorations = [];
        _this._updateBracketsSoon = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._updateBrackets(); }, 50));
        _this._matchBrackets = _this._editor.getConfiguration().contribInfo.matchBrackets;
        _this._updateBracketsSoon.schedule();
        _this._register(editor.onDidChangeCursorPosition(function (e) {
            if (!_this._matchBrackets) {
                // Early exit if nothing needs to be done!
                // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
                return;
            }
            _this._updateBracketsSoon.schedule();
        }));
        _this._register(editor.onDidChangeModelContent(function (e) {
            _this._updateBracketsSoon.schedule();
        }));
        _this._register(editor.onDidChangeModel(function (e) {
            _this._decorations = [];
            _this._updateBracketsSoon.schedule();
        }));
        _this._register(editor.onDidChangeModelLanguageConfiguration(function (e) {
            _this._lastBracketsData = [];
            _this._updateBracketsSoon.schedule();
        }));
        _this._register(editor.onDidChangeConfiguration(function (e) {
            _this._matchBrackets = _this._editor.getConfiguration().contribInfo.matchBrackets;
            if (!_this._matchBrackets && _this._decorations.length > 0) {
                // Remove existing decorations if bracket matching is off
                _this._decorations = _this._editor.deltaDecorations(_this._decorations, []);
            }
            _this._updateBracketsSoon.schedule();
        }));
        return _this;
    }
    BracketMatchingController.get = function (editor) {
        return editor.getContribution(BracketMatchingController.ID);
    };
    BracketMatchingController.prototype.getId = function () {
        return BracketMatchingController.ID;
    };
    BracketMatchingController.prototype.jumpToBracket = function () {
        var model = this._editor.getModel();
        if (!model) {
            return;
        }
        var newSelections = this._editor.getSelections().map(function (selection) {
            var position = selection.getStartPosition();
            // find matching brackets if position is on a bracket
            var brackets = model.matchBracket(position);
            var newCursorPosition = null;
            if (brackets) {
                if (brackets[0].containsPosition(position)) {
                    newCursorPosition = brackets[1].getStartPosition();
                }
                else if (brackets[1].containsPosition(position)) {
                    newCursorPosition = brackets[0].getStartPosition();
                }
            }
            else {
                // find the next bracket if the position isn't on a matching bracket
                var nextBracket = model.findNextBracket(position);
                if (nextBracket && nextBracket.range) {
                    newCursorPosition = nextBracket.range.getStartPosition();
                }
            }
            if (newCursorPosition) {
                return new __WEBPACK_IMPORTED_MODULE_4__common_core_selection_js__["a" /* Selection */](newCursorPosition.lineNumber, newCursorPosition.column, newCursorPosition.lineNumber, newCursorPosition.column);
            }
            return new __WEBPACK_IMPORTED_MODULE_4__common_core_selection_js__["a" /* Selection */](position.lineNumber, position.column, position.lineNumber, position.column);
        });
        this._editor.setSelections(newSelections);
        this._editor.revealRange(newSelections[0]);
    };
    BracketMatchingController.prototype.selectToBracket = function () {
        var model = this._editor.getModel();
        if (!model) {
            return;
        }
        var newSelections = [];
        this._editor.getSelections().forEach(function (selection) {
            var position = selection.getStartPosition();
            var brackets = model.matchBracket(position);
            var openBracket = null;
            var closeBracket = null;
            if (!brackets) {
                var nextBracket = model.findNextBracket(position);
                if (nextBracket && nextBracket.range) {
                    brackets = model.matchBracket(nextBracket.range.getStartPosition());
                }
            }
            if (brackets) {
                if (brackets[0].startLineNumber === brackets[1].startLineNumber) {
                    openBracket = brackets[1].startColumn < brackets[0].startColumn ?
                        brackets[1].getStartPosition() : brackets[0].getStartPosition();
                    closeBracket = brackets[1].startColumn < brackets[0].startColumn ?
                        brackets[0].getEndPosition() : brackets[1].getEndPosition();
                }
                else {
                    openBracket = brackets[1].startLineNumber < brackets[0].startLineNumber ?
                        brackets[1].getStartPosition() : brackets[0].getStartPosition();
                    closeBracket = brackets[1].startLineNumber < brackets[0].startLineNumber ?
                        brackets[0].getEndPosition() : brackets[1].getEndPosition();
                }
            }
            if (openBracket && closeBracket) {
                newSelections.push(new __WEBPACK_IMPORTED_MODULE_4__common_core_selection_js__["a" /* Selection */](openBracket.lineNumber, openBracket.column, closeBracket.lineNumber, closeBracket.column));
            }
        });
        if (newSelections.length > 0) {
            this._editor.setSelections(newSelections);
            this._editor.revealRange(newSelections[0]);
        }
    };
    BracketMatchingController.prototype._updateBrackets = function () {
        if (!this._matchBrackets) {
            return;
        }
        this._recomputeBrackets();
        var newDecorations = [], newDecorationsLen = 0;
        for (var i = 0, len = this._lastBracketsData.length; i < len; i++) {
            var brackets = this._lastBracketsData[i].brackets;
            if (brackets) {
                newDecorations[newDecorationsLen++] = { range: brackets[0], options: BracketMatchingController._DECORATION_OPTIONS };
                newDecorations[newDecorationsLen++] = { range: brackets[1], options: BracketMatchingController._DECORATION_OPTIONS };
            }
        }
        this._decorations = this._editor.deltaDecorations(this._decorations, newDecorations);
    };
    BracketMatchingController.prototype._recomputeBrackets = function () {
        var model = this._editor.getModel();
        if (!model) {
            // no model => no brackets!
            this._lastBracketsData = [];
            this._lastVersionId = 0;
            return;
        }
        var versionId = model.getVersionId();
        var previousData = [];
        if (this._lastVersionId === versionId) {
            // use the previous data only if the model is at the same version id
            previousData = this._lastBracketsData;
        }
        var selections = this._editor.getSelections();
        var positions = [], positionsLen = 0;
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (selection.isEmpty()) {
                // will bracket match a cursor only if the selection is collapsed
                positions[positionsLen++] = selection.getStartPosition();
            }
        }
        // sort positions for `previousData` cache hits
        if (positions.length > 1) {
            positions.sort(__WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */].compare);
        }
        var newData = [], newDataLen = 0;
        var previousIndex = 0, previousLen = previousData.length;
        for (var i = 0, len = positions.length; i < len; i++) {
            var position = positions[i];
            while (previousIndex < previousLen && previousData[previousIndex].position.isBefore(position)) {
                previousIndex++;
            }
            if (previousIndex < previousLen && previousData[previousIndex].position.equals(position)) {
                newData[newDataLen++] = previousData[previousIndex];
            }
            else {
                var brackets = model.matchBracket(position);
                newData[newDataLen++] = new BracketsData(position, brackets);
            }
        }
        this._lastBracketsData = newData;
        this._lastVersionId = versionId;
    };
    BracketMatchingController.ID = 'editor.contrib.bracketMatchingController';
    BracketMatchingController._DECORATION_OPTIONS = __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_12__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'bracket-match',
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(overviewRulerBracketMatchForeground),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(overviewRulerBracketMatchForeground),
            position: __WEBPACK_IMPORTED_MODULE_12__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    return BracketMatchingController;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));

Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(BracketMatchingController);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(SelectToBracketAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(JumpToBracketAction);
Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var bracketMatchBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["c" /* editorBracketMatchBackground */]);
    if (bracketMatchBackground) {
        collector.addRule(".monaco-editor .bracket-match { background-color: " + bracketMatchBackground + "; }");
    }
    var bracketMatchBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["d" /* editorBracketMatchBorder */]);
    if (bracketMatchBorder) {
        collector.addRule(".monaco-editor .bracket-match { border: 1px solid " + bracketMatchBorder + "; }");
    }
});


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchParams; });
/* unused harmony export SearchData */
/* harmony export (immutable) */ __webpack_exports__["d"] = createFindMatch;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TextModelSearch; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isValidMatch;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Searcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controller_wordCharacterClassifier_js__ = __webpack_require__(82);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var LIMIT_FIND_COUNT = 999;
var SearchParams = /** @class */ (function () {
    function SearchParams(searchString, isRegex, matchCase, wordSeparators) {
        this.searchString = searchString;
        this.isRegex = isRegex;
        this.matchCase = matchCase;
        this.wordSeparators = wordSeparators;
    }
    SearchParams._isMultilineRegexSource = function (searchString) {
        if (!searchString || searchString.length === 0) {
            return false;
        }
        for (var i = 0, len = searchString.length; i < len; i++) {
            var chCode = searchString.charCodeAt(i);
            if (chCode === 92 /* Backslash */) {
                // move to next char
                i++;
                if (i >= len) {
                    // string ends with a \
                    break;
                }
                var nextChCode = searchString.charCodeAt(i);
                if (nextChCode === 110 /* n */ || nextChCode === 114 /* r */) {
                    return true;
                }
            }
        }
        return false;
    };
    SearchParams.prototype.parseSearchRequest = function () {
        if (this.searchString === '') {
            return null;
        }
        // Try to create a RegExp out of the params
        var multiline;
        if (this.isRegex) {
            multiline = SearchParams._isMultilineRegexSource(this.searchString);
        }
        else {
            multiline = (this.searchString.indexOf('\n') >= 0);
        }
        var regex = null;
        try {
            regex = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["createRegExp"](this.searchString, this.isRegex, {
                matchCase: this.matchCase,
                wholeWord: false,
                multiline: multiline,
                global: true
            });
        }
        catch (err) {
            return null;
        }
        if (!regex) {
            return null;
        }
        var canUseSimpleSearch = (!this.isRegex && !multiline);
        if (canUseSimpleSearch && this.searchString.toLowerCase() !== this.searchString.toUpperCase()) {
            // casing might make a difference
            canUseSimpleSearch = this.matchCase;
        }
        return new SearchData(regex, this.wordSeparators ? Object(__WEBPACK_IMPORTED_MODULE_4__controller_wordCharacterClassifier_js__["a" /* getMapForWordSeparators */])(this.wordSeparators) : null, canUseSimpleSearch ? this.searchString : null);
    };
    return SearchParams;
}());

var SearchData = /** @class */ (function () {
    function SearchData(regex, wordSeparators, simpleSearch) {
        this.regex = regex;
        this.wordSeparators = wordSeparators;
        this.simpleSearch = simpleSearch;
    }
    return SearchData;
}());

function createFindMatch(range, rawMatches, captureMatches) {
    if (!captureMatches) {
        return new __WEBPACK_IMPORTED_MODULE_3__model_js__["e" /* FindMatch */](range, null);
    }
    var matches = [];
    for (var i = 0, len = rawMatches.length; i < len; i++) {
        matches[i] = rawMatches[i];
    }
    return new __WEBPACK_IMPORTED_MODULE_3__model_js__["e" /* FindMatch */](range, matches);
}
var LineFeedCounter = /** @class */ (function () {
    function LineFeedCounter(text) {
        var lineFeedsOffsets = [];
        var lineFeedsOffsetsLen = 0;
        for (var i = 0, textLen = text.length; i < textLen; i++) {
            if (text.charCodeAt(i) === 10 /* LineFeed */) {
                lineFeedsOffsets[lineFeedsOffsetsLen++] = i;
            }
        }
        this._lineFeedsOffsets = lineFeedsOffsets;
    }
    LineFeedCounter.prototype.findLineFeedCountBeforeOffset = function (offset) {
        var lineFeedsOffsets = this._lineFeedsOffsets;
        var min = 0;
        var max = lineFeedsOffsets.length - 1;
        if (max === -1) {
            // no line feeds
            return 0;
        }
        if (offset <= lineFeedsOffsets[0]) {
            // before first line feed
            return 0;
        }
        while (min < max) {
            var mid = min + ((max - min) / 2 >> 0);
            if (lineFeedsOffsets[mid] >= offset) {
                max = mid - 1;
            }
            else {
                if (lineFeedsOffsets[mid + 1] >= offset) {
                    // bingo!
                    min = mid;
                    max = mid;
                }
                else {
                    min = mid + 1;
                }
            }
        }
        return min + 1;
    };
    return LineFeedCounter;
}());
var TextModelSearch = /** @class */ (function () {
    function TextModelSearch() {
    }
    TextModelSearch.findMatches = function (model, searchParams, searchRange, captureMatches, limitResultCount) {
        var searchData = searchParams.parseSearchRequest();
        if (!searchData) {
            return [];
        }
        if (searchData.regex.multiline) {
            return this._doFindMatchesMultiline(model, searchRange, new Searcher(searchData.wordSeparators, searchData.regex), captureMatches, limitResultCount);
        }
        return this._doFindMatchesLineByLine(model, searchRange, searchData, captureMatches, limitResultCount);
    };
    /**
     * Multiline search always executes on the lines concatenated with \n.
     * We must therefore compensate for the count of \n in case the model is CRLF
     */
    TextModelSearch._getMultilineMatchRange = function (model, deltaOffset, text, lfCounter, matchIndex, match0) {
        var startOffset;
        var lineFeedCountBeforeMatch = 0;
        if (model.getEOL() === '\r\n') {
            lineFeedCountBeforeMatch = lfCounter.findLineFeedCountBeforeOffset(matchIndex);
            startOffset = deltaOffset + matchIndex + lineFeedCountBeforeMatch /* add as many \r as there were \n */;
        }
        else {
            startOffset = deltaOffset + matchIndex;
        }
        var endOffset;
        if (model.getEOL() === '\r\n') {
            var lineFeedCountBeforeEndOfMatch = lfCounter.findLineFeedCountBeforeOffset(matchIndex + match0.length);
            var lineFeedCountInMatch = lineFeedCountBeforeEndOfMatch - lineFeedCountBeforeMatch;
            endOffset = startOffset + match0.length + lineFeedCountInMatch /* add as many \r as there were \n */;
        }
        else {
            endOffset = startOffset + match0.length;
        }
        var startPosition = model.getPositionAt(startOffset);
        var endPosition = model.getPositionAt(endOffset);
        return new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column);
    };
    TextModelSearch._doFindMatchesMultiline = function (model, searchRange, searcher, captureMatches, limitResultCount) {
        var deltaOffset = model.getOffsetAt(searchRange.getStartPosition());
        // We always execute multiline search over the lines joined with \n
        // This makes it that \n will match the EOL for both CRLF and LF models
        // We compensate for offset errors in `_getMultilineMatchRange`
        var text = model.getValueInRange(searchRange, __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].LF);
        var lfCounter = (model.getEOL() === '\r\n' ? new LineFeedCounter(text) : null);
        var result = [];
        var counter = 0;
        var m;
        searcher.reset(0);
        while ((m = searcher.next(text))) {
            result[counter++] = createFindMatch(this._getMultilineMatchRange(model, deltaOffset, text, lfCounter, m.index, m[0]), m, captureMatches);
            if (counter >= limitResultCount) {
                return result;
            }
        }
        return result;
    };
    TextModelSearch._doFindMatchesLineByLine = function (model, searchRange, searchData, captureMatches, limitResultCount) {
        var result = [];
        var resultLen = 0;
        // Early case for a search range that starts & stops on the same line number
        if (searchRange.startLineNumber === searchRange.endLineNumber) {
            var text_1 = model.getLineContent(searchRange.startLineNumber).substring(searchRange.startColumn - 1, searchRange.endColumn - 1);
            resultLen = this._findMatchesInLine(searchData, text_1, searchRange.startLineNumber, searchRange.startColumn - 1, resultLen, result, captureMatches, limitResultCount);
            return result;
        }
        // Collect results from first line
        var text = model.getLineContent(searchRange.startLineNumber).substring(searchRange.startColumn - 1);
        resultLen = this._findMatchesInLine(searchData, text, searchRange.startLineNumber, searchRange.startColumn - 1, resultLen, result, captureMatches, limitResultCount);
        // Collect results from middle lines
        for (var lineNumber = searchRange.startLineNumber + 1; lineNumber < searchRange.endLineNumber && resultLen < limitResultCount; lineNumber++) {
            resultLen = this._findMatchesInLine(searchData, model.getLineContent(lineNumber), lineNumber, 0, resultLen, result, captureMatches, limitResultCount);
        }
        // Collect results from last line
        if (resultLen < limitResultCount) {
            var text_2 = model.getLineContent(searchRange.endLineNumber).substring(0, searchRange.endColumn - 1);
            resultLen = this._findMatchesInLine(searchData, text_2, searchRange.endLineNumber, 0, resultLen, result, captureMatches, limitResultCount);
        }
        return result;
    };
    TextModelSearch._findMatchesInLine = function (searchData, text, lineNumber, deltaOffset, resultLen, result, captureMatches, limitResultCount) {
        var wordSeparators = searchData.wordSeparators;
        if (!captureMatches && searchData.simpleSearch) {
            var searchString = searchData.simpleSearch;
            var searchStringLen = searchString.length;
            var textLength = text.length;
            var lastMatchIndex = -searchStringLen;
            while ((lastMatchIndex = text.indexOf(searchString, lastMatchIndex + searchStringLen)) !== -1) {
                if (!wordSeparators || isValidMatch(wordSeparators, text, textLength, lastMatchIndex, searchStringLen)) {
                    result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_3__model_js__["e" /* FindMatch */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, lastMatchIndex + 1 + deltaOffset, lineNumber, lastMatchIndex + 1 + searchStringLen + deltaOffset), null);
                    if (resultLen >= limitResultCount) {
                        return resultLen;
                    }
                }
            }
            return resultLen;
        }
        var searcher = new Searcher(searchData.wordSeparators, searchData.regex);
        var m;
        // Reset regex to search from the beginning
        searcher.reset(0);
        do {
            m = searcher.next(text);
            if (m) {
                result[resultLen++] = createFindMatch(new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, m.index + 1 + deltaOffset, lineNumber, m.index + 1 + m[0].length + deltaOffset), m, captureMatches);
                if (resultLen >= limitResultCount) {
                    return resultLen;
                }
            }
        } while (m);
        return resultLen;
    };
    TextModelSearch.findNextMatch = function (model, searchParams, searchStart, captureMatches) {
        var searchData = searchParams.parseSearchRequest();
        if (!searchData) {
            return null;
        }
        var searcher = new Searcher(searchData.wordSeparators, searchData.regex);
        if (searchData.regex.multiline) {
            return this._doFindNextMatchMultiline(model, searchStart, searcher, captureMatches);
        }
        return this._doFindNextMatchLineByLine(model, searchStart, searcher, captureMatches);
    };
    TextModelSearch._doFindNextMatchMultiline = function (model, searchStart, searcher, captureMatches) {
        var searchTextStart = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](searchStart.lineNumber, 1);
        var deltaOffset = model.getOffsetAt(searchTextStart);
        var lineCount = model.getLineCount();
        // We always execute multiline search over the lines joined with \n
        // This makes it that \n will match the EOL for both CRLF and LF models
        // We compensate for offset errors in `_getMultilineMatchRange`
        var text = model.getValueInRange(new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](searchTextStart.lineNumber, searchTextStart.column, lineCount, model.getLineMaxColumn(lineCount)), __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].LF);
        var lfCounter = (model.getEOL() === '\r\n' ? new LineFeedCounter(text) : null);
        searcher.reset(searchStart.column - 1);
        var m = searcher.next(text);
        if (m) {
            return createFindMatch(this._getMultilineMatchRange(model, deltaOffset, text, lfCounter, m.index, m[0]), m, captureMatches);
        }
        if (searchStart.lineNumber !== 1 || searchStart.column !== 1) {
            // Try again from the top
            return this._doFindNextMatchMultiline(model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](1, 1), searcher, captureMatches);
        }
        return null;
    };
    TextModelSearch._doFindNextMatchLineByLine = function (model, searchStart, searcher, captureMatches) {
        var lineCount = model.getLineCount();
        var startLineNumber = searchStart.lineNumber;
        // Look in first line
        var text = model.getLineContent(startLineNumber);
        var r = this._findFirstMatchInLine(searcher, text, startLineNumber, searchStart.column, captureMatches);
        if (r) {
            return r;
        }
        for (var i = 1; i <= lineCount; i++) {
            var lineIndex = (startLineNumber + i - 1) % lineCount;
            var text_3 = model.getLineContent(lineIndex + 1);
            var r_1 = this._findFirstMatchInLine(searcher, text_3, lineIndex + 1, 1, captureMatches);
            if (r_1) {
                return r_1;
            }
        }
        return null;
    };
    TextModelSearch._findFirstMatchInLine = function (searcher, text, lineNumber, fromColumn, captureMatches) {
        // Set regex to search from column
        searcher.reset(fromColumn - 1);
        var m = searcher.next(text);
        if (m) {
            return createFindMatch(new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, m.index + 1, lineNumber, m.index + 1 + m[0].length), m, captureMatches);
        }
        return null;
    };
    TextModelSearch.findPreviousMatch = function (model, searchParams, searchStart, captureMatches) {
        var searchData = searchParams.parseSearchRequest();
        if (!searchData) {
            return null;
        }
        var searcher = new Searcher(searchData.wordSeparators, searchData.regex);
        if (searchData.regex.multiline) {
            return this._doFindPreviousMatchMultiline(model, searchStart, searcher, captureMatches);
        }
        return this._doFindPreviousMatchLineByLine(model, searchStart, searcher, captureMatches);
    };
    TextModelSearch._doFindPreviousMatchMultiline = function (model, searchStart, searcher, captureMatches) {
        var matches = this._doFindMatchesMultiline(model, new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](1, 1, searchStart.lineNumber, searchStart.column), searcher, captureMatches, 10 * LIMIT_FIND_COUNT);
        if (matches.length > 0) {
            return matches[matches.length - 1];
        }
        var lineCount = model.getLineCount();
        if (searchStart.lineNumber !== lineCount || searchStart.column !== model.getLineMaxColumn(lineCount)) {
            // Try again with all content
            return this._doFindPreviousMatchMultiline(model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineCount, model.getLineMaxColumn(lineCount)), searcher, captureMatches);
        }
        return null;
    };
    TextModelSearch._doFindPreviousMatchLineByLine = function (model, searchStart, searcher, captureMatches) {
        var lineCount = model.getLineCount();
        var startLineNumber = searchStart.lineNumber;
        // Look in first line
        var text = model.getLineContent(startLineNumber).substring(0, searchStart.column - 1);
        var r = this._findLastMatchInLine(searcher, text, startLineNumber, captureMatches);
        if (r) {
            return r;
        }
        for (var i = 1; i <= lineCount; i++) {
            var lineIndex = (lineCount + startLineNumber - i - 1) % lineCount;
            var text_4 = model.getLineContent(lineIndex + 1);
            var r_2 = this._findLastMatchInLine(searcher, text_4, lineIndex + 1, captureMatches);
            if (r_2) {
                return r_2;
            }
        }
        return null;
    };
    TextModelSearch._findLastMatchInLine = function (searcher, text, lineNumber, captureMatches) {
        var bestResult = null;
        var m;
        searcher.reset(0);
        while ((m = searcher.next(text))) {
            bestResult = createFindMatch(new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, m.index + 1, lineNumber, m.index + 1 + m[0].length), m, captureMatches);
        }
        return bestResult;
    };
    return TextModelSearch;
}());

function leftIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength) {
    if (matchStartIndex === 0) {
        // Match starts at start of string
        return true;
    }
    var charBefore = text.charCodeAt(matchStartIndex - 1);
    if (wordSeparators.get(charBefore) !== 0 /* Regular */) {
        // The character before the match is a word separator
        return true;
    }
    if (charBefore === 13 /* CarriageReturn */ || charBefore === 10 /* LineFeed */) {
        // The character before the match is line break or carriage return.
        return true;
    }
    if (matchLength > 0) {
        var firstCharInMatch = text.charCodeAt(matchStartIndex);
        if (wordSeparators.get(firstCharInMatch) !== 0 /* Regular */) {
            // The first character inside the match is a word separator
            return true;
        }
    }
    return false;
}
function rightIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength) {
    if (matchStartIndex + matchLength === textLength) {
        // Match ends at end of string
        return true;
    }
    var charAfter = text.charCodeAt(matchStartIndex + matchLength);
    if (wordSeparators.get(charAfter) !== 0 /* Regular */) {
        // The character after the match is a word separator
        return true;
    }
    if (charAfter === 13 /* CarriageReturn */ || charAfter === 10 /* LineFeed */) {
        // The character after the match is line break or carriage return.
        return true;
    }
    if (matchLength > 0) {
        var lastCharInMatch = text.charCodeAt(matchStartIndex + matchLength - 1);
        if (wordSeparators.get(lastCharInMatch) !== 0 /* Regular */) {
            // The last character in the match is a word separator
            return true;
        }
    }
    return false;
}
function isValidMatch(wordSeparators, text, textLength, matchStartIndex, matchLength) {
    return (leftIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength)
        && rightIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength));
}
var Searcher = /** @class */ (function () {
    function Searcher(wordSeparators, searchRegex) {
        this._wordSeparators = wordSeparators;
        this._searchRegex = searchRegex;
        this._prevMatchStartIndex = -1;
        this._prevMatchLength = 0;
    }
    Searcher.prototype.reset = function (lastIndex) {
        this._searchRegex.lastIndex = lastIndex;
        this._prevMatchStartIndex = -1;
        this._prevMatchLength = 0;
    };
    Searcher.prototype.next = function (text) {
        var textLength = text.length;
        var m;
        do {
            if (this._prevMatchStartIndex + this._prevMatchLength === textLength) {
                // Reached the end of the line
                return null;
            }
            m = this._searchRegex.exec(text);
            if (!m) {
                return null;
            }
            var matchStartIndex = m.index;
            var matchLength = m[0].length;
            if (matchStartIndex === this._prevMatchStartIndex && matchLength === this._prevMatchLength) {
                // Exit early if the regex matches the same range twice
                return null;
            }
            this._prevMatchStartIndex = matchStartIndex;
            this._prevMatchLength = matchLength;
            if (!this._wordSeparators || isValidMatch(this._wordSeparators, text, textLength, matchStartIndex, matchLength)) {
                return m;
            }
        } while (m);
        return null;
    };
    return Searcher;
}());



/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__moveCaretCommand_js__ = __webpack_require__(333);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var MoveCaretAction = /** @class */ (function (_super) {
    __extends(MoveCaretAction, _super);
    function MoveCaretAction(left, opts) {
        var _this = _super.call(this, opts) || this;
        _this.left = left;
        return _this;
    }
    MoveCaretAction.prototype.run = function (accessor, editor) {
        var commands = [];
        var selections = editor.getSelections();
        for (var i = 0; i < selections.length; i++) {
            commands.push(new __WEBPACK_IMPORTED_MODULE_3__moveCaretCommand_js__["a" /* MoveCaretCommand */](selections[i], this.left));
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return MoveCaretAction;
}(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["b" /* EditorAction */]));
var MoveCaretLeftAction = /** @class */ (function (_super) {
    __extends(MoveCaretLeftAction, _super);
    function MoveCaretLeftAction() {
        return _super.call(this, true, {
            id: 'editor.action.moveCarretLeftAction',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('caret.moveLeft', "Move Caret Left"),
            alias: 'Move Caret Left',
            precondition: __WEBPACK_IMPORTED_MODULE_1__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return MoveCaretLeftAction;
}(MoveCaretAction));
var MoveCaretRightAction = /** @class */ (function (_super) {
    __extends(MoveCaretRightAction, _super);
    function MoveCaretRightAction() {
        return _super.call(this, false, {
            id: 'editor.action.moveCarretRightAction',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('caret.moveRight', "Move Caret Right"),
            alias: 'Move Caret Right',
            precondition: __WEBPACK_IMPORTED_MODULE_1__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return MoveCaretRightAction;
}(MoveCaretAction));
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["f" /* registerEditorAction */])(MoveCaretLeftAction);
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["f" /* registerEditorAction */])(MoveCaretRightAction);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clipboard_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clipboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__clipboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_controller_textAreaInput_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__ = __webpack_require__(41);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var CLIPBOARD_CONTEXT_MENU_GROUP = '9_cutcopypaste';
var supportsCut = (__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["e" /* isNative */] || document.queryCommandSupported('cut'));
var supportsCopy = (__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["e" /* isNative */] || document.queryCommandSupported('copy'));
// IE and Edge have trouble with setting html content in clipboard
var supportsCopyWithSyntaxHighlighting = (supportsCopy && !__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["h" /* isEdgeOrIE */]);
// Chrome incorrectly returns true for document.queryCommandSupported('paste')
// when the paste feature is available but the calling script has insufficient
// privileges to actually perform the action
var supportsPaste = (__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["e" /* isNative */] || (!__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["f" /* isChrome */] && document.queryCommandSupported('paste')));
var ExecCommandAction = /** @class */ (function (_super) {
    __extends(ExecCommandAction, _super);
    function ExecCommandAction(browserCommand, opts) {
        var _this = _super.call(this, opts) || this;
        _this.browserCommand = browserCommand;
        return _this;
    }
    ExecCommandAction.prototype.runCommand = function (accessor, args) {
        var focusedEditor = accessor.get(__WEBPACK_IMPORTED_MODULE_4__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]).getFocusedCodeEditor();
        // Only if editor text focus (i.e. not if editor has widget focus).
        if (focusedEditor && focusedEditor.hasTextFocus()) {
            focusedEditor.trigger('keyboard', this.id, args);
            return;
        }
        document.execCommand(this.browserCommand);
    };
    ExecCommandAction.prototype.run = function (accessor, editor) {
        editor.focus();
        document.execCommand(this.browserCommand);
    };
    return ExecCommandAction;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));
var ExecCommandCutAction = /** @class */ (function (_super) {
    __extends(ExecCommandCutAction, _super);
    function ExecCommandCutAction() {
        var _this = this;
        var kbOpts = {
            kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 54 /* KEY_X */,
            win: { primary: 2048 /* CtrlCmd */ | 54 /* KEY_X */, secondary: [1024 /* Shift */ | 20 /* Delete */] },
            weight: 100 /* EditorContrib */
        };
        // Do not bind cut keybindings in the browser,
        // since browsers do that for us and it avoids security prompts
        if (!__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["e" /* isNative */]) {
            kbOpts = null;
        }
        _this = _super.call(this, 'cut', {
            id: 'editor.action.clipboardCutAction',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('actions.clipboard.cutLabel', "Cut"),
            alias: 'Cut',
            precondition: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: kbOpts,
            menuOpts: {
                group: CLIPBOARD_CONTEXT_MENU_GROUP,
                order: 1
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
                group: '2_ccp',
                title: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]({ key: 'miCut', comment: ['&& denotes a mnemonic'] }, "Cu&&t"),
                order: 1
            }
        }) || this;
        return _this;
    }
    ExecCommandCutAction.prototype.run = function (accessor, editor) {
        var emptySelectionClipboard = editor.getConfiguration().emptySelectionClipboard;
        if (!emptySelectionClipboard && editor.getSelection().isEmpty()) {
            return;
        }
        _super.prototype.run.call(this, accessor, editor);
    };
    return ExecCommandCutAction;
}(ExecCommandAction));
var ExecCommandCopyAction = /** @class */ (function (_super) {
    __extends(ExecCommandCopyAction, _super);
    function ExecCommandCopyAction() {
        var _this = this;
        var kbOpts = {
            kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 33 /* KEY_C */,
            win: { primary: 2048 /* CtrlCmd */ | 33 /* KEY_C */, secondary: [2048 /* CtrlCmd */ | 19 /* Insert */] },
            weight: 100 /* EditorContrib */
        };
        // Do not bind copy keybindings in the browser,
        // since browsers do that for us and it avoids security prompts
        if (!__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["e" /* isNative */]) {
            kbOpts = null;
        }
        _this = _super.call(this, 'copy', {
            id: 'editor.action.clipboardCopyAction',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('actions.clipboard.copyLabel', "Copy"),
            alias: 'Copy',
            precondition: null,
            kbOpts: kbOpts,
            menuOpts: {
                group: CLIPBOARD_CONTEXT_MENU_GROUP,
                order: 2
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
                group: '2_ccp',
                title: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]({ key: 'miCopy', comment: ['&& denotes a mnemonic'] }, "&&Copy"),
                order: 2
            }
        }) || this;
        return _this;
    }
    ExecCommandCopyAction.prototype.run = function (accessor, editor) {
        var emptySelectionClipboard = editor.getConfiguration().emptySelectionClipboard;
        if (!emptySelectionClipboard && editor.getSelection().isEmpty()) {
            return;
        }
        _super.prototype.run.call(this, accessor, editor);
    };
    return ExecCommandCopyAction;
}(ExecCommandAction));
var ExecCommandPasteAction = /** @class */ (function (_super) {
    __extends(ExecCommandPasteAction, _super);
    function ExecCommandPasteAction() {
        var _this = this;
        var kbOpts = {
            kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
            primary: 2048 /* CtrlCmd */ | 52 /* KEY_V */,
            win: { primary: 2048 /* CtrlCmd */ | 52 /* KEY_V */, secondary: [1024 /* Shift */ | 19 /* Insert */] },
            weight: 100 /* EditorContrib */
        };
        // Do not bind paste keybindings in the browser,
        // since browsers do that for us and it avoids security prompts
        if (!__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["e" /* isNative */]) {
            kbOpts = null;
        }
        _this = _super.call(this, 'paste', {
            id: 'editor.action.clipboardPasteAction',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('actions.clipboard.pasteLabel', "Paste"),
            alias: 'Paste',
            precondition: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: kbOpts,
            menuOpts: {
                group: CLIPBOARD_CONTEXT_MENU_GROUP,
                order: 3
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
                group: '2_ccp',
                title: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]({ key: 'miPaste', comment: ['&& denotes a mnemonic'] }, "&&Paste"),
                order: 3
            }
        }) || this;
        return _this;
    }
    return ExecCommandPasteAction;
}(ExecCommandAction));
var ExecCommandCopyWithSyntaxHighlightingAction = /** @class */ (function (_super) {
    __extends(ExecCommandCopyWithSyntaxHighlightingAction, _super);
    function ExecCommandCopyWithSyntaxHighlightingAction() {
        return _super.call(this, 'copy', {
            id: 'editor.action.clipboardCopyWithSyntaxHighlightingAction',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('actions.clipboard.copyWithSyntaxHighlightingLabel', "Copy With Syntax Highlighting"),
            alias: 'Copy With Syntax Highlighting',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: null,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    ExecCommandCopyWithSyntaxHighlightingAction.prototype.run = function (accessor, editor) {
        var emptySelectionClipboard = editor.getConfiguration().emptySelectionClipboard;
        if (!emptySelectionClipboard && editor.getSelection().isEmpty()) {
            return;
        }
        __WEBPACK_IMPORTED_MODULE_6__browser_controller_textAreaInput_js__["a" /* CopyOptions */].forceCopyWithSyntaxHighlighting = true;
        _super.prototype.run.call(this, accessor, editor);
        __WEBPACK_IMPORTED_MODULE_6__browser_controller_textAreaInput_js__["a" /* CopyOptions */].forceCopyWithSyntaxHighlighting = false;
    };
    return ExecCommandCopyWithSyntaxHighlightingAction;
}(ExecCommandAction));
if (supportsCut) {
    Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(ExecCommandCutAction);
}
if (supportsCopy) {
    Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(ExecCommandCopyAction);
}
if (supportsPaste) {
    Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(ExecCommandPasteAction);
}
if (supportsCopyWithSyntaxHighlighting) {
    Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(ExecCommandCopyWithSyntaxHighlightingAction);
}


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__codeActionCommands_js__ = __webpack_require__(335);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


Object(__WEBPACK_IMPORTED_MODULE_0__browser_editorExtensions_js__["h" /* registerEditorContribution */])(__WEBPACK_IMPORTED_MODULE_1__codeActionCommands_js__["d" /* QuickFixController */]);
Object(__WEBPACK_IMPORTED_MODULE_0__browser_editorExtensions_js__["f" /* registerEditorAction */])(__WEBPACK_IMPORTED_MODULE_1__codeActionCommands_js__["c" /* QuickFixAction */]);
Object(__WEBPACK_IMPORTED_MODULE_0__browser_editorExtensions_js__["f" /* registerEditorAction */])(__WEBPACK_IMPORTED_MODULE_1__codeActionCommands_js__["e" /* RefactorAction */]);
Object(__WEBPACK_IMPORTED_MODULE_0__browser_editorExtensions_js__["f" /* registerEditorAction */])(__WEBPACK_IMPORTED_MODULE_1__codeActionCommands_js__["f" /* SourceAction */]);
Object(__WEBPACK_IMPORTED_MODULE_0__browser_editorExtensions_js__["f" /* registerEditorAction */])(__WEBPACK_IMPORTED_MODULE_1__codeActionCommands_js__["b" /* OrganizeImportsAction */]);
Object(__WEBPACK_IMPORTED_MODULE_0__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new __WEBPACK_IMPORTED_MODULE_1__codeActionCommands_js__["a" /* CodeActionCommand */]());


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IBulkEditService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IBulkEditService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])('IWorkspaceEditService');


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messageController_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messageController_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__messageController_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};











var MessageController = /** @class */ (function (_super) {
    __extends(MessageController, _super);
    function MessageController(editor, contextKeyService) {
        var _this = _super.call(this) || this;
        _this._messageListeners = [];
        _this._editor = editor;
        _this._visible = MessageController.MESSAGE_VISIBLE.bindTo(contextKeyService);
        _this._register(_this._editor.onDidAttemptReadOnlyEdit(function () { return _this._onDidAttemptReadOnlyEdit(); }));
        return _this;
    }
    MessageController.get = function (editor) {
        return editor.getContribution(MessageController._id);
    };
    MessageController.prototype.getId = function () {
        return MessageController._id;
    };
    MessageController.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._visible.reset();
    };
    MessageController.prototype.showMessage = function (message, position) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_4__base_browser_ui_aria_aria_js__["a" /* alert */])(message);
        this._visible.set(true);
        Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._messageWidget);
        this._messageListeners = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._messageListeners);
        this._messageWidget = new MessageWidget(this._editor, position, message);
        // close on blur, cursor, model change, dispose
        this._messageListeners.push(this._editor.onDidBlurEditorText(function () { return _this.closeMessage(); }));
        this._messageListeners.push(this._editor.onDidChangeCursorPosition(function () { return _this.closeMessage(); }));
        this._messageListeners.push(this._editor.onDidDispose(function () { return _this.closeMessage(); }));
        this._messageListeners.push(this._editor.onDidChangeModel(function () { return _this.closeMessage(); }));
        // close after 3s
        this._messageListeners.push(Object(__WEBPACK_IMPORTED_MODULE_2__base_common_async_js__["l" /* setDisposableTimeout */])(function () { return _this.closeMessage(); }, 3000));
        // close on mouse move
        var bounds;
        this._messageListeners.push(this._editor.onMouseMove(function (e) {
            // outside the text area
            if (!e.target.position) {
                return;
            }
            if (!bounds) {
                // define bounding box around position and first mouse occurance
                bounds = new __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */](position.lineNumber - 3, 1, e.target.position.lineNumber + 3, 1);
            }
            else if (!bounds.containsPosition(e.target.position)) {
                // check if position is still in bounds
                _this.closeMessage();
            }
        }));
    };
    MessageController.prototype.closeMessage = function () {
        this._visible.reset();
        this._messageListeners = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._messageListeners);
        this._messageListeners.push(MessageWidget.fadeOut(this._messageWidget));
    };
    MessageController.prototype._onDidAttemptReadOnlyEdit = function () {
        this.showMessage(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editor.readonly', "Cannot edit in read-only editor"), this._editor.getPosition());
    };
    MessageController._id = 'editor.contrib.messageController';
    MessageController.MESSAGE_VISIBLE = new __WEBPACK_IMPORTED_MODULE_8__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('messageVisible', false);
    MessageController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_8__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], MessageController);
    return MessageController;
}(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["a" /* Disposable */]));

var MessageCommand = __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(MessageController.get);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new MessageCommand({
    id: 'leaveEditorMessage',
    precondition: MessageController.MESSAGE_VISIBLE,
    handler: function (c) { return c.closeMessage(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 30,
        primary: 9 /* Escape */
    }
}));
var MessageWidget = /** @class */ (function () {
    function MessageWidget(editor, _a, text) {
        var lineNumber = _a.lineNumber, column = _a.column;
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = true;
        this.suppressMouseDown = false;
        this._editor = editor;
        this._editor.revealLinesInCenterIfOutsideViewport(lineNumber, lineNumber, 0 /* Smooth */);
        this._position = { lineNumber: lineNumber, column: column - 1 };
        this._domNode = document.createElement('div');
        this._domNode.classList.add('monaco-editor-overlaymessage');
        var message = document.createElement('div');
        message.classList.add('message');
        message.textContent = text;
        this._domNode.appendChild(message);
        var anchor = document.createElement('div');
        anchor.classList.add('anchor');
        this._domNode.appendChild(anchor);
        this._editor.addContentWidget(this);
        this._domNode.classList.add('fadeIn');
    }
    MessageWidget.fadeOut = function (messageWidget) {
        var handle;
        var dispose = function () {
            messageWidget.dispose();
            clearTimeout(handle);
            messageWidget.getDomNode().removeEventListener('animationend', dispose);
        };
        handle = setTimeout(dispose, 110);
        messageWidget.getDomNode().addEventListener('animationend', dispose);
        messageWidget.getDomNode().classList.add('fadeOut');
        return { dispose: dispose };
    };
    MessageWidget.prototype.dispose = function () {
        this._editor.removeContentWidget(this);
    };
    MessageWidget.prototype.getId = function () {
        return 'messageoverlay';
    };
    MessageWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    MessageWidget.prototype.getPosition = function () {
        return { position: this._position, preference: [__WEBPACK_IMPORTED_MODULE_7__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE] };
    };
    return MessageWidget;
}());
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(MessageController);
Object(__WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var border = theme.getColor(__WEBPACK_IMPORTED_MODULE_10__platform_theme_common_colorRegistry_js__["Q" /* inputValidationInfoBorder */]);
    if (border) {
        var borderWidth = theme.type === __WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__["b" /* HIGH_CONTRAST */] ? 2 : 1;
        collector.addRule(".monaco-editor .monaco-editor-overlaymessage .anchor { border-top-color: " + border + "; }");
        collector.addRule(".monaco-editor .monaco-editor-overlaymessage .message { border: " + borderWidth + "px solid " + border + "; }");
    }
    var background = theme.getColor(__WEBPACK_IMPORTED_MODULE_10__platform_theme_common_colorRegistry_js__["P" /* inputValidationInfoBackground */]);
    if (background) {
        collector.addRule(".monaco-editor .monaco-editor-overlaymessage .message { background-color: " + background + "; }");
    }
});


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var Severity;
(function (Severity) {
    Severity[Severity["Ignore"] = 0] = "Ignore";
    Severity[Severity["Info"] = 1] = "Info";
    Severity[Severity["Warning"] = 2] = "Warning";
    Severity[Severity["Error"] = 3] = "Error";
})(Severity || (Severity = {}));
(function (Severity) {
    var _error = 'error';
    var _warning = 'warning';
    var _warn = 'warn';
    var _info = 'info';
    var _displayStrings = Object.create(null);
    _displayStrings[Severity.Error] = __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('sev.error', "Error");
    _displayStrings[Severity.Warning] = __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('sev.warning', "Warning");
    _displayStrings[Severity.Info] = __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('sev.info', "Info");
    /**
     * Parses 'error', 'warning', 'warn', 'info' in call casings
     * and falls back to ignore.
     */
    function fromValue(value) {
        if (!value) {
            return Severity.Ignore;
        }
        if (__WEBPACK_IMPORTED_MODULE_1__strings_js__["equalsIgnoreCase"](_error, value)) {
            return Severity.Error;
        }
        if (__WEBPACK_IMPORTED_MODULE_1__strings_js__["equalsIgnoreCase"](_warning, value) || __WEBPACK_IMPORTED_MODULE_1__strings_js__["equalsIgnoreCase"](_warn, value)) {
            return Severity.Warning;
        }
        if (__WEBPACK_IMPORTED_MODULE_1__strings_js__["equalsIgnoreCase"](_info, value)) {
            return Severity.Info;
        }
        return Severity.Ignore;
    }
    Severity.fromValue = fromValue;
})(Severity || (Severity = {}));
/* harmony default export */ __webpack_exports__["a"] = (Severity);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CodeActionKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeActionAutoApply; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var CodeActionKind = /** @class */ (function () {
    function CodeActionKind(value) {
        this.value = value;
    }
    CodeActionKind.prototype.contains = function (other) {
        return this.value === other || Object(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["startsWith"])(other, this.value + CodeActionKind.sep);
    };
    CodeActionKind.sep = '.';
    CodeActionKind.Empty = new CodeActionKind('');
    CodeActionKind.Refactor = new CodeActionKind('refactor');
    CodeActionKind.Source = new CodeActionKind('source');
    CodeActionKind.SourceOrganizeImports = new CodeActionKind('source.organizeImports');
    return CodeActionKind;
}());

var CodeActionAutoApply;
(function (CodeActionAutoApply) {
    CodeActionAutoApply[CodeActionAutoApply["IfSingle"] = 1] = "IfSingle";
    CodeActionAutoApply[CodeActionAutoApply["First"] = 2] = "First";
    CodeActionAutoApply[CodeActionAutoApply["Never"] = 3] = "Never";
})(CodeActionAutoApply || (CodeActionAutoApply = {}));


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CodeLensContribution", function() { return CodeLensContribution; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_core_editorState_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__codelensWidget_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__codelens_js__ = __webpack_require__(344);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};










var CodeLensContribution = /** @class */ (function () {
    function CodeLensContribution(_editor, _commandService, _notificationService) {
        var _this = this;
        this._editor = _editor;
        this._commandService = _commandService;
        this._notificationService = _notificationService;
        this._isEnabled = this._editor.getConfiguration().contribInfo.codeLens;
        this._globalToDispose = [];
        this._localToDispose = [];
        this._lenses = [];
        this._currentFindCodeLensSymbolsPromise = null;
        this._modelChangeCounter = 0;
        this._globalToDispose.push(this._editor.onDidChangeModel(function () { return _this._onModelChange(); }));
        this._globalToDispose.push(this._editor.onDidChangeModelLanguage(function () { return _this._onModelChange(); }));
        this._globalToDispose.push(this._editor.onDidChangeConfiguration(function (e) {
            var prevIsEnabled = _this._isEnabled;
            _this._isEnabled = _this._editor.getConfiguration().contribInfo.codeLens;
            if (prevIsEnabled !== _this._isEnabled) {
                _this._onModelChange();
            }
        }));
        this._globalToDispose.push(__WEBPACK_IMPORTED_MODULE_5__common_modes_js__["c" /* CodeLensProviderRegistry */].onDidChange(this._onModelChange, this));
        this._onModelChange();
    }
    CodeLensContribution.prototype.dispose = function () {
        this._localDispose();
        this._globalToDispose = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._globalToDispose);
    };
    CodeLensContribution.prototype._localDispose = function () {
        if (this._currentFindCodeLensSymbolsPromise) {
            this._currentFindCodeLensSymbolsPromise.cancel();
            this._currentFindCodeLensSymbolsPromise = null;
            this._modelChangeCounter++;
        }
        if (this._currentResolveCodeLensSymbolsPromise) {
            this._currentResolveCodeLensSymbolsPromise.cancel();
            this._currentResolveCodeLensSymbolsPromise = null;
        }
        this._localToDispose = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._localToDispose);
    };
    CodeLensContribution.prototype.getId = function () {
        return CodeLensContribution.ID;
    };
    CodeLensContribution.prototype._onModelChange = function () {
        var _this = this;
        this._localDispose();
        var model = this._editor.getModel();
        if (!model) {
            return;
        }
        if (!this._isEnabled) {
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__common_modes_js__["c" /* CodeLensProviderRegistry */].has(model)) {
            return;
        }
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["c" /* CodeLensProviderRegistry */].all(model); _i < _a.length; _i++) {
            var provider = _a[_i];
            if (typeof provider.onDidChange === 'function') {
                var registration = provider.onDidChange(function () { return scheduler.schedule(); });
                this._localToDispose.push(registration);
            }
        }
        this._detectVisibleLenses = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["c" /* RunOnceScheduler */](function () {
            _this._onViewportChanged();
        }, 500);
        var scheduler = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["c" /* RunOnceScheduler */](function () {
            var counterValue = ++_this._modelChangeCounter;
            if (_this._currentFindCodeLensSymbolsPromise) {
                _this._currentFindCodeLensSymbolsPromise.cancel();
            }
            _this._currentFindCodeLensSymbolsPromise = Object(__WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return Object(__WEBPACK_IMPORTED_MODULE_9__codelens_js__["a" /* getCodeLensData */])(model, token); });
            _this._currentFindCodeLensSymbolsPromise.then(function (result) {
                if (counterValue === _this._modelChangeCounter) { // only the last one wins
                    _this._renderCodeLensSymbols(result);
                    _this._detectVisibleLenses.schedule();
                }
            }, __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */]);
        }, 250);
        this._localToDispose.push(scheduler);
        this._localToDispose.push(this._detectVisibleLenses);
        this._localToDispose.push(this._editor.onDidChangeModelContent(function (e) {
            _this._editor.changeDecorations(function (changeAccessor) {
                _this._editor.changeViewZones(function (viewAccessor) {
                    var toDispose = [];
                    var lastLensLineNumber = -1;
                    _this._lenses.forEach(function (lens) {
                        if (!lens.isValid() || lastLensLineNumber === lens.getLineNumber()) {
                            // invalid -> lens collapsed, attach range doesn't exist anymore
                            // line_number -> lenses should never be on the same line
                            toDispose.push(lens);
                        }
                        else {
                            lens.update(viewAccessor);
                            lastLensLineNumber = lens.getLineNumber();
                        }
                    });
                    var helper = new __WEBPACK_IMPORTED_MODULE_6__codelensWidget_js__["b" /* CodeLensHelper */]();
                    toDispose.forEach(function (l) {
                        l.dispose(helper, viewAccessor);
                        _this._lenses.splice(_this._lenses.indexOf(l), 1);
                    });
                    helper.commit(changeAccessor);
                });
            });
            // Compute new `visible` code lenses
            _this._detectVisibleLenses.schedule();
            // Ask for all references again
            scheduler.schedule();
        }));
        this._localToDispose.push(this._editor.onDidScrollChange(function (e) {
            if (e.scrollTopChanged && _this._lenses.length > 0) {
                _this._detectVisibleLenses.schedule();
            }
        }));
        this._localToDispose.push(this._editor.onDidLayoutChange(function (e) {
            _this._detectVisibleLenses.schedule();
        }));
        this._localToDispose.push(Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            if (_this._editor.getModel()) {
                var scrollState = __WEBPACK_IMPORTED_MODULE_3__browser_core_editorState_js__["b" /* StableEditorScrollState */].capture(_this._editor);
                _this._editor.changeDecorations(function (changeAccessor) {
                    _this._editor.changeViewZones(function (accessor) {
                        _this._disposeAllLenses(changeAccessor, accessor);
                    });
                });
                scrollState.restore(_this._editor);
            }
            else {
                // No accessors available
                _this._disposeAllLenses(null, null);
            }
        }));
        scheduler.schedule();
    };
    CodeLensContribution.prototype._disposeAllLenses = function (decChangeAccessor, viewZoneChangeAccessor) {
        var helper = new __WEBPACK_IMPORTED_MODULE_6__codelensWidget_js__["b" /* CodeLensHelper */]();
        this._lenses.forEach(function (lens) { return lens.dispose(helper, viewZoneChangeAccessor); });
        if (decChangeAccessor) {
            helper.commit(decChangeAccessor);
        }
        this._lenses = [];
    };
    CodeLensContribution.prototype._renderCodeLensSymbols = function (symbols) {
        var _this = this;
        if (!this._editor.getModel()) {
            return;
        }
        var maxLineNumber = this._editor.getModel().getLineCount();
        var groups = [];
        var lastGroup;
        for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
            var symbol = symbols_1[_i];
            var line = symbol.symbol.range.startLineNumber;
            if (line < 1 || line > maxLineNumber) {
                // invalid code lens
                continue;
            }
            else if (lastGroup && lastGroup[lastGroup.length - 1].symbol.range.startLineNumber === line) {
                // on same line as previous
                lastGroup.push(symbol);
            }
            else {
                // on later line as previous
                lastGroup = [symbol];
                groups.push(lastGroup);
            }
        }
        var scrollState = __WEBPACK_IMPORTED_MODULE_3__browser_core_editorState_js__["b" /* StableEditorScrollState */].capture(this._editor);
        this._editor.changeDecorations(function (changeAccessor) {
            _this._editor.changeViewZones(function (accessor) {
                var codeLensIndex = 0, groupsIndex = 0, helper = new __WEBPACK_IMPORTED_MODULE_6__codelensWidget_js__["b" /* CodeLensHelper */]();
                while (groupsIndex < groups.length && codeLensIndex < _this._lenses.length) {
                    var symbolsLineNumber = groups[groupsIndex][0].symbol.range.startLineNumber;
                    var codeLensLineNumber = _this._lenses[codeLensIndex].getLineNumber();
                    if (codeLensLineNumber < symbolsLineNumber) {
                        _this._lenses[codeLensIndex].dispose(helper, accessor);
                        _this._lenses.splice(codeLensIndex, 1);
                    }
                    else if (codeLensLineNumber === symbolsLineNumber) {
                        _this._lenses[codeLensIndex].updateCodeLensSymbols(groups[groupsIndex], helper);
                        groupsIndex++;
                        codeLensIndex++;
                    }
                    else {
                        _this._lenses.splice(codeLensIndex, 0, new __WEBPACK_IMPORTED_MODULE_6__codelensWidget_js__["a" /* CodeLens */](groups[groupsIndex], _this._editor, helper, accessor, _this._commandService, _this._notificationService, function () { return _this._detectVisibleLenses.schedule(); }));
                        codeLensIndex++;
                        groupsIndex++;
                    }
                }
                // Delete extra code lenses
                while (codeLensIndex < _this._lenses.length) {
                    _this._lenses[codeLensIndex].dispose(helper, accessor);
                    _this._lenses.splice(codeLensIndex, 1);
                }
                // Create extra symbols
                while (groupsIndex < groups.length) {
                    _this._lenses.push(new __WEBPACK_IMPORTED_MODULE_6__codelensWidget_js__["a" /* CodeLens */](groups[groupsIndex], _this._editor, helper, accessor, _this._commandService, _this._notificationService, function () { return _this._detectVisibleLenses.schedule(); }));
                    groupsIndex++;
                }
                helper.commit(changeAccessor);
            });
        });
        scrollState.restore(this._editor);
    };
    CodeLensContribution.prototype._onViewportChanged = function () {
        var _this = this;
        if (this._currentResolveCodeLensSymbolsPromise) {
            this._currentResolveCodeLensSymbolsPromise.cancel();
            this._currentResolveCodeLensSymbolsPromise = null;
        }
        var model = this._editor.getModel();
        if (!model) {
            return;
        }
        var toResolve = [];
        var lenses = [];
        this._lenses.forEach(function (lens) {
            var request = lens.computeIfNecessary(model);
            if (request) {
                toResolve.push(request);
                lenses.push(lens);
            }
        });
        if (toResolve.length === 0) {
            return;
        }
        this._currentResolveCodeLensSymbolsPromise = Object(__WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["i" /* createCancelablePromise */])(function (token) {
            var promises = toResolve.map(function (request, i) {
                var resolvedSymbols = new Array(request.length);
                var promises = request.map(function (request, i) {
                    if (typeof request.provider.resolveCodeLens === 'function') {
                        return Promise.resolve(request.provider.resolveCodeLens(model, request.symbol, token)).then(function (symbol) {
                            resolvedSymbols[i] = symbol;
                        });
                    }
                    resolvedSymbols[i] = request.symbol;
                    return Promise.resolve(void 0);
                });
                return Promise.all(promises).then(function () {
                    lenses[i].updateCommands(resolvedSymbols);
                });
            });
            return Promise.all(promises);
        });
        this._currentResolveCodeLensSymbolsPromise.then(function () {
            _this._currentResolveCodeLensSymbolsPromise = null;
        }).catch(function (err) {
            _this._currentResolveCodeLensSymbolsPromise = null;
            Object(__WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */])(err);
        });
    };
    CodeLensContribution.ID = 'css.editor.codeLens';
    CodeLensContribution = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_7__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_8__platform_notification_common_notification_js__["a" /* INotificationService */])
    ], CodeLensContribution);
    return CodeLensContribution;
}());

Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["h" /* registerEditorContribution */])(CodeLensContribution);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blockCommentCommand_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lineCommentCommand_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_actions_common_actions_js__ = __webpack_require__(41);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var CommentLineAction = /** @class */ (function (_super) {
    __extends(CommentLineAction, _super);
    function CommentLineAction(type, opts) {
        var _this = _super.call(this, opts) || this;
        _this._type = type;
        return _this;
    }
    CommentLineAction.prototype.run = function (accessor, editor) {
        var model = editor.getModel();
        if (!model) {
            return;
        }
        var commands = [];
        var selections = editor.getSelections();
        var opts = model.getOptions();
        for (var i = 0; i < selections.length; i++) {
            commands.push(new __WEBPACK_IMPORTED_MODULE_5__lineCommentCommand_js__["a" /* LineCommentCommand */](selections[i], opts.tabSize, this._type));
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return CommentLineAction;
}(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["b" /* EditorAction */]));
var ToggleCommentLineAction = /** @class */ (function (_super) {
    __extends(ToggleCommentLineAction, _super);
    function ToggleCommentLineAction() {
        return _super.call(this, 0 /* Toggle */, {
            id: 'editor.action.commentLine',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('comment.line', "Toggle Line Comment"),
            alias: 'Toggle Line Comment',
            precondition: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 85 /* US_SLASH */,
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_6__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
                group: '5_insert',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miToggleLineComment', comment: ['&& denotes a mnemonic'] }, "&&Toggle Line Comment"),
                order: 1
            }
        }) || this;
    }
    return ToggleCommentLineAction;
}(CommentLineAction));
var AddLineCommentAction = /** @class */ (function (_super) {
    __extends(AddLineCommentAction, _super);
    function AddLineCommentAction() {
        return _super.call(this, 1 /* ForceAdd */, {
            id: 'editor.action.addCommentLine',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('comment.line.add', "Add Line Comment"),
            alias: 'Add Line Comment',
            precondition: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_1__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 33 /* KEY_C */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return AddLineCommentAction;
}(CommentLineAction));
var RemoveLineCommentAction = /** @class */ (function (_super) {
    __extends(RemoveLineCommentAction, _super);
    function RemoveLineCommentAction() {
        return _super.call(this, 2 /* ForceRemove */, {
            id: 'editor.action.removeCommentLine',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('comment.line.remove', "Remove Line Comment"),
            alias: 'Remove Line Comment',
            precondition: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_1__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 51 /* KEY_U */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return RemoveLineCommentAction;
}(CommentLineAction));
var BlockCommentAction = /** @class */ (function (_super) {
    __extends(BlockCommentAction, _super);
    function BlockCommentAction() {
        return _super.call(this, {
            id: 'editor.action.blockComment',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('comment.block', "Toggle Block Comment"),
            alias: 'Toggle Block Comment',
            precondition: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_2__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 512 /* Alt */ | 31 /* KEY_A */,
                linux: { primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 31 /* KEY_A */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_6__platform_actions_common_actions_js__["b" /* MenuId */].MenubarEditMenu,
                group: '5_insert',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miToggleBlockComment', comment: ['&& denotes a mnemonic'] }, "Toggle &&Block Comment"),
                order: 2
            }
        }) || this;
    }
    BlockCommentAction.prototype.run = function (accessor, editor) {
        var commands = [];
        var selections = editor.getSelections();
        for (var i = 0; i < selections.length; i++) {
            commands.push(new __WEBPACK_IMPORTED_MODULE_4__blockCommentCommand_js__["a" /* BlockCommentCommand */](selections[i]));
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return BlockCommentAction;
}(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["f" /* registerEditorAction */])(ToggleCommentLineAction);
Object(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["f" /* registerEditorAction */])(AddLineCommentAction);
Object(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["f" /* registerEditorAction */])(RemoveLineCommentAction);
Object(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["f" /* registerEditorAction */])(BlockCommentAction);


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContextMenuController", function() { return ContextMenuController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_actionbar_actionbar_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_contextview_browser_contextView_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__browser_editorBrowser_js__ = __webpack_require__(20);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};












var ContextMenuController = /** @class */ (function () {
    function ContextMenuController(editor, _contextMenuService, _contextViewService, _contextKeyService, _keybindingService, _menuService) {
        var _this = this;
        this._contextMenuService = _contextMenuService;
        this._contextViewService = _contextViewService;
        this._contextKeyService = _contextKeyService;
        this._keybindingService = _keybindingService;
        this._menuService = _menuService;
        this._toDispose = [];
        this._contextMenuIsBeingShownCount = 0;
        this._editor = editor;
        this._toDispose.push(this._editor.onContextMenu(function (e) { return _this._onContextMenu(e); }));
        this._toDispose.push(this._editor.onDidScrollChange(function (e) {
            if (_this._contextMenuIsBeingShownCount > 0) {
                _this._contextViewService.hideContextView();
            }
        }));
        this._toDispose.push(this._editor.onKeyDown(function (e) {
            if (e.keyCode === 58 /* ContextMenu */) {
                // Chrome is funny like that
                e.preventDefault();
                e.stopPropagation();
                _this.showContextMenu();
            }
        }));
    }
    ContextMenuController.get = function (editor) {
        return editor.getContribution(ContextMenuController.ID);
    };
    ContextMenuController.prototype._onContextMenu = function (e) {
        if (!this._editor.getConfiguration().contribInfo.contextmenu) {
            this._editor.focus();
            // Ensure the cursor is at the position of the mouse click
            if (e.target.position && !this._editor.getSelection().containsPosition(e.target.position)) {
                this._editor.setPosition(e.target.position);
            }
            return; // Context menu is turned off through configuration
        }
        if (e.target.type === __WEBPACK_IMPORTED_MODULE_11__browser_editorBrowser_js__["b" /* MouseTargetType */].OVERLAY_WIDGET) {
            return; // allow native menu on widgets to support right click on input field for example in find
        }
        e.event.preventDefault();
        if (e.target.type !== __WEBPACK_IMPORTED_MODULE_11__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT && e.target.type !== __WEBPACK_IMPORTED_MODULE_11__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY && e.target.type !== __WEBPACK_IMPORTED_MODULE_11__browser_editorBrowser_js__["b" /* MouseTargetType */].TEXTAREA) {
            return; // only support mouse click into text or native context menu key for now
        }
        // Ensure the editor gets focus if it hasn't, so the right events are being sent to other contributions
        this._editor.focus();
        // Ensure the cursor is at the position of the mouse click
        if (e.target.position && !this._editor.getSelection().containsPosition(e.target.position)) {
            this._editor.setPosition(e.target.position);
        }
        // Unless the user triggerd the context menu through Shift+F10, use the mouse position as menu position
        var forcedPosition;
        if (e.target.type !== __WEBPACK_IMPORTED_MODULE_11__browser_editorBrowser_js__["b" /* MouseTargetType */].TEXTAREA) {
            forcedPosition = { x: e.event.posx, y: e.event.posy + 1 };
        }
        // Show the context menu
        this.showContextMenu(forcedPosition);
    };
    ContextMenuController.prototype.showContextMenu = function (forcedPosition) {
        if (!this._editor.getConfiguration().contribInfo.contextmenu) {
            return; // Context menu is turned off through configuration
        }
        if (!this._contextMenuService) {
            this._editor.focus();
            return; // We need the context menu service to function
        }
        // Find actions available for menu
        var menuActions = this._getMenuActions();
        // Show menu if we have actions to show
        if (menuActions.length > 0) {
            this._doShowContextMenu(menuActions, forcedPosition);
        }
    };
    ContextMenuController.prototype._getMenuActions = function () {
        var result = [];
        var contextMenu = this._menuService.createMenu(__WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["b" /* MenuId */].EditorContext, this._contextKeyService);
        var groups = contextMenu.getActions({ arg: this._editor.getModel().uri });
        contextMenu.dispose();
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var group = groups_1[_i];
            var actions = group[1];
            result.push.apply(result, actions);
            result.push(new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_actionbar_actionbar_js__["e" /* Separator */]());
        }
        result.pop(); // remove last separator
        return result;
    };
    ContextMenuController.prototype._doShowContextMenu = function (actions, forcedPosition) {
        var _this = this;
        if (forcedPosition === void 0) { forcedPosition = null; }
        // Disable hover
        var oldHoverSetting = this._editor.getConfiguration().contribInfo.hover;
        this._editor.updateOptions({
            hover: {
                enabled: false
            }
        });
        var menuPosition = forcedPosition;
        if (!menuPosition) {
            // Ensure selection is visible
            this._editor.revealPosition(this._editor.getPosition(), 1 /* Immediate */);
            this._editor.render();
            var cursorCoords = this._editor.getScrolledVisiblePosition(this._editor.getPosition());
            // Translate to absolute editor position
            var editorCoords = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["u" /* getDomNodePagePosition */](this._editor.getDomNode());
            var posx = editorCoords.left + cursorCoords.left;
            var posy = editorCoords.top + cursorCoords.top + cursorCoords.height;
            menuPosition = { x: posx, y: posy };
        }
        // Show menu
        this._contextMenuIsBeingShownCount++;
        this._contextMenuService.showContextMenu({
            getAnchor: function () { return menuPosition; },
            getActions: function () {
                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(actions);
            },
            getActionItem: function (action) {
                var keybinding = _this._keybindingFor(action);
                if (keybinding) {
                    return new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_actionbar_actionbar_js__["b" /* ActionItem */](action, action, { label: true, keybinding: keybinding.getLabel(), isMenu: true });
                }
                var customActionItem = action;
                if (typeof customActionItem.getActionItem === 'function') {
                    return customActionItem.getActionItem();
                }
                return new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_actionbar_actionbar_js__["b" /* ActionItem */](action, action, { icon: true, label: true, isMenu: true });
            },
            getKeyBinding: function (action) {
                return _this._keybindingFor(action);
            },
            onHide: function (wasCancelled) {
                _this._contextMenuIsBeingShownCount--;
                _this._editor.focus();
                _this._editor.updateOptions({
                    hover: oldHoverSetting
                });
            }
        });
    };
    ContextMenuController.prototype._keybindingFor = function (action) {
        return this._keybindingService.lookupKeybinding(action.id);
    };
    ContextMenuController.prototype.getId = function () {
        return ContextMenuController.ID;
    };
    ContextMenuController.prototype.dispose = function () {
        if (this._contextMenuIsBeingShownCount > 0) {
            this._contextViewService.hideContextView();
        }
        this._toDispose = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._toDispose);
    };
    ContextMenuController.ID = 'editor.contrib.contextmenu';
    ContextMenuController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_5__platform_contextview_browser_contextView_js__["a" /* IContextMenuService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_5__platform_contextview_browser_contextView_js__["b" /* IContextViewService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_7__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_6__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["a" /* IMenuService */])
    ], ContextMenuController);
    return ContextMenuController;
}());

var ShowContextMenu = /** @class */ (function (_super) {
    __extends(ShowContextMenu, _super);
    function ShowContextMenu() {
        return _super.call(this, {
            id: 'editor.action.showContextMenu',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('action.showContextMenu.label', "Show Editor Context Menu"),
            alias: 'Show Editor Context Menu',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_9__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 1024 /* Shift */ | 68 /* F10 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    ShowContextMenu.prototype.run = function (accessor, editor) {
        var contribution = ContextMenuController.get(editor);
        contribution.showContextMenu();
    };
    return ShowContextMenu;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["h" /* registerEditorContribution */])(ContextMenuController);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(ShowContextMenu);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function memoize(target, key, descriptor) {
    var fnKey = null;
    var fn = null;
    if (typeof descriptor.value === 'function') {
        fnKey = 'value';
        fn = descriptor.value;
        if (fn.length !== 0) {
            console.warn('Memoize should only be used in functions with zero parameters');
        }
    }
    else if (typeof descriptor.get === 'function') {
        fnKey = 'get';
        fn = descriptor.get;
    }
    if (!fn) {
        throw new Error('not supported');
    }
    var memoizeKey = "$memoize$" + key;
    descriptor[fnKey] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.hasOwnProperty(memoizeKey)) {
            Object.defineProperty(this, memoizeKey, {
                configurable: false,
                enumerable: false,
                writable: false,
                value: fn.apply(this, args)
            });
        }
        return this[memoizeKey];
    };
}


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WordOperations; });
/* unused harmony export _lastWordPartEnd */
/* unused harmony export _nextWordPartBegin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WordPartOperations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wordCharacterClassifier_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var WordOperations = /** @class */ (function () {
    function WordOperations() {
    }
    WordOperations._createWord = function (lineContent, wordType, nextCharClass, start, end) {
        // console.log('WORD ==> ' + start + ' => ' + end + ':::: <<<' + lineContent.substring(start, end) + '>>>');
        return { start: start, end: end, wordType: wordType, nextCharClass: nextCharClass };
    };
    WordOperations._findPreviousWordOnLine = function (wordSeparators, model, position) {
        var lineContent = model.getLineContent(position.lineNumber);
        return this._doFindPreviousWordOnLine(lineContent, wordSeparators, position);
    };
    WordOperations._doFindPreviousWordOnLine = function (lineContent, wordSeparators, position) {
        var wordType = 0 /* None */;
        for (var chIndex = position.column - 2; chIndex >= 0; chIndex--) {
            var chCode = lineContent.charCodeAt(chIndex);
            var chClass = wordSeparators.get(chCode);
            if (chClass === 0 /* Regular */) {
                if (wordType === 2 /* Separator */) {
                    return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
                }
                wordType = 1 /* Regular */;
            }
            else if (chClass === 2 /* WordSeparator */) {
                if (wordType === 1 /* Regular */) {
                    return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
                }
                wordType = 2 /* Separator */;
            }
            else if (chClass === 1 /* Whitespace */) {
                if (wordType !== 0 /* None */) {
                    return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
                }
            }
        }
        if (wordType !== 0 /* None */) {
            return this._createWord(lineContent, wordType, 1 /* Whitespace */, 0, this._findEndOfWord(lineContent, wordSeparators, wordType, 0));
        }
        return null;
    };
    WordOperations._findEndOfWord = function (lineContent, wordSeparators, wordType, startIndex) {
        var len = lineContent.length;
        for (var chIndex = startIndex; chIndex < len; chIndex++) {
            var chCode = lineContent.charCodeAt(chIndex);
            var chClass = wordSeparators.get(chCode);
            if (chClass === 1 /* Whitespace */) {
                return chIndex;
            }
            if (wordType === 1 /* Regular */ && chClass === 2 /* WordSeparator */) {
                return chIndex;
            }
            if (wordType === 2 /* Separator */ && chClass === 0 /* Regular */) {
                return chIndex;
            }
        }
        return len;
    };
    WordOperations._findNextWordOnLine = function (wordSeparators, model, position) {
        var lineContent = model.getLineContent(position.lineNumber);
        return this._doFindNextWordOnLine(lineContent, wordSeparators, position);
    };
    WordOperations._doFindNextWordOnLine = function (lineContent, wordSeparators, position) {
        var wordType = 0 /* None */;
        var len = lineContent.length;
        for (var chIndex = position.column - 1; chIndex < len; chIndex++) {
            var chCode = lineContent.charCodeAt(chIndex);
            var chClass = wordSeparators.get(chCode);
            if (chClass === 0 /* Regular */) {
                if (wordType === 2 /* Separator */) {
                    return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
                }
                wordType = 1 /* Regular */;
            }
            else if (chClass === 2 /* WordSeparator */) {
                if (wordType === 1 /* Regular */) {
                    return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
                }
                wordType = 2 /* Separator */;
            }
            else if (chClass === 1 /* Whitespace */) {
                if (wordType !== 0 /* None */) {
                    return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
                }
            }
        }
        if (wordType !== 0 /* None */) {
            return this._createWord(lineContent, wordType, 1 /* Whitespace */, this._findStartOfWord(lineContent, wordSeparators, wordType, len - 1), len);
        }
        return null;
    };
    WordOperations._findStartOfWord = function (lineContent, wordSeparators, wordType, startIndex) {
        for (var chIndex = startIndex; chIndex >= 0; chIndex--) {
            var chCode = lineContent.charCodeAt(chIndex);
            var chClass = wordSeparators.get(chCode);
            if (chClass === 1 /* Whitespace */) {
                return chIndex + 1;
            }
            if (wordType === 1 /* Regular */ && chClass === 2 /* WordSeparator */) {
                return chIndex + 1;
            }
            if (wordType === 2 /* Separator */ && chClass === 0 /* Regular */) {
                return chIndex + 1;
            }
        }
        return 0;
    };
    WordOperations.moveWordLeft = function (wordSeparators, model, position, wordNavigationType) {
        var lineNumber = position.lineNumber;
        var column = position.column;
        if (column === 1) {
            if (lineNumber > 1) {
                lineNumber = lineNumber - 1;
                column = model.getLineMaxColumn(lineNumber);
            }
        }
        var prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, column));
        if (wordNavigationType === 0 /* WordStart */) {
            if (prevWordOnLine && prevWordOnLine.wordType === 2 /* Separator */) {
                if (prevWordOnLine.end - prevWordOnLine.start === 1 && prevWordOnLine.nextCharClass === 0 /* Regular */) {
                    // Skip over a word made up of one single separator and followed by a regular character
                    prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, prevWordOnLine.start + 1));
                }
            }
            if (prevWordOnLine) {
                column = prevWordOnLine.start + 1;
            }
            else {
                column = 1;
            }
        }
        else {
            if (prevWordOnLine && column <= prevWordOnLine.end + 1) {
                prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, prevWordOnLine.start + 1));
            }
            if (prevWordOnLine) {
                column = prevWordOnLine.end + 1;
            }
            else {
                column = 1;
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, column);
    };
    WordOperations.moveWordRight = function (wordSeparators, model, position, wordNavigationType) {
        var lineNumber = position.lineNumber;
        var column = position.column;
        if (column === model.getLineMaxColumn(lineNumber)) {
            if (lineNumber < model.getLineCount()) {
                lineNumber = lineNumber + 1;
                column = 1;
            }
        }
        var nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, column));
        if (wordNavigationType === 1 /* WordEnd */) {
            if (nextWordOnLine && nextWordOnLine.wordType === 2 /* Separator */) {
                if (nextWordOnLine.end - nextWordOnLine.start === 1 && nextWordOnLine.nextCharClass === 0 /* Regular */) {
                    // Skip over a word made up of one single separator and followed by a regular character
                    nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, nextWordOnLine.end + 1));
                }
            }
            if (nextWordOnLine) {
                column = nextWordOnLine.end + 1;
            }
            else {
                column = model.getLineMaxColumn(lineNumber);
            }
        }
        else {
            if (nextWordOnLine && column >= nextWordOnLine.start + 1) {
                nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, nextWordOnLine.end + 1));
            }
            if (nextWordOnLine) {
                column = nextWordOnLine.start + 1;
            }
            else {
                column = model.getLineMaxColumn(lineNumber);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, column);
    };
    WordOperations._deleteWordLeftWhitespace = function (model, position) {
        var lineContent = model.getLineContent(position.lineNumber);
        var startIndex = position.column - 2;
        var lastNonWhitespace = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["lastNonWhitespaceIndex"](lineContent, startIndex);
        if (lastNonWhitespace + 1 < startIndex) {
            return new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](position.lineNumber, lastNonWhitespace + 2, position.lineNumber, position.column);
        }
        return null;
    };
    WordOperations.deleteWordLeft = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        if (!selection.isEmpty()) {
            return selection;
        }
        var position = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](selection.positionLineNumber, selection.positionColumn);
        var lineNumber = position.lineNumber;
        var column = position.column;
        if (lineNumber === 1 && column === 1) {
            // Ignore deleting at beginning of file
            return null;
        }
        if (whitespaceHeuristics) {
            var r = this._deleteWordLeftWhitespace(model, position);
            if (r) {
                return r;
            }
        }
        var prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
        if (wordNavigationType === 0 /* WordStart */) {
            if (prevWordOnLine) {
                column = prevWordOnLine.start + 1;
            }
            else {
                if (column > 1) {
                    column = 1;
                }
                else {
                    lineNumber--;
                    column = model.getLineMaxColumn(lineNumber);
                }
            }
        }
        else {
            if (prevWordOnLine && column <= prevWordOnLine.end + 1) {
                prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, prevWordOnLine.start + 1));
            }
            if (prevWordOnLine) {
                column = prevWordOnLine.end + 1;
            }
            else {
                if (column > 1) {
                    column = 1;
                }
                else {
                    lineNumber--;
                    column = model.getLineMaxColumn(lineNumber);
                }
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](lineNumber, column, position.lineNumber, position.column);
    };
    WordOperations._findFirstNonWhitespaceChar = function (str, startIndex) {
        var len = str.length;
        for (var chIndex = startIndex; chIndex < len; chIndex++) {
            var ch = str.charAt(chIndex);
            if (ch !== ' ' && ch !== '\t') {
                return chIndex;
            }
        }
        return len;
    };
    WordOperations._deleteWordRightWhitespace = function (model, position) {
        var lineContent = model.getLineContent(position.lineNumber);
        var startIndex = position.column - 1;
        var firstNonWhitespace = this._findFirstNonWhitespaceChar(lineContent, startIndex);
        if (startIndex + 1 < firstNonWhitespace) {
            // bingo
            return new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, firstNonWhitespace + 1);
        }
        return null;
    };
    WordOperations.deleteWordRight = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        if (!selection.isEmpty()) {
            return selection;
        }
        var position = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](selection.positionLineNumber, selection.positionColumn);
        var lineNumber = position.lineNumber;
        var column = position.column;
        var lineCount = model.getLineCount();
        var maxColumn = model.getLineMaxColumn(lineNumber);
        if (lineNumber === lineCount && column === maxColumn) {
            // Ignore deleting at end of file
            return null;
        }
        if (whitespaceHeuristics) {
            var r = this._deleteWordRightWhitespace(model, position);
            if (r) {
                return r;
            }
        }
        var nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, position);
        if (wordNavigationType === 1 /* WordEnd */) {
            if (nextWordOnLine) {
                column = nextWordOnLine.end + 1;
            }
            else {
                if (column < maxColumn || lineNumber === lineCount) {
                    column = maxColumn;
                }
                else {
                    lineNumber++;
                    nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, 1));
                    if (nextWordOnLine) {
                        column = nextWordOnLine.start + 1;
                    }
                    else {
                        column = model.getLineMaxColumn(lineNumber);
                    }
                }
            }
        }
        else {
            if (nextWordOnLine && column >= nextWordOnLine.start + 1) {
                nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, nextWordOnLine.end + 1));
            }
            if (nextWordOnLine) {
                column = nextWordOnLine.start + 1;
            }
            else {
                if (column < maxColumn || lineNumber === lineCount) {
                    column = maxColumn;
                }
                else {
                    lineNumber++;
                    nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, 1));
                    if (nextWordOnLine) {
                        column = nextWordOnLine.start + 1;
                    }
                    else {
                        column = model.getLineMaxColumn(lineNumber);
                    }
                }
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](lineNumber, column, position.lineNumber, position.column);
    };
    WordOperations.word = function (config, model, cursor, inSelectionMode, position) {
        var wordSeparators = Object(__WEBPACK_IMPORTED_MODULE_2__wordCharacterClassifier_js__["a" /* getMapForWordSeparators */])(config.wordSeparators);
        var prevWord = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
        var nextWord = WordOperations._findNextWordOnLine(wordSeparators, model, position);
        if (!inSelectionMode) {
            // Entering word selection for the first time
            var isTouchingPrevWord = (prevWord && prevWord.wordType === 1 /* Regular */ && prevWord.start <= position.column - 1 && position.column - 1 <= prevWord.end);
            var isTouchingNextWord = (nextWord && nextWord.wordType === 1 /* Regular */ && nextWord.start <= position.column - 1 && position.column - 1 <= nextWord.end);
            var startColumn_1;
            var endColumn_1;
            if (isTouchingPrevWord) {
                startColumn_1 = prevWord.start + 1;
                endColumn_1 = prevWord.end + 1;
            }
            else if (isTouchingNextWord) {
                startColumn_1 = nextWord.start + 1;
                endColumn_1 = nextWord.end + 1;
            }
            else {
                if (prevWord) {
                    startColumn_1 = prevWord.end + 1;
                }
                else {
                    startColumn_1 = 1;
                }
                if (nextWord) {
                    endColumn_1 = nextWord.start + 1;
                }
                else {
                    endColumn_1 = model.getLineMaxColumn(position.lineNumber);
                }
            }
            return new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](position.lineNumber, startColumn_1, position.lineNumber, endColumn_1), 0, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](position.lineNumber, endColumn_1), 0);
        }
        var isInsidePrevWord = (prevWord && prevWord.wordType === 1 /* Regular */ && prevWord.start < position.column - 1 && position.column - 1 < prevWord.end);
        var isInsideNextWord = (nextWord && nextWord.wordType === 1 /* Regular */ && nextWord.start < position.column - 1 && position.column - 1 < nextWord.end);
        var startColumn;
        var endColumn;
        if (isInsidePrevWord) {
            startColumn = prevWord.start + 1;
            endColumn = prevWord.end + 1;
        }
        else if (isInsideNextWord) {
            startColumn = nextWord.start + 1;
            endColumn = nextWord.end + 1;
        }
        else {
            startColumn = position.column;
            endColumn = position.column;
        }
        var lineNumber = position.lineNumber;
        var column;
        if (cursor.selectionStart.containsPosition(position)) {
            column = cursor.selectionStart.endColumn;
        }
        else if (position.isBeforeOrEqual(cursor.selectionStart.getStartPosition())) {
            column = startColumn;
            var possiblePosition = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, column);
            if (cursor.selectionStart.containsPosition(possiblePosition)) {
                column = cursor.selectionStart.endColumn;
            }
        }
        else {
            column = endColumn;
            var possiblePosition = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, column);
            if (cursor.selectionStart.containsPosition(possiblePosition)) {
                column = cursor.selectionStart.startColumn;
            }
        }
        return cursor.move(true, lineNumber, column, 0);
    };
    return WordOperations;
}());

function _lastWordPartEnd(str, startIndex) {
    if (startIndex === void 0) { startIndex = str.length - 1; }
    var ignoreUpperCase = !__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isLowerAsciiLetter"](str.charCodeAt(startIndex + 1));
    for (var i = startIndex; i >= 0; i--) {
        var chCode = str.charCodeAt(i);
        if (chCode === 32 /* Space */ || chCode === 9 /* Tab */ || (!ignoreUpperCase && __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isUpperAsciiLetter"](chCode)) || chCode === 95 /* Underline */) {
            return i - 1;
        }
        if (ignoreUpperCase && i < startIndex && __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isLowerAsciiLetter"](chCode)) {
            return i;
        }
        ignoreUpperCase = ignoreUpperCase && __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isUpperAsciiLetter"](chCode);
    }
    return -1;
}
function _nextWordPartBegin(str, startIndex) {
    if (startIndex === void 0) { startIndex = 0; }
    var prevChCode = str.charCodeAt(startIndex - 1);
    var chCode = str.charCodeAt(startIndex);
    // handle the special case ' X' and ' x' which is different from the standard methods
    if ((prevChCode === 32 /* Space */ || prevChCode === 9 /* Tab */) && (__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isLowerAsciiLetter"](chCode) || __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isUpperAsciiLetter"](chCode))) {
        return startIndex + 1;
    }
    var ignoreUpperCase = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isUpperAsciiLetter"](chCode);
    for (var i = startIndex; i < str.length; ++i) {
        chCode = str.charCodeAt(i);
        if (chCode === 32 /* Space */ || chCode === 9 /* Tab */ || (!ignoreUpperCase && __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isUpperAsciiLetter"](chCode))) {
            return i + 1;
        }
        if (ignoreUpperCase && __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isLowerAsciiLetter"](chCode)) {
            return i; // multiple UPPERCase : assume an upper case word and a CamelCase word - like DSLModel
        }
        ignoreUpperCase = ignoreUpperCase && __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isUpperAsciiLetter"](chCode);
        if (chCode === 95 /* Underline */) {
            return i + 2;
        }
    }
    return str.length + 1;
}
var WordPartOperations = /** @class */ (function (_super) {
    __extends(WordPartOperations, _super);
    function WordPartOperations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WordPartOperations.deleteWordPartLeft = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        if (!selection.isEmpty()) {
            return selection;
        }
        var position = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](selection.positionLineNumber, selection.positionColumn);
        var lineNumber = position.lineNumber;
        var column = position.column;
        if (lineNumber === 1 && column === 1) {
            // Ignore deleting at beginning of file
            return null;
        }
        if (whitespaceHeuristics) {
            var r = WordOperations._deleteWordLeftWhitespace(model, position);
            if (r) {
                return r;
            }
        }
        var wordRange = WordOperations.deleteWordLeft(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);
        var lastWordPartEnd = _lastWordPartEnd(model.getLineContent(position.lineNumber), position.column - 2);
        var wordPartRange = new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](lineNumber, column, lineNumber, lastWordPartEnd + 2);
        if (wordPartRange.getStartPosition().isBeforeOrEqual(wordRange.getStartPosition())) {
            return wordRange;
        }
        return wordPartRange;
    };
    WordPartOperations.deleteWordPartRight = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        if (!selection.isEmpty()) {
            return selection;
        }
        var position = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](selection.positionLineNumber, selection.positionColumn);
        var lineNumber = position.lineNumber;
        var column = position.column;
        var lineCount = model.getLineCount();
        var maxColumn = model.getLineMaxColumn(lineNumber);
        if (lineNumber === lineCount && column === maxColumn) {
            // Ignore deleting at end of file
            return null;
        }
        if (whitespaceHeuristics) {
            var r = WordOperations._deleteWordRightWhitespace(model, position);
            if (r) {
                return r;
            }
        }
        var wordRange = WordOperations.deleteWordRight(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);
        var nextWordPartBegin = _nextWordPartBegin(model.getLineContent(position.lineNumber), position.column);
        var wordPartRange = new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](lineNumber, column, lineNumber, nextWordPartBegin);
        if (wordRange.getEndPosition().isBeforeOrEqual(wordPartRange.getEndPosition())) {
            return wordRange;
        }
        return wordPartRange;
    };
    WordPartOperations.moveWordPartLeft = function (wordSeparators, model, position, wordNavigationType) {
        var lineNumber = position.lineNumber;
        var column = position.column;
        if (column === 1) {
            return (lineNumber > 1 ? new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber - 1, model.getLineMaxColumn(lineNumber - 1)) : position);
        }
        var wordPos = WordOperations.moveWordLeft(wordSeparators, model, position, wordNavigationType);
        var lastWordPartEnd = _lastWordPartEnd(model.getLineContent(lineNumber), column - 2);
        var wordPartPos = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, lastWordPartEnd + 2);
        if (wordPartPos.isBeforeOrEqual(wordPos)) {
            return wordPos;
        }
        return wordPartPos;
    };
    WordPartOperations.moveWordPartRight = function (wordSeparators, model, position, wordNavigationType) {
        var lineNumber = position.lineNumber;
        var column = position.column;
        var maxColumn = model.getLineMaxColumn(lineNumber);
        if (column === maxColumn) {
            return (lineNumber < model.getLineCount() ? new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber + 1, 1) : position);
        }
        var wordPos = WordOperations.moveWordRight(wordSeparators, model, position, wordNavigationType);
        var nextWordPartBegin = _nextWordPartBegin(model.getLineContent(lineNumber), column);
        var wordPartPos = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, nextWordPartBegin);
        if (wordPos.isBeforeOrEqual(wordPartPos)) {
            return wordPos;
        }
        return wordPartPos;
    };
    return WordPartOperations;
}(WordOperations));



/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeOperations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_shiftCommand_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modes_languageConfiguration_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commands_surroundSelectionCommand_js__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wordCharacterClassifier_js__ = __webpack_require__(82);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/











var TypeOperations = /** @class */ (function () {
    function TypeOperations() {
    }
    TypeOperations.indent = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            commands[i] = new __WEBPACK_IMPORTED_MODULE_5__commands_shiftCommand_js__["a" /* ShiftCommand */](selections[i], {
                isUnshift: false,
                tabSize: config.tabSize,
                oneIndent: config.oneIndent,
                useTabStops: config.useTabStops
            });
        }
        return commands;
    };
    TypeOperations.outdent = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            commands[i] = new __WEBPACK_IMPORTED_MODULE_5__commands_shiftCommand_js__["a" /* ShiftCommand */](selections[i], {
                isUnshift: true,
                tabSize: config.tabSize,
                oneIndent: config.oneIndent,
                useTabStops: config.useTabStops
            });
        }
        return commands;
    };
    TypeOperations.shiftIndent = function (config, indentation, count) {
        count = count || 1;
        var desiredIndentCount = __WEBPACK_IMPORTED_MODULE_5__commands_shiftCommand_js__["a" /* ShiftCommand */].shiftIndentCount(indentation, indentation.length + count, config.tabSize);
        var newIndentation = '';
        for (var i = 0; i < desiredIndentCount; i++) {
            newIndentation += '\t';
        }
        return newIndentation;
    };
    TypeOperations.unshiftIndent = function (config, indentation, count) {
        count = count || 1;
        var desiredIndentCount = __WEBPACK_IMPORTED_MODULE_5__commands_shiftCommand_js__["a" /* ShiftCommand */].unshiftIndentCount(indentation, indentation.length + count, config.tabSize);
        var newIndentation = '';
        for (var i = 0; i < desiredIndentCount; i++) {
            newIndentation += '\t';
        }
        return newIndentation;
    };
    TypeOperations._distributedPaste = function (config, model, selections, text) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](selections[i], text[i]);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](0 /* Other */, commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    };
    TypeOperations._simplePaste = function (config, model, selections, text, pasteOnNewLine) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var position = selection.getPosition();
            if (pasteOnNewLine && text.indexOf('\n') !== text.length - 1) {
                pasteOnNewLine = false;
            }
            if (pasteOnNewLine && selection.startLineNumber !== selection.endLineNumber) {
                pasteOnNewLine = false;
            }
            if (pasteOnNewLine && selection.startColumn === model.getLineMinColumn(selection.startLineNumber) && selection.endColumn === model.getLineMaxColumn(selection.startLineNumber)) {
                pasteOnNewLine = false;
            }
            if (pasteOnNewLine) {
                // Paste entire line at the beginning of line
                var typeSelection = new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](position.lineNumber, 1, position.lineNumber, 1);
                commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](typeSelection, text);
            }
            else {
                commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](selection, text);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](0 /* Other */, commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    };
    TypeOperations._distributePasteToCursors = function (selections, text, pasteOnNewLine, multicursorText) {
        if (pasteOnNewLine) {
            return null;
        }
        if (selections.length === 1) {
            return null;
        }
        if (multicursorText && multicursorText.length === selections.length) {
            return multicursorText;
        }
        // Remove trailing \n if present
        if (text.charCodeAt(text.length - 1) === 10 /* LineFeed */) {
            text = text.substr(0, text.length - 1);
        }
        var lines = text.split(/\r\n|\r|\n/);
        if (lines.length === selections.length) {
            return lines;
        }
        return null;
    };
    TypeOperations.paste = function (config, model, selections, text, pasteOnNewLine, multicursorText) {
        var distributedPaste = this._distributePasteToCursors(selections, text, pasteOnNewLine, multicursorText);
        if (distributedPaste) {
            selections = selections.sort(__WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */].compareRangesUsingStarts);
            return this._distributedPaste(config, model, selections, distributedPaste);
        }
        else {
            return this._simplePaste(config, model, selections, text, pasteOnNewLine);
        }
    };
    TypeOperations._goodIndentForLine = function (config, model, lineNumber) {
        var action;
        var indentation;
        var expectedIndentAction = config.autoIndent ? __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getInheritIndentForLine(model, lineNumber, false) : null;
        if (expectedIndentAction) {
            action = expectedIndentAction.action;
            indentation = expectedIndentAction.indentation;
        }
        else if (lineNumber > 1) {
            var lastLineNumber = lineNumber - 1;
            for (lastLineNumber = lineNumber - 1; lastLineNumber >= 1; lastLineNumber--) {
                var lineText = model.getLineContent(lastLineNumber);
                var nonWhitespaceIdx = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["lastNonWhitespaceIndex"](lineText);
                if (nonWhitespaceIdx >= 0) {
                    break;
                }
            }
            if (lastLineNumber < 1) {
                // No previous line with content found
                return null;
            }
            var maxColumn = model.getLineMaxColumn(lastLineNumber);
            var expectedEnterAction = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getEnterAction(model, new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](lastLineNumber, maxColumn, lastLineNumber, maxColumn));
            if (expectedEnterAction) {
                indentation = expectedEnterAction.indentation;
                action = expectedEnterAction.enterAction;
                if (action) {
                    indentation += action.appendText;
                }
            }
        }
        if (action) {
            if (action === __WEBPACK_IMPORTED_MODULE_7__modes_languageConfiguration_js__["a" /* IndentAction */].Indent) {
                indentation = TypeOperations.shiftIndent(config, indentation);
            }
            if (action === __WEBPACK_IMPORTED_MODULE_7__modes_languageConfiguration_js__["a" /* IndentAction */].Outdent) {
                indentation = TypeOperations.unshiftIndent(config, indentation);
            }
            indentation = config.normalizeIndentation(indentation);
        }
        if (!indentation) {
            return null;
        }
        return indentation;
    };
    TypeOperations._replaceJumpToNextIndent = function (config, model, selection, insertsAutoWhitespace) {
        var typeText = '';
        var position = selection.getStartPosition();
        if (config.insertSpaces) {
            var visibleColumnFromColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(config, model, position);
            var tabSize = config.tabSize;
            var spacesCnt = tabSize - (visibleColumnFromColumn % tabSize);
            for (var i = 0; i < spacesCnt; i++) {
                typeText += ' ';
            }
        }
        else {
            typeText = '\t';
        }
        return new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](selection, typeText, insertsAutoWhitespace);
    };
    TypeOperations.tab = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (selection.isEmpty()) {
                var lineText = model.getLineContent(selection.startLineNumber);
                if (/^\s*$/.test(lineText) && model.isCheapToTokenize(selection.startLineNumber)) {
                    var goodIndent = this._goodIndentForLine(config, model, selection.startLineNumber);
                    goodIndent = goodIndent || '\t';
                    var possibleTypeText = config.normalizeIndentation(goodIndent);
                    if (!__WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["startsWith"](lineText, possibleTypeText)) {
                        commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](selection.startLineNumber, 1, selection.startLineNumber, lineText.length + 1), possibleTypeText, true);
                        continue;
                    }
                }
                commands[i] = this._replaceJumpToNextIndent(config, model, selection, true);
            }
            else {
                if (selection.startLineNumber === selection.endLineNumber) {
                    var lineMaxColumn = model.getLineMaxColumn(selection.startLineNumber);
                    if (selection.startColumn !== 1 || selection.endColumn !== lineMaxColumn) {
                        // This is a single line selection that is not the entire line
                        commands[i] = this._replaceJumpToNextIndent(config, model, selection, false);
                        continue;
                    }
                }
                commands[i] = new __WEBPACK_IMPORTED_MODULE_5__commands_shiftCommand_js__["a" /* ShiftCommand */](selection, {
                    isUnshift: false,
                    tabSize: config.tabSize,
                    oneIndent: config.oneIndent,
                    useTabStops: config.useTabStops
                });
            }
        }
        return commands;
    };
    TypeOperations.replacePreviousChar = function (prevEditOperationType, config, model, selections, txt, replaceCharCnt) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (!selection.isEmpty()) {
                // looks like https://github.com/Microsoft/vscode/issues/2773
                // where a cursor operation occurred before a canceled composition
                // => ignore composition
                commands[i] = null;
                continue;
            }
            var pos = selection.getPosition();
            var startColumn = Math.max(1, pos.column - replaceCharCnt);
            var range = new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](pos.lineNumber, startColumn, pos.lineNumber, pos.column);
            commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](range, txt);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands, {
            shouldPushStackElementBefore: (prevEditOperationType !== 1 /* Typing */),
            shouldPushStackElementAfter: false
        });
    };
    TypeOperations._typeCommand = function (range, text, keepPosition) {
        if (keepPosition) {
            return new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["d" /* ReplaceCommandWithoutChangingPosition */](range, text, true);
        }
        else {
            return new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](range, text, true);
        }
    };
    TypeOperations._enter = function (config, model, keepPosition, range) {
        if (!model.isCheapToTokenize(range.getStartPosition().lineNumber)) {
            var lineText_1 = model.getLineContent(range.startLineNumber);
            var indentation_1 = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["getLeadingWhitespace"](lineText_1).substring(0, range.startColumn - 1);
            return TypeOperations._typeCommand(range, '\n' + config.normalizeIndentation(indentation_1), keepPosition);
        }
        var r = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getEnterAction(model, range);
        if (r) {
            var enterAction = r.enterAction;
            var indentation_2 = r.indentation;
            if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_7__modes_languageConfiguration_js__["a" /* IndentAction */].None) {
                // Nothing special
                return TypeOperations._typeCommand(range, '\n' + config.normalizeIndentation(indentation_2 + enterAction.appendText), keepPosition);
            }
            else if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_7__modes_languageConfiguration_js__["a" /* IndentAction */].Indent) {
                // Indent once
                return TypeOperations._typeCommand(range, '\n' + config.normalizeIndentation(indentation_2 + enterAction.appendText), keepPosition);
            }
            else if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_7__modes_languageConfiguration_js__["a" /* IndentAction */].IndentOutdent) {
                // Ultra special
                var normalIndent = config.normalizeIndentation(indentation_2);
                var increasedIndent = config.normalizeIndentation(indentation_2 + enterAction.appendText);
                var typeText = '\n' + increasedIndent + '\n' + normalIndent;
                if (keepPosition) {
                    return new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["d" /* ReplaceCommandWithoutChangingPosition */](range, typeText, true);
                }
                else {
                    return new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["c" /* ReplaceCommandWithOffsetCursorState */](range, typeText, -1, increasedIndent.length - normalIndent.length, true);
                }
            }
            else if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_7__modes_languageConfiguration_js__["a" /* IndentAction */].Outdent) {
                var actualIndentation = TypeOperations.unshiftIndent(config, indentation_2);
                return TypeOperations._typeCommand(range, '\n' + config.normalizeIndentation(actualIndentation + enterAction.appendText), keepPosition);
            }
        }
        // no enter rules applied, we should check indentation rules then.
        if (!config.autoIndent) {
            // Nothing special
            var lineText_2 = model.getLineContent(range.startLineNumber);
            var indentation_3 = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["getLeadingWhitespace"](lineText_2).substring(0, range.startColumn - 1);
            return TypeOperations._typeCommand(range, '\n' + config.normalizeIndentation(indentation_3), keepPosition);
        }
        var ir = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getIndentForEnter(model, range, {
            unshiftIndent: function (indent) {
                return TypeOperations.unshiftIndent(config, indent);
            },
            shiftIndent: function (indent) {
                return TypeOperations.shiftIndent(config, indent);
            },
            normalizeIndentation: function (indent) {
                return config.normalizeIndentation(indent);
            }
        }, config.autoIndent);
        var lineText = model.getLineContent(range.startLineNumber);
        var indentation = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["getLeadingWhitespace"](lineText).substring(0, range.startColumn - 1);
        if (ir) {
            var oldEndViewColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(config, model, range.getEndPosition());
            var oldEndColumn = range.endColumn;
            var beforeText = '\n';
            if (indentation !== config.normalizeIndentation(ir.beforeEnter)) {
                beforeText = config.normalizeIndentation(ir.beforeEnter) + lineText.substring(indentation.length, range.startColumn - 1) + '\n';
                range = new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](range.startLineNumber, 1, range.endLineNumber, range.endColumn);
            }
            var newLineContent = model.getLineContent(range.endLineNumber);
            var firstNonWhitespace = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["firstNonWhitespaceIndex"](newLineContent);
            if (firstNonWhitespace >= 0) {
                range = range.setEndPosition(range.endLineNumber, Math.max(range.endColumn, firstNonWhitespace + 1));
            }
            else {
                range = range.setEndPosition(range.endLineNumber, model.getLineMaxColumn(range.endLineNumber));
            }
            if (keepPosition) {
                return new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["d" /* ReplaceCommandWithoutChangingPosition */](range, beforeText + config.normalizeIndentation(ir.afterEnter), true);
            }
            else {
                var offset = 0;
                if (oldEndColumn <= firstNonWhitespace + 1) {
                    if (!config.insertSpaces) {
                        oldEndViewColumn = Math.ceil(oldEndViewColumn / config.tabSize);
                    }
                    offset = Math.min(oldEndViewColumn + 1 - config.normalizeIndentation(ir.afterEnter).length - 1, 0);
                }
                return new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["c" /* ReplaceCommandWithOffsetCursorState */](range, beforeText + config.normalizeIndentation(ir.afterEnter), 0, offset, true);
            }
        }
        else {
            return TypeOperations._typeCommand(range, '\n' + config.normalizeIndentation(indentation), keepPosition);
        }
    };
    TypeOperations._isAutoIndentType = function (config, model, selections) {
        if (!config.autoIndent) {
            return false;
        }
        for (var i = 0, len = selections.length; i < len; i++) {
            if (!model.isCheapToTokenize(selections[i].getEndPosition().lineNumber)) {
                return false;
            }
        }
        return true;
    };
    TypeOperations._runAutoIndentType = function (config, model, range, ch) {
        var currentIndentation = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getIndentationAtPosition(model, range.startLineNumber, range.startColumn);
        var actualIndentation = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getIndentActionForType(model, range, ch, {
            shiftIndent: function (indentation) {
                return TypeOperations.shiftIndent(config, indentation);
            },
            unshiftIndent: function (indentation) {
                return TypeOperations.unshiftIndent(config, indentation);
            },
        });
        if (actualIndentation === null) {
            return null;
        }
        if (actualIndentation !== config.normalizeIndentation(currentIndentation)) {
            var firstNonWhitespace = model.getLineFirstNonWhitespaceColumn(range.startLineNumber);
            if (firstNonWhitespace === 0) {
                return TypeOperations._typeCommand(new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](range.startLineNumber, 0, range.endLineNumber, range.endColumn), config.normalizeIndentation(actualIndentation) + ch, false);
            }
            else {
                return TypeOperations._typeCommand(new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](range.startLineNumber, 0, range.endLineNumber, range.endColumn), config.normalizeIndentation(actualIndentation) +
                    model.getLineContent(range.startLineNumber).substring(firstNonWhitespace - 1, range.startColumn - 1) + ch, false);
            }
        }
        return null;
    };
    TypeOperations._isAutoClosingCloseCharType = function (config, model, selections, ch) {
        if (!config.autoClosingBrackets || !config.autoClosingPairsClose.hasOwnProperty(ch)) {
            return false;
        }
        var isEqualPair = (ch === config.autoClosingPairsClose[ch]);
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (!selection.isEmpty()) {
                return false;
            }
            var position = selection.getPosition();
            var lineText = model.getLineContent(position.lineNumber);
            var afterCharacter = lineText.charAt(position.column - 1);
            if (afterCharacter !== ch) {
                return false;
            }
            if (isEqualPair) {
                var lineTextBeforeCursor = lineText.substr(0, position.column - 1);
                var chCntBefore = this._countNeedlesInHaystack(lineTextBeforeCursor, ch);
                if (chCntBefore % 2 === 0) {
                    return false;
                }
            }
        }
        return true;
    };
    TypeOperations._countNeedlesInHaystack = function (haystack, needle) {
        var cnt = 0;
        var lastIndex = -1;
        while ((lastIndex = haystack.indexOf(needle, lastIndex + 1)) !== -1) {
            cnt++;
        }
        return cnt;
    };
    TypeOperations._runAutoClosingCloseCharType = function (prevEditOperationType, config, model, selections, ch) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var position = selection.getPosition();
            var typeSelection = new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column + 1);
            commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](typeSelection, ch);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands, {
            shouldPushStackElementBefore: (prevEditOperationType !== 1 /* Typing */),
            shouldPushStackElementAfter: false
        });
    };
    TypeOperations._isBeforeClosingBrace = function (config, ch, characterAfter) {
        var thisBraceIsSymmetric = (config.autoClosingPairsOpen[ch] === ch);
        var isBeforeCloseBrace = false;
        for (var otherCloseBrace in config.autoClosingPairsClose) {
            var otherBraceIsSymmetric = (config.autoClosingPairsOpen[otherCloseBrace] === otherCloseBrace);
            if (!thisBraceIsSymmetric && otherBraceIsSymmetric) {
                continue;
            }
            if (characterAfter === otherCloseBrace) {
                isBeforeCloseBrace = true;
                break;
            }
        }
        return isBeforeCloseBrace;
    };
    TypeOperations._isAutoClosingOpenCharType = function (config, model, selections, ch) {
        if (!config.autoClosingBrackets || !config.autoClosingPairsOpen.hasOwnProperty(ch)) {
            return false;
        }
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (!selection.isEmpty()) {
                return false;
            }
            var position = selection.getPosition();
            var lineText = model.getLineContent(position.lineNumber);
            // Do not auto-close ' or " after a word character
            if ((ch === '\'' || ch === '"') && position.column > 1) {
                var wordSeparators = Object(__WEBPACK_IMPORTED_MODULE_9__wordCharacterClassifier_js__["a" /* getMapForWordSeparators */])(config.wordSeparators);
                var characterBeforeCode = lineText.charCodeAt(position.column - 2);
                var characterBeforeType = wordSeparators.get(characterBeforeCode);
                if (characterBeforeType === 0 /* Regular */) {
                    return false;
                }
            }
            // Only consider auto closing the pair if a space follows or if another autoclosed pair follows
            var characterAfter = lineText.charAt(position.column - 1);
            if (characterAfter) {
                var isBeforeCloseBrace = TypeOperations._isBeforeClosingBrace(config, ch, characterAfter);
                if (!isBeforeCloseBrace && !/\s/.test(characterAfter)) {
                    return false;
                }
            }
            if (!model.isCheapToTokenize(position.lineNumber)) {
                // Do not force tokenization
                return false;
            }
            model.forceTokenization(position.lineNumber);
            var lineTokens = model.getLineTokens(position.lineNumber);
            var shouldAutoClosePair = false;
            try {
                shouldAutoClosePair = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].shouldAutoClosePair(ch, lineTokens, position.column);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            }
            if (!shouldAutoClosePair) {
                return false;
            }
        }
        return true;
    };
    TypeOperations._runAutoClosingOpenCharType = function (prevEditOperationType, config, model, selections, ch) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var closeCharacter = config.autoClosingPairsOpen[ch];
            commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["c" /* ReplaceCommandWithOffsetCursorState */](selection, ch + closeCharacter, 0, -closeCharacter.length);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: false
        });
    };
    TypeOperations._isSurroundSelectionType = function (config, model, selections, ch) {
        if (!config.autoClosingBrackets || !config.surroundingPairs.hasOwnProperty(ch)) {
            return false;
        }
        var isTypingAQuoteCharacter = (ch === '\'' || ch === '"');
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (selection.isEmpty()) {
                return false;
            }
            var selectionContainsOnlyWhitespace = true;
            for (var lineNumber = selection.startLineNumber; lineNumber <= selection.endLineNumber; lineNumber++) {
                var lineText = model.getLineContent(lineNumber);
                var startIndex = (lineNumber === selection.startLineNumber ? selection.startColumn - 1 : 0);
                var endIndex = (lineNumber === selection.endLineNumber ? selection.endColumn - 1 : lineText.length);
                var selectedText = lineText.substring(startIndex, endIndex);
                if (/[^ \t]/.test(selectedText)) {
                    // this selected text contains something other than whitespace
                    selectionContainsOnlyWhitespace = false;
                    break;
                }
            }
            if (selectionContainsOnlyWhitespace) {
                return false;
            }
            if (isTypingAQuoteCharacter && selection.startLineNumber === selection.endLineNumber && selection.startColumn + 1 === selection.endColumn) {
                var selectionText = model.getValueInRange(selection);
                if ((selectionText === '\'' || selectionText === '"')) {
                    // Typing a quote character on top of another quote character
                    // => disable surround selection type
                    return false;
                }
            }
        }
        return true;
    };
    TypeOperations._runSurroundSelectionType = function (prevEditOperationType, config, model, selections, ch) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var closeCharacter = config.surroundingPairs[ch];
            commands[i] = new __WEBPACK_IMPORTED_MODULE_8__commands_surroundSelectionCommand_js__["a" /* SurroundSelectionCommand */](selection, ch, closeCharacter);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](0 /* Other */, commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    };
    TypeOperations._isTypeInterceptorElectricChar = function (config, model, selections) {
        if (selections.length === 1 && model.isCheapToTokenize(selections[0].getEndPosition().lineNumber)) {
            return true;
        }
        return false;
    };
    TypeOperations._typeInterceptorElectricChar = function (prevEditOperationType, config, model, selection, ch) {
        if (!config.electricChars.hasOwnProperty(ch) || !selection.isEmpty()) {
            return null;
        }
        var position = selection.getPosition();
        model.forceTokenization(position.lineNumber);
        var lineTokens = model.getLineTokens(position.lineNumber);
        var electricAction;
        try {
            electricAction = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].onElectricCharacter(ch, lineTokens, position.column);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
        }
        if (!electricAction) {
            return null;
        }
        if (electricAction.appendText) {
            var command = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["c" /* ReplaceCommandWithOffsetCursorState */](selection, ch + electricAction.appendText, 0, -electricAction.appendText.length);
            return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, [command], {
                shouldPushStackElementBefore: false,
                shouldPushStackElementAfter: true
            });
        }
        if (electricAction.matchOpenBracket) {
            var endColumn = (lineTokens.getLineContent() + ch).lastIndexOf(electricAction.matchOpenBracket) + 1;
            var match = model.findMatchingBracketUp(electricAction.matchOpenBracket, {
                lineNumber: position.lineNumber,
                column: endColumn
            });
            if (match) {
                if (match.startLineNumber === position.lineNumber) {
                    // matched something on the same line => no change in indentation
                    return null;
                }
                var matchLine = model.getLineContent(match.startLineNumber);
                var matchLineIndentation = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["getLeadingWhitespace"](matchLine);
                var newIndentation = config.normalizeIndentation(matchLineIndentation);
                var lineText = model.getLineContent(position.lineNumber);
                var lineFirstNonBlankColumn = model.getLineFirstNonWhitespaceColumn(position.lineNumber) || position.column;
                var prefix = lineText.substring(lineFirstNonBlankColumn - 1, position.column - 1);
                var typeText = newIndentation + prefix + ch;
                var typeSelection = new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](position.lineNumber, 1, position.lineNumber, position.column);
                var command = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](typeSelection, typeText);
                return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, [command], {
                    shouldPushStackElementBefore: false,
                    shouldPushStackElementAfter: true
                });
            }
        }
        return null;
    };
    TypeOperations.compositionEndWithInterceptors = function (prevEditOperationType, config, model, selections) {
        if (!config.autoClosingBrackets) {
            return null;
        }
        var commands = [];
        for (var i = 0; i < selections.length; i++) {
            if (!selections[i].isEmpty()) {
                continue;
            }
            var position = selections[i].getPosition();
            var lineText = model.getLineContent(position.lineNumber);
            var ch = lineText.charAt(position.column - 2);
            if (config.autoClosingPairsClose.hasOwnProperty(ch)) { // first of all, it's a closing tag
                if (ch === config.autoClosingPairsClose[ch] /** isEqualPair */) {
                    var lineTextBeforeCursor = lineText.substr(0, position.column - 2);
                    var chCntBefore = this._countNeedlesInHaystack(lineTextBeforeCursor, ch);
                    if (chCntBefore % 2 === 1) {
                        continue; // it pairs with the opening tag.
                    }
                }
            }
            // As we are not typing in a new character, so we don't need to run `_runAutoClosingCloseCharType`
            // Next step, let's try to check if it's an open char.
            if (config.autoClosingPairsOpen.hasOwnProperty(ch)) {
                if ((ch === '\'' || ch === '"') && position.column > 2) {
                    var wordSeparators = Object(__WEBPACK_IMPORTED_MODULE_9__wordCharacterClassifier_js__["a" /* getMapForWordSeparators */])(config.wordSeparators);
                    var characterBeforeCode = lineText.charCodeAt(position.column - 3);
                    var characterBeforeType = wordSeparators.get(characterBeforeCode);
                    if (characterBeforeType === 0 /* Regular */) {
                        continue;
                    }
                }
                var characterAfter = lineText.charAt(position.column - 1);
                if (characterAfter) {
                    var isBeforeCloseBrace = TypeOperations._isBeforeClosingBrace(config, ch, characterAfter);
                    if (!isBeforeCloseBrace && !/\s/.test(characterAfter)) {
                        continue;
                    }
                }
                if (!model.isCheapToTokenize(position.lineNumber)) {
                    // Do not force tokenization
                    continue;
                }
                model.forceTokenization(position.lineNumber);
                var lineTokens = model.getLineTokens(position.lineNumber);
                var shouldAutoClosePair = false;
                try {
                    shouldAutoClosePair = __WEBPACK_IMPORTED_MODULE_6__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].shouldAutoClosePair(ch, lineTokens, position.column - 1);
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
                }
                if (shouldAutoClosePair) {
                    var closeCharacter = config.autoClosingPairsOpen[ch];
                    commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["c" /* ReplaceCommandWithOffsetCursorState */](selections[i], closeCharacter, 0, -closeCharacter.length);
                }
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: false
        });
    };
    TypeOperations.typeWithInterceptors = function (prevEditOperationType, config, model, selections, ch) {
        if (ch === '\n') {
            var commands_1 = [];
            for (var i = 0, len = selections.length; i < len; i++) {
                commands_1[i] = TypeOperations._enter(config, model, false, selections[i]);
            }
            return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands_1, {
                shouldPushStackElementBefore: true,
                shouldPushStackElementAfter: false,
            });
        }
        if (this._isAutoIndentType(config, model, selections)) {
            var commands_2 = [];
            var autoIndentFails = false;
            for (var i = 0, len = selections.length; i < len; i++) {
                commands_2[i] = this._runAutoIndentType(config, model, selections[i], ch);
                if (!commands_2[i]) {
                    autoIndentFails = true;
                    break;
                }
            }
            if (!autoIndentFails) {
                return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands_2, {
                    shouldPushStackElementBefore: true,
                    shouldPushStackElementAfter: false,
                });
            }
        }
        if (this._isAutoClosingCloseCharType(config, model, selections, ch)) {
            return this._runAutoClosingCloseCharType(prevEditOperationType, config, model, selections, ch);
        }
        if (this._isAutoClosingOpenCharType(config, model, selections, ch)) {
            return this._runAutoClosingOpenCharType(prevEditOperationType, config, model, selections, ch);
        }
        if (this._isSurroundSelectionType(config, model, selections, ch)) {
            return this._runSurroundSelectionType(prevEditOperationType, config, model, selections, ch);
        }
        // Electric characters make sense only when dealing with a single cursor,
        // as multiple cursors typing brackets for example would interfer with bracket matching
        if (this._isTypeInterceptorElectricChar(config, model, selections)) {
            var r = this._typeInterceptorElectricChar(prevEditOperationType, config, model, selections[0], ch);
            if (r) {
                return r;
            }
        }
        // A simple character type
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](selections[i], ch);
        }
        var shouldPushStackElementBefore = (prevEditOperationType !== 1 /* Typing */);
        if (ch === ' ') {
            shouldPushStackElementBefore = true;
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands, {
            shouldPushStackElementBefore: shouldPushStackElementBefore,
            shouldPushStackElementAfter: false
        });
    };
    TypeOperations.typeWithoutInterceptors = function (prevEditOperationType, config, model, selections, str) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["a" /* ReplaceCommand */](selections[i], str);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["e" /* EditOperationResult */](1 /* Typing */, commands, {
            shouldPushStackElementBefore: (prevEditOperationType !== 1 /* Typing */),
            shouldPushStackElementAfter: false
        });
    };
    TypeOperations.lineInsertBefore = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var lineNumber = selections[i].positionLineNumber;
            if (lineNumber === 1) {
                commands[i] = new __WEBPACK_IMPORTED_MODULE_1__commands_replaceCommand_js__["d" /* ReplaceCommandWithoutChangingPosition */](new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](1, 1, 1, 1), '\n');
            }
            else {
                lineNumber--;
                var column = model.getLineMaxColumn(lineNumber);
                commands[i] = this._enter(config, model, false, new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column));
            }
        }
        return commands;
    };
    TypeOperations.lineInsertAfter = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var lineNumber = selections[i].positionLineNumber;
            var column = model.getLineMaxColumn(lineNumber);
            commands[i] = this._enter(config, model, false, new __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column));
        }
        return commands;
    };
    TypeOperations.lineBreakInsert = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            commands[i] = this._enter(config, model, true, selections[i]);
        }
        return commands;
    };
    return TypeOperations;
}());



/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorUndoController", function() { return CursorUndoController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorUndo", function() { return CursorUndo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__ = __webpack_require__(17);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CursorState = /** @class */ (function () {
    function CursorState(selections) {
        this.selections = selections;
    }
    CursorState.prototype.equals = function (other) {
        var thisLen = this.selections.length;
        var otherLen = other.selections.length;
        if (thisLen !== otherLen) {
            return false;
        }
        for (var i = 0; i < thisLen; i++) {
            if (!this.selections[i].equalsSelection(other.selections[i])) {
                return false;
            }
        }
        return true;
    };
    return CursorState;
}());
var CursorUndoController = /** @class */ (function (_super) {
    __extends(CursorUndoController, _super);
    function CursorUndoController(editor) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        _this._isCursorUndo = false;
        _this._undoStack = [];
        _this._prevState = _this._readState();
        _this._register(editor.onDidChangeModel(function (e) {
            _this._undoStack = [];
            _this._prevState = null;
        }));
        _this._register(editor.onDidChangeModelContent(function (e) {
            _this._undoStack = [];
            _this._prevState = null;
        }));
        _this._register(editor.onDidChangeCursorSelection(function (e) {
            if (!_this._isCursorUndo && _this._prevState) {
                _this._undoStack.push(_this._prevState);
                if (_this._undoStack.length > 50) {
                    // keep the cursor undo stack bounded
                    _this._undoStack.shift();
                }
            }
            _this._prevState = _this._readState();
        }));
        return _this;
    }
    CursorUndoController.get = function (editor) {
        return editor.getContribution(CursorUndoController.ID);
    };
    CursorUndoController.prototype._readState = function () {
        if (!this._editor.getModel()) {
            // no model => no state
            return null;
        }
        return new CursorState(this._editor.getSelections());
    };
    CursorUndoController.prototype.getId = function () {
        return CursorUndoController.ID;
    };
    CursorUndoController.prototype.cursorUndo = function () {
        var currState = new CursorState(this._editor.getSelections());
        while (this._undoStack.length > 0) {
            var prevState = this._undoStack.pop();
            if (!prevState.equals(currState)) {
                this._isCursorUndo = true;
                this._editor.setSelections(prevState.selections);
                this._editor.revealRangeInCenterIfOutsideViewport(prevState.selections[0], 0 /* Smooth */);
                this._isCursorUndo = false;
                return;
            }
        }
    };
    CursorUndoController.ID = 'editor.contrib.cursorUndoController';
    return CursorUndoController;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));

var CursorUndo = /** @class */ (function (_super) {
    __extends(CursorUndo, _super);
    function CursorUndo() {
        return _super.call(this, {
            id: 'cursorUndo',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('cursor.undo', "Soft Undo"),
            alias: 'Soft Undo',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 51 /* KEY_U */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    CursorUndo.prototype.run = function (accessor, editor, args) {
        CursorUndoController.get(editor).cursorUndo();
    };
    return CursorUndo;
}(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["h" /* registerEditorContribution */])(CursorUndoController);
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["f" /* registerEditorAction */])(CursorUndo);


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragAndDropController", function() { return DragAndDropController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dnd_css__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dnd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dnd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dragAndDropCommand_js__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_model_textModel_js__ = __webpack_require__(27);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/











function hasTriggerModifier(e) {
    if (__WEBPACK_IMPORTED_MODULE_2__base_common_platform_js__["d" /* isMacintosh */]) {
        return e.altKey;
    }
    else {
        return e.ctrlKey;
    }
}
var DragAndDropController = /** @class */ (function () {
    function DragAndDropController(editor) {
        var _this = this;
        this._editor = editor;
        this._toUnhook = [];
        this._toUnhook.push(this._editor.onMouseDown(function (e) { return _this._onEditorMouseDown(e); }));
        this._toUnhook.push(this._editor.onMouseUp(function (e) { return _this._onEditorMouseUp(e); }));
        this._toUnhook.push(this._editor.onMouseDrag(function (e) { return _this._onEditorMouseDrag(e); }));
        this._toUnhook.push(this._editor.onMouseDrop(function (e) { return _this._onEditorMouseDrop(e); }));
        this._toUnhook.push(this._editor.onKeyDown(function (e) { return _this.onEditorKeyDown(e); }));
        this._toUnhook.push(this._editor.onKeyUp(function (e) { return _this.onEditorKeyUp(e); }));
        this._dndDecorationIds = [];
        this._mouseDown = false;
        this._modiferPressed = false;
        this._dragSelection = null;
    }
    DragAndDropController.prototype.onEditorKeyDown = function (e) {
        if (!this._editor.getConfiguration().dragAndDrop) {
            return;
        }
        if (hasTriggerModifier(e)) {
            this._modiferPressed = true;
        }
        if (this._mouseDown && hasTriggerModifier(e)) {
            this._editor.updateOptions({
                mouseStyle: 'copy'
            });
        }
    };
    DragAndDropController.prototype.onEditorKeyUp = function (e) {
        if (!this._editor.getConfiguration().dragAndDrop) {
            return;
        }
        if (hasTriggerModifier(e)) {
            this._modiferPressed = false;
        }
        if (this._mouseDown && e.keyCode === DragAndDropController.TRIGGER_KEY_VALUE) {
            this._editor.updateOptions({
                mouseStyle: 'default'
            });
        }
    };
    DragAndDropController.prototype._onEditorMouseDown = function (mouseEvent) {
        this._mouseDown = true;
    };
    DragAndDropController.prototype._onEditorMouseUp = function (mouseEvent) {
        this._mouseDown = false;
        // Whenever users release the mouse, the drag and drop operation should finish and the cursor should revert to text.
        this._editor.updateOptions({
            mouseStyle: 'text'
        });
    };
    DragAndDropController.prototype._onEditorMouseDrag = function (mouseEvent) {
        var target = mouseEvent.target;
        if (this._dragSelection === null) {
            var possibleSelections = this._editor.getSelections().filter(function (selection) { return selection.containsPosition(target.position); });
            if (possibleSelections.length === 1) {
                this._dragSelection = possibleSelections[0];
            }
            else {
                return;
            }
        }
        if (hasTriggerModifier(mouseEvent.event)) {
            this._editor.updateOptions({
                mouseStyle: 'copy'
            });
        }
        else {
            this._editor.updateOptions({
                mouseStyle: 'default'
            });
        }
        if (this._dragSelection.containsPosition(target.position)) {
            this._removeDecoration();
        }
        else {
            this.showAt(target.position);
        }
    };
    DragAndDropController.prototype._onEditorMouseDrop = function (mouseEvent) {
        if (mouseEvent.target && (this._hitContent(mouseEvent.target) || this._hitMargin(mouseEvent.target)) && mouseEvent.target.position) {
            var newCursorPosition_1 = new __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__["a" /* Position */](mouseEvent.target.position.lineNumber, mouseEvent.target.position.column);
            if (this._dragSelection === null) {
                if (mouseEvent.event.shiftKey) {
                    var primarySelection = this._editor.getSelection();
                    var startLineNumber = primarySelection.startLineNumber, startColumn = primarySelection.startColumn;
                    this._editor.setSelections([new __WEBPACK_IMPORTED_MODULE_7__common_core_selection_js__["a" /* Selection */](startLineNumber, startColumn, newCursorPosition_1.lineNumber, newCursorPosition_1.column)]);
                }
                else {
                    var newSelections = this._editor.getSelections().map(function (selection) {
                        if (selection.containsPosition(newCursorPosition_1)) {
                            return new __WEBPACK_IMPORTED_MODULE_7__common_core_selection_js__["a" /* Selection */](newCursorPosition_1.lineNumber, newCursorPosition_1.column, newCursorPosition_1.lineNumber, newCursorPosition_1.column);
                        }
                        else {
                            return selection;
                        }
                    });
                    this._editor.setSelections(newSelections);
                }
            }
            else if (!this._dragSelection.containsPosition(newCursorPosition_1) ||
                ((hasTriggerModifier(mouseEvent.event) ||
                    this._modiferPressed) && (this._dragSelection.getEndPosition().equals(newCursorPosition_1) || this._dragSelection.getStartPosition().equals(newCursorPosition_1)) // we allow users to paste content beside the selection
                )) {
                this._editor.pushUndoStop();
                this._editor.executeCommand(DragAndDropController.ID, new __WEBPACK_IMPORTED_MODULE_8__dragAndDropCommand_js__["a" /* DragAndDropCommand */](this._dragSelection, newCursorPosition_1, hasTriggerModifier(mouseEvent.event) || this._modiferPressed));
                this._editor.pushUndoStop();
            }
        }
        this._editor.updateOptions({
            mouseStyle: 'text'
        });
        this._removeDecoration();
        this._dragSelection = null;
        this._mouseDown = false;
    };
    DragAndDropController.prototype.showAt = function (position) {
        var newDecorations = [{
                range: new __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column),
                options: DragAndDropController._DECORATION_OPTIONS
            }];
        this._dndDecorationIds = this._editor.deltaDecorations(this._dndDecorationIds, newDecorations);
        this._editor.revealPosition(position, 1 /* Immediate */);
    };
    DragAndDropController.prototype._removeDecoration = function () {
        this._dndDecorationIds = this._editor.deltaDecorations(this._dndDecorationIds, []);
    };
    DragAndDropController.prototype._hitContent = function (target) {
        return target.type === __WEBPACK_IMPORTED_MODULE_3__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT ||
            target.type === __WEBPACK_IMPORTED_MODULE_3__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY;
    };
    DragAndDropController.prototype._hitMargin = function (target) {
        return target.type === __WEBPACK_IMPORTED_MODULE_3__browser_editorBrowser_js__["b" /* MouseTargetType */].GUTTER_GLYPH_MARGIN ||
            target.type === __WEBPACK_IMPORTED_MODULE_3__browser_editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_NUMBERS ||
            target.type === __WEBPACK_IMPORTED_MODULE_3__browser_editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_DECORATIONS;
    };
    DragAndDropController.prototype.getId = function () {
        return DragAndDropController.ID;
    };
    DragAndDropController.prototype.dispose = function () {
        this._removeDecoration();
        this._dragSelection = null;
        this._mouseDown = false;
        this._modiferPressed = false;
        this._toUnhook = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._toUnhook);
    };
    DragAndDropController.ID = 'editor.contrib.dragAndDrop';
    DragAndDropController.TRIGGER_KEY_VALUE = __WEBPACK_IMPORTED_MODULE_2__base_common_platform_js__["d" /* isMacintosh */] ? 6 /* Alt */ : 5 /* Ctrl */;
    DragAndDropController._DECORATION_OPTIONS = __WEBPACK_IMPORTED_MODULE_9__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'dnd-target'
    });
    return DragAndDropController;
}());

Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["h" /* registerEditorContribution */])(DragAndDropController);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTEXT_FIND_WIDGET_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTEXT_FIND_INPUT_FOCUSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTEXT_REPLACE_INPUT_FOCUSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ToggleCaseSensitiveKeybinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ToggleWholeWordKeybinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ToggleRegexKeybinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ToggleSearchScopeKeybinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MATCHES_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FindModelBoundToEditorModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__replacePattern_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_commands_replaceCommand_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findDecorations_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__replaceAllCommand_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_model_textModelSearch_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_controller_cursorEvents_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/














var CONTEXT_FIND_WIDGET_VISIBLE = new __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('findWidgetVisible', false);
// Keep ContextKey use of 'Focussed' to not break when clauses
var CONTEXT_FIND_INPUT_FOCUSED = new __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('findInputFocussed', false);
var CONTEXT_REPLACE_INPUT_FOCUSED = new __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('replaceInputFocussed', false);
var ToggleCaseSensitiveKeybinding = {
    primary: 512 /* Alt */ | 33 /* KEY_C */,
    mac: { primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 33 /* KEY_C */ }
};
var ToggleWholeWordKeybinding = {
    primary: 512 /* Alt */ | 53 /* KEY_W */,
    mac: { primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 53 /* KEY_W */ }
};
var ToggleRegexKeybinding = {
    primary: 512 /* Alt */ | 48 /* KEY_R */,
    mac: { primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 48 /* KEY_R */ }
};
var ToggleSearchScopeKeybinding = {
    primary: 512 /* Alt */ | 42 /* KEY_L */,
    mac: { primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 42 /* KEY_L */ }
};
var FIND_IDS = {
    StartFindAction: 'actions.find',
    StartFindWithSelection: 'actions.findWithSelection',
    NextMatchFindAction: 'editor.action.nextMatchFindAction',
    PreviousMatchFindAction: 'editor.action.previousMatchFindAction',
    NextSelectionMatchFindAction: 'editor.action.nextSelectionMatchFindAction',
    PreviousSelectionMatchFindAction: 'editor.action.previousSelectionMatchFindAction',
    StartFindReplaceAction: 'editor.action.startFindReplaceAction',
    CloseFindWidgetCommand: 'closeFindWidget',
    ToggleCaseSensitiveCommand: 'toggleFindCaseSensitive',
    ToggleWholeWordCommand: 'toggleFindWholeWord',
    ToggleRegexCommand: 'toggleFindRegex',
    ToggleSearchScopeCommand: 'toggleFindInSelection',
    ReplaceOneAction: 'editor.action.replaceOne',
    ReplaceAllAction: 'editor.action.replaceAll',
    SelectAllMatchesAction: 'editor.action.selectAllMatches'
};
var MATCHES_LIMIT = 19999;
var RESEARCH_DELAY = 240;
var FindModelBoundToEditorModel = /** @class */ (function () {
    function FindModelBoundToEditorModel(editor, state) {
        var _this = this;
        this._editor = editor;
        this._state = state;
        this._toDispose = [];
        this._isDisposed = false;
        this._startSearchingTimer = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["f" /* TimeoutTimer */]();
        this._decorations = new __WEBPACK_IMPORTED_MODULE_6__findDecorations_js__["a" /* FindDecorations */](editor);
        this._toDispose.push(this._decorations);
        this._updateDecorationsScheduler = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this.research(false); }, 100);
        this._toDispose.push(this._updateDecorationsScheduler);
        this._toDispose.push(this._editor.onDidChangeCursorPosition(function (e) {
            if (e.reason === __WEBPACK_IMPORTED_MODULE_10__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit
                || e.reason === __WEBPACK_IMPORTED_MODULE_10__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Undo
                || e.reason === __WEBPACK_IMPORTED_MODULE_10__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Redo) {
                _this._decorations.setStartPosition(_this._editor.getPosition());
            }
        }));
        this._ignoreModelContentChanged = false;
        this._toDispose.push(this._editor.onDidChangeModelContent(function (e) {
            if (_this._ignoreModelContentChanged) {
                return;
            }
            if (e.isFlush) {
                // a model.setValue() was called
                _this._decorations.reset();
            }
            _this._decorations.setStartPosition(_this._editor.getPosition());
            _this._updateDecorationsScheduler.schedule();
        }));
        this._toDispose.push(this._state.onFindReplaceStateChange(function (e) { return _this._onStateChanged(e); }));
        this.research(false, this._state.searchScope);
    }
    FindModelBoundToEditorModel.prototype.dispose = function () {
        this._isDisposed = true;
        Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._startSearchingTimer);
        this._toDispose = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._toDispose);
    };
    FindModelBoundToEditorModel.prototype._onStateChanged = function (e) {
        var _this = this;
        if (this._isDisposed) {
            // The find model is disposed during a find state changed event
            return;
        }
        if (!this._editor.getModel()) {
            // The find model will be disposed momentarily
            return;
        }
        if (e.searchString || e.isReplaceRevealed || e.isRegex || e.wholeWord || e.matchCase || e.searchScope) {
            var model = this._editor.getModel();
            if (model.isTooLargeForSyncing()) {
                this._startSearchingTimer.cancel();
                this._startSearchingTimer.setIfNotSet(function () {
                    if (e.searchScope) {
                        _this.research(e.moveCursor, _this._state.searchScope);
                    }
                    else {
                        _this.research(e.moveCursor);
                    }
                }, RESEARCH_DELAY);
            }
            else {
                if (e.searchScope) {
                    this.research(e.moveCursor, this._state.searchScope);
                }
                else {
                    this.research(e.moveCursor);
                }
            }
        }
    };
    FindModelBoundToEditorModel._getSearchRange = function (model, findScope) {
        var searchRange = model.getFullModelRange();
        // If we have set now or before a find scope, use it for computing the search range
        if (findScope) {
            searchRange = searchRange.intersectRanges(findScope);
        }
        return searchRange;
    };
    FindModelBoundToEditorModel.prototype.research = function (moveCursor, newFindScope) {
        var findScope = null;
        if (typeof newFindScope !== 'undefined') {
            findScope = newFindScope;
        }
        else {
            findScope = this._decorations.getFindScope();
        }
        if (findScope !== null) {
            if (findScope.startLineNumber !== findScope.endLineNumber) {
                // multiline find scope => expand to line starts / ends
                findScope = new __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */](findScope.startLineNumber, 1, findScope.endLineNumber, this._editor.getModel().getLineMaxColumn(findScope.endLineNumber));
            }
        }
        var findMatches = this._findMatches(findScope, false, MATCHES_LIMIT);
        this._decorations.set(findMatches, findScope);
        this._state.changeMatchInfo(this._decorations.getCurrentMatchesPosition(this._editor.getSelection()), this._decorations.getCount(), undefined);
        if (moveCursor) {
            this._moveToNextMatch(this._decorations.getStartPosition());
        }
    };
    FindModelBoundToEditorModel.prototype._hasMatches = function () {
        return (this._state.matchesCount > 0);
    };
    FindModelBoundToEditorModel.prototype._cannotFind = function () {
        if (!this._hasMatches()) {
            var findScope = this._decorations.getFindScope();
            if (findScope) {
                // Reveal the selection so user is reminded that 'selection find' is on.
                this._editor.revealRangeInCenterIfOutsideViewport(findScope, 0 /* Smooth */);
            }
            return true;
        }
        return false;
    };
    FindModelBoundToEditorModel.prototype._setCurrentFindMatch = function (match) {
        var matchesPosition = this._decorations.setCurrentFindMatch(match);
        this._state.changeMatchInfo(matchesPosition, this._decorations.getCount(), match);
        this._editor.setSelection(match);
        this._editor.revealRangeInCenterIfOutsideViewport(match, 0 /* Smooth */);
    };
    FindModelBoundToEditorModel.prototype._prevSearchPosition = function (before) {
        var isUsingLineStops = this._state.isRegex && (this._state.searchString.indexOf('^') >= 0
            || this._state.searchString.indexOf('$') >= 0);
        var lineNumber = before.lineNumber, column = before.column;
        var model = this._editor.getModel();
        if (isUsingLineStops || column === 1) {
            if (lineNumber === 1) {
                lineNumber = model.getLineCount();
            }
            else {
                lineNumber--;
            }
            column = model.getLineMaxColumn(lineNumber);
        }
        else {
            column--;
        }
        return new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](lineNumber, column);
    };
    FindModelBoundToEditorModel.prototype._moveToPrevMatch = function (before, isRecursed) {
        if (isRecursed === void 0) { isRecursed = false; }
        if (this._decorations.getCount() < MATCHES_LIMIT) {
            var prevMatchRange = this._decorations.matchBeforePosition(before);
            if (prevMatchRange && prevMatchRange.isEmpty() && prevMatchRange.getStartPosition().equals(before)) {
                before = this._prevSearchPosition(before);
                prevMatchRange = this._decorations.matchBeforePosition(before);
            }
            if (prevMatchRange) {
                this._setCurrentFindMatch(prevMatchRange);
            }
            return;
        }
        if (this._cannotFind()) {
            return;
        }
        var findScope = this._decorations.getFindScope();
        var searchRange = FindModelBoundToEditorModel._getSearchRange(this._editor.getModel(), findScope);
        // ...(----)...|...
        if (searchRange.getEndPosition().isBefore(before)) {
            before = searchRange.getEndPosition();
        }
        // ...|...(----)...
        if (before.isBefore(searchRange.getStartPosition())) {
            before = searchRange.getEndPosition();
        }
        var lineNumber = before.lineNumber, column = before.column;
        var model = this._editor.getModel();
        var position = new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](lineNumber, column);
        var prevMatch = model.findPreviousMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getConfiguration().wordSeparators : null, false);
        if (prevMatch && prevMatch.range.isEmpty() && prevMatch.range.getStartPosition().equals(position)) {
            // Looks like we're stuck at this position, unacceptable!
            position = this._prevSearchPosition(position);
            prevMatch = model.findPreviousMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getConfiguration().wordSeparators : null, false);
        }
        if (!prevMatch) {
            // there is precisely one match and selection is on top of it
            return null;
        }
        if (!isRecursed && !searchRange.containsRange(prevMatch.range)) {
            return this._moveToPrevMatch(prevMatch.range.getStartPosition(), true);
        }
        this._setCurrentFindMatch(prevMatch.range);
    };
    FindModelBoundToEditorModel.prototype.moveToPrevMatch = function () {
        this._moveToPrevMatch(this._editor.getSelection().getStartPosition());
    };
    FindModelBoundToEditorModel.prototype._nextSearchPosition = function (after) {
        var isUsingLineStops = this._state.isRegex && (this._state.searchString.indexOf('^') >= 0
            || this._state.searchString.indexOf('$') >= 0);
        var lineNumber = after.lineNumber, column = after.column;
        var model = this._editor.getModel();
        if (isUsingLineStops || column === model.getLineMaxColumn(lineNumber)) {
            if (lineNumber === model.getLineCount()) {
                lineNumber = 1;
            }
            else {
                lineNumber++;
            }
            column = 1;
        }
        else {
            column++;
        }
        return new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](lineNumber, column);
    };
    FindModelBoundToEditorModel.prototype._moveToNextMatch = function (after) {
        if (this._decorations.getCount() < MATCHES_LIMIT) {
            var nextMatchRange = this._decorations.matchAfterPosition(after);
            if (nextMatchRange && nextMatchRange.isEmpty() && nextMatchRange.getStartPosition().equals(after)) {
                // Looks like we're stuck at this position, unacceptable!
                after = this._nextSearchPosition(after);
                nextMatchRange = this._decorations.matchAfterPosition(after);
            }
            if (nextMatchRange) {
                this._setCurrentFindMatch(nextMatchRange);
            }
            return;
        }
        var nextMatch = this._getNextMatch(after, false, true);
        if (nextMatch) {
            this._setCurrentFindMatch(nextMatch.range);
        }
    };
    FindModelBoundToEditorModel.prototype._getNextMatch = function (after, captureMatches, forceMove, isRecursed) {
        if (isRecursed === void 0) { isRecursed = false; }
        if (this._cannotFind()) {
            return null;
        }
        var findScope = this._decorations.getFindScope();
        var searchRange = FindModelBoundToEditorModel._getSearchRange(this._editor.getModel(), findScope);
        // ...(----)...|...
        if (searchRange.getEndPosition().isBefore(after)) {
            after = searchRange.getStartPosition();
        }
        // ...|...(----)...
        if (after.isBefore(searchRange.getStartPosition())) {
            after = searchRange.getStartPosition();
        }
        var lineNumber = after.lineNumber, column = after.column;
        var model = this._editor.getModel();
        var position = new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](lineNumber, column);
        var nextMatch = model.findNextMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getConfiguration().wordSeparators : null, captureMatches);
        if (forceMove && nextMatch && nextMatch.range.isEmpty() && nextMatch.range.getStartPosition().equals(position)) {
            // Looks like we're stuck at this position, unacceptable!
            position = this._nextSearchPosition(position);
            nextMatch = model.findNextMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getConfiguration().wordSeparators : null, captureMatches);
        }
        if (!nextMatch) {
            // there is precisely one match and selection is on top of it
            return null;
        }
        if (!isRecursed && !searchRange.containsRange(nextMatch.range)) {
            return this._getNextMatch(nextMatch.range.getEndPosition(), captureMatches, forceMove, true);
        }
        return nextMatch;
    };
    FindModelBoundToEditorModel.prototype.moveToNextMatch = function () {
        this._moveToNextMatch(this._editor.getSelection().getEndPosition());
    };
    FindModelBoundToEditorModel.prototype._getReplacePattern = function () {
        if (this._state.isRegex) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__replacePattern_js__["b" /* parseReplaceString */])(this._state.replaceString);
        }
        return __WEBPACK_IMPORTED_MODULE_2__replacePattern_js__["a" /* ReplacePattern */].fromStaticValue(this._state.replaceString);
    };
    FindModelBoundToEditorModel.prototype.replace = function () {
        if (!this._hasMatches()) {
            return;
        }
        var replacePattern = this._getReplacePattern();
        var selection = this._editor.getSelection();
        var nextMatch = this._getNextMatch(selection.getStartPosition(), replacePattern.hasReplacementPatterns, false);
        if (nextMatch) {
            if (selection.equalsRange(nextMatch.range)) {
                // selection sits on a find match => replace it!
                var replaceString = replacePattern.buildReplaceString(nextMatch.matches);
                var command = new __WEBPACK_IMPORTED_MODULE_3__common_commands_replaceCommand_js__["a" /* ReplaceCommand */](selection, replaceString);
                this._executeEditorCommand('replace', command);
                this._decorations.setStartPosition(new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](selection.startLineNumber, selection.startColumn + replaceString.length));
                this.research(true);
            }
            else {
                this._decorations.setStartPosition(this._editor.getPosition());
                this._setCurrentFindMatch(nextMatch.range);
            }
        }
    };
    FindModelBoundToEditorModel.prototype._findMatches = function (findScope, captureMatches, limitResultCount) {
        var searchRange = FindModelBoundToEditorModel._getSearchRange(this._editor.getModel(), findScope);
        return this._editor.getModel().findMatches(this._state.searchString, searchRange, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getConfiguration().wordSeparators : null, captureMatches, limitResultCount);
    };
    FindModelBoundToEditorModel.prototype.replaceAll = function () {
        if (!this._hasMatches()) {
            return;
        }
        var findScope = this._decorations.getFindScope();
        if (findScope === null && this._state.matchesCount >= MATCHES_LIMIT) {
            // Doing a replace on the entire file that is over ${MATCHES_LIMIT} matches
            this._largeReplaceAll();
        }
        else {
            this._regularReplaceAll(findScope);
        }
        this.research(false);
    };
    FindModelBoundToEditorModel.prototype._largeReplaceAll = function () {
        var searchParams = new __WEBPACK_IMPORTED_MODULE_9__common_model_textModelSearch_js__["a" /* SearchParams */](this._state.searchString, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getConfiguration().wordSeparators : null);
        var searchData = searchParams.parseSearchRequest();
        if (!searchData) {
            return;
        }
        var searchRegex = searchData.regex;
        if (!searchRegex.multiline) {
            var mod = 'm';
            if (searchRegex.ignoreCase) {
                mod += 'i';
            }
            if (searchRegex.global) {
                mod += 'g';
            }
            searchRegex = new RegExp(searchRegex.source, mod);
        }
        var model = this._editor.getModel();
        var modelText = model.getValue(__WEBPACK_IMPORTED_MODULE_12__common_model_js__["c" /* EndOfLinePreference */].LF);
        var fullModelRange = model.getFullModelRange();
        var replacePattern = this._getReplacePattern();
        var resultText;
        if (replacePattern.hasReplacementPatterns) {
            resultText = modelText.replace(searchRegex, function () {
                return replacePattern.buildReplaceString(arguments);
            });
        }
        else {
            resultText = modelText.replace(searchRegex, replacePattern.buildReplaceString(null));
        }
        var command = new __WEBPACK_IMPORTED_MODULE_3__common_commands_replaceCommand_js__["b" /* ReplaceCommandThatPreservesSelection */](fullModelRange, resultText, this._editor.getSelection());
        this._executeEditorCommand('replaceAll', command);
    };
    FindModelBoundToEditorModel.prototype._regularReplaceAll = function (findScope) {
        var replacePattern = this._getReplacePattern();
        // Get all the ranges (even more than the highlighted ones)
        var matches = this._findMatches(findScope, replacePattern.hasReplacementPatterns, 1073741824 /* MAX_SAFE_SMALL_INTEGER */);
        var replaceStrings = [];
        for (var i = 0, len = matches.length; i < len; i++) {
            replaceStrings[i] = replacePattern.buildReplaceString(matches[i].matches);
        }
        var command = new __WEBPACK_IMPORTED_MODULE_7__replaceAllCommand_js__["a" /* ReplaceAllCommand */](this._editor.getSelection(), matches.map(function (m) { return m.range; }), replaceStrings);
        this._executeEditorCommand('replaceAll', command);
    };
    FindModelBoundToEditorModel.prototype.selectAllMatches = function () {
        if (!this._hasMatches()) {
            return;
        }
        var findScope = this._decorations.getFindScope();
        // Get all the ranges (even more than the highlighted ones)
        var matches = this._findMatches(findScope, false, 1073741824 /* MAX_SAFE_SMALL_INTEGER */);
        var selections = matches.map(function (m) { return new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](m.range.startLineNumber, m.range.startColumn, m.range.endLineNumber, m.range.endColumn); });
        // If one of the ranges is the editor selection, then maintain it as primary
        var editorSelection = this._editor.getSelection();
        for (var i = 0, len = selections.length; i < len; i++) {
            var sel = selections[i];
            if (sel.equalsRange(editorSelection)) {
                selections = [editorSelection].concat(selections.slice(0, i)).concat(selections.slice(i + 1));
                break;
            }
        }
        this._editor.setSelections(selections);
    };
    FindModelBoundToEditorModel.prototype._executeEditorCommand = function (source, command) {
        try {
            this._ignoreModelContentChanged = true;
            this._editor.pushUndoStop();
            this._editor.executeCommand(source, command);
            this._editor.pushUndoStop();
        }
        finally {
            this._ignoreModelContentChanged = false;
        }
    };
    return FindModelBoundToEditorModel;
}());



/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MessageType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InputBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HistoryInputBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputBox_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inputBox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__htmlContentRenderer_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actionbar_actionbar_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contextview_contextview_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_history_js__ = __webpack_require__(363);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var $ = __WEBPACK_IMPORTED_MODULE_3__dom_js__["a" /* $ */];
var MessageType;
(function (MessageType) {
    MessageType[MessageType["INFO"] = 1] = "INFO";
    MessageType[MessageType["WARNING"] = 2] = "WARNING";
    MessageType[MessageType["ERROR"] = 3] = "ERROR";
})(MessageType || (MessageType = {}));
var defaultOpts = {
    inputBackground: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#3C3C3C'),
    inputForeground: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#CCCCCC'),
    inputValidationInfoBorder: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#55AAFF'),
    inputValidationInfoBackground: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#063B49'),
    inputValidationWarningBorder: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#B89500'),
    inputValidationWarningBackground: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#352A05'),
    inputValidationErrorBorder: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#BE1100'),
    inputValidationErrorBackground: __WEBPACK_IMPORTED_MODULE_10__common_color_js__["a" /* Color */].fromHex('#5A1D1D')
};
var InputBox = /** @class */ (function (_super) {
    __extends(InputBox, _super);
    function InputBox(container, contextViewProvider, options) {
        var _this = _super.call(this) || this;
        _this.state = 'idle';
        _this._onDidChange = _this._register(new __WEBPACK_IMPORTED_MODULE_8__common_event_js__["a" /* Emitter */]());
        _this.onDidChange = _this._onDidChange.event;
        _this._onDidHeightChange = _this._register(new __WEBPACK_IMPORTED_MODULE_8__common_event_js__["a" /* Emitter */]());
        _this.contextViewProvider = contextViewProvider;
        _this.options = options || Object.create(null);
        Object(__WEBPACK_IMPORTED_MODULE_11__common_objects_js__["g" /* mixin */])(_this.options, defaultOpts, false);
        _this.message = null;
        _this.cachedHeight = null;
        _this.placeholder = _this.options.placeholder || '';
        _this.ariaLabel = _this.options.ariaLabel || '';
        _this.inputBackground = _this.options.inputBackground;
        _this.inputForeground = _this.options.inputForeground;
        _this.inputBorder = _this.options.inputBorder;
        _this.inputValidationInfoBorder = _this.options.inputValidationInfoBorder;
        _this.inputValidationInfoBackground = _this.options.inputValidationInfoBackground;
        _this.inputValidationWarningBorder = _this.options.inputValidationWarningBorder;
        _this.inputValidationWarningBackground = _this.options.inputValidationWarningBackground;
        _this.inputValidationErrorBorder = _this.options.inputValidationErrorBorder;
        _this.inputValidationErrorBackground = _this.options.inputValidationErrorBackground;
        if (_this.options.validationOptions) {
            _this.validation = _this.options.validationOptions.validation;
        }
        _this.element = __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](container, $('.monaco-inputbox.idle'));
        var tagName = _this.options.flexibleHeight ? 'textarea' : 'input';
        var wrapper = __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](_this.element, $('.wrapper'));
        _this.input = __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](wrapper, $(tagName + '.input'));
        _this.input.setAttribute('autocorrect', 'off');
        _this.input.setAttribute('autocapitalize', 'off');
        _this.input.setAttribute('spellcheck', 'false');
        _this.onfocus(_this.input, function () { return __WEBPACK_IMPORTED_MODULE_3__dom_js__["f" /* addClass */](_this.element, 'synthetic-focus'); });
        _this.onblur(_this.input, function () { return __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](_this.element, 'synthetic-focus'); });
        if (_this.options.flexibleHeight) {
            _this.mirror = __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](wrapper, $('div.mirror'));
        }
        else {
            _this.input.type = _this.options.type || 'text';
            _this.input.setAttribute('wrap', 'off');
        }
        if (_this.ariaLabel) {
            _this.input.setAttribute('aria-label', _this.ariaLabel);
        }
        if (_this.placeholder) {
            _this.setPlaceHolder(_this.placeholder);
        }
        _this.oninput(_this.input, function () { return _this.onValueChange(); });
        _this.onblur(_this.input, function () { return _this.onBlur(); });
        _this.onfocus(_this.input, function () { return _this.onFocus(); });
        // Add placeholder shim for IE because IE decides to hide the placeholder on focus (we dont want that!)
        if (_this.placeholder && __WEBPACK_IMPORTED_MODULE_2__browser_js__["k" /* isIE */]) {
            _this.onclick(_this.input, function (e) {
                __WEBPACK_IMPORTED_MODULE_3__dom_js__["c" /* EventHelper */].stop(e, true);
                _this.input.focus();
            });
        }
        setTimeout(function () {
            if (!_this.input) {
                return;
            }
            _this.updateMirror();
        }, 0);
        // Support actions
        if (_this.options.actions) {
            _this.actionbar = _this._register(new __WEBPACK_IMPORTED_MODULE_6__actionbar_actionbar_js__["a" /* ActionBar */](_this.element));
            _this.actionbar.push(_this.options.actions, { icon: true, label: false });
        }
        _this.applyStyles();
        return _this;
    }
    InputBox.prototype.onBlur = function () {
        this._hideMessage();
    };
    InputBox.prototype.onFocus = function () {
        this._showMessage();
    };
    InputBox.prototype.setPlaceHolder = function (placeHolder) {
        if (this.input) {
            this.input.setAttribute('placeholder', placeHolder);
            this.input.title = placeHolder;
        }
    };
    InputBox.prototype.setAriaLabel = function (label) {
        this.ariaLabel = label;
        if (this.input) {
            if (label) {
                this.input.setAttribute('aria-label', this.ariaLabel);
            }
            else {
                this.input.removeAttribute('aria-label');
            }
        }
    };
    Object.defineProperty(InputBox.prototype, "inputElement", {
        get: function () {
            return this.input;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputBox.prototype, "value", {
        get: function () {
            return this.input.value;
        },
        set: function (newValue) {
            if (this.input.value !== newValue) {
                this.input.value = newValue;
                this.onValueChange();
            }
        },
        enumerable: true,
        configurable: true
    });
    InputBox.prototype.focus = function () {
        this.input.focus();
    };
    InputBox.prototype.blur = function () {
        this.input.blur();
    };
    InputBox.prototype.hasFocus = function () {
        return document.activeElement === this.input;
    };
    InputBox.prototype.select = function (range) {
        if (range === void 0) { range = null; }
        this.input.select();
        if (range) {
            this.input.setSelectionRange(range.start, range.end);
        }
    };
    InputBox.prototype.enable = function () {
        this.input.removeAttribute('disabled');
    };
    InputBox.prototype.disable = function () {
        this.input.disabled = true;
        this._hideMessage();
    };
    InputBox.prototype.setEnabled = function (enabled) {
        if (enabled) {
            this.enable();
        }
        else {
            this.disable();
        }
    };
    Object.defineProperty(InputBox.prototype, "width", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3__dom_js__["y" /* getTotalWidth */](this.input);
        },
        set: function (width) {
            this.input.style.width = width + 'px';
        },
        enumerable: true,
        configurable: true
    });
    InputBox.prototype.showMessage = function (message, force) {
        this.message = message;
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](this.element, 'idle');
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](this.element, 'info');
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](this.element, 'warning');
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](this.element, 'error');
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["f" /* addClass */](this.element, this.classForType(message.type));
        var styles = this.stylesForType(this.message.type);
        this.element.style.border = styles.border ? "1px solid " + styles.border : null;
        // ARIA Support
        var alertText;
        if (message.type === MessageType.ERROR) {
            alertText = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('alertErrorMessage', "Error: {0}", message.content);
        }
        else if (message.type === MessageType.WARNING) {
            alertText = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('alertWarningMessage', "Warning: {0}", message.content);
        }
        else {
            alertText = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('alertInfoMessage', "Info: {0}", message.content);
        }
        __WEBPACK_IMPORTED_MODULE_5__aria_aria_js__["a" /* alert */](alertText);
        if (this.hasFocus() || force) {
            this._showMessage();
        }
    };
    InputBox.prototype.hideMessage = function () {
        this.message = null;
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](this.element, 'info');
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](this.element, 'warning');
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["G" /* removeClass */](this.element, 'error');
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["f" /* addClass */](this.element, 'idle');
        this._hideMessage();
        this.applyStyles();
    };
    InputBox.prototype.validate = function () {
        var errorMsg = null;
        if (this.validation) {
            errorMsg = this.validation(this.value);
            if (errorMsg) {
                this.inputElement.setAttribute('aria-invalid', 'true');
                this.showMessage(errorMsg);
            }
            else if (this.inputElement.hasAttribute('aria-invalid')) {
                this.inputElement.removeAttribute('aria-invalid');
                this.hideMessage();
            }
        }
        return !errorMsg;
    };
    InputBox.prototype.stylesForType = function (type) {
        switch (type) {
            case MessageType.INFO: return { border: this.inputValidationInfoBorder, background: this.inputValidationInfoBackground };
            case MessageType.WARNING: return { border: this.inputValidationWarningBorder, background: this.inputValidationWarningBackground };
            default: return { border: this.inputValidationErrorBorder, background: this.inputValidationErrorBackground };
        }
    };
    InputBox.prototype.classForType = function (type) {
        switch (type) {
            case MessageType.INFO: return 'info';
            case MessageType.WARNING: return 'warning';
            default: return 'error';
        }
    };
    InputBox.prototype._showMessage = function () {
        var _this = this;
        if (!this.contextViewProvider || !this.message) {
            return;
        }
        var div;
        var layout = function () { return div.style.width = __WEBPACK_IMPORTED_MODULE_3__dom_js__["y" /* getTotalWidth */](_this.element) + 'px'; };
        this.state = 'open';
        this.contextViewProvider.showContextView({
            getAnchor: function () { return _this.element; },
            anchorAlignment: __WEBPACK_IMPORTED_MODULE_7__contextview_contextview_js__["a" /* AnchorAlignment */].RIGHT,
            render: function (container) {
                div = __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](container, $('.monaco-inputbox-container'));
                layout();
                var renderOptions = {
                    inline: true,
                    className: 'monaco-inputbox-message'
                };
                var spanElement = (_this.message.formatContent
                    ? Object(__WEBPACK_IMPORTED_MODULE_4__htmlContentRenderer_js__["a" /* renderFormattedText */])(_this.message.content, renderOptions)
                    : Object(__WEBPACK_IMPORTED_MODULE_4__htmlContentRenderer_js__["c" /* renderText */])(_this.message.content, renderOptions));
                __WEBPACK_IMPORTED_MODULE_3__dom_js__["f" /* addClass */](spanElement, _this.classForType(_this.message.type));
                var styles = _this.stylesForType(_this.message.type);
                spanElement.style.backgroundColor = styles.background ? styles.background.toString() : null;
                spanElement.style.border = styles.border ? "1px solid " + styles.border : null;
                __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](div, spanElement);
                return null;
            },
            layout: layout
        });
    };
    InputBox.prototype._hideMessage = function () {
        if (!this.contextViewProvider || this.state !== 'open') {
            return;
        }
        this.state = 'idle';
        this.contextViewProvider.hideContextView();
    };
    InputBox.prototype.onValueChange = function () {
        this._onDidChange.fire(this.value);
        this.validate();
        this.updateMirror();
        if (this.state === 'open') {
            this.contextViewProvider.layout();
        }
    };
    InputBox.prototype.updateMirror = function () {
        if (!this.mirror) {
            return;
        }
        var value = this.value || this.placeholder;
        var lastCharCode = value.charCodeAt(value.length - 1);
        var suffix = lastCharCode === 10 ? ' ' : '';
        this.mirror.textContent = value + suffix;
        this.layout();
    };
    InputBox.prototype.style = function (styles) {
        this.inputBackground = styles.inputBackground;
        this.inputForeground = styles.inputForeground;
        this.inputBorder = styles.inputBorder;
        this.inputValidationInfoBackground = styles.inputValidationInfoBackground;
        this.inputValidationInfoBorder = styles.inputValidationInfoBorder;
        this.inputValidationWarningBackground = styles.inputValidationWarningBackground;
        this.inputValidationWarningBorder = styles.inputValidationWarningBorder;
        this.inputValidationErrorBackground = styles.inputValidationErrorBackground;
        this.inputValidationErrorBorder = styles.inputValidationErrorBorder;
        this.applyStyles();
    };
    InputBox.prototype.applyStyles = function () {
        if (this.element) {
            var background = this.inputBackground ? this.inputBackground.toString() : null;
            var foreground = this.inputForeground ? this.inputForeground.toString() : null;
            var border = this.inputBorder ? this.inputBorder.toString() : null;
            this.element.style.backgroundColor = background;
            this.element.style.color = foreground;
            this.input.style.backgroundColor = background;
            this.input.style.color = foreground;
            this.element.style.borderWidth = border ? '1px' : null;
            this.element.style.borderStyle = border ? 'solid' : null;
            this.element.style.borderColor = border;
        }
    };
    InputBox.prototype.layout = function () {
        if (!this.mirror) {
            return;
        }
        var previousHeight = this.cachedHeight;
        this.cachedHeight = __WEBPACK_IMPORTED_MODULE_3__dom_js__["x" /* getTotalHeight */](this.mirror);
        if (previousHeight !== this.cachedHeight) {
            this.input.style.height = this.cachedHeight + 'px';
            this._onDidHeightChange.fire(this.cachedHeight);
        }
    };
    InputBox.prototype.dispose = function () {
        this._hideMessage();
        this.element = null;
        this.input = null;
        this.contextViewProvider = null;
        this.message = null;
        this.placeholder = null;
        this.ariaLabel = null;
        this.validation = null;
        this.state = null;
        this.actionbar = null;
        _super.prototype.dispose.call(this);
    };
    return InputBox;
}(__WEBPACK_IMPORTED_MODULE_9__widget_js__["a" /* Widget */]));

var HistoryInputBox = /** @class */ (function (_super) {
    __extends(HistoryInputBox, _super);
    function HistoryInputBox(container, contextViewProvider, options) {
        var _this = _super.call(this, container, contextViewProvider, options) || this;
        _this.history = new __WEBPACK_IMPORTED_MODULE_12__common_history_js__["a" /* HistoryNavigator */](options.history, 100);
        return _this;
    }
    HistoryInputBox.prototype.addToHistory = function () {
        if (this.value && this.value !== this.getCurrentValue()) {
            this.history.add(this.value);
        }
    };
    HistoryInputBox.prototype.showNextValue = function () {
        if (!this.history.has(this.value)) {
            this.addToHistory();
        }
        var next = this.getNextValue();
        if (next) {
            next = next === this.value ? this.getNextValue() : next;
        }
        if (next) {
            this.value = next;
            __WEBPACK_IMPORTED_MODULE_5__aria_aria_js__["c" /* status */](this.value);
        }
    };
    HistoryInputBox.prototype.showPreviousValue = function () {
        if (!this.history.has(this.value)) {
            this.addToHistory();
        }
        var previous = this.getPreviousValue();
        if (previous) {
            previous = previous === this.value ? this.getPreviousValue() : previous;
        }
        if (previous) {
            this.value = previous;
            __WEBPACK_IMPORTED_MODULE_5__aria_aria_js__["c" /* status */](this.value);
        }
    };
    HistoryInputBox.prototype.getCurrentValue = function () {
        var currentValue = this.history.current();
        if (!currentValue) {
            currentValue = this.history.last();
            this.history.next();
        }
        return currentValue;
    };
    HistoryInputBox.prototype.getPreviousValue = function () {
        return this.history.previous() || this.history.first();
    };
    HistoryInputBox.prototype.getNextValue = function () {
        return this.history.next() || this.history.last();
    };
    return HistoryInputBox;
}(InputBox));



/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Iterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrayIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArrayNavigator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MappedIterator; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Iterator;
(function (Iterator) {
    var _empty = {
        next: function () {
            return { done: true, value: undefined };
        }
    };
    function empty() {
        return _empty;
    }
    Iterator.empty = empty;
    function iterate(array, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = array.length; }
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: undefined };
                }
                return { done: false, value: array[index++] };
            }
        };
    }
    Iterator.iterate = iterate;
    function map(iterator, fn) {
        return {
            next: function () {
                var _a = iterator.next(), done = _a.done, value = _a.value;
                return { done: done, value: done ? undefined : fn(value) };
            }
        };
    }
    Iterator.map = map;
    function filter(iterator, fn) {
        return {
            next: function () {
                while (true) {
                    var _a = iterator.next(), done = _a.done, value = _a.value;
                    if (done) {
                        return { done: done, value: undefined };
                    }
                    if (fn(value)) {
                        return { done: done, value: value };
                    }
                }
            }
        };
    }
    Iterator.filter = filter;
    function forEach(iterator, fn) {
        for (var next = iterator.next(); !next.done; next = iterator.next()) {
            fn(next.value);
        }
    }
    Iterator.forEach = forEach;
    function collect(iterator) {
        var result = [];
        forEach(iterator, function (value) { return result.push(value); });
        return result;
    }
    Iterator.collect = collect;
})(Iterator || (Iterator = {}));
var ArrayIterator = /** @class */ (function () {
    function ArrayIterator(items, start, end, index) {
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = items.length; }
        if (index === void 0) { index = start - 1; }
        this.items = items;
        this.start = start;
        this.end = end;
        this.index = index;
    }
    ArrayIterator.prototype.next = function () {
        this.index = Math.min(this.index + 1, this.end);
        return this.current();
    };
    ArrayIterator.prototype.current = function () {
        if (this.index === this.start - 1 || this.index === this.end) {
            return null;
        }
        return this.items[this.index];
    };
    return ArrayIterator;
}());

var ArrayNavigator = /** @class */ (function (_super) {
    __extends(ArrayNavigator, _super);
    function ArrayNavigator(items, start, end, index) {
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = items.length; }
        if (index === void 0) { index = start - 1; }
        return _super.call(this, items, start, end, index) || this;
    }
    ArrayNavigator.prototype.current = function () {
        return _super.prototype.current.call(this);
    };
    ArrayNavigator.prototype.previous = function () {
        this.index = Math.max(this.index - 1, this.start - 1);
        return this.current();
    };
    ArrayNavigator.prototype.first = function () {
        this.index = this.start;
        return this.current();
    };
    ArrayNavigator.prototype.last = function () {
        this.index = this.end - 1;
        return this.current();
    };
    ArrayNavigator.prototype.parent = function () {
        return null;
    };
    return ArrayNavigator;
}(ArrayIterator));

var MappedIterator = /** @class */ (function () {
    function MappedIterator(iterator, fn) {
        this.iterator = iterator;
        this.fn = fn;
        // noop
    }
    MappedIterator.prototype.next = function () { return this.fn(this.iterator.next()); };
    return MappedIterator;
}());



/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ID", function() { return ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FoldingController", function() { return FoldingController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__folding_css__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__folding_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__folding_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__foldingModel_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__foldingDecorations_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hiddenRangeModel_js__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__indentRangeProvider_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__syntaxRangeProvider_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__intializingRangeProvider_js__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__base_common_errors_js__ = __webpack_require__(6);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















var ID = 'editor.contrib.folding';
var FoldingController = /** @class */ (function () {
    function FoldingController(editor) {
        var _this = this;
        this.editor = editor;
        this._isEnabled = this.editor.getConfiguration().contribInfo.folding;
        this._autoHideFoldingControls = this.editor.getConfiguration().contribInfo.showFoldingControls === 'mouseover';
        this._useFoldingProviders = this.editor.getConfiguration().contribInfo.foldingStrategy !== 'indentation';
        this.globalToDispose = [];
        this.localToDispose = [];
        this.foldingDecorationProvider = new __WEBPACK_IMPORTED_MODULE_11__foldingDecorations_js__["a" /* FoldingDecorationProvider */](editor);
        this.foldingDecorationProvider.autoHideFoldingControls = this._autoHideFoldingControls;
        this.globalToDispose.push(this.editor.onDidChangeModel(function () { return _this.onModelChanged(); }));
        this.globalToDispose.push(__WEBPACK_IMPORTED_MODULE_16__common_modes_js__["l" /* FoldingRangeProviderRegistry */].onDidChange(function () { return _this.onFoldingStrategyChanged(); }));
        this.globalToDispose.push(this.editor.onDidChangeConfiguration(function (e) {
            if (e.contribInfo) {
                var oldIsEnabled = _this._isEnabled;
                _this._isEnabled = _this.editor.getConfiguration().contribInfo.folding;
                if (oldIsEnabled !== _this._isEnabled) {
                    _this.onModelChanged();
                }
                var oldShowFoldingControls = _this._autoHideFoldingControls;
                _this._autoHideFoldingControls = _this.editor.getConfiguration().contribInfo.showFoldingControls === 'mouseover';
                if (oldShowFoldingControls !== _this._autoHideFoldingControls) {
                    _this.foldingDecorationProvider.autoHideFoldingControls = _this._autoHideFoldingControls;
                    _this.onModelContentChanged();
                }
                var oldUseFoldingProviders = _this._useFoldingProviders;
                _this._useFoldingProviders = _this.editor.getConfiguration().contribInfo.foldingStrategy !== 'indentation';
                if (oldUseFoldingProviders !== _this._useFoldingProviders) {
                    _this.onFoldingStrategyChanged();
                }
            }
        }));
        this.globalToDispose.push({ dispose: function () { return Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(_this.localToDispose); } });
        this.onModelChanged();
    }
    FoldingController.get = function (editor) {
        return editor.getContribution(ID);
    };
    FoldingController.prototype.getId = function () {
        return ID;
    };
    FoldingController.prototype.dispose = function () {
        this.globalToDispose = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.globalToDispose);
    };
    /**
     * Store view state.
     */
    FoldingController.prototype.saveViewState = function () {
        var model = this.editor.getModel();
        if (!model || !this._isEnabled || model.isTooLargeForTokenization()) {
            return {};
        }
        if (this.foldingModel) { // disposed ?
            var collapsedRegions = this.foldingModel.isInitialized ? this.foldingModel.getMemento() : this.hiddenRangeModel.getMemento();
            var provider = this.rangeProvider ? this.rangeProvider.id : void 0;
            return { collapsedRegions: collapsedRegions, lineCount: model.getLineCount(), provider: provider };
        }
        return void 0;
    };
    /**
     * Restore view state.
     */
    FoldingController.prototype.restoreViewState = function (state) {
        var model = this.editor.getModel();
        if (!model || !this._isEnabled || model.isTooLargeForTokenization()) {
            return;
        }
        if (!state || !state.collapsedRegions || state.lineCount !== model.getLineCount()) {
            return;
        }
        if (state.provider === __WEBPACK_IMPORTED_MODULE_17__syntaxRangeProvider_js__["a" /* ID_SYNTAX_PROVIDER */] || state.provider === __WEBPACK_IMPORTED_MODULE_18__intializingRangeProvider_js__["a" /* ID_INIT_PROVIDER */]) {
            this.foldingStateMemento = state;
        }
        // set the hidden ranges right away, before waiting for the folding model.
        if (this.hiddenRangeModel.applyMemento(state.collapsedRegions)) {
            this.getFoldingModel().then(function (foldingModel) {
                if (foldingModel) {
                    foldingModel.applyMemento(state.collapsedRegions);
                }
            }).done(undefined, __WEBPACK_IMPORTED_MODULE_19__base_common_errors_js__["e" /* onUnexpectedError */]);
        }
    };
    FoldingController.prototype.onModelChanged = function () {
        var _this = this;
        this.localToDispose = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.localToDispose);
        var model = this.editor.getModel();
        if (!this._isEnabled || !model || model.isTooLargeForTokenization()) {
            // huge files get no view model, so they cannot support hidden areas
            return;
        }
        this.foldingModel = new __WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["a" /* FoldingModel */](model, this.foldingDecorationProvider);
        this.localToDispose.push(this.foldingModel);
        this.hiddenRangeModel = new __WEBPACK_IMPORTED_MODULE_13__hiddenRangeModel_js__["a" /* HiddenRangeModel */](this.foldingModel);
        this.localToDispose.push(this.hiddenRangeModel);
        this.localToDispose.push(this.hiddenRangeModel.onDidChange(function (hr) { return _this.onHiddenRangesChanges(hr); }));
        this.updateScheduler = new __WEBPACK_IMPORTED_MODULE_4__base_common_async_js__["a" /* Delayer */](200);
        this.cursorChangedScheduler = new __WEBPACK_IMPORTED_MODULE_4__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this.revealCursor(); }, 200);
        this.localToDispose.push(this.cursorChangedScheduler);
        this.localToDispose.push(this.editor.onDidChangeModelLanguageConfiguration(function (e) { return _this.onModelContentChanged(); })); // covers model language changes as well
        this.localToDispose.push(this.editor.onDidChangeModelContent(function (e) { return _this.onModelContentChanged(); }));
        this.localToDispose.push(this.editor.onDidChangeCursorPosition(function (e) { return _this.onCursorPositionChanged(); }));
        this.localToDispose.push(this.editor.onMouseDown(function (e) { return _this.onEditorMouseDown(e); }));
        this.localToDispose.push(this.editor.onMouseUp(function (e) { return _this.onEditorMouseUp(e); }));
        this.localToDispose.push({
            dispose: function () {
                if (_this.foldingRegionPromise) {
                    _this.foldingRegionPromise.cancel();
                    _this.foldingRegionPromise = null;
                }
                _this.updateScheduler.cancel();
                _this.updateScheduler = null;
                _this.foldingModel = null;
                _this.foldingModelPromise = null;
                _this.hiddenRangeModel = null;
                _this.cursorChangedScheduler = null;
                _this.foldingStateMemento = null;
                if (_this.rangeProvider) {
                    _this.rangeProvider.dispose();
                }
                _this.rangeProvider = null;
            }
        });
        this.onModelContentChanged();
    };
    FoldingController.prototype.onFoldingStrategyChanged = function () {
        if (this.rangeProvider) {
            this.rangeProvider.dispose();
        }
        this.rangeProvider = null;
        this.onModelContentChanged();
    };
    FoldingController.prototype.getRangeProvider = function (editorModel) {
        var _this = this;
        if (this.rangeProvider) {
            return this.rangeProvider;
        }
        this.rangeProvider = new __WEBPACK_IMPORTED_MODULE_15__indentRangeProvider_js__["a" /* IndentRangeProvider */](editorModel); // fallback
        if (this._useFoldingProviders) {
            var foldingProviders = __WEBPACK_IMPORTED_MODULE_16__common_modes_js__["l" /* FoldingRangeProviderRegistry */].ordered(this.foldingModel.textModel);
            if (foldingProviders.length === 0 && this.foldingStateMemento) {
                this.rangeProvider = new __WEBPACK_IMPORTED_MODULE_18__intializingRangeProvider_js__["b" /* InitializingRangeProvider */](editorModel, this.foldingStateMemento.collapsedRegions, function () {
                    // if after 30 the InitializingRangeProvider is still not replaced, force a refresh
                    _this.foldingStateMemento = null;
                    _this.onFoldingStrategyChanged();
                }, 30000);
                return this.rangeProvider; // keep memento in case there are still no foldingProviders on the next request.
            }
            else if (foldingProviders.length > 0) {
                this.rangeProvider = new __WEBPACK_IMPORTED_MODULE_17__syntaxRangeProvider_js__["b" /* SyntaxRangeProvider */](editorModel, foldingProviders);
            }
        }
        this.foldingStateMemento = null;
        return this.rangeProvider;
    };
    FoldingController.prototype.getFoldingModel = function () {
        return this.foldingModelPromise;
    };
    FoldingController.prototype.onModelContentChanged = function () {
        var _this = this;
        if (this.updateScheduler) {
            if (this.foldingRegionPromise) {
                this.foldingRegionPromise.cancel();
                this.foldingRegionPromise = null;
            }
            this.foldingModelPromise = this.updateScheduler.trigger(function () {
                if (!_this.foldingModel) { // null if editor has been disposed, or folding turned off
                    return null;
                }
                var foldingRegionPromise = _this.foldingRegionPromise = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return _this.getRangeProvider(_this.foldingModel.textModel).compute(token); });
                return __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].wrap(foldingRegionPromise.then(function (foldingRanges) {
                    if (foldingRanges && foldingRegionPromise === _this.foldingRegionPromise) { // new request or cancelled in the meantime?
                        // some cursors might have moved into hidden regions, make sure they are in expanded regions
                        var selections = _this.editor.getSelections();
                        var selectionLineNumbers = selections ? selections.map(function (s) { return s.startLineNumber; }) : [];
                        _this.foldingModel.update(foldingRanges, selectionLineNumbers);
                    }
                    return _this.foldingModel;
                }));
            });
        }
    };
    FoldingController.prototype.onHiddenRangesChanges = function (hiddenRanges) {
        if (hiddenRanges.length) {
            var selections = this.editor.getSelections();
            if (selections) {
                if (this.hiddenRangeModel.adjustSelections(selections)) {
                    this.editor.setSelections(selections);
                }
            }
        }
        this.editor.setHiddenAreas(hiddenRanges);
    };
    FoldingController.prototype.onCursorPositionChanged = function () {
        if (this.hiddenRangeModel.hasRanges()) {
            this.cursorChangedScheduler.schedule();
        }
    };
    FoldingController.prototype.revealCursor = function () {
        var _this = this;
        this.getFoldingModel().then(function (foldingModel) {
            if (foldingModel) {
                var selections = _this.editor.getSelections();
                if (selections && selections.length > 0) {
                    var toToggle = [];
                    var _loop_1 = function (selection) {
                        var lineNumber = selection.selectionStartLineNumber;
                        if (_this.hiddenRangeModel.isHidden(lineNumber)) {
                            toToggle.push.apply(toToggle, foldingModel.getAllRegionsAtLine(lineNumber, function (r) { return r.isCollapsed && lineNumber > r.startLineNumber; }));
                        }
                    };
                    for (var _i = 0, selections_1 = selections; _i < selections_1.length; _i++) {
                        var selection = selections_1[_i];
                        _loop_1(selection);
                    }
                    if (toToggle.length) {
                        foldingModel.toggleCollapseState(toToggle);
                        _this.reveal(selections[0].getPosition());
                    }
                }
            }
        }).done(undefined, __WEBPACK_IMPORTED_MODULE_19__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    FoldingController.prototype.onEditorMouseDown = function (e) {
        this.mouseDownInfo = null;
        var range = e.target.range;
        if (!this.hiddenRangeModel || !range) {
            return;
        }
        if (!e.event.leftButton && !e.event.middleButton) {
            return;
        }
        var iconClicked = false;
        switch (e.target.type) {
            case __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_DECORATIONS:
                var data = e.target.detail;
                var gutterOffsetX = data.offsetX - data.glyphMarginWidth - data.lineNumbersWidth - data.glyphMarginLeft;
                // TODO@joao TODO@alex TODO@martin this is such that we don't collide with dirty diff
                if (gutterOffsetX <= 10) {
                    return;
                }
                iconClicked = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY: {
                if (this.hiddenRangeModel.hasRanges()) {
                    var data_1 = e.target.detail;
                    if (!data_1.isAfterLines) {
                        break;
                    }
                }
                return;
            }
            case __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT: {
                if (this.hiddenRangeModel.hasRanges()) {
                    var model = this.editor.getModel();
                    if (model && range.startColumn === model.getLineMaxColumn(range.startLineNumber)) {
                        break;
                    }
                }
                return;
            }
            default:
                return;
        }
        this.mouseDownInfo = { lineNumber: range.startLineNumber, iconClicked: iconClicked };
    };
    FoldingController.prototype.onEditorMouseUp = function (e) {
        var _this = this;
        if (!this.mouseDownInfo) {
            return;
        }
        var lineNumber = this.mouseDownInfo.lineNumber;
        var iconClicked = this.mouseDownInfo.iconClicked;
        var range = e.target.range;
        if (!range || range.startLineNumber !== lineNumber) {
            return;
        }
        if (iconClicked) {
            if (e.target.type !== __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_DECORATIONS) {
                return;
            }
        }
        else {
            var model = this.editor.getModel();
            if (range.startColumn !== model.getLineMaxColumn(lineNumber)) {
                return;
            }
        }
        this.getFoldingModel().then(function (foldingModel) {
            if (foldingModel) {
                var region = foldingModel.getRegionAtLine(lineNumber);
                if (region && region.startLineNumber === lineNumber) {
                    var isCollapsed_1 = region.isCollapsed;
                    if (iconClicked || isCollapsed_1) {
                        var toToggle = [region];
                        if (e.event.middleButton || e.event.shiftKey) {
                            toToggle.push.apply(toToggle, foldingModel.getRegionsInside(region, function (r) { return r.isCollapsed === isCollapsed_1; }));
                        }
                        foldingModel.toggleCollapseState(toToggle);
                        _this.reveal({ lineNumber: lineNumber, column: 1 });
                    }
                }
            }
        }).done(undefined, __WEBPACK_IMPORTED_MODULE_19__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    FoldingController.prototype.reveal = function (position) {
        this.editor.revealPositionInCenterIfOutsideViewport(position, 0 /* Smooth */);
    };
    return FoldingController;
}());

var FoldingAction = /** @class */ (function (_super) {
    __extends(FoldingAction, _super);
    function FoldingAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FoldingAction.prototype.runEditorCommand = function (accessor, editor, args) {
        var _this = this;
        var foldingController = FoldingController.get(editor);
        if (!foldingController) {
            return;
        }
        var foldingModelPromise = foldingController.getFoldingModel();
        if (foldingModelPromise) {
            this.reportTelemetry(accessor, editor);
            return foldingModelPromise.then(function (foldingModel) {
                if (foldingModel) {
                    _this.invoke(foldingController, foldingModel, editor, args);
                    foldingController.reveal(editor.getSelection().getStartPosition());
                }
            });
        }
    };
    FoldingAction.prototype.getSelectedLines = function (editor) {
        var selections = editor.getSelections();
        return selections ? selections.map(function (s) { return s.startLineNumber; }) : [];
    };
    FoldingAction.prototype.getLineNumbers = function (args, editor) {
        if (args && args.selectionLines) {
            return args.selectionLines.map(function (l) { return l + 1; }); // to 0-bases line numbers
        }
        return this.getSelectedLines(editor);
    };
    FoldingAction.prototype.run = function (accessor, editor) {
    };
    return FoldingAction;
}(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["b" /* EditorAction */]));
function foldingArgumentsConstraint(args) {
    if (!__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["i" /* isUndefined */](args)) {
        if (!__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["g" /* isObject */](args)) {
            return false;
        }
        var foldingArgs = args;
        if (!__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["i" /* isUndefined */](foldingArgs.levels) && !__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["f" /* isNumber */](foldingArgs.levels)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["i" /* isUndefined */](foldingArgs.direction) && !__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["h" /* isString */](foldingArgs.direction)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["i" /* isUndefined */](foldingArgs.selectionLines) && (!__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["b" /* isArray */](foldingArgs.selectionLines) || !foldingArgs.selectionLines.every(__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["f" /* isNumber */]))) {
            return false;
        }
    }
    return true;
}
var UnfoldAction = /** @class */ (function (_super) {
    __extends(UnfoldAction, _super);
    function UnfoldAction() {
        return _super.call(this, {
            id: 'editor.unfold',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('unfoldAction.label', "Unfold"),
            alias: 'Unfold',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 89 /* US_CLOSE_SQUARE_BRACKET */,
                mac: {
                    primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 89 /* US_CLOSE_SQUARE_BRACKET */
                },
                weight: 100 /* EditorContrib */
            },
            description: {
                description: 'Unfold the content in the editor',
                args: [
                    {
                        name: 'Unfold editor argument',
                        description: "Property-value pairs that can be passed through this argument:\n\t\t\t\t\t\t* 'levels': Number of levels to unfold. If not set, defaults to 1.\n\t\t\t\t\t\t* 'direction': If 'up', unfold given number of levels up otherwise unfolds down.\n\t\t\t\t\t\t* 'selectionLines': The start lines (0-based) of the editor selections to apply the unfold action to. If not set, the active selection(s) will be used.\n\t\t\t\t\t\t",
                        constraint: foldingArgumentsConstraint
                    }
                ]
            }
        }) || this;
    }
    UnfoldAction.prototype.invoke = function (foldingController, foldingModel, editor, args) {
        var levels = args && args.levels || 1;
        var lineNumbers = this.getLineNumbers(args, editor);
        if (args && args.direction === 'up') {
            Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["f" /* setCollapseStateLevelsUp */])(foldingModel, false, levels, lineNumbers);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["e" /* setCollapseStateLevelsDown */])(foldingModel, false, levels, lineNumbers);
        }
    };
    return UnfoldAction;
}(FoldingAction));
var UnFoldRecursivelyAction = /** @class */ (function (_super) {
    __extends(UnFoldRecursivelyAction, _super);
    function UnFoldRecursivelyAction() {
        return _super.call(this, {
            id: 'editor.unfoldRecursively',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('unFoldRecursivelyAction.label', "Unfold Recursively"),
            alias: 'Unfold Recursively',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 89 /* US_CLOSE_SQUARE_BRACKET */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    UnFoldRecursivelyAction.prototype.invoke = function (foldingController, foldingModel, editor, args) {
        Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["e" /* setCollapseStateLevelsDown */])(foldingModel, false, Number.MAX_VALUE, this.getSelectedLines(editor));
    };
    return UnFoldRecursivelyAction;
}(FoldingAction));
var FoldAction = /** @class */ (function (_super) {
    __extends(FoldAction, _super);
    function FoldAction() {
        return _super.call(this, {
            id: 'editor.fold',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('foldAction.label', "Fold"),
            alias: 'Fold',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 87 /* US_OPEN_SQUARE_BRACKET */,
                mac: {
                    primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 87 /* US_OPEN_SQUARE_BRACKET */
                },
                weight: 100 /* EditorContrib */
            },
            description: {
                description: 'Fold the content in the editor',
                args: [
                    {
                        name: 'Fold editor argument',
                        description: "Property-value pairs that can be passed through this argument:\n\t\t\t\t\t\t\t* 'levels': Number of levels to fold. Defaults to 1.\n\t\t\t\t\t\t\t* 'direction': If 'up', folds given number of levels up otherwise folds down.\n\t\t\t\t\t\t\t* 'selectionLines': The start lines (0-based) of the editor selections to apply the fold action to. If not set, the active selection(s) will be used.\n\t\t\t\t\t\t",
                        constraint: foldingArgumentsConstraint
                    }
                ]
            }
        }) || this;
    }
    FoldAction.prototype.invoke = function (foldingController, foldingModel, editor, args) {
        var levels = args && args.levels || 1;
        var lineNumbers = this.getLineNumbers(args, editor);
        if (args && args.direction === 'up') {
            Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["f" /* setCollapseStateLevelsUp */])(foldingModel, true, levels, lineNumbers);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["e" /* setCollapseStateLevelsDown */])(foldingModel, true, levels, lineNumbers);
        }
    };
    return FoldAction;
}(FoldingAction));
var FoldRecursivelyAction = /** @class */ (function (_super) {
    __extends(FoldRecursivelyAction, _super);
    function FoldRecursivelyAction() {
        return _super.call(this, {
            id: 'editor.foldRecursively',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('foldRecursivelyAction.label', "Fold Recursively"),
            alias: 'Fold Recursively',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 87 /* US_OPEN_SQUARE_BRACKET */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    FoldRecursivelyAction.prototype.invoke = function (foldingController, foldingModel, editor) {
        var selectedLines = this.getSelectedLines(editor);
        Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["e" /* setCollapseStateLevelsDown */])(foldingModel, true, Number.MAX_VALUE, selectedLines);
    };
    return FoldRecursivelyAction;
}(FoldingAction));
var FoldAllBlockCommentsAction = /** @class */ (function (_super) {
    __extends(FoldAllBlockCommentsAction, _super);
    function FoldAllBlockCommentsAction() {
        return _super.call(this, {
            id: 'editor.foldAllBlockComments',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('foldAllBlockComments.label', "Fold All Block Comments"),
            alias: 'Fold All Block Comments',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 85 /* US_SLASH */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    FoldAllBlockCommentsAction.prototype.invoke = function (foldingController, foldingModel, editor) {
        if (foldingModel.regions.hasTypes()) {
            Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["d" /* setCollapseStateForType */])(foldingModel, __WEBPACK_IMPORTED_MODULE_16__common_modes_js__["k" /* FoldingRangeKind */].Comment.value, true);
        }
        else {
            var comments = __WEBPACK_IMPORTED_MODULE_14__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getComments(editor.getModel().getLanguageIdentifier().id);
            if (comments && comments.blockCommentStartToken) {
                var regExp = new RegExp('^\\s*' + Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["escapeRegExpCharacters"])(comments.blockCommentStartToken));
                Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["c" /* setCollapseStateForMatchingLines */])(foldingModel, regExp, true);
            }
        }
    };
    return FoldAllBlockCommentsAction;
}(FoldingAction));
var FoldAllRegionsAction = /** @class */ (function (_super) {
    __extends(FoldAllRegionsAction, _super);
    function FoldAllRegionsAction() {
        return _super.call(this, {
            id: 'editor.foldAllMarkerRegions',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('foldAllMarkerRegions.label', "Fold All Regions"),
            alias: 'Fold All Regions',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 29 /* KEY_8 */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    FoldAllRegionsAction.prototype.invoke = function (foldingController, foldingModel, editor) {
        if (foldingModel.regions.hasTypes()) {
            Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["d" /* setCollapseStateForType */])(foldingModel, __WEBPACK_IMPORTED_MODULE_16__common_modes_js__["k" /* FoldingRangeKind */].Region.value, true);
        }
        else {
            var foldingRules = __WEBPACK_IMPORTED_MODULE_14__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getFoldingRules(editor.getModel().getLanguageIdentifier().id);
            if (foldingRules && foldingRules.markers && foldingRules.markers.start) {
                var regExp = new RegExp(foldingRules.markers.start);
                Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["c" /* setCollapseStateForMatchingLines */])(foldingModel, regExp, true);
            }
        }
    };
    return FoldAllRegionsAction;
}(FoldingAction));
var UnfoldAllRegionsAction = /** @class */ (function (_super) {
    __extends(UnfoldAllRegionsAction, _super);
    function UnfoldAllRegionsAction() {
        return _super.call(this, {
            id: 'editor.unfoldAllMarkerRegions',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('unfoldAllMarkerRegions.label', "Unfold All Regions"),
            alias: 'Unfold All Regions',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 30 /* KEY_9 */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    UnfoldAllRegionsAction.prototype.invoke = function (foldingController, foldingModel, editor) {
        if (foldingModel.regions.hasTypes()) {
            Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["d" /* setCollapseStateForType */])(foldingModel, __WEBPACK_IMPORTED_MODULE_16__common_modes_js__["k" /* FoldingRangeKind */].Region.value, false);
        }
        else {
            var foldingRules = __WEBPACK_IMPORTED_MODULE_14__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getFoldingRules(editor.getModel().getLanguageIdentifier().id);
            if (foldingRules && foldingRules.markers && foldingRules.markers.start) {
                var regExp = new RegExp(foldingRules.markers.start);
                Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["c" /* setCollapseStateForMatchingLines */])(foldingModel, regExp, false);
            }
        }
    };
    return UnfoldAllRegionsAction;
}(FoldingAction));
var FoldAllAction = /** @class */ (function (_super) {
    __extends(FoldAllAction, _super);
    function FoldAllAction() {
        return _super.call(this, {
            id: 'editor.foldAll',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('foldAllAction.label', "Fold All"),
            alias: 'Fold All',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 21 /* KEY_0 */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    FoldAllAction.prototype.invoke = function (foldingController, foldingModel, editor) {
        Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["e" /* setCollapseStateLevelsDown */])(foldingModel, true);
    };
    return FoldAllAction;
}(FoldingAction));
var UnfoldAllAction = /** @class */ (function (_super) {
    __extends(UnfoldAllAction, _super);
    function UnfoldAllAction() {
        return _super.call(this, {
            id: 'editor.unfoldAll',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('unfoldAllAction.label', "Unfold All"),
            alias: 'Unfold All',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 40 /* KEY_J */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    UnfoldAllAction.prototype.invoke = function (foldingController, foldingModel, editor) {
        Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["e" /* setCollapseStateLevelsDown */])(foldingModel, false);
    };
    return UnfoldAllAction;
}(FoldingAction));
var FoldLevelAction = /** @class */ (function (_super) {
    __extends(FoldLevelAction, _super);
    function FoldLevelAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FoldLevelAction.prototype.getFoldingLevel = function () {
        return parseInt(this.id.substr(FoldLevelAction.ID_PREFIX.length));
    };
    FoldLevelAction.prototype.invoke = function (foldingController, foldingModel, editor) {
        Object(__WEBPACK_IMPORTED_MODULE_10__foldingModel_js__["b" /* setCollapseStateAtLevel */])(foldingModel, this.getFoldingLevel(), true, this.getSelectedLines(editor));
    };
    FoldLevelAction.ID_PREFIX = 'editor.foldLevel';
    FoldLevelAction.ID = function (level) { return FoldLevelAction.ID_PREFIX + level; };
    return FoldLevelAction;
}(FoldingAction));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["h" /* registerEditorContribution */])(FoldingController);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(UnfoldAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(UnFoldRecursivelyAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(FoldAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(FoldRecursivelyAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(FoldAllAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(UnfoldAllAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(FoldAllBlockCommentsAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(FoldAllRegionsAction);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(UnfoldAllRegionsAction);
for (var i = 1; i <= 7; i++) {
    Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["i" /* registerInstantiatedEditorAction */])(new FoldLevelAction({
        id: FoldLevelAction.ID(i),
        label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('foldLevelAction.label', "Fold Level {0}", i),
        alias: "Fold Level " + i,
        precondition: null,
        kbOpts: {
            kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
            primary: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | (21 /* KEY_0 */ + i)),
            weight: 100 /* EditorContrib */
        }
    }));
}


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_FOLDING_REGIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_LINE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FoldingRegions; });
/* unused harmony export FoldingRegion */
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var MAX_FOLDING_REGIONS = 0xFFFF;
var MAX_LINE_NUMBER = 0xFFFFFF;
var MASK_INDENT = 0xFF000000;
var FoldingRegions = /** @class */ (function () {
    function FoldingRegions(startIndexes, endIndexes, types) {
        if (startIndexes.length !== endIndexes.length || startIndexes.length > MAX_FOLDING_REGIONS) {
            throw new Error('invalid startIndexes or endIndexes size');
        }
        this._startIndexes = startIndexes;
        this._endIndexes = endIndexes;
        this._collapseStates = new Uint32Array(Math.ceil(startIndexes.length / 32));
        this._types = types;
    }
    FoldingRegions.prototype.ensureParentIndices = function () {
        var _this = this;
        if (!this._parentsComputed) {
            this._parentsComputed = true;
            var parentIndexes_1 = [];
            var isInsideLast = function (startLineNumber, endLineNumber) {
                var index = parentIndexes_1[parentIndexes_1.length - 1];
                return _this.getStartLineNumber(index) <= startLineNumber && _this.getEndLineNumber(index) >= endLineNumber;
            };
            for (var i = 0, len = this._startIndexes.length; i < len; i++) {
                var startLineNumber = this._startIndexes[i];
                var endLineNumber = this._endIndexes[i];
                if (startLineNumber > MAX_LINE_NUMBER || endLineNumber > MAX_LINE_NUMBER) {
                    throw new Error('startLineNumber or endLineNumber must not exceed ' + MAX_LINE_NUMBER);
                }
                while (parentIndexes_1.length > 0 && !isInsideLast(startLineNumber, endLineNumber)) {
                    parentIndexes_1.pop();
                }
                var parentIndex = parentIndexes_1.length > 0 ? parentIndexes_1[parentIndexes_1.length - 1] : -1;
                parentIndexes_1.push(i);
                this._startIndexes[i] = startLineNumber + ((parentIndex & 0xFF) << 24);
                this._endIndexes[i] = endLineNumber + ((parentIndex & 0xFF00) << 16);
            }
        }
    };
    Object.defineProperty(FoldingRegions.prototype, "length", {
        get: function () {
            return this._startIndexes.length;
        },
        enumerable: true,
        configurable: true
    });
    FoldingRegions.prototype.getStartLineNumber = function (index) {
        return this._startIndexes[index] & MAX_LINE_NUMBER;
    };
    FoldingRegions.prototype.getEndLineNumber = function (index) {
        return this._endIndexes[index] & MAX_LINE_NUMBER;
    };
    FoldingRegions.prototype.getType = function (index) {
        return this._types ? this._types[index] : void 0;
    };
    FoldingRegions.prototype.hasTypes = function () {
        return !!this._types;
    };
    FoldingRegions.prototype.isCollapsed = function (index) {
        var arrayIndex = (index / 32) | 0;
        var bit = index % 32;
        return (this._collapseStates[arrayIndex] & (1 << bit)) !== 0;
    };
    FoldingRegions.prototype.setCollapsed = function (index, newState) {
        var arrayIndex = (index / 32) | 0;
        var bit = index % 32;
        var value = this._collapseStates[arrayIndex];
        if (newState) {
            this._collapseStates[arrayIndex] = value | (1 << bit);
        }
        else {
            this._collapseStates[arrayIndex] = value & ~(1 << bit);
        }
    };
    FoldingRegions.prototype.toRegion = function (index) {
        return new FoldingRegion(this, index);
    };
    FoldingRegions.prototype.getParentIndex = function (index) {
        this.ensureParentIndices();
        var parent = ((this._startIndexes[index] & MASK_INDENT) >>> 24) + ((this._endIndexes[index] & MASK_INDENT) >>> 16);
        if (parent === MAX_FOLDING_REGIONS) {
            return -1;
        }
        return parent;
    };
    FoldingRegions.prototype.contains = function (index, line) {
        return this.getStartLineNumber(index) <= line && this.getEndLineNumber(index) >= line;
    };
    FoldingRegions.prototype.findIndex = function (line) {
        var low = 0, high = this._startIndexes.length;
        if (high === 0) {
            return -1; // no children
        }
        while (low < high) {
            var mid = Math.floor((low + high) / 2);
            if (line < this.getStartLineNumber(mid)) {
                high = mid;
            }
            else {
                low = mid + 1;
            }
        }
        return low - 1;
    };
    FoldingRegions.prototype.findRange = function (line) {
        var index = this.findIndex(line);
        if (index >= 0) {
            var endLineNumber = this.getEndLineNumber(index);
            if (endLineNumber >= line) {
                return index;
            }
            index = this.getParentIndex(index);
            while (index !== -1) {
                if (this.contains(index, line)) {
                    return index;
                }
                index = this.getParentIndex(index);
            }
        }
        return -1;
    };
    FoldingRegions.prototype.toString = function () {
        var res = [];
        for (var i = 0; i < this.length; i++) {
            res[i] = "[" + (this.isCollapsed(i) ? '+' : '-') + "] " + this.getStartLineNumber(i) + "/" + this.getEndLineNumber(i);
        }
        return res.join(', ');
    };
    return FoldingRegions;
}());

var FoldingRegion = /** @class */ (function () {
    function FoldingRegion(ranges, index) {
        this.ranges = ranges;
        this.index = index;
    }
    Object.defineProperty(FoldingRegion.prototype, "startLineNumber", {
        get: function () {
            return this.ranges.getStartLineNumber(this.index);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FoldingRegion.prototype, "endLineNumber", {
        get: function () {
            return this.ranges.getEndLineNumber(this.index);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FoldingRegion.prototype, "regionIndex", {
        get: function () {
            return this.index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FoldingRegion.prototype, "parentIndex", {
        get: function () {
            return this.ranges.getParentIndex(this.index);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FoldingRegion.prototype, "isCollapsed", {
        get: function () {
            return this.ranges.isCollapsed(this.index);
        },
        enumerable: true,
        configurable: true
    });
    FoldingRegion.prototype.containedBy = function (range) {
        return range.startLineNumber <= this.startLineNumber && range.endLineNumber >= this.endLineNumber;
    };
    FoldingRegion.prototype.containsLine = function (lineNumber) {
        return this.startLineNumber <= lineNumber && lineNumber <= this.endLineNumber;
    };
    return FoldingRegion;
}());



/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_config_editorZoom_js__ = __webpack_require__(92);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var EditorFontZoomIn = /** @class */ (function (_super) {
    __extends(EditorFontZoomIn, _super);
    function EditorFontZoomIn() {
        return _super.call(this, {
            id: 'editor.action.fontZoomIn',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('EditorFontZoomIn.label', "Editor Font Zoom In"),
            alias: 'Editor Font Zoom In',
            precondition: null
        }) || this;
    }
    EditorFontZoomIn.prototype.run = function (accessor, editor) {
        __WEBPACK_IMPORTED_MODULE_2__common_config_editorZoom_js__["a" /* EditorZoom */].setZoomLevel(__WEBPACK_IMPORTED_MODULE_2__common_config_editorZoom_js__["a" /* EditorZoom */].getZoomLevel() + 1);
    };
    return EditorFontZoomIn;
}(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["b" /* EditorAction */]));
var EditorFontZoomOut = /** @class */ (function (_super) {
    __extends(EditorFontZoomOut, _super);
    function EditorFontZoomOut() {
        return _super.call(this, {
            id: 'editor.action.fontZoomOut',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('EditorFontZoomOut.label', "Editor Font Zoom Out"),
            alias: 'Editor Font Zoom Out',
            precondition: null
        }) || this;
    }
    EditorFontZoomOut.prototype.run = function (accessor, editor) {
        __WEBPACK_IMPORTED_MODULE_2__common_config_editorZoom_js__["a" /* EditorZoom */].setZoomLevel(__WEBPACK_IMPORTED_MODULE_2__common_config_editorZoom_js__["a" /* EditorZoom */].getZoomLevel() - 1);
    };
    return EditorFontZoomOut;
}(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["b" /* EditorAction */]));
var EditorFontZoomReset = /** @class */ (function (_super) {
    __extends(EditorFontZoomReset, _super);
    function EditorFontZoomReset() {
        return _super.call(this, {
            id: 'editor.action.fontZoomReset',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('EditorFontZoomReset.label', "Editor Font Zoom Reset"),
            alias: 'Editor Font Zoom Reset',
            precondition: null
        }) || this;
    }
    EditorFontZoomReset.prototype.run = function (accessor, editor) {
        __WEBPACK_IMPORTED_MODULE_2__common_config_editorZoom_js__["a" /* EditorZoom */].setZoomLevel(0);
    };
    return EditorFontZoomReset;
}(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["f" /* registerEditorAction */])(EditorFontZoomIn);
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["f" /* registerEditorAction */])(EditorFontZoomOut);
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["f" /* registerEditorAction */])(EditorFontZoomReset);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractFormatAction", function() { return AbstractFormatAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatDocumentAction", function() { return FormatDocumentAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatSelectionAction", function() { return FormatSelectionAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__format_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__formattingEdit_js__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_services_editorWorkerService_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_core_characterClassifier_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__browser_core_editorState_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__platform_notification_common_notification_js__ = __webpack_require__(34);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



















function alertFormattingEdits(edits) {
    edits = edits.filter(function (edit) { return edit.range; });
    if (!edits.length) {
        return;
    }
    var range = edits[0].range;
    for (var i = 1; i < edits.length; i++) {
        range = __WEBPACK_IMPORTED_MODULE_14__common_core_range_js__["a" /* Range */].plusRange(range, edits[i].range);
    }
    var startLineNumber = range.startLineNumber, endLineNumber = range.endLineNumber;
    if (startLineNumber === endLineNumber) {
        if (edits.length === 1) {
            Object(__WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hint11', "Made 1 formatting edit on line {0}", startLineNumber));
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hintn1', "Made {0} formatting edits on line {1}", edits.length, startLineNumber));
        }
    }
    else {
        if (edits.length === 1) {
            Object(__WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hint1n', "Made 1 formatting edit between lines {0} and {1}", startLineNumber, endLineNumber));
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('hintnn', "Made {0} formatting edits between lines {1} and {2}", edits.length, startLineNumber, endLineNumber));
        }
    }
}
var FormatOnType = /** @class */ (function () {
    function FormatOnType(editor, workerService) {
        var _this = this;
        this.editor = editor;
        this.workerService = workerService;
        this.callOnDispose = [];
        this.callOnModel = [];
        this.callOnDispose.push(editor.onDidChangeConfiguration(function () { return _this.update(); }));
        this.callOnDispose.push(editor.onDidChangeModel(function () { return _this.update(); }));
        this.callOnDispose.push(editor.onDidChangeModelLanguage(function () { return _this.update(); }));
        this.callOnDispose.push(__WEBPACK_IMPORTED_MODULE_7__common_modes_js__["q" /* OnTypeFormattingEditProviderRegistry */].onDidChange(this.update, this));
    }
    FormatOnType.prototype.update = function () {
        var _this = this;
        // clean up
        this.callOnModel = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this.callOnModel);
        // we are disabled
        if (!this.editor.getConfiguration().contribInfo.formatOnType) {
            return;
        }
        // no model
        if (!this.editor.getModel()) {
            return;
        }
        var model = this.editor.getModel();
        // no support
        var support = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["q" /* OnTypeFormattingEditProviderRegistry */].ordered(model)[0];
        if (!support || !support.autoFormatTriggerCharacters) {
            return;
        }
        // register typing listeners that will trigger the format
        var triggerChars = new __WEBPACK_IMPORTED_MODULE_13__common_core_characterClassifier_js__["b" /* CharacterSet */]();
        for (var _i = 0, _a = support.autoFormatTriggerCharacters; _i < _a.length; _i++) {
            var ch = _a[_i];
            triggerChars.add(ch.charCodeAt(0));
        }
        this.callOnModel.push(this.editor.onDidType(function (text) {
            var lastCharCode = text.charCodeAt(text.length - 1);
            if (triggerChars.has(lastCharCode)) {
                _this.trigger(String.fromCharCode(lastCharCode));
            }
        }));
    };
    FormatOnType.prototype.trigger = function (ch) {
        var _this = this;
        if (this.editor.getSelections().length > 1) {
            return;
        }
        var model = this.editor.getModel();
        var position = this.editor.getPosition();
        var canceled = false;
        // install a listener that checks if edits happens before the
        // position on which we format right now. If so, we won't
        // apply the format edits
        var unbind = this.editor.onDidChangeModelContent(function (e) {
            if (e.isFlush) {
                // a model.setValue() was called
                // cancel only once
                canceled = true;
                unbind.dispose();
                return;
            }
            for (var i = 0, len = e.changes.length; i < len; i++) {
                var change = e.changes[i];
                if (change.range.endLineNumber <= position.lineNumber) {
                    // cancel only once
                    canceled = true;
                    unbind.dispose();
                    return;
                }
            }
        });
        var modelOpts = model.getOptions();
        Object(__WEBPACK_IMPORTED_MODULE_8__format_js__["d" /* getOnTypeFormattingEdits */])(model, position, ch, {
            tabSize: modelOpts.tabSize,
            insertSpaces: modelOpts.insertSpaces
        }).then(function (edits) {
            return _this.workerService.computeMoreMinimalEdits(model.uri, edits);
        }).then(function (edits) {
            unbind.dispose();
            if (canceled || Object(__WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(edits)) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_9__formattingEdit_js__["a" /* FormattingEdit */].execute(_this.editor, edits);
            alertFormattingEdits(edits);
        }, function (err) {
            unbind.dispose();
            throw err;
        });
    };
    FormatOnType.prototype.getId = function () {
        return FormatOnType.ID;
    };
    FormatOnType.prototype.dispose = function () {
        this.callOnDispose = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this.callOnDispose);
        this.callOnModel = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this.callOnModel);
    };
    FormatOnType.ID = 'editor.contrib.autoFormat';
    FormatOnType = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_12__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */])
    ], FormatOnType);
    return FormatOnType;
}());
var FormatOnPaste = /** @class */ (function () {
    function FormatOnPaste(editor, workerService) {
        var _this = this;
        this.editor = editor;
        this.workerService = workerService;
        this.callOnDispose = [];
        this.callOnModel = [];
        this.callOnDispose.push(editor.onDidChangeConfiguration(function () { return _this.update(); }));
        this.callOnDispose.push(editor.onDidChangeModel(function () { return _this.update(); }));
        this.callOnDispose.push(editor.onDidChangeModelLanguage(function () { return _this.update(); }));
        this.callOnDispose.push(__WEBPACK_IMPORTED_MODULE_7__common_modes_js__["i" /* DocumentRangeFormattingEditProviderRegistry */].onDidChange(this.update, this));
    }
    FormatOnPaste.prototype.update = function () {
        var _this = this;
        // clean up
        this.callOnModel = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this.callOnModel);
        // we are disabled
        if (!this.editor.getConfiguration().contribInfo.formatOnPaste) {
            return;
        }
        // no model
        if (!this.editor.getModel()) {
            return;
        }
        var model = this.editor.getModel();
        // no support
        var support = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["i" /* DocumentRangeFormattingEditProviderRegistry */].ordered(model)[0];
        if (!support || !support.provideDocumentRangeFormattingEdits) {
            return;
        }
        this.callOnModel.push(this.editor.onDidPaste(function (range) {
            _this.trigger(range);
        }));
    };
    FormatOnPaste.prototype.trigger = function (range) {
        var _this = this;
        if (this.editor.getSelections().length > 1) {
            return;
        }
        var model = this.editor.getModel();
        var _a = model.getOptions(), tabSize = _a.tabSize, insertSpaces = _a.insertSpaces;
        var state = new __WEBPACK_IMPORTED_MODULE_16__browser_core_editorState_js__["a" /* EditorState */](this.editor, 1 /* Value */ | 4 /* Position */);
        Object(__WEBPACK_IMPORTED_MODULE_8__format_js__["c" /* getDocumentRangeFormattingEdits */])(model, range, { tabSize: tabSize, insertSpaces: insertSpaces }).then(function (edits) {
            return _this.workerService.computeMoreMinimalEdits(model.uri, edits);
        }).then(function (edits) {
            if (!state.validate(_this.editor) || Object(__WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(edits)) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_9__formattingEdit_js__["a" /* FormattingEdit */].execute(_this.editor, edits);
            alertFormattingEdits(edits);
        });
    };
    FormatOnPaste.prototype.getId = function () {
        return FormatOnPaste.ID;
    };
    FormatOnPaste.prototype.dispose = function () {
        this.callOnDispose = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this.callOnDispose);
        this.callOnModel = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this.callOnModel);
    };
    FormatOnPaste.ID = 'editor.contrib.formatOnPaste';
    FormatOnPaste = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_12__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */])
    ], FormatOnPaste);
    return FormatOnPaste;
}());
var AbstractFormatAction = /** @class */ (function (_super) {
    __extends(AbstractFormatAction, _super);
    function AbstractFormatAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractFormatAction.prototype.run = function (accessor, editor) {
        var _this = this;
        var workerService = accessor.get(__WEBPACK_IMPORTED_MODULE_12__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */]);
        var notificationService = accessor.get(__WEBPACK_IMPORTED_MODULE_18__platform_notification_common_notification_js__["a" /* INotificationService */]);
        var formattingPromise = this._getFormattingEdits(editor);
        if (!formattingPromise) {
            return __WEBPACK_IMPORTED_MODULE_4__base_common_winjs_base_js__["b" /* TPromise */].as(void 0);
        }
        // Capture the state of the editor
        var state = new __WEBPACK_IMPORTED_MODULE_16__browser_core_editorState_js__["a" /* EditorState */](editor, 1 /* Value */ | 4 /* Position */);
        // Receive formatted value from worker
        return formattingPromise.then(function (edits) { return workerService.computeMoreMinimalEdits(editor.getModel().uri, edits); }).then(function (edits) {
            if (!state.validate(editor) || Object(__WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(edits)) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_9__formattingEdit_js__["a" /* FormattingEdit */].execute(editor, edits);
            alertFormattingEdits(edits);
            editor.focus();
        }, function (err) {
            if (err instanceof Error && err.name === __WEBPACK_IMPORTED_MODULE_8__format_js__["a" /* NoProviderError */].Name) {
                _this._notifyNoProviderError(notificationService, editor.getModel().getLanguageIdentifier().language);
            }
            else {
                throw err;
            }
        });
    };
    AbstractFormatAction.prototype._notifyNoProviderError = function (notificationService, language) {
        notificationService.info(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('no.provider', "There is no formatter for '{0}'-files installed.", language));
    };
    return AbstractFormatAction;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));

var FormatDocumentAction = /** @class */ (function (_super) {
    __extends(FormatDocumentAction, _super);
    function FormatDocumentAction() {
        return _super.call(this, {
            id: 'editor.action.formatDocument',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('formatDocument.label', "Format Document"),
            alias: 'Format Document',
            precondition: __WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 512 /* Alt */ | 36 /* KEY_F */,
                // secondary: [KeyChord(KeyMod.CtrlCmd | KeyCode.KEY_K, KeyMod.CtrlCmd | KeyCode.KEY_D)],
                linux: { primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 39 /* KEY_I */ },
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                when: __WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDocumentFormattingProvider,
                group: '1_modification',
                order: 1.3
            }
        }) || this;
    }
    FormatDocumentAction.prototype._getFormattingEdits = function (editor) {
        var model = editor.getModel();
        var _a = model.getOptions(), tabSize = _a.tabSize, insertSpaces = _a.insertSpaces;
        return Object(__WEBPACK_IMPORTED_MODULE_8__format_js__["b" /* getDocumentFormattingEdits */])(model, { tabSize: tabSize, insertSpaces: insertSpaces });
    };
    FormatDocumentAction.prototype._notifyNoProviderError = function (notificationService, language) {
        notificationService.info(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('no.documentprovider', "There is no document formatter for '{0}'-files installed.", language));
    };
    return FormatDocumentAction;
}(AbstractFormatAction));

var FormatSelectionAction = /** @class */ (function (_super) {
    __extends(FormatSelectionAction, _super);
    function FormatSelectionAction() {
        return _super.call(this, {
            id: 'editor.action.formatSelection',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('formatSelection.label', "Format Selection"),
            alias: 'Format Code',
            precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, __WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasNonEmptySelection),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 36 /* KEY_F */),
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                when: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDocumentSelectionFormattingProvider, __WEBPACK_IMPORTED_MODULE_17__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasNonEmptySelection),
                group: '1_modification',
                order: 1.31
            }
        }) || this;
    }
    FormatSelectionAction.prototype._getFormattingEdits = function (editor) {
        var model = editor.getModel();
        var _a = model.getOptions(), tabSize = _a.tabSize, insertSpaces = _a.insertSpaces;
        return Object(__WEBPACK_IMPORTED_MODULE_8__format_js__["c" /* getDocumentRangeFormattingEdits */])(model, editor.getSelection(), { tabSize: tabSize, insertSpaces: insertSpaces });
    };
    FormatSelectionAction.prototype._notifyNoProviderError = function (notificationService, language) {
        notificationService.info(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('no.selectionprovider', "There is no selection formatter for '{0}'-files installed.", language));
    };
    return FormatSelectionAction;
}(AbstractFormatAction));

Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(FormatOnType);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(FormatOnPaste);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(FormatDocumentAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(FormatSelectionAction);
// this is the old format action that does both (format document OR format selection)
// and we keep it here such that existing keybinding configurations etc will still work
__WEBPACK_IMPORTED_MODULE_10__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand('editor.action.format', function (accessor) {
    var editor = accessor.get(__WEBPACK_IMPORTED_MODULE_11__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]).getFocusedCodeEditor();
    if (editor) {
        return new /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super.call(this, {}) || this;
            }
            class_1.prototype._getFormattingEdits = function (editor) {
                var model = editor.getModel();
                var editorSelection = editor.getSelection();
                var _a = model.getOptions(), tabSize = _a.tabSize, insertSpaces = _a.insertSpaces;
                return editorSelection.isEmpty()
                    ? Object(__WEBPACK_IMPORTED_MODULE_8__format_js__["b" /* getDocumentFormattingEdits */])(model, { tabSize: tabSize, insertSpaces: insertSpaces })
                    : Object(__WEBPACK_IMPORTED_MODULE_8__format_js__["c" /* getDocumentRangeFormattingEdits */])(model, editorSelection, { tabSize: tabSize, insertSpaces: insertSpaces });
            };
            return class_1;
        }(AbstractFormatAction))().run(accessor, editor);
    }
    return undefined;
});


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ctxReferenceSearchVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReferencesController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_configuration_common_configuration_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_storage_common_storage_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__referencesWidget_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_notification_common_notification_js__ = __webpack_require__(34);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};












var ctxReferenceSearchVisible = new __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('referenceSearchVisible', false);
var ReferencesController = /** @class */ (function () {
    function ReferencesController(_defaultTreeKeyboardSupport, editor, contextKeyService, _editorService, _notificationService, _instantiationService, _storageService, _configurationService) {
        this._defaultTreeKeyboardSupport = _defaultTreeKeyboardSupport;
        this._editorService = _editorService;
        this._notificationService = _notificationService;
        this._instantiationService = _instantiationService;
        this._storageService = _storageService;
        this._configurationService = _configurationService;
        this._requestIdPool = 0;
        this._disposables = [];
        this._ignoreModelChangeEvent = false;
        this._editor = editor;
        this._referenceSearchVisible = ctxReferenceSearchVisible.bindTo(contextKeyService);
    }
    ReferencesController.get = function (editor) {
        return editor.getContribution(ReferencesController.ID);
    };
    ReferencesController.prototype.getId = function () {
        return ReferencesController.ID;
    };
    ReferencesController.prototype.dispose = function () {
        this._referenceSearchVisible.reset();
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._widget);
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._model);
        this._widget = null;
        this._model = null;
        this._editor = null;
    };
    ReferencesController.prototype.toggleWidget = function (range, modelPromise, options) {
        var _this = this;
        // close current widget and return early is position didn't change
        var widgetPosition;
        if (this._widget) {
            widgetPosition = this._widget.position;
        }
        this.closeWidget();
        if (!!widgetPosition && range.containsPosition(widgetPosition)) {
            return null;
        }
        this._referenceSearchVisible.set(true);
        // close the widget on model/mode changes
        this._disposables.push(this._editor.onDidChangeModelLanguage(function () { _this.closeWidget(); }));
        this._disposables.push(this._editor.onDidChangeModel(function () {
            if (!_this._ignoreModelChangeEvent) {
                _this.closeWidget();
            }
        }));
        var storageKey = 'peekViewLayout';
        var data = JSON.parse(this._storageService.get(storageKey, undefined, '{}'));
        this._widget = this._instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_8__referencesWidget_js__["a" /* ReferenceWidget */], this._editor, this._defaultTreeKeyboardSupport, data);
        this._widget.setTitle(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('labelLoading', "Loading..."));
        this._widget.show(range);
        this._disposables.push(this._widget.onDidClose(function () {
            modelPromise.cancel();
            _this._storageService.store(storageKey, JSON.stringify(_this._widget.layoutData));
            _this._widget = null;
            _this.closeWidget();
        }));
        this._disposables.push(this._widget.onDidSelectReference(function (event) {
            var element = event.element, kind = event.kind;
            switch (kind) {
                case 'open':
                    if (event.source === 'editor'
                        && _this._configurationService.getValue('editor.stablePeek')) {
                        // when stable peek is configured we don't close
                        // the peek window on selecting the editor
                        break;
                    }
                case 'side':
                    _this.openReference(element, kind === 'side');
                    break;
                case 'goto':
                    if (options.onGoto) {
                        options.onGoto(element);
                    }
                    else {
                        _this._gotoReference(element);
                    }
                    break;
            }
        }));
        var requestId = ++this._requestIdPool;
        modelPromise.then(function (model) {
            // still current request? widget still open?
            if (requestId !== _this._requestIdPool || !_this._widget) {
                return undefined;
            }
            if (_this._model) {
                _this._model.dispose();
            }
            _this._model = model;
            // show widget
            return _this._widget.setModel(_this._model).then(function () {
                if (_this._widget) { // might have been closed
                    // set title
                    _this._widget.setMetaTitle(options.getMetaTitle(_this._model));
                    // set 'best' selection
                    var uri = _this._editor.getModel().uri;
                    var pos = new __WEBPACK_IMPORTED_MODULE_10__common_core_position_js__["a" /* Position */](range.startLineNumber, range.startColumn);
                    var selection = _this._model.nearestReference(uri, pos);
                    if (selection) {
                        return _this._widget.setSelection(selection);
                    }
                }
                return undefined;
            });
        }, function (error) {
            _this._notificationService.error(error);
        });
    };
    ReferencesController.prototype.goToNextOrPreviousReference = function (fwd) {
        return __awaiter(this, void 0, void 0, function () {
            var source, target, editorFocus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._model) return [3 /*break*/, 3];
                        source = this._model.nearestReference(this._editor.getModel().uri, this._widget.position);
                        target = this._model.nextOrPreviousReference(source, fwd);
                        editorFocus = this._editor.hasTextFocus();
                        return [4 /*yield*/, this._widget.setSelection(target)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._gotoReference(target)];
                    case 2:
                        _a.sent();
                        if (editorFocus) {
                            this._editor.focus();
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferencesController.prototype.closeWidget = function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._widget);
        this._widget = null;
        this._referenceSearchVisible.reset();
        this._disposables = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._model);
        this._model = null;
        this._editor.focus();
        this._requestIdPool += 1; // Cancel pending requests
    };
    ReferencesController.prototype._gotoReference = function (ref) {
        var _this = this;
        this._widget.hide();
        this._ignoreModelChangeEvent = true;
        var range = __WEBPACK_IMPORTED_MODULE_9__common_core_range_js__["a" /* Range */].lift(ref.range).collapseToStart();
        return this._editorService.openCodeEditor({
            resource: ref.uri,
            options: { selection: range }
        }, this._editor).then(function (openedEditor) {
            _this._ignoreModelChangeEvent = false;
            if (!openedEditor || openedEditor !== _this._editor) {
                // TODO@Alex TODO@Joh
                // when opening the current reference we might end up
                // in a different editor instance. that means we also have
                // a different instance of this reference search controller
                // and cannot hold onto the widget (which likely doesn't
                // exist). Instead of bailing out we should find the
                // 'sister' action and pass our current model on to it.
                _this.closeWidget();
                return;
            }
            _this._widget.show(range);
            _this._widget.focus();
        }, function (err) {
            _this._ignoreModelChangeEvent = false;
            Object(__WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */])(err);
        });
    };
    ReferencesController.prototype.openReference = function (ref, sideBySide) {
        var uri = ref.uri, range = ref.range;
        this._editorService.openCodeEditor({
            resource: uri,
            options: { selection: range }
        }, this._editor, sideBySide);
        // clear stage
        if (!sideBySide) {
            this.closeWidget();
        }
    };
    ReferencesController.ID = 'editor.contrib.referencesController';
    ReferencesController = __decorate([
        __param(2, __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_3__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_11__platform_notification_common_notification_js__["a" /* INotificationService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_4__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_7__platform_storage_common_storage_js__["a" /* IStorageService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_6__platform_configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], ReferencesController);
    return ReferencesController;
}());



/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightedLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__octiconLabel_octiconLabel_js__ = __webpack_require__(383);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var HighlightedLabel = /** @class */ (function () {
    function HighlightedLabel(container) {
        this.domNode = document.createElement('span');
        this.domNode.className = 'monaco-highlighted-label';
        this.didEverRender = false;
        container.appendChild(this.domNode);
    }
    Object.defineProperty(HighlightedLabel.prototype, "element", {
        get: function () {
            return this.domNode;
        },
        enumerable: true,
        configurable: true
    });
    HighlightedLabel.prototype.set = function (text, highlights, title, escapeNewLines) {
        if (highlights === void 0) { highlights = []; }
        if (title === void 0) { title = ''; }
        if (!text) {
            text = '';
        }
        if (escapeNewLines) {
            // adjusts highlights inplace
            text = HighlightedLabel.escapeNewLines(text, highlights);
        }
        if (this.didEverRender && this.text === text && this.title === title && __WEBPACK_IMPORTED_MODULE_1__common_objects_js__["e" /* equals */](this.highlights, highlights)) {
            return;
        }
        if (!Array.isArray(highlights)) {
            highlights = [];
        }
        this.text = text;
        this.title = title;
        this.highlights = highlights;
        this.render();
    };
    HighlightedLabel.prototype.render = function () {
        __WEBPACK_IMPORTED_MODULE_0__dom_js__["l" /* clearNode */](this.domNode);
        var htmlContent = [], highlight, pos = 0;
        for (var i = 0; i < this.highlights.length; i++) {
            highlight = this.highlights[i];
            if (highlight.end === highlight.start) {
                continue;
            }
            if (pos < highlight.start) {
                htmlContent.push('<span>');
                htmlContent.push(Object(__WEBPACK_IMPORTED_MODULE_2__octiconLabel_octiconLabel_js__["a" /* renderOcticons */])(this.text.substring(pos, highlight.start)));
                htmlContent.push('</span>');
                pos = highlight.end;
            }
            htmlContent.push('<span class="highlight">');
            htmlContent.push(Object(__WEBPACK_IMPORTED_MODULE_2__octiconLabel_octiconLabel_js__["a" /* renderOcticons */])(this.text.substring(highlight.start, highlight.end)));
            htmlContent.push('</span>');
            pos = highlight.end;
        }
        if (pos < this.text.length) {
            htmlContent.push('<span>');
            htmlContent.push(Object(__WEBPACK_IMPORTED_MODULE_2__octiconLabel_octiconLabel_js__["a" /* renderOcticons */])(this.text.substring(pos)));
            htmlContent.push('</span>');
        }
        this.domNode.innerHTML = htmlContent.join('');
        this.domNode.title = this.title;
        this.didEverRender = true;
    };
    HighlightedLabel.prototype.dispose = function () {
        this.text = null;
        this.highlights = null;
    };
    HighlightedLabel.escapeNewLines = function (text, highlights) {
        var total = 0;
        var extra = 0;
        return text.replace(/\r\n|\r|\n/, function (match, offset) {
            extra = match === '\r\n' ? -1 : 0;
            offset += total;
            for (var _i = 0, highlights_1 = highlights; _i < highlights_1.length; _i++) {
                var highlight = highlights_1[_i];
                if (highlight.end <= offset) {
                    continue;
                }
                if (highlight.start >= offset) {
                    highlight.start += extra;
                }
                if (highlight.end >= offset) {
                    highlight.end += extra;
                }
            }
            total += extra;
            return '\u23CE';
        });
    };
    return HighlightedLabel;
}());



/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IWorkspaceContextService; });
/* unused harmony export IWorkspace */
/* unused harmony export IWorkspaceFolder */
/* unused harmony export Workspace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WorkspaceFolder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_map_js__ = __webpack_require__(66);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var IWorkspaceContextService = Object(__WEBPACK_IMPORTED_MODULE_2__instantiation_common_instantiation_js__["c" /* createDecorator */])('contextService');
var IWorkspace;
(function (IWorkspace) {
    function isIWorkspace(thing) {
        return thing && typeof thing === 'object'
            && typeof thing.id === 'string'
            && typeof thing.name === 'string'
            && Array.isArray(thing.folders);
    }
    IWorkspace.isIWorkspace = isIWorkspace;
})(IWorkspace || (IWorkspace = {}));
var IWorkspaceFolder;
(function (IWorkspaceFolder) {
    function isIWorkspaceFolder(thing) {
        return thing && typeof thing === 'object'
            && __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__["a" /* default */].isUri(thing.uri)
            && typeof thing.name === 'string'
            && typeof thing.toResource === 'function';
    }
    IWorkspaceFolder.isIWorkspaceFolder = isIWorkspaceFolder;
})(IWorkspaceFolder || (IWorkspaceFolder = {}));
var Workspace = /** @class */ (function () {
    function Workspace(_id, _name, folders, _configuration, _ctime) {
        if (_name === void 0) { _name = ''; }
        if (folders === void 0) { folders = []; }
        if (_configuration === void 0) { _configuration = null; }
        this._id = _id;
        this._name = _name;
        this._configuration = _configuration;
        this._ctime = _ctime;
        this._foldersMap = __WEBPACK_IMPORTED_MODULE_3__base_common_map_js__["c" /* TernarySearchTree */].forPaths();
        this.folders = folders;
    }
    Object.defineProperty(Workspace.prototype, "folders", {
        get: function () {
            return this._folders;
        },
        set: function (folders) {
            this._folders = folders;
            this.updateFoldersMap();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Workspace.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Workspace.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (name) {
            this._name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Workspace.prototype, "configuration", {
        get: function () {
            return this._configuration;
        },
        set: function (configuration) {
            this._configuration = configuration;
        },
        enumerable: true,
        configurable: true
    });
    Workspace.prototype.getFolder = function (resource) {
        if (!resource) {
            return null;
        }
        return this._foldersMap.findSubstr(resource.toString());
    };
    Workspace.prototype.updateFoldersMap = function () {
        this._foldersMap = __WEBPACK_IMPORTED_MODULE_3__base_common_map_js__["c" /* TernarySearchTree */].forPaths();
        for (var _i = 0, _a = this.folders; _i < _a.length; _i++) {
            var folder = _a[_i];
            this._foldersMap.set(folder.uri.toString(), folder);
        }
    };
    Workspace.prototype.toJSON = function () {
        return { id: this.id, folders: this.folders, name: this.name, configuration: this.configuration };
    };
    return Workspace;
}());

var WorkspaceFolder = /** @class */ (function () {
    function WorkspaceFolder(data, raw) {
        this.raw = raw;
        this.uri = data.uri;
        this.index = data.index;
        this.name = data.name;
    }
    WorkspaceFolder.prototype.toResource = function (relativePath) {
        return this.uri.with({ path: __WEBPACK_IMPORTED_MODULE_1__base_common_paths_js__["f" /* join */](this.uri.path, relativePath) });
    };
    WorkspaceFolder.prototype.toJSON = function () {
        return { uri: this.uri, name: this.name, index: this.index };
    };
    return WorkspaceFolder;
}());



/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmbeddedCodeEditorWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__codeEditorWidget_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_notification_common_notification_js__ = __webpack_require__(34);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};








var EmbeddedCodeEditorWidget = /** @class */ (function (_super) {
    __extends(EmbeddedCodeEditorWidget, _super);
    function EmbeddedCodeEditorWidget(domElement, options, parentEditor, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService) {
        var _this = _super.call(this, domElement, parentEditor.getRawConfiguration(), {}, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService) || this;
        _this._parentEditor = parentEditor;
        _this._overwriteOptions = options;
        // Overwrite parent's options
        _super.prototype.updateOptions.call(_this, _this._overwriteOptions);
        _this._register(parentEditor.onDidChangeConfiguration(function (e) { return _this._onParentConfigurationChanged(e); }));
        return _this;
    }
    EmbeddedCodeEditorWidget.prototype.getParentEditor = function () {
        return this._parentEditor;
    };
    EmbeddedCodeEditorWidget.prototype._onParentConfigurationChanged = function (e) {
        _super.prototype.updateOptions.call(this, this._parentEditor.getRawConfiguration());
        _super.prototype.updateOptions.call(this, this._overwriteOptions);
    };
    EmbeddedCodeEditorWidget.prototype.updateOptions = function (newOptions) {
        __WEBPACK_IMPORTED_MODULE_0__base_common_objects_js__["g" /* mixin */](this._overwriteOptions, newOptions, true);
        _super.prototype.updateOptions.call(this, this._overwriteOptions);
    };
    EmbeddedCodeEditorWidget = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_1__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_4__services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_2__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(8, __WEBPACK_IMPORTED_MODULE_7__platform_notification_common_notification_js__["a" /* INotificationService */])
    ], EmbeddedCodeEditorWidget);
    return EmbeddedCodeEditorWidget;
}(__WEBPACK_IMPORTED_MODULE_5__codeEditorWidget_js__["a" /* CodeEditorWidget */]));



/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PrefixSumIndexOfResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrefixSumComputer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PrefixSumComputerWithCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_uint_js__ = __webpack_require__(98);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var PrefixSumIndexOfResult = /** @class */ (function () {
    function PrefixSumIndexOfResult(index, remainder) {
        this.index = index;
        this.remainder = remainder;
    }
    return PrefixSumIndexOfResult;
}());

var PrefixSumComputer = /** @class */ (function () {
    function PrefixSumComputer(values) {
        this.values = values;
        this.prefixSum = new Uint32Array(values.length);
        this.prefixSumValidIndex = new Int32Array(1);
        this.prefixSumValidIndex[0] = -1;
    }
    PrefixSumComputer.prototype.getCount = function () {
        return this.values.length;
    };
    PrefixSumComputer.prototype.insertValues = function (insertIndex, insertValues) {
        insertIndex = Object(__WEBPACK_IMPORTED_MODULE_0__core_uint_js__["b" /* toUint32 */])(insertIndex);
        var oldValues = this.values;
        var oldPrefixSum = this.prefixSum;
        var insertValuesLen = insertValues.length;
        if (insertValuesLen === 0) {
            return false;
        }
        this.values = new Uint32Array(oldValues.length + insertValuesLen);
        this.values.set(oldValues.subarray(0, insertIndex), 0);
        this.values.set(oldValues.subarray(insertIndex), insertIndex + insertValuesLen);
        this.values.set(insertValues, insertIndex);
        if (insertIndex - 1 < this.prefixSumValidIndex[0]) {
            this.prefixSumValidIndex[0] = insertIndex - 1;
        }
        this.prefixSum = new Uint32Array(this.values.length);
        if (this.prefixSumValidIndex[0] >= 0) {
            this.prefixSum.set(oldPrefixSum.subarray(0, this.prefixSumValidIndex[0] + 1));
        }
        return true;
    };
    PrefixSumComputer.prototype.changeValue = function (index, value) {
        index = Object(__WEBPACK_IMPORTED_MODULE_0__core_uint_js__["b" /* toUint32 */])(index);
        value = Object(__WEBPACK_IMPORTED_MODULE_0__core_uint_js__["b" /* toUint32 */])(value);
        if (this.values[index] === value) {
            return false;
        }
        this.values[index] = value;
        if (index - 1 < this.prefixSumValidIndex[0]) {
            this.prefixSumValidIndex[0] = index - 1;
        }
        return true;
    };
    PrefixSumComputer.prototype.removeValues = function (startIndex, cnt) {
        startIndex = Object(__WEBPACK_IMPORTED_MODULE_0__core_uint_js__["b" /* toUint32 */])(startIndex);
        cnt = Object(__WEBPACK_IMPORTED_MODULE_0__core_uint_js__["b" /* toUint32 */])(cnt);
        var oldValues = this.values;
        var oldPrefixSum = this.prefixSum;
        if (startIndex >= oldValues.length) {
            return false;
        }
        var maxCnt = oldValues.length - startIndex;
        if (cnt >= maxCnt) {
            cnt = maxCnt;
        }
        if (cnt === 0) {
            return false;
        }
        this.values = new Uint32Array(oldValues.length - cnt);
        this.values.set(oldValues.subarray(0, startIndex), 0);
        this.values.set(oldValues.subarray(startIndex + cnt), startIndex);
        this.prefixSum = new Uint32Array(this.values.length);
        if (startIndex - 1 < this.prefixSumValidIndex[0]) {
            this.prefixSumValidIndex[0] = startIndex - 1;
        }
        if (this.prefixSumValidIndex[0] >= 0) {
            this.prefixSum.set(oldPrefixSum.subarray(0, this.prefixSumValidIndex[0] + 1));
        }
        return true;
    };
    PrefixSumComputer.prototype.getTotalValue = function () {
        if (this.values.length === 0) {
            return 0;
        }
        return this._getAccumulatedValue(this.values.length - 1);
    };
    PrefixSumComputer.prototype.getAccumulatedValue = function (index) {
        if (index < 0) {
            return 0;
        }
        index = Object(__WEBPACK_IMPORTED_MODULE_0__core_uint_js__["b" /* toUint32 */])(index);
        return this._getAccumulatedValue(index);
    };
    PrefixSumComputer.prototype._getAccumulatedValue = function (index) {
        if (index <= this.prefixSumValidIndex[0]) {
            return this.prefixSum[index];
        }
        var startIndex = this.prefixSumValidIndex[0] + 1;
        if (startIndex === 0) {
            this.prefixSum[0] = this.values[0];
            startIndex++;
        }
        if (index >= this.values.length) {
            index = this.values.length - 1;
        }
        for (var i = startIndex; i <= index; i++) {
            this.prefixSum[i] = this.prefixSum[i - 1] + this.values[i];
        }
        this.prefixSumValidIndex[0] = Math.max(this.prefixSumValidIndex[0], index);
        return this.prefixSum[index];
    };
    PrefixSumComputer.prototype.getIndexOf = function (accumulatedValue) {
        accumulatedValue = Math.floor(accumulatedValue); //@perf
        // Compute all sums (to get a fully valid prefixSum)
        this.getTotalValue();
        var low = 0;
        var high = this.values.length - 1;
        var mid;
        var midStop;
        var midStart;
        while (low <= high) {
            mid = low + ((high - low) / 2) | 0;
            midStop = this.prefixSum[mid];
            midStart = midStop - this.values[mid];
            if (accumulatedValue < midStart) {
                high = mid - 1;
            }
            else if (accumulatedValue >= midStop) {
                low = mid + 1;
            }
            else {
                break;
            }
        }
        return new PrefixSumIndexOfResult(mid, accumulatedValue - midStart);
    };
    return PrefixSumComputer;
}());

var PrefixSumComputerWithCache = /** @class */ (function () {
    function PrefixSumComputerWithCache(values) {
        this._cacheAccumulatedValueStart = 0;
        this._cache = null;
        this._actual = new PrefixSumComputer(values);
        this._bustCache();
    }
    PrefixSumComputerWithCache.prototype._bustCache = function () {
        this._cacheAccumulatedValueStart = 0;
        this._cache = null;
    };
    PrefixSumComputerWithCache.prototype.insertValues = function (insertIndex, insertValues) {
        if (this._actual.insertValues(insertIndex, insertValues)) {
            this._bustCache();
        }
    };
    PrefixSumComputerWithCache.prototype.changeValue = function (index, value) {
        if (this._actual.changeValue(index, value)) {
            this._bustCache();
        }
    };
    PrefixSumComputerWithCache.prototype.removeValues = function (startIndex, cnt) {
        if (this._actual.removeValues(startIndex, cnt)) {
            this._bustCache();
        }
    };
    PrefixSumComputerWithCache.prototype.getTotalValue = function () {
        return this._actual.getTotalValue();
    };
    PrefixSumComputerWithCache.prototype.getAccumulatedValue = function (index) {
        return this._actual.getAccumulatedValue(index);
    };
    PrefixSumComputerWithCache.prototype.getIndexOf = function (accumulatedValue) {
        accumulatedValue = Math.floor(accumulatedValue); //@perf
        if (this._cache !== null) {
            var cacheIndex = accumulatedValue - this._cacheAccumulatedValueStart;
            if (cacheIndex >= 0 && cacheIndex < this._cache.length) {
                // Cache hit!
                return this._cache[cacheIndex];
            }
        }
        // Cache miss!
        return this._actual.getIndexOf(accumulatedValue);
    };
    /**
     * Gives a hint that a lot of requests are about to come in for these accumulated values.
     */
    PrefixSumComputerWithCache.prototype.warmUpCache = function (accumulatedValueStart, accumulatedValueEnd) {
        var newCache = [];
        for (var accumulatedValue = accumulatedValueStart; accumulatedValue <= accumulatedValueEnd; accumulatedValue++) {
            newCache[accumulatedValue - accumulatedValueStart] = this.getIndexOf(accumulatedValue);
        }
        this._cache = newCache;
        this._cacheAccumulatedValueStart = accumulatedValueStart;
    };
    return PrefixSumComputerWithCache;
}());



/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MinimapTokensColorTracker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MinimapCharRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_rgba_js__ = __webpack_require__(393);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var MinimapTokensColorTracker = /** @class */ (function () {
    function MinimapTokensColorTracker() {
        var _this = this;
        this._onDidChange = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.onDidChange = this._onDidChange.event;
        this._updateColorMap();
        __WEBPACK_IMPORTED_MODULE_0__modes_js__["y" /* TokenizationRegistry */].onDidChange(function (e) {
            if (e.changedColorMap) {
                _this._updateColorMap();
            }
        });
    }
    MinimapTokensColorTracker.getInstance = function () {
        if (!this._INSTANCE) {
            this._INSTANCE = new MinimapTokensColorTracker();
        }
        return this._INSTANCE;
    };
    MinimapTokensColorTracker.prototype._updateColorMap = function () {
        var colorMap = __WEBPACK_IMPORTED_MODULE_0__modes_js__["y" /* TokenizationRegistry */].getColorMap();
        if (!colorMap) {
            this._colors = [null];
            this._backgroundIsLight = true;
            return;
        }
        this._colors = [null];
        for (var colorId = 1; colorId < colorMap.length; colorId++) {
            var source = colorMap[colorId].rgba;
            // Use a VM friendly data-type
            this._colors[colorId] = new __WEBPACK_IMPORTED_MODULE_2__core_rgba_js__["a" /* RGBA8 */](source.r, source.g, source.b, Math.round(source.a * 255));
        }
        var backgroundLuminosity = colorMap[2 /* DefaultBackground */].getRelativeLuminance();
        this._backgroundIsLight = (backgroundLuminosity >= 0.5);
        this._onDidChange.fire(void 0);
    };
    MinimapTokensColorTracker.prototype.getColor = function (colorId) {
        if (colorId < 1 || colorId >= this._colors.length) {
            // background color (basically invisible)
            colorId = 2 /* DefaultBackground */;
        }
        return this._colors[colorId];
    };
    MinimapTokensColorTracker.prototype.backgroundIsLight = function () {
        return this._backgroundIsLight;
    };
    MinimapTokensColorTracker._INSTANCE = null;
    return MinimapTokensColorTracker;
}());

var MinimapCharRenderer = /** @class */ (function () {
    function MinimapCharRenderer(x2CharData, x1CharData) {
        var x2ExpectedLen = 4 /* x2_CHAR_HEIGHT */ * 2 /* x2_CHAR_WIDTH */ * 95 /* CHAR_COUNT */;
        if (x2CharData.length !== x2ExpectedLen) {
            throw new Error('Invalid x2CharData');
        }
        var x1ExpectedLen = 2 /* x1_CHAR_HEIGHT */ * 1 /* x1_CHAR_WIDTH */ * 95 /* CHAR_COUNT */;
        if (x1CharData.length !== x1ExpectedLen) {
            throw new Error('Invalid x1CharData');
        }
        this.x2charData = x2CharData;
        this.x1charData = x1CharData;
        this.x2charDataLight = MinimapCharRenderer.soften(x2CharData, 12 / 15);
        this.x1charDataLight = MinimapCharRenderer.soften(x1CharData, 50 / 60);
    }
    MinimapCharRenderer.soften = function (input, ratio) {
        var result = new Uint8ClampedArray(input.length);
        for (var i = 0, len = input.length; i < len; i++) {
            result[i] = input[i] * ratio;
        }
        return result;
    };
    MinimapCharRenderer._getChIndex = function (chCode) {
        chCode -= 32 /* START_CH_CODE */;
        if (chCode < 0) {
            chCode += 95 /* CHAR_COUNT */;
        }
        return (chCode % 95 /* CHAR_COUNT */);
    };
    MinimapCharRenderer.prototype.x2RenderChar = function (target, dx, dy, chCode, color, backgroundColor, useLighterFont) {
        if (dx + 2 /* x2_CHAR_WIDTH */ > target.width || dy + 4 /* x2_CHAR_HEIGHT */ > target.height) {
            console.warn('bad render request outside image data');
            return;
        }
        var x2CharData = useLighterFont ? this.x2charDataLight : this.x2charData;
        var chIndex = MinimapCharRenderer._getChIndex(chCode);
        var outWidth = target.width * 4 /* RGBA_CHANNELS_CNT */;
        var backgroundR = backgroundColor.r;
        var backgroundG = backgroundColor.g;
        var backgroundB = backgroundColor.b;
        var deltaR = color.r - backgroundR;
        var deltaG = color.g - backgroundG;
        var deltaB = color.b - backgroundB;
        var dest = target.data;
        var sourceOffset = chIndex * 4 /* x2_CHAR_HEIGHT */ * 2 /* x2_CHAR_WIDTH */;
        var destOffset = dy * outWidth + dx * 4 /* RGBA_CHANNELS_CNT */;
        {
            var c = x2CharData[sourceOffset] / 255;
            dest[destOffset + 0] = backgroundR + deltaR * c;
            dest[destOffset + 1] = backgroundG + deltaG * c;
            dest[destOffset + 2] = backgroundB + deltaB * c;
        }
        {
            var c = x2CharData[sourceOffset + 1] / 255;
            dest[destOffset + 4] = backgroundR + deltaR * c;
            dest[destOffset + 5] = backgroundG + deltaG * c;
            dest[destOffset + 6] = backgroundB + deltaB * c;
        }
        destOffset += outWidth;
        {
            var c = x2CharData[sourceOffset + 2] / 255;
            dest[destOffset + 0] = backgroundR + deltaR * c;
            dest[destOffset + 1] = backgroundG + deltaG * c;
            dest[destOffset + 2] = backgroundB + deltaB * c;
        }
        {
            var c = x2CharData[sourceOffset + 3] / 255;
            dest[destOffset + 4] = backgroundR + deltaR * c;
            dest[destOffset + 5] = backgroundG + deltaG * c;
            dest[destOffset + 6] = backgroundB + deltaB * c;
        }
        destOffset += outWidth;
        {
            var c = x2CharData[sourceOffset + 4] / 255;
            dest[destOffset + 0] = backgroundR + deltaR * c;
            dest[destOffset + 1] = backgroundG + deltaG * c;
            dest[destOffset + 2] = backgroundB + deltaB * c;
        }
        {
            var c = x2CharData[sourceOffset + 5] / 255;
            dest[destOffset + 4] = backgroundR + deltaR * c;
            dest[destOffset + 5] = backgroundG + deltaG * c;
            dest[destOffset + 6] = backgroundB + deltaB * c;
        }
        destOffset += outWidth;
        {
            var c = x2CharData[sourceOffset + 6] / 255;
            dest[destOffset + 0] = backgroundR + deltaR * c;
            dest[destOffset + 1] = backgroundG + deltaG * c;
            dest[destOffset + 2] = backgroundB + deltaB * c;
        }
        {
            var c = x2CharData[sourceOffset + 7] / 255;
            dest[destOffset + 4] = backgroundR + deltaR * c;
            dest[destOffset + 5] = backgroundG + deltaG * c;
            dest[destOffset + 6] = backgroundB + deltaB * c;
        }
    };
    MinimapCharRenderer.prototype.x1RenderChar = function (target, dx, dy, chCode, color, backgroundColor, useLighterFont) {
        if (dx + 1 /* x1_CHAR_WIDTH */ > target.width || dy + 2 /* x1_CHAR_HEIGHT */ > target.height) {
            console.warn('bad render request outside image data');
            return;
        }
        var x1CharData = useLighterFont ? this.x1charDataLight : this.x1charData;
        var chIndex = MinimapCharRenderer._getChIndex(chCode);
        var outWidth = target.width * 4 /* RGBA_CHANNELS_CNT */;
        var backgroundR = backgroundColor.r;
        var backgroundG = backgroundColor.g;
        var backgroundB = backgroundColor.b;
        var deltaR = color.r - backgroundR;
        var deltaG = color.g - backgroundG;
        var deltaB = color.b - backgroundB;
        var dest = target.data;
        var sourceOffset = chIndex * 2 /* x1_CHAR_HEIGHT */ * 1 /* x1_CHAR_WIDTH */;
        var destOffset = dy * outWidth + dx * 4 /* RGBA_CHANNELS_CNT */;
        {
            var c = x1CharData[sourceOffset] / 255;
            dest[destOffset + 0] = backgroundR + deltaR * c;
            dest[destOffset + 1] = backgroundG + deltaG * c;
            dest[destOffset + 2] = backgroundB + deltaB * c;
        }
        destOffset += outWidth;
        {
            var c = x1CharData[sourceOffset + 1] / 255;
            dest[destOffset + 0] = backgroundR + deltaR * c;
            dest[destOffset + 1] = backgroundG + deltaG * c;
            dest[destOffset + 2] = backgroundB + deltaB * c;
        }
    };
    MinimapCharRenderer.prototype.x2BlockRenderChar = function (target, dx, dy, color, backgroundColor, useLighterFont) {
        if (dx + 2 /* x2_CHAR_WIDTH */ > target.width || dy + 4 /* x2_CHAR_HEIGHT */ > target.height) {
            console.warn('bad render request outside image data');
            return;
        }
        var outWidth = target.width * 4 /* RGBA_CHANNELS_CNT */;
        var c = 0.5;
        var backgroundR = backgroundColor.r;
        var backgroundG = backgroundColor.g;
        var backgroundB = backgroundColor.b;
        var deltaR = color.r - backgroundR;
        var deltaG = color.g - backgroundG;
        var deltaB = color.b - backgroundB;
        var colorR = backgroundR + deltaR * c;
        var colorG = backgroundG + deltaG * c;
        var colorB = backgroundB + deltaB * c;
        var dest = target.data;
        var destOffset = dy * outWidth + dx * 4 /* RGBA_CHANNELS_CNT */;
        {
            dest[destOffset + 0] = colorR;
            dest[destOffset + 1] = colorG;
            dest[destOffset + 2] = colorB;
        }
        {
            dest[destOffset + 4] = colorR;
            dest[destOffset + 5] = colorG;
            dest[destOffset + 6] = colorB;
        }
        destOffset += outWidth;
        {
            dest[destOffset + 0] = colorR;
            dest[destOffset + 1] = colorG;
            dest[destOffset + 2] = colorB;
        }
        {
            dest[destOffset + 4] = colorR;
            dest[destOffset + 5] = colorG;
            dest[destOffset + 6] = colorB;
        }
        destOffset += outWidth;
        {
            dest[destOffset + 0] = colorR;
            dest[destOffset + 1] = colorG;
            dest[destOffset + 2] = colorB;
        }
        {
            dest[destOffset + 4] = colorR;
            dest[destOffset + 5] = colorG;
            dest[destOffset + 6] = colorB;
        }
        destOffset += outWidth;
        {
            dest[destOffset + 0] = colorR;
            dest[destOffset + 1] = colorG;
            dest[destOffset + 2] = colorB;
        }
        {
            dest[destOffset + 4] = colorR;
            dest[destOffset + 5] = colorG;
            dest[destOffset + 6] = colorB;
        }
    };
    MinimapCharRenderer.prototype.x1BlockRenderChar = function (target, dx, dy, color, backgroundColor, useLighterFont) {
        if (dx + 1 /* x1_CHAR_WIDTH */ > target.width || dy + 2 /* x1_CHAR_HEIGHT */ > target.height) {
            console.warn('bad render request outside image data');
            return;
        }
        var outWidth = target.width * 4 /* RGBA_CHANNELS_CNT */;
        var c = 0.5;
        var backgroundR = backgroundColor.r;
        var backgroundG = backgroundColor.g;
        var backgroundB = backgroundColor.b;
        var deltaR = color.r - backgroundR;
        var deltaG = color.g - backgroundG;
        var deltaB = color.b - backgroundB;
        var colorR = backgroundR + deltaR * c;
        var colorG = backgroundG + deltaG * c;
        var colorB = backgroundB + deltaB * c;
        var dest = target.data;
        var destOffset = dy * outWidth + dx * 4 /* RGBA_CHANNELS_CNT */;
        {
            dest[destOffset + 0] = colorR;
            dest[destOffset + 1] = colorG;
            dest[destOffset + 2] = colorB;
        }
        destOffset += outWidth;
        {
            dest[destOffset + 0] = colorR;
            dest[destOffset + 1] = colorG;
            dest[destOffset + 2] = colorB;
        }
    };
    return MinimapCharRenderer;
}());



/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PageCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientCoordinates; });
/* unused harmony export EditorPagePosition */
/* harmony export (immutable) */ __webpack_exports__["f"] = createEditorPagePosition;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditorMouseEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditorMouseEventFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GlobalEditorMouseMoveMonitor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_globalMouseMoveMonitor_js__ = __webpack_require__(69);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * Coordinates relative to the whole document (e.g. mouse event's pageX and pageY)
 */
var PageCoordinates = /** @class */ (function () {
    function PageCoordinates(x, y) {
        this.x = x;
        this.y = y;
    }
    PageCoordinates.prototype.toClientCoordinates = function () {
        return new ClientCoordinates(this.x - __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["e" /* StandardWindow */].scrollX, this.y - __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["e" /* StandardWindow */].scrollY);
    };
    return PageCoordinates;
}());

/**
 * Coordinates within the application's client area (i.e. origin is document's scroll position).
 *
 * For example, clicking in the top-left corner of the client area will
 * always result in a mouse event with a client.x value of 0, regardless
 * of whether the page is scrolled horizontally.
 */
var ClientCoordinates = /** @class */ (function () {
    function ClientCoordinates(clientX, clientY) {
        this.clientX = clientX;
        this.clientY = clientY;
    }
    ClientCoordinates.prototype.toPageCoordinates = function () {
        return new PageCoordinates(this.clientX + __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["e" /* StandardWindow */].scrollX, this.clientY + __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["e" /* StandardWindow */].scrollY);
    };
    return ClientCoordinates;
}());

/**
 * The position of the editor in the page.
 */
var EditorPagePosition = /** @class */ (function () {
    function EditorPagePosition(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    return EditorPagePosition;
}());

function createEditorPagePosition(editorViewDomNode) {
    var editorPos = __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["u" /* getDomNodePagePosition */](editorViewDomNode);
    return new EditorPagePosition(editorPos.left, editorPos.top, editorPos.width, editorPos.height);
}
var EditorMouseEvent = /** @class */ (function (_super) {
    __extends(EditorMouseEvent, _super);
    function EditorMouseEvent(e, editorViewDomNode) {
        var _this = _super.call(this, e) || this;
        _this.pos = new PageCoordinates(_this.posx, _this.posy);
        _this.editorPos = createEditorPagePosition(editorViewDomNode);
        return _this;
    }
    return EditorMouseEvent;
}(__WEBPACK_IMPORTED_MODULE_1__base_browser_mouseEvent_js__["b" /* StandardMouseEvent */]));

var EditorMouseEventFactory = /** @class */ (function () {
    function EditorMouseEventFactory(editorViewDomNode) {
        this._editorViewDomNode = editorViewDomNode;
    }
    EditorMouseEventFactory.prototype._create = function (e) {
        return new EditorMouseEvent(e, this._editorViewDomNode);
    };
    EditorMouseEventFactory.prototype.onContextMenu = function (target, callback) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["g" /* addDisposableListener */](target, 'contextmenu', function (e) {
            callback(_this._create(e));
        });
    };
    EditorMouseEventFactory.prototype.onMouseUp = function (target, callback) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["g" /* addDisposableListener */](target, 'mouseup', function (e) {
            callback(_this._create(e));
        });
    };
    EditorMouseEventFactory.prototype.onMouseDown = function (target, callback) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["g" /* addDisposableListener */](target, 'mousedown', function (e) {
            callback(_this._create(e));
        });
    };
    EditorMouseEventFactory.prototype.onMouseLeave = function (target, callback) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["h" /* addDisposableNonBubblingMouseOutListener */](target, function (e) {
            callback(_this._create(e));
        });
    };
    EditorMouseEventFactory.prototype.onMouseMoveThrottled = function (target, callback, merger, minimumTimeMs) {
        var _this = this;
        var myMerger = function (lastEvent, currentEvent) {
            return merger(lastEvent, _this._create(currentEvent));
        };
        return __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["i" /* addDisposableThrottledListener */](target, 'mousemove', callback, myMerger, minimumTimeMs);
    };
    return EditorMouseEventFactory;
}());

var GlobalEditorMouseMoveMonitor = /** @class */ (function (_super) {
    __extends(GlobalEditorMouseMoveMonitor, _super);
    function GlobalEditorMouseMoveMonitor(editorViewDomNode) {
        var _this = _super.call(this) || this;
        _this._editorViewDomNode = editorViewDomNode;
        _this._globalMouseMoveMonitor = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_browser_globalMouseMoveMonitor_js__["a" /* GlobalMouseMoveMonitor */]());
        _this._keydownListener = null;
        return _this;
    }
    GlobalEditorMouseMoveMonitor.prototype.startMonitoring = function (merger, mouseMoveCallback, onStopCallback) {
        var _this = this;
        // Add a <<capture>> keydown event listener that will cancel the monitoring
        // if something other than a modifier key is pressed
        this._keydownListener = __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["j" /* addStandardDisposableListener */](document, 'keydown', function (e) {
            var kb = e.toKeybinding();
            if (kb.isModifierKey()) {
                // Allow modifier keys
                return;
            }
            _this._globalMouseMoveMonitor.stopMonitoring(true);
        }, true);
        var myMerger = function (lastEvent, currentEvent) {
            return merger(lastEvent, new EditorMouseEvent(currentEvent, _this._editorViewDomNode));
        };
        this._globalMouseMoveMonitor.startMonitoring(myMerger, mouseMoveCallback, function () {
            _this._keydownListener.dispose();
            onStopCallback();
        });
    };
    return GlobalEditorMouseMoveMonitor;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineDecoration; });
/* unused harmony export DecorationSegment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LineDecorationsNormalizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var LineDecoration = /** @class */ (function () {
    function LineDecoration(startColumn, endColumn, className, type) {
        this.startColumn = startColumn;
        this.endColumn = endColumn;
        this.className = className;
        this.type = type;
    }
    LineDecoration._equals = function (a, b) {
        return (a.startColumn === b.startColumn
            && a.endColumn === b.endColumn
            && a.className === b.className
            && a.type === b.type);
    };
    LineDecoration.equalsArr = function (a, b) {
        var aLen = a.length;
        var bLen = b.length;
        if (aLen !== bLen) {
            return false;
        }
        for (var i = 0; i < aLen; i++) {
            if (!LineDecoration._equals(a[i], b[i])) {
                return false;
            }
        }
        return true;
    };
    LineDecoration.filter = function (lineDecorations, lineNumber, minLineColumn, maxLineColumn) {
        if (lineDecorations.length === 0) {
            return [];
        }
        var result = [], resultLen = 0;
        for (var i = 0, len = lineDecorations.length; i < len; i++) {
            var d = lineDecorations[i];
            var range = d.range;
            if (range.endLineNumber < lineNumber || range.startLineNumber > lineNumber) {
                // Ignore decorations that sit outside this line
                continue;
            }
            if (range.isEmpty() && (d.type === 0 /* Regular */ || d.type === 3 /* RegularAffectingLetterSpacing */)) {
                // Ignore empty range decorations
                continue;
            }
            var startColumn = (range.startLineNumber === lineNumber ? range.startColumn : minLineColumn);
            var endColumn = (range.endLineNumber === lineNumber ? range.endColumn : maxLineColumn);
            result[resultLen++] = new LineDecoration(startColumn, endColumn, d.inlineClassName, d.type);
        }
        return result;
    };
    LineDecoration.compare = function (a, b) {
        if (a.startColumn === b.startColumn) {
            if (a.endColumn === b.endColumn) {
                if (a.className < b.className) {
                    return -1;
                }
                if (a.className > b.className) {
                    return 1;
                }
                return 0;
            }
            return a.endColumn - b.endColumn;
        }
        return a.startColumn - b.startColumn;
    };
    return LineDecoration;
}());

var DecorationSegment = /** @class */ (function () {
    function DecorationSegment(startOffset, endOffset, className) {
        this.startOffset = startOffset;
        this.endOffset = endOffset;
        this.className = className;
    }
    return DecorationSegment;
}());

var Stack = /** @class */ (function () {
    function Stack() {
        this.stopOffsets = [];
        this.classNames = [];
        this.count = 0;
    }
    Stack.prototype.consumeLowerThan = function (maxStopOffset, nextStartOffset, result) {
        while (this.count > 0 && this.stopOffsets[0] < maxStopOffset) {
            var i = 0;
            // Take all equal stopping offsets
            while (i + 1 < this.count && this.stopOffsets[i] === this.stopOffsets[i + 1]) {
                i++;
            }
            // Basically we are consuming the first i + 1 elements of the stack
            result.push(new DecorationSegment(nextStartOffset, this.stopOffsets[i], this.classNames.join(' ')));
            nextStartOffset = this.stopOffsets[i] + 1;
            // Consume them
            this.stopOffsets.splice(0, i + 1);
            this.classNames.splice(0, i + 1);
            this.count -= (i + 1);
        }
        if (this.count > 0 && nextStartOffset < maxStopOffset) {
            result.push(new DecorationSegment(nextStartOffset, maxStopOffset - 1, this.classNames.join(' ')));
            nextStartOffset = maxStopOffset;
        }
        return nextStartOffset;
    };
    Stack.prototype.insert = function (stopOffset, className) {
        if (this.count === 0 || this.stopOffsets[this.count - 1] <= stopOffset) {
            // Insert at the end
            this.stopOffsets.push(stopOffset);
            this.classNames.push(className);
        }
        else {
            // Find the insertion position for `stopOffset`
            for (var i = 0; i < this.count; i++) {
                if (this.stopOffsets[i] >= stopOffset) {
                    this.stopOffsets.splice(i, 0, stopOffset);
                    this.classNames.splice(i, 0, className);
                    break;
                }
            }
        }
        this.count++;
        return;
    };
    return Stack;
}());
var LineDecorationsNormalizer = /** @class */ (function () {
    function LineDecorationsNormalizer() {
    }
    /**
     * Normalize line decorations. Overlapping decorations will generate multiple segments
     */
    LineDecorationsNormalizer.normalize = function (lineContent, lineDecorations) {
        if (lineDecorations.length === 0) {
            return [];
        }
        var result = [];
        var stack = new Stack();
        var nextStartOffset = 0;
        for (var i = 0, len = lineDecorations.length; i < len; i++) {
            var d = lineDecorations[i];
            var startColumn = d.startColumn;
            var endColumn = d.endColumn;
            var className = d.className;
            // If the position would end up in the middle of a high-low surrogate pair, we move it to before the pair
            if (startColumn > 1) {
                var charCodeBefore = lineContent.charCodeAt(startColumn - 2);
                if (__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["isHighSurrogate"](charCodeBefore)) {
                    startColumn--;
                }
            }
            if (endColumn > 1) {
                var charCodeBefore = lineContent.charCodeAt(endColumn - 2);
                if (__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["isHighSurrogate"](charCodeBefore)) {
                    endColumn--;
                }
            }
            var currentStartOffset = startColumn - 1;
            var currentEndOffset = endColumn - 2;
            nextStartOffset = stack.consumeLowerThan(currentStartOffset, nextStartOffset, result);
            if (stack.count === 0) {
                nextStartOffset = currentStartOffset;
            }
            stack.insert(currentEndOffset, className);
        }
        stack.consumeLowerThan(1073741824 /* MAX_SAFE_SMALL_INTEGER */, nextStartOffset, result);
        return result;
    };
    return LineDecorationsNormalizer;
}());



/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStringBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var createStringBuilder;
if (typeof TextDecoder !== 'undefined') {
    createStringBuilder = function (capacity) { return new StringBuilder(capacity); };
}
else {
    createStringBuilder = function (capacity) { return new CompatStringBuilder(); };
}
var StringBuilder = /** @class */ (function () {
    function StringBuilder(capacity) {
        this._decoder = new TextDecoder('UTF-16LE');
        this._capacity = capacity | 0;
        this._buffer = new Uint16Array(this._capacity);
        this._completedStrings = null;
        this._bufferLength = 0;
    }
    StringBuilder.prototype.reset = function () {
        this._completedStrings = null;
        this._bufferLength = 0;
    };
    StringBuilder.prototype.build = function () {
        if (this._completedStrings !== null) {
            this._flushBuffer();
            return this._completedStrings.join('');
        }
        return this._buildBuffer();
    };
    StringBuilder.prototype._buildBuffer = function () {
        if (this._bufferLength === 0) {
            return '';
        }
        var view = new Uint16Array(this._buffer.buffer, 0, this._bufferLength);
        return this._decoder.decode(view);
    };
    StringBuilder.prototype._flushBuffer = function () {
        var bufferString = this._buildBuffer();
        this._bufferLength = 0;
        if (this._completedStrings === null) {
            this._completedStrings = [bufferString];
        }
        else {
            this._completedStrings[this._completedStrings.length] = bufferString;
        }
    };
    StringBuilder.prototype.write1 = function (charCode) {
        var remainingSpace = this._capacity - this._bufferLength;
        if (remainingSpace <= 1) {
            if (remainingSpace === 0 || __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["isHighSurrogate"](charCode)) {
                this._flushBuffer();
            }
        }
        this._buffer[this._bufferLength++] = charCode;
    };
    StringBuilder.prototype.appendASCII = function (charCode) {
        if (this._bufferLength === this._capacity) {
            // buffer is full
            this._flushBuffer();
        }
        this._buffer[this._bufferLength++] = charCode;
    };
    StringBuilder.prototype.appendASCIIString = function (str) {
        var strLen = str.length;
        if (this._bufferLength + strLen >= this._capacity) {
            // This string does not fit in the remaining buffer space
            this._flushBuffer();
            this._completedStrings[this._completedStrings.length] = str;
            return;
        }
        for (var i = 0; i < strLen; i++) {
            this._buffer[this._bufferLength++] = str.charCodeAt(i);
        }
    };
    return StringBuilder;
}());
var CompatStringBuilder = /** @class */ (function () {
    function CompatStringBuilder() {
        this._pieces = [];
        this._piecesLen = 0;
    }
    CompatStringBuilder.prototype.reset = function () {
        this._pieces = [];
        this._piecesLen = 0;
    };
    CompatStringBuilder.prototype.build = function () {
        return this._pieces.join('');
    };
    CompatStringBuilder.prototype.write1 = function (charCode) {
        this._pieces[this._piecesLen++] = String.fromCharCode(charCode);
    };
    CompatStringBuilder.prototype.appendASCII = function (charCode) {
        this._pieces[this._piecesLen++] = String.fromCharCode(charCode);
    };
    CompatStringBuilder.prototype.appendASCIIString = function (str) {
        this._pieces[this._piecesLen++] = str;
    };
    return CompatStringBuilder;
}());


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderedLinesCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VisibleLinesCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_stringBuilder_js__ = __webpack_require__(152);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var RenderedLinesCollection = /** @class */ (function () {
    function RenderedLinesCollection(createLine) {
        this._createLine = createLine;
        this._set(1, []);
    }
    RenderedLinesCollection.prototype.flush = function () {
        this._set(1, []);
    };
    RenderedLinesCollection.prototype._set = function (rendLineNumberStart, lines) {
        this._lines = lines;
        this._rendLineNumberStart = rendLineNumberStart;
    };
    RenderedLinesCollection.prototype._get = function () {
        return {
            rendLineNumberStart: this._rendLineNumberStart,
            lines: this._lines
        };
    };
    /**
     * @returns Inclusive line number that is inside this collection
     */
    RenderedLinesCollection.prototype.getStartLineNumber = function () {
        return this._rendLineNumberStart;
    };
    /**
     * @returns Inclusive line number that is inside this collection
     */
    RenderedLinesCollection.prototype.getEndLineNumber = function () {
        return this._rendLineNumberStart + this._lines.length - 1;
    };
    RenderedLinesCollection.prototype.getCount = function () {
        return this._lines.length;
    };
    RenderedLinesCollection.prototype.getLine = function (lineNumber) {
        var lineIndex = lineNumber - this._rendLineNumberStart;
        if (lineIndex < 0 || lineIndex >= this._lines.length) {
            throw new Error('Illegal value for lineNumber');
        }
        return this._lines[lineIndex];
    };
    /**
     * @returns Lines that were removed from this collection
     */
    RenderedLinesCollection.prototype.onLinesDeleted = function (deleteFromLineNumber, deleteToLineNumber) {
        if (this.getCount() === 0) {
            // no lines
            return null;
        }
        var startLineNumber = this.getStartLineNumber();
        var endLineNumber = this.getEndLineNumber();
        if (deleteToLineNumber < startLineNumber) {
            // deleting above the viewport
            var deleteCnt = deleteToLineNumber - deleteFromLineNumber + 1;
            this._rendLineNumberStart -= deleteCnt;
            return null;
        }
        if (deleteFromLineNumber > endLineNumber) {
            // deleted below the viewport
            return null;
        }
        // Record what needs to be deleted
        var deleteStartIndex = 0;
        var deleteCount = 0;
        for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
            var lineIndex = lineNumber - this._rendLineNumberStart;
            if (deleteFromLineNumber <= lineNumber && lineNumber <= deleteToLineNumber) {
                // this is a line to be deleted
                if (deleteCount === 0) {
                    // this is the first line to be deleted
                    deleteStartIndex = lineIndex;
                    deleteCount = 1;
                }
                else {
                    deleteCount++;
                }
            }
        }
        // Adjust this._rendLineNumberStart for lines deleted above
        if (deleteFromLineNumber < startLineNumber) {
            // Something was deleted above
            var deleteAboveCount = 0;
            if (deleteToLineNumber < startLineNumber) {
                // the entire deleted lines are above
                deleteAboveCount = deleteToLineNumber - deleteFromLineNumber + 1;
            }
            else {
                deleteAboveCount = startLineNumber - deleteFromLineNumber;
            }
            this._rendLineNumberStart -= deleteAboveCount;
        }
        var deleted = this._lines.splice(deleteStartIndex, deleteCount);
        return deleted;
    };
    RenderedLinesCollection.prototype.onLinesChanged = function (changeFromLineNumber, changeToLineNumber) {
        if (this.getCount() === 0) {
            // no lines
            return false;
        }
        var startLineNumber = this.getStartLineNumber();
        var endLineNumber = this.getEndLineNumber();
        var someoneNotified = false;
        for (var changedLineNumber = changeFromLineNumber; changedLineNumber <= changeToLineNumber; changedLineNumber++) {
            if (changedLineNumber >= startLineNumber && changedLineNumber <= endLineNumber) {
                // Notify the line
                this._lines[changedLineNumber - this._rendLineNumberStart].onContentChanged();
                someoneNotified = true;
            }
        }
        return someoneNotified;
    };
    RenderedLinesCollection.prototype.onLinesInserted = function (insertFromLineNumber, insertToLineNumber) {
        if (this.getCount() === 0) {
            // no lines
            return null;
        }
        var insertCnt = insertToLineNumber - insertFromLineNumber + 1;
        var startLineNumber = this.getStartLineNumber();
        var endLineNumber = this.getEndLineNumber();
        if (insertFromLineNumber <= startLineNumber) {
            // inserting above the viewport
            this._rendLineNumberStart += insertCnt;
            return null;
        }
        if (insertFromLineNumber > endLineNumber) {
            // inserting below the viewport
            return null;
        }
        if (insertCnt + insertFromLineNumber > endLineNumber) {
            // insert inside the viewport in such a way that all remaining lines are pushed outside
            var deleted = this._lines.splice(insertFromLineNumber - this._rendLineNumberStart, endLineNumber - insertFromLineNumber + 1);
            return deleted;
        }
        // insert inside the viewport, push out some lines, but not all remaining lines
        var newLines = [];
        for (var i = 0; i < insertCnt; i++) {
            newLines[i] = this._createLine();
        }
        var insertIndex = insertFromLineNumber - this._rendLineNumberStart;
        var beforeLines = this._lines.slice(0, insertIndex);
        var afterLines = this._lines.slice(insertIndex, this._lines.length - insertCnt);
        var deletedLines = this._lines.slice(this._lines.length - insertCnt, this._lines.length);
        this._lines = beforeLines.concat(newLines).concat(afterLines);
        return deletedLines;
    };
    RenderedLinesCollection.prototype.onTokensChanged = function (ranges) {
        if (this.getCount() === 0) {
            // no lines
            return false;
        }
        var startLineNumber = this.getStartLineNumber();
        var endLineNumber = this.getEndLineNumber();
        var notifiedSomeone = false;
        for (var i = 0, len = ranges.length; i < len; i++) {
            var rng = ranges[i];
            if (rng.toLineNumber < startLineNumber || rng.fromLineNumber > endLineNumber) {
                // range outside viewport
                continue;
            }
            var from = Math.max(startLineNumber, rng.fromLineNumber);
            var to = Math.min(endLineNumber, rng.toLineNumber);
            for (var lineNumber = from; lineNumber <= to; lineNumber++) {
                var lineIndex = lineNumber - this._rendLineNumberStart;
                this._lines[lineIndex].onTokensChanged();
                notifiedSomeone = true;
            }
        }
        return notifiedSomeone;
    };
    return RenderedLinesCollection;
}());

var VisibleLinesCollection = /** @class */ (function () {
    function VisibleLinesCollection(host) {
        var _this = this;
        this._host = host;
        this.domNode = this._createDomNode();
        this._linesCollection = new RenderedLinesCollection(function () { return _this._host.createVisibleLine(); });
    }
    VisibleLinesCollection.prototype._createDomNode = function () {
        var domNode = Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        domNode.setClassName('view-layer');
        domNode.setPosition('absolute');
        domNode.domNode.setAttribute('role', 'presentation');
        domNode.domNode.setAttribute('aria-hidden', 'true');
        return domNode;
    };
    // ---- begin view event handlers
    VisibleLinesCollection.prototype.onConfigurationChanged = function (e) {
        return e.layoutInfo;
    };
    VisibleLinesCollection.prototype.onFlushed = function (e) {
        this._linesCollection.flush();
        // No need to clear the dom node because a full .innerHTML will occur in ViewLayerRenderer._render
        return true;
    };
    VisibleLinesCollection.prototype.onLinesChanged = function (e) {
        return this._linesCollection.onLinesChanged(e.fromLineNumber, e.toLineNumber);
    };
    VisibleLinesCollection.prototype.onLinesDeleted = function (e) {
        var deleted = this._linesCollection.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
        if (deleted) {
            // Remove from DOM
            for (var i = 0, len = deleted.length; i < len; i++) {
                var lineDomNode = deleted[i].getDomNode();
                if (lineDomNode) {
                    this.domNode.domNode.removeChild(lineDomNode);
                }
            }
        }
        return true;
    };
    VisibleLinesCollection.prototype.onLinesInserted = function (e) {
        var deleted = this._linesCollection.onLinesInserted(e.fromLineNumber, e.toLineNumber);
        if (deleted) {
            // Remove from DOM
            for (var i = 0, len = deleted.length; i < len; i++) {
                var lineDomNode = deleted[i].getDomNode();
                if (lineDomNode) {
                    this.domNode.domNode.removeChild(lineDomNode);
                }
            }
        }
        return true;
    };
    VisibleLinesCollection.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged;
    };
    VisibleLinesCollection.prototype.onTokensChanged = function (e) {
        return this._linesCollection.onTokensChanged(e.ranges);
    };
    VisibleLinesCollection.prototype.onZonesChanged = function (e) {
        return true;
    };
    // ---- end view event handlers
    VisibleLinesCollection.prototype.getStartLineNumber = function () {
        return this._linesCollection.getStartLineNumber();
    };
    VisibleLinesCollection.prototype.getEndLineNumber = function () {
        return this._linesCollection.getEndLineNumber();
    };
    VisibleLinesCollection.prototype.getVisibleLine = function (lineNumber) {
        return this._linesCollection.getLine(lineNumber);
    };
    VisibleLinesCollection.prototype.renderLines = function (viewportData) {
        var inp = this._linesCollection._get();
        var renderer = new ViewLayerRenderer(this.domNode.domNode, this._host, viewportData);
        var ctx = {
            rendLineNumberStart: inp.rendLineNumberStart,
            lines: inp.lines,
            linesLength: inp.lines.length
        };
        // Decide if this render will do a single update (single large .innerHTML) or many updates (inserting/removing dom nodes)
        var resCtx = renderer.render(ctx, viewportData.startLineNumber, viewportData.endLineNumber, viewportData.relativeVerticalOffset);
        this._linesCollection._set(resCtx.rendLineNumberStart, resCtx.lines);
    };
    return VisibleLinesCollection;
}());

var ViewLayerRenderer = /** @class */ (function () {
    function ViewLayerRenderer(domNode, host, viewportData) {
        this.domNode = domNode;
        this.host = host;
        this.viewportData = viewportData;
    }
    ViewLayerRenderer.prototype.render = function (inContext, startLineNumber, stopLineNumber, deltaTop) {
        var ctx = {
            rendLineNumberStart: inContext.rendLineNumberStart,
            lines: inContext.lines.slice(0),
            linesLength: inContext.linesLength
        };
        if ((ctx.rendLineNumberStart + ctx.linesLength - 1 < startLineNumber) || (stopLineNumber < ctx.rendLineNumberStart)) {
            // There is no overlap whatsoever
            ctx.rendLineNumberStart = startLineNumber;
            ctx.linesLength = stopLineNumber - startLineNumber + 1;
            ctx.lines = [];
            for (var x = startLineNumber; x <= stopLineNumber; x++) {
                ctx.lines[x - startLineNumber] = this.host.createVisibleLine();
            }
            this._finishRendering(ctx, true, deltaTop);
            return ctx;
        }
        // Update lines which will remain untouched
        this._renderUntouchedLines(ctx, Math.max(startLineNumber - ctx.rendLineNumberStart, 0), Math.min(stopLineNumber - ctx.rendLineNumberStart, ctx.linesLength - 1), deltaTop, startLineNumber);
        if (ctx.rendLineNumberStart > startLineNumber) {
            // Insert lines before
            var fromLineNumber = startLineNumber;
            var toLineNumber = Math.min(stopLineNumber, ctx.rendLineNumberStart - 1);
            if (fromLineNumber <= toLineNumber) {
                this._insertLinesBefore(ctx, fromLineNumber, toLineNumber, deltaTop, startLineNumber);
                ctx.linesLength += toLineNumber - fromLineNumber + 1;
            }
        }
        else if (ctx.rendLineNumberStart < startLineNumber) {
            // Remove lines before
            var removeCnt = Math.min(ctx.linesLength, startLineNumber - ctx.rendLineNumberStart);
            if (removeCnt > 0) {
                this._removeLinesBefore(ctx, removeCnt);
                ctx.linesLength -= removeCnt;
            }
        }
        ctx.rendLineNumberStart = startLineNumber;
        if (ctx.rendLineNumberStart + ctx.linesLength - 1 < stopLineNumber) {
            // Insert lines after
            var fromLineNumber = ctx.rendLineNumberStart + ctx.linesLength;
            var toLineNumber = stopLineNumber;
            if (fromLineNumber <= toLineNumber) {
                this._insertLinesAfter(ctx, fromLineNumber, toLineNumber, deltaTop, startLineNumber);
                ctx.linesLength += toLineNumber - fromLineNumber + 1;
            }
        }
        else if (ctx.rendLineNumberStart + ctx.linesLength - 1 > stopLineNumber) {
            // Remove lines after
            var fromLineNumber = Math.max(0, stopLineNumber - ctx.rendLineNumberStart + 1);
            var toLineNumber = ctx.linesLength - 1;
            var removeCnt = toLineNumber - fromLineNumber + 1;
            if (removeCnt > 0) {
                this._removeLinesAfter(ctx, removeCnt);
                ctx.linesLength -= removeCnt;
            }
        }
        this._finishRendering(ctx, false, deltaTop);
        return ctx;
    };
    ViewLayerRenderer.prototype._renderUntouchedLines = function (ctx, startIndex, endIndex, deltaTop, deltaLN) {
        var rendLineNumberStart = ctx.rendLineNumberStart;
        var lines = ctx.lines;
        for (var i = startIndex; i <= endIndex; i++) {
            var lineNumber = rendLineNumberStart + i;
            lines[i].layoutLine(lineNumber, deltaTop[lineNumber - deltaLN]);
        }
    };
    ViewLayerRenderer.prototype._insertLinesBefore = function (ctx, fromLineNumber, toLineNumber, deltaTop, deltaLN) {
        var newLines = [];
        var newLinesLen = 0;
        for (var lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++) {
            newLines[newLinesLen++] = this.host.createVisibleLine();
        }
        ctx.lines = newLines.concat(ctx.lines);
    };
    ViewLayerRenderer.prototype._removeLinesBefore = function (ctx, removeCount) {
        for (var i = 0; i < removeCount; i++) {
            var lineDomNode = ctx.lines[i].getDomNode();
            if (lineDomNode) {
                this.domNode.removeChild(lineDomNode);
            }
        }
        ctx.lines.splice(0, removeCount);
    };
    ViewLayerRenderer.prototype._insertLinesAfter = function (ctx, fromLineNumber, toLineNumber, deltaTop, deltaLN) {
        var newLines = [];
        var newLinesLen = 0;
        for (var lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++) {
            newLines[newLinesLen++] = this.host.createVisibleLine();
        }
        ctx.lines = ctx.lines.concat(newLines);
    };
    ViewLayerRenderer.prototype._removeLinesAfter = function (ctx, removeCount) {
        var removeIndex = ctx.linesLength - removeCount;
        for (var i = 0; i < removeCount; i++) {
            var lineDomNode = ctx.lines[removeIndex + i].getDomNode();
            if (lineDomNode) {
                this.domNode.removeChild(lineDomNode);
            }
        }
        ctx.lines.splice(removeIndex, removeCount);
    };
    ViewLayerRenderer.prototype._finishRenderingNewLines = function (ctx, domNodeIsEmpty, newLinesHTML, wasNew) {
        var lastChild = this.domNode.lastChild;
        if (domNodeIsEmpty || !lastChild) {
            this.domNode.innerHTML = newLinesHTML;
        }
        else {
            lastChild.insertAdjacentHTML('afterend', newLinesHTML);
        }
        var currChild = this.domNode.lastChild;
        for (var i = ctx.linesLength - 1; i >= 0; i--) {
            var line = ctx.lines[i];
            if (wasNew[i]) {
                line.setDomNode(currChild);
                currChild = currChild.previousSibling;
            }
        }
    };
    ViewLayerRenderer.prototype._finishRenderingInvalidLines = function (ctx, invalidLinesHTML, wasInvalid) {
        var hugeDomNode = document.createElement('div');
        hugeDomNode.innerHTML = invalidLinesHTML;
        for (var i = 0; i < ctx.linesLength; i++) {
            var line = ctx.lines[i];
            if (wasInvalid[i]) {
                var source = hugeDomNode.firstChild;
                var lineDomNode = line.getDomNode();
                lineDomNode.parentNode.replaceChild(source, lineDomNode);
                line.setDomNode(source);
            }
        }
    };
    ViewLayerRenderer.prototype._finishRendering = function (ctx, domNodeIsEmpty, deltaTop) {
        var sb = ViewLayerRenderer._sb;
        var linesLength = ctx.linesLength;
        var lines = ctx.lines;
        var rendLineNumberStart = ctx.rendLineNumberStart;
        var wasNew = [];
        {
            sb.reset();
            var hadNewLine = false;
            for (var i = 0; i < linesLength; i++) {
                var line = lines[i];
                wasNew[i] = false;
                var lineDomNode = line.getDomNode();
                if (lineDomNode) {
                    // line is not new
                    continue;
                }
                var renderResult = line.renderLine(i + rendLineNumberStart, deltaTop[i], this.viewportData, sb);
                if (!renderResult) {
                    // line does not need rendering
                    continue;
                }
                wasNew[i] = true;
                hadNewLine = true;
            }
            if (hadNewLine) {
                this._finishRenderingNewLines(ctx, domNodeIsEmpty, sb.build(), wasNew);
            }
        }
        {
            sb.reset();
            var hadInvalidLine = false;
            var wasInvalid = [];
            for (var i = 0; i < linesLength; i++) {
                var line = lines[i];
                wasInvalid[i] = false;
                if (wasNew[i]) {
                    // line was new
                    continue;
                }
                var renderResult = line.renderLine(i + rendLineNumberStart, deltaTop[i], this.viewportData, sb);
                if (!renderResult) {
                    // line does not need rendering
                    continue;
                }
                wasInvalid[i] = true;
                hadInvalidLine = true;
            }
            if (hadInvalidLine) {
                this._finishRenderingInvalidLines(ctx, sb.build(), wasInvalid);
            }
        }
    };
    ViewLayerRenderer._sb = Object(__WEBPACK_IMPORTED_MODULE_1__common_core_stringBuilder_js__["a" /* createStringBuilder */])(100000);
    return ViewLayerRenderer;
}());


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DecorationToRender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DedupOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GlyphMarginOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__glyphMargin_css__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__glyphMargin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__glyphMargin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__ = __webpack_require__(63);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var DecorationToRender = /** @class */ (function () {
    function DecorationToRender(startLineNumber, endLineNumber, className) {
        this.startLineNumber = +startLineNumber;
        this.endLineNumber = +endLineNumber;
        this.className = String(className);
    }
    return DecorationToRender;
}());

var DedupOverlay = /** @class */ (function (_super) {
    __extends(DedupOverlay, _super);
    function DedupOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DedupOverlay.prototype._render = function (visibleStartLineNumber, visibleEndLineNumber, decorations) {
        var output = [];
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var lineIndex = lineNumber - visibleStartLineNumber;
            output[lineIndex] = [];
        }
        if (decorations.length === 0) {
            return output;
        }
        decorations.sort(function (a, b) {
            if (a.className === b.className) {
                if (a.startLineNumber === b.startLineNumber) {
                    return a.endLineNumber - b.endLineNumber;
                }
                return a.startLineNumber - b.startLineNumber;
            }
            return (a.className < b.className ? -1 : 1);
        });
        var prevClassName = null;
        var prevEndLineIndex = 0;
        for (var i = 0, len = decorations.length; i < len; i++) {
            var d = decorations[i];
            var className = d.className;
            var startLineIndex = Math.max(d.startLineNumber, visibleStartLineNumber) - visibleStartLineNumber;
            var endLineIndex = Math.min(d.endLineNumber, visibleEndLineNumber) - visibleStartLineNumber;
            if (prevClassName === className) {
                startLineIndex = Math.max(prevEndLineIndex + 1, startLineIndex);
                prevEndLineIndex = Math.max(prevEndLineIndex, endLineIndex);
            }
            else {
                prevClassName = className;
                prevEndLineIndex = endLineIndex;
            }
            for (var i_1 = startLineIndex; i_1 <= prevEndLineIndex; i_1++) {
                output[i_1].push(prevClassName);
            }
        }
        return output;
    };
    return DedupOverlay;
}(__WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__["a" /* DynamicViewOverlay */]));

var GlyphMarginOverlay = /** @class */ (function (_super) {
    __extends(GlyphMarginOverlay, _super);
    function GlyphMarginOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._lineHeight = _this._context.configuration.editor.lineHeight;
        _this._glyphMargin = _this._context.configuration.editor.viewInfo.glyphMargin;
        _this._glyphMarginLeft = _this._context.configuration.editor.layoutInfo.glyphMarginLeft;
        _this._glyphMarginWidth = _this._context.configuration.editor.layoutInfo.glyphMarginWidth;
        _this._renderResult = null;
        _this._context.addEventHandler(_this);
        return _this;
    }
    GlyphMarginOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        this._renderResult = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    GlyphMarginOverlay.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.viewInfo) {
            this._glyphMargin = this._context.configuration.editor.viewInfo.glyphMargin;
        }
        if (e.layoutInfo) {
            this._glyphMarginLeft = this._context.configuration.editor.layoutInfo.glyphMarginLeft;
            this._glyphMarginWidth = this._context.configuration.editor.layoutInfo.glyphMarginWidth;
        }
        return true;
    };
    GlyphMarginOverlay.prototype.onDecorationsChanged = function (e) {
        return true;
    };
    GlyphMarginOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    GlyphMarginOverlay.prototype.onLinesChanged = function (e) {
        return true;
    };
    GlyphMarginOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    GlyphMarginOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    GlyphMarginOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged;
    };
    GlyphMarginOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    GlyphMarginOverlay.prototype._getDecorations = function (ctx) {
        var decorations = ctx.getDecorationsInViewport();
        var r = [], rLen = 0;
        for (var i = 0, len = decorations.length; i < len; i++) {
            var d = decorations[i];
            var glyphMarginClassName = d.options.glyphMarginClassName;
            if (glyphMarginClassName) {
                r[rLen++] = new DecorationToRender(d.range.startLineNumber, d.range.endLineNumber, glyphMarginClassName);
            }
        }
        return r;
    };
    GlyphMarginOverlay.prototype.prepareRender = function (ctx) {
        if (!this._glyphMargin) {
            this._renderResult = null;
            return;
        }
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        var toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));
        var lineHeight = this._lineHeight.toString();
        var left = this._glyphMarginLeft.toString();
        var width = this._glyphMarginWidth.toString();
        var common = '" style="left:' + left + 'px;width:' + width + 'px' + ';height:' + lineHeight + 'px;"></div>';
        var output = [];
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var lineIndex = lineNumber - visibleStartLineNumber;
            var classNames = toRender[lineIndex];
            if (classNames.length === 0) {
                output[lineIndex] = '';
            }
            else {
                output[lineIndex] = ('<div class="cgmr '
                    + classNames.join(' ')
                    + common);
            }
        }
        this._renderResult = output;
    };
    GlyphMarginOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (!this._renderResult) {
            return '';
        }
        var lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) {
            return '';
        }
        return this._renderResult[lineIndex];
    };
    return GlyphMarginOverlay;
}(DedupOverlay));



/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARROW_IMG_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScrollbarArrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalMouseMoveMonitor_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * The arrow image size.
 */
var ARROW_IMG_SIZE = 11;
var ScrollbarArrow = /** @class */ (function (_super) {
    __extends(ScrollbarArrow, _super);
    function ScrollbarArrow(opts) {
        var _this = _super.call(this) || this;
        _this._onActivate = opts.onActivate;
        _this.bgDomNode = document.createElement('div');
        _this.bgDomNode.className = 'arrow-background';
        _this.bgDomNode.style.position = 'absolute';
        _this.bgDomNode.style.width = opts.bgWidth + 'px';
        _this.bgDomNode.style.height = opts.bgHeight + 'px';
        if (typeof opts.top !== 'undefined') {
            _this.bgDomNode.style.top = '0px';
        }
        if (typeof opts.left !== 'undefined') {
            _this.bgDomNode.style.left = '0px';
        }
        if (typeof opts.bottom !== 'undefined') {
            _this.bgDomNode.style.bottom = '0px';
        }
        if (typeof opts.right !== 'undefined') {
            _this.bgDomNode.style.right = '0px';
        }
        _this.domNode = document.createElement('div');
        _this.domNode.className = opts.className;
        _this.domNode.style.position = 'absolute';
        _this.domNode.style.width = ARROW_IMG_SIZE + 'px';
        _this.domNode.style.height = ARROW_IMG_SIZE + 'px';
        if (typeof opts.top !== 'undefined') {
            _this.domNode.style.top = opts.top + 'px';
        }
        if (typeof opts.left !== 'undefined') {
            _this.domNode.style.left = opts.left + 'px';
        }
        if (typeof opts.bottom !== 'undefined') {
            _this.domNode.style.bottom = opts.bottom + 'px';
        }
        if (typeof opts.right !== 'undefined') {
            _this.domNode.style.right = opts.right + 'px';
        }
        _this._mouseMoveMonitor = _this._register(new __WEBPACK_IMPORTED_MODULE_0__globalMouseMoveMonitor_js__["a" /* GlobalMouseMoveMonitor */]());
        _this.onmousedown(_this.bgDomNode, function (e) { return _this._arrowMouseDown(e); });
        _this.onmousedown(_this.domNode, function (e) { return _this._arrowMouseDown(e); });
        _this._mousedownRepeatTimer = _this._register(new __WEBPACK_IMPORTED_MODULE_2__common_async_js__["b" /* IntervalTimer */]());
        _this._mousedownScheduleRepeatTimer = _this._register(new __WEBPACK_IMPORTED_MODULE_2__common_async_js__["f" /* TimeoutTimer */]());
        return _this;
    }
    ScrollbarArrow.prototype._arrowMouseDown = function (e) {
        var _this = this;
        var scheduleRepeater = function () {
            _this._mousedownRepeatTimer.cancelAndSet(function () { return _this._onActivate(); }, 1000 / 24);
        };
        this._onActivate();
        this._mousedownRepeatTimer.cancel();
        this._mousedownScheduleRepeatTimer.cancelAndSet(scheduleRepeater, 200);
        this._mouseMoveMonitor.startMonitoring(__WEBPACK_IMPORTED_MODULE_0__globalMouseMoveMonitor_js__["b" /* standardMouseMoveMerger */], function (mouseMoveData) {
            /* Intentional empty */
        }, function () {
            _this._mousedownRepeatTimer.cancel();
            _this._mousedownScheduleRepeatTimer.cancel();
        });
        e.preventDefault();
    };
    return ScrollbarArrow;
}(__WEBPACK_IMPORTED_MODULE_1__widget_js__["a" /* Widget */]));



/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PeekContext; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getOuterEditor;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PeekViewWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_peekViewWidget_css__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_peekViewWidget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__media_peekViewWidget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_actions_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_browser_ui_actionbar_actionbar_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zoneWidget_zoneWidget_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__browser_widget_embeddedCodeEditorWidget_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_common_color_js__ = __webpack_require__(24);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var PeekContext;
(function (PeekContext) {
    PeekContext.inPeekEditor = new __WEBPACK_IMPORTED_MODULE_12__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('inReferenceSearchEditor', true);
    PeekContext.notInPeekEditor = PeekContext.inPeekEditor.toNegated();
})(PeekContext || (PeekContext = {}));
function getOuterEditor(accessor) {
    var editor = accessor.get(__WEBPACK_IMPORTED_MODULE_9__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]).getFocusedCodeEditor();
    if (editor instanceof __WEBPACK_IMPORTED_MODULE_11__browser_widget_embeddedCodeEditorWidget_js__["a" /* EmbeddedCodeEditorWidget */]) {
        return editor.getParentEditor();
    }
    return editor;
}
var defaultOptions = {
    headerBackgroundColor: __WEBPACK_IMPORTED_MODULE_13__base_common_color_js__["a" /* Color */].white,
    primaryHeadingColor: __WEBPACK_IMPORTED_MODULE_13__base_common_color_js__["a" /* Color */].fromHex('#333333'),
    secondaryHeadingColor: __WEBPACK_IMPORTED_MODULE_13__base_common_color_js__["a" /* Color */].fromHex('#6c6c6cb3')
};
var PeekViewWidget = /** @class */ (function (_super) {
    __extends(PeekViewWidget, _super);
    function PeekViewWidget(editor, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, editor, options) || this;
        _this._onDidClose = new __WEBPACK_IMPORTED_MODULE_6__base_common_event_js__["a" /* Emitter */]();
        __WEBPACK_IMPORTED_MODULE_4__base_common_objects_js__["g" /* mixin */](_this.options, defaultOptions, false);
        return _this;
    }
    PeekViewWidget.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._onDidClose.fire(this);
    };
    Object.defineProperty(PeekViewWidget.prototype, "onDidClose", {
        get: function () {
            return this._onDidClose.event;
        },
        enumerable: true,
        configurable: true
    });
    PeekViewWidget.prototype.style = function (styles) {
        var options = this.options;
        if (styles.headerBackgroundColor) {
            options.headerBackgroundColor = styles.headerBackgroundColor;
        }
        if (styles.primaryHeadingColor) {
            options.primaryHeadingColor = styles.primaryHeadingColor;
        }
        if (styles.secondaryHeadingColor) {
            options.secondaryHeadingColor = styles.secondaryHeadingColor;
        }
        _super.prototype.style.call(this, styles);
    };
    PeekViewWidget.prototype._applyStyles = function () {
        _super.prototype._applyStyles.call(this);
        var options = this.options;
        if (this._headElement) {
            this._headElement.style.backgroundColor = options.headerBackgroundColor.toString();
        }
        if (this._primaryHeading) {
            this._primaryHeading.style.color = options.primaryHeadingColor.toString();
        }
        if (this._secondaryHeading) {
            this._secondaryHeading.style.color = options.secondaryHeadingColor.toString();
        }
        if (this._bodyElement) {
            this._bodyElement.style.borderColor = options.frameColor.toString();
        }
    };
    PeekViewWidget.prototype._fillContainer = function (container) {
        this.setCssClass('peekview-widget');
        this._headElement = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])('.head').getHTMLElement();
        this._bodyElement = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])('.body').getHTMLElement();
        this._fillHead(this._headElement);
        this._fillBody(this._bodyElement);
        container.appendChild(this._headElement);
        container.appendChild(this._bodyElement);
    };
    PeekViewWidget.prototype._fillHead = function (container) {
        var _this = this;
        var titleElement = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])('.peekview-title').
            on(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["d" /* EventType */].CLICK, function (e) { return _this._onTitleClick(e); }).
            appendTo(this._headElement).
            getHTMLElement();
        this._primaryHeading = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])('span.filename').appendTo(titleElement).getHTMLElement();
        this._secondaryHeading = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])('span.dirname').appendTo(titleElement).getHTMLElement();
        this._metaHeading = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])('span.meta').appendTo(titleElement).getHTMLElement();
        var actionsContainer = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])('.peekview-actions').appendTo(this._headElement);
        var actionBarOptions = this._getActionBarOptions();
        this._actionbarWidget = new __WEBPACK_IMPORTED_MODULE_8__base_browser_ui_actionbar_actionbar_js__["a" /* ActionBar */](actionsContainer.getHTMLElement(), actionBarOptions);
        this._disposables.push(this._actionbarWidget);
        this._actionbarWidget.push(new __WEBPACK_IMPORTED_MODULE_2__base_common_actions_js__["a" /* Action */]('peekview.close', __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.close', "Close"), 'close-peekview-action', true, function () {
            _this.dispose();
            return null;
        }), { label: false, icon: true });
    };
    PeekViewWidget.prototype._getActionBarOptions = function () {
        return {};
    };
    PeekViewWidget.prototype._onTitleClick = function (event) {
        // implement me
    };
    PeekViewWidget.prototype.setTitle = function (primaryHeading, secondaryHeading) {
        Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])(this._primaryHeading).safeInnerHtml(primaryHeading);
        this._primaryHeading.setAttribute('aria-label', primaryHeading);
        if (secondaryHeading) {
            Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])(this._secondaryHeading).safeInnerHtml(secondaryHeading);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["l" /* clearNode */](this._secondaryHeading);
        }
    };
    PeekViewWidget.prototype.setMetaTitle = function (value) {
        if (value) {
            Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_builder_js__["a" /* $ */])(this._metaHeading).safeInnerHtml(value);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["l" /* clearNode */](this._metaHeading);
        }
    };
    PeekViewWidget.prototype._doLayout = function (heightInPixel, widthInPixel) {
        if (!this._isShowing && heightInPixel < 0) {
            // Looks like the view zone got folded away!
            this.dispose();
            return;
        }
        var headHeight = Math.ceil(this.editor.getConfiguration().lineHeight * 1.2);
        var bodyHeight = heightInPixel - (headHeight + 2 /* the border-top/bottom width*/);
        this._doLayoutHead(headHeight, widthInPixel);
        this._doLayoutBody(bodyHeight, widthInPixel);
    };
    PeekViewWidget.prototype._doLayoutHead = function (heightInPixel, widthInPixel) {
        this._headElement.style.height = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"]('{0}px', heightInPixel);
        this._headElement.style.lineHeight = this._headElement.style.height;
    };
    PeekViewWidget.prototype._doLayoutBody = function (heightInPixel, widthInPixel) {
        this._bodyElement.style.height = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"]('{0}px', heightInPixel);
    };
    return PeekViewWidget;
}(__WEBPACK_IMPORTED_MODULE_10__zoneWidget_zoneWidget_js__["a" /* ZoneWidget */]));



/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OneReference; });
/* unused harmony export FilePreview */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileReferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ReferencesModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_idGenerator_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/









var OneReference = /** @class */ (function () {
    function OneReference(_parent, _range) {
        this._parent = _parent;
        this._range = _range;
        this._onRefChanged = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.onRefChanged = this._onRefChanged.event;
        this._id = __WEBPACK_IMPORTED_MODULE_5__base_common_idGenerator_js__["b" /* defaultGenerator */].nextId();
    }
    Object.defineProperty(OneReference.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OneReference.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OneReference.prototype, "uri", {
        get: function () {
            return this._parent.uri;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OneReference.prototype, "range", {
        get: function () {
            return this._range;
        },
        set: function (value) {
            this._range = value;
            this._onRefChanged.fire(this);
        },
        enumerable: true,
        configurable: true
    });
    OneReference.prototype.getAriaMessage = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */])('aria.oneReference', "symbol in {0} on line {1} at column {2}", Object(__WEBPACK_IMPORTED_MODULE_2__base_common_paths_js__["a" /* basename */])(this.uri.fsPath), this.range.startLineNumber, this.range.startColumn);
    };
    return OneReference;
}());

var FilePreview = /** @class */ (function () {
    function FilePreview(_modelReference) {
        this._modelReference = _modelReference;
    }
    Object.defineProperty(FilePreview.prototype, "_model", {
        get: function () { return this._modelReference.object.textEditorModel; },
        enumerable: true,
        configurable: true
    });
    FilePreview.prototype.preview = function (range, n) {
        if (n === void 0) { n = 8; }
        var model = this._model;
        if (!model) {
            return undefined;
        }
        var startLineNumber = range.startLineNumber, startColumn = range.startColumn, endLineNumber = range.endLineNumber, endColumn = range.endColumn;
        var word = model.getWordUntilPosition({ lineNumber: startLineNumber, column: startColumn - n });
        var beforeRange = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](startLineNumber, word.startColumn, startLineNumber, startColumn);
        var afterRange = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](endLineNumber, endColumn, endLineNumber, Number.MAX_VALUE);
        var ret = {
            before: model.getValueInRange(beforeRange).replace(/^\s+/, __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["empty"]),
            inside: model.getValueInRange(range),
            after: model.getValueInRange(afterRange).replace(/\s+$/, __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["empty"])
        };
        return ret;
    };
    FilePreview.prototype.dispose = function () {
        if (this._modelReference) {
            this._modelReference.dispose();
            this._modelReference = null;
        }
    };
    return FilePreview;
}());

var FileReferences = /** @class */ (function () {
    function FileReferences(_parent, _uri) {
        this._parent = _parent;
        this._uri = _uri;
        this._children = [];
    }
    Object.defineProperty(FileReferences.prototype, "id", {
        get: function () {
            return this._uri.toString();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReferences.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReferences.prototype, "children", {
        get: function () {
            return this._children;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReferences.prototype, "uri", {
        get: function () {
            return this._uri;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReferences.prototype, "preview", {
        get: function () {
            return this._preview;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileReferences.prototype, "failure", {
        get: function () {
            return this._loadFailure;
        },
        enumerable: true,
        configurable: true
    });
    FileReferences.prototype.getAriaMessage = function () {
        var len = this.children.length;
        if (len === 1) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */])('aria.fileReferences.1', "1 symbol in {0}, full path {1}", Object(__WEBPACK_IMPORTED_MODULE_2__base_common_paths_js__["a" /* basename */])(this.uri.fsPath), this.uri.fsPath);
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */])('aria.fileReferences.N', "{0} symbols in {1}, full path {2}", len, Object(__WEBPACK_IMPORTED_MODULE_2__base_common_paths_js__["a" /* basename */])(this.uri.fsPath), this.uri.fsPath);
        }
    };
    FileReferences.prototype.resolve = function (textModelResolverService) {
        var _this = this;
        if (this._resolved) {
            return __WEBPACK_IMPORTED_MODULE_6__base_common_winjs_base_js__["b" /* TPromise */].as(this);
        }
        return textModelResolverService.createModelReference(this._uri).then(function (modelReference) {
            var model = modelReference.object;
            if (!model) {
                modelReference.dispose();
                throw new Error();
            }
            _this._preview = new FilePreview(modelReference);
            _this._resolved = true;
            return _this;
        }, function (err) {
            // something wrong here
            _this._children = [];
            _this._resolved = true;
            _this._loadFailure = err;
            return _this;
        });
    };
    FileReferences.prototype.dispose = function () {
        if (this._preview) {
            this._preview.dispose();
            this._preview = null;
        }
    };
    return FileReferences;
}());

var ReferencesModel = /** @class */ (function () {
    function ReferencesModel(references) {
        var _this = this;
        this._groups = [];
        this._references = [];
        this._onDidChangeReferenceRange = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.onDidChangeReferenceRange = this._onDidChangeReferenceRange.event;
        this._disposables = [];
        // grouping and sorting
        references.sort(ReferencesModel._compareReferences);
        var current;
        for (var _i = 0, references_1 = references; _i < references_1.length; _i++) {
            var ref = references_1[_i];
            if (!current || current.uri.toString() !== ref.uri.toString()) {
                // new group
                current = new FileReferences(this, ref.uri);
                this.groups.push(current);
            }
            // append, check for equality first!
            if (current.children.length === 0
                || !__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].equalsRange(ref.range, current.children[current.children.length - 1].range)) {
                var oneRef = new OneReference(current, ref.range);
                this._disposables.push(oneRef.onRefChanged(function (e) { return _this._onDidChangeReferenceRange.fire(e); }));
                this._references.push(oneRef);
                current.children.push(oneRef);
            }
        }
    }
    Object.defineProperty(ReferencesModel.prototype, "empty", {
        get: function () {
            return this._groups.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferencesModel.prototype, "references", {
        get: function () {
            return this._references;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferencesModel.prototype, "groups", {
        get: function () {
            return this._groups;
        },
        enumerable: true,
        configurable: true
    });
    ReferencesModel.prototype.getAriaMessage = function () {
        if (this.empty) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */])('aria.result.0', "No results found");
        }
        else if (this.references.length === 1) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */])('aria.result.1', "Found 1 symbol in {0}", this.references[0].uri.fsPath);
        }
        else if (this.groups.length === 1) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */])('aria.result.n1', "Found {0} symbols in {1}", this.references.length, this.groups[0].uri.fsPath);
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */])('aria.result.nm', "Found {0} symbols in {1} files", this.references.length, this.groups.length);
        }
    };
    ReferencesModel.prototype.nextOrPreviousReference = function (reference, next) {
        var parent = reference.parent;
        var idx = parent.children.indexOf(reference);
        var childCount = parent.children.length;
        var groupCount = parent.parent.groups.length;
        if (groupCount === 1 || next && idx + 1 < childCount || !next && idx > 0) {
            // cycling within one file
            if (next) {
                idx = (idx + 1) % childCount;
            }
            else {
                idx = (idx + childCount - 1) % childCount;
            }
            return parent.children[idx];
        }
        idx = parent.parent.groups.indexOf(parent);
        if (next) {
            idx = (idx + 1) % groupCount;
            return parent.parent.groups[idx].children[0];
        }
        else {
            idx = (idx + groupCount - 1) % groupCount;
            return parent.parent.groups[idx].children[parent.parent.groups[idx].children.length - 1];
        }
    };
    ReferencesModel.prototype.nearestReference = function (resource, position) {
        var nearest = this._references.map(function (ref, idx) {
            return {
                idx: idx,
                prefixLen: __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["commonPrefixLength"](ref.uri.toString(), resource.toString()),
                offsetDist: Math.abs(ref.range.startLineNumber - position.lineNumber) * 100 + Math.abs(ref.range.startColumn - position.column)
            };
        }).sort(function (a, b) {
            if (a.prefixLen > b.prefixLen) {
                return -1;
            }
            else if (a.prefixLen < b.prefixLen) {
                return 1;
            }
            else if (a.offsetDist < b.offsetDist) {
                return -1;
            }
            else if (a.offsetDist > b.offsetDist) {
                return 1;
            }
            else {
                return 0;
            }
        })[0];
        if (nearest) {
            return this._references[nearest.idx];
        }
        return undefined;
    };
    ReferencesModel.prototype.dispose = function () {
        this._groups = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._groups);
        Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        this._disposables.length = 0;
    };
    ReferencesModel._compareReferences = function (a, b) {
        var auri = a.uri.toString();
        var buri = b.uri.toString();
        if (auri < buri) {
            return -1;
        }
        else if (auri > buri) {
            return 1;
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(a.range, b.range);
        }
    };
    return ReferencesModel;
}());



/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ITextModelService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ITextModelService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])('textModelService');


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IListService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListService; });
/* unused harmony export WorkbenchListSupportsMultiSelectContextKey */
/* unused harmony export WorkbenchListHasSelectionOrFocus */
/* unused harmony export WorkbenchListDoubleSelection */
/* unused harmony export WorkbenchListMultiSelection */
/* unused harmony export multiSelectModifierSettingKey */
/* unused harmony export openModeSettingKey */
/* unused harmony export horizontalScrollingKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WorkbenchTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WorkbenchTreeController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_parts_tree_browser_treeImpl_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme_common_styler_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuration_common_configuration_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configuration_common_configurationRegistry_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_parts_tree_browser_treeDefaults_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_common_scrollable_js__ = __webpack_require__(42);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;














var IListService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('listService');
var ListService = /** @class */ (function () {
    function ListService(contextKeyService) {
        this.lists = [];
        this._lastFocusedWidget = undefined;
    }
    Object.defineProperty(ListService.prototype, "lastFocusedList", {
        get: function () {
            return this._lastFocusedWidget;
        },
        enumerable: true,
        configurable: true
    });
    ListService.prototype.register = function (widget, extraContextKeys) {
        var _this = this;
        if (this.lists.some(function (l) { return l.widget === widget; })) {
            throw new Error('Cannot register the same widget multiple times');
        }
        // Keep in our lists list
        var registeredList = { widget: widget, extraContextKeys: extraContextKeys };
        this.lists.push(registeredList);
        // Check for currently being focused
        if (widget.isDOMFocused()) {
            this._lastFocusedWidget = widget;
        }
        var result = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["c" /* combinedDisposable */])([
            widget.onDidFocus(function () { return _this._lastFocusedWidget = widget; }),
            Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["f" /* toDisposable */])(function () { return _this.lists.splice(_this.lists.indexOf(registeredList), 1); }),
            widget.onDidDispose(function () {
                _this.lists = _this.lists.filter(function (l) { return l !== registeredList; });
                if (_this._lastFocusedWidget === widget) {
                    _this._lastFocusedWidget = undefined;
                }
            })
        ]);
        return result;
    };
    ListService = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], ListService);
    return ListService;
}());

var RawWorkbenchListFocusContextKey = new __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["f" /* RawContextKey */]('listFocus', true);
var WorkbenchListSupportsMultiSelectContextKey = new __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["f" /* RawContextKey */]('listSupportsMultiselect', true);
var WorkbenchListHasSelectionOrFocus = new __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["f" /* RawContextKey */]('listHasSelectionOrFocus', false);
var WorkbenchListDoubleSelection = new __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["f" /* RawContextKey */]('listDoubleSelection', false);
var WorkbenchListMultiSelection = new __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["f" /* RawContextKey */]('listMultiSelection', false);
function createScopedContextKeyService(contextKeyService, widget) {
    var result = contextKeyService.createScoped(widget.getHTMLElement());
    RawWorkbenchListFocusContextKey.bindTo(result);
    return result;
}
var multiSelectModifierSettingKey = 'workbench.list.multiSelectModifier';
var openModeSettingKey = 'workbench.list.openMode';
var horizontalScrollingKey = 'workbench.tree.horizontalScrolling';
function useAltAsMultipleSelectionModifier(configurationService) {
    return configurationService.getValue(multiSelectModifierSettingKey) === 'alt';
}
function useSingleClickToOpen(configurationService) {
    return configurationService.getValue(openModeSettingKey) !== 'doubleClick';
}
var sharedTreeStyleSheet;
function getSharedTreeStyleSheet() {
    if (!sharedTreeStyleSheet) {
        sharedTreeStyleSheet = Object(__WEBPACK_IMPORTED_MODULE_12__base_browser_dom_js__["o" /* createStyleSheet */])();
    }
    return sharedTreeStyleSheet;
}
function handleTreeController(configuration, instantiationService) {
    if (!configuration.controller) {
        configuration.controller = instantiationService.createInstance(WorkbenchTreeController, {});
    }
    if (!configuration.styler) {
        configuration.styler = new __WEBPACK_IMPORTED_MODULE_10__base_parts_tree_browser_treeDefaults_js__["f" /* DefaultTreestyler */](getSharedTreeStyleSheet());
    }
    return configuration;
}
var WorkbenchTree = /** @class */ (function (_super) {
    __extends(WorkbenchTree, _super);
    function WorkbenchTree(container, configuration, options, contextKeyService, listService, themeService, instantiationService, configurationService) {
        var _this = this;
        var config = handleTreeController(configuration, instantiationService);
        var horizontalScrollMode = configurationService.getValue(horizontalScrollingKey) ? __WEBPACK_IMPORTED_MODULE_13__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Auto : __WEBPACK_IMPORTED_MODULE_13__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden;
        var opts = __assign({ horizontalScrollMode: horizontalScrollMode, keyboardSupport: false }, Object(__WEBPACK_IMPORTED_MODULE_4__theme_common_styler_js__["d" /* computeStyles */])(themeService.getTheme(), __WEBPACK_IMPORTED_MODULE_4__theme_common_styler_js__["e" /* defaultListStyles */]), options);
        _this = _super.call(this, container, config, opts) || this;
        _this.disposables = [];
        _this.contextKeyService = createScopedContextKeyService(contextKeyService, _this);
        WorkbenchListSupportsMultiSelectContextKey.bindTo(_this.contextKeyService);
        _this.listHasSelectionOrFocus = WorkbenchListHasSelectionOrFocus.bindTo(_this.contextKeyService);
        _this.listDoubleSelection = WorkbenchListDoubleSelection.bindTo(_this.contextKeyService);
        _this.listMultiSelection = WorkbenchListMultiSelection.bindTo(_this.contextKeyService);
        _this._openOnSingleClick = useSingleClickToOpen(configurationService);
        _this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
        _this.disposables.push(_this.contextKeyService, listService.register(_this), Object(__WEBPACK_IMPORTED_MODULE_4__theme_common_styler_js__["b" /* attachListStyler */])(_this, themeService));
        _this.disposables.push(_this.onDidChangeSelection(function () {
            var selection = _this.getSelection();
            var focus = _this.getFocus();
            _this.listHasSelectionOrFocus.set((selection && selection.length > 0) || !!focus);
            _this.listDoubleSelection.set(selection && selection.length === 2);
            _this.listMultiSelection.set(selection && selection.length > 1);
        }));
        _this.disposables.push(_this.onDidChangeFocus(function () {
            var selection = _this.getSelection();
            var focus = _this.getFocus();
            _this.listHasSelectionOrFocus.set((selection && selection.length > 0) || !!focus);
        }));
        _this.disposables.push(configurationService.onDidChangeConfiguration(function (e) {
            if (e.affectsConfiguration(openModeSettingKey)) {
                _this._openOnSingleClick = useSingleClickToOpen(configurationService);
            }
            if (e.affectsConfiguration(multiSelectModifierSettingKey)) {
                _this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
            }
        }));
        return _this;
    }
    WorkbenchTree.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    WorkbenchTree = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(4, IListService),
        __param(5, __WEBPACK_IMPORTED_MODULE_5__theme_common_themeService_js__["c" /* IThemeService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_6__configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], WorkbenchTree);
    return WorkbenchTree;
}(__WEBPACK_IMPORTED_MODULE_3__base_parts_tree_browser_treeImpl_js__["a" /* Tree */]));

function massageControllerOptions(options) {
    if (typeof options.keyboardSupport !== 'boolean') {
        options.keyboardSupport = false;
    }
    if (typeof options.clickBehavior !== 'number') {
        options.clickBehavior = __WEBPACK_IMPORTED_MODULE_10__base_parts_tree_browser_treeDefaults_js__["a" /* ClickBehavior */].ON_MOUSE_DOWN;
    }
    return options;
}
var WorkbenchTreeController = /** @class */ (function (_super) {
    __extends(WorkbenchTreeController, _super);
    function WorkbenchTreeController(options, configurationService) {
        var _this = _super.call(this, massageControllerOptions(options)) || this;
        _this.configurationService = configurationService;
        _this.disposables = [];
        // if the open mode is not set, we configure it based on settings
        if (Object(__WEBPACK_IMPORTED_MODULE_11__base_common_types_js__["j" /* isUndefinedOrNull */])(options.openMode)) {
            _this.setOpenMode(_this.getOpenModeSetting());
            _this.registerListeners();
        }
        return _this;
    }
    WorkbenchTreeController.prototype.registerListeners = function () {
        var _this = this;
        this.disposables.push(this.configurationService.onDidChangeConfiguration(function (e) {
            if (e.affectsConfiguration(openModeSettingKey)) {
                _this.setOpenMode(_this.getOpenModeSetting());
            }
        }));
    };
    WorkbenchTreeController.prototype.getOpenModeSetting = function () {
        return useSingleClickToOpen(this.configurationService) ? __WEBPACK_IMPORTED_MODULE_10__base_parts_tree_browser_treeDefaults_js__["g" /* OpenMode */].SINGLE_CLICK : __WEBPACK_IMPORTED_MODULE_10__base_parts_tree_browser_treeDefaults_js__["g" /* OpenMode */].DOUBLE_CLICK;
    };
    WorkbenchTreeController.prototype.dispose = function () {
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    WorkbenchTreeController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_6__configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], WorkbenchTreeController);
    return WorkbenchTreeController;
}(__WEBPACK_IMPORTED_MODULE_10__base_parts_tree_browser_treeDefaults_js__["c" /* DefaultController */]));

var configurationRegistry = __WEBPACK_IMPORTED_MODULE_8__registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_9__configuration_common_configurationRegistry_js__["b" /* Extensions */].Configuration);
configurationRegistry.registerConfiguration({
    'id': 'workbench',
    'order': 7,
    'title': Object(__WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */])('workbenchConfigurationTitle', "Workbench"),
    'type': 'object',
    'properties': (_a = {},
        _a[multiSelectModifierSettingKey] = {
            'type': 'string',
            'enum': ['ctrlCmd', 'alt'],
            'enumDescriptions': [
                Object(__WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */])('multiSelectModifier.ctrlCmd', "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
                Object(__WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */])('multiSelectModifier.alt', "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
            ],
            'default': 'ctrlCmd',
            'description': Object(__WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */])({
                key: 'multiSelectModifier',
                comment: [
                    '- `ctrlCmd` refers to a value the setting can take and should not be localized.',
                    '- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized.'
                ]
            }, "The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.")
        },
        _a[openModeSettingKey] = {
            'type': 'string',
            'enum': ['singleClick', 'doubleClick'],
            'default': 'singleClick',
            'description': Object(__WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */])({
                key: 'openModeModifier',
                comment: ['`singleClick` and `doubleClick` refers to a value the setting can take and should not be localized.']
            }, "Controls how to open items in trees and lists using the mouse (if supported). For parents with children in trees, this setting will control if a single click expands the parent or a double click. Note that some trees and lists might choose to ignore this setting if it is not applicable. ")
        },
        _a[horizontalScrollingKey] = {
            'type': 'boolean',
            'default': false,
            'description': Object(__WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */])('horizontalScrolling setting', "Controls whether trees support horizontal scrolling in the workbench.")
        },
        _a)
});


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = stringDiff;
/* unused harmony export Debug */
/* unused harmony export MyArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LcsDiff; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__diffChange_js__ = __webpack_require__(455);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


function createStringSequence(a) {
    return {
        getLength: function () { return a.length; },
        getElementAtIndex: function (pos) { return a.charCodeAt(pos); }
    };
}
function stringDiff(original, modified, pretty) {
    return new LcsDiff(createStringSequence(original), createStringSequence(modified)).ComputeDiff(pretty);
}
//
// The code below has been ported from a C# implementation in VS
//
var Debug = /** @class */ (function () {
    function Debug() {
    }
    Debug.Assert = function (condition, message) {
        if (!condition) {
            throw new Error(message);
        }
    };
    return Debug;
}());

var MyArray = /** @class */ (function () {
    function MyArray() {
    }
    /**
     * Copies a range of elements from an Array starting at the specified source index and pastes
     * them to another Array starting at the specified destination index. The length and the indexes
     * are specified as 64-bit integers.
     * sourceArray:
     *		The Array that contains the data to copy.
     * sourceIndex:
     *		A 64-bit integer that represents the index in the sourceArray at which copying begins.
     * destinationArray:
     *		The Array that receives the data.
     * destinationIndex:
     *		A 64-bit integer that represents the index in the destinationArray at which storing begins.
     * length:
     *		A 64-bit integer that represents the number of elements to copy.
     */
    MyArray.Copy = function (sourceArray, sourceIndex, destinationArray, destinationIndex, length) {
        for (var i = 0; i < length; i++) {
            destinationArray[destinationIndex + i] = sourceArray[sourceIndex + i];
        }
    };
    return MyArray;
}());

//*****************************************************************************
// LcsDiff.cs
//
// An implementation of the difference algorithm described in
// "An O(ND) Difference Algorithm and its variations" by Eugene W. Myers
//
// Copyright (C) 2008 Microsoft Corporation @minifier_do_not_preserve
//*****************************************************************************
// Our total memory usage for storing history is (worst-case):
// 2 * [(MaxDifferencesHistory + 1) * (MaxDifferencesHistory + 1) - 1] * sizeof(int)
// 2 * [1448*1448 - 1] * 4 = 16773624 = 16MB
var MaxDifferencesHistory = 1447;
//let MaxDifferencesHistory = 100;
/**
 * A utility class which helps to create the set of DiffChanges from
 * a difference operation. This class accepts original DiffElements and
 * modified DiffElements that are involved in a particular change. The
 * MarktNextChange() method can be called to mark the separation between
 * distinct changes. At the end, the Changes property can be called to retrieve
 * the constructed changes.
 */
var DiffChangeHelper = /** @class */ (function () {
    /**
     * Constructs a new DiffChangeHelper for the given DiffSequences.
     */
    function DiffChangeHelper() {
        this.m_changes = [];
        this.m_originalStart = Number.MAX_VALUE;
        this.m_modifiedStart = Number.MAX_VALUE;
        this.m_originalCount = 0;
        this.m_modifiedCount = 0;
    }
    /**
     * Marks the beginning of the next change in the set of differences.
     */
    DiffChangeHelper.prototype.MarkNextChange = function () {
        // Only add to the list if there is something to add
        if (this.m_originalCount > 0 || this.m_modifiedCount > 0) {
            // Add the new change to our list
            this.m_changes.push(new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](this.m_originalStart, this.m_originalCount, this.m_modifiedStart, this.m_modifiedCount));
        }
        // Reset for the next change
        this.m_originalCount = 0;
        this.m_modifiedCount = 0;
        this.m_originalStart = Number.MAX_VALUE;
        this.m_modifiedStart = Number.MAX_VALUE;
    };
    /**
     * Adds the original element at the given position to the elements
     * affected by the current change. The modified index gives context
     * to the change position with respect to the original sequence.
     * @param originalIndex The index of the original element to add.
     * @param modifiedIndex The index of the modified element that provides corresponding position in the modified sequence.
     */
    DiffChangeHelper.prototype.AddOriginalElement = function (originalIndex, modifiedIndex) {
        // The 'true' start index is the smallest of the ones we've seen
        this.m_originalStart = Math.min(this.m_originalStart, originalIndex);
        this.m_modifiedStart = Math.min(this.m_modifiedStart, modifiedIndex);
        this.m_originalCount++;
    };
    /**
     * Adds the modified element at the given position to the elements
     * affected by the current change. The original index gives context
     * to the change position with respect to the modified sequence.
     * @param originalIndex The index of the original element that provides corresponding position in the original sequence.
     * @param modifiedIndex The index of the modified element to add.
     */
    DiffChangeHelper.prototype.AddModifiedElement = function (originalIndex, modifiedIndex) {
        // The 'true' start index is the smallest of the ones we've seen
        this.m_originalStart = Math.min(this.m_originalStart, originalIndex);
        this.m_modifiedStart = Math.min(this.m_modifiedStart, modifiedIndex);
        this.m_modifiedCount++;
    };
    /**
     * Retrieves all of the changes marked by the class.
     */
    DiffChangeHelper.prototype.getChanges = function () {
        if (this.m_originalCount > 0 || this.m_modifiedCount > 0) {
            // Finish up on whatever is left
            this.MarkNextChange();
        }
        return this.m_changes;
    };
    /**
     * Retrieves all of the changes marked by the class in the reverse order
     */
    DiffChangeHelper.prototype.getReverseChanges = function () {
        if (this.m_originalCount > 0 || this.m_modifiedCount > 0) {
            // Finish up on whatever is left
            this.MarkNextChange();
        }
        this.m_changes.reverse();
        return this.m_changes;
    };
    return DiffChangeHelper;
}());
/**
 * An implementation of the difference algorithm described in
 * "An O(ND) Difference Algorithm and its variations" by Eugene W. Myers
 */
var LcsDiff = /** @class */ (function () {
    /**
     * Constructs the DiffFinder
     */
    function LcsDiff(originalSequence, newSequence, continueProcessingPredicate) {
        if (continueProcessingPredicate === void 0) { continueProcessingPredicate = null; }
        this.OriginalSequence = originalSequence;
        this.ModifiedSequence = newSequence;
        this.ContinueProcessingPredicate = continueProcessingPredicate;
        this.m_forwardHistory = [];
        this.m_reverseHistory = [];
    }
    LcsDiff.prototype.ElementsAreEqual = function (originalIndex, newIndex) {
        return (this.OriginalSequence.getElementAtIndex(originalIndex) === this.ModifiedSequence.getElementAtIndex(newIndex));
    };
    LcsDiff.prototype.OriginalElementsAreEqual = function (index1, index2) {
        return (this.OriginalSequence.getElementAtIndex(index1) === this.OriginalSequence.getElementAtIndex(index2));
    };
    LcsDiff.prototype.ModifiedElementsAreEqual = function (index1, index2) {
        return (this.ModifiedSequence.getElementAtIndex(index1) === this.ModifiedSequence.getElementAtIndex(index2));
    };
    LcsDiff.prototype.ComputeDiff = function (pretty) {
        return this._ComputeDiff(0, this.OriginalSequence.getLength() - 1, 0, this.ModifiedSequence.getLength() - 1, pretty);
    };
    /**
     * Computes the differences between the original and modified input
     * sequences on the bounded range.
     * @returns An array of the differences between the two input sequences.
     */
    LcsDiff.prototype._ComputeDiff = function (originalStart, originalEnd, modifiedStart, modifiedEnd, pretty) {
        var quitEarlyArr = [false];
        var changes = this.ComputeDiffRecursive(originalStart, originalEnd, modifiedStart, modifiedEnd, quitEarlyArr);
        if (pretty) {
            // We have to clean up the computed diff to be more intuitive
            // but it turns out this cannot be done correctly until the entire set
            // of diffs have been computed
            return this.ShiftChanges(changes);
        }
        return changes;
    };
    /**
     * Private helper method which computes the differences on the bounded range
     * recursively.
     * @returns An array of the differences between the two input sequences.
     */
    LcsDiff.prototype.ComputeDiffRecursive = function (originalStart, originalEnd, modifiedStart, modifiedEnd, quitEarlyArr) {
        quitEarlyArr[0] = false;
        // Find the start of the differences
        while (originalStart <= originalEnd && modifiedStart <= modifiedEnd && this.ElementsAreEqual(originalStart, modifiedStart)) {
            originalStart++;
            modifiedStart++;
        }
        // Find the end of the differences
        while (originalEnd >= originalStart && modifiedEnd >= modifiedStart && this.ElementsAreEqual(originalEnd, modifiedEnd)) {
            originalEnd--;
            modifiedEnd--;
        }
        // In the special case where we either have all insertions or all deletions or the sequences are identical
        if (originalStart > originalEnd || modifiedStart > modifiedEnd) {
            var changes = void 0;
            if (modifiedStart <= modifiedEnd) {
                Debug.Assert(originalStart === originalEnd + 1, 'originalStart should only be one more than originalEnd');
                // All insertions
                changes = [
                    new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](originalStart, 0, modifiedStart, modifiedEnd - modifiedStart + 1)
                ];
            }
            else if (originalStart <= originalEnd) {
                Debug.Assert(modifiedStart === modifiedEnd + 1, 'modifiedStart should only be one more than modifiedEnd');
                // All deletions
                changes = [
                    new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](originalStart, originalEnd - originalStart + 1, modifiedStart, 0)
                ];
            }
            else {
                Debug.Assert(originalStart === originalEnd + 1, 'originalStart should only be one more than originalEnd');
                Debug.Assert(modifiedStart === modifiedEnd + 1, 'modifiedStart should only be one more than modifiedEnd');
                // Identical sequences - No differences
                changes = [];
            }
            return changes;
        }
        // This problem can be solved using the Divide-And-Conquer technique.
        var midOriginalArr = [0], midModifiedArr = [0];
        var result = this.ComputeRecursionPoint(originalStart, originalEnd, modifiedStart, modifiedEnd, midOriginalArr, midModifiedArr, quitEarlyArr);
        var midOriginal = midOriginalArr[0];
        var midModified = midModifiedArr[0];
        if (result !== null) {
            // Result is not-null when there was enough memory to compute the changes while
            // searching for the recursion point
            return result;
        }
        else if (!quitEarlyArr[0]) {
            // We can break the problem down recursively by finding the changes in the
            // First Half:   (originalStart, modifiedStart) to (midOriginal, midModified)
            // Second Half:  (midOriginal + 1, minModified + 1) to (originalEnd, modifiedEnd)
            // NOTE: ComputeDiff() is inclusive, therefore the second range starts on the next point
            var leftChanges = this.ComputeDiffRecursive(originalStart, midOriginal, modifiedStart, midModified, quitEarlyArr);
            var rightChanges = [];
            if (!quitEarlyArr[0]) {
                rightChanges = this.ComputeDiffRecursive(midOriginal + 1, originalEnd, midModified + 1, modifiedEnd, quitEarlyArr);
            }
            else {
                // We did't have time to finish the first half, so we don't have time to compute this half.
                // Consider the entire rest of the sequence different.
                rightChanges = [
                    new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](midOriginal + 1, originalEnd - (midOriginal + 1) + 1, midModified + 1, modifiedEnd - (midModified + 1) + 1)
                ];
            }
            return this.ConcatenateChanges(leftChanges, rightChanges);
        }
        // If we hit here, we quit early, and so can't return anything meaningful
        return [
            new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](originalStart, originalEnd - originalStart + 1, modifiedStart, modifiedEnd - modifiedStart + 1)
        ];
    };
    LcsDiff.prototype.WALKTRACE = function (diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr) {
        var forwardChanges = null, reverseChanges = null;
        // First, walk backward through the forward diagonals history
        var changeHelper = new DiffChangeHelper();
        var diagonalMin = diagonalForwardStart;
        var diagonalMax = diagonalForwardEnd;
        var diagonalRelative = (midOriginalArr[0] - midModifiedArr[0]) - diagonalForwardOffset;
        var lastOriginalIndex = Number.MIN_VALUE;
        var historyIndex = this.m_forwardHistory.length - 1;
        var diagonal;
        do {
            // Get the diagonal index from the relative diagonal number
            diagonal = diagonalRelative + diagonalForwardBase;
            // Figure out where we came from
            if (diagonal === diagonalMin || (diagonal < diagonalMax && forwardPoints[diagonal - 1] < forwardPoints[diagonal + 1])) {
                // Vertical line (the element is an insert)
                originalIndex = forwardPoints[diagonal + 1];
                modifiedIndex = originalIndex - diagonalRelative - diagonalForwardOffset;
                if (originalIndex < lastOriginalIndex) {
                    changeHelper.MarkNextChange();
                }
                lastOriginalIndex = originalIndex;
                changeHelper.AddModifiedElement(originalIndex + 1, modifiedIndex);
                diagonalRelative = (diagonal + 1) - diagonalForwardBase; //Setup for the next iteration
            }
            else {
                // Horizontal line (the element is a deletion)
                originalIndex = forwardPoints[diagonal - 1] + 1;
                modifiedIndex = originalIndex - diagonalRelative - diagonalForwardOffset;
                if (originalIndex < lastOriginalIndex) {
                    changeHelper.MarkNextChange();
                }
                lastOriginalIndex = originalIndex - 1;
                changeHelper.AddOriginalElement(originalIndex, modifiedIndex + 1);
                diagonalRelative = (diagonal - 1) - diagonalForwardBase; //Setup for the next iteration
            }
            if (historyIndex >= 0) {
                forwardPoints = this.m_forwardHistory[historyIndex];
                diagonalForwardBase = forwardPoints[0]; //We stored this in the first spot
                diagonalMin = 1;
                diagonalMax = forwardPoints.length - 1;
            }
        } while (--historyIndex >= -1);
        // Ironically, we get the forward changes as the reverse of the
        // order we added them since we technically added them backwards
        forwardChanges = changeHelper.getReverseChanges();
        if (quitEarlyArr[0]) {
            // TODO: Calculate a partial from the reverse diagonals.
            //       For now, just assume everything after the midOriginal/midModified point is a diff
            var originalStartPoint = midOriginalArr[0] + 1;
            var modifiedStartPoint = midModifiedArr[0] + 1;
            if (forwardChanges !== null && forwardChanges.length > 0) {
                var lastForwardChange = forwardChanges[forwardChanges.length - 1];
                originalStartPoint = Math.max(originalStartPoint, lastForwardChange.getOriginalEnd());
                modifiedStartPoint = Math.max(modifiedStartPoint, lastForwardChange.getModifiedEnd());
            }
            reverseChanges = [
                new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](originalStartPoint, originalEnd - originalStartPoint + 1, modifiedStartPoint, modifiedEnd - modifiedStartPoint + 1)
            ];
        }
        else {
            // Now walk backward through the reverse diagonals history
            changeHelper = new DiffChangeHelper();
            diagonalMin = diagonalReverseStart;
            diagonalMax = diagonalReverseEnd;
            diagonalRelative = (midOriginalArr[0] - midModifiedArr[0]) - diagonalReverseOffset;
            lastOriginalIndex = Number.MAX_VALUE;
            historyIndex = (deltaIsEven) ? this.m_reverseHistory.length - 1 : this.m_reverseHistory.length - 2;
            do {
                // Get the diagonal index from the relative diagonal number
                diagonal = diagonalRelative + diagonalReverseBase;
                // Figure out where we came from
                if (diagonal === diagonalMin || (diagonal < diagonalMax && reversePoints[diagonal - 1] >= reversePoints[diagonal + 1])) {
                    // Horizontal line (the element is a deletion))
                    originalIndex = reversePoints[diagonal + 1] - 1;
                    modifiedIndex = originalIndex - diagonalRelative - diagonalReverseOffset;
                    if (originalIndex > lastOriginalIndex) {
                        changeHelper.MarkNextChange();
                    }
                    lastOriginalIndex = originalIndex + 1;
                    changeHelper.AddOriginalElement(originalIndex + 1, modifiedIndex + 1);
                    diagonalRelative = (diagonal + 1) - diagonalReverseBase; //Setup for the next iteration
                }
                else {
                    // Vertical line (the element is an insertion)
                    originalIndex = reversePoints[diagonal - 1];
                    modifiedIndex = originalIndex - diagonalRelative - diagonalReverseOffset;
                    if (originalIndex > lastOriginalIndex) {
                        changeHelper.MarkNextChange();
                    }
                    lastOriginalIndex = originalIndex;
                    changeHelper.AddModifiedElement(originalIndex + 1, modifiedIndex + 1);
                    diagonalRelative = (diagonal - 1) - diagonalReverseBase; //Setup for the next iteration
                }
                if (historyIndex >= 0) {
                    reversePoints = this.m_reverseHistory[historyIndex];
                    diagonalReverseBase = reversePoints[0]; //We stored this in the first spot
                    diagonalMin = 1;
                    diagonalMax = reversePoints.length - 1;
                }
            } while (--historyIndex >= -1);
            // There are cases where the reverse history will find diffs that
            // are correct, but not intuitive, so we need shift them.
            reverseChanges = changeHelper.getChanges();
        }
        return this.ConcatenateChanges(forwardChanges, reverseChanges);
    };
    /**
     * Given the range to compute the diff on, this method finds the point:
     * (midOriginal, midModified)
     * that exists in the middle of the LCS of the two sequences and
     * is the point at which the LCS problem may be broken down recursively.
     * This method will try to keep the LCS trace in memory. If the LCS recursion
     * point is calculated and the full trace is available in memory, then this method
     * will return the change list.
     * @param originalStart The start bound of the original sequence range
     * @param originalEnd The end bound of the original sequence range
     * @param modifiedStart The start bound of the modified sequence range
     * @param modifiedEnd The end bound of the modified sequence range
     * @param midOriginal The middle point of the original sequence range
     * @param midModified The middle point of the modified sequence range
     * @returns The diff changes, if available, otherwise null
     */
    LcsDiff.prototype.ComputeRecursionPoint = function (originalStart, originalEnd, modifiedStart, modifiedEnd, midOriginalArr, midModifiedArr, quitEarlyArr) {
        var originalIndex, modifiedIndex;
        var diagonalForwardStart = 0, diagonalForwardEnd = 0;
        var diagonalReverseStart = 0, diagonalReverseEnd = 0;
        var numDifferences;
        // To traverse the edit graph and produce the proper LCS, our actual
        // start position is just outside the given boundary
        originalStart--;
        modifiedStart--;
        // We set these up to make the compiler happy, but they will
        // be replaced before we return with the actual recursion point
        midOriginalArr[0] = 0;
        midModifiedArr[0] = 0;
        // Clear out the history
        this.m_forwardHistory = [];
        this.m_reverseHistory = [];
        // Each cell in the two arrays corresponds to a diagonal in the edit graph.
        // The integer value in the cell represents the originalIndex of the furthest
        // reaching point found so far that ends in that diagonal.
        // The modifiedIndex can be computed mathematically from the originalIndex and the diagonal number.
        var maxDifferences = (originalEnd - originalStart) + (modifiedEnd - modifiedStart);
        var numDiagonals = maxDifferences + 1;
        var forwardPoints = new Array(numDiagonals);
        var reversePoints = new Array(numDiagonals);
        // diagonalForwardBase: Index into forwardPoints of the diagonal which passes through (originalStart, modifiedStart)
        // diagonalReverseBase: Index into reversePoints of the diagonal which passes through (originalEnd, modifiedEnd)
        var diagonalForwardBase = (modifiedEnd - modifiedStart);
        var diagonalReverseBase = (originalEnd - originalStart);
        // diagonalForwardOffset: Geometric offset which allows modifiedIndex to be computed from originalIndex and the
        //    diagonal number (relative to diagonalForwardBase)
        // diagonalReverseOffset: Geometric offset which allows modifiedIndex to be computed from originalIndex and the
        //    diagonal number (relative to diagonalReverseBase)
        var diagonalForwardOffset = (originalStart - modifiedStart);
        var diagonalReverseOffset = (originalEnd - modifiedEnd);
        // delta: The difference between the end diagonal and the start diagonal. This is used to relate diagonal numbers
        //   relative to the start diagonal with diagonal numbers relative to the end diagonal.
        // The Even/Oddn-ness of this delta is important for determining when we should check for overlap
        var delta = diagonalReverseBase - diagonalForwardBase;
        var deltaIsEven = (delta % 2 === 0);
        // Here we set up the start and end points as the furthest points found so far
        // in both the forward and reverse directions, respectively
        forwardPoints[diagonalForwardBase] = originalStart;
        reversePoints[diagonalReverseBase] = originalEnd;
        // Remember if we quit early, and thus need to do a best-effort result instead of a real result.
        quitEarlyArr[0] = false;
        // A couple of points:
        // --With this method, we iterate on the number of differences between the two sequences.
        //   The more differences there actually are, the longer this will take.
        // --Also, as the number of differences increases, we have to search on diagonals further
        //   away from the reference diagonal (which is diagonalForwardBase for forward, diagonalReverseBase for reverse).
        // --We extend on even diagonals (relative to the reference diagonal) only when numDifferences
        //   is even and odd diagonals only when numDifferences is odd.
        var diagonal, tempOriginalIndex;
        for (numDifferences = 1; numDifferences <= (maxDifferences / 2) + 1; numDifferences++) {
            var furthestOriginalIndex = 0;
            var furthestModifiedIndex = 0;
            // Run the algorithm in the forward direction
            diagonalForwardStart = this.ClipDiagonalBound(diagonalForwardBase - numDifferences, numDifferences, diagonalForwardBase, numDiagonals);
            diagonalForwardEnd = this.ClipDiagonalBound(diagonalForwardBase + numDifferences, numDifferences, diagonalForwardBase, numDiagonals);
            for (diagonal = diagonalForwardStart; diagonal <= diagonalForwardEnd; diagonal += 2) {
                // STEP 1: We extend the furthest reaching point in the present diagonal
                // by looking at the diagonals above and below and picking the one whose point
                // is further away from the start point (originalStart, modifiedStart)
                if (diagonal === diagonalForwardStart || (diagonal < diagonalForwardEnd && forwardPoints[diagonal - 1] < forwardPoints[diagonal + 1])) {
                    originalIndex = forwardPoints[diagonal + 1];
                }
                else {
                    originalIndex = forwardPoints[diagonal - 1] + 1;
                }
                modifiedIndex = originalIndex - (diagonal - diagonalForwardBase) - diagonalForwardOffset;
                // Save the current originalIndex so we can test for false overlap in step 3
                tempOriginalIndex = originalIndex;
                // STEP 2: We can continue to extend the furthest reaching point in the present diagonal
                // so long as the elements are equal.
                while (originalIndex < originalEnd && modifiedIndex < modifiedEnd && this.ElementsAreEqual(originalIndex + 1, modifiedIndex + 1)) {
                    originalIndex++;
                    modifiedIndex++;
                }
                forwardPoints[diagonal] = originalIndex;
                if (originalIndex + modifiedIndex > furthestOriginalIndex + furthestModifiedIndex) {
                    furthestOriginalIndex = originalIndex;
                    furthestModifiedIndex = modifiedIndex;
                }
                // STEP 3: If delta is odd (overlap first happens on forward when delta is odd)
                // and diagonal is in the range of reverse diagonals computed for numDifferences-1
                // (the previous iteration; we haven't computed reverse diagonals for numDifferences yet)
                // then check for overlap.
                if (!deltaIsEven && Math.abs(diagonal - diagonalReverseBase) <= (numDifferences - 1)) {
                    if (originalIndex >= reversePoints[diagonal]) {
                        midOriginalArr[0] = originalIndex;
                        midModifiedArr[0] = modifiedIndex;
                        if (tempOriginalIndex <= reversePoints[diagonal] && MaxDifferencesHistory > 0 && numDifferences <= (MaxDifferencesHistory + 1)) {
                            // BINGO! We overlapped, and we have the full trace in memory!
                            return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
                        }
                        else {
                            // Either false overlap, or we didn't have enough memory for the full trace
                            // Just return the recursion point
                            return null;
                        }
                    }
                }
            }
            // Check to see if we should be quitting early, before moving on to the next iteration.
            var matchLengthOfLongest = ((furthestOriginalIndex - originalStart) + (furthestModifiedIndex - modifiedStart) - numDifferences) / 2;
            if (this.ContinueProcessingPredicate !== null && !this.ContinueProcessingPredicate(furthestOriginalIndex, this.OriginalSequence, matchLengthOfLongest)) {
                // We can't finish, so skip ahead to generating a result from what we have.
                quitEarlyArr[0] = true;
                // Use the furthest distance we got in the forward direction.
                midOriginalArr[0] = furthestOriginalIndex;
                midModifiedArr[0] = furthestModifiedIndex;
                if (matchLengthOfLongest > 0 && MaxDifferencesHistory > 0 && numDifferences <= (MaxDifferencesHistory + 1)) {
                    // Enough of the history is in memory to walk it backwards
                    return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
                }
                else {
                    // We didn't actually remember enough of the history.
                    //Since we are quiting the diff early, we need to shift back the originalStart and modified start
                    //back into the boundary limits since we decremented their value above beyond the boundary limit.
                    originalStart++;
                    modifiedStart++;
                    return [
                        new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](originalStart, originalEnd - originalStart + 1, modifiedStart, modifiedEnd - modifiedStart + 1)
                    ];
                }
            }
            // Run the algorithm in the reverse direction
            diagonalReverseStart = this.ClipDiagonalBound(diagonalReverseBase - numDifferences, numDifferences, diagonalReverseBase, numDiagonals);
            diagonalReverseEnd = this.ClipDiagonalBound(diagonalReverseBase + numDifferences, numDifferences, diagonalReverseBase, numDiagonals);
            for (diagonal = diagonalReverseStart; diagonal <= diagonalReverseEnd; diagonal += 2) {
                // STEP 1: We extend the furthest reaching point in the present diagonal
                // by looking at the diagonals above and below and picking the one whose point
                // is further away from the start point (originalEnd, modifiedEnd)
                if (diagonal === diagonalReverseStart || (diagonal < diagonalReverseEnd && reversePoints[diagonal - 1] >= reversePoints[diagonal + 1])) {
                    originalIndex = reversePoints[diagonal + 1] - 1;
                }
                else {
                    originalIndex = reversePoints[diagonal - 1];
                }
                modifiedIndex = originalIndex - (diagonal - diagonalReverseBase) - diagonalReverseOffset;
                // Save the current originalIndex so we can test for false overlap
                tempOriginalIndex = originalIndex;
                // STEP 2: We can continue to extend the furthest reaching point in the present diagonal
                // as long as the elements are equal.
                while (originalIndex > originalStart && modifiedIndex > modifiedStart && this.ElementsAreEqual(originalIndex, modifiedIndex)) {
                    originalIndex--;
                    modifiedIndex--;
                }
                reversePoints[diagonal] = originalIndex;
                // STEP 4: If delta is even (overlap first happens on reverse when delta is even)
                // and diagonal is in the range of forward diagonals computed for numDifferences
                // then check for overlap.
                if (deltaIsEven && Math.abs(diagonal - diagonalForwardBase) <= numDifferences) {
                    if (originalIndex <= forwardPoints[diagonal]) {
                        midOriginalArr[0] = originalIndex;
                        midModifiedArr[0] = modifiedIndex;
                        if (tempOriginalIndex >= forwardPoints[diagonal] && MaxDifferencesHistory > 0 && numDifferences <= (MaxDifferencesHistory + 1)) {
                            // BINGO! We overlapped, and we have the full trace in memory!
                            return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
                        }
                        else {
                            // Either false overlap, or we didn't have enough memory for the full trace
                            // Just return the recursion point
                            return null;
                        }
                    }
                }
            }
            // Save current vectors to history before the next iteration
            if (numDifferences <= MaxDifferencesHistory) {
                // We are allocating space for one extra int, which we fill with
                // the index of the diagonal base index
                var temp = new Array(diagonalForwardEnd - diagonalForwardStart + 2);
                temp[0] = diagonalForwardBase - diagonalForwardStart + 1;
                MyArray.Copy(forwardPoints, diagonalForwardStart, temp, 1, diagonalForwardEnd - diagonalForwardStart + 1);
                this.m_forwardHistory.push(temp);
                temp = new Array(diagonalReverseEnd - diagonalReverseStart + 2);
                temp[0] = diagonalReverseBase - diagonalReverseStart + 1;
                MyArray.Copy(reversePoints, diagonalReverseStart, temp, 1, diagonalReverseEnd - diagonalReverseStart + 1);
                this.m_reverseHistory.push(temp);
            }
        }
        // If we got here, then we have the full trace in history. We just have to convert it to a change list
        // NOTE: This part is a bit messy
        return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
    };
    /**
     * Shifts the given changes to provide a more intuitive diff.
     * While the first element in a diff matches the first element after the diff,
     * we shift the diff down.
     *
     * @param changes The list of changes to shift
     * @returns The shifted changes
     */
    LcsDiff.prototype.ShiftChanges = function (changes) {
        var mergedDiffs;
        do {
            mergedDiffs = false;
            // Shift all the changes down first
            for (var i = 0; i < changes.length; i++) {
                var change = changes[i];
                var originalStop = (i < changes.length - 1) ? changes[i + 1].originalStart : this.OriginalSequence.getLength();
                var modifiedStop = (i < changes.length - 1) ? changes[i + 1].modifiedStart : this.ModifiedSequence.getLength();
                var checkOriginal = change.originalLength > 0;
                var checkModified = change.modifiedLength > 0;
                while (change.originalStart + change.originalLength < originalStop &&
                    change.modifiedStart + change.modifiedLength < modifiedStop &&
                    (!checkOriginal || this.OriginalElementsAreEqual(change.originalStart, change.originalStart + change.originalLength)) &&
                    (!checkModified || this.ModifiedElementsAreEqual(change.modifiedStart, change.modifiedStart + change.modifiedLength))) {
                    change.originalStart++;
                    change.modifiedStart++;
                }
            }
            // Build up the new list (we have to build a new list because we
            // might have changes we can merge together now)
            var result = new Array();
            var mergedChangeArr = [null];
            for (var i = 0; i < changes.length; i++) {
                if (i < changes.length - 1 && this.ChangesOverlap(changes[i], changes[i + 1], mergedChangeArr)) {
                    mergedDiffs = true;
                    result.push(mergedChangeArr[0]);
                    i++;
                }
                else {
                    result.push(changes[i]);
                }
            }
            changes = result;
        } while (mergedDiffs);
        // Shift changes back up until we hit empty or whitespace-only lines
        for (var i = changes.length - 1; i >= 0; i--) {
            var change = changes[i];
            var originalStop = 0;
            var modifiedStop = 0;
            if (i > 0) {
                var prevChange = changes[i - 1];
                if (prevChange.originalLength > 0) {
                    originalStop = prevChange.originalStart + prevChange.originalLength;
                }
                if (prevChange.modifiedLength > 0) {
                    modifiedStop = prevChange.modifiedStart + prevChange.modifiedLength;
                }
            }
            var checkOriginal = change.originalLength > 0;
            var checkModified = change.modifiedLength > 0;
            var bestDelta = 0;
            var bestScore = this._boundaryScore(change.originalStart, change.originalLength, change.modifiedStart, change.modifiedLength);
            for (var delta = 1;; delta++) {
                var originalStart = change.originalStart - delta;
                var modifiedStart = change.modifiedStart - delta;
                if (originalStart < originalStop || modifiedStart < modifiedStop) {
                    break;
                }
                if (checkOriginal && !this.OriginalElementsAreEqual(originalStart, originalStart + change.originalLength)) {
                    break;
                }
                if (checkModified && !this.ModifiedElementsAreEqual(modifiedStart, modifiedStart + change.modifiedLength)) {
                    break;
                }
                var score = this._boundaryScore(originalStart, change.originalLength, modifiedStart, change.modifiedLength);
                if (score > bestScore) {
                    bestScore = score;
                    bestDelta = delta;
                }
            }
            change.originalStart -= bestDelta;
            change.modifiedStart -= bestDelta;
        }
        return changes;
    };
    LcsDiff.prototype._OriginalIsBoundary = function (index) {
        if (index <= 0 || index >= this.OriginalSequence.getLength() - 1) {
            return true;
        }
        var element = this.OriginalSequence.getElementAtIndex(index);
        return (typeof element === 'string' && /^\s*$/.test(element));
    };
    LcsDiff.prototype._OriginalRegionIsBoundary = function (originalStart, originalLength) {
        if (this._OriginalIsBoundary(originalStart) || this._OriginalIsBoundary(originalStart - 1)) {
            return true;
        }
        if (originalLength > 0) {
            var originalEnd = originalStart + originalLength;
            if (this._OriginalIsBoundary(originalEnd - 1) || this._OriginalIsBoundary(originalEnd)) {
                return true;
            }
        }
        return false;
    };
    LcsDiff.prototype._ModifiedIsBoundary = function (index) {
        if (index <= 0 || index >= this.ModifiedSequence.getLength() - 1) {
            return true;
        }
        var element = this.ModifiedSequence.getElementAtIndex(index);
        return (typeof element === 'string' && /^\s*$/.test(element));
    };
    LcsDiff.prototype._ModifiedRegionIsBoundary = function (modifiedStart, modifiedLength) {
        if (this._ModifiedIsBoundary(modifiedStart) || this._ModifiedIsBoundary(modifiedStart - 1)) {
            return true;
        }
        if (modifiedLength > 0) {
            var modifiedEnd = modifiedStart + modifiedLength;
            if (this._ModifiedIsBoundary(modifiedEnd - 1) || this._ModifiedIsBoundary(modifiedEnd)) {
                return true;
            }
        }
        return false;
    };
    LcsDiff.prototype._boundaryScore = function (originalStart, originalLength, modifiedStart, modifiedLength) {
        var originalScore = (this._OriginalRegionIsBoundary(originalStart, originalLength) ? 1 : 0);
        var modifiedScore = (this._ModifiedRegionIsBoundary(modifiedStart, modifiedLength) ? 1 : 0);
        return (originalScore + modifiedScore);
    };
    /**
     * Concatenates the two input DiffChange lists and returns the resulting
     * list.
     * @param The left changes
     * @param The right changes
     * @returns The concatenated list
     */
    LcsDiff.prototype.ConcatenateChanges = function (left, right) {
        var mergedChangeArr = [];
        var result = null;
        if (left.length === 0 || right.length === 0) {
            return (right.length > 0) ? right : left;
        }
        else if (this.ChangesOverlap(left[left.length - 1], right[0], mergedChangeArr)) {
            // Since we break the problem down recursively, it is possible that we
            // might recurse in the middle of a change thereby splitting it into
            // two changes. Here in the combining stage, we detect and fuse those
            // changes back together
            result = new Array(left.length + right.length - 1);
            MyArray.Copy(left, 0, result, 0, left.length - 1);
            result[left.length - 1] = mergedChangeArr[0];
            MyArray.Copy(right, 1, result, left.length, right.length - 1);
            return result;
        }
        else {
            result = new Array(left.length + right.length);
            MyArray.Copy(left, 0, result, 0, left.length);
            MyArray.Copy(right, 0, result, left.length, right.length);
            return result;
        }
    };
    /**
     * Returns true if the two changes overlap and can be merged into a single
     * change
     * @param left The left change
     * @param right The right change
     * @param mergedChange The merged change if the two overlap, null otherwise
     * @returns True if the two changes overlap
     */
    LcsDiff.prototype.ChangesOverlap = function (left, right, mergedChangeArr) {
        Debug.Assert(left.originalStart <= right.originalStart, 'Left change is not less than or equal to right change');
        Debug.Assert(left.modifiedStart <= right.modifiedStart, 'Left change is not less than or equal to right change');
        if (left.originalStart + left.originalLength >= right.originalStart || left.modifiedStart + left.modifiedLength >= right.modifiedStart) {
            var originalStart = left.originalStart;
            var originalLength = left.originalLength;
            var modifiedStart = left.modifiedStart;
            var modifiedLength = left.modifiedLength;
            if (left.originalStart + left.originalLength >= right.originalStart) {
                originalLength = right.originalStart + right.originalLength - left.originalStart;
            }
            if (left.modifiedStart + left.modifiedLength >= right.modifiedStart) {
                modifiedLength = right.modifiedStart + right.modifiedLength - left.modifiedStart;
            }
            mergedChangeArr[0] = new __WEBPACK_IMPORTED_MODULE_0__diffChange_js__["a" /* DiffChange */](originalStart, originalLength, modifiedStart, modifiedLength);
            return true;
        }
        else {
            mergedChangeArr[0] = null;
            return false;
        }
    };
    /**
     * Helper method used to clip a diagonal index to the range of valid
     * diagonals. This also decides whether or not the diagonal index,
     * if it exceeds the boundary, should be clipped to the boundary or clipped
     * one inside the boundary depending on the Even/Odd status of the boundary
     * and numDifferences.
     * @param diagonal The index of the diagonal to clip.
     * @param numDifferences The current number of differences being iterated upon.
     * @param diagonalBaseIndex The base reference diagonal.
     * @param numDiagonals The total number of diagonals.
     * @returns The clipped diagonal index.
     */
    LcsDiff.prototype.ClipDiagonalBound = function (diagonal, numDifferences, diagonalBaseIndex, numDiagonals) {
        if (diagonal >= 0 && diagonal < numDiagonals) {
            // Nothing to clip, its in range
            return diagonal;
        }
        // diagonalsBelow: The number of diagonals below the reference diagonal
        // diagonalsAbove: The number of diagonals above the reference diagonal
        var diagonalsBelow = diagonalBaseIndex;
        var diagonalsAbove = numDiagonals - diagonalBaseIndex - 1;
        var diffEven = (numDifferences % 2 === 0);
        if (diagonal < 0) {
            var lowerBoundEven = (diagonalsBelow % 2 === 0);
            return (diffEven === lowerBoundEven) ? 0 : 1;
        }
        else {
            var upperBoundEven = (diagonalsAbove % 2 === 0);
            return (diffEven === upperBoundEven) ? numDiagonals - 1 : numDiagonals - 2;
        }
    };
    return LcsDiff;
}());



/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goToDefinitionMouse_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goToDefinitionMouse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__goToDefinitionMouse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_htmlContent_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_services_modeService_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__goToDefinition_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_services_resolverService_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__browser_core_editorState_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__goToDefinitionCommands_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__clickLinkGesture_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_core_position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};




















var GotoDefinitionWithMouseEditorContribution = /** @class */ (function () {
    function GotoDefinitionWithMouseEditorContribution(editor, textModelResolverService, modeService) {
        var _this = this;
        this.textModelResolverService = textModelResolverService;
        this.modeService = modeService;
        this.toUnhook = [];
        this.decorations = [];
        this.editor = editor;
        this.throttler = new __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__["e" /* Throttler */]();
        var linkGesture = new __WEBPACK_IMPORTED_MODULE_18__clickLinkGesture_js__["a" /* ClickLinkGesture */](editor);
        this.toUnhook.push(linkGesture);
        this.toUnhook.push(linkGesture.onMouseMoveOrRelevantKeyDown(function (_a) {
            var mouseEvent = _a[0], keyboardEvent = _a[1];
            _this.startFindDefinition(mouseEvent, keyboardEvent);
        }));
        this.toUnhook.push(linkGesture.onExecute(function (mouseEvent) {
            if (_this.isEnabled(mouseEvent)) {
                _this.gotoDefinition(mouseEvent.target, mouseEvent.hasSideBySideModifier).done(function () {
                    _this.removeDecorations();
                }, function (error) {
                    _this.removeDecorations();
                    Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["e" /* onUnexpectedError */])(error);
                });
            }
        }));
        this.toUnhook.push(linkGesture.onCancel(function () {
            _this.removeDecorations();
            _this.currentWordUnderMouse = null;
        }));
    }
    GotoDefinitionWithMouseEditorContribution.prototype.startFindDefinition = function (mouseEvent, withKey) {
        var _this = this;
        if (!this.isEnabled(mouseEvent, withKey)) {
            this.currentWordUnderMouse = null;
            this.removeDecorations();
            return;
        }
        // Find word at mouse position
        var position = mouseEvent.target.position;
        var word = position ? this.editor.getModel().getWordAtPosition(position) : null;
        if (!word) {
            this.currentWordUnderMouse = null;
            this.removeDecorations();
            return;
        }
        // Return early if word at position is still the same
        if (this.currentWordUnderMouse && this.currentWordUnderMouse.startColumn === word.startColumn && this.currentWordUnderMouse.endColumn === word.endColumn && this.currentWordUnderMouse.word === word.word) {
            return;
        }
        this.currentWordUnderMouse = word;
        // Find definition and decorate word if found
        var state = new __WEBPACK_IMPORTED_MODULE_16__browser_core_editorState_js__["a" /* EditorState */](this.editor, 4 /* Position */ | 1 /* Value */ | 2 /* Selection */ | 8 /* Scroll */);
        this.throttler.queue(function () {
            return state.validate(_this.editor)
                ? _this.findDefinition(mouseEvent.target)
                : __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__["b" /* TPromise */].wrap(null);
        }).then(function (results) {
            if (!results || !results.length || !state.validate(_this.editor)) {
                _this.removeDecorations();
                return;
            }
            // Multiple results
            if (results.length > 1) {
                _this.addDecoration(new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](position.lineNumber, word.startColumn, position.lineNumber, word.endColumn), new __WEBPACK_IMPORTED_MODULE_4__base_common_htmlContent_js__["a" /* MarkdownString */]().appendText(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('multipleResults', "Click to show {0} definitions.", results.length)));
            }
            // Single result
            else {
                var result_1 = results[0];
                if (!result_1.uri) {
                    return;
                }
                _this.textModelResolverService.createModelReference(result_1.uri).then(function (ref) {
                    if (!ref.object || !ref.object.textEditorModel) {
                        ref.dispose();
                        return;
                    }
                    var textEditorModel = ref.object.textEditorModel;
                    var startLineNumber = result_1.range.startLineNumber;
                    if (textEditorModel.getLineMaxColumn(startLineNumber) === 0) {
                        ref.dispose();
                        return;
                    }
                    var previewValue = _this.getPreviewValue(textEditorModel, startLineNumber);
                    var wordRange;
                    if (result_1.origin) {
                        wordRange = __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].lift(result_1.origin);
                    }
                    else {
                        wordRange = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
                    }
                    _this.addDecoration(wordRange, new __WEBPACK_IMPORTED_MODULE_4__base_common_htmlContent_js__["a" /* MarkdownString */]().appendCodeblock(_this.modeService.getModeIdByFilenameOrFirstLine(textEditorModel.uri.fsPath), previewValue));
                    ref.dispose();
                });
            }
        }).done(undefined, __WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    GotoDefinitionWithMouseEditorContribution.prototype.getPreviewValue = function (textEditorModel, startLineNumber) {
        var rangeToUse = this.getPreviewRangeBasedOnBrackets(textEditorModel, startLineNumber);
        var numberOfLinesInRange = rangeToUse.endLineNumber - rangeToUse.startLineNumber;
        if (numberOfLinesInRange >= GotoDefinitionWithMouseEditorContribution.MAX_SOURCE_PREVIEW_LINES) {
            rangeToUse = this.getPreviewRangeBasedOnIndentation(textEditorModel, startLineNumber);
        }
        var previewValue = this.stripIndentationFromPreviewRange(textEditorModel, startLineNumber, rangeToUse);
        return previewValue;
    };
    GotoDefinitionWithMouseEditorContribution.prototype.stripIndentationFromPreviewRange = function (textEditorModel, startLineNumber, previewRange) {
        var startIndent = textEditorModel.getLineFirstNonWhitespaceColumn(startLineNumber);
        var minIndent = startIndent;
        for (var endLineNumber = startLineNumber + 1; endLineNumber < previewRange.endLineNumber; endLineNumber++) {
            var endIndent = textEditorModel.getLineFirstNonWhitespaceColumn(endLineNumber);
            minIndent = Math.min(minIndent, endIndent);
        }
        var previewValue = textEditorModel.getValueInRange(previewRange).replace(new RegExp("^\\s{" + (minIndent - 1) + "}", 'gm'), '').trim();
        return previewValue;
    };
    GotoDefinitionWithMouseEditorContribution.prototype.getPreviewRangeBasedOnIndentation = function (textEditorModel, startLineNumber) {
        var startIndent = textEditorModel.getLineFirstNonWhitespaceColumn(startLineNumber);
        var maxLineNumber = Math.min(textEditorModel.getLineCount(), startLineNumber + GotoDefinitionWithMouseEditorContribution.MAX_SOURCE_PREVIEW_LINES);
        var endLineNumber = startLineNumber + 1;
        for (; endLineNumber < maxLineNumber; endLineNumber++) {
            var endIndent = textEditorModel.getLineFirstNonWhitespaceColumn(endLineNumber);
            if (startIndent === endIndent) {
                break;
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](startLineNumber, 1, endLineNumber + 1, 1);
    };
    GotoDefinitionWithMouseEditorContribution.prototype.getPreviewRangeBasedOnBrackets = function (textEditorModel, startLineNumber) {
        var maxLineNumber = Math.min(textEditorModel.getLineCount(), startLineNumber + GotoDefinitionWithMouseEditorContribution.MAX_SOURCE_PREVIEW_LINES);
        var brackets = [];
        var ignoreFirstEmpty = true;
        var currentBracket = textEditorModel.findNextBracket(new __WEBPACK_IMPORTED_MODULE_19__common_core_position_js__["a" /* Position */](startLineNumber, 1));
        while (currentBracket !== null) {
            if (brackets.length === 0) {
                brackets.push(currentBracket);
            }
            else {
                var lastBracket = brackets[brackets.length - 1];
                if (lastBracket.open === currentBracket.open && lastBracket.isOpen && !currentBracket.isOpen) {
                    brackets.pop();
                }
                else {
                    brackets.push(currentBracket);
                }
                if (brackets.length === 0) {
                    if (ignoreFirstEmpty) {
                        ignoreFirstEmpty = false;
                    }
                    else {
                        return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](startLineNumber, 1, currentBracket.range.endLineNumber + 1, 1);
                    }
                }
            }
            var maxColumn = textEditorModel.getLineMaxColumn(startLineNumber);
            var nextLineNumber = currentBracket.range.endLineNumber;
            var nextColumn = currentBracket.range.endColumn;
            if (maxColumn === currentBracket.range.endColumn) {
                nextLineNumber++;
                nextColumn = 1;
            }
            if (nextLineNumber > maxLineNumber) {
                return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](startLineNumber, 1, maxLineNumber + 1, 1);
            }
            currentBracket = textEditorModel.findNextBracket(new __WEBPACK_IMPORTED_MODULE_19__common_core_position_js__["a" /* Position */](nextLineNumber, nextColumn));
        }
        return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](startLineNumber, 1, maxLineNumber + 1, 1);
    };
    GotoDefinitionWithMouseEditorContribution.prototype.addDecoration = function (range, hoverMessage) {
        var newDecorations = {
            range: range,
            options: {
                inlineClassName: 'goto-definition-link',
                hoverMessage: hoverMessage
            }
        };
        this.decorations = this.editor.deltaDecorations(this.decorations, [newDecorations]);
    };
    GotoDefinitionWithMouseEditorContribution.prototype.removeDecorations = function () {
        if (this.decorations.length > 0) {
            this.decorations = this.editor.deltaDecorations(this.decorations, []);
        }
    };
    GotoDefinitionWithMouseEditorContribution.prototype.isEnabled = function (mouseEvent, withKey) {
        return this.editor.getModel() &&
            mouseEvent.isNoneOrSingleMouseDown &&
            mouseEvent.target.type === __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT &&
            (mouseEvent.hasTriggerModifier || (withKey && withKey.keyCodeIsTriggerKey)) &&
            __WEBPACK_IMPORTED_MODULE_8__common_modes_js__["e" /* DefinitionProviderRegistry */].has(this.editor.getModel());
    };
    GotoDefinitionWithMouseEditorContribution.prototype.findDefinition = function (target) {
        var model = this.editor.getModel();
        if (!model) {
            return __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__["b" /* TPromise */].as(null);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_11__goToDefinition_js__["a" /* getDefinitionsAtPosition */])(model, target.position);
    };
    GotoDefinitionWithMouseEditorContribution.prototype.gotoDefinition = function (target, sideBySide) {
        var _this = this;
        this.editor.setPosition(target.position);
        var action = new __WEBPACK_IMPORTED_MODULE_17__goToDefinitionCommands_js__["DefinitionAction"](new __WEBPACK_IMPORTED_MODULE_17__goToDefinitionCommands_js__["DefinitionActionConfig"](sideBySide, false, true, false), { alias: undefined, label: undefined, id: undefined, precondition: undefined });
        return this.editor.invokeWithinContext(function (accessor) { return action.run(accessor, _this.editor); });
    };
    GotoDefinitionWithMouseEditorContribution.prototype.getId = function () {
        return GotoDefinitionWithMouseEditorContribution.ID;
    };
    GotoDefinitionWithMouseEditorContribution.prototype.dispose = function () {
        this.toUnhook = Object(__WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__["d" /* dispose */])(this.toUnhook);
    };
    GotoDefinitionWithMouseEditorContribution.ID = 'editor.contrib.gotodefinitionwithmouse';
    GotoDefinitionWithMouseEditorContribution.MAX_SOURCE_PREVIEW_LINES = 8;
    GotoDefinitionWithMouseEditorContribution = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_13__common_services_resolverService_js__["a" /* ITextModelService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_6__common_services_modeService_js__["a" /* IModeService */])
    ], GotoDefinitionWithMouseEditorContribution);
    return GotoDefinitionWithMouseEditorContribution;
}());
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["h" /* registerEditorContribution */])(GotoDefinitionWithMouseEditorContribution);
Object(__WEBPACK_IMPORTED_MODULE_14__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var activeLinkForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_15__platform_theme_common_colorRegistry_js__["m" /* editorActiveLinkForeground */]);
    if (activeLinkForeground) {
        collector.addRule(".monaco-editor .goto-definition-link { color: " + activeLinkForeground + " !important; }");
    }
});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gotoErrorWidget_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_common_errors_js__ = __webpack_require__(6);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};














var MarkerModel = /** @class */ (function () {
    function MarkerModel(editor, markers) {
        var _this = this;
        this._editor = editor;
        this._markers = null;
        this._nextIdx = -1;
        this._toUnbind = [];
        this._ignoreSelectionChange = false;
        this._onCurrentMarkerChanged = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this._onMarkerSetChanged = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.setMarkers(markers);
        // listen on editor
        this._toUnbind.push(this._editor.onDidDispose(function () { return _this.dispose(); }));
        this._toUnbind.push(this._editor.onDidChangeCursorPosition(function () {
            if (_this._ignoreSelectionChange) {
                return;
            }
            if (_this.currentMarker && __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].containsPosition(_this.currentMarker, _this._editor.getPosition())) {
                return;
            }
            _this._nextIdx = -1;
        }));
    }
    Object.defineProperty(MarkerModel.prototype, "onCurrentMarkerChanged", {
        get: function () {
            return this._onCurrentMarkerChanged.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerModel.prototype, "onMarkerSetChanged", {
        get: function () {
            return this._onMarkerSetChanged.event;
        },
        enumerable: true,
        configurable: true
    });
    MarkerModel.prototype.setMarkers = function (markers) {
        var oldMarker = this._nextIdx >= 0 ? this._markers[this._nextIdx] : undefined;
        this._markers = markers || [];
        this._markers.sort(MarkerNavigationAction.compareMarker);
        if (!oldMarker) {
            this._nextIdx = -1;
        }
        else {
            this._nextIdx = Math.max(-1, Object(__WEBPACK_IMPORTED_MODULE_11__base_common_arrays_js__["b" /* binarySearch */])(this._markers, oldMarker, MarkerNavigationAction.compareMarker));
        }
        this._onMarkerSetChanged.fire(this);
    };
    MarkerModel.prototype.withoutWatchingEditorPosition = function (callback) {
        this._ignoreSelectionChange = true;
        try {
            callback();
        }
        finally {
            this._ignoreSelectionChange = false;
        }
    };
    MarkerModel.prototype._initIdx = function (fwd) {
        var found = false;
        var position = this._editor.getPosition();
        for (var i = 0; i < this._markers.length; i++) {
            var range = __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].lift(this._markers[i]);
            if (range.isEmpty()) {
                var word = this._editor.getModel().getWordAtPosition(range.getStartPosition());
                if (word) {
                    range = new __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */](range.startLineNumber, word.startColumn, range.startLineNumber, word.endColumn);
                }
            }
            if (range.containsPosition(position) || position.isBeforeOrEqual(range.getStartPosition())) {
                this._nextIdx = i;
                found = true;
                break;
            }
        }
        if (!found) {
            // after the last change
            this._nextIdx = fwd ? 0 : this._markers.length - 1;
        }
        if (this._nextIdx < 0) {
            this._nextIdx = this._markers.length - 1;
        }
    };
    Object.defineProperty(MarkerModel.prototype, "currentMarker", {
        get: function () {
            return this.canNavigate() ? this._markers[this._nextIdx] : undefined;
        },
        enumerable: true,
        configurable: true
    });
    MarkerModel.prototype.move = function (fwd, inCircles) {
        if (!this.canNavigate()) {
            this._onCurrentMarkerChanged.fire(undefined);
            return !inCircles;
        }
        var oldIdx = this._nextIdx;
        var atEdge = false;
        if (this._nextIdx === -1) {
            this._initIdx(fwd);
        }
        else if (fwd) {
            if (inCircles || this._nextIdx + 1 < this._markers.length) {
                this._nextIdx = (this._nextIdx + 1) % this._markers.length;
            }
            else {
                atEdge = true;
            }
        }
        else if (!fwd) {
            if (inCircles || this._nextIdx > 0) {
                this._nextIdx = (this._nextIdx - 1 + this._markers.length) % this._markers.length;
            }
            else {
                atEdge = true;
            }
        }
        if (oldIdx !== this._nextIdx) {
            var marker = this._markers[this._nextIdx];
            this._onCurrentMarkerChanged.fire(marker);
        }
        return atEdge;
    };
    MarkerModel.prototype.canNavigate = function () {
        return this._markers.length > 0;
    };
    MarkerModel.prototype.findMarkerAtPosition = function (pos) {
        for (var _i = 0, _a = this._markers; _i < _a.length; _i++) {
            var marker = _a[_i];
            if (__WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].containsPosition(marker, pos)) {
                return marker;
            }
        }
        return undefined;
    };
    Object.defineProperty(MarkerModel.prototype, "total", {
        get: function () {
            return this._markers.length;
        },
        enumerable: true,
        configurable: true
    });
    MarkerModel.prototype.indexOf = function (marker) {
        return 1 + this._markers.indexOf(marker);
    };
    MarkerModel.prototype.dispose = function () {
        this._toUnbind = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._toUnbind);
    };
    return MarkerModel;
}());
var MarkerController = /** @class */ (function () {
    function MarkerController(editor, _markerService, _contextKeyService, _themeService, _editorService) {
        this._markerService = _markerService;
        this._contextKeyService = _contextKeyService;
        this._themeService = _themeService;
        this._editorService = _editorService;
        this._disposeOnClose = [];
        this._editor = editor;
        this._widgetVisible = CONTEXT_MARKERS_NAVIGATION_VISIBLE.bindTo(this._contextKeyService);
    }
    MarkerController.get = function (editor) {
        return editor.getContribution(MarkerController.ID);
    };
    MarkerController.prototype.getId = function () {
        return MarkerController.ID;
    };
    MarkerController.prototype.dispose = function () {
        this._cleanUp();
    };
    MarkerController.prototype._cleanUp = function () {
        this._widgetVisible.reset();
        this._disposeOnClose = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._disposeOnClose);
        this._widget = null;
        this._model = null;
    };
    MarkerController.prototype.getOrCreateModel = function () {
        var _this = this;
        if (this._model) {
            return this._model;
        }
        var markers = this._getMarkers();
        this._model = new MarkerModel(this._editor, markers);
        this._markerService.onMarkerChanged(this._onMarkerChanged, this, this._disposeOnClose);
        this._widget = new __WEBPACK_IMPORTED_MODULE_9__gotoErrorWidget_js__["a" /* MarkerNavigationWidget */](this._editor, this._themeService);
        this._widgetVisible.set(true);
        this._disposeOnClose.push(this._model);
        this._disposeOnClose.push(this._widget);
        this._disposeOnClose.push(this._widget.onDidSelectRelatedInformation(function (related) {
            _this._editorService.openCodeEditor({
                resource: related.resource,
                options: { pinned: true, revealIfOpened: true, selection: __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].lift(related).collapseToStart() }
            }, _this._editor).then(undefined, __WEBPACK_IMPORTED_MODULE_13__base_common_errors_js__["e" /* onUnexpectedError */]);
            _this.closeMarkersNavigation(false);
        }));
        this._disposeOnClose.push(this._editor.onDidChangeModel(function () { return _this._cleanUp(); }));
        this._disposeOnClose.push(this._model.onCurrentMarkerChanged(function (marker) {
            if (!marker) {
                _this._cleanUp();
            }
            else {
                _this._model.withoutWatchingEditorPosition(function () {
                    _this._widget.showAtMarker(marker, _this._model.indexOf(marker), _this._model.total);
                });
            }
        }));
        this._disposeOnClose.push(this._model.onMarkerSetChanged(function () {
            var marker = _this._model.findMarkerAtPosition(_this._widget.position);
            if (marker) {
                _this._widget.updateMarker(marker);
            }
            else {
                _this._widget.showStale();
            }
        }));
        return this._model;
    };
    MarkerController.prototype.closeMarkersNavigation = function (focusEditor) {
        if (focusEditor === void 0) { focusEditor = true; }
        this._cleanUp();
        if (focusEditor) {
            this._editor.focus();
        }
    };
    MarkerController.prototype._onMarkerChanged = function (changedResources) {
        var _this = this;
        if (!changedResources.some(function (r) { return _this._editor.getModel().uri.toString() === r.toString(); })) {
            return;
        }
        this._model.setMarkers(this._getMarkers());
    };
    MarkerController.prototype._getMarkers = function () {
        return this._markerService.read({
            resource: this._editor.getModel().uri,
            severities: __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Error | __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Warning | __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Info
        });
    };
    MarkerController.ID = 'editor.contrib.markerController';
    MarkerController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["a" /* IMarkerService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_12__browser_services_codeEditorService_js__["a" /* ICodeEditorService */])
    ], MarkerController);
    return MarkerController;
}());
var MarkerNavigationAction = /** @class */ (function (_super) {
    __extends(MarkerNavigationAction, _super);
    function MarkerNavigationAction(next, multiFile, opts) {
        var _this = _super.call(this, opts) || this;
        _this._isNext = next;
        _this._multiFile = multiFile;
        return _this;
    }
    MarkerNavigationAction.prototype.run = function (accessor, editor) {
        var _this = this;
        var markerService = accessor.get(__WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["a" /* IMarkerService */]);
        var editorService = accessor.get(__WEBPACK_IMPORTED_MODULE_12__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]);
        var controller = MarkerController.get(editor);
        if (!controller) {
            return undefined;
        }
        var model = controller.getOrCreateModel();
        var atEdge = model.move(this._isNext, !this._multiFile);
        if (!atEdge || !this._multiFile) {
            return undefined;
        }
        // try with the next/prev file
        var markers = markerService.read({ severities: __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Error | __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Warning | __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Info }).sort(MarkerNavigationAction.compareMarker);
        if (markers.length === 0) {
            return undefined;
        }
        var oldMarker = model.currentMarker || { resource: editor.getModel().uri, severity: __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Error, startLineNumber: 1, startColumn: 1, endLineNumber: 1, endColumn: 1 };
        var idx = Object(__WEBPACK_IMPORTED_MODULE_11__base_common_arrays_js__["b" /* binarySearch */])(markers, oldMarker, MarkerNavigationAction.compareMarker);
        if (idx < 0) {
            // find best match...
            idx = ~idx;
            idx %= markers.length;
        }
        else if (this._isNext) {
            idx = (idx + 1) % markers.length;
        }
        else {
            idx = (idx + markers.length - 1) % markers.length;
        }
        var newMarker = markers[idx];
        if (newMarker.resource.toString() === editor.getModel().uri.toString()) {
            // the next `resource` is this resource which
            // means we cycle within this file
            model.move(this._isNext, true);
            return undefined;
        }
        // close the widget for this editor-instance, open the resource
        // for the next marker and re-start marker navigation in there
        controller.closeMarkersNavigation();
        return editorService.openCodeEditor({
            resource: newMarker.resource,
            options: { pinned: false, revealIfOpened: true, revealInCenterIfOutsideViewport: true, selection: newMarker }
        }, editor).then(function (editor) {
            if (!editor) {
                return undefined;
            }
            return editor.getAction(_this.id).run();
        });
    };
    MarkerNavigationAction.compareMarker = function (a, b) {
        var res = Object(__WEBPACK_IMPORTED_MODULE_10__base_common_strings_js__["compare"])(a.resource.toString(), b.resource.toString());
        if (res === 0) {
            res = __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].compare(a.severity, b.severity);
        }
        if (res === 0) {
            res = __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(a, b);
        }
        return res;
    };
    return MarkerNavigationAction;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));
var NextMarkerAction = /** @class */ (function (_super) {
    __extends(NextMarkerAction, _super);
    function NextMarkerAction() {
        return _super.call(this, true, false, {
            id: 'editor.action.marker.next',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('markerAction.next.label', "Go to Next Problem (Error, Warning, Info)"),
            alias: 'Go to Next Error or Warning',
            precondition: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return NextMarkerAction;
}(MarkerNavigationAction));
var PrevMarkerAction = /** @class */ (function (_super) {
    __extends(PrevMarkerAction, _super);
    function PrevMarkerAction() {
        return _super.call(this, false, false, {
            id: 'editor.action.marker.prev',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('markerAction.previous.label', "Go to Previous Problem (Error, Warning, Info)"),
            alias: 'Go to Previous Error or Warning',
            precondition: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return PrevMarkerAction;
}(MarkerNavigationAction));
var NextMarkerInFilesAction = /** @class */ (function (_super) {
    __extends(NextMarkerInFilesAction, _super);
    function NextMarkerInFilesAction() {
        return _super.call(this, true, true, {
            id: 'editor.action.marker.nextInFiles',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('markerAction.nextInFiles.label', "Go to Next Problem in Files (Error, Warning, Info)"),
            alias: 'Go to Next Error or Warning in Files',
            precondition: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 66 /* F8 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return NextMarkerInFilesAction;
}(MarkerNavigationAction));
var PrevMarkerInFilesAction = /** @class */ (function (_super) {
    __extends(PrevMarkerInFilesAction, _super);
    function PrevMarkerInFilesAction() {
        return _super.call(this, false, true, {
            id: 'editor.action.marker.prevInFiles',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('markerAction.previousInFiles.label', "Go to Previous Problem in Files (Error, Warning, Info)"),
            alias: 'Go to Previous Error or Warning in Files',
            precondition: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 1024 /* Shift */ | 66 /* F8 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return PrevMarkerInFilesAction;
}(MarkerNavigationAction));
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(MarkerController);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(NextMarkerAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(PrevMarkerAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(NextMarkerInFilesAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(PrevMarkerInFilesAction);
var CONTEXT_MARKERS_NAVIGATION_VISIBLE = new __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('markersNavigationVisible', false);
var MarkerCommand = __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(MarkerController.get);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new MarkerCommand({
    id: 'closeMarkersNavigation',
    precondition: CONTEXT_MARKERS_NAVIGATION_VISIBLE,
    handler: function (x) { return x.closeMarkersNavigation(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 50,
        kbExpr: __WEBPACK_IMPORTED_MODULE_8__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 9 /* Escape */,
        secondary: [1024 /* Shift */ | 9 /* Escape */]
    }
}));


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GotoLineEntry", function() { return GotoLineEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GotoLineAction", function() { return GotoLineAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gotoLine_css__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gotoLine_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gotoLine_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_parts_quickopen_browser_quickOpenModel_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_parts_quickopen_common_quickOpen_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editorQuickOpen_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var GotoLineEntry = /** @class */ (function (_super) {
    __extends(GotoLineEntry, _super);
    function GotoLineEntry(line, editor, decorator) {
        var _this = _super.call(this) || this;
        _this.editor = editor;
        _this.decorator = decorator;
        _this._parseResult = _this._parseInput(line);
        return _this;
    }
    GotoLineEntry.prototype._parseInput = function (line) {
        var numbers = line.split(',').map(function (part) { return parseInt(part, 10); }).filter(function (part) { return !isNaN(part); }), position;
        if (numbers.length === 0) {
            position = new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](-1, -1);
        }
        else if (numbers.length === 1) {
            position = new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](numbers[0], 1);
        }
        else {
            position = new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](numbers[0], numbers[1]);
        }
        var model;
        if (Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__["d" /* isCodeEditor */])(this.editor)) {
            model = this.editor.getModel();
        }
        else {
            model = this.editor.getModel().modified;
        }
        var isValid = model.validatePosition(position).equals(position), label;
        if (isValid) {
            if (position.column && position.column > 1) {
                label = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('gotoLineLabelValidLineAndColumn', "Go to line {0} and character {1}", position.lineNumber, position.column);
            }
            else {
                label = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('gotoLineLabelValidLine', "Go to line {0}", position.lineNumber, position.column);
            }
        }
        else if (position.lineNumber < 1 || position.lineNumber > model.getLineCount()) {
            label = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('gotoLineLabelEmptyWithLineLimit', "Type a line number between 1 and {0} to navigate to", model.getLineCount());
        }
        else {
            label = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('gotoLineLabelEmptyWithLineAndColumnLimit', "Type a character between 1 and {0} to navigate to", model.getLineMaxColumn(position.lineNumber));
        }
        return {
            position: position,
            isValid: isValid,
            label: label
        };
    };
    GotoLineEntry.prototype.getLabel = function () {
        return this._parseResult.label;
    };
    GotoLineEntry.prototype.getAriaLabel = function () {
        return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('gotoLineAriaLabel', "Go to line {0}", this._parseResult.label);
    };
    GotoLineEntry.prototype.run = function (mode, context) {
        if (mode === __WEBPACK_IMPORTED_MODULE_3__base_parts_quickopen_common_quickOpen_js__["a" /* Mode */].OPEN) {
            return this.runOpen();
        }
        return this.runPreview();
    };
    GotoLineEntry.prototype.runOpen = function () {
        // No-op if range is not valid
        if (!this._parseResult.isValid) {
            return false;
        }
        // Apply selection and focus
        var range = this.toSelection();
        this.editor.setSelection(range);
        this.editor.revealRangeInCenter(range, 0 /* Smooth */);
        this.editor.focus();
        return true;
    };
    GotoLineEntry.prototype.runPreview = function () {
        // No-op if range is not valid
        if (!this._parseResult.isValid) {
            this.decorator.clearDecorations();
            return false;
        }
        // Select Line Position
        var range = this.toSelection();
        this.editor.revealRangeInCenter(range, 0 /* Smooth */);
        // Decorate if possible
        this.decorator.decorateLine(range, this.editor);
        return false;
    };
    GotoLineEntry.prototype.toSelection = function () {
        return new __WEBPACK_IMPORTED_MODULE_9__common_core_range_js__["a" /* Range */](this._parseResult.position.lineNumber, this._parseResult.position.column, this._parseResult.position.lineNumber, this._parseResult.position.column);
    };
    return GotoLineEntry;
}(__WEBPACK_IMPORTED_MODULE_2__base_parts_quickopen_browser_quickOpenModel_js__["a" /* QuickOpenEntry */]));

var GotoLineAction = /** @class */ (function (_super) {
    __extends(GotoLineAction, _super);
    function GotoLineAction() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('gotoLineActionInput', "Type a line number, followed by an optional colon and a character number to navigate to"), {
            id: 'editor.action.gotoLine',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('GotoLineAction.label', "Go to Line..."),
            alias: 'Go to Line...',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 2048 /* CtrlCmd */ | 37 /* KEY_G */,
                mac: { primary: 256 /* WinCtrl */ | 37 /* KEY_G */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    GotoLineAction.prototype.run = function (accessor, editor) {
        var _this = this;
        this._show(this.getController(editor), {
            getModel: function (value) {
                return new __WEBPACK_IMPORTED_MODULE_2__base_parts_quickopen_browser_quickOpenModel_js__["c" /* QuickOpenModel */]([new GotoLineEntry(value, editor, _this.getController(editor))]);
            },
            getAutoFocus: function (searchValue) {
                return {
                    autoFocusFirstEntry: searchValue.length > 0
                };
            }
        });
    };
    return GotoLineAction;
}(__WEBPACK_IMPORTED_MODULE_6__editorQuickOpen_js__["a" /* BaseEditorQuickOpenAction */]));

Object(__WEBPACK_IMPORTED_MODULE_7__browser_editorExtensions_js__["f" /* registerEditorAction */])(GotoLineAction);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickOpenEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QuickOpenEntryGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QuickOpenModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_ui_iconLabel_iconLabel_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_ui_actionbar_actionbar_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_ui_highlightedlabel_highlightedLabel_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_ui_keybindingLabel_keybindingLabel_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_platform_js__ = __webpack_require__(14);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var IDS = 0;
var QuickOpenEntry = /** @class */ (function () {
    function QuickOpenEntry(highlights) {
        if (highlights === void 0) { highlights = []; }
        this.id = (IDS++).toString();
        this.labelHighlights = highlights;
        this.descriptionHighlights = [];
    }
    /**
     * A unique identifier for the entry
     */
    QuickOpenEntry.prototype.getId = function () {
        return this.id;
    };
    /**
     * The label of the entry to identify it from others in the list
     */
    QuickOpenEntry.prototype.getLabel = function () {
        return null;
    };
    /**
     * The options for the label to use for this entry
     */
    QuickOpenEntry.prototype.getLabelOptions = function () {
        return null;
    };
    /**
     * The label of the entry to use when a screen reader wants to read about the entry
     */
    QuickOpenEntry.prototype.getAriaLabel = function () {
        return [this.getLabel(), this.getDescription(), this.getDetail()]
            .filter(function (s) { return !!s; })
            .join(', ');
    };
    /**
     * Detail information about the entry that is optional and can be shown below the label
     */
    QuickOpenEntry.prototype.getDetail = function () {
        return null;
    };
    /**
     * The icon of the entry to identify it from others in the list
     */
    QuickOpenEntry.prototype.getIcon = function () {
        return null;
    };
    /**
     * A secondary description that is optional and can be shown right to the label
     */
    QuickOpenEntry.prototype.getDescription = function () {
        return null;
    };
    /**
     * A tooltip to show when hovering over the entry.
     */
    QuickOpenEntry.prototype.getTooltip = function () {
        return null;
    };
    /**
     * A tooltip to show when hovering over the description portion of the entry.
     */
    QuickOpenEntry.prototype.getDescriptionTooltip = function () {
        return null;
    };
    /**
     * An optional keybinding to show for an entry.
     */
    QuickOpenEntry.prototype.getKeybinding = function () {
        return null;
    };
    /**
     * Allows to reuse the same model while filtering. Hidden entries will not show up in the viewer.
     */
    QuickOpenEntry.prototype.isHidden = function () {
        return this.hidden;
    };
    /**
     * Allows to set highlight ranges that should show up for the entry label and optionally description if set.
     */
    QuickOpenEntry.prototype.setHighlights = function (labelHighlights, descriptionHighlights, detailHighlights) {
        this.labelHighlights = labelHighlights;
        this.descriptionHighlights = descriptionHighlights;
        this.detailHighlights = detailHighlights;
    };
    /**
     * Allows to return highlight ranges that should show up for the entry label and description.
     */
    QuickOpenEntry.prototype.getHighlights = function () {
        return [this.labelHighlights, this.descriptionHighlights, this.detailHighlights];
    };
    /**
     * Called when the entry is selected for opening. Returns a boolean value indicating if an action was performed or not.
     * The mode parameter gives an indication if the element is previewed (using arrow keys) or opened.
     *
     * The context parameter provides additional context information how the run was triggered.
     */
    QuickOpenEntry.prototype.run = function (mode, context) {
        return false;
    };
    return QuickOpenEntry;
}());

var QuickOpenEntryGroup = /** @class */ (function (_super) {
    __extends(QuickOpenEntryGroup, _super);
    function QuickOpenEntryGroup(entry, groupLabel, withBorder) {
        var _this = _super.call(this) || this;
        _this.entry = entry;
        _this.groupLabel = groupLabel;
        _this.withBorder = withBorder;
        return _this;
    }
    /**
     * The label of the group or null if none.
     */
    QuickOpenEntryGroup.prototype.getGroupLabel = function () {
        return this.groupLabel;
    };
    QuickOpenEntryGroup.prototype.setGroupLabel = function (groupLabel) {
        this.groupLabel = groupLabel;
    };
    /**
     * Whether to show a border on top of the group entry or not.
     */
    QuickOpenEntryGroup.prototype.showBorder = function () {
        return this.withBorder;
    };
    QuickOpenEntryGroup.prototype.setShowBorder = function (showBorder) {
        this.withBorder = showBorder;
    };
    QuickOpenEntryGroup.prototype.getLabel = function () {
        return this.entry ? this.entry.getLabel() : _super.prototype.getLabel.call(this);
    };
    QuickOpenEntryGroup.prototype.getLabelOptions = function () {
        return this.entry ? this.entry.getLabelOptions() : _super.prototype.getLabelOptions.call(this);
    };
    QuickOpenEntryGroup.prototype.getAriaLabel = function () {
        return this.entry ? this.entry.getAriaLabel() : _super.prototype.getAriaLabel.call(this);
    };
    QuickOpenEntryGroup.prototype.getDetail = function () {
        return this.entry ? this.entry.getDetail() : _super.prototype.getDetail.call(this);
    };
    QuickOpenEntryGroup.prototype.getIcon = function () {
        return this.entry ? this.entry.getIcon() : _super.prototype.getIcon.call(this);
    };
    QuickOpenEntryGroup.prototype.getDescription = function () {
        return this.entry ? this.entry.getDescription() : _super.prototype.getDescription.call(this);
    };
    QuickOpenEntryGroup.prototype.getHighlights = function () {
        return this.entry ? this.entry.getHighlights() : _super.prototype.getHighlights.call(this);
    };
    QuickOpenEntryGroup.prototype.isHidden = function () {
        return this.entry ? this.entry.isHidden() : _super.prototype.isHidden.call(this);
    };
    QuickOpenEntryGroup.prototype.setHighlights = function (labelHighlights, descriptionHighlights, detailHighlights) {
        this.entry ? this.entry.setHighlights(labelHighlights, descriptionHighlights, detailHighlights) : _super.prototype.setHighlights.call(this, labelHighlights, descriptionHighlights, detailHighlights);
    };
    QuickOpenEntryGroup.prototype.run = function (mode, context) {
        return this.entry ? this.entry.run(mode, context) : _super.prototype.run.call(this, mode, context);
    };
    return QuickOpenEntryGroup;
}(QuickOpenEntry));

var NoActionProvider = /** @class */ (function () {
    function NoActionProvider() {
    }
    NoActionProvider.prototype.hasActions = function (tree, element) {
        return false;
    };
    NoActionProvider.prototype.getActions = function (tree, element) {
        return __WEBPACK_IMPORTED_MODULE_1__common_winjs_base_js__["b" /* TPromise */].as(null);
    };
    return NoActionProvider;
}());
var templateEntry = 'quickOpenEntry';
var templateEntryGroup = 'quickOpenEntryGroup';
var Renderer = /** @class */ (function () {
    function Renderer(actionProvider, actionRunner) {
        if (actionProvider === void 0) { actionProvider = new NoActionProvider(); }
        if (actionRunner === void 0) { actionRunner = null; }
        this.actionProvider = actionProvider;
        this.actionRunner = actionRunner;
    }
    Renderer.prototype.getHeight = function (entry) {
        if (entry.getDetail()) {
            return 44;
        }
        return 22;
    };
    Renderer.prototype.getTemplateId = function (entry) {
        if (entry instanceof QuickOpenEntryGroup) {
            return templateEntryGroup;
        }
        return templateEntry;
    };
    Renderer.prototype.renderTemplate = function (templateId, container, styles) {
        var entryContainer = document.createElement('div');
        __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](entryContainer, 'sub-content');
        container.appendChild(entryContainer);
        // Entry
        var row1 = __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["a" /* $ */]('.quick-open-row');
        var row2 = __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["a" /* $ */]('.quick-open-row');
        var entry = __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["a" /* $ */]('.quick-open-entry', null, row1, row2);
        entryContainer.appendChild(entry);
        // Icon
        var icon = document.createElement('span');
        row1.appendChild(icon);
        // Label
        var label = new __WEBPACK_IMPORTED_MODULE_2__browser_ui_iconLabel_iconLabel_js__["b" /* IconLabel */](row1, { supportHighlights: true, supportDescriptionHighlights: true });
        // Keybinding
        var keybindingContainer = document.createElement('span');
        row1.appendChild(keybindingContainer);
        __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](keybindingContainer, 'quick-open-entry-keybinding');
        var keybinding = new __WEBPACK_IMPORTED_MODULE_6__browser_ui_keybindingLabel_keybindingLabel_js__["a" /* KeybindingLabel */](keybindingContainer, __WEBPACK_IMPORTED_MODULE_7__common_platform_js__["a" /* OS */]);
        // Detail
        var detailContainer = document.createElement('div');
        row2.appendChild(detailContainer);
        __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](detailContainer, 'quick-open-entry-meta');
        var detail = new __WEBPACK_IMPORTED_MODULE_4__browser_ui_highlightedlabel_highlightedLabel_js__["a" /* HighlightedLabel */](detailContainer);
        // Entry Group
        var group;
        if (templateId === templateEntryGroup) {
            group = document.createElement('div');
            __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](group, 'results-group');
            container.appendChild(group);
        }
        // Actions
        __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](container, 'actions');
        var actionBarContainer = document.createElement('div');
        __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](actionBarContainer, 'primary-action-bar');
        container.appendChild(actionBarContainer);
        var actionBar = new __WEBPACK_IMPORTED_MODULE_3__browser_ui_actionbar_actionbar_js__["a" /* ActionBar */](actionBarContainer, {
            actionRunner: this.actionRunner
        });
        return {
            container: container,
            entry: entry,
            icon: icon,
            label: label,
            detail: detail,
            keybinding: keybinding,
            group: group,
            actionBar: actionBar
        };
    };
    Renderer.prototype.renderElement = function (entry, templateId, data, styles) {
        // Action Bar
        if (this.actionProvider.hasActions(null, entry)) {
            __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](data.container, 'has-actions');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["G" /* removeClass */](data.container, 'has-actions');
        }
        data.actionBar.context = entry; // make sure the context is the current element
        this.actionProvider.getActions(null, entry).then(function (actions) {
            if (data.actionBar.isEmpty() && actions && actions.length > 0) {
                data.actionBar.push(actions, { icon: true, label: false });
            }
            else if (!data.actionBar.isEmpty() && (!actions || actions.length === 0)) {
                data.actionBar.clear();
            }
        });
        // Entry group class
        if (entry instanceof QuickOpenEntryGroup && entry.getGroupLabel()) {
            __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](data.container, 'has-group-label');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["G" /* removeClass */](data.container, 'has-group-label');
        }
        // Entry group
        if (entry instanceof QuickOpenEntryGroup) {
            var group = entry;
            var groupData = data;
            // Border
            if (group.showBorder()) {
                __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["f" /* addClass */](groupData.container, 'results-group-separator');
                groupData.container.style.borderTopColor = styles.pickerGroupBorder.toString();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_5__browser_dom_js__["G" /* removeClass */](groupData.container, 'results-group-separator');
                groupData.container.style.borderTopColor = null;
            }
            // Group Label
            var groupLabel = group.getGroupLabel() || '';
            groupData.group.textContent = groupLabel;
            groupData.group.style.color = styles.pickerGroupForeground.toString();
        }
        // Normal Entry
        if (entry instanceof QuickOpenEntry) {
            var _a = entry.getHighlights(), labelHighlights = _a[0], descriptionHighlights = _a[1], detailHighlights = _a[2];
            // Icon
            var iconClass = entry.getIcon() ? ('quick-open-entry-icon ' + entry.getIcon()) : '';
            data.icon.className = iconClass;
            // Label
            var options = entry.getLabelOptions() || Object.create(null);
            options.matches = labelHighlights || [];
            options.title = entry.getTooltip();
            options.descriptionTitle = entry.getDescriptionTooltip() || entry.getDescription(); // tooltip over description because it could overflow
            options.descriptionMatches = descriptionHighlights || [];
            data.label.setValue(entry.getLabel(), entry.getDescription(), options);
            // Meta
            data.detail.set(entry.getDetail(), detailHighlights);
            // Keybinding
            data.keybinding.set(entry.getKeybinding(), null);
        }
    };
    Renderer.prototype.disposeTemplate = function (templateId, templateData) {
        var data = templateData;
        data.actionBar.dispose();
        data.actionBar = null;
        data.container = null;
        data.entry = null;
        data.keybinding.dispose();
        data.keybinding = null;
        data.detail.dispose();
        data.detail = null;
        data.group = null;
        data.icon = null;
        data.label.dispose();
        data.label = null;
    };
    return Renderer;
}());
var QuickOpenModel = /** @class */ (function () {
    function QuickOpenModel(entries, actionProvider) {
        if (entries === void 0) { entries = []; }
        if (actionProvider === void 0) { actionProvider = new NoActionProvider(); }
        this._entries = entries;
        this._dataSource = this;
        this._renderer = new Renderer(actionProvider);
        this._filter = this;
        this._runner = this;
        this._accessibilityProvider = this;
    }
    Object.defineProperty(QuickOpenModel.prototype, "entries", {
        get: function () { return this._entries; },
        set: function (entries) {
            this._entries = entries;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickOpenModel.prototype, "dataSource", {
        get: function () { return this._dataSource; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickOpenModel.prototype, "renderer", {
        get: function () { return this._renderer; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickOpenModel.prototype, "filter", {
        get: function () { return this._filter; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickOpenModel.prototype, "runner", {
        get: function () { return this._runner; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickOpenModel.prototype, "accessibilityProvider", {
        get: function () { return this._accessibilityProvider; },
        enumerable: true,
        configurable: true
    });
    QuickOpenModel.prototype.getId = function (entry) {
        return entry.getId();
    };
    QuickOpenModel.prototype.getLabel = function (entry) {
        return entry.getLabel();
    };
    QuickOpenModel.prototype.getAriaLabel = function (entry) {
        var ariaLabel = entry.getAriaLabel();
        if (ariaLabel) {
            return __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickOpenAriaLabelEntry', "{0}, picker", entry.getAriaLabel());
        }
        return __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickOpenAriaLabel', "picker");
    };
    QuickOpenModel.prototype.isVisible = function (entry) {
        return !entry.isHidden();
    };
    QuickOpenModel.prototype.run = function (entry, mode, context) {
        return entry.run(mode, context);
    };
    return QuickOpenModel;
}());



/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuickOpenController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseEditorQuickOpenAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quickOpenEditorWidget_js__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_model_textModel_js__ = __webpack_require__(27);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};




var QuickOpenController = /** @class */ (function () {
    function QuickOpenController(editor, themeService) {
        this.themeService = themeService;
        this.editor = editor;
    }
    QuickOpenController.get = function (editor) {
        return editor.getContribution(QuickOpenController.ID);
    };
    QuickOpenController.prototype.getId = function () {
        return QuickOpenController.ID;
    };
    QuickOpenController.prototype.dispose = function () {
        // Dispose widget
        if (this.widget) {
            this.widget.destroy();
            this.widget = null;
        }
    };
    QuickOpenController.prototype.run = function (opts) {
        var _this = this;
        if (this.widget) {
            this.widget.destroy();
            this.widget = null;
        }
        // Create goto line widget
        var onClose = function (canceled) {
            // Clear Highlight Decorations if present
            _this.clearDecorations();
            // Restore selection if canceled
            if (canceled && _this.lastKnownEditorSelection) {
                _this.editor.setSelection(_this.lastKnownEditorSelection);
                _this.editor.revealRangeInCenterIfOutsideViewport(_this.lastKnownEditorSelection, 0 /* Smooth */);
            }
            _this.lastKnownEditorSelection = null;
            _this.editor.focus();
        };
        this.widget = new __WEBPACK_IMPORTED_MODULE_0__quickOpenEditorWidget_js__["a" /* QuickOpenEditorWidget */](this.editor, function () { return onClose(false); }, function () { return onClose(true); }, function (value) {
            _this.widget.setInput(opts.getModel(value), opts.getAutoFocus(value));
        }, {
            inputAriaLabel: opts.inputAriaLabel
        }, this.themeService);
        // Remember selection to be able to restore on cancel
        if (!this.lastKnownEditorSelection) {
            this.lastKnownEditorSelection = this.editor.getSelection();
        }
        // Show
        this.widget.show('');
    };
    QuickOpenController.prototype.decorateLine = function (range, editor) {
        var oldDecorations = [];
        if (this.rangeHighlightDecorationId) {
            oldDecorations.push(this.rangeHighlightDecorationId);
            this.rangeHighlightDecorationId = null;
        }
        var newDecorations = [
            {
                range: range,
                options: QuickOpenController._RANGE_HIGHLIGHT_DECORATION
            }
        ];
        var decorations = editor.deltaDecorations(oldDecorations, newDecorations);
        this.rangeHighlightDecorationId = decorations[0];
    };
    QuickOpenController.prototype.clearDecorations = function () {
        if (this.rangeHighlightDecorationId) {
            this.editor.deltaDecorations([this.rangeHighlightDecorationId], []);
            this.rangeHighlightDecorationId = null;
        }
    };
    QuickOpenController.ID = 'editor.controller.quickOpenController';
    QuickOpenController._RANGE_HIGHLIGHT_DECORATION = __WEBPACK_IMPORTED_MODULE_3__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'rangeHighlight',
        isWholeLine: true
    });
    QuickOpenController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__["c" /* IThemeService */])
    ], QuickOpenController);
    return QuickOpenController;
}());

/**
 * Base class for providing quick open in the editor.
 */
var BaseEditorQuickOpenAction = /** @class */ (function (_super) {
    __extends(BaseEditorQuickOpenAction, _super);
    function BaseEditorQuickOpenAction(inputAriaLabel, opts) {
        var _this = _super.call(this, opts) || this;
        _this._inputAriaLabel = inputAriaLabel;
        return _this;
    }
    BaseEditorQuickOpenAction.prototype.getController = function (editor) {
        return QuickOpenController.get(editor);
    };
    BaseEditorQuickOpenAction.prototype._show = function (controller, opts) {
        controller.run({
            inputAriaLabel: this._inputAriaLabel,
            getModel: function (value) { return opts.getModel(value); },
            getAutoFocus: function (searchValue) { return opts.getAutoFocus(searchValue); }
        });
    };
    return BaseEditorQuickOpenAction;
}(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["h" /* registerEditorContribution */])(QuickOpenController);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModesHoverController", function() { return ModesHoverController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hover_css__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_opener_common_opener_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_services_modeService_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modesContentHover_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modesGlyphHover_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__markdown_markdownRenderer_js__ = __webpack_require__(167);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
















var ModesHoverController = /** @class */ (function () {
    function ModesHoverController(_editor, _openerService, _modeService, _themeService) {
        var _this = this;
        this._editor = _editor;
        this._openerService = _openerService;
        this._modeService = _modeService;
        this._themeService = _themeService;
        this._toUnhook = [];
        this._isMouseDown = false;
        this._hoverClicked = false;
        this._hookEvents();
        this._didChangeConfigurationHandler = this._editor.onDidChangeConfiguration(function (e) {
            if (e.contribInfo) {
                _this._hideWidgets();
                _this._unhookEvents();
                _this._hookEvents();
            }
        });
    }
    Object.defineProperty(ModesHoverController.prototype, "contentWidget", {
        get: function () {
            if (!this._contentWidget) {
                this._createHoverWidget();
            }
            return this._contentWidget;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModesHoverController.prototype, "glyphWidget", {
        get: function () {
            if (!this._glyphWidget) {
                this._createHoverWidget();
            }
            return this._glyphWidget;
        },
        enumerable: true,
        configurable: true
    });
    ModesHoverController.get = function (editor) {
        return editor.getContribution(ModesHoverController.ID);
    };
    ModesHoverController.prototype._hookEvents = function () {
        var _this = this;
        var hideWidgetsEventHandler = function () { return _this._hideWidgets(); };
        var hoverOpts = this._editor.getConfiguration().contribInfo.hover;
        this._isHoverEnabled = hoverOpts.enabled;
        this._isHoverSticky = hoverOpts.sticky;
        if (this._isHoverEnabled) {
            this._toUnhook.push(this._editor.onMouseDown(function (e) { return _this._onEditorMouseDown(e); }));
            this._toUnhook.push(this._editor.onMouseUp(function (e) { return _this._onEditorMouseUp(e); }));
            this._toUnhook.push(this._editor.onMouseMove(function (e) { return _this._onEditorMouseMove(e); }));
            this._toUnhook.push(this._editor.onKeyDown(function (e) { return _this._onKeyDown(e); }));
            this._toUnhook.push(this._editor.onDidChangeModelDecorations(function () { return _this._onModelDecorationsChanged(); }));
        }
        else {
            this._toUnhook.push(this._editor.onMouseMove(hideWidgetsEventHandler));
        }
        this._toUnhook.push(this._editor.onMouseLeave(hideWidgetsEventHandler));
        this._toUnhook.push(this._editor.onDidChangeModel(hideWidgetsEventHandler));
        this._toUnhook.push(this._editor.onDidScrollChange(function (e) { return _this._onEditorScrollChanged(e); }));
    };
    ModesHoverController.prototype._unhookEvents = function () {
        this._toUnhook = Object(__WEBPACK_IMPORTED_MODULE_11__base_common_lifecycle_js__["d" /* dispose */])(this._toUnhook);
    };
    ModesHoverController.prototype._onModelDecorationsChanged = function () {
        this.contentWidget.onModelDecorationsChanged();
        this.glyphWidget.onModelDecorationsChanged();
    };
    ModesHoverController.prototype._onEditorScrollChanged = function (e) {
        if (e.scrollTopChanged || e.scrollLeftChanged) {
            this._hideWidgets();
        }
    };
    ModesHoverController.prototype._onEditorMouseDown = function (mouseEvent) {
        this._isMouseDown = true;
        var targetType = mouseEvent.target.type;
        if (targetType === __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_WIDGET && mouseEvent.target.detail === __WEBPACK_IMPORTED_MODULE_9__modesContentHover_js__["a" /* ModesContentHoverWidget */].ID) {
            this._hoverClicked = true;
            // mouse down on top of content hover widget
            return;
        }
        if (targetType === __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].OVERLAY_WIDGET && mouseEvent.target.detail === __WEBPACK_IMPORTED_MODULE_10__modesGlyphHover_js__["a" /* ModesGlyphHoverWidget */].ID) {
            // mouse down on top of overlay hover widget
            return;
        }
        if (targetType !== __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].OVERLAY_WIDGET && mouseEvent.target.detail !== __WEBPACK_IMPORTED_MODULE_10__modesGlyphHover_js__["a" /* ModesGlyphHoverWidget */].ID) {
            this._hoverClicked = false;
        }
        this._hideWidgets();
    };
    ModesHoverController.prototype._onEditorMouseUp = function (mouseEvent) {
        this._isMouseDown = false;
    };
    ModesHoverController.prototype._onEditorMouseMove = function (mouseEvent) {
        // const this._editor.getConfiguration().contribInfo.hover.sticky;
        var targetType = mouseEvent.target.type;
        var hasStopKey = (__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["d" /* isMacintosh */] ? mouseEvent.event.metaKey : mouseEvent.event.ctrlKey);
        if (this._isMouseDown && this._hoverClicked && this.contentWidget.isColorPickerVisible()) {
            return;
        }
        if (this._isHoverSticky && targetType === __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_WIDGET && mouseEvent.target.detail === __WEBPACK_IMPORTED_MODULE_9__modesContentHover_js__["a" /* ModesContentHoverWidget */].ID && !hasStopKey) {
            // mouse moved on top of content hover widget
            return;
        }
        if (this._isHoverSticky && targetType === __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].OVERLAY_WIDGET && mouseEvent.target.detail === __WEBPACK_IMPORTED_MODULE_10__modesGlyphHover_js__["a" /* ModesGlyphHoverWidget */].ID && !hasStopKey) {
            // mouse moved on top of overlay hover widget
            return;
        }
        if (targetType === __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY) {
            var epsilon = this._editor.getConfiguration().fontInfo.typicalHalfwidthCharacterWidth / 2;
            var data = mouseEvent.target.detail;
            if (data && !data.isAfterLines && typeof data.horizontalDistanceToText === 'number' && data.horizontalDistanceToText < epsilon) {
                // Let hover kick in even when the mouse is technically in the empty area after a line, given the distance is small enough
                targetType = __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT;
            }
        }
        if (targetType === __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT) {
            this.glyphWidget.hide();
            if (this._isHoverEnabled) {
                this.contentWidget.startShowingAt(mouseEvent.target.range, 0 /* Delayed */, false);
            }
        }
        else if (targetType === __WEBPACK_IMPORTED_MODULE_8__browser_editorBrowser_js__["b" /* MouseTargetType */].GUTTER_GLYPH_MARGIN) {
            this.contentWidget.hide();
            if (this._isHoverEnabled) {
                this.glyphWidget.startShowingAt(mouseEvent.target.position.lineNumber);
            }
        }
        else {
            this._hideWidgets();
        }
    };
    ModesHoverController.prototype._onKeyDown = function (e) {
        if (e.keyCode !== 5 /* Ctrl */ && e.keyCode !== 6 /* Alt */ && e.keyCode !== 57 /* Meta */) {
            // Do not hide hover when Ctrl/Meta is pressed
            this._hideWidgets();
        }
    };
    ModesHoverController.prototype._hideWidgets = function () {
        if (!this._contentWidget || (this._isMouseDown && this._hoverClicked && this._contentWidget.isColorPickerVisible())) {
            return;
        }
        this._glyphWidget.hide();
        this._contentWidget.hide();
    };
    ModesHoverController.prototype._createHoverWidget = function () {
        var renderer = new __WEBPACK_IMPORTED_MODULE_15__markdown_markdownRenderer_js__["a" /* MarkdownRenderer */](this._editor, this._modeService, this._openerService);
        this._contentWidget = new __WEBPACK_IMPORTED_MODULE_9__modesContentHover_js__["a" /* ModesContentHoverWidget */](this._editor, renderer, this._themeService);
        this._glyphWidget = new __WEBPACK_IMPORTED_MODULE_10__modesGlyphHover_js__["a" /* ModesGlyphHoverWidget */](this._editor, renderer);
    };
    ModesHoverController.prototype.showContentHover = function (range, mode, focus) {
        this.contentWidget.startShowingAt(range, mode, focus);
    };
    ModesHoverController.prototype.getId = function () {
        return ModesHoverController.ID;
    };
    ModesHoverController.prototype.dispose = function () {
        this._unhookEvents();
        this._didChangeConfigurationHandler.dispose();
        if (this._glyphWidget) {
            this._glyphWidget.dispose();
            this._glyphWidget = null;
        }
        if (this._contentWidget) {
            this._contentWidget.dispose();
            this._contentWidget = null;
        }
    };
    ModesHoverController.ID = 'editor.contrib.hover';
    ModesHoverController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_4__platform_opener_common_opener_js__["a" /* IOpenerService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_5__common_services_modeService_js__["a" /* IModeService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_12__platform_theme_common_themeService_js__["c" /* IThemeService */])
    ], ModesHoverController);
    return ModesHoverController;
}());

var ShowHoverAction = /** @class */ (function (_super) {
    __extends(ShowHoverAction, _super);
    function ShowHoverAction() {
        return _super.call(this, {
            id: 'editor.action.showHover',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]({
                key: 'showHover',
                comment: [
                    'Label for action that will trigger the showing of a hover in the editor.',
                    'This allows for users to show the hover without using the mouse.'
                ]
            }, "Show Hover"),
            alias: 'Show Hover',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_14__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 39 /* KEY_I */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    ShowHoverAction.prototype.run = function (accessor, editor) {
        var controller = ModesHoverController.get(editor);
        if (!controller) {
            return;
        }
        var position = editor.getPosition();
        var range = new __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column);
        controller.showContentHover(range, 1 /* Immediate */, true);
    };
    return ShowHoverAction;
}(__WEBPACK_IMPORTED_MODULE_7__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_7__browser_editorExtensions_js__["h" /* registerEditorContribution */])(ModesHoverController);
Object(__WEBPACK_IMPORTED_MODULE_7__browser_editorExtensions_js__["f" /* registerEditorAction */])(ShowHoverAction);
// theming
Object(__WEBPACK_IMPORTED_MODULE_12__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var editorHoverHighlightColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["x" /* editorHoverHighlight */]);
    if (editorHoverHighlightColor) {
        collector.addRule(".monaco-editor .hoverHighlight { background-color: " + editorHoverHighlightColor + "; }");
    }
    var hoverBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["v" /* editorHoverBackground */]);
    if (hoverBackground) {
        collector.addRule(".monaco-editor .monaco-editor-hover { background-color: " + hoverBackground + "; }");
    }
    var hoverBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["w" /* editorHoverBorder */]);
    if (hoverBorder) {
        collector.addRule(".monaco-editor .monaco-editor-hover { border: 1px solid " + hoverBorder + "; }");
        collector.addRule(".monaco-editor .monaco-editor-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid " + hoverBorder.transparent(0.5) + "; }");
    }
    var link = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["_16" /* textLinkForeground */]);
    if (link) {
        collector.addRule(".monaco-editor .monaco-editor-hover a { color: " + link + "; }");
    }
    var codeBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["_15" /* textCodeBlockBackground */]);
    if (codeBackground) {
        collector.addRule(".monaco-editor .monaco-editor-hover code { background-color: " + codeBackground + "; }");
    }
});


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkdownRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_htmlContentRenderer_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_opener_common_opener_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_services_modeService_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modes_textToHtmlTokenizer_js__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};









var MarkdownRenderer = /** @class */ (function () {
    function MarkdownRenderer(_editor, _modeService, _openerService) {
        if (_openerService === void 0) { _openerService = __WEBPACK_IMPORTED_MODULE_1__platform_opener_common_opener_js__["b" /* NullOpenerService */]; }
        this._editor = _editor;
        this._modeService = _modeService;
        this._openerService = _openerService;
        this._onDidRenderCodeBlock = new __WEBPACK_IMPORTED_MODULE_7__base_common_event_js__["a" /* Emitter */]();
        this.onDidRenderCodeBlock = this._onDidRenderCodeBlock.event;
    }
    MarkdownRenderer.prototype.getOptions = function (disposeables) {
        var _this = this;
        return {
            codeBlockRenderer: function (languageAlias, value) {
                // In markdown,
                // it is possible that we stumble upon language aliases (e.g.js instead of javascript)
                // it is possible no alias is given in which case we fall back to the current editor lang
                var modeId = languageAlias
                    ? _this._modeService.getModeIdForLanguageName(languageAlias)
                    : _this._editor.getModel().getLanguageIdentifier().language;
                return _this._modeService.getOrCreateMode(modeId).then(function (_) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__common_modes_textToHtmlTokenizer_js__["b" /* tokenizeToString */])(value, modeId);
                }).then(function (code) {
                    return "<span style=\"font-family: " + _this._editor.getConfiguration().fontInfo.fontFamily + "\">" + code + "</span>";
                });
            },
            codeBlockRenderCallback: function () { return _this._onDidRenderCodeBlock.fire(); },
            actionHandler: {
                callback: function (content) {
                    _this._openerService.open(__WEBPACK_IMPORTED_MODULE_3__base_common_uri_js__["a" /* default */].parse(content)).then(void 0, __WEBPACK_IMPORTED_MODULE_4__base_common_errors_js__["e" /* onUnexpectedError */]);
                },
                disposeables: disposeables
            }
        };
    };
    MarkdownRenderer.prototype.render = function (markdown) {
        var disposeables = [];
        var element;
        if (!markdown) {
            element = document.createElement('span');
        }
        else {
            element = Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_htmlContentRenderer_js__["b" /* renderMarkdown */])(markdown, this.getOptions(disposeables));
        }
        return {
            element: element,
            dispose: function () { return Object(__WEBPACK_IMPORTED_MODULE_8__base_common_lifecycle_js__["d" /* dispose */])(disposeables); }
        };
    };
    MarkdownRenderer = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_2__common_services_modeService_js__["a" /* IModeService */]),
        __param(2, Object(__WEBPACK_IMPORTED_MODULE_6__platform_instantiation_common_instantiation_js__["d" /* optional */])(__WEBPACK_IMPORTED_MODULE_1__platform_opener_common_opener_js__["a" /* IOpenerService */]))
    ], MarkdownRenderer);
    return MarkdownRenderer;
}());



/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_services_editorWorkerService_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inPlaceReplaceCommand_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__browser_core_editorState_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_common_errors_js__ = __webpack_require__(6);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};














var InPlaceReplaceController = /** @class */ (function () {
    function InPlaceReplaceController(editor, editorWorkerService) {
        this.decorationIds = [];
        this.editor = editor;
        this.editorWorkerService = editorWorkerService;
    }
    InPlaceReplaceController.get = function (editor) {
        return editor.getContribution(InPlaceReplaceController.ID);
    };
    InPlaceReplaceController.prototype.dispose = function () {
    };
    InPlaceReplaceController.prototype.getId = function () {
        return InPlaceReplaceController.ID;
    };
    InPlaceReplaceController.prototype.run = function (source, up) {
        var _this = this;
        // cancel any pending request
        if (this.currentRequest) {
            this.currentRequest.cancel();
        }
        var selection = this.editor.getSelection();
        var model = this.editor.getModel();
        var modelURI = model.uri;
        if (selection.startLineNumber !== selection.endLineNumber) {
            // Can't accept multiline selection
            return null;
        }
        var state = new __WEBPACK_IMPORTED_MODULE_8__browser_core_editorState_js__["a" /* EditorState */](this.editor, 1 /* Value */ | 4 /* Position */);
        if (!this.editorWorkerService.canNavigateValueSet(modelURI)) {
            return undefined;
        }
        this.currentRequest = Object(__WEBPACK_IMPORTED_MODULE_12__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return _this.editorWorkerService.navigateValueSet(modelURI, selection, up); });
        return this.currentRequest.then(function (result) {
            if (!result || !result.range || !result.value) {
                // No proper result
                return;
            }
            if (!state.validate(_this.editor)) {
                // state has changed
                return;
            }
            // Selection
            var editRange = __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].lift(result.range);
            var highlightRange = result.range;
            var diff = result.value.length - (selection.endColumn - selection.startColumn);
            // highlight
            highlightRange = {
                startLineNumber: highlightRange.startLineNumber,
                startColumn: highlightRange.startColumn,
                endLineNumber: highlightRange.endLineNumber,
                endColumn: highlightRange.startColumn + result.value.length
            };
            if (diff > 1) {
                selection = new __WEBPACK_IMPORTED_MODULE_3__common_core_selection_js__["a" /* Selection */](selection.startLineNumber, selection.startColumn, selection.endLineNumber, selection.endColumn + diff - 1);
            }
            // Insert new text
            var command = new __WEBPACK_IMPORTED_MODULE_7__inPlaceReplaceCommand_js__["a" /* InPlaceReplaceCommand */](editRange, selection, result.value);
            _this.editor.pushUndoStop();
            _this.editor.executeCommand(source, command);
            _this.editor.pushUndoStop();
            // add decoration
            _this.decorationIds = _this.editor.deltaDecorations(_this.decorationIds, [{
                    range: highlightRange,
                    options: InPlaceReplaceController.DECORATION
                }]);
            // remove decoration after delay
            if (_this.decorationRemover) {
                _this.decorationRemover.cancel();
            }
            _this.decorationRemover = Object(__WEBPACK_IMPORTED_MODULE_12__base_common_async_js__["m" /* timeout */])(350);
            _this.decorationRemover.then(function () { return _this.decorationIds = _this.editor.deltaDecorations(_this.decorationIds, []); }).catch(__WEBPACK_IMPORTED_MODULE_13__base_common_errors_js__["e" /* onUnexpectedError */]);
        }).catch(__WEBPACK_IMPORTED_MODULE_13__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    InPlaceReplaceController.ID = 'editor.contrib.inPlaceReplaceController';
    InPlaceReplaceController.DECORATION = __WEBPACK_IMPORTED_MODULE_11__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'valueSetReplacement'
    });
    InPlaceReplaceController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_6__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */])
    ], InPlaceReplaceController);
    return InPlaceReplaceController;
}());
var InPlaceReplaceUp = /** @class */ (function (_super) {
    __extends(InPlaceReplaceUp, _super);
    function InPlaceReplaceUp() {
        return _super.call(this, {
            id: 'editor.action.inPlaceReplace.up',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('InPlaceReplaceAction.previous.label', "Replace with Previous Value"),
            alias: 'Replace with Previous Value',
            precondition: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 82 /* US_COMMA */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    InPlaceReplaceUp.prototype.run = function (accessor, editor) {
        var controller = InPlaceReplaceController.get(editor);
        if (!controller) {
            return undefined;
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].wrap(controller.run(this.id, true));
    };
    return InPlaceReplaceUp;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));
var InPlaceReplaceDown = /** @class */ (function (_super) {
    __extends(InPlaceReplaceDown, _super);
    function InPlaceReplaceDown() {
        return _super.call(this, {
            id: 'editor.action.inPlaceReplace.down',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('InPlaceReplaceAction.next.label', "Replace with Next Value"),
            alias: 'Replace with Next Value',
            precondition: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 84 /* US_DOT */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    InPlaceReplaceDown.prototype.run = function (accessor, editor) {
        var controller = InPlaceReplaceController.get(editor);
        if (!controller) {
            return undefined;
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].wrap(controller.run(this.id, false));
    };
    return InPlaceReplaceDown;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["h" /* registerEditorContribution */])(InPlaceReplaceController);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(InPlaceReplaceUp);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(InPlaceReplaceDown);
Object(__WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var border = theme.getColor(__WEBPACK_IMPORTED_MODULE_10__common_view_editorColorRegistry_js__["d" /* editorBracketMatchBorder */]);
    if (border) {
        collector.addRule(".monaco-editor.vs .valueSetReplacement { outline: solid 2px " + border + "; }");
    }
});


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspectTokens_css__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspectTokens_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inspectTokens_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_services_modeService_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_standaloneThemeService_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_modes_nullMode_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};













var InspectTokensController = /** @class */ (function (_super) {
    __extends(InspectTokensController, _super);
    function InspectTokensController(editor, standaloneColorService, modeService) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        _this._standaloneThemeService = standaloneColorService;
        _this._modeService = modeService;
        _this._widget = null;
        _this._register(_this._editor.onDidChangeModel(function (e) { return _this.stop(); }));
        _this._register(_this._editor.onDidChangeModelLanguage(function (e) { return _this.stop(); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_7__common_modes_js__["y" /* TokenizationRegistry */].onDidChange(function (e) { return _this.stop(); }));
        return _this;
    }
    InspectTokensController.get = function (editor) {
        return editor.getContribution(InspectTokensController.ID);
    };
    InspectTokensController.prototype.getId = function () {
        return InspectTokensController.ID;
    };
    InspectTokensController.prototype.dispose = function () {
        this.stop();
        _super.prototype.dispose.call(this);
    };
    InspectTokensController.prototype.launch = function () {
        if (this._widget) {
            return;
        }
        if (!this._editor.getModel()) {
            return;
        }
        this._widget = new InspectTokensWidget(this._editor, this._standaloneThemeService, this._modeService);
    };
    InspectTokensController.prototype.stop = function () {
        if (this._widget) {
            this._widget.dispose();
            this._widget = null;
        }
    };
    InspectTokensController.ID = 'editor.contrib.inspectTokens';
    InspectTokensController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_8__common_standaloneThemeService_js__["a" /* IStandaloneThemeService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_6__common_services_modeService_js__["a" /* IModeService */])
    ], InspectTokensController);
    return InspectTokensController;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));
var InspectTokens = /** @class */ (function (_super) {
    __extends(InspectTokens, _super);
    function InspectTokens() {
        return _super.call(this, {
            id: 'editor.action.inspectTokens',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('inspectTokens', "Developer: Inspect Tokens"),
            alias: 'Developer: Inspect Tokens',
            precondition: null
        }) || this;
    }
    InspectTokens.prototype.run = function (accessor, editor) {
        var controller = InspectTokensController.get(editor);
        if (controller) {
            controller.launch();
        }
    };
    return InspectTokens;
}(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["b" /* EditorAction */]));
function renderTokenText(tokenText) {
    var result = '';
    for (var charIndex = 0, len = tokenText.length; charIndex < len; charIndex++) {
        var charCode = tokenText.charCodeAt(charIndex);
        switch (charCode) {
            case 9 /* Tab */:
                result += '&rarr;';
                break;
            case 32 /* Space */:
                result += '&middot;';
                break;
            case 60 /* LessThan */:
                result += '&lt;';
                break;
            case 62 /* GreaterThan */:
                result += '&gt;';
                break;
            case 38 /* Ampersand */:
                result += '&amp;';
                break;
            default:
                result += String.fromCharCode(charCode);
        }
    }
    return result;
}
function getSafeTokenizationSupport(languageIdentifier) {
    var tokenizationSupport = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["y" /* TokenizationRegistry */].get(languageIdentifier.language);
    if (tokenizationSupport) {
        return tokenizationSupport;
    }
    return {
        getInitialState: function () { return __WEBPACK_IMPORTED_MODULE_9__common_modes_nullMode_js__["c" /* NULL_STATE */]; },
        tokenize: function (line, state, deltaOffset) { return Object(__WEBPACK_IMPORTED_MODULE_9__common_modes_nullMode_js__["d" /* nullTokenize */])(languageIdentifier.language, line, state, deltaOffset); },
        tokenize2: function (line, state, deltaOffset) { return Object(__WEBPACK_IMPORTED_MODULE_9__common_modes_nullMode_js__["e" /* nullTokenize2 */])(languageIdentifier.id, line, state, deltaOffset); }
    };
}
var InspectTokensWidget = /** @class */ (function (_super) {
    __extends(InspectTokensWidget, _super);
    function InspectTokensWidget(editor, standaloneThemeService, modeService) {
        var _this = _super.call(this) || this;
        // Editor.IContentWidget.allowEditorOverflow
        _this.allowEditorOverflow = true;
        _this._editor = editor;
        _this._modeService = modeService;
        _this._model = _this._editor.getModel();
        _this._domNode = document.createElement('div');
        _this._domNode.className = 'tokens-inspect-widget';
        _this._tokenizationSupport = getSafeTokenizationSupport(_this._model.getLanguageIdentifier());
        _this._compute(_this._editor.getPosition());
        _this._register(_this._editor.onDidChangeCursorPosition(function (e) { return _this._compute(_this._editor.getPosition()); }));
        _this._editor.addContentWidget(_this);
        return _this;
    }
    InspectTokensWidget.prototype.dispose = function () {
        this._editor.removeContentWidget(this);
        _super.prototype.dispose.call(this);
    };
    InspectTokensWidget.prototype.getId = function () {
        return InspectTokensWidget._ID;
    };
    InspectTokensWidget.prototype._compute = function (position) {
        var data = this._getTokensAtLine(position.lineNumber);
        var token1Index = 0;
        for (var i = data.tokens1.length - 1; i >= 0; i--) {
            var t = data.tokens1[i];
            if (position.column - 1 >= t.offset) {
                token1Index = i;
                break;
            }
        }
        var token2Index = 0;
        for (var i = (data.tokens2.length >>> 1); i >= 0; i--) {
            if (position.column - 1 >= data.tokens2[(i << 1)]) {
                token2Index = i;
                break;
            }
        }
        var result = '';
        var lineContent = this._model.getLineContent(position.lineNumber);
        var tokenText = '';
        if (token1Index < data.tokens1.length) {
            var tokenStartIndex = data.tokens1[token1Index].offset;
            var tokenEndIndex = token1Index + 1 < data.tokens1.length ? data.tokens1[token1Index + 1].offset : lineContent.length;
            tokenText = lineContent.substring(tokenStartIndex, tokenEndIndex);
        }
        result += "<h2 class=\"tm-token\">" + renderTokenText(tokenText) + "<span class=\"tm-token-length\">(" + tokenText.length + " " + (tokenText.length === 1 ? 'char' : 'chars') + ")</span></h2>";
        result += "<hr class=\"tokens-inspect-separator\" style=\"clear:both\"/>";
        var metadata = this._decodeMetadata(data.tokens2[(token2Index << 1) + 1]);
        result += "<table class=\"tm-metadata-table\"><tbody>";
        result += "<tr><td class=\"tm-metadata-key\">language</td><td class=\"tm-metadata-value\">" + Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["escape"])(metadata.languageIdentifier.language) + "</td>";
        result += "<tr><td class=\"tm-metadata-key\">token type</td><td class=\"tm-metadata-value\">" + this._tokenTypeToString(metadata.tokenType) + "</td>";
        result += "<tr><td class=\"tm-metadata-key\">font style</td><td class=\"tm-metadata-value\">" + this._fontStyleToString(metadata.fontStyle) + "</td>";
        result += "<tr><td class=\"tm-metadata-key\">foreground</td><td class=\"tm-metadata-value\">" + __WEBPACK_IMPORTED_MODULE_10__base_common_color_js__["a" /* Color */].Format.CSS.formatHex(metadata.foreground) + "</td>";
        result += "<tr><td class=\"tm-metadata-key\">background</td><td class=\"tm-metadata-value\">" + __WEBPACK_IMPORTED_MODULE_10__base_common_color_js__["a" /* Color */].Format.CSS.formatHex(metadata.background) + "</td>";
        result += "</tbody></table>";
        result += "<hr class=\"tokens-inspect-separator\"/>";
        if (token1Index < data.tokens1.length) {
            result += "<span class=\"tm-token-type\">" + Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["escape"])(data.tokens1[token1Index].type) + "</span>";
        }
        this._domNode.innerHTML = result;
        this._editor.layoutContentWidget(this);
    };
    InspectTokensWidget.prototype._decodeMetadata = function (metadata) {
        var colorMap = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["y" /* TokenizationRegistry */].getColorMap();
        var languageId = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["x" /* TokenMetadata */].getLanguageId(metadata);
        var tokenType = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["x" /* TokenMetadata */].getTokenType(metadata);
        var fontStyle = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["x" /* TokenMetadata */].getFontStyle(metadata);
        var foreground = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["x" /* TokenMetadata */].getForeground(metadata);
        var background = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["x" /* TokenMetadata */].getBackground(metadata);
        return {
            languageIdentifier: this._modeService.getLanguageIdentifier(languageId),
            tokenType: tokenType,
            fontStyle: fontStyle,
            foreground: colorMap[foreground],
            background: colorMap[background]
        };
    };
    InspectTokensWidget.prototype._tokenTypeToString = function (tokenType) {
        switch (tokenType) {
            case 0 /* Other */: return 'Other';
            case 1 /* Comment */: return 'Comment';
            case 2 /* String */: return 'String';
            case 4 /* RegEx */: return 'RegEx';
        }
        return '??';
    };
    InspectTokensWidget.prototype._fontStyleToString = function (fontStyle) {
        var r = '';
        if (fontStyle & 1 /* Italic */) {
            r += 'italic ';
        }
        if (fontStyle & 2 /* Bold */) {
            r += 'bold ';
        }
        if (fontStyle & 4 /* Underline */) {
            r += 'underline ';
        }
        if (r.length === 0) {
            r = '---';
        }
        return r;
    };
    InspectTokensWidget.prototype._getTokensAtLine = function (lineNumber) {
        var stateBeforeLine = this._getStateBeforeLine(lineNumber);
        var tokenizationResult1 = this._tokenizationSupport.tokenize(this._model.getLineContent(lineNumber), stateBeforeLine, 0);
        var tokenizationResult2 = this._tokenizationSupport.tokenize2(this._model.getLineContent(lineNumber), stateBeforeLine, 0);
        return {
            startState: stateBeforeLine,
            tokens1: tokenizationResult1.tokens,
            tokens2: tokenizationResult2.tokens,
            endState: tokenizationResult1.endState
        };
    };
    InspectTokensWidget.prototype._getStateBeforeLine = function (lineNumber) {
        var state = this._tokenizationSupport.getInitialState();
        for (var i = 1; i < lineNumber; i++) {
            var tokenizationResult = this._tokenizationSupport.tokenize(this._model.getLineContent(i), state, 0);
            state = tokenizationResult.endState;
        }
        return state;
    };
    InspectTokensWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    InspectTokensWidget.prototype.getPosition = function () {
        return {
            position: this._editor.getPosition(),
            preference: [__WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].BELOW, __WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE]
        };
    };
    InspectTokensWidget._ID = 'editor.contrib.inspectTokensWidget';
    return InspectTokensWidget;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["h" /* registerEditorContribution */])(InspectTokensController);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(InspectTokens);
Object(__WEBPACK_IMPORTED_MODULE_11__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var border = theme.getColor(__WEBPACK_IMPORTED_MODULE_12__platform_theme_common_colorRegistry_js__["w" /* editorHoverBorder */]);
    if (border) {
        var borderWidth = theme.type === __WEBPACK_IMPORTED_MODULE_11__platform_theme_common_themeService_js__["b" /* HIGH_CONTRAST */] ? 2 : 1;
        collector.addRule(".monaco-editor .tokens-inspect-widget { border: " + borderWidth + "px solid " + border + "; }");
        collector.addRule(".monaco-editor .tokens-inspect-widget .tokens-inspect-separator { background-color: " + border + "; }");
    }
    var background = theme.getColor(__WEBPACK_IMPORTED_MODULE_12__platform_theme_common_colorRegistry_js__["v" /* editorHoverBackground */]);
    if (background) {
        collector.addRule(".monaco-editor .tokens-inspect-widget { background-color: " + background + "; }");
    }
});


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IPadShowKeyboard", function() { return IPadShowKeyboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iPadShowKeyboard_css__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iPadShowKeyboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__iPadShowKeyboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/







var IPadShowKeyboard = /** @class */ (function () {
    function IPadShowKeyboard(editor) {
        var _this = this;
        this.editor = editor;
        this.toDispose = [];
        if (__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["l" /* isIPad */]) {
            this.toDispose.push(editor.onDidChangeConfiguration(function () { return _this.update(); }));
            this.update();
        }
    }
    IPadShowKeyboard.prototype.update = function () {
        var hasWidget = (!!this.widget);
        var shouldHaveWidget = (!this.editor.getConfiguration().readOnly);
        if (!hasWidget && shouldHaveWidget) {
            this.widget = new ShowKeyboardWidget(this.editor);
        }
        else if (hasWidget && !shouldHaveWidget) {
            this.widget.dispose();
            this.widget = null;
        }
    };
    IPadShowKeyboard.prototype.getId = function () {
        return IPadShowKeyboard.ID;
    };
    IPadShowKeyboard.prototype.dispose = function () {
        this.toDispose = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this.toDispose);
        if (this.widget) {
            this.widget.dispose();
            this.widget = null;
        }
    };
    IPadShowKeyboard.ID = 'editor.contrib.iPadShowKeyboard';
    return IPadShowKeyboard;
}());

var ShowKeyboardWidget = /** @class */ (function () {
    function ShowKeyboardWidget(editor) {
        var _this = this;
        this.editor = editor;
        this._domNode = document.createElement('textarea');
        this._domNode.className = 'iPadShowKeyboard';
        this._toDispose = [];
        this._toDispose.push(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](this._domNode, 'touchstart', function (e) {
            _this.editor.focus();
        }));
        this._toDispose.push(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](this._domNode, 'focus', function (e) {
            _this.editor.focus();
        }));
        this.editor.addOverlayWidget(this);
    }
    ShowKeyboardWidget.prototype.dispose = function () {
        this.editor.removeOverlayWidget(this);
        this._toDispose = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._toDispose);
    };
    // ----- IOverlayWidget API
    ShowKeyboardWidget.prototype.getId = function () {
        return ShowKeyboardWidget.ID;
    };
    ShowKeyboardWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    ShowKeyboardWidget.prototype.getPosition = function () {
        return {
            preference: __WEBPACK_IMPORTED_MODULE_4__browser_editorBrowser_js__["c" /* OverlayWidgetPositionPreference */].BOTTOM_RIGHT_CORNER
        };
    };
    ShowKeyboardWidget.ID = 'editor.contrib.ShowKeyboardWidget';
    return ShowKeyboardWidget;
}());
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["h" /* registerEditorContribution */])(IPadShowKeyboard);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractSortLinesAction", function() { return AbstractSortLinesAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortLinesAscendingAction", function() { return SortLinesAscendingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortLinesDescendingAction", function() { return SortLinesDescendingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrimTrailingWhitespaceAction", function() { return TrimTrailingWhitespaceAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndentLinesAction", function() { return IndentLinesAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InsertLineBeforeAction", function() { return InsertLineBeforeAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InsertLineAfterAction", function() { return InsertLineAfterAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractDeleteAllToBoundaryAction", function() { return AbstractDeleteAllToBoundaryAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteAllLeftAction", function() { return DeleteAllLeftAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteAllRightAction", function() { return DeleteAllRightAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JoinLinesAction", function() { return JoinLinesAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransposeAction", function() { return TransposeAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCaseAction", function() { return AbstractCaseAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpperCaseAction", function() { return UpperCaseAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LowerCaseAction", function() { return LowerCaseAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sortLinesCommand_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_commands_trimTrailingWhitespaceCommand_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__copyLinesCommand_js__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deleteLinesCommand_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__moveLinesCommand_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_controller_cursorTypeOperations_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browser_controller_coreCommands_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__ = __webpack_require__(41);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

















// copy lines
var AbstractCopyLinesAction = /** @class */ (function (_super) {
    __extends(AbstractCopyLinesAction, _super);
    function AbstractCopyLinesAction(down, opts) {
        var _this = _super.call(this, opts) || this;
        _this.down = down;
        return _this;
    }
    AbstractCopyLinesAction.prototype.run = function (_accessor, editor) {
        var commands = [];
        var selections = editor.getSelections();
        for (var i = 0; i < selections.length; i++) {
            commands.push(new __WEBPACK_IMPORTED_MODULE_11__copyLinesCommand_js__["a" /* CopyLinesCommand */](selections[i], this.down));
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return AbstractCopyLinesAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));
var CopyLinesUpAction = /** @class */ (function (_super) {
    __extends(CopyLinesUpAction, _super);
    function CopyLinesUpAction() {
        return _super.call(this, false, {
            id: 'editor.action.copyLinesUpAction',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.copyUp', "Copy Line Up"),
            alias: 'Copy Line Up',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 512 /* Alt */ | 1024 /* Shift */ | 16 /* UpArrow */,
                linux: { primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 1024 /* Shift */ | 16 /* UpArrow */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '2_line',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miCopyLinesUp', comment: ['&& denotes a mnemonic'] }, "&&Copy Line Up"),
                order: 1
            }
        }) || this;
    }
    return CopyLinesUpAction;
}(AbstractCopyLinesAction));
var CopyLinesDownAction = /** @class */ (function (_super) {
    __extends(CopyLinesDownAction, _super);
    function CopyLinesDownAction() {
        return _super.call(this, true, {
            id: 'editor.action.copyLinesDownAction',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.copyDown', "Copy Line Down"),
            alias: 'Copy Line Down',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 512 /* Alt */ | 1024 /* Shift */ | 18 /* DownArrow */,
                linux: { primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 1024 /* Shift */ | 18 /* DownArrow */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '2_line',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miCopyLinesDown', comment: ['&& denotes a mnemonic'] }, "Co&&py Line Down"),
                order: 2
            }
        }) || this;
    }
    return CopyLinesDownAction;
}(AbstractCopyLinesAction));
// move lines
var AbstractMoveLinesAction = /** @class */ (function (_super) {
    __extends(AbstractMoveLinesAction, _super);
    function AbstractMoveLinesAction(down, opts) {
        var _this = _super.call(this, opts) || this;
        _this.down = down;
        return _this;
    }
    AbstractMoveLinesAction.prototype.run = function (_accessor, editor) {
        var commands = [];
        var selections = editor.getSelections();
        var autoIndent = editor.getConfiguration().autoIndent;
        for (var i = 0; i < selections.length; i++) {
            commands.push(new __WEBPACK_IMPORTED_MODULE_13__moveLinesCommand_js__["a" /* MoveLinesCommand */](selections[i], this.down, autoIndent));
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return AbstractMoveLinesAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));
var MoveLinesUpAction = /** @class */ (function (_super) {
    __extends(MoveLinesUpAction, _super);
    function MoveLinesUpAction() {
        return _super.call(this, false, {
            id: 'editor.action.moveLinesUpAction',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.moveUp', "Move Line Up"),
            alias: 'Move Line Up',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 512 /* Alt */ | 16 /* UpArrow */,
                linux: { primary: 512 /* Alt */ | 16 /* UpArrow */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '2_line',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miMoveLinesUp', comment: ['&& denotes a mnemonic'] }, "Mo&&ve Line Up"),
                order: 3
            }
        }) || this;
    }
    return MoveLinesUpAction;
}(AbstractMoveLinesAction));
var MoveLinesDownAction = /** @class */ (function (_super) {
    __extends(MoveLinesDownAction, _super);
    function MoveLinesDownAction() {
        return _super.call(this, true, {
            id: 'editor.action.moveLinesDownAction',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.moveDown', "Move Line Down"),
            alias: 'Move Line Down',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 512 /* Alt */ | 18 /* DownArrow */,
                linux: { primary: 512 /* Alt */ | 18 /* DownArrow */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '2_line',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miMoveLinesDown', comment: ['&& denotes a mnemonic'] }, "Move &&Line Down"),
                order: 4
            }
        }) || this;
    }
    return MoveLinesDownAction;
}(AbstractMoveLinesAction));
var AbstractSortLinesAction = /** @class */ (function (_super) {
    __extends(AbstractSortLinesAction, _super);
    function AbstractSortLinesAction(descending, opts) {
        var _this = _super.call(this, opts) || this;
        _this.descending = descending;
        return _this;
    }
    AbstractSortLinesAction.prototype.run = function (_accessor, editor) {
        var selections = editor.getSelections();
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (!__WEBPACK_IMPORTED_MODULE_2__sortLinesCommand_js__["a" /* SortLinesCommand */].canRun(editor.getModel(), selection, this.descending)) {
                return;
            }
        }
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            commands[i] = new __WEBPACK_IMPORTED_MODULE_2__sortLinesCommand_js__["a" /* SortLinesCommand */](selections[i], this.descending);
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return AbstractSortLinesAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var SortLinesAscendingAction = /** @class */ (function (_super) {
    __extends(SortLinesAscendingAction, _super);
    function SortLinesAscendingAction() {
        return _super.call(this, false, {
            id: 'editor.action.sortLinesAscending',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.sortAscending', "Sort Lines Ascending"),
            alias: 'Sort Lines Ascending',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return SortLinesAscendingAction;
}(AbstractSortLinesAction));

var SortLinesDescendingAction = /** @class */ (function (_super) {
    __extends(SortLinesDescendingAction, _super);
    function SortLinesDescendingAction() {
        return _super.call(this, true, {
            id: 'editor.action.sortLinesDescending',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.sortDescending', "Sort Lines Descending"),
            alias: 'Sort Lines Descending',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    return SortLinesDescendingAction;
}(AbstractSortLinesAction));

var TrimTrailingWhitespaceAction = /** @class */ (function (_super) {
    __extends(TrimTrailingWhitespaceAction, _super);
    function TrimTrailingWhitespaceAction() {
        return _super.call(this, {
            id: TrimTrailingWhitespaceAction.ID,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.trimTrailingWhitespace', "Trim Trailing Whitespace"),
            alias: 'Trim Trailing Whitespace',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_1__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 54 /* KEY_X */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    TrimTrailingWhitespaceAction.prototype.run = function (_accessor, editor, args) {
        var cursors = [];
        if (args.reason === 'auto-save') {
            // See https://github.com/editorconfig/editorconfig-vscode/issues/47
            // It is very convenient for the editor config extension to invoke this action.
            // So, if we get a reason:'auto-save' passed in, let's preserve cursor positions.
            cursors = editor.getSelections().map(function (s) { return new __WEBPACK_IMPORTED_MODULE_9__common_core_position_js__["a" /* Position */](s.positionLineNumber, s.positionColumn); });
        }
        var command = new __WEBPACK_IMPORTED_MODULE_4__common_commands_trimTrailingWhitespaceCommand_js__["a" /* TrimTrailingWhitespaceCommand */](editor.getSelection(), cursors);
        editor.pushUndoStop();
        editor.executeCommands(this.id, [command]);
        editor.pushUndoStop();
    };
    TrimTrailingWhitespaceAction.ID = 'editor.action.trimTrailingWhitespace';
    return TrimTrailingWhitespaceAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var DeleteLinesAction = /** @class */ (function (_super) {
    __extends(DeleteLinesAction, _super);
    function DeleteLinesAction() {
        return _super.call(this, {
            id: 'editor.action.deleteLines',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.delete', "Delete Line"),
            alias: 'Delete Line',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 41 /* KEY_K */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    DeleteLinesAction.prototype.run = function (_accessor, editor) {
        var ops = this._getLinesToRemove(editor);
        // Finally, construct the delete lines commands
        var commands = ops.map(function (op) {
            return new __WEBPACK_IMPORTED_MODULE_12__deleteLinesCommand_js__["a" /* DeleteLinesCommand */](op.startLineNumber, op.endLineNumber, op.positionColumn);
        });
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    DeleteLinesAction.prototype._getLinesToRemove = function (editor) {
        // Construct delete operations
        var operations = editor.getSelections().map(function (s) {
            var endLineNumber = s.endLineNumber;
            if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
                endLineNumber -= 1;
            }
            return {
                startLineNumber: s.startLineNumber,
                endLineNumber: endLineNumber,
                positionColumn: s.positionColumn
            };
        });
        // Sort delete operations
        operations.sort(function (a, b) {
            return a.startLineNumber - b.startLineNumber;
        });
        // Merge delete operations on consecutive lines
        var mergedOperations = [];
        var previousOperation = operations[0];
        for (var i = 1; i < operations.length; i++) {
            if (previousOperation.endLineNumber + 1 === operations[i].startLineNumber) {
                // Merge current operations into the previous one
                previousOperation.endLineNumber = operations[i].endLineNumber;
            }
            else {
                // Push previous operation
                mergedOperations.push(previousOperation);
                previousOperation = operations[i];
            }
        }
        // Push the last operation
        mergedOperations.push(previousOperation);
        return mergedOperations;
    };
    return DeleteLinesAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));
var IndentLinesAction = /** @class */ (function (_super) {
    __extends(IndentLinesAction, _super);
    function IndentLinesAction() {
        return _super.call(this, {
            id: 'editor.action.indentLines',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.indent', "Indent Line"),
            alias: 'Indent Line',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 89 /* US_CLOSE_SQUARE_BRACKET */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    IndentLinesAction.prototype.run = function (_accessor, editor) {
        editor.pushUndoStop();
        editor.executeCommands(this.id, __WEBPACK_IMPORTED_MODULE_14__common_controller_cursorTypeOperations_js__["a" /* TypeOperations */].indent(editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()));
        editor.pushUndoStop();
    };
    return IndentLinesAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var OutdentLinesAction = /** @class */ (function (_super) {
    __extends(OutdentLinesAction, _super);
    function OutdentLinesAction() {
        return _super.call(this, {
            id: 'editor.action.outdentLines',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.outdent', "Outdent Line"),
            alias: 'Outdent Line',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 87 /* US_OPEN_SQUARE_BRACKET */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    OutdentLinesAction.prototype.run = function (_accessor, editor) {
        __WEBPACK_IMPORTED_MODULE_15__browser_controller_coreCommands_js__["CoreEditingCommands"].Outdent.runEditorCommand(null, editor, null);
    };
    return OutdentLinesAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));
var InsertLineBeforeAction = /** @class */ (function (_super) {
    __extends(InsertLineBeforeAction, _super);
    function InsertLineBeforeAction() {
        return _super.call(this, {
            id: 'editor.action.insertLineBefore',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.insertBefore', "Insert Line Above"),
            alias: 'Insert Line Above',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 3 /* Enter */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    InsertLineBeforeAction.prototype.run = function (_accessor, editor) {
        editor.pushUndoStop();
        editor.executeCommands(this.id, __WEBPACK_IMPORTED_MODULE_14__common_controller_cursorTypeOperations_js__["a" /* TypeOperations */].lineInsertBefore(editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()));
    };
    return InsertLineBeforeAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var InsertLineAfterAction = /** @class */ (function (_super) {
    __extends(InsertLineAfterAction, _super);
    function InsertLineAfterAction() {
        return _super.call(this, {
            id: 'editor.action.insertLineAfter',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.insertAfter', "Insert Line Below"),
            alias: 'Insert Line Below',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 3 /* Enter */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    InsertLineAfterAction.prototype.run = function (_accessor, editor) {
        editor.pushUndoStop();
        editor.executeCommands(this.id, __WEBPACK_IMPORTED_MODULE_14__common_controller_cursorTypeOperations_js__["a" /* TypeOperations */].lineInsertAfter(editor._getCursorConfiguration(), editor.getModel(), editor.getSelections()));
    };
    return InsertLineAfterAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var AbstractDeleteAllToBoundaryAction = /** @class */ (function (_super) {
    __extends(AbstractDeleteAllToBoundaryAction, _super);
    function AbstractDeleteAllToBoundaryAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractDeleteAllToBoundaryAction.prototype.run = function (_accessor, editor) {
        var primaryCursor = editor.getSelection();
        var rangesToDelete = this._getRangesToDelete(editor);
        // merge overlapping selections
        var effectiveRanges = [];
        for (var i = 0, count = rangesToDelete.length - 1; i < count; i++) {
            var range = rangesToDelete[i];
            var nextRange = rangesToDelete[i + 1];
            if (__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].intersectRanges(range, nextRange) === null) {
                effectiveRanges.push(range);
            }
            else {
                rangesToDelete[i + 1] = __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].plusRange(range, nextRange);
            }
        }
        effectiveRanges.push(rangesToDelete[rangesToDelete.length - 1]);
        var endCursorState = this._getEndCursorState(primaryCursor, effectiveRanges);
        var edits = effectiveRanges.map(function (range) {
            return __WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__["a" /* EditOperation */].replace(range, '');
        });
        editor.pushUndoStop();
        editor.executeEdits(this.id, edits, endCursorState);
        editor.pushUndoStop();
    };
    return AbstractDeleteAllToBoundaryAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var DeleteAllLeftAction = /** @class */ (function (_super) {
    __extends(DeleteAllLeftAction, _super);
    function DeleteAllLeftAction() {
        return _super.call(this, {
            id: 'deleteAllLeft',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.deleteAllLeft', "Delete All Left"),
            alias: 'Delete All Left',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: null,
                mac: { primary: 2048 /* CtrlCmd */ | 1 /* Backspace */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    DeleteAllLeftAction.prototype._getEndCursorState = function (primaryCursor, rangesToDelete) {
        var endPrimaryCursor;
        var endCursorState = [];
        var deletedLines = 0;
        rangesToDelete.forEach(function (range) {
            var endCursor;
            if (range.endColumn === 1 && deletedLines > 0) {
                var newStartLine = range.startLineNumber - deletedLines;
                endCursor = new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](newStartLine, range.startColumn, newStartLine, range.startColumn);
            }
            else {
                endCursor = new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](range.startLineNumber, range.startColumn, range.startLineNumber, range.startColumn);
            }
            deletedLines += range.endLineNumber - range.startLineNumber;
            if (range.intersectRanges(primaryCursor)) {
                endPrimaryCursor = endCursor;
            }
            else {
                endCursorState.push(endCursor);
            }
        });
        if (endPrimaryCursor) {
            endCursorState.unshift(endPrimaryCursor);
        }
        return endCursorState;
    };
    DeleteAllLeftAction.prototype._getRangesToDelete = function (editor) {
        var rangesToDelete = editor.getSelections();
        var model = editor.getModel();
        rangesToDelete.sort(__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
        rangesToDelete = rangesToDelete.map(function (selection) {
            if (selection.isEmpty()) {
                if (selection.startColumn === 1) {
                    var deleteFromLine = Math.max(1, selection.startLineNumber - 1);
                    var deleteFromColumn = selection.startLineNumber === 1 ? 1 : model.getLineContent(deleteFromLine).length + 1;
                    return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](deleteFromLine, deleteFromColumn, selection.startLineNumber, 1);
                }
                else {
                    return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](selection.startLineNumber, 1, selection.startLineNumber, selection.startColumn);
                }
            }
            else {
                return selection;
            }
        });
        return rangesToDelete;
    };
    return DeleteAllLeftAction;
}(AbstractDeleteAllToBoundaryAction));

var DeleteAllRightAction = /** @class */ (function (_super) {
    __extends(DeleteAllRightAction, _super);
    function DeleteAllRightAction() {
        return _super.call(this, {
            id: 'deleteAllRight',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.deleteAllRight', "Delete All Right"),
            alias: 'Delete All Right',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: null,
                mac: { primary: 256 /* WinCtrl */ | 41 /* KEY_K */, secondary: [2048 /* CtrlCmd */ | 20 /* Delete */] },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    DeleteAllRightAction.prototype._getEndCursorState = function (primaryCursor, rangesToDelete) {
        var endPrimaryCursor;
        var endCursorState = [];
        for (var i = 0, len = rangesToDelete.length, offset = 0; i < len; i++) {
            var range = rangesToDelete[i];
            var endCursor = new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](range.startLineNumber - offset, range.startColumn, range.startLineNumber - offset, range.startColumn);
            if (range.intersectRanges(primaryCursor)) {
                endPrimaryCursor = endCursor;
            }
            else {
                endCursorState.push(endCursor);
            }
        }
        if (endPrimaryCursor) {
            endCursorState.unshift(endPrimaryCursor);
        }
        return endCursorState;
    };
    DeleteAllRightAction.prototype._getRangesToDelete = function (editor) {
        var model = editor.getModel();
        var rangesToDelete = editor.getSelections().map(function (sel) {
            if (sel.isEmpty()) {
                var maxColumn = model.getLineMaxColumn(sel.startLineNumber);
                if (sel.startColumn === maxColumn) {
                    return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](sel.startLineNumber, sel.startColumn, sel.startLineNumber + 1, 1);
                }
                else {
                    return new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](sel.startLineNumber, sel.startColumn, sel.startLineNumber, maxColumn);
                }
            }
            return sel;
        });
        rangesToDelete.sort(__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
        return rangesToDelete;
    };
    return DeleteAllRightAction;
}(AbstractDeleteAllToBoundaryAction));

var JoinLinesAction = /** @class */ (function (_super) {
    __extends(JoinLinesAction, _super);
    function JoinLinesAction() {
        return _super.call(this, {
            id: 'editor.action.joinLines',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('lines.joinLines', "Join Lines"),
            alias: 'Join Lines',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 0,
                mac: { primary: 256 /* WinCtrl */ | 40 /* KEY_J */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    JoinLinesAction.prototype.run = function (_accessor, editor) {
        var selections = editor.getSelections();
        var primaryCursor = editor.getSelection();
        selections.sort(__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
        var reducedSelections = [];
        var lastSelection = selections.reduce(function (previousValue, currentValue) {
            if (previousValue.isEmpty()) {
                if (previousValue.endLineNumber === currentValue.startLineNumber) {
                    if (primaryCursor.equalsSelection(previousValue)) {
                        primaryCursor = currentValue;
                    }
                    return currentValue;
                }
                if (currentValue.startLineNumber > previousValue.endLineNumber + 1) {
                    reducedSelections.push(previousValue);
                    return currentValue;
                }
                else {
                    return new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](previousValue.startLineNumber, previousValue.startColumn, currentValue.endLineNumber, currentValue.endColumn);
                }
            }
            else {
                if (currentValue.startLineNumber > previousValue.endLineNumber) {
                    reducedSelections.push(previousValue);
                    return currentValue;
                }
                else {
                    return new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](previousValue.startLineNumber, previousValue.startColumn, currentValue.endLineNumber, currentValue.endColumn);
                }
            }
        });
        reducedSelections.push(lastSelection);
        var model = editor.getModel();
        var edits = [];
        var endCursorState = [];
        var endPrimaryCursor = primaryCursor;
        var lineOffset = 0;
        for (var i = 0, len = reducedSelections.length; i < len; i++) {
            var selection = reducedSelections[i];
            var startLineNumber = selection.startLineNumber;
            var startColumn = 1;
            var columnDeltaOffset = 0;
            var endLineNumber = void 0, endColumn = void 0;
            var selectionEndPositionOffset = model.getLineContent(selection.endLineNumber).length - selection.endColumn;
            if (selection.isEmpty() || selection.startLineNumber === selection.endLineNumber) {
                var position = selection.getStartPosition();
                if (position.lineNumber < model.getLineCount()) {
                    endLineNumber = startLineNumber + 1;
                    endColumn = model.getLineMaxColumn(endLineNumber);
                }
                else {
                    endLineNumber = position.lineNumber;
                    endColumn = model.getLineMaxColumn(position.lineNumber);
                }
            }
            else {
                endLineNumber = selection.endLineNumber;
                endColumn = model.getLineMaxColumn(endLineNumber);
            }
            var trimmedLinesContent = model.getLineContent(startLineNumber);
            for (var i_1 = startLineNumber + 1; i_1 <= endLineNumber; i_1++) {
                var lineText = model.getLineContent(i_1);
                var firstNonWhitespaceIdx = model.getLineFirstNonWhitespaceColumn(i_1);
                if (firstNonWhitespaceIdx >= 1) {
                    var insertSpace = true;
                    if (trimmedLinesContent === '') {
                        insertSpace = false;
                    }
                    if (insertSpace && (trimmedLinesContent.charAt(trimmedLinesContent.length - 1) === ' ' ||
                        trimmedLinesContent.charAt(trimmedLinesContent.length - 1) === '\t')) {
                        insertSpace = false;
                        trimmedLinesContent = trimmedLinesContent.replace(/[\s\uFEFF\xA0]+$/g, ' ');
                    }
                    var lineTextWithoutIndent = lineText.substr(firstNonWhitespaceIdx - 1);
                    trimmedLinesContent += (insertSpace ? ' ' : '') + lineTextWithoutIndent;
                    if (insertSpace) {
                        columnDeltaOffset = lineTextWithoutIndent.length + 1;
                    }
                    else {
                        columnDeltaOffset = lineTextWithoutIndent.length;
                    }
                }
                else {
                    columnDeltaOffset = 0;
                }
            }
            var deleteSelection = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn);
            if (!deleteSelection.isEmpty()) {
                var resultSelection = void 0;
                if (selection.isEmpty()) {
                    edits.push(__WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__["a" /* EditOperation */].replace(deleteSelection, trimmedLinesContent));
                    resultSelection = new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](deleteSelection.startLineNumber - lineOffset, trimmedLinesContent.length - columnDeltaOffset + 1, startLineNumber - lineOffset, trimmedLinesContent.length - columnDeltaOffset + 1);
                }
                else {
                    if (selection.startLineNumber === selection.endLineNumber) {
                        edits.push(__WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__["a" /* EditOperation */].replace(deleteSelection, trimmedLinesContent));
                        resultSelection = new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](selection.startLineNumber - lineOffset, selection.startColumn, selection.endLineNumber - lineOffset, selection.endColumn);
                    }
                    else {
                        edits.push(__WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__["a" /* EditOperation */].replace(deleteSelection, trimmedLinesContent));
                        resultSelection = new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](selection.startLineNumber - lineOffset, selection.startColumn, selection.startLineNumber - lineOffset, trimmedLinesContent.length - selectionEndPositionOffset);
                    }
                }
                if (__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].intersectRanges(deleteSelection, primaryCursor) !== null) {
                    endPrimaryCursor = resultSelection;
                }
                else {
                    endCursorState.push(resultSelection);
                }
            }
            lineOffset += deleteSelection.endLineNumber - deleteSelection.startLineNumber;
        }
        endCursorState.unshift(endPrimaryCursor);
        editor.pushUndoStop();
        editor.executeEdits(this.id, edits, endCursorState);
        editor.pushUndoStop();
    };
    return JoinLinesAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var TransposeAction = /** @class */ (function (_super) {
    __extends(TransposeAction, _super);
    function TransposeAction() {
        return _super.call(this, {
            id: 'editor.action.transpose',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editor.transpose', "Transpose characters around the cursor"),
            alias: 'Transpose characters around the cursor',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    TransposeAction.prototype.run = function (_accessor, editor) {
        var selections = editor.getSelections();
        var model = editor.getModel();
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (!selection.isEmpty()) {
                continue;
            }
            var cursor = selection.getStartPosition();
            var maxColumn = model.getLineMaxColumn(cursor.lineNumber);
            if (cursor.column >= maxColumn) {
                if (cursor.lineNumber === model.getLineCount()) {
                    continue;
                }
                // The cursor is at the end of current line and current line is not empty
                // then we transpose the character before the cursor and the line break if there is any following line.
                var deleteSelection = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](cursor.lineNumber, Math.max(1, cursor.column - 1), cursor.lineNumber + 1, 1);
                var chars = model.getValueInRange(deleteSelection).split('').reverse().join('');
                commands.push(new __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__["a" /* ReplaceCommand */](new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](cursor.lineNumber, Math.max(1, cursor.column - 1), cursor.lineNumber + 1, 1), chars));
            }
            else {
                var deleteSelection = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](cursor.lineNumber, Math.max(1, cursor.column - 1), cursor.lineNumber, cursor.column + 1);
                var chars = model.getValueInRange(deleteSelection).split('').reverse().join('');
                commands.push(new __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__["b" /* ReplaceCommandThatPreservesSelection */](deleteSelection, chars, new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](cursor.lineNumber, cursor.column + 1, cursor.lineNumber, cursor.column + 1)));
            }
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return TransposeAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var AbstractCaseAction = /** @class */ (function (_super) {
    __extends(AbstractCaseAction, _super);
    function AbstractCaseAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractCaseAction.prototype.run = function (_accessor, editor) {
        var selections = editor.getSelections();
        var model = editor.getModel();
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (selection.isEmpty()) {
                var cursor = selection.getStartPosition();
                var word = model.getWordAtPosition(cursor);
                if (!word) {
                    continue;
                }
                var wordRange = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](cursor.lineNumber, word.startColumn, cursor.lineNumber, word.endColumn);
                var text = model.getValueInRange(wordRange);
                commands.push(new __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__["b" /* ReplaceCommandThatPreservesSelection */](wordRange, this._modifyText(text), new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](cursor.lineNumber, cursor.column, cursor.lineNumber, cursor.column)));
            }
            else {
                var text = model.getValueInRange(selection);
                commands.push(new __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__["b" /* ReplaceCommandThatPreservesSelection */](selection, this._modifyText(text), selection));
            }
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    };
    return AbstractCaseAction;
}(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["b" /* EditorAction */]));

var UpperCaseAction = /** @class */ (function (_super) {
    __extends(UpperCaseAction, _super);
    function UpperCaseAction() {
        return _super.call(this, {
            id: 'editor.action.transformToUppercase',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editor.transformToUppercase', "Transform to Uppercase"),
            alias: 'Transform to Uppercase',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    UpperCaseAction.prototype._modifyText = function (text) {
        return text.toLocaleUpperCase();
    };
    return UpperCaseAction;
}(AbstractCaseAction));

var LowerCaseAction = /** @class */ (function (_super) {
    __extends(LowerCaseAction, _super);
    function LowerCaseAction() {
        return _super.call(this, {
            id: 'editor.action.transformToLowercase',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('editor.transformToLowercase', "Transform to Lowercase"),
            alias: 'Transform to Lowercase',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable
        }) || this;
    }
    LowerCaseAction.prototype._modifyText = function (text) {
        return text.toLocaleLowerCase();
    };
    return LowerCaseAction;
}(AbstractCaseAction));

Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(CopyLinesUpAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(CopyLinesDownAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(MoveLinesUpAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(MoveLinesDownAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(SortLinesAscendingAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(SortLinesDescendingAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(TrimTrailingWhitespaceAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(DeleteLinesAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(IndentLinesAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(OutdentLinesAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(InsertLineBeforeAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(InsertLineAfterAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(DeleteAllLeftAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(DeleteAllRightAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(JoinLinesAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(TransposeAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(UpperCaseAction);
Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(LowerCaseAction);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__links_css__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__links_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__links_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_opener_common_opener_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getLinks_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__goToDefinition_clickLinkGesture_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_common_htmlContent_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__base_common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


















var HOVER_MESSAGE_GENERAL_META = new __WEBPACK_IMPORTED_MODULE_14__base_common_htmlContent_js__["a" /* MarkdownString */]().appendText(__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["d" /* isMacintosh */]
    ? __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.navigate.mac', "Cmd + click to follow link")
    : __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.navigate', "Ctrl + click to follow link"));
var HOVER_MESSAGE_COMMAND_META = new __WEBPACK_IMPORTED_MODULE_14__base_common_htmlContent_js__["a" /* MarkdownString */]().appendText(__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["d" /* isMacintosh */]
    ? __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.command.mac', "Cmd + click to execute command")
    : __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.command', "Ctrl + click to execute command"));
var HOVER_MESSAGE_GENERAL_ALT = new __WEBPACK_IMPORTED_MODULE_14__base_common_htmlContent_js__["a" /* MarkdownString */]().appendText(__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["d" /* isMacintosh */]
    ? __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.navigate.al.mac', "Option + click to follow link")
    : __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.navigate.al', "Alt + click to follow link"));
var HOVER_MESSAGE_COMMAND_ALT = new __WEBPACK_IMPORTED_MODULE_14__base_common_htmlContent_js__["a" /* MarkdownString */]().appendText(__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["d" /* isMacintosh */]
    ? __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.command.al.mac', "Option + click to execute command")
    : __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('links.command.al', "Alt + click to execute command"));
var decoration = {
    meta: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link',
        hoverMessage: HOVER_MESSAGE_GENERAL_META
    }),
    metaActive: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link-active',
        hoverMessage: HOVER_MESSAGE_GENERAL_META
    }),
    alt: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link',
        hoverMessage: HOVER_MESSAGE_GENERAL_ALT
    }),
    altActive: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link-active',
        hoverMessage: HOVER_MESSAGE_GENERAL_ALT
    }),
    altCommand: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link',
        hoverMessage: HOVER_MESSAGE_COMMAND_ALT
    }),
    altCommandActive: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link-active',
        hoverMessage: HOVER_MESSAGE_COMMAND_ALT
    }),
    metaCommand: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link',
        hoverMessage: HOVER_MESSAGE_COMMAND_META
    }),
    metaCommandActive: __WEBPACK_IMPORTED_MODULE_12__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_15__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        inlineClassName: 'detected-link-active',
        hoverMessage: HOVER_MESSAGE_COMMAND_META
    }),
};
var LinkOccurrence = /** @class */ (function () {
    function LinkOccurrence(link, decorationId) {
        this.link = link;
        this.decorationId = decorationId;
    }
    LinkOccurrence.decoration = function (link, useMetaKey) {
        return {
            range: link.range,
            options: LinkOccurrence._getOptions(link, useMetaKey, false)
        };
    };
    LinkOccurrence._getOptions = function (link, useMetaKey, isActive) {
        if (/^command:/i.test(link.url)) {
            if (useMetaKey) {
                return (isActive ? decoration.metaCommandActive : decoration.metaCommand);
            }
            else {
                return (isActive ? decoration.altCommandActive : decoration.altCommand);
            }
        }
        else {
            if (useMetaKey) {
                return (isActive ? decoration.metaActive : decoration.meta);
            }
            else {
                return (isActive ? decoration.altActive : decoration.alt);
            }
        }
    };
    LinkOccurrence.prototype.activate = function (changeAccessor, useMetaKey) {
        changeAccessor.changeDecorationOptions(this.decorationId, LinkOccurrence._getOptions(this.link, useMetaKey, true));
    };
    LinkOccurrence.prototype.deactivate = function (changeAccessor, useMetaKey) {
        changeAccessor.changeDecorationOptions(this.decorationId, LinkOccurrence._getOptions(this.link, useMetaKey, false));
    };
    return LinkOccurrence;
}());
var LinkDetector = /** @class */ (function () {
    function LinkDetector(editor, openerService, notificationService) {
        var _this = this;
        this.editor = editor;
        this.openerService = openerService;
        this.notificationService = notificationService;
        this.listenersToRemove = [];
        var clickLinkGesture = new __WEBPACK_IMPORTED_MODULE_13__goToDefinition_clickLinkGesture_js__["a" /* ClickLinkGesture */](editor);
        this.listenersToRemove.push(clickLinkGesture);
        this.listenersToRemove.push(clickLinkGesture.onMouseMoveOrRelevantKeyDown(function (_a) {
            var mouseEvent = _a[0], keyboardEvent = _a[1];
            _this._onEditorMouseMove(mouseEvent, keyboardEvent);
        }));
        this.listenersToRemove.push(clickLinkGesture.onExecute(function (e) {
            _this.onEditorMouseUp(e);
        }));
        this.listenersToRemove.push(clickLinkGesture.onCancel(function (e) {
            _this.cleanUpActiveLinkDecoration();
        }));
        this.enabled = editor.getConfiguration().contribInfo.links;
        this.listenersToRemove.push(editor.onDidChangeConfiguration(function (e) {
            var enabled = editor.getConfiguration().contribInfo.links;
            if (_this.enabled === enabled) {
                // No change in our configuration option
                return;
            }
            _this.enabled = enabled;
            // Remove any links (for the getting disabled case)
            _this.updateDecorations([]);
            // Stop any computation (for the getting disabled case)
            _this.stop();
            // Start computing (for the getting enabled case)
            _this.beginCompute();
        }));
        this.listenersToRemove.push(editor.onDidChangeModelContent(function (e) { return _this.onChange(); }));
        this.listenersToRemove.push(editor.onDidChangeModel(function (e) { return _this.onModelChanged(); }));
        this.listenersToRemove.push(editor.onDidChangeModelLanguage(function (e) { return _this.onModelModeChanged(); }));
        this.listenersToRemove.push(__WEBPACK_IMPORTED_MODULE_6__common_modes_js__["p" /* LinkProviderRegistry */].onDidChange(function (e) { return _this.onModelModeChanged(); }));
        this.timeout = new __WEBPACK_IMPORTED_MODULE_17__base_common_async_js__["f" /* TimeoutTimer */]();
        this.computePromise = null;
        this.currentOccurrences = {};
        this.activeLinkDecorationId = null;
        this.beginCompute();
    }
    LinkDetector.get = function (editor) {
        return editor.getContribution(LinkDetector.ID);
    };
    LinkDetector.prototype.getId = function () {
        return LinkDetector.ID;
    };
    LinkDetector.prototype.onModelChanged = function () {
        this.currentOccurrences = {};
        this.activeLinkDecorationId = null;
        this.stop();
        this.beginCompute();
    };
    LinkDetector.prototype.onModelModeChanged = function () {
        this.stop();
        this.beginCompute();
    };
    LinkDetector.prototype.onChange = function () {
        var _this = this;
        this.timeout.setIfNotSet(function () { return _this.beginCompute(); }, LinkDetector.RECOMPUTE_TIME);
    };
    LinkDetector.prototype.beginCompute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var links, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.editor.getModel() || !this.enabled) {
                            return [2 /*return*/];
                        }
                        if (!__WEBPACK_IMPORTED_MODULE_6__common_modes_js__["p" /* LinkProviderRegistry */].has(this.editor.getModel())) {
                            return [2 /*return*/];
                        }
                        this.computePromise = __WEBPACK_IMPORTED_MODULE_17__base_common_async_js__["i" /* createCancelablePromise */](function (token) { return Object(__WEBPACK_IMPORTED_MODULE_8__getLinks_js__["a" /* getLinks */])(_this.editor.getModel(), token); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.computePromise];
                    case 2:
                        links = _a.sent();
                        this.updateDecorations(links);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */])(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.computePromise = null;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LinkDetector.prototype.updateDecorations = function (links) {
        var useMetaKey = (this.editor.getConfiguration().multiCursorModifier === 'altKey');
        var oldDecorations = [];
        var keys = Object.keys(this.currentOccurrences);
        for (var i = 0, len = keys.length; i < len; i++) {
            var decorationId = keys[i];
            var occurance = this.currentOccurrences[decorationId];
            oldDecorations.push(occurance.decorationId);
        }
        var newDecorations = [];
        if (links) {
            // Not sure why this is sometimes null
            for (var i = 0; i < links.length; i++) {
                newDecorations.push(LinkOccurrence.decoration(links[i], useMetaKey));
            }
        }
        var decorations = this.editor.deltaDecorations(oldDecorations, newDecorations);
        this.currentOccurrences = {};
        this.activeLinkDecorationId = null;
        for (var i = 0, len = decorations.length; i < len; i++) {
            var occurance = new LinkOccurrence(links[i], decorations[i]);
            this.currentOccurrences[occurance.decorationId] = occurance;
        }
    };
    LinkDetector.prototype._onEditorMouseMove = function (mouseEvent, withKey) {
        var _this = this;
        var useMetaKey = (this.editor.getConfiguration().multiCursorModifier === 'altKey');
        if (this.isEnabled(mouseEvent, withKey)) {
            this.cleanUpActiveLinkDecoration(); // always remove previous link decoration as their can only be one
            var occurrence_1 = this.getLinkOccurrence(mouseEvent.target.position);
            if (occurrence_1) {
                this.editor.changeDecorations(function (changeAccessor) {
                    occurrence_1.activate(changeAccessor, useMetaKey);
                    _this.activeLinkDecorationId = occurrence_1.decorationId;
                });
            }
        }
        else {
            this.cleanUpActiveLinkDecoration();
        }
    };
    LinkDetector.prototype.cleanUpActiveLinkDecoration = function () {
        var useMetaKey = (this.editor.getConfiguration().multiCursorModifier === 'altKey');
        if (this.activeLinkDecorationId) {
            var occurrence_2 = this.currentOccurrences[this.activeLinkDecorationId];
            if (occurrence_2) {
                this.editor.changeDecorations(function (changeAccessor) {
                    occurrence_2.deactivate(changeAccessor, useMetaKey);
                });
            }
            this.activeLinkDecorationId = null;
        }
    };
    LinkDetector.prototype.onEditorMouseUp = function (mouseEvent) {
        if (!this.isEnabled(mouseEvent)) {
            return;
        }
        var occurrence = this.getLinkOccurrence(mouseEvent.target.position);
        if (!occurrence) {
            return;
        }
        this.openLinkOccurrence(occurrence, mouseEvent.hasSideBySideModifier);
    };
    LinkDetector.prototype.openLinkOccurrence = function (occurrence, openToSide) {
        var _this = this;
        if (!this.openerService) {
            return;
        }
        var link = occurrence.link;
        link.resolve().then(function (uri) {
            // open the uri
            return _this.openerService.open(uri, { openToSide: openToSide });
        }, function (err) {
            // different error cases
            if (err === 'invalid') {
                _this.notificationService.warn(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('invalid.url', 'Failed to open this link because it is not well-formed: {0}', link.url));
            }
            else if (err === 'missing') {
                _this.notificationService.warn(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('missing.url', 'Failed to open this link because its target is missing.'));
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */])(err);
            }
        }).done(null, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    LinkDetector.prototype.getLinkOccurrence = function (position) {
        var decorations = this.editor.getModel().getDecorationsInRange({
            startLineNumber: position.lineNumber,
            startColumn: position.column,
            endLineNumber: position.lineNumber,
            endColumn: position.column
        }, 0, true);
        for (var i = 0; i < decorations.length; i++) {
            var decoration_1 = decorations[i];
            var currentOccurrence = this.currentOccurrences[decoration_1.id];
            if (currentOccurrence) {
                return currentOccurrence;
            }
        }
        return null;
    };
    LinkDetector.prototype.isEnabled = function (mouseEvent, withKey) {
        return (mouseEvent.target.type === __WEBPACK_IMPORTED_MODULE_7__browser_editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT
            && (mouseEvent.hasTriggerModifier || (withKey && withKey.keyCodeIsTriggerKey)));
    };
    LinkDetector.prototype.stop = function () {
        this.timeout.cancel();
        if (this.computePromise) {
            this.computePromise.cancel();
            this.computePromise = null;
        }
    };
    LinkDetector.prototype.dispose = function () {
        this.listenersToRemove = Object(__WEBPACK_IMPORTED_MODULE_9__base_common_lifecycle_js__["d" /* dispose */])(this.listenersToRemove);
        this.stop();
        this.timeout.dispose();
    };
    LinkDetector.ID = 'editor.linkDetector';
    LinkDetector.RECOMPUTE_TIME = 1000; // ms
    LinkDetector = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_4__platform_opener_common_opener_js__["a" /* IOpenerService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_16__platform_notification_common_notification_js__["a" /* INotificationService */])
    ], LinkDetector);
    return LinkDetector;
}());
var OpenLinkAction = /** @class */ (function (_super) {
    __extends(OpenLinkAction, _super);
    function OpenLinkAction() {
        return _super.call(this, {
            id: 'editor.action.openLink',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label', "Open Link"),
            alias: 'Open Link',
            precondition: null
        }) || this;
    }
    OpenLinkAction.prototype.run = function (accessor, editor) {
        var linkDetector = LinkDetector.get(editor);
        if (!linkDetector) {
            return;
        }
        var selections = editor.getSelections();
        for (var _i = 0, selections_1 = selections; _i < selections_1.length; _i++) {
            var sel = selections_1[_i];
            var link = linkDetector.getLinkOccurrence(sel.getEndPosition());
            if (link) {
                linkDetector.openLinkOccurrence(link, false);
            }
        }
    };
    return OpenLinkAction;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["h" /* registerEditorContribution */])(LinkDetector);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(OpenLinkAction);
Object(__WEBPACK_IMPORTED_MODULE_10__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var activeLinkForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_11__platform_theme_common_colorRegistry_js__["m" /* editorActiveLinkForeground */]);
    if (activeLinkForeground) {
        collector.addRule(".monaco-editor .detected-link-active { color: " + activeLinkForeground + " !important; }");
    }
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InsertCursorAbove", function() { return InsertCursorAbove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InsertCursorBelow", function() { return InsertCursorBelow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiCursorSessionResult", function() { return MultiCursorSessionResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiCursorSession", function() { return MultiCursorSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiCursorSelectionController", function() { return MultiCursorSelectionController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiCursorSelectionControllerAction", function() { return MultiCursorSelectionControllerAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddSelectionToNextFindMatchAction", function() { return AddSelectionToNextFindMatchAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddSelectionToPreviousFindMatchAction", function() { return AddSelectionToPreviousFindMatchAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoveSelectionToNextFindMatchAction", function() { return MoveSelectionToNextFindMatchAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoveSelectionToPreviousFindMatchAction", function() { return MoveSelectionToPreviousFindMatchAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectHighlightsAction", function() { return SelectHighlightsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompatChangeAll", function() { return CompatChangeAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectionHighlighter", function() { return SelectionHighlighter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_controller_cursorMoveCommands_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__find_findController_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__ = __webpack_require__(41);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

















var InsertCursorAbove = /** @class */ (function (_super) {
    __extends(InsertCursorAbove, _super);
    function InsertCursorAbove() {
        return _super.call(this, {
            id: 'editor.action.insertCursorAbove',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('mutlicursor.insertAbove', "Add Cursor Above"),
            alias: 'Add Cursor Above',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 16 /* UpArrow */,
                linux: {
                    primary: 1024 /* Shift */ | 512 /* Alt */ | 16 /* UpArrow */,
                    secondary: [2048 /* CtrlCmd */ | 1024 /* Shift */ | 16 /* UpArrow */]
                },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '3_multi',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miInsertCursorAbove', comment: ['&& denotes a mnemonic'] }, "&&Add Cursor Above"),
                order: 2
            }
        }) || this;
    }
    InsertCursorAbove.prototype.run = function (accessor, editor, args) {
        var useLogicalLine = (args && args.logicalLine === true);
        var cursors = editor._getCursors();
        var context = cursors.context;
        if (context.config.readOnly) {
            return;
        }
        context.model.pushStackElement();
        cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_10__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].addCursorUp(context, cursors.getAll(), useLogicalLine));
        cursors.reveal(true, 1 /* TopMost */, 0 /* Smooth */);
    };
    return InsertCursorAbove;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));

var InsertCursorBelow = /** @class */ (function (_super) {
    __extends(InsertCursorBelow, _super);
    function InsertCursorBelow() {
        return _super.call(this, {
            id: 'editor.action.insertCursorBelow',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('mutlicursor.insertBelow', "Add Cursor Below"),
            alias: 'Add Cursor Below',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 18 /* DownArrow */,
                linux: {
                    primary: 1024 /* Shift */ | 512 /* Alt */ | 18 /* DownArrow */,
                    secondary: [2048 /* CtrlCmd */ | 1024 /* Shift */ | 18 /* DownArrow */]
                },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '3_multi',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miInsertCursorBelow', comment: ['&& denotes a mnemonic'] }, "A&&dd Cursor Below"),
                order: 3
            }
        }) || this;
    }
    InsertCursorBelow.prototype.run = function (accessor, editor, args) {
        var useLogicalLine = (args && args.logicalLine === true);
        var cursors = editor._getCursors();
        var context = cursors.context;
        if (context.config.readOnly) {
            return;
        }
        context.model.pushStackElement();
        cursors.setStates(args.source, __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit, __WEBPACK_IMPORTED_MODULE_10__common_controller_cursorMoveCommands_js__["b" /* CursorMoveCommands */].addCursorDown(context, cursors.getAll(), useLogicalLine));
        cursors.reveal(true, 2 /* BottomMost */, 0 /* Smooth */);
    };
    return InsertCursorBelow;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));

var InsertCursorAtEndOfEachLineSelected = /** @class */ (function (_super) {
    __extends(InsertCursorAtEndOfEachLineSelected, _super);
    function InsertCursorAtEndOfEachLineSelected() {
        return _super.call(this, {
            id: 'editor.action.insertCursorAtEndOfEachLineSelected',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('mutlicursor.insertAtEndOfEachLineSelected', "Add Cursors to Line Ends"),
            alias: 'Add Cursors to Line Ends',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 512 /* Alt */ | 39 /* KEY_I */,
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '3_multi',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miInsertCursorAtEndOfEachLineSelected', comment: ['&& denotes a mnemonic'] }, "Add C&&ursors to Line Ends"),
                order: 4
            }
        }) || this;
    }
    InsertCursorAtEndOfEachLineSelected.prototype.getCursorsForSelection = function (selection, model, result) {
        if (selection.isEmpty()) {
            return;
        }
        for (var i = selection.startLineNumber; i < selection.endLineNumber; i++) {
            var currentLineMaxColumn = model.getLineMaxColumn(i);
            result.push(new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](i, currentLineMaxColumn, i, currentLineMaxColumn));
        }
        if (selection.endColumn > 1) {
            result.push(new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](selection.endLineNumber, selection.endColumn, selection.endLineNumber, selection.endColumn));
        }
    };
    InsertCursorAtEndOfEachLineSelected.prototype.run = function (accessor, editor) {
        var _this = this;
        var model = editor.getModel();
        var selections = editor.getSelections();
        var newSelections = [];
        selections.forEach(function (sel) { return _this.getCursorsForSelection(sel, model, newSelections); });
        if (newSelections.length > 0) {
            editor.setSelections(newSelections);
        }
    };
    return InsertCursorAtEndOfEachLineSelected;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));
var MultiCursorSessionResult = /** @class */ (function () {
    function MultiCursorSessionResult(selections, revealRange, revealScrollType) {
        this.selections = selections;
        this.revealRange = revealRange;
        this.revealScrollType = revealScrollType;
    }
    return MultiCursorSessionResult;
}());

var MultiCursorSession = /** @class */ (function () {
    function MultiCursorSession(_editor, findController, isDisconnectedFromFindController, searchText, wholeWord, matchCase, currentMatch) {
        this._editor = _editor;
        this.findController = findController;
        this.isDisconnectedFromFindController = isDisconnectedFromFindController;
        this.searchText = searchText;
        this.wholeWord = wholeWord;
        this.matchCase = matchCase;
        this.currentMatch = currentMatch;
    }
    MultiCursorSession.create = function (editor, findController) {
        var findState = findController.getState();
        // Find widget owns entirely what we search for if:
        //  - focus is not in the editor (i.e. it is in the find widget)
        //  - and the search widget is visible
        //  - and the search string is non-empty
        if (!editor.hasTextFocus() && findState.isRevealed && findState.searchString.length > 0) {
            // Find widget owns what is searched for
            return new MultiCursorSession(editor, findController, false, findState.searchString, findState.wholeWord, findState.matchCase, null);
        }
        // Otherwise, the selection gives the search text, and the find widget gives the search settings
        // The exception is the find state disassociation case: when beginning with a single, collapsed selection
        var isDisconnectedFromFindController = false;
        var wholeWord;
        var matchCase;
        var selections = editor.getSelections();
        if (selections.length === 1 && selections[0].isEmpty()) {
            isDisconnectedFromFindController = true;
            wholeWord = true;
            matchCase = true;
        }
        else {
            wholeWord = findState.wholeWord;
            matchCase = findState.matchCase;
        }
        // Selection owns what is searched for
        var s = editor.getSelection();
        var searchText;
        var currentMatch = null;
        if (s.isEmpty()) {
            // selection is empty => expand to current word
            var word = editor.getModel().getWordAtPosition(s.getStartPosition());
            if (!word) {
                return null;
            }
            searchText = word.word;
            currentMatch = new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](s.startLineNumber, word.startColumn, s.startLineNumber, word.endColumn);
        }
        else {
            searchText = editor.getModel().getValueInRange(s).replace(/\r\n/g, '\n');
        }
        return new MultiCursorSession(editor, findController, isDisconnectedFromFindController, searchText, wholeWord, matchCase, currentMatch);
    };
    MultiCursorSession.prototype.addSelectionToNextFindMatch = function () {
        var nextMatch = this._getNextMatch();
        if (!nextMatch) {
            return null;
        }
        var allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.concat(nextMatch), nextMatch, 0 /* Smooth */);
    };
    MultiCursorSession.prototype.moveSelectionToNextFindMatch = function () {
        var nextMatch = this._getNextMatch();
        if (!nextMatch) {
            return null;
        }
        var allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.slice(0, allSelections.length - 1).concat(nextMatch), nextMatch, 0 /* Smooth */);
    };
    MultiCursorSession.prototype._getNextMatch = function () {
        if (this.currentMatch) {
            var result = this.currentMatch;
            this.currentMatch = null;
            return result;
        }
        this.findController.highlightFindOptions();
        var allSelections = this._editor.getSelections();
        var lastAddedSelection = allSelections[allSelections.length - 1];
        var nextMatch = this._editor.getModel().findNextMatch(this.searchText, lastAddedSelection.getEndPosition(), false, this.matchCase, this.wholeWord ? this._editor.getConfiguration().wordSeparators : null, false);
        if (!nextMatch) {
            return null;
        }
        return new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](nextMatch.range.startLineNumber, nextMatch.range.startColumn, nextMatch.range.endLineNumber, nextMatch.range.endColumn);
    };
    MultiCursorSession.prototype.addSelectionToPreviousFindMatch = function () {
        var previousMatch = this._getPreviousMatch();
        if (!previousMatch) {
            return null;
        }
        var allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.concat(previousMatch), previousMatch, 0 /* Smooth */);
    };
    MultiCursorSession.prototype.moveSelectionToPreviousFindMatch = function () {
        var previousMatch = this._getPreviousMatch();
        if (!previousMatch) {
            return null;
        }
        var allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.slice(0, allSelections.length - 1).concat(previousMatch), previousMatch, 0 /* Smooth */);
    };
    MultiCursorSession.prototype._getPreviousMatch = function () {
        if (this.currentMatch) {
            var result = this.currentMatch;
            this.currentMatch = null;
            return result;
        }
        this.findController.highlightFindOptions();
        var allSelections = this._editor.getSelections();
        var lastAddedSelection = allSelections[allSelections.length - 1];
        var previousMatch = this._editor.getModel().findPreviousMatch(this.searchText, lastAddedSelection.getStartPosition(), false, this.matchCase, this.wholeWord ? this._editor.getConfiguration().wordSeparators : null, false);
        if (!previousMatch) {
            return null;
        }
        return new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](previousMatch.range.startLineNumber, previousMatch.range.startColumn, previousMatch.range.endLineNumber, previousMatch.range.endColumn);
    };
    MultiCursorSession.prototype.selectAll = function () {
        this.findController.highlightFindOptions();
        return this._editor.getModel().findMatches(this.searchText, true, false, this.matchCase, this.wholeWord ? this._editor.getConfiguration().wordSeparators : null, false, 1073741824 /* MAX_SAFE_SMALL_INTEGER */);
    };
    return MultiCursorSession;
}());

var MultiCursorSelectionController = /** @class */ (function (_super) {
    __extends(MultiCursorSelectionController, _super);
    function MultiCursorSelectionController(editor) {
        var _this = _super.call(this) || this;
        _this._editor = editor;
        _this._ignoreSelectionChange = false;
        _this._session = null;
        _this._sessionDispose = [];
        return _this;
    }
    MultiCursorSelectionController.get = function (editor) {
        return editor.getContribution(MultiCursorSelectionController.ID);
    };
    MultiCursorSelectionController.prototype.dispose = function () {
        this._endSession();
        _super.prototype.dispose.call(this);
    };
    MultiCursorSelectionController.prototype.getId = function () {
        return MultiCursorSelectionController.ID;
    };
    MultiCursorSelectionController.prototype._beginSessionIfNeeded = function (findController) {
        var _this = this;
        if (!this._session) {
            // Create a new session
            var session = MultiCursorSession.create(this._editor, findController);
            if (!session) {
                return;
            }
            this._session = session;
            var newState = { searchString: this._session.searchText };
            if (this._session.isDisconnectedFromFindController) {
                newState.wholeWordOverride = 1 /* True */;
                newState.matchCaseOverride = 1 /* True */;
                newState.isRegexOverride = 2 /* False */;
            }
            findController.getState().change(newState, false);
            this._sessionDispose = [
                this._editor.onDidChangeCursorSelection(function (e) {
                    if (_this._ignoreSelectionChange) {
                        return;
                    }
                    _this._endSession();
                }),
                this._editor.onDidBlurEditorText(function () {
                    _this._endSession();
                }),
                findController.getState().onFindReplaceStateChange(function (e) {
                    if (e.matchCase || e.wholeWord) {
                        _this._endSession();
                    }
                })
            ];
        }
    };
    MultiCursorSelectionController.prototype._endSession = function () {
        this._sessionDispose = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._sessionDispose);
        if (this._session && this._session.isDisconnectedFromFindController) {
            var newState = {
                wholeWordOverride: 0 /* NotSet */,
                matchCaseOverride: 0 /* NotSet */,
                isRegexOverride: 0 /* NotSet */,
            };
            this._session.findController.getState().change(newState, false);
        }
        this._session = null;
    };
    MultiCursorSelectionController.prototype._setSelections = function (selections) {
        this._ignoreSelectionChange = true;
        this._editor.setSelections(selections);
        this._ignoreSelectionChange = false;
    };
    MultiCursorSelectionController.prototype._expandEmptyToWord = function (model, selection) {
        if (!selection.isEmpty()) {
            return selection;
        }
        var word = model.getWordAtPosition(selection.getStartPosition());
        if (!word) {
            return selection;
        }
        return new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](selection.startLineNumber, word.startColumn, selection.startLineNumber, word.endColumn);
    };
    MultiCursorSelectionController.prototype._applySessionResult = function (result) {
        if (!result) {
            return;
        }
        this._setSelections(result.selections);
        if (result.revealRange) {
            this._editor.revealRangeInCenterIfOutsideViewport(result.revealRange, result.revealScrollType);
        }
    };
    MultiCursorSelectionController.prototype.getSession = function (findController) {
        return this._session;
    };
    MultiCursorSelectionController.prototype.addSelectionToNextFindMatch = function (findController) {
        if (!this._session) {
            // If there are multiple cursors, handle the case where they do not all select the same text.
            var allSelections = this._editor.getSelections();
            if (allSelections.length > 1) {
                var findState = findController.getState();
                var matchCase = findState.matchCase;
                var selectionsContainSameText = modelRangesContainSameText(this._editor.getModel(), allSelections, matchCase);
                if (!selectionsContainSameText) {
                    var model = this._editor.getModel();
                    var resultingSelections = [];
                    for (var i = 0, len = allSelections.length; i < len; i++) {
                        resultingSelections[i] = this._expandEmptyToWord(model, allSelections[i]);
                    }
                    this._editor.setSelections(resultingSelections);
                    return;
                }
            }
        }
        this._beginSessionIfNeeded(findController);
        if (this._session) {
            this._applySessionResult(this._session.addSelectionToNextFindMatch());
        }
    };
    MultiCursorSelectionController.prototype.addSelectionToPreviousFindMatch = function (findController) {
        this._beginSessionIfNeeded(findController);
        if (this._session) {
            this._applySessionResult(this._session.addSelectionToPreviousFindMatch());
        }
    };
    MultiCursorSelectionController.prototype.moveSelectionToNextFindMatch = function (findController) {
        this._beginSessionIfNeeded(findController);
        if (this._session) {
            this._applySessionResult(this._session.moveSelectionToNextFindMatch());
        }
    };
    MultiCursorSelectionController.prototype.moveSelectionToPreviousFindMatch = function (findController) {
        this._beginSessionIfNeeded(findController);
        if (this._session) {
            this._applySessionResult(this._session.moveSelectionToPreviousFindMatch());
        }
    };
    MultiCursorSelectionController.prototype.selectAll = function (findController) {
        var matches = null;
        var findState = findController.getState();
        // Special case: find widget owns entirely what we search for if:
        // - focus is not in the editor (i.e. it is in the find widget)
        // - and the search widget is visible
        // - and the search string is non-empty
        // - and we're searching for a regex
        if (findState.isRevealed && findState.searchString.length > 0 && findState.isRegex) {
            matches = this._editor.getModel().findMatches(findState.searchString, true, findState.isRegex, findState.matchCase, findState.wholeWord ? this._editor.getConfiguration().wordSeparators : null, false, 1073741824 /* MAX_SAFE_SMALL_INTEGER */);
        }
        else {
            this._beginSessionIfNeeded(findController);
            if (!this._session) {
                return;
            }
            matches = this._session.selectAll();
        }
        if (matches.length > 0) {
            var editorSelection = this._editor.getSelection();
            // Have the primary cursor remain the one where the action was invoked
            for (var i = 0, len = matches.length; i < len; i++) {
                var match = matches[i];
                var intersection = match.range.intersectRanges(editorSelection);
                if (intersection) {
                    // bingo!
                    matches[i] = matches[0];
                    matches[0] = match;
                    break;
                }
            }
            this._setSelections(matches.map(function (m) { return new __WEBPACK_IMPORTED_MODULE_8__common_core_selection_js__["a" /* Selection */](m.range.startLineNumber, m.range.startColumn, m.range.endLineNumber, m.range.endColumn); }));
        }
    };
    MultiCursorSelectionController.ID = 'editor.contrib.multiCursorController';
    return MultiCursorSelectionController;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));

var MultiCursorSelectionControllerAction = /** @class */ (function (_super) {
    __extends(MultiCursorSelectionControllerAction, _super);
    function MultiCursorSelectionControllerAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiCursorSelectionControllerAction.prototype.run = function (accessor, editor) {
        var multiCursorController = MultiCursorSelectionController.get(editor);
        if (!multiCursorController) {
            return;
        }
        var findController = __WEBPACK_IMPORTED_MODULE_12__find_findController_js__["CommonFindController"].get(editor);
        if (!findController) {
            return null;
        }
        this._run(multiCursorController, findController);
    };
    return MultiCursorSelectionControllerAction;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));

var AddSelectionToNextFindMatchAction = /** @class */ (function (_super) {
    __extends(AddSelectionToNextFindMatchAction, _super);
    function AddSelectionToNextFindMatchAction() {
        return _super.call(this, {
            id: 'editor.action.addSelectionToNextFindMatch',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('addSelectionToNextFindMatch', "Add Selection To Next Find Match"),
            alias: 'Add Selection To Next Find Match',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 2048 /* CtrlCmd */ | 34 /* KEY_D */,
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '3_multi',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miAddSelectionToNextFindMatch', comment: ['&& denotes a mnemonic'] }, "Add &&Next Occurrence"),
                order: 5
            }
        }) || this;
    }
    AddSelectionToNextFindMatchAction.prototype._run = function (multiCursorController, findController) {
        multiCursorController.addSelectionToNextFindMatch(findController);
    };
    return AddSelectionToNextFindMatchAction;
}(MultiCursorSelectionControllerAction));

var AddSelectionToPreviousFindMatchAction = /** @class */ (function (_super) {
    __extends(AddSelectionToPreviousFindMatchAction, _super);
    function AddSelectionToPreviousFindMatchAction() {
        return _super.call(this, {
            id: 'editor.action.addSelectionToPreviousFindMatch',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('addSelectionToPreviousFindMatch', "Add Selection To Previous Find Match"),
            alias: 'Add Selection To Previous Find Match',
            precondition: null,
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '3_multi',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miAddSelectionToPreviousFindMatch', comment: ['&& denotes a mnemonic'] }, "Add P&&revious Occurrence"),
                order: 6
            }
        }) || this;
    }
    AddSelectionToPreviousFindMatchAction.prototype._run = function (multiCursorController, findController) {
        multiCursorController.addSelectionToPreviousFindMatch(findController);
    };
    return AddSelectionToPreviousFindMatchAction;
}(MultiCursorSelectionControllerAction));

var MoveSelectionToNextFindMatchAction = /** @class */ (function (_super) {
    __extends(MoveSelectionToNextFindMatchAction, _super);
    function MoveSelectionToNextFindMatchAction() {
        return _super.call(this, {
            id: 'editor.action.moveSelectionToNextFindMatch',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('moveSelectionToNextFindMatch', "Move Last Selection To Next Find Match"),
            alias: 'Move Last Selection To Next Find Match',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: Object(__WEBPACK_IMPORTED_MODULE_2__base_common_keyCodes_js__["a" /* KeyChord */])(2048 /* CtrlCmd */ | 41 /* KEY_K */, 2048 /* CtrlCmd */ | 34 /* KEY_D */),
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    MoveSelectionToNextFindMatchAction.prototype._run = function (multiCursorController, findController) {
        multiCursorController.moveSelectionToNextFindMatch(findController);
    };
    return MoveSelectionToNextFindMatchAction;
}(MultiCursorSelectionControllerAction));

var MoveSelectionToPreviousFindMatchAction = /** @class */ (function (_super) {
    __extends(MoveSelectionToPreviousFindMatchAction, _super);
    function MoveSelectionToPreviousFindMatchAction() {
        return _super.call(this, {
            id: 'editor.action.moveSelectionToPreviousFindMatch',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('moveSelectionToPreviousFindMatch', "Move Last Selection To Previous Find Match"),
            alias: 'Move Last Selection To Previous Find Match',
            precondition: null
        }) || this;
    }
    MoveSelectionToPreviousFindMatchAction.prototype._run = function (multiCursorController, findController) {
        multiCursorController.moveSelectionToPreviousFindMatch(findController);
    };
    return MoveSelectionToPreviousFindMatchAction;
}(MultiCursorSelectionControllerAction));

var SelectHighlightsAction = /** @class */ (function (_super) {
    __extends(SelectHighlightsAction, _super);
    function SelectHighlightsAction() {
        return _super.call(this, {
            id: 'editor.action.selectHighlights',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('selectAllOccurrencesOfFindMatch', "Select All Occurrences of Find Match"),
            alias: 'Select All Occurrences of Find Match',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 42 /* KEY_L */,
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '3_multi',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miSelectHighlights', comment: ['&& denotes a mnemonic'] }, "Select All &&Occurrences"),
                order: 7
            }
        }) || this;
    }
    SelectHighlightsAction.prototype._run = function (multiCursorController, findController) {
        multiCursorController.selectAll(findController);
    };
    return SelectHighlightsAction;
}(MultiCursorSelectionControllerAction));

var CompatChangeAll = /** @class */ (function (_super) {
    __extends(CompatChangeAll, _super);
    function CompatChangeAll() {
        return _super.call(this, {
            id: 'editor.action.changeAll',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('changeAll.label', "Change All Occurrences"),
            alias: 'Change All Occurrences',
            precondition: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 60 /* F2 */,
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: '1_modification',
                order: 1.2
            }
        }) || this;
    }
    CompatChangeAll.prototype._run = function (multiCursorController, findController) {
        multiCursorController.selectAll(findController);
    };
    return CompatChangeAll;
}(MultiCursorSelectionControllerAction));

var SelectionHighlighterState = /** @class */ (function () {
    function SelectionHighlighterState(lastWordUnderCursor, searchText, matchCase, wordSeparators) {
        this.lastWordUnderCursor = lastWordUnderCursor;
        this.searchText = searchText;
        this.matchCase = matchCase;
        this.wordSeparators = wordSeparators;
    }
    /**
     * Everything equals except for `lastWordUnderCursor`
     */
    SelectionHighlighterState.softEquals = function (a, b) {
        if (!a && !b) {
            return true;
        }
        if (!a || !b) {
            return false;
        }
        return (a.searchText === b.searchText
            && a.matchCase === b.matchCase
            && a.wordSeparators === b.wordSeparators);
    };
    return SelectionHighlighterState;
}());
var SelectionHighlighter = /** @class */ (function (_super) {
    __extends(SelectionHighlighter, _super);
    function SelectionHighlighter(editor) {
        var _this = _super.call(this) || this;
        _this.editor = editor;
        _this._isEnabled = editor.getConfiguration().contribInfo.selectionHighlight;
        _this.decorations = [];
        _this.updateSoon = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._update(); }, 300));
        _this.state = null;
        _this._register(editor.onDidChangeConfiguration(function (e) {
            _this._isEnabled = editor.getConfiguration().contribInfo.selectionHighlight;
        }));
        _this._register(editor.onDidChangeCursorSelection(function (e) {
            if (!_this._isEnabled) {
                // Early exit if nothing needs to be done!
                // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
                return;
            }
            if (e.selection.isEmpty()) {
                if (e.reason === __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit) {
                    if (_this.state && (!_this.state.lastWordUnderCursor || !_this.state.lastWordUnderCursor.containsPosition(e.selection.getStartPosition()))) {
                        // no longer valid
                        _this._setState(null);
                    }
                    _this.updateSoon.schedule();
                }
                else {
                    _this._setState(null);
                }
            }
            else {
                _this._update();
            }
        }));
        _this._register(editor.onDidChangeModel(function (e) {
            _this._setState(null);
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_12__find_findController_js__["CommonFindController"].get(editor).getState().onFindReplaceStateChange(function (e) {
            _this._update();
        }));
        return _this;
    }
    SelectionHighlighter.prototype.getId = function () {
        return SelectionHighlighter.ID;
    };
    SelectionHighlighter.prototype._update = function () {
        this._setState(SelectionHighlighter._createState(this._isEnabled, this.editor));
    };
    SelectionHighlighter._createState = function (isEnabled, editor) {
        if (!isEnabled) {
            return null;
        }
        var model = editor.getModel();
        if (!model) {
            return null;
        }
        var s = editor.getSelection();
        if (s.startLineNumber !== s.endLineNumber) {
            // multiline forbidden for perf reasons
            return null;
        }
        var multiCursorController = MultiCursorSelectionController.get(editor);
        if (!multiCursorController) {
            return null;
        }
        var findController = __WEBPACK_IMPORTED_MODULE_12__find_findController_js__["CommonFindController"].get(editor);
        if (!findController) {
            return null;
        }
        var r = multiCursorController.getSession(findController);
        if (!r) {
            var allSelections = editor.getSelections();
            if (allSelections.length > 1) {
                var findState_1 = findController.getState();
                var matchCase = findState_1.matchCase;
                var selectionsContainSameText = modelRangesContainSameText(editor.getModel(), allSelections, matchCase);
                if (!selectionsContainSameText) {
                    return null;
                }
            }
            r = MultiCursorSession.create(editor, findController);
        }
        if (!r) {
            return null;
        }
        var lastWordUnderCursor = null;
        var hasFindOccurrences = __WEBPACK_IMPORTED_MODULE_11__common_modes_js__["h" /* DocumentHighlightProviderRegistry */].has(model);
        if (r.currentMatch) {
            // This is an empty selection
            if (hasFindOccurrences) {
                // Do not interfere with semantic word highlighting in the no selection case
                return null;
            }
            var config = editor.getConfiguration();
            if (!config.contribInfo.occurrencesHighlight) {
                return null;
            }
            lastWordUnderCursor = r.currentMatch;
        }
        if (/^[ \t]+$/.test(r.searchText)) {
            // whitespace only selection
            return null;
        }
        if (r.searchText.length > 200) {
            // very long selection
            return null;
        }
        // TODO: better handling of this case
        var findState = findController.getState();
        var caseSensitive = findState.matchCase;
        // Return early if the find widget shows the exact same matches
        if (findState.isRevealed) {
            var findStateSearchString = findState.searchString;
            if (!caseSensitive) {
                findStateSearchString = findStateSearchString.toLowerCase();
            }
            var mySearchString = r.searchText;
            if (!caseSensitive) {
                mySearchString = mySearchString.toLowerCase();
            }
            if (findStateSearchString === mySearchString && r.matchCase === findState.matchCase && r.wholeWord === findState.wholeWord && !findState.isRegex) {
                return null;
            }
        }
        return new SelectionHighlighterState(lastWordUnderCursor, r.searchText, r.matchCase, r.wholeWord ? editor.getConfiguration().wordSeparators : null);
    };
    SelectionHighlighter.prototype._setState = function (state) {
        if (SelectionHighlighterState.softEquals(this.state, state)) {
            this.state = state;
            return;
        }
        this.state = state;
        if (!this.state) {
            this.decorations = this.editor.deltaDecorations(this.decorations, []);
            return;
        }
        var model = this.editor.getModel();
        if (model.isTooLargeForTokenization()) {
            // the file is too large, so searching word under cursor in the whole document takes is blocking the UI.
            return;
        }
        var hasFindOccurrences = __WEBPACK_IMPORTED_MODULE_11__common_modes_js__["h" /* DocumentHighlightProviderRegistry */].has(model);
        var allMatches = model.findMatches(this.state.searchText, true, false, this.state.matchCase, this.state.wordSeparators, false).map(function (m) { return m.range; });
        allMatches.sort(__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
        var selections = this.editor.getSelections();
        selections.sort(__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
        // do not overlap with selection (issue #64 and #512)
        var matches = [];
        for (var i = 0, j = 0, len = allMatches.length, lenJ = selections.length; i < len;) {
            var match = allMatches[i];
            if (j >= lenJ) {
                // finished all editor selections
                matches.push(match);
                i++;
            }
            else {
                var cmp = __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(match, selections[j]);
                if (cmp < 0) {
                    // match is before sel
                    if (selections[j].isEmpty() || !__WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */].areIntersecting(match, selections[j])) {
                        matches.push(match);
                    }
                    i++;
                }
                else if (cmp > 0) {
                    // sel is before match
                    j++;
                }
                else {
                    // sel is equal to match
                    i++;
                    j++;
                }
            }
        }
        var decorations = matches.map(function (r) {
            return {
                range: r,
                // Show in overviewRuler only if model has no semantic highlighting
                options: (hasFindOccurrences ? SelectionHighlighter._SELECTION_HIGHLIGHT : SelectionHighlighter._SELECTION_HIGHLIGHT_OVERVIEW)
            };
        });
        this.decorations = this.editor.deltaDecorations(this.decorations, decorations);
    };
    SelectionHighlighter.prototype.dispose = function () {
        this._setState(null);
        _super.prototype.dispose.call(this);
    };
    SelectionHighlighter.ID = 'editor.contrib.selectionHighlighter';
    SelectionHighlighter._SELECTION_HIGHLIGHT_OVERVIEW = __WEBPACK_IMPORTED_MODULE_13__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'selectionHighlight',
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_15__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__platform_theme_common_colorRegistry_js__["_6" /* overviewRulerSelectionHighlightForeground */]),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_15__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__platform_theme_common_colorRegistry_js__["_6" /* overviewRulerSelectionHighlightForeground */]),
            position: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    SelectionHighlighter._SELECTION_HIGHLIGHT = __WEBPACK_IMPORTED_MODULE_13__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'selectionHighlight',
    });
    return SelectionHighlighter;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));

function modelRangesContainSameText(model, ranges, matchCase) {
    var selectedText = getValueInRange(model, ranges[0], !matchCase);
    for (var i = 1, len = ranges.length; i < len; i++) {
        var range = ranges[i];
        if (range.isEmpty()) {
            return false;
        }
        var thisSelectedText = getValueInRange(model, range, !matchCase);
        if (selectedText !== thisSelectedText) {
            return false;
        }
    }
    return true;
}
function getValueInRange(model, range, toLowerCase) {
    var text = model.getValueInRange(range);
    return (toLowerCase ? text.toLowerCase() : text);
}
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(MultiCursorSelectionController);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(SelectionHighlighter);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(InsertCursorAbove);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(InsertCursorBelow);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(InsertCursorAtEndOfEachLineSelected);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(AddSelectionToNextFindMatchAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(AddSelectionToPreviousFindMatchAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(MoveSelectionToNextFindMatchAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(MoveSelectionToPreviousFindMatchAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(SelectHighlightsAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(CompatChangeAll);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TriggerParameterHintsAction", function() { return TriggerParameterHintsAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parameterHintsWidget_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__provideSignatureHelp_js__ = __webpack_require__(285);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};








var ParameterHintsController = /** @class */ (function () {
    function ParameterHintsController(editor, instantiationService) {
        this.editor = editor;
        this.widget = instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_6__parameterHintsWidget_js__["a" /* ParameterHintsWidget */], this.editor);
    }
    ParameterHintsController.get = function (editor) {
        return editor.getContribution(ParameterHintsController.ID);
    };
    ParameterHintsController.prototype.getId = function () {
        return ParameterHintsController.ID;
    };
    ParameterHintsController.prototype.cancel = function () {
        this.widget.cancel();
    };
    ParameterHintsController.prototype.previous = function () {
        this.widget.previous();
    };
    ParameterHintsController.prototype.next = function () {
        this.widget.next();
    };
    ParameterHintsController.prototype.trigger = function () {
        this.widget.trigger();
    };
    ParameterHintsController.prototype.dispose = function () {
        this.widget = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this.widget);
    };
    ParameterHintsController.ID = 'editor.controller.parameterHints';
    ParameterHintsController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_2__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */])
    ], ParameterHintsController);
    return ParameterHintsController;
}());
var TriggerParameterHintsAction = /** @class */ (function (_super) {
    __extends(TriggerParameterHintsAction, _super);
    function TriggerParameterHintsAction() {
        return _super.call(this, {
            id: 'editor.action.triggerParameterHints',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('parameterHints.trigger.label', "Trigger Parameter Hints"),
            alias: 'Trigger Parameter Hints',
            precondition: __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasSignatureHelpProvider,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 10 /* Space */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    TriggerParameterHintsAction.prototype.run = function (accessor, editor) {
        var controller = ParameterHintsController.get(editor);
        if (controller) {
            controller.trigger();
        }
    };
    return TriggerParameterHintsAction;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["h" /* registerEditorContribution */])(ParameterHintsController);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(TriggerParameterHintsAction);
var weight = 100 /* EditorContrib */ + 75;
var ParameterHintsCommand = __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(ParameterHintsController.get);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new ParameterHintsCommand({
    id: 'closeParameterHints',
    precondition: __WEBPACK_IMPORTED_MODULE_7__provideSignatureHelp_js__["a" /* Context */].Visible,
    handler: function (x) { return x.cancel(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
        primary: 9 /* Escape */,
        secondary: [1024 /* Shift */ | 9 /* Escape */]
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new ParameterHintsCommand({
    id: 'showPrevParameterHint',
    precondition: __WEBPACK_IMPORTED_MODULE_4__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_7__provideSignatureHelp_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_7__provideSignatureHelp_js__["a" /* Context */].MultipleSignatures),
    handler: function (x) { return x.previous(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
        primary: 16 /* UpArrow */,
        secondary: [512 /* Alt */ | 16 /* UpArrow */],
        mac: { primary: 16 /* UpArrow */, secondary: [512 /* Alt */ | 16 /* UpArrow */, 256 /* WinCtrl */ | 46 /* KEY_P */] }
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new ParameterHintsCommand({
    id: 'showNextParameterHint',
    precondition: __WEBPACK_IMPORTED_MODULE_4__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_7__provideSignatureHelp_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_7__provideSignatureHelp_js__["a" /* Context */].MultipleSignatures),
    handler: function (x) { return x.next(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_3__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
        primary: 18 /* DownArrow */,
        secondary: [512 /* Alt */ | 18 /* DownArrow */],
        mac: { primary: 18 /* DownArrow */, secondary: [512 /* Alt */ | 18 /* DownArrow */, 256 /* WinCtrl */ | 44 /* KEY_N */] }
    }
}));


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditorActionCommandEntry", function() { return EditorActionCommandEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuickCommandAction", function() { return QuickCommandAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_filters_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_parts_quickopen_browser_quickOpenModel_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_parts_quickopen_common_quickOpen_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editorQuickOpen_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_browser_browser_js__ = __webpack_require__(25);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var EditorActionCommandEntry = /** @class */ (function (_super) {
    __extends(EditorActionCommandEntry, _super);
    function EditorActionCommandEntry(key, highlights, action, editor) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.setHighlights(highlights);
        _this.action = action;
        _this.editor = editor;
        return _this;
    }
    EditorActionCommandEntry.prototype.getLabel = function () {
        return this.action.label;
    };
    EditorActionCommandEntry.prototype.getAriaLabel = function () {
        return __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('ariaLabelEntry', "{0}, commands", this.getLabel());
    };
    EditorActionCommandEntry.prototype.getGroupLabel = function () {
        return this.key;
    };
    EditorActionCommandEntry.prototype.run = function (mode, context) {
        var _this = this;
        if (mode === __WEBPACK_IMPORTED_MODULE_5__base_parts_quickopen_common_quickOpen_js__["a" /* Mode */].OPEN) {
            // Use a timeout to give the quick open widget a chance to close itself first
            __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].timeout(50).done(function () {
                // Some actions are enabled only when editor has focus
                _this.editor.focus();
                try {
                    var promise = _this.action.run() || __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].as(null);
                    promise.done(null, __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */]);
                }
                catch (error) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */])(error);
                }
            }, __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */]);
            return true;
        }
        return false;
    };
    return EditorActionCommandEntry;
}(__WEBPACK_IMPORTED_MODULE_4__base_parts_quickopen_browser_quickOpenModel_js__["b" /* QuickOpenEntryGroup */]));

var QuickCommandAction = /** @class */ (function (_super) {
    __extends(QuickCommandAction, _super);
    function QuickCommandAction() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('quickCommandActionInput', "Type the name of an action you want to execute"), {
            id: 'editor.action.quickCommand',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('QuickCommandAction.label', "Command Palette"),
            alias: 'Command Palette',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: (__WEBPACK_IMPORTED_MODULE_10__base_browser_browser_js__["k" /* isIE */] ? 512 /* Alt */ | 59 /* F1 */ : 59 /* F1 */),
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: 'z_commands',
                order: 1
            }
        }) || this;
    }
    QuickCommandAction.prototype.run = function (accessor, editor) {
        var _this = this;
        var keybindingService = accessor.get(__WEBPACK_IMPORTED_MODULE_6__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]);
        this._show(this.getController(editor), {
            getModel: function (value) {
                return new __WEBPACK_IMPORTED_MODULE_4__base_parts_quickopen_browser_quickOpenModel_js__["c" /* QuickOpenModel */](_this._editorActionsToEntries(keybindingService, editor, value));
            },
            getAutoFocus: function (searchValue) {
                return {
                    autoFocusFirstEntry: true,
                    autoFocusPrefixMatch: searchValue
                };
            }
        });
    };
    QuickCommandAction.prototype._sort = function (elementA, elementB) {
        var elementAName = elementA.getLabel().toLowerCase();
        var elementBName = elementB.getLabel().toLowerCase();
        return elementAName.localeCompare(elementBName);
    };
    QuickCommandAction.prototype._editorActionsToEntries = function (keybindingService, editor, searchValue) {
        var actions = editor.getSupportedActions();
        var entries = [];
        for (var i = 0; i < actions.length; i++) {
            var action = actions[i];
            var keybind = keybindingService.lookupKeybinding(action.id);
            if (action.label) {
                var highlights = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_filters_js__["e" /* matchesFuzzy */])(searchValue, action.label);
                if (highlights) {
                    entries.push(new EditorActionCommandEntry(keybind ? keybind.getLabel() : '', highlights, action, editor));
                }
            }
        }
        // Sort by name
        entries = entries.sort(this._sort);
        return entries;
    };
    return QuickCommandAction;
}(__WEBPACK_IMPORTED_MODULE_8__editorQuickOpen_js__["a" /* BaseEditorQuickOpenAction */]));

Object(__WEBPACK_IMPORTED_MODULE_9__browser_editorExtensions_js__["f" /* registerEditorAction */])(QuickCommandAction);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolEntry", function() { return SymbolEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuickOutlineAction", function() { return QuickOutlineAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quickOutline_css__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quickOutline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__quickOutline_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_filters_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_parts_quickopen_browser_quickOpenModel_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_parts_quickopen_common_quickOpen_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editorQuickOpen_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__contrib_quickOpen_quickOpen_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var SCOPE_PREFIX = ':';
var SymbolEntry = /** @class */ (function (_super) {
    __extends(SymbolEntry, _super);
    function SymbolEntry(name, type, description, range, highlights, editor, decorator) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.type = type;
        _this.description = description;
        _this.range = range;
        _this.setHighlights(highlights);
        _this.editor = editor;
        _this.decorator = decorator;
        return _this;
    }
    SymbolEntry.prototype.getLabel = function () {
        return this.name;
    };
    SymbolEntry.prototype.getAriaLabel = function () {
        return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('entryAriaLabel', "{0}, symbols", this.name);
    };
    SymbolEntry.prototype.getIcon = function () {
        return this.type;
    };
    SymbolEntry.prototype.getDescription = function () {
        return this.description;
    };
    SymbolEntry.prototype.getType = function () {
        return this.type;
    };
    SymbolEntry.prototype.getRange = function () {
        return this.range;
    };
    SymbolEntry.prototype.run = function (mode, context) {
        if (mode === __WEBPACK_IMPORTED_MODULE_5__base_parts_quickopen_common_quickOpen_js__["a" /* Mode */].OPEN) {
            return this.runOpen(context);
        }
        return this.runPreview();
    };
    SymbolEntry.prototype.runOpen = function (context) {
        // Apply selection and focus
        var range = this.toSelection();
        this.editor.setSelection(range);
        this.editor.revealRangeInCenter(range, 0 /* Smooth */);
        this.editor.focus();
        return true;
    };
    SymbolEntry.prototype.runPreview = function () {
        // Select Outline Position
        var range = this.toSelection();
        this.editor.revealRangeInCenter(range, 0 /* Smooth */);
        // Decorate if possible
        this.decorator.decorateLine(this.range, this.editor);
        return false;
    };
    SymbolEntry.prototype.toSelection = function () {
        return new __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */](this.range.startLineNumber, this.range.startColumn || 1, this.range.startLineNumber, this.range.startColumn || 1);
    };
    return SymbolEntry;
}(__WEBPACK_IMPORTED_MODULE_4__base_parts_quickopen_browser_quickOpenModel_js__["b" /* QuickOpenEntryGroup */]));

var QuickOutlineAction = /** @class */ (function (_super) {
    __extends(QuickOutlineAction, _super);
    function QuickOutlineAction() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('quickOutlineActionInput', "Type the name of an identifier you wish to navigate to"), {
            id: 'editor.action.quickOutline',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('QuickOutlineAction.label', "Go to Symbol..."),
            alias: 'Go to Symbol...',
            precondition: __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasDocumentSymbolProvider,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 45 /* KEY_O */,
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: 'navigation',
                order: 3
            }
        }) || this;
    }
    QuickOutlineAction.prototype.run = function (accessor, editor) {
        var _this = this;
        var model = editor.getModel();
        if (!__WEBPACK_IMPORTED_MODULE_7__common_modes_js__["j" /* DocumentSymbolProviderRegistry */].has(model)) {
            return null;
        }
        // Resolve outline
        return Object(__WEBPACK_IMPORTED_MODULE_9__contrib_quickOpen_quickOpen_js__["a" /* getDocumentSymbols */])(model).then(function (result) {
            if (result.length === 0) {
                return;
            }
            _this._run(editor, result);
        });
    };
    QuickOutlineAction.prototype._run = function (editor, result) {
        var _this = this;
        this._show(this.getController(editor), {
            getModel: function (value) {
                return new __WEBPACK_IMPORTED_MODULE_4__base_parts_quickopen_browser_quickOpenModel_js__["c" /* QuickOpenModel */](_this.toQuickOpenEntries(editor, result, value));
            },
            getAutoFocus: function (searchValue) {
                // Remove any type pattern (:) from search value as needed
                if (searchValue.indexOf(SCOPE_PREFIX) === 0) {
                    searchValue = searchValue.substr(SCOPE_PREFIX.length);
                }
                return {
                    autoFocusPrefixMatch: searchValue,
                    autoFocusFirstEntry: !!searchValue
                };
            }
        });
    };
    QuickOutlineAction.prototype.symbolEntry = function (name, type, description, range, highlights, editor, decorator) {
        return new SymbolEntry(name, type, description, __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */].lift(range), highlights, editor, decorator);
    };
    QuickOutlineAction.prototype.toQuickOpenEntries = function (editor, flattened, searchValue) {
        var controller = this.getController(editor);
        var results = [];
        // Convert to Entries
        var normalizedSearchValue = searchValue;
        if (searchValue.indexOf(SCOPE_PREFIX) === 0) {
            normalizedSearchValue = normalizedSearchValue.substr(SCOPE_PREFIX.length);
        }
        for (var i = 0; i < flattened.length; i++) {
            var element = flattened[i];
            var label = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["trim"](element.name);
            // Check for meatch
            var highlights = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_filters_js__["e" /* matchesFuzzy */])(normalizedSearchValue, label);
            if (highlights) {
                // Show parent scope as description
                var description = null;
                if (element.containerName) {
                    description = element.containerName;
                }
                // Add
                results.push(this.symbolEntry(label, Object(__WEBPACK_IMPORTED_MODULE_7__common_modes_js__["B" /* symbolKindToCssClass */])(element.kind), description, element.range, highlights, editor, controller));
            }
        }
        // Sort properly if actually searching
        if (searchValue) {
            if (searchValue.indexOf(SCOPE_PREFIX) === 0) {
                results = results.sort(this.sortScoped.bind(this, searchValue.toLowerCase()));
            }
            else {
                results = results.sort(this.sortNormal.bind(this, searchValue.toLowerCase()));
            }
        }
        // Mark all type groups
        if (results.length > 0 && searchValue.indexOf(SCOPE_PREFIX) === 0) {
            var currentType = null;
            var currentResult = null;
            var typeCounter = 0;
            for (var i = 0; i < results.length; i++) {
                var result = results[i];
                // Found new type
                if (currentType !== result.getType()) {
                    // Update previous result with count
                    if (currentResult) {
                        currentResult.setGroupLabel(this.typeToLabel(currentType, typeCounter));
                    }
                    currentType = result.getType();
                    currentResult = result;
                    typeCounter = 1;
                    result.setShowBorder(i > 0);
                }
                // Existing type, keep counting
                else {
                    typeCounter++;
                }
            }
            // Update previous result with count
            if (currentResult) {
                currentResult.setGroupLabel(this.typeToLabel(currentType, typeCounter));
            }
        }
        // Mark first entry as outline
        else if (results.length > 0) {
            results[0].setGroupLabel(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('symbols', "symbols ({0})", results.length));
        }
        return results;
    };
    QuickOutlineAction.prototype.typeToLabel = function (type, count) {
        switch (type) {
            case 'module': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('modules', "modules ({0})", count);
            case 'class': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('class', "classes ({0})", count);
            case 'interface': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('interface', "interfaces ({0})", count);
            case 'method': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('method', "methods ({0})", count);
            case 'function': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('function', "functions ({0})", count);
            case 'property': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('property', "properties ({0})", count);
            case 'variable': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('variable', "variables ({0})", count);
            case 'var': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('variable2', "variables ({0})", count);
            case 'constructor': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('_constructor', "constructors ({0})", count);
            case 'call': return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('call', "calls ({0})", count);
        }
        return type;
    };
    QuickOutlineAction.prototype.sortNormal = function (searchValue, elementA, elementB) {
        var elementAName = elementA.getLabel().toLowerCase();
        var elementBName = elementB.getLabel().toLowerCase();
        // Compare by name
        var r = elementAName.localeCompare(elementBName);
        if (r !== 0) {
            return r;
        }
        // If name identical sort by range instead
        var elementARange = elementA.getRange();
        var elementBRange = elementB.getRange();
        return elementARange.startLineNumber - elementBRange.startLineNumber;
    };
    QuickOutlineAction.prototype.sortScoped = function (searchValue, elementA, elementB) {
        // Remove scope char
        searchValue = searchValue.substr(SCOPE_PREFIX.length);
        // Sort by type first if scoped search
        var elementAType = elementA.getType();
        var elementBType = elementB.getType();
        var r = elementAType.localeCompare(elementBType);
        if (r !== 0) {
            return r;
        }
        // Special sort when searching in scoped mode
        if (searchValue) {
            var elementAName = elementA.getLabel().toLowerCase();
            var elementBName = elementB.getLabel().toLowerCase();
            // Compare by name
            var r_1 = elementAName.localeCompare(elementBName);
            if (r_1 !== 0) {
                return r_1;
            }
        }
        // Default to sort by range
        var elementARange = elementA.getRange();
        var elementBRange = elementB.getRange();
        return elementARange.startLineNumber - elementBRange.startLineNumber;
    };
    return QuickOutlineAction;
}(__WEBPACK_IMPORTED_MODULE_8__editorQuickOpen_js__["a" /* BaseEditorQuickOpenAction */]));

Object(__WEBPACK_IMPORTED_MODULE_10__browser_editorExtensions_js__["f" /* registerEditorAction */])(QuickOutlineAction);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultReferenceSearchOptions", function() { return defaultReferenceSearchOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceController", function() { return ReferenceController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceAction", function() { return ReferenceAction; });
/* harmony export (immutable) */ __webpack_exports__["provideReferences"] = provideReferences;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__peekViewWidget_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__referencesController_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__referencesModel_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__browser_widget_embeddedCodeEditorWidget_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_list_browser_listService_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__referencesWidget_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};






















var defaultReferenceSearchOptions = {
    getMetaTitle: function (model) {
        return model.references.length > 1 && __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('meta.titleReference', " – {0} references", model.references.length);
    }
};
var ReferenceController = /** @class */ (function () {
    function ReferenceController(editor, contextKeyService) {
        if (editor instanceof __WEBPACK_IMPORTED_MODULE_14__browser_widget_embeddedCodeEditorWidget_js__["a" /* EmbeddedCodeEditorWidget */]) {
            __WEBPACK_IMPORTED_MODULE_8__peekViewWidget_js__["a" /* PeekContext */].inPeekEditor.bindTo(contextKeyService);
        }
    }
    ReferenceController.prototype.dispose = function () {
    };
    ReferenceController.prototype.getId = function () {
        return ReferenceController.ID;
    };
    ReferenceController.ID = 'editor.contrib.referenceController';
    ReferenceController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], ReferenceController);
    return ReferenceController;
}());

var ReferenceAction = /** @class */ (function (_super) {
    __extends(ReferenceAction, _super);
    function ReferenceAction() {
        return _super.call(this, {
            id: 'editor.action.referenceSearch.trigger',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('references.action.label', "Find All References"),
            alias: 'Find All References',
            precondition: __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasReferenceProvider, __WEBPACK_IMPORTED_MODULE_8__peekViewWidget_js__["a" /* PeekContext */].notInPeekEditor, __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].isInEmbeddedEditor.toNegated()),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_13__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 70 /* F12 */,
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: 'navigation',
                order: 1.5
            }
        }) || this;
    }
    ReferenceAction.prototype.run = function (accessor, editor) {
        var controller = __WEBPACK_IMPORTED_MODULE_9__referencesController_js__["a" /* ReferencesController */].get(editor);
        if (!controller) {
            return;
        }
        var range = editor.getSelection();
        var model = editor.getModel();
        var references = Object(__WEBPACK_IMPORTED_MODULE_11__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return provideReferences(model, range.getStartPosition(), token).then(function (references) { return new __WEBPACK_IMPORTED_MODULE_10__referencesModel_js__["c" /* ReferencesModel */](references); }); });
        controller.toggleWidget(range, references, defaultReferenceSearchOptions);
    };
    return ReferenceAction;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["h" /* registerEditorContribution */])(ReferenceController);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(ReferenceAction);
var findReferencesCommand = function (accessor, resource, position) {
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_19__base_common_uri_js__["a" /* default */])) {
        throw new Error('illegal argument, uri');
    }
    if (!position) {
        throw new Error('illegal argument, position');
    }
    var codeEditorService = accessor.get(__WEBPACK_IMPORTED_MODULE_20__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]);
    return codeEditorService.openCodeEditor({ resource: resource }, codeEditorService.getFocusedCodeEditor()).then(function (control) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_15__browser_editorBrowser_js__["d" /* isCodeEditor */])(control)) {
            return undefined;
        }
        var controller = __WEBPACK_IMPORTED_MODULE_9__referencesController_js__["a" /* ReferencesController */].get(control);
        if (!controller) {
            return undefined;
        }
        var references = Object(__WEBPACK_IMPORTED_MODULE_11__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return provideReferences(control.getModel(), __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */].lift(position), token).then(function (references) { return new __WEBPACK_IMPORTED_MODULE_10__referencesModel_js__["c" /* ReferencesModel */](references); }); });
        var range = new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column);
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(controller.toggleWidget(range, references, defaultReferenceSearchOptions));
    });
};
var showReferencesCommand = function (accessor, resource, position, references) {
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_19__base_common_uri_js__["a" /* default */])) {
        throw new Error('illegal argument, uri expected');
    }
    var codeEditorService = accessor.get(__WEBPACK_IMPORTED_MODULE_20__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]);
    return codeEditorService.openCodeEditor({ resource: resource }, codeEditorService.getFocusedCodeEditor()).then(function (control) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_15__browser_editorBrowser_js__["d" /* isCodeEditor */])(control)) {
            return undefined;
        }
        var controller = __WEBPACK_IMPORTED_MODULE_9__referencesController_js__["a" /* ReferencesController */].get(control);
        if (!controller) {
            return undefined;
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(controller.toggleWidget(new __WEBPACK_IMPORTED_MODULE_7__common_core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column), Object(__WEBPACK_IMPORTED_MODULE_11__base_common_async_js__["i" /* createCancelablePromise */])(function (_) { return Promise.resolve(new __WEBPACK_IMPORTED_MODULE_10__referencesModel_js__["c" /* ReferencesModel */](references)); }), defaultReferenceSearchOptions)).then(function () { return true; });
    });
};
// register commands
__WEBPACK_IMPORTED_MODULE_18__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand({
    id: 'editor.action.findReferences',
    handler: findReferencesCommand
});
__WEBPACK_IMPORTED_MODULE_18__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand({
    id: 'editor.action.showReferences',
    handler: showReferencesCommand,
    description: {
        description: 'Show references at a position in a file',
        args: [
            { name: 'uri', description: 'The text document in which to show references', constraint: __WEBPACK_IMPORTED_MODULE_19__base_common_uri_js__["a" /* default */] },
            { name: 'position', description: 'The position at which to show', constraint: __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */].isIPosition },
            { name: 'locations', description: 'An array of locations.', constraint: Array },
        ]
    }
});
function closeActiveReferenceSearch(accessor, args) {
    withController(accessor, function (controller) { return controller.closeWidget(); });
}
function openReferenceToSide(accessor, args) {
    var listService = accessor.get(__WEBPACK_IMPORTED_MODULE_16__platform_list_browser_listService_js__["a" /* IListService */]);
    var focus = listService.lastFocusedList && listService.lastFocusedList.getFocus();
    if (focus instanceof __WEBPACK_IMPORTED_MODULE_10__referencesModel_js__["b" /* OneReference */]) {
        withController(accessor, function (controller) { return controller.openReference(focus, true); });
    }
}
function withController(accessor, fn) {
    var outerEditor = Object(__WEBPACK_IMPORTED_MODULE_8__peekViewWidget_js__["c" /* getOuterEditor */])(accessor);
    if (!outerEditor) {
        return;
    }
    var controller = __WEBPACK_IMPORTED_MODULE_9__referencesController_js__["a" /* ReferencesController */].get(outerEditor);
    if (!controller) {
        return;
    }
    fn(controller);
}
__WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'goToNextReference',
    weight: 200 /* WorkbenchContrib */ + 50,
    primary: 62 /* F4 */,
    when: __WEBPACK_IMPORTED_MODULE_9__referencesController_js__["b" /* ctxReferenceSearchVisible */],
    handler: function (accessor) {
        withController(accessor, function (controller) {
            controller.goToNextOrPreviousReference(true);
        });
    }
});
__WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'goToNextReferenceFromEmbeddedEditor',
    weight: 100 /* EditorContrib */ + 50,
    primary: 62 /* F4 */,
    when: __WEBPACK_IMPORTED_MODULE_8__peekViewWidget_js__["a" /* PeekContext */].inPeekEditor,
    handler: function (accessor) {
        withController(accessor, function (controller) {
            controller.goToNextOrPreviousReference(true);
        });
    }
});
__WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'goToPreviousReference',
    weight: 200 /* WorkbenchContrib */ + 50,
    primary: 1024 /* Shift */ | 62 /* F4 */,
    when: __WEBPACK_IMPORTED_MODULE_9__referencesController_js__["b" /* ctxReferenceSearchVisible */],
    handler: function (accessor) {
        withController(accessor, function (controller) {
            controller.goToNextOrPreviousReference(false);
        });
    }
});
__WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'goToPreviousReferenceFromEmbeddedEditor',
    weight: 100 /* EditorContrib */ + 50,
    primary: 1024 /* Shift */ | 62 /* F4 */,
    when: __WEBPACK_IMPORTED_MODULE_8__peekViewWidget_js__["a" /* PeekContext */].inPeekEditor,
    handler: function (accessor) {
        withController(accessor, function (controller) {
            controller.goToNextOrPreviousReference(false);
        });
    }
});
__WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'closeReferenceSearch',
    weight: 200 /* WorkbenchContrib */ + 50,
    primary: 9 /* Escape */,
    secondary: [1024 /* Shift */ | 9 /* Escape */],
    when: __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_9__referencesController_js__["b" /* ctxReferenceSearchVisible */], __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].not('config.editor.stablePeek')),
    handler: closeActiveReferenceSearch
});
__WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'closeReferenceSearchEditor',
    weight: 100 /* EditorContrib */ - 101,
    primary: 9 /* Escape */,
    secondary: [1024 /* Shift */ | 9 /* Escape */],
    when: __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_8__peekViewWidget_js__["a" /* PeekContext */].inPeekEditor, __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].not('config.editor.stablePeek')),
    handler: closeActiveReferenceSearch
});
__WEBPACK_IMPORTED_MODULE_3__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'openReferenceToSide',
    weight: 100 /* EditorContrib */,
    primary: 2048 /* CtrlCmd */ | 3 /* Enter */,
    mac: {
        primary: 256 /* WinCtrl */ | 3 /* Enter */
    },
    when: __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_9__referencesController_js__["b" /* ctxReferenceSearchVisible */], __WEBPACK_IMPORTED_MODULE_17__referencesWidget_js__["b" /* ctxReferenceWidgetSearchTreeFocused */]),
    handler: openReferenceToSide
});
function provideReferences(model, position, token) {
    // collect references from all providers
    var promises = __WEBPACK_IMPORTED_MODULE_6__common_modes_js__["r" /* ReferenceProviderRegistry */].ordered(model).map(function (provider) {
        return Object(__WEBPACK_IMPORTED_MODULE_11__base_common_async_js__["h" /* asWinJsPromise */])(function (token) {
            return provider.provideReferences(model, position, { includeDeclaration: true }, token);
        }).then(function (result) {
            if (Array.isArray(result)) {
                return result;
            }
            return undefined;
        }, function (err) {
            Object(__WEBPACK_IMPORTED_MODULE_12__base_common_errors_js__["f" /* onUnexpectedExternalError */])(err);
        });
    });
    return Promise.all(promises).then(function (references) {
        var result = [];
        for (var _i = 0, references_1 = references; _i < references_1.length; _i++) {
            var ref = references_1[_i];
            if (ref) {
                result.push.apply(result, ref);
            }
        }
        return result;
    });
}
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeReferenceProvider', function (model, position) { return provideReferences(model, position, __WEBPACK_IMPORTED_MODULE_21__base_common_cancellation_js__["a" /* CancellationToken */].None); });


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandaloneReferencesController", function() { return StandaloneReferencesController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_configuration_common_configuration_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_storage_common_storage_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contrib_referenceSearch_referencesController_js__ = __webpack_require__(144);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};








var StandaloneReferencesController = /** @class */ (function (_super) {
    __extends(StandaloneReferencesController, _super);
    function StandaloneReferencesController(editor, contextKeyService, editorService, notificationService, instantiationService, storageService, configurationService) {
        return _super.call(this, true, editor, contextKeyService, editorService, notificationService, instantiationService, storageService, configurationService) || this;
    }
    StandaloneReferencesController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_2__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_0__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_6__platform_notification_common_notification_js__["a" /* INotificationService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_1__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_4__platform_storage_common_storage_js__["a" /* IStorageService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_3__platform_configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], StandaloneReferencesController);
    return StandaloneReferencesController;
}(__WEBPACK_IMPORTED_MODULE_7__contrib_referenceSearch_referencesController_js__["a" /* ReferencesController */]));

Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["h" /* registerEditorContribution */])(StandaloneReferencesController);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["rename"] = rename;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenameAction", function() { return RenameAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_progress_common_progress_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__renameInputField_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__message_messageController_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browser_core_editorState_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__browser_services_bulkEditService_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__browser_services_codeEditorService_js__ = __webpack_require__(29);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




















var RenameSkeleton = /** @class */ (function () {
    function RenameSkeleton(model, position) {
        this.model = model;
        this.position = position;
        this._provider = __WEBPACK_IMPORTED_MODULE_10__common_modes_js__["s" /* RenameProviderRegistry */].ordered(model);
    }
    RenameSkeleton.prototype.hasProvider = function () {
        return this._provider.length > 0;
    };
    RenameSkeleton.prototype.resolveRenameLocation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var provider, res, word;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        provider = this._provider[0];
                        if (!provider.resolveRenameLocation) return [3 /*break*/, 2];
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_9__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return provider.resolveRenameLocation(_this.model, _this.position, token); })];
                    case 1:
                        res = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!res) {
                            word = this.model.getWordAtPosition(this.position);
                            if (word) {
                                res = {
                                    range: new __WEBPACK_IMPORTED_MODULE_13__common_core_range_js__["a" /* Range */](this.position.lineNumber, word.startColumn, this.position.lineNumber, word.endColumn),
                                    text: word.word
                                };
                            }
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    RenameSkeleton.prototype.provideRenameEdits = function (newName, i, rejects, position) {
        if (i === void 0) { i = 0; }
        if (rejects === void 0) { rejects = []; }
        if (position === void 0) { position = this.position; }
        return __awaiter(this, void 0, void 0, function () {
            var provider, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (i >= this._provider.length) {
                            return [2 /*return*/, {
                                    edits: undefined,
                                    rejectReason: rejects.join('\n')
                                }];
                        }
                        provider = this._provider[i];
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_9__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return provider.provideRenameEdits(_this.model, _this.position, newName, token); })];
                    case 1:
                        result = _a.sent();
                        if (!result) {
                            return [2 /*return*/, this.provideRenameEdits(newName, i + 1, rejects.concat(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('no result', "No result.")))];
                        }
                        else if (result.rejectReason) {
                            return [2 /*return*/, this.provideRenameEdits(newName, i + 1, rejects.concat(result.rejectReason))];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return RenameSkeleton;
}());
function rename(model, position, newName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new RenameSkeleton(model, position).provideRenameEdits(newName)];
        });
    });
}
// ---  register actions and commands
var CONTEXT_RENAME_INPUT_VISIBLE = new __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('renameInputVisible', false);
var RenameController = /** @class */ (function () {
    function RenameController(editor, _notificationService, _bulkEditService, _progressService, contextKeyService, themeService) {
        this.editor = editor;
        this._notificationService = _notificationService;
        this._bulkEditService = _bulkEditService;
        this._progressService = _progressService;
        this._renameInputField = new __WEBPACK_IMPORTED_MODULE_7__renameInputField_js__["a" /* default */](editor, themeService);
        this._renameInputVisible = CONTEXT_RENAME_INPUT_VISIBLE.bindTo(contextKeyService);
    }
    RenameController.get = function (editor) {
        return editor.getContribution(RenameController.ID);
    };
    RenameController.prototype.dispose = function () {
        this._renameInputField.dispose();
    };
    RenameController.prototype.getId = function () {
        return RenameController.ID;
    };
    RenameController.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            var position, skeleton, loc, e_1, selection, selectionStart, selectionEnd;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        position = this.editor.getPosition();
                        skeleton = new RenameSkeleton(this.editor.getModel(), position);
                        if (!skeleton.hasProvider()) {
                            return [2 /*return*/, undefined];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, skeleton.resolveRenameLocation()];
                    case 2:
                        loc = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        __WEBPACK_IMPORTED_MODULE_14__message_messageController_js__["a" /* MessageController */].get(this.editor).showMessage(e_1, position);
                        return [2 /*return*/, undefined];
                    case 4:
                        if (!loc) {
                            return [2 /*return*/, undefined];
                        }
                        selection = this.editor.getSelection();
                        selectionStart = 0;
                        selectionEnd = loc.text.length;
                        if (!__WEBPACK_IMPORTED_MODULE_13__common_core_range_js__["a" /* Range */].isEmpty(selection) && !__WEBPACK_IMPORTED_MODULE_13__common_core_range_js__["a" /* Range */].spansMultipleLines(selection) && __WEBPACK_IMPORTED_MODULE_13__common_core_range_js__["a" /* Range */].containsRange(loc.range, selection)) {
                            selectionStart = Math.max(0, selection.startColumn - loc.range.startColumn);
                            selectionEnd = Math.min(loc.range.endColumn, selection.endColumn) - loc.range.startColumn;
                        }
                        this._renameInputVisible.set(true);
                        return [2 /*return*/, this._renameInputField.getInput(loc.range, loc.text, selectionStart, selectionEnd).then(function (newNameOrFocusFlag) {
                                _this._renameInputVisible.reset();
                                if (typeof newNameOrFocusFlag === 'boolean') {
                                    if (newNameOrFocusFlag) {
                                        _this.editor.focus();
                                    }
                                    return undefined;
                                }
                                _this.editor.focus();
                                var state = new __WEBPACK_IMPORTED_MODULE_15__browser_core_editorState_js__["a" /* EditorState */](_this.editor, 4 /* Position */ | 1 /* Value */ | 2 /* Selection */ | 8 /* Scroll */);
                                var renameOperation = __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrap(skeleton.provideRenameEdits(newNameOrFocusFlag, 0, [], __WEBPACK_IMPORTED_MODULE_13__common_core_range_js__["a" /* Range */].lift(loc.range).getStartPosition()).then(function (result) {
                                    if (result.rejectReason) {
                                        if (state.validate(_this.editor)) {
                                            __WEBPACK_IMPORTED_MODULE_14__message_messageController_js__["a" /* MessageController */].get(_this.editor).showMessage(result.rejectReason, _this.editor.getPosition());
                                        }
                                        else {
                                            _this._notificationService.info(result.rejectReason);
                                        }
                                        return undefined;
                                    }
                                    return _this._bulkEditService.apply(result, { editor: _this.editor }).then(function (result) {
                                        // alert
                                        if (result.ariaSummary) {
                                            Object(__WEBPACK_IMPORTED_MODULE_12__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('aria', "Successfully renamed '{0}' to '{1}'. Summary: {2}", loc.text, newNameOrFocusFlag, result.ariaSummary));
                                        }
                                    });
                                }, function (err) {
                                    _this._notificationService.error(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('rename.failed', "Rename failed to execute."));
                                    return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(err);
                                }));
                                _this._progressService.showWhile(renameOperation, 250);
                                return renameOperation;
                            }, function (err) {
                                _this._renameInputVisible.reset();
                                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(err);
                            })];
                }
            });
        });
    };
    RenameController.prototype.acceptRenameInput = function () {
        this._renameInputField.acceptInput();
    };
    RenameController.prototype.cancelRenameInput = function () {
        this._renameInputField.cancelInput(true);
    };
    RenameController.ID = 'editor.contrib.renameController';
    RenameController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_16__platform_notification_common_notification_js__["a" /* INotificationService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_17__browser_services_bulkEditService_js__["a" /* IBulkEditService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_4__platform_progress_common_progress_js__["a" /* IProgressService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["c" /* IThemeService */])
    ], RenameController);
    return RenameController;
}());
// ---- action implementation
var RenameAction = /** @class */ (function (_super) {
    __extends(RenameAction, _super);
    function RenameAction() {
        return _super.call(this, {
            id: 'editor.action.rename',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('rename.label', "Rename Symbol"),
            alias: 'Rename Symbol',
            precondition: __WEBPACK_IMPORTED_MODULE_3__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasRenameProvider),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 60 /* F2 */,
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: '1_modification',
                order: 1.1
            }
        }) || this;
    }
    RenameAction.prototype.runCommand = function (accessor, args) {
        var _this = this;
        var editorService = accessor.get(__WEBPACK_IMPORTED_MODULE_19__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]);
        var _a = args || [undefined, undefined], uri = _a[0], pos = _a[1];
        if (__WEBPACK_IMPORTED_MODULE_18__base_common_uri_js__["a" /* default */].isUri(uri) && __WEBPACK_IMPORTED_MODULE_11__common_core_position_js__["a" /* Position */].isIPosition(pos)) {
            return editorService.openCodeEditor({ resource: uri }, editorService.getActiveCodeEditor()).then(function (editor) {
                editor.setPosition(pos);
                editor.invokeWithinContext(function (accessor) {
                    _this.reportTelemetry(accessor, editor);
                    return _this.run(accessor, editor);
                });
            }, __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */]);
        }
        return _super.prototype.runCommand.call(this, accessor, args);
    };
    RenameAction.prototype.run = function (accessor, editor) {
        var controller = RenameController.get(editor);
        if (controller) {
            return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrap(controller.run());
        }
        return undefined;
    };
    return RenameAction;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["h" /* registerEditorContribution */])(RenameController);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(RenameAction);
var RenameCommand = __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(RenameController.get);
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new RenameCommand({
    id: 'acceptRenameInput',
    precondition: CONTEXT_RENAME_INPUT_VISIBLE,
    handler: function (x) { return x.acceptRenameInput(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 99,
        kbExpr: __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 3 /* Enter */
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new RenameCommand({
    id: 'cancelRenameInput',
    precondition: CONTEXT_RENAME_INPUT_VISIBLE,
    handler: function (x) { return x.cancelRenameInput(); },
    kbOpts: {
        weight: 100 /* EditorContrib */ + 99,
        kbExpr: __WEBPACK_IMPORTED_MODULE_6__common_editorContextKeys_js__["a" /* EditorContextKeys */].focus,
        primary: 9 /* Escape */,
        secondary: [1024 /* Shift */ | 9 /* Escape */]
    }
}));
// ---- api bridge command
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeDocumentRenameProvider', function (model, position, args) {
    var newName = args.newName;
    if (typeof newName !== 'string') {
        throw Object(__WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["b" /* illegalArgument */])('newName');
    }
    return rename(model, position, newName);
});


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tokenSelectionSupport_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__ = __webpack_require__(41);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};









// --- selection state machine
var State = /** @class */ (function () {
    function State(editor) {
        this.editor = editor;
        this.next = null;
        this.previous = null;
        this.selection = editor.getSelection();
    }
    return State;
}());
// -- action implementation
var SmartSelectController = /** @class */ (function () {
    function SmartSelectController(editor, instantiationService) {
        this.editor = editor;
        this._tokenSelectionSupport = instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_7__tokenSelectionSupport_js__["a" /* TokenSelectionSupport */]);
        this._state = null;
        this._ignoreSelection = false;
    }
    SmartSelectController.get = function (editor) {
        return editor.getContribution(SmartSelectController.ID);
    };
    SmartSelectController.prototype.dispose = function () {
    };
    SmartSelectController.prototype.getId = function () {
        return SmartSelectController.ID;
    };
    SmartSelectController.prototype.run = function (forward) {
        var _this = this;
        var selection = this.editor.getSelection();
        var model = this.editor.getModel();
        // forget about current state
        if (this._state) {
            if (this._state.editor !== this.editor) {
                this._state = null;
            }
        }
        var promise = __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(null);
        if (!this._state) {
            promise = this._tokenSelectionSupport.getRangesToPosition(model.uri, selection.getStartPosition()).then(function (elements) {
                if (__WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["k" /* isFalsyOrEmpty */](elements)) {
                    return;
                }
                var lastState;
                elements.filter(function (element) {
                    // filter ranges inside the selection
                    var selection = _this.editor.getSelection();
                    var range = new __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */](element.range.startLineNumber, element.range.startColumn, element.range.endLineNumber, element.range.endColumn);
                    return range.containsPosition(selection.getStartPosition()) && range.containsPosition(selection.getEndPosition());
                }).forEach(function (element) {
                    // create ranges
                    var range = element.range;
                    var state = new State(_this.editor);
                    state.selection = new __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */](range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
                    if (lastState) {
                        state.next = lastState;
                        lastState.previous = state;
                    }
                    lastState = state;
                });
                // insert current selection
                var editorState = new State(_this.editor);
                editorState.next = lastState;
                if (lastState) {
                    lastState.previous = editorState;
                }
                _this._state = editorState;
                // listen to caret move and forget about state
                var unhook = _this.editor.onDidChangeCursorPosition(function (e) {
                    if (_this._ignoreSelection) {
                        return;
                    }
                    _this._state = null;
                    unhook.dispose();
                });
            });
        }
        return promise.then(function () {
            if (!_this._state) {
                return;
            }
            _this._state = forward ? _this._state.next : _this._state.previous;
            if (!_this._state) {
                return;
            }
            _this._ignoreSelection = true;
            try {
                _this.editor.setSelection(_this._state.selection);
            }
            finally {
                _this._ignoreSelection = false;
            }
            return;
        });
    };
    SmartSelectController.ID = 'editor.contrib.smartSelectController';
    SmartSelectController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_3__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */])
    ], SmartSelectController);
    return SmartSelectController;
}());
var AbstractSmartSelect = /** @class */ (function (_super) {
    __extends(AbstractSmartSelect, _super);
    function AbstractSmartSelect(forward, opts) {
        var _this = _super.call(this, opts) || this;
        _this._forward = forward;
        return _this;
    }
    AbstractSmartSelect.prototype.run = function (accessor, editor) {
        var controller = SmartSelectController.get(editor);
        if (controller) {
            return controller.run(this._forward);
        }
        return undefined;
    };
    return AbstractSmartSelect;
}(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["b" /* EditorAction */]));
var GrowSelectionAction = /** @class */ (function (_super) {
    __extends(GrowSelectionAction, _super);
    function GrowSelectionAction() {
        return _super.call(this, true, {
            id: 'editor.action.smartSelect.grow',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('smartSelect.grow', "Expand Select"),
            alias: 'Expand Select',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 512 /* Alt */ | 17 /* RightArrow */,
                mac: { primary: 2048 /* CtrlCmd */ | 256 /* WinCtrl */ | 1024 /* Shift */ | 17 /* RightArrow */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '1_basic',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miSmartSelectGrow', comment: ['&& denotes a mnemonic'] }, "&&Expand Selection"),
                order: 2
            }
        }) || this;
    }
    return GrowSelectionAction;
}(AbstractSmartSelect));
var ShrinkSelectionAction = /** @class */ (function (_super) {
    __extends(ShrinkSelectionAction, _super);
    function ShrinkSelectionAction() {
        return _super.call(this, false, {
            id: 'editor.action.smartSelect.shrink',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('smartSelect.shrink', "Shrink Select"),
            alias: 'Shrink Select',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 512 /* Alt */ | 15 /* LeftArrow */,
                mac: { primary: 2048 /* CtrlCmd */ | 256 /* WinCtrl */ | 1024 /* Shift */ | 15 /* LeftArrow */ },
                weight: 100 /* EditorContrib */
            },
            menubarOpts: {
                menuId: __WEBPACK_IMPORTED_MODULE_8__platform_actions_common_actions_js__["b" /* MenuId */].MenubarSelectionMenu,
                group: '1_basic',
                title: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'miSmartSelectShrink', comment: ['&& denotes a mnemonic'] }, "&&Shrink Selection"),
                order: 3
            }
        }) || this;
    }
    return ShrinkSelectionAction;
}(AbstractSmartSelect));
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["h" /* registerEditorContribution */])(SmartSelectController);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(GrowSelectionAction);
Object(__WEBPACK_IMPORTED_MODULE_6__browser_editorExtensions_js__["f" /* registerEditorAction */])(ShrinkSelectionAction);


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Scanner */
/* unused harmony export Marker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Text; });
/* unused harmony export TransformableMarker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Placeholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Choice; });
/* unused harmony export Transform */
/* unused harmony export FormatString */
/* unused harmony export Variable */
/* unused harmony export TextmateSnippet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SnippetParser; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
var Scanner = /** @class */ (function () {
    function Scanner() {
        this.text('');
    }
    Scanner.isDigitCharacter = function (ch) {
        return ch >= 48 /* Digit0 */ && ch <= 57 /* Digit9 */;
    };
    Scanner.isVariableCharacter = function (ch) {
        return ch === 95 /* Underline */
            || (ch >= 97 /* a */ && ch <= 122 /* z */)
            || (ch >= 65 /* A */ && ch <= 90 /* Z */);
    };
    Scanner.prototype.text = function (value) {
        this.value = value;
        this.pos = 0;
    };
    Scanner.prototype.tokenText = function (token) {
        return this.value.substr(token.pos, token.len);
    };
    Scanner.prototype.next = function () {
        if (this.pos >= this.value.length) {
            return { type: 14 /* EOF */, pos: this.pos, len: 0 };
        }
        var pos = this.pos;
        var len = 0;
        var ch = this.value.charCodeAt(pos);
        var type;
        // static types
        type = Scanner._table[ch];
        if (typeof type === 'number') {
            this.pos += 1;
            return { type: type, pos: pos, len: 1 };
        }
        // number
        if (Scanner.isDigitCharacter(ch)) {
            type = 8 /* Int */;
            do {
                len += 1;
                ch = this.value.charCodeAt(pos + len);
            } while (Scanner.isDigitCharacter(ch));
            this.pos += len;
            return { type: type, pos: pos, len: len };
        }
        // variable name
        if (Scanner.isVariableCharacter(ch)) {
            type = 9 /* VariableName */;
            do {
                ch = this.value.charCodeAt(pos + (++len));
            } while (Scanner.isVariableCharacter(ch) || Scanner.isDigitCharacter(ch));
            this.pos += len;
            return { type: type, pos: pos, len: len };
        }
        // format
        type = 10 /* Format */;
        do {
            len += 1;
            ch = this.value.charCodeAt(pos + len);
        } while (!isNaN(ch)
            && typeof Scanner._table[ch] === 'undefined' // not static token
            && !Scanner.isDigitCharacter(ch) // not number
            && !Scanner.isVariableCharacter(ch) // not variable
        );
        this.pos += len;
        return { type: type, pos: pos, len: len };
    };
    Scanner._table = (_a = {},
        _a[36 /* DollarSign */] = 0 /* Dollar */,
        _a[58 /* Colon */] = 1 /* Colon */,
        _a[44 /* Comma */] = 2 /* Comma */,
        _a[123 /* OpenCurlyBrace */] = 3 /* CurlyOpen */,
        _a[125 /* CloseCurlyBrace */] = 4 /* CurlyClose */,
        _a[92 /* Backslash */] = 5 /* Backslash */,
        _a[47 /* Slash */] = 6 /* Forwardslash */,
        _a[124 /* Pipe */] = 7 /* Pipe */,
        _a[43 /* Plus */] = 11 /* Plus */,
        _a[45 /* Dash */] = 12 /* Dash */,
        _a[63 /* QuestionMark */] = 13 /* QuestionMark */,
        _a);
    return Scanner;
}());

var Marker = /** @class */ (function () {
    function Marker() {
        this._children = [];
    }
    Marker.prototype.appendChild = function (child) {
        if (child instanceof Text && this._children[this._children.length - 1] instanceof Text) {
            // this and previous child are text -> merge them
            this._children[this._children.length - 1].value += child.value;
        }
        else {
            // normal adoption of child
            child.parent = this;
            this._children.push(child);
        }
        return this;
    };
    Marker.prototype.replace = function (child, others) {
        var parent = child.parent;
        var idx = parent.children.indexOf(child);
        var newChildren = parent.children.slice(0);
        newChildren.splice.apply(newChildren, [idx, 1].concat(others));
        parent._children = newChildren;
        others.forEach(function (node) { return node.parent = parent; });
    };
    Object.defineProperty(Marker.prototype, "children", {
        get: function () {
            return this._children;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Marker.prototype, "snippet", {
        get: function () {
            var candidate = this;
            while (true) {
                if (!candidate) {
                    return undefined;
                }
                if (candidate instanceof TextmateSnippet) {
                    return candidate;
                }
                candidate = candidate.parent;
            }
        },
        enumerable: true,
        configurable: true
    });
    Marker.prototype.toString = function () {
        return this.children.reduce(function (prev, cur) { return prev + cur.toString(); }, '');
    };
    Marker.prototype.len = function () {
        return 0;
    };
    return Marker;
}());

var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text(value) {
        var _this_1 = _super.call(this) || this;
        _this_1.value = value;
        return _this_1;
    }
    Text.prototype.toString = function () {
        return this.value;
    };
    Text.prototype.len = function () {
        return this.value.length;
    };
    Text.prototype.clone = function () {
        return new Text(this.value);
    };
    return Text;
}(Marker));

var TransformableMarker = /** @class */ (function (_super) {
    __extends(TransformableMarker, _super);
    function TransformableMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransformableMarker;
}(Marker));

var Placeholder = /** @class */ (function (_super) {
    __extends(Placeholder, _super);
    function Placeholder(index) {
        var _this_1 = _super.call(this) || this;
        _this_1.index = index;
        return _this_1;
    }
    Placeholder.compareByIndex = function (a, b) {
        if (a.index === b.index) {
            return 0;
        }
        else if (a.isFinalTabstop) {
            return 1;
        }
        else if (b.isFinalTabstop) {
            return -1;
        }
        else if (a.index < b.index) {
            return -1;
        }
        else if (a.index > b.index) {
            return 1;
        }
        else {
            return 0;
        }
    };
    Object.defineProperty(Placeholder.prototype, "isFinalTabstop", {
        get: function () {
            return this.index === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Placeholder.prototype, "choice", {
        get: function () {
            return this._children.length === 1 && this._children[0] instanceof Choice
                ? this._children[0]
                : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Placeholder.prototype.clone = function () {
        var ret = new Placeholder(this.index);
        if (this.transform) {
            ret.transform = this.transform.clone();
        }
        ret._children = this.children.map(function (child) { return child.clone(); });
        return ret;
    };
    return Placeholder;
}(TransformableMarker));

var Choice = /** @class */ (function (_super) {
    __extends(Choice, _super);
    function Choice() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.options = [];
        return _this_1;
    }
    Choice.prototype.appendChild = function (marker) {
        if (marker instanceof Text) {
            marker.parent = this;
            this.options.push(marker);
        }
        return this;
    };
    Choice.prototype.toString = function () {
        return this.options[0].value;
    };
    Choice.prototype.len = function () {
        return this.options[0].len();
    };
    Choice.prototype.clone = function () {
        var ret = new Choice();
        this.options.forEach(ret.appendChild, ret);
        return ret;
    };
    return Choice;
}(Marker));

var Transform = /** @class */ (function (_super) {
    __extends(Transform, _super);
    function Transform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Transform.prototype.resolve = function (value) {
        var _this = this;
        return value.replace(this.regexp, function () {
            var ret = '';
            for (var _i = 0, _a = _this._children; _i < _a.length; _i++) {
                var marker = _a[_i];
                if (marker instanceof FormatString) {
                    var value_1 = arguments.length - 2 > marker.index ? arguments[marker.index] : '';
                    value_1 = marker.resolve(value_1);
                    ret += value_1;
                }
                else {
                    ret += marker.toString();
                }
            }
            return ret;
        });
    };
    Transform.prototype.toString = function () {
        return '';
    };
    Transform.prototype.clone = function () {
        var ret = new Transform();
        ret.regexp = new RegExp(this.regexp.source, '' + (this.regexp.ignoreCase ? 'i' : '') + (this.regexp.global ? 'g' : ''));
        ret._children = this.children.map(function (child) { return child.clone(); });
        return ret;
    };
    return Transform;
}(Marker));

var FormatString = /** @class */ (function (_super) {
    __extends(FormatString, _super);
    function FormatString(index, shorthandName, ifValue, elseValue) {
        var _this_1 = _super.call(this) || this;
        _this_1.index = index;
        _this_1.shorthandName = shorthandName;
        _this_1.ifValue = ifValue;
        _this_1.elseValue = elseValue;
        return _this_1;
    }
    FormatString.prototype.resolve = function (value) {
        if (this.shorthandName === 'upcase') {
            return !value ? '' : value.toLocaleUpperCase();
        }
        else if (this.shorthandName === 'downcase') {
            return !value ? '' : value.toLocaleLowerCase();
        }
        else if (this.shorthandName === 'capitalize') {
            return !value ? '' : (value[0].toLocaleUpperCase() + value.substr(1));
        }
        else if (Boolean(value) && typeof this.ifValue === 'string') {
            return this.ifValue;
        }
        else if (!Boolean(value) && typeof this.elseValue === 'string') {
            return this.elseValue;
        }
        else {
            return value || '';
        }
    };
    FormatString.prototype.clone = function () {
        var ret = new FormatString(this.index, this.shorthandName, this.ifValue, this.elseValue);
        return ret;
    };
    return FormatString;
}(Marker));

var Variable = /** @class */ (function (_super) {
    __extends(Variable, _super);
    function Variable(name) {
        var _this_1 = _super.call(this) || this;
        _this_1.name = name;
        return _this_1;
    }
    Variable.prototype.resolve = function (resolver) {
        var value = resolver.resolve(this);
        if (this.transform) {
            value = this.transform.resolve(value || '');
        }
        if (value !== undefined) {
            this._children = [new Text(value)];
            return true;
        }
        return false;
    };
    Variable.prototype.clone = function () {
        var ret = new Variable(this.name);
        if (this.transform) {
            ret.transform = this.transform.clone();
        }
        ret._children = this.children.map(function (child) { return child.clone(); });
        return ret;
    };
    return Variable;
}(TransformableMarker));

function walk(marker, visitor) {
    var stack = marker.slice();
    while (stack.length > 0) {
        var marker_1 = stack.shift();
        var recurse = visitor(marker_1);
        if (!recurse) {
            break;
        }
        stack.unshift.apply(stack, marker_1.children);
    }
}
var TextmateSnippet = /** @class */ (function (_super) {
    __extends(TextmateSnippet, _super);
    function TextmateSnippet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextmateSnippet.prototype, "placeholderInfo", {
        get: function () {
            if (!this._placeholders) {
                // fill in placeholders
                var all_1 = [];
                var last_1;
                this.walk(function (candidate) {
                    if (candidate instanceof Placeholder) {
                        all_1.push(candidate);
                        last_1 = !last_1 || last_1.index < candidate.index ? candidate : last_1;
                    }
                    return true;
                });
                this._placeholders = { all: all_1, last: last_1 };
            }
            return this._placeholders;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextmateSnippet.prototype, "placeholders", {
        get: function () {
            var all = this.placeholderInfo.all;
            return all;
        },
        enumerable: true,
        configurable: true
    });
    TextmateSnippet.prototype.offset = function (marker) {
        var pos = 0;
        var found = false;
        this.walk(function (candidate) {
            if (candidate === marker) {
                found = true;
                return false;
            }
            pos += candidate.len();
            return true;
        });
        if (!found) {
            return -1;
        }
        return pos;
    };
    TextmateSnippet.prototype.fullLen = function (marker) {
        var ret = 0;
        walk([marker], function (marker) {
            ret += marker.len();
            return true;
        });
        return ret;
    };
    TextmateSnippet.prototype.enclosingPlaceholders = function (placeholder) {
        var ret = [];
        var parent = placeholder.parent;
        while (parent) {
            if (parent instanceof Placeholder) {
                ret.push(parent);
            }
            parent = parent.parent;
        }
        return ret;
    };
    TextmateSnippet.prototype.resolveVariables = function (resolver) {
        var _this_1 = this;
        this.walk(function (candidate) {
            if (candidate instanceof Variable) {
                if (candidate.resolve(resolver)) {
                    _this_1._placeholders = undefined;
                }
            }
            return true;
        });
        return this;
    };
    TextmateSnippet.prototype.appendChild = function (child) {
        this._placeholders = undefined;
        return _super.prototype.appendChild.call(this, child);
    };
    TextmateSnippet.prototype.replace = function (child, others) {
        this._placeholders = undefined;
        return _super.prototype.replace.call(this, child, others);
    };
    TextmateSnippet.prototype.clone = function () {
        var ret = new TextmateSnippet();
        this._children = this.children.map(function (child) { return child.clone(); });
        return ret;
    };
    TextmateSnippet.prototype.walk = function (visitor) {
        walk(this.children, visitor);
    };
    return TextmateSnippet;
}(Marker));

var SnippetParser = /** @class */ (function () {
    function SnippetParser() {
        this._scanner = new Scanner();
    }
    SnippetParser.escape = function (value) {
        return value.replace(/\$|}|\\/g, '\\$&');
    };
    SnippetParser.prototype.parse = function (value, insertFinalTabstop, enforceFinalTabstop) {
        this._scanner.text(value);
        this._token = this._scanner.next();
        var snippet = new TextmateSnippet();
        while (this._parse(snippet)) {
            // nothing
        }
        // fill in values for placeholders. the first placeholder of an index
        // that has a value defines the value for all placeholders with that index
        var placeholderDefaultValues = new Map();
        var incompletePlaceholders = [];
        var placeholderCount = 0;
        snippet.walk(function (marker) {
            if (marker instanceof Placeholder) {
                placeholderCount += 1;
                if (marker.isFinalTabstop) {
                    placeholderDefaultValues.set(0, undefined);
                }
                else if (!placeholderDefaultValues.has(marker.index) && marker.children.length > 0) {
                    placeholderDefaultValues.set(marker.index, marker.children);
                }
                else {
                    incompletePlaceholders.push(marker);
                }
            }
            return true;
        });
        for (var _i = 0, incompletePlaceholders_1 = incompletePlaceholders; _i < incompletePlaceholders_1.length; _i++) {
            var placeholder = incompletePlaceholders_1[_i];
            if (placeholderDefaultValues.has(placeholder.index)) {
                var clone = new Placeholder(placeholder.index);
                clone.transform = placeholder.transform;
                for (var _a = 0, _b = placeholderDefaultValues.get(placeholder.index); _a < _b.length; _a++) {
                    var child = _b[_a];
                    clone.appendChild(child.clone());
                }
                snippet.replace(placeholder, [clone]);
            }
        }
        if (!enforceFinalTabstop) {
            enforceFinalTabstop = placeholderCount > 0 && insertFinalTabstop;
        }
        if (!placeholderDefaultValues.has(0) && enforceFinalTabstop) {
            // the snippet uses placeholders but has no
            // final tabstop defined -> insert at the end
            snippet.appendChild(new Placeholder(0));
        }
        return snippet;
    };
    SnippetParser.prototype._accept = function (type, value) {
        if (type === undefined || this._token.type === type) {
            var ret = !value ? true : this._scanner.tokenText(this._token);
            this._token = this._scanner.next();
            return ret;
        }
        return false;
    };
    SnippetParser.prototype._backTo = function (token) {
        this._scanner.pos = token.pos + token.len;
        this._token = token;
        return false;
    };
    SnippetParser.prototype._until = function (type) {
        if (this._token.type === 14 /* EOF */) {
            return false;
        }
        var start = this._token;
        while (this._token.type !== type) {
            this._token = this._scanner.next();
            if (this._token.type === 14 /* EOF */) {
                return false;
            }
        }
        var value = this._scanner.value.substring(start.pos, this._token.pos);
        this._token = this._scanner.next();
        return value;
    };
    SnippetParser.prototype._parse = function (marker) {
        return this._parseEscaped(marker)
            || this._parseTabstopOrVariableName(marker)
            || this._parseComplexPlaceholder(marker)
            || this._parseComplexVariable(marker)
            || this._parseAnything(marker);
    };
    // \$, \\, \} -> just text
    SnippetParser.prototype._parseEscaped = function (marker) {
        var value;
        if (value = this._accept(5 /* Backslash */, true)) {
            // saw a backslash, append escaped token or that backslash
            value = this._accept(0 /* Dollar */, true)
                || this._accept(4 /* CurlyClose */, true)
                || this._accept(5 /* Backslash */, true)
                || value;
            marker.appendChild(new Text(value));
            return true;
        }
        return false;
    };
    // $foo -> variable, $1 -> tabstop
    SnippetParser.prototype._parseTabstopOrVariableName = function (parent) {
        var value;
        var token = this._token;
        var match = this._accept(0 /* Dollar */)
            && (value = this._accept(9 /* VariableName */, true) || this._accept(8 /* Int */, true));
        if (!match) {
            return this._backTo(token);
        }
        parent.appendChild(/^\d+$/.test(value)
            ? new Placeholder(Number(value))
            : new Variable(value));
        return true;
    };
    // ${1:<children>}, ${1} -> placeholder
    SnippetParser.prototype._parseComplexPlaceholder = function (parent) {
        var index;
        var token = this._token;
        var match = this._accept(0 /* Dollar */)
            && this._accept(3 /* CurlyOpen */)
            && (index = this._accept(8 /* Int */, true));
        if (!match) {
            return this._backTo(token);
        }
        var placeholder = new Placeholder(Number(index));
        if (this._accept(1 /* Colon */)) {
            // ${1:<children>}
            while (true) {
                // ...} -> done
                if (this._accept(4 /* CurlyClose */)) {
                    parent.appendChild(placeholder);
                    return true;
                }
                if (this._parse(placeholder)) {
                    continue;
                }
                // fallback
                parent.appendChild(new Text('${' + index + ':'));
                placeholder.children.forEach(parent.appendChild, parent);
                return true;
            }
        }
        else if (placeholder.index > 0 && this._accept(7 /* Pipe */)) {
            // ${1|one,two,three|}
            var choice = new Choice();
            while (true) {
                if (this._parseChoiceElement(choice)) {
                    if (this._accept(2 /* Comma */)) {
                        // opt, -> more
                        continue;
                    }
                    if (this._accept(7 /* Pipe */)) {
                        placeholder.appendChild(choice);
                        if (this._accept(4 /* CurlyClose */)) {
                            // ..|} -> done
                            parent.appendChild(placeholder);
                            return true;
                        }
                    }
                }
                this._backTo(token);
                return false;
            }
        }
        else if (this._accept(6 /* Forwardslash */)) {
            // ${1/<regex>/<format>/<options>}
            if (this._parseTransform(placeholder)) {
                parent.appendChild(placeholder);
                return true;
            }
            this._backTo(token);
            return false;
        }
        else if (this._accept(4 /* CurlyClose */)) {
            // ${1}
            parent.appendChild(placeholder);
            return true;
        }
        else {
            // ${1 <- missing curly or colon
            return this._backTo(token);
        }
    };
    SnippetParser.prototype._parseChoiceElement = function (parent) {
        var token = this._token;
        var values = [];
        while (true) {
            if (this._token.type === 2 /* Comma */ || this._token.type === 7 /* Pipe */) {
                break;
            }
            var value = void 0;
            if (value = this._accept(5 /* Backslash */, true)) {
                // \, or \|
                value = this._accept(2 /* Comma */, true)
                    || this._accept(7 /* Pipe */, true)
                    || value;
            }
            else {
                value = this._accept(undefined, true);
            }
            if (!value) {
                // EOF
                this._backTo(token);
                return false;
            }
            values.push(value);
        }
        if (values.length === 0) {
            this._backTo(token);
            return false;
        }
        parent.appendChild(new Text(values.join('')));
        return true;
    };
    // ${foo:<children>}, ${foo} -> variable
    SnippetParser.prototype._parseComplexVariable = function (parent) {
        var name;
        var token = this._token;
        var match = this._accept(0 /* Dollar */)
            && this._accept(3 /* CurlyOpen */)
            && (name = this._accept(9 /* VariableName */, true));
        if (!match) {
            return this._backTo(token);
        }
        var variable = new Variable(name);
        if (this._accept(1 /* Colon */)) {
            // ${foo:<children>}
            while (true) {
                // ...} -> done
                if (this._accept(4 /* CurlyClose */)) {
                    parent.appendChild(variable);
                    return true;
                }
                if (this._parse(variable)) {
                    continue;
                }
                // fallback
                parent.appendChild(new Text('${' + name + ':'));
                variable.children.forEach(parent.appendChild, parent);
                return true;
            }
        }
        else if (this._accept(6 /* Forwardslash */)) {
            // ${foo/<regex>/<format>/<options>}
            if (this._parseTransform(variable)) {
                parent.appendChild(variable);
                return true;
            }
            this._backTo(token);
            return false;
        }
        else if (this._accept(4 /* CurlyClose */)) {
            // ${foo}
            parent.appendChild(variable);
            return true;
        }
        else {
            // ${foo <- missing curly or colon
            return this._backTo(token);
        }
    };
    SnippetParser.prototype._parseTransform = function (parent) {
        // ...<regex>/<format>/<options>}
        var transform = new Transform();
        var regexValue = '';
        var regexOptions = '';
        // (1) /regex
        while (true) {
            if (this._accept(6 /* Forwardslash */)) {
                break;
            }
            var escaped = void 0;
            if (escaped = this._accept(5 /* Backslash */, true)) {
                escaped = this._accept(6 /* Forwardslash */, true) || escaped;
                regexValue += escaped;
                continue;
            }
            if (this._token.type !== 14 /* EOF */) {
                regexValue += this._accept(undefined, true);
                continue;
            }
            return false;
        }
        // (2) /format
        while (true) {
            if (this._accept(6 /* Forwardslash */)) {
                break;
            }
            var escaped = void 0;
            if (escaped = this._accept(5 /* Backslash */, true)) {
                escaped = this._accept(6 /* Forwardslash */, true) || escaped;
                transform.appendChild(new Text(escaped));
                continue;
            }
            if (this._parseFormatString(transform) || this._parseAnything(transform)) {
                continue;
            }
            return false;
        }
        // (3) /option
        while (true) {
            if (this._accept(4 /* CurlyClose */)) {
                break;
            }
            if (this._token.type !== 14 /* EOF */) {
                regexOptions += this._accept(undefined, true);
                continue;
            }
            return false;
        }
        try {
            transform.regexp = new RegExp(regexValue, regexOptions);
        }
        catch (e) {
            // invalid regexp
            return false;
        }
        parent.transform = transform;
        return true;
    };
    SnippetParser.prototype._parseFormatString = function (parent) {
        var token = this._token;
        if (!this._accept(0 /* Dollar */)) {
            return false;
        }
        var complex = false;
        if (this._accept(3 /* CurlyOpen */)) {
            complex = true;
        }
        var index = this._accept(8 /* Int */, true);
        if (!index) {
            this._backTo(token);
            return false;
        }
        else if (!complex) {
            // $1
            parent.appendChild(new FormatString(Number(index)));
            return true;
        }
        else if (this._accept(4 /* CurlyClose */)) {
            // ${1}
            parent.appendChild(new FormatString(Number(index)));
            return true;
        }
        else if (!this._accept(1 /* Colon */)) {
            this._backTo(token);
            return false;
        }
        if (this._accept(6 /* Forwardslash */)) {
            // ${1:/upcase}
            var shorthand = this._accept(9 /* VariableName */, true);
            if (!shorthand || !this._accept(4 /* CurlyClose */)) {
                this._backTo(token);
                return false;
            }
            else {
                parent.appendChild(new FormatString(Number(index), shorthand));
                return true;
            }
        }
        else if (this._accept(11 /* Plus */)) {
            // ${1:+<if>}
            var ifValue = this._until(4 /* CurlyClose */);
            if (ifValue) {
                parent.appendChild(new FormatString(Number(index), undefined, ifValue, undefined));
                return true;
            }
        }
        else if (this._accept(12 /* Dash */)) {
            // ${2:-<else>}
            var elseValue = this._until(4 /* CurlyClose */);
            if (elseValue) {
                parent.appendChild(new FormatString(Number(index), undefined, undefined, elseValue));
                return true;
            }
        }
        else if (this._accept(13 /* QuestionMark */)) {
            // ${2:?<if>:<else>}
            var ifValue = this._until(1 /* Colon */);
            if (ifValue) {
                var elseValue = this._until(4 /* CurlyClose */);
                if (elseValue) {
                    parent.appendChild(new FormatString(Number(index), undefined, ifValue, elseValue));
                    return true;
                }
            }
        }
        else {
            // ${1:<else>}
            var elseValue = this._until(4 /* CurlyClose */);
            if (elseValue) {
                parent.appendChild(new FormatString(Number(index), undefined, undefined, elseValue));
                return true;
            }
        }
        this._backTo(token);
        return false;
    };
    SnippetParser.prototype._parseAnything = function (marker) {
        if (this._token.type !== 14 /* EOF */) {
            marker.appendChild(new Text(this._scanner.tokenText(this._token)));
            this._accept(undefined);
            return true;
        }
        return false;
    };
    return SnippetParser;
}());



/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ILogService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NullLogService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ILogService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('logService');
var NullLogService = /** @class */ (function () {
    function NullLogService() {
    }
    NullLogService.prototype.trace = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
    };
    NullLogService.prototype.error = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
    };
    NullLogService.prototype.dispose = function () { };
    return NullLogService;
}());



/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SuggestController", function() { return SuggestController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TriggerSuggestAction", function() { return TriggerSuggestAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__snippet_snippetParser_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__snippet_snippetController2_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__suggest_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__suggestModel_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__suggestWidget_js__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__suggestMemory_js__ = __webpack_require__(511);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


















var AcceptOnCharacterOracle = /** @class */ (function () {
    function AcceptOnCharacterOracle(editor, widget, accept) {
        var _this = this;
        this._disposables = [];
        this._activeAcceptCharacters = new Set();
        this._disposables.push(widget.onDidShow(function () { return _this._onItem(widget.getFocusedItem()); }));
        this._disposables.push(widget.onDidFocus(this._onItem, this));
        this._disposables.push(widget.onDidHide(this.reset, this));
        this._disposables.push(editor.onWillType(function (text) {
            if (_this._activeItem) {
                var ch = text[text.length - 1];
                if (_this._activeAcceptCharacters.has(ch) && editor.getConfiguration().contribInfo.acceptSuggestionOnCommitCharacter) {
                    accept(_this._activeItem);
                }
            }
        }));
    }
    AcceptOnCharacterOracle.prototype._onItem = function (selected) {
        if (!selected || Object(__WEBPACK_IMPORTED_MODULE_2__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(selected.item.suggestion.commitCharacters)) {
            this.reset();
            return;
        }
        this._activeItem = selected;
        this._activeAcceptCharacters.clear();
        for (var _i = 0, _a = selected.item.suggestion.commitCharacters; _i < _a.length; _i++) {
            var ch = _a[_i];
            if (ch.length > 0) {
                this._activeAcceptCharacters.add(ch[0]);
            }
        }
    };
    AcceptOnCharacterOracle.prototype.reset = function () {
        this._activeItem = undefined;
    };
    AcceptOnCharacterOracle.prototype.dispose = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
    };
    return AcceptOnCharacterOracle;
}());
var SuggestController = /** @class */ (function () {
    function SuggestController(_editor, _commandService, _contextKeyService, _instantiationService) {
        var _this = this;
        this._editor = _editor;
        this._commandService = _commandService;
        this._contextKeyService = _contextKeyService;
        this._instantiationService = _instantiationService;
        this._toDispose = [];
        this._model = new __WEBPACK_IMPORTED_MODULE_15__suggestModel_js__["a" /* SuggestModel */](this._editor);
        this._memory = _instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_17__suggestMemory_js__["a" /* SuggestMemories */], this._editor.getConfiguration().contribInfo.suggestSelection);
        this._toDispose.push(this._model.onDidTrigger(function (e) {
            if (!_this._widget) {
                _this._createSuggestWidget();
            }
            _this._widget.showTriggered(e.auto);
        }));
        this._toDispose.push(this._model.onDidSuggest(function (e) {
            var index = _this._memory.select(_this._editor.getModel(), _this._editor.getPosition(), e.completionModel.items);
            _this._widget.showSuggestions(e.completionModel, index, e.isFrozen, e.auto);
        }));
        this._toDispose.push(this._model.onDidCancel(function (e) {
            if (_this._widget && !e.retrigger) {
                _this._widget.hideWidget();
            }
        }));
        // Manage the acceptSuggestionsOnEnter context key
        var acceptSuggestionsOnEnter = __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].AcceptSuggestionsOnEnter.bindTo(_contextKeyService);
        var updateFromConfig = function () {
            var _a = _this._editor.getConfiguration().contribInfo, acceptSuggestionOnEnter = _a.acceptSuggestionOnEnter, suggestSelection = _a.suggestSelection;
            acceptSuggestionsOnEnter.set(acceptSuggestionOnEnter === 'on' || acceptSuggestionOnEnter === 'smart');
            _this._memory.setMode(suggestSelection);
        };
        this._toDispose.push(this._editor.onDidChangeConfiguration(function (e) { return updateFromConfig(); }));
        updateFromConfig();
    }
    SuggestController.get = function (editor) {
        return editor.getContribution(SuggestController.ID);
    };
    SuggestController.prototype._createSuggestWidget = function () {
        var _this = this;
        this._widget = this._instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_16__suggestWidget_js__["a" /* SuggestWidget */], this._editor);
        this._toDispose.push(this._widget.onDidSelect(this._onDidSelectItem, this));
        // Wire up logic to accept a suggestion on certain characters
        var autoAcceptOracle = new AcceptOnCharacterOracle(this._editor, this._widget, function (item) { return _this._onDidSelectItem(item); });
        this._toDispose.push(autoAcceptOracle, this._model.onDidSuggest(function (e) {
            if (e.completionModel.items.length === 0) {
                autoAcceptOracle.reset();
            }
        }));
        var makesTextEdit = __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MakesTextEdit.bindTo(this._contextKeyService);
        this._toDispose.push(this._widget.onDidFocus(function (_a) {
            var item = _a.item;
            var position = _this._editor.getPosition();
            var startColumn = item.position.column - item.suggestion.overwriteBefore;
            var endColumn = position.column;
            var value = true;
            if (_this._editor.getConfiguration().contribInfo.acceptSuggestionOnEnter === 'smart'
                && _this._model.state === 2 /* Auto */
                && !item.suggestion.command
                && !item.suggestion.additionalTextEdits
                && item.suggestion.snippetType !== 'textmate'
                && endColumn - startColumn === item.suggestion.insertText.length) {
                var oldText = _this._editor.getModel().getValueInRange({
                    startLineNumber: position.lineNumber,
                    startColumn: startColumn,
                    endLineNumber: position.lineNumber,
                    endColumn: endColumn
                });
                value = oldText !== item.suggestion.insertText;
            }
            makesTextEdit.set(value);
        }));
        this._toDispose.push({
            dispose: function () { makesTextEdit.reset(); }
        });
    };
    SuggestController.prototype.getId = function () {
        return SuggestController.ID;
    };
    SuggestController.prototype.dispose = function () {
        this._toDispose = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._toDispose);
        if (this._widget) {
            this._widget.dispose();
            this._widget = null;
        }
        if (this._model) {
            this._model.dispose();
            this._model = null;
        }
    };
    SuggestController.prototype._onDidSelectItem = function (event) {
        var _a;
        if (!event || !event.item) {
            this._model.cancel();
            return;
        }
        var _b = event.item, suggestion = _b.suggestion, position = _b.position;
        var editorColumn = this._editor.getPosition().column;
        var columnDelta = editorColumn - position.column;
        // pushing undo stops *before* additional text edits and
        // *after* the main edit
        this._editor.pushUndoStop();
        if (Array.isArray(suggestion.additionalTextEdits)) {
            this._editor.executeEdits('suggestController.additionalTextEdits', suggestion.additionalTextEdits.map(function (edit) { return __WEBPACK_IMPORTED_MODULE_10__common_core_editOperation_js__["a" /* EditOperation */].replace(__WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */].lift(edit.range), edit.text); }));
        }
        // keep item in memory
        this._memory.memorize(this._editor.getModel(), this._editor.getPosition(), event.item);
        var insertText = suggestion.insertText;
        if (suggestion.snippetType !== 'textmate') {
            insertText = __WEBPACK_IMPORTED_MODULE_12__snippet_snippetParser_js__["c" /* SnippetParser */].escape(insertText);
        }
        __WEBPACK_IMPORTED_MODULE_13__snippet_snippetController2_js__["SnippetController2"].get(this._editor).insert(insertText, suggestion.overwriteBefore + columnDelta, suggestion.overwriteAfter, false, false);
        this._editor.pushUndoStop();
        if (!suggestion.command) {
            // done
            this._model.cancel();
        }
        else if (suggestion.command.id === TriggerSuggestAction.id) {
            // retigger
            this._model.trigger({ auto: true }, true);
        }
        else {
            // exec command, done
            (_a = this._commandService).executeCommand.apply(_a, [suggestion.command.id].concat(suggestion.command.arguments)).done(undefined, __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */]);
            this._model.cancel();
        }
        this._alertCompletionItem(event.item);
    };
    SuggestController.prototype._alertCompletionItem = function (_a) {
        var suggestion = _a.suggestion;
        var msg = __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('arai.alert.snippet', "Accepting '{0}' did insert the following text: {1}", suggestion.label, suggestion.insertText);
        Object(__WEBPACK_IMPORTED_MODULE_9__base_browser_ui_aria_aria_js__["a" /* alert */])(msg);
    };
    SuggestController.prototype.triggerSuggest = function (onlyFrom) {
        this._model.trigger({ auto: false }, false, onlyFrom);
        this._editor.revealLine(this._editor.getPosition().lineNumber, 0 /* Smooth */);
        this._editor.focus();
    };
    SuggestController.prototype.acceptSelectedSuggestion = function () {
        if (this._widget) {
            var item = this._widget.getFocusedItem();
            this._onDidSelectItem(item);
        }
    };
    SuggestController.prototype.cancelSuggestWidget = function () {
        if (this._widget) {
            this._model.cancel();
            this._widget.hideWidget();
        }
    };
    SuggestController.prototype.selectNextSuggestion = function () {
        if (this._widget) {
            this._widget.selectNext();
        }
    };
    SuggestController.prototype.selectNextPageSuggestion = function () {
        if (this._widget) {
            this._widget.selectNextPage();
        }
    };
    SuggestController.prototype.selectLastSuggestion = function () {
        if (this._widget) {
            this._widget.selectLast();
        }
    };
    SuggestController.prototype.selectPrevSuggestion = function () {
        if (this._widget) {
            this._widget.selectPrevious();
        }
    };
    SuggestController.prototype.selectPrevPageSuggestion = function () {
        if (this._widget) {
            this._widget.selectPreviousPage();
        }
    };
    SuggestController.prototype.selectFirstSuggestion = function () {
        if (this._widget) {
            this._widget.selectFirst();
        }
    };
    SuggestController.prototype.toggleSuggestionDetails = function () {
        if (this._widget) {
            this._widget.toggleDetails();
        }
    };
    SuggestController.prototype.toggleSuggestionFocus = function () {
        if (this._widget) {
            this._widget.toggleDetailsFocus();
        }
    };
    SuggestController.ID = 'editor.contrib.suggestController';
    SuggestController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_6__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_4__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */])
    ], SuggestController);
    return SuggestController;
}());

var TriggerSuggestAction = /** @class */ (function (_super) {
    __extends(TriggerSuggestAction, _super);
    function TriggerSuggestAction() {
        return _super.call(this, {
            id: TriggerSuggestAction.id,
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('suggest.trigger.label', "Trigger Suggest"),
            alias: 'Trigger Suggest',
            precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCompletionItemProvider),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 2048 /* CtrlCmd */ | 10 /* Space */,
                mac: { primary: 256 /* WinCtrl */ | 10 /* Space */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    TriggerSuggestAction.prototype.run = function (accessor, editor) {
        var controller = SuggestController.get(editor);
        if (!controller) {
            return;
        }
        controller.triggerSuggest();
    };
    TriggerSuggestAction.id = 'editor.action.triggerSuggest';
    return TriggerSuggestAction;
}(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["b" /* EditorAction */]));

Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["h" /* registerEditorContribution */])(SuggestController);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["f" /* registerEditorAction */])(TriggerSuggestAction);
var weight = 100 /* EditorContrib */ + 90;
var SuggestCommand = __WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["c" /* EditorCommand */].bindToContribution(SuggestController.get);
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'acceptSelectedSuggestion',
    precondition: __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible,
    handler: function (x) { return x.acceptSelectedSuggestion(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 2 /* Tab */
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'acceptSelectedSuggestionOnEnter',
    precondition: __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible,
    handler: function (x) { return x.acceptSelectedSuggestion(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].AcceptSuggestionsOnEnter, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MakesTextEdit),
        primary: 3 /* Enter */
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'hideSuggestWidget',
    precondition: __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible,
    handler: function (x) { return x.cancelSuggestWidget(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 9 /* Escape */,
        secondary: [1024 /* Shift */ | 9 /* Escape */]
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'selectNextSuggestion',
    precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MultipleSuggestions),
    handler: function (c) { return c.selectNextSuggestion(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 18 /* DownArrow */,
        secondary: [2048 /* CtrlCmd */ | 18 /* DownArrow */],
        mac: { primary: 18 /* DownArrow */, secondary: [2048 /* CtrlCmd */ | 18 /* DownArrow */, 256 /* WinCtrl */ | 44 /* KEY_N */] }
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'selectNextPageSuggestion',
    precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MultipleSuggestions),
    handler: function (c) { return c.selectNextPageSuggestion(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 12 /* PageDown */,
        secondary: [2048 /* CtrlCmd */ | 12 /* PageDown */]
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'selectLastSuggestion',
    precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MultipleSuggestions),
    handler: function (c) { return c.selectLastSuggestion(); }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'selectPrevSuggestion',
    precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MultipleSuggestions),
    handler: function (c) { return c.selectPrevSuggestion(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 16 /* UpArrow */,
        secondary: [2048 /* CtrlCmd */ | 16 /* UpArrow */],
        mac: { primary: 16 /* UpArrow */, secondary: [2048 /* CtrlCmd */ | 16 /* UpArrow */, 256 /* WinCtrl */ | 46 /* KEY_P */] }
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'selectPrevPageSuggestion',
    precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MultipleSuggestions),
    handler: function (c) { return c.selectPrevPageSuggestion(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 11 /* PageUp */,
        secondary: [2048 /* CtrlCmd */ | 11 /* PageUp */]
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'selectFirstSuggestion',
    precondition: __WEBPACK_IMPORTED_MODULE_5__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible, __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MultipleSuggestions),
    handler: function (c) { return c.selectFirstSuggestion(); }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'toggleSuggestionDetails',
    precondition: __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible,
    handler: function (x) { return x.toggleSuggestionDetails(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 2048 /* CtrlCmd */ | 10 /* Space */,
        mac: { primary: 256 /* WinCtrl */ | 10 /* Space */ }
    }
}));
Object(__WEBPACK_IMPORTED_MODULE_8__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new SuggestCommand({
    id: 'toggleSuggestionFocus',
    precondition: __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible,
    handler: function (x) { return x.toggleSuggestionFocus(); },
    kbOpts: {
        weight: weight,
        kbExpr: __WEBPACK_IMPORTED_MODULE_7__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
        primary: 2048 /* CtrlCmd */ | 512 /* Alt */ | 10 /* Space */,
        mac: { primary: 256 /* WinCtrl */ | 512 /* Alt */ | 10 /* Space */ }
    }
}));


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_standaloneThemeService_js__ = __webpack_require__(88);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ToggleHighContrast = /** @class */ (function (_super) {
    __extends(ToggleHighContrast, _super);
    function ToggleHighContrast() {
        var _this = _super.call(this, {
            id: 'editor.action.toggleHighContrast',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('toggleHighContrast', "Toggle High Contrast Theme"),
            alias: 'Toggle High Contrast Theme',
            precondition: null
        }) || this;
        _this._originalThemeName = null;
        return _this;
    }
    ToggleHighContrast.prototype.run = function (accessor, editor) {
        var standaloneThemeService = accessor.get(__WEBPACK_IMPORTED_MODULE_2__common_standaloneThemeService_js__["a" /* IStandaloneThemeService */]);
        if (this._originalThemeName) {
            // We must toggle back to the integrator's theme
            standaloneThemeService.setTheme(this._originalThemeName);
            this._originalThemeName = null;
        }
        else {
            this._originalThemeName = standaloneThemeService.getTheme().themeName;
            standaloneThemeService.setTheme('hc-black');
        }
    };
    return ToggleHighContrast;
}(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["f" /* registerEditorAction */])(ToggleHighContrast);


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__ = __webpack_require__(73);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var TransposeLettersAction = /** @class */ (function (_super) {
    __extends(TransposeLettersAction, _super);
    function TransposeLettersAction() {
        return _super.call(this, {
            id: 'editor.action.transposeLetters',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('transposeLetters.label', "Transpose Letters"),
            alias: 'Transpose Letters',
            precondition: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_4__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 0,
                mac: {
                    primary: 256 /* WinCtrl */ | 50 /* KEY_T */
                },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    TransposeLettersAction.prototype.positionLeftOf = function (start, model) {
        var column = start.column;
        var lineNumber = start.lineNumber;
        if (column > model.getLineMinColumn(lineNumber)) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isLowSurrogate"])(model.getLineContent(lineNumber).charCodeAt(column - 2))) {
                // character before column is a low surrogate
                column = column - 2;
            }
            else {
                column = column - 1;
            }
        }
        else if (lineNumber > 1) {
            lineNumber = lineNumber - 1;
            column = model.getLineMaxColumn(lineNumber);
        }
        return new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](lineNumber, column);
    };
    TransposeLettersAction.prototype.positionRightOf = function (start, model) {
        var column = start.column;
        var lineNumber = start.lineNumber;
        if (column < model.getLineMaxColumn(lineNumber)) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isHighSurrogate"])(model.getLineContent(lineNumber).charCodeAt(column - 1))) {
                // character after column is a high surrogate
                column = column + 2;
            }
            else {
                column = column + 1;
            }
        }
        else if (lineNumber < model.getLineCount()) {
            lineNumber = lineNumber + 1;
            column = 0;
        }
        return new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](lineNumber, column);
    };
    TransposeLettersAction.prototype.run = function (accessor, editor) {
        var model = editor.getModel();
        var commands = [];
        var selections = editor.getSelections();
        for (var _i = 0, selections_1 = selections; _i < selections_1.length; _i++) {
            var selection = selections_1[_i];
            if (!selection.isEmpty()) {
                continue;
            }
            var lineNumber = selection.startLineNumber;
            var column = selection.startColumn;
            var lastColumn = model.getLineMaxColumn(lineNumber);
            if (lineNumber === 1 && (column === 1 || (column === 2 && lastColumn === 2))) {
                // at beginning of file, nothing to do
                continue;
            }
            // handle special case: when at end of line, transpose left two chars
            // otherwise, transpose left and right chars
            var endPosition = (column === lastColumn) ?
                selection.getPosition() :
                this.positionRightOf(selection.getPosition(), model);
            var middlePosition = this.positionLeftOf(endPosition, model);
            var beginPosition = this.positionLeftOf(middlePosition, model);
            var leftChar = model.getValueInRange(__WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].fromPositions(beginPosition, middlePosition));
            var rightChar = model.getValueInRange(__WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].fromPositions(middlePosition, endPosition));
            var replaceRange = __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].fromPositions(beginPosition, endPosition);
            commands.push(new __WEBPACK_IMPORTED_MODULE_6__common_commands_replaceCommand_js__["a" /* ReplaceCommand */](replaceRange, rightChar + leftChar));
        }
        if (commands.length > 0) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, commands);
            editor.pushUndoStop();
        }
    };
    return TransposeLettersAction;
}(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["b" /* EditorAction */]));
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["f" /* registerEditorAction */])(TransposeLettersAction);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editorWordHighlight", function() { return editorWordHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editorWordHighlightStrong", function() { return editorWordHighlightStrong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editorWordHighlightBorder", function() { return editorWordHighlightBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editorWordHighlightStrongBorder", function() { return editorWordHighlightStrongBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overviewRulerWordHighlightForeground", function() { return overviewRulerWordHighlightForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overviewRulerWordHighlightStrongForeground", function() { return overviewRulerWordHighlightStrongForeground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ctxHasWordHighlights", function() { return ctxHasWordHighlights; });
/* harmony export (immutable) */ __webpack_exports__["getOccurrencesAtPosition"] = getOccurrencesAtPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
















var editorWordHighlight = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.wordHighlightBackground', { dark: '#575757B8', light: '#57575740', hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordHighlight', 'Background color of a symbol during read-access, like reading a variable. The color must not be opaque to not hide underlying decorations.'), true);
var editorWordHighlightStrong = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.wordHighlightStrongBackground', { dark: '#004972B8', light: '#0e639c40', hc: null }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordHighlightStrong', 'Background color of a symbol during write-access, like writing to a variable. The color must not be opaque to not hide underlying decorations.'), true);
var editorWordHighlightBorder = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.wordHighlightBorder', { light: null, dark: null, hc: __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["b" /* activeContrastBorder */] }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordHighlightBorder', 'Border color of a symbol during read-access, like reading a variable.'));
var editorWordHighlightStrongBorder = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editor.wordHighlightStrongBorder', { light: null, dark: null, hc: __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["b" /* activeContrastBorder */] }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordHighlightStrongBorder', 'Border color of a symbol during write-access, like writing to a variable.'));
var overviewRulerWordHighlightForeground = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorOverviewRuler.wordHighlightForeground', { dark: '#A0A0A0CC', light: '#A0A0A0CC', hc: '#A0A0A0CC' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overviewRulerWordHighlightForeground', 'Overview ruler marker color for symbol highlights. The color must not be opaque to not hide underlying decorations.'), true);
var overviewRulerWordHighlightStrongForeground = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorOverviewRuler.wordHighlightStrongForeground', { dark: '#C0A0C0CC', light: '#C0A0C0CC', hc: '#C0A0C0CC' }, __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('overviewRulerWordHighlightStrongForeground', 'Overview ruler marker color for write-access symbol highlights. The color must not be opaque to not hide underlying decorations.'), true);
var ctxHasWordHighlights = new __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('hasWordHighlights', false);
function getOccurrencesAtPosition(model, position, token) {
    var orderedByScore = __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["h" /* DocumentHighlightProviderRegistry */].ordered(model);
    // in order of score ask the occurrences provider
    // until someone response with a good result
    // (good = none empty array)
    return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["k" /* first2 */])(orderedByScore.map(function (provider) { return function () {
        return Promise.resolve(provider.provideDocumentHighlights(model, position, token))
            .then(undefined, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
    }; }), function (result) { return !Object(__WEBPACK_IMPORTED_MODULE_13__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(result); });
}
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeDocumentHighlights', function (model, position) { return getOccurrencesAtPosition(model, position, __WEBPACK_IMPORTED_MODULE_15__base_common_cancellation_js__["a" /* CancellationToken */].None); });
var WordHighlighter = /** @class */ (function () {
    function WordHighlighter(editor, contextKeyService) {
        var _this = this;
        this.workerRequestTokenId = 0;
        this.workerRequest = null;
        this.workerRequestCompleted = false;
        this.workerRequestValue = [];
        this.lastCursorPositionChangeTime = 0;
        this.renderDecorationsTimer = -1;
        this.editor = editor;
        this._hasWordHighlights = ctxHasWordHighlights.bindTo(contextKeyService);
        this._ignorePositionChangeEvent = false;
        this.occurrencesHighlight = this.editor.getConfiguration().contribInfo.occurrencesHighlight;
        this.model = this.editor.getModel();
        this.toUnhook = [];
        this.toUnhook.push(editor.onDidChangeCursorPosition(function (e) {
            if (_this._ignorePositionChangeEvent) {
                // We are changing the position => ignore this event
                return;
            }
            if (!_this.occurrencesHighlight) {
                // Early exit if nothing needs to be done!
                // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
                return;
            }
            _this._onPositionChanged(e);
        }));
        this.toUnhook.push(editor.onDidChangeModel(function (e) {
            _this._stopAll();
            _this.model = _this.editor.getModel();
        }));
        this.toUnhook.push(editor.onDidChangeModelContent(function (e) {
            _this._stopAll();
        }));
        this.toUnhook.push(editor.onDidChangeConfiguration(function (e) {
            var newValue = _this.editor.getConfiguration().contribInfo.occurrencesHighlight;
            if (_this.occurrencesHighlight !== newValue) {
                _this.occurrencesHighlight = newValue;
                _this._stopAll();
            }
        }));
        this._lastWordRange = null;
        this._decorationIds = [];
        this.workerRequestTokenId = 0;
        this.workerRequest = null;
        this.workerRequestCompleted = false;
        this.lastCursorPositionChangeTime = 0;
        this.renderDecorationsTimer = -1;
    }
    WordHighlighter.prototype.hasDecorations = function () {
        return (this._decorationIds.length > 0);
    };
    WordHighlighter.prototype.restore = function () {
        if (!this.occurrencesHighlight) {
            return;
        }
        this._run();
    };
    WordHighlighter.prototype._getSortedHighlights = function () {
        var _this = this;
        return this._decorationIds
            .map(function (id) { return _this.model.getDecorationRange(id); })
            .sort(__WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
    };
    WordHighlighter.prototype.moveNext = function () {
        var _this = this;
        var highlights = this._getSortedHighlights();
        var index = Object(__WEBPACK_IMPORTED_MODULE_13__base_common_arrays_js__["h" /* firstIndex */])(highlights, function (range) { return range.containsPosition(_this.editor.getPosition()); });
        var newIndex = ((index + 1) % highlights.length);
        var dest = highlights[newIndex];
        try {
            this._ignorePositionChangeEvent = true;
            this.editor.setPosition(dest.getStartPosition());
            this.editor.revealRangeInCenterIfOutsideViewport(dest);
        }
        finally {
            this._ignorePositionChangeEvent = false;
        }
    };
    WordHighlighter.prototype.moveBack = function () {
        var _this = this;
        var highlights = this._getSortedHighlights();
        var index = Object(__WEBPACK_IMPORTED_MODULE_13__base_common_arrays_js__["h" /* firstIndex */])(highlights, function (range) { return range.containsPosition(_this.editor.getPosition()); });
        var newIndex = ((index - 1 + highlights.length) % highlights.length);
        var dest = highlights[newIndex];
        try {
            this._ignorePositionChangeEvent = true;
            this.editor.setPosition(dest.getStartPosition());
            this.editor.revealRangeInCenterIfOutsideViewport(dest);
        }
        finally {
            this._ignorePositionChangeEvent = false;
        }
    };
    WordHighlighter.prototype._removeDecorations = function () {
        if (this._decorationIds.length > 0) {
            // remove decorations
            this._decorationIds = this.editor.deltaDecorations(this._decorationIds, []);
            this._hasWordHighlights.set(false);
        }
    };
    WordHighlighter.prototype._stopAll = function () {
        this._lastWordRange = null;
        // Remove any existing decorations
        this._removeDecorations();
        // Cancel any renderDecorationsTimer
        if (this.renderDecorationsTimer !== -1) {
            clearTimeout(this.renderDecorationsTimer);
            this.renderDecorationsTimer = -1;
        }
        // Cancel any worker request
        if (this.workerRequest !== null) {
            this.workerRequest.cancel();
            this.workerRequest = null;
        }
        // Invalidate any worker request callback
        if (!this.workerRequestCompleted) {
            this.workerRequestTokenId++;
            this.workerRequestCompleted = true;
        }
    };
    WordHighlighter.prototype._onPositionChanged = function (e) {
        // disabled
        if (!this.occurrencesHighlight) {
            this._stopAll();
            return;
        }
        // ignore typing & other
        if (e.reason !== __WEBPACK_IMPORTED_MODULE_9__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].Explicit) {
            this._stopAll();
            return;
        }
        this._run();
    };
    WordHighlighter.prototype._run = function () {
        var _this = this;
        // no providers for this model
        if (!__WEBPACK_IMPORTED_MODULE_5__common_modes_js__["h" /* DocumentHighlightProviderRegistry */].has(this.model)) {
            this._stopAll();
            return;
        }
        var editorSelection = this.editor.getSelection();
        // ignore multiline selection
        if (editorSelection.startLineNumber !== editorSelection.endLineNumber) {
            this._stopAll();
            return;
        }
        var lineNumber = editorSelection.startLineNumber;
        var startColumn = editorSelection.startColumn;
        var endColumn = editorSelection.endColumn;
        var word = this.model.getWordAtPosition({
            lineNumber: lineNumber,
            column: startColumn
        });
        // The selection must be inside a word or surround one word at most
        if (!word || word.startColumn > startColumn || word.endColumn < endColumn) {
            this._stopAll();
            return;
        }
        // All the effort below is trying to achieve this:
        // - when cursor is moved to a word, trigger immediately a findOccurrences request
        // - 250ms later after the last cursor move event, render the occurrences
        // - no flickering!
        var currentWordRange = new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](lineNumber, word.startColumn, lineNumber, word.endColumn);
        var workerRequestIsValid = this._lastWordRange && this._lastWordRange.equalsRange(currentWordRange);
        // Even if we are on a different word, if that word is in the decorations ranges, the request is still valid
        // (Same symbol)
        for (var i = 0, len = this._decorationIds.length; !workerRequestIsValid && i < len; i++) {
            var range = this.model.getDecorationRange(this._decorationIds[i]);
            if (range && range.startLineNumber === lineNumber) {
                if (range.startColumn <= startColumn && range.endColumn >= endColumn) {
                    workerRequestIsValid = true;
                }
            }
        }
        // There are 4 cases:
        // a) old workerRequest is valid & completed, renderDecorationsTimer fired
        // b) old workerRequest is valid & completed, renderDecorationsTimer not fired
        // c) old workerRequest is valid, but not completed
        // d) old workerRequest is not valid
        // For a) no action is needed
        // For c), member 'lastCursorPositionChangeTime' will be used when installing the timer so no action is needed
        this.lastCursorPositionChangeTime = (new Date()).getTime();
        if (workerRequestIsValid) {
            if (this.workerRequestCompleted && this.renderDecorationsTimer !== -1) {
                // case b)
                // Delay the firing of renderDecorationsTimer by an extra 250 ms
                clearTimeout(this.renderDecorationsTimer);
                this.renderDecorationsTimer = -1;
                this._beginRenderDecorations();
            }
        }
        else {
            // case d)
            // Stop all previous actions and start fresh
            this._stopAll();
            var myRequestId_1 = ++this.workerRequestTokenId;
            this.workerRequestCompleted = false;
            this.workerRequest = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return getOccurrencesAtPosition(_this.model, _this.editor.getPosition(), token); });
            this.workerRequest.then(function (data) {
                if (myRequestId_1 === _this.workerRequestTokenId) {
                    _this.workerRequestCompleted = true;
                    _this.workerRequestValue = data || [];
                    _this._beginRenderDecorations();
                }
            }, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
        }
        this._lastWordRange = currentWordRange;
    };
    WordHighlighter.prototype._beginRenderDecorations = function () {
        var _this = this;
        var currentTime = (new Date()).getTime();
        var minimumRenderTime = this.lastCursorPositionChangeTime + 250;
        if (currentTime >= minimumRenderTime) {
            // Synchronous
            this.renderDecorationsTimer = -1;
            this.renderDecorations();
        }
        else {
            // Asynchronous
            this.renderDecorationsTimer = setTimeout(function () {
                _this.renderDecorations();
            }, (minimumRenderTime - currentTime));
        }
    };
    WordHighlighter.prototype.renderDecorations = function () {
        this.renderDecorationsTimer = -1;
        var decorations = [];
        for (var i = 0, len = this.workerRequestValue.length; i < len; i++) {
            var info = this.workerRequestValue[i];
            decorations.push({
                range: info.range,
                options: WordHighlighter._getDecorationOptions(info.kind)
            });
        }
        this._decorationIds = this.editor.deltaDecorations(this._decorationIds, decorations);
        this._hasWordHighlights.set(this.hasDecorations());
    };
    WordHighlighter._getDecorationOptions = function (kind) {
        if (kind === __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["g" /* DocumentHighlightKind */].Write) {
            return this._WRITE_OPTIONS;
        }
        else if (kind === __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["g" /* DocumentHighlightKind */].Text) {
            return this._TEXT_OPTIONS;
        }
        else {
            return this._REGULAR_OPTIONS;
        }
    };
    WordHighlighter.prototype.dispose = function () {
        this._stopAll();
        this.toUnhook = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.toUnhook);
    };
    WordHighlighter._WRITE_OPTIONS = __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_14__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'wordHighlightStrong',
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(overviewRulerWordHighlightStrongForeground),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(overviewRulerWordHighlightStrongForeground),
            position: __WEBPACK_IMPORTED_MODULE_14__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    WordHighlighter._TEXT_OPTIONS = __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_14__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'selectionHighlight',
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_6" /* overviewRulerSelectionHighlightForeground */]),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_6" /* overviewRulerSelectionHighlightForeground */]),
            position: __WEBPACK_IMPORTED_MODULE_14__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    WordHighlighter._REGULAR_OPTIONS = __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_14__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'wordHighlight',
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(overviewRulerWordHighlightForeground),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(overviewRulerWordHighlightForeground),
            position: __WEBPACK_IMPORTED_MODULE_14__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    return WordHighlighter;
}());
var WordHighlighterContribution = /** @class */ (function () {
    function WordHighlighterContribution(editor, contextKeyService) {
        this.wordHighligher = new WordHighlighter(editor, contextKeyService);
    }
    WordHighlighterContribution.get = function (editor) {
        return editor.getContribution(WordHighlighterContribution.ID);
    };
    WordHighlighterContribution.prototype.getId = function () {
        return WordHighlighterContribution.ID;
    };
    WordHighlighterContribution.prototype.saveViewState = function () {
        if (this.wordHighligher.hasDecorations()) {
            return true;
        }
        return false;
    };
    WordHighlighterContribution.prototype.moveNext = function () {
        this.wordHighligher.moveNext();
    };
    WordHighlighterContribution.prototype.moveBack = function () {
        this.wordHighligher.moveBack();
    };
    WordHighlighterContribution.prototype.restoreViewState = function (state) {
        if (state) {
            this.wordHighligher.restore();
        }
    };
    WordHighlighterContribution.prototype.dispose = function () {
        this.wordHighligher.dispose();
    };
    WordHighlighterContribution.ID = 'editor.contrib.wordHighlighter';
    WordHighlighterContribution = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_11__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], WordHighlighterContribution);
    return WordHighlighterContribution;
}());
var WordHighlightNavigationAction = /** @class */ (function (_super) {
    __extends(WordHighlightNavigationAction, _super);
    function WordHighlightNavigationAction(next, opts) {
        var _this = _super.call(this, opts) || this;
        _this._isNext = next;
        return _this;
    }
    WordHighlightNavigationAction.prototype.run = function (accessor, editor) {
        var controller = WordHighlighterContribution.get(editor);
        if (!controller) {
            return;
        }
        if (this._isNext) {
            controller.moveNext();
        }
        else {
            controller.moveBack();
        }
    };
    return WordHighlightNavigationAction;
}(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["b" /* EditorAction */]));
var NextWordHighlightAction = /** @class */ (function (_super) {
    __extends(NextWordHighlightAction, _super);
    function NextWordHighlightAction() {
        return _super.call(this, true, {
            id: 'editor.action.wordHighlight.next',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordHighlight.next.label', "Go to Next Symbol Highlight"),
            alias: 'Go to Next Symbol Highlight',
            precondition: ctxHasWordHighlights,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 65 /* F7 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return NextWordHighlightAction;
}(WordHighlightNavigationAction));
var PrevWordHighlightAction = /** @class */ (function (_super) {
    __extends(PrevWordHighlightAction, _super);
    function PrevWordHighlightAction() {
        return _super.call(this, false, {
            id: 'editor.action.wordHighlight.prev',
            label: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('wordHighlight.previous.label', "Go to Previous Symbol Highlight"),
            alias: 'Go to Previous Symbol Highlight',
            precondition: ctxHasWordHighlights,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_12__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 65 /* F7 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return PrevWordHighlightAction;
}(WordHighlightNavigationAction));
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["h" /* registerEditorContribution */])(WordHighlighterContribution);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(NextWordHighlightAction);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["f" /* registerEditorAction */])(PrevWordHighlightAction);
Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var selectionHighlight = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["B" /* editorSelectionHighlight */]);
    if (selectionHighlight) {
        collector.addRule(".monaco-editor .focused .selectionHighlight { background-color: " + selectionHighlight + "; }");
        collector.addRule(".monaco-editor .selectionHighlight { background-color: " + selectionHighlight.transparent(0.5) + "; }");
    }
    var wordHighlight = theme.getColor(editorWordHighlight);
    if (wordHighlight) {
        collector.addRule(".monaco-editor .wordHighlight { background-color: " + wordHighlight + "; }");
    }
    var wordHighlightStrong = theme.getColor(editorWordHighlightStrong);
    if (wordHighlightStrong) {
        collector.addRule(".monaco-editor .wordHighlightStrong { background-color: " + wordHighlightStrong + "; }");
    }
    var selectionHighlightBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["C" /* editorSelectionHighlightBorder */]);
    if (selectionHighlightBorder) {
        collector.addRule(".monaco-editor .selectionHighlight { border: 1px " + (theme.type === 'hc' ? 'dotted' : 'solid') + " " + selectionHighlightBorder + "; box-sizing: border-box; }");
    }
    var wordHighlightBorder = theme.getColor(editorWordHighlightBorder);
    if (wordHighlightBorder) {
        collector.addRule(".monaco-editor .wordHighlight { border: 1px " + (theme.type === 'hc' ? 'dashed' : 'solid') + " " + wordHighlightBorder + "; box-sizing: border-box; }");
    }
    var wordHighlightStrongBorder = theme.getColor(editorWordHighlightStrongBorder);
    if (wordHighlightStrongBorder) {
        collector.addRule(".monaco-editor .wordHighlightStrong { border: 1px " + (theme.type === 'hc' ? 'dashed' : 'solid') + " " + wordHighlightStrongBorder + "; box-sizing: border-box; }");
    }
});


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordPartLeft", function() { return DeleteWordPartLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteWordPartRight", function() { return DeleteWordPartRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WordPartLeftCommand", function() { return WordPartLeftCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordPartLeft", function() { return CursorWordPartLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordPartLeftSelect", function() { return CursorWordPartLeftSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WordPartRightCommand", function() { return WordPartRightCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordPartRight", function() { return CursorWordPartRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorWordPartRightSelect", function() { return CursorWordPartRightSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_controller_cursorWordOperations_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wordOperations_wordOperations_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_commands_common_commands_js__ = __webpack_require__(30);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var DeleteWordPartLeft = /** @class */ (function (_super) {
    __extends(DeleteWordPartLeft, _super);
    function DeleteWordPartLeft() {
        return _super.call(this, {
            whitespaceHeuristics: true,
            wordNavigationType: 0 /* WordStart */,
            id: 'deleteWordPartLeft',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 0,
                mac: { primary: 256 /* WinCtrl */ | 512 /* Alt */ | 1 /* Backspace */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    DeleteWordPartLeft.prototype._delete = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        var r = __WEBPACK_IMPORTED_MODULE_3__common_controller_cursorWordOperations_js__["b" /* WordPartOperations */].deleteWordPartLeft(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);
        if (r) {
            return r;
        }
        return new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](1, 1, 1, 1);
    };
    return DeleteWordPartLeft;
}(__WEBPACK_IMPORTED_MODULE_4__wordOperations_wordOperations_js__["DeleteWordCommand"]));

var DeleteWordPartRight = /** @class */ (function (_super) {
    __extends(DeleteWordPartRight, _super);
    function DeleteWordPartRight() {
        return _super.call(this, {
            whitespaceHeuristics: true,
            wordNavigationType: 1 /* WordEnd */,
            id: 'deleteWordPartRight',
            precondition: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 0,
                mac: { primary: 256 /* WinCtrl */ | 512 /* Alt */ | 20 /* Delete */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    DeleteWordPartRight.prototype._delete = function (wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
        var r = __WEBPACK_IMPORTED_MODULE_3__common_controller_cursorWordOperations_js__["b" /* WordPartOperations */].deleteWordPartRight(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);
        if (r) {
            return r;
        }
        var lineCount = model.getLineCount();
        var maxColumn = model.getLineMaxColumn(lineCount);
        return new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](lineCount, maxColumn, lineCount, maxColumn);
    };
    return DeleteWordPartRight;
}(__WEBPACK_IMPORTED_MODULE_4__wordOperations_wordOperations_js__["DeleteWordCommand"]));

var WordPartLeftCommand = /** @class */ (function (_super) {
    __extends(WordPartLeftCommand, _super);
    function WordPartLeftCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WordPartLeftCommand.prototype._move = function (wordSeparators, model, position, wordNavigationType) {
        return __WEBPACK_IMPORTED_MODULE_3__common_controller_cursorWordOperations_js__["b" /* WordPartOperations */].moveWordPartLeft(wordSeparators, model, position, wordNavigationType);
    };
    return WordPartLeftCommand;
}(__WEBPACK_IMPORTED_MODULE_4__wordOperations_wordOperations_js__["MoveWordCommand"]));

var CursorWordPartLeft = /** @class */ (function (_super) {
    __extends(CursorWordPartLeft, _super);
    function CursorWordPartLeft() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordPartLeft',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 0,
                mac: { primary: 256 /* WinCtrl */ | 512 /* Alt */ | 15 /* LeftArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordPartLeft;
}(WordPartLeftCommand));

// Register previous id for compatibility purposes
__WEBPACK_IMPORTED_MODULE_5__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommandAlias('cursorWordPartStartLeft', 'cursorWordPartLeft');
var CursorWordPartLeftSelect = /** @class */ (function (_super) {
    __extends(CursorWordPartLeftSelect, _super);
    function CursorWordPartLeftSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 0 /* WordStart */,
            id: 'cursorWordPartLeftSelect',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 0,
                mac: { primary: 256 /* WinCtrl */ | 512 /* Alt */ | 1024 /* Shift */ | 15 /* LeftArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordPartLeftSelect;
}(WordPartLeftCommand));

// Register previous id for compatibility purposes
__WEBPACK_IMPORTED_MODULE_5__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommandAlias('cursorWordPartStartLeftSelect', 'cursorWordPartLeftSelect');
var WordPartRightCommand = /** @class */ (function (_super) {
    __extends(WordPartRightCommand, _super);
    function WordPartRightCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WordPartRightCommand.prototype._move = function (wordSeparators, model, position, wordNavigationType) {
        return __WEBPACK_IMPORTED_MODULE_3__common_controller_cursorWordOperations_js__["b" /* WordPartOperations */].moveWordPartRight(wordSeparators, model, position, wordNavigationType);
    };
    return WordPartRightCommand;
}(__WEBPACK_IMPORTED_MODULE_4__wordOperations_wordOperations_js__["MoveWordCommand"]));

var CursorWordPartRight = /** @class */ (function (_super) {
    __extends(CursorWordPartRight, _super);
    function CursorWordPartRight() {
        return _super.call(this, {
            inSelectionMode: false,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordPartRight',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 0,
                mac: { primary: 256 /* WinCtrl */ | 512 /* Alt */ | 17 /* RightArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordPartRight;
}(WordPartRightCommand));

var CursorWordPartRightSelect = /** @class */ (function (_super) {
    __extends(CursorWordPartRightSelect, _super);
    function CursorWordPartRightSelect() {
        return _super.call(this, {
            inSelectionMode: true,
            wordNavigationType: 1 /* WordEnd */,
            id: 'cursorWordPartRightSelect',
            precondition: null,
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_0__common_editorContextKeys_js__["a" /* EditorContextKeys */].textInputFocus,
                primary: 0,
                mac: { primary: 256 /* WinCtrl */ | 512 /* Alt */ | 1024 /* Shift */ | 17 /* RightArrow */ },
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    return CursorWordPartRightSelect;
}(WordPartRightCommand));

Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordPartLeft());
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new DeleteWordPartRight());
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordPartLeft());
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordPartLeftSelect());
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordPartRight());
Object(__WEBPACK_IMPORTED_MODULE_1__browser_editorExtensions_js__["g" /* registerEditorCommand */])(new CursorWordPartRightSelect());


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LanguageServiceDefaultsImpl", function() { return LanguageServiceDefaultsImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__);

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
var Emitter = monaco.Emitter;
// --- TypeScript configuration and defaults ---------
var LanguageServiceDefaultsImpl = /** @class */ (function () {
    function LanguageServiceDefaultsImpl(compilerOptions, diagnosticsOptions) {
        this._onDidChange = new Emitter();
        this._extraLibs = Object.create(null);
        this._workerMaxIdleTime = 2 * 60 * 1000;
        this.setCompilerOptions(compilerOptions);
        this.setDiagnosticsOptions(diagnosticsOptions);
    }
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "onDidChange", {
        get: function () {
            return this._onDidChange.event;
        },
        enumerable: true,
        configurable: true
    });
    LanguageServiceDefaultsImpl.prototype.getExtraLibs = function () {
        var result = Object.create(null);
        for (var key in this._extraLibs) {
            result[key] = this._extraLibs[key];
        }
        return Object.freeze(result);
    };
    LanguageServiceDefaultsImpl.prototype.addExtraLib = function (content, filePath) {
        var _this = this;
        if (typeof filePath === 'undefined') {
            filePath = "ts:extralib-" + Date.now();
        }
        if (this._extraLibs[filePath]) {
            throw new Error(filePath + " already a extra lib");
        }
        this._extraLibs[filePath] = content;
        this._onDidChange.fire(this);
        return {
            dispose: function () {
                if (delete _this._extraLibs[filePath]) {
                    _this._onDidChange.fire(_this);
                }
            }
        };
    };
    LanguageServiceDefaultsImpl.prototype.getCompilerOptions = function () {
        return this._compilerOptions;
    };
    LanguageServiceDefaultsImpl.prototype.setCompilerOptions = function (options) {
        this._compilerOptions = options || Object.create(null);
        this._onDidChange.fire(this);
    };
    LanguageServiceDefaultsImpl.prototype.getDiagnosticsOptions = function () {
        return this._diagnosticsOptions;
    };
    LanguageServiceDefaultsImpl.prototype.setDiagnosticsOptions = function (options) {
        this._diagnosticsOptions = options || Object.create(null);
        this._onDidChange.fire(this);
    };
    LanguageServiceDefaultsImpl.prototype.setMaximumWorkerIdleTime = function (value) {
        // doesn't fire an event since no
        // worker restart is required here
        this._workerMaxIdleTime = value;
    };
    LanguageServiceDefaultsImpl.prototype.getWorkerMaxIdleTime = function () {
        return this._workerMaxIdleTime;
    };
    LanguageServiceDefaultsImpl.prototype.setEagerModelSync = function (value) {
        // doesn't fire an event since no
        // worker restart is required here
        this._eagerModelSync = value;
    };
    LanguageServiceDefaultsImpl.prototype.getEagerModelSync = function () {
        return this._eagerModelSync;
    };
    return LanguageServiceDefaultsImpl;
}());

//#region enums copied from typescript to prevent loading the entire typescriptServices ---
var ModuleKind;
(function (ModuleKind) {
    ModuleKind[ModuleKind["None"] = 0] = "None";
    ModuleKind[ModuleKind["CommonJS"] = 1] = "CommonJS";
    ModuleKind[ModuleKind["AMD"] = 2] = "AMD";
    ModuleKind[ModuleKind["UMD"] = 3] = "UMD";
    ModuleKind[ModuleKind["System"] = 4] = "System";
    ModuleKind[ModuleKind["ES2015"] = 5] = "ES2015";
    ModuleKind[ModuleKind["ESNext"] = 6] = "ESNext";
})(ModuleKind || (ModuleKind = {}));
var JsxEmit;
(function (JsxEmit) {
    JsxEmit[JsxEmit["None"] = 0] = "None";
    JsxEmit[JsxEmit["Preserve"] = 1] = "Preserve";
    JsxEmit[JsxEmit["React"] = 2] = "React";
    JsxEmit[JsxEmit["ReactNative"] = 3] = "ReactNative";
})(JsxEmit || (JsxEmit = {}));
var NewLineKind;
(function (NewLineKind) {
    NewLineKind[NewLineKind["CarriageReturnLineFeed"] = 0] = "CarriageReturnLineFeed";
    NewLineKind[NewLineKind["LineFeed"] = 1] = "LineFeed";
})(NewLineKind || (NewLineKind = {}));
var ScriptTarget;
(function (ScriptTarget) {
    ScriptTarget[ScriptTarget["ES3"] = 0] = "ES3";
    ScriptTarget[ScriptTarget["ES5"] = 1] = "ES5";
    ScriptTarget[ScriptTarget["ES2015"] = 2] = "ES2015";
    ScriptTarget[ScriptTarget["ES2016"] = 3] = "ES2016";
    ScriptTarget[ScriptTarget["ES2017"] = 4] = "ES2017";
    ScriptTarget[ScriptTarget["ES2018"] = 5] = "ES2018";
    ScriptTarget[ScriptTarget["ESNext"] = 6] = "ESNext";
    ScriptTarget[ScriptTarget["JSON"] = 100] = "JSON";
    ScriptTarget[ScriptTarget["Latest"] = 6] = "Latest";
})(ScriptTarget || (ScriptTarget = {}));
var ModuleResolutionKind;
(function (ModuleResolutionKind) {
    ModuleResolutionKind[ModuleResolutionKind["Classic"] = 1] = "Classic";
    ModuleResolutionKind[ModuleResolutionKind["NodeJs"] = 2] = "NodeJs";
})(ModuleResolutionKind || (ModuleResolutionKind = {}));
//#endregion
var typescriptDefaults = new LanguageServiceDefaultsImpl({ allowNonTsExtensions: true, target: ScriptTarget.Latest }, { noSemanticValidation: false, noSyntaxValidation: false });
var javascriptDefaults = new LanguageServiceDefaultsImpl({ allowNonTsExtensions: true, allowJs: true, target: ScriptTarget.Latest }, { noSemanticValidation: true, noSyntaxValidation: false });
function getTypeScriptWorker() {
    return getMode().then(function (mode) { return mode.getTypeScriptWorker(); });
}
function getJavaScriptWorker() {
    return getMode().then(function (mode) { return mode.getJavaScriptWorker(); });
}
// Export API
function createAPI() {
    return {
        ModuleKind: ModuleKind,
        JsxEmit: JsxEmit,
        NewLineKind: NewLineKind,
        ScriptTarget: ScriptTarget,
        ModuleResolutionKind: ModuleResolutionKind,
        typescriptDefaults: typescriptDefaults,
        javascriptDefaults: javascriptDefaults,
        getTypeScriptWorker: getTypeScriptWorker,
        getJavaScriptWorker: getJavaScriptWorker
    };
}
monaco.languages.typescript = createAPI();
// --- Registration to monaco editor ---
function getMode() {
    return monaco.Promise.wrap(__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 622)));
}
monaco.languages.onLanguage('typescript', function () {
    return getMode().then(function (mode) { return mode.setupTypeScript(typescriptDefaults); });
});
monaco.languages.onLanguage('javascript', function () {
    return getMode().then(function (mode) { return mode.setupJavaScript(javascriptDefaults); });
});


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SimpleModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SimpleEditorModelResolverService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SimpleProgressService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SimpleDialogService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SimpleNotificationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return StandaloneCommandService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return StandaloneKeybindingService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SimpleConfigurationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SimpleResourceConfigurationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SimpleMenuService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return StandaloneTelemetryService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SimpleWorkspaceContextService; });
/* harmony export (immutable) */ __webpack_exports__["n"] = applyConfigurationValues;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleBulkEditService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SimpleUriDisplayService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_keybinding_common_abstractKeybindingService_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_keybinding_common_usLayoutResolvedKeybinding_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_keybinding_common_keybindingResolver_js__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_workspace_common_workspace_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_configuration_common_configurationModels_js__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_browser_keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_keybinding_common_keybindingsRegistry_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_menu_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__platform_keybinding_common_resolvedKeybindingItem_js__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_config_commonEditorConfig_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__nls_js__ = __webpack_require__(2);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



























var SimpleModel = /** @class */ (function () {
    function SimpleModel(model) {
        this.model = model;
        this._onDispose = new __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__["a" /* Emitter */]();
    }
    Object.defineProperty(SimpleModel.prototype, "textEditorModel", {
        get: function () {
            return this.model;
        },
        enumerable: true,
        configurable: true
    });
    SimpleModel.prototype.dispose = function () {
        this._onDispose.fire();
    };
    return SimpleModel;
}());

function withTypedEditor(widget, codeEditorCallback, diffEditorCallback) {
    if (Object(__WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__["d" /* isCodeEditor */])(widget)) {
        // Single Editor
        return codeEditorCallback(widget);
    }
    else {
        // Diff Editor
        return diffEditorCallback(widget);
    }
}
var SimpleEditorModelResolverService = /** @class */ (function () {
    function SimpleEditorModelResolverService() {
    }
    SimpleEditorModelResolverService.prototype.setEditor = function (editor) {
        this.editor = editor;
    };
    SimpleEditorModelResolverService.prototype.createModelReference = function (resource) {
        var _this = this;
        var model;
        model = withTypedEditor(this.editor, function (editor) { return _this.findModel(editor, resource); }, function (diffEditor) { return _this.findModel(diffEditor.getOriginalEditor(), resource) || _this.findModel(diffEditor.getModifiedEditor(), resource); });
        if (!model) {
            return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(new __WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__["b" /* ImmortalReference */](null));
        }
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(new __WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__["b" /* ImmortalReference */](new SimpleModel(model)));
    };
    SimpleEditorModelResolverService.prototype.findModel = function (editor, resource) {
        var model = editor.getModel();
        if (model.uri.toString() !== resource.toString()) {
            return null;
        }
        return model;
    };
    return SimpleEditorModelResolverService;
}());

var SimpleProgressService = /** @class */ (function () {
    function SimpleProgressService() {
    }
    SimpleProgressService.prototype.showWhile = function (promise, delay) {
        return null;
    };
    return SimpleProgressService;
}());

var SimpleDialogService = /** @class */ (function () {
    function SimpleDialogService() {
    }
    return SimpleDialogService;
}());

var SimpleNotificationService = /** @class */ (function () {
    function SimpleNotificationService() {
    }
    SimpleNotificationService.prototype.info = function (message) {
        return this.notify({ severity: __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__["a" /* default */].Info, message: message });
    };
    SimpleNotificationService.prototype.warn = function (message) {
        return this.notify({ severity: __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__["a" /* default */].Warning, message: message });
    };
    SimpleNotificationService.prototype.error = function (error) {
        return this.notify({ severity: __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__["a" /* default */].Error, message: error });
    };
    SimpleNotificationService.prototype.notify = function (notification) {
        switch (notification.severity) {
            case __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__["a" /* default */].Error:
                console.error(notification.message);
                break;
            case __WEBPACK_IMPORTED_MODULE_0__base_common_severity_js__["a" /* default */].Warning:
                console.warn(notification.message);
                break;
            default:
                console.log(notification.message);
                break;
        }
        return SimpleNotificationService.NO_OP;
    };
    SimpleNotificationService.NO_OP = new __WEBPACK_IMPORTED_MODULE_21__platform_notification_common_notification_js__["b" /* NoOpNotification */]();
    return SimpleNotificationService;
}());

var StandaloneCommandService = /** @class */ (function () {
    function StandaloneCommandService(instantiationService) {
        this._onWillExecuteCommand = new __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__["a" /* Emitter */]();
        this._instantiationService = instantiationService;
        this._dynamicCommands = Object.create(null);
    }
    StandaloneCommandService.prototype.addCommand = function (command) {
        var _this = this;
        var id = command.id;
        this._dynamicCommands[id] = command;
        return Object(__WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            delete _this._dynamicCommands[id];
        });
    };
    StandaloneCommandService.prototype.executeCommand = function (id) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var command = (__WEBPACK_IMPORTED_MODULE_3__platform_commands_common_commands_js__["a" /* CommandsRegistry */].getCommand(id) || this._dynamicCommands[id]);
        if (!command) {
            return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error("command '" + id + "' not found"));
        }
        try {
            this._onWillExecuteCommand.fire({ commandId: id });
            var result = this._instantiationService.invokeFunction.apply(this._instantiationService, [command.handler].concat(args));
            return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(result);
        }
        catch (err) {
            return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(err);
        }
    };
    return StandaloneCommandService;
}());

var StandaloneKeybindingService = /** @class */ (function (_super) {
    __extends(StandaloneKeybindingService, _super);
    function StandaloneKeybindingService(contextKeyService, commandService, telemetryService, notificationService, domNode) {
        var _this = _super.call(this, contextKeyService, commandService, telemetryService, notificationService) || this;
        _this._cachedResolver = null;
        _this._dynamicKeybindings = [];
        _this._register(__WEBPACK_IMPORTED_MODULE_13__base_browser_dom_js__["g" /* addDisposableListener */](domNode, __WEBPACK_IMPORTED_MODULE_13__base_browser_dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
            var keyEvent = new __WEBPACK_IMPORTED_MODULE_14__base_browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
            var shouldPreventDefault = _this._dispatch(keyEvent, keyEvent.target);
            if (shouldPreventDefault) {
                keyEvent.preventDefault();
            }
        }));
        return _this;
    }
    StandaloneKeybindingService.prototype.addDynamicKeybinding = function (commandId, keybinding, handler, when) {
        var _this = this;
        var toDispose = [];
        this._dynamicKeybindings.push({
            keybinding: Object(__WEBPACK_IMPORTED_MODULE_17__base_common_keyCodes_js__["f" /* createKeybinding */])(keybinding, __WEBPACK_IMPORTED_MODULE_19__base_common_platform_js__["a" /* OS */]),
            command: commandId,
            when: when,
            weight1: 1000,
            weight2: 0
        });
        toDispose.push(Object(__WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            for (var i = 0; i < _this._dynamicKeybindings.length; i++) {
                var kb = _this._dynamicKeybindings[i];
                if (kb.command === commandId) {
                    _this._dynamicKeybindings.splice(i, 1);
                    _this.updateResolver({ source: __WEBPACK_IMPORTED_MODULE_7__platform_keybinding_common_keybinding_js__["b" /* KeybindingSource */].Default });
                    return;
                }
            }
        }));
        var commandService = this._commandService;
        if (commandService instanceof StandaloneCommandService) {
            toDispose.push(commandService.addCommand({
                id: commandId,
                handler: handler
            }));
        }
        else {
            throw new Error('Unknown command service!');
        }
        this.updateResolver({ source: __WEBPACK_IMPORTED_MODULE_7__platform_keybinding_common_keybinding_js__["b" /* KeybindingSource */].Default });
        return Object(__WEBPACK_IMPORTED_MODULE_12__base_common_lifecycle_js__["c" /* combinedDisposable */])(toDispose);
    };
    StandaloneKeybindingService.prototype.updateResolver = function (event) {
        this._cachedResolver = null;
        this._onDidUpdateKeybindings.fire(event);
    };
    StandaloneKeybindingService.prototype._getResolver = function () {
        if (!this._cachedResolver) {
            var defaults = this._toNormalizedKeybindingItems(__WEBPACK_IMPORTED_MODULE_15__platform_keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].getDefaultKeybindings(), true);
            var overrides = this._toNormalizedKeybindingItems(this._dynamicKeybindings, false);
            this._cachedResolver = new __WEBPACK_IMPORTED_MODULE_6__platform_keybinding_common_keybindingResolver_js__["a" /* KeybindingResolver */](defaults, overrides);
        }
        return this._cachedResolver;
    };
    StandaloneKeybindingService.prototype._documentHasFocus = function () {
        return document.hasFocus();
    };
    StandaloneKeybindingService.prototype._toNormalizedKeybindingItems = function (items, isDefault) {
        var result = [], resultLen = 0;
        for (var i = 0, len = items.length; i < len; i++) {
            var item = items[i];
            var when = (item.when ? item.when.normalize() : null);
            var keybinding = item.keybinding;
            if (!keybinding) {
                // This might be a removal keybinding item in user settings => accept it
                result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_18__platform_keybinding_common_resolvedKeybindingItem_js__["a" /* ResolvedKeybindingItem */](null, item.command, item.commandArgs, when, isDefault);
            }
            else {
                var resolvedKeybindings = this.resolveKeybinding(keybinding);
                for (var j = 0; j < resolvedKeybindings.length; j++) {
                    result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_18__platform_keybinding_common_resolvedKeybindingItem_js__["a" /* ResolvedKeybindingItem */](resolvedKeybindings[j], item.command, item.commandArgs, when, isDefault);
                }
            }
        }
        return result;
    };
    StandaloneKeybindingService.prototype.resolveKeybinding = function (keybinding) {
        return [new __WEBPACK_IMPORTED_MODULE_5__platform_keybinding_common_usLayoutResolvedKeybinding_js__["a" /* USLayoutResolvedKeybinding */](keybinding, __WEBPACK_IMPORTED_MODULE_19__base_common_platform_js__["a" /* OS */])];
    };
    StandaloneKeybindingService.prototype.resolveKeyboardEvent = function (keyboardEvent) {
        var keybinding = new __WEBPACK_IMPORTED_MODULE_17__base_common_keyCodes_js__["e" /* SimpleKeybinding */](keyboardEvent.ctrlKey, keyboardEvent.shiftKey, keyboardEvent.altKey, keyboardEvent.metaKey, keyboardEvent.keyCode);
        return new __WEBPACK_IMPORTED_MODULE_5__platform_keybinding_common_usLayoutResolvedKeybinding_js__["a" /* USLayoutResolvedKeybinding */](keybinding, __WEBPACK_IMPORTED_MODULE_19__base_common_platform_js__["a" /* OS */]);
    };
    return StandaloneKeybindingService;
}(__WEBPACK_IMPORTED_MODULE_4__platform_keybinding_common_abstractKeybindingService_js__["a" /* AbstractKeybindingService */]));

function isConfigurationOverrides(thing) {
    return thing
        && typeof thing === 'object'
        && (!thing.overrideIdentifier || typeof thing.overrideIdentifier === 'string')
        && (!thing.resource || thing.resource instanceof __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */]);
}
var SimpleConfigurationService = /** @class */ (function () {
    function SimpleConfigurationService() {
        this._onDidChangeConfiguration = new __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__["a" /* Emitter */]();
        this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
        this._configuration = new __WEBPACK_IMPORTED_MODULE_11__platform_configuration_common_configurationModels_js__["a" /* Configuration */](new __WEBPACK_IMPORTED_MODULE_11__platform_configuration_common_configurationModels_js__["c" /* DefaultConfigurationModel */](), new __WEBPACK_IMPORTED_MODULE_11__platform_configuration_common_configurationModels_js__["b" /* ConfigurationModel */]());
    }
    SimpleConfigurationService.prototype.configuration = function () {
        return this._configuration;
    };
    SimpleConfigurationService.prototype.getValue = function (arg1, arg2) {
        var section = typeof arg1 === 'string' ? arg1 : void 0;
        var overrides = isConfigurationOverrides(arg1) ? arg1 : isConfigurationOverrides(arg2) ? arg2 : {};
        return this.configuration().getValue(section, overrides, null);
    };
    SimpleConfigurationService.prototype.updateValue = function (key, value, arg3, arg4) {
        this.configuration().updateValue(key, value);
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(null);
    };
    return SimpleConfigurationService;
}());

var SimpleResourceConfigurationService = /** @class */ (function () {
    function SimpleResourceConfigurationService(configurationService) {
        var _this = this;
        this.configurationService = configurationService;
        this._onDidChangeConfigurationEmitter = new __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__["a" /* Emitter */]();
        this.configurationService.onDidChangeConfiguration(function (e) {
            _this._onDidChangeConfigurationEmitter.fire(e);
        });
    }
    SimpleResourceConfigurationService.prototype.getValue = function (resource, arg2, arg3) {
        var position = __WEBPACK_IMPORTED_MODULE_22__common_core_position_js__["a" /* Position */].isIPosition(arg2) ? arg2 : null;
        var section = position ? (typeof arg3 === 'string' ? arg3 : void 0) : (typeof arg2 === 'string' ? arg2 : void 0);
        return this.configurationService.getValue(section);
    };
    return SimpleResourceConfigurationService;
}());

var SimpleMenuService = /** @class */ (function () {
    function SimpleMenuService(commandService) {
        this._commandService = commandService;
    }
    SimpleMenuService.prototype.createMenu = function (id, contextKeyService) {
        return new __WEBPACK_IMPORTED_MODULE_16__platform_actions_common_menu_js__["a" /* Menu */](id, __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(true), this._commandService, contextKeyService);
    };
    return SimpleMenuService;
}());

var StandaloneTelemetryService = /** @class */ (function () {
    function StandaloneTelemetryService() {
    }
    StandaloneTelemetryService.prototype.publicLog = function (eventName, data) {
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrap(null);
    };
    return StandaloneTelemetryService;
}());

var SimpleWorkspaceContextService = /** @class */ (function () {
    function SimpleWorkspaceContextService() {
        var resource = __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */].from({ scheme: SimpleWorkspaceContextService.SCHEME, authority: 'model', path: '/' });
        this.workspace = { id: '4064f6ec-cb38-4ad0-af64-ee6467e63c82', folders: [new __WEBPACK_IMPORTED_MODULE_8__platform_workspace_common_workspace_js__["b" /* WorkspaceFolder */]({ uri: resource, name: '', index: 0 })], name: resource.fsPath };
    }
    SimpleWorkspaceContextService.prototype.getWorkspace = function () {
        return this.workspace;
    };
    SimpleWorkspaceContextService.prototype.getWorkspaceFolder = function (resource) {
        return resource && resource.scheme === SimpleWorkspaceContextService.SCHEME ? this.workspace.folders[0] : void 0;
    };
    return SimpleWorkspaceContextService;
}());

function applyConfigurationValues(configurationService, source, isDiffEditor) {
    if (!source) {
        return;
    }
    if (!(configurationService instanceof SimpleConfigurationService)) {
        return;
    }
    Object.keys(source).forEach(function (key) {
        if (Object(__WEBPACK_IMPORTED_MODULE_23__common_config_commonEditorConfig_js__["d" /* isEditorConfigurationKey */])(key)) {
            configurationService.updateValue("editor." + key, source[key]);
        }
        if (isDiffEditor && Object(__WEBPACK_IMPORTED_MODULE_23__common_config_commonEditorConfig_js__["c" /* isDiffEditorConfigurationKey */])(key)) {
            configurationService.updateValue("diffEditor." + key, source[key]);
        }
    });
}
var SimpleBulkEditService = /** @class */ (function () {
    function SimpleBulkEditService(_modelService) {
        this._modelService = _modelService;
        //
    }
    SimpleBulkEditService.prototype.apply = function (workspaceEdit, options) {
        var edits = new Map();
        for (var _i = 0, _a = workspaceEdit.edits; _i < _a.length; _i++) {
            var edit = _a[_i];
            if (!Object(__WEBPACK_IMPORTED_MODULE_24__common_modes_js__["A" /* isResourceTextEdit */])(edit)) {
                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error('bad edit - only text edits are supported'));
            }
            var model = this._modelService.getModel(edit.resource);
            if (!model) {
                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error('bad edit - model not found'));
            }
            var array = edits.get(model);
            if (!array) {
                array = [];
            }
            edits.set(model, array.concat(edit.edits));
        }
        var totalEdits = 0;
        var totalFiles = 0;
        edits.forEach(function (edits, model) {
            model.applyEdits(edits.map(function (edit) { return __WEBPACK_IMPORTED_MODULE_25__common_core_editOperation_js__["a" /* EditOperation */].replaceMove(__WEBPACK_IMPORTED_MODULE_20__common_core_range_js__["a" /* Range */].lift(edit.range), edit.text); }));
            totalFiles += 1;
            totalEdits += edits.length;
        });
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as({
            selection: undefined,
            ariaSummary: Object(__WEBPACK_IMPORTED_MODULE_26__nls_js__["a" /* localize */])('summary', 'Made {0} edits in {1} files', totalEdits, totalFiles)
        });
    };
    return SimpleBulkEditService;
}());

var SimpleUriDisplayService = /** @class */ (function () {
    function SimpleUriDisplayService() {
    }
    SimpleUriDisplayService.prototype.getLabel = function (resource, relative) {
        if (resource.scheme === 'file') {
            return resource.fsPath;
        }
        return resource.path;
    };
    return SimpleUriDisplayService;
}());



/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Extensions */
/* unused harmony export EditorModesRegistry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModesRegistry; });
/* unused harmony export PLAINTEXT_MODE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLAINTEXT_LANGUAGE_IDENTIFIER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modes_js__ = __webpack_require__(15);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






// Define extension point ids
var Extensions = {
    ModesRegistry: 'editor.modesRegistry'
};
var EditorModesRegistry = /** @class */ (function () {
    function EditorModesRegistry() {
        this._onDidAddLanguages = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.onDidAddLanguages = this._onDidAddLanguages.event;
        this._languages = [];
    }
    // --- languages
    EditorModesRegistry.prototype.registerLanguage = function (def) {
        this._languages.push(def);
        this._onDidAddLanguages.fire([def]);
    };
    EditorModesRegistry.prototype.getLanguages = function () {
        return this._languages.slice(0);
    };
    return EditorModesRegistry;
}());

var ModesRegistry = new EditorModesRegistry();
__WEBPACK_IMPORTED_MODULE_2__platform_registry_common_platform_js__["a" /* Registry */].add(Extensions.ModesRegistry, ModesRegistry);
var PLAINTEXT_MODE_ID = 'plaintext';
var PLAINTEXT_LANGUAGE_IDENTIFIER = new __WEBPACK_IMPORTED_MODULE_4__modes_js__["o" /* LanguageIdentifier */](PLAINTEXT_MODE_ID, 1 /* PlainText */);
ModesRegistry.registerLanguage({
    id: PLAINTEXT_MODE_ID,
    extensions: ['.txt', '.gitignore'],
    aliases: [__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('plainText.alias', "Plain Text"), 'text'],
    mimetypes: ['text/plain']
});
__WEBPACK_IMPORTED_MODULE_3__languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].register(PLAINTEXT_LANGUAGE_IDENTIFIER, {
    brackets: [
        ['(', ')'],
        ['[', ']'],
        ['{', '}'],
    ]
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'apex',
    extensions: ['.cls'],
    aliases: ['Apex', 'apex'],
    mimetypes: ['text/x-apex-source', 'text/x-apex'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 572))); }
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'azcli',
    extensions: ['.azcli'],
    aliases: ['Azure CLI', 'azcli'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 573))); }
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'bat',
    extensions: ['.bat', '.cmd'],
    aliases: ['Batch', 'bat'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 574))); }
});


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = typeof monaco === 'undefined' ? self.monaco : monaco;
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'clojure',
    extensions: ['.clj', '.clojure'],
    aliases: ['clojure', 'Clojure'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 575))); },
});


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'coffeescript',
    extensions: ['.coffee'],
    aliases: ['CoffeeScript', 'coffeescript', 'coffee'],
    mimetypes: ['text/x-coffeescript', 'text/coffeescript'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 576))); }
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'c',
    extensions: ['.c', '.h'],
    aliases: ['C', 'c'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 295))); }
});
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'cpp',
    extensions: ['.cpp', '.cc', '.cxx', '.hpp', '.hh', '.hxx'],
    aliases: ['C++', 'Cpp', 'cpp'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 295))); }
});


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'csharp',
    extensions: ['.cs', '.csx'],
    aliases: ['C#', 'csharp'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 577))); }
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'csp',
    extensions: [],
    aliases: ['CSP', 'csp'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 578))); }
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'css',
    extensions: ['.css'],
    aliases: ['CSS', 'css'],
    mimetypes: ['text/css'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 579))); }
});


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LanguageServiceDefaultsImpl", function() { return LanguageServiceDefaultsImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__);

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
var Emitter = monaco.Emitter;
// --- CSS configuration and defaults ---------
var LanguageServiceDefaultsImpl = /** @class */ (function () {
    function LanguageServiceDefaultsImpl(languageId, diagnosticsOptions) {
        this._onDidChange = new Emitter();
        this._languageId = languageId;
        this.setDiagnosticsOptions(diagnosticsOptions);
    }
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "onDidChange", {
        get: function () {
            return this._onDidChange.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "languageId", {
        get: function () {
            return this._languageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "diagnosticsOptions", {
        get: function () {
            return this._diagnosticsOptions;
        },
        enumerable: true,
        configurable: true
    });
    LanguageServiceDefaultsImpl.prototype.setDiagnosticsOptions = function (options) {
        this._diagnosticsOptions = options || Object.create(null);
        this._onDidChange.fire(this);
    };
    return LanguageServiceDefaultsImpl;
}());

var diagnosticDefault = {
    validate: true,
    lint: {
        compatibleVendorPrefixes: 'ignore',
        vendorPrefix: 'warning',
        duplicateProperties: 'warning',
        emptyRules: 'warning',
        importStatement: 'ignore',
        boxModel: 'ignore',
        universalSelector: 'ignore',
        zeroUnits: 'ignore',
        fontFaceProperties: 'warning',
        hexColorLength: 'error',
        argumentsInColorFunction: 'error',
        unknownProperties: 'warning',
        ieHack: 'ignore',
        unknownVendorSpecificProperties: 'ignore',
        propertyIgnoredDueToDisplay: 'warning',
        important: 'ignore',
        float: 'ignore',
        idSelector: 'ignore'
    }
};
var cssDefaults = new LanguageServiceDefaultsImpl('css', diagnosticDefault);
var scssDefaults = new LanguageServiceDefaultsImpl('scss', diagnosticDefault);
var lessDefaults = new LanguageServiceDefaultsImpl('less', diagnosticDefault);
// Export API
function createAPI() {
    return {
        cssDefaults: cssDefaults,
        lessDefaults: lessDefaults,
        scssDefaults: scssDefaults
    };
}
monaco.languages.css = createAPI();
// --- Registration to monaco editor ---
function getMode() {
    return monaco.Promise.wrap(__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 580)));
}
monaco.languages.onLanguage('less', function () {
    getMode().then(function (mode) { return mode.setupMode(lessDefaults); });
});
monaco.languages.onLanguage('scss', function () {
    getMode().then(function (mode) { return mode.setupMode(scssDefaults); });
});
monaco.languages.onLanguage('css', function () {
    getMode().then(function (mode) { return mode.setupMode(cssDefaults); });
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'dockerfile',
    extensions: ['.dockerfile'],
    filenames: ['Dockerfile'],
    aliases: ['Dockerfile'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 581))); }
});


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'fsharp',
    extensions: ['.fs', '.fsi', '.ml', '.mli', '.fsx', '.fsscript'],
    aliases: ['F#', 'FSharp', 'fsharp'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 582))); }
});


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'go',
    extensions: ['.go'],
    aliases: ['Go'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 583))); }
});


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'handlebars',
    extensions: ['.handlebars', '.hbs'],
    aliases: ['Handlebars', 'handlebars'],
    mimetypes: ['text/x-handlebars-template'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 584))); }
});


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'html',
    extensions: ['.html', '.htm', '.shtml', '.xhtml', '.mdoc', '.jsp', '.asp', '.aspx', '.jshtm'],
    aliases: ['HTML', 'htm', 'html', 'xhtml'],
    mimetypes: ['text/html', 'text/x-jshtm', 'text/template', 'text/ng-template'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 585))); }
});


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LanguageServiceDefaultsImpl", function() { return LanguageServiceDefaultsImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__);

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
var Emitter = monaco.Emitter;
// --- HTML configuration and defaults ---------
var LanguageServiceDefaultsImpl = /** @class */ (function () {
    function LanguageServiceDefaultsImpl(languageId, options) {
        this._onDidChange = new Emitter();
        this._languageId = languageId;
        this.setOptions(options);
    }
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "onDidChange", {
        get: function () {
            return this._onDidChange.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "languageId", {
        get: function () {
            return this._languageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    LanguageServiceDefaultsImpl.prototype.setOptions = function (options) {
        this._options = options || Object.create(null);
        this._onDidChange.fire(this);
    };
    return LanguageServiceDefaultsImpl;
}());

var formatDefaults = {
    tabSize: 4,
    insertSpaces: false,
    wrapLineLength: 120,
    unformatted: 'default": "a, abbr, acronym, b, bdo, big, br, button, cite, code, dfn, em, i, img, input, kbd, label, map, object, q, samp, select, small, span, strong, sub, sup, textarea, tt, var',
    contentUnformatted: 'pre',
    indentInnerHtml: false,
    preserveNewLines: true,
    maxPreserveNewLines: null,
    indentHandlebars: false,
    endWithNewline: false,
    extraLiners: 'head, body, /html',
    wrapAttributes: 'auto'
};
var htmlOptionsDefault = {
    format: formatDefaults,
    suggest: { html5: true, angular1: true, ionic: true }
};
var handlebarOptionsDefault = {
    format: formatDefaults,
    suggest: { html5: true }
};
var razorOptionsDefault = {
    format: formatDefaults,
    suggest: { html5: true, razor: true }
};
var htmlLanguageId = 'html';
var handlebarsLanguageId = 'handlebars';
var razorLanguageId = 'razor';
var htmlDefaults = new LanguageServiceDefaultsImpl(htmlLanguageId, htmlOptionsDefault);
var handlebarDefaults = new LanguageServiceDefaultsImpl(handlebarsLanguageId, handlebarOptionsDefault);
var razorDefaults = new LanguageServiceDefaultsImpl(razorLanguageId, razorOptionsDefault);
// Export API
function createAPI() {
    return {
        htmlDefaults: htmlDefaults,
        razorDefaults: razorDefaults,
        handlebarDefaults: handlebarDefaults
    };
}
monaco.languages.html = createAPI();
// --- Registration to monaco editor ---
function getMode() {
    return monaco.Promise.wrap(__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 586)));
}
monaco.languages.onLanguage(htmlLanguageId, function () {
    getMode().then(function (mode) { return mode.setupMode(htmlDefaults); });
});
monaco.languages.onLanguage(handlebarsLanguageId, function () {
    getMode().then(function (mode) { return mode.setupMode(handlebarDefaults); });
});
monaco.languages.onLanguage(razorLanguageId, function () {
    getMode().then(function (mode) { return mode.setupMode(razorDefaults); });
});


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'ini',
    extensions: ['.ini', '.properties', '.gitconfig'],
    filenames: ['config', '.gitattributes', '.gitconfig', '.editorconfig'],
    aliases: ['Ini', 'ini'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 587))); }
});


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'java',
    extensions: ['.java', '.jav'],
    aliases: ['Java', 'java'],
    mimetypes: ['text/x-java-source', 'text/x-java'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 588))); }
});


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'javascript',
    extensions: ['.js', '.es6', '.jsx'],
    firstLine: '^#!.*\\bnode',
    filenames: ['jakefile'],
    aliases: ['JavaScript', 'javascript', 'js'],
    mimetypes: ['text/javascript'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 589))); }
});


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LanguageServiceDefaultsImpl", function() { return LanguageServiceDefaultsImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__);

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
var Emitter = monaco.Emitter;
// --- JSON configuration and defaults ---------
var LanguageServiceDefaultsImpl = /** @class */ (function () {
    function LanguageServiceDefaultsImpl(languageId, diagnosticsOptions) {
        this._onDidChange = new Emitter();
        this._languageId = languageId;
        this.setDiagnosticsOptions(diagnosticsOptions);
    }
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "onDidChange", {
        get: function () {
            return this._onDidChange.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "languageId", {
        get: function () {
            return this._languageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "diagnosticsOptions", {
        get: function () {
            return this._diagnosticsOptions;
        },
        enumerable: true,
        configurable: true
    });
    LanguageServiceDefaultsImpl.prototype.setDiagnosticsOptions = function (options) {
        this._diagnosticsOptions = options || Object.create(null);
        this._onDidChange.fire(this);
    };
    return LanguageServiceDefaultsImpl;
}());

var diagnosticDefault = {
    validate: true,
    allowComments: true,
    schemas: []
};
var jsonDefaults = new LanguageServiceDefaultsImpl('json', diagnosticDefault);
// Export API
function createAPI() {
    return {
        jsonDefaults: jsonDefaults,
    };
}
monaco.languages.json = createAPI();
// --- Registration to monaco editor ---
function getMode() {
    return monaco.Promise.wrap(__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 590)));
}
monaco.languages.register({
    id: 'json',
    extensions: ['.json', '.bowerrc', '.jshintrc', '.jscsrc', '.eslintrc', '.babelrc'],
    aliases: ['JSON', 'json'],
    mimetypes: ['application/json'],
});
monaco.languages.onLanguage('json', function () {
    getMode().then(function (mode) { return mode.setupMode(jsonDefaults); });
});


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'less',
    extensions: ['.less'],
    aliases: ['Less', 'less'],
    mimetypes: ['text/x-less', 'text/less'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 591))); }
});


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'lua',
    extensions: ['.lua'],
    aliases: ['Lua', 'lua'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 592))); }
});


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'markdown',
    extensions: ['.md', '.markdown', '.mdown', '.mkdn', '.mkd', '.mdwn', '.mdtxt', '.mdtext'],
    aliases: ['Markdown', 'markdown'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 593))); }
});


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'msdax',
    extensions: ['.dax', '.msdax'],
    aliases: ['DAX', 'MSDAX'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 594))); }
});


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'mysql',
    extensions: [],
    aliases: ['MySQL', 'mysql'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 595))); }
});


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'objective-c',
    extensions: ['.m'],
    aliases: ['Objective-C'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 596))); }
});


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
*  Copyright (c) Microsoft Corporation. All rights reserved.
*  Licensed under the MIT License. See License.txt in the project root for license information.
*--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = typeof monaco === 'undefined' ? self.monaco : monaco;
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'perl',
    extensions: ['.pl'],
    aliases: ['Perl', 'pl'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 597))); },
});


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'pgsql',
    extensions: [],
    aliases: ['PostgreSQL', 'postgres', 'pg', 'postgre'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 598))); }
});


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'php',
    extensions: ['.php', '.php4', '.php5', '.phtml', '.ctp'],
    aliases: ['PHP', 'php'],
    mimetypes: ['application/x-php'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 599))); }
});


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'postiats',
    extensions: ['.dats', '.sats', '.hats'],
    aliases: ['ATS', 'ATS/Postiats'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 600))); }
});


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'powerquery',
    extensions: ['.pq', '.pqm'],
    aliases: ['PQ', 'M', 'Power Query', 'Power Query M'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 601))); }
});


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'powershell',
    extensions: ['.ps1', '.psm1', '.psd1'],
    aliases: ['PowerShell', 'powershell', 'ps', 'ps1'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 602))); }
});


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'pug',
    extensions: ['.jade', '.pug'],
    aliases: ['Pug', 'Jade', 'jade'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 603))); }
});


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'python',
    extensions: ['.py', '.rpy', '.pyw', '.cpy', '.gyp', '.gypi'],
    aliases: ['Python', 'py'],
    firstLine: '^#!/.*\\bpython[0-9.-]*\\b',
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 604))); }
});


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'r',
    extensions: ['.r', '.rhistory', '.rprofile', '.rt'],
    aliases: ['R', 'r'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 605))); }
});


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'razor',
    extensions: ['.cshtml'],
    aliases: ['Razor', 'razor'],
    mimetypes: ['text/x-cshtml'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 606))); }
});


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'redis',
    extensions: ['.redis'],
    aliases: ['redis'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 607))); }
});


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'redshift',
    extensions: [],
    aliases: ['Redshift', 'redshift'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 608))); }
});


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'ruby',
    extensions: ['.rb', '.rbx', '.rjs', '.gemspec', '.pp'],
    filenames: ['rakefile'],
    aliases: ['Ruby', 'rb'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 609))); }
});


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'rust',
    extensions: ['.rs', '.rlib'],
    aliases: ['Rust', 'rust'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 610))); }
});


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'sb',
    extensions: ['.sb'],
    aliases: ['Small Basic', 'sb'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 611))); }
});


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = typeof monaco === 'undefined' ? self.monaco : monaco;
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'scheme',
    extensions: ['.scm', '.ss', '.sch', '.rkt'],
    aliases: ['scheme', 'Scheme'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 612))); },
});


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'scss',
    extensions: ['.scss'],
    aliases: ['Sass', 'sass', 'scss'],
    mimetypes: ['text/x-scss', 'text/scss'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 613))); }
});


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
*  Copyright (c) Microsoft Corporation. All rights reserved.
*  Licensed under the MIT License. See License.txt in the project root for license information.
*--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = typeof monaco === 'undefined' ? self.monaco : monaco;
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'shell',
    extensions: ['.sh', '.bash'],
    aliases: ['Shell', 'sh'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 614))); },
});


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'sol',
    extensions: ['.sol'],
    aliases: ['sol', 'solidity', 'Solidity'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 615))); }
});


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'sql',
    extensions: ['.sql'],
    aliases: ['SQL'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 616))); }
});


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'st',
    extensions: ['.st', '.iecst', '.iecplc', '.lc3lib'],
    aliases: ['StructuredText', 'scl', 'stl'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 617))); }
});


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'swift',
    aliases: ['Swift', 'swift'],
    extensions: ['.swift'],
    mimetypes: ['text/swift'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 618))); }
});


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'typescript',
    extensions: ['.ts', '.tsx'],
    aliases: ['TypeScript', 'ts', 'typescript'],
    mimetypes: ['text/typescript'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 571))); }
});


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'vb',
    extensions: ['.vb'],
    aliases: ['Visual Basic', 'vb'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 619))); }
});


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'xml',
    extensions: ['.xml', '.dtd', '.ascx', '.csproj', '.config', '.wxi', '.wxl', '.wxs', '.xaml', '.svg', '.svgz'],
    firstLine: '(\\<\\?xml.*)|(\\<svg)|(\\<\\!doctype\\s+svg)',
    aliases: ['XML', 'xml'],
    mimetypes: ['text/xml', 'application/xml', 'application/xaml+xml', 'application/xml-dtd'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 620))); }
});


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contribution_js__ = __webpack_require__(11);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


// Allow for running under nodejs/requirejs in tests
var _monaco = (typeof monaco === 'undefined' ? self.monaco : monaco);
Object(__WEBPACK_IMPORTED_MODULE_0__contribution_js__["a" /* registerLanguage */])({
    id: 'yaml',
    extensions: ['.yaml', '.yml'],
    aliases: ['YAML', 'yaml', 'YML', 'yml'],
    mimetypes: ['application/x-yaml'],
    loader: function () { return _monaco.Promise.wrap(__webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 621))); }
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(299);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        getWorkerUrl: function (moduleId, label) {
          const pathPrefix = (typeof window.__webpack_public_path__ === 'string' ? window.__webpack_public_path__ : "/");
          return (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
        }
      };
    })({
  "editorWorkerService": "editor.worker.js",
  "css": "css.worker.js",
  "html": "html.worker.js",
  "json": "json.worker.js",
  "typescript": "typescript.worker.js",
  "javascript": "typescript.worker.js",
  "less": "css.worker.js",
  "scss": "css.worker.js"
});
__webpack_require__(115);
__webpack_require__(120);
__webpack_require__(122);
__webpack_require__(123);
__webpack_require__(124);
__webpack_require__(129);
__webpack_require__(100);
__webpack_require__(130);
__webpack_require__(131);
__webpack_require__(84);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(101);
__webpack_require__(140);
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(103);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(166);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(89);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(91);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(111);
__webpack_require__(187);
module.exports = __webpack_require__(512);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(188);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedList; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var Node = /** @class */ (function () {
    function Node(element) {
        this.element = element;
    }
    return Node;
}());
var LinkedList = /** @class */ (function () {
    function LinkedList() {
    }
    LinkedList.prototype.isEmpty = function () {
        return !this._first;
    };
    LinkedList.prototype.unshift = function (element) {
        return this.insert(element, false);
    };
    LinkedList.prototype.push = function (element) {
        return this.insert(element, true);
    };
    LinkedList.prototype.insert = function (element, atTheEnd) {
        var _this = this;
        var newNode = new Node(element);
        if (!this._first) {
            this._first = newNode;
            this._last = newNode;
        }
        else if (atTheEnd) {
            // push
            var oldLast = this._last;
            this._last = newNode;
            newNode.prev = oldLast;
            oldLast.next = newNode;
        }
        else {
            // unshift
            var oldFirst = this._first;
            this._first = newNode;
            newNode.next = oldFirst;
            oldFirst.prev = newNode;
        }
        return function () {
            for (var candidate = _this._first; candidate instanceof Node; candidate = candidate.next) {
                if (candidate !== newNode) {
                    continue;
                }
                if (candidate.prev && candidate.next) {
                    // middle
                    var anchor = candidate.prev;
                    anchor.next = candidate.next;
                    candidate.next.prev = anchor;
                }
                else if (!candidate.prev && !candidate.next) {
                    // only node
                    _this._first = undefined;
                    _this._last = undefined;
                }
                else if (!candidate.next) {
                    // last
                    _this._last = _this._last.prev;
                    _this._last.next = undefined;
                }
                else if (!candidate.prev) {
                    // first
                    _this._first = _this._first.next;
                    _this._first.prev = undefined;
                }
                // done
                break;
            }
        };
    };
    LinkedList.prototype.iterator = function () {
        var element = {
            done: undefined,
            value: undefined,
        };
        var node = this._first;
        return {
            next: function () {
                if (!node) {
                    element.done = true;
                    element.value = undefined;
                }
                else {
                    element.done = false;
                    element.value = node.element;
                    node = node.next;
                }
                return element;
            }
        };
    };
    return LinkedList;
}());



/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IframeUtils; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var hasDifferentOriginAncestorFlag = false;
var sameOriginWindowChainCache = null;
function getParentWindowIfSameOrigin(w) {
    if (!w.parent || w.parent === w) {
        return null;
    }
    // Cannot really tell if we have access to the parent window unless we try to access something in it
    try {
        var location_1 = w.location;
        var parentLocation = w.parent.location;
        if (location_1.protocol !== parentLocation.protocol || location_1.hostname !== parentLocation.hostname || location_1.port !== parentLocation.port) {
            hasDifferentOriginAncestorFlag = true;
            return null;
        }
    }
    catch (e) {
        hasDifferentOriginAncestorFlag = true;
        return null;
    }
    return w.parent;
}
function findIframeElementInParentWindow(parentWindow, childWindow) {
    var parentWindowIframes = parentWindow.document.getElementsByTagName('iframe');
    var iframe;
    for (var i = 0, len = parentWindowIframes.length; i < len; i++) {
        iframe = parentWindowIframes[i];
        if (iframe.contentWindow === childWindow) {
            return iframe;
        }
    }
    return null;
}
var IframeUtils = /** @class */ (function () {
    function IframeUtils() {
    }
    /**
     * Returns a chain of embedded windows with the same origin (which can be accessed programmatically).
     * Having a chain of length 1 might mean that the current execution environment is running outside of an iframe or inside an iframe embedded in a window with a different origin.
     * To distinguish if at one point the current execution environment is running inside a window with a different origin, see hasDifferentOriginAncestor()
     */
    IframeUtils.getSameOriginWindowChain = function () {
        if (!sameOriginWindowChainCache) {
            sameOriginWindowChainCache = [];
            var w = window, parent_1;
            do {
                parent_1 = getParentWindowIfSameOrigin(w);
                if (parent_1) {
                    sameOriginWindowChainCache.push({
                        window: w,
                        iframeElement: findIframeElementInParentWindow(parent_1, w)
                    });
                }
                else {
                    sameOriginWindowChainCache.push({
                        window: w,
                        iframeElement: null
                    });
                }
                w = parent_1;
            } while (w);
        }
        return sameOriginWindowChainCache.slice(0);
    };
    /**
     * Returns true if the current execution environment is chained in a list of iframes which at one point ends in a window with a different origin.
     * Returns false if the current execution environment is not running inside an iframe or if the entire chain of iframes have the same origin.
     */
    IframeUtils.hasDifferentOriginAncestor = function () {
        if (!sameOriginWindowChainCache) {
            this.getSameOriginWindowChain();
        }
        return hasDifferentOriginAncestorFlag;
    };
    /**
     * Returns the position of `childWindow` relative to `ancestorWindow`
     */
    IframeUtils.getPositionOfChildWindowRelativeToAncestorWindow = function (childWindow, ancestorWindow) {
        if (!ancestorWindow || childWindow === ancestorWindow) {
            return {
                top: 0,
                left: 0
            };
        }
        var top = 0, left = 0;
        var windowChain = this.getSameOriginWindowChain();
        for (var i = 0; i < windowChain.length; i++) {
            var windowChainEl = windowChain[i];
            if (windowChainEl.window === ancestorWindow) {
                break;
            }
            if (!windowChainEl.iframeElement) {
                break;
            }
            var boundingRect = windowChainEl.iframeElement.getBoundingClientRect();
            top += boundingRect.top;
            left += boundingRect.left;
        }
        return {
            top: top,
            left: left
        };
    };
    return IframeUtils;
}());



/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export splitGlobAware */
/* harmony export (immutable) */ __webpack_exports__["a"] = match;
/* unused harmony export parse */
/* unused harmony export isRelativePattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__winjs_base_js__ = __webpack_require__(8);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var GLOBSTAR = '**';
var GLOB_SPLIT = '/';
var PATH_REGEX = '[/\\\\]'; // any slash or backslash
var NO_PATH_REGEX = '[^/\\\\]'; // any non-slash and non-backslash
var ALL_FORWARD_SLASHES = /\//g;
function starsToRegExp(starCount) {
    switch (starCount) {
        case 0:
            return '';
        case 1:
            return NO_PATH_REGEX + "*?"; // 1 star matches any number of characters except path separator (/ and \) - non greedy (?)
        default:
            // Matches:  (Path Sep OR Path Val followed by Path Sep OR Path Sep followed by Path Val) 0-many times
            // Group is non capturing because we don't need to capture at all (?:...)
            // Overall we use non-greedy matching because it could be that we match too much
            return "(?:" + PATH_REGEX + "|" + NO_PATH_REGEX + "+" + PATH_REGEX + "|" + PATH_REGEX + NO_PATH_REGEX + "+)*?";
    }
}
function splitGlobAware(pattern, splitChar) {
    if (!pattern) {
        return [];
    }
    var segments = [];
    var inBraces = false;
    var inBrackets = false;
    var char;
    var curVal = '';
    for (var i = 0; i < pattern.length; i++) {
        char = pattern[i];
        switch (char) {
            case splitChar:
                if (!inBraces && !inBrackets) {
                    segments.push(curVal);
                    curVal = '';
                    continue;
                }
                break;
            case '{':
                inBraces = true;
                break;
            case '}':
                inBraces = false;
                break;
            case '[':
                inBrackets = true;
                break;
            case ']':
                inBrackets = false;
                break;
        }
        curVal += char;
    }
    // Tail
    if (curVal) {
        segments.push(curVal);
    }
    return segments;
}
function parseRegExp(pattern) {
    if (!pattern) {
        return '';
    }
    var regEx = '';
    // Split up into segments for each slash found
    var segments = splitGlobAware(pattern, GLOB_SPLIT);
    // Special case where we only have globstars
    if (segments.every(function (s) { return s === GLOBSTAR; })) {
        regEx = '.*';
    }
    // Build regex over segments
    else {
        var previousSegmentWasGlobStar_1 = false;
        segments.forEach(function (segment, index) {
            // Globstar is special
            if (segment === GLOBSTAR) {
                // if we have more than one globstar after another, just ignore it
                if (!previousSegmentWasGlobStar_1) {
                    regEx += starsToRegExp(2);
                    previousSegmentWasGlobStar_1 = true;
                }
                return;
            }
            // States
            var inBraces = false;
            var braceVal = '';
            var inBrackets = false;
            var bracketVal = '';
            var char;
            for (var i = 0; i < segment.length; i++) {
                char = segment[i];
                // Support brace expansion
                if (char !== '}' && inBraces) {
                    braceVal += char;
                    continue;
                }
                // Support brackets
                if (inBrackets && (char !== ']' || !bracketVal) /* ] is literally only allowed as first character in brackets to match it */) {
                    var res = void 0;
                    // range operator
                    if (char === '-') {
                        res = char;
                    }
                    // negation operator (only valid on first index in bracket)
                    else if ((char === '^' || char === '!') && !bracketVal) {
                        res = '^';
                    }
                    // glob split matching is not allowed within character ranges
                    // see http://man7.org/linux/man-pages/man7/glob.7.html
                    else if (char === GLOB_SPLIT) {
                        res = '';
                    }
                    // anything else gets escaped
                    else {
                        res = __WEBPACK_IMPORTED_MODULE_1__strings_js__["escapeRegExpCharacters"](char);
                    }
                    bracketVal += res;
                    continue;
                }
                switch (char) {
                    case '{':
                        inBraces = true;
                        continue;
                    case '[':
                        inBrackets = true;
                        continue;
                    case '}':
                        var choices = splitGlobAware(braceVal, ',');
                        // Converts {foo,bar} => [foo|bar]
                        var braceRegExp = "(?:" + choices.map(function (c) { return parseRegExp(c); }).join('|') + ")";
                        regEx += braceRegExp;
                        inBraces = false;
                        braceVal = '';
                        break;
                    case ']':
                        regEx += ('[' + bracketVal + ']');
                        inBrackets = false;
                        bracketVal = '';
                        break;
                    case '?':
                        regEx += NO_PATH_REGEX; // 1 ? matches any single character except path separator (/ and \)
                        continue;
                    case '*':
                        regEx += starsToRegExp(1);
                        continue;
                    default:
                        regEx += __WEBPACK_IMPORTED_MODULE_1__strings_js__["escapeRegExpCharacters"](char);
                }
            }
            // Tail: Add the slash we had split on if there is more to come and the remaining pattern is not a globstar
            // For example if pattern: some/**/*.js we want the "/" after some to be included in the RegEx to prevent
            // a folder called "something" to match as well.
            // However, if pattern: some/**, we tolerate that we also match on "something" because our globstar behaviour
            // is to match 0-N segments.
            if (index < segments.length - 1 && (segments[index + 1] !== GLOBSTAR || index + 2 < segments.length)) {
                regEx += PATH_REGEX;
            }
            // reset state
            previousSegmentWasGlobStar_1 = false;
        });
    }
    return regEx;
}
// regexes to check for trival glob patterns that just check for String#endsWith
var T1 = /^\*\*\/\*\.[\w\.-]+$/; // **/*.something
var T2 = /^\*\*\/([\w\.-]+)\/?$/; // **/something
var T3 = /^{\*\*\/[\*\.]?[\w\.-]+\/?(,\*\*\/[\*\.]?[\w\.-]+\/?)*}$/; // {**/*.something,**/*.else} or {**/package.json,**/project.json}
var T3_2 = /^{\*\*\/[\*\.]?[\w\.-]+(\/(\*\*)?)?(,\*\*\/[\*\.]?[\w\.-]+(\/(\*\*)?)?)*}$/; // Like T3, with optional trailing /**
var T4 = /^\*\*((\/[\w\.-]+)+)\/?$/; // **/something/else
var T5 = /^([\w\.-]+(\/[\w\.-]+)*)\/?$/; // something/else
var CACHE = new __WEBPACK_IMPORTED_MODULE_3__map_js__["a" /* LRUCache */](10000); // bounded to 10000 elements
var FALSE = function () {
    return false;
};
var NULL = function () {
    return null;
};
function parsePattern(arg1, options) {
    if (!arg1) {
        return NULL;
    }
    // Handle IRelativePattern
    var pattern;
    if (typeof arg1 !== 'string') {
        pattern = arg1.pattern;
    }
    else {
        pattern = arg1;
    }
    // Whitespace trimming
    pattern = pattern.trim();
    // Check cache
    var patternKey = pattern + "_" + !!options.trimForExclusions;
    var parsedPattern = CACHE.get(patternKey);
    if (parsedPattern) {
        return wrapRelativePattern(parsedPattern, arg1);
    }
    // Check for Trivias
    var match;
    if (T1.test(pattern)) { // common pattern: **/*.txt just need endsWith check
        var base_1 = pattern.substr(4); // '**/*'.length === 4
        parsedPattern = function (path, basename) {
            return path && __WEBPACK_IMPORTED_MODULE_1__strings_js__["endsWith"](path, base_1) ? pattern : null;
        };
    }
    else if (match = T2.exec(trimForExclusions(pattern, options))) { // common pattern: **/some.txt just need basename check
        parsedPattern = trivia2(match[1], pattern);
    }
    else if ((options.trimForExclusions ? T3_2 : T3).test(pattern)) { // repetition of common patterns (see above) {**/*.txt,**/*.png}
        parsedPattern = trivia3(pattern, options);
    }
    else if (match = T4.exec(trimForExclusions(pattern, options))) { // common pattern: **/something/else just need endsWith check
        parsedPattern = trivia4and5(match[1].substr(1), pattern, true);
    }
    else if (match = T5.exec(trimForExclusions(pattern, options))) { // common pattern: something/else just need equals check
        parsedPattern = trivia4and5(match[1], pattern, false);
    }
    // Otherwise convert to pattern
    else {
        parsedPattern = toRegExp(pattern);
    }
    // Cache
    CACHE.set(patternKey, parsedPattern);
    return wrapRelativePattern(parsedPattern, arg1);
}
function wrapRelativePattern(parsedPattern, arg2) {
    if (typeof arg2 === 'string') {
        return parsedPattern;
    }
    return function (path, basename) {
        if (!__WEBPACK_IMPORTED_MODULE_2__paths_js__["e" /* isEqualOrParent */](path, arg2.base)) {
            return null;
        }
        return parsedPattern(__WEBPACK_IMPORTED_MODULE_2__paths_js__["h" /* normalize */](arg2.pathToRelative(arg2.base, path)), basename);
    };
}
function trimForExclusions(pattern, options) {
    return options.trimForExclusions && __WEBPACK_IMPORTED_MODULE_1__strings_js__["endsWith"](pattern, '/**') ? pattern.substr(0, pattern.length - 2) : pattern; // dropping **, tailing / is dropped later
}
// common pattern: **/some.txt just need basename check
function trivia2(base, originalPattern) {
    var slashBase = "/" + base;
    var backslashBase = "\\" + base;
    var parsedPattern = function (path, basename) {
        if (!path) {
            return null;
        }
        if (basename) {
            return basename === base ? originalPattern : null;
        }
        return path === base || __WEBPACK_IMPORTED_MODULE_1__strings_js__["endsWith"](path, slashBase) || __WEBPACK_IMPORTED_MODULE_1__strings_js__["endsWith"](path, backslashBase) ? originalPattern : null;
    };
    var basenames = [base];
    parsedPattern.basenames = basenames;
    parsedPattern.patterns = [originalPattern];
    parsedPattern.allBasenames = basenames;
    return parsedPattern;
}
// repetition of common patterns (see above) {**/*.txt,**/*.png}
function trivia3(pattern, options) {
    var parsedPatterns = aggregateBasenameMatches(pattern.slice(1, -1).split(',')
        .map(function (pattern) { return parsePattern(pattern, options); })
        .filter(function (pattern) { return pattern !== NULL; }), pattern);
    var n = parsedPatterns.length;
    if (!n) {
        return NULL;
    }
    if (n === 1) {
        return parsedPatterns[0];
    }
    var parsedPattern = function (path, basename) {
        for (var i = 0, n_1 = parsedPatterns.length; i < n_1; i++) {
            if (parsedPatterns[i](path, basename)) {
                return pattern;
            }
        }
        return null;
    };
    var withBasenames = __WEBPACK_IMPORTED_MODULE_0__arrays_js__["g" /* first */](parsedPatterns, function (pattern) { return !!pattern.allBasenames; });
    if (withBasenames) {
        parsedPattern.allBasenames = withBasenames.allBasenames;
    }
    var allPaths = parsedPatterns.reduce(function (all, current) { return current.allPaths ? all.concat(current.allPaths) : all; }, []);
    if (allPaths.length) {
        parsedPattern.allPaths = allPaths;
    }
    return parsedPattern;
}
// common patterns: **/something/else just need endsWith check, something/else just needs and equals check
function trivia4and5(path, pattern, matchPathEnds) {
    var nativePath = __WEBPACK_IMPORTED_MODULE_2__paths_js__["g" /* nativeSep */] !== __WEBPACK_IMPORTED_MODULE_2__paths_js__["i" /* sep */] ? path.replace(ALL_FORWARD_SLASHES, __WEBPACK_IMPORTED_MODULE_2__paths_js__["g" /* nativeSep */]) : path;
    var nativePathEnd = __WEBPACK_IMPORTED_MODULE_2__paths_js__["g" /* nativeSep */] + nativePath;
    var parsedPattern = matchPathEnds ? function (path, basename) {
        return path && (path === nativePath || __WEBPACK_IMPORTED_MODULE_1__strings_js__["endsWith"](path, nativePathEnd)) ? pattern : null;
    } : function (path, basename) {
        return path && path === nativePath ? pattern : null;
    };
    parsedPattern.allPaths = [(matchPathEnds ? '*/' : './') + path];
    return parsedPattern;
}
function toRegExp(pattern) {
    try {
        var regExp_1 = new RegExp("^" + parseRegExp(pattern) + "$");
        return function (path, basename) {
            regExp_1.lastIndex = 0; // reset RegExp to its initial state to reuse it!
            return path && regExp_1.test(path) ? pattern : null;
        };
    }
    catch (error) {
        return NULL;
    }
}
function match(arg1, path, hasSibling) {
    if (!arg1 || !path) {
        return false;
    }
    return parse(arg1)(path, undefined, hasSibling);
}
function parse(arg1, options) {
    if (options === void 0) { options = {}; }
    if (!arg1) {
        return FALSE;
    }
    // Glob with String
    if (typeof arg1 === 'string' || isRelativePattern(arg1)) {
        var parsedPattern_1 = parsePattern(arg1, options);
        if (parsedPattern_1 === NULL) {
            return FALSE;
        }
        var resultPattern = function (path, basename) {
            return !!parsedPattern_1(path, basename);
        };
        if (parsedPattern_1.allBasenames) {
            resultPattern.allBasenames = parsedPattern_1.allBasenames;
        }
        if (parsedPattern_1.allPaths) {
            resultPattern.allPaths = parsedPattern_1.allPaths;
        }
        return resultPattern;
    }
    // Glob with Expression
    return parsedExpression(arg1, options);
}
function isRelativePattern(obj) {
    var rp = obj;
    return rp && typeof rp.base === 'string' && typeof rp.pattern === 'string' && typeof rp.pathToRelative === 'function';
}
function parsedExpression(expression, options) {
    var parsedPatterns = aggregateBasenameMatches(Object.getOwnPropertyNames(expression)
        .map(function (pattern) { return parseExpressionPattern(pattern, expression[pattern], options); })
        .filter(function (pattern) { return pattern !== NULL; }));
    var n = parsedPatterns.length;
    if (!n) {
        return NULL;
    }
    if (!parsedPatterns.some(function (parsedPattern) { return parsedPattern.requiresSiblings; })) {
        if (n === 1) {
            return parsedPatterns[0];
        }
        var resultExpression_1 = function (path, basename) {
            for (var i = 0, n_2 = parsedPatterns.length; i < n_2; i++) {
                // Pattern matches path
                var result = parsedPatterns[i](path, basename);
                if (result) {
                    return result;
                }
            }
            return null;
        };
        var withBasenames_1 = __WEBPACK_IMPORTED_MODULE_0__arrays_js__["g" /* first */](parsedPatterns, function (pattern) { return !!pattern.allBasenames; });
        if (withBasenames_1) {
            resultExpression_1.allBasenames = withBasenames_1.allBasenames;
        }
        var allPaths_1 = parsedPatterns.reduce(function (all, current) { return current.allPaths ? all.concat(current.allPaths) : all; }, []);
        if (allPaths_1.length) {
            resultExpression_1.allPaths = allPaths_1;
        }
        return resultExpression_1;
    }
    var resultExpression = function (path, basename, hasSibling) {
        var name;
        for (var i = 0, n_3 = parsedPatterns.length; i < n_3; i++) {
            // Pattern matches path
            var parsedPattern = parsedPatterns[i];
            if (parsedPattern.requiresSiblings && hasSibling) {
                if (!basename) {
                    basename = __WEBPACK_IMPORTED_MODULE_2__paths_js__["a" /* basename */](path);
                }
                if (!name) {
                    name = basename.substr(0, basename.length - __WEBPACK_IMPORTED_MODULE_2__paths_js__["c" /* extname */](path).length);
                }
            }
            var result = parsedPattern(path, basename, name, hasSibling);
            if (result) {
                return result;
            }
        }
        return null;
    };
    var withBasenames = __WEBPACK_IMPORTED_MODULE_0__arrays_js__["g" /* first */](parsedPatterns, function (pattern) { return !!pattern.allBasenames; });
    if (withBasenames) {
        resultExpression.allBasenames = withBasenames.allBasenames;
    }
    var allPaths = parsedPatterns.reduce(function (all, current) { return current.allPaths ? all.concat(current.allPaths) : all; }, []);
    if (allPaths.length) {
        resultExpression.allPaths = allPaths;
    }
    return resultExpression;
}
function parseExpressionPattern(pattern, value, options) {
    if (value === false) {
        return NULL; // pattern is disabled
    }
    var parsedPattern = parsePattern(pattern, options);
    if (parsedPattern === NULL) {
        return NULL;
    }
    // Expression Pattern is <boolean>
    if (typeof value === 'boolean') {
        return parsedPattern;
    }
    // Expression Pattern is <SiblingClause>
    if (value) {
        var when_1 = value.when;
        if (typeof when_1 === 'string') {
            var result = function (path, basename, name, hasSibling) {
                if (!hasSibling || !parsedPattern(path, basename)) {
                    return null;
                }
                var clausePattern = when_1.replace('$(basename)', name);
                var matched = hasSibling(clausePattern);
                return __WEBPACK_IMPORTED_MODULE_4__winjs_base_js__["b" /* TPromise */].is(matched) ?
                    matched.then(function (m) { return m ? pattern : null; }) :
                    matched ? pattern : null;
            };
            result.requiresSiblings = true;
            return result;
        }
    }
    // Expression is Anything
    return parsedPattern;
}
function aggregateBasenameMatches(parsedPatterns, result) {
    var basenamePatterns = parsedPatterns.filter(function (parsedPattern) { return !!parsedPattern.basenames; });
    if (basenamePatterns.length < 2) {
        return parsedPatterns;
    }
    var basenames = basenamePatterns.reduce(function (all, current) { return all.concat(current.basenames); }, []);
    var patterns;
    if (result) {
        patterns = [];
        for (var i = 0, n = basenames.length; i < n; i++) {
            patterns.push(result);
        }
    }
    else {
        patterns = basenamePatterns.reduce(function (all, current) { return all.concat(current.patterns); }, []);
    }
    var aggregate = function (path, basename) {
        if (!path) {
            return null;
        }
        if (!basename) {
            var i = void 0;
            for (i = path.length; i > 0; i--) {
                var ch = path.charCodeAt(i - 1);
                if (ch === 47 /* Slash */ || ch === 92 /* Backslash */) {
                    break;
                }
            }
            basename = path.substr(i);
        }
        var index = basenames.indexOf(basename);
        return index !== -1 ? patterns[index] : null;
    };
    aggregate.basenames = basenames;
    aggregate.patterns = patterns;
    aggregate.allBasenames = basenames;
    var aggregatedPatterns = parsedPatterns.filter(function (parsedPattern) { return !parsedPattern.basenames; });
    aggregatedPatterns.push(aggregate);
    return aggregatedPatterns;
}


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AverageBufferSize */
/* unused harmony export createUintArray */
/* unused harmony export LineStarts */
/* harmony export (immutable) */ __webpack_exports__["d"] = createLineStartsFast;
/* harmony export (immutable) */ __webpack_exports__["c"] = createLineStarts;
/* unused harmony export Piece */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StringBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PieceTreeBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__textModelSearch_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






// const lfRegex = new RegExp(/\r\n|\r|\n/g);
var AverageBufferSize = 65535;
function createUintArray(arr) {
    var r;
    if (arr[arr.length - 1] < 65536) {
        r = new Uint16Array(arr.length);
    }
    else {
        r = new Uint32Array(arr.length);
    }
    r.set(arr, 0);
    return r;
}
var LineStarts = /** @class */ (function () {
    function LineStarts(lineStarts, cr, lf, crlf, isBasicASCII) {
        this.lineStarts = lineStarts;
        this.cr = cr;
        this.lf = lf;
        this.crlf = crlf;
        this.isBasicASCII = isBasicASCII;
    }
    return LineStarts;
}());

function createLineStartsFast(str, readonly) {
    if (readonly === void 0) { readonly = true; }
    var r = [0], rLength = 1;
    for (var i = 0, len = str.length; i < len; i++) {
        var chr = str.charCodeAt(i);
        if (chr === 13 /* CarriageReturn */) {
            if (i + 1 < len && str.charCodeAt(i + 1) === 10 /* LineFeed */) {
                // \r\n... case
                r[rLength++] = i + 2;
                i++; // skip \n
            }
            else {
                // \r... case
                r[rLength++] = i + 1;
            }
        }
        else if (chr === 10 /* LineFeed */) {
            r[rLength++] = i + 1;
        }
    }
    if (readonly) {
        return createUintArray(r);
    }
    else {
        return r;
    }
}
function createLineStarts(r, str) {
    r.length = 0;
    r[0] = 0;
    var rLength = 1;
    var cr = 0, lf = 0, crlf = 0;
    var isBasicASCII = true;
    for (var i = 0, len = str.length; i < len; i++) {
        var chr = str.charCodeAt(i);
        if (chr === 13 /* CarriageReturn */) {
            if (i + 1 < len && str.charCodeAt(i + 1) === 10 /* LineFeed */) {
                // \r\n... case
                crlf++;
                r[rLength++] = i + 2;
                i++; // skip \n
            }
            else {
                cr++;
                // \r... case
                r[rLength++] = i + 1;
            }
        }
        else if (chr === 10 /* LineFeed */) {
            lf++;
            r[rLength++] = i + 1;
        }
        else {
            if (isBasicASCII) {
                if (chr !== 9 /* Tab */ && (chr < 32 || chr > 126)) {
                    isBasicASCII = false;
                }
            }
        }
    }
    var result = new LineStarts(createUintArray(r), cr, lf, crlf, isBasicASCII);
    r.length = 0;
    return result;
}
var Piece = /** @class */ (function () {
    function Piece(bufferIndex, start, end, lineFeedCnt, length) {
        this.bufferIndex = bufferIndex;
        this.start = start;
        this.end = end;
        this.lineFeedCnt = lineFeedCnt;
        this.length = length;
    }
    return Piece;
}());

var StringBuffer = /** @class */ (function () {
    function StringBuffer(buffer, lineStarts) {
        this.buffer = buffer;
        this.lineStarts = lineStarts;
    }
    return StringBuffer;
}());

var PieceTreeSearchCache = /** @class */ (function () {
    function PieceTreeSearchCache(limit) {
        this._limit = limit;
        this._cache = [];
    }
    PieceTreeSearchCache.prototype.get = function (offset) {
        for (var i = this._cache.length - 1; i >= 0; i--) {
            var nodePos = this._cache[i];
            if (nodePos.nodeStartOffset <= offset && nodePos.nodeStartOffset + nodePos.node.piece.length >= offset) {
                return nodePos;
            }
        }
        return null;
    };
    PieceTreeSearchCache.prototype.get2 = function (lineNumber) {
        for (var i = this._cache.length - 1; i >= 0; i--) {
            var nodePos = this._cache[i];
            if (nodePos.nodeStartLineNumber && nodePos.nodeStartLineNumber < lineNumber && nodePos.nodeStartLineNumber + nodePos.node.piece.lineFeedCnt >= lineNumber) {
                return nodePos;
            }
        }
        return null;
    };
    PieceTreeSearchCache.prototype.set = function (nodePosition) {
        if (this._cache.length >= this._limit) {
            this._cache.shift();
        }
        this._cache.push(nodePosition);
    };
    PieceTreeSearchCache.prototype.valdiate = function (offset) {
        var hasInvalidVal = false;
        for (var i = 0; i < this._cache.length; i++) {
            var nodePos = this._cache[i];
            if (nodePos.node.parent === null || nodePos.nodeStartOffset >= offset) {
                this._cache[i] = null;
                hasInvalidVal = true;
                continue;
            }
        }
        if (hasInvalidVal) {
            var newArr = [];
            for (var i = 0; i < this._cache.length; i++) {
                if (this._cache[i] !== null) {
                    newArr.push(this._cache[i]);
                }
            }
            this._cache = newArr;
        }
    };
    return PieceTreeSearchCache;
}());
var PieceTreeBase = /** @class */ (function () {
    function PieceTreeBase(chunks, eol, eolNormalized) {
        this.create(chunks, eol, eolNormalized);
    }
    PieceTreeBase.prototype.create = function (chunks, eol, eolNormalized) {
        this._buffers = [
            new StringBuffer('', [0])
        ];
        this._lastChangeBufferPos = { line: 0, column: 0 };
        this.root = __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */];
        this._lineCnt = 1;
        this._length = 0;
        this._EOL = eol;
        this._EOLLength = eol.length;
        this._EOLNormalized = eolNormalized;
        var lastNode = null;
        for (var i = 0, len = chunks.length; i < len; i++) {
            if (chunks[i].buffer.length > 0) {
                if (!chunks[i].lineStarts) {
                    chunks[i].lineStarts = createLineStartsFast(chunks[i].buffer);
                }
                var piece = new Piece(i + 1, { line: 0, column: 0 }, { line: chunks[i].lineStarts.length - 1, column: chunks[i].buffer.length - chunks[i].lineStarts[chunks[i].lineStarts.length - 1] }, chunks[i].lineStarts.length - 1, chunks[i].buffer.length);
                this._buffers.push(chunks[i]);
                lastNode = this.rbInsertRight(lastNode, piece);
            }
        }
        this._searchCache = new PieceTreeSearchCache(1);
        this._lastVisitedLine = { lineNumber: 0, value: null };
        this.computeBufferMetadata();
    };
    PieceTreeBase.prototype.normalizeEOL = function (eol) {
        var _this = this;
        var averageBufferSize = AverageBufferSize;
        var min = averageBufferSize - Math.floor(averageBufferSize / 3);
        var max = min * 2;
        var tempChunk = '';
        var tempChunkLen = 0;
        var chunks = [];
        this.iterate(this.root, function (node) {
            var str = _this.getNodeContent(node);
            var len = str.length;
            if (tempChunkLen <= min || tempChunkLen + len < max) {
                tempChunk += str;
                tempChunkLen += len;
                return true;
            }
            // flush anyways
            var text = tempChunk.replace(/\r\n|\r|\n/g, eol);
            chunks.push(new StringBuffer(text, createLineStartsFast(text)));
            tempChunk = str;
            tempChunkLen = len;
            return true;
        });
        if (tempChunkLen > 0) {
            var text = tempChunk.replace(/\r\n|\r|\n/g, eol);
            chunks.push(new StringBuffer(text, createLineStartsFast(text)));
        }
        this.create(chunks, eol, true);
    };
    // #region Buffer API
    PieceTreeBase.prototype.getEOL = function () {
        return this._EOL;
    };
    PieceTreeBase.prototype.setEOL = function (newEOL) {
        this._EOL = newEOL;
        this._EOLLength = this._EOL.length;
        this.normalizeEOL(newEOL);
    };
    PieceTreeBase.prototype.getOffsetAt = function (lineNumber, column) {
        var leftLen = 0; // inorder
        var x = this.root;
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            if (x.left !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */] && x.lf_left + 1 >= lineNumber) {
                x = x.left;
            }
            else if (x.lf_left + x.piece.lineFeedCnt + 1 >= lineNumber) {
                leftLen += x.size_left;
                // lineNumber >= 2
                var accumualtedValInCurrentIndex = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                return leftLen += accumualtedValInCurrentIndex + column - 1;
            }
            else {
                lineNumber -= x.lf_left + x.piece.lineFeedCnt;
                leftLen += x.size_left + x.piece.length;
                x = x.right;
            }
        }
        return leftLen;
    };
    PieceTreeBase.prototype.getPositionAt = function (offset) {
        offset = Math.floor(offset);
        offset = Math.max(0, offset);
        var x = this.root;
        var lfCnt = 0;
        var originalOffset = offset;
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            if (x.size_left !== 0 && x.size_left >= offset) {
                x = x.left;
            }
            else if (x.size_left + x.piece.length >= offset) {
                var out = this.getIndexOf(x, offset - x.size_left);
                lfCnt += x.lf_left + out.index;
                if (out.index === 0) {
                    var lineStartOffset = this.getOffsetAt(lfCnt + 1, 1);
                    var column = originalOffset - lineStartOffset;
                    return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lfCnt + 1, column + 1);
                }
                return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lfCnt + 1, out.remainder + 1);
            }
            else {
                offset -= x.size_left + x.piece.length;
                lfCnt += x.lf_left + x.piece.lineFeedCnt;
                if (x.right === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
                    // last node
                    var lineStartOffset = this.getOffsetAt(lfCnt + 1, 1);
                    var column = originalOffset - offset - lineStartOffset;
                    return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lfCnt + 1, column + 1);
                }
                else {
                    x = x.right;
                }
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](1, 1);
    };
    PieceTreeBase.prototype.getValueInRange = function (range, eol) {
        if (range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn) {
            return '';
        }
        var startPosition = this.nodeAt2(range.startLineNumber, range.startColumn);
        var endPosition = this.nodeAt2(range.endLineNumber, range.endColumn);
        var value = this.getValueInRange2(startPosition, endPosition);
        if (eol) {
            if (eol !== this._EOL || !this._EOLNormalized) {
                return value.replace(/\r\n|\r|\n/g, eol);
            }
            if (eol === this.getEOL() && this._EOLNormalized) {
                if (eol === '\r\n') {
                }
                return value;
            }
            return value.replace(/\r\n|\r|\n/g, eol);
        }
        return value;
    };
    PieceTreeBase.prototype.getValueInRange2 = function (startPosition, endPosition) {
        if (startPosition.node === endPosition.node) {
            var node = startPosition.node;
            var buffer_1 = this._buffers[node.piece.bufferIndex].buffer;
            var startOffset_1 = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start);
            return buffer_1.substring(startOffset_1 + startPosition.remainder, startOffset_1 + endPosition.remainder);
        }
        var x = startPosition.node;
        var buffer = this._buffers[x.piece.bufferIndex].buffer;
        var startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
        var ret = buffer.substring(startOffset + startPosition.remainder, startOffset + x.piece.length);
        x = x.next();
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            var buffer_2 = this._buffers[x.piece.bufferIndex].buffer;
            var startOffset_2 = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
            if (x === endPosition.node) {
                ret += buffer_2.substring(startOffset_2, startOffset_2 + endPosition.remainder);
                break;
            }
            else {
                ret += buffer_2.substr(startOffset_2, x.piece.length);
            }
            x = x.next();
        }
        return ret;
    };
    PieceTreeBase.prototype.getLinesContent = function () {
        return this.getContentOfSubTree(this.root).split(/\r\n|\r|\n/);
    };
    PieceTreeBase.prototype.getLength = function () {
        return this._length;
    };
    PieceTreeBase.prototype.getLineCount = function () {
        return this._lineCnt;
    };
    PieceTreeBase.prototype.getLineContent = function (lineNumber) {
        if (this._lastVisitedLine.lineNumber === lineNumber) {
            return this._lastVisitedLine.value;
        }
        this._lastVisitedLine.lineNumber = lineNumber;
        if (lineNumber === this._lineCnt) {
            this._lastVisitedLine.value = this.getLineRawContent(lineNumber);
        }
        else if (this._EOLNormalized) {
            this._lastVisitedLine.value = this.getLineRawContent(lineNumber, this._EOLLength);
        }
        else {
            this._lastVisitedLine.value = this.getLineRawContent(lineNumber).replace(/(\r\n|\r|\n)$/, '');
        }
        return this._lastVisitedLine.value;
    };
    PieceTreeBase.prototype.getLineCharCode = function (lineNumber, index) {
        var nodePos = this.nodeAt2(lineNumber, index + 1);
        if (nodePos.remainder === nodePos.node.piece.length) {
            // the char we want to fetch is at the head of next node.
            var matchingNode = nodePos.node.next();
            if (!matchingNode) {
                return 0;
            }
            var buffer = this._buffers[matchingNode.piece.bufferIndex];
            var startOffset = this.offsetInBuffer(matchingNode.piece.bufferIndex, matchingNode.piece.start);
            return buffer.buffer.charCodeAt(startOffset);
        }
        else {
            var buffer = this._buffers[nodePos.node.piece.bufferIndex];
            var startOffset = this.offsetInBuffer(nodePos.node.piece.bufferIndex, nodePos.node.piece.start);
            var targetOffset = startOffset + nodePos.remainder;
            return buffer.buffer.charCodeAt(targetOffset);
        }
    };
    PieceTreeBase.prototype.getLineLength = function (lineNumber) {
        if (lineNumber === this.getLineCount()) {
            var startOffset = this.getOffsetAt(lineNumber, 1);
            return this.getLength() - startOffset;
        }
        return this.getOffsetAt(lineNumber + 1, 1) - this.getOffsetAt(lineNumber, 1) - this._EOLLength;
    };
    PieceTreeBase.prototype.findMatchesInNode = function (node, searcher, startLineNumber, startColumn, startCursor, endCursor, searchData, captureMatches, limitResultCount, resultLen, result) {
        var buffer = this._buffers[node.piece.bufferIndex];
        var startOffsetInBuffer = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start);
        var start = this.offsetInBuffer(node.piece.bufferIndex, startCursor);
        var end = this.offsetInBuffer(node.piece.bufferIndex, endCursor);
        var m;
        // Reset regex to search from the beginning
        searcher.reset(start);
        var ret = { line: 0, column: 0 };
        do {
            m = searcher.next(buffer.buffer);
            if (m) {
                if (m.index >= end) {
                    return resultLen;
                }
                this.positionInBuffer(node, m.index - startOffsetInBuffer, ret);
                var lineFeedCnt = this.getLineFeedCnt(node.piece.bufferIndex, startCursor, ret);
                var retStartColumn = ret.line === startCursor.line ? ret.column - startCursor.column + startColumn : ret.column + 1;
                var retEndColumn = retStartColumn + m[0].length;
                result[resultLen++] = Object(__WEBPACK_IMPORTED_MODULE_3__textModelSearch_js__["d" /* createFindMatch */])(new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](startLineNumber + lineFeedCnt, retStartColumn, startLineNumber + lineFeedCnt, retEndColumn), m, captureMatches);
                if (m.index + m[0].length >= end) {
                    return resultLen;
                }
                if (resultLen >= limitResultCount) {
                    return resultLen;
                }
            }
        } while (m);
        return resultLen;
    };
    PieceTreeBase.prototype.findMatchesLineByLine = function (searchRange, searchData, captureMatches, limitResultCount) {
        var result = [];
        var resultLen = 0;
        var searcher = new __WEBPACK_IMPORTED_MODULE_3__textModelSearch_js__["b" /* Searcher */](searchData.wordSeparators, searchData.regex);
        var startPostion = this.nodeAt2(searchRange.startLineNumber, searchRange.startColumn);
        if (startPostion === null) {
            return [];
        }
        var endPosition = this.nodeAt2(searchRange.endLineNumber, searchRange.endColumn);
        if (endPosition === null) {
            return [];
        }
        var start = this.positionInBuffer(startPostion.node, startPostion.remainder);
        var end = this.positionInBuffer(endPosition.node, endPosition.remainder);
        if (startPostion.node === endPosition.node) {
            this.findMatchesInNode(startPostion.node, searcher, searchRange.startLineNumber, searchRange.startColumn, start, end, searchData, captureMatches, limitResultCount, resultLen, result);
            return result;
        }
        var startLineNumber = searchRange.startLineNumber;
        var currentNode = startPostion.node;
        while (currentNode !== endPosition.node) {
            var lineBreakCnt = this.getLineFeedCnt(currentNode.piece.bufferIndex, start, currentNode.piece.end);
            if (lineBreakCnt >= 1) {
                // last line break position
                var lineStarts = this._buffers[currentNode.piece.bufferIndex].lineStarts;
                var startOffsetInBuffer = this.offsetInBuffer(currentNode.piece.bufferIndex, currentNode.piece.start);
                var nextLineStartOffset = lineStarts[start.line + lineBreakCnt];
                var startColumn_1 = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn : 1;
                resultLen = this.findMatchesInNode(currentNode, searcher, startLineNumber, startColumn_1, start, this.positionInBuffer(currentNode, nextLineStartOffset - startOffsetInBuffer), searchData, captureMatches, limitResultCount, resultLen, result);
                if (resultLen >= limitResultCount) {
                    return result;
                }
                startLineNumber += lineBreakCnt;
            }
            var startColumn_2 = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn - 1 : 0;
            // search for the remaining content
            if (startLineNumber === searchRange.endLineNumber) {
                var text = this.getLineContent(startLineNumber).substring(startColumn_2, searchRange.endColumn - 1);
                resultLen = this._findMatchesInLine(searchData, searcher, text, searchRange.endLineNumber, startColumn_2, resultLen, result, captureMatches, limitResultCount);
                return result;
            }
            resultLen = this._findMatchesInLine(searchData, searcher, this.getLineContent(startLineNumber).substr(startColumn_2), startLineNumber, startColumn_2, resultLen, result, captureMatches, limitResultCount);
            if (resultLen >= limitResultCount) {
                return result;
            }
            startLineNumber++;
            startPostion = this.nodeAt2(startLineNumber, 1);
            currentNode = startPostion.node;
            start = this.positionInBuffer(startPostion.node, startPostion.remainder);
        }
        if (startLineNumber === searchRange.endLineNumber) {
            var startColumn_3 = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn - 1 : 0;
            var text = this.getLineContent(startLineNumber).substring(startColumn_3, searchRange.endColumn - 1);
            resultLen = this._findMatchesInLine(searchData, searcher, text, searchRange.endLineNumber, startColumn_3, resultLen, result, captureMatches, limitResultCount);
            return result;
        }
        var startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn : 1;
        resultLen = this.findMatchesInNode(endPosition.node, searcher, startLineNumber, startColumn, start, end, searchData, captureMatches, limitResultCount, resultLen, result);
        return result;
    };
    PieceTreeBase.prototype._findMatchesInLine = function (searchData, searcher, text, lineNumber, deltaOffset, resultLen, result, captureMatches, limitResultCount) {
        var wordSeparators = searchData.wordSeparators;
        if (!captureMatches && searchData.simpleSearch) {
            var searchString = searchData.simpleSearch;
            var searchStringLen = searchString.length;
            var textLength = text.length;
            var lastMatchIndex = -searchStringLen;
            while ((lastMatchIndex = text.indexOf(searchString, lastMatchIndex + searchStringLen)) !== -1) {
                if (!wordSeparators || Object(__WEBPACK_IMPORTED_MODULE_3__textModelSearch_js__["e" /* isValidMatch */])(wordSeparators, text, textLength, lastMatchIndex, searchStringLen)) {
                    result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_4__model_js__["e" /* FindMatch */](new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](lineNumber, lastMatchIndex + 1 + deltaOffset, lineNumber, lastMatchIndex + 1 + searchStringLen + deltaOffset), null);
                    if (resultLen >= limitResultCount) {
                        return resultLen;
                    }
                }
            }
            return resultLen;
        }
        var m;
        // Reset regex to search from the beginning
        searcher.reset(0);
        do {
            m = searcher.next(text);
            if (m) {
                result[resultLen++] = Object(__WEBPACK_IMPORTED_MODULE_3__textModelSearch_js__["d" /* createFindMatch */])(new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](lineNumber, m.index + 1 + deltaOffset, lineNumber, m.index + 1 + m[0].length + deltaOffset), m, captureMatches);
                if (resultLen >= limitResultCount) {
                    return resultLen;
                }
            }
        } while (m);
        return resultLen;
    };
    // #endregion
    // #region Piece Table
    PieceTreeBase.prototype.insert = function (offset, value, eolNormalized) {
        if (eolNormalized === void 0) { eolNormalized = false; }
        this._EOLNormalized = this._EOLNormalized && eolNormalized;
        this._lastVisitedLine.lineNumber = 0;
        this._lastVisitedLine.value = null;
        if (this.root !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            var _a = this.nodeAt(offset), node = _a.node, remainder = _a.remainder, nodeStartOffset = _a.nodeStartOffset;
            var piece = node.piece;
            var bufferIndex = piece.bufferIndex;
            var insertPosInBuffer = this.positionInBuffer(node, remainder);
            if (node.piece.bufferIndex === 0 &&
                piece.end.line === this._lastChangeBufferPos.line &&
                piece.end.column === this._lastChangeBufferPos.column &&
                (nodeStartOffset + piece.length === offset) &&
                value.length < AverageBufferSize) {
                // changed buffer
                this.appendToNode(node, value);
                this.computeBufferMetadata();
                return;
            }
            if (nodeStartOffset === offset) {
                this.insertContentToNodeLeft(value, node);
                this._searchCache.valdiate(offset);
            }
            else if (nodeStartOffset + node.piece.length > offset) {
                // we are inserting into the middle of a node.
                var nodesToDel = [];
                var newRightPiece = new Piece(piece.bufferIndex, insertPosInBuffer, piece.end, this.getLineFeedCnt(piece.bufferIndex, insertPosInBuffer, piece.end), this.offsetInBuffer(bufferIndex, piece.end) - this.offsetInBuffer(bufferIndex, insertPosInBuffer));
                if (this.shouldCheckCRLF() && this.endWithCR(value)) {
                    var headOfRight = this.nodeCharCodeAt(node, remainder);
                    if (headOfRight === 10 /** \n */) {
                        var newStart = { line: newRightPiece.start.line + 1, column: 0 };
                        newRightPiece = new Piece(newRightPiece.bufferIndex, newStart, newRightPiece.end, this.getLineFeedCnt(newRightPiece.bufferIndex, newStart, newRightPiece.end), newRightPiece.length - 1);
                        value += '\n';
                    }
                }
                // reuse node for content before insertion point.
                if (this.shouldCheckCRLF() && this.startWithLF(value)) {
                    var tailOfLeft = this.nodeCharCodeAt(node, remainder - 1);
                    if (tailOfLeft === 13 /** \r */) {
                        var previousPos = this.positionInBuffer(node, remainder - 1);
                        this.deleteNodeTail(node, previousPos);
                        value = '\r' + value;
                        if (node.piece.length === 0) {
                            nodesToDel.push(node);
                        }
                    }
                    else {
                        this.deleteNodeTail(node, insertPosInBuffer);
                    }
                }
                else {
                    this.deleteNodeTail(node, insertPosInBuffer);
                }
                var newPieces = this.createNewPieces(value);
                if (newRightPiece.length > 0) {
                    this.rbInsertRight(node, newRightPiece);
                }
                var tmpNode = node;
                for (var k = 0; k < newPieces.length; k++) {
                    tmpNode = this.rbInsertRight(tmpNode, newPieces[k]);
                }
                this.deleteNodes(nodesToDel);
            }
            else {
                this.insertContentToNodeRight(value, node);
            }
        }
        else {
            // insert new node
            var pieces = this.createNewPieces(value);
            var node = this.rbInsertLeft(null, pieces[0]);
            for (var k = 1; k < pieces.length; k++) {
                node = this.rbInsertRight(node, pieces[k]);
            }
        }
        // todo, this is too brutal. Total line feed count should be updated the same way as lf_left.
        this.computeBufferMetadata();
    };
    PieceTreeBase.prototype.delete = function (offset, cnt) {
        this._lastVisitedLine.lineNumber = 0;
        this._lastVisitedLine.value = null;
        if (cnt <= 0 || this.root === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            return;
        }
        var startPosition = this.nodeAt(offset);
        var endPosition = this.nodeAt(offset + cnt);
        var startNode = startPosition.node;
        var endNode = endPosition.node;
        if (startNode === endNode) {
            var startSplitPosInBuffer_1 = this.positionInBuffer(startNode, startPosition.remainder);
            var endSplitPosInBuffer_1 = this.positionInBuffer(startNode, endPosition.remainder);
            if (startPosition.nodeStartOffset === offset) {
                if (cnt === startNode.piece.length) { // delete node
                    var next = startNode.next();
                    Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["e" /* rbDelete */])(this, startNode);
                    this.validateCRLFWithPrevNode(next);
                    this.computeBufferMetadata();
                    return;
                }
                this.deleteNodeHead(startNode, endSplitPosInBuffer_1);
                this._searchCache.valdiate(offset);
                this.validateCRLFWithPrevNode(startNode);
                this.computeBufferMetadata();
                return;
            }
            if (startPosition.nodeStartOffset + startNode.piece.length === offset + cnt) {
                this.deleteNodeTail(startNode, startSplitPosInBuffer_1);
                this.validateCRLFWithNextNode(startNode);
                this.computeBufferMetadata();
                return;
            }
            // delete content in the middle, this node will be splitted to nodes
            this.shrinkNode(startNode, startSplitPosInBuffer_1, endSplitPosInBuffer_1);
            this.computeBufferMetadata();
            return;
        }
        var nodesToDel = [];
        var startSplitPosInBuffer = this.positionInBuffer(startNode, startPosition.remainder);
        this.deleteNodeTail(startNode, startSplitPosInBuffer);
        this._searchCache.valdiate(offset);
        if (startNode.piece.length === 0) {
            nodesToDel.push(startNode);
        }
        // update last touched node
        var endSplitPosInBuffer = this.positionInBuffer(endNode, endPosition.remainder);
        this.deleteNodeHead(endNode, endSplitPosInBuffer);
        if (endNode.piece.length === 0) {
            nodesToDel.push(endNode);
        }
        // delete nodes in between
        var secondNode = startNode.next();
        for (var node = secondNode; node !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */] && node !== endNode; node = node.next()) {
            nodesToDel.push(node);
        }
        var prev = startNode.piece.length === 0 ? startNode.prev() : startNode;
        this.deleteNodes(nodesToDel);
        this.validateCRLFWithNextNode(prev);
        this.computeBufferMetadata();
    };
    PieceTreeBase.prototype.insertContentToNodeLeft = function (value, node) {
        // we are inserting content to the beginning of node
        var nodesToDel = [];
        if (this.shouldCheckCRLF() && this.endWithCR(value) && this.startWithLF(node)) {
            // move `\n` to new node.
            var piece = node.piece;
            var newStart = { line: piece.start.line + 1, column: 0 };
            var nPiece = new Piece(piece.bufferIndex, newStart, piece.end, this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end), piece.length - 1);
            node.piece = nPiece;
            value += '\n';
            Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, node, -1, -1);
            if (node.piece.length === 0) {
                nodesToDel.push(node);
            }
        }
        var newPieces = this.createNewPieces(value);
        var newNode = this.rbInsertLeft(node, newPieces[newPieces.length - 1]);
        for (var k = newPieces.length - 2; k >= 0; k--) {
            newNode = this.rbInsertLeft(newNode, newPieces[k]);
        }
        this.validateCRLFWithPrevNode(newNode);
        this.deleteNodes(nodesToDel);
    };
    PieceTreeBase.prototype.insertContentToNodeRight = function (value, node) {
        // we are inserting to the right of this node.
        if (this.adjustCarriageReturnFromNext(value, node)) {
            // move \n to the new node.
            value += '\n';
        }
        var newPieces = this.createNewPieces(value);
        var newNode = this.rbInsertRight(node, newPieces[0]);
        var tmpNode = newNode;
        for (var k = 1; k < newPieces.length; k++) {
            tmpNode = this.rbInsertRight(tmpNode, newPieces[k]);
        }
        this.validateCRLFWithPrevNode(newNode);
    };
    PieceTreeBase.prototype.positionInBuffer = function (node, remainder, ret) {
        var piece = node.piece;
        var bufferIndex = node.piece.bufferIndex;
        var lineStarts = this._buffers[bufferIndex].lineStarts;
        var startOffset = lineStarts[piece.start.line] + piece.start.column;
        var offset = startOffset + remainder;
        // binary search offset between startOffset and endOffset
        var low = piece.start.line;
        var high = piece.end.line;
        var mid;
        var midStop;
        var midStart;
        while (low <= high) {
            mid = low + ((high - low) / 2) | 0;
            midStart = lineStarts[mid];
            if (mid === high) {
                break;
            }
            midStop = lineStarts[mid + 1];
            if (offset < midStart) {
                high = mid - 1;
            }
            else if (offset >= midStop) {
                low = mid + 1;
            }
            else {
                break;
            }
        }
        if (ret) {
            ret.line = mid;
            ret.column = offset - midStart;
            return null;
        }
        return {
            line: mid,
            column: offset - midStart
        };
    };
    PieceTreeBase.prototype.getLineFeedCnt = function (bufferIndex, start, end) {
        // we don't need to worry about start: abc\r|\n, or abc|\r, or abc|\n, or abc|\r\n doesn't change the fact that, there is one line break after start.
        // now let's take care of end: abc\r|\n, if end is in between \r and \n, we need to add line feed count by 1
        if (end.column === 0) {
            return end.line - start.line;
        }
        var lineStarts = this._buffers[bufferIndex].lineStarts;
        if (end.line === lineStarts.length - 1) { // it means, there is no \n after end, otherwise, there will be one more lineStart.
            return end.line - start.line;
        }
        var nextLineStartOffset = lineStarts[end.line + 1];
        var endOffset = lineStarts[end.line] + end.column;
        if (nextLineStartOffset > endOffset + 1) { // there are more than 1 character after end, which means it can't be \n
            return end.line - start.line;
        }
        // endOffset + 1 === nextLineStartOffset
        // character at endOffset is \n, so we check the character before first
        // if character at endOffset is \r, end.column is 0 and we can't get here.
        var previousCharOffset = endOffset - 1; // end.column > 0 so it's okay.
        var buffer = this._buffers[bufferIndex].buffer;
        if (buffer.charCodeAt(previousCharOffset) === 13) {
            return end.line - start.line + 1;
        }
        else {
            return end.line - start.line;
        }
    };
    PieceTreeBase.prototype.offsetInBuffer = function (bufferIndex, cursor) {
        var lineStarts = this._buffers[bufferIndex].lineStarts;
        return lineStarts[cursor.line] + cursor.column;
    };
    PieceTreeBase.prototype.deleteNodes = function (nodes) {
        for (var i = 0; i < nodes.length; i++) {
            Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["e" /* rbDelete */])(this, nodes[i]);
        }
    };
    PieceTreeBase.prototype.createNewPieces = function (text) {
        if (text.length > AverageBufferSize) {
            // the content is large, operations like substring, charCode becomes slow
            // so here we split it into smaller chunks, just like what we did for CR/LF normalization
            var newPieces = [];
            while (text.length > AverageBufferSize) {
                var lastChar = text.charCodeAt(AverageBufferSize - 1);
                var splitText = void 0;
                if (lastChar === 13 /* CarriageReturn */ || (lastChar >= 0xd800 && lastChar <= 0xdbff)) {
                    // last character is \r or a high surrogate => keep it back
                    splitText = text.substring(0, AverageBufferSize - 1);
                    text = text.substring(AverageBufferSize - 1);
                }
                else {
                    splitText = text.substring(0, AverageBufferSize);
                    text = text.substring(AverageBufferSize);
                }
                var lineStarts_1 = createLineStartsFast(splitText);
                newPieces.push(new Piece(this._buffers.length, /* buffer index */ { line: 0, column: 0 }, { line: lineStarts_1.length - 1, column: splitText.length - lineStarts_1[lineStarts_1.length - 1] }, lineStarts_1.length - 1, splitText.length));
                this._buffers.push(new StringBuffer(splitText, lineStarts_1));
            }
            var lineStarts_2 = createLineStartsFast(text);
            newPieces.push(new Piece(this._buffers.length, /* buffer index */ { line: 0, column: 0 }, { line: lineStarts_2.length - 1, column: text.length - lineStarts_2[lineStarts_2.length - 1] }, lineStarts_2.length - 1, text.length));
            this._buffers.push(new StringBuffer(text, lineStarts_2));
            return newPieces;
        }
        var startOffset = this._buffers[0].buffer.length;
        var lineStarts = createLineStartsFast(text, false);
        var start = this._lastChangeBufferPos;
        if (this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 1] === startOffset
            && startOffset !== 0
            && this.startWithLF(text)
            && this.endWithCR(this._buffers[0].buffer) // todo, we can check this._lastChangeBufferPos's column as it's the last one
        ) {
            this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line, column: this._lastChangeBufferPos.column + 1 };
            start = this._lastChangeBufferPos;
            for (var i = 0; i < lineStarts.length; i++) {
                lineStarts[i] += startOffset + 1;
            }
            this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
            this._buffers[0].buffer += '_' + text;
            startOffset += 1;
        }
        else {
            if (startOffset !== 0) {
                for (var i = 0; i < lineStarts.length; i++) {
                    lineStarts[i] += startOffset;
                }
            }
            this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
            this._buffers[0].buffer += text;
        }
        var endOffset = this._buffers[0].buffer.length;
        var endIndex = this._buffers[0].lineStarts.length - 1;
        var endColumn = endOffset - this._buffers[0].lineStarts[endIndex];
        var endPos = { line: endIndex, column: endColumn };
        var newPiece = new Piece(0, /** todo */ start, endPos, this.getLineFeedCnt(0, start, endPos), endOffset - startOffset);
        this._lastChangeBufferPos = endPos;
        return [newPiece];
    };
    PieceTreeBase.prototype.getLineRawContent = function (lineNumber, endOffset) {
        if (endOffset === void 0) { endOffset = 0; }
        var x = this.root;
        var ret = '';
        var cache = this._searchCache.get2(lineNumber);
        if (cache) {
            x = cache.node;
            var prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - cache.nodeStartLineNumber - 1);
            var buffer = this._buffers[x.piece.bufferIndex].buffer;
            var startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
            if (cache.nodeStartLineNumber + x.piece.lineFeedCnt === lineNumber) {
                ret = buffer.substring(startOffset + prevAccumualtedValue, startOffset + x.piece.length);
            }
            else {
                var accumualtedValue = this.getAccumulatedValue(x, lineNumber - cache.nodeStartLineNumber);
                return buffer.substring(startOffset + prevAccumualtedValue, startOffset + accumualtedValue - endOffset);
            }
        }
        else {
            var nodeStartOffset = 0;
            var originalLineNumber = lineNumber;
            while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
                if (x.left !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */] && x.lf_left >= lineNumber - 1) {
                    x = x.left;
                }
                else if (x.lf_left + x.piece.lineFeedCnt > lineNumber - 1) {
                    var prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                    var accumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 1);
                    var buffer = this._buffers[x.piece.bufferIndex].buffer;
                    var startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                    nodeStartOffset += x.size_left;
                    this._searchCache.set({
                        node: x,
                        nodeStartOffset: nodeStartOffset,
                        nodeStartLineNumber: originalLineNumber - (lineNumber - 1 - x.lf_left)
                    });
                    return buffer.substring(startOffset + prevAccumualtedValue, startOffset + accumualtedValue - endOffset);
                }
                else if (x.lf_left + x.piece.lineFeedCnt === lineNumber - 1) {
                    var prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                    var buffer = this._buffers[x.piece.bufferIndex].buffer;
                    var startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                    ret = buffer.substring(startOffset + prevAccumualtedValue, startOffset + x.piece.length);
                    break;
                }
                else {
                    lineNumber -= x.lf_left + x.piece.lineFeedCnt;
                    nodeStartOffset += x.size_left + x.piece.length;
                    x = x.right;
                }
            }
        }
        // search in order, to find the node contains end column
        x = x.next();
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            var buffer = this._buffers[x.piece.bufferIndex].buffer;
            if (x.piece.lineFeedCnt > 0) {
                var accumualtedValue = this.getAccumulatedValue(x, 0);
                var startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                ret += buffer.substring(startOffset, startOffset + accumualtedValue - endOffset);
                return ret;
            }
            else {
                var startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                ret += buffer.substr(startOffset, x.piece.length);
            }
            x = x.next();
        }
        return ret;
    };
    PieceTreeBase.prototype.computeBufferMetadata = function () {
        var x = this.root;
        var lfCnt = 1;
        var len = 0;
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            lfCnt += x.lf_left + x.piece.lineFeedCnt;
            len += x.size_left + x.piece.length;
            x = x.right;
        }
        this._lineCnt = lfCnt;
        this._length = len;
        this._searchCache.valdiate(this._length);
    };
    // #region node operations
    PieceTreeBase.prototype.getIndexOf = function (node, accumulatedValue) {
        var piece = node.piece;
        var pos = this.positionInBuffer(node, accumulatedValue);
        var lineCnt = pos.line - piece.start.line;
        if (this.offsetInBuffer(piece.bufferIndex, piece.end) - this.offsetInBuffer(piece.bufferIndex, piece.start) === accumulatedValue) {
            // we are checking the end of this node, so a CRLF check is necessary.
            var realLineCnt = this.getLineFeedCnt(node.piece.bufferIndex, piece.start, pos);
            if (realLineCnt !== lineCnt) {
                // aha yes, CRLF
                return { index: realLineCnt, remainder: 0 };
            }
        }
        return { index: lineCnt, remainder: pos.column };
    };
    PieceTreeBase.prototype.getAccumulatedValue = function (node, index) {
        if (index < 0) {
            return 0;
        }
        var piece = node.piece;
        var lineStarts = this._buffers[piece.bufferIndex].lineStarts;
        var expectedLineStartIndex = piece.start.line + index + 1;
        if (expectedLineStartIndex > piece.end.line) {
            return lineStarts[piece.end.line] + piece.end.column - lineStarts[piece.start.line] - piece.start.column;
        }
        else {
            return lineStarts[expectedLineStartIndex] - lineStarts[piece.start.line] - piece.start.column;
        }
    };
    PieceTreeBase.prototype.deleteNodeTail = function (node, pos) {
        var piece = node.piece;
        var originalLFCnt = piece.lineFeedCnt;
        var originalEndOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
        var newEnd = pos;
        var newEndOffset = this.offsetInBuffer(piece.bufferIndex, newEnd);
        var newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, piece.start, newEnd);
        var lf_delta = newLineFeedCnt - originalLFCnt;
        var size_delta = newEndOffset - originalEndOffset;
        var newLength = piece.length + size_delta;
        node.piece = new Piece(piece.bufferIndex, piece.start, newEnd, newLineFeedCnt, newLength);
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, node, size_delta, lf_delta);
    };
    PieceTreeBase.prototype.deleteNodeHead = function (node, pos) {
        var piece = node.piece;
        var originalLFCnt = piece.lineFeedCnt;
        var originalStartOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
        var newStart = pos;
        var newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end);
        var newStartOffset = this.offsetInBuffer(piece.bufferIndex, newStart);
        var lf_delta = newLineFeedCnt - originalLFCnt;
        var size_delta = originalStartOffset - newStartOffset;
        var newLength = piece.length + size_delta;
        node.piece = new Piece(piece.bufferIndex, newStart, piece.end, newLineFeedCnt, newLength);
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, node, size_delta, lf_delta);
    };
    PieceTreeBase.prototype.shrinkNode = function (node, start, end) {
        var piece = node.piece;
        var originalStartPos = piece.start;
        var originalEndPos = piece.end;
        // old piece, originalStartPos, start
        var oldLength = piece.length;
        var oldLFCnt = piece.lineFeedCnt;
        var newEnd = start;
        var newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, piece.start, newEnd);
        var newLength = this.offsetInBuffer(piece.bufferIndex, start) - this.offsetInBuffer(piece.bufferIndex, originalStartPos);
        node.piece = new Piece(piece.bufferIndex, piece.start, newEnd, newLineFeedCnt, newLength);
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, node, newLength - oldLength, newLineFeedCnt - oldLFCnt);
        // new right piece, end, originalEndPos
        var newPiece = new Piece(piece.bufferIndex, end, originalEndPos, this.getLineFeedCnt(piece.bufferIndex, end, originalEndPos), this.offsetInBuffer(piece.bufferIndex, originalEndPos) - this.offsetInBuffer(piece.bufferIndex, end));
        var newNode = this.rbInsertRight(node, newPiece);
        this.validateCRLFWithPrevNode(newNode);
    };
    PieceTreeBase.prototype.appendToNode = function (node, value) {
        if (this.adjustCarriageReturnFromNext(value, node)) {
            value += '\n';
        }
        var hitCRLF = this.shouldCheckCRLF() && this.startWithLF(value) && this.endWithCR(node);
        var startOffset = this._buffers[0].buffer.length;
        this._buffers[0].buffer += value;
        var lineStarts = createLineStartsFast(value, false);
        for (var i = 0; i < lineStarts.length; i++) {
            lineStarts[i] += startOffset;
        }
        if (hitCRLF) {
            var prevStartOffset = this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 2];
            this._buffers[0].lineStarts.pop();
            // _lastChangeBufferPos is already wrong
            this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line - 1, column: startOffset - prevStartOffset };
        }
        this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
        var endIndex = this._buffers[0].lineStarts.length - 1;
        var endColumn = this._buffers[0].buffer.length - this._buffers[0].lineStarts[endIndex];
        var newEnd = { line: endIndex, column: endColumn };
        var newLength = node.piece.length + value.length;
        var oldLineFeedCnt = node.piece.lineFeedCnt;
        var newLineFeedCnt = this.getLineFeedCnt(0, node.piece.start, newEnd);
        var lf_delta = newLineFeedCnt - oldLineFeedCnt;
        node.piece = new Piece(node.piece.bufferIndex, node.piece.start, newEnd, newLineFeedCnt, newLength);
        this._lastChangeBufferPos = newEnd;
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, node, value.length, lf_delta);
    };
    PieceTreeBase.prototype.nodeAt = function (offset) {
        var x = this.root;
        var cache = this._searchCache.get(offset);
        if (cache) {
            return {
                node: cache.node,
                nodeStartOffset: cache.nodeStartOffset,
                remainder: offset - cache.nodeStartOffset
            };
        }
        var nodeStartOffset = 0;
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            if (x.size_left > offset) {
                x = x.left;
            }
            else if (x.size_left + x.piece.length >= offset) {
                nodeStartOffset += x.size_left;
                var ret = {
                    node: x,
                    remainder: offset - x.size_left,
                    nodeStartOffset: nodeStartOffset
                };
                this._searchCache.set(ret);
                return ret;
            }
            else {
                offset -= x.size_left + x.piece.length;
                nodeStartOffset += x.size_left + x.piece.length;
                x = x.right;
            }
        }
        return null;
    };
    PieceTreeBase.prototype.nodeAt2 = function (lineNumber, column) {
        var x = this.root;
        var nodeStartOffset = 0;
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            if (x.left !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */] && x.lf_left >= lineNumber - 1) {
                x = x.left;
            }
            else if (x.lf_left + x.piece.lineFeedCnt > lineNumber - 1) {
                var prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                var accumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 1);
                nodeStartOffset += x.size_left;
                return {
                    node: x,
                    remainder: Math.min(prevAccumualtedValue + column - 1, accumualtedValue),
                    nodeStartOffset: nodeStartOffset
                };
            }
            else if (x.lf_left + x.piece.lineFeedCnt === lineNumber - 1) {
                var prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                if (prevAccumualtedValue + column - 1 <= x.piece.length) {
                    return {
                        node: x,
                        remainder: prevAccumualtedValue + column - 1,
                        nodeStartOffset: nodeStartOffset
                    };
                }
                else {
                    column -= x.piece.length - prevAccumualtedValue;
                    break;
                }
            }
            else {
                lineNumber -= x.lf_left + x.piece.lineFeedCnt;
                nodeStartOffset += x.size_left + x.piece.length;
                x = x.right;
            }
        }
        // search in order, to find the node contains position.column
        x = x.next();
        while (x !== __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            if (x.piece.lineFeedCnt > 0) {
                var accumualtedValue = this.getAccumulatedValue(x, 0);
                var nodeStartOffset_1 = this.offsetOfNode(x);
                return {
                    node: x,
                    remainder: Math.min(column - 1, accumualtedValue),
                    nodeStartOffset: nodeStartOffset_1
                };
            }
            else {
                if (x.piece.length >= column - 1) {
                    var nodeStartOffset_2 = this.offsetOfNode(x);
                    return {
                        node: x,
                        remainder: column - 1,
                        nodeStartOffset: nodeStartOffset_2
                    };
                }
                else {
                    column -= x.piece.length;
                }
            }
            x = x.next();
        }
        return null;
    };
    PieceTreeBase.prototype.nodeCharCodeAt = function (node, offset) {
        if (node.piece.lineFeedCnt < 1) {
            return -1;
        }
        var buffer = this._buffers[node.piece.bufferIndex];
        var newOffset = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start) + offset;
        return buffer.buffer.charCodeAt(newOffset);
    };
    PieceTreeBase.prototype.offsetOfNode = function (node) {
        if (!node) {
            return 0;
        }
        var pos = node.size_left;
        while (node !== this.root) {
            if (node.parent.right === node) {
                pos += node.parent.size_left + node.parent.piece.length;
            }
            node = node.parent;
        }
        return pos;
    };
    // #endregion
    // #region CRLF
    PieceTreeBase.prototype.shouldCheckCRLF = function () {
        return !(this._EOLNormalized && this._EOL === '\n');
    };
    PieceTreeBase.prototype.startWithLF = function (val) {
        if (typeof val === 'string') {
            return val.charCodeAt(0) === 10;
        }
        if (val === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */] || val.piece.lineFeedCnt === 0) {
            return false;
        }
        var piece = val.piece;
        var lineStarts = this._buffers[piece.bufferIndex].lineStarts;
        var line = piece.start.line;
        var startOffset = lineStarts[line] + piece.start.column;
        if (line === lineStarts.length - 1) {
            // last line, so there is no line feed at the end of this line
            return false;
        }
        var nextLineOffset = lineStarts[line + 1];
        if (nextLineOffset > startOffset + 1) {
            return false;
        }
        return this._buffers[piece.bufferIndex].buffer.charCodeAt(startOffset) === 10;
    };
    PieceTreeBase.prototype.endWithCR = function (val) {
        if (typeof val === 'string') {
            return val.charCodeAt(val.length - 1) === 13;
        }
        if (val === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */] || val.piece.lineFeedCnt === 0) {
            return false;
        }
        return this.nodeCharCodeAt(val, val.piece.length - 1) === 13;
    };
    PieceTreeBase.prototype.validateCRLFWithPrevNode = function (nextNode) {
        if (this.shouldCheckCRLF() && this.startWithLF(nextNode)) {
            var node = nextNode.prev();
            if (this.endWithCR(node)) {
                this.fixCRLF(node, nextNode);
            }
        }
    };
    PieceTreeBase.prototype.validateCRLFWithNextNode = function (node) {
        if (this.shouldCheckCRLF() && this.endWithCR(node)) {
            var nextNode = node.next();
            if (this.startWithLF(nextNode)) {
                this.fixCRLF(node, nextNode);
            }
        }
    };
    PieceTreeBase.prototype.fixCRLF = function (prev, next) {
        var nodesToDel = [];
        // update node
        var lineStarts = this._buffers[prev.piece.bufferIndex].lineStarts;
        var newEnd;
        if (prev.piece.end.column === 0) {
            // it means, last line ends with \r, not \r\n
            newEnd = { line: prev.piece.end.line - 1, column: lineStarts[prev.piece.end.line] - lineStarts[prev.piece.end.line - 1] - 1 };
        }
        else {
            // \r\n
            newEnd = { line: prev.piece.end.line, column: prev.piece.end.column - 1 };
        }
        var prevNewLength = prev.piece.length - 1;
        var prevNewLFCnt = prev.piece.lineFeedCnt - 1;
        prev.piece = new Piece(prev.piece.bufferIndex, prev.piece.start, newEnd, prevNewLFCnt, prevNewLength);
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, prev, -1, -1);
        if (prev.piece.length === 0) {
            nodesToDel.push(prev);
        }
        // update nextNode
        var newStart = { line: next.piece.start.line + 1, column: 0 };
        var newLength = next.piece.length - 1;
        var newLineFeedCnt = this.getLineFeedCnt(next.piece.bufferIndex, newStart, next.piece.end);
        next.piece = new Piece(next.piece.bufferIndex, newStart, next.piece.end, newLineFeedCnt, newLength);
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, next, -1, -1);
        if (next.piece.length === 0) {
            nodesToDel.push(next);
        }
        // create new piece which contains \r\n
        var pieces = this.createNewPieces('\r\n');
        this.rbInsertRight(prev, pieces[0]);
        // delete empty nodes
        for (var i = 0; i < nodesToDel.length; i++) {
            Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["e" /* rbDelete */])(this, nodesToDel[i]);
        }
    };
    PieceTreeBase.prototype.adjustCarriageReturnFromNext = function (value, node) {
        if (this.shouldCheckCRLF() && this.endWithCR(value)) {
            var nextNode = node.next();
            if (this.startWithLF(nextNode)) {
                // move `\n` forward
                value += '\n';
                if (nextNode.piece.length === 1) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["e" /* rbDelete */])(this, nextNode);
                }
                else {
                    var piece = nextNode.piece;
                    var newStart = { line: piece.start.line + 1, column: 0 };
                    var newLength = piece.length - 1;
                    var newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end);
                    nextNode.piece = new Piece(piece.bufferIndex, newStart, piece.end, newLineFeedCnt, newLength);
                    Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["g" /* updateTreeMetadata */])(this, nextNode, -1, -1);
                }
                return true;
            }
        }
        return false;
    };
    // #endregion
    // #endregion
    // #region Tree operations
    PieceTreeBase.prototype.iterate = function (node, callback) {
        if (node === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            return callback(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]);
        }
        var leftRet = this.iterate(node.left, callback);
        if (!leftRet) {
            return leftRet;
        }
        return callback(node) && this.iterate(node.right, callback);
    };
    PieceTreeBase.prototype.getNodeContent = function (node) {
        if (node === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            return '';
        }
        var buffer = this._buffers[node.piece.bufferIndex];
        var currentContent;
        var piece = node.piece;
        var startOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
        var endOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
        currentContent = buffer.buffer.substring(startOffset, endOffset);
        return currentContent;
    };
    /**
     *      node              node
     *     /  \              /  \
     *    a   b    <----   a    b
     *                         /
     *                        z
     */
    PieceTreeBase.prototype.rbInsertRight = function (node, p) {
        var z = new __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["b" /* TreeNode */](p, 1 /* Red */);
        z.left = __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */];
        z.right = __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */];
        z.parent = __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */];
        z.size_left = 0;
        z.lf_left = 0;
        var x = this.root;
        if (x === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            this.root = z;
            z.color = 0 /* Black */;
        }
        else if (node.right === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            node.right = z;
            z.parent = node;
        }
        else {
            var nextNode = Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["d" /* leftest */])(node.right);
            nextNode.left = z;
            z.parent = nextNode;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["c" /* fixInsert */])(this, z);
        return z;
    };
    /**
     *      node              node
     *     /  \              /  \
     *    a   b     ---->   a    b
     *                       \
     *                        z
     */
    PieceTreeBase.prototype.rbInsertLeft = function (node, p) {
        var z = new __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["b" /* TreeNode */](p, 1 /* Red */);
        z.left = __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */];
        z.right = __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */];
        z.parent = __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */];
        z.size_left = 0;
        z.lf_left = 0;
        var x = this.root;
        if (x === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            this.root = z;
            z.color = 0 /* Black */;
        }
        else if (node.left === __WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["a" /* SENTINEL */]) {
            node.left = z;
            z.parent = node;
        }
        else {
            var prevNode = Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["f" /* righttest */])(node.left); // a
            prevNode.right = z;
            z.parent = prevNode;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__rbTreeBase_js__["c" /* fixInsert */])(this, z);
        return z;
    };
    PieceTreeBase.prototype.getContentOfSubTree = function (node) {
        var _this = this;
        var str = '';
        this.iterate(node, function (node) {
            str += _this.getNodeContent(node);
            return true;
        });
        return str;
    };
    return PieceTreeBase;
}());



/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CopyOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextAreaInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var CopyOptions = {
    forceCopyWithSyntaxHighlighting: false
};
/**
 * Writes screen reader content to the textarea and is able to analyze its input events to generate:
 *  - onCut
 *  - onPaste
 *  - onType
 *
 * Composition events are generated for presentation purposes (composition input is reflected in onType).
 */
var TextAreaInput = /** @class */ (function (_super) {
    __extends(TextAreaInput, _super);
    function TextAreaInput(host, textArea) {
        var _this = _super.call(this) || this;
        _this._onFocus = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onFocus = _this._onFocus.event;
        _this._onBlur = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onBlur = _this._onBlur.event;
        _this._onKeyDown = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onKeyDown = _this._onKeyDown.event;
        _this._onKeyUp = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onKeyUp = _this._onKeyUp.event;
        _this._onCut = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onCut = _this._onCut.event;
        _this._onPaste = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onPaste = _this._onPaste.event;
        _this._onType = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onType = _this._onType.event;
        _this._onCompositionStart = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onCompositionStart = _this._onCompositionStart.event;
        _this._onCompositionUpdate = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onCompositionUpdate = _this._onCompositionUpdate.event;
        _this._onCompositionEnd = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onCompositionEnd = _this._onCompositionEnd.event;
        _this._onSelectionChangeRequest = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onSelectionChangeRequest = _this._onSelectionChangeRequest.event;
        _this._host = host;
        _this._textArea = _this._register(new TextAreaWrapper(textArea));
        _this._lastTextAreaEvent = 0 /* none */;
        _this._asyncTriggerCut = _this._register(new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._onCut.fire(); }, 0));
        _this._textAreaState = __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].EMPTY;
        _this.writeScreenReaderContent('ctor');
        _this._hasFocus = false;
        _this._isDoingComposition = false;
        _this._nextCommand = 0 /* Type */;
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["j" /* addStandardDisposableListener */](textArea.domNode, 'keydown', function (e) {
            if (_this._isDoingComposition &&
                (e.keyCode === 109 /* KEY_IN_COMPOSITION */ || e.keyCode === 1 /* Backspace */)) {
                // Stop propagation for keyDown events if the IME is processing key input
                e.stopPropagation();
            }
            if (e.equals(9 /* Escape */)) {
                // Prevent default always for `Esc`, otherwise it will generate a keypress
                // See https://msdn.microsoft.com/en-us/library/ie/ms536939(v=vs.85).aspx
                e.preventDefault();
            }
            _this._onKeyDown.fire(e);
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["j" /* addStandardDisposableListener */](textArea.domNode, 'keyup', function (e) {
            _this._onKeyUp.fire(e);
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'compositionstart', function (e) {
            _this._lastTextAreaEvent = 1 /* compositionstart */;
            if (_this._isDoingComposition) {
                return;
            }
            _this._isDoingComposition = true;
            // In IE we cannot set .value when handling 'compositionstart' because the entire composition will get canceled.
            if (!__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["h" /* isEdgeOrIE */]) {
                _this._setAndWriteTextAreaState('compositionstart', __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].EMPTY);
            }
            _this._onCompositionStart.fire();
        }));
        /**
         * Deduce the typed input from a text area's value and the last observed state.
         */
        var deduceInputFromTextAreaValue = function (couldBeEmojiInput, couldBeTypingAtOffset0) {
            var oldState = _this._textAreaState;
            var newState = __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].readFromTextArea(_this._textArea);
            return [newState, __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].deduceInput(oldState, newState, couldBeEmojiInput, couldBeTypingAtOffset0)];
        };
        /**
         * Deduce the composition input from a string.
         */
        var deduceComposition = function (text) {
            var oldState = _this._textAreaState;
            var newState = __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].selectedText(text);
            var typeInput = {
                text: newState.value,
                replaceCharCnt: oldState.selectionEnd - oldState.selectionStart
            };
            return [newState, typeInput];
        };
        var compositionDataInValid = function (locale) {
            // https://github.com/Microsoft/monaco-editor/issues/339
            // Multi-part Japanese compositions reset cursor in Edge/IE, Chinese and Korean IME don't have this issue.
            // The reason that we can't use this path for all CJK IME is IE and Edge behave differently when handling Korean IME,
            // which breaks this path of code.
            if (__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["h" /* isEdgeOrIE */] && locale === 'ja') {
                return true;
            }
            // https://github.com/Microsoft/monaco-editor/issues/545
            // On IE11, we can't trust composition data when typing Chinese as IE11 doesn't emit correct
            // events when users type numbers in IME.
            // Chinese: zh-Hans-CN, zh-Hans-SG, zh-Hant-TW, zh-Hant-HK
            if (__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["k" /* isIE */] && locale.indexOf('zh-Han') === 0) {
                return true;
            }
            return false;
        };
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'compositionupdate', function (e) {
            _this._lastTextAreaEvent = 2 /* compositionupdate */;
            if (compositionDataInValid(e.locale)) {
                var _a = deduceInputFromTextAreaValue(/*couldBeEmojiInput*/ false, /*couldBeTypingAtOffset0*/ false), newState_1 = _a[0], typeInput_1 = _a[1];
                _this._textAreaState = newState_1;
                _this._onType.fire(typeInput_1);
                _this._onCompositionUpdate.fire(e);
                return;
            }
            var _b = deduceComposition(e.data), newState = _b[0], typeInput = _b[1];
            _this._textAreaState = newState;
            _this._onType.fire(typeInput);
            _this._onCompositionUpdate.fire(e);
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'compositionend', function (e) {
            _this._lastTextAreaEvent = 3 /* compositionend */;
            if (compositionDataInValid(e.locale)) {
                // https://github.com/Microsoft/monaco-editor/issues/339
                var _a = deduceInputFromTextAreaValue(/*couldBeEmojiInput*/ false, /*couldBeTypingAtOffset0*/ false), newState = _a[0], typeInput = _a[1];
                _this._textAreaState = newState;
                _this._onType.fire(typeInput);
            }
            else {
                var _b = deduceComposition(e.data), newState = _b[0], typeInput = _b[1];
                _this._textAreaState = newState;
                _this._onType.fire(typeInput);
            }
            // Due to isEdgeOrIE (where the textarea was not cleared initially) and isChrome (the textarea is not updated correctly when composition ends)
            // we cannot assume the text at the end consists only of the composited text
            if (__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["h" /* isEdgeOrIE */] || __WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["f" /* isChrome */]) {
                _this._textAreaState = __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].readFromTextArea(_this._textArea);
            }
            if (!_this._isDoingComposition) {
                return;
            }
            _this._isDoingComposition = false;
            _this._onCompositionEnd.fire();
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'input', function () {
            // We want to find out if this is the first `input` after a `focus`.
            var previousEventWasFocus = (_this._lastTextAreaEvent === 8 /* focus */);
            _this._lastTextAreaEvent = 4 /* input */;
            // Pretend here we touched the text area, as the `input` event will most likely
            // result in a `selectionchange` event which we want to ignore
            _this._textArea.setIgnoreSelectionChangeTime('received input event');
            if (_this._isDoingComposition) {
                return;
            }
            var _a = deduceInputFromTextAreaValue(/*couldBeEmojiInput*/ __WEBPACK_IMPORTED_MODULE_7__base_common_platform_js__["d" /* isMacintosh */], /*couldBeTypingAtOffset0*/ previousEventWasFocus && __WEBPACK_IMPORTED_MODULE_7__base_common_platform_js__["d" /* isMacintosh */]), newState = _a[0], typeInput = _a[1];
            if (typeInput.replaceCharCnt === 0 && typeInput.text.length === 1 && __WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["isHighSurrogate"](typeInput.text.charCodeAt(0))) {
                // Ignore invalid input but keep it around for next time
                return;
            }
            _this._textAreaState = newState;
            if (_this._nextCommand === 0 /* Type */) {
                if (typeInput.text !== '') {
                    _this._onType.fire(typeInput);
                }
            }
            else {
                if (typeInput.text !== '') {
                    _this._onPaste.fire({
                        text: typeInput.text
                    });
                }
                _this._nextCommand = 0 /* Type */;
            }
        }));
        // --- Clipboard operations
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'cut', function (e) {
            _this._lastTextAreaEvent = 5 /* cut */;
            // Pretend here we touched the text area, as the `cut` event will most likely
            // result in a `selectionchange` event which we want to ignore
            _this._textArea.setIgnoreSelectionChangeTime('received cut event');
            _this._ensureClipboardGetsEditorSelection(e);
            _this._asyncTriggerCut.schedule();
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'copy', function (e) {
            _this._lastTextAreaEvent = 6 /* copy */;
            _this._ensureClipboardGetsEditorSelection(e);
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'paste', function (e) {
            _this._lastTextAreaEvent = 7 /* paste */;
            // Pretend here we touched the text area, as the `paste` event will most likely
            // result in a `selectionchange` event which we want to ignore
            _this._textArea.setIgnoreSelectionChangeTime('received paste event');
            if (ClipboardEventUtils.canUseTextData(e)) {
                var pastePlainText = ClipboardEventUtils.getTextData(e);
                if (pastePlainText !== '') {
                    _this._onPaste.fire({
                        text: pastePlainText
                    });
                }
            }
            else {
                if (_this._textArea.getSelectionStart() !== _this._textArea.getSelectionEnd()) {
                    // Clean up the textarea, to get a clean paste
                    _this._setAndWriteTextAreaState('paste', __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].EMPTY);
                }
                _this._nextCommand = 1 /* Paste */;
            }
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'focus', function () {
            _this._lastTextAreaEvent = 8 /* focus */;
            _this._setHasFocus(true);
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](textArea.domNode, 'blur', function () {
            _this._lastTextAreaEvent = 9 /* blur */;
            _this._setHasFocus(false);
        }));
        // See https://github.com/Microsoft/vscode/issues/27216
        // When using a Braille display, it is possible for users to reposition the
        // system caret. This is reflected in Chrome as a `selectionchange` event.
        //
        // The `selectionchange` event appears to be emitted under numerous other circumstances,
        // so it is quite a challenge to distinguish a `selectionchange` coming in from a user
        // using a Braille display from all the other cases.
        //
        // The problems with the `selectionchange` event are:
        //  * the event is emitted when the textarea is focused programmatically -- textarea.focus()
        //  * the event is emitted when the selection is changed in the textarea programatically -- textarea.setSelectionRange(...)
        //  * the event is emitted when the value of the textarea is changed programmatically -- textarea.value = '...'
        //  * the event is emitted when tabbing into the textarea
        //  * the event is emitted asynchronously (sometimes with a delay as high as a few tens of ms)
        //  * the event sometimes comes in bursts for a single logical textarea operation
        // `selectionchange` events often come multiple times for a single logical change
        // so throttle multiple `selectionchange` events that burst in a short period of time.
        var previousSelectionChangeEventTime = 0;
        _this._register(__WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["g" /* addDisposableListener */](document, 'selectionchange', function (e) {
            if (!_this._hasFocus) {
                return;
            }
            if (_this._isDoingComposition) {
                return;
            }
            if (!__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["f" /* isChrome */] || !__WEBPACK_IMPORTED_MODULE_7__base_common_platform_js__["g" /* isWindows */]) {
                // Support only for Chrome on Windows until testing happens on other browsers + OS configurations
                return;
            }
            var now = Date.now();
            var delta1 = now - previousSelectionChangeEventTime;
            previousSelectionChangeEventTime = now;
            if (delta1 < 5) {
                // received another `selectionchange` event within 5ms of the previous `selectionchange` event
                // => ignore it
                return;
            }
            var delta2 = now - _this._textArea.getIgnoreSelectionChangeTime();
            _this._textArea.resetSelectionChangeTime();
            if (delta2 < 100) {
                // received a `selectionchange` event within 100ms since we touched the textarea
                // => ignore it, since we caused it
                return;
            }
            if (!_this._textAreaState.selectionStartPosition || !_this._textAreaState.selectionEndPosition) {
                // Cannot correlate a position in the textarea with a position in the editor...
                return;
            }
            var newValue = _this._textArea.getValue();
            if (_this._textAreaState.value !== newValue) {
                // Cannot correlate a position in the textarea with a position in the editor...
                return;
            }
            var newSelectionStart = _this._textArea.getSelectionStart();
            var newSelectionEnd = _this._textArea.getSelectionEnd();
            if (_this._textAreaState.selectionStart === newSelectionStart && _this._textAreaState.selectionEnd === newSelectionEnd) {
                // Nothing to do...
                return;
            }
            var _newSelectionStartPosition = _this._textAreaState.deduceEditorPosition(newSelectionStart);
            var newSelectionStartPosition = _this._host.deduceModelPosition(_newSelectionStartPosition[0], _newSelectionStartPosition[1], _newSelectionStartPosition[2]);
            var _newSelectionEndPosition = _this._textAreaState.deduceEditorPosition(newSelectionEnd);
            var newSelectionEndPosition = _this._host.deduceModelPosition(_newSelectionEndPosition[0], _newSelectionEndPosition[1], _newSelectionEndPosition[2]);
            var newSelection = new __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__["a" /* Selection */](newSelectionStartPosition.lineNumber, newSelectionStartPosition.column, newSelectionEndPosition.lineNumber, newSelectionEndPosition.column);
            _this._onSelectionChangeRequest.fire(newSelection);
        }));
        return _this;
    }
    TextAreaInput.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    TextAreaInput.prototype.focusTextArea = function () {
        // Setting this._hasFocus and writing the screen reader content
        // will result in a focus() and setSelectionRange() in the textarea
        this._setHasFocus(true);
    };
    TextAreaInput.prototype.isFocused = function () {
        return this._hasFocus;
    };
    TextAreaInput.prototype._setHasFocus = function (newHasFocus) {
        if (this._hasFocus === newHasFocus) {
            // no change
            return;
        }
        this._hasFocus = newHasFocus;
        if (this._hasFocus) {
            if (__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["g" /* isEdge */]) {
                // Edge has a bug where setting the selection range while the focus event
                // is dispatching doesn't work. To reproduce, "tab into" the editor.
                this._setAndWriteTextAreaState('focusgain', __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].EMPTY);
            }
            else {
                this.writeScreenReaderContent('focusgain');
            }
        }
        if (this._hasFocus) {
            this._onFocus.fire();
        }
        else {
            this._onBlur.fire();
        }
    };
    TextAreaInput.prototype._setAndWriteTextAreaState = function (reason, textAreaState) {
        if (!this._hasFocus) {
            textAreaState = textAreaState.collapseSelection();
        }
        textAreaState.writeToTextArea(reason, this._textArea, this._hasFocus);
        this._textAreaState = textAreaState;
    };
    TextAreaInput.prototype.writeScreenReaderContent = function (reason) {
        if (this._isDoingComposition) {
            // Do not write to the text area when doing composition
            return;
        }
        this._setAndWriteTextAreaState(reason, this._host.getScreenReaderContent(this._textAreaState));
    };
    TextAreaInput.prototype._ensureClipboardGetsEditorSelection = function (e) {
        var copyPlainText = this._host.getPlainTextToCopy();
        if (!ClipboardEventUtils.canUseTextData(e)) {
            // Looks like an old browser. The strategy is to place the text
            // we'd like to be copied to the clipboard in the textarea and select it.
            this._setAndWriteTextAreaState('copy or cut', __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].selectedText(copyPlainText));
            return;
        }
        var copyHTML = null;
        if (__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["e" /* hasClipboardSupport */]() && (copyPlainText.length < 65536 || CopyOptions.forceCopyWithSyntaxHighlighting)) {
            copyHTML = this._host.getHTMLToCopy();
        }
        ClipboardEventUtils.setTextData(e, copyPlainText, copyHTML);
    };
    return TextAreaInput;
}(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["a" /* Disposable */]));

var ClipboardEventUtils = /** @class */ (function () {
    function ClipboardEventUtils() {
    }
    ClipboardEventUtils.canUseTextData = function (e) {
        if (e.clipboardData) {
            return true;
        }
        if (window.clipboardData) {
            return true;
        }
        return false;
    };
    ClipboardEventUtils.getTextData = function (e) {
        if (e.clipboardData) {
            e.preventDefault();
            return e.clipboardData.getData('text/plain');
        }
        if (window.clipboardData) {
            e.preventDefault();
            return window.clipboardData.getData('Text');
        }
        throw new Error('ClipboardEventUtils.getTextData: Cannot use text data!');
    };
    ClipboardEventUtils.setTextData = function (e, text, richText) {
        if (e.clipboardData) {
            e.clipboardData.setData('text/plain', text);
            if (richText !== null) {
                e.clipboardData.setData('text/html', richText);
            }
            e.preventDefault();
            return;
        }
        if (window.clipboardData) {
            window.clipboardData.setData('Text', text);
            e.preventDefault();
            return;
        }
        throw new Error('ClipboardEventUtils.setTextData: Cannot use text data!');
    };
    return ClipboardEventUtils;
}());
var TextAreaWrapper = /** @class */ (function (_super) {
    __extends(TextAreaWrapper, _super);
    function TextAreaWrapper(_textArea) {
        var _this = _super.call(this) || this;
        _this._actual = _textArea;
        _this._ignoreSelectionChangeTime = 0;
        return _this;
    }
    TextAreaWrapper.prototype.setIgnoreSelectionChangeTime = function (reason) {
        this._ignoreSelectionChangeTime = Date.now();
    };
    TextAreaWrapper.prototype.getIgnoreSelectionChangeTime = function () {
        return this._ignoreSelectionChangeTime;
    };
    TextAreaWrapper.prototype.resetSelectionChangeTime = function () {
        this._ignoreSelectionChangeTime = 0;
    };
    TextAreaWrapper.prototype.getValue = function () {
        // console.log('current value: ' + this._textArea.value);
        return this._actual.domNode.value;
    };
    TextAreaWrapper.prototype.setValue = function (reason, value) {
        var textArea = this._actual.domNode;
        if (textArea.value === value) {
            // No change
            return;
        }
        // console.log('reason: ' + reason + ', current value: ' + textArea.value + ' => new value: ' + value);
        this.setIgnoreSelectionChangeTime('setValue');
        textArea.value = value;
    };
    TextAreaWrapper.prototype.getSelectionStart = function () {
        return this._actual.domNode.selectionStart;
    };
    TextAreaWrapper.prototype.getSelectionEnd = function () {
        return this._actual.domNode.selectionEnd;
    };
    TextAreaWrapper.prototype.setSelectionRange = function (reason, selectionStart, selectionEnd) {
        var textArea = this._actual.domNode;
        var currentIsFocused = (document.activeElement === textArea);
        var currentSelectionStart = textArea.selectionStart;
        var currentSelectionEnd = textArea.selectionEnd;
        if (currentIsFocused && currentSelectionStart === selectionStart && currentSelectionEnd === selectionEnd) {
            // No change
            // Firefox iframe bug https://github.com/Microsoft/monaco-editor/issues/643#issuecomment-367871377
            if (__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["j" /* isFirefox */] && window.parent !== window) {
                textArea.focus();
            }
            return;
        }
        // console.log('reason: ' + reason + ', setSelectionRange: ' + selectionStart + ' -> ' + selectionEnd);
        if (currentIsFocused) {
            // No need to focus, only need to change the selection range
            this.setIgnoreSelectionChangeTime('setSelectionRange');
            textArea.setSelectionRange(selectionStart, selectionEnd);
            if (__WEBPACK_IMPORTED_MODULE_6__base_browser_browser_js__["j" /* isFirefox */] && window.parent !== window) {
                textArea.focus();
            }
            return;
        }
        // If the focus is outside the textarea, browsers will try really hard to reveal the textarea.
        // Here, we try to undo the browser's desperate reveal.
        try {
            var scrollState = __WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["K" /* saveParentsScrollTop */](textArea);
            this.setIgnoreSelectionChangeTime('setSelectionRange');
            textArea.focus();
            textArea.setSelectionRange(selectionStart, selectionEnd);
            __WEBPACK_IMPORTED_MODULE_8__base_browser_dom_js__["I" /* restoreParentsScrollTop */](textArea, scrollState);
        }
        catch (e) {
            // Sometimes IE throws when setting selection (e.g. textarea is off-DOM)
        }
    };
    return TextAreaWrapper;
}(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["a" /* Disposable */]));


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextAreaState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PagedScreenReaderStrategy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var TextAreaState = /** @class */ (function () {
    function TextAreaState(value, selectionStart, selectionEnd, selectionStartPosition, selectionEndPosition) {
        this.value = value;
        this.selectionStart = selectionStart;
        this.selectionEnd = selectionEnd;
        this.selectionStartPosition = selectionStartPosition;
        this.selectionEndPosition = selectionEndPosition;
    }
    TextAreaState.prototype.toString = function () {
        return '[ <' + this.value + '>, selectionStart: ' + this.selectionStart + ', selectionEnd: ' + this.selectionEnd + ']';
    };
    TextAreaState.readFromTextArea = function (textArea) {
        return new TextAreaState(textArea.getValue(), textArea.getSelectionStart(), textArea.getSelectionEnd(), null, null);
    };
    TextAreaState.prototype.collapseSelection = function () {
        return new TextAreaState(this.value, this.value.length, this.value.length, null, null);
    };
    TextAreaState.prototype.writeToTextArea = function (reason, textArea, select) {
        // console.log(Date.now() + ': writeToTextArea ' + reason + ': ' + this.toString());
        textArea.setValue(reason, this.value);
        if (select) {
            textArea.setSelectionRange(reason, this.selectionStart, this.selectionEnd);
        }
    };
    TextAreaState.prototype.deduceEditorPosition = function (offset) {
        if (offset <= this.selectionStart) {
            var str = this.value.substring(offset, this.selectionStart);
            return this._finishDeduceEditorPosition(this.selectionStartPosition, str, -1);
        }
        if (offset >= this.selectionEnd) {
            var str = this.value.substring(this.selectionEnd, offset);
            return this._finishDeduceEditorPosition(this.selectionEndPosition, str, 1);
        }
        var str1 = this.value.substring(this.selectionStart, offset);
        if (str1.indexOf(String.fromCharCode(8230)) === -1) {
            return this._finishDeduceEditorPosition(this.selectionStartPosition, str1, 1);
        }
        var str2 = this.value.substring(offset, this.selectionEnd);
        return this._finishDeduceEditorPosition(this.selectionEndPosition, str2, -1);
    };
    TextAreaState.prototype._finishDeduceEditorPosition = function (anchor, deltaText, signum) {
        var lineFeedCnt = 0;
        var lastLineFeedIndex = -1;
        while ((lastLineFeedIndex = deltaText.indexOf('\n', lastLineFeedIndex + 1)) !== -1) {
            lineFeedCnt++;
        }
        return [anchor, signum * deltaText.length, lineFeedCnt];
    };
    TextAreaState.selectedText = function (text) {
        return new TextAreaState(text, 0, text.length, null, null);
    };
    TextAreaState.deduceInput = function (previousState, currentState, couldBeEmojiInput, couldBeTypingAtOffset0) {
        if (!previousState) {
            // This is the EMPTY state
            return {
                text: '',
                replaceCharCnt: 0
            };
        }
        // console.log('------------------------deduceInput');
        // console.log('PREVIOUS STATE: ' + previousState.toString());
        // console.log('CURRENT STATE: ' + currentState.toString());
        var previousValue = previousState.value;
        var previousSelectionStart = previousState.selectionStart;
        var previousSelectionEnd = previousState.selectionEnd;
        var currentValue = currentState.value;
        var currentSelectionStart = currentState.selectionStart;
        var currentSelectionEnd = currentState.selectionEnd;
        if (couldBeTypingAtOffset0 && previousValue.length > 0 && previousSelectionStart === previousSelectionEnd && currentSelectionStart === currentSelectionEnd) {
            // See https://github.com/Microsoft/vscode/issues/42251
            // where typing always happens at offset 0 in the textarea
            // when using a custom title area in OSX and moving the window
            if (!__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["startsWith"](currentValue, previousValue) && __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["endsWith"](currentValue, previousValue)) {
                // Looks like something was typed at offset 0
                // ==> pretend we placed the cursor at offset 0 to begin with...
                previousSelectionStart = 0;
                previousSelectionEnd = 0;
            }
        }
        // Strip the previous suffix from the value (without interfering with the current selection)
        var previousSuffix = previousValue.substring(previousSelectionEnd);
        var currentSuffix = currentValue.substring(currentSelectionEnd);
        var suffixLength = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["commonSuffixLength"](previousSuffix, currentSuffix);
        currentValue = currentValue.substring(0, currentValue.length - suffixLength);
        previousValue = previousValue.substring(0, previousValue.length - suffixLength);
        var previousPrefix = previousValue.substring(0, previousSelectionStart);
        var currentPrefix = currentValue.substring(0, currentSelectionStart);
        var prefixLength = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["commonPrefixLength"](previousPrefix, currentPrefix);
        currentValue = currentValue.substring(prefixLength);
        previousValue = previousValue.substring(prefixLength);
        currentSelectionStart -= prefixLength;
        previousSelectionStart -= prefixLength;
        currentSelectionEnd -= prefixLength;
        previousSelectionEnd -= prefixLength;
        // console.log('AFTER DIFFING PREVIOUS STATE: <' + previousValue + '>, selectionStart: ' + previousSelectionStart + ', selectionEnd: ' + previousSelectionEnd);
        // console.log('AFTER DIFFING CURRENT STATE: <' + currentValue + '>, selectionStart: ' + currentSelectionStart + ', selectionEnd: ' + currentSelectionEnd);
        if (couldBeEmojiInput && currentSelectionStart === currentSelectionEnd && previousValue.length > 0) {
            // on OSX, emojis from the emoji picker are inserted at random locations
            // the only hints we can use is that the selection is immediately after the inserted emoji
            // and that none of the old text has been deleted
            var potentialEmojiInput = null;
            if (currentSelectionStart === currentValue.length) {
                // emoji potentially inserted "somewhere" after the previous selection => it should appear at the end of `currentValue`
                if (__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["startsWith"](currentValue, previousValue)) {
                    // only if all of the old text is accounted for
                    potentialEmojiInput = currentValue.substring(previousValue.length);
                }
            }
            else {
                // emoji potentially inserted "somewhere" before the previous selection => it should appear at the start of `currentValue`
                if (__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["endsWith"](currentValue, previousValue)) {
                    // only if all of the old text is accounted for
                    potentialEmojiInput = currentValue.substring(0, currentValue.length - previousValue.length);
                }
            }
            if (potentialEmojiInput !== null && potentialEmojiInput.length > 0) {
                // now we check that this is indeed an emoji
                // emojis can grow quite long, so a length check is of no help
                // e.g. 1F3F4 E0067 E0062 E0065 E006E E0067 E007F  ; fully-qualified     # 🏴󠁧󠁢󠁥󠁮󠁧󠁿 England
                // Oftentimes, emojis use Variation Selector-16 (U+FE0F), so that is a good hint
                // http://emojipedia.org/variation-selector-16/
                // > An invisible codepoint which specifies that the preceding character
                // > should be displayed with emoji presentation. Only required if the
                // > preceding character defaults to text presentation.
                if (/\uFE0F/.test(potentialEmojiInput) || __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["containsEmoji"](potentialEmojiInput)) {
                    return {
                        text: potentialEmojiInput,
                        replaceCharCnt: 0
                    };
                }
            }
        }
        if (currentSelectionStart === currentSelectionEnd) {
            // composition accept case (noticed in FF + Japanese)
            // [blahblah] => blahblah|
            if (previousValue === currentValue
                && previousSelectionStart === 0
                && previousSelectionEnd === previousValue.length
                && currentSelectionStart === currentValue.length
                && currentValue.indexOf('\n') === -1) {
                if (__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["containsFullWidthCharacter"](currentValue)) {
                    return {
                        text: '',
                        replaceCharCnt: 0
                    };
                }
            }
            // no current selection
            var replacePreviousCharacters_1 = (previousPrefix.length - prefixLength);
            // console.log('REMOVE PREVIOUS: ' + (previousPrefix.length - prefixLength) + ' chars');
            return {
                text: currentValue,
                replaceCharCnt: replacePreviousCharacters_1
            };
        }
        // there is a current selection => composition case
        var replacePreviousCharacters = previousSelectionEnd - previousSelectionStart;
        return {
            text: currentValue,
            replaceCharCnt: replacePreviousCharacters
        };
    };
    TextAreaState.EMPTY = new TextAreaState('', 0, 0, null, null);
    return TextAreaState;
}());

var PagedScreenReaderStrategy = /** @class */ (function () {
    function PagedScreenReaderStrategy() {
    }
    PagedScreenReaderStrategy._getPageOfLine = function (lineNumber) {
        return Math.floor((lineNumber - 1) / PagedScreenReaderStrategy._LINES_PER_PAGE);
    };
    PagedScreenReaderStrategy._getRangeForPage = function (page) {
        var offset = page * PagedScreenReaderStrategy._LINES_PER_PAGE;
        var startLineNumber = offset + 1;
        var endLineNumber = offset + PagedScreenReaderStrategy._LINES_PER_PAGE;
        return new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](startLineNumber, 1, endLineNumber + 1, 1);
    };
    PagedScreenReaderStrategy.fromEditorSelection = function (previousState, model, selection, trimLongText) {
        var selectionStartPage = PagedScreenReaderStrategy._getPageOfLine(selection.startLineNumber);
        var selectionStartPageRange = PagedScreenReaderStrategy._getRangeForPage(selectionStartPage);
        var selectionEndPage = PagedScreenReaderStrategy._getPageOfLine(selection.endLineNumber);
        var selectionEndPageRange = PagedScreenReaderStrategy._getRangeForPage(selectionEndPage);
        var pretextRange = selectionStartPageRange.intersectRanges(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](1, 1, selection.startLineNumber, selection.startColumn));
        var pretext = model.getValueInRange(pretextRange, __WEBPACK_IMPORTED_MODULE_2__common_model_js__["c" /* EndOfLinePreference */].LF);
        var lastLine = model.getLineCount();
        var lastLineMaxColumn = model.getLineMaxColumn(lastLine);
        var posttextRange = selectionEndPageRange.intersectRanges(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](selection.endLineNumber, selection.endColumn, lastLine, lastLineMaxColumn));
        var posttext = model.getValueInRange(posttextRange, __WEBPACK_IMPORTED_MODULE_2__common_model_js__["c" /* EndOfLinePreference */].LF);
        var text = null;
        if (selectionStartPage === selectionEndPage || selectionStartPage + 1 === selectionEndPage) {
            // take full selection
            text = model.getValueInRange(selection, __WEBPACK_IMPORTED_MODULE_2__common_model_js__["c" /* EndOfLinePreference */].LF);
        }
        else {
            var selectionRange1 = selectionStartPageRange.intersectRanges(selection);
            var selectionRange2 = selectionEndPageRange.intersectRanges(selection);
            text = (model.getValueInRange(selectionRange1, __WEBPACK_IMPORTED_MODULE_2__common_model_js__["c" /* EndOfLinePreference */].LF)
                + String.fromCharCode(8230)
                + model.getValueInRange(selectionRange2, __WEBPACK_IMPORTED_MODULE_2__common_model_js__["c" /* EndOfLinePreference */].LF));
        }
        // Chromium handles very poorly text even of a few thousand chars
        // Cut text to avoid stalling the entire UI
        if (trimLongText) {
            var LIMIT_CHARS = 500;
            if (pretext.length > LIMIT_CHARS) {
                pretext = pretext.substring(pretext.length - LIMIT_CHARS, pretext.length);
            }
            if (posttext.length > LIMIT_CHARS) {
                posttext = posttext.substring(0, LIMIT_CHARS);
            }
            if (text.length > 2 * LIMIT_CHARS) {
                text = text.substring(0, LIMIT_CHARS) + String.fromCharCode(8230) + text.substring(text.length - LIMIT_CHARS, text.length);
            }
        }
        return new TextAreaState(pretext + text + posttext, pretext.length, pretext.length + text.length, new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](selection.startLineNumber, selection.startColumn), new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](selection.endLineNumber, selection.endColumn));
    };
    PagedScreenReaderStrategy._LINES_PER_PAGE = 10;
    return PagedScreenReaderStrategy;
}());



/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getColors;
/* harmony export (immutable) */ __webpack_exports__["a"] = getColorPresentations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__ = __webpack_require__(44);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








function getColors(model, token) {
    var colors = [];
    var providers = __WEBPACK_IMPORTED_MODULE_2__common_modes_js__["d" /* ColorProviderRegistry */].ordered(model).reverse();
    var promises = providers.map(function (provider) { return Promise.resolve(provider.provideDocumentColors(model, token)).then(function (result) {
        if (Array.isArray(result)) {
            for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
                var colorInfo = result_1[_i];
                colors.push({ colorInfo: colorInfo, provider: provider });
            }
        }
    }); });
    return Promise.all(promises).then(function () { return colors; });
}
function getColorPresentations(model, colorInfo, provider, token) {
    return Promise.resolve(provider.provideColorPresentations(model, colorInfo, token));
}
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["j" /* registerLanguageCommand */])('_executeDocumentColorProvider', function (accessor, args) {
    var resource = args.resource;
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__["a" /* default */])) {
        throw Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
    if (!model) {
        throw Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var rawCIs = [];
    var providers = __WEBPACK_IMPORTED_MODULE_2__common_modes_js__["d" /* ColorProviderRegistry */].ordered(model).reverse();
    var promises = providers.map(function (provider) { return Object(__WEBPACK_IMPORTED_MODULE_3__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return provider.provideDocumentColors(model, token); }).then(function (result) {
        if (Array.isArray(result)) {
            for (var _i = 0, result_2 = result; _i < result_2.length; _i++) {
                var ci = result_2[_i];
                rawCIs.push({ range: ci.range, color: [ci.color.red, ci.color.green, ci.color.blue, ci.color.alpha] });
            }
        }
    }); });
    return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].join(promises).then(function () { return rawCIs; });
});
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["j" /* registerLanguageCommand */])('_executeColorPresentationProvider', function (accessor, args) {
    var resource = args.resource, color = args.color, range = args.range;
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__["a" /* default */]) || !Array.isArray(color) || color.length !== 4 || !__WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].isIRange(range)) {
        throw Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var red = color[0], green = color[1], blue = color[2], alpha = color[3];
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
    if (!model) {
        throw Object(__WEBPACK_IMPORTED_MODULE_6__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var colorInfo = {
        range: range,
        color: { red: red, green: green, blue: blue, alpha: alpha }
    };
    var presentations = [];
    var providers = __WEBPACK_IMPORTED_MODULE_2__common_modes_js__["d" /* ColorProviderRegistry */].ordered(model).reverse();
    var promises = providers.map(function (provider) { return Object(__WEBPACK_IMPORTED_MODULE_3__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return provider.provideColorPresentations(model, colorInfo, token); }).then(function (result) {
        if (Array.isArray(result)) {
            presentations.push.apply(presentations, result);
        }
    }); });
    return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].join(promises).then(function () { return presentations; });
});


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockCommentCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var BlockCommentCommand = /** @class */ (function () {
    function BlockCommentCommand(selection) {
        this._selection = selection;
        this._usedEndToken = null;
    }
    BlockCommentCommand._haystackHasNeedleAtOffset = function (haystack, needle, offset) {
        if (offset < 0) {
            return false;
        }
        var needleLength = needle.length;
        var haystackLength = haystack.length;
        if (offset + needleLength > haystackLength) {
            return false;
        }
        for (var i = 0; i < needleLength; i++) {
            var codeA = haystack.charCodeAt(offset + i);
            var codeB = needle.charCodeAt(i);
            if (codeA === codeB) {
                continue;
            }
            if (codeA >= 65 /* A */ && codeA <= 90 /* Z */ && codeA + 32 === codeB) {
                // codeA is upper-case variant of codeB
                continue;
            }
            if (codeB >= 65 /* A */ && codeB <= 90 /* Z */ && codeB + 32 === codeA) {
                // codeB is upper-case variant of codeA
                continue;
            }
            return false;
        }
        return true;
    };
    BlockCommentCommand.prototype._createOperationsForBlockComment = function (selection, config, model, builder) {
        var startLineNumber = selection.startLineNumber;
        var startColumn = selection.startColumn;
        var endLineNumber = selection.endLineNumber;
        var endColumn = selection.endColumn;
        var startLineText = model.getLineContent(startLineNumber);
        var endLineText = model.getLineContent(endLineNumber);
        var startToken = config.blockCommentStartToken;
        var endToken = config.blockCommentEndToken;
        var startTokenIndex = startLineText.lastIndexOf(startToken, startColumn - 1 + startToken.length);
        var endTokenIndex = endLineText.indexOf(endToken, endColumn - 1 - endToken.length);
        if (startTokenIndex !== -1 && endTokenIndex !== -1) {
            if (startLineNumber === endLineNumber) {
                var lineBetweenTokens = startLineText.substring(startTokenIndex + startToken.length, endTokenIndex);
                if (lineBetweenTokens.indexOf(endToken) >= 0) {
                    // force to add a block comment
                    startTokenIndex = -1;
                    endTokenIndex = -1;
                }
            }
            else {
                var startLineAfterStartToken = startLineText.substring(startTokenIndex + startToken.length);
                var endLineBeforeEndToken = endLineText.substring(0, endTokenIndex);
                if (startLineAfterStartToken.indexOf(endToken) >= 0 || endLineBeforeEndToken.indexOf(endToken) >= 0) {
                    // force to add a block comment
                    startTokenIndex = -1;
                    endTokenIndex = -1;
                }
            }
        }
        var ops;
        if (startTokenIndex !== -1 && endTokenIndex !== -1) {
            // Consider spaces as part of the comment tokens
            if (startTokenIndex + startToken.length < startLineText.length) {
                if (startLineText.charCodeAt(startTokenIndex + startToken.length) === 32 /* Space */) {
                    // Pretend the start token contains a trailing space
                    startToken = startToken + ' ';
                }
            }
            if (endTokenIndex > 0) {
                if (endLineText.charCodeAt(endTokenIndex - 1) === 32 /* Space */) {
                    // Pretend the end token contains a leading space
                    endToken = ' ' + endToken;
                    endTokenIndex -= 1;
                }
            }
            ops = BlockCommentCommand._createRemoveBlockCommentOperations(new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](startLineNumber, startTokenIndex + startToken.length + 1, endLineNumber, endTokenIndex + 1), startToken, endToken);
        }
        else {
            ops = BlockCommentCommand._createAddBlockCommentOperations(selection, startToken, endToken);
            this._usedEndToken = ops.length === 1 ? endToken : null;
        }
        for (var i = 0; i < ops.length; i++) {
            builder.addTrackedEditOperation(ops[i].range, ops[i].text);
        }
    };
    BlockCommentCommand._createRemoveBlockCommentOperations = function (r, startToken, endToken) {
        var res = [];
        if (!__WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].isEmpty(r)) {
            // Remove block comment start
            res.push(__WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].delete(new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](r.startLineNumber, r.startColumn - startToken.length, r.startLineNumber, r.startColumn)));
            // Remove block comment end
            res.push(__WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].delete(new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](r.endLineNumber, r.endColumn, r.endLineNumber, r.endColumn + endToken.length)));
        }
        else {
            // Remove both continuously
            res.push(__WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].delete(new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](r.startLineNumber, r.startColumn - startToken.length, r.endLineNumber, r.endColumn + endToken.length)));
        }
        return res;
    };
    BlockCommentCommand._createAddBlockCommentOperations = function (r, startToken, endToken) {
        var res = [];
        if (!__WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].isEmpty(r)) {
            // Insert block comment start
            res.push(__WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].insert(new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](r.startLineNumber, r.startColumn), startToken + ' '));
            // Insert block comment end
            res.push(__WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].insert(new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](r.endLineNumber, r.endColumn), ' ' + endToken));
        }
        else {
            // Insert both continuously
            res.push(__WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].replace(new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](r.startLineNumber, r.startColumn, r.endLineNumber, r.endColumn), startToken + '  ' + endToken));
        }
        return res;
    };
    BlockCommentCommand.prototype.getEditOperations = function (model, builder) {
        var startLineNumber = this._selection.startLineNumber;
        var startColumn = this._selection.startColumn;
        model.tokenizeIfCheap(startLineNumber);
        var languageId = model.getLanguageIdAtPosition(startLineNumber, startColumn);
        var config = __WEBPACK_IMPORTED_MODULE_4__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getComments(languageId);
        if (!config || !config.blockCommentStartToken || !config.blockCommentEndToken) {
            // Mode does not support block comments
            return;
        }
        this._createOperationsForBlockComment(this._selection, config, model, builder);
    };
    BlockCommentCommand.prototype.computeCursorState = function (model, helper) {
        var inverseEditOperations = helper.getInverseEditOperations();
        if (inverseEditOperations.length === 2) {
            var startTokenEditOperation = inverseEditOperations[0];
            var endTokenEditOperation = inverseEditOperations[1];
            return new __WEBPACK_IMPORTED_MODULE_3__common_core_selection_js__["a" /* Selection */](startTokenEditOperation.range.endLineNumber, startTokenEditOperation.range.endColumn, endTokenEditOperation.range.startLineNumber, endTokenEditOperation.range.startColumn);
        }
        else {
            var srcRange = inverseEditOperations[0].range;
            var deltaColumn = this._usedEndToken ? -this._usedEndToken.length - 1 : 0; // minus 1 space before endToken
            return new __WEBPACK_IMPORTED_MODULE_3__common_core_selection_js__["a" /* Selection */](srcRange.endLineNumber, srcRange.endColumn + deltaColumn, srcRange.endLineNumber, srcRange.endColumn + deltaColumn);
        }
    };
    return BlockCommentCommand;
}());



/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CursorMoveCommands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CursorMove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cursorWordOperations_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_types_js__ = __webpack_require__(31);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/







var CursorMoveCommands = /** @class */ (function () {
    function CursorMoveCommands() {
    }
    CursorMoveCommands.addCursorDown = function (context, cursors, useLogicalLine) {
        var result = [], resultLen = 0;
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */](cursor.modelState, cursor.viewState);
            if (useLogicalLine) {
                result[resultLen++] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].translateDown(context.config, context.model, cursor.modelState));
            }
            else {
                result[resultLen++] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].translateDown(context.config, context.viewModel, cursor.viewState));
            }
        }
        return result;
    };
    CursorMoveCommands.addCursorUp = function (context, cursors, useLogicalLine) {
        var result = [], resultLen = 0;
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */](cursor.modelState, cursor.viewState);
            if (useLogicalLine) {
                result[resultLen++] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].translateUp(context.config, context.model, cursor.modelState));
            }
            else {
                result[resultLen++] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].translateUp(context.config, context.viewModel, cursor.viewState));
            }
        }
        return result;
    };
    CursorMoveCommands.moveToBeginningOfLine = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = this._moveToLineStart(context, cursor, inSelectionMode);
        }
        return result;
    };
    CursorMoveCommands._moveToLineStart = function (context, cursor, inSelectionMode) {
        var currentViewStateColumn = cursor.viewState.position.column;
        var currentModelStateColumn = cursor.modelState.position.column;
        var isFirstLineOfWrappedLine = currentViewStateColumn === currentModelStateColumn;
        var currentViewStatelineNumber = cursor.viewState.position.lineNumber;
        var firstNonBlankColumn = context.viewModel.getLineFirstNonWhitespaceColumn(currentViewStatelineNumber);
        var isBeginningOfViewLine = currentViewStateColumn === firstNonBlankColumn;
        if (!isFirstLineOfWrappedLine && !isBeginningOfViewLine) {
            return this._moveToLineStartByView(context, cursor, inSelectionMode);
        }
        else {
            return this._moveToLineStartByModel(context, cursor, inSelectionMode);
        }
    };
    CursorMoveCommands._moveToLineStartByView = function (context, cursor, inSelectionMode) {
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveToBeginningOfLine(context.config, context.viewModel, cursor.viewState, inSelectionMode));
    };
    CursorMoveCommands._moveToLineStartByModel = function (context, cursor, inSelectionMode) {
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveToBeginningOfLine(context.config, context.model, cursor.modelState, inSelectionMode));
    };
    CursorMoveCommands.moveToEndOfLine = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = this._moveToLineEnd(context, cursor, inSelectionMode);
        }
        return result;
    };
    CursorMoveCommands._moveToLineEnd = function (context, cursor, inSelectionMode) {
        var viewStatePosition = cursor.viewState.position;
        var viewModelMaxColumn = context.viewModel.getLineMaxColumn(viewStatePosition.lineNumber);
        var isEndOfViewLine = viewStatePosition.column === viewModelMaxColumn;
        var modelStatePosition = cursor.modelState.position;
        var modelMaxColumn = context.model.getLineMaxColumn(modelStatePosition.lineNumber);
        var isEndLineOfWrappedLine = viewModelMaxColumn - viewStatePosition.column === modelMaxColumn - modelStatePosition.column;
        if (isEndOfViewLine || isEndLineOfWrappedLine) {
            return this._moveToLineEndByModel(context, cursor, inSelectionMode);
        }
        else {
            return this._moveToLineEndByView(context, cursor, inSelectionMode);
        }
    };
    CursorMoveCommands._moveToLineEndByView = function (context, cursor, inSelectionMode) {
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveToEndOfLine(context.config, context.viewModel, cursor.viewState, inSelectionMode));
    };
    CursorMoveCommands._moveToLineEndByModel = function (context, cursor, inSelectionMode) {
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveToEndOfLine(context.config, context.model, cursor.modelState, inSelectionMode));
    };
    CursorMoveCommands.expandLineSelection = function (context, cursors) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewSelection = cursor.viewState.selection;
            var startLineNumber = viewSelection.startLineNumber;
            var lineCount = context.viewModel.getLineCount();
            var endLineNumber = viewSelection.endLineNumber;
            var endColumn = void 0;
            if (endLineNumber === lineCount) {
                endColumn = context.viewModel.getLineMaxColumn(lineCount);
            }
            else {
                endLineNumber++;
                endColumn = 1;
            }
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](startLineNumber, 1, startLineNumber, 1), 0, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](endLineNumber, endColumn), 0));
        }
        return result;
    };
    CursorMoveCommands.moveToBeginningOfBuffer = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveToBeginningOfBuffer(context.config, context.model, cursor.modelState, inSelectionMode));
        }
        return result;
    };
    CursorMoveCommands.moveToEndOfBuffer = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveToEndOfBuffer(context.config, context.model, cursor.modelState, inSelectionMode));
        }
        return result;
    };
    CursorMoveCommands.selectAll = function (context, cursor) {
        var lineCount = context.model.getLineCount();
        var maxColumn = context.model.getLineMaxColumn(lineCount);
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](1, 1, 1, 1), 0, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineCount, maxColumn), 0));
    };
    CursorMoveCommands.line = function (context, cursor, inSelectionMode, _position, _viewPosition) {
        var position = context.model.validatePosition(_position);
        var viewPosition = (_viewPosition
            ? context.validateViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](_viewPosition.lineNumber, _viewPosition.column), position)
            : context.convertModelPositionToViewPosition(position));
        if (!inSelectionMode || !cursor.modelState.hasSelection()) {
            // Entering line selection for the first time
            var lineCount = context.model.getLineCount();
            var selectToLineNumber = position.lineNumber + 1;
            var selectToColumn = 1;
            if (selectToLineNumber > lineCount) {
                selectToLineNumber = lineCount;
                selectToColumn = context.model.getLineMaxColumn(selectToLineNumber);
            }
            return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](position.lineNumber, 1, selectToLineNumber, selectToColumn), 0, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](selectToLineNumber, selectToColumn), 0));
        }
        // Continuing line selection
        var enteringLineNumber = cursor.modelState.selectionStart.getStartPosition().lineNumber;
        if (position.lineNumber < enteringLineNumber) {
            return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(cursor.viewState.move(cursor.modelState.hasSelection(), viewPosition.lineNumber, 1, 0));
        }
        else if (position.lineNumber > enteringLineNumber) {
            var lineCount = context.viewModel.getLineCount();
            var selectToViewLineNumber = viewPosition.lineNumber + 1;
            var selectToViewColumn = 1;
            if (selectToViewLineNumber > lineCount) {
                selectToViewLineNumber = lineCount;
                selectToViewColumn = context.viewModel.getLineMaxColumn(selectToViewLineNumber);
            }
            return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(cursor.viewState.move(cursor.modelState.hasSelection(), selectToViewLineNumber, selectToViewColumn, 0));
        }
        else {
            var endPositionOfSelectionStart = cursor.modelState.selectionStart.getEndPosition();
            return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(cursor.modelState.move(cursor.modelState.hasSelection(), endPositionOfSelectionStart.lineNumber, endPositionOfSelectionStart.column, 0));
        }
    };
    CursorMoveCommands.word = function (context, cursor, inSelectionMode, _position) {
        var position = context.model.validatePosition(_position);
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_4__cursorWordOperations_js__["a" /* WordOperations */].word(context.config, context.model, cursor.modelState, inSelectionMode, position));
    };
    CursorMoveCommands.cancelSelection = function (context, cursor) {
        if (!cursor.modelState.hasSelection()) {
            return new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */](cursor.modelState, cursor.viewState);
        }
        var lineNumber = cursor.viewState.position.lineNumber;
        var column = cursor.viewState.position.column;
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column), 0, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](lineNumber, column), 0));
    };
    CursorMoveCommands.moveTo = function (context, cursor, inSelectionMode, _position, _viewPosition) {
        var position = context.model.validatePosition(_position);
        var viewPosition = (_viewPosition
            ? context.validateViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](_viewPosition.lineNumber, _viewPosition.column), position)
            : context.convertModelPositionToViewPosition(position));
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(cursor.viewState.move(inSelectionMode, viewPosition.lineNumber, viewPosition.column, 0));
    };
    CursorMoveCommands.move = function (context, cursors, args) {
        var inSelectionMode = args.select;
        var value = args.value;
        switch (args.direction) {
            case 0 /* Left */: {
                if (args.unit === 4 /* HalfLine */) {
                    // Move left by half the current line length
                    return this._moveHalfLineLeft(context, cursors, inSelectionMode);
                }
                else {
                    // Move left by `moveParams.value` columns
                    return this._moveLeft(context, cursors, inSelectionMode, value);
                }
            }
            case 1 /* Right */: {
                if (args.unit === 4 /* HalfLine */) {
                    // Move right by half the current line length
                    return this._moveHalfLineRight(context, cursors, inSelectionMode);
                }
                else {
                    // Move right by `moveParams.value` columns
                    return this._moveRight(context, cursors, inSelectionMode, value);
                }
            }
            case 2 /* Up */: {
                if (args.unit === 2 /* WrappedLine */) {
                    // Move up by view lines
                    return this._moveUpByViewLines(context, cursors, inSelectionMode, value);
                }
                else {
                    // Move up by model lines
                    return this._moveUpByModelLines(context, cursors, inSelectionMode, value);
                }
            }
            case 3 /* Down */: {
                if (args.unit === 2 /* WrappedLine */) {
                    // Move down by view lines
                    return this._moveDownByViewLines(context, cursors, inSelectionMode, value);
                }
                else {
                    // Move down by model lines
                    return this._moveDownByModelLines(context, cursors, inSelectionMode, value);
                }
            }
            case 4 /* WrappedLineStart */: {
                // Move to the beginning of the current view line
                return this._moveToViewMinColumn(context, cursors, inSelectionMode);
            }
            case 5 /* WrappedLineFirstNonWhitespaceCharacter */: {
                // Move to the first non-whitespace column of the current view line
                return this._moveToViewFirstNonWhitespaceColumn(context, cursors, inSelectionMode);
            }
            case 6 /* WrappedLineColumnCenter */: {
                // Move to the "center" of the current view line
                return this._moveToViewCenterColumn(context, cursors, inSelectionMode);
            }
            case 7 /* WrappedLineEnd */: {
                // Move to the end of the current view line
                return this._moveToViewMaxColumn(context, cursors, inSelectionMode);
            }
            case 8 /* WrappedLineLastNonWhitespaceCharacter */: {
                // Move to the last non-whitespace column of the current view line
                return this._moveToViewLastNonWhitespaceColumn(context, cursors, inSelectionMode);
            }
            case 9 /* ViewPortTop */: {
                // Move to the nth line start in the viewport (from the top)
                var cursor = cursors[0];
                var visibleModelRange = context.getCompletelyVisibleModelRange();
                var modelLineNumber = this._firstLineNumberInRange(context.model, visibleModelRange, value);
                var modelColumn = context.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
                return [this._moveToModelPosition(context, cursor, inSelectionMode, modelLineNumber, modelColumn)];
            }
            case 11 /* ViewPortBottom */: {
                // Move to the nth line start in the viewport (from the bottom)
                var cursor = cursors[0];
                var visibleModelRange = context.getCompletelyVisibleModelRange();
                var modelLineNumber = this._lastLineNumberInRange(context.model, visibleModelRange, value);
                var modelColumn = context.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
                return [this._moveToModelPosition(context, cursor, inSelectionMode, modelLineNumber, modelColumn)];
            }
            case 10 /* ViewPortCenter */: {
                // Move to the line start in the viewport center
                var cursor = cursors[0];
                var visibleModelRange = context.getCompletelyVisibleModelRange();
                var modelLineNumber = Math.round((visibleModelRange.startLineNumber + visibleModelRange.endLineNumber) / 2);
                var modelColumn = context.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
                return [this._moveToModelPosition(context, cursor, inSelectionMode, modelLineNumber, modelColumn)];
            }
            case 12 /* ViewPortIfOutside */: {
                // Move to a position inside the viewport
                var visibleViewRange = context.getCompletelyVisibleViewRange();
                var result = [];
                for (var i = 0, len = cursors.length; i < len; i++) {
                    var cursor = cursors[i];
                    result[i] = this.findPositionInViewportIfOutside(context, cursor, visibleViewRange, inSelectionMode);
                }
                return result;
            }
        }
        return null;
    };
    CursorMoveCommands.findPositionInViewportIfOutside = function (context, cursor, visibleViewRange, inSelectionMode) {
        var viewLineNumber = cursor.viewState.position.lineNumber;
        if (visibleViewRange.startLineNumber <= viewLineNumber && viewLineNumber <= visibleViewRange.endLineNumber - 1) {
            // Nothing to do, cursor is in viewport
            return new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */](cursor.modelState, cursor.viewState);
        }
        else {
            if (viewLineNumber > visibleViewRange.endLineNumber - 1) {
                viewLineNumber = visibleViewRange.endLineNumber - 1;
            }
            if (viewLineNumber < visibleViewRange.startLineNumber) {
                viewLineNumber = visibleViewRange.startLineNumber;
            }
            var viewColumn = context.viewModel.getLineFirstNonWhitespaceColumn(viewLineNumber);
            return this._moveToViewPosition(context, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
    };
    /**
     * Find the nth line start included in the range (from the start).
     */
    CursorMoveCommands._firstLineNumberInRange = function (model, range, count) {
        var startLineNumber = range.startLineNumber;
        if (range.startColumn !== model.getLineMinColumn(startLineNumber)) {
            // Move on to the second line if the first line start is not included in the range
            startLineNumber++;
        }
        return Math.min(range.endLineNumber, startLineNumber + count - 1);
    };
    /**
     * Find the nth line start included in the range (from the end).
     */
    CursorMoveCommands._lastLineNumberInRange = function (model, range, count) {
        var startLineNumber = range.startLineNumber;
        if (range.startColumn !== model.getLineMinColumn(startLineNumber)) {
            // Move on to the second line if the first line start is not included in the range
            startLineNumber++;
        }
        return Math.max(startLineNumber, range.endLineNumber - count + 1);
    };
    CursorMoveCommands._moveLeft = function (context, cursors, inSelectionMode, noOfColumns) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var newViewState = __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveLeft(context.config, context.viewModel, cursor.viewState, inSelectionMode, noOfColumns);
            if (noOfColumns === 1 && newViewState.position.lineNumber !== cursor.viewState.position.lineNumber) {
                // moved over to the previous view line
                var newViewModelPosition = context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(newViewState.position);
                if (newViewModelPosition.lineNumber === cursor.modelState.position.lineNumber) {
                    // stayed on the same model line => pass wrapping point where 2 view positions map to a single model position
                    newViewState = __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveLeft(context.config, context.viewModel, newViewState, inSelectionMode, 1);
                }
            }
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(newViewState);
        }
        return result;
    };
    CursorMoveCommands._moveHalfLineLeft = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewLineNumber = cursor.viewState.position.lineNumber;
            var halfLine = Math.round(context.viewModel.getLineContent(viewLineNumber).length / 2);
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveLeft(context.config, context.viewModel, cursor.viewState, inSelectionMode, halfLine));
        }
        return result;
    };
    CursorMoveCommands._moveRight = function (context, cursors, inSelectionMode, noOfColumns) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var newViewState = __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveRight(context.config, context.viewModel, cursor.viewState, inSelectionMode, noOfColumns);
            if (noOfColumns === 1 && newViewState.position.lineNumber !== cursor.viewState.position.lineNumber) {
                // moved over to the next view line
                var newViewModelPosition = context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(newViewState.position);
                if (newViewModelPosition.lineNumber === cursor.modelState.position.lineNumber) {
                    // stayed on the same model line => pass wrapping point where 2 view positions map to a single model position
                    newViewState = __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveRight(context.config, context.viewModel, newViewState, inSelectionMode, 1);
                }
            }
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(newViewState);
        }
        return result;
    };
    CursorMoveCommands._moveHalfLineRight = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewLineNumber = cursor.viewState.position.lineNumber;
            var halfLine = Math.round(context.viewModel.getLineContent(viewLineNumber).length / 2);
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveRight(context.config, context.viewModel, cursor.viewState, inSelectionMode, halfLine));
        }
        return result;
    };
    CursorMoveCommands._moveDownByViewLines = function (context, cursors, inSelectionMode, linesCount) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveDown(context.config, context.viewModel, cursor.viewState, inSelectionMode, linesCount));
        }
        return result;
    };
    CursorMoveCommands._moveDownByModelLines = function (context, cursors, inSelectionMode, linesCount) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveDown(context.config, context.model, cursor.modelState, inSelectionMode, linesCount));
        }
        return result;
    };
    CursorMoveCommands._moveUpByViewLines = function (context, cursors, inSelectionMode, linesCount) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveUp(context.config, context.viewModel, cursor.viewState, inSelectionMode, linesCount));
        }
        return result;
    };
    CursorMoveCommands._moveUpByModelLines = function (context, cursors, inSelectionMode, linesCount) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            result[i] = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(__WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].moveUp(context.config, context.model, cursor.modelState, inSelectionMode, linesCount));
        }
        return result;
    };
    CursorMoveCommands._moveToViewPosition = function (context, cursor, inSelectionMode, toViewLineNumber, toViewColumn) {
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromViewState(cursor.viewState.move(inSelectionMode, toViewLineNumber, toViewColumn, 0));
    };
    CursorMoveCommands._moveToModelPosition = function (context, cursor, inSelectionMode, toModelLineNumber, toModelColumn) {
        return __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */].fromModelState(cursor.modelState.move(inSelectionMode, toModelLineNumber, toModelColumn, 0));
    };
    CursorMoveCommands._moveToViewMinColumn = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewLineNumber = cursor.viewState.position.lineNumber;
            var viewColumn = context.viewModel.getLineMinColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(context, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    };
    CursorMoveCommands._moveToViewFirstNonWhitespaceColumn = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewLineNumber = cursor.viewState.position.lineNumber;
            var viewColumn = context.viewModel.getLineFirstNonWhitespaceColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(context, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    };
    CursorMoveCommands._moveToViewCenterColumn = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewLineNumber = cursor.viewState.position.lineNumber;
            var viewColumn = Math.round((context.viewModel.getLineMaxColumn(viewLineNumber) + context.viewModel.getLineMinColumn(viewLineNumber)) / 2);
            result[i] = this._moveToViewPosition(context, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    };
    CursorMoveCommands._moveToViewMaxColumn = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewLineNumber = cursor.viewState.position.lineNumber;
            var viewColumn = context.viewModel.getLineMaxColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(context, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    };
    CursorMoveCommands._moveToViewLastNonWhitespaceColumn = function (context, cursors, inSelectionMode) {
        var result = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            var cursor = cursors[i];
            var viewLineNumber = cursor.viewState.position.lineNumber;
            var viewColumn = context.viewModel.getLineLastNonWhitespaceColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(context, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    };
    return CursorMoveCommands;
}());

var CursorMove;
(function (CursorMove) {
    var isCursorMoveArgs = function (arg) {
        if (!__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["g" /* isObject */](arg)) {
            return false;
        }
        var cursorMoveArg = arg;
        if (!__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["h" /* isString */](cursorMoveArg.to)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["i" /* isUndefined */](cursorMoveArg.select) && !__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["c" /* isBoolean */](cursorMoveArg.select)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["i" /* isUndefined */](cursorMoveArg.by) && !__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["h" /* isString */](cursorMoveArg.by)) {
            return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["i" /* isUndefined */](cursorMoveArg.value) && !__WEBPACK_IMPORTED_MODULE_5__base_common_types_js__["f" /* isNumber */](cursorMoveArg.value)) {
            return false;
        }
        return true;
    };
    CursorMove.description = {
        description: 'Move cursor to a logical position in the view',
        args: [
            {
                name: 'Cursor move argument object',
                description: "Property-value pairs that can be passed through this argument:\n\t\t\t\t\t* 'to': A mandatory logical position value providing where to move the cursor.\n\t\t\t\t\t\t```\n\t\t\t\t\t\t'left', 'right', 'up', 'down'\n\t\t\t\t\t\t'wrappedLineStart', 'wrappedLineEnd', 'wrappedLineColumnCenter'\n\t\t\t\t\t\t'wrappedLineFirstNonWhitespaceCharacter', 'wrappedLineLastNonWhitespaceCharacter'\n\t\t\t\t\t\t'viewPortTop', 'viewPortCenter', 'viewPortBottom', 'viewPortIfOutside'\n\t\t\t\t\t\t```\n\t\t\t\t\t* 'by': Unit to move. Default is computed based on 'to' value.\n\t\t\t\t\t\t```\n\t\t\t\t\t\t'line', 'wrappedLine', 'character', 'halfLine'\n\t\t\t\t\t\t```\n\t\t\t\t\t* 'value': Number of units to move. Default is '1'.\n\t\t\t\t\t* 'select': If 'true' makes the selection. Default is 'false'.\n\t\t\t\t",
                constraint: isCursorMoveArgs
            }
        ]
    };
    /**
     * Positions in the view for cursor move command.
     */
    CursorMove.RawDirection = {
        Left: 'left',
        Right: 'right',
        Up: 'up',
        Down: 'down',
        WrappedLineStart: 'wrappedLineStart',
        WrappedLineFirstNonWhitespaceCharacter: 'wrappedLineFirstNonWhitespaceCharacter',
        WrappedLineColumnCenter: 'wrappedLineColumnCenter',
        WrappedLineEnd: 'wrappedLineEnd',
        WrappedLineLastNonWhitespaceCharacter: 'wrappedLineLastNonWhitespaceCharacter',
        ViewPortTop: 'viewPortTop',
        ViewPortCenter: 'viewPortCenter',
        ViewPortBottom: 'viewPortBottom',
        ViewPortIfOutside: 'viewPortIfOutside'
    };
    /**
     * Units for Cursor move 'by' argument
     */
    CursorMove.RawUnit = {
        Line: 'line',
        WrappedLine: 'wrappedLine',
        Character: 'character',
        HalfLine: 'halfLine'
    };
    function parse(args) {
        if (!args.to) {
            // illegal arguments
            return null;
        }
        var direction;
        switch (args.to) {
            case CursorMove.RawDirection.Left:
                direction = 0 /* Left */;
                break;
            case CursorMove.RawDirection.Right:
                direction = 1 /* Right */;
                break;
            case CursorMove.RawDirection.Up:
                direction = 2 /* Up */;
                break;
            case CursorMove.RawDirection.Down:
                direction = 3 /* Down */;
                break;
            case CursorMove.RawDirection.WrappedLineStart:
                direction = 4 /* WrappedLineStart */;
                break;
            case CursorMove.RawDirection.WrappedLineFirstNonWhitespaceCharacter:
                direction = 5 /* WrappedLineFirstNonWhitespaceCharacter */;
                break;
            case CursorMove.RawDirection.WrappedLineColumnCenter:
                direction = 6 /* WrappedLineColumnCenter */;
                break;
            case CursorMove.RawDirection.WrappedLineEnd:
                direction = 7 /* WrappedLineEnd */;
                break;
            case CursorMove.RawDirection.WrappedLineLastNonWhitespaceCharacter:
                direction = 8 /* WrappedLineLastNonWhitespaceCharacter */;
                break;
            case CursorMove.RawDirection.ViewPortTop:
                direction = 9 /* ViewPortTop */;
                break;
            case CursorMove.RawDirection.ViewPortBottom:
                direction = 11 /* ViewPortBottom */;
                break;
            case CursorMove.RawDirection.ViewPortCenter:
                direction = 10 /* ViewPortCenter */;
                break;
            case CursorMove.RawDirection.ViewPortIfOutside:
                direction = 12 /* ViewPortIfOutside */;
                break;
            default:
                // illegal arguments
                return null;
        }
        var unit = 0 /* None */;
        switch (args.by) {
            case CursorMove.RawUnit.Line:
                unit = 1 /* Line */;
                break;
            case CursorMove.RawUnit.WrappedLine:
                unit = 2 /* WrappedLine */;
                break;
            case CursorMove.RawUnit.Character:
                unit = 3 /* Character */;
                break;
            case CursorMove.RawUnit.HalfLine:
                unit = 4 /* HalfLine */;
                break;
        }
        return {
            direction: direction,
            unit: unit,
            select: (!!args.select),
            value: (args.value || 1)
        };
    }
    CursorMove.parse = parse;
})(CursorMove || (CursorMove = {}));


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CursorPosition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoveOperations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var CursorPosition = /** @class */ (function () {
    function CursorPosition(lineNumber, column, leftoverVisibleColumns) {
        this.lineNumber = lineNumber;
        this.column = column;
        this.leftoverVisibleColumns = leftoverVisibleColumns;
    }
    return CursorPosition;
}());

var MoveOperations = /** @class */ (function () {
    function MoveOperations() {
    }
    MoveOperations.left = function (config, model, lineNumber, column) {
        if (column > model.getLineMinColumn(lineNumber)) {
            if (__WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].isLowSurrogate(model, lineNumber, column - 2)) {
                // character before column is a low surrogate
                column = column - 2;
            }
            else {
                column = column - 1;
            }
        }
        else if (lineNumber > 1) {
            lineNumber = lineNumber - 1;
            column = model.getLineMaxColumn(lineNumber);
        }
        return new CursorPosition(lineNumber, column, 0);
    };
    MoveOperations.moveLeft = function (config, model, cursor, inSelectionMode, noOfColumns) {
        var lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If we are in selection mode, move left without selection cancels selection and puts cursor at the beginning of the selection
            lineNumber = cursor.selection.startLineNumber;
            column = cursor.selection.startColumn;
        }
        else {
            var r = MoveOperations.left(config, model, cursor.position.lineNumber, cursor.position.column - (noOfColumns - 1));
            lineNumber = r.lineNumber;
            column = r.column;
        }
        return cursor.move(inSelectionMode, lineNumber, column, 0);
    };
    MoveOperations.right = function (config, model, lineNumber, column) {
        if (column < model.getLineMaxColumn(lineNumber)) {
            if (__WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].isHighSurrogate(model, lineNumber, column - 1)) {
                // character after column is a high surrogate
                column = column + 2;
            }
            else {
                column = column + 1;
            }
        }
        else if (lineNumber < model.getLineCount()) {
            lineNumber = lineNumber + 1;
            column = model.getLineMinColumn(lineNumber);
        }
        return new CursorPosition(lineNumber, column, 0);
    };
    MoveOperations.moveRight = function (config, model, cursor, inSelectionMode, noOfColumns) {
        var lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If we are in selection mode, move right without selection cancels selection and puts cursor at the end of the selection
            lineNumber = cursor.selection.endLineNumber;
            column = cursor.selection.endColumn;
        }
        else {
            var r = MoveOperations.right(config, model, cursor.position.lineNumber, cursor.position.column + (noOfColumns - 1));
            lineNumber = r.lineNumber;
            column = r.column;
        }
        return cursor.move(inSelectionMode, lineNumber, column, 0);
    };
    MoveOperations.down = function (config, model, lineNumber, column, leftoverVisibleColumns, count, allowMoveOnLastLine) {
        var currentVisibleColumn = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize) + leftoverVisibleColumns;
        lineNumber = lineNumber + count;
        var lineCount = model.getLineCount();
        if (lineNumber > lineCount) {
            lineNumber = lineCount;
            if (allowMoveOnLastLine) {
                column = model.getLineMaxColumn(lineNumber);
            }
            else {
                column = Math.min(model.getLineMaxColumn(lineNumber), column);
                if (__WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].isInsideSurrogatePair(model, lineNumber, column)) {
                    column = column - 1;
                }
            }
        }
        else {
            column = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].columnFromVisibleColumn2(config, model, lineNumber, currentVisibleColumn);
            if (__WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].isInsideSurrogatePair(model, lineNumber, column)) {
                column = column - 1;
            }
        }
        leftoverVisibleColumns = currentVisibleColumn - __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize);
        return new CursorPosition(lineNumber, column, leftoverVisibleColumns);
    };
    MoveOperations.moveDown = function (config, model, cursor, inSelectionMode, linesCount) {
        var lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If we are in selection mode, move down acts relative to the end of selection
            lineNumber = cursor.selection.endLineNumber;
            column = cursor.selection.endColumn;
        }
        else {
            lineNumber = cursor.position.lineNumber;
            column = cursor.position.column;
        }
        var r = MoveOperations.down(config, model, lineNumber, column, cursor.leftoverVisibleColumns, linesCount, true);
        return cursor.move(inSelectionMode, r.lineNumber, r.column, r.leftoverVisibleColumns);
    };
    MoveOperations.translateDown = function (config, model, cursor) {
        var selection = cursor.selection;
        var selectionStart = MoveOperations.down(config, model, selection.selectionStartLineNumber, selection.selectionStartColumn, cursor.selectionStartLeftoverVisibleColumns, 1, false);
        var position = MoveOperations.down(config, model, selection.positionLineNumber, selection.positionColumn, cursor.leftoverVisibleColumns, 1, false);
        return new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](selectionStart.lineNumber, selectionStart.column, selectionStart.lineNumber, selectionStart.column), selectionStart.leftoverVisibleColumns, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](position.lineNumber, position.column), position.leftoverVisibleColumns);
    };
    MoveOperations.up = function (config, model, lineNumber, column, leftoverVisibleColumns, count, allowMoveOnFirstLine) {
        var currentVisibleColumn = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize) + leftoverVisibleColumns;
        lineNumber = lineNumber - count;
        if (lineNumber < 1) {
            lineNumber = 1;
            if (allowMoveOnFirstLine) {
                column = model.getLineMinColumn(lineNumber);
            }
            else {
                column = Math.min(model.getLineMaxColumn(lineNumber), column);
                if (__WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].isInsideSurrogatePair(model, lineNumber, column)) {
                    column = column - 1;
                }
            }
        }
        else {
            column = __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].columnFromVisibleColumn2(config, model, lineNumber, currentVisibleColumn);
            if (__WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].isInsideSurrogatePair(model, lineNumber, column)) {
                column = column - 1;
            }
        }
        leftoverVisibleColumns = currentVisibleColumn - __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize);
        return new CursorPosition(lineNumber, column, leftoverVisibleColumns);
    };
    MoveOperations.moveUp = function (config, model, cursor, inSelectionMode, linesCount) {
        var lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If we are in selection mode, move up acts relative to the beginning of selection
            lineNumber = cursor.selection.startLineNumber;
            column = cursor.selection.startColumn;
        }
        else {
            lineNumber = cursor.position.lineNumber;
            column = cursor.position.column;
        }
        var r = MoveOperations.up(config, model, lineNumber, column, cursor.leftoverVisibleColumns, linesCount, true);
        return cursor.move(inSelectionMode, r.lineNumber, r.column, r.leftoverVisibleColumns);
    };
    MoveOperations.translateUp = function (config, model, cursor) {
        var selection = cursor.selection;
        var selectionStart = MoveOperations.up(config, model, selection.selectionStartLineNumber, selection.selectionStartColumn, cursor.selectionStartLeftoverVisibleColumns, 1, false);
        var position = MoveOperations.up(config, model, selection.positionLineNumber, selection.positionColumn, cursor.leftoverVisibleColumns, 1, false);
        return new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](selectionStart.lineNumber, selectionStart.column, selectionStart.lineNumber, selectionStart.column), selectionStart.leftoverVisibleColumns, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](position.lineNumber, position.column), position.leftoverVisibleColumns);
    };
    MoveOperations.moveToBeginningOfLine = function (config, model, cursor, inSelectionMode) {
        var lineNumber = cursor.position.lineNumber;
        var minColumn = model.getLineMinColumn(lineNumber);
        var firstNonBlankColumn = model.getLineFirstNonWhitespaceColumn(lineNumber) || minColumn;
        var column;
        var relevantColumnNumber = cursor.position.column;
        if (relevantColumnNumber === firstNonBlankColumn) {
            column = minColumn;
        }
        else {
            column = firstNonBlankColumn;
        }
        return cursor.move(inSelectionMode, lineNumber, column, 0);
    };
    MoveOperations.moveToEndOfLine = function (config, model, cursor, inSelectionMode) {
        var lineNumber = cursor.position.lineNumber;
        var maxColumn = model.getLineMaxColumn(lineNumber);
        return cursor.move(inSelectionMode, lineNumber, maxColumn, 0);
    };
    MoveOperations.moveToBeginningOfBuffer = function (config, model, cursor, inSelectionMode) {
        return cursor.move(inSelectionMode, 1, 1, 0);
    };
    MoveOperations.moveToEndOfBuffer = function (config, model, cursor, inSelectionMode) {
        var lastLineNumber = model.getLineCount();
        var lastColumn = model.getLineMaxColumn(lastLineNumber);
        return cursor.move(inSelectionMode, lastLineNumber, lastColumn, 0);
    };
    return MoveOperations;
}());



/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShiftCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controller_cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var ShiftCommand = /** @class */ (function () {
    function ShiftCommand(range, opts) {
        this._opts = opts;
        this._selection = range;
        this._useLastEditRangeForCursorEndPosition = false;
        this._selectionStartColumnStaysPut = false;
    }
    ShiftCommand.unshiftIndentCount = function (line, column, tabSize) {
        // Determine the visible column where the content starts
        var contentStartVisibleColumn = __WEBPACK_IMPORTED_MODULE_1__controller_cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(line, column, tabSize);
        var desiredTabStop = __WEBPACK_IMPORTED_MODULE_1__controller_cursorCommon_js__["a" /* CursorColumns */].prevTabStop(contentStartVisibleColumn, tabSize);
        // The `desiredTabStop` is a multiple of `tabSize` => determine the number of indents
        return desiredTabStop / tabSize;
    };
    ShiftCommand.shiftIndentCount = function (line, column, tabSize) {
        // Determine the visible column where the content starts
        var contentStartVisibleColumn = __WEBPACK_IMPORTED_MODULE_1__controller_cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(line, column, tabSize);
        var desiredTabStop = __WEBPACK_IMPORTED_MODULE_1__controller_cursorCommon_js__["a" /* CursorColumns */].nextTabStop(contentStartVisibleColumn, tabSize);
        // The `desiredTabStop` is a multiple of `tabSize` => determine the number of indents
        return desiredTabStop / tabSize;
    };
    ShiftCommand.prototype._addEditOperation = function (builder, range, text) {
        if (this._useLastEditRangeForCursorEndPosition) {
            builder.addTrackedEditOperation(range, text);
        }
        else {
            builder.addEditOperation(range, text);
        }
    };
    ShiftCommand.prototype.getEditOperations = function (model, builder) {
        var startLine = this._selection.startLineNumber;
        var endLine = this._selection.endLineNumber;
        if (this._selection.endColumn === 1 && startLine !== endLine) {
            endLine = endLine - 1;
        }
        var tabSize = this._opts.tabSize;
        var oneIndent = this._opts.oneIndent;
        var shouldIndentEmptyLines = (startLine === endLine);
        // if indenting or outdenting on a whitespace only line
        if (this._selection.isEmpty()) {
            if (/^\s*$/.test(model.getLineContent(startLine))) {
                this._useLastEditRangeForCursorEndPosition = true;
            }
        }
        if (this._opts.useTabStops) {
            // indents[i] represents i * oneIndent
            var indents = ['', oneIndent];
            // keep track of previous line's "miss-alignment"
            var previousLineExtraSpaces = 0, extraSpaces = 0;
            for (var lineNumber = startLine; lineNumber <= endLine; lineNumber++, previousLineExtraSpaces = extraSpaces) {
                extraSpaces = 0;
                var lineText = model.getLineContent(lineNumber);
                var indentationEndIndex = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["firstNonWhitespaceIndex"](lineText);
                if (this._opts.isUnshift && (lineText.length === 0 || indentationEndIndex === 0)) {
                    // empty line or line with no leading whitespace => nothing to do
                    continue;
                }
                if (!shouldIndentEmptyLines && !this._opts.isUnshift && lineText.length === 0) {
                    // do not indent empty lines => nothing to do
                    continue;
                }
                if (indentationEndIndex === -1) {
                    // the entire line is whitespace
                    indentationEndIndex = lineText.length;
                }
                if (lineNumber > 1) {
                    var contentStartVisibleColumn = __WEBPACK_IMPORTED_MODULE_1__controller_cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn(lineText, indentationEndIndex + 1, tabSize);
                    if (contentStartVisibleColumn % tabSize !== 0) {
                        // The current line is "miss-aligned", so let's see if this is expected...
                        // This can only happen when it has trailing commas in the indent
                        if (model.isCheapToTokenize(lineNumber - 1)) {
                            var enterAction = __WEBPACK_IMPORTED_MODULE_4__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getRawEnterActionAtPosition(model, lineNumber - 1, model.getLineMaxColumn(lineNumber - 1));
                            if (enterAction) {
                                extraSpaces = previousLineExtraSpaces;
                                if (enterAction.appendText) {
                                    for (var j = 0, lenJ = enterAction.appendText.length; j < lenJ && extraSpaces < tabSize; j++) {
                                        if (enterAction.appendText.charCodeAt(j) === 32 /* Space */) {
                                            extraSpaces++;
                                        }
                                        else {
                                            break;
                                        }
                                    }
                                }
                                if (enterAction.removeText) {
                                    extraSpaces = Math.max(0, extraSpaces - enterAction.removeText);
                                }
                                // Act as if `prefixSpaces` is not part of the indentation
                                for (var j = 0; j < extraSpaces; j++) {
                                    if (indentationEndIndex === 0 || lineText.charCodeAt(indentationEndIndex - 1) !== 32 /* Space */) {
                                        break;
                                    }
                                    indentationEndIndex--;
                                }
                            }
                        }
                    }
                }
                if (this._opts.isUnshift && indentationEndIndex === 0) {
                    // line with no leading whitespace => nothing to do
                    continue;
                }
                var desiredIndentCount = void 0;
                if (this._opts.isUnshift) {
                    desiredIndentCount = ShiftCommand.unshiftIndentCount(lineText, indentationEndIndex + 1, tabSize);
                }
                else {
                    desiredIndentCount = ShiftCommand.shiftIndentCount(lineText, indentationEndIndex + 1, tabSize);
                }
                // Fill `indents`, as needed
                for (var j = indents.length; j <= desiredIndentCount; j++) {
                    indents[j] = indents[j - 1] + oneIndent;
                }
                this._addEditOperation(builder, new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, indentationEndIndex + 1), indents[desiredIndentCount]);
                if (lineNumber === startLine) {
                    // Force the startColumn to stay put because we're inserting after it
                    this._selectionStartColumnStaysPut = (this._selection.startColumn <= indentationEndIndex + 1);
                }
            }
        }
        else {
            for (var lineNumber = startLine; lineNumber <= endLine; lineNumber++) {
                var lineText = model.getLineContent(lineNumber);
                var indentationEndIndex = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["firstNonWhitespaceIndex"](lineText);
                if (this._opts.isUnshift && (lineText.length === 0 || indentationEndIndex === 0)) {
                    // empty line or line with no leading whitespace => nothing to do
                    continue;
                }
                if (!shouldIndentEmptyLines && !this._opts.isUnshift && lineText.length === 0) {
                    // do not indent empty lines => nothing to do
                    continue;
                }
                if (indentationEndIndex === -1) {
                    // the entire line is whitespace
                    indentationEndIndex = lineText.length;
                }
                if (this._opts.isUnshift && indentationEndIndex === 0) {
                    // line with no leading whitespace => nothing to do
                    continue;
                }
                if (this._opts.isUnshift) {
                    indentationEndIndex = Math.min(indentationEndIndex, tabSize);
                    for (var i = 0; i < indentationEndIndex; i++) {
                        var chr = lineText.charCodeAt(i);
                        if (chr === 9 /* Tab */) {
                            indentationEndIndex = i + 1;
                            break;
                        }
                    }
                    this._addEditOperation(builder, new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, indentationEndIndex + 1), '');
                }
                else {
                    this._addEditOperation(builder, new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, 1), oneIndent);
                    if (lineNumber === startLine) {
                        // Force the startColumn to stay put because we're inserting after it
                        this._selectionStartColumnStaysPut = (this._selection.startColumn === 1);
                    }
                }
            }
        }
        this._selectionId = builder.trackSelection(this._selection);
    };
    ShiftCommand.prototype.computeCursorState = function (model, helper) {
        if (this._useLastEditRangeForCursorEndPosition) {
            var lastOp = helper.getInverseEditOperations()[0];
            return new __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["a" /* Selection */](lastOp.range.endLineNumber, lastOp.range.endColumn, lastOp.range.endLineNumber, lastOp.range.endColumn);
        }
        var result = helper.getTrackedSelection(this._selectionId);
        if (this._selectionStartColumnStaysPut) {
            // The selection start should not move
            var initialStartColumn = this._selection.startColumn;
            var resultStartColumn = result.startColumn;
            if (resultStartColumn <= initialStartColumn) {
                return result;
            }
            if (result.getDirection() === __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["b" /* SelectionDirection */].LTR) {
                return new __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["a" /* Selection */](result.startLineNumber, initialStartColumn, result.endLineNumber, result.endColumn);
            }
            return new __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["a" /* Selection */](result.endLineNumber, result.endColumn, result.startLineNumber, initialStartColumn);
        }
        return result;
    };
    return ShiftCommand;
}());



/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteOperations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commands_replaceCommand_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var DeleteOperations = /** @class */ (function () {
    function DeleteOperations() {
    }
    DeleteOperations.deleteRight = function (prevEditOperationType, config, model, selections) {
        var commands = [];
        var shouldPushStackElementBefore = (prevEditOperationType !== 3 /* DeletingRight */);
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var deleteSelection = selection;
            if (deleteSelection.isEmpty()) {
                var position = selection.getPosition();
                var rightOfPosition = __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].right(config, model, position.lineNumber, position.column);
                deleteSelection = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](rightOfPosition.lineNumber, rightOfPosition.column, position.lineNumber, position.column);
            }
            if (deleteSelection.isEmpty()) {
                // Probably at end of file => ignore
                commands[i] = null;
                continue;
            }
            if (deleteSelection.startLineNumber !== deleteSelection.endLineNumber) {
                shouldPushStackElementBefore = true;
            }
            commands[i] = new __WEBPACK_IMPORTED_MODULE_0__commands_replaceCommand_js__["a" /* ReplaceCommand */](deleteSelection, '');
        }
        return [shouldPushStackElementBefore, commands];
    };
    DeleteOperations._isAutoClosingPairDelete = function (config, model, selections) {
        if (!config.autoClosingBrackets) {
            return false;
        }
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var position = selection.getPosition();
            if (!selection.isEmpty()) {
                return false;
            }
            var lineText = model.getLineContent(position.lineNumber);
            var character = lineText[position.column - 2];
            if (!config.autoClosingPairsOpen.hasOwnProperty(character)) {
                return false;
            }
            var afterCharacter = lineText[position.column - 1];
            var closeCharacter = config.autoClosingPairsOpen[character];
            if (afterCharacter !== closeCharacter) {
                return false;
            }
        }
        return true;
    };
    DeleteOperations._runAutoClosingPairDelete = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var position = selections[i].getPosition();
            var deleteSelection = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](position.lineNumber, position.column - 1, position.lineNumber, position.column + 1);
            commands[i] = new __WEBPACK_IMPORTED_MODULE_0__commands_replaceCommand_js__["a" /* ReplaceCommand */](deleteSelection, '');
        }
        return [true, commands];
    };
    DeleteOperations.deleteLeft = function (prevEditOperationType, config, model, selections) {
        if (this._isAutoClosingPairDelete(config, model, selections)) {
            return this._runAutoClosingPairDelete(config, model, selections);
        }
        var commands = [];
        var shouldPushStackElementBefore = (prevEditOperationType !== 2 /* DeletingLeft */);
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var deleteSelection = selection;
            if (deleteSelection.isEmpty()) {
                var position = selection.getPosition();
                if (config.useTabStops && position.column > 1) {
                    var lineContent = model.getLineContent(position.lineNumber);
                    var firstNonWhitespaceIndex = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["firstNonWhitespaceIndex"](lineContent);
                    var lastIndentationColumn = (firstNonWhitespaceIndex === -1
                        ? /* entire string is whitespace */ lineContent.length + 1
                        : firstNonWhitespaceIndex + 1);
                    if (position.column <= lastIndentationColumn) {
                        var fromVisibleColumn = __WEBPACK_IMPORTED_MODULE_1__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(config, model, position);
                        var toVisibleColumn = __WEBPACK_IMPORTED_MODULE_1__cursorCommon_js__["a" /* CursorColumns */].prevTabStop(fromVisibleColumn, config.tabSize);
                        var toColumn = __WEBPACK_IMPORTED_MODULE_1__cursorCommon_js__["a" /* CursorColumns */].columnFromVisibleColumn2(config, model, position.lineNumber, toVisibleColumn);
                        deleteSelection = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](position.lineNumber, toColumn, position.lineNumber, position.column);
                    }
                    else {
                        deleteSelection = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](position.lineNumber, position.column - 1, position.lineNumber, position.column);
                    }
                }
                else {
                    var leftOfPosition = __WEBPACK_IMPORTED_MODULE_3__cursorMoveOperations_js__["a" /* MoveOperations */].left(config, model, position.lineNumber, position.column);
                    deleteSelection = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](leftOfPosition.lineNumber, leftOfPosition.column, position.lineNumber, position.column);
                }
            }
            if (deleteSelection.isEmpty()) {
                // Probably at beginning of file => ignore
                commands[i] = null;
                continue;
            }
            if (deleteSelection.startLineNumber !== deleteSelection.endLineNumber) {
                shouldPushStackElementBefore = true;
            }
            commands[i] = new __WEBPACK_IMPORTED_MODULE_0__commands_replaceCommand_js__["a" /* ReplaceCommand */](deleteSelection, '');
        }
        return [shouldPushStackElementBefore, commands];
    };
    DeleteOperations.cut = function (config, model, selections) {
        var commands = [];
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            if (selection.isEmpty()) {
                if (config.emptySelectionClipboard) {
                    // This is a full line cut
                    var position = selection.getPosition();
                    var startLineNumber = void 0, startColumn = void 0, endLineNumber = void 0, endColumn = void 0;
                    if (position.lineNumber < model.getLineCount()) {
                        // Cutting a line in the middle of the model
                        startLineNumber = position.lineNumber;
                        startColumn = 1;
                        endLineNumber = position.lineNumber + 1;
                        endColumn = 1;
                    }
                    else if (position.lineNumber > 1) {
                        // Cutting the last line & there are more than 1 lines in the model
                        startLineNumber = position.lineNumber - 1;
                        startColumn = model.getLineMaxColumn(position.lineNumber - 1);
                        endLineNumber = position.lineNumber;
                        endColumn = model.getLineMaxColumn(position.lineNumber);
                    }
                    else {
                        // Cutting the single line that the model contains
                        startLineNumber = position.lineNumber;
                        startColumn = 1;
                        endLineNumber = position.lineNumber;
                        endColumn = model.getLineMaxColumn(position.lineNumber);
                    }
                    var deleteSelection = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn);
                    if (!deleteSelection.isEmpty()) {
                        commands[i] = new __WEBPACK_IMPORTED_MODULE_0__commands_replaceCommand_js__["a" /* ReplaceCommand */](deleteSelection, '');
                    }
                    else {
                        commands[i] = null;
                    }
                }
                else {
                    // Cannot cut empty selection
                    commands[i] = null;
                }
            }
            else {
                commands[i] = new __WEBPACK_IMPORTED_MODULE_0__commands_replaceCommand_js__["a" /* ReplaceCommand */](selection, '');
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_1__cursorCommon_js__["e" /* EditOperationResult */](0 /* Other */, commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    };
    return DeleteOperations;
}());



/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IClipboardService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IClipboardService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('clipboardService');


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnchorAlignment; });
/* unused harmony export AnchorPosition */
/* unused harmony export LayoutAnchorPosition */
/* unused harmony export layout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContextView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextview_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__contextview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var AnchorAlignment;
(function (AnchorAlignment) {
    AnchorAlignment[AnchorAlignment["LEFT"] = 0] = "LEFT";
    AnchorAlignment[AnchorAlignment["RIGHT"] = 1] = "RIGHT";
})(AnchorAlignment || (AnchorAlignment = {}));
var AnchorPosition;
(function (AnchorPosition) {
    AnchorPosition[AnchorPosition["BELOW"] = 0] = "BELOW";
    AnchorPosition[AnchorPosition["ABOVE"] = 1] = "ABOVE";
})(AnchorPosition || (AnchorPosition = {}));
var LayoutAnchorPosition;
(function (LayoutAnchorPosition) {
    LayoutAnchorPosition[LayoutAnchorPosition["Before"] = 0] = "Before";
    LayoutAnchorPosition[LayoutAnchorPosition["After"] = 1] = "After";
})(LayoutAnchorPosition || (LayoutAnchorPosition = {}));
/**
 * Lays out a one dimensional view next to an anchor in a viewport.
 *
 * @returns The view offset within the viewport.
 */
function layout(viewportSize, viewSize, anchor) {
    var anchorEnd = anchor.offset + anchor.size;
    if (anchor.position === LayoutAnchorPosition.Before) {
        if (viewSize <= viewportSize - anchorEnd) {
            return anchorEnd; // happy case, lay it out after the anchor
        }
        if (viewSize <= anchor.offset) {
            return anchor.offset - viewSize; // ok case, lay it out before the anchor
        }
        return Math.max(viewportSize - viewSize, 0); // sad case, lay it over the anchor
    }
    else {
        if (viewSize <= anchor.offset) {
            return anchor.offset - viewSize; // happy case, lay it out before the anchor
        }
        if (viewSize <= viewportSize - anchorEnd) {
            return anchorEnd; // ok case, lay it out after the anchor
        }
        return 0; // sad case, lay it over the anchor
    }
}
var ContextView = /** @class */ (function () {
    function ContextView(container) {
        var _this = this;
        this.$view = Object(__WEBPACK_IMPORTED_MODULE_1__builder_js__["a" /* $ */])('.context-view').hide();
        this.setContainer(container);
        this.toDispose = [Object(__WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["f" /* toDisposable */])(function () {
                _this.setContainer(null);
            })];
        this.toDisposeOnClean = null;
    }
    ContextView.prototype.setContainer = function (container) {
        var _this = this;
        if (this.$container) {
            this.$container.getHTMLElement().removeChild(this.$view.getHTMLElement());
            this.$container.off(ContextView.BUBBLE_UP_EVENTS);
            this.$container.off(ContextView.BUBBLE_DOWN_EVENTS, true);
            this.$container = null;
        }
        if (container) {
            this.$container = Object(__WEBPACK_IMPORTED_MODULE_1__builder_js__["a" /* $ */])(container);
            this.$view.appendTo(this.$container);
            this.$container.on(ContextView.BUBBLE_UP_EVENTS, function (e) {
                _this.onDOMEvent(e, document.activeElement, false);
            });
            this.$container.on(ContextView.BUBBLE_DOWN_EVENTS, function (e) {
                _this.onDOMEvent(e, document.activeElement, true);
            }, null, true);
        }
    };
    ContextView.prototype.show = function (delegate) {
        if (this.isVisible()) {
            this.hide();
        }
        // Show static box
        this.$view.setClass('context-view').empty().style({ top: '0px', left: '0px' }).show();
        // Render content
        this.toDisposeOnClean = delegate.render(this.$view.getHTMLElement());
        // Set active delegate
        this.delegate = delegate;
        // Layout
        this.doLayout();
    };
    ContextView.prototype.layout = function () {
        if (!this.isVisible()) {
            return;
        }
        if (this.delegate.canRelayout === false) {
            this.hide();
            return;
        }
        if (this.delegate.layout) {
            this.delegate.layout();
        }
        this.doLayout();
    };
    ContextView.prototype.doLayout = function () {
        // Get anchor
        var anchor = this.delegate.getAnchor();
        // Compute around
        var around;
        // Get the element's position and size (to anchor the view)
        if (__WEBPACK_IMPORTED_MODULE_2__dom_js__["C" /* isHTMLElement */](anchor)) {
            var elementPosition = __WEBPACK_IMPORTED_MODULE_2__dom_js__["u" /* getDomNodePagePosition */](anchor);
            around = {
                top: elementPosition.top,
                left: elementPosition.left,
                width: elementPosition.width,
                height: elementPosition.height
            };
        }
        else {
            var realAnchor = anchor;
            around = {
                top: realAnchor.y,
                left: realAnchor.x,
                width: realAnchor.width || 0,
                height: realAnchor.height || 0
            };
        }
        var viewSize = this.$view.getTotalSize();
        var anchorPosition = this.delegate.anchorPosition || AnchorPosition.BELOW;
        var anchorAlignment = this.delegate.anchorAlignment || AnchorAlignment.LEFT;
        var verticalAnchor = { offset: around.top, size: around.height, position: anchorPosition === AnchorPosition.BELOW ? LayoutAnchorPosition.Before : LayoutAnchorPosition.After };
        var horizontalAnchor;
        if (anchorAlignment === AnchorAlignment.LEFT) {
            horizontalAnchor = { offset: around.left, size: 0, position: LayoutAnchorPosition.Before };
        }
        else {
            horizontalAnchor = { offset: around.left + around.width, size: 0, position: LayoutAnchorPosition.After };
        }
        var containerPosition = __WEBPACK_IMPORTED_MODULE_2__dom_js__["u" /* getDomNodePagePosition */](this.$container.getHTMLElement());
        var top = layout(window.innerHeight, viewSize.height, verticalAnchor) - containerPosition.top;
        var left = layout(window.innerWidth, viewSize.width, horizontalAnchor) - containerPosition.left;
        this.$view.removeClass('top', 'bottom', 'left', 'right');
        this.$view.addClass(anchorPosition === AnchorPosition.BELOW ? 'bottom' : 'top');
        this.$view.addClass(anchorAlignment === AnchorAlignment.LEFT ? 'left' : 'right');
        this.$view.style({ top: top + "px", left: left + "px", width: 'initial' });
    };
    ContextView.prototype.hide = function (data) {
        if (this.delegate && this.delegate.onHide) {
            this.delegate.onHide(data);
        }
        this.delegate = null;
        if (this.toDisposeOnClean) {
            this.toDisposeOnClean.dispose();
            this.toDisposeOnClean = null;
        }
        this.$view.hide();
    };
    ContextView.prototype.isVisible = function () {
        return !!this.delegate;
    };
    ContextView.prototype.onDOMEvent = function (e, element, onCapture) {
        if (this.delegate) {
            if (this.delegate.onDOMEvent) {
                this.delegate.onDOMEvent(e, document.activeElement);
            }
            else if (onCapture && !__WEBPACK_IMPORTED_MODULE_2__dom_js__["B" /* isAncestor */](e.target, this.$container.getHTMLElement())) {
                this.hide();
            }
        }
    };
    ContextView.prototype.dispose = function () {
        this.hide();
        this.toDispose = Object(__WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */])(this.toDispose);
    };
    ContextView.BUBBLE_UP_EVENTS = ['click', 'keydown', 'focus', 'blur'];
    ContextView.BUBBLE_DOWN_EVENTS = ['click'];
    return ContextView;
}());



/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaseSensitiveCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WholeWordsCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RegexCheckbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_checkbox_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findInputCheckboxes_css__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findInputCheckboxes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__findInputCheckboxes_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nls_js__ = __webpack_require__(2);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var NLS_CASE_SENSITIVE_CHECKBOX_LABEL = __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('caseDescription', "Match Case");
var NLS_WHOLE_WORD_CHECKBOX_LABEL = __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('wordsDescription', "Match Whole Word");
var NLS_REGEX_CHECKBOX_LABEL = __WEBPACK_IMPORTED_MODULE_2__nls_js__["a" /* localize */]('regexDescription', "Use Regular Expression");
var CaseSensitiveCheckbox = /** @class */ (function (_super) {
    __extends(CaseSensitiveCheckbox, _super);
    function CaseSensitiveCheckbox(opts) {
        return _super.call(this, {
            actionClassName: 'monaco-case-sensitive',
            title: NLS_CASE_SENSITIVE_CHECKBOX_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            inputActiveOptionBorder: opts.inputActiveOptionBorder
        }) || this;
    }
    return CaseSensitiveCheckbox;
}(__WEBPACK_IMPORTED_MODULE_0__checkbox_checkbox_js__["a" /* Checkbox */]));

var WholeWordsCheckbox = /** @class */ (function (_super) {
    __extends(WholeWordsCheckbox, _super);
    function WholeWordsCheckbox(opts) {
        return _super.call(this, {
            actionClassName: 'monaco-whole-word',
            title: NLS_WHOLE_WORD_CHECKBOX_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            inputActiveOptionBorder: opts.inputActiveOptionBorder
        }) || this;
    }
    return WholeWordsCheckbox;
}(__WEBPACK_IMPORTED_MODULE_0__checkbox_checkbox_js__["a" /* Checkbox */]));

var RegexCheckbox = /** @class */ (function (_super) {
    __extends(RegexCheckbox, _super);
    function RegexCheckbox(opts) {
        return _super.call(this, {
            actionClassName: 'monaco-regex',
            title: NLS_REGEX_CHECKBOX_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            inputActiveOptionBorder: opts.inputActiveOptionBorder
        }) || this;
    }
    return RegexCheckbox;
}(__WEBPACK_IMPORTED_MODULE_0__checkbox_checkbox_js__["a" /* Checkbox */]));



/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_SYNTAX_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SyntaxRangeProvider; });
/* unused harmony export RangesCollector */
/* harmony export (immutable) */ __webpack_exports__["c"] = sanitizeRanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__foldingRanges_js__ = __webpack_require__(141);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var MAX_FOLDING_REGIONS = 5000;
var foldingContext = {};
var ID_SYNTAX_PROVIDER = 'syntax';
var SyntaxRangeProvider = /** @class */ (function () {
    function SyntaxRangeProvider(editorModel, providers, limit) {
        if (limit === void 0) { limit = MAX_FOLDING_REGIONS; }
        this.editorModel = editorModel;
        this.providers = providers;
        this.limit = limit;
        this.id = ID_SYNTAX_PROVIDER;
    }
    SyntaxRangeProvider.prototype.compute = function (cancellationToken) {
        var _this = this;
        return collectSyntaxRanges(this.providers, this.editorModel, cancellationToken).then(function (ranges) {
            if (ranges) {
                var res = sanitizeRanges(ranges, _this.limit);
                return res;
            }
            return null;
        });
    };
    SyntaxRangeProvider.prototype.dispose = function () {
    };
    return SyntaxRangeProvider;
}());

function collectSyntaxRanges(providers, model, cancellationToken) {
    var rangeData = null;
    var promises = providers.map(function (provider, i) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["n" /* toThenable */])(provider.provideFoldingRanges(model, foldingContext, cancellationToken)).then(function (ranges) {
            if (cancellationToken.isCancellationRequested) {
                return;
            }
            if (Array.isArray(ranges)) {
                if (!Array.isArray(rangeData)) {
                    rangeData = [];
                }
                var nLines = model.getLineCount();
                for (var _i = 0, ranges_1 = ranges; _i < ranges_1.length; _i++) {
                    var r = ranges_1[_i];
                    if (r.start > 0 && r.end > r.start && r.end <= nLines) {
                        rangeData.push({ start: r.start, end: r.end, rank: i, kind: r.kind });
                    }
                }
            }
        }, __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
    });
    return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].join(promises).then(function (_) {
        return rangeData;
    });
}
var RangesCollector = /** @class */ (function () {
    function RangesCollector(foldingRangesLimit) {
        this._startIndexes = [];
        this._endIndexes = [];
        this._nestingLevels = [];
        this._nestingLevelCounts = [];
        this._types = [];
        this._length = 0;
        this._foldingRangesLimit = foldingRangesLimit;
    }
    RangesCollector.prototype.add = function (startLineNumber, endLineNumber, type, nestingLevel) {
        if (startLineNumber > __WEBPACK_IMPORTED_MODULE_3__foldingRanges_js__["b" /* MAX_LINE_NUMBER */] || endLineNumber > __WEBPACK_IMPORTED_MODULE_3__foldingRanges_js__["b" /* MAX_LINE_NUMBER */]) {
            return;
        }
        var index = this._length;
        this._startIndexes[index] = startLineNumber;
        this._endIndexes[index] = endLineNumber;
        this._nestingLevels[index] = nestingLevel;
        this._types[index] = type;
        this._length++;
        if (nestingLevel < 30) {
            this._nestingLevelCounts[nestingLevel] = (this._nestingLevelCounts[nestingLevel] || 0) + 1;
        }
    };
    RangesCollector.prototype.toIndentRanges = function () {
        if (this._length <= this._foldingRangesLimit) {
            var startIndexes = new Uint32Array(this._length);
            var endIndexes = new Uint32Array(this._length);
            for (var i = 0; i < this._length; i++) {
                startIndexes[i] = this._startIndexes[i];
                endIndexes[i] = this._endIndexes[i];
            }
            return new __WEBPACK_IMPORTED_MODULE_3__foldingRanges_js__["a" /* FoldingRegions */](startIndexes, endIndexes, this._types);
        }
        else {
            var entries = 0;
            var maxLevel = this._nestingLevelCounts.length;
            for (var i = 0; i < this._nestingLevelCounts.length; i++) {
                var n = this._nestingLevelCounts[i];
                if (n) {
                    if (n + entries > this._foldingRangesLimit) {
                        maxLevel = i;
                        break;
                    }
                    entries += n;
                }
            }
            var startIndexes = new Uint32Array(this._foldingRangesLimit);
            var endIndexes = new Uint32Array(this._foldingRangesLimit);
            var types = [];
            for (var i = 0, k = 0; i < this._length; i++) {
                var level = this._nestingLevels[i];
                if (level < maxLevel || (level === maxLevel && entries++ < this._foldingRangesLimit)) {
                    startIndexes[k] = this._startIndexes[i];
                    endIndexes[k] = this._endIndexes[i];
                    types[k] = this._types[i];
                    k++;
                }
            }
            return new __WEBPACK_IMPORTED_MODULE_3__foldingRanges_js__["a" /* FoldingRegions */](startIndexes, endIndexes, types);
        }
    };
    return RangesCollector;
}());

function sanitizeRanges(rangeData, limit) {
    var sorted = rangeData.sort(function (d1, d2) {
        var diff = d1.start - d2.start;
        if (diff === 0) {
            diff = d1.rank - d2.rank;
        }
        return diff;
    });
    var collector = new RangesCollector(limit);
    var top = null;
    var previous = [];
    for (var _i = 0, sorted_1 = sorted; _i < sorted_1.length; _i++) {
        var entry = sorted_1[_i];
        if (!top) {
            top = entry;
            collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
        }
        else {
            if (entry.start > top.start) {
                if (entry.end <= top.end) {
                    previous.push(top);
                    top = entry;
                    collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
                }
                else {
                    if (entry.start > top.end) {
                        do {
                            top = previous.pop();
                        } while (top && entry.start > top.end);
                        if (top) {
                            previous.push(top);
                        }
                        top = entry;
                    }
                    collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
                }
            }
        }
    }
    return collector.toIndentRanges();
}


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefinitionsAtPosition;
/* harmony export (immutable) */ __webpack_exports__["b"] = getImplementationsAtPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTypeDefinitionsAtPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modes_js__ = __webpack_require__(15);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






function getDefinitions(model, position, registry, provide) {
    var provider = registry.ordered(model);
    // get results
    var promises = provider.map(function (provider) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["h" /* asWinJsPromise */])(function (token) {
            return provide(provider, model, position, token);
        }).then(undefined, function (err) {
            Object(__WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["f" /* onUnexpectedExternalError */])(err);
            return null;
        });
    });
    return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].join(promises)
        .then(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["i" /* flatten */])
        .then(function (references) { return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["c" /* coalesce */])(references); });
}
function getDefinitionsAtPosition(model, position) {
    return getDefinitions(model, position, __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["e" /* DefinitionProviderRegistry */], function (provider, model, position, token) {
        return provider.provideDefinition(model, position, token);
    });
}
function getImplementationsAtPosition(model, position) {
    return getDefinitions(model, position, __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["n" /* ImplementationProviderRegistry */], function (provider, model, position, token) {
        return provider.provideImplementation(model, position, token);
    });
}
function getTypeDefinitionsAtPosition(model, position) {
    return getDefinitions(model, position, __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["z" /* TypeDefinitionProviderRegistry */], function (provider, model, position, token) {
        return provider.provideTypeDefinition(model, position, token);
    });
}
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeDefinitionProvider', getDefinitionsAtPosition);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeImplementationProvider', getImplementationsAtPosition);
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeTypeDefinitionProvider', getTypeDefinitionsAtPosition);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ctxReferenceWidgetSearchTreeFocused; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReferenceWidget; });
/* unused harmony export peekViewTitleBackground */
/* unused harmony export peekViewTitleForeground */
/* unused harmony export peekViewTitleInfoForeground */
/* unused harmony export peekViewBorder */
/* unused harmony export peekViewResultsBackground */
/* unused harmony export peekViewResultsMatchForeground */
/* unused harmony export peekViewResultsFileForeground */
/* unused harmony export peekViewResultsSelectionBackground */
/* unused harmony export peekViewResultsSelectionForeground */
/* unused harmony export peekViewEditorBackground */
/* unused harmony export peekViewEditorGutterBackground */
/* unused harmony export peekViewResultsMatchHighlight */
/* unused harmony export peekViewEditorMatchHighlight */
/* unused harmony export peekViewEditorMatchHighlightBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_referencesWidget_css__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_referencesWidget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__media_referencesWidget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_network_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_browser_builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_browser_ui_sash_sash_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_browser_ui_countBadge_countBadge_js__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_browser_ui_iconLabel_iconLabel_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_workspace_common_workspace_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__browser_widget_embeddedCodeEditorWidget_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__peekViewWidget_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_services_resolverService_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__platform_theme_common_styler_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__platform_environment_common_environment_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__platform_list_browser_listService_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__base_parts_tree_browser_treeDefaults_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__platform_uriDisplay_common_uriDisplay_js__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__base_common_resources_js__ = __webpack_require__(266);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

































var DecorationsManager = /** @class */ (function () {
    function DecorationsManager(_editor, _model) {
        var _this = this;
        this._editor = _editor;
        this._model = _model;
        this._decorations = new Map();
        this._decorationIgnoreSet = new Set();
        this._callOnDispose = [];
        this._callOnModelChange = [];
        this._callOnDispose.push(this._editor.onDidChangeModel(function () { return _this._onModelChanged(); }));
        this._onModelChanged();
    }
    DecorationsManager.prototype.dispose = function () {
        this._callOnModelChange = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._callOnModelChange);
        this._callOnDispose = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._callOnDispose);
        this.removeDecorations();
    };
    DecorationsManager.prototype._onModelChanged = function () {
        this._callOnModelChange = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._callOnModelChange);
        var model = this._editor.getModel();
        if (model) {
            for (var _i = 0, _a = this._model.groups; _i < _a.length; _i++) {
                var ref = _a[_i];
                if (ref.uri.toString() === model.uri.toString()) {
                    this._addDecorations(ref);
                    return;
                }
            }
        }
    };
    DecorationsManager.prototype._addDecorations = function (reference) {
        var _this = this;
        this._callOnModelChange.push(this._editor.getModel().onDidChangeDecorations(function (event) { return _this._onDecorationChanged(); }));
        var newDecorations = [];
        var newDecorationsActualIndex = [];
        for (var i = 0, len = reference.children.length; i < len; i++) {
            var oneReference = reference.children[i];
            if (this._decorationIgnoreSet.has(oneReference.id)) {
                continue;
            }
            newDecorations.push({
                range: oneReference.range,
                options: DecorationsManager.DecorationOptions
            });
            newDecorationsActualIndex.push(i);
        }
        var decorations = this._editor.deltaDecorations([], newDecorations);
        for (var i = 0; i < decorations.length; i++) {
            this._decorations.set(decorations[i], reference.children[newDecorationsActualIndex[i]]);
        }
    };
    DecorationsManager.prototype._onDecorationChanged = function () {
        var _this = this;
        var toRemove = [];
        this._decorations.forEach(function (reference, decorationId) {
            var newRange = _this._editor.getModel().getDecorationRange(decorationId);
            if (!newRange) {
                return;
            }
            var ignore = false;
            if (__WEBPACK_IMPORTED_MODULE_16__common_core_range_js__["a" /* Range */].equalsRange(newRange, reference.range)) {
                return;
            }
            else if (__WEBPACK_IMPORTED_MODULE_16__common_core_range_js__["a" /* Range */].spansMultipleLines(newRange)) {
                ignore = true;
            }
            else {
                var lineLength = reference.range.endColumn - reference.range.startColumn;
                var newLineLength = newRange.endColumn - newRange.startColumn;
                if (lineLength !== newLineLength) {
                    ignore = true;
                }
            }
            if (ignore) {
                _this._decorationIgnoreSet.add(reference.id);
                toRemove.push(decorationId);
            }
            else {
                reference.range = newRange;
            }
        });
        for (var i = 0, len = toRemove.length; i < len; i++) {
            this._decorations.delete(toRemove[i]);
        }
        this._editor.deltaDecorations(toRemove, []);
    };
    DecorationsManager.prototype.removeDecorations = function () {
        var toRemove = [];
        this._decorations.forEach(function (value, key) {
            toRemove.push(key);
        });
        this._editor.deltaDecorations(toRemove, []);
        this._decorations.clear();
    };
    DecorationsManager.DecorationOptions = __WEBPACK_IMPORTED_MODULE_17__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_27__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'reference-decoration'
    });
    return DecorationsManager;
}());
var DataSource = /** @class */ (function () {
    function DataSource(_textModelResolverService) {
        this._textModelResolverService = _textModelResolverService;
        //
    }
    DataSource.prototype.getId = function (tree, element) {
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["c" /* ReferencesModel */]) {
            return 'root';
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            return element.id;
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["b" /* OneReference */]) {
            return element.id;
        }
        return undefined;
    };
    DataSource.prototype.hasChildren = function (tree, element) {
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["c" /* ReferencesModel */]) {
            return true;
        }
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */] && !element.failure) {
            return true;
        }
        return false;
    };
    DataSource.prototype.getChildren = function (tree, element) {
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["c" /* ReferencesModel */]) {
            return __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].as(element.groups);
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            return element.resolve(this._textModelResolverService).then(function (val) {
                if (element.failure) {
                    // refresh the element on failure so that
                    // we can update its rendering
                    return tree.refresh(element).then(function () { return val.children; });
                }
                return val.children;
            });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].as([]);
        }
    };
    DataSource.prototype.getParent = function (tree, element) {
        var result = null;
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            result = element.parent;
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["b" /* OneReference */]) {
            result = element.parent;
        }
        return __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].as(result);
    };
    DataSource = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_21__common_services_resolverService_js__["a" /* ITextModelService */])
    ], DataSource);
    return DataSource;
}());
var Controller = /** @class */ (function (_super) {
    __extends(Controller, _super);
    function Controller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onDidFocus = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        _this.onDidFocus = _this._onDidFocus.event;
        _this._onDidSelect = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        _this.onDidSelect = _this._onDidSelect.event;
        _this._onDidOpenToSide = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        _this.onDidOpenToSide = _this._onDidOpenToSide.event;
        return _this;
    }
    Controller.prototype.onTap = function (tree, element, event) {
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            event.preventDefault();
            event.stopPropagation();
            return this._expandCollapse(tree, element);
        }
        var result = _super.prototype.onTap.call(this, tree, element, event);
        this._onDidFocus.fire(element);
        return result;
    };
    Controller.prototype.onMouseDown = function (tree, element, event) {
        var isDoubleClick = event.detail === 2;
        if (event.leftButton) {
            if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
                if (this.openOnSingleClick || isDoubleClick || this.isClickOnTwistie(event)) {
                    event.preventDefault();
                    event.stopPropagation();
                    return this._expandCollapse(tree, element);
                }
            }
            var result = _super.prototype.onClick.call(this, tree, element, event);
            var openToSide = event.ctrlKey || event.metaKey || event.altKey;
            if (openToSide && (isDoubleClick || this.openOnSingleClick)) {
                this._onDidOpenToSide.fire(element);
            }
            else if (isDoubleClick) {
                this._onDidSelect.fire(element);
            }
            else if (this.openOnSingleClick) {
                this._onDidFocus.fire(element);
            }
            return result;
        }
        return false;
    };
    Controller.prototype.onClick = function (tree, element, event) {
        if (event.leftButton) {
            return false; // Already handled by onMouseDown
        }
        return _super.prototype.onClick.call(this, tree, element, event);
    };
    Controller.prototype._expandCollapse = function (tree, element) {
        if (tree.isExpanded(element)) {
            tree.collapse(element).done(null, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
        }
        else {
            tree.expand(element).done(null, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
        }
        return true;
    };
    Controller.prototype.onEscape = function (tree, event) {
        return false;
    };
    Controller.prototype.dispose = function () {
        this._onDidFocus.dispose();
        this._onDidSelect.dispose();
        this._onDidOpenToSide.dispose();
    };
    return Controller;
}(__WEBPACK_IMPORTED_MODULE_28__platform_list_browser_listService_js__["d" /* WorkbenchTreeController */]));
var FileReferencesTemplate = /** @class */ (function () {
    function FileReferencesTemplate(container, _contextService, _environmentService, themeService) {
        var _this = this;
        this._contextService = _contextService;
        this._environmentService = _environmentService;
        var parent = document.createElement('div');
        __WEBPACK_IMPORTED_MODULE_10__base_browser_dom_js__["f" /* addClass */](parent, 'reference-file');
        container.appendChild(parent);
        this.file = new __WEBPACK_IMPORTED_MODULE_13__base_browser_ui_iconLabel_iconLabel_js__["a" /* FileLabel */](parent, __WEBPACK_IMPORTED_MODULE_26__base_common_uri_js__["a" /* default */].parse('no:file'), this._contextService, this._environmentService);
        this.badge = new __WEBPACK_IMPORTED_MODULE_12__base_browser_ui_countBadge_countBadge_js__["a" /* CountBadge */](Object(__WEBPACK_IMPORTED_MODULE_9__base_browser_builder_js__["a" /* $ */])('.count').appendTo(parent).getHTMLElement());
        var styler = Object(__WEBPACK_IMPORTED_MODULE_24__platform_theme_common_styler_js__["a" /* attachBadgeStyler */])(this.badge, themeService);
        this.dispose = function () {
            _this.file.dispose();
            styler.dispose();
        };
    }
    FileReferencesTemplate.prototype.set = function (element) {
        this.file.setFile(element.uri, this._contextService, this._environmentService);
        var len = element.children.length;
        this.badge.setCount(len);
        if (element.failure) {
            this.badge.setTitleFormat(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('referencesFailre', "Failed to resolve file."));
        }
        else if (len > 1) {
            this.badge.setTitleFormat(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('referencesCount', "{0} references", len));
        }
        else {
            this.badge.setTitleFormat(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('referenceCount', "{0} reference", len));
        }
    };
    FileReferencesTemplate = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_15__platform_workspace_common_workspace_js__["a" /* IWorkspaceContextService */]),
        __param(2, Object(__WEBPACK_IMPORTED_MODULE_14__platform_instantiation_common_instantiation_js__["d" /* optional */])(__WEBPACK_IMPORTED_MODULE_25__platform_environment_common_environment_js__["a" /* IEnvironmentService */])),
        __param(3, __WEBPACK_IMPORTED_MODULE_23__platform_theme_common_themeService_js__["c" /* IThemeService */])
    ], FileReferencesTemplate);
    return FileReferencesTemplate;
}());
var OneReferenceTemplate = /** @class */ (function () {
    function OneReferenceTemplate(container) {
        var parent = document.createElement('div');
        this.before = document.createElement('span');
        this.inside = document.createElement('span');
        this.after = document.createElement('span');
        __WEBPACK_IMPORTED_MODULE_10__base_browser_dom_js__["f" /* addClass */](this.inside, 'referenceMatch');
        __WEBPACK_IMPORTED_MODULE_10__base_browser_dom_js__["f" /* addClass */](parent, 'reference');
        parent.appendChild(this.before);
        parent.appendChild(this.inside);
        parent.appendChild(this.after);
        container.appendChild(parent);
    }
    OneReferenceTemplate.prototype.set = function (element) {
        var _a = element.parent.preview.preview(element.range), before = _a.before, inside = _a.inside, after = _a.after;
        this.before.innerHTML = __WEBPACK_IMPORTED_MODULE_6__base_common_strings_js__["escape"](before);
        this.inside.innerHTML = __WEBPACK_IMPORTED_MODULE_6__base_common_strings_js__["escape"](inside);
        this.after.innerHTML = __WEBPACK_IMPORTED_MODULE_6__base_common_strings_js__["escape"](after);
    };
    return OneReferenceTemplate;
}());
var Renderer = /** @class */ (function () {
    function Renderer(_contextService, _themeService, _environmentService) {
        this._contextService = _contextService;
        this._themeService = _themeService;
        this._environmentService = _environmentService;
        //
    }
    Renderer.prototype.getHeight = function (tree, element) {
        return 23;
    };
    Renderer.prototype.getTemplateId = function (tree, element) {
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            return Renderer._ids.FileReferences;
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["b" /* OneReference */]) {
            return Renderer._ids.OneReference;
        }
        throw element;
    };
    Renderer.prototype.renderTemplate = function (tree, templateId, container) {
        if (templateId === Renderer._ids.FileReferences) {
            return new FileReferencesTemplate(container, this._contextService, this._environmentService, this._themeService);
        }
        else if (templateId === Renderer._ids.OneReference) {
            return new OneReferenceTemplate(container);
        }
        throw templateId;
    };
    Renderer.prototype.renderElement = function (tree, element, templateId, templateData) {
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            templateData.set(element);
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["b" /* OneReference */]) {
            templateData.set(element);
        }
        else {
            throw templateId;
        }
    };
    Renderer.prototype.disposeTemplate = function (tree, templateId, templateData) {
        if (templateData instanceof FileReferencesTemplate) {
            templateData.dispose();
        }
    };
    Renderer._ids = {
        FileReferences: 'FileReferences',
        OneReference: 'OneReference'
    };
    Renderer = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_15__platform_workspace_common_workspace_js__["a" /* IWorkspaceContextService */]),
        __param(1, __WEBPACK_IMPORTED_MODULE_23__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(2, Object(__WEBPACK_IMPORTED_MODULE_14__platform_instantiation_common_instantiation_js__["d" /* optional */])(__WEBPACK_IMPORTED_MODULE_25__platform_environment_common_environment_js__["a" /* IEnvironmentService */]))
    ], Renderer);
    return Renderer;
}());
var AriaProvider = /** @class */ (function () {
    function AriaProvider() {
    }
    AriaProvider.prototype.getAriaLabel = function (tree, element) {
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            return element.getAriaMessage();
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["b" /* OneReference */]) {
            return element.getAriaMessage();
        }
        else {
            return undefined;
        }
    };
    return AriaProvider;
}());
var VSash = /** @class */ (function () {
    function VSash(container, ratio) {
        var _this = this;
        this._disposables = [];
        this._onDidChangePercentages = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        this._ratio = ratio;
        this._sash = new __WEBPACK_IMPORTED_MODULE_11__base_browser_ui_sash_sash_js__["b" /* Sash */](container, {
            getVerticalSashLeft: function () { return _this._width * _this._ratio; },
            getVerticalSashHeight: function () { return _this._height; }
        });
        // compute the current widget clientX postion since
        // the sash works with clientX when dragging
        var clientX;
        this._disposables.push(this._sash.onDidStart(function (e) {
            clientX = e.startX - (_this._width * _this.ratio);
        }));
        this._disposables.push(this._sash.onDidChange(function (e) {
            // compute the new position of the sash and from that
            // compute the new ratio that we are using
            var newLeft = e.currentX - clientX;
            if (newLeft > 20 && newLeft + 20 < _this._width) {
                _this._ratio = newLeft / _this._width;
                _this._sash.layout();
                _this._onDidChangePercentages.fire(_this);
            }
        }));
    }
    VSash.prototype.dispose = function () {
        this._sash.dispose();
        this._onDidChangePercentages.dispose();
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
    };
    Object.defineProperty(VSash.prototype, "onDidChangePercentages", {
        get: function () {
            return this._onDidChangePercentages.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VSash.prototype, "width", {
        set: function (value) {
            this._width = value;
            this._sash.layout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VSash.prototype, "height", {
        set: function (value) {
            this._height = value;
            this._sash.layout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VSash.prototype, "percentages", {
        get: function () {
            var left = 100 * this._ratio;
            var right = 100 - left;
            return [left + "%", right + "%"];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VSash.prototype, "ratio", {
        get: function () {
            return this._ratio;
        },
        enumerable: true,
        configurable: true
    });
    return VSash;
}());
var ctxReferenceWidgetSearchTreeFocused = new __WEBPACK_IMPORTED_MODULE_29__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('referenceSearchTreeFocused', true);
/**
 * ZoneWidget that is shown inside the editor
 */
var ReferenceWidget = /** @class */ (function (_super) {
    __extends(ReferenceWidget, _super);
    function ReferenceWidget(editor, _defaultTreeKeyboardSupport, layoutData, themeService, _textModelResolverService, _instantiationService, _uriDisplay) {
        var _this = _super.call(this, editor, { showFrame: false, showArrow: true, isResizeable: true, isAccessible: true }) || this;
        _this._defaultTreeKeyboardSupport = _defaultTreeKeyboardSupport;
        _this.layoutData = layoutData;
        _this._textModelResolverService = _textModelResolverService;
        _this._instantiationService = _instantiationService;
        _this._uriDisplay = _uriDisplay;
        _this._disposeOnNewModel = [];
        _this._callOnDispose = [];
        _this._onDidSelectReference = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        _this._applyTheme(themeService.getTheme());
        _this._callOnDispose.push(themeService.onThemeChange(_this._applyTheme.bind(_this)));
        _this.create();
        return _this;
    }
    ReferenceWidget.prototype._applyTheme = function (theme) {
        var borderColor = theme.getColor(peekViewBorder) || __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].transparent;
        this.style({
            arrowColor: borderColor,
            frameColor: borderColor,
            headerBackgroundColor: theme.getColor(peekViewTitleBackground) || __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].transparent,
            primaryHeadingColor: theme.getColor(peekViewTitleForeground),
            secondaryHeadingColor: theme.getColor(peekViewTitleInfoForeground)
        });
    };
    ReferenceWidget.prototype.dispose = function () {
        this.setModel(null);
        this._callOnDispose = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._callOnDispose);
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._preview, this._previewNotAvailableMessage, this._tree, this._sash, this._previewModelReference);
        _super.prototype.dispose.call(this);
    };
    Object.defineProperty(ReferenceWidget.prototype, "onDidSelectReference", {
        get: function () {
            return this._onDidSelectReference.event;
        },
        enumerable: true,
        configurable: true
    });
    ReferenceWidget.prototype.show = function (where) {
        this.editor.revealRangeInCenterIfOutsideViewport(where, 0 /* Smooth */);
        _super.prototype.show.call(this, where, this.layoutData.heightInLines || 18);
    };
    ReferenceWidget.prototype.focus = function () {
        this._tree.domFocus();
    };
    ReferenceWidget.prototype._onTitleClick = function (e) {
        if (this._preview && this._preview.getModel()) {
            this._onDidSelectReference.fire({
                element: this._getFocusedReference(),
                kind: e.ctrlKey || e.metaKey || e.altKey ? 'side' : 'open',
                source: 'title'
            });
        }
    };
    ReferenceWidget.prototype._fillBody = function (containerElement) {
        var _this = this;
        var container = Object(__WEBPACK_IMPORTED_MODULE_9__base_browser_builder_js__["a" /* $ */])(containerElement);
        this.setCssClass('reference-zone-widget');
        // message pane
        container.div({ 'class': 'messages' }, function (div) {
            _this._messageContainer = div.hide();
        });
        // editor
        container.div({ 'class': 'preview inline' }, function (div) {
            var options = {
                scrollBeyondLastLine: false,
                scrollbar: {
                    verticalScrollbarSize: 14,
                    horizontal: 'auto',
                    useShadows: true,
                    verticalHasArrows: false,
                    horizontalHasArrows: false
                },
                overviewRulerLanes: 2,
                fixedOverflowWidgets: true,
                minimap: {
                    enabled: false
                }
            };
            _this._preview = _this._instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_18__browser_widget_embeddedCodeEditorWidget_js__["a" /* EmbeddedCodeEditorWidget */], div.getHTMLElement(), options, _this.editor);
            _this._previewContainer = div.hide();
            _this._previewNotAvailableMessage = __WEBPACK_IMPORTED_MODULE_17__common_model_textModel_js__["b" /* TextModel */].createFromString(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('missingPreviewMessage', "no preview available"));
        });
        // sash
        this._sash = new VSash(containerElement, this.layoutData.ratio || .8);
        this._sash.onDidChangePercentages(function () {
            var _a = _this._sash.percentages, left = _a[0], right = _a[1];
            _this._previewContainer.style({ width: left });
            _this._treeContainer.style({ width: right });
            _this._preview.layout();
            _this._tree.layout();
            _this.layoutData.ratio = _this._sash.ratio;
        });
        // tree
        container.div({ 'class': 'ref-tree inline' }, function (div) {
            var controller = _this._instantiationService.createInstance(Controller, { keyboardSupport: _this._defaultTreeKeyboardSupport, clickBehavior: __WEBPACK_IMPORTED_MODULE_30__base_parts_tree_browser_treeDefaults_js__["a" /* ClickBehavior */].ON_MOUSE_UP /* our controller already deals with this */ });
            _this._callOnDispose.push(controller);
            var config = {
                dataSource: _this._instantiationService.createInstance(DataSource),
                renderer: _this._instantiationService.createInstance(Renderer),
                controller: controller,
                accessibilityProvider: new AriaProvider()
            };
            var options = {
                twistiePixels: 20,
                ariaLabel: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('treeAriaLabel', "References")
            };
            _this._tree = _this._instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_28__platform_list_browser_listService_js__["c" /* WorkbenchTree */], div.getHTMLElement(), config, options);
            ctxReferenceWidgetSearchTreeFocused.bindTo(_this._tree.contextKeyService);
            // listen on selection and focus
            var onEvent = function (element, kind) {
                if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["b" /* OneReference */]) {
                    if (kind === 'show') {
                        _this._revealReference(element, false);
                    }
                    _this._onDidSelectReference.fire({ element: element, kind: kind, source: 'tree' });
                }
            };
            _this._disposables.push(_this._tree.onDidChangeFocus(function (event) {
                if (event && event.payload && event.payload.origin === 'keyboard') {
                    onEvent(event.focus, 'show'); // only handle events from keyboard, mouse/touch is handled by other listeners below
                }
            }));
            _this._disposables.push(_this._tree.onDidChangeSelection(function (event) {
                if (event && event.payload && event.payload.origin === 'keyboard') {
                    onEvent(event.selection[0], 'goto'); // only handle events from keyboard, mouse/touch is handled by other listeners below
                }
            }));
            _this._disposables.push(controller.onDidFocus(function (element) { return onEvent(element, 'show'); }));
            _this._disposables.push(controller.onDidSelect(function (element) { return onEvent(element, 'goto'); }));
            _this._disposables.push(controller.onDidOpenToSide(function (element) { return onEvent(element, 'side'); }));
            _this._treeContainer = div.hide();
        });
    };
    ReferenceWidget.prototype._doLayoutBody = function (heightInPixel, widthInPixel) {
        _super.prototype._doLayoutBody.call(this, heightInPixel, widthInPixel);
        var height = heightInPixel + 'px';
        this._sash.height = heightInPixel;
        this._sash.width = widthInPixel;
        // set height/width
        var _a = this._sash.percentages, left = _a[0], right = _a[1];
        this._previewContainer.style({ height: height, width: left });
        this._treeContainer.style({ height: height, width: right });
        // forward
        this._tree.layout(heightInPixel);
        this._preview.layout();
        // store layout data
        this.layoutData = {
            heightInLines: this._viewZone.heightInLines,
            ratio: this._sash.ratio
        };
    };
    ReferenceWidget.prototype._onWidth = function (widthInPixel) {
        this._sash.width = widthInPixel;
        this._preview.layout();
    };
    ReferenceWidget.prototype.setSelection = function (selection) {
        var _this = this;
        return this._revealReference(selection, true).then(function () {
            // show in tree
            _this._tree.setSelection([selection]);
            _this._tree.setFocus(selection);
        });
    };
    ReferenceWidget.prototype.setModel = function (newModel) {
        // clean up
        this._disposeOnNewModel = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._disposeOnNewModel);
        this._model = newModel;
        if (this._model) {
            return this._onNewModel();
        }
        return undefined;
    };
    ReferenceWidget.prototype._onNewModel = function () {
        var _this = this;
        if (this._model.empty) {
            this.setTitle('');
            this._messageContainer.innerHtml(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('noResults', "No results")).show();
            return __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].as(void 0);
        }
        this._messageContainer.hide();
        this._decorationsManager = new DecorationsManager(this._preview, this._model);
        this._disposeOnNewModel.push(this._decorationsManager);
        // listen on model changes
        this._disposeOnNewModel.push(this._model.onDidChangeReferenceRange(function (reference) { return _this._tree.refresh(reference); }));
        // listen on editor
        this._disposeOnNewModel.push(this._preview.onMouseDown(function (e) {
            var event = e.event, target = e.target;
            if (event.detail === 2) {
                _this._onDidSelectReference.fire({
                    element: { uri: _this._getFocusedReference().uri, range: target.range },
                    kind: (event.ctrlKey || event.metaKey || event.altKey) ? 'side' : 'open',
                    source: 'editor'
                });
            }
        }));
        // make sure things are rendered
        __WEBPACK_IMPORTED_MODULE_10__base_browser_dom_js__["f" /* addClass */](this.container, 'results-loaded');
        this._treeContainer.show();
        this._previewContainer.show();
        this._preview.layout();
        this._tree.layout();
        this.focus();
        // pick input and a reference to begin with
        var input = this._model.groups.length === 1 ? this._model.groups[0] : this._model;
        return this._tree.setInput(input);
    };
    ReferenceWidget.prototype._getFocusedReference = function () {
        var element = this._tree.getFocus();
        if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["b" /* OneReference */]) {
            return element;
        }
        else if (element instanceof __WEBPACK_IMPORTED_MODULE_20__referencesModel_js__["a" /* FileReferences */]) {
            if (element.children.length > 0) {
                return element.children[0];
            }
        }
        return undefined;
    };
    ReferenceWidget.prototype._revealReference = function (reference, revealParent) {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Update widget header
                        if (reference.uri.scheme !== __WEBPACK_IMPORTED_MODULE_5__base_common_network_js__["a" /* Schemas */].inMemory) {
                            this.setTitle(Object(__WEBPACK_IMPORTED_MODULE_32__base_common_resources_js__["a" /* basenameOrAuthority */])(reference.uri), this._uriDisplay.getLabel(Object(__WEBPACK_IMPORTED_MODULE_32__base_common_resources_js__["b" /* dirname */])(reference.uri), false));
                        }
                        else {
                            this.setTitle(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekView.alternateTitle', "References"));
                        }
                        promise = this._textModelResolverService.createModelReference(reference.uri);
                        if (!revealParent) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._tree.reveal(reference.parent)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_7__base_common_winjs_base_js__["b" /* TPromise */].join([promise, this._tree.reveal(reference)]).then(function (values) {
                            var ref = values[0];
                            if (!_this._model) {
                                ref.dispose();
                                // disposed
                                return;
                            }
                            Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(_this._previewModelReference);
                            // show in editor
                            var model = ref.object;
                            if (model) {
                                _this._previewModelReference = ref;
                                var isSameModel = (_this._preview.getModel() === model.textEditorModel);
                                _this._preview.setModel(model.textEditorModel);
                                var sel = __WEBPACK_IMPORTED_MODULE_16__common_core_range_js__["a" /* Range */].lift(reference.range).collapseToStart();
                                _this._preview.setSelection(sel);
                                _this._preview.revealRangeInCenter(sel, isSameModel ? 0 /* Smooth */ : 1 /* Immediate */);
                            }
                            else {
                                _this._preview.setModel(_this._previewNotAvailableMessage);
                                ref.dispose();
                            }
                        }, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */])];
                }
            });
        });
    };
    ReferenceWidget = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_23__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_21__common_services_resolverService_js__["a" /* ITextModelService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_14__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_31__platform_uriDisplay_common_uriDisplay_js__["a" /* IUriDisplayService */])
    ], ReferenceWidget);
    return ReferenceWidget;
}(__WEBPACK_IMPORTED_MODULE_19__peekViewWidget_js__["b" /* PeekViewWidget */]));

// theming
var peekViewTitleBackground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewTitle.background', { dark: '#1E1E1E', light: '#FFFFFF', hc: '#0C141F' }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewTitleBackground', 'Background color of the peek view title area.'));
var peekViewTitleForeground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewTitleLabel.foreground', { dark: '#FFFFFF', light: '#333333', hc: '#FFFFFF' }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewTitleForeground', 'Color of the peek view title.'));
var peekViewTitleInfoForeground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewTitleDescription.foreground', { dark: '#ccccccb3', light: '#6c6c6cb3', hc: '#FFFFFF99' }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewTitleInfoForeground', 'Color of the peek view title info.'));
var peekViewBorder = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekView.border', { dark: '#007acc', light: '#007acc', hc: __WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["e" /* contrastBorder */] }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewBorder', 'Color of the peek view borders and arrow.'));
var peekViewResultsBackground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewResult.background', { dark: '#252526', light: '#F3F3F3', hc: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewResultsBackground', 'Background color of the peek view result list.'));
var peekViewResultsMatchForeground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewResult.lineForeground', { dark: '#bbbbbb', light: '#646465', hc: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewResultsMatchForeground', 'Foreground color for line nodes in the peek view result list.'));
var peekViewResultsFileForeground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewResult.fileForeground', { dark: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].white, light: '#1E1E1E', hc: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewResultsFileForeground', 'Foreground color for file nodes in the peek view result list.'));
var peekViewResultsSelectionBackground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewResult.selectionBackground', { dark: '#3399ff33', light: '#3399ff33', hc: null }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewResultsSelectionBackground', 'Background color of the selected entry in the peek view result list.'));
var peekViewResultsSelectionForeground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewResult.selectionForeground', { dark: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].white, light: '#6C6C6C', hc: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].white }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewResultsSelectionForeground', 'Foreground color of the selected entry in the peek view result list.'));
var peekViewEditorBackground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewEditor.background', { dark: '#001F33', light: '#F2F8FC', hc: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].black }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewEditorBackground', 'Background color of the peek view editor.'));
var peekViewEditorGutterBackground = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewEditorGutter.background', { dark: peekViewEditorBackground, light: peekViewEditorBackground, hc: peekViewEditorBackground }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewEditorGutterBackground', 'Background color of the gutter in the peek view editor.'));
var peekViewResultsMatchHighlight = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewResult.matchHighlightBackground', { dark: '#ea5c004d', light: '#ea5c004d', hc: null }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewResultsMatchHighlight', 'Match highlight color in the peek view result list.'));
var peekViewEditorMatchHighlight = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewEditor.matchHighlightBackground', { dark: '#ff8f0099', light: '#f5d802de', hc: null }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewEditorMatchHighlight', 'Match highlight color in the peek view editor.'));
var peekViewEditorMatchHighlightBorder = Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('peekViewEditor.matchHighlightBorder', { dark: null, light: null, hc: __WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["b" /* activeContrastBorder */] }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('peekViewEditorMatchHighlightBorder', 'Match highlight border in the peek view editor.'));
Object(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var findMatchHighlightColor = theme.getColor(peekViewResultsMatchHighlight);
    if (findMatchHighlightColor) {
        collector.addRule(".monaco-editor .reference-zone-widget .ref-tree .referenceMatch { background-color: " + findMatchHighlightColor + "; }");
    }
    var referenceHighlightColor = theme.getColor(peekViewEditorMatchHighlight);
    if (referenceHighlightColor) {
        collector.addRule(".monaco-editor .reference-zone-widget .preview .reference-decoration { background-color: " + referenceHighlightColor + "; }");
    }
    var referenceHighlightBorder = theme.getColor(peekViewEditorMatchHighlightBorder);
    if (referenceHighlightBorder) {
        collector.addRule(".monaco-editor .reference-zone-widget .preview .reference-decoration { border: 2px solid " + referenceHighlightBorder + "; box-sizing: border-box; }");
    }
    var hcOutline = theme.getColor(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_colorRegistry_js__["b" /* activeContrastBorder */]);
    if (hcOutline) {
        collector.addRule(".monaco-editor .reference-zone-widget .ref-tree .referenceMatch { border: 1px dotted " + hcOutline + "; box-sizing: border-box; }");
    }
    var resultsBackground = theme.getColor(peekViewResultsBackground);
    if (resultsBackground) {
        collector.addRule(".monaco-editor .reference-zone-widget .ref-tree { background-color: " + resultsBackground + "; }");
    }
    var resultsMatchForeground = theme.getColor(peekViewResultsMatchForeground);
    if (resultsMatchForeground) {
        collector.addRule(".monaco-editor .reference-zone-widget .ref-tree { color: " + resultsMatchForeground + "; }");
    }
    var resultsFileForeground = theme.getColor(peekViewResultsFileForeground);
    if (resultsFileForeground) {
        collector.addRule(".monaco-editor .reference-zone-widget .ref-tree .reference-file { color: " + resultsFileForeground + "; }");
    }
    var resultsSelectedBackground = theme.getColor(peekViewResultsSelectionBackground);
    if (resultsSelectedBackground) {
        collector.addRule(".monaco-editor .reference-zone-widget .ref-tree .monaco-tree.focused .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted) { background-color: " + resultsSelectedBackground + "; }");
    }
    var resultsSelectedForeground = theme.getColor(peekViewResultsSelectionForeground);
    if (resultsSelectedForeground) {
        collector.addRule(".monaco-editor .reference-zone-widget .ref-tree .monaco-tree.focused .monaco-tree-rows > .monaco-tree-row.selected:not(.highlighted) { color: " + resultsSelectedForeground + " !important; }");
    }
    var editorBackground = theme.getColor(peekViewEditorBackground);
    if (editorBackground) {
        collector.addRule(".monaco-editor .reference-zone-widget .preview .monaco-editor .monaco-editor-background," +
            ".monaco-editor .reference-zone-widget .preview .monaco-editor .inputarea.ime-input {" +
            ("\tbackground-color: " + editorBackground + ";") +
            "}");
    }
    var editorGutterBackground = theme.getColor(peekViewEditorGutterBackground);
    if (editorGutterBackground) {
        collector.addRule(".monaco-editor .reference-zone-widget .preview .monaco-editor .margin {" +
            ("\tbackground-color: " + editorGutterBackground + ";") +
            "}");
    }
});


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iconlabel_css__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iconlabel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__iconlabel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__highlightedlabel_highlightedLabel_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_labels_js__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var FastLabelNode = /** @class */ (function () {
    function FastLabelNode(_element) {
        this._element = _element;
    }
    Object.defineProperty(FastLabelNode.prototype, "element", {
        get: function () {
            return this._element;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FastLabelNode.prototype, "textContent", {
        set: function (content) {
            if (this.disposed || content === this._textContent) {
                return;
            }
            this._textContent = content;
            this._element.textContent = content;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FastLabelNode.prototype, "className", {
        set: function (className) {
            if (this.disposed || className === this._className) {
                return;
            }
            this._className = className;
            this._element.className = className;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FastLabelNode.prototype, "title", {
        set: function (title) {
            if (this.disposed || title === this._title) {
                return;
            }
            this._title = title;
            if (this._title) {
                this._element.title = title;
            }
            else {
                this._element.removeAttribute('title');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FastLabelNode.prototype, "empty", {
        set: function (empty) {
            if (this.disposed || empty === this._empty) {
                return;
            }
            this._empty = empty;
            this._element.style.marginLeft = empty ? '0' : null;
        },
        enumerable: true,
        configurable: true
    });
    FastLabelNode.prototype.dispose = function () {
        this.disposed = true;
    };
    return FastLabelNode;
}());
var IconLabel = /** @class */ (function (_super) {
    __extends(IconLabel, _super);
    function IconLabel(container, options) {
        var _this = _super.call(this) || this;
        _this.domNode = _this._register(new FastLabelNode(__WEBPACK_IMPORTED_MODULE_1__dom_js__["k" /* append */](container, __WEBPACK_IMPORTED_MODULE_1__dom_js__["a" /* $ */]('.monaco-icon-label'))));
        _this.labelDescriptionContainer = _this._register(new FastLabelNode(__WEBPACK_IMPORTED_MODULE_1__dom_js__["k" /* append */](_this.domNode.element, __WEBPACK_IMPORTED_MODULE_1__dom_js__["a" /* $ */]('.monaco-icon-label-description-container'))));
        if (options && options.supportHighlights) {
            _this.labelNode = _this._register(new __WEBPACK_IMPORTED_MODULE_2__highlightedlabel_highlightedLabel_js__["a" /* HighlightedLabel */](__WEBPACK_IMPORTED_MODULE_1__dom_js__["k" /* append */](_this.labelDescriptionContainer.element, __WEBPACK_IMPORTED_MODULE_1__dom_js__["a" /* $ */]('a.label-name'))));
        }
        else {
            _this.labelNode = _this._register(new FastLabelNode(__WEBPACK_IMPORTED_MODULE_1__dom_js__["k" /* append */](_this.labelDescriptionContainer.element, __WEBPACK_IMPORTED_MODULE_1__dom_js__["a" /* $ */]('a.label-name'))));
        }
        if (options && options.supportDescriptionHighlights) {
            _this.descriptionNodeFactory = function () { return _this._register(new __WEBPACK_IMPORTED_MODULE_2__highlightedlabel_highlightedLabel_js__["a" /* HighlightedLabel */](__WEBPACK_IMPORTED_MODULE_1__dom_js__["k" /* append */](_this.labelDescriptionContainer.element, __WEBPACK_IMPORTED_MODULE_1__dom_js__["a" /* $ */]('span.label-description')))); };
        }
        else {
            _this.descriptionNodeFactory = function () { return _this._register(new FastLabelNode(__WEBPACK_IMPORTED_MODULE_1__dom_js__["k" /* append */](_this.labelDescriptionContainer.element, __WEBPACK_IMPORTED_MODULE_1__dom_js__["a" /* $ */]('span.label-description')))); };
        }
        return _this;
    }
    IconLabel.prototype.setValue = function (label, description, options) {
        var classes = ['monaco-icon-label'];
        if (options) {
            if (options.extraClasses) {
                classes.push.apply(classes, options.extraClasses);
            }
            if (options.italic) {
                classes.push('italic');
            }
        }
        this.domNode.className = classes.join(' ');
        this.domNode.title = options && options.title ? options.title : '';
        if (this.labelNode instanceof __WEBPACK_IMPORTED_MODULE_2__highlightedlabel_highlightedLabel_js__["a" /* HighlightedLabel */]) {
            this.labelNode.set(label || '', options ? options.matches : void 0);
        }
        else {
            this.labelNode.textContent = label || '';
        }
        if (description || this.descriptionNode) {
            if (!this.descriptionNode) {
                this.descriptionNode = this.descriptionNodeFactory(); // description node is created lazily on demand
            }
            if (this.descriptionNode instanceof __WEBPACK_IMPORTED_MODULE_2__highlightedlabel_highlightedLabel_js__["a" /* HighlightedLabel */]) {
                this.descriptionNode.set(description || '', options ? options.descriptionMatches : void 0);
                if (options && options.descriptionTitle) {
                    this.descriptionNode.element.title = options.descriptionTitle;
                }
                else {
                    this.descriptionNode.element.removeAttribute('title');
                }
            }
            else {
                this.descriptionNode.textContent = description || '';
                this.descriptionNode.title = options && options.descriptionTitle ? options.descriptionTitle : '';
                this.descriptionNode.empty = !description;
            }
        }
    };
    return IconLabel;
}(__WEBPACK_IMPORTED_MODULE_5__common_lifecycle_js__["a" /* Disposable */]));

var FileLabel = /** @class */ (function (_super) {
    __extends(FileLabel, _super);
    function FileLabel(container, file, provider, userHome) {
        var _this = _super.call(this, container) || this;
        _this.setFile(file, provider, userHome);
        return _this;
    }
    FileLabel.prototype.setFile = function (file, provider, userHome) {
        var parent = __WEBPACK_IMPORTED_MODULE_3__common_paths_js__["b" /* dirname */](file.fsPath);
        this.setValue(Object(__WEBPACK_IMPORTED_MODULE_4__common_labels_js__["a" /* getBaseLabel */])(file), parent && parent !== '.' ? Object(__WEBPACK_IMPORTED_MODULE_4__common_labels_js__["b" /* getPathLabel */])(parent, userHome, provider) : '', { title: file.fsPath });
    };
    return FileLabel;
}(IconLabel));



/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getPathLabel;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBaseLabel;
/* unused harmony export normalizeDriveLetter */
/* unused harmony export tildify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__network_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_js__ = __webpack_require__(266);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/







/**
 * @deprecated use UriLabelService instead
 */
function getPathLabel(resource, userHomeProvider, rootProvider) {
    if (!resource) {
        return null;
    }
    if (typeof resource === 'string') {
        resource = __WEBPACK_IMPORTED_MODULE_0__uri_js__["a" /* default */].file(resource);
    }
    // return early if we can resolve a relative path label from the root
    var baseResource = rootProvider ? rootProvider.getWorkspaceFolder(resource) : null;
    if (baseResource) {
        var hasMultipleRoots = rootProvider.getWorkspace().folders.length > 1;
        var pathLabel = void 0;
        if (Object(__WEBPACK_IMPORTED_MODULE_5__resources_js__["c" /* isEqual */])(baseResource.uri, resource, !__WEBPACK_IMPORTED_MODULE_4__platform_js__["c" /* isLinux */])) {
            pathLabel = ''; // no label if paths are identical
        }
        else {
            pathLabel = Object(__WEBPACK_IMPORTED_MODULE_1__paths_js__["h" /* normalize */])(Object(__WEBPACK_IMPORTED_MODULE_2__strings_js__["ltrim"])(resource.path.substr(baseResource.uri.path.length), __WEBPACK_IMPORTED_MODULE_1__paths_js__["i" /* sep */]), true);
        }
        if (hasMultipleRoots) {
            var rootName = (baseResource && baseResource.name) ? baseResource.name : Object(__WEBPACK_IMPORTED_MODULE_1__paths_js__["a" /* basename */])(baseResource.uri.fsPath);
            pathLabel = pathLabel ? (rootName + ' • ' + pathLabel) : rootName; // always show root basename if there are multiple
        }
        return pathLabel;
    }
    // return if the resource is neither file:// nor untitled:// and no baseResource was provided
    if (resource.scheme !== __WEBPACK_IMPORTED_MODULE_3__network_js__["a" /* Schemas */].file && resource.scheme !== __WEBPACK_IMPORTED_MODULE_3__network_js__["a" /* Schemas */].untitled) {
        return resource.with({ query: null, fragment: null }).toString(true);
    }
    // convert c:\something => C:\something
    if (hasDriveLetter(resource.fsPath)) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__paths_js__["h" /* normalize */])(normalizeDriveLetter(resource.fsPath), true);
    }
    // normalize and tildify (macOS, Linux only)
    var res = Object(__WEBPACK_IMPORTED_MODULE_1__paths_js__["h" /* normalize */])(resource.fsPath, true);
    if (!__WEBPACK_IMPORTED_MODULE_4__platform_js__["g" /* isWindows */] && userHomeProvider) {
        res = tildify(res, userHomeProvider.userHome);
    }
    return res;
}
function getBaseLabel(resource) {
    if (!resource) {
        return null;
    }
    if (typeof resource === 'string') {
        resource = __WEBPACK_IMPORTED_MODULE_0__uri_js__["a" /* default */].file(resource);
    }
    var base = Object(__WEBPACK_IMPORTED_MODULE_1__paths_js__["a" /* basename */])(resource.path) || (resource.scheme === __WEBPACK_IMPORTED_MODULE_3__network_js__["a" /* Schemas */].file ? resource.fsPath : resource.path) /* can be empty string if '/' is passed in */;
    // convert c: => C:
    if (hasDriveLetter(base)) {
        return normalizeDriveLetter(base);
    }
    return base;
}
function hasDriveLetter(path) {
    return __WEBPACK_IMPORTED_MODULE_4__platform_js__["g" /* isWindows */] && path && path[1] === ':';
}
function normalizeDriveLetter(path) {
    if (hasDriveLetter(path)) {
        return path.charAt(0).toUpperCase() + path.slice(1);
    }
    return path;
}
var normalizedUserHomeCached = Object.create(null);
function tildify(path, userHome) {
    if (__WEBPACK_IMPORTED_MODULE_4__platform_js__["g" /* isWindows */] || !path || !userHome) {
        return path; // unsupported
    }
    // Keep a normalized user home path as cache to prevent accumulated string creation
    var normalizedUserHome = normalizedUserHomeCached.original === userHome ? normalizedUserHomeCached.normalized : void 0;
    if (!normalizedUserHome) {
        normalizedUserHome = "" + Object(__WEBPACK_IMPORTED_MODULE_2__strings_js__["rtrim"])(userHome, __WEBPACK_IMPORTED_MODULE_1__paths_js__["i" /* sep */]) + __WEBPACK_IMPORTED_MODULE_1__paths_js__["i" /* sep */];
        normalizedUserHomeCached = { original: userHome, normalized: normalizedUserHome };
    }
    // Linux: case sensitive, macOS: case insensitive
    if (__WEBPACK_IMPORTED_MODULE_4__platform_js__["c" /* isLinux */] ? Object(__WEBPACK_IMPORTED_MODULE_2__strings_js__["startsWith"])(path, normalizedUserHome) : Object(__WEBPACK_IMPORTED_MODULE_2__strings_js__["startsWithIgnoreCase"])(path, normalizedUserHome)) {
        path = "~/" + path.substr(normalizedUserHome.length);
    }
    return path;
}


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basenameOrAuthority;
/* harmony export (immutable) */ __webpack_exports__["c"] = isEqual;
/* harmony export (immutable) */ __webpack_exports__["b"] = dirname;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



function basenameOrAuthority(resource) {
    return __WEBPACK_IMPORTED_MODULE_0__paths_js__["a" /* basename */](resource.path) || resource.authority;
}
function isEqual(first, second, ignoreCase) {
    var identityEquals = (first === second);
    if (identityEquals) {
        return true;
    }
    if (!first || !second) {
        return false;
    }
    if (ignoreCase) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__strings_js__["equalsIgnoreCase"])(first.toString(), second.toString());
    }
    return first.toString() === second.toString();
}
function dirname(resource) {
    var dirname = __WEBPACK_IMPORTED_MODULE_0__paths_js__["b" /* dirname */](resource.path);
    if (resource.authority && dirname && !__WEBPACK_IMPORTED_MODULE_0__paths_js__["d" /* isAbsolute */](dirname)) {
        return null; // If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character
    }
    return resource.with({
        path: dirname
    });
}


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tokenizeToString;
/* harmony export (immutable) */ __webpack_exports__["a"] = tokenizeLineToHTML;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nullMode_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_lineTokens_js__ = __webpack_require__(97);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





function tokenizeToString(text, languageId) {
    return _tokenizeToString(text, _getSafeTokenizationSupport(languageId));
}
function tokenizeLineToHTML(text, viewLineTokens, colorMap, startOffset, endOffset, tabSize) {
    var result = "<div>";
    var charIndex = startOffset;
    var tabsCharDelta = 0;
    for (var tokenIndex = 0, tokenCount = viewLineTokens.getCount(); tokenIndex < tokenCount; tokenIndex++) {
        var tokenEndIndex = viewLineTokens.getEndOffset(tokenIndex);
        if (tokenEndIndex <= startOffset) {
            continue;
        }
        var partContent = '';
        for (; charIndex < tokenEndIndex && charIndex < endOffset; charIndex++) {
            var charCode = text.charCodeAt(charIndex);
            switch (charCode) {
                case 9 /* Tab */:
                    var insertSpacesCount = tabSize - (charIndex + tabsCharDelta) % tabSize;
                    tabsCharDelta += insertSpacesCount - 1;
                    while (insertSpacesCount > 0) {
                        partContent += '&nbsp;';
                        insertSpacesCount--;
                    }
                    break;
                case 60 /* LessThan */:
                    partContent += '&lt;';
                    break;
                case 62 /* GreaterThan */:
                    partContent += '&gt;';
                    break;
                case 38 /* Ampersand */:
                    partContent += '&amp;';
                    break;
                case 0 /* Null */:
                    partContent += '&#00;';
                    break;
                case 65279 /* UTF8_BOM */:
                case 8232 /* LINE_SEPARATOR_2028 */:
                    partContent += '\ufffd';
                    break;
                case 13 /* CarriageReturn */:
                    // zero width space, because carriage return would introduce a line break
                    partContent += '&#8203';
                    break;
                default:
                    partContent += String.fromCharCode(charCode);
            }
        }
        result += "<span style=\"" + viewLineTokens.getInlineStyle(tokenIndex, colorMap) + "\">" + partContent + "</span>";
        if (tokenEndIndex > endOffset || charIndex >= endOffset) {
            break;
        }
    }
    result += "</div>";
    return result;
}
function _getSafeTokenizationSupport(languageId) {
    var tokenizationSupport = __WEBPACK_IMPORTED_MODULE_1__modes_js__["y" /* TokenizationRegistry */].get(languageId);
    if (tokenizationSupport) {
        return tokenizationSupport;
    }
    return {
        getInitialState: function () { return __WEBPACK_IMPORTED_MODULE_2__nullMode_js__["c" /* NULL_STATE */]; },
        tokenize: undefined,
        tokenize2: function (buffer, state, deltaOffset) { return Object(__WEBPACK_IMPORTED_MODULE_2__nullMode_js__["e" /* nullTokenize2 */])(0 /* Null */, buffer, state, deltaOffset); }
    };
}
function _tokenizeToString(text, tokenizationSupport) {
    var result = "<div class=\"monaco-tokenized-source\">";
    var lines = text.split(/\r\n|\r|\n/);
    var currentState = tokenizationSupport.getInitialState();
    for (var i = 0, len = lines.length; i < len; i++) {
        var line = lines[i];
        if (i > 0) {
            result += "<br/>";
        }
        var tokenizationResult = tokenizationSupport.tokenize2(line, currentState, 0);
        __WEBPACK_IMPORTED_MODULE_3__core_lineTokens_js__["a" /* LineTokens */].convertToEndOffset(tokenizationResult.tokens, line.length);
        var lineTokens = new __WEBPACK_IMPORTED_MODULE_3__core_lineTokens_js__["a" /* LineTokens */](tokenizationResult.tokens, line);
        var viewLineTokens = lineTokens.inflate();
        var startOffset = 0;
        for (var j = 0, lenJ = viewLineTokens.getCount(); j < lenJ; j++) {
            var type = viewLineTokens.getClassName(j);
            var endIndex = viewLineTokens.getEndOffset(j);
            result += "<span class=\"" + type + "\">" + __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["escape"](line.substring(startOffset, endIndex)) + "</span>";
            startOffset = endIndex;
        }
        currentState = tokenizationResult.endState;
    }
    result += "</div>";
    return result;
}


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OutputPosition; });
/* unused harmony export CoordinatesConverter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SplitLinesCollection; });
/* unused harmony export SplitLine */
/* unused harmony export IdentityCoordinatesConverter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdentityLinesCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prefixSumComputer_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewModel_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_color_js__ = __webpack_require__(24);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var OutputPosition = /** @class */ (function () {
    function OutputPosition(outputLineIndex, outputOffset) {
        this.outputLineIndex = outputLineIndex;
        this.outputOffset = outputOffset;
    }
    return OutputPosition;
}());

var CoordinatesConverter = /** @class */ (function () {
    function CoordinatesConverter(lines) {
        this._lines = lines;
    }
    // View -> Model conversion and related methods
    CoordinatesConverter.prototype.convertViewPositionToModelPosition = function (viewPosition) {
        return this._lines.convertViewPositionToModelPosition(viewPosition.lineNumber, viewPosition.column);
    };
    CoordinatesConverter.prototype.convertViewRangeToModelRange = function (viewRange) {
        var start = this._lines.convertViewPositionToModelPosition(viewRange.startLineNumber, viewRange.startColumn);
        var end = this._lines.convertViewPositionToModelPosition(viewRange.endLineNumber, viewRange.endColumn);
        return new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](start.lineNumber, start.column, end.lineNumber, end.column);
    };
    CoordinatesConverter.prototype.validateViewPosition = function (viewPosition, expectedModelPosition) {
        return this._lines.validateViewPosition(viewPosition.lineNumber, viewPosition.column, expectedModelPosition);
    };
    CoordinatesConverter.prototype.validateViewRange = function (viewRange, expectedModelRange) {
        var validViewStart = this._lines.validateViewPosition(viewRange.startLineNumber, viewRange.startColumn, expectedModelRange.getStartPosition());
        var validViewEnd = this._lines.validateViewPosition(viewRange.endLineNumber, viewRange.endColumn, expectedModelRange.getEndPosition());
        return new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](validViewStart.lineNumber, validViewStart.column, validViewEnd.lineNumber, validViewEnd.column);
    };
    // Model -> View conversion and related methods
    CoordinatesConverter.prototype.convertModelPositionToViewPosition = function (modelPosition) {
        return this._lines.convertModelPositionToViewPosition(modelPosition.lineNumber, modelPosition.column);
    };
    CoordinatesConverter.prototype.convertModelRangeToViewRange = function (modelRange) {
        var start = this._lines.convertModelPositionToViewPosition(modelRange.startLineNumber, modelRange.startColumn);
        var end = this._lines.convertModelPositionToViewPosition(modelRange.endLineNumber, modelRange.endColumn);
        return new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](start.lineNumber, start.column, end.lineNumber, end.column);
    };
    CoordinatesConverter.prototype.modelPositionIsVisible = function (modelPosition) {
        return this._lines.modelPositionIsVisible(modelPosition.lineNumber, modelPosition.column);
    };
    return CoordinatesConverter;
}());

var SplitLinesCollection = /** @class */ (function () {
    function SplitLinesCollection(model, linePositionMapperFactory, tabSize, wrappingColumn, columnsForFullWidthChar, wrappingIndent) {
        this.model = model;
        this._validModelVersionId = -1;
        this.tabSize = tabSize;
        this.wrappingColumn = wrappingColumn;
        this.columnsForFullWidthChar = columnsForFullWidthChar;
        this.wrappingIndent = wrappingIndent;
        this.linePositionMapperFactory = linePositionMapperFactory;
        this._constructLines(true);
    }
    SplitLinesCollection.prototype.dispose = function () {
        this.hiddenAreasIds = this.model.deltaDecorations(this.hiddenAreasIds, []);
    };
    SplitLinesCollection.prototype.createCoordinatesConverter = function () {
        return new CoordinatesConverter(this);
    };
    SplitLinesCollection.prototype._ensureValidState = function () {
        var modelVersion = this.model.getVersionId();
        if (modelVersion !== this._validModelVersionId) {
            // This is pretty bad, it means we lost track of the model...
            throw new Error("ViewModel is out of sync with Model!");
        }
    };
    SplitLinesCollection.prototype._constructLines = function (resetHiddenAreas) {
        var _this = this;
        this.lines = [];
        if (resetHiddenAreas) {
            this.hiddenAreasIds = [];
        }
        var linesContent = this.model.getLinesContent();
        var lineCount = linesContent.length;
        var values = new Uint32Array(lineCount);
        var hiddenAreas = this.hiddenAreasIds.map(function (areaId) { return _this.model.getDecorationRange(areaId); }).sort(__WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */].compareRangesUsingStarts);
        var hiddenAreaStart = 1, hiddenAreaEnd = 0;
        var hiddenAreaIdx = -1;
        var nextLineNumberToUpdateHiddenArea = (hiddenAreaIdx + 1 < hiddenAreas.length) ? hiddenAreaEnd + 1 : lineCount + 2;
        for (var i = 0; i < lineCount; i++) {
            var lineNumber = i + 1;
            if (lineNumber === nextLineNumberToUpdateHiddenArea) {
                hiddenAreaIdx++;
                hiddenAreaStart = hiddenAreas[hiddenAreaIdx].startLineNumber;
                hiddenAreaEnd = hiddenAreas[hiddenAreaIdx].endLineNumber;
                nextLineNumberToUpdateHiddenArea = (hiddenAreaIdx + 1 < hiddenAreas.length) ? hiddenAreaEnd + 1 : lineCount + 2;
            }
            var isInHiddenArea = (lineNumber >= hiddenAreaStart && lineNumber <= hiddenAreaEnd);
            var line = createSplitLine(this.linePositionMapperFactory, linesContent[i], this.tabSize, this.wrappingColumn, this.columnsForFullWidthChar, this.wrappingIndent, !isInHiddenArea);
            values[i] = line.getViewLineCount();
            this.lines[i] = line;
        }
        this._validModelVersionId = this.model.getVersionId();
        this.prefixSumComputer = new __WEBPACK_IMPORTED_MODULE_2__prefixSumComputer_js__["b" /* PrefixSumComputerWithCache */](values);
    };
    SplitLinesCollection.prototype.getHiddenAreas = function () {
        var _this = this;
        return this.hiddenAreasIds.map(function (decId) {
            return _this.model.getDecorationRange(decId);
        });
    };
    SplitLinesCollection.prototype._reduceRanges = function (_ranges) {
        var _this = this;
        if (_ranges.length === 0) {
            return [];
        }
        var ranges = _ranges.map(function (r) { return _this.model.validateRange(r); }).sort(__WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */].compareRangesUsingStarts);
        var result = [];
        var currentRangeStart = ranges[0].startLineNumber;
        var currentRangeEnd = ranges[0].endLineNumber;
        for (var i = 1, len = ranges.length; i < len; i++) {
            var range = ranges[i];
            if (range.startLineNumber > currentRangeEnd + 1) {
                result.push(new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](currentRangeStart, 1, currentRangeEnd, 1));
                currentRangeStart = range.startLineNumber;
                currentRangeEnd = range.endLineNumber;
            }
            else if (range.endLineNumber > currentRangeEnd) {
                currentRangeEnd = range.endLineNumber;
            }
        }
        result.push(new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](currentRangeStart, 1, currentRangeEnd, 1));
        return result;
    };
    SplitLinesCollection.prototype.setHiddenAreas = function (_ranges) {
        var _this = this;
        var newRanges = this._reduceRanges(_ranges);
        // BEGIN TODO@Martin: Please stop calling this method on each model change!
        var oldRanges = this.hiddenAreasIds.map(function (areaId) { return _this.model.getDecorationRange(areaId); }).sort(__WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */].compareRangesUsingStarts);
        if (newRanges.length === oldRanges.length) {
            var hasDifference = false;
            for (var i = 0; i < newRanges.length; i++) {
                if (!newRanges[i].equalsRange(oldRanges[i])) {
                    hasDifference = true;
                    break;
                }
            }
            if (!hasDifference) {
                return false;
            }
        }
        // END TODO@Martin: Please stop calling this method on each model change!
        var newDecorations = [];
        for (var i = 0; i < newRanges.length; i++) {
            newDecorations.push({
                range: newRanges[i],
                options: __WEBPACK_IMPORTED_MODULE_5__model_textModel_js__["a" /* ModelDecorationOptions */].EMPTY
            });
        }
        this.hiddenAreasIds = this.model.deltaDecorations(this.hiddenAreasIds, newDecorations);
        var hiddenAreas = newRanges;
        var hiddenAreaStart = 1, hiddenAreaEnd = 0;
        var hiddenAreaIdx = -1;
        var nextLineNumberToUpdateHiddenArea = (hiddenAreaIdx + 1 < hiddenAreas.length) ? hiddenAreaEnd + 1 : this.lines.length + 2;
        var hasVisibleLine = false;
        for (var i = 0; i < this.lines.length; i++) {
            var lineNumber = i + 1;
            if (lineNumber === nextLineNumberToUpdateHiddenArea) {
                hiddenAreaIdx++;
                hiddenAreaStart = hiddenAreas[hiddenAreaIdx].startLineNumber;
                hiddenAreaEnd = hiddenAreas[hiddenAreaIdx].endLineNumber;
                nextLineNumberToUpdateHiddenArea = (hiddenAreaIdx + 1 < hiddenAreas.length) ? hiddenAreaEnd + 1 : this.lines.length + 2;
            }
            var lineChanged = false;
            if (lineNumber >= hiddenAreaStart && lineNumber <= hiddenAreaEnd) {
                // Line should be hidden
                if (this.lines[i].isVisible()) {
                    this.lines[i] = this.lines[i].setVisible(false);
                    lineChanged = true;
                }
            }
            else {
                hasVisibleLine = true;
                // Line should be visible
                if (!this.lines[i].isVisible()) {
                    this.lines[i] = this.lines[i].setVisible(true);
                    lineChanged = true;
                }
            }
            if (lineChanged) {
                var newOutputLineCount = this.lines[i].getViewLineCount();
                this.prefixSumComputer.changeValue(i, newOutputLineCount);
            }
        }
        if (!hasVisibleLine) {
            // Cannot have everything be hidden => reveal everything!
            this.setHiddenAreas([]);
        }
        return true;
    };
    SplitLinesCollection.prototype.modelPositionIsVisible = function (modelLineNumber, modelColumn) {
        if (modelLineNumber < 1 || modelLineNumber > this.lines.length) {
            // invalid arguments
            return false;
        }
        return this.lines[modelLineNumber - 1].isVisible();
    };
    SplitLinesCollection.prototype.setTabSize = function (newTabSize) {
        if (this.tabSize === newTabSize) {
            return false;
        }
        this.tabSize = newTabSize;
        this._constructLines(false);
        return true;
    };
    SplitLinesCollection.prototype.setWrappingSettings = function (wrappingIndent, wrappingColumn, columnsForFullWidthChar) {
        if (this.wrappingIndent === wrappingIndent && this.wrappingColumn === wrappingColumn && this.columnsForFullWidthChar === columnsForFullWidthChar) {
            return false;
        }
        this.wrappingIndent = wrappingIndent;
        this.wrappingColumn = wrappingColumn;
        this.columnsForFullWidthChar = columnsForFullWidthChar;
        this._constructLines(false);
        return true;
    };
    SplitLinesCollection.prototype.onModelFlushed = function () {
        this._constructLines(true);
    };
    SplitLinesCollection.prototype.onModelLinesDeleted = function (versionId, fromLineNumber, toLineNumber) {
        if (versionId <= this._validModelVersionId) {
            // Here we check for versionId in case the lines were reconstructed in the meantime.
            // We don't want to apply stale change events on top of a newer read model state.
            return null;
        }
        var outputFromLineNumber = (fromLineNumber === 1 ? 1 : this.prefixSumComputer.getAccumulatedValue(fromLineNumber - 2) + 1);
        var outputToLineNumber = this.prefixSumComputer.getAccumulatedValue(toLineNumber - 1);
        this.lines.splice(fromLineNumber - 1, toLineNumber - fromLineNumber + 1);
        this.prefixSumComputer.removeValues(fromLineNumber - 1, toLineNumber - fromLineNumber + 1);
        return new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["j" /* ViewLinesDeletedEvent */](outputFromLineNumber, outputToLineNumber);
    };
    SplitLinesCollection.prototype.onModelLinesInserted = function (versionId, fromLineNumber, toLineNumber, text) {
        if (versionId <= this._validModelVersionId) {
            // Here we check for versionId in case the lines were reconstructed in the meantime.
            // We don't want to apply stale change events on top of a newer read model state.
            return null;
        }
        var hiddenAreas = this.getHiddenAreas();
        var isInHiddenArea = false;
        var testPosition = new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](fromLineNumber, 1);
        for (var i = 0; i < hiddenAreas.length; i++) {
            if (hiddenAreas[i].containsPosition(testPosition)) {
                isInHiddenArea = true;
                break;
            }
        }
        var outputFromLineNumber = (fromLineNumber === 1 ? 1 : this.prefixSumComputer.getAccumulatedValue(fromLineNumber - 2) + 1);
        var totalOutputLineCount = 0;
        var insertLines = [];
        var insertPrefixSumValues = new Uint32Array(text.length);
        for (var i = 0, len = text.length; i < len; i++) {
            var line = createSplitLine(this.linePositionMapperFactory, text[i], this.tabSize, this.wrappingColumn, this.columnsForFullWidthChar, this.wrappingIndent, !isInHiddenArea);
            insertLines.push(line);
            var outputLineCount = line.getViewLineCount();
            totalOutputLineCount += outputLineCount;
            insertPrefixSumValues[i] = outputLineCount;
        }
        // TODO@Alex: use arrays.arrayInsert
        this.lines = this.lines.slice(0, fromLineNumber - 1).concat(insertLines).concat(this.lines.slice(fromLineNumber - 1));
        this.prefixSumComputer.insertValues(fromLineNumber - 1, insertPrefixSumValues);
        return new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["k" /* ViewLinesInsertedEvent */](outputFromLineNumber, outputFromLineNumber + totalOutputLineCount - 1);
    };
    SplitLinesCollection.prototype.onModelLineChanged = function (versionId, lineNumber, newText) {
        if (versionId <= this._validModelVersionId) {
            // Here we check for versionId in case the lines were reconstructed in the meantime.
            // We don't want to apply stale change events on top of a newer read model state.
            return [false, null, null, null];
        }
        var lineIndex = lineNumber - 1;
        var oldOutputLineCount = this.lines[lineIndex].getViewLineCount();
        var isVisible = this.lines[lineIndex].isVisible();
        var line = createSplitLine(this.linePositionMapperFactory, newText, this.tabSize, this.wrappingColumn, this.columnsForFullWidthChar, this.wrappingIndent, isVisible);
        this.lines[lineIndex] = line;
        var newOutputLineCount = this.lines[lineIndex].getViewLineCount();
        var lineMappingChanged = false;
        var changeFrom = 0;
        var changeTo = -1;
        var insertFrom = 0;
        var insertTo = -1;
        var deleteFrom = 0;
        var deleteTo = -1;
        if (oldOutputLineCount > newOutputLineCount) {
            changeFrom = (lineNumber === 1 ? 1 : this.prefixSumComputer.getAccumulatedValue(lineNumber - 2) + 1);
            changeTo = changeFrom + newOutputLineCount - 1;
            deleteFrom = changeTo + 1;
            deleteTo = deleteFrom + (oldOutputLineCount - newOutputLineCount) - 1;
            lineMappingChanged = true;
        }
        else if (oldOutputLineCount < newOutputLineCount) {
            changeFrom = (lineNumber === 1 ? 1 : this.prefixSumComputer.getAccumulatedValue(lineNumber - 2) + 1);
            changeTo = changeFrom + oldOutputLineCount - 1;
            insertFrom = changeTo + 1;
            insertTo = insertFrom + (newOutputLineCount - oldOutputLineCount) - 1;
            lineMappingChanged = true;
        }
        else {
            changeFrom = (lineNumber === 1 ? 1 : this.prefixSumComputer.getAccumulatedValue(lineNumber - 2) + 1);
            changeTo = changeFrom + newOutputLineCount - 1;
        }
        this.prefixSumComputer.changeValue(lineIndex, newOutputLineCount);
        var viewLinesChangedEvent = (changeFrom <= changeTo ? new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["i" /* ViewLinesChangedEvent */](changeFrom, changeTo) : null);
        var viewLinesInsertedEvent = (insertFrom <= insertTo ? new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["k" /* ViewLinesInsertedEvent */](insertFrom, insertTo) : null);
        var viewLinesDeletedEvent = (deleteFrom <= deleteTo ? new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["j" /* ViewLinesDeletedEvent */](deleteFrom, deleteTo) : null);
        return [lineMappingChanged, viewLinesChangedEvent, viewLinesInsertedEvent, viewLinesDeletedEvent];
    };
    SplitLinesCollection.prototype.acceptVersionId = function (versionId) {
        this._validModelVersionId = versionId;
        if (this.lines.length === 1 && !this.lines[0].isVisible()) {
            // At least one line must be visible => reset hidden areas
            this.setHiddenAreas([]);
        }
    };
    SplitLinesCollection.prototype.getViewLineCount = function () {
        this._ensureValidState();
        return this.prefixSumComputer.getTotalValue();
    };
    SplitLinesCollection.prototype._toValidViewLineNumber = function (viewLineNumber) {
        if (viewLineNumber < 1) {
            return 1;
        }
        var viewLineCount = this.getViewLineCount();
        if (viewLineNumber > viewLineCount) {
            return viewLineCount;
        }
        return viewLineNumber;
    };
    /**
     * Gives a hint that a lot of requests are about to come in for these line numbers.
     */
    SplitLinesCollection.prototype.warmUpLookupCache = function (viewStartLineNumber, viewEndLineNumber) {
        this.prefixSumComputer.warmUpCache(viewStartLineNumber - 1, viewEndLineNumber - 1);
    };
    SplitLinesCollection.prototype.getActiveIndentGuide = function (viewLineNumber, minLineNumber, maxLineNumber) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        minLineNumber = this._toValidViewLineNumber(minLineNumber);
        maxLineNumber = this._toValidViewLineNumber(maxLineNumber);
        var modelPosition = this.convertViewPositionToModelPosition(viewLineNumber, this.getViewLineMinColumn(viewLineNumber));
        var modelMinPosition = this.convertViewPositionToModelPosition(minLineNumber, this.getViewLineMinColumn(minLineNumber));
        var modelMaxPosition = this.convertViewPositionToModelPosition(maxLineNumber, this.getViewLineMinColumn(maxLineNumber));
        var result = this.model.getActiveIndentGuide(modelPosition.lineNumber, modelMinPosition.lineNumber, modelMaxPosition.lineNumber);
        var viewStartPosition = this.convertModelPositionToViewPosition(result.startLineNumber, 1);
        var viewEndPosition = this.convertModelPositionToViewPosition(result.endLineNumber, 1);
        return {
            startLineNumber: viewStartPosition.lineNumber,
            endLineNumber: viewEndPosition.lineNumber,
            indent: result.indent
        };
    };
    SplitLinesCollection.prototype.getViewLinesIndentGuides = function (viewStartLineNumber, viewEndLineNumber) {
        this._ensureValidState();
        viewStartLineNumber = this._toValidViewLineNumber(viewStartLineNumber);
        viewEndLineNumber = this._toValidViewLineNumber(viewEndLineNumber);
        var modelStart = this.convertViewPositionToModelPosition(viewStartLineNumber, this.getViewLineMinColumn(viewStartLineNumber));
        var modelEnd = this.convertViewPositionToModelPosition(viewEndLineNumber, this.getViewLineMaxColumn(viewEndLineNumber));
        var result = [];
        var resultRepeatCount = [];
        var resultRepeatOption = [];
        var modelStartLineIndex = modelStart.lineNumber - 1;
        var modelEndLineIndex = modelEnd.lineNumber - 1;
        var reqStart = null;
        for (var modelLineIndex = modelStartLineIndex; modelLineIndex <= modelEndLineIndex; modelLineIndex++) {
            var line = this.lines[modelLineIndex];
            if (line.isVisible()) {
                var viewLineStartIndex = line.getViewLineNumberOfModelPosition(0, modelLineIndex === modelStartLineIndex ? modelStart.column : 1);
                var viewLineEndIndex = line.getViewLineNumberOfModelPosition(0, this.model.getLineMaxColumn(modelLineIndex + 1));
                var count = viewLineEndIndex - viewLineStartIndex + 1;
                var option = 0 /* BlockNone */;
                if (count > 1 && line.getViewLineMinColumn(this.model, modelLineIndex + 1, viewLineEndIndex) === 1) {
                    // wrapped lines should block indent guides
                    option = (viewLineStartIndex === 0 ? 1 /* BlockSubsequent */ : 2 /* BlockAll */);
                }
                resultRepeatCount.push(count);
                resultRepeatOption.push(option);
                // merge into previous request
                if (reqStart === null) {
                    reqStart = new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](modelLineIndex + 1, 0);
                }
            }
            else {
                // hit invisible line => flush request
                if (reqStart !== null) {
                    result = result.concat(this.model.getLinesIndentGuides(reqStart.lineNumber, modelLineIndex));
                    reqStart = null;
                }
            }
        }
        if (reqStart !== null) {
            result = result.concat(this.model.getLinesIndentGuides(reqStart.lineNumber, modelEnd.lineNumber));
            reqStart = null;
        }
        var viewLineCount = viewEndLineNumber - viewStartLineNumber + 1;
        var viewIndents = new Array(viewLineCount);
        var currIndex = 0;
        for (var i = 0, len = result.length; i < len; i++) {
            var value = result[i];
            var count = Math.min(viewLineCount - currIndex, resultRepeatCount[i]);
            var option = resultRepeatOption[i];
            var blockAtIndex = void 0;
            if (option === 2 /* BlockAll */) {
                blockAtIndex = 0;
            }
            else if (option === 1 /* BlockSubsequent */) {
                blockAtIndex = 1;
            }
            else {
                blockAtIndex = count;
            }
            for (var j = 0; j < count; j++) {
                if (j === blockAtIndex) {
                    value = 0;
                }
                viewIndents[currIndex++] = value;
            }
        }
        return viewIndents;
    };
    SplitLinesCollection.prototype.getViewLineContent = function (viewLineNumber) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        var r = this.prefixSumComputer.getIndexOf(viewLineNumber - 1);
        var lineIndex = r.index;
        var remainder = r.remainder;
        return this.lines[lineIndex].getViewLineContent(this.model, lineIndex + 1, remainder);
    };
    SplitLinesCollection.prototype.getViewLineLength = function (viewLineNumber) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        var r = this.prefixSumComputer.getIndexOf(viewLineNumber - 1);
        var lineIndex = r.index;
        var remainder = r.remainder;
        return this.lines[lineIndex].getViewLineLength(this.model, lineIndex + 1, remainder);
    };
    SplitLinesCollection.prototype.getViewLineMinColumn = function (viewLineNumber) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        var r = this.prefixSumComputer.getIndexOf(viewLineNumber - 1);
        var lineIndex = r.index;
        var remainder = r.remainder;
        return this.lines[lineIndex].getViewLineMinColumn(this.model, lineIndex + 1, remainder);
    };
    SplitLinesCollection.prototype.getViewLineMaxColumn = function (viewLineNumber) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        var r = this.prefixSumComputer.getIndexOf(viewLineNumber - 1);
        var lineIndex = r.index;
        var remainder = r.remainder;
        return this.lines[lineIndex].getViewLineMaxColumn(this.model, lineIndex + 1, remainder);
    };
    SplitLinesCollection.prototype.getViewLineData = function (viewLineNumber) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        var r = this.prefixSumComputer.getIndexOf(viewLineNumber - 1);
        var lineIndex = r.index;
        var remainder = r.remainder;
        return this.lines[lineIndex].getViewLineData(this.model, lineIndex + 1, remainder);
    };
    SplitLinesCollection.prototype.getViewLinesData = function (viewStartLineNumber, viewEndLineNumber, needed) {
        this._ensureValidState();
        viewStartLineNumber = this._toValidViewLineNumber(viewStartLineNumber);
        viewEndLineNumber = this._toValidViewLineNumber(viewEndLineNumber);
        var start = this.prefixSumComputer.getIndexOf(viewStartLineNumber - 1);
        var viewLineNumber = viewStartLineNumber;
        var startModelLineIndex = start.index;
        var startRemainder = start.remainder;
        var result = [];
        for (var modelLineIndex = startModelLineIndex, len = this.model.getLineCount(); modelLineIndex < len; modelLineIndex++) {
            var line = this.lines[modelLineIndex];
            if (!line.isVisible()) {
                continue;
            }
            var fromViewLineIndex = (modelLineIndex === startModelLineIndex ? startRemainder : 0);
            var remainingViewLineCount = line.getViewLineCount() - fromViewLineIndex;
            var lastLine = false;
            if (viewLineNumber + remainingViewLineCount > viewEndLineNumber) {
                lastLine = true;
                remainingViewLineCount = viewEndLineNumber - viewLineNumber + 1;
            }
            var toViewLineIndex = fromViewLineIndex + remainingViewLineCount;
            line.getViewLinesData(this.model, modelLineIndex + 1, fromViewLineIndex, toViewLineIndex, viewLineNumber - viewStartLineNumber, needed, result);
            viewLineNumber += remainingViewLineCount;
            if (lastLine) {
                break;
            }
        }
        return result;
    };
    SplitLinesCollection.prototype.validateViewPosition = function (viewLineNumber, viewColumn, expectedModelPosition) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        var r = this.prefixSumComputer.getIndexOf(viewLineNumber - 1);
        var lineIndex = r.index;
        var remainder = r.remainder;
        var line = this.lines[lineIndex];
        var minColumn = line.getViewLineMinColumn(this.model, lineIndex + 1, remainder);
        var maxColumn = line.getViewLineMaxColumn(this.model, lineIndex + 1, remainder);
        if (viewColumn < minColumn) {
            viewColumn = minColumn;
        }
        if (viewColumn > maxColumn) {
            viewColumn = maxColumn;
        }
        var computedModelColumn = line.getModelColumnOfViewPosition(remainder, viewColumn);
        var computedModelPosition = this.model.validatePosition(new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineIndex + 1, computedModelColumn));
        if (computedModelPosition.equals(expectedModelPosition)) {
            return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](viewLineNumber, viewColumn);
        }
        return this.convertModelPositionToViewPosition(expectedModelPosition.lineNumber, expectedModelPosition.column);
    };
    SplitLinesCollection.prototype.convertViewPositionToModelPosition = function (viewLineNumber, viewColumn) {
        this._ensureValidState();
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        var r = this.prefixSumComputer.getIndexOf(viewLineNumber - 1);
        var lineIndex = r.index;
        var remainder = r.remainder;
        var inputColumn = this.lines[lineIndex].getModelColumnOfViewPosition(remainder, viewColumn);
        // console.log('out -> in ' + viewLineNumber + ',' + viewColumn + ' ===> ' + (lineIndex+1) + ',' + inputColumn);
        return this.model.validatePosition(new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineIndex + 1, inputColumn));
    };
    SplitLinesCollection.prototype.convertModelPositionToViewPosition = function (_modelLineNumber, _modelColumn) {
        this._ensureValidState();
        var validPosition = this.model.validatePosition(new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](_modelLineNumber, _modelColumn));
        var inputLineNumber = validPosition.lineNumber;
        var inputColumn = validPosition.column;
        var lineIndex = inputLineNumber - 1, lineIndexChanged = false;
        while (lineIndex > 0 && !this.lines[lineIndex].isVisible()) {
            lineIndex--;
            lineIndexChanged = true;
        }
        if (lineIndex === 0 && !this.lines[lineIndex].isVisible()) {
            // Could not reach a real line
            // console.log('in -> out ' + inputLineNumber + ',' + inputColumn + ' ===> ' + 1 + ',' + 1);
            return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](1, 1);
        }
        var deltaLineNumber = 1 + (lineIndex === 0 ? 0 : this.prefixSumComputer.getAccumulatedValue(lineIndex - 1));
        var r;
        if (lineIndexChanged) {
            r = this.lines[lineIndex].getViewPositionOfModelPosition(deltaLineNumber, this.model.getLineMaxColumn(lineIndex + 1));
        }
        else {
            r = this.lines[inputLineNumber - 1].getViewPositionOfModelPosition(deltaLineNumber, inputColumn);
        }
        // console.log('in -> out ' + inputLineNumber + ',' + inputColumn + ' ===> ' + r.lineNumber + ',' + r);
        return r;
    };
    SplitLinesCollection.prototype._getViewLineNumberForModelPosition = function (inputLineNumber, inputColumn) {
        var lineIndex = inputLineNumber - 1;
        if (this.lines[lineIndex].isVisible()) {
            // this model line is visible
            var deltaLineNumber_1 = 1 + (lineIndex === 0 ? 0 : this.prefixSumComputer.getAccumulatedValue(lineIndex - 1));
            return this.lines[lineIndex].getViewLineNumberOfModelPosition(deltaLineNumber_1, inputColumn);
        }
        // this model line is not visible
        while (lineIndex > 0 && !this.lines[lineIndex].isVisible()) {
            lineIndex--;
        }
        if (lineIndex === 0 && !this.lines[lineIndex].isVisible()) {
            // Could not reach a real line
            return 1;
        }
        var deltaLineNumber = 1 + (lineIndex === 0 ? 0 : this.prefixSumComputer.getAccumulatedValue(lineIndex - 1));
        return this.lines[lineIndex].getViewLineNumberOfModelPosition(deltaLineNumber, this.model.getLineMaxColumn(lineIndex + 1));
    };
    SplitLinesCollection.prototype.getAllOverviewRulerDecorations = function (ownerId, filterOutValidation, theme) {
        var decorations = this.model.getOverviewRulerDecorations(ownerId, filterOutValidation);
        var result = new OverviewRulerDecorations();
        for (var i = 0, len = decorations.length; i < len; i++) {
            var decoration = decorations[i];
            var opts = decoration.options.overviewRuler;
            var lane = opts.position;
            if (lane === 0) {
                continue;
            }
            var color = resolveColor(opts, theme);
            var viewStartLineNumber = this._getViewLineNumberForModelPosition(decoration.range.startLineNumber, decoration.range.startColumn);
            var viewEndLineNumber = this._getViewLineNumberForModelPosition(decoration.range.endLineNumber, decoration.range.endColumn);
            result.accept(color, viewStartLineNumber, viewEndLineNumber, lane);
        }
        return result.result;
    };
    SplitLinesCollection.prototype.getDecorationsInRange = function (range, ownerId, filterOutValidation) {
        var modelStart = this.convertViewPositionToModelPosition(range.startLineNumber, range.startColumn);
        var modelEnd = this.convertViewPositionToModelPosition(range.endLineNumber, range.endColumn);
        if (modelEnd.lineNumber - modelStart.lineNumber <= range.endLineNumber - range.startLineNumber) {
            // most likely there are no hidden lines => fast path
            return this.model.getDecorationsInRange(new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](modelStart.lineNumber, modelStart.column, modelEnd.lineNumber, modelEnd.column), ownerId, filterOutValidation);
        }
        var result = [];
        var modelStartLineIndex = modelStart.lineNumber - 1;
        var modelEndLineIndex = modelEnd.lineNumber - 1;
        var reqStart = null;
        for (var modelLineIndex = modelStartLineIndex; modelLineIndex <= modelEndLineIndex; modelLineIndex++) {
            var line = this.lines[modelLineIndex];
            if (line.isVisible()) {
                // merge into previous request
                if (reqStart === null) {
                    reqStart = new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](modelLineIndex + 1, modelLineIndex === modelStartLineIndex ? modelStart.column : 1);
                }
            }
            else {
                // hit invisible line => flush request
                if (reqStart !== null) {
                    var maxLineColumn = this.model.getLineMaxColumn(modelLineIndex);
                    result = result.concat(this.model.getDecorationsInRange(new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](reqStart.lineNumber, reqStart.column, modelLineIndex, maxLineColumn), ownerId, filterOutValidation));
                    reqStart = null;
                }
            }
        }
        if (reqStart !== null) {
            result = result.concat(this.model.getDecorationsInRange(new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](reqStart.lineNumber, reqStart.column, modelEnd.lineNumber, modelEnd.column), ownerId, filterOutValidation));
            reqStart = null;
        }
        return result;
    };
    return SplitLinesCollection;
}());

var VisibleIdentitySplitLine = /** @class */ (function () {
    function VisibleIdentitySplitLine() {
    }
    VisibleIdentitySplitLine.prototype.isVisible = function () {
        return true;
    };
    VisibleIdentitySplitLine.prototype.setVisible = function (isVisible) {
        if (isVisible) {
            return this;
        }
        return InvisibleIdentitySplitLine.INSTANCE;
    };
    VisibleIdentitySplitLine.prototype.getViewLineCount = function () {
        return 1;
    };
    VisibleIdentitySplitLine.prototype.getViewLineContent = function (model, modelLineNumber, outputLineIndex) {
        return model.getLineContent(modelLineNumber);
    };
    VisibleIdentitySplitLine.prototype.getViewLineLength = function (model, modelLineNumber, outputLineIndex) {
        return model.getLineLength(modelLineNumber);
    };
    VisibleIdentitySplitLine.prototype.getViewLineMinColumn = function (model, modelLineNumber, outputLineIndex) {
        return model.getLineMinColumn(modelLineNumber);
    };
    VisibleIdentitySplitLine.prototype.getViewLineMaxColumn = function (model, modelLineNumber, outputLineIndex) {
        return model.getLineMaxColumn(modelLineNumber);
    };
    VisibleIdentitySplitLine.prototype.getViewLineData = function (model, modelLineNumber, outputLineIndex) {
        var lineTokens = model.getLineTokens(modelLineNumber);
        var lineContent = lineTokens.getLineContent();
        return new __WEBPACK_IMPORTED_MODULE_3__viewModel_js__["c" /* ViewLineData */](lineContent, false, 1, lineContent.length + 1, lineTokens.inflate());
    };
    VisibleIdentitySplitLine.prototype.getViewLinesData = function (model, modelLineNumber, fromOuputLineIndex, toOutputLineIndex, globalStartIndex, needed, result) {
        if (!needed[globalStartIndex]) {
            result[globalStartIndex] = null;
            return;
        }
        result[globalStartIndex] = this.getViewLineData(model, modelLineNumber, 0);
    };
    VisibleIdentitySplitLine.prototype.getModelColumnOfViewPosition = function (outputLineIndex, outputColumn) {
        return outputColumn;
    };
    VisibleIdentitySplitLine.prototype.getViewPositionOfModelPosition = function (deltaLineNumber, inputColumn) {
        return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](deltaLineNumber, inputColumn);
    };
    VisibleIdentitySplitLine.prototype.getViewLineNumberOfModelPosition = function (deltaLineNumber, inputColumn) {
        return deltaLineNumber;
    };
    VisibleIdentitySplitLine.INSTANCE = new VisibleIdentitySplitLine();
    return VisibleIdentitySplitLine;
}());
var InvisibleIdentitySplitLine = /** @class */ (function () {
    function InvisibleIdentitySplitLine() {
    }
    InvisibleIdentitySplitLine.prototype.isVisible = function () {
        return false;
    };
    InvisibleIdentitySplitLine.prototype.setVisible = function (isVisible) {
        if (!isVisible) {
            return this;
        }
        return VisibleIdentitySplitLine.INSTANCE;
    };
    InvisibleIdentitySplitLine.prototype.getViewLineCount = function () {
        return 0;
    };
    InvisibleIdentitySplitLine.prototype.getViewLineContent = function (model, modelLineNumber, outputLineIndex) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getViewLineLength = function (model, modelLineNumber, outputLineIndex) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getViewLineMinColumn = function (model, modelLineNumber, outputLineIndex) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getViewLineMaxColumn = function (model, modelLineNumber, outputLineIndex) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getViewLineData = function (model, modelLineNumber, outputLineIndex) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getViewLinesData = function (model, modelLineNumber, fromOuputLineIndex, toOutputLineIndex, globalStartIndex, needed, result) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getModelColumnOfViewPosition = function (outputLineIndex, outputColumn) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getViewPositionOfModelPosition = function (deltaLineNumber, inputColumn) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.prototype.getViewLineNumberOfModelPosition = function (deltaLineNumber, inputColumn) {
        throw new Error('Not supported');
    };
    InvisibleIdentitySplitLine.INSTANCE = new InvisibleIdentitySplitLine();
    return InvisibleIdentitySplitLine;
}());
var SplitLine = /** @class */ (function () {
    function SplitLine(positionMapper, isVisible) {
        this.positionMapper = positionMapper;
        this.wrappedIndent = this.positionMapper.getWrappedLinesIndent();
        this.wrappedIndentLength = this.wrappedIndent.length;
        this.outputLineCount = this.positionMapper.getOutputLineCount();
        this._isVisible = isVisible;
    }
    SplitLine.prototype.isVisible = function () {
        return this._isVisible;
    };
    SplitLine.prototype.setVisible = function (isVisible) {
        this._isVisible = isVisible;
        return this;
    };
    SplitLine.prototype.getViewLineCount = function () {
        if (!this._isVisible) {
            return 0;
        }
        return this.outputLineCount;
    };
    SplitLine.prototype.getInputStartOffsetOfOutputLineIndex = function (outputLineIndex) {
        return this.positionMapper.getInputOffsetOfOutputPosition(outputLineIndex, 0);
    };
    SplitLine.prototype.getInputEndOffsetOfOutputLineIndex = function (model, modelLineNumber, outputLineIndex) {
        if (outputLineIndex + 1 === this.outputLineCount) {
            return model.getLineMaxColumn(modelLineNumber) - 1;
        }
        return this.positionMapper.getInputOffsetOfOutputPosition(outputLineIndex + 1, 0);
    };
    SplitLine.prototype.getViewLineContent = function (model, modelLineNumber, outputLineIndex) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        var startOffset = this.getInputStartOffsetOfOutputLineIndex(outputLineIndex);
        var endOffset = this.getInputEndOffsetOfOutputLineIndex(model, modelLineNumber, outputLineIndex);
        var r = model.getValueInRange({
            startLineNumber: modelLineNumber,
            startColumn: startOffset + 1,
            endLineNumber: modelLineNumber,
            endColumn: endOffset + 1
        });
        if (outputLineIndex > 0) {
            r = this.wrappedIndent + r;
        }
        return r;
    };
    SplitLine.prototype.getViewLineLength = function (model, modelLineNumber, outputLineIndex) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        var startOffset = this.getInputStartOffsetOfOutputLineIndex(outputLineIndex);
        var endOffset = this.getInputEndOffsetOfOutputLineIndex(model, modelLineNumber, outputLineIndex);
        var r = endOffset - startOffset;
        if (outputLineIndex > 0) {
            r = this.wrappedIndent.length + r;
        }
        return r;
    };
    SplitLine.prototype.getViewLineMinColumn = function (model, modelLineNumber, outputLineIndex) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        if (outputLineIndex > 0) {
            return this.wrappedIndentLength + 1;
        }
        return 1;
    };
    SplitLine.prototype.getViewLineMaxColumn = function (model, modelLineNumber, outputLineIndex) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        return this.getViewLineContent(model, modelLineNumber, outputLineIndex).length + 1;
    };
    SplitLine.prototype.getViewLineData = function (model, modelLineNumber, outputLineIndex) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        var startOffset = this.getInputStartOffsetOfOutputLineIndex(outputLineIndex);
        var endOffset = this.getInputEndOffsetOfOutputLineIndex(model, modelLineNumber, outputLineIndex);
        var lineContent = model.getValueInRange({
            startLineNumber: modelLineNumber,
            startColumn: startOffset + 1,
            endLineNumber: modelLineNumber,
            endColumn: endOffset + 1
        });
        if (outputLineIndex > 0) {
            lineContent = this.wrappedIndent + lineContent;
        }
        var minColumn = (outputLineIndex > 0 ? this.wrappedIndentLength + 1 : 1);
        var maxColumn = lineContent.length + 1;
        var continuesWithWrappedLine = (outputLineIndex + 1 < this.getViewLineCount());
        var deltaStartIndex = 0;
        if (outputLineIndex > 0) {
            deltaStartIndex = this.wrappedIndentLength;
        }
        var lineTokens = model.getLineTokens(modelLineNumber);
        return new __WEBPACK_IMPORTED_MODULE_3__viewModel_js__["c" /* ViewLineData */](lineContent, continuesWithWrappedLine, minColumn, maxColumn, lineTokens.sliceAndInflate(startOffset, endOffset, deltaStartIndex));
    };
    SplitLine.prototype.getViewLinesData = function (model, modelLineNumber, fromOuputLineIndex, toOutputLineIndex, globalStartIndex, needed, result) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        for (var outputLineIndex = fromOuputLineIndex; outputLineIndex < toOutputLineIndex; outputLineIndex++) {
            var globalIndex = globalStartIndex + outputLineIndex - fromOuputLineIndex;
            if (!needed[globalIndex]) {
                result[globalIndex] = null;
                continue;
            }
            result[globalIndex] = this.getViewLineData(model, modelLineNumber, outputLineIndex);
        }
    };
    SplitLine.prototype.getModelColumnOfViewPosition = function (outputLineIndex, outputColumn) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        var adjustedColumn = outputColumn - 1;
        if (outputLineIndex > 0) {
            if (adjustedColumn < this.wrappedIndentLength) {
                adjustedColumn = 0;
            }
            else {
                adjustedColumn -= this.wrappedIndentLength;
            }
        }
        return this.positionMapper.getInputOffsetOfOutputPosition(outputLineIndex, adjustedColumn) + 1;
    };
    SplitLine.prototype.getViewPositionOfModelPosition = function (deltaLineNumber, inputColumn) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        var r = this.positionMapper.getOutputPositionOfInputOffset(inputColumn - 1);
        var outputLineIndex = r.outputLineIndex;
        var outputColumn = r.outputOffset + 1;
        if (outputLineIndex > 0) {
            outputColumn += this.wrappedIndentLength;
        }
        //		console.log('in -> out ' + deltaLineNumber + ',' + inputColumn + ' ===> ' + (deltaLineNumber+outputLineIndex) + ',' + outputColumn);
        return new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](deltaLineNumber + outputLineIndex, outputColumn);
    };
    SplitLine.prototype.getViewLineNumberOfModelPosition = function (deltaLineNumber, inputColumn) {
        if (!this._isVisible) {
            throw new Error('Not supported');
        }
        var r = this.positionMapper.getOutputPositionOfInputOffset(inputColumn - 1);
        return (deltaLineNumber + r.outputLineIndex);
    };
    return SplitLine;
}());

function createSplitLine(linePositionMapperFactory, text, tabSize, wrappingColumn, columnsForFullWidthChar, wrappingIndent, isVisible) {
    var positionMapper = linePositionMapperFactory.createLineMapping(text, tabSize, wrappingColumn, columnsForFullWidthChar, wrappingIndent);
    if (positionMapper === null) {
        // No mapping needed
        if (isVisible) {
            return VisibleIdentitySplitLine.INSTANCE;
        }
        return InvisibleIdentitySplitLine.INSTANCE;
    }
    else {
        return new SplitLine(positionMapper, isVisible);
    }
}
var IdentityCoordinatesConverter = /** @class */ (function () {
    function IdentityCoordinatesConverter(lines) {
        this._lines = lines;
    }
    IdentityCoordinatesConverter.prototype._validPosition = function (pos) {
        return this._lines.model.validatePosition(pos);
    };
    IdentityCoordinatesConverter.prototype._validRange = function (range) {
        return this._lines.model.validateRange(range);
    };
    // View -> Model conversion and related methods
    IdentityCoordinatesConverter.prototype.convertViewPositionToModelPosition = function (viewPosition) {
        return this._validPosition(viewPosition);
    };
    IdentityCoordinatesConverter.prototype.convertViewRangeToModelRange = function (viewRange) {
        return this._validRange(viewRange);
    };
    IdentityCoordinatesConverter.prototype.validateViewPosition = function (viewPosition, expectedModelPosition) {
        return this._validPosition(expectedModelPosition);
    };
    IdentityCoordinatesConverter.prototype.validateViewRange = function (viewRange, expectedModelRange) {
        return this._validRange(expectedModelRange);
    };
    // Model -> View conversion and related methods
    IdentityCoordinatesConverter.prototype.convertModelPositionToViewPosition = function (modelPosition) {
        return this._validPosition(modelPosition);
    };
    IdentityCoordinatesConverter.prototype.convertModelRangeToViewRange = function (modelRange) {
        return this._validRange(modelRange);
    };
    IdentityCoordinatesConverter.prototype.modelPositionIsVisible = function (modelPosition) {
        var lineCount = this._lines.model.getLineCount();
        if (modelPosition.lineNumber < 1 || modelPosition.lineNumber > lineCount) {
            // invalid arguments
            return false;
        }
        return true;
    };
    return IdentityCoordinatesConverter;
}());

var IdentityLinesCollection = /** @class */ (function () {
    function IdentityLinesCollection(model) {
        this.model = model;
    }
    IdentityLinesCollection.prototype.dispose = function () {
    };
    IdentityLinesCollection.prototype.createCoordinatesConverter = function () {
        return new IdentityCoordinatesConverter(this);
    };
    IdentityLinesCollection.prototype.getHiddenAreas = function () {
        return [];
    };
    IdentityLinesCollection.prototype.setHiddenAreas = function (_ranges) {
        return false;
    };
    IdentityLinesCollection.prototype.setTabSize = function (newTabSize) {
        return false;
    };
    IdentityLinesCollection.prototype.setWrappingSettings = function (wrappingIndent, wrappingColumn, columnsForFullWidthChar) {
        return false;
    };
    IdentityLinesCollection.prototype.onModelFlushed = function () {
    };
    IdentityLinesCollection.prototype.onModelLinesDeleted = function (versionId, fromLineNumber, toLineNumber) {
        return new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["j" /* ViewLinesDeletedEvent */](fromLineNumber, toLineNumber);
    };
    IdentityLinesCollection.prototype.onModelLinesInserted = function (versionId, fromLineNumber, toLineNumber, text) {
        return new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["k" /* ViewLinesInsertedEvent */](fromLineNumber, toLineNumber);
    };
    IdentityLinesCollection.prototype.onModelLineChanged = function (versionId, lineNumber, newText) {
        return [false, new __WEBPACK_IMPORTED_MODULE_4__view_viewEvents_js__["i" /* ViewLinesChangedEvent */](lineNumber, lineNumber), null, null];
    };
    IdentityLinesCollection.prototype.acceptVersionId = function (versionId) {
    };
    IdentityLinesCollection.prototype.getViewLineCount = function () {
        return this.model.getLineCount();
    };
    IdentityLinesCollection.prototype.warmUpLookupCache = function (viewStartLineNumber, viewEndLineNumber) {
    };
    IdentityLinesCollection.prototype.getActiveIndentGuide = function (viewLineNumber, minLineNumber, maxLineNumber) {
        return {
            startLineNumber: viewLineNumber,
            endLineNumber: viewLineNumber,
            indent: 0
        };
    };
    IdentityLinesCollection.prototype.getViewLinesIndentGuides = function (viewStartLineNumber, viewEndLineNumber) {
        var viewLineCount = viewEndLineNumber - viewStartLineNumber + 1;
        var result = new Array(viewLineCount);
        for (var i = 0; i < viewLineCount; i++) {
            result[i] = 0;
        }
        return result;
    };
    IdentityLinesCollection.prototype.getViewLineContent = function (viewLineNumber) {
        return this.model.getLineContent(viewLineNumber);
    };
    IdentityLinesCollection.prototype.getViewLineLength = function (viewLineNumber) {
        return this.model.getLineLength(viewLineNumber);
    };
    IdentityLinesCollection.prototype.getViewLineMinColumn = function (viewLineNumber) {
        return this.model.getLineMinColumn(viewLineNumber);
    };
    IdentityLinesCollection.prototype.getViewLineMaxColumn = function (viewLineNumber) {
        return this.model.getLineMaxColumn(viewLineNumber);
    };
    IdentityLinesCollection.prototype.getViewLineData = function (viewLineNumber) {
        var lineTokens = this.model.getLineTokens(viewLineNumber);
        var lineContent = lineTokens.getLineContent();
        return new __WEBPACK_IMPORTED_MODULE_3__viewModel_js__["c" /* ViewLineData */](lineContent, false, 1, lineContent.length + 1, lineTokens.inflate());
    };
    IdentityLinesCollection.prototype.getViewLinesData = function (viewStartLineNumber, viewEndLineNumber, needed) {
        var lineCount = this.model.getLineCount();
        viewStartLineNumber = Math.min(Math.max(1, viewStartLineNumber), lineCount);
        viewEndLineNumber = Math.min(Math.max(1, viewEndLineNumber), lineCount);
        var result = [];
        for (var lineNumber = viewStartLineNumber; lineNumber <= viewEndLineNumber; lineNumber++) {
            var idx = lineNumber - viewStartLineNumber;
            if (!needed[idx]) {
                result[idx] = null;
            }
            result[idx] = this.getViewLineData(lineNumber);
        }
        return result;
    };
    IdentityLinesCollection.prototype.getAllOverviewRulerDecorations = function (ownerId, filterOutValidation, theme) {
        var decorations = this.model.getOverviewRulerDecorations(ownerId, filterOutValidation);
        var result = new OverviewRulerDecorations();
        for (var i = 0, len = decorations.length; i < len; i++) {
            var decoration = decorations[i];
            var opts = decoration.options.overviewRuler;
            var lane = opts.position;
            if (lane === 0) {
                continue;
            }
            var color = resolveColor(opts, theme);
            var viewStartLineNumber = decoration.range.startLineNumber;
            var viewEndLineNumber = decoration.range.endLineNumber;
            result.accept(color, viewStartLineNumber, viewEndLineNumber, lane);
        }
        return result.result;
    };
    IdentityLinesCollection.prototype.getDecorationsInRange = function (range, ownerId, filterOutValidation) {
        return this.model.getDecorationsInRange(range, ownerId, filterOutValidation);
    };
    return IdentityLinesCollection;
}());

var OverviewRulerDecorations = /** @class */ (function () {
    function OverviewRulerDecorations() {
        this.result = Object.create(null);
    }
    OverviewRulerDecorations.prototype.accept = function (color, startLineNumber, endLineNumber, lane) {
        var prev = this.result[color];
        if (prev) {
            var prevLane = prev[prev.length - 3];
            var prevEndLineNumber = prev[prev.length - 1];
            if (prevLane === lane && prevEndLineNumber + 1 >= startLineNumber) {
                // merge into prev
                if (endLineNumber > prevEndLineNumber) {
                    prev[prev.length - 1] = endLineNumber;
                }
                return;
            }
            // push
            prev.push(lane, startLineNumber, endLineNumber);
        }
        else {
            this.result[color] = [lane, startLineNumber, endLineNumber];
        }
    };
    return OverviewRulerDecorations;
}());
function resolveColor(opts, theme) {
    if (!opts._resolvedColor) {
        var themeType = theme.type;
        var color = (themeType === 'dark' ? opts.darkColor : themeType === 'light' ? opts.color : opts.hcColor);
        opts._resolvedColor = resolveRulerColor(color, theme);
    }
    return opts._resolvedColor;
}
function resolveRulerColor(color, theme) {
    if (typeof color === 'string') {
        return color;
    }
    var c = color ? theme.getColor(color.id) : null;
    if (!c) {
        c = __WEBPACK_IMPORTED_MODULE_6__base_common_color_js__["a" /* Color */].transparent;
    }
    return c.toString();
}


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Margin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_viewPart_js__ = __webpack_require__(33);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Margin = /** @class */ (function (_super) {
    __extends(Margin, _super);
    function Margin(context) {
        var _this = _super.call(this, context) || this;
        _this._canUseLayerHinting = _this._context.configuration.editor.canUseLayerHinting;
        _this._contentLeft = _this._context.configuration.editor.layoutInfo.contentLeft;
        _this._glyphMarginLeft = _this._context.configuration.editor.layoutInfo.glyphMarginLeft;
        _this._glyphMarginWidth = _this._context.configuration.editor.layoutInfo.glyphMarginWidth;
        _this._domNode = _this._createDomNode();
        return _this;
    }
    Margin.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    Margin.prototype.getDomNode = function () {
        return this._domNode;
    };
    Margin.prototype._createDomNode = function () {
        var domNode = Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        domNode.setClassName(Margin.OUTER_CLASS_NAME);
        domNode.setPosition('absolute');
        domNode.setAttribute('role', 'presentation');
        domNode.setAttribute('aria-hidden', 'true');
        this._glyphMarginBackgroundDomNode = Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        this._glyphMarginBackgroundDomNode.setClassName(Margin.CLASS_NAME);
        domNode.appendChild(this._glyphMarginBackgroundDomNode);
        return domNode;
    };
    // --- begin event handlers
    Margin.prototype.onConfigurationChanged = function (e) {
        if (e.canUseLayerHinting) {
            this._canUseLayerHinting = this._context.configuration.editor.canUseLayerHinting;
        }
        if (e.layoutInfo) {
            this._contentLeft = this._context.configuration.editor.layoutInfo.contentLeft;
            this._glyphMarginLeft = this._context.configuration.editor.layoutInfo.glyphMarginLeft;
            this._glyphMarginWidth = this._context.configuration.editor.layoutInfo.glyphMarginWidth;
        }
        return true;
    };
    Margin.prototype.onScrollChanged = function (e) {
        return _super.prototype.onScrollChanged.call(this, e) || e.scrollTopChanged;
    };
    // --- end event handlers
    Margin.prototype.prepareRender = function (ctx) {
        // Nothing to read
    };
    Margin.prototype.render = function (ctx) {
        this._domNode.setLayerHinting(this._canUseLayerHinting);
        var adjustedScrollTop = ctx.scrollTop - ctx.bigNumbersDelta;
        this._domNode.setTop(-adjustedScrollTop);
        var height = Math.min(ctx.scrollHeight, 1000000);
        this._domNode.setHeight(height);
        this._domNode.setWidth(this._contentLeft);
        this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft);
        this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth);
        this._glyphMarginBackgroundDomNode.setHeight(height);
    };
    Margin.CLASS_NAME = 'glyph-margin';
    Margin.OUTER_CLASS_NAME = 'margin';
    return Margin;
}(__WEBPACK_IMPORTED_MODULE_1__view_viewPart_js__["b" /* ViewPart */]));



/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineNumbersOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lineNumbers_css__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lineNumbers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lineNumbers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_dynamicViewOverlay_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var LineNumbersOverlay = /** @class */ (function (_super) {
    __extends(LineNumbersOverlay, _super);
    function LineNumbersOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._readConfig();
        _this._lastCursorModelPosition = new __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__["a" /* Position */](1, 1);
        _this._renderResult = null;
        _this._context.addEventHandler(_this);
        return _this;
    }
    LineNumbersOverlay.prototype._readConfig = function () {
        var config = this._context.configuration.editor;
        this._lineHeight = config.lineHeight;
        this._renderLineNumbers = config.viewInfo.renderLineNumbers;
        this._renderCustomLineNumbers = config.viewInfo.renderCustomLineNumbers;
        this._lineNumbersLeft = config.layoutInfo.lineNumbersLeft;
        this._lineNumbersWidth = config.layoutInfo.lineNumbersWidth;
    };
    LineNumbersOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        this._renderResult = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    LineNumbersOverlay.prototype.onConfigurationChanged = function (e) {
        this._readConfig();
        return true;
    };
    LineNumbersOverlay.prototype.onCursorStateChanged = function (e) {
        var primaryViewPosition = e.selections[0].getPosition();
        this._lastCursorModelPosition = this._context.model.coordinatesConverter.convertViewPositionToModelPosition(primaryViewPosition);
        if (this._renderLineNumbers === 2 /* Relative */ || this._renderLineNumbers === 3 /* Interval */) {
            return true;
        }
        return false;
    };
    LineNumbersOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    LineNumbersOverlay.prototype.onLinesChanged = function (e) {
        return true;
    };
    LineNumbersOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    LineNumbersOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    LineNumbersOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged;
    };
    LineNumbersOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    LineNumbersOverlay.prototype._getLineRenderLineNumber = function (viewLineNumber) {
        var modelPosition = this._context.model.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__["a" /* Position */](viewLineNumber, 1));
        if (modelPosition.column !== 1) {
            return '';
        }
        var modelLineNumber = modelPosition.lineNumber;
        if (this._renderCustomLineNumbers) {
            return this._renderCustomLineNumbers(modelLineNumber);
        }
        if (this._renderLineNumbers === 2 /* Relative */) {
            var diff = Math.abs(this._lastCursorModelPosition.lineNumber - modelLineNumber);
            if (diff === 0) {
                return '<span class="relative-current-line-number">' + modelLineNumber + '</span>';
            }
            return String(diff);
        }
        if (this._renderLineNumbers === 3 /* Interval */) {
            if (this._lastCursorModelPosition.lineNumber === modelLineNumber) {
                return String(modelLineNumber);
            }
            if (modelLineNumber % 10 === 0) {
                return String(modelLineNumber);
            }
            return '';
        }
        return String(modelLineNumber);
    };
    LineNumbersOverlay.prototype.prepareRender = function (ctx) {
        if (this._renderLineNumbers === 0 /* Off */) {
            this._renderResult = null;
            return;
        }
        var lineHeightClassName = (__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["c" /* isLinux */] ? (this._lineHeight % 2 === 0 ? ' lh-even' : ' lh-odd') : '');
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        var common = '<div class="' + LineNumbersOverlay.CLASS_NAME + lineHeightClassName + '" style="left:' + this._lineNumbersLeft.toString() + 'px;width:' + this._lineNumbersWidth.toString() + 'px;">';
        var output = [];
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var lineIndex = lineNumber - visibleStartLineNumber;
            var renderLineNumber = this._getLineRenderLineNumber(lineNumber);
            if (renderLineNumber) {
                output[lineIndex] = (common
                    + renderLineNumber
                    + '</div>');
            }
            else {
                output[lineIndex] = '';
            }
        }
        this._renderResult = output;
    };
    LineNumbersOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (!this._renderResult) {
            return '';
        }
        var lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) {
            return '';
        }
        return this._renderResult[lineIndex];
    };
    LineNumbersOverlay.CLASS_NAME = 'line-numbers';
    return LineNumbersOverlay;
}(__WEBPACK_IMPORTED_MODULE_4__view_dynamicViewOverlay_js__["a" /* DynamicViewOverlay */]));

// theming
Object(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var lineNumbers = theme.getColor(__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["q" /* editorLineNumbers */]);
    if (lineNumbers) {
        collector.addRule(".monaco-editor .line-numbers { color: " + lineNumbers + "; }");
    }
    var activeLineNumber = theme.getColor(__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["b" /* editorActiveLineNumber */]);
    if (activeLineNumber) {
        collector.addRule(".monaco-editor .current-line ~ .line-numbers { color: " + activeLineNumber + "; }");
    }
});


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MouseTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HitTestContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MouseTargetFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorDom_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewParts_lines_viewLine_js__ = __webpack_require__(272);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var MouseTarget = /** @class */ (function () {
    function MouseTarget(element, type, mouseColumn, position, range, detail) {
        if (mouseColumn === void 0) { mouseColumn = 0; }
        if (position === void 0) { position = null; }
        if (range === void 0) { range = null; }
        if (detail === void 0) { detail = null; }
        this.element = element;
        this.type = type;
        this.mouseColumn = mouseColumn;
        this.position = position;
        if (!range && position) {
            range = new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column);
        }
        this.range = range;
        this.detail = detail;
    }
    MouseTarget._typeToString = function (type) {
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].TEXTAREA) {
            return 'TEXTAREA';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_GLYPH_MARGIN) {
            return 'GUTTER_GLYPH_MARGIN';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_NUMBERS) {
            return 'GUTTER_LINE_NUMBERS';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_DECORATIONS) {
            return 'GUTTER_LINE_DECORATIONS';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_VIEW_ZONE) {
            return 'GUTTER_VIEW_ZONE';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT) {
            return 'CONTENT_TEXT';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY) {
            return 'CONTENT_EMPTY';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_VIEW_ZONE) {
            return 'CONTENT_VIEW_ZONE';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_WIDGET) {
            return 'CONTENT_WIDGET';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].OVERVIEW_RULER) {
            return 'OVERVIEW_RULER';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].SCROLLBAR) {
            return 'SCROLLBAR';
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].OVERLAY_WIDGET) {
            return 'OVERLAY_WIDGET';
        }
        return 'UNKNOWN';
    };
    MouseTarget.toString = function (target) {
        return this._typeToString(target.type) + ': ' + target.position + ' - ' + target.range + ' - ' + target.detail;
    };
    MouseTarget.prototype.toString = function () {
        return MouseTarget.toString(this);
    };
    return MouseTarget;
}());

var ElementPath = /** @class */ (function () {
    function ElementPath() {
    }
    ElementPath.isTextArea = function (path) {
        return (path.length === 2
            && path[0] === 3 /* OverflowGuard */
            && path[1] === 6 /* TextArea */);
    };
    ElementPath.isChildOfViewLines = function (path) {
        return (path.length >= 4
            && path[0] === 3 /* OverflowGuard */
            && path[3] === 7 /* ViewLines */);
    };
    ElementPath.isStrictChildOfViewLines = function (path) {
        return (path.length > 4
            && path[0] === 3 /* OverflowGuard */
            && path[3] === 7 /* ViewLines */);
    };
    ElementPath.isChildOfScrollableElement = function (path) {
        return (path.length >= 2
            && path[0] === 3 /* OverflowGuard */
            && path[1] === 5 /* ScrollableElement */);
    };
    ElementPath.isChildOfMinimap = function (path) {
        return (path.length >= 2
            && path[0] === 3 /* OverflowGuard */
            && path[1] === 8 /* Minimap */);
    };
    ElementPath.isChildOfContentWidgets = function (path) {
        return (path.length >= 4
            && path[0] === 3 /* OverflowGuard */
            && path[3] === 1 /* ContentWidgets */);
    };
    ElementPath.isChildOfOverflowingContentWidgets = function (path) {
        return (path.length >= 1
            && path[0] === 2 /* OverflowingContentWidgets */);
    };
    ElementPath.isChildOfOverlayWidgets = function (path) {
        return (path.length >= 2
            && path[0] === 3 /* OverflowGuard */
            && path[1] === 4 /* OverlayWidgets */);
    };
    return ElementPath;
}());
var HitTestContext = /** @class */ (function () {
    function HitTestContext(context, viewHelper, lastViewCursorsRenderData) {
        this.model = context.model;
        this.layoutInfo = context.configuration.editor.layoutInfo;
        this.viewDomNode = viewHelper.viewDomNode;
        this.lineHeight = context.configuration.editor.lineHeight;
        this.typicalHalfwidthCharacterWidth = context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        this.lastViewCursorsRenderData = lastViewCursorsRenderData;
        this._context = context;
        this._viewHelper = viewHelper;
    }
    HitTestContext.prototype.getZoneAtCoord = function (mouseVerticalOffset) {
        return HitTestContext.getZoneAtCoord(this._context, mouseVerticalOffset);
    };
    HitTestContext.getZoneAtCoord = function (context, mouseVerticalOffset) {
        // The target is either a view zone or the empty space after the last view-line
        var viewZoneWhitespace = context.viewLayout.getWhitespaceAtVerticalOffset(mouseVerticalOffset);
        if (viewZoneWhitespace) {
            var viewZoneMiddle = viewZoneWhitespace.verticalOffset + viewZoneWhitespace.height / 2, lineCount = context.model.getLineCount(), positionBefore = null, position = void 0, positionAfter = null;
            if (viewZoneWhitespace.afterLineNumber !== lineCount) {
                // There are more lines after this view zone
                positionAfter = new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](viewZoneWhitespace.afterLineNumber + 1, 1);
            }
            if (viewZoneWhitespace.afterLineNumber > 0) {
                // There are more lines above this view zone
                positionBefore = new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](viewZoneWhitespace.afterLineNumber, context.model.getLineMaxColumn(viewZoneWhitespace.afterLineNumber));
            }
            if (positionAfter === null) {
                position = positionBefore;
            }
            else if (positionBefore === null) {
                position = positionAfter;
            }
            else if (mouseVerticalOffset < viewZoneMiddle) {
                position = positionBefore;
            }
            else {
                position = positionAfter;
            }
            return {
                viewZoneId: viewZoneWhitespace.id,
                afterLineNumber: viewZoneWhitespace.afterLineNumber,
                positionBefore: positionBefore,
                positionAfter: positionAfter,
                position: position
            };
        }
        return null;
    };
    HitTestContext.prototype.getFullLineRangeAtCoord = function (mouseVerticalOffset) {
        if (this._context.viewLayout.isAfterLines(mouseVerticalOffset)) {
            // Below the last line
            var lineNumber_1 = this._context.model.getLineCount();
            var maxLineColumn_1 = this._context.model.getLineMaxColumn(lineNumber_1);
            return {
                range: new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](lineNumber_1, maxLineColumn_1, lineNumber_1, maxLineColumn_1),
                isAfterLines: true
            };
        }
        var lineNumber = this._context.viewLayout.getLineNumberAtVerticalOffset(mouseVerticalOffset);
        var maxLineColumn = this._context.model.getLineMaxColumn(lineNumber);
        return {
            range: new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, maxLineColumn),
            isAfterLines: false
        };
    };
    HitTestContext.prototype.getLineNumberAtVerticalOffset = function (mouseVerticalOffset) {
        return this._context.viewLayout.getLineNumberAtVerticalOffset(mouseVerticalOffset);
    };
    HitTestContext.prototype.isAfterLines = function (mouseVerticalOffset) {
        return this._context.viewLayout.isAfterLines(mouseVerticalOffset);
    };
    HitTestContext.prototype.getVerticalOffsetForLineNumber = function (lineNumber) {
        return this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber);
    };
    HitTestContext.prototype.findAttribute = function (element, attr) {
        return HitTestContext._findAttribute(element, attr, this._viewHelper.viewDomNode);
    };
    HitTestContext._findAttribute = function (element, attr, stopAt) {
        while (element && element !== document.body) {
            if (element.hasAttribute && element.hasAttribute(attr)) {
                return element.getAttribute(attr);
            }
            if (element === stopAt) {
                return null;
            }
            element = element.parentNode;
        }
        return null;
    };
    HitTestContext.prototype.getLineWidth = function (lineNumber) {
        return this._viewHelper.getLineWidth(lineNumber);
    };
    HitTestContext.prototype.visibleRangeForPosition2 = function (lineNumber, column) {
        return this._viewHelper.visibleRangeForPosition2(lineNumber, column);
    };
    HitTestContext.prototype.getPositionFromDOMInfo = function (spanNode, offset) {
        return this._viewHelper.getPositionFromDOMInfo(spanNode, offset);
    };
    HitTestContext.prototype.getCurrentScrollTop = function () {
        return this._context.viewLayout.getCurrentScrollTop();
    };
    HitTestContext.prototype.getCurrentScrollLeft = function () {
        return this._context.viewLayout.getCurrentScrollLeft();
    };
    return HitTestContext;
}());

var BareHitTestRequest = /** @class */ (function () {
    function BareHitTestRequest(ctx, editorPos, pos) {
        this.editorPos = editorPos;
        this.pos = pos;
        this.mouseVerticalOffset = Math.max(0, ctx.getCurrentScrollTop() + pos.y - editorPos.y);
        this.mouseContentHorizontalOffset = ctx.getCurrentScrollLeft() + pos.x - editorPos.x - ctx.layoutInfo.contentLeft;
        this.isInMarginArea = (pos.x - editorPos.x < ctx.layoutInfo.contentLeft && pos.x - editorPos.x >= ctx.layoutInfo.glyphMarginLeft);
        this.isInContentArea = !this.isInMarginArea;
        this.mouseColumn = Math.max(0, MouseTargetFactory._getMouseColumn(this.mouseContentHorizontalOffset, ctx.typicalHalfwidthCharacterWidth));
    }
    return BareHitTestRequest;
}());
var HitTestRequest = /** @class */ (function (_super) {
    __extends(HitTestRequest, _super);
    function HitTestRequest(ctx, editorPos, pos, target) {
        var _this = _super.call(this, ctx, editorPos, pos) || this;
        _this._ctx = ctx;
        if (target) {
            _this.target = target;
            _this.targetPath = __WEBPACK_IMPORTED_MODULE_5__view_viewPart_js__["a" /* PartFingerprints */].collect(target, ctx.viewDomNode);
        }
        else {
            _this.target = null;
            _this.targetPath = new Uint8Array(0);
        }
        return _this;
    }
    HitTestRequest.prototype.toString = function () {
        return "pos(" + this.pos.x + "," + this.pos.y + "), editorPos(" + this.editorPos.x + "," + this.editorPos.y + "), mouseVerticalOffset: " + this.mouseVerticalOffset + ", mouseContentHorizontalOffset: " + this.mouseContentHorizontalOffset + "\n\ttarget: " + (this.target ? this.target.outerHTML : null);
    };
    HitTestRequest.prototype.fulfill = function (type, position, range, detail) {
        if (position === void 0) { position = null; }
        if (range === void 0) { range = null; }
        if (detail === void 0) { detail = null; }
        return new MouseTarget(this.target, type, this.mouseColumn, position, range, detail);
    };
    HitTestRequest.prototype.withTarget = function (target) {
        return new HitTestRequest(this._ctx, this.editorPos, this.pos, target);
    };
    return HitTestRequest;
}(BareHitTestRequest));
var EMPTY_CONTENT_AFTER_LINES = { isAfterLines: true };
function createEmptyContentDataInLines(horizontalDistanceToText) {
    return {
        isAfterLines: false,
        horizontalDistanceToText: horizontalDistanceToText
    };
}
var MouseTargetFactory = /** @class */ (function () {
    function MouseTargetFactory(context, viewHelper) {
        this._context = context;
        this._viewHelper = viewHelper;
    }
    MouseTargetFactory.prototype.mouseTargetIsWidget = function (e) {
        var t = e.target;
        var path = __WEBPACK_IMPORTED_MODULE_5__view_viewPart_js__["a" /* PartFingerprints */].collect(t, this._viewHelper.viewDomNode);
        // Is it a content widget?
        if (ElementPath.isChildOfContentWidgets(path) || ElementPath.isChildOfOverflowingContentWidgets(path)) {
            return true;
        }
        // Is it an overlay widget?
        if (ElementPath.isChildOfOverlayWidgets(path)) {
            return true;
        }
        return false;
    };
    MouseTargetFactory.prototype.createMouseTarget = function (lastViewCursorsRenderData, editorPos, pos, target) {
        var ctx = new HitTestContext(this._context, this._viewHelper, lastViewCursorsRenderData);
        var request = new HitTestRequest(ctx, editorPos, pos, target);
        try {
            var r = MouseTargetFactory._createMouseTarget(ctx, request, false);
            // console.log(r.toString());
            return r;
        }
        catch (err) {
            // console.log(err);
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].UNKNOWN);
        }
    };
    MouseTargetFactory._createMouseTarget = function (ctx, request, domHitTestExecuted) {
        // console.log(`${domHitTestExecuted ? '=>' : ''}CAME IN REQUEST: ${request}`);
        // First ensure the request has a target
        if (request.target === null) {
            if (domHitTestExecuted) {
                // Still no target... and we have already executed hit test...
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].UNKNOWN);
            }
            var hitTestResult = MouseTargetFactory._doHitTest(ctx, request);
            if (hitTestResult.position) {
                return MouseTargetFactory.createMouseTargetFromHitTestPosition(ctx, request, hitTestResult.position.lineNumber, hitTestResult.position.column);
            }
            return this._createMouseTarget(ctx, request.withTarget(hitTestResult.hitTarget), true);
        }
        var result = null;
        result = result || MouseTargetFactory._hitTestContentWidget(ctx, request);
        result = result || MouseTargetFactory._hitTestOverlayWidget(ctx, request);
        result = result || MouseTargetFactory._hitTestMinimap(ctx, request);
        result = result || MouseTargetFactory._hitTestScrollbarSlider(ctx, request);
        result = result || MouseTargetFactory._hitTestViewZone(ctx, request);
        result = result || MouseTargetFactory._hitTestMargin(ctx, request);
        result = result || MouseTargetFactory._hitTestViewCursor(ctx, request);
        result = result || MouseTargetFactory._hitTestTextArea(ctx, request);
        result = result || MouseTargetFactory._hitTestViewLines(ctx, request, domHitTestExecuted);
        result = result || MouseTargetFactory._hitTestScrollbar(ctx, request);
        return (result || request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].UNKNOWN));
    };
    MouseTargetFactory._hitTestContentWidget = function (ctx, request) {
        // Is it a content widget?
        if (ElementPath.isChildOfContentWidgets(request.targetPath) || ElementPath.isChildOfOverflowingContentWidgets(request.targetPath)) {
            var widgetId = ctx.findAttribute(request.target, 'widgetId');
            if (widgetId) {
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_WIDGET, null, null, widgetId);
            }
            else {
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].UNKNOWN);
            }
        }
        return null;
    };
    MouseTargetFactory._hitTestOverlayWidget = function (ctx, request) {
        // Is it an overlay widget?
        if (ElementPath.isChildOfOverlayWidgets(request.targetPath)) {
            var widgetId = ctx.findAttribute(request.target, 'widgetId');
            if (widgetId) {
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].OVERLAY_WIDGET, null, null, widgetId);
            }
            else {
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].UNKNOWN);
            }
        }
        return null;
    };
    MouseTargetFactory._hitTestViewCursor = function (ctx, request) {
        if (request.target) {
            // Check if we've hit a painted cursor
            var lastViewCursorsRenderData = ctx.lastViewCursorsRenderData;
            for (var i = 0, len = lastViewCursorsRenderData.length; i < len; i++) {
                var d = lastViewCursorsRenderData[i];
                if (request.target === d.domNode) {
                    return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT, d.position);
                }
            }
        }
        if (request.isInContentArea) {
            // Edge has a bug when hit-testing the exact position of a cursor,
            // instead of returning the correct dom node, it returns the
            // first or last rendered view line dom node, therefore help it out
            // and first check if we are on top of a cursor
            var lastViewCursorsRenderData = ctx.lastViewCursorsRenderData;
            var mouseContentHorizontalOffset = request.mouseContentHorizontalOffset;
            var mouseVerticalOffset = request.mouseVerticalOffset;
            for (var i = 0, len = lastViewCursorsRenderData.length; i < len; i++) {
                var d = lastViewCursorsRenderData[i];
                if (mouseContentHorizontalOffset < d.contentLeft) {
                    // mouse position is to the left of the cursor
                    continue;
                }
                if (mouseContentHorizontalOffset > d.contentLeft + d.width) {
                    // mouse position is to the right of the cursor
                    continue;
                }
                var cursorVerticalOffset = ctx.getVerticalOffsetForLineNumber(d.position.lineNumber);
                if (cursorVerticalOffset <= mouseVerticalOffset
                    && mouseVerticalOffset <= cursorVerticalOffset + d.height) {
                    return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT, d.position);
                }
            }
        }
        return null;
    };
    MouseTargetFactory._hitTestViewZone = function (ctx, request) {
        var viewZoneData = ctx.getZoneAtCoord(request.mouseVerticalOffset);
        if (viewZoneData) {
            var mouseTargetType = (request.isInContentArea ? __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_VIEW_ZONE : __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_VIEW_ZONE);
            return request.fulfill(mouseTargetType, viewZoneData.position, null, viewZoneData);
        }
        return null;
    };
    MouseTargetFactory._hitTestTextArea = function (ctx, request) {
        // Is it the textarea?
        if (ElementPath.isTextArea(request.targetPath)) {
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].TEXTAREA);
        }
        return null;
    };
    MouseTargetFactory._hitTestMargin = function (ctx, request) {
        if (request.isInMarginArea) {
            var res = ctx.getFullLineRangeAtCoord(request.mouseVerticalOffset);
            var pos = res.range.getStartPosition();
            var offset = Math.abs(request.pos.x - request.editorPos.x);
            var detail = {
                isAfterLines: res.isAfterLines,
                glyphMarginLeft: ctx.layoutInfo.glyphMarginLeft,
                glyphMarginWidth: ctx.layoutInfo.glyphMarginWidth,
                lineNumbersWidth: ctx.layoutInfo.lineNumbersWidth,
                offsetX: offset
            };
            offset -= ctx.layoutInfo.glyphMarginLeft;
            if (offset <= ctx.layoutInfo.glyphMarginWidth) {
                // On the glyph margin
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_GLYPH_MARGIN, pos, res.range, detail);
            }
            offset -= ctx.layoutInfo.glyphMarginWidth;
            if (offset <= ctx.layoutInfo.lineNumbersWidth) {
                // On the line numbers
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_NUMBERS, pos, res.range, detail);
            }
            offset -= ctx.layoutInfo.lineNumbersWidth;
            // On the line decorations
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_DECORATIONS, pos, res.range, detail);
        }
        return null;
    };
    MouseTargetFactory._hitTestViewLines = function (ctx, request, domHitTestExecuted) {
        if (!ElementPath.isChildOfViewLines(request.targetPath)) {
            return null;
        }
        // Check if it is below any lines and any view zones
        if (ctx.isAfterLines(request.mouseVerticalOffset)) {
            // This most likely indicates it happened after the last view-line
            var lineCount = ctx.model.getLineCount();
            var maxLineColumn = ctx.model.getLineMaxColumn(lineCount);
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY, new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](lineCount, maxLineColumn), void 0, EMPTY_CONTENT_AFTER_LINES);
        }
        if (domHitTestExecuted) {
            // Check if we are hitting a view-line (can happen in the case of inline decorations on empty lines)
            // See https://github.com/Microsoft/vscode/issues/46942
            if (ElementPath.isStrictChildOfViewLines(request.targetPath)) {
                var lineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
                if (ctx.model.getLineLength(lineNumber) === 0) {
                    var lineWidth = ctx.getLineWidth(lineNumber);
                    var detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
                    return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY, new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](lineNumber, 1), void 0, detail);
                }
            }
            // We have already executed hit test...
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].UNKNOWN);
        }
        var hitTestResult = MouseTargetFactory._doHitTest(ctx, request);
        if (hitTestResult.position) {
            return MouseTargetFactory.createMouseTargetFromHitTestPosition(ctx, request, hitTestResult.position.lineNumber, hitTestResult.position.column);
        }
        return this._createMouseTarget(ctx, request.withTarget(hitTestResult.hitTarget), true);
    };
    MouseTargetFactory._hitTestMinimap = function (ctx, request) {
        if (ElementPath.isChildOfMinimap(request.targetPath)) {
            var possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
            var maxColumn = ctx.model.getLineMaxColumn(possibleLineNumber);
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].SCROLLBAR, new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](possibleLineNumber, maxColumn));
        }
        return null;
    };
    MouseTargetFactory._hitTestScrollbarSlider = function (ctx, request) {
        if (ElementPath.isChildOfScrollableElement(request.targetPath)) {
            if (request.target && request.target.nodeType === 1) {
                var className = request.target.className;
                if (className && /\b(slider|scrollbar)\b/.test(className)) {
                    var possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
                    var maxColumn = ctx.model.getLineMaxColumn(possibleLineNumber);
                    return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].SCROLLBAR, new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](possibleLineNumber, maxColumn));
                }
            }
        }
        return null;
    };
    MouseTargetFactory._hitTestScrollbar = function (ctx, request) {
        // Is it the overview ruler?
        // Is it a child of the scrollable element?
        if (ElementPath.isChildOfScrollableElement(request.targetPath)) {
            var possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
            var maxColumn = ctx.model.getLineMaxColumn(possibleLineNumber);
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].SCROLLBAR, new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](possibleLineNumber, maxColumn));
        }
        return null;
    };
    MouseTargetFactory.prototype.getMouseColumn = function (editorPos, pos) {
        var layoutInfo = this._context.configuration.editor.layoutInfo;
        var mouseContentHorizontalOffset = this._context.viewLayout.getCurrentScrollLeft() + pos.x - editorPos.x - layoutInfo.contentLeft;
        return MouseTargetFactory._getMouseColumn(mouseContentHorizontalOffset, this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth);
    };
    MouseTargetFactory._getMouseColumn = function (mouseContentHorizontalOffset, typicalHalfwidthCharacterWidth) {
        if (mouseContentHorizontalOffset < 0) {
            return 1;
        }
        var chars = Math.round(mouseContentHorizontalOffset / typicalHalfwidthCharacterWidth);
        return (chars + 1);
    };
    MouseTargetFactory.createMouseTargetFromHitTestPosition = function (ctx, request, lineNumber, column) {
        var pos = new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](lineNumber, column);
        var lineWidth = ctx.getLineWidth(lineNumber);
        if (request.mouseContentHorizontalOffset > lineWidth) {
            if (__WEBPACK_IMPORTED_MODULE_4__base_browser_browser_js__["g" /* isEdge */] && pos.column === 1) {
                // See https://github.com/Microsoft/vscode/issues/10875
                var detail_1 = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY, new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](lineNumber, ctx.model.getLineMaxColumn(lineNumber)), void 0, detail_1);
            }
            var detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY, pos, void 0, detail);
        }
        var visibleRange = ctx.visibleRangeForPosition2(lineNumber, column);
        if (!visibleRange) {
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].UNKNOWN, pos);
        }
        var columnHorizontalOffset = visibleRange.left;
        if (request.mouseContentHorizontalOffset === columnHorizontalOffset) {
            return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT, pos);
        }
        var points = [];
        points.push({ offset: visibleRange.left, column: column });
        if (column > 1) {
            var visibleRange_1 = ctx.visibleRangeForPosition2(lineNumber, column - 1);
            if (visibleRange_1) {
                points.push({ offset: visibleRange_1.left, column: column - 1 });
            }
        }
        var lineMaxColumn = ctx.model.getLineMaxColumn(lineNumber);
        if (column < lineMaxColumn) {
            var visibleRange_2 = ctx.visibleRangeForPosition2(lineNumber, column + 1);
            if (visibleRange_2) {
                points.push({ offset: visibleRange_2.left, column: column + 1 });
            }
        }
        points.sort(function (a, b) { return a.offset - b.offset; });
        for (var i = 1; i < points.length; i++) {
            var prev = points[i - 1];
            var curr = points[i];
            if (prev.offset <= request.mouseContentHorizontalOffset && request.mouseContentHorizontalOffset <= curr.offset) {
                var rng = new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](lineNumber, prev.column, lineNumber, curr.column);
                return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT, pos, rng);
            }
        }
        return request.fulfill(__WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT, pos);
    };
    /**
     * Most probably WebKit browsers and Edge
     */
    MouseTargetFactory._doHitTestWithCaretRangeFromPoint = function (ctx, request) {
        // In Chrome, especially on Linux it is possible to click between lines,
        // so try to adjust the `hity` below so that it lands in the center of a line
        var lineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
        var lineVerticalOffset = ctx.getVerticalOffsetForLineNumber(lineNumber);
        var lineCenteredVerticalOffset = lineVerticalOffset + Math.floor(ctx.lineHeight / 2);
        var adjustedPageY = request.pos.y + (lineCenteredVerticalOffset - request.mouseVerticalOffset);
        if (adjustedPageY <= request.editorPos.y) {
            adjustedPageY = request.editorPos.y + 1;
        }
        if (adjustedPageY >= request.editorPos.y + ctx.layoutInfo.height) {
            adjustedPageY = request.editorPos.y + ctx.layoutInfo.height - 1;
        }
        var adjustedPage = new __WEBPACK_IMPORTED_MODULE_3__editorDom_js__["e" /* PageCoordinates */](request.pos.x, adjustedPageY);
        var r = this._actualDoHitTestWithCaretRangeFromPoint(ctx, adjustedPage.toClientCoordinates());
        if (r.position) {
            return r;
        }
        // Also try to hit test without the adjustment (for the edge cases that we are near the top or bottom)
        return this._actualDoHitTestWithCaretRangeFromPoint(ctx, request.pos.toClientCoordinates());
    };
    MouseTargetFactory._actualDoHitTestWithCaretRangeFromPoint = function (ctx, coords) {
        var range = document.caretRangeFromPoint(coords.clientX, coords.clientY);
        if (!range || !range.startContainer) {
            return {
                position: null,
                hitTarget: null
            };
        }
        // Chrome always hits a TEXT_NODE, while Edge sometimes hits a token span
        var startContainer = range.startContainer;
        var hitTarget;
        if (startContainer.nodeType === startContainer.TEXT_NODE) {
            // startContainer is expected to be the token text
            var parent1 = startContainer.parentNode; // expected to be the token span
            var parent2 = parent1 ? parent1.parentNode : null; // expected to be the view line container span
            var parent3 = parent2 ? parent2.parentNode : null; // expected to be the view line div
            var parent3ClassName = parent3 && parent3.nodeType === parent3.ELEMENT_NODE ? parent3.className : null;
            if (parent3ClassName === __WEBPACK_IMPORTED_MODULE_6__viewParts_lines_viewLine_js__["b" /* ViewLine */].CLASS_NAME) {
                var p = ctx.getPositionFromDOMInfo(parent1, range.startOffset);
                return {
                    position: p,
                    hitTarget: null
                };
            }
            else {
                hitTarget = startContainer.parentNode;
            }
        }
        else if (startContainer.nodeType === startContainer.ELEMENT_NODE) {
            // startContainer is expected to be the token span
            var parent1 = startContainer.parentNode; // expected to be the view line container span
            var parent2 = parent1 ? parent1.parentNode : null; // expected to be the view line div
            var parent2ClassName = parent2 && parent2.nodeType === parent2.ELEMENT_NODE ? parent2.className : null;
            if (parent2ClassName === __WEBPACK_IMPORTED_MODULE_6__viewParts_lines_viewLine_js__["b" /* ViewLine */].CLASS_NAME) {
                var p = ctx.getPositionFromDOMInfo(startContainer, startContainer.textContent.length);
                return {
                    position: p,
                    hitTarget: null
                };
            }
            else {
                hitTarget = startContainer;
            }
        }
        return {
            position: null,
            hitTarget: hitTarget
        };
    };
    /**
     * Most probably Gecko
     */
    MouseTargetFactory._doHitTestWithCaretPositionFromPoint = function (ctx, coords) {
        var hitResult = document.caretPositionFromPoint(coords.clientX, coords.clientY);
        if (hitResult.offsetNode.nodeType === hitResult.offsetNode.TEXT_NODE) {
            // offsetNode is expected to be the token text
            var parent1 = hitResult.offsetNode.parentNode; // expected to be the token span
            var parent2 = parent1 ? parent1.parentNode : null; // expected to be the view line container span
            var parent3 = parent2 ? parent2.parentNode : null; // expected to be the view line div
            var parent3ClassName = parent3 && parent3.nodeType === parent3.ELEMENT_NODE ? parent3.className : null;
            if (parent3ClassName === __WEBPACK_IMPORTED_MODULE_6__viewParts_lines_viewLine_js__["b" /* ViewLine */].CLASS_NAME) {
                var p = ctx.getPositionFromDOMInfo(hitResult.offsetNode.parentNode, hitResult.offset);
                return {
                    position: p,
                    hitTarget: null
                };
            }
            else {
                return {
                    position: null,
                    hitTarget: hitResult.offsetNode.parentNode
                };
            }
        }
        return {
            position: null,
            hitTarget: hitResult.offsetNode
        };
    };
    /**
     * Most probably IE
     */
    MouseTargetFactory._doHitTestWithMoveToPoint = function (ctx, coords) {
        var resultPosition = null;
        var resultHitTarget = null;
        var textRange = document.body.createTextRange();
        try {
            textRange.moveToPoint(coords.clientX, coords.clientY);
        }
        catch (err) {
            return {
                position: null,
                hitTarget: null
            };
        }
        textRange.collapse(true);
        // Now, let's do our best to figure out what we hit :)
        var parentElement = textRange ? textRange.parentElement() : null;
        var parent1 = parentElement ? parentElement.parentNode : null;
        var parent2 = parent1 ? parent1.parentNode : null;
        var parent2ClassName = parent2 && parent2.nodeType === parent2.ELEMENT_NODE ? parent2.className : '';
        if (parent2ClassName === __WEBPACK_IMPORTED_MODULE_6__viewParts_lines_viewLine_js__["b" /* ViewLine */].CLASS_NAME) {
            var rangeToContainEntireSpan = textRange.duplicate();
            rangeToContainEntireSpan.moveToElementText(parentElement);
            rangeToContainEntireSpan.setEndPoint('EndToStart', textRange);
            resultPosition = ctx.getPositionFromDOMInfo(parentElement, rangeToContainEntireSpan.text.length);
            // Move range out of the span node, IE doesn't like having many ranges in
            // the same spot and will act badly for lines containing dashes ('-')
            rangeToContainEntireSpan.moveToElementText(ctx.viewDomNode);
        }
        else {
            // Looks like we've hit the hover or something foreign
            resultHitTarget = parentElement;
        }
        // Move range out of the span node, IE doesn't like having many ranges in
        // the same spot and will act badly for lines containing dashes ('-')
        textRange.moveToElementText(ctx.viewDomNode);
        return {
            position: resultPosition,
            hitTarget: resultHitTarget
        };
    };
    MouseTargetFactory._doHitTest = function (ctx, request) {
        // State of the art (18.10.2012):
        // The spec says browsers should support document.caretPositionFromPoint, but nobody implemented it (http://dev.w3.org/csswg/cssom-view/)
        // Gecko:
        //    - they tried to implement it once, but failed: https://bugzilla.mozilla.org/show_bug.cgi?id=654352
        //    - however, they do give out rangeParent/rangeOffset properties on mouse events
        // Webkit:
        //    - they have implemented a previous version of the spec which was using document.caretRangeFromPoint
        // IE:
        //    - they have a proprietary method on ranges, moveToPoint: https://msdn.microsoft.com/en-us/library/ie/ms536632(v=vs.85).aspx
        // 24.08.2016: Edge has added WebKit's document.caretRangeFromPoint, but it is quite buggy
        //    - when hit testing the cursor it returns the first or the last line in the viewport
        //    - it inconsistently hits text nodes or span nodes, while WebKit only hits text nodes
        //    - when toggling render whitespace on, and hit testing in the empty content after a line, it always hits offset 0 of the first span of the line
        // Thank you browsers for making this so 'easy' :)
        if (document.caretRangeFromPoint) {
            return this._doHitTestWithCaretRangeFromPoint(ctx, request);
        }
        else if (document.caretPositionFromPoint) {
            return this._doHitTestWithCaretPositionFromPoint(ctx, request.pos.toClientCoordinates());
        }
        else if (document.body.createTextRange) {
            return this._doHitTestWithMoveToPoint(ctx, request.pos.toClientCoordinates());
        }
        return {
            position: null,
            hitTarget: null
        };
    };
    return MouseTargetFactory;
}());



/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DomReadingContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ViewLineOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ViewLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_viewLayout_lineDecorations_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rangeUtil_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_view_renderingContext_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_themeService_js__ = __webpack_require__(13);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var canUseFastRenderedViewLine = (function () {
    if (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["e" /* isNative */]) {
        // In VSCode we know very well when the zoom level changes
        return true;
    }
    if (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["c" /* isLinux */] || __WEBPACK_IMPORTED_MODULE_0__base_browser_browser_js__["j" /* isFirefox */] || __WEBPACK_IMPORTED_MODULE_0__base_browser_browser_js__["m" /* isSafari */]) {
        // On Linux, it appears that zooming affects char widths (in pixels), which is unexpected.
        // --
        // Even though we read character widths correctly, having read them at a specific zoom level
        // does not mean they are the same at the current zoom level.
        // --
        // This could be improved if we ever figure out how to get an event when browsers zoom,
        // but until then we have to stick with reading client rects.
        // --
        // The same has been observed with Firefox on Windows7
        // --
        // The same has been oversved with Safari
        return false;
    }
    return true;
})();
var alwaysRenderInlineSelection = (__WEBPACK_IMPORTED_MODULE_0__base_browser_browser_js__["h" /* isEdgeOrIE */]);
var DomReadingContext = /** @class */ (function () {
    function DomReadingContext(domNode, endNode) {
        this._domNode = domNode;
        this._clientRectDeltaLeft = 0;
        this._clientRectDeltaLeftRead = false;
        this.endNode = endNode;
    }
    Object.defineProperty(DomReadingContext.prototype, "clientRectDeltaLeft", {
        get: function () {
            if (!this._clientRectDeltaLeftRead) {
                this._clientRectDeltaLeftRead = true;
                this._clientRectDeltaLeft = this._domNode.getBoundingClientRect().left;
            }
            return this._clientRectDeltaLeft;
        },
        enumerable: true,
        configurable: true
    });
    return DomReadingContext;
}());

var ViewLineOptions = /** @class */ (function () {
    function ViewLineOptions(config, themeType) {
        this.themeType = themeType;
        this.renderWhitespace = config.editor.viewInfo.renderWhitespace;
        this.renderControlCharacters = config.editor.viewInfo.renderControlCharacters;
        this.spaceWidth = config.editor.fontInfo.spaceWidth;
        this.useMonospaceOptimizations = (config.editor.fontInfo.isMonospace
            && !config.editor.viewInfo.disableMonospaceOptimizations);
        this.lineHeight = config.editor.lineHeight;
        this.stopRenderingLineAfter = config.editor.viewInfo.stopRenderingLineAfter;
        this.fontLigatures = config.editor.viewInfo.fontLigatures;
    }
    ViewLineOptions.prototype.equals = function (other) {
        return (this.themeType === other.themeType
            && this.renderWhitespace === other.renderWhitespace
            && this.renderControlCharacters === other.renderControlCharacters
            && this.spaceWidth === other.spaceWidth
            && this.useMonospaceOptimizations === other.useMonospaceOptimizations
            && this.lineHeight === other.lineHeight
            && this.stopRenderingLineAfter === other.stopRenderingLineAfter
            && this.fontLigatures === other.fontLigatures);
    };
    return ViewLineOptions;
}());

var ViewLine = /** @class */ (function () {
    function ViewLine(options) {
        this._options = options;
        this._isMaybeInvalid = true;
        this._renderedViewLine = null;
    }
    // --- begin IVisibleLineData
    ViewLine.prototype.getDomNode = function () {
        if (this._renderedViewLine && this._renderedViewLine.domNode) {
            return this._renderedViewLine.domNode.domNode;
        }
        return null;
    };
    ViewLine.prototype.setDomNode = function (domNode) {
        if (this._renderedViewLine) {
            this._renderedViewLine.domNode = Object(__WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(domNode);
        }
        else {
            throw new Error('I have no rendered view line to set the dom node to...');
        }
    };
    ViewLine.prototype.onContentChanged = function () {
        this._isMaybeInvalid = true;
    };
    ViewLine.prototype.onTokensChanged = function () {
        this._isMaybeInvalid = true;
    };
    ViewLine.prototype.onDecorationsChanged = function () {
        this._isMaybeInvalid = true;
    };
    ViewLine.prototype.onOptionsChanged = function (newOptions) {
        this._isMaybeInvalid = true;
        this._options = newOptions;
    };
    ViewLine.prototype.onSelectionChanged = function () {
        if (alwaysRenderInlineSelection || this._options.themeType === __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_themeService_js__["b" /* HIGH_CONTRAST */]) {
            this._isMaybeInvalid = true;
            return true;
        }
        return false;
    };
    ViewLine.prototype.renderLine = function (lineNumber, deltaTop, viewportData, sb) {
        if (this._isMaybeInvalid === false) {
            // it appears that nothing relevant has changed
            return false;
        }
        this._isMaybeInvalid = false;
        var lineData = viewportData.getViewLineRenderingData(lineNumber);
        var options = this._options;
        var actualInlineDecorations = __WEBPACK_IMPORTED_MODULE_3__common_viewLayout_lineDecorations_js__["a" /* LineDecoration */].filter(lineData.inlineDecorations, lineNumber, lineData.minColumn, lineData.maxColumn);
        if (alwaysRenderInlineSelection || options.themeType === __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_themeService_js__["b" /* HIGH_CONTRAST */]) {
            var selections = viewportData.selections;
            for (var i = 0, len = selections.length; i < len; i++) {
                var selection = selections[i];
                if (selection.endLineNumber < lineNumber || selection.startLineNumber > lineNumber) {
                    // Selection does not intersect line
                    continue;
                }
                var startColumn = (selection.startLineNumber === lineNumber ? selection.startColumn : lineData.minColumn);
                var endColumn = (selection.endLineNumber === lineNumber ? selection.endColumn : lineData.maxColumn);
                if (startColumn < endColumn) {
                    actualInlineDecorations.push(new __WEBPACK_IMPORTED_MODULE_3__common_viewLayout_lineDecorations_js__["a" /* LineDecoration */](startColumn, endColumn, 'inline-selected-text', 0 /* Regular */));
                }
            }
        }
        var renderLineInput = new __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["b" /* RenderLineInput */](options.useMonospaceOptimizations, lineData.content, lineData.continuesWithWrappedLine, lineData.isBasicASCII, lineData.containsRTL, lineData.minColumn - 1, lineData.tokens, actualInlineDecorations, lineData.tabSize, options.spaceWidth, options.stopRenderingLineAfter, options.renderWhitespace, options.renderControlCharacters, options.fontLigatures);
        if (this._renderedViewLine && this._renderedViewLine.input.equals(renderLineInput)) {
            // no need to do anything, we have the same render input
            return false;
        }
        sb.appendASCIIString('<div style="top:');
        sb.appendASCIIString(String(deltaTop));
        sb.appendASCIIString('px;height:');
        sb.appendASCIIString(String(this._options.lineHeight));
        sb.appendASCIIString('px;" class="');
        sb.appendASCIIString(ViewLine.CLASS_NAME);
        sb.appendASCIIString('">');
        var output = Object(__WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["c" /* renderViewLine */])(renderLineInput, sb);
        sb.appendASCIIString('</div>');
        var renderedViewLine = null;
        if (canUseFastRenderedViewLine && lineData.isBasicASCII && options.useMonospaceOptimizations && output.containsForeignElements === 0 /* None */) {
            if (lineData.content.length < 300 && renderLineInput.lineTokens.getCount() < 100) {
                // Browser rounding errors have been observed in Chrome and IE, so using the fast
                // view line only for short lines. Please test before removing the length check...
                // ---
                // Another rounding error has been observed on Linux in VSCode, where <span> width
                // rounding errors add up to an observable large number...
                // ---
                // Also see another example of rounding errors on Windows in
                // https://github.com/Microsoft/vscode/issues/33178
                renderedViewLine = new FastRenderedViewLine(this._renderedViewLine ? this._renderedViewLine.domNode : null, renderLineInput, output.characterMapping);
            }
        }
        if (!renderedViewLine) {
            renderedViewLine = createRenderedLine(this._renderedViewLine ? this._renderedViewLine.domNode : null, renderLineInput, output.characterMapping, output.containsRTL, output.containsForeignElements);
        }
        this._renderedViewLine = renderedViewLine;
        return true;
    };
    ViewLine.prototype.layoutLine = function (lineNumber, deltaTop) {
        if (this._renderedViewLine && this._renderedViewLine.domNode) {
            this._renderedViewLine.domNode.setTop(deltaTop);
            this._renderedViewLine.domNode.setHeight(this._options.lineHeight);
        }
    };
    // --- end IVisibleLineData
    ViewLine.prototype.getWidth = function () {
        if (!this._renderedViewLine) {
            return 0;
        }
        return this._renderedViewLine.getWidth();
    };
    ViewLine.prototype.getWidthIsFast = function () {
        if (!this._renderedViewLine) {
            return true;
        }
        return this._renderedViewLine.getWidthIsFast();
    };
    ViewLine.prototype.getVisibleRangesForRange = function (startColumn, endColumn, context) {
        startColumn = startColumn | 0; // @perf
        endColumn = endColumn | 0; // @perf
        startColumn = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, startColumn));
        endColumn = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, endColumn));
        var stopRenderingLineAfter = this._renderedViewLine.input.stopRenderingLineAfter | 0; // @perf
        if (stopRenderingLineAfter !== -1 && startColumn > stopRenderingLineAfter && endColumn > stopRenderingLineAfter) {
            // This range is obviously not visible
            return null;
        }
        if (stopRenderingLineAfter !== -1 && startColumn > stopRenderingLineAfter) {
            startColumn = stopRenderingLineAfter;
        }
        if (stopRenderingLineAfter !== -1 && endColumn > stopRenderingLineAfter) {
            endColumn = stopRenderingLineAfter;
        }
        return this._renderedViewLine.getVisibleRangesForRange(startColumn, endColumn, context);
    };
    ViewLine.prototype.getColumnOfNodeOffset = function (lineNumber, spanNode, offset) {
        return this._renderedViewLine.getColumnOfNodeOffset(lineNumber, spanNode, offset);
    };
    ViewLine.CLASS_NAME = 'view-line';
    return ViewLine;
}());

/**
 * A rendered line which is guaranteed to contain only regular ASCII and is rendered with a monospace font.
 */
var FastRenderedViewLine = /** @class */ (function () {
    function FastRenderedViewLine(domNode, renderLineInput, characterMapping) {
        this.domNode = domNode;
        this.input = renderLineInput;
        this._characterMapping = characterMapping;
        this._charWidth = renderLineInput.spaceWidth;
    }
    FastRenderedViewLine.prototype.getWidth = function () {
        return this._getCharPosition(this._characterMapping.length);
    };
    FastRenderedViewLine.prototype.getWidthIsFast = function () {
        return true;
    };
    FastRenderedViewLine.prototype.getVisibleRangesForRange = function (startColumn, endColumn, context) {
        var startPosition = this._getCharPosition(startColumn);
        var endPosition = this._getCharPosition(endColumn);
        return [new __WEBPACK_IMPORTED_MODULE_6__common_view_renderingContext_js__["a" /* HorizontalRange */](startPosition, endPosition - startPosition)];
    };
    FastRenderedViewLine.prototype._getCharPosition = function (column) {
        var charOffset = this._characterMapping.getAbsoluteOffsets();
        if (charOffset.length === 0) {
            // No characters on this line
            return 0;
        }
        return Math.round(this._charWidth * charOffset[column - 1]);
    };
    FastRenderedViewLine.prototype.getColumnOfNodeOffset = function (lineNumber, spanNode, offset) {
        var spanNodeTextContentLength = spanNode.textContent.length;
        var spanIndex = -1;
        while (spanNode) {
            spanNode = spanNode.previousSibling;
            spanIndex++;
        }
        var charOffset = this._characterMapping.partDataToCharOffset(spanIndex, spanNodeTextContentLength, offset);
        return charOffset + 1;
    };
    return FastRenderedViewLine;
}());
/**
 * Every time we render a line, we save what we have rendered in an instance of this class.
 */
var RenderedViewLine = /** @class */ (function () {
    function RenderedViewLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements) {
        this.domNode = domNode;
        this.input = renderLineInput;
        this._characterMapping = characterMapping;
        this._isWhitespaceOnly = /^\s*$/.test(renderLineInput.lineContent);
        this._containsForeignElements = containsForeignElements;
        this._cachedWidth = -1;
        this._pixelOffsetCache = null;
        if (!containsRTL || this._characterMapping.length === 0 /* the line is empty */) {
            this._pixelOffsetCache = new Int32Array(Math.max(2, this._characterMapping.length + 1));
            for (var column = 0, len = this._characterMapping.length; column <= len; column++) {
                this._pixelOffsetCache[column] = -1;
            }
        }
    }
    // --- Reading from the DOM methods
    RenderedViewLine.prototype._getReadingTarget = function () {
        return this.domNode.domNode.firstChild;
    };
    /**
     * Width of the line in pixels
     */
    RenderedViewLine.prototype.getWidth = function () {
        if (this._cachedWidth === -1) {
            this._cachedWidth = this._getReadingTarget().offsetWidth;
        }
        return this._cachedWidth;
    };
    RenderedViewLine.prototype.getWidthIsFast = function () {
        if (this._cachedWidth === -1) {
            return false;
        }
        return true;
    };
    /**
     * Visible ranges for a model range
     */
    RenderedViewLine.prototype.getVisibleRangesForRange = function (startColumn, endColumn, context) {
        if (this._pixelOffsetCache !== null) {
            // the text is LTR
            var startOffset = this._readPixelOffset(startColumn, context);
            if (startOffset === -1) {
                return null;
            }
            var endOffset = this._readPixelOffset(endColumn, context);
            if (endOffset === -1) {
                return null;
            }
            return [new __WEBPACK_IMPORTED_MODULE_6__common_view_renderingContext_js__["a" /* HorizontalRange */](startOffset, endOffset - startOffset)];
        }
        return this._readVisibleRangesForRange(startColumn, endColumn, context);
    };
    RenderedViewLine.prototype._readVisibleRangesForRange = function (startColumn, endColumn, context) {
        if (startColumn === endColumn) {
            var pixelOffset = this._readPixelOffset(startColumn, context);
            if (pixelOffset === -1) {
                return null;
            }
            else {
                return [new __WEBPACK_IMPORTED_MODULE_6__common_view_renderingContext_js__["a" /* HorizontalRange */](pixelOffset, 0)];
            }
        }
        else {
            return this._readRawVisibleRangesForRange(startColumn, endColumn, context);
        }
    };
    RenderedViewLine.prototype._readPixelOffset = function (column, context) {
        if (this._characterMapping.length === 0) {
            // This line has no content
            if (this._containsForeignElements === 0 /* None */) {
                // We can assume the line is really empty
                return 0;
            }
            if (this._containsForeignElements === 2 /* After */) {
                // We have foreign elements after the (empty) line
                return 0;
            }
            if (this._containsForeignElements === 1 /* Before */) {
                // We have foreign element before the (empty) line
                return this.getWidth();
            }
        }
        if (this._pixelOffsetCache !== null) {
            // the text is LTR
            var cachedPixelOffset = this._pixelOffsetCache[column];
            if (cachedPixelOffset !== -1) {
                return cachedPixelOffset;
            }
            var result = this._actualReadPixelOffset(column, context);
            this._pixelOffsetCache[column] = result;
            return result;
        }
        return this._actualReadPixelOffset(column, context);
    };
    RenderedViewLine.prototype._actualReadPixelOffset = function (column, context) {
        if (this._characterMapping.length === 0) {
            // This line has no content
            var r_1 = __WEBPACK_IMPORTED_MODULE_5__rangeUtil_js__["a" /* RangeUtil */].readHorizontalRanges(this._getReadingTarget(), 0, 0, 0, 0, context.clientRectDeltaLeft, context.endNode);
            if (!r_1 || r_1.length === 0) {
                return -1;
            }
            return r_1[0].left;
        }
        if (column === this._characterMapping.length && this._isWhitespaceOnly && this._containsForeignElements === 0 /* None */) {
            // This branch helps in the case of whitespace only lines which have a width set
            return this.getWidth();
        }
        var partData = this._characterMapping.charOffsetToPartData(column - 1);
        var partIndex = __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["a" /* CharacterMapping */].getPartIndex(partData);
        var charOffsetInPart = __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["a" /* CharacterMapping */].getCharIndex(partData);
        var r = __WEBPACK_IMPORTED_MODULE_5__rangeUtil_js__["a" /* RangeUtil */].readHorizontalRanges(this._getReadingTarget(), partIndex, charOffsetInPart, partIndex, charOffsetInPart, context.clientRectDeltaLeft, context.endNode);
        if (!r || r.length === 0) {
            return -1;
        }
        return r[0].left;
    };
    RenderedViewLine.prototype._readRawVisibleRangesForRange = function (startColumn, endColumn, context) {
        if (startColumn === 1 && endColumn === this._characterMapping.length) {
            // This branch helps IE with bidi text & gives a performance boost to other browsers when reading visible ranges for an entire line
            return [new __WEBPACK_IMPORTED_MODULE_6__common_view_renderingContext_js__["a" /* HorizontalRange */](0, this.getWidth())];
        }
        var startPartData = this._characterMapping.charOffsetToPartData(startColumn - 1);
        var startPartIndex = __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["a" /* CharacterMapping */].getPartIndex(startPartData);
        var startCharOffsetInPart = __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["a" /* CharacterMapping */].getCharIndex(startPartData);
        var endPartData = this._characterMapping.charOffsetToPartData(endColumn - 1);
        var endPartIndex = __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["a" /* CharacterMapping */].getPartIndex(endPartData);
        var endCharOffsetInPart = __WEBPACK_IMPORTED_MODULE_4__common_viewLayout_viewLineRenderer_js__["a" /* CharacterMapping */].getCharIndex(endPartData);
        return __WEBPACK_IMPORTED_MODULE_5__rangeUtil_js__["a" /* RangeUtil */].readHorizontalRanges(this._getReadingTarget(), startPartIndex, startCharOffsetInPart, endPartIndex, endCharOffsetInPart, context.clientRectDeltaLeft, context.endNode);
    };
    /**
     * Returns the column for the text found at a specific offset inside a rendered dom node
     */
    RenderedViewLine.prototype.getColumnOfNodeOffset = function (lineNumber, spanNode, offset) {
        var spanNodeTextContentLength = spanNode.textContent.length;
        var spanIndex = -1;
        while (spanNode) {
            spanNode = spanNode.previousSibling;
            spanIndex++;
        }
        var charOffset = this._characterMapping.partDataToCharOffset(spanIndex, spanNodeTextContentLength, offset);
        return charOffset + 1;
    };
    return RenderedViewLine;
}());
var WebKitRenderedViewLine = /** @class */ (function (_super) {
    __extends(WebKitRenderedViewLine, _super);
    function WebKitRenderedViewLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebKitRenderedViewLine.prototype._readVisibleRangesForRange = function (startColumn, endColumn, context) {
        var output = _super.prototype._readVisibleRangesForRange.call(this, startColumn, endColumn, context);
        if (!output || output.length === 0 || startColumn === endColumn || (startColumn === 1 && endColumn === this._characterMapping.length)) {
            return output;
        }
        // WebKit is buggy and returns an expanded range (to contain words in some cases)
        // The last client rect is enlarged (I think)
        // This is an attempt to patch things up
        // Find position of previous column
        var beforeEndPixelOffset = this._readPixelOffset(endColumn - 1, context);
        // Find position of last column
        var endPixelOffset = this._readPixelOffset(endColumn, context);
        if (beforeEndPixelOffset !== -1 && endPixelOffset !== -1) {
            var isLTR = (beforeEndPixelOffset <= endPixelOffset);
            var lastRange = output[output.length - 1];
            if (isLTR && lastRange.left < endPixelOffset) {
                // Trim down the width of the last visible range to not go after the last column's position
                lastRange.width = endPixelOffset - lastRange.left;
            }
        }
        return output;
    };
    return WebKitRenderedViewLine;
}(RenderedViewLine));
var createRenderedLine = (function () {
    if (__WEBPACK_IMPORTED_MODULE_0__base_browser_browser_js__["n" /* isWebKit */]) {
        return createWebKitRenderedLine;
    }
    return createNormalRenderedLine;
})();
function createWebKitRenderedLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements) {
    return new WebKitRenderedViewLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements);
}
function createNormalRenderedLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements) {
    return new RenderedViewLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements);
}


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorZone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverviewRulerZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OverviewZoneManager; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var ColorZone = /** @class */ (function () {
    function ColorZone(from, to, colorId) {
        this.from = from | 0;
        this.to = to | 0;
        this.colorId = colorId | 0;
    }
    ColorZone.compare = function (a, b) {
        if (a.colorId === b.colorId) {
            if (a.from === b.from) {
                return a.to - b.to;
            }
            return a.from - b.from;
        }
        return a.colorId - b.colorId;
    };
    return ColorZone;
}());

/**
 * A zone in the overview ruler
 */
var OverviewRulerZone = /** @class */ (function () {
    function OverviewRulerZone(startLineNumber, endLineNumber, color) {
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
        this.color = color;
        this._colorZone = null;
    }
    OverviewRulerZone.compare = function (a, b) {
        if (a.color === b.color) {
            if (a.startLineNumber === b.startLineNumber) {
                return a.endLineNumber - b.endLineNumber;
            }
            return a.startLineNumber - b.startLineNumber;
        }
        return a.color < b.color ? -1 : 1;
    };
    OverviewRulerZone.prototype.setColorZone = function (colorZone) {
        this._colorZone = colorZone;
    };
    OverviewRulerZone.prototype.getColorZones = function () {
        return this._colorZone;
    };
    return OverviewRulerZone;
}());

var OverviewZoneManager = /** @class */ (function () {
    function OverviewZoneManager(getVerticalOffsetForLine) {
        this._getVerticalOffsetForLine = getVerticalOffsetForLine;
        this._zones = [];
        this._colorZonesInvalid = false;
        this._lineHeight = 0;
        this._domWidth = 0;
        this._domHeight = 0;
        this._outerHeight = 0;
        this._pixelRatio = 1;
        this._lastAssignedId = 0;
        this._color2Id = Object.create(null);
        this._id2Color = [];
    }
    OverviewZoneManager.prototype.getId2Color = function () {
        return this._id2Color;
    };
    OverviewZoneManager.prototype.setZones = function (newZones) {
        this._zones = newZones;
        this._zones.sort(OverviewRulerZone.compare);
    };
    OverviewZoneManager.prototype.setLineHeight = function (lineHeight) {
        if (this._lineHeight === lineHeight) {
            return false;
        }
        this._lineHeight = lineHeight;
        this._colorZonesInvalid = true;
        return true;
    };
    OverviewZoneManager.prototype.setPixelRatio = function (pixelRatio) {
        this._pixelRatio = pixelRatio;
        this._colorZonesInvalid = true;
    };
    OverviewZoneManager.prototype.getDOMWidth = function () {
        return this._domWidth;
    };
    OverviewZoneManager.prototype.getCanvasWidth = function () {
        return this._domWidth * this._pixelRatio;
    };
    OverviewZoneManager.prototype.setDOMWidth = function (width) {
        if (this._domWidth === width) {
            return false;
        }
        this._domWidth = width;
        this._colorZonesInvalid = true;
        return true;
    };
    OverviewZoneManager.prototype.getDOMHeight = function () {
        return this._domHeight;
    };
    OverviewZoneManager.prototype.getCanvasHeight = function () {
        return this._domHeight * this._pixelRatio;
    };
    OverviewZoneManager.prototype.setDOMHeight = function (height) {
        if (this._domHeight === height) {
            return false;
        }
        this._domHeight = height;
        this._colorZonesInvalid = true;
        return true;
    };
    OverviewZoneManager.prototype.getOuterHeight = function () {
        return this._outerHeight;
    };
    OverviewZoneManager.prototype.setOuterHeight = function (outerHeight) {
        if (this._outerHeight === outerHeight) {
            return false;
        }
        this._outerHeight = outerHeight;
        this._colorZonesInvalid = true;
        return true;
    };
    OverviewZoneManager.prototype.resolveColorZones = function () {
        var colorZonesInvalid = this._colorZonesInvalid;
        var lineHeight = Math.floor(this._lineHeight); // @perf
        var totalHeight = Math.floor(this.getCanvasHeight()); // @perf
        var outerHeight = Math.floor(this._outerHeight); // @perf
        var heightRatio = totalHeight / outerHeight;
        var halfMinimumHeight = Math.floor(4 /* MINIMUM_HEIGHT */ * this._pixelRatio / 2);
        var allColorZones = [];
        for (var i = 0, len = this._zones.length; i < len; i++) {
            var zone = this._zones[i];
            if (!colorZonesInvalid) {
                var colorZone_1 = zone.getColorZones();
                if (colorZone_1) {
                    allColorZones.push(colorZone_1);
                    continue;
                }
            }
            var y1 = Math.floor(heightRatio * (this._getVerticalOffsetForLine(zone.startLineNumber)));
            var y2 = Math.floor(heightRatio * (this._getVerticalOffsetForLine(zone.endLineNumber) + lineHeight));
            var ycenter = Math.floor((y1 + y2) / 2);
            var halfHeight = (y2 - ycenter);
            if (halfHeight < halfMinimumHeight) {
                halfHeight = halfMinimumHeight;
            }
            if (ycenter - halfHeight < 0) {
                ycenter = halfHeight;
            }
            if (ycenter + halfHeight > totalHeight) {
                ycenter = totalHeight - halfHeight;
            }
            var color = zone.color;
            var colorId = this._color2Id[color];
            if (!colorId) {
                colorId = (++this._lastAssignedId);
                this._color2Id[color] = colorId;
                this._id2Color[colorId] = color;
            }
            var colorZone = new ColorZone(ycenter - halfHeight, ycenter + halfHeight, colorId);
            zone.setColorZone(colorZone);
            allColorZones.push(colorZone);
        }
        this._colorZonesInvalid = false;
        allColorZones.sort(ColorZone.compare);
        return allColorZones;
    };
    return OverviewZoneManager;
}());



/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractScrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalMouseMoveMonitor_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scrollbarArrow_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scrollbarVisibilityController_js__ = __webpack_require__(444);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * The orthogonal distance to the slider at which dragging "resets". This implements "snapping"
 */
var MOUSE_DRAG_RESET_DISTANCE = 140;
var AbstractScrollbar = /** @class */ (function (_super) {
    __extends(AbstractScrollbar, _super);
    function AbstractScrollbar(opts) {
        var _this = _super.call(this) || this;
        _this._lazyRender = opts.lazyRender;
        _this._host = opts.host;
        _this._scrollable = opts.scrollable;
        _this._scrollbarState = opts.scrollbarState;
        _this._visibilityController = _this._register(new __WEBPACK_IMPORTED_MODULE_6__scrollbarVisibilityController_js__["a" /* ScrollbarVisibilityController */](opts.visibility, 'visible scrollbar ' + opts.extraScrollbarClassName, 'invisible scrollbar ' + opts.extraScrollbarClassName));
        _this._mouseMoveMonitor = _this._register(new __WEBPACK_IMPORTED_MODULE_2__globalMouseMoveMonitor_js__["a" /* GlobalMouseMoveMonitor */]());
        _this._shouldRender = true;
        _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_4__fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.domNode.setAttribute('role', 'presentation');
        _this.domNode.setAttribute('aria-hidden', 'true');
        _this._visibilityController.setDomNode(_this.domNode);
        _this.domNode.setPosition('absolute');
        _this.onmousedown(_this.domNode.domNode, function (e) { return _this._domNodeMouseDown(e); });
        return _this;
    }
    // ----------------- creation
    /**
     * Creates the dom node for an arrow & adds it to the container
     */
    AbstractScrollbar.prototype._createArrow = function (opts) {
        var arrow = this._register(new __WEBPACK_IMPORTED_MODULE_5__scrollbarArrow_js__["b" /* ScrollbarArrow */](opts));
        this.domNode.domNode.appendChild(arrow.bgDomNode);
        this.domNode.domNode.appendChild(arrow.domNode);
    };
    /**
     * Creates the slider dom node, adds it to the container & hooks up the events
     */
    AbstractScrollbar.prototype._createSlider = function (top, left, width, height) {
        var _this = this;
        this.slider = Object(__WEBPACK_IMPORTED_MODULE_4__fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        this.slider.setClassName('slider');
        this.slider.setPosition('absolute');
        this.slider.setTop(top);
        this.slider.setLeft(left);
        this.slider.setWidth(width);
        this.slider.setHeight(height);
        this.slider.setLayerHinting(true);
        this.domNode.domNode.appendChild(this.slider.domNode);
        this.onmousedown(this.slider.domNode, function (e) {
            if (e.leftButton) {
                e.preventDefault();
                _this._sliderMouseDown(e, function () { });
            }
        });
    };
    // ----------------- Update state
    AbstractScrollbar.prototype._onElementSize = function (visibleSize) {
        if (this._scrollbarState.setVisibleSize(visibleSize)) {
            this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
            this._shouldRender = true;
            if (!this._lazyRender) {
                this.render();
            }
        }
        return this._shouldRender;
    };
    AbstractScrollbar.prototype._onElementScrollSize = function (elementScrollSize) {
        if (this._scrollbarState.setScrollSize(elementScrollSize)) {
            this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
            this._shouldRender = true;
            if (!this._lazyRender) {
                this.render();
            }
        }
        return this._shouldRender;
    };
    AbstractScrollbar.prototype._onElementScrollPosition = function (elementScrollPosition) {
        if (this._scrollbarState.setScrollPosition(elementScrollPosition)) {
            this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
            this._shouldRender = true;
            if (!this._lazyRender) {
                this.render();
            }
        }
        return this._shouldRender;
    };
    // ----------------- rendering
    AbstractScrollbar.prototype.beginReveal = function () {
        this._visibilityController.setShouldBeVisible(true);
    };
    AbstractScrollbar.prototype.beginHide = function () {
        this._visibilityController.setShouldBeVisible(false);
    };
    AbstractScrollbar.prototype.render = function () {
        if (!this._shouldRender) {
            return;
        }
        this._shouldRender = false;
        this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize());
        this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition());
    };
    // ----------------- DOM events
    AbstractScrollbar.prototype._domNodeMouseDown = function (e) {
        if (e.target !== this.domNode.domNode) {
            return;
        }
        this._onMouseDown(e);
    };
    AbstractScrollbar.prototype.delegateMouseDown = function (e) {
        var domTop = this.domNode.domNode.getClientRects()[0].top;
        var sliderStart = domTop + this._scrollbarState.getSliderPosition();
        var sliderStop = domTop + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize();
        var mousePos = this._sliderMousePosition(e);
        if (sliderStart <= mousePos && mousePos <= sliderStop) {
            // Act as if it was a mouse down on the slider
            if (e.leftButton) {
                e.preventDefault();
                this._sliderMouseDown(e, function () { });
            }
        }
        else {
            // Act as if it was a mouse down on the scrollbar
            this._onMouseDown(e);
        }
    };
    AbstractScrollbar.prototype._onMouseDown = function (e) {
        var offsetX;
        var offsetY;
        if (e.target === this.domNode.domNode && typeof e.browserEvent.offsetX === 'number' && typeof e.browserEvent.offsetY === 'number') {
            offsetX = e.browserEvent.offsetX;
            offsetY = e.browserEvent.offsetY;
        }
        else {
            var domNodePosition = __WEBPACK_IMPORTED_MODULE_1__dom_js__["u" /* getDomNodePagePosition */](this.domNode.domNode);
            offsetX = e.posx - domNodePosition.left;
            offsetY = e.posy - domNodePosition.top;
        }
        this._setDesiredScrollPositionNow(this._scrollbarState.getDesiredScrollPositionFromOffset(this._mouseDownRelativePosition(offsetX, offsetY)));
        if (e.leftButton) {
            e.preventDefault();
            this._sliderMouseDown(e, function () { });
        }
    };
    AbstractScrollbar.prototype._sliderMouseDown = function (e, onDragFinished) {
        var _this = this;
        var initialMousePosition = this._sliderMousePosition(e);
        var initialMouseOrthogonalPosition = this._sliderOrthogonalMousePosition(e);
        var initialScrollbarState = this._scrollbarState.clone();
        this.slider.toggleClassName('active', true);
        this._mouseMoveMonitor.startMonitoring(__WEBPACK_IMPORTED_MODULE_2__globalMouseMoveMonitor_js__["b" /* standardMouseMoveMerger */], function (mouseMoveData) {
            var mouseOrthogonalPosition = _this._sliderOrthogonalMousePosition(mouseMoveData);
            var mouseOrthogonalDelta = Math.abs(mouseOrthogonalPosition - initialMouseOrthogonalPosition);
            if (__WEBPACK_IMPORTED_MODULE_0__common_platform_js__["g" /* isWindows */] && mouseOrthogonalDelta > MOUSE_DRAG_RESET_DISTANCE) {
                // The mouse has wondered away from the scrollbar => reset dragging
                _this._setDesiredScrollPositionNow(initialScrollbarState.getScrollPosition());
                return;
            }
            var mousePosition = _this._sliderMousePosition(mouseMoveData);
            var mouseDelta = mousePosition - initialMousePosition;
            _this._setDesiredScrollPositionNow(initialScrollbarState.getDesiredScrollPositionFromDelta(mouseDelta));
        }, function () {
            _this.slider.toggleClassName('active', false);
            _this._host.onDragEnd();
            onDragFinished();
        });
        this._host.onDragStart();
    };
    AbstractScrollbar.prototype._setDesiredScrollPositionNow = function (_desiredScrollPosition) {
        var desiredScrollPosition = {};
        this.writeScrollPosition(desiredScrollPosition, _desiredScrollPosition);
        this._scrollable.setScrollPositionNow(desiredScrollPosition);
    };
    return AbstractScrollbar;
}(__WEBPACK_IMPORTED_MODULE_3__widget_js__["a" /* Widget */]));



/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarState; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * The minimal size of the slider (such that it can still be clickable) -- it is artificially enlarged.
 */
var MINIMUM_SLIDER_SIZE = 20;
var ScrollbarState = /** @class */ (function () {
    function ScrollbarState(arrowSize, scrollbarSize, oppositeScrollbarSize) {
        this._scrollbarSize = Math.round(scrollbarSize);
        this._oppositeScrollbarSize = Math.round(oppositeScrollbarSize);
        this._arrowSize = Math.round(arrowSize);
        this._visibleSize = 0;
        this._scrollSize = 0;
        this._scrollPosition = 0;
        this._computedAvailableSize = 0;
        this._computedIsNeeded = false;
        this._computedSliderSize = 0;
        this._computedSliderRatio = 0;
        this._computedSliderPosition = 0;
        this._refreshComputedValues();
    }
    ScrollbarState.prototype.clone = function () {
        var r = new ScrollbarState(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize);
        r.setVisibleSize(this._visibleSize);
        r.setScrollSize(this._scrollSize);
        r.setScrollPosition(this._scrollPosition);
        return r;
    };
    ScrollbarState.prototype.setVisibleSize = function (visibleSize) {
        var iVisibleSize = Math.round(visibleSize);
        if (this._visibleSize !== iVisibleSize) {
            this._visibleSize = iVisibleSize;
            this._refreshComputedValues();
            return true;
        }
        return false;
    };
    ScrollbarState.prototype.setScrollSize = function (scrollSize) {
        var iScrollSize = Math.round(scrollSize);
        if (this._scrollSize !== iScrollSize) {
            this._scrollSize = iScrollSize;
            this._refreshComputedValues();
            return true;
        }
        return false;
    };
    ScrollbarState.prototype.setScrollPosition = function (scrollPosition) {
        var iScrollPosition = Math.round(scrollPosition);
        if (this._scrollPosition !== iScrollPosition) {
            this._scrollPosition = iScrollPosition;
            this._refreshComputedValues();
            return true;
        }
        return false;
    };
    ScrollbarState._computeValues = function (oppositeScrollbarSize, arrowSize, visibleSize, scrollSize, scrollPosition) {
        var computedAvailableSize = Math.max(0, visibleSize - oppositeScrollbarSize);
        var computedRepresentableSize = Math.max(0, computedAvailableSize - 2 * arrowSize);
        var computedIsNeeded = (scrollSize > 0 && scrollSize > visibleSize);
        if (!computedIsNeeded) {
            // There is no need for a slider
            return {
                computedAvailableSize: Math.round(computedAvailableSize),
                computedIsNeeded: computedIsNeeded,
                computedSliderSize: Math.round(computedRepresentableSize),
                computedSliderRatio: 0,
                computedSliderPosition: 0,
            };
        }
        // We must artificially increase the size of the slider if needed, since the slider would be too small to grab with the mouse otherwise
        var computedSliderSize = Math.round(Math.max(MINIMUM_SLIDER_SIZE, Math.floor(visibleSize * computedRepresentableSize / scrollSize)));
        // The slider can move from 0 to `computedRepresentableSize` - `computedSliderSize`
        // in the same way `scrollPosition` can move from 0 to `scrollSize` - `visibleSize`.
        var computedSliderRatio = (computedRepresentableSize - computedSliderSize) / (scrollSize - visibleSize);
        var computedSliderPosition = (scrollPosition * computedSliderRatio);
        return {
            computedAvailableSize: Math.round(computedAvailableSize),
            computedIsNeeded: computedIsNeeded,
            computedSliderSize: Math.round(computedSliderSize),
            computedSliderRatio: computedSliderRatio,
            computedSliderPosition: Math.round(computedSliderPosition),
        };
    };
    ScrollbarState.prototype._refreshComputedValues = function () {
        var r = ScrollbarState._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
        this._computedAvailableSize = r.computedAvailableSize;
        this._computedIsNeeded = r.computedIsNeeded;
        this._computedSliderSize = r.computedSliderSize;
        this._computedSliderRatio = r.computedSliderRatio;
        this._computedSliderPosition = r.computedSliderPosition;
    };
    ScrollbarState.prototype.getArrowSize = function () {
        return this._arrowSize;
    };
    ScrollbarState.prototype.getScrollPosition = function () {
        return this._scrollPosition;
    };
    ScrollbarState.prototype.getRectangleLargeSize = function () {
        return this._computedAvailableSize;
    };
    ScrollbarState.prototype.getRectangleSmallSize = function () {
        return this._scrollbarSize;
    };
    ScrollbarState.prototype.isNeeded = function () {
        return this._computedIsNeeded;
    };
    ScrollbarState.prototype.getSliderSize = function () {
        return this._computedSliderSize;
    };
    ScrollbarState.prototype.getSliderPosition = function () {
        return this._computedSliderPosition;
    };
    /**
     * Compute a desired `scrollPosition` such that `offset` ends up in the center of the slider.
     * `offset` is based on the same coordinate system as the `sliderPosition`.
     */
    ScrollbarState.prototype.getDesiredScrollPositionFromOffset = function (offset) {
        if (!this._computedIsNeeded) {
            // no need for a slider
            return 0;
        }
        var desiredSliderPosition = offset - this._arrowSize - this._computedSliderSize / 2;
        return Math.round(desiredSliderPosition / this._computedSliderRatio);
    };
    /**
     * Compute a desired `scrollPosition` such that the slider moves by `delta`.
     */
    ScrollbarState.prototype.getDesiredScrollPositionFromDelta = function (delta) {
        if (!this._computedIsNeeded) {
            // no need for a slider
            return 0;
        }
        var desiredSliderPosition = this._computedSliderPosition + delta;
        return Math.round(desiredSliderPosition / this._computedSliderRatio);
    };
    return ScrollbarState;
}());



/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InternalEditorAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__ = __webpack_require__(8);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var InternalEditorAction = /** @class */ (function () {
    function InternalEditorAction(id, label, alias, precondition, run, contextKeyService) {
        this.id = id;
        this.label = label;
        this.alias = alias;
        this._precondition = precondition;
        this._run = run;
        this._contextKeyService = contextKeyService;
    }
    InternalEditorAction.prototype.isSupported = function () {
        return this._contextKeyService.contextMatchesRules(this._precondition);
    };
    InternalEditorAction.prototype.run = function () {
        if (!this.isSupported()) {
            return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(void 0);
        }
        var r = this._run();
        return r ? r : __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(void 0);
    };
    return InternalEditorAction;
}());



/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ViewZoneDelegate */
/* unused harmony export OverlayWidgetDelegate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZoneWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zoneWidget_css__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zoneWidget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zoneWidget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_sash_sash_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_idGenerator_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/











var defaultColor = new __WEBPACK_IMPORTED_MODULE_6__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_6__base_common_color_js__["c" /* RGBA */](0, 122, 204));
var defaultOptions = {
    showArrow: true,
    showFrame: true,
    className: '',
    frameColor: defaultColor,
    arrowColor: defaultColor,
    keepEditorSelection: false
};
var WIDGET_ID = 'vs.editor.contrib.zoneWidget';
var ViewZoneDelegate = /** @class */ (function () {
    function ViewZoneDelegate(domNode, afterLineNumber, afterColumn, heightInLines, onDomNodeTop, onComputedHeight) {
        this.domNode = domNode;
        this.afterLineNumber = afterLineNumber;
        this.afterColumn = afterColumn;
        this.heightInLines = heightInLines;
        this._onDomNodeTop = onDomNodeTop;
        this._onComputedHeight = onComputedHeight;
    }
    ViewZoneDelegate.prototype.onDomNodeTop = function (top) {
        this._onDomNodeTop(top);
    };
    ViewZoneDelegate.prototype.onComputedHeight = function (height) {
        this._onComputedHeight(height);
    };
    return ViewZoneDelegate;
}());

var OverlayWidgetDelegate = /** @class */ (function () {
    function OverlayWidgetDelegate(id, domNode) {
        this._id = id;
        this._domNode = domNode;
    }
    OverlayWidgetDelegate.prototype.getId = function () {
        return this._id;
    };
    OverlayWidgetDelegate.prototype.getDomNode = function () {
        return this._domNode;
    };
    OverlayWidgetDelegate.prototype.getPosition = function () {
        return null;
    };
    return OverlayWidgetDelegate;
}());

var Arrow = /** @class */ (function () {
    function Arrow(_editor) {
        this._editor = _editor;
        this._ruleName = Arrow._IdGenerator.nextId();
        this._decorations = [];
        //
    }
    Arrow.prototype.dispose = function () {
        this.hide();
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["F" /* removeCSSRulesContainingSelector */](this._ruleName);
    };
    Object.defineProperty(Arrow.prototype, "color", {
        set: function (value) {
            if (this._color !== value) {
                this._color = value;
                this._updateStyle();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Arrow.prototype, "height", {
        set: function (value) {
            if (this._height !== value) {
                this._height = value;
                this._updateStyle();
            }
        },
        enumerable: true,
        configurable: true
    });
    Arrow.prototype._updateStyle = function () {
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["F" /* removeCSSRulesContainingSelector */](this._ruleName);
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["n" /* createCSSRule */](".monaco-editor " + this._ruleName, "border-style: solid; border-color: transparent; border-bottom-color: " + this._color + "; border-width: " + this._height + "px; bottom: -" + this._height + "px; margin-left: -" + this._height + "px; ");
    };
    Arrow.prototype.show = function (where) {
        this._decorations = this._editor.deltaDecorations(this._decorations, [{ range: __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].fromPositions(where), options: { className: this._ruleName, stickiness: __WEBPACK_IMPORTED_MODULE_9__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges } }]);
    };
    Arrow.prototype.hide = function () {
        this._editor.deltaDecorations(this._decorations, []);
    };
    Arrow._IdGenerator = new __WEBPACK_IMPORTED_MODULE_8__base_common_idGenerator_js__["a" /* IdGenerator */]('.arrow-decoration-');
    return Arrow;
}());
var ZoneWidget = /** @class */ (function () {
    function ZoneWidget(editor, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this._positionMarkerId = [];
        this._disposables = [];
        this._isShowing = false;
        this.editor = editor;
        this.options = __WEBPACK_IMPORTED_MODULE_2__base_common_objects_js__["c" /* deepClone */](options);
        __WEBPACK_IMPORTED_MODULE_2__base_common_objects_js__["g" /* mixin */](this.options, defaultOptions, false);
        this.domNode = document.createElement('div');
        if (!this.options.isAccessible) {
            this.domNode.setAttribute('aria-hidden', 'true');
            this.domNode.setAttribute('role', 'presentation');
        }
        this._disposables.push(this.editor.onDidLayoutChange(function (info) {
            var width = _this._getWidth(info);
            _this.domNode.style.width = width + 'px';
            _this.domNode.style.left = _this._getLeft(info) + 'px';
            _this._onWidth(width);
        }));
    }
    ZoneWidget.prototype.dispose = function () {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        if (this._overlayWidget) {
            this.editor.removeOverlayWidget(this._overlayWidget);
            this._overlayWidget = null;
        }
        if (this._viewZone) {
            this.editor.changeViewZones(function (accessor) {
                accessor.removeZone(_this._viewZone.id);
                _this._viewZone = null;
            });
        }
        this.editor.deltaDecorations(this._positionMarkerId, []);
        this._positionMarkerId = [];
    };
    ZoneWidget.prototype.create = function () {
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this.domNode, 'zone-widget');
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this.domNode, this.options.className);
        this.container = document.createElement('div');
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this.container, 'zone-widget-container');
        this.domNode.appendChild(this.container);
        if (this.options.showArrow) {
            this._arrow = new Arrow(this.editor);
            this._disposables.push(this._arrow);
        }
        this._fillContainer(this.container);
        this._initSash();
        this._applyStyles();
    };
    ZoneWidget.prototype.style = function (styles) {
        if (styles.frameColor) {
            this.options.frameColor = styles.frameColor;
        }
        if (styles.arrowColor) {
            this.options.arrowColor = styles.arrowColor;
        }
        this._applyStyles();
    };
    ZoneWidget.prototype._applyStyles = function () {
        if (this.container) {
            var frameColor = this.options.frameColor.toString();
            this.container.style.borderTopColor = frameColor;
            this.container.style.borderBottomColor = frameColor;
        }
        if (this._arrow) {
            var arrowColor = this.options.arrowColor.toString();
            this._arrow.color = arrowColor;
        }
    };
    ZoneWidget.prototype._getWidth = function (info) {
        return info.width - info.minimapWidth - info.verticalScrollbarWidth;
    };
    ZoneWidget.prototype._getLeft = function (info) {
        // If minimap is to the left, we move beyond it
        if (info.minimapWidth > 0 && info.minimapLeft === 0) {
            return info.minimapWidth;
        }
        return 0;
    };
    ZoneWidget.prototype._onViewZoneTop = function (top) {
        this.domNode.style.top = top + 'px';
    };
    ZoneWidget.prototype._onViewZoneHeight = function (height) {
        this.domNode.style.height = height + "px";
        var containerHeight = height - this._decoratingElementsHeight();
        this.container.style.height = containerHeight + "px";
        var layoutInfo = this.editor.getLayoutInfo();
        this._doLayout(containerHeight, this._getWidth(layoutInfo));
        this._resizeSash.layout();
    };
    Object.defineProperty(ZoneWidget.prototype, "position", {
        get: function () {
            var id = this._positionMarkerId[0];
            if (!id) {
                return undefined;
            }
            var range = this.editor.getModel().getDecorationRange(id);
            if (!range) {
                return undefined;
            }
            return range.getStartPosition();
        },
        enumerable: true,
        configurable: true
    });
    ZoneWidget.prototype.show = function (rangeOrPos, heightInLines) {
        var range = __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].isIRange(rangeOrPos)
            ? rangeOrPos
            : new __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */](rangeOrPos.lineNumber, rangeOrPos.column, rangeOrPos.lineNumber, rangeOrPos.column);
        this._isShowing = true;
        this._showImpl(range, heightInLines);
        this._isShowing = false;
        this._positionMarkerId = this.editor.deltaDecorations(this._positionMarkerId, [{ range: range, options: __WEBPACK_IMPORTED_MODULE_7__common_model_textModel_js__["a" /* ModelDecorationOptions */].EMPTY }]);
    };
    ZoneWidget.prototype.hide = function () {
        var _this = this;
        if (this._viewZone) {
            this.editor.changeViewZones(function (accessor) {
                accessor.removeZone(_this._viewZone.id);
            });
            this._viewZone = null;
        }
        if (this._overlayWidget) {
            this.editor.removeOverlayWidget(this._overlayWidget);
            this._overlayWidget = null;
        }
        if (this._arrow) {
            this._arrow.hide();
        }
    };
    ZoneWidget.prototype._decoratingElementsHeight = function () {
        var lineHeight = this.editor.getConfiguration().lineHeight;
        var result = 0;
        if (this.options.showArrow) {
            var arrowHeight = Math.round(lineHeight / 3);
            result += 2 * arrowHeight;
        }
        if (this.options.showFrame) {
            var frameThickness = Math.round(lineHeight / 9);
            result += 2 * frameThickness;
        }
        return result;
    };
    ZoneWidget.prototype._showImpl = function (where, heightInLines) {
        var _this = this;
        var position = {
            lineNumber: where.startLineNumber,
            column: where.startColumn
        };
        var layoutInfo = this.editor.getLayoutInfo();
        var width = this._getWidth(layoutInfo);
        this.domNode.style.width = width + "px";
        this.domNode.style.left = this._getLeft(layoutInfo) + 'px';
        // Render the widget as zone (rendering) and widget (lifecycle)
        var viewZoneDomNode = document.createElement('div');
        viewZoneDomNode.style.overflow = 'hidden';
        var lineHeight = this.editor.getConfiguration().lineHeight;
        // adjust heightInLines to viewport
        var maxHeightInLines = (this.editor.getLayoutInfo().height / lineHeight) * .8;
        if (heightInLines >= maxHeightInLines) {
            heightInLines = maxHeightInLines;
        }
        var arrowHeight = 0;
        var frameThickness = 0;
        // Render the arrow one 1/3 of an editor line height
        if (this.options.showArrow) {
            arrowHeight = Math.round(lineHeight / 3);
            this._arrow.height = arrowHeight;
            this._arrow.show(position);
        }
        // Render the frame as 1/9 of an editor line height
        if (this.options.showFrame) {
            frameThickness = Math.round(lineHeight / 9);
        }
        // insert zone widget
        this.editor.changeViewZones(function (accessor) {
            if (_this._viewZone) {
                accessor.removeZone(_this._viewZone.id);
            }
            if (_this._overlayWidget) {
                _this.editor.removeOverlayWidget(_this._overlayWidget);
                _this._overlayWidget = null;
            }
            _this.domNode.style.top = '-1000px';
            _this._viewZone = new ViewZoneDelegate(viewZoneDomNode, position.lineNumber, position.column, heightInLines, function (top) { return _this._onViewZoneTop(top); }, function (height) { return _this._onViewZoneHeight(height); });
            _this._viewZone.id = accessor.addZone(_this._viewZone);
            _this._overlayWidget = new OverlayWidgetDelegate(WIDGET_ID + _this._viewZone.id, _this.domNode);
            _this.editor.addOverlayWidget(_this._overlayWidget);
        });
        if (this.options.showFrame) {
            var width_1 = this.options.frameWidth ? this.options.frameWidth : frameThickness;
            this.container.style.borderTopWidth = width_1 + 'px';
            this.container.style.borderBottomWidth = width_1 + 'px';
        }
        var containerHeight = heightInLines * lineHeight - this._decoratingElementsHeight();
        this.container.style.top = arrowHeight + 'px';
        this.container.style.height = containerHeight + 'px';
        this.container.style.overflow = 'hidden';
        this._doLayout(containerHeight, width);
        if (!this.options.keepEditorSelection) {
            this.editor.setSelection(where);
        }
        // Reveal the line above or below the zone widget, to get the zone widget in the viewport
        var revealLineNumber = Math.min(this.editor.getModel().getLineCount(), Math.max(1, where.endLineNumber + 1));
        this.revealLine(revealLineNumber);
    };
    ZoneWidget.prototype.revealLine = function (lineNumber) {
        this.editor.revealLine(lineNumber, 0 /* Smooth */);
    };
    ZoneWidget.prototype.setCssClass = function (className, classToReplace) {
        if (classToReplace) {
            this.container.classList.remove(classToReplace);
        }
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this.container, className);
    };
    ZoneWidget.prototype._onWidth = function (widthInPixel) {
        // implement in subclass
    };
    ZoneWidget.prototype._doLayout = function (heightInPixel, widthInPixel) {
        // implement in subclass
    };
    ZoneWidget.prototype._relayout = function (newHeightInLines) {
        var _this = this;
        if (this._viewZone.heightInLines !== newHeightInLines) {
            this.editor.changeViewZones(function (accessor) {
                _this._viewZone.heightInLines = newHeightInLines;
                accessor.layoutZone(_this._viewZone.id);
            });
        }
    };
    // --- sash
    ZoneWidget.prototype._initSash = function () {
        var _this = this;
        this._resizeSash = new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_sash_sash_js__["b" /* Sash */](this.domNode, this, { orientation: __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_sash_sash_js__["a" /* Orientation */].HORIZONTAL });
        if (!this.options.isResizeable) {
            this._resizeSash.hide();
            this._resizeSash.state = __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_sash_sash_js__["c" /* SashState */].Disabled;
        }
        var data;
        this._disposables.push(this._resizeSash.onDidStart(function (e) {
            if (_this._viewZone) {
                data = {
                    startY: e.startY,
                    heightInLines: _this._viewZone.heightInLines,
                };
            }
        }));
        this._disposables.push(this._resizeSash.onDidEnd(function () {
            data = undefined;
        }));
        this._disposables.push(this._resizeSash.onDidChange(function (evt) {
            if (data) {
                var lineDelta = (evt.currentY - data.startY) / _this.editor.getConfiguration().lineHeight;
                var roundedLineDelta = lineDelta < 0 ? Math.ceil(lineDelta) : Math.floor(lineDelta);
                var newHeightInLines = data.heightInLines + roundedLineDelta;
                if (newHeightInLines > 5 && newHeightInLines < 35) {
                    _this._relayout(newHeightInLines);
                }
            }
        }));
    };
    ZoneWidget.prototype.getHorizontalSashLeft = function () {
        return 0;
    };
    ZoneWidget.prototype.getHorizontalSashTop = function () {
        return parseInt(this.domNode.style.height) - (this._decoratingElementsHeight() / 2);
    };
    ZoneWidget.prototype.getHorizontalSashWidth = function () {
        var layoutInfo = this.editor.getLayoutInfo();
        return layoutInfo.width - layoutInfo.minimapWidth;
    };
    return ZoneWidget;
}());



/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TreeContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tree; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tree_css__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tree_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tree_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treeDefaults_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__treeModel_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treeView_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_objects_js__ = __webpack_require__(26);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var TreeContext = /** @class */ (function () {
    function TreeContext(tree, configuration, options) {
        if (options === void 0) { options = {}; }
        this.tree = tree;
        this.configuration = configuration;
        this.options = options;
        if (!configuration.dataSource) {
            throw new Error('You must provide a Data Source to the tree.');
        }
        this.dataSource = configuration.dataSource;
        this.renderer = configuration.renderer;
        this.controller = configuration.controller || new __WEBPACK_IMPORTED_MODULE_1__treeDefaults_js__["c" /* DefaultController */]({ clickBehavior: __WEBPACK_IMPORTED_MODULE_1__treeDefaults_js__["a" /* ClickBehavior */].ON_MOUSE_UP, keyboardSupport: typeof options.keyboardSupport !== 'boolean' || options.keyboardSupport });
        this.dnd = configuration.dnd || new __WEBPACK_IMPORTED_MODULE_1__treeDefaults_js__["d" /* DefaultDragAndDrop */]();
        this.filter = configuration.filter || new __WEBPACK_IMPORTED_MODULE_1__treeDefaults_js__["e" /* DefaultFilter */]();
        this.sorter = configuration.sorter || null;
        this.accessibilityProvider = configuration.accessibilityProvider || new __WEBPACK_IMPORTED_MODULE_1__treeDefaults_js__["b" /* DefaultAccessibilityProvider */]();
        this.styler = configuration.styler || null;
    }
    return TreeContext;
}());

var defaultStyles = {
    listFocusBackground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#073655'),
    listActiveSelectionBackground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#0E639C'),
    listActiveSelectionForeground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#FFFFFF'),
    listFocusAndSelectionBackground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#094771'),
    listFocusAndSelectionForeground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#FFFFFF'),
    listInactiveSelectionBackground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#3F3F46'),
    listHoverBackground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#2A2D2E'),
    listDropBackground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#383B3D')
};
var Tree = /** @class */ (function () {
    function Tree(container, configuration, options) {
        if (options === void 0) { options = {}; }
        this._onDidChangeFocus = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidChangeFocus = this._onDidChangeFocus.event;
        this._onDidChangeSelection = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidChangeSelection = this._onDidChangeSelection.event;
        this._onHighlightChange = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this._onDidExpandItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this._onDidCollapseItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this._onDispose = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidDispose = this._onDispose.event;
        this.container = container;
        Object(__WEBPACK_IMPORTED_MODULE_6__common_objects_js__["g" /* mixin */])(options, defaultStyles, false);
        options.twistiePixels = typeof options.twistiePixels === 'number' ? options.twistiePixels : 32;
        options.showTwistie = options.showTwistie === false ? false : true;
        options.indentPixels = typeof options.indentPixels === 'number' ? options.indentPixels : 12;
        options.alwaysFocused = options.alwaysFocused === true ? true : false;
        options.useShadows = options.useShadows === false ? false : true;
        options.paddingOnRow = options.paddingOnRow === false ? false : true;
        options.showLoading = options.showLoading === false ? false : true;
        this.context = new TreeContext(this, configuration, options);
        this.model = new __WEBPACK_IMPORTED_MODULE_2__treeModel_js__["a" /* TreeModel */](this.context);
        this.view = new __WEBPACK_IMPORTED_MODULE_3__treeView_js__["a" /* TreeView */](this.context, this.container);
        this.view.setModel(this.model);
        this._onDidChangeFocus.input = this.model.onDidFocus;
        this._onDidChangeSelection.input = this.model.onDidSelect;
        this._onHighlightChange.input = this.model.onDidHighlight;
        this._onDidExpandItem.input = this.model.onDidExpandItem;
        this._onDidCollapseItem.input = this.model.onDidCollapseItem;
    }
    Tree.prototype.style = function (styles) {
        this.view.applyStyles(styles);
    };
    Object.defineProperty(Tree.prototype, "onDidFocus", {
        get: function () {
            return this.view && this.view.onDOMFocus;
        },
        enumerable: true,
        configurable: true
    });
    Tree.prototype.getHTMLElement = function () {
        return this.view.getHTMLElement();
    };
    Tree.prototype.layout = function (height, width) {
        this.view.layout(height, width);
    };
    Tree.prototype.domFocus = function () {
        this.view.focus();
    };
    Tree.prototype.isDOMFocused = function () {
        return this.view.isFocused();
    };
    Tree.prototype.domBlur = function () {
        this.view.blur();
    };
    Tree.prototype.setInput = function (element) {
        return this.model.setInput(element);
    };
    Tree.prototype.getInput = function () {
        return this.model.getInput();
    };
    Tree.prototype.refresh = function (element, recursive) {
        if (element === void 0) { element = null; }
        if (recursive === void 0) { recursive = true; }
        return this.model.refresh(element, recursive);
    };
    Tree.prototype.expand = function (element) {
        return this.model.expand(element);
    };
    Tree.prototype.collapse = function (element, recursive) {
        if (recursive === void 0) { recursive = false; }
        return this.model.collapse(element, recursive);
    };
    Tree.prototype.toggleExpansion = function (element, recursive) {
        if (recursive === void 0) { recursive = false; }
        return this.model.toggleExpansion(element, recursive);
    };
    Tree.prototype.isExpanded = function (element) {
        return this.model.isExpanded(element);
    };
    Tree.prototype.reveal = function (element, relativeTop) {
        if (relativeTop === void 0) { relativeTop = null; }
        return this.model.reveal(element, relativeTop);
    };
    Tree.prototype.getHighlight = function () {
        return this.model.getHighlight();
    };
    Tree.prototype.clearHighlight = function (eventPayload) {
        this.model.setHighlight(null, eventPayload);
    };
    Tree.prototype.setSelection = function (elements, eventPayload) {
        this.model.setSelection(elements, eventPayload);
    };
    Tree.prototype.getSelection = function () {
        return this.model.getSelection();
    };
    Tree.prototype.clearSelection = function (eventPayload) {
        this.model.setSelection([], eventPayload);
    };
    Tree.prototype.setFocus = function (element, eventPayload) {
        this.model.setFocus(element, eventPayload);
    };
    Tree.prototype.getFocus = function () {
        return this.model.getFocus();
    };
    Tree.prototype.focusNext = function (count, eventPayload) {
        this.model.focusNext(count, eventPayload);
    };
    Tree.prototype.focusPrevious = function (count, eventPayload) {
        this.model.focusPrevious(count, eventPayload);
    };
    Tree.prototype.focusParent = function (eventPayload) {
        this.model.focusParent(eventPayload);
    };
    Tree.prototype.focusFirstChild = function (eventPayload) {
        this.model.focusFirstChild(eventPayload);
    };
    Tree.prototype.focusFirst = function (eventPayload, from) {
        this.model.focusFirst(eventPayload, from);
    };
    Tree.prototype.focusNth = function (index, eventPayload) {
        this.model.focusNth(index, eventPayload);
    };
    Tree.prototype.focusLast = function (eventPayload, from) {
        this.model.focusLast(eventPayload, from);
    };
    Tree.prototype.focusNextPage = function (eventPayload) {
        this.view.focusNextPage(eventPayload);
    };
    Tree.prototype.focusPreviousPage = function (eventPayload) {
        this.view.focusPreviousPage(eventPayload);
    };
    Tree.prototype.clearFocus = function (eventPayload) {
        this.model.setFocus(null, eventPayload);
    };
    Tree.prototype.dispose = function () {
        this._onDispose.fire();
        if (this.model !== null) {
            this.model.dispose();
            this.model = null;
        }
        if (this.view !== null) {
            this.view.dispose();
            this.view = null;
        }
        this._onDidChangeFocus.dispose();
        this._onDidChangeSelection.dispose();
        this._onHighlightChange.dispose();
        this._onDidExpandItem.dispose();
        this._onDidCollapseItem.dispose();
        this._onDispose.dispose();
    };
    return Tree;
}());



/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IUriDisplayService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var URI_DISPLAY_SERVICE_ID = 'uriDisplay';
var IUriDisplayService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])(URI_DISPLAY_SERVICE_ID);


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClickLinkMouseEvent */
/* unused harmony export ClickLinkKeyboardEvent */
/* unused harmony export ClickLinkOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickLinkGesture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goToDefinitionMouse_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goToDefinitionMouse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__goToDefinitionMouse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_platform_js__ = __webpack_require__(14);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





function hasModifier(e, modifier) {
    return !!e[modifier];
}
/**
 * An event that encapsulates the various trigger modifiers logic needed for go to definition.
 */
var ClickLinkMouseEvent = /** @class */ (function () {
    function ClickLinkMouseEvent(source, opts) {
        this.target = source.target;
        this.hasTriggerModifier = hasModifier(source.event, opts.triggerModifier);
        this.hasSideBySideModifier = hasModifier(source.event, opts.triggerSideBySideModifier);
        this.isNoneOrSingleMouseDown = (__WEBPACK_IMPORTED_MODULE_1__base_browser_browser_js__["k" /* isIE */] || source.event.detail <= 1); // IE does not support event.detail properly
    }
    return ClickLinkMouseEvent;
}());

/**
 * An event that encapsulates the various trigger modifiers logic needed for go to definition.
 */
var ClickLinkKeyboardEvent = /** @class */ (function () {
    function ClickLinkKeyboardEvent(source, opts) {
        this.keyCodeIsTriggerKey = (source.keyCode === opts.triggerKey);
        this.keyCodeIsSideBySideKey = (source.keyCode === opts.triggerSideBySideKey);
        this.hasTriggerModifier = hasModifier(source, opts.triggerModifier);
    }
    return ClickLinkKeyboardEvent;
}());

var ClickLinkOptions = /** @class */ (function () {
    function ClickLinkOptions(triggerKey, triggerModifier, triggerSideBySideKey, triggerSideBySideModifier) {
        this.triggerKey = triggerKey;
        this.triggerModifier = triggerModifier;
        this.triggerSideBySideKey = triggerSideBySideKey;
        this.triggerSideBySideModifier = triggerSideBySideModifier;
    }
    ClickLinkOptions.prototype.equals = function (other) {
        return (this.triggerKey === other.triggerKey
            && this.triggerModifier === other.triggerModifier
            && this.triggerSideBySideKey === other.triggerSideBySideKey
            && this.triggerSideBySideModifier === other.triggerSideBySideModifier);
    };
    return ClickLinkOptions;
}());

function createOptions(multiCursorModifier) {
    if (multiCursorModifier === 'altKey') {
        if (__WEBPACK_IMPORTED_MODULE_4__base_common_platform_js__["d" /* isMacintosh */]) {
            return new ClickLinkOptions(57 /* Meta */, 'metaKey', 6 /* Alt */, 'altKey');
        }
        return new ClickLinkOptions(5 /* Ctrl */, 'ctrlKey', 6 /* Alt */, 'altKey');
    }
    if (__WEBPACK_IMPORTED_MODULE_4__base_common_platform_js__["d" /* isMacintosh */]) {
        return new ClickLinkOptions(6 /* Alt */, 'altKey', 57 /* Meta */, 'metaKey');
    }
    return new ClickLinkOptions(6 /* Alt */, 'altKey', 5 /* Ctrl */, 'ctrlKey');
}
var ClickLinkGesture = /** @class */ (function (_super) {
    __extends(ClickLinkGesture, _super);
    function ClickLinkGesture(editor) {
        var _this = _super.call(this) || this;
        _this._onMouseMoveOrRelevantKeyDown = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onMouseMoveOrRelevantKeyDown = _this._onMouseMoveOrRelevantKeyDown.event;
        _this._onExecute = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onExecute = _this._onExecute.event;
        _this._onCancel = _this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]());
        _this.onCancel = _this._onCancel.event;
        _this._editor = editor;
        _this._opts = createOptions(_this._editor.getConfiguration().multiCursorModifier);
        _this.lastMouseMoveEvent = null;
        _this.hasTriggerKeyOnMouseDown = false;
        _this._register(_this._editor.onDidChangeConfiguration(function (e) {
            if (e.multiCursorModifier) {
                var newOpts = createOptions(_this._editor.getConfiguration().multiCursorModifier);
                if (_this._opts.equals(newOpts)) {
                    return;
                }
                _this._opts = newOpts;
                _this.lastMouseMoveEvent = null;
                _this.hasTriggerKeyOnMouseDown = false;
                _this._onCancel.fire();
            }
        }));
        _this._register(_this._editor.onMouseMove(function (e) { return _this.onEditorMouseMove(new ClickLinkMouseEvent(e, _this._opts)); }));
        _this._register(_this._editor.onMouseDown(function (e) { return _this.onEditorMouseDown(new ClickLinkMouseEvent(e, _this._opts)); }));
        _this._register(_this._editor.onMouseUp(function (e) { return _this.onEditorMouseUp(new ClickLinkMouseEvent(e, _this._opts)); }));
        _this._register(_this._editor.onKeyDown(function (e) { return _this.onEditorKeyDown(new ClickLinkKeyboardEvent(e, _this._opts)); }));
        _this._register(_this._editor.onKeyUp(function (e) { return _this.onEditorKeyUp(new ClickLinkKeyboardEvent(e, _this._opts)); }));
        _this._register(_this._editor.onMouseDrag(function () { return _this.resetHandler(); }));
        _this._register(_this._editor.onDidChangeCursorSelection(function (e) { return _this.onDidChangeCursorSelection(e); }));
        _this._register(_this._editor.onDidChangeModel(function (e) { return _this.resetHandler(); }));
        _this._register(_this._editor.onDidChangeModelContent(function () { return _this.resetHandler(); }));
        _this._register(_this._editor.onDidScrollChange(function (e) {
            if (e.scrollTopChanged || e.scrollLeftChanged) {
                _this.resetHandler();
            }
        }));
        return _this;
    }
    ClickLinkGesture.prototype.onDidChangeCursorSelection = function (e) {
        if (e.selection && e.selection.startColumn !== e.selection.endColumn) {
            this.resetHandler(); // immediately stop this feature if the user starts to select (https://github.com/Microsoft/vscode/issues/7827)
        }
    };
    ClickLinkGesture.prototype.onEditorMouseMove = function (mouseEvent) {
        this.lastMouseMoveEvent = mouseEvent;
        this._onMouseMoveOrRelevantKeyDown.fire([mouseEvent, null]);
    };
    ClickLinkGesture.prototype.onEditorMouseDown = function (mouseEvent) {
        // We need to record if we had the trigger key on mouse down because someone might select something in the editor
        // holding the mouse down and then while mouse is down start to press Ctrl/Cmd to start a copy operation and then
        // release the mouse button without wanting to do the navigation.
        // With this flag we prevent goto definition if the mouse was down before the trigger key was pressed.
        this.hasTriggerKeyOnMouseDown = mouseEvent.hasTriggerModifier;
    };
    ClickLinkGesture.prototype.onEditorMouseUp = function (mouseEvent) {
        if (this.hasTriggerKeyOnMouseDown) {
            this._onExecute.fire(mouseEvent);
        }
    };
    ClickLinkGesture.prototype.onEditorKeyDown = function (e) {
        if (this.lastMouseMoveEvent
            && (e.keyCodeIsTriggerKey // User just pressed Ctrl/Cmd (normal goto definition)
                || (e.keyCodeIsSideBySideKey && e.hasTriggerModifier) // User pressed Ctrl/Cmd+Alt (goto definition to the side)
            )) {
            this._onMouseMoveOrRelevantKeyDown.fire([this.lastMouseMoveEvent, e]);
        }
        else if (e.hasTriggerModifier) {
            this._onCancel.fire(); // remove decorations if user holds another key with ctrl/cmd to prevent accident goto declaration
        }
    };
    ClickLinkGesture.prototype.onEditorKeyUp = function (e) {
        if (e.keyCodeIsTriggerKey) {
            this._onCancel.fire();
        }
    };
    ClickLinkGesture.prototype.resetHandler = function () {
        this.lastMouseMoveEvent = null;
        this.hasTriggerKeyOnMouseDown = false;
        this._onCancel.fire();
    };
    return ClickLinkGesture;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModifierLabelProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UILabelProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AriaLabelProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ModifierLabelProvider = /** @class */ (function () {
    function ModifierLabelProvider(mac, windows, linux) {
        if (linux === void 0) { linux = windows; }
        this.modifierLabels = [null];
        this.modifierLabels[2 /* Macintosh */] = mac;
        this.modifierLabels[1 /* Windows */] = windows;
        this.modifierLabels[3 /* Linux */] = linux;
    }
    ModifierLabelProvider.prototype.toLabel = function (firstPartMod, firstPartKey, chordPartMod, chordPartKey, OS) {
        if (firstPartKey === null && chordPartKey === null) {
            return null;
        }
        return _asString(firstPartMod, firstPartKey, chordPartMod, chordPartKey, this.modifierLabels[OS]);
    };
    return ModifierLabelProvider;
}());

/**
 * A label provider that prints modifiers in a suitable format for displaying in the UI.
 */
var UILabelProvider = new ModifierLabelProvider({
    ctrlKey: '⌃',
    shiftKey: '⇧',
    altKey: '⌥',
    metaKey: '⌘',
    separator: '',
}, {
    ctrlKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'ctrlKey', comment: ['This is the short form for the Control key on the keyboard'] }, "Ctrl"),
    shiftKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'shiftKey', comment: ['This is the short form for the Shift key on the keyboard'] }, "Shift"),
    altKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'altKey', comment: ['This is the short form for the Alt key on the keyboard'] }, "Alt"),
    metaKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'windowsKey', comment: ['This is the short form for the Windows key on the keyboard'] }, "Windows"),
    separator: '+',
}, {
    ctrlKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'ctrlKey', comment: ['This is the short form for the Control key on the keyboard'] }, "Ctrl"),
    shiftKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'shiftKey', comment: ['This is the short form for the Shift key on the keyboard'] }, "Shift"),
    altKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'altKey', comment: ['This is the short form for the Alt key on the keyboard'] }, "Alt"),
    metaKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'superKey', comment: ['This is the short form for the Super key on the keyboard'] }, "Super"),
    separator: '+',
});
/**
 * A label provider that prints modifiers in a suitable format for ARIA.
 */
var AriaLabelProvider = new ModifierLabelProvider({
    ctrlKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'ctrlKey.long', comment: ['This is the long form for the Control key on the keyboard'] }, "Control"),
    shiftKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'shiftKey.long', comment: ['This is the long form for the Shift key on the keyboard'] }, "Shift"),
    altKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'altKey.long', comment: ['This is the long form for the Alt key on the keyboard'] }, "Alt"),
    metaKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'cmdKey.long', comment: ['This is the long form for the Command key on the keyboard'] }, "Command"),
    separator: '+',
}, {
    ctrlKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'ctrlKey.long', comment: ['This is the long form for the Control key on the keyboard'] }, "Control"),
    shiftKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'shiftKey.long', comment: ['This is the long form for the Shift key on the keyboard'] }, "Shift"),
    altKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'altKey.long', comment: ['This is the long form for the Alt key on the keyboard'] }, "Alt"),
    metaKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'windowsKey.long', comment: ['This is the long form for the Windows key on the keyboard'] }, "Windows"),
    separator: '+',
}, {
    ctrlKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'ctrlKey.long', comment: ['This is the long form for the Control key on the keyboard'] }, "Control"),
    shiftKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'shiftKey.long', comment: ['This is the long form for the Shift key on the keyboard'] }, "Shift"),
    altKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'altKey.long', comment: ['This is the long form for the Alt key on the keyboard'] }, "Alt"),
    metaKey: __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]({ key: 'superKey.long', comment: ['This is the long form for the Super key on the keyboard'] }, "Super"),
    separator: '+',
});
function _simpleAsString(modifiers, key, labels) {
    if (key === null) {
        return '';
    }
    var result = [];
    // translate modifier keys: Ctrl-Shift-Alt-Meta
    if (modifiers.ctrlKey) {
        result.push(labels.ctrlKey);
    }
    if (modifiers.shiftKey) {
        result.push(labels.shiftKey);
    }
    if (modifiers.altKey) {
        result.push(labels.altKey);
    }
    if (modifiers.metaKey) {
        result.push(labels.metaKey);
    }
    // the actual key
    result.push(key);
    return result.join(labels.separator);
}
function _asString(firstPartMod, firstPartKey, chordPartMod, chordPartKey, labels) {
    var result = _simpleAsString(firstPartMod, firstPartKey, labels);
    if (chordPartKey !== null) {
        result += ' ';
        result += _simpleAsString(chordPartMod, chordPartKey, labels);
    }
    return result;
}


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HoverOperation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var HoverOperation = /** @class */ (function () {
    function HoverOperation(computer, success, error, progress) {
        var _this = this;
        this._computer = computer;
        this._state = 0 /* IDLE */;
        this._hoverTime = HoverOperation.HOVER_TIME;
        this._firstWaitScheduler = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._triggerAsyncComputation(); }, 0);
        this._secondWaitScheduler = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._triggerSyncComputation(); }, 0);
        this._loadingMessageScheduler = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._showLoadingMessage(); }, 0);
        this._asyncComputationPromise = null;
        this._asyncComputationPromiseDone = false;
        this._completeCallback = success;
        this._errorCallback = error;
        this._progressCallback = progress;
    }
    HoverOperation.prototype.setHoverTime = function (hoverTime) {
        this._hoverTime = hoverTime;
    };
    HoverOperation.prototype._firstWaitTime = function () {
        return this._hoverTime / 2;
    };
    HoverOperation.prototype._secondWaitTime = function () {
        return this._hoverTime / 2;
    };
    HoverOperation.prototype._loadingMessageTime = function () {
        return 3 * this._hoverTime;
    };
    HoverOperation.prototype._triggerAsyncComputation = function () {
        var _this = this;
        this._state = 2 /* SECOND_WAIT */;
        this._secondWaitScheduler.schedule(this._secondWaitTime());
        if (this._computer.computeAsync) {
            this._asyncComputationPromiseDone = false;
            this._asyncComputationPromise = Object(__WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return _this._computer.computeAsync(token); });
            this._asyncComputationPromise.then(function (asyncResult) {
                _this._asyncComputationPromiseDone = true;
                _this._withAsyncResult(asyncResult);
            }, function (e) { return _this._onError(e); });
        }
        else {
            this._asyncComputationPromiseDone = true;
        }
    };
    HoverOperation.prototype._triggerSyncComputation = function () {
        if (this._computer.computeSync) {
            this._computer.onResult(this._computer.computeSync(), true);
        }
        if (this._asyncComputationPromiseDone) {
            this._state = 0 /* IDLE */;
            this._onComplete(this._computer.getResult());
        }
        else {
            this._state = 3 /* WAITING_FOR_ASYNC_COMPUTATION */;
            this._onProgress(this._computer.getResult());
        }
    };
    HoverOperation.prototype._showLoadingMessage = function () {
        if (this._state === 3 /* WAITING_FOR_ASYNC_COMPUTATION */) {
            this._onProgress(this._computer.getResultWithLoadingMessage());
        }
    };
    HoverOperation.prototype._withAsyncResult = function (asyncResult) {
        if (asyncResult) {
            this._computer.onResult(asyncResult, false);
        }
        if (this._state === 3 /* WAITING_FOR_ASYNC_COMPUTATION */) {
            this._state = 0 /* IDLE */;
            this._onComplete(this._computer.getResult());
        }
    };
    HoverOperation.prototype._onComplete = function (value) {
        if (this._completeCallback) {
            this._completeCallback(value);
        }
    };
    HoverOperation.prototype._onError = function (error) {
        if (this._errorCallback) {
            this._errorCallback(error);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["e" /* onUnexpectedError */])(error);
        }
    };
    HoverOperation.prototype._onProgress = function (value) {
        if (this._progressCallback) {
            this._progressCallback(value);
        }
    };
    HoverOperation.prototype.start = function (mode) {
        if (mode === 0 /* Delayed */) {
            if (this._state === 0 /* IDLE */) {
                this._state = 1 /* FIRST_WAIT */;
                this._firstWaitScheduler.schedule(this._firstWaitTime());
                this._loadingMessageScheduler.schedule(this._loadingMessageTime());
            }
        }
        else {
            switch (this._state) {
                case 0 /* IDLE */:
                    this._triggerAsyncComputation();
                    this._secondWaitScheduler.cancel();
                    this._triggerSyncComputation();
                    break;
                case 2 /* SECOND_WAIT */:
                    this._secondWaitScheduler.cancel();
                    this._triggerSyncComputation();
                    break;
            }
        }
    };
    HoverOperation.prototype.cancel = function () {
        this._loadingMessageScheduler.cancel();
        if (this._state === 1 /* FIRST_WAIT */) {
            this._firstWaitScheduler.cancel();
        }
        if (this._state === 2 /* SECOND_WAIT */) {
            this._secondWaitScheduler.cancel();
            if (this._asyncComputationPromise) {
                this._asyncComputationPromise.cancel();
                this._asyncComputationPromise = null;
            }
        }
        if (this._state === 3 /* WAITING_FOR_ASYNC_COMPUTATION */) {
            if (this._asyncComputationPromise) {
                this._asyncComputationPromise.cancel();
                this._asyncComputationPromise = null;
            }
        }
        this._state = 0 /* IDLE */;
    };
    HoverOperation.HOVER_TIME = 300;
    return HoverOperation;
}());



/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentHoverWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GlyphHoverWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_ui_widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ContentHoverWidget = /** @class */ (function (_super) {
    __extends(ContentHoverWidget, _super);
    function ContentHoverWidget(id, editor) {
        var _this = _super.call(this) || this;
        _this.disposables = [];
        // Editor.IContentWidget.allowEditorOverflow
        _this.allowEditorOverflow = true;
        _this._id = id;
        _this._editor = editor;
        _this._isVisible = false;
        _this._containerDomNode = document.createElement('div');
        _this._containerDomNode.className = 'monaco-editor-hover hidden';
        _this._containerDomNode.tabIndex = 0;
        _this._domNode = document.createElement('div');
        _this._domNode.className = 'monaco-editor-hover-content';
        _this.scrollbar = new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_scrollbar_scrollableElement_js__["a" /* DomScrollableElement */](_this._domNode, {});
        _this.disposables.push(_this.scrollbar);
        _this._containerDomNode.appendChild(_this.scrollbar.getDomNode());
        _this.onkeydown(_this._containerDomNode, function (e) {
            if (e.equals(9 /* Escape */)) {
                _this.hide();
            }
        });
        _this._register(_this._editor.onDidChangeConfiguration(function (e) {
            if (e.fontInfo) {
                _this.updateFont();
            }
        }));
        _this._editor.onDidLayoutChange(function (e) { return _this.updateMaxHeight(); });
        _this.updateMaxHeight();
        _this._editor.addContentWidget(_this);
        _this._showAtPosition = null;
        return _this;
    }
    Object.defineProperty(ContentHoverWidget.prototype, "isVisible", {
        get: function () {
            return this._isVisible;
        },
        set: function (value) {
            this._isVisible = value;
            Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["N" /* toggleClass */])(this._containerDomNode, 'hidden', !this._isVisible);
        },
        enumerable: true,
        configurable: true
    });
    ContentHoverWidget.prototype.getId = function () {
        return this._id;
    };
    ContentHoverWidget.prototype.getDomNode = function () {
        return this._containerDomNode;
    };
    ContentHoverWidget.prototype.showAt = function (position, focus) {
        // Position has changed
        this._showAtPosition = new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](position.lineNumber, position.column);
        this.isVisible = true;
        this._editor.layoutContentWidget(this);
        // Simply force a synchronous render on the editor
        // such that the widget does not really render with left = '0px'
        this._editor.render();
        this._stoleFocus = focus;
        if (focus) {
            this._containerDomNode.focus();
        }
    };
    ContentHoverWidget.prototype.hide = function () {
        if (!this.isVisible) {
            return;
        }
        this.isVisible = false;
        this._editor.layoutContentWidget(this);
        if (this._stoleFocus) {
            this._editor.focus();
        }
    };
    ContentHoverWidget.prototype.getPosition = function () {
        if (this.isVisible) {
            return {
                position: this._showAtPosition,
                preference: [
                    __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE,
                    __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].BELOW
                ]
            };
        }
        return null;
    };
    ContentHoverWidget.prototype.dispose = function () {
        this._editor.removeContentWidget(this);
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_5__base_common_lifecycle_js__["d" /* dispose */])(this.disposables);
        _super.prototype.dispose.call(this);
    };
    ContentHoverWidget.prototype.updateFont = function () {
        var _this = this;
        var codeClasses = Array.prototype.slice.call(this._domNode.getElementsByClassName('code'));
        codeClasses.forEach(function (node) { return _this._editor.applyFontInfo(node); });
    };
    ContentHoverWidget.prototype.updateContents = function (node) {
        this._domNode.textContent = '';
        this._domNode.appendChild(node);
        this.updateFont();
        this._editor.layoutContentWidget(this);
        this.onContentsChange();
    };
    ContentHoverWidget.prototype.onContentsChange = function () {
        this.scrollbar.scanDomNode();
    };
    ContentHoverWidget.prototype.updateMaxHeight = function () {
        var height = Math.max(this._editor.getLayoutInfo().height / 4, 250);
        var _a = this._editor.getConfiguration().fontInfo, fontSize = _a.fontSize, lineHeight = _a.lineHeight;
        this._domNode.style.fontSize = fontSize + "px";
        this._domNode.style.lineHeight = lineHeight + "px";
        this._domNode.style.maxHeight = height + "px";
    };
    return ContentHoverWidget;
}(__WEBPACK_IMPORTED_MODULE_3__base_browser_ui_widget_js__["a" /* Widget */]));

var GlyphHoverWidget = /** @class */ (function (_super) {
    __extends(GlyphHoverWidget, _super);
    function GlyphHoverWidget(id, editor) {
        var _this = _super.call(this) || this;
        _this._id = id;
        _this._editor = editor;
        _this._isVisible = false;
        _this._domNode = document.createElement('div');
        _this._domNode.className = 'monaco-editor-hover hidden';
        _this._domNode.setAttribute('aria-hidden', 'true');
        _this._domNode.setAttribute('role', 'presentation');
        _this._showAtLineNumber = -1;
        _this._register(_this._editor.onDidChangeConfiguration(function (e) {
            if (e.fontInfo) {
                _this.updateFont();
            }
        }));
        _this._editor.addOverlayWidget(_this);
        return _this;
    }
    Object.defineProperty(GlyphHoverWidget.prototype, "isVisible", {
        get: function () {
            return this._isVisible;
        },
        set: function (value) {
            this._isVisible = value;
            Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["N" /* toggleClass */])(this._domNode, 'hidden', !this._isVisible);
        },
        enumerable: true,
        configurable: true
    });
    GlyphHoverWidget.prototype.getId = function () {
        return this._id;
    };
    GlyphHoverWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    GlyphHoverWidget.prototype.showAt = function (lineNumber) {
        this._showAtLineNumber = lineNumber;
        if (!this.isVisible) {
            this.isVisible = true;
        }
        var editorLayout = this._editor.getLayoutInfo();
        var topForLineNumber = this._editor.getTopForLineNumber(this._showAtLineNumber);
        var editorScrollTop = this._editor.getScrollTop();
        var lineHeight = this._editor.getConfiguration().lineHeight;
        var nodeHeight = this._domNode.clientHeight;
        var top = topForLineNumber - editorScrollTop - ((nodeHeight - lineHeight) / 2);
        this._domNode.style.left = editorLayout.glyphMarginLeft + editorLayout.glyphMarginWidth + "px";
        this._domNode.style.top = Math.max(Math.round(top), 0) + "px";
    };
    GlyphHoverWidget.prototype.hide = function () {
        if (!this.isVisible) {
            return;
        }
        this.isVisible = false;
    };
    GlyphHoverWidget.prototype.getPosition = function () {
        return null;
    };
    GlyphHoverWidget.prototype.dispose = function () {
        this._editor.removeOverlayWidget(this);
        _super.prototype.dispose.call(this);
    };
    GlyphHoverWidget.prototype.updateFont = function () {
        var _this = this;
        var codeTags = Array.prototype.slice.call(this._domNode.getElementsByTagName('code'));
        var codeClasses = Array.prototype.slice.call(this._domNode.getElementsByClassName('code'));
        codeTags.concat(codeClasses).forEach(function (node) { return _this._editor.applyFontInfo(node); });
    };
    GlyphHoverWidget.prototype.updateContents = function (node) {
        this._domNode.textContent = '';
        this._domNode.appendChild(node);
        this.updateFont();
    };
    return GlyphHoverWidget;
}(__WEBPACK_IMPORTED_MODULE_3__base_browser_ui_widget_js__["a" /* Widget */]));



/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Context; });
/* harmony export (immutable) */ __webpack_exports__["b"] = provideSignatureHelp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var Context = {
    Visible: new __WEBPACK_IMPORTED_MODULE_4__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('parameterHintsVisible', false),
    MultipleSignatures: new __WEBPACK_IMPORTED_MODULE_4__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('parameterHintsMultipleSignatures', false),
};
function provideSignatureHelp(model, position, token) {
    var supports = __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["t" /* SignatureHelpProviderRegistry */].ordered(model);
    return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["k" /* first2 */])(supports.map(function (support) { return function () {
        return Promise.resolve(support.provideSignatureHelp(model, position, token)).catch(__WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
    }; }));
}
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeSignatureHelpProvider', function (model, position) { return provideSignatureHelp(model, position, __WEBPACK_IMPORTED_MODULE_5__base_common_cancellation_js__["a" /* CancellationToken */].None); });


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MarkerTag */
/* unused harmony export MarkerSeverity */
/* unused harmony export KeyMod */
/* unused harmony export KeyCode */
/* harmony export (immutable) */ __webpack_exports__["a"] = createMonacoBaseAPI;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_cancellation_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_token_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_uri_js__ = __webpack_require__(28);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/










// --------------------------------------------
// This is repeated here so it can be exported
// because TS inlines const enums
// --------------------------------------------
var MarkerTag;
(function (MarkerTag) {
    MarkerTag[MarkerTag["Unnecessary"] = 1] = "Unnecessary";
})(MarkerTag || (MarkerTag = {}));
var MarkerSeverity;
(function (MarkerSeverity) {
    MarkerSeverity[MarkerSeverity["Hint"] = 1] = "Hint";
    MarkerSeverity[MarkerSeverity["Info"] = 2] = "Info";
    MarkerSeverity[MarkerSeverity["Warning"] = 4] = "Warning";
    MarkerSeverity[MarkerSeverity["Error"] = 8] = "Error";
})(MarkerSeverity || (MarkerSeverity = {}));
// --------------------------------------------
// This is repeated here so it can be exported
// because TS inlines const enums
// --------------------------------------------
var KeyMod = /** @class */ (function () {
    function KeyMod() {
    }
    KeyMod.chord = function (firstPart, secondPart) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_keyCodes_js__["a" /* KeyChord */])(firstPart, secondPart);
    };
    KeyMod.CtrlCmd = 2048 /* CtrlCmd */;
    KeyMod.Shift = 1024 /* Shift */;
    KeyMod.Alt = 512 /* Alt */;
    KeyMod.WinCtrl = 256 /* WinCtrl */;
    return KeyMod;
}());

// --------------------------------------------
// This is repeated here so it can be exported
// because TS inlines const enums
// --------------------------------------------
/**
 * Virtual Key Codes, the value does not hold any inherent meaning.
 * Inspired somewhat from https://msdn.microsoft.com/en-us/library/windows/desktop/dd375731(v=vs.85).aspx
 * But these are "more general", as they should work across browsers & OS`s.
 */
var KeyCode;
(function (KeyCode) {
    /**
     * Placed first to cover the 0 value of the enum.
     */
    KeyCode[KeyCode["Unknown"] = 0] = "Unknown";
    KeyCode[KeyCode["Backspace"] = 1] = "Backspace";
    KeyCode[KeyCode["Tab"] = 2] = "Tab";
    KeyCode[KeyCode["Enter"] = 3] = "Enter";
    KeyCode[KeyCode["Shift"] = 4] = "Shift";
    KeyCode[KeyCode["Ctrl"] = 5] = "Ctrl";
    KeyCode[KeyCode["Alt"] = 6] = "Alt";
    KeyCode[KeyCode["PauseBreak"] = 7] = "PauseBreak";
    KeyCode[KeyCode["CapsLock"] = 8] = "CapsLock";
    KeyCode[KeyCode["Escape"] = 9] = "Escape";
    KeyCode[KeyCode["Space"] = 10] = "Space";
    KeyCode[KeyCode["PageUp"] = 11] = "PageUp";
    KeyCode[KeyCode["PageDown"] = 12] = "PageDown";
    KeyCode[KeyCode["End"] = 13] = "End";
    KeyCode[KeyCode["Home"] = 14] = "Home";
    KeyCode[KeyCode["LeftArrow"] = 15] = "LeftArrow";
    KeyCode[KeyCode["UpArrow"] = 16] = "UpArrow";
    KeyCode[KeyCode["RightArrow"] = 17] = "RightArrow";
    KeyCode[KeyCode["DownArrow"] = 18] = "DownArrow";
    KeyCode[KeyCode["Insert"] = 19] = "Insert";
    KeyCode[KeyCode["Delete"] = 20] = "Delete";
    KeyCode[KeyCode["KEY_0"] = 21] = "KEY_0";
    KeyCode[KeyCode["KEY_1"] = 22] = "KEY_1";
    KeyCode[KeyCode["KEY_2"] = 23] = "KEY_2";
    KeyCode[KeyCode["KEY_3"] = 24] = "KEY_3";
    KeyCode[KeyCode["KEY_4"] = 25] = "KEY_4";
    KeyCode[KeyCode["KEY_5"] = 26] = "KEY_5";
    KeyCode[KeyCode["KEY_6"] = 27] = "KEY_6";
    KeyCode[KeyCode["KEY_7"] = 28] = "KEY_7";
    KeyCode[KeyCode["KEY_8"] = 29] = "KEY_8";
    KeyCode[KeyCode["KEY_9"] = 30] = "KEY_9";
    KeyCode[KeyCode["KEY_A"] = 31] = "KEY_A";
    KeyCode[KeyCode["KEY_B"] = 32] = "KEY_B";
    KeyCode[KeyCode["KEY_C"] = 33] = "KEY_C";
    KeyCode[KeyCode["KEY_D"] = 34] = "KEY_D";
    KeyCode[KeyCode["KEY_E"] = 35] = "KEY_E";
    KeyCode[KeyCode["KEY_F"] = 36] = "KEY_F";
    KeyCode[KeyCode["KEY_G"] = 37] = "KEY_G";
    KeyCode[KeyCode["KEY_H"] = 38] = "KEY_H";
    KeyCode[KeyCode["KEY_I"] = 39] = "KEY_I";
    KeyCode[KeyCode["KEY_J"] = 40] = "KEY_J";
    KeyCode[KeyCode["KEY_K"] = 41] = "KEY_K";
    KeyCode[KeyCode["KEY_L"] = 42] = "KEY_L";
    KeyCode[KeyCode["KEY_M"] = 43] = "KEY_M";
    KeyCode[KeyCode["KEY_N"] = 44] = "KEY_N";
    KeyCode[KeyCode["KEY_O"] = 45] = "KEY_O";
    KeyCode[KeyCode["KEY_P"] = 46] = "KEY_P";
    KeyCode[KeyCode["KEY_Q"] = 47] = "KEY_Q";
    KeyCode[KeyCode["KEY_R"] = 48] = "KEY_R";
    KeyCode[KeyCode["KEY_S"] = 49] = "KEY_S";
    KeyCode[KeyCode["KEY_T"] = 50] = "KEY_T";
    KeyCode[KeyCode["KEY_U"] = 51] = "KEY_U";
    KeyCode[KeyCode["KEY_V"] = 52] = "KEY_V";
    KeyCode[KeyCode["KEY_W"] = 53] = "KEY_W";
    KeyCode[KeyCode["KEY_X"] = 54] = "KEY_X";
    KeyCode[KeyCode["KEY_Y"] = 55] = "KEY_Y";
    KeyCode[KeyCode["KEY_Z"] = 56] = "KEY_Z";
    KeyCode[KeyCode["Meta"] = 57] = "Meta";
    KeyCode[KeyCode["ContextMenu"] = 58] = "ContextMenu";
    KeyCode[KeyCode["F1"] = 59] = "F1";
    KeyCode[KeyCode["F2"] = 60] = "F2";
    KeyCode[KeyCode["F3"] = 61] = "F3";
    KeyCode[KeyCode["F4"] = 62] = "F4";
    KeyCode[KeyCode["F5"] = 63] = "F5";
    KeyCode[KeyCode["F6"] = 64] = "F6";
    KeyCode[KeyCode["F7"] = 65] = "F7";
    KeyCode[KeyCode["F8"] = 66] = "F8";
    KeyCode[KeyCode["F9"] = 67] = "F9";
    KeyCode[KeyCode["F10"] = 68] = "F10";
    KeyCode[KeyCode["F11"] = 69] = "F11";
    KeyCode[KeyCode["F12"] = 70] = "F12";
    KeyCode[KeyCode["F13"] = 71] = "F13";
    KeyCode[KeyCode["F14"] = 72] = "F14";
    KeyCode[KeyCode["F15"] = 73] = "F15";
    KeyCode[KeyCode["F16"] = 74] = "F16";
    KeyCode[KeyCode["F17"] = 75] = "F17";
    KeyCode[KeyCode["F18"] = 76] = "F18";
    KeyCode[KeyCode["F19"] = 77] = "F19";
    KeyCode[KeyCode["NumLock"] = 78] = "NumLock";
    KeyCode[KeyCode["ScrollLock"] = 79] = "ScrollLock";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the ';:' key
     */
    KeyCode[KeyCode["US_SEMICOLON"] = 80] = "US_SEMICOLON";
    /**
     * For any country/region, the '+' key
     * For the US standard keyboard, the '=+' key
     */
    KeyCode[KeyCode["US_EQUAL"] = 81] = "US_EQUAL";
    /**
     * For any country/region, the ',' key
     * For the US standard keyboard, the ',<' key
     */
    KeyCode[KeyCode["US_COMMA"] = 82] = "US_COMMA";
    /**
     * For any country/region, the '-' key
     * For the US standard keyboard, the '-_' key
     */
    KeyCode[KeyCode["US_MINUS"] = 83] = "US_MINUS";
    /**
     * For any country/region, the '.' key
     * For the US standard keyboard, the '.>' key
     */
    KeyCode[KeyCode["US_DOT"] = 84] = "US_DOT";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '/?' key
     */
    KeyCode[KeyCode["US_SLASH"] = 85] = "US_SLASH";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '`~' key
     */
    KeyCode[KeyCode["US_BACKTICK"] = 86] = "US_BACKTICK";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '[{' key
     */
    KeyCode[KeyCode["US_OPEN_SQUARE_BRACKET"] = 87] = "US_OPEN_SQUARE_BRACKET";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '\|' key
     */
    KeyCode[KeyCode["US_BACKSLASH"] = 88] = "US_BACKSLASH";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the ']}' key
     */
    KeyCode[KeyCode["US_CLOSE_SQUARE_BRACKET"] = 89] = "US_CLOSE_SQUARE_BRACKET";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the ''"' key
     */
    KeyCode[KeyCode["US_QUOTE"] = 90] = "US_QUOTE";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     */
    KeyCode[KeyCode["OEM_8"] = 91] = "OEM_8";
    /**
     * Either the angle bracket key or the backslash key on the RT 102-key keyboard.
     */
    KeyCode[KeyCode["OEM_102"] = 92] = "OEM_102";
    KeyCode[KeyCode["NUMPAD_0"] = 93] = "NUMPAD_0";
    KeyCode[KeyCode["NUMPAD_1"] = 94] = "NUMPAD_1";
    KeyCode[KeyCode["NUMPAD_2"] = 95] = "NUMPAD_2";
    KeyCode[KeyCode["NUMPAD_3"] = 96] = "NUMPAD_3";
    KeyCode[KeyCode["NUMPAD_4"] = 97] = "NUMPAD_4";
    KeyCode[KeyCode["NUMPAD_5"] = 98] = "NUMPAD_5";
    KeyCode[KeyCode["NUMPAD_6"] = 99] = "NUMPAD_6";
    KeyCode[KeyCode["NUMPAD_7"] = 100] = "NUMPAD_7";
    KeyCode[KeyCode["NUMPAD_8"] = 101] = "NUMPAD_8";
    KeyCode[KeyCode["NUMPAD_9"] = 102] = "NUMPAD_9";
    KeyCode[KeyCode["NUMPAD_MULTIPLY"] = 103] = "NUMPAD_MULTIPLY";
    KeyCode[KeyCode["NUMPAD_ADD"] = 104] = "NUMPAD_ADD";
    KeyCode[KeyCode["NUMPAD_SEPARATOR"] = 105] = "NUMPAD_SEPARATOR";
    KeyCode[KeyCode["NUMPAD_SUBTRACT"] = 106] = "NUMPAD_SUBTRACT";
    KeyCode[KeyCode["NUMPAD_DECIMAL"] = 107] = "NUMPAD_DECIMAL";
    KeyCode[KeyCode["NUMPAD_DIVIDE"] = 108] = "NUMPAD_DIVIDE";
    /**
     * Cover all key codes when IME is processing input.
     */
    KeyCode[KeyCode["KEY_IN_COMPOSITION"] = 109] = "KEY_IN_COMPOSITION";
    KeyCode[KeyCode["ABNT_C1"] = 110] = "ABNT_C1";
    KeyCode[KeyCode["ABNT_C2"] = 111] = "ABNT_C2";
    /**
     * Placed last to cover the length of the enum.
     * Please do not depend on this value!
     */
    KeyCode[KeyCode["MAX_VALUE"] = 112] = "MAX_VALUE";
})(KeyCode || (KeyCode = {}));
function createMonacoBaseAPI() {
    return {
        editor: undefined,
        languages: undefined,
        CancellationTokenSource: __WEBPACK_IMPORTED_MODULE_6__base_common_cancellation_js__["b" /* CancellationTokenSource */],
        Emitter: __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */],
        KeyCode: KeyCode,
        KeyMod: KeyMod,
        Position: __WEBPACK_IMPORTED_MODULE_2__core_position_js__["a" /* Position */],
        Range: __WEBPACK_IMPORTED_MODULE_3__core_range_js__["a" /* Range */],
        Selection: __WEBPACK_IMPORTED_MODULE_4__core_selection_js__["a" /* Selection */],
        SelectionDirection: __WEBPACK_IMPORTED_MODULE_4__core_selection_js__["b" /* SelectionDirection */],
        MarkerSeverity: MarkerSeverity,
        MarkerTag: MarkerTag,
        Promise: __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__["b" /* TPromise */],
        Uri: __WEBPACK_IMPORTED_MODULE_8__base_common_uri_js__["a" /* default */],
        Token: __WEBPACK_IMPORTED_MODULE_7__core_token_js__["a" /* Token */]
    };
}


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeybindingResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__ = __webpack_require__(16);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var KeybindingResolver = /** @class */ (function () {
    function KeybindingResolver(defaultKeybindings, overrides) {
        this._defaultKeybindings = defaultKeybindings;
        this._defaultBoundCommands = new Map();
        for (var i = 0, len = defaultKeybindings.length; i < len; i++) {
            var command = defaultKeybindings[i].command;
            this._defaultBoundCommands.set(command, true);
        }
        this._map = new Map();
        this._lookupMap = new Map();
        this._keybindings = KeybindingResolver.combine(defaultKeybindings, overrides);
        for (var i = 0, len = this._keybindings.length; i < len; i++) {
            var k = this._keybindings[i];
            if (k.keypressFirstPart === null) {
                // unbound
                continue;
            }
            this._addKeyPress(k.keypressFirstPart, k);
        }
    }
    KeybindingResolver._isTargetedForRemoval = function (defaultKb, keypressFirstPart, keypressChordPart, command, when) {
        if (defaultKb.command !== command) {
            return false;
        }
        if (keypressFirstPart && defaultKb.keypressFirstPart !== keypressFirstPart) {
            return false;
        }
        if (keypressChordPart && defaultKb.keypressChordPart !== keypressChordPart) {
            return false;
        }
        if (when) {
            if (!defaultKb.when) {
                return false;
            }
            if (!when.equals(defaultKb.when)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Looks for rules containing -command in `overrides` and removes them directly from `defaults`.
     */
    KeybindingResolver.combine = function (defaults, rawOverrides) {
        defaults = defaults.slice(0);
        var overrides = [];
        for (var i = 0, len = rawOverrides.length; i < len; i++) {
            var override = rawOverrides[i];
            if (!override.command || override.command.length === 0 || override.command.charAt(0) !== '-') {
                overrides.push(override);
                continue;
            }
            var command = override.command.substr(1);
            var keypressFirstPart = override.keypressFirstPart;
            var keypressChordPart = override.keypressChordPart;
            var when = override.when;
            for (var j = defaults.length - 1; j >= 0; j--) {
                if (this._isTargetedForRemoval(defaults[j], keypressFirstPart, keypressChordPart, command, when)) {
                    defaults.splice(j, 1);
                }
            }
        }
        return defaults.concat(overrides);
    };
    KeybindingResolver.prototype._addKeyPress = function (keypress, item) {
        var conflicts = this._map.get(keypress);
        if (typeof conflicts === 'undefined') {
            // There is no conflict so far
            this._map.set(keypress, [item]);
            this._addToLookupMap(item);
            return;
        }
        for (var i = conflicts.length - 1; i >= 0; i--) {
            var conflict = conflicts[i];
            if (conflict.command === item.command) {
                continue;
            }
            var conflictIsChord = (conflict.keypressChordPart !== null);
            var itemIsChord = (item.keypressChordPart !== null);
            if (conflictIsChord && itemIsChord && conflict.keypressChordPart !== item.keypressChordPart) {
                // The conflict only shares the chord start with this command
                continue;
            }
            if (KeybindingResolver.whenIsEntirelyIncluded(conflict.when, item.when)) {
                // `item` completely overwrites `conflict`
                // Remove conflict from the lookupMap
                this._removeFromLookupMap(conflict);
            }
        }
        conflicts.push(item);
        this._addToLookupMap(item);
    };
    KeybindingResolver.prototype._addToLookupMap = function (item) {
        if (!item.command) {
            return;
        }
        var arr = this._lookupMap.get(item.command);
        if (typeof arr === 'undefined') {
            arr = [item];
            this._lookupMap.set(item.command, arr);
        }
        else {
            arr.push(item);
        }
    };
    KeybindingResolver.prototype._removeFromLookupMap = function (item) {
        var arr = this._lookupMap.get(item.command);
        if (typeof arr === 'undefined') {
            return;
        }
        for (var i = 0, len = arr.length; i < len; i++) {
            if (arr[i] === item) {
                arr.splice(i, 1);
                return;
            }
        }
    };
    /**
     * Returns true if it is provable `a` implies `b`.
     * **Precondition**: Assumes `a` and `b` are normalized!
     */
    KeybindingResolver.whenIsEntirelyIncluded = function (a, b) {
        if (!b) {
            return true;
        }
        if (!a) {
            return false;
        }
        var aExpressions = ((a instanceof __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["a" /* ContextKeyAndExpr */]) ? a.expr : [a]);
        var bExpressions = ((b instanceof __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["a" /* ContextKeyAndExpr */]) ? b.expr : [b]);
        var aIndex = 0;
        for (var bIndex = 0; bIndex < bExpressions.length; bIndex++) {
            var bExpr = bExpressions[bIndex];
            var bExprMatched = false;
            while (!bExprMatched && aIndex < aExpressions.length) {
                var aExpr = aExpressions[aIndex];
                if (aExpr.equals(bExpr)) {
                    bExprMatched = true;
                }
                aIndex++;
            }
            if (!bExprMatched) {
                return false;
            }
        }
        return true;
    };
    KeybindingResolver.prototype.lookupPrimaryKeybinding = function (commandId) {
        var items = this._lookupMap.get(commandId);
        if (typeof items === 'undefined' || items.length === 0) {
            return null;
        }
        return items[items.length - 1];
    };
    KeybindingResolver.prototype.resolve = function (context, currentChord, keypress) {
        var lookupMap = null;
        if (currentChord !== null) {
            // Fetch all chord bindings for `currentChord`
            var candidates = this._map.get(currentChord);
            if (typeof candidates === 'undefined') {
                // No chords starting with `currentChord`
                return null;
            }
            lookupMap = [];
            for (var i = 0, len = candidates.length; i < len; i++) {
                var candidate = candidates[i];
                if (candidate.keypressChordPart === keypress) {
                    lookupMap.push(candidate);
                }
            }
        }
        else {
            var candidates = this._map.get(keypress);
            if (typeof candidates === 'undefined') {
                // No bindings with `keypress`
                return null;
            }
            lookupMap = candidates;
        }
        var result = this._findCommand(context, lookupMap);
        if (!result) {
            return null;
        }
        if (currentChord === null && result.keypressChordPart !== null) {
            return {
                enterChord: true,
                commandId: null,
                commandArgs: null,
                bubble: false
            };
        }
        return {
            enterChord: false,
            commandId: result.command,
            commandArgs: result.commandArgs,
            bubble: result.bubble
        };
    };
    KeybindingResolver.prototype._findCommand = function (context, matches) {
        for (var i = matches.length - 1; i >= 0; i--) {
            var k = matches[i];
            if (!KeybindingResolver.contextMatchesRules(context, k.when)) {
                continue;
            }
            return k;
        }
        return null;
    };
    KeybindingResolver.contextMatchesRules = function (context, rules) {
        if (!rules) {
            return true;
        }
        return rules.evaluate(context);
    };
    return KeybindingResolver;
}());



/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiffEditorWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_diffEditor_css__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_diffEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__media_diffEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_browser_ui_sash_sash_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_editorCommon_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_services_editorWorkerService_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_viewLayout_lineDecorations_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_viewLayout_viewLineRenderer_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__codeEditorWidget_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config_configuration_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModel_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__platform_instantiation_common_serviceCollection_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_config_editorOptions_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_view_overviewZoneManager_js__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__diffReview_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_core_stringBuilder_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__core_editorState_js__ = __webpack_require__(70);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};






























var VisualEditorState = /** @class */ (function () {
    function VisualEditorState() {
        this._zones = [];
        this._zonesMap = {};
        this._decorations = [];
    }
    VisualEditorState.prototype.getForeignViewZones = function (allViewZones) {
        var _this = this;
        return allViewZones.filter(function (z) { return !_this._zonesMap[String(z.id)]; });
    };
    VisualEditorState.prototype.clean = function (editor) {
        var _this = this;
        // (1) View zones
        if (this._zones.length > 0) {
            editor.changeViewZones(function (viewChangeAccessor) {
                for (var i = 0, length_1 = _this._zones.length; i < length_1; i++) {
                    viewChangeAccessor.removeZone(_this._zones[i]);
                }
            });
        }
        this._zones = [];
        this._zonesMap = {};
        // (2) Model decorations
        this._decorations = editor.deltaDecorations(this._decorations, []);
    };
    VisualEditorState.prototype.apply = function (editor, overviewRuler, newDecorations, restoreScrollState) {
        var _this = this;
        var scrollState = restoreScrollState ? __WEBPACK_IMPORTED_MODULE_29__core_editorState_js__["b" /* StableEditorScrollState */].capture(editor) : null;
        // view zones
        editor.changeViewZones(function (viewChangeAccessor) {
            for (var i = 0, length_2 = _this._zones.length; i < length_2; i++) {
                viewChangeAccessor.removeZone(_this._zones[i]);
            }
            _this._zones = [];
            _this._zonesMap = {};
            for (var i = 0, length_3 = newDecorations.zones.length; i < length_3; i++) {
                newDecorations.zones[i].suppressMouseDown = true;
                var zoneId = viewChangeAccessor.addZone(newDecorations.zones[i]);
                _this._zones.push(zoneId);
                _this._zonesMap[String(zoneId)] = true;
            }
        });
        if (scrollState) {
            scrollState.restore(editor);
        }
        // decorations
        this._decorations = editor.deltaDecorations(this._decorations, newDecorations.decorations);
        // overview ruler
        if (overviewRuler) {
            overviewRuler.setZones(newDecorations.overviewZones);
        }
    };
    return VisualEditorState;
}());
var DIFF_EDITOR_ID = 0;
var DiffEditorWidget = /** @class */ (function (_super) {
    __extends(DiffEditorWidget, _super);
    function DiffEditorWidget(domElement, options, editorWorkerService, contextKeyService, instantiationService, codeEditorService, themeService, notificationService) {
        var _this = _super.call(this) || this;
        _this._onDidDispose = _this._register(new __WEBPACK_IMPORTED_MODULE_20__base_common_event_js__["a" /* Emitter */]());
        _this.onDidDispose = _this._onDidDispose.event;
        _this._onDidUpdateDiff = _this._register(new __WEBPACK_IMPORTED_MODULE_20__base_common_event_js__["a" /* Emitter */]());
        _this.onDidUpdateDiff = _this._onDidUpdateDiff.event;
        _this._lastOriginalWarning = null;
        _this._lastModifiedWarning = null;
        _this._editorWorkerService = editorWorkerService;
        _this._codeEditorService = codeEditorService;
        _this._contextKeyService = _this._register(contextKeyService.createScoped(domElement));
        _this._contextKeyService.createKey('isInDiffEditor', true);
        _this._themeService = themeService;
        _this._notificationService = notificationService;
        _this.id = (++DIFF_EDITOR_ID);
        _this._domElement = domElement;
        options = options || {};
        // renderSideBySide
        _this._renderSideBySide = true;
        if (typeof options.renderSideBySide !== 'undefined') {
            _this._renderSideBySide = options.renderSideBySide;
        }
        // ignoreTrimWhitespace
        _this._ignoreTrimWhitespace = true;
        if (typeof options.ignoreTrimWhitespace !== 'undefined') {
            _this._ignoreTrimWhitespace = options.ignoreTrimWhitespace;
        }
        // renderIndicators
        _this._renderIndicators = true;
        if (typeof options.renderIndicators !== 'undefined') {
            _this._renderIndicators = options.renderIndicators;
        }
        _this._originalIsEditable = false;
        if (typeof options.originalEditable !== 'undefined') {
            _this._originalIsEditable = Boolean(options.originalEditable);
        }
        _this._updateDecorationsRunner = _this._register(new __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._updateDecorations(); }, 0));
        _this._containerDomElement = document.createElement('div');
        _this._containerDomElement.className = DiffEditorWidget._getClassName(_this._themeService.getTheme(), _this._renderSideBySide);
        _this._containerDomElement.style.position = 'relative';
        _this._containerDomElement.style.height = '100%';
        _this._domElement.appendChild(_this._containerDomElement);
        _this._overviewViewportDomElement = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._overviewViewportDomElement.setClassName('diffViewport');
        _this._overviewViewportDomElement.setPosition('absolute');
        _this._overviewDomElement = document.createElement('div');
        _this._overviewDomElement.className = 'diffOverview';
        _this._overviewDomElement.style.position = 'absolute';
        _this._overviewDomElement.appendChild(_this._overviewViewportDomElement.domNode);
        _this._register(__WEBPACK_IMPORTED_MODULE_5__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this._overviewDomElement, 'mousedown', function (e) {
            _this.modifiedEditor.delegateVerticalScrollbarMouseDown(e);
        }));
        _this._containerDomElement.appendChild(_this._overviewDomElement);
        _this._createLeftHandSide();
        _this._createRightHandSide();
        _this._beginUpdateDecorationsTimeout = -1;
        _this._currentlyChangingViewZones = false;
        _this._diffComputationToken = 0;
        _this._originalEditorState = new VisualEditorState();
        _this._modifiedEditorState = new VisualEditorState();
        _this._isVisible = true;
        _this._isHandlingScrollEvent = false;
        _this._width = 0;
        _this._height = 0;
        _this._reviewHeight = 0;
        _this._lineChanges = null;
        var leftContextKeyService = _this._contextKeyService.createScoped();
        leftContextKeyService.createKey('isInDiffLeftEditor', true);
        var leftServices = new __WEBPACK_IMPORTED_MODULE_19__platform_instantiation_common_serviceCollection_js__["a" /* ServiceCollection */]();
        leftServices.set(__WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */], leftContextKeyService);
        var leftScopedInstantiationService = instantiationService.createChild(leftServices);
        var rightContextKeyService = _this._contextKeyService.createScoped();
        rightContextKeyService.createKey('isInDiffRightEditor', true);
        var rightServices = new __WEBPACK_IMPORTED_MODULE_19__platform_instantiation_common_serviceCollection_js__["a" /* ServiceCollection */]();
        rightServices.set(__WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */], rightContextKeyService);
        var rightScopedInstantiationService = instantiationService.createChild(rightServices);
        _this._createLeftHandSideEditor(options, leftScopedInstantiationService);
        _this._createRightHandSideEditor(options, rightScopedInstantiationService);
        _this._reviewPane = new __WEBPACK_IMPORTED_MODULE_26__diffReview_js__["a" /* DiffReview */](_this);
        _this._containerDomElement.appendChild(_this._reviewPane.domNode.domNode);
        _this._containerDomElement.appendChild(_this._reviewPane.shadow.domNode);
        _this._containerDomElement.appendChild(_this._reviewPane.actionBarContainer.domNode);
        if (options.automaticLayout) {
            _this._measureDomElementToken = window.setInterval(function () { return _this._measureDomElement(false); }, 100);
        }
        // enableSplitViewResizing
        _this._enableSplitViewResizing = true;
        if (typeof options.enableSplitViewResizing !== 'undefined') {
            _this._enableSplitViewResizing = options.enableSplitViewResizing;
        }
        if (_this._renderSideBySide) {
            _this._setStrategy(new DiffEdtorWidgetSideBySide(_this._createDataSource(), _this._enableSplitViewResizing));
        }
        else {
            _this._setStrategy(new DiffEdtorWidgetInline(_this._createDataSource(), _this._enableSplitViewResizing));
        }
        _this._register(themeService.onThemeChange(function (t) {
            if (_this._strategy && _this._strategy.applyColors(t)) {
                _this._updateDecorationsRunner.schedule();
            }
            _this._containerDomElement.className = DiffEditorWidget._getClassName(_this._themeService.getTheme(), _this._renderSideBySide);
        }));
        _this._codeEditorService.addDiffEditor(_this);
        return _this;
    }
    DiffEditorWidget.prototype.hasWidgetFocus = function () {
        return __WEBPACK_IMPORTED_MODULE_5__base_browser_dom_js__["B" /* isAncestor */](document.activeElement, this._domElement);
    };
    DiffEditorWidget.prototype.diffReviewNext = function () {
        this._reviewPane.next();
    };
    DiffEditorWidget.prototype.diffReviewPrev = function () {
        this._reviewPane.prev();
    };
    DiffEditorWidget._getClassName = function (theme, renderSideBySide) {
        var result = 'monaco-diff-editor monaco-editor-background ';
        if (renderSideBySide) {
            result += 'side-by-side ';
        }
        result += Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_themeService_js__["d" /* getThemeTypeSelector */])(theme.type);
        return result;
    };
    DiffEditorWidget.prototype._recreateOverviewRulers = function () {
        if (this._originalOverviewRuler) {
            this._overviewDomElement.removeChild(this._originalOverviewRuler.getDomNode());
            this._originalOverviewRuler.dispose();
        }
        this._originalOverviewRuler = this.originalEditor.createOverviewRuler('original diffOverviewRuler');
        this._overviewDomElement.appendChild(this._originalOverviewRuler.getDomNode());
        if (this._modifiedOverviewRuler) {
            this._overviewDomElement.removeChild(this._modifiedOverviewRuler.getDomNode());
            this._modifiedOverviewRuler.dispose();
        }
        this._modifiedOverviewRuler = this.modifiedEditor.createOverviewRuler('modified diffOverviewRuler');
        this._overviewDomElement.appendChild(this._modifiedOverviewRuler.getDomNode());
        this._layoutOverviewRulers();
    };
    DiffEditorWidget.prototype._createLeftHandSide = function () {
        this._originalDomNode = document.createElement('div');
        this._originalDomNode.className = 'editor original';
        this._originalDomNode.style.position = 'absolute';
        this._originalDomNode.style.height = '100%';
        this._containerDomElement.appendChild(this._originalDomNode);
    };
    DiffEditorWidget.prototype._createRightHandSide = function () {
        this._modifiedDomNode = document.createElement('div');
        this._modifiedDomNode.className = 'editor modified';
        this._modifiedDomNode.style.position = 'absolute';
        this._modifiedDomNode.style.height = '100%';
        this._containerDomElement.appendChild(this._modifiedDomNode);
    };
    DiffEditorWidget.prototype._createLeftHandSideEditor = function (options, instantiationService) {
        var _this = this;
        this.originalEditor = this._createInnerEditor(instantiationService, this._originalDomNode, this._adjustOptionsForLeftHandSide(options, this._originalIsEditable));
        this._register(this.originalEditor.onDidScrollChange(function (e) {
            if (_this._isHandlingScrollEvent) {
                return;
            }
            if (!e.scrollTopChanged && !e.scrollLeftChanged && !e.scrollHeightChanged) {
                return;
            }
            _this._isHandlingScrollEvent = true;
            _this.modifiedEditor.setScrollPosition({
                scrollLeft: e.scrollLeft,
                scrollTop: e.scrollTop
            });
            _this._isHandlingScrollEvent = false;
            _this._layoutOverviewViewport();
        }));
        this._register(this.originalEditor.onDidChangeViewZones(function () {
            _this._onViewZonesChanged();
        }));
        this._register(this.originalEditor.onDidChangeModelContent(function () {
            if (_this._isVisible) {
                _this._beginUpdateDecorationsSoon();
            }
        }));
    };
    DiffEditorWidget.prototype._createRightHandSideEditor = function (options, instantiationService) {
        var _this = this;
        this.modifiedEditor = this._createInnerEditor(instantiationService, this._modifiedDomNode, this._adjustOptionsForRightHandSide(options));
        this._register(this.modifiedEditor.onDidScrollChange(function (e) {
            if (_this._isHandlingScrollEvent) {
                return;
            }
            if (!e.scrollTopChanged && !e.scrollLeftChanged && !e.scrollHeightChanged) {
                return;
            }
            _this._isHandlingScrollEvent = true;
            _this.originalEditor.setScrollPosition({
                scrollLeft: e.scrollLeft,
                scrollTop: e.scrollTop
            });
            _this._isHandlingScrollEvent = false;
            _this._layoutOverviewViewport();
        }));
        this._register(this.modifiedEditor.onDidChangeViewZones(function () {
            _this._onViewZonesChanged();
        }));
        this._register(this.modifiedEditor.onDidChangeConfiguration(function (e) {
            if (e.fontInfo && _this.modifiedEditor.getModel()) {
                _this._onViewZonesChanged();
            }
        }));
        this._register(this.modifiedEditor.onDidChangeModelContent(function () {
            if (_this._isVisible) {
                _this._beginUpdateDecorationsSoon();
            }
        }));
    };
    DiffEditorWidget.prototype._createInnerEditor = function (instantiationService, container, options) {
        return instantiationService.createInstance(__WEBPACK_IMPORTED_MODULE_16__codeEditorWidget_js__["a" /* CodeEditorWidget */], container, options, {});
    };
    DiffEditorWidget.prototype.dispose = function () {
        this._codeEditorService.removeDiffEditor(this);
        if (this._beginUpdateDecorationsTimeout !== -1) {
            window.clearTimeout(this._beginUpdateDecorationsTimeout);
            this._beginUpdateDecorationsTimeout = -1;
        }
        window.clearInterval(this._measureDomElementToken);
        this._cleanViewZonesAndDecorations();
        if (this._originalOverviewRuler) {
            this._overviewDomElement.removeChild(this._originalOverviewRuler.getDomNode());
            this._originalOverviewRuler.dispose();
        }
        if (this._modifiedOverviewRuler) {
            this._overviewDomElement.removeChild(this._modifiedOverviewRuler.getDomNode());
            this._modifiedOverviewRuler.dispose();
        }
        this._overviewDomElement.removeChild(this._overviewViewportDomElement.domNode);
        this._containerDomElement.removeChild(this._overviewDomElement);
        this._containerDomElement.removeChild(this._originalDomNode);
        this.originalEditor.dispose();
        this._containerDomElement.removeChild(this._modifiedDomNode);
        this.modifiedEditor.dispose();
        this._strategy.dispose();
        this._containerDomElement.removeChild(this._reviewPane.domNode.domNode);
        this._containerDomElement.removeChild(this._reviewPane.shadow.domNode);
        this._containerDomElement.removeChild(this._reviewPane.actionBarContainer.domNode);
        this._reviewPane.dispose();
        this._domElement.removeChild(this._containerDomElement);
        this._onDidDispose.fire();
        _super.prototype.dispose.call(this);
    };
    //------------ begin IDiffEditor methods
    DiffEditorWidget.prototype.getId = function () {
        return this.getEditorType() + ':' + this.id;
    };
    DiffEditorWidget.prototype.getEditorType = function () {
        return __WEBPACK_IMPORTED_MODULE_12__common_editorCommon_js__["a" /* EditorType */].IDiffEditor;
    };
    DiffEditorWidget.prototype.getLineChanges = function () {
        return this._lineChanges;
    };
    DiffEditorWidget.prototype.getOriginalEditor = function () {
        return this.originalEditor;
    };
    DiffEditorWidget.prototype.getModifiedEditor = function () {
        return this.modifiedEditor;
    };
    DiffEditorWidget.prototype.updateOptions = function (newOptions) {
        // Handle side by side
        var renderSideBySideChanged = false;
        if (typeof newOptions.renderSideBySide !== 'undefined') {
            if (this._renderSideBySide !== newOptions.renderSideBySide) {
                this._renderSideBySide = newOptions.renderSideBySide;
                renderSideBySideChanged = true;
            }
        }
        var beginUpdateDecorations = false;
        if (typeof newOptions.ignoreTrimWhitespace !== 'undefined') {
            if (this._ignoreTrimWhitespace !== newOptions.ignoreTrimWhitespace) {
                this._ignoreTrimWhitespace = newOptions.ignoreTrimWhitespace;
                // Begin comparing
                beginUpdateDecorations = true;
            }
        }
        if (typeof newOptions.renderIndicators !== 'undefined') {
            if (this._renderIndicators !== newOptions.renderIndicators) {
                this._renderIndicators = newOptions.renderIndicators;
                beginUpdateDecorations = true;
            }
        }
        if (beginUpdateDecorations) {
            this._beginUpdateDecorations();
        }
        if (typeof newOptions.originalEditable !== 'undefined') {
            this._originalIsEditable = Boolean(newOptions.originalEditable);
        }
        this.modifiedEditor.updateOptions(this._adjustOptionsForRightHandSide(newOptions));
        this.originalEditor.updateOptions(this._adjustOptionsForLeftHandSide(newOptions, this._originalIsEditable));
        // enableSplitViewResizing
        if (typeof newOptions.enableSplitViewResizing !== 'undefined') {
            this._enableSplitViewResizing = newOptions.enableSplitViewResizing;
        }
        this._strategy.setEnableSplitViewResizing(this._enableSplitViewResizing);
        // renderSideBySide
        if (renderSideBySideChanged) {
            if (this._renderSideBySide) {
                this._setStrategy(new DiffEdtorWidgetSideBySide(this._createDataSource(), this._enableSplitViewResizing));
            }
            else {
                this._setStrategy(new DiffEdtorWidgetInline(this._createDataSource(), this._enableSplitViewResizing));
            }
            // Update class name
            this._containerDomElement.className = DiffEditorWidget._getClassName(this._themeService.getTheme(), this._renderSideBySide);
        }
    };
    DiffEditorWidget.prototype.getModel = function () {
        return {
            original: this.originalEditor.getModel(),
            modified: this.modifiedEditor.getModel()
        };
    };
    DiffEditorWidget.prototype.setModel = function (model) {
        // Guard us against partial null model
        if (model && (!model.original || !model.modified)) {
            throw new Error(!model.original ? 'DiffEditorWidget.setModel: Original model is null' : 'DiffEditorWidget.setModel: Modified model is null');
        }
        // Remove all view zones & decorations
        this._cleanViewZonesAndDecorations();
        // Update code editor models
        this.originalEditor.setModel(model ? model.original : null);
        this.modifiedEditor.setModel(model ? model.modified : null);
        this._updateDecorationsRunner.cancel();
        if (model) {
            this.originalEditor.setScrollTop(0);
            this.modifiedEditor.setScrollTop(0);
        }
        // Disable any diff computations that will come in
        this._lineChanges = null;
        this._diffComputationToken++;
        if (model) {
            this._recreateOverviewRulers();
            // Begin comparing
            this._beginUpdateDecorations();
        }
        else {
            this._lineChanges = null;
        }
        this._layoutOverviewViewport();
    };
    DiffEditorWidget.prototype.getDomNode = function () {
        return this._domElement;
    };
    DiffEditorWidget.prototype.getVisibleColumnFromPosition = function (position) {
        return this.modifiedEditor.getVisibleColumnFromPosition(position);
    };
    DiffEditorWidget.prototype.getPosition = function () {
        return this.modifiedEditor.getPosition();
    };
    DiffEditorWidget.prototype.setPosition = function (position) {
        this.modifiedEditor.setPosition(position);
    };
    DiffEditorWidget.prototype.revealLine = function (lineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealLine(lineNumber, scrollType);
    };
    DiffEditorWidget.prototype.revealLineInCenter = function (lineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealLineInCenter(lineNumber, scrollType);
    };
    DiffEditorWidget.prototype.revealLineInCenterIfOutsideViewport = function (lineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealLineInCenterIfOutsideViewport(lineNumber, scrollType);
    };
    DiffEditorWidget.prototype.revealPosition = function (position, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealPosition(position, scrollType);
    };
    DiffEditorWidget.prototype.revealPositionInCenter = function (position, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealPositionInCenter(position, scrollType);
    };
    DiffEditorWidget.prototype.revealPositionInCenterIfOutsideViewport = function (position, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealPositionInCenterIfOutsideViewport(position, scrollType);
    };
    DiffEditorWidget.prototype.getSelection = function () {
        return this.modifiedEditor.getSelection();
    };
    DiffEditorWidget.prototype.getSelections = function () {
        return this.modifiedEditor.getSelections();
    };
    DiffEditorWidget.prototype.setSelection = function (something) {
        this.modifiedEditor.setSelection(something);
    };
    DiffEditorWidget.prototype.setSelections = function (ranges) {
        this.modifiedEditor.setSelections(ranges);
    };
    DiffEditorWidget.prototype.revealLines = function (startLineNumber, endLineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealLines(startLineNumber, endLineNumber, scrollType);
    };
    DiffEditorWidget.prototype.revealLinesInCenter = function (startLineNumber, endLineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealLinesInCenter(startLineNumber, endLineNumber, scrollType);
    };
    DiffEditorWidget.prototype.revealLinesInCenterIfOutsideViewport = function (startLineNumber, endLineNumber, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealLinesInCenterIfOutsideViewport(startLineNumber, endLineNumber, scrollType);
    };
    DiffEditorWidget.prototype.revealRange = function (range, scrollType, revealVerticalInCenter, revealHorizontal) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        if (revealVerticalInCenter === void 0) { revealVerticalInCenter = false; }
        if (revealHorizontal === void 0) { revealHorizontal = true; }
        this.modifiedEditor.revealRange(range, scrollType, revealVerticalInCenter, revealHorizontal);
    };
    DiffEditorWidget.prototype.revealRangeInCenter = function (range, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealRangeInCenter(range, scrollType);
    };
    DiffEditorWidget.prototype.revealRangeInCenterIfOutsideViewport = function (range, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealRangeInCenterIfOutsideViewport(range, scrollType);
    };
    DiffEditorWidget.prototype.revealRangeAtTop = function (range, scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this.modifiedEditor.revealRangeAtTop(range, scrollType);
    };
    DiffEditorWidget.prototype.getSupportedActions = function () {
        return this.modifiedEditor.getSupportedActions();
    };
    DiffEditorWidget.prototype.saveViewState = function () {
        var originalViewState = this.originalEditor.saveViewState();
        var modifiedViewState = this.modifiedEditor.saveViewState();
        return {
            original: originalViewState,
            modified: modifiedViewState
        };
    };
    DiffEditorWidget.prototype.restoreViewState = function (s) {
        if (s.original && s.original) {
            var diffEditorState = s;
            this.originalEditor.restoreViewState(diffEditorState.original);
            this.modifiedEditor.restoreViewState(diffEditorState.modified);
        }
    };
    DiffEditorWidget.prototype.layout = function (dimension) {
        this._measureDomElement(false, dimension);
    };
    DiffEditorWidget.prototype.focus = function () {
        this.modifiedEditor.focus();
    };
    DiffEditorWidget.prototype.hasTextFocus = function () {
        return this.originalEditor.hasTextFocus() || this.modifiedEditor.hasTextFocus();
    };
    DiffEditorWidget.prototype.trigger = function (source, handlerId, payload) {
        this.modifiedEditor.trigger(source, handlerId, payload);
    };
    DiffEditorWidget.prototype.changeDecorations = function (callback) {
        return this.modifiedEditor.changeDecorations(callback);
    };
    //------------ end IDiffEditor methods
    //------------ begin layouting methods
    DiffEditorWidget.prototype._measureDomElement = function (forceDoLayoutCall, dimensions) {
        dimensions = dimensions || {
            width: this._containerDomElement.clientWidth,
            height: this._containerDomElement.clientHeight
        };
        if (dimensions.width <= 0) {
            this._width = 0;
            this._height = 0;
            this._reviewHeight = 0;
            return;
        }
        if (!forceDoLayoutCall && dimensions.width === this._width && dimensions.height === this._height) {
            // Nothing has changed
            return;
        }
        this._width = dimensions.width;
        this._height = dimensions.height;
        this._reviewHeight = this._reviewPane.isVisible() ? this._height : 0;
        this._doLayout();
    };
    DiffEditorWidget.prototype._layoutOverviewRulers = function () {
        var freeSpace = DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH - 2 * DiffEditorWidget.ONE_OVERVIEW_WIDTH;
        var layoutInfo = this.modifiedEditor.getLayoutInfo();
        if (layoutInfo) {
            this._originalOverviewRuler.setLayout({
                top: 0,
                width: DiffEditorWidget.ONE_OVERVIEW_WIDTH,
                right: freeSpace + DiffEditorWidget.ONE_OVERVIEW_WIDTH,
                height: (this._height - this._reviewHeight)
            });
            this._modifiedOverviewRuler.setLayout({
                top: 0,
                right: 0,
                width: DiffEditorWidget.ONE_OVERVIEW_WIDTH,
                height: (this._height - this._reviewHeight)
            });
        }
    };
    //------------ end layouting methods
    DiffEditorWidget.prototype._onViewZonesChanged = function () {
        if (this._currentlyChangingViewZones) {
            return;
        }
        this._updateDecorationsRunner.schedule();
    };
    DiffEditorWidget.prototype._beginUpdateDecorationsSoon = function () {
        var _this = this;
        // Clear previous timeout if necessary
        if (this._beginUpdateDecorationsTimeout !== -1) {
            window.clearTimeout(this._beginUpdateDecorationsTimeout);
            this._beginUpdateDecorationsTimeout = -1;
        }
        this._beginUpdateDecorationsTimeout = window.setTimeout(function () { return _this._beginUpdateDecorations(); }, DiffEditorWidget.UPDATE_DIFF_DECORATIONS_DELAY);
    };
    DiffEditorWidget._equals = function (a, b) {
        if (!a && !b) {
            return true;
        }
        if (!a || !b) {
            return false;
        }
        return (a.toString() === b.toString());
    };
    DiffEditorWidget.prototype._beginUpdateDecorations = function () {
        var _this = this;
        this._beginUpdateDecorationsTimeout = -1;
        var currentOriginalModel = this.originalEditor.getModel();
        var currentModifiedModel = this.modifiedEditor.getModel();
        if (!currentOriginalModel || !currentModifiedModel) {
            return;
        }
        // Prevent old diff requests to come if a new request has been initiated
        // The best method would be to call cancel on the Promise, but this is not
        // yet supported, so using tokens for now.
        this._diffComputationToken++;
        var currentToken = this._diffComputationToken;
        if (!this._editorWorkerService.canComputeDiff(currentOriginalModel.uri, currentModifiedModel.uri)) {
            if (!DiffEditorWidget._equals(currentOriginalModel.uri, this._lastOriginalWarning)
                || !DiffEditorWidget._equals(currentModifiedModel.uri, this._lastModifiedWarning)) {
                this._lastOriginalWarning = currentOriginalModel.uri;
                this._lastModifiedWarning = currentModifiedModel.uri;
                this._notificationService.warn(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]("diff.tooLarge", "Cannot compare files because one file is too large."));
            }
            return;
        }
        this._editorWorkerService.computeDiff(currentOriginalModel.uri, currentModifiedModel.uri, this._ignoreTrimWhitespace).then(function (result) {
            if (currentToken === _this._diffComputationToken
                && currentOriginalModel === _this.originalEditor.getModel()
                && currentModifiedModel === _this.modifiedEditor.getModel()) {
                _this._lineChanges = result;
                _this._updateDecorationsRunner.schedule();
                _this._onDidUpdateDiff.fire();
            }
        }, function (error) {
            if (currentToken === _this._diffComputationToken
                && currentOriginalModel === _this.originalEditor.getModel()
                && currentModifiedModel === _this.modifiedEditor.getModel()) {
                _this._lineChanges = null;
                _this._updateDecorationsRunner.schedule();
            }
        });
    };
    DiffEditorWidget.prototype._cleanViewZonesAndDecorations = function () {
        this._originalEditorState.clean(this.originalEditor);
        this._modifiedEditorState.clean(this.modifiedEditor);
    };
    DiffEditorWidget.prototype._updateDecorations = function () {
        if (!this.originalEditor.getModel() || !this.modifiedEditor.getModel()) {
            return;
        }
        var lineChanges = this._lineChanges || [];
        var foreignOriginal = this._originalEditorState.getForeignViewZones(this.originalEditor.getWhitespaces());
        var foreignModified = this._modifiedEditorState.getForeignViewZones(this.modifiedEditor.getWhitespaces());
        var diffDecorations = this._strategy.getEditorsDiffDecorations(lineChanges, this._ignoreTrimWhitespace, this._renderIndicators, foreignOriginal, foreignModified, this.originalEditor, this.modifiedEditor);
        try {
            this._currentlyChangingViewZones = true;
            this._originalEditorState.apply(this.originalEditor, this._originalOverviewRuler, diffDecorations.original, false);
            this._modifiedEditorState.apply(this.modifiedEditor, this._modifiedOverviewRuler, diffDecorations.modified, true);
        }
        finally {
            this._currentlyChangingViewZones = false;
        }
    };
    DiffEditorWidget.prototype._adjustOptionsForSubEditor = function (options) {
        var clonedOptions = __WEBPACK_IMPORTED_MODULE_4__base_common_objects_js__["c" /* deepClone */](options || {});
        clonedOptions.inDiffEditor = true;
        clonedOptions.wordWrap = 'off';
        clonedOptions.wordWrapMinified = false;
        clonedOptions.automaticLayout = false;
        clonedOptions.scrollbar = clonedOptions.scrollbar || {};
        clonedOptions.scrollbar.vertical = 'visible';
        clonedOptions.folding = false;
        clonedOptions.codeLens = false;
        clonedOptions.fixedOverflowWidgets = true;
        clonedOptions.lineDecorationsWidth = '2ch';
        if (!clonedOptions.minimap) {
            clonedOptions.minimap = {};
        }
        clonedOptions.minimap.enabled = false;
        return clonedOptions;
    };
    DiffEditorWidget.prototype._adjustOptionsForLeftHandSide = function (options, isEditable) {
        var result = this._adjustOptionsForSubEditor(options);
        result.readOnly = !isEditable;
        result.overviewRulerLanes = 1;
        result.extraEditorClassName = 'original-in-monaco-diff-editor';
        return result;
    };
    DiffEditorWidget.prototype._adjustOptionsForRightHandSide = function (options) {
        var result = this._adjustOptionsForSubEditor(options);
        result.revealHorizontalRightPadding = __WEBPACK_IMPORTED_MODULE_21__common_config_editorOptions_js__["a" /* EDITOR_DEFAULTS */].viewInfo.revealHorizontalRightPadding + DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH;
        result.scrollbar.verticalHasArrows = false;
        result.extraEditorClassName = 'modified-in-monaco-diff-editor';
        return result;
    };
    DiffEditorWidget.prototype.doLayout = function () {
        this._measureDomElement(true);
    };
    DiffEditorWidget.prototype._doLayout = function () {
        var splitPoint = this._strategy.layout();
        this._originalDomNode.style.width = splitPoint + 'px';
        this._originalDomNode.style.left = '0px';
        this._modifiedDomNode.style.width = (this._width - splitPoint) + 'px';
        this._modifiedDomNode.style.left = splitPoint + 'px';
        this._overviewDomElement.style.top = '0px';
        this._overviewDomElement.style.height = (this._height - this._reviewHeight) + 'px';
        this._overviewDomElement.style.width = DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH + 'px';
        this._overviewDomElement.style.left = (this._width - DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH) + 'px';
        this._overviewViewportDomElement.setWidth(DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH);
        this._overviewViewportDomElement.setHeight(30);
        this.originalEditor.layout({ width: splitPoint, height: (this._height - this._reviewHeight) });
        this.modifiedEditor.layout({ width: this._width - splitPoint - DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH, height: (this._height - this._reviewHeight) });
        if (this._originalOverviewRuler || this._modifiedOverviewRuler) {
            this._layoutOverviewRulers();
        }
        this._reviewPane.layout(this._height - this._reviewHeight, this._width, this._reviewHeight);
        this._layoutOverviewViewport();
    };
    DiffEditorWidget.prototype._layoutOverviewViewport = function () {
        var layout = this._computeOverviewViewport();
        if (!layout) {
            this._overviewViewportDomElement.setTop(0);
            this._overviewViewportDomElement.setHeight(0);
        }
        else {
            this._overviewViewportDomElement.setTop(layout.top);
            this._overviewViewportDomElement.setHeight(layout.height);
        }
    };
    DiffEditorWidget.prototype._computeOverviewViewport = function () {
        var layoutInfo = this.modifiedEditor.getLayoutInfo();
        if (!layoutInfo) {
            return null;
        }
        var scrollTop = this.modifiedEditor.getScrollTop();
        var scrollHeight = this.modifiedEditor.getScrollHeight();
        var computedAvailableSize = Math.max(0, layoutInfo.contentHeight);
        var computedRepresentableSize = Math.max(0, computedAvailableSize - 2 * 0);
        var computedRatio = scrollHeight > 0 ? (computedRepresentableSize / scrollHeight) : 0;
        var computedSliderSize = Math.max(0, Math.floor(layoutInfo.contentHeight * computedRatio));
        var computedSliderPosition = Math.floor(scrollTop * computedRatio);
        return {
            height: computedSliderSize,
            top: computedSliderPosition
        };
    };
    DiffEditorWidget.prototype._createDataSource = function () {
        var _this = this;
        return {
            getWidth: function () {
                return _this._width;
            },
            getHeight: function () {
                return (_this._height - _this._reviewHeight);
            },
            getContainerDomNode: function () {
                return _this._containerDomElement;
            },
            relayoutEditors: function () {
                _this._doLayout();
            },
            getOriginalEditor: function () {
                return _this.originalEditor;
            },
            getModifiedEditor: function () {
                return _this.modifiedEditor;
            }
        };
    };
    DiffEditorWidget.prototype._setStrategy = function (newStrategy) {
        if (this._strategy) {
            this._strategy.dispose();
        }
        this._strategy = newStrategy;
        newStrategy.applyColors(this._themeService.getTheme());
        if (this._lineChanges) {
            this._updateDecorations();
        }
        // Just do a layout, the strategy might need it
        this._measureDomElement(true);
    };
    DiffEditorWidget.prototype._getLineChangeAtOrBeforeLineNumber = function (lineNumber, startLineNumberExtractor) {
        if (this._lineChanges.length === 0 || lineNumber < startLineNumberExtractor(this._lineChanges[0])) {
            // There are no changes or `lineNumber` is before the first change
            return null;
        }
        var min = 0, max = this._lineChanges.length - 1;
        while (min < max) {
            var mid = Math.floor((min + max) / 2);
            var midStart = startLineNumberExtractor(this._lineChanges[mid]);
            var midEnd = (mid + 1 <= max ? startLineNumberExtractor(this._lineChanges[mid + 1]) : Number.MAX_VALUE);
            if (lineNumber < midStart) {
                max = mid - 1;
            }
            else if (lineNumber >= midEnd) {
                min = mid + 1;
            }
            else {
                // HIT!
                min = mid;
                max = mid;
            }
        }
        return this._lineChanges[min];
    };
    DiffEditorWidget.prototype._getEquivalentLineForOriginalLineNumber = function (lineNumber) {
        var lineChange = this._getLineChangeAtOrBeforeLineNumber(lineNumber, function (lineChange) { return lineChange.originalStartLineNumber; });
        if (!lineChange) {
            return lineNumber;
        }
        var originalEquivalentLineNumber = lineChange.originalStartLineNumber + (lineChange.originalEndLineNumber > 0 ? -1 : 0);
        var modifiedEquivalentLineNumber = lineChange.modifiedStartLineNumber + (lineChange.modifiedEndLineNumber > 0 ? -1 : 0);
        var lineChangeOriginalLength = (lineChange.originalEndLineNumber > 0 ? (lineChange.originalEndLineNumber - lineChange.originalStartLineNumber + 1) : 0);
        var lineChangeModifiedLength = (lineChange.modifiedEndLineNumber > 0 ? (lineChange.modifiedEndLineNumber - lineChange.modifiedStartLineNumber + 1) : 0);
        var delta = lineNumber - originalEquivalentLineNumber;
        if (delta <= lineChangeOriginalLength) {
            return modifiedEquivalentLineNumber + Math.min(delta, lineChangeModifiedLength);
        }
        return modifiedEquivalentLineNumber + lineChangeModifiedLength - lineChangeOriginalLength + delta;
    };
    DiffEditorWidget.prototype._getEquivalentLineForModifiedLineNumber = function (lineNumber) {
        var lineChange = this._getLineChangeAtOrBeforeLineNumber(lineNumber, function (lineChange) { return lineChange.modifiedStartLineNumber; });
        if (!lineChange) {
            return lineNumber;
        }
        var originalEquivalentLineNumber = lineChange.originalStartLineNumber + (lineChange.originalEndLineNumber > 0 ? -1 : 0);
        var modifiedEquivalentLineNumber = lineChange.modifiedStartLineNumber + (lineChange.modifiedEndLineNumber > 0 ? -1 : 0);
        var lineChangeOriginalLength = (lineChange.originalEndLineNumber > 0 ? (lineChange.originalEndLineNumber - lineChange.originalStartLineNumber + 1) : 0);
        var lineChangeModifiedLength = (lineChange.modifiedEndLineNumber > 0 ? (lineChange.modifiedEndLineNumber - lineChange.modifiedStartLineNumber + 1) : 0);
        var delta = lineNumber - modifiedEquivalentLineNumber;
        if (delta <= lineChangeModifiedLength) {
            return originalEquivalentLineNumber + Math.min(delta, lineChangeOriginalLength);
        }
        return originalEquivalentLineNumber + lineChangeOriginalLength - lineChangeModifiedLength + delta;
    };
    DiffEditorWidget.prototype.getDiffLineInformationForOriginal = function (lineNumber) {
        if (!this._lineChanges) {
            // Cannot answer that which I don't know
            return null;
        }
        return {
            equivalentLineNumber: this._getEquivalentLineForOriginalLineNumber(lineNumber)
        };
    };
    DiffEditorWidget.prototype.getDiffLineInformationForModified = function (lineNumber) {
        if (!this._lineChanges) {
            // Cannot answer that which I don't know
            return null;
        }
        return {
            equivalentLineNumber: this._getEquivalentLineForModifiedLineNumber(lineNumber)
        };
    };
    DiffEditorWidget.ONE_OVERVIEW_WIDTH = 15;
    DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH = 30;
    DiffEditorWidget.UPDATE_DIFF_DECORATIONS_DELAY = 200; // ms
    DiffEditorWidget = __decorate([
        __param(2, __WEBPACK_IMPORTED_MODULE_13__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_10__services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_22__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_28__platform_notification_common_notification_js__["a" /* INotificationService */])
    ], DiffEditorWidget);
    return DiffEditorWidget;
}(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["a" /* Disposable */]));

var DiffEditorWidgetStyle = /** @class */ (function (_super) {
    __extends(DiffEditorWidgetStyle, _super);
    function DiffEditorWidgetStyle(dataSource) {
        var _this = _super.call(this) || this;
        _this._dataSource = dataSource;
        return _this;
    }
    DiffEditorWidgetStyle.prototype.applyColors = function (theme) {
        var newInsertColor = (theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["i" /* diffInserted */]) || __WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["f" /* defaultInsertColor */]).transparent(2);
        var newRemoveColor = (theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["k" /* diffRemoved */]) || __WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["g" /* defaultRemoveColor */]).transparent(2);
        var hasChanges = !newInsertColor.equals(this._insertColor) || !newRemoveColor.equals(this._removeColor);
        this._insertColor = newInsertColor;
        this._removeColor = newRemoveColor;
        return hasChanges;
    };
    DiffEditorWidgetStyle.prototype.getEditorsDiffDecorations = function (lineChanges, ignoreTrimWhitespace, renderIndicators, originalWhitespaces, modifiedWhitespaces, originalEditor, modifiedEditor) {
        // Get view zones
        modifiedWhitespaces = modifiedWhitespaces.sort(function (a, b) {
            return a.afterLineNumber - b.afterLineNumber;
        });
        originalWhitespaces = originalWhitespaces.sort(function (a, b) {
            return a.afterLineNumber - b.afterLineNumber;
        });
        var zones = this._getViewZones(lineChanges, originalWhitespaces, modifiedWhitespaces, originalEditor, modifiedEditor, renderIndicators);
        // Get decorations & overview ruler zones
        var originalDecorations = this._getOriginalEditorDecorations(lineChanges, ignoreTrimWhitespace, renderIndicators, originalEditor, modifiedEditor);
        var modifiedDecorations = this._getModifiedEditorDecorations(lineChanges, ignoreTrimWhitespace, renderIndicators, originalEditor, modifiedEditor);
        return {
            original: {
                decorations: originalDecorations.decorations,
                overviewZones: originalDecorations.overviewZones,
                zones: zones.original
            },
            modified: {
                decorations: modifiedDecorations.decorations,
                overviewZones: modifiedDecorations.overviewZones,
                zones: zones.modified
            }
        };
    };
    return DiffEditorWidgetStyle;
}(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["a" /* Disposable */]));
var ForeignViewZonesIterator = /** @class */ (function () {
    function ForeignViewZonesIterator(source) {
        this._source = source;
        this._index = -1;
        this.advance();
    }
    ForeignViewZonesIterator.prototype.advance = function () {
        this._index++;
        if (this._index < this._source.length) {
            this.current = this._source[this._index];
        }
        else {
            this.current = null;
        }
    };
    return ForeignViewZonesIterator;
}());
var ViewZonesComputer = /** @class */ (function () {
    function ViewZonesComputer(lineChanges, originalForeignVZ, modifiedForeignVZ) {
        this.lineChanges = lineChanges;
        this.originalForeignVZ = originalForeignVZ;
        this.modifiedForeignVZ = modifiedForeignVZ;
    }
    ViewZonesComputer.prototype.getViewZones = function () {
        var result = {
            original: [],
            modified: []
        };
        var lineChangeModifiedLength = 0;
        var lineChangeOriginalLength = 0;
        var originalEquivalentLineNumber = 0;
        var modifiedEquivalentLineNumber = 0;
        var originalEndEquivalentLineNumber = 0;
        var modifiedEndEquivalentLineNumber = 0;
        var sortMyViewZones = function (a, b) {
            return a.afterLineNumber - b.afterLineNumber;
        };
        var addAndCombineIfPossible = function (destination, item) {
            if (item.domNode === null && destination.length > 0) {
                var lastItem = destination[destination.length - 1];
                if (lastItem.afterLineNumber === item.afterLineNumber && lastItem.domNode === null) {
                    lastItem.heightInLines += item.heightInLines;
                    return;
                }
            }
            destination.push(item);
        };
        var modifiedForeignVZ = new ForeignViewZonesIterator(this.modifiedForeignVZ);
        var originalForeignVZ = new ForeignViewZonesIterator(this.originalForeignVZ);
        // In order to include foreign view zones after the last line change, the for loop will iterate once more after the end of the `lineChanges` array
        for (var i = 0, length_4 = this.lineChanges.length; i <= length_4; i++) {
            var lineChange = (i < length_4 ? this.lineChanges[i] : null);
            if (lineChange !== null) {
                originalEquivalentLineNumber = lineChange.originalStartLineNumber + (lineChange.originalEndLineNumber > 0 ? -1 : 0);
                modifiedEquivalentLineNumber = lineChange.modifiedStartLineNumber + (lineChange.modifiedEndLineNumber > 0 ? -1 : 0);
                lineChangeOriginalLength = (lineChange.originalEndLineNumber > 0 ? (lineChange.originalEndLineNumber - lineChange.originalStartLineNumber + 1) : 0);
                lineChangeModifiedLength = (lineChange.modifiedEndLineNumber > 0 ? (lineChange.modifiedEndLineNumber - lineChange.modifiedStartLineNumber + 1) : 0);
                originalEndEquivalentLineNumber = Math.max(lineChange.originalStartLineNumber, lineChange.originalEndLineNumber);
                modifiedEndEquivalentLineNumber = Math.max(lineChange.modifiedStartLineNumber, lineChange.modifiedEndLineNumber);
            }
            else {
                // Increase to very large value to get the producing tests of foreign view zones running
                originalEquivalentLineNumber += 10000000 + lineChangeOriginalLength;
                modifiedEquivalentLineNumber += 10000000 + lineChangeModifiedLength;
                originalEndEquivalentLineNumber = originalEquivalentLineNumber;
                modifiedEndEquivalentLineNumber = modifiedEquivalentLineNumber;
            }
            // Each step produces view zones, and after producing them, we try to cancel them out, to avoid empty-empty view zone cases
            var stepOriginal = [];
            var stepModified = [];
            // ---------------------------- PRODUCE VIEW ZONES
            // [PRODUCE] View zone(s) in original-side due to foreign view zone(s) in modified-side
            while (modifiedForeignVZ.current && modifiedForeignVZ.current.afterLineNumber <= modifiedEndEquivalentLineNumber) {
                var viewZoneLineNumber = void 0;
                if (modifiedForeignVZ.current.afterLineNumber <= modifiedEquivalentLineNumber) {
                    viewZoneLineNumber = originalEquivalentLineNumber - modifiedEquivalentLineNumber + modifiedForeignVZ.current.afterLineNumber;
                }
                else {
                    viewZoneLineNumber = originalEndEquivalentLineNumber;
                }
                stepOriginal.push({
                    afterLineNumber: viewZoneLineNumber,
                    heightInLines: modifiedForeignVZ.current.heightInLines,
                    domNode: null
                });
                modifiedForeignVZ.advance();
            }
            // [PRODUCE] View zone(s) in modified-side due to foreign view zone(s) in original-side
            while (originalForeignVZ.current && originalForeignVZ.current.afterLineNumber <= originalEndEquivalentLineNumber) {
                var viewZoneLineNumber = void 0;
                if (originalForeignVZ.current.afterLineNumber <= originalEquivalentLineNumber) {
                    viewZoneLineNumber = modifiedEquivalentLineNumber - originalEquivalentLineNumber + originalForeignVZ.current.afterLineNumber;
                }
                else {
                    viewZoneLineNumber = modifiedEndEquivalentLineNumber;
                }
                stepModified.push({
                    afterLineNumber: viewZoneLineNumber,
                    heightInLines: originalForeignVZ.current.heightInLines,
                    domNode: null
                });
                originalForeignVZ.advance();
            }
            if (lineChange !== null && isChangeOrInsert(lineChange)) {
                var r = this._produceOriginalFromDiff(lineChange, lineChangeOriginalLength, lineChangeModifiedLength);
                if (r) {
                    stepOriginal.push(r);
                }
            }
            if (lineChange !== null && isChangeOrDelete(lineChange)) {
                var r = this._produceModifiedFromDiff(lineChange, lineChangeOriginalLength, lineChangeModifiedLength);
                if (r) {
                    stepModified.push(r);
                }
            }
            // ---------------------------- END PRODUCE VIEW ZONES
            // ---------------------------- EMIT MINIMAL VIEW ZONES
            // [CANCEL & EMIT] Try to cancel view zones out
            var stepOriginalIndex = 0;
            var stepModifiedIndex = 0;
            stepOriginal = stepOriginal.sort(sortMyViewZones);
            stepModified = stepModified.sort(sortMyViewZones);
            while (stepOriginalIndex < stepOriginal.length && stepModifiedIndex < stepModified.length) {
                var original = stepOriginal[stepOriginalIndex];
                var modified = stepModified[stepModifiedIndex];
                var originalDelta = original.afterLineNumber - originalEquivalentLineNumber;
                var modifiedDelta = modified.afterLineNumber - modifiedEquivalentLineNumber;
                if (originalDelta < modifiedDelta) {
                    addAndCombineIfPossible(result.original, original);
                    stepOriginalIndex++;
                }
                else if (modifiedDelta < originalDelta) {
                    addAndCombineIfPossible(result.modified, modified);
                    stepModifiedIndex++;
                }
                else if (original.shouldNotShrink) {
                    addAndCombineIfPossible(result.original, original);
                    stepOriginalIndex++;
                }
                else if (modified.shouldNotShrink) {
                    addAndCombineIfPossible(result.modified, modified);
                    stepModifiedIndex++;
                }
                else {
                    if (original.heightInLines >= modified.heightInLines) {
                        // modified view zone gets removed
                        original.heightInLines -= modified.heightInLines;
                        stepModifiedIndex++;
                    }
                    else {
                        // original view zone gets removed
                        modified.heightInLines -= original.heightInLines;
                        stepOriginalIndex++;
                    }
                }
            }
            // [EMIT] Remaining original view zones
            while (stepOriginalIndex < stepOriginal.length) {
                addAndCombineIfPossible(result.original, stepOriginal[stepOriginalIndex]);
                stepOriginalIndex++;
            }
            // [EMIT] Remaining modified view zones
            while (stepModifiedIndex < stepModified.length) {
                addAndCombineIfPossible(result.modified, stepModified[stepModifiedIndex]);
                stepModifiedIndex++;
            }
            // ---------------------------- END EMIT MINIMAL VIEW ZONES
        }
        var ensureDomNode = function (z) {
            if (!z.domNode) {
                z.domNode = createFakeLinesDiv();
            }
        };
        result.original.forEach(ensureDomNode);
        result.modified.forEach(ensureDomNode);
        return result;
    };
    return ViewZonesComputer;
}());
function createDecoration(startLineNumber, startColumn, endLineNumber, endColumn, options) {
    return {
        range: new __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn),
        options: options
    };
}
var DECORATIONS = {
    charDelete: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'char-delete'
    }),
    charDeleteWholeLine: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'char-delete',
        isWholeLine: true
    }),
    charInsert: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'char-insert'
    }),
    charInsertWholeLine: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'char-insert',
        isWholeLine: true
    }),
    lineInsert: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'line-insert',
        marginClassName: 'line-insert',
        isWholeLine: true
    }),
    lineInsertWithSign: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'line-insert',
        linesDecorationsClassName: 'insert-sign',
        marginClassName: 'line-insert',
        isWholeLine: true
    }),
    lineDelete: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'line-delete',
        marginClassName: 'line-delete',
        isWholeLine: true
    }),
    lineDeleteWithSign: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'line-delete',
        linesDecorationsClassName: 'delete-sign',
        marginClassName: 'line-delete',
        isWholeLine: true
    }),
    lineDeleteMargin: __WEBPACK_IMPORTED_MODULE_25__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        marginClassName: 'line-delete',
    })
};
var DiffEdtorWidgetSideBySide = /** @class */ (function (_super) {
    __extends(DiffEdtorWidgetSideBySide, _super);
    function DiffEdtorWidgetSideBySide(dataSource, enableSplitViewResizing) {
        var _this = _super.call(this, dataSource) || this;
        _this._disableSash = (enableSplitViewResizing === false);
        _this._sashRatio = null;
        _this._sashPosition = null;
        _this._sash = _this._register(new __WEBPACK_IMPORTED_MODULE_7__base_browser_ui_sash_sash_js__["b" /* Sash */](_this._dataSource.getContainerDomNode(), _this));
        if (_this._disableSash) {
            _this._sash.state = __WEBPACK_IMPORTED_MODULE_7__base_browser_ui_sash_sash_js__["c" /* SashState */].Disabled;
        }
        _this._sash.onDidStart(function () { return _this.onSashDragStart(); });
        _this._sash.onDidChange(function (e) { return _this.onSashDrag(e); });
        _this._sash.onDidEnd(function () { return _this.onSashDragEnd(); });
        _this._sash.onDidReset(function () { return _this.onSashReset(); });
        return _this;
    }
    DiffEdtorWidgetSideBySide.prototype.setEnableSplitViewResizing = function (enableSplitViewResizing) {
        var newDisableSash = (enableSplitViewResizing === false);
        if (this._disableSash !== newDisableSash) {
            this._disableSash = newDisableSash;
            this._sash.state = this._disableSash ? __WEBPACK_IMPORTED_MODULE_7__base_browser_ui_sash_sash_js__["c" /* SashState */].Disabled : __WEBPACK_IMPORTED_MODULE_7__base_browser_ui_sash_sash_js__["c" /* SashState */].Enabled;
        }
    };
    DiffEdtorWidgetSideBySide.prototype.layout = function (sashRatio) {
        if (sashRatio === void 0) { sashRatio = this._sashRatio; }
        var w = this._dataSource.getWidth();
        var contentWidth = w - DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH;
        var sashPosition = Math.floor((sashRatio || 0.5) * contentWidth);
        var midPoint = Math.floor(0.5 * contentWidth);
        sashPosition = this._disableSash ? midPoint : sashPosition || midPoint;
        if (contentWidth > DiffEdtorWidgetSideBySide.MINIMUM_EDITOR_WIDTH * 2) {
            if (sashPosition < DiffEdtorWidgetSideBySide.MINIMUM_EDITOR_WIDTH) {
                sashPosition = DiffEdtorWidgetSideBySide.MINIMUM_EDITOR_WIDTH;
            }
            if (sashPosition > contentWidth - DiffEdtorWidgetSideBySide.MINIMUM_EDITOR_WIDTH) {
                sashPosition = contentWidth - DiffEdtorWidgetSideBySide.MINIMUM_EDITOR_WIDTH;
            }
        }
        else {
            sashPosition = midPoint;
        }
        if (this._sashPosition !== sashPosition) {
            this._sashPosition = sashPosition;
            this._sash.layout();
        }
        return this._sashPosition;
    };
    DiffEdtorWidgetSideBySide.prototype.onSashDragStart = function () {
        this._startSashPosition = this._sashPosition;
    };
    DiffEdtorWidgetSideBySide.prototype.onSashDrag = function (e) {
        var w = this._dataSource.getWidth();
        var contentWidth = w - DiffEditorWidget.ENTIRE_DIFF_OVERVIEW_WIDTH;
        var sashPosition = this.layout((this._startSashPosition + (e.currentX - e.startX)) / contentWidth);
        this._sashRatio = sashPosition / contentWidth;
        this._dataSource.relayoutEditors();
    };
    DiffEdtorWidgetSideBySide.prototype.onSashDragEnd = function () {
        this._sash.layout();
    };
    DiffEdtorWidgetSideBySide.prototype.onSashReset = function () {
        this._sashRatio = 0.5;
        this._dataSource.relayoutEditors();
        this._sash.layout();
    };
    DiffEdtorWidgetSideBySide.prototype.getVerticalSashTop = function (sash) {
        return 0;
    };
    DiffEdtorWidgetSideBySide.prototype.getVerticalSashLeft = function (sash) {
        return this._sashPosition;
    };
    DiffEdtorWidgetSideBySide.prototype.getVerticalSashHeight = function (sash) {
        return this._dataSource.getHeight();
    };
    DiffEdtorWidgetSideBySide.prototype._getViewZones = function (lineChanges, originalForeignVZ, modifiedForeignVZ, originalEditor, modifiedEditor) {
        var c = new SideBySideViewZonesComputer(lineChanges, originalForeignVZ, modifiedForeignVZ);
        return c.getViewZones();
    };
    DiffEdtorWidgetSideBySide.prototype._getOriginalEditorDecorations = function (lineChanges, ignoreTrimWhitespace, renderIndicators, originalEditor, modifiedEditor) {
        var overviewZoneColor = this._removeColor.toString();
        var result = {
            decorations: [],
            overviewZones: []
        };
        var originalModel = originalEditor.getModel();
        for (var i = 0, length_5 = lineChanges.length; i < length_5; i++) {
            var lineChange = lineChanges[i];
            if (isChangeOrDelete(lineChange)) {
                result.decorations.push({
                    range: new __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */](lineChange.originalStartLineNumber, 1, lineChange.originalEndLineNumber, Number.MAX_VALUE),
                    options: (renderIndicators ? DECORATIONS.lineDeleteWithSign : DECORATIONS.lineDelete)
                });
                if (!isChangeOrInsert(lineChange) || !lineChange.charChanges) {
                    result.decorations.push(createDecoration(lineChange.originalStartLineNumber, 1, lineChange.originalEndLineNumber, Number.MAX_VALUE, DECORATIONS.charDeleteWholeLine));
                }
                result.overviewZones.push(new __WEBPACK_IMPORTED_MODULE_24__common_view_overviewZoneManager_js__["a" /* OverviewRulerZone */](lineChange.originalStartLineNumber, lineChange.originalEndLineNumber, overviewZoneColor));
                if (lineChange.charChanges) {
                    for (var j = 0, lengthJ = lineChange.charChanges.length; j < lengthJ; j++) {
                        var charChange = lineChange.charChanges[j];
                        if (isChangeOrDelete(charChange)) {
                            if (ignoreTrimWhitespace) {
                                for (var lineNumber = charChange.originalStartLineNumber; lineNumber <= charChange.originalEndLineNumber; lineNumber++) {
                                    var startColumn = void 0;
                                    var endColumn = void 0;
                                    if (lineNumber === charChange.originalStartLineNumber) {
                                        startColumn = charChange.originalStartColumn;
                                    }
                                    else {
                                        startColumn = originalModel.getLineFirstNonWhitespaceColumn(lineNumber);
                                    }
                                    if (lineNumber === charChange.originalEndLineNumber) {
                                        endColumn = charChange.originalEndColumn;
                                    }
                                    else {
                                        endColumn = originalModel.getLineLastNonWhitespaceColumn(lineNumber);
                                    }
                                    result.decorations.push(createDecoration(lineNumber, startColumn, lineNumber, endColumn, DECORATIONS.charDelete));
                                }
                            }
                            else {
                                result.decorations.push(createDecoration(charChange.originalStartLineNumber, charChange.originalStartColumn, charChange.originalEndLineNumber, charChange.originalEndColumn, DECORATIONS.charDelete));
                            }
                        }
                    }
                }
            }
        }
        return result;
    };
    DiffEdtorWidgetSideBySide.prototype._getModifiedEditorDecorations = function (lineChanges, ignoreTrimWhitespace, renderIndicators, originalEditor, modifiedEditor) {
        var overviewZoneColor = this._insertColor.toString();
        var result = {
            decorations: [],
            overviewZones: []
        };
        var modifiedModel = modifiedEditor.getModel();
        for (var i = 0, length_6 = lineChanges.length; i < length_6; i++) {
            var lineChange = lineChanges[i];
            if (isChangeOrInsert(lineChange)) {
                result.decorations.push({
                    range: new __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */](lineChange.modifiedStartLineNumber, 1, lineChange.modifiedEndLineNumber, Number.MAX_VALUE),
                    options: (renderIndicators ? DECORATIONS.lineInsertWithSign : DECORATIONS.lineInsert)
                });
                if (!isChangeOrDelete(lineChange) || !lineChange.charChanges) {
                    result.decorations.push(createDecoration(lineChange.modifiedStartLineNumber, 1, lineChange.modifiedEndLineNumber, Number.MAX_VALUE, DECORATIONS.charInsertWholeLine));
                }
                result.overviewZones.push(new __WEBPACK_IMPORTED_MODULE_24__common_view_overviewZoneManager_js__["a" /* OverviewRulerZone */](lineChange.modifiedStartLineNumber, lineChange.modifiedEndLineNumber, overviewZoneColor));
                if (lineChange.charChanges) {
                    for (var j = 0, lengthJ = lineChange.charChanges.length; j < lengthJ; j++) {
                        var charChange = lineChange.charChanges[j];
                        if (isChangeOrInsert(charChange)) {
                            if (ignoreTrimWhitespace) {
                                for (var lineNumber = charChange.modifiedStartLineNumber; lineNumber <= charChange.modifiedEndLineNumber; lineNumber++) {
                                    var startColumn = void 0;
                                    var endColumn = void 0;
                                    if (lineNumber === charChange.modifiedStartLineNumber) {
                                        startColumn = charChange.modifiedStartColumn;
                                    }
                                    else {
                                        startColumn = modifiedModel.getLineFirstNonWhitespaceColumn(lineNumber);
                                    }
                                    if (lineNumber === charChange.modifiedEndLineNumber) {
                                        endColumn = charChange.modifiedEndColumn;
                                    }
                                    else {
                                        endColumn = modifiedModel.getLineLastNonWhitespaceColumn(lineNumber);
                                    }
                                    result.decorations.push(createDecoration(lineNumber, startColumn, lineNumber, endColumn, DECORATIONS.charInsert));
                                }
                            }
                            else {
                                result.decorations.push(createDecoration(charChange.modifiedStartLineNumber, charChange.modifiedStartColumn, charChange.modifiedEndLineNumber, charChange.modifiedEndColumn, DECORATIONS.charInsert));
                            }
                        }
                    }
                }
            }
        }
        return result;
    };
    DiffEdtorWidgetSideBySide.MINIMUM_EDITOR_WIDTH = 100;
    return DiffEdtorWidgetSideBySide;
}(DiffEditorWidgetStyle));
var SideBySideViewZonesComputer = /** @class */ (function (_super) {
    __extends(SideBySideViewZonesComputer, _super);
    function SideBySideViewZonesComputer(lineChanges, originalForeignVZ, modifiedForeignVZ) {
        return _super.call(this, lineChanges, originalForeignVZ, modifiedForeignVZ) || this;
    }
    SideBySideViewZonesComputer.prototype._produceOriginalFromDiff = function (lineChange, lineChangeOriginalLength, lineChangeModifiedLength) {
        if (lineChangeModifiedLength > lineChangeOriginalLength) {
            return {
                afterLineNumber: Math.max(lineChange.originalStartLineNumber, lineChange.originalEndLineNumber),
                heightInLines: (lineChangeModifiedLength - lineChangeOriginalLength),
                domNode: null
            };
        }
        return null;
    };
    SideBySideViewZonesComputer.prototype._produceModifiedFromDiff = function (lineChange, lineChangeOriginalLength, lineChangeModifiedLength) {
        if (lineChangeOriginalLength > lineChangeModifiedLength) {
            return {
                afterLineNumber: Math.max(lineChange.modifiedStartLineNumber, lineChange.modifiedEndLineNumber),
                heightInLines: (lineChangeOriginalLength - lineChangeModifiedLength),
                domNode: null
            };
        }
        return null;
    };
    return SideBySideViewZonesComputer;
}(ViewZonesComputer));
var DiffEdtorWidgetInline = /** @class */ (function (_super) {
    __extends(DiffEdtorWidgetInline, _super);
    function DiffEdtorWidgetInline(dataSource, enableSplitViewResizing) {
        var _this = _super.call(this, dataSource) || this;
        _this.decorationsLeft = dataSource.getOriginalEditor().getLayoutInfo().decorationsLeft;
        _this._register(dataSource.getOriginalEditor().onDidLayoutChange(function (layoutInfo) {
            if (_this.decorationsLeft !== layoutInfo.decorationsLeft) {
                _this.decorationsLeft = layoutInfo.decorationsLeft;
                dataSource.relayoutEditors();
            }
        }));
        return _this;
    }
    DiffEdtorWidgetInline.prototype.setEnableSplitViewResizing = function (enableSplitViewResizing) {
        // Nothing to do..
    };
    DiffEdtorWidgetInline.prototype._getViewZones = function (lineChanges, originalForeignVZ, modifiedForeignVZ, originalEditor, modifiedEditor, renderIndicators) {
        var computer = new InlineViewZonesComputer(lineChanges, originalForeignVZ, modifiedForeignVZ, originalEditor, modifiedEditor, renderIndicators);
        return computer.getViewZones();
    };
    DiffEdtorWidgetInline.prototype._getOriginalEditorDecorations = function (lineChanges, ignoreTrimWhitespace, renderIndicators, originalEditor, modifiedEditor) {
        var overviewZoneColor = this._removeColor.toString();
        var result = {
            decorations: [],
            overviewZones: []
        };
        for (var i = 0, length_7 = lineChanges.length; i < length_7; i++) {
            var lineChange = lineChanges[i];
            // Add overview zones in the overview ruler
            if (isChangeOrDelete(lineChange)) {
                result.decorations.push({
                    range: new __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */](lineChange.originalStartLineNumber, 1, lineChange.originalEndLineNumber, Number.MAX_VALUE),
                    options: DECORATIONS.lineDeleteMargin
                });
                result.overviewZones.push(new __WEBPACK_IMPORTED_MODULE_24__common_view_overviewZoneManager_js__["a" /* OverviewRulerZone */](lineChange.originalStartLineNumber, lineChange.originalEndLineNumber, overviewZoneColor));
            }
        }
        return result;
    };
    DiffEdtorWidgetInline.prototype._getModifiedEditorDecorations = function (lineChanges, ignoreTrimWhitespace, renderIndicators, originalEditor, modifiedEditor) {
        var overviewZoneColor = this._insertColor.toString();
        var result = {
            decorations: [],
            overviewZones: []
        };
        var modifiedModel = modifiedEditor.getModel();
        for (var i = 0, length_8 = lineChanges.length; i < length_8; i++) {
            var lineChange = lineChanges[i];
            // Add decorations & overview zones
            if (isChangeOrInsert(lineChange)) {
                result.decorations.push({
                    range: new __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */](lineChange.modifiedStartLineNumber, 1, lineChange.modifiedEndLineNumber, Number.MAX_VALUE),
                    options: (renderIndicators ? DECORATIONS.lineInsertWithSign : DECORATIONS.lineInsert)
                });
                result.overviewZones.push(new __WEBPACK_IMPORTED_MODULE_24__common_view_overviewZoneManager_js__["a" /* OverviewRulerZone */](lineChange.modifiedStartLineNumber, lineChange.modifiedEndLineNumber, overviewZoneColor));
                if (lineChange.charChanges) {
                    for (var j = 0, lengthJ = lineChange.charChanges.length; j < lengthJ; j++) {
                        var charChange = lineChange.charChanges[j];
                        if (isChangeOrInsert(charChange)) {
                            if (ignoreTrimWhitespace) {
                                for (var lineNumber = charChange.modifiedStartLineNumber; lineNumber <= charChange.modifiedEndLineNumber; lineNumber++) {
                                    var startColumn = void 0;
                                    var endColumn = void 0;
                                    if (lineNumber === charChange.modifiedStartLineNumber) {
                                        startColumn = charChange.modifiedStartColumn;
                                    }
                                    else {
                                        startColumn = modifiedModel.getLineFirstNonWhitespaceColumn(lineNumber);
                                    }
                                    if (lineNumber === charChange.modifiedEndLineNumber) {
                                        endColumn = charChange.modifiedEndColumn;
                                    }
                                    else {
                                        endColumn = modifiedModel.getLineLastNonWhitespaceColumn(lineNumber);
                                    }
                                    result.decorations.push(createDecoration(lineNumber, startColumn, lineNumber, endColumn, DECORATIONS.charInsert));
                                }
                            }
                            else {
                                result.decorations.push(createDecoration(charChange.modifiedStartLineNumber, charChange.modifiedStartColumn, charChange.modifiedEndLineNumber, charChange.modifiedEndColumn, DECORATIONS.charInsert));
                            }
                        }
                    }
                }
                else {
                    result.decorations.push(createDecoration(lineChange.modifiedStartLineNumber, 1, lineChange.modifiedEndLineNumber, Number.MAX_VALUE, DECORATIONS.charInsertWholeLine));
                }
            }
        }
        return result;
    };
    DiffEdtorWidgetInline.prototype.layout = function () {
        // An editor should not be smaller than 5px
        return Math.max(5, this.decorationsLeft);
    };
    return DiffEdtorWidgetInline;
}(DiffEditorWidgetStyle));
var InlineViewZonesComputer = /** @class */ (function (_super) {
    __extends(InlineViewZonesComputer, _super);
    function InlineViewZonesComputer(lineChanges, originalForeignVZ, modifiedForeignVZ, originalEditor, modifiedEditor, renderIndicators) {
        var _this = _super.call(this, lineChanges, originalForeignVZ, modifiedForeignVZ) || this;
        _this.originalModel = originalEditor.getModel();
        _this.modifiedEditorConfiguration = modifiedEditor.getConfiguration();
        _this.modifiedEditorTabSize = modifiedEditor.getModel().getOptions().tabSize;
        _this.renderIndicators = renderIndicators;
        return _this;
    }
    InlineViewZonesComputer.prototype._produceOriginalFromDiff = function (lineChange, lineChangeOriginalLength, lineChangeModifiedLength) {
        var marginDomNode = document.createElement('div');
        marginDomNode.className = 'inline-added-margin-view-zone';
        __WEBPACK_IMPORTED_MODULE_17__config_configuration_js__["a" /* Configuration */].applyFontInfoSlow(marginDomNode, this.modifiedEditorConfiguration.fontInfo);
        return {
            afterLineNumber: Math.max(lineChange.originalStartLineNumber, lineChange.originalEndLineNumber),
            heightInLines: lineChangeModifiedLength,
            domNode: document.createElement('div'),
            marginDomNode: marginDomNode
        };
    };
    InlineViewZonesComputer.prototype._produceModifiedFromDiff = function (lineChange, lineChangeOriginalLength, lineChangeModifiedLength) {
        var decorations = [];
        if (lineChange.charChanges) {
            for (var j = 0, lengthJ = lineChange.charChanges.length; j < lengthJ; j++) {
                var charChange = lineChange.charChanges[j];
                if (isChangeOrDelete(charChange)) {
                    decorations.push(new __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModel_js__["a" /* InlineDecoration */](new __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */](charChange.originalStartLineNumber, charChange.originalStartColumn, charChange.originalEndLineNumber, charChange.originalEndColumn), 'char-delete', 0 /* Regular */));
                }
            }
        }
        var sb = Object(__WEBPACK_IMPORTED_MODULE_27__common_core_stringBuilder_js__["a" /* createStringBuilder */])(10000);
        var marginHTML = [];
        var lineDecorationsWidth = this.modifiedEditorConfiguration.layoutInfo.decorationsWidth;
        var lineHeight = this.modifiedEditorConfiguration.lineHeight;
        var typicalHalfwidthCharacterWidth = this.modifiedEditorConfiguration.fontInfo.typicalHalfwidthCharacterWidth;
        var maxCharsPerLine = 0;
        for (var lineNumber = lineChange.originalStartLineNumber; lineNumber <= lineChange.originalEndLineNumber; lineNumber++) {
            maxCharsPerLine = Math.max(maxCharsPerLine, this._renderOriginalLine(lineNumber - lineChange.originalStartLineNumber, this.originalModel, this.modifiedEditorConfiguration, this.modifiedEditorTabSize, lineNumber, decorations, sb));
            if (this.renderIndicators) {
                var index = lineNumber - lineChange.originalStartLineNumber;
                marginHTML = marginHTML.concat([
                    "<div class=\"delete-sign\" style=\"position:absolute;top:" + index * lineHeight + "px;width:" + lineDecorationsWidth + "px;height:" + lineHeight + "px;right:0;\"></div>"
                ]);
            }
        }
        maxCharsPerLine += this.modifiedEditorConfiguration.viewInfo.scrollBeyondLastColumn;
        var domNode = document.createElement('div');
        domNode.className = 'view-lines line-delete';
        domNode.innerHTML = sb.build();
        __WEBPACK_IMPORTED_MODULE_17__config_configuration_js__["a" /* Configuration */].applyFontInfoSlow(domNode, this.modifiedEditorConfiguration.fontInfo);
        var marginDomNode = document.createElement('div');
        marginDomNode.className = 'inline-deleted-margin-view-zone';
        marginDomNode.innerHTML = marginHTML.join('');
        __WEBPACK_IMPORTED_MODULE_17__config_configuration_js__["a" /* Configuration */].applyFontInfoSlow(marginDomNode, this.modifiedEditorConfiguration.fontInfo);
        return {
            shouldNotShrink: true,
            afterLineNumber: (lineChange.modifiedEndLineNumber === 0 ? lineChange.modifiedStartLineNumber : lineChange.modifiedStartLineNumber - 1),
            heightInLines: lineChangeOriginalLength,
            minWidthInPx: (maxCharsPerLine * typicalHalfwidthCharacterWidth),
            domNode: domNode,
            marginDomNode: marginDomNode
        };
    };
    InlineViewZonesComputer.prototype._renderOriginalLine = function (count, originalModel, config, tabSize, lineNumber, decorations, sb) {
        var lineTokens = originalModel.getLineTokens(lineNumber);
        var lineContent = lineTokens.getLineContent();
        var actualDecorations = __WEBPACK_IMPORTED_MODULE_14__common_viewLayout_lineDecorations_js__["a" /* LineDecoration */].filter(decorations, lineNumber, 1, lineContent.length + 1);
        sb.appendASCIIString('<div class="view-line');
        if (decorations.length === 0) {
            // No char changes
            sb.appendASCIIString(' char-delete');
        }
        sb.appendASCIIString('" style="top:');
        sb.appendASCIIString(String(count * config.lineHeight));
        sb.appendASCIIString('px;width:1000000px;">');
        var isBasicASCII = __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].isBasicASCII(lineContent, originalModel.mightContainNonBasicASCII());
        var containsRTL = __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].containsRTL(lineContent, isBasicASCII, originalModel.mightContainRTL());
        var output = Object(__WEBPACK_IMPORTED_MODULE_15__common_viewLayout_viewLineRenderer_js__["c" /* renderViewLine */])(new __WEBPACK_IMPORTED_MODULE_15__common_viewLayout_viewLineRenderer_js__["b" /* RenderLineInput */]((config.fontInfo.isMonospace && !config.viewInfo.disableMonospaceOptimizations), lineContent, false, isBasicASCII, containsRTL, 0, lineTokens, actualDecorations, tabSize, config.fontInfo.spaceWidth, config.viewInfo.stopRenderingLineAfter, config.viewInfo.renderWhitespace, config.viewInfo.renderControlCharacters, config.viewInfo.fontLigatures), sb);
        sb.appendASCIIString('</div>');
        var absoluteOffsets = output.characterMapping.getAbsoluteOffsets();
        return absoluteOffsets.length > 0 ? absoluteOffsets[absoluteOffsets.length - 1] : 0;
    };
    return InlineViewZonesComputer;
}(ViewZonesComputer));
function isChangeOrInsert(lineChange) {
    return lineChange.modifiedEndLineNumber > 0;
}
function isChangeOrDelete(lineChange) {
    return lineChange.originalEndLineNumber > 0;
}
function createFakeLinesDiv() {
    var r = document.createElement('div');
    r.className = 'diagonal-fill';
    return r;
}
Object(__WEBPACK_IMPORTED_MODULE_22__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var added = theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["i" /* diffInserted */]);
    if (added) {
        collector.addRule(".monaco-editor .line-insert, .monaco-editor .char-insert { background-color: " + added + "; }");
        collector.addRule(".monaco-diff-editor .line-insert, .monaco-diff-editor .char-insert { background-color: " + added + "; }");
        collector.addRule(".monaco-editor .inline-added-margin-view-zone { background-color: " + added + "; }");
    }
    var removed = theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["k" /* diffRemoved */]);
    if (removed) {
        collector.addRule(".monaco-editor .line-delete, .monaco-editor .char-delete { background-color: " + removed + "; }");
        collector.addRule(".monaco-diff-editor .line-delete, .monaco-diff-editor .char-delete { background-color: " + removed + "; }");
        collector.addRule(".monaco-editor .inline-deleted-margin-view-zone { background-color: " + removed + "; }");
    }
    var addedOutline = theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["j" /* diffInsertedOutline */]);
    if (addedOutline) {
        collector.addRule(".monaco-editor .line-insert, .monaco-editor .char-insert { border: 1px " + (theme.type === 'hc' ? 'dashed' : 'solid') + " " + addedOutline + "; }");
    }
    var removedOutline = theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["l" /* diffRemovedOutline */]);
    if (removedOutline) {
        collector.addRule(".monaco-editor .line-delete, .monaco-editor .char-delete { border: 1px " + (theme.type === 'hc' ? 'dashed' : 'solid') + " " + removedOutline + "; }");
    }
    var shadow = theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["_11" /* scrollbarShadow */]);
    if (shadow) {
        collector.addRule(".monaco-diff-editor.side-by-side .editor.modified { box-shadow: -6px 0 5px -5px " + shadow + "; }");
    }
    var border = theme.getColor(__WEBPACK_IMPORTED_MODULE_23__platform_theme_common_colorRegistry_js__["h" /* diffBorder */]);
    if (border) {
        collector.addRule(".monaco-diff-editor.side-by-side .editor.modified { border-left: 1px solid " + border + "; }");
    }
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StaticServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicStandaloneServices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_configuration_common_configuration_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_contextview_browser_contextMenuService_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_contextview_browser_contextView_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_contextview_browser_contextViewService_js__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_instantiation_common_instantiationService_js__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_instantiation_common_serviceCollection_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_markers_common_markerService_js__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_markers_common_markers_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_progress_common_progress_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_storage_common_storage_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_telemetry_common_telemetry_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_workspace_common_workspace_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_services_editorWorkerService_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_services_editorWorkerServiceImpl_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_services_resourceConfiguration_js__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_services_modeService_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_services_modeServiceImpl_js__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_services_modelServiceImpl_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__standaloneCodeServiceImpl_js__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__platform_contextkey_browser_contextKeyService_js__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__platform_actions_common_actions_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_standaloneThemeService_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__standaloneThemeServiceImpl_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__platform_log_common_log_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__platform_dialogs_common_dialogs_js__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__platform_list_browser_listService_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__browser_services_bulkEditService_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__platform_uriDisplay_common_uriDisplay_js__ = __webpack_require__(279);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





































var StaticServices;
(function (StaticServices) {
    var _serviceCollection = new __WEBPACK_IMPORTED_MODULE_7__platform_instantiation_common_serviceCollection_js__["a" /* ServiceCollection */]();
    var LazyStaticService = /** @class */ (function () {
        function LazyStaticService(serviceId, factory) {
            this._serviceId = serviceId;
            this._factory = factory;
            this._value = null;
        }
        Object.defineProperty(LazyStaticService.prototype, "id", {
            get: function () { return this._serviceId; },
            enumerable: true,
            configurable: true
        });
        LazyStaticService.prototype.get = function (overrides) {
            if (!this._value) {
                if (overrides) {
                    this._value = overrides[this._serviceId.toString()];
                }
                if (!this._value) {
                    this._value = this._factory(overrides);
                }
                if (!this._value) {
                    throw new Error('Service ' + this._serviceId + ' is missing!');
                }
                _serviceCollection.set(this._serviceId, this._value);
            }
            return this._value;
        };
        return LazyStaticService;
    }());
    StaticServices.LazyStaticService = LazyStaticService;
    var _all = [];
    function define(serviceId, factory) {
        var r = new LazyStaticService(serviceId, factory);
        _all.push(r);
        return r;
    }
    function init(overrides) {
        // Create a fresh service collection
        var result = new __WEBPACK_IMPORTED_MODULE_7__platform_instantiation_common_serviceCollection_js__["a" /* ServiceCollection */]();
        // Initialize the service collection with the overrides
        for (var serviceId in overrides) {
            if (overrides.hasOwnProperty(serviceId)) {
                result.set(Object(__WEBPACK_IMPORTED_MODULE_5__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])(serviceId), overrides[serviceId]);
            }
        }
        // Make sure the same static services are present in all service collections
        _all.forEach(function (service) { return result.set(service.id, service.get(overrides)); });
        // Ensure the collection gets the correct instantiation service
        var instantiationService = new __WEBPACK_IMPORTED_MODULE_6__platform_instantiation_common_instantiationService_js__["a" /* InstantiationService */](result, true);
        result.set(__WEBPACK_IMPORTED_MODULE_5__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */], instantiationService);
        return [result, instantiationService];
    }
    StaticServices.init = init;
    StaticServices.instantiationService = define(__WEBPACK_IMPORTED_MODULE_5__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */], function () { return new __WEBPACK_IMPORTED_MODULE_6__platform_instantiation_common_instantiationService_js__["a" /* InstantiationService */](_serviceCollection, true); });
    var configurationServiceImpl = new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["b" /* SimpleConfigurationService */]();
    StaticServices.configurationService = define(__WEBPACK_IMPORTED_MODULE_1__platform_configuration_common_configuration_js__["b" /* IConfigurationService */], function () { return configurationServiceImpl; });
    StaticServices.resourceConfigurationService = define(__WEBPACK_IMPORTED_MODULE_20__common_services_resourceConfiguration_js__["a" /* ITextResourceConfigurationService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["h" /* SimpleResourceConfigurationService */](configurationServiceImpl); });
    StaticServices.contextService = define(__WEBPACK_IMPORTED_MODULE_16__platform_workspace_common_workspace_js__["a" /* IWorkspaceContextService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["j" /* SimpleWorkspaceContextService */](); });
    StaticServices.uriDisplayService = define(__WEBPACK_IMPORTED_MODULE_36__platform_uriDisplay_common_uriDisplay_js__["a" /* IUriDisplayService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["i" /* SimpleUriDisplayService */](); });
    StaticServices.telemetryService = define(__WEBPACK_IMPORTED_MODULE_15__platform_telemetry_common_telemetry_js__["a" /* ITelemetryService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["m" /* StandaloneTelemetryService */](); });
    StaticServices.dialogService = define(__WEBPACK_IMPORTED_MODULE_33__platform_dialogs_common_dialogs_js__["a" /* IDialogService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["c" /* SimpleDialogService */](); });
    StaticServices.notificationService = define(__WEBPACK_IMPORTED_MODULE_32__platform_notification_common_notification_js__["a" /* INotificationService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["f" /* SimpleNotificationService */](); });
    StaticServices.markerService = define(__WEBPACK_IMPORTED_MODULE_12__platform_markers_common_markers_js__["a" /* IMarkerService */], function () { return new __WEBPACK_IMPORTED_MODULE_11__platform_markers_common_markerService_js__["a" /* MarkerService */](); });
    StaticServices.modeService = define(__WEBPACK_IMPORTED_MODULE_21__common_services_modeService_js__["a" /* IModeService */], function (o) { return new __WEBPACK_IMPORTED_MODULE_22__common_services_modeServiceImpl_js__["a" /* ModeServiceImpl */](); });
    StaticServices.modelService = define(__WEBPACK_IMPORTED_MODULE_23__common_services_modelService_js__["a" /* IModelService */], function (o) { return new __WEBPACK_IMPORTED_MODULE_24__common_services_modelServiceImpl_js__["a" /* ModelServiceImpl */](StaticServices.markerService.get(o), StaticServices.configurationService.get(o)); });
    StaticServices.editorWorkerService = define(__WEBPACK_IMPORTED_MODULE_18__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */], function (o) { return new __WEBPACK_IMPORTED_MODULE_19__common_services_editorWorkerServiceImpl_js__["b" /* EditorWorkerServiceImpl */](StaticServices.modelService.get(o), StaticServices.resourceConfigurationService.get(o)); });
    StaticServices.standaloneThemeService = define(__WEBPACK_IMPORTED_MODULE_29__common_standaloneThemeService_js__["a" /* IStandaloneThemeService */], function () { return new __WEBPACK_IMPORTED_MODULE_30__standaloneThemeServiceImpl_js__["a" /* StandaloneThemeServiceImpl */](); });
    StaticServices.codeEditorService = define(__WEBPACK_IMPORTED_MODULE_17__browser_services_codeEditorService_js__["a" /* ICodeEditorService */], function (o) { return new __WEBPACK_IMPORTED_MODULE_25__standaloneCodeServiceImpl_js__["a" /* StandaloneCodeEditorServiceImpl */](StaticServices.standaloneThemeService.get(o)); });
    StaticServices.progressService = define(__WEBPACK_IMPORTED_MODULE_13__platform_progress_common_progress_js__["a" /* IProgressService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["g" /* SimpleProgressService */](); });
    StaticServices.storageService = define(__WEBPACK_IMPORTED_MODULE_14__platform_storage_common_storage_js__["a" /* IStorageService */], function () { return __WEBPACK_IMPORTED_MODULE_14__platform_storage_common_storage_js__["b" /* NullStorageService */]; });
    StaticServices.logService = define(__WEBPACK_IMPORTED_MODULE_31__platform_log_common_log_js__["a" /* ILogService */], function () { return new __WEBPACK_IMPORTED_MODULE_31__platform_log_common_log_js__["b" /* NullLogService */](); });
})(StaticServices || (StaticServices = {}));
var DynamicStandaloneServices = /** @class */ (function (_super) {
    __extends(DynamicStandaloneServices, _super);
    function DynamicStandaloneServices(domElement, overrides) {
        var _this = _super.call(this) || this;
        var _a = StaticServices.init(overrides), _serviceCollection = _a[0], _instantiationService = _a[1];
        _this._serviceCollection = _serviceCollection;
        _this._instantiationService = _instantiationService;
        var configurationService = _this.get(__WEBPACK_IMPORTED_MODULE_1__platform_configuration_common_configuration_js__["b" /* IConfigurationService */]);
        var notificationService = _this.get(__WEBPACK_IMPORTED_MODULE_32__platform_notification_common_notification_js__["a" /* INotificationService */]);
        var telemetryService = _this.get(__WEBPACK_IMPORTED_MODULE_15__platform_telemetry_common_telemetry_js__["a" /* ITelemetryService */]);
        var ensure = function (serviceId, factory) {
            var value = null;
            if (overrides) {
                value = overrides[serviceId.toString()];
            }
            if (!value) {
                value = factory();
            }
            _this._serviceCollection.set(serviceId, value);
            return value;
        };
        var contextKeyService = ensure(__WEBPACK_IMPORTED_MODULE_10__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */], function () { return _this._register(new __WEBPACK_IMPORTED_MODULE_27__platform_contextkey_browser_contextKeyService_js__["a" /* ContextKeyService */](configurationService)); });
        ensure(__WEBPACK_IMPORTED_MODULE_34__platform_list_browser_listService_js__["a" /* IListService */], function () { return new __WEBPACK_IMPORTED_MODULE_34__platform_list_browser_listService_js__["b" /* ListService */](contextKeyService); });
        var commandService = ensure(__WEBPACK_IMPORTED_MODULE_8__platform_commands_common_commands_js__["b" /* ICommandService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["k" /* StandaloneCommandService */](_this._instantiationService); });
        ensure(__WEBPACK_IMPORTED_MODULE_9__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */], function () { return _this._register(new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["l" /* StandaloneKeybindingService */](contextKeyService, commandService, telemetryService, notificationService, domElement)); });
        var contextViewService = ensure(__WEBPACK_IMPORTED_MODULE_3__platform_contextview_browser_contextView_js__["b" /* IContextViewService */], function () { return _this._register(new __WEBPACK_IMPORTED_MODULE_4__platform_contextview_browser_contextViewService_js__["a" /* ContextViewService */](domElement, telemetryService, new __WEBPACK_IMPORTED_MODULE_31__platform_log_common_log_js__["b" /* NullLogService */]())); });
        ensure(__WEBPACK_IMPORTED_MODULE_3__platform_contextview_browser_contextView_js__["a" /* IContextMenuService */], function () { return _this._register(new __WEBPACK_IMPORTED_MODULE_2__platform_contextview_browser_contextMenuService_js__["a" /* ContextMenuService */](domElement, telemetryService, notificationService, contextViewService)); });
        ensure(__WEBPACK_IMPORTED_MODULE_28__platform_actions_common_actions_js__["a" /* IMenuService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["e" /* SimpleMenuService */](commandService); });
        ensure(__WEBPACK_IMPORTED_MODULE_35__browser_services_bulkEditService_js__["a" /* IBulkEditService */], function () { return new __WEBPACK_IMPORTED_MODULE_26__simpleServices_js__["a" /* SimpleBulkEditService */](StaticServices.modelService.get(__WEBPACK_IMPORTED_MODULE_23__common_services_modelService_js__["a" /* IModelService */])); });
        return _this;
    }
    DynamicStandaloneServices.prototype.get = function (serviceId) {
        var r = this._serviceCollection.get(serviceId);
        if (!r) {
            throw new Error('Missing service ' + serviceId);
        }
        return r;
    };
    DynamicStandaloneServices.prototype.set = function (serviceId, instance) {
        this._serviceCollection.set(serviceId, instance);
    };
    DynamicStandaloneServices.prototype.has = function (serviceId) {
        return this._serviceCollection.has(serviceId);
    };
    return DynamicStandaloneServices;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditorWorkerServiceImpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorWorkerClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_worker_simpleWorker_js__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_worker_defaultWorkerFactory_js__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editorSimpleWorker_js__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resourceConfiguration_js__ = __webpack_require__(292);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};










/**
 * Stop syncing a model to the worker if it was not needed for 1 min.
 */
var STOP_SYNC_MODEL_DELTA_TIME_MS = 60 * 1000;
/**
 * Stop the worker if it was not needed for 5 min.
 */
var STOP_WORKER_DELTA_TIME_MS = 5 * 60 * 1000;
function canSyncModel(modelService, resource) {
    var model = modelService.getModel(resource);
    if (!model) {
        return false;
    }
    if (model.isTooLargeForSyncing()) {
        return false;
    }
    return true;
}
var EditorWorkerServiceImpl = /** @class */ (function (_super) {
    __extends(EditorWorkerServiceImpl, _super);
    function EditorWorkerServiceImpl(modelService, configurationService) {
        var _this = _super.call(this) || this;
        _this._modelService = modelService;
        _this._workerManager = _this._register(new WorkerManager(_this._modelService));
        // todo@joh make sure this happens only once
        _this._register(__WEBPACK_IMPORTED_MODULE_5__modes_js__["p" /* LinkProviderRegistry */].register('*', {
            provideLinks: function (model, token) {
                if (!canSyncModel(_this._modelService, model.uri)) {
                    return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as([]); // File too large
                }
                return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["o" /* wireCancellationToken */])(token, _this._workerManager.withWorker().then(function (client) { return client.computeLinks(model.uri); }));
            }
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_5__modes_js__["u" /* SuggestRegistry */].register('*', new WordBasedCompletionItemProvider(_this._workerManager, configurationService, _this._modelService)));
        return _this;
    }
    EditorWorkerServiceImpl.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    EditorWorkerServiceImpl.prototype.canComputeDiff = function (original, modified) {
        return (canSyncModel(this._modelService, original) && canSyncModel(this._modelService, modified));
    };
    EditorWorkerServiceImpl.prototype.computeDiff = function (original, modified, ignoreTrimWhitespace) {
        return this._workerManager.withWorker().then(function (client) { return client.computeDiff(original, modified, ignoreTrimWhitespace); });
    };
    EditorWorkerServiceImpl.prototype.computeMoreMinimalEdits = function (resource, edits) {
        if (!Array.isArray(edits) || edits.length === 0) {
            return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(edits);
        }
        else {
            if (!canSyncModel(this._modelService, resource)) {
                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(edits); // File too large
            }
            return this._workerManager.withWorker().then(function (client) { return client.computeMoreMinimalEdits(resource, edits); });
        }
    };
    EditorWorkerServiceImpl.prototype.canNavigateValueSet = function (resource) {
        return (canSyncModel(this._modelService, resource));
    };
    EditorWorkerServiceImpl.prototype.navigateValueSet = function (resource, range, up) {
        return this._workerManager.withWorker().then(function (client) { return client.navigateValueSet(resource, range, up); });
    };
    EditorWorkerServiceImpl = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_6__modelService_js__["a" /* IModelService */]),
        __param(1, __WEBPACK_IMPORTED_MODULE_9__resourceConfiguration_js__["a" /* ITextResourceConfigurationService */])
    ], EditorWorkerServiceImpl);
    return EditorWorkerServiceImpl;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));

var WordBasedCompletionItemProvider = /** @class */ (function () {
    function WordBasedCompletionItemProvider(workerManager, configurationService, modelService) {
        this._workerManager = workerManager;
        this._configurationService = configurationService;
        this._modelService = modelService;
    }
    WordBasedCompletionItemProvider.prototype.provideCompletionItems = function (model, position) {
        var wordBasedSuggestions = this._configurationService.getValue(model.uri, position, 'editor').wordBasedSuggestions;
        if (!wordBasedSuggestions) {
            return undefined;
        }
        if (!canSyncModel(this._modelService, model.uri)) {
            return undefined; // File too large
        }
        return this._workerManager.withWorker().then(function (client) { return client.textualSuggest(model.uri, position); });
    };
    return WordBasedCompletionItemProvider;
}());
var WorkerManager = /** @class */ (function (_super) {
    __extends(WorkerManager, _super);
    function WorkerManager(modelService) {
        var _this = _super.call(this) || this;
        _this._modelService = modelService;
        _this._editorWorkerClient = null;
        var stopWorkerInterval = _this._register(new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["b" /* IntervalTimer */]());
        stopWorkerInterval.cancelAndSet(function () { return _this._checkStopIdleWorker(); }, Math.round(STOP_WORKER_DELTA_TIME_MS / 2));
        _this._register(_this._modelService.onModelRemoved(function (_) { return _this._checkStopEmptyWorker(); }));
        return _this;
    }
    WorkerManager.prototype.dispose = function () {
        if (this._editorWorkerClient) {
            this._editorWorkerClient.dispose();
            this._editorWorkerClient = null;
        }
        _super.prototype.dispose.call(this);
    };
    /**
     * Check if the model service has no more models and stop the worker if that is the case.
     */
    WorkerManager.prototype._checkStopEmptyWorker = function () {
        if (!this._editorWorkerClient) {
            return;
        }
        var models = this._modelService.getModels();
        if (models.length === 0) {
            // There are no more models => nothing possible for me to do
            this._editorWorkerClient.dispose();
            this._editorWorkerClient = null;
        }
    };
    /**
     * Check if the worker has been idle for a while and then stop it.
     */
    WorkerManager.prototype._checkStopIdleWorker = function () {
        if (!this._editorWorkerClient) {
            return;
        }
        var timeSinceLastWorkerUsedTime = (new Date()).getTime() - this._lastWorkerUsedTime;
        if (timeSinceLastWorkerUsedTime > STOP_WORKER_DELTA_TIME_MS) {
            this._editorWorkerClient.dispose();
            this._editorWorkerClient = null;
        }
    };
    WorkerManager.prototype.withWorker = function () {
        this._lastWorkerUsedTime = (new Date()).getTime();
        if (!this._editorWorkerClient) {
            this._editorWorkerClient = new EditorWorkerClient(this._modelService, 'editorWorkerService');
        }
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(this._editorWorkerClient);
    };
    return WorkerManager;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));
var EditorModelManager = /** @class */ (function (_super) {
    __extends(EditorModelManager, _super);
    function EditorModelManager(proxy, modelService, keepIdleModels) {
        var _this = _super.call(this) || this;
        _this._syncedModels = Object.create(null);
        _this._syncedModelsLastUsedTime = Object.create(null);
        _this._proxy = proxy;
        _this._modelService = modelService;
        if (!keepIdleModels) {
            var timer = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["b" /* IntervalTimer */]();
            timer.cancelAndSet(function () { return _this._checkStopModelSync(); }, Math.round(STOP_SYNC_MODEL_DELTA_TIME_MS / 2));
            _this._register(timer);
        }
        return _this;
    }
    EditorModelManager.prototype.dispose = function () {
        for (var modelUrl in this._syncedModels) {
            Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._syncedModels[modelUrl]);
        }
        this._syncedModels = Object.create(null);
        this._syncedModelsLastUsedTime = Object.create(null);
        _super.prototype.dispose.call(this);
    };
    EditorModelManager.prototype.esureSyncedResources = function (resources) {
        for (var i = 0; i < resources.length; i++) {
            var resource = resources[i];
            var resourceStr = resource.toString();
            if (!this._syncedModels[resourceStr]) {
                this._beginModelSync(resource);
            }
            if (this._syncedModels[resourceStr]) {
                this._syncedModelsLastUsedTime[resourceStr] = (new Date()).getTime();
            }
        }
    };
    EditorModelManager.prototype._checkStopModelSync = function () {
        var currentTime = (new Date()).getTime();
        var toRemove = [];
        for (var modelUrl in this._syncedModelsLastUsedTime) {
            var elapsedTime = currentTime - this._syncedModelsLastUsedTime[modelUrl];
            if (elapsedTime > STOP_SYNC_MODEL_DELTA_TIME_MS) {
                toRemove.push(modelUrl);
            }
        }
        for (var i = 0; i < toRemove.length; i++) {
            this._stopModelSync(toRemove[i]);
        }
    };
    EditorModelManager.prototype._beginModelSync = function (resource) {
        var _this = this;
        var model = this._modelService.getModel(resource);
        if (!model) {
            return;
        }
        if (model.isTooLargeForSyncing()) {
            return;
        }
        var modelUrl = resource.toString();
        this._proxy.acceptNewModel({
            url: model.uri.toString(),
            lines: model.getLinesContent(),
            EOL: model.getEOL(),
            versionId: model.getVersionId()
        });
        var toDispose = [];
        toDispose.push(model.onDidChangeContent(function (e) {
            _this._proxy.acceptModelChanged(modelUrl.toString(), e);
        }));
        toDispose.push(model.onWillDispose(function () {
            _this._stopModelSync(modelUrl);
        }));
        toDispose.push(Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            _this._proxy.acceptRemovedModel(modelUrl);
        }));
        this._syncedModels[modelUrl] = toDispose;
    };
    EditorModelManager.prototype._stopModelSync = function (modelUrl) {
        var toDispose = this._syncedModels[modelUrl];
        delete this._syncedModels[modelUrl];
        delete this._syncedModelsLastUsedTime[modelUrl];
        Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(toDispose);
    };
    return EditorModelManager;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));
var SynchronousWorkerClient = /** @class */ (function () {
    function SynchronousWorkerClient(instance) {
        this._instance = instance;
        this._proxyObj = __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(this._instance);
    }
    SynchronousWorkerClient.prototype.dispose = function () {
        this._instance.dispose();
        this._instance = null;
        this._proxyObj = null;
    };
    SynchronousWorkerClient.prototype.getProxyObject = function () {
        return new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["d" /* ShallowCancelThenPromise */](this._proxyObj);
    };
    return SynchronousWorkerClient;
}());
var EditorWorkerClient = /** @class */ (function (_super) {
    __extends(EditorWorkerClient, _super);
    function EditorWorkerClient(modelService, label) {
        var _this = _super.call(this) || this;
        _this._modelService = modelService;
        _this._workerFactory = new __WEBPACK_IMPORTED_MODULE_4__base_worker_defaultWorkerFactory_js__["a" /* DefaultWorkerFactory */](label);
        _this._worker = null;
        _this._modelManager = null;
        return _this;
    }
    EditorWorkerClient.prototype._getOrCreateWorker = function () {
        if (!this._worker) {
            try {
                this._worker = this._register(new __WEBPACK_IMPORTED_MODULE_3__base_common_worker_simpleWorker_js__["a" /* SimpleWorkerClient */](this._workerFactory, 'vs/editor/common/services/editorSimpleWorker'));
            }
            catch (err) {
                Object(__WEBPACK_IMPORTED_MODULE_3__base_common_worker_simpleWorker_js__["b" /* logOnceWebWorkerWarning */])(err);
                this._worker = new SynchronousWorkerClient(new __WEBPACK_IMPORTED_MODULE_7__editorSimpleWorker_js__["a" /* EditorSimpleWorkerImpl */](null));
            }
        }
        return this._worker;
    };
    EditorWorkerClient.prototype._getProxy = function () {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["d" /* ShallowCancelThenPromise */](this._getOrCreateWorker().getProxyObject().then(null, function (err) {
            Object(__WEBPACK_IMPORTED_MODULE_3__base_common_worker_simpleWorker_js__["b" /* logOnceWebWorkerWarning */])(err);
            _this._worker = new SynchronousWorkerClient(new __WEBPACK_IMPORTED_MODULE_7__editorSimpleWorker_js__["a" /* EditorSimpleWorkerImpl */](null));
            return _this._getOrCreateWorker().getProxyObject();
        }));
    };
    EditorWorkerClient.prototype._getOrCreateModelManager = function (proxy) {
        if (!this._modelManager) {
            this._modelManager = this._register(new EditorModelManager(proxy, this._modelService, false));
        }
        return this._modelManager;
    };
    EditorWorkerClient.prototype._withSyncedResources = function (resources) {
        var _this = this;
        return this._getProxy().then(function (proxy) {
            _this._getOrCreateModelManager(proxy).esureSyncedResources(resources);
            return proxy;
        });
    };
    EditorWorkerClient.prototype.computeDiff = function (original, modified, ignoreTrimWhitespace) {
        return this._withSyncedResources([original, modified]).then(function (proxy) {
            return proxy.computeDiff(original.toString(), modified.toString(), ignoreTrimWhitespace);
        });
    };
    EditorWorkerClient.prototype.computeMoreMinimalEdits = function (resource, edits) {
        return this._withSyncedResources([resource]).then(function (proxy) {
            return proxy.computeMoreMinimalEdits(resource.toString(), edits);
        });
    };
    EditorWorkerClient.prototype.computeLinks = function (resource) {
        return this._withSyncedResources([resource]).then(function (proxy) {
            return proxy.computeLinks(resource.toString());
        });
    };
    EditorWorkerClient.prototype.textualSuggest = function (resource, position) {
        var _this = this;
        return this._withSyncedResources([resource]).then(function (proxy) {
            var model = _this._modelService.getModel(resource);
            if (!model) {
                return null;
            }
            var wordDefRegExp = __WEBPACK_IMPORTED_MODULE_8__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getWordDefinition(model.getLanguageIdentifier().id);
            var wordDef = wordDefRegExp.source;
            var wordDefFlags = (wordDefRegExp.global ? 'g' : '') + (wordDefRegExp.ignoreCase ? 'i' : '') + (wordDefRegExp.multiline ? 'm' : '');
            return proxy.textualSuggest(resource.toString(), position, wordDef, wordDefFlags);
        });
    };
    EditorWorkerClient.prototype.navigateValueSet = function (resource, range, up) {
        var _this = this;
        return this._withSyncedResources([resource]).then(function (proxy) {
            var model = _this._modelService.getModel(resource);
            if (!model) {
                return null;
            }
            var wordDefRegExp = __WEBPACK_IMPORTED_MODULE_8__modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getWordDefinition(model.getLanguageIdentifier().id);
            var wordDef = wordDefRegExp.source;
            var wordDefFlags = (wordDefRegExp.global ? 'g' : '') + (wordDefRegExp.ignoreCase ? 'i' : '') + (wordDefRegExp.multiline ? 'm' : '');
            return proxy.navigateValueSet(resource.toString(), range, up, wordDef, wordDefFlags);
        });
    };
    return EditorWorkerClient;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = logOnceWebWorkerWarning;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleWorkerClient; });
/* unused harmony export SimpleWorkerServer */
/* unused harmony export create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_js__ = __webpack_require__(14);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var INITIALIZE = '$initialize';
var webWorkerWarningLogged = false;
function logOnceWebWorkerWarning(err) {
    if (!__WEBPACK_IMPORTED_MODULE_4__platform_js__["f" /* isWeb */]) {
        // running tests
        return;
    }
    if (!webWorkerWarningLogged) {
        webWorkerWarningLogged = true;
        console.warn('Could not create web worker(s). Falling back to loading web worker code in main thread, which might cause UI freezes. Please see https://github.com/Microsoft/monaco-editor#faq');
    }
    console.warn(err.message);
}
var SimpleWorkerProtocol = /** @class */ (function () {
    function SimpleWorkerProtocol(handler) {
        this._workerId = -1;
        this._handler = handler;
        this._lastSentReq = 0;
        this._pendingReplies = Object.create(null);
    }
    SimpleWorkerProtocol.prototype.setWorkerId = function (workerId) {
        this._workerId = workerId;
    };
    SimpleWorkerProtocol.prototype.sendMessage = function (method, args) {
        var req = String(++this._lastSentReq);
        var reply = {
            c: null,
            e: null
        };
        var result = new __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */](function (c, e) {
            reply.c = c;
            reply.e = e;
        }, function () {
            // Cancel not supported
        });
        this._pendingReplies[req] = reply;
        this._send({
            vsWorker: this._workerId,
            req: req,
            method: method,
            args: args
        });
        return result;
    };
    SimpleWorkerProtocol.prototype.handleMessage = function (serializedMessage) {
        var message;
        try {
            message = JSON.parse(serializedMessage);
        }
        catch (e) {
            // nothing
        }
        if (!message || !message.vsWorker) {
            return;
        }
        if (this._workerId !== -1 && message.vsWorker !== this._workerId) {
            return;
        }
        this._handleMessage(message);
    };
    SimpleWorkerProtocol.prototype._handleMessage = function (msg) {
        var _this = this;
        if (msg.seq) {
            var replyMessage = msg;
            if (!this._pendingReplies[replyMessage.seq]) {
                console.warn('Got reply to unknown seq');
                return;
            }
            var reply = this._pendingReplies[replyMessage.seq];
            delete this._pendingReplies[replyMessage.seq];
            if (replyMessage.err) {
                var err = replyMessage.err;
                if (replyMessage.err.$isError) {
                    err = new Error();
                    err.name = replyMessage.err.name;
                    err.message = replyMessage.err.message;
                    err.stack = replyMessage.err.stack;
                }
                reply.e(err);
                return;
            }
            reply.c(replyMessage.res);
            return;
        }
        var requestMessage = msg;
        var req = requestMessage.req;
        var result = this._handler.handleMessage(requestMessage.method, requestMessage.args);
        result.then(function (r) {
            _this._send({
                vsWorker: _this._workerId,
                seq: req,
                res: r,
                err: undefined
            });
        }, function (e) {
            if (e.detail instanceof Error) {
                // Loading errors have a detail property that points to the actual error
                e.detail = Object(__WEBPACK_IMPORTED_MODULE_0__errors_js__["g" /* transformErrorForSerialization */])(e.detail);
            }
            _this._send({
                vsWorker: _this._workerId,
                seq: req,
                res: undefined,
                err: Object(__WEBPACK_IMPORTED_MODULE_0__errors_js__["g" /* transformErrorForSerialization */])(e)
            });
        });
    };
    SimpleWorkerProtocol.prototype._send = function (msg) {
        var strMsg = JSON.stringify(msg);
        // console.log('SENDING: ' + strMsg);
        this._handler.sendMessage(strMsg);
    };
    return SimpleWorkerProtocol;
}());
/**
 * Main thread side
 */
var SimpleWorkerClient = /** @class */ (function (_super) {
    __extends(SimpleWorkerClient, _super);
    function SimpleWorkerClient(workerFactory, moduleId) {
        var _this = _super.call(this) || this;
        var lazyProxyFulfill = null;
        var lazyProxyReject = null;
        _this._worker = _this._register(workerFactory.create('vs/base/common/worker/simpleWorker', function (msg) {
            _this._protocol.handleMessage(msg);
        }, function (err) {
            // in Firefox, web workers fail lazily :(
            // we will reject the proxy
            lazyProxyReject(err);
        }));
        _this._protocol = new SimpleWorkerProtocol({
            sendMessage: function (msg) {
                _this._worker.postMessage(msg);
            },
            handleMessage: function (method, args) {
                // Intentionally not supporting worker -> main requests
                return __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */].as(null);
            }
        });
        _this._protocol.setWorkerId(_this._worker.getId());
        // Gather loader configuration
        var loaderConfiguration = null;
        if (typeof self.require !== 'undefined' && typeof self.require.getConfig === 'function') {
            // Get the configuration from the Monaco AMD Loader
            loaderConfiguration = self.require.getConfig();
        }
        else if (typeof self.requirejs !== 'undefined') {
            // Get the configuration from requirejs
            loaderConfiguration = self.requirejs.s.contexts._.config;
        }
        _this._lazyProxy = new __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */](function (c, e) {
            lazyProxyFulfill = c;
            lazyProxyReject = e;
        }, function () { });
        // Send initialize message
        _this._onModuleLoaded = _this._protocol.sendMessage(INITIALIZE, [
            _this._worker.getId(),
            moduleId,
            loaderConfiguration
        ]);
        _this._onModuleLoaded.then(function (availableMethods) {
            var proxy = {};
            for (var i = 0; i < availableMethods.length; i++) {
                proxy[availableMethods[i]] = createProxyMethod(availableMethods[i], proxyMethodRequest);
            }
            lazyProxyFulfill(proxy);
        }, function (e) {
            lazyProxyReject(e);
            _this._onError('Worker failed to load ' + moduleId, e);
        });
        // Create proxy to loaded code
        var proxyMethodRequest = function (method, args) {
            return _this._request(method, args);
        };
        var createProxyMethod = function (method, proxyMethodRequest) {
            return function () {
                var args = Array.prototype.slice.call(arguments, 0);
                return proxyMethodRequest(method, args);
            };
        };
        return _this;
    }
    SimpleWorkerClient.prototype.getProxyObject = function () {
        // Do not allow chaining promises to cancel the proxy creation
        return new __WEBPACK_IMPORTED_MODULE_3__async_js__["d" /* ShallowCancelThenPromise */](this._lazyProxy);
    };
    SimpleWorkerClient.prototype._request = function (method, args) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */](function (c, e) {
            _this._onModuleLoaded.then(function () {
                _this._protocol.sendMessage(method, args).then(c, e);
            }, e);
        }, function () {
            // Cancel intentionally not supported
        });
    };
    SimpleWorkerClient.prototype._onError = function (message, error) {
        console.error(message);
        console.info(error);
    };
    return SimpleWorkerClient;
}(__WEBPACK_IMPORTED_MODULE_1__lifecycle_js__["a" /* Disposable */]));

/**
 * Worker side
 */
var SimpleWorkerServer = /** @class */ (function () {
    function SimpleWorkerServer(postSerializedMessage, requestHandler) {
        var _this = this;
        this._requestHandler = requestHandler;
        this._protocol = new SimpleWorkerProtocol({
            sendMessage: function (msg) {
                postSerializedMessage(msg);
            },
            handleMessage: function (method, args) { return _this._handleMessage(method, args); }
        });
    }
    SimpleWorkerServer.prototype.onmessage = function (msg) {
        this._protocol.handleMessage(msg);
    };
    SimpleWorkerServer.prototype._handleMessage = function (method, args) {
        if (method === INITIALIZE) {
            return this.initialize(args[0], args[1], args[2]);
        }
        if (!this._requestHandler || typeof this._requestHandler[method] !== 'function') {
            return __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */].wrapError(new Error('Missing requestHandler or method: ' + method));
        }
        try {
            return __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */].as(this._requestHandler[method].apply(this._requestHandler, args));
        }
        catch (e) {
            return __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */].wrapError(e);
        }
    };
    SimpleWorkerServer.prototype.initialize = function (workerId, moduleId, loaderConfig) {
        var _this = this;
        this._protocol.setWorkerId(workerId);
        if (this._requestHandler) {
            // static request handler
            var methods = [];
            for (var prop in this._requestHandler) {
                if (typeof this._requestHandler[prop] === 'function') {
                    methods.push(prop);
                }
            }
            return __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */].as(methods);
        }
        if (loaderConfig) {
            // Remove 'baseUrl', handling it is beyond scope for now
            if (typeof loaderConfig.baseUrl !== 'undefined') {
                delete loaderConfig['baseUrl'];
            }
            if (typeof loaderConfig.paths !== 'undefined') {
                if (typeof loaderConfig.paths.vs !== 'undefined') {
                    delete loaderConfig.paths['vs'];
                }
            }
            // Since this is in a web worker, enable catching errors
            loaderConfig.catchError = true;
            self.require.config(loaderConfig);
        }
        var cc;
        var ee;
        var r = new __WEBPACK_IMPORTED_MODULE_2__winjs_base_js__["b" /* TPromise */](function (c, e) {
            cc = c;
            ee = e;
        });
        // Use the global require to be sure to get the global config
        self.require([moduleId], function () {
            var result = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                result[_i] = arguments[_i];
            }
            var handlerModule = result[0];
            _this._requestHandler = handlerModule.create();
            var methods = [];
            for (var prop in _this._requestHandler) {
                if (typeof _this._requestHandler[prop] === 'function') {
                    methods.push(prop);
                }
            }
            cc(methods);
        }, ee);
        return r;
    };
    return SimpleWorkerServer;
}());

/**
 * Called on the worker side
 */
function create(postMessage) {
    return new SimpleWorkerServer(postMessage, null);
}


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ITextResourceConfigurationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);

var ITextResourceConfigurationService = Object(__WEBPACK_IMPORTED_MODULE_0__platform_instantiation_common_instantiation_js__["c" /* createDecorator */])('textResourceConfigurationService');


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiffNavigator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_assert_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var defaultOptions = {
    followsCaret: true,
    ignoreCharChanges: true,
    alwaysRevealFirst: true
};
/**
 * Create a new diff navigator for the provided diff editor.
 */
var DiffNavigator = /** @class */ (function () {
    function DiffNavigator(editor, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this._onDidUpdate = new __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["a" /* Emitter */]();
        this._editor = editor;
        this._options = __WEBPACK_IMPORTED_MODULE_1__base_common_objects_js__["g" /* mixin */](options, defaultOptions, false);
        this.disposed = false;
        this._disposables = [];
        this.nextIdx = -1;
        this.ranges = [];
        this.ignoreSelectionChange = false;
        this.revealFirst = this._options.alwaysRevealFirst;
        // hook up to diff editor for diff, disposal, and caret move
        this._disposables.push(this._editor.onDidDispose(function () { return _this.dispose(); }));
        this._disposables.push(this._editor.onDidUpdateDiff(function () { return _this._onDiffUpdated(); }));
        if (this._options.followsCaret) {
            this._disposables.push(this._editor.getModifiedEditor().onDidChangeCursorPosition(function (e) {
                if (_this.ignoreSelectionChange) {
                    return;
                }
                _this.nextIdx = -1;
            }));
        }
        if (this._options.alwaysRevealFirst) {
            this._disposables.push(this._editor.getModifiedEditor().onDidChangeModel(function (e) {
                _this.revealFirst = true;
            }));
        }
        // init things
        this._init();
    }
    DiffNavigator.prototype._init = function () {
        var changes = this._editor.getLineChanges();
        if (!changes) {
            return;
        }
    };
    DiffNavigator.prototype._onDiffUpdated = function () {
        this._init();
        this._compute(this._editor.getLineChanges());
        if (this.revealFirst) {
            // Only reveal first on first non-null changes
            if (this._editor.getLineChanges() !== null) {
                this.revealFirst = false;
                this.nextIdx = -1;
                this.next(1 /* Immediate */);
            }
        }
    };
    DiffNavigator.prototype._compute = function (lineChanges) {
        var _this = this;
        // new ranges
        this.ranges = [];
        if (lineChanges) {
            // create ranges from changes
            lineChanges.forEach(function (lineChange) {
                if (!_this._options.ignoreCharChanges && lineChange.charChanges) {
                    lineChange.charChanges.forEach(function (charChange) {
                        _this.ranges.push({
                            rhs: true,
                            range: new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](charChange.modifiedStartLineNumber, charChange.modifiedStartColumn, charChange.modifiedEndLineNumber, charChange.modifiedEndColumn)
                        });
                    });
                }
                else {
                    _this.ranges.push({
                        rhs: true,
                        range: new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](lineChange.modifiedStartLineNumber, 1, lineChange.modifiedStartLineNumber, 1)
                    });
                }
            });
        }
        // sort
        this.ranges.sort(function (left, right) {
            if (left.range.getStartPosition().isBeforeOrEqual(right.range.getStartPosition())) {
                return -1;
            }
            else if (right.range.getStartPosition().isBeforeOrEqual(left.range.getStartPosition())) {
                return 1;
            }
            else {
                return 0;
            }
        });
        this._onDidUpdate.fire(this);
    };
    DiffNavigator.prototype._initIdx = function (fwd) {
        var found = false;
        var position = this._editor.getPosition();
        for (var i = 0, len = this.ranges.length; i < len && !found; i++) {
            var range = this.ranges[i].range;
            if (position.isBeforeOrEqual(range.getStartPosition())) {
                this.nextIdx = i + (fwd ? 0 : -1);
                found = true;
            }
        }
        if (!found) {
            // after the last change
            this.nextIdx = fwd ? 0 : this.ranges.length - 1;
        }
        if (this.nextIdx < 0) {
            this.nextIdx = this.ranges.length - 1;
        }
    };
    DiffNavigator.prototype._move = function (fwd, scrollType) {
        __WEBPACK_IMPORTED_MODULE_0__base_common_assert_js__["a" /* ok */](!this.disposed, 'Illegal State - diff navigator has been disposed');
        if (!this.canNavigate()) {
            return;
        }
        if (this.nextIdx === -1) {
            this._initIdx(fwd);
        }
        else if (fwd) {
            this.nextIdx += 1;
            if (this.nextIdx >= this.ranges.length) {
                this.nextIdx = 0;
            }
        }
        else {
            this.nextIdx -= 1;
            if (this.nextIdx < 0) {
                this.nextIdx = this.ranges.length - 1;
            }
        }
        var info = this.ranges[this.nextIdx];
        this.ignoreSelectionChange = true;
        try {
            var pos = info.range.getStartPosition();
            this._editor.setPosition(pos);
            this._editor.revealPositionInCenter(pos, scrollType);
        }
        finally {
            this.ignoreSelectionChange = false;
        }
    };
    DiffNavigator.prototype.canNavigate = function () {
        return this.ranges && this.ranges.length > 0;
    };
    DiffNavigator.prototype.next = function (scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._move(true, scrollType);
    };
    DiffNavigator.prototype.previous = function (scrollType) {
        if (scrollType === void 0) { scrollType = 0 /* Smooth */; }
        this._move(false, scrollType);
    };
    DiffNavigator.prototype.dispose = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        this._disposables.length = 0;
        this._onDidUpdate.dispose();
        this.ranges = null;
        this.disposed = true;
    };
    return DiffNavigator;
}());



/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isFuzzyActionArr */
/* harmony export (immutable) */ __webpack_exports__["d"] = isFuzzyAction;
/* harmony export (immutable) */ __webpack_exports__["f"] = isString;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIAction;
/* harmony export (immutable) */ __webpack_exports__["a"] = empty;
/* harmony export (immutable) */ __webpack_exports__["c"] = fixCase;
/* harmony export (immutable) */ __webpack_exports__["h"] = sanitize;
/* harmony export (immutable) */ __webpack_exports__["g"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = throwError;
/* harmony export (immutable) */ __webpack_exports__["j"] = substituteMatches;
/* harmony export (immutable) */ __webpack_exports__["b"] = findRules;
/* harmony export (immutable) */ __webpack_exports__["i"] = stateExists;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function isFuzzyActionArr(what) {
    return (Array.isArray(what));
}
function isFuzzyAction(what) {
    return !isFuzzyActionArr(what);
}
function isString(what) {
    return (typeof what === 'string');
}
function isIAction(what) {
    return !isString(what);
}
// Small helper functions
/**
 * Is a string null, undefined, or empty?
 */
function empty(s) {
    return (s ? false : true);
}
/**
 * Puts a string to lower case if 'ignoreCase' is set.
 */
function fixCase(lexer, str) {
    return (lexer.ignoreCase && str ? str.toLowerCase() : str);
}
/**
 * Ensures there are no bad characters in a CSS token class.
 */
function sanitize(s) {
    return s.replace(/[&<>'"_]/g, '-'); // used on all output token CSS classes
}
// Logging
/**
 * Logs a message.
 */
function log(lexer, msg) {
    console.log(lexer.languageId + ": " + msg);
}
// Throwing errors
/**
 * Throws error. May actually just log the error and continue.
 */
function throwError(lexer, msg) {
    throw new Error(lexer.languageId + ": " + msg);
}
// Helper functions for rule finding and substitution
/**
 * substituteMatches is used on lexer strings and can substitutes predefined patterns:
 * 		$$  => $
 * 		$#  => id
 * 		$n  => matched entry n
 * 		@attr => contents of lexer[attr]
 *
 * See documentation for more info
 */
function substituteMatches(lexer, str, id, matches, state) {
    var re = /\$((\$)|(#)|(\d\d?)|[sS](\d\d?)|@(\w+))/g;
    var stateMatches = null;
    return str.replace(re, function (full, sub, dollar, hash, n, s, attr, ofs, total) {
        if (!empty(dollar)) {
            return '$'; // $$
        }
        if (!empty(hash)) {
            return fixCase(lexer, id); // default $#
        }
        if (!empty(n) && n < matches.length) {
            return fixCase(lexer, matches[n]); // $n
        }
        if (!empty(attr) && lexer && typeof (lexer[attr]) === 'string') {
            return lexer[attr]; //@attribute
        }
        if (stateMatches === null) { // split state on demand
            stateMatches = state.split('.');
            stateMatches.unshift(state);
        }
        if (!empty(s) && s < stateMatches.length) {
            return fixCase(lexer, stateMatches[s]); //$Sn
        }
        return '';
    });
}
/**
 * Find the tokenizer rules for a specific state (i.e. next action)
 */
function findRules(lexer, state) {
    while (state && state.length > 0) {
        var rules = lexer.tokenizer[state];
        if (rules) {
            return rules;
        }
        var idx = state.lastIndexOf('.');
        if (idx < 0) {
            state = null; // no further parent
        }
        else {
            state = state.substr(0, idx);
        }
    }
    return null;
}
/**
 * Is a certain state defined? In contrast to 'findRules' this works on a ILexerMin.
 * This is used during compilation where we may know the defined states
 * but not yet whether the corresponding rules are correct.
 */
function stateExists(lexer, state) {
    while (state && state.length > 0) {
        var exist = lexer.stateNames[state];
        if (exist) {
            return true;
        }
        var idx = state.lastIndexOf('.');
        if (idx < 0) {
            state = null; // no further parent
        }
        else {
            state = state.substr(0, idx);
        }
    }
    return false;
}


/***/ }),
/* 295 */,
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(297);
module.exports = __webpack_require__(302);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(298).enable();
  window.Promise = __webpack_require__(300);
}

// fetch() polyfill for making API calls.
__webpack_require__(301);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(113);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(243);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)))

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(243);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 301 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(570);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(113),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(305);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(114),n=__webpack_require__(113),r=__webpack_require__(306);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(307);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_less__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_monaco_editor__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_monaco_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_monaco_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_ActionCtrlD__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_settings_svg__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Utils__ = __webpack_require__(569);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var languageKey="language";var contentKey="content";var wrapWordKey="wrapWord";var localLanguage=Object(__WEBPACK_IMPORTED_MODULE_5__utils_Utils__["a" /* readLocalStorage */])(languageKey);var localContent=Object(__WEBPACK_IMPORTED_MODULE_5__utils_Utils__["a" /* readLocalStorage */])(contentKey);var localWrapWord=Object(__WEBPACK_IMPORTED_MODULE_5__utils_Utils__["a" /* readLocalStorage */])(wrapWordKey);var App=function(_Component){_inherits(App,_Component);function App(args){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,args));_this.vsEditor=null;_this.languages=["plainText","java","javascript","html","less","sql"];_this.state={show:true,language:localLanguage?localLanguage:_this.languages[0],wrapWord:localWrapWord?localWrapWord:"on"};return _this;}_createClass(App,[{key:'componentWillUnmount',value:function componentWillUnmount(){console.log("componentWillUnmount 方法调用");window.removeEventListener("resize",this.vsEditorLayout.bind(this));}},{key:'componentDidMount',value:function componentDidMount(){var that=this;this.vsEditor=__WEBPACK_IMPORTED_MODULE_2_monaco_editor__["editor"].create(document.getElementById('VsEditor'),{value:localContent?localContent:"",language:this.state.language,wordWrap:this.state.wrapWord});//手动增加Ctrl+D的功能。
this.vsEditor.addAction(__WEBPACK_IMPORTED_MODULE_3__action_ActionCtrlD__["a" /* default */]);window.addEventListener("resize",this.vsEditorLayout.bind(this));window.onbeforeunload=function(event){Object(__WEBPACK_IMPORTED_MODULE_5__utils_Utils__["b" /* saveToLocalStorage */])(contentKey,that.vsEditor.getValue());};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.show?'App ShowPanel':'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'VsEditor'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ToolPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ChooseLang'},'\u9009\u62E9\u8BED\u8A00\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.language,onChange:this.changeLanguage.bind(this)},this.languages.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:item},item);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'WrapWord'},'\u6362\u884C\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.wrapWord,onChange:this.changeWrapWord.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'on'},'\u81EA\u52A8\u6362\u884C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'off'},'\u4E0D\u6362\u884C')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ToggleImage',alt:'\u5F00\u5173',src:__WEBPACK_IMPORTED_MODULE_4__img_settings_svg___default.a,onClick:this.togglePanel.bind(this)}));}},{key:'vsEditorLayout',value:function vsEditorLayout(){console.log("vsEditorLayout 方法调用");this.vsEditor.layout();}},{key:'togglePanel',value:function togglePanel(){this.setState({show:!this.state.show});}},{key:'changeLanguage',value:function changeLanguage(e){var language=e.target.value;this.setState({show:!this.state.show,language:language});if(this.vsEditor){__WEBPACK_IMPORTED_MODULE_2_monaco_editor__["editor"].setModelLanguage(this.vsEditor.getModel(),language);}Object(__WEBPACK_IMPORTED_MODULE_5__utils_Utils__["b" /* saveToLocalStorage */])(languageKey,language);}},{key:'changeWrapWord',value:function changeWrapWord(e){var wrapInfo=e.target.value;this.setState({show:!this.state.show,wrapWord:wrapInfo});if(this.vsEditor){this.vsEditor.updateOptions({wordWrap:wrapInfo});}Object(__WEBPACK_IMPORTED_MODULE_5__utils_Utils__["b" /* saveToLocalStorage */])(wrapWordKey,wrapInfo);}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = once;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function once(fn) {
    var _this = this;
    var didCall = false;
    var result;
    return function () {
        if (didCall) {
            return result;
        }
        didCall = true;
        result = fn.apply(_this, arguments);
        return result;
    };
}


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marked; });
/* unused harmony export Parser */
/* unused harmony export parser */
/* unused harmony export Renderer */
/* unused harmony export TextRenderer */
/* unused harmony export Lexer */
/* unused harmony export lexer */
/* unused harmony export InlineLexer */
/* unused harmony export inlineLexer */
/* unused harmony export parse */
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

var __marked_exports;

; (function (root) {
'use strict';

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: noop,
  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,
  nptable: noop,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?\\?>\\n*' // (3)
    + '|<![A-Z][\\s\\S]*?>\\n*' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)' // (6)
    + '|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=\\h*\\n)[\\s\\S]*?(?:\\n{2,}|$)' // (7) open tag
    + '|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=\\h*\\n)[\\s\\S]*?(?:\\n{2,}|$)' // (7) closing tag
    + ')',
  def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
  table: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading| {0,3}>|<\/?(?:tag)(?: +|\n|\/?>)|<(?:script|pre|style|!--))[^\n]+)*)/,
  text: /^[^\n]+/
};

block._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def)
  .replace('label', block._label)
  .replace('title', block._title)
  .getRegex();

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = edit(block.item, 'gm')
  .replace(/bull/g, block.bullet)
  .getRegex();

block.list = edit(block.list)
  .replace(/bull/g, block.bullet)
  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
  .replace('def', '\\n+(?=' + block.def.source + ')')
  .getRegex();

block._tag = 'address|article|aside|base|basefont|blockquote|body|caption'
  + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
  + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
  + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
  + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr'
  + '|track|ul';
block._comment = /<!--(?!-?>)[\s\S]*?-->/;
block.html = edit(block.html, 'i')
  .replace('comment', block._comment)
  .replace('tag', block._tag)
  .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
  .getRegex();

block.paragraph = edit(block.paragraph)
  .replace('hr', block.hr)
  .replace('heading', block.heading)
  .replace('lheading', block.lheading)
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();

block.blockquote = edit(block.blockquote)
  .replace('paragraph', block.paragraph)
  .getRegex();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = edit(block.paragraph)
  .replace('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  .getRegex();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *([^|\n ].*\|.*)\n *([-:]+ *\|[-| :]*)(?:\n((?:.*[^>\n ].*(?:\n|$))*)\n*|$)/,
  table: /^ *\|(.+)\n *\|?( *[-:]+[-| :]*)(?:\n((?: *[^>\n ].*(?:\n|$))*)\n*|$)/
});

/**
 * Pedantic grammar
 */

block.pedantic = merge({}, block.normal, {
  html: edit(
    '^ *(?:comment *(?:\\n|\\s*$)'
    + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
    .replace('comment', block._comment)
    .replace(/tag/g, '(?!(?:'
      + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
      + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
      + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
    .getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = {};
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.pedantic) {
    this.rules = block.pedantic;
  } else if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top) {
  src = src.replace(/^ +$/gm, '');
  var next,
      loose,
      cap,
      bull,
      b,
      item,
      space,
      i,
      tag,
      l,
      isordered,
      istask,
      ischecked;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      this.tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? rtrim(cap, '\n')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      item = {
        type: 'table',
        header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        src = src.substring(cap[0].length);

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = splitCells(item.cells[i], item.header.length);
        }

        this.tokens.push(item);

        continue;
      }
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];
      isordered = bull.length > 1;

      this.tokens.push({
        type: 'list_start',
        ordered: isordered,
        start: isordered ? +bull : ''
      });

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        // Check for task list items
        istask = /^\[[ xX]\] /.test(item);
        ischecked = undefined;
        if (istask) {
          ischecked = item[1] !== ' ';
          item = item.replace(/^\[[ xX]\] +/, '');
        }

        this.tokens.push({
          type: loose
            ? 'loose_item_start'
            : 'list_item_start',
          task: istask,
          checked: ischecked
        });

        // Recurse.
        this.token(item, false);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if (top && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
      tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
      if (!this.tokens.links[tag]) {
        this.tokens.links[tag] = {
          href: cap[2],
          title: cap[3]
        };
      }
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      item = {
        type: 'table',
        header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3] ? cap[3].replace(/(?: *\| *)?\n$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        src = src.substring(cap[0].length);

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = splitCells(
            item.cells[i].replace(/^ *\| *| *\| *$/g, ''),
            item.header.length);
        }

        this.tokens.push(item);

        continue;
      }
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noop,
  tag: '^comment'
    + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>', // CDATA section
  link: /^!?\[(label)\]\(href(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
  nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
  strong: /^__([^\s][\s\S]*?[^\s])__(?!_)|^\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)|^__([^\s])__(?!_)|^\*\*([^\s])\*\*(?!\*)/,
  em: /^_([^\s][\s\S]*?[^\s_])_(?!_)|^_([^\s_][\s\S]*?[^\s])_(?!_)|^\*([^\s][\s\S]*?[^\s*])\*(?!\*)|^\*([^\s*][\s\S]*?[^\s])\*(?!\*)|^_([^\s_])_(?!_)|^\*([^\s*])\*(?!\*)/,
  code: /^(`+)\s*([\s\S]*?[^`]?)\s*\1(?!`)/,
  br: /^ {2,}\n(?!\s*$)/,
  del: noop,
  text: /^[\s\S]+?(?=[\\<!\[`*]|\b_| {2,}\n|$)/
};

inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;

inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink)
  .replace('scheme', inline._scheme)
  .replace('email', inline._email)
  .getRegex();

inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;

inline.tag = edit(inline.tag)
  .replace('comment', block._comment)
  .replace('attribute', inline._attribute)
  .getRegex();

inline._label = /(?:\[[^\[\]]*\]|\\[\[\]]?|`[^`]*`|[^\[\]\\])*?/;
inline._href = /\s*(<(?:\\[<>]?|[^\s<>\\])*>|(?:\\[()]?|\([^\s\x00-\x1f()\\]*\)|[^\s\x00-\x1f()\\])*?)/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;

inline.link = edit(inline.link)
  .replace('label', inline._label)
  .replace('href', inline._href)
  .replace('title', inline._title)
  .getRegex();

inline.reflink = edit(inline.reflink)
  .replace('label', inline._label)
  .getRegex();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/,
  link: edit(/^!?\[(label)\]\((.*?)\)/)
    .replace('label', inline._label)
    .getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
    .replace('label', inline._label)
    .getRegex()
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
  url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/)
    .replace('email', inline._email)
    .getRegex(),
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^~~(?=\S)([\s\S]*?\S)~~/,
  text: edit(inline.text)
    .replace(']|', '~]|')
    .replace('|', '|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&\'*+/=?^_`{\\|}~-]+@|')
    .getRegex()
});

/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: edit(inline.br).replace('{2,}', '*').getRegex(),
  text: edit(inline.gfm.text).replace('{2,}', '*').getRegex()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer();
  this.renderer.options = this.options;

  if (!this.links) {
    throw new Error('Tokens array requires a `links` property.');
  }

  if (this.options.pedantic) {
    this.rules = inline.pedantic;
  } else if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = '',
      link,
      text,
      href,
      title,
      cap;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += cap[1];
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = escape(this.mangle(cap[1]));
        href = 'mailto:' + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      cap[0] = this.rules._backpedal.exec(cap[0])[0];
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = escape(cap[0]);
        href = 'mailto:' + text;
      } else {
        text = escape(cap[0]);
        if (cap[1] === 'www.') {
          href = 'http://' + text;
        } else {
          href = text;
        }
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0]
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      href = cap[2];
      if (this.options.pedantic) {
        link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

        if (link) {
          href = link[1];
          title = link[3];
        } else {
          title = '';
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : '';
      }
      href = href.trim().replace(/^<([\s\S]*)>$/, '$1');
      out += this.outputLink(cap, {
        href: InlineLexer.escapes(href),
        title: InlineLexer.escapes(title)
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[4] || cap[3] || cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[6] || cap[5] || cap[4] || cap[3] || cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2].trim(), true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.text(escape(this.smartypants(cap[0])));
      continue;
    }

    if (src) {
      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

InlineLexer.escapes = function(text) {
  return text ? text.replace(InlineLexer.rules._escapes, '$1') : text;
}

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = link.href,
      title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = '',
      l = text.length,
      i = 0,
      ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || marked.defaults;
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  if (this.options.headerIds) {
    return '<h'
      + level
      + ' id="'
      + this.options.headerPrefix
      + raw.toLowerCase().replace(/[^\w]+/g, '-')
      + '">'
      + text
      + '</h'
      + level
      + '>\n';
  }
  // ignore IDs
  return '<h' + level + '>' + text + '</h' + level + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered, start) {
  var type = ordered ? 'ol' : 'ul',
      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
  return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.checkbox = function(checked) {
  return '<input '
    + (checked ? 'checked="" ' : '')
    + 'disabled="" type="checkbox"'
    + (this.options.xhtml ? ' /' : '')
    + '> ';
}

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  if (body) body = '<tbody>' + body + '</tbody>';

  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + body
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' align="' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  if (this.options.sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return text;
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return text;
    }
  }
  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
    href = resolveUrl(this.options.baseUrl, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, '%');
  } catch (e) {
    return text;
  }
  var out = '<a href="' + escape(href) + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
    href = resolveUrl(this.options.baseUrl, href);
  }
  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * TextRenderer
 * returns only the textual part of the token
 */

function TextRenderer() {}

// no need for block level renderers

TextRenderer.prototype.strong =
TextRenderer.prototype.em =
TextRenderer.prototype.codespan =
TextRenderer.prototype.del =
TextRenderer.prototype.text = function (text) {
  return text;
}

TextRenderer.prototype.link =
TextRenderer.prototype.image = function(href, title, text) {
  return '' + text;
}

TextRenderer.prototype.br = function() {
  return '';
}

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer();
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options) {
  var parser = new Parser(options);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options);
  // use an InlineLexer with a TextRenderer to extract pure text
  this.inlineText = new InlineLexer(
    src.links,
    merge({}, this.options, {renderer: new TextRenderer()})
  );
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        unescape(this.inlineText.output(this.token.text)));
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = '',
          body = '',
          i,
          row,
          cell,
          j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      body = '';
      var ordered = this.token.ordered,
          start = this.token.start;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered, start);
    }
    case 'list_item_start': {
      body = '';

      if (this.token.task) {
        body += this.renderer.checkbox(this.token.checked);
      }

      while (this.next().type !== 'list_item_end') {
        body += this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'loose_item_start': {
      body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'html': {
      // TODO parse inline content if parameter markdown=1
      return this.renderer.html(this.token.text);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  return html
    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function unescape(html) {
  // explicitly match decimal, hex, and named HTML entities
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function edit(regex, opt) {
  regex = regex.source || regex;
  opt = opt || '';
  return {
    replace: function(name, val) {
      val = val.source || val;
      val = val.replace(/(^|[^\[])\^/g, '$1');
      regex = regex.replace(name, val);
      return this;
    },
    getRegex: function() {
      return new RegExp(regex, opt);
    }
  };
}

function resolveUrl(base, href) {
  if (!baseUrls[' ' + base]) {
    // we can ignore everything in base after the last slash of its path component,
    // but we might need to add _that_
    // https://tools.ietf.org/html/rfc3986#section-3
    if (/^[^:]+:\/*[^/]*$/.test(base)) {
      baseUrls[' ' + base] = base + '/';
    } else {
      baseUrls[' ' + base] = rtrim(base, '/', true);
    }
  }
  base = baseUrls[' ' + base];

  if (href.slice(0, 2) === '//') {
    return base.replace(/:[\s\S]*/, ':') + href;
  } else if (href.charAt(0) === '/') {
    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
  } else {
    return base + href;
  }
}
var baseUrls = {};
var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1,
      target,
      key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}

function splitCells(tableRow, count) {
  // ensure that every cell-delimiting pipe has a space
  // before it to distinguish it from an escaped pipe
  var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
            curr = offset;
        while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/),
      i = 0;

  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count) cells.push('');
  }

  for (; i < cells.length; i++) {
    // leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, '|');
  }
  return cells;
}

// Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
// /c*$/ is vulnerable to REDOS.
// invert: Remove suffix of non-c chars instead. Default falsey.
function rtrim(str, c, invert) {
  if (str.length === 0) {
    return '';
  }

  // Length of suffix matching the invert condition.
  var suffLen = 0;

  // Step left until we fail to match the invert condition.
  while (suffLen < str.length) {
    var currChar = str.charAt(str.length - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }

  return str.substr(0, str.length - suffLen);
}

/**
 * Marked
 */

function marked(src, opt, callback) {
  // throw error in case of non string input
  if (typeof src === 'undefined' || src === null) {
    throw new Error('marked(): input parameter is undefined or null');
  }
  if (typeof src !== 'string') {
    throw new Error('marked(): input parameter is of type '
      + Object.prototype.toString.call(src) + ', string expected');
  }

  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight,
        tokens,
        pending,
        i = 0;

    try {
      tokens = Lexer.lex(src, opt)
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occurred:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.getDefaults = function () {
  return {
    baseUrl: null,
    breaks: false,
    gfm: true,
    headerIds: true,
    headerPrefix: '',
    highlight: null,
    langPrefix: 'language-',
    mangle: true,
    pedantic: false,
    renderer: new Renderer(),
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartLists: false,
    smartypants: false,
    tables: true,
    xhtml: false
  };
}

marked.defaults = marked.getDefaults();

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;
marked.TextRenderer = TextRenderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;
__marked_exports = marked;

}).call(this);

// ESM-comment-begin
// define([], function() {
// return {
//   marked: __marked_exports
// };
// });
// ESM-comment-end

// ESM-uncomment-begin
var marked = __marked_exports;
var Parser = __marked_exports.Parser;
var parser = __marked_exports.parser;
var Renderer = __marked_exports.Renderer;
var TextRenderer = __marked_exports.TextRenderer;
var Lexer = __marked_exports.Lexer;
var lexer = __marked_exports.lexer;
var InlineLexer = __marked_exports.InlineLexer;
var inlineLexer = __marked_exports.inlineLexer;
var parse = __marked_exports.parse;
// ESM-uncomment-end


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Extensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var Extensions = {
    JSONContribution: 'base.contributions.json'
};
function normalizeId(id) {
    if (id.length > 0 && id.charAt(id.length - 1) === '#') {
        return id.substring(0, id.length - 1);
    }
    return id;
}
var JSONContributionRegistry = /** @class */ (function () {
    function JSONContributionRegistry() {
        this._onDidChangeSchema = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.schemasById = {};
    }
    JSONContributionRegistry.prototype.registerSchema = function (uri, unresolvedSchemaContent) {
        this.schemasById[normalizeId(uri)] = unresolvedSchemaContent;
        this._onDidChangeSchema.fire(uri);
    };
    return JSONContributionRegistry;
}());
var jsonContributionRegistry = new JSONContributionRegistry();
__WEBPACK_IMPORTED_MODULE_0__registry_common_platform_js__["a" /* Registry */].add(Extensions.JSONContribution, jsonContributionRegistry);


/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languageSelector_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_modelService_js__ = __webpack_require__(44);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





function isExclusive(selector) {
    if (typeof selector === 'string') {
        return false;
    }
    else if (Array.isArray(selector)) {
        return selector.every(isExclusive);
    }
    else {
        return selector.exclusive;
    }
}
var LanguageFeatureRegistry = /** @class */ (function () {
    function LanguageFeatureRegistry() {
        this._clock = 0;
        this._entries = [];
        this._onDidChange = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
    }
    Object.defineProperty(LanguageFeatureRegistry.prototype, "onDidChange", {
        get: function () {
            return this._onDidChange.event;
        },
        enumerable: true,
        configurable: true
    });
    LanguageFeatureRegistry.prototype.register = function (selector, provider) {
        var _this = this;
        var entry = {
            selector: selector,
            provider: provider,
            _score: -1,
            _time: this._clock++
        };
        this._entries.push(entry);
        this._lastCandidate = undefined;
        this._onDidChange.fire(this._entries.length);
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            if (entry) {
                var idx = _this._entries.indexOf(entry);
                if (idx >= 0) {
                    _this._entries.splice(idx, 1);
                    _this._lastCandidate = undefined;
                    _this._onDidChange.fire(_this._entries.length);
                    entry = undefined;
                }
            }
        });
    };
    LanguageFeatureRegistry.prototype.has = function (model) {
        return this.all(model).length > 0;
    };
    LanguageFeatureRegistry.prototype.all = function (model) {
        if (!model) {
            return [];
        }
        this._updateScores(model);
        var result = [];
        // from registry
        for (var _i = 0, _a = this._entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry._score > 0) {
                result.push(entry.provider);
            }
        }
        return result;
    };
    LanguageFeatureRegistry.prototype.ordered = function (model) {
        var result = [];
        this._orderedForEach(model, function (entry) { return result.push(entry.provider); });
        return result;
    };
    LanguageFeatureRegistry.prototype.orderedGroups = function (model) {
        var result = [];
        var lastBucket;
        var lastBucketScore;
        this._orderedForEach(model, function (entry) {
            if (lastBucket && lastBucketScore === entry._score) {
                lastBucket.push(entry.provider);
            }
            else {
                lastBucketScore = entry._score;
                lastBucket = [entry.provider];
                result.push(lastBucket);
            }
        });
        return result;
    };
    LanguageFeatureRegistry.prototype._orderedForEach = function (model, callback) {
        if (!model) {
            return;
        }
        this._updateScores(model);
        for (var from = 0; from < this._entries.length; from++) {
            var entry = this._entries[from];
            if (entry._score > 0) {
                callback(entry);
            }
        }
    };
    LanguageFeatureRegistry.prototype._updateScores = function (model) {
        var candidate = {
            uri: model.uri.toString(),
            language: model.getLanguageIdentifier().language
        };
        if (this._lastCandidate
            && this._lastCandidate.language === candidate.language
            && this._lastCandidate.uri === candidate.uri) {
            // nothing has changed
            return;
        }
        this._lastCandidate = candidate;
        for (var _i = 0, _a = this._entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            entry._score = Object(__WEBPACK_IMPORTED_MODULE_2__languageSelector_js__["a" /* score */])(entry.selector, model.uri, model.getLanguageIdentifier().language, Object(__WEBPACK_IMPORTED_MODULE_3__services_modelService_js__["b" /* shouldSynchronizeModel */])(model));
            if (isExclusive(entry.selector) && entry._score > 0) {
                // support for one exclusive selector that overwrites
                // any other selector
                for (var _b = 0, _c = this._entries; _b < _c.length; _b++) {
                    var entry_1 = _c[_b];
                    entry_1._score = 0;
                }
                entry._score = 1000;
                break;
            }
        }
        // needs sorting
        this._entries.sort(LanguageFeatureRegistry._compareByScoreAndTime);
    };
    LanguageFeatureRegistry._compareByScoreAndTime = function (a, b) {
        if (a._score < b._score) {
            return 1;
        }
        else if (a._score > b._score) {
            return -1;
        }
        else if (a._time < b._time) {
            return 1;
        }
        else if (a._time > b._time) {
            return -1;
        }
        else {
            return 0;
        }
    };
    return LanguageFeatureRegistry;
}());
/* harmony default export */ __webpack_exports__["a"] = (LanguageFeatureRegistry);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = score;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_glob_js__ = __webpack_require__(248);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

 // TODO@Alex
function score(selector, candidateUri, candidateLanguage, candidateIsSynchronized) {
    if (Array.isArray(selector)) {
        // array -> take max individual value
        var ret = 0;
        for (var _i = 0, selector_1 = selector; _i < selector_1.length; _i++) {
            var filter = selector_1[_i];
            var value = score(filter, candidateUri, candidateLanguage, candidateIsSynchronized);
            if (value === 10) {
                return value; // already at the highest
            }
            if (value > ret) {
                ret = value;
            }
        }
        return ret;
    }
    else if (typeof selector === 'string') {
        if (!candidateIsSynchronized) {
            return 0;
        }
        // short-hand notion, desugars to
        // 'fooLang' -> { language: 'fooLang'}
        // '*' -> { language: '*' }
        if (selector === '*') {
            return 5;
        }
        else if (selector === candidateLanguage) {
            return 10;
        }
        else {
            return 0;
        }
    }
    else if (selector) {
        // filter -> select accordingly, use defaults for scheme
        var language = selector.language, pattern = selector.pattern, scheme = selector.scheme, hasAccessToAllModels = selector.hasAccessToAllModels;
        if (!candidateIsSynchronized && !hasAccessToAllModels) {
            return 0;
        }
        var ret = 0;
        if (scheme) {
            if (scheme === candidateUri.scheme) {
                ret = 10;
            }
            else if (scheme === '*') {
                ret = 5;
            }
            else {
                return 0;
            }
        }
        if (language) {
            if (language === candidateLanguage) {
                ret = 10;
            }
            else if (language === '*') {
                ret = Math.max(ret, 5);
            }
            else {
                return 0;
            }
        }
        if (pattern) {
            if (pattern === candidateUri.fsPath || Object(__WEBPACK_IMPORTED_MODULE_0__base_common_glob_js__["a" /* match */])(pattern, candidateUri.fsPath)) {
                ret = 10;
            }
            else {
                return 0;
            }
        }
        return ret;
    }
    else {
        return 0;
    }
}


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenizationRegistryImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var TokenizationRegistryImpl = /** @class */ (function () {
    function TokenizationRegistryImpl() {
        this._onDidChange = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.onDidChange = this._onDidChange.event;
        this._map = Object.create(null);
        this._colorMap = null;
    }
    TokenizationRegistryImpl.prototype.fire = function (languages) {
        this._onDidChange.fire({
            changedLanguages: languages,
            changedColorMap: false
        });
    };
    TokenizationRegistryImpl.prototype.register = function (language, support) {
        var _this = this;
        this._map[language] = support;
        this.fire([language]);
        return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            if (_this._map[language] !== support) {
                return;
            }
            delete _this._map[language];
            _this.fire([language]);
        });
    };
    TokenizationRegistryImpl.prototype.get = function (language) {
        return (this._map[language] || null);
    };
    TokenizationRegistryImpl.prototype.setColorMap = function (colorMap) {
        this._colorMap = colorMap;
        this._onDidChange.fire({
            changedLanguages: Object.keys(this._map),
            changedColorMap: true
        });
    };
    TokenizationRegistryImpl.prototype.getColorMap = function () {
        return this._colorMap;
    };
    TokenizationRegistryImpl.prototype.getDefaultBackground = function () {
        return this._colorMap[2 /* DefaultBackground */];
    };
    return TokenizationRegistryImpl;
}());



/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditStack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var EditStackElement = /** @class */ (function () {
    function EditStackElement(beforeVersionId, beforeCursorState) {
        this.beforeVersionId = beforeVersionId;
        this.beforeCursorState = beforeCursorState;
        this.afterCursorState = null;
        this.afterVersionId = -1;
        this.editOperations = [];
    }
    EditStackElement.prototype.undo = function (model) {
        // Apply all operations in reverse order
        for (var i = this.editOperations.length - 1; i >= 0; i--) {
            this.editOperations[i] = {
                operations: model.applyEdits(this.editOperations[i].operations)
            };
        }
    };
    EditStackElement.prototype.redo = function (model) {
        // Apply all operations
        for (var i = 0; i < this.editOperations.length; i++) {
            this.editOperations[i] = {
                operations: model.applyEdits(this.editOperations[i].operations)
            };
        }
    };
    return EditStackElement;
}());
function getModelEOL(model) {
    var eol = model.getEOL();
    if (eol === '\n') {
        return __WEBPACK_IMPORTED_MODULE_1__model_js__["d" /* EndOfLineSequence */].LF;
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_1__model_js__["d" /* EndOfLineSequence */].CRLF;
    }
}
var EOLStackElement = /** @class */ (function () {
    function EOLStackElement(beforeVersionId, setEOL) {
        this.beforeVersionId = beforeVersionId;
        this.beforeCursorState = null;
        this.afterCursorState = null;
        this.afterVersionId = -1;
        this.eol = setEOL;
    }
    EOLStackElement.prototype.undo = function (model) {
        var redoEOL = getModelEOL(model);
        model.setEOL(this.eol);
        this.eol = redoEOL;
    };
    EOLStackElement.prototype.redo = function (model) {
        var undoEOL = getModelEOL(model);
        model.setEOL(this.eol);
        this.eol = undoEOL;
    };
    return EOLStackElement;
}());
var EditStack = /** @class */ (function () {
    function EditStack(model) {
        this.model = model;
        this.currentOpenStackElement = null;
        this.past = [];
        this.future = [];
    }
    EditStack.prototype.pushStackElement = function () {
        if (this.currentOpenStackElement !== null) {
            this.past.push(this.currentOpenStackElement);
            this.currentOpenStackElement = null;
        }
    };
    EditStack.prototype.clear = function () {
        this.currentOpenStackElement = null;
        this.past = [];
        this.future = [];
    };
    EditStack.prototype.pushEOL = function (eol) {
        // No support for parallel universes :(
        this.future = [];
        if (this.currentOpenStackElement) {
            this.pushStackElement();
        }
        var prevEOL = getModelEOL(this.model);
        var stackElement = new EOLStackElement(this.model.getAlternativeVersionId(), prevEOL);
        this.model.setEOL(eol);
        stackElement.afterVersionId = this.model.getVersionId();
        this.currentOpenStackElement = stackElement;
        this.pushStackElement();
    };
    EditStack.prototype.pushEditOperation = function (beforeCursorState, editOperations, cursorStateComputer) {
        // No support for parallel universes :(
        this.future = [];
        var stackElement = null;
        if (this.currentOpenStackElement) {
            if (this.currentOpenStackElement instanceof EditStackElement) {
                stackElement = this.currentOpenStackElement;
            }
            else {
                this.pushStackElement();
            }
        }
        if (!this.currentOpenStackElement) {
            stackElement = new EditStackElement(this.model.getAlternativeVersionId(), beforeCursorState);
            this.currentOpenStackElement = stackElement;
        }
        var inverseEditOperation = {
            operations: this.model.applyEdits(editOperations)
        };
        stackElement.editOperations.push(inverseEditOperation);
        stackElement.afterCursorState = EditStack._computeCursorState(cursorStateComputer, inverseEditOperation.operations);
        stackElement.afterVersionId = this.model.getVersionId();
        return stackElement.afterCursorState;
    };
    EditStack._computeCursorState = function (cursorStateComputer, inverseEditOperations) {
        try {
            return cursorStateComputer ? cursorStateComputer(inverseEditOperations) : null;
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            return null;
        }
    };
    EditStack.prototype.undo = function () {
        this.pushStackElement();
        if (this.past.length > 0) {
            var pastStackElement = this.past.pop();
            try {
                pastStackElement.undo(this.model);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
                this.clear();
                return null;
            }
            this.future.push(pastStackElement);
            return {
                selections: pastStackElement.beforeCursorState,
                recordedVersionId: pastStackElement.beforeVersionId
            };
        }
        return null;
    };
    EditStack.prototype.canUndo = function () {
        return (this.past.length > 0);
    };
    EditStack.prototype.redo = function () {
        if (this.future.length > 0) {
            var futureStackElement = this.future.pop();
            try {
                futureStackElement.redo(this.model);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
                this.clear();
                return null;
            }
            this.past.push(futureStackElement);
            return {
                selections: futureStackElement.afterCursorState,
                recordedVersionId: futureStackElement.afterVersionId
            };
        }
        return null;
    };
    EditStack.prototype.canRedo = function () {
        return (this.future.length > 0);
    };
    return EditStack;
}());



/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ModelRawFlush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ModelRawLineChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ModelRawLinesDeleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ModelRawLinesInserted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModelRawEOLChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModelRawContentChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InternalModelContentChangeEvent; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * An event describing that a model has been reset to a new value.
 * @internal
 */
var ModelRawFlush = /** @class */ (function () {
    function ModelRawFlush() {
        this.changeType = 1 /* Flush */;
    }
    return ModelRawFlush;
}());

/**
 * An event describing that a line has changed in a model.
 * @internal
 */
var ModelRawLineChanged = /** @class */ (function () {
    function ModelRawLineChanged(lineNumber, detail) {
        this.changeType = 2 /* LineChanged */;
        this.lineNumber = lineNumber;
        this.detail = detail;
    }
    return ModelRawLineChanged;
}());

/**
 * An event describing that line(s) have been deleted in a model.
 * @internal
 */
var ModelRawLinesDeleted = /** @class */ (function () {
    function ModelRawLinesDeleted(fromLineNumber, toLineNumber) {
        this.changeType = 3 /* LinesDeleted */;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
    }
    return ModelRawLinesDeleted;
}());

/**
 * An event describing that line(s) have been inserted in a model.
 * @internal
 */
var ModelRawLinesInserted = /** @class */ (function () {
    function ModelRawLinesInserted(fromLineNumber, toLineNumber, detail) {
        this.changeType = 4 /* LinesInserted */;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
        this.detail = detail;
    }
    return ModelRawLinesInserted;
}());

/**
 * An event describing that a model has had its EOL changed.
 * @internal
 */
var ModelRawEOLChanged = /** @class */ (function () {
    function ModelRawEOLChanged() {
        this.changeType = 5 /* EOLChanged */;
    }
    return ModelRawEOLChanged;
}());

/**
 * An event describing a change in the text of a model.
 * @internal
 */
var ModelRawContentChangedEvent = /** @class */ (function () {
    function ModelRawContentChangedEvent(changes, versionId, isUndoing, isRedoing) {
        this.changes = changes;
        this.versionId = versionId;
        this.isUndoing = isUndoing;
        this.isRedoing = isRedoing;
    }
    ModelRawContentChangedEvent.prototype.containsEvent = function (type) {
        for (var i = 0, len = this.changes.length; i < len; i++) {
            var change = this.changes[i];
            if (change.changeType === type) {
                return true;
            }
        }
        return false;
    };
    ModelRawContentChangedEvent.merge = function (a, b) {
        var changes = [].concat(a.changes).concat(b.changes);
        var versionId = b.versionId;
        var isUndoing = (a.isUndoing || b.isUndoing);
        var isRedoing = (a.isRedoing || b.isRedoing);
        return new ModelRawContentChangedEvent(changes, versionId, isUndoing, isRedoing);
    };
    return ModelRawContentChangedEvent;
}());

/**
 * @internal
 */
var InternalModelContentChangeEvent = /** @class */ (function () {
    function InternalModelContentChangeEvent(rawContentChangedEvent, contentChangedEvent) {
        this.rawContentChangedEvent = rawContentChangedEvent;
        this.contentChangedEvent = contentChangedEvent;
    }
    InternalModelContentChangeEvent.prototype.merge = function (other) {
        var rawContentChangedEvent = ModelRawContentChangedEvent.merge(this.rawContentChangedEvent, other.rawContentChangedEvent);
        var contentChangedEvent = InternalModelContentChangeEvent._mergeChangeEvents(this.contentChangedEvent, other.contentChangedEvent);
        return new InternalModelContentChangeEvent(rawContentChangedEvent, contentChangedEvent);
    };
    InternalModelContentChangeEvent._mergeChangeEvents = function (a, b) {
        var changes = [].concat(a.changes).concat(b.changes);
        var eol = b.eol;
        var versionId = b.versionId;
        var isUndoing = (a.isUndoing || b.isUndoing);
        var isRedoing = (a.isRedoing || b.isRedoing);
        var isFlush = (a.isFlush || b.isFlush);
        return {
            changes: changes,
            eol: eol,
            versionId: versionId,
            isUndoing: isUndoing,
            isRedoing: isRedoing,
            isFlush: isFlush
        };
    };
    return InternalModelContentChangeEvent;
}());



/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getNodeColor */
/* harmony export (immutable) */ __webpack_exports__["c"] = getNodeIsInOverviewRuler;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntervalNode; });
/* unused harmony export SENTINEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntervalTree; });
/* unused harmony export nodeAcceptEdit */
/* harmony export (immutable) */ __webpack_exports__["d"] = recomputeMaxEnd;
/* unused harmony export intervalCompare */
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function getNodeColor(node) {
    return ((node.metadata & 1 /* ColorMask */) >>> 0 /* ColorOffset */);
}
function setNodeColor(node, color) {
    node.metadata = ((node.metadata & 254 /* ColorMaskInverse */) | (color << 0 /* ColorOffset */));
}
function getNodeIsVisited(node) {
    return ((node.metadata & 2 /* IsVisitedMask */) >>> 1 /* IsVisitedOffset */) === 1;
}
function setNodeIsVisited(node, value) {
    node.metadata = ((node.metadata & 253 /* IsVisitedMaskInverse */) | ((value ? 1 : 0) << 1 /* IsVisitedOffset */));
}
function getNodeIsForValidation(node) {
    return ((node.metadata & 4 /* IsForValidationMask */) >>> 2 /* IsForValidationOffset */) === 1;
}
function setNodeIsForValidation(node, value) {
    node.metadata = ((node.metadata & 251 /* IsForValidationMaskInverse */) | ((value ? 1 : 0) << 2 /* IsForValidationOffset */));
}
function getNodeIsInOverviewRuler(node) {
    return ((node.metadata & 8 /* IsInOverviewRulerMask */) >>> 3 /* IsInOverviewRulerOffset */) === 1;
}
function setNodeIsInOverviewRuler(node, value) {
    node.metadata = ((node.metadata & 247 /* IsInOverviewRulerMaskInverse */) | ((value ? 1 : 0) << 3 /* IsInOverviewRulerOffset */));
}
function getNodeStickiness(node) {
    return ((node.metadata & 48 /* StickinessMask */) >>> 4 /* StickinessOffset */);
}
function _setNodeStickiness(node, stickiness) {
    node.metadata = ((node.metadata & 207 /* StickinessMaskInverse */) | (stickiness << 4 /* StickinessOffset */));
}
var IntervalNode = /** @class */ (function () {
    function IntervalNode(id, start, end) {
        this.metadata = 0;
        this.parent = null;
        this.left = null;
        this.right = null;
        setNodeColor(this, 1 /* Red */);
        this.start = start;
        this.end = end;
        // FORCE_OVERFLOWING_TEST: this.delta = start;
        this.delta = 0;
        this.maxEnd = end;
        this.id = id;
        this.ownerId = 0;
        this.options = null;
        setNodeIsForValidation(this, false);
        _setNodeStickiness(this, 1 /* NeverGrowsWhenTypingAtEdges */);
        setNodeIsInOverviewRuler(this, false);
        this.cachedVersionId = 0;
        this.cachedAbsoluteStart = start;
        this.cachedAbsoluteEnd = end;
        this.range = null;
        setNodeIsVisited(this, false);
    }
    IntervalNode.prototype.reset = function (versionId, start, end, range) {
        this.start = start;
        this.end = end;
        this.maxEnd = end;
        this.cachedVersionId = versionId;
        this.cachedAbsoluteStart = start;
        this.cachedAbsoluteEnd = end;
        this.range = range;
    };
    IntervalNode.prototype.setOptions = function (options) {
        this.options = options;
        var className = this.options.className;
        setNodeIsForValidation(this, (className === "squiggly-error" /* EditorErrorDecoration */
            || className === "squiggly-warning" /* EditorWarningDecoration */
            || className === "squiggly-info" /* EditorInfoDecoration */));
        _setNodeStickiness(this, this.options.stickiness);
        setNodeIsInOverviewRuler(this, this.options.overviewRuler.color ? true : false);
    };
    IntervalNode.prototype.setCachedOffsets = function (absoluteStart, absoluteEnd, cachedVersionId) {
        if (this.cachedVersionId !== cachedVersionId) {
            this.range = null;
        }
        this.cachedVersionId = cachedVersionId;
        this.cachedAbsoluteStart = absoluteStart;
        this.cachedAbsoluteEnd = absoluteEnd;
    };
    IntervalNode.prototype.detach = function () {
        this.parent = null;
        this.left = null;
        this.right = null;
    };
    return IntervalNode;
}());

var SENTINEL = new IntervalNode(null, 0, 0);
SENTINEL.parent = SENTINEL;
SENTINEL.left = SENTINEL;
SENTINEL.right = SENTINEL;
setNodeColor(SENTINEL, 0 /* Black */);
var IntervalTree = /** @class */ (function () {
    function IntervalTree() {
        this.root = SENTINEL;
        this.requestNormalizeDelta = false;
    }
    IntervalTree.prototype.intervalSearch = function (start, end, filterOwnerId, filterOutValidation, cachedVersionId) {
        if (this.root === SENTINEL) {
            return [];
        }
        return intervalSearch(this, start, end, filterOwnerId, filterOutValidation, cachedVersionId);
    };
    IntervalTree.prototype.search = function (filterOwnerId, filterOutValidation, cachedVersionId) {
        if (this.root === SENTINEL) {
            return [];
        }
        return search(this, filterOwnerId, filterOutValidation, cachedVersionId);
    };
    /**
     * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
     */
    IntervalTree.prototype.collectNodesFromOwner = function (ownerId) {
        return collectNodesFromOwner(this, ownerId);
    };
    /**
     * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
     */
    IntervalTree.prototype.collectNodesPostOrder = function () {
        return collectNodesPostOrder(this);
    };
    IntervalTree.prototype.insert = function (node) {
        rbTreeInsert(this, node);
        this._normalizeDeltaIfNecessary();
    };
    IntervalTree.prototype.delete = function (node) {
        rbTreeDelete(this, node);
        this._normalizeDeltaIfNecessary();
    };
    IntervalTree.prototype.resolveNode = function (node, cachedVersionId) {
        var initialNode = node;
        var delta = 0;
        while (node !== this.root) {
            if (node === node.parent.right) {
                delta += node.parent.delta;
            }
            node = node.parent;
        }
        var nodeStart = initialNode.start + delta;
        var nodeEnd = initialNode.end + delta;
        initialNode.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
    };
    IntervalTree.prototype.acceptReplace = function (offset, length, textLength, forceMoveMarkers) {
        // Our strategy is to remove all directly impacted nodes, and then add them back to the tree.
        // (1) collect all nodes that are intersecting this edit as nodes of interest
        var nodesOfInterest = searchForEditing(this, offset, offset + length);
        // (2) remove all nodes that are intersecting this edit
        for (var i = 0, len = nodesOfInterest.length; i < len; i++) {
            var node = nodesOfInterest[i];
            rbTreeDelete(this, node);
        }
        this._normalizeDeltaIfNecessary();
        // (3) edit all tree nodes except the nodes of interest
        noOverlapReplace(this, offset, offset + length, textLength);
        this._normalizeDeltaIfNecessary();
        // (4) edit the nodes of interest and insert them back in the tree
        for (var i = 0, len = nodesOfInterest.length; i < len; i++) {
            var node = nodesOfInterest[i];
            node.start = node.cachedAbsoluteStart;
            node.end = node.cachedAbsoluteEnd;
            nodeAcceptEdit(node, offset, (offset + length), textLength, forceMoveMarkers);
            node.maxEnd = node.end;
            rbTreeInsert(this, node);
        }
        this._normalizeDeltaIfNecessary();
    };
    IntervalTree.prototype._normalizeDeltaIfNecessary = function () {
        if (!this.requestNormalizeDelta) {
            return;
        }
        this.requestNormalizeDelta = false;
        normalizeDelta(this);
    };
    return IntervalTree;
}());

//#region Delta Normalization
function normalizeDelta(T) {
    var node = T.root;
    var delta = 0;
    while (node !== SENTINEL) {
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
        // handle current node
        node.start = delta + node.start;
        node.end = delta + node.end;
        node.delta = 0;
        recomputeMaxEnd(node);
        setNodeIsVisited(node, true);
        // going up from this node
        setNodeIsVisited(node.left, false);
        setNodeIsVisited(node.right, false);
        if (node === node.parent.right) {
            delta -= node.parent.delta;
        }
        node = node.parent;
    }
    setNodeIsVisited(T.root, false);
}
function adjustMarkerBeforeColumn(markerOffset, markerStickToPreviousCharacter, checkOffset, moveSemantics) {
    if (markerOffset < checkOffset) {
        return true;
    }
    if (markerOffset > checkOffset) {
        return false;
    }
    if (moveSemantics === 1 /* ForceMove */) {
        return false;
    }
    if (moveSemantics === 2 /* ForceStay */) {
        return true;
    }
    return markerStickToPreviousCharacter;
}
/**
 * This is a lot more complicated than strictly necessary to maintain the same behaviour
 * as when decorations were implemented using two markers.
 */
function nodeAcceptEdit(node, start, end, textLength, forceMoveMarkers) {
    var nodeStickiness = getNodeStickiness(node);
    var startStickToPreviousCharacter = (nodeStickiness === 0 /* AlwaysGrowsWhenTypingAtEdges */
        || nodeStickiness === 2 /* GrowsOnlyWhenTypingBefore */);
    var endStickToPreviousCharacter = (nodeStickiness === 1 /* NeverGrowsWhenTypingAtEdges */
        || nodeStickiness === 2 /* GrowsOnlyWhenTypingBefore */);
    var deletingCnt = (end - start);
    var insertingCnt = textLength;
    var commonLength = Math.min(deletingCnt, insertingCnt);
    var nodeStart = node.start;
    var startDone = false;
    var nodeEnd = node.end;
    var endDone = false;
    {
        var moveSemantics = forceMoveMarkers ? 1 /* ForceMove */ : (deletingCnt > 0 ? 2 /* ForceStay */ : 0 /* MarkerDefined */);
        if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, start, moveSemantics)) {
            startDone = true;
        }
        if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, start, moveSemantics)) {
            endDone = true;
        }
    }
    if (commonLength > 0 && !forceMoveMarkers) {
        var moveSemantics = (deletingCnt > insertingCnt ? 2 /* ForceStay */ : 0 /* MarkerDefined */);
        if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, start + commonLength, moveSemantics)) {
            startDone = true;
        }
        if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, start + commonLength, moveSemantics)) {
            endDone = true;
        }
    }
    {
        var moveSemantics = forceMoveMarkers ? 1 /* ForceMove */ : 0 /* MarkerDefined */;
        if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, end, moveSemantics)) {
            node.start = start + insertingCnt;
            startDone = true;
        }
        if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, end, moveSemantics)) {
            node.end = start + insertingCnt;
            endDone = true;
        }
    }
    // Finish
    var deltaColumn = (insertingCnt - deletingCnt);
    if (!startDone) {
        node.start = Math.max(0, nodeStart + deltaColumn);
        startDone = true;
    }
    if (!endDone) {
        node.end = Math.max(0, nodeEnd + deltaColumn);
        endDone = true;
    }
    if (node.start > node.end) {
        node.end = node.start;
    }
}
function searchForEditing(T, start, end) {
    // https://en.wikipedia.org/wiki/Interval_tree#Augmented_tree
    // Now, it is known that two intervals A and B overlap only when both
    // A.low <= B.high and A.high >= B.low. When searching the trees for
    // nodes overlapping with a given interval, you can immediately skip:
    //  a) all nodes to the right of nodes whose low value is past the end of the given interval.
    //  b) all nodes that have their maximum 'high' value below the start of the given interval.
    var node = T.root;
    var delta = 0;
    var nodeMaxEnd = 0;
    var nodeStart = 0;
    var nodeEnd = 0;
    var result = [];
    var resultLen = 0;
    while (node !== SENTINEL) {
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) {
                delta -= node.parent.delta;
            }
            node = node.parent;
            continue;
        }
        if (!getNodeIsVisited(node.left)) {
            // first time seeing this node
            nodeMaxEnd = delta + node.maxEnd;
            if (nodeMaxEnd < start) {
                // cover case b) from above
                // there is no need to search this node or its children
                setNodeIsVisited(node, true);
                continue;
            }
            if (node.left !== SENTINEL) {
                // go left
                node = node.left;
                continue;
            }
        }
        // handle current node
        nodeStart = delta + node.start;
        if (nodeStart > end) {
            // cover case a) from above
            // there is no need to search this node or its right subtree
            setNodeIsVisited(node, true);
            continue;
        }
        nodeEnd = delta + node.end;
        if (nodeEnd >= start) {
            node.setCachedOffsets(nodeStart, nodeEnd, 0);
            result[resultLen++] = node;
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function noOverlapReplace(T, start, end, textLength) {
    // https://en.wikipedia.org/wiki/Interval_tree#Augmented_tree
    // Now, it is known that two intervals A and B overlap only when both
    // A.low <= B.high and A.high >= B.low. When searching the trees for
    // nodes overlapping with a given interval, you can immediately skip:
    //  a) all nodes to the right of nodes whose low value is past the end of the given interval.
    //  b) all nodes that have their maximum 'high' value below the start of the given interval.
    var node = T.root;
    var delta = 0;
    var nodeMaxEnd = 0;
    var nodeStart = 0;
    var editDelta = (textLength - (end - start));
    while (node !== SENTINEL) {
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) {
                delta -= node.parent.delta;
            }
            recomputeMaxEnd(node);
            node = node.parent;
            continue;
        }
        if (!getNodeIsVisited(node.left)) {
            // first time seeing this node
            nodeMaxEnd = delta + node.maxEnd;
            if (nodeMaxEnd < start) {
                // cover case b) from above
                // there is no need to search this node or its children
                setNodeIsVisited(node, true);
                continue;
            }
            if (node.left !== SENTINEL) {
                // go left
                node = node.left;
                continue;
            }
        }
        // handle current node
        nodeStart = delta + node.start;
        if (nodeStart > end) {
            node.start += editDelta;
            node.end += editDelta;
            node.delta += editDelta;
            if (node.delta < -1073741824 /* MIN_SAFE_DELTA */ || node.delta > 1073741824 /* MAX_SAFE_DELTA */) {
                T.requestNormalizeDelta = true;
            }
            // cover case a) from above
            // there is no need to search this node or its right subtree
            setNodeIsVisited(node, true);
            continue;
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
}
//#endregion
//#region Searching
function collectNodesFromOwner(T, ownerId) {
    var node = T.root;
    var result = [];
    var resultLen = 0;
    while (node !== SENTINEL) {
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            node = node.parent;
            continue;
        }
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        // handle current node
        if (node.ownerId === ownerId) {
            result[resultLen++] = node;
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function collectNodesPostOrder(T) {
    var node = T.root;
    var result = [];
    var resultLen = 0;
    while (node !== SENTINEL) {
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            node = node.parent;
            continue;
        }
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            node = node.right;
            continue;
        }
        // handle current node
        result[resultLen++] = node;
        setNodeIsVisited(node, true);
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function search(T, filterOwnerId, filterOutValidation, cachedVersionId) {
    var node = T.root;
    var delta = 0;
    var nodeStart = 0;
    var nodeEnd = 0;
    var result = [];
    var resultLen = 0;
    while (node !== SENTINEL) {
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) {
                delta -= node.parent.delta;
            }
            node = node.parent;
            continue;
        }
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        // handle current node
        nodeStart = delta + node.start;
        nodeEnd = delta + node.end;
        node.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
        var include = true;
        if (filterOwnerId && node.ownerId && node.ownerId !== filterOwnerId) {
            include = false;
        }
        if (filterOutValidation && getNodeIsForValidation(node)) {
            include = false;
        }
        if (include) {
            result[resultLen++] = node;
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function intervalSearch(T, intervalStart, intervalEnd, filterOwnerId, filterOutValidation, cachedVersionId) {
    // https://en.wikipedia.org/wiki/Interval_tree#Augmented_tree
    // Now, it is known that two intervals A and B overlap only when both
    // A.low <= B.high and A.high >= B.low. When searching the trees for
    // nodes overlapping with a given interval, you can immediately skip:
    //  a) all nodes to the right of nodes whose low value is past the end of the given interval.
    //  b) all nodes that have their maximum 'high' value below the start of the given interval.
    var node = T.root;
    var delta = 0;
    var nodeMaxEnd = 0;
    var nodeStart = 0;
    var nodeEnd = 0;
    var result = [];
    var resultLen = 0;
    while (node !== SENTINEL) {
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) {
                delta -= node.parent.delta;
            }
            node = node.parent;
            continue;
        }
        if (!getNodeIsVisited(node.left)) {
            // first time seeing this node
            nodeMaxEnd = delta + node.maxEnd;
            if (nodeMaxEnd < intervalStart) {
                // cover case b) from above
                // there is no need to search this node or its children
                setNodeIsVisited(node, true);
                continue;
            }
            if (node.left !== SENTINEL) {
                // go left
                node = node.left;
                continue;
            }
        }
        // handle current node
        nodeStart = delta + node.start;
        if (nodeStart > intervalEnd) {
            // cover case a) from above
            // there is no need to search this node or its right subtree
            setNodeIsVisited(node, true);
            continue;
        }
        nodeEnd = delta + node.end;
        if (nodeEnd >= intervalStart) {
            // There is overlap
            node.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
            var include = true;
            if (filterOwnerId && node.ownerId && node.ownerId !== filterOwnerId) {
                include = false;
            }
            if (filterOutValidation && getNodeIsForValidation(node)) {
                include = false;
            }
            if (include) {
                result[resultLen++] = node;
            }
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
//#endregion
//#region Insertion
function rbTreeInsert(T, newNode) {
    if (T.root === SENTINEL) {
        newNode.parent = SENTINEL;
        newNode.left = SENTINEL;
        newNode.right = SENTINEL;
        setNodeColor(newNode, 0 /* Black */);
        T.root = newNode;
        return T.root;
    }
    treeInsert(T, newNode);
    recomputeMaxEndWalkToRoot(newNode.parent);
    // repair tree
    var x = newNode;
    while (x !== T.root && getNodeColor(x.parent) === 1 /* Red */) {
        if (x.parent === x.parent.parent.left) {
            var y = x.parent.parent.right;
            if (getNodeColor(y) === 1 /* Red */) {
                setNodeColor(x.parent, 0 /* Black */);
                setNodeColor(y, 0 /* Black */);
                setNodeColor(x.parent.parent, 1 /* Red */);
                x = x.parent.parent;
            }
            else {
                if (x === x.parent.right) {
                    x = x.parent;
                    leftRotate(T, x);
                }
                setNodeColor(x.parent, 0 /* Black */);
                setNodeColor(x.parent.parent, 1 /* Red */);
                rightRotate(T, x.parent.parent);
            }
        }
        else {
            var y = x.parent.parent.left;
            if (getNodeColor(y) === 1 /* Red */) {
                setNodeColor(x.parent, 0 /* Black */);
                setNodeColor(y, 0 /* Black */);
                setNodeColor(x.parent.parent, 1 /* Red */);
                x = x.parent.parent;
            }
            else {
                if (x === x.parent.left) {
                    x = x.parent;
                    rightRotate(T, x);
                }
                setNodeColor(x.parent, 0 /* Black */);
                setNodeColor(x.parent.parent, 1 /* Red */);
                leftRotate(T, x.parent.parent);
            }
        }
    }
    setNodeColor(T.root, 0 /* Black */);
    return newNode;
}
function treeInsert(T, z) {
    var delta = 0;
    var x = T.root;
    var zAbsoluteStart = z.start;
    var zAbsoluteEnd = z.end;
    while (true) {
        var cmp = intervalCompare(zAbsoluteStart, zAbsoluteEnd, x.start + delta, x.end + delta);
        if (cmp < 0) {
            // this node should be inserted to the left
            // => it is not affected by the node's delta
            if (x.left === SENTINEL) {
                z.start -= delta;
                z.end -= delta;
                z.maxEnd -= delta;
                x.left = z;
                break;
            }
            else {
                x = x.left;
            }
        }
        else {
            // this node should be inserted to the right
            // => it is not affected by the node's delta
            if (x.right === SENTINEL) {
                z.start -= (delta + x.delta);
                z.end -= (delta + x.delta);
                z.maxEnd -= (delta + x.delta);
                x.right = z;
                break;
            }
            else {
                delta += x.delta;
                x = x.right;
            }
        }
    }
    z.parent = x;
    z.left = SENTINEL;
    z.right = SENTINEL;
    setNodeColor(z, 1 /* Red */);
}
//#endregion
//#region Deletion
function rbTreeDelete(T, z) {
    var x;
    var y;
    // RB-DELETE except we don't swap z and y in case c)
    // i.e. we always delete what's pointed at by z.
    if (z.left === SENTINEL) {
        x = z.right;
        y = z;
        // x's delta is no longer influenced by z's delta
        x.delta += z.delta;
        if (x.delta < -1073741824 /* MIN_SAFE_DELTA */ || x.delta > 1073741824 /* MAX_SAFE_DELTA */) {
            T.requestNormalizeDelta = true;
        }
        x.start += z.delta;
        x.end += z.delta;
    }
    else if (z.right === SENTINEL) {
        x = z.left;
        y = z;
    }
    else {
        y = leftest(z.right);
        x = y.right;
        // y's delta is no longer influenced by z's delta,
        // but we don't want to walk the entire right-hand-side subtree of x.
        // we therefore maintain z's delta in y, and adjust only x
        x.start += y.delta;
        x.end += y.delta;
        x.delta += y.delta;
        if (x.delta < -1073741824 /* MIN_SAFE_DELTA */ || x.delta > 1073741824 /* MAX_SAFE_DELTA */) {
            T.requestNormalizeDelta = true;
        }
        y.start += z.delta;
        y.end += z.delta;
        y.delta = z.delta;
        if (y.delta < -1073741824 /* MIN_SAFE_DELTA */ || y.delta > 1073741824 /* MAX_SAFE_DELTA */) {
            T.requestNormalizeDelta = true;
        }
    }
    if (y === T.root) {
        T.root = x;
        setNodeColor(x, 0 /* Black */);
        z.detach();
        resetSentinel();
        recomputeMaxEnd(x);
        T.root.parent = SENTINEL;
        return;
    }
    var yWasRed = (getNodeColor(y) === 1 /* Red */);
    if (y === y.parent.left) {
        y.parent.left = x;
    }
    else {
        y.parent.right = x;
    }
    if (y === z) {
        x.parent = y.parent;
    }
    else {
        if (y.parent === z) {
            x.parent = y;
        }
        else {
            x.parent = y.parent;
        }
        y.left = z.left;
        y.right = z.right;
        y.parent = z.parent;
        setNodeColor(y, getNodeColor(z));
        if (z === T.root) {
            T.root = y;
        }
        else {
            if (z === z.parent.left) {
                z.parent.left = y;
            }
            else {
                z.parent.right = y;
            }
        }
        if (y.left !== SENTINEL) {
            y.left.parent = y;
        }
        if (y.right !== SENTINEL) {
            y.right.parent = y;
        }
    }
    z.detach();
    if (yWasRed) {
        recomputeMaxEndWalkToRoot(x.parent);
        if (y !== z) {
            recomputeMaxEndWalkToRoot(y);
            recomputeMaxEndWalkToRoot(y.parent);
        }
        resetSentinel();
        return;
    }
    recomputeMaxEndWalkToRoot(x);
    recomputeMaxEndWalkToRoot(x.parent);
    if (y !== z) {
        recomputeMaxEndWalkToRoot(y);
        recomputeMaxEndWalkToRoot(y.parent);
    }
    // RB-DELETE-FIXUP
    var w;
    while (x !== T.root && getNodeColor(x) === 0 /* Black */) {
        if (x === x.parent.left) {
            w = x.parent.right;
            if (getNodeColor(w) === 1 /* Red */) {
                setNodeColor(w, 0 /* Black */);
                setNodeColor(x.parent, 1 /* Red */);
                leftRotate(T, x.parent);
                w = x.parent.right;
            }
            if (getNodeColor(w.left) === 0 /* Black */ && getNodeColor(w.right) === 0 /* Black */) {
                setNodeColor(w, 1 /* Red */);
                x = x.parent;
            }
            else {
                if (getNodeColor(w.right) === 0 /* Black */) {
                    setNodeColor(w.left, 0 /* Black */);
                    setNodeColor(w, 1 /* Red */);
                    rightRotate(T, w);
                    w = x.parent.right;
                }
                setNodeColor(w, getNodeColor(x.parent));
                setNodeColor(x.parent, 0 /* Black */);
                setNodeColor(w.right, 0 /* Black */);
                leftRotate(T, x.parent);
                x = T.root;
            }
        }
        else {
            w = x.parent.left;
            if (getNodeColor(w) === 1 /* Red */) {
                setNodeColor(w, 0 /* Black */);
                setNodeColor(x.parent, 1 /* Red */);
                rightRotate(T, x.parent);
                w = x.parent.left;
            }
            if (getNodeColor(w.left) === 0 /* Black */ && getNodeColor(w.right) === 0 /* Black */) {
                setNodeColor(w, 1 /* Red */);
                x = x.parent;
            }
            else {
                if (getNodeColor(w.left) === 0 /* Black */) {
                    setNodeColor(w.right, 0 /* Black */);
                    setNodeColor(w, 1 /* Red */);
                    leftRotate(T, w);
                    w = x.parent.left;
                }
                setNodeColor(w, getNodeColor(x.parent));
                setNodeColor(x.parent, 0 /* Black */);
                setNodeColor(w.left, 0 /* Black */);
                rightRotate(T, x.parent);
                x = T.root;
            }
        }
    }
    setNodeColor(x, 0 /* Black */);
    resetSentinel();
}
function leftest(node) {
    while (node.left !== SENTINEL) {
        node = node.left;
    }
    return node;
}
function resetSentinel() {
    SENTINEL.parent = SENTINEL;
    SENTINEL.delta = 0; // optional
    SENTINEL.start = 0; // optional
    SENTINEL.end = 0; // optional
}
//#endregion
//#region Rotations
function leftRotate(T, x) {
    var y = x.right; // set y.
    y.delta += x.delta; // y's delta is no longer influenced by x's delta
    if (y.delta < -1073741824 /* MIN_SAFE_DELTA */ || y.delta > 1073741824 /* MAX_SAFE_DELTA */) {
        T.requestNormalizeDelta = true;
    }
    y.start += x.delta;
    y.end += x.delta;
    x.right = y.left; // turn y's left subtree into x's right subtree.
    if (y.left !== SENTINEL) {
        y.left.parent = x;
    }
    y.parent = x.parent; // link x's parent to y.
    if (x.parent === SENTINEL) {
        T.root = y;
    }
    else if (x === x.parent.left) {
        x.parent.left = y;
    }
    else {
        x.parent.right = y;
    }
    y.left = x; // put x on y's left.
    x.parent = y;
    recomputeMaxEnd(x);
    recomputeMaxEnd(y);
}
function rightRotate(T, y) {
    var x = y.left;
    y.delta -= x.delta;
    if (y.delta < -1073741824 /* MIN_SAFE_DELTA */ || y.delta > 1073741824 /* MAX_SAFE_DELTA */) {
        T.requestNormalizeDelta = true;
    }
    y.start -= x.delta;
    y.end -= x.delta;
    y.left = x.right;
    if (x.right !== SENTINEL) {
        x.right.parent = y;
    }
    x.parent = y.parent;
    if (y.parent === SENTINEL) {
        T.root = x;
    }
    else if (y === y.parent.right) {
        y.parent.right = x;
    }
    else {
        y.parent.left = x;
    }
    x.right = y;
    y.parent = x;
    recomputeMaxEnd(y);
    recomputeMaxEnd(x);
}
//#endregion
//#region max end computation
function computeMaxEnd(node) {
    var maxEnd = node.end;
    if (node.left !== SENTINEL) {
        var leftMaxEnd = node.left.maxEnd;
        if (leftMaxEnd > maxEnd) {
            maxEnd = leftMaxEnd;
        }
    }
    if (node.right !== SENTINEL) {
        var rightMaxEnd = node.right.maxEnd + node.delta;
        if (rightMaxEnd > maxEnd) {
            maxEnd = rightMaxEnd;
        }
    }
    return maxEnd;
}
function recomputeMaxEnd(node) {
    node.maxEnd = computeMaxEnd(node);
}
function recomputeMaxEndWalkToRoot(node) {
    while (node !== SENTINEL) {
        var maxEnd = computeMaxEnd(node);
        if (node.maxEnd === maxEnd) {
            // no need to go further
            return;
        }
        node.maxEnd = maxEnd;
        node = node.parent;
    }
}
//#endregion
//#region utils
function intervalCompare(aStart, aEnd, bStart, bEnd) {
    if (aStart === bStart) {
        return aEnd - bEnd;
    }
    return aStart - bStart;
}


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StopWatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_js__ = __webpack_require__(14);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var hasPerformanceNow = (__WEBPACK_IMPORTED_MODULE_0__platform_js__["b" /* globals */].performance && typeof __WEBPACK_IMPORTED_MODULE_0__platform_js__["b" /* globals */].performance.now === 'function');
var StopWatch = /** @class */ (function () {
    function StopWatch(highResolution) {
        this._highResolution = hasPerformanceNow && highResolution;
        this._startTime = this._now();
        this._stopTime = -1;
    }
    StopWatch.create = function (highResolution) {
        if (highResolution === void 0) { highResolution = true; }
        return new StopWatch(highResolution);
    };
    StopWatch.prototype.elapsed = function () {
        if (this._stopTime !== -1) {
            return this._stopTime - this._startTime;
        }
        return this._now() - this._startTime;
    };
    StopWatch.prototype._now = function () {
        return this._highResolution ? __WEBPACK_IMPORTED_MODULE_0__platform_js__["b" /* globals */].performance.now() : new Date().getTime();
    };
    return StopWatch;
}());



/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharacterPairSupport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__languageConfiguration_js__ = __webpack_require__(58);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var CharacterPairSupport = /** @class */ (function () {
    function CharacterPairSupport(config) {
        if (config.autoClosingPairs) {
            this._autoClosingPairs = config.autoClosingPairs.map(function (el) { return new __WEBPACK_IMPORTED_MODULE_0__languageConfiguration_js__["b" /* StandardAutoClosingPairConditional */](el); });
        }
        else if (config.brackets) {
            this._autoClosingPairs = config.brackets.map(function (b) { return new __WEBPACK_IMPORTED_MODULE_0__languageConfiguration_js__["b" /* StandardAutoClosingPairConditional */]({ open: b[0], close: b[1] }); });
        }
        else {
            this._autoClosingPairs = [];
        }
        this._surroundingPairs = config.surroundingPairs || this._autoClosingPairs;
    }
    CharacterPairSupport.prototype.getAutoClosingPairs = function () {
        return this._autoClosingPairs;
    };
    CharacterPairSupport.prototype.shouldAutoClosePair = function (character, context, column) {
        // Always complete on empty line
        if (context.getTokenCount() === 0) {
            return true;
        }
        var tokenIndex = context.findTokenIndexAtOffset(column - 2);
        var standardTokenType = context.getStandardTokenType(tokenIndex);
        for (var i = 0; i < this._autoClosingPairs.length; ++i) {
            var autoClosingPair = this._autoClosingPairs[i];
            if (autoClosingPair.open === character) {
                return autoClosingPair.isOK(standardTokenType);
            }
        }
        return false;
    };
    CharacterPairSupport.prototype.getSurroundingPairs = function () {
        return this._surroundingPairs;
    };
    return CharacterPairSupport;
}());



/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BracketElectricCharacterSupport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__supports_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__richEditBrackets_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languageConfiguration_js__ = __webpack_require__(58);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var BracketElectricCharacterSupport = /** @class */ (function () {
    function BracketElectricCharacterSupport(richEditBrackets, autoClosePairs, contribution) {
        contribution = contribution || {};
        this._richEditBrackets = richEditBrackets;
        this._complexAutoClosePairs = autoClosePairs.filter(function (pair) { return pair.open.length > 1 && !!pair.close; }).map(function (el) { return new __WEBPACK_IMPORTED_MODULE_2__languageConfiguration_js__["b" /* StandardAutoClosingPairConditional */](el); });
        if (contribution.docComment) {
            // IDocComment is legacy, only partially supported
            this._complexAutoClosePairs.push(new __WEBPACK_IMPORTED_MODULE_2__languageConfiguration_js__["b" /* StandardAutoClosingPairConditional */]({ open: contribution.docComment.open, close: contribution.docComment.close }));
        }
    }
    BracketElectricCharacterSupport.prototype.getElectricCharacters = function () {
        var result = [];
        if (this._richEditBrackets) {
            for (var i = 0, len = this._richEditBrackets.brackets.length; i < len; i++) {
                var bracketPair = this._richEditBrackets.brackets[i];
                var lastChar = bracketPair.close.charAt(bracketPair.close.length - 1);
                result.push(lastChar);
            }
        }
        // auto close
        for (var _i = 0, _a = this._complexAutoClosePairs; _i < _a.length; _i++) {
            var pair = _a[_i];
            result.push(pair.open.charAt(pair.open.length - 1));
        }
        // Filter duplicate entries
        result = result.filter(function (item, pos, array) {
            return array.indexOf(item) === pos;
        });
        return result;
    };
    BracketElectricCharacterSupport.prototype.onElectricCharacter = function (character, context, column) {
        return (this._onElectricAutoClose(character, context, column) ||
            this._onElectricAutoIndent(character, context, column));
    };
    BracketElectricCharacterSupport.prototype._onElectricAutoIndent = function (character, context, column) {
        if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0) {
            return null;
        }
        var tokenIndex = context.findTokenIndexAtOffset(column - 1);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__supports_js__["b" /* ignoreBracketsInToken */])(context.getStandardTokenType(tokenIndex))) {
            return null;
        }
        var reversedBracketRegex = this._richEditBrackets.reversedRegex;
        var text = context.getLineContent().substring(0, column - 1) + character;
        var r = __WEBPACK_IMPORTED_MODULE_1__richEditBrackets_js__["a" /* BracketsUtils */].findPrevBracketInToken(reversedBracketRegex, 1, text, 0, text.length);
        if (!r) {
            return null;
        }
        var bracketText = text.substring(r.startColumn - 1, r.endColumn - 1);
        bracketText = bracketText.toLowerCase();
        var isOpen = this._richEditBrackets.textIsOpenBracket[bracketText];
        if (isOpen) {
            return null;
        }
        var textBeforeBracket = text.substring(0, r.startColumn - 1);
        if (!/^\s*$/.test(textBeforeBracket)) {
            // There is other text on the line before the bracket
            return null;
        }
        return {
            matchOpenBracket: bracketText
        };
    };
    BracketElectricCharacterSupport.prototype._onElectricAutoClose = function (character, context, column) {
        if (!this._complexAutoClosePairs.length) {
            return null;
        }
        var line = context.getLineContent();
        for (var i = 0, len = this._complexAutoClosePairs.length; i < len; i++) {
            var pair = this._complexAutoClosePairs[i];
            // See if the right electric character was pressed
            if (character !== pair.open.charAt(pair.open.length - 1)) {
                continue;
            }
            // check if the full open bracket matches
            var actual = line.substring(line.length - pair.open.length + 1) + character;
            if (actual !== pair.open) {
                continue;
            }
            var lastTokenIndex = context.findTokenIndexAtOffset(column - 1);
            var lastTokenStandardType = context.getStandardTokenType(lastTokenIndex);
            // If we're in a scope listed in 'notIn', do nothing
            if (!pair.isOK(lastTokenStandardType)) {
                continue;
            }
            // If this line already contains the closing tag, do nothing.
            if (line.indexOf(pair.close, column - 1) >= 0) {
                continue;
            }
            return { appendText: pair.close };
        }
        return null;
    };
    return BracketElectricCharacterSupport;
}());



/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OnEnterSupport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languageConfiguration_js__ = __webpack_require__(58);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var OnEnterSupport = /** @class */ (function () {
    function OnEnterSupport(opts) {
        opts = opts || {};
        opts.brackets = opts.brackets || [
            ['(', ')'],
            ['{', '}'],
            ['[', ']']
        ];
        this._brackets = opts.brackets.map(function (bracket) {
            return {
                open: bracket[0],
                openRegExp: OnEnterSupport._createOpenBracketRegExp(bracket[0]),
                close: bracket[1],
                closeRegExp: OnEnterSupport._createCloseBracketRegExp(bracket[1]),
            };
        });
        this._regExpRules = opts.regExpRules || [];
    }
    OnEnterSupport.prototype.onEnter = function (oneLineAboveText, beforeEnterText, afterEnterText) {
        // (1): `regExpRules`
        for (var i = 0, len = this._regExpRules.length; i < len; i++) {
            var rule = this._regExpRules[i];
            if (rule.beforeText.test(beforeEnterText)) {
                if (rule.afterText) {
                    if (rule.afterText.test(afterEnterText)) {
                        return rule.action;
                    }
                }
                else {
                    return rule.action;
                }
            }
        }
        // (2): Special indent-outdent
        if (beforeEnterText.length > 0 && afterEnterText.length > 0) {
            for (var i = 0, len = this._brackets.length; i < len; i++) {
                var bracket = this._brackets[i];
                if (bracket.openRegExp.test(beforeEnterText) && bracket.closeRegExp.test(afterEnterText)) {
                    return { indentAction: __WEBPACK_IMPORTED_MODULE_2__languageConfiguration_js__["a" /* IndentAction */].IndentOutdent };
                }
            }
        }
        // (4): Open bracket based logic
        if (beforeEnterText.length > 0) {
            for (var i = 0, len = this._brackets.length; i < len; i++) {
                var bracket = this._brackets[i];
                if (bracket.openRegExp.test(beforeEnterText)) {
                    return { indentAction: __WEBPACK_IMPORTED_MODULE_2__languageConfiguration_js__["a" /* IndentAction */].Indent };
                }
            }
        }
        return null;
    };
    OnEnterSupport._createOpenBracketRegExp = function (bracket) {
        var str = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["escapeRegExpCharacters"](bracket);
        if (!/\B/.test(str.charAt(0))) {
            str = '\\b' + str;
        }
        str += '\\s*$';
        return OnEnterSupport._safeRegExp(str);
    };
    OnEnterSupport._createCloseBracketRegExp = function (bracket) {
        var str = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["escapeRegExpCharacters"](bracket);
        if (!/\B/.test(str.charAt(str.length - 1))) {
            str = str + '\\b';
        }
        str = '^\\s*' + str;
        return OnEnterSupport._safeRegExp(str);
    };
    OnEnterSupport._safeRegExp = function (def) {
        try {
            return new RegExp(def);
        }
        catch (err) {
            Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(err);
            return null;
        }
    };
    return OnEnterSupport;
}());



/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndentRulesSupport; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var IndentRulesSupport = /** @class */ (function () {
    function IndentRulesSupport(indentationRules) {
        this._indentationRules = indentationRules;
    }
    IndentRulesSupport.prototype.shouldIncrease = function (text) {
        if (this._indentationRules) {
            if (this._indentationRules.increaseIndentPattern && this._indentationRules.increaseIndentPattern.test(text)) {
                return true;
            }
            // if (this._indentationRules.indentNextLinePattern && this._indentationRules.indentNextLinePattern.test(text)) {
            // 	return true;
            // }
        }
        return false;
    };
    IndentRulesSupport.prototype.shouldDecrease = function (text) {
        if (this._indentationRules && this._indentationRules.decreaseIndentPattern && this._indentationRules.decreaseIndentPattern.test(text)) {
            return true;
        }
        return false;
    };
    IndentRulesSupport.prototype.shouldIndentNextLine = function (text) {
        if (this._indentationRules && this._indentationRules.indentNextLinePattern && this._indentationRules.indentNextLinePattern.test(text)) {
            return true;
        }
        return false;
    };
    IndentRulesSupport.prototype.shouldIgnore = function (text) {
        // the text matches `unIndentedLinePattern`
        if (this._indentationRules && this._indentationRules.unIndentedLinePattern && this._indentationRules.unIndentedLinePattern.test(text)) {
            return true;
        }
        return false;
    };
    IndentRulesSupport.prototype.getIndentMetadata = function (text) {
        var ret = 0;
        if (this.shouldIncrease(text)) {
            ret += 1 /* INCREASE_MASK */;
        }
        if (this.shouldDecrease(text)) {
            ret += 2 /* DECREASE_MASK */;
        }
        if (this.shouldIndentNextLine(text)) {
            ret += 4 /* INDENT_NEXTLINE_MASK */;
        }
        if (this.shouldIgnore(text)) {
            ret += 8 /* UNINDENT_MASK */;
        }
        return ret;
    };
    return IndentRulesSupport;
}());



/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModelLinesTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModelTokensChangedEventBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_lineTokens_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modes_nullMode_js__ = __webpack_require__(57);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






function getDefaultMetadata(topLevelLanguageId) {
    return ((topLevelLanguageId << 0 /* LANGUAGEID_OFFSET */)
        | (0 /* Other */ << 8 /* TOKEN_TYPE_OFFSET */)
        | (0 /* None */ << 11 /* FONT_STYLE_OFFSET */)
        | (1 /* DefaultForeground */ << 14 /* FOREGROUND_OFFSET */)
        | (2 /* DefaultBackground */ << 23 /* BACKGROUND_OFFSET */)) >>> 0;
}
var EMPTY_LINE_TOKENS = (new Uint32Array(0)).buffer;
var ModelLineTokens = /** @class */ (function () {
    function ModelLineTokens(state) {
        this._state = state;
        this._lineTokens = null;
        this._invalid = true;
    }
    ModelLineTokens.prototype.deleteBeginning = function (toChIndex) {
        if (this._lineTokens === null || this._lineTokens === EMPTY_LINE_TOKENS) {
            return;
        }
        this.delete(0, toChIndex);
    };
    ModelLineTokens.prototype.deleteEnding = function (fromChIndex) {
        if (this._lineTokens === null || this._lineTokens === EMPTY_LINE_TOKENS) {
            return;
        }
        var tokens = new Uint32Array(this._lineTokens);
        var lineTextLength = tokens[tokens.length - 2];
        this.delete(fromChIndex, lineTextLength);
    };
    ModelLineTokens.prototype.delete = function (fromChIndex, toChIndex) {
        if (this._lineTokens === null || this._lineTokens === EMPTY_LINE_TOKENS || fromChIndex === toChIndex) {
            return;
        }
        var tokens = new Uint32Array(this._lineTokens);
        var tokensCount = (tokens.length >>> 1);
        // special case: deleting everything
        if (fromChIndex === 0 && tokens[tokens.length - 2] === toChIndex) {
            this._lineTokens = EMPTY_LINE_TOKENS;
            return;
        }
        var fromTokenIndex = __WEBPACK_IMPORTED_MODULE_0__core_lineTokens_js__["a" /* LineTokens */].findIndexInTokensArray(tokens, fromChIndex);
        var fromTokenStartOffset = (fromTokenIndex > 0 ? tokens[(fromTokenIndex - 1) << 1] : 0);
        var fromTokenEndOffset = tokens[fromTokenIndex << 1];
        if (toChIndex < fromTokenEndOffset) {
            // the delete range is inside a single token
            var delta_1 = (toChIndex - fromChIndex);
            for (var i = fromTokenIndex; i < tokensCount; i++) {
                tokens[i << 1] -= delta_1;
            }
            return;
        }
        var dest;
        var lastEnd;
        if (fromTokenStartOffset !== fromChIndex) {
            tokens[fromTokenIndex << 1] = fromChIndex;
            dest = ((fromTokenIndex + 1) << 1);
            lastEnd = fromChIndex;
        }
        else {
            dest = (fromTokenIndex << 1);
            lastEnd = fromTokenStartOffset;
        }
        var delta = (toChIndex - fromChIndex);
        for (var tokenIndex = fromTokenIndex + 1; tokenIndex < tokensCount; tokenIndex++) {
            var tokenEndOffset = tokens[tokenIndex << 1] - delta;
            if (tokenEndOffset > lastEnd) {
                tokens[dest++] = tokenEndOffset;
                tokens[dest++] = tokens[(tokenIndex << 1) + 1];
                lastEnd = tokenEndOffset;
            }
        }
        if (dest === tokens.length) {
            // nothing to trim
            return;
        }
        var tmp = new Uint32Array(dest);
        tmp.set(tokens.subarray(0, dest), 0);
        this._lineTokens = tmp.buffer;
    };
    ModelLineTokens.prototype.append = function (_otherTokens) {
        if (_otherTokens === EMPTY_LINE_TOKENS) {
            return;
        }
        if (this._lineTokens === EMPTY_LINE_TOKENS) {
            this._lineTokens = _otherTokens;
            return;
        }
        if (this._lineTokens === null) {
            return;
        }
        if (_otherTokens === null) {
            // cannot determine combined line length...
            this._lineTokens = null;
            return;
        }
        var myTokens = new Uint32Array(this._lineTokens);
        var otherTokens = new Uint32Array(_otherTokens);
        var otherTokensCount = (otherTokens.length >>> 1);
        var result = new Uint32Array(myTokens.length + otherTokens.length);
        result.set(myTokens, 0);
        var dest = myTokens.length;
        var delta = myTokens[myTokens.length - 2];
        for (var i = 0; i < otherTokensCount; i++) {
            result[dest++] = otherTokens[(i << 1)] + delta;
            result[dest++] = otherTokens[(i << 1) + 1];
        }
        this._lineTokens = result.buffer;
    };
    ModelLineTokens.prototype.insert = function (chIndex, textLength) {
        if (!this._lineTokens) {
            // nothing to do
            return;
        }
        var tokens = new Uint32Array(this._lineTokens);
        var tokensCount = (tokens.length >>> 1);
        var fromTokenIndex = __WEBPACK_IMPORTED_MODULE_0__core_lineTokens_js__["a" /* LineTokens */].findIndexInTokensArray(tokens, chIndex);
        if (fromTokenIndex > 0) {
            var fromTokenStartOffset = (fromTokenIndex > 0 ? tokens[(fromTokenIndex - 1) << 1] : 0);
            if (fromTokenStartOffset === chIndex) {
                fromTokenIndex--;
            }
        }
        for (var tokenIndex = fromTokenIndex; tokenIndex < tokensCount; tokenIndex++) {
            tokens[tokenIndex << 1] += textLength;
        }
    };
    return ModelLineTokens;
}());
var ModelLinesTokens = /** @class */ (function () {
    function ModelLinesTokens(languageIdentifier, tokenizationSupport) {
        this.languageIdentifier = languageIdentifier;
        this.tokenizationSupport = tokenizationSupport;
        this._tokens = [];
        if (this.tokenizationSupport) {
            var initialState = null;
            try {
                initialState = this.tokenizationSupport.getInitialState();
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["e" /* onUnexpectedError */])(e);
                this.tokenizationSupport = null;
            }
            if (initialState) {
                this._tokens[0] = new ModelLineTokens(initialState);
            }
        }
        this._invalidLineStartIndex = 0;
        this._lastState = null;
    }
    Object.defineProperty(ModelLinesTokens.prototype, "inValidLineStartIndex", {
        get: function () {
            return this._invalidLineStartIndex;
        },
        enumerable: true,
        configurable: true
    });
    ModelLinesTokens.prototype.getTokens = function (topLevelLanguageId, lineIndex, lineText) {
        var rawLineTokens = null;
        if (lineIndex < this._tokens.length && this._tokens[lineIndex]) {
            rawLineTokens = this._tokens[lineIndex]._lineTokens;
        }
        if (rawLineTokens !== null && rawLineTokens !== EMPTY_LINE_TOKENS) {
            return new __WEBPACK_IMPORTED_MODULE_0__core_lineTokens_js__["a" /* LineTokens */](new Uint32Array(rawLineTokens), lineText);
        }
        var lineTokens = new Uint32Array(2);
        lineTokens[0] = lineText.length;
        lineTokens[1] = getDefaultMetadata(topLevelLanguageId);
        return new __WEBPACK_IMPORTED_MODULE_0__core_lineTokens_js__["a" /* LineTokens */](lineTokens, lineText);
    };
    ModelLinesTokens.prototype.isCheapToTokenize = function (lineNumber) {
        var firstInvalidLineNumber = this._invalidLineStartIndex + 1;
        return (firstInvalidLineNumber >= lineNumber);
    };
    ModelLinesTokens.prototype.hasLinesToTokenize = function (buffer) {
        return (this._invalidLineStartIndex < buffer.getLineCount());
    };
    ModelLinesTokens.prototype.invalidateLine = function (lineIndex) {
        this._setIsInvalid(lineIndex, true);
        if (lineIndex < this._invalidLineStartIndex) {
            this._setIsInvalid(this._invalidLineStartIndex, true);
            this._invalidLineStartIndex = lineIndex;
        }
    };
    ModelLinesTokens.prototype._setIsInvalid = function (lineIndex, invalid) {
        if (lineIndex < this._tokens.length && this._tokens[lineIndex]) {
            this._tokens[lineIndex]._invalid = invalid;
        }
    };
    ModelLinesTokens.prototype._isInvalid = function (lineIndex) {
        if (lineIndex < this._tokens.length && this._tokens[lineIndex]) {
            return this._tokens[lineIndex]._invalid;
        }
        return true;
    };
    ModelLinesTokens.prototype._getState = function (lineIndex) {
        if (lineIndex < this._tokens.length && this._tokens[lineIndex]) {
            return this._tokens[lineIndex]._state;
        }
        return null;
    };
    ModelLinesTokens.prototype._setTokens = function (topLevelLanguageId, lineIndex, lineTextLength, tokens) {
        var target;
        if (lineIndex < this._tokens.length && this._tokens[lineIndex]) {
            target = this._tokens[lineIndex];
        }
        else {
            target = new ModelLineTokens(null);
            this._tokens[lineIndex] = target;
        }
        if (lineTextLength === 0) {
            target._lineTokens = EMPTY_LINE_TOKENS;
            return;
        }
        if (!tokens || tokens.length === 0) {
            tokens = new Uint32Array(2);
            tokens[0] = 0;
            tokens[1] = getDefaultMetadata(topLevelLanguageId);
        }
        __WEBPACK_IMPORTED_MODULE_0__core_lineTokens_js__["a" /* LineTokens */].convertToEndOffset(tokens, lineTextLength);
        target._lineTokens = tokens.buffer;
    };
    ModelLinesTokens.prototype._setState = function (lineIndex, state) {
        if (lineIndex < this._tokens.length && this._tokens[lineIndex]) {
            this._tokens[lineIndex]._state = state;
        }
        else {
            var tmp = new ModelLineTokens(state);
            this._tokens[lineIndex] = tmp;
        }
    };
    //#region Editing
    ModelLinesTokens.prototype.applyEdits = function (range, eolCount, firstLineLength) {
        var deletingLinesCnt = range.endLineNumber - range.startLineNumber;
        var insertingLinesCnt = eolCount;
        var editingLinesCnt = Math.min(deletingLinesCnt, insertingLinesCnt);
        for (var j = editingLinesCnt; j >= 0; j--) {
            this.invalidateLine(range.startLineNumber + j - 1);
        }
        this._acceptDeleteRange(range);
        this._acceptInsertText(new __WEBPACK_IMPORTED_MODULE_2__core_position_js__["a" /* Position */](range.startLineNumber, range.startColumn), eolCount, firstLineLength);
    };
    ModelLinesTokens.prototype._acceptDeleteRange = function (range) {
        var firstLineIndex = range.startLineNumber - 1;
        if (firstLineIndex >= this._tokens.length) {
            return;
        }
        if (range.startLineNumber === range.endLineNumber) {
            if (range.startColumn === range.endColumn) {
                // Nothing to delete
                return;
            }
            this._tokens[firstLineIndex].delete(range.startColumn - 1, range.endColumn - 1);
            return;
        }
        var firstLine = this._tokens[firstLineIndex];
        firstLine.deleteEnding(range.startColumn - 1);
        var lastLineIndex = range.endLineNumber - 1;
        var lastLineTokens = null;
        if (lastLineIndex < this._tokens.length) {
            var lastLine = this._tokens[lastLineIndex];
            lastLine.deleteBeginning(range.endColumn - 1);
            lastLineTokens = lastLine._lineTokens;
        }
        // Take remaining text on last line and append it to remaining text on first line
        firstLine.append(lastLineTokens);
        // Delete middle lines
        this._tokens.splice(range.startLineNumber, range.endLineNumber - range.startLineNumber);
    };
    ModelLinesTokens.prototype._acceptInsertText = function (position, eolCount, firstLineLength) {
        if (eolCount === 0 && firstLineLength === 0) {
            // Nothing to insert
            return;
        }
        var lineIndex = position.lineNumber - 1;
        if (lineIndex >= this._tokens.length) {
            return;
        }
        if (eolCount === 0) {
            // Inserting text on one line
            this._tokens[lineIndex].insert(position.column - 1, firstLineLength);
            return;
        }
        var line = this._tokens[lineIndex];
        line.deleteEnding(position.column - 1);
        line.insert(position.column - 1, firstLineLength);
        var insert = new Array(eolCount);
        for (var i = eolCount - 1; i >= 0; i--) {
            insert[i] = new ModelLineTokens(null);
        }
        this._tokens = __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["a" /* arrayInsert */](this._tokens, position.lineNumber, insert);
    };
    //#endregion
    //#region Tokenization
    ModelLinesTokens.prototype._tokenizeOneLine = function (buffer, eventBuilder) {
        if (!this.hasLinesToTokenize(buffer)) {
            return buffer.getLineCount() + 1;
        }
        var lineNumber = this._invalidLineStartIndex + 1;
        this._updateTokensUntilLine(buffer, eventBuilder, lineNumber);
        return lineNumber;
    };
    ModelLinesTokens.prototype._tokenizeText = function (buffer, text, state) {
        var r = null;
        try {
            r = this.tokenizationSupport.tokenize2(text, state, 0);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["e" /* onUnexpectedError */])(e);
        }
        if (!r) {
            r = Object(__WEBPACK_IMPORTED_MODULE_4__modes_nullMode_js__["e" /* nullTokenize2 */])(this.languageIdentifier.id, text, state, 0);
        }
        return r;
    };
    ModelLinesTokens.prototype._updateTokensUntilLine = function (buffer, eventBuilder, lineNumber) {
        if (!this.tokenizationSupport) {
            this._invalidLineStartIndex = buffer.getLineCount();
            return;
        }
        var linesLength = buffer.getLineCount();
        var endLineIndex = lineNumber - 1;
        // Validate all states up to and including endLineIndex
        for (var lineIndex = this._invalidLineStartIndex; lineIndex <= endLineIndex; lineIndex++) {
            var endStateIndex = lineIndex + 1;
            var r = null;
            var text = buffer.getLineContent(lineIndex + 1);
            try {
                // Tokenize only the first X characters
                var freshState = this._getState(lineIndex).clone();
                r = this.tokenizationSupport.tokenize2(text, freshState, 0);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            }
            if (!r) {
                r = Object(__WEBPACK_IMPORTED_MODULE_4__modes_nullMode_js__["e" /* nullTokenize2 */])(this.languageIdentifier.id, text, this._getState(lineIndex), 0);
            }
            this._setTokens(this.languageIdentifier.id, lineIndex, text.length, r.tokens);
            eventBuilder.registerChangedTokens(lineIndex + 1);
            this._setIsInvalid(lineIndex, false);
            if (endStateIndex < linesLength) {
                if (this._getState(endStateIndex) !== null && r.endState.equals(this._getState(endStateIndex))) {
                    // The end state of this line remains the same
                    var nextInvalidLineIndex = lineIndex + 1;
                    while (nextInvalidLineIndex < linesLength) {
                        if (this._isInvalid(nextInvalidLineIndex)) {
                            break;
                        }
                        if (nextInvalidLineIndex + 1 < linesLength) {
                            if (this._getState(nextInvalidLineIndex + 1) === null) {
                                break;
                            }
                        }
                        else {
                            if (this._lastState === null) {
                                break;
                            }
                        }
                        nextInvalidLineIndex++;
                    }
                    this._invalidLineStartIndex = Math.max(this._invalidLineStartIndex, nextInvalidLineIndex);
                    lineIndex = nextInvalidLineIndex - 1; // -1 because the outer loop increments it
                }
                else {
                    this._setState(endStateIndex, r.endState);
                }
            }
            else {
                this._lastState = r.endState;
            }
        }
        this._invalidLineStartIndex = Math.max(this._invalidLineStartIndex, endLineIndex + 1);
    };
    return ModelLinesTokens;
}());

var ModelTokensChangedEventBuilder = /** @class */ (function () {
    function ModelTokensChangedEventBuilder() {
        this._ranges = [];
    }
    ModelTokensChangedEventBuilder.prototype.registerChangedTokens = function (lineNumber) {
        var ranges = this._ranges;
        var rangesLength = ranges.length;
        var previousRange = rangesLength > 0 ? ranges[rangesLength - 1] : null;
        if (previousRange && previousRange.toLineNumber === lineNumber - 1) {
            // extend previous range
            previousRange.toLineNumber++;
        }
        else {
            // insert new range
            ranges[rangesLength] = {
                fromLineNumber: lineNumber,
                toLineNumber: lineNumber
            };
        }
    };
    ModelTokensChangedEventBuilder.prototype.build = function () {
        if (this._ranges.length === 0) {
            return null;
        }
        return {
            ranges: this._ranges
        };
    };
    return ModelTokensChangedEventBuilder;
}());



/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = guessIndentation;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Compute the diff in spaces between two line's indentation.
 */
function spacesDiff(a, aLength, b, bLength) {
    // This can go both ways (e.g.):
    //  - a: "\t"
    //  - b: "\t    "
    //  => This should count 1 tab and 4 spaces
    var i;
    for (i = 0; i < aLength && i < bLength; i++) {
        var aCharCode = a.charCodeAt(i);
        var bCharCode = b.charCodeAt(i);
        if (aCharCode !== bCharCode) {
            break;
        }
    }
    var aSpacesCnt = 0, aTabsCount = 0;
    for (var j = i; j < aLength; j++) {
        var aCharCode = a.charCodeAt(j);
        if (aCharCode === 32 /* Space */) {
            aSpacesCnt++;
        }
        else {
            aTabsCount++;
        }
    }
    var bSpacesCnt = 0, bTabsCount = 0;
    for (var j = i; j < bLength; j++) {
        var bCharCode = b.charCodeAt(j);
        if (bCharCode === 32 /* Space */) {
            bSpacesCnt++;
        }
        else {
            bTabsCount++;
        }
    }
    if (aSpacesCnt > 0 && aTabsCount > 0) {
        return 0;
    }
    if (bSpacesCnt > 0 && bTabsCount > 0) {
        return 0;
    }
    var tabsDiff = Math.abs(aTabsCount - bTabsCount);
    var spacesDiff = Math.abs(aSpacesCnt - bSpacesCnt);
    if (tabsDiff === 0) {
        return spacesDiff;
    }
    if (spacesDiff % tabsDiff === 0) {
        return spacesDiff / tabsDiff;
    }
    return 0;
}
function guessIndentation(source, defaultTabSize, defaultInsertSpaces) {
    // Look at most at the first 10k lines
    var linesCount = Math.min(source.getLineCount(), 10000);
    var linesIndentedWithTabsCount = 0; // number of lines that contain at least one tab in indentation
    var linesIndentedWithSpacesCount = 0; // number of lines that contain only spaces in indentation
    var previousLineText = ''; // content of latest line that contained non-whitespace chars
    var previousLineIndentation = 0; // index at which latest line contained the first non-whitespace char
    var ALLOWED_TAB_SIZE_GUESSES = [2, 4, 6, 8]; // limit guesses for `tabSize` to 2, 4, 6 or 8.
    var MAX_ALLOWED_TAB_SIZE_GUESS = 8; // max(2,4,6,8) = 8
    var spacesDiffCount = [0, 0, 0, 0, 0, 0, 0, 0, 0]; // `tabSize` scores
    for (var lineNumber = 1; lineNumber <= linesCount; lineNumber++) {
        var currentLineLength = source.getLineLength(lineNumber);
        var currentLineText = source.getLineContent(lineNumber);
        // if the text buffer is chunk based, so long lines are cons-string, v8 will flattern the string when we check charCode.
        // checking charCode on chunks directly is cheaper.
        var useCurrentLineText = (currentLineLength <= 65536);
        var currentLineHasContent = false; // does `currentLineText` contain non-whitespace chars
        var currentLineIndentation = 0; // index at which `currentLineText` contains the first non-whitespace char
        var currentLineSpacesCount = 0; // count of spaces found in `currentLineText` indentation
        var currentLineTabsCount = 0; // count of tabs found in `currentLineText` indentation
        for (var j = 0, lenJ = currentLineLength; j < lenJ; j++) {
            var charCode = (useCurrentLineText ? currentLineText.charCodeAt(j) : source.getLineCharCode(lineNumber, j));
            if (charCode === 9 /* Tab */) {
                currentLineTabsCount++;
            }
            else if (charCode === 32 /* Space */) {
                currentLineSpacesCount++;
            }
            else {
                // Hit non whitespace character on this line
                currentLineHasContent = true;
                currentLineIndentation = j;
                break;
            }
        }
        // Ignore empty or only whitespace lines
        if (!currentLineHasContent) {
            continue;
        }
        if (currentLineTabsCount > 0) {
            linesIndentedWithTabsCount++;
        }
        else if (currentLineSpacesCount > 1) {
            linesIndentedWithSpacesCount++;
        }
        var currentSpacesDiff = spacesDiff(previousLineText, previousLineIndentation, currentLineText, currentLineIndentation);
        if (currentSpacesDiff <= MAX_ALLOWED_TAB_SIZE_GUESS) {
            spacesDiffCount[currentSpacesDiff]++;
        }
        previousLineText = currentLineText;
        previousLineIndentation = currentLineIndentation;
    }
    var insertSpaces = defaultInsertSpaces;
    if (linesIndentedWithTabsCount !== linesIndentedWithSpacesCount) {
        insertSpaces = (linesIndentedWithTabsCount < linesIndentedWithSpacesCount);
    }
    var tabSize = defaultTabSize;
    var tabSizeScore = (insertSpaces ? 0 : 0.1 * linesCount);
    // console.log("score threshold: " + tabSizeScore);
    ALLOWED_TAB_SIZE_GUESSES.forEach(function (possibleTabSize) {
        var possibleTabSizeScore = spacesDiffCount[possibleTabSize];
        if (possibleTabSizeScore > tabSizeScore) {
            tabSizeScore = possibleTabSizeScore;
            tabSize = possibleTabSize;
        }
    });
    // console.log('--------------------------');
    // console.log('linesIndentedWithTabsCount: ' + linesIndentedWithTabsCount + ', linesIndentedWithSpacesCount: ' + linesIndentedWithSpacesCount);
    // console.log('spacesDiffCount: ' + spacesDiffCount);
    // console.log('tabSize: ' + tabSize + ', tabSizeScore: ' + tabSizeScore);
    return {
        insertSpaces: insertSpaces,
        tabSize: tabSize
    };
}


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PieceTreeTextBufferFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PieceTreeTextBufferBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pieceTreeTextBuffer_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pieceTreeBase_js__ = __webpack_require__(249);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var PieceTreeTextBufferFactory = /** @class */ (function () {
    function PieceTreeTextBufferFactory(_chunks, _bom, _cr, _lf, _crlf, _containsRTL, _isBasicASCII, _normalizeEOL) {
        this._chunks = _chunks;
        this._bom = _bom;
        this._cr = _cr;
        this._lf = _lf;
        this._crlf = _crlf;
        this._containsRTL = _containsRTL;
        this._isBasicASCII = _isBasicASCII;
        this._normalizeEOL = _normalizeEOL;
    }
    PieceTreeTextBufferFactory.prototype._getEOL = function (defaultEOL) {
        var totalEOLCount = this._cr + this._lf + this._crlf;
        var totalCRCount = this._cr + this._crlf;
        if (totalEOLCount === 0) {
            // This is an empty file or a file with precisely one line
            return (defaultEOL === __WEBPACK_IMPORTED_MODULE_1__model_js__["b" /* DefaultEndOfLine */].LF ? '\n' : '\r\n');
        }
        if (totalCRCount > totalEOLCount / 2) {
            // More than half of the file contains \r\n ending lines
            return '\r\n';
        }
        // At least one line more ends in \n
        return '\n';
    };
    PieceTreeTextBufferFactory.prototype.create = function (defaultEOL) {
        var eol = this._getEOL(defaultEOL);
        var chunks = this._chunks;
        if (this._normalizeEOL &&
            ((eol === '\r\n' && (this._cr > 0 || this._lf > 0))
                || (eol === '\n' && (this._cr > 0 || this._crlf > 0)))) {
            // Normalize pieces
            for (var i = 0, len = chunks.length; i < len; i++) {
                var str = chunks[i].buffer.replace(/\r\n|\r|\n/g, eol);
                var newLineStart = Object(__WEBPACK_IMPORTED_MODULE_3__pieceTreeBase_js__["d" /* createLineStartsFast */])(str);
                chunks[i] = new __WEBPACK_IMPORTED_MODULE_3__pieceTreeBase_js__["b" /* StringBuffer */](str, newLineStart);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_2__pieceTreeTextBuffer_js__["a" /* PieceTreeTextBuffer */](chunks, this._bom, eol, this._containsRTL, this._isBasicASCII, this._normalizeEOL);
    };
    return PieceTreeTextBufferFactory;
}());

var PieceTreeTextBufferBuilder = /** @class */ (function () {
    function PieceTreeTextBufferBuilder() {
        this.chunks = [];
        this.BOM = '';
        this._hasPreviousChar = false;
        this._previousChar = 0;
        this._tmpLineStarts = [];
        this.cr = 0;
        this.lf = 0;
        this.crlf = 0;
        this.containsRTL = false;
        this.isBasicASCII = true;
    }
    PieceTreeTextBufferBuilder.prototype.acceptChunk = function (chunk) {
        if (chunk.length === 0) {
            return;
        }
        if (this.chunks.length === 0) {
            if (__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["startsWithUTF8BOM"](chunk)) {
                this.BOM = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["UTF8_BOM_CHARACTER"];
                chunk = chunk.substr(1);
            }
        }
        var lastChar = chunk.charCodeAt(chunk.length - 1);
        if (lastChar === 13 /* CarriageReturn */ || (lastChar >= 0xd800 && lastChar <= 0xdbff)) {
            // last character is \r or a high surrogate => keep it back
            this._acceptChunk1(chunk.substr(0, chunk.length - 1), false);
            this._hasPreviousChar = true;
            this._previousChar = lastChar;
        }
        else {
            this._acceptChunk1(chunk, false);
            this._hasPreviousChar = false;
            this._previousChar = lastChar;
        }
    };
    PieceTreeTextBufferBuilder.prototype._acceptChunk1 = function (chunk, allowEmptyStrings) {
        if (!allowEmptyStrings && chunk.length === 0) {
            // Nothing to do
            return;
        }
        if (this._hasPreviousChar) {
            this._acceptChunk2(String.fromCharCode(this._previousChar) + chunk);
        }
        else {
            this._acceptChunk2(chunk);
        }
    };
    PieceTreeTextBufferBuilder.prototype._acceptChunk2 = function (chunk) {
        var lineStarts = Object(__WEBPACK_IMPORTED_MODULE_3__pieceTreeBase_js__["c" /* createLineStarts */])(this._tmpLineStarts, chunk);
        this.chunks.push(new __WEBPACK_IMPORTED_MODULE_3__pieceTreeBase_js__["b" /* StringBuffer */](chunk, lineStarts.lineStarts));
        this.cr += lineStarts.cr;
        this.lf += lineStarts.lf;
        this.crlf += lineStarts.crlf;
        if (this.isBasicASCII) {
            this.isBasicASCII = lineStarts.isBasicASCII;
        }
        if (!this.isBasicASCII && !this.containsRTL) {
            // No need to check if is basic ASCII
            this.containsRTL = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["containsRTL"](chunk);
        }
    };
    PieceTreeTextBufferBuilder.prototype.finish = function (normalizeEOL) {
        if (normalizeEOL === void 0) { normalizeEOL = true; }
        this._finish();
        return new PieceTreeTextBufferFactory(this.chunks, this.BOM, this.cr, this.lf, this.crlf, this.containsRTL, this.isBasicASCII, normalizeEOL);
    };
    PieceTreeTextBufferBuilder.prototype._finish = function () {
        if (this.chunks.length === 0) {
            this._acceptChunk1('', true);
        }
        if (this._hasPreviousChar) {
            this._hasPreviousChar = false;
            // recreate last chunk
            var lastChunk = this.chunks[this.chunks.length - 1];
            lastChunk.buffer += String.fromCharCode(this._previousChar);
            var newLineStarts = Object(__WEBPACK_IMPORTED_MODULE_3__pieceTreeBase_js__["d" /* createLineStartsFast */])(lastChunk.buffer);
            lastChunk.lineStarts = newLineStarts;
            if (this._previousChar === 13 /* CarriageReturn */) {
                this.cr++;
            }
        }
    };
    return PieceTreeTextBufferBuilder;
}());



/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PieceTreeTextBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pieceTreeBase_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var PieceTreeTextBuffer = /** @class */ (function () {
    function PieceTreeTextBuffer(chunks, BOM, eol, containsRTL, isBasicASCII, eolNormalized) {
        this._BOM = BOM;
        this._mightContainNonBasicASCII = !isBasicASCII;
        this._mightContainRTL = containsRTL;
        this._pieceTree = new __WEBPACK_IMPORTED_MODULE_2__pieceTreeBase_js__["a" /* PieceTreeBase */](chunks, eol, eolNormalized);
    }
    PieceTreeTextBuffer.prototype.mightContainRTL = function () {
        return this._mightContainRTL;
    };
    PieceTreeTextBuffer.prototype.mightContainNonBasicASCII = function () {
        return this._mightContainNonBasicASCII;
    };
    PieceTreeTextBuffer.prototype.getBOM = function () {
        return this._BOM;
    };
    PieceTreeTextBuffer.prototype.getEOL = function () {
        return this._pieceTree.getEOL();
    };
    PieceTreeTextBuffer.prototype.getOffsetAt = function (lineNumber, column) {
        return this._pieceTree.getOffsetAt(lineNumber, column);
    };
    PieceTreeTextBuffer.prototype.getPositionAt = function (offset) {
        return this._pieceTree.getPositionAt(offset);
    };
    PieceTreeTextBuffer.prototype.getRangeAt = function (start, length) {
        var end = start + length;
        var startPosition = this.getPositionAt(start);
        var endPosition = this.getPositionAt(end);
        return new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column);
    };
    PieceTreeTextBuffer.prototype.getValueInRange = function (range, eol) {
        if (eol === void 0) { eol = __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].TextDefined; }
        if (range.isEmpty()) {
            return '';
        }
        var lineEnding = this._getEndOfLine(eol);
        return this._pieceTree.getValueInRange(range, lineEnding);
    };
    PieceTreeTextBuffer.prototype.getValueLengthInRange = function (range, eol) {
        if (eol === void 0) { eol = __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].TextDefined; }
        if (range.isEmpty()) {
            return 0;
        }
        if (range.startLineNumber === range.endLineNumber) {
            return (range.endColumn - range.startColumn);
        }
        var startOffset = this.getOffsetAt(range.startLineNumber, range.startColumn);
        var endOffset = this.getOffsetAt(range.endLineNumber, range.endColumn);
        return endOffset - startOffset;
    };
    PieceTreeTextBuffer.prototype.getLength = function () {
        return this._pieceTree.getLength();
    };
    PieceTreeTextBuffer.prototype.getLineCount = function () {
        return this._pieceTree.getLineCount();
    };
    PieceTreeTextBuffer.prototype.getLinesContent = function () {
        return this._pieceTree.getLinesContent();
    };
    PieceTreeTextBuffer.prototype.getLineContent = function (lineNumber) {
        return this._pieceTree.getLineContent(lineNumber);
    };
    PieceTreeTextBuffer.prototype.getLineCharCode = function (lineNumber, index) {
        return this._pieceTree.getLineCharCode(lineNumber, index);
    };
    PieceTreeTextBuffer.prototype.getLineLength = function (lineNumber) {
        return this._pieceTree.getLineLength(lineNumber);
    };
    PieceTreeTextBuffer.prototype.getLineFirstNonWhitespaceColumn = function (lineNumber) {
        var result = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["firstNonWhitespaceIndex"](this.getLineContent(lineNumber));
        if (result === -1) {
            return 0;
        }
        return result + 1;
    };
    PieceTreeTextBuffer.prototype.getLineLastNonWhitespaceColumn = function (lineNumber) {
        var result = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["lastNonWhitespaceIndex"](this.getLineContent(lineNumber));
        if (result === -1) {
            return 0;
        }
        return result + 2;
    };
    PieceTreeTextBuffer.prototype._getEndOfLine = function (eol) {
        switch (eol) {
            case __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].LF:
                return '\n';
            case __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].CRLF:
                return '\r\n';
            case __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].TextDefined:
                return this.getEOL();
        }
        throw new Error('Unknown EOL preference');
    };
    PieceTreeTextBuffer.prototype.setEOL = function (newEOL) {
        this._pieceTree.setEOL(newEOL);
    };
    PieceTreeTextBuffer.prototype.applyEdits = function (rawOperations, recordTrimAutoWhitespace) {
        var mightContainRTL = this._mightContainRTL;
        var mightContainNonBasicASCII = this._mightContainNonBasicASCII;
        var canReduceOperations = true;
        var operations = [];
        for (var i = 0; i < rawOperations.length; i++) {
            var op = rawOperations[i];
            if (canReduceOperations && op._isTracked) {
                canReduceOperations = false;
            }
            var validatedRange = op.range;
            if (!mightContainRTL && op.text) {
                // check if the new inserted text contains RTL
                mightContainRTL = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["containsRTL"](op.text);
            }
            if (!mightContainNonBasicASCII && op.text) {
                mightContainNonBasicASCII = !__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isBasicASCII"](op.text);
            }
            operations[i] = {
                sortIndex: i,
                identifier: op.identifier,
                range: validatedRange,
                rangeOffset: this.getOffsetAt(validatedRange.startLineNumber, validatedRange.startColumn),
                rangeLength: this.getValueLengthInRange(validatedRange),
                lines: op.text ? op.text.split(/\r\n|\r|\n/) : null,
                forceMoveMarkers: op.forceMoveMarkers,
                isAutoWhitespaceEdit: op.isAutoWhitespaceEdit || false
            };
        }
        // Sort operations ascending
        operations.sort(PieceTreeTextBuffer._sortOpsAscending);
        var hasTouchingRanges = false;
        for (var i = 0, count = operations.length - 1; i < count; i++) {
            var rangeEnd = operations[i].range.getEndPosition();
            var nextRangeStart = operations[i + 1].range.getStartPosition();
            if (nextRangeStart.isBeforeOrEqual(rangeEnd)) {
                if (nextRangeStart.isBefore(rangeEnd)) {
                    // overlapping ranges
                    throw new Error('Overlapping ranges are not allowed!');
                }
                hasTouchingRanges = true;
            }
        }
        if (canReduceOperations) {
            operations = this._reduceOperations(operations);
        }
        // Delta encode operations
        var reverseRanges = PieceTreeTextBuffer._getInverseEditRanges(operations);
        var newTrimAutoWhitespaceCandidates = [];
        for (var i = 0; i < operations.length; i++) {
            var op = operations[i];
            var reverseRange = reverseRanges[i];
            if (recordTrimAutoWhitespace && op.isAutoWhitespaceEdit && op.range.isEmpty()) {
                // Record already the future line numbers that might be auto whitespace removal candidates on next edit
                for (var lineNumber = reverseRange.startLineNumber; lineNumber <= reverseRange.endLineNumber; lineNumber++) {
                    var currentLineContent = '';
                    if (lineNumber === reverseRange.startLineNumber) {
                        currentLineContent = this.getLineContent(op.range.startLineNumber);
                        if (__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["firstNonWhitespaceIndex"](currentLineContent) !== -1) {
                            continue;
                        }
                    }
                    newTrimAutoWhitespaceCandidates.push({ lineNumber: lineNumber, oldContent: currentLineContent });
                }
            }
        }
        var reverseOperations = [];
        for (var i = 0; i < operations.length; i++) {
            var op = operations[i];
            var reverseRange = reverseRanges[i];
            reverseOperations[i] = {
                sortIndex: op.sortIndex,
                identifier: op.identifier,
                range: reverseRange,
                text: this.getValueInRange(op.range),
                forceMoveMarkers: op.forceMoveMarkers
            };
        }
        // Can only sort reverse operations when the order is not significant
        if (!hasTouchingRanges) {
            reverseOperations.sort(function (a, b) { return a.sortIndex - b.sortIndex; });
        }
        this._mightContainRTL = mightContainRTL;
        this._mightContainNonBasicASCII = mightContainNonBasicASCII;
        var contentChanges = this._doApplyEdits(operations);
        var trimAutoWhitespaceLineNumbers = null;
        if (recordTrimAutoWhitespace && newTrimAutoWhitespaceCandidates.length > 0) {
            // sort line numbers auto whitespace removal candidates for next edit descending
            newTrimAutoWhitespaceCandidates.sort(function (a, b) { return b.lineNumber - a.lineNumber; });
            trimAutoWhitespaceLineNumbers = [];
            for (var i = 0, len = newTrimAutoWhitespaceCandidates.length; i < len; i++) {
                var lineNumber = newTrimAutoWhitespaceCandidates[i].lineNumber;
                if (i > 0 && newTrimAutoWhitespaceCandidates[i - 1].lineNumber === lineNumber) {
                    // Do not have the same line number twice
                    continue;
                }
                var prevContent = newTrimAutoWhitespaceCandidates[i].oldContent;
                var lineContent = this.getLineContent(lineNumber);
                if (lineContent.length === 0 || lineContent === prevContent || __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["firstNonWhitespaceIndex"](lineContent) !== -1) {
                    continue;
                }
                trimAutoWhitespaceLineNumbers.push(lineNumber);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_3__model_js__["a" /* ApplyEditsResult */](reverseOperations, contentChanges, trimAutoWhitespaceLineNumbers);
    };
    /**
     * Transform operations such that they represent the same logic edit,
     * but that they also do not cause OOM crashes.
     */
    PieceTreeTextBuffer.prototype._reduceOperations = function (operations) {
        if (operations.length < 1000) {
            // We know from empirical testing that a thousand edits work fine regardless of their shape.
            return operations;
        }
        // At one point, due to how events are emitted and how each operation is handled,
        // some operations can trigger a high ammount of temporary string allocations,
        // that will immediately get edited again.
        // e.g. a formatter inserting ridiculous ammounts of \n on a model with a single line
        // Therefore, the strategy is to collapse all the operations into a huge single edit operation
        return [this._toSingleEditOperation(operations)];
    };
    PieceTreeTextBuffer.prototype._toSingleEditOperation = function (operations) {
        var forceMoveMarkers = false, firstEditRange = operations[0].range, lastEditRange = operations[operations.length - 1].range, entireEditRange = new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](firstEditRange.startLineNumber, firstEditRange.startColumn, lastEditRange.endLineNumber, lastEditRange.endColumn), lastEndLineNumber = firstEditRange.startLineNumber, lastEndColumn = firstEditRange.startColumn, result = [];
        for (var i = 0, len = operations.length; i < len; i++) {
            var operation = operations[i], range = operation.range;
            forceMoveMarkers = forceMoveMarkers || operation.forceMoveMarkers;
            // (1) -- Push old text
            for (var lineNumber = lastEndLineNumber; lineNumber < range.startLineNumber; lineNumber++) {
                if (lineNumber === lastEndLineNumber) {
                    result.push(this.getLineContent(lineNumber).substring(lastEndColumn - 1));
                }
                else {
                    result.push('\n');
                    result.push(this.getLineContent(lineNumber));
                }
            }
            if (range.startLineNumber === lastEndLineNumber) {
                result.push(this.getLineContent(range.startLineNumber).substring(lastEndColumn - 1, range.startColumn - 1));
            }
            else {
                result.push('\n');
                result.push(this.getLineContent(range.startLineNumber).substring(0, range.startColumn - 1));
            }
            // (2) -- Push new text
            if (operation.lines) {
                for (var j = 0, lenJ = operation.lines.length; j < lenJ; j++) {
                    if (j !== 0) {
                        result.push('\n');
                    }
                    result.push(operation.lines[j]);
                }
            }
            lastEndLineNumber = operation.range.endLineNumber;
            lastEndColumn = operation.range.endColumn;
        }
        return {
            sortIndex: 0,
            identifier: operations[0].identifier,
            range: entireEditRange,
            rangeOffset: this.getOffsetAt(entireEditRange.startLineNumber, entireEditRange.startColumn),
            rangeLength: this.getValueLengthInRange(entireEditRange, __WEBPACK_IMPORTED_MODULE_3__model_js__["c" /* EndOfLinePreference */].TextDefined),
            lines: result.join('').split('\n'),
            forceMoveMarkers: forceMoveMarkers,
            isAutoWhitespaceEdit: false
        };
    };
    PieceTreeTextBuffer.prototype._doApplyEdits = function (operations) {
        operations.sort(PieceTreeTextBuffer._sortOpsDescending);
        var contentChanges = [];
        // operations are from bottom to top
        for (var i = 0; i < operations.length; i++) {
            var op = operations[i];
            var startLineNumber = op.range.startLineNumber;
            var startColumn = op.range.startColumn;
            var endLineNumber = op.range.endLineNumber;
            var endColumn = op.range.endColumn;
            if (startLineNumber === endLineNumber && startColumn === endColumn && (!op.lines || op.lines.length === 0)) {
                // no-op
                continue;
            }
            var deletingLinesCnt = endLineNumber - startLineNumber;
            var insertingLinesCnt = (op.lines ? op.lines.length - 1 : 0);
            var editingLinesCnt = Math.min(deletingLinesCnt, insertingLinesCnt);
            var text = (op.lines ? op.lines.join(this.getEOL()) : '');
            if (text) {
                // replacement
                this._pieceTree.delete(op.rangeOffset, op.rangeLength);
                this._pieceTree.insert(op.rangeOffset, text, true);
            }
            else {
                // deletion
                this._pieceTree.delete(op.rangeOffset, op.rangeLength);
            }
            if (editingLinesCnt < insertingLinesCnt) {
                var newLinesContent = [];
                for (var j = editingLinesCnt + 1; j <= insertingLinesCnt; j++) {
                    newLinesContent.push(op.lines[j]);
                }
                newLinesContent[newLinesContent.length - 1] = this.getLineContent(startLineNumber + insertingLinesCnt - 1);
            }
            var contentChangeRange = new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn);
            contentChanges.push({
                range: contentChangeRange,
                rangeLength: op.rangeLength,
                text: text,
                rangeOffset: op.rangeOffset,
                forceMoveMarkers: op.forceMoveMarkers
            });
        }
        return contentChanges;
    };
    PieceTreeTextBuffer.prototype.findMatchesLineByLine = function (searchRange, searchData, captureMatches, limitResultCount) {
        return this._pieceTree.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
    };
    /**
     * Assumes `operations` are validated and sorted ascending
     */
    PieceTreeTextBuffer._getInverseEditRanges = function (operations) {
        var result = [];
        var prevOpEndLineNumber;
        var prevOpEndColumn;
        var prevOp = null;
        for (var i = 0, len = operations.length; i < len; i++) {
            var op = operations[i];
            var startLineNumber = void 0;
            var startColumn = void 0;
            if (prevOp) {
                if (prevOp.range.endLineNumber === op.range.startLineNumber) {
                    startLineNumber = prevOpEndLineNumber;
                    startColumn = prevOpEndColumn + (op.range.startColumn - prevOp.range.endColumn);
                }
                else {
                    startLineNumber = prevOpEndLineNumber + (op.range.startLineNumber - prevOp.range.endLineNumber);
                    startColumn = op.range.startColumn;
                }
            }
            else {
                startLineNumber = op.range.startLineNumber;
                startColumn = op.range.startColumn;
            }
            var resultRange = void 0;
            if (op.lines && op.lines.length > 0) {
                // the operation inserts something
                var lineCount = op.lines.length;
                var firstLine = op.lines[0];
                var lastLine = op.lines[lineCount - 1];
                if (lineCount === 1) {
                    // single line insert
                    resultRange = new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](startLineNumber, startColumn, startLineNumber, startColumn + firstLine.length);
                }
                else {
                    // multi line insert
                    resultRange = new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](startLineNumber, startColumn, startLineNumber + lineCount - 1, lastLine.length + 1);
                }
            }
            else {
                // There is nothing to insert
                resultRange = new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](startLineNumber, startColumn, startLineNumber, startColumn);
            }
            prevOpEndLineNumber = resultRange.endLineNumber;
            prevOpEndColumn = resultRange.endColumn;
            result.push(resultRange);
            prevOp = op;
        }
        return result;
    };
    PieceTreeTextBuffer._sortOpsAscending = function (a, b) {
        var r = __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */].compareRangesUsingEnds(a.range, b.range);
        if (r === 0) {
            return a.sortIndex - b.sortIndex;
        }
        return r;
    };
    PieceTreeTextBuffer._sortOpsDescending = function (a, b) {
        var r = __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */].compareRangesUsingEnds(a.range, b.range);
        if (r === 0) {
            return b.sortIndex - a.sortIndex;
        }
        return -r;
    };
    return PieceTreeTextBuffer;
}());



/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TreeNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SENTINEL; });
/* harmony export (immutable) */ __webpack_exports__["d"] = leftest;
/* harmony export (immutable) */ __webpack_exports__["f"] = righttest;
/* unused harmony export calculateSize */
/* unused harmony export calculateLF */
/* unused harmony export resetSentinel */
/* unused harmony export leftRotate */
/* unused harmony export rightRotate */
/* harmony export (immutable) */ __webpack_exports__["e"] = rbDelete;
/* harmony export (immutable) */ __webpack_exports__["c"] = fixInsert;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateTreeMetadata;
/* unused harmony export recomputeTreeMetadata */
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var TreeNode = /** @class */ (function () {
    function TreeNode(piece, color) {
        this.piece = piece;
        this.color = color;
        this.size_left = 0;
        this.lf_left = 0;
        this.parent = null;
        this.left = null;
        this.right = null;
    }
    TreeNode.prototype.next = function () {
        if (this.right !== SENTINEL) {
            return leftest(this.right);
        }
        var node = this;
        while (node.parent !== SENTINEL) {
            if (node.parent.left === node) {
                break;
            }
            node = node.parent;
        }
        if (node.parent === SENTINEL) {
            return SENTINEL;
        }
        else {
            return node.parent;
        }
    };
    TreeNode.prototype.prev = function () {
        if (this.left !== SENTINEL) {
            return righttest(this.left);
        }
        var node = this;
        while (node.parent !== SENTINEL) {
            if (node.parent.right === node) {
                break;
            }
            node = node.parent;
        }
        if (node.parent === SENTINEL) {
            return SENTINEL;
        }
        else {
            return node.parent;
        }
    };
    TreeNode.prototype.detach = function () {
        this.parent = null;
        this.left = null;
        this.right = null;
    };
    return TreeNode;
}());

var SENTINEL = new TreeNode(null, 0 /* Black */);
SENTINEL.parent = SENTINEL;
SENTINEL.left = SENTINEL;
SENTINEL.right = SENTINEL;
SENTINEL.color = 0 /* Black */;
function leftest(node) {
    while (node.left !== SENTINEL) {
        node = node.left;
    }
    return node;
}
function righttest(node) {
    while (node.right !== SENTINEL) {
        node = node.right;
    }
    return node;
}
function calculateSize(node) {
    if (node === SENTINEL) {
        return 0;
    }
    return node.size_left + node.piece.length + calculateSize(node.right);
}
function calculateLF(node) {
    if (node === SENTINEL) {
        return 0;
    }
    return node.lf_left + node.piece.lineFeedCnt + calculateLF(node.right);
}
function resetSentinel() {
    SENTINEL.parent = SENTINEL;
}
function leftRotate(tree, x) {
    var y = x.right;
    // fix size_left
    y.size_left += x.size_left + (x.piece ? x.piece.length : 0);
    y.lf_left += x.lf_left + (x.piece ? x.piece.lineFeedCnt : 0);
    x.right = y.left;
    if (y.left !== SENTINEL) {
        y.left.parent = x;
    }
    y.parent = x.parent;
    if (x.parent === SENTINEL) {
        tree.root = y;
    }
    else if (x.parent.left === x) {
        x.parent.left = y;
    }
    else {
        x.parent.right = y;
    }
    y.left = x;
    x.parent = y;
}
function rightRotate(tree, y) {
    var x = y.left;
    y.left = x.right;
    if (x.right !== SENTINEL) {
        x.right.parent = y;
    }
    x.parent = y.parent;
    // fix size_left
    y.size_left -= x.size_left + (x.piece ? x.piece.length : 0);
    y.lf_left -= x.lf_left + (x.piece ? x.piece.lineFeedCnt : 0);
    if (y.parent === SENTINEL) {
        tree.root = x;
    }
    else if (y === y.parent.right) {
        y.parent.right = x;
    }
    else {
        y.parent.left = x;
    }
    x.right = y;
    y.parent = x;
}
function rbDelete(tree, z) {
    var x;
    var y;
    if (z.left === SENTINEL) {
        y = z;
        x = y.right;
    }
    else if (z.right === SENTINEL) {
        y = z;
        x = y.left;
    }
    else {
        y = leftest(z.right);
        x = y.right;
    }
    if (y === tree.root) {
        tree.root = x;
        // if x is null, we are removing the only node
        x.color = 0 /* Black */;
        z.detach();
        resetSentinel();
        tree.root.parent = SENTINEL;
        return;
    }
    var yWasRed = (y.color === 1 /* Red */);
    if (y === y.parent.left) {
        y.parent.left = x;
    }
    else {
        y.parent.right = x;
    }
    if (y === z) {
        x.parent = y.parent;
        recomputeTreeMetadata(tree, x);
    }
    else {
        if (y.parent === z) {
            x.parent = y;
        }
        else {
            x.parent = y.parent;
        }
        // as we make changes to x's hierarchy, update size_left of subtree first
        recomputeTreeMetadata(tree, x);
        y.left = z.left;
        y.right = z.right;
        y.parent = z.parent;
        y.color = z.color;
        if (z === tree.root) {
            tree.root = y;
        }
        else {
            if (z === z.parent.left) {
                z.parent.left = y;
            }
            else {
                z.parent.right = y;
            }
        }
        if (y.left !== SENTINEL) {
            y.left.parent = y;
        }
        if (y.right !== SENTINEL) {
            y.right.parent = y;
        }
        // update metadata
        // we replace z with y, so in this sub tree, the length change is z.item.length
        y.size_left = z.size_left;
        y.lf_left = z.lf_left;
        recomputeTreeMetadata(tree, y);
    }
    z.detach();
    if (x.parent.left === x) {
        var newSizeLeft = calculateSize(x);
        var newLFLeft = calculateLF(x);
        if (newSizeLeft !== x.parent.size_left || newLFLeft !== x.parent.lf_left) {
            var delta = newSizeLeft - x.parent.size_left;
            var lf_delta = newLFLeft - x.parent.lf_left;
            x.parent.size_left = newSizeLeft;
            x.parent.lf_left = newLFLeft;
            updateTreeMetadata(tree, x.parent, delta, lf_delta);
        }
    }
    recomputeTreeMetadata(tree, x.parent);
    if (yWasRed) {
        resetSentinel();
        return;
    }
    // RB-DELETE-FIXUP
    var w;
    while (x !== tree.root && x.color === 0 /* Black */) {
        if (x === x.parent.left) {
            w = x.parent.right;
            if (w.color === 1 /* Red */) {
                w.color = 0 /* Black */;
                x.parent.color = 1 /* Red */;
                leftRotate(tree, x.parent);
                w = x.parent.right;
            }
            if (w.left.color === 0 /* Black */ && w.right.color === 0 /* Black */) {
                w.color = 1 /* Red */;
                x = x.parent;
            }
            else {
                if (w.right.color === 0 /* Black */) {
                    w.left.color = 0 /* Black */;
                    w.color = 1 /* Red */;
                    rightRotate(tree, w);
                    w = x.parent.right;
                }
                w.color = x.parent.color;
                x.parent.color = 0 /* Black */;
                w.right.color = 0 /* Black */;
                leftRotate(tree, x.parent);
                x = tree.root;
            }
        }
        else {
            w = x.parent.left;
            if (w.color === 1 /* Red */) {
                w.color = 0 /* Black */;
                x.parent.color = 1 /* Red */;
                rightRotate(tree, x.parent);
                w = x.parent.left;
            }
            if (w.left.color === 0 /* Black */ && w.right.color === 0 /* Black */) {
                w.color = 1 /* Red */;
                x = x.parent;
            }
            else {
                if (w.left.color === 0 /* Black */) {
                    w.right.color = 0 /* Black */;
                    w.color = 1 /* Red */;
                    leftRotate(tree, w);
                    w = x.parent.left;
                }
                w.color = x.parent.color;
                x.parent.color = 0 /* Black */;
                w.left.color = 0 /* Black */;
                rightRotate(tree, x.parent);
                x = tree.root;
            }
        }
    }
    x.color = 0 /* Black */;
    resetSentinel();
}
function fixInsert(tree, x) {
    recomputeTreeMetadata(tree, x);
    while (x !== tree.root && x.parent.color === 1 /* Red */) {
        if (x.parent === x.parent.parent.left) {
            var y = x.parent.parent.right;
            if (y.color === 1 /* Red */) {
                x.parent.color = 0 /* Black */;
                y.color = 0 /* Black */;
                x.parent.parent.color = 1 /* Red */;
                x = x.parent.parent;
            }
            else {
                if (x === x.parent.right) {
                    x = x.parent;
                    leftRotate(tree, x);
                }
                x.parent.color = 0 /* Black */;
                x.parent.parent.color = 1 /* Red */;
                rightRotate(tree, x.parent.parent);
            }
        }
        else {
            var y = x.parent.parent.left;
            if (y.color === 1 /* Red */) {
                x.parent.color = 0 /* Black */;
                y.color = 0 /* Black */;
                x.parent.parent.color = 1 /* Red */;
                x = x.parent.parent;
            }
            else {
                if (x === x.parent.left) {
                    x = x.parent;
                    rightRotate(tree, x);
                }
                x.parent.color = 0 /* Black */;
                x.parent.parent.color = 1 /* Red */;
                leftRotate(tree, x.parent.parent);
            }
        }
    }
    tree.root.color = 0 /* Black */;
}
function updateTreeMetadata(tree, x, delta, lineFeedCntDelta) {
    // node length change or line feed count change
    while (x !== tree.root && x !== SENTINEL) {
        if (x.parent.left === x) {
            x.parent.size_left += delta;
            x.parent.lf_left += lineFeedCntDelta;
        }
        x = x.parent;
    }
}
function recomputeTreeMetadata(tree, x) {
    var delta = 0;
    var lf_delta = 0;
    if (x === tree.root) {
        return;
    }
    if (delta === 0) {
        // go upwards till the node whose left subtree is changed.
        while (x !== tree.root && x === x.parent.right) {
            x = x.parent;
        }
        if (x === tree.root) {
            // well, it means we add a node to the end (inorder)
            return;
        }
        // x is the node whose right subtree is changed.
        x = x.parent;
        delta = calculateSize(x.left) - x.size_left;
        lf_delta = calculateLF(x.left) - x.lf_left;
        x.size_left += delta;
        x.lf_left += lf_delta;
    }
    // go upwards till root. O(logN)
    while (x !== tree.root && (delta !== 0 || lf_delta !== 0)) {
        if (x.parent.left === x) {
            x.parent.size_left += delta;
            x.parent.lf_left += lf_delta;
        }
        x = x.parent;
    }
}


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoveCaretCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var MoveCaretCommand = /** @class */ (function () {
    function MoveCaretCommand(selection, isMovingLeft) {
        this._selection = selection;
        this._isMovingLeft = isMovingLeft;
    }
    MoveCaretCommand.prototype.getEditOperations = function (model, builder) {
        var s = this._selection;
        this._selectionId = builder.trackSelection(s);
        if (s.startLineNumber !== s.endLineNumber) {
            return;
        }
        if (this._isMovingLeft && s.startColumn === 0) {
            return;
        }
        else if (!this._isMovingLeft && s.endColumn === model.getLineMaxColumn(s.startLineNumber)) {
            return;
        }
        var lineNumber = s.selectionStartLineNumber;
        var lineContent = model.getLineContent(lineNumber);
        var left;
        var middle;
        var right;
        if (this._isMovingLeft) {
            left = lineContent.substring(0, s.startColumn - 2);
            middle = lineContent.substring(s.startColumn - 1, s.endColumn - 1);
            right = lineContent.substring(s.startColumn - 2, s.startColumn - 1) + lineContent.substring(s.endColumn - 1);
        }
        else {
            left = lineContent.substring(0, s.startColumn - 1) + lineContent.substring(s.endColumn - 1, s.endColumn);
            middle = lineContent.substring(s.startColumn - 1, s.endColumn - 1);
            right = lineContent.substring(s.endColumn);
        }
        var newLineContent = left + middle + right;
        builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, model.getLineMaxColumn(lineNumber)), null);
        builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, 1), newLineContent);
        this._cutStartIndex = s.startColumn + (this._isMovingLeft ? -1 : 1);
        this._cutEndIndex = this._cutStartIndex + s.endColumn - s.startColumn;
        this._moved = true;
    };
    MoveCaretCommand.prototype.computeCursorState = function (model, helper) {
        var result = helper.getTrackedSelection(this._selectionId);
        if (this._moved) {
            result = result.setStartPosition(result.startLineNumber, this._cutStartIndex);
            result = result.setEndPosition(result.startLineNumber, this._cutEndIndex);
        }
        return result;
    };
    return MoveCaretCommand;
}());



/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return QuickFixController; });
/* unused harmony export applyCodeAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QuickFixAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeActionCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RefactorAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SourceAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OrganizeImportsAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_services_bulkEditService_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__message_messageController_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_contextview_browser_contextView_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_markers_common_markers_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_progress_common_progress_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__codeActionModel_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__codeActionWidget_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lightBulbWidget_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__base_common_errors_js__ = __webpack_require__(6);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



















function contextKeyForSupportedActions(kind) {
    return __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].regex(__WEBPACK_IMPORTED_MODULE_14__codeActionModel_js__["b" /* SUPPORTED_CODE_ACTIONS */].keys()[0], new RegExp('(\\s|^)' + Object(__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["escapeRegExpCharacters"])(kind.value) + '\\b'));
}
var QuickFixController = /** @class */ (function () {
    function QuickFixController(editor, markerService, contextKeyService, progressService, contextMenuService, _commandService, _keybindingService, _bulkEditService) {
        var _this = this;
        this._commandService = _commandService;
        this._keybindingService = _keybindingService;
        this._bulkEditService = _bulkEditService;
        this._disposables = [];
        this._editor = editor;
        this._model = new __WEBPACK_IMPORTED_MODULE_14__codeActionModel_js__["a" /* CodeActionModel */](this._editor, markerService, contextKeyService, progressService);
        this._codeActionContextMenu = new __WEBPACK_IMPORTED_MODULE_16__codeActionWidget_js__["a" /* CodeActionContextMenu */](editor, contextMenuService, function (action) { return _this._onApplyCodeAction(action); });
        this._lightBulbWidget = new __WEBPACK_IMPORTED_MODULE_17__lightBulbWidget_js__["a" /* LightBulbWidget */](editor);
        this._updateLightBulbTitle();
        this._disposables.push(this._codeActionContextMenu.onDidExecuteCodeAction(function (_) { return _this._model.trigger({ type: 'auto', filter: {} }); }), this._lightBulbWidget.onClick(this._handleLightBulbSelect, this), this._model.onDidChangeFixes(function (e) { return _this._onCodeActionsEvent(e); }), this._keybindingService.onDidUpdateKeybindings(this._updateLightBulbTitle, this));
    }
    QuickFixController.get = function (editor) {
        return editor.getContribution(QuickFixController.ID);
    };
    QuickFixController.prototype.dispose = function () {
        this._model.dispose();
        Object(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
    };
    QuickFixController.prototype._onCodeActionsEvent = function (e) {
        var _this = this;
        if (this._activeRequest) {
            this._activeRequest.cancel();
            this._activeRequest = undefined;
        }
        if (e && e.actions) {
            this._activeRequest = e.actions;
        }
        if (e && e.actions && e.trigger.filter && e.trigger.filter.kind) {
            // Triggered for specific scope
            // Apply if we only have one action or requested autoApply, otherwise show menu
            e.actions.then(function (fixes) {
                if (e.trigger.autoApply === __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].First || (e.trigger.autoApply === __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].IfSingle && fixes.length === 1)) {
                    _this._onApplyCodeAction(fixes[0]);
                }
                else {
                    _this._codeActionContextMenu.show(e.actions, e.position);
                }
            }).catch(__WEBPACK_IMPORTED_MODULE_18__base_common_errors_js__["e" /* onUnexpectedError */]);
            return;
        }
        if (e && e.trigger.type === 'manual') {
            this._codeActionContextMenu.show(e.actions, e.position);
        }
        else if (e && e.actions) {
            // auto magically triggered
            // * update an existing list of code actions
            // * manage light bulb
            if (this._codeActionContextMenu.isVisible) {
                this._codeActionContextMenu.show(e.actions, e.position);
            }
            else {
                this._lightBulbWidget.model = e;
            }
        }
        else {
            this._lightBulbWidget.hide();
        }
    };
    QuickFixController.prototype.getId = function () {
        return QuickFixController.ID;
    };
    QuickFixController.prototype._handleLightBulbSelect = function (coords) {
        if (this._lightBulbWidget.model.actions) {
            this._codeActionContextMenu.show(this._lightBulbWidget.model.actions, coords);
        }
    };
    QuickFixController.prototype.triggerFromEditorSelection = function (filter, autoApply) {
        return this._model.trigger({ type: 'manual', filter: filter, autoApply: autoApply });
    };
    QuickFixController.prototype._updateLightBulbTitle = function () {
        var kb = this._keybindingService.lookupKeybinding(QuickFixAction.Id);
        var title;
        if (kb) {
            title = __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('quickFixWithKb', "Show Fixes ({0})", kb.getLabel());
        }
        else {
            title = __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('quickFix', "Show Fixes");
        }
        this._lightBulbWidget.title = title;
    };
    QuickFixController.prototype._onApplyCodeAction = function (action) {
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrap(applyCodeAction(action, this._bulkEditService, this._commandService, this._editor));
    };
    QuickFixController.ID = 'editor.contrib.quickFixController';
    QuickFixController = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_12__platform_markers_common_markers_js__["a" /* IMarkerService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_13__platform_progress_common_progress_js__["a" /* IProgressService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_10__platform_contextview_browser_contextView_js__["a" /* IContextMenuService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_8__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_11__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_4__browser_services_bulkEditService_js__["a" /* IBulkEditService */])
    ], QuickFixController);
    return QuickFixController;
}());

function applyCodeAction(action, bulkEditService, commandService, editor) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!action.edit) return [3 /*break*/, 2];
                    return [4 /*yield*/, bulkEditService.apply(action.edit, { editor: editor })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!action.command) return [3 /*break*/, 4];
                    return [4 /*yield*/, commandService.executeCommand.apply(commandService, [action.command.id].concat(action.command.arguments))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function showCodeActionsForEditorSelection(editor, notAvailableMessage, filter, autoApply) {
    var controller = QuickFixController.get(editor);
    if (!controller) {
        return;
    }
    var pos = editor.getPosition();
    controller.triggerFromEditorSelection(filter, autoApply).then(function (codeActions) {
        if (!codeActions || !codeActions.length) {
            __WEBPACK_IMPORTED_MODULE_6__message_messageController_js__["a" /* MessageController */].get(editor).showMessage(notAvailableMessage, pos);
        }
    });
}
var QuickFixAction = /** @class */ (function (_super) {
    __extends(QuickFixAction, _super);
    function QuickFixAction() {
        return _super.call(this, {
            id: QuickFixAction.Id,
            label: __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('quickfix.trigger.label', "Quick Fix..."),
            alias: 'Quick Fix',
            precondition: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCodeActionsProvider),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 84 /* US_DOT */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    QuickFixAction.prototype.run = function (_accessor, editor) {
        return showCodeActionsForEditorSelection(editor, __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('editor.action.quickFix.noneMessage', "No code actions available"));
    };
    QuickFixAction.Id = 'editor.action.quickFix';
    return QuickFixAction;
}(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["b" /* EditorAction */]));

var CodeActionCommandArgs = /** @class */ (function () {
    function CodeActionCommandArgs(kind, apply) {
        this.kind = kind;
        this.apply = apply;
    }
    CodeActionCommandArgs.fromUser = function (arg) {
        if (!arg || typeof arg !== 'object') {
            return new CodeActionCommandArgs(__WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].Empty, __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].IfSingle);
        }
        return new CodeActionCommandArgs(CodeActionCommandArgs.getKindFromUser(arg), CodeActionCommandArgs.getApplyFromUser(arg));
    };
    CodeActionCommandArgs.getApplyFromUser = function (arg) {
        switch (typeof arg.apply === 'string' ? arg.apply.toLowerCase() : '') {
            case 'first':
                return __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].First;
            case 'never':
                return __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].Never;
            case 'ifsingle':
            default:
                return __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].IfSingle;
        }
    };
    CodeActionCommandArgs.getKindFromUser = function (arg) {
        return typeof arg.kind === 'string'
            ? new __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */](arg.kind)
            : __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].Empty;
    };
    return CodeActionCommandArgs;
}());
var CodeActionCommand = /** @class */ (function (_super) {
    __extends(CodeActionCommand, _super);
    function CodeActionCommand() {
        return _super.call(this, {
            id: CodeActionCommand.Id,
            precondition: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCodeActionsProvider)
        }) || this;
    }
    CodeActionCommand.prototype.runEditorCommand = function (_accessor, editor, userArg) {
        var args = CodeActionCommandArgs.fromUser(userArg);
        return showCodeActionsForEditorSelection(editor, __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('editor.action.quickFix.noneMessage', "No code actions available"), { kind: args.kind, includeSourceActions: true }, args.apply);
    };
    CodeActionCommand.Id = 'editor.action.codeAction';
    return CodeActionCommand;
}(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["c" /* EditorCommand */]));

var RefactorAction = /** @class */ (function (_super) {
    __extends(RefactorAction, _super);
    function RefactorAction() {
        return _super.call(this, {
            id: RefactorAction.Id,
            label: __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('refactor.label', "Refactor..."),
            alias: 'Refactor',
            precondition: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCodeActionsProvider),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 2048 /* CtrlCmd */ | 1024 /* Shift */ | 48 /* KEY_R */,
                mac: {
                    primary: 256 /* WinCtrl */ | 1024 /* Shift */ | 48 /* KEY_R */
                },
                weight: 100 /* EditorContrib */
            },
            menuOpts: {
                group: '1_modification',
                order: 2,
                when: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, contextKeyForSupportedActions(__WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].Refactor)),
            }
        }) || this;
    }
    RefactorAction.prototype.run = function (_accessor, editor) {
        return showCodeActionsForEditorSelection(editor, __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('editor.action.refactor.noneMessage', "No refactorings available"), { kind: __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].Refactor }, __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].Never);
    };
    RefactorAction.Id = 'editor.action.refactor';
    return RefactorAction;
}(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["b" /* EditorAction */]));

var SourceAction = /** @class */ (function (_super) {
    __extends(SourceAction, _super);
    function SourceAction() {
        return _super.call(this, {
            id: SourceAction.Id,
            label: __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('source.label', "Source Action..."),
            alias: 'Source Action',
            precondition: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].hasCodeActionsProvider),
            menuOpts: {
                group: '1_modification',
                order: 2.1,
                when: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, contextKeyForSupportedActions(__WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].Source)),
            }
        }) || this;
    }
    SourceAction.prototype.run = function (_accessor, editor) {
        return showCodeActionsForEditorSelection(editor, __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('editor.action.source.noneMessage', "No source actions available"), { kind: __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].Source, includeSourceActions: true }, __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].Never);
    };
    SourceAction.Id = 'editor.action.sourceAction';
    return SourceAction;
}(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["b" /* EditorAction */]));

var OrganizeImportsAction = /** @class */ (function (_super) {
    __extends(OrganizeImportsAction, _super);
    function OrganizeImportsAction() {
        return _super.call(this, {
            id: OrganizeImportsAction.Id,
            label: __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('organizeImports.label', "Organize Imports"),
            alias: 'Organize Imports',
            precondition: __WEBPACK_IMPORTED_MODULE_9__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].writable, contextKeyForSupportedActions(__WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].SourceOrganizeImports)),
            kbOpts: {
                kbExpr: __WEBPACK_IMPORTED_MODULE_5__common_editorContextKeys_js__["a" /* EditorContextKeys */].editorTextFocus,
                primary: 1024 /* Shift */ | 512 /* Alt */ | 45 /* KEY_O */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    OrganizeImportsAction.prototype.run = function (_accessor, editor) {
        return showCodeActionsForEditorSelection(editor, __WEBPACK_IMPORTED_MODULE_7__nls_js__["a" /* localize */]('editor.action.organize.noneMessage', "No organize imports action available"), { kind: __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["b" /* CodeActionKind */].SourceOrganizeImports, includeSourceActions: true }, __WEBPACK_IMPORTED_MODULE_15__codeActionTrigger_js__["a" /* CodeActionAutoApply */].IfSingle);
    };
    OrganizeImportsAction.Id = 'editor.action.organizeImports';
    return OrganizeImportsAction;
}(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["b" /* EditorAction */]));



/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUPPORTED_CODE_ACTIONS; });
/* unused harmony export CodeActionOracle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeActionModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__codeAction_js__ = __webpack_require__(338);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var SUPPORTED_CODE_ACTIONS = new __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["f" /* RawContextKey */]('supportedCodeAction', '');
var CodeActionOracle = /** @class */ (function () {
    function CodeActionOracle(_editor, _markerService, _signalChange, delay, _progressService) {
        if (delay === void 0) { delay = 250; }
        var _this = this;
        this._editor = _editor;
        this._markerService = _markerService;
        this._signalChange = _signalChange;
        this._progressService = _progressService;
        this._disposables = [];
        this._disposables.push(Object(__WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["h" /* debounceEvent */])(this._markerService.onMarkerChanged, function (last, cur) { return last ? last.concat(cur) : cur; }, delay / 2)(function (e) { return _this._onMarkerChanges(e); }), Object(__WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["h" /* debounceEvent */])(this._editor.onDidChangeCursorPosition, function (last, cur) { return cur; }, delay)(function (e) { return _this._onCursorChange(); }));
    }
    CodeActionOracle.prototype.dispose = function () {
        this._disposables = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
    };
    CodeActionOracle.prototype.trigger = function (trigger) {
        var selection = this._getRangeOfSelectionUnlessWhitespaceEnclosed(trigger);
        return this._createEventAndSignalChange(trigger, selection);
    };
    CodeActionOracle.prototype._onMarkerChanges = function (resources) {
        var uri = this._editor.getModel().uri;
        for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
            var resource = resources_1[_i];
            if (resource.toString() === uri.toString()) {
                this.trigger({ type: 'auto' });
                return;
            }
        }
    };
    CodeActionOracle.prototype._onCursorChange = function () {
        this.trigger({ type: 'auto' });
    };
    CodeActionOracle.prototype._getRangeOfMarker = function (selection) {
        var model = this._editor.getModel();
        for (var _i = 0, _a = this._markerService.read({ resource: model.uri }); _i < _a.length; _i++) {
            var marker = _a[_i];
            if (__WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].intersectRanges(marker, selection)) {
                return __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].lift(marker);
            }
        }
        return undefined;
    };
    CodeActionOracle.prototype._getRangeOfSelectionUnlessWhitespaceEnclosed = function (trigger) {
        var model = this._editor.getModel();
        var selection = this._editor.getSelection();
        if (selection.isEmpty() && !(trigger.filter && trigger.filter.includeSourceActions)) {
            var _a = selection.getPosition(), lineNumber = _a.lineNumber, column = _a.column;
            var line = model.getLineContent(lineNumber);
            if (line.length === 0) {
                // empty line
                return undefined;
            }
            else if (column === 1) {
                // look only right
                if (/\s/.test(line[0])) {
                    return undefined;
                }
            }
            else if (column === model.getLineMaxColumn(lineNumber)) {
                // look only left
                if (/\s/.test(line[line.length - 1])) {
                    return undefined;
                }
            }
            else {
                // look left and right
                if (/\s/.test(line[column - 2]) && /\s/.test(line[column - 1])) {
                    return undefined;
                }
            }
        }
        return selection;
    };
    CodeActionOracle.prototype._createEventAndSignalChange = function (trigger, selection) {
        if (!selection) {
            // cancel
            this._signalChange({
                trigger: trigger,
                rangeOrSelection: undefined,
                position: undefined,
                actions: undefined,
            });
            return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].as(undefined);
        }
        else {
            var model_1 = this._editor.getModel();
            var markerRange = this._getRangeOfMarker(selection);
            var position = markerRange ? markerRange.getStartPosition() : selection.getStartPosition();
            var actions = Object(__WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return Object(__WEBPACK_IMPORTED_MODULE_7__codeAction_js__["a" /* getCodeActions */])(model_1, selection, trigger, token); });
            if (this._progressService && trigger.type === 'manual') {
                this._progressService.showWhile(__WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].wrap(actions), 250);
            }
            this._signalChange({
                trigger: trigger,
                rangeOrSelection: selection,
                position: position,
                actions: actions
            });
            return actions;
        }
    };
    return CodeActionOracle;
}());

var CodeActionModel = /** @class */ (function () {
    function CodeActionModel(editor, markerService, contextKeyService, _progressService) {
        var _this = this;
        this._progressService = _progressService;
        this._onDidChangeFixes = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this._disposables = [];
        this._editor = editor;
        this._markerService = markerService;
        this._supportedCodeActions = SUPPORTED_CODE_ACTIONS.bindTo(contextKeyService);
        this._disposables.push(this._editor.onDidChangeModel(function () { return _this._update(); }));
        this._disposables.push(this._editor.onDidChangeModelLanguage(function () { return _this._update(); }));
        this._disposables.push(__WEBPACK_IMPORTED_MODULE_5__common_modes_js__["a" /* CodeActionProviderRegistry */].onDidChange(this._update, this));
        this._update();
    }
    CodeActionModel.prototype.dispose = function () {
        this._disposables = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._codeActionOracle);
    };
    Object.defineProperty(CodeActionModel.prototype, "onDidChangeFixes", {
        get: function () {
            return this._onDidChangeFixes.event;
        },
        enumerable: true,
        configurable: true
    });
    CodeActionModel.prototype._update = function () {
        var _this = this;
        if (this._codeActionOracle) {
            this._codeActionOracle.dispose();
            this._codeActionOracle = undefined;
            this._onDidChangeFixes.fire(undefined);
        }
        if (this._editor.getModel()
            && __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["a" /* CodeActionProviderRegistry */].has(this._editor.getModel())
            && !this._editor.getConfiguration().readOnly) {
            var supportedActions = [];
            for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["a" /* CodeActionProviderRegistry */].all(this._editor.getModel()); _i < _a.length; _i++) {
                var provider = _a[_i];
                if (Array.isArray(provider.providedCodeActionKinds)) {
                    supportedActions.push.apply(supportedActions, provider.providedCodeActionKinds);
                }
            }
            this._supportedCodeActions.set(supportedActions.join(' '));
            this._codeActionOracle = new CodeActionOracle(this._editor, this._markerService, function (p) { return _this._onDidChangeFixes.fire(p); }, undefined, this._progressService);
            this._codeActionOracle.trigger({ type: 'auto' });
        }
        else {
            this._supportedCodeActions.reset();
        }
    };
    CodeActionModel.prototype.trigger = function (trigger) {
        if (this._codeActionOracle) {
            return this._codeActionOracle.trigger(trigger);
        }
        return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].as(undefined);
    };
    return CodeActionModel;
}());



/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCodeActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_cancellation_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__codeActionTrigger_js__ = __webpack_require__(128);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/










function getCodeActions(model, rangeOrSelection, trigger, token) {
    if (token === void 0) { token = __WEBPACK_IMPORTED_MODULE_2__base_common_cancellation_js__["a" /* CancellationToken */].None; }
    var codeActionContext = {
        only: trigger && trigger.filter && trigger.filter.kind ? trigger.filter.kind.value : undefined,
        trigger: trigger && trigger.type === 'manual' ? __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["b" /* CodeActionTrigger */].Manual : __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["b" /* CodeActionTrigger */].Automatic
    };
    var promises = __WEBPACK_IMPORTED_MODULE_7__common_modes_js__["a" /* CodeActionProviderRegistry */].all(model).map(function (support) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return support.provideCodeActions(model, rangeOrSelection, codeActionContext, token); }).then(function (providedCodeActions) {
            if (!Array.isArray(providedCodeActions)) {
                return [];
            }
            return providedCodeActions.filter(function (action) { return isValidAction(trigger && trigger.filter, action); });
        }, function (err) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["d" /* isPromiseCanceledError */])(err)) {
                throw err;
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["f" /* onUnexpectedExternalError */])(err);
            return [];
        });
    });
    return Promise.all(promises)
        .then(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["i" /* flatten */])
        .then(function (allCodeActions) { return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["l" /* mergeSort */])(allCodeActions, codeActionsComparator); });
}
function isValidAction(filter, action) {
    if (!action) {
        return false;
    }
    // Filter out actions by kind
    if (filter && filter.kind && (!action.kind || !filter.kind.contains(action.kind))) {
        return false;
    }
    // Don't return source actions unless they are explicitly requested
    if (action.kind && __WEBPACK_IMPORTED_MODULE_9__codeActionTrigger_js__["b" /* CodeActionKind */].Source.contains(action.kind) && (!filter || !filter.includeSourceActions)) {
        return false;
    }
    return true;
}
function codeActionsComparator(a, b) {
    var aHasDiags = !Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(a.diagnostics);
    var bHasDiags = !Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(b.diagnostics);
    if (aHasDiags) {
        if (bHasDiags) {
            return a.diagnostics[0].message.localeCompare(b.diagnostics[0].message);
        }
        else {
            return -1;
        }
    }
    else if (bHasDiags) {
        return 1;
    }
    else {
        return 0; // both have no diagnostics
    }
}
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["j" /* registerLanguageCommand */])('_executeCodeActionProvider', function (accessor, args) {
    var resource = args.resource, range = args.range;
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_4__base_common_uri_js__["a" /* default */]) || !__WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].isIRange(range)) {
        throw Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_8__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
    if (!model) {
        throw Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["b" /* illegalArgument */])();
    }
    return getCodeActions(model, model.validateRange(range), { type: 'manual', filter: { includeSourceActions: true } });
});


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeActionContextMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_actions_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/







var CodeActionContextMenu = /** @class */ (function () {
    function CodeActionContextMenu(_editor, _contextMenuService, _onApplyCodeAction) {
        this._editor = _editor;
        this._contextMenuService = _contextMenuService;
        this._onApplyCodeAction = _onApplyCodeAction;
        this._onDidExecuteCodeAction = new __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["a" /* Emitter */]();
        this.onDidExecuteCodeAction = this._onDidExecuteCodeAction.event;
    }
    CodeActionContextMenu.prototype.show = function (fixes, at) {
        var _this = this;
        var actions = fixes.then(function (value) {
            return value.map(function (action) {
                return new __WEBPACK_IMPORTED_MODULE_1__base_common_actions_js__["a" /* Action */](action.command ? action.command.id : action.title, action.title, undefined, true, function () {
                    return Object(__WEBPACK_IMPORTED_MODULE_2__base_common_async_js__["g" /* always */])(_this._onApplyCodeAction(action), function () { return _this._onDidExecuteCodeAction.fire(undefined); });
                });
            });
        }).then(function (actions) {
            if (!_this._editor.getDomNode()) {
                // cancel when editor went off-dom
                return __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__["b" /* TPromise */].wrapError(Object(__WEBPACK_IMPORTED_MODULE_3__base_common_errors_js__["a" /* canceled */])());
            }
            return actions;
        });
        this._contextMenuService.showContextMenu({
            getAnchor: function () {
                if (__WEBPACK_IMPORTED_MODULE_6__common_core_position_js__["a" /* Position */].isIPosition(at)) {
                    at = _this._toCoords(at);
                }
                return at;
            },
            getActions: function () { return __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__["b" /* TPromise */].wrap(actions); },
            onHide: function () {
                _this._visible = false;
                _this._editor.focus();
            },
            autoSelectFirstItem: true
        });
    };
    Object.defineProperty(CodeActionContextMenu.prototype, "isVisible", {
        get: function () {
            return this._visible;
        },
        enumerable: true,
        configurable: true
    });
    CodeActionContextMenu.prototype._toCoords = function (position) {
        this._editor.revealPosition(position, 1 /* Immediate */);
        this._editor.render();
        // Translate to absolute editor position
        var cursorCoords = this._editor.getScrolledVisiblePosition(this._editor.getPosition());
        var editorCoords = Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["u" /* getDomNodePagePosition */])(this._editor.getDomNode());
        var x = editorCoords.left + cursorCoords.left;
        var y = editorCoords.top + cursorCoords.top + cursorCoords.height;
        return { x: x, y: y };
    };
    return CodeActionContextMenu;
}());



/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LightBulbWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_globalMouseMoveMonitor_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_cancellation_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lightBulbWidget_css__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lightBulbWidget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lightBulbWidget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__codeActionTrigger_js__ = __webpack_require__(128);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/









var LightBulbWidget = /** @class */ (function () {
    function LightBulbWidget(editor) {
        var _this = this;
        this._disposables = [];
        this._onClick = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        this.onClick = this._onClick.event;
        this._futureFixes = new __WEBPACK_IMPORTED_MODULE_2__base_common_cancellation_js__["b" /* CancellationTokenSource */]();
        this._domNode = document.createElement('div');
        this._domNode.className = 'lightbulb-glyph';
        this._editor = editor;
        this._editor.addContentWidget(this);
        this._disposables.push(this._editor.onDidChangeModel(function (_) { return _this._futureFixes.cancel(); }));
        this._disposables.push(this._editor.onDidChangeModelLanguage(function (_) { return _this._futureFixes.cancel(); }));
        this._disposables.push(this._editor.onDidChangeModelContent(function (_) {
            // cancel when the line in question has been removed
            if (_this._model && _this.model.position.lineNumber >= _this._editor.getModel().getLineCount()) {
                _this._futureFixes.cancel();
            }
        }));
        this._disposables.push(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["j" /* addStandardDisposableListener */](this._domNode, 'click', function (e) {
            // Make sure that focus / cursor location is not lost when clicking widget icon
            _this._editor.focus();
            // a bit of extra work to make sure the menu
            // doesn't cover the line-text
            var _a = __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["u" /* getDomNodePagePosition */](_this._domNode), top = _a.top, height = _a.height;
            var lineHeight = _this._editor.getConfiguration().lineHeight;
            var pad = Math.floor(lineHeight / 3);
            if (_this._position && _this._position.position.lineNumber < _this._model.position.lineNumber) {
                pad += lineHeight;
            }
            _this._onClick.fire({
                x: e.posx,
                y: top + height + pad
            });
        }));
        this._disposables.push(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](this._domNode, 'mouseenter', function (e) {
            if ((e.buttons & 1) !== 1) {
                return;
            }
            // mouse enters lightbulb while the primary/left button
            // is being pressed -> hide the lightbulb and block future
            // showings until mouse is released
            _this.hide();
            var monitor = new __WEBPACK_IMPORTED_MODULE_1__base_browser_globalMouseMoveMonitor_js__["a" /* GlobalMouseMoveMonitor */]();
            monitor.startMonitoring(__WEBPACK_IMPORTED_MODULE_1__base_browser_globalMouseMoveMonitor_js__["b" /* standardMouseMoveMerger */], function () { }, function () {
                monitor.dispose();
            });
        }));
        this._disposables.push(this._editor.onDidChangeConfiguration(function (e) {
            // hide when told to do so
            if (e.contribInfo && !_this._editor.getConfiguration().contribInfo.lightbulbEnabled) {
                _this.hide();
            }
        }));
    }
    LightBulbWidget.prototype.dispose = function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        this._editor.removeContentWidget(this);
    };
    LightBulbWidget.prototype.getId = function () {
        return 'LightBulbWidget';
    };
    LightBulbWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    LightBulbWidget.prototype.getPosition = function () {
        return this._position;
    };
    Object.defineProperty(LightBulbWidget.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (value) {
            var _this = this;
            if (this._position && (!value.position || this._position.position.lineNumber !== value.position.lineNumber)) {
                // hide when getting a 'hide'-request or when currently
                // showing on another line
                this.hide();
            }
            else if (this._futureFixes) {
                // cancel pending show request in any case
                this._futureFixes.cancel();
            }
            this._futureFixes = new __WEBPACK_IMPORTED_MODULE_2__base_common_cancellation_js__["b" /* CancellationTokenSource */]();
            var token = this._futureFixes.token;
            this._model = value;
            var selection = this._model.rangeOrSelection;
            this._model.actions.then(function (fixes) {
                if (!token.isCancellationRequested && fixes && fixes.length > 0) {
                    if (selection.isEmpty() && fixes.every(function (fix) { return fix.kind && __WEBPACK_IMPORTED_MODULE_8__codeActionTrigger_js__["b" /* CodeActionKind */].Refactor.contains(fix.kind); })) {
                        _this.hide();
                    }
                    else {
                        _this._show();
                    }
                }
                else {
                    _this.hide();
                }
            }).catch(function (err) {
                _this.hide();
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LightBulbWidget.prototype, "title", {
        get: function () {
            return this._domNode.title;
        },
        set: function (value) {
            this._domNode.title = value;
        },
        enumerable: true,
        configurable: true
    });
    LightBulbWidget.prototype._show = function () {
        var config = this._editor.getConfiguration();
        if (!config.contribInfo.lightbulbEnabled) {
            return;
        }
        var lineNumber = this._model.position.lineNumber;
        var model = this._editor.getModel();
        if (!model) {
            return;
        }
        var tabSize = model.getOptions().tabSize;
        var lineContent = model.getLineContent(lineNumber);
        var indent = __WEBPACK_IMPORTED_MODULE_7__common_model_textModel_js__["b" /* TextModel */].computeIndentLevel(lineContent, tabSize);
        var lineHasSpace = config.fontInfo.spaceWidth * indent > 22;
        var effectiveLineNumber = lineNumber;
        if (!lineHasSpace) {
            if (lineNumber > 1) {
                effectiveLineNumber -= 1;
            }
            else {
                effectiveLineNumber += 1;
            }
        }
        this._position = {
            position: { lineNumber: effectiveLineNumber, column: 1 },
            preference: LightBulbWidget._posPref
        };
        this._editor.layoutContentWidget(this);
    };
    LightBulbWidget.prototype.hide = function () {
        this._position = null;
        this._model = null;
        this._futureFixes.cancel();
        this._editor.layoutContentWidget(this);
    };
    LightBulbWidget._posPref = [__WEBPACK_IMPORTED_MODULE_6__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].EXACT];
    return LightBulbWidget;
}());



/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CodeLensHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeLens; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__codelensWidget_css__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__codelensWidget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__codelensWidget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/











var CodeLensViewZone = /** @class */ (function () {
    function CodeLensViewZone(afterLineNumber, onHeight) {
        this.afterLineNumber = afterLineNumber;
        this._onHeight = onHeight;
        this.heightInLines = 1;
        this.suppressMouseDown = true;
        this.domNode = document.createElement('div');
    }
    CodeLensViewZone.prototype.onComputedHeight = function (height) {
        if (this._lastHeight === undefined) {
            this._lastHeight = height;
        }
        else if (this._lastHeight !== height) {
            this._lastHeight = height;
            this._onHeight();
        }
    };
    return CodeLensViewZone;
}());
var CodeLensContentWidget = /** @class */ (function () {
    function CodeLensContentWidget(editor, symbolRange, commandService, notificationService) {
        var _this = this;
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = false;
        this.suppressMouseDown = true;
        this._disposables = [];
        this._commands = Object.create(null);
        this._id = 'codeLensWidget' + (++CodeLensContentWidget._idPool);
        this._editor = editor;
        this.setSymbolRange(symbolRange);
        this._domNode = document.createElement('span');
        this._domNode.innerHTML = '&nbsp;';
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this._domNode, 'codelens-decoration');
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this._domNode, 'invisible-cl');
        this._updateHeight();
        this._disposables.push(this._editor.onDidChangeConfiguration(function (e) { return e.fontInfo && _this._updateHeight(); }));
        this._disposables.push(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](this._domNode, 'click', function (e) {
            var element = e.target;
            if (element.tagName === 'A' && element.id) {
                var command = _this._commands[element.id];
                if (command) {
                    editor.focus();
                    commandService.executeCommand.apply(commandService, [command.id].concat(command.arguments)).done(undefined, function (err) {
                        notificationService.error(err);
                    });
                }
            }
        }));
        this.updateVisibility();
    }
    CodeLensContentWidget.prototype.dispose = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
    };
    CodeLensContentWidget.prototype._updateHeight = function () {
        var _a = this._editor.getConfiguration(), fontInfo = _a.fontInfo, lineHeight = _a.lineHeight;
        this._domNode.style.height = Math.round(lineHeight * 1.1) + "px";
        this._domNode.style.lineHeight = lineHeight + "px";
        this._domNode.style.fontSize = Math.round(fontInfo.fontSize * .9) + "px";
        this._domNode.innerHTML = '&nbsp;';
    };
    CodeLensContentWidget.prototype.updateVisibility = function () {
        if (this.isVisible()) {
            __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["G" /* removeClass */](this._domNode, 'invisible-cl');
            __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this._domNode, 'fadein');
        }
    };
    CodeLensContentWidget.prototype.withCommands = function (symbols) {
        this._commands = Object.create(null);
        if (!symbols || !symbols.length) {
            this._domNode.innerHTML = 'no commands';
            return;
        }
        var html = [];
        for (var i = 0; i < symbols.length; i++) {
            var command = symbols[i].command;
            var title = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["escape"])(command.title);
            var part = void 0;
            if (command.id) {
                part = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["format"])('<a id={0}>{1}</a>', i, title);
                this._commands[i] = command;
            }
            else {
                part = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["format"])('<span>{0}</span>', title);
            }
            html.push(part);
        }
        this._domNode.innerHTML = html.join('<span>&nbsp;|&nbsp;</span>');
        this._editor.layoutContentWidget(this);
    };
    CodeLensContentWidget.prototype.getId = function () {
        return this._id;
    };
    CodeLensContentWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    CodeLensContentWidget.prototype.setSymbolRange = function (range) {
        var lineNumber = range.startLineNumber;
        var column = this._editor.getModel().getLineFirstNonWhitespaceColumn(lineNumber);
        this._widgetPosition = {
            position: { lineNumber: lineNumber, column: column },
            preference: [__WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE]
        };
    };
    CodeLensContentWidget.prototype.getPosition = function () {
        return this._widgetPosition;
    };
    CodeLensContentWidget.prototype.isVisible = function () {
        return this._domNode.hasAttribute('monaco-visible-content-widget');
    };
    CodeLensContentWidget._idPool = 0;
    return CodeLensContentWidget;
}());
var CodeLensHelper = /** @class */ (function () {
    function CodeLensHelper() {
        this._removeDecorations = [];
        this._addDecorations = [];
        this._addDecorationsCallbacks = [];
    }
    CodeLensHelper.prototype.addDecoration = function (decoration, callback) {
        this._addDecorations.push(decoration);
        this._addDecorationsCallbacks.push(callback);
    };
    CodeLensHelper.prototype.removeDecoration = function (decorationId) {
        this._removeDecorations.push(decorationId);
    };
    CodeLensHelper.prototype.commit = function (changeAccessor) {
        var resultingDecorations = changeAccessor.deltaDecorations(this._removeDecorations, this._addDecorations);
        for (var i = 0, len = resultingDecorations.length; i < len; i++) {
            this._addDecorationsCallbacks[i](resultingDecorations[i]);
        }
    };
    return CodeLensHelper;
}());

var CodeLens = /** @class */ (function () {
    function CodeLens(data, editor, helper, viewZoneChangeAccessor, commandService, notificationService, updateCallabck) {
        var _this = this;
        this._editor = editor;
        this._data = data;
        this._decorationIds = new Array(this._data.length);
        var range;
        this._data.forEach(function (codeLensData, i) {
            helper.addDecoration({
                range: codeLensData.symbol.range,
                options: __WEBPACK_IMPORTED_MODULE_6__common_model_textModel_js__["a" /* ModelDecorationOptions */].EMPTY
            }, function (id) { return _this._decorationIds[i] = id; });
            // the range contains all lenses on this line
            if (!range) {
                range = __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].lift(codeLensData.symbol.range);
            }
            else {
                range = __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].plusRange(range, codeLensData.symbol.range);
            }
        });
        this._contentWidget = new CodeLensContentWidget(editor, range, commandService, notificationService);
        this._viewZone = new CodeLensViewZone(range.startLineNumber - 1, updateCallabck);
        this._viewZoneId = viewZoneChangeAccessor.addZone(this._viewZone);
        this._editor.addContentWidget(this._contentWidget);
    }
    CodeLens.prototype.dispose = function (helper, viewZoneChangeAccessor) {
        while (this._decorationIds.length) {
            helper.removeDecoration(this._decorationIds.pop());
        }
        if (viewZoneChangeAccessor) {
            viewZoneChangeAccessor.removeZone(this._viewZoneId);
        }
        this._editor.removeContentWidget(this._contentWidget);
        this._contentWidget.dispose();
    };
    CodeLens.prototype.isValid = function () {
        var _this = this;
        return this._decorationIds.some(function (id, i) {
            var range = _this._editor.getModel().getDecorationRange(id);
            var symbol = _this._data[i].symbol;
            return range && __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].isEmpty(symbol.range) === range.isEmpty();
        });
    };
    CodeLens.prototype.updateCodeLensSymbols = function (data, helper) {
        var _this = this;
        while (this._decorationIds.length) {
            helper.removeDecoration(this._decorationIds.pop());
        }
        this._data = data;
        this._decorationIds = new Array(this._data.length);
        this._data.forEach(function (codeLensData, i) {
            helper.addDecoration({
                range: codeLensData.symbol.range,
                options: __WEBPACK_IMPORTED_MODULE_6__common_model_textModel_js__["a" /* ModelDecorationOptions */].EMPTY
            }, function (id) { return _this._decorationIds[i] = id; });
        });
    };
    CodeLens.prototype.computeIfNecessary = function (model) {
        this._contentWidget.updateVisibility(); // trigger the fade in
        if (!this._contentWidget.isVisible()) {
            return null;
        }
        // Read editor current state
        for (var i = 0; i < this._decorationIds.length; i++) {
            this._data[i].symbol.range = model.getDecorationRange(this._decorationIds[i]);
        }
        return this._data;
    };
    CodeLens.prototype.updateCommands = function (symbols) {
        this._contentWidget.withCommands(symbols);
    };
    CodeLens.prototype.getLineNumber = function () {
        var range = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
        if (range) {
            return range.startLineNumber;
        }
        return -1;
    };
    CodeLens.prototype.update = function (viewZoneChangeAccessor) {
        if (this.isValid()) {
            var range = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
            this._viewZone.afterLineNumber = range.startLineNumber - 1;
            viewZoneChangeAccessor.layoutZone(this._viewZoneId);
            this._contentWidget.setSymbolRange(range);
            this._editor.layoutContentWidget(this._contentWidget);
        }
    };
    return CodeLens;
}());

Object(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var codeLensForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__common_view_editorColorRegistry_js__["e" /* editorCodeLensForeground */]);
    if (codeLensForeground) {
        collector.addRule(".monaco-editor .codelens-decoration { color: " + codeLensForeground + "; }");
    }
    var activeLinkForeground = theme.getColor(__WEBPACK_IMPORTED_MODULE_9__platform_theme_common_colorRegistry_js__["m" /* editorActiveLinkForeground */]);
    if (activeLinkForeground) {
        collector.addRule(".monaco-editor .codelens-decoration > a:hover { color: " + activeLinkForeground + " !important; }");
    }
});


/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCodeLensData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








function getCodeLensData(model, token) {
    var symbols = [];
    var provider = __WEBPACK_IMPORTED_MODULE_4__common_modes_js__["c" /* CodeLensProviderRegistry */].ordered(model);
    var promises = provider.map(function (provider) { return Promise.resolve(provider.provideCodeLenses(model, token)).then(function (result) {
        if (Array.isArray(result)) {
            for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
                var symbol = result_1[_i];
                symbols.push({ symbol: symbol, provider: provider });
            }
        }
    }).catch(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["f" /* onUnexpectedExternalError */]); });
    return Promise.all(promises).then(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["l" /* mergeSort */])(symbols, function (a, b) {
            // sort by lineNumber, provider-rank, and column
            if (a.symbol.range.startLineNumber < b.symbol.range.startLineNumber) {
                return -1;
            }
            else if (a.symbol.range.startLineNumber > b.symbol.range.startLineNumber) {
                return 1;
            }
            else if (provider.indexOf(a.provider) < provider.indexOf(b.provider)) {
                return -1;
            }
            else if (provider.indexOf(a.provider) > provider.indexOf(b.provider)) {
                return 1;
            }
            else if (a.symbol.range.startColumn < b.symbol.range.startColumn) {
                return -1;
            }
            else if (a.symbol.range.startColumn > b.symbol.range.startColumn) {
                return 1;
            }
            else {
                return 0;
            }
        });
    });
}
Object(__WEBPACK_IMPORTED_MODULE_3__browser_editorExtensions_js__["j" /* registerLanguageCommand */])('_executeCodeLensProvider', function (accessor, args) {
    var resource = args.resource, itemResolveCount = args.itemResolveCount;
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_2__base_common_uri_js__["a" /* default */])) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_5__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
    if (!model) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var result = [];
    return getCodeLensData(model, __WEBPACK_IMPORTED_MODULE_6__base_common_cancellation_js__["a" /* CancellationToken */].None).then(function (value) {
        var resolve = [];
        for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
            var item = value_1[_i];
            if (typeof itemResolveCount === 'undefined' || Boolean(item.symbol.command)) {
                result.push(item.symbol);
            }
            else if (itemResolveCount-- > 0) {
                resolve.push(Promise.resolve(item.provider.resolveCodeLens(model, item.symbol, __WEBPACK_IMPORTED_MODULE_6__base_common_cancellation_js__["a" /* CancellationToken */].None)).then(function (symbol) { return result.push(symbol); }));
            }
        }
        return Promise.all(resolve);
    }).then(function () {
        return result;
    });
});


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hash;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Return a hash value for an object.
 */
function hash(obj, hashVal) {
    if (hashVal === void 0) { hashVal = 0; }
    switch (typeof obj) {
        case 'object':
            if (obj === null) {
                return numberHash(349, hashVal);
            }
            else if (Array.isArray(obj)) {
                return arrayHash(obj, hashVal);
            }
            return objectHash(obj, hashVal);
        case 'string':
            return stringHash(obj, hashVal);
        case 'boolean':
            return booleanHash(obj, hashVal);
        case 'number':
            return numberHash(obj, hashVal);
        case 'undefined':
            return numberHash(obj, 937);
        default:
            return numberHash(obj, 617);
    }
}
function numberHash(val, initialHashVal) {
    return (((initialHashVal << 5) - initialHashVal) + val) | 0; // hashVal * 31 + ch, keep as int32
}
function booleanHash(b, initialHashVal) {
    return numberHash(b ? 433 : 863, initialHashVal);
}
function stringHash(s, hashVal) {
    hashVal = numberHash(149417, hashVal);
    for (var i = 0, length_1 = s.length; i < length_1; i++) {
        hashVal = numberHash(s.charCodeAt(i), hashVal);
    }
    return hashVal;
}
function arrayHash(arr, initialHashVal) {
    initialHashVal = numberHash(104579, initialHashVal);
    return arr.reduce(function (hashVal, item) { return hash(item, hashVal); }, initialHashVal);
}
function objectHash(obj, initialHashVal) {
    initialHashVal = numberHash(181387, initialHashVal);
    return Object.keys(obj).sort().reduce(function (hashVal, key) {
        hashVal = stringHash(key, hashVal);
        return hash(obj[key], hashVal);
    }, initialHashVal);
}


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineCommentCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blockCommentCommand_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var LineCommentCommand = /** @class */ (function () {
    function LineCommentCommand(selection, tabSize, type) {
        this._selection = selection;
        this._tabSize = tabSize;
        this._type = type;
        this._deltaColumn = 0;
    }
    /**
     * Do an initial pass over the lines and gather info about the line comment string.
     * Returns null if any of the lines doesn't support a line comment string.
     */
    LineCommentCommand._gatherPreflightCommentStrings = function (model, startLineNumber, endLineNumber) {
        model.tokenizeIfCheap(startLineNumber);
        var languageId = model.getLanguageIdAtPosition(startLineNumber, 1);
        var config = __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getComments(languageId);
        var commentStr = (config ? config.lineCommentToken : null);
        if (!commentStr) {
            // Mode does not support line comments
            return null;
        }
        var lines = [];
        for (var i = 0, lineCount = endLineNumber - startLineNumber + 1; i < lineCount; i++) {
            lines[i] = {
                ignore: false,
                commentStr: commentStr,
                commentStrOffset: 0,
                commentStrLength: commentStr.length
            };
        }
        return lines;
    };
    /**
     * Analyze lines and decide which lines are relevant and what the toggle should do.
     * Also, build up several offsets and lengths useful in the generation of editor operations.
     */
    LineCommentCommand._analyzeLines = function (type, model, lines, startLineNumber) {
        var onlyWhitespaceLines = true;
        var shouldRemoveComments;
        if (type === 0 /* Toggle */) {
            shouldRemoveComments = true;
        }
        else if (type === 1 /* ForceAdd */) {
            shouldRemoveComments = false;
        }
        else {
            shouldRemoveComments = true;
        }
        for (var i = 0, lineCount = lines.length; i < lineCount; i++) {
            var lineData = lines[i];
            var lineNumber = startLineNumber + i;
            var lineContent = model.getLineContent(lineNumber);
            var lineContentStartOffset = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["firstNonWhitespaceIndex"](lineContent);
            if (lineContentStartOffset === -1) {
                // Empty or whitespace only line
                if (type === 0 /* Toggle */) {
                    lineData.ignore = true;
                }
                else if (type === 1 /* ForceAdd */) {
                    lineData.ignore = true;
                }
                else {
                    lineData.ignore = true;
                }
                lineData.commentStrOffset = lineContent.length;
                continue;
            }
            onlyWhitespaceLines = false;
            lineData.ignore = false;
            lineData.commentStrOffset = lineContentStartOffset;
            if (shouldRemoveComments && !__WEBPACK_IMPORTED_MODULE_5__blockCommentCommand_js__["a" /* BlockCommentCommand */]._haystackHasNeedleAtOffset(lineContent, lineData.commentStr, lineContentStartOffset)) {
                if (type === 0 /* Toggle */) {
                    // Every line so far has been a line comment, but this one is not
                    shouldRemoveComments = false;
                }
                else if (type === 1 /* ForceAdd */) {
                    // Will not happen
                }
                else {
                    lineData.ignore = true;
                }
            }
            if (shouldRemoveComments) {
                var commentStrEndOffset = lineContentStartOffset + lineData.commentStrLength;
                if (commentStrEndOffset < lineContent.length && lineContent.charCodeAt(commentStrEndOffset) === 32 /* Space */) {
                    lineData.commentStrLength += 1;
                }
            }
        }
        if (type === 0 /* Toggle */ && onlyWhitespaceLines) {
            // For only whitespace lines, we insert comments
            shouldRemoveComments = false;
            // Also, no longer ignore them
            for (var i = 0, lineCount = lines.length; i < lineCount; i++) {
                lines[i].ignore = false;
            }
        }
        return {
            supported: true,
            shouldRemoveComments: shouldRemoveComments,
            lines: lines
        };
    };
    /**
     * Analyze all lines and decide exactly what to do => not supported | insert line comments | remove line comments
     */
    LineCommentCommand._gatherPreflightData = function (type, model, startLineNumber, endLineNumber) {
        var lines = LineCommentCommand._gatherPreflightCommentStrings(model, startLineNumber, endLineNumber);
        if (lines === null) {
            return {
                supported: false,
                shouldRemoveComments: false,
                lines: null
            };
        }
        return LineCommentCommand._analyzeLines(type, model, lines, startLineNumber);
    };
    /**
     * Given a successful analysis, execute either insert line comments, either remove line comments
     */
    LineCommentCommand.prototype._executeLineComments = function (model, builder, data, s) {
        var ops;
        if (data.shouldRemoveComments) {
            ops = LineCommentCommand._createRemoveLineCommentsOperations(data.lines, s.startLineNumber);
        }
        else {
            LineCommentCommand._normalizeInsertionPoint(model, data.lines, s.startLineNumber, this._tabSize);
            ops = LineCommentCommand._createAddLineCommentsOperations(data.lines, s.startLineNumber);
        }
        var cursorPosition = new __WEBPACK_IMPORTED_MODULE_2__common_core_position_js__["a" /* Position */](s.positionLineNumber, s.positionColumn);
        for (var i = 0, len = ops.length; i < len; i++) {
            builder.addEditOperation(ops[i].range, ops[i].text);
            if (ops[i].range.isEmpty() && ops[i].range.getStartPosition().equals(cursorPosition)) {
                var lineContent = model.getLineContent(cursorPosition.lineNumber);
                if (lineContent.length + 1 === cursorPosition.column) {
                    this._deltaColumn = ops[i].text.length;
                }
            }
        }
        this._selectionId = builder.trackSelection(s);
    };
    LineCommentCommand.prototype._attemptRemoveBlockComment = function (model, s, startToken, endToken) {
        var startLineNumber = s.startLineNumber;
        var endLineNumber = s.endLineNumber;
        var startTokenAllowedBeforeColumn = endToken.length + Math.max(model.getLineFirstNonWhitespaceColumn(s.startLineNumber), s.startColumn);
        var startTokenIndex = model.getLineContent(startLineNumber).lastIndexOf(startToken, startTokenAllowedBeforeColumn - 1);
        var endTokenIndex = model.getLineContent(endLineNumber).indexOf(endToken, s.endColumn - 1 - startToken.length);
        if (startTokenIndex !== -1 && endTokenIndex === -1) {
            endTokenIndex = model.getLineContent(startLineNumber).indexOf(endToken, startTokenIndex + startToken.length);
            endLineNumber = startLineNumber;
        }
        if (startTokenIndex === -1 && endTokenIndex !== -1) {
            startTokenIndex = model.getLineContent(endLineNumber).lastIndexOf(startToken, endTokenIndex);
            startLineNumber = endLineNumber;
        }
        if (s.isEmpty() && (startTokenIndex === -1 || endTokenIndex === -1)) {
            startTokenIndex = model.getLineContent(startLineNumber).indexOf(startToken);
            if (startTokenIndex !== -1) {
                endTokenIndex = model.getLineContent(startLineNumber).indexOf(endToken, startTokenIndex + startToken.length);
            }
        }
        // We have to adjust to possible inner white space.
        // For Space after startToken, add Space to startToken - range math will work out.
        if (startTokenIndex !== -1 && model.getLineContent(startLineNumber).charCodeAt(startTokenIndex + startToken.length) === 32 /* Space */) {
            startToken += ' ';
        }
        // For Space before endToken, add Space before endToken and shift index one left.
        if (endTokenIndex !== -1 && model.getLineContent(endLineNumber).charCodeAt(endTokenIndex - 1) === 32 /* Space */) {
            endToken = ' ' + endToken;
            endTokenIndex -= 1;
        }
        if (startTokenIndex !== -1 && endTokenIndex !== -1) {
            return __WEBPACK_IMPORTED_MODULE_5__blockCommentCommand_js__["a" /* BlockCommentCommand */]._createRemoveBlockCommentOperations(new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](startLineNumber, startTokenIndex + startToken.length + 1, endLineNumber, endTokenIndex + 1), startToken, endToken);
        }
        return null;
    };
    /**
     * Given an unsuccessful analysis, delegate to the block comment command
     */
    LineCommentCommand.prototype._executeBlockComment = function (model, builder, s) {
        model.tokenizeIfCheap(s.startLineNumber);
        var languageId = model.getLanguageIdAtPosition(s.startLineNumber, 1);
        var config = __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getComments(languageId);
        if (!config || !config.blockCommentStartToken || !config.blockCommentEndToken) {
            // Mode does not support block comments
            return;
        }
        var startToken = config.blockCommentStartToken;
        var endToken = config.blockCommentEndToken;
        var ops = this._attemptRemoveBlockComment(model, s, startToken, endToken);
        if (!ops) {
            if (s.isEmpty()) {
                var lineContent = model.getLineContent(s.startLineNumber);
                var firstNonWhitespaceIndex = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["firstNonWhitespaceIndex"](lineContent);
                if (firstNonWhitespaceIndex === -1) {
                    // Line is empty or contains only whitespace
                    firstNonWhitespaceIndex = lineContent.length;
                }
                ops = __WEBPACK_IMPORTED_MODULE_5__blockCommentCommand_js__["a" /* BlockCommentCommand */]._createAddBlockCommentOperations(new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](s.startLineNumber, firstNonWhitespaceIndex + 1, s.startLineNumber, lineContent.length + 1), startToken, endToken);
            }
            else {
                ops = __WEBPACK_IMPORTED_MODULE_5__blockCommentCommand_js__["a" /* BlockCommentCommand */]._createAddBlockCommentOperations(new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](s.startLineNumber, model.getLineFirstNonWhitespaceColumn(s.startLineNumber), s.endLineNumber, model.getLineMaxColumn(s.endLineNumber)), startToken, endToken);
            }
            if (ops.length === 1) {
                // Leave cursor after token and Space
                this._deltaColumn = startToken.length + 1;
            }
        }
        this._selectionId = builder.trackSelection(s);
        for (var i = 0; i < ops.length; i++) {
            builder.addEditOperation(ops[i].range, ops[i].text);
        }
    };
    LineCommentCommand.prototype.getEditOperations = function (model, builder) {
        var s = this._selection;
        this._moveEndPositionDown = false;
        if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
            this._moveEndPositionDown = true;
            s = s.setEndPosition(s.endLineNumber - 1, model.getLineMaxColumn(s.endLineNumber - 1));
        }
        var data = LineCommentCommand._gatherPreflightData(this._type, model, s.startLineNumber, s.endLineNumber);
        if (data.supported) {
            return this._executeLineComments(model, builder, data, s);
        }
        return this._executeBlockComment(model, builder, s);
    };
    LineCommentCommand.prototype.computeCursorState = function (model, helper) {
        var result = helper.getTrackedSelection(this._selectionId);
        if (this._moveEndPositionDown) {
            result = result.setEndPosition(result.endLineNumber + 1, 1);
        }
        return new __WEBPACK_IMPORTED_MODULE_4__common_core_selection_js__["a" /* Selection */](result.selectionStartLineNumber, result.selectionStartColumn + this._deltaColumn, result.positionLineNumber, result.positionColumn + this._deltaColumn);
    };
    /**
     * Generate edit operations in the remove line comment case
     */
    LineCommentCommand._createRemoveLineCommentsOperations = function (lines, startLineNumber) {
        var res = [];
        for (var i = 0, len = lines.length; i < len; i++) {
            var lineData = lines[i];
            if (lineData.ignore) {
                continue;
            }
            res.push(__WEBPACK_IMPORTED_MODULE_1__common_core_editOperation_js__["a" /* EditOperation */].delete(new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](startLineNumber + i, lineData.commentStrOffset + 1, startLineNumber + i, lineData.commentStrOffset + lineData.commentStrLength + 1)));
        }
        return res;
    };
    /**
     * Generate edit operations in the add line comment case
     */
    LineCommentCommand._createAddLineCommentsOperations = function (lines, startLineNumber) {
        var res = [];
        for (var i = 0, len = lines.length; i < len; i++) {
            var lineData = lines[i];
            if (lineData.ignore) {
                continue;
            }
            res.push(__WEBPACK_IMPORTED_MODULE_1__common_core_editOperation_js__["a" /* EditOperation */].insert(new __WEBPACK_IMPORTED_MODULE_2__common_core_position_js__["a" /* Position */](startLineNumber + i, lineData.commentStrOffset + 1), lineData.commentStr + ' '));
        }
        return res;
    };
    // TODO@Alex -> duplicated in characterHardWrappingLineMapper
    LineCommentCommand.nextVisibleColumn = function (currentVisibleColumn, tabSize, isTab, columnSize) {
        if (isTab) {
            return currentVisibleColumn + (tabSize - (currentVisibleColumn % tabSize));
        }
        return currentVisibleColumn + columnSize;
    };
    /**
     * Adjust insertion points to have them vertically aligned in the add line comment case
     */
    LineCommentCommand._normalizeInsertionPoint = function (model, lines, startLineNumber, tabSize) {
        var minVisibleColumn = Number.MAX_VALUE;
        var j;
        var lenJ;
        for (var i = 0, len = lines.length; i < len; i++) {
            if (lines[i].ignore) {
                continue;
            }
            var lineContent = model.getLineContent(startLineNumber + i);
            var currentVisibleColumn = 0;
            for (var j_1 = 0, lenJ_1 = lines[i].commentStrOffset; currentVisibleColumn < minVisibleColumn && j_1 < lenJ_1; j_1++) {
                currentVisibleColumn = LineCommentCommand.nextVisibleColumn(currentVisibleColumn, tabSize, lineContent.charCodeAt(j_1) === 9 /* Tab */, 1);
            }
            if (currentVisibleColumn < minVisibleColumn) {
                minVisibleColumn = currentVisibleColumn;
            }
        }
        minVisibleColumn = Math.floor(minVisibleColumn / tabSize) * tabSize;
        for (var i = 0, len = lines.length; i < len; i++) {
            if (lines[i].ignore) {
                continue;
            }
            var lineContent = model.getLineContent(startLineNumber + i);
            var currentVisibleColumn = 0;
            for (j = 0, lenJ = lines[i].commentStrOffset; currentVisibleColumn < minVisibleColumn && j < lenJ; j++) {
                currentVisibleColumn = LineCommentCommand.nextVisibleColumn(currentVisibleColumn, tabSize, lineContent.charCodeAt(j) === 9 /* Tab */, 1);
            }
            if (currentVisibleColumn > minVisibleColumn) {
                lines[i].commentStrOffset = j - 1;
            }
            else {
                lines[i].commentStrOffset = j;
            }
        }
    };
    return LineCommentCommand;
}());



/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__ = __webpack_require__(39);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var ColumnSelection = /** @class */ (function () {
    function ColumnSelection() {
    }
    ColumnSelection._columnSelect = function (config, model, fromLineNumber, fromVisibleColumn, toLineNumber, toVisibleColumn) {
        var lineCount = Math.abs(toLineNumber - fromLineNumber) + 1;
        var reversed = (fromLineNumber > toLineNumber);
        var isRTL = (fromVisibleColumn > toVisibleColumn);
        var isLTR = (fromVisibleColumn < toVisibleColumn);
        var result = [];
        // console.log(`fromVisibleColumn: ${fromVisibleColumn}, toVisibleColumn: ${toVisibleColumn}`);
        for (var i = 0; i < lineCount; i++) {
            var lineNumber = fromLineNumber + (reversed ? -i : i);
            var startColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].columnFromVisibleColumn2(config, model, lineNumber, fromVisibleColumn);
            var endColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].columnFromVisibleColumn2(config, model, lineNumber, toVisibleColumn);
            var visibleStartColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(config, model, new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineNumber, startColumn));
            var visibleEndColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(config, model, new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineNumber, endColumn));
            // console.log(`lineNumber: ${lineNumber}: visibleStartColumn: ${visibleStartColumn}, visibleEndColumn: ${visibleEndColumn}`);
            if (isLTR) {
                if (visibleStartColumn > toVisibleColumn) {
                    continue;
                }
                if (visibleEndColumn < fromVisibleColumn) {
                    continue;
                }
            }
            if (isRTL) {
                if (visibleEndColumn > fromVisibleColumn) {
                    continue;
                }
                if (visibleStartColumn < toVisibleColumn) {
                    continue;
                }
            }
            result.push(new __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_1__core_range_js__["a" /* Range */](lineNumber, startColumn, lineNumber, startColumn), 0, new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineNumber, endColumn), 0));
        }
        return {
            viewStates: result,
            reversed: reversed,
            toLineNumber: toLineNumber,
            toVisualColumn: toVisibleColumn
        };
    };
    ColumnSelection.columnSelect = function (config, model, fromViewSelection, toViewLineNumber, toViewVisualColumn) {
        var fromViewPosition = new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](fromViewSelection.selectionStartLineNumber, fromViewSelection.selectionStartColumn);
        var fromViewVisibleColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(config, model, fromViewPosition);
        return ColumnSelection._columnSelect(config, model, fromViewPosition.lineNumber, fromViewVisibleColumn, toViewLineNumber, toViewVisualColumn);
    };
    ColumnSelection.columnSelectLeft = function (config, model, cursor, toViewLineNumber, toViewVisualColumn) {
        if (toViewVisualColumn > 1) {
            toViewVisualColumn--;
        }
        return this.columnSelect(config, model, cursor.selection, toViewLineNumber, toViewVisualColumn);
    };
    ColumnSelection.columnSelectRight = function (config, model, cursor, toViewLineNumber, toViewVisualColumn) {
        var maxVisualViewColumn = 0;
        var minViewLineNumber = Math.min(cursor.position.lineNumber, toViewLineNumber);
        var maxViewLineNumber = Math.max(cursor.position.lineNumber, toViewLineNumber);
        for (var lineNumber = minViewLineNumber; lineNumber <= maxViewLineNumber; lineNumber++) {
            var lineMaxViewColumn = model.getLineMaxColumn(lineNumber);
            var lineMaxVisualViewColumn = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(config, model, new __WEBPACK_IMPORTED_MODULE_0__core_position_js__["a" /* Position */](lineNumber, lineMaxViewColumn));
            maxVisualViewColumn = Math.max(maxVisualViewColumn, lineMaxVisualViewColumn);
        }
        if (toViewVisualColumn < maxVisualViewColumn) {
            toViewVisualColumn++;
        }
        return this.columnSelect(config, model, cursor.selection, toViewLineNumber, toViewVisualColumn);
    };
    ColumnSelection.columnSelectUp = function (config, model, cursor, isPaged, toViewLineNumber, toViewVisualColumn) {
        var linesCount = isPaged ? config.pageSize : 1;
        toViewLineNumber -= linesCount;
        if (toViewLineNumber < 1) {
            toViewLineNumber = 1;
        }
        return this.columnSelect(config, model, cursor.selection, toViewLineNumber, toViewVisualColumn);
    };
    ColumnSelection.columnSelectDown = function (config, model, cursor, isPaged, toViewLineNumber, toViewVisualColumn) {
        var linesCount = isPaged ? config.pageSize : 1;
        toViewLineNumber += linesCount;
        if (toViewLineNumber > model.getLineCount()) {
            toViewLineNumber = model.getLineCount();
        }
        return this.columnSelect(config, model, cursor.selection, toViewLineNumber, toViewVisualColumn);
    };
    return ColumnSelection;
}());



/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurroundSelectionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_selection_js__ = __webpack_require__(18);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var SurroundSelectionCommand = /** @class */ (function () {
    function SurroundSelectionCommand(range, charBeforeSelection, charAfterSelection) {
        this._range = range;
        this._charBeforeSelection = charBeforeSelection;
        this._charAfterSelection = charAfterSelection;
    }
    SurroundSelectionCommand.prototype.getEditOperations = function (model, builder) {
        builder.addTrackedEditOperation(new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](this._range.startLineNumber, this._range.startColumn, this._range.startLineNumber, this._range.startColumn), this._charBeforeSelection);
        builder.addTrackedEditOperation(new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](this._range.endLineNumber, this._range.endColumn, this._range.endLineNumber, this._range.endColumn), this._charAfterSelection);
    };
    SurroundSelectionCommand.prototype.computeCursorState = function (model, helper) {
        var inverseEditOperations = helper.getInverseEditOperations();
        var firstOperationRange = inverseEditOperations[0].range;
        var secondOperationRange = inverseEditOperations[1].range;
        return new __WEBPACK_IMPORTED_MODULE_1__core_selection_js__["a" /* Selection */](firstOperationRange.endLineNumber, firstOperationRange.endColumn, secondOperationRange.endLineNumber, secondOperationRange.endColumn - this._charAfterSelection.length);
    };
    return SurroundSelectionCommand;
}());



/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragAndDropCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var DragAndDropCommand = /** @class */ (function () {
    function DragAndDropCommand(selection, targetPosition, copy) {
        this.selection = selection;
        this.targetPosition = targetPosition;
        this.copy = copy;
    }
    DragAndDropCommand.prototype.getEditOperations = function (model, builder) {
        var text = model.getValueInRange(this.selection);
        if (!this.copy) {
            builder.addEditOperation(this.selection, null);
        }
        builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column), text);
        if (this.selection.containsPosition(this.targetPosition) && !(this.copy && (this.selection.getEndPosition().equals(this.targetPosition) || this.selection.getStartPosition().equals(this.targetPosition)) // we allow users to paste content beside the selection
        )) {
            this.targetSelection = this.selection;
            return;
        }
        if (this.copy) {
            this.targetSelection = new __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__["a" /* Selection */](this.targetPosition.lineNumber, this.targetPosition.column, this.selection.endLineNumber - this.selection.startLineNumber + this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ?
                this.targetPosition.column + this.selection.endColumn - this.selection.startColumn :
                this.selection.endColumn);
            return;
        }
        if (this.targetPosition.lineNumber > this.selection.endLineNumber) {
            // Drag the selection downwards
            this.targetSelection = new __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__["a" /* Selection */](this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ?
                this.targetPosition.column + this.selection.endColumn - this.selection.startColumn :
                this.selection.endColumn);
            return;
        }
        if (this.targetPosition.lineNumber < this.selection.endLineNumber) {
            // Drag the selection upwards
            this.targetSelection = new __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__["a" /* Selection */](this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber + this.selection.endLineNumber - this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ?
                this.targetPosition.column + this.selection.endColumn - this.selection.startColumn :
                this.selection.endColumn);
            return;
        }
        // The target position is at the same line as the selection's end position.
        if (this.selection.endColumn <= this.targetPosition.column) {
            // The target position is after the selection's end position
            this.targetSelection = new __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__["a" /* Selection */](this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ?
                this.targetPosition.column - this.selection.endColumn + this.selection.startColumn :
                this.targetPosition.column - this.selection.endColumn + this.selection.startColumn, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ?
                this.targetPosition.column :
                this.selection.endColumn);
        }
        else {
            // The target position is before the selection's end postion. Since the selection doesn't contain the target position, the selection is one-line and target position is before this selection.
            this.targetSelection = new __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__["a" /* Selection */](this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column + this.selection.endColumn - this.selection.startColumn);
        }
    };
    DragAndDropCommand.prototype.computeCursorState = function (model, helper) {
        return this.targetSelection;
    };
    return DragAndDropCommand;
}());



/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplacePattern; });
/* unused harmony export ReplacePiece */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseReplaceString;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var ReplacePattern = /** @class */ (function () {
    function ReplacePattern(pieces) {
        if (!pieces || pieces.length === 0) {
            this._staticValue = '';
            this._pieces = null;
        }
        else if (pieces.length === 1 && pieces[0].staticValue !== null) {
            this._staticValue = pieces[0].staticValue;
            this._pieces = null;
        }
        else {
            this._staticValue = null;
            this._pieces = pieces;
        }
    }
    ReplacePattern.fromStaticValue = function (value) {
        return new ReplacePattern([ReplacePiece.staticValue(value)]);
    };
    Object.defineProperty(ReplacePattern.prototype, "hasReplacementPatterns", {
        get: function () {
            return this._staticValue === null;
        },
        enumerable: true,
        configurable: true
    });
    ReplacePattern.prototype.buildReplaceString = function (matches) {
        if (this._staticValue !== null) {
            return this._staticValue;
        }
        var result = '';
        for (var i = 0, len = this._pieces.length; i < len; i++) {
            var piece = this._pieces[i];
            if (piece.staticValue !== null) {
                // static value ReplacePiece
                result += piece.staticValue;
                continue;
            }
            // match index ReplacePiece
            result += ReplacePattern._substitute(piece.matchIndex, matches);
        }
        return result;
    };
    ReplacePattern._substitute = function (matchIndex, matches) {
        if (matchIndex === 0) {
            return matches[0];
        }
        var remainder = '';
        while (matchIndex > 0) {
            if (matchIndex < matches.length) {
                // A match can be undefined
                var match = (matches[matchIndex] || '');
                return match + remainder;
            }
            remainder = String(matchIndex % 10) + remainder;
            matchIndex = Math.floor(matchIndex / 10);
        }
        return '$' + remainder;
    };
    return ReplacePattern;
}());

/**
 * A replace piece can either be a static string or an index to a specific match.
 */
var ReplacePiece = /** @class */ (function () {
    function ReplacePiece(staticValue, matchIndex) {
        this.staticValue = staticValue;
        this.matchIndex = matchIndex;
    }
    ReplacePiece.staticValue = function (value) {
        return new ReplacePiece(value, -1);
    };
    ReplacePiece.matchIndex = function (index) {
        return new ReplacePiece(null, index);
    };
    return ReplacePiece;
}());

var ReplacePieceBuilder = /** @class */ (function () {
    function ReplacePieceBuilder(source) {
        this._source = source;
        this._lastCharIndex = 0;
        this._result = [];
        this._resultLen = 0;
        this._currentStaticPiece = '';
    }
    ReplacePieceBuilder.prototype.emitUnchanged = function (toCharIndex) {
        this._emitStatic(this._source.substring(this._lastCharIndex, toCharIndex));
        this._lastCharIndex = toCharIndex;
    };
    ReplacePieceBuilder.prototype.emitStatic = function (value, toCharIndex) {
        this._emitStatic(value);
        this._lastCharIndex = toCharIndex;
    };
    ReplacePieceBuilder.prototype._emitStatic = function (value) {
        if (value.length === 0) {
            return;
        }
        this._currentStaticPiece += value;
    };
    ReplacePieceBuilder.prototype.emitMatchIndex = function (index, toCharIndex) {
        if (this._currentStaticPiece.length !== 0) {
            this._result[this._resultLen++] = ReplacePiece.staticValue(this._currentStaticPiece);
            this._currentStaticPiece = '';
        }
        this._result[this._resultLen++] = ReplacePiece.matchIndex(index);
        this._lastCharIndex = toCharIndex;
    };
    ReplacePieceBuilder.prototype.finalize = function () {
        this.emitUnchanged(this._source.length);
        if (this._currentStaticPiece.length !== 0) {
            this._result[this._resultLen++] = ReplacePiece.staticValue(this._currentStaticPiece);
            this._currentStaticPiece = '';
        }
        return new ReplacePattern(this._result);
    };
    return ReplacePieceBuilder;
}());
/**
 * \n			=> inserts a LF
 * \t			=> inserts a TAB
 * \\			=> inserts a "\".
 * $$			=> inserts a "$".
 * $& and $0	=> inserts the matched substring.
 * $n			=> Where n is a non-negative integer lesser than 100, inserts the nth parenthesized submatch string
 * everything else stays untouched
 *
 * Also see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#Specifying_a_string_as_a_parameter
 */
function parseReplaceString(replaceString) {
    if (!replaceString || replaceString.length === 0) {
        return new ReplacePattern(null);
    }
    var result = new ReplacePieceBuilder(replaceString);
    for (var i = 0, len = replaceString.length; i < len; i++) {
        var chCode = replaceString.charCodeAt(i);
        if (chCode === 92 /* Backslash */) {
            // move to next char
            i++;
            if (i >= len) {
                // string ends with a \
                break;
            }
            var nextChCode = replaceString.charCodeAt(i);
            // let replaceWithCharacter: string = null;
            switch (nextChCode) {
                case 92 /* Backslash */:
                    // \\ => inserts a "\"
                    result.emitUnchanged(i - 1);
                    result.emitStatic('\\', i + 1);
                    break;
                case 110 /* n */:
                    // \n => inserts a LF
                    result.emitUnchanged(i - 1);
                    result.emitStatic('\n', i + 1);
                    break;
                case 116 /* t */:
                    // \t => inserts a TAB
                    result.emitUnchanged(i - 1);
                    result.emitStatic('\t', i + 1);
                    break;
            }
            continue;
        }
        if (chCode === 36 /* DollarSign */) {
            // move to next char
            i++;
            if (i >= len) {
                // string ends with a $
                break;
            }
            var nextChCode = replaceString.charCodeAt(i);
            if (nextChCode === 36 /* DollarSign */) {
                // $$ => inserts a "$"
                result.emitUnchanged(i - 1);
                result.emitStatic('$', i + 1);
                continue;
            }
            if (nextChCode === 48 /* Digit0 */ || nextChCode === 38 /* Ampersand */) {
                // $& and $0 => inserts the matched substring.
                result.emitUnchanged(i - 1);
                result.emitMatchIndex(0, i + 1);
                continue;
            }
            if (49 /* Digit1 */ <= nextChCode && nextChCode <= 57 /* Digit9 */) {
                // $n
                var matchIndex = nextChCode - 48 /* Digit0 */;
                // peek next char to probe for $nn
                if (i + 1 < len) {
                    var nextNextChCode = replaceString.charCodeAt(i + 1);
                    if (48 /* Digit0 */ <= nextNextChCode && nextNextChCode <= 57 /* Digit9 */) {
                        // $nn
                        // move to next char
                        i++;
                        matchIndex = matchIndex * 10 + (nextNextChCode - 48 /* Digit0 */);
                        result.emitUnchanged(i - 2);
                        result.emitMatchIndex(matchIndex, i + 1);
                        continue;
                    }
                }
                result.emitUnchanged(i - 1);
                result.emitMatchIndex(matchIndex, i + 1);
                continue;
            }
        }
    }
    return result.finalize();
}


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindDecorations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var FindDecorations = /** @class */ (function () {
    function FindDecorations(editor) {
        this._editor = editor;
        this._decorations = [];
        this._overviewRulerApproximateDecorations = [];
        this._findScopeDecorationId = null;
        this._rangeHighlightDecorationId = null;
        this._highlightedDecorationId = null;
        this._startPosition = this._editor.getPosition();
    }
    FindDecorations.prototype.dispose = function () {
        this._editor.deltaDecorations(this._allDecorations(), []);
        this._editor = null;
        this._decorations = [];
        this._overviewRulerApproximateDecorations = [];
        this._findScopeDecorationId = null;
        this._rangeHighlightDecorationId = null;
        this._highlightedDecorationId = null;
        this._startPosition = null;
    };
    FindDecorations.prototype.reset = function () {
        this._decorations = [];
        this._overviewRulerApproximateDecorations = [];
        this._findScopeDecorationId = null;
        this._rangeHighlightDecorationId = null;
        this._highlightedDecorationId = null;
    };
    FindDecorations.prototype.getCount = function () {
        return this._decorations.length;
    };
    FindDecorations.prototype.getFindScope = function () {
        if (this._findScopeDecorationId) {
            return this._editor.getModel().getDecorationRange(this._findScopeDecorationId);
        }
        return null;
    };
    FindDecorations.prototype.getStartPosition = function () {
        return this._startPosition;
    };
    FindDecorations.prototype.setStartPosition = function (newStartPosition) {
        this._startPosition = newStartPosition;
        this.setCurrentFindMatch(null);
    };
    FindDecorations.prototype._getDecorationIndex = function (decorationId) {
        var index = this._decorations.indexOf(decorationId);
        if (index >= 0) {
            return index + 1;
        }
        return 1;
    };
    FindDecorations.prototype.getCurrentMatchesPosition = function (desiredRange) {
        var candidates = this._editor.getModel().getDecorationsInRange(desiredRange);
        for (var i = 0, len = candidates.length; i < len; i++) {
            var candidate = candidates[i];
            var candidateOpts = candidate.options;
            if (candidateOpts === FindDecorations._FIND_MATCH_DECORATION || candidateOpts === FindDecorations._CURRENT_FIND_MATCH_DECORATION) {
                return this._getDecorationIndex(candidate.id);
            }
        }
        return 1;
    };
    FindDecorations.prototype.setCurrentFindMatch = function (nextMatch) {
        var _this = this;
        var newCurrentDecorationId = null;
        var matchPosition = 0;
        if (nextMatch) {
            for (var i = 0, len = this._decorations.length; i < len; i++) {
                var range = this._editor.getModel().getDecorationRange(this._decorations[i]);
                if (nextMatch.equalsRange(range)) {
                    newCurrentDecorationId = this._decorations[i];
                    matchPosition = (i + 1);
                    break;
                }
            }
        }
        if (this._highlightedDecorationId !== null || newCurrentDecorationId !== null) {
            this._editor.changeDecorations(function (changeAccessor) {
                if (_this._highlightedDecorationId !== null) {
                    changeAccessor.changeDecorationOptions(_this._highlightedDecorationId, FindDecorations._FIND_MATCH_DECORATION);
                    _this._highlightedDecorationId = null;
                }
                if (newCurrentDecorationId !== null) {
                    _this._highlightedDecorationId = newCurrentDecorationId;
                    changeAccessor.changeDecorationOptions(_this._highlightedDecorationId, FindDecorations._CURRENT_FIND_MATCH_DECORATION);
                }
                if (_this._rangeHighlightDecorationId !== null) {
                    changeAccessor.removeDecoration(_this._rangeHighlightDecorationId);
                    _this._rangeHighlightDecorationId = null;
                }
                if (newCurrentDecorationId !== null) {
                    var rng = _this._editor.getModel().getDecorationRange(newCurrentDecorationId);
                    if (rng.startLineNumber !== rng.endLineNumber && rng.endColumn === 1) {
                        var lineBeforeEnd = rng.endLineNumber - 1;
                        var lineBeforeEndMaxColumn = _this._editor.getModel().getLineMaxColumn(lineBeforeEnd);
                        rng = new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](rng.startLineNumber, rng.startColumn, lineBeforeEnd, lineBeforeEndMaxColumn);
                    }
                    _this._rangeHighlightDecorationId = changeAccessor.addDecoration(rng, FindDecorations._RANGE_HIGHLIGHT_DECORATION);
                }
            });
        }
        return matchPosition;
    };
    FindDecorations.prototype.set = function (findMatches, findScope) {
        var _this = this;
        this._editor.changeDecorations(function (accessor) {
            var findMatchesOptions = FindDecorations._FIND_MATCH_DECORATION;
            var newOverviewRulerApproximateDecorations = [];
            if (findMatches.length > 1000) {
                // we go into a mode where the overview ruler gets "approximate" decorations
                // the reason is that the overview ruler paints all the decorations in the file and we don't want to cause freezes
                findMatchesOptions = FindDecorations._FIND_MATCH_NO_OVERVIEW_DECORATION;
                // approximate a distance in lines where matches should be merged
                var lineCount = _this._editor.getModel().getLineCount();
                var height = _this._editor.getLayoutInfo().height;
                var approxPixelsPerLine = height / lineCount;
                var mergeLinesDelta = Math.max(2, Math.ceil(3 / approxPixelsPerLine));
                // merge decorations as much as possible
                var prevStartLineNumber = findMatches[0].range.startLineNumber;
                var prevEndLineNumber = findMatches[0].range.endLineNumber;
                for (var i = 1, len = findMatches.length; i < len; i++) {
                    var range = findMatches[i].range;
                    if (prevEndLineNumber + mergeLinesDelta >= range.startLineNumber) {
                        if (range.endLineNumber > prevEndLineNumber) {
                            prevEndLineNumber = range.endLineNumber;
                        }
                    }
                    else {
                        newOverviewRulerApproximateDecorations.push({
                            range: new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](prevStartLineNumber, 1, prevEndLineNumber, 1),
                            options: FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION
                        });
                        prevStartLineNumber = range.startLineNumber;
                        prevEndLineNumber = range.endLineNumber;
                    }
                }
                newOverviewRulerApproximateDecorations.push({
                    range: new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](prevStartLineNumber, 1, prevEndLineNumber, 1),
                    options: FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION
                });
            }
            // Find matches
            var newFindMatchesDecorations = new Array(findMatches.length);
            for (var i = 0, len = findMatches.length; i < len; i++) {
                newFindMatchesDecorations[i] = {
                    range: findMatches[i].range,
                    options: findMatchesOptions
                };
            }
            _this._decorations = accessor.deltaDecorations(_this._decorations, newFindMatchesDecorations);
            // Overview ruler approximate decorations
            _this._overviewRulerApproximateDecorations = accessor.deltaDecorations(_this._overviewRulerApproximateDecorations, newOverviewRulerApproximateDecorations);
            // Range highlight
            if (_this._rangeHighlightDecorationId) {
                accessor.removeDecoration(_this._rangeHighlightDecorationId);
                _this._rangeHighlightDecorationId = null;
            }
            // Find scope
            if (_this._findScopeDecorationId) {
                accessor.removeDecoration(_this._findScopeDecorationId);
                _this._findScopeDecorationId = null;
            }
            if (findScope) {
                _this._findScopeDecorationId = accessor.addDecoration(findScope, FindDecorations._FIND_SCOPE_DECORATION);
            }
        });
    };
    FindDecorations.prototype.matchBeforePosition = function (position) {
        if (this._decorations.length === 0) {
            return null;
        }
        for (var i = this._decorations.length - 1; i >= 0; i--) {
            var decorationId = this._decorations[i];
            var r = this._editor.getModel().getDecorationRange(decorationId);
            if (!r || r.endLineNumber > position.lineNumber) {
                continue;
            }
            if (r.endLineNumber < position.lineNumber) {
                return r;
            }
            if (r.endColumn > position.column) {
                continue;
            }
            return r;
        }
        return this._editor.getModel().getDecorationRange(this._decorations[this._decorations.length - 1]);
    };
    FindDecorations.prototype.matchAfterPosition = function (position) {
        if (this._decorations.length === 0) {
            return null;
        }
        for (var i = 0, len = this._decorations.length; i < len; i++) {
            var decorationId = this._decorations[i];
            var r = this._editor.getModel().getDecorationRange(decorationId);
            if (!r || r.startLineNumber < position.lineNumber) {
                continue;
            }
            if (r.startLineNumber > position.lineNumber) {
                return r;
            }
            if (r.startColumn < position.column) {
                continue;
            }
            return r;
        }
        return this._editor.getModel().getDecorationRange(this._decorations[0]);
    };
    FindDecorations.prototype._allDecorations = function () {
        var result = [];
        result = result.concat(this._decorations);
        result = result.concat(this._overviewRulerApproximateDecorations);
        if (this._findScopeDecorationId) {
            result.push(this._findScopeDecorationId);
        }
        if (this._rangeHighlightDecorationId) {
            result.push(this._rangeHighlightDecorationId);
        }
        return result;
    };
    FindDecorations._CURRENT_FIND_MATCH_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        zIndex: 13,
        className: 'currentFindMatch',
        showIfCollapsed: true,
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["_5" /* overviewRulerFindMatchForeground */]),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["_5" /* overviewRulerFindMatchForeground */]),
            position: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    FindDecorations._FIND_MATCH_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'findMatch',
        showIfCollapsed: true,
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["_5" /* overviewRulerFindMatchForeground */]),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["_5" /* overviewRulerFindMatchForeground */]),
            position: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    FindDecorations._FIND_MATCH_NO_OVERVIEW_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'findMatch',
        showIfCollapsed: true
    });
    FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        overviewRuler: {
            color: Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["_5" /* overviewRulerFindMatchForeground */]),
            darkColor: Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["_5" /* overviewRulerFindMatchForeground */]),
            position: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["f" /* OverviewRulerLane */].Center
        }
    });
    FindDecorations._RANGE_HIGHLIGHT_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_4__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        className: 'rangeHighlight',
        isWholeLine: true
    });
    FindDecorations._FIND_SCOPE_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'findScope',
        isWholeLine: true
    });
    return FindDecorations;
}());



/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplaceAllCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ReplaceAllCommand = /** @class */ (function () {
    function ReplaceAllCommand(editorSelection, ranges, replaceStrings) {
        this._editorSelection = editorSelection;
        this._ranges = ranges;
        this._replaceStrings = replaceStrings;
    }
    ReplaceAllCommand.prototype.getEditOperations = function (model, builder) {
        if (this._ranges.length > 0) {
            // Collect all edit operations
            var ops = [];
            for (var i = 0; i < this._ranges.length; i++) {
                ops.push({
                    range: this._ranges[i],
                    text: this._replaceStrings[i]
                });
            }
            // Sort them in ascending order by range starts
            ops.sort(function (o1, o2) {
                return __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(o1.range, o2.range);
            });
            // Merge operations that touch each other
            var resultOps = [];
            var previousOp = ops[0];
            for (var i = 1; i < ops.length; i++) {
                if (previousOp.range.endLineNumber === ops[i].range.startLineNumber && previousOp.range.endColumn === ops[i].range.startColumn) {
                    // These operations are one after another and can be merged
                    previousOp.range = previousOp.range.plusRange(ops[i].range);
                    previousOp.text = previousOp.text + ops[i].text;
                }
                else {
                    resultOps.push(previousOp);
                    previousOp = ops[i];
                }
            }
            resultOps.push(previousOp);
            for (var i = 0; i < resultOps.length; i++) {
                builder.addEditOperation(resultOps[i].range, resultOps[i].text);
            }
        }
        this._trackedEditorSelectionId = builder.trackSelection(this._editorSelection);
    };
    ReplaceAllCommand.prototype.computeCursorState = function (model, helper) {
        return helper.getTrackedSelection(this._trackedEditorSelectionId);
    };
    return ReplaceAllCommand;
}());



/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindReplaceState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



function effectiveOptionValue(override, value) {
    if (override === 1 /* True */) {
        return true;
    }
    if (override === 2 /* False */) {
        return false;
    }
    return value;
}
var FindReplaceState = /** @class */ (function () {
    function FindReplaceState() {
        this._searchString = '';
        this._replaceString = '';
        this._isRevealed = false;
        this._isReplaceRevealed = false;
        this._isRegex = false;
        this._isRegexOverride = 0 /* NotSet */;
        this._wholeWord = false;
        this._wholeWordOverride = 0 /* NotSet */;
        this._matchCase = false;
        this._matchCaseOverride = 0 /* NotSet */;
        this._searchScope = null;
        this._matchesPosition = 0;
        this._matchesCount = 0;
        this._currentMatch = null;
        this._onFindReplaceStateChange = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
    }
    Object.defineProperty(FindReplaceState.prototype, "searchString", {
        get: function () { return this._searchString; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "replaceString", {
        get: function () { return this._replaceString; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "isRevealed", {
        get: function () { return this._isRevealed; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "isReplaceRevealed", {
        get: function () { return this._isReplaceRevealed; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "isRegex", {
        get: function () { return effectiveOptionValue(this._isRegexOverride, this._isRegex); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "wholeWord", {
        get: function () { return effectiveOptionValue(this._wholeWordOverride, this._wholeWord); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "matchCase", {
        get: function () { return effectiveOptionValue(this._matchCaseOverride, this._matchCase); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "actualIsRegex", {
        get: function () { return this._isRegex; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "actualWholeWord", {
        get: function () { return this._wholeWord; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "actualMatchCase", {
        get: function () { return this._matchCase; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "searchScope", {
        get: function () { return this._searchScope; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "matchesPosition", {
        get: function () { return this._matchesPosition; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "matchesCount", {
        get: function () { return this._matchesCount; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "currentMatch", {
        get: function () { return this._currentMatch; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FindReplaceState.prototype, "onFindReplaceStateChange", {
        get: function () { return this._onFindReplaceStateChange.event; },
        enumerable: true,
        configurable: true
    });
    FindReplaceState.prototype.dispose = function () {
    };
    FindReplaceState.prototype.changeMatchInfo = function (matchesPosition, matchesCount, currentMatch) {
        var changeEvent = {
            moveCursor: false,
            updateHistory: false,
            searchString: false,
            replaceString: false,
            isRevealed: false,
            isReplaceRevealed: false,
            isRegex: false,
            wholeWord: false,
            matchCase: false,
            searchScope: false,
            matchesPosition: false,
            matchesCount: false,
            currentMatch: false
        };
        var somethingChanged = false;
        if (matchesCount === 0) {
            matchesPosition = 0;
        }
        if (matchesPosition > matchesCount) {
            matchesPosition = matchesCount;
        }
        if (this._matchesPosition !== matchesPosition) {
            this._matchesPosition = matchesPosition;
            changeEvent.matchesPosition = true;
            somethingChanged = true;
        }
        if (this._matchesCount !== matchesCount) {
            this._matchesCount = matchesCount;
            changeEvent.matchesCount = true;
            somethingChanged = true;
        }
        if (typeof currentMatch !== 'undefined') {
            if (!__WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */].equalsRange(this._currentMatch, currentMatch)) {
                this._currentMatch = currentMatch;
                changeEvent.currentMatch = true;
                somethingChanged = true;
            }
        }
        if (somethingChanged) {
            this._onFindReplaceStateChange.fire(changeEvent);
        }
    };
    FindReplaceState.prototype.change = function (newState, moveCursor, updateHistory) {
        if (updateHistory === void 0) { updateHistory = true; }
        var changeEvent = {
            moveCursor: moveCursor,
            updateHistory: updateHistory,
            searchString: false,
            replaceString: false,
            isRevealed: false,
            isReplaceRevealed: false,
            isRegex: false,
            wholeWord: false,
            matchCase: false,
            searchScope: false,
            matchesPosition: false,
            matchesCount: false,
            currentMatch: false
        };
        var somethingChanged = false;
        var oldEffectiveIsRegex = this.isRegex;
        var oldEffectiveWholeWords = this.wholeWord;
        var oldEffectiveMatchCase = this.matchCase;
        if (typeof newState.searchString !== 'undefined') {
            if (this._searchString !== newState.searchString) {
                this._searchString = newState.searchString;
                changeEvent.searchString = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.replaceString !== 'undefined') {
            if (this._replaceString !== newState.replaceString) {
                this._replaceString = newState.replaceString;
                changeEvent.replaceString = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.isRevealed !== 'undefined') {
            if (this._isRevealed !== newState.isRevealed) {
                this._isRevealed = newState.isRevealed;
                changeEvent.isRevealed = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.isReplaceRevealed !== 'undefined') {
            if (this._isReplaceRevealed !== newState.isReplaceRevealed) {
                this._isReplaceRevealed = newState.isReplaceRevealed;
                changeEvent.isReplaceRevealed = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.isRegex !== 'undefined') {
            this._isRegex = newState.isRegex;
        }
        if (typeof newState.wholeWord !== 'undefined') {
            this._wholeWord = newState.wholeWord;
        }
        if (typeof newState.matchCase !== 'undefined') {
            this._matchCase = newState.matchCase;
        }
        if (typeof newState.searchScope !== 'undefined') {
            if (!__WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */].equalsRange(this._searchScope, newState.searchScope)) {
                this._searchScope = newState.searchScope;
                changeEvent.searchScope = true;
                somethingChanged = true;
            }
        }
        // Overrides get set when they explicitly come in and get reset anytime something else changes
        this._isRegexOverride = (typeof newState.isRegexOverride !== 'undefined' ? newState.isRegexOverride : 0 /* NotSet */);
        this._wholeWordOverride = (typeof newState.wholeWordOverride !== 'undefined' ? newState.wholeWordOverride : 0 /* NotSet */);
        this._matchCaseOverride = (typeof newState.matchCaseOverride !== 'undefined' ? newState.matchCaseOverride : 0 /* NotSet */);
        if (oldEffectiveIsRegex !== this.isRegex) {
            somethingChanged = true;
            changeEvent.isRegex = true;
        }
        if (oldEffectiveWholeWords !== this.wholeWord) {
            somethingChanged = true;
            changeEvent.wholeWord = true;
        }
        if (oldEffectiveMatchCase !== this.matchCase) {
            somethingChanged = true;
            changeEvent.matchCase = true;
        }
        if (somethingChanged) {
            this._onFindReplaceStateChange.fire(changeEvent);
        }
    };
    return FindReplaceState;
}());



/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FindWidgetViewZone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindWidget; });
/* unused harmony export SimpleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findWidget_css__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findWidget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__findWidget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_browser_ui_widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_browser_ui_sash_sash_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__findModel_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_widget_browser_contextScopedHistoryWidget_js__ = __webpack_require__(360);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var NLS_FIND_INPUT_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.find', "Find");
var NLS_FIND_INPUT_PLACEHOLDER = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('placeholder.find', "Find");
var NLS_PREVIOUS_MATCH_BTN_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.previousMatchButton', "Previous match");
var NLS_NEXT_MATCH_BTN_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.nextMatchButton', "Next match");
var NLS_TOGGLE_SELECTION_FIND_TITLE = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.toggleSelectionFind', "Find in selection");
var NLS_CLOSE_BTN_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.closeButton', "Close");
var NLS_REPLACE_INPUT_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.replace', "Replace");
var NLS_REPLACE_INPUT_PLACEHOLDER = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('placeholder.replace', "Replace");
var NLS_REPLACE_BTN_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.replaceButton', "Replace");
var NLS_REPLACE_ALL_BTN_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.replaceAllButton', "Replace All");
var NLS_TOGGLE_REPLACE_MODE_BTN_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.toggleReplaceButton', "Toggle Replace mode");
var NLS_MATCHES_COUNT_LIMIT_TITLE = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('title.matchesCountLimit', "Only the first {0} results are highlighted, but all find operations work on the entire text.", __WEBPACK_IMPORTED_MODULE_10__findModel_js__["f" /* MATCHES_LIMIT */]);
var NLS_MATCHES_LOCATION = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.matchesLocation', "{0} of {1}");
var NLS_NO_RESULTS = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.noResults', "No Results");
var FIND_WIDGET_INITIAL_WIDTH = 411;
var PART_WIDTH = 275;
var FIND_INPUT_AREA_WIDTH = PART_WIDTH - 54;
var REPLACE_INPUT_AREA_WIDTH = FIND_INPUT_AREA_WIDTH;
var MAX_MATCHES_COUNT_WIDTH = 69;
var FIND_ALL_CONTROLS_WIDTH = 17 /** Find Input margin-left */ + (MAX_MATCHES_COUNT_WIDTH + 3 + 1) /** Match Results */ + 23 /** Button */ * 4 + 2 /** sash */;
var FIND_INPUT_AREA_HEIGHT = 34; // The height of Find Widget when Replace Input is not visible.
var FIND_REPLACE_AREA_HEIGHT = 64; // The height of Find Widget when Replace Input is  visible.
var FindWidgetViewZone = /** @class */ (function () {
    function FindWidgetViewZone(afterLineNumber) {
        this.afterLineNumber = afterLineNumber;
        this.heightInPx = FIND_INPUT_AREA_HEIGHT;
        this.suppressMouseDown = false;
        this.domNode = document.createElement('div');
        this.domNode.className = 'dock-find-viewzone';
    }
    return FindWidgetViewZone;
}());

var FindWidget = /** @class */ (function (_super) {
    __extends(FindWidget, _super);
    function FindWidget(codeEditor, controller, state, contextViewProvider, keybindingService, contextKeyService, themeService) {
        var _this = _super.call(this) || this;
        _this._codeEditor = codeEditor;
        _this._controller = controller;
        _this._state = state;
        _this._contextViewProvider = contextViewProvider;
        _this._keybindingService = keybindingService;
        _this._contextKeyService = contextKeyService;
        _this._isVisible = false;
        _this._isReplaceVisible = false;
        _this._updateHistoryDelayer = new __WEBPACK_IMPORTED_MODULE_5__base_common_async_js__["a" /* Delayer */](500);
        _this._register(_this._state.onFindReplaceStateChange(function (e) { return _this._onStateChanged(e); }));
        _this._buildDomNode();
        _this._updateButtons();
        _this._tryUpdateWidgetWidth();
        _this._register(_this._codeEditor.onDidChangeConfiguration(function (e) {
            if (e.readOnly) {
                if (_this._codeEditor.getConfiguration().readOnly) {
                    // Hide replace part if editor becomes read only
                    _this._state.change({ isReplaceRevealed: false }, false);
                }
                _this._updateButtons();
            }
            if (e.layoutInfo) {
                _this._tryUpdateWidgetWidth();
            }
        }));
        _this._register(_this._codeEditor.onDidChangeCursorSelection(function () {
            if (_this._isVisible) {
                _this._updateToggleSelectionFindButton();
            }
        }));
        _this._register(_this._codeEditor.onDidFocusEditorWidget(function () {
            if (_this._isVisible) {
                var globalBufferTerm = _this._controller.getGlobalBufferTerm();
                if (globalBufferTerm && globalBufferTerm !== _this._state.searchString) {
                    _this._state.change({ searchString: globalBufferTerm }, true);
                    _this._findInput.select();
                }
            }
        }));
        _this._findInputFocused = __WEBPACK_IMPORTED_MODULE_10__findModel_js__["a" /* CONTEXT_FIND_INPUT_FOCUSED */].bindTo(contextKeyService);
        _this._findFocusTracker = _this._register(__WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["O" /* trackFocus */](_this._findInput.inputBox.inputElement));
        _this._register(_this._findFocusTracker.onDidFocus(function () {
            _this._findInputFocused.set(true);
            _this._updateSearchScope();
        }));
        _this._register(_this._findFocusTracker.onDidBlur(function () {
            _this._findInputFocused.set(false);
        }));
        _this._replaceInputFocused = __WEBPACK_IMPORTED_MODULE_10__findModel_js__["c" /* CONTEXT_REPLACE_INPUT_FOCUSED */].bindTo(contextKeyService);
        _this._replaceFocusTracker = _this._register(__WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["O" /* trackFocus */](_this._replaceInputBox.inputElement));
        _this._register(_this._replaceFocusTracker.onDidFocus(function () {
            _this._replaceInputFocused.set(true);
            _this._updateSearchScope();
        }));
        _this._register(_this._replaceFocusTracker.onDidBlur(function () {
            _this._replaceInputFocused.set(false);
        }));
        _this._codeEditor.addOverlayWidget(_this);
        _this._viewZone = new FindWidgetViewZone(0); // Put it before the first line then users can scroll beyond the first line.
        _this._applyTheme(themeService.getTheme());
        _this._register(themeService.onThemeChange(_this._applyTheme.bind(_this)));
        _this._register(_this._codeEditor.onDidChangeModel(function (e) {
            if (!_this._isVisible) {
                return;
            }
            if (_this._viewZoneId === undefined) {
                return;
            }
            _this._codeEditor.changeViewZones(function (accessor) {
                accessor.removeZone(_this._viewZoneId);
                _this._viewZoneId = undefined;
            });
        }));
        _this._register(_this._codeEditor.onDidScrollChange(function (e) {
            if (e.scrollTopChanged) {
                _this._layoutViewZone();
                return;
            }
            // for other scroll changes, layout the viewzone in next tick to avoid ruining current rendering.
            setTimeout(function () {
                _this._layoutViewZone();
            }, 0);
        }));
        return _this;
    }
    // ----- IOverlayWidget API
    FindWidget.prototype.getId = function () {
        return FindWidget.ID;
    };
    FindWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    FindWidget.prototype.getPosition = function () {
        if (this._isVisible) {
            return {
                preference: __WEBPACK_IMPORTED_MODULE_9__browser_editorBrowser_js__["c" /* OverlayWidgetPositionPreference */].TOP_RIGHT_CORNER
            };
        }
        return null;
    };
    // ----- React to state changes
    FindWidget.prototype._onStateChanged = function (e) {
        if (e.searchString) {
            this._findInput.setValue(this._state.searchString);
            this._updateButtons();
        }
        if (e.replaceString) {
            this._replaceInputBox.value = this._state.replaceString;
        }
        if (e.isRevealed) {
            if (this._state.isRevealed) {
                this._reveal(true);
            }
            else {
                this._hide(true);
            }
        }
        if (e.isReplaceRevealed) {
            if (this._state.isReplaceRevealed) {
                if (!this._codeEditor.getConfiguration().readOnly && !this._isReplaceVisible) {
                    this._isReplaceVisible = true;
                    this._replaceInputBox.width = this._findInput.inputBox.width;
                    this._updateButtons();
                }
            }
            else {
                if (this._isReplaceVisible) {
                    this._isReplaceVisible = false;
                    this._updateButtons();
                }
            }
        }
        if (e.isRegex) {
            this._findInput.setRegex(this._state.isRegex);
        }
        if (e.wholeWord) {
            this._findInput.setWholeWords(this._state.wholeWord);
        }
        if (e.matchCase) {
            this._findInput.setCaseSensitive(this._state.matchCase);
        }
        if (e.searchScope) {
            if (this._state.searchScope) {
                this._toggleSelectionFind.checked = true;
            }
            else {
                this._toggleSelectionFind.checked = false;
            }
            this._updateToggleSelectionFindButton();
        }
        if (e.searchString || e.matchesCount || e.matchesPosition) {
            var showRedOutline = (this._state.searchString.length > 0 && this._state.matchesCount === 0);
            __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["N" /* toggleClass */](this._domNode, 'no-results', showRedOutline);
            this._updateMatchesCount();
        }
        if (e.searchString || e.currentMatch) {
            this._layoutViewZone();
        }
        if (e.updateHistory) {
            this._delayedUpdateHistory();
        }
    };
    FindWidget.prototype._delayedUpdateHistory = function () {
        this._updateHistoryDelayer.trigger(this._updateHistory.bind(this));
    };
    FindWidget.prototype._updateHistory = function () {
        if (this._state.searchString) {
            this._findInput.inputBox.addToHistory();
        }
        if (this._state.replaceString) {
            this._replaceInputBox.addToHistory();
        }
    };
    FindWidget.prototype._updateMatchesCount = function () {
        this._matchesCount.style.minWidth = MAX_MATCHES_COUNT_WIDTH + 'px';
        if (this._state.matchesCount >= __WEBPACK_IMPORTED_MODULE_10__findModel_js__["f" /* MATCHES_LIMIT */]) {
            this._matchesCount.title = NLS_MATCHES_COUNT_LIMIT_TITLE;
        }
        else {
            this._matchesCount.title = '';
        }
        // remove previous content
        if (this._matchesCount.firstChild) {
            this._matchesCount.removeChild(this._matchesCount.firstChild);
        }
        var label;
        if (this._state.matchesCount > 0) {
            var matchesCount = String(this._state.matchesCount);
            if (this._state.matchesCount >= __WEBPACK_IMPORTED_MODULE_10__findModel_js__["f" /* MATCHES_LIMIT */]) {
                matchesCount += '+';
            }
            var matchesPosition = String(this._state.matchesPosition);
            if (matchesPosition === '0') {
                matchesPosition = '?';
            }
            label = __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["format"](NLS_MATCHES_LOCATION, matchesPosition, matchesCount);
        }
        else {
            label = NLS_NO_RESULTS;
        }
        this._matchesCount.appendChild(document.createTextNode(label));
        MAX_MATCHES_COUNT_WIDTH = Math.max(MAX_MATCHES_COUNT_WIDTH, this._matchesCount.clientWidth);
    };
    // ----- actions
    /**
     * If 'selection find' is ON we should not disable the button (its function is to cancel 'selection find').
     * If 'selection find' is OFF we enable the button only if there is a selection.
     */
    FindWidget.prototype._updateToggleSelectionFindButton = function () {
        var selection = this._codeEditor.getSelection();
        var isSelection = selection ? (selection.startLineNumber !== selection.endLineNumber || selection.startColumn !== selection.endColumn) : false;
        var isChecked = this._toggleSelectionFind.checked;
        this._toggleSelectionFind.setEnabled(this._isVisible && (isChecked || isSelection));
    };
    FindWidget.prototype._updateButtons = function () {
        this._findInput.setEnabled(this._isVisible);
        this._replaceInputBox.setEnabled(this._isVisible && this._isReplaceVisible);
        this._updateToggleSelectionFindButton();
        this._closeBtn.setEnabled(this._isVisible);
        var findInputIsNonEmpty = (this._state.searchString.length > 0);
        this._prevBtn.setEnabled(this._isVisible && findInputIsNonEmpty);
        this._nextBtn.setEnabled(this._isVisible && findInputIsNonEmpty);
        this._replaceBtn.setEnabled(this._isVisible && this._isReplaceVisible && findInputIsNonEmpty);
        this._replaceAllBtn.setEnabled(this._isVisible && this._isReplaceVisible && findInputIsNonEmpty);
        __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["N" /* toggleClass */](this._domNode, 'replaceToggled', this._isReplaceVisible);
        this._toggleReplaceBtn.toggleClass('collapse', !this._isReplaceVisible);
        this._toggleReplaceBtn.toggleClass('expand', this._isReplaceVisible);
        this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
        var canReplace = !this._codeEditor.getConfiguration().readOnly;
        this._toggleReplaceBtn.setEnabled(this._isVisible && canReplace);
    };
    FindWidget.prototype._reveal = function (animate) {
        var _this = this;
        if (!this._isVisible) {
            this._isVisible = true;
            var selection = this._codeEditor.getSelection();
            var isSelection = selection ? (selection.startLineNumber !== selection.endLineNumber || selection.startColumn !== selection.endColumn) : false;
            if (isSelection && this._codeEditor.getConfiguration().contribInfo.find.autoFindInSelection) {
                this._toggleSelectionFind.checked = true;
            }
            else {
                this._toggleSelectionFind.checked = false;
            }
            this._tryUpdateWidgetWidth();
            this._updateButtons();
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["f" /* addClass */](_this._domNode, 'visible');
                _this._domNode.setAttribute('aria-hidden', 'false');
            }, 0);
            this._codeEditor.layoutOverlayWidget(this);
            var adjustEditorScrollTop = true;
            if (this._codeEditor.getConfiguration().contribInfo.find.seedSearchStringFromSelection && selection) {
                var editorCoords = __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["u" /* getDomNodePagePosition */](this._codeEditor.getDomNode());
                var startCoords = this._codeEditor.getScrolledVisiblePosition(selection.getStartPosition());
                var startLeft = editorCoords.left + startCoords.left;
                var startTop = startCoords.top;
                if (startTop < this._viewZone.heightInPx) {
                    if (selection.endLineNumber > selection.startLineNumber) {
                        adjustEditorScrollTop = false;
                    }
                    var leftOfFindWidget = __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["w" /* getTopLeftOffset */](this._domNode).left;
                    if (startLeft > leftOfFindWidget) {
                        adjustEditorScrollTop = false;
                    }
                    var endCoords = this._codeEditor.getScrolledVisiblePosition(selection.getEndPosition());
                    var endLeft = editorCoords.left + endCoords.left;
                    if (endLeft > leftOfFindWidget) {
                        adjustEditorScrollTop = false;
                    }
                }
            }
            this._showViewZone(adjustEditorScrollTop);
        }
    };
    FindWidget.prototype._hide = function (focusTheEditor) {
        var _this = this;
        if (this._isVisible) {
            this._isVisible = false;
            this._updateButtons();
            __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["G" /* removeClass */](this._domNode, 'visible');
            this._domNode.setAttribute('aria-hidden', 'true');
            if (focusTheEditor) {
                this._codeEditor.focus();
            }
            this._codeEditor.layoutOverlayWidget(this);
            this._codeEditor.changeViewZones(function (accessor) {
                if (_this._viewZoneId !== undefined) {
                    accessor.removeZone(_this._viewZoneId);
                    _this._viewZoneId = undefined;
                    _this._codeEditor.setScrollTop(_this._codeEditor.getScrollTop() - _this._viewZone.heightInPx);
                }
            });
        }
    };
    FindWidget.prototype._layoutViewZone = function () {
        var _this = this;
        if (!this._isVisible) {
            return;
        }
        if (this._viewZoneId !== undefined) {
            return;
        }
        this._codeEditor.changeViewZones(function (accessor) {
            if (_this._state.isReplaceRevealed) {
                _this._viewZone.heightInPx = FIND_REPLACE_AREA_HEIGHT;
            }
            else {
                _this._viewZone.heightInPx = FIND_INPUT_AREA_HEIGHT;
            }
            _this._viewZoneId = accessor.addZone(_this._viewZone);
            // scroll top adjust to make sure the editor doesn't scroll when adding viewzone at the beginning.
            _this._codeEditor.setScrollTop(_this._codeEditor.getScrollTop() + _this._viewZone.heightInPx);
        });
    };
    FindWidget.prototype._showViewZone = function (adjustScroll) {
        var _this = this;
        if (adjustScroll === void 0) { adjustScroll = true; }
        if (!this._isVisible) {
            return;
        }
        this._codeEditor.changeViewZones(function (accessor) {
            var scrollAdjustment = FIND_INPUT_AREA_HEIGHT;
            if (_this._viewZoneId !== undefined) {
                if (_this._state.isReplaceRevealed) {
                    _this._viewZone.heightInPx = FIND_REPLACE_AREA_HEIGHT;
                    scrollAdjustment = FIND_REPLACE_AREA_HEIGHT - FIND_INPUT_AREA_HEIGHT;
                }
                else {
                    _this._viewZone.heightInPx = FIND_INPUT_AREA_HEIGHT;
                    scrollAdjustment = FIND_INPUT_AREA_HEIGHT - FIND_REPLACE_AREA_HEIGHT;
                }
                accessor.removeZone(_this._viewZoneId);
            }
            else {
                _this._viewZone.heightInPx = FIND_INPUT_AREA_HEIGHT;
            }
            _this._viewZoneId = accessor.addZone(_this._viewZone);
            if (adjustScroll) {
                _this._codeEditor.setScrollTop(_this._codeEditor.getScrollTop() + scrollAdjustment);
            }
        });
    };
    FindWidget.prototype._applyTheme = function (theme) {
        var inputStyles = {
            inputActiveOptionBorder: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["J" /* inputActiveOptionBorder */]),
            inputBackground: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["K" /* inputBackground */]),
            inputForeground: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["M" /* inputForeground */]),
            inputBorder: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["L" /* inputBorder */]),
            inputValidationInfoBackground: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["P" /* inputValidationInfoBackground */]),
            inputValidationInfoBorder: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["Q" /* inputValidationInfoBorder */]),
            inputValidationWarningBackground: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["R" /* inputValidationWarningBackground */]),
            inputValidationWarningBorder: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["S" /* inputValidationWarningBorder */]),
            inputValidationErrorBackground: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["N" /* inputValidationErrorBackground */]),
            inputValidationErrorBorder: theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["O" /* inputValidationErrorBorder */])
        };
        this._findInput.style(inputStyles);
        this._replaceInputBox.style(inputStyles);
    };
    FindWidget.prototype._tryUpdateWidgetWidth = function () {
        if (!this._isVisible) {
            return;
        }
        var editorWidth = this._codeEditor.getConfiguration().layoutInfo.width;
        var minimapWidth = this._codeEditor.getConfiguration().layoutInfo.minimapWidth;
        var collapsedFindWidget = false;
        var reducedFindWidget = false;
        var narrowFindWidget = false;
        if (this._resized) {
            var widgetWidth = __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["y" /* getTotalWidth */](this._domNode);
            if (widgetWidth > FIND_WIDGET_INITIAL_WIDTH) {
                // as the widget is resized by users, we may need to change the max width of the widget as the editor width changes.
                this._domNode.style.maxWidth = editorWidth - 28 - minimapWidth - 15 + "px";
                this._replaceInputBox.inputElement.style.width = __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["y" /* getTotalWidth */](this._findInput.inputBox.inputElement) + "px";
                return;
            }
        }
        if (FIND_WIDGET_INITIAL_WIDTH + 28 + minimapWidth >= editorWidth) {
            reducedFindWidget = true;
        }
        if (FIND_WIDGET_INITIAL_WIDTH + 28 + minimapWidth - MAX_MATCHES_COUNT_WIDTH >= editorWidth) {
            narrowFindWidget = true;
        }
        if (FIND_WIDGET_INITIAL_WIDTH + 28 + minimapWidth - MAX_MATCHES_COUNT_WIDTH >= editorWidth + 50) {
            collapsedFindWidget = true;
        }
        __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["N" /* toggleClass */](this._domNode, 'collapsed-find-widget', collapsedFindWidget);
        __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["N" /* toggleClass */](this._domNode, 'narrow-find-widget', narrowFindWidget);
        __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["N" /* toggleClass */](this._domNode, 'reduced-find-widget', reducedFindWidget);
        if (!narrowFindWidget && !collapsedFindWidget) {
            // the minimal left offset of findwidget is 15px.
            this._domNode.style.maxWidth = editorWidth - 28 - minimapWidth - 15 + "px";
        }
        if (this._resized) {
            var findInputWidth = __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["y" /* getTotalWidth */](this._findInput.inputBox.inputElement);
            if (findInputWidth > 0) {
                this._replaceInputBox.inputElement.style.width = findInputWidth + "px";
            }
        }
    };
    // ----- Public
    FindWidget.prototype.focusFindInput = function () {
        this._findInput.select();
        // Edge browser requires focus() in addition to select()
        this._findInput.focus();
    };
    FindWidget.prototype.focusReplaceInput = function () {
        this._replaceInputBox.select();
        // Edge browser requires focus() in addition to select()
        this._replaceInputBox.focus();
    };
    FindWidget.prototype.highlightFindOptions = function () {
        this._findInput.highlightFindOptions();
    };
    FindWidget.prototype._updateSearchScope = function () {
        if (this._toggleSelectionFind.checked) {
            var selection = this._codeEditor.getSelection();
            if (selection.endColumn === 1 && selection.endLineNumber > selection.startLineNumber) {
                selection = selection.setEndPosition(selection.endLineNumber - 1, 1);
            }
            var currentMatch = this._state.currentMatch;
            if (selection.startLineNumber !== selection.endLineNumber) {
                if (!__WEBPACK_IMPORTED_MODULE_11__common_core_range_js__["a" /* Range */].equalsRange(selection, currentMatch)) {
                    // Reseed find scope
                    this._state.change({ searchScope: selection }, true);
                }
            }
        }
    };
    FindWidget.prototype._onFindInputMouseDown = function (e) {
        // on linux, middle key does pasting.
        if (e.middleButton) {
            e.stopPropagation();
        }
    };
    FindWidget.prototype._onFindInputKeyDown = function (e) {
        if (e.equals(3 /* Enter */)) {
            this._codeEditor.getAction(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].NextMatchFindAction).run().done(null, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
            e.preventDefault();
            return;
        }
        if (e.equals(1024 /* Shift */ | 3 /* Enter */)) {
            this._codeEditor.getAction(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].PreviousMatchFindAction).run().done(null, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
            e.preventDefault();
            return;
        }
        if (e.equals(2 /* Tab */)) {
            if (this._isReplaceVisible) {
                this._replaceInputBox.focus();
            }
            else {
                this._findInput.focusOnCaseSensitive();
            }
            e.preventDefault();
            return;
        }
        if (e.equals(2048 /* CtrlCmd */ | 18 /* DownArrow */)) {
            this._codeEditor.focus();
            e.preventDefault();
            return;
        }
    };
    FindWidget.prototype._onReplaceInputKeyDown = function (e) {
        if (e.equals(3 /* Enter */)) {
            this._controller.replace();
            e.preventDefault();
            return;
        }
        if (e.equals(2048 /* CtrlCmd */ | 3 /* Enter */)) {
            this._controller.replaceAll();
            e.preventDefault();
            return;
        }
        if (e.equals(2 /* Tab */)) {
            this._findInput.focusOnCaseSensitive();
            e.preventDefault();
            return;
        }
        if (e.equals(1024 /* Shift */ | 2 /* Tab */)) {
            this._findInput.focus();
            e.preventDefault();
            return;
        }
        if (e.equals(2048 /* CtrlCmd */ | 18 /* DownArrow */)) {
            this._codeEditor.focus();
            e.preventDefault();
            return;
        }
    };
    // ----- sash
    FindWidget.prototype.getHorizontalSashTop = function (sash) {
        return 0;
    };
    FindWidget.prototype.getHorizontalSashLeft = function (sash) {
        return 0;
    };
    FindWidget.prototype.getHorizontalSashWidth = function (sash) {
        return 500;
    };
    // ----- initialization
    FindWidget.prototype._keybindingLabelFor = function (actionId) {
        var kb = this._keybindingService.lookupKeybinding(actionId);
        if (!kb) {
            return '';
        }
        return " (" + kb.getLabel() + ")";
    };
    FindWidget.prototype._buildFindPart = function () {
        var _this = this;
        // Find input
        this._findInput = this._register(new __WEBPACK_IMPORTED_MODULE_14__platform_widget_browser_contextScopedHistoryWidget_js__["a" /* ContextScopedFindInput */](null, this._contextViewProvider, {
            width: FIND_INPUT_AREA_WIDTH,
            label: NLS_FIND_INPUT_LABEL,
            placeholder: NLS_FIND_INPUT_PLACEHOLDER,
            appendCaseSensitiveLabel: this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].ToggleCaseSensitiveCommand),
            appendWholeWordsLabel: this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].ToggleWholeWordCommand),
            appendRegexLabel: this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].ToggleRegexCommand),
            validation: function (value) {
                if (value.length === 0) {
                    return null;
                }
                if (!_this._findInput.getRegex()) {
                    return null;
                }
                try {
                    /* tslint:disable:no-unused-expression */
                    new RegExp(value);
                    /* tslint:enable:no-unused-expression */
                    return null;
                }
                catch (e) {
                    return { content: e.message };
                }
            }
        }, this._contextKeyService));
        this._findInput.setRegex(!!this._state.isRegex);
        this._findInput.setCaseSensitive(!!this._state.matchCase);
        this._findInput.setWholeWords(!!this._state.wholeWord);
        this._register(this._findInput.onKeyDown(function (e) { return _this._onFindInputKeyDown(e); }));
        this._register(this._findInput.inputBox.onDidChange(function () {
            _this._state.change({ searchString: _this._findInput.getValue() }, true);
        }));
        this._register(this._findInput.onDidOptionChange(function () {
            _this._state.change({
                isRegex: _this._findInput.getRegex(),
                wholeWord: _this._findInput.getWholeWords(),
                matchCase: _this._findInput.getCaseSensitive()
            }, true);
        }));
        this._register(this._findInput.onCaseSensitiveKeyDown(function (e) {
            if (e.equals(1024 /* Shift */ | 2 /* Tab */)) {
                if (_this._isReplaceVisible) {
                    _this._replaceInputBox.focus();
                    e.preventDefault();
                }
            }
        }));
        if (__WEBPACK_IMPORTED_MODULE_3__base_common_platform_js__["c" /* isLinux */]) {
            this._register(this._findInput.onMouseDown(function (e) { return _this._onFindInputMouseDown(e); }));
        }
        this._matchesCount = document.createElement('div');
        this._matchesCount.className = 'matchesCount';
        this._updateMatchesCount();
        // Previous button
        this._prevBtn = this._register(new SimpleButton({
            label: NLS_PREVIOUS_MATCH_BTN_LABEL + this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].PreviousMatchFindAction),
            className: 'previous',
            onTrigger: function () {
                _this._codeEditor.getAction(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].PreviousMatchFindAction).run().done(null, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
            }
        }));
        // Next button
        this._nextBtn = this._register(new SimpleButton({
            label: NLS_NEXT_MATCH_BTN_LABEL + this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].NextMatchFindAction),
            className: 'next',
            onTrigger: function () {
                _this._codeEditor.getAction(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].NextMatchFindAction).run().done(null, __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
            }
        }));
        var findPart = document.createElement('div');
        findPart.className = 'find-part';
        findPart.appendChild(this._findInput.domNode);
        findPart.appendChild(this._matchesCount);
        findPart.appendChild(this._prevBtn.domNode);
        findPart.appendChild(this._nextBtn.domNode);
        // Toggle selection button
        this._toggleSelectionFind = this._register(new SimpleCheckbox({
            parent: findPart,
            title: NLS_TOGGLE_SELECTION_FIND_TITLE + this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].ToggleSearchScopeCommand),
            onChange: function () {
                if (_this._toggleSelectionFind.checked) {
                    var selection = _this._codeEditor.getSelection();
                    if (selection.endColumn === 1 && selection.endLineNumber > selection.startLineNumber) {
                        selection = selection.setEndPosition(selection.endLineNumber - 1, 1);
                    }
                    if (!selection.isEmpty()) {
                        _this._state.change({ searchScope: selection }, true);
                    }
                }
                else {
                    _this._state.change({ searchScope: null }, true);
                }
            }
        }));
        // Close button
        this._closeBtn = this._register(new SimpleButton({
            label: NLS_CLOSE_BTN_LABEL + this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].CloseFindWidgetCommand),
            className: 'close-fw',
            onTrigger: function () {
                _this._state.change({ isRevealed: false, searchScope: null }, false);
            },
            onKeyDown: function (e) {
                if (e.equals(2 /* Tab */)) {
                    if (_this._isReplaceVisible) {
                        if (_this._replaceBtn.isEnabled()) {
                            _this._replaceBtn.focus();
                        }
                        else {
                            _this._codeEditor.focus();
                        }
                        e.preventDefault();
                    }
                }
            }
        }));
        findPart.appendChild(this._closeBtn.domNode);
        return findPart;
    };
    FindWidget.prototype._buildReplacePart = function () {
        var _this = this;
        // Replace input
        var replaceInput = document.createElement('div');
        replaceInput.className = 'replace-input';
        replaceInput.style.width = REPLACE_INPUT_AREA_WIDTH + 'px';
        this._replaceInputBox = this._register(new __WEBPACK_IMPORTED_MODULE_14__platform_widget_browser_contextScopedHistoryWidget_js__["b" /* ContextScopedHistoryInputBox */](replaceInput, null, {
            ariaLabel: NLS_REPLACE_INPUT_LABEL,
            placeholder: NLS_REPLACE_INPUT_PLACEHOLDER,
            history: []
        }, this._contextKeyService));
        this._register(__WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["j" /* addStandardDisposableListener */](this._replaceInputBox.inputElement, 'keydown', function (e) { return _this._onReplaceInputKeyDown(e); }));
        this._register(__WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["j" /* addStandardDisposableListener */](this._replaceInputBox.inputElement, 'input', function (e) {
            _this._state.change({ replaceString: _this._replaceInputBox.value }, false);
        }));
        // Replace one button
        this._replaceBtn = this._register(new SimpleButton({
            label: NLS_REPLACE_BTN_LABEL + this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].ReplaceOneAction),
            className: 'replace',
            onTrigger: function () {
                _this._controller.replace();
            },
            onKeyDown: function (e) {
                if (e.equals(1024 /* Shift */ | 2 /* Tab */)) {
                    _this._closeBtn.focus();
                    e.preventDefault();
                }
            }
        }));
        // Replace all button
        this._replaceAllBtn = this._register(new SimpleButton({
            label: NLS_REPLACE_ALL_BTN_LABEL + this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_10__findModel_js__["d" /* FIND_IDS */].ReplaceAllAction),
            className: 'replace-all',
            onTrigger: function () {
                _this._controller.replaceAll();
            }
        }));
        var replacePart = document.createElement('div');
        replacePart.className = 'replace-part';
        replacePart.appendChild(replaceInput);
        replacePart.appendChild(this._replaceBtn.domNode);
        replacePart.appendChild(this._replaceAllBtn.domNode);
        return replacePart;
    };
    FindWidget.prototype._buildDomNode = function () {
        var _this = this;
        // Find part
        var findPart = this._buildFindPart();
        // Replace part
        var replacePart = this._buildReplacePart();
        // Toggle replace button
        this._toggleReplaceBtn = this._register(new SimpleButton({
            label: NLS_TOGGLE_REPLACE_MODE_BTN_LABEL,
            className: 'toggle left',
            onTrigger: function () {
                _this._state.change({ isReplaceRevealed: !_this._isReplaceVisible }, false);
                if (_this._isReplaceVisible) {
                    _this._replaceInputBox.width = _this._findInput.inputBox.width;
                }
                _this._showViewZone();
            }
        }));
        this._toggleReplaceBtn.toggleClass('expand', this._isReplaceVisible);
        this._toggleReplaceBtn.toggleClass('collapse', !this._isReplaceVisible);
        this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
        // Widget
        this._domNode = document.createElement('div');
        this._domNode.className = 'editor-widget find-widget';
        this._domNode.setAttribute('aria-hidden', 'true');
        // We need to set this explicitly, otherwise on IE11, the width inheritence of flex doesn't work.
        this._domNode.style.width = FIND_WIDGET_INITIAL_WIDTH + "px";
        this._domNode.appendChild(this._toggleReplaceBtn.domNode);
        this._domNode.appendChild(findPart);
        this._domNode.appendChild(replacePart);
        this._buildSash();
    };
    FindWidget.prototype._buildSash = function () {
        var _this = this;
        this._resizeSash = new __WEBPACK_IMPORTED_MODULE_8__base_browser_ui_sash_sash_js__["b" /* Sash */](this._domNode, this, { orientation: __WEBPACK_IMPORTED_MODULE_8__base_browser_ui_sash_sash_js__["a" /* Orientation */].VERTICAL });
        this._resized = false;
        var originalWidth = FIND_WIDGET_INITIAL_WIDTH;
        this._register(this._resizeSash.onDidStart(function (e) {
            originalWidth = __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["y" /* getTotalWidth */](_this._domNode);
        }));
        this._register(this._resizeSash.onDidChange(function (evt) {
            _this._resized = true;
            var width = originalWidth + evt.startX - evt.currentX;
            if (width < FIND_WIDGET_INITIAL_WIDTH) {
                // narrow down the find widget should be handled by CSS.
                return;
            }
            var inputBoxWidth = width - FIND_ALL_CONTROLS_WIDTH;
            var maxWidth = parseFloat(__WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["r" /* getComputedStyle */](_this._domNode).maxWidth) || 0;
            if (width > maxWidth) {
                return;
            }
            _this._domNode.style.width = width + "px";
            if (_this._isReplaceVisible) {
                _this._replaceInputBox.width = inputBoxWidth;
            }
        }));
    };
    FindWidget.ID = 'editor.contrib.findWidget';
    return FindWidget;
}(__WEBPACK_IMPORTED_MODULE_7__base_browser_ui_widget_js__["a" /* Widget */]));

var SimpleCheckbox = /** @class */ (function (_super) {
    __extends(SimpleCheckbox, _super);
    function SimpleCheckbox(opts) {
        var _this = _super.call(this) || this;
        _this._opts = opts;
        _this._domNode = document.createElement('div');
        _this._domNode.className = 'monaco-checkbox';
        _this._domNode.title = _this._opts.title;
        _this._domNode.tabIndex = 0;
        _this._checkbox = document.createElement('input');
        _this._checkbox.type = 'checkbox';
        _this._checkbox.className = 'checkbox';
        _this._checkbox.id = 'checkbox-' + SimpleCheckbox._COUNTER++;
        _this._checkbox.tabIndex = -1;
        _this._label = document.createElement('label');
        _this._label.className = 'label';
        // Connect the label and the checkbox. Checkbox will get checked when the label receives a click.
        _this._label.htmlFor = _this._checkbox.id;
        _this._label.tabIndex = -1;
        _this._domNode.appendChild(_this._checkbox);
        _this._domNode.appendChild(_this._label);
        _this._opts.parent.appendChild(_this._domNode);
        _this.onchange(_this._checkbox, function (e) {
            _this._opts.onChange();
        });
        return _this;
    }
    Object.defineProperty(SimpleCheckbox.prototype, "domNode", {
        get: function () {
            return this._domNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SimpleCheckbox.prototype, "checked", {
        get: function () {
            return this._checkbox.checked;
        },
        set: function (newValue) {
            this._checkbox.checked = newValue;
        },
        enumerable: true,
        configurable: true
    });
    SimpleCheckbox.prototype.enable = function () {
        this._checkbox.removeAttribute('disabled');
    };
    SimpleCheckbox.prototype.disable = function () {
        this._checkbox.disabled = true;
    };
    SimpleCheckbox.prototype.setEnabled = function (enabled) {
        if (enabled) {
            this.enable();
            this.domNode.tabIndex = 0;
        }
        else {
            this.disable();
            this.domNode.tabIndex = -1;
        }
    };
    SimpleCheckbox._COUNTER = 0;
    return SimpleCheckbox;
}(__WEBPACK_IMPORTED_MODULE_7__base_browser_ui_widget_js__["a" /* Widget */]));
var SimpleButton = /** @class */ (function (_super) {
    __extends(SimpleButton, _super);
    function SimpleButton(opts) {
        var _this = _super.call(this) || this;
        _this._opts = opts;
        _this._domNode = document.createElement('div');
        _this._domNode.title = _this._opts.label;
        _this._domNode.tabIndex = 0;
        _this._domNode.className = 'button ' + _this._opts.className;
        _this._domNode.setAttribute('role', 'button');
        _this._domNode.setAttribute('aria-label', _this._opts.label);
        _this.onclick(_this._domNode, function (e) {
            _this._opts.onTrigger();
            e.preventDefault();
        });
        _this.onkeydown(_this._domNode, function (e) {
            if (e.equals(10 /* Space */) || e.equals(3 /* Enter */)) {
                _this._opts.onTrigger();
                e.preventDefault();
                return;
            }
            if (_this._opts.onKeyDown) {
                _this._opts.onKeyDown(e);
            }
        });
        return _this;
    }
    Object.defineProperty(SimpleButton.prototype, "domNode", {
        get: function () {
            return this._domNode;
        },
        enumerable: true,
        configurable: true
    });
    SimpleButton.prototype.isEnabled = function () {
        return (this._domNode.tabIndex >= 0);
    };
    SimpleButton.prototype.focus = function () {
        this._domNode.focus();
    };
    SimpleButton.prototype.setEnabled = function (enabled) {
        __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["N" /* toggleClass */](this._domNode, 'disabled', !enabled);
        this._domNode.setAttribute('aria-disabled', String(!enabled));
        this._domNode.tabIndex = enabled ? 0 : -1;
    };
    SimpleButton.prototype.setExpanded = function (expanded) {
        this._domNode.setAttribute('aria-expanded', String(!!expanded));
    };
    SimpleButton.prototype.toggleClass = function (className, shouldHaveIt) {
        __WEBPACK_IMPORTED_MODULE_6__base_browser_dom_js__["N" /* toggleClass */](this._domNode, className, shouldHaveIt);
    };
    return SimpleButton;
}(__WEBPACK_IMPORTED_MODULE_7__base_browser_ui_widget_js__["a" /* Widget */]));

// theming
Object(__WEBPACK_IMPORTED_MODULE_12__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var addBackgroundColorRule = function (selector, color) {
        if (color) {
            collector.addRule(".monaco-editor " + selector + " { background-color: " + color + "; }");
        }
    };
    addBackgroundColorRule('.findMatch', theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["q" /* editorFindMatchHighlight */]));
    addBackgroundColorRule('.currentFindMatch', theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["o" /* editorFindMatch */]));
    addBackgroundColorRule('.findScope', theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["s" /* editorFindRangeHighlight */]));
    var widgetBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["D" /* editorWidgetBackground */]);
    addBackgroundColorRule('.find-widget', widgetBackground);
    var widgetShadowColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["_17" /* widgetShadow */]);
    if (widgetShadowColor) {
        collector.addRule(".monaco-editor .find-widget { box-shadow: 0 2px 8px " + widgetShadowColor + "; }");
    }
    var findMatchHighlightBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["r" /* editorFindMatchHighlightBorder */]);
    if (findMatchHighlightBorder) {
        collector.addRule(".monaco-editor .findMatch { border: 1px " + (theme.type === 'hc' ? 'dotted' : 'solid') + " " + findMatchHighlightBorder + "; box-sizing: border-box; }");
    }
    var findMatchBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["p" /* editorFindMatchBorder */]);
    if (findMatchBorder) {
        collector.addRule(".monaco-editor .currentFindMatch { border: 2px solid " + findMatchBorder + "; padding: 1px; box-sizing: border-box; }");
    }
    var findRangeHighlightBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["t" /* editorFindRangeHighlightBorder */]);
    if (findRangeHighlightBorder) {
        collector.addRule(".monaco-editor .findScope { border: 1px " + (theme.type === 'hc' ? 'dashed' : 'solid') + " " + findRangeHighlightBorder + "; }");
    }
    var hcBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["e" /* contrastBorder */]);
    if (hcBorder) {
        collector.addRule(".monaco-editor .find-widget { border: 2px solid " + hcBorder + "; }");
    }
    var error = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["G" /* errorForeground */]);
    if (error) {
        collector.addRule(".monaco-editor .find-widget.no-results .matchesCount { color: " + error + "; }");
    }
    var resizeBorderBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["F" /* editorWidgetResizeBorder */]);
    if (resizeBorderBackground) {
        collector.addRule(".monaco-editor .find-widget .monaco-sash { background-color: " + resizeBorderBackground + "; width: 3px !important; margin-left: -4px;}");
    }
    else {
        var border = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["E" /* editorWidgetBorder */]);
        if (border) {
            collector.addRule(".monaco-editor .find-widget .monaco-sash { background-color: " + border + "; width: 3px !important; margin-left: -4px;}");
        }
    }
});


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HistoryNavigationWidgetContext */
/* unused harmony export HistoryNavigationEnablementContext */
/* unused harmony export createAndBindHistoryNavigationWidgetScopedContextKeyService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContextScopedHistoryInputBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextScopedFindInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_ui_inputbox_inputBox_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_ui_findinput_findInput_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_contextScopedWidget_js__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keybinding_common_keybindingsRegistry_js__ = __webpack_require__(90);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





var HistoryNavigationWidgetContext = 'historyNavigationWidget';
var HistoryNavigationEnablementContext = 'historyNavigationEnabled';
function createAndBindHistoryNavigationWidgetScopedContextKeyService(contextKeyService, widget) {
    var scopedContextKeyService = Object(__WEBPACK_IMPORTED_MODULE_3__common_contextScopedWidget_js__["b" /* createWidgetScopedContextKeyService */])(contextKeyService, widget);
    Object(__WEBPACK_IMPORTED_MODULE_3__common_contextScopedWidget_js__["a" /* bindContextScopedWidget */])(scopedContextKeyService, widget, HistoryNavigationWidgetContext);
    var historyNavigationEnablement = new __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["f" /* RawContextKey */](HistoryNavigationEnablementContext, true).bindTo(scopedContextKeyService);
    return { scopedContextKeyService: scopedContextKeyService, historyNavigationEnablement: historyNavigationEnablement };
}
var ContextScopedHistoryInputBox = /** @class */ (function (_super) {
    __extends(ContextScopedHistoryInputBox, _super);
    function ContextScopedHistoryInputBox(container, contextViewProvider, options, contextKeyService) {
        var _this = _super.call(this, container, contextViewProvider, options) || this;
        _this._register(createAndBindHistoryNavigationWidgetScopedContextKeyService(contextKeyService, { target: _this.element, historyNavigator: _this }).scopedContextKeyService);
        return _this;
    }
    ContextScopedHistoryInputBox = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], ContextScopedHistoryInputBox);
    return ContextScopedHistoryInputBox;
}(__WEBPACK_IMPORTED_MODULE_1__base_browser_ui_inputbox_inputBox_js__["a" /* HistoryInputBox */]));

var ContextScopedFindInput = /** @class */ (function (_super) {
    __extends(ContextScopedFindInput, _super);
    function ContextScopedFindInput(container, contextViewProvider, options, contextKeyService) {
        var _this = _super.call(this, container, contextViewProvider, options) || this;
        _this._register(createAndBindHistoryNavigationWidgetScopedContextKeyService(contextKeyService, { target: _this.inputBox.element, historyNavigator: _this.inputBox }).scopedContextKeyService);
        return _this;
    }
    ContextScopedFindInput = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], ContextScopedFindInput);
    return ContextScopedFindInput;
}(__WEBPACK_IMPORTED_MODULE_2__base_browser_ui_findinput_findInput_js__["a" /* FindInput */]));

__WEBPACK_IMPORTED_MODULE_4__keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'history.showPrevious',
    weight: 200 /* WorkbenchContrib */,
    when: __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(new __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["b" /* ContextKeyDefinedExpr */](HistoryNavigationWidgetContext), new __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["c" /* ContextKeyEqualsExpr */](HistoryNavigationEnablementContext, true)),
    primary: 16 /* UpArrow */,
    secondary: [512 /* Alt */ | 16 /* UpArrow */],
    handler: function (accessor, arg2) {
        var historyInputBox = Object(__WEBPACK_IMPORTED_MODULE_3__common_contextScopedWidget_js__["c" /* getContextScopedWidget */])(accessor.get(__WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["e" /* IContextKeyService */]), HistoryNavigationWidgetContext).historyNavigator;
        historyInputBox.showPreviousValue();
    }
});
__WEBPACK_IMPORTED_MODULE_4__keybinding_common_keybindingsRegistry_js__["a" /* KeybindingsRegistry */].registerCommandAndKeybindingRule({
    id: 'history.showNext',
    weight: 200 /* WorkbenchContrib */,
    when: new __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["a" /* ContextKeyAndExpr */]([new __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["b" /* ContextKeyDefinedExpr */](HistoryNavigationWidgetContext), new __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["c" /* ContextKeyEqualsExpr */](HistoryNavigationEnablementContext, true)]),
    primary: 18 /* DownArrow */,
    secondary: [512 /* Alt */ | 18 /* DownArrow */],
    handler: function (accessor, arg2) {
        var historyInputBox = Object(__WEBPACK_IMPORTED_MODULE_3__common_contextScopedWidget_js__["c" /* getContextScopedWidget */])(accessor.get(__WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["e" /* IContextKeyService */]), HistoryNavigationWidgetContext).historyNavigator;
        historyInputBox.showNextValue();
    }
});


/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HistoryNavigator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iterator_js__ = __webpack_require__(139);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var HistoryNavigator = /** @class */ (function () {
    function HistoryNavigator(history, limit) {
        if (history === void 0) { history = []; }
        if (limit === void 0) { limit = 10; }
        this._initialize(history);
        this._limit = limit;
        this._onChange();
    }
    HistoryNavigator.prototype.add = function (t) {
        this._history.delete(t);
        this._history.add(t);
        this._onChange();
    };
    HistoryNavigator.prototype.next = function () {
        return this._navigator.next();
    };
    HistoryNavigator.prototype.previous = function () {
        return this._navigator.previous();
    };
    HistoryNavigator.prototype.current = function () {
        return this._navigator.current();
    };
    HistoryNavigator.prototype.parent = function () {
        return null;
    };
    HistoryNavigator.prototype.first = function () {
        return this._navigator.first();
    };
    HistoryNavigator.prototype.last = function () {
        return this._navigator.last();
    };
    HistoryNavigator.prototype.has = function (t) {
        return this._history.has(t);
    };
    HistoryNavigator.prototype._onChange = function () {
        this._reduceToLimit();
        this._navigator = new __WEBPACK_IMPORTED_MODULE_0__iterator_js__["b" /* ArrayNavigator */](this._elements, 0, this._elements.length, this._elements.length);
    };
    HistoryNavigator.prototype._reduceToLimit = function () {
        var data = this._elements;
        if (data.length > this._limit) {
            this._initialize(data.slice(data.length - this._limit));
        }
    };
    HistoryNavigator.prototype._initialize = function (history) {
        this._history = new Set();
        for (var _i = 0, history_1 = history; _i < history_1.length; _i++) {
            var entry = history_1[_i];
            this._history.add(entry);
        }
    };
    Object.defineProperty(HistoryNavigator.prototype, "_elements", {
        get: function () {
            var elements = [];
            this._history.forEach(function (e) { return elements.push(e); });
            return elements;
        },
        enumerable: true,
        configurable: true
    });
    return HistoryNavigator;
}());



/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findInput_css__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__findInput_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inputbox_inputBox_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findInputCheckboxes_js__ = __webpack_require__(260);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var NLS_DEFAULT_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('defaultLabel', "input");
var FindInput = /** @class */ (function (_super) {
    __extends(FindInput, _super);
    function FindInput(parent, contextViewProvider, options) {
        var _this = _super.call(this) || this;
        _this._onDidOptionChange = _this._register(new __WEBPACK_IMPORTED_MODULE_5__common_event_js__["a" /* Emitter */]());
        _this.onDidOptionChange = _this._onDidOptionChange.event;
        _this._onKeyDown = _this._register(new __WEBPACK_IMPORTED_MODULE_5__common_event_js__["a" /* Emitter */]());
        _this.onKeyDown = _this._onKeyDown.event;
        _this._onMouseDown = _this._register(new __WEBPACK_IMPORTED_MODULE_5__common_event_js__["a" /* Emitter */]());
        _this.onMouseDown = _this._onMouseDown.event;
        _this._onInput = _this._register(new __WEBPACK_IMPORTED_MODULE_5__common_event_js__["a" /* Emitter */]());
        _this._onKeyUp = _this._register(new __WEBPACK_IMPORTED_MODULE_5__common_event_js__["a" /* Emitter */]());
        _this._onCaseSensitiveKeyDown = _this._register(new __WEBPACK_IMPORTED_MODULE_5__common_event_js__["a" /* Emitter */]());
        _this.onCaseSensitiveKeyDown = _this._onCaseSensitiveKeyDown.event;
        _this._onRegexKeyDown = _this._register(new __WEBPACK_IMPORTED_MODULE_5__common_event_js__["a" /* Emitter */]());
        _this._lastHighlightFindOptions = 0;
        _this.contextViewProvider = contextViewProvider;
        _this.width = options.width || 100;
        _this.placeholder = options.placeholder || '';
        _this.validation = options.validation;
        _this.label = options.label || NLS_DEFAULT_LABEL;
        _this.inputActiveOptionBorder = options.inputActiveOptionBorder;
        _this.inputBackground = options.inputBackground;
        _this.inputForeground = options.inputForeground;
        _this.inputBorder = options.inputBorder;
        _this.inputValidationInfoBorder = options.inputValidationInfoBorder;
        _this.inputValidationInfoBackground = options.inputValidationInfoBackground;
        _this.inputValidationWarningBorder = options.inputValidationWarningBorder;
        _this.inputValidationWarningBackground = options.inputValidationWarningBackground;
        _this.inputValidationErrorBorder = options.inputValidationErrorBorder;
        _this.inputValidationErrorBackground = options.inputValidationErrorBackground;
        _this.regex = null;
        _this.wholeWords = null;
        _this.caseSensitive = null;
        _this.domNode = null;
        _this.inputBox = null;
        _this.buildDomNode(options.appendCaseSensitiveLabel || '', options.appendWholeWordsLabel || '', options.appendRegexLabel || '', options.history);
        if (Boolean(parent)) {
            parent.appendChild(_this.domNode);
        }
        _this.onkeydown(_this.inputBox.inputElement, function (e) { return _this._onKeyDown.fire(e); });
        _this.onkeyup(_this.inputBox.inputElement, function (e) { return _this._onKeyUp.fire(e); });
        _this.oninput(_this.inputBox.inputElement, function (e) { return _this._onInput.fire(); });
        _this.onmousedown(_this.inputBox.inputElement, function (e) { return _this._onMouseDown.fire(e); });
        return _this;
    }
    FindInput.prototype.enable = function () {
        __WEBPACK_IMPORTED_MODULE_2__dom_js__["G" /* removeClass */](this.domNode, 'disabled');
        this.inputBox.enable();
        this.regex.enable();
        this.wholeWords.enable();
        this.caseSensitive.enable();
    };
    FindInput.prototype.disable = function () {
        __WEBPACK_IMPORTED_MODULE_2__dom_js__["f" /* addClass */](this.domNode, 'disabled');
        this.inputBox.disable();
        this.regex.disable();
        this.wholeWords.disable();
        this.caseSensitive.disable();
    };
    FindInput.prototype.setEnabled = function (enabled) {
        if (enabled) {
            this.enable();
        }
        else {
            this.disable();
        }
    };
    FindInput.prototype.getValue = function () {
        return this.inputBox.value;
    };
    FindInput.prototype.setValue = function (value) {
        if (this.inputBox.value !== value) {
            this.inputBox.value = value;
        }
    };
    FindInput.prototype.style = function (styles) {
        this.inputActiveOptionBorder = styles.inputActiveOptionBorder;
        this.inputBackground = styles.inputBackground;
        this.inputForeground = styles.inputForeground;
        this.inputBorder = styles.inputBorder;
        this.inputValidationInfoBackground = styles.inputValidationInfoBackground;
        this.inputValidationInfoBorder = styles.inputValidationInfoBorder;
        this.inputValidationWarningBackground = styles.inputValidationWarningBackground;
        this.inputValidationWarningBorder = styles.inputValidationWarningBorder;
        this.inputValidationErrorBackground = styles.inputValidationErrorBackground;
        this.inputValidationErrorBorder = styles.inputValidationErrorBorder;
        this.applyStyles();
    };
    FindInput.prototype.applyStyles = function () {
        if (this.domNode) {
            var checkBoxStyles = {
                inputActiveOptionBorder: this.inputActiveOptionBorder,
            };
            this.regex.style(checkBoxStyles);
            this.wholeWords.style(checkBoxStyles);
            this.caseSensitive.style(checkBoxStyles);
            var inputBoxStyles = {
                inputBackground: this.inputBackground,
                inputForeground: this.inputForeground,
                inputBorder: this.inputBorder,
                inputValidationInfoBackground: this.inputValidationInfoBackground,
                inputValidationInfoBorder: this.inputValidationInfoBorder,
                inputValidationWarningBackground: this.inputValidationWarningBackground,
                inputValidationWarningBorder: this.inputValidationWarningBorder,
                inputValidationErrorBackground: this.inputValidationErrorBackground,
                inputValidationErrorBorder: this.inputValidationErrorBorder
            };
            this.inputBox.style(inputBoxStyles);
        }
    };
    FindInput.prototype.select = function () {
        this.inputBox.select();
    };
    FindInput.prototype.focus = function () {
        this.inputBox.focus();
    };
    FindInput.prototype.getCaseSensitive = function () {
        return this.caseSensitive.checked;
    };
    FindInput.prototype.setCaseSensitive = function (value) {
        this.caseSensitive.checked = value;
        this.setInputWidth();
    };
    FindInput.prototype.getWholeWords = function () {
        return this.wholeWords.checked;
    };
    FindInput.prototype.setWholeWords = function (value) {
        this.wholeWords.checked = value;
        this.setInputWidth();
    };
    FindInput.prototype.getRegex = function () {
        return this.regex.checked;
    };
    FindInput.prototype.setRegex = function (value) {
        this.regex.checked = value;
        this.setInputWidth();
        this.validate();
    };
    FindInput.prototype.focusOnCaseSensitive = function () {
        this.caseSensitive.focus();
    };
    FindInput.prototype.highlightFindOptions = function () {
        __WEBPACK_IMPORTED_MODULE_2__dom_js__["G" /* removeClass */](this.domNode, 'highlight-' + (this._lastHighlightFindOptions));
        this._lastHighlightFindOptions = 1 - this._lastHighlightFindOptions;
        __WEBPACK_IMPORTED_MODULE_2__dom_js__["f" /* addClass */](this.domNode, 'highlight-' + (this._lastHighlightFindOptions));
    };
    FindInput.prototype.setInputWidth = function () {
        var w = this.width - this.caseSensitive.width() - this.wholeWords.width() - this.regex.width();
        this.inputBox.width = w;
    };
    FindInput.prototype.buildDomNode = function (appendCaseSensitiveLabel, appendWholeWordsLabel, appendRegexLabel, history) {
        var _this = this;
        this.domNode = document.createElement('div');
        this.domNode.style.width = this.width + 'px';
        __WEBPACK_IMPORTED_MODULE_2__dom_js__["f" /* addClass */](this.domNode, 'monaco-findInput');
        this.inputBox = this._register(new __WEBPACK_IMPORTED_MODULE_3__inputbox_inputBox_js__["a" /* HistoryInputBox */](this.domNode, this.contextViewProvider, {
            placeholder: this.placeholder || '',
            ariaLabel: this.label || '',
            validationOptions: {
                validation: this.validation || null
            },
            inputBackground: this.inputBackground,
            inputForeground: this.inputForeground,
            inputBorder: this.inputBorder,
            inputValidationInfoBackground: this.inputValidationInfoBackground,
            inputValidationInfoBorder: this.inputValidationInfoBorder,
            inputValidationWarningBackground: this.inputValidationWarningBackground,
            inputValidationWarningBorder: this.inputValidationWarningBorder,
            inputValidationErrorBackground: this.inputValidationErrorBackground,
            inputValidationErrorBorder: this.inputValidationErrorBorder,
            history: history
        }));
        this.regex = this._register(new __WEBPACK_IMPORTED_MODULE_6__findInputCheckboxes_js__["b" /* RegexCheckbox */]({
            appendTitle: appendRegexLabel,
            isChecked: false,
            inputActiveOptionBorder: this.inputActiveOptionBorder
        }));
        this._register(this.regex.onChange(function (viaKeyboard) {
            _this._onDidOptionChange.fire(viaKeyboard);
            if (!viaKeyboard) {
                _this.inputBox.focus();
            }
            _this.setInputWidth();
            _this.validate();
        }));
        this._register(this.regex.onKeyDown(function (e) {
            _this._onRegexKeyDown.fire(e);
        }));
        this.wholeWords = this._register(new __WEBPACK_IMPORTED_MODULE_6__findInputCheckboxes_js__["c" /* WholeWordsCheckbox */]({
            appendTitle: appendWholeWordsLabel,
            isChecked: false,
            inputActiveOptionBorder: this.inputActiveOptionBorder
        }));
        this._register(this.wholeWords.onChange(function (viaKeyboard) {
            _this._onDidOptionChange.fire(viaKeyboard);
            if (!viaKeyboard) {
                _this.inputBox.focus();
            }
            _this.setInputWidth();
            _this.validate();
        }));
        this.caseSensitive = this._register(new __WEBPACK_IMPORTED_MODULE_6__findInputCheckboxes_js__["a" /* CaseSensitiveCheckbox */]({
            appendTitle: appendCaseSensitiveLabel,
            isChecked: false,
            inputActiveOptionBorder: this.inputActiveOptionBorder
        }));
        this._register(this.caseSensitive.onChange(function (viaKeyboard) {
            _this._onDidOptionChange.fire(viaKeyboard);
            if (!viaKeyboard) {
                _this.inputBox.focus();
            }
            _this.setInputWidth();
            _this.validate();
        }));
        this._register(this.caseSensitive.onKeyDown(function (e) {
            _this._onCaseSensitiveKeyDown.fire(e);
        }));
        // Arrow-Key support to navigate between options
        var indexes = [this.caseSensitive.domNode, this.wholeWords.domNode, this.regex.domNode];
        this.onkeydown(this.domNode, function (event) {
            if (event.equals(15 /* LeftArrow */) || event.equals(17 /* RightArrow */) || event.equals(9 /* Escape */)) {
                var index = indexes.indexOf(document.activeElement);
                if (index >= 0) {
                    var newIndex = void 0;
                    if (event.equals(17 /* RightArrow */)) {
                        newIndex = (index + 1) % indexes.length;
                    }
                    else if (event.equals(15 /* LeftArrow */)) {
                        if (index === 0) {
                            newIndex = indexes.length - 1;
                        }
                        else {
                            newIndex = index - 1;
                        }
                    }
                    if (event.equals(9 /* Escape */)) {
                        indexes[index].blur();
                    }
                    else if (newIndex >= 0) {
                        indexes[newIndex].focus();
                    }
                    __WEBPACK_IMPORTED_MODULE_2__dom_js__["c" /* EventHelper */].stop(event, true);
                }
            }
        });
        this.setInputWidth();
        var controls = document.createElement('div');
        controls.className = 'controls';
        controls.appendChild(this.caseSensitive.domNode);
        controls.appendChild(this.wholeWords.domNode);
        controls.appendChild(this.regex.domNode);
        this.domNode.appendChild(controls);
    };
    FindInput.prototype.validate = function () {
        this.inputBox.validate();
    };
    FindInput.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    return FindInput;
}(__WEBPACK_IMPORTED_MODULE_4__widget_js__["a" /* Widget */]));



/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_css__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_objects_js__ = __webpack_require__(26);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var defaultOpts = {
    inputActiveOptionBorder: __WEBPACK_IMPORTED_MODULE_3__common_color_js__["a" /* Color */].fromHex('#007ACC')
};
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(opts) {
        var _this = _super.call(this) || this;
        _this._onChange = _this._register(new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]());
        _this._onKeyDown = _this._register(new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]());
        _this._opts = __WEBPACK_IMPORTED_MODULE_5__common_objects_js__["c" /* deepClone */](opts);
        __WEBPACK_IMPORTED_MODULE_5__common_objects_js__["g" /* mixin */](_this._opts, defaultOpts, false);
        _this._checked = _this._opts.isChecked;
        _this.domNode = document.createElement('div');
        _this.domNode.title = _this._opts.title;
        _this.domNode.className = 'monaco-custom-checkbox ' + _this._opts.actionClassName + ' ' + (_this._checked ? 'checked' : 'unchecked');
        _this.domNode.tabIndex = 0;
        _this.domNode.setAttribute('role', 'checkbox');
        _this.domNode.setAttribute('aria-checked', String(_this._checked));
        _this.domNode.setAttribute('aria-label', _this._opts.title);
        _this.applyStyles();
        _this.onclick(_this.domNode, function (ev) {
            _this.checked = !_this._checked;
            _this._onChange.fire(false);
            ev.preventDefault();
        });
        _this.onkeydown(_this.domNode, function (keyboardEvent) {
            if (keyboardEvent.keyCode === 10 /* Space */ || keyboardEvent.keyCode === 3 /* Enter */) {
                _this.checked = !_this._checked;
                _this._onChange.fire(true);
                keyboardEvent.preventDefault();
                return;
            }
            _this._onKeyDown.fire(keyboardEvent);
        });
        return _this;
    }
    Object.defineProperty(Checkbox.prototype, "onChange", {
        get: function () { return this._onChange.event; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "onKeyDown", {
        get: function () { return this._onKeyDown.event; },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.focus = function () {
        this.domNode.focus();
    };
    Object.defineProperty(Checkbox.prototype, "checked", {
        get: function () {
            return this._checked;
        },
        set: function (newIsChecked) {
            this._checked = newIsChecked;
            this.domNode.setAttribute('aria-checked', String(this._checked));
            if (this._checked) {
                this.domNode.classList.add('checked');
            }
            else {
                this.domNode.classList.remove('checked');
            }
            this.applyStyles();
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.width = function () {
        return 2 /*marginleft*/ + 2 /*border*/ + 2 /*padding*/ + 16 /* icon width */;
    };
    Checkbox.prototype.style = function (styles) {
        if (styles.inputActiveOptionBorder) {
            this._opts.inputActiveOptionBorder = styles.inputActiveOptionBorder;
        }
        this.applyStyles();
    };
    Checkbox.prototype.applyStyles = function () {
        if (this.domNode) {
            this.domNode.style.borderColor = this._checked && this._opts.inputActiveOptionBorder ? this._opts.inputActiveOptionBorder.toString() : 'transparent';
        }
    };
    Checkbox.prototype.enable = function () {
        this.domNode.tabIndex = 0;
        this.domNode.setAttribute('aria-disabled', String(false));
    };
    Checkbox.prototype.disable = function () {
        __WEBPACK_IMPORTED_MODULE_1__dom_js__["H" /* removeTabIndexAndUpdateFocus */](this.domNode);
        this.domNode.setAttribute('aria-disabled', String(true));
    };
    return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_2__widget_js__["a" /* Widget */]));



/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindContextScopedWidget;
/* harmony export (immutable) */ __webpack_exports__["b"] = createWidgetScopedContextKeyService;
/* harmony export (immutable) */ __webpack_exports__["c"] = getContextScopedWidget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__ = __webpack_require__(16);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


function bindContextScopedWidget(contextKeyService, widget, contextKey) {
    new __WEBPACK_IMPORTED_MODULE_0__contextkey_common_contextkey_js__["f" /* RawContextKey */](contextKey, widget).bindTo(contextKeyService);
}
function createWidgetScopedContextKeyService(contextKeyService, widget) {
    return contextKeyService.createScoped(widget.target);
}
function getContextScopedWidget(contextKeyService, contextKey) {
    return contextKeyService.getContext(document.activeElement).getValue(contextKey);
}


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindOptionsWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_ui_widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findModel_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_findinput_findInputCheckboxes_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var FindOptionsWidget = /** @class */ (function (_super) {
    __extends(FindOptionsWidget, _super);
    function FindOptionsWidget(editor, state, keybindingService, themeService) {
        var _this = _super.call(this) || this;
        _this._hideSoon = _this._register(new __WEBPACK_IMPORTED_MODULE_5__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._hide(); }, 2000));
        _this._isVisible = false;
        _this._editor = editor;
        _this._state = state;
        _this._keybindingService = keybindingService;
        _this._domNode = document.createElement('div');
        _this._domNode.className = 'findOptionsWidget';
        _this._domNode.style.display = 'none';
        _this._domNode.style.top = '10px';
        _this._domNode.setAttribute('role', 'presentation');
        _this._domNode.setAttribute('aria-hidden', 'true');
        var inputActiveOptionBorderColor = themeService.getTheme().getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["J" /* inputActiveOptionBorder */]);
        _this.caseSensitive = _this._register(new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_findinput_findInputCheckboxes_js__["a" /* CaseSensitiveCheckbox */]({
            appendTitle: _this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_3__findModel_js__["d" /* FIND_IDS */].ToggleCaseSensitiveCommand),
            isChecked: _this._state.matchCase,
            inputActiveOptionBorder: inputActiveOptionBorderColor
        }));
        _this._domNode.appendChild(_this.caseSensitive.domNode);
        _this._register(_this.caseSensitive.onChange(function () {
            _this._state.change({
                matchCase: _this.caseSensitive.checked
            }, false);
        }));
        _this.wholeWords = _this._register(new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_findinput_findInputCheckboxes_js__["c" /* WholeWordsCheckbox */]({
            appendTitle: _this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_3__findModel_js__["d" /* FIND_IDS */].ToggleWholeWordCommand),
            isChecked: _this._state.wholeWord,
            inputActiveOptionBorder: inputActiveOptionBorderColor
        }));
        _this._domNode.appendChild(_this.wholeWords.domNode);
        _this._register(_this.wholeWords.onChange(function () {
            _this._state.change({
                wholeWord: _this.wholeWords.checked
            }, false);
        }));
        _this.regex = _this._register(new __WEBPACK_IMPORTED_MODULE_4__base_browser_ui_findinput_findInputCheckboxes_js__["b" /* RegexCheckbox */]({
            appendTitle: _this._keybindingLabelFor(__WEBPACK_IMPORTED_MODULE_3__findModel_js__["d" /* FIND_IDS */].ToggleRegexCommand),
            isChecked: _this._state.isRegex,
            inputActiveOptionBorder: inputActiveOptionBorderColor
        }));
        _this._domNode.appendChild(_this.regex.domNode);
        _this._register(_this.regex.onChange(function () {
            _this._state.change({
                isRegex: _this.regex.checked
            }, false);
        }));
        _this._editor.addOverlayWidget(_this);
        _this._register(_this._state.onFindReplaceStateChange(function (e) {
            var somethingChanged = false;
            if (e.isRegex) {
                _this.regex.checked = _this._state.isRegex;
                somethingChanged = true;
            }
            if (e.wholeWord) {
                _this.wholeWords.checked = _this._state.wholeWord;
                somethingChanged = true;
            }
            if (e.matchCase) {
                _this.caseSensitive.checked = _this._state.matchCase;
                somethingChanged = true;
            }
            if (!_this._state.isRevealed && somethingChanged) {
                _this._revealTemporarily();
            }
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["h" /* addDisposableNonBubblingMouseOutListener */](_this._domNode, function (e) { return _this._onMouseOut(); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](_this._domNode, 'mouseover', function (e) { return _this._onMouseOver(); }));
        _this._applyTheme(themeService.getTheme());
        _this._register(themeService.onThemeChange(_this._applyTheme.bind(_this)));
        return _this;
    }
    FindOptionsWidget.prototype._keybindingLabelFor = function (actionId) {
        var kb = this._keybindingService.lookupKeybinding(actionId);
        if (!kb) {
            return '';
        }
        return " (" + kb.getLabel() + ")";
    };
    FindOptionsWidget.prototype.dispose = function () {
        this._editor.removeOverlayWidget(this);
        _super.prototype.dispose.call(this);
    };
    // ----- IOverlayWidget API
    FindOptionsWidget.prototype.getId = function () {
        return FindOptionsWidget.ID;
    };
    FindOptionsWidget.prototype.getDomNode = function () {
        return this._domNode;
    };
    FindOptionsWidget.prototype.getPosition = function () {
        return {
            preference: __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__["c" /* OverlayWidgetPositionPreference */].TOP_RIGHT_CORNER
        };
    };
    FindOptionsWidget.prototype.highlightFindOptions = function () {
        this._revealTemporarily();
    };
    FindOptionsWidget.prototype._revealTemporarily = function () {
        this._show();
        this._hideSoon.schedule();
    };
    FindOptionsWidget.prototype._onMouseOut = function () {
        this._hideSoon.schedule();
    };
    FindOptionsWidget.prototype._onMouseOver = function () {
        this._hideSoon.cancel();
    };
    FindOptionsWidget.prototype._show = function () {
        if (this._isVisible) {
            return;
        }
        this._isVisible = true;
        this._domNode.style.display = 'block';
    };
    FindOptionsWidget.prototype._hide = function () {
        if (!this._isVisible) {
            return;
        }
        this._isVisible = false;
        this._domNode.style.display = 'none';
    };
    FindOptionsWidget.prototype._applyTheme = function (theme) {
        var inputStyles = { inputActiveOptionBorder: theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["J" /* inputActiveOptionBorder */]) };
        this.caseSensitive.style(inputStyles);
        this.wholeWords.style(inputStyles);
        this.regex.style(inputStyles);
    };
    FindOptionsWidget.ID = 'editor.contrib.findOptionsWidget';
    return FindOptionsWidget;
}(__WEBPACK_IMPORTED_MODULE_1__base_browser_ui_widget_js__["a" /* Widget */]));

Object(__WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var widgetBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["D" /* editorWidgetBackground */]);
    if (widgetBackground) {
        collector.addRule(".monaco-editor .findOptionsWidget { background-color: " + widgetBackground + "; }");
    }
    var widgetShadowColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_17" /* widgetShadow */]);
    if (widgetShadowColor) {
        collector.addRule(".monaco-editor .findOptionsWidget { box-shadow: 0 2px 8px " + widgetShadowColor + "; }");
    }
    var hcBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["e" /* contrastBorder */]);
    if (hcBorder) {
        collector.addRule(".monaco-editor .findOptionsWidget { border: 2px solid " + hcBorder + "; }");
    }
});


/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FoldingModel; });
/* harmony export (immutable) */ __webpack_exports__["e"] = setCollapseStateLevelsDown;
/* harmony export (immutable) */ __webpack_exports__["f"] = setCollapseStateLevelsUp;
/* harmony export (immutable) */ __webpack_exports__["b"] = setCollapseStateAtLevel;
/* harmony export (immutable) */ __webpack_exports__["c"] = setCollapseStateForMatchingLines;
/* harmony export (immutable) */ __webpack_exports__["d"] = setCollapseStateForType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__foldingRanges_js__ = __webpack_require__(141);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var FoldingModel = /** @class */ (function () {
    function FoldingModel(textModel, decorationProvider) {
        this._updateEventEmitter = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this._textModel = textModel;
        this._decorationProvider = decorationProvider;
        this._regions = new __WEBPACK_IMPORTED_MODULE_1__foldingRanges_js__["a" /* FoldingRegions */](new Uint32Array(0), new Uint32Array(0));
        this._editorDecorationIds = [];
        this._isInitialized = false;
    }
    Object.defineProperty(FoldingModel.prototype, "regions", {
        get: function () { return this._regions; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FoldingModel.prototype, "onDidChange", {
        get: function () { return this._updateEventEmitter.event; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FoldingModel.prototype, "textModel", {
        get: function () { return this._textModel; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FoldingModel.prototype, "isInitialized", {
        get: function () { return this._isInitialized; },
        enumerable: true,
        configurable: true
    });
    FoldingModel.prototype.toggleCollapseState = function (regions) {
        var _this = this;
        if (!regions.length) {
            return;
        }
        var processed = {};
        this._decorationProvider.changeDecorations(function (accessor) {
            for (var _i = 0, regions_1 = regions; _i < regions_1.length; _i++) {
                var region = regions_1[_i];
                var index = region.regionIndex;
                var editorDecorationId = _this._editorDecorationIds[index];
                if (editorDecorationId && !processed[editorDecorationId]) {
                    processed[editorDecorationId] = true;
                    var newCollapseState = !_this._regions.isCollapsed(index);
                    _this._regions.setCollapsed(index, newCollapseState);
                    accessor.changeDecorationOptions(editorDecorationId, _this._decorationProvider.getDecorationOption(newCollapseState));
                }
            }
        });
        this._updateEventEmitter.fire({ model: this, collapseStateChanged: regions });
    };
    FoldingModel.prototype.update = function (newRegions, blockedLineNumers) {
        var _this = this;
        if (blockedLineNumers === void 0) { blockedLineNumers = []; }
        var newEditorDecorations = [];
        var isBlocked = function (startLineNumber, endLineNumber) {
            for (var _i = 0, blockedLineNumers_1 = blockedLineNumers; _i < blockedLineNumers_1.length; _i++) {
                var blockedLineNumber = blockedLineNumers_1[_i];
                if (startLineNumber < blockedLineNumber && blockedLineNumber <= endLineNumber) { // first line is visible
                    return true;
                }
            }
            return false;
        };
        var initRange = function (index, isCollapsed) {
            var startLineNumber = newRegions.getStartLineNumber(index);
            if (isCollapsed && isBlocked(startLineNumber, newRegions.getEndLineNumber(index))) {
                isCollapsed = false;
            }
            newRegions.setCollapsed(index, isCollapsed);
            var maxColumn = _this._textModel.getLineMaxColumn(startLineNumber);
            var decorationRange = {
                startLineNumber: startLineNumber,
                startColumn: maxColumn,
                endLineNumber: startLineNumber,
                endColumn: maxColumn
            };
            newEditorDecorations.push({ range: decorationRange, options: _this._decorationProvider.getDecorationOption(isCollapsed) });
        };
        var i = 0;
        var nextCollapsed = function () {
            while (i < _this._regions.length) {
                var isCollapsed = _this._regions.isCollapsed(i);
                i++;
                if (isCollapsed) {
                    return i - 1;
                }
            }
            return -1;
        };
        var k = 0;
        var collapsedIndex = nextCollapsed();
        while (collapsedIndex !== -1 && k < newRegions.length) {
            // get the latest range
            var decRange = this._textModel.getDecorationRange(this._editorDecorationIds[collapsedIndex]);
            if (decRange) {
                var collapsedStartLineNumber = decRange.startLineNumber;
                if (this._textModel.getLineMaxColumn(collapsedStartLineNumber) === decRange.startColumn) { // test that the decoration is still at the end otherwise it got deleted
                    while (k < newRegions.length) {
                        var startLineNumber = newRegions.getStartLineNumber(k);
                        if (collapsedStartLineNumber >= startLineNumber) {
                            initRange(k, collapsedStartLineNumber === startLineNumber);
                            k++;
                        }
                        else {
                            break;
                        }
                    }
                }
            }
            collapsedIndex = nextCollapsed();
        }
        while (k < newRegions.length) {
            initRange(k, false);
            k++;
        }
        this._editorDecorationIds = this._decorationProvider.deltaDecorations(this._editorDecorationIds, newEditorDecorations);
        this._regions = newRegions;
        this._isInitialized = true;
        this._updateEventEmitter.fire({ model: this });
    };
    /**
     * Collapse state memento, for persistence only
     */
    FoldingModel.prototype.getMemento = function () {
        var collapsedRanges = [];
        for (var i = 0; i < this._regions.length; i++) {
            if (this._regions.isCollapsed(i)) {
                var range = this._textModel.getDecorationRange(this._editorDecorationIds[i]);
                if (range) {
                    var startLineNumber = range.startLineNumber;
                    var endLineNumber = range.endLineNumber + this._regions.getEndLineNumber(i) - this._regions.getStartLineNumber(i);
                    collapsedRanges.push({ startLineNumber: startLineNumber, endLineNumber: endLineNumber });
                }
            }
        }
        if (collapsedRanges.length > 0) {
            return collapsedRanges;
        }
        return null;
    };
    /**
     * Apply persisted state, for persistence only
     */
    FoldingModel.prototype.applyMemento = function (state) {
        if (!Array.isArray(state)) {
            return;
        }
        var toToogle = [];
        for (var _i = 0, state_1 = state; _i < state_1.length; _i++) {
            var range = state_1[_i];
            var region = this.getRegionAtLine(range.startLineNumber);
            if (region && !region.isCollapsed) {
                toToogle.push(region);
            }
        }
        this.toggleCollapseState(toToogle);
    };
    FoldingModel.prototype.dispose = function () {
        this._decorationProvider.deltaDecorations(this._editorDecorationIds, []);
    };
    FoldingModel.prototype.getAllRegionsAtLine = function (lineNumber, filter) {
        var result = [];
        if (this._regions) {
            var index = this._regions.findRange(lineNumber);
            var level = 1;
            while (index >= 0) {
                var current = this._regions.toRegion(index);
                if (!filter || filter(current, level)) {
                    result.push(current);
                }
                level++;
                index = current.parentIndex;
            }
        }
        return result;
    };
    FoldingModel.prototype.getRegionAtLine = function (lineNumber) {
        if (this._regions) {
            var index = this._regions.findRange(lineNumber);
            if (index >= 0) {
                return this._regions.toRegion(index);
            }
        }
        return null;
    };
    FoldingModel.prototype.getRegionsInside = function (region, filter) {
        var result = [];
        var trackLevel = filter && filter.length === 2;
        var levelStack = trackLevel ? [] : null;
        var index = region ? region.regionIndex + 1 : 0;
        var endLineNumber = region ? region.endLineNumber : Number.MAX_VALUE;
        for (var i = index, len = this._regions.length; i < len; i++) {
            var current = this._regions.toRegion(i);
            if (this._regions.getStartLineNumber(i) < endLineNumber) {
                if (trackLevel) {
                    while (levelStack.length > 0 && !current.containedBy(levelStack[levelStack.length - 1])) {
                        levelStack.pop();
                    }
                    levelStack.push(current);
                    if (filter(current, levelStack.length)) {
                        result.push(current);
                    }
                }
                else if (!filter || filter(current)) {
                    result.push(current);
                }
            }
            else {
                break;
            }
        }
        return result;
    };
    return FoldingModel;
}());

/**
 * Collapse or expand the regions at the given locations including all children.
 * @param doCollapse Wheter to collase or expand
 * @param levels The number of levels. Use 1 to only impact the regions at the location, use Number.MAX_VALUE for all levels.
 * @param lineNumbers the location of the regions to collapse or expand, or if not set, all regions in the model.
 */
function setCollapseStateLevelsDown(foldingModel, doCollapse, levels, lineNumbers) {
    if (levels === void 0) { levels = Number.MAX_VALUE; }
    var toToggle = [];
    if (lineNumbers && lineNumbers.length > 0) {
        for (var _i = 0, lineNumbers_1 = lineNumbers; _i < lineNumbers_1.length; _i++) {
            var lineNumber = lineNumbers_1[_i];
            var region = foldingModel.getRegionAtLine(lineNumber);
            if (region) {
                if (region.isCollapsed !== doCollapse) {
                    toToggle.push(region);
                }
                if (levels > 1) {
                    var regionsInside = foldingModel.getRegionsInside(region, function (r, level) { return r.isCollapsed !== doCollapse && level < levels; });
                    toToggle.push.apply(toToggle, regionsInside);
                }
            }
        }
    }
    else {
        var regionsInside = foldingModel.getRegionsInside(null, function (r, level) { return r.isCollapsed !== doCollapse && level < levels; });
        toToggle.push.apply(toToggle, regionsInside);
    }
    foldingModel.toggleCollapseState(toToggle);
}
/**
 * Collapse or expand the regions at the given locations including all parents.
 * @param doCollapse Wheter to collase or expand
 * @param levels The number of levels. Use 1 to only impact the regions at the location, use Number.MAX_VALUE for all levels.
 * @param lineNumbers the location of the regions to collapse or expand, or if not set, all regions in the model.
 */
function setCollapseStateLevelsUp(foldingModel, doCollapse, levels, lineNumbers) {
    var toToggle = [];
    for (var _i = 0, lineNumbers_2 = lineNumbers; _i < lineNumbers_2.length; _i++) {
        var lineNumber = lineNumbers_2[_i];
        var regions = foldingModel.getAllRegionsAtLine(lineNumber, function (region, level) { return region.isCollapsed !== doCollapse && level <= levels; });
        toToggle.push.apply(toToggle, regions);
    }
    foldingModel.toggleCollapseState(toToggle);
}
/**
 * Folds or unfolds all regions that have a given level, except if they contain one of the blocked lines.
 * @param foldLevel level. Level == 1 is the top level
 * @param doCollapse Wheter to collase or expand
* @param blockedLineNumbers
*/
function setCollapseStateAtLevel(foldingModel, foldLevel, doCollapse, blockedLineNumbers) {
    var filter = function (region, level) { return level === foldLevel && region.isCollapsed !== doCollapse && !blockedLineNumbers.some(function (line) { return region.containsLine(line); }); };
    var toToggle = foldingModel.getRegionsInside(null, filter);
    foldingModel.toggleCollapseState(toToggle);
}
/**
 * Folds all regions for which the lines start with a given regex
 * @param foldingModel the folding model
 */
function setCollapseStateForMatchingLines(foldingModel, regExp, doCollapse) {
    var editorModel = foldingModel.textModel;
    var regions = foldingModel.regions;
    var toToggle = [];
    for (var i = regions.length - 1; i >= 0; i--) {
        if (doCollapse !== regions.isCollapsed(i)) {
            var startLineNumber = regions.getStartLineNumber(i);
            if (regExp.test(editorModel.getLineContent(startLineNumber))) {
                toToggle.push(regions.toRegion(i));
            }
        }
    }
    foldingModel.toggleCollapseState(toToggle);
}
/**
 * Folds all regions of the given type
 * @param foldingModel the folding model
 */
function setCollapseStateForType(foldingModel, type, doCollapse) {
    var regions = foldingModel.regions;
    var toToggle = [];
    for (var i = regions.length - 1; i >= 0; i--) {
        if (doCollapse !== regions.isCollapsed(i) && type === regions.getType(i)) {
            toToggle.push(regions.toRegion(i));
        }
    }
    foldingModel.toggleCollapseState(toToggle);
}


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FoldingDecorationProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__ = __webpack_require__(27);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var FoldingDecorationProvider = /** @class */ (function () {
    function FoldingDecorationProvider(editor) {
        this.editor = editor;
        this.autoHideFoldingControls = true;
    }
    FoldingDecorationProvider.prototype.getDecorationOption = function (isCollapsed) {
        if (isCollapsed) {
            return FoldingDecorationProvider.COLLAPSED_VISUAL_DECORATION;
        }
        else if (this.autoHideFoldingControls) {
            return FoldingDecorationProvider.EXPANDED_AUTO_HIDE_VISUAL_DECORATION;
        }
        else {
            return FoldingDecorationProvider.EXPANDED_VISUAL_DECORATION;
        }
    };
    FoldingDecorationProvider.prototype.deltaDecorations = function (oldDecorations, newDecorations) {
        return this.editor.deltaDecorations(oldDecorations, newDecorations);
    };
    FoldingDecorationProvider.prototype.changeDecorations = function (callback) {
        return this.editor.changeDecorations(callback);
    };
    FoldingDecorationProvider.COLLAPSED_VISUAL_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_0__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        afterContentClassName: 'inline-folded',
        linesDecorationsClassName: 'folding collapsed'
    });
    FoldingDecorationProvider.EXPANDED_AUTO_HIDE_VISUAL_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_0__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        linesDecorationsClassName: 'folding'
    });
    FoldingDecorationProvider.EXPANDED_VISUAL_DECORATION = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        stickiness: __WEBPACK_IMPORTED_MODULE_0__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
        linesDecorationsClassName: 'folding alwaysShowFoldIcons'
    });
    return FoldingDecorationProvider;
}());



/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HiddenRangeModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_arrays_js__ = __webpack_require__(22);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var HiddenRangeModel = /** @class */ (function () {
    function HiddenRangeModel(model) {
        var _this = this;
        this._updateEventEmitter = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this._foldingModel = model;
        this._foldingModelListener = model.onDidChange(function (_) { return _this.updateHiddenRanges(); });
        this._hiddenRanges = [];
        if (model.regions.length) {
            this.updateHiddenRanges();
        }
    }
    Object.defineProperty(HiddenRangeModel.prototype, "onDidChange", {
        get: function () { return this._updateEventEmitter.event; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HiddenRangeModel.prototype, "hiddenRanges", {
        get: function () { return this._hiddenRanges; },
        enumerable: true,
        configurable: true
    });
    HiddenRangeModel.prototype.updateHiddenRanges = function () {
        var updateHiddenAreas = false;
        var newHiddenAreas = [];
        var i = 0; // index into hidden
        var k = 0;
        var lastCollapsedStart = Number.MAX_VALUE;
        var lastCollapsedEnd = -1;
        var ranges = this._foldingModel.regions;
        for (; i < ranges.length; i++) {
            if (!ranges.isCollapsed(i)) {
                continue;
            }
            var startLineNumber = ranges.getStartLineNumber(i) + 1; // the first line is not hidden
            var endLineNumber = ranges.getEndLineNumber(i);
            if (lastCollapsedStart <= startLineNumber && endLineNumber <= lastCollapsedEnd) {
                // ignore ranges contained in collapsed regions
                continue;
            }
            if (!updateHiddenAreas && k < this._hiddenRanges.length && this._hiddenRanges[k].startLineNumber === startLineNumber && this._hiddenRanges[k].endLineNumber === endLineNumber) {
                // reuse the old ranges
                newHiddenAreas.push(this._hiddenRanges[k]);
                k++;
            }
            else {
                updateHiddenAreas = true;
                newHiddenAreas.push(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](startLineNumber, 1, endLineNumber, 1));
            }
            lastCollapsedStart = startLineNumber;
            lastCollapsedEnd = endLineNumber;
        }
        if (updateHiddenAreas || k < this._hiddenRanges.length) {
            this.applyHiddenRanges(newHiddenAreas);
        }
    };
    HiddenRangeModel.prototype.applyMemento = function (state) {
        if (!Array.isArray(state) || state.length === 0) {
            return false;
        }
        var hiddenRanges = [];
        for (var _i = 0, state_1 = state; _i < state_1.length; _i++) {
            var r = state_1[_i];
            if (!r.startLineNumber || !r.endLineNumber) {
                return false;
            }
            hiddenRanges.push(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](r.startLineNumber + 1, 1, r.endLineNumber, 1));
        }
        this.applyHiddenRanges(hiddenRanges);
        return true;
    };
    /**
     * Collapse state memento, for persistence only, only used if folding model is not yet initialized
     */
    HiddenRangeModel.prototype.getMemento = function () {
        return this._hiddenRanges.map(function (r) { return ({ startLineNumber: r.startLineNumber - 1, endLineNumber: r.endLineNumber }); });
    };
    HiddenRangeModel.prototype.applyHiddenRanges = function (newHiddenAreas) {
        this._hiddenRanges = newHiddenAreas;
        this._updateEventEmitter.fire(newHiddenAreas);
    };
    HiddenRangeModel.prototype.hasRanges = function () {
        return this._hiddenRanges.length > 0;
    };
    HiddenRangeModel.prototype.isHidden = function (line) {
        return findRange(this._hiddenRanges, line) !== null;
    };
    HiddenRangeModel.prototype.adjustSelections = function (selections) {
        var _this = this;
        var hasChanges = false;
        var editorModel = this._foldingModel.textModel;
        var lastRange = null;
        var adjustLine = function (line) {
            if (!lastRange || !isInside(line, lastRange)) {
                lastRange = findRange(_this._hiddenRanges, line);
            }
            if (lastRange) {
                return lastRange.startLineNumber - 1;
            }
            return null;
        };
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            var adjustedStartLine = adjustLine(selection.startLineNumber);
            if (adjustedStartLine) {
                selection = selection.setStartPosition(adjustedStartLine, editorModel.getLineMaxColumn(adjustedStartLine));
                hasChanges = true;
            }
            var adjustedEndLine = adjustLine(selection.endLineNumber);
            if (adjustedEndLine) {
                selection = selection.setEndPosition(adjustedEndLine, editorModel.getLineMaxColumn(adjustedEndLine));
                hasChanges = true;
            }
            selections[i] = selection;
        }
        return hasChanges;
    };
    HiddenRangeModel.prototype.dispose = function () {
        if (this.hiddenRanges.length > 0) {
            this._hiddenRanges = [];
            this._updateEventEmitter.fire(this._hiddenRanges);
        }
        if (this._foldingModelListener) {
            this._foldingModelListener.dispose();
            this._foldingModelListener = null;
        }
    };
    return HiddenRangeModel;
}());

function isInside(line, range) {
    return line >= range.startLineNumber && line <= range.endLineNumber;
}
function findRange(ranges, line) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_arrays_js__["f" /* findFirstInSorted */])(ranges, function (r) { return line < r.startLineNumber; }) - 1;
    if (i >= 0 && ranges[i].endLineNumber >= line) {
        return ranges[i];
    }
    return null;
}


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ID_INDENT_PROVIDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndentRangeProvider; });
/* unused harmony export RangesCollector */
/* unused harmony export computeRanges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__foldingRanges_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var MAX_FOLDING_REGIONS_FOR_INDENT_LIMIT = 5000;
var ID_INDENT_PROVIDER = 'indent';
var IndentRangeProvider = /** @class */ (function () {
    function IndentRangeProvider(editorModel) {
        this.editorModel = editorModel;
        this.id = ID_INDENT_PROVIDER;
    }
    IndentRangeProvider.prototype.dispose = function () {
    };
    IndentRangeProvider.prototype.compute = function (cancelationToken) {
        var foldingRules = __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getFoldingRules(this.editorModel.getLanguageIdentifier().id);
        var offSide = foldingRules && foldingRules.offSide;
        var markers = foldingRules && foldingRules.markers;
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(computeRanges(this.editorModel, offSide, markers));
    };
    return IndentRangeProvider;
}());

// public only for testing
var RangesCollector = /** @class */ (function () {
    function RangesCollector(foldingRangesLimit) {
        this._startIndexes = [];
        this._endIndexes = [];
        this._indentOccurrences = [];
        this._length = 0;
        this._foldingRangesLimit = foldingRangesLimit;
    }
    RangesCollector.prototype.insertFirst = function (startLineNumber, endLineNumber, indent) {
        if (startLineNumber > __WEBPACK_IMPORTED_MODULE_0__foldingRanges_js__["b" /* MAX_LINE_NUMBER */] || endLineNumber > __WEBPACK_IMPORTED_MODULE_0__foldingRanges_js__["b" /* MAX_LINE_NUMBER */]) {
            return;
        }
        var index = this._length;
        this._startIndexes[index] = startLineNumber;
        this._endIndexes[index] = endLineNumber;
        this._length++;
        if (indent < 1000) {
            this._indentOccurrences[indent] = (this._indentOccurrences[indent] || 0) + 1;
        }
    };
    RangesCollector.prototype.toIndentRanges = function (model) {
        if (this._length <= this._foldingRangesLimit) {
            // reverse and create arrays of the exact length
            var startIndexes = new Uint32Array(this._length);
            var endIndexes = new Uint32Array(this._length);
            for (var i = this._length - 1, k = 0; i >= 0; i--, k++) {
                startIndexes[k] = this._startIndexes[i];
                endIndexes[k] = this._endIndexes[i];
            }
            return new __WEBPACK_IMPORTED_MODULE_0__foldingRanges_js__["a" /* FoldingRegions */](startIndexes, endIndexes);
        }
        else {
            var entries = 0;
            var maxIndent = this._indentOccurrences.length;
            for (var i = 0; i < this._indentOccurrences.length; i++) {
                var n = this._indentOccurrences[i];
                if (n) {
                    if (n + entries > this._foldingRangesLimit) {
                        maxIndent = i;
                        break;
                    }
                    entries += n;
                }
            }
            var tabSize = model.getOptions().tabSize;
            // reverse and create arrays of the exact length
            var startIndexes = new Uint32Array(this._foldingRangesLimit);
            var endIndexes = new Uint32Array(this._foldingRangesLimit);
            for (var i = this._length - 1, k = 0; i >= 0; i--) {
                var startIndex = this._startIndexes[i];
                var lineContent = model.getLineContent(startIndex);
                var indent = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["b" /* TextModel */].computeIndentLevel(lineContent, tabSize);
                if (indent < maxIndent || (indent === maxIndent && entries++ < this._foldingRangesLimit)) {
                    startIndexes[k] = startIndex;
                    endIndexes[k] = this._endIndexes[i];
                    k++;
                }
            }
            return new __WEBPACK_IMPORTED_MODULE_0__foldingRanges_js__["a" /* FoldingRegions */](startIndexes, endIndexes);
        }
    };
    return RangesCollector;
}());

function computeRanges(model, offSide, markers, foldingRangesLimit) {
    if (foldingRangesLimit === void 0) { foldingRangesLimit = MAX_FOLDING_REGIONS_FOR_INDENT_LIMIT; }
    var tabSize = model.getOptions().tabSize;
    var result = new RangesCollector(foldingRangesLimit);
    var pattern = void 0;
    if (markers) {
        pattern = new RegExp("(" + markers.start.source + ")|(?:" + markers.end.source + ")");
    }
    var previousRegions = [];
    previousRegions.push({ indent: -1, line: model.getLineCount() + 1, marker: false }); // sentinel, to make sure there's at least one entry
    for (var line = model.getLineCount(); line > 0; line--) {
        var lineContent = model.getLineContent(line);
        var indent = __WEBPACK_IMPORTED_MODULE_1__common_model_textModel_js__["b" /* TextModel */].computeIndentLevel(lineContent, tabSize);
        var previous = previousRegions[previousRegions.length - 1];
        if (indent === -1) {
            if (offSide && !previous.marker) {
                // for offSide languages, empty lines are associated to the next block
                previous.line = line;
            }
            continue; // only whitespace
        }
        var m = void 0;
        if (pattern && (m = lineContent.match(pattern))) {
            // folding pattern match
            if (m[1]) { // start pattern match
                // discard all regions until the folding pattern
                var i = previousRegions.length - 1;
                while (i > 0 && !previousRegions[i].marker) {
                    i--;
                }
                if (i > 0) {
                    previousRegions.length = i + 1;
                    previous = previousRegions[i];
                    // new folding range from pattern, includes the end line
                    result.insertFirst(line, previous.line, indent);
                    previous.marker = false;
                    previous.indent = indent;
                    previous.line = line;
                    continue;
                }
                else {
                    // no end marker found, treat line as a regular line
                }
            }
            else { // end pattern match
                previousRegions.push({ indent: -2, line: line, marker: true });
                continue;
            }
        }
        if (previous.indent > indent) {
            // discard all regions with larger indent
            do {
                previousRegions.pop();
                previous = previousRegions[previousRegions.length - 1];
            } while (previous.indent > indent);
            // new folding range
            var endLineNumber = previous.line - 1;
            if (endLineNumber - line >= 1) { // needs at east size 1
                result.insertFirst(line, endLineNumber, indent);
            }
        }
        if (previous.indent === indent) {
            previous.line = line;
        }
        else { // previous.indent < indent
            // new region with a bigger indent
            previousRegions.push({ indent: indent, line: line, marker: false });
        }
    }
    return result.toIndentRanges(model);
}


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_INIT_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InitializingRangeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syntaxRangeProvider_js__ = __webpack_require__(261);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var ID_INIT_PROVIDER = 'init';
var InitializingRangeProvider = /** @class */ (function () {
    function InitializingRangeProvider(editorModel, initialRanges, onTimeout, timeoutTime) {
        this.editorModel = editorModel;
        this.id = ID_INIT_PROVIDER;
        if (initialRanges.length) {
            var toDecorationRange = function (range) {
                return {
                    range: {
                        startLineNumber: range.startLineNumber,
                        startColumn: 0,
                        endLineNumber: range.endLineNumber,
                        endColumn: editorModel.getLineLength(range.endLineNumber)
                    },
                    options: {
                        stickiness: __WEBPACK_IMPORTED_MODULE_0__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges
                    }
                };
            };
            this.decorationIds = editorModel.deltaDecorations([], initialRanges.map(toDecorationRange));
            this.timeout = setTimeout(onTimeout, timeoutTime);
        }
    }
    InitializingRangeProvider.prototype.dispose = function () {
        if (this.decorationIds) {
            this.editorModel.deltaDecorations(this.decorationIds, []);
            this.decorationIds = void 0;
        }
        if (typeof this.timeout === 'number') {
            clearTimeout(this.timeout);
            this.timeout = void 0;
        }
    };
    InitializingRangeProvider.prototype.compute = function (cancelationToken) {
        var foldingRangeData = [];
        if (this.decorationIds) {
            for (var _i = 0, _a = this.decorationIds; _i < _a.length; _i++) {
                var id = _a[_i];
                var range = this.editorModel.getDecorationRange(id);
                if (range) {
                    foldingRangeData.push({ start: range.startLineNumber, end: range.endLineNumber, rank: 1 });
                }
            }
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(Object(__WEBPACK_IMPORTED_MODULE_2__syntaxRangeProvider_js__["c" /* sanitizeRanges */])(foldingRangeData, Number.MAX_VALUE));
    };
    return InitializingRangeProvider;
}());



/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoProviderError; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getDocumentRangeFormattingEdits;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDocumentFormattingEdits;
/* harmony export (immutable) */ __webpack_exports__["d"] = getOnTypeFormattingEdits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var NoProviderError = /** @class */ (function (_super) {
    __extends(NoProviderError, _super);
    function NoProviderError(message) {
        var _this = _super.call(this) || this;
        _this.name = NoProviderError.Name;
        _this.message = message;
        return _this;
    }
    NoProviderError.Name = 'NOPRO';
    return NoProviderError;
}(Error));

function getDocumentRangeFormattingEdits(model, range, options) {
    var providers = __WEBPACK_IMPORTED_MODULE_6__common_modes_js__["i" /* DocumentRangeFormattingEditProviderRegistry */].ordered(model);
    if (providers.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new NoProviderError());
    }
    return Object(__WEBPACK_IMPORTED_MODULE_8__base_common_async_js__["j" /* first */])(providers.map(function (provider) { return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_8__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return provider.provideDocumentRangeFormattingEdits(model, range, options, token); })
            .then(undefined, __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
    }; }), function (result) { return !Object(__WEBPACK_IMPORTED_MODULE_2__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(result); });
}
function getDocumentFormattingEdits(model, options) {
    var providers = __WEBPACK_IMPORTED_MODULE_6__common_modes_js__["f" /* DocumentFormattingEditProviderRegistry */].ordered(model);
    // try range formatters when no document formatter is registered
    if (providers.length === 0) {
        return getDocumentRangeFormattingEdits(model, model.getFullModelRange(), options);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_8__base_common_async_js__["j" /* first */])(providers.map(function (provider) { return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_8__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return provider.provideDocumentFormattingEdits(model, options, token); })
            .then(undefined, __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
    }; }), function (result) { return !Object(__WEBPACK_IMPORTED_MODULE_2__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(result); });
}
function getOnTypeFormattingEdits(model, position, ch, options) {
    var support = __WEBPACK_IMPORTED_MODULE_6__common_modes_js__["q" /* OnTypeFormattingEditProviderRegistry */].ordered(model)[0];
    if (!support) {
        return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].as(undefined);
    }
    if (support.autoFormatTriggerCharacters.indexOf(ch) < 0) {
        return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].as(undefined);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_8__base_common_async_js__["h" /* asWinJsPromise */])(function (token) {
        return support.provideOnTypeFormattingEdits(model, position, ch, options, token);
    }).then(function (r) { return r; }, __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
}
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["j" /* registerLanguageCommand */])('_executeFormatRangeProvider', function (accessor, args) {
    var resource = args.resource, range = args.range, options = args.options;
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */]) || !__WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].isIRange(range)) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])();
    }
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
    if (!model) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('resource');
    }
    return getDocumentRangeFormattingEdits(model, __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].lift(range), options);
});
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["j" /* registerLanguageCommand */])('_executeFormatDocumentProvider', function (accessor, args) {
    var resource = args.resource, options = args.options;
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */])) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('resource');
    }
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
    if (!model) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('resource');
    }
    return getDocumentFormattingEdits(model, options);
});
Object(__WEBPACK_IMPORTED_MODULE_5__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeFormatOnTypeProvider', function (model, position, args) {
    var ch = args.ch, options = args.options;
    if (typeof ch !== 'string') {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('ch');
    }
    return getOnTypeFormattingEdits(model, position, ch, options);
});


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattingEdit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var FormattingEdit = /** @class */ (function () {
    function FormattingEdit() {
    }
    FormattingEdit._handleEolEdits = function (editor, edits) {
        var newEol = undefined;
        var singleEdits = [];
        for (var _i = 0, edits_1 = edits; _i < edits_1.length; _i++) {
            var edit = edits_1[_i];
            if (typeof edit.eol === 'number') {
                newEol = edit.eol;
            }
            if (edit.range && typeof edit.text === 'string') {
                singleEdits.push(edit);
            }
        }
        if (typeof newEol === 'number') {
            editor.getModel().pushEOL(newEol);
        }
        return singleEdits;
    };
    FormattingEdit._isFullModelReplaceEdit = function (editor, edit) {
        var model = editor.getModel();
        var editRange = model.validateRange(edit.range);
        var fullModelRange = model.getFullModelRange();
        return fullModelRange.equalsRange(editRange);
    };
    FormattingEdit.execute = function (editor, _edits) {
        editor.pushUndoStop();
        var edits = FormattingEdit._handleEolEdits(editor, _edits);
        if (edits.length === 1 && FormattingEdit._isFullModelReplaceEdit(editor, edits[0])) {
            // We use replace semantics and hope that markers stay put...
            editor.executeEdits('formatEditsCommand', edits.map(function (edit) { return __WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].replace(__WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */].lift(edit.range), edit.text); }));
        }
        else {
            editor.executeEdits('formatEditsCommand', edits.map(function (edit) { return __WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].replaceMove(__WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */].lift(edit.range), edit.text); }));
        }
        editor.pushUndoStop();
    };
    return FormattingEdit;
}());



/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CountBadge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__countBadge_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__countBadge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__countBadge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_objects_js__ = __webpack_require__(26);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var defaultOpts = {
    badgeBackground: __WEBPACK_IMPORTED_MODULE_3__common_color_js__["a" /* Color */].fromHex('#4D4D4D'),
    badgeForeground: __WEBPACK_IMPORTED_MODULE_3__common_color_js__["a" /* Color */].fromHex('#FFFFFF')
};
var CountBadge = /** @class */ (function () {
    function CountBadge(container, options) {
        this.options = options || Object.create(null);
        Object(__WEBPACK_IMPORTED_MODULE_4__common_objects_js__["g" /* mixin */])(this.options, defaultOpts, false);
        this.badgeBackground = this.options.badgeBackground;
        this.badgeForeground = this.options.badgeForeground;
        this.badgeBorder = this.options.badgeBorder;
        this.element = Object(__WEBPACK_IMPORTED_MODULE_1__dom_js__["k" /* append */])(container, Object(__WEBPACK_IMPORTED_MODULE_1__dom_js__["a" /* $ */])('.monaco-count-badge'));
        this.countFormat = this.options.countFormat || '{0}';
        this.titleFormat = this.options.titleFormat || '';
        this.setCount(this.options.count || 0);
    }
    CountBadge.prototype.setCount = function (count) {
        this.count = count;
        this.render();
    };
    CountBadge.prototype.setTitleFormat = function (titleFormat) {
        this.titleFormat = titleFormat;
        this.render();
    };
    CountBadge.prototype.render = function () {
        this.element.textContent = Object(__WEBPACK_IMPORTED_MODULE_2__common_strings_js__["format"])(this.countFormat, this.count);
        this.element.title = Object(__WEBPACK_IMPORTED_MODULE_2__common_strings_js__["format"])(this.titleFormat, this.count);
        this.applyStyles();
    };
    CountBadge.prototype.style = function (styles) {
        this.badgeBackground = styles.badgeBackground;
        this.badgeForeground = styles.badgeForeground;
        this.badgeBorder = styles.badgeBorder;
        this.applyStyles();
    };
    CountBadge.prototype.applyStyles = function () {
        if (this.element) {
            var background = this.badgeBackground ? this.badgeBackground.toString() : null;
            var foreground = this.badgeForeground ? this.badgeForeground.toString() : null;
            var border = this.badgeBorder ? this.badgeBorder.toString() : null;
            this.element.style.backgroundColor = background;
            this.element.style.color = foreground;
            this.element.style.borderWidth = border ? '1px' : null;
            this.element.style.borderStyle = border ? 'solid' : null;
            this.element.style.borderColor = border;
        }
    };
    return CountBadge;
}());



/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderOcticons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function renderOcticons(text) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common_strings_js__["escape"])(text);
}


/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ElementSizeObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ElementSizeObserver = /** @class */ (function (_super) {
    __extends(ElementSizeObserver, _super);
    function ElementSizeObserver(referenceDomElement, changeCallback) {
        var _this = _super.call(this) || this;
        _this.referenceDomElement = referenceDomElement;
        _this.changeCallback = changeCallback;
        _this.measureReferenceDomElementToken = -1;
        _this.width = -1;
        _this.height = -1;
        _this.measureReferenceDomElement(false);
        return _this;
    }
    ElementSizeObserver.prototype.dispose = function () {
        this.stopObserving();
        _super.prototype.dispose.call(this);
    };
    ElementSizeObserver.prototype.getWidth = function () {
        return this.width;
    };
    ElementSizeObserver.prototype.getHeight = function () {
        return this.height;
    };
    ElementSizeObserver.prototype.startObserving = function () {
        var _this = this;
        if (this.measureReferenceDomElementToken === -1) {
            this.measureReferenceDomElementToken = setInterval(function () { return _this.measureReferenceDomElement(true); }, 100);
        }
    };
    ElementSizeObserver.prototype.stopObserving = function () {
        if (this.measureReferenceDomElementToken !== -1) {
            clearInterval(this.measureReferenceDomElementToken);
            this.measureReferenceDomElementToken = -1;
        }
    };
    ElementSizeObserver.prototype.observe = function (dimension) {
        this.measureReferenceDomElement(true, dimension);
    };
    ElementSizeObserver.prototype.measureReferenceDomElement = function (callChangeCallback, dimension) {
        var observedWidth = 0;
        var observedHeight = 0;
        if (dimension) {
            observedWidth = dimension.width;
            observedHeight = dimension.height;
        }
        else if (this.referenceDomElement) {
            observedWidth = this.referenceDomElement.clientWidth;
            observedHeight = this.referenceDomElement.clientHeight;
        }
        observedWidth = Math.max(5, observedWidth);
        observedHeight = Math.max(5, observedHeight);
        if (this.width !== observedWidth || this.height !== observedHeight) {
            this.width = observedWidth;
            this.height = observedHeight;
            if (callChangeCallback) {
                this.changeCallback();
            }
        }
    };
    return ElementSizeObserver;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharWidthRequest; });
/* harmony export (immutable) */ __webpack_exports__["b"] = readCharWidths;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var CharWidthRequest = /** @class */ (function () {
    function CharWidthRequest(chr, type) {
        this.chr = chr;
        this.type = type;
        this.width = 0;
    }
    CharWidthRequest.prototype.fulfill = function (width) {
        this.width = width;
    };
    return CharWidthRequest;
}());

var DomCharWidthReader = /** @class */ (function () {
    function DomCharWidthReader(bareFontInfo, requests) {
        this._bareFontInfo = bareFontInfo;
        this._requests = requests;
        this._container = null;
        this._testElements = null;
    }
    DomCharWidthReader.prototype.read = function () {
        // Create a test container with all these test elements
        this._createDomElements();
        // Add the container to the DOM
        document.body.appendChild(this._container);
        // Read character widths
        this._readFromDomElements();
        // Remove the container from the DOM
        document.body.removeChild(this._container);
        this._container = null;
        this._testElements = null;
    };
    DomCharWidthReader.prototype._createDomElements = function () {
        var container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.top = '-50000px';
        container.style.width = '50000px';
        var regularDomNode = document.createElement('div');
        regularDomNode.style.fontFamily = this._bareFontInfo.fontFamily;
        regularDomNode.style.fontWeight = this._bareFontInfo.fontWeight;
        regularDomNode.style.fontSize = this._bareFontInfo.fontSize + 'px';
        regularDomNode.style.lineHeight = this._bareFontInfo.lineHeight + 'px';
        regularDomNode.style.letterSpacing = this._bareFontInfo.letterSpacing + 'px';
        container.appendChild(regularDomNode);
        var boldDomNode = document.createElement('div');
        boldDomNode.style.fontFamily = this._bareFontInfo.fontFamily;
        boldDomNode.style.fontWeight = 'bold';
        boldDomNode.style.fontSize = this._bareFontInfo.fontSize + 'px';
        boldDomNode.style.lineHeight = this._bareFontInfo.lineHeight + 'px';
        boldDomNode.style.letterSpacing = this._bareFontInfo.letterSpacing + 'px';
        container.appendChild(boldDomNode);
        var italicDomNode = document.createElement('div');
        italicDomNode.style.fontFamily = this._bareFontInfo.fontFamily;
        italicDomNode.style.fontWeight = this._bareFontInfo.fontWeight;
        italicDomNode.style.fontSize = this._bareFontInfo.fontSize + 'px';
        italicDomNode.style.lineHeight = this._bareFontInfo.lineHeight + 'px';
        italicDomNode.style.letterSpacing = this._bareFontInfo.letterSpacing + 'px';
        italicDomNode.style.fontStyle = 'italic';
        container.appendChild(italicDomNode);
        var testElements = [];
        for (var i = 0, len = this._requests.length; i < len; i++) {
            var request = this._requests[i];
            var parent_1 = void 0;
            if (request.type === 0 /* Regular */) {
                parent_1 = regularDomNode;
            }
            if (request.type === 2 /* Bold */) {
                parent_1 = boldDomNode;
            }
            if (request.type === 1 /* Italic */) {
                parent_1 = italicDomNode;
            }
            parent_1.appendChild(document.createElement('br'));
            var testElement = document.createElement('span');
            DomCharWidthReader._render(testElement, request);
            parent_1.appendChild(testElement);
            testElements[i] = testElement;
        }
        this._container = container;
        this._testElements = testElements;
    };
    DomCharWidthReader._render = function (testElement, request) {
        if (request.chr === ' ') {
            var htmlString = '&nbsp;';
            // Repeat character 256 (2^8) times
            for (var i = 0; i < 8; i++) {
                htmlString += htmlString;
            }
            testElement.innerHTML = htmlString;
        }
        else {
            var testString = request.chr;
            // Repeat character 256 (2^8) times
            for (var i = 0; i < 8; i++) {
                testString += testString;
            }
            testElement.textContent = testString;
        }
    };
    DomCharWidthReader.prototype._readFromDomElements = function () {
        for (var i = 0, len = this._requests.length; i < len; i++) {
            var request = this._requests[i];
            var testElement = this._testElements[i];
            request.fulfill(testElement.offsetWidth / 256);
        }
    };
    return DomCharWidthReader;
}());
function readCharWidths(bareFontInfo, requests) {
    var reader = new DomCharWidthReader(bareFontInfo, requests);
    reader.read();
}


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CursorStateChangedEvent */
/* unused harmony export CursorModelState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cursorCollection_js__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editorCommon_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cursorDeleteOperations_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cursorTypeOperations_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_viewEvents_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














function containsLineMappingChanged(events) {
    for (var i = 0, len = events.length; i < len; i++) {
        if (events[i].type === 6 /* ViewLineMappingChanged */) {
            return true;
        }
    }
    return false;
}
var CursorStateChangedEvent = /** @class */ (function () {
    function CursorStateChangedEvent(selections, source, reason) {
        this.selections = selections;
        this.source = source;
        this.reason = reason;
    }
    return CursorStateChangedEvent;
}());

/**
 * A snapshot of the cursor and the model state
 */
var CursorModelState = /** @class */ (function () {
    function CursorModelState(model, cursor) {
        this.modelVersionId = model.getVersionId();
        this.cursorState = cursor.getAll();
    }
    CursorModelState.prototype.equals = function (other) {
        if (!other) {
            return false;
        }
        if (this.modelVersionId !== other.modelVersionId) {
            return false;
        }
        if (this.cursorState.length !== other.cursorState.length) {
            return false;
        }
        for (var i = 0, len = this.cursorState.length; i < len; i++) {
            if (!this.cursorState[i].equals(other.cursorState[i])) {
                return false;
            }
        }
        return true;
    };
    return CursorModelState;
}());

var Cursor = /** @class */ (function (_super) {
    __extends(Cursor, _super);
    function Cursor(configuration, model, viewModel) {
        var _this = _super.call(this) || this;
        _this._onDidReachMaxCursorCount = _this._register(new __WEBPACK_IMPORTED_MODULE_12__base_common_event_js__["a" /* Emitter */]());
        _this.onDidReachMaxCursorCount = _this._onDidReachMaxCursorCount.event;
        _this._onDidAttemptReadOnlyEdit = _this._register(new __WEBPACK_IMPORTED_MODULE_12__base_common_event_js__["a" /* Emitter */]());
        _this.onDidAttemptReadOnlyEdit = _this._onDidAttemptReadOnlyEdit.event;
        _this._onDidChange = _this._register(new __WEBPACK_IMPORTED_MODULE_12__base_common_event_js__["a" /* Emitter */]());
        _this.onDidChange = _this._onDidChange.event;
        _this._configuration = configuration;
        _this._model = model;
        _this._knownModelVersionId = _this._model.getVersionId();
        _this._viewModel = viewModel;
        _this.context = new __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["c" /* CursorContext */](_this._configuration, _this._model, _this._viewModel);
        _this._cursors = new __WEBPACK_IMPORTED_MODULE_3__cursorCollection_js__["a" /* CursorCollection */](_this.context);
        _this._isHandling = false;
        _this._isDoingComposition = false;
        _this._columnSelectData = null;
        _this._prevEditOperationType = 0 /* Other */;
        _this._register(_this._model.onDidChangeRawContent(function (e) {
            _this._knownModelVersionId = e.versionId;
            if (_this._isHandling) {
                return;
            }
            var hadFlushEvent = e.containsEvent(1 /* Flush */);
            _this._onModelContentChanged(hadFlushEvent);
        }));
        _this._register(viewModel.addEventListener(function (events) {
            if (!containsLineMappingChanged(events)) {
                return;
            }
            if (_this._knownModelVersionId !== _this._model.getVersionId()) {
                // There are model change events that I didn't yet receive.
                //
                // This can happen when editing the model, and the view model receives the change events first,
                // and the view model emits line mapping changed events, all before the cursor gets a chance to
                // recover from markers.
                //
                // The model change listener above will be called soon and we'll ensure a valid cursor state there.
                return;
            }
            // Ensure valid state
            _this.setStates('viewModel', __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].NotSet, _this.getAll());
        }));
        var updateCursorContext = function () {
            _this.context = new __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["c" /* CursorContext */](_this._configuration, _this._model, _this._viewModel);
            _this._cursors.updateContext(_this.context);
        };
        _this._register(_this._model.onDidChangeLanguage(function (e) {
            updateCursorContext();
        }));
        _this._register(_this._model.onDidChangeLanguageConfiguration(function () {
            updateCursorContext();
        }));
        _this._register(_this._model.onDidChangeOptions(function () {
            updateCursorContext();
        }));
        _this._register(_this._configuration.onDidChange(function (e) {
            if (__WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["b" /* CursorConfiguration */].shouldRecreate(e)) {
                updateCursorContext();
            }
        }));
        return _this;
    }
    Cursor.prototype.dispose = function () {
        this._cursors.dispose();
        _super.prototype.dispose.call(this);
    };
    // ------ some getters/setters
    Cursor.prototype.getPrimaryCursor = function () {
        return this._cursors.getPrimaryCursor();
    };
    Cursor.prototype.getLastAddedCursorIndex = function () {
        return this._cursors.getLastAddedCursorIndex();
    };
    Cursor.prototype.getAll = function () {
        return this._cursors.getAll();
    };
    Cursor.prototype.setStates = function (source, reason, states) {
        if (states.length > Cursor.MAX_CURSOR_COUNT) {
            states = states.slice(0, Cursor.MAX_CURSOR_COUNT);
            this._onDidReachMaxCursorCount.fire(void 0);
        }
        var oldState = new CursorModelState(this._model, this);
        this._cursors.setStates(states);
        this._cursors.normalize();
        this._columnSelectData = null;
        this._emitStateChangedIfNecessary(source, reason, oldState);
    };
    Cursor.prototype.setColumnSelectData = function (columnSelectData) {
        this._columnSelectData = columnSelectData;
    };
    Cursor.prototype.reveal = function (horizontal, target, scrollType) {
        this._revealRange(target, 0 /* Simple */, horizontal, scrollType);
    };
    Cursor.prototype.revealRange = function (revealHorizontal, viewRange, verticalType, scrollType) {
        this.emitCursorRevealRange(viewRange, verticalType, revealHorizontal, scrollType);
    };
    Cursor.prototype.scrollTo = function (desiredScrollTop) {
        this._viewModel.viewLayout.setScrollPositionSmooth({
            scrollTop: desiredScrollTop
        });
    };
    Cursor.prototype.saveState = function () {
        var result = [];
        var selections = this._cursors.getSelections();
        for (var i = 0, len = selections.length; i < len; i++) {
            var selection = selections[i];
            result.push({
                inSelectionMode: !selection.isEmpty(),
                selectionStart: {
                    lineNumber: selection.selectionStartLineNumber,
                    column: selection.selectionStartColumn,
                },
                position: {
                    lineNumber: selection.positionLineNumber,
                    column: selection.positionColumn,
                }
            });
        }
        return result;
    };
    Cursor.prototype.restoreState = function (states) {
        var desiredSelections = [];
        for (var i = 0, len = states.length; i < len; i++) {
            var state = states[i];
            var positionLineNumber = 1;
            var positionColumn = 1;
            // Avoid missing properties on the literal
            if (state.position && state.position.lineNumber) {
                positionLineNumber = state.position.lineNumber;
            }
            if (state.position && state.position.column) {
                positionColumn = state.position.column;
            }
            var selectionStartLineNumber = positionLineNumber;
            var selectionStartColumn = positionColumn;
            // Avoid missing properties on the literal
            if (state.selectionStart && state.selectionStart.lineNumber) {
                selectionStartLineNumber = state.selectionStart.lineNumber;
            }
            if (state.selectionStart && state.selectionStart.column) {
                selectionStartColumn = state.selectionStart.column;
            }
            desiredSelections.push({
                selectionStartLineNumber: selectionStartLineNumber,
                selectionStartColumn: selectionStartColumn,
                positionLineNumber: positionLineNumber,
                positionColumn: positionColumn
            });
        }
        this.setStates('restoreState', __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].NotSet, __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["d" /* CursorState */].fromModelSelections(desiredSelections));
        this.reveal(true, 0 /* Primary */, 1 /* Immediate */);
    };
    Cursor.prototype._onModelContentChanged = function (hadFlushEvent) {
        this._prevEditOperationType = 0 /* Other */;
        if (hadFlushEvent) {
            // a model.setValue() was called
            this._cursors.dispose();
            this._cursors = new __WEBPACK_IMPORTED_MODULE_3__cursorCollection_js__["a" /* CursorCollection */](this.context);
            this._emitStateChangedIfNecessary('model', __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].ContentFlush, null);
        }
        else {
            var selectionsFromMarkers = this._cursors.readSelectionFromMarkers();
            this.setStates('modelChange', __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].RecoverFromMarkers, __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["d" /* CursorState */].fromModelSelections(selectionsFromMarkers));
        }
    };
    Cursor.prototype.getSelection = function () {
        return this._cursors.getPrimaryCursor().modelState.selection;
    };
    Cursor.prototype.getColumnSelectData = function () {
        if (this._columnSelectData) {
            return this._columnSelectData;
        }
        var primaryCursor = this._cursors.getPrimaryCursor();
        var primaryPos = primaryCursor.viewState.position;
        return {
            toViewLineNumber: primaryPos.lineNumber,
            toViewVisualColumn: __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["a" /* CursorColumns */].visibleColumnFromColumn2(this.context.config, this.context.viewModel, primaryPos)
        };
    };
    Cursor.prototype.getSelections = function () {
        return this._cursors.getSelections();
    };
    Cursor.prototype.getViewSelections = function () {
        return this._cursors.getViewSelections();
    };
    Cursor.prototype.getPosition = function () {
        return this._cursors.getPrimaryCursor().modelState.position;
    };
    Cursor.prototype.setSelections = function (source, selections) {
        this.setStates(source, __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].NotSet, __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["d" /* CursorState */].fromModelSelections(selections));
    };
    Cursor.prototype.getPrevEditOperationType = function () {
        return this._prevEditOperationType;
    };
    Cursor.prototype.setPrevEditOperationType = function (type) {
        this._prevEditOperationType = type;
    };
    // ------ auxiliary handling logic
    Cursor.prototype._executeEditOperation = function (opResult) {
        if (!opResult) {
            // Nothing to execute
            return;
        }
        if (opResult.shouldPushStackElementBefore) {
            this._model.pushStackElement();
        }
        var result = CommandExecutor.executeCommands(this._model, this._cursors.getSelections(), opResult.commands);
        if (result) {
            // The commands were applied correctly
            this._interpretCommandResult(result);
            this._prevEditOperationType = opResult.type;
        }
        if (opResult.shouldPushStackElementAfter) {
            this._model.pushStackElement();
        }
    };
    Cursor.prototype._interpretCommandResult = function (cursorState) {
        if (!cursorState || cursorState.length === 0) {
            cursorState = this._cursors.readSelectionFromMarkers();
        }
        this._columnSelectData = null;
        this._cursors.setSelections(cursorState);
        this._cursors.normalize();
    };
    // -----------------------------------------------------------------------------------------------------------
    // ----- emitting events
    Cursor.prototype._emitStateChangedIfNecessary = function (source, reason, oldState) {
        var newState = new CursorModelState(this._model, this);
        if (newState.equals(oldState)) {
            return false;
        }
        var selections = this._cursors.getSelections();
        var viewSelections = this._cursors.getViewSelections();
        // Let the view get the event first.
        try {
            var eventsCollector = this._beginEmit();
            eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_11__view_viewEvents_js__["b" /* ViewCursorStateChangedEvent */](viewSelections));
        }
        finally {
            this._endEmit();
        }
        // Only after the view has been notified, let the rest of the world know...
        if (!oldState
            || oldState.cursorState.length !== newState.cursorState.length
            || newState.cursorState.some(function (newCursorState, i) { return !newCursorState.modelState.equals(oldState.cursorState[i].modelState); })) {
            this._onDidChange.fire(new CursorStateChangedEvent(selections, source || 'keyboard', reason));
        }
        return true;
    };
    Cursor.prototype._revealRange = function (revealTarget, verticalType, revealHorizontal, scrollType) {
        var viewPositions = this._cursors.getViewPositions();
        var viewPosition = viewPositions[0];
        if (revealTarget === 1 /* TopMost */) {
            for (var i = 1; i < viewPositions.length; i++) {
                if (viewPositions[i].isBefore(viewPosition)) {
                    viewPosition = viewPositions[i];
                }
            }
        }
        else if (revealTarget === 2 /* BottomMost */) {
            for (var i = 1; i < viewPositions.length; i++) {
                if (viewPosition.isBeforeOrEqual(viewPositions[i])) {
                    viewPosition = viewPositions[i];
                }
            }
        }
        else {
            if (viewPositions.length > 1) {
                // no revealing!
                return;
            }
        }
        var viewRange = new __WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */](viewPosition.lineNumber, viewPosition.column, viewPosition.lineNumber, viewPosition.column);
        this.emitCursorRevealRange(viewRange, verticalType, revealHorizontal, scrollType);
    };
    Cursor.prototype.emitCursorRevealRange = function (viewRange, verticalType, revealHorizontal, scrollType) {
        try {
            var eventsCollector = this._beginEmit();
            eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_11__view_viewEvents_js__["l" /* ViewRevealRangeRequestEvent */](viewRange, verticalType, revealHorizontal, scrollType));
        }
        finally {
            this._endEmit();
        }
    };
    // -----------------------------------------------------------------------------------------------------------
    // ----- handlers beyond this point
    Cursor.prototype.trigger = function (source, handlerId, payload) {
        var H = __WEBPACK_IMPORTED_MODULE_6__editorCommon_js__["b" /* Handler */];
        if (handlerId === H.CompositionStart) {
            this._isDoingComposition = true;
            return;
        }
        if (handlerId === H.CompositionEnd) {
            this._isDoingComposition = false;
        }
        if (this._configuration.editor.readOnly) {
            // All the remaining handlers will try to edit the model,
            // but we cannot edit when read only...
            this._onDidAttemptReadOnlyEdit.fire(void 0);
            return;
        }
        var oldState = new CursorModelState(this._model, this);
        var cursorChangeReason = __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].NotSet;
        if (handlerId !== H.Undo && handlerId !== H.Redo) {
            // TODO@Alex: if the undo/redo stack contains non-null selections
            // it would also be OK to stop tracking selections here
            this._cursors.stopTrackingSelections();
        }
        // ensure valid state on all cursors
        this._cursors.ensureValidState();
        this._isHandling = true;
        try {
            switch (handlerId) {
                case H.Type:
                    this._type(source, payload.text);
                    break;
                case H.ReplacePreviousChar:
                    this._replacePreviousChar(payload.text, payload.replaceCharCnt);
                    break;
                case H.Paste:
                    cursorChangeReason = __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].Paste;
                    this._paste(payload.text, payload.pasteOnNewLine, payload.multicursorText);
                    break;
                case H.Cut:
                    this._cut();
                    break;
                case H.Undo:
                    cursorChangeReason = __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].Undo;
                    this._interpretCommandResult(this._model.undo());
                    break;
                case H.Redo:
                    cursorChangeReason = __WEBPACK_IMPORTED_MODULE_10__cursorEvents_js__["a" /* CursorChangeReason */].Redo;
                    this._interpretCommandResult(this._model.redo());
                    break;
                case H.ExecuteCommand:
                    this._externalExecuteCommand(payload);
                    break;
                case H.ExecuteCommands:
                    this._externalExecuteCommands(payload);
                    break;
                case H.CompositionEnd:
                    this._interpretCompositionEnd(source);
                    break;
            }
        }
        catch (err) {
            Object(__WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */])(err);
        }
        this._isHandling = false;
        if (handlerId !== H.Undo && handlerId !== H.Redo) {
            this._cursors.startTrackingSelections();
        }
        if (this._emitStateChangedIfNecessary(source, cursorChangeReason, oldState)) {
            this._revealRange(0 /* Primary */, 0 /* Simple */, true, 0 /* Smooth */);
        }
    };
    Cursor.prototype._interpretCompositionEnd = function (source) {
        if (!this._isDoingComposition && source === 'keyboard') {
            // composition finishes, let's check if we need to auto complete if necessary.
            this._executeEditOperation(__WEBPACK_IMPORTED_MODULE_9__cursorTypeOperations_js__["a" /* TypeOperations */].compositionEndWithInterceptors(this._prevEditOperationType, this.context.config, this.context.model, this.getSelections()));
        }
    };
    Cursor.prototype._type = function (source, text) {
        if (!this._isDoingComposition && source === 'keyboard') {
            // If this event is coming straight from the keyboard, look for electric characters and enter
            for (var i = 0, len = text.length; i < len; i++) {
                var charCode = text.charCodeAt(i);
                var chr = void 0;
                if (__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["isHighSurrogate"](charCode) && i + 1 < len) {
                    chr = text.charAt(i) + text.charAt(i + 1);
                    i++;
                }
                else {
                    chr = text.charAt(i);
                }
                // Here we must interpret each typed character individually, that's why we create a new context
                this._executeEditOperation(__WEBPACK_IMPORTED_MODULE_9__cursorTypeOperations_js__["a" /* TypeOperations */].typeWithInterceptors(this._prevEditOperationType, this.context.config, this.context.model, this.getSelections(), chr));
            }
        }
        else {
            this._executeEditOperation(__WEBPACK_IMPORTED_MODULE_9__cursorTypeOperations_js__["a" /* TypeOperations */].typeWithoutInterceptors(this._prevEditOperationType, this.context.config, this.context.model, this.getSelections(), text));
        }
    };
    Cursor.prototype._replacePreviousChar = function (text, replaceCharCnt) {
        this._executeEditOperation(__WEBPACK_IMPORTED_MODULE_9__cursorTypeOperations_js__["a" /* TypeOperations */].replacePreviousChar(this._prevEditOperationType, this.context.config, this.context.model, this.getSelections(), text, replaceCharCnt));
    };
    Cursor.prototype._paste = function (text, pasteOnNewLine, multicursorText) {
        this._executeEditOperation(__WEBPACK_IMPORTED_MODULE_9__cursorTypeOperations_js__["a" /* TypeOperations */].paste(this.context.config, this.context.model, this.getSelections(), text, pasteOnNewLine, multicursorText));
    };
    Cursor.prototype._cut = function () {
        this._executeEditOperation(__WEBPACK_IMPORTED_MODULE_8__cursorDeleteOperations_js__["a" /* DeleteOperations */].cut(this.context.config, this.context.model, this.getSelections()));
    };
    Cursor.prototype._externalExecuteCommand = function (command) {
        this._cursors.killSecondaryCursors();
        this._executeEditOperation(new __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["e" /* EditOperationResult */](0 /* Other */, [command], {
            shouldPushStackElementBefore: false,
            shouldPushStackElementAfter: false
        }));
    };
    Cursor.prototype._externalExecuteCommands = function (commands) {
        this._executeEditOperation(new __WEBPACK_IMPORTED_MODULE_7__cursorCommon_js__["e" /* EditOperationResult */](0 /* Other */, commands, {
            shouldPushStackElementBefore: false,
            shouldPushStackElementAfter: false
        }));
    };
    Cursor.MAX_CURSOR_COUNT = 10000;
    return Cursor;
}(__WEBPACK_IMPORTED_MODULE_11__view_viewEvents_js__["d" /* ViewEventEmitter */]));

var CommandExecutor = /** @class */ (function () {
    function CommandExecutor() {
    }
    CommandExecutor.executeCommands = function (model, selectionsBefore, commands) {
        var ctx = {
            model: model,
            selectionsBefore: selectionsBefore,
            trackedRanges: [],
            trackedRangesDirection: []
        };
        var result = this._innerExecuteCommands(ctx, commands);
        for (var i = 0, len = ctx.trackedRanges.length; i < len; i++) {
            ctx.model._setTrackedRange(ctx.trackedRanges[i], null, __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].AlwaysGrowsWhenTypingAtEdges);
        }
        return result;
    };
    CommandExecutor._innerExecuteCommands = function (ctx, commands) {
        if (this._arrayIsEmpty(commands)) {
            return null;
        }
        var commandsData = this._getEditOperations(ctx, commands);
        if (commandsData.operations.length === 0) {
            return null;
        }
        var rawOperations = commandsData.operations;
        var loserCursorsMap = this._getLoserCursorMap(rawOperations);
        if (loserCursorsMap.hasOwnProperty('0')) {
            // These commands are very messed up
            console.warn('Ignoring commands');
            return null;
        }
        // Remove operations belonging to losing cursors
        var filteredOperations = [];
        for (var i = 0, len = rawOperations.length; i < len; i++) {
            if (!loserCursorsMap.hasOwnProperty(rawOperations[i].identifier.major.toString())) {
                filteredOperations.push(rawOperations[i]);
            }
        }
        // TODO@Alex: find a better way to do this.
        // give the hint that edit operations are tracked to the model
        if (commandsData.hadTrackedEditOperation && filteredOperations.length > 0) {
            filteredOperations[0]._isTracked = true;
        }
        var selectionsAfter = ctx.model.pushEditOperations(ctx.selectionsBefore, filteredOperations, function (inverseEditOperations) {
            var groupedInverseEditOperations = [];
            for (var i = 0; i < ctx.selectionsBefore.length; i++) {
                groupedInverseEditOperations[i] = [];
            }
            for (var i = 0; i < inverseEditOperations.length; i++) {
                var op = inverseEditOperations[i];
                if (!op.identifier) {
                    // perhaps auto whitespace trim edits
                    continue;
                }
                groupedInverseEditOperations[op.identifier.major].push(op);
            }
            var minorBasedSorter = function (a, b) {
                return a.identifier.minor - b.identifier.minor;
            };
            var cursorSelections = [];
            var _loop_1 = function (i) {
                if (groupedInverseEditOperations[i].length > 0) {
                    groupedInverseEditOperations[i].sort(minorBasedSorter);
                    cursorSelections[i] = commands[i].computeCursorState(ctx.model, {
                        getInverseEditOperations: function () {
                            return groupedInverseEditOperations[i];
                        },
                        getTrackedSelection: function (id) {
                            var idx = parseInt(id, 10);
                            var range = ctx.model._getTrackedRange(ctx.trackedRanges[idx]);
                            if (ctx.trackedRangesDirection[idx] === __WEBPACK_IMPORTED_MODULE_5__core_selection_js__["b" /* SelectionDirection */].LTR) {
                                return new __WEBPACK_IMPORTED_MODULE_5__core_selection_js__["a" /* Selection */](range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
                            }
                            return new __WEBPACK_IMPORTED_MODULE_5__core_selection_js__["a" /* Selection */](range.endLineNumber, range.endColumn, range.startLineNumber, range.startColumn);
                        }
                    });
                }
                else {
                    cursorSelections[i] = ctx.selectionsBefore[i];
                }
            };
            for (var i = 0; i < ctx.selectionsBefore.length; i++) {
                _loop_1(i);
            }
            return cursorSelections;
        });
        // Extract losing cursors
        var losingCursors = [];
        for (var losingCursorIndex in loserCursorsMap) {
            if (loserCursorsMap.hasOwnProperty(losingCursorIndex)) {
                losingCursors.push(parseInt(losingCursorIndex, 10));
            }
        }
        // Sort losing cursors descending
        losingCursors.sort(function (a, b) {
            return b - a;
        });
        // Remove losing cursors
        for (var i = 0; i < losingCursors.length; i++) {
            selectionsAfter.splice(losingCursors[i], 1);
        }
        return selectionsAfter;
    };
    CommandExecutor._arrayIsEmpty = function (commands) {
        for (var i = 0, len = commands.length; i < len; i++) {
            if (commands[i]) {
                return false;
            }
        }
        return true;
    };
    CommandExecutor._getEditOperations = function (ctx, commands) {
        var operations = [];
        var hadTrackedEditOperation = false;
        for (var i = 0, len = commands.length; i < len; i++) {
            if (commands[i]) {
                var r = this._getEditOperationsFromCommand(ctx, i, commands[i]);
                operations = operations.concat(r.operations);
                hadTrackedEditOperation = hadTrackedEditOperation || r.hadTrackedEditOperation;
            }
        }
        return {
            operations: operations,
            hadTrackedEditOperation: hadTrackedEditOperation
        };
    };
    CommandExecutor._getEditOperationsFromCommand = function (ctx, majorIdentifier, command) {
        // This method acts as a transaction, if the command fails
        // everything it has done is ignored
        var operations = [];
        var operationMinor = 0;
        var addEditOperation = function (selection, text) {
            if (selection.isEmpty() && text === '') {
                // This command wants to add a no-op => no thank you
                return;
            }
            operations.push({
                identifier: {
                    major: majorIdentifier,
                    minor: operationMinor++
                },
                range: selection,
                text: text,
                forceMoveMarkers: false,
                isAutoWhitespaceEdit: command.insertsAutoWhitespace
            });
        };
        var hadTrackedEditOperation = false;
        var addTrackedEditOperation = function (selection, text) {
            hadTrackedEditOperation = true;
            addEditOperation(selection, text);
        };
        var trackSelection = function (selection, trackPreviousOnEmpty) {
            var stickiness;
            if (selection.isEmpty()) {
                if (typeof trackPreviousOnEmpty === 'boolean') {
                    if (trackPreviousOnEmpty) {
                        stickiness = __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].GrowsOnlyWhenTypingBefore;
                    }
                    else {
                        stickiness = __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].GrowsOnlyWhenTypingAfter;
                    }
                }
                else {
                    // Try to lock it with surrounding text
                    var maxLineColumn = ctx.model.getLineMaxColumn(selection.startLineNumber);
                    if (selection.startColumn === maxLineColumn) {
                        stickiness = __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].GrowsOnlyWhenTypingBefore;
                    }
                    else {
                        stickiness = __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].GrowsOnlyWhenTypingAfter;
                    }
                }
            }
            else {
                stickiness = __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges;
            }
            var l = ctx.trackedRanges.length;
            var id = ctx.model._setTrackedRange(null, selection, stickiness);
            ctx.trackedRanges[l] = id;
            ctx.trackedRangesDirection[l] = selection.getDirection();
            return l.toString();
        };
        var editOperationBuilder = {
            addEditOperation: addEditOperation,
            addTrackedEditOperation: addTrackedEditOperation,
            trackSelection: trackSelection
        };
        try {
            command.getEditOperations(ctx.model, editOperationBuilder);
        }
        catch (e) {
            e.friendlyMessage = __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('corrupt.commands', "Unexpected exception while executing command.");
            Object(__WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            return {
                operations: [],
                hadTrackedEditOperation: false
            };
        }
        return {
            operations: operations,
            hadTrackedEditOperation: hadTrackedEditOperation
        };
    };
    CommandExecutor._getLoserCursorMap = function (operations) {
        // This is destructive on the array
        operations = operations.slice(0);
        // Sort operations with last one first
        operations.sort(function (a, b) {
            // Note the minus!
            return -(__WEBPACK_IMPORTED_MODULE_4__core_range_js__["a" /* Range */].compareRangesUsingEnds(a.range, b.range));
        });
        // Operations can not overlap!
        var loserCursorsMap = {};
        for (var i = 1; i < operations.length; i++) {
            var previousOp = operations[i - 1];
            var currentOp = operations[i];
            if (previousOp.range.getStartPosition().isBefore(currentOp.range.getEndPosition())) {
                var loserMajor = void 0;
                if (previousOp.identifier.major > currentOp.identifier.major) {
                    // previousOp loses the battle
                    loserMajor = previousOp.identifier.major;
                }
                else {
                    loserMajor = currentOp.identifier.major;
                }
                loserCursorsMap[loserMajor.toString()] = true;
                for (var j = 0; j < operations.length; j++) {
                    if (operations[j].identifier.major === loserMajor) {
                        operations.splice(j, 1);
                        if (j < i) {
                            i--;
                        }
                        j--;
                    }
                }
                if (i > 0) {
                    i--;
                }
            }
        }
        return loserCursorsMap;
    };
    return CommandExecutor;
}());


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CursorCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oneCursor_js__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__ = __webpack_require__(39);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var CursorCollection = /** @class */ (function () {
    function CursorCollection(context) {
        this.context = context;
        this.primaryCursor = new __WEBPACK_IMPORTED_MODULE_0__oneCursor_js__["a" /* OneCursor */](context);
        this.secondaryCursors = [];
        this.lastAddedCursorIndex = 0;
    }
    CursorCollection.prototype.dispose = function () {
        this.primaryCursor.dispose(this.context);
        this.killSecondaryCursors();
    };
    CursorCollection.prototype.startTrackingSelections = function () {
        this.primaryCursor.startTrackingSelection(this.context);
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            this.secondaryCursors[i].startTrackingSelection(this.context);
        }
    };
    CursorCollection.prototype.stopTrackingSelections = function () {
        this.primaryCursor.stopTrackingSelection(this.context);
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            this.secondaryCursors[i].stopTrackingSelection(this.context);
        }
    };
    CursorCollection.prototype.updateContext = function (context) {
        this.context = context;
    };
    CursorCollection.prototype.ensureValidState = function () {
        this.primaryCursor.ensureValidState(this.context);
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            this.secondaryCursors[i].ensureValidState(this.context);
        }
    };
    CursorCollection.prototype.readSelectionFromMarkers = function () {
        var result = [];
        result[0] = this.primaryCursor.readSelectionFromMarkers(this.context);
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            result[i + 1] = this.secondaryCursors[i].readSelectionFromMarkers(this.context);
        }
        return result;
    };
    CursorCollection.prototype.getAll = function () {
        var result = [];
        result[0] = this.primaryCursor.asCursorState();
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            result[i + 1] = this.secondaryCursors[i].asCursorState();
        }
        return result;
    };
    CursorCollection.prototype.getViewPositions = function () {
        var result = [];
        result[0] = this.primaryCursor.viewState.position;
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            result[i + 1] = this.secondaryCursors[i].viewState.position;
        }
        return result;
    };
    CursorCollection.prototype.getSelections = function () {
        var result = [];
        result[0] = this.primaryCursor.modelState.selection;
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            result[i + 1] = this.secondaryCursors[i].modelState.selection;
        }
        return result;
    };
    CursorCollection.prototype.getViewSelections = function () {
        var result = [];
        result[0] = this.primaryCursor.viewState.selection;
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            result[i + 1] = this.secondaryCursors[i].viewState.selection;
        }
        return result;
    };
    CursorCollection.prototype.setSelections = function (selections) {
        this.setStates(__WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["d" /* CursorState */].fromModelSelections(selections));
    };
    CursorCollection.prototype.getPrimaryCursor = function () {
        return this.primaryCursor.asCursorState();
    };
    CursorCollection.prototype.setStates = function (states) {
        if (states === null) {
            return;
        }
        this.primaryCursor.setState(this.context, states[0].modelState, states[0].viewState);
        this._setSecondaryStates(states.slice(1));
    };
    /**
     * Creates or disposes secondary cursors as necessary to match the number of `secondarySelections`.
     */
    CursorCollection.prototype._setSecondaryStates = function (secondaryStates) {
        var secondaryCursorsLength = this.secondaryCursors.length;
        var secondaryStatesLength = secondaryStates.length;
        if (secondaryCursorsLength < secondaryStatesLength) {
            var createCnt = secondaryStatesLength - secondaryCursorsLength;
            for (var i = 0; i < createCnt; i++) {
                this._addSecondaryCursor();
            }
        }
        else if (secondaryCursorsLength > secondaryStatesLength) {
            var removeCnt = secondaryCursorsLength - secondaryStatesLength;
            for (var i = 0; i < removeCnt; i++) {
                this._removeSecondaryCursor(this.secondaryCursors.length - 1);
            }
        }
        for (var i = 0; i < secondaryStatesLength; i++) {
            this.secondaryCursors[i].setState(this.context, secondaryStates[i].modelState, secondaryStates[i].viewState);
        }
    };
    CursorCollection.prototype.killSecondaryCursors = function () {
        this._setSecondaryStates([]);
    };
    CursorCollection.prototype._addSecondaryCursor = function () {
        this.secondaryCursors.push(new __WEBPACK_IMPORTED_MODULE_0__oneCursor_js__["a" /* OneCursor */](this.context));
        this.lastAddedCursorIndex = this.secondaryCursors.length;
    };
    CursorCollection.prototype.getLastAddedCursorIndex = function () {
        if (this.secondaryCursors.length === 0 || this.lastAddedCursorIndex === 0) {
            return 0;
        }
        return this.lastAddedCursorIndex;
    };
    CursorCollection.prototype._removeSecondaryCursor = function (removeIndex) {
        if (this.lastAddedCursorIndex >= removeIndex + 1) {
            this.lastAddedCursorIndex--;
        }
        this.secondaryCursors[removeIndex].dispose(this.context);
        this.secondaryCursors.splice(removeIndex, 1);
    };
    CursorCollection.prototype._getAll = function () {
        var result = [];
        result[0] = this.primaryCursor;
        for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
            result[i + 1] = this.secondaryCursors[i];
        }
        return result;
    };
    CursorCollection.prototype.normalize = function () {
        if (this.secondaryCursors.length === 0) {
            return;
        }
        var cursors = this._getAll();
        var sortedCursors = [];
        for (var i = 0, len = cursors.length; i < len; i++) {
            sortedCursors.push({
                index: i,
                selection: cursors[i].modelState.selection,
            });
        }
        sortedCursors.sort(function (a, b) {
            if (a.selection.startLineNumber === b.selection.startLineNumber) {
                return a.selection.startColumn - b.selection.startColumn;
            }
            return a.selection.startLineNumber - b.selection.startLineNumber;
        });
        for (var sortedCursorIndex = 0; sortedCursorIndex < sortedCursors.length - 1; sortedCursorIndex++) {
            var current = sortedCursors[sortedCursorIndex];
            var next = sortedCursors[sortedCursorIndex + 1];
            var currentSelection = current.selection;
            var nextSelection = next.selection;
            if (!this.context.config.multiCursorMergeOverlapping) {
                continue;
            }
            var shouldMergeCursors = void 0;
            if (nextSelection.isEmpty() || currentSelection.isEmpty()) {
                // Merge touching cursors if one of them is collapsed
                shouldMergeCursors = nextSelection.getStartPosition().isBeforeOrEqual(currentSelection.getEndPosition());
            }
            else {
                // Merge only overlapping cursors (i.e. allow touching ranges)
                shouldMergeCursors = nextSelection.getStartPosition().isBefore(currentSelection.getEndPosition());
            }
            if (shouldMergeCursors) {
                var winnerSortedCursorIndex = current.index < next.index ? sortedCursorIndex : sortedCursorIndex + 1;
                var looserSortedCursorIndex = current.index < next.index ? sortedCursorIndex + 1 : sortedCursorIndex;
                var looserIndex = sortedCursors[looserSortedCursorIndex].index;
                var winnerIndex = sortedCursors[winnerSortedCursorIndex].index;
                var looserSelection = sortedCursors[looserSortedCursorIndex].selection;
                var winnerSelection = sortedCursors[winnerSortedCursorIndex].selection;
                if (!looserSelection.equalsSelection(winnerSelection)) {
                    var resultingRange = looserSelection.plusRange(winnerSelection);
                    var looserSelectionIsLTR = (looserSelection.selectionStartLineNumber === looserSelection.startLineNumber && looserSelection.selectionStartColumn === looserSelection.startColumn);
                    var winnerSelectionIsLTR = (winnerSelection.selectionStartLineNumber === winnerSelection.startLineNumber && winnerSelection.selectionStartColumn === winnerSelection.startColumn);
                    // Give more importance to the last added cursor (think Ctrl-dragging + hitting another cursor)
                    var resultingSelectionIsLTR = void 0;
                    if (looserIndex === this.lastAddedCursorIndex) {
                        resultingSelectionIsLTR = looserSelectionIsLTR;
                        this.lastAddedCursorIndex = winnerIndex;
                    }
                    else {
                        // Winner takes it all
                        resultingSelectionIsLTR = winnerSelectionIsLTR;
                    }
                    var resultingSelection = void 0;
                    if (resultingSelectionIsLTR) {
                        resultingSelection = new __WEBPACK_IMPORTED_MODULE_1__core_selection_js__["a" /* Selection */](resultingRange.startLineNumber, resultingRange.startColumn, resultingRange.endLineNumber, resultingRange.endColumn);
                    }
                    else {
                        resultingSelection = new __WEBPACK_IMPORTED_MODULE_1__core_selection_js__["a" /* Selection */](resultingRange.endLineNumber, resultingRange.endColumn, resultingRange.startLineNumber, resultingRange.startColumn);
                    }
                    sortedCursors[winnerSortedCursorIndex].selection = resultingSelection;
                    var resultingState = __WEBPACK_IMPORTED_MODULE_2__cursorCommon_js__["d" /* CursorState */].fromModelSelection(resultingSelection);
                    cursors[winnerIndex].setState(this.context, resultingState.modelState, resultingState.viewState);
                }
                for (var j = 0; j < sortedCursors.length; j++) {
                    if (sortedCursors[j].index > looserIndex) {
                        sortedCursors[j].index--;
                    }
                }
                cursors.splice(looserIndex, 1);
                sortedCursors.splice(looserSortedCursorIndex, 1);
                this._removeSecondaryCursor(looserIndex - 1);
                sortedCursorIndex--;
            }
        }
    };
    return CursorCollection;
}());



/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OneCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var OneCursor = /** @class */ (function () {
    function OneCursor(context) {
        this.modelState = null;
        this.viewState = null;
        this._selTrackedRange = null;
        this._trackSelection = true;
        this._setState(context, new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](1, 1, 1, 1), 0, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](1, 1), 0), new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](1, 1, 1, 1), 0, new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](1, 1), 0));
    }
    OneCursor.prototype.dispose = function (context) {
        this._removeTrackedRange(context);
    };
    OneCursor.prototype.startTrackingSelection = function (context) {
        this._trackSelection = true;
        this._updateTrackedRange(context);
    };
    OneCursor.prototype.stopTrackingSelection = function (context) {
        this._trackSelection = false;
        this._removeTrackedRange(context);
    };
    OneCursor.prototype._updateTrackedRange = function (context) {
        if (!this._trackSelection) {
            // don't track the selection
            return;
        }
        this._selTrackedRange = context.model._setTrackedRange(this._selTrackedRange, this.modelState.selection, __WEBPACK_IMPORTED_MODULE_4__model_js__["h" /* TrackedRangeStickiness */].AlwaysGrowsWhenTypingAtEdges);
    };
    OneCursor.prototype._removeTrackedRange = function (context) {
        this._selTrackedRange = context.model._setTrackedRange(this._selTrackedRange, null, __WEBPACK_IMPORTED_MODULE_4__model_js__["h" /* TrackedRangeStickiness */].AlwaysGrowsWhenTypingAtEdges);
    };
    OneCursor.prototype.asCursorState = function () {
        return new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["d" /* CursorState */](this.modelState, this.viewState);
    };
    OneCursor.prototype.readSelectionFromMarkers = function (context) {
        var range = context.model._getTrackedRange(this._selTrackedRange);
        if (this.modelState.selection.getDirection() === __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["b" /* SelectionDirection */].LTR) {
            return new __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["a" /* Selection */](range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
        }
        return new __WEBPACK_IMPORTED_MODULE_3__core_selection_js__["a" /* Selection */](range.endLineNumber, range.endColumn, range.startLineNumber, range.startColumn);
    };
    OneCursor.prototype.ensureValidState = function (context) {
        this._setState(context, this.modelState, this.viewState);
    };
    OneCursor.prototype.setState = function (context, modelState, viewState) {
        this._setState(context, modelState, viewState);
    };
    OneCursor.prototype._setState = function (context, modelState, viewState) {
        if (!modelState) {
            // We only have the view state => compute the model state
            var selectionStart = context.model.validateRange(context.convertViewRangeToModelRange(viewState.selectionStart));
            var position = context.model.validatePosition(context.convertViewPositionToModelPosition(viewState.position.lineNumber, viewState.position.column));
            modelState = new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](selectionStart, viewState.selectionStartLeftoverVisibleColumns, position, viewState.leftoverVisibleColumns);
        }
        else {
            // Validate new model state
            var selectionStart = context.model.validateRange(modelState.selectionStart);
            var selectionStartLeftoverVisibleColumns = modelState.selectionStart.equalsRange(selectionStart) ? modelState.selectionStartLeftoverVisibleColumns : 0;
            var position = context.model.validatePosition(modelState.position);
            var leftoverVisibleColumns = modelState.position.equals(position) ? modelState.leftoverVisibleColumns : 0;
            modelState = new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](selectionStart, selectionStartLeftoverVisibleColumns, position, leftoverVisibleColumns);
        }
        if (!viewState) {
            // We only have the model state => compute the view state
            var viewSelectionStart1 = context.convertModelPositionToViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](modelState.selectionStart.startLineNumber, modelState.selectionStart.startColumn));
            var viewSelectionStart2 = context.convertModelPositionToViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](modelState.selectionStart.endLineNumber, modelState.selectionStart.endColumn));
            var viewSelectionStart = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](viewSelectionStart1.lineNumber, viewSelectionStart1.column, viewSelectionStart2.lineNumber, viewSelectionStart2.column);
            var viewPosition = context.convertModelPositionToViewPosition(modelState.position);
            viewState = new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](viewSelectionStart, modelState.selectionStartLeftoverVisibleColumns, viewPosition, modelState.leftoverVisibleColumns);
        }
        else {
            // Validate new view state
            var viewSelectionStart = context.validateViewRange(viewState.selectionStart, modelState.selectionStart);
            var viewPosition = context.validateViewPosition(viewState.position, modelState.position);
            viewState = new __WEBPACK_IMPORTED_MODULE_0__cursorCommon_js__["f" /* SingleCursorState */](viewSelectionStart, modelState.selectionStartLeftoverVisibleColumns, viewPosition, modelState.leftoverVisibleColumns);
        }
        this.modelState = modelState;
        this.viewState = viewState;
        this._updateTrackedRange(context);
    };
    return OneCursor;
}());



/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modes_textToHtmlTokenizer_js__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__viewModelDecorations_js__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewModel_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__splitLinesCollection_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_minimapCharRenderer_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__characterHardWrappingLineMapper_js__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__viewLayout_viewLayout_js__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_js__ = __webpack_require__(21);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var USE_IDENTITY_LINES_COLLECTION = true;
var ViewModel = /** @class */ (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(editorId, configuration, model, scheduleAtNextAnimationFrame) {
        var _this = _super.call(this) || this;
        _this.editorId = editorId;
        _this.configuration = configuration;
        _this.model = model;
        _this.hasFocus = false;
        _this.viewportStartLine = -1;
        _this.viewportStartLineTrackedRange = null;
        _this.viewportStartLineTop = 0;
        if (USE_IDENTITY_LINES_COLLECTION && _this.model.isTooLargeForTokenization()) {
            _this.lines = new __WEBPACK_IMPORTED_MODULE_7__splitLinesCollection_js__["a" /* IdentityLinesCollection */](_this.model);
        }
        else {
            var conf = _this.configuration.editor;
            var hardWrappingLineMapperFactory = new __WEBPACK_IMPORTED_MODULE_10__characterHardWrappingLineMapper_js__["a" /* CharacterHardWrappingLineMapperFactory */](conf.wrappingInfo.wordWrapBreakBeforeCharacters, conf.wrappingInfo.wordWrapBreakAfterCharacters, conf.wrappingInfo.wordWrapBreakObtrusiveCharacters);
            _this.lines = new __WEBPACK_IMPORTED_MODULE_7__splitLinesCollection_js__["c" /* SplitLinesCollection */](_this.model, hardWrappingLineMapperFactory, _this.model.getOptions().tabSize, conf.wrappingInfo.wrappingColumn, conf.fontInfo.typicalFullwidthCharacterWidth / conf.fontInfo.typicalHalfwidthCharacterWidth, conf.wrappingInfo.wrappingIndent);
        }
        _this.coordinatesConverter = _this.lines.createCoordinatesConverter();
        _this.viewLayout = _this._register(new __WEBPACK_IMPORTED_MODULE_11__viewLayout_viewLayout_js__["a" /* ViewLayout */](_this.configuration, _this.getLineCount(), scheduleAtNextAnimationFrame));
        _this._register(_this.viewLayout.onDidScroll(function (e) {
            try {
                var eventsCollector = _this._beginEmit();
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["m" /* ViewScrollChangedEvent */](e));
            }
            finally {
                _this._endEmit();
            }
        }));
        _this.decorations = new __WEBPACK_IMPORTED_MODULE_5__viewModelDecorations_js__["a" /* ViewModelDecorations */](_this.editorId, _this.model, _this.configuration, _this.lines, _this.coordinatesConverter);
        _this._registerModelEvents();
        _this._register(_this.configuration.onDidChange(function (e) {
            try {
                var eventsCollector = _this._beginEmit();
                _this._onConfigurationChanged(eventsCollector, e);
            }
            finally {
                _this._endEmit();
            }
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_9__view_minimapCharRenderer_js__["b" /* MinimapTokensColorTracker */].getInstance().onDidChange(function () {
            try {
                var eventsCollector = _this._beginEmit();
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["p" /* ViewTokensColorsChangedEvent */]());
            }
            finally {
                _this._endEmit();
            }
        }));
        return _this;
    }
    ViewModel.prototype.dispose = function () {
        // First remove listeners, as disposing the lines might end up sending
        // model decoration changed events ... and we no longer care about them ...
        _super.prototype.dispose.call(this);
        this.decorations.dispose();
        this.lines.dispose();
        this.viewportStartLineTrackedRange = this.model._setTrackedRange(this.viewportStartLineTrackedRange, null, __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges);
    };
    ViewModel.prototype.setHasFocus = function (hasFocus) {
        this.hasFocus = hasFocus;
    };
    ViewModel.prototype._onConfigurationChanged = function (eventsCollector, e) {
        // We might need to restore the current centered view range, so save it (if available)
        var previousViewportStartModelPosition = null;
        if (this.viewportStartLine !== -1) {
            var previousViewportStartViewPosition = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](this.viewportStartLine, this.getLineMinColumn(this.viewportStartLine));
            previousViewportStartModelPosition = this.coordinatesConverter.convertViewPositionToModelPosition(previousViewportStartViewPosition);
        }
        var restorePreviousViewportStart = false;
        var conf = this.configuration.editor;
        if (this.lines.setWrappingSettings(conf.wrappingInfo.wrappingIndent, conf.wrappingInfo.wrappingColumn, conf.fontInfo.typicalFullwidthCharacterWidth / conf.fontInfo.typicalHalfwidthCharacterWidth)) {
            eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["e" /* ViewFlushedEvent */]());
            eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["h" /* ViewLineMappingChangedEvent */]());
            eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["c" /* ViewDecorationsChangedEvent */]());
            this.decorations.onLineMappingChanged();
            this.viewLayout.onFlushed(this.getLineCount());
            if (this.viewLayout.getCurrentScrollTop() !== 0) {
                // Never change the scroll position from 0 to something else...
                restorePreviousViewportStart = true;
            }
        }
        if (e.readOnly) {
            // Must read again all decorations due to readOnly filtering
            this.decorations.reset();
            eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["c" /* ViewDecorationsChangedEvent */]());
        }
        eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["a" /* ViewConfigurationChangedEvent */](e));
        this.viewLayout.onConfigurationChanged(e);
        if (restorePreviousViewportStart && previousViewportStartModelPosition) {
            var viewPosition = this.coordinatesConverter.convertModelPositionToViewPosition(previousViewportStartModelPosition);
            var viewPositionTop = this.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
            this.viewLayout.deltaScrollNow(0, viewPositionTop - this.viewportStartLineTop);
        }
    };
    ViewModel.prototype._registerModelEvents = function () {
        var _this = this;
        this._register(this.model.onDidChangeRawContentFast(function (e) {
            try {
                var eventsCollector = _this._beginEmit();
                var hadOtherModelChange = false;
                var hadModelLineChangeThatChangedLineMapping = false;
                var changes = e.changes;
                var versionId = e.versionId;
                for (var j = 0, lenJ = changes.length; j < lenJ; j++) {
                    var change = changes[j];
                    switch (change.changeType) {
                        case 1 /* Flush */: {
                            _this.lines.onModelFlushed();
                            eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["e" /* ViewFlushedEvent */]());
                            _this.decorations.reset();
                            _this.viewLayout.onFlushed(_this.getLineCount());
                            hadOtherModelChange = true;
                            break;
                        }
                        case 3 /* LinesDeleted */: {
                            var linesDeletedEvent = _this.lines.onModelLinesDeleted(versionId, change.fromLineNumber, change.toLineNumber);
                            if (linesDeletedEvent !== null) {
                                eventsCollector.emit(linesDeletedEvent);
                                _this.viewLayout.onLinesDeleted(linesDeletedEvent.fromLineNumber, linesDeletedEvent.toLineNumber);
                            }
                            hadOtherModelChange = true;
                            break;
                        }
                        case 4 /* LinesInserted */: {
                            var linesInsertedEvent = _this.lines.onModelLinesInserted(versionId, change.fromLineNumber, change.toLineNumber, change.detail);
                            if (linesInsertedEvent !== null) {
                                eventsCollector.emit(linesInsertedEvent);
                                _this.viewLayout.onLinesInserted(linesInsertedEvent.fromLineNumber, linesInsertedEvent.toLineNumber);
                            }
                            hadOtherModelChange = true;
                            break;
                        }
                        case 2 /* LineChanged */: {
                            var _a = _this.lines.onModelLineChanged(versionId, change.lineNumber, change.detail), lineMappingChanged = _a[0], linesChangedEvent = _a[1], linesInsertedEvent = _a[2], linesDeletedEvent = _a[3];
                            hadModelLineChangeThatChangedLineMapping = lineMappingChanged;
                            if (linesChangedEvent) {
                                eventsCollector.emit(linesChangedEvent);
                            }
                            if (linesInsertedEvent) {
                                eventsCollector.emit(linesInsertedEvent);
                                _this.viewLayout.onLinesInserted(linesInsertedEvent.fromLineNumber, linesInsertedEvent.toLineNumber);
                            }
                            if (linesDeletedEvent) {
                                eventsCollector.emit(linesDeletedEvent);
                                _this.viewLayout.onLinesDeleted(linesDeletedEvent.fromLineNumber, linesDeletedEvent.toLineNumber);
                            }
                            break;
                        }
                        case 5 /* EOLChanged */: {
                            // Nothing to do. The new version will be accepted below
                            break;
                        }
                    }
                }
                _this.lines.acceptVersionId(versionId);
                _this.viewLayout.onHeightMaybeChanged();
                if (!hadOtherModelChange && hadModelLineChangeThatChangedLineMapping) {
                    eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["h" /* ViewLineMappingChangedEvent */]());
                    eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["c" /* ViewDecorationsChangedEvent */]());
                    _this.decorations.onLineMappingChanged();
                }
            }
            finally {
                _this._endEmit();
            }
            // Update the configuration and reset the centered view line
            _this.viewportStartLine = -1;
            _this.configuration.setMaxLineNumber(_this.model.getLineCount());
            // Recover viewport
            if (!_this.hasFocus && _this.model.getAttachedEditorCount() >= 2 && _this.viewportStartLineTrackedRange) {
                var modelRange = _this.model._getTrackedRange(_this.viewportStartLineTrackedRange);
                if (modelRange) {
                    var viewPosition = _this.coordinatesConverter.convertModelPositionToViewPosition(modelRange.getStartPosition());
                    var viewPositionTop = _this.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
                    _this.viewLayout.deltaScrollNow(0, viewPositionTop - _this.viewportStartLineTop);
                }
            }
        }));
        this._register(this.model.onDidChangeTokens(function (e) {
            var viewRanges = [];
            for (var j = 0, lenJ = e.ranges.length; j < lenJ; j++) {
                var modelRange = e.ranges[j];
                var viewStartLineNumber = _this.coordinatesConverter.convertModelPositionToViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](modelRange.fromLineNumber, 1)).lineNumber;
                var viewEndLineNumber = _this.coordinatesConverter.convertModelPositionToViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](modelRange.toLineNumber, _this.model.getLineMaxColumn(modelRange.toLineNumber))).lineNumber;
                viewRanges[j] = {
                    fromLineNumber: viewStartLineNumber,
                    toLineNumber: viewEndLineNumber
                };
            }
            try {
                var eventsCollector = _this._beginEmit();
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["o" /* ViewTokensChangedEvent */](viewRanges));
            }
            finally {
                _this._endEmit();
            }
        }));
        this._register(this.model.onDidChangeLanguageConfiguration(function (e) {
            try {
                var eventsCollector = _this._beginEmit();
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["g" /* ViewLanguageConfigurationEvent */]());
            }
            finally {
                _this._endEmit();
            }
        }));
        this._register(this.model.onDidChangeOptions(function (e) {
            // A tab size change causes a line mapping changed event => all view parts will repaint OK, no further event needed here
            if (_this.lines.setTabSize(_this.model.getOptions().tabSize)) {
                _this.decorations.onLineMappingChanged();
                _this.viewLayout.onFlushed(_this.getLineCount());
                try {
                    var eventsCollector = _this._beginEmit();
                    eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["e" /* ViewFlushedEvent */]());
                    eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["h" /* ViewLineMappingChangedEvent */]());
                    eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["c" /* ViewDecorationsChangedEvent */]());
                }
                finally {
                    _this._endEmit();
                }
            }
        }));
        this._register(this.model.onDidChangeDecorations(function (e) {
            _this.decorations.onModelDecorationsChanged();
            try {
                var eventsCollector = _this._beginEmit();
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["c" /* ViewDecorationsChangedEvent */]());
            }
            finally {
                _this._endEmit();
            }
        }));
    };
    ViewModel.prototype.setHiddenAreas = function (ranges) {
        try {
            var eventsCollector = this._beginEmit();
            var lineMappingChanged = this.lines.setHiddenAreas(ranges);
            if (lineMappingChanged) {
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["e" /* ViewFlushedEvent */]());
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["h" /* ViewLineMappingChangedEvent */]());
                eventsCollector.emit(new __WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["c" /* ViewDecorationsChangedEvent */]());
                this.decorations.onLineMappingChanged();
                this.viewLayout.onFlushed(this.getLineCount());
                this.viewLayout.onHeightMaybeChanged();
            }
        }
        finally {
            this._endEmit();
        }
    };
    ViewModel.prototype.getVisibleRanges = function () {
        var visibleViewRange = this.getCompletelyVisibleViewRange();
        var visibleRange = this.coordinatesConverter.convertViewRangeToModelRange(visibleViewRange);
        var hiddenAreas = this.lines.getHiddenAreas();
        if (hiddenAreas.length === 0) {
            return [visibleRange];
        }
        var result = [], resultLen = 0;
        var startLineNumber = visibleRange.startLineNumber;
        var startColumn = visibleRange.startColumn;
        var endLineNumber = visibleRange.endLineNumber;
        var endColumn = visibleRange.endColumn;
        for (var i = 0, len = hiddenAreas.length; i < len; i++) {
            var hiddenStartLineNumber = hiddenAreas[i].startLineNumber;
            var hiddenEndLineNumber = hiddenAreas[i].endLineNumber;
            if (hiddenEndLineNumber < startLineNumber) {
                continue;
            }
            if (hiddenStartLineNumber > endLineNumber) {
                continue;
            }
            if (startLineNumber < hiddenStartLineNumber) {
                result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](startLineNumber, startColumn, hiddenStartLineNumber - 1, this.model.getLineMaxColumn(hiddenStartLineNumber - 1));
            }
            startLineNumber = hiddenEndLineNumber + 1;
            startColumn = 1;
        }
        if (startLineNumber < endLineNumber || (startLineNumber === endLineNumber && startColumn < endColumn)) {
            result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn);
        }
        return result;
    };
    ViewModel.prototype.getCompletelyVisibleViewRange = function () {
        var partialData = this.viewLayout.getLinesViewportData();
        var startViewLineNumber = partialData.completelyVisibleStartLineNumber;
        var endViewLineNumber = partialData.completelyVisibleEndLineNumber;
        return new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber));
    };
    ViewModel.prototype.getCompletelyVisibleViewRangeAtScrollTop = function (scrollTop) {
        var partialData = this.viewLayout.getLinesViewportDataAtScrollTop(scrollTop);
        var startViewLineNumber = partialData.completelyVisibleStartLineNumber;
        var endViewLineNumber = partialData.completelyVisibleEndLineNumber;
        return new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber));
    };
    ViewModel.prototype.saveState = function () {
        var compatViewState = this.viewLayout.saveState();
        var scrollTop = compatViewState.scrollTop;
        var firstViewLineNumber = this.viewLayout.getLineNumberAtVerticalOffset(scrollTop);
        var firstPosition = this.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](firstViewLineNumber, this.getLineMinColumn(firstViewLineNumber)));
        var firstPositionDeltaTop = this.viewLayout.getVerticalOffsetForLineNumber(firstViewLineNumber) - scrollTop;
        return {
            scrollLeft: compatViewState.scrollLeft,
            firstPosition: firstPosition,
            firstPositionDeltaTop: firstPositionDeltaTop
        };
    };
    ViewModel.prototype.reduceRestoreState = function (state) {
        if (typeof state.firstPosition === 'undefined') {
            // This is a view state serialized by an older version
            return this._reduceRestoreStateCompatibility(state);
        }
        var modelPosition = this.model.validatePosition(state.firstPosition);
        var viewPosition = this.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
        var scrollTop = this.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber) - state.firstPositionDeltaTop;
        return {
            scrollLeft: state.scrollLeft,
            scrollTop: scrollTop
        };
    };
    ViewModel.prototype._reduceRestoreStateCompatibility = function (state) {
        return {
            scrollLeft: state.scrollLeft,
            scrollTop: state.scrollTopWithoutViewZones
        };
    };
    ViewModel.prototype.getTabSize = function () {
        return this.model.getOptions().tabSize;
    };
    ViewModel.prototype.getLineCount = function () {
        return this.lines.getViewLineCount();
    };
    /**
     * Gives a hint that a lot of requests are about to come in for these line numbers.
     */
    ViewModel.prototype.setViewport = function (startLineNumber, endLineNumber, centeredLineNumber) {
        this.lines.warmUpLookupCache(startLineNumber, endLineNumber);
        this.viewportStartLine = startLineNumber;
        var position = this.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](startLineNumber, this.getLineMinColumn(startLineNumber)));
        this.viewportStartLineTrackedRange = this.model._setTrackedRange(this.viewportStartLineTrackedRange, new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column), __WEBPACK_IMPORTED_MODULE_13__model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges);
        this.viewportStartLineTop = this.viewLayout.getVerticalOffsetForLineNumber(startLineNumber);
    };
    ViewModel.prototype.getActiveIndentGuide = function (lineNumber, minLineNumber, maxLineNumber) {
        return this.lines.getActiveIndentGuide(lineNumber, minLineNumber, maxLineNumber);
    };
    ViewModel.prototype.getLinesIndentGuides = function (startLineNumber, endLineNumber) {
        return this.lines.getViewLinesIndentGuides(startLineNumber, endLineNumber);
    };
    ViewModel.prototype.getLineContent = function (lineNumber) {
        return this.lines.getViewLineContent(lineNumber);
    };
    ViewModel.prototype.getLineLength = function (lineNumber) {
        return this.lines.getViewLineLength(lineNumber);
    };
    ViewModel.prototype.getLineMinColumn = function (lineNumber) {
        return this.lines.getViewLineMinColumn(lineNumber);
    };
    ViewModel.prototype.getLineMaxColumn = function (lineNumber) {
        return this.lines.getViewLineMaxColumn(lineNumber);
    };
    ViewModel.prototype.getLineFirstNonWhitespaceColumn = function (lineNumber) {
        var result = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["firstNonWhitespaceIndex"](this.getLineContent(lineNumber));
        if (result === -1) {
            return 0;
        }
        return result + 1;
    };
    ViewModel.prototype.getLineLastNonWhitespaceColumn = function (lineNumber) {
        var result = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["lastNonWhitespaceIndex"](this.getLineContent(lineNumber));
        if (result === -1) {
            return 0;
        }
        return result + 2;
    };
    ViewModel.prototype.getDecorationsInViewport = function (visibleRange) {
        return this.decorations.getDecorationsViewportData(visibleRange).decorations;
    };
    ViewModel.prototype.getViewLineRenderingData = function (visibleRange, lineNumber) {
        var mightContainRTL = this.model.mightContainRTL();
        var mightContainNonBasicASCII = this.model.mightContainNonBasicASCII();
        var tabSize = this.getTabSize();
        var lineData = this.lines.getViewLineData(lineNumber);
        var allInlineDecorations = this.decorations.getDecorationsViewportData(visibleRange).inlineDecorations;
        var inlineDecorations = allInlineDecorations[lineNumber - visibleRange.startLineNumber];
        return new __WEBPACK_IMPORTED_MODULE_6__viewModel_js__["d" /* ViewLineRenderingData */](lineData.minColumn, lineData.maxColumn, lineData.content, lineData.continuesWithWrappedLine, mightContainRTL, mightContainNonBasicASCII, lineData.tokens, inlineDecorations, tabSize);
    };
    ViewModel.prototype.getViewLineData = function (lineNumber) {
        return this.lines.getViewLineData(lineNumber);
    };
    ViewModel.prototype.getMinimapLinesRenderingData = function (startLineNumber, endLineNumber, needed) {
        var result = this.lines.getViewLinesData(startLineNumber, endLineNumber, needed);
        return new __WEBPACK_IMPORTED_MODULE_6__viewModel_js__["b" /* MinimapLinesRenderingData */](this.getTabSize(), result);
    };
    ViewModel.prototype.getAllOverviewRulerDecorations = function (theme) {
        return this.lines.getAllOverviewRulerDecorations(this.editorId, this.configuration.editor.readOnly, theme);
    };
    ViewModel.prototype.invalidateOverviewRulerColorCache = function () {
        var decorations = this.model.getOverviewRulerDecorations();
        for (var i = 0, len = decorations.length; i < len; i++) {
            var decoration = decorations[i];
            var opts = decoration.options.overviewRuler;
            opts._resolvedColor = null;
        }
    };
    ViewModel.prototype.getValueInRange = function (range, eol) {
        var modelRange = this.coordinatesConverter.convertViewRangeToModelRange(range);
        return this.model.getValueInRange(modelRange, eol);
    };
    ViewModel.prototype.getModelLineMaxColumn = function (modelLineNumber) {
        return this.model.getLineMaxColumn(modelLineNumber);
    };
    ViewModel.prototype.validateModelPosition = function (position) {
        return this.model.validatePosition(position);
    };
    ViewModel.prototype.deduceModelPositionRelativeToViewPosition = function (viewAnchorPosition, deltaOffset, lineFeedCnt) {
        var modelAnchor = this.coordinatesConverter.convertViewPositionToModelPosition(viewAnchorPosition);
        if (this.model.getEOL().length === 2) {
            // This model uses CRLF, so the delta must take that into account
            if (deltaOffset < 0) {
                deltaOffset -= lineFeedCnt;
            }
            else {
                deltaOffset += lineFeedCnt;
            }
        }
        var modelAnchorOffset = this.model.getOffsetAt(modelAnchor);
        var resultOffset = modelAnchorOffset + deltaOffset;
        return this.model.getPositionAt(resultOffset);
    };
    ViewModel.prototype.getEOL = function () {
        return this.model.getEOL();
    };
    ViewModel.prototype.getPlainTextToCopy = function (ranges, emptySelectionClipboard, forceCRLF) {
        var _this = this;
        var newLineCharacter = forceCRLF ? '\r\n' : this.model.getEOL();
        ranges = ranges.slice(0);
        ranges.sort(__WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */].compareRangesUsingStarts);
        var nonEmptyRanges = ranges.filter(function (r) { return !r.isEmpty(); });
        if (nonEmptyRanges.length === 0) {
            if (!emptySelectionClipboard) {
                return '';
            }
            var modelLineNumbers = ranges.map(function (r) {
                var viewLineStart = new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](r.startLineNumber, 1);
                return _this.coordinatesConverter.convertViewPositionToModelPosition(viewLineStart).lineNumber;
            });
            var result_1 = '';
            for (var i = 0; i < modelLineNumbers.length; i++) {
                if (i > 0 && modelLineNumbers[i - 1] === modelLineNumbers[i]) {
                    continue;
                }
                result_1 += this.model.getLineContent(modelLineNumbers[i]) + newLineCharacter;
            }
            return result_1;
        }
        var result = [];
        for (var i = 0; i < nonEmptyRanges.length; i++) {
            result.push(this.getValueInRange(nonEmptyRanges[i], forceCRLF ? __WEBPACK_IMPORTED_MODULE_13__model_js__["c" /* EndOfLinePreference */].CRLF : __WEBPACK_IMPORTED_MODULE_13__model_js__["c" /* EndOfLinePreference */].TextDefined));
        }
        return result.length === 1 ? result[0] : result;
    };
    ViewModel.prototype.getHTMLToCopy = function (viewRanges, emptySelectionClipboard) {
        if (this.model.getLanguageIdentifier().id === 1 /* PlainText */) {
            return null;
        }
        if (viewRanges.length !== 1) {
            // no multiple selection support at this time
            return null;
        }
        var range = this.coordinatesConverter.convertViewRangeToModelRange(viewRanges[0]);
        if (range.isEmpty()) {
            if (!emptySelectionClipboard) {
                // nothing to copy
                return null;
            }
            var lineNumber = range.startLineNumber;
            range = new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, this.model.getLineMinColumn(lineNumber), lineNumber, this.model.getLineMaxColumn(lineNumber));
        }
        var fontInfo = this.configuration.editor.fontInfo;
        var colorMap = this._getColorMap();
        return ("<div style=\""
            + ("color: " + colorMap[1 /* DefaultForeground */] + ";")
            + ("background-color: " + colorMap[2 /* DefaultBackground */] + ";")
            + ("font-family: " + fontInfo.fontFamily + ";")
            + ("font-weight: " + fontInfo.fontWeight + ";")
            + ("font-size: " + fontInfo.fontSize + "px;")
            + ("line-height: " + fontInfo.lineHeight + "px;")
            + "white-space: pre;"
            + "\">"
            + this._getHTMLToCopy(range, colorMap)
            + '</div>');
    };
    ViewModel.prototype._getHTMLToCopy = function (modelRange, colorMap) {
        var startLineNumber = modelRange.startLineNumber;
        var startColumn = modelRange.startColumn;
        var endLineNumber = modelRange.endLineNumber;
        var endColumn = modelRange.endColumn;
        var tabSize = this.getTabSize();
        var result = '';
        for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
            var lineTokens = this.model.getLineTokens(lineNumber);
            var lineContent = lineTokens.getLineContent();
            var startOffset = (lineNumber === startLineNumber ? startColumn - 1 : 0);
            var endOffset = (lineNumber === endLineNumber ? endColumn - 1 : lineContent.length);
            if (lineContent === '') {
                result += '<br>';
            }
            else {
                result += Object(__WEBPACK_IMPORTED_MODULE_4__modes_textToHtmlTokenizer_js__["a" /* tokenizeLineToHTML */])(lineContent, lineTokens.inflate(), colorMap, startOffset, endOffset, tabSize);
            }
        }
        return result;
    };
    ViewModel.prototype._getColorMap = function () {
        var colorMap = __WEBPACK_IMPORTED_MODULE_3__modes_js__["y" /* TokenizationRegistry */].getColorMap();
        var result = [null];
        for (var i = 1, len = colorMap.length; i < len; i++) {
            result[i] = __WEBPACK_IMPORTED_MODULE_12__base_common_color_js__["a" /* Color */].Format.CSS.formatHex(colorMap[i]);
        }
        return result;
    };
    return ViewModel;
}(__WEBPACK_IMPORTED_MODULE_8__view_viewEvents_js__["d" /* ViewEventEmitter */]));



/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewModelDecorations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__viewModel_js__ = __webpack_require__(62);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var ViewModelDecorations = /** @class */ (function () {
    function ViewModelDecorations(editorId, model, configuration, linesCollection, coordinatesConverter) {
        this.editorId = editorId;
        this.model = model;
        this.configuration = configuration;
        this._linesCollection = linesCollection;
        this._coordinatesConverter = coordinatesConverter;
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    }
    ViewModelDecorations.prototype._clearCachedModelDecorationsResolver = function () {
        this._cachedModelDecorationsResolver = null;
        this._cachedModelDecorationsResolverViewRange = null;
    };
    ViewModelDecorations.prototype.dispose = function () {
        this._decorationsCache = null;
        this._clearCachedModelDecorationsResolver();
    };
    ViewModelDecorations.prototype.reset = function () {
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    };
    ViewModelDecorations.prototype.onModelDecorationsChanged = function () {
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    };
    ViewModelDecorations.prototype.onLineMappingChanged = function () {
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    };
    ViewModelDecorations.prototype._getOrCreateViewModelDecoration = function (modelDecoration) {
        var id = modelDecoration.id;
        var r = this._decorationsCache[id];
        if (!r) {
            var modelRange = modelDecoration.range;
            var options = modelDecoration.options;
            var viewRange = void 0;
            if (options.isWholeLine) {
                var start = this._coordinatesConverter.convertModelPositionToViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](modelRange.startLineNumber, 1));
                var end = this._coordinatesConverter.convertModelPositionToViewPosition(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](modelRange.endLineNumber, this.model.getLineMaxColumn(modelRange.endLineNumber)));
                viewRange = new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](start.lineNumber, start.column, end.lineNumber, end.column);
            }
            else {
                viewRange = this._coordinatesConverter.convertModelRangeToViewRange(modelRange);
            }
            r = new __WEBPACK_IMPORTED_MODULE_2__viewModel_js__["e" /* ViewModelDecoration */](viewRange, options);
            this._decorationsCache[id] = r;
        }
        return r;
    };
    ViewModelDecorations.prototype.getDecorationsViewportData = function (viewRange) {
        var cacheIsValid = true;
        cacheIsValid = cacheIsValid && (this._cachedModelDecorationsResolver !== null);
        cacheIsValid = cacheIsValid && (viewRange.equalsRange(this._cachedModelDecorationsResolverViewRange));
        if (!cacheIsValid) {
            this._cachedModelDecorationsResolver = this._getDecorationsViewportData(viewRange);
            this._cachedModelDecorationsResolverViewRange = viewRange;
        }
        return this._cachedModelDecorationsResolver;
    };
    ViewModelDecorations.prototype._getDecorationsViewportData = function (viewportRange) {
        var modelDecorations = this._linesCollection.getDecorationsInRange(viewportRange, this.editorId, this.configuration.editor.readOnly);
        var startLineNumber = viewportRange.startLineNumber;
        var endLineNumber = viewportRange.endLineNumber;
        var decorationsInViewport = [], decorationsInViewportLen = 0;
        var inlineDecorations = [];
        for (var j = startLineNumber; j <= endLineNumber; j++) {
            inlineDecorations[j - startLineNumber] = [];
        }
        for (var i = 0, len = modelDecorations.length; i < len; i++) {
            var modelDecoration = modelDecorations[i];
            var decorationOptions = modelDecoration.options;
            var viewModelDecoration = this._getOrCreateViewModelDecoration(modelDecoration);
            var viewRange = viewModelDecoration.range;
            decorationsInViewport[decorationsInViewportLen++] = viewModelDecoration;
            if (decorationOptions.inlineClassName) {
                var inlineDecoration = new __WEBPACK_IMPORTED_MODULE_2__viewModel_js__["a" /* InlineDecoration */](viewRange, decorationOptions.inlineClassName, decorationOptions.inlineClassNameAffectsLetterSpacing ? 3 /* RegularAffectingLetterSpacing */ : 0 /* Regular */);
                var intersectedStartLineNumber = Math.max(startLineNumber, viewRange.startLineNumber);
                var intersectedEndLineNumber = Math.min(endLineNumber, viewRange.endLineNumber);
                for (var j = intersectedStartLineNumber; j <= intersectedEndLineNumber; j++) {
                    inlineDecorations[j - startLineNumber].push(inlineDecoration);
                }
            }
            if (decorationOptions.beforeContentClassName) {
                if (startLineNumber <= viewRange.startLineNumber && viewRange.startLineNumber <= endLineNumber) {
                    var inlineDecoration = new __WEBPACK_IMPORTED_MODULE_2__viewModel_js__["a" /* InlineDecoration */](new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](viewRange.startLineNumber, viewRange.startColumn, viewRange.startLineNumber, viewRange.startColumn), decorationOptions.beforeContentClassName, 1 /* Before */);
                    inlineDecorations[viewRange.startLineNumber - startLineNumber].push(inlineDecoration);
                }
            }
            if (decorationOptions.afterContentClassName) {
                if (startLineNumber <= viewRange.endLineNumber && viewRange.endLineNumber <= endLineNumber) {
                    var inlineDecoration = new __WEBPACK_IMPORTED_MODULE_2__viewModel_js__["a" /* InlineDecoration */](new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](viewRange.endLineNumber, viewRange.endColumn, viewRange.endLineNumber, viewRange.endColumn), decorationOptions.afterContentClassName, 2 /* After */);
                    inlineDecorations[viewRange.endLineNumber - startLineNumber].push(inlineDecoration);
                }
            }
        }
        return {
            decorations: decorationsInViewport,
            inlineDecorations: inlineDecorations
        };
    };
    return ViewModelDecorations;
}());



/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RGBA8; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * A very VM friendly rgba datastructure.
 * Please don't touch unless you take a look at the IR.
 */
var RGBA8 = /** @class */ (function () {
    function RGBA8(r, g, b, a) {
        this.r = RGBA8._clamp(r);
        this.g = RGBA8._clamp(g);
        this.b = RGBA8._clamp(b);
        this.a = RGBA8._clamp(a);
    }
    RGBA8._clamp = function (c) {
        if (c < 0) {
            return 0;
        }
        if (c > 255) {
            return 255;
        }
        return c | 0;
    };
    return RGBA8;
}());



/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharacterHardWrappingLineMapperFactory; });
/* unused harmony export CharacterHardWrappingLineMapping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prefixSumComputer_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__splitLinesCollection_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_characterClassifier_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_uint_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_editorOptions_js__ = __webpack_require__(45);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var WrappingCharacterClassifier = /** @class */ (function (_super) {
    __extends(WrappingCharacterClassifier, _super);
    function WrappingCharacterClassifier(BREAK_BEFORE, BREAK_AFTER, BREAK_OBTRUSIVE) {
        var _this = _super.call(this, 0 /* NONE */) || this;
        for (var i = 0; i < BREAK_BEFORE.length; i++) {
            _this.set(BREAK_BEFORE.charCodeAt(i), 1 /* BREAK_BEFORE */);
        }
        for (var i = 0; i < BREAK_AFTER.length; i++) {
            _this.set(BREAK_AFTER.charCodeAt(i), 2 /* BREAK_AFTER */);
        }
        for (var i = 0; i < BREAK_OBTRUSIVE.length; i++) {
            _this.set(BREAK_OBTRUSIVE.charCodeAt(i), 3 /* BREAK_OBTRUSIVE */);
        }
        return _this;
    }
    WrappingCharacterClassifier.prototype.get = function (charCode) {
        // Initialize CharacterClass.BREAK_IDEOGRAPHIC for these Unicode ranges:
        // 1. CJK Unified Ideographs (0x4E00 -- 0x9FFF)
        // 2. CJK Unified Ideographs Extension A (0x3400 -- 0x4DBF)
        // 3. Hiragana and Katakana (0x3040 -- 0x30FF)
        if ((charCode >= 0x3040 && charCode <= 0x30FF)
            || (charCode >= 0x3400 && charCode <= 0x4DBF)
            || (charCode >= 0x4E00 && charCode <= 0x9FFF)) {
            return 4 /* BREAK_IDEOGRAPHIC */;
        }
        return _super.prototype.get.call(this, charCode);
    };
    return WrappingCharacterClassifier;
}(__WEBPACK_IMPORTED_MODULE_3__core_characterClassifier_js__["a" /* CharacterClassifier */]));
var CharacterHardWrappingLineMapperFactory = /** @class */ (function () {
    function CharacterHardWrappingLineMapperFactory(breakBeforeChars, breakAfterChars, breakObtrusiveChars) {
        this.classifier = new WrappingCharacterClassifier(breakBeforeChars, breakAfterChars, breakObtrusiveChars);
    }
    // TODO@Alex -> duplicated in lineCommentCommand
    CharacterHardWrappingLineMapperFactory.nextVisibleColumn = function (currentVisibleColumn, tabSize, isTab, columnSize) {
        currentVisibleColumn = +currentVisibleColumn; //@perf
        tabSize = +tabSize; //@perf
        columnSize = +columnSize; //@perf
        if (isTab) {
            return currentVisibleColumn + (tabSize - (currentVisibleColumn % tabSize));
        }
        return currentVisibleColumn + columnSize;
    };
    CharacterHardWrappingLineMapperFactory.prototype.createLineMapping = function (lineText, tabSize, breakingColumn, columnsForFullWidthChar, hardWrappingIndent) {
        if (breakingColumn === -1) {
            return null;
        }
        tabSize = +tabSize; //@perf
        breakingColumn = +breakingColumn; //@perf
        columnsForFullWidthChar = +columnsForFullWidthChar; //@perf
        hardWrappingIndent = +hardWrappingIndent; //@perf
        var wrappedTextIndentVisibleColumn = 0;
        var wrappedTextIndent = '';
        var firstNonWhitespaceIndex = -1;
        if (hardWrappingIndent !== __WEBPACK_IMPORTED_MODULE_5__config_editorOptions_js__["j" /* WrappingIndent */].None) {
            firstNonWhitespaceIndex = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["firstNonWhitespaceIndex"](lineText);
            if (firstNonWhitespaceIndex !== -1) {
                // Track existing indent
                wrappedTextIndent = lineText.substring(0, firstNonWhitespaceIndex);
                for (var i = 0; i < firstNonWhitespaceIndex; i++) {
                    wrappedTextIndentVisibleColumn = CharacterHardWrappingLineMapperFactory.nextVisibleColumn(wrappedTextIndentVisibleColumn, tabSize, lineText.charCodeAt(i) === 9 /* Tab */, 1);
                }
                // Increase indent of continuation lines, if desired
                var numberOfAdditionalTabs = 0;
                if (hardWrappingIndent === __WEBPACK_IMPORTED_MODULE_5__config_editorOptions_js__["j" /* WrappingIndent */].Indent) {
                    numberOfAdditionalTabs = 1;
                }
                else if (hardWrappingIndent === __WEBPACK_IMPORTED_MODULE_5__config_editorOptions_js__["j" /* WrappingIndent */].DeepIndent) {
                    numberOfAdditionalTabs = 2;
                }
                for (var i = 0; i < numberOfAdditionalTabs; i++) {
                    wrappedTextIndent += '\t';
                    wrappedTextIndentVisibleColumn = CharacterHardWrappingLineMapperFactory.nextVisibleColumn(wrappedTextIndentVisibleColumn, tabSize, true, 1);
                }
                // Force sticking to beginning of line if no character would fit except for the indentation
                if (wrappedTextIndentVisibleColumn + columnsForFullWidthChar > breakingColumn) {
                    wrappedTextIndent = '';
                    wrappedTextIndentVisibleColumn = 0;
                }
            }
        }
        var classifier = this.classifier;
        var lastBreakingOffset = 0; // Last 0-based offset in the lineText at which a break happened
        var breakingLengths = []; // The length of each broken-up line text
        var breakingLengthsIndex = 0; // The count of breaks already done
        var visibleColumn = 0; // Visible column since the beginning of the current line
        var niceBreakOffset = -1; // Last index of a character that indicates a break should happen before it (more desirable)
        var niceBreakVisibleColumn = 0; // visible column if a break were to be later introduced before `niceBreakOffset`
        var obtrusiveBreakOffset = -1; // Last index of a character that indicates a break should happen before it (less desirable)
        var obtrusiveBreakVisibleColumn = 0; // visible column if a break were to be later introduced before `obtrusiveBreakOffset`
        var len = lineText.length;
        for (var i = 0; i < len; i++) {
            // At this point, there is a certainty that the character before `i` fits on the current line,
            // but the character at `i` might not fit
            var charCode = lineText.charCodeAt(i);
            var charCodeIsTab = (charCode === 9 /* Tab */);
            var charCodeClass = classifier.get(charCode);
            if (charCodeClass === 1 /* BREAK_BEFORE */) {
                // This is a character that indicates that a break should happen before it
                // Since we are certain the character before `i` fits, there's no extra checking needed,
                // just mark it as a nice breaking opportunity
                niceBreakOffset = i;
                niceBreakVisibleColumn = wrappedTextIndentVisibleColumn;
            }
            // CJK breaking : before break
            if (charCodeClass === 4 /* BREAK_IDEOGRAPHIC */ && i > 0) {
                var prevCode = lineText.charCodeAt(i - 1);
                var prevClass = classifier.get(prevCode);
                if (prevClass !== 1 /* BREAK_BEFORE */) { // Kinsoku Shori: Don't break after a leading character, like an open bracket
                    niceBreakOffset = i;
                    niceBreakVisibleColumn = wrappedTextIndentVisibleColumn;
                }
            }
            var charColumnSize = 1;
            if (__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["isFullWidthCharacter"](charCode)) {
                charColumnSize = columnsForFullWidthChar;
            }
            // Advance visibleColumn with character at `i`
            visibleColumn = CharacterHardWrappingLineMapperFactory.nextVisibleColumn(visibleColumn, tabSize, charCodeIsTab, charColumnSize);
            if (visibleColumn > breakingColumn && i !== 0) {
                // We need to break at least before character at `i`:
                //  - break before niceBreakLastOffset if it exists (and re-establish a correct visibleColumn by using niceBreakVisibleColumn + charAt(i))
                //  - otherwise, break before obtrusiveBreakLastOffset if it exists (and re-establish a correct visibleColumn by using obtrusiveBreakVisibleColumn + charAt(i))
                //  - otherwise, break before i (and re-establish a correct visibleColumn by charAt(i))
                var breakBeforeOffset = void 0;
                var restoreVisibleColumnFrom = void 0;
                if (niceBreakOffset !== -1 && niceBreakVisibleColumn <= breakingColumn) {
                    // We will break before `niceBreakLastOffset`
                    breakBeforeOffset = niceBreakOffset;
                    restoreVisibleColumnFrom = niceBreakVisibleColumn;
                }
                else if (obtrusiveBreakOffset !== -1 && obtrusiveBreakVisibleColumn <= breakingColumn) {
                    // We will break before `obtrusiveBreakLastOffset`
                    breakBeforeOffset = obtrusiveBreakOffset;
                    restoreVisibleColumnFrom = obtrusiveBreakVisibleColumn;
                }
                else {
                    // We will break before `i`
                    breakBeforeOffset = i;
                    restoreVisibleColumnFrom = wrappedTextIndentVisibleColumn;
                }
                // Break before character at `breakBeforeOffset`
                breakingLengths[breakingLengthsIndex++] = breakBeforeOffset - lastBreakingOffset;
                lastBreakingOffset = breakBeforeOffset;
                // Re-establish visibleColumn by taking character at `i` into account
                visibleColumn = CharacterHardWrappingLineMapperFactory.nextVisibleColumn(restoreVisibleColumnFrom, tabSize, charCodeIsTab, charColumnSize);
                // Reset markers
                niceBreakOffset = -1;
                niceBreakVisibleColumn = 0;
                obtrusiveBreakOffset = -1;
                obtrusiveBreakVisibleColumn = 0;
            }
            // At this point, there is a certainty that the character at `i` fits on the current line
            if (niceBreakOffset !== -1) {
                // Advance niceBreakVisibleColumn
                niceBreakVisibleColumn = CharacterHardWrappingLineMapperFactory.nextVisibleColumn(niceBreakVisibleColumn, tabSize, charCodeIsTab, charColumnSize);
            }
            if (obtrusiveBreakOffset !== -1) {
                // Advance obtrusiveBreakVisibleColumn
                obtrusiveBreakVisibleColumn = CharacterHardWrappingLineMapperFactory.nextVisibleColumn(obtrusiveBreakVisibleColumn, tabSize, charCodeIsTab, charColumnSize);
            }
            if (charCodeClass === 2 /* BREAK_AFTER */ && (hardWrappingIndent === __WEBPACK_IMPORTED_MODULE_5__config_editorOptions_js__["j" /* WrappingIndent */].None || i >= firstNonWhitespaceIndex)) {
                // This is a character that indicates that a break should happen after it
                niceBreakOffset = i + 1;
                niceBreakVisibleColumn = wrappedTextIndentVisibleColumn;
            }
            // CJK breaking : after break
            if (charCodeClass === 4 /* BREAK_IDEOGRAPHIC */ && i < len - 1) {
                var nextCode = lineText.charCodeAt(i + 1);
                var nextClass = classifier.get(nextCode);
                if (nextClass !== 2 /* BREAK_AFTER */) { // Kinsoku Shori: Don't break before a trailing character, like a period
                    niceBreakOffset = i + 1;
                    niceBreakVisibleColumn = wrappedTextIndentVisibleColumn;
                }
            }
            if (charCodeClass === 3 /* BREAK_OBTRUSIVE */) {
                // This is an obtrusive character that indicates that a break should happen after it
                obtrusiveBreakOffset = i + 1;
                obtrusiveBreakVisibleColumn = wrappedTextIndentVisibleColumn;
            }
        }
        if (breakingLengthsIndex === 0) {
            return null;
        }
        // Add last segment
        breakingLengths[breakingLengthsIndex++] = len - lastBreakingOffset;
        return new CharacterHardWrappingLineMapping(new __WEBPACK_IMPORTED_MODULE_1__prefixSumComputer_js__["a" /* PrefixSumComputer */](Object(__WEBPACK_IMPORTED_MODULE_4__core_uint_js__["c" /* toUint32Array */])(breakingLengths)), wrappedTextIndent);
    };
    return CharacterHardWrappingLineMapperFactory;
}());

var CharacterHardWrappingLineMapping = /** @class */ (function () {
    function CharacterHardWrappingLineMapping(prefixSums, wrappedLinesIndent) {
        this._prefixSums = prefixSums;
        this._wrappedLinesIndent = wrappedLinesIndent;
    }
    CharacterHardWrappingLineMapping.prototype.getOutputLineCount = function () {
        return this._prefixSums.getCount();
    };
    CharacterHardWrappingLineMapping.prototype.getWrappedLinesIndent = function () {
        return this._wrappedLinesIndent;
    };
    CharacterHardWrappingLineMapping.prototype.getInputOffsetOfOutputPosition = function (outputLineIndex, outputOffset) {
        if (outputLineIndex === 0) {
            return outputOffset;
        }
        else {
            return this._prefixSums.getAccumulatedValue(outputLineIndex - 1) + outputOffset;
        }
    };
    CharacterHardWrappingLineMapping.prototype.getOutputPositionOfInputOffset = function (inputOffset) {
        var r = this._prefixSums.getIndexOf(inputOffset);
        return new __WEBPACK_IMPORTED_MODULE_2__splitLinesCollection_js__["b" /* OutputPosition */](r.index, r.remainder);
    };
    return CharacterHardWrappingLineMapping;
}());



/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linesLayout_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewModel_viewModel_js__ = __webpack_require__(62);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SMOOTH_SCROLLING_TIME = 125;
var ViewLayout = /** @class */ (function (_super) {
    __extends(ViewLayout, _super);
    function ViewLayout(configuration, lineCount, scheduleAtNextAnimationFrame) {
        var _this = _super.call(this) || this;
        _this._configuration = configuration;
        _this._linesLayout = new __WEBPACK_IMPORTED_MODULE_2__linesLayout_js__["a" /* LinesLayout */](lineCount, _this._configuration.editor.lineHeight);
        _this.scrollable = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_common_scrollable_js__["a" /* Scrollable */](0, scheduleAtNextAnimationFrame));
        _this._configureSmoothScrollDuration();
        _this.scrollable.setScrollDimensions({
            width: configuration.editor.layoutInfo.contentWidth,
            height: configuration.editor.layoutInfo.contentHeight
        });
        _this.onDidScroll = _this.scrollable.onScroll;
        _this._updateHeight();
        return _this;
    }
    ViewLayout.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    ViewLayout.prototype.onHeightMaybeChanged = function () {
        this._updateHeight();
    };
    ViewLayout.prototype._configureSmoothScrollDuration = function () {
        this.scrollable.setSmoothScrollDuration(this._configuration.editor.viewInfo.smoothScrolling ? SMOOTH_SCROLLING_TIME : 0);
    };
    // ---- begin view event handlers
    ViewLayout.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._linesLayout.setLineHeight(this._configuration.editor.lineHeight);
        }
        if (e.layoutInfo) {
            this.scrollable.setScrollDimensions({
                width: this._configuration.editor.layoutInfo.contentWidth,
                height: this._configuration.editor.layoutInfo.contentHeight
            });
        }
        if (e.viewInfo) {
            this._configureSmoothScrollDuration();
        }
        this._updateHeight();
    };
    ViewLayout.prototype.onFlushed = function (lineCount) {
        this._linesLayout.onFlushed(lineCount);
    };
    ViewLayout.prototype.onLinesDeleted = function (fromLineNumber, toLineNumber) {
        this._linesLayout.onLinesDeleted(fromLineNumber, toLineNumber);
    };
    ViewLayout.prototype.onLinesInserted = function (fromLineNumber, toLineNumber) {
        this._linesLayout.onLinesInserted(fromLineNumber, toLineNumber);
    };
    // ---- end view event handlers
    ViewLayout.prototype._getHorizontalScrollbarHeight = function (scrollDimensions) {
        if (this._configuration.editor.viewInfo.scrollbar.horizontal === __WEBPACK_IMPORTED_MODULE_1__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden) {
            // horizontal scrollbar not visible
            return 0;
        }
        if (scrollDimensions.width >= scrollDimensions.scrollWidth) {
            // horizontal scrollbar not visible
            return 0;
        }
        return this._configuration.editor.viewInfo.scrollbar.horizontalScrollbarSize;
    };
    ViewLayout.prototype._getTotalHeight = function () {
        var scrollDimensions = this.scrollable.getScrollDimensions();
        var result = this._linesLayout.getLinesTotalHeight();
        if (this._configuration.editor.viewInfo.scrollBeyondLastLine) {
            result += scrollDimensions.height - this._configuration.editor.lineHeight;
        }
        else {
            result += this._getHorizontalScrollbarHeight(scrollDimensions);
        }
        return Math.max(scrollDimensions.height, result);
    };
    ViewLayout.prototype._updateHeight = function () {
        this.scrollable.setScrollDimensions({
            scrollHeight: this._getTotalHeight()
        });
    };
    // ---- Layouting logic
    ViewLayout.prototype.getCurrentViewport = function () {
        var scrollDimensions = this.scrollable.getScrollDimensions();
        var currentScrollPosition = this.scrollable.getCurrentScrollPosition();
        return new __WEBPACK_IMPORTED_MODULE_3__viewModel_viewModel_js__["f" /* Viewport */](currentScrollPosition.scrollTop, currentScrollPosition.scrollLeft, scrollDimensions.width, scrollDimensions.height);
    };
    ViewLayout.prototype.getFutureViewport = function () {
        var scrollDimensions = this.scrollable.getScrollDimensions();
        var currentScrollPosition = this.scrollable.getFutureScrollPosition();
        return new __WEBPACK_IMPORTED_MODULE_3__viewModel_viewModel_js__["f" /* Viewport */](currentScrollPosition.scrollTop, currentScrollPosition.scrollLeft, scrollDimensions.width, scrollDimensions.height);
    };
    ViewLayout.prototype._computeScrollWidth = function (maxLineWidth, viewportWidth) {
        var isViewportWrapping = this._configuration.editor.wrappingInfo.isViewportWrapping;
        if (!isViewportWrapping) {
            var extraHorizontalSpace = this._configuration.editor.viewInfo.scrollBeyondLastColumn * this._configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
            var whitespaceMinWidth = this._linesLayout.getWhitespaceMinWidth();
            return Math.max(maxLineWidth + extraHorizontalSpace, viewportWidth, whitespaceMinWidth);
        }
        return Math.max(maxLineWidth, viewportWidth);
    };
    ViewLayout.prototype.onMaxLineWidthChanged = function (maxLineWidth) {
        var newScrollWidth = this._computeScrollWidth(maxLineWidth, this.getCurrentViewport().width);
        this.scrollable.setScrollDimensions({
            scrollWidth: newScrollWidth
        });
        // The height might depend on the fact that there is a horizontal scrollbar or not
        this._updateHeight();
    };
    // ---- view state
    ViewLayout.prototype.saveState = function () {
        var currentScrollPosition = this.scrollable.getFutureScrollPosition();
        var scrollTop = currentScrollPosition.scrollTop;
        var firstLineNumberInViewport = this._linesLayout.getLineNumberAtOrAfterVerticalOffset(scrollTop);
        var whitespaceAboveFirstLine = this._linesLayout.getWhitespaceAccumulatedHeightBeforeLineNumber(firstLineNumberInViewport);
        return {
            scrollTop: scrollTop,
            scrollTopWithoutViewZones: scrollTop - whitespaceAboveFirstLine,
            scrollLeft: currentScrollPosition.scrollLeft
        };
    };
    // ---- IVerticalLayoutProvider
    ViewLayout.prototype.addWhitespace = function (afterLineNumber, ordinal, height, minWidth) {
        return this._linesLayout.insertWhitespace(afterLineNumber, ordinal, height, minWidth);
    };
    ViewLayout.prototype.changeWhitespace = function (id, newAfterLineNumber, newHeight) {
        return this._linesLayout.changeWhitespace(id, newAfterLineNumber, newHeight);
    };
    ViewLayout.prototype.removeWhitespace = function (id) {
        return this._linesLayout.removeWhitespace(id);
    };
    ViewLayout.prototype.getVerticalOffsetForLineNumber = function (lineNumber) {
        return this._linesLayout.getVerticalOffsetForLineNumber(lineNumber);
    };
    ViewLayout.prototype.isAfterLines = function (verticalOffset) {
        return this._linesLayout.isAfterLines(verticalOffset);
    };
    ViewLayout.prototype.getLineNumberAtVerticalOffset = function (verticalOffset) {
        return this._linesLayout.getLineNumberAtOrAfterVerticalOffset(verticalOffset);
    };
    ViewLayout.prototype.getWhitespaceAtVerticalOffset = function (verticalOffset) {
        return this._linesLayout.getWhitespaceAtVerticalOffset(verticalOffset);
    };
    ViewLayout.prototype.getLinesViewportData = function () {
        var visibleBox = this.getCurrentViewport();
        return this._linesLayout.getLinesViewportData(visibleBox.top, visibleBox.top + visibleBox.height);
    };
    ViewLayout.prototype.getLinesViewportDataAtScrollTop = function (scrollTop) {
        // do some minimal validations on scrollTop
        var scrollDimensions = this.scrollable.getScrollDimensions();
        if (scrollTop + scrollDimensions.height > scrollDimensions.scrollHeight) {
            scrollTop = scrollDimensions.scrollHeight - scrollDimensions.height;
        }
        if (scrollTop < 0) {
            scrollTop = 0;
        }
        return this._linesLayout.getLinesViewportData(scrollTop, scrollTop + scrollDimensions.height);
    };
    ViewLayout.prototype.getWhitespaceViewportData = function () {
        var visibleBox = this.getCurrentViewport();
        return this._linesLayout.getWhitespaceViewportData(visibleBox.top, visibleBox.top + visibleBox.height);
    };
    ViewLayout.prototype.getWhitespaces = function () {
        return this._linesLayout.getWhitespaces();
    };
    // ---- IScrollingProvider
    ViewLayout.prototype.getScrollWidth = function () {
        var scrollDimensions = this.scrollable.getScrollDimensions();
        return scrollDimensions.scrollWidth;
    };
    ViewLayout.prototype.getScrollHeight = function () {
        var scrollDimensions = this.scrollable.getScrollDimensions();
        return scrollDimensions.scrollHeight;
    };
    ViewLayout.prototype.getCurrentScrollLeft = function () {
        var currentScrollPosition = this.scrollable.getCurrentScrollPosition();
        return currentScrollPosition.scrollLeft;
    };
    ViewLayout.prototype.getCurrentScrollTop = function () {
        var currentScrollPosition = this.scrollable.getCurrentScrollPosition();
        return currentScrollPosition.scrollTop;
    };
    ViewLayout.prototype.validateScrollPosition = function (scrollPosition) {
        return this.scrollable.validateScrollPosition(scrollPosition);
    };
    ViewLayout.prototype.setScrollPositionNow = function (position) {
        this.scrollable.setScrollPositionNow(position);
    };
    ViewLayout.prototype.setScrollPositionSmooth = function (position) {
        this.scrollable.setScrollPositionSmooth(position);
    };
    ViewLayout.prototype.deltaScrollNow = function (deltaScrollLeft, deltaScrollTop) {
        var currentScrollPosition = this.scrollable.getCurrentScrollPosition();
        this.scrollable.setScrollPositionNow({
            scrollLeft: currentScrollPosition.scrollLeft + deltaScrollLeft,
            scrollTop: currentScrollPosition.scrollTop + deltaScrollTop
        });
    };
    return ViewLayout;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinesLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__whitespaceComputer_js__ = __webpack_require__(397);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


/**
 * Layouting of objects that take vertical space (by having a height) and push down other objects.
 *
 * These objects are basically either text (lines) or spaces between those lines (whitespaces).
 * This provides commodity operations for working with lines that contain whitespace that pushes lines lower (vertically).
 * This is written with no knowledge of an editor in mind.
 */
var LinesLayout = /** @class */ (function () {
    function LinesLayout(lineCount, lineHeight) {
        this._lineCount = lineCount;
        this._lineHeight = lineHeight;
        this._whitespaces = new __WEBPACK_IMPORTED_MODULE_0__whitespaceComputer_js__["a" /* WhitespaceComputer */]();
    }
    /**
     * Change the height of a line in pixels.
     */
    LinesLayout.prototype.setLineHeight = function (lineHeight) {
        this._lineHeight = lineHeight;
    };
    /**
     * Set the number of lines.
     *
     * @param lineCount New number of lines.
     */
    LinesLayout.prototype.onFlushed = function (lineCount) {
        this._lineCount = lineCount;
    };
    /**
     * Insert a new whitespace of a certain height after a line number.
     * The whitespace has a "sticky" characteristic.
     * Irrespective of edits above or below `afterLineNumber`, the whitespace will follow the initial line.
     *
     * @param afterLineNumber The conceptual position of this whitespace. The whitespace will follow this line as best as possible even when deleting/inserting lines above/below.
     * @param heightInPx The height of the whitespace, in pixels.
     * @return An id that can be used later to mutate or delete the whitespace
     */
    LinesLayout.prototype.insertWhitespace = function (afterLineNumber, ordinal, heightInPx, minWidth) {
        return this._whitespaces.insertWhitespace(afterLineNumber, ordinal, heightInPx, minWidth);
    };
    /**
     * Change properties associated with a certain whitespace.
     */
    LinesLayout.prototype.changeWhitespace = function (id, newAfterLineNumber, newHeight) {
        return this._whitespaces.changeWhitespace(id, newAfterLineNumber, newHeight);
    };
    /**
     * Remove an existing whitespace.
     *
     * @param id The whitespace to remove
     * @return Returns true if the whitespace is found and it is removed.
     */
    LinesLayout.prototype.removeWhitespace = function (id) {
        return this._whitespaces.removeWhitespace(id);
    };
    /**
     * Notify the layouter that lines have been deleted (a continuous zone of lines).
     *
     * @param fromLineNumber The line number at which the deletion started, inclusive
     * @param toLineNumber The line number at which the deletion ended, inclusive
     */
    LinesLayout.prototype.onLinesDeleted = function (fromLineNumber, toLineNumber) {
        this._lineCount -= (toLineNumber - fromLineNumber + 1);
        this._whitespaces.onLinesDeleted(fromLineNumber, toLineNumber);
    };
    /**
     * Notify the layouter that lines have been inserted (a continuous zone of lines).
     *
     * @param fromLineNumber The line number at which the insertion started, inclusive
     * @param toLineNumber The line number at which the insertion ended, inclusive.
     */
    LinesLayout.prototype.onLinesInserted = function (fromLineNumber, toLineNumber) {
        this._lineCount += (toLineNumber - fromLineNumber + 1);
        this._whitespaces.onLinesInserted(fromLineNumber, toLineNumber);
    };
    /**
     * Get the sum of heights for all objects.
     *
     * @return The sum of heights for all objects.
     */
    LinesLayout.prototype.getLinesTotalHeight = function () {
        var linesHeight = this._lineHeight * this._lineCount;
        var whitespacesHeight = this._whitespaces.getTotalHeight();
        return linesHeight + whitespacesHeight;
    };
    /**
     * Get the vertical offset (the sum of heights for all objects above) a certain line number.
     *
     * @param lineNumber The line number
     * @return The sum of heights for all objects above `lineNumber`.
     */
    LinesLayout.prototype.getVerticalOffsetForLineNumber = function (lineNumber) {
        lineNumber = lineNumber | 0;
        var previousLinesHeight;
        if (lineNumber > 1) {
            previousLinesHeight = this._lineHeight * (lineNumber - 1);
        }
        else {
            previousLinesHeight = 0;
        }
        var previousWhitespacesHeight = this._whitespaces.getAccumulatedHeightBeforeLineNumber(lineNumber);
        return previousLinesHeight + previousWhitespacesHeight;
    };
    /**
     * Returns the accumulated height of whitespaces before the given line number.
     *
     * @param lineNumber The line number
     */
    LinesLayout.prototype.getWhitespaceAccumulatedHeightBeforeLineNumber = function (lineNumber) {
        return this._whitespaces.getAccumulatedHeightBeforeLineNumber(lineNumber);
    };
    LinesLayout.prototype.getWhitespaceMinWidth = function () {
        return this._whitespaces.getMinWidth();
    };
    /**
     * Check if `verticalOffset` is below all lines.
     */
    LinesLayout.prototype.isAfterLines = function (verticalOffset) {
        var totalHeight = this.getLinesTotalHeight();
        return verticalOffset > totalHeight;
    };
    /**
     * Find the first line number that is at or after vertical offset `verticalOffset`.
     * i.e. if getVerticalOffsetForLine(line) is x and getVerticalOffsetForLine(line + 1) is y, then
     * getLineNumberAtOrAfterVerticalOffset(i) = line, x <= i < y.
     *
     * @param verticalOffset The vertical offset to search at.
     * @return The line number at or after vertical offset `verticalOffset`.
     */
    LinesLayout.prototype.getLineNumberAtOrAfterVerticalOffset = function (verticalOffset) {
        verticalOffset = verticalOffset | 0;
        if (verticalOffset < 0) {
            return 1;
        }
        var linesCount = this._lineCount | 0;
        var lineHeight = this._lineHeight;
        var minLineNumber = 1;
        var maxLineNumber = linesCount;
        while (minLineNumber < maxLineNumber) {
            var midLineNumber = ((minLineNumber + maxLineNumber) / 2) | 0;
            var midLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(midLineNumber) | 0;
            if (verticalOffset >= midLineNumberVerticalOffset + lineHeight) {
                // vertical offset is after mid line number
                minLineNumber = midLineNumber + 1;
            }
            else if (verticalOffset >= midLineNumberVerticalOffset) {
                // Hit
                return midLineNumber;
            }
            else {
                // vertical offset is before mid line number, but mid line number could still be what we're searching for
                maxLineNumber = midLineNumber;
            }
        }
        if (minLineNumber > linesCount) {
            return linesCount;
        }
        return minLineNumber;
    };
    /**
     * Get all the lines and their relative vertical offsets that are positioned between `verticalOffset1` and `verticalOffset2`.
     *
     * @param verticalOffset1 The beginning of the viewport.
     * @param verticalOffset2 The end of the viewport.
     * @return A structure describing the lines positioned between `verticalOffset1` and `verticalOffset2`.
     */
    LinesLayout.prototype.getLinesViewportData = function (verticalOffset1, verticalOffset2) {
        verticalOffset1 = verticalOffset1 | 0;
        verticalOffset2 = verticalOffset2 | 0;
        var lineHeight = this._lineHeight;
        // Find first line number
        // We don't live in a perfect world, so the line number might start before or after verticalOffset1
        var startLineNumber = this.getLineNumberAtOrAfterVerticalOffset(verticalOffset1) | 0;
        var startLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(startLineNumber) | 0;
        var endLineNumber = this._lineCount | 0;
        // Also keep track of what whitespace we've got
        var whitespaceIndex = this._whitespaces.getFirstWhitespaceIndexAfterLineNumber(startLineNumber) | 0;
        var whitespaceCount = this._whitespaces.getCount() | 0;
        var currentWhitespaceHeight;
        var currentWhitespaceAfterLineNumber;
        if (whitespaceIndex === -1) {
            whitespaceIndex = whitespaceCount;
            currentWhitespaceAfterLineNumber = endLineNumber + 1;
            currentWhitespaceHeight = 0;
        }
        else {
            currentWhitespaceAfterLineNumber = this._whitespaces.getAfterLineNumberForWhitespaceIndex(whitespaceIndex) | 0;
            currentWhitespaceHeight = this._whitespaces.getHeightForWhitespaceIndex(whitespaceIndex) | 0;
        }
        var currentVerticalOffset = startLineNumberVerticalOffset;
        var currentLineRelativeOffset = currentVerticalOffset;
        // IE (all versions) cannot handle units above about 1,533,908 px, so every 500k pixels bring numbers down
        var STEP_SIZE = 500000;
        var bigNumbersDelta = 0;
        if (startLineNumberVerticalOffset >= STEP_SIZE) {
            // Compute a delta that guarantees that lines are positioned at `lineHeight` increments
            bigNumbersDelta = Math.floor(startLineNumberVerticalOffset / STEP_SIZE) * STEP_SIZE;
            bigNumbersDelta = Math.floor(bigNumbersDelta / lineHeight) * lineHeight;
            currentLineRelativeOffset -= bigNumbersDelta;
        }
        var linesOffsets = [];
        var verticalCenter = verticalOffset1 + (verticalOffset2 - verticalOffset1) / 2;
        var centeredLineNumber = -1;
        // Figure out how far the lines go
        for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
            if (centeredLineNumber === -1) {
                var currentLineTop = currentVerticalOffset;
                var currentLineBottom = currentVerticalOffset + lineHeight;
                if ((currentLineTop <= verticalCenter && verticalCenter < currentLineBottom) || currentLineTop > verticalCenter) {
                    centeredLineNumber = lineNumber;
                }
            }
            // Count current line height in the vertical offsets
            currentVerticalOffset += lineHeight;
            linesOffsets[lineNumber - startLineNumber] = currentLineRelativeOffset;
            // Next line starts immediately after this one
            currentLineRelativeOffset += lineHeight;
            while (currentWhitespaceAfterLineNumber === lineNumber) {
                // Push down next line with the height of the current whitespace
                currentLineRelativeOffset += currentWhitespaceHeight;
                // Count current whitespace in the vertical offsets
                currentVerticalOffset += currentWhitespaceHeight;
                whitespaceIndex++;
                if (whitespaceIndex >= whitespaceCount) {
                    currentWhitespaceAfterLineNumber = endLineNumber + 1;
                }
                else {
                    currentWhitespaceAfterLineNumber = this._whitespaces.getAfterLineNumberForWhitespaceIndex(whitespaceIndex) | 0;
                    currentWhitespaceHeight = this._whitespaces.getHeightForWhitespaceIndex(whitespaceIndex) | 0;
                }
            }
            if (currentVerticalOffset >= verticalOffset2) {
                // We have covered the entire viewport area, time to stop
                endLineNumber = lineNumber;
                break;
            }
        }
        if (centeredLineNumber === -1) {
            centeredLineNumber = endLineNumber;
        }
        var endLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(endLineNumber) | 0;
        var completelyVisibleStartLineNumber = startLineNumber;
        var completelyVisibleEndLineNumber = endLineNumber;
        if (completelyVisibleStartLineNumber < completelyVisibleEndLineNumber) {
            if (startLineNumberVerticalOffset < verticalOffset1) {
                completelyVisibleStartLineNumber++;
            }
        }
        if (completelyVisibleStartLineNumber < completelyVisibleEndLineNumber) {
            if (endLineNumberVerticalOffset + lineHeight > verticalOffset2) {
                completelyVisibleEndLineNumber--;
            }
        }
        return {
            bigNumbersDelta: bigNumbersDelta,
            startLineNumber: startLineNumber,
            endLineNumber: endLineNumber,
            relativeVerticalOffset: linesOffsets,
            centeredLineNumber: centeredLineNumber,
            completelyVisibleStartLineNumber: completelyVisibleStartLineNumber,
            completelyVisibleEndLineNumber: completelyVisibleEndLineNumber
        };
    };
    LinesLayout.prototype.getVerticalOffsetForWhitespaceIndex = function (whitespaceIndex) {
        whitespaceIndex = whitespaceIndex | 0;
        var afterLineNumber = this._whitespaces.getAfterLineNumberForWhitespaceIndex(whitespaceIndex);
        var previousLinesHeight;
        if (afterLineNumber >= 1) {
            previousLinesHeight = this._lineHeight * afterLineNumber;
        }
        else {
            previousLinesHeight = 0;
        }
        var previousWhitespacesHeight;
        if (whitespaceIndex > 0) {
            previousWhitespacesHeight = this._whitespaces.getAccumulatedHeight(whitespaceIndex - 1);
        }
        else {
            previousWhitespacesHeight = 0;
        }
        return previousLinesHeight + previousWhitespacesHeight;
    };
    LinesLayout.prototype.getWhitespaceIndexAtOrAfterVerticallOffset = function (verticalOffset) {
        verticalOffset = verticalOffset | 0;
        var midWhitespaceIndex, minWhitespaceIndex = 0, maxWhitespaceIndex = this._whitespaces.getCount() - 1, midWhitespaceVerticalOffset, midWhitespaceHeight;
        if (maxWhitespaceIndex < 0) {
            return -1;
        }
        // Special case: nothing to be found
        var maxWhitespaceVerticalOffset = this.getVerticalOffsetForWhitespaceIndex(maxWhitespaceIndex);
        var maxWhitespaceHeight = this._whitespaces.getHeightForWhitespaceIndex(maxWhitespaceIndex);
        if (verticalOffset >= maxWhitespaceVerticalOffset + maxWhitespaceHeight) {
            return -1;
        }
        while (minWhitespaceIndex < maxWhitespaceIndex) {
            midWhitespaceIndex = Math.floor((minWhitespaceIndex + maxWhitespaceIndex) / 2);
            midWhitespaceVerticalOffset = this.getVerticalOffsetForWhitespaceIndex(midWhitespaceIndex);
            midWhitespaceHeight = this._whitespaces.getHeightForWhitespaceIndex(midWhitespaceIndex);
            if (verticalOffset >= midWhitespaceVerticalOffset + midWhitespaceHeight) {
                // vertical offset is after whitespace
                minWhitespaceIndex = midWhitespaceIndex + 1;
            }
            else if (verticalOffset >= midWhitespaceVerticalOffset) {
                // Hit
                return midWhitespaceIndex;
            }
            else {
                // vertical offset is before whitespace, but midWhitespaceIndex might still be what we're searching for
                maxWhitespaceIndex = midWhitespaceIndex;
            }
        }
        return minWhitespaceIndex;
    };
    /**
     * Get exactly the whitespace that is layouted at `verticalOffset`.
     *
     * @param verticalOffset The vertical offset.
     * @return Precisely the whitespace that is layouted at `verticaloffset` or null.
     */
    LinesLayout.prototype.getWhitespaceAtVerticalOffset = function (verticalOffset) {
        verticalOffset = verticalOffset | 0;
        var candidateIndex = this.getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset);
        if (candidateIndex < 0) {
            return null;
        }
        if (candidateIndex >= this._whitespaces.getCount()) {
            return null;
        }
        var candidateTop = this.getVerticalOffsetForWhitespaceIndex(candidateIndex);
        if (candidateTop > verticalOffset) {
            return null;
        }
        var candidateHeight = this._whitespaces.getHeightForWhitespaceIndex(candidateIndex);
        var candidateId = this._whitespaces.getIdForWhitespaceIndex(candidateIndex);
        var candidateAfterLineNumber = this._whitespaces.getAfterLineNumberForWhitespaceIndex(candidateIndex);
        return {
            id: candidateId,
            afterLineNumber: candidateAfterLineNumber,
            verticalOffset: candidateTop,
            height: candidateHeight
        };
    };
    /**
     * Get a list of whitespaces that are positioned between `verticalOffset1` and `verticalOffset2`.
     *
     * @param verticalOffset1 The beginning of the viewport.
     * @param verticalOffset2 The end of the viewport.
     * @return An array with all the whitespaces in the viewport. If no whitespace is in viewport, the array is empty.
     */
    LinesLayout.prototype.getWhitespaceViewportData = function (verticalOffset1, verticalOffset2) {
        verticalOffset1 = verticalOffset1 | 0;
        verticalOffset2 = verticalOffset2 | 0;
        var startIndex = this.getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset1);
        var endIndex = this._whitespaces.getCount() - 1;
        if (startIndex < 0) {
            return [];
        }
        var result = [];
        for (var i = startIndex; i <= endIndex; i++) {
            var top_1 = this.getVerticalOffsetForWhitespaceIndex(i);
            var height = this._whitespaces.getHeightForWhitespaceIndex(i);
            if (top_1 >= verticalOffset2) {
                break;
            }
            result.push({
                id: this._whitespaces.getIdForWhitespaceIndex(i),
                afterLineNumber: this._whitespaces.getAfterLineNumberForWhitespaceIndex(i),
                verticalOffset: top_1,
                height: height
            });
        }
        return result;
    };
    /**
     * Get all whitespaces.
     */
    LinesLayout.prototype.getWhitespaces = function () {
        return this._whitespaces.getWhitespaces(this._lineHeight);
    };
    return LinesLayout;
}());



/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WhitespaceComputer; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Represent whitespaces in between lines and provide fast CRUD management methods.
 * The whitespaces are sorted ascending by `afterLineNumber`.
 */
var WhitespaceComputer = /** @class */ (function () {
    function WhitespaceComputer() {
        this._heights = [];
        this._minWidths = [];
        this._ids = [];
        this._afterLineNumbers = [];
        this._ordinals = [];
        this._prefixSum = [];
        this._prefixSumValidIndex = -1;
        this._whitespaceId2Index = {};
        this._lastWhitespaceId = 0;
        this._minWidth = -1; /* marker for not being computed */
    }
    /**
     * Find the insertion index for a new value inside a sorted array of values.
     * If the value is already present in the sorted array, the insertion index will be after the already existing value.
     */
    WhitespaceComputer.findInsertionIndex = function (sortedArray, value, ordinals, valueOrdinal) {
        var low = 0;
        var high = sortedArray.length;
        while (low < high) {
            var mid = ((low + high) >>> 1);
            if (value === sortedArray[mid]) {
                if (valueOrdinal < ordinals[mid]) {
                    high = mid;
                }
                else {
                    low = mid + 1;
                }
            }
            else if (value < sortedArray[mid]) {
                high = mid;
            }
            else {
                low = mid + 1;
            }
        }
        return low;
    };
    /**
     * Insert a new whitespace of a certain height after a line number.
     * The whitespace has a "sticky" characteristic.
     * Irrespective of edits above or below `afterLineNumber`, the whitespace will follow the initial line.
     *
     * @param afterLineNumber The conceptual position of this whitespace. The whitespace will follow this line as best as possible even when deleting/inserting lines above/below.
     * @param heightInPx The height of the whitespace, in pixels.
     * @return An id that can be used later to mutate or delete the whitespace
     */
    WhitespaceComputer.prototype.insertWhitespace = function (afterLineNumber, ordinal, heightInPx, minWidth) {
        afterLineNumber = afterLineNumber | 0;
        ordinal = ordinal | 0;
        heightInPx = heightInPx | 0;
        minWidth = minWidth | 0;
        var id = (++this._lastWhitespaceId);
        var insertionIndex = WhitespaceComputer.findInsertionIndex(this._afterLineNumbers, afterLineNumber, this._ordinals, ordinal);
        this._insertWhitespaceAtIndex(id, insertionIndex, afterLineNumber, ordinal, heightInPx, minWidth);
        this._minWidth = -1; /* marker for not being computed */
        return id;
    };
    WhitespaceComputer.prototype._insertWhitespaceAtIndex = function (id, insertIndex, afterLineNumber, ordinal, heightInPx, minWidth) {
        id = id | 0;
        insertIndex = insertIndex | 0;
        afterLineNumber = afterLineNumber | 0;
        ordinal = ordinal | 0;
        heightInPx = heightInPx | 0;
        minWidth = minWidth | 0;
        this._heights.splice(insertIndex, 0, heightInPx);
        this._minWidths.splice(insertIndex, 0, minWidth);
        this._ids.splice(insertIndex, 0, id);
        this._afterLineNumbers.splice(insertIndex, 0, afterLineNumber);
        this._ordinals.splice(insertIndex, 0, ordinal);
        this._prefixSum.splice(insertIndex, 0, 0);
        var keys = Object.keys(this._whitespaceId2Index);
        for (var i = 0, len = keys.length; i < len; i++) {
            var sid = keys[i];
            var oldIndex = this._whitespaceId2Index[sid];
            if (oldIndex >= insertIndex) {
                this._whitespaceId2Index[sid] = oldIndex + 1;
            }
        }
        this._whitespaceId2Index[id.toString()] = insertIndex;
        this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, insertIndex - 1);
    };
    /**
     * Change properties associated with a certain whitespace.
     */
    WhitespaceComputer.prototype.changeWhitespace = function (id, newAfterLineNumber, newHeight) {
        id = id | 0;
        newAfterLineNumber = newAfterLineNumber | 0;
        newHeight = newHeight | 0;
        var hasChanges = false;
        hasChanges = this.changeWhitespaceHeight(id, newHeight) || hasChanges;
        hasChanges = this.changeWhitespaceAfterLineNumber(id, newAfterLineNumber) || hasChanges;
        return hasChanges;
    };
    /**
     * Change the height of an existing whitespace
     *
     * @param id The whitespace to change
     * @param newHeightInPx The new height of the whitespace, in pixels
     * @return Returns true if the whitespace is found and if the new height is different than the old height
     */
    WhitespaceComputer.prototype.changeWhitespaceHeight = function (id, newHeightInPx) {
        id = id | 0;
        newHeightInPx = newHeightInPx | 0;
        var sid = id.toString();
        if (this._whitespaceId2Index.hasOwnProperty(sid)) {
            var index = this._whitespaceId2Index[sid];
            if (this._heights[index] !== newHeightInPx) {
                this._heights[index] = newHeightInPx;
                this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, index - 1);
                return true;
            }
        }
        return false;
    };
    /**
     * Change the line number after which an existing whitespace flows.
     *
     * @param id The whitespace to change
     * @param newAfterLineNumber The new line number the whitespace will follow
     * @return Returns true if the whitespace is found and if the new line number is different than the old line number
     */
    WhitespaceComputer.prototype.changeWhitespaceAfterLineNumber = function (id, newAfterLineNumber) {
        id = id | 0;
        newAfterLineNumber = newAfterLineNumber | 0;
        var sid = id.toString();
        if (this._whitespaceId2Index.hasOwnProperty(sid)) {
            var index = this._whitespaceId2Index[sid];
            if (this._afterLineNumbers[index] !== newAfterLineNumber) {
                // `afterLineNumber` changed for this whitespace
                // Record old ordinal
                var ordinal = this._ordinals[index];
                // Record old height
                var heightInPx = this._heights[index];
                // Record old min width
                var minWidth = this._minWidths[index];
                // Since changing `afterLineNumber` can trigger a reordering, we're gonna remove this whitespace
                this.removeWhitespace(id);
                // And add it again
                var insertionIndex = WhitespaceComputer.findInsertionIndex(this._afterLineNumbers, newAfterLineNumber, this._ordinals, ordinal);
                this._insertWhitespaceAtIndex(id, insertionIndex, newAfterLineNumber, ordinal, heightInPx, minWidth);
                return true;
            }
        }
        return false;
    };
    /**
     * Remove an existing whitespace.
     *
     * @param id The whitespace to remove
     * @return Returns true if the whitespace is found and it is removed.
     */
    WhitespaceComputer.prototype.removeWhitespace = function (id) {
        id = id | 0;
        var sid = id.toString();
        if (this._whitespaceId2Index.hasOwnProperty(sid)) {
            var index = this._whitespaceId2Index[sid];
            delete this._whitespaceId2Index[sid];
            this._removeWhitespaceAtIndex(index);
            this._minWidth = -1; /* marker for not being computed */
            return true;
        }
        return false;
    };
    WhitespaceComputer.prototype._removeWhitespaceAtIndex = function (removeIndex) {
        removeIndex = removeIndex | 0;
        this._heights.splice(removeIndex, 1);
        this._minWidths.splice(removeIndex, 1);
        this._ids.splice(removeIndex, 1);
        this._afterLineNumbers.splice(removeIndex, 1);
        this._ordinals.splice(removeIndex, 1);
        this._prefixSum.splice(removeIndex, 1);
        this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, removeIndex - 1);
        var keys = Object.keys(this._whitespaceId2Index);
        for (var i = 0, len = keys.length; i < len; i++) {
            var sid = keys[i];
            var oldIndex = this._whitespaceId2Index[sid];
            if (oldIndex >= removeIndex) {
                this._whitespaceId2Index[sid] = oldIndex - 1;
            }
        }
    };
    /**
     * Notify the computer that lines have been deleted (a continuous zone of lines).
     * This gives it a chance to update `afterLineNumber` for whitespaces, giving the "sticky" characteristic.
     *
     * @param fromLineNumber The line number at which the deletion started, inclusive
     * @param toLineNumber The line number at which the deletion ended, inclusive
     */
    WhitespaceComputer.prototype.onLinesDeleted = function (fromLineNumber, toLineNumber) {
        fromLineNumber = fromLineNumber | 0;
        toLineNumber = toLineNumber | 0;
        for (var i = 0, len = this._afterLineNumbers.length; i < len; i++) {
            var afterLineNumber = this._afterLineNumbers[i];
            if (fromLineNumber <= afterLineNumber && afterLineNumber <= toLineNumber) {
                // The line this whitespace was after has been deleted
                //  => move whitespace to before first deleted line
                this._afterLineNumbers[i] = fromLineNumber - 1;
            }
            else if (afterLineNumber > toLineNumber) {
                // The line this whitespace was after has been moved up
                //  => move whitespace up
                this._afterLineNumbers[i] -= (toLineNumber - fromLineNumber + 1);
            }
        }
    };
    /**
     * Notify the computer that lines have been inserted (a continuous zone of lines).
     * This gives it a chance to update `afterLineNumber` for whitespaces, giving the "sticky" characteristic.
     *
     * @param fromLineNumber The line number at which the insertion started, inclusive
     * @param toLineNumber The line number at which the insertion ended, inclusive.
     */
    WhitespaceComputer.prototype.onLinesInserted = function (fromLineNumber, toLineNumber) {
        fromLineNumber = fromLineNumber | 0;
        toLineNumber = toLineNumber | 0;
        for (var i = 0, len = this._afterLineNumbers.length; i < len; i++) {
            var afterLineNumber = this._afterLineNumbers[i];
            if (fromLineNumber <= afterLineNumber) {
                this._afterLineNumbers[i] += (toLineNumber - fromLineNumber + 1);
            }
        }
    };
    /**
     * Get the sum of all the whitespaces.
     */
    WhitespaceComputer.prototype.getTotalHeight = function () {
        if (this._heights.length === 0) {
            return 0;
        }
        return this.getAccumulatedHeight(this._heights.length - 1);
    };
    /**
     * Return the sum of the heights of the whitespaces at [0..index].
     * This includes the whitespace at `index`.
     *
     * @param index The index of the whitespace.
     * @return The sum of the heights of all whitespaces before the one at `index`, including the one at `index`.
     */
    WhitespaceComputer.prototype.getAccumulatedHeight = function (index) {
        index = index | 0;
        var startIndex = Math.max(0, this._prefixSumValidIndex + 1);
        if (startIndex === 0) {
            this._prefixSum[0] = this._heights[0];
            startIndex++;
        }
        for (var i = startIndex; i <= index; i++) {
            this._prefixSum[i] = this._prefixSum[i - 1] + this._heights[i];
        }
        this._prefixSumValidIndex = Math.max(this._prefixSumValidIndex, index);
        return this._prefixSum[index];
    };
    /**
     * Find all whitespaces with `afterLineNumber` < `lineNumber` and return the sum of their heights.
     *
     * @param lineNumber The line number whitespaces should be before.
     * @return The sum of the heights of the whitespaces before `lineNumber`.
     */
    WhitespaceComputer.prototype.getAccumulatedHeightBeforeLineNumber = function (lineNumber) {
        lineNumber = lineNumber | 0;
        var lastWhitespaceBeforeLineNumber = this._findLastWhitespaceBeforeLineNumber(lineNumber);
        if (lastWhitespaceBeforeLineNumber === -1) {
            return 0;
        }
        return this.getAccumulatedHeight(lastWhitespaceBeforeLineNumber);
    };
    WhitespaceComputer.prototype._findLastWhitespaceBeforeLineNumber = function (lineNumber) {
        lineNumber = lineNumber | 0;
        // Find the whitespace before line number
        var afterLineNumbers = this._afterLineNumbers;
        var low = 0;
        var high = afterLineNumbers.length - 1;
        while (low <= high) {
            var delta = (high - low) | 0;
            var halfDelta = (delta / 2) | 0;
            var mid = (low + halfDelta) | 0;
            if (afterLineNumbers[mid] < lineNumber) {
                if (mid + 1 >= afterLineNumbers.length || afterLineNumbers[mid + 1] >= lineNumber) {
                    return mid;
                }
                else {
                    low = (mid + 1) | 0;
                }
            }
            else {
                high = (mid - 1) | 0;
            }
        }
        return -1;
    };
    WhitespaceComputer.prototype._findFirstWhitespaceAfterLineNumber = function (lineNumber) {
        lineNumber = lineNumber | 0;
        var lastWhitespaceBeforeLineNumber = this._findLastWhitespaceBeforeLineNumber(lineNumber);
        var firstWhitespaceAfterLineNumber = lastWhitespaceBeforeLineNumber + 1;
        if (firstWhitespaceAfterLineNumber < this._heights.length) {
            return firstWhitespaceAfterLineNumber;
        }
        return -1;
    };
    /**
     * Find the index of the first whitespace which has `afterLineNumber` >= `lineNumber`.
     * @return The index of the first whitespace with `afterLineNumber` >= `lineNumber` or -1 if no whitespace is found.
     */
    WhitespaceComputer.prototype.getFirstWhitespaceIndexAfterLineNumber = function (lineNumber) {
        lineNumber = lineNumber | 0;
        return this._findFirstWhitespaceAfterLineNumber(lineNumber);
    };
    /**
     * The number of whitespaces.
     */
    WhitespaceComputer.prototype.getCount = function () {
        return this._heights.length;
    };
    /**
     * The maximum min width for all whitespaces.
     */
    WhitespaceComputer.prototype.getMinWidth = function () {
        if (this._minWidth === -1) {
            var minWidth = 0;
            for (var i = 0, len = this._minWidths.length; i < len; i++) {
                minWidth = Math.max(minWidth, this._minWidths[i]);
            }
            this._minWidth = minWidth;
        }
        return this._minWidth;
    };
    /**
     * Get the `afterLineNumber` for whitespace at index `index`.
     *
     * @param index The index of the whitespace.
     * @return `afterLineNumber` of whitespace at `index`.
     */
    WhitespaceComputer.prototype.getAfterLineNumberForWhitespaceIndex = function (index) {
        index = index | 0;
        return this._afterLineNumbers[index];
    };
    /**
     * Get the `id` for whitespace at index `index`.
     *
     * @param index The index of the whitespace.
     * @return `id` of whitespace at `index`.
     */
    WhitespaceComputer.prototype.getIdForWhitespaceIndex = function (index) {
        index = index | 0;
        return this._ids[index];
    };
    /**
     * Get the `height` for whitespace at index `index`.
     *
     * @param index The index of the whitespace.
     * @return `height` of whitespace at `index`.
     */
    WhitespaceComputer.prototype.getHeightForWhitespaceIndex = function (index) {
        index = index | 0;
        return this._heights[index];
    };
    /**
     * Get all whitespaces.
     */
    WhitespaceComputer.prototype.getWhitespaces = function (deviceLineHeight) {
        deviceLineHeight = deviceLineHeight | 0;
        var result = [];
        for (var i = 0; i < this._heights.length; i++) {
            result.push({
                id: this._ids[i],
                afterLineNumber: this._afterLineNumbers[i],
                heightInLines: this._heights[i] / deviceLineHeight
            });
        }
        return result;
    };
    return WhitespaceComputer;
}());



/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_viewModel_viewEventHandler_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controller_textAreaHandler_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controller_pointerHandler_js__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__viewController_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_view_viewEventDispatcher_js__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__viewOverlays_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__viewParts_contentWidgets_contentWidgets_js__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__viewParts_currentLineHighlight_currentLineHighlight_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__viewParts_currentLineMarginHighlight_currentLineMarginHighlight_js__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__viewParts_decorations_decorations_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__viewParts_glyphMargin_glyphMargin_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__viewParts_lineNumbers_lineNumbers_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__viewParts_indentGuides_indentGuides_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__viewParts_lines_viewLines_js__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__viewParts_margin_margin_js__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__viewParts_linesDecorations_linesDecorations_js__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__viewParts_marginDecorations_marginDecorations_js__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__viewParts_overlayWidgets_overlayWidgets_js__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__viewParts_overviewRuler_decorationsOverviewRuler_js__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__viewParts_overviewRuler_overviewRuler_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__viewParts_rulers_rulers_js__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__viewParts_scrollDecoration_scrollDecoration_js__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__viewParts_selections_selections_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__viewParts_viewCursors_viewCursors_js__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__viewParts_viewZones_viewZones_js__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_view_viewContext_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__common_view_renderingContext_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__viewOutgoingEvents_js__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__common_viewLayout_viewLinesViewportData_js__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__viewParts_editorScrollbar_editorScrollbar_js__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__viewParts_minimap_minimap_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__common_view_viewEvents_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__platform_theme_common_themeService_js__ = __webpack_require__(13);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






































var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View(commandDelegate, configuration, themeService, model, cursor, execCoreEditorCommandFunc) {
        var _this = _super.call(this) || this;
        _this._cursor = cursor;
        _this._renderAnimationFrame = null;
        _this.outgoingEvents = new __WEBPACK_IMPORTED_MODULE_32__viewOutgoingEvents_js__["a" /* ViewOutgoingEvents */](model);
        var viewController = new __WEBPACK_IMPORTED_MODULE_7__viewController_js__["a" /* ViewController */](configuration, model, execCoreEditorCommandFunc, _this.outgoingEvents, commandDelegate);
        // The event dispatcher will always go through _renderOnce before dispatching any events
        _this.eventDispatcher = new __WEBPACK_IMPORTED_MODULE_8__common_view_viewEventDispatcher_js__["a" /* ViewEventDispatcher */](function (callback) { return _this._renderOnce(callback); });
        // Ensure the view is the first event handler in order to update the layout
        _this.eventDispatcher.addEventHandler(_this);
        // The view context is passed on to most classes (basically to reduce param. counts in ctors)
        _this._context = new __WEBPACK_IMPORTED_MODULE_30__common_view_viewContext_js__["a" /* ViewContext */](configuration, themeService.getTheme(), model, _this.eventDispatcher);
        _this._register(themeService.onThemeChange(function (theme) {
            _this._context.theme = theme;
            _this.eventDispatcher.emit(new __WEBPACK_IMPORTED_MODULE_36__common_view_viewEvents_js__["n" /* ViewThemeChangedEvent */]());
            _this.render(true, false);
        }));
        _this.viewParts = [];
        // Keyboard handler
        _this._textAreaHandler = new __WEBPACK_IMPORTED_MODULE_5__controller_textAreaHandler_js__["a" /* TextAreaHandler */](_this._context, viewController, _this.createTextAreaHandlerHelper());
        _this.viewParts.push(_this._textAreaHandler);
        _this.createViewParts();
        _this._setLayout();
        // Pointer handler
        _this.pointerHandler = new __WEBPACK_IMPORTED_MODULE_6__controller_pointerHandler_js__["a" /* PointerHandler */](_this._context, viewController, _this.createPointerHandlerHelper());
        _this._register(model.addEventListener(function (events) {
            _this.eventDispatcher.emitMany(events);
        }));
        _this._register(_this._cursor.addEventListener(function (events) {
            _this.eventDispatcher.emitMany(events);
        }));
        return _this;
    }
    View.prototype.createViewParts = function () {
        // These two dom nodes must be constructed up front, since references are needed in the layout provider (scrolling & co.)
        this.linesContent = Object(__WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        this.linesContent.setClassName('lines-content' + ' monaco-editor-background');
        this.linesContent.setPosition('absolute');
        this.domNode = Object(__WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        this.domNode.setClassName(this.getEditorClassName());
        this.overflowGuardContainer = Object(__WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        __WEBPACK_IMPORTED_MODULE_29__viewPart_js__["a" /* PartFingerprints */].write(this.overflowGuardContainer, 3 /* OverflowGuard */);
        this.overflowGuardContainer.setClassName('overflow-guard');
        this._scrollbar = new __WEBPACK_IMPORTED_MODULE_34__viewParts_editorScrollbar_editorScrollbar_js__["a" /* EditorScrollbar */](this._context, this.linesContent, this.domNode, this.overflowGuardContainer);
        this.viewParts.push(this._scrollbar);
        // View Lines
        this.viewLines = new __WEBPACK_IMPORTED_MODULE_17__viewParts_lines_viewLines_js__["a" /* ViewLines */](this._context, this.linesContent);
        // View Zones
        this.viewZones = new __WEBPACK_IMPORTED_MODULE_28__viewParts_viewZones_viewZones_js__["a" /* ViewZones */](this._context);
        this.viewParts.push(this.viewZones);
        // Decorations overview ruler
        var decorationsOverviewRuler = new __WEBPACK_IMPORTED_MODULE_22__viewParts_overviewRuler_decorationsOverviewRuler_js__["a" /* DecorationsOverviewRuler */](this._context);
        this.viewParts.push(decorationsOverviewRuler);
        var scrollDecoration = new __WEBPACK_IMPORTED_MODULE_25__viewParts_scrollDecoration_scrollDecoration_js__["a" /* ScrollDecorationViewPart */](this._context);
        this.viewParts.push(scrollDecoration);
        var contentViewOverlays = new __WEBPACK_IMPORTED_MODULE_9__viewOverlays_js__["a" /* ContentViewOverlays */](this._context);
        this.viewParts.push(contentViewOverlays);
        contentViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_11__viewParts_currentLineHighlight_currentLineHighlight_js__["a" /* CurrentLineHighlightOverlay */](this._context));
        contentViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_26__viewParts_selections_selections_js__["a" /* SelectionsOverlay */](this._context));
        contentViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_16__viewParts_indentGuides_indentGuides_js__["a" /* IndentGuidesOverlay */](this._context));
        contentViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_13__viewParts_decorations_decorations_js__["a" /* DecorationsOverlay */](this._context));
        var marginViewOverlays = new __WEBPACK_IMPORTED_MODULE_9__viewOverlays_js__["b" /* MarginViewOverlays */](this._context);
        this.viewParts.push(marginViewOverlays);
        marginViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_12__viewParts_currentLineMarginHighlight_currentLineMarginHighlight_js__["a" /* CurrentLineMarginHighlightOverlay */](this._context));
        marginViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_14__viewParts_glyphMargin_glyphMargin_js__["c" /* GlyphMarginOverlay */](this._context));
        marginViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_20__viewParts_marginDecorations_marginDecorations_js__["a" /* MarginViewLineDecorationsOverlay */](this._context));
        marginViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_19__viewParts_linesDecorations_linesDecorations_js__["a" /* LinesDecorationsOverlay */](this._context));
        marginViewOverlays.addDynamicOverlay(new __WEBPACK_IMPORTED_MODULE_15__viewParts_lineNumbers_lineNumbers_js__["a" /* LineNumbersOverlay */](this._context));
        var margin = new __WEBPACK_IMPORTED_MODULE_18__viewParts_margin_margin_js__["a" /* Margin */](this._context);
        margin.getDomNode().appendChild(this.viewZones.marginDomNode);
        margin.getDomNode().appendChild(marginViewOverlays.getDomNode());
        this.viewParts.push(margin);
        // Content widgets
        this.contentWidgets = new __WEBPACK_IMPORTED_MODULE_10__viewParts_contentWidgets_contentWidgets_js__["a" /* ViewContentWidgets */](this._context, this.domNode);
        this.viewParts.push(this.contentWidgets);
        this.viewCursors = new __WEBPACK_IMPORTED_MODULE_27__viewParts_viewCursors_viewCursors_js__["a" /* ViewCursors */](this._context);
        this.viewParts.push(this.viewCursors);
        // Overlay widgets
        this.overlayWidgets = new __WEBPACK_IMPORTED_MODULE_21__viewParts_overlayWidgets_overlayWidgets_js__["a" /* ViewOverlayWidgets */](this._context);
        this.viewParts.push(this.overlayWidgets);
        var rulers = new __WEBPACK_IMPORTED_MODULE_24__viewParts_rulers_rulers_js__["a" /* Rulers */](this._context);
        this.viewParts.push(rulers);
        var minimap = new __WEBPACK_IMPORTED_MODULE_35__viewParts_minimap_minimap_js__["a" /* Minimap */](this._context);
        this.viewParts.push(minimap);
        // -------------- Wire dom nodes up
        if (decorationsOverviewRuler) {
            var overviewRulerData = this._scrollbar.getOverviewRulerLayoutInfo();
            overviewRulerData.parent.insertBefore(decorationsOverviewRuler.getDomNode(), overviewRulerData.insertBefore);
        }
        this.linesContent.appendChild(contentViewOverlays.getDomNode());
        this.linesContent.appendChild(rulers.domNode);
        this.linesContent.appendChild(this.viewZones.domNode);
        this.linesContent.appendChild(this.viewLines.getDomNode());
        this.linesContent.appendChild(this.contentWidgets.domNode);
        this.linesContent.appendChild(this.viewCursors.getDomNode());
        this.overflowGuardContainer.appendChild(margin.getDomNode());
        this.overflowGuardContainer.appendChild(this._scrollbar.getDomNode());
        this.overflowGuardContainer.appendChild(scrollDecoration.getDomNode());
        this.overflowGuardContainer.appendChild(this._textAreaHandler.textArea);
        this.overflowGuardContainer.appendChild(this._textAreaHandler.textAreaCover);
        this.overflowGuardContainer.appendChild(this.overlayWidgets.getDomNode());
        this.overflowGuardContainer.appendChild(minimap.getDomNode());
        this.domNode.appendChild(this.overflowGuardContainer);
        this.domNode.appendChild(this.contentWidgets.overflowingContentWidgetsDomNode);
    };
    View.prototype._flushAccumulatedAndRenderNow = function () {
        this._renderNow();
    };
    View.prototype.createPointerHandlerHelper = function () {
        var _this = this;
        return {
            viewDomNode: this.domNode.domNode,
            linesContentDomNode: this.linesContent.domNode,
            focusTextArea: function () {
                _this.focus();
            },
            getLastViewCursorsRenderData: function () {
                return _this.viewCursors.getLastRenderData() || [];
            },
            shouldSuppressMouseDownOnViewZone: function (viewZoneId) {
                return _this.viewZones.shouldSuppressMouseDownOnViewZone(viewZoneId);
            },
            shouldSuppressMouseDownOnWidget: function (widgetId) {
                return _this.contentWidgets.shouldSuppressMouseDownOnWidget(widgetId);
            },
            getPositionFromDOMInfo: function (spanNode, offset) {
                _this._flushAccumulatedAndRenderNow();
                return _this.viewLines.getPositionFromDOMInfo(spanNode, offset);
            },
            visibleRangeForPosition2: function (lineNumber, column) {
                _this._flushAccumulatedAndRenderNow();
                var visibleRanges = _this.viewLines.visibleRangesForRange2(new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column));
                if (!visibleRanges) {
                    return null;
                }
                return visibleRanges[0];
            },
            getLineWidth: function (lineNumber) {
                _this._flushAccumulatedAndRenderNow();
                return _this.viewLines.getLineWidth(lineNumber);
            }
        };
    };
    View.prototype.createTextAreaHandlerHelper = function () {
        var _this = this;
        return {
            visibleRangeForPositionRelativeToEditor: function (lineNumber, column) {
                _this._flushAccumulatedAndRenderNow();
                var visibleRanges = _this.viewLines.visibleRangesForRange2(new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column));
                if (!visibleRanges) {
                    return null;
                }
                return visibleRanges[0];
            }
        };
    };
    View.prototype._setLayout = function () {
        var layoutInfo = this._context.configuration.editor.layoutInfo;
        this.domNode.setWidth(layoutInfo.width);
        this.domNode.setHeight(layoutInfo.height);
        this.overflowGuardContainer.setWidth(layoutInfo.width);
        this.overflowGuardContainer.setHeight(layoutInfo.height);
        this.linesContent.setWidth(1000000);
        this.linesContent.setHeight(1000000);
    };
    View.prototype.getEditorClassName = function () {
        var focused = this._textAreaHandler.isFocused() ? ' focused' : '';
        return this._context.configuration.editor.editorClassName + ' ' + Object(__WEBPACK_IMPORTED_MODULE_37__platform_theme_common_themeService_js__["d" /* getThemeTypeSelector */])(this._context.theme.type) + focused;
    };
    // --- begin event handlers
    View.prototype.onConfigurationChanged = function (e) {
        if (e.editorClassName) {
            this.domNode.setClassName(this.getEditorClassName());
        }
        if (e.layoutInfo) {
            this._setLayout();
        }
        return false;
    };
    View.prototype.onFocusChanged = function (e) {
        this.domNode.setClassName(this.getEditorClassName());
        this._context.model.setHasFocus(e.isFocused);
        if (e.isFocused) {
            this.outgoingEvents.emitViewFocusGained();
        }
        else {
            this.outgoingEvents.emitViewFocusLost();
        }
        return false;
    };
    View.prototype.onScrollChanged = function (e) {
        this.outgoingEvents.emitScrollChanged(e);
        return false;
    };
    View.prototype.onThemeChanged = function (e) {
        this.domNode.setClassName(this.getEditorClassName());
        return false;
    };
    // --- end event handlers
    View.prototype.dispose = function () {
        if (this._renderAnimationFrame !== null) {
            this._renderAnimationFrame.dispose();
            this._renderAnimationFrame = null;
        }
        this.eventDispatcher.removeEventHandler(this);
        this.outgoingEvents.dispose();
        this.pointerHandler.dispose();
        this.viewLines.dispose();
        // Destroy view parts
        for (var i = 0, len = this.viewParts.length; i < len; i++) {
            this.viewParts[i].dispose();
        }
        this.viewParts = [];
        _super.prototype.dispose.call(this);
    };
    View.prototype._renderOnce = function (callback) {
        var r = safeInvokeNoArg(callback);
        this._scheduleRender();
        return r;
    };
    View.prototype._scheduleRender = function () {
        if (this._renderAnimationFrame === null) {
            this._renderAnimationFrame = __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["J" /* runAtThisOrScheduleAtNextAnimationFrame */](this._onRenderScheduled.bind(this), 100);
        }
    };
    View.prototype._onRenderScheduled = function () {
        this._renderAnimationFrame = null;
        this._flushAccumulatedAndRenderNow();
    };
    View.prototype._renderNow = function () {
        var _this = this;
        safeInvokeNoArg(function () { return _this._actualRender(); });
    };
    View.prototype._getViewPartsToRender = function () {
        var result = [], resultLen = 0;
        for (var i = 0, len = this.viewParts.length; i < len; i++) {
            var viewPart = this.viewParts[i];
            if (viewPart.shouldRender()) {
                result[resultLen++] = viewPart;
            }
        }
        return result;
    };
    View.prototype._actualRender = function () {
        if (!__WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["D" /* isInDOM */](this.domNode.domNode)) {
            return;
        }
        var viewPartsToRender = this._getViewPartsToRender();
        if (!this.viewLines.shouldRender() && viewPartsToRender.length === 0) {
            // Nothing to render
            return;
        }
        var partialViewportData = this._context.viewLayout.getLinesViewportData();
        this._context.model.setViewport(partialViewportData.startLineNumber, partialViewportData.endLineNumber, partialViewportData.centeredLineNumber);
        var viewportData = new __WEBPACK_IMPORTED_MODULE_33__common_viewLayout_viewLinesViewportData_js__["a" /* ViewportData */](this._cursor.getViewSelections(), partialViewportData, this._context.viewLayout.getWhitespaceViewportData(), this._context.model);
        if (this.contentWidgets.shouldRender()) {
            // Give the content widgets a chance to set their max width before a possible synchronous layout
            this.contentWidgets.onBeforeRender(viewportData);
        }
        if (this.viewLines.shouldRender()) {
            this.viewLines.renderText(viewportData);
            this.viewLines.onDidRender();
            // Rendering of viewLines might cause scroll events to occur, so collect view parts to render again
            viewPartsToRender = this._getViewPartsToRender();
        }
        var renderingContext = new __WEBPACK_IMPORTED_MODULE_31__common_view_renderingContext_js__["c" /* RenderingContext */](this._context.viewLayout, viewportData, this.viewLines);
        // Render the rest of the parts
        for (var i = 0, len = viewPartsToRender.length; i < len; i++) {
            var viewPart = viewPartsToRender[i];
            viewPart.prepareRender(renderingContext);
        }
        for (var i = 0, len = viewPartsToRender.length; i < len; i++) {
            var viewPart = viewPartsToRender[i];
            viewPart.render(renderingContext);
            viewPart.onDidRender();
        }
    };
    // --- BEGIN CodeEditor helpers
    View.prototype.delegateVerticalScrollbarMouseDown = function (browserEvent) {
        this._scrollbar.delegateVerticalScrollbarMouseDown(browserEvent);
    };
    View.prototype.restoreState = function (scrollPosition) {
        this._context.viewLayout.setScrollPositionNow({ scrollTop: scrollPosition.scrollTop });
        this._renderNow();
        this.viewLines.updateLineWidths();
        this._context.viewLayout.setScrollPositionNow({ scrollLeft: scrollPosition.scrollLeft });
    };
    View.prototype.getOffsetForColumn = function (modelLineNumber, modelColumn) {
        var modelPosition = this._context.model.validateModelPosition({
            lineNumber: modelLineNumber,
            column: modelColumn
        });
        var viewPosition = this._context.model.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
        this._flushAccumulatedAndRenderNow();
        var visibleRanges = this.viewLines.visibleRangesForRange2(new __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */](viewPosition.lineNumber, viewPosition.column, viewPosition.lineNumber, viewPosition.column));
        if (!visibleRanges) {
            return -1;
        }
        return visibleRanges[0].left;
    };
    View.prototype.getTargetAtClientPoint = function (clientX, clientY) {
        return this.pointerHandler.getTargetAtClientPoint(clientX, clientY);
    };
    View.prototype.getInternalEventBus = function () {
        return this.outgoingEvents;
    };
    View.prototype.createOverviewRuler = function (cssClassName) {
        return new __WEBPACK_IMPORTED_MODULE_23__viewParts_overviewRuler_overviewRuler_js__["a" /* OverviewRuler */](this._context, cssClassName);
    };
    View.prototype.change = function (callback) {
        var _this = this;
        var zonesHaveChanged = false;
        this._renderOnce(function () {
            var changeAccessor = {
                addZone: function (zone) {
                    zonesHaveChanged = true;
                    return _this.viewZones.addZone(zone);
                },
                removeZone: function (id) {
                    if (!id) {
                        return;
                    }
                    zonesHaveChanged = _this.viewZones.removeZone(id) || zonesHaveChanged;
                },
                layoutZone: function (id) {
                    if (!id) {
                        return;
                    }
                    zonesHaveChanged = _this.viewZones.layoutZone(id) || zonesHaveChanged;
                }
            };
            safeInvoke1Arg(callback, changeAccessor);
            // Invalidate changeAccessor
            changeAccessor.addZone = null;
            changeAccessor.removeZone = null;
            if (zonesHaveChanged) {
                _this._context.viewLayout.onHeightMaybeChanged();
                _this._context.privateViewEventBus.emit(new __WEBPACK_IMPORTED_MODULE_36__common_view_viewEvents_js__["q" /* ViewZonesChangedEvent */]());
            }
        });
        return zonesHaveChanged;
    };
    View.prototype.render = function (now, everything) {
        if (everything) {
            // Force everything to render...
            this.viewLines.forceShouldRender();
            for (var i = 0, len = this.viewParts.length; i < len; i++) {
                var viewPart = this.viewParts[i];
                viewPart.forceShouldRender();
            }
        }
        if (now) {
            this._flushAccumulatedAndRenderNow();
        }
        else {
            this._scheduleRender();
        }
    };
    View.prototype.focus = function () {
        this._textAreaHandler.focusTextArea();
    };
    View.prototype.isFocused = function () {
        return this._textAreaHandler.isFocused();
    };
    View.prototype.addContentWidget = function (widgetData) {
        this.contentWidgets.addWidget(widgetData.widget);
        this.layoutContentWidget(widgetData);
        this._scheduleRender();
    };
    View.prototype.layoutContentWidget = function (widgetData) {
        var newPosition = widgetData.position ? widgetData.position.position : null;
        var newPreference = widgetData.position ? widgetData.position.preference : null;
        this.contentWidgets.setWidgetPosition(widgetData.widget, newPosition, newPreference);
        this._scheduleRender();
    };
    View.prototype.removeContentWidget = function (widgetData) {
        this.contentWidgets.removeWidget(widgetData.widget);
        this._scheduleRender();
    };
    View.prototype.addOverlayWidget = function (widgetData) {
        this.overlayWidgets.addWidget(widgetData.widget);
        this.layoutOverlayWidget(widgetData);
        this._scheduleRender();
    };
    View.prototype.layoutOverlayWidget = function (widgetData) {
        var newPreference = widgetData.position ? widgetData.position.preference : null;
        var shouldRender = this.overlayWidgets.setWidgetPosition(widgetData.widget, newPreference);
        if (shouldRender) {
            this._scheduleRender();
        }
    };
    View.prototype.removeOverlayWidget = function (widgetData) {
        this.overlayWidgets.removeWidget(widgetData.widget);
        this._scheduleRender();
    };
    return View;
}(__WEBPACK_IMPORTED_MODULE_4__common_viewModel_viewEventHandler_js__["a" /* ViewEventHandler */]));

function safeInvokeNoArg(func) {
    try {
        return func();
    }
    catch (e) {
        Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
    }
}
function safeInvoke1Arg(func, arg1) {
    try {
        return func(arg1);
    }
    catch (e) {
        Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
    }
}


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextAreaHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__textAreaHandler_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__textAreaHandler_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__textAreaHandler_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__textAreaInput_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_configuration_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_view_viewEvents_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__viewParts_margin_margin_js__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__viewParts_lineNumbers_lineNumbers_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_controller_wordCharacterClassifier_js__ = __webpack_require__(82);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
















var VisibleTextAreaData = /** @class */ (function () {
    function VisibleTextAreaData(top, left, width) {
        this.top = top;
        this.left = left;
        this.width = width;
    }
    VisibleTextAreaData.prototype.setWidth = function (width) {
        return new VisibleTextAreaData(this.top, this.left, width);
    };
    return VisibleTextAreaData;
}());
var canUseZeroSizeTextarea = (__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["h" /* isEdgeOrIE */] || __WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["j" /* isFirefox */]);
/**
 * Every time we write to the clipboard, we record a bit of extra metadata here.
 * Every time we read from the cipboard, if the text matches our last written text,
 * we can fetch the previous metadata.
 */
var LocalClipboardMetadataManager = /** @class */ (function () {
    function LocalClipboardMetadataManager() {
        this._lastState = null;
    }
    LocalClipboardMetadataManager.prototype.set = function (state) {
        this._lastState = state;
    };
    LocalClipboardMetadataManager.prototype.get = function (pastedText) {
        if (this._lastState && this._lastState.lastCopiedValue === pastedText) {
            // match!
            return this._lastState;
        }
        this._lastState = null;
        return null;
    };
    LocalClipboardMetadataManager.INSTANCE = new LocalClipboardMetadataManager();
    return LocalClipboardMetadataManager;
}());
var TextAreaHandler = /** @class */ (function (_super) {
    __extends(TextAreaHandler, _super);
    function TextAreaHandler(context, viewController, viewHelper) {
        var _this = _super.call(this, context) || this;
        // --- end view API
        _this._primaryCursorVisibleRange = null;
        _this._viewController = viewController;
        _this._viewHelper = viewHelper;
        var conf = _this._context.configuration.editor;
        _this._accessibilitySupport = conf.accessibilitySupport;
        _this._contentLeft = conf.layoutInfo.contentLeft;
        _this._contentWidth = conf.layoutInfo.contentWidth;
        _this._contentHeight = conf.layoutInfo.contentHeight;
        _this._scrollLeft = 0;
        _this._scrollTop = 0;
        _this._fontInfo = conf.fontInfo;
        _this._lineHeight = conf.lineHeight;
        _this._emptySelectionClipboard = conf.emptySelectionClipboard;
        _this._visibleTextArea = null;
        _this._selections = [new __WEBPACK_IMPORTED_MODULE_7__common_core_selection_js__["a" /* Selection */](1, 1, 1, 1)];
        // Text Area (The focus will always be in the textarea when the cursor is blinking)
        _this.textArea = Object(__WEBPACK_IMPORTED_MODULE_11__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('textarea'));
        __WEBPACK_IMPORTED_MODULE_12__view_viewPart_js__["a" /* PartFingerprints */].write(_this.textArea, 6 /* TextArea */);
        _this.textArea.setClassName('inputarea');
        _this.textArea.setAttribute('wrap', 'off');
        _this.textArea.setAttribute('autocorrect', 'off');
        _this.textArea.setAttribute('autocapitalize', 'off');
        _this.textArea.setAttribute('autocomplete', 'off');
        _this.textArea.setAttribute('spellcheck', 'false');
        _this.textArea.setAttribute('aria-label', conf.viewInfo.ariaLabel);
        _this.textArea.setAttribute('role', 'textbox');
        _this.textArea.setAttribute('aria-multiline', 'true');
        _this.textArea.setAttribute('aria-haspopup', 'false');
        _this.textArea.setAttribute('aria-autocomplete', 'both');
        _this.textAreaCover = Object(__WEBPACK_IMPORTED_MODULE_11__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.textAreaCover.setPosition('absolute');
        var simpleModel = {
            getLineCount: function () {
                return _this._context.model.getLineCount();
            },
            getLineMaxColumn: function (lineNumber) {
                return _this._context.model.getLineMaxColumn(lineNumber);
            },
            getValueInRange: function (range, eol) {
                return _this._context.model.getValueInRange(range, eol);
            }
        };
        var textAreaInputHost = {
            getPlainTextToCopy: function () {
                var rawWhatToCopy = _this._context.model.getPlainTextToCopy(_this._selections, _this._emptySelectionClipboard, __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["g" /* isWindows */]);
                var newLineCharacter = _this._context.model.getEOL();
                var isFromEmptySelection = (_this._emptySelectionClipboard && _this._selections.length === 1 && _this._selections[0].isEmpty());
                var multicursorText = (Array.isArray(rawWhatToCopy) ? rawWhatToCopy : null);
                var whatToCopy = (Array.isArray(rawWhatToCopy) ? rawWhatToCopy.join(newLineCharacter) : rawWhatToCopy);
                var metadata = null;
                if (isFromEmptySelection || multicursorText) {
                    // Only store the non-default metadata
                    // When writing "LINE\r\n" to the clipboard and then pasting,
                    // Firefox pastes "LINE\n", so let's work around this quirk
                    var lastCopiedValue = (__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["j" /* isFirefox */] ? whatToCopy.replace(/\r\n/g, '\n') : whatToCopy);
                    metadata = {
                        lastCopiedValue: lastCopiedValue,
                        isFromEmptySelection: (_this._emptySelectionClipboard && _this._selections.length === 1 && _this._selections[0].isEmpty()),
                        multicursorText: multicursorText
                    };
                }
                LocalClipboardMetadataManager.INSTANCE.set(metadata);
                return whatToCopy;
            },
            getHTMLToCopy: function () {
                return _this._context.model.getHTMLToCopy(_this._selections, _this._emptySelectionClipboard);
            },
            getScreenReaderContent: function (currentState) {
                if (__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["l" /* isIPad */]) {
                    // Do not place anything in the textarea for the iPad
                    return __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].EMPTY;
                }
                if (_this._accessibilitySupport === 1 /* Disabled */) {
                    // We know for a fact that a screen reader is not attached
                    // On OSX, we write the character before the cursor to allow for "long-press" composition
                    // Also on OSX, we write the word before the cursor to allow for the Accessibility Keyboard to give good hints
                    if (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["d" /* isMacintosh */]) {
                        var selection = _this._selections[0];
                        if (selection.isEmpty()) {
                            var position = selection.getStartPosition();
                            var textBefore = _this._getWordBeforePosition(position);
                            if (textBefore.length === 0) {
                                textBefore = _this._getCharacterBeforePosition(position);
                            }
                            if (textBefore.length > 0) {
                                return new __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */](textBefore, textBefore.length, textBefore.length, position, position);
                            }
                        }
                    }
                    return __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["b" /* TextAreaState */].EMPTY;
                }
                return __WEBPACK_IMPORTED_MODULE_5__textAreaState_js__["a" /* PagedScreenReaderStrategy */].fromEditorSelection(currentState, simpleModel, _this._selections[0], _this._accessibilitySupport === 0 /* Unknown */);
            },
            deduceModelPosition: function (viewAnchorPosition, deltaOffset, lineFeedCnt) {
                return _this._context.model.deduceModelPositionRelativeToViewPosition(viewAnchorPosition, deltaOffset, lineFeedCnt);
            }
        };
        _this._textAreaInput = _this._register(new __WEBPACK_IMPORTED_MODULE_4__textAreaInput_js__["b" /* TextAreaInput */](textAreaInputHost, _this.textArea));
        _this._register(_this._textAreaInput.onKeyDown(function (e) {
            _this._viewController.emitKeyDown(e);
        }));
        _this._register(_this._textAreaInput.onKeyUp(function (e) {
            _this._viewController.emitKeyUp(e);
        }));
        _this._register(_this._textAreaInput.onPaste(function (e) {
            var metadata = LocalClipboardMetadataManager.INSTANCE.get(e.text);
            var pasteOnNewLine = false;
            var multicursorText = null;
            if (metadata) {
                pasteOnNewLine = (_this._emptySelectionClipboard && metadata.isFromEmptySelection);
                multicursorText = metadata.multicursorText;
            }
            _this._viewController.paste('keyboard', e.text, pasteOnNewLine, multicursorText);
        }));
        _this._register(_this._textAreaInput.onCut(function () {
            _this._viewController.cut('keyboard');
        }));
        _this._register(_this._textAreaInput.onType(function (e) {
            if (e.replaceCharCnt) {
                _this._viewController.replacePreviousChar('keyboard', e.text, e.replaceCharCnt);
            }
            else {
                _this._viewController.type('keyboard', e.text);
            }
        }));
        _this._register(_this._textAreaInput.onSelectionChangeRequest(function (modelSelection) {
            _this._viewController.setSelection('keyboard', modelSelection);
        }));
        _this._register(_this._textAreaInput.onCompositionStart(function () {
            var lineNumber = _this._selections[0].startLineNumber;
            var column = _this._selections[0].startColumn;
            _this._context.privateViewEventBus.emit(new __WEBPACK_IMPORTED_MODULE_10__common_view_viewEvents_js__["l" /* ViewRevealRangeRequestEvent */](new __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */](lineNumber, column, lineNumber, column), 0 /* Simple */, true, 1 /* Immediate */));
            // Find range pixel position
            var visibleRange = _this._viewHelper.visibleRangeForPositionRelativeToEditor(lineNumber, column);
            if (visibleRange) {
                _this._visibleTextArea = new VisibleTextAreaData(_this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber), visibleRange.left, canUseZeroSizeTextarea ? 0 : 1);
                _this._render();
            }
            // Show the textarea
            _this.textArea.setClassName('inputarea ime-input');
            _this._viewController.compositionStart('keyboard');
        }));
        _this._register(_this._textAreaInput.onCompositionUpdate(function (e) {
            if (__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["h" /* isEdgeOrIE */]) {
                // Due to isEdgeOrIE (where the textarea was not cleared initially)
                // we cannot assume the text consists only of the composited text
                _this._visibleTextArea = _this._visibleTextArea.setWidth(0);
            }
            else {
                // adjust width by its size
                _this._visibleTextArea = _this._visibleTextArea.setWidth(measureText(e.data, _this._fontInfo));
            }
            _this._render();
        }));
        _this._register(_this._textAreaInput.onCompositionEnd(function () {
            _this._visibleTextArea = null;
            _this._render();
            _this.textArea.setClassName('inputarea');
            _this._viewController.compositionEnd('keyboard');
        }));
        _this._register(_this._textAreaInput.onFocus(function () {
            _this._context.privateViewEventBus.emit(new __WEBPACK_IMPORTED_MODULE_10__common_view_viewEvents_js__["f" /* ViewFocusChangedEvent */](true));
        }));
        _this._register(_this._textAreaInput.onBlur(function () {
            _this._context.privateViewEventBus.emit(new __WEBPACK_IMPORTED_MODULE_10__common_view_viewEvents_js__["f" /* ViewFocusChangedEvent */](false));
        }));
        return _this;
    }
    TextAreaHandler.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    TextAreaHandler.prototype._getWordBeforePosition = function (position) {
        var lineContent = this._context.model.getLineContent(position.lineNumber);
        var wordSeparators = Object(__WEBPACK_IMPORTED_MODULE_15__common_controller_wordCharacterClassifier_js__["a" /* getMapForWordSeparators */])(this._context.configuration.editor.wordSeparators);
        var column = position.column;
        var distance = 0;
        while (column > 1) {
            var charCode = lineContent.charCodeAt(column - 2);
            var charClass = wordSeparators.get(charCode);
            if (charClass !== 0 /* Regular */ || distance > 50) {
                return lineContent.substring(column - 1, position.column - 1);
            }
            distance++;
            column--;
        }
        return lineContent.substring(0, position.column - 1);
    };
    TextAreaHandler.prototype._getCharacterBeforePosition = function (position) {
        if (position.column > 1) {
            var lineContent = this._context.model.getLineContent(position.lineNumber);
            var charBefore = lineContent.charAt(position.column - 2);
            if (!__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isHighSurrogate"](charBefore.charCodeAt(0))) {
                return charBefore;
            }
        }
        return '';
    };
    // --- begin event handlers
    TextAreaHandler.prototype.onConfigurationChanged = function (e) {
        var conf = this._context.configuration.editor;
        if (e.fontInfo) {
            this._fontInfo = conf.fontInfo;
        }
        if (e.viewInfo) {
            this.textArea.setAttribute('aria-label', conf.viewInfo.ariaLabel);
        }
        if (e.layoutInfo) {
            this._contentLeft = conf.layoutInfo.contentLeft;
            this._contentWidth = conf.layoutInfo.contentWidth;
            this._contentHeight = conf.layoutInfo.contentHeight;
        }
        if (e.lineHeight) {
            this._lineHeight = conf.lineHeight;
        }
        if (e.accessibilitySupport) {
            this._accessibilitySupport = conf.accessibilitySupport;
            this._textAreaInput.writeScreenReaderContent('strategy changed');
        }
        if (e.emptySelectionClipboard) {
            this._emptySelectionClipboard = conf.emptySelectionClipboard;
        }
        return true;
    };
    TextAreaHandler.prototype.onCursorStateChanged = function (e) {
        this._selections = e.selections.slice(0);
        this._textAreaInput.writeScreenReaderContent('selection changed');
        return true;
    };
    TextAreaHandler.prototype.onDecorationsChanged = function (e) {
        // true for inline decorations that can end up relayouting text
        return true;
    };
    TextAreaHandler.prototype.onFlushed = function (e) {
        return true;
    };
    TextAreaHandler.prototype.onLinesChanged = function (e) {
        return true;
    };
    TextAreaHandler.prototype.onLinesDeleted = function (e) {
        return true;
    };
    TextAreaHandler.prototype.onLinesInserted = function (e) {
        return true;
    };
    TextAreaHandler.prototype.onScrollChanged = function (e) {
        this._scrollLeft = e.scrollLeft;
        this._scrollTop = e.scrollTop;
        return true;
    };
    TextAreaHandler.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    // --- begin view API
    TextAreaHandler.prototype.isFocused = function () {
        return this._textAreaInput.isFocused();
    };
    TextAreaHandler.prototype.focusTextArea = function () {
        this._textAreaInput.focusTextArea();
    };
    TextAreaHandler.prototype.prepareRender = function (ctx) {
        if (this._accessibilitySupport === 2 /* Enabled */) {
            // Do not move the textarea with the cursor, as this generates accessibility events that might confuse screen readers
            // See https://github.com/Microsoft/vscode/issues/26730
            this._primaryCursorVisibleRange = null;
        }
        else {
            var primaryCursorPosition = new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](this._selections[0].positionLineNumber, this._selections[0].positionColumn);
            this._primaryCursorVisibleRange = ctx.visibleRangeForPosition(primaryCursorPosition);
        }
    };
    TextAreaHandler.prototype.render = function (ctx) {
        this._textAreaInput.writeScreenReaderContent('render');
        this._render();
    };
    TextAreaHandler.prototype._render = function () {
        if (this._visibleTextArea) {
            // The text area is visible for composition reasons
            this._renderInsideEditor(this._visibleTextArea.top - this._scrollTop, this._contentLeft + this._visibleTextArea.left - this._scrollLeft, this._visibleTextArea.width, this._lineHeight, true);
            return;
        }
        if (!this._primaryCursorVisibleRange) {
            // The primary cursor is outside the viewport => place textarea to the top left
            this._renderAtTopLeft();
            return;
        }
        var left = this._contentLeft + this._primaryCursorVisibleRange.left - this._scrollLeft;
        if (left < this._contentLeft || left > this._contentLeft + this._contentWidth) {
            // cursor is outside the viewport
            this._renderAtTopLeft();
            return;
        }
        var top = this._context.viewLayout.getVerticalOffsetForLineNumber(this._selections[0].positionLineNumber) - this._scrollTop;
        if (top < 0 || top > this._contentHeight) {
            // cursor is outside the viewport
            this._renderAtTopLeft();
            return;
        }
        // The primary cursor is in the viewport (at least vertically) => place textarea on the cursor
        this._renderInsideEditor(top, left, canUseZeroSizeTextarea ? 0 : 1, canUseZeroSizeTextarea ? 0 : 1, false);
    };
    TextAreaHandler.prototype._renderInsideEditor = function (top, left, width, height, useEditorFont) {
        var ta = this.textArea;
        var tac = this.textAreaCover;
        if (useEditorFont) {
            __WEBPACK_IMPORTED_MODULE_9__config_configuration_js__["a" /* Configuration */].applyFontInfo(ta, this._fontInfo);
        }
        else {
            ta.setFontSize(1);
            ta.setLineHeight(this._fontInfo.lineHeight);
        }
        ta.setTop(top);
        ta.setLeft(left);
        ta.setWidth(width);
        ta.setHeight(height);
        tac.setTop(0);
        tac.setLeft(0);
        tac.setWidth(0);
        tac.setHeight(0);
    };
    TextAreaHandler.prototype._renderAtTopLeft = function () {
        var ta = this.textArea;
        var tac = this.textAreaCover;
        __WEBPACK_IMPORTED_MODULE_9__config_configuration_js__["a" /* Configuration */].applyFontInfo(ta, this._fontInfo);
        ta.setTop(0);
        ta.setLeft(0);
        tac.setTop(0);
        tac.setLeft(0);
        if (canUseZeroSizeTextarea) {
            ta.setWidth(0);
            ta.setHeight(0);
            tac.setWidth(0);
            tac.setHeight(0);
            return;
        }
        // (in WebKit the textarea is 1px by 1px because it cannot handle input to a 0x0 textarea)
        // specifically, when doing Korean IME, setting the textare to 0x0 breaks IME badly.
        ta.setWidth(1);
        ta.setHeight(1);
        tac.setWidth(1);
        tac.setHeight(1);
        if (this._context.configuration.editor.viewInfo.glyphMargin) {
            tac.setClassName('monaco-editor-background textAreaCover ' + __WEBPACK_IMPORTED_MODULE_13__viewParts_margin_margin_js__["a" /* Margin */].OUTER_CLASS_NAME);
        }
        else {
            if (this._context.configuration.editor.viewInfo.renderLineNumbers !== 0 /* Off */) {
                tac.setClassName('monaco-editor-background textAreaCover ' + __WEBPACK_IMPORTED_MODULE_14__viewParts_lineNumbers_lineNumbers_js__["a" /* LineNumbersOverlay */].CLASS_NAME);
            }
            else {
                tac.setClassName('monaco-editor-background textAreaCover');
            }
        }
    };
    return TextAreaHandler;
}(__WEBPACK_IMPORTED_MODULE_12__view_viewPart_js__["b" /* ViewPart */]));

function measureText(text, fontInfo) {
    // adjust width by its size
    var canvasElem = document.createElement('canvas');
    var context = canvasElem.getContext('2d');
    context.font = createFontString(fontInfo);
    var metrics = context.measureText(text);
    if (__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["j" /* isFirefox */]) {
        return metrics.width + 2; // +2 for Japanese...
    }
    else {
        return metrics.width;
    }
}
function createFontString(bareFontInfo) {
    return doCreateFontString('normal', bareFontInfo.fontWeight, bareFontInfo.fontSize, bareFontInfo.lineHeight, bareFontInfo.fontFamily);
}
function doCreateFontString(fontStyle, fontWeight, fontSize, lineHeight, fontFamily) {
    // The full font syntax is:
    // style | variant | weight | stretch | size/line-height | fontFamily
    // (https://developer.mozilla.org/en-US/docs/Web/CSS/font)
    // But it appears Edge and IE11 cannot properly parse `stretch`.
    return fontStyle + " normal " + fontWeight + " " + fontSize + "px / " + lineHeight + "px " + fontFamily;
}


/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PointerHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_touch_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mouseHandler_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorDom_js__ = __webpack_require__(150);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




function gestureChangeEventMerger(lastEvent, currentEvent) {
    var r = {
        translationY: currentEvent.translationY,
        translationX: currentEvent.translationX
    };
    if (lastEvent) {
        r.translationY += lastEvent.translationY;
        r.translationX += lastEvent.translationX;
    }
    return r;
}
/**
 * Basically IE10 and IE11
 */
var MsPointerHandler = /** @class */ (function (_super) {
    __extends(MsPointerHandler, _super);
    function MsPointerHandler(context, viewController, viewHelper) {
        var _this = _super.call(this, context, viewController, viewHelper) || this;
        _this.viewHelper.linesContentDomNode.style.msTouchAction = 'none';
        _this.viewHelper.linesContentDomNode.style.msContentZooming = 'none';
        // TODO@Alex -> this expects that the view is added in 100 ms, might not be the case
        // This handler should be added when the dom node is in the dom tree
        _this._installGestureHandlerTimeout = window.setTimeout(function () {
            _this._installGestureHandlerTimeout = -1;
            if (window.MSGesture) {
                var touchGesture_1 = new MSGesture();
                var penGesture_1 = new MSGesture();
                touchGesture_1.target = _this.viewHelper.linesContentDomNode;
                penGesture_1.target = _this.viewHelper.linesContentDomNode;
                _this.viewHelper.linesContentDomNode.addEventListener('MSPointerDown', function (e) {
                    // Circumvent IE11 breaking change in e.pointerType & TypeScript's stale definitions
                    var pointerType = e.pointerType;
                    if (pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) {
                        _this._lastPointerType = 'mouse';
                        return;
                    }
                    else if (pointerType === (e.MSPOINTER_TYPE_TOUCH || 'touch')) {
                        _this._lastPointerType = 'touch';
                        touchGesture_1.addPointer(e.pointerId);
                    }
                    else {
                        _this._lastPointerType = 'pen';
                        penGesture_1.addPointer(e.pointerId);
                    }
                });
                _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["i" /* addDisposableThrottledListener */](_this.viewHelper.linesContentDomNode, 'MSGestureChange', function (e) { return _this._onGestureChange(e); }, gestureChangeEventMerger));
                _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](_this.viewHelper.linesContentDomNode, 'MSGestureTap', function (e) { return _this._onCaptureGestureTap(e); }, true));
            }
        }, 100);
        _this._lastPointerType = 'mouse';
        return _this;
    }
    MsPointerHandler.prototype._onMouseDown = function (e) {
        if (this._lastPointerType === 'mouse') {
            _super.prototype._onMouseDown.call(this, e);
        }
    };
    MsPointerHandler.prototype._onCaptureGestureTap = function (rawEvent) {
        var _this = this;
        var e = new __WEBPACK_IMPORTED_MODULE_3__editorDom_js__["b" /* EditorMouseEvent */](rawEvent, this.viewHelper.viewDomNode);
        var t = this._createMouseTarget(e, false);
        if (t.position) {
            this.viewController.moveTo(t.position);
        }
        // IE does not want to focus when coming in from the browser's address bar
        if (e.browserEvent.fromElement) {
            e.preventDefault();
            this.viewHelper.focusTextArea();
        }
        else {
            // TODO@Alex -> cancel this is focus is lost
            setTimeout(function () {
                _this.viewHelper.focusTextArea();
            });
        }
    };
    MsPointerHandler.prototype._onGestureChange = function (e) {
        this._context.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
    };
    MsPointerHandler.prototype.dispose = function () {
        window.clearTimeout(this._installGestureHandlerTimeout);
        _super.prototype.dispose.call(this);
    };
    return MsPointerHandler;
}(__WEBPACK_IMPORTED_MODULE_2__mouseHandler_js__["a" /* MouseHandler */]));
/**
 * Basically Edge but should be modified to handle any pointerEnabled, even without support of MSGesture
 */
var StandardPointerHandler = /** @class */ (function (_super) {
    __extends(StandardPointerHandler, _super);
    function StandardPointerHandler(context, viewController, viewHelper) {
        var _this = _super.call(this, context, viewController, viewHelper) || this;
        _this.viewHelper.linesContentDomNode.style.touchAction = 'none';
        // TODO@Alex -> this expects that the view is added in 100 ms, might not be the case
        // This handler should be added when the dom node is in the dom tree
        _this._installGestureHandlerTimeout = window.setTimeout(function () {
            _this._installGestureHandlerTimeout = -1;
            // TODO@Alex: replace the usage of MSGesture here with something that works across all browsers
            if (window.MSGesture) {
                var touchGesture_2 = new MSGesture();
                var penGesture_2 = new MSGesture();
                touchGesture_2.target = _this.viewHelper.linesContentDomNode;
                penGesture_2.target = _this.viewHelper.linesContentDomNode;
                _this.viewHelper.linesContentDomNode.addEventListener('pointerdown', function (e) {
                    var pointerType = e.pointerType;
                    if (pointerType === 'mouse') {
                        _this._lastPointerType = 'mouse';
                        return;
                    }
                    else if (pointerType === 'touch') {
                        _this._lastPointerType = 'touch';
                        touchGesture_2.addPointer(e.pointerId);
                    }
                    else {
                        _this._lastPointerType = 'pen';
                        penGesture_2.addPointer(e.pointerId);
                    }
                });
                _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["i" /* addDisposableThrottledListener */](_this.viewHelper.linesContentDomNode, 'MSGestureChange', function (e) { return _this._onGestureChange(e); }, gestureChangeEventMerger));
                _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](_this.viewHelper.linesContentDomNode, 'MSGestureTap', function (e) { return _this._onCaptureGestureTap(e); }, true));
            }
        }, 100);
        _this._lastPointerType = 'mouse';
        return _this;
    }
    StandardPointerHandler.prototype._onMouseDown = function (e) {
        if (this._lastPointerType === 'mouse') {
            _super.prototype._onMouseDown.call(this, e);
        }
    };
    StandardPointerHandler.prototype._onCaptureGestureTap = function (rawEvent) {
        var _this = this;
        var e = new __WEBPACK_IMPORTED_MODULE_3__editorDom_js__["b" /* EditorMouseEvent */](rawEvent, this.viewHelper.viewDomNode);
        var t = this._createMouseTarget(e, false);
        if (t.position) {
            this.viewController.moveTo(t.position);
        }
        // IE does not want to focus when coming in from the browser's address bar
        if (e.browserEvent.fromElement) {
            e.preventDefault();
            this.viewHelper.focusTextArea();
        }
        else {
            // TODO@Alex -> cancel this is focus is lost
            setTimeout(function () {
                _this.viewHelper.focusTextArea();
            });
        }
    };
    StandardPointerHandler.prototype._onGestureChange = function (e) {
        this._context.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
    };
    StandardPointerHandler.prototype.dispose = function () {
        window.clearTimeout(this._installGestureHandlerTimeout);
        _super.prototype.dispose.call(this);
    };
    return StandardPointerHandler;
}(__WEBPACK_IMPORTED_MODULE_2__mouseHandler_js__["a" /* MouseHandler */]));
var TouchHandler = /** @class */ (function (_super) {
    __extends(TouchHandler, _super);
    function TouchHandler(context, viewController, viewHelper) {
        var _this = _super.call(this, context, viewController, viewHelper) || this;
        __WEBPACK_IMPORTED_MODULE_1__base_browser_touch_js__["b" /* Gesture */].addTarget(_this.viewHelper.linesContentDomNode);
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](_this.viewHelper.linesContentDomNode, __WEBPACK_IMPORTED_MODULE_1__base_browser_touch_js__["a" /* EventType */].Tap, function (e) { return _this.onTap(e); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](_this.viewHelper.linesContentDomNode, __WEBPACK_IMPORTED_MODULE_1__base_browser_touch_js__["a" /* EventType */].Change, function (e) { return _this.onChange(e); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](_this.viewHelper.linesContentDomNode, __WEBPACK_IMPORTED_MODULE_1__base_browser_touch_js__["a" /* EventType */].Contextmenu, function (e) { return _this._onContextMenu(new __WEBPACK_IMPORTED_MODULE_3__editorDom_js__["b" /* EditorMouseEvent */](e, _this.viewHelper.viewDomNode), false); }));
        return _this;
    }
    TouchHandler.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    TouchHandler.prototype.onTap = function (event) {
        event.preventDefault();
        this.viewHelper.focusTextArea();
        var target = this._createMouseTarget(new __WEBPACK_IMPORTED_MODULE_3__editorDom_js__["b" /* EditorMouseEvent */](event, this.viewHelper.viewDomNode), false);
        if (target.position) {
            this.viewController.moveTo(target.position);
        }
    };
    TouchHandler.prototype.onChange = function (e) {
        this._context.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
    };
    return TouchHandler;
}(__WEBPACK_IMPORTED_MODULE_2__mouseHandler_js__["a" /* MouseHandler */]));
var PointerHandler = /** @class */ (function () {
    function PointerHandler(context, viewController, viewHelper) {
        if (window.navigator.msPointerEnabled) {
            this.handler = new MsPointerHandler(context, viewController, viewHelper);
        }
        else if (window.TouchEvent) {
            this.handler = new TouchHandler(context, viewController, viewHelper);
        }
        else if (window.navigator.pointerEnabled || window.PointerEvent) {
            this.handler = new StandardPointerHandler(context, viewController, viewHelper);
        }
        else {
            this.handler = new __WEBPACK_IMPORTED_MODULE_2__mouseHandler_js__["a" /* MouseHandler */](context, viewController, viewHelper);
        }
    }
    PointerHandler.prototype.getTargetAtClientPoint = function (clientX, clientY) {
        return this.handler.getTargetAtClientPoint(clientX, clientY);
    };
    PointerHandler.prototype.dispose = function () {
        this.handler.dispose();
    };
    return PointerHandler;
}());



/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MouseHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_viewModel_viewEventHandler_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editorDom_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_browser_mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_config_editorZoom_js__ = __webpack_require__(92);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













/**
 * Merges mouse events when mouse move events are throttled
 */
function createMouseMoveEventMerger(mouseTargetFactory) {
    return function (lastEvent, currentEvent) {
        var targetIsWidget = false;
        if (mouseTargetFactory) {
            targetIsWidget = mouseTargetFactory.mouseTargetIsWidget(currentEvent);
        }
        if (!targetIsWidget) {
            currentEvent.preventDefault();
        }
        return currentEvent;
    };
}
var MouseHandler = /** @class */ (function (_super) {
    __extends(MouseHandler, _super);
    function MouseHandler(context, viewController, viewHelper) {
        var _this = _super.call(this) || this;
        _this._isFocused = false;
        _this._context = context;
        _this.viewController = viewController;
        _this.viewHelper = viewHelper;
        _this.mouseTargetFactory = new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["c" /* MouseTargetFactory */](_this._context, viewHelper);
        _this._mouseDownOperation = _this._register(new MouseDownOperation(_this._context, _this.viewController, _this.viewHelper, function (e, testEventTarget) { return _this._createMouseTarget(e, testEventTarget); }, function (e) { return _this._getMouseColumn(e); }));
        _this._asyncFocus = _this._register(new __WEBPACK_IMPORTED_MODULE_9__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this.viewHelper.focusTextArea(); }, 0));
        _this.lastMouseLeaveTime = -1;
        var mouseEvents = new __WEBPACK_IMPORTED_MODULE_10__editorDom_js__["c" /* EditorMouseEventFactory */](_this.viewHelper.viewDomNode);
        _this._register(mouseEvents.onContextMenu(_this.viewHelper.viewDomNode, function (e) { return _this._onContextMenu(e, true); }));
        _this._register(mouseEvents.onMouseMoveThrottled(_this.viewHelper.viewDomNode, function (e) { return _this._onMouseMove(e); }, createMouseMoveEventMerger(_this.mouseTargetFactory), MouseHandler.MOUSE_MOVE_MINIMUM_TIME));
        _this._register(mouseEvents.onMouseUp(_this.viewHelper.viewDomNode, function (e) { return _this._onMouseUp(e); }));
        _this._register(mouseEvents.onMouseLeave(_this.viewHelper.viewDomNode, function (e) { return _this._onMouseLeave(e); }));
        _this._register(mouseEvents.onMouseDown(_this.viewHelper.viewDomNode, function (e) { return _this._onMouseDown(e); }));
        var onMouseWheel = function (browserEvent) {
            if (!_this._context.configuration.editor.viewInfo.mouseWheelZoom) {
                return;
            }
            var e = new __WEBPACK_IMPORTED_MODULE_11__base_browser_mouseEvent_js__["c" /* StandardMouseWheelEvent */](browserEvent);
            if (e.browserEvent.ctrlKey || e.browserEvent.metaKey) {
                var zoomLevel = __WEBPACK_IMPORTED_MODULE_12__common_config_editorZoom_js__["a" /* EditorZoom */].getZoomLevel();
                var delta = e.deltaY > 0 ? 1 : -1;
                __WEBPACK_IMPORTED_MODULE_12__common_config_editorZoom_js__["a" /* EditorZoom */].setZoomLevel(zoomLevel + delta);
                e.preventDefault();
                e.stopPropagation();
            }
        };
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](_this.viewHelper.viewDomNode, 'mousewheel', onMouseWheel, true));
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](_this.viewHelper.viewDomNode, 'DOMMouseScroll', onMouseWheel, true));
        _this._context.addEventHandler(_this);
        return _this;
    }
    MouseHandler.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    MouseHandler.prototype.onCursorStateChanged = function (e) {
        this._mouseDownOperation.onCursorStateChanged(e);
        return false;
    };
    MouseHandler.prototype.onFocusChanged = function (e) {
        this._isFocused = e.isFocused;
        return false;
    };
    MouseHandler.prototype.onScrollChanged = function (e) {
        this._mouseDownOperation.onScrollChanged();
        return false;
    };
    // --- end event handlers
    MouseHandler.prototype.getTargetAtClientPoint = function (clientX, clientY) {
        var clientPos = new __WEBPACK_IMPORTED_MODULE_10__editorDom_js__["a" /* ClientCoordinates */](clientX, clientY);
        var pos = clientPos.toPageCoordinates();
        var editorPos = Object(__WEBPACK_IMPORTED_MODULE_10__editorDom_js__["f" /* createEditorPagePosition */])(this.viewHelper.viewDomNode);
        if (pos.y < editorPos.y || pos.y > editorPos.y + editorPos.height || pos.x < editorPos.x || pos.x > editorPos.x + editorPos.width) {
            return null;
        }
        var lastViewCursorsRenderData = this.viewHelper.getLastViewCursorsRenderData();
        return this.mouseTargetFactory.createMouseTarget(lastViewCursorsRenderData, editorPos, pos, null);
    };
    MouseHandler.prototype._createMouseTarget = function (e, testEventTarget) {
        var lastViewCursorsRenderData = this.viewHelper.getLastViewCursorsRenderData();
        return this.mouseTargetFactory.createMouseTarget(lastViewCursorsRenderData, e.editorPos, e.pos, testEventTarget ? e.target : null);
    };
    MouseHandler.prototype._getMouseColumn = function (e) {
        return this.mouseTargetFactory.getMouseColumn(e.editorPos, e.pos);
    };
    MouseHandler.prototype._onContextMenu = function (e, testEventTarget) {
        this.viewController.emitContextMenu({
            event: e,
            target: this._createMouseTarget(e, testEventTarget)
        });
    };
    MouseHandler.prototype._onMouseMove = function (e) {
        if (this._mouseDownOperation.isActive()) {
            // In selection/drag operation
            return;
        }
        var actualMouseMoveTime = e.timestamp;
        if (actualMouseMoveTime < this.lastMouseLeaveTime) {
            // Due to throttling, this event occurred before the mouse left the editor, therefore ignore it.
            return;
        }
        this.viewController.emitMouseMove({
            event: e,
            target: this._createMouseTarget(e, true)
        });
    };
    MouseHandler.prototype._onMouseLeave = function (e) {
        this.lastMouseLeaveTime = (new Date()).getTime();
        this.viewController.emitMouseLeave({
            event: e,
            target: null
        });
    };
    MouseHandler.prototype._onMouseUp = function (e) {
        this.viewController.emitMouseUp({
            event: e,
            target: this._createMouseTarget(e, true)
        });
    };
    MouseHandler.prototype._onMouseDown = function (e) {
        var _this = this;
        var t = this._createMouseTarget(e, true);
        var targetIsContent = (t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_TEXT || t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_EMPTY);
        var targetIsGutter = (t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_GLYPH_MARGIN || t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_NUMBERS || t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_DECORATIONS);
        var targetIsLineNumbers = (t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_NUMBERS);
        var selectOnLineNumbers = this._context.configuration.editor.viewInfo.selectOnLineNumbers;
        var targetIsViewZone = (t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_VIEW_ZONE || t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_VIEW_ZONE);
        var targetIsWidget = (t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_WIDGET);
        var shouldHandle = e.leftButton || e.middleButton;
        if (__WEBPACK_IMPORTED_MODULE_1__base_common_platform_js__["d" /* isMacintosh */] && e.leftButton && e.ctrlKey) {
            shouldHandle = false;
        }
        var focus = function () {
            // In IE11, if the focus is in the browser's address bar and
            // then you click in the editor, calling preventDefault()
            // will not move focus properly (focus remains the address bar)
            if (__WEBPACK_IMPORTED_MODULE_2__base_browser_browser_js__["k" /* isIE */] && !_this._isFocused) {
                _this._asyncFocus.schedule();
            }
            else {
                e.preventDefault();
                _this.viewHelper.focusTextArea();
            }
        };
        if (shouldHandle && (targetIsContent || (targetIsLineNumbers && selectOnLineNumbers))) {
            focus();
            this._mouseDownOperation.start(t.type, e);
        }
        else if (targetIsGutter) {
            // Do not steal focus
            e.preventDefault();
        }
        else if (targetIsViewZone) {
            var viewZoneData = t.detail;
            if (this.viewHelper.shouldSuppressMouseDownOnViewZone(viewZoneData.viewZoneId)) {
                focus();
                this._mouseDownOperation.start(t.type, e);
                e.preventDefault();
            }
        }
        else if (targetIsWidget && this.viewHelper.shouldSuppressMouseDownOnWidget(t.detail)) {
            focus();
            e.preventDefault();
        }
        this.viewController.emitMouseDown({
            event: e,
            target: t
        });
    };
    MouseHandler.MOUSE_MOVE_MINIMUM_TIME = 100; // ms
    return MouseHandler;
}(__WEBPACK_IMPORTED_MODULE_6__common_viewModel_viewEventHandler_js__["a" /* ViewEventHandler */]));

var MouseDownOperation = /** @class */ (function (_super) {
    __extends(MouseDownOperation, _super);
    function MouseDownOperation(context, viewController, viewHelper, createMouseTarget, getMouseColumn) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._viewController = viewController;
        _this._viewHelper = viewHelper;
        _this._createMouseTarget = createMouseTarget;
        _this._getMouseColumn = getMouseColumn;
        _this._mouseMoveMonitor = _this._register(new __WEBPACK_IMPORTED_MODULE_10__editorDom_js__["d" /* GlobalEditorMouseMoveMonitor */](_this._viewHelper.viewDomNode));
        _this._onScrollTimeout = _this._register(new __WEBPACK_IMPORTED_MODULE_9__base_common_async_js__["f" /* TimeoutTimer */]());
        _this._mouseState = new MouseDownState();
        _this._currentSelection = new __WEBPACK_IMPORTED_MODULE_5__common_core_selection_js__["a" /* Selection */](1, 1, 1, 1);
        _this._isActive = false;
        _this._lastMouseEvent = null;
        return _this;
    }
    MouseDownOperation.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    MouseDownOperation.prototype.isActive = function () {
        return this._isActive;
    };
    MouseDownOperation.prototype._onMouseDownThenMove = function (e) {
        this._lastMouseEvent = e;
        this._mouseState.setModifiers(e);
        var position = this._findMousePosition(e, true);
        if (!position) {
            // Ignoring because position is unknown
            return;
        }
        if (this._mouseState.isDragAndDrop) {
            this._viewController.emitMouseDrag({
                event: e,
                target: position
            });
        }
        else {
            this._dispatchMouse(position, true);
        }
    };
    MouseDownOperation.prototype.start = function (targetType, e) {
        var _this = this;
        this._lastMouseEvent = e;
        this._mouseState.setStartedOnLineNumbers(targetType === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_LINE_NUMBERS);
        this._mouseState.setStartButtons(e);
        this._mouseState.setModifiers(e);
        var position = this._findMousePosition(e, true);
        if (!position) {
            // Ignoring because position is unknown
            return;
        }
        this._mouseState.trySetCount(e.detail, position.position);
        // Overwrite the detail of the MouseEvent, as it will be sent out in an event and contributions might rely on it.
        e.detail = this._mouseState.count;
        if (!this._context.configuration.editor.readOnly
            && this._context.configuration.editor.dragAndDrop
            && !this._mouseState.altKey // we don't support multiple mouse
            && e.detail < 2 // only single click on a selection can work
            && !this._isActive // the mouse is not down yet
            && !this._currentSelection.isEmpty() // we don't drag single cursor
            && this._currentSelection.containsPosition(position.position) // single click on a selection
        ) {
            this._mouseState.isDragAndDrop = true;
            this._isActive = true;
            this._mouseMoveMonitor.startMonitoring(createMouseMoveEventMerger(null), function (e) { return _this._onMouseDownThenMove(e); }, function () {
                var position = _this._findMousePosition(_this._lastMouseEvent, true);
                _this._viewController.emitMouseDrop({
                    event: _this._lastMouseEvent,
                    target: position ? _this._createMouseTarget(_this._lastMouseEvent, true) : null // Ignoring because position is unknown, e.g., Content View Zone
                });
                _this._stop();
            });
            return;
        }
        this._mouseState.isDragAndDrop = false;
        this._dispatchMouse(position, e.shiftKey);
        if (!this._isActive) {
            this._isActive = true;
            this._mouseMoveMonitor.startMonitoring(createMouseMoveEventMerger(null), function (e) { return _this._onMouseDownThenMove(e); }, function () { return _this._stop(); });
        }
    };
    MouseDownOperation.prototype._stop = function () {
        this._isActive = false;
        this._onScrollTimeout.cancel();
    };
    MouseDownOperation.prototype.onScrollChanged = function () {
        var _this = this;
        if (!this._isActive) {
            return;
        }
        this._onScrollTimeout.setIfNotSet(function () {
            var position = _this._findMousePosition(_this._lastMouseEvent, false);
            if (!position) {
                // Ignoring because position is unknown
                return;
            }
            if (_this._mouseState.isDragAndDrop) {
                // Ignoring because users are dragging the text
                return;
            }
            _this._dispatchMouse(position, true);
        }, 10);
    };
    MouseDownOperation.prototype.onCursorStateChanged = function (e) {
        this._currentSelection = e.selections[0];
    };
    MouseDownOperation.prototype._getPositionOutsideEditor = function (e) {
        var editorContent = e.editorPos;
        var model = this._context.model;
        var viewLayout = this._context.viewLayout;
        var mouseColumn = this._getMouseColumn(e);
        if (e.posy < editorContent.y) {
            var verticalOffset = Math.max(viewLayout.getCurrentScrollTop() - (editorContent.y - e.posy), 0);
            var viewZoneData = __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["a" /* HitTestContext */].getZoneAtCoord(this._context, verticalOffset);
            if (viewZoneData) {
                var newPosition = this._helpPositionJumpOverViewZone(viewZoneData);
                if (newPosition) {
                    return new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["b" /* MouseTarget */](null, __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].OUTSIDE_EDITOR, mouseColumn, newPosition);
                }
            }
            var aboveLineNumber = viewLayout.getLineNumberAtVerticalOffset(verticalOffset);
            return new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["b" /* MouseTarget */](null, __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].OUTSIDE_EDITOR, mouseColumn, new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](aboveLineNumber, 1));
        }
        if (e.posy > editorContent.y + editorContent.height) {
            var verticalOffset = viewLayout.getCurrentScrollTop() + (e.posy - editorContent.y);
            var viewZoneData = __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["a" /* HitTestContext */].getZoneAtCoord(this._context, verticalOffset);
            if (viewZoneData) {
                var newPosition = this._helpPositionJumpOverViewZone(viewZoneData);
                if (newPosition) {
                    return new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["b" /* MouseTarget */](null, __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].OUTSIDE_EDITOR, mouseColumn, newPosition);
                }
            }
            var belowLineNumber = viewLayout.getLineNumberAtVerticalOffset(verticalOffset);
            return new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["b" /* MouseTarget */](null, __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].OUTSIDE_EDITOR, mouseColumn, new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](belowLineNumber, model.getLineMaxColumn(belowLineNumber)));
        }
        var possibleLineNumber = viewLayout.getLineNumberAtVerticalOffset(viewLayout.getCurrentScrollTop() + (e.posy - editorContent.y));
        if (e.posx < editorContent.x) {
            return new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["b" /* MouseTarget */](null, __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].OUTSIDE_EDITOR, mouseColumn, new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](possibleLineNumber, 1));
        }
        if (e.posx > editorContent.x + editorContent.width) {
            return new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["b" /* MouseTarget */](null, __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].OUTSIDE_EDITOR, mouseColumn, new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](possibleLineNumber, model.getLineMaxColumn(possibleLineNumber)));
        }
        return null;
    };
    MouseDownOperation.prototype._findMousePosition = function (e, testEventTarget) {
        var positionOutsideEditor = this._getPositionOutsideEditor(e);
        if (positionOutsideEditor) {
            return positionOutsideEditor;
        }
        var t = this._createMouseTarget(e, testEventTarget);
        var hintedPosition = t.position;
        if (!hintedPosition) {
            return null;
        }
        if (t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].CONTENT_VIEW_ZONE || t.type === __WEBPACK_IMPORTED_MODULE_8__editorBrowser_js__["b" /* MouseTargetType */].GUTTER_VIEW_ZONE) {
            var newPosition = this._helpPositionJumpOverViewZone(t.detail);
            if (newPosition) {
                return new __WEBPACK_IMPORTED_MODULE_7__mouseTarget_js__["b" /* MouseTarget */](t.element, t.type, t.mouseColumn, newPosition, null, t.detail);
            }
        }
        return t;
    };
    MouseDownOperation.prototype._helpPositionJumpOverViewZone = function (viewZoneData) {
        // Force position on view zones to go above or below depending on where selection started from
        var selectionStart = new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](this._currentSelection.selectionStartLineNumber, this._currentSelection.selectionStartColumn);
        var positionBefore = viewZoneData.positionBefore;
        var positionAfter = viewZoneData.positionAfter;
        if (positionBefore && positionAfter) {
            if (positionBefore.isBefore(selectionStart)) {
                return positionBefore;
            }
            else {
                return positionAfter;
            }
        }
        return null;
    };
    MouseDownOperation.prototype._dispatchMouse = function (position, inSelectionMode) {
        this._viewController.dispatchMouse({
            position: position.position,
            mouseColumn: position.mouseColumn,
            startedOnLineNumbers: this._mouseState.startedOnLineNumbers,
            inSelectionMode: inSelectionMode,
            mouseDownCount: this._mouseState.count,
            altKey: this._mouseState.altKey,
            ctrlKey: this._mouseState.ctrlKey,
            metaKey: this._mouseState.metaKey,
            shiftKey: this._mouseState.shiftKey,
            leftButton: this._mouseState.leftButton,
            middleButton: this._mouseState.middleButton,
        });
    };
    return MouseDownOperation;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */]));
var MouseDownState = /** @class */ (function () {
    function MouseDownState() {
        this._altKey = false;
        this._ctrlKey = false;
        this._metaKey = false;
        this._shiftKey = false;
        this._leftButton = false;
        this._middleButton = false;
        this._startedOnLineNumbers = false;
        this._lastMouseDownPosition = null;
        this._lastMouseDownPositionEqualCount = 0;
        this._lastMouseDownCount = 0;
        this._lastSetMouseDownCountTime = 0;
        this.isDragAndDrop = false;
    }
    Object.defineProperty(MouseDownState.prototype, "altKey", {
        get: function () { return this._altKey; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MouseDownState.prototype, "ctrlKey", {
        get: function () { return this._ctrlKey; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MouseDownState.prototype, "metaKey", {
        get: function () { return this._metaKey; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MouseDownState.prototype, "shiftKey", {
        get: function () { return this._shiftKey; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MouseDownState.prototype, "leftButton", {
        get: function () { return this._leftButton; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MouseDownState.prototype, "middleButton", {
        get: function () { return this._middleButton; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MouseDownState.prototype, "startedOnLineNumbers", {
        get: function () { return this._startedOnLineNumbers; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MouseDownState.prototype, "count", {
        get: function () {
            return this._lastMouseDownCount;
        },
        enumerable: true,
        configurable: true
    });
    MouseDownState.prototype.setModifiers = function (source) {
        this._altKey = source.altKey;
        this._ctrlKey = source.ctrlKey;
        this._metaKey = source.metaKey;
        this._shiftKey = source.shiftKey;
    };
    MouseDownState.prototype.setStartButtons = function (source) {
        this._leftButton = source.leftButton;
        this._middleButton = source.middleButton;
    };
    MouseDownState.prototype.setStartedOnLineNumbers = function (startedOnLineNumbers) {
        this._startedOnLineNumbers = startedOnLineNumbers;
    };
    MouseDownState.prototype.trySetCount = function (setMouseDownCount, newMouseDownPosition) {
        // a. Invalidate multiple clicking if too much time has passed (will be hit by IE because the detail field of mouse events contains garbage in IE10)
        var currentTime = (new Date()).getTime();
        if (currentTime - this._lastSetMouseDownCountTime > MouseDownState.CLEAR_MOUSE_DOWN_COUNT_TIME) {
            setMouseDownCount = 1;
        }
        this._lastSetMouseDownCountTime = currentTime;
        // b. Ensure that we don't jump from single click to triple click in one go (will be hit by IE because the detail field of mouse events contains garbage in IE10)
        if (setMouseDownCount > this._lastMouseDownCount + 1) {
            setMouseDownCount = this._lastMouseDownCount + 1;
        }
        // c. Invalidate multiple clicking if the logical position is different
        if (this._lastMouseDownPosition && this._lastMouseDownPosition.equals(newMouseDownPosition)) {
            this._lastMouseDownPositionEqualCount++;
        }
        else {
            this._lastMouseDownPositionEqualCount = 1;
        }
        this._lastMouseDownPosition = newMouseDownPosition;
        // Finally set the lastMouseDownCount
        this._lastMouseDownCount = Math.min(setMouseDownCount, this._lastMouseDownPositionEqualCount);
    };
    MouseDownState.CLEAR_MOUSE_DOWN_COUNT_TIME = 400; // ms
    return MouseDownState;
}());


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RangeUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_view_renderingContext_js__ = __webpack_require__(86);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var FloatHorizontalRange = /** @class */ (function () {
    function FloatHorizontalRange(left, width) {
        this.left = left;
        this.width = width;
    }
    FloatHorizontalRange.prototype.toString = function () {
        return "[" + this.left + "," + this.width + "]";
    };
    FloatHorizontalRange.compare = function (a, b) {
        return a.left - b.left;
    };
    return FloatHorizontalRange;
}());
var RangeUtil = /** @class */ (function () {
    function RangeUtil() {
    }
    RangeUtil._createRange = function () {
        if (!this._handyReadyRange) {
            this._handyReadyRange = document.createRange();
        }
        return this._handyReadyRange;
    };
    RangeUtil._detachRange = function (range, endNode) {
        // Move range out of the span node, IE doesn't like having many ranges in
        // the same spot and will act badly for lines containing dashes ('-')
        range.selectNodeContents(endNode);
    };
    RangeUtil._readClientRects = function (startElement, startOffset, endElement, endOffset, endNode) {
        var range = this._createRange();
        try {
            range.setStart(startElement, startOffset);
            range.setEnd(endElement, endOffset);
            return range.getClientRects();
        }
        catch (e) {
            // This is life ...
            return null;
        }
        finally {
            this._detachRange(range, endNode);
        }
    };
    RangeUtil._mergeAdjacentRanges = function (ranges) {
        if (ranges.length === 1) {
            // There is nothing to merge
            return [new __WEBPACK_IMPORTED_MODULE_0__common_view_renderingContext_js__["a" /* HorizontalRange */](ranges[0].left, ranges[0].width)];
        }
        ranges.sort(FloatHorizontalRange.compare);
        var result = [], resultLen = 0;
        var prevLeft = ranges[0].left;
        var prevWidth = ranges[0].width;
        for (var i = 1, len = ranges.length; i < len; i++) {
            var range = ranges[i];
            var myLeft = range.left;
            var myWidth = range.width;
            if (prevLeft + prevWidth + 0.9 /* account for browser's rounding errors*/ >= myLeft) {
                prevWidth = Math.max(prevWidth, myLeft + myWidth - prevLeft);
            }
            else {
                result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_0__common_view_renderingContext_js__["a" /* HorizontalRange */](prevLeft, prevWidth);
                prevLeft = myLeft;
                prevWidth = myWidth;
            }
        }
        result[resultLen++] = new __WEBPACK_IMPORTED_MODULE_0__common_view_renderingContext_js__["a" /* HorizontalRange */](prevLeft, prevWidth);
        return result;
    };
    RangeUtil._createHorizontalRangesFromClientRects = function (clientRects, clientRectDeltaLeft) {
        if (!clientRects || clientRects.length === 0) {
            return null;
        }
        // We go through FloatHorizontalRange because it has been observed in bi-di text
        // that the clientRects are not coming in sorted from the browser
        var result = [];
        for (var i = 0, len = clientRects.length; i < len; i++) {
            var clientRect = clientRects[i];
            result[i] = new FloatHorizontalRange(Math.max(0, clientRect.left - clientRectDeltaLeft), clientRect.width);
        }
        return this._mergeAdjacentRanges(result);
    };
    RangeUtil.readHorizontalRanges = function (domNode, startChildIndex, startOffset, endChildIndex, endOffset, clientRectDeltaLeft, endNode) {
        // Panic check
        var min = 0;
        var max = domNode.children.length - 1;
        if (min > max) {
            return null;
        }
        startChildIndex = Math.min(max, Math.max(min, startChildIndex));
        endChildIndex = Math.min(max, Math.max(min, endChildIndex));
        // If crossing over to a span only to select offset 0, then use the previous span's maximum offset
        // Chrome is buggy and doesn't handle 0 offsets well sometimes.
        if (startChildIndex !== endChildIndex) {
            if (endChildIndex > 0 && endOffset === 0) {
                endChildIndex--;
                endOffset = Number.MAX_VALUE;
            }
        }
        var startElement = domNode.children[startChildIndex].firstChild;
        var endElement = domNode.children[endChildIndex].firstChild;
        if (!startElement || !endElement) {
            // When having an empty <span> (without any text content), try to move to the previous <span>
            if (!startElement && startOffset === 0 && startChildIndex > 0) {
                startElement = domNode.children[startChildIndex - 1].firstChild;
                startOffset = 1073741824 /* MAX_SAFE_SMALL_INTEGER */;
            }
            if (!endElement && endOffset === 0 && endChildIndex > 0) {
                endElement = domNode.children[endChildIndex - 1].firstChild;
                endOffset = 1073741824 /* MAX_SAFE_SMALL_INTEGER */;
            }
        }
        if (!startElement || !endElement) {
            return null;
        }
        startOffset = Math.min(startElement.textContent.length, Math.max(0, startOffset));
        endOffset = Math.min(endElement.textContent.length, Math.max(0, endOffset));
        var clientRects = this._readClientRects(startElement, startOffset, endElement, endOffset, endNode);
        return this._createHorizontalRangesFromClientRects(clientRects, clientRectDeltaLeft);
    };
    return RangeUtil;
}());



/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__ = __webpack_require__(84);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var ViewController = /** @class */ (function () {
    function ViewController(configuration, viewModel, execCommandFunc, outgoingEvents, commandDelegate) {
        this.configuration = configuration;
        this.viewModel = viewModel;
        this._execCoreEditorCommandFunc = execCommandFunc;
        this.outgoingEvents = outgoingEvents;
        this.commandDelegate = commandDelegate;
    }
    ViewController.prototype._execMouseCommand = function (editorCommand, args) {
        args.source = 'mouse';
        this._execCoreEditorCommandFunc(editorCommand, args);
    };
    ViewController.prototype.paste = function (source, text, pasteOnNewLine, multicursorText) {
        this.commandDelegate.paste(source, text, pasteOnNewLine, multicursorText);
    };
    ViewController.prototype.type = function (source, text) {
        this.commandDelegate.type(source, text);
    };
    ViewController.prototype.replacePreviousChar = function (source, text, replaceCharCnt) {
        this.commandDelegate.replacePreviousChar(source, text, replaceCharCnt);
    };
    ViewController.prototype.compositionStart = function (source) {
        this.commandDelegate.compositionStart(source);
    };
    ViewController.prototype.compositionEnd = function (source) {
        this.commandDelegate.compositionEnd(source);
    };
    ViewController.prototype.cut = function (source) {
        this.commandDelegate.cut(source);
    };
    ViewController.prototype.setSelection = function (source, modelSelection) {
        this._execCoreEditorCommandFunc(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].SetSelection, {
            source: source,
            selection: modelSelection
        });
    };
    ViewController.prototype._validateViewColumn = function (viewPosition) {
        var minColumn = this.viewModel.getLineMinColumn(viewPosition.lineNumber);
        if (viewPosition.column < minColumn) {
            return new __WEBPACK_IMPORTED_MODULE_0__common_core_position_js__["a" /* Position */](viewPosition.lineNumber, minColumn);
        }
        return viewPosition;
    };
    ViewController.prototype._hasMulticursorModifier = function (data) {
        switch (this.configuration.editor.multiCursorModifier) {
            case 'altKey':
                return data.altKey;
            case 'ctrlKey':
                return data.ctrlKey;
            case 'metaKey':
                return data.metaKey;
        }
        return false;
    };
    ViewController.prototype._hasNonMulticursorModifier = function (data) {
        switch (this.configuration.editor.multiCursorModifier) {
            case 'altKey':
                return data.ctrlKey || data.metaKey;
            case 'ctrlKey':
                return data.altKey || data.metaKey;
            case 'metaKey':
                return data.ctrlKey || data.altKey;
        }
        return false;
    };
    ViewController.prototype.dispatchMouse = function (data) {
        if (data.middleButton) {
            if (data.inSelectionMode) {
                this.columnSelect(data.position, data.mouseColumn);
            }
            else {
                this.moveTo(data.position);
            }
        }
        else if (data.startedOnLineNumbers) {
            // If the dragging started on the gutter, then have operations work on the entire line
            if (this._hasMulticursorModifier(data)) {
                if (data.inSelectionMode) {
                    this.lastCursorLineSelect(data.position);
                }
                else {
                    this.createCursor(data.position, true);
                }
            }
            else {
                if (data.inSelectionMode) {
                    this.lineSelectDrag(data.position);
                }
                else {
                    this.lineSelect(data.position);
                }
            }
        }
        else if (data.mouseDownCount >= 4) {
            this.selectAll();
        }
        else if (data.mouseDownCount === 3) {
            if (this._hasMulticursorModifier(data)) {
                if (data.inSelectionMode) {
                    this.lastCursorLineSelectDrag(data.position);
                }
                else {
                    this.lastCursorLineSelect(data.position);
                }
            }
            else {
                if (data.inSelectionMode) {
                    this.lineSelectDrag(data.position);
                }
                else {
                    this.lineSelect(data.position);
                }
            }
        }
        else if (data.mouseDownCount === 2) {
            if (this._hasMulticursorModifier(data)) {
                this.lastCursorWordSelect(data.position);
            }
            else {
                if (data.inSelectionMode) {
                    this.wordSelectDrag(data.position);
                }
                else {
                    this.wordSelect(data.position);
                }
            }
        }
        else {
            if (this._hasMulticursorModifier(data)) {
                if (!this._hasNonMulticursorModifier(data)) {
                    if (data.shiftKey) {
                        this.columnSelect(data.position, data.mouseColumn);
                    }
                    else {
                        // Do multi-cursor operations only when purely alt is pressed
                        if (data.inSelectionMode) {
                            this.lastCursorMoveToSelect(data.position);
                        }
                        else {
                            this.createCursor(data.position, false);
                        }
                    }
                }
            }
            else {
                if (data.inSelectionMode) {
                    this.moveToSelect(data.position);
                }
                else {
                    this.moveTo(data.position);
                }
            }
        }
    };
    ViewController.prototype._usualArgs = function (viewPosition) {
        viewPosition = this._validateViewColumn(viewPosition);
        return {
            position: this.convertViewToModelPosition(viewPosition),
            viewPosition: viewPosition
        };
    };
    ViewController.prototype.moveTo = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].MoveTo, this._usualArgs(viewPosition));
    };
    ViewController.prototype.moveToSelect = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].MoveToSelect, this._usualArgs(viewPosition));
    };
    ViewController.prototype.columnSelect = function (viewPosition, mouseColumn) {
        viewPosition = this._validateViewColumn(viewPosition);
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].ColumnSelect, {
            position: this.convertViewToModelPosition(viewPosition),
            viewPosition: viewPosition,
            mouseColumn: mouseColumn
        });
    };
    ViewController.prototype.createCursor = function (viewPosition, wholeLine) {
        viewPosition = this._validateViewColumn(viewPosition);
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].CreateCursor, {
            position: this.convertViewToModelPosition(viewPosition),
            viewPosition: viewPosition,
            wholeLine: wholeLine
        });
    };
    ViewController.prototype.lastCursorMoveToSelect = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].LastCursorMoveToSelect, this._usualArgs(viewPosition));
    };
    ViewController.prototype.wordSelect = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].WordSelect, this._usualArgs(viewPosition));
    };
    ViewController.prototype.wordSelectDrag = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].WordSelectDrag, this._usualArgs(viewPosition));
    };
    ViewController.prototype.lastCursorWordSelect = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].LastCursorWordSelect, this._usualArgs(viewPosition));
    };
    ViewController.prototype.lineSelect = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].LineSelect, this._usualArgs(viewPosition));
    };
    ViewController.prototype.lineSelectDrag = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].LineSelectDrag, this._usualArgs(viewPosition));
    };
    ViewController.prototype.lastCursorLineSelect = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].LastCursorLineSelect, this._usualArgs(viewPosition));
    };
    ViewController.prototype.lastCursorLineSelectDrag = function (viewPosition) {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].LastCursorLineSelectDrag, this._usualArgs(viewPosition));
    };
    ViewController.prototype.selectAll = function () {
        this._execMouseCommand(__WEBPACK_IMPORTED_MODULE_1__controller_coreCommands_js__["CoreNavigationCommands"].SelectAll, {});
    };
    // ----------------------
    ViewController.prototype.convertViewToModelPosition = function (viewPosition) {
        return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(viewPosition);
    };
    ViewController.prototype.emitKeyDown = function (e) {
        this.outgoingEvents.emitKeyDown(e);
    };
    ViewController.prototype.emitKeyUp = function (e) {
        this.outgoingEvents.emitKeyUp(e);
    };
    ViewController.prototype.emitContextMenu = function (e) {
        this.outgoingEvents.emitContextMenu(e);
    };
    ViewController.prototype.emitMouseMove = function (e) {
        this.outgoingEvents.emitMouseMove(e);
    };
    ViewController.prototype.emitMouseLeave = function (e) {
        this.outgoingEvents.emitMouseLeave(e);
    };
    ViewController.prototype.emitMouseUp = function (e) {
        this.outgoingEvents.emitMouseUp(e);
    };
    ViewController.prototype.emitMouseDown = function (e) {
        this.outgoingEvents.emitMouseDown(e);
    };
    ViewController.prototype.emitMouseDrag = function (e) {
        this.outgoingEvents.emitMouseDrag(e);
    };
    ViewController.prototype.emitMouseDrop = function (e) {
        this.outgoingEvents.emitMouseDrop(e);
    };
    return ViewController;
}());



/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewEventDispatcher; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var ViewEventDispatcher = /** @class */ (function () {
    function ViewEventDispatcher(eventHandlerGateKeeper) {
        this._eventHandlerGateKeeper = eventHandlerGateKeeper;
        this._eventHandlers = [];
        this._eventQueue = null;
        this._isConsumingQueue = false;
    }
    ViewEventDispatcher.prototype.addEventHandler = function (eventHandler) {
        for (var i = 0, len = this._eventHandlers.length; i < len; i++) {
            if (this._eventHandlers[i] === eventHandler) {
                console.warn('Detected duplicate listener in ViewEventDispatcher', eventHandler);
            }
        }
        this._eventHandlers.push(eventHandler);
    };
    ViewEventDispatcher.prototype.removeEventHandler = function (eventHandler) {
        for (var i = 0; i < this._eventHandlers.length; i++) {
            if (this._eventHandlers[i] === eventHandler) {
                this._eventHandlers.splice(i, 1);
                break;
            }
        }
    };
    ViewEventDispatcher.prototype.emit = function (event) {
        if (this._eventQueue) {
            this._eventQueue.push(event);
        }
        else {
            this._eventQueue = [event];
        }
        if (!this._isConsumingQueue) {
            this.consumeQueue();
        }
    };
    ViewEventDispatcher.prototype.emitMany = function (events) {
        if (this._eventQueue) {
            this._eventQueue = this._eventQueue.concat(events);
        }
        else {
            this._eventQueue = events;
        }
        if (!this._isConsumingQueue) {
            this.consumeQueue();
        }
    };
    ViewEventDispatcher.prototype.consumeQueue = function () {
        var _this = this;
        this._eventHandlerGateKeeper(function () {
            try {
                _this._isConsumingQueue = true;
                _this._doConsumeQueue();
            }
            finally {
                _this._isConsumingQueue = false;
            }
        });
    };
    ViewEventDispatcher.prototype._doConsumeQueue = function () {
        while (this._eventQueue) {
            // Empty event queue, as events might come in while sending these off
            var events = this._eventQueue;
            this._eventQueue = null;
            // Use a clone of the event handlers list, as they might remove themselves
            var eventHandlers = this._eventHandlers.slice(0);
            for (var i = 0, len = eventHandlers.length; i < len; i++) {
                eventHandlers[i].handleEvents(events);
            }
        }
    };
    return ViewEventDispatcher;
}());



/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ViewOverlays */
/* unused harmony export ViewOverlayLine */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentViewOverlays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MarginViewOverlays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__viewLayer_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_configuration_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewPart_js__ = __webpack_require__(33);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ViewOverlays = /** @class */ (function (_super) {
    __extends(ViewOverlays, _super);
    function ViewOverlays(context) {
        var _this = _super.call(this, context) || this;
        _this._visibleLines = new __WEBPACK_IMPORTED_MODULE_1__viewLayer_js__["b" /* VisibleLinesCollection */](_this);
        _this.domNode = _this._visibleLines.domNode;
        _this._dynamicOverlays = [];
        _this._isFocused = false;
        _this.domNode.setClassName('view-overlays');
        return _this;
    }
    ViewOverlays.prototype.shouldRender = function () {
        if (_super.prototype.shouldRender.call(this)) {
            return true;
        }
        for (var i = 0, len = this._dynamicOverlays.length; i < len; i++) {
            var dynamicOverlay = this._dynamicOverlays[i];
            if (dynamicOverlay.shouldRender()) {
                return true;
            }
        }
        return false;
    };
    ViewOverlays.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        for (var i = 0, len = this._dynamicOverlays.length; i < len; i++) {
            var dynamicOverlay = this._dynamicOverlays[i];
            dynamicOverlay.dispose();
        }
        this._dynamicOverlays = null;
    };
    ViewOverlays.prototype.getDomNode = function () {
        return this.domNode;
    };
    // ---- begin IVisibleLinesHost
    ViewOverlays.prototype.createVisibleLine = function () {
        return new ViewOverlayLine(this._context.configuration, this._dynamicOverlays);
    };
    // ---- end IVisibleLinesHost
    ViewOverlays.prototype.addDynamicOverlay = function (overlay) {
        this._dynamicOverlays.push(overlay);
    };
    // ----- event handlers
    ViewOverlays.prototype.onConfigurationChanged = function (e) {
        this._visibleLines.onConfigurationChanged(e);
        var startLineNumber = this._visibleLines.getStartLineNumber();
        var endLineNumber = this._visibleLines.getEndLineNumber();
        for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
            var line = this._visibleLines.getVisibleLine(lineNumber);
            line.onConfigurationChanged(e);
        }
        return true;
    };
    ViewOverlays.prototype.onFlushed = function (e) {
        return this._visibleLines.onFlushed(e);
    };
    ViewOverlays.prototype.onFocusChanged = function (e) {
        this._isFocused = e.isFocused;
        return true;
    };
    ViewOverlays.prototype.onLinesChanged = function (e) {
        return this._visibleLines.onLinesChanged(e);
    };
    ViewOverlays.prototype.onLinesDeleted = function (e) {
        return this._visibleLines.onLinesDeleted(e);
    };
    ViewOverlays.prototype.onLinesInserted = function (e) {
        return this._visibleLines.onLinesInserted(e);
    };
    ViewOverlays.prototype.onScrollChanged = function (e) {
        return this._visibleLines.onScrollChanged(e) || true;
    };
    ViewOverlays.prototype.onTokensChanged = function (e) {
        return this._visibleLines.onTokensChanged(e);
    };
    ViewOverlays.prototype.onZonesChanged = function (e) {
        return this._visibleLines.onZonesChanged(e);
    };
    // ----- end event handlers
    ViewOverlays.prototype.prepareRender = function (ctx) {
        var toRender = this._dynamicOverlays.filter(function (overlay) { return overlay.shouldRender(); });
        for (var i = 0, len = toRender.length; i < len; i++) {
            var dynamicOverlay = toRender[i];
            dynamicOverlay.prepareRender(ctx);
            dynamicOverlay.onDidRender();
        }
        return null;
    };
    ViewOverlays.prototype.render = function (ctx) {
        // Overwriting to bypass `shouldRender` flag
        this._viewOverlaysRender(ctx);
        this.domNode.toggleClassName('focused', this._isFocused);
    };
    ViewOverlays.prototype._viewOverlaysRender = function (ctx) {
        this._visibleLines.renderLines(ctx.viewportData);
    };
    return ViewOverlays;
}(__WEBPACK_IMPORTED_MODULE_3__viewPart_js__["b" /* ViewPart */]));

var ViewOverlayLine = /** @class */ (function () {
    function ViewOverlayLine(configuration, dynamicOverlays) {
        this._configuration = configuration;
        this._lineHeight = this._configuration.editor.lineHeight;
        this._dynamicOverlays = dynamicOverlays;
        this._domNode = null;
        this._renderedContent = null;
    }
    ViewOverlayLine.prototype.getDomNode = function () {
        if (!this._domNode) {
            return null;
        }
        return this._domNode.domNode;
    };
    ViewOverlayLine.prototype.setDomNode = function (domNode) {
        this._domNode = Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(domNode);
    };
    ViewOverlayLine.prototype.onContentChanged = function () {
        // Nothing
    };
    ViewOverlayLine.prototype.onTokensChanged = function () {
        // Nothing
    };
    ViewOverlayLine.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._configuration.editor.lineHeight;
        }
    };
    ViewOverlayLine.prototype.renderLine = function (lineNumber, deltaTop, viewportData, sb) {
        var result = '';
        for (var i = 0, len = this._dynamicOverlays.length; i < len; i++) {
            var dynamicOverlay = this._dynamicOverlays[i];
            result += dynamicOverlay.render(viewportData.startLineNumber, lineNumber);
        }
        if (this._renderedContent === result) {
            // No rendering needed
            return false;
        }
        this._renderedContent = result;
        sb.appendASCIIString('<div style="position:absolute;top:');
        sb.appendASCIIString(String(deltaTop));
        sb.appendASCIIString('px;width:100%;height:');
        sb.appendASCIIString(String(this._lineHeight));
        sb.appendASCIIString('px;">');
        sb.appendASCIIString(result);
        sb.appendASCIIString('</div>');
        return true;
    };
    ViewOverlayLine.prototype.layoutLine = function (lineNumber, deltaTop) {
        if (this._domNode) {
            this._domNode.setTop(deltaTop);
            this._domNode.setHeight(this._lineHeight);
        }
    };
    return ViewOverlayLine;
}());

var ContentViewOverlays = /** @class */ (function (_super) {
    __extends(ContentViewOverlays, _super);
    function ContentViewOverlays(context) {
        var _this = _super.call(this, context) || this;
        _this._contentWidth = _this._context.configuration.editor.layoutInfo.contentWidth;
        _this.domNode.setHeight(0);
        return _this;
    }
    // --- begin event handlers
    ContentViewOverlays.prototype.onConfigurationChanged = function (e) {
        if (e.layoutInfo) {
            this._contentWidth = this._context.configuration.editor.layoutInfo.contentWidth;
        }
        return _super.prototype.onConfigurationChanged.call(this, e);
    };
    ContentViewOverlays.prototype.onScrollChanged = function (e) {
        return _super.prototype.onScrollChanged.call(this, e) || e.scrollWidthChanged;
    };
    // --- end event handlers
    ContentViewOverlays.prototype._viewOverlaysRender = function (ctx) {
        _super.prototype._viewOverlaysRender.call(this, ctx);
        this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
    };
    return ContentViewOverlays;
}(ViewOverlays));

var MarginViewOverlays = /** @class */ (function (_super) {
    __extends(MarginViewOverlays, _super);
    function MarginViewOverlays(context) {
        var _this = _super.call(this, context) || this;
        _this._contentLeft = _this._context.configuration.editor.layoutInfo.contentLeft;
        _this.domNode.setClassName('margin-view-overlays');
        _this.domNode.setWidth(1);
        __WEBPACK_IMPORTED_MODULE_2__config_configuration_js__["a" /* Configuration */].applyFontInfo(_this.domNode, _this._context.configuration.editor.fontInfo);
        return _this;
    }
    MarginViewOverlays.prototype.onConfigurationChanged = function (e) {
        var shouldRender = false;
        if (e.fontInfo) {
            __WEBPACK_IMPORTED_MODULE_2__config_configuration_js__["a" /* Configuration */].applyFontInfo(this.domNode, this._context.configuration.editor.fontInfo);
            shouldRender = true;
        }
        if (e.layoutInfo) {
            this._contentLeft = this._context.configuration.editor.layoutInfo.contentLeft;
            shouldRender = true;
        }
        return _super.prototype.onConfigurationChanged.call(this, e) || shouldRender;
    };
    MarginViewOverlays.prototype.onScrollChanged = function (e) {
        return _super.prototype.onScrollChanged.call(this, e) || e.scrollHeightChanged;
    };
    MarginViewOverlays.prototype._viewOverlaysRender = function (ctx) {
        _super.prototype._viewOverlaysRender.call(this, ctx);
        var height = Math.min(ctx.scrollHeight, 1000000);
        this.domNode.setHeight(height);
        this.domNode.setWidth(this._contentLeft);
    };
    return MarginViewOverlays;
}(ViewOverlays));



/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewContentWidgets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_viewPart_js__ = __webpack_require__(33);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Coordinate = /** @class */ (function () {
    function Coordinate(top, left) {
        this.top = top;
        this.left = left;
    }
    return Coordinate;
}());
var ViewContentWidgets = /** @class */ (function (_super) {
    __extends(ViewContentWidgets, _super);
    function ViewContentWidgets(context, viewDomNode) {
        var _this = _super.call(this, context) || this;
        _this._viewDomNode = viewDomNode;
        _this._widgets = {};
        _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        __WEBPACK_IMPORTED_MODULE_3__view_viewPart_js__["a" /* PartFingerprints */].write(_this.domNode, 1 /* ContentWidgets */);
        _this.domNode.setClassName('contentWidgets');
        _this.domNode.setPosition('absolute');
        _this.domNode.setTop(0);
        _this.overflowingContentWidgetsDomNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        __WEBPACK_IMPORTED_MODULE_3__view_viewPart_js__["a" /* PartFingerprints */].write(_this.overflowingContentWidgetsDomNode, 2 /* OverflowingContentWidgets */);
        _this.overflowingContentWidgetsDomNode.setClassName('overflowingContentWidgets');
        return _this;
    }
    ViewContentWidgets.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._widgets = null;
        this.domNode = null;
    };
    // --- begin event handlers
    ViewContentWidgets.prototype.onConfigurationChanged = function (e) {
        var keys = Object.keys(this._widgets);
        for (var i = 0, len = keys.length; i < len; i++) {
            var widgetId = keys[i];
            this._widgets[widgetId].onConfigurationChanged(e);
        }
        return true;
    };
    ViewContentWidgets.prototype.onDecorationsChanged = function (e) {
        // true for inline decorations that can end up relayouting text
        return true;
    };
    ViewContentWidgets.prototype.onFlushed = function (e) {
        return true;
    };
    ViewContentWidgets.prototype.onLineMappingChanged = function (e) {
        var keys = Object.keys(this._widgets);
        for (var i = 0, len = keys.length; i < len; i++) {
            var widgetId = keys[i];
            this._widgets[widgetId].onLineMappingChanged(e);
        }
        return true;
    };
    ViewContentWidgets.prototype.onLinesChanged = function (e) {
        return true;
    };
    ViewContentWidgets.prototype.onLinesDeleted = function (e) {
        return true;
    };
    ViewContentWidgets.prototype.onLinesInserted = function (e) {
        return true;
    };
    ViewContentWidgets.prototype.onScrollChanged = function (e) {
        return true;
    };
    ViewContentWidgets.prototype.onZonesChanged = function (e) {
        return true;
    };
    // ---- end view event handlers
    ViewContentWidgets.prototype.addWidget = function (_widget) {
        var myWidget = new Widget(this._context, this._viewDomNode, _widget);
        this._widgets[myWidget.id] = myWidget;
        if (myWidget.allowEditorOverflow) {
            this.overflowingContentWidgetsDomNode.appendChild(myWidget.domNode);
        }
        else {
            this.domNode.appendChild(myWidget.domNode);
        }
        this.setShouldRender();
    };
    ViewContentWidgets.prototype.setWidgetPosition = function (widget, position, preference) {
        var myWidget = this._widgets[widget.getId()];
        myWidget.setPosition(position, preference);
        this.setShouldRender();
    };
    ViewContentWidgets.prototype.removeWidget = function (widget) {
        var widgetId = widget.getId();
        if (this._widgets.hasOwnProperty(widgetId)) {
            var myWidget = this._widgets[widgetId];
            delete this._widgets[widgetId];
            var domNode = myWidget.domNode.domNode;
            domNode.parentNode.removeChild(domNode);
            domNode.removeAttribute('monaco-visible-content-widget');
            this.setShouldRender();
        }
    };
    ViewContentWidgets.prototype.shouldSuppressMouseDownOnWidget = function (widgetId) {
        if (this._widgets.hasOwnProperty(widgetId)) {
            return this._widgets[widgetId].suppressMouseDown;
        }
        return false;
    };
    ViewContentWidgets.prototype.onBeforeRender = function (viewportData) {
        var keys = Object.keys(this._widgets);
        for (var i = 0, len = keys.length; i < len; i++) {
            var widgetId = keys[i];
            this._widgets[widgetId].onBeforeRender(viewportData);
        }
    };
    ViewContentWidgets.prototype.prepareRender = function (ctx) {
        var keys = Object.keys(this._widgets);
        for (var i = 0, len = keys.length; i < len; i++) {
            var widgetId = keys[i];
            this._widgets[widgetId].prepareRender(ctx);
        }
    };
    ViewContentWidgets.prototype.render = function (ctx) {
        var keys = Object.keys(this._widgets);
        for (var i = 0, len = keys.length; i < len; i++) {
            var widgetId = keys[i];
            this._widgets[widgetId].render(ctx);
        }
    };
    return ViewContentWidgets;
}(__WEBPACK_IMPORTED_MODULE_3__view_viewPart_js__["b" /* ViewPart */]));

var Widget = /** @class */ (function () {
    function Widget(context, viewDomNode, actual) {
        this._context = context;
        this._viewDomNode = viewDomNode;
        this._actual = actual;
        this.domNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(this._actual.getDomNode());
        this.id = this._actual.getId();
        this.allowEditorOverflow = this._actual.allowEditorOverflow || false;
        this.suppressMouseDown = this._actual.suppressMouseDown || false;
        this._fixedOverflowWidgets = this._context.configuration.editor.viewInfo.fixedOverflowWidgets;
        this._contentWidth = this._context.configuration.editor.layoutInfo.contentWidth;
        this._contentLeft = this._context.configuration.editor.layoutInfo.contentLeft;
        this._lineHeight = this._context.configuration.editor.lineHeight;
        this._setPosition(null);
        this._preference = null;
        this._cachedDomNodeClientWidth = -1;
        this._cachedDomNodeClientHeight = -1;
        this._maxWidth = this._getMaxWidth();
        this._isVisible = false;
        this._renderData = null;
        this.domNode.setPosition((this._fixedOverflowWidgets && this.allowEditorOverflow) ? 'fixed' : 'absolute');
        this.domNode.setVisibility('hidden');
        this.domNode.setAttribute('widgetId', this.id);
        this.domNode.setMaxWidth(this._maxWidth);
    }
    Widget.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.layoutInfo) {
            this._contentLeft = this._context.configuration.editor.layoutInfo.contentLeft;
            this._contentWidth = this._context.configuration.editor.layoutInfo.contentWidth;
            this._maxWidth = this._getMaxWidth();
        }
    };
    Widget.prototype.onLineMappingChanged = function (e) {
        this._setPosition(this._position);
    };
    Widget.prototype._setPosition = function (position) {
        this._position = position;
        this._viewPosition = null;
        if (this._position) {
            // Do not trust that widgets give a valid position
            var validModelPosition = this._context.model.validateModelPosition(this._position);
            if (this._context.model.coordinatesConverter.modelPositionIsVisible(validModelPosition)) {
                this._viewPosition = this._context.model.coordinatesConverter.convertModelPositionToViewPosition(validModelPosition);
            }
        }
    };
    Widget.prototype._getMaxWidth = function () {
        return (this.allowEditorOverflow
            ? window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            : this._contentWidth);
    };
    Widget.prototype.setPosition = function (position, preference) {
        this._setPosition(position);
        this._preference = preference;
        this._cachedDomNodeClientWidth = -1;
        this._cachedDomNodeClientHeight = -1;
    };
    Widget.prototype._layoutBoxInViewport = function (topLeft, width, height, ctx) {
        // Our visible box is split horizontally by the current line => 2 boxes
        // a) the box above the line
        var aboveLineTop = topLeft.top;
        var heightAboveLine = aboveLineTop;
        // b) the box under the line
        var underLineTop = topLeft.top + this._lineHeight;
        var heightUnderLine = ctx.viewportHeight - underLineTop;
        var aboveTop = aboveLineTop - height;
        var fitsAbove = (heightAboveLine >= height);
        var belowTop = underLineTop;
        var fitsBelow = (heightUnderLine >= height);
        // And its left
        var actualLeft = topLeft.left;
        if (actualLeft + width > ctx.scrollLeft + ctx.viewportWidth) {
            actualLeft = ctx.scrollLeft + ctx.viewportWidth - width;
        }
        if (actualLeft < ctx.scrollLeft) {
            actualLeft = ctx.scrollLeft;
        }
        return {
            aboveTop: aboveTop,
            fitsAbove: fitsAbove,
            belowTop: belowTop,
            fitsBelow: fitsBelow,
            left: actualLeft
        };
    };
    Widget.prototype._layoutBoxInPage = function (topLeft, width, height, ctx) {
        var left0 = topLeft.left - ctx.scrollLeft;
        if (left0 < 0 || left0 > this._contentWidth) {
            // Don't render if position is scrolled outside viewport
            return null;
        }
        var aboveTop = topLeft.top - height;
        var belowTop = topLeft.top + this._lineHeight;
        var left = left0 + this._contentLeft;
        var domNodePosition = __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["u" /* getDomNodePagePosition */](this._viewDomNode.domNode);
        var absoluteAboveTop = domNodePosition.top + aboveTop - __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["e" /* StandardWindow */].scrollY;
        var absoluteBelowTop = domNodePosition.top + belowTop - __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["e" /* StandardWindow */].scrollY;
        var absoluteLeft = domNodePosition.left + left - __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["e" /* StandardWindow */].scrollX;
        var INNER_WIDTH = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var INNER_HEIGHT = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        // Leave some clearance to the bottom
        var TOP_PADDING = 22;
        var BOTTOM_PADDING = 22;
        var fitsAbove = (absoluteAboveTop >= TOP_PADDING), fitsBelow = (absoluteBelowTop + height <= INNER_HEIGHT - BOTTOM_PADDING);
        if (absoluteLeft + width + 20 > INNER_WIDTH) {
            var delta = absoluteLeft - (INNER_WIDTH - width - 20);
            absoluteLeft -= delta;
            left -= delta;
        }
        if (absoluteLeft < 0) {
            var delta = absoluteLeft;
            absoluteLeft -= delta;
            left -= delta;
        }
        if (this._fixedOverflowWidgets) {
            aboveTop = absoluteAboveTop;
            belowTop = absoluteBelowTop;
            left = absoluteLeft;
        }
        return { aboveTop: aboveTop, fitsAbove: fitsAbove, belowTop: belowTop, fitsBelow: fitsBelow, left: left };
    };
    Widget.prototype._prepareRenderWidgetAtExactPositionOverflowing = function (topLeft) {
        return new Coordinate(topLeft.top, topLeft.left + this._contentLeft);
    };
    /**
     * Compute `this._topLeft`
     */
    Widget.prototype._getTopLeft = function (ctx) {
        if (!this._viewPosition) {
            return null;
        }
        var visibleRange = ctx.visibleRangeForPosition(this._viewPosition);
        if (!visibleRange) {
            return null;
        }
        var top = ctx.getVerticalOffsetForLineNumber(this._viewPosition.lineNumber) - ctx.scrollTop;
        return new Coordinate(top, visibleRange.left);
    };
    Widget.prototype._prepareRenderWidget = function (topLeft, ctx) {
        var _this = this;
        if (!topLeft) {
            return null;
        }
        var placement = null;
        var fetchPlacement = function () {
            if (placement) {
                return;
            }
            if (_this._cachedDomNodeClientWidth === -1 || _this._cachedDomNodeClientHeight === -1) {
                var domNode = _this.domNode.domNode;
                _this._cachedDomNodeClientWidth = domNode.clientWidth;
                _this._cachedDomNodeClientHeight = domNode.clientHeight;
            }
            if (_this.allowEditorOverflow) {
                placement = _this._layoutBoxInPage(topLeft, _this._cachedDomNodeClientWidth, _this._cachedDomNodeClientHeight, ctx);
            }
            else {
                placement = _this._layoutBoxInViewport(topLeft, _this._cachedDomNodeClientWidth, _this._cachedDomNodeClientHeight, ctx);
            }
        };
        // Do two passes, first for perfect fit, second picks first option
        for (var pass = 1; pass <= 2; pass++) {
            for (var i = 0; i < this._preference.length; i++) {
                var pref = this._preference[i];
                if (pref === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE) {
                    fetchPlacement();
                    if (!placement) {
                        // Widget outside of viewport
                        return null;
                    }
                    if (pass === 2 || placement.fitsAbove) {
                        return new Coordinate(placement.aboveTop, placement.left);
                    }
                }
                else if (pref === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["a" /* ContentWidgetPositionPreference */].BELOW) {
                    fetchPlacement();
                    if (!placement) {
                        // Widget outside of viewport
                        return null;
                    }
                    if (pass === 2 || placement.fitsBelow) {
                        return new Coordinate(placement.belowTop, placement.left);
                    }
                }
                else {
                    if (this.allowEditorOverflow) {
                        return this._prepareRenderWidgetAtExactPositionOverflowing(topLeft);
                    }
                    else {
                        return topLeft;
                    }
                }
            }
        }
        return null;
    };
    /**
     * On this first pass, we ensure that the content widget (if it is in the viewport) has the max width set correctly.
     */
    Widget.prototype.onBeforeRender = function (viewportData) {
        if (!this._viewPosition || !this._preference) {
            return;
        }
        if (this._viewPosition.lineNumber < viewportData.startLineNumber || this._viewPosition.lineNumber > viewportData.endLineNumber) {
            // Outside of viewport
            return;
        }
        this.domNode.setMaxWidth(this._maxWidth);
    };
    Widget.prototype.prepareRender = function (ctx) {
        var topLeft = this._getTopLeft(ctx);
        this._renderData = this._prepareRenderWidget(topLeft, ctx);
    };
    Widget.prototype.render = function (ctx) {
        if (!this._renderData) {
            // This widget should be invisible
            if (this._isVisible) {
                this.domNode.removeAttribute('monaco-visible-content-widget');
                this._isVisible = false;
                this.domNode.setVisibility('hidden');
            }
            return;
        }
        // This widget should be visible
        if (this.allowEditorOverflow) {
            this.domNode.setTop(this._renderData.top);
            this.domNode.setLeft(this._renderData.left);
        }
        else {
            this.domNode.setTop(this._renderData.top + ctx.scrollTop - ctx.bigNumbersDelta);
            this.domNode.setLeft(this._renderData.left);
        }
        if (!this._isVisible) {
            this.domNode.setVisibility('inherit');
            this.domNode.setAttribute('monaco-visible-content-widget', 'true');
            this._isVisible = true;
        }
    };
    return Widget;
}());


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrentLineHighlightOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currentLineHighlight_css__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currentLineHighlight_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__currentLineHighlight_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CurrentLineHighlightOverlay = /** @class */ (function (_super) {
    __extends(CurrentLineHighlightOverlay, _super);
    function CurrentLineHighlightOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._lineHeight = _this._context.configuration.editor.lineHeight;
        _this._renderLineHighlight = _this._context.configuration.editor.viewInfo.renderLineHighlight;
        _this._selectionIsEmpty = true;
        _this._primaryCursorLineNumber = 1;
        _this._scrollWidth = 0;
        _this._contentWidth = _this._context.configuration.editor.layoutInfo.contentWidth;
        _this._context.addEventHandler(_this);
        return _this;
    }
    CurrentLineHighlightOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    CurrentLineHighlightOverlay.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.viewInfo) {
            this._renderLineHighlight = this._context.configuration.editor.viewInfo.renderLineHighlight;
        }
        if (e.layoutInfo) {
            this._contentWidth = this._context.configuration.editor.layoutInfo.contentWidth;
        }
        return true;
    };
    CurrentLineHighlightOverlay.prototype.onCursorStateChanged = function (e) {
        var hasChanged = false;
        var primaryCursorLineNumber = e.selections[0].positionLineNumber;
        if (this._primaryCursorLineNumber !== primaryCursorLineNumber) {
            this._primaryCursorLineNumber = primaryCursorLineNumber;
            hasChanged = true;
        }
        var selectionIsEmpty = e.selections[0].isEmpty();
        if (this._selectionIsEmpty !== selectionIsEmpty) {
            this._selectionIsEmpty = selectionIsEmpty;
            hasChanged = true;
            return true;
        }
        return hasChanged;
    };
    CurrentLineHighlightOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    CurrentLineHighlightOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    CurrentLineHighlightOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    CurrentLineHighlightOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollWidthChanged;
    };
    CurrentLineHighlightOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    CurrentLineHighlightOverlay.prototype.prepareRender = function (ctx) {
        this._scrollWidth = ctx.scrollWidth;
    };
    CurrentLineHighlightOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (lineNumber === this._primaryCursorLineNumber) {
            if (this._shouldShowCurrentLine()) {
                var paintedInMargin = this._willRenderMarginCurrentLine();
                var className = 'current-line' + (paintedInMargin ? ' current-line-both' : '');
                return ('<div class="'
                    + className
                    + '" style="width:'
                    + String(Math.max(this._scrollWidth, this._contentWidth))
                    + 'px; height:'
                    + String(this._lineHeight)
                    + 'px;"></div>');
            }
            else {
                return '';
            }
        }
        return '';
    };
    CurrentLineHighlightOverlay.prototype._shouldShowCurrentLine = function () {
        return ((this._renderLineHighlight === 'line' || this._renderLineHighlight === 'all')
            && this._selectionIsEmpty);
    };
    CurrentLineHighlightOverlay.prototype._willRenderMarginCurrentLine = function () {
        return ((this._renderLineHighlight === 'gutter' || this._renderLineHighlight === 'all'));
    };
    return CurrentLineHighlightOverlay;
}(__WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__["a" /* DynamicViewOverlay */]));

Object(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var lineHighlight = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["o" /* editorLineHighlight */]);
    if (lineHighlight) {
        collector.addRule(".monaco-editor .view-overlays .current-line { background-color: " + lineHighlight + "; }");
    }
    if (!lineHighlight || lineHighlight.isTransparent() || theme.defines(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["p" /* editorLineHighlightBorder */])) {
        var lineHighlightBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["p" /* editorLineHighlightBorder */]);
        if (lineHighlightBorder) {
            collector.addRule(".monaco-editor .view-overlays .current-line { border: 2px solid " + lineHighlightBorder + "; }");
            if (theme.type === 'hc') {
                collector.addRule(".monaco-editor .view-overlays .current-line { border-width: 1px; }");
            }
        }
    }
});


/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrentLineMarginHighlightOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currentLineMarginHighlight_css__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currentLineMarginHighlight_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__currentLineMarginHighlight_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CurrentLineMarginHighlightOverlay = /** @class */ (function (_super) {
    __extends(CurrentLineMarginHighlightOverlay, _super);
    function CurrentLineMarginHighlightOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._lineHeight = _this._context.configuration.editor.lineHeight;
        _this._renderLineHighlight = _this._context.configuration.editor.viewInfo.renderLineHighlight;
        _this._selectionIsEmpty = true;
        _this._primaryCursorLineNumber = 1;
        _this._contentLeft = _this._context.configuration.editor.layoutInfo.contentLeft;
        _this._context.addEventHandler(_this);
        return _this;
    }
    CurrentLineMarginHighlightOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    CurrentLineMarginHighlightOverlay.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.viewInfo) {
            this._renderLineHighlight = this._context.configuration.editor.viewInfo.renderLineHighlight;
        }
        if (e.layoutInfo) {
            this._contentLeft = this._context.configuration.editor.layoutInfo.contentLeft;
        }
        return true;
    };
    CurrentLineMarginHighlightOverlay.prototype.onCursorStateChanged = function (e) {
        var hasChanged = false;
        var primaryCursorLineNumber = e.selections[0].positionLineNumber;
        if (this._primaryCursorLineNumber !== primaryCursorLineNumber) {
            this._primaryCursorLineNumber = primaryCursorLineNumber;
            hasChanged = true;
        }
        var selectionIsEmpty = e.selections[0].isEmpty();
        if (this._selectionIsEmpty !== selectionIsEmpty) {
            this._selectionIsEmpty = selectionIsEmpty;
            hasChanged = true;
            return true;
        }
        return hasChanged;
    };
    CurrentLineMarginHighlightOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    CurrentLineMarginHighlightOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    CurrentLineMarginHighlightOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    CurrentLineMarginHighlightOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    CurrentLineMarginHighlightOverlay.prototype.prepareRender = function (ctx) {
    };
    CurrentLineMarginHighlightOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (lineNumber === this._primaryCursorLineNumber) {
            var className = 'current-line';
            if (this._shouldShowCurrentLine()) {
                var paintedInContent = this._willRenderContentCurrentLine();
                className = 'current-line current-line-margin' + (paintedInContent ? ' current-line-margin-both' : '');
            }
            return ('<div class="'
                + className
                + '" style="width:'
                + String(this._contentLeft)
                + 'px; height:'
                + String(this._lineHeight)
                + 'px;"></div>');
        }
        return '';
    };
    CurrentLineMarginHighlightOverlay.prototype._shouldShowCurrentLine = function () {
        return ((this._renderLineHighlight === 'gutter' || this._renderLineHighlight === 'all'));
    };
    CurrentLineMarginHighlightOverlay.prototype._willRenderContentCurrentLine = function () {
        return ((this._renderLineHighlight === 'line' || this._renderLineHighlight === 'all')
            && this._selectionIsEmpty);
    };
    return CurrentLineMarginHighlightOverlay;
}(__WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__["a" /* DynamicViewOverlay */]));

Object(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var lineHighlight = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["o" /* editorLineHighlight */]);
    if (lineHighlight) {
        collector.addRule(".monaco-editor .margin-view-overlays .current-line-margin { background-color: " + lineHighlight + "; border: none; }");
    }
    else {
        var lineHighlightBorder = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["p" /* editorLineHighlightBorder */]);
        if (lineHighlightBorder) {
            collector.addRule(".monaco-editor .margin-view-overlays .current-line-margin { border: 2px solid " + lineHighlightBorder + "; }");
        }
        if (theme.type === 'hc') {
            collector.addRule(".monaco-editor .margin-view-overlays .current-line-margin { border-width: 1px; }");
        }
    }
});


/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DecorationsOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decorations_css__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decorations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__decorations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_view_renderingContext_js__ = __webpack_require__(86);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DecorationsOverlay = /** @class */ (function (_super) {
    __extends(DecorationsOverlay, _super);
    function DecorationsOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._lineHeight = _this._context.configuration.editor.lineHeight;
        _this._typicalHalfwidthCharacterWidth = _this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        _this._renderResult = null;
        _this._context.addEventHandler(_this);
        return _this;
    }
    DecorationsOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        this._renderResult = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    DecorationsOverlay.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.fontInfo) {
            this._typicalHalfwidthCharacterWidth = this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        }
        return true;
    };
    DecorationsOverlay.prototype.onDecorationsChanged = function (e) {
        return true;
    };
    DecorationsOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    DecorationsOverlay.prototype.onLinesChanged = function (e) {
        return true;
    };
    DecorationsOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    DecorationsOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    DecorationsOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged || e.scrollWidthChanged;
    };
    DecorationsOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    DecorationsOverlay.prototype.prepareRender = function (ctx) {
        var _decorations = ctx.getDecorationsInViewport();
        // Keep only decorations with `className`
        var decorations = [], decorationsLen = 0;
        for (var i = 0, len = _decorations.length; i < len; i++) {
            var d = _decorations[i];
            if (d.options.className) {
                decorations[decorationsLen++] = d;
            }
        }
        // Sort decorations for consistent render output
        decorations = decorations.sort(function (a, b) {
            if (a.options.zIndex < b.options.zIndex) {
                return -1;
            }
            if (a.options.zIndex > b.options.zIndex) {
                return 1;
            }
            var aClassName = a.options.className;
            var bClassName = b.options.className;
            if (aClassName < bClassName) {
                return -1;
            }
            if (aClassName > bClassName) {
                return 1;
            }
            return __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(a.range, b.range);
        });
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        var output = [];
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var lineIndex = lineNumber - visibleStartLineNumber;
            output[lineIndex] = '';
        }
        // Render first whole line decorations and then regular decorations
        this._renderWholeLineDecorations(ctx, decorations, output);
        this._renderNormalDecorations(ctx, decorations, output);
        this._renderResult = output;
    };
    DecorationsOverlay.prototype._renderWholeLineDecorations = function (ctx, decorations, output) {
        var lineHeight = String(this._lineHeight);
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        for (var i = 0, lenI = decorations.length; i < lenI; i++) {
            var d = decorations[i];
            if (!d.options.isWholeLine) {
                continue;
            }
            var decorationOutput = ('<div class="cdr '
                + d.options.className
                + '" style="left:0;width:100%;height:'
                + lineHeight
                + 'px;"></div>');
            var startLineNumber = Math.max(d.range.startLineNumber, visibleStartLineNumber);
            var endLineNumber = Math.min(d.range.endLineNumber, visibleEndLineNumber);
            for (var j = startLineNumber; j <= endLineNumber; j++) {
                var lineIndex = j - visibleStartLineNumber;
                output[lineIndex] += decorationOutput;
            }
        }
    };
    DecorationsOverlay.prototype._renderNormalDecorations = function (ctx, decorations, output) {
        var lineHeight = String(this._lineHeight);
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var prevClassName = null;
        var prevShowIfCollapsed = false;
        var prevRange = null;
        for (var i = 0, lenI = decorations.length; i < lenI; i++) {
            var d = decorations[i];
            if (d.options.isWholeLine) {
                continue;
            }
            var className = d.options.className;
            var showIfCollapsed = d.options.showIfCollapsed;
            var range = d.range;
            if (showIfCollapsed && range.endColumn === 1 && range.endLineNumber !== range.startLineNumber) {
                range = new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](range.startLineNumber, range.startColumn, range.endLineNumber - 1, this._context.model.getLineMaxColumn(range.endLineNumber - 1));
            }
            if (prevClassName === className && prevShowIfCollapsed === showIfCollapsed && __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].areIntersectingOrTouching(prevRange, range)) {
                // merge into previous decoration
                prevRange = __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].plusRange(prevRange, range);
                continue;
            }
            // flush previous decoration
            if (prevClassName !== null) {
                this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShowIfCollapsed, lineHeight, visibleStartLineNumber, output);
            }
            prevClassName = className;
            prevShowIfCollapsed = showIfCollapsed;
            prevRange = range;
        }
        if (prevClassName !== null) {
            this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShowIfCollapsed, lineHeight, visibleStartLineNumber, output);
        }
    };
    DecorationsOverlay.prototype._renderNormalDecoration = function (ctx, range, className, showIfCollapsed, lineHeight, visibleStartLineNumber, output) {
        var linesVisibleRanges = ctx.linesVisibleRangesForRange(range, /*TODO@Alex*/ className === 'findMatch');
        if (!linesVisibleRanges) {
            return;
        }
        for (var j = 0, lenJ = linesVisibleRanges.length; j < lenJ; j++) {
            var lineVisibleRanges = linesVisibleRanges[j];
            var lineIndex = lineVisibleRanges.lineNumber - visibleStartLineNumber;
            if (showIfCollapsed && lineVisibleRanges.ranges.length === 1) {
                var singleVisibleRange = lineVisibleRanges.ranges[0];
                if (singleVisibleRange.width === 0) {
                    // collapsed range case => make the decoration visible by faking its width
                    lineVisibleRanges.ranges[0] = new __WEBPACK_IMPORTED_MODULE_3__common_view_renderingContext_js__["a" /* HorizontalRange */](singleVisibleRange.left, this._typicalHalfwidthCharacterWidth);
                }
            }
            for (var k = 0, lenK = lineVisibleRanges.ranges.length; k < lenK; k++) {
                var visibleRange = lineVisibleRanges.ranges[k];
                var decorationOutput = ('<div class="cdr '
                    + className
                    + '" style="left:'
                    + String(visibleRange.left)
                    + 'px;width:'
                    + String(visibleRange.width)
                    + 'px;height:'
                    + lineHeight
                    + 'px;"></div>');
                output[lineIndex] += decorationOutput;
            }
        }
    };
    DecorationsOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (!this._renderResult) {
            return '';
        }
        var lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) {
            return '';
        }
        return this._renderResult[lineIndex];
    };
    return DecorationsOverlay;
}(__WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__["a" /* DynamicViewOverlay */]));



/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndentGuidesOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indentGuides_css__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indentGuides_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__indentGuides_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var IndentGuidesOverlay = /** @class */ (function (_super) {
    __extends(IndentGuidesOverlay, _super);
    function IndentGuidesOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._primaryLineNumber = 0;
        _this._lineHeight = _this._context.configuration.editor.lineHeight;
        _this._spaceWidth = _this._context.configuration.editor.fontInfo.spaceWidth;
        _this._enabled = _this._context.configuration.editor.viewInfo.renderIndentGuides;
        _this._activeIndentEnabled = _this._context.configuration.editor.viewInfo.highlightActiveIndentGuide;
        _this._renderResult = null;
        _this._context.addEventHandler(_this);
        return _this;
    }
    IndentGuidesOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        this._renderResult = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    IndentGuidesOverlay.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.fontInfo) {
            this._spaceWidth = this._context.configuration.editor.fontInfo.spaceWidth;
        }
        if (e.viewInfo) {
            this._enabled = this._context.configuration.editor.viewInfo.renderIndentGuides;
            this._activeIndentEnabled = this._context.configuration.editor.viewInfo.highlightActiveIndentGuide;
        }
        return true;
    };
    IndentGuidesOverlay.prototype.onCursorStateChanged = function (e) {
        var selection = e.selections[0];
        var newPrimaryLineNumber = selection.isEmpty() ? selection.positionLineNumber : 0;
        if (this._primaryLineNumber !== newPrimaryLineNumber) {
            this._primaryLineNumber = newPrimaryLineNumber;
            return true;
        }
        return false;
    };
    IndentGuidesOverlay.prototype.onDecorationsChanged = function (e) {
        // true for inline decorations
        return true;
    };
    IndentGuidesOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    IndentGuidesOverlay.prototype.onLinesChanged = function (e) {
        return true;
    };
    IndentGuidesOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    IndentGuidesOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    IndentGuidesOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged; // || e.scrollWidthChanged;
    };
    IndentGuidesOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    IndentGuidesOverlay.prototype.onLanguageConfigurationChanged = function (e) {
        return true;
    };
    // --- end event handlers
    IndentGuidesOverlay.prototype.prepareRender = function (ctx) {
        if (!this._enabled) {
            this._renderResult = null;
            return;
        }
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        var tabSize = this._context.model.getTabSize();
        var tabWidth = tabSize * this._spaceWidth;
        var scrollWidth = ctx.scrollWidth;
        var lineHeight = this._lineHeight;
        var indentGuideWidth = tabWidth;
        var indents = this._context.model.getLinesIndentGuides(visibleStartLineNumber, visibleEndLineNumber);
        var activeIndentStartLineNumber = 0;
        var activeIndentEndLineNumber = 0;
        var activeIndentLevel = 0;
        if (this._activeIndentEnabled && this._primaryLineNumber) {
            var activeIndentInfo = this._context.model.getActiveIndentGuide(this._primaryLineNumber, visibleStartLineNumber, visibleEndLineNumber);
            activeIndentStartLineNumber = activeIndentInfo.startLineNumber;
            activeIndentEndLineNumber = activeIndentInfo.endLineNumber;
            activeIndentLevel = activeIndentInfo.indent;
        }
        var output = [];
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var containsActiveIndentGuide = (activeIndentStartLineNumber <= lineNumber && lineNumber <= activeIndentEndLineNumber);
            var lineIndex = lineNumber - visibleStartLineNumber;
            var indent = indents[lineIndex];
            var result = '';
            var leftMostVisiblePosition = ctx.visibleRangeForPosition(new __WEBPACK_IMPORTED_MODULE_4__common_core_position_js__["a" /* Position */](lineNumber, 1));
            var left = leftMostVisiblePosition ? leftMostVisiblePosition.left : 0;
            for (var i = 1; i <= indent; i++) {
                var className = (containsActiveIndentGuide && i === activeIndentLevel ? 'cigra' : 'cigr');
                result += "<div class=\"" + className + "\" style=\"left:" + left + "px;height:" + lineHeight + "px;width:" + indentGuideWidth + "px\"></div>";
                left += tabWidth;
                if (left > scrollWidth) {
                    break;
                }
            }
            output[lineIndex] = result;
        }
        this._renderResult = output;
    };
    IndentGuidesOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (!this._renderResult) {
            return '';
        }
        var lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) {
            return '';
        }
        return this._renderResult[lineIndex];
    };
    return IndentGuidesOverlay;
}(__WEBPACK_IMPORTED_MODULE_1__view_dynamicViewOverlay_js__["a" /* DynamicViewOverlay */]));

Object(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var editorIndentGuidesColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["l" /* editorIndentGuides */]);
    if (editorIndentGuidesColor) {
        collector.addRule(".monaco-editor .lines-content .cigr { box-shadow: 1px 0 0 0 " + editorIndentGuidesColor + " inset; }");
    }
    var editorActiveIndentGuidesColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["a" /* editorActiveIndentGuides */]) || editorIndentGuidesColor;
    if (editorActiveIndentGuidesColor) {
        collector.addRule(".monaco-editor .lines-content .cigra { box-shadow: 1px 0 0 0 " + editorActiveIndentGuidesColor + " inset; }");
    }
});


/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewLines; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__viewLines_css__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__viewLines_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__viewLines_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_viewLayer_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__viewLine_js__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_configuration_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_view_renderingContext_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_viewPart_js__ = __webpack_require__(33);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var LastRenderedData = /** @class */ (function () {
    function LastRenderedData() {
        this._currentVisibleRange = new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](1, 1, 1, 1);
    }
    LastRenderedData.prototype.getCurrentVisibleRange = function () {
        return this._currentVisibleRange;
    };
    LastRenderedData.prototype.setCurrentVisibleRange = function (currentVisibleRange) {
        this._currentVisibleRange = currentVisibleRange;
    };
    return LastRenderedData;
}());
var HorizontalRevealRequest = /** @class */ (function () {
    function HorizontalRevealRequest(lineNumber, startColumn, endColumn, startScrollTop, stopScrollTop, scrollType) {
        this.lineNumber = lineNumber;
        this.startColumn = startColumn;
        this.endColumn = endColumn;
        this.startScrollTop = startScrollTop;
        this.stopScrollTop = stopScrollTop;
        this.scrollType = scrollType;
    }
    return HorizontalRevealRequest;
}());
var ViewLines = /** @class */ (function (_super) {
    __extends(ViewLines, _super);
    function ViewLines(context, linesContent) {
        var _this = _super.call(this, context) || this;
        _this._linesContent = linesContent;
        _this._textRangeRestingSpot = document.createElement('div');
        _this._visibleLines = new __WEBPACK_IMPORTED_MODULE_4__view_viewLayer_js__["b" /* VisibleLinesCollection */](_this);
        _this.domNode = _this._visibleLines.domNode;
        var conf = _this._context.configuration;
        _this._lineHeight = conf.editor.lineHeight;
        _this._typicalHalfwidthCharacterWidth = conf.editor.fontInfo.typicalHalfwidthCharacterWidth;
        _this._isViewportWrapping = conf.editor.wrappingInfo.isViewportWrapping;
        _this._revealHorizontalRightPadding = conf.editor.viewInfo.revealHorizontalRightPadding;
        _this._canUseLayerHinting = conf.editor.canUseLayerHinting;
        _this._viewLineOptions = new __WEBPACK_IMPORTED_MODULE_5__viewLine_js__["c" /* ViewLineOptions */](conf, _this._context.theme.type);
        __WEBPACK_IMPORTED_MODULE_8__view_viewPart_js__["a" /* PartFingerprints */].write(_this.domNode, 7 /* ViewLines */);
        _this.domNode.setClassName('view-lines');
        __WEBPACK_IMPORTED_MODULE_6__config_configuration_js__["a" /* Configuration */].applyFontInfo(_this.domNode, conf.editor.fontInfo);
        // --- width & height
        _this._maxLineWidth = 0;
        _this._asyncUpdateLineWidths = new __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["c" /* RunOnceScheduler */](function () {
            _this._updateLineWidthsSlow();
        }, 200);
        _this._lastRenderedData = new LastRenderedData();
        _this._horizontalRevealRequest = null;
        return _this;
    }
    ViewLines.prototype.dispose = function () {
        this._asyncUpdateLineWidths.dispose();
        _super.prototype.dispose.call(this);
    };
    ViewLines.prototype.getDomNode = function () {
        return this.domNode;
    };
    // ---- begin IVisibleLinesHost
    ViewLines.prototype.createVisibleLine = function () {
        return new __WEBPACK_IMPORTED_MODULE_5__viewLine_js__["b" /* ViewLine */](this._viewLineOptions);
    };
    // ---- end IVisibleLinesHost
    // ---- begin view event handlers
    ViewLines.prototype.onConfigurationChanged = function (e) {
        this._visibleLines.onConfigurationChanged(e);
        if (e.wrappingInfo) {
            this._maxLineWidth = 0;
        }
        var conf = this._context.configuration;
        if (e.lineHeight) {
            this._lineHeight = conf.editor.lineHeight;
        }
        if (e.fontInfo) {
            this._typicalHalfwidthCharacterWidth = conf.editor.fontInfo.typicalHalfwidthCharacterWidth;
        }
        if (e.wrappingInfo) {
            this._isViewportWrapping = conf.editor.wrappingInfo.isViewportWrapping;
        }
        if (e.viewInfo) {
            this._revealHorizontalRightPadding = conf.editor.viewInfo.revealHorizontalRightPadding;
        }
        if (e.canUseLayerHinting) {
            this._canUseLayerHinting = conf.editor.canUseLayerHinting;
        }
        if (e.fontInfo) {
            __WEBPACK_IMPORTED_MODULE_6__config_configuration_js__["a" /* Configuration */].applyFontInfo(this.domNode, conf.editor.fontInfo);
        }
        this._onOptionsMaybeChanged();
        if (e.layoutInfo) {
            this._maxLineWidth = 0;
        }
        return true;
    };
    ViewLines.prototype._onOptionsMaybeChanged = function () {
        var conf = this._context.configuration;
        var newViewLineOptions = new __WEBPACK_IMPORTED_MODULE_5__viewLine_js__["c" /* ViewLineOptions */](conf, this._context.theme.type);
        if (!this._viewLineOptions.equals(newViewLineOptions)) {
            this._viewLineOptions = newViewLineOptions;
            var startLineNumber = this._visibleLines.getStartLineNumber();
            var endLineNumber = this._visibleLines.getEndLineNumber();
            for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
                var line = this._visibleLines.getVisibleLine(lineNumber);
                line.onOptionsChanged(this._viewLineOptions);
            }
            return true;
        }
        return false;
    };
    ViewLines.prototype.onCursorStateChanged = function (e) {
        var rendStartLineNumber = this._visibleLines.getStartLineNumber();
        var rendEndLineNumber = this._visibleLines.getEndLineNumber();
        var r = false;
        for (var lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) {
            r = this._visibleLines.getVisibleLine(lineNumber).onSelectionChanged() || r;
        }
        return r;
    };
    ViewLines.prototype.onDecorationsChanged = function (e) {
        if (true /*e.inlineDecorationsChanged*/) {
            var rendStartLineNumber = this._visibleLines.getStartLineNumber();
            var rendEndLineNumber = this._visibleLines.getEndLineNumber();
            for (var lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) {
                this._visibleLines.getVisibleLine(lineNumber).onDecorationsChanged();
            }
        }
        return true;
    };
    ViewLines.prototype.onFlushed = function (e) {
        var shouldRender = this._visibleLines.onFlushed(e);
        this._maxLineWidth = 0;
        return shouldRender;
    };
    ViewLines.prototype.onLinesChanged = function (e) {
        return this._visibleLines.onLinesChanged(e);
    };
    ViewLines.prototype.onLinesDeleted = function (e) {
        return this._visibleLines.onLinesDeleted(e);
    };
    ViewLines.prototype.onLinesInserted = function (e) {
        return this._visibleLines.onLinesInserted(e);
    };
    ViewLines.prototype.onRevealRangeRequest = function (e) {
        // Using the future viewport here in order to handle multiple
        // incoming reveal range requests that might all desire to be animated
        var desiredScrollTop = this._computeScrollTopToRevealRange(this._context.viewLayout.getFutureViewport(), e.range, e.verticalType);
        // validate the new desired scroll top
        var newScrollPosition = this._context.viewLayout.validateScrollPosition({ scrollTop: desiredScrollTop });
        if (e.revealHorizontal) {
            if (e.range.startLineNumber !== e.range.endLineNumber) {
                // Two or more lines? => scroll to base (That's how you see most of the two lines)
                newScrollPosition = {
                    scrollTop: newScrollPosition.scrollTop,
                    scrollLeft: 0
                };
            }
            else {
                // We don't necessarily know the horizontal offset of this range since the line might not be in the view...
                this._horizontalRevealRequest = new HorizontalRevealRequest(e.range.startLineNumber, e.range.startColumn, e.range.endColumn, this._context.viewLayout.getCurrentScrollTop(), newScrollPosition.scrollTop, e.scrollType);
            }
        }
        else {
            this._horizontalRevealRequest = null;
        }
        var scrollTopDelta = Math.abs(this._context.viewLayout.getCurrentScrollTop() - newScrollPosition.scrollTop);
        if (e.scrollType === 0 /* Smooth */ && scrollTopDelta > this._lineHeight) {
            this._context.viewLayout.setScrollPositionSmooth(newScrollPosition);
        }
        else {
            this._context.viewLayout.setScrollPositionNow(newScrollPosition);
        }
        return true;
    };
    ViewLines.prototype.onScrollChanged = function (e) {
        if (this._horizontalRevealRequest && e.scrollLeftChanged) {
            // cancel any outstanding horizontal reveal request if someone else scrolls horizontally.
            this._horizontalRevealRequest = null;
        }
        if (this._horizontalRevealRequest && e.scrollTopChanged) {
            var min = Math.min(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
            var max = Math.max(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
            if (e.scrollTop < min || e.scrollTop > max) {
                // cancel any outstanding horizontal reveal request if someone else scrolls vertically.
                this._horizontalRevealRequest = null;
            }
        }
        this.domNode.setWidth(e.scrollWidth);
        return this._visibleLines.onScrollChanged(e) || true;
    };
    ViewLines.prototype.onTokensChanged = function (e) {
        return this._visibleLines.onTokensChanged(e);
    };
    ViewLines.prototype.onZonesChanged = function (e) {
        this._context.viewLayout.onMaxLineWidthChanged(this._maxLineWidth);
        return this._visibleLines.onZonesChanged(e);
    };
    ViewLines.prototype.onThemeChanged = function (e) {
        return this._onOptionsMaybeChanged();
    };
    // ---- end view event handlers
    // ----------- HELPERS FOR OTHERS
    ViewLines.prototype.getPositionFromDOMInfo = function (spanNode, offset) {
        var viewLineDomNode = this._getViewLineDomNode(spanNode);
        if (viewLineDomNode === null) {
            // Couldn't find view line node
            return null;
        }
        var lineNumber = this._getLineNumberFor(viewLineDomNode);
        if (lineNumber === -1) {
            // Couldn't find view line node
            return null;
        }
        if (lineNumber < 1 || lineNumber > this._context.model.getLineCount()) {
            // lineNumber is outside range
            return null;
        }
        if (this._context.model.getLineMaxColumn(lineNumber) === 1) {
            // Line is empty
            return new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](lineNumber, 1);
        }
        var rendStartLineNumber = this._visibleLines.getStartLineNumber();
        var rendEndLineNumber = this._visibleLines.getEndLineNumber();
        if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) {
            // Couldn't find line
            return null;
        }
        var column = this._visibleLines.getVisibleLine(lineNumber).getColumnOfNodeOffset(lineNumber, spanNode, offset);
        var minColumn = this._context.model.getLineMinColumn(lineNumber);
        if (column < minColumn) {
            column = minColumn;
        }
        return new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](lineNumber, column);
    };
    ViewLines.prototype._getViewLineDomNode = function (node) {
        while (node && node.nodeType === 1) {
            if (node.className === __WEBPACK_IMPORTED_MODULE_5__viewLine_js__["b" /* ViewLine */].CLASS_NAME) {
                return node;
            }
            node = node.parentElement;
        }
        return null;
    };
    /**
     * @returns the line number of this view line dom node.
     */
    ViewLines.prototype._getLineNumberFor = function (domNode) {
        var startLineNumber = this._visibleLines.getStartLineNumber();
        var endLineNumber = this._visibleLines.getEndLineNumber();
        for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
            var line = this._visibleLines.getVisibleLine(lineNumber);
            if (domNode === line.getDomNode()) {
                return lineNumber;
            }
        }
        return -1;
    };
    ViewLines.prototype.getLineWidth = function (lineNumber) {
        var rendStartLineNumber = this._visibleLines.getStartLineNumber();
        var rendEndLineNumber = this._visibleLines.getEndLineNumber();
        if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) {
            // Couldn't find line
            return -1;
        }
        return this._visibleLines.getVisibleLine(lineNumber).getWidth();
    };
    ViewLines.prototype.linesVisibleRangesForRange = function (range, includeNewLines) {
        if (this.shouldRender()) {
            // Cannot read from the DOM because it is dirty
            // i.e. the model & the dom are out of sync, so I'd be reading something stale
            return null;
        }
        var originalEndLineNumber = range.endLineNumber;
        range = __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].intersectRanges(range, this._lastRenderedData.getCurrentVisibleRange());
        if (!range) {
            return null;
        }
        var visibleRanges = [], visibleRangesLen = 0;
        var domReadingContext = new __WEBPACK_IMPORTED_MODULE_5__viewLine_js__["a" /* DomReadingContext */](this.domNode.domNode, this._textRangeRestingSpot);
        var nextLineModelLineNumber;
        if (includeNewLines) {
            nextLineModelLineNumber = this._context.model.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](range.startLineNumber, 1)).lineNumber;
        }
        var rendStartLineNumber = this._visibleLines.getStartLineNumber();
        var rendEndLineNumber = this._visibleLines.getEndLineNumber();
        for (var lineNumber = range.startLineNumber; lineNumber <= range.endLineNumber; lineNumber++) {
            if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) {
                continue;
            }
            var startColumn = lineNumber === range.startLineNumber ? range.startColumn : 1;
            var endColumn = lineNumber === range.endLineNumber ? range.endColumn : this._context.model.getLineMaxColumn(lineNumber);
            var visibleRangesForLine = this._visibleLines.getVisibleLine(lineNumber).getVisibleRangesForRange(startColumn, endColumn, domReadingContext);
            if (!visibleRangesForLine || visibleRangesForLine.length === 0) {
                continue;
            }
            if (includeNewLines && lineNumber < originalEndLineNumber) {
                var currentLineModelLineNumber = nextLineModelLineNumber;
                nextLineModelLineNumber = this._context.model.coordinatesConverter.convertViewPositionToModelPosition(new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](lineNumber + 1, 1)).lineNumber;
                if (currentLineModelLineNumber !== nextLineModelLineNumber) {
                    visibleRangesForLine[visibleRangesForLine.length - 1].width += this._typicalHalfwidthCharacterWidth;
                }
            }
            visibleRanges[visibleRangesLen++] = new __WEBPACK_IMPORTED_MODULE_7__common_view_renderingContext_js__["b" /* LineVisibleRanges */](lineNumber, visibleRangesForLine);
        }
        if (visibleRangesLen === 0) {
            return null;
        }
        return visibleRanges;
    };
    ViewLines.prototype.visibleRangesForRange2 = function (range) {
        if (this.shouldRender()) {
            // Cannot read from the DOM because it is dirty
            // i.e. the model & the dom are out of sync, so I'd be reading something stale
            return null;
        }
        range = __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].intersectRanges(range, this._lastRenderedData.getCurrentVisibleRange());
        if (!range) {
            return null;
        }
        var result = [];
        var domReadingContext = new __WEBPACK_IMPORTED_MODULE_5__viewLine_js__["a" /* DomReadingContext */](this.domNode.domNode, this._textRangeRestingSpot);
        var rendStartLineNumber = this._visibleLines.getStartLineNumber();
        var rendEndLineNumber = this._visibleLines.getEndLineNumber();
        for (var lineNumber = range.startLineNumber; lineNumber <= range.endLineNumber; lineNumber++) {
            if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) {
                continue;
            }
            var startColumn = lineNumber === range.startLineNumber ? range.startColumn : 1;
            var endColumn = lineNumber === range.endLineNumber ? range.endColumn : this._context.model.getLineMaxColumn(lineNumber);
            var visibleRangesForLine = this._visibleLines.getVisibleLine(lineNumber).getVisibleRangesForRange(startColumn, endColumn, domReadingContext);
            if (!visibleRangesForLine || visibleRangesForLine.length === 0) {
                continue;
            }
            result = result.concat(visibleRangesForLine);
        }
        if (result.length === 0) {
            return null;
        }
        return result;
    };
    // --- implementation
    ViewLines.prototype.updateLineWidths = function () {
        this._updateLineWidths(false);
    };
    /**
     * Updates the max line width if it is fast to compute.
     * Returns true if all lines were taken into account.
     * Returns false if some lines need to be reevaluated (in a slow fashion).
     */
    ViewLines.prototype._updateLineWidthsFast = function () {
        return this._updateLineWidths(true);
    };
    ViewLines.prototype._updateLineWidthsSlow = function () {
        this._updateLineWidths(false);
    };
    ViewLines.prototype._updateLineWidths = function (fast) {
        var rendStartLineNumber = this._visibleLines.getStartLineNumber();
        var rendEndLineNumber = this._visibleLines.getEndLineNumber();
        var localMaxLineWidth = 1;
        var allWidthsComputed = true;
        for (var lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) {
            var visibleLine = this._visibleLines.getVisibleLine(lineNumber);
            if (fast && !visibleLine.getWidthIsFast()) {
                // Cannot compute width in a fast way for this line
                allWidthsComputed = false;
                continue;
            }
            localMaxLineWidth = Math.max(localMaxLineWidth, visibleLine.getWidth());
        }
        if (allWidthsComputed && rendStartLineNumber === 1 && rendEndLineNumber === this._context.model.getLineCount()) {
            // we know the max line width for all the lines
            this._maxLineWidth = 0;
        }
        this._ensureMaxLineWidth(localMaxLineWidth);
        return allWidthsComputed;
    };
    ViewLines.prototype.prepareRender = function () {
        throw new Error('Not supported');
    };
    ViewLines.prototype.render = function () {
        throw new Error('Not supported');
    };
    ViewLines.prototype.renderText = function (viewportData) {
        // (1) render lines - ensures lines are in the DOM
        this._visibleLines.renderLines(viewportData);
        this._lastRenderedData.setCurrentVisibleRange(viewportData.visibleRange);
        this.domNode.setWidth(this._context.viewLayout.getScrollWidth());
        this.domNode.setHeight(Math.min(this._context.viewLayout.getScrollHeight(), 1000000));
        // (2) compute horizontal scroll position:
        //  - this must happen after the lines are in the DOM since it might need a line that rendered just now
        //  - it might change `scrollWidth` and `scrollLeft`
        if (this._horizontalRevealRequest) {
            var revealLineNumber = this._horizontalRevealRequest.lineNumber;
            var revealStartColumn = this._horizontalRevealRequest.startColumn;
            var revealEndColumn = this._horizontalRevealRequest.endColumn;
            var scrollType = this._horizontalRevealRequest.scrollType;
            // Check that we have the line that contains the horizontal range in the viewport
            if (viewportData.startLineNumber <= revealLineNumber && revealLineNumber <= viewportData.endLineNumber) {
                this._horizontalRevealRequest = null;
                // allow `visibleRangesForRange2` to work
                this.onDidRender();
                // compute new scroll position
                var newScrollLeft = this._computeScrollLeftToRevealRange(revealLineNumber, revealStartColumn, revealEndColumn);
                var isViewportWrapping = this._isViewportWrapping;
                if (!isViewportWrapping) {
                    // ensure `scrollWidth` is large enough
                    this._ensureMaxLineWidth(newScrollLeft.maxHorizontalOffset);
                }
                // set `scrollLeft`
                if (scrollType === 0 /* Smooth */) {
                    this._context.viewLayout.setScrollPositionSmooth({
                        scrollLeft: newScrollLeft.scrollLeft
                    });
                }
                else {
                    this._context.viewLayout.setScrollPositionNow({
                        scrollLeft: newScrollLeft.scrollLeft
                    });
                }
            }
        }
        // Update max line width (not so important, it is just so the horizontal scrollbar doesn't get too small)
        if (!this._updateLineWidthsFast()) {
            // Computing the width of some lines would be slow => delay it
            this._asyncUpdateLineWidths.schedule();
        }
        // (3) handle scrolling
        this._linesContent.setLayerHinting(this._canUseLayerHinting);
        var adjustedScrollTop = this._context.viewLayout.getCurrentScrollTop() - viewportData.bigNumbersDelta;
        this._linesContent.setTop(-adjustedScrollTop);
        this._linesContent.setLeft(-this._context.viewLayout.getCurrentScrollLeft());
    };
    // --- width
    ViewLines.prototype._ensureMaxLineWidth = function (lineWidth) {
        var iLineWidth = Math.ceil(lineWidth);
        if (this._maxLineWidth < iLineWidth) {
            this._maxLineWidth = iLineWidth;
            this._context.viewLayout.onMaxLineWidthChanged(this._maxLineWidth);
        }
    };
    ViewLines.prototype._computeScrollTopToRevealRange = function (viewport, range, verticalType) {
        var viewportStartY = viewport.top;
        var viewportHeight = viewport.height;
        var viewportEndY = viewportStartY + viewportHeight;
        var boxStartY;
        var boxEndY;
        // Have a box that includes one extra line height (for the horizontal scrollbar)
        boxStartY = this._context.viewLayout.getVerticalOffsetForLineNumber(range.startLineNumber);
        boxEndY = this._context.viewLayout.getVerticalOffsetForLineNumber(range.endLineNumber) + this._lineHeight;
        if (verticalType === 0 /* Simple */ || verticalType === 4 /* Bottom */) {
            // Reveal one line more when the last line would be covered by the scrollbar - arrow down case or revealing a line explicitly at bottom
            boxEndY += this._lineHeight;
        }
        var newScrollTop;
        if (verticalType === 1 /* Center */ || verticalType === 2 /* CenterIfOutsideViewport */) {
            if (verticalType === 2 /* CenterIfOutsideViewport */ && viewportStartY <= boxStartY && boxEndY <= viewportEndY) {
                // Box is already in the viewport... do nothing
                newScrollTop = viewportStartY;
            }
            else {
                // Box is outside the viewport... center it
                var boxMiddleY = (boxStartY + boxEndY) / 2;
                newScrollTop = Math.max(0, boxMiddleY - viewportHeight / 2);
            }
        }
        else {
            newScrollTop = this._computeMinimumScrolling(viewportStartY, viewportEndY, boxStartY, boxEndY, verticalType === 3 /* Top */, verticalType === 4 /* Bottom */);
        }
        return newScrollTop;
    };
    ViewLines.prototype._computeScrollLeftToRevealRange = function (lineNumber, startColumn, endColumn) {
        var maxHorizontalOffset = 0;
        var viewport = this._context.viewLayout.getCurrentViewport();
        var viewportStartX = viewport.left;
        var viewportEndX = viewportStartX + viewport.width;
        var visibleRanges = this.visibleRangesForRange2(new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](lineNumber, startColumn, lineNumber, endColumn));
        var boxStartX = Number.MAX_VALUE;
        var boxEndX = 0;
        if (!visibleRanges) {
            // Unknown
            return {
                scrollLeft: viewportStartX,
                maxHorizontalOffset: maxHorizontalOffset
            };
        }
        for (var i = 0; i < visibleRanges.length; i++) {
            var visibleRange = visibleRanges[i];
            if (visibleRange.left < boxStartX) {
                boxStartX = visibleRange.left;
            }
            if (visibleRange.left + visibleRange.width > boxEndX) {
                boxEndX = visibleRange.left + visibleRange.width;
            }
        }
        maxHorizontalOffset = boxEndX;
        boxStartX = Math.max(0, boxStartX - ViewLines.HORIZONTAL_EXTRA_PX);
        boxEndX += this._revealHorizontalRightPadding;
        var newScrollLeft = this._computeMinimumScrolling(viewportStartX, viewportEndX, boxStartX, boxEndX);
        return {
            scrollLeft: newScrollLeft,
            maxHorizontalOffset: maxHorizontalOffset
        };
    };
    ViewLines.prototype._computeMinimumScrolling = function (viewportStart, viewportEnd, boxStart, boxEnd, revealAtStart, revealAtEnd) {
        viewportStart = viewportStart | 0;
        viewportEnd = viewportEnd | 0;
        boxStart = boxStart | 0;
        boxEnd = boxEnd | 0;
        revealAtStart = !!revealAtStart;
        revealAtEnd = !!revealAtEnd;
        var viewportLength = viewportEnd - viewportStart;
        var boxLength = boxEnd - boxStart;
        if (boxLength < viewportLength) {
            // The box would fit in the viewport
            if (revealAtStart) {
                return boxStart;
            }
            if (revealAtEnd) {
                return Math.max(0, boxEnd - viewportLength);
            }
            if (boxStart < viewportStart) {
                // The box is above the viewport
                return boxStart;
            }
            else if (boxEnd > viewportEnd) {
                // The box is below the viewport
                return Math.max(0, boxEnd - viewportLength);
            }
        }
        else {
            // The box would not fit in the viewport
            // Reveal the beginning of the box
            return boxStart;
        }
        return viewportStart;
    };
    /**
     * Adds this ammount of pixels to the right of lines (no-one wants to type near the edge of the viewport)
     */
    ViewLines.HORIZONTAL_EXTRA_PX = 30;
    return ViewLines;
}(__WEBPACK_IMPORTED_MODULE_8__view_viewPart_js__["b" /* ViewPart */]));



/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinesDecorationsOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linesDecorations_css__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linesDecorations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__linesDecorations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__glyphMargin_glyphMargin_js__ = __webpack_require__(154);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var LinesDecorationsOverlay = /** @class */ (function (_super) {
    __extends(LinesDecorationsOverlay, _super);
    function LinesDecorationsOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._decorationsLeft = _this._context.configuration.editor.layoutInfo.decorationsLeft;
        _this._decorationsWidth = _this._context.configuration.editor.layoutInfo.decorationsWidth;
        _this._renderResult = null;
        _this._context.addEventHandler(_this);
        return _this;
    }
    LinesDecorationsOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        this._renderResult = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    LinesDecorationsOverlay.prototype.onConfigurationChanged = function (e) {
        if (e.layoutInfo) {
            this._decorationsLeft = this._context.configuration.editor.layoutInfo.decorationsLeft;
            this._decorationsWidth = this._context.configuration.editor.layoutInfo.decorationsWidth;
        }
        return true;
    };
    LinesDecorationsOverlay.prototype.onDecorationsChanged = function (e) {
        return true;
    };
    LinesDecorationsOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    LinesDecorationsOverlay.prototype.onLinesChanged = function (e) {
        return true;
    };
    LinesDecorationsOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    LinesDecorationsOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    LinesDecorationsOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged;
    };
    LinesDecorationsOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    LinesDecorationsOverlay.prototype._getDecorations = function (ctx) {
        var decorations = ctx.getDecorationsInViewport();
        var r = [], rLen = 0;
        for (var i = 0, len = decorations.length; i < len; i++) {
            var d = decorations[i];
            var linesDecorationsClassName = d.options.linesDecorationsClassName;
            if (linesDecorationsClassName) {
                r[rLen++] = new __WEBPACK_IMPORTED_MODULE_1__glyphMargin_glyphMargin_js__["a" /* DecorationToRender */](d.range.startLineNumber, d.range.endLineNumber, linesDecorationsClassName);
            }
        }
        return r;
    };
    LinesDecorationsOverlay.prototype.prepareRender = function (ctx) {
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        var toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));
        var left = this._decorationsLeft.toString();
        var width = this._decorationsWidth.toString();
        var common = '" style="left:' + left + 'px;width:' + width + 'px;"></div>';
        var output = [];
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var lineIndex = lineNumber - visibleStartLineNumber;
            var classNames = toRender[lineIndex];
            var lineOutput = '';
            for (var i = 0, len = classNames.length; i < len; i++) {
                lineOutput += '<div class="cldr ' + classNames[i] + common;
            }
            output[lineIndex] = lineOutput;
        }
        this._renderResult = output;
    };
    LinesDecorationsOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (!this._renderResult) {
            return '';
        }
        return this._renderResult[lineNumber - startLineNumber];
    };
    return LinesDecorationsOverlay;
}(__WEBPACK_IMPORTED_MODULE_1__glyphMargin_glyphMargin_js__["b" /* DedupOverlay */]));



/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarginViewLineDecorationsOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marginDecorations_css__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marginDecorations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__marginDecorations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__glyphMargin_glyphMargin_js__ = __webpack_require__(154);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MarginViewLineDecorationsOverlay = /** @class */ (function (_super) {
    __extends(MarginViewLineDecorationsOverlay, _super);
    function MarginViewLineDecorationsOverlay(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._renderResult = null;
        _this._context.addEventHandler(_this);
        return _this;
    }
    MarginViewLineDecorationsOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        this._renderResult = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    MarginViewLineDecorationsOverlay.prototype.onConfigurationChanged = function (e) {
        return true;
    };
    MarginViewLineDecorationsOverlay.prototype.onDecorationsChanged = function (e) {
        return true;
    };
    MarginViewLineDecorationsOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    MarginViewLineDecorationsOverlay.prototype.onLinesChanged = function (e) {
        return true;
    };
    MarginViewLineDecorationsOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    MarginViewLineDecorationsOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    MarginViewLineDecorationsOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged;
    };
    MarginViewLineDecorationsOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    MarginViewLineDecorationsOverlay.prototype._getDecorations = function (ctx) {
        var decorations = ctx.getDecorationsInViewport();
        var r = [], rLen = 0;
        for (var i = 0, len = decorations.length; i < len; i++) {
            var d = decorations[i];
            var marginClassName = d.options.marginClassName;
            if (marginClassName) {
                r[rLen++] = new __WEBPACK_IMPORTED_MODULE_1__glyphMargin_glyphMargin_js__["a" /* DecorationToRender */](d.range.startLineNumber, d.range.endLineNumber, marginClassName);
            }
        }
        return r;
    };
    MarginViewLineDecorationsOverlay.prototype.prepareRender = function (ctx) {
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        var toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));
        var output = [];
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var lineIndex = lineNumber - visibleStartLineNumber;
            var classNames = toRender[lineIndex];
            var lineOutput = '';
            for (var i = 0, len = classNames.length; i < len; i++) {
                lineOutput += '<div class="cmdr ' + classNames[i] + '" style=""></div>';
            }
            output[lineIndex] = lineOutput;
        }
        this._renderResult = output;
    };
    MarginViewLineDecorationsOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (!this._renderResult) {
            return '';
        }
        return this._renderResult[lineNumber - startLineNumber];
    };
    return MarginViewLineDecorationsOverlay;
}(__WEBPACK_IMPORTED_MODULE_1__glyphMargin_glyphMargin_js__["b" /* DedupOverlay */]));



/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewOverlayWidgets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlayWidgets_css__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlayWidgets_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__overlayWidgets_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_viewPart_js__ = __webpack_require__(33);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ViewOverlayWidgets = /** @class */ (function (_super) {
    __extends(ViewOverlayWidgets, _super);
    function ViewOverlayWidgets(context) {
        var _this = _super.call(this, context) || this;
        _this._widgets = {};
        _this._verticalScrollbarWidth = _this._context.configuration.editor.layoutInfo.verticalScrollbarWidth;
        _this._minimapWidth = _this._context.configuration.editor.layoutInfo.minimapWidth;
        _this._horizontalScrollbarHeight = _this._context.configuration.editor.layoutInfo.horizontalScrollbarHeight;
        _this._editorHeight = _this._context.configuration.editor.layoutInfo.height;
        _this._editorWidth = _this._context.configuration.editor.layoutInfo.width;
        _this._domNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        __WEBPACK_IMPORTED_MODULE_3__view_viewPart_js__["a" /* PartFingerprints */].write(_this._domNode, 4 /* OverlayWidgets */);
        _this._domNode.setClassName('overlayWidgets');
        return _this;
    }
    ViewOverlayWidgets.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._widgets = null;
    };
    ViewOverlayWidgets.prototype.getDomNode = function () {
        return this._domNode;
    };
    // ---- begin view event handlers
    ViewOverlayWidgets.prototype.onConfigurationChanged = function (e) {
        if (e.layoutInfo) {
            this._verticalScrollbarWidth = this._context.configuration.editor.layoutInfo.verticalScrollbarWidth;
            this._minimapWidth = this._context.configuration.editor.layoutInfo.minimapWidth;
            this._horizontalScrollbarHeight = this._context.configuration.editor.layoutInfo.horizontalScrollbarHeight;
            this._editorHeight = this._context.configuration.editor.layoutInfo.height;
            this._editorWidth = this._context.configuration.editor.layoutInfo.width;
            return true;
        }
        return false;
    };
    // ---- end view event handlers
    ViewOverlayWidgets.prototype.addWidget = function (widget) {
        var domNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(widget.getDomNode());
        this._widgets[widget.getId()] = {
            widget: widget,
            preference: null,
            domNode: domNode
        };
        // This is sync because a widget wants to be in the dom
        domNode.setPosition('absolute');
        domNode.setAttribute('widgetId', widget.getId());
        this._domNode.appendChild(domNode);
        this.setShouldRender();
    };
    ViewOverlayWidgets.prototype.setWidgetPosition = function (widget, preference) {
        var widgetData = this._widgets[widget.getId()];
        if (widgetData.preference === preference) {
            return false;
        }
        widgetData.preference = preference;
        this.setShouldRender();
        return true;
    };
    ViewOverlayWidgets.prototype.removeWidget = function (widget) {
        var widgetId = widget.getId();
        if (this._widgets.hasOwnProperty(widgetId)) {
            var widgetData = this._widgets[widgetId];
            var domNode = widgetData.domNode.domNode;
            delete this._widgets[widgetId];
            domNode.parentNode.removeChild(domNode);
            this.setShouldRender();
        }
    };
    ViewOverlayWidgets.prototype._renderWidget = function (widgetData) {
        var domNode = widgetData.domNode;
        if (widgetData.preference === null) {
            domNode.unsetTop();
            return;
        }
        if (widgetData.preference === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["c" /* OverlayWidgetPositionPreference */].TOP_RIGHT_CORNER) {
            domNode.setTop(0);
            domNode.setRight((2 * this._verticalScrollbarWidth) + this._minimapWidth);
        }
        else if (widgetData.preference === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["c" /* OverlayWidgetPositionPreference */].BOTTOM_RIGHT_CORNER) {
            var widgetHeight = domNode.domNode.clientHeight;
            domNode.setTop((this._editorHeight - widgetHeight - 2 * this._horizontalScrollbarHeight));
            domNode.setRight((2 * this._verticalScrollbarWidth) + this._minimapWidth);
        }
        else if (widgetData.preference === __WEBPACK_IMPORTED_MODULE_2__editorBrowser_js__["c" /* OverlayWidgetPositionPreference */].TOP_CENTER) {
            domNode.setTop(0);
            domNode.domNode.style.right = '50%';
        }
    };
    ViewOverlayWidgets.prototype.prepareRender = function (ctx) {
        // Nothing to read
    };
    ViewOverlayWidgets.prototype.render = function (ctx) {
        this._domNode.setWidth(this._editorWidth);
        var keys = Object.keys(this._widgets);
        for (var i = 0, len = keys.length; i < len; i++) {
            var widgetId = keys[i];
            this._renderWidget(this._widgets[widgetId]);
        }
    };
    return ViewOverlayWidgets;
}(__WEBPACK_IMPORTED_MODULE_3__view_viewPart_js__["b" /* ViewPart */]));



/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DecorationsOverviewRuler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_browser_fastDomNode_js__ = __webpack_require__(23);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var Settings = /** @class */ (function () {
    function Settings(config, theme) {
        this.lineHeight = config.editor.lineHeight;
        this.pixelRatio = config.editor.pixelRatio;
        this.overviewRulerLanes = config.editor.viewInfo.overviewRulerLanes;
        this.renderBorder = config.editor.viewInfo.overviewRulerBorder;
        var borderColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["r" /* editorOverviewRulerBorder */]);
        this.borderColor = borderColor ? borderColor.toString() : null;
        this.hideCursor = config.editor.viewInfo.hideCursorInOverviewRuler;
        var cursorColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_3__common_view_editorColorRegistry_js__["g" /* editorCursorForeground */]);
        this.cursorColor = cursorColor ? cursorColor.transparent(0.7).toString() : null;
        this.themeType = theme.type;
        var minimapEnabled = config.editor.viewInfo.minimap.enabled;
        var minimapSide = config.editor.viewInfo.minimap.side;
        var backgroundColor = (minimapEnabled ? __WEBPACK_IMPORTED_MODULE_2__common_modes_js__["y" /* TokenizationRegistry */].getDefaultBackground() : null);
        if (backgroundColor === null || minimapSide === 'left') {
            this.backgroundColor = null;
        }
        else {
            this.backgroundColor = __WEBPACK_IMPORTED_MODULE_4__base_common_color_js__["a" /* Color */].Format.CSS.formatHex(backgroundColor);
        }
        var position = config.editor.layoutInfo.overviewRuler;
        this.top = position.top;
        this.right = position.right;
        this.domWidth = position.width;
        this.domHeight = position.height;
        this.canvasWidth = (this.domWidth * this.pixelRatio) | 0;
        this.canvasHeight = (this.domHeight * this.pixelRatio) | 0;
        var _a = this._initLanes(1, this.canvasWidth, this.overviewRulerLanes), x = _a[0], w = _a[1];
        this.x = x;
        this.w = w;
    }
    Settings.prototype._initLanes = function (canvasLeftOffset, canvasWidth, laneCount) {
        var remainingWidth = canvasWidth - canvasLeftOffset;
        if (laneCount >= 3) {
            var leftWidth = Math.floor(remainingWidth / 3);
            var rightWidth = Math.floor(remainingWidth / 3);
            var centerWidth = remainingWidth - leftWidth - rightWidth;
            var leftOffset = canvasLeftOffset;
            var centerOffset = leftOffset + leftWidth;
            var rightOffset = leftOffset + leftWidth + centerWidth;
            return [
                [
                    0,
                    leftOffset,
                    centerOffset,
                    leftOffset,
                    rightOffset,
                    leftOffset,
                    centerOffset,
                    leftOffset,
                ], [
                    0,
                    leftWidth,
                    centerWidth,
                    leftWidth + centerWidth,
                    rightWidth,
                    leftWidth + centerWidth + rightWidth,
                    centerWidth + rightWidth,
                    leftWidth + centerWidth + rightWidth,
                ]
            ];
        }
        else if (laneCount === 2) {
            var leftWidth = Math.floor(remainingWidth / 2);
            var rightWidth = remainingWidth - leftWidth;
            var leftOffset = canvasLeftOffset;
            var rightOffset = leftOffset + leftWidth;
            return [
                [
                    0,
                    leftOffset,
                    leftOffset,
                    leftOffset,
                    rightOffset,
                    leftOffset,
                    leftOffset,
                    leftOffset,
                ], [
                    0,
                    leftWidth,
                    leftWidth,
                    leftWidth,
                    rightWidth,
                    leftWidth + rightWidth,
                    leftWidth + rightWidth,
                    leftWidth + rightWidth,
                ]
            ];
        }
        else {
            var offset = canvasLeftOffset;
            var width = remainingWidth;
            return [
                [
                    0,
                    offset,
                    offset,
                    offset,
                    offset,
                    offset,
                    offset,
                    offset,
                ], [
                    0,
                    width,
                    width,
                    width,
                    width,
                    width,
                    width,
                    width,
                ]
            ];
        }
    };
    Settings.prototype.equals = function (other) {
        return (this.lineHeight === other.lineHeight
            && this.pixelRatio === other.pixelRatio
            && this.overviewRulerLanes === other.overviewRulerLanes
            && this.renderBorder === other.renderBorder
            && this.borderColor === other.borderColor
            && this.hideCursor === other.hideCursor
            && this.cursorColor === other.cursorColor
            && this.themeType === other.themeType
            && this.backgroundColor === other.backgroundColor
            && this.top === other.top
            && this.right === other.right
            && this.domWidth === other.domWidth
            && this.domHeight === other.domHeight
            && this.canvasWidth === other.canvasWidth
            && this.canvasHeight === other.canvasHeight);
    };
    return Settings;
}());
var DecorationsOverviewRuler = /** @class */ (function (_super) {
    __extends(DecorationsOverviewRuler, _super);
    function DecorationsOverviewRuler(context) {
        var _this = _super.call(this, context) || this;
        _this._domNode = Object(__WEBPACK_IMPORTED_MODULE_5__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('canvas'));
        _this._domNode.setClassName('decorationsOverviewRuler');
        _this._domNode.setPosition('absolute');
        _this._domNode.setLayerHinting(true);
        _this._domNode.setAttribute('aria-hidden', 'true');
        _this._settings = null;
        _this._updateSettings(false);
        _this._tokensColorTrackerListener = __WEBPACK_IMPORTED_MODULE_2__common_modes_js__["y" /* TokenizationRegistry */].onDidChange(function (e) {
            if (e.changedColorMap) {
                _this._updateSettings(true);
            }
        });
        _this._cursorPositions = [];
        return _this;
    }
    DecorationsOverviewRuler.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._tokensColorTrackerListener.dispose();
    };
    DecorationsOverviewRuler.prototype._updateSettings = function (renderNow) {
        var newSettings = new Settings(this._context.configuration, this._context.theme);
        if (this._settings !== null && this._settings.equals(newSettings)) {
            // nothing to do
            return false;
        }
        this._settings = newSettings;
        this._domNode.setTop(this._settings.top);
        this._domNode.setRight(this._settings.right);
        this._domNode.setWidth(this._settings.domWidth);
        this._domNode.setHeight(this._settings.domHeight);
        this._domNode.domNode.width = this._settings.canvasWidth;
        this._domNode.domNode.height = this._settings.canvasHeight;
        if (renderNow) {
            this._render();
        }
        return true;
    };
    // ---- begin view event handlers
    DecorationsOverviewRuler.prototype.onConfigurationChanged = function (e) {
        return this._updateSettings(false);
    };
    DecorationsOverviewRuler.prototype.onCursorStateChanged = function (e) {
        this._cursorPositions = [];
        for (var i = 0, len = e.selections.length; i < len; i++) {
            this._cursorPositions[i] = e.selections[i].getPosition();
        }
        this._cursorPositions.sort(__WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */].compare);
        return true;
    };
    DecorationsOverviewRuler.prototype.onDecorationsChanged = function (e) {
        return true;
    };
    DecorationsOverviewRuler.prototype.onFlushed = function (e) {
        return true;
    };
    DecorationsOverviewRuler.prototype.onScrollChanged = function (e) {
        return e.scrollHeightChanged;
    };
    DecorationsOverviewRuler.prototype.onZonesChanged = function (e) {
        return true;
    };
    DecorationsOverviewRuler.prototype.onThemeChanged = function (e) {
        // invalidate color cache
        this._context.model.invalidateOverviewRulerColorCache();
        return this._updateSettings(false);
    };
    // ---- end view event handlers
    DecorationsOverviewRuler.prototype.getDomNode = function () {
        return this._domNode.domNode;
    };
    DecorationsOverviewRuler.prototype.prepareRender = function (ctx) {
        // Nothing to read
    };
    DecorationsOverviewRuler.prototype.render = function (editorCtx) {
        this._render();
    };
    DecorationsOverviewRuler.prototype._render = function () {
        var canvasWidth = this._settings.canvasWidth;
        var canvasHeight = this._settings.canvasHeight;
        var lineHeight = this._settings.lineHeight;
        var viewLayout = this._context.viewLayout;
        var outerHeight = this._context.viewLayout.getScrollHeight();
        var heightRatio = canvasHeight / outerHeight;
        var decorations = this._context.model.getAllOverviewRulerDecorations(this._context.theme);
        var minDecorationHeight = (6 /* MIN_DECORATION_HEIGHT */ * this._settings.pixelRatio) | 0;
        var halfMinDecorationHeight = (minDecorationHeight / 2) | 0;
        var canvasCtx = this._domNode.domNode.getContext('2d');
        if (this._settings.backgroundColor === null) {
            canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight);
        }
        else {
            canvasCtx.fillStyle = this._settings.backgroundColor;
            canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
        }
        var x = this._settings.x;
        var w = this._settings.w;
        // Avoid flickering by always rendering the colors in the same order
        // colors that don't use transparency will be sorted last (they start with #)
        var colors = Object.keys(decorations);
        colors.sort();
        for (var cIndex = 0, cLen = colors.length; cIndex < cLen; cIndex++) {
            var color = colors[cIndex];
            var colorDecorations = decorations[color];
            canvasCtx.fillStyle = color;
            var prevLane = 0;
            var prevY1 = 0;
            var prevY2 = 0;
            for (var i = 0, len = colorDecorations.length; i < len; i++) {
                var lane = colorDecorations[3 * i];
                var startLineNumber = colorDecorations[3 * i + 1];
                var endLineNumber = colorDecorations[3 * i + 2];
                var y1 = (viewLayout.getVerticalOffsetForLineNumber(startLineNumber) * heightRatio) | 0;
                var y2 = ((viewLayout.getVerticalOffsetForLineNumber(endLineNumber) + lineHeight) * heightRatio) | 0;
                var height = y2 - y1;
                if (height < minDecorationHeight) {
                    var yCenter = ((y1 + y2) / 2) | 0;
                    if (yCenter < halfMinDecorationHeight) {
                        yCenter = halfMinDecorationHeight;
                    }
                    else if (yCenter + halfMinDecorationHeight > canvasHeight) {
                        yCenter = canvasHeight - halfMinDecorationHeight;
                    }
                    y1 = yCenter - halfMinDecorationHeight;
                    y2 = yCenter + halfMinDecorationHeight;
                }
                if (y1 > prevY2 + 1 || lane !== prevLane) {
                    // flush prev
                    if (i !== 0) {
                        canvasCtx.fillRect(x[prevLane], prevY1, w[prevLane], prevY2 - prevY1);
                    }
                    prevLane = lane;
                    prevY1 = y1;
                    prevY2 = y2;
                }
                else {
                    // merge into prev
                    if (y2 > prevY2) {
                        prevY2 = y2;
                    }
                }
            }
            canvasCtx.fillRect(x[prevLane], prevY1, w[prevLane], prevY2 - prevY1);
        }
        // Draw cursors
        if (!this._settings.hideCursor) {
            var cursorHeight = (2 * this._settings.pixelRatio) | 0;
            var halfCursorHeight = (cursorHeight / 2) | 0;
            var cursorX = this._settings.x[7 /* Full */];
            var cursorW = this._settings.w[7 /* Full */];
            canvasCtx.fillStyle = this._settings.cursorColor;
            var prevY1 = -100;
            var prevY2 = -100;
            for (var i = 0, len = this._cursorPositions.length; i < len; i++) {
                var cursor = this._cursorPositions[i];
                var yCenter = (viewLayout.getVerticalOffsetForLineNumber(cursor.lineNumber) * heightRatio) | 0;
                if (yCenter < halfCursorHeight) {
                    yCenter = halfCursorHeight;
                }
                else if (yCenter + halfCursorHeight > canvasHeight) {
                    yCenter = canvasHeight - halfCursorHeight;
                }
                var y1 = yCenter - halfCursorHeight;
                var y2 = y1 + cursorHeight;
                if (y1 > prevY2 + 1) {
                    // flush prev
                    if (i !== 0) {
                        canvasCtx.fillRect(cursorX, prevY1, cursorW, prevY2 - prevY1);
                    }
                    prevY1 = y1;
                    prevY2 = y2;
                }
                else {
                    // merge into prev
                    if (y2 > prevY2) {
                        prevY2 = y2;
                    }
                }
            }
            canvasCtx.fillRect(cursorX, prevY1, cursorW, prevY2 - prevY1);
        }
        if (this._settings.renderBorder && this._settings.borderColor && this._settings.overviewRulerLanes > 0) {
            canvasCtx.beginPath();
            canvasCtx.lineWidth = 1;
            canvasCtx.strokeStyle = this._settings.borderColor;
            canvasCtx.moveTo(0, 0);
            canvasCtx.lineTo(0, canvasHeight);
            canvasCtx.stroke();
            canvasCtx.moveTo(0, 0);
            canvasCtx.lineTo(canvasWidth, 0);
            canvasCtx.stroke();
        }
    };
    return DecorationsOverviewRuler;
}(__WEBPACK_IMPORTED_MODULE_0__view_viewPart_js__["b" /* ViewPart */]));



/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverviewRuler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_viewModel_viewEventHandler_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_view_overviewZoneManager_js__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__ = __webpack_require__(23);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var OverviewRuler = /** @class */ (function (_super) {
    __extends(OverviewRuler, _super);
    function OverviewRuler(context, cssClassName) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._domNode = Object(__WEBPACK_IMPORTED_MODULE_2__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('canvas'));
        _this._domNode.setClassName(cssClassName);
        _this._domNode.setPosition('absolute');
        _this._domNode.setLayerHinting(true);
        _this._zoneManager = new __WEBPACK_IMPORTED_MODULE_1__common_view_overviewZoneManager_js__["b" /* OverviewZoneManager */](function (lineNumber) { return _this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber); });
        _this._zoneManager.setDOMWidth(0);
        _this._zoneManager.setDOMHeight(0);
        _this._zoneManager.setOuterHeight(_this._context.viewLayout.getScrollHeight());
        _this._zoneManager.setLineHeight(_this._context.configuration.editor.lineHeight);
        _this._zoneManager.setPixelRatio(_this._context.configuration.editor.pixelRatio);
        _this._context.addEventHandler(_this);
        return _this;
    }
    OverviewRuler.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._zoneManager = null;
        _super.prototype.dispose.call(this);
    };
    // ---- begin view event handlers
    OverviewRuler.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._zoneManager.setLineHeight(this._context.configuration.editor.lineHeight);
            this._render();
        }
        if (e.pixelRatio) {
            this._zoneManager.setPixelRatio(this._context.configuration.editor.pixelRatio);
            this._domNode.setWidth(this._zoneManager.getDOMWidth());
            this._domNode.setHeight(this._zoneManager.getDOMHeight());
            this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
            this._domNode.domNode.height = this._zoneManager.getCanvasHeight();
            this._render();
        }
        return true;
    };
    OverviewRuler.prototype.onFlushed = function (e) {
        this._render();
        return true;
    };
    OverviewRuler.prototype.onScrollChanged = function (e) {
        if (e.scrollHeightChanged) {
            this._zoneManager.setOuterHeight(e.scrollHeight);
            this._render();
        }
        return true;
    };
    OverviewRuler.prototype.onZonesChanged = function (e) {
        this._render();
        return true;
    };
    // ---- end view event handlers
    OverviewRuler.prototype.getDomNode = function () {
        return this._domNode.domNode;
    };
    OverviewRuler.prototype.setLayout = function (position) {
        this._domNode.setTop(position.top);
        this._domNode.setRight(position.right);
        var hasChanged = false;
        hasChanged = this._zoneManager.setDOMWidth(position.width) || hasChanged;
        hasChanged = this._zoneManager.setDOMHeight(position.height) || hasChanged;
        if (hasChanged) {
            this._domNode.setWidth(this._zoneManager.getDOMWidth());
            this._domNode.setHeight(this._zoneManager.getDOMHeight());
            this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
            this._domNode.domNode.height = this._zoneManager.getCanvasHeight();
            this._render();
        }
    };
    OverviewRuler.prototype.setZones = function (zones) {
        this._zoneManager.setZones(zones);
        this._render();
    };
    OverviewRuler.prototype._render = function () {
        if (this._zoneManager.getOuterHeight() === 0) {
            return false;
        }
        var width = this._zoneManager.getCanvasWidth();
        var height = this._zoneManager.getCanvasHeight();
        var colorZones = this._zoneManager.resolveColorZones();
        var id2Color = this._zoneManager.getId2Color();
        var ctx = this._domNode.domNode.getContext('2d');
        ctx.clearRect(0, 0, width, height);
        if (colorZones.length > 0) {
            this._renderOneLane(ctx, colorZones, id2Color, width);
        }
        return true;
    };
    OverviewRuler.prototype._renderOneLane = function (ctx, colorZones, id2Color, width) {
        var currentColorId = 0;
        var currentFrom = 0;
        var currentTo = 0;
        for (var i = 0, len = colorZones.length; i < len; i++) {
            var zone = colorZones[i];
            var zoneColorId = zone.colorId;
            var zoneFrom = zone.from;
            var zoneTo = zone.to;
            if (zoneColorId !== currentColorId) {
                ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
                currentColorId = zoneColorId;
                ctx.fillStyle = id2Color[currentColorId];
                currentFrom = zoneFrom;
                currentTo = zoneTo;
            }
            else {
                if (currentTo >= zoneFrom) {
                    currentTo = Math.max(currentTo, zoneTo);
                }
                else {
                    ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
                    currentFrom = zoneFrom;
                    currentTo = zoneTo;
                }
            }
        }
        ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
    };
    return OverviewRuler;
}(__WEBPACK_IMPORTED_MODULE_0__common_viewModel_viewEventHandler_js__["a" /* ViewEventHandler */]));



/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rulers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rulers_css__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rulers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__rulers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Rulers = /** @class */ (function (_super) {
    __extends(Rulers, _super);
    function Rulers(context) {
        var _this = _super.call(this, context) || this;
        _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.domNode.setAttribute('role', 'presentation');
        _this.domNode.setAttribute('aria-hidden', 'true');
        _this.domNode.setClassName('view-rulers');
        _this._renderedRulers = [];
        _this._rulers = _this._context.configuration.editor.viewInfo.rulers;
        _this._typicalHalfwidthCharacterWidth = _this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        return _this;
    }
    Rulers.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    Rulers.prototype.onConfigurationChanged = function (e) {
        if (e.viewInfo || e.layoutInfo || e.fontInfo) {
            this._rulers = this._context.configuration.editor.viewInfo.rulers;
            this._typicalHalfwidthCharacterWidth = this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
            return true;
        }
        return false;
    };
    Rulers.prototype.onScrollChanged = function (e) {
        return e.scrollHeightChanged;
    };
    // --- end event handlers
    Rulers.prototype.prepareRender = function (ctx) {
        // Nothing to read
    };
    Rulers.prototype._ensureRulersCount = function () {
        var currentCount = this._renderedRulers.length;
        var desiredCount = this._rulers.length;
        if (currentCount === desiredCount) {
            // Nothing to do
            return;
        }
        if (currentCount < desiredCount) {
            var rulerWidth = this._context.model.getTabSize();
            var addCount = desiredCount - currentCount;
            while (addCount > 0) {
                var node = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
                node.setClassName('view-ruler');
                node.setWidth(rulerWidth);
                this.domNode.appendChild(node);
                this._renderedRulers.push(node);
                addCount--;
            }
            return;
        }
        var removeCount = currentCount - desiredCount;
        while (removeCount > 0) {
            var node = this._renderedRulers.pop();
            this.domNode.removeChild(node);
            removeCount--;
        }
    };
    Rulers.prototype.render = function (ctx) {
        this._ensureRulersCount();
        for (var i = 0, len = this._rulers.length; i < len; i++) {
            var node = this._renderedRulers[i];
            node.setHeight(Math.min(ctx.scrollHeight, 1000000));
            node.setLeft(this._rulers[i] * this._typicalHalfwidthCharacterWidth);
        }
    };
    return Rulers;
}(__WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__["b" /* ViewPart */]));

Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var rulerColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_4__common_view_editorColorRegistry_js__["s" /* editorRuler */]);
    if (rulerColor) {
        collector.addRule(".monaco-editor .view-ruler { box-shadow: 1px 0 0 0 " + rulerColor + " inset; }");
    }
});


/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollDecorationViewPart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scrollDecoration_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scrollDecoration_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scrollDecoration_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ScrollDecorationViewPart = /** @class */ (function (_super) {
    __extends(ScrollDecorationViewPart, _super);
    function ScrollDecorationViewPart(context) {
        var _this = _super.call(this, context) || this;
        _this._scrollTop = 0;
        _this._width = 0;
        _this._updateWidth();
        _this._shouldShow = false;
        _this._useShadows = _this._context.configuration.editor.viewInfo.scrollbar.useShadows;
        _this._domNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._domNode.setAttribute('role', 'presentation');
        _this._domNode.setAttribute('aria-hidden', 'true');
        return _this;
    }
    ScrollDecorationViewPart.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    ScrollDecorationViewPart.prototype._updateShouldShow = function () {
        var newShouldShow = (this._useShadows && this._scrollTop > 0);
        if (this._shouldShow !== newShouldShow) {
            this._shouldShow = newShouldShow;
            return true;
        }
        return false;
    };
    ScrollDecorationViewPart.prototype.getDomNode = function () {
        return this._domNode;
    };
    ScrollDecorationViewPart.prototype._updateWidth = function () {
        var layoutInfo = this._context.configuration.editor.layoutInfo;
        var newWidth = 0;
        if (layoutInfo.renderMinimap === 0 || (layoutInfo.minimapWidth > 0 && layoutInfo.minimapLeft === 0)) {
            newWidth = layoutInfo.width;
        }
        else {
            newWidth = layoutInfo.width - layoutInfo.minimapWidth - layoutInfo.verticalScrollbarWidth;
        }
        if (this._width !== newWidth) {
            this._width = newWidth;
            return true;
        }
        return false;
    };
    // --- begin event handlers
    ScrollDecorationViewPart.prototype.onConfigurationChanged = function (e) {
        var shouldRender = false;
        if (e.viewInfo) {
            this._useShadows = this._context.configuration.editor.viewInfo.scrollbar.useShadows;
        }
        if (e.layoutInfo) {
            shouldRender = this._updateWidth();
        }
        return this._updateShouldShow() || shouldRender;
    };
    ScrollDecorationViewPart.prototype.onScrollChanged = function (e) {
        this._scrollTop = e.scrollTop;
        return this._updateShouldShow();
    };
    // --- end event handlers
    ScrollDecorationViewPart.prototype.prepareRender = function (ctx) {
        // Nothing to read
    };
    ScrollDecorationViewPart.prototype.render = function (ctx) {
        this._domNode.setWidth(this._width);
        this._domNode.setClassName(this._shouldShow ? 'scroll-decoration' : '');
    };
    return ScrollDecorationViewPart;
}(__WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__["b" /* ViewPart */]));

Object(__WEBPACK_IMPORTED_MODULE_3__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var shadow = theme.getColor(__WEBPACK_IMPORTED_MODULE_4__platform_theme_common_colorRegistry_js__["_11" /* scrollbarShadow */]);
    if (shadow) {
        collector.addRule(".monaco-editor .scroll-decoration { box-shadow: " + shadow + " 0 6px 6px -6px inset; }");
    }
});


/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectionsOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selections_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selections_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__selections_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_dynamicViewOverlay_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_browser_js__ = __webpack_require__(25);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var HorizontalRangeWithStyle = /** @class */ (function () {
    function HorizontalRangeWithStyle(other) {
        this.left = other.left;
        this.width = other.width;
        this.startStyle = null;
        this.endStyle = null;
    }
    return HorizontalRangeWithStyle;
}());
var LineVisibleRangesWithStyle = /** @class */ (function () {
    function LineVisibleRangesWithStyle(lineNumber, ranges) {
        this.lineNumber = lineNumber;
        this.ranges = ranges;
    }
    return LineVisibleRangesWithStyle;
}());
function toStyledRange(item) {
    return new HorizontalRangeWithStyle(item);
}
function toStyled(item) {
    return new LineVisibleRangesWithStyle(item.lineNumber, item.ranges.map(toStyledRange));
}
// TODO@Alex: Remove this once IE11 fixes Bug #524217
// The problem in IE11 is that it does some sort of auto-zooming to accomodate for displays with different pixel density.
// Unfortunately, this auto-zooming is buggy around dealing with rounded borders
var isIEWithZoomingIssuesNearRoundedBorders = __WEBPACK_IMPORTED_MODULE_4__base_browser_browser_js__["h" /* isEdgeOrIE */];
var SelectionsOverlay = /** @class */ (function (_super) {
    __extends(SelectionsOverlay, _super);
    function SelectionsOverlay(context) {
        var _this = _super.call(this) || this;
        _this._previousFrameVisibleRangesWithStyle = [];
        _this._context = context;
        _this._lineHeight = _this._context.configuration.editor.lineHeight;
        _this._roundedSelection = _this._context.configuration.editor.viewInfo.roundedSelection;
        _this._typicalHalfwidthCharacterWidth = _this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        _this._selections = [];
        _this._renderResult = null;
        _this._context.addEventHandler(_this);
        return _this;
    }
    SelectionsOverlay.prototype.dispose = function () {
        this._context.removeEventHandler(this);
        this._context = null;
        this._selections = null;
        this._renderResult = null;
        _super.prototype.dispose.call(this);
    };
    // --- begin event handlers
    SelectionsOverlay.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.viewInfo) {
            this._roundedSelection = this._context.configuration.editor.viewInfo.roundedSelection;
        }
        if (e.fontInfo) {
            this._typicalHalfwidthCharacterWidth = this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        }
        return true;
    };
    SelectionsOverlay.prototype.onCursorStateChanged = function (e) {
        this._selections = e.selections.slice(0);
        return true;
    };
    SelectionsOverlay.prototype.onDecorationsChanged = function (e) {
        // true for inline decorations that can end up relayouting text
        return true; //e.inlineDecorationsChanged;
    };
    SelectionsOverlay.prototype.onFlushed = function (e) {
        return true;
    };
    SelectionsOverlay.prototype.onLinesChanged = function (e) {
        return true;
    };
    SelectionsOverlay.prototype.onLinesDeleted = function (e) {
        return true;
    };
    SelectionsOverlay.prototype.onLinesInserted = function (e) {
        return true;
    };
    SelectionsOverlay.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged;
    };
    SelectionsOverlay.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    SelectionsOverlay.prototype._visibleRangesHaveGaps = function (linesVisibleRanges) {
        for (var i = 0, len = linesVisibleRanges.length; i < len; i++) {
            var lineVisibleRanges = linesVisibleRanges[i];
            if (lineVisibleRanges.ranges.length > 1) {
                // There are two ranges on the same line
                return true;
            }
        }
        return false;
    };
    SelectionsOverlay.prototype._enrichVisibleRangesWithStyle = function (viewport, linesVisibleRanges, previousFrame) {
        var epsilon = this._typicalHalfwidthCharacterWidth / 4;
        var previousFrameTop = null;
        var previousFrameBottom = null;
        if (previousFrame && previousFrame.length > 0 && linesVisibleRanges.length > 0) {
            var topLineNumber = linesVisibleRanges[0].lineNumber;
            if (topLineNumber === viewport.startLineNumber) {
                for (var i = 0; !previousFrameTop && i < previousFrame.length; i++) {
                    if (previousFrame[i].lineNumber === topLineNumber) {
                        previousFrameTop = previousFrame[i].ranges[0];
                    }
                }
            }
            var bottomLineNumber = linesVisibleRanges[linesVisibleRanges.length - 1].lineNumber;
            if (bottomLineNumber === viewport.endLineNumber) {
                for (var i = previousFrame.length - 1; !previousFrameBottom && i >= 0; i--) {
                    if (previousFrame[i].lineNumber === bottomLineNumber) {
                        previousFrameBottom = previousFrame[i].ranges[0];
                    }
                }
            }
            if (previousFrameTop && !previousFrameTop.startStyle) {
                previousFrameTop = null;
            }
            if (previousFrameBottom && !previousFrameBottom.startStyle) {
                previousFrameBottom = null;
            }
        }
        for (var i = 0, len = linesVisibleRanges.length; i < len; i++) {
            // We know for a fact that there is precisely one range on each line
            var curLineRange = linesVisibleRanges[i].ranges[0];
            var curLeft = curLineRange.left;
            var curRight = curLineRange.left + curLineRange.width;
            var startStyle = {
                top: 0 /* EXTERN */,
                bottom: 0 /* EXTERN */
            };
            var endStyle = {
                top: 0 /* EXTERN */,
                bottom: 0 /* EXTERN */
            };
            if (i > 0) {
                // Look above
                var prevLeft = linesVisibleRanges[i - 1].ranges[0].left;
                var prevRight = linesVisibleRanges[i - 1].ranges[0].left + linesVisibleRanges[i - 1].ranges[0].width;
                if (abs(curLeft - prevLeft) < epsilon) {
                    startStyle.top = 2 /* FLAT */;
                }
                else if (curLeft > prevLeft) {
                    startStyle.top = 1 /* INTERN */;
                }
                if (abs(curRight - prevRight) < epsilon) {
                    endStyle.top = 2 /* FLAT */;
                }
                else if (prevLeft < curRight && curRight < prevRight) {
                    endStyle.top = 1 /* INTERN */;
                }
            }
            else if (previousFrameTop) {
                // Accept some hick-ups near the viewport edges to save on repaints
                startStyle.top = previousFrameTop.startStyle.top;
                endStyle.top = previousFrameTop.endStyle.top;
            }
            if (i + 1 < len) {
                // Look below
                var nextLeft = linesVisibleRanges[i + 1].ranges[0].left;
                var nextRight = linesVisibleRanges[i + 1].ranges[0].left + linesVisibleRanges[i + 1].ranges[0].width;
                if (abs(curLeft - nextLeft) < epsilon) {
                    startStyle.bottom = 2 /* FLAT */;
                }
                else if (nextLeft < curLeft && curLeft < nextRight) {
                    startStyle.bottom = 1 /* INTERN */;
                }
                if (abs(curRight - nextRight) < epsilon) {
                    endStyle.bottom = 2 /* FLAT */;
                }
                else if (curRight < nextRight) {
                    endStyle.bottom = 1 /* INTERN */;
                }
            }
            else if (previousFrameBottom) {
                // Accept some hick-ups near the viewport edges to save on repaints
                startStyle.bottom = previousFrameBottom.startStyle.bottom;
                endStyle.bottom = previousFrameBottom.endStyle.bottom;
            }
            curLineRange.startStyle = startStyle;
            curLineRange.endStyle = endStyle;
        }
    };
    SelectionsOverlay.prototype._getVisibleRangesWithStyle = function (selection, ctx, previousFrame) {
        var _linesVisibleRanges = ctx.linesVisibleRangesForRange(selection, true) || [];
        var linesVisibleRanges = _linesVisibleRanges.map(toStyled);
        var visibleRangesHaveGaps = this._visibleRangesHaveGaps(linesVisibleRanges);
        if (!isIEWithZoomingIssuesNearRoundedBorders && !visibleRangesHaveGaps && this._roundedSelection) {
            this._enrichVisibleRangesWithStyle(ctx.visibleRange, linesVisibleRanges, previousFrame);
        }
        // The visible ranges are sorted TOP-BOTTOM and LEFT-RIGHT
        return linesVisibleRanges;
    };
    SelectionsOverlay.prototype._createSelectionPiece = function (top, height, className, left, width) {
        return ('<div class="cslr '
            + className
            + '" style="top:'
            + top.toString()
            + 'px;left:'
            + left.toString()
            + 'px;width:'
            + width.toString()
            + 'px;height:'
            + height
            + 'px;"></div>');
    };
    SelectionsOverlay.prototype._actualRenderOneSelection = function (output2, visibleStartLineNumber, hasMultipleSelections, visibleRanges) {
        var visibleRangesHaveStyle = (visibleRanges.length > 0 && visibleRanges[0].ranges[0].startStyle);
        var fullLineHeight = (this._lineHeight).toString();
        var reducedLineHeight = (this._lineHeight - 1).toString();
        var firstLineNumber = (visibleRanges.length > 0 ? visibleRanges[0].lineNumber : 0);
        var lastLineNumber = (visibleRanges.length > 0 ? visibleRanges[visibleRanges.length - 1].lineNumber : 0);
        for (var i = 0, len = visibleRanges.length; i < len; i++) {
            var lineVisibleRanges = visibleRanges[i];
            var lineNumber = lineVisibleRanges.lineNumber;
            var lineIndex = lineNumber - visibleStartLineNumber;
            var lineHeight = hasMultipleSelections ? (lineNumber === lastLineNumber || lineNumber === firstLineNumber ? reducedLineHeight : fullLineHeight) : fullLineHeight;
            var top_1 = hasMultipleSelections ? (lineNumber === firstLineNumber ? 1 : 0) : 0;
            var lineOutput = '';
            for (var j = 0, lenJ = lineVisibleRanges.ranges.length; j < lenJ; j++) {
                var visibleRange = lineVisibleRanges.ranges[j];
                if (visibleRangesHaveStyle) {
                    if (visibleRange.startStyle.top === 1 /* INTERN */ || visibleRange.startStyle.bottom === 1 /* INTERN */) {
                        // Reverse rounded corner to the left
                        // First comes the selection (blue layer)
                        lineOutput += this._createSelectionPiece(top_1, lineHeight, SelectionsOverlay.SELECTION_CLASS_NAME, visibleRange.left - SelectionsOverlay.ROUNDED_PIECE_WIDTH, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                        // Second comes the background (white layer) with inverse border radius
                        var className_1 = SelectionsOverlay.EDITOR_BACKGROUND_CLASS_NAME;
                        if (visibleRange.startStyle.top === 1 /* INTERN */) {
                            className_1 += ' ' + SelectionsOverlay.SELECTION_TOP_RIGHT;
                        }
                        if (visibleRange.startStyle.bottom === 1 /* INTERN */) {
                            className_1 += ' ' + SelectionsOverlay.SELECTION_BOTTOM_RIGHT;
                        }
                        lineOutput += this._createSelectionPiece(top_1, lineHeight, className_1, visibleRange.left - SelectionsOverlay.ROUNDED_PIECE_WIDTH, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                    }
                    if (visibleRange.endStyle.top === 1 /* INTERN */ || visibleRange.endStyle.bottom === 1 /* INTERN */) {
                        // Reverse rounded corner to the right
                        // First comes the selection (blue layer)
                        lineOutput += this._createSelectionPiece(top_1, lineHeight, SelectionsOverlay.SELECTION_CLASS_NAME, visibleRange.left + visibleRange.width, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                        // Second comes the background (white layer) with inverse border radius
                        var className_2 = SelectionsOverlay.EDITOR_BACKGROUND_CLASS_NAME;
                        if (visibleRange.endStyle.top === 1 /* INTERN */) {
                            className_2 += ' ' + SelectionsOverlay.SELECTION_TOP_LEFT;
                        }
                        if (visibleRange.endStyle.bottom === 1 /* INTERN */) {
                            className_2 += ' ' + SelectionsOverlay.SELECTION_BOTTOM_LEFT;
                        }
                        lineOutput += this._createSelectionPiece(top_1, lineHeight, className_2, visibleRange.left + visibleRange.width, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                    }
                }
                var className = SelectionsOverlay.SELECTION_CLASS_NAME;
                if (visibleRangesHaveStyle) {
                    if (visibleRange.startStyle.top === 0 /* EXTERN */) {
                        className += ' ' + SelectionsOverlay.SELECTION_TOP_LEFT;
                    }
                    if (visibleRange.startStyle.bottom === 0 /* EXTERN */) {
                        className += ' ' + SelectionsOverlay.SELECTION_BOTTOM_LEFT;
                    }
                    if (visibleRange.endStyle.top === 0 /* EXTERN */) {
                        className += ' ' + SelectionsOverlay.SELECTION_TOP_RIGHT;
                    }
                    if (visibleRange.endStyle.bottom === 0 /* EXTERN */) {
                        className += ' ' + SelectionsOverlay.SELECTION_BOTTOM_RIGHT;
                    }
                }
                lineOutput += this._createSelectionPiece(top_1, lineHeight, className, visibleRange.left, visibleRange.width);
            }
            output2[lineIndex] += lineOutput;
        }
    };
    SelectionsOverlay.prototype.prepareRender = function (ctx) {
        var output = [];
        var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
            var lineIndex = lineNumber - visibleStartLineNumber;
            output[lineIndex] = '';
        }
        var thisFrameVisibleRangesWithStyle = [];
        for (var i = 0, len = this._selections.length; i < len; i++) {
            var selection = this._selections[i];
            if (selection.isEmpty()) {
                thisFrameVisibleRangesWithStyle[i] = null;
                continue;
            }
            var visibleRangesWithStyle = this._getVisibleRangesWithStyle(selection, ctx, this._previousFrameVisibleRangesWithStyle[i]);
            thisFrameVisibleRangesWithStyle[i] = visibleRangesWithStyle;
            this._actualRenderOneSelection(output, visibleStartLineNumber, this._selections.length > 1, visibleRangesWithStyle);
        }
        this._previousFrameVisibleRangesWithStyle = thisFrameVisibleRangesWithStyle;
        this._renderResult = output;
    };
    SelectionsOverlay.prototype.render = function (startLineNumber, lineNumber) {
        if (!this._renderResult) {
            return '';
        }
        var lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) {
            return '';
        }
        return this._renderResult[lineIndex];
    };
    SelectionsOverlay.SELECTION_CLASS_NAME = 'selected-text';
    SelectionsOverlay.SELECTION_TOP_LEFT = 'top-left-radius';
    SelectionsOverlay.SELECTION_BOTTOM_LEFT = 'bottom-left-radius';
    SelectionsOverlay.SELECTION_TOP_RIGHT = 'top-right-radius';
    SelectionsOverlay.SELECTION_BOTTOM_RIGHT = 'bottom-right-radius';
    SelectionsOverlay.EDITOR_BACKGROUND_CLASS_NAME = 'monaco-editor-background';
    SelectionsOverlay.ROUNDED_PIECE_WIDTH = 10;
    return SelectionsOverlay;
}(__WEBPACK_IMPORTED_MODULE_3__view_dynamicViewOverlay_js__["a" /* DynamicViewOverlay */]));

Object(__WEBPACK_IMPORTED_MODULE_1__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var editorSelectionColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["z" /* editorSelectionBackground */]);
    if (editorSelectionColor) {
        collector.addRule(".monaco-editor .focused .selected-text { background-color: " + editorSelectionColor + "; }");
    }
    var editorInactiveSelectionColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["y" /* editorInactiveSelection */]);
    if (editorInactiveSelectionColor) {
        collector.addRule(".monaco-editor .selected-text { background-color: " + editorInactiveSelectionColor + "; }");
    }
    var editorSelectionForegroundColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_colorRegistry_js__["A" /* editorSelectionForeground */]);
    if (editorSelectionForegroundColor) {
        collector.addRule(".monaco-editor .view-line span.inline-selected-text { color: " + editorSelectionForegroundColor + "; }");
    }
});
function abs(n) {
    return n < 0 ? -n : n;
}


/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewCursors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__viewCursors_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__viewCursors_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__viewCursors_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__viewCursor_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__ = __webpack_require__(45);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var ViewCursors = /** @class */ (function (_super) {
    __extends(ViewCursors, _super);
    function ViewCursors(context) {
        var _this = _super.call(this, context) || this;
        _this._readOnly = _this._context.configuration.editor.readOnly;
        _this._cursorBlinking = _this._context.configuration.editor.viewInfo.cursorBlinking;
        _this._cursorStyle = _this._context.configuration.editor.viewInfo.cursorStyle;
        _this._selectionIsEmpty = true;
        _this._primaryCursor = new __WEBPACK_IMPORTED_MODULE_2__viewCursor_js__["a" /* ViewCursor */](_this._context);
        _this._secondaryCursors = [];
        _this._renderData = [];
        _this._domNode = Object(__WEBPACK_IMPORTED_MODULE_3__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._domNode.setAttribute('role', 'presentation');
        _this._domNode.setAttribute('aria-hidden', 'true');
        _this._updateDomClassName();
        _this._domNode.appendChild(_this._primaryCursor.getDomNode());
        _this._startCursorBlinkAnimation = new __WEBPACK_IMPORTED_MODULE_4__base_common_async_js__["f" /* TimeoutTimer */]();
        _this._cursorFlatBlinkInterval = new __WEBPACK_IMPORTED_MODULE_4__base_common_async_js__["b" /* IntervalTimer */]();
        _this._blinkingEnabled = false;
        _this._editorHasFocus = false;
        _this._updateBlinking();
        return _this;
    }
    ViewCursors.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._startCursorBlinkAnimation.dispose();
        this._cursorFlatBlinkInterval.dispose();
    };
    ViewCursors.prototype.getDomNode = function () {
        return this._domNode;
    };
    // --- begin event handlers
    ViewCursors.prototype.onConfigurationChanged = function (e) {
        if (e.readOnly) {
            this._readOnly = this._context.configuration.editor.readOnly;
        }
        if (e.viewInfo) {
            this._cursorBlinking = this._context.configuration.editor.viewInfo.cursorBlinking;
            this._cursorStyle = this._context.configuration.editor.viewInfo.cursorStyle;
        }
        this._primaryCursor.onConfigurationChanged(e);
        this._updateBlinking();
        if (e.viewInfo) {
            this._updateDomClassName();
        }
        for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
            this._secondaryCursors[i].onConfigurationChanged(e);
        }
        return true;
    };
    ViewCursors.prototype._onCursorPositionChanged = function (position, secondaryPositions) {
        this._primaryCursor.onCursorPositionChanged(position);
        this._updateBlinking();
        if (this._secondaryCursors.length < secondaryPositions.length) {
            // Create new cursors
            var addCnt = secondaryPositions.length - this._secondaryCursors.length;
            for (var i = 0; i < addCnt; i++) {
                var newCursor = new __WEBPACK_IMPORTED_MODULE_2__viewCursor_js__["a" /* ViewCursor */](this._context);
                this._domNode.domNode.insertBefore(newCursor.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling);
                this._secondaryCursors.push(newCursor);
            }
        }
        else if (this._secondaryCursors.length > secondaryPositions.length) {
            // Remove some cursors
            var removeCnt = this._secondaryCursors.length - secondaryPositions.length;
            for (var i = 0; i < removeCnt; i++) {
                this._domNode.removeChild(this._secondaryCursors[0].getDomNode());
                this._secondaryCursors.splice(0, 1);
            }
        }
        for (var i = 0; i < secondaryPositions.length; i++) {
            this._secondaryCursors[i].onCursorPositionChanged(secondaryPositions[i]);
        }
    };
    ViewCursors.prototype.onCursorStateChanged = function (e) {
        var positions = [];
        for (var i = 0, len = e.selections.length; i < len; i++) {
            positions[i] = e.selections[i].getPosition();
        }
        this._onCursorPositionChanged(positions[0], positions.slice(1));
        var selectionIsEmpty = e.selections[0].isEmpty();
        if (this._selectionIsEmpty !== selectionIsEmpty) {
            this._selectionIsEmpty = selectionIsEmpty;
            this._updateDomClassName();
        }
        return true;
    };
    ViewCursors.prototype.onDecorationsChanged = function (e) {
        // true for inline decorations that can end up relayouting text
        return true;
    };
    ViewCursors.prototype.onFlushed = function (e) {
        return true;
    };
    ViewCursors.prototype.onFocusChanged = function (e) {
        this._editorHasFocus = e.isFocused;
        this._updateBlinking();
        return false;
    };
    ViewCursors.prototype.onLinesChanged = function (e) {
        return true;
    };
    ViewCursors.prototype.onLinesDeleted = function (e) {
        return true;
    };
    ViewCursors.prototype.onLinesInserted = function (e) {
        return true;
    };
    ViewCursors.prototype.onScrollChanged = function (e) {
        return true;
    };
    ViewCursors.prototype.onTokensChanged = function (e) {
        var shouldRender = function (position) {
            for (var i = 0, len = e.ranges.length; i < len; i++) {
                if (e.ranges[i].fromLineNumber <= position.lineNumber && position.lineNumber <= e.ranges[i].toLineNumber) {
                    return true;
                }
            }
            return false;
        };
        if (shouldRender(this._primaryCursor.getPosition())) {
            return true;
        }
        for (var i = 0; i < this._secondaryCursors.length; i++) {
            if (shouldRender(this._secondaryCursors[i].getPosition())) {
                return true;
            }
        }
        return false;
    };
    ViewCursors.prototype.onZonesChanged = function (e) {
        return true;
    };
    // --- end event handlers
    // ---- blinking logic
    ViewCursors.prototype._getCursorBlinking = function () {
        if (!this._editorHasFocus) {
            return __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Hidden;
        }
        if (this._readOnly) {
            return __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Solid;
        }
        return this._cursorBlinking;
    };
    ViewCursors.prototype._updateBlinking = function () {
        var _this = this;
        this._startCursorBlinkAnimation.cancel();
        this._cursorFlatBlinkInterval.cancel();
        var blinkingStyle = this._getCursorBlinking();
        // hidden and solid are special as they involve no animations
        var isHidden = (blinkingStyle === __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Hidden);
        var isSolid = (blinkingStyle === __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Solid);
        if (isHidden) {
            this._hide();
        }
        else {
            this._show();
        }
        this._blinkingEnabled = false;
        this._updateDomClassName();
        if (!isHidden && !isSolid) {
            if (blinkingStyle === __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Blink) {
                // flat blinking is handled by JavaScript to save battery life due to Chromium step timing issue https://bugs.chromium.org/p/chromium/issues/detail?id=361587
                this._cursorFlatBlinkInterval.cancelAndSet(function () {
                    if (_this._isVisible) {
                        _this._hide();
                    }
                    else {
                        _this._show();
                    }
                }, ViewCursors.BLINK_INTERVAL);
            }
            else {
                this._startCursorBlinkAnimation.setIfNotSet(function () {
                    _this._blinkingEnabled = true;
                    _this._updateDomClassName();
                }, ViewCursors.BLINK_INTERVAL);
            }
        }
    };
    // --- end blinking logic
    ViewCursors.prototype._updateDomClassName = function () {
        this._domNode.setClassName(this._getClassName());
    };
    ViewCursors.prototype._getClassName = function () {
        var result = 'cursors-layer';
        if (!this._selectionIsEmpty) {
            result += ' has-selection';
        }
        switch (this._cursorStyle) {
            case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].Line:
                result += ' cursor-line-style';
                break;
            case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].Block:
                result += ' cursor-block-style';
                break;
            case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].Underline:
                result += ' cursor-underline-style';
                break;
            case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].LineThin:
                result += ' cursor-line-thin-style';
                break;
            case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].BlockOutline:
                result += ' cursor-block-outline-style';
                break;
            case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].UnderlineThin:
                result += ' cursor-underline-thin-style';
                break;
            default:
                result += ' cursor-line-style';
        }
        if (this._blinkingEnabled) {
            switch (this._getCursorBlinking()) {
                case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Blink:
                    result += ' cursor-blink';
                    break;
                case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Smooth:
                    result += ' cursor-smooth';
                    break;
                case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Phase:
                    result += ' cursor-phase';
                    break;
                case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Expand:
                    result += ' cursor-expand';
                    break;
                case __WEBPACK_IMPORTED_MODULE_7__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */].Solid:
                    result += ' cursor-solid';
                    break;
                default:
                    result += ' cursor-solid';
            }
        }
        else {
            result += ' cursor-solid';
        }
        return result;
    };
    ViewCursors.prototype._show = function () {
        this._primaryCursor.show();
        for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
            this._secondaryCursors[i].show();
        }
        this._isVisible = true;
    };
    ViewCursors.prototype._hide = function () {
        this._primaryCursor.hide();
        for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
            this._secondaryCursors[i].hide();
        }
        this._isVisible = false;
    };
    // ---- IViewPart implementation
    ViewCursors.prototype.prepareRender = function (ctx) {
        this._primaryCursor.prepareRender(ctx);
        for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
            this._secondaryCursors[i].prepareRender(ctx);
        }
    };
    ViewCursors.prototype.render = function (ctx) {
        var renderData = [], renderDataLen = 0;
        var primaryRenderData = this._primaryCursor.render(ctx);
        if (primaryRenderData) {
            renderData[renderDataLen++] = primaryRenderData;
        }
        for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
            var secondaryRenderData = this._secondaryCursors[i].render(ctx);
            if (secondaryRenderData) {
                renderData[renderDataLen++] = secondaryRenderData;
            }
        }
        this._renderData = renderData;
    };
    ViewCursors.prototype.getLastRenderData = function () {
        return this._renderData;
    };
    ViewCursors.BLINK_INTERVAL = 500;
    return ViewCursors;
}(__WEBPACK_IMPORTED_MODULE_1__view_viewPart_js__["b" /* ViewPart */]));

Object(__WEBPACK_IMPORTED_MODULE_5__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var caret = theme.getColor(__WEBPACK_IMPORTED_MODULE_6__common_view_editorColorRegistry_js__["g" /* editorCursorForeground */]);
    if (caret) {
        var caretBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_6__common_view_editorColorRegistry_js__["f" /* editorCursorBackground */]);
        if (!caretBackground) {
            caretBackground = caret.opposite();
        }
        collector.addRule(".monaco-editor .cursor { background-color: " + caret + "; border-color: " + caret + "; color: " + caretBackground + "; }");
        if (theme.type === 'hc') {
            collector.addRule(".monaco-editor .cursors-layer.has-selection .cursor { border-left: 1px solid " + caretBackground + "; border-right: 1px solid " + caretBackground + "; }");
        }
    }
});


/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_configuration_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var ViewCursorRenderData = /** @class */ (function () {
    function ViewCursorRenderData(top, left, width, height, textContent, textContentClassName) {
        this.top = top;
        this.left = left;
        this.width = width;
        this.height = height;
        this.textContent = textContent;
        this.textContentClassName = textContentClassName;
    }
    return ViewCursorRenderData;
}());
var ViewCursor = /** @class */ (function () {
    function ViewCursor(context) {
        this._context = context;
        this._cursorStyle = this._context.configuration.editor.viewInfo.cursorStyle;
        this._lineHeight = this._context.configuration.editor.lineHeight;
        this._typicalHalfwidthCharacterWidth = this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        this._lineCursorWidth = Math.min(this._context.configuration.editor.viewInfo.cursorWidth, this._typicalHalfwidthCharacterWidth);
        this._isVisible = true;
        // Create the dom node
        this._domNode = Object(__WEBPACK_IMPORTED_MODULE_0__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        this._domNode.setClassName('cursor');
        this._domNode.setHeight(this._lineHeight);
        this._domNode.setTop(0);
        this._domNode.setLeft(0);
        __WEBPACK_IMPORTED_MODULE_4__config_configuration_js__["a" /* Configuration */].applyFontInfo(this._domNode, this._context.configuration.editor.fontInfo);
        this._domNode.setDisplay('none');
        this.updatePosition(new __WEBPACK_IMPORTED_MODULE_1__common_core_position_js__["a" /* Position */](1, 1));
        this._lastRenderedContent = '';
        this._renderData = null;
    }
    ViewCursor.prototype.getDomNode = function () {
        return this._domNode;
    };
    ViewCursor.prototype.getPosition = function () {
        return this._position;
    };
    ViewCursor.prototype.show = function () {
        if (!this._isVisible) {
            this._domNode.setVisibility('inherit');
            this._isVisible = true;
        }
    };
    ViewCursor.prototype.hide = function () {
        if (this._isVisible) {
            this._domNode.setVisibility('hidden');
            this._isVisible = false;
        }
    };
    ViewCursor.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
        }
        if (e.fontInfo) {
            __WEBPACK_IMPORTED_MODULE_4__config_configuration_js__["a" /* Configuration */].applyFontInfo(this._domNode, this._context.configuration.editor.fontInfo);
            this._typicalHalfwidthCharacterWidth = this._context.configuration.editor.fontInfo.typicalHalfwidthCharacterWidth;
        }
        if (e.viewInfo) {
            this._cursorStyle = this._context.configuration.editor.viewInfo.cursorStyle;
            this._lineCursorWidth = Math.min(this._context.configuration.editor.viewInfo.cursorWidth, this._typicalHalfwidthCharacterWidth);
        }
        return true;
    };
    ViewCursor.prototype.onCursorPositionChanged = function (position) {
        this.updatePosition(position);
        return true;
    };
    ViewCursor.prototype._prepareRender = function (ctx) {
        var textContent = '';
        var textContentClassName = '';
        if (this._cursorStyle === __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].Line || this._cursorStyle === __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].LineThin) {
            var visibleRange = ctx.visibleRangeForPosition(this._position);
            if (!visibleRange) {
                // Outside viewport
                return null;
            }
            var width_1;
            if (this._cursorStyle === __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].Line) {
                width_1 = __WEBPACK_IMPORTED_MODULE_5__base_browser_dom_js__["m" /* computeScreenAwareSize */](this._lineCursorWidth > 0 ? this._lineCursorWidth : 2);
                if (width_1 > 2) {
                    var lineContent = this._context.model.getLineContent(this._position.lineNumber);
                    textContent = lineContent.charAt(this._position.column - 1);
                }
            }
            else {
                width_1 = __WEBPACK_IMPORTED_MODULE_5__base_browser_dom_js__["m" /* computeScreenAwareSize */](1);
            }
            var top_1 = ctx.getVerticalOffsetForLineNumber(this._position.lineNumber) - ctx.bigNumbersDelta;
            return new ViewCursorRenderData(top_1, visibleRange.left, width_1, this._lineHeight, textContent, textContentClassName);
        }
        var visibleRangeForCharacter = ctx.linesVisibleRangesForRange(new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](this._position.lineNumber, this._position.column, this._position.lineNumber, this._position.column + 1), false);
        if (!visibleRangeForCharacter || visibleRangeForCharacter.length === 0 || visibleRangeForCharacter[0].ranges.length === 0) {
            // Outside viewport
            return null;
        }
        var range = visibleRangeForCharacter[0].ranges[0];
        var width = range.width < 1 ? this._typicalHalfwidthCharacterWidth : range.width;
        if (this._cursorStyle === __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].Block) {
            var lineData = this._context.model.getViewLineData(this._position.lineNumber);
            textContent = lineData.content.charAt(this._position.column - 1);
            if (__WEBPACK_IMPORTED_MODULE_6__base_common_strings_js__["isHighSurrogate"](lineData.content.charCodeAt(this._position.column - 1))) {
                textContent += lineData.content.charAt(this._position.column);
            }
            var tokenIndex = lineData.tokens.findTokenIndexAtOffset(this._position.column - 1);
            textContentClassName = lineData.tokens.getClassName(tokenIndex);
        }
        var top = ctx.getVerticalOffsetForLineNumber(this._position.lineNumber) - ctx.bigNumbersDelta;
        var height = this._lineHeight;
        // Underline might interfere with clicking
        if (this._cursorStyle === __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].Underline || this._cursorStyle === __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */].UnderlineThin) {
            top += this._lineHeight - 2;
            height = 2;
        }
        return new ViewCursorRenderData(top, range.left, width, height, textContent, textContentClassName);
    };
    ViewCursor.prototype.prepareRender = function (ctx) {
        this._renderData = this._prepareRender(ctx);
    };
    ViewCursor.prototype.render = function (ctx) {
        if (!this._renderData) {
            this._domNode.setDisplay('none');
            return null;
        }
        if (this._lastRenderedContent !== this._renderData.textContent) {
            this._lastRenderedContent = this._renderData.textContent;
            this._domNode.domNode.textContent = this._lastRenderedContent;
        }
        this._domNode.setClassName('cursor ' + this._renderData.textContentClassName);
        this._domNode.setDisplay('block');
        this._domNode.setTop(this._renderData.top);
        this._domNode.setLeft(this._renderData.left);
        this._domNode.setWidth(this._renderData.width);
        this._domNode.setLineHeight(this._renderData.height);
        this._domNode.setHeight(this._renderData.height);
        return {
            domNode: this._domNode.domNode,
            position: this._position,
            contentLeft: this._renderData.left,
            height: this._renderData.height,
            width: 2
        };
    };
    ViewCursor.prototype.updatePosition = function (newPosition) {
        this._position = newPosition;
    };
    return ViewCursor;
}());



/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewZones; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ViewZones = /** @class */ (function (_super) {
    __extends(ViewZones, _super);
    function ViewZones(context) {
        var _this = _super.call(this, context) || this;
        _this._lineHeight = _this._context.configuration.editor.lineHeight;
        _this._contentWidth = _this._context.configuration.editor.layoutInfo.contentWidth;
        _this._contentLeft = _this._context.configuration.editor.layoutInfo.contentLeft;
        _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.domNode.setClassName('view-zones');
        _this.domNode.setPosition('absolute');
        _this.domNode.setAttribute('role', 'presentation');
        _this.domNode.setAttribute('aria-hidden', 'true');
        _this.marginDomNode = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.marginDomNode.setClassName('margin-view-zones');
        _this.marginDomNode.setPosition('absolute');
        _this.marginDomNode.setAttribute('role', 'presentation');
        _this.marginDomNode.setAttribute('aria-hidden', 'true');
        _this._zones = {};
        return _this;
    }
    ViewZones.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._zones = {};
    };
    // ---- begin view event handlers
    ViewZones.prototype._recomputeWhitespacesProps = function () {
        var hadAChange = false;
        var keys = Object.keys(this._zones);
        for (var i = 0, len = keys.length; i < len; i++) {
            var id = keys[i];
            var zone = this._zones[id];
            var props = this._computeWhitespaceProps(zone.delegate);
            if (this._context.viewLayout.changeWhitespace(parseInt(id, 10), props.afterViewLineNumber, props.heightInPx)) {
                this._safeCallOnComputedHeight(zone.delegate, props.heightInPx);
                hadAChange = true;
            }
        }
        return hadAChange;
    };
    ViewZones.prototype.onConfigurationChanged = function (e) {
        if (e.lineHeight) {
            this._lineHeight = this._context.configuration.editor.lineHeight;
            return this._recomputeWhitespacesProps();
        }
        if (e.layoutInfo) {
            this._contentWidth = this._context.configuration.editor.layoutInfo.contentWidth;
            this._contentLeft = this._context.configuration.editor.layoutInfo.contentLeft;
        }
        return true;
    };
    ViewZones.prototype.onLineMappingChanged = function (e) {
        var hadAChange = this._recomputeWhitespacesProps();
        if (hadAChange) {
            this._context.viewLayout.onHeightMaybeChanged();
        }
        return hadAChange;
    };
    ViewZones.prototype.onLinesDeleted = function (e) {
        return true;
    };
    ViewZones.prototype.onScrollChanged = function (e) {
        return e.scrollTopChanged || e.scrollWidthChanged;
    };
    ViewZones.prototype.onZonesChanged = function (e) {
        return true;
    };
    ViewZones.prototype.onLinesInserted = function (e) {
        return true;
    };
    // ---- end view event handlers
    ViewZones.prototype._getZoneOrdinal = function (zone) {
        if (typeof zone.afterColumn !== 'undefined') {
            return zone.afterColumn;
        }
        return 10000;
    };
    ViewZones.prototype._computeWhitespaceProps = function (zone) {
        if (zone.afterLineNumber === 0) {
            return {
                afterViewLineNumber: 0,
                heightInPx: this._heightInPixels(zone),
                minWidthInPx: this._minWidthInPixels(zone)
            };
        }
        var zoneAfterModelPosition;
        if (typeof zone.afterColumn !== 'undefined') {
            zoneAfterModelPosition = this._context.model.validateModelPosition({
                lineNumber: zone.afterLineNumber,
                column: zone.afterColumn
            });
        }
        else {
            var validAfterLineNumber = this._context.model.validateModelPosition({
                lineNumber: zone.afterLineNumber,
                column: 1
            }).lineNumber;
            zoneAfterModelPosition = new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](validAfterLineNumber, this._context.model.getModelLineMaxColumn(validAfterLineNumber));
        }
        var zoneBeforeModelPosition;
        if (zoneAfterModelPosition.column === this._context.model.getModelLineMaxColumn(zoneAfterModelPosition.lineNumber)) {
            zoneBeforeModelPosition = this._context.model.validateModelPosition({
                lineNumber: zoneAfterModelPosition.lineNumber + 1,
                column: 1
            });
        }
        else {
            zoneBeforeModelPosition = this._context.model.validateModelPosition({
                lineNumber: zoneAfterModelPosition.lineNumber,
                column: zoneAfterModelPosition.column + 1
            });
        }
        var viewPosition = this._context.model.coordinatesConverter.convertModelPositionToViewPosition(zoneAfterModelPosition);
        var isVisible = this._context.model.coordinatesConverter.modelPositionIsVisible(zoneBeforeModelPosition);
        return {
            afterViewLineNumber: viewPosition.lineNumber,
            heightInPx: (isVisible ? this._heightInPixels(zone) : 0),
            minWidthInPx: this._minWidthInPixels(zone)
        };
    };
    ViewZones.prototype.addZone = function (zone) {
        var props = this._computeWhitespaceProps(zone);
        var whitespaceId = this._context.viewLayout.addWhitespace(props.afterViewLineNumber, this._getZoneOrdinal(zone), props.heightInPx, props.minWidthInPx);
        var myZone = {
            whitespaceId: whitespaceId,
            delegate: zone,
            isVisible: false,
            domNode: Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(zone.domNode),
            marginDomNode: zone.marginDomNode ? Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(zone.marginDomNode) : null
        };
        this._safeCallOnComputedHeight(myZone.delegate, props.heightInPx);
        myZone.domNode.setPosition('absolute');
        myZone.domNode.domNode.style.width = '100%';
        myZone.domNode.setDisplay('none');
        myZone.domNode.setAttribute('monaco-view-zone', myZone.whitespaceId.toString());
        this.domNode.appendChild(myZone.domNode);
        if (myZone.marginDomNode) {
            myZone.marginDomNode.setPosition('absolute');
            myZone.marginDomNode.domNode.style.width = '100%';
            myZone.marginDomNode.setDisplay('none');
            myZone.marginDomNode.setAttribute('monaco-view-zone', myZone.whitespaceId.toString());
            this.marginDomNode.appendChild(myZone.marginDomNode);
        }
        this._zones[myZone.whitespaceId.toString()] = myZone;
        this.setShouldRender();
        return myZone.whitespaceId;
    };
    ViewZones.prototype.removeZone = function (id) {
        if (this._zones.hasOwnProperty(id.toString())) {
            var zone = this._zones[id.toString()];
            delete this._zones[id.toString()];
            this._context.viewLayout.removeWhitespace(zone.whitespaceId);
            zone.domNode.removeAttribute('monaco-visible-view-zone');
            zone.domNode.removeAttribute('monaco-view-zone');
            zone.domNode.domNode.parentNode.removeChild(zone.domNode.domNode);
            if (zone.marginDomNode) {
                zone.marginDomNode.removeAttribute('monaco-visible-view-zone');
                zone.marginDomNode.removeAttribute('monaco-view-zone');
                zone.marginDomNode.domNode.parentNode.removeChild(zone.marginDomNode.domNode);
            }
            this.setShouldRender();
            return true;
        }
        return false;
    };
    ViewZones.prototype.layoutZone = function (id) {
        var changed = false;
        if (this._zones.hasOwnProperty(id.toString())) {
            var zone = this._zones[id.toString()];
            var props = this._computeWhitespaceProps(zone.delegate);
            // let newOrdinal = this._getZoneOrdinal(zone.delegate);
            changed = this._context.viewLayout.changeWhitespace(zone.whitespaceId, props.afterViewLineNumber, props.heightInPx) || changed;
            // TODO@Alex: change `newOrdinal` too
            if (changed) {
                this._safeCallOnComputedHeight(zone.delegate, props.heightInPx);
                this.setShouldRender();
            }
        }
        return changed;
    };
    ViewZones.prototype.shouldSuppressMouseDownOnViewZone = function (id) {
        if (this._zones.hasOwnProperty(id.toString())) {
            var zone = this._zones[id.toString()];
            return zone.delegate.suppressMouseDown;
        }
        return false;
    };
    ViewZones.prototype._heightInPixels = function (zone) {
        if (typeof zone.heightInPx === 'number') {
            return zone.heightInPx;
        }
        if (typeof zone.heightInLines === 'number') {
            return this._lineHeight * zone.heightInLines;
        }
        return this._lineHeight;
    };
    ViewZones.prototype._minWidthInPixels = function (zone) {
        if (typeof zone.minWidthInPx === 'number') {
            return zone.minWidthInPx;
        }
        return 0;
    };
    ViewZones.prototype._safeCallOnComputedHeight = function (zone, height) {
        if (typeof zone.onComputedHeight === 'function') {
            try {
                zone.onComputedHeight(height);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            }
        }
    };
    ViewZones.prototype._safeCallOnDomNodeTop = function (zone, top) {
        if (typeof zone.onDomNodeTop === 'function') {
            try {
                zone.onDomNodeTop(top);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(e);
            }
        }
    };
    ViewZones.prototype.prepareRender = function (ctx) {
        // Nothing to read
    };
    ViewZones.prototype.render = function (ctx) {
        var visibleWhitespaces = ctx.viewportData.whitespaceViewportData;
        var visibleZones = {};
        var hasVisibleZone = false;
        for (var i = 0, len = visibleWhitespaces.length; i < len; i++) {
            visibleZones[visibleWhitespaces[i].id.toString()] = visibleWhitespaces[i];
            hasVisibleZone = true;
        }
        var keys = Object.keys(this._zones);
        for (var i = 0, len = keys.length; i < len; i++) {
            var id = keys[i];
            var zone = this._zones[id];
            var newTop = 0;
            var newHeight = 0;
            var newDisplay = 'none';
            if (visibleZones.hasOwnProperty(id)) {
                newTop = visibleZones[id].verticalOffset - ctx.bigNumbersDelta;
                newHeight = visibleZones[id].height;
                newDisplay = 'block';
                // zone is visible
                if (!zone.isVisible) {
                    zone.domNode.setAttribute('monaco-visible-view-zone', 'true');
                    zone.isVisible = true;
                }
                this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(visibleZones[id].verticalOffset));
            }
            else {
                if (zone.isVisible) {
                    zone.domNode.removeAttribute('monaco-visible-view-zone');
                    zone.isVisible = false;
                }
                this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(-1000000));
            }
            zone.domNode.setTop(newTop);
            zone.domNode.setHeight(newHeight);
            zone.domNode.setDisplay(newDisplay);
            if (zone.marginDomNode) {
                zone.marginDomNode.setTop(newTop);
                zone.marginDomNode.setHeight(newHeight);
                zone.marginDomNode.setDisplay(newDisplay);
            }
        }
        if (hasVisibleZone) {
            this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
            this.marginDomNode.setWidth(this._contentLeft);
        }
    };
    return ViewZones;
}(__WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__["b" /* ViewPart */]));



/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewContext; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var ViewContext = /** @class */ (function () {
    function ViewContext(configuration, theme, model, privateViewEventBus) {
        this.configuration = configuration;
        this.theme = theme;
        this.model = model;
        this.viewLayout = model.viewLayout;
        this.privateViewEventBus = privateViewEventBus;
    }
    ViewContext.prototype.addEventHandler = function (eventHandler) {
        this.privateViewEventBus.addEventHandler(eventHandler);
    };
    ViewContext.prototype.removeEventHandler = function (eventHandler) {
        this.privateViewEventBus.removeEventHandler(eventHandler);
    };
    return ViewContext;
}());



/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewOutgoingEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controller_mouseTarget_js__ = __webpack_require__(271);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ViewOutgoingEvents = /** @class */ (function (_super) {
    __extends(ViewOutgoingEvents, _super);
    function ViewOutgoingEvents(viewModel) {
        var _this = _super.call(this) || this;
        _this.onDidScroll = null;
        _this.onDidGainFocus = null;
        _this.onDidLoseFocus = null;
        _this.onKeyDown = null;
        _this.onKeyUp = null;
        _this.onContextMenu = null;
        _this.onMouseMove = null;
        _this.onMouseLeave = null;
        _this.onMouseUp = null;
        _this.onMouseDown = null;
        _this.onMouseDrag = null;
        _this.onMouseDrop = null;
        _this._viewModel = viewModel;
        return _this;
    }
    ViewOutgoingEvents.prototype.emitScrollChanged = function (e) {
        if (this.onDidScroll) {
            this.onDidScroll(e);
        }
    };
    ViewOutgoingEvents.prototype.emitViewFocusGained = function () {
        if (this.onDidGainFocus) {
            this.onDidGainFocus(void 0);
        }
    };
    ViewOutgoingEvents.prototype.emitViewFocusLost = function () {
        if (this.onDidLoseFocus) {
            this.onDidLoseFocus(void 0);
        }
    };
    ViewOutgoingEvents.prototype.emitKeyDown = function (e) {
        if (this.onKeyDown) {
            this.onKeyDown(e);
        }
    };
    ViewOutgoingEvents.prototype.emitKeyUp = function (e) {
        if (this.onKeyUp) {
            this.onKeyUp(e);
        }
    };
    ViewOutgoingEvents.prototype.emitContextMenu = function (e) {
        if (this.onContextMenu) {
            this.onContextMenu(this._convertViewToModelMouseEvent(e));
        }
    };
    ViewOutgoingEvents.prototype.emitMouseMove = function (e) {
        if (this.onMouseMove) {
            this.onMouseMove(this._convertViewToModelMouseEvent(e));
        }
    };
    ViewOutgoingEvents.prototype.emitMouseLeave = function (e) {
        if (this.onMouseLeave) {
            this.onMouseLeave(this._convertViewToModelMouseEvent(e));
        }
    };
    ViewOutgoingEvents.prototype.emitMouseUp = function (e) {
        if (this.onMouseUp) {
            this.onMouseUp(this._convertViewToModelMouseEvent(e));
        }
    };
    ViewOutgoingEvents.prototype.emitMouseDown = function (e) {
        if (this.onMouseDown) {
            this.onMouseDown(this._convertViewToModelMouseEvent(e));
        }
    };
    ViewOutgoingEvents.prototype.emitMouseDrag = function (e) {
        if (this.onMouseDrag) {
            this.onMouseDrag(this._convertViewToModelMouseEvent(e));
        }
    };
    ViewOutgoingEvents.prototype.emitMouseDrop = function (e) {
        if (this.onMouseDrop) {
            this.onMouseDrop(this._convertViewToModelMouseEvent(e));
        }
    };
    ViewOutgoingEvents.prototype._convertViewToModelMouseEvent = function (e) {
        if (e.target) {
            return {
                event: e.event,
                target: this._convertViewToModelMouseTarget(e.target)
            };
        }
        return e;
    };
    ViewOutgoingEvents.prototype._convertViewToModelMouseTarget = function (target) {
        return new ExternalMouseTarget(target.element, target.type, target.mouseColumn, target.position ? this._convertViewToModelPosition(target.position) : null, target.range ? this._convertViewToModelRange(target.range) : null, target.detail);
    };
    ViewOutgoingEvents.prototype._convertViewToModelPosition = function (viewPosition) {
        return this._viewModel.coordinatesConverter.convertViewPositionToModelPosition(viewPosition);
    };
    ViewOutgoingEvents.prototype._convertViewToModelRange = function (viewRange) {
        return this._viewModel.coordinatesConverter.convertViewRangeToModelRange(viewRange);
    };
    return ViewOutgoingEvents;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */]));

var ExternalMouseTarget = /** @class */ (function () {
    function ExternalMouseTarget(element, type, mouseColumn, position, range, detail) {
        this.element = element;
        this.type = type;
        this.mouseColumn = mouseColumn;
        this.position = position;
        this.range = range;
        this.detail = detail;
    }
    ExternalMouseTarget.prototype.toString = function () {
        return __WEBPACK_IMPORTED_MODULE_1__controller_mouseTarget_js__["b" /* MouseTarget */].toString(this);
    };
    return ExternalMouseTarget;
}());


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewportData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


/**
 * Contains all data needed to render at a specific viewport.
 */
var ViewportData = /** @class */ (function () {
    function ViewportData(selections, partialData, whitespaceViewportData, model) {
        this.selections = selections;
        this.startLineNumber = partialData.startLineNumber | 0;
        this.endLineNumber = partialData.endLineNumber | 0;
        this.relativeVerticalOffset = partialData.relativeVerticalOffset;
        this.bigNumbersDelta = partialData.bigNumbersDelta | 0;
        this.whitespaceViewportData = whitespaceViewportData;
        this._model = model;
        this.visibleRange = new __WEBPACK_IMPORTED_MODULE_0__core_range_js__["a" /* Range */](partialData.startLineNumber, this._model.getLineMinColumn(partialData.startLineNumber), partialData.endLineNumber, this._model.getLineMaxColumn(partialData.endLineNumber));
    }
    ViewportData.prototype.getViewLineRenderingData = function (lineNumber) {
        return this._model.getViewLineRenderingData(this.visibleRange, lineNumber);
    };
    ViewportData.prototype.getDecorationsInViewport = function () {
        return this._model.getDecorationsInViewport(this.visibleRange);
    };
    return ViewportData;
}());



/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorScrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_ui_scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_theme_common_themeService_js__ = __webpack_require__(13);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EditorScrollbar = /** @class */ (function (_super) {
    __extends(EditorScrollbar, _super);
    function EditorScrollbar(context, linesContent, viewDomNode, overflowGuardDomNode) {
        var _this = _super.call(this, context) || this;
        var editor = _this._context.configuration.editor;
        var configScrollbarOpts = editor.viewInfo.scrollbar;
        var scrollbarOptions = {
            listenOnDomNode: viewDomNode.domNode,
            className: 'editor-scrollable' + ' ' + Object(__WEBPACK_IMPORTED_MODULE_4__platform_theme_common_themeService_js__["d" /* getThemeTypeSelector */])(context.theme.type),
            useShadows: false,
            lazyRender: true,
            vertical: configScrollbarOpts.vertical,
            horizontal: configScrollbarOpts.horizontal,
            verticalHasArrows: configScrollbarOpts.verticalHasArrows,
            horizontalHasArrows: configScrollbarOpts.horizontalHasArrows,
            verticalScrollbarSize: configScrollbarOpts.verticalScrollbarSize,
            verticalSliderSize: configScrollbarOpts.verticalSliderSize,
            horizontalScrollbarSize: configScrollbarOpts.horizontalScrollbarSize,
            horizontalSliderSize: configScrollbarOpts.horizontalSliderSize,
            handleMouseWheel: configScrollbarOpts.handleMouseWheel,
            arrowSize: configScrollbarOpts.arrowSize,
            mouseWheelScrollSensitivity: configScrollbarOpts.mouseWheelScrollSensitivity,
        };
        _this.scrollbar = _this._register(new __WEBPACK_IMPORTED_MODULE_1__base_browser_ui_scrollbar_scrollableElement_js__["c" /* SmoothScrollableElement */](linesContent.domNode, scrollbarOptions, _this._context.viewLayout.scrollable));
        __WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__["a" /* PartFingerprints */].write(_this.scrollbar.getDomNode(), 5 /* ScrollableElement */);
        _this.scrollbarDomNode = Object(__WEBPACK_IMPORTED_MODULE_3__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(_this.scrollbar.getDomNode());
        _this.scrollbarDomNode.setPosition('absolute');
        _this._setLayout();
        // When having a zone widget that calls .focus() on one of its dom elements,
        // the browser will try desperately to reveal that dom node, unexpectedly
        // changing the .scrollTop of this.linesContent
        var onBrowserDesperateReveal = function (domNode, lookAtScrollTop, lookAtScrollLeft) {
            var newScrollPosition = {};
            if (lookAtScrollTop) {
                var deltaTop = domNode.scrollTop;
                if (deltaTop) {
                    newScrollPosition.scrollTop = _this._context.viewLayout.getCurrentScrollTop() + deltaTop;
                    domNode.scrollTop = 0;
                }
            }
            if (lookAtScrollLeft) {
                var deltaLeft = domNode.scrollLeft;
                if (deltaLeft) {
                    newScrollPosition.scrollLeft = _this._context.viewLayout.getCurrentScrollLeft() + deltaLeft;
                    domNode.scrollLeft = 0;
                }
            }
            _this._context.viewLayout.setScrollPositionNow(newScrollPosition);
        };
        // I've seen this happen both on the view dom node & on the lines content dom node.
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](viewDomNode.domNode, 'scroll', function (e) { return onBrowserDesperateReveal(viewDomNode.domNode, true, true); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](linesContent.domNode, 'scroll', function (e) { return onBrowserDesperateReveal(linesContent.domNode, true, false); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](overflowGuardDomNode.domNode, 'scroll', function (e) { return onBrowserDesperateReveal(overflowGuardDomNode.domNode, true, false); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["g" /* addDisposableListener */](_this.scrollbarDomNode.domNode, 'scroll', function (e) { return onBrowserDesperateReveal(_this.scrollbarDomNode.domNode, true, false); }));
        return _this;
    }
    EditorScrollbar.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    EditorScrollbar.prototype._setLayout = function () {
        var layoutInfo = this._context.configuration.editor.layoutInfo;
        this.scrollbarDomNode.setLeft(layoutInfo.contentLeft);
        var side = this._context.configuration.editor.viewInfo.minimap.side;
        if (side === 'right') {
            this.scrollbarDomNode.setWidth(layoutInfo.contentWidth + layoutInfo.minimapWidth);
        }
        else {
            this.scrollbarDomNode.setWidth(layoutInfo.contentWidth);
        }
        this.scrollbarDomNode.setHeight(layoutInfo.contentHeight);
    };
    EditorScrollbar.prototype.getOverviewRulerLayoutInfo = function () {
        return this.scrollbar.getOverviewRulerLayoutInfo();
    };
    EditorScrollbar.prototype.getDomNode = function () {
        return this.scrollbarDomNode;
    };
    EditorScrollbar.prototype.delegateVerticalScrollbarMouseDown = function (browserEvent) {
        this.scrollbar.delegateVerticalScrollbarMouseDown(browserEvent);
    };
    // --- begin event handlers
    EditorScrollbar.prototype.onConfigurationChanged = function (e) {
        if (e.viewInfo) {
            var editor = this._context.configuration.editor;
            var newOpts = {
                handleMouseWheel: editor.viewInfo.scrollbar.handleMouseWheel,
                mouseWheelScrollSensitivity: editor.viewInfo.scrollbar.mouseWheelScrollSensitivity
            };
            this.scrollbar.updateOptions(newOpts);
        }
        if (e.layoutInfo) {
            this._setLayout();
        }
        return true;
    };
    EditorScrollbar.prototype.onScrollChanged = function (e) {
        return true;
    };
    EditorScrollbar.prototype.onThemeChanged = function (e) {
        this.scrollbar.updateClassName('editor-scrollable' + ' ' + Object(__WEBPACK_IMPORTED_MODULE_4__platform_theme_common_themeService_js__["d" /* getThemeTypeSelector */])(this._context.theme.type));
        return true;
    };
    // --- end event handlers
    EditorScrollbar.prototype.prepareRender = function (ctx) {
        // Nothing to do
    };
    EditorScrollbar.prototype.render = function (ctx) {
        this.scrollbar.renderNow();
    };
    return EditorScrollbar;
}(__WEBPACK_IMPORTED_MODULE_2__view_viewPart_js__["b" /* ViewPart */]));



/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HorizontalScrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstractScrollbar_js__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scrollbarState_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scrollbarArrow_js__ = __webpack_require__(155);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var HorizontalScrollbar = /** @class */ (function (_super) {
    __extends(HorizontalScrollbar, _super);
    function HorizontalScrollbar(scrollable, options, host) {
        var _this = _super.call(this, {
            lazyRender: options.lazyRender,
            host: host,
            scrollbarState: new __WEBPACK_IMPORTED_MODULE_3__scrollbarState_js__["a" /* ScrollbarState */]((options.horizontalHasArrows ? options.arrowSize : 0), (options.horizontal === __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden ? 0 : options.horizontalScrollbarSize), (options.vertical === __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden ? 0 : options.verticalScrollbarSize)),
            visibility: options.horizontal,
            extraScrollbarClassName: 'horizontal',
            scrollable: scrollable
        }) || this;
        if (options.horizontalHasArrows) {
            var arrowDelta = (options.arrowSize - __WEBPACK_IMPORTED_MODULE_4__scrollbarArrow_js__["a" /* ARROW_IMG_SIZE */]) / 2;
            var scrollbarDelta = (options.horizontalScrollbarSize - __WEBPACK_IMPORTED_MODULE_4__scrollbarArrow_js__["a" /* ARROW_IMG_SIZE */]) / 2;
            _this._createArrow({
                className: 'left-arrow',
                top: scrollbarDelta,
                left: arrowDelta,
                bottom: void 0,
                right: void 0,
                bgWidth: options.arrowSize,
                bgHeight: options.horizontalScrollbarSize,
                onActivate: function () { return _this._host.onMouseWheel(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["c" /* StandardMouseWheelEvent */](null, 1, 0)); },
            });
            _this._createArrow({
                className: 'right-arrow',
                top: scrollbarDelta,
                left: void 0,
                bottom: void 0,
                right: arrowDelta,
                bgWidth: options.arrowSize,
                bgHeight: options.horizontalScrollbarSize,
                onActivate: function () { return _this._host.onMouseWheel(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["c" /* StandardMouseWheelEvent */](null, -1, 0)); },
            });
        }
        _this._createSlider(Math.floor((options.horizontalScrollbarSize - options.horizontalSliderSize) / 2), 0, null, options.horizontalSliderSize);
        return _this;
    }
    HorizontalScrollbar.prototype._updateSlider = function (sliderSize, sliderPosition) {
        this.slider.setWidth(sliderSize);
        this.slider.setLeft(sliderPosition);
    };
    HorizontalScrollbar.prototype._renderDomNode = function (largeSize, smallSize) {
        this.domNode.setWidth(largeSize);
        this.domNode.setHeight(smallSize);
        this.domNode.setLeft(0);
        this.domNode.setBottom(0);
    };
    HorizontalScrollbar.prototype.onDidScroll = function (e) {
        this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender;
        this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender;
        this._shouldRender = this._onElementSize(e.width) || this._shouldRender;
        return this._shouldRender;
    };
    HorizontalScrollbar.prototype._mouseDownRelativePosition = function (offsetX, offsetY) {
        return offsetX;
    };
    HorizontalScrollbar.prototype._sliderMousePosition = function (e) {
        return e.posx;
    };
    HorizontalScrollbar.prototype._sliderOrthogonalMousePosition = function (e) {
        return e.posy;
    };
    HorizontalScrollbar.prototype.writeScrollPosition = function (target, scrollPosition) {
        target.scrollLeft = scrollPosition;
    };
    return HorizontalScrollbar;
}(__WEBPACK_IMPORTED_MODULE_0__abstractScrollbar_js__["a" /* AbstractScrollbar */]));



/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarVisibilityController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__ = __webpack_require__(42);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ScrollbarVisibilityController = /** @class */ (function (_super) {
    __extends(ScrollbarVisibilityController, _super);
    function ScrollbarVisibilityController(visibility, visibleClassName, invisibleClassName) {
        var _this = _super.call(this) || this;
        _this._visibility = visibility;
        _this._visibleClassName = visibleClassName;
        _this._invisibleClassName = invisibleClassName;
        _this._domNode = null;
        _this._isVisible = false;
        _this._isNeeded = false;
        _this._shouldBeVisible = false;
        _this._revealTimer = _this._register(new __WEBPACK_IMPORTED_MODULE_1__common_async_js__["f" /* TimeoutTimer */]());
        return _this;
    }
    // ----------------- Hide / Reveal
    ScrollbarVisibilityController.prototype.applyVisibilitySetting = function (shouldBeVisible) {
        if (this._visibility === __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden) {
            return false;
        }
        if (this._visibility === __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__["b" /* ScrollbarVisibility */].Visible) {
            return true;
        }
        return shouldBeVisible;
    };
    ScrollbarVisibilityController.prototype.setShouldBeVisible = function (rawShouldBeVisible) {
        var shouldBeVisible = this.applyVisibilitySetting(rawShouldBeVisible);
        if (this._shouldBeVisible !== shouldBeVisible) {
            this._shouldBeVisible = shouldBeVisible;
            this.ensureVisibility();
        }
    };
    ScrollbarVisibilityController.prototype.setIsNeeded = function (isNeeded) {
        if (this._isNeeded !== isNeeded) {
            this._isNeeded = isNeeded;
            this.ensureVisibility();
        }
    };
    ScrollbarVisibilityController.prototype.setDomNode = function (domNode) {
        this._domNode = domNode;
        this._domNode.setClassName(this._invisibleClassName);
        // Now that the flags & the dom node are in a consistent state, ensure the Hidden/Visible configuration
        this.setShouldBeVisible(false);
    };
    ScrollbarVisibilityController.prototype.ensureVisibility = function () {
        if (!this._isNeeded) {
            // Nothing to be rendered
            this._hide(false);
            return;
        }
        if (this._shouldBeVisible) {
            this._reveal();
        }
        else {
            this._hide(true);
        }
    };
    ScrollbarVisibilityController.prototype._reveal = function () {
        var _this = this;
        if (this._isVisible) {
            return;
        }
        this._isVisible = true;
        // The CSS animation doesn't play otherwise
        this._revealTimer.setIfNotSet(function () {
            _this._domNode.setClassName(_this._visibleClassName);
        }, 0);
    };
    ScrollbarVisibilityController.prototype._hide = function (withFadeAway) {
        this._revealTimer.cancel();
        if (!this._isVisible) {
            return;
        }
        this._isVisible = false;
        this._domNode.setClassName(this._invisibleClassName + (withFadeAway ? ' fade' : ''));
    };
    return ScrollbarVisibilityController;
}(__WEBPACK_IMPORTED_MODULE_0__common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerticalScrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstractScrollbar_js__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scrollbarState_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scrollbarArrow_js__ = __webpack_require__(155);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var VerticalScrollbar = /** @class */ (function (_super) {
    __extends(VerticalScrollbar, _super);
    function VerticalScrollbar(scrollable, options, host) {
        var _this = _super.call(this, {
            lazyRender: options.lazyRender,
            host: host,
            scrollbarState: new __WEBPACK_IMPORTED_MODULE_3__scrollbarState_js__["a" /* ScrollbarState */]((options.verticalHasArrows ? options.arrowSize : 0), (options.vertical === __WEBPACK_IMPORTED_MODULE_2__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden ? 0 : options.verticalScrollbarSize), 
            // give priority to vertical scroll bar over horizontal and let it scroll all the way to the bottom
            0),
            visibility: options.vertical,
            extraScrollbarClassName: 'vertical',
            scrollable: scrollable
        }) || this;
        if (options.verticalHasArrows) {
            var arrowDelta = (options.arrowSize - __WEBPACK_IMPORTED_MODULE_4__scrollbarArrow_js__["a" /* ARROW_IMG_SIZE */]) / 2;
            var scrollbarDelta = (options.verticalScrollbarSize - __WEBPACK_IMPORTED_MODULE_4__scrollbarArrow_js__["a" /* ARROW_IMG_SIZE */]) / 2;
            _this._createArrow({
                className: 'up-arrow',
                top: arrowDelta,
                left: scrollbarDelta,
                bottom: void 0,
                right: void 0,
                bgWidth: options.verticalScrollbarSize,
                bgHeight: options.arrowSize,
                onActivate: function () { return _this._host.onMouseWheel(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["c" /* StandardMouseWheelEvent */](null, 0, 1)); },
            });
            _this._createArrow({
                className: 'down-arrow',
                top: void 0,
                left: scrollbarDelta,
                bottom: arrowDelta,
                right: void 0,
                bgWidth: options.verticalScrollbarSize,
                bgHeight: options.arrowSize,
                onActivate: function () { return _this._host.onMouseWheel(new __WEBPACK_IMPORTED_MODULE_1__mouseEvent_js__["c" /* StandardMouseWheelEvent */](null, 0, -1)); },
            });
        }
        _this._createSlider(0, Math.floor((options.verticalScrollbarSize - options.verticalSliderSize) / 2), options.verticalSliderSize, null);
        return _this;
    }
    VerticalScrollbar.prototype._updateSlider = function (sliderSize, sliderPosition) {
        this.slider.setHeight(sliderSize);
        this.slider.setTop(sliderPosition);
    };
    VerticalScrollbar.prototype._renderDomNode = function (largeSize, smallSize) {
        this.domNode.setWidth(smallSize);
        this.domNode.setHeight(largeSize);
        this.domNode.setRight(0);
        this.domNode.setTop(0);
    };
    VerticalScrollbar.prototype.onDidScroll = function (e) {
        this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender;
        this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender;
        this._shouldRender = this._onElementSize(e.height) || this._shouldRender;
        return this._shouldRender;
    };
    VerticalScrollbar.prototype._mouseDownRelativePosition = function (offsetX, offsetY) {
        return offsetY;
    };
    VerticalScrollbar.prototype._sliderMousePosition = function (e) {
        return e.posy;
    };
    VerticalScrollbar.prototype._sliderOrthogonalMousePosition = function (e) {
        return e.posx;
    };
    VerticalScrollbar.prototype.writeScrollPosition = function (target, scrollPosition) {
        target.scrollTop = scrollPosition;
    };
    return VerticalScrollbar;
}(__WEBPACK_IMPORTED_MODULE_0__abstractScrollbar_js__["a" /* AbstractScrollbar */]));



/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Minimap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__minimap_css__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__minimap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__minimap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_viewPart_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_view_runtimeMinimapCharRenderer_js__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_view_minimapCharRenderer_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_viewLayer_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_view_viewEvents_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_browser_globalMouseMoveMonitor_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














function getMinimapLineHeight(renderMinimap) {
    if (renderMinimap === 2 /* Large */) {
        return 4 /* x2_CHAR_HEIGHT */;
    }
    if (renderMinimap === 4 /* LargeBlocks */) {
        return 4 /* x2_CHAR_HEIGHT */ + 2;
    }
    if (renderMinimap === 1 /* Small */) {
        return 2 /* x1_CHAR_HEIGHT */;
    }
    // RenderMinimap.SmallBlocks
    return 2 /* x1_CHAR_HEIGHT */ + 1;
}
function getMinimapCharWidth(renderMinimap) {
    if (renderMinimap === 2 /* Large */) {
        return 2 /* x2_CHAR_WIDTH */;
    }
    if (renderMinimap === 4 /* LargeBlocks */) {
        return 2 /* x2_CHAR_WIDTH */;
    }
    if (renderMinimap === 1 /* Small */) {
        return 1 /* x1_CHAR_WIDTH */;
    }
    // RenderMinimap.SmallBlocks
    return 1 /* x1_CHAR_WIDTH */;
}
/**
 * The orthogonal distance to the slider at which dragging "resets". This implements "snapping"
 */
var MOUSE_DRAG_RESET_DISTANCE = 140;
var MinimapOptions = /** @class */ (function () {
    function MinimapOptions(configuration) {
        var pixelRatio = configuration.editor.pixelRatio;
        var layoutInfo = configuration.editor.layoutInfo;
        var viewInfo = configuration.editor.viewInfo;
        var fontInfo = configuration.editor.fontInfo;
        this.renderMinimap = layoutInfo.renderMinimap | 0;
        this.scrollBeyondLastLine = viewInfo.scrollBeyondLastLine;
        this.showSlider = viewInfo.minimap.showSlider;
        this.pixelRatio = pixelRatio;
        this.typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
        this.lineHeight = configuration.editor.lineHeight;
        this.minimapLeft = layoutInfo.minimapLeft;
        this.minimapWidth = layoutInfo.minimapWidth;
        this.minimapHeight = layoutInfo.height;
        this.canvasInnerWidth = Math.max(1, Math.floor(pixelRatio * this.minimapWidth));
        this.canvasInnerHeight = Math.max(1, Math.floor(pixelRatio * this.minimapHeight));
        this.canvasOuterWidth = this.canvasInnerWidth / pixelRatio;
        this.canvasOuterHeight = this.canvasInnerHeight / pixelRatio;
    }
    MinimapOptions.prototype.equals = function (other) {
        return (this.renderMinimap === other.renderMinimap
            && this.scrollBeyondLastLine === other.scrollBeyondLastLine
            && this.showSlider === other.showSlider
            && this.pixelRatio === other.pixelRatio
            && this.typicalHalfwidthCharacterWidth === other.typicalHalfwidthCharacterWidth
            && this.lineHeight === other.lineHeight
            && this.minimapLeft === other.minimapLeft
            && this.minimapWidth === other.minimapWidth
            && this.minimapHeight === other.minimapHeight
            && this.canvasInnerWidth === other.canvasInnerWidth
            && this.canvasInnerHeight === other.canvasInnerHeight
            && this.canvasOuterWidth === other.canvasOuterWidth
            && this.canvasOuterHeight === other.canvasOuterHeight);
    };
    return MinimapOptions;
}());
var MinimapLayout = /** @class */ (function () {
    function MinimapLayout(scrollTop, scrollHeight, computedSliderRatio, sliderTop, sliderHeight, startLineNumber, endLineNumber) {
        this.scrollTop = scrollTop;
        this.scrollHeight = scrollHeight;
        this._computedSliderRatio = computedSliderRatio;
        this.sliderTop = sliderTop;
        this.sliderHeight = sliderHeight;
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
    }
    /**
     * Compute a desired `scrollPosition` such that the slider moves by `delta`.
     */
    MinimapLayout.prototype.getDesiredScrollTopFromDelta = function (delta) {
        var desiredSliderPosition = this.sliderTop + delta;
        return Math.round(desiredSliderPosition / this._computedSliderRatio);
    };
    MinimapLayout.create = function (options, viewportStartLineNumber, viewportEndLineNumber, viewportHeight, viewportContainsWhitespaceGaps, lineCount, scrollTop, scrollHeight, previousLayout) {
        var pixelRatio = options.pixelRatio;
        var minimapLineHeight = getMinimapLineHeight(options.renderMinimap);
        var minimapLinesFitting = Math.floor(options.canvasInnerHeight / minimapLineHeight);
        var lineHeight = options.lineHeight;
        // The visible line count in a viewport can change due to a number of reasons:
        //  a) with the same viewport width, different scroll positions can result in partial lines being visible:
        //    e.g. for a line height of 20, and a viewport height of 600
        //          * scrollTop = 0  => visible lines are [1, 30]
        //          * scrollTop = 10 => visible lines are [1, 31] (with lines 1 and 31 partially visible)
        //          * scrollTop = 20 => visible lines are [2, 31]
        //  b) whitespace gaps might make their way in the viewport (which results in a decrease in the visible line count)
        //  c) we could be in the scroll beyond last line case (which also results in a decrease in the visible line count, down to possibly only one line being visible)
        // We must first establish a desirable slider height.
        var sliderHeight;
        if (viewportContainsWhitespaceGaps && viewportEndLineNumber !== lineCount) {
            // case b) from above: there are whitespace gaps in the viewport.
            // In this case, the height of the slider directly reflects the visible line count.
            var viewportLineCount = viewportEndLineNumber - viewportStartLineNumber + 1;
            sliderHeight = Math.floor(viewportLineCount * minimapLineHeight / pixelRatio);
        }
        else {
            // The slider has a stable height
            var expectedViewportLineCount = viewportHeight / lineHeight;
            sliderHeight = Math.floor(expectedViewportLineCount * minimapLineHeight / pixelRatio);
        }
        var maxMinimapSliderTop;
        if (options.scrollBeyondLastLine) {
            // The minimap slider, when dragged all the way down, will contain the last line at its top
            maxMinimapSliderTop = (lineCount - 1) * minimapLineHeight / pixelRatio;
        }
        else {
            // The minimap slider, when dragged all the way down, will contain the last line at its bottom
            maxMinimapSliderTop = Math.max(0, lineCount * minimapLineHeight / pixelRatio - sliderHeight);
        }
        maxMinimapSliderTop = Math.min(options.minimapHeight - sliderHeight, maxMinimapSliderTop);
        // The slider can move from 0 to `maxMinimapSliderTop`
        // in the same way `scrollTop` can move from 0 to `scrollHeight` - `viewportHeight`.
        var computedSliderRatio = (maxMinimapSliderTop) / (scrollHeight - viewportHeight);
        var sliderTop = (scrollTop * computedSliderRatio);
        if (minimapLinesFitting >= lineCount) {
            // All lines fit in the minimap
            var startLineNumber = 1;
            var endLineNumber = lineCount;
            return new MinimapLayout(scrollTop, scrollHeight, computedSliderRatio, sliderTop, sliderHeight, startLineNumber, endLineNumber);
        }
        else {
            var startLineNumber = Math.max(1, Math.floor(viewportStartLineNumber - sliderTop * pixelRatio / minimapLineHeight));
            // Avoid flickering caused by a partial viewport start line
            // by being consistent w.r.t. the previous layout decision
            if (previousLayout && previousLayout.scrollHeight === scrollHeight) {
                if (previousLayout.scrollTop > scrollTop) {
                    // Scrolling up => never increase `startLineNumber`
                    startLineNumber = Math.min(startLineNumber, previousLayout.startLineNumber);
                }
                if (previousLayout.scrollTop < scrollTop) {
                    // Scrolling down => never decrease `startLineNumber`
                    startLineNumber = Math.max(startLineNumber, previousLayout.startLineNumber);
                }
            }
            var endLineNumber = Math.min(lineCount, startLineNumber + minimapLinesFitting - 1);
            return new MinimapLayout(scrollTop, scrollHeight, computedSliderRatio, sliderTop, sliderHeight, startLineNumber, endLineNumber);
        }
    };
    return MinimapLayout;
}());
var MinimapLine = /** @class */ (function () {
    function MinimapLine(dy) {
        this.dy = dy;
    }
    MinimapLine.prototype.onContentChanged = function () {
        this.dy = -1;
    };
    MinimapLine.prototype.onTokensChanged = function () {
        this.dy = -1;
    };
    MinimapLine.INVALID = new MinimapLine(-1);
    return MinimapLine;
}());
var RenderData = /** @class */ (function () {
    function RenderData(renderedLayout, imageData, lines) {
        this.renderedLayout = renderedLayout;
        this._imageData = imageData;
        this._renderedLines = new __WEBPACK_IMPORTED_MODULE_7__view_viewLayer_js__["a" /* RenderedLinesCollection */](function () { return MinimapLine.INVALID; });
        this._renderedLines._set(renderedLayout.startLineNumber, lines);
    }
    /**
     * Check if the current RenderData matches accurately the new desired layout and no painting is needed.
     */
    RenderData.prototype.linesEquals = function (layout) {
        if (this.renderedLayout.startLineNumber !== layout.startLineNumber) {
            return false;
        }
        if (this.renderedLayout.endLineNumber !== layout.endLineNumber) {
            return false;
        }
        var tmp = this._renderedLines._get();
        var lines = tmp.lines;
        for (var i = 0, len = lines.length; i < len; i++) {
            if (lines[i].dy === -1) {
                // This line is invalid
                return false;
            }
        }
        return true;
    };
    RenderData.prototype._get = function () {
        var tmp = this._renderedLines._get();
        return {
            imageData: this._imageData,
            rendLineNumberStart: tmp.rendLineNumberStart,
            lines: tmp.lines
        };
    };
    RenderData.prototype.onLinesChanged = function (e) {
        return this._renderedLines.onLinesChanged(e.fromLineNumber, e.toLineNumber);
    };
    RenderData.prototype.onLinesDeleted = function (e) {
        this._renderedLines.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
    };
    RenderData.prototype.onLinesInserted = function (e) {
        this._renderedLines.onLinesInserted(e.fromLineNumber, e.toLineNumber);
    };
    RenderData.prototype.onTokensChanged = function (e) {
        return this._renderedLines.onTokensChanged(e.ranges);
    };
    return RenderData;
}());
/**
 * Some sort of double buffering.
 *
 * Keeps two buffers around that will be rotated for painting.
 * Always gives a buffer that is filled with the background color.
 */
var MinimapBuffers = /** @class */ (function () {
    function MinimapBuffers(ctx, WIDTH, HEIGHT, background) {
        this._backgroundFillData = MinimapBuffers._createBackgroundFillData(WIDTH, HEIGHT, background);
        this._buffers = [
            ctx.createImageData(WIDTH, HEIGHT),
            ctx.createImageData(WIDTH, HEIGHT)
        ];
        this._lastUsedBuffer = 0;
    }
    MinimapBuffers.prototype.getBuffer = function () {
        // rotate buffers
        this._lastUsedBuffer = 1 - this._lastUsedBuffer;
        var result = this._buffers[this._lastUsedBuffer];
        // fill with background color
        result.data.set(this._backgroundFillData);
        return result;
    };
    MinimapBuffers._createBackgroundFillData = function (WIDTH, HEIGHT, background) {
        var backgroundR = background.r;
        var backgroundG = background.g;
        var backgroundB = background.b;
        var result = new Uint8ClampedArray(WIDTH * HEIGHT * 4);
        var offset = 0;
        for (var i = 0; i < HEIGHT; i++) {
            for (var j = 0; j < WIDTH; j++) {
                result[offset] = backgroundR;
                result[offset + 1] = backgroundG;
                result[offset + 2] = backgroundB;
                result[offset + 3] = 255;
                offset += 4;
            }
        }
        return result;
    };
    return MinimapBuffers;
}());
var Minimap = /** @class */ (function (_super) {
    __extends(Minimap, _super);
    function Minimap(context) {
        var _this = _super.call(this, context) || this;
        _this._options = new MinimapOptions(_this._context.configuration);
        _this._lastRenderData = null;
        _this._buffers = null;
        _this._domNode = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        __WEBPACK_IMPORTED_MODULE_1__view_viewPart_js__["a" /* PartFingerprints */].write(_this._domNode, 8 /* Minimap */);
        _this._domNode.setClassName(_this._getMinimapDomNodeClassName());
        _this._domNode.setPosition('absolute');
        _this._domNode.setAttribute('role', 'presentation');
        _this._domNode.setAttribute('aria-hidden', 'true');
        _this._shadow = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._shadow.setClassName('minimap-shadow-hidden');
        _this._domNode.appendChild(_this._shadow);
        _this._canvas = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('canvas'));
        _this._canvas.setPosition('absolute');
        _this._canvas.setLeft(0);
        _this._domNode.appendChild(_this._canvas);
        _this._slider = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._slider.setPosition('absolute');
        _this._slider.setClassName('minimap-slider');
        _this._slider.setLayerHinting(true);
        _this._domNode.appendChild(_this._slider);
        _this._sliderHorizontal = Object(__WEBPACK_IMPORTED_MODULE_6__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._sliderHorizontal.setPosition('absolute');
        _this._sliderHorizontal.setClassName('minimap-slider-horizontal');
        _this._slider.appendChild(_this._sliderHorizontal);
        _this._tokensColorTracker = __WEBPACK_IMPORTED_MODULE_5__common_view_minimapCharRenderer_js__["b" /* MinimapTokensColorTracker */].getInstance();
        _this._applyLayout();
        _this._mouseDownListener = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this._canvas.domNode, 'mousedown', function (e) {
            e.preventDefault();
            var renderMinimap = _this._options.renderMinimap;
            if (renderMinimap === 0 /* None */) {
                return;
            }
            if (!_this._lastRenderData) {
                return;
            }
            var minimapLineHeight = getMinimapLineHeight(renderMinimap);
            var internalOffsetY = _this._options.pixelRatio * e.browserEvent.offsetY;
            var lineIndex = Math.floor(internalOffsetY / minimapLineHeight);
            var lineNumber = lineIndex + _this._lastRenderData.renderedLayout.startLineNumber;
            lineNumber = Math.min(lineNumber, _this._context.model.getLineCount());
            _this._context.privateViewEventBus.emit(new __WEBPACK_IMPORTED_MODULE_9__common_view_viewEvents_js__["l" /* ViewRevealRangeRequestEvent */](new __WEBPACK_IMPORTED_MODULE_8__common_core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, 1), 1 /* Center */, false, 0 /* Smooth */));
        });
        _this._sliderMouseMoveMonitor = new __WEBPACK_IMPORTED_MODULE_10__base_browser_globalMouseMoveMonitor_js__["a" /* GlobalMouseMoveMonitor */]();
        _this._sliderMouseDownListener = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this._slider.domNode, 'mousedown', function (e) {
            e.preventDefault();
            if (e.leftButton && _this._lastRenderData) {
                var initialMousePosition_1 = e.posy;
                var initialMouseOrthogonalPosition_1 = e.posx;
                var initialSliderState_1 = _this._lastRenderData.renderedLayout;
                _this._slider.toggleClassName('active', true);
                _this._sliderMouseMoveMonitor.startMonitoring(__WEBPACK_IMPORTED_MODULE_10__base_browser_globalMouseMoveMonitor_js__["b" /* standardMouseMoveMerger */], function (mouseMoveData) {
                    var mouseOrthogonalDelta = Math.abs(mouseMoveData.posx - initialMouseOrthogonalPosition_1);
                    if (__WEBPACK_IMPORTED_MODULE_11__base_common_platform_js__["g" /* isWindows */] && mouseOrthogonalDelta > MOUSE_DRAG_RESET_DISTANCE) {
                        // The mouse has wondered away from the scrollbar => reset dragging
                        _this._context.viewLayout.setScrollPositionNow({
                            scrollTop: initialSliderState_1.scrollTop
                        });
                        return;
                    }
                    var mouseDelta = mouseMoveData.posy - initialMousePosition_1;
                    _this._context.viewLayout.setScrollPositionNow({
                        scrollTop: initialSliderState_1.getDesiredScrollTopFromDelta(mouseDelta)
                    });
                }, function () {
                    _this._slider.toggleClassName('active', false);
                });
            }
        });
        return _this;
    }
    Minimap.prototype.dispose = function () {
        this._mouseDownListener.dispose();
        this._sliderMouseMoveMonitor.dispose();
        this._sliderMouseDownListener.dispose();
        _super.prototype.dispose.call(this);
    };
    Minimap.prototype._getMinimapDomNodeClassName = function () {
        if (this._options.showSlider === 'always') {
            return 'minimap slider-always';
        }
        return 'minimap slider-mouseover';
    };
    Minimap.prototype.getDomNode = function () {
        return this._domNode;
    };
    Minimap.prototype._applyLayout = function () {
        this._domNode.setLeft(this._options.minimapLeft);
        this._domNode.setWidth(this._options.minimapWidth);
        this._domNode.setHeight(this._options.minimapHeight);
        this._shadow.setHeight(this._options.minimapHeight);
        this._canvas.setWidth(this._options.canvasOuterWidth);
        this._canvas.setHeight(this._options.canvasOuterHeight);
        this._canvas.domNode.width = this._options.canvasInnerWidth;
        this._canvas.domNode.height = this._options.canvasInnerHeight;
        this._slider.setWidth(this._options.minimapWidth);
    };
    Minimap.prototype._getBuffer = function () {
        if (!this._buffers) {
            this._buffers = new MinimapBuffers(this._canvas.domNode.getContext('2d'), this._options.canvasInnerWidth, this._options.canvasInnerHeight, this._tokensColorTracker.getColor(2 /* DefaultBackground */));
        }
        return this._buffers.getBuffer();
    };
    Minimap.prototype._onOptionsMaybeChanged = function () {
        var opts = new MinimapOptions(this._context.configuration);
        if (this._options.equals(opts)) {
            return false;
        }
        this._options = opts;
        this._lastRenderData = null;
        this._buffers = null;
        this._applyLayout();
        this._domNode.setClassName(this._getMinimapDomNodeClassName());
        return true;
    };
    // ---- begin view event handlers
    Minimap.prototype.onConfigurationChanged = function (e) {
        return this._onOptionsMaybeChanged();
    };
    Minimap.prototype.onFlushed = function (e) {
        this._lastRenderData = null;
        return true;
    };
    Minimap.prototype.onLinesChanged = function (e) {
        if (this._lastRenderData) {
            return this._lastRenderData.onLinesChanged(e);
        }
        return false;
    };
    Minimap.prototype.onLinesDeleted = function (e) {
        if (this._lastRenderData) {
            this._lastRenderData.onLinesDeleted(e);
        }
        return true;
    };
    Minimap.prototype.onLinesInserted = function (e) {
        if (this._lastRenderData) {
            this._lastRenderData.onLinesInserted(e);
        }
        return true;
    };
    Minimap.prototype.onScrollChanged = function (e) {
        return true;
    };
    Minimap.prototype.onTokensChanged = function (e) {
        if (this._lastRenderData) {
            return this._lastRenderData.onTokensChanged(e);
        }
        return false;
    };
    Minimap.prototype.onTokensColorsChanged = function (e) {
        this._lastRenderData = null;
        this._buffers = null;
        return true;
    };
    Minimap.prototype.onZonesChanged = function (e) {
        this._lastRenderData = null;
        return true;
    };
    // --- end event handlers
    Minimap.prototype.prepareRender = function (ctx) {
        // Nothing to read
    };
    Minimap.prototype.render = function (renderingCtx) {
        var renderMinimap = this._options.renderMinimap;
        if (renderMinimap === 0 /* None */) {
            this._shadow.setClassName('minimap-shadow-hidden');
            this._sliderHorizontal.setWidth(0);
            this._sliderHorizontal.setHeight(0);
            return;
        }
        if (renderingCtx.scrollLeft + renderingCtx.viewportWidth >= renderingCtx.scrollWidth) {
            this._shadow.setClassName('minimap-shadow-hidden');
        }
        else {
            this._shadow.setClassName('minimap-shadow-visible');
        }
        var layout = MinimapLayout.create(this._options, renderingCtx.visibleRange.startLineNumber, renderingCtx.visibleRange.endLineNumber, renderingCtx.viewportHeight, (renderingCtx.viewportData.whitespaceViewportData.length > 0), this._context.model.getLineCount(), renderingCtx.scrollTop, renderingCtx.scrollHeight, this._lastRenderData ? this._lastRenderData.renderedLayout : null);
        this._slider.setTop(layout.sliderTop);
        this._slider.setHeight(layout.sliderHeight);
        // Compute horizontal slider coordinates
        var scrollLeftChars = renderingCtx.scrollLeft / this._options.typicalHalfwidthCharacterWidth;
        var horizontalSliderLeft = Math.min(this._options.minimapWidth, Math.round(scrollLeftChars * getMinimapCharWidth(this._options.renderMinimap) / this._options.pixelRatio));
        this._sliderHorizontal.setLeft(horizontalSliderLeft);
        this._sliderHorizontal.setWidth(this._options.minimapWidth - horizontalSliderLeft);
        this._sliderHorizontal.setTop(0);
        this._sliderHorizontal.setHeight(layout.sliderHeight);
        this._lastRenderData = this.renderLines(layout);
    };
    Minimap.prototype.renderLines = function (layout) {
        var renderMinimap = this._options.renderMinimap;
        var startLineNumber = layout.startLineNumber;
        var endLineNumber = layout.endLineNumber;
        var minimapLineHeight = getMinimapLineHeight(renderMinimap);
        // Check if nothing changed w.r.t. lines from last frame
        if (this._lastRenderData && this._lastRenderData.linesEquals(layout)) {
            var _lastData = this._lastRenderData._get();
            // Nice!! Nothing changed from last frame
            return new RenderData(layout, _lastData.imageData, _lastData.lines);
        }
        // Oh well!! We need to repaint some lines...
        var imageData = this._getBuffer();
        // Render untouched lines by using last rendered data.
        var _a = Minimap._renderUntouchedLines(imageData, startLineNumber, endLineNumber, minimapLineHeight, this._lastRenderData), _dirtyY1 = _a[0], _dirtyY2 = _a[1], needed = _a[2];
        // Fetch rendering info from view model for rest of lines that need rendering.
        var lineInfo = this._context.model.getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed);
        var tabSize = lineInfo.tabSize;
        var background = this._tokensColorTracker.getColor(2 /* DefaultBackground */);
        var useLighterFont = this._tokensColorTracker.backgroundIsLight();
        // Render the rest of lines
        var dy = 0;
        var renderedLines = [];
        for (var lineIndex = 0, lineCount = endLineNumber - startLineNumber + 1; lineIndex < lineCount; lineIndex++) {
            if (needed[lineIndex]) {
                Minimap._renderLine(imageData, background, useLighterFont, renderMinimap, this._tokensColorTracker, Object(__WEBPACK_IMPORTED_MODULE_3__common_view_runtimeMinimapCharRenderer_js__["a" /* getOrCreateMinimapCharRenderer */])(), dy, tabSize, lineInfo.data[lineIndex]);
            }
            renderedLines[lineIndex] = new MinimapLine(dy);
            dy += minimapLineHeight;
        }
        var dirtyY1 = (_dirtyY1 === -1 ? 0 : _dirtyY1);
        var dirtyY2 = (_dirtyY2 === -1 ? imageData.height : _dirtyY2);
        var dirtyHeight = dirtyY2 - dirtyY1;
        // Finally, paint to the canvas
        var ctx = this._canvas.domNode.getContext('2d');
        ctx.putImageData(imageData, 0, 0, 0, dirtyY1, imageData.width, dirtyHeight);
        // Save rendered data for reuse on next frame if possible
        return new RenderData(layout, imageData, renderedLines);
    };
    Minimap._renderUntouchedLines = function (target, startLineNumber, endLineNumber, minimapLineHeight, lastRenderData) {
        var needed = [];
        if (!lastRenderData) {
            for (var i = 0, len = endLineNumber - startLineNumber + 1; i < len; i++) {
                needed[i] = true;
            }
            return [-1, -1, needed];
        }
        var _lastData = lastRenderData._get();
        var lastTargetData = _lastData.imageData.data;
        var lastStartLineNumber = _lastData.rendLineNumberStart;
        var lastLines = _lastData.lines;
        var lastLinesLength = lastLines.length;
        var WIDTH = target.width;
        var targetData = target.data;
        var maxDestPixel = (endLineNumber - startLineNumber + 1) * minimapLineHeight * WIDTH * 4;
        var dirtyPixel1 = -1; // the pixel offset up to which all the data is equal to the prev frame
        var dirtyPixel2 = -1; // the pixel offset after which all the data is equal to the prev frame
        var copySourceStart = -1;
        var copySourceEnd = -1;
        var copyDestStart = -1;
        var copyDestEnd = -1;
        var dest_dy = 0;
        for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
            var lineIndex = lineNumber - startLineNumber;
            var lastLineIndex = lineNumber - lastStartLineNumber;
            var source_dy = (lastLineIndex >= 0 && lastLineIndex < lastLinesLength ? lastLines[lastLineIndex].dy : -1);
            if (source_dy === -1) {
                needed[lineIndex] = true;
                dest_dy += minimapLineHeight;
                continue;
            }
            var sourceStart = source_dy * WIDTH * 4;
            var sourceEnd = (source_dy + minimapLineHeight) * WIDTH * 4;
            var destStart = dest_dy * WIDTH * 4;
            var destEnd = (dest_dy + minimapLineHeight) * WIDTH * 4;
            if (copySourceEnd === sourceStart && copyDestEnd === destStart) {
                // contiguous zone => extend copy request
                copySourceEnd = sourceEnd;
                copyDestEnd = destEnd;
            }
            else {
                if (copySourceStart !== -1) {
                    // flush existing copy request
                    targetData.set(lastTargetData.subarray(copySourceStart, copySourceEnd), copyDestStart);
                    if (dirtyPixel1 === -1 && copySourceStart === 0 && copySourceStart === copyDestStart) {
                        dirtyPixel1 = copySourceEnd;
                    }
                    if (dirtyPixel2 === -1 && copySourceEnd === maxDestPixel && copySourceStart === copyDestStart) {
                        dirtyPixel2 = copySourceStart;
                    }
                }
                copySourceStart = sourceStart;
                copySourceEnd = sourceEnd;
                copyDestStart = destStart;
                copyDestEnd = destEnd;
            }
            needed[lineIndex] = false;
            dest_dy += minimapLineHeight;
        }
        if (copySourceStart !== -1) {
            // flush existing copy request
            targetData.set(lastTargetData.subarray(copySourceStart, copySourceEnd), copyDestStart);
            if (dirtyPixel1 === -1 && copySourceStart === 0 && copySourceStart === copyDestStart) {
                dirtyPixel1 = copySourceEnd;
            }
            if (dirtyPixel2 === -1 && copySourceEnd === maxDestPixel && copySourceStart === copyDestStart) {
                dirtyPixel2 = copySourceStart;
            }
        }
        var dirtyY1 = (dirtyPixel1 === -1 ? -1 : dirtyPixel1 / (WIDTH * 4));
        var dirtyY2 = (dirtyPixel2 === -1 ? -1 : dirtyPixel2 / (WIDTH * 4));
        return [dirtyY1, dirtyY2, needed];
    };
    Minimap._renderLine = function (target, backgroundColor, useLighterFont, renderMinimap, colorTracker, minimapCharRenderer, dy, tabSize, lineData) {
        var content = lineData.content;
        var tokens = lineData.tokens;
        var charWidth = getMinimapCharWidth(renderMinimap);
        var maxDx = target.width - charWidth;
        var dx = 0;
        var charIndex = 0;
        var tabsCharDelta = 0;
        for (var tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++) {
            var tokenEndIndex = tokens.getEndOffset(tokenIndex);
            var tokenColorId = tokens.getForeground(tokenIndex);
            var tokenColor = colorTracker.getColor(tokenColorId);
            for (; charIndex < tokenEndIndex; charIndex++) {
                if (dx > maxDx) {
                    // hit edge of minimap
                    return;
                }
                var charCode = content.charCodeAt(charIndex);
                if (charCode === 9 /* Tab */) {
                    var insertSpacesCount = tabSize - (charIndex + tabsCharDelta) % tabSize;
                    tabsCharDelta += insertSpacesCount - 1;
                    // No need to render anything since tab is invisible
                    dx += insertSpacesCount * charWidth;
                }
                else if (charCode === 32 /* Space */) {
                    // No need to render anything since space is invisible
                    dx += charWidth;
                }
                else {
                    // Render twice for a full width character
                    var count = __WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["isFullWidthCharacter"](charCode) ? 2 : 1;
                    for (var i = 0; i < count; i++) {
                        if (renderMinimap === 2 /* Large */) {
                            minimapCharRenderer.x2RenderChar(target, dx, dy, charCode, tokenColor, backgroundColor, useLighterFont);
                        }
                        else if (renderMinimap === 1 /* Small */) {
                            minimapCharRenderer.x1RenderChar(target, dx, dy, charCode, tokenColor, backgroundColor, useLighterFont);
                        }
                        else if (renderMinimap === 4 /* LargeBlocks */) {
                            minimapCharRenderer.x2BlockRenderChar(target, dx, dy, tokenColor, backgroundColor, useLighterFont);
                        }
                        else {
                            // RenderMinimap.SmallBlocks
                            minimapCharRenderer.x1BlockRenderChar(target, dx, dy, tokenColor, backgroundColor, useLighterFont);
                        }
                        dx += charWidth;
                        if (dx > maxDx) {
                            // hit edge of minimap
                            return;
                        }
                    }
                }
            }
        }
    };
    return Minimap;
}(__WEBPACK_IMPORTED_MODULE_1__view_viewPart_js__["b" /* ViewPart */]));

Object(__WEBPACK_IMPORTED_MODULE_12__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var sliderBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["_13" /* scrollbarSliderBackground */]);
    if (sliderBackground) {
        var halfSliderBackground = sliderBackground.transparent(0.5);
        collector.addRule(".monaco-editor .minimap-slider, .monaco-editor .minimap-slider .minimap-slider-horizontal { background: " + halfSliderBackground + "; }");
    }
    var sliderHoverBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["_14" /* scrollbarSliderHoverBackground */]);
    if (sliderHoverBackground) {
        var halfSliderHoverBackground = sliderHoverBackground.transparent(0.5);
        collector.addRule(".monaco-editor .minimap-slider:hover, .monaco-editor .minimap-slider:hover .minimap-slider-horizontal { background: " + halfSliderHoverBackground + "; }");
    }
    var sliderActiveBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["_12" /* scrollbarSliderActiveBackground */]);
    if (sliderActiveBackground) {
        var halfSliderActiveBackground = sliderActiveBackground.transparent(0.5);
        collector.addRule(".monaco-editor .minimap-slider.active, .monaco-editor .minimap-slider.active .minimap-slider-horizontal { background: " + halfSliderActiveBackground + "; }");
    }
    var shadow = theme.getColor(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_colorRegistry_js__["_11" /* scrollbarShadow */]);
    if (shadow) {
        collector.addRule(".monaco-editor .minimap-shadow-visible { box-shadow: " + shadow + " -6px 0 6px -6px inset; }");
    }
});


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOrCreateMinimapCharRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__minimapCharRenderer_js__ = __webpack_require__(149);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


function toUint8ClampedArrat(arr) {
    var r = new Uint8ClampedArray(arr.length);
    for (var i = 0, len = arr.length; i < len; i++) {
        r[i] = arr[i];
    }
    return r;
}
var minimapCharRenderer = null;
function getOrCreateMinimapCharRenderer() {
    if (!minimapCharRenderer) {
        var _x1Data = toUint8ClampedArrat(x1Data);
        x1Data = null;
        var _x2Data = toUint8ClampedArrat(x2Data);
        x2Data = null;
        minimapCharRenderer = new __WEBPACK_IMPORTED_MODULE_0__minimapCharRenderer_js__["a" /* MinimapCharRenderer */](_x2Data, _x1Data);
    }
    return minimapCharRenderer;
}
var x2Data = [
    //
    0, 0,
    0, 0,
    0, 0,
    0, 0,
    // !
    39, 14,
    39, 14,
    14, 5,
    29, 10,
    // "
    96, 96,
    29, 29,
    0, 0,
    0, 0,
    // #
    49, 113,
    195, 214,
    227, 166,
    135, 42,
    // $
    40, 29,
    194, 38,
    75, 148,
    197, 187,
    // %
    145, 0,
    160, 61,
    75, 143,
    2, 183,
    // &
    138, 58,
    163, 6,
    177, 223,
    197, 227,
    // '
    38, 13,
    11, 4,
    0, 0,
    0, 0,
    // (
    10, 54,
    52, 8,
    62, 4,
    71, 122,
    // )
    73, 2,
    19, 40,
    10, 50,
    155, 36,
    // *
    79, 70,
    145, 121,
    7, 5,
    0, 0,
    // +
    2, 1,
    36, 12,
    204, 166,
    16, 5,
    // ,
    0, 0,
    0, 0,
    1, 0,
    154, 34,
    // -
    0, 0,
    0, 0,
    96, 83,
    0, 0,
    // .
    0, 0,
    0, 0,
    0, 0,
    46, 34,
    // /
    0, 82,
    2, 56,
    53, 3,
    146, 0,
    // 0
    146, 119,
    152, 132,
    152, 131,
    145, 119,
    // 1
    170, 42,
    15, 42,
    15, 42,
    172, 194,
    // 2
    131, 132,
    0, 139,
    80, 28,
    227, 143,
    // 3
    159, 135,
    15, 118,
    11, 126,
    171, 144,
    // 4
    20, 124,
    88, 106,
    217, 196,
    0, 106,
    // 5
    189, 92,
    168, 43,
    5, 130,
    164, 133,
    // 6
    130, 115,
    183, 65,
    134, 120,
    141, 141,
    // 7
    170, 196,
    2, 106,
    31, 32,
    105, 2,
    // 8
    145, 130,
    116, 114,
    132, 135,
    138, 140,
    // 9
    138, 113,
    147, 137,
    81, 183,
    129, 94,
    // :
    0, 0,
    21, 16,
    4, 3,
    46, 34,
    // ;
    0, 0,
    45, 34,
    1, 0,
    160, 49,
    // <
    0, 0,
    43, 143,
    203, 23,
    1, 76,
    // =
    0, 0,
    38, 28,
    131, 96,
    38, 28,
    // >
    0, 0,
    168, 31,
    29, 191,
    98, 0,
    // ?
    118, 139,
    5, 113,
    45, 13,
    37, 6,
    // @
    97, 115,
    161, 179,
    204, 105,
    223, 224,
    // A
    83, 52,
    111, 100,
    184, 186,
    120, 132,
    // B
    212, 145,
    180, 139,
    174, 161,
    212, 182,
    // C
    104, 162,
    131, 0,
    131, 0,
    104, 161,
    // D
    219, 120,
    110, 116,
    110, 116,
    219, 120,
    // E
    207, 154,
    163, 40,
    147, 22,
    207, 154,
    // F
    202, 159,
    161, 47,
    145, 23,
    111, 0,
    // G
    139, 154,
    144, 30,
    144, 135,
    139, 187,
    // H
    110, 110,
    168, 161,
    150, 145,
    110, 110,
    // I
    185, 162,
    43, 16,
    43, 16,
    185, 162,
    // J
    73, 129,
    0, 110,
    0, 110,
    191, 87,
    // K
    149, 149,
    236, 48,
    195, 91,
    146, 149,
    // L
    146, 0,
    146, 0,
    146, 0,
    187, 173,
    // M
    200, 201,
    222, 215,
    172, 147,
    95, 95,
    // N
    193, 97,
    224, 129,
    159, 206,
    97, 192,
    // O
    155, 139,
    153, 115,
    153, 115,
    156, 140,
    // P
    189, 158,
    123, 136,
    190, 64,
    111, 0,
    // Q
    155, 139,
    153, 115,
    153, 114,
    156, 241,
    // R
    197, 148,
    150, 152,
    170, 116,
    110, 157,
    // S
    156, 128,
    169, 14,
    13, 159,
    158, 149,
    // T
    212, 189,
    43, 16,
    43, 16,
    43, 16,
    // U
    148, 110,
    148, 110,
    147, 109,
    182, 151,
    // V
    133, 121,
    106, 118,
    114, 103,
    89, 66,
    // W
    94, 94,
    211, 188,
    205, 207,
    139, 168,
    // X
    151, 152,
    87, 76,
    101, 79,
    151, 152,
    // Y
    130, 156,
    125, 116,
    47, 29,
    43, 16,
    // Z
    169, 228,
    11, 103,
    120, 6,
    230, 176,
    // [
    55, 49,
    55, 6,
    55, 6,
    193, 102,
    // \
    92, 0,
    71, 0,
    13, 30,
    0, 147,
    // ]
    63, 43,
    12, 43,
    12, 43,
    142, 152,
    // ^
    71, 53,
    61, 61,
    0, 0,
    0, 0,
    // _
    0, 0,
    0, 0,
    0, 0,
    158, 146,
    // `
    25, 2,
    0, 0,
    0, 0,
    0, 0,
    // a
    0, 0,
    107, 130,
    170, 194,
    176, 188,
    // b
    109, 0,
    203, 159,
    113, 111,
    202, 158,
    // c
    0, 0,
    135, 135,
    114, 0,
    136, 135,
    // d
    0, 109,
    187, 190,
    148, 126,
    177, 187,
    // e
    0, 0,
    149, 130,
    218, 105,
    169, 135,
    // f
    37, 113,
    146, 113,
    49, 13,
    49, 13,
    // g
    0, 0,
    178, 195,
    147, 114,
    255, 255,
    // h
    109, 0,
    193, 149,
    110, 109,
    109, 109,
    // i
    12, 15,
    125, 41,
    33, 41,
    144, 188,
    // j
    1, 6,
    75, 53,
    10, 53,
    210, 161,
    // k
    110, 0,
    152, 148,
    210, 60,
    110, 156,
    // l
    213, 5,
    63, 5,
    63, 5,
    45, 111,
    // m
    0, 0,
    232, 172,
    190, 168,
    190, 169,
    // n
    0, 0,
    190, 144,
    109, 109,
    109, 109,
    // o
    0, 0,
    168, 140,
    148, 111,
    168, 140,
    // p
    0, 0,
    200, 151,
    113, 110,
    255, 158,
    // q
    0, 0,
    184, 188,
    147, 139,
    186, 255,
    // r
    0, 0,
    122, 130,
    111, 0,
    109, 0,
    // s
    0, 0,
    132, 69,
    109, 93,
    110, 136,
    // t
    51, 5,
    205, 103,
    61, 6,
    47, 106,
    // u
    0, 0,
    110, 109,
    110, 122,
    155, 179,
    // v
    0, 0,
    132, 120,
    113, 114,
    84, 63,
    // w
    0, 0,
    124, 108,
    202, 189,
    160, 174,
    // x
    0, 0,
    144, 142,
    79, 57,
    159, 146,
    // y
    0, 0,
    138, 138,
    119, 117,
    255, 69,
    // z
    0, 0,
    97, 198,
    47, 38,
    208, 84,
    // {
    23, 112,
    41, 14,
    157, 7,
    121, 192,
    // |
    35, 11,
    35, 11,
    35, 11,
    160, 61,
    // }
    129, 9,
    40, 19,
    20, 139,
    236, 44,
    // ~
    0, 0,
    15, 3,
    97, 93,
    0, 0,
];
var x1Data = [
    //
    0,
    0,
    // !
    23,
    12,
    // "
    53,
    0,
    // #
    130,
    127,
    // $
    58,
    149,
    // %
    67,
    77,
    // &
    72,
    198,
    // '
    13,
    0,
    // (
    25,
    51,
    // )
    25,
    49,
    // *
    94,
    2,
    // +
    8,
    64,
    // ,
    0,
    24,
    // -
    0,
    21,
    // .
    0,
    9,
    // /
    19,
    27,
    // 0
    126,
    126,
    // 1
    51,
    80,
    // 2
    72,
    105,
    // 3
    87,
    98,
    // 4
    73,
    93,
    // 5
    106,
    85,
    // 6
    111,
    123,
    // 7
    87,
    30,
    // 8
    116,
    126,
    // 9
    123,
    110,
    // :
    4,
    16,
    // ;
    9,
    28,
    // <
    21,
    53,
    // =
    8,
    62,
    // >
    23,
    52,
    // ?
    73,
    21,
    // @
    132,
    183,
    // A
    78,
    142,
    // B
    168,
    175,
    // C
    70,
    70,
    // D
    128,
    128,
    // E
    123,
    110,
    // F
    125,
    43,
    // G
    100,
    139,
    // H
    125,
    119,
    // I
    78,
    78,
    // J
    54,
    77,
    // K
    139,
    139,
    // L
    33,
    87,
    // M
    201,
    117,
    // N
    162,
    149,
    // O
    130,
    130,
    // P
    138,
    60,
    // Q
    130,
    172,
    // R
    149,
    127,
    // S
    95,
    98,
    // T
    95,
    25,
    // U
    118,
    135,
    // V
    110,
    85,
    // W
    147,
    175,
    // X
    105,
    110,
    // Y
    121,
    30,
    // Z
    101,
    113,
    // [
    34,
    68,
    // \
    20,
    26,
    // ]
    34,
    68,
    // ^
    56,
    0,
    // _
    0,
    44,
    // `
    3,
    0,
    // a
    27,
    175,
    // b
    80,
    133,
    // c
    31,
    66,
    // d
    85,
    147,
    // e
    32,
    150,
    // f
    90,
    25,
    // g
    45,
    230,
    // h
    77,
    101,
    // i
    36,
    83,
    // j
    22,
    84,
    // k
    71,
    118,
    // l
    44,
    44,
    // m
    52,
    172,
    // n
    38,
    101,
    // o
    35,
    130,
    // p
    40,
    197,
    // q
    43,
    197,
    // r
    29,
    26,
    // s
    23,
    103,
    // t
    67,
    44,
    // u
    25,
    129,
    // v
    29,
    85,
    // w
    27,
    177,
    // x
    33,
    97,
    // y
    32,
    145,
    // z
    33,
    77,
    // {
    38,
    96,
    // |
    20,
    55,
    // }
    36,
    95,
    // ~
    2,
    22,
];


/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IEnvironmentService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var IEnvironmentService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('environmentService');


/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LockData */
/* unused harmony export Lock */
/* unused harmony export ItemRegistry */
/* unused harmony export Item */
/* unused harmony export TreeNavigator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assert_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var LockData = /** @class */ (function () {
    function LockData(item) {
        this._onDispose = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDispose = this._onDispose.event;
        this._item = item;
    }
    Object.defineProperty(LockData.prototype, "item", {
        get: function () {
            return this._item;
        },
        enumerable: true,
        configurable: true
    });
    LockData.prototype.dispose = function () {
        if (this._onDispose) {
            this._onDispose.fire();
            this._onDispose.dispose();
            this._onDispose = null;
        }
    };
    return LockData;
}());

var Lock = /** @class */ (function () {
    function Lock() {
        this.locks = Object.create({});
    }
    Lock.prototype.isLocked = function (item) {
        return !!this.locks[item.id];
    };
    Lock.prototype.run = function (item, fn) {
        var _this = this;
        var lock = this.getLock(item);
        if (lock) {
            var unbindListener;
            return new __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */](function (c, e) {
                unbindListener = Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["k" /* once */])(lock.onDispose)(function () {
                    return _this.run(item, fn).then(c, e);
                });
            }, function () { unbindListener.dispose(); });
        }
        var result;
        return new __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */](function (c, e) {
            if (item.isDisposed()) {
                return e(new Error('Item is disposed.'));
            }
            var lock = _this.locks[item.id] = new LockData(item);
            result = fn().then(function (r) {
                delete _this.locks[item.id];
                lock.dispose();
                return r;
            }).then(c, e);
            return result;
        }, function () { return result.cancel(); });
    };
    Lock.prototype.getLock = function (item) {
        var key;
        for (key in this.locks) {
            var lock = this.locks[key];
            if (item.intersects(lock.item)) {
                return lock;
            }
        }
        return null;
    };
    return Lock;
}());

var ItemRegistry = /** @class */ (function () {
    function ItemRegistry() {
        this._isDisposed = false;
        this._onDidRevealItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidRevealItem = this._onDidRevealItem.event;
        this._onExpandItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onExpandItem = this._onExpandItem.event;
        this._onDidExpandItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidExpandItem = this._onDidExpandItem.event;
        this._onCollapseItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onCollapseItem = this._onCollapseItem.event;
        this._onDidCollapseItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidCollapseItem = this._onDidCollapseItem.event;
        this._onDidAddTraitItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidAddTraitItem = this._onDidAddTraitItem.event;
        this._onDidRemoveTraitItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidRemoveTraitItem = this._onDidRemoveTraitItem.event;
        this._onDidRefreshItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidRefreshItem = this._onDidRefreshItem.event;
        this._onRefreshItemChildren = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onRefreshItemChildren = this._onRefreshItemChildren.event;
        this._onDidRefreshItemChildren = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidRefreshItemChildren = this._onDidRefreshItemChildren.event;
        this._onDidDisposeItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["d" /* EventMultiplexer */]();
        this.onDidDisposeItem = this._onDidDisposeItem.event;
        this.items = {};
    }
    ItemRegistry.prototype.register = function (item) {
        __WEBPACK_IMPORTED_MODULE_0__common_assert_js__["a" /* ok */](!this.isRegistered(item.id), 'item already registered: ' + item.id);
        var disposable = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["c" /* combinedDisposable */])([
            this._onDidRevealItem.add(item.onDidReveal),
            this._onExpandItem.add(item.onExpand),
            this._onDidExpandItem.add(item.onDidExpand),
            this._onCollapseItem.add(item.onCollapse),
            this._onDidCollapseItem.add(item.onDidCollapse),
            this._onDidAddTraitItem.add(item.onDidAddTrait),
            this._onDidRemoveTraitItem.add(item.onDidRemoveTrait),
            this._onDidRefreshItem.add(item.onDidRefresh),
            this._onRefreshItemChildren.add(item.onRefreshChildren),
            this._onDidRefreshItemChildren.add(item.onDidRefreshChildren),
            this._onDidDisposeItem.add(item.onDidDispose)
        ]);
        this.items[item.id] = { item: item, disposable: disposable };
    };
    ItemRegistry.prototype.deregister = function (item) {
        __WEBPACK_IMPORTED_MODULE_0__common_assert_js__["a" /* ok */](this.isRegistered(item.id), 'item not registered: ' + item.id);
        this.items[item.id].disposable.dispose();
        delete this.items[item.id];
    };
    ItemRegistry.prototype.isRegistered = function (id) {
        return this.items.hasOwnProperty(id);
    };
    ItemRegistry.prototype.getItem = function (id) {
        var result = this.items[id];
        return result ? result.item : null;
    };
    ItemRegistry.prototype.dispose = function () {
        this.items = null;
        this._onDidRevealItem.dispose();
        this._onExpandItem.dispose();
        this._onDidExpandItem.dispose();
        this._onCollapseItem.dispose();
        this._onDidCollapseItem.dispose();
        this._onDidAddTraitItem.dispose();
        this._onDidRemoveTraitItem.dispose();
        this._onDidRefreshItem.dispose();
        this._onRefreshItemChildren.dispose();
        this._onDidRefreshItemChildren.dispose();
        this._isDisposed = true;
    };
    ItemRegistry.prototype.isDisposed = function () {
        return this._isDisposed;
    };
    return ItemRegistry;
}());

var Item = /** @class */ (function () {
    function Item(id, registry, context, lock, element) {
        this._onDidCreate = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this._onDidReveal = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidReveal = this._onDidReveal.event;
        this._onExpand = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onExpand = this._onExpand.event;
        this._onDidExpand = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidExpand = this._onDidExpand.event;
        this._onCollapse = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onCollapse = this._onCollapse.event;
        this._onDidCollapse = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidCollapse = this._onDidCollapse.event;
        this._onDidAddTrait = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidAddTrait = this._onDidAddTrait.event;
        this._onDidRemoveTrait = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidRemoveTrait = this._onDidRemoveTrait.event;
        this._onDidRefresh = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidRefresh = this._onDidRefresh.event;
        this._onRefreshChildren = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onRefreshChildren = this._onRefreshChildren.event;
        this._onDidRefreshChildren = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidRefreshChildren = this._onDidRefreshChildren.event;
        this._onDidDispose = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidDispose = this._onDidDispose.event;
        this.registry = registry;
        this.context = context;
        this.lock = lock;
        this.element = element;
        this.id = id;
        this.registry.register(this);
        this.doesHaveChildren = this.context.dataSource.hasChildren(this.context.tree, this.element);
        this.needsChildrenRefresh = true;
        this.parent = null;
        this.previous = null;
        this.next = null;
        this.firstChild = null;
        this.lastChild = null;
        this.traits = {};
        this.depth = 0;
        this.expanded = this.context.dataSource.shouldAutoexpand && this.context.dataSource.shouldAutoexpand(this.context.tree, element);
        this._onDidCreate.fire(this);
        this.visible = this._isVisible();
        this.height = this._getHeight();
        this._isDisposed = false;
    }
    Item.prototype.getElement = function () {
        return this.element;
    };
    Item.prototype.hasChildren = function () {
        return this.doesHaveChildren;
    };
    Item.prototype.getDepth = function () {
        return this.depth;
    };
    Item.prototype.isVisible = function () {
        return this.visible;
    };
    Item.prototype.setVisible = function (value) {
        this.visible = value;
    };
    Item.prototype.isExpanded = function () {
        return this.expanded;
    };
    /* protected */ Item.prototype._setExpanded = function (value) {
        this.expanded = value;
    };
    Item.prototype.reveal = function (relativeTop) {
        if (relativeTop === void 0) { relativeTop = null; }
        var eventData = { item: this, relativeTop: relativeTop };
        this._onDidReveal.fire(eventData);
    };
    Item.prototype.expand = function () {
        var _this = this;
        if (this.isExpanded() || !this.doesHaveChildren || this.lock.isLocked(this)) {
            return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(false);
        }
        var result = this.lock.run(this, function () {
            var eventData = { item: _this };
            var result;
            _this._onExpand.fire(eventData);
            if (_this.needsChildrenRefresh) {
                result = _this.refreshChildren(false, true, true);
            }
            else {
                result = __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(null);
            }
            return result.then(function () {
                _this._setExpanded(true);
                _this._onDidExpand.fire(eventData);
                return true;
            });
        });
        return result.then(function (r) {
            if (_this.isDisposed()) {
                return false;
            }
            // Auto expand single child folders
            if (_this.context.options.autoExpandSingleChildren && r && _this.firstChild !== null && _this.firstChild === _this.lastChild && _this.firstChild.isVisible()) {
                return _this.firstChild.expand().then(function () { return true; });
            }
            return r;
        });
    };
    Item.prototype.collapse = function (recursive) {
        var _this = this;
        if (recursive === void 0) { recursive = false; }
        if (recursive) {
            var collapseChildrenPromise = __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(null);
            this.forEachChild(function (child) {
                collapseChildrenPromise = collapseChildrenPromise.then(function () { return child.collapse(true); });
            });
            return collapseChildrenPromise.then(function () {
                return _this.collapse(false);
            });
        }
        else {
            if (!this.isExpanded() || this.lock.isLocked(this)) {
                return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(false);
            }
            return this.lock.run(this, function () {
                var eventData = { item: _this };
                _this._onCollapse.fire(eventData);
                _this._setExpanded(false);
                _this._onDidCollapse.fire(eventData);
                return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(true);
            });
        }
    };
    Item.prototype.addTrait = function (trait) {
        var eventData = { item: this, trait: trait };
        this.traits[trait] = true;
        this._onDidAddTrait.fire(eventData);
    };
    Item.prototype.removeTrait = function (trait) {
        var eventData = { item: this, trait: trait };
        delete this.traits[trait];
        this._onDidRemoveTrait.fire(eventData);
    };
    Item.prototype.hasTrait = function (trait) {
        return this.traits[trait] || false;
    };
    Item.prototype.getAllTraits = function () {
        var result = [];
        var trait;
        for (trait in this.traits) {
            if (this.traits.hasOwnProperty(trait) && this.traits[trait]) {
                result.push(trait);
            }
        }
        return result;
    };
    Item.prototype.getHeight = function () {
        return this.height;
    };
    Item.prototype.refreshChildren = function (recursive, safe, force) {
        var _this = this;
        if (safe === void 0) { safe = false; }
        if (force === void 0) { force = false; }
        if (!force && !this.isExpanded()) {
            this.needsChildrenRefresh = true;
            return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(this);
        }
        this.needsChildrenRefresh = false;
        var doRefresh = function () {
            var eventData = { item: _this, isNested: safe };
            _this._onRefreshChildren.fire(eventData);
            var childrenPromise;
            if (_this.doesHaveChildren) {
                childrenPromise = _this.context.dataSource.getChildren(_this.context.tree, _this.element);
            }
            else {
                childrenPromise = __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as([]);
            }
            var result = childrenPromise.then(function (elements) {
                if (_this.isDisposed() || _this.registry.isDisposed()) {
                    return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(null);
                }
                if (!Array.isArray(elements)) {
                    return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].wrapError(new Error('Please return an array of children.'));
                }
                elements = !elements ? [] : elements.slice(0);
                elements = _this.sort(elements);
                var staleItems = {};
                while (_this.firstChild !== null) {
                    staleItems[_this.firstChild.id] = _this.firstChild;
                    _this.removeChild(_this.firstChild);
                }
                for (var i = 0, len = elements.length; i < len; i++) {
                    var element = elements[i];
                    var id = _this.context.dataSource.getId(_this.context.tree, element);
                    var item = staleItems[id] || new Item(id, _this.registry, _this.context, _this.lock, element);
                    item.element = element;
                    if (recursive) {
                        item.needsChildrenRefresh = recursive;
                    }
                    delete staleItems[id];
                    _this.addChild(item);
                }
                for (var staleItemId in staleItems) {
                    if (staleItems.hasOwnProperty(staleItemId)) {
                        staleItems[staleItemId].dispose();
                    }
                }
                if (recursive) {
                    return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["a" /* Promise */].join(_this.mapEachChild(function (child) {
                        return child.doRefresh(recursive, true);
                    }));
                }
                else {
                    _this.mapEachChild(function (child) { return child.updateVisibility(); });
                    return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(null);
                }
            });
            return result
                .then(null, __WEBPACK_IMPORTED_MODULE_1__common_errors_js__["e" /* onUnexpectedError */])
                .then(function () { return _this._onDidRefreshChildren.fire(eventData); });
        };
        return safe ? doRefresh() : this.lock.run(this, doRefresh);
    };
    Item.prototype.doRefresh = function (recursive, safe) {
        if (safe === void 0) { safe = false; }
        this.doesHaveChildren = this.context.dataSource.hasChildren(this.context.tree, this.element);
        this.height = this._getHeight();
        this.updateVisibility();
        this._onDidRefresh.fire(this);
        return this.refreshChildren(recursive, safe);
    };
    Item.prototype.updateVisibility = function () {
        this.setVisible(this._isVisible());
    };
    Item.prototype.refresh = function (recursive) {
        return this.doRefresh(recursive);
    };
    Item.prototype.getNavigator = function () {
        return new TreeNavigator(this);
    };
    Item.prototype.intersects = function (other) {
        return this.isAncestorOf(other) || other.isAncestorOf(this);
    };
    Item.prototype.isAncestorOf = function (item) {
        while (item) {
            if (item.id === this.id) {
                return true;
            }
            item = item.parent;
        }
        return false;
    };
    Item.prototype.addChild = function (item, afterItem) {
        if (afterItem === void 0) { afterItem = this.lastChild; }
        var isEmpty = this.firstChild === null;
        var atHead = afterItem === null;
        var atTail = afterItem === this.lastChild;
        if (isEmpty) {
            this.firstChild = this.lastChild = item;
            item.next = item.previous = null;
        }
        else if (atHead) {
            this.firstChild.previous = item;
            item.next = this.firstChild;
            item.previous = null;
            this.firstChild = item;
        }
        else if (atTail) {
            this.lastChild.next = item;
            item.next = null;
            item.previous = this.lastChild;
            this.lastChild = item;
        }
        else {
            item.previous = afterItem;
            item.next = afterItem.next;
            afterItem.next.previous = item;
            afterItem.next = item;
        }
        item.parent = this;
        item.depth = this.depth + 1;
    };
    Item.prototype.removeChild = function (item) {
        var isFirstChild = this.firstChild === item;
        var isLastChild = this.lastChild === item;
        if (isFirstChild && isLastChild) {
            this.firstChild = this.lastChild = null;
        }
        else if (isFirstChild) {
            item.next.previous = null;
            this.firstChild = item.next;
        }
        else if (isLastChild) {
            item.previous.next = null;
            this.lastChild = item.previous;
        }
        else {
            item.next.previous = item.previous;
            item.previous.next = item.next;
        }
        item.parent = null;
        item.depth = null;
    };
    Item.prototype.forEachChild = function (fn) {
        var child = this.firstChild, next;
        while (child) {
            next = child.next;
            fn(child);
            child = next;
        }
    };
    Item.prototype.mapEachChild = function (fn) {
        var result = [];
        this.forEachChild(function (child) {
            result.push(fn(child));
        });
        return result;
    };
    Item.prototype.sort = function (elements) {
        var _this = this;
        if (this.context.sorter) {
            return elements.sort(function (element, otherElement) {
                return _this.context.sorter.compare(_this.context.tree, element, otherElement);
            });
        }
        return elements;
    };
    /* protected */ Item.prototype._getHeight = function () {
        return this.context.renderer.getHeight(this.context.tree, this.element);
    };
    /* protected */ Item.prototype._isVisible = function () {
        return this.context.filter.isVisible(this.context.tree, this.element);
    };
    Item.prototype.isDisposed = function () {
        return this._isDisposed;
    };
    Item.prototype.dispose = function () {
        this.forEachChild(function (child) { return child.dispose(); });
        this.parent = null;
        this.previous = null;
        this.next = null;
        this.firstChild = null;
        this.lastChild = null;
        this._onDidDispose.fire(this);
        this.registry.deregister(this);
        this._onDidCreate.dispose();
        this._onDidReveal.dispose();
        this._onExpand.dispose();
        this._onDidExpand.dispose();
        this._onCollapse.dispose();
        this._onDidCollapse.dispose();
        this._onDidAddTrait.dispose();
        this._onDidRemoveTrait.dispose();
        this._onDidRefresh.dispose();
        this._onRefreshChildren.dispose();
        this._onDidRefreshChildren.dispose();
        this._onDidDispose.dispose();
        this._isDisposed = true;
    };
    return Item;
}());

var RootItem = /** @class */ (function (_super) {
    __extends(RootItem, _super);
    function RootItem(id, registry, context, lock, element) {
        return _super.call(this, id, registry, context, lock, element) || this;
    }
    RootItem.prototype.isVisible = function () {
        return false;
    };
    RootItem.prototype.setVisible = function (value) {
        // no-op
    };
    RootItem.prototype.isExpanded = function () {
        return true;
    };
    /* protected */ RootItem.prototype._setExpanded = function (value) {
        // no-op
    };
    /* protected */ RootItem.prototype._getHeight = function () {
        return 0;
    };
    /* protected */ RootItem.prototype._isVisible = function () {
        return false;
    };
    return RootItem;
}(Item));
var TreeNavigator = /** @class */ (function () {
    function TreeNavigator(item, subTreeOnly) {
        if (subTreeOnly === void 0) { subTreeOnly = true; }
        this.item = item;
        this.start = subTreeOnly ? item : null;
    }
    TreeNavigator.lastDescendantOf = function (item) {
        if (!item) {
            return null;
        }
        if (item instanceof RootItem) {
            return TreeNavigator.lastDescendantOf(item.lastChild);
        }
        if (!item.isVisible()) {
            return TreeNavigator.lastDescendantOf(item.previous);
        }
        if (!item.isExpanded() || item.lastChild === null) {
            return item;
        }
        return TreeNavigator.lastDescendantOf(item.lastChild);
    };
    TreeNavigator.prototype.current = function () {
        return this.item || null;
    };
    TreeNavigator.prototype.next = function () {
        if (this.item) {
            do {
                if ((this.item instanceof RootItem || (this.item.isVisible() && this.item.isExpanded())) && this.item.firstChild) {
                    this.item = this.item.firstChild;
                }
                else if (this.item === this.start) {
                    this.item = null;
                }
                else {
                    // select next brother, next uncle, next great-uncle, etc...
                    while (this.item && this.item !== this.start && !this.item.next) {
                        this.item = this.item.parent;
                    }
                    if (this.item === this.start) {
                        this.item = null;
                    }
                    this.item = !this.item ? null : this.item.next;
                }
            } while (this.item && !this.item.isVisible());
        }
        return this.item || null;
    };
    TreeNavigator.prototype.previous = function () {
        if (this.item) {
            do {
                var previous = TreeNavigator.lastDescendantOf(this.item.previous);
                if (previous) {
                    this.item = previous;
                }
                else if (this.item.parent && this.item.parent !== this.start && this.item.parent.isVisible()) {
                    this.item = this.item.parent;
                }
                else {
                    this.item = null;
                }
            } while (this.item && !this.item.isVisible());
        }
        return this.item || null;
    };
    TreeNavigator.prototype.parent = function () {
        if (this.item) {
            var parent = this.item.parent;
            if (parent && parent !== this.start && parent.isVisible()) {
                this.item = parent;
            }
            else {
                this.item = null;
            }
        }
        return this.item || null;
    };
    TreeNavigator.prototype.first = function () {
        this.item = this.start;
        this.next();
        return this.item || null;
    };
    TreeNavigator.prototype.last = function () {
        return TreeNavigator.lastDescendantOf(this.start);
    };
    return TreeNavigator;
}());

var TreeModel = /** @class */ (function () {
    function TreeModel(context) {
        this._onSetInput = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onSetInput = this._onSetInput.event;
        this._onDidSetInput = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidSetInput = this._onDidSetInput.event;
        this._onRefresh = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onRefresh = this._onRefresh.event;
        this._onDidRefresh = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidRefresh = this._onDidRefresh.event;
        this._onDidHighlight = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidHighlight = this._onDidHighlight.event;
        this._onDidSelect = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidSelect = this._onDidSelect.event;
        this._onDidFocus = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["a" /* Emitter */]();
        this.onDidFocus = this._onDidFocus.event;
        this._onDidRevealItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidRevealItem = this._onDidRevealItem.event;
        this._onExpandItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onExpandItem = this._onExpandItem.event;
        this._onDidExpandItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidExpandItem = this._onDidExpandItem.event;
        this._onCollapseItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onCollapseItem = this._onCollapseItem.event;
        this._onDidCollapseItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidCollapseItem = this._onDidCollapseItem.event;
        this._onDidAddTraitItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidAddTraitItem = this._onDidAddTraitItem.event;
        this._onDidRemoveTraitItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidRemoveTraitItem = this._onDidRemoveTraitItem.event;
        this._onDidRefreshItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidRefreshItem = this._onDidRefreshItem.event;
        this._onRefreshItemChildren = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onRefreshItemChildren = this._onRefreshItemChildren.event;
        this._onDidRefreshItemChildren = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.onDidRefreshItemChildren = this._onDidRefreshItemChildren.event;
        this._onDidDisposeItem = new __WEBPACK_IMPORTED_MODULE_4__common_event_js__["e" /* Relay */]();
        this.context = context;
        this.input = null;
        this.traitsToItems = {};
    }
    TreeModel.prototype.setInput = function (element) {
        var _this = this;
        var eventData = { item: this.input };
        this._onSetInput.fire(eventData);
        this.setSelection([]);
        this.setFocus();
        this.setHighlight();
        this.lock = new Lock();
        if (this.input) {
            this.input.dispose();
        }
        if (this.registry) {
            this.registry.dispose();
            this.registryDisposable.dispose();
        }
        this.registry = new ItemRegistry();
        this._onDidRevealItem.input = this.registry.onDidRevealItem;
        this._onExpandItem.input = this.registry.onExpandItem;
        this._onDidExpandItem.input = this.registry.onDidExpandItem;
        this._onCollapseItem.input = this.registry.onCollapseItem;
        this._onDidCollapseItem.input = this.registry.onDidCollapseItem;
        this._onDidAddTraitItem.input = this.registry.onDidAddTraitItem;
        this._onDidRemoveTraitItem.input = this.registry.onDidRemoveTraitItem;
        this._onDidRefreshItem.input = this.registry.onDidRefreshItem;
        this._onRefreshItemChildren.input = this.registry.onRefreshItemChildren;
        this._onDidRefreshItemChildren.input = this.registry.onDidRefreshItemChildren;
        this._onDidDisposeItem.input = this.registry.onDidDisposeItem;
        this.registryDisposable = this.registry
            .onDidDisposeItem(function (item) { return item.getAllTraits().forEach(function (trait) { return delete _this.traitsToItems[trait][item.id]; }); });
        var id = this.context.dataSource.getId(this.context.tree, element);
        this.input = new RootItem(id, this.registry, this.context, this.lock, element);
        eventData = { item: this.input };
        this._onDidSetInput.fire(eventData);
        return this.refresh(this.input);
    };
    TreeModel.prototype.getInput = function () {
        return this.input ? this.input.getElement() : null;
    };
    TreeModel.prototype.refresh = function (element, recursive) {
        var _this = this;
        if (element === void 0) { element = null; }
        if (recursive === void 0) { recursive = true; }
        var item = this.getItem(element);
        if (!item) {
            return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(null);
        }
        var eventData = { item: item, recursive: recursive };
        this._onRefresh.fire(eventData);
        return item.refresh(recursive).then(function () {
            _this._onDidRefresh.fire(eventData);
        });
    };
    TreeModel.prototype.expand = function (element) {
        var item = this.getItem(element);
        if (!item) {
            return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(false);
        }
        return item.expand();
    };
    TreeModel.prototype.collapse = function (element, recursive) {
        if (recursive === void 0) { recursive = false; }
        var item = this.getItem(element);
        if (!item) {
            return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(false);
        }
        return item.collapse(recursive);
    };
    TreeModel.prototype.toggleExpansion = function (element, recursive) {
        if (recursive === void 0) { recursive = false; }
        return this.isExpanded(element) ? this.collapse(element, recursive) : this.expand(element);
    };
    TreeModel.prototype.isExpanded = function (element) {
        var item = this.getItem(element);
        if (!item) {
            return false;
        }
        return item.isExpanded();
    };
    TreeModel.prototype.reveal = function (element, relativeTop) {
        var _this = this;
        if (relativeTop === void 0) { relativeTop = null; }
        return this.resolveUnknownParentChain(element).then(function (chain) {
            var result = __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as(null);
            chain.forEach(function (e) {
                result = result.then(function () { return _this.expand(e); });
            });
            return result;
        }).then(function () {
            var item = _this.getItem(element);
            if (item) {
                return item.reveal(relativeTop);
            }
        });
    };
    TreeModel.prototype.resolveUnknownParentChain = function (element) {
        var _this = this;
        return this.context.dataSource.getParent(this.context.tree, element).then(function (parent) {
            if (!parent) {
                return __WEBPACK_IMPORTED_MODULE_3__common_winjs_base_js__["b" /* TPromise */].as([]);
            }
            return _this.resolveUnknownParentChain(parent).then(function (result) {
                result.push(parent);
                return result;
            });
        });
    };
    TreeModel.prototype.setHighlight = function (element, eventPayload) {
        this.setTraits('highlighted', element ? [element] : []);
        var eventData = { highlight: this.getHighlight(), payload: eventPayload };
        this._onDidHighlight.fire(eventData);
    };
    TreeModel.prototype.getHighlight = function (includeHidden) {
        var result = this.getElementsWithTrait('highlighted', includeHidden);
        return result.length === 0 ? null : result[0];
    };
    TreeModel.prototype.setSelection = function (elements, eventPayload) {
        this.setTraits('selected', elements);
        var eventData = { selection: this.getSelection(), payload: eventPayload };
        this._onDidSelect.fire(eventData);
    };
    TreeModel.prototype.getSelection = function (includeHidden) {
        return this.getElementsWithTrait('selected', includeHidden);
    };
    TreeModel.prototype.setFocus = function (element, eventPayload) {
        this.setTraits('focused', element ? [element] : []);
        var eventData = { focus: this.getFocus(), payload: eventPayload };
        this._onDidFocus.fire(eventData);
    };
    TreeModel.prototype.getFocus = function (includeHidden) {
        var result = this.getElementsWithTrait('focused', includeHidden);
        return result.length === 0 ? null : result[0];
    };
    TreeModel.prototype.focusNext = function (count, eventPayload) {
        if (count === void 0) { count = 1; }
        var item = this.getFocus() || this.input;
        var nextItem;
        var nav = this.getNavigator(item, false);
        for (var i = 0; i < count; i++) {
            nextItem = nav.next();
            if (!nextItem) {
                break;
            }
            item = nextItem;
        }
        this.setFocus(item, eventPayload);
    };
    TreeModel.prototype.focusPrevious = function (count, eventPayload) {
        if (count === void 0) { count = 1; }
        var item = this.getFocus() || this.input;
        var previousItem;
        var nav = this.getNavigator(item, false);
        for (var i = 0; i < count; i++) {
            previousItem = nav.previous();
            if (!previousItem) {
                break;
            }
            item = previousItem;
        }
        this.setFocus(item, eventPayload);
    };
    TreeModel.prototype.focusParent = function (eventPayload) {
        var item = this.getFocus() || this.input;
        var nav = this.getNavigator(item, false);
        var parent = nav.parent();
        if (parent) {
            this.setFocus(parent, eventPayload);
        }
    };
    TreeModel.prototype.focusFirstChild = function (eventPayload) {
        var item = this.getItem(this.getFocus() || this.input);
        var nav = this.getNavigator(item, false);
        var next = nav.next();
        var parent = nav.parent();
        if (parent === item) {
            this.setFocus(next, eventPayload);
        }
    };
    TreeModel.prototype.focusFirst = function (eventPayload, from) {
        this.focusNth(0, eventPayload, from);
    };
    TreeModel.prototype.focusNth = function (index, eventPayload, from) {
        var navItem = this.getParent(from);
        var nav = this.getNavigator(navItem);
        var item = nav.first();
        for (var i = 0; i < index; i++) {
            item = nav.next();
        }
        if (item) {
            this.setFocus(item, eventPayload);
        }
    };
    TreeModel.prototype.focusLast = function (eventPayload, from) {
        var navItem = this.getParent(from);
        var item;
        if (from) {
            item = navItem.lastChild;
        }
        else {
            var nav = this.getNavigator(navItem);
            item = nav.last();
        }
        if (item) {
            this.setFocus(item, eventPayload);
        }
    };
    TreeModel.prototype.getParent = function (from) {
        if (from) {
            var fromItem = this.getItem(from);
            if (fromItem && fromItem.parent) {
                return fromItem.parent;
            }
        }
        return this.getItem(this.input);
    };
    TreeModel.prototype.getNavigator = function (element, subTreeOnly) {
        if (element === void 0) { element = null; }
        if (subTreeOnly === void 0) { subTreeOnly = true; }
        return new TreeNavigator(this.getItem(element), subTreeOnly);
    };
    TreeModel.prototype.getItem = function (element) {
        if (element === void 0) { element = null; }
        if (element === null) {
            return this.input;
        }
        else if (element instanceof Item) {
            return element;
        }
        else if (typeof element === 'string') {
            return this.registry.getItem(element);
        }
        else {
            return this.registry.getItem(this.context.dataSource.getId(this.context.tree, element));
        }
    };
    TreeModel.prototype.removeTraits = function (trait, elements) {
        var items = this.traitsToItems[trait] || {};
        var item;
        var id;
        if (elements.length === 0) {
            for (id in items) {
                if (items.hasOwnProperty(id)) {
                    item = items[id];
                    item.removeTrait(trait);
                }
            }
            delete this.traitsToItems[trait];
        }
        else {
            for (var i = 0, len = elements.length; i < len; i++) {
                item = this.getItem(elements[i]);
                if (item) {
                    item.removeTrait(trait);
                    delete items[item.id];
                }
            }
        }
    };
    TreeModel.prototype.setTraits = function (trait, elements) {
        if (elements.length === 0) {
            this.removeTraits(trait, elements);
        }
        else {
            var items = {};
            var item;
            for (var i = 0, len = elements.length; i < len; i++) {
                item = this.getItem(elements[i]);
                if (item) {
                    items[item.id] = item;
                }
            }
            var traitItems = this.traitsToItems[trait] || {};
            var itemsToRemoveTrait = [];
            var id;
            for (id in traitItems) {
                if (traitItems.hasOwnProperty(id)) {
                    if (items.hasOwnProperty(id)) {
                        delete items[id];
                    }
                    else {
                        itemsToRemoveTrait.push(traitItems[id]);
                    }
                }
            }
            for (var i = 0, len = itemsToRemoveTrait.length; i < len; i++) {
                item = itemsToRemoveTrait[i];
                item.removeTrait(trait);
                delete traitItems[item.id];
            }
            for (id in items) {
                if (items.hasOwnProperty(id)) {
                    item = items[id];
                    item.addTrait(trait);
                    traitItems[id] = item;
                }
            }
            this.traitsToItems[trait] = traitItems;
        }
    };
    TreeModel.prototype.getElementsWithTrait = function (trait, includeHidden) {
        var elements = [];
        var items = this.traitsToItems[trait] || {};
        var id;
        for (id in items) {
            if (items.hasOwnProperty(id) && (items[id].isVisible() || includeHidden)) {
                elements.push(items[id].getElement());
            }
        }
        return elements;
    };
    TreeModel.prototype.dispose = function () {
        if (this.registry) {
            this.registry.dispose();
            this.registry = null;
        }
        this._onSetInput.dispose();
        this._onDidSetInput.dispose();
        this._onRefresh.dispose();
        this._onDidRefresh.dispose();
        this._onDidHighlight.dispose();
        this._onDidSelect.dispose();
        this._onDidFocus.dispose();
        this._onDidRevealItem.dispose();
        this._onExpandItem.dispose();
        this._onDidExpandItem.dispose();
        this._onCollapseItem.dispose();
        this._onDidCollapseItem.dispose();
        this._onDidAddTraitItem.dispose();
        this._onDidRemoveTraitItem.dispose();
        this._onDidRefreshItem.dispose();
        this._onRefreshItemChildren.dispose();
        this._onDidRefreshItemChildren.dispose();
        this._onDidDisposeItem.dispose();
    };
    return TreeModel;
}());



/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RowCache */
/* unused harmony export ViewItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_diff_diff_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_touch_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__treeDnd_js__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_iterator_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__browser_ui_scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__treeViewModel_js__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tree_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__browser_dnd_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__treeDefaults_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















function removeFromParent(element) {
    try {
        element.parentElement.removeChild(element);
    }
    catch (e) {
        // this will throw if this happens due to a blur event, nasty business
    }
}
var RowCache = /** @class */ (function () {
    function RowCache(context) {
        this.context = context;
        this._cache = { '': [] };
    }
    RowCache.prototype.alloc = function (templateId) {
        var result = this.cache(templateId).pop();
        if (!result) {
            var content = document.createElement('div');
            content.className = 'content';
            var row = document.createElement('div');
            row.appendChild(content);
            result = {
                element: row,
                templateId: templateId,
                templateData: this.context.renderer.renderTemplate(this.context.tree, templateId, content)
            };
        }
        return result;
    };
    RowCache.prototype.release = function (templateId, row) {
        removeFromParent(row.element);
        this.cache(templateId).push(row);
    };
    RowCache.prototype.cache = function (templateId) {
        return this._cache[templateId] || (this._cache[templateId] = []);
    };
    RowCache.prototype.garbageCollect = function () {
        var _this = this;
        if (this._cache) {
            Object.keys(this._cache).forEach(function (templateId) {
                _this._cache[templateId].forEach(function (cachedRow) {
                    _this.context.renderer.disposeTemplate(_this.context.tree, templateId, cachedRow.templateData);
                    cachedRow.element = null;
                    cachedRow.templateData = null;
                });
                delete _this._cache[templateId];
            });
        }
    };
    RowCache.prototype.dispose = function () {
        this.garbageCollect();
        this._cache = null;
        this.context = null;
    };
    return RowCache;
}());

var ViewItem = /** @class */ (function () {
    function ViewItem(context, model) {
        var _this = this;
        this.width = 0;
        this.context = context;
        this.model = model;
        this.id = this.model.id;
        this.row = null;
        this.top = 0;
        this.height = model.getHeight();
        this._styles = {};
        model.getAllTraits().forEach(function (t) { return _this._styles[t] = true; });
        if (model.isExpanded()) {
            this.addClass('expanded');
        }
    }
    Object.defineProperty(ViewItem.prototype, "expanded", {
        set: function (value) {
            value ? this.addClass('expanded') : this.removeClass('expanded');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewItem.prototype, "loading", {
        set: function (value) {
            value ? this.addClass('loading') : this.removeClass('loading');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewItem.prototype, "draggable", {
        get: function () {
            return this._draggable;
        },
        set: function (value) {
            this._draggable = value;
            this.render(true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewItem.prototype, "dropTarget", {
        set: function (value) {
            value ? this.addClass('drop-target') : this.removeClass('drop-target');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewItem.prototype, "element", {
        get: function () {
            return this.row && this.row.element;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewItem.prototype, "templateId", {
        get: function () {
            return this._templateId || (this._templateId = (this.context.renderer.getTemplateId && this.context.renderer.getTemplateId(this.context.tree, this.model.getElement())));
        },
        enumerable: true,
        configurable: true
    });
    ViewItem.prototype.addClass = function (name) {
        this._styles[name] = true;
        this.render(true);
    };
    ViewItem.prototype.removeClass = function (name) {
        delete this._styles[name]; // is this slow?
        this.render(true);
    };
    ViewItem.prototype.render = function (skipUserRender) {
        var _this = this;
        if (skipUserRender === void 0) { skipUserRender = false; }
        if (!this.model || !this.element) {
            return;
        }
        var classes = ['monaco-tree-row'];
        classes.push.apply(classes, Object.keys(this._styles));
        if (this.model.hasChildren()) {
            classes.push('has-children');
        }
        this.element.className = classes.join(' ');
        this.element.draggable = this.draggable;
        this.element.style.height = this.height + 'px';
        // ARIA
        this.element.setAttribute('role', 'treeitem');
        var accessibility = this.context.accessibilityProvider;
        var ariaLabel = accessibility.getAriaLabel(this.context.tree, this.model.getElement());
        if (ariaLabel) {
            this.element.setAttribute('aria-label', ariaLabel);
        }
        if (accessibility.getPosInSet && accessibility.getSetSize) {
            this.element.setAttribute('aria-setsize', accessibility.getSetSize());
            this.element.setAttribute('aria-posinset', accessibility.getPosInSet(this.context.tree, this.model.getElement()));
        }
        if (this.model.hasTrait('focused')) {
            var base64Id = __WEBPACK_IMPORTED_MODULE_7__common_strings_js__["safeBtoa"](this.model.id);
            this.element.setAttribute('aria-selected', 'true');
            this.element.setAttribute('id', base64Id);
        }
        else {
            this.element.setAttribute('aria-selected', 'false');
            this.element.removeAttribute('id');
        }
        if (this.model.hasChildren()) {
            this.element.setAttribute('aria-expanded', String(!!this._styles['expanded']));
        }
        else {
            this.element.removeAttribute('aria-expanded');
        }
        this.element.setAttribute('aria-level', String(this.model.getDepth()));
        if (this.context.options.paddingOnRow) {
            this.element.style.paddingLeft = this.context.options.twistiePixels + ((this.model.getDepth() - 1) * this.context.options.indentPixels) + 'px';
        }
        else {
            this.element.style.paddingLeft = ((this.model.getDepth() - 1) * this.context.options.indentPixels) + 'px';
            this.row.element.firstElementChild.style.paddingLeft = this.context.options.twistiePixels + 'px';
        }
        var uri = this.context.dnd.getDragURI(this.context.tree, this.model.getElement());
        if (uri !== this.uri) {
            if (this.unbindDragStart) {
                this.unbindDragStart.dispose();
                this.unbindDragStart = null;
            }
            if (uri) {
                this.uri = uri;
                this.draggable = true;
                this.unbindDragStart = __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](this.element, 'dragstart', function (e) {
                    _this.onDragStart(e);
                });
            }
            else {
                this.uri = null;
            }
        }
        if (!skipUserRender && this.element) {
            var style = window.getComputedStyle(this.element);
            var paddingLeft = parseFloat(style.paddingLeft);
            if (this.context.horizontalScrolling) {
                this.element.style.width = 'fit-content';
            }
            this.context.renderer.renderElement(this.context.tree, this.model.getElement(), this.templateId, this.row.templateData);
            if (this.context.horizontalScrolling) {
                this.width = __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["t" /* getContentWidth */](this.element) + paddingLeft;
                this.element.style.width = '';
            }
        }
    };
    ViewItem.prototype.insertInDOM = function (container, afterElement) {
        if (!this.row) {
            this.row = this.context.cache.alloc(this.templateId);
            // used in reverse lookup from HTMLElement to Item
            this.element[TreeView.BINDING] = this;
        }
        if (this.element.parentElement) {
            return;
        }
        if (afterElement === null) {
            container.appendChild(this.element);
        }
        else {
            try {
                container.insertBefore(this.element, afterElement);
            }
            catch (e) {
                console.warn('Failed to locate previous tree element');
                container.appendChild(this.element);
            }
        }
        this.render();
    };
    ViewItem.prototype.removeFromDOM = function () {
        if (!this.row) {
            return;
        }
        if (this.unbindDragStart) {
            this.unbindDragStart.dispose();
            this.unbindDragStart = null;
        }
        this.uri = null;
        this.element[TreeView.BINDING] = null;
        this.context.cache.release(this.templateId, this.row);
        this.row = null;
    };
    ViewItem.prototype.dispose = function () {
        this.row = null;
        this.model = null;
    };
    return ViewItem;
}());

var RootViewItem = /** @class */ (function (_super) {
    __extends(RootViewItem, _super);
    function RootViewItem(context, model, wrapper) {
        var _this = _super.call(this, context, model) || this;
        _this.row = {
            element: wrapper,
            templateData: null,
            templateId: null
        };
        return _this;
    }
    RootViewItem.prototype.render = function () {
        if (!this.model || !this.element) {
            return;
        }
        var classes = ['monaco-tree-wrapper'];
        classes.push.apply(classes, Object.keys(this._styles));
        if (this.model.hasChildren()) {
            classes.push('has-children');
        }
        this.element.className = classes.join(' ');
    };
    RootViewItem.prototype.insertInDOM = function (container, afterElement) {
        // noop
    };
    RootViewItem.prototype.removeFromDOM = function () {
        // noop
    };
    return RootViewItem;
}(ViewItem));
function reactionEquals(one, other) {
    if (!one && !other) {
        return true;
    }
    else if (!one || !other) {
        return false;
    }
    else if (one.accept !== other.accept) {
        return false;
    }
    else if (one.bubble !== other.bubble) {
        return false;
    }
    else if (one.effect !== other.effect) {
        return false;
    }
    else {
        return true;
    }
}
var TreeView = /** @class */ (function (_super) {
    __extends(TreeView, _super);
    function TreeView(context, container) {
        var _this = _super.call(this) || this;
        _this.lastClickTimeStamp = 0;
        _this.contentWidthUpdateDelayer = new __WEBPACK_IMPORTED_MODULE_19__common_async_js__["a" /* Delayer */](50);
        _this.isRefreshing = false;
        _this.refreshingPreviousChildrenIds = {};
        _this._onDOMFocus = new __WEBPACK_IMPORTED_MODULE_16__common_event_js__["a" /* Emitter */]();
        _this._onDOMBlur = new __WEBPACK_IMPORTED_MODULE_16__common_event_js__["a" /* Emitter */]();
        _this._onDidScroll = new __WEBPACK_IMPORTED_MODULE_16__common_event_js__["a" /* Emitter */]();
        TreeView.counter++;
        _this.instance = TreeView.counter;
        var horizontalScrollMode = typeof context.options.horizontalScrollMode === 'undefined' ? __WEBPACK_IMPORTED_MODULE_13__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden : context.options.horizontalScrollMode;
        _this.horizontalScrolling = horizontalScrollMode !== __WEBPACK_IMPORTED_MODULE_13__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden;
        _this.context = {
            dataSource: context.dataSource,
            renderer: context.renderer,
            controller: context.controller,
            dnd: context.dnd,
            filter: context.filter,
            sorter: context.sorter,
            tree: context.tree,
            accessibilityProvider: context.accessibilityProvider,
            options: context.options,
            cache: new RowCache(context),
            horizontalScrolling: _this.horizontalScrolling
        };
        _this.modelListeners = [];
        _this.viewListeners = [];
        _this.model = null;
        _this.items = {};
        _this.domNode = document.createElement('div');
        _this.domNode.className = "monaco-tree no-focused-item monaco-tree-instance-" + _this.instance;
        // to allow direct tabbing into the tree instead of first focusing the tree
        _this.domNode.tabIndex = context.options.preventRootFocus ? -1 : 0;
        _this.styleElement = __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["o" /* createStyleSheet */](_this.domNode);
        _this.treeStyler = context.styler;
        if (!_this.treeStyler) {
            _this.treeStyler = new __WEBPACK_IMPORTED_MODULE_18__treeDefaults_js__["f" /* DefaultTreestyler */](_this.styleElement, "monaco-tree-instance-" + _this.instance);
        }
        // ARIA
        _this.domNode.setAttribute('role', 'tree');
        if (_this.context.options.ariaLabel) {
            _this.domNode.setAttribute('aria-label', _this.context.options.ariaLabel);
        }
        if (_this.context.options.alwaysFocused) {
            __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["f" /* addClass */](_this.domNode, 'focused');
        }
        if (!_this.context.options.paddingOnRow) {
            __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["f" /* addClass */](_this.domNode, 'no-row-padding');
        }
        _this.wrapper = document.createElement('div');
        _this.wrapper.className = 'monaco-tree-wrapper';
        _this.scrollableElement = new __WEBPACK_IMPORTED_MODULE_12__browser_ui_scrollbar_scrollableElement_js__["b" /* ScrollableElement */](_this.wrapper, {
            alwaysConsumeMouseWheel: true,
            horizontal: horizontalScrollMode,
            vertical: (typeof context.options.verticalScrollMode !== 'undefined' ? context.options.verticalScrollMode : __WEBPACK_IMPORTED_MODULE_13__common_scrollable_js__["b" /* ScrollbarVisibility */].Auto),
            useShadows: context.options.useShadows
        });
        _this.scrollableElement.onScroll(function (e) {
            _this.render(e.scrollTop, e.height, e.scrollLeft, e.width, e.scrollWidth);
            _this._onDidScroll.fire();
        });
        if (__WEBPACK_IMPORTED_MODULE_1__browser_browser_js__["k" /* isIE */]) {
            _this.wrapper.style.msTouchAction = 'none';
            _this.wrapper.style.msContentZooming = 'none';
        }
        else {
            __WEBPACK_IMPORTED_MODULE_6__browser_touch_js__["b" /* Gesture */].addTarget(_this.wrapper);
        }
        _this.rowsContainer = document.createElement('div');
        _this.rowsContainer.className = 'monaco-tree-rows';
        if (context.options.showTwistie) {
            _this.rowsContainer.className += ' show-twisties';
        }
        var focusTracker = __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["O" /* trackFocus */](_this.domNode);
        _this.viewListeners.push(focusTracker.onDidFocus(function () { return _this.onFocus(); }));
        _this.viewListeners.push(focusTracker.onDidBlur(function () { return _this.onBlur(); }));
        _this.viewListeners.push(focusTracker);
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.domNode, 'keydown', function (e) { return _this.onKeyDown(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.domNode, 'keyup', function (e) { return _this.onKeyUp(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.domNode, 'mousedown', function (e) { return _this.onMouseDown(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.domNode, 'mouseup', function (e) { return _this.onMouseUp(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.wrapper, 'click', function (e) { return _this.onClick(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.wrapper, 'auxclick', function (e) { return _this.onClick(e); })); // >= Chrome 56
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.domNode, 'contextmenu', function (e) { return _this.onContextMenu(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.wrapper, __WEBPACK_IMPORTED_MODULE_6__browser_touch_js__["a" /* EventType */].Tap, function (e) { return _this.onTap(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.wrapper, __WEBPACK_IMPORTED_MODULE_6__browser_touch_js__["a" /* EventType */].Change, function (e) { return _this.onTouchChange(e); }));
        if (__WEBPACK_IMPORTED_MODULE_1__browser_browser_js__["k" /* isIE */]) {
            _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.wrapper, 'MSPointerDown', function (e) { return _this.onMsPointerDown(e); }));
            _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.wrapper, 'MSGestureTap', function (e) { return _this.onMsGestureTap(e); }));
            // these events come too fast, we throttle them
            _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["i" /* addDisposableThrottledListener */](_this.wrapper, 'MSGestureChange', function (e) { return _this.onThrottledMsGestureChange(e); }, function (lastEvent, event) {
                event.stopPropagation();
                event.preventDefault();
                var result = { translationY: event.translationY, translationX: event.translationX };
                if (lastEvent) {
                    result.translationY += lastEvent.translationY;
                    result.translationX += lastEvent.translationX;
                }
                return result;
            }));
        }
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](window, 'dragover', function (e) { return _this.onDragOver(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](_this.wrapper, 'drop', function (e) { return _this.onDrop(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](window, 'dragend', function (e) { return _this.onDragEnd(e); }));
        _this.viewListeners.push(__WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["g" /* addDisposableListener */](window, 'dragleave', function (e) { return _this.onDragOver(e); }));
        _this.wrapper.appendChild(_this.rowsContainer);
        _this.domNode.appendChild(_this.scrollableElement.getDomNode());
        container.appendChild(_this.domNode);
        _this.lastRenderTop = 0;
        _this.lastRenderHeight = 0;
        _this.didJustPressContextMenuKey = false;
        _this.currentDropTarget = null;
        _this.currentDropTargets = [];
        _this.shouldInvalidateDropReaction = false;
        _this.dragAndDropScrollInterval = null;
        _this.dragAndDropScrollTimeout = null;
        _this.onHiddenScrollTop = null;
        _this.onRowsChanged();
        _this.layout();
        _this.setupMSGesture();
        _this.applyStyles(context.options);
        return _this;
    }
    Object.defineProperty(TreeView.prototype, "onDOMFocus", {
        get: function () { return this._onDOMFocus.event; },
        enumerable: true,
        configurable: true
    });
    TreeView.prototype.applyStyles = function (styles) {
        this.treeStyler.style(styles);
    };
    TreeView.prototype.createViewItem = function (item) {
        return new ViewItem(this.context, item);
    };
    TreeView.prototype.getHTMLElement = function () {
        return this.domNode;
    };
    TreeView.prototype.focus = function () {
        this.domNode.focus();
    };
    TreeView.prototype.isFocused = function () {
        return document.activeElement === this.domNode;
    };
    TreeView.prototype.blur = function () {
        this.domNode.blur();
    };
    TreeView.prototype.setupMSGesture = function () {
        var _this = this;
        if (window.MSGesture) {
            this.msGesture = new MSGesture();
            setTimeout(function () { return _this.msGesture.target = _this.wrapper; }, 100); // TODO@joh, TODO@IETeam
        }
    };
    TreeView.prototype.isTreeVisible = function () {
        return this.onHiddenScrollTop === null;
    };
    TreeView.prototype.layout = function (height, width) {
        if (!this.isTreeVisible()) {
            return;
        }
        this.viewHeight = height || __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["s" /* getContentHeight */](this.wrapper); // render
        this.scrollHeight = this.getContentHeight();
        if (this.horizontalScrolling) {
            this.viewWidth = width || __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["t" /* getContentWidth */](this.wrapper);
        }
    };
    TreeView.prototype.render = function (scrollTop, viewHeight, scrollLeft, viewWidth, scrollWidth) {
        var i;
        var stop;
        var renderTop = scrollTop;
        var renderBottom = scrollTop + viewHeight;
        var thisRenderBottom = this.lastRenderTop + this.lastRenderHeight;
        // when view scrolls down, start rendering from the renderBottom
        for (i = this.indexAfter(renderBottom) - 1, stop = this.indexAt(Math.max(thisRenderBottom, renderTop)); i >= stop; i--) {
            this.insertItemInDOM(this.itemAtIndex(i));
        }
        // when view scrolls up, start rendering from either this.renderTop or renderBottom
        for (i = Math.min(this.indexAt(this.lastRenderTop), this.indexAfter(renderBottom)) - 1, stop = this.indexAt(renderTop); i >= stop; i--) {
            this.insertItemInDOM(this.itemAtIndex(i));
        }
        // when view scrolls down, start unrendering from renderTop
        for (i = this.indexAt(this.lastRenderTop), stop = Math.min(this.indexAt(renderTop), this.indexAfter(thisRenderBottom)); i < stop; i++) {
            this.removeItemFromDOM(this.itemAtIndex(i));
        }
        // when view scrolls up, start unrendering from either renderBottom this.renderTop
        for (i = Math.max(this.indexAfter(renderBottom), this.indexAt(this.lastRenderTop)), stop = this.indexAfter(thisRenderBottom); i < stop; i++) {
            this.removeItemFromDOM(this.itemAtIndex(i));
        }
        var topItem = this.itemAtIndex(this.indexAt(renderTop));
        if (topItem) {
            this.rowsContainer.style.top = (topItem.top - renderTop) + 'px';
        }
        if (this.horizontalScrolling) {
            this.rowsContainer.style.left = -scrollLeft + 'px';
            this.rowsContainer.style.width = Math.max(scrollWidth, viewWidth) + "px";
        }
        this.lastRenderTop = renderTop;
        this.lastRenderHeight = renderBottom - renderTop;
    };
    TreeView.prototype.setModel = function (newModel) {
        this.releaseModel();
        this.model = newModel;
        this.model.onRefresh(this.onRefreshing, this, this.modelListeners);
        this.model.onDidRefresh(this.onRefreshed, this, this.modelListeners);
        this.model.onSetInput(this.onClearingInput, this, this.modelListeners);
        this.model.onDidSetInput(this.onSetInput, this, this.modelListeners);
        this.model.onDidFocus(this.onModelFocusChange, this, this.modelListeners);
        this.model.onRefreshItemChildren(this.onItemChildrenRefreshing, this, this.modelListeners);
        this.model.onDidRefreshItemChildren(this.onItemChildrenRefreshed, this, this.modelListeners);
        this.model.onDidRefreshItem(this.onItemRefresh, this, this.modelListeners);
        this.model.onExpandItem(this.onItemExpanding, this, this.modelListeners);
        this.model.onDidExpandItem(this.onItemExpanded, this, this.modelListeners);
        this.model.onCollapseItem(this.onItemCollapsing, this, this.modelListeners);
        this.model.onDidRevealItem(this.onItemReveal, this, this.modelListeners);
        this.model.onDidAddTraitItem(this.onItemAddTrait, this, this.modelListeners);
        this.model.onDidRemoveTraitItem(this.onItemRemoveTrait, this, this.modelListeners);
    };
    TreeView.prototype.onRefreshing = function () {
        this.isRefreshing = true;
    };
    TreeView.prototype.onRefreshed = function () {
        this.isRefreshing = false;
        this.onRowsChanged();
    };
    TreeView.prototype.onRowsChanged = function (scrollTop) {
        if (scrollTop === void 0) { scrollTop = this.scrollTop; }
        if (this.isRefreshing) {
            return;
        }
        this.scrollTop = scrollTop;
        this.updateScrollWidth();
    };
    TreeView.prototype.updateScrollWidth = function () {
        var _this = this;
        if (!this.horizontalScrolling) {
            return;
        }
        this.contentWidthUpdateDelayer.trigger(function () {
            var keys = Object.keys(_this.items);
            var scrollWidth = 0;
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                scrollWidth = Math.max(scrollWidth, _this.items[key].width);
            }
            _this.scrollWidth = scrollWidth + 10 /* scrollbar */;
        });
    };
    TreeView.prototype.focusNextPage = function (eventPayload) {
        var _this = this;
        var lastPageIndex = this.indexAt(this.scrollTop + this.viewHeight);
        lastPageIndex = lastPageIndex === 0 ? 0 : lastPageIndex - 1;
        var lastPageElement = this.itemAtIndex(lastPageIndex).model.getElement();
        var currentlyFocusedElement = this.model.getFocus();
        if (currentlyFocusedElement !== lastPageElement) {
            this.model.setFocus(lastPageElement, eventPayload);
        }
        else {
            var previousScrollTop = this.scrollTop;
            this.scrollTop += this.viewHeight;
            if (this.scrollTop !== previousScrollTop) {
                // Let the scroll event listener run
                setTimeout(function () {
                    _this.focusNextPage(eventPayload);
                }, 0);
            }
        }
    };
    TreeView.prototype.focusPreviousPage = function (eventPayload) {
        var _this = this;
        var firstPageIndex;
        if (this.scrollTop === 0) {
            firstPageIndex = this.indexAt(this.scrollTop);
        }
        else {
            firstPageIndex = this.indexAfter(this.scrollTop - 1);
        }
        var firstPageElement = this.itemAtIndex(firstPageIndex).model.getElement();
        var currentlyFocusedElement = this.model.getFocus();
        if (currentlyFocusedElement !== firstPageElement) {
            this.model.setFocus(firstPageElement, eventPayload);
        }
        else {
            var previousScrollTop = this.scrollTop;
            this.scrollTop -= this.viewHeight;
            if (this.scrollTop !== previousScrollTop) {
                // Let the scroll event listener run
                setTimeout(function () {
                    _this.focusPreviousPage(eventPayload);
                }, 0);
            }
        }
    };
    Object.defineProperty(TreeView.prototype, "viewHeight", {
        get: function () {
            var scrollDimensions = this.scrollableElement.getScrollDimensions();
            return scrollDimensions.height;
        },
        set: function (height) {
            this.scrollableElement.setScrollDimensions({ height: height });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeView.prototype, "scrollHeight", {
        set: function (scrollHeight) {
            this.scrollableElement.setScrollDimensions({ scrollHeight: scrollHeight });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeView.prototype, "viewWidth", {
        get: function () {
            var scrollDimensions = this.scrollableElement.getScrollDimensions();
            return scrollDimensions.width;
        },
        set: function (viewWidth) {
            this.scrollableElement.setScrollDimensions({ width: viewWidth });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeView.prototype, "scrollWidth", {
        set: function (scrollWidth) {
            this.scrollableElement.setScrollDimensions({ scrollWidth: scrollWidth });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeView.prototype, "scrollTop", {
        get: function () {
            var scrollPosition = this.scrollableElement.getScrollPosition();
            return scrollPosition.scrollTop;
        },
        set: function (scrollTop) {
            this.scrollableElement.setScrollDimensions({
                scrollHeight: this.getContentHeight()
            });
            this.scrollableElement.setScrollPosition({
                scrollTop: scrollTop
            });
        },
        enumerable: true,
        configurable: true
    });
    // Events
    TreeView.prototype.onClearingInput = function (e) {
        var item = e.item;
        if (item) {
            this.onRemoveItems(new __WEBPACK_IMPORTED_MODULE_11__common_iterator_js__["c" /* MappedIterator */](item.getNavigator(), function (item) { return item && item.id; }));
            this.onRowsChanged();
        }
    };
    TreeView.prototype.onSetInput = function (e) {
        this.context.cache.garbageCollect();
        this.inputItem = new RootViewItem(this.context, e.item, this.wrapper);
    };
    TreeView.prototype.onItemChildrenRefreshing = function (e) {
        var item = e.item;
        var viewItem = this.items[item.id];
        if (viewItem && this.context.options.showLoading) {
            viewItem.loadingTimer = setTimeout(function () {
                viewItem.loadingTimer = 0;
                viewItem.loading = true;
            }, TreeView.LOADING_DECORATION_DELAY);
        }
        if (!e.isNested) {
            var childrenIds = [];
            var navigator = item.getNavigator();
            var childItem;
            while (childItem = navigator.next()) {
                childrenIds.push(childItem.id);
            }
            this.refreshingPreviousChildrenIds[item.id] = childrenIds;
        }
    };
    TreeView.prototype.onItemChildrenRefreshed = function (e) {
        var _this = this;
        var item = e.item;
        var viewItem = this.items[item.id];
        if (viewItem) {
            if (viewItem.loadingTimer) {
                clearTimeout(viewItem.loadingTimer);
                viewItem.loadingTimer = 0;
            }
            viewItem.loading = false;
        }
        if (!e.isNested) {
            var previousChildrenIds = this.refreshingPreviousChildrenIds[item.id];
            var afterModelItems = [];
            var navigator = item.getNavigator();
            var childItem;
            while (childItem = navigator.next()) {
                afterModelItems.push(childItem);
            }
            var skipDiff = Math.abs(previousChildrenIds.length - afterModelItems.length) > 1000;
            var diff = void 0;
            var doToInsertItemsAlreadyExist = void 0;
            if (!skipDiff) {
                var lcs = new __WEBPACK_IMPORTED_MODULE_5__common_diff_diff_js__["a" /* LcsDiff */]({
                    getLength: function () { return previousChildrenIds.length; },
                    getElementAtIndex: function (i) { return previousChildrenIds[i]; }
                }, {
                    getLength: function () { return afterModelItems.length; },
                    getElementAtIndex: function (i) { return afterModelItems[i].id; }
                }, null);
                diff = lcs.ComputeDiff(false);
                // this means that the result of the diff algorithm would result
                // in inserting items that were already registered. this can only
                // happen if the data provider returns bad ids OR if the sorting
                // of the elements has changed
                doToInsertItemsAlreadyExist = diff.some(function (d) {
                    if (d.modifiedLength > 0) {
                        for (var i = d.modifiedStart, len = d.modifiedStart + d.modifiedLength; i < len; i++) {
                            if (_this.items.hasOwnProperty(afterModelItems[i].id)) {
                                return true;
                            }
                        }
                    }
                    return false;
                });
            }
            // 50 is an optimization number, at some point we're better off
            // just replacing everything
            if (!skipDiff && !doToInsertItemsAlreadyExist && diff.length < 50) {
                for (var i = 0, len = diff.length; i < len; i++) {
                    var diffChange = diff[i];
                    if (diffChange.originalLength > 0) {
                        this.onRemoveItems(new __WEBPACK_IMPORTED_MODULE_11__common_iterator_js__["a" /* ArrayIterator */](previousChildrenIds, diffChange.originalStart, diffChange.originalStart + diffChange.originalLength));
                    }
                    if (diffChange.modifiedLength > 0) {
                        var beforeItem = afterModelItems[diffChange.modifiedStart - 1] || item;
                        beforeItem = beforeItem.getDepth() > 0 ? beforeItem : null;
                        this.onInsertItems(new __WEBPACK_IMPORTED_MODULE_11__common_iterator_js__["a" /* ArrayIterator */](afterModelItems, diffChange.modifiedStart, diffChange.modifiedStart + diffChange.modifiedLength), beforeItem ? beforeItem.id : null);
                    }
                }
            }
            else if (skipDiff || diff.length) {
                this.onRemoveItems(new __WEBPACK_IMPORTED_MODULE_11__common_iterator_js__["a" /* ArrayIterator */](previousChildrenIds));
                this.onInsertItems(new __WEBPACK_IMPORTED_MODULE_11__common_iterator_js__["a" /* ArrayIterator */](afterModelItems), item.getDepth() > 0 ? item.id : null);
            }
            if (skipDiff || diff.length) {
                this.onRowsChanged();
            }
        }
    };
    TreeView.prototype.onItemRefresh = function (item) {
        this.onItemsRefresh([item]);
    };
    TreeView.prototype.onItemsRefresh = function (items) {
        var _this = this;
        this.onRefreshItemSet(items.filter(function (item) { return _this.items.hasOwnProperty(item.id); }));
        this.onRowsChanged();
    };
    TreeView.prototype.onItemExpanding = function (e) {
        var viewItem = this.items[e.item.id];
        if (viewItem) {
            viewItem.expanded = true;
        }
    };
    TreeView.prototype.onItemExpanded = function (e) {
        var item = e.item;
        var viewItem = this.items[item.id];
        if (viewItem) {
            viewItem.expanded = true;
            var height = this.onInsertItems(item.getNavigator(), item.id);
            var scrollTop = this.scrollTop;
            if (viewItem.top + viewItem.height <= this.scrollTop) {
                scrollTop += height;
            }
            this.onRowsChanged(scrollTop);
        }
    };
    TreeView.prototype.onItemCollapsing = function (e) {
        var item = e.item;
        var viewItem = this.items[item.id];
        if (viewItem) {
            viewItem.expanded = false;
            this.onRemoveItems(new __WEBPACK_IMPORTED_MODULE_11__common_iterator_js__["c" /* MappedIterator */](item.getNavigator(), function (item) { return item && item.id; }));
            this.onRowsChanged();
        }
    };
    TreeView.prototype.onItemReveal = function (e) {
        var item = e.item;
        var relativeTop = e.relativeTop;
        var viewItem = this.items[item.id];
        if (viewItem) {
            if (relativeTop !== null) {
                relativeTop = relativeTop < 0 ? 0 : relativeTop;
                relativeTop = relativeTop > 1 ? 1 : relativeTop;
                // y = mx + b
                var m = viewItem.height - this.viewHeight;
                this.scrollTop = m * relativeTop + viewItem.top;
            }
            else {
                var viewItemBottom = viewItem.top + viewItem.height;
                var wrapperBottom = this.scrollTop + this.viewHeight;
                if (viewItem.top < this.scrollTop) {
                    this.scrollTop = viewItem.top;
                }
                else if (viewItemBottom >= wrapperBottom) {
                    this.scrollTop = viewItemBottom - this.viewHeight;
                }
            }
        }
    };
    TreeView.prototype.onItemAddTrait = function (e) {
        var item = e.item;
        var trait = e.trait;
        var viewItem = this.items[item.id];
        if (viewItem) {
            viewItem.addClass(trait);
        }
        if (trait === 'highlighted') {
            __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["f" /* addClass */](this.domNode, trait);
            // Ugly Firefox fix: input fields can't be selected if parent nodes are draggable
            if (viewItem) {
                this.highlightedItemWasDraggable = !!viewItem.draggable;
                if (viewItem.draggable) {
                    viewItem.draggable = false;
                }
            }
        }
    };
    TreeView.prototype.onItemRemoveTrait = function (e) {
        var item = e.item;
        var trait = e.trait;
        var viewItem = this.items[item.id];
        if (viewItem) {
            viewItem.removeClass(trait);
        }
        if (trait === 'highlighted') {
            __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["G" /* removeClass */](this.domNode, trait);
            // Ugly Firefox fix: input fields can't be selected if parent nodes are draggable
            if (this.highlightedItemWasDraggable) {
                viewItem.draggable = true;
            }
            this.highlightedItemWasDraggable = false;
        }
    };
    TreeView.prototype.onModelFocusChange = function () {
        var focus = this.model && this.model.getFocus();
        __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["N" /* toggleClass */](this.domNode, 'no-focused-item', !focus);
        // ARIA
        if (focus) {
            this.domNode.setAttribute('aria-activedescendant', __WEBPACK_IMPORTED_MODULE_7__common_strings_js__["safeBtoa"](this.context.dataSource.getId(this.context.tree, focus)));
        }
        else {
            this.domNode.removeAttribute('aria-activedescendant');
        }
    };
    // HeightMap "events"
    TreeView.prototype.onInsertItem = function (item) {
        var _this = this;
        item.onDragStart = function (e) { _this.onDragStart(item, e); };
        item.needsRender = true;
        this.refreshViewItem(item);
        this.items[item.id] = item;
    };
    TreeView.prototype.onRefreshItem = function (item, needsRender) {
        if (needsRender === void 0) { needsRender = false; }
        item.needsRender = item.needsRender || needsRender;
        this.refreshViewItem(item);
    };
    TreeView.prototype.onRemoveItem = function (item) {
        this.removeItemFromDOM(item);
        item.dispose();
        delete this.items[item.id];
    };
    // ViewItem refresh
    TreeView.prototype.refreshViewItem = function (item) {
        item.render();
        if (this.shouldBeRendered(item)) {
            this.insertItemInDOM(item);
        }
        else {
            this.removeItemFromDOM(item);
        }
    };
    // DOM Events
    TreeView.prototype.onClick = function (e) {
        if (this.lastPointerType && this.lastPointerType !== 'mouse') {
            return;
        }
        var event = new __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__["b" /* StandardMouseEvent */](e);
        var item = this.getItemAround(event.target);
        if (!item) {
            return;
        }
        if (__WEBPACK_IMPORTED_MODULE_1__browser_browser_js__["k" /* isIE */] && Date.now() - this.lastClickTimeStamp < 300) {
            // IE10+ doesn't set the detail property correctly. While IE10 simply
            // counts the number of clicks, IE11 reports always 1. To align with
            // other browser, we set the value to 2 if clicks events come in a 300ms
            // sequence.
            event.detail = 2;
        }
        this.lastClickTimeStamp = Date.now();
        this.context.controller.onClick(this.context.tree, item.model.getElement(), event);
    };
    TreeView.prototype.onMouseDown = function (e) {
        this.didJustPressContextMenuKey = false;
        if (!this.context.controller.onMouseDown) {
            return;
        }
        if (this.lastPointerType && this.lastPointerType !== 'mouse') {
            return;
        }
        var event = new __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__["b" /* StandardMouseEvent */](e);
        if (event.ctrlKey && __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["e" /* isNative */] && __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["d" /* isMacintosh */]) {
            return;
        }
        var item = this.getItemAround(event.target);
        if (!item) {
            return;
        }
        this.context.controller.onMouseDown(this.context.tree, item.model.getElement(), event);
    };
    TreeView.prototype.onMouseUp = function (e) {
        if (!this.context.controller.onMouseUp) {
            return;
        }
        if (this.lastPointerType && this.lastPointerType !== 'mouse') {
            return;
        }
        var event = new __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__["b" /* StandardMouseEvent */](e);
        if (event.ctrlKey && __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["e" /* isNative */] && __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["d" /* isMacintosh */]) {
            return;
        }
        var item = this.getItemAround(event.target);
        if (!item) {
            return;
        }
        this.context.controller.onMouseUp(this.context.tree, item.model.getElement(), event);
    };
    TreeView.prototype.onTap = function (e) {
        var item = this.getItemAround(e.initialTarget);
        if (!item) {
            return;
        }
        this.context.controller.onTap(this.context.tree, item.model.getElement(), e);
    };
    TreeView.prototype.onTouchChange = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.scrollTop -= event.translationY;
    };
    TreeView.prototype.onContextMenu = function (event) {
        var resultEvent;
        var element;
        if (event instanceof KeyboardEvent || this.didJustPressContextMenuKey) {
            this.didJustPressContextMenuKey = false;
            var keyboardEvent = new __WEBPACK_IMPORTED_MODULE_9__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](event);
            element = this.model.getFocus();
            var position;
            if (!element) {
                element = this.model.getInput();
                position = __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["u" /* getDomNodePagePosition */](this.inputItem.element);
            }
            else {
                var id = this.context.dataSource.getId(this.context.tree, element);
                var viewItem = this.items[id];
                position = __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["u" /* getDomNodePagePosition */](viewItem.element);
            }
            resultEvent = new __WEBPACK_IMPORTED_MODULE_15__tree_js__["c" /* KeyboardContextMenuEvent */](position.left + position.width, position.top, keyboardEvent);
        }
        else {
            var mouseEvent = new __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__["b" /* StandardMouseEvent */](event);
            var item = this.getItemAround(mouseEvent.target);
            if (!item) {
                return;
            }
            element = item.model.getElement();
            resultEvent = new __WEBPACK_IMPORTED_MODULE_15__tree_js__["d" /* MouseContextMenuEvent */](mouseEvent);
        }
        this.context.controller.onContextMenu(this.context.tree, element, resultEvent);
    };
    TreeView.prototype.onKeyDown = function (e) {
        var event = new __WEBPACK_IMPORTED_MODULE_9__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
        this.didJustPressContextMenuKey = event.keyCode === 58 /* ContextMenu */ || (event.shiftKey && event.keyCode === 68 /* F10 */);
        if (this.didJustPressContextMenuKey) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (event.target && event.target.tagName && event.target.tagName.toLowerCase() === 'input') {
            return; // Ignore event if target is a form input field (avoids browser specific issues)
        }
        this.context.controller.onKeyDown(this.context.tree, event);
    };
    TreeView.prototype.onKeyUp = function (e) {
        if (this.didJustPressContextMenuKey) {
            this.onContextMenu(e);
        }
        this.didJustPressContextMenuKey = false;
        this.context.controller.onKeyUp(this.context.tree, new __WEBPACK_IMPORTED_MODULE_9__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e));
    };
    TreeView.prototype.onDragStart = function (item, e) {
        if (this.model.getHighlight()) {
            return;
        }
        var element = item.model.getElement();
        var selection = this.model.getSelection();
        var elements;
        if (selection.indexOf(element) > -1) {
            elements = selection;
        }
        else {
            elements = [element];
        }
        e.dataTransfer.effectAllowed = 'copyMove';
        e.dataTransfer.setData(__WEBPACK_IMPORTED_MODULE_17__browser_dnd_js__["a" /* DataTransfers */].RESOURCES, JSON.stringify([item.uri]));
        if (e.dataTransfer.setDragImage) {
            var label = void 0;
            if (this.context.dnd.getDragLabel) {
                label = this.context.dnd.getDragLabel(this.context.tree, elements);
            }
            else {
                label = String(elements.length);
            }
            var dragImage_1 = document.createElement('div');
            dragImage_1.className = 'monaco-tree-drag-image';
            dragImage_1.textContent = label;
            document.body.appendChild(dragImage_1);
            e.dataTransfer.setDragImage(dragImage_1, -10, -10);
            setTimeout(function () { return document.body.removeChild(dragImage_1); }, 0);
        }
        this.currentDragAndDropData = new __WEBPACK_IMPORTED_MODULE_10__treeDnd_js__["b" /* ElementsDragAndDropData */](elements);
        TreeView.currentExternalDragAndDropData = new __WEBPACK_IMPORTED_MODULE_10__treeDnd_js__["c" /* ExternalElementsDragAndDropData */](elements);
        this.context.dnd.onDragStart(this.context.tree, this.currentDragAndDropData, new __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__["a" /* DragMouseEvent */](e));
    };
    TreeView.prototype.setupDragAndDropScrollInterval = function () {
        var _this = this;
        var viewTop = __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["w" /* getTopLeftOffset */](this.wrapper).top;
        if (!this.dragAndDropScrollInterval) {
            this.dragAndDropScrollInterval = window.setInterval(function () {
                if (_this.dragAndDropMouseY === undefined) {
                    return;
                }
                var diff = _this.dragAndDropMouseY - viewTop;
                var scrollDiff = 0;
                var upperLimit = _this.viewHeight - 35;
                if (diff < 35) {
                    scrollDiff = Math.max(-14, 0.2 * (diff - 35));
                }
                else if (diff > upperLimit) {
                    scrollDiff = Math.min(14, 0.2 * (diff - upperLimit));
                }
                _this.scrollTop += scrollDiff;
            }, 10);
            this.cancelDragAndDropScrollTimeout();
            this.dragAndDropScrollTimeout = window.setTimeout(function () {
                _this.cancelDragAndDropScrollInterval();
                _this.dragAndDropScrollTimeout = null;
            }, 1000);
        }
    };
    TreeView.prototype.cancelDragAndDropScrollInterval = function () {
        if (this.dragAndDropScrollInterval) {
            window.clearInterval(this.dragAndDropScrollInterval);
            this.dragAndDropScrollInterval = null;
        }
        this.cancelDragAndDropScrollTimeout();
    };
    TreeView.prototype.cancelDragAndDropScrollTimeout = function () {
        if (this.dragAndDropScrollTimeout) {
            window.clearTimeout(this.dragAndDropScrollTimeout);
            this.dragAndDropScrollTimeout = null;
        }
    };
    TreeView.prototype.onDragOver = function (e) {
        var _this = this;
        var event = new __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__["a" /* DragMouseEvent */](e);
        var viewItem = this.getItemAround(event.target);
        if (!viewItem || (event.posx === 0 && event.posy === 0 && event.browserEvent.type === __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["d" /* EventType */].DRAG_LEAVE)) {
            // dragging outside of tree
            if (this.currentDropTarget) {
                // clear previously hovered element feedback
                this.currentDropTargets.forEach(function (i) { return i.dropTarget = false; });
                this.currentDropTargets = [];
                if (this.currentDropPromise) {
                    this.currentDropPromise.cancel();
                    this.currentDropPromise = null;
                }
            }
            this.cancelDragAndDropScrollInterval();
            this.currentDropTarget = null;
            this.currentDropElement = null;
            this.dragAndDropMouseY = null;
            return false;
        }
        // dragging inside the tree
        this.setupDragAndDropScrollInterval();
        this.dragAndDropMouseY = event.posy;
        if (!this.currentDragAndDropData) {
            // just started dragging
            if (TreeView.currentExternalDragAndDropData) {
                this.currentDragAndDropData = TreeView.currentExternalDragAndDropData;
            }
            else {
                if (!event.dataTransfer.types) {
                    return false;
                }
                this.currentDragAndDropData = new __WEBPACK_IMPORTED_MODULE_10__treeDnd_js__["a" /* DesktopDragAndDropData */]();
            }
        }
        this.currentDragAndDropData.update(event);
        var element;
        var item = viewItem.model;
        var reaction;
        // check the bubble up behavior
        do {
            element = item ? item.getElement() : this.model.getInput();
            reaction = this.context.dnd.onDragOver(this.context.tree, this.currentDragAndDropData, element, event);
            if (!reaction || reaction.bubble !== __WEBPACK_IMPORTED_MODULE_15__tree_js__["a" /* DragOverBubble */].BUBBLE_UP) {
                break;
            }
            item = item && item.parent;
        } while (item);
        if (!item) {
            this.currentDropElement = null;
            return false;
        }
        var canDrop = reaction && reaction.accept;
        if (canDrop) {
            this.currentDropElement = item.getElement();
            event.preventDefault();
            event.dataTransfer.dropEffect = reaction.effect === __WEBPACK_IMPORTED_MODULE_15__tree_js__["b" /* DragOverEffect */].COPY ? 'copy' : 'move';
        }
        else {
            this.currentDropElement = null;
        }
        // item is the model item where drop() should be called
        // can be null
        var currentDropTarget = item.id === this.inputItem.id ? this.inputItem : this.items[item.id];
        if (this.shouldInvalidateDropReaction || this.currentDropTarget !== currentDropTarget || !reactionEquals(this.currentDropElementReaction, reaction)) {
            this.shouldInvalidateDropReaction = false;
            if (this.currentDropTarget) {
                this.currentDropTargets.forEach(function (i) { return i.dropTarget = false; });
                this.currentDropTargets = [];
                if (this.currentDropPromise) {
                    this.currentDropPromise.cancel();
                    this.currentDropPromise = null;
                }
            }
            this.currentDropTarget = currentDropTarget;
            this.currentDropElementReaction = reaction;
            if (canDrop) {
                // setup hover feedback for drop target
                if (this.currentDropTarget) {
                    this.currentDropTarget.dropTarget = true;
                    this.currentDropTargets.push(this.currentDropTarget);
                }
                if (reaction.bubble === __WEBPACK_IMPORTED_MODULE_15__tree_js__["a" /* DragOverBubble */].BUBBLE_DOWN) {
                    var nav = item.getNavigator();
                    var child;
                    while (child = nav.next()) {
                        viewItem = this.items[child.id];
                        if (viewItem) {
                            viewItem.dropTarget = true;
                            this.currentDropTargets.push(viewItem);
                        }
                    }
                }
                if (reaction.autoExpand) {
                    this.currentDropPromise = __WEBPACK_IMPORTED_MODULE_2__common_winjs_base_js__["b" /* TPromise */].timeout(500)
                        .then(function () { return _this.context.tree.expand(_this.currentDropElement); })
                        .then(function () { return _this.shouldInvalidateDropReaction = true; });
                }
            }
        }
        return true;
    };
    TreeView.prototype.onDrop = function (e) {
        if (this.currentDropElement) {
            var event = new __WEBPACK_IMPORTED_MODULE_8__browser_mouseEvent_js__["a" /* DragMouseEvent */](e);
            event.preventDefault();
            this.currentDragAndDropData.update(event);
            this.context.dnd.drop(this.context.tree, this.currentDragAndDropData, this.currentDropElement, event);
            this.onDragEnd(e);
        }
        this.cancelDragAndDropScrollInterval();
    };
    TreeView.prototype.onDragEnd = function (e) {
        if (this.currentDropTarget) {
            this.currentDropTargets.forEach(function (i) { return i.dropTarget = false; });
            this.currentDropTargets = [];
        }
        if (this.currentDropPromise) {
            this.currentDropPromise.cancel();
            this.currentDropPromise = null;
        }
        this.cancelDragAndDropScrollInterval();
        this.currentDragAndDropData = null;
        TreeView.currentExternalDragAndDropData = null;
        this.currentDropElement = null;
        this.currentDropTarget = null;
        this.dragAndDropMouseY = null;
    };
    TreeView.prototype.onFocus = function () {
        if (!this.context.options.alwaysFocused) {
            __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["f" /* addClass */](this.domNode, 'focused');
        }
        this._onDOMFocus.fire();
    };
    TreeView.prototype.onBlur = function () {
        if (!this.context.options.alwaysFocused) {
            __WEBPACK_IMPORTED_MODULE_4__browser_dom_js__["G" /* removeClass */](this.domNode, 'focused');
        }
        this.domNode.removeAttribute('aria-activedescendant'); // ARIA
        this._onDOMBlur.fire();
    };
    // MS specific DOM Events
    TreeView.prototype.onMsPointerDown = function (event) {
        if (!this.msGesture) {
            return;
        }
        // Circumvent IE11 breaking change in e.pointerType & TypeScript's stale definitions
        var pointerType = event.pointerType;
        if (pointerType === (event.MSPOINTER_TYPE_MOUSE || 'mouse')) {
            this.lastPointerType = 'mouse';
            return;
        }
        else if (pointerType === (event.MSPOINTER_TYPE_TOUCH || 'touch')) {
            this.lastPointerType = 'touch';
        }
        else {
            return;
        }
        event.stopPropagation();
        event.preventDefault();
        this.msGesture.addPointer(event.pointerId);
    };
    TreeView.prototype.onThrottledMsGestureChange = function (event) {
        this.scrollTop -= event.translationY;
    };
    TreeView.prototype.onMsGestureTap = function (event) {
        event.initialTarget = document.elementFromPoint(event.clientX, event.clientY);
        this.onTap(event);
    };
    // DOM changes
    TreeView.prototype.insertItemInDOM = function (item) {
        var elementAfter = null;
        var itemAfter = this.itemAfter(item);
        if (itemAfter && itemAfter.element) {
            elementAfter = itemAfter.element;
        }
        item.insertInDOM(this.rowsContainer, elementAfter);
    };
    TreeView.prototype.removeItemFromDOM = function (item) {
        if (!item) {
            return;
        }
        item.removeFromDOM();
    };
    // Helpers
    TreeView.prototype.shouldBeRendered = function (item) {
        return item.top < this.lastRenderTop + this.lastRenderHeight && item.top + item.height > this.lastRenderTop;
    };
    TreeView.prototype.getItemAround = function (element) {
        var candidate = this.inputItem;
        do {
            if (element[TreeView.BINDING]) {
                candidate = element[TreeView.BINDING];
            }
            if (element === this.wrapper || element === this.domNode) {
                return candidate;
            }
            if (element === document.body) {
                return null;
            }
        } while (element = element.parentElement);
        return undefined;
    };
    // Cleanup
    TreeView.prototype.releaseModel = function () {
        if (this.model) {
            this.modelListeners = __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */](this.modelListeners);
            this.model = null;
        }
    };
    TreeView.prototype.dispose = function () {
        var _this = this;
        // TODO@joao: improve
        this.scrollableElement.dispose();
        this.releaseModel();
        this.modelListeners = null;
        this.viewListeners = __WEBPACK_IMPORTED_MODULE_3__common_lifecycle_js__["d" /* dispose */](this.viewListeners);
        this._onDOMFocus.dispose();
        this._onDOMBlur.dispose();
        if (this.domNode.parentNode) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.domNode = null;
        if (this.items) {
            Object.keys(this.items).forEach(function (key) { return _this.items[key].removeFromDOM(); });
            this.items = null;
        }
        if (this.context.cache) {
            this.context.cache.dispose();
            this.context.cache = null;
        }
        _super.prototype.dispose.call(this);
    };
    TreeView.BINDING = 'monaco-tree-row';
    TreeView.LOADING_DECORATION_DELAY = 800;
    TreeView.counter = 0;
    TreeView.currentExternalDragAndDropData = null;
    return TreeView;
}(__WEBPACK_IMPORTED_MODULE_14__treeViewModel_js__["a" /* HeightMap */]));



/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiffChange; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * Represents information about a specific difference between two sequences.
 */
var DiffChange = /** @class */ (function () {
    /**
     * Constructs a new DiffChange with the given sequence information
     * and content.
     */
    function DiffChange(originalStart, originalLength, modifiedStart, modifiedLength) {
        //Debug.Assert(originalLength > 0 || modifiedLength > 0, "originalLength and modifiedLength cannot both be <= 0");
        this.originalStart = originalStart;
        this.originalLength = originalLength;
        this.modifiedStart = modifiedStart;
        this.modifiedLength = modifiedLength;
    }
    /**
     * The end point (exclusive) of the change in the original sequence.
     */
    DiffChange.prototype.getOriginalEnd = function () {
        return this.originalStart + this.originalLength;
    };
    /**
     * The end point (exclusive) of the change in the modified sequence.
     */
    DiffChange.prototype.getModifiedEnd = function () {
        return this.modifiedStart + this.modifiedLength;
    };
    return DiffChange;
}());



/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ElementsDragAndDropData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ExternalElementsDragAndDropData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DesktopDragAndDropData; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var ElementsDragAndDropData = /** @class */ (function () {
    function ElementsDragAndDropData(elements) {
        this.elements = elements;
    }
    ElementsDragAndDropData.prototype.update = function (event) {
        // no-op
    };
    return ElementsDragAndDropData;
}());

var ExternalElementsDragAndDropData = /** @class */ (function () {
    function ExternalElementsDragAndDropData(elements) {
        this.elements = elements;
    }
    ExternalElementsDragAndDropData.prototype.update = function (event) {
        // no-op
    };
    return ExternalElementsDragAndDropData;
}());

var DesktopDragAndDropData = /** @class */ (function () {
    function DesktopDragAndDropData() {
        this.types = [];
        this.files = [];
    }
    DesktopDragAndDropData.prototype.update = function (event) {
        if (event.dataTransfer.types) {
            this.types = [];
            Array.prototype.push.apply(this.types, event.dataTransfer.types);
        }
        if (event.dataTransfer.files) {
            this.files = [];
            Array.prototype.push.apply(this.files, event.dataTransfer.files);
            this.files = this.files.filter(function (f) { return f.size || f.type; });
        }
    };
    return DesktopDragAndDropData;
}());



/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeightMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_iterator_js__ = __webpack_require__(139);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var HeightMap = /** @class */ (function () {
    function HeightMap() {
        this.heightMap = [];
        this.indexes = {};
    }
    HeightMap.prototype.getContentHeight = function () {
        var last = this.heightMap[this.heightMap.length - 1];
        return !last ? 0 : last.top + last.height;
    };
    HeightMap.prototype.onInsertItems = function (iterator, afterItemId) {
        if (afterItemId === void 0) { afterItemId = null; }
        var item;
        var viewItem;
        var i, j;
        var totalSize;
        var sizeDiff = 0;
        if (afterItemId === null) {
            i = 0;
            totalSize = 0;
        }
        else {
            i = this.indexes[afterItemId] + 1;
            viewItem = this.heightMap[i - 1];
            if (!viewItem) {
                console.error('view item doesnt exist');
                return undefined;
            }
            totalSize = viewItem.top + viewItem.height;
        }
        var boundSplice = this.heightMap.splice.bind(this.heightMap, i, 0);
        var itemsToInsert = [];
        while (item = iterator.next()) {
            viewItem = this.createViewItem(item);
            viewItem.top = totalSize + sizeDiff;
            this.indexes[item.id] = i++;
            itemsToInsert.push(viewItem);
            sizeDiff += viewItem.height;
        }
        boundSplice.apply(this.heightMap, itemsToInsert);
        for (j = i; j < this.heightMap.length; j++) {
            viewItem = this.heightMap[j];
            viewItem.top += sizeDiff;
            this.indexes[viewItem.model.id] = j;
        }
        for (j = itemsToInsert.length - 1; j >= 0; j--) {
            this.onInsertItem(itemsToInsert[j]);
        }
        for (j = this.heightMap.length - 1; j >= i; j--) {
            this.onRefreshItem(this.heightMap[j]);
        }
        return sizeDiff;
    };
    HeightMap.prototype.onInsertItem = function (item) {
        // noop
    };
    // Contiguous items
    HeightMap.prototype.onRemoveItems = function (iterator) {
        var itemId;
        var viewItem;
        var startIndex = null;
        var i;
        var sizeDiff = 0;
        while (itemId = iterator.next()) {
            i = this.indexes[itemId];
            viewItem = this.heightMap[i];
            if (!viewItem) {
                console.error('view item doesnt exist');
                return;
            }
            sizeDiff -= viewItem.height;
            delete this.indexes[itemId];
            this.onRemoveItem(viewItem);
            if (startIndex === null) {
                startIndex = i;
            }
        }
        if (sizeDiff === 0) {
            return;
        }
        this.heightMap.splice(startIndex, i - startIndex + 1);
        for (i = startIndex; i < this.heightMap.length; i++) {
            viewItem = this.heightMap[i];
            viewItem.top += sizeDiff;
            this.indexes[viewItem.model.id] = i;
            this.onRefreshItem(viewItem);
        }
    };
    HeightMap.prototype.onRemoveItem = function (item) {
        // noop
    };
    HeightMap.prototype.onRefreshItemSet = function (items) {
        var _this = this;
        var sortedItems = items.sort(function (a, b) { return _this.indexes[a.id] - _this.indexes[b.id]; });
        this.onRefreshItems(new __WEBPACK_IMPORTED_MODULE_0__common_iterator_js__["a" /* ArrayIterator */](sortedItems));
    };
    // Ordered, but not necessarily contiguous items
    HeightMap.prototype.onRefreshItems = function (iterator) {
        var item;
        var viewItem;
        var newHeight;
        var i, j = null;
        var cummDiff = 0;
        while (item = iterator.next()) {
            i = this.indexes[item.id];
            for (; cummDiff !== 0 && j !== null && j < i; j++) {
                viewItem = this.heightMap[j];
                viewItem.top += cummDiff;
                this.onRefreshItem(viewItem);
            }
            viewItem = this.heightMap[i];
            newHeight = item.getHeight();
            viewItem.top += cummDiff;
            cummDiff += newHeight - viewItem.height;
            viewItem.height = newHeight;
            this.onRefreshItem(viewItem, true);
            j = i + 1;
        }
        if (cummDiff !== 0 && j !== null) {
            for (; j < this.heightMap.length; j++) {
                viewItem = this.heightMap[j];
                viewItem.top += cummDiff;
                this.onRefreshItem(viewItem);
            }
        }
    };
    HeightMap.prototype.onRefreshItem = function (item, needsRender) {
        if (needsRender === void 0) { needsRender = false; }
        // noop
    };
    HeightMap.prototype.indexAt = function (position) {
        var left = 0;
        var right = this.heightMap.length;
        var center;
        var item;
        // Binary search
        while (left < right) {
            center = Math.floor((left + right) / 2);
            item = this.heightMap[center];
            if (position < item.top) {
                right = center;
            }
            else if (position >= item.top + item.height) {
                if (left === center) {
                    break;
                }
                left = center;
            }
            else {
                return center;
            }
        }
        return this.heightMap.length;
    };
    HeightMap.prototype.indexAfter = function (position) {
        return Math.min(this.indexAt(position) + 1, this.heightMap.length);
    };
    HeightMap.prototype.itemAtIndex = function (index) {
        return this.heightMap[index];
    };
    HeightMap.prototype.itemAfter = function (item) {
        return this.heightMap[this.indexes[item.model.id] + 1] || null;
    };
    HeightMap.prototype.createViewItem = function (item) {
        throw new Error('not implemented');
    };
    HeightMap.prototype.dispose = function () {
        this.heightMap = null;
        this.indexes = null;
    };
    return HeightMap;
}());



/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContextMenuEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MouseContextMenuEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KeyboardContextMenuEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DragOverEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragOverBubble; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ContextMenuEvent = /** @class */ (function () {
    function ContextMenuEvent(posx, posy, target) {
        this._posx = posx;
        this._posy = posy;
        this._target = target;
    }
    ContextMenuEvent.prototype.preventDefault = function () {
        // no-op
    };
    ContextMenuEvent.prototype.stopPropagation = function () {
        // no-op
    };
    Object.defineProperty(ContextMenuEvent.prototype, "target", {
        get: function () {
            return this._target;
        },
        enumerable: true,
        configurable: true
    });
    return ContextMenuEvent;
}());

var MouseContextMenuEvent = /** @class */ (function (_super) {
    __extends(MouseContextMenuEvent, _super);
    function MouseContextMenuEvent(originalEvent) {
        var _this = _super.call(this, originalEvent.posx, originalEvent.posy, originalEvent.target) || this;
        _this.originalEvent = originalEvent;
        return _this;
    }
    MouseContextMenuEvent.prototype.preventDefault = function () {
        this.originalEvent.preventDefault();
    };
    MouseContextMenuEvent.prototype.stopPropagation = function () {
        this.originalEvent.stopPropagation();
    };
    return MouseContextMenuEvent;
}(ContextMenuEvent));

var KeyboardContextMenuEvent = /** @class */ (function (_super) {
    __extends(KeyboardContextMenuEvent, _super);
    function KeyboardContextMenuEvent(posx, posy, originalEvent) {
        var _this = _super.call(this, posx, posy, originalEvent.target) || this;
        _this.originalEvent = originalEvent;
        return _this;
    }
    KeyboardContextMenuEvent.prototype.preventDefault = function () {
        this.originalEvent.preventDefault();
    };
    KeyboardContextMenuEvent.prototype.stopPropagation = function () {
        this.originalEvent.stopPropagation();
    };
    return KeyboardContextMenuEvent;
}(ContextMenuEvent));

var DragOverEffect;
(function (DragOverEffect) {
    DragOverEffect[DragOverEffect["COPY"] = 0] = "COPY";
    DragOverEffect[DragOverEffect["MOVE"] = 1] = "MOVE";
})(DragOverEffect || (DragOverEffect = {}));
var DragOverBubble;
(function (DragOverBubble) {
    DragOverBubble[DragOverBubble["BUBBLE_DOWN"] = 0] = "BUBBLE_DOWN";
    DragOverBubble[DragOverBubble["BUBBLE_UP"] = 1] = "BUBBLE_UP";
})(DragOverBubble || (DragOverBubble = {}));


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataTransfers; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// Common data transfers
var DataTransfers = {
    /**
     * Application specific resource transfer type
     */
    RESOURCES: 'ResourceURLs',
    /**
     * Browser specific transfer type to download
     */
    DOWNLOAD_URL: 'DownloadURL',
    /**
     * Browser specific transfer type for files
     */
    FILES: 'Files',
    /**
     * Typicaly transfer type for copy/paste transfers.
     */
    TEXT: 'text/plain'
};


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkerNavigationWidget; });
/* unused harmony export editorMarkerNavigationError */
/* unused harmony export editorMarkerNavigationWarning */
/* unused harmony export editorMarkerNavigationInfo */
/* unused harmony export editorMarkerNavigationBackground */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gotoErrorWidget_css__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gotoErrorWidget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gotoErrorWidget_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zoneWidget_zoneWidget_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_browser_ui_scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_common_labels_js__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var MessageWidget = /** @class */ (function () {
    function MessageWidget(parent, editor, onRelatedInformation) {
        var _this = this;
        this._lines = 0;
        this._longestLineLength = 0;
        this._relatedDiagnostics = new WeakMap();
        this._disposables = [];
        this._editor = editor;
        var domNode = document.createElement('div');
        domNode.className = 'descriptioncontainer';
        domNode.setAttribute('aria-live', 'assertive');
        domNode.setAttribute('role', 'alert');
        this._messageBlock = document.createElement('div');
        domNode.appendChild(this._messageBlock);
        this._relatedBlock = document.createElement('div');
        domNode.appendChild(this._relatedBlock);
        this._disposables.push(__WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["j" /* addStandardDisposableListener */](this._relatedBlock, 'click', function (event) {
            event.preventDefault();
            var related = _this._relatedDiagnostics.get(event.target);
            if (related) {
                onRelatedInformation(related);
            }
        }));
        this._scrollable = new __WEBPACK_IMPORTED_MODULE_10__base_browser_ui_scrollbar_scrollableElement_js__["b" /* ScrollableElement */](domNode, {
            horizontal: __WEBPACK_IMPORTED_MODULE_11__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Auto,
            vertical: __WEBPACK_IMPORTED_MODULE_11__base_common_scrollable_js__["b" /* ScrollbarVisibility */].Auto,
            useShadows: false,
            horizontalScrollbarSize: 3,
            verticalScrollbarSize: 3
        });
        __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["f" /* addClass */](this._scrollable.getDomNode(), 'block');
        parent.appendChild(this._scrollable.getDomNode());
        this._disposables.push(this._scrollable.onScroll(function (e) {
            domNode.style.left = "-" + e.scrollLeft + "px";
            domNode.style.top = "-" + e.scrollTop + "px";
        }));
        this._disposables.push(this._scrollable);
    }
    MessageWidget.prototype.dispose = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
    };
    MessageWidget.prototype.update = function (_a) {
        var source = _a.source, message = _a.message, relatedInformation = _a.relatedInformation;
        if (source) {
            this._lines = 0;
            this._longestLineLength = 0;
            var indent = new Array(source.length + 3 + 1).join(' ');
            var lines = message.split(/\r\n|\r|\n/g);
            for (var i = 0; i < lines.length; i++) {
                var line = lines[i];
                this._lines += 1;
                this._longestLineLength = Math.max(line.length, this._longestLineLength);
                if (i === 0) {
                    message = "[" + source + "] " + line;
                }
                else {
                    message += "\n" + indent + line;
                }
            }
        }
        else {
            this._lines = 1;
            this._longestLineLength = message.length;
        }
        __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["l" /* clearNode */](this._relatedBlock);
        if (!Object(__WEBPACK_IMPORTED_MODULE_13__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(relatedInformation)) {
            this._relatedBlock.style.paddingTop = Math.floor(this._editor.getConfiguration().lineHeight * .66) + "px";
            this._lines += 1;
            for (var _i = 0, relatedInformation_1 = relatedInformation; _i < relatedInformation_1.length; _i++) {
                var related = relatedInformation_1[_i];
                var container = document.createElement('div');
                var relatedResource = document.createElement('span');
                __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["f" /* addClass */](relatedResource, 'filename');
                relatedResource.innerHTML = Object(__WEBPACK_IMPORTED_MODULE_12__base_common_labels_js__["a" /* getBaseLabel */])(related.resource) + "(" + related.startLineNumber + ", " + related.startColumn + "): ";
                relatedResource.title = Object(__WEBPACK_IMPORTED_MODULE_12__base_common_labels_js__["b" /* getPathLabel */])(related.resource, undefined);
                this._relatedDiagnostics.set(relatedResource, related);
                var relatedMessage = document.createElement('span');
                relatedMessage.innerText = related.message;
                this._editor.applyFontInfo(relatedMessage);
                container.appendChild(relatedResource);
                container.appendChild(relatedMessage);
                this._lines += 1;
                this._relatedBlock.appendChild(container);
            }
        }
        this._messageBlock.innerText = message;
        this._editor.applyFontInfo(this._messageBlock);
        var fontInfo = this._editor.getConfiguration().fontInfo;
        var scrollWidth = Math.ceil(fontInfo.typicalFullwidthCharacterWidth * this._longestLineLength * 0.75);
        var scrollHeight = fontInfo.lineHeight * this._lines;
        this._scrollable.setScrollDimensions({ scrollWidth: scrollWidth, scrollHeight: scrollHeight });
    };
    MessageWidget.prototype.layout = function (height, width) {
        this._scrollable.getDomNode().style.height = height + "px";
        this._scrollable.setScrollDimensions({ width: width, height: height });
    };
    MessageWidget.prototype.getHeightInLines = function () {
        return Math.min(17, this._lines);
    };
    return MessageWidget;
}());
var MarkerNavigationWidget = /** @class */ (function (_super) {
    __extends(MarkerNavigationWidget, _super);
    function MarkerNavigationWidget(editor, _themeService) {
        var _this = _super.call(this, editor, { showArrow: true, showFrame: true, isAccessible: true }) || this;
        _this._themeService = _themeService;
        _this._callOnDispose = [];
        _this._onDidSelectRelatedInformation = new __WEBPACK_IMPORTED_MODULE_14__base_common_event_js__["a" /* Emitter */]();
        _this.onDidSelectRelatedInformation = _this._onDidSelectRelatedInformation.event;
        _this._severity = __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Warning;
        _this._backgroundColor = __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].white;
        _this._applyTheme(_themeService.getTheme());
        _this._callOnDispose.push(_themeService.onThemeChange(_this._applyTheme.bind(_this)));
        _this.create();
        return _this;
    }
    MarkerNavigationWidget.prototype._applyTheme = function (theme) {
        this._backgroundColor = theme.getColor(editorMarkerNavigationBackground);
        var colorId = editorMarkerNavigationError;
        if (this._severity === __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Warning) {
            colorId = editorMarkerNavigationWarning;
        }
        else if (this._severity === __WEBPACK_IMPORTED_MODULE_4__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Info) {
            colorId = editorMarkerNavigationInfo;
        }
        var frameColor = theme.getColor(colorId);
        this.style({
            arrowColor: frameColor,
            frameColor: frameColor
        }); // style() will trigger _applyStyles
    };
    MarkerNavigationWidget.prototype._applyStyles = function () {
        if (this._parentContainer) {
            this._parentContainer.style.backgroundColor = this._backgroundColor.toString();
        }
        _super.prototype._applyStyles.call(this);
    };
    MarkerNavigationWidget.prototype.dispose = function () {
        this._callOnDispose = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_lifecycle_js__["d" /* dispose */])(this._callOnDispose);
        _super.prototype.dispose.call(this);
    };
    MarkerNavigationWidget.prototype.focus = function () {
        this._parentContainer.focus();
    };
    MarkerNavigationWidget.prototype._fillContainer = function (container) {
        var _this = this;
        this._parentContainer = container;
        __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["f" /* addClass */](container, 'marker-widget');
        this._parentContainer.tabIndex = 0;
        this._parentContainer.setAttribute('role', 'tooltip');
        this._container = document.createElement('div');
        container.appendChild(this._container);
        this._title = document.createElement('div');
        this._title.className = 'block title';
        this._container.appendChild(this._title);
        this._message = new MessageWidget(this._container, this.editor, function (related) { return _this._onDidSelectRelatedInformation.fire(related); });
        this._disposables.push(this._message);
    };
    MarkerNavigationWidget.prototype.show = function (where, heightInLines) {
        throw new Error('call showAtMarker');
    };
    MarkerNavigationWidget.prototype.showAtMarker = function (marker, markerIdx, markerCount) {
        // update:
        // * title
        // * message
        this._container.classList.remove('stale');
        this._title.innerHTML = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('title.wo_source', "({0}/{1})", markerIdx, markerCount);
        this._message.update(marker);
        // update frame color (only applied on 'show')
        this._severity = marker.severity;
        this._applyTheme(this._themeService.getTheme());
        // show
        var range = __WEBPACK_IMPORTED_MODULE_5__common_core_range_js__["a" /* Range */].lift(marker);
        var position = range.containsPosition(this.editor.getPosition()) ? this.editor.getPosition() : range.getStartPosition();
        _super.prototype.show.call(this, position, this.computeRequiredHeight());
        this.editor.revealPositionInCenter(position, 0 /* Smooth */);
        if (this.editor.getConfiguration().accessibilitySupport !== 1 /* Disabled */) {
            this.focus();
        }
    };
    MarkerNavigationWidget.prototype.updateMarker = function (marker) {
        this._container.classList.remove('stale');
        this._message.update(marker);
    };
    MarkerNavigationWidget.prototype.showStale = function () {
        this._container.classList.add('stale');
        this._relayout();
    };
    MarkerNavigationWidget.prototype._doLayout = function (heightInPixel, widthInPixel) {
        this._message.layout(heightInPixel, widthInPixel);
        this._container.style.height = heightInPixel + "px";
    };
    MarkerNavigationWidget.prototype._relayout = function () {
        _super.prototype._relayout.call(this, this.computeRequiredHeight());
    };
    MarkerNavigationWidget.prototype.computeRequiredHeight = function () {
        return 1 + this._message.getHeightInLines();
    };
    return MarkerNavigationWidget;
}(__WEBPACK_IMPORTED_MODULE_6__zoneWidget_zoneWidget_js__["a" /* ZoneWidget */]));

// theming
var errorDefault = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_4" /* oneOf */])(__WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["i" /* editorErrorForeground */], __WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["h" /* editorErrorBorder */]);
var warningDefault = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_4" /* oneOf */])(__WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["w" /* editorWarningForeground */], __WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["v" /* editorWarningBorder */]);
var infoDefault = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_4" /* oneOf */])(__WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["n" /* editorInfoForeground */], __WEBPACK_IMPORTED_MODULE_9__common_view_editorColorRegistry_js__["m" /* editorInfoBorder */]);
var editorMarkerNavigationError = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorMarkerNavigationError.background', { dark: errorDefault, light: errorDefault, hc: errorDefault }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorMarkerNavigationError', 'Editor marker navigation widget error color.'));
var editorMarkerNavigationWarning = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorMarkerNavigationWarning.background', { dark: warningDefault, light: warningDefault, hc: warningDefault }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorMarkerNavigationWarning', 'Editor marker navigation widget warning color.'));
var editorMarkerNavigationInfo = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorMarkerNavigationInfo.background', { dark: infoDefault, light: infoDefault, hc: infoDefault }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorMarkerNavigationInfo', 'Editor marker navigation widget info color.'));
var editorMarkerNavigationBackground = Object(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorMarkerNavigation.background', { dark: '#2D2D30', light: __WEBPACK_IMPORTED_MODULE_8__base_common_color_js__["a" /* Color */].white, hc: '#0C141F' }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorMarkerNavigationBackground', 'Editor marker navigation widget background.'));


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeybindingLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keybindingLabel_css__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keybindingLabel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__keybindingLabel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_keybindingLabels_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var $ = __WEBPACK_IMPORTED_MODULE_3__dom_js__["a" /* $ */];
var KeybindingLabel = /** @class */ (function () {
    function KeybindingLabel(container, os) {
        this.os = os;
        this.domNode = __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](container, $('.monaco-keybinding'));
        this.didEverRender = false;
        container.appendChild(this.domNode);
    }
    KeybindingLabel.prototype.set = function (keybinding, matches) {
        if (this.didEverRender && this.keybinding === keybinding && KeybindingLabel.areSame(this.matches, matches)) {
            return;
        }
        this.keybinding = keybinding;
        this.matches = matches;
        this.render();
    };
    KeybindingLabel.prototype.render = function () {
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["l" /* clearNode */](this.domNode);
        if (this.keybinding) {
            var _a = this.keybinding.getParts(), firstPart = _a[0], chordPart = _a[1];
            if (firstPart) {
                this.renderPart(this.domNode, firstPart, this.matches ? this.matches.firstPart : null);
            }
            if (chordPart) {
                __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](this.domNode, $('span.monaco-keybinding-key-chord-separator', null, ' '));
                this.renderPart(this.domNode, chordPart, this.matches ? this.matches.chordPart : null);
            }
            this.domNode.title = this.keybinding.getAriaLabel();
        }
        this.didEverRender = true;
    };
    KeybindingLabel.prototype.renderPart = function (parent, part, match) {
        var modifierLabels = __WEBPACK_IMPORTED_MODULE_2__common_keybindingLabels_js__["b" /* UILabelProvider */].modifierLabels[this.os];
        if (part.ctrlKey) {
            this.renderKey(parent, modifierLabels.ctrlKey, match && match.ctrlKey, modifierLabels.separator);
        }
        if (part.shiftKey) {
            this.renderKey(parent, modifierLabels.shiftKey, match && match.shiftKey, modifierLabels.separator);
        }
        if (part.altKey) {
            this.renderKey(parent, modifierLabels.altKey, match && match.altKey, modifierLabels.separator);
        }
        if (part.metaKey) {
            this.renderKey(parent, modifierLabels.metaKey, match && match.metaKey, modifierLabels.separator);
        }
        var keyLabel = part.keyLabel;
        if (keyLabel) {
            this.renderKey(parent, keyLabel, match && match.keyCode, '');
        }
    };
    KeybindingLabel.prototype.renderKey = function (parent, label, highlight, separator) {
        __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](parent, $('span.monaco-keybinding-key' + (highlight ? '.highlight' : ''), null, label));
        if (separator) {
            __WEBPACK_IMPORTED_MODULE_3__dom_js__["k" /* append */](parent, $('span.monaco-keybinding-key-separator', null, separator));
        }
    };
    KeybindingLabel.prototype.dispose = function () {
        this.keybinding = null;
    };
    KeybindingLabel.areSame = function (a, b) {
        if (a === b || (!a && !b)) {
            return true;
        }
        return !!a && !!b && Object(__WEBPACK_IMPORTED_MODULE_1__common_objects_js__["e" /* equals */])(a.firstPart, b.firstPart) && Object(__WEBPACK_IMPORTED_MODULE_1__common_objects_js__["e" /* equals */])(a.chordPart, b.chordPart);
    };
    return KeybindingLabel;
}());



/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickOpenEditorWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_parts_quickopen_browser_quickOpenWidget_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_theme_common_styler_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var QuickOpenEditorWidget = /** @class */ (function () {
    function QuickOpenEditorWidget(codeEditor, onOk, onCancel, onType, configuration, themeService) {
        this.codeEditor = codeEditor;
        this.themeService = themeService;
        this.create(onOk, onCancel, onType, configuration);
    }
    QuickOpenEditorWidget.prototype.create = function (onOk, onCancel, onType, configuration) {
        this.domNode = document.createElement('div');
        this.quickOpenWidget = new __WEBPACK_IMPORTED_MODULE_0__base_parts_quickopen_browser_quickOpenWidget_js__["a" /* QuickOpenWidget */](this.domNode, {
            onOk: onOk,
            onCancel: onCancel,
            onType: onType
        }, {
            inputPlaceHolder: null,
            inputAriaLabel: configuration.inputAriaLabel,
            keyboardSupport: true
        });
        this.styler = Object(__WEBPACK_IMPORTED_MODULE_2__platform_theme_common_styler_js__["c" /* attachQuickOpenStyler */])(this.quickOpenWidget, this.themeService, {
            pickerGroupForeground: __WEBPACK_IMPORTED_MODULE_3__platform_theme_common_colorRegistry_js__["I" /* foreground */]
        });
        this.quickOpenWidget.create();
        this.codeEditor.addOverlayWidget(this);
    };
    QuickOpenEditorWidget.prototype.setInput = function (model, focus) {
        this.quickOpenWidget.setInput(model, focus);
    };
    QuickOpenEditorWidget.prototype.getId = function () {
        return QuickOpenEditorWidget.ID;
    };
    QuickOpenEditorWidget.prototype.getDomNode = function () {
        return this.domNode;
    };
    QuickOpenEditorWidget.prototype.destroy = function () {
        this.codeEditor.removeOverlayWidget(this);
        this.quickOpenWidget.dispose();
        this.styler.dispose();
    };
    QuickOpenEditorWidget.prototype.show = function (value) {
        this.visible = true;
        var editorLayout = this.codeEditor.getLayoutInfo();
        if (editorLayout) {
            this.quickOpenWidget.layout(new __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["b" /* Dimension */](editorLayout.width, editorLayout.height));
        }
        this.quickOpenWidget.show(value);
        this.codeEditor.layoutOverlayWidget(this);
    };
    QuickOpenEditorWidget.prototype.getPosition = function () {
        if (this.visible) {
            return {
                preference: __WEBPACK_IMPORTED_MODULE_1__browser_editorBrowser_js__["c" /* OverlayWidgetPositionPreference */].TOP_CENTER
            };
        }
        return null;
    };
    QuickOpenEditorWidget.ID = 'editor.contrib.quickOpenEditorWidget';
    return QuickOpenEditorWidget;
}());



/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuickOpenController */
/* unused harmony export HideReason */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickOpenWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quickopen_css__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quickopen_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__quickopen_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_quickOpen_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__quickOpenViewer_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__browser_builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__browser_ui_inputbox_inputBox_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tree_browser_treeImpl_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__browser_ui_progressbar_progressbar_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__browser_keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tree_browser_treeDefaults_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__browser_mouseEvent_js__ = __webpack_require__(37);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















var QuickOpenController = /** @class */ (function (_super) {
    __extends(QuickOpenController, _super);
    function QuickOpenController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuickOpenController.prototype.onContextMenu = function (tree, element, event) {
        if (__WEBPACK_IMPORTED_MODULE_3__common_platform_js__["d" /* isMacintosh */]) {
            return this.onLeftClick(tree, element, event); // https://github.com/Microsoft/vscode/issues/1011
        }
        return _super.prototype.onContextMenu.call(this, tree, element, event);
    };
    return QuickOpenController;
}(__WEBPACK_IMPORTED_MODULE_13__tree_browser_treeDefaults_js__["c" /* DefaultController */]));

var HideReason;
(function (HideReason) {
    HideReason[HideReason["ELEMENT_SELECTED"] = 0] = "ELEMENT_SELECTED";
    HideReason[HideReason["FOCUS_LOST"] = 1] = "FOCUS_LOST";
    HideReason[HideReason["CANCELED"] = 2] = "CANCELED";
})(HideReason || (HideReason = {}));
var defaultStyles = {
    background: __WEBPACK_IMPORTED_MODULE_17__common_color_js__["a" /* Color */].fromHex('#1E1E1E'),
    foreground: __WEBPACK_IMPORTED_MODULE_17__common_color_js__["a" /* Color */].fromHex('#CCCCCC'),
    pickerGroupForeground: __WEBPACK_IMPORTED_MODULE_17__common_color_js__["a" /* Color */].fromHex('#0097FB'),
    pickerGroupBorder: __WEBPACK_IMPORTED_MODULE_17__common_color_js__["a" /* Color */].fromHex('#3F3F46'),
    widgetShadow: __WEBPACK_IMPORTED_MODULE_17__common_color_js__["a" /* Color */].fromHex('#000000'),
    progressBarBackground: __WEBPACK_IMPORTED_MODULE_17__common_color_js__["a" /* Color */].fromHex('#0E70C0')
};
var DEFAULT_INPUT_ARIA_LABEL = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('quickOpenAriaLabel', "Quick picker. Type to narrow down results.");
var QuickOpenWidget = /** @class */ (function (_super) {
    __extends(QuickOpenWidget, _super);
    function QuickOpenWidget(container, callbacks, options) {
        var _this = _super.call(this) || this;
        _this.isDisposed = false;
        _this.container = container;
        _this.callbacks = callbacks;
        _this.options = options;
        _this.styles = options || Object.create(null);
        Object(__WEBPACK_IMPORTED_MODULE_18__common_objects_js__["g" /* mixin */])(_this.styles, defaultStyles, false);
        _this.model = null;
        return _this;
    }
    QuickOpenWidget.prototype.getModel = function () {
        return this.model;
    };
    QuickOpenWidget.prototype.create = function () {
        var _this = this;
        this.builder = Object(__WEBPACK_IMPORTED_MODULE_8__browser_builder_js__["a" /* $ */])().div(function (div) {
            // Eventing
            div.on(__WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
                var keyboardEvent = new __WEBPACK_IMPORTED_MODULE_12__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
                if (keyboardEvent.keyCode === 9 /* Escape */) {
                    __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true);
                    _this.hide(HideReason.CANCELED);
                }
                else if (keyboardEvent.keyCode === 2 /* Tab */ && !keyboardEvent.altKey && !keyboardEvent.ctrlKey && !keyboardEvent.metaKey) {
                    var stops = e.currentTarget.querySelectorAll('input, .monaco-tree, .monaco-tree-row.focused .action-label.icon');
                    if (keyboardEvent.shiftKey && keyboardEvent.target === stops[0]) {
                        __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true);
                        stops[stops.length - 1].focus();
                    }
                    else if (!keyboardEvent.shiftKey && keyboardEvent.target === stops[stops.length - 1]) {
                        __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true);
                        stops[0].focus();
                    }
                }
            })
                .on(__WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].CONTEXT_MENU, function (e) { return __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true); }) // Do this to fix an issue on Mac where the menu goes into the way
                .on(__WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].FOCUS, function (e) { return _this.gainingFocus(); }, null, true)
                .on(__WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].BLUR, function (e) { return _this.loosingFocus(e); }, null, true);
            // Progress Bar
            _this.progressBar = _this._register(new __WEBPACK_IMPORTED_MODULE_11__browser_ui_progressbar_progressbar_js__["a" /* ProgressBar */](div.clone(), { progressBarBackground: _this.styles.progressBarBackground }));
            _this.progressBar.hide();
            // Input Field
            div.div({ 'class': 'quick-open-input' }, function (inputContainer) {
                _this.inputContainer = inputContainer;
                _this.inputBox = _this._register(new __WEBPACK_IMPORTED_MODULE_9__browser_ui_inputbox_inputBox_js__["b" /* InputBox */](inputContainer.getHTMLElement(), null, {
                    placeholder: _this.options.inputPlaceHolder || '',
                    ariaLabel: DEFAULT_INPUT_ARIA_LABEL,
                    inputBackground: _this.styles.inputBackground,
                    inputForeground: _this.styles.inputForeground,
                    inputBorder: _this.styles.inputBorder,
                    inputValidationInfoBackground: _this.styles.inputValidationInfoBackground,
                    inputValidationInfoBorder: _this.styles.inputValidationInfoBorder,
                    inputValidationWarningBackground: _this.styles.inputValidationWarningBackground,
                    inputValidationWarningBorder: _this.styles.inputValidationWarningBorder,
                    inputValidationErrorBackground: _this.styles.inputValidationErrorBackground,
                    inputValidationErrorBorder: _this.styles.inputValidationErrorBorder
                }));
                // ARIA
                _this.inputElement = _this.inputBox.inputElement;
                _this.inputElement.setAttribute('role', 'combobox');
                _this.inputElement.setAttribute('aria-haspopup', 'false');
                _this.inputElement.setAttribute('aria-autocomplete', 'list');
                __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["g" /* addDisposableListener */](_this.inputBox.inputElement, __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
                    var keyboardEvent = new __WEBPACK_IMPORTED_MODULE_12__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
                    var shouldOpenInBackground = _this.shouldOpenInBackground(keyboardEvent);
                    // Do not handle Tab: It is used to navigate between elements without mouse
                    if (keyboardEvent.keyCode === 2 /* Tab */) {
                        return;
                    }
                    // Pass tree navigation keys to the tree but leave focus in input field
                    else if (keyboardEvent.keyCode === 18 /* DownArrow */ || keyboardEvent.keyCode === 16 /* UpArrow */ || keyboardEvent.keyCode === 12 /* PageDown */ || keyboardEvent.keyCode === 11 /* PageUp */) {
                        __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true);
                        _this.navigateInTree(keyboardEvent.keyCode, keyboardEvent.shiftKey);
                        // Position cursor at the end of input to allow right arrow (open in background)
                        // to function immediately unless the user has made a selection
                        if (_this.inputBox.inputElement.selectionStart === _this.inputBox.inputElement.selectionEnd) {
                            _this.inputBox.inputElement.selectionStart = _this.inputBox.value.length;
                        }
                    }
                    // Select element on Enter or on Arrow-Right if we are at the end of the input
                    else if (keyboardEvent.keyCode === 3 /* Enter */ || shouldOpenInBackground) {
                        __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true);
                        var focus_1 = _this.tree.getFocus();
                        if (focus_1) {
                            _this.elementSelected(focus_1, e, shouldOpenInBackground ? __WEBPACK_IMPORTED_MODULE_6__common_quickOpen_js__["a" /* Mode */].OPEN_IN_BACKGROUND : __WEBPACK_IMPORTED_MODULE_6__common_quickOpen_js__["a" /* Mode */].OPEN);
                        }
                    }
                });
                __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["g" /* addDisposableListener */](_this.inputBox.inputElement, __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].INPUT, function (e) {
                    _this.onType();
                });
            });
            // Result count for screen readers
            _this.resultCount = div.div({
                'class': 'quick-open-result-count',
                'aria-live': 'polite'
            }).clone();
            // Tree
            _this.treeContainer = div.div({
                'class': 'quick-open-tree'
            }, function (div) {
                var createTree = _this.options.treeCreator || (function (container, config, opts) { return new __WEBPACK_IMPORTED_MODULE_10__tree_browser_treeImpl_js__["a" /* Tree */](container, config, opts); });
                _this.tree = _this._register(createTree(div.getHTMLElement(), {
                    dataSource: new __WEBPACK_IMPORTED_MODULE_7__quickOpenViewer_js__["b" /* DataSource */](_this),
                    controller: new QuickOpenController({ clickBehavior: __WEBPACK_IMPORTED_MODULE_13__tree_browser_treeDefaults_js__["a" /* ClickBehavior */].ON_MOUSE_UP, keyboardSupport: _this.options.keyboardSupport }),
                    renderer: (_this.renderer = new __WEBPACK_IMPORTED_MODULE_7__quickOpenViewer_js__["d" /* Renderer */](_this, _this.styles)),
                    filter: new __WEBPACK_IMPORTED_MODULE_7__quickOpenViewer_js__["c" /* Filter */](_this),
                    accessibilityProvider: new __WEBPACK_IMPORTED_MODULE_7__quickOpenViewer_js__["a" /* AccessibilityProvider */](_this)
                }, {
                    twistiePixels: 11,
                    indentPixels: 0,
                    alwaysFocused: true,
                    verticalScrollMode: __WEBPACK_IMPORTED_MODULE_16__common_scrollable_js__["b" /* ScrollbarVisibility */].Visible,
                    horizontalScrollMode: __WEBPACK_IMPORTED_MODULE_16__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden,
                    ariaLabel: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('treeAriaLabel', "Quick Picker"),
                    keyboardSupport: _this.options.keyboardSupport,
                    preventRootFocus: false
                }));
                _this.treeElement = _this.tree.getHTMLElement();
                // Handle Focus and Selection event
                _this._register(_this.tree.onDidChangeFocus(function (event) {
                    _this.elementFocused(event.focus, event);
                }));
                _this._register(_this.tree.onDidChangeSelection(function (event) {
                    if (event.selection && event.selection.length > 0) {
                        var mouseEvent = event.payload && event.payload.originalEvent instanceof __WEBPACK_IMPORTED_MODULE_19__browser_mouseEvent_js__["b" /* StandardMouseEvent */] ? event.payload.originalEvent : void 0;
                        var shouldOpenInBackground = mouseEvent ? _this.shouldOpenInBackground(mouseEvent) : false;
                        _this.elementSelected(event.selection[0], event, shouldOpenInBackground ? __WEBPACK_IMPORTED_MODULE_6__common_quickOpen_js__["a" /* Mode */].OPEN_IN_BACKGROUND : __WEBPACK_IMPORTED_MODULE_6__common_quickOpen_js__["a" /* Mode */].OPEN);
                    }
                }));
            }).
                on(__WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
                var keyboardEvent = new __WEBPACK_IMPORTED_MODULE_12__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
                // Only handle when in quick navigation mode
                if (!_this.quickNavigateConfiguration) {
                    return;
                }
                // Support keyboard navigation in quick navigation mode
                if (keyboardEvent.keyCode === 18 /* DownArrow */ || keyboardEvent.keyCode === 16 /* UpArrow */ || keyboardEvent.keyCode === 12 /* PageDown */ || keyboardEvent.keyCode === 11 /* PageUp */) {
                    __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true);
                    _this.navigateInTree(keyboardEvent.keyCode);
                }
            }).
                on(__WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].KEY_UP, function (e) {
                var keyboardEvent = new __WEBPACK_IMPORTED_MODULE_12__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
                var keyCode = keyboardEvent.keyCode;
                // Only handle when in quick navigation mode
                if (!_this.quickNavigateConfiguration) {
                    return;
                }
                // Select element when keys are pressed that signal it
                var quickNavKeys = _this.quickNavigateConfiguration.keybindings;
                var wasTriggerKeyPressed = keyCode === 3 /* Enter */ || quickNavKeys.some(function (k) {
                    var _a = k.getParts(), firstPart = _a[0], chordPart = _a[1];
                    if (chordPart) {
                        return false;
                    }
                    if (firstPart.shiftKey && keyCode === 4 /* Shift */) {
                        if (keyboardEvent.ctrlKey || keyboardEvent.altKey || keyboardEvent.metaKey) {
                            return false; // this is an optimistic check for the shift key being used to navigate back in quick open
                        }
                        return true;
                    }
                    if (firstPart.altKey && keyCode === 6 /* Alt */) {
                        return true;
                    }
                    if (firstPart.ctrlKey && keyCode === 5 /* Ctrl */) {
                        return true;
                    }
                    if (firstPart.metaKey && keyCode === 57 /* Meta */) {
                        return true;
                    }
                    return false;
                });
                if (wasTriggerKeyPressed) {
                    var focus_2 = _this.tree.getFocus();
                    if (focus_2) {
                        _this.elementSelected(focus_2, e);
                    }
                }
            }).
                clone();
        })
            // Widget Attributes
            .addClass('monaco-quick-open-widget')
            .build(this.container);
        // Support layout
        if (this.layoutDimensions) {
            this.layout(this.layoutDimensions);
        }
        this.applyStyles();
        // Allows focus to switch to next/previous entry after tab into an actionbar item
        __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["g" /* addDisposableListener */](this.treeContainer.getHTMLElement(), __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
            var keyboardEvent = new __WEBPACK_IMPORTED_MODULE_12__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
            // Only handle when not in quick navigation mode
            if (_this.quickNavigateConfiguration) {
                return;
            }
            if (keyboardEvent.keyCode === 18 /* DownArrow */ || keyboardEvent.keyCode === 16 /* UpArrow */ || keyboardEvent.keyCode === 12 /* PageDown */ || keyboardEvent.keyCode === 11 /* PageUp */) {
                __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["c" /* EventHelper */].stop(e, true);
                _this.navigateInTree(keyboardEvent.keyCode, keyboardEvent.shiftKey);
                _this.treeElement.focus();
            }
        });
        return this.builder.getHTMLElement();
    };
    QuickOpenWidget.prototype.style = function (styles) {
        this.styles = styles;
        this.applyStyles();
    };
    QuickOpenWidget.prototype.applyStyles = function () {
        if (this.builder) {
            var foreground = this.styles.foreground ? this.styles.foreground.toString() : null;
            var background = this.styles.background ? this.styles.background.toString() : null;
            var borderColor = this.styles.borderColor ? this.styles.borderColor.toString() : null;
            var widgetShadow = this.styles.widgetShadow ? this.styles.widgetShadow.toString() : null;
            this.builder.style('color', foreground);
            this.builder.style('background-color', background);
            this.builder.style('border-color', borderColor);
            this.builder.style('border-width', borderColor ? '1px' : null);
            this.builder.style('border-style', borderColor ? 'solid' : null);
            this.builder.style('box-shadow', widgetShadow ? "0 5px 8px " + widgetShadow : null);
        }
        if (this.progressBar) {
            this.progressBar.style({
                progressBarBackground: this.styles.progressBarBackground
            });
        }
        if (this.inputBox) {
            this.inputBox.style({
                inputBackground: this.styles.inputBackground,
                inputForeground: this.styles.inputForeground,
                inputBorder: this.styles.inputBorder,
                inputValidationInfoBackground: this.styles.inputValidationInfoBackground,
                inputValidationInfoBorder: this.styles.inputValidationInfoBorder,
                inputValidationWarningBackground: this.styles.inputValidationWarningBackground,
                inputValidationWarningBorder: this.styles.inputValidationWarningBorder,
                inputValidationErrorBackground: this.styles.inputValidationErrorBackground,
                inputValidationErrorBorder: this.styles.inputValidationErrorBorder
            });
        }
        if (this.tree && !this.options.treeCreator) {
            this.tree.style(this.styles);
        }
        if (this.renderer) {
            this.renderer.updateStyles(this.styles);
        }
    };
    QuickOpenWidget.prototype.shouldOpenInBackground = function (e) {
        // Keyboard
        if (e instanceof __WEBPACK_IMPORTED_MODULE_12__browser_keyboardEvent_js__["a" /* StandardKeyboardEvent */]) {
            if (e.keyCode !== 17 /* RightArrow */) {
                return false; // only for right arrow
            }
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
                return false; // no modifiers allowed
            }
            // validate the cursor is at the end of the input and there is no selection,
            // and if not prevent opening in the background such as the selection can be changed
            var element = this.inputBox.inputElement;
            return element.selectionEnd === this.inputBox.value.length && element.selectionStart === element.selectionEnd;
        }
        // Mouse
        return e.middleButton;
    };
    QuickOpenWidget.prototype.onType = function () {
        var value = this.inputBox.value;
        // Adjust help text as needed if present
        if (this.helpText) {
            if (value) {
                this.helpText.hide();
            }
            else {
                this.helpText.show();
            }
        }
        // Send to callbacks
        this.callbacks.onType(value);
    };
    QuickOpenWidget.prototype.navigateInTree = function (keyCode, isShift) {
        var model = this.tree.getInput();
        var entries = model ? model.entries : [];
        var oldFocus = this.tree.getFocus();
        // Normal Navigation
        switch (keyCode) {
            case 18 /* DownArrow */:
                this.tree.focusNext();
                break;
            case 16 /* UpArrow */:
                this.tree.focusPrevious();
                break;
            case 12 /* PageDown */:
                this.tree.focusNextPage();
                break;
            case 11 /* PageUp */:
                this.tree.focusPreviousPage();
                break;
            case 2 /* Tab */:
                if (isShift) {
                    this.tree.focusPrevious();
                }
                else {
                    this.tree.focusNext();
                }
                break;
        }
        var newFocus = this.tree.getFocus();
        // Support cycle-through navigation if focus did not change
        if (entries.length > 1 && oldFocus === newFocus) {
            // Up from no entry or first entry goes down to last
            if (keyCode === 16 /* UpArrow */ || (keyCode === 2 /* Tab */ && isShift)) {
                this.tree.focusLast();
            }
            // Down from last entry goes to up to first
            else if (keyCode === 18 /* DownArrow */ || keyCode === 2 /* Tab */ && !isShift) {
                this.tree.focusFirst();
            }
        }
        // Reveal
        newFocus = this.tree.getFocus();
        if (newFocus) {
            this.tree.reveal(newFocus).done(null, __WEBPACK_IMPORTED_MODULE_5__common_errors_js__["e" /* onUnexpectedError */]);
        }
    };
    QuickOpenWidget.prototype.elementFocused = function (value, event) {
        if (!value || !this.isVisible()) {
            return;
        }
        // ARIA
        this.inputElement.setAttribute('aria-activedescendant', this.treeElement.getAttribute('aria-activedescendant'));
        var context = { event: event, keymods: this.extractKeyMods(event), quickNavigateConfiguration: this.quickNavigateConfiguration };
        this.model.runner.run(value, __WEBPACK_IMPORTED_MODULE_6__common_quickOpen_js__["a" /* Mode */].PREVIEW, context);
    };
    QuickOpenWidget.prototype.elementSelected = function (value, event, preferredMode) {
        var hide = true;
        // Trigger open of element on selection
        if (this.isVisible()) {
            var mode = preferredMode || __WEBPACK_IMPORTED_MODULE_6__common_quickOpen_js__["a" /* Mode */].OPEN;
            var context = { event: event, keymods: this.extractKeyMods(event), quickNavigateConfiguration: this.quickNavigateConfiguration };
            hide = this.model.runner.run(value, mode, context);
        }
        // Hide if command was run successfully
        if (hide) {
            this.hide(HideReason.ELEMENT_SELECTED);
        }
    };
    QuickOpenWidget.prototype.extractKeyMods = function (event) {
        return {
            ctrlCmd: event && (event.ctrlKey || event.metaKey || (event.payload && event.payload.originalEvent && (event.payload.originalEvent.ctrlKey || event.payload.originalEvent.metaKey))),
            alt: event && (event.altKey || (event.payload && event.payload.originalEvent && event.payload.originalEvent.altKey))
        };
    };
    QuickOpenWidget.prototype.show = function (param, options) {
        this.visible = true;
        this.isLoosingFocus = false;
        this.quickNavigateConfiguration = options ? options.quickNavigateConfiguration : void 0;
        // Adjust UI for quick navigate mode
        if (this.quickNavigateConfiguration) {
            this.inputContainer.hide();
            this.builder.show();
            this.tree.domFocus();
        }
        // Otherwise use normal UI
        else {
            this.inputContainer.show();
            this.builder.show();
            this.inputBox.focus();
        }
        // Adjust Help text for IE
        if (this.helpText) {
            if (this.quickNavigateConfiguration || __WEBPACK_IMPORTED_MODULE_4__common_types_js__["h" /* isString */](param)) {
                this.helpText.hide();
            }
            else {
                this.helpText.show();
            }
        }
        // Show based on param
        if (__WEBPACK_IMPORTED_MODULE_4__common_types_js__["h" /* isString */](param)) {
            this.doShowWithPrefix(param);
        }
        else {
            this.doShowWithInput(param, options && options.autoFocus ? options.autoFocus : {});
        }
        // Respect selectAll option
        if (options && options.inputSelection && !this.quickNavigateConfiguration) {
            this.inputBox.select(options.inputSelection);
        }
        if (this.callbacks.onShow) {
            this.callbacks.onShow();
        }
    };
    QuickOpenWidget.prototype.doShowWithPrefix = function (prefix) {
        this.inputBox.value = prefix;
        this.callbacks.onType(prefix);
    };
    QuickOpenWidget.prototype.doShowWithInput = function (input, autoFocus) {
        this.setInput(input, autoFocus);
    };
    QuickOpenWidget.prototype.setInputAndLayout = function (input, autoFocus) {
        var _this = this;
        this.treeContainer.style({ height: this.getHeight(input) + "px" });
        this.tree.setInput(null).then(function () {
            _this.model = input;
            // ARIA
            _this.inputElement.setAttribute('aria-haspopup', String(input && input.entries && input.entries.length > 0));
            return _this.tree.setInput(input);
        }).done(function () {
            // Indicate entries to tree
            _this.tree.layout();
            var entries = input ? input.entries.filter(function (e) { return _this.isElementVisible(input, e); }) : [];
            _this.updateResultCount(entries.length);
            // Handle auto focus
            if (entries.length) {
                _this.autoFocus(input, entries, autoFocus);
            }
        }, __WEBPACK_IMPORTED_MODULE_5__common_errors_js__["e" /* onUnexpectedError */]);
    };
    QuickOpenWidget.prototype.isElementVisible = function (input, e) {
        if (!input.filter) {
            return true;
        }
        return input.filter.isVisible(e);
    };
    QuickOpenWidget.prototype.autoFocus = function (input, entries, autoFocus) {
        if (autoFocus === void 0) { autoFocus = {}; }
        // First check for auto focus of prefix matches
        if (autoFocus.autoFocusPrefixMatch) {
            var caseSensitiveMatch = void 0;
            var caseInsensitiveMatch = void 0;
            var prefix = autoFocus.autoFocusPrefixMatch;
            var lowerCasePrefix = prefix.toLowerCase();
            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                var label = input.dataSource.getLabel(entry);
                if (!caseSensitiveMatch && label.indexOf(prefix) === 0) {
                    caseSensitiveMatch = entry;
                }
                else if (!caseInsensitiveMatch && label.toLowerCase().indexOf(lowerCasePrefix) === 0) {
                    caseInsensitiveMatch = entry;
                }
                if (caseSensitiveMatch && caseInsensitiveMatch) {
                    break;
                }
            }
            var entryToFocus = caseSensitiveMatch || caseInsensitiveMatch;
            if (entryToFocus) {
                this.tree.setFocus(entryToFocus);
                this.tree.reveal(entryToFocus, 0.5).done(null, __WEBPACK_IMPORTED_MODULE_5__common_errors_js__["e" /* onUnexpectedError */]);
                return;
            }
        }
        // Second check for auto focus of first entry
        if (autoFocus.autoFocusFirstEntry) {
            this.tree.focusFirst();
            this.tree.reveal(this.tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_5__common_errors_js__["e" /* onUnexpectedError */]);
        }
        // Third check for specific index option
        else if (typeof autoFocus.autoFocusIndex === 'number') {
            if (entries.length > autoFocus.autoFocusIndex) {
                this.tree.focusNth(autoFocus.autoFocusIndex);
                this.tree.reveal(this.tree.getFocus()).done(null, __WEBPACK_IMPORTED_MODULE_5__common_errors_js__["e" /* onUnexpectedError */]);
            }
        }
        // Check for auto focus of second entry
        else if (autoFocus.autoFocusSecondEntry) {
            if (entries.length > 1) {
                this.tree.focusNth(1);
            }
        }
        // Finally check for auto focus of last entry
        else if (autoFocus.autoFocusLastEntry) {
            if (entries.length > 1) {
                this.tree.focusLast();
            }
        }
    };
    QuickOpenWidget.prototype.getHeight = function (input) {
        var _this = this;
        var renderer = input.renderer;
        if (!input) {
            var itemHeight = renderer.getHeight(null);
            return this.options.minItemsToShow ? this.options.minItemsToShow * itemHeight : 0;
        }
        var height = 0;
        var preferredItemsHeight;
        if (this.layoutDimensions && this.layoutDimensions.height) {
            preferredItemsHeight = (this.layoutDimensions.height - 50 /* subtract height of input field (30px) and some spacing (drop shadow) to fit */) * 0.40 /* max 40% of screen */;
        }
        if (!preferredItemsHeight || preferredItemsHeight > QuickOpenWidget.MAX_ITEMS_HEIGHT) {
            preferredItemsHeight = QuickOpenWidget.MAX_ITEMS_HEIGHT;
        }
        var entries = input.entries.filter(function (e) { return _this.isElementVisible(input, e); });
        var maxEntries = this.options.maxItemsToShow || entries.length;
        for (var i = 0; i < maxEntries && i < entries.length; i++) {
            var entryHeight = renderer.getHeight(entries[i]);
            if (height + entryHeight <= preferredItemsHeight) {
                height += entryHeight;
            }
            else {
                break;
            }
        }
        return height;
    };
    QuickOpenWidget.prototype.updateResultCount = function (count) {
        this.resultCount.text(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]({ key: 'quickInput.visibleCount', comment: ['This tells the user how many items are shown in a list of items to select from. The items can be anything. Currently not visible, but read by screen readers.'] }, "{0} Results", count));
    };
    QuickOpenWidget.prototype.hide = function (reason) {
        if (!this.isVisible()) {
            return;
        }
        this.visible = false;
        this.builder.hide();
        this.builder.domBlur();
        // Clear input field and clear tree
        this.inputBox.value = '';
        this.tree.setInput(null);
        // ARIA
        this.inputElement.setAttribute('aria-haspopup', 'false');
        // Reset Tree Height
        this.treeContainer.style({ height: (this.options.minItemsToShow ? this.options.minItemsToShow * 22 : 0) + 'px' });
        // Clear any running Progress
        this.progressBar.stop().hide();
        // Clear Focus
        if (this.tree.isDOMFocused()) {
            this.tree.domBlur();
        }
        else if (this.inputBox.hasFocus()) {
            this.inputBox.blur();
        }
        // Callbacks
        if (reason === HideReason.ELEMENT_SELECTED) {
            this.callbacks.onOk();
        }
        else {
            this.callbacks.onCancel();
        }
        if (this.callbacks.onHide) {
            this.callbacks.onHide(reason);
        }
    };
    QuickOpenWidget.prototype.setInput = function (input, autoFocus, ariaLabel) {
        if (!this.isVisible()) {
            return;
        }
        // If the input changes, indicate this to the tree
        if (!!this.getInput()) {
            this.onInputChanging();
        }
        // Adapt tree height to entries and apply input
        this.setInputAndLayout(input, autoFocus);
        // Apply ARIA
        if (this.inputBox) {
            this.inputBox.setAriaLabel(ariaLabel || DEFAULT_INPUT_ARIA_LABEL);
        }
    };
    QuickOpenWidget.prototype.onInputChanging = function () {
        var _this = this;
        if (this.inputChangingTimeoutHandle) {
            clearTimeout(this.inputChangingTimeoutHandle);
            this.inputChangingTimeoutHandle = null;
        }
        // when the input is changing in quick open, we indicate this as CSS class to the widget
        // for a certain timeout. this helps reducing some hectic UI updates when input changes quickly
        this.builder.addClass('content-changing');
        this.inputChangingTimeoutHandle = setTimeout(function () {
            _this.builder.removeClass('content-changing');
        }, 500);
    };
    QuickOpenWidget.prototype.getInput = function () {
        return this.tree.getInput();
    };
    QuickOpenWidget.prototype.isVisible = function () {
        return this.visible;
    };
    QuickOpenWidget.prototype.layout = function (dimension) {
        this.layoutDimensions = dimension;
        // Apply to quick open width (height is dynamic by number of items to show)
        var quickOpenWidth = Math.min(this.layoutDimensions.width * 0.62 /* golden cut */, QuickOpenWidget.MAX_WIDTH);
        if (this.builder) {
            // quick open
            this.builder.style({
                width: quickOpenWidth + 'px',
                marginLeft: '-' + (quickOpenWidth / 2) + 'px'
            });
            // input field
            this.inputContainer.style({
                width: (quickOpenWidth - 12) + 'px'
            });
        }
    };
    QuickOpenWidget.prototype.gainingFocus = function () {
        this.isLoosingFocus = false;
    };
    QuickOpenWidget.prototype.loosingFocus = function (e) {
        var _this = this;
        if (!this.isVisible()) {
            return;
        }
        var relatedTarget = e.relatedTarget;
        if (!this.quickNavigateConfiguration && __WEBPACK_IMPORTED_MODULE_14__browser_dom_js__["B" /* isAncestor */](relatedTarget, this.builder.getHTMLElement())) {
            return; // user clicked somewhere into quick open widget, do not close thereby
        }
        this.isLoosingFocus = true;
        __WEBPACK_IMPORTED_MODULE_2__common_winjs_base_js__["b" /* TPromise */].timeout(0).then(function () {
            if (!_this.isLoosingFocus) {
                return;
            }
            if (_this.isDisposed) {
                return;
            }
            var veto = _this.callbacks.onFocusLost && _this.callbacks.onFocusLost();
            if (!veto) {
                _this.hide(HideReason.FOCUS_LOST);
            }
        });
    };
    QuickOpenWidget.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.isDisposed = true;
    };
    QuickOpenWidget.MAX_WIDTH = 600; // Max total width of quick open widget
    QuickOpenWidget.MAX_ITEMS_HEIGHT = 20 * 22; // Max height of item list below input field
    return QuickOpenWidget;
}(__WEBPACK_IMPORTED_MODULE_15__common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DataSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessibilityProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Renderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_types_js__ = __webpack_require__(31);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var DataSource = /** @class */ (function () {
    function DataSource(arg) {
        this.modelProvider = Object(__WEBPACK_IMPORTED_MODULE_1__common_types_js__["e" /* isFunction */])(arg.getModel) ? arg : { getModel: function () { return arg; } };
    }
    DataSource.prototype.getId = function (tree, element) {
        if (!element) {
            return null;
        }
        var model = this.modelProvider.getModel();
        return model === element ? '__root__' : model.dataSource.getId(element);
    };
    DataSource.prototype.hasChildren = function (tree, element) {
        var model = this.modelProvider.getModel();
        return model && model === element && model.entries.length > 0;
    };
    DataSource.prototype.getChildren = function (tree, element) {
        var model = this.modelProvider.getModel();
        return __WEBPACK_IMPORTED_MODULE_0__common_winjs_base_js__["b" /* TPromise */].as(model === element ? model.entries : []);
    };
    DataSource.prototype.getParent = function (tree, element) {
        return __WEBPACK_IMPORTED_MODULE_0__common_winjs_base_js__["b" /* TPromise */].as(null);
    };
    return DataSource;
}());

var AccessibilityProvider = /** @class */ (function () {
    function AccessibilityProvider(modelProvider) {
        this.modelProvider = modelProvider;
    }
    AccessibilityProvider.prototype.getAriaLabel = function (tree, element) {
        var model = this.modelProvider.getModel();
        return model.accessibilityProvider && model.accessibilityProvider.getAriaLabel(element);
    };
    AccessibilityProvider.prototype.getPosInSet = function (tree, element) {
        var model = this.modelProvider.getModel();
        return String(model.entries.indexOf(element) + 1);
    };
    AccessibilityProvider.prototype.getSetSize = function () {
        var model = this.modelProvider.getModel();
        return String(model.entries.length);
    };
    return AccessibilityProvider;
}());

var Filter = /** @class */ (function () {
    function Filter(modelProvider) {
        this.modelProvider = modelProvider;
    }
    Filter.prototype.isVisible = function (tree, element) {
        var model = this.modelProvider.getModel();
        if (!model.filter) {
            return true;
        }
        return model.filter.isVisible(element);
    };
    return Filter;
}());

var Renderer = /** @class */ (function () {
    function Renderer(modelProvider, styles) {
        this.modelProvider = modelProvider;
        this.styles = styles;
    }
    Renderer.prototype.updateStyles = function (styles) {
        this.styles = styles;
    };
    Renderer.prototype.getHeight = function (tree, element) {
        var model = this.modelProvider.getModel();
        return model.renderer.getHeight(element);
    };
    Renderer.prototype.getTemplateId = function (tree, element) {
        var model = this.modelProvider.getModel();
        return model.renderer.getTemplateId(element);
    };
    Renderer.prototype.renderTemplate = function (tree, templateId, container) {
        var model = this.modelProvider.getModel();
        return model.renderer.renderTemplate(templateId, container, this.styles);
    };
    Renderer.prototype.renderElement = function (tree, element, templateId, templateData) {
        var model = this.modelProvider.getModel();
        model.renderer.renderElement(element, templateId, templateData, this.styles);
    };
    Renderer.prototype.disposeTemplate = function (tree, templateId, templateData) {
        var model = this.modelProvider.getModel();
        model.renderer.disposeTemplate(templateId, templateData);
    };
    return Renderer;
}());



/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progressbar_css__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progressbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progressbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_objects_js__ = __webpack_require__(26);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var css_done = 'done';
var css_active = 'active';
var css_infinite = 'infinite';
var css_discrete = 'discrete';
var css_progress_container = 'monaco-progress-container';
var css_progress_bit = 'progress-bit';
var defaultOpts = {
    progressBarBackground: __WEBPACK_IMPORTED_MODULE_5__common_color_js__["a" /* Color */].fromHex('#0E70C0')
};
/**
 * A progress bar with support for infinite or discrete progress.
 */
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar(container, options) {
        var _this = _super.call(this) || this;
        _this.options = options || Object.create(null);
        Object(__WEBPACK_IMPORTED_MODULE_6__common_objects_js__["g" /* mixin */])(_this.options, defaultOpts, false);
        _this.workedVal = 0;
        _this.progressBarBackground = _this.options.progressBarBackground;
        _this.create(container);
        return _this;
    }
    ProgressBar.prototype.create = function (container) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_2__builder_js__["a" /* $ */])(container).div({ 'class': css_progress_container }, function (builder) {
            _this.element = builder.clone();
            builder.div({ 'class': css_progress_bit }).on([__WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].ANIMATION_START, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].ANIMATION_END, __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].ANIMATION_ITERATION], function (e) {
                switch (e.type) {
                    case __WEBPACK_IMPORTED_MODULE_3__dom_js__["d" /* EventType */].ANIMATION_ITERATION:
                        if (_this.animationStopToken) {
                            _this.animationStopToken(null);
                        }
                        break;
                }
            }, _this.toDispose);
            _this.bit = builder.getHTMLElement();
        });
        this.applyStyles();
    };
    ProgressBar.prototype.off = function () {
        this.bit.style.width = 'inherit';
        this.bit.style.opacity = '1';
        this.element.removeClass(css_active);
        this.element.removeClass(css_infinite);
        this.element.removeClass(css_discrete);
        this.workedVal = 0;
        this.totalWork = undefined;
    };
    /**
     * Stops the progressbar from showing any progress instantly without fading out.
     */
    ProgressBar.prototype.stop = function () {
        return this.doDone(false);
    };
    ProgressBar.prototype.doDone = function (delayed) {
        var _this = this;
        this.element.addClass(css_done);
        // let it grow to 100% width and hide afterwards
        if (!this.element.hasClass(css_infinite)) {
            this.bit.style.width = 'inherit';
            if (delayed) {
                __WEBPACK_IMPORTED_MODULE_1__common_winjs_base_js__["b" /* TPromise */].timeout(200).then(function () { return _this.off(); });
            }
            else {
                this.off();
            }
        }
        // let it fade out and hide afterwards
        else {
            this.bit.style.opacity = '0';
            if (delayed) {
                __WEBPACK_IMPORTED_MODULE_1__common_winjs_base_js__["b" /* TPromise */].timeout(200).then(function () { return _this.off(); });
            }
            else {
                this.off();
            }
        }
        return this;
    };
    ProgressBar.prototype.hide = function () {
        this.element.hide();
    };
    ProgressBar.prototype.style = function (styles) {
        this.progressBarBackground = styles.progressBarBackground;
        this.applyStyles();
    };
    ProgressBar.prototype.applyStyles = function () {
        if (this.bit) {
            var background = this.progressBarBackground ? this.progressBarBackground.toString() : null;
            this.bit.style.backgroundColor = background;
        }
    };
    return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_4__common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModesContentHoverWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getHover_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoverOperation_js__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hoverWidgets_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_htmlContent_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colorPicker_colorPickerModel_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colorPicker_colorPickerWidget_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__colorPicker_colorDetector_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__colorPicker_color_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

















var $ = __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["a" /* $ */];
var ColorHover = /** @class */ (function () {
    function ColorHover(range, color, provider) {
        this.range = range;
        this.color = color;
        this.provider = provider;
    }
    return ColorHover;
}());
var ModesContentComputer = /** @class */ (function () {
    function ModesContentComputer(editor) {
        this._editor = editor;
        this._range = null;
    }
    ModesContentComputer.prototype.setRange = function (range) {
        this._range = range;
        this._result = [];
    };
    ModesContentComputer.prototype.clearResult = function () {
        this._result = [];
    };
    ModesContentComputer.prototype.computeAsync = function (token) {
        var model = this._editor.getModel();
        if (!__WEBPACK_IMPORTED_MODULE_4__common_modes_js__["m" /* HoverProviderRegistry */].has(model)) {
            return Promise.resolve(null);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_5__getHover_js__["a" /* getHover */])(model, new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](this._range.startLineNumber, this._range.startColumn), token);
    };
    ModesContentComputer.prototype.computeSync = function () {
        var _this = this;
        var lineNumber = this._range.startLineNumber;
        if (lineNumber > this._editor.getModel().getLineCount()) {
            // Illegal line number => no results
            return [];
        }
        var colorDetector = __WEBPACK_IMPORTED_MODULE_12__colorPicker_colorDetector_js__["ColorDetector"].get(this._editor);
        var maxColumn = this._editor.getModel().getLineMaxColumn(lineNumber);
        var lineDecorations = this._editor.getLineDecorations(lineNumber);
        var didFindColor = false;
        var result = lineDecorations.map(function (d) {
            var startColumn = (d.range.startLineNumber === lineNumber) ? d.range.startColumn : 1;
            var endColumn = (d.range.endLineNumber === lineNumber) ? d.range.endColumn : maxColumn;
            if (startColumn > _this._range.startColumn || _this._range.endColumn > endColumn) {
                return null;
            }
            var range = new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](_this._range.startLineNumber, startColumn, _this._range.startLineNumber, endColumn);
            var colorData = colorDetector.getColorData(d.range.getStartPosition());
            if (!didFindColor && colorData) {
                didFindColor = true;
                var _a = colorData.colorInfo, color = _a.color, range_1 = _a.range;
                return new ColorHover(range_1, color, colorData.provider);
            }
            else {
                if (Object(__WEBPACK_IMPORTED_MODULE_8__base_common_htmlContent_js__["b" /* isEmptyMarkdownString */])(d.options.hoverMessage)) {
                    return null;
                }
                var contents = void 0;
                if (d.options.hoverMessage) {
                    if (Array.isArray(d.options.hoverMessage)) {
                        contents = d.options.hoverMessage.slice();
                    }
                    else {
                        contents = [d.options.hoverMessage];
                    }
                }
                return { contents: contents, range: range };
            }
        });
        return result.filter(function (d) { return !!d; });
    };
    ModesContentComputer.prototype.onResult = function (result, isFromSynchronousComputation) {
        // Always put synchronous messages before asynchronous ones
        if (isFromSynchronousComputation) {
            this._result = result.concat(this._result.sort(function (a, b) {
                if (a instanceof ColorHover) { // sort picker messages at to the top
                    return -1;
                }
                else if (b instanceof ColorHover) {
                    return 1;
                }
                return 0;
            }));
        }
        else {
            this._result = this._result.concat(result);
        }
    };
    ModesContentComputer.prototype.getResult = function () {
        return this._result.slice(0);
    };
    ModesContentComputer.prototype.getResultWithLoadingMessage = function () {
        return this._result.slice(0).concat([this._getLoadingMessage()]);
    };
    ModesContentComputer.prototype._getLoadingMessage = function () {
        return {
            range: this._range,
            contents: [new __WEBPACK_IMPORTED_MODULE_8__base_common_htmlContent_js__["a" /* MarkdownString */]().appendText(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('modesContentHover.loading', "Loading..."))]
        };
    };
    return ModesContentComputer;
}());
var ModesContentHoverWidget = /** @class */ (function (_super) {
    __extends(ModesContentHoverWidget, _super);
    function ModesContentHoverWidget(editor, markdownRenderer, _themeService) {
        var _this = _super.call(this, ModesContentHoverWidget.ID, editor) || this;
        _this._themeService = _themeService;
        _this.renderDisposable = __WEBPACK_IMPORTED_MODULE_14__base_common_lifecycle_js__["a" /* Disposable */].None;
        _this._computer = new ModesContentComputer(_this._editor);
        _this._highlightDecorations = [];
        _this._isChangingDecorations = false;
        _this._markdownRenderer = markdownRenderer;
        _this._register(markdownRenderer.onDidRenderCodeBlock(_this.onContentsChange, _this));
        _this._hoverOperation = new __WEBPACK_IMPORTED_MODULE_6__hoverOperation_js__["a" /* HoverOperation */](_this._computer, function (result) { return _this._withResult(result, true); }, null, function (result) { return _this._withResult(result, false); });
        _this._register(__WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this.getDomNode(), __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["d" /* EventType */].FOCUS, function () {
            if (_this._colorPicker) {
                __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["f" /* addClass */](_this.getDomNode(), 'colorpicker-hover');
            }
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this.getDomNode(), __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["d" /* EventType */].BLUR, function () {
            __WEBPACK_IMPORTED_MODULE_1__base_browser_dom_js__["G" /* removeClass */](_this.getDomNode(), 'colorpicker-hover');
        }));
        _this._register(editor.onDidChangeConfiguration(function (e) {
            _this._hoverOperation.setHoverTime(_this._editor.getConfiguration().contribInfo.hover.delay);
        }));
        return _this;
    }
    ModesContentHoverWidget.prototype.dispose = function () {
        this.renderDisposable.dispose();
        this.renderDisposable = __WEBPACK_IMPORTED_MODULE_14__base_common_lifecycle_js__["a" /* Disposable */].None;
        this._hoverOperation.cancel();
        _super.prototype.dispose.call(this);
    };
    ModesContentHoverWidget.prototype.onModelDecorationsChanged = function () {
        if (this._isChangingDecorations) {
            return;
        }
        if (this.isVisible) {
            // The decorations have changed and the hover is visible,
            // we need to recompute the displayed text
            this._hoverOperation.cancel();
            this._computer.clearResult();
            if (!this._colorPicker) { // TODO@Michel ensure that displayed text for other decorations is computed even if color picker is in place
                this._hoverOperation.start(0 /* Delayed */);
            }
        }
    };
    ModesContentHoverWidget.prototype.startShowingAt = function (range, mode, focus) {
        if (this._lastRange && this._lastRange.equalsRange(range)) {
            // We have to show the widget at the exact same range as before, so no work is needed
            return;
        }
        this._hoverOperation.cancel();
        if (this.isVisible) {
            // The range might have changed, but the hover is visible
            // Instead of hiding it completely, filter out messages that are still in the new range and
            // kick off a new computation
            if (this._showAtPosition.lineNumber !== range.startLineNumber) {
                this.hide();
            }
            else {
                var filteredMessages = [];
                for (var i = 0, len = this._messages.length; i < len; i++) {
                    var msg = this._messages[i];
                    var rng = msg.range;
                    if (rng.startColumn <= range.startColumn && rng.endColumn >= range.endColumn) {
                        filteredMessages.push(msg);
                    }
                }
                if (filteredMessages.length > 0) {
                    if (hoverContentsEquals(filteredMessages, this._messages)) {
                        return;
                    }
                    this._renderMessages(range, filteredMessages);
                }
                else {
                    this.hide();
                }
            }
        }
        this._lastRange = range;
        this._computer.setRange(range);
        this._shouldFocus = focus;
        this._hoverOperation.start(mode);
    };
    ModesContentHoverWidget.prototype.hide = function () {
        this._lastRange = null;
        this._hoverOperation.cancel();
        _super.prototype.hide.call(this);
        this._isChangingDecorations = true;
        this._highlightDecorations = this._editor.deltaDecorations(this._highlightDecorations, []);
        this._isChangingDecorations = false;
        this.renderDisposable.dispose();
        this.renderDisposable = __WEBPACK_IMPORTED_MODULE_14__base_common_lifecycle_js__["a" /* Disposable */].None;
        this._colorPicker = null;
    };
    ModesContentHoverWidget.prototype.isColorPickerVisible = function () {
        if (this._colorPicker) {
            return true;
        }
        return false;
    };
    ModesContentHoverWidget.prototype._withResult = function (result, complete) {
        this._messages = result;
        if (this._lastRange && this._messages.length > 0) {
            this._renderMessages(this._lastRange, this._messages);
        }
        else if (complete) {
            this.hide();
        }
    };
    ModesContentHoverWidget.prototype._renderMessages = function (renderRange, messages) {
        var _this = this;
        this.renderDisposable.dispose();
        this._colorPicker = null;
        // update column from which to show
        var renderColumn = Number.MAX_VALUE;
        var highlightRange = messages[0].range;
        var fragment = document.createDocumentFragment();
        var isEmptyHoverContent = true;
        var containColorPicker = false;
        var markdownDisposeable;
        messages.forEach(function (msg) {
            if (!msg.range) {
                return;
            }
            renderColumn = Math.min(renderColumn, msg.range.startColumn);
            highlightRange = __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */].plusRange(highlightRange, msg.range);
            if (!(msg instanceof ColorHover)) {
                msg.contents
                    .filter(function (contents) { return !Object(__WEBPACK_IMPORTED_MODULE_8__base_common_htmlContent_js__["b" /* isEmptyMarkdownString */])(contents); })
                    .forEach(function (contents) {
                    var renderedContents = _this._markdownRenderer.render(contents);
                    markdownDisposeable = renderedContents;
                    fragment.appendChild($('div.hover-row', null, renderedContents.element));
                    isEmptyHoverContent = false;
                });
            }
            else {
                containColorPicker = true;
                var _a = msg.color, red = _a.red, green = _a.green, blue = _a.blue, alpha = _a.alpha;
                var rgba = new __WEBPACK_IMPORTED_MODULE_13__base_common_color_js__["c" /* RGBA */](red * 255, green * 255, blue * 255, alpha);
                var color_1 = new __WEBPACK_IMPORTED_MODULE_13__base_common_color_js__["a" /* Color */](rgba);
                var editorModel_1 = _this._editor.getModel();
                var range_2 = new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](msg.range.startLineNumber, msg.range.startColumn, msg.range.endLineNumber, msg.range.endColumn);
                var colorInfo = { range: msg.range, color: msg.color };
                // create blank olor picker model and widget first to ensure it's positioned correctly.
                var model_1 = new __WEBPACK_IMPORTED_MODULE_10__colorPicker_colorPickerModel_js__["a" /* ColorPickerModel */](color_1, [], 0);
                var widget_1 = new __WEBPACK_IMPORTED_MODULE_11__colorPicker_colorPickerWidget_js__["a" /* ColorPickerWidget */](fragment, model_1, _this._editor.getConfiguration().pixelRatio, _this._themeService);
                Object(__WEBPACK_IMPORTED_MODULE_15__colorPicker_color_js__["a" /* getColorPresentations */])(editorModel_1, colorInfo, msg.provider, __WEBPACK_IMPORTED_MODULE_16__base_common_cancellation_js__["a" /* CancellationToken */].None).then(function (colorPresentations) {
                    model_1.colorPresentations = colorPresentations;
                    var originalText = _this._editor.getModel().getValueInRange(msg.range);
                    model_1.guessColorPresentation(color_1, originalText);
                    var updateEditorModel = function () {
                        var textEdits;
                        var newRange;
                        if (model_1.presentation.textEdit) {
                            textEdits = [model_1.presentation.textEdit];
                            newRange = new __WEBPACK_IMPORTED_MODULE_2__common_core_range_js__["a" /* Range */](model_1.presentation.textEdit.range.startLineNumber, model_1.presentation.textEdit.range.startColumn, model_1.presentation.textEdit.range.endLineNumber, model_1.presentation.textEdit.range.endColumn);
                            newRange = newRange.setEndPosition(newRange.endLineNumber, newRange.startColumn + model_1.presentation.textEdit.text.length);
                        }
                        else {
                            textEdits = [{ identifier: null, range: range_2, text: model_1.presentation.label, forceMoveMarkers: false }];
                            newRange = range_2.setEndPosition(range_2.endLineNumber, range_2.startColumn + model_1.presentation.label.length);
                        }
                        _this._editor.executeEdits('colorpicker', textEdits);
                        if (model_1.presentation.additionalTextEdits) {
                            textEdits = model_1.presentation.additionalTextEdits.slice();
                            _this._editor.executeEdits('colorpicker', textEdits);
                            _this.hide();
                        }
                        _this._editor.pushUndoStop();
                        range_2 = newRange;
                    };
                    var updateColorPresentations = function (color) {
                        return Object(__WEBPACK_IMPORTED_MODULE_15__colorPicker_color_js__["a" /* getColorPresentations */])(editorModel_1, {
                            range: range_2,
                            color: {
                                red: color.rgba.r / 255,
                                green: color.rgba.g / 255,
                                blue: color.rgba.b / 255,
                                alpha: color.rgba.a
                            }
                        }, msg.provider, __WEBPACK_IMPORTED_MODULE_16__base_common_cancellation_js__["a" /* CancellationToken */].None).then(function (colorPresentations) {
                            model_1.colorPresentations = colorPresentations;
                        });
                    };
                    var colorListener = model_1.onColorFlushed(function (color) {
                        updateColorPresentations(color).then(updateEditorModel);
                    });
                    var colorChangeListener = model_1.onDidChangeColor(updateColorPresentations);
                    _this._colorPicker = widget_1;
                    _this.showAt(new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](renderRange.startLineNumber, renderColumn), _this._shouldFocus);
                    _this.updateContents(fragment);
                    _this._colorPicker.layout();
                    _this.renderDisposable = Object(__WEBPACK_IMPORTED_MODULE_14__base_common_lifecycle_js__["c" /* combinedDisposable */])([colorListener, colorChangeListener, widget_1, markdownDisposeable]);
                });
            }
        });
        // show
        if (!containColorPicker && !isEmptyHoverContent) {
            this.showAt(new __WEBPACK_IMPORTED_MODULE_3__common_core_position_js__["a" /* Position */](renderRange.startLineNumber, renderColumn), this._shouldFocus);
            this.updateContents(fragment);
        }
        this._isChangingDecorations = true;
        this._highlightDecorations = this._editor.deltaDecorations(this._highlightDecorations, [{
                range: highlightRange,
                options: ModesContentHoverWidget._DECORATION_OPTIONS
            }]);
        this._isChangingDecorations = false;
    };
    ModesContentHoverWidget.ID = 'editor.contrib.modesContentHoverWidget';
    ModesContentHoverWidget._DECORATION_OPTIONS = __WEBPACK_IMPORTED_MODULE_9__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({
        className: 'hoverHighlight'
    });
    return ModesContentHoverWidget;
}(__WEBPACK_IMPORTED_MODULE_7__hoverWidgets_js__["a" /* ContentHoverWidget */]));

function hoverContentsEquals(first, second) {
    if ((!first && second) || (first && !second) || first.length !== second.length) {
        return false;
    }
    for (var i = 0; i < first.length; i++) {
        var firstElement = first[i];
        var secondElement = second[i];
        if (firstElement instanceof ColorHover) {
            return false;
        }
        if (secondElement instanceof ColorHover) {
            return false;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__base_common_htmlContent_js__["c" /* markedStringsEquals */])(firstElement.contents, secondElement.contents)) {
            return false;
        }
    }
    return true;
}


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHover;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





function getHover(model, position, token) {
    var supports = __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["m" /* HoverProviderRegistry */].ordered(model);
    var promises = supports.map(function (support) {
        return Promise.resolve(support.provideHover(model, position, token)).then(function (hover) {
            return hover && isValid(hover) ? hover : undefined;
        }, function (err) {
            Object(__WEBPACK_IMPORTED_MODULE_1__base_common_errors_js__["f" /* onUnexpectedExternalError */])(err);
            return undefined;
        });
    });
    return Promise.all(promises).then(function (values) { return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["c" /* coalesce */])(values); });
}
Object(__WEBPACK_IMPORTED_MODULE_2__browser_editorExtensions_js__["e" /* registerDefaultLanguageCommand */])('_executeHoverProvider', function (model, position) { return getHover(model, position, __WEBPACK_IMPORTED_MODULE_4__base_common_cancellation_js__["a" /* CancellationToken */].None); });
function isValid(result) {
    var hasRange = (typeof result.range !== 'undefined');
    var hasHtmlContent = typeof result.contents !== 'undefined' && result.contents && result.contents.length > 0;
    return hasRange && hasHtmlContent;
}


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var ColorPickerModel = /** @class */ (function () {
    function ColorPickerModel(color, availableColorPresentations, presentationIndex) {
        this.presentationIndex = presentationIndex;
        this._onColorFlushed = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this.onColorFlushed = this._onColorFlushed.event;
        this._onDidChangeColor = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this.onDidChangeColor = this._onDidChangeColor.event;
        this._onDidChangePresentation = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this.onDidChangePresentation = this._onDidChangePresentation.event;
        this.originalColor = color;
        this._color = color;
        this._colorPresentations = availableColorPresentations;
    }
    Object.defineProperty(ColorPickerModel.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (color) {
            if (this._color.equals(color)) {
                return;
            }
            this._color = color;
            this._onDidChangeColor.fire(color);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColorPickerModel.prototype, "presentation", {
        get: function () { return this.colorPresentations[this.presentationIndex]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColorPickerModel.prototype, "colorPresentations", {
        get: function () {
            return this._colorPresentations;
        },
        set: function (colorPresentations) {
            this._colorPresentations = colorPresentations;
            if (this.presentationIndex > colorPresentations.length - 1) {
                this.presentationIndex = 0;
            }
            this._onDidChangePresentation.fire(this.presentation);
        },
        enumerable: true,
        configurable: true
    });
    ColorPickerModel.prototype.selectNextColorPresentation = function () {
        this.presentationIndex = (this.presentationIndex + 1) % this.colorPresentations.length;
        this.flushColor();
        this._onDidChangePresentation.fire(this.presentation);
    };
    ColorPickerModel.prototype.guessColorPresentation = function (color, originalText) {
        for (var i = 0; i < this.colorPresentations.length; i++) {
            if (originalText === this.colorPresentations[i].label) {
                this.presentationIndex = i;
                this._onDidChangePresentation.fire(this.presentation);
                break;
            }
        }
    };
    ColorPickerModel.prototype.flushColor = function () {
        this._onColorFlushed.fire(this._color);
    };
    return ColorPickerModel;
}());



/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorPickerHeader */
/* unused harmony export ColorPickerBody */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorPicker_css__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorPicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__colorPicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_ui_widget_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_browser_globalMouseMoveMonitor_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__ = __webpack_require__(13);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var $ = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["a" /* $ */];
var ColorPickerHeader = /** @class */ (function (_super) {
    __extends(ColorPickerHeader, _super);
    function ColorPickerHeader(container, model, themeService) {
        var _this = _super.call(this) || this;
        _this.model = model;
        _this.domNode = $('.colorpicker-header');
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](container, _this.domNode);
        _this.pickedColorNode = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](_this.domNode, $('.picked-color'));
        var colorBox = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](_this.domNode, $('.original-color'));
        colorBox.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */].Format.CSS.format(_this.model.originalColor);
        _this.backgroundColor = themeService.getTheme().getColor(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_colorRegistry_js__["v" /* editorHoverBackground */]) || __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */].white;
        _this._register(Object(__WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
            _this.backgroundColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_8__platform_theme_common_colorRegistry_js__["v" /* editorHoverBackground */]) || __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */].white;
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](_this.pickedColorNode, __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["d" /* EventType */].CLICK, function () { return _this.model.selectNextColorPresentation(); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](colorBox, __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["d" /* EventType */].CLICK, function () {
            _this.model.color = _this.model.originalColor;
            _this.model.flushColor();
        }));
        _this._register(model.onDidChangeColor(_this.onDidChangeColor, _this));
        _this._register(model.onDidChangePresentation(_this.onDidChangePresentation, _this));
        _this.pickedColorNode.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */].Format.CSS.format(model.color);
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["N" /* toggleClass */](_this.pickedColorNode, 'light', model.color.rgba.a < 0.5 ? _this.backgroundColor.isLighter() : model.color.isLighter());
        return _this;
    }
    ColorPickerHeader.prototype.onDidChangeColor = function (color) {
        this.pickedColorNode.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */].Format.CSS.format(color);
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["N" /* toggleClass */](this.pickedColorNode, 'light', color.rgba.a < 0.5 ? this.backgroundColor.isLighter() : color.isLighter());
        this.onDidChangePresentation();
    };
    ColorPickerHeader.prototype.onDidChangePresentation = function () {
        this.pickedColorNode.textContent = this.model.presentation ? this.model.presentation.label : '';
    };
    return ColorPickerHeader;
}(__WEBPACK_IMPORTED_MODULE_5__base_common_lifecycle_js__["a" /* Disposable */]));

var ColorPickerBody = /** @class */ (function (_super) {
    __extends(ColorPickerBody, _super);
    function ColorPickerBody(container, model, pixelRatio) {
        var _this = _super.call(this) || this;
        _this.model = model;
        _this.pixelRatio = pixelRatio;
        _this.domNode = $('.colorpicker-body');
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](container, _this.domNode);
        _this.saturationBox = new SaturationBox(_this.domNode, _this.model, _this.pixelRatio);
        _this._register(_this.saturationBox);
        _this._register(_this.saturationBox.onDidChange(_this.onDidSaturationValueChange, _this));
        _this._register(_this.saturationBox.onColorFlushed(_this.flushColor, _this));
        _this.opacityStrip = new OpacityStrip(_this.domNode, _this.model);
        _this._register(_this.opacityStrip);
        _this._register(_this.opacityStrip.onDidChange(_this.onDidOpacityChange, _this));
        _this._register(_this.opacityStrip.onColorFlushed(_this.flushColor, _this));
        _this.hueStrip = new HueStrip(_this.domNode, _this.model);
        _this._register(_this.hueStrip);
        _this._register(_this.hueStrip.onDidChange(_this.onDidHueChange, _this));
        _this._register(_this.hueStrip.onColorFlushed(_this.flushColor, _this));
        return _this;
    }
    ColorPickerBody.prototype.flushColor = function () {
        this.model.flushColor();
    };
    ColorPickerBody.prototype.onDidSaturationValueChange = function (_a) {
        var s = _a.s, v = _a.v;
        var hsva = this.model.color.hsva;
        this.model.color = new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["b" /* HSVA */](hsva.h, s, v, hsva.a));
    };
    ColorPickerBody.prototype.onDidOpacityChange = function (a) {
        var hsva = this.model.color.hsva;
        this.model.color = new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["b" /* HSVA */](hsva.h, hsva.s, hsva.v, a));
    };
    ColorPickerBody.prototype.onDidHueChange = function (value) {
        var hsva = this.model.color.hsva;
        var h = (1 - value) * 360;
        this.model.color = new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["b" /* HSVA */](h === 360 ? 0 : h, hsva.s, hsva.v, hsva.a));
    };
    ColorPickerBody.prototype.layout = function () {
        this.saturationBox.layout();
        this.opacityStrip.layout();
        this.hueStrip.layout();
    };
    return ColorPickerBody;
}(__WEBPACK_IMPORTED_MODULE_5__base_common_lifecycle_js__["a" /* Disposable */]));

var SaturationBox = /** @class */ (function (_super) {
    __extends(SaturationBox, _super);
    function SaturationBox(container, model, pixelRatio) {
        var _this = _super.call(this) || this;
        _this.model = model;
        _this.pixelRatio = pixelRatio;
        _this._onDidChange = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        _this.onDidChange = _this._onDidChange.event;
        _this._onColorFlushed = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        _this.onColorFlushed = _this._onColorFlushed.event;
        _this.domNode = $('.saturation-wrap');
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](container, _this.domNode);
        // Create canvas, draw selected color
        _this.canvas = document.createElement('canvas');
        _this.canvas.className = 'saturation-box';
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](_this.domNode, _this.canvas);
        // Add selection circle
        _this.selection = $('.saturation-selection');
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](_this.domNode, _this.selection);
        _this.layout();
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](_this.domNode, __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["d" /* EventType */].MOUSE_DOWN, function (e) { return _this.onMouseDown(e); }));
        _this._register(_this.model.onDidChangeColor(_this.onDidChangeColor, _this));
        _this.monitor = null;
        return _this;
    }
    SaturationBox.prototype.onMouseDown = function (e) {
        var _this = this;
        this.monitor = this._register(new __WEBPACK_IMPORTED_MODULE_6__base_browser_globalMouseMoveMonitor_js__["a" /* GlobalMouseMoveMonitor */]());
        var origin = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["u" /* getDomNodePagePosition */](this.domNode);
        if (e.target !== this.selection) {
            this.onDidChangePosition(e.offsetX, e.offsetY);
        }
        this.monitor.startMonitoring(__WEBPACK_IMPORTED_MODULE_6__base_browser_globalMouseMoveMonitor_js__["b" /* standardMouseMoveMerger */], function (event) { return _this.onDidChangePosition(event.posx - origin.left, event.posy - origin.top); }, function () { return null; });
        var mouseUpListener = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](document, __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["d" /* EventType */].MOUSE_UP, function () {
            _this._onColorFlushed.fire();
            mouseUpListener.dispose();
            _this.monitor.stopMonitoring(true);
            _this.monitor = null;
        }, true);
    };
    SaturationBox.prototype.onDidChangePosition = function (left, top) {
        var s = Math.max(0, Math.min(1, left / this.width));
        var v = Math.max(0, Math.min(1, 1 - (top / this.height)));
        this.paintSelection(s, v);
        this._onDidChange.fire({ s: s, v: v });
    };
    SaturationBox.prototype.layout = function () {
        this.width = this.domNode.offsetWidth;
        this.height = this.domNode.offsetHeight;
        this.canvas.width = this.width * this.pixelRatio;
        this.canvas.height = this.height * this.pixelRatio;
        this.paint();
        var hsva = this.model.color.hsva;
        this.paintSelection(hsva.s, hsva.v);
    };
    SaturationBox.prototype.paint = function () {
        var hsva = this.model.color.hsva;
        var saturatedColor = new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["b" /* HSVA */](hsva.h, 1, 1, 1));
        var ctx = this.canvas.getContext('2d');
        var whiteGradient = ctx.createLinearGradient(0, 0, this.canvas.width, 0);
        whiteGradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
        whiteGradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.5)');
        whiteGradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
        var blackGradient = ctx.createLinearGradient(0, 0, 0, this.canvas.height);
        blackGradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
        blackGradient.addColorStop(1, 'rgba(0, 0, 0, 1)');
        ctx.rect(0, 0, this.canvas.width, this.canvas.height);
        ctx.fillStyle = __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */].Format.CSS.format(saturatedColor);
        ctx.fill();
        ctx.fillStyle = whiteGradient;
        ctx.fill();
        ctx.fillStyle = blackGradient;
        ctx.fill();
    };
    SaturationBox.prototype.paintSelection = function (s, v) {
        this.selection.style.left = s * this.width + "px";
        this.selection.style.top = this.height - v * this.height + "px";
    };
    SaturationBox.prototype.onDidChangeColor = function () {
        if (this.monitor && this.monitor.isMonitoring()) {
            return;
        }
        this.paint();
    };
    return SaturationBox;
}(__WEBPACK_IMPORTED_MODULE_5__base_common_lifecycle_js__["a" /* Disposable */]));
var Strip = /** @class */ (function (_super) {
    __extends(Strip, _super);
    function Strip(container, model) {
        var _this = _super.call(this) || this;
        _this.model = model;
        _this._onDidChange = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        _this.onDidChange = _this._onDidChange.event;
        _this._onColorFlushed = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        _this.onColorFlushed = _this._onColorFlushed.event;
        _this.domNode = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](container, $('.strip'));
        _this.overlay = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](_this.domNode, $('.overlay'));
        _this.slider = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["k" /* append */](_this.domNode, $('.slider'));
        _this.slider.style.top = "0px";
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](_this.domNode, __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["d" /* EventType */].MOUSE_DOWN, function (e) { return _this.onMouseDown(e); }));
        _this.layout();
        return _this;
    }
    Strip.prototype.layout = function () {
        this.height = this.domNode.offsetHeight - this.slider.offsetHeight;
        var value = this.getValue(this.model.color);
        this.updateSliderPosition(value);
    };
    Strip.prototype.onMouseDown = function (e) {
        var _this = this;
        var monitor = this._register(new __WEBPACK_IMPORTED_MODULE_6__base_browser_globalMouseMoveMonitor_js__["a" /* GlobalMouseMoveMonitor */]());
        var origin = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["u" /* getDomNodePagePosition */](this.domNode);
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](this.domNode, 'grabbing');
        if (e.target !== this.slider) {
            this.onDidChangeTop(e.offsetY);
        }
        monitor.startMonitoring(__WEBPACK_IMPORTED_MODULE_6__base_browser_globalMouseMoveMonitor_js__["b" /* standardMouseMoveMerger */], function (event) { return _this.onDidChangeTop(event.posy - origin.top); }, function () { return null; });
        var mouseUpListener = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["g" /* addDisposableListener */](document, __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["d" /* EventType */].MOUSE_UP, function () {
            _this._onColorFlushed.fire();
            mouseUpListener.dispose();
            monitor.stopMonitoring(true);
            __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["G" /* removeClass */](_this.domNode, 'grabbing');
        }, true);
    };
    Strip.prototype.onDidChangeTop = function (top) {
        var value = Math.max(0, Math.min(1, 1 - (top / this.height)));
        this.updateSliderPosition(value);
        this._onDidChange.fire(value);
    };
    Strip.prototype.updateSliderPosition = function (value) {
        this.slider.style.top = (1 - value) * this.height + "px";
    };
    return Strip;
}(__WEBPACK_IMPORTED_MODULE_5__base_common_lifecycle_js__["a" /* Disposable */]));
var OpacityStrip = /** @class */ (function (_super) {
    __extends(OpacityStrip, _super);
    function OpacityStrip(container, model) {
        var _this = _super.call(this, container, model) || this;
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](_this.domNode, 'opacity-strip');
        _this._register(model.onDidChangeColor(_this.onDidChangeColor, _this));
        _this.onDidChangeColor(_this.model.color);
        return _this;
    }
    OpacityStrip.prototype.onDidChangeColor = function (color) {
        var _a = color.rgba, r = _a.r, g = _a.g, b = _a.b;
        var opaque = new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["c" /* RGBA */](r, g, b, 1));
        var transparent = new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["a" /* Color */](new __WEBPACK_IMPORTED_MODULE_7__base_common_color_js__["c" /* RGBA */](r, g, b, 0));
        this.overlay.style.background = "linear-gradient(to bottom, " + opaque + " 0%, " + transparent + " 100%)";
    };
    OpacityStrip.prototype.getValue = function (color) {
        return color.hsva.a;
    };
    return OpacityStrip;
}(Strip));
var HueStrip = /** @class */ (function (_super) {
    __extends(HueStrip, _super);
    function HueStrip(container, model) {
        var _this = _super.call(this, container, model) || this;
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["f" /* addClass */](_this.domNode, 'hue-strip');
        return _this;
    }
    HueStrip.prototype.getValue = function (color) {
        return 1 - (color.hsva.h / 360);
    };
    return HueStrip;
}(Strip));
var ColorPickerWidget = /** @class */ (function (_super) {
    __extends(ColorPickerWidget, _super);
    function ColorPickerWidget(container, model, pixelRatio, themeService) {
        var _this = _super.call(this) || this;
        _this.model = model;
        _this.pixelRatio = pixelRatio;
        _this._register(Object(__WEBPACK_IMPORTED_MODULE_4__base_browser_browser_js__["p" /* onDidChangeZoomLevel */])(function () { return _this.layout(); }));
        var element = $('.colorpicker-widget');
        container.appendChild(element);
        var header = new ColorPickerHeader(element, _this.model, themeService);
        _this.body = new ColorPickerBody(element, _this.model, _this.pixelRatio);
        _this._register(header);
        _this._register(_this.body);
        return _this;
    }
    ColorPickerWidget.prototype.layout = function () {
        this.body.layout();
    };
    return ColorPickerWidget;
}(__WEBPACK_IMPORTED_MODULE_2__base_browser_ui_widget_js__["a" /* Widget */]));



/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModesGlyphHoverWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hoverOperation_js__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoverWidgets_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_htmlContent_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__ = __webpack_require__(0);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MarginComputer = /** @class */ (function () {
    function MarginComputer(editor) {
        this._editor = editor;
        this._lineNumber = -1;
    }
    MarginComputer.prototype.setLineNumber = function (lineNumber) {
        this._lineNumber = lineNumber;
        this._result = [];
    };
    MarginComputer.prototype.clearResult = function () {
        this._result = [];
    };
    MarginComputer.prototype.computeSync = function () {
        var toHoverMessage = function (contents) {
            return {
                value: contents
            };
        };
        var lineDecorations = this._editor.getLineDecorations(this._lineNumber);
        var result = [];
        for (var i = 0, len = lineDecorations.length; i < len; i++) {
            var d = lineDecorations[i];
            if (!d.options.glyphMarginClassName) {
                continue;
            }
            var hoverMessage = d.options.glyphMarginHoverMessage;
            if (Object(__WEBPACK_IMPORTED_MODULE_3__base_common_htmlContent_js__["b" /* isEmptyMarkdownString */])(hoverMessage)) {
                continue;
            }
            if (Array.isArray(hoverMessage)) {
                result = result.concat(hoverMessage.map(toHoverMessage));
            }
            else {
                result.push(toHoverMessage(hoverMessage));
            }
        }
        return result;
    };
    MarginComputer.prototype.onResult = function (result, isFromSynchronousComputation) {
        this._result = this._result.concat(result);
    };
    MarginComputer.prototype.getResult = function () {
        return this._result;
    };
    MarginComputer.prototype.getResultWithLoadingMessage = function () {
        return this.getResult();
    };
    return MarginComputer;
}());
var ModesGlyphHoverWidget = /** @class */ (function (_super) {
    __extends(ModesGlyphHoverWidget, _super);
    function ModesGlyphHoverWidget(editor, markdownRenderer) {
        var _this = _super.call(this, ModesGlyphHoverWidget.ID, editor) || this;
        _this._lastLineNumber = -1;
        _this._markdownRenderer = markdownRenderer;
        _this._computer = new MarginComputer(_this._editor);
        _this._hoverOperation = new __WEBPACK_IMPORTED_MODULE_0__hoverOperation_js__["a" /* HoverOperation */](_this._computer, function (result) { return _this._withResult(result); }, null, function (result) { return _this._withResult(result); });
        return _this;
    }
    ModesGlyphHoverWidget.prototype.dispose = function () {
        this._renderDisposeables = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._renderDisposeables);
        this._hoverOperation.cancel();
        _super.prototype.dispose.call(this);
    };
    ModesGlyphHoverWidget.prototype.onModelDecorationsChanged = function () {
        if (this.isVisible) {
            // The decorations have changed and the hover is visible,
            // we need to recompute the displayed text
            this._hoverOperation.cancel();
            this._computer.clearResult();
            this._hoverOperation.start(0 /* Delayed */);
        }
    };
    ModesGlyphHoverWidget.prototype.startShowingAt = function (lineNumber) {
        if (this._lastLineNumber === lineNumber) {
            // We have to show the widget at the exact same line number as before, so no work is needed
            return;
        }
        this._hoverOperation.cancel();
        this.hide();
        this._lastLineNumber = lineNumber;
        this._computer.setLineNumber(lineNumber);
        this._hoverOperation.start(0 /* Delayed */);
    };
    ModesGlyphHoverWidget.prototype.hide = function () {
        this._lastLineNumber = -1;
        this._hoverOperation.cancel();
        _super.prototype.hide.call(this);
    };
    ModesGlyphHoverWidget.prototype._withResult = function (result) {
        this._messages = result;
        if (this._messages.length > 0) {
            this._renderMessages(this._lastLineNumber, this._messages);
        }
        else {
            this.hide();
        }
    };
    ModesGlyphHoverWidget.prototype._renderMessages = function (lineNumber, messages) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._renderDisposeables);
        this._renderDisposeables = [];
        var fragment = document.createDocumentFragment();
        messages.forEach(function (msg) {
            var renderedContents = _this._markdownRenderer.render(msg.value);
            _this._renderDisposeables.push(renderedContents);
            fragment.appendChild(Object(__WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["a" /* $ */])('div.hover-row', null, renderedContents.element));
        });
        this.updateContents(fragment);
        this.showAt(lineNumber);
    };
    ModesGlyphHoverWidget.ID = 'editor.contrib.modesGlyphHoverWidget';
    return ModesGlyphHoverWidget;
}(__WEBPACK_IMPORTED_MODULE_1__hoverWidgets_js__["b" /* GlyphHoverWidget */]));



/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InPlaceReplaceCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__ = __webpack_require__(18);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var InPlaceReplaceCommand = /** @class */ (function () {
    function InPlaceReplaceCommand(editRange, originalSelection, text) {
        this._editRange = editRange;
        this._originalSelection = originalSelection;
        this._text = text;
    }
    InPlaceReplaceCommand.prototype.getEditOperations = function (model, builder) {
        builder.addTrackedEditOperation(this._editRange, this._text);
    };
    InPlaceReplaceCommand.prototype.computeCursorState = function (model, helper) {
        var inverseEditOperations = helper.getInverseEditOperations();
        var srcRange = inverseEditOperations[0].range;
        if (!this._originalSelection.isEmpty()) {
            // Preserve selection and extends to typed text
            return new __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__["a" /* Selection */](srcRange.endLineNumber, srcRange.endColumn - this._text.length, srcRange.endLineNumber, srcRange.endColumn);
        }
        return new __WEBPACK_IMPORTED_MODULE_0__common_core_selection_js__["a" /* Selection */](srcRange.endLineNumber, Math.min(this._originalSelection.positionColumn, srcRange.endColumn), srcRange.endLineNumber, Math.min(this._originalSelection.positionColumn, srcRange.endColumn));
    };
    return InPlaceReplaceCommand;
}());



/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortLinesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var SortLinesCommand = /** @class */ (function () {
    function SortLinesCommand(selection, descending) {
        this.selection = selection;
        this.descending = descending;
    }
    SortLinesCommand.prototype.getEditOperations = function (model, builder) {
        var op = sortLines(model, this.selection, this.descending);
        if (op) {
            builder.addEditOperation(op.range, op.text);
        }
        this.selectionId = builder.trackSelection(this.selection);
    };
    SortLinesCommand.prototype.computeCursorState = function (model, helper) {
        return helper.getTrackedSelection(this.selectionId);
    };
    SortLinesCommand.canRun = function (model, selection, descending) {
        var data = getSortData(model, selection, descending);
        if (!data) {
            return false;
        }
        for (var i = 0, len = data.before.length; i < len; i++) {
            if (data.before[i] !== data.after[i]) {
                return true;
            }
        }
        return false;
    };
    return SortLinesCommand;
}());

function getSortData(model, selection, descending) {
    var startLineNumber = selection.startLineNumber;
    var endLineNumber = selection.endLineNumber;
    if (selection.endColumn === 1) {
        endLineNumber--;
    }
    // Nothing to sort if user didn't select anything.
    if (startLineNumber >= endLineNumber) {
        return null;
    }
    var linesToSort = [];
    // Get the contents of the selection to be sorted.
    for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
        linesToSort.push(model.getLineContent(lineNumber));
    }
    var sorted = linesToSort.slice(0);
    sorted.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    // If descending, reverse the order.
    if (descending === true) {
        sorted = sorted.reverse();
    }
    return {
        startLineNumber: startLineNumber,
        endLineNumber: endLineNumber,
        before: linesToSort,
        after: sorted
    };
}
/**
 * Generate commands for sorting lines on a model.
 */
function sortLines(model, selection, descending) {
    var data = getSortData(model, selection, descending);
    if (!data) {
        return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0__common_core_editOperation_js__["a" /* EditOperation */].replace(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](data.startLineNumber, 1, data.endLineNumber, model.getLineMaxColumn(data.endLineNumber)), data.after.join('\n'));
}


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrimTrailingWhitespaceCommand; });
/* unused harmony export trimTrailingWhitespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var TrimTrailingWhitespaceCommand = /** @class */ (function () {
    function TrimTrailingWhitespaceCommand(selection, cursors) {
        this.selection = selection;
        this.cursors = cursors;
    }
    TrimTrailingWhitespaceCommand.prototype.getEditOperations = function (model, builder) {
        var ops = trimTrailingWhitespace(model, this.cursors);
        for (var i = 0, len = ops.length; i < len; i++) {
            var op = ops[i];
            builder.addEditOperation(op.range, op.text);
        }
        this.selectionId = builder.trackSelection(this.selection);
    };
    TrimTrailingWhitespaceCommand.prototype.computeCursorState = function (model, helper) {
        return helper.getTrackedSelection(this.selectionId);
    };
    return TrimTrailingWhitespaceCommand;
}());

/**
 * Generate commands for trimming trailing whitespace on a model and ignore lines on which cursors are sitting.
 */
function trimTrailingWhitespace(model, cursors) {
    // Sort cursors ascending
    cursors.sort(function (a, b) {
        if (a.lineNumber === b.lineNumber) {
            return a.column - b.column;
        }
        return a.lineNumber - b.lineNumber;
    });
    // Reduce multiple cursors on the same line and only keep the last one on the line
    for (var i = cursors.length - 2; i >= 0; i--) {
        if (cursors[i].lineNumber === cursors[i + 1].lineNumber) {
            // Remove cursor at `i`
            cursors.splice(i, 1);
        }
    }
    var r = [];
    var rLen = 0;
    var cursorIndex = 0;
    var cursorLen = cursors.length;
    for (var lineNumber = 1, lineCount = model.getLineCount(); lineNumber <= lineCount; lineNumber++) {
        var lineContent = model.getLineContent(lineNumber);
        var maxLineColumn = lineContent.length + 1;
        var minEditColumn = 0;
        if (cursorIndex < cursorLen && cursors[cursorIndex].lineNumber === lineNumber) {
            minEditColumn = cursors[cursorIndex].column;
            cursorIndex++;
            if (minEditColumn === maxLineColumn) {
                // The cursor is at the end of the line => no edits for sure on this line
                continue;
            }
        }
        if (lineContent.length === 0) {
            continue;
        }
        var lastNonWhitespaceIndex = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["lastNonWhitespaceIndex"](lineContent);
        var fromColumn = 0;
        if (lastNonWhitespaceIndex === -1) {
            // Entire line is whitespace
            fromColumn = 1;
        }
        else if (lastNonWhitespaceIndex !== lineContent.length - 1) {
            // There is trailing whitespace
            fromColumn = lastNonWhitespaceIndex + 2;
        }
        else {
            // There is no trailing whitespace
            continue;
        }
        fromColumn = Math.max(minEditColumn, fromColumn);
        r[rLen++] = __WEBPACK_IMPORTED_MODULE_1__core_editOperation_js__["a" /* EditOperation */].delete(new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](lineNumber, fromColumn, lineNumber, maxLineColumn));
    }
    return r;
}


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CopyLinesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__ = __webpack_require__(18);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var CopyLinesCommand = /** @class */ (function () {
    function CopyLinesCommand(selection, isCopyingDown) {
        this._selection = selection;
        this._isCopyingDown = isCopyingDown;
    }
    CopyLinesCommand.prototype.getEditOperations = function (model, builder) {
        var s = this._selection;
        this._startLineNumberDelta = 0;
        this._endLineNumberDelta = 0;
        if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
            this._endLineNumberDelta = 1;
            s = s.setEndPosition(s.endLineNumber - 1, model.getLineMaxColumn(s.endLineNumber - 1));
        }
        var sourceLines = [];
        for (var i = s.startLineNumber; i <= s.endLineNumber; i++) {
            sourceLines.push(model.getLineContent(i));
        }
        var sourceText = sourceLines.join('\n');
        if (sourceText === '') {
            // Duplicating empty line
            if (this._isCopyingDown) {
                this._startLineNumberDelta++;
                this._endLineNumberDelta++;
            }
        }
        if (!this._isCopyingDown) {
            builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](s.endLineNumber, model.getLineMaxColumn(s.endLineNumber), s.endLineNumber, model.getLineMaxColumn(s.endLineNumber)), '\n' + sourceText);
        }
        else {
            builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](s.startLineNumber, 1, s.startLineNumber, 1), sourceText + '\n');
        }
        this._selectionId = builder.trackSelection(s);
        this._selectionDirection = this._selection.getDirection();
    };
    CopyLinesCommand.prototype.computeCursorState = function (model, helper) {
        var result = helper.getTrackedSelection(this._selectionId);
        if (this._startLineNumberDelta !== 0 || this._endLineNumberDelta !== 0) {
            var startLineNumber = result.startLineNumber;
            var startColumn = result.startColumn;
            var endLineNumber = result.endLineNumber;
            var endColumn = result.endColumn;
            if (this._startLineNumberDelta !== 0) {
                startLineNumber = startLineNumber + this._startLineNumberDelta;
                startColumn = 1;
            }
            if (this._endLineNumberDelta !== 0) {
                endLineNumber = endLineNumber + this._endLineNumberDelta;
                endColumn = 1;
            }
            result = __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__["a" /* Selection */].createWithDirection(startLineNumber, startColumn, endLineNumber, endColumn, this._selectionDirection);
        }
        return result;
    };
    return CopyLinesCommand;
}());



/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteLinesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__ = __webpack_require__(18);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var DeleteLinesCommand = /** @class */ (function () {
    function DeleteLinesCommand(startLineNumber, endLineNumber, restoreCursorToColumn) {
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
        this.restoreCursorToColumn = restoreCursorToColumn;
    }
    DeleteLinesCommand.prototype.getEditOperations = function (model, builder) {
        if (model.getLineCount() === 1 && model.getLineMaxColumn(1) === 1) {
            // Model is empty
            return;
        }
        var startLineNumber = this.startLineNumber;
        var endLineNumber = this.endLineNumber;
        var startColumn = 1;
        var endColumn = model.getLineMaxColumn(endLineNumber);
        if (endLineNumber < model.getLineCount()) {
            endLineNumber += 1;
            endColumn = 1;
        }
        else if (startLineNumber > 1) {
            startLineNumber -= 1;
            startColumn = model.getLineMaxColumn(startLineNumber);
        }
        builder.addTrackedEditOperation(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](startLineNumber, startColumn, endLineNumber, endColumn), null);
    };
    DeleteLinesCommand.prototype.computeCursorState = function (model, helper) {
        var inverseEditOperations = helper.getInverseEditOperations();
        var srcRange = inverseEditOperations[0].range;
        return new __WEBPACK_IMPORTED_MODULE_1__common_core_selection_js__["a" /* Selection */](srcRange.endLineNumber, this.restoreCursorToColumn, srcRange.endLineNumber, this.restoreCursorToColumn);
    };
    return DeleteLinesCommand;
}());



/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoveLinesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_commands_shiftCommand_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfiguration_js__ = __webpack_require__(58);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var MoveLinesCommand = /** @class */ (function () {
    function MoveLinesCommand(selection, isMovingDown, autoIndent) {
        this._selection = selection;
        this._isMovingDown = isMovingDown;
        this._autoIndent = autoIndent;
        this._moveEndLineSelectionShrink = false;
    }
    MoveLinesCommand.prototype.getEditOperations = function (model, builder) {
        var modelLineCount = model.getLineCount();
        if (this._isMovingDown && this._selection.endLineNumber === modelLineCount) {
            return;
        }
        if (!this._isMovingDown && this._selection.startLineNumber === 1) {
            return;
        }
        this._moveEndPositionDown = false;
        var s = this._selection;
        if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
            this._moveEndPositionDown = true;
            s = s.setEndPosition(s.endLineNumber - 1, model.getLineMaxColumn(s.endLineNumber - 1));
        }
        var tabSize = model.getOptions().tabSize;
        var insertSpaces = model.getOptions().insertSpaces;
        var indentConverter = this.buildIndentConverter(tabSize);
        var virtualModel = {
            getLineTokens: function (lineNumber) {
                return model.getLineTokens(lineNumber);
            },
            getLanguageIdentifier: function () {
                return model.getLanguageIdentifier();
            },
            getLanguageIdAtPosition: function (lineNumber, column) {
                return model.getLanguageIdAtPosition(lineNumber, column);
            },
            getLineContent: null,
        };
        if (s.startLineNumber === s.endLineNumber && model.getLineMaxColumn(s.startLineNumber) === 1) {
            // Current line is empty
            var lineNumber = s.startLineNumber;
            var otherLineNumber = (this._isMovingDown ? lineNumber + 1 : lineNumber - 1);
            if (model.getLineMaxColumn(otherLineNumber) === 1) {
                // Other line number is empty too, so no editing is needed
                // Add a no-op to force running by the model
                builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](1, 1, 1, 1), null);
            }
            else {
                // Type content from other line number on line number
                builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](lineNumber, 1, lineNumber, 1), model.getLineContent(otherLineNumber));
                // Remove content from other line number
                builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](otherLineNumber, 1, otherLineNumber, model.getLineMaxColumn(otherLineNumber)), null);
            }
            // Track selection at the other line number
            s = new __WEBPACK_IMPORTED_MODULE_2__common_core_selection_js__["a" /* Selection */](otherLineNumber, 1, otherLineNumber, 1);
        }
        else {
            var movingLineNumber_1;
            var movingLineText = void 0;
            if (this._isMovingDown) {
                movingLineNumber_1 = s.endLineNumber + 1;
                movingLineText = model.getLineContent(movingLineNumber_1);
                // Delete line that needs to be moved
                builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](movingLineNumber_1 - 1, model.getLineMaxColumn(movingLineNumber_1 - 1), movingLineNumber_1, model.getLineMaxColumn(movingLineNumber_1)), null);
                var insertingText_1 = movingLineText;
                if (this.shouldAutoIndent(model, s)) {
                    var movingLineMatchResult = this.matchEnterRule(model, indentConverter, tabSize, movingLineNumber_1, s.startLineNumber - 1);
                    // if s.startLineNumber - 1 matches onEnter rule, we still honor that.
                    if (movingLineMatchResult !== null) {
                        var oldIndentation = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(movingLineNumber_1));
                        var newSpaceCnt = movingLineMatchResult + __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](oldIndentation, tabSize);
                        var newIndentation = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["a" /* generateIndent */](newSpaceCnt, tabSize, insertSpaces);
                        insertingText_1 = newIndentation + this.trimLeft(movingLineText);
                    }
                    else {
                        // no enter rule matches, let's check indentatin rules then.
                        virtualModel.getLineContent = function (lineNumber) {
                            if (lineNumber === s.startLineNumber) {
                                return model.getLineContent(movingLineNumber_1);
                            }
                            else {
                                return model.getLineContent(lineNumber);
                            }
                        };
                        var indentOfMovingLine = __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getGoodIndentForLine(virtualModel, model.getLanguageIdAtPosition(movingLineNumber_1, 1), s.startLineNumber, indentConverter);
                        if (indentOfMovingLine !== null) {
                            var oldIndentation = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(movingLineNumber_1));
                            var newSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](indentOfMovingLine, tabSize);
                            var oldSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](oldIndentation, tabSize);
                            if (newSpaceCnt !== oldSpaceCnt) {
                                var newIndentation = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["a" /* generateIndent */](newSpaceCnt, tabSize, insertSpaces);
                                insertingText_1 = newIndentation + this.trimLeft(movingLineText);
                            }
                        }
                    }
                    // add edit operations for moving line first to make sure it's executed after we make indentation change
                    // to s.startLineNumber
                    builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](s.startLineNumber, 1, s.startLineNumber, 1), insertingText_1 + '\n');
                    var ret = this.matchEnterRule(model, indentConverter, tabSize, s.startLineNumber, s.startLineNumber, insertingText_1);
                    // check if the line being moved before matches onEnter rules, if so let's adjust the indentation by onEnter rules.
                    if (ret !== null) {
                        if (ret !== 0) {
                            this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, ret);
                        }
                    }
                    else {
                        // it doesn't match onEnter rules, let's check indentation rules then.
                        virtualModel.getLineContent = function (lineNumber) {
                            if (lineNumber === s.startLineNumber) {
                                return insertingText_1;
                            }
                            else if (lineNumber >= s.startLineNumber + 1 && lineNumber <= s.endLineNumber + 1) {
                                return model.getLineContent(lineNumber - 1);
                            }
                            else {
                                return model.getLineContent(lineNumber);
                            }
                        };
                        var newIndentatOfMovingBlock = __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getGoodIndentForLine(virtualModel, model.getLanguageIdAtPosition(movingLineNumber_1, 1), s.startLineNumber + 1, indentConverter);
                        if (newIndentatOfMovingBlock !== null) {
                            var oldIndentation = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(s.startLineNumber));
                            var newSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](newIndentatOfMovingBlock, tabSize);
                            var oldSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](oldIndentation, tabSize);
                            if (newSpaceCnt !== oldSpaceCnt) {
                                var spaceCntOffset = newSpaceCnt - oldSpaceCnt;
                                this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, spaceCntOffset);
                            }
                        }
                    }
                }
                else {
                    // Insert line that needs to be moved before
                    builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](s.startLineNumber, 1, s.startLineNumber, 1), insertingText_1 + '\n');
                }
            }
            else {
                movingLineNumber_1 = s.startLineNumber - 1;
                movingLineText = model.getLineContent(movingLineNumber_1);
                // Delete line that needs to be moved
                builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](movingLineNumber_1, 1, movingLineNumber_1 + 1, 1), null);
                // Insert line that needs to be moved after
                builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](s.endLineNumber, model.getLineMaxColumn(s.endLineNumber), s.endLineNumber, model.getLineMaxColumn(s.endLineNumber)), '\n' + movingLineText);
                if (this.shouldAutoIndent(model, s)) {
                    virtualModel.getLineContent = function (lineNumber) {
                        if (lineNumber === movingLineNumber_1) {
                            return model.getLineContent(s.startLineNumber);
                        }
                        else {
                            return model.getLineContent(lineNumber);
                        }
                    };
                    var ret = this.matchEnterRule(model, indentConverter, tabSize, s.startLineNumber, s.startLineNumber - 2);
                    // check if s.startLineNumber - 2 matches onEnter rules, if so adjust the moving block by onEnter rules.
                    if (ret !== null) {
                        if (ret !== 0) {
                            this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, ret);
                        }
                    }
                    else {
                        // it doesn't match any onEnter rule, let's check indentation rules then.
                        var indentOfFirstLine = __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getGoodIndentForLine(virtualModel, model.getLanguageIdAtPosition(s.startLineNumber, 1), movingLineNumber_1, indentConverter);
                        if (indentOfFirstLine !== null) {
                            // adjust the indentation of the moving block
                            var oldIndent = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(s.startLineNumber));
                            var newSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](indentOfFirstLine, tabSize);
                            var oldSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](oldIndent, tabSize);
                            if (newSpaceCnt !== oldSpaceCnt) {
                                var spaceCntOffset = newSpaceCnt - oldSpaceCnt;
                                this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, spaceCntOffset);
                            }
                        }
                    }
                }
            }
        }
        this._selectionId = builder.trackSelection(s);
    };
    MoveLinesCommand.prototype.buildIndentConverter = function (tabSize) {
        return {
            shiftIndent: function (indentation) {
                var desiredIndentCount = __WEBPACK_IMPORTED_MODULE_4__common_commands_shiftCommand_js__["a" /* ShiftCommand */].shiftIndentCount(indentation, indentation.length + 1, tabSize);
                var newIndentation = '';
                for (var i = 0; i < desiredIndentCount; i++) {
                    newIndentation += '\t';
                }
                return newIndentation;
            },
            unshiftIndent: function (indentation) {
                var desiredIndentCount = __WEBPACK_IMPORTED_MODULE_4__common_commands_shiftCommand_js__["a" /* ShiftCommand */].unshiftIndentCount(indentation, indentation.length + 1, tabSize);
                var newIndentation = '';
                for (var i = 0; i < desiredIndentCount; i++) {
                    newIndentation += '\t';
                }
                return newIndentation;
            }
        };
    };
    MoveLinesCommand.prototype.matchEnterRule = function (model, indentConverter, tabSize, line, oneLineAbove, oneLineAboveText) {
        var validPrecedingLine = oneLineAbove;
        while (validPrecedingLine >= 1) {
            // ship empty lines as empty lines just inherit indentation
            var lineContent = void 0;
            if (validPrecedingLine === oneLineAbove && oneLineAboveText !== undefined) {
                lineContent = oneLineAboveText;
            }
            else {
                lineContent = model.getLineContent(validPrecedingLine);
            }
            var nonWhitespaceIdx = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["lastNonWhitespaceIndex"](lineContent);
            if (nonWhitespaceIdx >= 0) {
                break;
            }
            validPrecedingLine--;
        }
        if (validPrecedingLine < 1 || line > model.getLineCount()) {
            return null;
        }
        var maxColumn = model.getLineMaxColumn(validPrecedingLine);
        var enter = __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getEnterAction(model, new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](validPrecedingLine, maxColumn, validPrecedingLine, maxColumn));
        if (enter) {
            var enterPrefix = enter.indentation;
            var enterAction = enter.enterAction;
            if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfiguration_js__["a" /* IndentAction */].None) {
                enterPrefix = enter.indentation + enterAction.appendText;
            }
            else if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfiguration_js__["a" /* IndentAction */].Indent) {
                enterPrefix = enter.indentation + enterAction.appendText;
            }
            else if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfiguration_js__["a" /* IndentAction */].IndentOutdent) {
                enterPrefix = enter.indentation;
            }
            else if (enterAction.indentAction === __WEBPACK_IMPORTED_MODULE_6__common_modes_languageConfiguration_js__["a" /* IndentAction */].Outdent) {
                enterPrefix = indentConverter.unshiftIndent(enter.indentation) + enterAction.appendText;
            }
            var movingLineText = model.getLineContent(line);
            if (this.trimLeft(movingLineText).indexOf(this.trimLeft(enterPrefix)) >= 0) {
                var oldIndentation = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["getLeadingWhitespace"](model.getLineContent(line));
                var newIndentation = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["getLeadingWhitespace"](enterPrefix);
                var indentMetadataOfMovelingLine = __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getIndentMetadata(model, line);
                if (indentMetadataOfMovelingLine & 2 /* DECREASE_MASK */) {
                    newIndentation = indentConverter.unshiftIndent(newIndentation);
                }
                var newSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](newIndentation, tabSize);
                var oldSpaceCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](oldIndentation, tabSize);
                return newSpaceCnt - oldSpaceCnt;
            }
        }
        return null;
    };
    MoveLinesCommand.prototype.trimLeft = function (str) {
        return str.replace(/^\s+/, '');
    };
    MoveLinesCommand.prototype.shouldAutoIndent = function (model, selection) {
        if (!this._autoIndent) {
            return false;
        }
        // if it's not easy to tokenize, we stop auto indent.
        if (!model.isCheapToTokenize(selection.startLineNumber)) {
            return false;
        }
        var languageAtSelectionStart = model.getLanguageIdAtPosition(selection.startLineNumber, 1);
        var languageAtSelectionEnd = model.getLanguageIdAtPosition(selection.endLineNumber, 1);
        if (languageAtSelectionStart !== languageAtSelectionEnd) {
            return false;
        }
        if (__WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getIndentRulesSupport(languageAtSelectionStart) === null) {
            return false;
        }
        return true;
    };
    MoveLinesCommand.prototype.getIndentEditsOfMovingBlock = function (model, builder, s, tabSize, insertSpaces, offset) {
        for (var i = s.startLineNumber; i <= s.endLineNumber; i++) {
            var lineContent = model.getLineContent(i);
            var originalIndent = __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["getLeadingWhitespace"](lineContent);
            var originalSpacesCnt = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["b" /* getSpaceCnt */](originalIndent, tabSize);
            var newSpacesCnt = originalSpacesCnt + offset;
            var newIndent = __WEBPACK_IMPORTED_MODULE_5__indentation_indentUtils_js__["a" /* generateIndent */](newSpacesCnt, tabSize, insertSpaces);
            if (newIndent !== originalIndent) {
                builder.addEditOperation(new __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */](i, 1, i, originalIndent.length + 1), newIndent);
                if (i === s.endLineNumber && s.endColumn <= originalIndent.length + 1 && newIndent === '') {
                    // as users select part of the original indent white spaces
                    // when we adjust the indentation of endLine, we should adjust the cursor position as well.
                    this._moveEndLineSelectionShrink = true;
                }
            }
        }
    };
    MoveLinesCommand.prototype.computeCursorState = function (model, helper) {
        var result = helper.getTrackedSelection(this._selectionId);
        if (this._moveEndPositionDown) {
            result = result.setEndPosition(result.endLineNumber + 1, 1);
        }
        if (this._moveEndLineSelectionShrink && result.startLineNumber < result.endLineNumber) {
            result = result.setEndPosition(result.endLineNumber, 2);
        }
        return result;
    };
    return MoveLinesCommand;
}());



/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSpaceCnt;
/* harmony export (immutable) */ __webpack_exports__["a"] = generateIndent;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
function getSpaceCnt(str, tabSize) {
    var spacesCnt = 0;
    for (var i = 0; i < str.length; i++) {
        if (str.charAt(i) === '\t') {
            spacesCnt += tabSize;
        }
        else {
            spacesCnt++;
        }
    }
    return spacesCnt;
}
function generateIndent(spacesCnt, tabSize, insertSpaces) {
    spacesCnt = spacesCnt < 0 ? 0 : spacesCnt;
    var result = '';
    if (!insertSpaces) {
        var tabsCnt = Math.floor(spacesCnt / tabSize);
        spacesCnt = spacesCnt % tabSize;
        for (var i = 0; i < tabsCnt; i++) {
            result += '\t';
        }
    }
    for (var i = 0; i < spacesCnt; i++) {
        result += ' ';
    }
    return result;
}


/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLinks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/










var Link = /** @class */ (function () {
    function Link(link, provider) {
        this._link = link;
        this._provider = provider;
    }
    Link.prototype.toJSON = function () {
        return {
            range: this.range,
            url: this.url
        };
    };
    Object.defineProperty(Link.prototype, "range", {
        get: function () {
            return this._link.range;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Link.prototype, "url", {
        get: function () {
            return this._link.url;
        },
        enumerable: true,
        configurable: true
    });
    Link.prototype.resolve = function () {
        var _this = this;
        if (this._link.url) {
            try {
                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(__WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */].parse(this._link.url));
            }
            catch (e) {
                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error('invalid'));
            }
        }
        if (typeof this._provider.resolveLink === 'function') {
            return Object(__WEBPACK_IMPORTED_MODULE_5__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return _this._provider.resolveLink(_this._link, token); }).then(function (value) {
                _this._link = value || _this._link;
                if (_this._link.url) {
                    // recurse
                    return _this.resolve();
                }
                return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error('missing'));
            });
        }
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error('missing'));
    };
    return Link;
}());

function getLinks(model, token) {
    var links = [];
    // ask all providers for links in parallel
    var promises = __WEBPACK_IMPORTED_MODULE_4__common_modes_js__["p" /* LinkProviderRegistry */].ordered(model).reverse().map(function (provider) {
        return Promise.resolve(provider.provideLinks(model, token)).then(function (result) {
            if (Array.isArray(result)) {
                var newLinks = result.map(function (link) { return new Link(link, provider); });
                links = union(links, newLinks);
            }
        }, __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["f" /* onUnexpectedExternalError */]);
    });
    return Promise.all(promises).then(function () {
        return links;
    });
}
function union(oldLinks, newLinks) {
    // reunite oldLinks with newLinks and remove duplicates
    var result = [];
    var oldIndex;
    var oldLen;
    var newIndex;
    var newLen;
    for (oldIndex = 0, newIndex = 0, oldLen = oldLinks.length, newLen = newLinks.length; oldIndex < oldLen && newIndex < newLen;) {
        var oldLink = oldLinks[oldIndex];
        var newLink = newLinks[newIndex];
        if (__WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */].areIntersectingOrTouching(oldLink.range, newLink.range)) {
            // Remove the oldLink
            oldIndex++;
            continue;
        }
        var comparisonResult = __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(oldLink.range, newLink.range);
        if (comparisonResult < 0) {
            // oldLink is before
            result.push(oldLink);
            oldIndex++;
        }
        else {
            // newLink is before
            result.push(newLink);
            newIndex++;
        }
    }
    for (; oldIndex < oldLen; oldIndex++) {
        result.push(oldLinks[oldIndex]);
    }
    for (; newIndex < newLen; newIndex++) {
        result.push(newLinks[newIndex]);
    }
    return result;
}
__WEBPACK_IMPORTED_MODULE_6__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand('_executeLinkProvider', function (accessor) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var uri = args[0];
    if (!(uri instanceof __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */])) {
        return undefined;
    }
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_7__common_services_modelService_js__["a" /* IModelService */]).getModel(uri);
    if (!model) {
        return undefined;
    }
    return getLinks(model, __WEBPACK_IMPORTED_MODULE_8__base_common_cancellation_js__["a" /* CancellationToken */].None);
});


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ParameterHintsModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParameterHintsWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parameterHints_css__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parameterHints_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__parameterHints_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_browser_event_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__provideSignatureHelp_js__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_browser_ui_scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_core_characterClassifier_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__platform_opener_common_opener_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_services_modeService_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__markdown_markdownRenderer_js__ = __webpack_require__(167);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





















var $ = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["a" /* $ */];
var ParameterHintsModel = /** @class */ (function (_super) {
    __extends(ParameterHintsModel, _super);
    function ParameterHintsModel(editor) {
        var _this = _super.call(this) || this;
        _this._onHint = _this._register(new __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__["a" /* Emitter */]());
        _this.onHint = _this._onHint.event;
        _this._onCancel = _this._register(new __WEBPACK_IMPORTED_MODULE_10__base_common_event_js__["a" /* Emitter */]());
        _this.onCancel = _this._onCancel.event;
        _this.editor = editor;
        _this.enabled = false;
        _this.triggerCharactersListeners = [];
        _this.throttledDelayer = new __WEBPACK_IMPORTED_MODULE_8__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this.doTrigger(); }, ParameterHintsModel.DELAY);
        _this.active = false;
        _this._register(_this.editor.onDidChangeConfiguration(function () { return _this.onEditorConfigurationChange(); }));
        _this._register(_this.editor.onDidChangeModel(function (e) { return _this.onModelChanged(); }));
        _this._register(_this.editor.onDidChangeModelLanguage(function (_) { return _this.onModelChanged(); }));
        _this._register(_this.editor.onDidChangeCursorSelection(function (e) { return _this.onCursorChange(e); }));
        _this._register(_this.editor.onDidChangeModelContent(function (e) { return _this.onModelContentChange(); }));
        _this._register(__WEBPACK_IMPORTED_MODULE_6__common_modes_js__["t" /* SignatureHelpProviderRegistry */].onDidChange(_this.onModelChanged, _this));
        _this.onEditorConfigurationChange();
        _this.onModelChanged();
        return _this;
    }
    ParameterHintsModel.prototype.cancel = function (silent) {
        if (silent === void 0) { silent = false; }
        this.active = false;
        this.throttledDelayer.cancel();
        if (!silent) {
            this._onCancel.fire(void 0);
        }
        if (this.provideSignatureHelpRequest) {
            this.provideSignatureHelpRequest.cancel();
            this.provideSignatureHelpRequest = undefined;
        }
    };
    ParameterHintsModel.prototype.trigger = function (delay) {
        if (delay === void 0) { delay = ParameterHintsModel.DELAY; }
        if (!__WEBPACK_IMPORTED_MODULE_6__common_modes_js__["t" /* SignatureHelpProviderRegistry */].has(this.editor.getModel())) {
            return;
        }
        this.cancel(true);
        return this.throttledDelayer.schedule(delay);
    };
    ParameterHintsModel.prototype.doTrigger = function () {
        var _this = this;
        if (this.provideSignatureHelpRequest) {
            this.provideSignatureHelpRequest.cancel();
        }
        this.provideSignatureHelpRequest = Object(__WEBPACK_IMPORTED_MODULE_8__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return Object(__WEBPACK_IMPORTED_MODULE_13__provideSignatureHelp_js__["b" /* provideSignatureHelp */])(_this.editor.getModel(), _this.editor.getPosition(), token); });
        this.provideSignatureHelpRequest.then(function (result) {
            if (!result || !result.signatures || result.signatures.length === 0) {
                _this.cancel();
                _this._onCancel.fire(void 0);
                return false;
            }
            _this.active = true;
            var event = { hints: result };
            _this._onHint.fire(event);
            return true;
        }).catch(__WEBPACK_IMPORTED_MODULE_9__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    ParameterHintsModel.prototype.isTriggered = function () {
        return this.active || this.throttledDelayer.isScheduled();
    };
    ParameterHintsModel.prototype.onModelChanged = function () {
        var _this = this;
        this.cancel();
        this.triggerCharactersListeners = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this.triggerCharactersListeners);
        var model = this.editor.getModel();
        if (!model) {
            return;
        }
        var triggerChars = new __WEBPACK_IMPORTED_MODULE_15__common_core_characterClassifier_js__["b" /* CharacterSet */]();
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_6__common_modes_js__["t" /* SignatureHelpProviderRegistry */].ordered(model); _i < _a.length; _i++) {
            var support = _a[_i];
            if (Array.isArray(support.signatureHelpTriggerCharacters)) {
                for (var _b = 0, _c = support.signatureHelpTriggerCharacters; _b < _c.length; _b++) {
                    var ch = _c[_b];
                    triggerChars.add(ch.charCodeAt(0));
                }
            }
        }
        this.triggerCharactersListeners.push(this.editor.onDidType(function (text) {
            if (!_this.enabled) {
                return;
            }
            if (triggerChars.has(text.charCodeAt(text.length - 1))) {
                _this.trigger();
            }
        }));
    };
    ParameterHintsModel.prototype.onCursorChange = function (e) {
        if (e.source === 'mouse') {
            this.cancel();
        }
        else if (this.isTriggered()) {
            this.trigger();
        }
    };
    ParameterHintsModel.prototype.onModelContentChange = function () {
        if (this.isTriggered()) {
            this.trigger();
        }
    };
    ParameterHintsModel.prototype.onEditorConfigurationChange = function () {
        this.enabled = this.editor.getConfiguration().contribInfo.parameterHints;
        if (!this.enabled) {
            this.cancel();
        }
    };
    ParameterHintsModel.prototype.dispose = function () {
        this.cancel(true);
        this.triggerCharactersListeners = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this.triggerCharactersListeners);
        _super.prototype.dispose.call(this);
    };
    ParameterHintsModel.DELAY = 120; // ms
    return ParameterHintsModel;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));

var ParameterHintsWidget = /** @class */ (function () {
    function ParameterHintsWidget(editor, contextKeyService, openerService, modeService) {
        var _this = this;
        this.editor = editor;
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = true;
        this.markdownRenderer = new __WEBPACK_IMPORTED_MODULE_20__markdown_markdownRenderer_js__["a" /* MarkdownRenderer */](editor, modeService, openerService);
        this.model = new ParameterHintsModel(editor);
        this.keyVisible = __WEBPACK_IMPORTED_MODULE_13__provideSignatureHelp_js__["a" /* Context */].Visible.bindTo(contextKeyService);
        this.keyMultipleSignatures = __WEBPACK_IMPORTED_MODULE_13__provideSignatureHelp_js__["a" /* Context */].MultipleSignatures.bindTo(contextKeyService);
        this.visible = false;
        this.disposables = [];
        this.disposables.push(this.model.onHint(function (e) {
            _this.show();
            _this.hints = e.hints;
            _this.currentSignature = e.hints.activeSignature;
            _this.render();
        }));
        this.disposables.push(this.model.onCancel(function () {
            _this.hide();
        }));
    }
    ParameterHintsWidget.prototype.createParamaterHintDOMNodes = function () {
        var _this = this;
        this.element = $('.editor-widget.parameter-hints-widget');
        var wrapper = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](this.element, $('.wrapper'));
        var buttons = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](wrapper, $('.buttons'));
        var previous = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](buttons, $('.button.previous'));
        var next = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](buttons, $('.button.next'));
        var onPreviousClick = Object(__WEBPACK_IMPORTED_MODULE_11__base_browser_event_js__["b" /* stop */])(Object(__WEBPACK_IMPORTED_MODULE_11__base_browser_event_js__["a" /* domEvent */])(previous, 'click'));
        onPreviousClick(this.previous, this, this.disposables);
        var onNextClick = Object(__WEBPACK_IMPORTED_MODULE_11__base_browser_event_js__["b" /* stop */])(Object(__WEBPACK_IMPORTED_MODULE_11__base_browser_event_js__["a" /* domEvent */])(next, 'click'));
        onNextClick(this.next, this, this.disposables);
        this.overloads = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](wrapper, $('.overloads'));
        var body = $('.body');
        this.scrollbar = new __WEBPACK_IMPORTED_MODULE_14__base_browser_ui_scrollbar_scrollableElement_js__["a" /* DomScrollableElement */](body, {});
        this.disposables.push(this.scrollbar);
        wrapper.appendChild(this.scrollbar.getDomNode());
        this.signature = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](body, $('.signature'));
        this.docs = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](body, $('.docs'));
        this.currentSignature = 0;
        this.editor.addContentWidget(this);
        this.hide();
        this.disposables.push(this.editor.onDidChangeCursorSelection(function (e) {
            if (_this.visible) {
                _this.editor.layoutContentWidget(_this);
            }
        }));
        var updateFont = function () {
            var fontInfo = _this.editor.getConfiguration().fontInfo;
            _this.element.style.fontSize = fontInfo.fontSize + "px";
        };
        updateFont();
        Object(__WEBPACK_IMPORTED_MODULE_10__base_common_event_js__["g" /* chain */])(this.editor.onDidChangeConfiguration.bind(this.editor))
            .filter(function (e) { return e.fontInfo; })
            .on(updateFont, null, this.disposables);
        this.disposables.push(this.editor.onDidLayoutChange(function (e) { return _this.updateMaxHeight(); }));
        this.updateMaxHeight();
    };
    ParameterHintsWidget.prototype.show = function () {
        var _this = this;
        if (!this.model || this.visible) {
            return;
        }
        if (!this.element) {
            this.createParamaterHintDOMNodes();
        }
        this.keyVisible.set(true);
        this.visible = true;
        __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].timeout(100).done(function () { return __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["f" /* addClass */](_this.element, 'visible'); });
        this.editor.layoutContentWidget(this);
    };
    ParameterHintsWidget.prototype.hide = function () {
        if (!this.model || !this.visible) {
            return;
        }
        if (!this.element) {
            this.createParamaterHintDOMNodes();
        }
        this.keyVisible.reset();
        this.visible = false;
        this.hints = null;
        this.announcedLabel = null;
        __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["G" /* removeClass */](this.element, 'visible');
        this.editor.layoutContentWidget(this);
    };
    ParameterHintsWidget.prototype.getPosition = function () {
        if (this.visible) {
            return {
                position: this.editor.getPosition(),
                preference: [__WEBPACK_IMPORTED_MODULE_7__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE, __WEBPACK_IMPORTED_MODULE_7__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].BELOW]
            };
        }
        return null;
    };
    ParameterHintsWidget.prototype.render = function () {
        var multiple = this.hints.signatures.length > 1;
        __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["N" /* toggleClass */](this.element, 'multiple', multiple);
        this.keyMultipleSignatures.set(multiple);
        this.signature.innerHTML = '';
        this.docs.innerHTML = '';
        var signature = this.hints.signatures[this.currentSignature];
        if (!signature) {
            return;
        }
        var code = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](this.signature, $('.code'));
        var hasParameters = signature.parameters.length > 0;
        var fontInfo = this.editor.getConfiguration().fontInfo;
        code.style.fontSize = fontInfo.fontSize + "px";
        code.style.fontFamily = fontInfo.fontFamily;
        if (!hasParameters) {
            var label = __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](code, $('span'));
            label.textContent = signature.label;
        }
        else {
            this.renderParameters(code, signature, this.hints.activeParameter);
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this.renderDisposeables);
        this.renderDisposeables = [];
        var activeParameter = signature.parameters[this.hints.activeParameter];
        if (activeParameter && activeParameter.documentation) {
            var documentation = $('span.documentation');
            if (typeof activeParameter.documentation === 'string') {
                documentation.textContent = activeParameter.documentation;
            }
            else {
                var renderedContents = this.markdownRenderer.render(activeParameter.documentation);
                __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["f" /* addClass */](renderedContents.element, 'markdown-docs');
                this.renderDisposeables.push(renderedContents);
                documentation.appendChild(renderedContents.element);
            }
            __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](this.docs, $('p', null, documentation));
        }
        __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["N" /* toggleClass */](this.signature, 'has-docs', !!signature.documentation);
        if (typeof signature.documentation === 'string') {
            __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](this.docs, $('p', null, signature.documentation));
        }
        else {
            var renderedContents = this.markdownRenderer.render(signature.documentation);
            __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["f" /* addClass */](renderedContents.element, 'markdown-docs');
            this.renderDisposeables.push(renderedContents);
            __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["k" /* append */](this.docs, renderedContents.element);
        }
        var currentOverload = String(this.currentSignature + 1);
        if (this.hints.signatures.length < 10) {
            currentOverload += "/" + this.hints.signatures.length;
        }
        this.overloads.textContent = currentOverload;
        if (activeParameter) {
            var labelToAnnounce = activeParameter.label;
            // Select method gets called on every user type while parameter hints are visible.
            // We do not want to spam the user with same announcements, so we only announce if the current parameter changed.
            if (this.announcedLabel !== labelToAnnounce) {
                __WEBPACK_IMPORTED_MODULE_5__base_browser_ui_aria_aria_js__["a" /* alert */](__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('hint', "{0}, hint", labelToAnnounce));
                this.announcedLabel = labelToAnnounce;
            }
        }
        this.editor.layoutContentWidget(this);
        this.scrollbar.scanDomNode();
    };
    ParameterHintsWidget.prototype.renderParameters = function (parent, signature, currentParameter) {
        var end = signature.label.length;
        var idx = 0;
        var element;
        for (var i = signature.parameters.length - 1; i >= 0; i--) {
            var parameter = signature.parameters[i];
            idx = signature.label.lastIndexOf(parameter.label, end - 1);
            var signatureLabelOffset = 0;
            var signatureLabelEnd = 0;
            if (idx >= 0) {
                signatureLabelOffset = idx;
                signatureLabelEnd = idx + parameter.label.length;
            }
            // non parameter part
            element = document.createElement('span');
            element.textContent = signature.label.substring(signatureLabelEnd, end);
            __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["E" /* prepend */](parent, element);
            // parameter part
            element = document.createElement('span');
            element.className = "parameter " + (i === currentParameter ? 'active' : '');
            element.textContent = signature.label.substring(signatureLabelOffset, signatureLabelEnd);
            __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["E" /* prepend */](parent, element);
            end = signatureLabelOffset;
        }
        // non parameter part
        element = document.createElement('span');
        element.textContent = signature.label.substring(0, end);
        __WEBPACK_IMPORTED_MODULE_4__base_browser_dom_js__["E" /* prepend */](parent, element);
    };
    // private select(position: number): void {
    // 	const signature = this.signatureViews[position];
    // 	if (!signature) {
    // 		return;
    // 	}
    // 	this.signatures.style.height = `${ signature.height }px`;
    // 	this.signatures.scrollTop = signature.top;
    // 	let overloads = '' + (position + 1);
    // 	if (this.signatureViews.length < 10) {
    // 		overloads += '/' + this.signatureViews.length;
    // 	}
    // 	this.overloads.textContent = overloads;
    // 	if (this.hints && this.hints.signatures[position].parameters[this.hints.activeParameter]) {
    // 		const labelToAnnounce = this.hints.signatures[position].parameters[this.hints.activeParameter].label;
    // 		// Select method gets called on every user type while parameter hints are visible.
    // 		// We do not want to spam the user with same announcements, so we only announce if the current parameter changed.
    // 		if (this.announcedLabel !== labelToAnnounce) {
    // 			aria.alert(nls.localize('hint', "{0}, hint", labelToAnnounce));
    // 			this.announcedLabel = labelToAnnounce;
    // 		}
    // 	}
    // 	this.editor.layoutContentWidget(this);
    // }
    ParameterHintsWidget.prototype.next = function () {
        var length = this.hints.signatures.length;
        var last = (this.currentSignature % length) === (length - 1);
        // If there is only one signature, or we're on last signature of list
        if (length < 2 || last) {
            this.cancel();
            return false;
        }
        this.currentSignature++;
        this.render();
        return true;
    };
    ParameterHintsWidget.prototype.previous = function () {
        var length = this.hints.signatures.length;
        var first = this.currentSignature === 0;
        if (length < 2 || first) {
            this.cancel();
            return false;
        }
        this.currentSignature--;
        this.render();
        return true;
    };
    ParameterHintsWidget.prototype.cancel = function () {
        this.model.cancel();
    };
    ParameterHintsWidget.prototype.getDomNode = function () {
        return this.element;
    };
    ParameterHintsWidget.prototype.getId = function () {
        return ParameterHintsWidget.ID;
    };
    ParameterHintsWidget.prototype.trigger = function () {
        this.model.trigger(0);
    };
    ParameterHintsWidget.prototype.updateMaxHeight = function () {
        var height = Math.max(this.editor.getLayoutInfo().height / 4, 250);
        this.element.style.maxHeight = height + "px";
    };
    ParameterHintsWidget.prototype.dispose = function () {
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this.disposables);
        this.renderDisposeables = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this.renderDisposeables);
        if (this.model) {
            this.model.dispose();
            this.model = null;
        }
    };
    ParameterHintsWidget.ID = 'editor.widget.parameterHintsWidget';
    ParameterHintsWidget = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_12__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_18__platform_opener_common_opener_js__["a" /* IOpenerService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_19__common_services_modeService_js__["a" /* IModeService */])
    ], ParameterHintsWidget);
    return ParameterHintsWidget;
}());

Object(__WEBPACK_IMPORTED_MODULE_16__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var border = theme.getColor(__WEBPACK_IMPORTED_MODULE_17__platform_theme_common_colorRegistry_js__["w" /* editorHoverBorder */]);
    if (border) {
        var borderWidth = theme.type === __WEBPACK_IMPORTED_MODULE_16__platform_theme_common_themeService_js__["b" /* HIGH_CONTRAST */] ? 2 : 1;
        collector.addRule(".monaco-editor .parameter-hints-widget { border: " + borderWidth + "px solid " + border + "; }");
        collector.addRule(".monaco-editor .parameter-hints-widget.multiple .body { border-left: 1px solid " + border.transparent(0.5) + "; }");
        collector.addRule(".monaco-editor .parameter-hints-widget .signature.has-docs { border-bottom: 1px solid " + border.transparent(0.5) + "; }");
    }
    var background = theme.getColor(__WEBPACK_IMPORTED_MODULE_17__platform_theme_common_colorRegistry_js__["v" /* editorHoverBackground */]);
    if (background) {
        collector.addRule(".monaco-editor .parameter-hints-widget { background-color: " + background + "; }");
    }
    var link = theme.getColor(__WEBPACK_IMPORTED_MODULE_17__platform_theme_common_colorRegistry_js__["_16" /* textLinkForeground */]);
    if (link) {
        collector.addRule(".monaco-editor .parameter-hints-widget a { color: " + link + "; }");
    }
    var codeBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_17__platform_theme_common_colorRegistry_js__["_15" /* textCodeBlockBackground */]);
    if (codeBackground) {
        collector.addRule(".monaco-editor .parameter-hints-widget code { background-color: " + codeBackground + "; }");
    }
});


/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentSymbols;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/









function getDocumentSymbols(model) {
    var roots = [];
    var promises = __WEBPACK_IMPORTED_MODULE_5__common_modes_js__["j" /* DocumentSymbolProviderRegistry */].all(model).map(function (support) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__base_common_async_js__["h" /* asWinJsPromise */])(function (token) { return support.provideDocumentSymbols(model, token); }).then(function (result) {
            if (Array.isArray(result)) {
                roots.push.apply(roots, result);
            }
        }, function (err) {
            Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["f" /* onUnexpectedExternalError */])(err);
        });
    });
    return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].join(promises).then(function () {
        var flatEntries = [];
        flatten(flatEntries, roots, '');
        flatEntries.sort(compareEntriesUsingStart);
        return flatEntries;
    });
}
function compareEntriesUsingStart(a, b) {
    return __WEBPACK_IMPORTED_MODULE_3__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(a.range, b.range);
}
function flatten(bucket, entries, overrideContainerLabel) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var entry = entries_1[_i];
        bucket.push({
            kind: entry.kind,
            name: entry.name,
            detail: entry.detail,
            containerName: entry.containerName || overrideContainerLabel,
            range: entry.range,
            selectionRange: entry.selectionRange,
            children: undefined,
        });
        if (entry.children) {
            flatten(bucket, entry.children, entry.name);
        }
    }
}
Object(__WEBPACK_IMPORTED_MODULE_4__browser_editorExtensions_js__["j" /* registerLanguageCommand */])('_executeDocumentSymbolProvider', function (accessor, args) {
    var resource = args.resource;
    if (!(resource instanceof __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */])) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('resource');
    }
    var model = accessor.get(__WEBPACK_IMPORTED_MODULE_6__common_services_modelService_js__["a" /* IModelService */]).getModel(resource);
    if (!model) {
        throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["b" /* illegalArgument */])('resource');
    }
    return getDocumentSymbols(model);
});


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__renameInputField_css__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__renameInputField_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__renameInputField_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};









var RenameInputField = /** @class */ (function () {
    function RenameInputField(editor, themeService) {
        var _this = this;
        this.themeService = themeService;
        this._disposables = [];
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = true;
        this._currentAcceptInput = null;
        this._currentCancelInput = null;
        this._editor = editor;
        this._editor.addContentWidget(this);
        this._disposables.push(editor.onDidChangeConfiguration(function (e) {
            if (e.fontInfo) {
                _this.updateFont();
            }
        }));
        this._disposables.push(themeService.onThemeChange(function (theme) { return _this.onThemeChange(theme); }));
    }
    RenameInputField.prototype.onThemeChange = function (theme) {
        this.updateStyles(theme);
    };
    RenameInputField.prototype.dispose = function () {
        this._disposables = Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        this._editor.removeContentWidget(this);
    };
    RenameInputField.prototype.getId = function () {
        return '__renameInputWidget';
    };
    RenameInputField.prototype.getDomNode = function () {
        if (!this._domNode) {
            this._inputField = document.createElement('input');
            this._inputField.className = 'rename-input';
            this._inputField.type = 'text';
            this._inputField.setAttribute('aria-label', Object(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */])('renameAriaLabel', "Rename input. Type new name and press Enter to commit."));
            this._domNode = document.createElement('div');
            this._domNode.style.height = this._editor.getConfiguration().lineHeight + "px";
            this._domNode.className = 'monaco-editor rename-box';
            this._domNode.appendChild(this._inputField);
            this.updateFont();
            this.updateStyles(this.themeService.getTheme());
        }
        return this._domNode;
    };
    RenameInputField.prototype.updateStyles = function (theme) {
        if (!this._inputField) {
            return;
        }
        var background = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["K" /* inputBackground */]);
        var foreground = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["M" /* inputForeground */]);
        var widgetShadowColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["_17" /* widgetShadow */]);
        var border = theme.getColor(__WEBPACK_IMPORTED_MODULE_7__platform_theme_common_colorRegistry_js__["L" /* inputBorder */]);
        this._inputField.style.backgroundColor = background ? background.toString() : null;
        this._inputField.style.color = foreground ? foreground.toString() : null;
        this._inputField.style.borderWidth = border ? '1px' : '0px';
        this._inputField.style.borderStyle = border ? 'solid' : 'none';
        this._inputField.style.borderColor = border ? border.toString() : 'none';
        this._domNode.style.boxShadow = widgetShadowColor ? " 0 2px 8px " + widgetShadowColor : null;
    };
    RenameInputField.prototype.updateFont = function () {
        if (!this._inputField) {
            return;
        }
        var fontInfo = this._editor.getConfiguration().fontInfo;
        this._inputField.style.fontFamily = fontInfo.fontFamily;
        this._inputField.style.fontWeight = fontInfo.fontWeight;
        this._inputField.style.fontSize = fontInfo.fontSize + "px";
    };
    RenameInputField.prototype.getPosition = function () {
        return this._visible
            ? { position: this._position, preference: [__WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].BELOW, __WEBPACK_IMPORTED_MODULE_5__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE] }
            : null;
    };
    RenameInputField.prototype.acceptInput = function () {
        if (this._currentAcceptInput) {
            this._currentAcceptInput();
        }
    };
    RenameInputField.prototype.cancelInput = function (focusEditor) {
        if (this._currentCancelInput) {
            this._currentCancelInput(focusEditor);
        }
    };
    RenameInputField.prototype.getInput = function (where, value, selectionStart, selectionEnd) {
        var _this = this;
        this._position = new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](where.startLineNumber, where.startColumn);
        this._inputField.value = value;
        this._inputField.setAttribute('selectionStart', selectionStart.toString());
        this._inputField.setAttribute('selectionEnd', selectionEnd.toString());
        this._inputField.size = Math.max((where.endColumn - where.startColumn) * 1.1, 20);
        var disposeOnDone = [], always;
        always = function () {
            Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["d" /* dispose */])(disposeOnDone);
            _this._hide();
        };
        return new __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */](function (resolve) {
            _this._currentCancelInput = function (focusEditor) {
                _this._currentAcceptInput = null;
                _this._currentCancelInput = null;
                resolve(focusEditor);
                return true;
            };
            _this._currentAcceptInput = function () {
                if (_this._inputField.value.trim().length === 0 || _this._inputField.value === value) {
                    // empty or whitespace only or not changed
                    _this.cancelInput(true);
                    return;
                }
                _this._currentAcceptInput = null;
                _this._currentCancelInput = null;
                resolve(_this._inputField.value);
            };
            var onCursorChanged = function () {
                if (!__WEBPACK_IMPORTED_MODULE_4__common_core_range_js__["a" /* Range */].containsPosition(where, _this._editor.getPosition())) {
                    _this.cancelInput(true);
                }
            };
            disposeOnDone.push(_this._editor.onDidChangeCursorSelection(onCursorChanged));
            disposeOnDone.push(_this._editor.onDidBlurEditorWidget(function () { return _this.cancelInput(false); }));
            _this._show();
        }, function () {
            _this._currentCancelInput(true);
        }).then(function (newValue) {
            always();
            return newValue;
        }, function (err) {
            always();
            return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].wrapError(err);
        });
    };
    RenameInputField.prototype._show = function () {
        var _this = this;
        this._editor.revealLineInCenterIfOutsideViewport(this._position.lineNumber, 0 /* Smooth */);
        this._visible = true;
        this._editor.layoutContentWidget(this);
        setTimeout(function () {
            _this._inputField.focus();
            _this._inputField.setSelectionRange(parseInt(_this._inputField.getAttribute('selectionStart')), parseInt(_this._inputField.getAttribute('selectionEnd')));
        }, 100);
    };
    RenameInputField.prototype._hide = function () {
        this._visible = false;
        this._editor.layoutContentWidget(this);
    };
    RenameInputField = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__["c" /* IThemeService */])
    ], RenameInputField);
    return RenameInputField;
}());
/* harmony default export */ __webpack_exports__["a"] = (RenameInputField);


/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenSelectionSupport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_services_modelService_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tokenTree_js__ = __webpack_require__(496);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};




var TokenSelectionSupport = /** @class */ (function () {
    function TokenSelectionSupport(modelService) {
        this._modelService = modelService;
    }
    TokenSelectionSupport.prototype.getRangesToPosition = function (resource, position) {
        return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(this.getRangesToPositionSync(resource, position));
    };
    TokenSelectionSupport.prototype.getRangesToPositionSync = function (resource, position) {
        var model = this._modelService.getModel(resource);
        var entries = [];
        if (model) {
            this._doGetRangesToPosition(model, position).forEach(function (range) {
                entries.push({
                    type: void 0,
                    range: range
                });
            });
        }
        return entries;
    };
    TokenSelectionSupport.prototype._doGetRangesToPosition = function (model, position) {
        var tree = Object(__WEBPACK_IMPORTED_MODULE_3__tokenTree_js__["a" /* build */])(model);
        var node;
        var lastRange;
        node = Object(__WEBPACK_IMPORTED_MODULE_3__tokenTree_js__["b" /* find */])(tree, position);
        var ranges = [];
        while (node) {
            if (!lastRange || !__WEBPACK_IMPORTED_MODULE_1__common_core_range_js__["a" /* Range */].equalsRange(lastRange, node.range)) {
                ranges.push(node.range);
            }
            lastRange = node.range;
            node = node.parent;
        }
        ranges = ranges.reverse();
        return ranges;
    };
    TokenSelectionSupport = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_2__common_services_modelService_js__["a" /* IModelService */])
    ], TokenSelectionSupport);
    return TokenSelectionSupport;
}());



/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Node */
/* unused harmony export NodeList */
/* unused harmony export Block */
/* harmony export (immutable) */ __webpack_exports__["a"] = build;
/* harmony export (immutable) */ __webpack_exports__["b"] = find;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modes_supports_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_modes_supports_richEditBrackets_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Node = /** @class */ (function () {
    function Node() {
    }
    Object.defineProperty(Node.prototype, "range", {
        get: function () {
            return new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](this.start.lineNumber, this.start.column, this.end.lineNumber, this.end.column);
        },
        enumerable: true,
        configurable: true
    });
    return Node;
}());

var NodeList = /** @class */ (function (_super) {
    __extends(NodeList, _super);
    function NodeList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NodeList.prototype, "hasChildren", {
        get: function () {
            return this.children && this.children.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeList.prototype, "isEmpty", {
        get: function () {
            return !this.hasChildren && !this.parent;
        },
        enumerable: true,
        configurable: true
    });
    NodeList.prototype.append = function (node) {
        if (!node) {
            return false;
        }
        node.parent = this;
        if (!this.children) {
            this.children = [];
        }
        if (node instanceof NodeList) {
            if (node.children) {
                this.children.push.apply(this.children, node.children);
            }
        }
        else {
            this.children.push(node);
        }
        return true;
    };
    return NodeList;
}(Node));

var Block = /** @class */ (function (_super) {
    __extends(Block, _super);
    function Block() {
        var _this = _super.call(this) || this;
        _this.elements = new NodeList();
        _this.elements.parent = _this;
        return _this;
    }
    return Block;
}(Node));

var Token = /** @class */ (function () {
    function Token(range, bracket, bracketType) {
        this.range = range;
        this.bracket = bracket;
        this.bracketType = bracketType;
    }
    return Token;
}());
function newNode(token) {
    var node = new Node();
    node.start = token.range.getStartPosition();
    node.end = token.range.getEndPosition();
    return node;
}
var RawToken = /** @class */ (function () {
    function RawToken(source, tokenIndex, lineNumber) {
        this.lineNumber = lineNumber;
        this.lineText = source.getLineContent();
        this.startOffset = source.getStartOffset(tokenIndex);
        this.endOffset = source.getEndOffset(tokenIndex);
        this.type = source.getStandardTokenType(tokenIndex);
        this.languageId = source.getLanguageId(tokenIndex);
    }
    return RawToken;
}());
var ModelRawTokenScanner = /** @class */ (function () {
    function ModelRawTokenScanner(model) {
        this._model = model;
        this._lineCount = this._model.getLineCount();
        this._versionId = this._model.getVersionId();
        this._lineNumber = 0;
        this._tokenIndex = 0;
        this._lineTokens = null;
        this._advance();
    }
    ModelRawTokenScanner.prototype._advance = function () {
        if (this._lineTokens) {
            this._tokenIndex++;
            if (this._tokenIndex >= this._lineTokens.getCount()) {
                this._lineTokens = null;
            }
        }
        while (this._lineNumber < this._lineCount && !this._lineTokens) {
            this._lineNumber++;
            this._model.forceTokenization(this._lineNumber);
            this._lineTokens = this._model.getLineTokens(this._lineNumber);
            this._tokenIndex = 0;
            if (this._lineTokens.getCount() === 0) {
                // Skip empty lines
                this._lineTokens = null;
            }
        }
    };
    ModelRawTokenScanner.prototype.next = function () {
        if (!this._lineTokens) {
            return null;
        }
        if (this._model.getVersionId() !== this._versionId) {
            return null;
        }
        var result = new RawToken(this._lineTokens, this._tokenIndex, this._lineNumber);
        this._advance();
        return result;
    };
    return ModelRawTokenScanner;
}());
var TokenScanner = /** @class */ (function () {
    function TokenScanner(model) {
        this._rawTokenScanner = new ModelRawTokenScanner(model);
        this._nextBuff = [];
        this._cachedLanguageBrackets = null;
        this._cachedLanguageId = -1;
    }
    TokenScanner.prototype.next = function () {
        if (this._nextBuff.length > 0) {
            return this._nextBuff.shift();
        }
        var token = this._rawTokenScanner.next();
        if (!token) {
            return null;
        }
        var lineNumber = token.lineNumber;
        var lineText = token.lineText;
        var tokenType = token.type;
        var startOffset = token.startOffset;
        var endOffset = token.endOffset;
        if (this._cachedLanguageId !== token.languageId) {
            this._cachedLanguageId = token.languageId;
            this._cachedLanguageBrackets = __WEBPACK_IMPORTED_MODULE_3__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].getBracketsSupport(this._cachedLanguageId);
        }
        var modeBrackets = this._cachedLanguageBrackets;
        if (!modeBrackets || Object(__WEBPACK_IMPORTED_MODULE_1__common_modes_supports_js__["b" /* ignoreBracketsInToken */])(tokenType)) {
            return new Token(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](lineNumber, startOffset + 1, lineNumber, endOffset + 1), 0 /* None */, null);
        }
        var foundBracket;
        do {
            foundBracket = __WEBPACK_IMPORTED_MODULE_2__common_modes_supports_richEditBrackets_js__["a" /* BracketsUtils */].findNextBracketInToken(modeBrackets.forwardRegex, lineNumber, lineText, startOffset, endOffset);
            if (foundBracket) {
                var foundBracketStartOffset = foundBracket.startColumn - 1;
                var foundBracketEndOffset = foundBracket.endColumn - 1;
                if (startOffset < foundBracketStartOffset) {
                    // there is some text before this bracket in this token
                    this._nextBuff.push(new Token(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](lineNumber, startOffset + 1, lineNumber, foundBracketStartOffset + 1), 0 /* None */, null));
                }
                var bracketText = lineText.substring(foundBracketStartOffset, foundBracketEndOffset);
                bracketText = bracketText.toLowerCase();
                var bracketData = modeBrackets.textIsBracket[bracketText];
                var bracketIsOpen = modeBrackets.textIsOpenBracket[bracketText];
                this._nextBuff.push(new Token(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](lineNumber, foundBracketStartOffset + 1, lineNumber, foundBracketEndOffset + 1), bracketIsOpen ? 1 /* Open */ : -1 /* Close */, bracketData.languageIdentifier.language + ";" + bracketData.open + ";" + bracketData.close));
                startOffset = foundBracketEndOffset;
            }
        } while (foundBracket);
        if (startOffset < endOffset) {
            // there is some remaining none-bracket text in this token
            this._nextBuff.push(new Token(new __WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */](lineNumber, startOffset + 1, lineNumber, endOffset + 1), 0 /* None */, null));
        }
        return this._nextBuff.shift();
    };
    return TokenScanner;
}());
var TokenTreeBuilder = /** @class */ (function () {
    function TokenTreeBuilder(model) {
        this._stack = [];
        this._scanner = new TokenScanner(model);
    }
    TokenTreeBuilder.prototype.build = function () {
        var node = new NodeList();
        while (node.append(this._line() || this._any())) {
            // accept all
        }
        return node;
    };
    TokenTreeBuilder.prototype._accept = function (condt) {
        var token = this._stack.pop() || this._scanner.next();
        if (!token) {
            return false;
        }
        var accepted = condt(token);
        if (!accepted) {
            this._stack.push(token);
            this._currentToken = null;
        }
        else {
            this._currentToken = token;
            //			console.log('accepted: ' + token.__debugContent);
        }
        return accepted;
    };
    TokenTreeBuilder.prototype._peek = function (condt) {
        var ret = false;
        this._accept(function (info) {
            ret = condt(info);
            return false;
        });
        return ret;
    };
    TokenTreeBuilder.prototype._line = function () {
        var node = new NodeList();
        var lineNumber;
        // capture current linenumber
        this._peek(function (info) {
            lineNumber = info.range.startLineNumber;
            return false;
        });
        while (this._peek(function (info) { return info.range.startLineNumber === lineNumber; })
            && node.append(this._token() || this._block())) {
            // all children that started on this line
        }
        if (!node.children || node.children.length === 0) {
            return null;
        }
        else if (node.children.length === 1) {
            return node.children[0];
        }
        else {
            return node;
        }
    };
    TokenTreeBuilder.prototype._token = function () {
        if (!this._accept(function (token) { return token.bracket === 0 /* None */; })) {
            return null;
        }
        return newNode(this._currentToken);
    };
    TokenTreeBuilder.prototype._block = function () {
        var bracketType;
        var accepted;
        accepted = this._accept(function (token) {
            bracketType = token.bracketType;
            return token.bracket === 1 /* Open */;
        });
        if (!accepted) {
            return null;
        }
        var bracket = new Block();
        bracket.open = newNode(this._currentToken);
        while (bracket.elements.append(this._line())) {
            // inside brackets
        }
        if (!this._accept(function (token) { return token.bracket === -1 /* Close */ && token.bracketType === bracketType; })) {
            // missing closing bracket -> return just a node list
            var nodelist = new NodeList();
            nodelist.append(bracket.open);
            nodelist.append(bracket.elements);
            return nodelist;
        }
        bracket.close = newNode(this._currentToken);
        return bracket;
    };
    TokenTreeBuilder.prototype._any = function () {
        if (!this._accept(function (_) { return true; })) {
            return null;
        }
        return newNode(this._currentToken);
    };
    return TokenTreeBuilder;
}());
/**
 * Parses this grammar:
 *	grammer = { line }
 *	line = { block | "token" }
 *	block = "open_bracket" { line } "close_bracket"
 */
function build(model) {
    var node = new TokenTreeBuilder(model).build();
    return node;
}
function find(node, position) {
    if (node instanceof NodeList && node.isEmpty) {
        return null;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0__common_core_range_js__["a" /* Range */].containsPosition(node.range, position)) {
        return null;
    }
    var result;
    if (node instanceof NodeList) {
        if (node.hasChildren) {
            for (var i = 0, len = node.children.length; i < len && !result; i++) {
                result = find(node.children[i], position);
            }
        }
    }
    else if (node instanceof Block) {
        result = find(node.open, position) || find(node.elements, position) || find(node.close, position);
    }
    return result || node;
}


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OneSnippet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SnippetSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snippetSession_css__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snippetSession_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__snippetSession_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__snippetParser_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__snippetVariables_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_clipboard_common_clipboardService_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/














var OneSnippet = /** @class */ (function () {
    function OneSnippet(editor, snippet, offset) {
        this._nestingLevel = 1;
        this._editor = editor;
        this._snippet = snippet;
        this._offset = offset;
        this._placeholderGroups = Object(__WEBPACK_IMPORTED_MODULE_7__base_common_arrays_js__["j" /* groupBy */])(snippet.placeholders, __WEBPACK_IMPORTED_MODULE_4__snippetParser_js__["b" /* Placeholder */].compareByIndex);
        this._placeholderGroupsIdx = -1;
    }
    OneSnippet.prototype.dispose = function () {
        if (this._placeholderDecorations) {
            var toRemove_1 = [];
            this._placeholderDecorations.forEach(function (handle) { return toRemove_1.push(handle); });
            this._editor.deltaDecorations(toRemove_1, []);
        }
        this._placeholderGroups.length = 0;
    };
    OneSnippet.prototype._initDecorations = function () {
        var _this = this;
        if (this._placeholderDecorations) {
            // already initialized
            return;
        }
        this._placeholderDecorations = new Map();
        var model = this._editor.getModel();
        this._editor.changeDecorations(function (accessor) {
            // create a decoration for each placeholder
            for (var _i = 0, _a = _this._snippet.placeholders; _i < _a.length; _i++) {
                var placeholder = _a[_i];
                var placeholderOffset = _this._snippet.offset(placeholder);
                var placeholderLen = _this._snippet.fullLen(placeholder);
                var range = __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].fromPositions(model.getPositionAt(_this._offset + placeholderOffset), model.getPositionAt(_this._offset + placeholderOffset + placeholderLen));
                var options = placeholder.isFinalTabstop ? OneSnippet._decor.inactiveFinal : OneSnippet._decor.inactive;
                var handle = accessor.addDecoration(range, options);
                _this._placeholderDecorations.set(placeholder, handle);
            }
        });
    };
    OneSnippet.prototype.move = function (fwd) {
        var _this = this;
        this._initDecorations();
        // Transform placeholder text if necessary
        if (this._placeholderGroupsIdx >= 0) {
            var operations = [];
            for (var _i = 0, _a = this._placeholderGroups[this._placeholderGroupsIdx]; _i < _a.length; _i++) {
                var placeholder = _a[_i];
                // Check if the placeholder has a transformation
                if (placeholder.transform) {
                    var id = this._placeholderDecorations.get(placeholder);
                    var range = this._editor.getModel().getDecorationRange(id);
                    var currentValue = this._editor.getModel().getValueInRange(range);
                    operations.push(__WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__["a" /* EditOperation */].replaceMove(range, placeholder.transform.resolve(currentValue)));
                }
            }
            if (operations.length > 0) {
                this._editor.executeEdits('snippet.placeholderTransform', operations);
            }
        }
        if (fwd === true && this._placeholderGroupsIdx < this._placeholderGroups.length - 1) {
            this._placeholderGroupsIdx += 1;
        }
        else if (fwd === false && this._placeholderGroupsIdx > 0) {
            this._placeholderGroupsIdx -= 1;
        }
        else {
            // the selection of the current placeholder might
            // not acurate any more -> simply restore it
        }
        return this._editor.getModel().changeDecorations(function (accessor) {
            var activePlaceholders = new Set();
            // change stickiness to always grow when typing at its edges
            // because these decorations represent the currently active
            // tabstop.
            // Special case #1: reaching the final tabstop
            // Special case #2: placeholders enclosing active placeholders
            var selections = [];
            for (var _i = 0, _a = _this._placeholderGroups[_this._placeholderGroupsIdx]; _i < _a.length; _i++) {
                var placeholder = _a[_i];
                var id = _this._placeholderDecorations.get(placeholder);
                var range = _this._editor.getModel().getDecorationRange(id);
                selections.push(new __WEBPACK_IMPORTED_MODULE_5__common_core_selection_js__["a" /* Selection */](range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn));
                accessor.changeDecorationOptions(id, placeholder.isFinalTabstop ? OneSnippet._decor.activeFinal : OneSnippet._decor.active);
                activePlaceholders.add(placeholder);
                for (var _b = 0, _c = _this._snippet.enclosingPlaceholders(placeholder); _b < _c.length; _b++) {
                    var enclosingPlaceholder = _c[_b];
                    var id_1 = _this._placeholderDecorations.get(enclosingPlaceholder);
                    accessor.changeDecorationOptions(id_1, enclosingPlaceholder.isFinalTabstop ? OneSnippet._decor.activeFinal : OneSnippet._decor.active);
                    activePlaceholders.add(enclosingPlaceholder);
                }
            }
            // change stickness to never grow when typing at its edges
            // so that in-active tabstops never grow
            _this._placeholderDecorations.forEach(function (id, placeholder) {
                if (!activePlaceholders.has(placeholder)) {
                    accessor.changeDecorationOptions(id, placeholder.isFinalTabstop ? OneSnippet._decor.inactiveFinal : OneSnippet._decor.inactive);
                }
            });
            return selections;
        });
    };
    Object.defineProperty(OneSnippet.prototype, "isAtFirstPlaceholder", {
        get: function () {
            return this._placeholderGroupsIdx <= 0 || this._placeholderGroups.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OneSnippet.prototype, "isAtLastPlaceholder", {
        get: function () {
            return this._placeholderGroupsIdx === this._placeholderGroups.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OneSnippet.prototype, "hasPlaceholder", {
        get: function () {
            return this._snippet.placeholders.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    OneSnippet.prototype.computePossibleSelections = function () {
        var result = new Map();
        for (var _i = 0, _a = this._placeholderGroups; _i < _a.length; _i++) {
            var placeholdersWithEqualIndex = _a[_i];
            var ranges = void 0;
            for (var _b = 0, placeholdersWithEqualIndex_1 = placeholdersWithEqualIndex; _b < placeholdersWithEqualIndex_1.length; _b++) {
                var placeholder = placeholdersWithEqualIndex_1[_b];
                if (placeholder.isFinalTabstop) {
                    // ignore those
                    break;
                }
                if (!ranges) {
                    ranges = [];
                    result.set(placeholder.index, ranges);
                }
                var id = this._placeholderDecorations.get(placeholder);
                var range = this._editor.getModel().getDecorationRange(id);
                if (!range) {
                    // one of the placeholder lost its decoration and
                    // therefore we bail out and pretend the placeholder
                    // (with its mirrors) doesn't exist anymore.
                    result.delete(placeholder.index);
                    break;
                }
                ranges.push(range);
            }
        }
        return result;
    };
    Object.defineProperty(OneSnippet.prototype, "choice", {
        get: function () {
            return this._placeholderGroups[this._placeholderGroupsIdx][0].choice;
        },
        enumerable: true,
        configurable: true
    });
    OneSnippet.prototype.merge = function (others) {
        var _this = this;
        var model = this._editor.getModel();
        this._nestingLevel *= 10;
        this._editor.changeDecorations(function (accessor) {
            // For each active placeholder take one snippet and merge it
            // in that the placeholder (can be many for `$1foo$1foo`). Because
            // everything is sorted by editor selection we can simply remove
            // elements from the beginning of the array
            for (var _i = 0, _a = _this._placeholderGroups[_this._placeholderGroupsIdx]; _i < _a.length; _i++) {
                var placeholder = _a[_i];
                var nested = others.shift();
                console.assert(!nested._placeholderDecorations);
                // Massage placeholder-indicies of the nested snippet to be
                // sorted right after the insertion point. This ensures we move
                // through the placeholders in the correct order
                for (var _b = 0, _c = nested._snippet.placeholderInfo.all; _b < _c.length; _b++) {
                    var nestedPlaceholder = _c[_b];
                    if (nestedPlaceholder.isFinalTabstop) {
                        nestedPlaceholder.index = placeholder.index + ((nested._snippet.placeholderInfo.last.index + 1) / _this._nestingLevel);
                    }
                    else {
                        nestedPlaceholder.index = placeholder.index + (nestedPlaceholder.index / _this._nestingLevel);
                    }
                }
                _this._snippet.replace(placeholder, nested._snippet.children);
                // Remove the placeholder at which position are inserting
                // the snippet and also remove its decoration.
                var id = _this._placeholderDecorations.get(placeholder);
                accessor.removeDecoration(id);
                _this._placeholderDecorations.delete(placeholder);
                // For each *new* placeholder we create decoration to monitor
                // how and if it grows/shrinks.
                for (var _d = 0, _e = nested._snippet.placeholders; _d < _e.length; _d++) {
                    var placeholder_1 = _e[_d];
                    var placeholderOffset = nested._snippet.offset(placeholder_1);
                    var placeholderLen = nested._snippet.fullLen(placeholder_1);
                    var range = __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].fromPositions(model.getPositionAt(nested._offset + placeholderOffset), model.getPositionAt(nested._offset + placeholderOffset + placeholderLen));
                    var handle = accessor.addDecoration(range, OneSnippet._decor.inactive);
                    _this._placeholderDecorations.set(placeholder_1, handle);
                }
            }
            // Last, re-create the placeholder groups by sorting placeholders by their index.
            _this._placeholderGroups = Object(__WEBPACK_IMPORTED_MODULE_7__base_common_arrays_js__["j" /* groupBy */])(_this._snippet.placeholders, __WEBPACK_IMPORTED_MODULE_4__snippetParser_js__["b" /* Placeholder */].compareByIndex);
        });
    };
    OneSnippet._decor = {
        active: __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__common_model_js__["h" /* TrackedRangeStickiness */].AlwaysGrowsWhenTypingAtEdges, className: 'snippet-placeholder' }),
        inactive: __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges, className: 'snippet-placeholder' }),
        activeFinal: __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges, className: 'finish-snippet-placeholder' }),
        inactiveFinal: __WEBPACK_IMPORTED_MODULE_10__common_model_textModel_js__["a" /* ModelDecorationOptions */].register({ stickiness: __WEBPACK_IMPORTED_MODULE_2__common_model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges, className: 'finish-snippet-placeholder' }),
    };
    return OneSnippet;
}());

var SnippetSession = /** @class */ (function () {
    function SnippetSession(editor, template, overwriteBefore, overwriteAfter) {
        if (overwriteBefore === void 0) { overwriteBefore = 0; }
        if (overwriteAfter === void 0) { overwriteAfter = 0; }
        this._templateMerges = [];
        this._snippets = [];
        this._editor = editor;
        this._template = template;
        this._overwriteBefore = overwriteBefore;
        this._overwriteAfter = overwriteAfter;
    }
    SnippetSession.adjustWhitespace2 = function (model, position, snippet) {
        var line = model.getLineContent(position.lineNumber);
        var lineLeadingWhitespace = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["getLeadingWhitespace"])(line, 0, position.column - 1);
        snippet.walk(function (marker) {
            if (marker instanceof __WEBPACK_IMPORTED_MODULE_4__snippetParser_js__["d" /* Text */] && !(marker.parent instanceof __WEBPACK_IMPORTED_MODULE_4__snippetParser_js__["a" /* Choice */])) {
                // adjust indentation of text markers, except for choise elements
                // which get adjusted when being selected
                var lines = marker.value.split(/\r\n|\r|\n/);
                for (var i = 1; i < lines.length; i++) {
                    var templateLeadingWhitespace = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["getLeadingWhitespace"])(lines[i]);
                    lines[i] = model.normalizeIndentation(lineLeadingWhitespace + templateLeadingWhitespace) + lines[i].substr(templateLeadingWhitespace.length);
                }
                var newValue = lines.join(model.getEOL());
                if (newValue !== marker.value) {
                    marker.parent.replace(marker, [new __WEBPACK_IMPORTED_MODULE_4__snippetParser_js__["d" /* Text */](newValue)]);
                }
            }
            return true;
        });
    };
    SnippetSession.adjustSelection = function (model, selection, overwriteBefore, overwriteAfter) {
        if (overwriteBefore !== 0 || overwriteAfter !== 0) {
            // overwrite[Before|After] is compute using the position, not the whole
            // selection. therefore we adjust the selection around that position
            var positionLineNumber = selection.positionLineNumber, positionColumn = selection.positionColumn;
            var positionColumnBefore = positionColumn - overwriteBefore;
            var positionColumnAfter = positionColumn + overwriteAfter;
            var range = model.validateRange({
                startLineNumber: positionLineNumber,
                startColumn: positionColumnBefore,
                endLineNumber: positionLineNumber,
                endColumn: positionColumnAfter
            });
            selection = __WEBPACK_IMPORTED_MODULE_5__common_core_selection_js__["a" /* Selection */].createWithDirection(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn, selection.getDirection());
        }
        return selection;
    };
    SnippetSession.createEditsAndSnippets = function (editor, template, overwriteBefore, overwriteAfter, enforceFinalTabstop) {
        var model = editor.getModel();
        var edits = [];
        var snippets = [];
        var modelBasedVariableResolver = new __WEBPACK_IMPORTED_MODULE_9__snippetVariables_js__["c" /* ModelBasedVariableResolver */](model);
        var clipboardService = editor.invokeWithinContext(function (accessor) { return accessor.get(__WEBPACK_IMPORTED_MODULE_11__platform_clipboard_common_clipboardService_js__["a" /* IClipboardService */], __WEBPACK_IMPORTED_MODULE_12__platform_instantiation_common_instantiation_js__["d" /* optional */]); });
        var delta = 0;
        // know what text the overwrite[Before|After] extensions
        // of the primary curser have selected because only when
        // secondary selections extend to the same text we can grow them
        var firstBeforeText = model.getValueInRange(SnippetSession.adjustSelection(model, editor.getSelection(), overwriteBefore, 0));
        var firstAfterText = model.getValueInRange(SnippetSession.adjustSelection(model, editor.getSelection(), 0, overwriteAfter));
        // sort selections by their start position but remeber
        // the original index. that allows you to create correct
        // offset-based selection logic without changing the
        // primary selection
        var indexedSelections = editor.getSelections()
            .map(function (selection, idx) { return ({ selection: selection, idx: idx }); })
            .sort(function (a, b) { return __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].compareRangesUsingStarts(a.selection, b.selection); });
        for (var _i = 0, indexedSelections_1 = indexedSelections; _i < indexedSelections_1.length; _i++) {
            var _a = indexedSelections_1[_i], selection = _a.selection, idx = _a.idx;
            // extend selection with the `overwriteBefore` and `overwriteAfter` and then
            // compare if this matches the extensions of the primary selection
            var extensionBefore = SnippetSession.adjustSelection(model, selection, overwriteBefore, 0);
            var extensionAfter = SnippetSession.adjustSelection(model, selection, 0, overwriteAfter);
            if (firstBeforeText !== model.getValueInRange(extensionBefore)) {
                extensionBefore = selection;
            }
            if (firstAfterText !== model.getValueInRange(extensionAfter)) {
                extensionAfter = selection;
            }
            // merge the before and after selection into one
            var snippetSelection = selection
                .setStartPosition(extensionBefore.startLineNumber, extensionBefore.startColumn)
                .setEndPosition(extensionAfter.endLineNumber, extensionAfter.endColumn);
            var snippet = new __WEBPACK_IMPORTED_MODULE_4__snippetParser_js__["c" /* SnippetParser */]().parse(template, true, enforceFinalTabstop);
            // adjust the template string to match the indentation and
            // whitespace rules of this insert location (can be different for each cursor)
            var start = snippetSelection.getStartPosition();
            SnippetSession.adjustWhitespace2(model, start, snippet);
            snippet.resolveVariables(new __WEBPACK_IMPORTED_MODULE_9__snippetVariables_js__["b" /* CompositeSnippetVariableResolver */]([
                modelBasedVariableResolver,
                new __WEBPACK_IMPORTED_MODULE_9__snippetVariables_js__["a" /* ClipboardBasedVariableResolver */](clipboardService, idx, indexedSelections.length),
                new __WEBPACK_IMPORTED_MODULE_9__snippetVariables_js__["d" /* SelectionBasedVariableResolver */](model, selection),
                new __WEBPACK_IMPORTED_MODULE_9__snippetVariables_js__["e" /* TimeBasedVariableResolver */]
            ]));
            var offset = model.getOffsetAt(start) + delta;
            delta += snippet.toString().length - model.getValueLengthInRange(snippetSelection);
            // store snippets with the index of their originating selection.
            // that ensures the primiary cursor stays primary despite not being
            // the one with lowest start position
            edits[idx] = __WEBPACK_IMPORTED_MODULE_3__common_core_editOperation_js__["a" /* EditOperation */].replace(snippetSelection, snippet.toString());
            snippets[idx] = new OneSnippet(editor, snippet, offset);
        }
        return { edits: edits, snippets: snippets };
    };
    SnippetSession.prototype.dispose = function () {
        Object(__WEBPACK_IMPORTED_MODULE_8__base_common_lifecycle_js__["d" /* dispose */])(this._snippets);
    };
    SnippetSession.prototype._logInfo = function () {
        return "template=\"" + this._template + "\", merged_templates=\"" + this._templateMerges.join(' -> ') + "\"";
    };
    SnippetSession.prototype.insert = function () {
        var _this = this;
        var model = this._editor.getModel();
        // make insert edit and start with first selections
        var _a = SnippetSession.createEditsAndSnippets(this._editor, this._template, this._overwriteBefore, this._overwriteAfter, false), edits = _a.edits, snippets = _a.snippets;
        this._snippets = snippets;
        var selections = model.pushEditOperations(this._editor.getSelections(), edits, function (undoEdits) {
            if (_this._snippets[0].hasPlaceholder) {
                return _this._move(true);
            }
            else {
                return undoEdits.map(function (edit) { return __WEBPACK_IMPORTED_MODULE_5__common_core_selection_js__["a" /* Selection */].fromPositions(edit.range.getEndPosition()); });
            }
        });
        this._editor.setSelections(selections);
        this._editor.revealRange(selections[0]);
    };
    SnippetSession.prototype.merge = function (template, overwriteBefore, overwriteAfter) {
        var _this = this;
        if (overwriteBefore === void 0) { overwriteBefore = 0; }
        if (overwriteAfter === void 0) { overwriteAfter = 0; }
        this._templateMerges.push([this._snippets[0]._nestingLevel, this._snippets[0]._placeholderGroupsIdx, template]);
        var _a = SnippetSession.createEditsAndSnippets(this._editor, template, overwriteBefore, overwriteAfter, true), edits = _a.edits, snippets = _a.snippets;
        this._editor.setSelections(this._editor.getModel().pushEditOperations(this._editor.getSelections(), edits, function (undoEdits) {
            for (var _i = 0, _a = _this._snippets; _i < _a.length; _i++) {
                var snippet = _a[_i];
                snippet.merge(snippets);
            }
            console.assert(snippets.length === 0);
            if (_this._snippets[0].hasPlaceholder) {
                return _this._move(undefined);
            }
            else {
                return undoEdits.map(function (edit) { return __WEBPACK_IMPORTED_MODULE_5__common_core_selection_js__["a" /* Selection */].fromPositions(edit.range.getEndPosition()); });
            }
        }));
    };
    SnippetSession.prototype.next = function () {
        var newSelections = this._move(true);
        this._editor.setSelections(newSelections);
        this._editor.revealPositionInCenterIfOutsideViewport(newSelections[0].getPosition());
    };
    SnippetSession.prototype.prev = function () {
        var newSelections = this._move(false);
        this._editor.setSelections(newSelections);
        this._editor.revealPositionInCenterIfOutsideViewport(newSelections[0].getPosition());
    };
    SnippetSession.prototype._move = function (fwd) {
        var selections = [];
        for (var _i = 0, _a = this._snippets; _i < _a.length; _i++) {
            var snippet = _a[_i];
            var oneSelection = snippet.move(fwd);
            selections.push.apply(selections, oneSelection);
        }
        return selections;
    };
    Object.defineProperty(SnippetSession.prototype, "isAtFirstPlaceholder", {
        get: function () {
            return this._snippets[0].isAtFirstPlaceholder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SnippetSession.prototype, "isAtLastPlaceholder", {
        get: function () {
            return this._snippets[0].isAtLastPlaceholder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SnippetSession.prototype, "hasPlaceholder", {
        get: function () {
            return this._snippets[0].hasPlaceholder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SnippetSession.prototype, "choice", {
        get: function () {
            return this._snippets[0].choice;
        },
        enumerable: true,
        configurable: true
    });
    SnippetSession.prototype.isSelectionWithinPlaceholders = function () {
        if (!this.hasPlaceholder) {
            return false;
        }
        var selections = this._editor.getSelections();
        if (selections.length < this._snippets.length) {
            // this means we started snippet mode with N
            // selections and have M (N > M) selections.
            // So one snippet is without selection -> cancel
            return false;
        }
        var allPossibleSelections;
        var _loop_1 = function (snippet) {
            var possibleSelections = snippet.computePossibleSelections();
            // for the first snippet find the placeholder (and its ranges)
            // that contain at least one selection. for all remaining snippets
            // the same placeholder (and their ranges) must be used.
            if (!allPossibleSelections) {
                allPossibleSelections = new Map();
                possibleSelections.forEach(function (ranges, index) {
                    ranges.sort(__WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
                    for (var _i = 0, selections_1 = selections; _i < selections_1.length; _i++) {
                        var selection = selections_1[_i];
                        if (ranges[0].containsRange(selection)) {
                            allPossibleSelections.set(index, []);
                            break;
                        }
                    }
                });
            }
            if (allPossibleSelections.size === 0) {
                return { value: false };
            }
            // add selections from 'this' snippet so that we know all
            // selections for this placeholder
            allPossibleSelections.forEach(function (array, index) {
                array.push.apply(array, possibleSelections.get(index));
            });
        };
        for (var _i = 0, _a = this._snippets; _i < _a.length; _i++) {
            var snippet = _a[_i];
            var state_1 = _loop_1(snippet);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        // sort selections (and later placeholder-ranges). then walk both
        // arrays and make sure the placeholder-ranges contain the corresponding
        // selection
        selections.sort(__WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
        allPossibleSelections.forEach(function (ranges, index) {
            if (ranges.length !== selections.length) {
                allPossibleSelections.delete(index);
                return;
            }
            ranges.sort(__WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].compareRangesUsingStarts);
            for (var i = 0; i < ranges.length; i++) {
                if (!ranges[i].containsRange(selections[i])) {
                    allPossibleSelections.delete(index);
                    return;
                }
            }
        });
        // from all possible selections we have deleted those
        // that don't match with the current selection. if we don't
        // have any left, we don't have a selection anymore
        return allPossibleSelections.size > 0;
    };
    return SnippetSession;
}());



/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CompositeSnippetVariableResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SelectionBasedVariableResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModelBasedVariableResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClipboardBasedVariableResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TimeBasedVariableResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snippetParser_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var CompositeSnippetVariableResolver = /** @class */ (function () {
    function CompositeSnippetVariableResolver(_delegates) {
        this._delegates = _delegates;
        //
    }
    CompositeSnippetVariableResolver.prototype.resolve = function (variable) {
        for (var _i = 0, _a = this._delegates; _i < _a.length; _i++) {
            var delegate = _a[_i];
            var value = delegate.resolve(variable);
            if (value !== void 0) {
                return value;
            }
        }
        return undefined;
    };
    return CompositeSnippetVariableResolver;
}());

var SelectionBasedVariableResolver = /** @class */ (function () {
    function SelectionBasedVariableResolver(_model, _selection) {
        this._model = _model;
        this._selection = _selection;
        //
    }
    SelectionBasedVariableResolver.prototype.resolve = function (variable) {
        var name = variable.name;
        if (name === 'SELECTION' || name === 'TM_SELECTED_TEXT') {
            var value = this._model.getValueInRange(this._selection) || undefined;
            if (value && this._selection.startLineNumber !== this._selection.endLineNumber) {
                // Selection is a multiline string which we indentation we now
                // need to adjust. We compare the indentation of this variable
                // with the indentation at the editor position and add potential
                // extra indentation to the value
                var line = this._model.getLineContent(this._selection.startLineNumber);
                var lineLeadingWhitespace = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["getLeadingWhitespace"])(line, 0, this._selection.startColumn - 1);
                var varLeadingWhitespace_1 = lineLeadingWhitespace;
                variable.snippet.walk(function (marker) {
                    if (marker === variable) {
                        return false;
                    }
                    if (marker instanceof __WEBPACK_IMPORTED_MODULE_2__snippetParser_js__["d" /* Text */]) {
                        varLeadingWhitespace_1 = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["getLeadingWhitespace"])(marker.value.split(/\r\n|\r|\n/).pop());
                    }
                    return true;
                });
                var whitespaceCommonLength_1 = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["commonPrefixLength"])(varLeadingWhitespace_1, lineLeadingWhitespace);
                value = value.replace(/(\r\n|\r|\n)(.*)/g, function (m, newline, rest) { return "" + newline + varLeadingWhitespace_1.substr(whitespaceCommonLength_1) + rest; });
            }
            return value;
        }
        else if (name === 'TM_CURRENT_LINE') {
            return this._model.getLineContent(this._selection.positionLineNumber);
        }
        else if (name === 'TM_CURRENT_WORD') {
            var info = this._model.getWordAtPosition({
                lineNumber: this._selection.positionLineNumber,
                column: this._selection.positionColumn
            });
            return info && info.word || undefined;
        }
        else if (name === 'TM_LINE_INDEX') {
            return String(this._selection.positionLineNumber - 1);
        }
        else if (name === 'TM_LINE_NUMBER') {
            return String(this._selection.positionLineNumber);
        }
        return undefined;
    };
    return SelectionBasedVariableResolver;
}());

var ModelBasedVariableResolver = /** @class */ (function () {
    function ModelBasedVariableResolver(_model) {
        this._model = _model;
        //
    }
    ModelBasedVariableResolver.prototype.resolve = function (variable) {
        var name = variable.name;
        if (name === 'TM_FILENAME') {
            return Object(__WEBPACK_IMPORTED_MODULE_1__base_common_paths_js__["a" /* basename */])(this._model.uri.fsPath);
        }
        else if (name === 'TM_FILENAME_BASE') {
            var name_1 = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_paths_js__["a" /* basename */])(this._model.uri.fsPath);
            var idx = name_1.lastIndexOf('.');
            if (idx <= 0) {
                return name_1;
            }
            else {
                return name_1.slice(0, idx);
            }
        }
        else if (name === 'TM_DIRECTORY') {
            var dir = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_paths_js__["b" /* dirname */])(this._model.uri.fsPath);
            return dir !== '.' ? dir : '';
        }
        else if (name === 'TM_FILEPATH') {
            return this._model.uri.fsPath;
        }
        return undefined;
    };
    return ModelBasedVariableResolver;
}());

var ClipboardBasedVariableResolver = /** @class */ (function () {
    function ClipboardBasedVariableResolver(_clipboardService, _selectionIdx, _selectionCount) {
        this._clipboardService = _clipboardService;
        this._selectionIdx = _selectionIdx;
        this._selectionCount = _selectionCount;
        //
    }
    ClipboardBasedVariableResolver.prototype.resolve = function (variable) {
        if (variable.name !== 'CLIPBOARD' || !this._clipboardService) {
            return undefined;
        }
        var text = this._clipboardService.readText();
        if (!text) {
            return undefined;
        }
        var lines = text.split(/\r\n|\n|\r/).filter(function (s) { return !Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["isFalsyOrWhitespace"])(s); });
        if (lines.length === this._selectionCount) {
            return lines[this._selectionIdx];
        }
        else {
            return text;
        }
    };
    return ClipboardBasedVariableResolver;
}());

var TimeBasedVariableResolver = /** @class */ (function () {
    function TimeBasedVariableResolver() {
    }
    TimeBasedVariableResolver.prototype.resolve = function (variable) {
        var name = variable.name;
        if (name === 'CURRENT_YEAR') {
            return String(new Date().getFullYear());
        }
        else if (name === 'CURRENT_YEAR_SHORT') {
            return String(new Date().getFullYear()).slice(-2);
        }
        else if (name === 'CURRENT_MONTH') {
            return Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["pad"])((new Date().getMonth().valueOf() + 1), 2);
        }
        else if (name === 'CURRENT_DATE') {
            return Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["pad"])(new Date().getDate().valueOf(), 2);
        }
        else if (name === 'CURRENT_HOUR') {
            return Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["pad"])(new Date().getHours().valueOf(), 2);
        }
        else if (name === 'CURRENT_MINUTE') {
            return Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["pad"])(new Date().getMinutes().valueOf(), 2);
        }
        else if (name === 'CURRENT_SECOND') {
            return Object(__WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["pad"])(new Date().getSeconds().valueOf(), 2);
        }
        else if (name === 'CURRENT_DAY_NAME') {
            return TimeBasedVariableResolver.dayNames[new Date().getDay()];
        }
        else if (name === 'CURRENT_DAY_NAME_SHORT') {
            return TimeBasedVariableResolver.dayNamesShort[new Date().getDay()];
        }
        else if (name === 'CURRENT_MONTH_NAME') {
            return TimeBasedVariableResolver.monthNames[new Date().getMonth()];
        }
        else if (name === 'CURRENT_MONTH_NAME_SHORT') {
            return TimeBasedVariableResolver.monthNamesShort[new Date().getMonth()];
        }
        return undefined;
    };
    TimeBasedVariableResolver.dayNames = [__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('Sunday', "Sunday"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('Monday', "Monday"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('Tuesday', "Tuesday"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('Wednesday', "Wednesday"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('Thursday', "Thursday"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('Friday', "Friday"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('Saturday', "Saturday")];
    TimeBasedVariableResolver.dayNamesShort = [__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('SundayShort', "Sun"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('MondayShort', "Mon"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('TuesdayShort', "Tue"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('WednesdayShort', "Wed"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('ThursdayShort', "Thu"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('FridayShort', "Fri"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('SaturdayShort', "Sat")];
    TimeBasedVariableResolver.monthNames = [__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('January', "January"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('February', "February"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('March', "March"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('April', "April"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('May', "May"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('June', "June"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('July', "July"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('August', "August"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('September', "September"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('October', "October"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('November', "November"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('December', "December")];
    TimeBasedVariableResolver.monthNamesShort = [__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('JanuaryShort', "Jan"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('FebruaryShort', "Feb"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('MarchShort', "Mar"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('AprilShort', "Apr"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('MayShort', "May"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('JuneShort', "Jun"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('JulyShort', "Jul"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('AugustShort', "Aug"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('SeptemberShort', "Sep"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('OctoberShort', "Oct"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('NovemberShort', "Nov"), __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('DecemberShort', "Dec")];
    return TimeBasedVariableResolver;
}());



/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LineContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_map_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorEvents_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_core_selection_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__completionModel_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__suggest_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__snippet_snippetController2_js__ = __webpack_require__(89);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/













var LineContext = /** @class */ (function () {
    function LineContext(model, position, auto) {
        this.leadingLineContent = model.getLineContent(position.lineNumber).substr(0, position.column - 1);
        this.leadingWord = model.getWordUntilPosition(position);
        this.lineNumber = position.lineNumber;
        this.column = position.column;
        this.auto = auto;
    }
    LineContext.shouldAutoTrigger = function (editor) {
        var model = editor.getModel();
        if (!model) {
            return false;
        }
        var pos = editor.getPosition();
        model.tokenizeIfCheap(pos.lineNumber);
        var word = model.getWordAtPosition(pos);
        if (!word) {
            return false;
        }
        if (word.endColumn !== pos.column) {
            return false;
        }
        if (!isNaN(Number(word.word))) {
            return false;
        }
        return true;
    };
    return LineContext;
}());

var SuggestModel = /** @class */ (function () {
    function SuggestModel(editor) {
        var _this = this;
        this._toDispose = [];
        this._triggerQuickSuggest = new __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["f" /* TimeoutTimer */]();
        this._triggerRefilter = new __WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["f" /* TimeoutTimer */]();
        this._onDidCancel = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        this._onDidTrigger = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        this._onDidSuggest = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        this.onDidCancel = this._onDidCancel.event;
        this.onDidTrigger = this._onDidTrigger.event;
        this.onDidSuggest = this._onDidSuggest.event;
        this._editor = editor;
        this._state = 0 /* Idle */;
        this._requestPromise = null;
        this._completionModel = null;
        this._context = null;
        this._currentSelection = this._editor.getSelection() || new __WEBPACK_IMPORTED_MODULE_7__common_core_selection_js__["a" /* Selection */](1, 1, 1, 1);
        // wire up various listeners
        this._toDispose.push(this._editor.onDidChangeModel(function () {
            _this._updateTriggerCharacters();
            _this.cancel();
        }));
        this._toDispose.push(this._editor.onDidChangeModelLanguage(function () {
            _this._updateTriggerCharacters();
            _this.cancel();
        }));
        this._toDispose.push(this._editor.onDidChangeConfiguration(function () {
            _this._updateTriggerCharacters();
            _this._updateQuickSuggest();
        }));
        this._toDispose.push(__WEBPACK_IMPORTED_MODULE_8__common_modes_js__["u" /* SuggestRegistry */].onDidChange(function () {
            _this._updateTriggerCharacters();
            _this._updateActiveSuggestSession();
        }));
        this._toDispose.push(this._editor.onDidChangeCursorSelection(function (e) {
            _this._onCursorChange(e);
        }));
        this._toDispose.push(this._editor.onDidChangeModelContent(function (e) {
            _this._refilterCompletionItems();
        }));
        this._updateTriggerCharacters();
        this._updateQuickSuggest();
    }
    SuggestModel.prototype.dispose = function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])([this._onDidCancel, this._onDidSuggest, this._onDidTrigger, this._triggerCharacterListener, this._triggerQuickSuggest, this._triggerRefilter]);
        this._toDispose = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._toDispose);
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._completionModel);
        this.cancel();
    };
    // --- handle configuration & precondition changes
    SuggestModel.prototype._updateQuickSuggest = function () {
        this._quickSuggestDelay = this._editor.getConfiguration().contribInfo.quickSuggestionsDelay;
        if (isNaN(this._quickSuggestDelay) || (!this._quickSuggestDelay && this._quickSuggestDelay !== 0) || this._quickSuggestDelay < 0) {
            this._quickSuggestDelay = 10;
        }
    };
    SuggestModel.prototype._updateTriggerCharacters = function () {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._triggerCharacterListener);
        if (this._editor.getConfiguration().readOnly
            || !this._editor.getModel()
            || !this._editor.getConfiguration().contribInfo.suggestOnTriggerCharacters) {
            return;
        }
        var supportsByTriggerCharacter = Object.create(null);
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_8__common_modes_js__["u" /* SuggestRegistry */].all(this._editor.getModel()); _i < _a.length; _i++) {
            var support = _a[_i];
            if (Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(support.triggerCharacters)) {
                continue;
            }
            for (var _b = 0, _c = support.triggerCharacters; _b < _c.length; _b++) {
                var ch = _c[_b];
                var set = supportsByTriggerCharacter[ch];
                if (!set) {
                    set = supportsByTriggerCharacter[ch] = new Set();
                    set.add(Object(__WEBPACK_IMPORTED_MODULE_10__suggest_js__["b" /* getSnippetSuggestSupport */])());
                }
                set.add(support);
            }
        }
        this._triggerCharacterListener = this._editor.onDidType(function (text) {
            var lastChar = text.charAt(text.length - 1);
            var supports = supportsByTriggerCharacter[lastChar];
            if (supports) {
                // keep existing items that where not computed by the
                // supports/providers that want to trigger now
                var items = _this._completionModel ? _this._completionModel.adopt(supports) : undefined;
                _this.trigger({ auto: true, triggerCharacter: lastChar }, Boolean(_this._completionModel), Object(__WEBPACK_IMPORTED_MODULE_5__base_common_map_js__["d" /* values */])(supports), items);
            }
        });
    };
    Object.defineProperty(SuggestModel.prototype, "state", {
        // --- trigger/retrigger/cancel suggest
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    SuggestModel.prototype.cancel = function (retrigger) {
        if (retrigger === void 0) { retrigger = false; }
        this._triggerRefilter.cancel();
        if (this._triggerQuickSuggest) {
            this._triggerQuickSuggest.cancel();
        }
        if (this._requestPromise) {
            this._requestPromise.cancel();
            this._requestPromise = null;
        }
        this._state = 0 /* Idle */;
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._completionModel);
        this._completionModel = null;
        this._context = null;
        this._onDidCancel.fire({ retrigger: retrigger });
    };
    SuggestModel.prototype._updateActiveSuggestSession = function () {
        if (this._state !== 0 /* Idle */) {
            if (!__WEBPACK_IMPORTED_MODULE_8__common_modes_js__["u" /* SuggestRegistry */].has(this._editor.getModel())) {
                this.cancel();
            }
            else {
                this.trigger({ auto: this._state === 2 /* Auto */ }, true);
            }
        }
    };
    SuggestModel.prototype._onCursorChange = function (e) {
        var _this = this;
        var prevSelection = this._currentSelection;
        this._currentSelection = this._editor.getSelection();
        if (!e.selection.isEmpty()
            || e.reason !== __WEBPACK_IMPORTED_MODULE_6__common_controller_cursorEvents_js__["a" /* CursorChangeReason */].NotSet
            || (e.source !== 'keyboard' && e.source !== 'deleteLeft')) {
            // Early exit if nothing needs to be done!
            // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
            if (this._state !== 0 /* Idle */) {
                this.cancel();
            }
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_8__common_modes_js__["u" /* SuggestRegistry */].has(this._editor.getModel())) {
            return;
        }
        var model = this._editor.getModel();
        if (!model) {
            return;
        }
        if (this._state === 0 /* Idle */) {
            if (this._editor.getConfiguration().contribInfo.quickSuggestions === false) {
                // not enabled
                return;
            }
            if (!prevSelection.containsRange(this._currentSelection) && !prevSelection.getEndPosition().isBeforeOrEqual(this._currentSelection.getPosition())) {
                // cursor didn't move RIGHT
                return;
            }
            if (this._editor.getConfiguration().contribInfo.suggest.snippetsPreventQuickSuggestions && __WEBPACK_IMPORTED_MODULE_11__snippet_snippetController2_js__["SnippetController2"].get(this._editor).isInSnippet()) {
                // no quick suggestion when in snippet mode
                return;
            }
            this.cancel();
            this._triggerQuickSuggest.cancelAndSet(function () {
                if (!LineContext.shouldAutoTrigger(_this._editor)) {
                    return;
                }
                var model = _this._editor.getModel();
                var pos = _this._editor.getPosition();
                if (!model) {
                    return;
                }
                // validate enabled now
                var quickSuggestions = _this._editor.getConfiguration().contribInfo.quickSuggestions;
                if (quickSuggestions === false) {
                    return;
                }
                else if (quickSuggestions === true) {
                    // all good
                }
                else {
                    // Check the type of the token that triggered this
                    model.tokenizeIfCheap(pos.lineNumber);
                    var lineTokens = model.getLineTokens(pos.lineNumber);
                    var tokenType = lineTokens.getStandardTokenType(lineTokens.findTokenIndexAtOffset(Math.max(pos.column - 1 - 1, 0)));
                    var inValidScope = quickSuggestions.other && tokenType === 0 /* Other */
                        || quickSuggestions.comments && tokenType === 1 /* Comment */
                        || quickSuggestions.strings && tokenType === 2 /* String */;
                    if (!inValidScope) {
                        return;
                    }
                }
                // we made it till here -> trigger now
                _this.trigger({ auto: true });
            }, this._quickSuggestDelay);
        }
    };
    SuggestModel.prototype._refilterCompletionItems = function () {
        var _this = this;
        if (this._state === 0 /* Idle */) {
            return;
        }
        var model = this._editor.getModel();
        if (model) {
            // refine active suggestion
            this._triggerRefilter.cancelAndSet(function () {
                var position = _this._editor.getPosition();
                var ctx = new LineContext(model, position, _this._state === 2 /* Auto */);
                _this._onNewContext(ctx);
            }, 25);
        }
    };
    SuggestModel.prototype.trigger = function (context, retrigger, onlyFrom, existingItems) {
        var _this = this;
        if (retrigger === void 0) { retrigger = false; }
        var model = this._editor.getModel();
        if (!model) {
            return;
        }
        var auto = context.auto;
        var ctx = new LineContext(model, this._editor.getPosition(), auto);
        // Cancel previous requests, change state & update UI
        this.cancel(retrigger);
        this._state = auto ? 2 /* Auto */ : 1 /* Manual */;
        this._onDidTrigger.fire({ auto: auto });
        // Capture context when request was sent
        this._context = ctx;
        // Build context for request
        var suggestCtx;
        if (context.triggerCharacter) {
            suggestCtx = {
                triggerKind: __WEBPACK_IMPORTED_MODULE_8__common_modes_js__["v" /* SuggestTriggerKind */].TriggerCharacter,
                triggerCharacter: context.triggerCharacter
            };
        }
        else if (onlyFrom && onlyFrom.length) {
            suggestCtx = { triggerKind: __WEBPACK_IMPORTED_MODULE_8__common_modes_js__["v" /* SuggestTriggerKind */].TriggerForIncompleteCompletions };
        }
        else {
            suggestCtx = { triggerKind: __WEBPACK_IMPORTED_MODULE_8__common_modes_js__["v" /* SuggestTriggerKind */].Invoke };
        }
        this._requestPromise = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return Object(__WEBPACK_IMPORTED_MODULE_10__suggest_js__["d" /* provideSuggestionItems */])(model, _this._editor.getPosition(), _this._editor.getConfiguration().contribInfo.suggest.snippets, onlyFrom, suggestCtx, token); });
        this._requestPromise.then(function (items) {
            _this._requestPromise = null;
            if (_this._state === 0 /* Idle */) {
                return;
            }
            var model = _this._editor.getModel();
            if (!model) {
                return;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(existingItems)) {
                var cmpFn = Object(__WEBPACK_IMPORTED_MODULE_10__suggest_js__["c" /* getSuggestionComparator */])(_this._editor.getConfiguration().contribInfo.suggest.snippets);
                items = items.concat(existingItems).sort(cmpFn);
            }
            var ctx = new LineContext(model, _this._editor.getPosition(), auto);
            Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(_this._completionModel);
            _this._completionModel = new __WEBPACK_IMPORTED_MODULE_9__completionModel_js__["a" /* CompletionModel */](items, _this._context.column, {
                leadingLineContent: ctx.leadingLineContent,
                characterCountDelta: _this._context ? ctx.column - _this._context.column : 0
            }, _this._editor.getConfiguration().contribInfo.suggest);
            _this._onNewContext(ctx);
        }).catch(__WEBPACK_IMPORTED_MODULE_2__base_common_errors_js__["e" /* onUnexpectedError */]);
    };
    SuggestModel.prototype._onNewContext = function (ctx) {
        if (!this._context) {
            // happens when 24x7 IntelliSense is enabled and still in its delay
            return;
        }
        if (ctx.lineNumber !== this._context.lineNumber) {
            // e.g. happens when pressing Enter while IntelliSense is computed
            this.cancel();
            return;
        }
        if (ctx.leadingWord.startColumn < this._context.leadingWord.startColumn) {
            // happens when the current word gets outdented
            this.cancel();
            return;
        }
        if (ctx.column < this._context.column) {
            // typed -> moved cursor LEFT -> retrigger if still on a word
            if (ctx.leadingWord.word) {
                this.trigger({ auto: this._context.auto }, true);
            }
            else {
                this.cancel();
            }
            return;
        }
        if (!this._completionModel) {
            // happens when IntelliSense is not yet computed
            return;
        }
        if (ctx.column > this._context.column && this._completionModel.incomplete.size > 0 && ctx.leadingWord.word.length !== 0) {
            // typed -> moved cursor RIGHT & incomple model & still on a word -> retrigger
            var incomplete = this._completionModel.incomplete;
            var adopted = this._completionModel.adopt(incomplete);
            this.trigger({ auto: this._state === 2 /* Auto */ }, true, Object(__WEBPACK_IMPORTED_MODULE_5__base_common_map_js__["d" /* values */])(incomplete), adopted);
        }
        else {
            // typed -> moved cursor RIGHT -> update UI
            var oldLineContext = this._completionModel.lineContext;
            var isFrozen = false;
            this._completionModel.lineContext = {
                leadingLineContent: ctx.leadingLineContent,
                characterCountDelta: ctx.column - this._context.column
            };
            if (this._completionModel.items.length === 0) {
                if (LineContext.shouldAutoTrigger(this._editor) && this._context.leadingWord.endColumn < ctx.leadingWord.startColumn) {
                    // retrigger when heading into a new word
                    this.trigger({ auto: this._context.auto }, true);
                    return;
                }
                if (!this._context.auto) {
                    // freeze when IntelliSense was manually requested
                    this._completionModel.lineContext = oldLineContext;
                    isFrozen = this._completionModel.items.length > 0;
                    if (isFrozen && ctx.leadingWord.word.length === 0) {
                        // there were results before but now there aren't
                        // and also we are not on a word anymore -> cancel
                        this.cancel();
                        return;
                    }
                }
                else {
                    // nothing left
                    this.cancel();
                    return;
                }
            }
            this._onDidSuggest.fire({
                completionModel: this._completionModel,
                auto: this._context.auto,
                isFrozen: isFrozen,
            });
        }
    };
    return SuggestModel;
}());



/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LineContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompletionModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_filters_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_config_editorOptions_js__ = __webpack_require__(45);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var LineContext = /** @class */ (function () {
    function LineContext() {
    }
    return LineContext;
}());

var CompletionModel = /** @class */ (function () {
    function CompletionModel(items, column, lineContext, options) {
        if (options === void 0) { options = __WEBPACK_IMPORTED_MODULE_2__common_config_editorOptions_js__["a" /* EDITOR_DEFAULTS */].contribInfo.suggest; }
        this._snippetCompareFn = CompletionModel._compareCompletionItems;
        this._items = items;
        this._column = column;
        this._options = options;
        this._refilterKind = 1 /* All */;
        this._lineContext = lineContext;
        if (options.snippets === 'top') {
            this._snippetCompareFn = CompletionModel._compareCompletionItemsSnippetsUp;
        }
        else if (options.snippets === 'bottom') {
            this._snippetCompareFn = CompletionModel._compareCompletionItemsSnippetsDown;
        }
    }
    CompletionModel.prototype.dispose = function () {
        var seen = new Set();
        for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
            var container = _a[_i].container;
            if (!seen.has(container)) {
                seen.add(container);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["e" /* isDisposable */])(container)) {
                    container.dispose();
                }
            }
        }
    };
    Object.defineProperty(CompletionModel.prototype, "lineContext", {
        get: function () {
            return this._lineContext;
        },
        set: function (value) {
            if (this._lineContext.leadingLineContent !== value.leadingLineContent
                || this._lineContext.characterCountDelta !== value.characterCountDelta) {
                this._refilterKind = this._lineContext.characterCountDelta < value.characterCountDelta && this._filteredItems ? 2 /* Incr */ : 1 /* All */;
                this._lineContext = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletionModel.prototype, "items", {
        get: function () {
            this._ensureCachedState();
            return this._filteredItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletionModel.prototype, "incomplete", {
        get: function () {
            this._ensureCachedState();
            return this._isIncomplete;
        },
        enumerable: true,
        configurable: true
    });
    CompletionModel.prototype.adopt = function (except) {
        var res = new Array();
        for (var i = 0; i < this._items.length;) {
            if (!except.has(this._items[i].support)) {
                res.push(this._items[i]);
                // unordered removed
                this._items[i] = this._items[this._items.length - 1];
                this._items.pop();
            }
            else {
                // continue with next item
                i++;
            }
        }
        this._refilterKind = 1 /* All */;
        return res;
    };
    Object.defineProperty(CompletionModel.prototype, "stats", {
        get: function () {
            this._ensureCachedState();
            return this._stats;
        },
        enumerable: true,
        configurable: true
    });
    CompletionModel.prototype._ensureCachedState = function () {
        if (this._refilterKind !== 0 /* Nothing */) {
            this._createCachedState();
        }
    };
    CompletionModel.prototype._createCachedState = function () {
        this._isIncomplete = new Set();
        this._stats = { suggestionCount: 0, snippetCount: 0, textCount: 0 };
        var _a = this._lineContext, leadingLineContent = _a.leadingLineContent, characterCountDelta = _a.characterCountDelta;
        var word = '';
        // incrementally filter less
        var source = this._refilterKind === 1 /* All */ ? this._items : this._filteredItems;
        var target = [];
        // picks a score function based on the number of
        // items that we have to score/filter and based on the
        // user-configuration
        var scoreFn = (!this._options.filterGraceful || source.length > 2000) ? __WEBPACK_IMPORTED_MODULE_0__base_common_filters_js__["c" /* fuzzyScore */] : __WEBPACK_IMPORTED_MODULE_0__base_common_filters_js__["d" /* fuzzyScoreGracefulAggressive */];
        for (var i = 0; i < source.length; i++) {
            var item = source[i];
            var suggestion = item.suggestion, container = item.container;
            // collect those supports that signaled having
            // an incomplete result
            if (container.incomplete) {
                this._isIncomplete.add(item.support);
            }
            // 'word' is that remainder of the current line that we
            // filter and score against. In theory each suggestion uses a
            // different word, but in practice not - that's why we cache
            var wordLen = suggestion.overwriteBefore + characterCountDelta - (item.position.column - this._column);
            if (word.length !== wordLen) {
                word = wordLen === 0 ? '' : leadingLineContent.slice(-wordLen);
            }
            // remember the word against which this item was
            // scored
            item.word = word;
            if (wordLen === 0) {
                // when there is nothing to score against, don't
                // event try to do. Use a const rank and rely on
                // the fallback-sort using the initial sort order.
                // use a score of `-100` because that is out of the
                // bound of values `fuzzyScore` will return
                item.score = -100;
                item.matches = undefined;
            }
            else if (typeof suggestion.filterText === 'string') {
                // when there is a `filterText` it must match the `word`.
                // if it matches we check with the label to compute highlights
                // and if that doesn't yield a result we have no highlights,
                // despite having the match
                var match = scoreFn(word, suggestion.filterText, suggestion.overwriteBefore);
                if (!match) {
                    continue;
                }
                item.score = match[0];
                item.matches = (Object(__WEBPACK_IMPORTED_MODULE_0__base_common_filters_js__["c" /* fuzzyScore */])(word, suggestion.label) || Object(__WEBPACK_IMPORTED_MODULE_0__base_common_filters_js__["a" /* anyScore */])(word, suggestion.label))[1];
            }
            else {
                // by default match `word` against the `label`
                var match = scoreFn(word, suggestion.label, suggestion.overwriteBefore);
                if (match) {
                    item.score = match[0];
                    item.matches = match[1];
                }
                else {
                    continue;
                }
            }
            item.idx = i;
            target.push(item);
            // update stats
            this._stats.suggestionCount++;
            switch (suggestion.type) {
                case 'snippet':
                    this._stats.snippetCount++;
                    break;
                case 'text':
                    this._stats.textCount++;
                    break;
            }
        }
        this._filteredItems = target.sort(this._snippetCompareFn);
        this._refilterKind = 0 /* Nothing */;
    };
    CompletionModel._compareCompletionItems = function (a, b) {
        if (a.score > b.score) {
            return -1;
        }
        else if (a.score < b.score) {
            return 1;
        }
        else if (a.idx < b.idx) {
            return -1;
        }
        else if (a.idx > b.idx) {
            return 1;
        }
        else {
            return 0;
        }
    };
    CompletionModel._compareCompletionItemsSnippetsDown = function (a, b) {
        if (a.suggestion.type !== b.suggestion.type) {
            if (a.suggestion.type === 'snippet') {
                return 1;
            }
            else if (b.suggestion.type === 'snippet') {
                return -1;
            }
        }
        return CompletionModel._compareCompletionItems(a, b);
    };
    CompletionModel._compareCompletionItemsSnippetsUp = function (a, b) {
        if (a.suggestion.type !== b.suggestion.type) {
            if (a.suggestion.type === 'snippet') {
                return -1;
            }
            else if (b.suggestion.type === 'snippet') {
                return 1;
            }
        }
        return CompletionModel._compareCompletionItems(a, b);
    };
    return CompletionModel;
}());



/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export editorSuggestWidgetBackground */
/* unused harmony export editorSuggestWidgetBorder */
/* unused harmony export editorSuggestWidgetForeground */
/* unused harmony export editorSuggestWidgetSelectedBackground */
/* unused harmony export editorSuggestWidgetHighlightForeground */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_suggest_css__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_suggest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__media_suggest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_filters_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_browser_ui_highlightedlabel_highlightedLabel_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_browser_ui_list_listWidget_js__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_browser_ui_scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__suggest_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_telemetry_common_telemetry_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__platform_theme_common_styler_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__platform_storage_common_storage_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__markdown_markdownRenderer_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_services_modeService_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__platform_opener_common_opener_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__base_common_cancellation_js__ = __webpack_require__(35);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


























var sticky = false; // for development purposes
var expandSuggestionDocsByDefault = false;
var maxSuggestionsToShow = 12;
/**
 * Suggest widget colors
 */
var editorSuggestWidgetBackground = Object(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorSuggestWidget.background', { dark: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["D" /* editorWidgetBackground */], light: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["D" /* editorWidgetBackground */], hc: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["D" /* editorWidgetBackground */] }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorSuggestWidgetBackground', 'Background color of the suggest widget.'));
var editorSuggestWidgetBorder = Object(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorSuggestWidget.border', { dark: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["E" /* editorWidgetBorder */], light: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["E" /* editorWidgetBorder */], hc: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["E" /* editorWidgetBorder */] }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorSuggestWidgetBorder', 'Border color of the suggest widget.'));
var editorSuggestWidgetForeground = Object(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorSuggestWidget.foreground', { dark: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["u" /* editorForeground */], light: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["u" /* editorForeground */], hc: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["u" /* editorForeground */] }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorSuggestWidgetForeground', 'Foreground color of the suggest widget.'));
var editorSuggestWidgetSelectedBackground = Object(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorSuggestWidget.selectedBackground', { dark: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["W" /* listFocusBackground */], light: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["W" /* listFocusBackground */], hc: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["W" /* listFocusBackground */] }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorSuggestWidgetSelectedBackground', 'Background color of the selected entry in the suggest widget.'));
var editorSuggestWidgetHighlightForeground = Object(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["_10" /* registerColor */])('editorSuggestWidget.highlightForeground', { dark: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["Y" /* listHighlightForeground */], light: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["Y" /* listHighlightForeground */], hc: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["Y" /* listHighlightForeground */] }, __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editorSuggestWidgetHighlightForeground', 'Color of the match highlights in the suggest widget.'));
var colorRegExp = /^(#([\da-f]{3}){1,2}|(rgb|hsl)a\(\s*(\d{1,3}%?\s*,\s*){3}(1|0?\.\d+)\)|(rgb|hsl)\(\s*\d{1,3}%?(\s*,\s*\d{1,3}%?){2}\s*\))$/i;
function matchesColor(text) {
    return text && text.match(colorRegExp) ? text : null;
}
function canExpandCompletionItem(item) {
    if (!item) {
        return false;
    }
    var suggestion = item.suggestion;
    if (suggestion.documentation) {
        return true;
    }
    return (suggestion.detail && suggestion.detail !== suggestion.label);
}
var Renderer = /** @class */ (function () {
    function Renderer(widget, editor, triggerKeybindingLabel) {
        this.widget = widget;
        this.editor = editor;
        this.triggerKeybindingLabel = triggerKeybindingLabel;
    }
    Object.defineProperty(Renderer.prototype, "templateId", {
        get: function () {
            return 'suggestion';
        },
        enumerable: true,
        configurable: true
    });
    Renderer.prototype.renderTemplate = function (container) {
        var _this = this;
        var data = Object.create(null);
        data.disposables = [];
        data.root = container;
        data.icon = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(container, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.icon'));
        data.colorspan = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(data.icon, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('span.colorspan'));
        var text = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(container, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.contents'));
        var main = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(text, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.main'));
        data.highlightedLabel = new __WEBPACK_IMPORTED_MODULE_8__base_browser_ui_highlightedlabel_highlightedLabel_js__["a" /* HighlightedLabel */](main);
        data.disposables.push(data.highlightedLabel);
        data.typeLabel = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(main, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('span.type-label'));
        data.readMore = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(main, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('span.readMore'));
        data.readMore.title = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('readMore', "Read More...{0}", this.triggerKeybindingLabel);
        var configureFont = function () {
            var configuration = _this.editor.getConfiguration();
            var fontFamily = configuration.fontInfo.fontFamily;
            var fontSize = configuration.contribInfo.suggestFontSize || configuration.fontInfo.fontSize;
            var lineHeight = configuration.contribInfo.suggestLineHeight || configuration.fontInfo.lineHeight;
            var fontSizePx = fontSize + "px";
            var lineHeightPx = lineHeight + "px";
            data.root.style.fontSize = fontSizePx;
            main.style.fontFamily = fontFamily;
            main.style.lineHeight = lineHeightPx;
            data.icon.style.height = lineHeightPx;
            data.icon.style.width = lineHeightPx;
            data.readMore.style.height = lineHeightPx;
            data.readMore.style.width = lineHeightPx;
        };
        configureFont();
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["g" /* chain */])(this.editor.onDidChangeConfiguration.bind(this.editor))
            .filter(function (e) { return e.fontInfo || e.contribInfo; })
            .on(configureFont, null, data.disposables);
        return data;
    };
    Renderer.prototype.renderElement = function (element, index, templateData) {
        var _this = this;
        var data = templateData;
        var suggestion = element.suggestion;
        if (canExpandCompletionItem(element)) {
            data.root.setAttribute('aria-label', __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('suggestionWithDetailsAriaLabel', "{0}, suggestion, has details", suggestion.label));
        }
        else {
            data.root.setAttribute('aria-label', __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('suggestionAriaLabel', "{0}, suggestion", suggestion.label));
        }
        data.icon.className = 'icon ' + suggestion.type;
        data.colorspan.style.backgroundColor = '';
        if (suggestion.type === 'color') {
            var color = matchesColor(suggestion.label) || typeof suggestion.documentation === 'string' && matchesColor(suggestion.documentation);
            if (color) {
                data.icon.className = 'icon customcolor';
                data.colorspan.style.backgroundColor = color;
            }
        }
        data.highlightedLabel.set(suggestion.label, Object(__WEBPACK_IMPORTED_MODULE_2__base_common_filters_js__["b" /* createMatches */])(element.matches), '', true);
        // data.highlightedLabel.set(`${suggestion.label} <${element.score}=score(${element.word}, ${suggestion.filterText || suggestion.label})>`, createMatches(element.matches));
        data.typeLabel.textContent = (suggestion.detail || '').replace(/\n.*$/m, '');
        if (canExpandCompletionItem(element)) {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(data.readMore);
            data.readMore.onmousedown = function (e) {
                e.stopPropagation();
                e.preventDefault();
            };
            data.readMore.onclick = function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this.widget.toggleDetails();
            };
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(data.readMore);
            data.readMore.onmousedown = null;
            data.readMore.onclick = null;
        }
    };
    Renderer.prototype.disposeElement = function () {
        // noop
    };
    Renderer.prototype.disposeTemplate = function (templateData) {
        templateData.disposables = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(templateData.disposables);
    };
    return Renderer;
}());
var SuggestionDetails = /** @class */ (function () {
    function SuggestionDetails(container, widget, editor, markdownRenderer, triggerKeybindingLabel) {
        var _this = this;
        this.widget = widget;
        this.editor = editor;
        this.markdownRenderer = markdownRenderer;
        this.triggerKeybindingLabel = triggerKeybindingLabel;
        this.borderWidth = 1;
        this.disposables = [];
        this.el = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(container, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.details'));
        this.disposables.push(Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["f" /* toDisposable */])(function () { return container.removeChild(_this.el); }));
        this.body = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.body');
        this.scrollbar = new __WEBPACK_IMPORTED_MODULE_10__base_browser_ui_scrollbar_scrollableElement_js__["a" /* DomScrollableElement */](this.body, {});
        Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(this.el, this.scrollbar.getDomNode());
        this.disposables.push(this.scrollbar);
        this.header = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(this.body, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.header'));
        this.close = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(this.header, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('span.close'));
        this.close.title = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('readLess', "Read less...{0}", this.triggerKeybindingLabel);
        this.type = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(this.header, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('p.type'));
        this.docs = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(this.body, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('p.docs'));
        this.ariaLabel = null;
        this.configureFont();
        Object(__WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["g" /* chain */])(this.editor.onDidChangeConfiguration.bind(this.editor))
            .filter(function (e) { return e.fontInfo; })
            .on(this.configureFont, this, this.disposables);
        markdownRenderer.onDidRenderCodeBlock(function () { return _this.scrollbar.scanDomNode(); }, this, this.disposables);
    }
    Object.defineProperty(SuggestionDetails.prototype, "element", {
        get: function () {
            return this.el;
        },
        enumerable: true,
        configurable: true
    });
    SuggestionDetails.prototype.render = function (item) {
        var _this = this;
        this.renderDisposeable = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.renderDisposeable);
        if (!item || !canExpandCompletionItem(item)) {
            this.type.textContent = '';
            this.docs.textContent = '';
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["f" /* addClass */])(this.el, 'no-docs');
            this.ariaLabel = null;
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.el, 'no-docs');
        if (typeof item.suggestion.documentation === 'string') {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.docs, 'markdown-docs');
            this.docs.textContent = item.suggestion.documentation;
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["f" /* addClass */])(this.docs, 'markdown-docs');
            this.docs.innerHTML = '';
            var renderedContents = this.markdownRenderer.render(item.suggestion.documentation);
            this.renderDisposeable = renderedContents;
            this.docs.appendChild(renderedContents.element);
        }
        if (item.suggestion.detail) {
            this.type.innerText = item.suggestion.detail;
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(this.type);
        }
        else {
            this.type.innerText = '';
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.type);
        }
        this.el.style.height = this.header.offsetHeight + this.docs.offsetHeight + (this.borderWidth * 2) + 'px';
        this.close.onmousedown = function (e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.close.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.widget.toggleDetails();
        };
        this.body.scrollTop = 0;
        this.scrollbar.scanDomNode();
        this.ariaLabel = __WEBPACK_IMPORTED_MODULE_3__base_common_strings_js__["format"]('{0}\n{1}\n{2}', item.suggestion.label || '', item.suggestion.detail || '', item.suggestion.documentation || '');
    };
    SuggestionDetails.prototype.getAriaLabel = function () {
        return this.ariaLabel;
    };
    SuggestionDetails.prototype.scrollDown = function (much) {
        if (much === void 0) { much = 8; }
        this.body.scrollTop += much;
    };
    SuggestionDetails.prototype.scrollUp = function (much) {
        if (much === void 0) { much = 8; }
        this.body.scrollTop -= much;
    };
    SuggestionDetails.prototype.scrollTop = function () {
        this.body.scrollTop = 0;
    };
    SuggestionDetails.prototype.scrollBottom = function () {
        this.body.scrollTop = this.body.scrollHeight;
    };
    SuggestionDetails.prototype.pageDown = function () {
        this.scrollDown(80);
    };
    SuggestionDetails.prototype.pageUp = function () {
        this.scrollUp(80);
    };
    SuggestionDetails.prototype.setBorderWidth = function (width) {
        this.borderWidth = width;
    };
    SuggestionDetails.prototype.configureFont = function () {
        var configuration = this.editor.getConfiguration();
        var fontFamily = configuration.fontInfo.fontFamily;
        var fontSize = configuration.contribInfo.suggestFontSize || configuration.fontInfo.fontSize;
        var lineHeight = configuration.contribInfo.suggestLineHeight || configuration.fontInfo.lineHeight;
        var fontSizePx = fontSize + "px";
        var lineHeightPx = lineHeight + "px";
        this.el.style.fontSize = fontSizePx;
        this.type.style.fontFamily = fontFamily;
        this.close.style.height = lineHeightPx;
        this.close.style.width = lineHeightPx;
    };
    SuggestionDetails.prototype.dispose = function () {
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.disposables);
        this.renderDisposeable = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.renderDisposeable);
    };
    return SuggestionDetails;
}());
var SuggestWidget = /** @class */ (function () {
    function SuggestWidget(editor, telemetryService, contextKeyService, themeService, storageService, keybindingService, modeService, openerService) {
        var _this = this;
        this.editor = editor;
        this.telemetryService = telemetryService;
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = true;
        this.ignoreFocusEvents = false;
        this.editorBlurTimeout = new __WEBPACK_IMPORTED_MODULE_24__base_common_async_js__["f" /* TimeoutTimer */]();
        this.showTimeout = new __WEBPACK_IMPORTED_MODULE_24__base_common_async_js__["f" /* TimeoutTimer */]();
        this.onDidSelectEmitter = new __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["a" /* Emitter */]();
        this.onDidFocusEmitter = new __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["a" /* Emitter */]();
        this.onDidHideEmitter = new __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["a" /* Emitter */]();
        this.onDidShowEmitter = new __WEBPACK_IMPORTED_MODULE_4__base_common_event_js__["a" /* Emitter */]();
        this.onDidSelect = this.onDidSelectEmitter.event;
        this.onDidFocus = this.onDidFocusEmitter.event;
        this.onDidHide = this.onDidHideEmitter.event;
        this.onDidShow = this.onDidShowEmitter.event;
        this.maxWidgetWidth = 660;
        this.listWidth = 330;
        this.storageServiceAvailable = true;
        this.expandSuggestionDocs = false;
        this.firstFocusInCurrentList = false;
        var kb = keybindingService.lookupKeybinding('editor.action.triggerSuggest');
        var triggerKeybindingLabel = !kb ? '' : " (" + kb.getLabel() + ")";
        var markdownRenderer = new __WEBPACK_IMPORTED_MODULE_21__markdown_markdownRenderer_js__["a" /* MarkdownRenderer */](editor, modeService, openerService);
        this.isAuto = false;
        this.focusedItem = null;
        this.storageService = storageService;
        if (this.expandDocsSettingFromStorage() === undefined) {
            this.storageService.store('expandSuggestionDocs', expandSuggestionDocsByDefault, __WEBPACK_IMPORTED_MODULE_20__platform_storage_common_storage_js__["c" /* StorageScope */].GLOBAL);
            if (this.expandDocsSettingFromStorage() === undefined) {
                this.storageServiceAvailable = false;
            }
        }
        this.element = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.editor-widget.suggest-widget');
        if (!this.editor.getConfiguration().contribInfo.iconsInSuggestions) {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["f" /* addClass */])(this.element, 'no-icons');
        }
        this.messageElement = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(this.element, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.message'));
        this.listElement = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["k" /* append */])(this.element, Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["a" /* $ */])('.tree'));
        this.details = new SuggestionDetails(this.element, this, this.editor, markdownRenderer, triggerKeybindingLabel);
        var renderer = new Renderer(this, this.editor, triggerKeybindingLabel);
        this.list = new __WEBPACK_IMPORTED_MODULE_9__base_browser_ui_list_listWidget_js__["a" /* List */](this.listElement, this, [renderer], {
            useShadows: false,
            selectOnMouseDown: true,
            focusOnMouseDown: false,
            openController: { shouldOpen: function () { return false; } }
        });
        this.toDispose = [
            Object(__WEBPACK_IMPORTED_MODULE_17__platform_theme_common_styler_js__["b" /* attachListStyler */])(this.list, themeService, {
                listInactiveFocusBackground: editorSuggestWidgetSelectedBackground,
                listInactiveFocusOutline: __WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["b" /* activeContrastBorder */]
            }),
            themeService.onThemeChange(function (t) { return _this.onThemeChange(t); }),
            editor.onDidBlurEditorText(function () { return _this.onEditorBlur(); }),
            editor.onDidLayoutChange(function () { return _this.onEditorLayoutChange(); }),
            this.list.onSelectionChange(function (e) { return _this.onListSelection(e); }),
            this.list.onFocusChange(function (e) { return _this.onListFocus(e); }),
            this.editor.onDidChangeCursorSelection(function () { return _this.onCursorSelectionChanged(); })
        ];
        this.suggestWidgetVisible = __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].Visible.bindTo(contextKeyService);
        this.suggestWidgetMultipleSuggestions = __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].MultipleSuggestions.bindTo(contextKeyService);
        this.suggestionSupportsAutoAccept = __WEBPACK_IMPORTED_MODULE_14__suggest_js__["a" /* Context */].AcceptOnKey.bindTo(contextKeyService);
        this.editor.addContentWidget(this);
        this.setState(0 /* Hidden */);
        this.onThemeChange(themeService.getTheme());
    }
    SuggestWidget.prototype.onCursorSelectionChanged = function () {
        if (this.state === 0 /* Hidden */) {
            return;
        }
        this.editor.layoutContentWidget(this);
    };
    SuggestWidget.prototype.onEditorBlur = function () {
        var _this = this;
        if (sticky) {
            return;
        }
        this.editorBlurTimeout.cancelAndSet(function () {
            if (!_this.editor.hasTextFocus()) {
                _this.setState(0 /* Hidden */);
            }
        }, 150);
    };
    SuggestWidget.prototype.onEditorLayoutChange = function () {
        if ((this.state === 3 /* Open */ || this.state === 5 /* Details */) && this.expandDocsSettingFromStorage()) {
            this.expandSideOrBelow();
        }
    };
    SuggestWidget.prototype.onListSelection = function (e) {
        var _this = this;
        if (!e.elements.length) {
            return;
        }
        var item = e.elements[0];
        var index = e.indexes[0];
        item.resolve(__WEBPACK_IMPORTED_MODULE_25__base_common_cancellation_js__["a" /* CancellationToken */].None).then(function () {
            _this.onDidSelectEmitter.fire({ item: item, index: index, model: _this.completionModel });
            Object(__WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__["a" /* alert */])(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('suggestionAriaAccepted', "{0}, accepted", item.suggestion.label));
            _this.editor.focus();
        });
    };
    SuggestWidget.prototype._getSuggestionAriaAlertLabel = function (item) {
        if (canExpandCompletionItem(item)) {
            return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('ariaCurrentSuggestionWithDetails', "{0}, suggestion, has details", item.suggestion.label);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('ariaCurrentSuggestion', "{0}, suggestion", item.suggestion.label);
        }
    };
    SuggestWidget.prototype._ariaAlert = function (newAriaAlertLabel) {
        if (this._lastAriaAlertLabel === newAriaAlertLabel) {
            return;
        }
        this._lastAriaAlertLabel = newAriaAlertLabel;
        if (this._lastAriaAlertLabel) {
            Object(__WEBPACK_IMPORTED_MODULE_15__base_browser_ui_aria_aria_js__["a" /* alert */])(this._lastAriaAlertLabel);
        }
    };
    SuggestWidget.prototype.onThemeChange = function (theme) {
        var backgroundColor = theme.getColor(editorSuggestWidgetBackground);
        if (backgroundColor) {
            this.listElement.style.backgroundColor = backgroundColor.toString();
            this.details.element.style.backgroundColor = backgroundColor.toString();
            this.messageElement.style.backgroundColor = backgroundColor.toString();
        }
        var borderColor = theme.getColor(editorSuggestWidgetBorder);
        if (borderColor) {
            this.listElement.style.borderColor = borderColor.toString();
            this.details.element.style.borderColor = borderColor.toString();
            this.messageElement.style.borderColor = borderColor.toString();
            this.detailsBorderColor = borderColor.toString();
        }
        var focusBorderColor = theme.getColor(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["H" /* focusBorder */]);
        if (focusBorderColor) {
            this.detailsFocusBorderColor = focusBorderColor.toString();
        }
        this.details.setBorderWidth(theme.type === 'hc' ? 2 : 1);
    };
    SuggestWidget.prototype.onListFocus = function (e) {
        var _this = this;
        if (this.ignoreFocusEvents) {
            return;
        }
        if (!e.elements.length) {
            if (this.currentSuggestionDetails) {
                this.currentSuggestionDetails.cancel();
                this.currentSuggestionDetails = null;
                this.focusedItem = null;
            }
            this._ariaAlert(null);
            return;
        }
        var item = e.elements[0];
        this._ariaAlert(this._getSuggestionAriaAlertLabel(item));
        this.firstFocusInCurrentList = !this.focusedItem;
        if (item === this.focusedItem) {
            return;
        }
        if (this.currentSuggestionDetails) {
            this.currentSuggestionDetails.cancel();
            this.currentSuggestionDetails = null;
        }
        var index = e.indexes[0];
        this.suggestionSupportsAutoAccept.set(!item.suggestion.noAutoAccept);
        this.focusedItem = item;
        this.list.reveal(index);
        this.currentSuggestionDetails = Object(__WEBPACK_IMPORTED_MODULE_24__base_common_async_js__["i" /* createCancelablePromise */])(function (token) { return item.resolve(token); });
        this.currentSuggestionDetails.then(function () {
            // item can have extra information, so re-render
            _this.ignoreFocusEvents = true;
            _this.list.splice(index, 1, [item]);
            _this.list.setFocus([index]);
            _this.ignoreFocusEvents = false;
            if (_this.expandDocsSettingFromStorage()) {
                _this.showDetails();
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(_this.element, 'docs-side');
            }
        }).catch(__WEBPACK_IMPORTED_MODULE_5__base_common_errors_js__["e" /* onUnexpectedError */]).then(function () {
            if (_this.focusedItem === item) {
                _this.currentSuggestionDetails = null;
            }
        });
        // emit an event
        this.onDidFocusEmitter.fire({ item: item, index: index, model: this.completionModel });
    };
    SuggestWidget.prototype.setState = function (state) {
        if (!this.element) {
            return;
        }
        var stateChanged = this.state !== state;
        this.state = state;
        Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["N" /* toggleClass */])(this.element, 'frozen', state === 4 /* Frozen */);
        switch (state) {
            case 0 /* Hidden */:
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.messageElement, this.details.element, this.listElement);
                this.hide();
                this.listHeight = 0;
                if (stateChanged) {
                    this.list.splice(0, this.list.length);
                }
                this.focusedItem = null;
                break;
            case 1 /* Loading */:
                this.messageElement.textContent = SuggestWidget.LOADING_MESSAGE;
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.listElement, this.details.element);
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(this.messageElement);
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-side');
                this.show();
                this.focusedItem = null;
                break;
            case 2 /* Empty */:
                this.messageElement.textContent = SuggestWidget.NO_SUGGESTIONS_MESSAGE;
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.listElement, this.details.element);
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(this.messageElement);
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-side');
                this.show();
                this.focusedItem = null;
                break;
            case 3 /* Open */:
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.messageElement);
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(this.listElement);
                this.show();
                break;
            case 4 /* Frozen */:
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.messageElement);
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(this.listElement);
                this.show();
                break;
            case 5 /* Details */:
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.messageElement);
                Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(this.details.element, this.listElement);
                this.show();
                this._ariaAlert(this.details.getAriaLabel());
                break;
        }
    };
    SuggestWidget.prototype.showTriggered = function (auto) {
        var _this = this;
        if (this.state !== 0 /* Hidden */) {
            return;
        }
        this.isAuto = !!auto;
        if (!this.isAuto) {
            this.loadingTimeout = setTimeout(function () {
                _this.loadingTimeout = null;
                _this.setState(1 /* Loading */);
            }, 50);
        }
    };
    SuggestWidget.prototype.showSuggestions = function (completionModel, selectionIndex, isFrozen, isAuto) {
        if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
            this.loadingTimeout = null;
        }
        if (this.completionModel !== completionModel) {
            this.completionModel = completionModel;
        }
        if (isFrozen && this.state !== 2 /* Empty */ && this.state !== 0 /* Hidden */) {
            this.setState(4 /* Frozen */);
            return;
        }
        var visibleCount = this.completionModel.items.length;
        var isEmpty = visibleCount === 0;
        this.suggestWidgetMultipleSuggestions.set(visibleCount > 1);
        if (isEmpty) {
            if (isAuto) {
                this.setState(0 /* Hidden */);
            }
            else {
                this.setState(2 /* Empty */);
            }
            this.completionModel = null;
        }
        else {
            var stats = this.completionModel.stats;
            stats['wasAutomaticallyTriggered'] = !!isAuto;
            /* __GDPR__
                "suggestWidget" : {
                    "wasAutomaticallyTriggered" : { "classification": "SystemMetaData", "purpose": "FeatureInsight", "isMeasurement": true },
                    "${include}": [
                        "${ICompletionStats}",
                        "${EditorTelemetryData}"
                    ]
                }
            */
            this.telemetryService.publicLog('suggestWidget', __assign({}, stats, this.editor.getTelemetryData()));
            this.list.splice(0, this.list.length, this.completionModel.items);
            if (isFrozen) {
                this.setState(4 /* Frozen */);
            }
            else {
                this.setState(3 /* Open */);
            }
            this.list.reveal(selectionIndex, selectionIndex);
            this.list.setFocus([selectionIndex]);
            // Reset focus border
            if (this.detailsBorderColor) {
                this.details.element.style.borderColor = this.detailsBorderColor;
            }
        }
    };
    SuggestWidget.prototype.selectNextPage = function () {
        switch (this.state) {
            case 0 /* Hidden */:
                return false;
            case 5 /* Details */:
                this.details.pageDown();
                return true;
            case 1 /* Loading */:
                return !this.isAuto;
            default:
                this.list.focusNextPage();
                return true;
        }
    };
    SuggestWidget.prototype.selectNext = function () {
        switch (this.state) {
            case 0 /* Hidden */:
                return false;
            case 1 /* Loading */:
                return !this.isAuto;
            default:
                this.list.focusNext(1, true);
                return true;
        }
    };
    SuggestWidget.prototype.selectLast = function () {
        switch (this.state) {
            case 0 /* Hidden */:
                return false;
            case 5 /* Details */:
                this.details.scrollBottom();
                return true;
            case 1 /* Loading */:
                return !this.isAuto;
            default:
                this.list.focusLast();
                return true;
        }
    };
    SuggestWidget.prototype.selectPreviousPage = function () {
        switch (this.state) {
            case 0 /* Hidden */:
                return false;
            case 5 /* Details */:
                this.details.pageUp();
                return true;
            case 1 /* Loading */:
                return !this.isAuto;
            default:
                this.list.focusPreviousPage();
                return true;
        }
    };
    SuggestWidget.prototype.selectPrevious = function () {
        switch (this.state) {
            case 0 /* Hidden */:
                return false;
            case 1 /* Loading */:
                return !this.isAuto;
            default:
                this.list.focusPrevious(1, true);
                return false;
        }
    };
    SuggestWidget.prototype.selectFirst = function () {
        switch (this.state) {
            case 0 /* Hidden */:
                return false;
            case 5 /* Details */:
                this.details.scrollTop();
                return true;
            case 1 /* Loading */:
                return !this.isAuto;
            default:
                this.list.focusFirst();
                return true;
        }
    };
    SuggestWidget.prototype.getFocusedItem = function () {
        if (this.state !== 0 /* Hidden */
            && this.state !== 2 /* Empty */
            && this.state !== 1 /* Loading */) {
            return {
                item: this.list.getFocusedElements()[0],
                index: this.list.getFocus()[0],
                model: this.completionModel
            };
        }
        return undefined;
    };
    SuggestWidget.prototype.toggleDetailsFocus = function () {
        if (this.state === 5 /* Details */) {
            this.setState(3 /* Open */);
            if (this.detailsBorderColor) {
                this.details.element.style.borderColor = this.detailsBorderColor;
            }
        }
        else if (this.state === 3 /* Open */ && this.expandDocsSettingFromStorage()) {
            this.setState(5 /* Details */);
            if (this.detailsFocusBorderColor) {
                this.details.element.style.borderColor = this.detailsFocusBorderColor;
            }
        }
        /* __GDPR__
            "suggestWidget:toggleDetailsFocus" : {
                "${include}": [
                    "${EditorTelemetryData}"
                ]
            }
        */
        this.telemetryService.publicLog('suggestWidget:toggleDetailsFocus', this.editor.getTelemetryData());
    };
    SuggestWidget.prototype.toggleDetails = function () {
        if (!canExpandCompletionItem(this.list.getFocusedElements()[0])) {
            return;
        }
        if (this.expandDocsSettingFromStorage()) {
            this.updateExpandDocsSetting(false);
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["A" /* hide */])(this.details.element);
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-side');
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-below');
            this.editor.layoutContentWidget(this);
            /* __GDPR__
                "suggestWidget:collapseDetails" : {
                    "${include}": [
                        "${EditorTelemetryData}"
                    ]
                }
            */
            this.telemetryService.publicLog('suggestWidget:collapseDetails', this.editor.getTelemetryData());
        }
        else {
            if (this.state !== 3 /* Open */ && this.state !== 5 /* Details */ && this.state !== 4 /* Frozen */) {
                return;
            }
            this.updateExpandDocsSetting(true);
            this.showDetails();
            /* __GDPR__
                "suggestWidget:expandDetails" : {
                    "${include}": [
                        "${EditorTelemetryData}"
                    ]
                }
            */
            this.telemetryService.publicLog('suggestWidget:expandDetails', this.editor.getTelemetryData());
        }
    };
    SuggestWidget.prototype.showDetails = function () {
        this.expandSideOrBelow();
        Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["M" /* show */])(this.details.element);
        this.details.render(this.list.getFocusedElements()[0]);
        this.details.element.style.maxHeight = this.maxWidgetHeight + 'px';
        // Reset margin-top that was set as Fix for #26416
        this.listElement.style.marginTop = '0px';
        // with docs showing up widget width/height may change, so reposition the widget
        this.editor.layoutContentWidget(this);
        this.adjustDocsPosition();
        this.editor.focus();
        this._ariaAlert(this.details.getAriaLabel());
    };
    SuggestWidget.prototype.show = function () {
        var _this = this;
        var newHeight = this.updateListHeight();
        if (newHeight !== this.listHeight) {
            this.editor.layoutContentWidget(this);
            this.listHeight = newHeight;
        }
        this.suggestWidgetVisible.set(true);
        this.showTimeout.cancelAndSet(function () {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["f" /* addClass */])(_this.element, 'visible');
            _this.onDidShowEmitter.fire(_this);
        }, 100);
    };
    SuggestWidget.prototype.hide = function () {
        this.suggestWidgetVisible.reset();
        this.suggestWidgetMultipleSuggestions.reset();
        Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'visible');
    };
    SuggestWidget.prototype.hideWidget = function () {
        clearTimeout(this.loadingTimeout);
        this.setState(0 /* Hidden */);
        this.onDidHideEmitter.fire(this);
    };
    SuggestWidget.prototype.getPosition = function () {
        if (this.state === 0 /* Hidden */) {
            return null;
        }
        return {
            position: this.editor.getPosition(),
            preference: [__WEBPACK_IMPORTED_MODULE_13__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].BELOW, __WEBPACK_IMPORTED_MODULE_13__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */].ABOVE]
        };
    };
    SuggestWidget.prototype.getDomNode = function () {
        return this.element;
    };
    SuggestWidget.prototype.getId = function () {
        return SuggestWidget.ID;
    };
    SuggestWidget.prototype.updateListHeight = function () {
        var height = 0;
        if (this.state === 2 /* Empty */ || this.state === 1 /* Loading */) {
            height = this.unfocusedHeight;
        }
        else {
            var suggestionCount = this.list.contentHeight / this.unfocusedHeight;
            height = Math.min(suggestionCount, maxSuggestionsToShow) * this.unfocusedHeight;
        }
        this.element.style.lineHeight = this.unfocusedHeight + "px";
        this.listElement.style.height = height + "px";
        this.list.layout(height);
        return height;
    };
    SuggestWidget.prototype.adjustDocsPosition = function () {
        var lineHeight = this.editor.getConfiguration().fontInfo.lineHeight;
        var cursorCoords = this.editor.getScrolledVisiblePosition(this.editor.getPosition());
        var editorCoords = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["u" /* getDomNodePagePosition */])(this.editor.getDomNode());
        var cursorX = editorCoords.left + cursorCoords.left;
        var cursorY = editorCoords.top + cursorCoords.top + cursorCoords.height;
        var widgetCoords = Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["u" /* getDomNodePagePosition */])(this.element);
        var widgetX = widgetCoords.left;
        var widgetY = widgetCoords.top;
        if (widgetX < cursorX - this.listWidth) {
            // Widget is too far to the left of cursor, swap list and docs
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["f" /* addClass */])(this.element, 'list-right');
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'list-right');
        }
        // Compare top of the cursor (cursorY - lineheight) with widgetTop to determine if
        // margin-top needs to be applied on list to make it appear right above the cursor
        // Cannot compare cursorY directly as it may be a few decimals off due to zoooming
        if (Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["z" /* hasClass */])(this.element, 'docs-side')
            && cursorY - lineHeight > widgetY
            && this.details.element.offsetHeight > this.listElement.offsetHeight) {
            // Fix for #26416
            // Docs is bigger than list and widget is above cursor, apply margin-top so that list appears right above cursor
            this.listElement.style.marginTop = this.details.element.offsetHeight - this.listElement.offsetHeight + "px";
        }
    };
    SuggestWidget.prototype.expandSideOrBelow = function () {
        if (!canExpandCompletionItem(this.focusedItem) && this.firstFocusInCurrentList) {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-side');
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-below');
            return;
        }
        var matches = this.element.style.maxWidth.match(/(\d+)px/);
        if (!matches || Number(matches[1]) < this.maxWidgetWidth) {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["f" /* addClass */])(this.element, 'docs-below');
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-side');
        }
        else if (canExpandCompletionItem(this.focusedItem)) {
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["f" /* addClass */])(this.element, 'docs-side');
            Object(__WEBPACK_IMPORTED_MODULE_7__base_browser_dom_js__["G" /* removeClass */])(this.element, 'docs-below');
        }
    };
    Object.defineProperty(SuggestWidget.prototype, "maxWidgetHeight", {
        // Heights
        get: function () {
            return this.unfocusedHeight * maxSuggestionsToShow;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuggestWidget.prototype, "unfocusedHeight", {
        get: function () {
            var configuration = this.editor.getConfiguration();
            return configuration.contribInfo.suggestLineHeight || configuration.fontInfo.lineHeight;
        },
        enumerable: true,
        configurable: true
    });
    // IDelegate
    SuggestWidget.prototype.getHeight = function (element) {
        return this.unfocusedHeight;
    };
    SuggestWidget.prototype.getTemplateId = function (element) {
        return 'suggestion';
    };
    // Monaco Editor does not have a storage service
    SuggestWidget.prototype.expandDocsSettingFromStorage = function () {
        if (this.storageServiceAvailable) {
            return this.storageService.getBoolean('expandSuggestionDocs', __WEBPACK_IMPORTED_MODULE_20__platform_storage_common_storage_js__["c" /* StorageScope */].GLOBAL);
        }
        else {
            return this.expandSuggestionDocs;
        }
    };
    // Monaco Editor does not have a storage service
    SuggestWidget.prototype.updateExpandDocsSetting = function (value) {
        if (this.storageServiceAvailable) {
            this.storageService.store('expandSuggestionDocs', value, __WEBPACK_IMPORTED_MODULE_20__platform_storage_common_storage_js__["c" /* StorageScope */].GLOBAL);
        }
        else {
            this.expandSuggestionDocs = value;
        }
    };
    SuggestWidget.prototype.dispose = function () {
        this.state = null;
        this.suggestionSupportsAutoAccept = null;
        this.currentSuggestionDetails = null;
        this.focusedItem = null;
        this.element = null;
        this.messageElement = null;
        this.listElement = null;
        this.details.dispose();
        this.details = null;
        this.list.dispose();
        this.list = null;
        this.toDispose = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this.toDispose);
        if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
            this.loadingTimeout = null;
        }
        this.editorBlurTimeout.dispose();
        this.showTimeout.dispose();
    };
    SuggestWidget.ID = 'editor.widget.suggestWidget';
    SuggestWidget.LOADING_MESSAGE = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('suggestWidget.loading', "Loading...");
    SuggestWidget.NO_SUGGESTIONS_MESSAGE = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('suggestWidget.noSuggestions', "No suggestions.");
    SuggestWidget = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_16__platform_telemetry_common_telemetry_js__["a" /* ITelemetryService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_12__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_18__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_20__platform_storage_common_storage_js__["a" /* IStorageService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_11__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_22__common_services_modeService_js__["a" /* IModeService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_23__platform_opener_common_opener_js__["a" /* IOpenerService */])
    ], SuggestWidget);
    return SuggestWidget;
}());

Object(__WEBPACK_IMPORTED_MODULE_18__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var matchHighlight = theme.getColor(editorSuggestWidgetHighlightForeground);
    if (matchHighlight) {
        collector.addRule(".monaco-editor .suggest-widget .monaco-list .monaco-list-row .monaco-highlighted-label .highlight { color: " + matchHighlight + "; }");
    }
    var foreground = theme.getColor(editorSuggestWidgetForeground);
    if (foreground) {
        collector.addRule(".monaco-editor .suggest-widget { color: " + foreground + "; }");
    }
    var link = theme.getColor(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["_16" /* textLinkForeground */]);
    if (link) {
        collector.addRule(".monaco-editor .suggest-widget a { color: " + link + "; }");
    }
    var codeBackground = theme.getColor(__WEBPACK_IMPORTED_MODULE_19__platform_theme_common_colorRegistry_js__["_15" /* textCodeBlockBackground */]);
    if (codeBackground) {
        collector.addRule(".monaco-editor .suggest-widget code { background-color: " + codeBackground + "; }");
    }
});


/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isSelectionSingleChangeEvent */
/* unused harmony export isSelectionRangeChangeEvent */
/* unused harmony export DefaultStyleController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_css__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__list_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_decorators_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__touch_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__event_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__listView_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__splice_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_numbers_js__ = __webpack_require__(510);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

















var TraitRenderer = /** @class */ (function () {
    function TraitRenderer(trait) {
        this.trait = trait;
        this.renderedElements = [];
    }
    Object.defineProperty(TraitRenderer.prototype, "templateId", {
        get: function () {
            return "template:" + this.trait.trait;
        },
        enumerable: true,
        configurable: true
    });
    TraitRenderer.prototype.renderTemplate = function (container) {
        return container;
    };
    TraitRenderer.prototype.renderElement = function (element, index, templateData) {
        var renderedElementIndex = Object(__WEBPACK_IMPORTED_MODULE_4__common_arrays_js__["h" /* firstIndex */])(this.renderedElements, function (el) { return el.templateData === templateData; });
        if (renderedElementIndex >= 0) {
            var rendered = this.renderedElements[renderedElementIndex];
            this.trait.unrender(templateData);
            rendered.index = index;
        }
        else {
            var rendered = { index: index, templateData: templateData };
            this.renderedElements.push(rendered);
        }
        this.trait.renderIndex(index, templateData);
    };
    TraitRenderer.prototype.disposeElement = function () {
        // noop
    };
    TraitRenderer.prototype.splice = function (start, deleteCount, insertCount) {
        var rendered = [];
        for (var i = 0; i < this.renderedElements.length; i++) {
            var renderedElement = this.renderedElements[i];
            if (renderedElement.index < start) {
                rendered.push(renderedElement);
            }
            else if (renderedElement.index >= start + deleteCount) {
                rendered.push({
                    index: renderedElement.index + insertCount - deleteCount,
                    templateData: renderedElement.templateData
                });
            }
        }
        this.renderedElements = rendered;
    };
    TraitRenderer.prototype.renderIndexes = function (indexes) {
        for (var _i = 0, _a = this.renderedElements; _i < _a.length; _i++) {
            var _b = _a[_i], index = _b.index, templateData = _b.templateData;
            if (indexes.indexOf(index) > -1) {
                this.trait.renderIndex(index, templateData);
            }
        }
    };
    TraitRenderer.prototype.disposeTemplate = function (templateData) {
        var index = Object(__WEBPACK_IMPORTED_MODULE_4__common_arrays_js__["h" /* firstIndex */])(this.renderedElements, function (el) { return el.templateData === templateData; });
        if (index < 0) {
            return;
        }
        this.renderedElements.splice(index, 1);
    };
    return TraitRenderer;
}());
var Trait = /** @class */ (function () {
    function Trait(_trait) {
        this._trait = _trait;
        this._onChange = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this.indexes = [];
    }
    Object.defineProperty(Trait.prototype, "onChange", {
        get: function () { return this._onChange.event; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trait.prototype, "trait", {
        get: function () { return this._trait; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trait.prototype, "renderer", {
        get: function () {
            return new TraitRenderer(this);
        },
        enumerable: true,
        configurable: true
    });
    Trait.prototype.splice = function (start, deleteCount, elements) {
        var diff = elements.length - deleteCount;
        var end = start + deleteCount;
        var indexes = this.indexes.filter(function (i) { return i < start; }).concat(elements.map(function (hasTrait, i) { return hasTrait ? i + start : -1; }).filter(function (i) { return i !== -1; }), this.indexes.filter(function (i) { return i >= end; }).map(function (i) { return i + diff; }));
        this.renderer.splice(start, deleteCount, elements.length);
        this.set(indexes);
    };
    Trait.prototype.renderIndex = function (index, container) {
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["N" /* toggleClass */](container, this._trait, this.contains(index));
    };
    Trait.prototype.unrender = function (container) {
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["G" /* removeClass */](container, this._trait);
    };
    /**
     * Sets the indexes which should have this trait.
     *
     * @param indexes Indexes which should have this trait.
     * @return The old indexes which had this trait.
     */
    Trait.prototype.set = function (indexes) {
        var result = this.indexes;
        this.indexes = indexes;
        var toRender = disjunction(result, indexes);
        this.renderer.renderIndexes(toRender);
        this._onChange.fire({ indexes: indexes });
        return result;
    };
    Trait.prototype.get = function () {
        return this.indexes;
    };
    Trait.prototype.contains = function (index) {
        return this.indexes.some(function (i) { return i === index; });
    };
    Trait.prototype.dispose = function () {
        this.indexes = null;
        this._onChange = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this._onChange);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5__common_decorators_js__["a" /* memoize */]
    ], Trait.prototype, "renderer", null);
    return Trait;
}());
var FocusTrait = /** @class */ (function (_super) {
    __extends(FocusTrait, _super);
    function FocusTrait(getDomId) {
        var _this = _super.call(this, 'focused') || this;
        _this.getDomId = getDomId;
        return _this;
    }
    FocusTrait.prototype.renderIndex = function (index, container) {
        _super.prototype.renderIndex.call(this, index, container);
        container.setAttribute('role', 'treeitem');
        container.setAttribute('id', this.getDomId(index));
    };
    return FocusTrait;
}(Trait));
/**
 * The TraitSpliceable is used as a util class to be able
 * to preserve traits across splice calls, given an identity
 * provider.
 */
var TraitSpliceable = /** @class */ (function () {
    function TraitSpliceable(trait, view, getId) {
        this.trait = trait;
        this.view = view;
        this.getId = getId;
    }
    TraitSpliceable.prototype.splice = function (start, deleteCount, elements) {
        var _this = this;
        if (!this.getId) {
            return this.trait.splice(start, deleteCount, elements.map(function (e) { return false; }));
        }
        var pastElementsWithTrait = this.trait.get().map(function (i) { return _this.getId(_this.view.element(i)); });
        var elementsWithTrait = elements.map(function (e) { return pastElementsWithTrait.indexOf(_this.getId(e)) > -1; });
        this.trait.splice(start, deleteCount, elementsWithTrait);
    };
    return TraitSpliceable;
}());
function isInputElement(e) {
    return e.tagName === 'INPUT' || e.tagName === 'TEXTAREA';
}
var KeyboardController = /** @class */ (function () {
    function KeyboardController(list, view, options) {
        this.list = list;
        this.view = view;
        var multipleSelectionSupport = !(options.multipleSelectionSupport === false);
        this.disposables = [];
        this.openController = options.openController || DefaultOpenController;
        var onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["g" /* chain */])(Object(__WEBPACK_IMPORTED_MODULE_11__event_js__["a" /* domEvent */])(view.domNode, 'keydown'))
            .filter(function (e) { return !isInputElement(e.target); })
            .map(function (e) { return new __WEBPACK_IMPORTED_MODULE_9__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e); });
        onKeyDown.filter(function (e) { return e.keyCode === 3 /* Enter */; }).on(this.onEnter, this, this.disposables);
        onKeyDown.filter(function (e) { return e.keyCode === 16 /* UpArrow */; }).on(this.onUpArrow, this, this.disposables);
        onKeyDown.filter(function (e) { return e.keyCode === 18 /* DownArrow */; }).on(this.onDownArrow, this, this.disposables);
        onKeyDown.filter(function (e) { return e.keyCode === 11 /* PageUp */; }).on(this.onPageUpArrow, this, this.disposables);
        onKeyDown.filter(function (e) { return e.keyCode === 12 /* PageDown */; }).on(this.onPageDownArrow, this, this.disposables);
        onKeyDown.filter(function (e) { return e.keyCode === 9 /* Escape */; }).on(this.onEscape, this, this.disposables);
        if (multipleSelectionSupport) {
            onKeyDown.filter(function (e) { return (__WEBPACK_IMPORTED_MODULE_7__common_platform_js__["d" /* isMacintosh */] ? e.metaKey : e.ctrlKey) && e.keyCode === 31 /* KEY_A */; }).on(this.onCtrlA, this, this.disposables);
        }
    }
    KeyboardController.prototype.onEnter = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.setSelection(this.list.getFocus());
        if (this.openController.shouldOpen(e.browserEvent)) {
            this.list.open(this.list.getFocus(), e.browserEvent);
        }
    };
    KeyboardController.prototype.onUpArrow = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusPrevious();
        this.list.reveal(this.list.getFocus()[0]);
        this.view.domNode.focus();
    };
    KeyboardController.prototype.onDownArrow = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusNext();
        this.list.reveal(this.list.getFocus()[0]);
        this.view.domNode.focus();
    };
    KeyboardController.prototype.onPageUpArrow = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusPreviousPage();
        this.list.reveal(this.list.getFocus()[0]);
        this.view.domNode.focus();
    };
    KeyboardController.prototype.onPageDownArrow = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusNextPage();
        this.list.reveal(this.list.getFocus()[0]);
        this.view.domNode.focus();
    };
    KeyboardController.prototype.onCtrlA = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.setSelection(Object(__WEBPACK_IMPORTED_MODULE_4__common_arrays_js__["m" /* range */])(this.list.length));
        this.view.domNode.focus();
    };
    KeyboardController.prototype.onEscape = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.setSelection([]);
        this.view.domNode.focus();
    };
    KeyboardController.prototype.dispose = function () {
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    return KeyboardController;
}());
var DOMFocusController = /** @class */ (function () {
    function DOMFocusController(list, view) {
        this.list = list;
        this.view = view;
        this.disposables = [];
        this.disposables = [];
        var onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["g" /* chain */])(Object(__WEBPACK_IMPORTED_MODULE_11__event_js__["a" /* domEvent */])(view.domNode, 'keydown'))
            .filter(function (e) { return !isInputElement(e.target); })
            .map(function (e) { return new __WEBPACK_IMPORTED_MODULE_9__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e); });
        onKeyDown.filter(function (e) { return e.keyCode === 2 /* Tab */ && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey; })
            .on(this.onTab, this, this.disposables);
    }
    DOMFocusController.prototype.onTab = function (e) {
        if (e.target !== this.view.domNode) {
            return;
        }
        var focus = this.list.getFocus();
        if (focus.length === 0) {
            return;
        }
        var focusedDomElement = this.view.domElement(focus[0]);
        var tabIndexElement = focusedDomElement.querySelector('[tabIndex]');
        if (!tabIndexElement || !(tabIndexElement instanceof HTMLElement)) {
            return;
        }
        var style = window.getComputedStyle(tabIndexElement);
        if (style.visibility === 'hidden' || style.display === 'none') {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        tabIndexElement.focus();
    };
    DOMFocusController.prototype.dispose = function () {
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    return DOMFocusController;
}());
function isSelectionSingleChangeEvent(event) {
    return __WEBPACK_IMPORTED_MODULE_7__common_platform_js__["d" /* isMacintosh */] ? event.browserEvent.metaKey : event.browserEvent.ctrlKey;
}
function isSelectionRangeChangeEvent(event) {
    return event.browserEvent.shiftKey;
}
function isMouseRightClick(event) {
    return event instanceof MouseEvent && event.button === 2;
}
var DefaultMultipleSelectionContoller = {
    isSelectionSingleChangeEvent: isSelectionSingleChangeEvent,
    isSelectionRangeChangeEvent: isSelectionRangeChangeEvent
};
var DefaultOpenController = {
    shouldOpen: function (event) {
        if (event instanceof MouseEvent) {
            return !isMouseRightClick(event);
        }
        return true;
    }
};
var MouseController = /** @class */ (function () {
    function MouseController(list, view, options) {
        if (options === void 0) { options = {}; }
        this.list = list;
        this.view = view;
        this.options = options;
        this.didJustPressContextMenuKey = false;
        this.disposables = [];
        this.multipleSelectionSupport = !(options.multipleSelectionSupport === false);
        if (this.multipleSelectionSupport) {
            this.multipleSelectionController = options.multipleSelectionController || DefaultMultipleSelectionContoller;
        }
        this.openController = options.openController || DefaultOpenController;
        view.onMouseDown(this.onMouseDown, this, this.disposables);
        view.onMouseClick(this.onPointer, this, this.disposables);
        view.onMouseDblClick(this.onDoubleClick, this, this.disposables);
        view.onTouchStart(this.onMouseDown, this, this.disposables);
        view.onTap(this.onPointer, this, this.disposables);
        __WEBPACK_IMPORTED_MODULE_8__touch_js__["b" /* Gesture */].addTarget(view.domNode);
    }
    Object.defineProperty(MouseController.prototype, "onContextMenu", {
        get: function () {
            var _this = this;
            var fromKeydown = Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["g" /* chain */])(Object(__WEBPACK_IMPORTED_MODULE_11__event_js__["a" /* domEvent */])(this.view.domNode, 'keydown'))
                .map(function (e) { return new __WEBPACK_IMPORTED_MODULE_9__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e); })
                .filter(function (e) { return _this.didJustPressContextMenuKey = e.keyCode === 58 /* ContextMenu */ || (e.shiftKey && e.keyCode === 68 /* F10 */); })
                .filter(function (e) { e.preventDefault(); e.stopPropagation(); return false; })
                .event;
            var fromKeyup = Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["g" /* chain */])(Object(__WEBPACK_IMPORTED_MODULE_11__event_js__["a" /* domEvent */])(this.view.domNode, 'keyup'))
                .filter(function () {
                var didJustPressContextMenuKey = _this.didJustPressContextMenuKey;
                _this.didJustPressContextMenuKey = false;
                return didJustPressContextMenuKey;
            })
                .filter(function () { return _this.list.getFocus().length > 0; })
                .map(function () {
                var index = _this.list.getFocus()[0];
                var element = _this.view.element(index);
                var anchor = _this.view.domElement(index);
                return { index: index, element: element, anchor: anchor };
            })
                .filter(function (_a) {
                var anchor = _a.anchor;
                return !!anchor;
            })
                .event;
            var fromMouse = Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["g" /* chain */])(this.view.onContextMenu)
                .filter(function () { return !_this.didJustPressContextMenuKey; })
                .map(function (_a) {
                var element = _a.element, index = _a.index, browserEvent = _a.browserEvent;
                return ({ element: element, index: index, anchor: { x: browserEvent.clientX + 1, y: browserEvent.clientY } });
            })
                .event;
            return Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["f" /* anyEvent */])(fromKeydown, fromKeyup, fromMouse);
        },
        enumerable: true,
        configurable: true
    });
    MouseController.prototype.isSelectionSingleChangeEvent = function (event) {
        if (this.multipleSelectionController) {
            return this.multipleSelectionController.isSelectionSingleChangeEvent(event);
        }
        return __WEBPACK_IMPORTED_MODULE_7__common_platform_js__["d" /* isMacintosh */] ? event.browserEvent.metaKey : event.browserEvent.ctrlKey;
    };
    MouseController.prototype.isSelectionRangeChangeEvent = function (event) {
        if (this.multipleSelectionController) {
            return this.multipleSelectionController.isSelectionRangeChangeEvent(event);
        }
        return event.browserEvent.shiftKey;
    };
    MouseController.prototype.isSelectionChangeEvent = function (event) {
        return this.isSelectionSingleChangeEvent(event) || this.isSelectionRangeChangeEvent(event);
    };
    MouseController.prototype.onMouseDown = function (e) {
        if (this.options.focusOnMouseDown === false) {
            e.browserEvent.preventDefault();
            e.browserEvent.stopPropagation();
        }
        else if (document.activeElement !== e.browserEvent.target) {
            this.view.domNode.focus();
        }
        var reference = this.list.getFocus()[0];
        var selection = this.list.getSelection();
        reference = reference === undefined ? selection[0] : reference;
        if (this.multipleSelectionSupport && this.isSelectionRangeChangeEvent(e)) {
            return this.changeSelection(e, reference);
        }
        var focus = e.index;
        if (selection.every(function (s) { return s !== focus; })) {
            this.list.setFocus([focus]);
        }
        if (this.multipleSelectionSupport && this.isSelectionChangeEvent(e)) {
            return this.changeSelection(e, reference);
        }
        if (this.options.selectOnMouseDown && !isMouseRightClick(e.browserEvent)) {
            this.list.setSelection([focus]);
            if (this.openController.shouldOpen(e.browserEvent)) {
                this.list.open([focus], e.browserEvent);
            }
        }
    };
    MouseController.prototype.onPointer = function (e) {
        if (this.multipleSelectionSupport && this.isSelectionChangeEvent(e)) {
            return;
        }
        if (!this.options.selectOnMouseDown) {
            var focus_1 = this.list.getFocus();
            this.list.setSelection(focus_1);
            if (this.openController.shouldOpen(e.browserEvent)) {
                this.list.open(focus_1, e.browserEvent);
            }
        }
    };
    MouseController.prototype.onDoubleClick = function (e) {
        if (this.multipleSelectionSupport && this.isSelectionChangeEvent(e)) {
            return;
        }
        var focus = this.list.getFocus();
        this.list.setSelection(focus);
        this.list.pin(focus);
    };
    MouseController.prototype.changeSelection = function (e, reference) {
        var focus = e.index;
        if (this.isSelectionRangeChangeEvent(e) && reference !== undefined) {
            var min = Math.min(reference, focus);
            var max = Math.max(reference, focus);
            var rangeSelection = Object(__WEBPACK_IMPORTED_MODULE_4__common_arrays_js__["m" /* range */])(min, max + 1);
            var selection = this.list.getSelection();
            var contiguousRange = getContiguousRangeContaining(disjunction(selection, [reference]), reference);
            if (contiguousRange.length === 0) {
                return;
            }
            var newSelection = disjunction(rangeSelection, relativeComplement(selection, contiguousRange));
            this.list.setSelection(newSelection);
        }
        else if (this.isSelectionSingleChangeEvent(e)) {
            var selection = this.list.getSelection();
            var newSelection = selection.filter(function (i) { return i !== focus; });
            if (selection.length === newSelection.length) {
                this.list.setSelection(newSelection.concat([focus]));
            }
            else {
                this.list.setSelection(newSelection);
            }
        }
    };
    MouseController.prototype.dispose = function () {
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5__common_decorators_js__["a" /* memoize */]
    ], MouseController.prototype, "onContextMenu", null);
    return MouseController;
}());
var DefaultStyleController = /** @class */ (function () {
    function DefaultStyleController(styleElement, selectorSuffix) {
        this.styleElement = styleElement;
        this.selectorSuffix = selectorSuffix;
    }
    DefaultStyleController.prototype.style = function (styles) {
        var suffix = this.selectorSuffix ? "." + this.selectorSuffix : '';
        var content = [];
        if (styles.listFocusBackground) {
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.focused { background-color: " + styles.listFocusBackground + "; }");
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.focused:hover { background-color: " + styles.listFocusBackground + "; }"); // overwrite :hover style in this case!
        }
        if (styles.listFocusForeground) {
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.focused { color: " + styles.listFocusForeground + "; }");
        }
        if (styles.listActiveSelectionBackground) {
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.selected { background-color: " + styles.listActiveSelectionBackground + "; }");
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.selected:hover { background-color: " + styles.listActiveSelectionBackground + "; }"); // overwrite :hover style in this case!
        }
        if (styles.listActiveSelectionForeground) {
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.selected { color: " + styles.listActiveSelectionForeground + "; }");
        }
        if (styles.listFocusAndSelectionBackground) {
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.selected.focused { background-color: " + styles.listFocusAndSelectionBackground + "; }");
        }
        if (styles.listFocusAndSelectionForeground) {
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.selected.focused { color: " + styles.listFocusAndSelectionForeground + "; }");
        }
        if (styles.listInactiveFocusBackground) {
            content.push(".monaco-list" + suffix + " .monaco-list-row.focused { background-color:  " + styles.listInactiveFocusBackground + "; }");
            content.push(".monaco-list" + suffix + " .monaco-list-row.focused:hover { background-color:  " + styles.listInactiveFocusBackground + "; }"); // overwrite :hover style in this case!
        }
        if (styles.listInactiveSelectionBackground) {
            content.push(".monaco-list" + suffix + " .monaco-list-row.selected { background-color:  " + styles.listInactiveSelectionBackground + "; }");
            content.push(".monaco-list" + suffix + " .monaco-list-row.selected:hover { background-color:  " + styles.listInactiveSelectionBackground + "; }"); // overwrite :hover style in this case!
        }
        if (styles.listInactiveSelectionForeground) {
            content.push(".monaco-list" + suffix + " .monaco-list-row.selected { color: " + styles.listInactiveSelectionForeground + "; }");
        }
        if (styles.listHoverBackground) {
            content.push(".monaco-list" + suffix + " .monaco-list-row:hover { background-color:  " + styles.listHoverBackground + "; }");
        }
        if (styles.listHoverForeground) {
            content.push(".monaco-list" + suffix + " .monaco-list-row:hover { color:  " + styles.listHoverForeground + "; }");
        }
        if (styles.listSelectionOutline) {
            content.push(".monaco-list" + suffix + " .monaco-list-row.selected { outline: 1px dotted " + styles.listSelectionOutline + "; outline-offset: -1px; }");
        }
        if (styles.listFocusOutline) {
            content.push(".monaco-list" + suffix + ":focus .monaco-list-row.focused { outline: 1px solid " + styles.listFocusOutline + "; outline-offset: -1px; }");
        }
        if (styles.listInactiveFocusOutline) {
            content.push(".monaco-list" + suffix + " .monaco-list-row.focused { outline: 1px dotted " + styles.listInactiveFocusOutline + "; outline-offset: -1px; }");
        }
        if (styles.listHoverOutline) {
            content.push(".monaco-list" + suffix + " .monaco-list-row:hover { outline: 1px dashed " + styles.listHoverOutline + "; outline-offset: -1px; }");
        }
        var newStyles = content.join('\n');
        if (newStyles !== this.styleElement.innerHTML) {
            this.styleElement.innerHTML = newStyles;
        }
    };
    return DefaultStyleController;
}());

var defaultStyles = {
    listFocusBackground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#073655'),
    listActiveSelectionBackground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#0E639C'),
    listActiveSelectionForeground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#FFFFFF'),
    listFocusAndSelectionBackground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#094771'),
    listFocusAndSelectionForeground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#FFFFFF'),
    listInactiveSelectionBackground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#3F3F46'),
    listHoverBackground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#2A2D2E'),
    listDropBackground: __WEBPACK_IMPORTED_MODULE_13__common_color_js__["a" /* Color */].fromHex('#383B3D')
};
var DefaultOptions = {
    keyboardSupport: true,
    mouseSupport: true,
    multipleSelectionSupport: true
};
// TODO@Joao: move these utils into a SortedArray class
function getContiguousRangeContaining(range, value) {
    var index = range.indexOf(value);
    if (index === -1) {
        return [];
    }
    var result = [];
    var i = index - 1;
    while (i >= 0 && range[i] === value - (index - i)) {
        result.push(range[i--]);
    }
    result.reverse();
    i = index;
    while (i < range.length && range[i] === value + (i - index)) {
        result.push(range[i++]);
    }
    return result;
}
/**
 * Given two sorted collections of numbers, returns the intersection
 * betweem them (OR).
 */
function disjunction(one, other) {
    var result = [];
    var i = 0, j = 0;
    while (i < one.length || j < other.length) {
        if (i >= one.length) {
            result.push(other[j++]);
        }
        else if (j >= other.length) {
            result.push(one[i++]);
        }
        else if (one[i] === other[j]) {
            result.push(one[i]);
            i++;
            j++;
            continue;
        }
        else if (one[i] < other[j]) {
            result.push(one[i++]);
        }
        else {
            result.push(other[j++]);
        }
    }
    return result;
}
/**
 * Given two sorted collections of numbers, returns the relative
 * complement between them (XOR).
 */
function relativeComplement(one, other) {
    var result = [];
    var i = 0, j = 0;
    while (i < one.length || j < other.length) {
        if (i >= one.length) {
            result.push(other[j++]);
        }
        else if (j >= other.length) {
            result.push(one[i++]);
        }
        else if (one[i] === other[j]) {
            i++;
            j++;
            continue;
        }
        else if (one[i] < other[j]) {
            result.push(one[i++]);
        }
        else {
            j++;
        }
    }
    return result;
}
var numericSort = function (a, b) { return a - b; };
var PipelineRenderer = /** @class */ (function () {
    function PipelineRenderer(_templateId, renderers) {
        this._templateId = _templateId;
        this.renderers = renderers;
    }
    Object.defineProperty(PipelineRenderer.prototype, "templateId", {
        get: function () {
            return this._templateId;
        },
        enumerable: true,
        configurable: true
    });
    PipelineRenderer.prototype.renderTemplate = function (container) {
        return this.renderers.map(function (r) { return r.renderTemplate(container); });
    };
    PipelineRenderer.prototype.renderElement = function (element, index, templateData) {
        var i = 0;
        for (var _i = 0, _a = this.renderers; _i < _a.length; _i++) {
            var renderer = _a[_i];
            renderer.renderElement(element, index, templateData[i++]);
        }
    };
    PipelineRenderer.prototype.disposeElement = function (element, index, templateData) {
        var i = 0;
        for (var _i = 0, _a = this.renderers; _i < _a.length; _i++) {
            var renderer = _a[_i];
            renderer.disposeElement(element, index, templateData[i++]);
        }
    };
    PipelineRenderer.prototype.disposeTemplate = function (templateData) {
        var i = 0;
        for (var _i = 0, _a = this.renderers; _i < _a.length; _i++) {
            var renderer = _a[_i];
            renderer.disposeTemplate(templateData[i++]);
        }
    };
    return PipelineRenderer;
}());
var List = /** @class */ (function () {
    function List(container, virtualDelegate, renderers, options) {
        if (options === void 0) { options = DefaultOptions; }
        var _this = this;
        this.idPrefix = "list_id_" + ++List.InstanceCount;
        this.eventBufferer = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["c" /* EventBufferer */]();
        this.onContextMenu = __WEBPACK_IMPORTED_MODULE_10__common_event_js__["b" /* Event */].None;
        this._onOpen = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this._onPin = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this._onDidDispose = new __WEBPACK_IMPORTED_MODULE_10__common_event_js__["a" /* Emitter */]();
        this.focus = new FocusTrait(function (i) { return _this.getElementDomId(i); });
        this.selection = new Trait('selected');
        Object(__WEBPACK_IMPORTED_MODULE_14__common_objects_js__["g" /* mixin */])(options, defaultStyles, false);
        renderers = renderers.map(function (r) { return new PipelineRenderer(r.templateId, [_this.focus.renderer, _this.selection.renderer, r]); });
        this.view = new __WEBPACK_IMPORTED_MODULE_12__listView_js__["a" /* ListView */](container, virtualDelegate, renderers, options);
        this.view.domNode.setAttribute('role', 'tree');
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["f" /* addClass */](this.view.domNode, this.idPrefix);
        this.view.domNode.tabIndex = 0;
        this.styleElement = __WEBPACK_IMPORTED_MODULE_6__dom_js__["o" /* createStyleSheet */](this.view.domNode);
        this.styleController = options.styleController;
        if (!this.styleController) {
            this.styleController = new DefaultStyleController(this.styleElement, this.idPrefix);
        }
        this.spliceable = new __WEBPACK_IMPORTED_MODULE_15__splice_js__["a" /* CombinedSpliceable */]([
            new TraitSpliceable(this.focus, this.view, options.identityProvider),
            new TraitSpliceable(this.selection, this.view, options.identityProvider),
            this.view
        ]);
        this.disposables = [this.focus, this.selection, this.view, this._onDidDispose];
        this.onDidFocus = Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_11__event_js__["a" /* domEvent */])(this.view.domNode, 'focus', true), function () { return null; });
        this.onDidBlur = Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_11__event_js__["a" /* domEvent */])(this.view.domNode, 'blur', true), function () { return null; });
        this.disposables.push(new DOMFocusController(this, this.view));
        if (typeof options.keyboardSupport !== 'boolean' || options.keyboardSupport) {
            var controller = new KeyboardController(this, this.view, options);
            this.disposables.push(controller);
        }
        if (typeof options.mouseSupport !== 'boolean' || options.mouseSupport) {
            this.mouseController = new MouseController(this, this.view, options);
            this.disposables.push(this.mouseController);
            this.onContextMenu = this.mouseController.onContextMenu;
        }
        this.onFocusChange(this._onFocusChange, this, this.disposables);
        this.onSelectionChange(this._onSelectionChange, this, this.disposables);
        if (options.ariaLabel) {
            this.view.domNode.setAttribute('aria-label', Object(__WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */])('aria list', "{0}. Use the navigation keys to navigate.", options.ariaLabel));
        }
        this.style(options);
    }
    Object.defineProperty(List.prototype, "onFocusChange", {
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["j" /* mapEvent */])(this.eventBufferer.wrapEvent(this.focus.onChange), function (e) { return _this.toListEvent(e); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "onSelectionChange", {
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_10__common_event_js__["j" /* mapEvent */])(this.eventBufferer.wrapEvent(this.selection.onChange), function (e) { return _this.toListEvent(e); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "onDidDispose", {
        get: function () { return this._onDidDispose.event; },
        enumerable: true,
        configurable: true
    });
    List.prototype.splice = function (start, deleteCount, elements) {
        var _this = this;
        if (elements === void 0) { elements = []; }
        if (start < 0 || start > this.view.length) {
            throw new Error("Invalid start index: " + start);
        }
        if (deleteCount < 0) {
            throw new Error("Invalid delete count: " + deleteCount);
        }
        if (deleteCount === 0 && elements.length === 0) {
            return;
        }
        this.eventBufferer.bufferEvents(function () { return _this.spliceable.splice(start, deleteCount, elements); });
    };
    Object.defineProperty(List.prototype, "length", {
        get: function () {
            return this.view.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "contentHeight", {
        get: function () {
            return this.view.getContentHeight();
        },
        enumerable: true,
        configurable: true
    });
    List.prototype.layout = function (height) {
        this.view.layout(height);
    };
    List.prototype.setSelection = function (indexes) {
        for (var _i = 0, indexes_1 = indexes; _i < indexes_1.length; _i++) {
            var index = indexes_1[_i];
            if (index < 0 || index >= this.length) {
                throw new Error("Invalid index " + index);
            }
        }
        indexes = indexes.sort(numericSort);
        this.selection.set(indexes);
    };
    List.prototype.getSelection = function () {
        return this.selection.get();
    };
    List.prototype.setFocus = function (indexes) {
        for (var _i = 0, indexes_2 = indexes; _i < indexes_2.length; _i++) {
            var index = indexes_2[_i];
            if (index < 0 || index >= this.length) {
                throw new Error("Invalid index " + index);
            }
        }
        indexes = indexes.sort(numericSort);
        this.focus.set(indexes);
    };
    List.prototype.focusNext = function (n, loop) {
        if (n === void 0) { n = 1; }
        if (loop === void 0) { loop = false; }
        if (this.length === 0) {
            return;
        }
        var focus = this.focus.get();
        var index = focus.length > 0 ? focus[0] + n : 0;
        this.setFocus(loop ? [index % this.length] : [Math.min(index, this.length - 1)]);
    };
    List.prototype.focusPrevious = function (n, loop) {
        if (n === void 0) { n = 1; }
        if (loop === void 0) { loop = false; }
        if (this.length === 0) {
            return;
        }
        var focus = this.focus.get();
        var index = focus.length > 0 ? focus[0] - n : 0;
        if (loop && index < 0) {
            index = (this.length + (index % this.length)) % this.length;
        }
        this.setFocus([Math.max(index, 0)]);
    };
    List.prototype.focusNextPage = function () {
        var _this = this;
        var lastPageIndex = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
        lastPageIndex = lastPageIndex === 0 ? 0 : lastPageIndex - 1;
        var lastPageElement = this.view.element(lastPageIndex);
        var currentlyFocusedElement = this.getFocusedElements()[0];
        if (currentlyFocusedElement !== lastPageElement) {
            this.setFocus([lastPageIndex]);
        }
        else {
            var previousScrollTop = this.view.getScrollTop();
            this.view.setScrollTop(previousScrollTop + this.view.renderHeight - this.view.elementHeight(lastPageIndex));
            if (this.view.getScrollTop() !== previousScrollTop) {
                // Let the scroll event listener run
                setTimeout(function () { return _this.focusNextPage(); }, 0);
            }
        }
    };
    List.prototype.focusPreviousPage = function () {
        var _this = this;
        var firstPageIndex;
        var scrollTop = this.view.getScrollTop();
        if (scrollTop === 0) {
            firstPageIndex = this.view.indexAt(scrollTop);
        }
        else {
            firstPageIndex = this.view.indexAfter(scrollTop - 1);
        }
        var firstPageElement = this.view.element(firstPageIndex);
        var currentlyFocusedElement = this.getFocusedElements()[0];
        if (currentlyFocusedElement !== firstPageElement) {
            this.setFocus([firstPageIndex]);
        }
        else {
            var previousScrollTop = scrollTop;
            this.view.setScrollTop(scrollTop - this.view.renderHeight);
            if (this.view.getScrollTop() !== previousScrollTop) {
                // Let the scroll event listener run
                setTimeout(function () { return _this.focusPreviousPage(); }, 0);
            }
        }
    };
    List.prototype.focusLast = function () {
        if (this.length === 0) {
            return;
        }
        this.setFocus([this.length - 1]);
    };
    List.prototype.focusFirst = function () {
        if (this.length === 0) {
            return;
        }
        this.setFocus([0]);
    };
    List.prototype.getFocus = function () {
        return this.focus.get();
    };
    List.prototype.getFocusedElements = function () {
        var _this = this;
        return this.getFocus().map(function (i) { return _this.view.element(i); });
    };
    List.prototype.reveal = function (index, relativeTop) {
        if (index < 0 || index >= this.length) {
            throw new Error("Invalid index " + index);
        }
        var scrollTop = this.view.getScrollTop();
        var elementTop = this.view.elementTop(index);
        var elementHeight = this.view.elementHeight(index);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__common_types_js__["f" /* isNumber */])(relativeTop)) {
            // y = mx + b
            var m = elementHeight - this.view.renderHeight;
            this.view.setScrollTop(m * Object(__WEBPACK_IMPORTED_MODULE_16__common_numbers_js__["a" /* clamp */])(relativeTop, 0, 1) + elementTop);
        }
        else {
            var viewItemBottom = elementTop + elementHeight;
            var wrapperBottom = scrollTop + this.view.renderHeight;
            if (elementTop < scrollTop) {
                this.view.setScrollTop(elementTop);
            }
            else if (viewItemBottom >= wrapperBottom) {
                this.view.setScrollTop(viewItemBottom - this.view.renderHeight);
            }
        }
    };
    List.prototype.getElementDomId = function (index) {
        return this.idPrefix + "_" + index;
    };
    List.prototype.isDOMFocused = function () {
        return this.view.domNode === document.activeElement;
    };
    List.prototype.getHTMLElement = function () {
        return this.view.domNode;
    };
    List.prototype.open = function (indexes, browserEvent) {
        var _this = this;
        for (var _i = 0, indexes_3 = indexes; _i < indexes_3.length; _i++) {
            var index = indexes_3[_i];
            if (index < 0 || index >= this.length) {
                throw new Error("Invalid index " + index);
            }
        }
        this._onOpen.fire({ indexes: indexes, elements: indexes.map(function (i) { return _this.view.element(i); }), browserEvent: browserEvent });
    };
    List.prototype.pin = function (indexes) {
        for (var _i = 0, indexes_4 = indexes; _i < indexes_4.length; _i++) {
            var index = indexes_4[_i];
            if (index < 0 || index >= this.length) {
                throw new Error("Invalid index " + index);
            }
        }
        this._onPin.fire(indexes);
    };
    List.prototype.style = function (styles) {
        this.styleController.style(styles);
    };
    List.prototype.toListEvent = function (_a) {
        var _this = this;
        var indexes = _a.indexes;
        return { indexes: indexes, elements: indexes.map(function (i) { return _this.view.element(i); }) };
    };
    List.prototype._onFocusChange = function () {
        var focus = this.focus.get();
        if (focus.length > 0) {
            this.view.domNode.setAttribute('aria-activedescendant', this.getElementDomId(focus[0]));
        }
        else {
            this.view.domNode.removeAttribute('aria-activedescendant');
        }
        this.view.domNode.setAttribute('role', 'tree');
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["N" /* toggleClass */](this.view.domNode, 'element-focused', focus.length > 0);
    };
    List.prototype._onSelectionChange = function () {
        var selection = this.selection.get();
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["N" /* toggleClass */](this.view.domNode, 'selection-none', selection.length === 0);
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["N" /* toggleClass */](this.view.domNode, 'selection-single', selection.length === 1);
        __WEBPACK_IMPORTED_MODULE_6__dom_js__["N" /* toggleClass */](this.view.domNode, 'selection-multiple', selection.length > 1);
    };
    List.prototype.dispose = function () {
        this._onDidDispose.fire();
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_2__common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    List.InstanceCount = 0;
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5__common_decorators_js__["a" /* memoize */]
    ], List.prototype, "onFocusChange", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5__common_decorators_js__["a" /* memoize */]
    ], List.prototype, "onSelectionChange", null);
    return List;
}());



/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__touch_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rangeMap_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rowCache_js__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_decorators_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mouseEvent_js__ = __webpack_require__(37);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














function canUseTranslate3d() {
    if (__WEBPACK_IMPORTED_MODULE_11__browser_js__["j" /* isFirefox */]) {
        return false;
    }
    if (__WEBPACK_IMPORTED_MODULE_11__browser_js__["d" /* getZoomLevel */]() !== 0) {
        return false;
    }
    return true;
}
var DefaultOptions = {
    useShadows: true,
    verticalScrollMode: __WEBPACK_IMPORTED_MODULE_7__common_scrollable_js__["b" /* ScrollbarVisibility */].Auto
};
var ListView = /** @class */ (function () {
    function ListView(container, virtualDelegate, renderers, options) {
        if (options === void 0) { options = DefaultOptions; }
        this.virtualDelegate = virtualDelegate;
        this.renderers = new Map();
        this.splicing = false;
        this.items = [];
        this.itemId = 0;
        this.rangeMap = new __WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["a" /* RangeMap */]();
        for (var _i = 0, renderers_1 = renderers; _i < renderers_1.length; _i++) {
            var renderer = renderers_1[_i];
            this.renderers.set(renderer.templateId, renderer);
        }
        this.cache = new __WEBPACK_IMPORTED_MODULE_9__rowCache_js__["a" /* RowCache */](this.renderers);
        this.lastRenderTop = 0;
        this.lastRenderHeight = 0;
        this._domNode = document.createElement('div');
        this._domNode.className = 'monaco-list';
        this.rowsContainer = document.createElement('div');
        this.rowsContainer.className = 'monaco-list-rows';
        __WEBPACK_IMPORTED_MODULE_2__touch_js__["b" /* Gesture */].addTarget(this.rowsContainer);
        this.scrollableElement = new __WEBPACK_IMPORTED_MODULE_6__scrollbar_scrollableElement_js__["b" /* ScrollableElement */](this.rowsContainer, {
            alwaysConsumeMouseWheel: true,
            horizontal: __WEBPACK_IMPORTED_MODULE_7__common_scrollable_js__["b" /* ScrollbarVisibility */].Hidden,
            vertical: Object(__WEBPACK_IMPORTED_MODULE_0__common_objects_js__["f" /* getOrDefault */])(options, function (o) { return o.verticalScrollMode; }, DefaultOptions.verticalScrollMode),
            useShadows: Object(__WEBPACK_IMPORTED_MODULE_0__common_objects_js__["f" /* getOrDefault */])(options, function (o) { return o.useShadows; }, DefaultOptions.useShadows)
        });
        this._domNode.appendChild(this.scrollableElement.getDomNode());
        container.appendChild(this._domNode);
        this.disposables = [this.rangeMap, this.gesture, this.scrollableElement, this.cache];
        this.scrollableElement.onScroll(this.onScroll, this, this.disposables);
        Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.rowsContainer, __WEBPACK_IMPORTED_MODULE_2__touch_js__["a" /* EventType */].Change)(this.onTouchChange, this, this.disposables);
        // Prevent the monaco-scrollable-element from scrolling
        // https://github.com/Microsoft/vscode/issues/44181
        Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.scrollableElement.getDomNode(), 'scroll')(function (e) { return e.target.scrollTop = 0; }, null, this.disposables);
        var onDragOver = Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.rowsContainer, 'dragover'), function (e) { return new __WEBPACK_IMPORTED_MODULE_13__mouseEvent_js__["a" /* DragMouseEvent */](e); });
        onDragOver(this.onDragOver, this, this.disposables);
        this.layout();
    }
    Object.defineProperty(ListView.prototype, "domNode", {
        get: function () {
            return this._domNode;
        },
        enumerable: true,
        configurable: true
    });
    ListView.prototype.splice = function (start, deleteCount, elements) {
        if (elements === void 0) { elements = []; }
        if (this.splicing) {
            throw new Error('Can\'t run recursive splices.');
        }
        this.splicing = true;
        try {
            return this._splice(start, deleteCount, elements);
        }
        finally {
            this.splicing = false;
        }
    };
    ListView.prototype._splice = function (start, deleteCount, elements) {
        var _this = this;
        if (elements === void 0) { elements = []; }
        var _a, _b;
        var previousRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
        var deleteRange = { start: start, end: start + deleteCount };
        var removeRange = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["b" /* intersect */])(previousRenderRange, deleteRange);
        for (var i = removeRange.start; i < removeRange.end; i++) {
            this.removeItemFromDOM(i);
        }
        var previousRestRange = { start: start + deleteCount, end: this.items.length };
        var previousRenderedRestRange = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["b" /* intersect */])(previousRestRange, previousRenderRange);
        var previousUnrenderedRestRanges = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["c" /* relativeComplement */])(previousRestRange, previousRenderRange);
        var inserted = elements.map(function (element) { return ({
            id: String(_this.itemId++),
            element: element,
            size: _this.virtualDelegate.getHeight(element),
            templateId: _this.virtualDelegate.getTemplateId(element),
            row: null
        }); });
        (_a = this.rangeMap).splice.apply(_a, [start, deleteCount].concat(inserted));
        var deleted = (_b = this.items).splice.apply(_b, [start, deleteCount].concat(inserted));
        var delta = elements.length - deleteCount;
        var renderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
        var renderedRestRange = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["d" /* shift */])(previousRenderedRestRange, delta);
        var updateRange = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["b" /* intersect */])(renderRange, renderedRestRange);
        for (var i = updateRange.start; i < updateRange.end; i++) {
            this.updateItemInDOM(this.items[i], i);
        }
        var removeRanges = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["c" /* relativeComplement */])(renderedRestRange, renderRange);
        for (var r = 0; r < removeRanges.length; r++) {
            var removeRange_1 = removeRanges[r];
            for (var i = removeRange_1.start; i < removeRange_1.end; i++) {
                this.removeItemFromDOM(i);
            }
        }
        var unrenderedRestRanges = previousUnrenderedRestRanges.map(function (r) { return Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["d" /* shift */])(r, delta); });
        var elementsRange = { start: start, end: start + elements.length };
        var insertRanges = [elementsRange].concat(unrenderedRestRanges).map(function (r) { return Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["b" /* intersect */])(renderRange, r); });
        var beforeElement = this.getNextToLastElement(insertRanges);
        for (var r = 0; r < insertRanges.length; r++) {
            var insertRange = insertRanges[r];
            for (var i = insertRange.start; i < insertRange.end; i++) {
                this.insertItemInDOM(i, beforeElement);
            }
        }
        var scrollHeight = this.getContentHeight();
        this.rowsContainer.style.height = scrollHeight + "px";
        this.scrollableElement.setScrollDimensions({ scrollHeight: scrollHeight });
        return deleted.map(function (i) { return i.element; });
    };
    Object.defineProperty(ListView.prototype, "length", {
        get: function () {
            return this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListView.prototype, "renderHeight", {
        get: function () {
            var scrollDimensions = this.scrollableElement.getScrollDimensions();
            return scrollDimensions.height;
        },
        enumerable: true,
        configurable: true
    });
    ListView.prototype.element = function (index) {
        return this.items[index].element;
    };
    ListView.prototype.domElement = function (index) {
        var row = this.items[index].row;
        return row && row.domNode;
    };
    ListView.prototype.elementHeight = function (index) {
        return this.items[index].size;
    };
    ListView.prototype.elementTop = function (index) {
        return this.rangeMap.positionAt(index);
    };
    ListView.prototype.indexAt = function (position) {
        return this.rangeMap.indexAt(position);
    };
    ListView.prototype.indexAfter = function (position) {
        return this.rangeMap.indexAfter(position);
    };
    ListView.prototype.layout = function (height) {
        this.scrollableElement.setScrollDimensions({
            height: height || __WEBPACK_IMPORTED_MODULE_3__dom_js__["s" /* getContentHeight */](this._domNode)
        });
    };
    // Render
    ListView.prototype.render = function (renderTop, renderHeight) {
        var previousRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
        var renderRange = this.getRenderRange(renderTop, renderHeight);
        var rangesToInsert = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["c" /* relativeComplement */])(renderRange, previousRenderRange);
        var rangesToRemove = Object(__WEBPACK_IMPORTED_MODULE_8__rangeMap_js__["c" /* relativeComplement */])(previousRenderRange, renderRange);
        var beforeElement = this.getNextToLastElement(rangesToInsert);
        for (var _i = 0, rangesToInsert_1 = rangesToInsert; _i < rangesToInsert_1.length; _i++) {
            var range = rangesToInsert_1[_i];
            for (var i = range.start; i < range.end; i++) {
                this.insertItemInDOM(i, beforeElement);
            }
        }
        for (var _a = 0, rangesToRemove_1 = rangesToRemove; _a < rangesToRemove_1.length; _a++) {
            var range = rangesToRemove_1[_a];
            for (var i = range.start; i < range.end; i++) {
                this.removeItemFromDOM(i);
            }
        }
        if (canUseTranslate3d() && !__WEBPACK_IMPORTED_MODULE_10__common_platform_js__["g" /* isWindows */] /* Windows: translate3d breaks subpixel-antialias (ClearType) unless a background is defined */) {
            var transform = "translate3d(0px, -" + renderTop + "px, 0px)";
            this.rowsContainer.style.transform = transform;
            this.rowsContainer.style.webkitTransform = transform;
        }
        else {
            this.rowsContainer.style.top = "-" + renderTop + "px";
        }
        this.lastRenderTop = renderTop;
        this.lastRenderHeight = renderHeight;
    };
    // DOM operations
    ListView.prototype.insertItemInDOM = function (index, beforeElement) {
        var item = this.items[index];
        if (!item.row) {
            item.row = this.cache.alloc(item.templateId);
        }
        if (!item.row.domNode.parentElement) {
            if (beforeElement) {
                this.rowsContainer.insertBefore(item.row.domNode, beforeElement);
            }
            else {
                this.rowsContainer.appendChild(item.row.domNode);
            }
        }
        item.row.domNode.style.height = item.size + "px";
        this.updateItemInDOM(item, index);
        var renderer = this.renderers.get(item.templateId);
        renderer.renderElement(item.element, index, item.row.templateData);
    };
    ListView.prototype.updateItemInDOM = function (item, index) {
        item.row.domNode.style.top = this.elementTop(index) + "px";
        item.row.domNode.setAttribute('data-index', "" + index);
        item.row.domNode.setAttribute('data-last-element', index === this.length - 1 ? 'true' : 'false');
        item.row.domNode.setAttribute('aria-setsize', "" + this.length);
        item.row.domNode.setAttribute('aria-posinset', "" + (index + 1));
    };
    ListView.prototype.removeItemFromDOM = function (index) {
        var item = this.items[index];
        var renderer = this.renderers.get(item.templateId);
        if (renderer.disposeElement) {
            renderer.disposeElement(item.element, index, item.row.templateData);
        }
        this.cache.release(item.row);
        item.row = null;
    };
    ListView.prototype.getContentHeight = function () {
        return this.rangeMap.size;
    };
    ListView.prototype.getScrollTop = function () {
        var scrollPosition = this.scrollableElement.getScrollPosition();
        return scrollPosition.scrollTop;
    };
    ListView.prototype.setScrollTop = function (scrollTop) {
        this.scrollableElement.setScrollPosition({ scrollTop: scrollTop });
    };
    Object.defineProperty(ListView.prototype, "scrollTop", {
        get: function () {
            return this.getScrollTop();
        },
        set: function (scrollTop) {
            this.setScrollTop(scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListView.prototype, "onMouseClick", {
        // Events
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["i" /* filterEvent */])(Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.domNode, 'click'), function (e) { return _this.toMouseEvent(e); }), function (e) { return e.index >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListView.prototype, "onMouseDblClick", {
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["i" /* filterEvent */])(Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.domNode, 'dblclick'), function (e) { return _this.toMouseEvent(e); }), function (e) { return e.index >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListView.prototype, "onMouseDown", {
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["i" /* filterEvent */])(Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.domNode, 'mousedown'), function (e) { return _this.toMouseEvent(e); }), function (e) { return e.index >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListView.prototype, "onContextMenu", {
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["i" /* filterEvent */])(Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.domNode, 'contextmenu'), function (e) { return _this.toMouseEvent(e); }), function (e) { return e.index >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListView.prototype, "onTouchStart", {
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["i" /* filterEvent */])(Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.domNode, 'touchstart'), function (e) { return _this.toTouchEvent(e); }), function (e) { return e.index >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListView.prototype, "onTap", {
        get: function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["i" /* filterEvent */])(Object(__WEBPACK_IMPORTED_MODULE_4__common_event_js__["j" /* mapEvent */])(Object(__WEBPACK_IMPORTED_MODULE_5__event_js__["a" /* domEvent */])(this.rowsContainer, __WEBPACK_IMPORTED_MODULE_2__touch_js__["a" /* EventType */].Tap), function (e) { return _this.toGestureEvent(e); }), function (e) { return e.index >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    ListView.prototype.toMouseEvent = function (browserEvent) {
        var index = this.getItemIndexFromEventTarget(browserEvent.target);
        var item = index < 0 ? undefined : this.items[index];
        var element = item && item.element;
        return { browserEvent: browserEvent, index: index, element: element };
    };
    ListView.prototype.toTouchEvent = function (browserEvent) {
        var index = this.getItemIndexFromEventTarget(browserEvent.target);
        var item = index < 0 ? undefined : this.items[index];
        var element = item && item.element;
        return { browserEvent: browserEvent, index: index, element: element };
    };
    ListView.prototype.toGestureEvent = function (browserEvent) {
        var index = this.getItemIndexFromEventTarget(browserEvent.initialTarget);
        var item = index < 0 ? undefined : this.items[index];
        var element = item && item.element;
        return { browserEvent: browserEvent, index: index, element: element };
    };
    ListView.prototype.onScroll = function (e) {
        try {
            this.render(e.scrollTop, e.height);
        }
        catch (err) {
            console.log('Got bad scroll event:', e);
            throw err;
        }
    };
    ListView.prototype.onTouchChange = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.scrollTop -= event.translationY;
    };
    ListView.prototype.onDragOver = function (event) {
        this.setupDragAndDropScrollInterval();
        this.dragAndDropMouseY = event.posy;
    };
    ListView.prototype.setupDragAndDropScrollInterval = function () {
        var _this = this;
        var viewTop = __WEBPACK_IMPORTED_MODULE_3__dom_js__["w" /* getTopLeftOffset */](this._domNode).top;
        if (!this.dragAndDropScrollInterval) {
            this.dragAndDropScrollInterval = window.setInterval(function () {
                if (_this.dragAndDropMouseY === undefined) {
                    return;
                }
                var diff = _this.dragAndDropMouseY - viewTop;
                var scrollDiff = 0;
                var upperLimit = _this.renderHeight - 35;
                if (diff < 35) {
                    scrollDiff = Math.max(-14, 0.2 * (diff - 35));
                }
                else if (diff > upperLimit) {
                    scrollDiff = Math.min(14, 0.2 * (diff - upperLimit));
                }
                _this.scrollTop += scrollDiff;
            }, 10);
            this.cancelDragAndDropScrollTimeout();
            this.dragAndDropScrollTimeout = window.setTimeout(function () {
                _this.cancelDragAndDropScrollInterval();
                _this.dragAndDropScrollTimeout = null;
            }, 1000);
        }
    };
    ListView.prototype.cancelDragAndDropScrollInterval = function () {
        if (this.dragAndDropScrollInterval) {
            window.clearInterval(this.dragAndDropScrollInterval);
            this.dragAndDropScrollInterval = null;
        }
        this.cancelDragAndDropScrollTimeout();
    };
    ListView.prototype.cancelDragAndDropScrollTimeout = function () {
        if (this.dragAndDropScrollTimeout) {
            window.clearTimeout(this.dragAndDropScrollTimeout);
            this.dragAndDropScrollTimeout = null;
        }
    };
    // Util
    ListView.prototype.getItemIndexFromEventTarget = function (target) {
        while (target instanceof HTMLElement && target !== this.rowsContainer) {
            var element = target;
            var rawIndex = element.getAttribute('data-index');
            if (rawIndex) {
                var index = Number(rawIndex);
                if (!isNaN(index)) {
                    return index;
                }
            }
            target = element.parentElement;
        }
        return -1;
    };
    ListView.prototype.getRenderRange = function (renderTop, renderHeight) {
        return {
            start: this.rangeMap.indexAt(renderTop),
            end: this.rangeMap.indexAfter(renderTop + renderHeight - 1)
        };
    };
    ListView.prototype.getNextToLastElement = function (ranges) {
        var lastRange = ranges[ranges.length - 1];
        if (!lastRange) {
            return null;
        }
        var nextToLastItem = this.items[lastRange.end];
        if (!nextToLastItem) {
            return null;
        }
        if (!nextToLastItem.row) {
            return null;
        }
        return nextToLastItem.row.domNode;
    };
    // Dispose
    ListView.prototype.dispose = function () {
        if (this.items) {
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.row) {
                    var renderer = this.renderers.get(item.row.templateId);
                    renderer.disposeTemplate(item.row.templateData);
                    item.row = null;
                }
            }
            this.items = null;
        }
        if (this._domNode && this._domNode.parentElement) {
            this._domNode.parentNode.removeChild(this._domNode);
            this._domNode = null;
        }
        this.disposables = Object(__WEBPACK_IMPORTED_MODULE_1__common_lifecycle_js__["d" /* dispose */])(this.disposables);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_12__common_decorators_js__["a" /* memoize */]
    ], ListView.prototype, "onMouseClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_12__common_decorators_js__["a" /* memoize */]
    ], ListView.prototype, "onMouseDblClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_12__common_decorators_js__["a" /* memoize */]
    ], ListView.prototype, "onMouseDown", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_12__common_decorators_js__["a" /* memoize */]
    ], ListView.prototype, "onContextMenu", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_12__common_decorators_js__["a" /* memoize */]
    ], ListView.prototype, "onTouchStart", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_12__common_decorators_js__["a" /* memoize */]
    ], ListView.prototype, "onTap", null);
    return ListView;
}());



/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = intersect;
/* unused harmony export isEmpty */
/* harmony export (immutable) */ __webpack_exports__["c"] = relativeComplement;
/* unused harmony export groupIntersect */
/* harmony export (immutable) */ __webpack_exports__["d"] = shift;
/* unused harmony export consolidate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RangeMap; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/**
 * Returns the intersection between two ranges as a range itself.
 * Returns `{ start: 0, end: 0 }` if the intersection is empty.
 */
function intersect(one, other) {
    if (one.start >= other.end || other.start >= one.end) {
        return { start: 0, end: 0 };
    }
    var start = Math.max(one.start, other.start);
    var end = Math.min(one.end, other.end);
    if (end - start <= 0) {
        return { start: 0, end: 0 };
    }
    return { start: start, end: end };
}
function isEmpty(range) {
    return range.end - range.start <= 0;
}
function relativeComplement(one, other) {
    var result = [];
    var first = { start: one.start, end: Math.min(other.start, one.end) };
    var second = { start: Math.max(other.end, one.start), end: one.end };
    if (!isEmpty(first)) {
        result.push(first);
    }
    if (!isEmpty(second)) {
        result.push(second);
    }
    return result;
}
/**
 * Returns the intersection between a ranged group and a range.
 * Returns `[]` if the intersection is empty.
 */
function groupIntersect(range, groups) {
    var result = [];
    for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
        var r = groups_1[_i];
        if (range.start >= r.range.end) {
            continue;
        }
        if (range.end < r.range.start) {
            break;
        }
        var intersection = intersect(range, r.range);
        if (isEmpty(intersection)) {
            continue;
        }
        result.push({
            range: intersection,
            size: r.size
        });
    }
    return result;
}
/**
 * Shifts a range by that `much`.
 */
function shift(_a, much) {
    var start = _a.start, end = _a.end;
    return { start: start + much, end: end + much };
}
/**
 * Consolidates a collection of ranged groups.
 *
 * Consolidation is the process of merging consecutive ranged groups
 * that share the same `size`.
 */
function consolidate(groups) {
    var result = [];
    var previousGroup = null;
    for (var _i = 0, groups_2 = groups; _i < groups_2.length; _i++) {
        var group = groups_2[_i];
        var start = group.range.start;
        var end = group.range.end;
        var size = group.size;
        if (previousGroup && size === previousGroup.size) {
            previousGroup.range.end = end;
            continue;
        }
        previousGroup = { range: { start: start, end: end }, size: size };
        result.push(previousGroup);
    }
    return result;
}
/**
 * Concatenates several collections of ranged groups into a single
 * collection.
 */
function concat() {
    var groups = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        groups[_i] = arguments[_i];
    }
    return consolidate(groups.reduce(function (r, g) { return r.concat(g); }, []));
}
var RangeMap = /** @class */ (function () {
    function RangeMap() {
        this.groups = [];
        this._size = 0;
    }
    RangeMap.prototype.splice = function (index, deleteCount) {
        var items = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            items[_i - 2] = arguments[_i];
        }
        var diff = items.length - deleteCount;
        var before = groupIntersect({ start: 0, end: index }, this.groups);
        var after = groupIntersect({ start: index + deleteCount, end: Number.POSITIVE_INFINITY }, this.groups)
            .map(function (g) { return ({ range: shift(g.range, diff), size: g.size }); });
        var middle = items.map(function (item, i) { return ({
            range: { start: index + i, end: index + i + 1 },
            size: item.size
        }); });
        this.groups = concat(before, middle, after);
        this._size = this.groups.reduce(function (t, g) { return t + (g.size * (g.range.end - g.range.start)); }, 0);
    };
    Object.defineProperty(RangeMap.prototype, "count", {
        /**
         * Returns the number of items in the range map.
         */
        get: function () {
            var len = this.groups.length;
            if (!len) {
                return 0;
            }
            return this.groups[len - 1].range.end;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RangeMap.prototype, "size", {
        /**
         * Returns the sum of the sizes of all items in the range map.
         */
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the index of the item at the given position.
     */
    RangeMap.prototype.indexAt = function (position) {
        if (position < 0) {
            return -1;
        }
        var index = 0;
        var size = 0;
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            var count = group.range.end - group.range.start;
            var newSize = size + (count * group.size);
            if (position < newSize) {
                return index + Math.floor((position - size) / group.size);
            }
            index += count;
            size = newSize;
        }
        return index;
    };
    /**
     * Returns the index of the item right after the item at the
     * index of the given position.
     */
    RangeMap.prototype.indexAfter = function (position) {
        return Math.min(this.indexAt(position) + 1, this.count);
    };
    /**
     * Returns the start position of the item at the given index.
     */
    RangeMap.prototype.positionAt = function (index) {
        if (index < 0) {
            return -1;
        }
        var position = 0;
        var count = 0;
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            var groupCount = group.range.end - group.range.start;
            var newCount = count + groupCount;
            if (index < newCount) {
                return position + ((index - count) * group.size);
            }
            position += groupCount * group.size;
            count = newCount;
        }
        return -1;
    };
    RangeMap.prototype.dispose = function () {
        this.groups = null;
    };
    return RangeMap;
}());



/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RowCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_js__ = __webpack_require__(4);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function removeFromParent(element) {
    try {
        element.parentElement.removeChild(element);
    }
    catch (e) {
        // this will throw if this happens due to a blur event, nasty business
    }
}
var RowCache = /** @class */ (function () {
    function RowCache(renderers) {
        this.renderers = renderers;
        this.cache = new Map();
    }
    /**
     * Returns a row either by creating a new one or reusing
     * a previously released row which shares the same templateId.
     */
    RowCache.prototype.alloc = function (templateId) {
        var result = this.getTemplateCache(templateId).pop();
        if (!result) {
            var domNode = Object(__WEBPACK_IMPORTED_MODULE_0__dom_js__["a" /* $ */])('.monaco-list-row');
            var renderer = this.renderers.get(templateId);
            var templateData = renderer.renderTemplate(domNode);
            result = { domNode: domNode, templateId: templateId, templateData: templateData };
        }
        return result;
    };
    /**
     * Releases the row for eventual reuse.
     */
    RowCache.prototype.release = function (row) {
        if (!row) {
            return;
        }
        this.releaseRow(row);
    };
    RowCache.prototype.releaseRow = function (row) {
        var domNode = row.domNode, templateId = row.templateId;
        Object(__WEBPACK_IMPORTED_MODULE_0__dom_js__["G" /* removeClass */])(domNode, 'scrolling');
        removeFromParent(domNode);
        var cache = this.getTemplateCache(templateId);
        cache.push(row);
    };
    RowCache.prototype.getTemplateCache = function (templateId) {
        var result = this.cache.get(templateId);
        if (!result) {
            result = [];
            this.cache.set(templateId, result);
        }
        return result;
    };
    RowCache.prototype.garbageCollect = function () {
        var _this = this;
        if (!this.renderers) {
            return;
        }
        this.cache.forEach(function (cachedRows, templateId) {
            for (var _i = 0, cachedRows_1 = cachedRows; _i < cachedRows_1.length; _i++) {
                var cachedRow = cachedRows_1[_i];
                var renderer = _this.renderers.get(templateId);
                renderer.disposeTemplate(cachedRow.templateData);
                cachedRow.domNode = null;
                cachedRow.templateData = null;
            }
        });
        this.cache.clear();
    };
    RowCache.prototype.dispose = function () {
        this.garbageCollect();
        this.cache.clear();
        this.renderers = null;
    };
    return RowCache;
}());



/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombinedSpliceable; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var CombinedSpliceable = /** @class */ (function () {
    function CombinedSpliceable(spliceables) {
        this.spliceables = spliceables;
    }
    CombinedSpliceable.prototype.splice = function (start, deleteCount, elements) {
        this.spliceables.forEach(function (s) { return s.splice(start, deleteCount, elements); });
    };
    return CombinedSpliceable;
}());



/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clamp;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Memory */
/* unused harmony export NoMemory */
/* unused harmony export LRUMemory */
/* unused harmony export PrefixMemory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestMemories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_map_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_storage_common_storage_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var Memory = /** @class */ (function () {
    function Memory() {
    }
    Memory.prototype.select = function (model, pos, items) {
        if (items.length === 0) {
            return 0;
        }
        var topScore = items[0].score;
        for (var i = 1; i < items.length; i++) {
            var _a = items[i], score = _a.score, suggestion = _a.suggestion;
            if (score !== topScore) {
                // stop when leaving the group of top matches
                break;
            }
            if (suggestion.preselect) {
                // stop when seeing an auto-select-item
                return i;
            }
        }
        return 0;
    };
    return Memory;
}());

var NoMemory = /** @class */ (function (_super) {
    __extends(NoMemory, _super);
    function NoMemory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoMemory.prototype.memorize = function (model, pos, item) {
        // no-op
    };
    NoMemory.prototype.toJSON = function () {
        return undefined;
    };
    NoMemory.prototype.fromJSON = function () {
        //
    };
    return NoMemory;
}(Memory));

var LRUMemory = /** @class */ (function (_super) {
    __extends(LRUMemory, _super);
    function LRUMemory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cache = new __WEBPACK_IMPORTED_MODULE_0__base_common_map_js__["a" /* LRUCache */](300, .66);
        _this._seq = 0;
        return _this;
    }
    LRUMemory.prototype.memorize = function (model, pos, item) {
        var label = item.suggestion.label;
        var key = model.getLanguageIdentifier().language + "/" + label;
        this._cache.set(key, {
            touch: this._seq++,
            type: item.suggestion.type,
            insertText: item.suggestion.insertText
        });
    };
    LRUMemory.prototype.select = function (model, pos, items) {
        // in order of completions, select the first
        // that has been used in the past
        var word = model.getWordUntilPosition(pos).word;
        if (word.length !== 0) {
            return _super.prototype.select.call(this, model, pos, items);
        }
        var lineSuffix = model.getLineContent(pos.lineNumber).substr(pos.column - 10, pos.column - 1);
        if (/\s$/.test(lineSuffix)) {
            return _super.prototype.select.call(this, model, pos, items);
        }
        var res = -1;
        var seq = -1;
        for (var i = 0; i < items.length; i++) {
            var suggestion = items[i].suggestion;
            var key = model.getLanguageIdentifier().language + "/" + suggestion.label;
            var item = this._cache.get(key);
            if (item && item.touch > seq && item.type === suggestion.type && item.insertText === suggestion.insertText) {
                seq = item.touch;
                res = i;
            }
        }
        if (res === -1) {
            return _super.prototype.select.call(this, model, pos, items);
        }
        else {
            return res;
        }
    };
    LRUMemory.prototype.toJSON = function () {
        var data = [];
        this._cache.forEach(function (value, key) {
            data.push([key, value]);
        });
        return data;
    };
    LRUMemory.prototype.fromJSON = function (data) {
        this._cache.clear();
        var seq = 0;
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var _a = data_1[_i], key = _a[0], value = _a[1];
            value.touch = seq;
            this._cache.set(key, value);
        }
        this._seq = this._cache.size;
    };
    return LRUMemory;
}(Memory));

var PrefixMemory = /** @class */ (function (_super) {
    __extends(PrefixMemory, _super);
    function PrefixMemory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._trie = __WEBPACK_IMPORTED_MODULE_0__base_common_map_js__["c" /* TernarySearchTree */].forStrings();
        _this._seq = 0;
        return _this;
    }
    PrefixMemory.prototype.memorize = function (model, pos, item) {
        var word = model.getWordUntilPosition(pos).word;
        var key = model.getLanguageIdentifier().language + "/" + word;
        this._trie.set(key, {
            type: item.suggestion.type,
            insertText: item.suggestion.insertText,
            touch: this._seq++
        });
    };
    PrefixMemory.prototype.select = function (model, pos, items) {
        var word = model.getWordUntilPosition(pos).word;
        if (!word) {
            return _super.prototype.select.call(this, model, pos, items);
        }
        var key = model.getLanguageIdentifier().language + "/" + word;
        var item = this._trie.get(key);
        if (!item) {
            item = this._trie.findSubstr(key);
        }
        if (item) {
            for (var i = 0; i < items.length; i++) {
                var _a = items[i].suggestion, type = _a.type, insertText = _a.insertText;
                if (type === item.type && insertText === item.insertText) {
                    return i;
                }
            }
        }
        return _super.prototype.select.call(this, model, pos, items);
    };
    PrefixMemory.prototype.toJSON = function () {
        var entries = [];
        this._trie.forEach(function (value, key) { return entries.push([key, value]); });
        // sort by last recently used (touch), then
        // take the top 200 item and normalize their
        // touch
        entries
            .sort(function (a, b) { return -(a[1].touch - b[1].touch); })
            .forEach(function (value, i) { return value[1].touch = i; });
        return entries.slice(0, 200);
    };
    PrefixMemory.prototype.fromJSON = function (data) {
        this._trie.clear();
        if (data.length > 0) {
            this._seq = data[0][1].touch + 1;
            for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                var _a = data_2[_i], key = _a[0], value = _a[1];
                this._trie.set(key, value);
            }
        }
    };
    return PrefixMemory;
}(Memory));

var SuggestMemories = /** @class */ (function () {
    function SuggestMemories(mode, _storageService) {
        var _this = this;
        this._storageService = _storageService;
        this._storagePrefix = 'suggest/memories';
        this._persistSoon = new __WEBPACK_IMPORTED_MODULE_2__base_common_async_js__["c" /* RunOnceScheduler */](function () { return _this._flush(); }, 3000);
        this.setMode(mode);
    }
    SuggestMemories.prototype.setMode = function (mode) {
        if (this._mode === mode) {
            return;
        }
        this._mode = mode;
        this._strategy = mode === 'recentlyUsedByPrefix' ? new PrefixMemory() : mode === 'recentlyUsed' ? new LRUMemory() : new NoMemory();
        try {
            var raw = this._storageService.get(this._storagePrefix + "/" + this._mode, __WEBPACK_IMPORTED_MODULE_1__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE);
            if (raw) {
                this._strategy.fromJSON(JSON.parse(raw));
            }
        }
        catch (e) {
            // things can go wrong with JSON...
        }
    };
    SuggestMemories.prototype.memorize = function (model, pos, item) {
        this._strategy.memorize(model, pos, item);
        this._persistSoon.schedule();
    };
    SuggestMemories.prototype.select = function (model, pos, items) {
        return this._strategy.select(model, pos, items);
    };
    SuggestMemories.prototype._flush = function () {
        var raw = JSON.stringify(this._strategy);
        this._storageService.store(this._storagePrefix + "/" + this._mode, raw, __WEBPACK_IMPORTED_MODULE_1__platform_storage_common_storage_js__["c" /* StorageScope */].WORKSPACE);
    };
    SuggestMemories = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_1__platform_storage_common_storage_js__["a" /* IStorageService */])
    ], SuggestMemories);
    return SuggestMemories;
}());



/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_typescript_monaco_contribution__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_css_monaco_contribution__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_json_monaco_contribution__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_html_monaco_contribution__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basic_languages_monaco_contribution__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__edcore_main__ = __webpack_require__(565);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_5__edcore_main__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_5__edcore_main__[key]; }) }(__WEBPACK_IMPORT_KEY__));








/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CancellationTokenSource", function() { return CancellationTokenSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Emitter", function() { return Emitter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyCode", function() { return KeyCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyMod", function() { return KeyMod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Position", function() { return Position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Range", function() { return Range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Selection", function() { return Selection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectionDirection", function() { return SelectionDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarkerSeverity", function() { return MarkerSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarkerTag", function() { return MarkerTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Promise", function() { return Promise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Uri", function() { return Uri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Token", function() { return Token; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editor", function() { return editor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "languages", function() { return languages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_standalone_standaloneBase_js__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__standalone_browser_standaloneEditor_js__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__standalone_browser_standaloneLanguages_js__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_winjs_polyfill_promise_js__ = __webpack_require__(563);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var global = self;
// When missing, polyfill the native promise
// with our winjs-based polyfill
if (typeof global.Promise === 'undefined') {
    global.Promise = __WEBPACK_IMPORTED_MODULE_4__base_common_winjs_polyfill_promise_js__["a" /* PolyfillPromise */];
}
// Set defaults for standalone editor
__WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["a" /* EDITOR_DEFAULTS */].wrappingIndent = __WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["j" /* WrappingIndent */].None;
__WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["a" /* EDITOR_DEFAULTS */].viewInfo.glyphMargin = false;
__WEBPACK_IMPORTED_MODULE_3__common_config_editorOptions_js__["a" /* EDITOR_DEFAULTS */].autoIndent = false;
var api = Object(__WEBPACK_IMPORTED_MODULE_0__common_standalone_standaloneBase_js__["a" /* createMonacoBaseAPI */])();
api.editor = Object(__WEBPACK_IMPORTED_MODULE_1__standalone_browser_standaloneEditor_js__["a" /* createMonacoEditorAPI */])();
api.languages = Object(__WEBPACK_IMPORTED_MODULE_2__standalone_browser_standaloneLanguages_js__["a" /* createMonacoLanguagesAPI */])();
var CancellationTokenSource = api.CancellationTokenSource;
var Emitter = api.Emitter;
var KeyCode = api.KeyCode;
var KeyMod = api.KeyMod;
var Position = api.Position;
var Range = api.Range;
var Selection = api.Selection;
var SelectionDirection = api.SelectionDirection;
var MarkerSeverity = api.MarkerSeverity;
var MarkerTag = api.MarkerTag;
var Promise = api.Promise;
var Uri = api.Uri;
var Token = api.Token;
var editor = api.editor;
var languages = api.languages;
global.monaco = api;
if (typeof global.require !== 'undefined' && typeof global.require.config === 'function') {
    global.require.config({
        ignoreDuplicateModules: [
            'vscode-languageserver-types',
            'vscode-languageserver-types/main',
            'vscode-nls',
            'vscode-nls/vscode-nls',
            'jsonc-parser',
            'jsonc-parser/main',
            'vscode-uri',
            'vscode-uri/index'
        ]
    });
}


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export onDidCreateEditor */
/* unused harmony export createDiffEditor */
/* unused harmony export createDiffNavigator */
/* unused harmony export createModel */
/* unused harmony export setModelLanguage */
/* unused harmony export setModelMarkers */
/* unused harmony export getModelMarkers */
/* unused harmony export getModel */
/* unused harmony export getModels */
/* unused harmony export onDidCreateModel */
/* unused harmony export onWillDisposeModel */
/* unused harmony export onDidChangeModelLanguage */
/* unused harmony export createWebWorker */
/* unused harmony export colorizeElement */
/* unused harmony export colorize */
/* unused harmony export colorizeModelLine */
/* unused harmony export tokenize */
/* unused harmony export defineTheme */
/* unused harmony export setTheme */
/* harmony export (immutable) */ __webpack_exports__["a"] = createMonacoEditorAPI;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__standalone_tokens_css__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__standalone_tokens_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__standalone_tokens_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_editorCommon_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__standaloneCodeEditor_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_scrollable_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_services_openerService_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_opener_common_opener_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colorizer_js__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__simpleServices_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_services_webWorker_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__browser_widget_diffNavigator_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_contextview_browser_contextView_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_services_editorWorkerService_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_services_resolverService_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_modes_nullMode_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_standaloneThemeService_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_config_fontInfo_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_config_editorOptions_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_controller_cursorEvents_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__platform_configuration_common_configuration_js__ = __webpack_require__(49);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






























function withAllStandaloneServices(domElement, override, callback) {
    var services = new __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["a" /* DynamicStandaloneServices */](domElement, override);
    var simpleEditorModelResolverService = null;
    if (!services.has(__WEBPACK_IMPORTED_MODULE_20__common_services_resolverService_js__["a" /* ITextModelService */])) {
        simpleEditorModelResolverService = new __WEBPACK_IMPORTED_MODULE_9__simpleServices_js__["d" /* SimpleEditorModelResolverService */]();
        services.set(__WEBPACK_IMPORTED_MODULE_20__common_services_resolverService_js__["a" /* ITextModelService */], simpleEditorModelResolverService);
    }
    if (!services.has(__WEBPACK_IMPORTED_MODULE_7__platform_opener_common_opener_js__["a" /* IOpenerService */])) {
        services.set(__WEBPACK_IMPORTED_MODULE_7__platform_opener_common_opener_js__["a" /* IOpenerService */], new __WEBPACK_IMPORTED_MODULE_6__browser_services_openerService_js__["a" /* OpenerService */](services.get(__WEBPACK_IMPORTED_MODULE_18__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]), services.get(__WEBPACK_IMPORTED_MODULE_13__platform_commands_common_commands_js__["b" /* ICommandService */])));
    }
    var result = callback(services);
    if (simpleEditorModelResolverService) {
        simpleEditorModelResolverService.setEditor(result);
    }
    return result;
}
/**
 * Create a new editor under `domElement`.
 * `domElement` should be empty (not contain other dom nodes).
 * The editor will read the size of `domElement`.
 */
function create(domElement, options, override) {
    return withAllStandaloneServices(domElement, override, function (services) {
        return new __WEBPACK_IMPORTED_MODULE_3__standaloneCodeEditor_js__["b" /* StandaloneEditor */](domElement, options, services, services.get(__WEBPACK_IMPORTED_MODULE_15__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]), services.get(__WEBPACK_IMPORTED_MODULE_18__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]), services.get(__WEBPACK_IMPORTED_MODULE_13__platform_commands_common_commands_js__["b" /* ICommandService */]), services.get(__WEBPACK_IMPORTED_MODULE_17__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]), services.get(__WEBPACK_IMPORTED_MODULE_16__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]), services.get(__WEBPACK_IMPORTED_MODULE_14__platform_contextview_browser_contextView_js__["b" /* IContextViewService */]), services.get(__WEBPACK_IMPORTED_MODULE_22__common_standaloneThemeService_js__["a" /* IStandaloneThemeService */]), services.get(__WEBPACK_IMPORTED_MODULE_27__platform_notification_common_notification_js__["a" /* INotificationService */]), services.get(__WEBPACK_IMPORTED_MODULE_28__platform_configuration_common_configuration_js__["b" /* IConfigurationService */]));
    });
}
/**
 * Emitted when an editor is created.
 * Creating a diff editor might cause this listener to be invoked with the two editors.
 * @event
 */
function onDidCreateEditor(listener) {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].codeEditorService.get().onCodeEditorAdd(function (editor) {
        listener(editor);
    });
}
/**
 * Create a new diff editor under `domElement`.
 * `domElement` should be empty (not contain other dom nodes).
 * The editor will read the size of `domElement`.
 */
function createDiffEditor(domElement, options, override) {
    return withAllStandaloneServices(domElement, override, function (services) {
        return new __WEBPACK_IMPORTED_MODULE_3__standaloneCodeEditor_js__["a" /* StandaloneDiffEditor */](domElement, options, services, services.get(__WEBPACK_IMPORTED_MODULE_15__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]), services.get(__WEBPACK_IMPORTED_MODULE_17__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]), services.get(__WEBPACK_IMPORTED_MODULE_16__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]), services.get(__WEBPACK_IMPORTED_MODULE_14__platform_contextview_browser_contextView_js__["b" /* IContextViewService */]), services.get(__WEBPACK_IMPORTED_MODULE_19__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */]), services.get(__WEBPACK_IMPORTED_MODULE_18__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]), services.get(__WEBPACK_IMPORTED_MODULE_22__common_standaloneThemeService_js__["a" /* IStandaloneThemeService */]), services.get(__WEBPACK_IMPORTED_MODULE_27__platform_notification_common_notification_js__["a" /* INotificationService */]), services.get(__WEBPACK_IMPORTED_MODULE_28__platform_configuration_common_configuration_js__["b" /* IConfigurationService */]));
    });
}
function createDiffNavigator(diffEditor, opts) {
    return new __WEBPACK_IMPORTED_MODULE_12__browser_widget_diffNavigator_js__["a" /* DiffNavigator */](diffEditor, opts);
}
function doCreateModel(value, mode, uri) {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get().createModel(value, mode, uri);
}
/**
 * Create a new editor model.
 * You can specify the language that should be set for this model or let the language be inferred from the `uri`.
 */
function createModel(value, language, uri) {
    value = value || '';
    if (!language) {
        var path = uri ? uri.path : null;
        var firstLF = value.indexOf('\n');
        var firstLine = value;
        if (firstLF !== -1) {
            firstLine = value.substring(0, firstLF);
        }
        return doCreateModel(value, __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modeService.get().getOrCreateModeByFilenameOrFirstLine(path, firstLine), uri);
    }
    return doCreateModel(value, __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modeService.get().getOrCreateMode(language), uri);
}
/**
 * Change the language for a model.
 */
function setModelLanguage(model, languageId) {
    __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get().setMode(model, __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modeService.get().getOrCreateMode(languageId));
}
/**
 * Set the markers for a model.
 */
function setModelMarkers(model, owner, markers) {
    if (model) {
        __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].markerService.get().changeOne(owner, model.uri, markers);
    }
}
/**
 * Get markers for owner and/or resource
 * @returns {IMarker[]} list of markers
 * @param filter
 */
function getModelMarkers(filter) {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].markerService.get().read(filter);
}
/**
 * Get the model that has `uri` if it exists.
 */
function getModel(uri) {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get().getModel(uri);
}
/**
 * Get all the created models.
 */
function getModels() {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get().getModels();
}
/**
 * Emitted when a model is created.
 * @event
 */
function onDidCreateModel(listener) {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get().onModelAdded(listener);
}
/**
 * Emitted right before a model is disposed.
 * @event
 */
function onWillDisposeModel(listener) {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get().onModelRemoved(listener);
}
/**
 * Emitted when a different language is set to a model.
 * @event
 */
function onDidChangeModelLanguage(listener) {
    return __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get().onModelModeChanged(function (e) {
        listener({
            model: e.model,
            oldLanguage: e.oldModeId
        });
    });
}
/**
 * Create a new web worker that has model syncing capabilities built in.
 * Specify an AMD module to load that will `create` an object that will be proxied.
 */
function createWebWorker(opts) {
    return Object(__WEBPACK_IMPORTED_MODULE_11__common_services_webWorker_js__["a" /* createWebWorker */])(__WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modelService.get(), opts);
}
/**
 * Colorize the contents of `domNode` using attribute `data-lang`.
 */
function colorizeElement(domNode, options) {
    return __WEBPACK_IMPORTED_MODULE_8__colorizer_js__["a" /* Colorizer */].colorizeElement(__WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].standaloneThemeService.get(), __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modeService.get(), domNode, options);
}
/**
 * Colorize `text` using language `languageId`.
 */
function colorize(text, languageId, options) {
    return __WEBPACK_IMPORTED_MODULE_8__colorizer_js__["a" /* Colorizer */].colorize(__WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modeService.get(), text, languageId, options);
}
/**
 * Colorize a line in a model.
 */
function colorizeModelLine(model, lineNumber, tabSize) {
    if (tabSize === void 0) { tabSize = 4; }
    return __WEBPACK_IMPORTED_MODULE_8__colorizer_js__["a" /* Colorizer */].colorizeModelLine(model, lineNumber, tabSize);
}
/**
 * @internal
 */
function getSafeTokenizationSupport(language) {
    var tokenizationSupport = __WEBPACK_IMPORTED_MODULE_10__common_modes_js__["y" /* TokenizationRegistry */].get(language);
    if (tokenizationSupport) {
        return tokenizationSupport;
    }
    return {
        getInitialState: function () { return __WEBPACK_IMPORTED_MODULE_21__common_modes_nullMode_js__["c" /* NULL_STATE */]; },
        tokenize: function (line, state, deltaOffset) { return Object(__WEBPACK_IMPORTED_MODULE_21__common_modes_nullMode_js__["d" /* nullTokenize */])(language, line, state, deltaOffset); },
        tokenize2: undefined,
    };
}
/**
 * Tokenize `text` using language `languageId`
 */
function tokenize(text, languageId) {
    var modeService = __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].modeService.get();
    // Needed in order to get the mode registered for subsequent look-ups
    modeService.getOrCreateMode(languageId);
    var tokenizationSupport = getSafeTokenizationSupport(languageId);
    var lines = text.split(/\r\n|\r|\n/);
    var result = [];
    var state = tokenizationSupport.getInitialState();
    for (var i = 0, len = lines.length; i < len; i++) {
        var line = lines[i];
        var tokenizationResult = tokenizationSupport.tokenize(line, state, 0);
        result[i] = tokenizationResult.tokens;
        state = tokenizationResult.endState;
    }
    return result;
}
/**
 * Define a new theme or updte an existing theme.
 */
function defineTheme(themeName, themeData) {
    __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].standaloneThemeService.get().defineTheme(themeName, themeData);
}
/**
 * Switches to a theme.
 */
function setTheme(themeName) {
    __WEBPACK_IMPORTED_MODULE_5__standaloneServices_js__["b" /* StaticServices */].standaloneThemeService.get().setTheme(themeName);
}
/**
 * @internal
 * --------------------------------------------
 * This is repeated here so it can be exported
 * because TS inlines const enums
 * --------------------------------------------
 */
var ScrollType;
(function (ScrollType) {
    ScrollType[ScrollType["Smooth"] = 0] = "Smooth";
    ScrollType[ScrollType["Immediate"] = 1] = "Immediate";
})(ScrollType || (ScrollType = {}));
/**
 * @internal
 * --------------------------------------------
 * This is repeated here so it can be exported
 * because TS inlines const enums
 * --------------------------------------------
 */
var RenderLineNumbersType;
(function (RenderLineNumbersType) {
    RenderLineNumbersType[RenderLineNumbersType["Off"] = 0] = "Off";
    RenderLineNumbersType[RenderLineNumbersType["On"] = 1] = "On";
    RenderLineNumbersType[RenderLineNumbersType["Relative"] = 2] = "Relative";
    RenderLineNumbersType[RenderLineNumbersType["Interval"] = 3] = "Interval";
    RenderLineNumbersType[RenderLineNumbersType["Custom"] = 4] = "Custom";
})(RenderLineNumbersType || (RenderLineNumbersType = {}));
/**
 * @internal
 */
function createMonacoEditorAPI() {
    return {
        // methods
        create: create,
        onDidCreateEditor: onDidCreateEditor,
        createDiffEditor: createDiffEditor,
        createDiffNavigator: createDiffNavigator,
        createModel: createModel,
        setModelLanguage: setModelLanguage,
        setModelMarkers: setModelMarkers,
        getModelMarkers: getModelMarkers,
        getModels: getModels,
        getModel: getModel,
        onDidCreateModel: onDidCreateModel,
        onWillDisposeModel: onWillDisposeModel,
        onDidChangeModelLanguage: onDidChangeModelLanguage,
        createWebWorker: createWebWorker,
        colorizeElement: colorizeElement,
        colorize: colorize,
        colorizeModelLine: colorizeModelLine,
        tokenize: tokenize,
        defineTheme: defineTheme,
        setTheme: setTheme,
        // enums
        ScrollbarVisibility: __WEBPACK_IMPORTED_MODULE_4__base_common_scrollable_js__["b" /* ScrollbarVisibility */],
        WrappingIndent: __WEBPACK_IMPORTED_MODULE_24__common_config_editorOptions_js__["j" /* WrappingIndent */],
        OverviewRulerLane: __WEBPACK_IMPORTED_MODULE_26__common_model_js__["f" /* OverviewRulerLane */],
        EndOfLinePreference: __WEBPACK_IMPORTED_MODULE_26__common_model_js__["c" /* EndOfLinePreference */],
        DefaultEndOfLine: __WEBPACK_IMPORTED_MODULE_26__common_model_js__["b" /* DefaultEndOfLine */],
        EndOfLineSequence: __WEBPACK_IMPORTED_MODULE_26__common_model_js__["d" /* EndOfLineSequence */],
        TrackedRangeStickiness: __WEBPACK_IMPORTED_MODULE_26__common_model_js__["h" /* TrackedRangeStickiness */],
        CursorChangeReason: __WEBPACK_IMPORTED_MODULE_25__common_controller_cursorEvents_js__["a" /* CursorChangeReason */],
        MouseTargetType: __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__["b" /* MouseTargetType */],
        TextEditorCursorStyle: __WEBPACK_IMPORTED_MODULE_24__common_config_editorOptions_js__["i" /* TextEditorCursorStyle */],
        TextEditorCursorBlinkingStyle: __WEBPACK_IMPORTED_MODULE_24__common_config_editorOptions_js__["h" /* TextEditorCursorBlinkingStyle */],
        ContentWidgetPositionPreference: __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__["a" /* ContentWidgetPositionPreference */],
        OverlayWidgetPositionPreference: __WEBPACK_IMPORTED_MODULE_2__browser_editorBrowser_js__["c" /* OverlayWidgetPositionPreference */],
        RenderMinimap: __WEBPACK_IMPORTED_MODULE_24__common_config_editorOptions_js__["g" /* RenderMinimap */],
        ScrollType: ScrollType,
        RenderLineNumbersType: RenderLineNumbersType,
        // classes
        InternalEditorOptions: __WEBPACK_IMPORTED_MODULE_24__common_config_editorOptions_js__["e" /* InternalEditorOptions */],
        BareFontInfo: __WEBPACK_IMPORTED_MODULE_23__common_config_fontInfo_js__["a" /* BareFontInfo */],
        FontInfo: __WEBPACK_IMPORTED_MODULE_23__common_config_fontInfo_js__["b" /* FontInfo */],
        TextModelResolvedOptions: __WEBPACK_IMPORTED_MODULE_26__common_model_js__["g" /* TextModelResolvedOptions */],
        FindMatch: __WEBPACK_IMPORTED_MODULE_26__common_model_js__["e" /* FindMatch */],
        // vars
        EditorType: __WEBPACK_IMPORTED_MODULE_1__common_editorCommon_js__["a" /* EditorType */]
    };
}


/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StandaloneCodeEditor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StandaloneEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandaloneDiffEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_contextview_browser_contextView_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_keybinding_common_keybinding_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_services_editorWorkerService_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__simpleServices_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browser_widget_codeEditorWidget_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__browser_widget_diffEditorWidget_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_standaloneThemeService_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_editorAction_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__platform_actions_common_actions_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__base_browser_ui_aria_aria_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__base_browser_browser_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__platform_notification_common_notification_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__platform_configuration_common_configuration_js__ = __webpack_require__(49);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





















var LAST_GENERATED_COMMAND_ID = 0;
var ariaDomNodeCreated = false;
function createAriaDomNode() {
    if (ariaDomNodeCreated) {
        return;
    }
    ariaDomNodeCreated = true;
    __WEBPACK_IMPORTED_MODULE_16__base_browser_ui_aria_aria_js__["b" /* setARIAContainer */](document.body);
}
/**
 * A code editor to be used both by the standalone editor and the standalone diff editor.
 */
var StandaloneCodeEditor = /** @class */ (function (_super) {
    __extends(StandaloneCodeEditor, _super);
    function StandaloneCodeEditor(domElement, options, instantiationService, codeEditorService, commandService, contextKeyService, keybindingService, themeService, notificationService) {
        var _this = this;
        options = options || {};
        options.ariaLabel = options.ariaLabel || __WEBPACK_IMPORTED_MODULE_17__nls_js__["a" /* localize */]('editorViewAccessibleLabel', "Editor content");
        options.ariaLabel = options.ariaLabel + ';' + (__WEBPACK_IMPORTED_MODULE_18__base_browser_browser_js__["k" /* isIE */]
            ? __WEBPACK_IMPORTED_MODULE_17__nls_js__["a" /* localize */]('accessibilityHelpMessageIE', "Press Ctrl+F1 for Accessibility Options.")
            : __WEBPACK_IMPORTED_MODULE_17__nls_js__["a" /* localize */]('accessibilityHelpMessage', "Press Alt+F1 for Accessibility Options."));
        _this = _super.call(this, domElement, options, {}, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService) || this;
        if (keybindingService instanceof __WEBPACK_IMPORTED_MODULE_9__simpleServices_js__["l" /* StandaloneKeybindingService */]) {
            _this._standaloneKeybindingService = keybindingService;
        }
        // Create the ARIA dom node as soon as the first editor is instantiated
        createAriaDomNode();
        return _this;
    }
    StandaloneCodeEditor.prototype.addCommand = function (keybinding, handler, context) {
        if (!this._standaloneKeybindingService) {
            console.warn('Cannot add command because the editor is configured with an unrecognized KeybindingService');
            return null;
        }
        var commandId = 'DYNAMIC_' + (++LAST_GENERATED_COMMAND_ID);
        var whenExpression = __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].deserialize(context);
        this._standaloneKeybindingService.addDynamicKeybinding(commandId, keybinding, handler, whenExpression);
        return commandId;
    };
    StandaloneCodeEditor.prototype.createContextKey = function (key, defaultValue) {
        return this._contextKeyService.createKey(key, defaultValue);
    };
    StandaloneCodeEditor.prototype.addAction = function (_descriptor) {
        var _this = this;
        if ((typeof _descriptor.id !== 'string') || (typeof _descriptor.label !== 'string') || (typeof _descriptor.run !== 'function')) {
            throw new Error('Invalid action descriptor, `id`, `label` and `run` are required properties!');
        }
        if (!this._standaloneKeybindingService) {
            console.warn('Cannot add keybinding because the editor is configured with an unrecognized KeybindingService');
            return __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["a" /* Disposable */].None;
        }
        // Read descriptor options
        var id = _descriptor.id;
        var label = _descriptor.label;
        var precondition = __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(__WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].equals('editorId', this.getId()), __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].deserialize(_descriptor.precondition));
        var keybindings = _descriptor.keybindings;
        var keybindingsWhen = __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].and(precondition, __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].deserialize(_descriptor.keybindingContext));
        var contextMenuGroupId = _descriptor.contextMenuGroupId || null;
        var contextMenuOrder = _descriptor.contextMenuOrder || 0;
        var run = function () {
            var r = _descriptor.run(_this);
            return r ? r : __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(void 0);
        };
        var toDispose = [];
        // Generate a unique id to allow the same descriptor.id across multiple editor instances
        var uniqueId = this.getId() + ':' + id;
        // Register the command
        toDispose.push(__WEBPACK_IMPORTED_MODULE_4__platform_commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand(uniqueId, run));
        // Register the context menu item
        if (contextMenuGroupId) {
            var menuItem = {
                command: {
                    id: uniqueId,
                    title: label
                },
                when: precondition,
                group: contextMenuGroupId,
                order: contextMenuOrder
            };
            toDispose.push(__WEBPACK_IMPORTED_MODULE_14__platform_actions_common_actions_js__["d" /* MenuRegistry */].appendMenuItem(__WEBPACK_IMPORTED_MODULE_14__platform_actions_common_actions_js__["b" /* MenuId */].EditorContext, menuItem));
        }
        // Register the keybindings
        if (Array.isArray(keybindings)) {
            toDispose = toDispose.concat(keybindings.map(function (kb) {
                return _this._standaloneKeybindingService.addDynamicKeybinding(uniqueId, kb, run, keybindingsWhen);
            }));
        }
        // Finally, register an internal editor action
        var internalAction = new __WEBPACK_IMPORTED_MODULE_13__common_editorAction_js__["a" /* InternalEditorAction */](uniqueId, label, label, precondition, run, this._contextKeyService);
        // Store it under the original id, such that trigger with the original id will work
        this._actions[id] = internalAction;
        toDispose.push(Object(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["f" /* toDisposable */])(function () {
            delete _this._actions[id];
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["c" /* combinedDisposable */])(toDispose);
    };
    StandaloneCodeEditor = __decorate([
        __param(2, __WEBPACK_IMPORTED_MODULE_3__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_7__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_4__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_5__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_15__platform_theme_common_themeService_js__["c" /* IThemeService */]),
        __param(8, __WEBPACK_IMPORTED_MODULE_19__platform_notification_common_notification_js__["a" /* INotificationService */])
    ], StandaloneCodeEditor);
    return StandaloneCodeEditor;
}(__WEBPACK_IMPORTED_MODULE_10__browser_widget_codeEditorWidget_js__["a" /* CodeEditorWidget */]));

var StandaloneEditor = /** @class */ (function (_super) {
    __extends(StandaloneEditor, _super);
    function StandaloneEditor(domElement, options, toDispose, instantiationService, codeEditorService, commandService, contextKeyService, keybindingService, contextViewService, themeService, notificationService, configurationService) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_9__simpleServices_js__["n" /* applyConfigurationValues */])(configurationService, options, false);
        options = options || {};
        if (typeof options.theme === 'string') {
            themeService.setTheme(options.theme);
        }
        var model = options.model;
        delete options.model;
        _this = _super.call(this, domElement, options, instantiationService, codeEditorService, commandService, contextKeyService, keybindingService, themeService, notificationService) || this;
        _this._contextViewService = contextViewService;
        _this._configurationService = configurationService;
        _this._register(toDispose);
        if (typeof model === 'undefined') {
            model = self.monaco.editor.createModel(options.value || '', options.language || 'text/plain');
            _this._ownsModel = true;
        }
        else {
            _this._ownsModel = false;
        }
        _this._attachModel(model);
        if (model) {
            var e = {
                oldModelUrl: null,
                newModelUrl: model.uri
            };
            _this._onDidChangeModel.fire(e);
        }
        return _this;
    }
    StandaloneEditor.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    StandaloneEditor.prototype.updateOptions = function (newOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_9__simpleServices_js__["n" /* applyConfigurationValues */])(this._configurationService, newOptions, false);
        _super.prototype.updateOptions.call(this, newOptions);
    };
    StandaloneEditor.prototype._attachModel = function (model) {
        _super.prototype._attachModel.call(this, model);
        if (this._view) {
            this._contextViewService.setContainer(this._view.domNode.domNode);
        }
    };
    StandaloneEditor.prototype._postDetachModelCleanup = function (detachedModel) {
        _super.prototype._postDetachModelCleanup.call(this, detachedModel);
        if (detachedModel && this._ownsModel) {
            detachedModel.dispose();
            this._ownsModel = false;
        }
    };
    StandaloneEditor = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_3__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_7__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_4__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_5__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(8, __WEBPACK_IMPORTED_MODULE_2__platform_contextview_browser_contextView_js__["b" /* IContextViewService */]),
        __param(9, __WEBPACK_IMPORTED_MODULE_12__common_standaloneThemeService_js__["a" /* IStandaloneThemeService */]),
        __param(10, __WEBPACK_IMPORTED_MODULE_19__platform_notification_common_notification_js__["a" /* INotificationService */]),
        __param(11, __WEBPACK_IMPORTED_MODULE_20__platform_configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], StandaloneEditor);
    return StandaloneEditor;
}(StandaloneCodeEditor));

var StandaloneDiffEditor = /** @class */ (function (_super) {
    __extends(StandaloneDiffEditor, _super);
    function StandaloneDiffEditor(domElement, options, toDispose, instantiationService, contextKeyService, keybindingService, contextViewService, editorWorkerService, codeEditorService, themeService, notificationService, configurationService) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_9__simpleServices_js__["n" /* applyConfigurationValues */])(configurationService, options, true);
        options = options || {};
        if (typeof options.theme === 'string') {
            options.theme = themeService.setTheme(options.theme);
        }
        _this = _super.call(this, domElement, options, editorWorkerService, contextKeyService, instantiationService, codeEditorService, themeService, notificationService) || this;
        _this._contextViewService = contextViewService;
        _this._configurationService = configurationService;
        _this._register(toDispose);
        _this._contextViewService.setContainer(_this._containerDomElement);
        return _this;
    }
    StandaloneDiffEditor.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    StandaloneDiffEditor.prototype.updateOptions = function (newOptions) {
        Object(__WEBPACK_IMPORTED_MODULE_9__simpleServices_js__["n" /* applyConfigurationValues */])(this._configurationService, newOptions, true);
        _super.prototype.updateOptions.call(this, newOptions);
    };
    StandaloneDiffEditor.prototype._createInnerEditor = function (instantiationService, container, options) {
        return instantiationService.createInstance(StandaloneCodeEditor, container, options);
    };
    StandaloneDiffEditor.prototype.getOriginalEditor = function () {
        return _super.prototype.getOriginalEditor.call(this);
    };
    StandaloneDiffEditor.prototype.getModifiedEditor = function () {
        return _super.prototype.getModifiedEditor.call(this);
    };
    StandaloneDiffEditor.prototype.addCommand = function (keybinding, handler, context) {
        return this.getModifiedEditor().addCommand(keybinding, handler, context);
    };
    StandaloneDiffEditor.prototype.createContextKey = function (key, defaultValue) {
        return this.getModifiedEditor().createContextKey(key, defaultValue);
    };
    StandaloneDiffEditor.prototype.addAction = function (descriptor) {
        return this.getModifiedEditor().addAction(descriptor);
    };
    StandaloneDiffEditor = __decorate([
        __param(3, __WEBPACK_IMPORTED_MODULE_3__platform_instantiation_common_instantiation_js__["a" /* IInstantiationService */]),
        __param(4, __WEBPACK_IMPORTED_MODULE_6__platform_contextkey_common_contextkey_js__["e" /* IContextKeyService */]),
        __param(5, __WEBPACK_IMPORTED_MODULE_5__platform_keybinding_common_keybinding_js__["a" /* IKeybindingService */]),
        __param(6, __WEBPACK_IMPORTED_MODULE_2__platform_contextview_browser_contextView_js__["b" /* IContextViewService */]),
        __param(7, __WEBPACK_IMPORTED_MODULE_8__common_services_editorWorkerService_js__["a" /* IEditorWorkerService */]),
        __param(8, __WEBPACK_IMPORTED_MODULE_7__browser_services_codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(9, __WEBPACK_IMPORTED_MODULE_12__common_standaloneThemeService_js__["a" /* IStandaloneThemeService */]),
        __param(10, __WEBPACK_IMPORTED_MODULE_19__platform_notification_common_notification_js__["a" /* INotificationService */]),
        __param(11, __WEBPACK_IMPORTED_MODULE_20__platform_configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], StandaloneDiffEditor);
    return StandaloneDiffEditor;
}(__WEBPACK_IMPORTED_MODULE_11__browser_widget_diffEditorWidget_js__["a" /* DiffEditorWidget */]));



/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractKeybindingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var AbstractKeybindingService = /** @class */ (function (_super) {
    __extends(AbstractKeybindingService, _super);
    function AbstractKeybindingService(contextKeyService, commandService, telemetryService, notificationService, statusService) {
        var _this = _super.call(this) || this;
        _this._contextKeyService = contextKeyService;
        _this._commandService = commandService;
        _this._telemetryService = telemetryService;
        _this._statusService = statusService;
        _this._notificationService = notificationService;
        _this._currentChord = null;
        _this._currentChordChecker = new __WEBPACK_IMPORTED_MODULE_3__base_common_async_js__["b" /* IntervalTimer */]();
        _this._currentChordStatusMessage = null;
        _this._onDidUpdateKeybindings = _this._register(new __WEBPACK_IMPORTED_MODULE_2__base_common_event_js__["a" /* Emitter */]());
        return _this;
    }
    AbstractKeybindingService.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
    };
    Object.defineProperty(AbstractKeybindingService.prototype, "onDidUpdateKeybindings", {
        get: function () {
            return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : __WEBPACK_IMPORTED_MODULE_2__base_common_event_js__["b" /* Event */].None; // Sinon stubbing walks properties on prototype
        },
        enumerable: true,
        configurable: true
    });
    AbstractKeybindingService.prototype.lookupKeybinding = function (commandId) {
        var result = this._getResolver().lookupPrimaryKeybinding(commandId);
        if (!result) {
            return null;
        }
        return result.resolvedKeybinding;
    };
    AbstractKeybindingService.prototype._enterChordMode = function (firstPart, keypressLabel) {
        var _this = this;
        this._currentChord = {
            keypress: firstPart,
            label: keypressLabel
        };
        if (this._statusService) {
            this._currentChordStatusMessage = this._statusService.setStatusMessage(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('first.chord', "({0}) was pressed. Waiting for second key of chord...", keypressLabel));
        }
        var chordEnterTime = Date.now();
        this._currentChordChecker.cancelAndSet(function () {
            if (!_this._documentHasFocus()) {
                // Focus has been lost => leave chord mode
                _this._leaveChordMode();
                return;
            }
            if (Date.now() - chordEnterTime > 5000) {
                // 5 seconds elapsed => leave chord mode
                _this._leaveChordMode();
            }
        }, 500);
    };
    AbstractKeybindingService.prototype._leaveChordMode = function () {
        if (this._currentChordStatusMessage) {
            this._currentChordStatusMessage.dispose();
            this._currentChordStatusMessage = null;
        }
        this._currentChordChecker.cancel();
        this._currentChord = null;
    };
    AbstractKeybindingService.prototype._dispatch = function (e, target) {
        var _this = this;
        var shouldPreventDefault = false;
        var keybinding = this.resolveKeyboardEvent(e);
        if (keybinding.isChord()) {
            console.warn('Unexpected keyboard event mapped to a chord');
            return null;
        }
        var firstPart = keybinding.getDispatchParts()[0];
        if (firstPart === null) {
            // cannot be dispatched, probably only modifier keys
            return shouldPreventDefault;
        }
        var contextValue = this._contextKeyService.getContext(target);
        var currentChord = this._currentChord ? this._currentChord.keypress : null;
        var keypressLabel = keybinding.getLabel();
        var resolveResult = this._getResolver().resolve(contextValue, currentChord, firstPart);
        if (resolveResult && resolveResult.enterChord) {
            shouldPreventDefault = true;
            this._enterChordMode(firstPart, keypressLabel);
            return shouldPreventDefault;
        }
        if (this._statusService && this._currentChord) {
            if (!resolveResult || !resolveResult.commandId) {
                this._statusService.setStatusMessage(__WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('missing.chord', "The key combination ({0}, {1}) is not a command.", this._currentChord.label, keypressLabel), 10 * 1000 /* 10s */);
                shouldPreventDefault = true;
            }
        }
        this._leaveChordMode();
        if (resolveResult && resolveResult.commandId) {
            if (!resolveResult.bubble) {
                shouldPreventDefault = true;
            }
            if (typeof resolveResult.commandArgs === 'undefined') {
                this._commandService.executeCommand(resolveResult.commandId).done(undefined, function (err) { return _this._notificationService.warn(err); });
            }
            else {
                this._commandService.executeCommand(resolveResult.commandId, resolveResult.commandArgs).done(undefined, function (err) { return _this._notificationService.warn(err); });
            }
            /* __GDPR__
                "workbenchActionExecuted" : {
                    "id" : { "classification": "SystemMetaData", "purpose": "FeatureInsight" },
                    "from": { "classification": "SystemMetaData", "purpose": "FeatureInsight" }
                }
            */
            this._telemetryService.publicLog('workbenchActionExecuted', { id: resolveResult.commandId, from: 'keybinding' });
        }
        return shouldPreventDefault;
    };
    return AbstractKeybindingService;
}(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["a" /* Disposable */]));



/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USLayoutResolvedKeybinding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_keybindingLabels_js__ = __webpack_require__(282);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Do not instantiate. Use KeybindingService to get a ResolvedKeybinding seeded with information about the current kb layout.
 */
var USLayoutResolvedKeybinding = /** @class */ (function (_super) {
    __extends(USLayoutResolvedKeybinding, _super);
    function USLayoutResolvedKeybinding(actual, OS) {
        var _this = _super.call(this) || this;
        _this._os = OS;
        if (actual === null) {
            throw new Error("Invalid USLayoutResolvedKeybinding");
        }
        else if (actual.type === 2 /* Chord */) {
            _this._firstPart = actual.firstPart;
            _this._chordPart = actual.chordPart;
        }
        else {
            _this._firstPart = actual;
            _this._chordPart = null;
        }
        return _this;
    }
    USLayoutResolvedKeybinding.prototype._keyCodeToUILabel = function (keyCode) {
        if (this._os === 2 /* Macintosh */) {
            switch (keyCode) {
                case 15 /* LeftArrow */:
                    return '←';
                case 16 /* UpArrow */:
                    return '↑';
                case 17 /* RightArrow */:
                    return '→';
                case 18 /* DownArrow */:
                    return '↓';
            }
        }
        return __WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__["b" /* KeyCodeUtils */].toString(keyCode);
    };
    USLayoutResolvedKeybinding.prototype._getUILabelForKeybinding = function (keybinding) {
        if (!keybinding) {
            return null;
        }
        if (keybinding.isDuplicateModifierCase()) {
            return '';
        }
        return this._keyCodeToUILabel(keybinding.keyCode);
    };
    USLayoutResolvedKeybinding.prototype.getLabel = function () {
        var firstPart = this._getUILabelForKeybinding(this._firstPart);
        var chordPart = this._getUILabelForKeybinding(this._chordPart);
        return __WEBPACK_IMPORTED_MODULE_1__base_common_keybindingLabels_js__["b" /* UILabelProvider */].toLabel(this._firstPart, firstPart, this._chordPart, chordPart, this._os);
    };
    USLayoutResolvedKeybinding.prototype._getAriaLabelForKeybinding = function (keybinding) {
        if (!keybinding) {
            return null;
        }
        if (keybinding.isDuplicateModifierCase()) {
            return '';
        }
        return __WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__["b" /* KeyCodeUtils */].toString(keybinding.keyCode);
    };
    USLayoutResolvedKeybinding.prototype.getAriaLabel = function () {
        var firstPart = this._getAriaLabelForKeybinding(this._firstPart);
        var chordPart = this._getAriaLabelForKeybinding(this._chordPart);
        return __WEBPACK_IMPORTED_MODULE_1__base_common_keybindingLabels_js__["a" /* AriaLabelProvider */].toLabel(this._firstPart, firstPart, this._chordPart, chordPart, this._os);
    };
    USLayoutResolvedKeybinding.prototype.isChord = function () {
        return (this._chordPart ? true : false);
    };
    USLayoutResolvedKeybinding.prototype.getParts = function () {
        return [
            this._toResolvedKeybindingPart(this._firstPart),
            this._toResolvedKeybindingPart(this._chordPart)
        ];
    };
    USLayoutResolvedKeybinding.prototype._toResolvedKeybindingPart = function (keybinding) {
        if (!keybinding) {
            return null;
        }
        return new __WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__["d" /* ResolvedKeybindingPart */](keybinding.ctrlKey, keybinding.shiftKey, keybinding.altKey, keybinding.metaKey, this._getUILabelForKeybinding(keybinding), this._getAriaLabelForKeybinding(keybinding));
    };
    USLayoutResolvedKeybinding.prototype.getDispatchParts = function () {
        var firstPart = this._firstPart ? USLayoutResolvedKeybinding.getDispatchStr(this._firstPart) : null;
        var chordPart = this._chordPart ? USLayoutResolvedKeybinding.getDispatchStr(this._chordPart) : null;
        return [firstPart, chordPart];
    };
    USLayoutResolvedKeybinding.getDispatchStr = function (keybinding) {
        if (keybinding.isModifierKey()) {
            return null;
        }
        var result = '';
        if (keybinding.ctrlKey) {
            result += 'ctrl+';
        }
        if (keybinding.shiftKey) {
            result += 'shift+';
        }
        if (keybinding.altKey) {
            result += 'alt+';
        }
        if (keybinding.metaKey) {
            result += 'meta+';
        }
        result += __WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__["b" /* KeyCodeUtils */].toString(keybinding.keyCode);
        return result;
    };
    return USLayoutResolvedKeybinding;
}(__WEBPACK_IMPORTED_MODULE_0__base_common_keyCodes_js__["c" /* ResolvedKeybinding */]));



/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConfigurationModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DefaultConfigurationModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Configuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_map_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configurationRegistry_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration_js__ = __webpack_require__(49);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ConfigurationModel = /** @class */ (function () {
    function ConfigurationModel(_contents, _keys, _overrides) {
        if (_contents === void 0) { _contents = {}; }
        if (_keys === void 0) { _keys = []; }
        if (_overrides === void 0) { _overrides = []; }
        this._contents = _contents;
        this._keys = _keys;
        this._overrides = _overrides;
        this.isFrozen = false;
    }
    Object.defineProperty(ConfigurationModel.prototype, "contents", {
        get: function () {
            return this.checkAndFreeze(this._contents);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigurationModel.prototype, "overrides", {
        get: function () {
            return this.checkAndFreeze(this._overrides);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigurationModel.prototype, "keys", {
        get: function () {
            return this.checkAndFreeze(this._keys);
        },
        enumerable: true,
        configurable: true
    });
    ConfigurationModel.prototype.getValue = function (section) {
        return section ? Object(__WEBPACK_IMPORTED_MODULE_5__configuration_js__["e" /* getConfigurationValue */])(this.contents, section) : this.contents;
    };
    ConfigurationModel.prototype.override = function (identifier) {
        var overrideContents = this.getContentsForOverrideIdentifer(identifier);
        if (!overrideContents || typeof overrideContents !== 'object' || !Object.keys(overrideContents).length) {
            // If there are no valid overrides, return self
            return this;
        }
        var contents = {};
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["d" /* distinct */](Object.keys(this.contents).concat(Object.keys(overrideContents))); _i < _a.length; _i++) {
            var key = _a[_i];
            var contentsForKey = this.contents[key];
            var overrideContentsForKey = overrideContents[key];
            // If there are override contents for the key, clone and merge otherwise use base contents
            if (overrideContentsForKey) {
                // Clone and merge only if base contents and override contents are of type object otherwise just override
                if (typeof contentsForKey === 'object' && typeof overrideContentsForKey === 'object') {
                    contentsForKey = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["c" /* deepClone */](contentsForKey);
                    this.mergeContents(contentsForKey, overrideContentsForKey);
                }
                else {
                    contentsForKey = overrideContentsForKey;
                }
            }
            contents[key] = contentsForKey;
        }
        return new ConfigurationModel(contents);
    };
    ConfigurationModel.prototype.merge = function () {
        var others = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            others[_i] = arguments[_i];
        }
        var contents = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["c" /* deepClone */](this.contents);
        var overrides = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["c" /* deepClone */](this.overrides);
        var keys = this.keys.slice();
        for (var _a = 0, others_1 = others; _a < others_1.length; _a++) {
            var other = others_1[_a];
            this.mergeContents(contents, other.contents);
            var _loop_1 = function (otherOverride) {
                var override = overrides.filter(function (o) { return __WEBPACK_IMPORTED_MODULE_1__base_common_arrays_js__["e" /* equals */](o.identifiers, otherOverride.identifiers); })[0];
                if (override) {
                    this_1.mergeContents(override.contents, otherOverride.contents);
                }
                else {
                    overrides.push(__WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["c" /* deepClone */](otherOverride));
                }
            };
            var this_1 = this;
            for (var _b = 0, _c = other.overrides; _b < _c.length; _b++) {
                var otherOverride = _c[_b];
                _loop_1(otherOverride);
            }
            for (var _d = 0, _e = other.keys; _d < _e.length; _d++) {
                var key = _e[_d];
                if (keys.indexOf(key) === -1) {
                    keys.push(key);
                }
            }
        }
        return new ConfigurationModel(contents, keys, overrides);
    };
    ConfigurationModel.prototype.freeze = function () {
        this.isFrozen = true;
        return this;
    };
    ConfigurationModel.prototype.mergeContents = function (source, target) {
        for (var _i = 0, _a = Object.keys(target); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in source) {
                if (__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["g" /* isObject */](source[key]) && __WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["g" /* isObject */](target[key])) {
                    this.mergeContents(source[key], target[key]);
                    continue;
                }
            }
            source[key] = __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["c" /* deepClone */](target[key]);
        }
    };
    ConfigurationModel.prototype.checkAndFreeze = function (data) {
        if (this.isFrozen && !Object.isFrozen(data)) {
            return __WEBPACK_IMPORTED_MODULE_3__base_common_objects_js__["d" /* deepFreeze */](data);
        }
        return data;
    };
    ConfigurationModel.prototype.getContentsForOverrideIdentifer = function (identifier) {
        for (var _i = 0, _a = this.overrides; _i < _a.length; _i++) {
            var override = _a[_i];
            if (override.identifiers.indexOf(identifier) !== -1) {
                return override.contents;
            }
        }
        return null;
    };
    ConfigurationModel.prototype.toJSON = function () {
        return {
            contents: this.contents,
            overrides: this.overrides,
            keys: this.keys
        };
    };
    // Update methods
    ConfigurationModel.prototype.setValue = function (key, value) {
        this.addKey(key);
        Object(__WEBPACK_IMPORTED_MODULE_5__configuration_js__["c" /* addToValueTree */])(this.contents, key, value, function (e) { throw new Error(e); });
    };
    ConfigurationModel.prototype.removeValue = function (key) {
        if (this.removeKey(key)) {
            Object(__WEBPACK_IMPORTED_MODULE_5__configuration_js__["h" /* removeFromValueTree */])(this.contents, key);
        }
    };
    ConfigurationModel.prototype.addKey = function (key) {
        var index = this.keys.length;
        for (var i = 0; i < index; i++) {
            if (key.indexOf(this.keys[i]) === 0) {
                index = i;
            }
        }
        this.keys.splice(index, 1, key);
    };
    ConfigurationModel.prototype.removeKey = function (key) {
        var index = this.keys.indexOf(key);
        if (index !== -1) {
            this.keys.splice(index, 1);
            return true;
        }
        return false;
    };
    return ConfigurationModel;
}());

var DefaultConfigurationModel = /** @class */ (function (_super) {
    __extends(DefaultConfigurationModel, _super);
    function DefaultConfigurationModel() {
        var _this = this;
        var contents = Object(__WEBPACK_IMPORTED_MODULE_5__configuration_js__["f" /* getDefaultValues */])();
        var keys = Object(__WEBPACK_IMPORTED_MODULE_5__configuration_js__["d" /* getConfigurationKeys */])();
        var overrides = [];
        for (var _i = 0, _a = Object.keys(contents); _i < _a.length; _i++) {
            var key = _a[_i];
            if (__WEBPACK_IMPORTED_MODULE_4__configurationRegistry_js__["c" /* OVERRIDE_PROPERTY_PATTERN */].test(key)) {
                overrides.push({
                    identifiers: [Object(__WEBPACK_IMPORTED_MODULE_5__configuration_js__["g" /* overrideIdentifierFromKey */])(key).trim()],
                    contents: Object(__WEBPACK_IMPORTED_MODULE_5__configuration_js__["i" /* toValuesTree */])(contents[key], function (message) { return console.error("Conflict in default settings file: " + message); })
                });
            }
        }
        _this = _super.call(this, contents, keys, overrides) || this;
        return _this;
    }
    return DefaultConfigurationModel;
}(ConfigurationModel));

var Configuration = /** @class */ (function () {
    function Configuration(_defaultConfiguration, _userConfiguration, _workspaceConfiguration, _folderConfigurations, _memoryConfiguration, _memoryConfigurationByResource, _freeze) {
        if (_workspaceConfiguration === void 0) { _workspaceConfiguration = new ConfigurationModel(); }
        if (_folderConfigurations === void 0) { _folderConfigurations = new __WEBPACK_IMPORTED_MODULE_0__base_common_map_js__["b" /* ResourceMap */](); }
        if (_memoryConfiguration === void 0) { _memoryConfiguration = new ConfigurationModel(); }
        if (_memoryConfigurationByResource === void 0) { _memoryConfigurationByResource = new __WEBPACK_IMPORTED_MODULE_0__base_common_map_js__["b" /* ResourceMap */](); }
        if (_freeze === void 0) { _freeze = true; }
        this._defaultConfiguration = _defaultConfiguration;
        this._userConfiguration = _userConfiguration;
        this._workspaceConfiguration = _workspaceConfiguration;
        this._folderConfigurations = _folderConfigurations;
        this._memoryConfiguration = _memoryConfiguration;
        this._memoryConfigurationByResource = _memoryConfigurationByResource;
        this._freeze = _freeze;
        this._workspaceConsolidatedConfiguration = null;
        this._foldersConsolidatedConfigurations = new __WEBPACK_IMPORTED_MODULE_0__base_common_map_js__["b" /* ResourceMap */]();
    }
    Configuration.prototype.getValue = function (section, overrides, workspace) {
        var consolidateConfigurationModel = this.getConsolidateConfigurationModel(overrides, workspace);
        return consolidateConfigurationModel.getValue(section);
    };
    Configuration.prototype.updateValue = function (key, value, overrides) {
        if (overrides === void 0) { overrides = {}; }
        var memoryConfiguration;
        if (overrides.resource) {
            memoryConfiguration = this._memoryConfigurationByResource.get(overrides.resource);
            if (!memoryConfiguration) {
                memoryConfiguration = new ConfigurationModel();
                this._memoryConfigurationByResource.set(overrides.resource, memoryConfiguration);
            }
        }
        else {
            memoryConfiguration = this._memoryConfiguration;
        }
        if (value === void 0) {
            memoryConfiguration.removeValue(key);
        }
        else {
            memoryConfiguration.setValue(key, value);
        }
        if (!overrides.resource) {
            this._workspaceConsolidatedConfiguration = null;
        }
    };
    Configuration.prototype.getConsolidateConfigurationModel = function (overrides, workspace) {
        var configurationModel = this.getConsolidatedConfigurationModelForResource(overrides, workspace);
        return overrides.overrideIdentifier ? configurationModel.override(overrides.overrideIdentifier) : configurationModel;
    };
    Configuration.prototype.getConsolidatedConfigurationModelForResource = function (_a, workspace) {
        var resource = _a.resource;
        var consolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();
        if (workspace && resource) {
            var root = workspace.getFolder(resource);
            if (root) {
                consolidateConfiguration = this.getFolderConsolidatedConfiguration(root.uri) || consolidateConfiguration;
            }
            var memoryConfigurationForResource = this._memoryConfigurationByResource.get(resource);
            if (memoryConfigurationForResource) {
                consolidateConfiguration = consolidateConfiguration.merge(memoryConfigurationForResource);
            }
        }
        return consolidateConfiguration;
    };
    Configuration.prototype.getWorkspaceConsolidatedConfiguration = function () {
        if (!this._workspaceConsolidatedConfiguration) {
            this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this._userConfiguration, this._workspaceConfiguration, this._memoryConfiguration);
            if (this._freeze) {
                this._workspaceConfiguration = this._workspaceConfiguration.freeze();
            }
        }
        return this._workspaceConsolidatedConfiguration;
    };
    Configuration.prototype.getFolderConsolidatedConfiguration = function (folder) {
        var folderConsolidatedConfiguration = this._foldersConsolidatedConfigurations.get(folder);
        if (!folderConsolidatedConfiguration) {
            var workspaceConsolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();
            var folderConfiguration = this._folderConfigurations.get(folder);
            if (folderConfiguration) {
                folderConsolidatedConfiguration = workspaceConsolidateConfiguration.merge(folderConfiguration);
                if (this._freeze) {
                    folderConsolidatedConfiguration = folderConsolidatedConfiguration.freeze();
                }
                this._foldersConsolidatedConfigurations.set(folder, folderConsolidatedConfiguration);
            }
            else {
                folderConsolidatedConfiguration = workspaceConsolidateConfiguration;
            }
        }
        return folderConsolidatedConfiguration;
    };
    return Configuration;
}());



/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_common_commands_js__ = __webpack_require__(30);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};





var Menu = /** @class */ (function () {
    function Menu(id, startupSignal, _commandService, _contextKeyService) {
        var _this = this;
        this._commandService = _commandService;
        this._contextKeyService = _contextKeyService;
        this._menuGroups = [];
        this._disposables = [];
        this._onDidChange = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        startupSignal.then(function (_) {
            var menuItems = __WEBPACK_IMPORTED_MODULE_3__actions_js__["d" /* MenuRegistry */].getMenuItems(id);
            var keysFilter = new Set();
            var group;
            menuItems.sort(Menu._compareMenuItems);
            for (var _i = 0, menuItems_1 = menuItems; _i < menuItems_1.length; _i++) {
                var item = menuItems_1[_i];
                // group by groupId
                var groupName = item.group;
                if (!group || group[0] !== groupName) {
                    group = [groupName, []];
                    _this._menuGroups.push(group);
                }
                group[1].push(item);
                // keep keys for eventing
                Menu._fillInKbExprKeys(item.when, keysFilter);
            }
            // subscribe to context changes
            _this._disposables.push(_this._contextKeyService.onDidChangeContext(function (event) {
                if (event.affectsSome(keysFilter)) {
                    _this._onDidChange.fire();
                }
            }));
            _this._onDidChange.fire(_this);
        });
    }
    Menu.prototype.dispose = function () {
        this._disposables = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
        this._onDidChange.dispose();
    };
    Menu.prototype.getActions = function (options) {
        var result = [];
        for (var _i = 0, _a = this._menuGroups; _i < _a.length; _i++) {
            var group = _a[_i];
            var id = group[0], items = group[1];
            var activeActions = [];
            for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                var item = items_1[_b];
                if (this._contextKeyService.contextMatchesRules(item.when)) {
                    var action = Object(__WEBPACK_IMPORTED_MODULE_3__actions_js__["f" /* isIMenuItem */])(item) ? new __WEBPACK_IMPORTED_MODULE_3__actions_js__["c" /* MenuItemAction */](item.command, item.alt, options, this._contextKeyService, this._commandService) : new __WEBPACK_IMPORTED_MODULE_3__actions_js__["e" /* SubmenuItemAction */](item);
                    action.order = item.order; //TODO@Ben order is menu item property, not an action property
                    activeActions.push(action);
                }
            }
            if (activeActions.length > 0) {
                result.push([id, activeActions]);
            }
        }
        return result;
    };
    Menu._fillInKbExprKeys = function (exp, set) {
        if (exp) {
            for (var _i = 0, _a = exp.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                set.add(key);
            }
        }
    };
    Menu._compareMenuItems = function (a, b) {
        var aGroup = a.group;
        var bGroup = b.group;
        if (aGroup !== bGroup) {
            // Falsy groups come last
            if (!aGroup) {
                return 1;
            }
            else if (!bGroup) {
                return -1;
            }
            // 'navigation' group comes first
            if (aGroup === 'navigation') {
                return -1;
            }
            else if (bGroup === 'navigation') {
                return 1;
            }
            // lexical sort for groups
            var value = aGroup.localeCompare(bGroup);
            if (value !== 0) {
                return value;
            }
        }
        // sort on priority - default is 0
        var aPrio = a.order || 0;
        var bPrio = b.order || 0;
        if (aPrio < bPrio) {
            return -1;
        }
        else if (aPrio > bPrio) {
            return 1;
        }
        // sort on titles
        var aTitle = typeof a.command.title === 'string' ? a.command.title : a.command.title.value;
        var bTitle = typeof b.command.title === 'string' ? b.command.title : b.command.title.value;
        return aTitle.localeCompare(bTitle);
    };
    Menu = __decorate([
        __param(2, __WEBPACK_IMPORTED_MODULE_4__commands_common_commands_js__["b" /* ICommandService */]),
        __param(3, __WEBPACK_IMPORTED_MODULE_2__contextkey_common_contextkey_js__["e" /* IContextKeyService */])
    ], Menu);
    return Menu;
}());



/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResolvedKeybindingItem; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var ResolvedKeybindingItem = /** @class */ (function () {
    function ResolvedKeybindingItem(resolvedKeybinding, command, commandArgs, when, isDefault) {
        this.resolvedKeybinding = resolvedKeybinding;
        if (resolvedKeybinding) {
            var _a = resolvedKeybinding.getDispatchParts(), keypressFirstPart = _a[0], keypressChordPart = _a[1];
            this.keypressFirstPart = keypressFirstPart;
            this.keypressChordPart = keypressChordPart;
        }
        else {
            this.keypressFirstPart = null;
            this.keypressChordPart = null;
        }
        this.bubble = (command ? command.charCodeAt(0) === 94 /* Caret */ : false);
        this.command = this.bubble ? command.substr(1) : command;
        this.commandArgs = commandArgs;
        this.when = when;
        this.isDefault = isDefault;
    }
    return ResolvedKeybindingItem;
}());



/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiffReview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_diffReview_css__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_diffReview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__media_diffReview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_browser_fastDomNode_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_viewLayout_viewLineRenderer_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_lineTokens_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_configuration_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_browser_ui_scrollbar_scrollableElement_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_browser_ui_actionbar_actionbar_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_common_actions_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__editorExtensions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__platform_contextkey_common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModel_js__ = __webpack_require__(62);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



















var DIFF_LINES_PADDING = 3;
var DiffEntry = /** @class */ (function () {
    function DiffEntry(originalLineStart, originalLineEnd, modifiedLineStart, modifiedLineEnd) {
        this.originalLineStart = originalLineStart;
        this.originalLineEnd = originalLineEnd;
        this.modifiedLineStart = modifiedLineStart;
        this.modifiedLineEnd = modifiedLineEnd;
    }
    DiffEntry.prototype.getType = function () {
        if (this.originalLineStart === 0) {
            return 1 /* Insert */;
        }
        if (this.modifiedLineStart === 0) {
            return 2 /* Delete */;
        }
        return 0 /* Equal */;
    };
    return DiffEntry;
}());
var Diff = /** @class */ (function () {
    function Diff(entries) {
        this.entries = entries;
    }
    return Diff;
}());
var DiffReview = /** @class */ (function (_super) {
    __extends(DiffReview, _super);
    function DiffReview(diffEditor) {
        var _this = _super.call(this) || this;
        _this._width = 0;
        _this._diffEditor = diffEditor;
        _this._isVisible = false;
        _this.shadow = Object(__WEBPACK_IMPORTED_MODULE_4__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.shadow.setClassName('diff-review-shadow');
        _this.actionBarContainer = Object(__WEBPACK_IMPORTED_MODULE_4__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.actionBarContainer.setClassName('diff-review-actions');
        _this._actionBar = _this._register(new __WEBPACK_IMPORTED_MODULE_13__base_browser_ui_actionbar_actionbar_js__["a" /* ActionBar */](_this.actionBarContainer.domNode));
        _this._actionBar.push(new __WEBPACK_IMPORTED_MODULE_14__base_common_actions_js__["a" /* Action */]('diffreview.close', __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('label.close', "Close"), 'close-diff-review', true, function () {
            _this.hide();
            return null;
        }), { label: false, icon: true });
        _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_4__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this.domNode.setClassName('diff-review monaco-editor-background');
        _this._content = Object(__WEBPACK_IMPORTED_MODULE_4__base_browser_fastDomNode_js__["b" /* createFastDomNode */])(document.createElement('div'));
        _this._content.setClassName('diff-review-content');
        _this.scrollbar = _this._register(new __WEBPACK_IMPORTED_MODULE_11__base_browser_ui_scrollbar_scrollableElement_js__["a" /* DomScrollableElement */](_this._content.domNode, {}));
        _this.domNode.domNode.appendChild(_this.scrollbar.getDomNode());
        _this._register(diffEditor.onDidUpdateDiff(function () {
            if (!_this._isVisible) {
                return;
            }
            _this._diffs = _this._compute();
            _this._render();
        }));
        _this._register(diffEditor.getModifiedEditor().onDidChangeCursorPosition(function () {
            if (!_this._isVisible) {
                return;
            }
            _this._render();
        }));
        _this._register(diffEditor.getOriginalEditor().onDidFocusEditorWidget(function () {
            if (_this._isVisible) {
                _this.hide();
            }
        }));
        _this._register(diffEditor.getModifiedEditor().onDidFocusEditorWidget(function () {
            if (_this._isVisible) {
                _this.hide();
            }
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this.domNode.domNode, 'click', function (e) {
            e.preventDefault();
            var row = __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["p" /* findParentWithClass */](e.target, 'diff-review-row');
            if (row) {
                _this._goToRow(row);
            }
        }));
        _this._register(__WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["j" /* addStandardDisposableListener */](_this.domNode.domNode, 'keydown', function (e) {
            if (e.equals(18 /* DownArrow */)
                || e.equals(2048 /* CtrlCmd */ | 18 /* DownArrow */)
                || e.equals(512 /* Alt */ | 18 /* DownArrow */)) {
                e.preventDefault();
                _this._goToRow(_this._getNextRow());
            }
            if (e.equals(16 /* UpArrow */)
                || e.equals(2048 /* CtrlCmd */ | 16 /* UpArrow */)
                || e.equals(512 /* Alt */ | 16 /* UpArrow */)) {
                e.preventDefault();
                _this._goToRow(_this._getPrevRow());
            }
            if (e.equals(9 /* Escape */)
                || e.equals(2048 /* CtrlCmd */ | 9 /* Escape */)
                || e.equals(512 /* Alt */ | 9 /* Escape */)
                || e.equals(1024 /* Shift */ | 9 /* Escape */)) {
                e.preventDefault();
                _this.hide();
            }
            if (e.equals(10 /* Space */)
                || e.equals(3 /* Enter */)) {
                e.preventDefault();
                _this.accept();
            }
        }));
        _this._diffs = [];
        _this._currentDiff = null;
        return _this;
    }
    DiffReview.prototype.prev = function () {
        var index = 0;
        if (!this._isVisible) {
            this._diffs = this._compute();
        }
        if (this._isVisible) {
            var currentIndex = -1;
            for (var i = 0, len = this._diffs.length; i < len; i++) {
                if (this._diffs[i] === this._currentDiff) {
                    currentIndex = i;
                    break;
                }
            }
            index = (this._diffs.length + currentIndex - 1);
        }
        else {
            index = this._findDiffIndex(this._diffEditor.getPosition());
        }
        if (this._diffs.length === 0) {
            // Nothing to do
            return;
        }
        index = index % this._diffs.length;
        this._diffEditor.setPosition(new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](this._diffs[index].entries[0].modifiedLineStart, 1));
        this._isVisible = true;
        this._diffEditor.doLayout();
        this._render();
        this._goToRow(this._getNextRow());
    };
    DiffReview.prototype.next = function () {
        var index = 0;
        if (!this._isVisible) {
            this._diffs = this._compute();
        }
        if (this._isVisible) {
            var currentIndex = -1;
            for (var i = 0, len = this._diffs.length; i < len; i++) {
                if (this._diffs[i] === this._currentDiff) {
                    currentIndex = i;
                    break;
                }
            }
            index = (currentIndex + 1);
        }
        else {
            index = this._findDiffIndex(this._diffEditor.getPosition());
        }
        if (this._diffs.length === 0) {
            // Nothing to do
            return;
        }
        index = index % this._diffs.length;
        this._diffEditor.setPosition(new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](this._diffs[index].entries[0].modifiedLineStart, 1));
        this._isVisible = true;
        this._diffEditor.doLayout();
        this._render();
        this._goToRow(this._getNextRow());
    };
    DiffReview.prototype.accept = function () {
        var jumpToLineNumber = -1;
        var current = this._getCurrentFocusedRow();
        if (current) {
            var lineNumber = parseInt(current.getAttribute('data-line'), 10);
            if (!isNaN(lineNumber)) {
                jumpToLineNumber = lineNumber;
            }
        }
        this.hide();
        if (jumpToLineNumber !== -1) {
            this._diffEditor.setPosition(new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](jumpToLineNumber, 1));
            this._diffEditor.revealPosition(new __WEBPACK_IMPORTED_MODULE_8__common_core_position_js__["a" /* Position */](jumpToLineNumber, 1), 1 /* Immediate */);
        }
    };
    DiffReview.prototype.hide = function () {
        this._isVisible = false;
        this._diffEditor.focus();
        this._diffEditor.doLayout();
        this._render();
    };
    DiffReview.prototype._getPrevRow = function () {
        var current = this._getCurrentFocusedRow();
        if (!current) {
            return this._getFirstRow();
        }
        if (current.previousElementSibling) {
            return current.previousElementSibling;
        }
        return current;
    };
    DiffReview.prototype._getNextRow = function () {
        var current = this._getCurrentFocusedRow();
        if (!current) {
            return this._getFirstRow();
        }
        if (current.nextElementSibling) {
            return current.nextElementSibling;
        }
        return current;
    };
    DiffReview.prototype._getFirstRow = function () {
        return this.domNode.domNode.querySelector('.diff-review-row');
    };
    DiffReview.prototype._getCurrentFocusedRow = function () {
        var result = document.activeElement;
        if (result && /diff-review-row/.test(result.className)) {
            return result;
        }
        return null;
    };
    DiffReview.prototype._goToRow = function (row) {
        var prev = this._getCurrentFocusedRow();
        row.tabIndex = 0;
        row.focus();
        if (prev && prev !== row) {
            prev.tabIndex = -1;
        }
        this.scrollbar.scanDomNode();
    };
    DiffReview.prototype.isVisible = function () {
        return this._isVisible;
    };
    DiffReview.prototype.layout = function (top, width, height) {
        this._width = width;
        this.shadow.setTop(top - 6);
        this.shadow.setWidth(width);
        this.shadow.setHeight(this._isVisible ? 6 : 0);
        this.domNode.setTop(top);
        this.domNode.setWidth(width);
        this.domNode.setHeight(height);
        this._content.setHeight(height);
        this._content.setWidth(width);
        if (this._isVisible) {
            this.actionBarContainer.setAttribute('aria-hidden', 'false');
            this.actionBarContainer.setDisplay('block');
        }
        else {
            this.actionBarContainer.setAttribute('aria-hidden', 'true');
            this.actionBarContainer.setDisplay('none');
        }
    };
    DiffReview.prototype._compute = function () {
        var lineChanges = this._diffEditor.getLineChanges();
        if (!lineChanges || lineChanges.length === 0) {
            return [];
        }
        var originalModel = this._diffEditor.getOriginalEditor().getModel();
        var modifiedModel = this._diffEditor.getModifiedEditor().getModel();
        if (!originalModel || !modifiedModel) {
            return [];
        }
        return DiffReview._mergeAdjacent(lineChanges, originalModel.getLineCount(), modifiedModel.getLineCount());
    };
    DiffReview._mergeAdjacent = function (lineChanges, originalLineCount, modifiedLineCount) {
        if (!lineChanges || lineChanges.length === 0) {
            return [];
        }
        var diffs = [], diffsLength = 0;
        for (var i = 0, len = lineChanges.length; i < len; i++) {
            var lineChange = lineChanges[i];
            var originalStart = lineChange.originalStartLineNumber;
            var originalEnd = lineChange.originalEndLineNumber;
            var modifiedStart = lineChange.modifiedStartLineNumber;
            var modifiedEnd = lineChange.modifiedEndLineNumber;
            var r_1 = [], rLength_1 = 0;
            // Emit before anchors
            {
                var originalEqualAbove = (originalEnd === 0 ? originalStart : originalStart - 1);
                var modifiedEqualAbove = (modifiedEnd === 0 ? modifiedStart : modifiedStart - 1);
                // Make sure we don't step into the previous diff
                var minOriginal = 1;
                var minModified = 1;
                if (i > 0) {
                    var prevLineChange = lineChanges[i - 1];
                    if (prevLineChange.originalEndLineNumber === 0) {
                        minOriginal = prevLineChange.originalStartLineNumber + 1;
                    }
                    else {
                        minOriginal = prevLineChange.originalEndLineNumber + 1;
                    }
                    if (prevLineChange.modifiedEndLineNumber === 0) {
                        minModified = prevLineChange.modifiedStartLineNumber + 1;
                    }
                    else {
                        minModified = prevLineChange.modifiedEndLineNumber + 1;
                    }
                }
                var fromOriginal = originalEqualAbove - DIFF_LINES_PADDING + 1;
                var fromModified = modifiedEqualAbove - DIFF_LINES_PADDING + 1;
                if (fromOriginal < minOriginal) {
                    var delta = minOriginal - fromOriginal;
                    fromOriginal = fromOriginal + delta;
                    fromModified = fromModified + delta;
                }
                if (fromModified < minModified) {
                    var delta = minModified - fromModified;
                    fromOriginal = fromOriginal + delta;
                    fromModified = fromModified + delta;
                }
                r_1[rLength_1++] = new DiffEntry(fromOriginal, originalEqualAbove, fromModified, modifiedEqualAbove);
            }
            // Emit deleted lines
            {
                if (originalEnd !== 0) {
                    r_1[rLength_1++] = new DiffEntry(originalStart, originalEnd, 0, 0);
                }
            }
            // Emit inserted lines
            {
                if (modifiedEnd !== 0) {
                    r_1[rLength_1++] = new DiffEntry(0, 0, modifiedStart, modifiedEnd);
                }
            }
            // Emit after anchors
            {
                var originalEqualBelow = (originalEnd === 0 ? originalStart + 1 : originalEnd + 1);
                var modifiedEqualBelow = (modifiedEnd === 0 ? modifiedStart + 1 : modifiedEnd + 1);
                // Make sure we don't step into the next diff
                var maxOriginal = originalLineCount;
                var maxModified = modifiedLineCount;
                if (i + 1 < len) {
                    var nextLineChange = lineChanges[i + 1];
                    if (nextLineChange.originalEndLineNumber === 0) {
                        maxOriginal = nextLineChange.originalStartLineNumber;
                    }
                    else {
                        maxOriginal = nextLineChange.originalStartLineNumber - 1;
                    }
                    if (nextLineChange.modifiedEndLineNumber === 0) {
                        maxModified = nextLineChange.modifiedStartLineNumber;
                    }
                    else {
                        maxModified = nextLineChange.modifiedStartLineNumber - 1;
                    }
                }
                var toOriginal = originalEqualBelow + DIFF_LINES_PADDING - 1;
                var toModified = modifiedEqualBelow + DIFF_LINES_PADDING - 1;
                if (toOriginal > maxOriginal) {
                    var delta = maxOriginal - toOriginal;
                    toOriginal = toOriginal + delta;
                    toModified = toModified + delta;
                }
                if (toModified > maxModified) {
                    var delta = maxModified - toModified;
                    toOriginal = toOriginal + delta;
                    toModified = toModified + delta;
                }
                r_1[rLength_1++] = new DiffEntry(originalEqualBelow, toOriginal, modifiedEqualBelow, toModified);
            }
            diffs[diffsLength++] = new Diff(r_1);
        }
        // Merge adjacent diffs
        var curr = diffs[0].entries;
        var r = [], rLength = 0;
        for (var i = 1, len = diffs.length; i < len; i++) {
            var thisDiff = diffs[i].entries;
            var currLast = curr[curr.length - 1];
            var thisFirst = thisDiff[0];
            if (currLast.getType() === 0 /* Equal */
                && thisFirst.getType() === 0 /* Equal */
                && thisFirst.originalLineStart <= currLast.originalLineEnd) {
                // We are dealing with equal lines that overlap
                curr[curr.length - 1] = new DiffEntry(currLast.originalLineStart, thisFirst.originalLineEnd, currLast.modifiedLineStart, thisFirst.modifiedLineEnd);
                curr = curr.concat(thisDiff.slice(1));
                continue;
            }
            r[rLength++] = new Diff(curr);
            curr = thisDiff;
        }
        r[rLength++] = new Diff(curr);
        return r;
    };
    DiffReview.prototype._findDiffIndex = function (pos) {
        var lineNumber = pos.lineNumber;
        for (var i = 0, len = this._diffs.length; i < len; i++) {
            var diff = this._diffs[i].entries;
            var lastModifiedLine = diff[diff.length - 1].modifiedLineEnd;
            if (lineNumber <= lastModifiedLine) {
                return i;
            }
        }
        return 0;
    };
    DiffReview.prototype._render = function () {
        var originalOpts = this._diffEditor.getOriginalEditor().getConfiguration();
        var modifiedOpts = this._diffEditor.getModifiedEditor().getConfiguration();
        var originalModel = this._diffEditor.getOriginalEditor().getModel();
        var modifiedModel = this._diffEditor.getModifiedEditor().getModel();
        var originalModelOpts = originalModel.getOptions();
        var modifiedModelOpts = modifiedModel.getOptions();
        if (!this._isVisible || !originalModel || !modifiedModel) {
            __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["l" /* clearNode */](this._content.domNode);
            this._currentDiff = null;
            this.scrollbar.scanDomNode();
            return;
        }
        var pos = this._diffEditor.getPosition();
        var diffIndex = this._findDiffIndex(pos);
        if (this._diffs[diffIndex] === this._currentDiff) {
            return;
        }
        this._currentDiff = this._diffs[diffIndex];
        var diffs = this._diffs[diffIndex].entries;
        var container = document.createElement('div');
        container.className = 'diff-review-table';
        container.setAttribute('role', 'list');
        __WEBPACK_IMPORTED_MODULE_7__config_configuration_js__["a" /* Configuration */].applyFontInfoSlow(container, modifiedOpts.fontInfo);
        var minOriginalLine = 0;
        var maxOriginalLine = 0;
        var minModifiedLine = 0;
        var maxModifiedLine = 0;
        for (var i = 0, len = diffs.length; i < len; i++) {
            var diffEntry = diffs[i];
            var originalLineStart = diffEntry.originalLineStart;
            var originalLineEnd = diffEntry.originalLineEnd;
            var modifiedLineStart = diffEntry.modifiedLineStart;
            var modifiedLineEnd = diffEntry.modifiedLineEnd;
            if (originalLineStart !== 0 && ((minOriginalLine === 0 || originalLineStart < minOriginalLine))) {
                minOriginalLine = originalLineStart;
            }
            if (originalLineEnd !== 0 && ((maxOriginalLine === 0 || originalLineEnd > maxOriginalLine))) {
                maxOriginalLine = originalLineEnd;
            }
            if (modifiedLineStart !== 0 && ((minModifiedLine === 0 || modifiedLineStart < minModifiedLine))) {
                minModifiedLine = modifiedLineStart;
            }
            if (modifiedLineEnd !== 0 && ((maxModifiedLine === 0 || modifiedLineEnd > maxModifiedLine))) {
                maxModifiedLine = modifiedLineEnd;
            }
        }
        var header = document.createElement('div');
        header.className = 'diff-review-row';
        var cell = document.createElement('div');
        cell.className = 'diff-review-cell diff-review-summary';
        var originalChangedLinesCnt = maxOriginalLine - minOriginalLine + 1;
        var modifiedChangedLinesCnt = maxModifiedLine - minModifiedLine + 1;
        cell.appendChild(document.createTextNode(diffIndex + 1 + "/" + this._diffs.length + ": @@ -" + minOriginalLine + "," + originalChangedLinesCnt + " +" + minModifiedLine + "," + modifiedChangedLinesCnt + " @@"));
        header.setAttribute('data-line', String(minModifiedLine));
        var getAriaLines = function (lines) {
            if (lines === 0) {
                return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('no_lines', "no lines");
            }
            else if (lines === 1) {
                return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('one_line', "1 line");
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('more_lines', "{0} lines", lines);
            }
        };
        var originalChangedLinesCntAria = getAriaLines(originalChangedLinesCnt);
        var modifiedChangedLinesCntAria = getAriaLines(modifiedChangedLinesCnt);
        header.setAttribute('aria-label', __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]({
            key: 'header',
            comment: [
                'This is the ARIA label for a git diff header.',
                'A git diff header looks like this: @@ -154,12 +159,39 @@.',
                'That encodes that at original line 154 (which is now line 159), 12 lines were removed/changed with 39 lines.',
                'Variables 0 and 1 refer to the diff index out of total number of diffs.',
                'Variables 2 and 4 will be numbers (a line number).',
                'Variables 3 and 5 will be "no lines", "1 line" or "X lines", localized separately.'
            ]
        }, "Difference {0} of {1}: original {2}, {3}, modified {4}, {5}", (diffIndex + 1), this._diffs.length, minOriginalLine, originalChangedLinesCntAria, minModifiedLine, modifiedChangedLinesCntAria));
        header.appendChild(cell);
        // @@ -504,7 +517,7 @@
        header.setAttribute('role', 'listitem');
        container.appendChild(header);
        var modLine = minModifiedLine;
        for (var i = 0, len = diffs.length; i < len; i++) {
            var diffEntry = diffs[i];
            DiffReview._renderSection(container, diffEntry, modLine, this._width, originalOpts, originalModel, originalModelOpts, modifiedOpts, modifiedModel, modifiedModelOpts);
            if (diffEntry.modifiedLineStart !== 0) {
                modLine = diffEntry.modifiedLineEnd;
            }
        }
        __WEBPACK_IMPORTED_MODULE_3__base_browser_dom_js__["l" /* clearNode */](this._content.domNode);
        this._content.domNode.appendChild(container);
        this.scrollbar.scanDomNode();
    };
    DiffReview._renderSection = function (dest, diffEntry, modLine, width, originalOpts, originalModel, originalModelOpts, modifiedOpts, modifiedModel, modifiedModelOpts) {
        var type = diffEntry.getType();
        var rowClassName = 'diff-review-row';
        var lineNumbersExtraClassName = '';
        var spacerClassName = 'diff-review-spacer';
        switch (type) {
            case 1 /* Insert */:
                rowClassName = 'diff-review-row line-insert';
                lineNumbersExtraClassName = ' char-insert';
                spacerClassName = 'diff-review-spacer insert-sign';
                break;
            case 2 /* Delete */:
                rowClassName = 'diff-review-row line-delete';
                lineNumbersExtraClassName = ' char-delete';
                spacerClassName = 'diff-review-spacer delete-sign';
                break;
        }
        var originalLineStart = diffEntry.originalLineStart;
        var originalLineEnd = diffEntry.originalLineEnd;
        var modifiedLineStart = diffEntry.modifiedLineStart;
        var modifiedLineEnd = diffEntry.modifiedLineEnd;
        var cnt = Math.max(modifiedLineEnd - modifiedLineStart, originalLineEnd - originalLineStart);
        var originalLineNumbersWidth = originalOpts.layoutInfo.glyphMarginWidth + originalOpts.layoutInfo.lineNumbersWidth;
        var modifiedLineNumbersWidth = 10 + modifiedOpts.layoutInfo.glyphMarginWidth + modifiedOpts.layoutInfo.lineNumbersWidth;
        for (var i = 0; i <= cnt; i++) {
            var originalLine = (originalLineStart === 0 ? 0 : originalLineStart + i);
            var modifiedLine = (modifiedLineStart === 0 ? 0 : modifiedLineStart + i);
            var row = document.createElement('div');
            row.style.minWidth = width + 'px';
            row.className = rowClassName;
            row.setAttribute('role', 'listitem');
            if (modifiedLine !== 0) {
                modLine = modifiedLine;
            }
            row.setAttribute('data-line', String(modLine));
            var cell = document.createElement('div');
            cell.className = 'diff-review-cell';
            row.appendChild(cell);
            var originalLineNumber = document.createElement('span');
            originalLineNumber.style.width = (originalLineNumbersWidth + 'px');
            originalLineNumber.style.minWidth = (originalLineNumbersWidth + 'px');
            originalLineNumber.className = 'diff-review-line-number' + lineNumbersExtraClassName;
            if (originalLine !== 0) {
                originalLineNumber.appendChild(document.createTextNode(String(originalLine)));
            }
            else {
                originalLineNumber.innerHTML = '&nbsp;';
            }
            cell.appendChild(originalLineNumber);
            var modifiedLineNumber = document.createElement('span');
            modifiedLineNumber.style.width = (modifiedLineNumbersWidth + 'px');
            modifiedLineNumber.style.minWidth = (modifiedLineNumbersWidth + 'px');
            modifiedLineNumber.style.paddingRight = '10px';
            modifiedLineNumber.className = 'diff-review-line-number' + lineNumbersExtraClassName;
            if (modifiedLine !== 0) {
                modifiedLineNumber.appendChild(document.createTextNode(String(modifiedLine)));
            }
            else {
                modifiedLineNumber.innerHTML = '&nbsp;';
            }
            cell.appendChild(modifiedLineNumber);
            var spacer = document.createElement('span');
            spacer.className = spacerClassName;
            spacer.innerHTML = '&nbsp;&nbsp;';
            cell.appendChild(spacer);
            var lineContent = void 0;
            if (modifiedLine !== 0) {
                cell.insertAdjacentHTML('beforeend', this._renderLine(modifiedModel, modifiedOpts, modifiedModelOpts.tabSize, modifiedLine));
                lineContent = modifiedModel.getLineContent(modifiedLine);
            }
            else {
                cell.insertAdjacentHTML('beforeend', this._renderLine(originalModel, originalOpts, originalModelOpts.tabSize, originalLine));
                lineContent = originalModel.getLineContent(originalLine);
            }
            if (lineContent.length === 0) {
                lineContent = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('blankLine', "blank");
            }
            var ariaLabel = void 0;
            switch (type) {
                case 0 /* Equal */:
                    ariaLabel = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('equalLine', "original {0}, modified {1}: {2}", originalLine, modifiedLine, lineContent);
                    break;
                case 1 /* Insert */:
                    ariaLabel = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('insertLine', "+ modified {0}: {1}", modifiedLine, lineContent);
                    break;
                case 2 /* Delete */:
                    ariaLabel = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('deleteLine', "- original {0}: {1}", originalLine, lineContent);
                    break;
            }
            row.setAttribute('aria-label', ariaLabel);
            dest.appendChild(row);
        }
    };
    DiffReview._renderLine = function (model, config, tabSize, lineNumber) {
        var lineContent = model.getLineContent(lineNumber);
        var defaultMetadata = ((0 /* None */ << 11 /* FONT_STYLE_OFFSET */)
            | (1 /* DefaultForeground */ << 14 /* FOREGROUND_OFFSET */)
            | (2 /* DefaultBackground */ << 23 /* BACKGROUND_OFFSET */)) >>> 0;
        var tokens = new Uint32Array(2);
        tokens[0] = lineContent.length;
        tokens[1] = defaultMetadata;
        var lineTokens = new __WEBPACK_IMPORTED_MODULE_6__common_core_lineTokens_js__["a" /* LineTokens */](tokens, lineContent);
        var isBasicASCII = __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].isBasicASCII(lineContent, model.mightContainNonBasicASCII());
        var containsRTL = __WEBPACK_IMPORTED_MODULE_18__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].containsRTL(lineContent, isBasicASCII, model.mightContainRTL());
        var r = Object(__WEBPACK_IMPORTED_MODULE_5__common_viewLayout_viewLineRenderer_js__["d" /* renderViewLine2 */])(new __WEBPACK_IMPORTED_MODULE_5__common_viewLayout_viewLineRenderer_js__["b" /* RenderLineInput */]((config.fontInfo.isMonospace && !config.viewInfo.disableMonospaceOptimizations), lineContent, false, isBasicASCII, containsRTL, 0, lineTokens, [], tabSize, config.fontInfo.spaceWidth, config.viewInfo.stopRenderingLineAfter, config.viewInfo.renderWhitespace, config.viewInfo.renderControlCharacters, config.viewInfo.fontLigatures));
        return r.html;
    };
    return DiffReview;
}(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["a" /* Disposable */]));

// theming
Object(__WEBPACK_IMPORTED_MODULE_9__platform_theme_common_themeService_js__["e" /* registerThemingParticipant */])(function (theme, collector) {
    var lineNumbers = theme.getColor(__WEBPACK_IMPORTED_MODULE_12__common_view_editorColorRegistry_js__["q" /* editorLineNumbers */]);
    if (lineNumbers) {
        collector.addRule(".monaco-diff-editor .diff-review-line-number { color: " + lineNumbers + "; }");
    }
    var shadow = theme.getColor(__WEBPACK_IMPORTED_MODULE_10__platform_theme_common_colorRegistry_js__["_11" /* scrollbarShadow */]);
    if (shadow) {
        collector.addRule(".monaco-diff-editor .diff-review-shadow { box-shadow: " + shadow + " 0 -6px 6px -6px inset; }");
    }
});
var DiffReviewNext = /** @class */ (function (_super) {
    __extends(DiffReviewNext, _super);
    function DiffReviewNext() {
        return _super.call(this, {
            id: 'editor.action.diffReview.next',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editor.action.diffReview.next', "Go to Next Difference"),
            alias: 'Go to Next Difference',
            precondition: __WEBPACK_IMPORTED_MODULE_16__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].has('isInDiffEditor'),
            kbOpts: {
                kbExpr: null,
                primary: 65 /* F7 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    DiffReviewNext.prototype.run = function (accessor, editor) {
        var diffEditor = findFocusedDiffEditor(accessor);
        if (diffEditor) {
            diffEditor.diffReviewNext();
        }
    };
    return DiffReviewNext;
}(__WEBPACK_IMPORTED_MODULE_15__editorExtensions_js__["b" /* EditorAction */]));
var DiffReviewPrev = /** @class */ (function (_super) {
    __extends(DiffReviewPrev, _super);
    function DiffReviewPrev() {
        return _super.call(this, {
            id: 'editor.action.diffReview.prev',
            label: __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]('editor.action.diffReview.prev', "Go to Previous Difference"),
            alias: 'Go to Previous Difference',
            precondition: __WEBPACK_IMPORTED_MODULE_16__platform_contextkey_common_contextkey_js__["d" /* ContextKeyExpr */].has('isInDiffEditor'),
            kbOpts: {
                kbExpr: null,
                primary: 1024 /* Shift */ | 65 /* F7 */,
                weight: 100 /* EditorContrib */
            }
        }) || this;
    }
    DiffReviewPrev.prototype.run = function (accessor, editor) {
        var diffEditor = findFocusedDiffEditor(accessor);
        if (diffEditor) {
            diffEditor.diffReviewPrev();
        }
    };
    return DiffReviewPrev;
}(__WEBPACK_IMPORTED_MODULE_15__editorExtensions_js__["b" /* EditorAction */]));
function findFocusedDiffEditor(accessor) {
    var codeEditorService = accessor.get(__WEBPACK_IMPORTED_MODULE_17__services_codeEditorService_js__["a" /* ICodeEditorService */]);
    var diffEditors = codeEditorService.listDiffEditors();
    for (var i = 0, len = diffEditors.length; i < len; i++) {
        var diffEditor = diffEditors[i];
        if (diffEditor.hasWidgetFocus()) {
            return diffEditor;
        }
    }
    return null;
}
Object(__WEBPACK_IMPORTED_MODULE_15__editorExtensions_js__["f" /* registerEditorAction */])(DiffReviewNext);
Object(__WEBPACK_IMPORTED_MODULE_15__editorExtensions_js__["f" /* registerEditorAction */])(DiffReviewPrev);


/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextMenuService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextMenuHandler_js__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var ContextMenuService = /** @class */ (function () {
    function ContextMenuService(container, telemetryService, notificationService, contextViewService) {
        this._onDidContextMenu = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.contextMenuHandler = new __WEBPACK_IMPORTED_MODULE_0__contextMenuHandler_js__["a" /* ContextMenuHandler */](container, contextViewService, telemetryService, notificationService);
    }
    ContextMenuService.prototype.dispose = function () {
        this.contextMenuHandler.dispose();
    };
    // ContextMenu
    ContextMenuService.prototype.showContextMenu = function (delegate) {
        this.contextMenuHandler.showContextMenu(delegate);
        this._onDidContextMenu.fire();
    };
    return ContextMenuService;
}());



/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextMenuHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextMenuHandler_css__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextMenuHandler_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__contextMenuHandler_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_browser_builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_browser_mouseEvent_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_actions_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_browser_ui_menu_menu_js__ = __webpack_require__(528);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/







var ContextMenuHandler = /** @class */ (function () {
    function ContextMenuHandler(element, contextViewService, telemetryService, notificationService) {
        this.setContainer(element);
        this.contextViewService = contextViewService;
        this.telemetryService = telemetryService;
        this.notificationService = notificationService;
        this.menuContainerElement = null;
    }
    ContextMenuHandler.prototype.setContainer = function (container) {
        var _this = this;
        if (this.$el) {
            this.$el.off(['click', 'mousedown']);
            this.$el = null;
        }
        if (container) {
            this.$el = Object(__WEBPACK_IMPORTED_MODULE_1__base_browser_builder_js__["a" /* $ */])(container);
            this.$el.on('mousedown', function (e) { return _this.onMouseDown(e); });
        }
    };
    ContextMenuHandler.prototype.showContextMenu = function (delegate) {
        var _this = this;
        delegate.getActions().done(function (actions) {
            if (!actions.length) {
                return; // Don't render an empty context menu
            }
            _this.contextViewService.showContextView({
                getAnchor: function () { return delegate.getAnchor(); },
                canRelayout: false,
                render: function (container) {
                    _this.menuContainerElement = container;
                    var className = delegate.getMenuClassName ? delegate.getMenuClassName() : '';
                    if (className) {
                        container.className += ' ' + className;
                    }
                    var menuDisposables = [];
                    var actionRunner = delegate.actionRunner || new __WEBPACK_IMPORTED_MODULE_4__base_common_actions_js__["b" /* ActionRunner */]();
                    actionRunner.onDidBeforeRun(_this.onActionRun, _this, menuDisposables);
                    actionRunner.onDidRun(_this.onDidActionRun, _this, menuDisposables);
                    var menu = new __WEBPACK_IMPORTED_MODULE_5__base_browser_ui_menu_menu_js__["a" /* Menu */](container, actions, {
                        actionItemProvider: delegate.getActionItem,
                        context: delegate.getActionsContext ? delegate.getActionsContext() : null,
                        actionRunner: actionRunner,
                        getKeyBinding: delegate.getKeyBinding
                    });
                    menu.onDidCancel(function () { return _this.contextViewService.hideContextView(true); }, null, menuDisposables);
                    menu.onDidBlur(function () { return _this.contextViewService.hideContextView(true); }, null, menuDisposables);
                    menu.focus(!!delegate.autoSelectFirstItem);
                    return Object(__WEBPACK_IMPORTED_MODULE_2__base_common_lifecycle_js__["c" /* combinedDisposable */])(menuDisposables.concat([menu]));
                },
                onHide: function (didCancel) {
                    if (delegate.onHide) {
                        delegate.onHide(didCancel);
                    }
                    _this.menuContainerElement = null;
                }
            });
        });
    };
    ContextMenuHandler.prototype.onActionRun = function (e) {
        if (this.telemetryService) {
            /* __GDPR__
                "workbenchActionExecuted" : {
                    "id" : { "classification": "SystemMetaData", "purpose": "FeatureInsight" },
                    "from": { "classification": "SystemMetaData", "purpose": "FeatureInsight" }
                }
            */
            this.telemetryService.publicLog('workbenchActionExecuted', { id: e.action.id, from: 'contextMenu' });
        }
        this.contextViewService.hideContextView(false);
    };
    ContextMenuHandler.prototype.onDidActionRun = function (e) {
        if (e.error && this.notificationService) {
            this.notificationService.error(e.error);
        }
    };
    ContextMenuHandler.prototype.onMouseDown = function (e) {
        if (!this.menuContainerElement) {
            return;
        }
        var event = new __WEBPACK_IMPORTED_MODULE_3__base_browser_mouseEvent_js__["b" /* StandardMouseEvent */](e);
        var element = event.target;
        while (element) {
            if (element === this.menuContainerElement) {
                return;
            }
            element = element.parentElement;
        }
        this.contextViewService.hideContextView();
    };
    ContextMenuHandler.prototype.dispose = function () {
        this.setContainer(null);
    };
    return ContextMenuHandler;
}());



/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubmenuAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_css__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionbar_actionbar_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboardEvent_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__builder_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_async_js__ = __webpack_require__(10);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var SubmenuAction = /** @class */ (function (_super) {
    __extends(SubmenuAction, _super);
    function SubmenuAction(label, entries, cssClass) {
        var _this = _super.call(this, !!cssClass ? cssClass : 'submenu', label, '', true) || this;
        _this.entries = entries;
        return _this;
    }
    return SubmenuAction;
}(__WEBPACK_IMPORTED_MODULE_2__common_actions_js__["a" /* Action */]));

var Menu = /** @class */ (function () {
    function Menu(container, actions, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_4__dom_js__["f" /* addClass */])(container, 'monaco-menu-container');
        container.setAttribute('role', 'presentation');
        var menuContainer = document.createElement('div');
        Object(__WEBPACK_IMPORTED_MODULE_4__dom_js__["f" /* addClass */])(menuContainer, 'monaco-menu');
        menuContainer.setAttribute('role', 'presentation');
        container.appendChild(menuContainer);
        var parentData = {
            parent: this
        };
        this.actionBar = new __WEBPACK_IMPORTED_MODULE_3__actionbar_actionbar_js__["a" /* ActionBar */](menuContainer, {
            orientation: __WEBPACK_IMPORTED_MODULE_3__actionbar_actionbar_js__["c" /* ActionsOrientation */].VERTICAL,
            actionItemProvider: function (action) { return _this.doGetActionItem(action, options, parentData); },
            context: options.context,
            actionRunner: options.actionRunner,
            isMenu: true,
            ariaLabel: options.ariaLabel
        });
        this.actionBar.push(actions, { icon: true, label: true, isMenu: true });
    }
    Menu.prototype.doGetActionItem = function (action, options, parentData) {
        if (action instanceof __WEBPACK_IMPORTED_MODULE_3__actionbar_actionbar_js__["e" /* Separator */]) {
            return new __WEBPACK_IMPORTED_MODULE_3__actionbar_actionbar_js__["b" /* ActionItem */](options.context, action, { icon: true });
        }
        else if (action instanceof SubmenuAction) {
            return new SubmenuActionItem(action, action.entries, parentData, options);
        }
        else {
            var menuItemOptions = {};
            if (options.getKeyBinding) {
                var keybinding = options.getKeyBinding(action);
                if (keybinding) {
                    menuItemOptions.keybinding = keybinding.getLabel();
                }
            }
            return new MenuActionItem(options.context, action, menuItemOptions);
        }
    };
    Object.defineProperty(Menu.prototype, "onDidCancel", {
        get: function () {
            return this.actionBar.onDidCancel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Menu.prototype, "onDidBlur", {
        get: function () {
            return this.actionBar.onDidBlur;
        },
        enumerable: true,
        configurable: true
    });
    Menu.prototype.focus = function (selectFirst) {
        if (selectFirst === void 0) { selectFirst = true; }
        if (this.actionBar) {
            this.actionBar.focus(selectFirst);
        }
    };
    Menu.prototype.dispose = function () {
        if (this.actionBar) {
            this.actionBar.dispose();
            this.actionBar = null;
        }
        if (this.listener) {
            this.listener.dispose();
            this.listener = null;
        }
    };
    return Menu;
}());

var MenuActionItem = /** @class */ (function (_super) {
    __extends(MenuActionItem, _super);
    function MenuActionItem(ctx, action, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options.isMenu = true;
        _this = _super.call(this, action, action, options) || this;
        _this.options = options;
        _this.options.icon = options.icon !== undefined ? options.icon : false;
        _this.options.label = options.label !== undefined ? options.label : true;
        _this.cssClass = '';
        return _this;
    }
    MenuActionItem.prototype.render = function (container) {
        _super.prototype.render.call(this, container);
        this.$e = Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])('a.action-menu-item').appendTo(this.builder);
        if (this._action.id === __WEBPACK_IMPORTED_MODULE_3__actionbar_actionbar_js__["e" /* Separator */].ID) {
            // A separator is a presentation item
            this.$e.attr({ role: 'presentation' });
        }
        else {
            this.$e.attr({ role: 'menuitem' });
        }
        this.$label = Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])('span.action-label').appendTo(this.$e);
        if (this.options.label && this.options.keybinding) {
            Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])('span.keybinding').text(this.options.keybinding).appendTo(this.$e);
        }
        this._updateClass();
        this._updateLabel();
        this._updateTooltip();
        this._updateEnabled();
        this._updateChecked();
    };
    MenuActionItem.prototype._updateLabel = function () {
        if (this.options.label) {
            var label = this.getAction().label;
            if (label) {
                var matches = MenuActionItem.MNEMONIC_REGEX.exec(label);
                if (matches && matches.length === 2) {
                    var mnemonic = matches[1];
                    var ariaLabel = label.replace(MenuActionItem.MNEMONIC_REGEX, mnemonic);
                    this.$e.getHTMLElement().accessKey = mnemonic.toLocaleLowerCase();
                    this.$label.attr('aria-label', ariaLabel);
                }
                else {
                    this.$label.attr('aria-label', label);
                }
                label = label.replace(MenuActionItem.MNEMONIC_REGEX, '$1\u0332');
            }
            this.$label.text(label);
        }
    };
    MenuActionItem.prototype._updateTooltip = function () {
        var title = null;
        if (this.getAction().tooltip) {
            title = this.getAction().tooltip;
        }
        else if (!this.options.label && this.getAction().label && this.options.icon) {
            title = this.getAction().label;
            if (this.options.keybinding) {
                title = __WEBPACK_IMPORTED_MODULE_1__nls_js__["a" /* localize */]({ key: 'titleLabel', comment: ['action title', 'action keybinding'] }, "{0} ({1})", title, this.options.keybinding);
            }
        }
        if (title) {
            this.$e.attr({ title: title });
        }
    };
    MenuActionItem.prototype._updateClass = function () {
        if (this.cssClass) {
            this.$e.removeClass(this.cssClass);
        }
        if (this.options.icon) {
            this.cssClass = this.getAction().class;
            this.$label.addClass('icon');
            if (this.cssClass) {
                this.$label.addClass(this.cssClass);
            }
            this._updateEnabled();
        }
        else {
            this.$label.removeClass('icon');
        }
    };
    MenuActionItem.prototype._updateEnabled = function () {
        if (this.getAction().enabled) {
            this.builder.removeClass('disabled');
            this.$e.removeClass('disabled');
            this.$e.attr({ tabindex: 0 });
        }
        else {
            this.builder.addClass('disabled');
            this.$e.addClass('disabled');
            Object(__WEBPACK_IMPORTED_MODULE_4__dom_js__["H" /* removeTabIndexAndUpdateFocus */])(this.$e.getHTMLElement());
        }
    };
    MenuActionItem.prototype._updateChecked = function () {
        if (this.getAction().checked) {
            this.$label.addClass('checked');
        }
        else {
            this.$label.removeClass('checked');
        }
    };
    MenuActionItem.MNEMONIC_REGEX = /&&(.)/g;
    return MenuActionItem;
}(__WEBPACK_IMPORTED_MODULE_3__actionbar_actionbar_js__["d" /* BaseActionItem */]));
var SubmenuActionItem = /** @class */ (function (_super) {
    __extends(SubmenuActionItem, _super);
    function SubmenuActionItem(action, submenuActions, parentData, submenuOptions) {
        var _this = _super.call(this, action, action, { label: true, isMenu: true }) || this;
        _this.submenuActions = submenuActions;
        _this.parentData = parentData;
        _this.submenuOptions = submenuOptions;
        _this.showScheduler = new __WEBPACK_IMPORTED_MODULE_7__common_async_js__["c" /* RunOnceScheduler */](function () {
            if (_this.mouseOver) {
                _this.cleanupExistingSubmenu(false);
                _this.createSubmenu(false);
            }
        }, 250);
        _this.hideScheduler = new __WEBPACK_IMPORTED_MODULE_7__common_async_js__["c" /* RunOnceScheduler */](function () {
            if ((!Object(__WEBPACK_IMPORTED_MODULE_4__dom_js__["B" /* isAncestor */])(document.activeElement, _this.builder.getHTMLElement()) && _this.parentData.submenu === _this.mysubmenu)) {
                _this.parentData.parent.focus(false);
                _this.cleanupExistingSubmenu(true);
            }
        }, 750);
        return _this;
    }
    SubmenuActionItem.prototype.render = function (container) {
        var _this = this;
        _super.prototype.render.call(this, container);
        this.$e.addClass('monaco-submenu-item');
        this.$e.attr('aria-haspopup', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])('span.submenu-indicator').text('\u25B6').appendTo(this.$e);
        Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.builder).on(__WEBPACK_IMPORTED_MODULE_4__dom_js__["d" /* EventType */].KEY_UP, function (e) {
            var event = new __WEBPACK_IMPORTED_MODULE_5__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
            if (event.equals(17 /* RightArrow */)) {
                __WEBPACK_IMPORTED_MODULE_4__dom_js__["c" /* EventHelper */].stop(e, true);
                _this.createSubmenu(true);
            }
        });
        Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.builder).on(__WEBPACK_IMPORTED_MODULE_4__dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
            var event = new __WEBPACK_IMPORTED_MODULE_5__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
            if (event.equals(17 /* RightArrow */)) {
                __WEBPACK_IMPORTED_MODULE_4__dom_js__["c" /* EventHelper */].stop(e, true);
            }
        });
        Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.builder).on(__WEBPACK_IMPORTED_MODULE_4__dom_js__["d" /* EventType */].MOUSE_OVER, function (e) {
            if (!_this.mouseOver) {
                _this.mouseOver = true;
                _this.showScheduler.schedule();
            }
        });
        Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.builder).on(__WEBPACK_IMPORTED_MODULE_4__dom_js__["d" /* EventType */].MOUSE_LEAVE, function (e) {
            _this.mouseOver = false;
        });
        Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.builder).on(__WEBPACK_IMPORTED_MODULE_4__dom_js__["d" /* EventType */].FOCUS_OUT, function (e) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_4__dom_js__["B" /* isAncestor */])(document.activeElement, _this.builder.getHTMLElement())) {
                _this.hideScheduler.schedule();
            }
        });
    };
    SubmenuActionItem.prototype.onClick = function (e) {
        // stop clicking from trying to run an action
        __WEBPACK_IMPORTED_MODULE_4__dom_js__["c" /* EventHelper */].stop(e, true);
        this.createSubmenu(false);
    };
    SubmenuActionItem.prototype.cleanupExistingSubmenu = function (force) {
        if (this.parentData.submenu && (force || (this.parentData.submenu !== this.mysubmenu))) {
            this.parentData.submenu.dispose();
            this.parentData.submenu = null;
            if (this.submenuContainer) {
                this.submenuContainer.dispose();
                this.submenuContainer = null;
            }
        }
    };
    SubmenuActionItem.prototype.createSubmenu = function (selectFirstItem) {
        var _this = this;
        if (selectFirstItem === void 0) { selectFirstItem = true; }
        if (!this.parentData.submenu) {
            this.submenuContainer = Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.builder).div({ class: 'monaco-submenu menubar-menu-items-holder context-view' });
            Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.submenuContainer).style({
                'left': Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.builder).getClientArea().width + "px"
            });
            Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.submenuContainer).on(__WEBPACK_IMPORTED_MODULE_4__dom_js__["d" /* EventType */].KEY_UP, function (e) {
                var event = new __WEBPACK_IMPORTED_MODULE_5__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
                if (event.equals(15 /* LeftArrow */)) {
                    __WEBPACK_IMPORTED_MODULE_4__dom_js__["c" /* EventHelper */].stop(e, true);
                    _this.parentData.parent.focus();
                    _this.parentData.submenu.dispose();
                    _this.parentData.submenu = null;
                    _this.submenuContainer.dispose();
                    _this.submenuContainer = null;
                }
            });
            Object(__WEBPACK_IMPORTED_MODULE_6__builder_js__["a" /* $ */])(this.submenuContainer).on(__WEBPACK_IMPORTED_MODULE_4__dom_js__["d" /* EventType */].KEY_DOWN, function (e) {
                var event = new __WEBPACK_IMPORTED_MODULE_5__keyboardEvent_js__["a" /* StandardKeyboardEvent */](e);
                if (event.equals(15 /* LeftArrow */)) {
                    __WEBPACK_IMPORTED_MODULE_4__dom_js__["c" /* EventHelper */].stop(e, true);
                }
            });
            this.parentData.submenu = new Menu(this.submenuContainer.getHTMLElement(), this.submenuActions, this.submenuOptions);
            this.parentData.submenu.focus(selectFirstItem);
            this.mysubmenu = this.parentData.submenu;
        }
        else {
            this.parentData.submenu.focus(false);
        }
    };
    SubmenuActionItem.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.hideScheduler.dispose();
        if (this.mysubmenu) {
            this.mysubmenu.dispose();
            this.mysubmenu = null;
        }
        if (this.submenuContainer) {
            this.submenuContainer.dispose();
            this.submenuContainer = null;
        }
    };
    return SubmenuActionItem;
}(MenuActionItem));


/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextViewService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_ui_contextview_contextview_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__telemetry_common_telemetry_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log_common_log_js__ = __webpack_require__(182);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var ContextViewService = /** @class */ (function () {
    function ContextViewService(container, telemetryService, logService) {
        this.logService = logService;
        this.contextView = new __WEBPACK_IMPORTED_MODULE_0__base_browser_ui_contextview_contextview_js__["b" /* ContextView */](container);
    }
    ContextViewService.prototype.dispose = function () {
        this.contextView.dispose();
    };
    // ContextView
    ContextViewService.prototype.setContainer = function (container) {
        this.logService.trace('ContextViewService#setContainer');
        this.contextView.setContainer(container);
    };
    ContextViewService.prototype.showContextView = function (delegate) {
        this.logService.trace('ContextViewService#showContextView');
        this.contextView.show(delegate);
    };
    ContextViewService.prototype.layout = function () {
        this.contextView.layout();
    };
    ContextViewService.prototype.hideContextView = function (data) {
        this.logService.trace('ContextViewService#hideContextView');
        this.contextView.hide(data);
    };
    ContextViewService = __decorate([
        __param(1, __WEBPACK_IMPORTED_MODULE_1__telemetry_common_telemetry_js__["a" /* ITelemetryService */]),
        __param(2, __WEBPACK_IMPORTED_MODULE_2__log_common_log_js__["a" /* ILogService */])
    ], ContextViewService);
    return ContextViewService;
}());



/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstantiationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_assert_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_graph_js__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descriptors_js__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__serviceCollection_js__ = __webpack_require__(105);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








var InstantiationService = /** @class */ (function () {
    function InstantiationService(services, strict) {
        if (services === void 0) { services = new __WEBPACK_IMPORTED_MODULE_6__serviceCollection_js__["a" /* ServiceCollection */](); }
        if (strict === void 0) { strict = false; }
        this._services = services;
        this._strict = strict;
        this._services.set(__WEBPACK_IMPORTED_MODULE_5__instantiation_js__["a" /* IInstantiationService */], this);
    }
    InstantiationService.prototype.createChild = function (services) {
        var _this = this;
        this._services.forEach(function (id, thing) {
            if (services.has(id)) {
                return;
            }
            // If we copy descriptors we might end up with
            // multiple instances of the same service
            if (thing instanceof __WEBPACK_IMPORTED_MODULE_4__descriptors_js__["a" /* SyncDescriptor */]) {
                thing = _this._createAndCacheServiceInstance(id, thing);
            }
            services.set(id, thing);
        });
        return new InstantiationService(services, this._strict);
    };
    InstantiationService.prototype.invokeFunction = function (signature) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var accessor;
        try {
            accessor = {
                get: function (id, isOptional) {
                    var result = _this._getOrCreateServiceInstance(id);
                    if (!result && isOptional !== __WEBPACK_IMPORTED_MODULE_5__instantiation_js__["d" /* optional */]) {
                        throw new Error("[invokeFunction] unknown service '" + id + "'");
                    }
                    return result;
                }
            };
            return signature.apply(undefined, [accessor].concat(args));
        }
        finally {
            accessor.get = function () {
                throw Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["c" /* illegalState */])('service accessor is only valid during the invocation of its target method');
            };
        }
    };
    InstantiationService.prototype.createInstance = function (param) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        if (param instanceof __WEBPACK_IMPORTED_MODULE_4__descriptors_js__["a" /* SyncDescriptor */]) {
            // sync
            return this._createInstance(param, rest);
        }
        else {
            // sync, just ctor
            return this._createInstance(new __WEBPACK_IMPORTED_MODULE_4__descriptors_js__["a" /* SyncDescriptor */](param), rest);
        }
    };
    InstantiationService.prototype._createInstance = function (desc, args) {
        // arguments given by createInstance-call and/or the descriptor
        var staticArgs = desc.staticArguments.concat(args);
        // arguments defined by service decorators
        var serviceDependencies = __WEBPACK_IMPORTED_MODULE_5__instantiation_js__["b" /* _util */].getServiceDependencies(desc.ctor).sort(function (a, b) { return a.index - b.index; });
        var serviceArgs = [];
        for (var _i = 0, serviceDependencies_1 = serviceDependencies; _i < serviceDependencies_1.length; _i++) {
            var dependency = serviceDependencies_1[_i];
            var service = this._getOrCreateServiceInstance(dependency.id);
            if (!service && this._strict && !dependency.optional) {
                throw new Error("[createInstance] " + desc.ctor.name + " depends on UNKNOWN service " + dependency.id + ".");
            }
            serviceArgs.push(service);
        }
        var firstServiceArgPos = serviceDependencies.length > 0 ? serviceDependencies[0].index : staticArgs.length;
        // check for argument mismatches, adjust static args if needed
        if (staticArgs.length !== firstServiceArgPos) {
            console.warn("[createInstance] First service dependency of " + desc.ctor.name + " at position " + (firstServiceArgPos + 1) + " conflicts with " + staticArgs.length + " static arguments");
            var delta = firstServiceArgPos - staticArgs.length;
            if (delta > 0) {
                staticArgs = staticArgs.concat(new Array(delta));
            }
            else {
                staticArgs = staticArgs.slice(0, firstServiceArgPos);
            }
        }
        // // check for missing args
        // for (let i = 0; i < serviceArgs.length; i++) {
        // 	if (!serviceArgs[i]) {
        // 		console.warn(`${desc.ctor.name} MISSES service dependency ${serviceDependencies[i].id}`, new Error().stack);
        // 	}
        // }
        // now create the instance
        var argArray = [desc.ctor];
        argArray.push.apply(argArray, staticArgs);
        argArray.push.apply(argArray, serviceArgs);
        return __WEBPACK_IMPORTED_MODULE_1__base_common_types_js__["a" /* create */].apply(null, argArray);
    };
    InstantiationService.prototype._getOrCreateServiceInstance = function (id) {
        var thing = this._services.get(id);
        if (thing instanceof __WEBPACK_IMPORTED_MODULE_4__descriptors_js__["a" /* SyncDescriptor */]) {
            return this._createAndCacheServiceInstance(id, thing);
        }
        else {
            return thing;
        }
    };
    InstantiationService.prototype._createAndCacheServiceInstance = function (id, desc) {
        __WEBPACK_IMPORTED_MODULE_2__base_common_assert_js__["a" /* ok */](this._services.get(id) instanceof __WEBPACK_IMPORTED_MODULE_4__descriptors_js__["a" /* SyncDescriptor */]);
        var graph = new __WEBPACK_IMPORTED_MODULE_3__base_common_graph_js__["a" /* Graph */](function (data) { return data.id.toString(); });
        function throwCycleError() {
            var err = new Error('[createInstance] cyclic dependency between services');
            err.message = graph.toString();
            throw err;
        }
        var count = 0;
        var stack = [{ id: id, desc: desc }];
        while (stack.length) {
            var item = stack.pop();
            graph.lookupOrInsertNode(item);
            // TODO@joh use the graph to find a cycle
            // a weak heuristic for cycle checks
            if (count++ > 100) {
                throwCycleError();
            }
            // check all dependencies for existence and if the need to be created first
            var dependencies = __WEBPACK_IMPORTED_MODULE_5__instantiation_js__["b" /* _util */].getServiceDependencies(item.desc.ctor);
            for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
                var dependency = dependencies_1[_i];
                var instanceOrDesc = this._services.get(dependency.id);
                if (!instanceOrDesc) {
                    console.warn("[createInstance] " + id + " depends on " + dependency.id + " which is NOT registered.");
                }
                if (instanceOrDesc instanceof __WEBPACK_IMPORTED_MODULE_4__descriptors_js__["a" /* SyncDescriptor */]) {
                    var d = { id: dependency.id, desc: instanceOrDesc };
                    graph.insertEdge(item, d);
                    stack.push(d);
                }
            }
        }
        while (true) {
            var roots = graph.roots();
            // if there is no more roots but still
            // nodes in the graph we have a cycle
            if (roots.length === 0) {
                if (graph.length !== 0) {
                    throwCycleError();
                }
                break;
            }
            for (var _a = 0, roots_1 = roots; _a < roots_1.length; _a++) {
                var root = roots_1[_a];
                // create instance and overwrite the service collections
                var instance = this._createInstance(root.data.desc, []);
                this._services.set(root.data.id, instance);
                graph.removeNode(root.data);
            }
        }
        return this._services.get(id);
    };
    return InstantiationService;
}());



/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Graph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collections_js__ = __webpack_require__(533);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



function newNode(data) {
    return {
        data: data,
        incoming: Object.create(null),
        outgoing: Object.create(null)
    };
}
var Graph = /** @class */ (function () {
    function Graph(_hashFn) {
        this._hashFn = _hashFn;
        this._nodes = Object.create(null);
        // empty
    }
    Graph.prototype.roots = function () {
        var ret = [];
        Object(__WEBPACK_IMPORTED_MODULE_1__collections_js__["a" /* forEach */])(this._nodes, function (entry) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__types_js__["d" /* isEmptyObject */])(entry.value.outgoing)) {
                ret.push(entry.value);
            }
        });
        return ret;
    };
    Graph.prototype.insertEdge = function (from, to) {
        var fromNode = this.lookupOrInsertNode(from), toNode = this.lookupOrInsertNode(to);
        fromNode.outgoing[this._hashFn(to)] = toNode;
        toNode.incoming[this._hashFn(from)] = fromNode;
    };
    Graph.prototype.removeNode = function (data) {
        var key = this._hashFn(data);
        delete this._nodes[key];
        Object(__WEBPACK_IMPORTED_MODULE_1__collections_js__["a" /* forEach */])(this._nodes, function (entry) {
            delete entry.value.outgoing[key];
            delete entry.value.incoming[key];
        });
    };
    Graph.prototype.lookupOrInsertNode = function (data) {
        var key = this._hashFn(data);
        var node = this._nodes[key];
        if (!node) {
            node = newNode(data);
            this._nodes[key] = node;
        }
        return node;
    };
    Object.defineProperty(Graph.prototype, "length", {
        get: function () {
            return Object.keys(this._nodes).length;
        },
        enumerable: true,
        configurable: true
    });
    Graph.prototype.toString = function () {
        var data = [];
        Object(__WEBPACK_IMPORTED_MODULE_1__collections_js__["a" /* forEach */])(this._nodes, function (entry) {
            data.push(entry.key + ", (incoming)[" + Object.keys(entry.value.incoming).join(', ') + "], (outgoing)[" + Object.keys(entry.value.outgoing).join(',') + "]");
        });
        return data.join('\n');
    };
    return Graph;
}());



/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forEach;
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Iterates over each entry in the provided set. The iterator allows
 * to remove elements and will stop when the callback returns {{false}}.
 */
function forEach(from, callback) {
    var _loop_1 = function (key) {
        if (hasOwnProperty.call(from, key)) {
            var result = callback({ key: key, value: from[key] }, function () {
                delete from[key];
            });
            if (result === false) {
                return { value: void 0 };
            }
        }
    };
    for (var key in from) {
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object")
            return state_1.value;
    }
}


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncDescriptor; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var SyncDescriptor = /** @class */ (function () {
    function SyncDescriptor(ctor) {
        var _staticArguments = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _staticArguments[_i - 1] = arguments[_i];
        }
        this.ctor = ctor;
        this.staticArguments = _staticArguments;
    }
    return SyncDescriptor;
}());



/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_types_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__markers_js__ = __webpack_require__(68);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var MapMap;
(function (MapMap) {
    function get(map, key1, key2) {
        if (map[key1]) {
            return map[key1][key2];
        }
        return undefined;
    }
    MapMap.get = get;
    function set(map, key1, key2, value) {
        if (!map[key1]) {
            map[key1] = Object.create(null);
        }
        map[key1][key2] = value;
    }
    MapMap.set = set;
    function remove(map, key1, key2) {
        if (map[key1] && map[key1][key2]) {
            delete map[key1][key2];
            if (Object(__WEBPACK_IMPORTED_MODULE_2__base_common_types_js__["d" /* isEmptyObject */])(map[key1])) {
                delete map[key1];
            }
            return true;
        }
        return false;
    }
    MapMap.remove = remove;
})(MapMap || (MapMap = {}));
var MarkerStats = /** @class */ (function () {
    function MarkerStats(service) {
        this.errors = 0;
        this.infos = 0;
        this.warnings = 0;
        this.unknowns = 0;
        this._data = Object.create(null);
        this._service = service;
        this._subscription = service.onMarkerChanged(this._update, this);
    }
    MarkerStats.prototype.dispose = function () {
        this._subscription.dispose();
        this._data = undefined;
    };
    MarkerStats.prototype._update = function (resources) {
        for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
            var resource = resources_1[_i];
            var key = resource.toString();
            var oldStats = this._data[key];
            if (oldStats) {
                this._substract(oldStats);
            }
            var newStats = this._resourceStats(resource);
            this._add(newStats);
            this._data[key] = newStats;
        }
    };
    MarkerStats.prototype._resourceStats = function (resource) {
        var result = { errors: 0, warnings: 0, infos: 0, unknowns: 0 };
        // TODO this is a hack
        if (resource.scheme === __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__["a" /* Schemas */].inMemory || resource.scheme === __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__["a" /* Schemas */].walkThrough || resource.scheme === __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__["a" /* Schemas */].walkThroughSnippet) {
            return result;
        }
        for (var _i = 0, _a = this._service.read({ resource: resource }); _i < _a.length; _i++) {
            var severity = _a[_i].severity;
            if (severity === __WEBPACK_IMPORTED_MODULE_4__markers_js__["b" /* MarkerSeverity */].Error) {
                result.errors += 1;
            }
            else if (severity === __WEBPACK_IMPORTED_MODULE_4__markers_js__["b" /* MarkerSeverity */].Warning) {
                result.warnings += 1;
            }
            else if (severity === __WEBPACK_IMPORTED_MODULE_4__markers_js__["b" /* MarkerSeverity */].Info) {
                result.infos += 1;
            }
            else {
                result.unknowns += 1;
            }
        }
        return result;
    };
    MarkerStats.prototype._substract = function (op) {
        this.errors -= op.errors;
        this.warnings -= op.warnings;
        this.infos -= op.infos;
        this.unknowns -= op.unknowns;
    };
    MarkerStats.prototype._add = function (op) {
        this.errors += op.errors;
        this.warnings += op.warnings;
        this.infos += op.infos;
        this.unknowns += op.unknowns;
    };
    return MarkerStats;
}());
var MarkerService = /** @class */ (function () {
    function MarkerService() {
        this._onMarkerChanged = new __WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["a" /* Emitter */]();
        this._onMarkerChangedEvent = Object(__WEBPACK_IMPORTED_MODULE_3__base_common_event_js__["h" /* debounceEvent */])(this._onMarkerChanged.event, MarkerService._debouncer, 0);
        this._byResource = Object.create(null);
        this._byOwner = Object.create(null);
        this._stats = new MarkerStats(this);
    }
    MarkerService.prototype.dispose = function () {
        this._stats.dispose();
    };
    Object.defineProperty(MarkerService.prototype, "onMarkerChanged", {
        get: function () {
            return this._onMarkerChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    MarkerService.prototype.remove = function (owner, resources) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(resources)) {
            for (var _i = 0, resources_2 = resources; _i < resources_2.length; _i++) {
                var resource = resources_2[_i];
                this.changeOne(owner, resource, undefined);
            }
        }
    };
    MarkerService.prototype.changeOne = function (owner, resource, markerData) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(markerData)) {
            // remove marker for this (owner,resource)-tuple
            var a = MapMap.remove(this._byResource, resource.toString(), owner);
            var b = MapMap.remove(this._byOwner, owner, resource.toString());
            if (a !== b) {
                throw new Error('invalid marker service state');
            }
            if (a && b) {
                this._onMarkerChanged.fire([resource]);
            }
        }
        else {
            // insert marker for this (owner,resource)-tuple
            var markers = [];
            for (var _i = 0, markerData_1 = markerData; _i < markerData_1.length; _i++) {
                var data = markerData_1[_i];
                var marker = MarkerService._toMarker(owner, resource, data);
                if (marker) {
                    markers.push(marker);
                }
            }
            MapMap.set(this._byResource, resource.toString(), owner, markers);
            MapMap.set(this._byOwner, owner, resource.toString(), markers);
            this._onMarkerChanged.fire([resource]);
        }
    };
    MarkerService._toMarker = function (owner, resource, data) {
        var code = data.code, severity = data.severity, message = data.message, source = data.source, startLineNumber = data.startLineNumber, startColumn = data.startColumn, endLineNumber = data.endLineNumber, endColumn = data.endColumn, relatedInformation = data.relatedInformation, tags = data.tags;
        if (!message) {
            return undefined;
        }
        // santize data
        code = code || null;
        startLineNumber = startLineNumber > 0 ? startLineNumber : 1;
        startColumn = startColumn > 0 ? startColumn : 1;
        endLineNumber = endLineNumber >= startLineNumber ? endLineNumber : startLineNumber;
        endColumn = endColumn > 0 ? endColumn : startColumn;
        return {
            resource: resource,
            owner: owner,
            code: code,
            severity: severity,
            message: message,
            source: source,
            startLineNumber: startLineNumber,
            startColumn: startColumn,
            endLineNumber: endLineNumber,
            endColumn: endColumn,
            relatedInformation: relatedInformation,
            tags: tags,
        };
    };
    MarkerService.prototype.read = function (filter) {
        if (filter === void 0) { filter = Object.create(null); }
        var owner = filter.owner, resource = filter.resource, severities = filter.severities, take = filter.take;
        if (!take || take < 0) {
            take = -1;
        }
        if (owner && resource) {
            // exactly one owner AND resource
            var data = MapMap.get(this._byResource, resource.toString(), owner);
            if (!data) {
                return [];
            }
            else {
                var result = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var marker = data_1[_i];
                    if (MarkerService._accept(marker, severities)) {
                        var newLen = result.push(marker);
                        if (take > 0 && newLen === take) {
                            break;
                        }
                    }
                }
                return result;
            }
        }
        else if (!owner && !resource) {
            // all
            var result = [];
            for (var key1 in this._byResource) {
                for (var key2 in this._byResource[key1]) {
                    for (var _a = 0, _b = this._byResource[key1][key2]; _a < _b.length; _a++) {
                        var data = _b[_a];
                        if (MarkerService._accept(data, severities)) {
                            var newLen = result.push(data);
                            if (take > 0 && newLen === take) {
                                return result;
                            }
                        }
                    }
                }
            }
            return result;
        }
        else {
            // of one resource OR owner
            var map = owner
                ? this._byOwner[owner]
                : this._byResource[resource.toString()];
            if (!map) {
                return [];
            }
            var result = [];
            for (var key in map) {
                for (var _c = 0, _d = map[key]; _c < _d.length; _c++) {
                    var data = _d[_c];
                    if (MarkerService._accept(data, severities)) {
                        var newLen = result.push(data);
                        if (take > 0 && newLen === take) {
                            return result;
                        }
                    }
                }
            }
            return result;
        }
    };
    MarkerService._accept = function (marker, severities) {
        return severities === void 0 || (severities & marker.severity) === marker.severity;
    };
    MarkerService._debouncer = function (last, event) {
        if (!last) {
            MarkerService._dedupeMap = Object.create(null);
            last = [];
        }
        for (var _i = 0, event_1 = event; _i < event_1.length; _i++) {
            var uri = event_1[_i];
            if (MarkerService._dedupeMap[uri.toString()] === void 0) {
                MarkerService._dedupeMap[uri.toString()] = true;
                last.push(uri);
            }
        }
        return last;
    };
    return MarkerService;
}());



/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultWorkerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_worker_simpleWorker_js__ = __webpack_require__(291);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



function getWorker(workerId, label) {
    // Option for hosts to overwrite the worker script (used in the standalone editor)
    if (__WEBPACK_IMPORTED_MODULE_0__common_platform_js__["b" /* globals */].MonacoEnvironment) {
        if (typeof __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["b" /* globals */].MonacoEnvironment.getWorker === 'function') {
            return __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["b" /* globals */].MonacoEnvironment.getWorker(workerId, label);
        }
        if (typeof __WEBPACK_IMPORTED_MODULE_0__common_platform_js__["b" /* globals */].MonacoEnvironment.getWorkerUrl === 'function') {
            return new Worker(__WEBPACK_IMPORTED_MODULE_0__common_platform_js__["b" /* globals */].MonacoEnvironment.getWorkerUrl(workerId, label));
        }
    }
    // ESM-comment-begin
    // 	if (typeof require === 'function') {
    // 		return new Worker(require.toUrl('./' + workerId) + '#' + label);
    // 	}
    // ESM-comment-end
    throw new Error("You must define a function MonacoEnvironment.getWorkerUrl or MonacoEnvironment.getWorker");
}
/**
 * A worker that uses HTML5 web workers so that is has
 * its own global scope and its own thread.
 */
var WebWorker = /** @class */ (function () {
    function WebWorker(moduleId, id, label, onMessageCallback, onErrorCallback) {
        this.id = id;
        this.worker = getWorker('workerMain.js', label);
        this.postMessage(moduleId);
        this.worker.onmessage = function (ev) {
            onMessageCallback(ev.data);
        };
        if (typeof this.worker.addEventListener === 'function') {
            this.worker.addEventListener('error', onErrorCallback);
        }
    }
    WebWorker.prototype.getId = function () {
        return this.id;
    };
    WebWorker.prototype.postMessage = function (msg) {
        if (this.worker) {
            this.worker.postMessage(msg);
        }
    };
    WebWorker.prototype.dispose = function () {
        this.worker.terminate();
        this.worker = null;
    };
    return WebWorker;
}());
var DefaultWorkerFactory = /** @class */ (function () {
    function DefaultWorkerFactory(label) {
        this._label = label;
        this._webWorkerFailedBeforeError = false;
    }
    DefaultWorkerFactory.prototype.create = function (moduleId, onMessageCallback, onErrorCallback) {
        var _this = this;
        var workerId = (++DefaultWorkerFactory.LAST_WORKER_ID);
        if (this._webWorkerFailedBeforeError) {
            throw this._webWorkerFailedBeforeError;
        }
        return new WebWorker(moduleId, workerId, this._label || 'anonymous' + workerId, onMessageCallback, function (err) {
            Object(__WEBPACK_IMPORTED_MODULE_1__common_worker_simpleWorker_js__["b" /* logOnceWebWorkerWarning */])(err);
            _this._webWorkerFailedBeforeError = err;
            onErrorCallback(err);
        });
    };
    DefaultWorkerFactory.LAST_WORKER_ID = 0;
    return DefaultWorkerFactory;
}());



/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BaseEditorSimpleWorker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorSimpleWorkerImpl; });
/* unused harmony export create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__diff_diffComputer_js__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_diff_diff_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_mirrorTextModel_js__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modes_linkComputer_js__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modes_supports_inplaceReplaceSupport_js__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_wordHelper_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__standalone_standaloneBase_js__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_common_platform_js__ = __webpack_require__(14);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












/**
 * @internal
 */
var MirrorModel = /** @class */ (function (_super) {
    __extends(MirrorModel, _super);
    function MirrorModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MirrorModel.prototype, "uri", {
        get: function () {
            return this._uri;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MirrorModel.prototype, "version", {
        get: function () {
            return this._versionId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MirrorModel.prototype, "eol", {
        get: function () {
            return this._eol;
        },
        enumerable: true,
        configurable: true
    });
    MirrorModel.prototype.getValue = function () {
        return this.getText();
    };
    MirrorModel.prototype.getLinesContent = function () {
        return this._lines.slice(0);
    };
    MirrorModel.prototype.getLineCount = function () {
        return this._lines.length;
    };
    MirrorModel.prototype.getLineContent = function (lineNumber) {
        return this._lines[lineNumber - 1];
    };
    MirrorModel.prototype.getWordAtPosition = function (position, wordDefinition) {
        var wordAtText = Object(__WEBPACK_IMPORTED_MODULE_9__model_wordHelper_js__["d" /* getWordAtText */])(position.column, Object(__WEBPACK_IMPORTED_MODULE_9__model_wordHelper_js__["c" /* ensureValidWordDefinition */])(wordDefinition), this._lines[position.lineNumber - 1], 0);
        if (wordAtText) {
            return new __WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */](position.lineNumber, wordAtText.startColumn, position.lineNumber, wordAtText.endColumn);
        }
        return null;
    };
    MirrorModel.prototype.getWordUntilPosition = function (position, wordDefinition) {
        var wordAtPosition = this.getWordAtPosition(position, wordDefinition);
        if (!wordAtPosition) {
            return {
                word: '',
                startColumn: position.column,
                endColumn: position.column
            };
        }
        return {
            word: this._lines[position.lineNumber - 1].substring(wordAtPosition.startColumn - 1, position.column - 1),
            startColumn: wordAtPosition.startColumn,
            endColumn: position.column
        };
    };
    MirrorModel.prototype.createWordIterator = function (wordDefinition) {
        var _this = this;
        var obj = {
            done: false,
            value: ''
        };
        var lineNumber = 0;
        var lineText;
        var wordRangesIdx = 0;
        var wordRanges = [];
        var next = function () {
            if (wordRangesIdx < wordRanges.length) {
                obj.done = false;
                obj.value = lineText.substring(wordRanges[wordRangesIdx].start, wordRanges[wordRangesIdx].end);
                wordRangesIdx += 1;
            }
            else if (lineNumber >= _this._lines.length) {
                obj.done = true;
                obj.value = undefined;
            }
            else {
                lineText = _this._lines[lineNumber];
                wordRanges = _this._wordenize(lineText, wordDefinition);
                wordRangesIdx = 0;
                lineNumber += 1;
                return next();
            }
            return obj;
        };
        return { next: next };
    };
    MirrorModel.prototype._wordenize = function (content, wordDefinition) {
        var result = [];
        var match;
        wordDefinition.lastIndex = 0; // reset lastIndex just to be sure
        while (match = wordDefinition.exec(content)) {
            if (match[0].length === 0) {
                // it did match the empty string
                break;
            }
            result.push({ start: match.index, end: match.index + match[0].length });
        }
        return result;
    };
    MirrorModel.prototype.getValueInRange = function (range) {
        range = this._validateRange(range);
        if (range.startLineNumber === range.endLineNumber) {
            return this._lines[range.startLineNumber - 1].substring(range.startColumn - 1, range.endColumn - 1);
        }
        var lineEnding = this._eol;
        var startLineIndex = range.startLineNumber - 1;
        var endLineIndex = range.endLineNumber - 1;
        var resultLines = [];
        resultLines.push(this._lines[startLineIndex].substring(range.startColumn - 1));
        for (var i = startLineIndex + 1; i < endLineIndex; i++) {
            resultLines.push(this._lines[i]);
        }
        resultLines.push(this._lines[endLineIndex].substring(0, range.endColumn - 1));
        return resultLines.join(lineEnding);
    };
    MirrorModel.prototype.offsetAt = function (position) {
        position = this._validatePosition(position);
        this._ensureLineStarts();
        return this._lineStarts.getAccumulatedValue(position.lineNumber - 2) + (position.column - 1);
    };
    MirrorModel.prototype.positionAt = function (offset) {
        offset = Math.floor(offset);
        offset = Math.max(0, offset);
        this._ensureLineStarts();
        var out = this._lineStarts.getIndexOf(offset);
        var lineLength = this._lines[out.index].length;
        // Ensure we return a valid position
        return {
            lineNumber: 1 + out.index,
            column: 1 + Math.min(out.remainder, lineLength)
        };
    };
    MirrorModel.prototype._validateRange = function (range) {
        var start = this._validatePosition({ lineNumber: range.startLineNumber, column: range.startColumn });
        var end = this._validatePosition({ lineNumber: range.endLineNumber, column: range.endColumn });
        if (start.lineNumber !== range.startLineNumber
            || start.column !== range.startColumn
            || end.lineNumber !== range.endLineNumber
            || end.column !== range.endColumn) {
            return {
                startLineNumber: start.lineNumber,
                startColumn: start.column,
                endLineNumber: end.lineNumber,
                endColumn: end.column
            };
        }
        return range;
    };
    MirrorModel.prototype._validatePosition = function (position) {
        if (!__WEBPACK_IMPORTED_MODULE_5__core_position_js__["a" /* Position */].isIPosition(position)) {
            throw new Error('bad position');
        }
        var lineNumber = position.lineNumber, column = position.column;
        var hasChanged = false;
        if (lineNumber < 1) {
            lineNumber = 1;
            column = 1;
            hasChanged = true;
        }
        else if (lineNumber > this._lines.length) {
            lineNumber = this._lines.length;
            column = this._lines[lineNumber - 1].length + 1;
            hasChanged = true;
        }
        else {
            var maxCharacter = this._lines[lineNumber - 1].length + 1;
            if (column < 1) {
                column = 1;
                hasChanged = true;
            }
            else if (column > maxCharacter) {
                column = maxCharacter;
                hasChanged = true;
            }
        }
        if (!hasChanged) {
            return position;
        }
        else {
            return { lineNumber: lineNumber, column: column };
        }
    };
    return MirrorModel;
}(__WEBPACK_IMPORTED_MODULE_6__model_mirrorTextModel_js__["a" /* MirrorTextModel */]));
/**
 * @internal
 */
var BaseEditorSimpleWorker = /** @class */ (function () {
    function BaseEditorSimpleWorker(foreignModuleFactory) {
        this._foreignModuleFactory = foreignModuleFactory;
        this._foreignModule = null;
    }
    // ---- BEGIN diff --------------------------------------------------------------------------
    BaseEditorSimpleWorker.prototype.computeDiff = function (originalUrl, modifiedUrl, ignoreTrimWhitespace) {
        var original = this._getModel(originalUrl);
        var modified = this._getModel(modifiedUrl);
        if (!original || !modified) {
            return null;
        }
        var originalLines = original.getLinesContent();
        var modifiedLines = modified.getLinesContent();
        var diffComputer = new __WEBPACK_IMPORTED_MODULE_3__diff_diffComputer_js__["a" /* DiffComputer */](originalLines, modifiedLines, {
            shouldComputeCharChanges: true,
            shouldPostProcessCharChanges: true,
            shouldIgnoreTrimWhitespace: ignoreTrimWhitespace,
            shouldMakePrettyDiff: true
        });
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(diffComputer.computeDiff());
    };
    BaseEditorSimpleWorker.prototype.computeMoreMinimalEdits = function (modelUrl, edits) {
        var model = this._getModel(modelUrl);
        if (!model) {
            return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(edits);
        }
        var result = [];
        var lastEol;
        for (var _i = 0, edits_1 = edits; _i < edits_1.length; _i++) {
            var _a = edits_1[_i], range = _a.range, text = _a.text, eol = _a.eol;
            if (typeof eol === 'number') {
                lastEol = eol;
            }
            if (!range) {
                // eol-change only
                continue;
            }
            var original = model.getValueInRange(range);
            text = text.replace(/\r\n|\n|\r/g, model.eol);
            if (original === text) {
                // noop
                continue;
            }
            // make sure diff won't take too long
            if (Math.max(text.length, original.length) > BaseEditorSimpleWorker._diffLimit) {
                result.push({ range: range, text: text });
                continue;
            }
            // compute diff between original and edit.text
            var changes = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_diff_diff_js__["b" /* stringDiff */])(original, text, false);
            var editOffset = model.offsetAt(__WEBPACK_IMPORTED_MODULE_2__core_range_js__["a" /* Range */].lift(range).getStartPosition());
            for (var _b = 0, changes_1 = changes; _b < changes_1.length; _b++) {
                var change = changes_1[_b];
                var start = model.positionAt(editOffset + change.originalStart);
                var end = model.positionAt(editOffset + change.originalStart + change.originalLength);
                var newEdit = {
                    text: text.substr(change.modifiedStart, change.modifiedLength),
                    range: { startLineNumber: start.lineNumber, startColumn: start.column, endLineNumber: end.lineNumber, endColumn: end.column }
                };
                if (model.getValueInRange(newEdit.range) !== newEdit.text) {
                    result.push(newEdit);
                }
            }
        }
        if (typeof lastEol === 'number') {
            result.push({ eol: lastEol, text: undefined, range: undefined });
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(result);
    };
    // ---- END minimal edits ---------------------------------------------------------------
    BaseEditorSimpleWorker.prototype.computeLinks = function (modelUrl) {
        var model = this._getModel(modelUrl);
        if (!model) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(Object(__WEBPACK_IMPORTED_MODULE_7__modes_linkComputer_js__["a" /* computeLinks */])(model));
    };
    BaseEditorSimpleWorker.prototype.textualSuggest = function (modelUrl, position, wordDef, wordDefFlags) {
        var model = this._getModel(modelUrl);
        if (model) {
            var suggestions = [];
            var wordDefRegExp = new RegExp(wordDef, wordDefFlags);
            var currentWord = model.getWordUntilPosition(position, wordDefRegExp).word;
            var seen = Object.create(null);
            seen[currentWord] = true;
            for (var iter = model.createWordIterator(wordDefRegExp), e = iter.next(); !e.done && suggestions.length <= BaseEditorSimpleWorker._suggestionsLimit; e = iter.next()) {
                var word = e.value;
                if (seen[word]) {
                    continue;
                }
                seen[word] = true;
                if (!isNaN(Number(word))) {
                    continue;
                }
                suggestions.push({
                    type: 'text',
                    label: word,
                    insertText: word,
                    noAutoAccept: true,
                    overwriteBefore: currentWord.length
                });
            }
            return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as({ suggestions: suggestions });
        }
        return undefined;
    };
    // ---- END suggest --------------------------------------------------------------------------
    BaseEditorSimpleWorker.prototype.navigateValueSet = function (modelUrl, range, up, wordDef, wordDefFlags) {
        var model = this._getModel(modelUrl);
        if (!model) {
            return null;
        }
        var wordDefRegExp = new RegExp(wordDef, wordDefFlags);
        if (range.startColumn === range.endColumn) {
            range = {
                startLineNumber: range.startLineNumber,
                startColumn: range.startColumn,
                endLineNumber: range.endLineNumber,
                endColumn: range.endColumn + 1
            };
        }
        var selectionText = model.getValueInRange(range);
        var wordRange = model.getWordAtPosition({ lineNumber: range.startLineNumber, column: range.startColumn }, wordDefRegExp);
        var word = null;
        if (wordRange !== null) {
            word = model.getValueInRange(wordRange);
        }
        var result = __WEBPACK_IMPORTED_MODULE_8__modes_supports_inplaceReplaceSupport_js__["a" /* BasicInplaceReplace */].INSTANCE.navigateValueSet(range, selectionText, wordRange, word, up);
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(result);
    };
    // ---- BEGIN foreign module support --------------------------------------------------------------------------
    BaseEditorSimpleWorker.prototype.loadForeignModule = function (moduleId, createData) {
        var _this = this;
        var ctx = {
            getMirrorModels: function () {
                return _this._getModels();
            }
        };
        if (this._foreignModuleFactory) {
            this._foreignModule = this._foreignModuleFactory(ctx, createData);
            // static foreing module
            var methods = [];
            for (var prop in this._foreignModule) {
                if (typeof this._foreignModule[prop] === 'function') {
                    methods.push(prop);
                }
            }
            return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(methods);
        }
        // ESM-comment-begin
        // 		return new TPromise<any>((c, e) => {
        // 			require([moduleId], (foreignModule: { create: IForeignModuleFactory }) => {
        // 				this._foreignModule = foreignModule.create(ctx, createData);
        // 
        // 				let methods: string[] = [];
        // 				for (let prop in this._foreignModule) {
        // 					if (typeof this._foreignModule[prop] === 'function') {
        // 						methods.push(prop);
        // 					}
        // 				}
        // 
        // 				c(methods);
        // 
        // 			}, e);
        // 		});
        // ESM-comment-end
        // ESM-uncomment-begin
        return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error("Unexpected usage"));
        // ESM-uncomment-end
    };
    // foreign method request
    BaseEditorSimpleWorker.prototype.fmr = function (method, args) {
        if (!this._foreignModule || typeof this._foreignModule[method] !== 'function') {
            return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].wrapError(new Error('Missing requestHandler or method: ' + method));
        }
        try {
            return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].as(this._foreignModule[method].apply(this._foreignModule, args));
        }
        catch (e) {
            return __WEBPACK_IMPORTED_MODULE_1__base_common_winjs_base_js__["b" /* TPromise */].wrapError(e);
        }
    };
    // ---- END diff --------------------------------------------------------------------------
    // ---- BEGIN minimal edits ---------------------------------------------------------------
    BaseEditorSimpleWorker._diffLimit = 10000;
    // ---- BEGIN suggest --------------------------------------------------------------------------
    BaseEditorSimpleWorker._suggestionsLimit = 10000;
    return BaseEditorSimpleWorker;
}());

/**
 * @internal
 */
var EditorSimpleWorkerImpl = /** @class */ (function (_super) {
    __extends(EditorSimpleWorkerImpl, _super);
    function EditorSimpleWorkerImpl(foreignModuleFactory) {
        var _this = _super.call(this, foreignModuleFactory) || this;
        _this._models = Object.create(null);
        return _this;
    }
    EditorSimpleWorkerImpl.prototype.dispose = function () {
        this._models = Object.create(null);
    };
    EditorSimpleWorkerImpl.prototype._getModel = function (uri) {
        return this._models[uri];
    };
    EditorSimpleWorkerImpl.prototype._getModels = function () {
        var _this = this;
        var all = [];
        Object.keys(this._models).forEach(function (key) { return all.push(_this._models[key]); });
        return all;
    };
    EditorSimpleWorkerImpl.prototype.acceptNewModel = function (data) {
        this._models[data.url] = new MirrorModel(__WEBPACK_IMPORTED_MODULE_0__base_common_uri_js__["a" /* default */].parse(data.url), data.lines, data.EOL, data.versionId);
    };
    EditorSimpleWorkerImpl.prototype.acceptModelChanged = function (strURL, e) {
        if (!this._models[strURL]) {
            return;
        }
        var model = this._models[strURL];
        model.onEvents(e);
    };
    EditorSimpleWorkerImpl.prototype.acceptRemovedModel = function (strURL) {
        if (!this._models[strURL]) {
            return;
        }
        delete this._models[strURL];
    };
    return EditorSimpleWorkerImpl;
}(BaseEditorSimpleWorker));

/**
 * Called on the worker side
 * @internal
 */
function create() {
    return new EditorSimpleWorkerImpl(null);
}
if (typeof importScripts === 'function') {
    // Running in a web worker
    __WEBPACK_IMPORTED_MODULE_11__base_common_platform_js__["b" /* globals */].monaco = Object(__WEBPACK_IMPORTED_MODULE_10__standalone_standaloneBase_js__["a" /* createMonacoBaseAPI */])();
}


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiffComputer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_diff_diff_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__ = __webpack_require__(3);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var MAXIMUM_RUN_TIME = 5000; // 5 seconds
var MINIMUM_MATCHING_CHARACTER_LENGTH = 3;
function computeDiff(originalSequence, modifiedSequence, continueProcessingPredicate, pretty) {
    var diffAlgo = new __WEBPACK_IMPORTED_MODULE_0__base_common_diff_diff_js__["a" /* LcsDiff */](originalSequence, modifiedSequence, continueProcessingPredicate);
    return diffAlgo.ComputeDiff(pretty);
}
var LineMarkerSequence = /** @class */ (function () {
    function LineMarkerSequence(lines) {
        var startColumns = [];
        var endColumns = [];
        for (var i = 0, length_1 = lines.length; i < length_1; i++) {
            startColumns[i] = LineMarkerSequence._getFirstNonBlankColumn(lines[i], 1);
            endColumns[i] = LineMarkerSequence._getLastNonBlankColumn(lines[i], 1);
        }
        this._lines = lines;
        this._startColumns = startColumns;
        this._endColumns = endColumns;
    }
    LineMarkerSequence.prototype.getLength = function () {
        return this._lines.length;
    };
    LineMarkerSequence.prototype.getElementAtIndex = function (i) {
        return this._lines[i].substring(this._startColumns[i] - 1, this._endColumns[i] - 1);
    };
    LineMarkerSequence.prototype.getStartLineNumber = function (i) {
        return i + 1;
    };
    LineMarkerSequence.prototype.getEndLineNumber = function (i) {
        return i + 1;
    };
    LineMarkerSequence._getFirstNonBlankColumn = function (txt, defaultValue) {
        var r = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["firstNonWhitespaceIndex"](txt);
        if (r === -1) {
            return defaultValue;
        }
        return r + 1;
    };
    LineMarkerSequence._getLastNonBlankColumn = function (txt, defaultValue) {
        var r = __WEBPACK_IMPORTED_MODULE_1__base_common_strings_js__["lastNonWhitespaceIndex"](txt);
        if (r === -1) {
            return defaultValue;
        }
        return r + 2;
    };
    LineMarkerSequence.prototype.getCharSequence = function (shouldIgnoreTrimWhitespace, startIndex, endIndex) {
        var charCodes = [];
        var lineNumbers = [];
        var columns = [];
        var len = 0;
        for (var index = startIndex; index <= endIndex; index++) {
            var lineContent = this._lines[index];
            var startColumn = (shouldIgnoreTrimWhitespace ? this._startColumns[index] : 1);
            var endColumn = (shouldIgnoreTrimWhitespace ? this._endColumns[index] : lineContent.length + 1);
            for (var col = startColumn; col < endColumn; col++) {
                charCodes[len] = lineContent.charCodeAt(col - 1);
                lineNumbers[len] = index + 1;
                columns[len] = col;
                len++;
            }
        }
        return new CharSequence(charCodes, lineNumbers, columns);
    };
    return LineMarkerSequence;
}());
var CharSequence = /** @class */ (function () {
    function CharSequence(charCodes, lineNumbers, columns) {
        this._charCodes = charCodes;
        this._lineNumbers = lineNumbers;
        this._columns = columns;
    }
    CharSequence.prototype.getLength = function () {
        return this._charCodes.length;
    };
    CharSequence.prototype.getElementAtIndex = function (i) {
        return this._charCodes[i];
    };
    CharSequence.prototype.getStartLineNumber = function (i) {
        return this._lineNumbers[i];
    };
    CharSequence.prototype.getStartColumn = function (i) {
        return this._columns[i];
    };
    CharSequence.prototype.getEndLineNumber = function (i) {
        return this._lineNumbers[i];
    };
    CharSequence.prototype.getEndColumn = function (i) {
        return this._columns[i] + 1;
    };
    return CharSequence;
}());
var CharChange = /** @class */ (function () {
    function CharChange(originalStartLineNumber, originalStartColumn, originalEndLineNumber, originalEndColumn, modifiedStartLineNumber, modifiedStartColumn, modifiedEndLineNumber, modifiedEndColumn) {
        this.originalStartLineNumber = originalStartLineNumber;
        this.originalStartColumn = originalStartColumn;
        this.originalEndLineNumber = originalEndLineNumber;
        this.originalEndColumn = originalEndColumn;
        this.modifiedStartLineNumber = modifiedStartLineNumber;
        this.modifiedStartColumn = modifiedStartColumn;
        this.modifiedEndLineNumber = modifiedEndLineNumber;
        this.modifiedEndColumn = modifiedEndColumn;
    }
    CharChange.createFromDiffChange = function (diffChange, originalCharSequence, modifiedCharSequence) {
        var originalStartLineNumber;
        var originalStartColumn;
        var originalEndLineNumber;
        var originalEndColumn;
        var modifiedStartLineNumber;
        var modifiedStartColumn;
        var modifiedEndLineNumber;
        var modifiedEndColumn;
        if (diffChange.originalLength === 0) {
            originalStartLineNumber = 0;
            originalStartColumn = 0;
            originalEndLineNumber = 0;
            originalEndColumn = 0;
        }
        else {
            originalStartLineNumber = originalCharSequence.getStartLineNumber(diffChange.originalStart);
            originalStartColumn = originalCharSequence.getStartColumn(diffChange.originalStart);
            originalEndLineNumber = originalCharSequence.getEndLineNumber(diffChange.originalStart + diffChange.originalLength - 1);
            originalEndColumn = originalCharSequence.getEndColumn(diffChange.originalStart + diffChange.originalLength - 1);
        }
        if (diffChange.modifiedLength === 0) {
            modifiedStartLineNumber = 0;
            modifiedStartColumn = 0;
            modifiedEndLineNumber = 0;
            modifiedEndColumn = 0;
        }
        else {
            modifiedStartLineNumber = modifiedCharSequence.getStartLineNumber(diffChange.modifiedStart);
            modifiedStartColumn = modifiedCharSequence.getStartColumn(diffChange.modifiedStart);
            modifiedEndLineNumber = modifiedCharSequence.getEndLineNumber(diffChange.modifiedStart + diffChange.modifiedLength - 1);
            modifiedEndColumn = modifiedCharSequence.getEndColumn(diffChange.modifiedStart + diffChange.modifiedLength - 1);
        }
        return new CharChange(originalStartLineNumber, originalStartColumn, originalEndLineNumber, originalEndColumn, modifiedStartLineNumber, modifiedStartColumn, modifiedEndLineNumber, modifiedEndColumn);
    };
    return CharChange;
}());
function postProcessCharChanges(rawChanges) {
    if (rawChanges.length <= 1) {
        return rawChanges;
    }
    var result = [rawChanges[0]];
    var prevChange = result[0];
    for (var i = 1, len = rawChanges.length; i < len; i++) {
        var currChange = rawChanges[i];
        var originalMatchingLength = currChange.originalStart - (prevChange.originalStart + prevChange.originalLength);
        var modifiedMatchingLength = currChange.modifiedStart - (prevChange.modifiedStart + prevChange.modifiedLength);
        // Both of the above should be equal, but the continueProcessingPredicate may prevent this from being true
        var matchingLength = Math.min(originalMatchingLength, modifiedMatchingLength);
        if (matchingLength < MINIMUM_MATCHING_CHARACTER_LENGTH) {
            // Merge the current change into the previous one
            prevChange.originalLength = (currChange.originalStart + currChange.originalLength) - prevChange.originalStart;
            prevChange.modifiedLength = (currChange.modifiedStart + currChange.modifiedLength) - prevChange.modifiedStart;
        }
        else {
            // Add the current change
            result.push(currChange);
            prevChange = currChange;
        }
    }
    return result;
}
var LineChange = /** @class */ (function () {
    function LineChange(originalStartLineNumber, originalEndLineNumber, modifiedStartLineNumber, modifiedEndLineNumber, charChanges) {
        this.originalStartLineNumber = originalStartLineNumber;
        this.originalEndLineNumber = originalEndLineNumber;
        this.modifiedStartLineNumber = modifiedStartLineNumber;
        this.modifiedEndLineNumber = modifiedEndLineNumber;
        this.charChanges = charChanges;
    }
    LineChange.createFromDiffResult = function (shouldIgnoreTrimWhitespace, diffChange, originalLineSequence, modifiedLineSequence, continueProcessingPredicate, shouldComputeCharChanges, shouldPostProcessCharChanges) {
        var originalStartLineNumber;
        var originalEndLineNumber;
        var modifiedStartLineNumber;
        var modifiedEndLineNumber;
        var charChanges;
        if (diffChange.originalLength === 0) {
            originalStartLineNumber = originalLineSequence.getStartLineNumber(diffChange.originalStart) - 1;
            originalEndLineNumber = 0;
        }
        else {
            originalStartLineNumber = originalLineSequence.getStartLineNumber(diffChange.originalStart);
            originalEndLineNumber = originalLineSequence.getEndLineNumber(diffChange.originalStart + diffChange.originalLength - 1);
        }
        if (diffChange.modifiedLength === 0) {
            modifiedStartLineNumber = modifiedLineSequence.getStartLineNumber(diffChange.modifiedStart) - 1;
            modifiedEndLineNumber = 0;
        }
        else {
            modifiedStartLineNumber = modifiedLineSequence.getStartLineNumber(diffChange.modifiedStart);
            modifiedEndLineNumber = modifiedLineSequence.getEndLineNumber(diffChange.modifiedStart + diffChange.modifiedLength - 1);
        }
        if (shouldComputeCharChanges && diffChange.originalLength !== 0 && diffChange.modifiedLength !== 0 && continueProcessingPredicate()) {
            var originalCharSequence = originalLineSequence.getCharSequence(shouldIgnoreTrimWhitespace, diffChange.originalStart, diffChange.originalStart + diffChange.originalLength - 1);
            var modifiedCharSequence = modifiedLineSequence.getCharSequence(shouldIgnoreTrimWhitespace, diffChange.modifiedStart, diffChange.modifiedStart + diffChange.modifiedLength - 1);
            var rawChanges = computeDiff(originalCharSequence, modifiedCharSequence, continueProcessingPredicate, true);
            if (shouldPostProcessCharChanges) {
                rawChanges = postProcessCharChanges(rawChanges);
            }
            charChanges = [];
            for (var i = 0, length_2 = rawChanges.length; i < length_2; i++) {
                charChanges.push(CharChange.createFromDiffChange(rawChanges[i], originalCharSequence, modifiedCharSequence));
            }
        }
        return new LineChange(originalStartLineNumber, originalEndLineNumber, modifiedStartLineNumber, modifiedEndLineNumber, charChanges);
    };
    return LineChange;
}());
var DiffComputer = /** @class */ (function () {
    function DiffComputer(originalLines, modifiedLines, opts) {
        this.shouldComputeCharChanges = opts.shouldComputeCharChanges;
        this.shouldPostProcessCharChanges = opts.shouldPostProcessCharChanges;
        this.shouldIgnoreTrimWhitespace = opts.shouldIgnoreTrimWhitespace;
        this.shouldMakePrettyDiff = opts.shouldMakePrettyDiff;
        this.maximumRunTimeMs = MAXIMUM_RUN_TIME;
        this.originalLines = originalLines;
        this.modifiedLines = modifiedLines;
        this.original = new LineMarkerSequence(originalLines);
        this.modified = new LineMarkerSequence(modifiedLines);
    }
    DiffComputer.prototype.computeDiff = function () {
        if (this.original.getLength() === 1 && this.original.getElementAtIndex(0).length === 0) {
            // empty original => fast path
            return [{
                    originalStartLineNumber: 1,
                    originalEndLineNumber: 1,
                    modifiedStartLineNumber: 1,
                    modifiedEndLineNumber: this.modified.getLength(),
                    charChanges: [{
                            modifiedEndColumn: 0,
                            modifiedEndLineNumber: 0,
                            modifiedStartColumn: 0,
                            modifiedStartLineNumber: 0,
                            originalEndColumn: 0,
                            originalEndLineNumber: 0,
                            originalStartColumn: 0,
                            originalStartLineNumber: 0
                        }]
                }];
        }
        if (this.modified.getLength() === 1 && this.modified.getElementAtIndex(0).length === 0) {
            // empty modified => fast path
            return [{
                    originalStartLineNumber: 1,
                    originalEndLineNumber: this.original.getLength(),
                    modifiedStartLineNumber: 1,
                    modifiedEndLineNumber: 1,
                    charChanges: [{
                            modifiedEndColumn: 0,
                            modifiedEndLineNumber: 0,
                            modifiedStartColumn: 0,
                            modifiedStartLineNumber: 0,
                            originalEndColumn: 0,
                            originalEndLineNumber: 0,
                            originalStartColumn: 0,
                            originalStartLineNumber: 0
                        }]
                }];
        }
        this.computationStartTime = (new Date()).getTime();
        var rawChanges = computeDiff(this.original, this.modified, this._continueProcessingPredicate.bind(this), this.shouldMakePrettyDiff);
        // The diff is always computed with ignoring trim whitespace
        // This ensures we get the prettiest diff
        if (this.shouldIgnoreTrimWhitespace) {
            var lineChanges = [];
            for (var i = 0, length_3 = rawChanges.length; i < length_3; i++) {
                lineChanges.push(LineChange.createFromDiffResult(this.shouldIgnoreTrimWhitespace, rawChanges[i], this.original, this.modified, this._continueProcessingPredicate.bind(this), this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
            }
            return lineChanges;
        }
        // Need to post-process and introduce changes where the trim whitespace is different
        // Note that we are looping starting at -1 to also cover the lines before the first change
        var result = [];
        var originalLineIndex = 0;
        var modifiedLineIndex = 0;
        for (var i = -1 /* !!!! */, len = rawChanges.length; i < len; i++) {
            var nextChange = (i + 1 < len ? rawChanges[i + 1] : null);
            var originalStop = (nextChange ? nextChange.originalStart : this.originalLines.length);
            var modifiedStop = (nextChange ? nextChange.modifiedStart : this.modifiedLines.length);
            while (originalLineIndex < originalStop && modifiedLineIndex < modifiedStop) {
                var originalLine = this.originalLines[originalLineIndex];
                var modifiedLine = this.modifiedLines[modifiedLineIndex];
                if (originalLine !== modifiedLine) {
                    // These lines differ only in trim whitespace
                    // Check the leading whitespace
                    {
                        var originalStartColumn = LineMarkerSequence._getFirstNonBlankColumn(originalLine, 1);
                        var modifiedStartColumn = LineMarkerSequence._getFirstNonBlankColumn(modifiedLine, 1);
                        while (originalStartColumn > 1 && modifiedStartColumn > 1) {
                            var originalChar = originalLine.charCodeAt(originalStartColumn - 2);
                            var modifiedChar = modifiedLine.charCodeAt(modifiedStartColumn - 2);
                            if (originalChar !== modifiedChar) {
                                break;
                            }
                            originalStartColumn--;
                            modifiedStartColumn--;
                        }
                        if (originalStartColumn > 1 || modifiedStartColumn > 1) {
                            this._pushTrimWhitespaceCharChange(result, originalLineIndex + 1, 1, originalStartColumn, modifiedLineIndex + 1, 1, modifiedStartColumn);
                        }
                    }
                    // Check the trailing whitespace
                    {
                        var originalEndColumn = LineMarkerSequence._getLastNonBlankColumn(originalLine, 1);
                        var modifiedEndColumn = LineMarkerSequence._getLastNonBlankColumn(modifiedLine, 1);
                        var originalMaxColumn = originalLine.length + 1;
                        var modifiedMaxColumn = modifiedLine.length + 1;
                        while (originalEndColumn < originalMaxColumn && modifiedEndColumn < modifiedMaxColumn) {
                            var originalChar = originalLine.charCodeAt(originalEndColumn - 1);
                            var modifiedChar = originalLine.charCodeAt(modifiedEndColumn - 1);
                            if (originalChar !== modifiedChar) {
                                break;
                            }
                            originalEndColumn++;
                            modifiedEndColumn++;
                        }
                        if (originalEndColumn < originalMaxColumn || modifiedEndColumn < modifiedMaxColumn) {
                            this._pushTrimWhitespaceCharChange(result, originalLineIndex + 1, originalEndColumn, originalMaxColumn, modifiedLineIndex + 1, modifiedEndColumn, modifiedMaxColumn);
                        }
                    }
                }
                originalLineIndex++;
                modifiedLineIndex++;
            }
            if (nextChange) {
                // Emit the actual change
                result.push(LineChange.createFromDiffResult(this.shouldIgnoreTrimWhitespace, nextChange, this.original, this.modified, this._continueProcessingPredicate.bind(this), this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
                originalLineIndex += nextChange.originalLength;
                modifiedLineIndex += nextChange.modifiedLength;
            }
        }
        return result;
    };
    DiffComputer.prototype._pushTrimWhitespaceCharChange = function (result, originalLineNumber, originalStartColumn, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedEndColumn) {
        if (this._mergeTrimWhitespaceCharChange(result, originalLineNumber, originalStartColumn, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedEndColumn)) {
            // Merged into previous
            return;
        }
        var charChanges;
        if (this.shouldComputeCharChanges) {
            charChanges = [new CharChange(originalLineNumber, originalStartColumn, originalLineNumber, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedLineNumber, modifiedEndColumn)];
        }
        result.push(new LineChange(originalLineNumber, originalLineNumber, modifiedLineNumber, modifiedLineNumber, charChanges));
    };
    DiffComputer.prototype._mergeTrimWhitespaceCharChange = function (result, originalLineNumber, originalStartColumn, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedEndColumn) {
        var len = result.length;
        if (len === 0) {
            return false;
        }
        var prevChange = result[len - 1];
        if (prevChange.originalEndLineNumber === 0 || prevChange.modifiedEndLineNumber === 0) {
            // Don't merge with inserts/deletes
            return false;
        }
        if (prevChange.originalEndLineNumber + 1 === originalLineNumber && prevChange.modifiedEndLineNumber + 1 === modifiedLineNumber) {
            prevChange.originalEndLineNumber = originalLineNumber;
            prevChange.modifiedEndLineNumber = modifiedLineNumber;
            if (this.shouldComputeCharChanges) {
                prevChange.charChanges.push(new CharChange(originalLineNumber, originalStartColumn, originalLineNumber, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedLineNumber, modifiedEndColumn));
            }
            return true;
        }
        return false;
    };
    DiffComputer.prototype._continueProcessingPredicate = function () {
        if (this.maximumRunTimeMs === 0) {
            return true;
        }
        var now = (new Date()).getTime();
        return now - this.computationStartTime < this.maximumRunTimeMs;
    };
    return DiffComputer;
}());



/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MirrorTextModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__viewModel_prefixSumComputer_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_position_js__ = __webpack_require__(9);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var MirrorTextModel = /** @class */ (function () {
    function MirrorTextModel(uri, lines, eol, versionId) {
        this._uri = uri;
        this._lines = lines;
        this._eol = eol;
        this._versionId = versionId;
    }
    MirrorTextModel.prototype.dispose = function () {
        this._lines.length = 0;
    };
    MirrorTextModel.prototype.getText = function () {
        return this._lines.join(this._eol);
    };
    MirrorTextModel.prototype.onEvents = function (e) {
        if (e.eol && e.eol !== this._eol) {
            this._eol = e.eol;
            this._lineStarts = null;
        }
        // Update my lines
        var changes = e.changes;
        for (var i = 0, len = changes.length; i < len; i++) {
            var change = changes[i];
            this._acceptDeleteRange(change.range);
            this._acceptInsertText(new __WEBPACK_IMPORTED_MODULE_1__core_position_js__["a" /* Position */](change.range.startLineNumber, change.range.startColumn), change.text);
        }
        this._versionId = e.versionId;
    };
    MirrorTextModel.prototype._ensureLineStarts = function () {
        if (!this._lineStarts) {
            var eolLength = this._eol.length;
            var linesLength = this._lines.length;
            var lineStartValues = new Uint32Array(linesLength);
            for (var i = 0; i < linesLength; i++) {
                lineStartValues[i] = this._lines[i].length + eolLength;
            }
            this._lineStarts = new __WEBPACK_IMPORTED_MODULE_0__viewModel_prefixSumComputer_js__["a" /* PrefixSumComputer */](lineStartValues);
        }
    };
    /**
     * All changes to a line's text go through this method
     */
    MirrorTextModel.prototype._setLineText = function (lineIndex, newValue) {
        this._lines[lineIndex] = newValue;
        if (this._lineStarts) {
            // update prefix sum
            this._lineStarts.changeValue(lineIndex, this._lines[lineIndex].length + this._eol.length);
        }
    };
    MirrorTextModel.prototype._acceptDeleteRange = function (range) {
        if (range.startLineNumber === range.endLineNumber) {
            if (range.startColumn === range.endColumn) {
                // Nothing to delete
                return;
            }
            // Delete text on the affected line
            this._setLineText(range.startLineNumber - 1, this._lines[range.startLineNumber - 1].substring(0, range.startColumn - 1)
                + this._lines[range.startLineNumber - 1].substring(range.endColumn - 1));
            return;
        }
        // Take remaining text on last line and append it to remaining text on first line
        this._setLineText(range.startLineNumber - 1, this._lines[range.startLineNumber - 1].substring(0, range.startColumn - 1)
            + this._lines[range.endLineNumber - 1].substring(range.endColumn - 1));
        // Delete middle lines
        this._lines.splice(range.startLineNumber, range.endLineNumber - range.startLineNumber);
        if (this._lineStarts) {
            // update prefix sum
            this._lineStarts.removeValues(range.startLineNumber, range.endLineNumber - range.startLineNumber);
        }
    };
    MirrorTextModel.prototype._acceptInsertText = function (position, insertText) {
        if (insertText.length === 0) {
            // Nothing to insert
            return;
        }
        var insertLines = insertText.split(/\r\n|\r|\n/);
        if (insertLines.length === 1) {
            // Inserting text on one line
            this._setLineText(position.lineNumber - 1, this._lines[position.lineNumber - 1].substring(0, position.column - 1)
                + insertLines[0]
                + this._lines[position.lineNumber - 1].substring(position.column - 1));
            return;
        }
        // Append overflowing text from first line to the end of text to insert
        insertLines[insertLines.length - 1] += this._lines[position.lineNumber - 1].substring(position.column - 1);
        // Delete overflowing text from first line and insert text on first line
        this._setLineText(position.lineNumber - 1, this._lines[position.lineNumber - 1].substring(0, position.column - 1)
            + insertLines[0]);
        // Insert new lines & store lengths
        var newLengths = new Uint32Array(insertLines.length - 1);
        for (var i = 1; i < insertLines.length; i++) {
            this._lines.splice(position.lineNumber + i - 1, 0, insertLines[i]);
            newLengths[i - 1] = insertLines[i].length + this._eol.length;
        }
        if (this._lineStarts) {
            // update prefix sum
            this._lineStarts.insertValues(position.lineNumber, newLengths);
        }
    };
    return MirrorTextModel;
}());



/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeLinks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_characterClassifier_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_uint_js__ = __webpack_require__(98);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/



var StateMachine = /** @class */ (function () {
    function StateMachine(edges) {
        var maxCharCode = 0;
        var maxState = 0 /* Invalid */;
        for (var i = 0, len = edges.length; i < len; i++) {
            var _a = edges[i], from = _a[0], chCode = _a[1], to = _a[2];
            if (chCode > maxCharCode) {
                maxCharCode = chCode;
            }
            if (from > maxState) {
                maxState = from;
            }
            if (to > maxState) {
                maxState = to;
            }
        }
        maxCharCode++;
        maxState++;
        var states = new __WEBPACK_IMPORTED_MODULE_1__core_uint_js__["a" /* Uint8Matrix */](maxState, maxCharCode, 0 /* Invalid */);
        for (var i = 0, len = edges.length; i < len; i++) {
            var _b = edges[i], from = _b[0], chCode = _b[1], to = _b[2];
            states.set(from, chCode, to);
        }
        this._states = states;
        this._maxCharCode = maxCharCode;
    }
    StateMachine.prototype.nextState = function (currentState, chCode) {
        if (chCode < 0 || chCode >= this._maxCharCode) {
            return 0 /* Invalid */;
        }
        return this._states.get(currentState, chCode);
    };
    return StateMachine;
}());
// State machine for http:// or https:// or file://
var _stateMachine = null;
function getStateMachine() {
    if (_stateMachine === null) {
        _stateMachine = new StateMachine([
            [1 /* Start */, 104 /* h */, 2 /* H */],
            [1 /* Start */, 72 /* H */, 2 /* H */],
            [1 /* Start */, 102 /* f */, 6 /* F */],
            [1 /* Start */, 70 /* F */, 6 /* F */],
            [2 /* H */, 116 /* t */, 3 /* HT */],
            [2 /* H */, 84 /* T */, 3 /* HT */],
            [3 /* HT */, 116 /* t */, 4 /* HTT */],
            [3 /* HT */, 84 /* T */, 4 /* HTT */],
            [4 /* HTT */, 112 /* p */, 5 /* HTTP */],
            [4 /* HTT */, 80 /* P */, 5 /* HTTP */],
            [5 /* HTTP */, 115 /* s */, 9 /* BeforeColon */],
            [5 /* HTTP */, 83 /* S */, 9 /* BeforeColon */],
            [5 /* HTTP */, 58 /* Colon */, 10 /* AfterColon */],
            [6 /* F */, 105 /* i */, 7 /* FI */],
            [6 /* F */, 73 /* I */, 7 /* FI */],
            [7 /* FI */, 108 /* l */, 8 /* FIL */],
            [7 /* FI */, 76 /* L */, 8 /* FIL */],
            [8 /* FIL */, 101 /* e */, 9 /* BeforeColon */],
            [8 /* FIL */, 69 /* E */, 9 /* BeforeColon */],
            [9 /* BeforeColon */, 58 /* Colon */, 10 /* AfterColon */],
            [10 /* AfterColon */, 47 /* Slash */, 11 /* AlmostThere */],
            [11 /* AlmostThere */, 47 /* Slash */, 12 /* End */],
        ]);
    }
    return _stateMachine;
}
var _classifier = null;
function getClassifier() {
    if (_classifier === null) {
        _classifier = new __WEBPACK_IMPORTED_MODULE_0__core_characterClassifier_js__["a" /* CharacterClassifier */](0 /* None */);
        var FORCE_TERMINATION_CHARACTERS = ' \t<>\'\"、。｡､，．：；？！＠＃＄％＆＊‘“〈《「『【〔（［｛｢｣｝］）〕】』」》〉”’｀～…';
        for (var i = 0; i < FORCE_TERMINATION_CHARACTERS.length; i++) {
            _classifier.set(FORCE_TERMINATION_CHARACTERS.charCodeAt(i), 1 /* ForceTermination */);
        }
        var CANNOT_END_WITH_CHARACTERS = '.,;';
        for (var i = 0; i < CANNOT_END_WITH_CHARACTERS.length; i++) {
            _classifier.set(CANNOT_END_WITH_CHARACTERS.charCodeAt(i), 2 /* CannotEndIn */);
        }
    }
    return _classifier;
}
var LinkComputer = /** @class */ (function () {
    function LinkComputer() {
    }
    LinkComputer._createLink = function (classifier, line, lineNumber, linkBeginIndex, linkEndIndex) {
        // Do not allow to end link in certain characters...
        var lastIncludedCharIndex = linkEndIndex - 1;
        do {
            var chCode = line.charCodeAt(lastIncludedCharIndex);
            var chClass = classifier.get(chCode);
            if (chClass !== 2 /* CannotEndIn */) {
                break;
            }
            lastIncludedCharIndex--;
        } while (lastIncludedCharIndex > linkBeginIndex);
        // Handle links enclosed in parens, square brackets and curlys.
        if (linkBeginIndex > 0) {
            var charCodeBeforeLink = line.charCodeAt(linkBeginIndex - 1);
            var lastCharCodeInLink = line.charCodeAt(lastIncludedCharIndex);
            if ((charCodeBeforeLink === 40 /* OpenParen */ && lastCharCodeInLink === 41 /* CloseParen */)
                || (charCodeBeforeLink === 91 /* OpenSquareBracket */ && lastCharCodeInLink === 93 /* CloseSquareBracket */)
                || (charCodeBeforeLink === 123 /* OpenCurlyBrace */ && lastCharCodeInLink === 125 /* CloseCurlyBrace */)) {
                // Do not end in ) if ( is before the link start
                // Do not end in ] if [ is before the link start
                // Do not end in } if { is before the link start
                lastIncludedCharIndex--;
            }
        }
        return {
            range: {
                startLineNumber: lineNumber,
                startColumn: linkBeginIndex + 1,
                endLineNumber: lineNumber,
                endColumn: lastIncludedCharIndex + 2
            },
            url: line.substring(linkBeginIndex, lastIncludedCharIndex + 1)
        };
    };
    LinkComputer.computeLinks = function (model) {
        var stateMachine = getStateMachine();
        var classifier = getClassifier();
        var result = [];
        for (var i = 1, lineCount = model.getLineCount(); i <= lineCount; i++) {
            var line = model.getLineContent(i);
            var len = line.length;
            var j = 0;
            var linkBeginIndex = 0;
            var linkBeginChCode = 0;
            var state = 1 /* Start */;
            var hasOpenParens = false;
            var hasOpenSquareBracket = false;
            var hasOpenCurlyBracket = false;
            while (j < len) {
                var resetStateMachine = false;
                var chCode = line.charCodeAt(j);
                if (state === 13 /* Accept */) {
                    var chClass = void 0;
                    switch (chCode) {
                        case 40 /* OpenParen */:
                            hasOpenParens = true;
                            chClass = 0 /* None */;
                            break;
                        case 41 /* CloseParen */:
                            chClass = (hasOpenParens ? 0 /* None */ : 1 /* ForceTermination */);
                            break;
                        case 91 /* OpenSquareBracket */:
                            hasOpenSquareBracket = true;
                            chClass = 0 /* None */;
                            break;
                        case 93 /* CloseSquareBracket */:
                            chClass = (hasOpenSquareBracket ? 0 /* None */ : 1 /* ForceTermination */);
                            break;
                        case 123 /* OpenCurlyBrace */:
                            hasOpenCurlyBracket = true;
                            chClass = 0 /* None */;
                            break;
                        case 125 /* CloseCurlyBrace */:
                            chClass = (hasOpenCurlyBracket ? 0 /* None */ : 1 /* ForceTermination */);
                            break;
                        /* The following three rules make it that ' or " or ` are allowed inside links if the link began with a different one */
                        case 39 /* SingleQuote */:
                            chClass = (linkBeginChCode === 34 /* DoubleQuote */ || linkBeginChCode === 96 /* BackTick */) ? 0 /* None */ : 1 /* ForceTermination */;
                            break;
                        case 34 /* DoubleQuote */:
                            chClass = (linkBeginChCode === 39 /* SingleQuote */ || linkBeginChCode === 96 /* BackTick */) ? 0 /* None */ : 1 /* ForceTermination */;
                            break;
                        case 96 /* BackTick */:
                            chClass = (linkBeginChCode === 39 /* SingleQuote */ || linkBeginChCode === 34 /* DoubleQuote */) ? 0 /* None */ : 1 /* ForceTermination */;
                            break;
                        default:
                            chClass = classifier.get(chCode);
                    }
                    // Check if character terminates link
                    if (chClass === 1 /* ForceTermination */) {
                        result.push(LinkComputer._createLink(classifier, line, i, linkBeginIndex, j));
                        resetStateMachine = true;
                    }
                }
                else if (state === 12 /* End */) {
                    var chClass = classifier.get(chCode);
                    // Check if character terminates link
                    if (chClass === 1 /* ForceTermination */) {
                        resetStateMachine = true;
                    }
                    else {
                        state = 13 /* Accept */;
                    }
                }
                else {
                    state = stateMachine.nextState(state, chCode);
                    if (state === 0 /* Invalid */) {
                        resetStateMachine = true;
                    }
                }
                if (resetStateMachine) {
                    state = 1 /* Start */;
                    hasOpenParens = false;
                    hasOpenSquareBracket = false;
                    hasOpenCurlyBracket = false;
                    // Record where the link started
                    linkBeginIndex = j + 1;
                    linkBeginChCode = chCode;
                }
                j++;
            }
            if (state === 13 /* Accept */) {
                result.push(LinkComputer._createLink(classifier, line, i, linkBeginIndex, len));
            }
        }
        return result;
    };
    return LinkComputer;
}());
/**
 * Returns an array of all links contains in the provided
 * document. *Note* that this operation is computational
 * expensive and should not run in the UI thread.
 */
function computeLinks(model) {
    if (!model || typeof model.getLineCount !== 'function' || typeof model.getLineContent !== 'function') {
        // Unknown caller!
        return [];
    }
    return LinkComputer.computeLinks(model);
}


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasicInplaceReplace; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var BasicInplaceReplace = /** @class */ (function () {
    function BasicInplaceReplace() {
        this._defaultValueSet = [
            ['true', 'false'],
            ['True', 'False'],
            ['Private', 'Public', 'Friend', 'ReadOnly', 'Partial', 'Protected', 'WriteOnly'],
            ['public', 'protected', 'private'],
        ];
    }
    BasicInplaceReplace.prototype.navigateValueSet = function (range1, text1, range2, text2, up) {
        if (range1 && text1) {
            var result = this.doNavigateValueSet(text1, up);
            if (result) {
                return {
                    range: range1,
                    value: result
                };
            }
        }
        if (range2 && text2) {
            var result = this.doNavigateValueSet(text2, up);
            if (result) {
                return {
                    range: range2,
                    value: result
                };
            }
        }
        return null;
    };
    BasicInplaceReplace.prototype.doNavigateValueSet = function (text, up) {
        var numberResult = this.numberReplace(text, up);
        if (numberResult !== null) {
            return numberResult;
        }
        return this.textReplace(text, up);
    };
    BasicInplaceReplace.prototype.numberReplace = function (value, up) {
        var precision = Math.pow(10, value.length - (value.lastIndexOf('.') + 1));
        var n1 = Number(value);
        var n2 = parseFloat(value);
        if (!isNaN(n1) && !isNaN(n2) && n1 === n2) {
            if (n1 === 0 && !up) {
                return null; // don't do negative
                //			} else if(n1 === 9 && up) {
                //				return null; // don't insert 10 into a number
            }
            else {
                n1 = Math.floor(n1 * precision);
                n1 += up ? precision : -precision;
                return String(n1 / precision);
            }
        }
        return null;
    };
    BasicInplaceReplace.prototype.textReplace = function (value, up) {
        return this.valueSetsReplace(this._defaultValueSet, value, up);
    };
    BasicInplaceReplace.prototype.valueSetsReplace = function (valueSets, value, up) {
        var result = null;
        for (var i = 0, len = valueSets.length; result === null && i < len; i++) {
            result = this.valueSetReplace(valueSets[i], value, up);
        }
        return result;
    };
    BasicInplaceReplace.prototype.valueSetReplace = function (valueSet, value, up) {
        var idx = valueSet.indexOf(value);
        if (idx >= 0) {
            idx += up ? +1 : -1;
            if (idx < 0) {
                idx = valueSet.length - 1;
            }
            else {
                idx %= valueSet.length;
            }
            return valueSet[idx];
        }
        return null;
    };
    BasicInplaceReplace.INSTANCE = new BasicInplaceReplace();
    return BasicInplaceReplace;
}());



/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModeServiceImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modes_abstractMode_js__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__languagesRegistry_js__ = __webpack_require__(544);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/






var ModeServiceImpl = /** @class */ (function () {
    function ModeServiceImpl(warnOnOverwrite) {
        if (warnOnOverwrite === void 0) { warnOnOverwrite = false; }
        this._onDidCreateMode = new __WEBPACK_IMPORTED_MODULE_1__base_common_event_js__["a" /* Emitter */]();
        this.onDidCreateMode = this._onDidCreateMode.event;
        this._instantiatedModes = {};
        this._registry = new __WEBPACK_IMPORTED_MODULE_4__languagesRegistry_js__["a" /* LanguagesRegistry */](true, warnOnOverwrite);
    }
    ModeServiceImpl.prototype._onReady = function () {
        return __WEBPACK_IMPORTED_MODULE_2__base_common_winjs_base_js__["b" /* TPromise */].as(true);
    };
    ModeServiceImpl.prototype.isRegisteredMode = function (mimetypeOrModeId) {
        return this._registry.isRegisteredMode(mimetypeOrModeId);
    };
    ModeServiceImpl.prototype.getModeIdForLanguageName = function (alias) {
        return this._registry.getModeIdForLanguageNameLowercase(alias);
    };
    ModeServiceImpl.prototype.getModeIdByFilenameOrFirstLine = function (filename, firstLine) {
        var modeIds = this._registry.getModeIdsFromFilenameOrFirstLine(filename, firstLine);
        if (modeIds.length > 0) {
            return modeIds[0];
        }
        return null;
    };
    ModeServiceImpl.prototype.getModeId = function (commaSeparatedMimetypesOrCommaSeparatedIds) {
        var modeIds = this._registry.extractModeIds(commaSeparatedMimetypesOrCommaSeparatedIds);
        if (modeIds.length > 0) {
            return modeIds[0];
        }
        return null;
    };
    ModeServiceImpl.prototype.getLanguageIdentifier = function (modeId) {
        return this._registry.getLanguageIdentifier(modeId);
    };
    // --- instantiation
    ModeServiceImpl.prototype.getMode = function (commaSeparatedMimetypesOrCommaSeparatedIds) {
        var modeIds = this._registry.extractModeIds(commaSeparatedMimetypesOrCommaSeparatedIds);
        var isPlainText = false;
        for (var i = 0; i < modeIds.length; i++) {
            if (this._instantiatedModes.hasOwnProperty(modeIds[i])) {
                return this._instantiatedModes[modeIds[i]];
            }
            isPlainText = isPlainText || (modeIds[i] === 'plaintext');
        }
        if (isPlainText) {
            // Try to do it synchronously
            var r_1 = null;
            this.getOrCreateMode(commaSeparatedMimetypesOrCommaSeparatedIds).then(function (mode) {
                r_1 = mode;
            }).done(null, __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */]);
            return r_1;
        }
        return null;
    };
    ModeServiceImpl.prototype.getOrCreateMode = function (commaSeparatedMimetypesOrCommaSeparatedIds) {
        var _this = this;
        return this._onReady().then(function () {
            var modeId = _this.getModeId(commaSeparatedMimetypesOrCommaSeparatedIds);
            // Fall back to plain text if no mode was found
            return _this._getOrCreateMode(modeId || 'plaintext');
        });
    };
    ModeServiceImpl.prototype.getOrCreateModeByFilenameOrFirstLine = function (filename, firstLine) {
        var _this = this;
        return this._onReady().then(function () {
            var modeId = _this.getModeIdByFilenameOrFirstLine(filename, firstLine);
            // Fall back to plain text if no mode was found
            return _this._getOrCreateMode(modeId || 'plaintext');
        });
    };
    ModeServiceImpl.prototype._getOrCreateMode = function (modeId) {
        if (!this._instantiatedModes.hasOwnProperty(modeId)) {
            var languageIdentifier = this.getLanguageIdentifier(modeId);
            this._instantiatedModes[modeId] = new __WEBPACK_IMPORTED_MODULE_3__modes_abstractMode_js__["a" /* FrankensteinMode */](languageIdentifier);
            this._onDidCreateMode.fire(this._instantiatedModes[modeId]);
        }
        return this._instantiatedModes[modeId];
    };
    return ModeServiceImpl;
}());



/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FrankensteinMode; });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var FrankensteinMode = /** @class */ (function () {
    function FrankensteinMode(languageIdentifier) {
        this._languageIdentifier = languageIdentifier;
    }
    FrankensteinMode.prototype.getId = function () {
        return this._languageIdentifier.language;
    };
    FrankensteinMode.prototype.getLanguageIdentifier = function () {
        return this._languageIdentifier;
    };
    return FrankensteinMode;
}());



/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguagesRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_mime_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modes_modesRegistry_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modes_nullMode_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_configuration_common_configurationRegistry_js__ = __webpack_require__(81);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/









var hasOwnProperty = Object.prototype.hasOwnProperty;
var LanguagesRegistry = /** @class */ (function () {
    function LanguagesRegistry(useModesRegistry, warnOnOverwrite) {
        if (useModesRegistry === void 0) { useModesRegistry = true; }
        if (warnOnOverwrite === void 0) { warnOnOverwrite = false; }
        var _this = this;
        this._nextLanguageId = 1;
        this._languages = {};
        this._mimeTypesMap = {};
        this._nameMap = {};
        this._lowercaseNameMap = {};
        this._languageIds = [];
        this._warnOnOverwrite = warnOnOverwrite;
        if (useModesRegistry) {
            this._registerLanguages(__WEBPACK_IMPORTED_MODULE_4__modes_modesRegistry_js__["a" /* ModesRegistry */].getLanguages());
            __WEBPACK_IMPORTED_MODULE_4__modes_modesRegistry_js__["a" /* ModesRegistry */].onDidAddLanguages(function (m) { return _this._registerLanguages(m); });
        }
    }
    LanguagesRegistry.prototype._registerLanguages = function (desc) {
        var _this = this;
        if (desc.length === 0) {
            return;
        }
        for (var i = 0; i < desc.length; i++) {
            this._registerLanguage(desc[i]);
        }
        // Rebuild fast path maps
        this._mimeTypesMap = {};
        this._nameMap = {};
        this._lowercaseNameMap = {};
        Object.keys(this._languages).forEach(function (langId) {
            var language = _this._languages[langId];
            if (language.name) {
                _this._nameMap[language.name] = language.identifier;
            }
            language.aliases.forEach(function (alias) {
                _this._lowercaseNameMap[alias.toLowerCase()] = language.identifier;
            });
            language.mimetypes.forEach(function (mimetype) {
                _this._mimeTypesMap[mimetype] = language.identifier;
            });
        });
        __WEBPACK_IMPORTED_MODULE_3__platform_registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_7__platform_configuration_common_configurationRegistry_js__["b" /* Extensions */].Configuration).registerOverrideIdentifiers(__WEBPACK_IMPORTED_MODULE_4__modes_modesRegistry_js__["a" /* ModesRegistry */].getLanguages().map(function (language) { return language.id; }));
    };
    LanguagesRegistry.prototype._registerLanguage = function (lang) {
        var langId = lang.id;
        var resolvedLanguage = null;
        if (hasOwnProperty.call(this._languages, langId)) {
            resolvedLanguage = this._languages[langId];
        }
        else {
            var languageId = this._nextLanguageId++;
            resolvedLanguage = {
                identifier: new __WEBPACK_IMPORTED_MODULE_5__modes_js__["o" /* LanguageIdentifier */](langId, languageId),
                name: null,
                mimetypes: [],
                aliases: [],
                extensions: [],
                filenames: [],
                configurationFiles: []
            };
            this._languageIds[languageId] = langId;
            this._languages[langId] = resolvedLanguage;
        }
        this._mergeLanguage(resolvedLanguage, lang);
    };
    LanguagesRegistry.prototype._mergeLanguage = function (resolvedLanguage, lang) {
        var _a;
        var langId = lang.id;
        var primaryMime = null;
        if (Array.isArray(lang.mimetypes) && lang.mimetypes.length > 0) {
            (_a = resolvedLanguage.mimetypes).push.apply(_a, lang.mimetypes);
            primaryMime = lang.mimetypes[0];
        }
        if (!primaryMime) {
            primaryMime = "text/x-" + langId;
            resolvedLanguage.mimetypes.push(primaryMime);
        }
        if (Array.isArray(lang.extensions)) {
            for (var _i = 0, _b = lang.extensions; _i < _b.length; _i++) {
                var extension = _b[_i];
                __WEBPACK_IMPORTED_MODULE_1__base_common_mime_js__["b" /* registerTextMime */]({ id: langId, mime: primaryMime, extension: extension }, this._warnOnOverwrite);
                resolvedLanguage.extensions.push(extension);
            }
        }
        if (Array.isArray(lang.filenames)) {
            for (var _c = 0, _d = lang.filenames; _c < _d.length; _c++) {
                var filename = _d[_c];
                __WEBPACK_IMPORTED_MODULE_1__base_common_mime_js__["b" /* registerTextMime */]({ id: langId, mime: primaryMime, filename: filename }, this._warnOnOverwrite);
                resolvedLanguage.filenames.push(filename);
            }
        }
        if (Array.isArray(lang.filenamePatterns)) {
            for (var _e = 0, _f = lang.filenamePatterns; _e < _f.length; _e++) {
                var filenamePattern = _f[_e];
                __WEBPACK_IMPORTED_MODULE_1__base_common_mime_js__["b" /* registerTextMime */]({ id: langId, mime: primaryMime, filepattern: filenamePattern }, this._warnOnOverwrite);
            }
        }
        if (typeof lang.firstLine === 'string' && lang.firstLine.length > 0) {
            var firstLineRegexStr = lang.firstLine;
            if (firstLineRegexStr.charAt(0) !== '^') {
                firstLineRegexStr = '^' + firstLineRegexStr;
            }
            try {
                var firstLineRegex = new RegExp(firstLineRegexStr);
                if (!__WEBPACK_IMPORTED_MODULE_2__base_common_strings_js__["regExpLeadsToEndlessLoop"](firstLineRegex)) {
                    __WEBPACK_IMPORTED_MODULE_1__base_common_mime_js__["b" /* registerTextMime */]({ id: langId, mime: primaryMime, firstline: firstLineRegex }, this._warnOnOverwrite);
                }
            }
            catch (err) {
                // Most likely, the regex was bad
                Object(__WEBPACK_IMPORTED_MODULE_0__base_common_errors_js__["e" /* onUnexpectedError */])(err);
            }
        }
        resolvedLanguage.aliases.push(langId);
        var langAliases = null;
        if (typeof lang.aliases !== 'undefined' && Array.isArray(lang.aliases)) {
            if (lang.aliases.length === 0) {
                // signal that this language should not get a name
                langAliases = [null];
            }
            else {
                langAliases = lang.aliases;
            }
        }
        if (langAliases !== null) {
            for (var i = 0; i < langAliases.length; i++) {
                if (!langAliases[i] || langAliases[i].length === 0) {
                    continue;
                }
                resolvedLanguage.aliases.push(langAliases[i]);
            }
        }
        var containsAliases = (langAliases !== null && langAliases.length > 0);
        if (containsAliases && langAliases[0] === null) {
            // signal that this language should not get a name
        }
        else {
            var bestName = (containsAliases ? langAliases[0] : null) || langId;
            if (containsAliases || !resolvedLanguage.name) {
                resolvedLanguage.name = bestName;
            }
        }
        if (lang.configuration) {
            resolvedLanguage.configurationFiles.push(lang.configuration);
        }
    };
    LanguagesRegistry.prototype.isRegisteredMode = function (mimetypeOrModeId) {
        // Is this a known mime type ?
        if (hasOwnProperty.call(this._mimeTypesMap, mimetypeOrModeId)) {
            return true;
        }
        // Is this a known mode id ?
        return hasOwnProperty.call(this._languages, mimetypeOrModeId);
    };
    LanguagesRegistry.prototype.getModeIdForLanguageNameLowercase = function (languageNameLower) {
        if (!hasOwnProperty.call(this._lowercaseNameMap, languageNameLower)) {
            return null;
        }
        return this._lowercaseNameMap[languageNameLower].language;
    };
    LanguagesRegistry.prototype.extractModeIds = function (commaSeparatedMimetypesOrCommaSeparatedIds) {
        var _this = this;
        if (!commaSeparatedMimetypesOrCommaSeparatedIds) {
            return [];
        }
        return (commaSeparatedMimetypesOrCommaSeparatedIds.
            split(',').
            map(function (mimeTypeOrId) { return mimeTypeOrId.trim(); }).
            map(function (mimeTypeOrId) {
            if (hasOwnProperty.call(_this._mimeTypesMap, mimeTypeOrId)) {
                return _this._mimeTypesMap[mimeTypeOrId].language;
            }
            return mimeTypeOrId;
        }).
            filter(function (modeId) {
            return hasOwnProperty.call(_this._languages, modeId);
        }));
    };
    LanguagesRegistry.prototype.getLanguageIdentifier = function (_modeId) {
        if (_modeId === __WEBPACK_IMPORTED_MODULE_6__modes_nullMode_js__["b" /* NULL_MODE_ID */] || _modeId === 0 /* Null */) {
            return __WEBPACK_IMPORTED_MODULE_6__modes_nullMode_js__["a" /* NULL_LANGUAGE_IDENTIFIER */];
        }
        var modeId;
        if (typeof _modeId === 'string') {
            modeId = _modeId;
        }
        else {
            modeId = this._languageIds[_modeId];
            if (!modeId) {
                return null;
            }
        }
        if (!hasOwnProperty.call(this._languages, modeId)) {
            return null;
        }
        return this._languages[modeId].identifier;
    };
    LanguagesRegistry.prototype.getModeIdsFromFilenameOrFirstLine = function (filename, firstLine) {
        if (!filename && !firstLine) {
            return [];
        }
        var mimeTypes = __WEBPACK_IMPORTED_MODULE_1__base_common_mime_js__["a" /* guessMimeTypes */](filename, firstLine);
        return this.extractModeIds(mimeTypes.join(','));
    };
    return LanguagesRegistry;
}());



/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MIME_TEXT */
/* unused harmony export MIME_UNKNOWN */
/* harmony export (immutable) */ __webpack_exports__["b"] = registerTextMime;
/* harmony export (immutable) */ __webpack_exports__["a"] = guessMimeTypes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glob_js__ = __webpack_require__(248);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/




var MIME_TEXT = 'text/plain';
var MIME_UNKNOWN = 'application/unknown';
var registeredAssociations = [];
var nonUserRegisteredAssociations = [];
var userRegisteredAssociations = [];
/**
 * Associate a text mime to the registry.
 */
function registerTextMime(association, warnOnOverwrite) {
    if (warnOnOverwrite === void 0) { warnOnOverwrite = false; }
    // Register
    var associationItem = toTextMimeAssociationItem(association);
    registeredAssociations.push(associationItem);
    if (!associationItem.userConfigured) {
        nonUserRegisteredAssociations.push(associationItem);
    }
    else {
        userRegisteredAssociations.push(associationItem);
    }
    // Check for conflicts unless this is a user configured association
    if (warnOnOverwrite && !associationItem.userConfigured) {
        registeredAssociations.forEach(function (a) {
            if (a.mime === associationItem.mime || a.userConfigured) {
                return; // same mime or userConfigured is ok
            }
            if (associationItem.extension && a.extension === associationItem.extension) {
                console.warn("Overwriting extension <<" + associationItem.extension + ">> to now point to mime <<" + associationItem.mime + ">>");
            }
            if (associationItem.filename && a.filename === associationItem.filename) {
                console.warn("Overwriting filename <<" + associationItem.filename + ">> to now point to mime <<" + associationItem.mime + ">>");
            }
            if (associationItem.filepattern && a.filepattern === associationItem.filepattern) {
                console.warn("Overwriting filepattern <<" + associationItem.filepattern + ">> to now point to mime <<" + associationItem.mime + ">>");
            }
            if (associationItem.firstline && a.firstline === associationItem.firstline) {
                console.warn("Overwriting firstline <<" + associationItem.firstline + ">> to now point to mime <<" + associationItem.mime + ">>");
            }
        });
    }
}
function toTextMimeAssociationItem(association) {
    return {
        id: association.id,
        mime: association.mime,
        filename: association.filename,
        extension: association.extension,
        filepattern: association.filepattern,
        firstline: association.firstline,
        userConfigured: association.userConfigured,
        filenameLowercase: association.filename ? association.filename.toLowerCase() : void 0,
        extensionLowercase: association.extension ? association.extension.toLowerCase() : void 0,
        filepatternLowercase: association.filepattern ? association.filepattern.toLowerCase() : void 0,
        filepatternOnPath: association.filepattern ? association.filepattern.indexOf(__WEBPACK_IMPORTED_MODULE_0__paths_js__["i" /* sep */]) >= 0 : false
    };
}
/**
 * Given a file, return the best matching mime type for it
 */
function guessMimeTypes(path, firstLine) {
    if (!path) {
        return [MIME_UNKNOWN];
    }
    path = path.toLowerCase();
    var filename = __WEBPACK_IMPORTED_MODULE_0__paths_js__["a" /* basename */](path);
    // 1.) User configured mappings have highest priority
    var configuredMime = guessMimeTypeByPath(path, filename, userRegisteredAssociations);
    if (configuredMime) {
        return [configuredMime, MIME_TEXT];
    }
    // 2.) Registered mappings have middle priority
    var registeredMime = guessMimeTypeByPath(path, filename, nonUserRegisteredAssociations);
    if (registeredMime) {
        return [registeredMime, MIME_TEXT];
    }
    // 3.) Firstline has lowest priority
    if (firstLine) {
        var firstlineMime = guessMimeTypeByFirstline(firstLine);
        if (firstlineMime) {
            return [firstlineMime, MIME_TEXT];
        }
    }
    return [MIME_UNKNOWN];
}
function guessMimeTypeByPath(path, filename, associations) {
    var filenameMatch;
    var patternMatch;
    var extensionMatch;
    // We want to prioritize associations based on the order they are registered so that the last registered
    // association wins over all other. This is for https://github.com/Microsoft/vscode/issues/20074
    for (var i = associations.length - 1; i >= 0; i--) {
        var association = associations[i];
        // First exact name match
        if (filename === association.filenameLowercase) {
            filenameMatch = association;
            break; // take it!
        }
        // Longest pattern match
        if (association.filepattern) {
            if (!patternMatch || association.filepattern.length > patternMatch.filepattern.length) {
                var target = association.filepatternOnPath ? path : filename; // match on full path if pattern contains path separator
                if (Object(__WEBPACK_IMPORTED_MODULE_2__glob_js__["a" /* match */])(association.filepatternLowercase, target)) {
                    patternMatch = association;
                }
            }
        }
        // Longest extension match
        if (association.extension) {
            if (!extensionMatch || association.extension.length > extensionMatch.extension.length) {
                if (__WEBPACK_IMPORTED_MODULE_1__strings_js__["endsWith"](filename, association.extensionLowercase)) {
                    extensionMatch = association;
                }
            }
        }
    }
    // 1.) Exact name match has second highest prio
    if (filenameMatch) {
        return filenameMatch.mime;
    }
    // 2.) Match on pattern
    if (patternMatch) {
        return patternMatch.mime;
    }
    // 3.) Match on extension comes next
    if (extensionMatch) {
        return extensionMatch.mime;
    }
    return null;
}
function guessMimeTypeByFirstline(firstLine) {
    if (__WEBPACK_IMPORTED_MODULE_1__strings_js__["startsWithUTF8BOM"](firstLine)) {
        firstLine = firstLine.substr(1);
    }
    if (firstLine.length > 0) {
        for (var i = 0; i < registeredAssociations.length; ++i) {
            var association = registeredAssociations[i];
            if (!association.firstline) {
                continue;
            }
            var matches = firstLine.match(association.firstline);
            if (matches && matches.length > 0) {
                return association.mime;
            }
        }
    }
    return null;
}


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModelServiceImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nls_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_event_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_htmlContent_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_textModel_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_common_platform_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_configuration_common_configuration_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_editorOptions_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modes_modesRegistry_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_editorColorRegistry_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__base_common_arrays_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__base_common_paths_js__ = __webpack_require__(48);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};


















function MODEL_ID(resource) {
    return resource.toString();
}
var ModelData = /** @class */ (function () {
    function ModelData(model, onWillDispose, onDidChangeLanguage) {
        this.model = model;
        this._markerDecorations = [];
        this._modelEventListeners = [];
        this._modelEventListeners.push(model.onWillDispose(function () { return onWillDispose(model); }));
        this._modelEventListeners.push(model.onDidChangeLanguage(function (e) { return onDidChangeLanguage(model, e); }));
    }
    ModelData.prototype.dispose = function () {
        this._markerDecorations = this.model.deltaDecorations(this._markerDecorations, []);
        this._modelEventListeners = Object(__WEBPACK_IMPORTED_MODULE_4__base_common_lifecycle_js__["d" /* dispose */])(this._modelEventListeners);
        this.model = null;
    };
    ModelData.prototype.acceptMarkerDecorations = function (newDecorations) {
        this._markerDecorations = this.model.deltaDecorations(this._markerDecorations, newDecorations);
    };
    return ModelData;
}());
var ModelMarkerHandler = /** @class */ (function () {
    function ModelMarkerHandler() {
    }
    ModelMarkerHandler.setMarkers = function (modelData, markerService) {
        var _this = this;
        // Limit to the first 500 errors/warnings
        var markers = markerService.read({ resource: modelData.model.uri, take: 500 });
        var newModelDecorations = markers.map(function (marker) {
            return {
                range: _this._createDecorationRange(modelData.model, marker),
                options: _this._createDecorationOption(marker)
            };
        });
        modelData.acceptMarkerDecorations(newModelDecorations);
    };
    ModelMarkerHandler._createDecorationRange = function (model, rawMarker) {
        var ret = __WEBPACK_IMPORTED_MODULE_7__core_range_js__["a" /* Range */].lift(rawMarker);
        if (rawMarker.severity === __WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Hint && __WEBPACK_IMPORTED_MODULE_7__core_range_js__["a" /* Range */].spansMultipleLines(ret)) {
            // never render hints on multiple lines
            ret = ret.setEndPosition(ret.startLineNumber, ret.startColumn);
        }
        ret = model.validateRange(ret);
        if (ret.isEmpty()) {
            var word = model.getWordAtPosition(ret.getStartPosition());
            if (word) {
                ret = new __WEBPACK_IMPORTED_MODULE_7__core_range_js__["a" /* Range */](ret.startLineNumber, word.startColumn, ret.endLineNumber, word.endColumn);
            }
            else {
                var maxColumn = model.getLineLastNonWhitespaceColumn(ret.startLineNumber) ||
                    model.getLineMaxColumn(ret.startLineNumber);
                if (maxColumn === 1) {
                    // empty line
                    // console.warn('marker on empty line:', marker);
                }
                else if (ret.endColumn >= maxColumn) {
                    // behind eol
                    ret = new __WEBPACK_IMPORTED_MODULE_7__core_range_js__["a" /* Range */](ret.startLineNumber, maxColumn - 1, ret.endLineNumber, maxColumn);
                }
                else {
                    // extend marker to width = 1
                    ret = new __WEBPACK_IMPORTED_MODULE_7__core_range_js__["a" /* Range */](ret.startLineNumber, ret.startColumn, ret.endLineNumber, ret.endColumn + 1);
                }
            }
        }
        else if (rawMarker.endColumn === Number.MAX_VALUE && rawMarker.startColumn === 1 && ret.startLineNumber === ret.endLineNumber) {
            var minColumn = model.getLineFirstNonWhitespaceColumn(rawMarker.startLineNumber);
            if (minColumn < ret.endColumn) {
                ret = new __WEBPACK_IMPORTED_MODULE_7__core_range_js__["a" /* Range */](ret.startLineNumber, minColumn, ret.endLineNumber, ret.endColumn);
                rawMarker.startColumn = minColumn;
            }
        }
        return ret;
    };
    ModelMarkerHandler._createDecorationOption = function (marker) {
        var className;
        var color;
        var darkColor;
        var zIndex;
        var inlineClassName;
        switch (marker.severity) {
            case __WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Hint:
                if (marker.tags && marker.tags.indexOf(__WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["c" /* MarkerTag */].Unnecessary) >= 0) {
                    className = "squiggly-unnecessary" /* EditorUnnecessaryDecoration */;
                }
                else {
                    className = "squiggly-hint" /* EditorHintDecoration */;
                }
                zIndex = 0;
                break;
            case __WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Warning:
                className = "squiggly-warning" /* EditorWarningDecoration */;
                color = Object(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__view_editorColorRegistry_js__["z" /* overviewRulerWarning */]);
                darkColor = Object(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__view_editorColorRegistry_js__["z" /* overviewRulerWarning */]);
                zIndex = 20;
                break;
            case __WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Info:
                className = "squiggly-info" /* EditorInfoDecoration */;
                color = Object(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__view_editorColorRegistry_js__["y" /* overviewRulerInfo */]);
                darkColor = Object(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__view_editorColorRegistry_js__["y" /* overviewRulerInfo */]);
                zIndex = 10;
                break;
            case __WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["b" /* MarkerSeverity */].Error:
            default:
                className = "squiggly-error" /* EditorErrorDecoration */;
                color = Object(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__view_editorColorRegistry_js__["x" /* overviewRulerError */]);
                darkColor = Object(__WEBPACK_IMPORTED_MODULE_13__platform_theme_common_themeService_js__["f" /* themeColorFromId */])(__WEBPACK_IMPORTED_MODULE_14__view_editorColorRegistry_js__["x" /* overviewRulerError */]);
                zIndex = 30;
                break;
        }
        if (marker.tags) {
            if (marker.tags.indexOf(__WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["c" /* MarkerTag */].Unnecessary) !== -1) {
                inlineClassName = "squiggly-inline-unnecessary" /* EditorUnnecessaryInlineDecoration */;
            }
        }
        var hoverMessage = null;
        var message = marker.message, source = marker.source, relatedInformation = marker.relatedInformation;
        if (typeof message === 'string') {
            message = message.trim();
            if (source) {
                if (/\n/g.test(message)) {
                    message = __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('diagAndSourceMultiline', "[{0}]\n{1}", source, message);
                }
                else {
                    message = __WEBPACK_IMPORTED_MODULE_0__nls_js__["a" /* localize */]('diagAndSource', "[{0}] {1}", source, message);
                }
            }
            hoverMessage = new __WEBPACK_IMPORTED_MODULE_3__base_common_htmlContent_js__["a" /* MarkdownString */]().appendCodeblock('_', message);
            if (!Object(__WEBPACK_IMPORTED_MODULE_16__base_common_arrays_js__["k" /* isFalsyOrEmpty */])(relatedInformation)) {
                hoverMessage.appendMarkdown('\n');
                for (var _i = 0, relatedInformation_1 = relatedInformation; _i < relatedInformation_1.length; _i++) {
                    var _a = relatedInformation_1[_i], message_1 = _a.message, resource = _a.resource, startLineNumber = _a.startLineNumber, startColumn = _a.startColumn;
                    hoverMessage.appendMarkdown("* [" + Object(__WEBPACK_IMPORTED_MODULE_17__base_common_paths_js__["a" /* basename */])(resource.path) + "(" + startLineNumber + ", " + startColumn + ")](" + resource.toString(false) + "#" + startLineNumber + "," + startColumn + "): ");
                    hoverMessage.appendText("" + message_1);
                    hoverMessage.appendMarkdown('\n');
                }
                hoverMessage.appendMarkdown('\n');
            }
        }
        return {
            stickiness: __WEBPACK_IMPORTED_MODULE_15__model_js__["h" /* TrackedRangeStickiness */].NeverGrowsWhenTypingAtEdges,
            className: className,
            hoverMessage: hoverMessage,
            showIfCollapsed: true,
            overviewRuler: {
                color: color,
                darkColor: darkColor,
                position: __WEBPACK_IMPORTED_MODULE_15__model_js__["f" /* OverviewRulerLane */].Right
            },
            zIndex: zIndex,
            inlineClassName: inlineClassName,
        };
    };
    return ModelMarkerHandler;
}());
var DEFAULT_EOL = (__WEBPACK_IMPORTED_MODULE_9__base_common_platform_js__["c" /* isLinux */] || __WEBPACK_IMPORTED_MODULE_9__base_common_platform_js__["d" /* isMacintosh */]) ? __WEBPACK_IMPORTED_MODULE_15__model_js__["b" /* DefaultEndOfLine */].LF : __WEBPACK_IMPORTED_MODULE_15__model_js__["b" /* DefaultEndOfLine */].CRLF;
var ModelServiceImpl = /** @class */ (function () {
    function ModelServiceImpl(markerService, configurationService) {
        var _this = this;
        this._markerService = markerService;
        this._configurationService = configurationService;
        this._models = {};
        this._modelCreationOptionsByLanguageAndResource = Object.create(null);
        this._onModelAdded = new __WEBPACK_IMPORTED_MODULE_2__base_common_event_js__["a" /* Emitter */]();
        this._onModelRemoved = new __WEBPACK_IMPORTED_MODULE_2__base_common_event_js__["a" /* Emitter */]();
        this._onModelModeChanged = new __WEBPACK_IMPORTED_MODULE_2__base_common_event_js__["a" /* Emitter */]();
        if (this._markerService) {
            this._markerServiceSubscription = this._markerService.onMarkerChanged(this._handleMarkerChange, this);
        }
        this._configurationServiceSubscription = this._configurationService.onDidChangeConfiguration(function (e) { return _this._updateModelOptions(); });
        this._updateModelOptions();
    }
    ModelServiceImpl._readModelOptions = function (config, isForSimpleWidget) {
        var tabSize = __WEBPACK_IMPORTED_MODULE_11__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].tabSize;
        if (config.editor && typeof config.editor.tabSize !== 'undefined') {
            var parsedTabSize = parseInt(config.editor.tabSize, 10);
            if (!isNaN(parsedTabSize)) {
                tabSize = parsedTabSize;
            }
            if (tabSize < 1) {
                tabSize = 1;
            }
        }
        var insertSpaces = __WEBPACK_IMPORTED_MODULE_11__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].insertSpaces;
        if (config.editor && typeof config.editor.insertSpaces !== 'undefined') {
            insertSpaces = (config.editor.insertSpaces === 'false' ? false : Boolean(config.editor.insertSpaces));
        }
        var newDefaultEOL = DEFAULT_EOL;
        var eol = config.files && config.files.eol;
        if (eol === '\r\n') {
            newDefaultEOL = __WEBPACK_IMPORTED_MODULE_15__model_js__["b" /* DefaultEndOfLine */].CRLF;
        }
        else if (eol === '\n') {
            newDefaultEOL = __WEBPACK_IMPORTED_MODULE_15__model_js__["b" /* DefaultEndOfLine */].LF;
        }
        var trimAutoWhitespace = __WEBPACK_IMPORTED_MODULE_11__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].trimAutoWhitespace;
        if (config.editor && typeof config.editor.trimAutoWhitespace !== 'undefined') {
            trimAutoWhitespace = (config.editor.trimAutoWhitespace === 'false' ? false : Boolean(config.editor.trimAutoWhitespace));
        }
        var detectIndentation = __WEBPACK_IMPORTED_MODULE_11__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].detectIndentation;
        if (config.editor && typeof config.editor.detectIndentation !== 'undefined') {
            detectIndentation = (config.editor.detectIndentation === 'false' ? false : Boolean(config.editor.detectIndentation));
        }
        var largeFileOptimizations = __WEBPACK_IMPORTED_MODULE_11__config_editorOptions_js__["c" /* EDITOR_MODEL_DEFAULTS */].largeFileOptimizations;
        if (config.editor && typeof config.editor.largeFileOptimizations !== 'undefined') {
            largeFileOptimizations = (config.editor.largeFileOptimizations === 'false' ? false : Boolean(config.editor.largeFileOptimizations));
        }
        return {
            isForSimpleWidget: isForSimpleWidget,
            tabSize: tabSize,
            insertSpaces: insertSpaces,
            detectIndentation: detectIndentation,
            defaultEOL: newDefaultEOL,
            trimAutoWhitespace: trimAutoWhitespace,
            largeFileOptimizations: largeFileOptimizations
        };
    };
    ModelServiceImpl.prototype.getCreationOptions = function (language, resource, isForSimpleWidget) {
        var creationOptions = this._modelCreationOptionsByLanguageAndResource[language + resource];
        if (!creationOptions) {
            creationOptions = ModelServiceImpl._readModelOptions(this._configurationService.getValue({ overrideIdentifier: language, resource: resource }), isForSimpleWidget);
            this._modelCreationOptionsByLanguageAndResource[language + resource] = creationOptions;
        }
        return creationOptions;
    };
    ModelServiceImpl.prototype._updateModelOptions = function () {
        var oldOptionsByLanguageAndResource = this._modelCreationOptionsByLanguageAndResource;
        this._modelCreationOptionsByLanguageAndResource = Object.create(null);
        // Update options on all models
        var keys = Object.keys(this._models);
        for (var i = 0, len = keys.length; i < len; i++) {
            var modelId = keys[i];
            var modelData = this._models[modelId];
            var language = modelData.model.getLanguageIdentifier().language;
            var uri = modelData.model.uri;
            var oldOptions = oldOptionsByLanguageAndResource[language + uri];
            var newOptions = this.getCreationOptions(language, uri, modelData.model.isForSimpleWidget);
            ModelServiceImpl._setModelOptionsForModel(modelData.model, newOptions, oldOptions);
        }
    };
    ModelServiceImpl._setModelOptionsForModel = function (model, newOptions, currentOptions) {
        if (currentOptions
            && (currentOptions.detectIndentation === newOptions.detectIndentation)
            && (currentOptions.insertSpaces === newOptions.insertSpaces)
            && (currentOptions.tabSize === newOptions.tabSize)
            && (currentOptions.trimAutoWhitespace === newOptions.trimAutoWhitespace)) {
            // Same indent opts, no need to touch the model
            return;
        }
        if (newOptions.detectIndentation) {
            model.detectIndentation(newOptions.insertSpaces, newOptions.tabSize);
            model.updateOptions({
                trimAutoWhitespace: newOptions.trimAutoWhitespace
            });
        }
        else {
            model.updateOptions({
                insertSpaces: newOptions.insertSpaces,
                tabSize: newOptions.tabSize,
                trimAutoWhitespace: newOptions.trimAutoWhitespace
            });
        }
    };
    ModelServiceImpl.prototype.dispose = function () {
        if (this._markerServiceSubscription) {
            this._markerServiceSubscription.dispose();
        }
        this._configurationServiceSubscription.dispose();
    };
    ModelServiceImpl.prototype._handleMarkerChange = function (changedResources) {
        var _this = this;
        changedResources.forEach(function (resource) {
            var modelId = MODEL_ID(resource);
            var modelData = _this._models[modelId];
            if (!modelData) {
                return;
            }
            ModelMarkerHandler.setMarkers(modelData, _this._markerService);
        });
    };
    ModelServiceImpl.prototype._cleanUp = function (model) {
        var _this = this;
        // clean up markers for internal, transient models
        if (model.uri.scheme === __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__["a" /* Schemas */].inMemory
            || model.uri.scheme === __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__["a" /* Schemas */].internal
            || model.uri.scheme === __WEBPACK_IMPORTED_MODULE_1__base_common_network_js__["a" /* Schemas */].vscode) {
            if (this._markerService) {
                this._markerService.read({ resource: model.uri }).map(function (marker) { return marker.owner; }).forEach(function (owner) { return _this._markerService.remove(owner, [model.uri]); });
            }
        }
        // clean up cache
        delete this._modelCreationOptionsByLanguageAndResource[model.getLanguageIdentifier().language + model.uri];
    };
    // --- begin IModelService
    ModelServiceImpl.prototype._createModelData = function (value, languageIdentifier, resource, isForSimpleWidget) {
        var _this = this;
        // create & save the model
        var options = this.getCreationOptions(languageIdentifier.language, resource, isForSimpleWidget);
        var model = new __WEBPACK_IMPORTED_MODULE_8__model_textModel_js__["b" /* TextModel */](value, options, languageIdentifier, resource);
        var modelId = MODEL_ID(model.uri);
        if (this._models[modelId]) {
            // There already exists a model with this id => this is a programmer error
            throw new Error('ModelService: Cannot add model because it already exists!');
        }
        var modelData = new ModelData(model, function (model) { return _this._onWillDispose(model); }, function (model, e) { return _this._onDidChangeLanguage(model, e); });
        this._models[modelId] = modelData;
        return modelData;
    };
    ModelServiceImpl.prototype.createModel = function (value, modeOrPromise, resource, isForSimpleWidget) {
        if (isForSimpleWidget === void 0) { isForSimpleWidget = false; }
        var modelData;
        if (!modeOrPromise || __WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__["b" /* TPromise */].is(modeOrPromise)) {
            modelData = this._createModelData(value, __WEBPACK_IMPORTED_MODULE_12__modes_modesRegistry_js__["b" /* PLAINTEXT_LANGUAGE_IDENTIFIER */], resource, isForSimpleWidget);
            this.setMode(modelData.model, modeOrPromise);
        }
        else {
            modelData = this._createModelData(value, modeOrPromise.getLanguageIdentifier(), resource, isForSimpleWidget);
        }
        // handle markers (marker service => model)
        if (this._markerService) {
            ModelMarkerHandler.setMarkers(modelData, this._markerService);
        }
        this._onModelAdded.fire(modelData.model);
        return modelData.model;
    };
    ModelServiceImpl.prototype.setMode = function (model, modeOrPromise) {
        if (!modeOrPromise) {
            return;
        }
        if (__WEBPACK_IMPORTED_MODULE_5__base_common_winjs_base_js__["b" /* TPromise */].is(modeOrPromise)) {
            modeOrPromise.then(function (mode) {
                if (!model.isDisposed()) {
                    model.setMode(mode.getLanguageIdentifier());
                }
            });
        }
        else {
            model.setMode(modeOrPromise.getLanguageIdentifier());
        }
    };
    ModelServiceImpl.prototype.getModels = function () {
        var ret = [];
        var keys = Object.keys(this._models);
        for (var i = 0, len = keys.length; i < len; i++) {
            var modelId = keys[i];
            ret.push(this._models[modelId].model);
        }
        return ret;
    };
    ModelServiceImpl.prototype.getModel = function (resource) {
        var modelId = MODEL_ID(resource);
        var modelData = this._models[modelId];
        if (!modelData) {
            return null;
        }
        return modelData.model;
    };
    Object.defineProperty(ModelServiceImpl.prototype, "onModelAdded", {
        get: function () {
            return this._onModelAdded ? this._onModelAdded.event : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelServiceImpl.prototype, "onModelRemoved", {
        get: function () {
            return this._onModelRemoved ? this._onModelRemoved.event : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelServiceImpl.prototype, "onModelModeChanged", {
        get: function () {
            return this._onModelModeChanged ? this._onModelModeChanged.event : null;
        },
        enumerable: true,
        configurable: true
    });
    // --- end IModelService
    ModelServiceImpl.prototype._onWillDispose = function (model) {
        var modelId = MODEL_ID(model.uri);
        var modelData = this._models[modelId];
        delete this._models[modelId];
        modelData.dispose();
        this._cleanUp(model);
        this._onModelRemoved.fire(model);
    };
    ModelServiceImpl.prototype._onDidChangeLanguage = function (model, e) {
        var oldModeId = e.oldLanguage;
        var newModeId = model.getLanguageIdentifier().language;
        var oldOptions = this.getCreationOptions(oldModeId, model.uri, model.isForSimpleWidget);
        var newOptions = this.getCreationOptions(newModeId, model.uri, model.isForSimpleWidget);
        ModelServiceImpl._setModelOptionsForModel(model, newOptions, oldOptions);
        this._onModelModeChanged.fire({ model: model, oldModeId: oldModeId });
    };
    ModelServiceImpl = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_6__platform_markers_common_markers_js__["a" /* IMarkerService */]),
        __param(1, __WEBPACK_IMPORTED_MODULE_10__platform_configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], ModelServiceImpl);
    return ModelServiceImpl;
}());



/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandaloneCodeEditorServiceImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_services_codeEditorServiceImpl_js__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_network_js__ = __webpack_require__(60);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var StandaloneCodeEditorServiceImpl = /** @class */ (function (_super) {
    __extends(StandaloneCodeEditorServiceImpl, _super);
    function StandaloneCodeEditorServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StandaloneCodeEditorServiceImpl.prototype.getActiveCodeEditor = function () {
        return null; // not supported in the standalone case
    };
    StandaloneCodeEditorServiceImpl.prototype.openCodeEditor = function (input, source, sideBySide) {
        if (!source) {
            return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(null);
        }
        return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(this.doOpenEditor(source, input));
    };
    StandaloneCodeEditorServiceImpl.prototype.doOpenEditor = function (editor, input) {
        var model = this.findModel(editor, input.resource);
        if (!model) {
            if (input.resource) {
                var schema = input.resource.scheme;
                if (schema === __WEBPACK_IMPORTED_MODULE_3__base_common_network_js__["a" /* Schemas */].http || schema === __WEBPACK_IMPORTED_MODULE_3__base_common_network_js__["a" /* Schemas */].https) {
                    // This is a fully qualified http or https URL
                    Object(__WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["P" /* windowOpenNoOpener */])(input.resource.toString());
                    return editor;
                }
            }
            return null;
        }
        var selection = input.options.selection;
        if (selection) {
            if (typeof selection.endLineNumber === 'number' && typeof selection.endColumn === 'number') {
                editor.setSelection(selection);
                editor.revealRangeInCenter(selection, 1 /* Immediate */);
            }
            else {
                var pos = {
                    lineNumber: selection.startLineNumber,
                    column: selection.startColumn
                };
                editor.setPosition(pos);
                editor.revealPositionInCenter(pos, 1 /* Immediate */);
            }
        }
        return editor;
    };
    StandaloneCodeEditorServiceImpl.prototype.findModel = function (editor, resource) {
        var model = editor.getModel();
        if (model.uri.toString() !== resource.toString()) {
            return null;
        }
        return model;
    };
    return StandaloneCodeEditorServiceImpl;
}(__WEBPACK_IMPORTED_MODULE_1__browser_services_codeEditorServiceImpl_js__["a" /* CodeEditorServiceImpl */]));



/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeEditorServiceImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_editorCommon_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_model_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractCodeEditorService_js__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_themeService_js__ = __webpack_require__(13);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};








var CodeEditorServiceImpl = /** @class */ (function (_super) {
    __extends(CodeEditorServiceImpl, _super);
    function CodeEditorServiceImpl(themeService, styleSheet) {
        if (styleSheet === void 0) { styleSheet = __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["o" /* createStyleSheet */](); }
        var _this = _super.call(this) || this;
        _this._styleSheet = styleSheet;
        _this._decorationOptionProviders = Object.create(null);
        _this._themeService = themeService;
        return _this;
    }
    CodeEditorServiceImpl.prototype.registerDecorationType = function (key, options, parentTypeKey) {
        var provider = this._decorationOptionProviders[key];
        if (!provider) {
            var providerArgs = {
                styleSheet: this._styleSheet,
                key: key,
                parentTypeKey: parentTypeKey,
                options: options || Object.create(null)
            };
            if (!parentTypeKey) {
                provider = new DecorationTypeOptionsProvider(this._themeService, providerArgs);
            }
            else {
                provider = new DecorationSubTypeOptionsProvider(this._themeService, providerArgs);
            }
            this._decorationOptionProviders[key] = provider;
        }
        provider.refCount++;
    };
    CodeEditorServiceImpl.prototype.removeDecorationType = function (key) {
        var provider = this._decorationOptionProviders[key];
        if (provider) {
            provider.refCount--;
            if (provider.refCount <= 0) {
                delete this._decorationOptionProviders[key];
                provider.dispose();
                this.listCodeEditors().forEach(function (ed) { return ed.removeDecorations(key); });
            }
        }
    };
    CodeEditorServiceImpl.prototype.resolveDecorationOptions = function (decorationTypeKey, writable) {
        var provider = this._decorationOptionProviders[decorationTypeKey];
        if (!provider) {
            throw new Error('Unknown decoration type key: ' + decorationTypeKey);
        }
        return provider.getOptions(this, writable);
    };
    CodeEditorServiceImpl = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_7__platform_theme_common_themeService_js__["c" /* IThemeService */])
    ], CodeEditorServiceImpl);
    return CodeEditorServiceImpl;
}(__WEBPACK_IMPORTED_MODULE_5__abstractCodeEditorService_js__["a" /* AbstractCodeEditorService */]));

var DecorationSubTypeOptionsProvider = /** @class */ (function () {
    function DecorationSubTypeOptionsProvider(themeService, providerArgs) {
        this._parentTypeKey = providerArgs.parentTypeKey;
        this.refCount = 0;
        this._beforeContentRules = new DecorationCSSRules(3 /* BeforeContentClassName */, providerArgs, themeService);
        this._afterContentRules = new DecorationCSSRules(4 /* AfterContentClassName */, providerArgs, themeService);
    }
    DecorationSubTypeOptionsProvider.prototype.getOptions = function (codeEditorService, writable) {
        var options = codeEditorService.resolveDecorationOptions(this._parentTypeKey, true);
        if (this._beforeContentRules) {
            options.beforeContentClassName = this._beforeContentRules.className;
        }
        if (this._afterContentRules) {
            options.afterContentClassName = this._afterContentRules.className;
        }
        return options;
    };
    DecorationSubTypeOptionsProvider.prototype.dispose = function () {
        if (this._beforeContentRules) {
            this._beforeContentRules.dispose();
            this._beforeContentRules = null;
        }
        if (this._afterContentRules) {
            this._afterContentRules.dispose();
            this._afterContentRules = null;
        }
    };
    return DecorationSubTypeOptionsProvider;
}());
var DecorationTypeOptionsProvider = /** @class */ (function () {
    function DecorationTypeOptionsProvider(themeService, providerArgs) {
        var _this = this;
        this.refCount = 0;
        this._disposables = [];
        var createCSSRules = function (type) {
            var rules = new DecorationCSSRules(type, providerArgs, themeService);
            if (rules.hasContent) {
                _this._disposables.push(rules);
                return rules.className;
            }
            return void 0;
        };
        var createInlineCSSRules = function (type) {
            var rules = new DecorationCSSRules(type, providerArgs, themeService);
            if (rules.hasContent) {
                _this._disposables.push(rules);
                return { className: rules.className, hasLetterSpacing: rules.hasLetterSpacing };
            }
            return null;
        };
        this.className = createCSSRules(0 /* ClassName */);
        var inlineData = createInlineCSSRules(1 /* InlineClassName */);
        if (inlineData) {
            this.inlineClassName = inlineData.className;
            this.inlineClassNameAffectsLetterSpacing = inlineData.hasLetterSpacing;
        }
        this.beforeContentClassName = createCSSRules(3 /* BeforeContentClassName */);
        this.afterContentClassName = createCSSRules(4 /* AfterContentClassName */);
        this.glyphMarginClassName = createCSSRules(2 /* GlyphMarginClassName */);
        var options = providerArgs.options;
        this.isWholeLine = Boolean(options.isWholeLine);
        this.stickiness = options.rangeBehavior;
        var lightOverviewRulerColor = options.light && options.light.overviewRulerColor || options.overviewRulerColor;
        var darkOverviewRulerColor = options.dark && options.dark.overviewRulerColor || options.overviewRulerColor;
        if (typeof lightOverviewRulerColor !== 'undefined'
            || typeof darkOverviewRulerColor !== 'undefined') {
            this.overviewRuler = {
                color: lightOverviewRulerColor || darkOverviewRulerColor,
                darkColor: darkOverviewRulerColor || lightOverviewRulerColor,
                position: options.overviewRulerLane || __WEBPACK_IMPORTED_MODULE_4__common_model_js__["f" /* OverviewRulerLane */].Center
            };
        }
    }
    DecorationTypeOptionsProvider.prototype.getOptions = function (codeEditorService, writable) {
        if (!writable) {
            return this;
        }
        return {
            inlineClassName: this.inlineClassName,
            beforeContentClassName: this.beforeContentClassName,
            afterContentClassName: this.afterContentClassName,
            className: this.className,
            glyphMarginClassName: this.glyphMarginClassName,
            isWholeLine: this.isWholeLine,
            overviewRuler: this.overviewRuler,
            stickiness: this.stickiness
        };
    };
    DecorationTypeOptionsProvider.prototype.dispose = function () {
        this._disposables = Object(__WEBPACK_IMPORTED_MODULE_6__base_common_lifecycle_js__["d" /* dispose */])(this._disposables);
    };
    return DecorationTypeOptionsProvider;
}());
var _CSS_MAP = {
    color: 'color:{0} !important;',
    opacity: 'opacity:{0}; will-change: opacity;',
    backgroundColor: 'background-color:{0};',
    outline: 'outline:{0};',
    outlineColor: 'outline-color:{0};',
    outlineStyle: 'outline-style:{0};',
    outlineWidth: 'outline-width:{0};',
    border: 'border:{0};',
    borderColor: 'border-color:{0};',
    borderRadius: 'border-radius:{0};',
    borderSpacing: 'border-spacing:{0};',
    borderStyle: 'border-style:{0};',
    borderWidth: 'border-width:{0};',
    fontStyle: 'font-style:{0};',
    fontWeight: 'font-weight:{0};',
    textDecoration: 'text-decoration:{0};',
    cursor: 'cursor:{0};',
    letterSpacing: 'letter-spacing:{0};',
    gutterIconPath: 'background:url(\'{0}\') center center no-repeat;',
    gutterIconSize: 'background-size:{0};',
    contentText: 'content:\'{0}\';',
    contentIconPath: 'content:url(\'{0}\');',
    margin: 'margin:{0};',
    width: 'width:{0};',
    height: 'height:{0};'
};
var DecorationCSSRules = /** @class */ (function () {
    function DecorationCSSRules(ruleType, providerArgs, themeService) {
        var _this = this;
        this._theme = themeService.getTheme();
        this._ruleType = ruleType;
        this._providerArgs = providerArgs;
        this._usesThemeColors = false;
        this._hasContent = false;
        this._hasLetterSpacing = false;
        var className = CSSNameHelper.getClassName(this._providerArgs.key, ruleType);
        if (this._providerArgs.parentTypeKey) {
            className = className + ' ' + CSSNameHelper.getClassName(this._providerArgs.parentTypeKey, ruleType);
        }
        this._className = className;
        this._unThemedSelector = CSSNameHelper.getSelector(this._providerArgs.key, this._providerArgs.parentTypeKey, ruleType);
        this._buildCSS();
        if (this._usesThemeColors) {
            this._themeListener = themeService.onThemeChange(function (theme) {
                _this._theme = themeService.getTheme();
                _this._removeCSS();
                _this._buildCSS();
            });
        }
    }
    DecorationCSSRules.prototype.dispose = function () {
        if (this._hasContent) {
            this._removeCSS();
            this._hasContent = false;
        }
        if (this._themeListener) {
            this._themeListener.dispose();
            this._themeListener = null;
        }
    };
    Object.defineProperty(DecorationCSSRules.prototype, "hasContent", {
        get: function () {
            return this._hasContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecorationCSSRules.prototype, "hasLetterSpacing", {
        get: function () {
            return this._hasLetterSpacing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecorationCSSRules.prototype, "className", {
        get: function () {
            return this._className;
        },
        enumerable: true,
        configurable: true
    });
    DecorationCSSRules.prototype._buildCSS = function () {
        var options = this._providerArgs.options;
        var unthemedCSS, lightCSS, darkCSS;
        switch (this._ruleType) {
            case 0 /* ClassName */:
                unthemedCSS = this.getCSSTextForModelDecorationClassName(options);
                lightCSS = this.getCSSTextForModelDecorationClassName(options.light);
                darkCSS = this.getCSSTextForModelDecorationClassName(options.dark);
                break;
            case 1 /* InlineClassName */:
                unthemedCSS = this.getCSSTextForModelDecorationInlineClassName(options);
                lightCSS = this.getCSSTextForModelDecorationInlineClassName(options.light);
                darkCSS = this.getCSSTextForModelDecorationInlineClassName(options.dark);
                break;
            case 2 /* GlyphMarginClassName */:
                unthemedCSS = this.getCSSTextForModelDecorationGlyphMarginClassName(options);
                lightCSS = this.getCSSTextForModelDecorationGlyphMarginClassName(options.light);
                darkCSS = this.getCSSTextForModelDecorationGlyphMarginClassName(options.dark);
                break;
            case 3 /* BeforeContentClassName */:
                unthemedCSS = this.getCSSTextForModelDecorationContentClassName(options.before);
                lightCSS = this.getCSSTextForModelDecorationContentClassName(options.light && options.light.before);
                darkCSS = this.getCSSTextForModelDecorationContentClassName(options.dark && options.dark.before);
                break;
            case 4 /* AfterContentClassName */:
                unthemedCSS = this.getCSSTextForModelDecorationContentClassName(options.after);
                lightCSS = this.getCSSTextForModelDecorationContentClassName(options.light && options.light.after);
                darkCSS = this.getCSSTextForModelDecorationContentClassName(options.dark && options.dark.after);
                break;
            default:
                throw new Error('Unknown rule type: ' + this._ruleType);
        }
        var sheet = this._providerArgs.styleSheet.sheet;
        var hasContent = false;
        if (unthemedCSS.length > 0) {
            sheet.insertRule(this._unThemedSelector + " {" + unthemedCSS + "}", 0);
            hasContent = true;
        }
        if (lightCSS.length > 0) {
            sheet.insertRule(".vs" + this._unThemedSelector + " {" + lightCSS + "}", 0);
            hasContent = true;
        }
        if (darkCSS.length > 0) {
            sheet.insertRule(".vs-dark" + this._unThemedSelector + ", .hc-black" + this._unThemedSelector + " {" + darkCSS + "}", 0);
            hasContent = true;
        }
        this._hasContent = hasContent;
    };
    DecorationCSSRules.prototype._removeCSS = function () {
        __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["F" /* removeCSSRulesContainingSelector */](this._unThemedSelector, this._providerArgs.styleSheet);
    };
    /**
     * Build the CSS for decorations styled via `className`.
     */
    DecorationCSSRules.prototype.getCSSTextForModelDecorationClassName = function (opts) {
        if (!opts) {
            return '';
        }
        var cssTextArr = [];
        this.collectCSSText(opts, ['backgroundColor'], cssTextArr);
        this.collectCSSText(opts, ['outline', 'outlineColor', 'outlineStyle', 'outlineWidth'], cssTextArr);
        this.collectBorderSettingsCSSText(opts, cssTextArr);
        return cssTextArr.join('');
    };
    /**
     * Build the CSS for decorations styled via `inlineClassName`.
     */
    DecorationCSSRules.prototype.getCSSTextForModelDecorationInlineClassName = function (opts) {
        if (!opts) {
            return '';
        }
        var cssTextArr = [];
        this.collectCSSText(opts, ['fontStyle', 'fontWeight', 'textDecoration', 'cursor', 'color', 'opacity', 'letterSpacing'], cssTextArr);
        if (opts.letterSpacing) {
            this._hasLetterSpacing = true;
        }
        return cssTextArr.join('');
    };
    /**
     * Build the CSS for decorations styled before or after content.
     */
    DecorationCSSRules.prototype.getCSSTextForModelDecorationContentClassName = function (opts) {
        if (!opts) {
            return '';
        }
        var cssTextArr = [];
        if (typeof opts !== 'undefined') {
            this.collectBorderSettingsCSSText(opts, cssTextArr);
            if (typeof opts.contentIconPath !== 'undefined') {
                if (typeof opts.contentIconPath === 'string') {
                    cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"](_CSS_MAP.contentIconPath, __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */].file(opts.contentIconPath).toString().replace(/'/g, '%27')));
                }
                else {
                    cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"](_CSS_MAP.contentIconPath, __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */].revive(opts.contentIconPath).toString(true).replace(/'/g, '%27')));
                }
            }
            if (typeof opts.contentText === 'string') {
                var truncated = opts.contentText.match(/^.*$/m)[0]; // only take first line
                var escaped = truncated.replace(/['\\]/g, '\\$&');
                cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"](_CSS_MAP.contentText, escaped));
            }
            this.collectCSSText(opts, ['fontStyle', 'fontWeight', 'textDecoration', 'color', 'opacity', 'backgroundColor', 'margin'], cssTextArr);
            if (this.collectCSSText(opts, ['width', 'height'], cssTextArr)) {
                cssTextArr.push('display:inline-block;');
            }
        }
        return cssTextArr.join('');
    };
    /**
     * Build the CSS for decorations styled via `glpyhMarginClassName`.
     */
    DecorationCSSRules.prototype.getCSSTextForModelDecorationGlyphMarginClassName = function (opts) {
        if (!opts) {
            return '';
        }
        var cssTextArr = [];
        if (typeof opts.gutterIconPath !== 'undefined') {
            if (typeof opts.gutterIconPath === 'string') {
                cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"](_CSS_MAP.gutterIconPath, __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */].file(opts.gutterIconPath).toString()));
            }
            else {
                cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"](_CSS_MAP.gutterIconPath, __WEBPACK_IMPORTED_MODULE_1__base_common_uri_js__["a" /* default */].revive(opts.gutterIconPath).toString(true).replace(/'/g, '%27')));
            }
            if (typeof opts.gutterIconSize !== 'undefined') {
                cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"](_CSS_MAP.gutterIconSize, opts.gutterIconSize));
            }
        }
        return cssTextArr.join('');
    };
    DecorationCSSRules.prototype.collectBorderSettingsCSSText = function (opts, cssTextArr) {
        if (this.collectCSSText(opts, ['border', 'borderColor', 'borderRadius', 'borderSpacing', 'borderStyle', 'borderWidth'], cssTextArr)) {
            cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"]('box-sizing: border-box;'));
            return true;
        }
        return false;
    };
    DecorationCSSRules.prototype.collectCSSText = function (opts, properties, cssTextArr) {
        var lenBefore = cssTextArr.length;
        for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
            var property = properties_1[_i];
            var value = this.resolveValue(opts[property]);
            if (typeof value === 'string') {
                cssTextArr.push(__WEBPACK_IMPORTED_MODULE_0__base_common_strings_js__["format"](_CSS_MAP[property], value));
            }
        }
        return cssTextArr.length !== lenBefore;
    };
    DecorationCSSRules.prototype.resolveValue = function (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__common_editorCommon_js__["c" /* isThemeColor */])(value)) {
            this._usesThemeColors = true;
            var color = this._theme.getColor(value.id);
            if (color) {
                return color.toString();
            }
            return 'transparent';
        }
        return value;
    };
    return DecorationCSSRules;
}());
var CSSNameHelper = /** @class */ (function () {
    function CSSNameHelper() {
    }
    CSSNameHelper.getClassName = function (key, type) {
        return 'ced-' + key + '-' + type;
    };
    CSSNameHelper.getSelector = function (key, parentKey, ruleType) {
        var selector = '.monaco-editor .' + this.getClassName(key, ruleType);
        if (parentKey) {
            selector = selector + '.' + this.getClassName(parentKey, ruleType);
        }
        if (ruleType === 3 /* BeforeContentClassName */) {
            selector += '::before';
        }
        else if (ruleType === 4 /* AfterContentClassName */) {
            selector += '::after';
        }
        return selector;
    };
    return CSSNameHelper;
}());


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractCodeEditorService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var AbstractCodeEditorService = /** @class */ (function () {
    function AbstractCodeEditorService() {
        this._codeEditors = Object.create(null);
        this._diffEditors = Object.create(null);
        this._onCodeEditorAdd = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this._onCodeEditorRemove = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this._onDiffEditorAdd = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
        this._onDiffEditorRemove = new __WEBPACK_IMPORTED_MODULE_0__base_common_event_js__["a" /* Emitter */]();
    }
    AbstractCodeEditorService.prototype.addCodeEditor = function (editor) {
        this._codeEditors[editor.getId()] = editor;
        this._onCodeEditorAdd.fire(editor);
    };
    Object.defineProperty(AbstractCodeEditorService.prototype, "onCodeEditorAdd", {
        get: function () {
            return this._onCodeEditorAdd.event;
        },
        enumerable: true,
        configurable: true
    });
    AbstractCodeEditorService.prototype.removeCodeEditor = function (editor) {
        if (delete this._codeEditors[editor.getId()]) {
            this._onCodeEditorRemove.fire(editor);
        }
    };
    AbstractCodeEditorService.prototype.listCodeEditors = function () {
        var _this = this;
        return Object.keys(this._codeEditors).map(function (id) { return _this._codeEditors[id]; });
    };
    AbstractCodeEditorService.prototype.addDiffEditor = function (editor) {
        this._diffEditors[editor.getId()] = editor;
        this._onDiffEditorAdd.fire(editor);
    };
    AbstractCodeEditorService.prototype.removeDiffEditor = function (editor) {
        if (delete this._diffEditors[editor.getId()]) {
            this._onDiffEditorRemove.fire(editor);
        }
    };
    AbstractCodeEditorService.prototype.listDiffEditors = function () {
        var _this = this;
        return Object.keys(this._diffEditors).map(function (id) { return _this._diffEditors[id]; });
    };
    AbstractCodeEditorService.prototype.getFocusedCodeEditor = function () {
        var editorWithWidgetFocus = null;
        var editors = this.listCodeEditors();
        for (var i = 0; i < editors.length; i++) {
            var editor = editors[i];
            if (editor.hasTextFocus()) {
                // bingo!
                return editor;
            }
            if (editor.hasWidgetFocus()) {
                editorWithWidgetFocus = editor;
            }
        }
        return editorWithWidgetFocus;
    };
    return AbstractCodeEditorService;
}());



/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Context */
/* unused harmony export ContextKeyChangeEvent */
/* unused harmony export AbstractContextKeyService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextKeyService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keybinding_common_keybindingResolver_js__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_contextkey_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configuration_common_configuration_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};






var KEYBINDING_CONTEXT_ATTR = 'data-keybinding-context';
var Context = /** @class */ (function () {
    function Context(id, parent) {
        this._id = id;
        this._parent = parent;
        this._value = Object.create(null);
        this._value['_contextId'] = id;
    }
    Context.prototype.setValue = function (key, value) {
        // console.log('SET ' + key + ' = ' + value + ' ON ' + this._id);
        if (this._value[key] !== value) {
            this._value[key] = value;
            return true;
        }
        return false;
    };
    Context.prototype.removeValue = function (key) {
        // console.log('REMOVE ' + key + ' FROM ' + this._id);
        if (key in this._value) {
            delete this._value[key];
            return true;
        }
        return false;
    };
    Context.prototype.getValue = function (key) {
        var ret = this._value[key];
        if (typeof ret === 'undefined' && this._parent) {
            return this._parent.getValue(key);
        }
        return ret;
    };
    return Context;
}());

var ConfigAwareContextValuesContainer = /** @class */ (function (_super) {
    __extends(ConfigAwareContextValuesContainer, _super);
    function ConfigAwareContextValuesContainer(id, configurationService, emitter) {
        var _this = _super.call(this, id, null) || this;
        _this._emitter = emitter;
        _this._configurationService = configurationService;
        _this._subscription = configurationService.onDidChangeConfiguration(_this._onConfigurationUpdated, _this);
        _this._initFromConfiguration();
        return _this;
    }
    ConfigAwareContextValuesContainer.prototype.dispose = function () {
        this._subscription.dispose();
    };
    ConfigAwareContextValuesContainer.prototype._onConfigurationUpdated = function (event) {
        if (event.source === __WEBPACK_IMPORTED_MODULE_4__configuration_common_configuration_js__["a" /* ConfigurationTarget */].DEFAULT) {
            // new setting, rebuild everything
            this._initFromConfiguration();
        }
        else {
            // update those that we know
            for (var _i = 0, _a = event.affectedKeys; _i < _a.length; _i++) {
                var configKey = _a[_i];
                var contextKey = "config." + configKey;
                if (contextKey in this._value) {
                    this._value[contextKey] = this._configurationService.getValue(configKey);
                    this._emitter.fire(contextKey);
                }
            }
        }
    };
    ConfigAwareContextValuesContainer.prototype._initFromConfiguration = function () {
        var _this = this;
        var prefix = 'config.';
        var config = this._configurationService.getValue();
        var configKeys = Object.create(null);
        var configKeysChanged = [];
        // add new value from config
        var walk = function (obj, keys) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    keys.push(key);
                    var value = obj[key];
                    if (typeof value === 'boolean') {
                        var configKey = keys.join('.');
                        var oldValue = _this._value[configKey];
                        _this._value[configKey] = value;
                        if (oldValue !== value) {
                            configKeysChanged.push(configKey);
                            configKeys[configKey] = true;
                        }
                        else {
                            configKeys[configKey] = false;
                        }
                    }
                    else if (typeof value === 'object') {
                        walk(value, keys);
                    }
                    keys.pop();
                }
            }
        };
        walk(config, ['config']);
        // remove unused keys
        for (var key in this._value) {
            if (key.indexOf(prefix) === 0 && configKeys[key] === undefined) {
                delete this._value[key];
                configKeys[key] = true;
                configKeysChanged.push(key);
            }
        }
        // send events
        this._emitter.fire(configKeysChanged);
    };
    return ConfigAwareContextValuesContainer;
}(Context));
var ContextKey = /** @class */ (function () {
    function ContextKey(parent, key, defaultValue) {
        this._parent = parent;
        this._key = key;
        this._defaultValue = defaultValue;
        this.reset();
    }
    ContextKey.prototype.set = function (value) {
        this._parent.setContext(this._key, value);
    };
    ContextKey.prototype.reset = function () {
        if (typeof this._defaultValue === 'undefined') {
            this._parent.removeContext(this._key);
        }
        else {
            this._parent.setContext(this._key, this._defaultValue);
        }
    };
    ContextKey.prototype.get = function () {
        return this._parent.getContextKeyValue(this._key);
    };
    return ContextKey;
}());
var ContextKeyChangeEvent = /** @class */ (function () {
    function ContextKeyChangeEvent() {
        this._keys = [];
    }
    ContextKeyChangeEvent.prototype.collect = function (oneOrManyKeys) {
        this._keys = this._keys.concat(oneOrManyKeys);
    };
    ContextKeyChangeEvent.prototype.affectsSome = function (keys) {
        for (var _i = 0, _a = this._keys; _i < _a.length; _i++) {
            var key = _a[_i];
            if (keys.has(key)) {
                return true;
            }
        }
        return false;
    };
    return ContextKeyChangeEvent;
}());

var AbstractContextKeyService = /** @class */ (function () {
    function AbstractContextKeyService(myContextId) {
        this._myContextId = myContextId;
        this._onDidChangeContextKey = new __WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["a" /* Emitter */]();
    }
    AbstractContextKeyService.prototype.createKey = function (key, defaultValue) {
        return new ContextKey(this, key, defaultValue);
    };
    Object.defineProperty(AbstractContextKeyService.prototype, "onDidChangeContext", {
        get: function () {
            if (!this._onDidChangeContext) {
                this._onDidChangeContext = Object(__WEBPACK_IMPORTED_MODULE_5__base_common_event_js__["h" /* debounceEvent */])(this._onDidChangeContextKey.event, function (prev, cur) {
                    if (!prev) {
                        prev = new ContextKeyChangeEvent();
                    }
                    prev.collect(cur);
                    return prev;
                }, 25);
            }
            return this._onDidChangeContext;
        },
        enumerable: true,
        configurable: true
    });
    AbstractContextKeyService.prototype.createScoped = function (domNode) {
        return new ScopedContextKeyService(this, this._onDidChangeContextKey, domNode);
    };
    AbstractContextKeyService.prototype.contextMatchesRules = function (rules) {
        var context = this.getContextValuesContainer(this._myContextId);
        var result = __WEBPACK_IMPORTED_MODULE_2__keybinding_common_keybindingResolver_js__["a" /* KeybindingResolver */].contextMatchesRules(context, rules);
        // console.group(rules.serialize() + ' -> ' + result);
        // rules.keys().forEach(key => { console.log(key, ctx[key]); });
        // console.groupEnd();
        return result;
    };
    AbstractContextKeyService.prototype.getContextKeyValue = function (key) {
        return this.getContextValuesContainer(this._myContextId).getValue(key);
    };
    AbstractContextKeyService.prototype.setContext = function (key, value) {
        var myContext = this.getContextValuesContainer(this._myContextId);
        if (!myContext) {
            return;
        }
        if (myContext.setValue(key, value)) {
            this._onDidChangeContextKey.fire(key);
        }
    };
    AbstractContextKeyService.prototype.removeContext = function (key) {
        if (this.getContextValuesContainer(this._myContextId).removeValue(key)) {
            this._onDidChangeContextKey.fire(key);
        }
    };
    AbstractContextKeyService.prototype.getContext = function (target) {
        return this.getContextValuesContainer(findContextAttr(target));
    };
    return AbstractContextKeyService;
}());

var ContextKeyService = /** @class */ (function (_super) {
    __extends(ContextKeyService, _super);
    function ContextKeyService(configurationService) {
        var _this = _super.call(this, 0) || this;
        _this._toDispose = [];
        _this._lastContextId = 0;
        _this._contexts = Object.create(null);
        var myContext = new ConfigAwareContextValuesContainer(_this._myContextId, configurationService, _this._onDidChangeContextKey);
        _this._contexts[String(_this._myContextId)] = myContext;
        _this._toDispose.push(myContext);
        return _this;
        // Uncomment this to see the contexts continuously logged
        // let lastLoggedValue: string = null;
        // setInterval(() => {
        // 	let values = Object.keys(this._contexts).map((key) => this._contexts[key]);
        // 	let logValue = values.map(v => JSON.stringify(v._value, null, '\t')).join('\n');
        // 	if (lastLoggedValue !== logValue) {
        // 		lastLoggedValue = logValue;
        // 		console.log(lastLoggedValue);
        // 	}
        // }, 2000);
    }
    ContextKeyService.prototype.dispose = function () {
        this._toDispose = Object(__WEBPACK_IMPORTED_MODULE_0__base_common_lifecycle_js__["d" /* dispose */])(this._toDispose);
    };
    ContextKeyService.prototype.getContextValuesContainer = function (contextId) {
        return this._contexts[String(contextId)];
    };
    ContextKeyService.prototype.createChildContext = function (parentContextId) {
        if (parentContextId === void 0) { parentContextId = this._myContextId; }
        var id = (++this._lastContextId);
        this._contexts[String(id)] = new Context(id, this.getContextValuesContainer(parentContextId));
        return id;
    };
    ContextKeyService.prototype.disposeContext = function (contextId) {
        delete this._contexts[String(contextId)];
    };
    ContextKeyService = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_4__configuration_common_configuration_js__["b" /* IConfigurationService */])
    ], ContextKeyService);
    return ContextKeyService;
}(AbstractContextKeyService));

var ScopedContextKeyService = /** @class */ (function (_super) {
    __extends(ScopedContextKeyService, _super);
    function ScopedContextKeyService(parent, emitter, domNode) {
        var _this = _super.call(this, parent.createChildContext()) || this;
        _this._parent = parent;
        _this._onDidChangeContextKey = emitter;
        if (domNode) {
            _this._domNode = domNode;
            _this._domNode.setAttribute(KEYBINDING_CONTEXT_ATTR, String(_this._myContextId));
        }
        return _this;
    }
    ScopedContextKeyService.prototype.dispose = function () {
        this._parent.disposeContext(this._myContextId);
        if (this._domNode) {
            this._domNode.removeAttribute(KEYBINDING_CONTEXT_ATTR);
            this._domNode = undefined;
        }
    };
    Object.defineProperty(ScopedContextKeyService.prototype, "onDidChangeContext", {
        get: function () {
            return this._parent.onDidChangeContext;
        },
        enumerable: true,
        configurable: true
    });
    ScopedContextKeyService.prototype.getContextValuesContainer = function (contextId) {
        return this._parent.getContextValuesContainer(contextId);
    };
    ScopedContextKeyService.prototype.createChildContext = function (parentContextId) {
        if (parentContextId === void 0) { parentContextId = this._myContextId; }
        return this._parent.createChildContext(parentContextId);
    };
    ScopedContextKeyService.prototype.disposeContext = function (contextId) {
        this._parent.disposeContext(contextId);
    };
    return ScopedContextKeyService;
}(AbstractContextKeyService));
function findContextAttr(domNode) {
    while (domNode) {
        if (domNode.hasAttribute(KEYBINDING_CONTEXT_ATTR)) {
            return parseInt(domNode.getAttribute(KEYBINDING_CONTEXT_ATTR), 10);
        }
        domNode = domNode.parentElement;
    }
    return 0;
}
__WEBPACK_IMPORTED_MODULE_1__commands_common_commands_js__["a" /* CommandsRegistry */].registerCommand(__WEBPACK_IMPORTED_MODULE_3__common_contextkey_js__["g" /* SET_CONTEXT_COMMAND_ID */], function (accessor, contextKey, contextValue) {
    accessor.get(__WEBPACK_IMPORTED_MODULE_3__common_contextkey_js__["e" /* IContextKeyService */]).createKey(String(contextKey), contextValue);
});


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandaloneThemeServiceImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modes_supports_tokenization_js__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_themes_js__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_color_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_registry_common_platform_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_common_event_js__ = __webpack_require__(5);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/










var VS_THEME_NAME = 'vs';
var VS_DARK_THEME_NAME = 'vs-dark';
var HC_BLACK_THEME_NAME = 'hc-black';
var colorRegistry = __WEBPACK_IMPORTED_MODULE_7__platform_registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_5__platform_theme_common_colorRegistry_js__["a" /* Extensions */].ColorContribution);
var themingRegistry = __WEBPACK_IMPORTED_MODULE_7__platform_registry_common_platform_js__["a" /* Registry */].as(__WEBPACK_IMPORTED_MODULE_6__platform_theme_common_themeService_js__["a" /* Extensions */].ThemingContribution);
var StandaloneTheme = /** @class */ (function () {
    function StandaloneTheme(name, standaloneThemeData) {
        this.themeData = standaloneThemeData;
        var base = standaloneThemeData.base;
        if (name.length > 0) {
            this.id = base + ' ' + name;
            this.themeName = name;
        }
        else {
            this.id = base;
            this.themeName = base;
        }
        this.colors = null;
        this.defaultColors = Object.create(null);
        this._tokenTheme = null;
    }
    Object.defineProperty(StandaloneTheme.prototype, "base", {
        get: function () {
            return this.themeData.base;
        },
        enumerable: true,
        configurable: true
    });
    StandaloneTheme.prototype.notifyBaseUpdated = function () {
        if (this.themeData.inherit) {
            this.colors = null;
            this._tokenTheme = null;
        }
    };
    StandaloneTheme.prototype.getColors = function () {
        if (!this.colors) {
            var colors = Object.create(null);
            for (var id in this.themeData.colors) {
                colors[id] = __WEBPACK_IMPORTED_MODULE_4__base_common_color_js__["a" /* Color */].fromHex(this.themeData.colors[id]);
            }
            if (this.themeData.inherit) {
                var baseData = getBuiltinRules(this.themeData.base);
                for (var id in baseData.colors) {
                    if (!colors[id]) {
                        colors[id] = __WEBPACK_IMPORTED_MODULE_4__base_common_color_js__["a" /* Color */].fromHex(baseData.colors[id]);
                    }
                }
            }
            this.colors = colors;
        }
        return this.colors;
    };
    StandaloneTheme.prototype.getColor = function (colorId, useDefault) {
        var color = this.getColors()[colorId];
        if (color) {
            return color;
        }
        if (useDefault !== false) {
            return this.getDefault(colorId);
        }
        return null;
    };
    StandaloneTheme.prototype.getDefault = function (colorId) {
        var color = this.defaultColors[colorId];
        if (color) {
            return color;
        }
        color = colorRegistry.resolveDefaultColor(colorId, this);
        this.defaultColors[colorId] = color;
        return color;
    };
    StandaloneTheme.prototype.defines = function (colorId) {
        return Object.prototype.hasOwnProperty.call(this.getColors(), colorId);
    };
    Object.defineProperty(StandaloneTheme.prototype, "type", {
        get: function () {
            switch (this.base) {
                case VS_THEME_NAME: return 'light';
                case HC_BLACK_THEME_NAME: return 'hc';
                default: return 'dark';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneTheme.prototype, "tokenTheme", {
        get: function () {
            if (!this._tokenTheme) {
                var rules = [];
                var encodedTokensColors = [];
                if (this.themeData.inherit) {
                    var baseData = getBuiltinRules(this.themeData.base);
                    rules = baseData.rules;
                    if (baseData.encodedTokensColors) {
                        encodedTokensColors = baseData.encodedTokensColors;
                    }
                }
                rules = rules.concat(this.themeData.rules);
                if (this.themeData.encodedTokensColors) {
                    encodedTokensColors = this.themeData.encodedTokensColors;
                }
                this._tokenTheme = __WEBPACK_IMPORTED_MODULE_0__common_modes_supports_tokenization_js__["a" /* TokenTheme */].createFromRawTokenTheme(rules, encodedTokensColors);
            }
            return this._tokenTheme;
        },
        enumerable: true,
        configurable: true
    });
    return StandaloneTheme;
}());
function isBuiltinTheme(themeName) {
    return (themeName === VS_THEME_NAME
        || themeName === VS_DARK_THEME_NAME
        || themeName === HC_BLACK_THEME_NAME);
}
function getBuiltinRules(builtinTheme) {
    switch (builtinTheme) {
        case VS_THEME_NAME:
            return __WEBPACK_IMPORTED_MODULE_1__common_themes_js__["b" /* vs */];
        case VS_DARK_THEME_NAME:
            return __WEBPACK_IMPORTED_MODULE_1__common_themes_js__["c" /* vs_dark */];
        case HC_BLACK_THEME_NAME:
            return __WEBPACK_IMPORTED_MODULE_1__common_themes_js__["a" /* hc_black */];
    }
}
function newBuiltInTheme(builtinTheme) {
    var themeData = getBuiltinRules(builtinTheme);
    return new StandaloneTheme(builtinTheme, themeData);
}
var StandaloneThemeServiceImpl = /** @class */ (function () {
    function StandaloneThemeServiceImpl() {
        this.environment = Object.create(null);
        this._onThemeChange = new __WEBPACK_IMPORTED_MODULE_8__base_common_event_js__["a" /* Emitter */]();
        this._knownThemes = new Map();
        this._knownThemes.set(VS_THEME_NAME, newBuiltInTheme(VS_THEME_NAME));
        this._knownThemes.set(VS_DARK_THEME_NAME, newBuiltInTheme(VS_DARK_THEME_NAME));
        this._knownThemes.set(HC_BLACK_THEME_NAME, newBuiltInTheme(HC_BLACK_THEME_NAME));
        this._styleElement = __WEBPACK_IMPORTED_MODULE_2__base_browser_dom_js__["o" /* createStyleSheet */]();
        this._styleElement.className = 'monaco-colors';
        this.setTheme(VS_THEME_NAME);
    }
    Object.defineProperty(StandaloneThemeServiceImpl.prototype, "onThemeChange", {
        get: function () {
            return this._onThemeChange.event;
        },
        enumerable: true,
        configurable: true
    });
    StandaloneThemeServiceImpl.prototype.defineTheme = function (themeName, themeData) {
        if (!/^[a-z0-9\-]+$/i.test(themeName)) {
            throw new Error('Illegal theme name!');
        }
        if (!isBuiltinTheme(themeData.base) && !isBuiltinTheme(themeName)) {
            throw new Error('Illegal theme base!');
        }
        // set or replace theme
        this._knownThemes.set(themeName, new StandaloneTheme(themeName, themeData));
        if (isBuiltinTheme(themeName)) {
            this._knownThemes.forEach(function (theme) {
                if (theme.base === themeName) {
                    theme.notifyBaseUpdated();
                }
            });
        }
        if (this._theme && this._theme.themeName === themeName) {
            this.setTheme(themeName); // refresh theme
        }
    };
    StandaloneThemeServiceImpl.prototype.getTheme = function () {
        return this._theme;
    };
    StandaloneThemeServiceImpl.prototype.setTheme = function (themeName) {
        var _this = this;
        var theme;
        if (this._knownThemes.has(themeName)) {
            theme = this._knownThemes.get(themeName);
        }
        else {
            theme = this._knownThemes.get(VS_THEME_NAME);
        }
        this._theme = theme;
        var cssRules = [];
        var hasRule = {};
        var ruleCollector = {
            addRule: function (rule) {
                if (!hasRule[rule]) {
                    cssRules.push(rule);
                    hasRule[rule] = true;
                }
            }
        };
        themingRegistry.getThemingParticipants().forEach(function (p) { return p(theme, ruleCollector, _this.environment); });
        var tokenTheme = theme.tokenTheme;
        var colorMap = tokenTheme.getColorMap();
        ruleCollector.addRule(Object(__WEBPACK_IMPORTED_MODULE_0__common_modes_supports_tokenization_js__["b" /* generateTokensCSSForColorMap */])(colorMap));
        this._styleElement.innerHTML = cssRules.join('\n');
        __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["y" /* TokenizationRegistry */].setColorMap(colorMap);
        this._onThemeChange.fire(theme);
        return theme.id;
    };
    return StandaloneThemeServiceImpl;
}());



/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ParsedTokenThemeRule */
/* unused harmony export parseTokenTheme */
/* unused harmony export ColorMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenTheme; });
/* unused harmony export toStandardTokenType */
/* unused harmony export strcmp */
/* unused harmony export ThemeTrieElementRule */
/* unused harmony export ThemeTrieElement */
/* harmony export (immutable) */ __webpack_exports__["b"] = generateTokensCSSForColorMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_color_js__ = __webpack_require__(24);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var ParsedTokenThemeRule = /** @class */ (function () {
    function ParsedTokenThemeRule(token, index, fontStyle, foreground, background) {
        this.token = token;
        this.index = index;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
    return ParsedTokenThemeRule;
}());

/**
 * Parse a raw theme into rules.
 */
function parseTokenTheme(source) {
    if (!source || !Array.isArray(source)) {
        return [];
    }
    var result = [], resultLen = 0;
    for (var i = 0, len = source.length; i < len; i++) {
        var entry = source[i];
        var fontStyle = -1 /* NotSet */;
        if (typeof entry.fontStyle === 'string') {
            fontStyle = 0 /* None */;
            var segments = entry.fontStyle.split(' ');
            for (var j = 0, lenJ = segments.length; j < lenJ; j++) {
                var segment = segments[j];
                switch (segment) {
                    case 'italic':
                        fontStyle = fontStyle | 1 /* Italic */;
                        break;
                    case 'bold':
                        fontStyle = fontStyle | 2 /* Bold */;
                        break;
                    case 'underline':
                        fontStyle = fontStyle | 4 /* Underline */;
                        break;
                }
            }
        }
        var foreground = null;
        if (typeof entry.foreground === 'string') {
            foreground = entry.foreground;
        }
        var background = null;
        if (typeof entry.background === 'string') {
            background = entry.background;
        }
        result[resultLen++] = new ParsedTokenThemeRule(entry.token || '', i, fontStyle, foreground, background);
    }
    return result;
}
/**
 * Resolve rules (i.e. inheritance).
 */
function resolveParsedTokenThemeRules(parsedThemeRules, customTokenColors) {
    // Sort rules lexicographically, and then by index if necessary
    parsedThemeRules.sort(function (a, b) {
        var r = strcmp(a.token, b.token);
        if (r !== 0) {
            return r;
        }
        return a.index - b.index;
    });
    // Determine defaults
    var defaultFontStyle = 0 /* None */;
    var defaultForeground = '000000';
    var defaultBackground = 'ffffff';
    while (parsedThemeRules.length >= 1 && parsedThemeRules[0].token === '') {
        var incomingDefaults = parsedThemeRules.shift();
        if (incomingDefaults.fontStyle !== -1 /* NotSet */) {
            defaultFontStyle = incomingDefaults.fontStyle;
        }
        if (incomingDefaults.foreground !== null) {
            defaultForeground = incomingDefaults.foreground;
        }
        if (incomingDefaults.background !== null) {
            defaultBackground = incomingDefaults.background;
        }
    }
    var colorMap = new ColorMap();
    // start with token colors from custom token themes
    for (var _i = 0, customTokenColors_1 = customTokenColors; _i < customTokenColors_1.length; _i++) {
        var color = customTokenColors_1[_i];
        colorMap.getId(color);
    }
    var foregroundColorId = colorMap.getId(defaultForeground);
    var backgroundColorId = colorMap.getId(defaultBackground);
    var defaults = new ThemeTrieElementRule(defaultFontStyle, foregroundColorId, backgroundColorId);
    var root = new ThemeTrieElement(defaults);
    for (var i = 0, len = parsedThemeRules.length; i < len; i++) {
        var rule = parsedThemeRules[i];
        root.insert(rule.token, rule.fontStyle, colorMap.getId(rule.foreground), colorMap.getId(rule.background));
    }
    return new TokenTheme(colorMap, root);
}
var colorRegExp = /^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/;
var ColorMap = /** @class */ (function () {
    function ColorMap() {
        this._lastColorId = 0;
        this._id2color = [];
        this._color2id = new Map();
    }
    ColorMap.prototype.getId = function (color) {
        if (color === null) {
            return 0;
        }
        var match = color.match(colorRegExp);
        if (!match) {
            throw new Error('Illegal value for token color: ' + color);
        }
        color = match[1].toUpperCase();
        var value = this._color2id.get(color);
        if (value) {
            return value;
        }
        value = ++this._lastColorId;
        this._color2id.set(color, value);
        this._id2color[value] = __WEBPACK_IMPORTED_MODULE_0__base_common_color_js__["a" /* Color */].fromHex('#' + color);
        return value;
    };
    ColorMap.prototype.getColorMap = function () {
        return this._id2color.slice(0);
    };
    return ColorMap;
}());

var TokenTheme = /** @class */ (function () {
    function TokenTheme(colorMap, root) {
        this._colorMap = colorMap;
        this._root = root;
        this._cache = new Map();
    }
    TokenTheme.createFromRawTokenTheme = function (source, customTokenColors) {
        return this.createFromParsedTokenTheme(parseTokenTheme(source), customTokenColors);
    };
    TokenTheme.createFromParsedTokenTheme = function (source, customTokenColors) {
        return resolveParsedTokenThemeRules(source, customTokenColors);
    };
    TokenTheme.prototype.getColorMap = function () {
        return this._colorMap.getColorMap();
    };
    TokenTheme.prototype._match = function (token) {
        return this._root.match(token);
    };
    TokenTheme.prototype.match = function (languageId, token) {
        // The cache contains the metadata without the language bits set.
        var result = this._cache.get(token);
        if (typeof result === 'undefined') {
            var rule = this._match(token);
            var standardToken = toStandardTokenType(token);
            result = (rule.metadata
                | (standardToken << 8 /* TOKEN_TYPE_OFFSET */)) >>> 0;
            this._cache.set(token, result);
        }
        return (result
            | (languageId << 0 /* LANGUAGEID_OFFSET */)) >>> 0;
    };
    return TokenTheme;
}());

var STANDARD_TOKEN_TYPE_REGEXP = /\b(comment|string|regex)\b/;
function toStandardTokenType(tokenType) {
    var m = tokenType.match(STANDARD_TOKEN_TYPE_REGEXP);
    if (!m) {
        return 0 /* Other */;
    }
    switch (m[1]) {
        case 'comment':
            return 1 /* Comment */;
        case 'string':
            return 2 /* String */;
        case 'regex':
            return 4 /* RegEx */;
    }
    throw new Error('Unexpected match for standard token type!');
}
function strcmp(a, b) {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
}
var ThemeTrieElementRule = /** @class */ (function () {
    function ThemeTrieElementRule(fontStyle, foreground, background) {
        this._fontStyle = fontStyle;
        this._foreground = foreground;
        this._background = background;
        this.metadata = ((this._fontStyle << 11 /* FONT_STYLE_OFFSET */)
            | (this._foreground << 14 /* FOREGROUND_OFFSET */)
            | (this._background << 23 /* BACKGROUND_OFFSET */)) >>> 0;
    }
    ThemeTrieElementRule.prototype.clone = function () {
        return new ThemeTrieElementRule(this._fontStyle, this._foreground, this._background);
    };
    ThemeTrieElementRule.prototype.acceptOverwrite = function (fontStyle, foreground, background) {
        if (fontStyle !== -1 /* NotSet */) {
            this._fontStyle = fontStyle;
        }
        if (foreground !== 0 /* None */) {
            this._foreground = foreground;
        }
        if (background !== 0 /* None */) {
            this._background = background;
        }
        this.metadata = ((this._fontStyle << 11 /* FONT_STYLE_OFFSET */)
            | (this._foreground << 14 /* FOREGROUND_OFFSET */)
            | (this._background << 23 /* BACKGROUND_OFFSET */)) >>> 0;
    };
    return ThemeTrieElementRule;
}());

var ThemeTrieElement = /** @class */ (function () {
    function ThemeTrieElement(mainRule) {
        this._mainRule = mainRule;
        this._children = new Map();
    }
    ThemeTrieElement.prototype.match = function (token) {
        if (token === '') {
            return this._mainRule;
        }
        var dotIndex = token.indexOf('.');
        var head;
        var tail;
        if (dotIndex === -1) {
            head = token;
            tail = '';
        }
        else {
            head = token.substring(0, dotIndex);
            tail = token.substring(dotIndex + 1);
        }
        var child = this._children.get(head);
        if (typeof child !== 'undefined') {
            return child.match(tail);
        }
        return this._mainRule;
    };
    ThemeTrieElement.prototype.insert = function (token, fontStyle, foreground, background) {
        if (token === '') {
            // Merge into the main rule
            this._mainRule.acceptOverwrite(fontStyle, foreground, background);
            return;
        }
        var dotIndex = token.indexOf('.');
        var head;
        var tail;
        if (dotIndex === -1) {
            head = token;
            tail = '';
        }
        else {
            head = token.substring(0, dotIndex);
            tail = token.substring(dotIndex + 1);
        }
        var child = this._children.get(head);
        if (typeof child === 'undefined') {
            child = new ThemeTrieElement(this._mainRule.clone());
            this._children.set(head, child);
        }
        child.insert(tail, fontStyle, foreground, background);
    };
    return ThemeTrieElement;
}());

function generateTokensCSSForColorMap(colorMap) {
    var rules = [];
    for (var i = 1, len = colorMap.length; i < len; i++) {
        var color = colorMap[i];
        rules[i] = ".mtk" + i + " { color: " + color + "; }";
    }
    rules.push('.mtki { font-style: italic; }');
    rules.push('.mtkb { font-weight: bold; }');
    rules.push('.mtku { text-decoration: underline; text-underline-position: under; }');
    return rules.join('\n');
}


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return vs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return vs_dark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hc_black; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__ = __webpack_require__(32);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var _a, _b, _c;


/* -------------------------------- Begin vs theme -------------------------------- */
var vs = {
    base: 'vs',
    inherit: false,
    rules: [
        { token: '', foreground: '000000', background: 'fffffe' },
        { token: 'invalid', foreground: 'cd3131' },
        { token: 'emphasis', fontStyle: 'italic' },
        { token: 'strong', fontStyle: 'bold' },
        { token: 'variable', foreground: '001188' },
        { token: 'variable.predefined', foreground: '4864AA' },
        { token: 'constant', foreground: 'dd0000' },
        { token: 'comment', foreground: '008000' },
        { token: 'number', foreground: '09885A' },
        { token: 'number.hex', foreground: '3030c0' },
        { token: 'regexp', foreground: '800000' },
        { token: 'annotation', foreground: '808080' },
        { token: 'type', foreground: '008080' },
        { token: 'delimiter', foreground: '000000' },
        { token: 'delimiter.html', foreground: '383838' },
        { token: 'delimiter.xml', foreground: '0000FF' },
        { token: 'tag', foreground: '800000' },
        { token: 'tag.id.pug', foreground: '4F76AC' },
        { token: 'tag.class.pug', foreground: '4F76AC' },
        { token: 'meta.scss', foreground: '800000' },
        { token: 'metatag', foreground: 'e00000' },
        { token: 'metatag.content.html', foreground: 'FF0000' },
        { token: 'metatag.html', foreground: '808080' },
        { token: 'metatag.xml', foreground: '808080' },
        { token: 'metatag.php', fontStyle: 'bold' },
        { token: 'key', foreground: '863B00' },
        { token: 'string.key.json', foreground: 'A31515' },
        { token: 'string.value.json', foreground: '0451A5' },
        { token: 'attribute.name', foreground: 'FF0000' },
        { token: 'attribute.value', foreground: '0451A5' },
        { token: 'attribute.value.number', foreground: '09885A' },
        { token: 'attribute.value.unit', foreground: '09885A' },
        { token: 'attribute.value.html', foreground: '0000FF' },
        { token: 'attribute.value.xml', foreground: '0000FF' },
        { token: 'string', foreground: 'A31515' },
        { token: 'string.html', foreground: '0000FF' },
        { token: 'string.sql', foreground: 'FF0000' },
        { token: 'string.yaml', foreground: '0451A5' },
        { token: 'keyword', foreground: '0000FF' },
        { token: 'keyword.json', foreground: '0451A5' },
        { token: 'keyword.flow', foreground: 'AF00DB' },
        { token: 'keyword.flow.scss', foreground: '0000FF' },
        { token: 'operator.scss', foreground: '666666' },
        { token: 'operator.sql', foreground: '778899' },
        { token: 'operator.swift', foreground: '666666' },
        { token: 'predefined.sql', foreground: 'FF00FF' },
    ],
    colors: (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["n" /* editorBackground */]] = '#FFFFFE',
        _a[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["u" /* editorForeground */]] = '#000000',
        _a[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["y" /* editorInactiveSelection */]] = '#E5EBF1',
        _a[__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["l" /* editorIndentGuides */]] = '#D3D3D3',
        _a[__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["a" /* editorActiveIndentGuides */]] = '#939393',
        _a[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["B" /* editorSelectionHighlight */]] = '#ADD6FF4D',
        _a)
};
/* -------------------------------- End vs theme -------------------------------- */
/* -------------------------------- Begin vs-dark theme -------------------------------- */
var vs_dark = {
    base: 'vs-dark',
    inherit: false,
    rules: [
        { token: '', foreground: 'D4D4D4', background: '1E1E1E' },
        { token: 'invalid', foreground: 'f44747' },
        { token: 'emphasis', fontStyle: 'italic' },
        { token: 'strong', fontStyle: 'bold' },
        { token: 'variable', foreground: '74B0DF' },
        { token: 'variable.predefined', foreground: '4864AA' },
        { token: 'variable.parameter', foreground: '9CDCFE' },
        { token: 'constant', foreground: '569CD6' },
        { token: 'comment', foreground: '608B4E' },
        { token: 'number', foreground: 'B5CEA8' },
        { token: 'number.hex', foreground: '5BB498' },
        { token: 'regexp', foreground: 'B46695' },
        { token: 'annotation', foreground: 'cc6666' },
        { token: 'type', foreground: '3DC9B0' },
        { token: 'delimiter', foreground: 'DCDCDC' },
        { token: 'delimiter.html', foreground: '808080' },
        { token: 'delimiter.xml', foreground: '808080' },
        { token: 'tag', foreground: '569CD6' },
        { token: 'tag.id.pug', foreground: '4F76AC' },
        { token: 'tag.class.pug', foreground: '4F76AC' },
        { token: 'meta.scss', foreground: 'A79873' },
        { token: 'meta.tag', foreground: 'CE9178' },
        { token: 'metatag', foreground: 'DD6A6F' },
        { token: 'metatag.content.html', foreground: '9CDCFE' },
        { token: 'metatag.html', foreground: '569CD6' },
        { token: 'metatag.xml', foreground: '569CD6' },
        { token: 'metatag.php', fontStyle: 'bold' },
        { token: 'key', foreground: '9CDCFE' },
        { token: 'string.key.json', foreground: '9CDCFE' },
        { token: 'string.value.json', foreground: 'CE9178' },
        { token: 'attribute.name', foreground: '9CDCFE' },
        { token: 'attribute.value', foreground: 'CE9178' },
        { token: 'attribute.value.number.css', foreground: 'B5CEA8' },
        { token: 'attribute.value.unit.css', foreground: 'B5CEA8' },
        { token: 'attribute.value.hex.css', foreground: 'D4D4D4' },
        { token: 'string', foreground: 'CE9178' },
        { token: 'string.sql', foreground: 'FF0000' },
        { token: 'keyword', foreground: '569CD6' },
        { token: 'keyword.flow', foreground: 'C586C0' },
        { token: 'keyword.json', foreground: 'CE9178' },
        { token: 'keyword.flow.scss', foreground: '569CD6' },
        { token: 'operator.scss', foreground: '909090' },
        { token: 'operator.sql', foreground: '778899' },
        { token: 'operator.swift', foreground: '909090' },
        { token: 'predefined.sql', foreground: 'FF00FF' },
    ],
    colors: (_b = {},
        _b[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["n" /* editorBackground */]] = '#1E1E1E',
        _b[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["u" /* editorForeground */]] = '#D4D4D4',
        _b[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["y" /* editorInactiveSelection */]] = '#3A3D41',
        _b[__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["l" /* editorIndentGuides */]] = '#404040',
        _b[__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["a" /* editorActiveIndentGuides */]] = '#707070',
        _b[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["B" /* editorSelectionHighlight */]] = '#ADD6FF26',
        _b)
};
/* -------------------------------- End vs-dark theme -------------------------------- */
/* -------------------------------- Begin hc-black theme -------------------------------- */
var hc_black = {
    base: 'hc-black',
    inherit: false,
    rules: [
        { token: '', foreground: 'FFFFFF', background: '000000' },
        { token: 'invalid', foreground: 'f44747' },
        { token: 'emphasis', fontStyle: 'italic' },
        { token: 'strong', fontStyle: 'bold' },
        { token: 'variable', foreground: '1AEBFF' },
        { token: 'variable.parameter', foreground: '9CDCFE' },
        { token: 'constant', foreground: '569CD6' },
        { token: 'comment', foreground: '608B4E' },
        { token: 'number', foreground: 'FFFFFF' },
        { token: 'regexp', foreground: 'C0C0C0' },
        { token: 'annotation', foreground: '569CD6' },
        { token: 'type', foreground: '3DC9B0' },
        { token: 'delimiter', foreground: 'FFFF00' },
        { token: 'delimiter.html', foreground: 'FFFF00' },
        { token: 'tag', foreground: '569CD6' },
        { token: 'tag.id.pug', foreground: '4F76AC' },
        { token: 'tag.class.pug', foreground: '4F76AC' },
        { token: 'meta', foreground: 'D4D4D4' },
        { token: 'meta.tag', foreground: 'CE9178' },
        { token: 'metatag', foreground: '569CD6' },
        { token: 'metatag.content.html', foreground: '1AEBFF' },
        { token: 'metatag.html', foreground: '569CD6' },
        { token: 'metatag.xml', foreground: '569CD6' },
        { token: 'metatag.php', fontStyle: 'bold' },
        { token: 'key', foreground: '9CDCFE' },
        { token: 'string.key', foreground: '9CDCFE' },
        { token: 'string.value', foreground: 'CE9178' },
        { token: 'attribute.name', foreground: '569CD6' },
        { token: 'attribute.value', foreground: '3FF23F' },
        { token: 'string', foreground: 'CE9178' },
        { token: 'string.sql', foreground: 'FF0000' },
        { token: 'keyword', foreground: '569CD6' },
        { token: 'keyword.flow', foreground: 'C586C0' },
        { token: 'operator.sql', foreground: '778899' },
        { token: 'operator.swift', foreground: '909090' },
        { token: 'predefined.sql', foreground: 'FF00FF' },
    ],
    colors: (_c = {},
        _c[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["n" /* editorBackground */]] = '#000000',
        _c[__WEBPACK_IMPORTED_MODULE_0__platform_theme_common_colorRegistry_js__["u" /* editorForeground */]] = '#FFFFFF',
        _c[__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["l" /* editorIndentGuides */]] = '#FFFFFF',
        _c[__WEBPACK_IMPORTED_MODULE_1__common_view_editorColorRegistry_js__["a" /* editorActiveIndentGuides */]] = '#FFFFFF',
        _c)
};


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IDialogService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__ = __webpack_require__(12);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var IDialogService = Object(__WEBPACK_IMPORTED_MODULE_0__instantiation_common_instantiation_js__["c" /* createDecorator */])('dialogService');


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_common_marshalling_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_common_network_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__codeEditorService_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_common_paths_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__platform_commands_common_commands_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform_telemetry_common_telemetry_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform_telemetry_common_telemetryUtils_js__ = __webpack_require__(557);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};










var OpenerService = /** @class */ (function () {
    function OpenerService(_editorService, _commandService, _telemetryService) {
        if (_telemetryService === void 0) { _telemetryService = __WEBPACK_IMPORTED_MODULE_9__platform_telemetry_common_telemetryUtils_js__["a" /* NullTelemetryService */]; }
        this._editorService = _editorService;
        this._commandService = _commandService;
        this._telemetryService = _telemetryService;
        //
    }
    OpenerService.prototype.open = function (resource, options) {
        var _a;
        /* __GDPR__
            "openerService" : {
                "scheme" : { "classification": "SystemMetaData", "purpose": "FeatureInsight" }
            }
        */
        this._telemetryService.publicLog('openerService', { scheme: resource.scheme });
        var scheme = resource.scheme, path = resource.path, query = resource.query, fragment = resource.fragment;
        var promise = __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].wrap(void 0);
        if (scheme === __WEBPACK_IMPORTED_MODULE_2__base_common_network_js__["a" /* Schemas */].http || scheme === __WEBPACK_IMPORTED_MODULE_2__base_common_network_js__["a" /* Schemas */].https || scheme === __WEBPACK_IMPORTED_MODULE_2__base_common_network_js__["a" /* Schemas */].mailto) {
            // open http or default mail application
            __WEBPACK_IMPORTED_MODULE_0__base_browser_dom_js__["P" /* windowOpenNoOpener */](resource.toString(true));
        }
        else if (scheme === 'command' && __WEBPACK_IMPORTED_MODULE_6__platform_commands_common_commands_js__["a" /* CommandsRegistry */].getCommand(path)) {
            // execute as command
            var args = [];
            try {
                args = Object(__WEBPACK_IMPORTED_MODULE_1__base_common_marshalling_js__["a" /* parse */])(query);
                if (!Array.isArray(args)) {
                    args = [args];
                }
            }
            catch (e) {
                //
            }
            promise = (_a = this._commandService).executeCommand.apply(_a, [path].concat(args));
        }
        else {
            var selection = void 0;
            var match = /^L?(\d+)(?:,(\d+))?/.exec(fragment);
            if (match) {
                // support file:///some/file.js#73,84
                // support file:///some/file.js#L73
                selection = {
                    startLineNumber: parseInt(match[1]),
                    startColumn: match[2] ? parseInt(match[2]) : 1
                };
                // remove fragment
                resource = resource.with({ fragment: '' });
            }
            if (!resource.scheme) {
                // we cannot handle those
                return __WEBPACK_IMPORTED_MODULE_3__base_common_winjs_base_js__["b" /* TPromise */].as(undefined);
            }
            else if (resource.scheme === __WEBPACK_IMPORTED_MODULE_2__base_common_network_js__["a" /* Schemas */].file) {
                resource = resource.with({ path: Object(__WEBPACK_IMPORTED_MODULE_5__base_common_paths_js__["h" /* normalize */])(resource.path) }); // workaround for non-normalized paths (https://github.com/Microsoft/vscode/issues/12954)
            }
            promise = this._editorService.openCodeEditor({ resource: resource, options: { selection: selection, } }, this._editorService.getFocusedCodeEditor(), options && options.openToSide);
        }
        return promise;
    };
    OpenerService = __decorate([
        __param(0, __WEBPACK_IMPORTED_MODULE_4__codeEditorService_js__["a" /* ICodeEditorService */]),
        __param(1, __WEBPACK_IMPORTED_MODULE_6__platform_commands_common_commands_js__["b" /* ICommandService */]),
        __param(2, Object(__WEBPACK_IMPORTED_MODULE_8__platform_instantiation_common_instantiation_js__["d" /* optional */])(__WEBPACK_IMPORTED_MODULE_7__platform_telemetry_common_telemetry_js__["a" /* ITelemetryService */]))
    ], OpenerService);
    return OpenerService;
}());



/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* unused harmony export revive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uri_js__ = __webpack_require__(28);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


function parse(text) {
    var data = JSON.parse(text);
    data = revive(data, 0);
    return data;
}
function revive(obj, depth) {
    if (!obj || depth > 200) {
        return obj;
    }
    if (typeof obj === 'object') {
        switch (obj.$mid) {
            case 1: return __WEBPACK_IMPORTED_MODULE_0__uri_js__["a" /* default */].revive(obj);
            case 2: return new RegExp(obj.source, obj.flags);
        }
        // walk object (or array)
        for (var key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
                obj[key] = revive(obj[key], depth + 1);
            }
        }
    }
    return obj;
}


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NullTelemetryService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__ = __webpack_require__(8);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


var NullTelemetryService = new /** @class */ (function () {
    function class_1() {
    }
    class_1.prototype.publicLog = function (eventName, data) {
        return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].wrap(null);
    };
    class_1.prototype.getTelemetryInfo = function () {
        return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].wrap({
            instanceId: 'someValue.instanceId',
            sessionId: 'someValue.sessionId',
            machineId: 'someValue.machineId'
        });
    };
    return class_1;
}());


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Colorizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_viewLayout_viewLineRenderer_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_core_lineTokens_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_viewModel_viewModel_js__ = __webpack_require__(62);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/







var Colorizer = /** @class */ (function () {
    function Colorizer() {
    }
    Colorizer.colorizeElement = function (themeService, modeService, domNode, options) {
        options = options || {};
        var theme = options.theme || 'vs';
        var mimeType = options.mimeType || domNode.getAttribute('lang') || domNode.getAttribute('data-lang');
        if (!mimeType) {
            console.error('Mode not detected');
            return undefined;
        }
        themeService.setTheme(theme);
        var text = domNode.firstChild.nodeValue;
        domNode.className += ' ' + theme;
        var render = function (str) {
            domNode.innerHTML = str;
        };
        return this.colorize(modeService, text, mimeType, options).then(render, function (err) { return console.error(err); });
    };
    Colorizer._tokenizationSupportChangedPromise = function (language) {
        var listener = null;
        var stopListening = function () {
            if (listener) {
                listener.dispose();
                listener = null;
            }
        };
        return new __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */](function (c, e) {
            listener = __WEBPACK_IMPORTED_MODULE_1__common_modes_js__["y" /* TokenizationRegistry */].onDidChange(function (e) {
                if (e.changedLanguages.indexOf(language) >= 0) {
                    stopListening();
                    c(void 0);
                }
            });
        }, stopListening);
    };
    Colorizer.colorize = function (modeService, text, mimeType, options) {
        if (__WEBPACK_IMPORTED_MODULE_4__base_common_strings_js__["startsWithUTF8BOM"](text)) {
            text = text.substr(1);
        }
        var lines = text.split(/\r\n|\r|\n/);
        var language = modeService.getModeId(mimeType);
        options = options || {};
        if (typeof options.tabSize === 'undefined') {
            options.tabSize = 4;
        }
        // Send out the event to create the mode
        modeService.getOrCreateMode(language);
        var tokenizationSupport = __WEBPACK_IMPORTED_MODULE_1__common_modes_js__["y" /* TokenizationRegistry */].get(language);
        if (tokenizationSupport) {
            return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(_colorize(lines, options.tabSize, tokenizationSupport));
        }
        // wait 500ms for mode to load, then give up
        return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].any([this._tokenizationSupportChangedPromise(language), __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].timeout(500)]).then(function (_) {
            var tokenizationSupport = __WEBPACK_IMPORTED_MODULE_1__common_modes_js__["y" /* TokenizationRegistry */].get(language);
            if (tokenizationSupport) {
                return _colorize(lines, options.tabSize, tokenizationSupport);
            }
            return _fakeColorize(lines, options.tabSize);
        });
    };
    Colorizer.colorizeLine = function (line, mightContainNonBasicASCII, mightContainRTL, tokens, tabSize) {
        if (tabSize === void 0) { tabSize = 4; }
        var isBasicASCII = __WEBPACK_IMPORTED_MODULE_5__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].isBasicASCII(line, mightContainNonBasicASCII);
        var containsRTL = __WEBPACK_IMPORTED_MODULE_5__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].containsRTL(line, isBasicASCII, mightContainRTL);
        var renderResult = Object(__WEBPACK_IMPORTED_MODULE_2__common_viewLayout_viewLineRenderer_js__["d" /* renderViewLine2 */])(new __WEBPACK_IMPORTED_MODULE_2__common_viewLayout_viewLineRenderer_js__["b" /* RenderLineInput */](false, line, false, isBasicASCII, containsRTL, 0, tokens, [], tabSize, 0, -1, 'none', false, false));
        return renderResult.html;
    };
    Colorizer.colorizeModelLine = function (model, lineNumber, tabSize) {
        if (tabSize === void 0) { tabSize = 4; }
        var content = model.getLineContent(lineNumber);
        model.forceTokenization(lineNumber);
        var tokens = model.getLineTokens(lineNumber);
        var inflatedTokens = tokens.inflate();
        return this.colorizeLine(content, model.mightContainNonBasicASCII(), model.mightContainRTL(), inflatedTokens, tabSize);
    };
    return Colorizer;
}());

function _colorize(lines, tabSize, tokenizationSupport) {
    return _actualColorize(lines, tabSize, tokenizationSupport);
}
function _fakeColorize(lines, tabSize) {
    var html = [];
    var defaultMetadata = ((0 /* None */ << 11 /* FONT_STYLE_OFFSET */)
        | (1 /* DefaultForeground */ << 14 /* FOREGROUND_OFFSET */)
        | (2 /* DefaultBackground */ << 23 /* BACKGROUND_OFFSET */)) >>> 0;
    var tokens = new Uint32Array(2);
    tokens[0] = 0;
    tokens[1] = defaultMetadata;
    for (var i = 0, length_1 = lines.length; i < length_1; i++) {
        var line = lines[i];
        tokens[0] = line.length;
        var lineTokens = new __WEBPACK_IMPORTED_MODULE_3__common_core_lineTokens_js__["a" /* LineTokens */](tokens, line);
        var isBasicASCII = __WEBPACK_IMPORTED_MODULE_5__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].isBasicASCII(line, /* check for basic ASCII */ true);
        var containsRTL = __WEBPACK_IMPORTED_MODULE_5__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].containsRTL(line, isBasicASCII, /* check for RTL */ true);
        var renderResult = Object(__WEBPACK_IMPORTED_MODULE_2__common_viewLayout_viewLineRenderer_js__["d" /* renderViewLine2 */])(new __WEBPACK_IMPORTED_MODULE_2__common_viewLayout_viewLineRenderer_js__["b" /* RenderLineInput */](false, line, false, isBasicASCII, containsRTL, 0, lineTokens, [], tabSize, 0, -1, 'none', false, false));
        html = html.concat(renderResult.html);
        html.push('<br/>');
    }
    return html.join('');
}
function _actualColorize(lines, tabSize, tokenizationSupport) {
    var html = [];
    var state = tokenizationSupport.getInitialState();
    for (var i = 0, length_2 = lines.length; i < length_2; i++) {
        var line = lines[i];
        var tokenizeResult = tokenizationSupport.tokenize2(line, state, 0);
        __WEBPACK_IMPORTED_MODULE_3__common_core_lineTokens_js__["a" /* LineTokens */].convertToEndOffset(tokenizeResult.tokens, line.length);
        var lineTokens = new __WEBPACK_IMPORTED_MODULE_3__common_core_lineTokens_js__["a" /* LineTokens */](tokenizeResult.tokens, line);
        var isBasicASCII = __WEBPACK_IMPORTED_MODULE_5__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].isBasicASCII(line, /* check for basic ASCII */ true);
        var containsRTL = __WEBPACK_IMPORTED_MODULE_5__common_viewModel_viewModel_js__["d" /* ViewLineRenderingData */].containsRTL(line, isBasicASCII, /* check for RTL */ true);
        var renderResult = Object(__WEBPACK_IMPORTED_MODULE_2__common_viewLayout_viewLineRenderer_js__["d" /* renderViewLine2 */])(new __WEBPACK_IMPORTED_MODULE_2__common_viewLayout_viewLineRenderer_js__["b" /* RenderLineInput */](false, line, false, isBasicASCII, containsRTL, 0, lineTokens.inflate(), [], tabSize, 0, -1, 'none', false, false));
        html = html.concat(renderResult.html);
        html.push('<br/>');
        state = tokenizeResult.endState;
    }
    return html.join('');
}


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWebWorker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editorWorkerServiceImpl_js__ = __webpack_require__(290);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Create a new web worker that has model syncing capabilities built in.
 * Specify an AMD module to load that will `create` an object that will be proxied.
 */
function createWebWorker(modelService, opts) {
    return new MonacoWebWorkerImpl(modelService, opts);
}
var MonacoWebWorkerImpl = /** @class */ (function (_super) {
    __extends(MonacoWebWorkerImpl, _super);
    function MonacoWebWorkerImpl(modelService, opts) {
        var _this = _super.call(this, modelService, opts.label) || this;
        _this._foreignModuleId = opts.moduleId;
        _this._foreignModuleCreateData = opts.createData || null;
        _this._foreignProxy = null;
        return _this;
    }
    MonacoWebWorkerImpl.prototype._getForeignProxy = function () {
        var _this = this;
        if (!this._foreignProxy) {
            this._foreignProxy = new __WEBPACK_IMPORTED_MODULE_0__base_common_async_js__["d" /* ShallowCancelThenPromise */](this._getProxy().then(function (proxy) {
                return proxy.loadForeignModule(_this._foreignModuleId, _this._foreignModuleCreateData).then(function (foreignMethods) {
                    _this._foreignModuleId = null;
                    _this._foreignModuleCreateData = null;
                    var proxyMethodRequest = function (method, args) {
                        return proxy.fmr(method, args);
                    };
                    var createProxyMethod = function (method, proxyMethodRequest) {
                        return function () {
                            var args = Array.prototype.slice.call(arguments, 0);
                            return proxyMethodRequest(method, args);
                        };
                    };
                    var foreignProxy = {};
                    for (var i = 0; i < foreignMethods.length; i++) {
                        foreignProxy[foreignMethods[i]] = createProxyMethod(foreignMethods[i], proxyMethodRequest);
                    }
                    return foreignProxy;
                });
            }));
        }
        return this._foreignProxy;
    };
    MonacoWebWorkerImpl.prototype.getProxy = function () {
        return this._getForeignProxy();
    };
    MonacoWebWorkerImpl.prototype.withSyncedResources = function (resources) {
        var _this = this;
        return this._withSyncedResources(resources).then(function (_) { return _this.getProxy(); });
    };
    return MonacoWebWorkerImpl;
}(__WEBPACK_IMPORTED_MODULE_1__editorWorkerServiceImpl_js__["a" /* EditorWorkerClient */]));


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export register */
/* unused harmony export getLanguages */
/* unused harmony export getEncodedLanguageId */
/* unused harmony export onLanguage */
/* unused harmony export setLanguageConfiguration */
/* unused harmony export EncodedTokenizationSupport2Adapter */
/* unused harmony export TokenizationSupport2Adapter */
/* unused harmony export setTokensProvider */
/* unused harmony export setMonarchTokensProvider */
/* unused harmony export registerReferenceProvider */
/* unused harmony export registerRenameProvider */
/* unused harmony export registerSignatureHelpProvider */
/* unused harmony export registerHoverProvider */
/* unused harmony export registerDocumentSymbolProvider */
/* unused harmony export registerDocumentHighlightProvider */
/* unused harmony export registerDefinitionProvider */
/* unused harmony export registerImplementationProvider */
/* unused harmony export registerTypeDefinitionProvider */
/* unused harmony export registerCodeLensProvider */
/* unused harmony export registerCodeActionProvider */
/* unused harmony export registerDocumentFormattingEditProvider */
/* unused harmony export registerDocumentRangeFormattingEditProvider */
/* unused harmony export registerOnTypeFormattingEditProvider */
/* unused harmony export registerLinkProvider */
/* unused harmony export registerCompletionItemProvider */
/* unused harmony export registerColorProvider */
/* unused harmony export registerFoldingRangeProvider */
/* unused harmony export CompletionItemKind */
/* harmony export (immutable) */ __webpack_exports__["a"] = createMonacoLanguagesAPI;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_modes_modesRegistry_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_modes_languageConfiguration_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_common_async_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_monarch_monarchCompile_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_monarch_monarchLexer_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_modes_languageConfigurationRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_core_token_js__ = __webpack_require__(94);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/













/**
 * Register information about a new language.
 */
function register(language) {
    __WEBPACK_IMPORTED_MODULE_1__common_modes_modesRegistry_js__["a" /* ModesRegistry */].registerLanguage(language);
}
/**
 * Get the information of all the registered languages.
 */
function getLanguages() {
    var result = [];
    result = result.concat(__WEBPACK_IMPORTED_MODULE_1__common_modes_modesRegistry_js__["a" /* ModesRegistry */].getLanguages());
    return result;
}
function getEncodedLanguageId(languageId) {
    var lid = __WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].modeService.get().getLanguageIdentifier(languageId);
    return lid && lid.id;
}
/**
 * An event emitted when a language is first time needed (e.g. a model has it set).
 * @event
 */
function onLanguage(languageId, callback) {
    var disposable = __WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].modeService.get().onDidCreateMode(function (mode) {
        if (mode.getId() === languageId) {
            // stop listening
            disposable.dispose();
            // invoke actual listener
            callback();
        }
    });
    return disposable;
}
/**
 * Set the editing configuration for a language.
 */
function setLanguageConfiguration(languageId, configuration) {
    var languageIdentifier = __WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].modeService.get().getLanguageIdentifier(languageId);
    if (!languageIdentifier) {
        throw new Error("Cannot set configuration for unknown language " + languageId);
    }
    return __WEBPACK_IMPORTED_MODULE_10__common_modes_languageConfigurationRegistry_js__["a" /* LanguageConfigurationRegistry */].register(languageIdentifier, configuration);
}
/**
 * @internal
 */
var EncodedTokenizationSupport2Adapter = /** @class */ (function () {
    function EncodedTokenizationSupport2Adapter(actual) {
        this._actual = actual;
    }
    EncodedTokenizationSupport2Adapter.prototype.getInitialState = function () {
        return this._actual.getInitialState();
    };
    EncodedTokenizationSupport2Adapter.prototype.tokenize = function (line, state, offsetDelta) {
        throw new Error('Not supported!');
    };
    EncodedTokenizationSupport2Adapter.prototype.tokenize2 = function (line, state) {
        var result = this._actual.tokenizeEncoded(line, state);
        return new __WEBPACK_IMPORTED_MODULE_11__common_core_token_js__["c" /* TokenizationResult2 */](result.tokens, result.endState);
    };
    return EncodedTokenizationSupport2Adapter;
}());

/**
 * @internal
 */
var TokenizationSupport2Adapter = /** @class */ (function () {
    function TokenizationSupport2Adapter(standaloneThemeService, languageIdentifier, actual) {
        this._standaloneThemeService = standaloneThemeService;
        this._languageIdentifier = languageIdentifier;
        this._actual = actual;
    }
    TokenizationSupport2Adapter.prototype.getInitialState = function () {
        return this._actual.getInitialState();
    };
    TokenizationSupport2Adapter.prototype._toClassicTokens = function (tokens, language, offsetDelta) {
        var result = [];
        var previousStartIndex = 0;
        for (var i = 0, len = tokens.length; i < len; i++) {
            var t = tokens[i];
            var startIndex = t.startIndex;
            // Prevent issues stemming from a buggy external tokenizer.
            if (i === 0) {
                // Force first token to start at first index!
                startIndex = 0;
            }
            else if (startIndex < previousStartIndex) {
                // Force tokens to be after one another!
                startIndex = previousStartIndex;
            }
            result[i] = new __WEBPACK_IMPORTED_MODULE_11__common_core_token_js__["a" /* Token */](startIndex + offsetDelta, t.scopes, language);
            previousStartIndex = startIndex;
        }
        return result;
    };
    TokenizationSupport2Adapter.prototype.tokenize = function (line, state, offsetDelta) {
        var actualResult = this._actual.tokenize(line, state);
        var tokens = this._toClassicTokens(actualResult.tokens, this._languageIdentifier.language, offsetDelta);
        var endState;
        // try to save an object if possible
        if (actualResult.endState.equals(state)) {
            endState = state;
        }
        else {
            endState = actualResult.endState;
        }
        return new __WEBPACK_IMPORTED_MODULE_11__common_core_token_js__["b" /* TokenizationResult */](tokens, endState);
    };
    TokenizationSupport2Adapter.prototype._toBinaryTokens = function (tokens, offsetDelta) {
        var languageId = this._languageIdentifier.id;
        var tokenTheme = this._standaloneThemeService.getTheme().tokenTheme;
        var result = [], resultLen = 0;
        var previousStartIndex = 0;
        for (var i = 0, len = tokens.length; i < len; i++) {
            var t = tokens[i];
            var metadata = tokenTheme.match(languageId, t.scopes);
            if (resultLen > 0 && result[resultLen - 1] === metadata) {
                // same metadata
                continue;
            }
            var startIndex = t.startIndex;
            // Prevent issues stemming from a buggy external tokenizer.
            if (i === 0) {
                // Force first token to start at first index!
                startIndex = 0;
            }
            else if (startIndex < previousStartIndex) {
                // Force tokens to be after one another!
                startIndex = previousStartIndex;
            }
            result[resultLen++] = startIndex + offsetDelta;
            result[resultLen++] = metadata;
            previousStartIndex = startIndex;
        }
        var actualResult = new Uint32Array(resultLen);
        for (var i = 0; i < resultLen; i++) {
            actualResult[i] = result[i];
        }
        return actualResult;
    };
    TokenizationSupport2Adapter.prototype.tokenize2 = function (line, state, offsetDelta) {
        var actualResult = this._actual.tokenize(line, state);
        var tokens = this._toBinaryTokens(actualResult.tokens, offsetDelta);
        var endState;
        // try to save an object if possible
        if (actualResult.endState.equals(state)) {
            endState = state;
        }
        else {
            endState = actualResult.endState;
        }
        return new __WEBPACK_IMPORTED_MODULE_11__common_core_token_js__["c" /* TokenizationResult2 */](tokens, endState);
    };
    return TokenizationSupport2Adapter;
}());

function isEncodedTokensProvider(provider) {
    return provider['tokenizeEncoded'];
}
/**
 * Set the tokens provider for a language (manual implementation).
 */
function setTokensProvider(languageId, provider) {
    var languageIdentifier = __WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].modeService.get().getLanguageIdentifier(languageId);
    if (!languageIdentifier) {
        throw new Error("Cannot set tokens provider for unknown language " + languageId);
    }
    var adapter;
    if (isEncodedTokensProvider(provider)) {
        adapter = new EncodedTokenizationSupport2Adapter(provider);
    }
    else {
        adapter = new TokenizationSupport2Adapter(__WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].standaloneThemeService.get(), languageIdentifier, provider);
    }
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["y" /* TokenizationRegistry */].register(languageId, adapter);
}
/**
 * Set the tokens provider for a language (monarch implementation).
 */
function setMonarchTokensProvider(languageId, languageDef) {
    var lexer = Object(__WEBPACK_IMPORTED_MODULE_8__common_monarch_monarchCompile_js__["a" /* compile */])(languageId, languageDef);
    var adapter = Object(__WEBPACK_IMPORTED_MODULE_9__common_monarch_monarchLexer_js__["a" /* createTokenizationSupport */])(__WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].modeService.get(), __WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].standaloneThemeService.get(), languageId, lexer);
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["y" /* TokenizationRegistry */].register(languageId, adapter);
}
/**
 * Register a reference provider (used by e.g. reference search).
 */
function registerReferenceProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["r" /* ReferenceProviderRegistry */].register(languageId, provider);
}
/**
 * Register a rename provider (used by e.g. rename symbol).
 */
function registerRenameProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["s" /* RenameProviderRegistry */].register(languageId, provider);
}
/**
 * Register a signature help provider (used by e.g. paremeter hints).
 */
function registerSignatureHelpProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["t" /* SignatureHelpProviderRegistry */].register(languageId, provider);
}
/**
 * Register a hover provider (used by e.g. editor hover).
 */
function registerHoverProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["m" /* HoverProviderRegistry */].register(languageId, {
        provideHover: function (model, position, token) {
            var word = model.getWordAtPosition(position);
            return Object(__WEBPACK_IMPORTED_MODULE_7__base_common_async_js__["n" /* toThenable */])(provider.provideHover(model, position, token)).then(function (value) {
                if (!value) {
                    return undefined;
                }
                if (!value.range && word) {
                    value.range = new __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */](position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
                }
                if (!value.range) {
                    value.range = new __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */](position.lineNumber, position.column, position.lineNumber, position.column);
                }
                return value;
            });
        }
    });
}
/**
 * Register a document symbol provider (used by e.g. outline).
 */
function registerDocumentSymbolProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["j" /* DocumentSymbolProviderRegistry */].register(languageId, provider);
}
/**
 * Register a document highlight provider (used by e.g. highlight occurrences).
 */
function registerDocumentHighlightProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["h" /* DocumentHighlightProviderRegistry */].register(languageId, provider);
}
/**
 * Register a definition provider (used by e.g. go to definition).
 */
function registerDefinitionProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["e" /* DefinitionProviderRegistry */].register(languageId, provider);
}
/**
 * Register a implementation provider (used by e.g. go to implementation).
 */
function registerImplementationProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["n" /* ImplementationProviderRegistry */].register(languageId, provider);
}
/**
 * Register a type definition provider (used by e.g. go to type definition).
 */
function registerTypeDefinitionProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["z" /* TypeDefinitionProviderRegistry */].register(languageId, provider);
}
/**
 * Register a code lens provider (used by e.g. inline code lenses).
 */
function registerCodeLensProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["c" /* CodeLensProviderRegistry */].register(languageId, provider);
}
/**
 * Register a code action provider (used by e.g. quick fix).
 */
function registerCodeActionProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["a" /* CodeActionProviderRegistry */].register(languageId, {
        provideCodeActions: function (model, range, context, token) {
            var markers = __WEBPACK_IMPORTED_MODULE_2__standaloneServices_js__["b" /* StaticServices */].markerService.get().read({ resource: model.uri }).filter(function (m) {
                return __WEBPACK_IMPORTED_MODULE_6__common_core_range_js__["a" /* Range */].areIntersectingOrTouching(m, range);
            });
            return provider.provideCodeActions(model, range, { markers: markers, only: context.only }, token);
        }
    });
}
/**
 * Register a formatter that can handle only entire models.
 */
function registerDocumentFormattingEditProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["f" /* DocumentFormattingEditProviderRegistry */].register(languageId, provider);
}
/**
 * Register a formatter that can handle a range inside a model.
 */
function registerDocumentRangeFormattingEditProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["i" /* DocumentRangeFormattingEditProviderRegistry */].register(languageId, provider);
}
/**
 * Register a formatter than can do formatting as the user types.
 */
function registerOnTypeFormattingEditProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["q" /* OnTypeFormattingEditProviderRegistry */].register(languageId, provider);
}
/**
 * Register a link provider that can find links in text.
 */
function registerLinkProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["p" /* LinkProviderRegistry */].register(languageId, provider);
}
/**
 * Register a completion item provider (use by e.g. suggestions).
 */
function registerCompletionItemProvider(languageId, provider) {
    var adapter = new SuggestAdapter(provider);
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["u" /* SuggestRegistry */].register(languageId, {
        triggerCharacters: provider.triggerCharacters,
        provideCompletionItems: function (model, position, context, token) {
            return adapter.provideCompletionItems(model, position, context, token);
        },
        resolveCompletionItem: function (model, position, suggestion, token) {
            return adapter.resolveCompletionItem(model, position, suggestion, token);
        }
    });
}
/**
 * Register a document color provider (used by Color Picker, Color Decorator).
 */
function registerColorProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["d" /* ColorProviderRegistry */].register(languageId, provider);
}
/**
 * Register a folding range provider
 */
function registerFoldingRangeProvider(languageId, provider) {
    return __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["l" /* FoldingRangeProviderRegistry */].register(languageId, provider);
}
/**
 * Completion item kinds.
 */
var CompletionItemKind;
(function (CompletionItemKind) {
    CompletionItemKind[CompletionItemKind["Text"] = 0] = "Text";
    CompletionItemKind[CompletionItemKind["Method"] = 1] = "Method";
    CompletionItemKind[CompletionItemKind["Function"] = 2] = "Function";
    CompletionItemKind[CompletionItemKind["Constructor"] = 3] = "Constructor";
    CompletionItemKind[CompletionItemKind["Field"] = 4] = "Field";
    CompletionItemKind[CompletionItemKind["Variable"] = 5] = "Variable";
    CompletionItemKind[CompletionItemKind["Class"] = 6] = "Class";
    CompletionItemKind[CompletionItemKind["Interface"] = 7] = "Interface";
    CompletionItemKind[CompletionItemKind["Module"] = 8] = "Module";
    CompletionItemKind[CompletionItemKind["Property"] = 9] = "Property";
    CompletionItemKind[CompletionItemKind["Unit"] = 10] = "Unit";
    CompletionItemKind[CompletionItemKind["Value"] = 11] = "Value";
    CompletionItemKind[CompletionItemKind["Enum"] = 12] = "Enum";
    CompletionItemKind[CompletionItemKind["Keyword"] = 13] = "Keyword";
    CompletionItemKind[CompletionItemKind["Snippet"] = 14] = "Snippet";
    CompletionItemKind[CompletionItemKind["Color"] = 15] = "Color";
    CompletionItemKind[CompletionItemKind["File"] = 16] = "File";
    CompletionItemKind[CompletionItemKind["Reference"] = 17] = "Reference";
    CompletionItemKind[CompletionItemKind["Folder"] = 18] = "Folder";
})(CompletionItemKind || (CompletionItemKind = {}));
function convertKind(kind) {
    switch (kind) {
        case CompletionItemKind.Method: return 'method';
        case CompletionItemKind.Function: return 'function';
        case CompletionItemKind.Constructor: return 'constructor';
        case CompletionItemKind.Field: return 'field';
        case CompletionItemKind.Variable: return 'variable';
        case CompletionItemKind.Class: return 'class';
        case CompletionItemKind.Interface: return 'interface';
        case CompletionItemKind.Module: return 'module';
        case CompletionItemKind.Property: return 'property';
        case CompletionItemKind.Unit: return 'unit';
        case CompletionItemKind.Value: return 'value';
        case CompletionItemKind.Enum: return 'enum';
        case CompletionItemKind.Keyword: return 'keyword';
        case CompletionItemKind.Snippet: return 'snippet';
        case CompletionItemKind.Text: return 'text';
        case CompletionItemKind.Color: return 'color';
        case CompletionItemKind.File: return 'file';
        case CompletionItemKind.Reference: return 'reference';
        case CompletionItemKind.Folder: return 'folder';
    }
    return 'property';
}
var SuggestAdapter = /** @class */ (function () {
    function SuggestAdapter(provider) {
        this._provider = provider;
    }
    SuggestAdapter.from = function (item, position, wordStartPos) {
        var suggestion = {
            _actual: item,
            label: item.label,
            insertText: item.label,
            type: convertKind(item.kind),
            detail: item.detail,
            documentation: item.documentation,
            command: item.command,
            sortText: item.sortText,
            filterText: item.filterText,
            snippetType: 'internal',
            additionalTextEdits: item.additionalTextEdits,
            commitCharacters: item.commitCharacters
        };
        var editRange = item.textEdit ? item.textEdit.range : item.range;
        if (editRange) {
            var isSingleLine = (editRange.startLineNumber === editRange.endLineNumber);
            // invalid text edit
            if (!isSingleLine || editRange.startLineNumber !== position.lineNumber) {
                console.warn('INVALID range, must be single line and on the same line');
                return null;
            }
            // insert the text of the edit and create a dedicated
            // suggestion-container with overwrite[Before|After]
            suggestion.overwriteBefore = position.column - editRange.startColumn;
            suggestion.overwriteAfter = editRange.endColumn - position.column;
        }
        else {
            suggestion.overwriteBefore = position.column - wordStartPos.column;
            suggestion.overwriteAfter = 0;
        }
        if (item.textEdit) {
            suggestion.insertText = item.textEdit.text;
        }
        else if (typeof item.insertText === 'object' && typeof item.insertText.value === 'string') {
            suggestion.insertText = item.insertText.value;
            suggestion.snippetType = 'textmate';
        }
        else if (typeof item.insertText === 'string') {
            suggestion.insertText = item.insertText;
        }
        return suggestion;
    };
    SuggestAdapter.prototype.provideCompletionItems = function (model, position, context, token) {
        var result = this._provider.provideCompletionItems(model, position, token, context);
        return Object(__WEBPACK_IMPORTED_MODULE_7__base_common_async_js__["n" /* toThenable */])(result).then(function (value) {
            var result = {
                suggestions: []
            };
            // default text edit start
            var wordStartPos = position;
            var word = model.getWordUntilPosition(position);
            if (word) {
                wordStartPos = new __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__["a" /* Position */](wordStartPos.lineNumber, word.startColumn);
            }
            var list;
            if (Array.isArray(value)) {
                list = {
                    items: value,
                    isIncomplete: false
                };
            }
            else if (typeof value === 'object' && Array.isArray(value.items)) {
                list = value;
                result.incomplete = list.isIncomplete;
            }
            else if (!value) {
                // undefined and null are valid results
                return undefined;
            }
            else {
                // warn about everything else
                console.warn('INVALID result from completion provider. expected CompletionItem-array or CompletionList but got:', value);
            }
            for (var i = 0; i < list.items.length; i++) {
                var item = list.items[i];
                var suggestion = SuggestAdapter.from(item, position, wordStartPos);
                if (suggestion) {
                    result.suggestions.push(suggestion);
                }
            }
            return result;
        });
    };
    SuggestAdapter.prototype.resolveCompletionItem = function (model, position, suggestion, token) {
        if (typeof this._provider.resolveCompletionItem !== 'function') {
            return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(suggestion);
        }
        var item = suggestion._actual;
        if (!item) {
            return __WEBPACK_IMPORTED_MODULE_0__base_common_winjs_base_js__["b" /* TPromise */].as(suggestion);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_7__base_common_async_js__["n" /* toThenable */])(this._provider.resolveCompletionItem(item, token)).then(function (resolvedItem) {
            var wordStartPos = position;
            var word = model.getWordUntilPosition(position);
            if (word) {
                wordStartPos = new __WEBPACK_IMPORTED_MODULE_5__common_core_position_js__["a" /* Position */](wordStartPos.lineNumber, word.startColumn);
            }
            return SuggestAdapter.from(resolvedItem, position, wordStartPos);
        });
    };
    return SuggestAdapter;
}());
/**
 * @internal
 */
function createMonacoLanguagesAPI() {
    return {
        register: register,
        getLanguages: getLanguages,
        onLanguage: onLanguage,
        getEncodedLanguageId: getEncodedLanguageId,
        // provider methods
        setLanguageConfiguration: setLanguageConfiguration,
        setTokensProvider: setTokensProvider,
        setMonarchTokensProvider: setMonarchTokensProvider,
        registerReferenceProvider: registerReferenceProvider,
        registerRenameProvider: registerRenameProvider,
        registerCompletionItemProvider: registerCompletionItemProvider,
        registerSignatureHelpProvider: registerSignatureHelpProvider,
        registerHoverProvider: registerHoverProvider,
        registerDocumentSymbolProvider: registerDocumentSymbolProvider,
        registerDocumentHighlightProvider: registerDocumentHighlightProvider,
        registerDefinitionProvider: registerDefinitionProvider,
        registerImplementationProvider: registerImplementationProvider,
        registerTypeDefinitionProvider: registerTypeDefinitionProvider,
        registerCodeLensProvider: registerCodeLensProvider,
        registerCodeActionProvider: registerCodeActionProvider,
        registerDocumentFormattingEditProvider: registerDocumentFormattingEditProvider,
        registerDocumentRangeFormattingEditProvider: registerDocumentRangeFormattingEditProvider,
        registerOnTypeFormattingEditProvider: registerOnTypeFormattingEditProvider,
        registerLinkProvider: registerLinkProvider,
        registerColorProvider: registerColorProvider,
        registerFoldingRangeProvider: registerFoldingRangeProvider,
        // enums
        DocumentHighlightKind: __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["g" /* DocumentHighlightKind */],
        CompletionItemKind: CompletionItemKind,
        SymbolKind: __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["w" /* SymbolKind */],
        IndentAction: __WEBPACK_IMPORTED_MODULE_4__common_modes_languageConfiguration_js__["a" /* IndentAction */],
        SuggestTriggerKind: __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["v" /* SuggestTriggerKind */],
        FoldingRangeKind: __WEBPACK_IMPORTED_MODULE_3__common_modes_js__["k" /* FoldingRangeKind */]
    };
}


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_common_objects_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__ = __webpack_require__(294);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/*
 * This module only exports 'compile' which compiles a JSON language definition
 * into a typed and checked ILexer definition.
 */


/*
 * Type helpers
 *
 * Note: this is just for sanity checks on the JSON description which is
 * helpful for the programmer. No checks are done anymore once the lexer is
 * already 'compiled and checked'.
 *
 */
function isArrayOf(elemType, obj) {
    if (!obj) {
        return false;
    }
    if (!(Array.isArray(obj))) {
        return false;
    }
    for (var idx in obj) {
        if (obj.hasOwnProperty(idx)) {
            if (!(elemType(obj[idx]))) {
                return false;
            }
        }
    }
    return true;
}
function bool(prop, def, onerr) {
    if (typeof (prop) === 'boolean') {
        return prop;
    }
    if (onerr && (prop || def === undefined)) {
        onerr(); // type is wrong, or there is no default
    }
    return (def === undefined ? null : def);
}
function string(prop, def, onerr) {
    if (typeof (prop) === 'string') {
        return prop;
    }
    if (onerr && (prop || def === undefined)) {
        onerr(); // type is wrong, or there is no default
    }
    return (def === undefined ? null : def);
}
// Lexer helpers
/**
 * Compiles a regular expression string, adding the 'i' flag if 'ignoreCase' is set.
 * Also replaces @\w+ or sequences with the content of the specified attribute
 */
function compileRegExp(lexer, str) {
    if (typeof (str) !== 'string') {
        return null;
    }
    var n = 0;
    while (str.indexOf('@') >= 0 && n < 5) { // at most 5 expansions
        n++;
        str = str.replace(/@(\w+)/g, function (s, attr) {
            var sub = '';
            if (typeof (lexer[attr]) === 'string') {
                sub = lexer[attr];
            }
            else if (lexer[attr] && lexer[attr] instanceof RegExp) {
                sub = lexer[attr].source;
            }
            else {
                if (lexer[attr] === undefined) {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'language definition does not contain attribute \'' + attr + '\', used at: ' + str);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'attribute reference \'' + attr + '\' must be a string, used at: ' + str);
                }
            }
            return (__WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["a" /* empty */](sub) ? '' : '(?:' + sub + ')');
        });
    }
    return new RegExp(str, (lexer.ignoreCase ? 'i' : ''));
}
/**
 * Compiles guard functions for case matches.
 * This compiles 'cases' attributes into efficient match functions.
 *
 */
function selectScrutinee(id, matches, state, num) {
    if (num < 0) {
        return id;
    }
    if (num < matches.length) {
        return matches[num];
    }
    if (num >= 100) {
        num = num - 100;
        var parts = state.split('.');
        parts.unshift(state);
        if (num < parts.length) {
            return parts[num];
        }
    }
    return null;
}
function createGuard(lexer, ruleName, tkey, val) {
    // get the scrutinee and pattern
    var scrut = -1; // -1: $!, 0-99: $n, 100+n: $Sn
    var oppat = tkey;
    var matches = tkey.match(/^\$(([sS]?)(\d\d?)|#)(.*)$/);
    if (matches) {
        if (matches[3]) { // if digits
            scrut = parseInt(matches[3]);
            if (matches[2]) {
                scrut = scrut + 100; // if [sS] present
            }
        }
        oppat = matches[4];
    }
    // get operator
    var op = '~';
    var pat = oppat;
    if (!oppat || oppat.length === 0) {
        op = '!=';
        pat = '';
    }
    else if (/^\w*$/.test(pat)) { // just a word
        op = '==';
    }
    else {
        matches = oppat.match(/^(@|!@|~|!~|==|!=)(.*)$/);
        if (matches) {
            op = matches[1];
            pat = matches[2];
        }
    }
    // set the tester function
    var tester;
    // special case a regexp that matches just words
    if ((op === '~' || op === '!~') && /^(\w|\|)*$/.test(pat)) {
        var inWords_1 = __WEBPACK_IMPORTED_MODULE_0__base_common_objects_js__["b" /* createKeywordMatcher */](pat.split('|'), lexer.ignoreCase);
        tester = function (s) { return (op === '~' ? inWords_1(s) : !inWords_1(s)); };
    }
    else if (op === '@' || op === '!@') {
        var words = lexer[pat];
        if (!words) {
            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'the @ match target \'' + pat + '\' is not defined, in rule: ' + ruleName);
        }
        if (!(isArrayOf(function (elem) { return (typeof (elem) === 'string'); }, words))) {
            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'the @ match target \'' + pat + '\' must be an array of strings, in rule: ' + ruleName);
        }
        var inWords_2 = __WEBPACK_IMPORTED_MODULE_0__base_common_objects_js__["b" /* createKeywordMatcher */](words, lexer.ignoreCase);
        tester = function (s) { return (op === '@' ? inWords_2(s) : !inWords_2(s)); };
    }
    else if (op === '~' || op === '!~') {
        if (pat.indexOf('$') < 0) {
            // precompile regular expression
            var re_1 = compileRegExp(lexer, '^' + pat + '$');
            tester = function (s) { return (op === '~' ? re_1.test(s) : !re_1.test(s)); };
        }
        else {
            tester = function (s, id, matches, state) {
                var re = compileRegExp(lexer, '^' + __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](lexer, pat, id, matches, state) + '$');
                return re.test(s);
            };
        }
    }
    else { // if (op==='==' || op==='!=') {
        if (pat.indexOf('$') < 0) {
            var patx_1 = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["c" /* fixCase */](lexer, pat);
            tester = function (s) { return (op === '==' ? s === patx_1 : s !== patx_1); };
        }
        else {
            var patx_2 = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["c" /* fixCase */](lexer, pat);
            tester = function (s, id, matches, state, eos) {
                var patexp = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](lexer, patx_2, id, matches, state);
                return (op === '==' ? s === patexp : s !== patexp);
            };
        }
    }
    // return the branch object
    if (scrut === -1) {
        return {
            name: tkey, value: val, test: function (id, matches, state, eos) {
                return tester(id, id, matches, state, eos);
            }
        };
    }
    else {
        return {
            name: tkey, value: val, test: function (id, matches, state, eos) {
                var scrutinee = selectScrutinee(id, matches, state, scrut);
                return tester(!scrutinee ? '' : scrutinee, id, matches, state, eos);
            }
        };
    }
}
/**
 * Compiles an action: i.e. optimize regular expressions and case matches
 * and do many sanity checks.
 *
 * This is called only during compilation but if the lexer definition
 * contains user functions as actions (which is usually not allowed), then this
 * may be called during lexing. It is important therefore to compile common cases efficiently
 */
function compileAction(lexer, ruleName, action) {
    if (!action) {
        return { token: '' };
    }
    else if (typeof (action) === 'string') {
        return action; // { token: action };
    }
    else if (action.token || action.token === '') {
        if (typeof (action.token) !== 'string') {
            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'a \'token\' attribute must be of type string, in rule: ' + ruleName);
            return { token: '' };
        }
        else {
            // only copy specific typed fields (only happens once during compile Lexer)
            var newAction = { token: action.token };
            if (action.token.indexOf('$') >= 0) {
                newAction.tokenSubst = true;
            }
            if (typeof (action.bracket) === 'string') {
                if (action.bracket === '@open') {
                    newAction.bracket = 1 /* Open */;
                }
                else if (action.bracket === '@close') {
                    newAction.bracket = -1 /* Close */;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'a \'bracket\' attribute must be either \'@open\' or \'@close\', in rule: ' + ruleName);
                }
            }
            if (action.next) {
                if (typeof (action.next) !== 'string') {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'the next state must be a string value in rule: ' + ruleName);
                }
                else {
                    var next = action.next;
                    if (!/^(@pop|@push|@popall)$/.test(next)) {
                        if (next[0] === '@') {
                            next = next.substr(1); // peel off starting @ sign
                        }
                        if (next.indexOf('$') < 0) { // no dollar substitution, we can check if the state exists
                            if (!__WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["i" /* stateExists */](lexer, __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](lexer, next, '', [], ''))) {
                                __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'the next state \'' + action.next + '\' is not defined in rule: ' + ruleName);
                            }
                        }
                    }
                    newAction.next = next;
                }
            }
            if (typeof (action.goBack) === 'number') {
                newAction.goBack = action.goBack;
            }
            if (typeof (action.switchTo) === 'string') {
                newAction.switchTo = action.switchTo;
            }
            if (typeof (action.log) === 'string') {
                newAction.log = action.log;
            }
            if (typeof (action.nextEmbedded) === 'string') {
                newAction.nextEmbedded = action.nextEmbedded;
                lexer.usesEmbedded = true;
            }
            return newAction;
        }
    }
    else if (Array.isArray(action)) {
        var results = [];
        for (var idx in action) {
            if (action.hasOwnProperty(idx)) {
                results[idx] = compileAction(lexer, ruleName, action[idx]);
            }
        }
        return { group: results };
    }
    else if (action.cases) {
        // build an array of test cases
        var cases_1 = [];
        // for each case, push a test function and result value
        for (var tkey in action.cases) {
            if (action.cases.hasOwnProperty(tkey)) {
                var val = compileAction(lexer, ruleName, action.cases[tkey]);
                // what kind of case
                if (tkey === '@default' || tkey === '@' || tkey === '') {
                    cases_1.push({ test: null, value: val, name: tkey });
                }
                else if (tkey === '@eos') {
                    cases_1.push({ test: function (id, matches, state, eos) { return eos; }, value: val, name: tkey });
                }
                else {
                    cases_1.push(createGuard(lexer, ruleName, tkey, val)); // call separate function to avoid local variable capture
                }
            }
        }
        // create a matching function
        var def_1 = lexer.defaultToken;
        return {
            test: function (id, matches, state, eos) {
                for (var idx in cases_1) {
                    if (cases_1.hasOwnProperty(idx)) {
                        var didmatch = (!cases_1[idx].test || cases_1[idx].test(id, matches, state, eos));
                        if (didmatch) {
                            return cases_1[idx].value;
                        }
                    }
                }
                return def_1;
            }
        };
    }
    else {
        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'an action must be a string, an object with a \'token\' or \'cases\' attribute, or an array of actions; in rule: ' + ruleName);
        return '';
    }
}
/**
 * Helper class for creating matching rules
 */
var Rule = /** @class */ (function () {
    function Rule(name) {
        this.regex = new RegExp('');
        this.action = { token: '' };
        this.matchOnlyAtLineStart = false;
        this.name = '';
        this.name = name;
    }
    Rule.prototype.setRegex = function (lexer, re) {
        var sregex;
        if (typeof (re) === 'string') {
            sregex = re;
        }
        else if (re instanceof RegExp) {
            sregex = re.source;
        }
        else {
            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'rules must start with a match string or regular expression: ' + this.name);
        }
        this.matchOnlyAtLineStart = (sregex.length > 0 && sregex[0] === '^');
        this.name = this.name + ': ' + sregex;
        this.regex = compileRegExp(lexer, '^(?:' + (this.matchOnlyAtLineStart ? sregex.substr(1) : sregex) + ')');
    };
    Rule.prototype.setAction = function (lexer, act) {
        this.action = compileAction(lexer, this.name, act);
    };
    return Rule;
}());
/**
 * Compiles a json description function into json where all regular expressions,
 * case matches etc, are compiled and all include rules are expanded.
 * We also compile the bracket definitions, supply defaults, and do many sanity checks.
 * If the 'jsonStrict' parameter is 'false', we allow at certain locations
 * regular expression objects and functions that get called during lexing.
 * (Currently we have no samples that need this so perhaps we should always have
 * jsonStrict to true).
 */
function compile(languageId, json) {
    if (!json || typeof (json) !== 'object') {
        throw new Error('Monarch: expecting a language definition object');
    }
    // Create our lexer
    var lexer = {};
    lexer.languageId = languageId;
    lexer.noThrow = false; // raise exceptions during compilation
    lexer.maxStack = 100;
    // Set standard fields: be defensive about types
    lexer.start = string(json.start);
    lexer.ignoreCase = bool(json.ignoreCase, false);
    lexer.tokenPostfix = string(json.tokenPostfix, '.' + lexer.languageId);
    lexer.defaultToken = string(json.defaultToken, 'source', function () { __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'the \'defaultToken\' must be a string'); });
    lexer.usesEmbedded = false; // becomes true if we find a nextEmbedded action
    // For calling compileAction later on
    var lexerMin = json;
    lexerMin.languageId = languageId;
    lexerMin.ignoreCase = lexer.ignoreCase;
    lexerMin.noThrow = lexer.noThrow;
    lexerMin.usesEmbedded = lexer.usesEmbedded;
    lexerMin.stateNames = json.tokenizer;
    lexerMin.defaultToken = lexer.defaultToken;
    // Compile an array of rules into newrules where RegExp objects are created.
    function addRules(state, newrules, rules) {
        for (var idx in rules) {
            if (rules.hasOwnProperty(idx)) {
                var rule = rules[idx];
                var include = rule.include;
                if (include) {
                    if (typeof (include) !== 'string') {
                        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'an \'include\' attribute must be a string at: ' + state);
                    }
                    if (include[0] === '@') {
                        include = include.substr(1); // peel off starting @
                    }
                    if (!json.tokenizer[include]) {
                        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'include target \'' + include + '\' is not defined at: ' + state);
                    }
                    addRules(state + '.' + include, newrules, json.tokenizer[include]);
                }
                else {
                    var newrule = new Rule(state);
                    // Set up new rule attributes
                    if (Array.isArray(rule) && rule.length >= 1 && rule.length <= 3) {
                        newrule.setRegex(lexerMin, rule[0]);
                        if (rule.length >= 3) {
                            if (typeof (rule[1]) === 'string') {
                                newrule.setAction(lexerMin, { token: rule[1], next: rule[2] });
                            }
                            else if (typeof (rule[1]) === 'object') {
                                var rule1 = rule[1];
                                rule1.next = rule[2];
                                newrule.setAction(lexerMin, rule1);
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'a next state as the last element of a rule can only be given if the action is either an object or a string, at: ' + state);
                            }
                        }
                        else {
                            newrule.setAction(lexerMin, rule[1]);
                        }
                    }
                    else {
                        if (!rule.regex) {
                            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'a rule must either be an array, or an object with a \'regex\' or \'include\' field at: ' + state);
                        }
                        if (rule.name) {
                            newrule.name = string(rule.name);
                        }
                        if (rule.matchOnlyAtStart) {
                            newrule.matchOnlyAtLineStart = bool(rule.matchOnlyAtLineStart);
                        }
                        newrule.setRegex(lexerMin, rule.regex);
                        newrule.setAction(lexerMin, rule.action);
                    }
                    newrules.push(newrule);
                }
            }
        }
    }
    // compile the tokenizer rules
    if (!json.tokenizer || typeof (json.tokenizer) !== 'object') {
        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'a language definition must define the \'tokenizer\' attribute as an object');
    }
    lexer.tokenizer = [];
    for (var key in json.tokenizer) {
        if (json.tokenizer.hasOwnProperty(key)) {
            if (!lexer.start) {
                lexer.start = key;
            }
            var rules = json.tokenizer[key];
            lexer.tokenizer[key] = new Array();
            addRules('tokenizer.' + key, lexer.tokenizer[key], rules);
        }
    }
    lexer.usesEmbedded = lexerMin.usesEmbedded; // can be set during compileAction
    // Set simple brackets
    if (json.brackets) {
        if (!(Array.isArray(json.brackets))) {
            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'the \'brackets\' attribute must be defined as an array');
        }
    }
    else {
        json.brackets = [
            { open: '{', close: '}', token: 'delimiter.curly' },
            { open: '[', close: ']', token: 'delimiter.square' },
            { open: '(', close: ')', token: 'delimiter.parenthesis' },
            { open: '<', close: '>', token: 'delimiter.angle' }
        ];
    }
    var brackets = [];
    for (var bracketIdx in json.brackets) {
        if (json.brackets.hasOwnProperty(bracketIdx)) {
            var desc = json.brackets[bracketIdx];
            if (desc && Array.isArray(desc) && desc.length === 3) {
                desc = { token: desc[2], open: desc[0], close: desc[1] };
            }
            if (desc.open === desc.close) {
                __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'open and close brackets in a \'brackets\' attribute must be different: ' + desc.open +
                    '\n hint: use the \'bracket\' attribute if matching on equal brackets is required.');
            }
            if (typeof (desc.open) === 'string' && typeof (desc.token) === 'string') {
                brackets.push({
                    token: string(desc.token) + lexer.tokenPostfix,
                    open: __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["c" /* fixCase */](lexer, string(desc.open)),
                    close: __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["c" /* fixCase */](lexer, string(desc.close))
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](lexer, 'every element in the \'brackets\' array must be a \'{open,close,token}\' object or array');
            }
        }
    }
    lexer.brackets = brackets;
    // Disable throw so the syntax highlighter goes, no matter what
    lexer.noThrow = true;
    return lexer;
}


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTokenizationSupport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_modes_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_core_token_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_modes_nullMode_js__ = __webpack_require__(57);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/





var CACHE_STACK_DEPTH = 5;
/**
 * Reuse the same stack elements up to a certain depth.
 */
var MonarchStackElementFactory = /** @class */ (function () {
    function MonarchStackElementFactory(maxCacheDepth) {
        this._maxCacheDepth = maxCacheDepth;
        this._entries = Object.create(null);
    }
    MonarchStackElementFactory.create = function (parent, state) {
        return this._INSTANCE.create(parent, state);
    };
    MonarchStackElementFactory.prototype.create = function (parent, state) {
        if (parent !== null && parent.depth >= this._maxCacheDepth) {
            // no caching above a certain depth
            return new MonarchStackElement(parent, state);
        }
        var stackElementId = MonarchStackElement.getStackElementId(parent);
        if (stackElementId.length > 0) {
            stackElementId += '|';
        }
        stackElementId += state;
        var result = this._entries[stackElementId];
        if (result) {
            return result;
        }
        result = new MonarchStackElement(parent, state);
        this._entries[stackElementId] = result;
        return result;
    };
    MonarchStackElementFactory._INSTANCE = new MonarchStackElementFactory(CACHE_STACK_DEPTH);
    return MonarchStackElementFactory;
}());
var MonarchStackElement = /** @class */ (function () {
    function MonarchStackElement(parent, state) {
        this.parent = parent;
        this.state = state;
        this.depth = (this.parent ? this.parent.depth : 0) + 1;
    }
    MonarchStackElement.getStackElementId = function (element) {
        var result = '';
        while (element !== null) {
            if (result.length > 0) {
                result += '|';
            }
            result += element.state;
            element = element.parent;
        }
        return result;
    };
    MonarchStackElement._equals = function (a, b) {
        while (a !== null && b !== null) {
            if (a === b) {
                return true;
            }
            if (a.state !== b.state) {
                return false;
            }
            a = a.parent;
            b = b.parent;
        }
        if (a === null && b === null) {
            return true;
        }
        return false;
    };
    MonarchStackElement.prototype.equals = function (other) {
        return MonarchStackElement._equals(this, other);
    };
    MonarchStackElement.prototype.push = function (state) {
        return MonarchStackElementFactory.create(this, state);
    };
    MonarchStackElement.prototype.pop = function () {
        return this.parent;
    };
    MonarchStackElement.prototype.popall = function () {
        var result = this;
        while (result.parent) {
            result = result.parent;
        }
        return result;
    };
    MonarchStackElement.prototype.switchTo = function (state) {
        return MonarchStackElementFactory.create(this.parent, state);
    };
    return MonarchStackElement;
}());
var EmbeddedModeData = /** @class */ (function () {
    function EmbeddedModeData(modeId, state) {
        this.modeId = modeId;
        this.state = state;
    }
    EmbeddedModeData.prototype.equals = function (other) {
        return (this.modeId === other.modeId
            && this.state.equals(other.state));
    };
    EmbeddedModeData.prototype.clone = function () {
        var stateClone = this.state.clone();
        // save an object
        if (stateClone === this.state) {
            return this;
        }
        return new EmbeddedModeData(this.modeId, this.state);
    };
    return EmbeddedModeData;
}());
/**
 * Reuse the same line states up to a certain depth.
 */
var MonarchLineStateFactory = /** @class */ (function () {
    function MonarchLineStateFactory(maxCacheDepth) {
        this._maxCacheDepth = maxCacheDepth;
        this._entries = Object.create(null);
    }
    MonarchLineStateFactory.create = function (stack, embeddedModeData) {
        return this._INSTANCE.create(stack, embeddedModeData);
    };
    MonarchLineStateFactory.prototype.create = function (stack, embeddedModeData) {
        if (embeddedModeData !== null) {
            // no caching when embedding
            return new MonarchLineState(stack, embeddedModeData);
        }
        if (stack !== null && stack.depth >= this._maxCacheDepth) {
            // no caching above a certain depth
            return new MonarchLineState(stack, embeddedModeData);
        }
        var stackElementId = MonarchStackElement.getStackElementId(stack);
        var result = this._entries[stackElementId];
        if (result) {
            return result;
        }
        result = new MonarchLineState(stack, null);
        this._entries[stackElementId] = result;
        return result;
    };
    MonarchLineStateFactory._INSTANCE = new MonarchLineStateFactory(CACHE_STACK_DEPTH);
    return MonarchLineStateFactory;
}());
var MonarchLineState = /** @class */ (function () {
    function MonarchLineState(stack, embeddedModeData) {
        this.stack = stack;
        this.embeddedModeData = embeddedModeData;
    }
    MonarchLineState.prototype.clone = function () {
        var embeddedModeDataClone = this.embeddedModeData ? this.embeddedModeData.clone() : null;
        // save an object
        if (embeddedModeDataClone === this.embeddedModeData) {
            return this;
        }
        return MonarchLineStateFactory.create(this.stack, this.embeddedModeData);
    };
    MonarchLineState.prototype.equals = function (other) {
        if (!(other instanceof MonarchLineState)) {
            return false;
        }
        if (!this.stack.equals(other.stack)) {
            return false;
        }
        if (this.embeddedModeData === null && other.embeddedModeData === null) {
            return true;
        }
        if (this.embeddedModeData === null || other.embeddedModeData === null) {
            return false;
        }
        return this.embeddedModeData.equals(other.embeddedModeData);
    };
    return MonarchLineState;
}());
var hasOwnProperty = Object.hasOwnProperty;
var MonarchClassicTokensCollector = /** @class */ (function () {
    function MonarchClassicTokensCollector() {
        this._tokens = [];
        this._language = null;
        this._lastTokenType = null;
        this._lastTokenLanguage = null;
    }
    MonarchClassicTokensCollector.prototype.enterMode = function (startOffset, modeId) {
        this._language = modeId;
    };
    MonarchClassicTokensCollector.prototype.emit = function (startOffset, type) {
        if (this._lastTokenType === type && this._lastTokenLanguage === this._language) {
            return;
        }
        this._lastTokenType = type;
        this._lastTokenLanguage = this._language;
        this._tokens.push(new __WEBPACK_IMPORTED_MODULE_2__common_core_token_js__["a" /* Token */](startOffset, type, this._language));
    };
    MonarchClassicTokensCollector.prototype.nestedModeTokenize = function (embeddedModeLine, embeddedModeData, offsetDelta) {
        var nestedModeId = embeddedModeData.modeId;
        var embeddedModeState = embeddedModeData.state;
        var nestedModeTokenizationSupport = __WEBPACK_IMPORTED_MODULE_0__common_modes_js__["y" /* TokenizationRegistry */].get(nestedModeId);
        if (!nestedModeTokenizationSupport) {
            this.enterMode(offsetDelta, nestedModeId);
            this.emit(offsetDelta, '');
            return embeddedModeState;
        }
        var nestedResult = nestedModeTokenizationSupport.tokenize(embeddedModeLine, embeddedModeState, offsetDelta);
        this._tokens = this._tokens.concat(nestedResult.tokens);
        this._lastTokenType = null;
        this._lastTokenLanguage = null;
        this._language = null;
        return nestedResult.endState;
    };
    MonarchClassicTokensCollector.prototype.finalize = function (endState) {
        return new __WEBPACK_IMPORTED_MODULE_2__common_core_token_js__["b" /* TokenizationResult */](this._tokens, endState);
    };
    return MonarchClassicTokensCollector;
}());
var MonarchModernTokensCollector = /** @class */ (function () {
    function MonarchModernTokensCollector(modeService, theme) {
        this._modeService = modeService;
        this._theme = theme;
        this._prependTokens = null;
        this._tokens = [];
        this._currentLanguageId = 0 /* Null */;
        this._lastTokenMetadata = 0;
    }
    MonarchModernTokensCollector.prototype.enterMode = function (startOffset, modeId) {
        this._currentLanguageId = this._modeService.getLanguageIdentifier(modeId).id;
    };
    MonarchModernTokensCollector.prototype.emit = function (startOffset, type) {
        var metadata = this._theme.match(this._currentLanguageId, type);
        if (this._lastTokenMetadata === metadata) {
            return;
        }
        this._lastTokenMetadata = metadata;
        this._tokens.push(startOffset);
        this._tokens.push(metadata);
    };
    MonarchModernTokensCollector._merge = function (a, b, c) {
        var aLen = (a !== null ? a.length : 0);
        var bLen = b.length;
        var cLen = (c !== null ? c.length : 0);
        if (aLen === 0 && bLen === 0 && cLen === 0) {
            return new Uint32Array(0);
        }
        if (aLen === 0 && bLen === 0) {
            return c;
        }
        if (bLen === 0 && cLen === 0) {
            return a;
        }
        var result = new Uint32Array(aLen + bLen + cLen);
        if (a !== null) {
            result.set(a);
        }
        for (var i = 0; i < bLen; i++) {
            result[aLen + i] = b[i];
        }
        if (c !== null) {
            result.set(c, aLen + bLen);
        }
        return result;
    };
    MonarchModernTokensCollector.prototype.nestedModeTokenize = function (embeddedModeLine, embeddedModeData, offsetDelta) {
        var nestedModeId = embeddedModeData.modeId;
        var embeddedModeState = embeddedModeData.state;
        var nestedModeTokenizationSupport = __WEBPACK_IMPORTED_MODULE_0__common_modes_js__["y" /* TokenizationRegistry */].get(nestedModeId);
        if (!nestedModeTokenizationSupport) {
            this.enterMode(offsetDelta, nestedModeId);
            this.emit(offsetDelta, '');
            return embeddedModeState;
        }
        var nestedResult = nestedModeTokenizationSupport.tokenize2(embeddedModeLine, embeddedModeState, offsetDelta);
        this._prependTokens = MonarchModernTokensCollector._merge(this._prependTokens, this._tokens, nestedResult.tokens);
        this._tokens = [];
        this._currentLanguageId = 0;
        this._lastTokenMetadata = 0;
        return nestedResult.endState;
    };
    MonarchModernTokensCollector.prototype.finalize = function (endState) {
        return new __WEBPACK_IMPORTED_MODULE_2__common_core_token_js__["c" /* TokenizationResult2 */](MonarchModernTokensCollector._merge(this._prependTokens, this._tokens, null), endState);
    };
    return MonarchModernTokensCollector;
}());
var MonarchTokenizer = /** @class */ (function () {
    function MonarchTokenizer(modeService, standaloneThemeService, modeId, lexer) {
        var _this = this;
        this._modeService = modeService;
        this._standaloneThemeService = standaloneThemeService;
        this._modeId = modeId;
        this._lexer = lexer;
        this._embeddedModes = Object.create(null);
        // Set up listening for embedded modes
        var emitting = false;
        this._tokenizationRegistryListener = __WEBPACK_IMPORTED_MODULE_0__common_modes_js__["y" /* TokenizationRegistry */].onDidChange(function (e) {
            if (emitting) {
                return;
            }
            var isOneOfMyEmbeddedModes = false;
            for (var i = 0, len = e.changedLanguages.length; i < len; i++) {
                var language = e.changedLanguages[i];
                if (_this._embeddedModes[language]) {
                    isOneOfMyEmbeddedModes = true;
                    break;
                }
            }
            if (isOneOfMyEmbeddedModes) {
                emitting = true;
                __WEBPACK_IMPORTED_MODULE_0__common_modes_js__["y" /* TokenizationRegistry */].fire([_this._modeId]);
                emitting = false;
            }
        });
    }
    MonarchTokenizer.prototype.dispose = function () {
        this._tokenizationRegistryListener.dispose();
    };
    MonarchTokenizer.prototype.getInitialState = function () {
        var rootState = MonarchStackElementFactory.create(null, this._lexer.start);
        return MonarchLineStateFactory.create(rootState, null);
    };
    MonarchTokenizer.prototype.tokenize = function (line, lineState, offsetDelta) {
        var tokensCollector = new MonarchClassicTokensCollector();
        var endLineState = this._tokenize(line, lineState, offsetDelta, tokensCollector);
        return tokensCollector.finalize(endLineState);
    };
    MonarchTokenizer.prototype.tokenize2 = function (line, lineState, offsetDelta) {
        var tokensCollector = new MonarchModernTokensCollector(this._modeService, this._standaloneThemeService.getTheme().tokenTheme);
        var endLineState = this._tokenize(line, lineState, offsetDelta, tokensCollector);
        return tokensCollector.finalize(endLineState);
    };
    MonarchTokenizer.prototype._tokenize = function (line, lineState, offsetDelta, collector) {
        if (lineState.embeddedModeData) {
            return this._nestedTokenize(line, lineState, offsetDelta, collector);
        }
        else {
            return this._myTokenize(line, lineState, offsetDelta, collector);
        }
    };
    MonarchTokenizer.prototype._findLeavingNestedModeOffset = function (line, state) {
        var rules = this._lexer.tokenizer[state.stack.state];
        if (!rules) {
            rules = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["b" /* findRules */](this._lexer, state.stack.state); // do parent matching
            if (!rules) {
                __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'tokenizer state is not defined: ' + state.stack.state);
            }
        }
        var popOffset = -1;
        var hasEmbeddedPopRule = false;
        for (var idx in rules) {
            if (!hasOwnProperty.call(rules, idx)) {
                continue;
            }
            var rule = rules[idx];
            if (!__WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["e" /* isIAction */](rule.action) || rule.action.nextEmbedded !== '@pop') {
                continue;
            }
            hasEmbeddedPopRule = true;
            var regex = rule.regex;
            var regexSource = rule.regex.source;
            if (regexSource.substr(0, 4) === '^(?:' && regexSource.substr(regexSource.length - 1, 1) === ')') {
                regex = new RegExp(regexSource.substr(4, regexSource.length - 5), regex.ignoreCase ? 'i' : '');
            }
            var result = line.search(regex);
            if (result === -1) {
                continue;
            }
            if (popOffset === -1 || result < popOffset) {
                popOffset = result;
            }
        }
        if (!hasEmbeddedPopRule) {
            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'no rule containing nextEmbedded: "@pop" in tokenizer embedded state: ' + state.stack.state);
        }
        return popOffset;
    };
    MonarchTokenizer.prototype._nestedTokenize = function (line, lineState, offsetDelta, tokensCollector) {
        var popOffset = this._findLeavingNestedModeOffset(line, lineState);
        if (popOffset === -1) {
            // tokenization will not leave nested mode
            var nestedEndState = tokensCollector.nestedModeTokenize(line, lineState.embeddedModeData, offsetDelta);
            return MonarchLineStateFactory.create(lineState.stack, new EmbeddedModeData(lineState.embeddedModeData.modeId, nestedEndState));
        }
        var nestedModeLine = line.substring(0, popOffset);
        if (nestedModeLine.length > 0) {
            // tokenize with the nested mode
            tokensCollector.nestedModeTokenize(nestedModeLine, lineState.embeddedModeData, offsetDelta);
        }
        var restOfTheLine = line.substring(popOffset);
        return this._myTokenize(restOfTheLine, lineState, offsetDelta + popOffset, tokensCollector);
    };
    MonarchTokenizer.prototype._myTokenize = function (line, lineState, offsetDelta, tokensCollector) {
        tokensCollector.enterMode(offsetDelta, this._modeId);
        var lineLength = line.length;
        var embeddedModeData = lineState.embeddedModeData;
        var stack = lineState.stack;
        var pos = 0;
        // regular expression group matching
        // these never need cloning or equality since they are only used within a line match
        var groupActions = null;
        var groupMatches = null;
        var groupMatched = null;
        var groupRule = null;
        while (pos < lineLength) {
            var pos0 = pos;
            var stackLen0 = stack.depth;
            var groupLen0 = groupActions ? groupActions.length : 0;
            var state = stack.state;
            var matches = null;
            var matched = null;
            var action = null;
            var rule = null;
            var enteringEmbeddedMode = null;
            // check if we need to process group matches first
            if (groupActions) {
                matches = groupMatches;
                matched = groupMatched.shift();
                action = groupActions.shift();
                rule = groupRule;
                // cleanup if necessary
                if (groupActions.length === 0) {
                    groupActions = null;
                    groupMatches = null;
                    groupMatched = null;
                    groupRule = null;
                }
            }
            else {
                // otherwise we match on the token stream
                if (pos >= lineLength) {
                    // nothing to do
                    break;
                }
                // get the rules for this state
                var rules = this._lexer.tokenizer[state];
                if (!rules) {
                    rules = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["b" /* findRules */](this._lexer, state); // do parent matching
                    if (!rules) {
                        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'tokenizer state is not defined: ' + state);
                    }
                }
                // try each rule until we match
                var restOfLine = line.substr(pos);
                for (var idx in rules) {
                    if (hasOwnProperty.call(rules, idx)) {
                        var rule_1 = rules[idx];
                        if (pos === 0 || !rule_1.matchOnlyAtLineStart) {
                            matches = restOfLine.match(rule_1.regex);
                            if (matches) {
                                matched = matches[0];
                                action = rule_1.action;
                                break;
                            }
                        }
                    }
                }
            }
            // We matched 'rule' with 'matches' and 'action'
            if (!matches) {
                matches = [''];
                matched = '';
            }
            if (!action) {
                // bad: we didn't match anything, and there is no action to take
                // we need to advance the stream or we get progress trouble
                if (pos < lineLength) {
                    matches = [line.charAt(pos)];
                    matched = matches[0];
                }
                action = this._lexer.defaultToken;
            }
            // advance stream
            pos += matched.length;
            // maybe call action function (used for 'cases')
            while (__WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["d" /* isFuzzyAction */](action) && __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["e" /* isIAction */](action) && action.test) {
                action = action.test(matched, matches, state, pos === lineLength);
            }
            var result = null;
            // set the result: either a string or an array of actions
            if (typeof action === 'string' || Array.isArray(action)) {
                result = action;
            }
            else if (action.group) {
                result = action.group;
            }
            else if (action.token !== null && action.token !== undefined) {
                // do $n replacements?
                if (action.tokenSubst) {
                    result = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](this._lexer, action.token, matched, matches, state);
                }
                else {
                    result = action.token;
                }
                // enter embedded mode?
                if (action.nextEmbedded) {
                    if (action.nextEmbedded === '@pop') {
                        if (!embeddedModeData) {
                            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'cannot pop embedded mode if not inside one');
                        }
                        embeddedModeData = null;
                    }
                    else if (embeddedModeData) {
                        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'cannot enter embedded mode from within an embedded mode');
                    }
                    else {
                        enteringEmbeddedMode = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](this._lexer, action.nextEmbedded, matched, matches, state);
                    }
                }
                // state transformations
                if (action.goBack) { // back up the stream..
                    pos = Math.max(0, pos - action.goBack);
                }
                if (action.switchTo && typeof action.switchTo === 'string') {
                    var nextState = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](this._lexer, action.switchTo, matched, matches, state); // switch state without a push...
                    if (nextState[0] === '@') {
                        nextState = nextState.substr(1); // peel off starting '@'
                    }
                    if (!__WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["b" /* findRules */](this._lexer, nextState)) {
                        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'trying to switch to a state \'' + nextState + '\' that is undefined in rule: ' + rule.name);
                    }
                    else {
                        stack = stack.switchTo(nextState);
                    }
                }
                else if (action.transform && typeof action.transform === 'function') {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'action.transform not supported');
                }
                else if (action.next) {
                    if (action.next === '@push') {
                        if (stack.depth >= this._lexer.maxStack) {
                            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'maximum tokenizer stack size reached: [' +
                                stack.state + ',' + stack.parent.state + ',...]');
                        }
                        else {
                            stack = stack.push(state);
                        }
                    }
                    else if (action.next === '@pop') {
                        if (stack.depth <= 1) {
                            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'trying to pop an empty stack in rule: ' + rule.name);
                        }
                        else {
                            stack = stack.pop();
                        }
                    }
                    else if (action.next === '@popall') {
                        stack = stack.popall();
                    }
                    else {
                        var nextState = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](this._lexer, action.next, matched, matches, state);
                        if (nextState[0] === '@') {
                            nextState = nextState.substr(1); // peel off starting '@'
                        }
                        if (!__WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["b" /* findRules */](this._lexer, nextState)) {
                            __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'trying to set a next state \'' + nextState + '\' that is undefined in rule: ' + rule.name);
                        }
                        else {
                            stack = stack.push(nextState);
                        }
                    }
                }
                if (action.log && typeof (action.log) === 'string') {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["g" /* log */](this._lexer, this._lexer.languageId + ': ' + __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["j" /* substituteMatches */](this._lexer, action.log, matched, matches, state));
                }
            }
            // check result
            if (result === null) {
                __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'lexer rule has no well-defined action in rule: ' + rule.name);
            }
            // is the result a group match?
            if (Array.isArray(result)) {
                if (groupActions && groupActions.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'groups cannot be nested: ' + rule.name);
                }
                if (matches.length !== result.length + 1) {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'matched number of groups does not match the number of actions in rule: ' + rule.name);
                }
                var totalLen = 0;
                for (var i = 1; i < matches.length; i++) {
                    totalLen += matches[i].length;
                }
                if (totalLen !== matched.length) {
                    __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'with groups, all characters should be matched in consecutive groups in rule: ' + rule.name);
                }
                groupMatches = matches;
                groupMatched = matches.slice(1);
                groupActions = result.slice(0);
                groupRule = rule;
                pos -= matched.length;
                // call recursively to initiate first result match
                continue;
            }
            else {
                // regular result
                // check for '@rematch'
                if (result === '@rematch') {
                    pos -= matched.length;
                    matched = ''; // better set the next state too..
                    matches = null;
                    result = '';
                }
                // check progress
                if (matched.length === 0) {
                    if (stackLen0 !== stack.depth || state !== stack.state || (!groupActions ? 0 : groupActions.length) !== groupLen0) {
                        continue;
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, 'no progress in tokenizer in rule: ' + rule.name);
                        pos = lineLength; // must make progress or editor loops
                    }
                }
                // return the result (and check for brace matching)
                // todo: for efficiency we could pre-sanitize tokenPostfix and substitutions
                var tokenType = null;
                if (__WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["f" /* isString */](result) && result.indexOf('@brackets') === 0) {
                    var rest = result.substr('@brackets'.length);
                    var bracket = findBracket(this._lexer, matched);
                    if (!bracket) {
                        __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["k" /* throwError */](this._lexer, '@brackets token returned but no bracket defined as: ' + matched);
                        bracket = { token: '', bracketType: 0 /* None */ };
                    }
                    tokenType = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["h" /* sanitize */](bracket.token + rest);
                }
                else {
                    var token = (result === '' ? '' : result + this._lexer.tokenPostfix);
                    tokenType = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["h" /* sanitize */](token);
                }
                tokensCollector.emit(pos0 + offsetDelta, tokenType);
            }
            if (enteringEmbeddedMode !== null) {
                // substitute language alias to known modes to support syntax highlighting
                var enteringEmbeddedModeId = this._modeService.getModeIdForLanguageName(enteringEmbeddedMode);
                if (enteringEmbeddedModeId) {
                    enteringEmbeddedMode = enteringEmbeddedModeId;
                }
                var embeddedModeData_1 = this._getNestedEmbeddedModeData(enteringEmbeddedMode);
                if (pos < lineLength) {
                    // there is content from the embedded mode on this line
                    var restOfLine = line.substr(pos);
                    return this._nestedTokenize(restOfLine, MonarchLineStateFactory.create(stack, embeddedModeData_1), offsetDelta + pos, tokensCollector);
                }
                else {
                    return MonarchLineStateFactory.create(stack, embeddedModeData_1);
                }
            }
        }
        return MonarchLineStateFactory.create(stack, embeddedModeData);
    };
    MonarchTokenizer.prototype._getNestedEmbeddedModeData = function (mimetypeOrModeId) {
        var nestedMode = this._locateMode(mimetypeOrModeId);
        if (nestedMode) {
            var tokenizationSupport = __WEBPACK_IMPORTED_MODULE_0__common_modes_js__["y" /* TokenizationRegistry */].get(nestedMode.getId());
            if (tokenizationSupport) {
                return new EmbeddedModeData(nestedMode.getId(), tokenizationSupport.getInitialState());
            }
        }
        var nestedModeId = nestedMode ? nestedMode.getId() : __WEBPACK_IMPORTED_MODULE_3__common_modes_nullMode_js__["b" /* NULL_MODE_ID */];
        return new EmbeddedModeData(nestedModeId, __WEBPACK_IMPORTED_MODULE_3__common_modes_nullMode_js__["c" /* NULL_STATE */]);
    };
    MonarchTokenizer.prototype._locateMode = function (mimetypeOrModeId) {
        if (!mimetypeOrModeId || !this._modeService.isRegisteredMode(mimetypeOrModeId)) {
            return null;
        }
        var modeId = this._modeService.getModeId(mimetypeOrModeId);
        // Fire mode loading event
        this._modeService.getOrCreateMode(modeId);
        var mode = this._modeService.getMode(modeId);
        if (mode) {
            // Re-emit tokenizationSupport change events from all modes that I ever embedded
            this._embeddedModes[modeId] = true;
            return mode;
        }
        this._embeddedModes[modeId] = true;
        return null;
    };
    return MonarchTokenizer;
}());
/**
 * Searches for a bracket in the 'brackets' attribute that matches the input.
 */
function findBracket(lexer, matched) {
    if (!matched) {
        return null;
    }
    matched = __WEBPACK_IMPORTED_MODULE_1__monarchCommon_js__["c" /* fixCase */](lexer, matched);
    var brackets = lexer.brackets;
    for (var i = 0; i < brackets.length; i++) {
        var bracket = brackets[i];
        if (bracket.open === matched) {
            return { token: bracket.token, bracketType: 1 /* Open */ };
        }
        else if (bracket.close === matched) {
            return { token: bracket.token, bracketType: -1 /* Close */ };
        }
    }
    return null;
}
function createTokenizationSupport(modeService, standaloneThemeService, modeId, lexer) {
    return new MonarchTokenizer(modeService, standaloneThemeService, modeId, lexer);
}


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PolyfillPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__winjs_base_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_js__ = __webpack_require__(14);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/


/**
 * A polyfill for the native promises. The implementation is based on
 * WinJS promises but tries to gap differences between winjs promises
 * and native promises.
 */
var PolyfillPromise = /** @class */ (function () {
    function PolyfillPromise(initOrPromise) {
        if (__WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["a" /* Promise */].is(initOrPromise)) {
            this._winjsPromise = initOrPromise;
        }
        else {
            this._winjsPromise = new __WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["a" /* Promise */](function (resolve, reject) {
                var initializing = true;
                initOrPromise(function (value) {
                    if (!initializing) {
                        resolve(value);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_1__platform_js__["h" /* setImmediate */](function () { return resolve(value); });
                    }
                }, function (err) {
                    if (!initializing) {
                        reject(err);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_1__platform_js__["h" /* setImmediate */](function () { return reject(err); });
                    }
                });
                initializing = false;
            });
        }
    }
    PolyfillPromise.all = function (thenables) {
        return new PolyfillPromise(__WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["a" /* Promise */].join(thenables).then(null, function (values) {
            // WinJSPromise returns a sparse array whereas
            // native promises return the *first* error
            for (var key in values) {
                if (values.hasOwnProperty(key)) {
                    return values[key];
                }
            }
        }));
    };
    PolyfillPromise.race = function (thenables) {
        // WinJSPromise returns `{ key: <index/key>, value: <promise> }`
        // from the `any` call and Promise.race just wants the value
        return new PolyfillPromise(__WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["a" /* Promise */].any(thenables).then(function (entry) { return entry.value; }, function (err) { return err.value; }));
    };
    PolyfillPromise.resolve = function (value) {
        return new PolyfillPromise(__WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["a" /* Promise */].wrap(value));
    };
    PolyfillPromise.reject = function (value) {
        return new PolyfillPromise(__WEBPACK_IMPORTED_MODULE_0__winjs_base_js__["a" /* Promise */].wrapError(value));
    };
    PolyfillPromise.prototype.then = function (onFulfilled, onRejected) {
        var sync = true;
        var promise = new PolyfillPromise(this._winjsPromise.then(onFulfilled && function (value) {
            if (!sync) {
                onFulfilled(value);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__platform_js__["h" /* setImmediate */](function () { return onFulfilled(value); });
            }
        }, onRejected && function (err) {
            if (!sync) {
                onRejected(err);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__platform_js__["h" /* setImmediate */](function () { return onRejected(err); });
            }
        }));
        sync = false;
        return promise;
    };
    PolyfillPromise.prototype.catch = function (onRejected) {
        return this.then(null, onRejected);
    };
    return PolyfillPromise;
}());



/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__editor_editor_api_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bat_bat_contribution_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coffee_coffee_contribution_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cpp_cpp_contribution_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__csharp_csharp_contribution_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__csp_csp_contribution_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_css_contribution_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dockerfile_dockerfile_contribution_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fsharp_fsharp_contribution_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__go_go_contribution_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handlebars_handlebars_contribution_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__html_html_contribution_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ini_ini_contribution_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__java_java_contribution_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__javascript_javascript_contribution_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__less_less_contribution_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lua_lua_contribution_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__markdown_markdown_contribution_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__msdax_msdax_contribution_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mysql_mysql_contribution_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__objective_c_objective_c_contribution_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pgsql_pgsql_contribution_js__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__php_php_contribution_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__postiats_postiats_contribution_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__powerquery_powerquery_contribution_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__powershell_powershell_contribution_js__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pug_pug_contribution_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__python_python_contribution_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__r_r_contribution_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__razor_razor_contribution_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__redis_redis_contribution_js__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__redshift_redshift_contribution_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ruby_ruby_contribution_js__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__rust_rust_contribution_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__sb_sb_contribution_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__scss_scss_contribution_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__solidity_solidity_contribution_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sql_sql_contribution_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__st_st_contribution_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__swift_swift_contribution_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__typescript_typescript_contribution_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__vb_vb_contribution_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__xml_xml_contribution_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__yaml_yaml_contribution_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__scheme_scheme_contribution_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__clojure_clojure_contribution_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__shell_shell_contribution_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__perl_perl_contribution_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__azcli_azcli_contribution_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__apex_apex_contribution_js__ = __webpack_require__(191);

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';



















































/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_all_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__standalone_browser_accessibilityHelp_accessibilityHelp_js__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__standalone_browser_inspectTokens_inspectTokens_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__standalone_browser_iPadShowKeyboard_iPadShowKeyboard_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__standalone_browser_quickOpen_quickOutline_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__standalone_browser_quickOpen_gotoLine_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__standalone_browser_quickOpen_quickCommand_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__standalone_browser_toggleHighContrast_toggleHighContrast_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__standalone_browser_referenceSearch_standaloneReferenceSearch_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editor_api_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editor_api_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__editor_api_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_9__editor_api_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_9__editor_api_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/













/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_controller_coreCommands_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_widget_codeEditorWidget_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_widget_diffEditorWidget_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_widget_diffNavigator_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contrib_bracketMatching_bracketMatching_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contrib_caretOperations_caretOperations_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__contrib_caretOperations_transpose_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contrib_clipboard_clipboard_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contrib_codelens_codelensController_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__contrib_colorPicker_colorDetector_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contrib_comment_comment_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contrib_contextmenu_contextmenu_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contrib_cursorUndo_cursorUndo_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contrib_dnd_dnd_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__contrib_find_findController_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contrib_folding_folding_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__contrib_fontZoom_fontZoom_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__contrib_format_formatActions_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__contrib_goToDefinition_goToDefinitionCommands_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__contrib_goToDefinition_goToDefinitionMouse_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contrib_gotoError_gotoError_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__contrib_hover_hover_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__contrib_inPlaceReplace_inPlaceReplace_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__contrib_linesOperations_linesOperations_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contrib_links_links_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__contrib_multicursor_multicursor_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__contrib_parameterHints_parameterHints_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__contrib_codeAction_codeActionContributions_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__contrib_referenceSearch_referenceSearch_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__contrib_rename_rename_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__contrib_smartSelect_smartSelect_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__contrib_snippet_snippetController2_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__contrib_suggest_suggestController_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__contrib_toggleTabFocusMode_toggleTabFocusMode_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__contrib_wordHighlighter_wordHighlighter_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__contrib_wordOperations_wordOperations_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__contrib_wordPartOperations_wordPartOperations_js__ = __webpack_require__(187);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/








































/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_monaco_editor__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_monaco_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_monaco_editor__);
var action={// An unique identifier of the contributed action.
id:'copy-selections',// A label of the action that will be presented to the user.
label:'Copy Selections',// An optional array of keybindings for the action.
keybindings:[__WEBPACK_IMPORTED_MODULE_0_monaco_editor__["KeyMod"].CtrlCmd|__WEBPACK_IMPORTED_MODULE_0_monaco_editor__["KeyCode"].KEY_D],// A precondition for this action.
precondition:null,// A rule to evaluate on top of the precondition in order to dispatch the keybindings.
keybindingContext:null,contextMenuGroupId:'navigation',contextMenuOrder:1.5,// Method that will be executed when the action is triggered.
// @param editor The editor instance is passed in as a convinience
run:function run(ed){var selection=ed.getSelection();var position=ed.getPosition();var text=ed.getValue();var lines=text.split("\n");if(selection.startLineNumber===selection.endLineNumber&&selection.startColumn===selection.endColumn){//如果没有选择，复制当前行的内容。
var line=lines[position.lineNumber-1];//追加这一行
lines.splice(position.lineNumber,0,line);ed.setValue(lines.join("\n"));//设置新的光标位置
ed.setPosition({column:position.column,lineNumber:position.lineNumber+1});}else{//如果有选择，复制选中的文字。
var selectionText=ed.getModel().getValueInRange(selection);//默认是从左往右，从上往下选取
var headPosition={lineNumber:selection.startLineNumber,column:selection.startColumn};var tailPosition={lineNumber:selection.endLineNumber,column:selection.endColumn//这些情况是从右往左，从下往上选取的。
};if(selection.startLineNumber===selection.endLineNumber){if(selection.startColumn>selection.endColumn){headPosition={lineNumber:selection.endLineNumber,column:selection.endColumn};tailPosition={lineNumber:selection.startLineNumber,column:selection.startColumn};}}else if(selection.startLineNumber>selection.endLineNumber){headPosition={lineNumber:selection.endtLineNumber,column:selection.endColumn};tailPosition={lineNumber:selection.startLineNumber,column:selection.startColumn};}var _line=lines[tailPosition.lineNumber-1];_line=_line.substr(0,tailPosition.column-1)+selectionText+_line.substr(tailPosition.column-1);//替换tailPosition这一行
lines.splice(tailPosition.lineNumber-1,1,_line);ed.setValue(lines.join("\n"));var cursorPosition=null;//选取内容没有换行。
if(headPosition.lineNumber===tailPosition.lineNumber){//设置新的光标位置
cursorPosition={column:tailPosition.column+(tailPosition.column-headPosition.column),lineNumber:tailPosition.lineNumber};}else{//设置新的光标位置
cursorPosition={column:tailPosition.column,lineNumber:tailPosition.lineNumber+(tailPosition.lineNumber-headPosition.lineNumber)};}var newSelection={startLineNumber:tailPosition.lineNumber,startColumn:tailPosition.column,endLineNumber:cursorPosition.lineNumber,endColumn:cursorPosition.column//设置新的光标位置
};ed.setPosition(cursorPosition);//设置新的选取范围
ed.setSelection(newSelection);}}};/* harmony default export */ __webpack_exports__["a"] = (action);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/settings.29be0699.svg";

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isLocalStorageNameSupported */
/* harmony export (immutable) */ __webpack_exports__["a"] = readLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveToLocalStorage;
function isLocalStorageNameSupported(){var testKey='test';var storage=window.localStorage;try{storage.setItem(testKey,'1');storage.removeItem(testKey);return true;}catch(error){return false;}}function readLocalStorage(key){if(isLocalStorageNameSupported()){return window.localStorage[key];}else{console.error("not support localStorage.");return null;}}function saveToLocalStorage(key,content){if(isLocalStorageNameSupported()){window.localStorage[key]=content;}else{console.error("not support localStorage.");}}

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.69bbbdd8.js